function $parcel$interopDefault(a) {
    return a && a.__esModule ? a.default : a;
}
function $parcel$defineInteropFlag(a) {
    Object.defineProperty(a, '__esModule', {
        value: true,
        configurable: true
    });
}
function $parcel$export(e, n, v, s) {
    Object.defineProperty(e, n, {
        get: v,
        set: s,
        enumerable: true,
        configurable: true
    });
}
var $parcel$global = globalThis;
var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("2sFVY", function(module, exports) {
    $parcel$defineInteropFlag(module.exports);
    $parcel$export(module.exports, "default", ()=>$910ef3ef78c8cc8c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    parcelRequire("bnL6w");
    var $jD5no;
    var $7nKe3;
    var $x8FYU;
    var $1kpI8;
    var $jxKr9;
    var $194c9;
    var $dAmbh;
    var $l2N2a;
    var $9dbF6;
    var $9NiTW;
    var $l8ruj;
    const $910ef3ef78c8cc8c$var$JiraBusinessTimelineApp = ()=>{
        const { data: project } = (0, (0, parcelRequire("l2N2a")).useProject)();
        const canLinkIssues = Boolean(project?.permissions.linkIssues);
        const canScheduleIssues = Boolean(project?.permissions.scheduleIssues);
        const canCreateIssues = Boolean(project?.permissions.createIssues);
        const isSubtasksEnabled = (0, (0, parcelRequire("dAmbh")).useIsSubtasksEnabled)();
        const isSimplifiedProject = Boolean(project?.isSimplified);
        const canCreateSubtask = canCreateIssues && (isSimplifiedProject || isSubtasksEnabled);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "jira-business-timeline-app"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9NiTW")).AuthenticationCheck), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jD5no")).default), {
            id: "business"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7nKe3")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jxKr9")).default), {
            hasInlineCreate: canCreateIssues,
            hasCreateSubtask: canCreateSubtask,
            hasIssueLinking: canLinkIssues,
            hasScheduleIssues: canScheduleIssues
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1kpI8")).ViewPreferencesProvider), {
            view: "timeline",
            preferences: (0, (0, parcelRequire("x8FYU")).TIMELINE_VIEW_PREFERENCES)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("194c9")).default), null)))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9dbF6")).SubProductUpdater), {
            subProduct: "core"
        }))));
    };
    var $910ef3ef78c8cc8c$export$2e2bcd8739ae039 = $910ef3ef78c8cc8c$var$JiraBusinessTimelineApp;
});
parcelRegister("7nKe3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b120e66bf4d03608$export$2e2bcd8739ae039);
    var $1Mt6f;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Uumt = parcelRequire("8Uumt");
    var $12jwF;
    var $54qG5;
    var $5YBrl;
    var $1Zr0i;
    var $daQYX;
    var $cm8b5;
    var $gxGcZ;
    var $iXVV6;
    var $aVFIE;
    var $l2N2a;
    var $koeKL;
    var $lVJAU;
    var $k7McJ;
    var $8OqLl;
    const $b120e66bf4d03608$export$b29ebc220106a807 = ({ children: children, projectFragment: projectFragment })=>{
        const { replace: replace } = (0, (0, parcelRequire("lVJAU")).useRouterActions)();
        const projectData = (0, $8Uumt.useFragment)((0, (0, parcelRequire("1Mt6f")).default), projectFragment);
        const project = (0, $5uXOq.useMemo)(()=>projectData ? {
                id: Number(projectData.projectId),
                key: projectData.key,
                avatarUrl: projectData.avatar.large,
                name: projectData.name,
                type: projectData.projectType.toLowerCase(),
                isSimplified: projectData.projectStyle === 'TEAM_MANAGED_PROJECT',
                isFavorite: projectData.isFavourite,
                status: projectData.status,
                permissions: {
                    assignIssues: projectData.assignIssues.canPerform,
                    administerProject: projectData.administerProject.canPerform,
                    createIssues: projectData.createIssues.canPerform,
                    deleteIssues: projectData.deleteIssues.canPerform,
                    editIssues: projectData.editIssues.canPerform,
                    linkIssues: projectData.linkIssues.canPerform,
                    scheduleIssues: projectData.scheduleIssues.canPerform,
                    transitionIssues: projectData.transitionIssues.canPerform,
                    viewIssues: projectData.viewIssues.canPerform
                }
            } : null, [
            projectData
        ]);
        const jqlContext = projectData ? `project = '${projectData.key}'` : '';
        const analyticsAttributes = (0, $5uXOq.useMemo)(()=>({
                projectId: Number(projectData?.projectId),
                isTeamManaged: projectData?.projectStyle === 'TEAM_MANAGED_PROJECT',
                projectType: projectData?.projectType.toLowerCase()
            }), [
            projectData
        ]);
        const entityData = (0, $5uXOq.useMemo)(()=>projectData?.viewIssues.canPerform ? {
                name: projectData.name,
                id: String(projectData.projectId)
            } : null, [
            projectData
        ]);
        const projects = (0, $5uXOq.useMemo)(()=>project ? [
                project
            ] : undefined, [
            project
        ]);
        const projectIdList = (0, $5uXOq.useMemo)(()=>projectData ? [
                Number(projectData.projectId)
            ] : undefined, [
            projectData
        ]);
        if (projectData?.status === 'ARCHIVED') {
            replace('/jira/errors/project-archived');
            return null;
        }
        let content;
        if (projectData == null || project == null || entityData == null) content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8OqLl")).default), null);
        else content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("daQYX")).ProjectHookProvider), {
            project: project
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("54qG5")).BusinessEntityProvider), {
            data: entityData
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1Zr0i")).RealtimeProvider), {
            ids: projectIdList
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("12jwF")).AriProvider), {
            ari: projectData.id
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5YBrl")).JqlProvider), {
            jqlContext: jqlContext
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gxGcZ")).FiltersProvider), {
            projects: projects
        }, children)))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cm8b5")).ExperienceSuccess), {
            experience: (0, (0, parcelRequire("k7McJ")).FETCH_PROJECT_EXPERIENCE)
        })));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            containerId: projectData?.projectId,
            containerType: "project",
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
            sourceName: "businessProjectContext",
            attributes: analyticsAttributes,
            key: projectData?.projectId
        }, content);
    };
    const $b120e66bf4d03608$var$ProjectContextProvider = ({ children: children })=>{
        const { data: project, loading: loading, error: error } = (0, (0, parcelRequire("l2N2a")).useProject)();
        const { replace: replace } = (0, (0, parcelRequire("lVJAU")).useRouterActions)();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const projectId = project?.id;
        const projectKey = project?.key;
        const projectType = project?.type;
        const isTeamManaged = Boolean(project?.isSimplified);
        const jqlContext = projectKey ? `project = '${projectKey}'` : '';
        const analyticsAttributes = (0, $5uXOq.useMemo)(()=>({
                projectId: projectId,
                isTeamManaged: isTeamManaged,
                projectType: projectType
            }), [
            projectId,
            isTeamManaged,
            projectType
        ]);
        const entityData = (0, $5uXOq.useMemo)(()=>project?.permissions?.viewIssues ? {
                name: project.name,
                id: String(project.id)
            } : null, [
            project
        ]);
        const projects = (0, $5uXOq.useMemo)(()=>project ? [
                project
            ] : undefined, [
            project
        ]);
        const projectIdList = (0, $5uXOq.useMemo)(()=>projectId ? [
                projectId
            ] : undefined, [
            projectId
        ]);
        const projectAri = `ari:cloud:jira:${cloudId}:project/${projectId}`;
        if (project?.status === 'ARCHIVED') {
            replace('/jira/errors/project-archived');
            return null;
        }
        let content;
        if (loading) content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aVFIE")).ThemedLazySkeleton), null);
        else if (project == null || entityData == null || error) content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8OqLl")).default), null), error && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cm8b5")).ExperienceFailed), {
            experience: (0, (0, parcelRequire("k7McJ")).FETCH_PROJECT_EXPERIENCE),
            error: error
        }));
        else content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("daQYX")).ProjectHookProvider), {
            project: project
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("54qG5")).BusinessEntityProvider), {
            data: entityData
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1Zr0i")).RealtimeProvider), {
            ids: projectIdList
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("12jwF")).AriProvider), {
            ari: projectAri
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5YBrl")).JqlProvider), {
            jqlContext: jqlContext
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gxGcZ")).FiltersProvider), {
            projects: projects
        }, children)))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cm8b5")).ExperienceSuccess), {
            experience: (0, (0, parcelRequire("k7McJ")).FETCH_PROJECT_EXPERIENCE)
        })));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            containerId: String(project?.id),
            containerType: "project",
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
            sourceName: "businessProjectContext",
            attributes: analyticsAttributes,
            key: String(project?.id)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cm8b5")).ExperienceStart), {
            experience: (0, (0, parcelRequire("k7McJ")).FETCH_PROJECT_EXPERIENCE)
        }), content);
    };
    var $b120e66bf4d03608$export$2e2bcd8739ae039 = $b120e66bf4d03608$var$ProjectContextProvider;
});
parcelRegister("1Mt6f", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$86f6b5f51dcbf821$export$2e2bcd8739ae039);
    const $86f6b5f51dcbf821$var$node = function() {
        var v0 = {
            "kind": "ScalarField",
            "name": "canPerform"
        };
        return {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "projectContext_businessEntityProjectProvider_RelayProjectContextProvider",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "id"
                    },
                    "action": "THROW",
                    "path": "id"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "key"
                    },
                    "action": "THROW",
                    "path": "key"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "projectId"
                    },
                    "action": "THROW",
                    "path": "projectId"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "concreteType": "JiraAvatar",
                        "kind": "LinkedField",
                        "name": "avatar",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "kind": "ScalarField",
                                    "name": "large"
                                },
                                "action": "THROW",
                                "path": "avatar.large"
                            }
                        ]
                    },
                    "action": "THROW",
                    "path": "avatar"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "name"
                    },
                    "action": "THROW",
                    "path": "name"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "projectType"
                    },
                    "action": "THROW",
                    "path": "projectType"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "status"
                    },
                    "action": "THROW",
                    "path": "status"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "projectStyle"
                    },
                    "action": "THROW",
                    "path": "projectStyle"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "kind": "ScalarField",
                        "name": "isFavourite"
                    },
                    "action": "THROW",
                    "path": "isFavourite"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "alias": "assignIssues",
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "type",
                                "value": "ASSIGN_ISSUES"
                            }
                        ],
                        "concreteType": "JiraProjectAction",
                        "kind": "LinkedField",
                        "name": "action",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": v0,
                                "action": "THROW",
                                "path": "assignIssues.canPerform"
                            }
                        ],
                        "storageKey": "action(type:\"ASSIGN_ISSUES\")"
                    },
                    "action": "THROW",
                    "path": "assignIssues"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "alias": "administerProject",
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "type",
                                "value": "EDIT_PROJECT_CONFIG"
                            }
                        ],
                        "concreteType": "JiraProjectAction",
                        "kind": "LinkedField",
                        "name": "action",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": v0,
                                "action": "THROW",
                                "path": "administerProject.canPerform"
                            }
                        ],
                        "storageKey": "action(type:\"EDIT_PROJECT_CONFIG\")"
                    },
                    "action": "THROW",
                    "path": "administerProject"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "alias": "createIssues",
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "type",
                                "value": "CREATE_ISSUES"
                            }
                        ],
                        "concreteType": "JiraProjectAction",
                        "kind": "LinkedField",
                        "name": "action",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": v0,
                                "action": "THROW",
                                "path": "createIssues.canPerform"
                            }
                        ],
                        "storageKey": "action(type:\"CREATE_ISSUES\")"
                    },
                    "action": "THROW",
                    "path": "createIssues"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "alias": "deleteIssues",
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "type",
                                "value": "DELETE_ISSUES"
                            }
                        ],
                        "concreteType": "JiraProjectAction",
                        "kind": "LinkedField",
                        "name": "action",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": v0,
                                "action": "THROW",
                                "path": "deleteIssues.canPerform"
                            }
                        ],
                        "storageKey": "action(type:\"DELETE_ISSUES\")"
                    },
                    "action": "THROW",
                    "path": "deleteIssues"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "alias": "editIssues",
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "type",
                                "value": "EDIT_ISSUES"
                            }
                        ],
                        "concreteType": "JiraProjectAction",
                        "kind": "LinkedField",
                        "name": "action",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": v0,
                                "action": "THROW",
                                "path": "editIssues.canPerform"
                            }
                        ],
                        "storageKey": "action(type:\"EDIT_ISSUES\")"
                    },
                    "action": "THROW",
                    "path": "editIssues"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "alias": "linkIssues",
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "type",
                                "value": "LINK_ISSUES"
                            }
                        ],
                        "concreteType": "JiraProjectAction",
                        "kind": "LinkedField",
                        "name": "action",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": v0,
                                "action": "THROW",
                                "path": "linkIssues.canPerform"
                            }
                        ],
                        "storageKey": "action(type:\"LINK_ISSUES\")"
                    },
                    "action": "THROW",
                    "path": "linkIssues"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "alias": "scheduleIssues",
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "type",
                                "value": "SCHEDULE_ISSUES"
                            }
                        ],
                        "concreteType": "JiraProjectAction",
                        "kind": "LinkedField",
                        "name": "action",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": v0,
                                "action": "THROW",
                                "path": "scheduleIssues.canPerform"
                            }
                        ],
                        "storageKey": "action(type:\"SCHEDULE_ISSUES\")"
                    },
                    "action": "THROW",
                    "path": "scheduleIssues"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "alias": "transitionIssues",
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "type",
                                "value": "TRANSITION_ISSUES"
                            }
                        ],
                        "concreteType": "JiraProjectAction",
                        "kind": "LinkedField",
                        "name": "action",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": v0,
                                "action": "THROW",
                                "path": "transitionIssues.canPerform"
                            }
                        ],
                        "storageKey": "action(type:\"TRANSITION_ISSUES\")"
                    },
                    "action": "THROW",
                    "path": "transitionIssues"
                },
                {
                    "kind": "RequiredField",
                    "field": {
                        "alias": "viewIssues",
                        "args": [
                            {
                                "kind": "Literal",
                                "name": "type",
                                "value": "VIEW_ISSUES"
                            }
                        ],
                        "concreteType": "JiraProjectAction",
                        "kind": "LinkedField",
                        "name": "action",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "RequiredField",
                                "field": v0,
                                "action": "THROW",
                                "path": "viewIssues.canPerform"
                            }
                        ],
                        "storageKey": "action(type:\"VIEW_ISSUES\")"
                    },
                    "action": "THROW",
                    "path": "viewIssues"
                }
            ],
            "type": "JiraProject"
        };
    }();
    $86f6b5f51dcbf821$var$node.hash = "98150a5607016a9ea425926244f44d6a";
    var $86f6b5f51dcbf821$export$2e2bcd8739ae039 = $86f6b5f51dcbf821$var$node;
});
parcelRegister("12jwF", function(module, exports) {
    $parcel$export(module.exports, "AriProvider", ()=>$d9a27a44a6301e03$export$c806f8ac05dc61fa);
    $parcel$export(module.exports, "useEntityAri", ()=>$d9a27a44a6301e03$export$badcacdc306567b8);
    var $5uXOq = parcelRequire("5uXOq");
    const $d9a27a44a6301e03$var$AriContext = (0, $5uXOq.createContext)('');
    const $d9a27a44a6301e03$export$c806f8ac05dc61fa = ({ ari: ari, children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement($d9a27a44a6301e03$var$AriContext.Provider, {
            value: ari
        }, children);
    const $d9a27a44a6301e03$export$badcacdc306567b8 = ()=>(0, $5uXOq.useContext)($d9a27a44a6301e03$var$AriContext);
});
parcelRegister("54qG5", function(module, exports) {
    $parcel$export(module.exports, "BusinessEntityProvider", ()=>$a71d927d8f07dfcc$export$c800e064c3c327ef);
    $parcel$export(module.exports, "useBusinessEntity", ()=>$a71d927d8f07dfcc$export$ff2574b00bc1c100);
    var $5uXOq = parcelRequire("5uXOq");
    const $a71d927d8f07dfcc$var$BusinessEntityContext = (0, $5uXOq.createContext)(null);
    const $a71d927d8f07dfcc$export$c800e064c3c327ef = ({ data: data, children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement($a71d927d8f07dfcc$var$BusinessEntityContext.Provider, {
            value: data
        }, children);
    const $a71d927d8f07dfcc$export$ff2574b00bc1c100 = ()=>{
        const entity = (0, $5uXOq.useContext)($a71d927d8f07dfcc$var$BusinessEntityContext);
        return {
            data: entity
        };
    };
});
parcelRegister("5YBrl", function(module, exports) {
    $parcel$export(module.exports, "JqlProvider", ()=>$81e54c5b62a4ab4d$export$fdc879e2ba0da048);
    $parcel$export(module.exports, "useJqlContext", ()=>$81e54c5b62a4ab4d$export$f32e2f688fc08561);
    var $5uXOq = parcelRequire("5uXOq");
    const $81e54c5b62a4ab4d$var$JqlContext = (0, $5uXOq.createContext)('');
    const $81e54c5b62a4ab4d$export$fdc879e2ba0da048 = ({ jqlContext: jqlContext, children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement($81e54c5b62a4ab4d$var$JqlContext.Provider, {
            value: jqlContext
        }, children);
    const $81e54c5b62a4ab4d$export$f32e2f688fc08561 = ()=>(0, $5uXOq.useContext)($81e54c5b62a4ab4d$var$JqlContext);
});
parcelRegister("1Zr0i", function(module, exports) {
    $parcel$export(module.exports, "RealtimeProvider", ()=>$6a65786548fb921c$export$64d242981d970821);
    $parcel$export(module.exports, "useRealtimeContext", ()=>$6a65786548fb921c$export$f39c07717ad8c35b);
    var $5uXOq = parcelRequire("5uXOq");
    const $6a65786548fb921c$var$RealtimeContext = (0, $5uXOq.createContext)([]);
    const $6a65786548fb921c$export$64d242981d970821 = ({ ids: ids, children: children })=>{
        const projectsIds = (0, $5uXOq.useMemo)(()=>ids ? ids.map((pid)=>String(pid)) : [], [
            ids
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($6a65786548fb921c$var$RealtimeContext.Provider, {
            value: projectsIds
        }, children);
    };
    const $6a65786548fb921c$export$f39c07717ad8c35b = ()=>(0, $5uXOq.useContext)($6a65786548fb921c$var$RealtimeContext);
});
parcelRegister("daQYX", function(module, exports) {
    $parcel$export(module.exports, "ProjectHookProvider", ()=>$cf7f84dff81db95f$export$f1938a4916a14d9f);
    $parcel$export(module.exports, "useProject", ()=>$cf7f84dff81db95f$export$51b1383ef8844a7);
    var $5uXOq = parcelRequire("5uXOq");
    const $cf7f84dff81db95f$var$Context = (0, $5uXOq.createContext)(null);
    const $cf7f84dff81db95f$export$f1938a4916a14d9f = ({ project: project, children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement($cf7f84dff81db95f$var$Context.Provider, {
            value: project
        }, children);
    const $cf7f84dff81db95f$export$51b1383ef8844a7 = ()=>{
        const project = (0, $5uXOq.useContext)($cf7f84dff81db95f$var$Context);
        if (!project) throw new Error('useProject must be used within a ProjectHookProvider');
        return project;
    };
});
parcelRegister("gxGcZ", function(module, exports) {
    $parcel$export(module.exports, "FiltersProvider", ()=>$5ac2d1f4676106ae$export$905df3588d1d8c75);
    $parcel$export(module.exports, "useAssigneesFilterQuery", ()=>$5ac2d1f4676106ae$export$f39bce8705b01ff5);
    $parcel$export(module.exports, "useProjectFilter", ()=>$5ac2d1f4676106ae$export$b71768ffb8163578);
    $parcel$export(module.exports, "useAllowedFieldTypes", ()=>$5ac2d1f4676106ae$export$9dc8a291956c2fa9);
    var $5uXOq = parcelRequire("5uXOq");
    var $5fc53;
    var $gzkAf;
    const $5ac2d1f4676106ae$var$DEFAULT_VALUE = {
        assigneeQuery: '',
        projectFilter: {
            totalCount: 0,
            options: []
        }
    };
    const $5ac2d1f4676106ae$var$FiltersContext = (0, $5uXOq.createContext)($5ac2d1f4676106ae$var$DEFAULT_VALUE);
    const $5ac2d1f4676106ae$export$905df3588d1d8c75 = ({ projects: projects, children: children })=>{
        const value = (0, $5uXOq.useMemo)(()=>{
            if (!projects) return $5ac2d1f4676106ae$var$DEFAULT_VALUE;
            const assigneeQuery = `is assignee of (${projects.map((project)=>project.key).join(', ')})`;
            const projectFilter = {
                totalCount: projects.length,
                options: projects.map((project)=>({
                        label: project.name,
                        value: String(project.id),
                        avatar: project.avatarUrl,
                        square: true
                    }))
            };
            return {
                assigneeQuery: assigneeQuery,
                projectFilter: projectFilter
            };
        }, [
            projects
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($5ac2d1f4676106ae$var$FiltersContext.Provider, {
            value: value
        }, children);
    };
    const $5ac2d1f4676106ae$export$f39bce8705b01ff5 = ()=>(0, $5uXOq.useContext)($5ac2d1f4676106ae$var$FiltersContext).assigneeQuery;
    const $5ac2d1f4676106ae$export$b71768ffb8163578 = ()=>(0, $5uXOq.useContext)($5ac2d1f4676106ae$var$FiltersContext).projectFilter;
    const $5ac2d1f4676106ae$export$9dc8a291956c2fa9 = (inputAllowedFieldTypes)=>{
        const filtersContext = (0, $5uXOq.useContext)($5ac2d1f4676106ae$var$FiltersContext);
        return (0, $5uXOq.useMemo)(()=>{
            const result = new Set(inputAllowedFieldTypes ?? (0, (0, parcelRequire("gzkAf")).BUSINESS_FIELD_TYPES));
            if (filtersContext.projectFilter.totalCount <= 1) result.delete((0, (0, parcelRequire("5fc53")).PROJECT_TYPE));
            return result;
        }, [
            filtersContext,
            inputAllowedFieldTypes
        ]);
    };
});
parcelRegister("gzkAf", function(module, exports) {
    $parcel$export(module.exports, "POPUP_WIDTH", ()=>$92b04c6ea9a59b67$export$b6d617db656efcca);
    $parcel$export(module.exports, "SHOW_MORE_OPTIONS_BTN_SIZE", ()=>$92b04c6ea9a59b67$export$dd535f74d98d8b3);
    $parcel$export(module.exports, "OPTIONS_AVAILABLE_WIDTH", ()=>$92b04c6ea9a59b67$export$dba112976ea61483);
    $parcel$export(module.exports, "GAP_BETWEEN_OPTION", ()=>$92b04c6ea9a59b67$export$fe1082abeeda69ed);
    $parcel$export(module.exports, "OPTION_SPAN_PADDING", ()=>$92b04c6ea9a59b67$export$17ed91292eb6c163);
    $parcel$export(module.exports, "OPTION_DEFAULT_FONT_SIZE", ()=>$92b04c6ea9a59b67$export$fb22dccd99438559);
    $parcel$export(module.exports, "POPUP_OFFSET_TOP", ()=>$92b04c6ea9a59b67$export$15839778e99d81e7);
    $parcel$export(module.exports, "OPTION_MAX_WIDTH", ()=>$92b04c6ea9a59b67$export$39aa3a14ebf850c7);
    $parcel$export(module.exports, "DATE_RANGE_TYPE", ()=>$92b04c6ea9a59b67$export$1178808c606e043b);
    $parcel$export(module.exports, "BUSINESS_FIELD_TYPES", ()=>$92b04c6ea9a59b67$export$c269ba5d631cb115);
    $parcel$export(module.exports, "SOFTWARE_FIELD_TYPES", ()=>$92b04c6ea9a59b67$export$232814e45256d5dc);
    $parcel$export(module.exports, "IMPLEMENTED_TYPES", ()=>$92b04c6ea9a59b67$export$9615a3d79408a88a);
    $parcel$export(module.exports, "EXTRA_CUSTOM_FIELD_TYPES", ()=>$92b04c6ea9a59b67$export$a21166a4b76932b5);
    $parcel$export(module.exports, "SAVED_FILTERS_PER_PAGE", ()=>$92b04c6ea9a59b67$export$1989c7236a398e8a);
    var $gwIPs;
    var $5fc53;
    const $92b04c6ea9a59b67$export$b6d617db656efcca = 360;
    const $92b04c6ea9a59b67$export$90bfd0dcc25478e1 = (0, (0, parcelRequire("gwIPs")).gridSize) * 2.5;
    const $92b04c6ea9a59b67$export$dd535f74d98d8b3 = 32;
    const $92b04c6ea9a59b67$export$dba112976ea61483 = $92b04c6ea9a59b67$export$b6d617db656efcca - $92b04c6ea9a59b67$export$90bfd0dcc25478e1 * 2;
    const $92b04c6ea9a59b67$export$fe1082abeeda69ed = (0, (0, parcelRequire("gwIPs")).gridSize) / 2;
    const $92b04c6ea9a59b67$export$17ed91292eb6c163 = (0, (0, parcelRequire("gwIPs")).gridSize) * 2;
    const $92b04c6ea9a59b67$export$fb22dccd99438559 = 14;
    const $92b04c6ea9a59b67$export$15839778e99d81e7 = 215;
    const $92b04c6ea9a59b67$export$de3cbeaaf9d2669 = 28;
    const $92b04c6ea9a59b67$export$39aa3a14ebf850c7 = 150;
    const $92b04c6ea9a59b67$export$1178808c606e043b = 'dateRange';
    const $92b04c6ea9a59b67$export$c269ba5d631cb115 = [
        (0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE),
        (0, (0, parcelRequire("5fc53")).CATEGORY_TYPE),
        (0, (0, parcelRequire("5fc53")).COMPONENTS_TYPE),
        (0, (0, parcelRequire("5fc53")).CREATED),
        $92b04c6ea9a59b67$export$1178808c606e043b,
        (0, (0, parcelRequire("5fc53")).ISSUE_TYPE),
        (0, (0, parcelRequire("5fc53")).LABELS_TYPE),
        (0, (0, parcelRequire("5fc53")).PRIORITY_TYPE),
        (0, (0, parcelRequire("5fc53")).PROJECT_TYPE),
        (0, (0, parcelRequire("5fc53")).REPORTER_TYPE),
        (0, (0, parcelRequire("5fc53")).STATUS_TYPE),
        (0, (0, parcelRequire("5fc53")).UPDATED),
        (0, (0, parcelRequire("5fc53")).USER_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).SELECT_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).MULTI_SELECT_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).MULTI_CHECKBOXES_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).PEOPLE_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).DATE_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).GOALS_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).TEAMS_PLATFORM_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).PARENT_FIELD_TYPE)
    ];
    const $92b04c6ea9a59b67$export$232814e45256d5dc = [
        (0, (0, parcelRequire("5fc53")).SPRINT_TYPE),
        (0, (0, parcelRequire("5fc53")).FIX_VERSIONS_TYPE)
    ];
    const $92b04c6ea9a59b67$export$9615a3d79408a88a = new Set([
        ...$92b04c6ea9a59b67$export$c269ba5d631cb115,
        ...$92b04c6ea9a59b67$export$232814e45256d5dc
    ]);
    const $92b04c6ea9a59b67$export$a21166a4b76932b5 = new Set([
        (0, (0, parcelRequire("5fc53")).USER_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).SELECT_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).MULTI_SELECT_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).MULTI_CHECKBOXES_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).PEOPLE_CF_TYPE),
        (0, (0, parcelRequire("5fc53")).DATE_CF_TYPE)
    ]);
    const $92b04c6ea9a59b67$export$90ca377eb0b24ff1 = {
        assignee: (0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE),
        component: (0, (0, parcelRequire("5fc53")).COMPONENTS_TYPE),
        created: (0, (0, parcelRequire("5fc53")).CREATED),
        issuetype: (0, (0, parcelRequire("5fc53")).ISSUE_TYPE),
        labels: (0, (0, parcelRequire("5fc53")).LABELS_TYPE),
        priority: (0, (0, parcelRequire("5fc53")).PRIORITY_TYPE),
        project: (0, (0, parcelRequire("5fc53")).PROJECT_TYPE),
        reporter: (0, (0, parcelRequire("5fc53")).REPORTER_TYPE),
        status: (0, (0, parcelRequire("5fc53")).STATUS_TYPE),
        type: (0, (0, parcelRequire("5fc53")).ISSUE_TYPE),
        updated: (0, (0, parcelRequire("5fc53")).UPDATED)
    };
    const $92b04c6ea9a59b67$export$6a2e733db5135f27 = (0, (0, parcelRequire("gwIPs")).gridSize) * 3.5;
    const $92b04c6ea9a59b67$export$1989c7236a398e8a = 50;
    const $92b04c6ea9a59b67$export$91fc9d65fca142a3 = 'users';
    const $92b04c6ea9a59b67$export$d74c70f8fb216c6b = 'recentlyUsedUsers';
});
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';
parcelRegister("k7McJ", function(module, exports) {
    $parcel$export(module.exports, "FETCH_PROJECT_EXPERIENCE", ()=>$47951bf9c4bef1f5$export$cb40bbf7ea51db63);
    const $47951bf9c4bef1f5$export$cb40bbf7ea51db63 = {
        experience: 'fetch-project',
        packageName: 'jiraBusinessEntityProjectProvider',
        teamName: 'wanjel'
    };
});
parcelRegister("8OqLl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a5cc2e237e9a9763$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $1jUsD;
    const $a5cc2e237e9a9763$var$NotFoundComponent = (0, (0, parcelRequire("1jUsD")).lazyAfterPaint)(()=>(parcelRequire("imwWS")), {
        moduleId: "./src/packages/business/entity/project-provider/src/ui/project-context/not-found/main.tsx"
    });
    const $a5cc2e237e9a9763$var$NotFoundAsync = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "not-found-component",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($a5cc2e237e9a9763$var$NotFoundComponent, null));
    var $a5cc2e237e9a9763$export$2e2bcd8739ae039 = $a5cc2e237e9a9763$var$NotFoundAsync;
});
parcelRegister("imwWS", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("azGse")
    ]).then(()=>parcelRequire('4zX1V'));
});
parcelRegister("x8FYU", function(module, exports) {
    $parcel$export(module.exports, "ACTIVE_WORKFLOW_PREFERENCE", ()=>$3a8fd327ed3934d4$export$5d3f940b56d7af28);
    $parcel$export(module.exports, "COLLAPSED_COLUMNS_PREFERENCE", ()=>$3a8fd327ed3934d4$export$8019dfa5a44f6d46);
    $parcel$export(module.exports, "COLUMNS_ORDER_PREFERENCE", ()=>$3a8fd327ed3934d4$export$3ef984a9f784490f);
    $parcel$export(module.exports, "CREATE_TYPE_ID_PREFERENCE", ()=>$3a8fd327ed3934d4$export$2df4c3d44dcb1e5b);
    $parcel$export(module.exports, "EXPANDED_ISSUES_PREFERENCE", ()=>$3a8fd327ed3934d4$export$638c3932e4cbdede);
    $parcel$export(module.exports, "FIELDS_PREFERENCE", ()=>$3a8fd327ed3934d4$export$e3ddfc509464e305);
    $parcel$export(module.exports, "FIELDS_DETAIL_PREFERENCE", ()=>$3a8fd327ed3934d4$export$ffcb5603c64e12d0);
    $parcel$export(module.exports, "FILTER_PREFERENCE", ()=>$3a8fd327ed3934d4$export$f50d5db589fb1475);
    $parcel$export(module.exports, "GROUPING_PREFERENCE", ()=>$3a8fd327ed3934d4$export$ac8a4771da7f03af);
    $parcel$export(module.exports, "HIDE_DONE_ITEMS_PREFERENCE", ()=>$3a8fd327ed3934d4$export$4aace169721c2927);
    $parcel$export(module.exports, "HIDE_SOFTWARE_RELEASE_PREFERENCE", ()=>$3a8fd327ed3934d4$export$983f0d3325e2938);
    $parcel$export(module.exports, "RANGE_MODE_PREFERENCE", ()=>$3a8fd327ed3934d4$export$f43988a3762bf711);
    $parcel$export(module.exports, "SORTING_PREFERENCE", ()=>$3a8fd327ed3934d4$export$373eea1341dcff74);
    $parcel$export(module.exports, "BOARD_VIEW_PREFERENCES", ()=>$3a8fd327ed3934d4$export$4ec60be96e9eadc0);
    $parcel$export(module.exports, "LIST_VIEW_PREFERENCES", ()=>$3a8fd327ed3934d4$export$43fc1ec27b2f1801);
    $parcel$export(module.exports, "CALENDAR_VIEW_PREFERENCES", ()=>$3a8fd327ed3934d4$export$14e2a519a8c2881a);
    $parcel$export(module.exports, "TIMELINE_VIEW_PREFERENCES", ()=>$3a8fd327ed3934d4$export$8443f3f4fd94276);
    $parcel$export(module.exports, "ATTACHMENTS_VIEW_PREFERENCES", ()=>$3a8fd327ed3934d4$export$2e2923d9c9daba20);
    var $hE5wF;
    var $54zCO;
    const $3a8fd327ed3934d4$export$5d3f940b56d7af28 = (0, (0, parcelRequire("54zCO")).createSimplePreference)('activeWorkflow');
    const $3a8fd327ed3934d4$export$8019dfa5a44f6d46 = (0, (0, parcelRequire("54zCO")).createSimplePreference)('collapsedColumns');
    const $3a8fd327ed3934d4$export$3ef984a9f784490f = (0, (0, parcelRequire("54zCO")).createSimplePreference)('columnOrder');
    const $3a8fd327ed3934d4$export$2df4c3d44dcb1e5b = (0, (0, parcelRequire("54zCO")).createSimplePreference)('createType');
    const $3a8fd327ed3934d4$export$638c3932e4cbdede = (0, (0, parcelRequire("54zCO")).createSimplePreference)('expandedIssues');
    const $3a8fd327ed3934d4$export$e3ddfc509464e305 = (0, (0, parcelRequire("54zCO")).createSimplePreference)('fields');
    const $3a8fd327ed3934d4$export$ffcb5603c64e12d0 = (0, (0, parcelRequire("54zCO")).createSimplePreference)('fieldsDetail');
    const $3a8fd327ed3934d4$export$f50d5db589fb1475 = (0, (0, parcelRequire("54zCO")).createSimpleUrlPreference)((0, (0, parcelRequire("hE5wF")).FILTER_PARAM));
    const $3a8fd327ed3934d4$export$ac8a4771da7f03af = (0, (0, parcelRequire("54zCO")).createSimpleUrlPreference)('groupBy');
    const $3a8fd327ed3934d4$export$4aace169721c2927 = (0, (0, parcelRequire("54zCO")).createSimpleUrlPreference)('hideDone');
    const $3a8fd327ed3934d4$export$983f0d3325e2938 = (0, (0, parcelRequire("54zCO")).createSimpleUrlPreference)('hideSoftwareRelease');
    const $3a8fd327ed3934d4$export$f43988a3762bf711 = (0, (0, parcelRequire("54zCO")).createSimpleUrlPreference)('rangeMode');
    const $3a8fd327ed3934d4$export$373eea1341dcff74 = {
        ...(0, (0, parcelRequire("54zCO")).createSimplePreference)('sorting'),
        queryParameter: {
            serialize: (value)=>({
                    sortBy: value?.sortBy,
                    direction: value?.direction
                }),
            deserialize: (value)=>value.sortBy ? {
                    sortBy: value.sortBy,
                    direction: value.direction
                } : undefined
        }
    };
    const $3a8fd327ed3934d4$export$4ec60be96e9eadc0 = [
        $3a8fd327ed3934d4$export$5d3f940b56d7af28,
        $3a8fd327ed3934d4$export$8019dfa5a44f6d46,
        $3a8fd327ed3934d4$export$3ef984a9f784490f,
        $3a8fd327ed3934d4$export$2df4c3d44dcb1e5b,
        $3a8fd327ed3934d4$export$638c3932e4cbdede,
        $3a8fd327ed3934d4$export$e3ddfc509464e305,
        $3a8fd327ed3934d4$export$f50d5db589fb1475,
        $3a8fd327ed3934d4$export$ac8a4771da7f03af
    ];
    const $3a8fd327ed3934d4$export$43fc1ec27b2f1801 = [
        $3a8fd327ed3934d4$export$2df4c3d44dcb1e5b,
        $3a8fd327ed3934d4$export$e3ddfc509464e305,
        $3a8fd327ed3934d4$export$ffcb5603c64e12d0,
        $3a8fd327ed3934d4$export$f50d5db589fb1475,
        $3a8fd327ed3934d4$export$ac8a4771da7f03af,
        $3a8fd327ed3934d4$export$4aace169721c2927,
        $3a8fd327ed3934d4$export$373eea1341dcff74
    ];
    const $3a8fd327ed3934d4$export$14e2a519a8c2881a = [
        $3a8fd327ed3934d4$export$2df4c3d44dcb1e5b,
        $3a8fd327ed3934d4$export$f50d5db589fb1475,
        $3a8fd327ed3934d4$export$4aace169721c2927,
        $3a8fd327ed3934d4$export$983f0d3325e2938
    ];
    const $3a8fd327ed3934d4$export$8443f3f4fd94276 = [
        $3a8fd327ed3934d4$export$2df4c3d44dcb1e5b,
        $3a8fd327ed3934d4$export$f50d5db589fb1475,
        $3a8fd327ed3934d4$export$4aace169721c2927,
        $3a8fd327ed3934d4$export$f43988a3762bf711
    ];
    const $3a8fd327ed3934d4$export$2e2923d9c9daba20 = [
        $3a8fd327ed3934d4$export$f50d5db589fb1475
    ];
});
parcelRegister("hE5wF", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_RANK_SORTING_DIRECTION", ()=>$bfd6cbe4770149b5$export$8386e51ba415e85d);
    $parcel$export(module.exports, "DEFAULT_AVATAR_RES", ()=>$bfd6cbe4770149b5$export$159fe44438c210e9);
    $parcel$export(module.exports, "FILTER_PARAM", ()=>$bfd6cbe4770149b5$export$d8301e0b33832d94);
    $parcel$export(module.exports, "INLINE_CREATE_PARAM", ()=>$bfd6cbe4770149b5$export$599c163c1570a353);
    $parcel$export(module.exports, "INVITE_OPEN_PARAM", ()=>$bfd6cbe4770149b5$export$3a74d1a195d2f007);
    $parcel$export(module.exports, "SELECTED_ISSUE_PARAM", ()=>$bfd6cbe4770149b5$export$c070acdc9b0f1be5);
    $parcel$export(module.exports, "SELECTED_COMMENT_PARAM", ()=>$bfd6cbe4770149b5$export$3bcbd99d0f9ad6d8);
    $parcel$export(module.exports, "GROUP_BY_ASSIGNEE", ()=>$bfd6cbe4770149b5$export$dba794af6c0f2afc);
    $parcel$export(module.exports, "GROUP_BY_PRIORITY", ()=>$bfd6cbe4770149b5$export$56ecb5d2dfb80edc);
    $parcel$export(module.exports, "GROUP_BY_CATEGORY", ()=>$bfd6cbe4770149b5$export$22ef551f315f2786);
    $parcel$export(module.exports, "GROUP_BY_STATUS", ()=>$bfd6cbe4770149b5$export$6d69efb296b78a);
    $parcel$export(module.exports, "START_DATE_ALIAS_FIELD_ID", ()=>$bfd6cbe4770149b5$export$e23e1d1ea45171c2);
    $parcel$export(module.exports, "RANK_ALIAS_FIELD_ID", ()=>$bfd6cbe4770149b5$export$e35c6e217c75dc4b);
    $parcel$export(module.exports, "REMOTE_ISSUE_LINKS_TYPE", ()=>$bfd6cbe4770149b5$export$e5eab344feb92af9);
    $parcel$export(module.exports, "COMMENT_SUMMARY_TYPE", ()=>$bfd6cbe4770149b5$export$a311e1b78816c048);
    $parcel$export(module.exports, "CARD_COVERS_TYPE", ()=>$bfd6cbe4770149b5$export$f5583ff4ab4d63e5);
    $parcel$export(module.exports, "DEFAULT_PAGE_SIZE", ()=>$bfd6cbe4770149b5$export$5716e8bcb003888d);
    $parcel$export(module.exports, "STORY_POINTS_ALIAS_FIELD_ID", ()=>$bfd6cbe4770149b5$export$1f9fb9f15184100f);
    $parcel$export(module.exports, "STORY_POINT_ESTIMATE_ALIAS_FIELD_ID", ()=>$bfd6cbe4770149b5$export$c72ea455b368cdd9);
    const $bfd6cbe4770149b5$export$8386e51ba415e85d = (0, $2a9e000a443b1a95$export$1dee026a19752d6b);
    const $bfd6cbe4770149b5$export$159fe44438c210e9 = '48x48';
    const $bfd6cbe4770149b5$export$d8301e0b33832d94 = 'filter';
    const $bfd6cbe4770149b5$export$599c163c1570a353 = 'inlineCreate';
    const $bfd6cbe4770149b5$export$3a74d1a195d2f007 = 'inviteOpen';
    const $bfd6cbe4770149b5$export$e1e3f9fa6f04d6d = 'quickFilters';
    const $bfd6cbe4770149b5$export$c070acdc9b0f1be5 = 'selectedIssue';
    const $bfd6cbe4770149b5$export$3bcbd99d0f9ad6d8 = 'selectedComment';
    const $bfd6cbe4770149b5$export$dba794af6c0f2afc = 'assignee';
    const $bfd6cbe4770149b5$export$56ecb5d2dfb80edc = 'priority';
    const $bfd6cbe4770149b5$export$22ef551f315f2786 = 'category';
    const $bfd6cbe4770149b5$export$6d69efb296b78a = 'status';
    const $bfd6cbe4770149b5$export$e23e1d1ea45171c2 = 'startdate';
    const $bfd6cbe4770149b5$export$e35c6e217c75dc4b = 'rank';
    const $bfd6cbe4770149b5$export$e5eab344feb92af9 = 'remoteIssueLinks';
    const $bfd6cbe4770149b5$export$a311e1b78816c048 = 'commentsummary';
    const $bfd6cbe4770149b5$export$f5583ff4ab4d63e5 = 'cardCovers';
    const $bfd6cbe4770149b5$export$5716e8bcb003888d = 25;
    const $bfd6cbe4770149b5$export$1f9fb9f15184100f = 'storypoints';
    const $bfd6cbe4770149b5$export$c72ea455b368cdd9 = 'storypointestimate';
    const $bfd6cbe4770149b5$export$786b42b4618e6ee4 = 'sprint';
});
const $2a9e000a443b1a95$export$1dee026a19752d6b = 'ASC';
const $2a9e000a443b1a95$export$b6abcf7fa1d94f65 = 'DESC';
parcelRegister("54zCO", function(module, exports) {
    $parcel$export(module.exports, "createSimplePreference", ()=>$7a26b5020c269cbd$export$464a71be397e5f3d);
    $parcel$export(module.exports, "createSimpleUrlPreference", ()=>$7a26b5020c269cbd$export$78f3983105936d30);
    var $etyzk = parcelRequire("etyzk");
    const $7a26b5020c269cbd$export$464a71be397e5f3d = (id)=>({
            id: id,
            serialize: (0, ($parcel$interopDefault($etyzk))),
            deserialize: (0, ($parcel$interopDefault($etyzk)))
        });
    const $7a26b5020c269cbd$export$78f3983105936d30 = (queryParameter)=>({
            id: queryParameter,
            serialize: (0, ($parcel$interopDefault($etyzk))),
            deserialize: (0, ($parcel$interopDefault($etyzk))),
            queryParameter: {
                serialize: (value)=>({
                        [queryParameter]: value
                    }),
                deserialize: (value)=>value[queryParameter]
            }
        });
});
parcelRegister("1kpI8", function(module, exports) {
    $parcel$export(module.exports, "ViewPreferencesProvider", ()=>$5141bcd6fd206946$export$1db44e21d818b27);
    $parcel$export(module.exports, "useViewPreference", ()=>$5141bcd6fd206946$export$ee494de6c0ff45d7);
    var $5uXOq = parcelRequire("5uXOq");
    var $ajpes = parcelRequire("ajpes");
    var $54qG5;
    var $1XJ20;
    var $doZTA;
    var $kGDhO;
    const $5141bcd6fd206946$var$ViewPreferencesContext = (0, $5uXOq.createContext)(null);
    const $5141bcd6fd206946$export$1db44e21d818b27 = ({ view: view, preferences: preferences, children: children, persistChanges: persistChanges = true })=>{
        const { data: entity } = (0, (0, parcelRequire("54qG5")).useBusinessEntity)();
        const [{ query: query }, routerActions] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const { updateQueryParam: updateQueryParam } = routerActions;
        const prevQuery = (0, (0, parcelRequire("1XJ20")).usePreviousWithInitial)(query);
        const [store, setStore] = (0, $5uXOq.useState)(()=>preferences.reduce((acc, preference)=>{
                let value;
                const { id: id, queryParameter: queryParameter } = preference;
                const queryValue = queryParameter && queryParameter.deserialize(query);
                if (queryValue) value = queryValue;
                else if (persistChanges) value = preference.deserialize((0, (0, parcelRequire("kGDhO")).getPreference)(entity.id, view, preference.id));
                acc[id] = value;
                return acc;
            }, {}));
        const setPreferenceValue = (0, $5uXOq.useCallback)((preference, value, action)=>{
            setStore((prevStore)=>{
                const newStore = {
                    ...prevStore,
                    [preference.id]: value
                };
                return newStore;
            });
            if (preference.queryParameter && action !== 'none') updateQueryParam(preference.queryParameter.serialize(value), action);
            if (persistChanges) {
                const serializedValue = preference.serialize(value);
                (0, (0, parcelRequire("kGDhO")).setPreference)(entity.id, view, preference.id, serializedValue);
            }
        }, [
            persistChanges,
            updateQueryParam,
            entity.id,
            view
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!persistChanges) return;
            let restoredQuery = {};
            for (const preference of preferences){
                const value = store[preference.id];
                if (value && preference.queryParameter) restoredQuery = {
                    ...restoredQuery,
                    ...preference.queryParameter.serialize(value)
                };
            }
            updateQueryParam({
                ...restoredQuery,
                ...query
            }, 'replace');
        }, []);
        (0, $5uXOq.useEffect)(()=>{
            if (!(0, ($parcel$interopDefault($ajpes)))(prevQuery, query)) {
                const newState = preferences.reduce((acc, preference)=>{
                    const { id: id, queryParameter: queryParameter } = preference;
                    if (queryParameter) {
                        const queryValue = queryParameter.deserialize(query);
                        acc[id] = queryValue;
                    }
                    return acc;
                }, {});
                setStore({
                    ...store,
                    ...newState
                });
            }
        }, [
            preferences,
            query,
            store,
            entity.id,
            view,
            prevQuery
        ]);
        const contextValue = (0, $5uXOq.useMemo)(()=>({
                store: store,
                setPreferenceValue: setPreferenceValue
            }), [
            store,
            setPreferenceValue
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($5141bcd6fd206946$var$ViewPreferencesContext.Provider, {
            value: contextValue
        }, children);
    };
    const $5141bcd6fd206946$export$ee494de6c0ff45d7 = (preference)=>{
        const { store: store, setPreferenceValue: setPreferenceValue } = (0, $5uXOq.useContext)($5141bcd6fd206946$var$ViewPreferencesContext);
        const setValue = (0, $5uXOq.useCallback)((value, action = 'push')=>{
            setPreferenceValue(preference, value, action);
        }, [
            preference,
            setPreferenceValue
        ]);
        const value = store[preference.id];
        return [
            value,
            setValue
        ];
    };
});
parcelRegister("kGDhO", function(module, exports) {
    $parcel$export(module.exports, "setPreference", ()=>$39001b1dd806b76a$export$c6483f3cdc3e51e1);
    $parcel$export(module.exports, "getPreference", ()=>$39001b1dd806b76a$export$5fa261395d19a143);
    var $bSSG7;
    const $39001b1dd806b76a$var$store = (0, (0, parcelRequire("bSSG7")).createLocalStorageProvider)('jwm-view-preferences');
    const $39001b1dd806b76a$var$buildPreferenceKey = (entityId, viewId, preferenceId)=>`${entityId}_${viewId}_${preferenceId}`;
    const $39001b1dd806b76a$export$c6483f3cdc3e51e1 = (entityId, viewId, preferenceId, value)=>{
        const key = $39001b1dd806b76a$var$buildPreferenceKey(entityId, viewId, preferenceId);
        $39001b1dd806b76a$var$store.set(key, value);
    };
    const $39001b1dd806b76a$export$5fa261395d19a143 = (entityId, viewId, preferenceId)=>{
        const key = $39001b1dd806b76a$var$buildPreferenceKey(entityId, viewId, preferenceId);
        return $39001b1dd806b76a$var$store.get(key);
    };
});
parcelRegister("jxKr9", function(module, exports) {
    $parcel$export(module.exports, "useTimelineFeatures", ()=>$29756a19c7ec4e53$export$e3e1501a9c056805);
    $parcel$export(module.exports, "default", ()=>$29756a19c7ec4e53$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $29756a19c7ec4e53$var$defaultFeaturesContext = {
        featureView: 'timeline',
        hasExportButton: true,
        hasInlineCreate: true,
        hasCreateSubtask: true,
        hasInviteButton: true,
        hasIssueLinking: true,
        hasOnboarding: true,
        hasPresence: true,
        hasScheduleIssues: true,
        hasShareButton: true,
        inlineCreateInteraction: 'default',
        inviteButtonInteraction: 'default',
        issueViewInteraction: 'default',
        stickyInlineCreateInteraction: 'default',
        hasFilterCustomFields: true
    };
    const $29756a19c7ec4e53$var$TimelineFeaturesContext = (0, $5uXOq.createContext)($29756a19c7ec4e53$var$defaultFeaturesContext);
    const $29756a19c7ec4e53$export$e3e1501a9c056805 = ()=>(0, $5uXOq.useContext)($29756a19c7ec4e53$var$TimelineFeaturesContext);
    const $29756a19c7ec4e53$var$TimelineFeaturesProvider = ({ children: children, ...props })=>{
        const value = (0, $5uXOq.useMemo)(()=>({
                ...$29756a19c7ec4e53$var$defaultFeaturesContext,
                ...props
            }), [
            props
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($29756a19c7ec4e53$var$TimelineFeaturesContext.Provider, {
            value: value
        }, children);
    };
    var $29756a19c7ec4e53$export$2e2bcd8739ae039 = $29756a19c7ec4e53$var$TimelineFeaturesProvider;
});
parcelRegister("194c9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4da6e8c21b23b481$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6Ll2T;
    var $99gde;
    var $aXhsp;
    var $AeWM3;
    var $eiOkd;
    var $adJfs;
    var $cm8b5;
    var $cLGgz;
    var $4R6GH;
    var $iXVV6;
    var $5oFIy;
    var $dCm1o;
    var $gNAqw;
    var $jxKr9;
    var $kjQs8;
    var $b8JKg;
    var $k91Ah;
    const $4da6e8c21b23b481$var$analyticsSourceName = 'timelineView';
    const $4da6e8c21b23b481$export$3395082fff6e3088 = (0, $5uXOq.memo)(()=>{
        const { hasInlineCreate: hasInlineCreate, hasFilterCustomFields: hasFilterCustomFields } = (0, (0, parcelRequire("jxKr9")).useTimelineFeatures)();
        const [{ timelineMode: timelineMode }] = (0, (0, parcelRequire("kjQs8")).useTimelineUI)();
        const analyticsAttributes = (0, $5uXOq.useMemo)(()=>({
                timelineMode: timelineMode
            }), [
            timelineMode
        ]);
        const services = (0, (0, parcelRequire("b8JKg")).useCreateIssue)();
        const content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            objectType: "timeline",
            attributes: analyticsAttributes,
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
            sourceName: $4da6e8c21b23b481$var$analyticsSourceName
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k91Ah")).default), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireScreenAnalytics), null));
        const isUsingIssueTypesAndFields = hasInlineCreate || hasFilterCustomFields;
        const content2 = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, isUsingIssueTypesAndFields ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("adJfs")).IssueTypesAndFieldsContext), null, hasInlineCreate ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cLGgz")).IssueCreateProvider), {
            onCreateIssue: services.createIssue,
            onRefetchIssue: services.refetchIssue
        }, content) : content) : content);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eiOkd")).default), {
            withSidebar: true,
            withOverflow: true,
            shouldAddPadding: !((0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_1'))
        }, (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_1') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            xcss: $4da6e8c21b23b481$var$timelineStyles
        }, content2) : content2);
    });
    const $4da6e8c21b23b481$var$Timeline = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cm8b5")).ExperienceErrorBoundary), {
            experience: (0, (0, parcelRequire("gNAqw")).MAIN_EXPERIENCE),
            shouldStartExperience: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("AeWM3")).ApolloClientProvider), {
            client: (0, (0, parcelRequire("aXhsp")).default)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($4da6e8c21b23b481$export$3395082fff6e3088, null)));
    var $4da6e8c21b23b481$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($4da6e8c21b23b481$var$Timeline);
    const $4da6e8c21b23b481$var$timelineStyles = (0, (0, parcelRequire("99gde")).xcss)({
        overflowX: 'hidden',
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        flexShrink: 1,
        maxWidth: '100%',
        minWidth: '0',
        width: 'auto',
        paddingLeft: 'space.300'
    });
});
parcelRegister("aXhsp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d88f4e626c9babc0$export$2e2bcd8739ae039);
    var $9XE6b = parcelRequire("9XE6b");
    var $ivfDv;
    var $e3a3O;
    var $clSzL;
    var $h4ppL;
    var $JPsIz;
    var $lC4FX;
    var $cuKXc = parcelRequire("cuKXc");
    var $dJl1T;
    var $jQUy5;
    var $l0T7c;
    var $9g713;
    const $d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID = 'gira';
    const $d88f4e626c9babc0$var$CACHE_NAME = `apollo-cache/${$d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID}`;
    const $d88f4e626c9babc0$var$LOG_NAMESPACE = `apollo.${$d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID}.error.graphql`;
    const $d88f4e626c9babc0$var$isSsrSuccessful = ()=>false ? true : !window || !window.SPA_STATE;
    const $d88f4e626c9babc0$var$NETWORK_ERRORS_COUNTER_KEY = 'networkErrorsCounter';
    const $d88f4e626c9babc0$export$851a7159daf49c89 = new (0, (0, parcelRequire("ivfDv")).IntrospectionFragmentMatcher)({
        introspectionQueryResultData: ($parcel$interopDefault((0, parcelRequire("l0T7c"))))
    });
    const $d88f4e626c9babc0$var$errorLink = (0, (0, parcelRequire("h4ppL")).onError)(({ graphQLErrors: graphQLErrors, networkError: networkError, operation: operation })=>{
        (0, (0, parcelRequire("9g713")).reportErrors)({
            graphQLErrors: graphQLErrors,
            operation: operation
        });
        const errorAnalytics = (0, (0, parcelRequire("9g713")).getErrorAnalyticsContext)(operation.getContext());
        if (errorAnalytics !== undefined) return;
        if (graphQLErrors) {
            if (Array.isArray(graphQLErrors)) graphQLErrors.map(({ message: message, locations: locations, path: path })=>(0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData($d88f4e626c9babc0$var$LOG_NAMESPACE, `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`, {
                    message: JSON.stringify(message),
                    path: JSON.stringify(path),
                    locations: JSON.stringify(locations)
                }));
            else (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData($d88f4e626c9babc0$var$LOG_NAMESPACE, '[GraphQL error]: Unexpected error message format', {
                message: JSON.stringify(graphQLErrors)
            });
        }
        if (networkError) {
            const occuredNetworkErrorsBefore = (0, ($parcel$interopDefault($9XE6b)))(operation.getContext(), [
                $d88f4e626c9babc0$var$NETWORK_ERRORS_COUNTER_KEY
            ], 0);
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData($d88f4e626c9babc0$var$LOG_NAMESPACE, `[Network error]: ${networkError}, attempt ${occuredNetworkErrorsBefore + 1}`);
            operation.setContext({
                [$d88f4e626c9babc0$var$NETWORK_ERRORS_COUNTER_KEY]: occuredNetworkErrorsBefore + 1
            });
        }
    });
    const $d88f4e626c9babc0$var$retryLinkWithFama = new (0, (0, parcelRequire("lC4FX")).RetryLink)({
        delay: {
            initial: 300,
            max: 120000,
            jitter: true
        },
        attempts: (count, operation, networkError)=>{
            const retry = count < 5 && networkError && !networkError.statusCode;
            if (!retry) (0, (0, parcelRequire("9g713")).reportErrors)({
                networkError: networkError,
                operation: operation
            });
            return retry;
        }
    });
    class $d88f4e626c9babc0$var$CancelableRequestLink extends (0, (0, parcelRequire("clSzL")).ApolloLink) {
        constructor(){
            super();
            this.inFlightRequestControllers = {};
        }
        request(operation, forward) {
            const context = operation.getContext();
            if (!context.cancelable) return forward(operation);
            const key = JSON.stringify([
                operation.operationName,
                operation.query
            ]);
            this.inFlightRequestControllers[key]?.abort();
            const abortController = new AbortController();
            operation.setContext({
                ...context,
                fetchOptions: {
                    signal: abortController.signal
                }
            });
            this.inFlightRequestControllers[key] = abortController;
            const cleanup = ()=>{
                if (this.inFlightRequestControllers[key] === abortController) delete this.inFlightRequestControllers[key];
            };
            return new (0, (0, parcelRequire("clSzL")).Observable)((observer)=>{
                const subscription = forward(operation).subscribe({
                    next: observer.next.bind(observer),
                    error: (error)=>{
                        observer.error(error);
                        cleanup();
                    },
                    complete: observer.complete.bind(observer)
                });
                return ()=>{
                    subscription?.unsubscribe();
                    cleanup();
                };
            });
        }
    }
    const $d88f4e626c9babc0$var$cache = new (0, (0, parcelRequire("ivfDv")).InMemoryCache)({
        cacheRedirects: {
            Query: {
                ...(0, $cuKXc.fragmentCacheRedirect)()
            }
        },
        fragmentMatcher: $d88f4e626c9babc0$export$851a7159daf49c89,
        dataIdFromObject: (object)=>object.id && `${object.id}${object.__typename}`
    }).restore(!$d88f4e626c9babc0$var$isSsrSuccessful() && window.SPA_STATE[$d88f4e626c9babc0$var$CACHE_NAME] || {});
    const $d88f4e626c9babc0$export$de66868aab9e79ea = (baseUrl)=>new (0, (0, parcelRequire("e3a3O")).ApolloClient)({
            name: $d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID,
            ssrMode: $d88f4e626c9babc0$var$isSsrSuccessful(),
            addTypename: true,
            link: (0, (0, parcelRequire("clSzL")).ApolloLink).from([
                $d88f4e626c9babc0$var$retryLinkWithFama,
                $d88f4e626c9babc0$var$errorLink,
                (0, (0, parcelRequire("jQUy5")).UFOLoggerLink),
                (0, $cuKXc.fragmentLinkState)($d88f4e626c9babc0$var$cache),
                ...!$d88f4e626c9babc0$var$isSsrSuccessful() ? [
                    new $d88f4e626c9babc0$var$CancelableRequestLink()
                ] : [],
                new (0, (0, parcelRequire("JPsIz")).HttpLink)({
                    uri: ({ operationName: operationName })=>`${baseUrl}/rest/${$d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID}/1/?operation=${encodeURIComponent(operationName)}`,
                    credentials: 'same-origin',
                    abortErrorDoesNotCauseError: !$d88f4e626c9babc0$var$isSsrSuccessful()
                })
            ].filter(Boolean)),
            cache: $d88f4e626c9babc0$var$cache,
            connectToDevTools: false
        });
    var $d88f4e626c9babc0$export$2e2bcd8739ae039 = {
        clientId: $d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID,
        clientCreator: $d88f4e626c9babc0$export$de66868aab9e79ea
    };
});
parcelRegister("ivfDv", function(module, exports) {
    $parcel$export(module.exports, "IntrospectionFragmentMatcher", ()=>$d7874048ca668ecb$export$3b71c6b829c99d21);
    $parcel$export(module.exports, "defaultDataIdFromObject", ()=>$d7874048ca668ecb$export$bd03c5a9c99d6bce);
    $parcel$export(module.exports, "InMemoryCache", ()=>$d7874048ca668ecb$export$467265324939f47f);
    var $3VFsf;
    var $hzuXv;
    var $jojW6;
    var $bqMzA = parcelRequire("bqMzA");
    var $gLy2H = parcelRequire("gLy2H");
    var $1DiV8 = parcelRequire("1DiV8");
    var $d7874048ca668ecb$var$haveWarned = false;
    function $d7874048ca668ecb$var$shouldWarn() {
        var answer = !$d7874048ca668ecb$var$haveWarned;
        if (!(0, (0, parcelRequire("jojW6")).isTest)()) $d7874048ca668ecb$var$haveWarned = true;
        return answer;
    }
    var $d7874048ca668ecb$export$5d3fcf53267091de = function() {
        function HeuristicFragmentMatcher() {}
        HeuristicFragmentMatcher.prototype.ensureReady = function() {
            return Promise.resolve();
        };
        HeuristicFragmentMatcher.prototype.canBypassInit = function() {
            return true;
        };
        HeuristicFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
            var obj = context.store.get(idValue.id);
            var isRootQuery = idValue.id === 'ROOT_QUERY';
            if (!obj) return isRootQuery;
            var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
            if (!__typename) {
                $d7874048ca668ecb$var$shouldWarn();
                return 'heuristic';
            }
            if (__typename === typeCondition) return true;
            $d7874048ca668ecb$var$shouldWarn();
            return 'heuristic';
        };
        return HeuristicFragmentMatcher;
    }();
    var $d7874048ca668ecb$export$3b71c6b829c99d21 = function() {
        function IntrospectionFragmentMatcher(options) {
            if (options && options.introspectionQueryResultData) {
                this.possibleTypesMap = this.parseIntrospectionResult(options.introspectionQueryResultData);
                this.isReady = true;
            } else this.isReady = false;
            this.match = this.match.bind(this);
        }
        IntrospectionFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
            (0, $1DiV8.invariant)(this.isReady, 1);
            var obj = context.store.get(idValue.id);
            var isRootQuery = idValue.id === 'ROOT_QUERY';
            if (!obj) return isRootQuery;
            var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
            (0, $1DiV8.invariant)(__typename, 2);
            if (__typename === typeCondition) return true;
            var implementingTypes = this.possibleTypesMap[typeCondition];
            if (__typename && implementingTypes && implementingTypes.indexOf(__typename) > -1) return true;
            return false;
        };
        IntrospectionFragmentMatcher.prototype.parseIntrospectionResult = function(introspectionResultData) {
            var typeMap = {};
            introspectionResultData.__schema.types.forEach(function(type) {
                if (type.kind === 'UNION' || type.kind === 'INTERFACE') typeMap[type.name] = type.possibleTypes.map(function(implementingType) {
                    return implementingType.name;
                });
            });
            return typeMap;
        };
        return IntrospectionFragmentMatcher;
    }();
    var $d7874048ca668ecb$var$hasOwn = Object.prototype.hasOwnProperty;
    var $d7874048ca668ecb$var$DepTrackingCache = function() {
        function DepTrackingCache(data) {
            var _this = this;
            if (data === void 0) data = Object.create(null);
            this.data = data;
            this.depend = (0, $gLy2H.wrap)(function(dataId) {
                return _this.data[dataId];
            }, {
                disposable: true,
                makeCacheKey: function(dataId) {
                    return dataId;
                }
            });
        }
        DepTrackingCache.prototype.toObject = function() {
            return this.data;
        };
        DepTrackingCache.prototype.get = function(dataId) {
            this.depend(dataId);
            return this.data[dataId];
        };
        DepTrackingCache.prototype.set = function(dataId, value) {
            var oldValue = this.data[dataId];
            if (value !== oldValue) {
                this.data[dataId] = value;
                this.depend.dirty(dataId);
            }
        };
        DepTrackingCache.prototype.delete = function(dataId) {
            if ($d7874048ca668ecb$var$hasOwn.call(this.data, dataId)) {
                delete this.data[dataId];
                this.depend.dirty(dataId);
            }
        };
        DepTrackingCache.prototype.clear = function() {
            this.replace(null);
        };
        DepTrackingCache.prototype.replace = function(newData) {
            var _this = this;
            if (newData) {
                Object.keys(newData).forEach(function(dataId) {
                    _this.set(dataId, newData[dataId]);
                });
                Object.keys(this.data).forEach(function(dataId) {
                    if (!$d7874048ca668ecb$var$hasOwn.call(newData, dataId)) _this.delete(dataId);
                });
            } else Object.keys(this.data).forEach(function(dataId) {
                _this.delete(dataId);
            });
        };
        return DepTrackingCache;
    }();
    function $d7874048ca668ecb$var$defaultNormalizedCacheFactory(seed) {
        return new $d7874048ca668ecb$var$DepTrackingCache(seed);
    }
    var $d7874048ca668ecb$export$628ef07ba8965f12 = function() {
        function StoreReader(_a) {
            var _this = this;
            var _b = _a === void 0 ? {} : _a, _c = _b.cacheKeyRoot, cacheKeyRoot = _c === void 0 ? new (0, $gLy2H.KeyTrie)((0, (0, parcelRequire("jojW6")).canUseWeakMap)) : _c, _d = _b.freezeResults, freezeResults = _d === void 0 ? false : _d;
            var _e = this, executeStoreQuery = _e.executeStoreQuery, executeSelectionSet = _e.executeSelectionSet, executeSubSelectedArray = _e.executeSubSelectedArray;
            this.freezeResults = freezeResults;
            this.executeStoreQuery = (0, $gLy2H.wrap)(function(options) {
                return executeStoreQuery.call(_this, options);
            }, {
                makeCacheKey: function(_a) {
                    var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, fragmentMatcher = _a.fragmentMatcher;
                    if (contextValue.store instanceof $d7874048ca668ecb$var$DepTrackingCache) return cacheKeyRoot.lookup(contextValue.store, query, fragmentMatcher, JSON.stringify(variableValues), rootValue.id);
                }
            });
            this.executeSelectionSet = (0, $gLy2H.wrap)(function(options) {
                return executeSelectionSet.call(_this, options);
            }, {
                makeCacheKey: function(_a) {
                    var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
                    if (execContext.contextValue.store instanceof $d7874048ca668ecb$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, selectionSet, execContext.fragmentMatcher, JSON.stringify(execContext.variableValues), rootValue.id);
                }
            });
            this.executeSubSelectedArray = (0, $gLy2H.wrap)(function(options) {
                return executeSubSelectedArray.call(_this, options);
            }, {
                makeCacheKey: function(_a) {
                    var field = _a.field, array = _a.array, execContext = _a.execContext;
                    if (execContext.contextValue.store instanceof $d7874048ca668ecb$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, field, array, JSON.stringify(execContext.variableValues));
                }
            });
        }
        StoreReader.prototype.readQueryFromStore = function(options) {
            return this.diffQueryAgainstStore((0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, options), {
                returnPartialData: false
            })).result;
        };
        StoreReader.prototype.diffQueryAgainstStore = function(_a) {
            var store = _a.store, query = _a.query, variables = _a.variables, previousResult = _a.previousResult, _b = _a.returnPartialData, returnPartialData = _b === void 0 ? true : _b, _c = _a.rootId, rootId = _c === void 0 ? 'ROOT_QUERY' : _c, fragmentMatcherFunction = _a.fragmentMatcherFunction, config = _a.config;
            var queryDefinition = (0, (0, parcelRequire("jojW6")).getQueryDefinition)(query);
            variables = (0, (0, parcelRequire("jojW6")).assign)({}, (0, (0, parcelRequire("jojW6")).getDefaultValues)(queryDefinition), variables);
            var context = {
                store: store,
                dataIdFromObject: config && config.dataIdFromObject,
                cacheRedirects: config && config.cacheRedirects || {}
            };
            var execResult = this.executeStoreQuery({
                query: query,
                rootValue: {
                    type: 'id',
                    id: rootId,
                    generated: true,
                    typename: 'Query'
                },
                contextValue: context,
                variableValues: variables,
                fragmentMatcher: fragmentMatcherFunction
            });
            var hasMissingFields = execResult.missing && execResult.missing.length > 0;
            if (hasMissingFields && !returnPartialData) execResult.missing.forEach(function(info) {
                if (info.tolerable) return;
                throw new (0, $1DiV8.InvariantError)(8);
            });
            if (previousResult) {
                if ((0, $bqMzA.equal)(previousResult, execResult.result)) execResult.result = previousResult;
            }
            return {
                result: execResult.result,
                complete: !hasMissingFields
            };
        };
        StoreReader.prototype.executeStoreQuery = function(_a) {
            var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, _b = _a.fragmentMatcher, fragmentMatcher = _b === void 0 ? $d7874048ca668ecb$var$defaultFragmentMatcher : _b;
            var mainDefinition = (0, (0, parcelRequire("jojW6")).getMainDefinition)(query);
            var fragments = (0, (0, parcelRequire("jojW6")).getFragmentDefinitions)(query);
            var fragmentMap = (0, (0, parcelRequire("jojW6")).createFragmentMap)(fragments);
            var execContext = {
                query: query,
                fragmentMap: fragmentMap,
                contextValue: contextValue,
                variableValues: variableValues,
                fragmentMatcher: fragmentMatcher
            };
            return this.executeSelectionSet({
                selectionSet: mainDefinition.selectionSet,
                rootValue: rootValue,
                execContext: execContext
            });
        };
        StoreReader.prototype.executeSelectionSet = function(_a) {
            var _this = this;
            var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
            var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
            var finalResult = {
                result: null
            };
            var objectsToMerge = [];
            var object = contextValue.store.get(rootValue.id);
            var typename = object && object.__typename || rootValue.id === 'ROOT_QUERY' && 'Query' || void 0;
            function handleMissing(result) {
                var _a;
                if (result.missing) {
                    finalResult.missing = finalResult.missing || [];
                    (_a = finalResult.missing).push.apply(_a, result.missing);
                }
                return result.result;
            }
            selectionSet.selections.forEach(function(selection) {
                var _a;
                if (!(0, (0, parcelRequire("jojW6")).shouldInclude)(selection, variables)) return;
                if ((0, (0, parcelRequire("jojW6")).isField)(selection)) {
                    var fieldResult = handleMissing(_this.executeField(object, typename, selection, execContext));
                    if (typeof fieldResult !== 'undefined') objectsToMerge.push((_a = {}, _a[(0, (0, parcelRequire("jojW6")).resultKeyNameFromField)(selection)] = fieldResult, _a));
                } else {
                    var fragment = void 0;
                    if ((0, (0, parcelRequire("jojW6")).isInlineFragment)(selection)) fragment = selection;
                    else {
                        fragment = fragmentMap[selection.name.value];
                        if (!fragment) throw new (0, $1DiV8.InvariantError)(9);
                    }
                    var typeCondition = fragment.typeCondition && fragment.typeCondition.name.value;
                    var match = !typeCondition || execContext.fragmentMatcher(rootValue, typeCondition, contextValue);
                    if (match) {
                        var fragmentExecResult = _this.executeSelectionSet({
                            selectionSet: fragment.selectionSet,
                            rootValue: rootValue,
                            execContext: execContext
                        });
                        if (match === 'heuristic' && fragmentExecResult.missing) fragmentExecResult = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, fragmentExecResult), {
                            missing: fragmentExecResult.missing.map(function(info) {
                                return (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, info), {
                                    tolerable: true
                                });
                            })
                        });
                        objectsToMerge.push(handleMissing(fragmentExecResult));
                    }
                }
            });
            finalResult.result = (0, (0, parcelRequire("jojW6")).mergeDeepArray)(objectsToMerge);
            this.freezeResults;
            return finalResult;
        };
        StoreReader.prototype.executeField = function(object, typename, field, execContext) {
            var variables = execContext.variableValues, contextValue = execContext.contextValue;
            var fieldName = field.name.value;
            var args = (0, (0, parcelRequire("jojW6")).argumentsObjectFromField)(field, variables);
            var info = {
                resultKey: (0, (0, parcelRequire("jojW6")).resultKeyNameFromField)(field),
                directives: (0, (0, parcelRequire("jojW6")).getDirectiveInfoFromField)(field, variables)
            };
            var readStoreResult = $d7874048ca668ecb$var$readStoreResolver(object, typename, fieldName, args, contextValue, info);
            if (Array.isArray(readStoreResult.result)) return this.combineExecResults(readStoreResult, this.executeSubSelectedArray({
                field: field,
                array: readStoreResult.result,
                execContext: execContext
            }));
            if (!field.selectionSet) {
                $d7874048ca668ecb$var$assertSelectionSetForIdValue(field, readStoreResult.result);
                this.freezeResults;
                return readStoreResult;
            }
            if (readStoreResult.result == null) return readStoreResult;
            return this.combineExecResults(readStoreResult, this.executeSelectionSet({
                selectionSet: field.selectionSet,
                rootValue: readStoreResult.result,
                execContext: execContext
            }));
        };
        StoreReader.prototype.combineExecResults = function() {
            var execResults = [];
            for(var _i = 0; _i < arguments.length; _i++)execResults[_i] = arguments[_i];
            var missing;
            execResults.forEach(function(execResult) {
                if (execResult.missing) {
                    missing = missing || [];
                    missing.push.apply(missing, execResult.missing);
                }
            });
            return {
                result: execResults.pop().result,
                missing: missing
            };
        };
        StoreReader.prototype.executeSubSelectedArray = function(_a) {
            var _this = this;
            var field = _a.field, array = _a.array, execContext = _a.execContext;
            var missing;
            function handleMissing(childResult) {
                if (childResult.missing) {
                    missing = missing || [];
                    missing.push.apply(missing, childResult.missing);
                }
                return childResult.result;
            }
            array = array.map(function(item) {
                if (item === null) return null;
                if (Array.isArray(item)) return handleMissing(_this.executeSubSelectedArray({
                    field: field,
                    array: item,
                    execContext: execContext
                }));
                if (field.selectionSet) return handleMissing(_this.executeSelectionSet({
                    selectionSet: field.selectionSet,
                    rootValue: item,
                    execContext: execContext
                }));
                $d7874048ca668ecb$var$assertSelectionSetForIdValue(field, item);
                return item;
            });
            this.freezeResults;
            return {
                result: array,
                missing: missing
            };
        };
        return StoreReader;
    }();
    function $d7874048ca668ecb$var$assertSelectionSetForIdValue(field, value) {
        if (!field.selectionSet && (0, (0, parcelRequire("jojW6")).isIdValue)(value)) throw new (0, $1DiV8.InvariantError)(10);
    }
    function $d7874048ca668ecb$var$defaultFragmentMatcher() {
        return true;
    }
    function $d7874048ca668ecb$export$7a4899fe13f33235(idValue) {
        (0, $1DiV8.invariant)((0, (0, parcelRequire("jojW6")).isIdValue)(idValue), 11);
    }
    function $d7874048ca668ecb$var$readStoreResolver(object, typename, fieldName, args, context, _a) {
        var resultKey = _a.resultKey, directives = _a.directives;
        var storeKeyName = fieldName;
        if (args || directives) storeKeyName = (0, (0, parcelRequire("jojW6")).getStoreKeyName)(storeKeyName, args, directives);
        var fieldValue = void 0;
        if (object) {
            fieldValue = object[storeKeyName];
            if (typeof fieldValue === 'undefined' && context.cacheRedirects && typeof typename === 'string') {
                var type = context.cacheRedirects[typename];
                if (type) {
                    var resolver = type[fieldName];
                    if (resolver) fieldValue = resolver(object, args, {
                        getCacheKey: function(storeObj) {
                            var id = context.dataIdFromObject(storeObj);
                            return id && (0, (0, parcelRequire("jojW6")).toIdValue)({
                                id: id,
                                typename: storeObj.__typename
                            });
                        }
                    });
                }
            }
        }
        if (typeof fieldValue === 'undefined') return {
            result: fieldValue,
            missing: [
                {
                    object: object,
                    fieldName: storeKeyName,
                    tolerable: false
                }
            ]
        };
        if ((0, (0, parcelRequire("jojW6")).isJsonValue)(fieldValue)) fieldValue = fieldValue.json;
        return {
            result: fieldValue
        };
    }
    var $d7874048ca668ecb$export$ee7258b8691956a3 = function() {
        function ObjectCache(data) {
            if (data === void 0) data = Object.create(null);
            this.data = data;
        }
        ObjectCache.prototype.toObject = function() {
            return this.data;
        };
        ObjectCache.prototype.get = function(dataId) {
            return this.data[dataId];
        };
        ObjectCache.prototype.set = function(dataId, value) {
            this.data[dataId] = value;
        };
        ObjectCache.prototype.delete = function(dataId) {
            this.data[dataId] = void 0;
        };
        ObjectCache.prototype.clear = function() {
            this.data = Object.create(null);
        };
        ObjectCache.prototype.replace = function(newData) {
            this.data = newData || Object.create(null);
        };
        return ObjectCache;
    }();
    function $d7874048ca668ecb$export$7e2b40d1002de152(seed) {
        return new $d7874048ca668ecb$export$ee7258b8691956a3(seed);
    }
    var $d7874048ca668ecb$export$de4e6870dc6ac801 = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(WriteError, _super);
        function WriteError() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.type = 'WriteError';
            return _this;
        }
        return WriteError;
    }(Error);
    function $d7874048ca668ecb$export$fb86e3236e77e3(error, document) {
        var enhancedError = new $d7874048ca668ecb$export$de4e6870dc6ac801("Error writing result to store for query:\n " + JSON.stringify(document));
        enhancedError.message += '\n' + error.message;
        enhancedError.stack = error.stack;
        return enhancedError;
    }
    var $d7874048ca668ecb$export$eb8361c5d132fb8f = function() {
        function StoreWriter() {}
        StoreWriter.prototype.writeQueryToStore = function(_a) {
            var query = _a.query, result = _a.result, _b = _a.store, store = _b === void 0 ? $d7874048ca668ecb$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
            return this.writeResultToStore({
                dataId: 'ROOT_QUERY',
                result: result,
                document: query,
                store: store,
                variables: variables,
                dataIdFromObject: dataIdFromObject,
                fragmentMatcherFunction: fragmentMatcherFunction
            });
        };
        StoreWriter.prototype.writeResultToStore = function(_a) {
            var dataId = _a.dataId, result = _a.result, document = _a.document, _b = _a.store, store = _b === void 0 ? $d7874048ca668ecb$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
            var operationDefinition = (0, (0, parcelRequire("jojW6")).getOperationDefinition)(document);
            try {
                return this.writeSelectionSetToStore({
                    result: result,
                    dataId: dataId,
                    selectionSet: operationDefinition.selectionSet,
                    context: {
                        store: store,
                        processedData: {},
                        variables: (0, (0, parcelRequire("jojW6")).assign)({}, (0, (0, parcelRequire("jojW6")).getDefaultValues)(operationDefinition), variables),
                        dataIdFromObject: dataIdFromObject,
                        fragmentMap: (0, (0, parcelRequire("jojW6")).createFragmentMap)((0, (0, parcelRequire("jojW6")).getFragmentDefinitions)(document)),
                        fragmentMatcherFunction: fragmentMatcherFunction
                    }
                });
            } catch (e) {
                throw $d7874048ca668ecb$export$fb86e3236e77e3(e, document);
            }
        };
        StoreWriter.prototype.writeSelectionSetToStore = function(_a) {
            var _this = this;
            var result = _a.result, dataId = _a.dataId, selectionSet = _a.selectionSet, context = _a.context;
            var variables = context.variables, store = context.store, fragmentMap = context.fragmentMap;
            selectionSet.selections.forEach(function(selection) {
                var _a;
                if (!(0, (0, parcelRequire("jojW6")).shouldInclude)(selection, variables)) return;
                if ((0, (0, parcelRequire("jojW6")).isField)(selection)) {
                    var resultFieldKey = (0, (0, parcelRequire("jojW6")).resultKeyNameFromField)(selection);
                    var value = result[resultFieldKey];
                    if (typeof value !== 'undefined') _this.writeFieldToStore({
                        dataId: dataId,
                        value: value,
                        field: selection,
                        context: context
                    });
                    else {
                        var isDefered = false;
                        var isClient = false;
                        if (selection.directives && selection.directives.length) {
                            isDefered = selection.directives.some(function(directive) {
                                return directive.name && directive.name.value === 'defer';
                            });
                            isClient = selection.directives.some(function(directive) {
                                return directive.name && directive.name.value === 'client';
                            });
                        }
                        !isDefered && !isClient && context.fragmentMatcherFunction;
                    }
                } else {
                    var fragment = void 0;
                    if ((0, (0, parcelRequire("jojW6")).isInlineFragment)(selection)) fragment = selection;
                    else {
                        fragment = (fragmentMap || {})[selection.name.value];
                        (0, $1DiV8.invariant)(fragment, 3);
                    }
                    var matches = true;
                    if (context.fragmentMatcherFunction && fragment.typeCondition) {
                        var id = dataId || 'self';
                        var idValue = (0, (0, parcelRequire("jojW6")).toIdValue)({
                            id: id,
                            typename: undefined
                        });
                        var fakeContext = {
                            store: new $d7874048ca668ecb$export$ee7258b8691956a3((_a = {}, _a[id] = result, _a)),
                            cacheRedirects: {}
                        };
                        var match = context.fragmentMatcherFunction(idValue, fragment.typeCondition.name.value, fakeContext);
                        !(0, (0, parcelRequire("jojW6")).isProduction)() && match;
                        matches = !!match;
                    }
                    if (matches) _this.writeSelectionSetToStore({
                        result: result,
                        selectionSet: fragment.selectionSet,
                        dataId: dataId,
                        context: context
                    });
                }
            });
            return store;
        };
        StoreWriter.prototype.writeFieldToStore = function(_a) {
            var _b;
            var field = _a.field, value = _a.value, dataId = _a.dataId, context = _a.context;
            var variables = context.variables, dataIdFromObject = context.dataIdFromObject, store = context.store;
            var storeValue;
            var storeObject;
            var storeFieldName = (0, (0, parcelRequire("jojW6")).storeKeyNameFromField)(field, variables);
            if (!field.selectionSet || value === null) storeValue = value != null && typeof value === 'object' ? {
                type: 'json',
                json: value
            } : value;
            else if (Array.isArray(value)) {
                var generatedId = dataId + "." + storeFieldName;
                storeValue = this.processArrayValue(value, generatedId, field.selectionSet, context);
            } else {
                var valueDataId = dataId + "." + storeFieldName;
                var generated = true;
                if (!$d7874048ca668ecb$var$isGeneratedId(valueDataId)) valueDataId = '$' + valueDataId;
                if (dataIdFromObject) {
                    var semanticId = dataIdFromObject(value);
                    (0, $1DiV8.invariant)(!semanticId || !$d7874048ca668ecb$var$isGeneratedId(semanticId), 4);
                    if (semanticId || typeof semanticId === 'number' && semanticId === 0) {
                        valueDataId = semanticId;
                        generated = false;
                    }
                }
                if (!$d7874048ca668ecb$var$isDataProcessed(valueDataId, field, context.processedData)) this.writeSelectionSetToStore({
                    dataId: valueDataId,
                    result: value,
                    selectionSet: field.selectionSet,
                    context: context
                });
                var typename = value.__typename;
                storeValue = (0, (0, parcelRequire("jojW6")).toIdValue)({
                    id: valueDataId,
                    typename: typename
                }, generated);
                storeObject = store.get(dataId);
                var escapedId = storeObject && storeObject[storeFieldName];
                if (escapedId !== storeValue && (0, (0, parcelRequire("jojW6")).isIdValue)(escapedId)) {
                    var hadTypename = escapedId.typename !== undefined;
                    var hasTypename = typename !== undefined;
                    var typenameChanged = hadTypename && hasTypename && escapedId.typename !== typename;
                    (0, $1DiV8.invariant)(!generated || escapedId.generated || typenameChanged, 5);
                    (0, $1DiV8.invariant)(!hadTypename || hasTypename, 6);
                    if (escapedId.generated) {
                        if (typenameChanged) {
                            if (!generated) store.delete(escapedId.id);
                        } else $d7874048ca668ecb$var$mergeWithGenerated(escapedId.id, storeValue.id, store);
                    }
                }
            }
            storeObject = store.get(dataId);
            if (!storeObject || !(0, $bqMzA.equal)(storeValue, storeObject[storeFieldName])) store.set(dataId, (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, storeObject), (_b = {}, _b[storeFieldName] = storeValue, _b)));
        };
        StoreWriter.prototype.processArrayValue = function(value, generatedId, selectionSet, context) {
            var _this = this;
            return value.map(function(item, index) {
                if (item === null) return null;
                var itemDataId = generatedId + "." + index;
                if (Array.isArray(item)) return _this.processArrayValue(item, itemDataId, selectionSet, context);
                var generated = true;
                if (context.dataIdFromObject) {
                    var semanticId = context.dataIdFromObject(item);
                    if (semanticId) {
                        itemDataId = semanticId;
                        generated = false;
                    }
                }
                if (!$d7874048ca668ecb$var$isDataProcessed(itemDataId, selectionSet, context.processedData)) _this.writeSelectionSetToStore({
                    dataId: itemDataId,
                    result: item,
                    selectionSet: selectionSet,
                    context: context
                });
                return (0, (0, parcelRequire("jojW6")).toIdValue)({
                    id: itemDataId,
                    typename: item.__typename
                }, generated);
            });
        };
        return StoreWriter;
    }();
    function $d7874048ca668ecb$var$isGeneratedId(id) {
        return id[0] === '$';
    }
    function $d7874048ca668ecb$var$mergeWithGenerated(generatedKey, realKey, cache) {
        if (generatedKey === realKey) return false;
        var generated = cache.get(generatedKey);
        var real = cache.get(realKey);
        var madeChanges = false;
        Object.keys(generated).forEach(function(key) {
            var value = generated[key];
            var realValue = real[key];
            if ((0, (0, parcelRequire("jojW6")).isIdValue)(value) && $d7874048ca668ecb$var$isGeneratedId(value.id) && (0, (0, parcelRequire("jojW6")).isIdValue)(realValue) && !(0, $bqMzA.equal)(value, realValue) && $d7874048ca668ecb$var$mergeWithGenerated(value.id, realValue.id, cache)) madeChanges = true;
        });
        cache.delete(generatedKey);
        var newRealValue = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, generated), real);
        if ((0, $bqMzA.equal)(newRealValue, real)) return madeChanges;
        cache.set(realKey, newRealValue);
        return true;
    }
    function $d7874048ca668ecb$var$isDataProcessed(dataId, field, processedData) {
        if (!processedData) return false;
        if (processedData[dataId]) {
            if (processedData[dataId].indexOf(field) >= 0) return true;
            else processedData[dataId].push(field);
        } else processedData[dataId] = [
            field
        ];
        return false;
    }
    var $d7874048ca668ecb$var$defaultConfig = {
        fragmentMatcher: new $d7874048ca668ecb$export$5d3fcf53267091de(),
        dataIdFromObject: $d7874048ca668ecb$export$bd03c5a9c99d6bce,
        addTypename: true,
        resultCaching: true,
        freezeResults: false
    };
    function $d7874048ca668ecb$export$bd03c5a9c99d6bce(result) {
        if (result.__typename) {
            if (result.id !== undefined) return result.__typename + ":" + result.id;
            if (result._id !== undefined) return result.__typename + ":" + result._id;
        }
        return null;
    }
    var $d7874048ca668ecb$var$hasOwn$1 = Object.prototype.hasOwnProperty;
    var $d7874048ca668ecb$var$OptimisticCacheLayer = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(OptimisticCacheLayer, _super);
        function OptimisticCacheLayer(optimisticId, parent, transaction) {
            var _this = _super.call(this, Object.create(null)) || this;
            _this.optimisticId = optimisticId;
            _this.parent = parent;
            _this.transaction = transaction;
            return _this;
        }
        OptimisticCacheLayer.prototype.toObject = function() {
            return (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this.parent.toObject()), this.data);
        };
        OptimisticCacheLayer.prototype.get = function(dataId) {
            return $d7874048ca668ecb$var$hasOwn$1.call(this.data, dataId) ? this.data[dataId] : this.parent.get(dataId);
        };
        return OptimisticCacheLayer;
    }($d7874048ca668ecb$export$ee7258b8691956a3);
    var $d7874048ca668ecb$export$467265324939f47f = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(InMemoryCache, _super);
        function InMemoryCache(config) {
            if (config === void 0) config = {};
            var _this = _super.call(this) || this;
            _this.watches = new Set();
            _this.typenameDocumentCache = new Map();
            _this.cacheKeyRoot = new (0, $gLy2H.KeyTrie)((0, (0, parcelRequire("jojW6")).canUseWeakMap));
            _this.silenceBroadcast = false;
            _this.config = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, $d7874048ca668ecb$var$defaultConfig), config);
            if (_this.config.customResolvers) _this.config.cacheRedirects = _this.config.customResolvers;
            if (_this.config.cacheResolvers) _this.config.cacheRedirects = _this.config.cacheResolvers;
            _this.addTypename = !!_this.config.addTypename;
            _this.data = _this.config.resultCaching ? new $d7874048ca668ecb$var$DepTrackingCache() : new $d7874048ca668ecb$export$ee7258b8691956a3();
            _this.optimisticData = _this.data;
            _this.storeWriter = new $d7874048ca668ecb$export$eb8361c5d132fb8f();
            _this.storeReader = new $d7874048ca668ecb$export$628ef07ba8965f12({
                cacheKeyRoot: _this.cacheKeyRoot,
                freezeResults: config.freezeResults
            });
            var cache = _this;
            var maybeBroadcastWatch = cache.maybeBroadcastWatch;
            _this.maybeBroadcastWatch = (0, $gLy2H.wrap)(function(c) {
                return maybeBroadcastWatch.call(_this, c);
            }, {
                makeCacheKey: function(c) {
                    if (c.optimistic) return;
                    if (c.previousResult) return;
                    if (cache.data instanceof $d7874048ca668ecb$var$DepTrackingCache) return cache.cacheKeyRoot.lookup(c.query, JSON.stringify(c.variables));
                }
            });
            return _this;
        }
        InMemoryCache.prototype.restore = function(data) {
            if (data) this.data.replace(data);
            return this;
        };
        InMemoryCache.prototype.extract = function(optimistic) {
            if (optimistic === void 0) optimistic = false;
            return (optimistic ? this.optimisticData : this.data).toObject();
        };
        InMemoryCache.prototype.read = function(options) {
            if (typeof options.rootId === 'string' && typeof this.data.get(options.rootId) === 'undefined') return null;
            var fragmentMatcher = this.config.fragmentMatcher;
            var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
            return this.storeReader.readQueryFromStore({
                store: options.optimistic ? this.optimisticData : this.data,
                query: this.transformDocument(options.query),
                variables: options.variables,
                rootId: options.rootId,
                fragmentMatcherFunction: fragmentMatcherFunction,
                previousResult: options.previousResult,
                config: this.config
            }) || null;
        };
        InMemoryCache.prototype.write = function(write) {
            var fragmentMatcher = this.config.fragmentMatcher;
            var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
            this.storeWriter.writeResultToStore({
                dataId: write.dataId,
                result: write.result,
                variables: write.variables,
                document: this.transformDocument(write.query),
                store: this.data,
                dataIdFromObject: this.config.dataIdFromObject,
                fragmentMatcherFunction: fragmentMatcherFunction
            });
            this.broadcastWatches();
        };
        InMemoryCache.prototype.diff = function(query) {
            var fragmentMatcher = this.config.fragmentMatcher;
            var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
            return this.storeReader.diffQueryAgainstStore({
                store: query.optimistic ? this.optimisticData : this.data,
                query: this.transformDocument(query.query),
                variables: query.variables,
                returnPartialData: query.returnPartialData,
                previousResult: query.previousResult,
                fragmentMatcherFunction: fragmentMatcherFunction,
                config: this.config
            });
        };
        InMemoryCache.prototype.watch = function(watch) {
            var _this = this;
            this.watches.add(watch);
            return function() {
                _this.watches.delete(watch);
            };
        };
        InMemoryCache.prototype.evict = function(query) {
            throw new (0, $1DiV8.InvariantError)(7);
        };
        InMemoryCache.prototype.reset = function() {
            this.data.clear();
            this.broadcastWatches();
            return Promise.resolve();
        };
        InMemoryCache.prototype.removeOptimistic = function(idToRemove) {
            var toReapply = [];
            var removedCount = 0;
            var layer = this.optimisticData;
            while(layer instanceof $d7874048ca668ecb$var$OptimisticCacheLayer){
                if (layer.optimisticId === idToRemove) ++removedCount;
                else toReapply.push(layer);
                layer = layer.parent;
            }
            if (removedCount > 0) {
                this.optimisticData = layer;
                while(toReapply.length > 0){
                    var layer_1 = toReapply.pop();
                    this.performTransaction(layer_1.transaction, layer_1.optimisticId);
                }
                this.broadcastWatches();
            }
        };
        InMemoryCache.prototype.performTransaction = function(transaction, optimisticId) {
            var _a = this, data = _a.data, silenceBroadcast = _a.silenceBroadcast;
            this.silenceBroadcast = true;
            if (typeof optimisticId === 'string') this.data = this.optimisticData = new $d7874048ca668ecb$var$OptimisticCacheLayer(optimisticId, this.optimisticData, transaction);
            try {
                transaction(this);
            } finally{
                this.silenceBroadcast = silenceBroadcast;
                this.data = data;
            }
            this.broadcastWatches();
        };
        InMemoryCache.prototype.recordOptimisticTransaction = function(transaction, id) {
            return this.performTransaction(transaction, id);
        };
        InMemoryCache.prototype.transformDocument = function(document) {
            if (this.addTypename) {
                var result = this.typenameDocumentCache.get(document);
                if (!result) {
                    result = (0, (0, parcelRequire("jojW6")).addTypenameToDocument)(document);
                    this.typenameDocumentCache.set(document, result);
                    this.typenameDocumentCache.set(result, result);
                }
                return result;
            }
            return document;
        };
        InMemoryCache.prototype.broadcastWatches = function() {
            var _this = this;
            if (!this.silenceBroadcast) this.watches.forEach(function(c) {
                return _this.maybeBroadcastWatch(c);
            });
        };
        InMemoryCache.prototype.maybeBroadcastWatch = function(c) {
            c.callback(this.diff({
                query: c.query,
                variables: c.variables,
                previousResult: c.previousResult && c.previousResult(),
                optimistic: c.optimistic
            }));
        };
        return InMemoryCache;
    }((0, (0, parcelRequire("hzuXv")).ApolloCache));
});
parcelRegister("hzuXv", function(module, exports) {
    $parcel$export(module.exports, "ApolloCache", ()=>$ccadb856bf057658$export$5fc74f25506aa9c);
    var $jojW6;
    function $ccadb856bf057658$var$queryFromPojo(obj) {
        var op = {
            kind: 'OperationDefinition',
            operation: 'query',
            name: {
                kind: 'Name',
                value: 'GeneratedClientQuery'
            },
            selectionSet: $ccadb856bf057658$var$selectionSetFromObj(obj)
        };
        var out = {
            kind: 'Document',
            definitions: [
                op
            ]
        };
        return out;
    }
    function $ccadb856bf057658$var$fragmentFromPojo(obj, typename) {
        var frag = {
            kind: 'FragmentDefinition',
            typeCondition: {
                kind: 'NamedType',
                name: {
                    kind: 'Name',
                    value: typename || '__FakeType'
                }
            },
            name: {
                kind: 'Name',
                value: 'GeneratedClientQuery'
            },
            selectionSet: $ccadb856bf057658$var$selectionSetFromObj(obj)
        };
        var out = {
            kind: 'Document',
            definitions: [
                frag
            ]
        };
        return out;
    }
    function $ccadb856bf057658$var$selectionSetFromObj(obj) {
        if (typeof obj === 'number' || typeof obj === 'boolean' || typeof obj === 'string' || typeof obj === 'undefined' || obj === null) return null;
        if (Array.isArray(obj)) return $ccadb856bf057658$var$selectionSetFromObj(obj[0]);
        var selections = [];
        Object.keys(obj).forEach(function(key) {
            var nestedSelSet = $ccadb856bf057658$var$selectionSetFromObj(obj[key]);
            var field = {
                kind: 'Field',
                name: {
                    kind: 'Name',
                    value: key
                },
                selectionSet: nestedSelSet || undefined
            };
            selections.push(field);
        });
        var selectionSet = {
            kind: 'SelectionSet',
            selections: selections
        };
        return selectionSet;
    }
    var $ccadb856bf057658$var$justTypenameQuery = {
        kind: 'Document',
        definitions: [
            {
                kind: 'OperationDefinition',
                operation: 'query',
                name: null,
                variableDefinitions: null,
                directives: [],
                selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                        {
                            kind: 'Field',
                            alias: null,
                            name: {
                                kind: 'Name',
                                value: '__typename'
                            },
                            arguments: [],
                            directives: [],
                            selectionSet: null
                        }
                    ]
                }
            }
        ]
    };
    var $ccadb856bf057658$export$5fc74f25506aa9c = function() {
        function ApolloCache() {}
        ApolloCache.prototype.transformDocument = function(document) {
            return document;
        };
        ApolloCache.prototype.transformForLink = function(document) {
            return document;
        };
        ApolloCache.prototype.readQuery = function(options, optimistic) {
            if (optimistic === void 0) optimistic = false;
            return this.read({
                query: options.query,
                variables: options.variables,
                optimistic: optimistic
            });
        };
        ApolloCache.prototype.readFragment = function(options, optimistic) {
            if (optimistic === void 0) optimistic = false;
            return this.read({
                query: (0, (0, parcelRequire("jojW6")).getFragmentQueryDocument)(options.fragment, options.fragmentName),
                variables: options.variables,
                rootId: options.id,
                optimistic: optimistic
            });
        };
        ApolloCache.prototype.writeQuery = function(options) {
            this.write({
                dataId: 'ROOT_QUERY',
                result: options.data,
                query: options.query,
                variables: options.variables
            });
        };
        ApolloCache.prototype.writeFragment = function(options) {
            this.write({
                dataId: options.id,
                result: options.data,
                variables: options.variables,
                query: (0, (0, parcelRequire("jojW6")).getFragmentQueryDocument)(options.fragment, options.fragmentName)
            });
        };
        ApolloCache.prototype.writeData = function(_a) {
            var id = _a.id, data = _a.data;
            if (typeof id !== 'undefined') {
                var typenameResult = null;
                try {
                    typenameResult = this.read({
                        rootId: id,
                        optimistic: false,
                        query: $ccadb856bf057658$var$justTypenameQuery
                    });
                } catch (e) {}
                var __typename = typenameResult && typenameResult.__typename || '__ClientData';
                var dataToWrite = Object.assign({
                    __typename: __typename
                }, data);
                this.writeFragment({
                    id: id,
                    fragment: $ccadb856bf057658$var$fragmentFromPojo(dataToWrite, __typename),
                    data: dataToWrite
                });
            } else this.writeQuery({
                query: $ccadb856bf057658$var$queryFromPojo(data),
                data: data
            });
        };
        return ApolloCache;
    }();
    var $ccadb856bf057658$export$94affb487e701bf2;
    $ccadb856bf057658$export$94affb487e701bf2 || ($ccadb856bf057658$export$94affb487e701bf2 = {});
});
parcelRegister("gLy2H", function(module, exports) {
    $parcel$export(module.exports, "KeyTrie", ()=>$c34b71496108423e$export$6bd8d8299be3ac82);
    $parcel$export(module.exports, "wrap", ()=>$c34b71496108423e$export$4997ffc0176396a6);
    var $jFbNy = parcelRequire("jFbNy");
    function $c34b71496108423e$var$defaultDispose() {}
    var $c34b71496108423e$var$Cache = function() {
        function Cache(max, dispose) {
            if (max === void 0) max = Infinity;
            if (dispose === void 0) dispose = $c34b71496108423e$var$defaultDispose;
            this.max = max;
            this.dispose = dispose;
            this.map = new Map();
            this.newest = null;
            this.oldest = null;
        }
        Cache.prototype.has = function(key) {
            return this.map.has(key);
        };
        Cache.prototype.get = function(key) {
            var entry = this.getEntry(key);
            return entry && entry.value;
        };
        Cache.prototype.getEntry = function(key) {
            var entry = this.map.get(key);
            if (entry && entry !== this.newest) {
                var older = entry.older, newer = entry.newer;
                if (newer) newer.older = older;
                if (older) older.newer = newer;
                entry.older = this.newest;
                entry.older.newer = entry;
                entry.newer = null;
                this.newest = entry;
                if (entry === this.oldest) this.oldest = newer;
            }
            return entry;
        };
        Cache.prototype.set = function(key, value) {
            var entry = this.getEntry(key);
            if (entry) return entry.value = value;
            entry = {
                key: key,
                value: value,
                newer: null,
                older: this.newest
            };
            if (this.newest) this.newest.newer = entry;
            this.newest = entry;
            this.oldest = this.oldest || entry;
            this.map.set(key, entry);
            return entry.value;
        };
        Cache.prototype.clean = function() {
            while(this.oldest && this.map.size > this.max)this.delete(this.oldest.key);
        };
        Cache.prototype.delete = function(key) {
            var entry = this.map.get(key);
            if (entry) {
                if (entry === this.newest) this.newest = entry.older;
                if (entry === this.oldest) this.oldest = entry.newer;
                if (entry.newer) entry.newer.older = entry.older;
                if (entry.older) entry.older.newer = entry.newer;
                this.map.delete(key);
                this.dispose(entry.value, key);
                return true;
            }
            return false;
        };
        return Cache;
    }();
    var $c34b71496108423e$var$parentEntrySlot = new (0, $jFbNy.Slot)();
    var $c34b71496108423e$var$reusableEmptyArray = [];
    var $c34b71496108423e$var$emptySetPool = [];
    var $c34b71496108423e$var$POOL_TARGET_SIZE = 100;
    function $c34b71496108423e$var$assert(condition, optionalMessage) {
        if (!condition) throw new Error(optionalMessage || "assertion failure");
    }
    function $c34b71496108423e$var$valueIs(a, b) {
        var len = a.length;
        return (len > 0 && len === b.length && a[len - 1] === b[len - 1]);
    }
    function $c34b71496108423e$var$valueGet(value) {
        switch(value.length){
            case 0:
                throw new Error("unknown value");
            case 1:
                return value[0];
            case 2:
                throw value[1];
        }
    }
    function $c34b71496108423e$var$valueCopy(value) {
        return value.slice(0);
    }
    var $c34b71496108423e$var$Entry = function() {
        function Entry(fn, args) {
            this.fn = fn;
            this.args = args;
            this.parents = new Set();
            this.childValues = new Map();
            this.dirtyChildren = null;
            this.dirty = true;
            this.recomputing = false;
            this.value = [];
            ++Entry.count;
        }
        Entry.prototype.recompute = function() {
            $c34b71496108423e$var$assert(!this.recomputing, "already recomputing");
            if (!$c34b71496108423e$var$rememberParent(this) && $c34b71496108423e$var$maybeReportOrphan(this)) return void 0;
            return $c34b71496108423e$var$mightBeDirty(this) ? $c34b71496108423e$var$reallyRecompute(this) : $c34b71496108423e$var$valueGet(this.value);
        };
        Entry.prototype.setDirty = function() {
            if (this.dirty) return;
            this.dirty = true;
            this.value.length = 0;
            $c34b71496108423e$var$reportDirty(this);
            $c34b71496108423e$var$maybeUnsubscribe(this);
        };
        Entry.prototype.dispose = function() {
            var _this = this;
            $c34b71496108423e$var$forgetChildren(this).forEach($c34b71496108423e$var$maybeReportOrphan);
            $c34b71496108423e$var$maybeUnsubscribe(this);
            this.parents.forEach(function(parent) {
                parent.setDirty();
                $c34b71496108423e$var$forgetChild(parent, _this);
            });
        };
        Entry.count = 0;
        return Entry;
    }();
    function $c34b71496108423e$var$rememberParent(child) {
        var parent = $c34b71496108423e$var$parentEntrySlot.getValue();
        if (parent) {
            child.parents.add(parent);
            if (!parent.childValues.has(child)) parent.childValues.set(child, []);
            if ($c34b71496108423e$var$mightBeDirty(child)) $c34b71496108423e$var$reportDirtyChild(parent, child);
            else $c34b71496108423e$var$reportCleanChild(parent, child);
            return parent;
        }
    }
    function $c34b71496108423e$var$reallyRecompute(entry) {
        var originalChildren = $c34b71496108423e$var$forgetChildren(entry);
        $c34b71496108423e$var$parentEntrySlot.withValue(entry, $c34b71496108423e$var$recomputeNewValue, [
            entry
        ]);
        if ($c34b71496108423e$var$maybeSubscribe(entry)) $c34b71496108423e$var$setClean(entry);
        originalChildren.forEach($c34b71496108423e$var$maybeReportOrphan);
        return $c34b71496108423e$var$valueGet(entry.value);
    }
    function $c34b71496108423e$var$recomputeNewValue(entry) {
        entry.recomputing = true;
        entry.value.length = 0;
        try {
            entry.value[0] = entry.fn.apply(null, entry.args);
        } catch (e) {
            entry.value[1] = e;
        }
        entry.recomputing = false;
    }
    function $c34b71496108423e$var$mightBeDirty(entry) {
        return entry.dirty || !!(entry.dirtyChildren && entry.dirtyChildren.size);
    }
    function $c34b71496108423e$var$setClean(entry) {
        entry.dirty = false;
        if ($c34b71496108423e$var$mightBeDirty(entry)) return;
        $c34b71496108423e$var$reportClean(entry);
    }
    function $c34b71496108423e$var$reportDirty(child) {
        child.parents.forEach(function(parent) {
            return $c34b71496108423e$var$reportDirtyChild(parent, child);
        });
    }
    function $c34b71496108423e$var$reportClean(child) {
        child.parents.forEach(function(parent) {
            return $c34b71496108423e$var$reportCleanChild(parent, child);
        });
    }
    function $c34b71496108423e$var$reportDirtyChild(parent, child) {
        $c34b71496108423e$var$assert(parent.childValues.has(child));
        $c34b71496108423e$var$assert($c34b71496108423e$var$mightBeDirty(child));
        if (!parent.dirtyChildren) parent.dirtyChildren = $c34b71496108423e$var$emptySetPool.pop() || new Set;
        else if (parent.dirtyChildren.has(child)) return;
        parent.dirtyChildren.add(child);
        $c34b71496108423e$var$reportDirty(parent);
    }
    function $c34b71496108423e$var$reportCleanChild(parent, child) {
        $c34b71496108423e$var$assert(parent.childValues.has(child));
        $c34b71496108423e$var$assert(!$c34b71496108423e$var$mightBeDirty(child));
        var childValue = parent.childValues.get(child);
        if (childValue.length === 0) parent.childValues.set(child, $c34b71496108423e$var$valueCopy(child.value));
        else if (!$c34b71496108423e$var$valueIs(childValue, child.value)) parent.setDirty();
        $c34b71496108423e$var$removeDirtyChild(parent, child);
        if ($c34b71496108423e$var$mightBeDirty(parent)) return;
        $c34b71496108423e$var$reportClean(parent);
    }
    function $c34b71496108423e$var$removeDirtyChild(parent, child) {
        var dc = parent.dirtyChildren;
        if (dc) {
            dc.delete(child);
            if (dc.size === 0) {
                if ($c34b71496108423e$var$emptySetPool.length < $c34b71496108423e$var$POOL_TARGET_SIZE) $c34b71496108423e$var$emptySetPool.push(dc);
                parent.dirtyChildren = null;
            }
        }
    }
    function $c34b71496108423e$var$maybeReportOrphan(entry) {
        return entry.parents.size === 0 && typeof entry.reportOrphan === "function" && entry.reportOrphan() === true;
    }
    function $c34b71496108423e$var$forgetChildren(parent) {
        var children = $c34b71496108423e$var$reusableEmptyArray;
        if (parent.childValues.size > 0) {
            children = [];
            parent.childValues.forEach(function(_value, child) {
                $c34b71496108423e$var$forgetChild(parent, child);
                children.push(child);
            });
        }
        $c34b71496108423e$var$assert(parent.dirtyChildren === null);
        return children;
    }
    function $c34b71496108423e$var$forgetChild(parent, child) {
        child.parents.delete(parent);
        parent.childValues.delete(child);
        $c34b71496108423e$var$removeDirtyChild(parent, child);
    }
    function $c34b71496108423e$var$maybeSubscribe(entry) {
        if (typeof entry.subscribe === "function") try {
            $c34b71496108423e$var$maybeUnsubscribe(entry);
            entry.unsubscribe = entry.subscribe.apply(null, entry.args);
        } catch (e) {
            entry.setDirty();
            return false;
        }
        return true;
    }
    function $c34b71496108423e$var$maybeUnsubscribe(entry) {
        var unsubscribe = entry.unsubscribe;
        if (typeof unsubscribe === "function") {
            entry.unsubscribe = void 0;
            unsubscribe();
        }
    }
    var $c34b71496108423e$export$6bd8d8299be3ac82 = function() {
        function KeyTrie(weakness) {
            this.weakness = weakness;
        }
        KeyTrie.prototype.lookup = function() {
            var array = [];
            for(var _i = 0; _i < arguments.length; _i++)array[_i] = arguments[_i];
            return this.lookupArray(array);
        };
        KeyTrie.prototype.lookupArray = function(array) {
            var node = this;
            array.forEach(function(key) {
                return node = node.getChildTrie(key);
            });
            return node.data || (node.data = Object.create(null));
        };
        KeyTrie.prototype.getChildTrie = function(key) {
            var map = this.weakness && $c34b71496108423e$var$isObjRef(key) ? this.weak || (this.weak = new WeakMap()) : this.strong || (this.strong = new Map());
            var child = map.get(key);
            if (!child) map.set(key, child = new KeyTrie(this.weakness));
            return child;
        };
        return KeyTrie;
    }();
    function $c34b71496108423e$var$isObjRef(value) {
        switch(typeof value){
            case "object":
                if (value === null) break;
            case "function":
                return true;
        }
        return false;
    }
    var $c34b71496108423e$var$keyTrie = new $c34b71496108423e$export$6bd8d8299be3ac82(typeof WeakMap === "function");
    function $c34b71496108423e$export$cd3144f8dd136006() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return $c34b71496108423e$var$keyTrie.lookupArray(args);
    }
    var $c34b71496108423e$var$caches = new Set();
    function $c34b71496108423e$export$4997ffc0176396a6(originalFunction, options) {
        if (options === void 0) options = Object.create(null);
        var cache = new $c34b71496108423e$var$Cache(options.max || Math.pow(2, 16), function(entry) {
            return entry.dispose();
        });
        var disposable = !!options.disposable;
        var makeCacheKey = options.makeCacheKey || $c34b71496108423e$export$cd3144f8dd136006;
        function optimistic() {
            if (disposable && !$c34b71496108423e$var$parentEntrySlot.hasValue()) return void 0;
            var key = makeCacheKey.apply(null, arguments);
            if (key === void 0) return originalFunction.apply(null, arguments);
            var args = Array.prototype.slice.call(arguments);
            var entry = cache.get(key);
            if (entry) entry.args = args;
            else {
                entry = new $c34b71496108423e$var$Entry(originalFunction, args);
                cache.set(key, entry);
                entry.subscribe = options.subscribe;
                if (disposable) entry.reportOrphan = function() {
                    return cache.delete(key);
                };
            }
            var value = entry.recompute();
            cache.set(key, entry);
            $c34b71496108423e$var$caches.add(cache);
            if (!$c34b71496108423e$var$parentEntrySlot.hasValue()) {
                $c34b71496108423e$var$caches.forEach(function(cache) {
                    return cache.clean();
                });
                $c34b71496108423e$var$caches.clear();
            }
            return disposable ? void 0 : value;
        }
        optimistic.dirty = function() {
            var key = makeCacheKey.apply(null, arguments);
            var child = key !== void 0 && cache.get(key);
            if (child) child.setDirty();
        };
        return optimistic;
    }
});
parcelRegister("jFbNy", function(module, exports) {
    $parcel$export(module.exports, "Slot", ()=>$e50aff8f879ebe36$export$8c6ed5c666ac1360);
    var $e50aff8f879ebe36$var$currentContext = null;
    var $e50aff8f879ebe36$var$MISSING_VALUE = {};
    var $e50aff8f879ebe36$var$idCounter = 1;
    var $e50aff8f879ebe36$var$makeSlotClass = function() {
        return function() {
            function Slot() {
                this.id = [
                    "slot",
                    $e50aff8f879ebe36$var$idCounter++,
                    Date.now(),
                    Math.random().toString(36).slice(2)
                ].join(":");
            }
            Slot.prototype.hasValue = function() {
                for(var context_1 = $e50aff8f879ebe36$var$currentContext; context_1; context_1 = context_1.parent)if (this.id in context_1.slots) {
                    var value = context_1.slots[this.id];
                    if (value === $e50aff8f879ebe36$var$MISSING_VALUE) break;
                    if (context_1 !== $e50aff8f879ebe36$var$currentContext) $e50aff8f879ebe36$var$currentContext.slots[this.id] = value;
                    return true;
                }
                if ($e50aff8f879ebe36$var$currentContext) $e50aff8f879ebe36$var$currentContext.slots[this.id] = $e50aff8f879ebe36$var$MISSING_VALUE;
                return false;
            };
            Slot.prototype.getValue = function() {
                if (this.hasValue()) return $e50aff8f879ebe36$var$currentContext.slots[this.id];
            };
            Slot.prototype.withValue = function(value, callback, args, thisArg) {
                var _a;
                var slots = (_a = {
                    __proto__: null
                }, _a[this.id] = value, _a);
                var parent = $e50aff8f879ebe36$var$currentContext;
                $e50aff8f879ebe36$var$currentContext = {
                    parent: parent,
                    slots: slots
                };
                try {
                    return callback.apply(thisArg, args);
                } finally{
                    $e50aff8f879ebe36$var$currentContext = parent;
                }
            };
            Slot.bind = function(callback) {
                var context = $e50aff8f879ebe36$var$currentContext;
                return function() {
                    var saved = $e50aff8f879ebe36$var$currentContext;
                    try {
                        $e50aff8f879ebe36$var$currentContext = context;
                        return callback.apply(this, arguments);
                    } finally{
                        $e50aff8f879ebe36$var$currentContext = saved;
                    }
                };
            };
            Slot.noContext = function(callback, args, thisArg) {
                if ($e50aff8f879ebe36$var$currentContext) {
                    var saved = $e50aff8f879ebe36$var$currentContext;
                    try {
                        $e50aff8f879ebe36$var$currentContext = null;
                        return callback.apply(thisArg, args);
                    } finally{
                        $e50aff8f879ebe36$var$currentContext = saved;
                    }
                } else return callback.apply(thisArg, args);
            };
            return Slot;
        }();
    };
    var $e50aff8f879ebe36$var$globalKey = "@wry/context:Slot";
    var $e50aff8f879ebe36$var$host = Array;
    var $e50aff8f879ebe36$export$8c6ed5c666ac1360 = $e50aff8f879ebe36$var$host[$e50aff8f879ebe36$var$globalKey] || function() {
        var Slot = $e50aff8f879ebe36$var$makeSlotClass();
        try {
            Object.defineProperty($e50aff8f879ebe36$var$host, $e50aff8f879ebe36$var$globalKey, {
                value: $e50aff8f879ebe36$var$host[$e50aff8f879ebe36$var$globalKey] = Slot,
                enumerable: false,
                writable: false,
                configurable: false
            });
        } finally{
            return Slot;
        }
    }();
    var $e50aff8f879ebe36$export$2385a24977818dd0 = $e50aff8f879ebe36$export$8c6ed5c666ac1360.bind, $e50aff8f879ebe36$export$9fa6f2e300a97f8 = $e50aff8f879ebe36$export$8c6ed5c666ac1360.noContext;
    function $e50aff8f879ebe36$export$831dc9f2ab0a617b(callback, delay) {
        return setTimeout($e50aff8f879ebe36$export$2385a24977818dd0(callback), delay);
    }
    function $e50aff8f879ebe36$export$d5d7536e965c82da(genFn) {
        return function() {
            var gen = genFn.apply(this, arguments);
            var boundNext = $e50aff8f879ebe36$export$2385a24977818dd0(gen.next);
            var boundThrow = $e50aff8f879ebe36$export$2385a24977818dd0(gen.throw);
            return new Promise(function(resolve, reject) {
                function invoke(method, argument) {
                    try {
                        var result = method.call(gen, argument);
                    } catch (error) {
                        return reject(error);
                    }
                    var next = result.done ? resolve : invokeNext;
                    if ($e50aff8f879ebe36$var$isPromiseLike(result.value)) result.value.then(next, result.done ? reject : invokeThrow);
                    else next(result.value);
                }
                var invokeNext = function(value) {
                    return invoke(boundNext, value);
                };
                var invokeThrow = function(error) {
                    return invoke(boundThrow, error);
                };
                invokeNext();
            });
        };
    }
    function $e50aff8f879ebe36$var$isPromiseLike(value) {
        return value && typeof value.then === "function";
    }
    var $e50aff8f879ebe36$var$wrappedFibers = [];
    function $e50aff8f879ebe36$export$14794f6e0a4dc6a0(Fiber) {
        if ($e50aff8f879ebe36$var$wrappedFibers.indexOf(Fiber) < 0) {
            var wrap = function(obj, method) {
                var fn = obj[method];
                obj[method] = function() {
                    return $e50aff8f879ebe36$export$9fa6f2e300a97f8(fn, arguments, this);
                };
            };
            wrap(Fiber, "yield");
            wrap(Fiber.prototype, "run");
            wrap(Fiber.prototype, "throwInto");
            $e50aff8f879ebe36$var$wrappedFibers.push(Fiber);
        }
        return Fiber;
    }
});
parcelRegister("h4ppL", function(module, exports) {
    $parcel$export(module.exports, "onError", ()=>$c6d6862dd229df53$export$2288787135a8f66e);
    var $3VFsf;
    var $clSzL;
    function $c6d6862dd229df53$export$2288787135a8f66e(errorHandler) {
        return new (0, (0, parcelRequire("clSzL")).ApolloLink)(function(operation, forward) {
            return new (0, (0, parcelRequire("clSzL")).Observable)(function(observer) {
                var sub;
                var retriedSub;
                var retriedResult;
                try {
                    sub = forward(operation).subscribe({
                        next: function(result) {
                            if (result.errors) {
                                retriedResult = errorHandler({
                                    graphQLErrors: result.errors,
                                    response: result,
                                    operation: operation,
                                    forward: forward
                                });
                                if (retriedResult) {
                                    retriedSub = retriedResult.subscribe({
                                        next: observer.next.bind(observer),
                                        error: observer.error.bind(observer),
                                        complete: observer.complete.bind(observer)
                                    });
                                    return;
                                }
                            }
                            observer.next(result);
                        },
                        error: function(networkError) {
                            retriedResult = errorHandler({
                                operation: operation,
                                networkError: networkError,
                                graphQLErrors: networkError && networkError.result && networkError.result.errors,
                                forward: forward
                            });
                            if (retriedResult) {
                                retriedSub = retriedResult.subscribe({
                                    next: observer.next.bind(observer),
                                    error: observer.error.bind(observer),
                                    complete: observer.complete.bind(observer)
                                });
                                return;
                            }
                            observer.error(networkError);
                        },
                        complete: function() {
                            if (!retriedResult) observer.complete.bind(observer)();
                        }
                    });
                } catch (e) {
                    errorHandler({
                        networkError: e,
                        operation: operation,
                        forward: forward
                    });
                    observer.error(e);
                }
                return function() {
                    if (sub) sub.unsubscribe();
                    if (retriedSub) sub.unsubscribe();
                };
            });
        });
    }
    var $c6d6862dd229df53$export$d2c8415987899609 = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(ErrorLink, _super);
        function ErrorLink(errorHandler) {
            var _this = _super.call(this) || this;
            _this.link = $c6d6862dd229df53$export$2288787135a8f66e(errorHandler);
            return _this;
        }
        ErrorLink.prototype.request = function(operation, forward) {
            return this.link.request(operation, forward);
        };
        return ErrorLink;
    }((0, (0, parcelRequire("clSzL")).ApolloLink));
});
parcelRegister("JPsIz", function(module, exports) {
    $parcel$export(module.exports, "HttpLink", ()=>$089c1f6736cf7295$export$f4bbf1aec241cc1);
    var $3VFsf;
    var $clSzL;
    var $f0Elb;
    var $089c1f6736cf7295$export$95180a16573d6675 = function(linkOptions) {
        if (linkOptions === void 0) linkOptions = {};
        var _a = linkOptions.uri, uri = _a === void 0 ? '/graphql' : _a, fetcher = linkOptions.fetch, includeExtensions = linkOptions.includeExtensions, useGETForQueries = linkOptions.useGETForQueries, abortErrorDoesNotCauseError = linkOptions.abortErrorDoesNotCauseError, requestOptions = (0, (0, parcelRequire("3VFsf")).__rest)(linkOptions, [
            "uri",
            "fetch",
            "includeExtensions",
            "useGETForQueries",
            "abortErrorDoesNotCauseError"
        ]);
        (0, (0, parcelRequire("f0Elb")).checkFetcher)(fetcher);
        if (!fetcher) fetcher = fetch;
        var linkConfig = {
            http: {
                includeExtensions: includeExtensions
            },
            options: requestOptions.fetchOptions,
            credentials: requestOptions.credentials,
            headers: requestOptions.headers
        };
        return new (0, (0, parcelRequire("clSzL")).ApolloLink)(function(operation) {
            var chosenURI = (0, (0, parcelRequire("f0Elb")).selectURI)(operation, uri);
            var context = operation.getContext();
            var clientAwarenessHeaders = {};
            if (context.clientAwareness) {
                var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
                if (name_1) clientAwarenessHeaders['apollographql-client-name'] = name_1;
                if (version) clientAwarenessHeaders['apollographql-client-version'] = version;
            }
            var contextHeaders = (0, (0, parcelRequire("3VFsf")).__assign)({}, clientAwarenessHeaders, context.headers);
            var contextConfig = {
                http: context.http,
                options: context.fetchOptions,
                credentials: context.credentials,
                headers: contextHeaders
            };
            var _b = (0, (0, parcelRequire("f0Elb")).selectHttpOptionsAndBody)(operation, (0, (0, parcelRequire("f0Elb")).fallbackHttpConfig), linkConfig, contextConfig), options = _b.options, body = _b.body;
            var controller;
            if (!options.signal) {
                var _c = (0, (0, parcelRequire("f0Elb")).createSignalIfSupported)(), _controller = _c.controller, signal = _c.signal;
                controller = _controller;
                if (controller) options.signal = signal;
            }
            var definitionIsMutation = function(d) {
                return d.kind === 'OperationDefinition' && d.operation === 'mutation';
            };
            if (useGETForQueries && !operation.query.definitions.some(definitionIsMutation)) options.method = 'GET';
            if (options.method === 'GET') {
                var _d = $089c1f6736cf7295$var$rewriteURIForGET(chosenURI, body), newURI = _d.newURI, parseError = _d.parseError;
                if (parseError) return (0, (0, parcelRequire("clSzL")).fromError)(parseError);
                chosenURI = newURI;
            } else try {
                options.body = (0, (0, parcelRequire("f0Elb")).serializeFetchParameter)(body, 'Payload');
            } catch (parseError) {
                return (0, (0, parcelRequire("clSzL")).fromError)(parseError);
            }
            return new (0, (0, parcelRequire("clSzL")).Observable)(function(observer) {
                fetcher(chosenURI, options).then(function(response) {
                    operation.setContext({
                        response: response
                    });
                    return response;
                }).then((0, (0, parcelRequire("f0Elb")).parseAndCheckHttpResponse)(operation)).then(function(result) {
                    observer.next(result);
                    observer.complete();
                    return result;
                }).catch(function(err) {
                    if (err.name === 'AbortError' && !abortErrorDoesNotCauseError) return;
                    if (err.result && err.result.errors && err.result.data) observer.next(err.result);
                    observer.error(err);
                });
                return function() {
                    if (controller) controller.abort();
                };
            });
        });
    };
    function $089c1f6736cf7295$var$rewriteURIForGET(chosenURI, body) {
        var queryParams = [];
        var addQueryParam = function(key, value) {
            queryParams.push(key + "=" + encodeURIComponent(value));
        };
        if ('query' in body) addQueryParam('query', body.query);
        if (body.operationName) addQueryParam('operationName', body.operationName);
        if (body.variables) {
            var serializedVariables = void 0;
            try {
                serializedVariables = (0, (0, parcelRequire("f0Elb")).serializeFetchParameter)(body.variables, 'Variables map');
            } catch (parseError) {
                return {
                    parseError: parseError
                };
            }
            addQueryParam('variables', serializedVariables);
        }
        if (body.extensions) {
            var serializedExtensions = void 0;
            try {
                serializedExtensions = (0, (0, parcelRequire("f0Elb")).serializeFetchParameter)(body.extensions, 'Extensions map');
            } catch (parseError) {
                return {
                    parseError: parseError
                };
            }
            addQueryParam('extensions', serializedExtensions);
        }
        var fragment = '', preFragment = chosenURI;
        var fragmentStart = chosenURI.indexOf('#');
        if (fragmentStart !== -1) {
            fragment = chosenURI.substr(fragmentStart);
            preFragment = chosenURI.substr(0, fragmentStart);
        }
        var queryParamsPrefix = preFragment.indexOf('?') === -1 ? '?' : '&';
        var newURI = preFragment + queryParamsPrefix + queryParams.join('&') + fragment;
        return {
            newURI: newURI
        };
    }
    var $089c1f6736cf7295$export$f4bbf1aec241cc1 = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(HttpLink, _super);
        function HttpLink(opts) {
            return _super.call(this, $089c1f6736cf7295$export$95180a16573d6675(opts).request) || this;
        }
        return HttpLink;
    }((0, (0, parcelRequire("clSzL")).ApolloLink));
});
parcelRegister("f0Elb", function(module, exports) {
    $parcel$export(module.exports, "fallbackHttpConfig", ()=>$aed625edf13c57eb$export$dd86f00dc866e75d);
    $parcel$export(module.exports, "parseAndCheckHttpResponse", ()=>$aed625edf13c57eb$export$d4051215bea0639f);
    $parcel$export(module.exports, "checkFetcher", ()=>$aed625edf13c57eb$export$8423f0cd3773115e);
    $parcel$export(module.exports, "createSignalIfSupported", ()=>$aed625edf13c57eb$export$f5853cd1fc39aea6);
    $parcel$export(module.exports, "selectHttpOptionsAndBody", ()=>$aed625edf13c57eb$export$a00ebfd5f1eebfb1);
    $parcel$export(module.exports, "serializeFetchParameter", ()=>$aed625edf13c57eb$export$5f8e80ac52052e28);
    $parcel$export(module.exports, "selectURI", ()=>$aed625edf13c57eb$export$63ccc2571850f81a);
    var $3VFsf;
    var $1c8Um;
    var $1DiV8 = parcelRequire("1DiV8");
    var $aed625edf13c57eb$var$defaultHttpOptions = {
        includeQuery: true,
        includeExtensions: false
    };
    var $aed625edf13c57eb$var$defaultHeaders = {
        accept: '*/*',
        'content-type': 'application/json'
    };
    var $aed625edf13c57eb$var$defaultOptions = {
        method: 'POST'
    };
    var $aed625edf13c57eb$export$dd86f00dc866e75d = {
        http: $aed625edf13c57eb$var$defaultHttpOptions,
        headers: $aed625edf13c57eb$var$defaultHeaders,
        options: $aed625edf13c57eb$var$defaultOptions
    };
    var $aed625edf13c57eb$export$c33ef9219f27efd7 = function(response, result, message) {
        var error = new Error(message);
        error.name = 'ServerError';
        error.response = response;
        error.statusCode = response.status;
        error.result = result;
        throw error;
    };
    var $aed625edf13c57eb$export$d4051215bea0639f = function(operations) {
        return function(response) {
            return response.text().then(function(bodyText) {
                try {
                    return JSON.parse(bodyText);
                } catch (err) {
                    var parseError = err;
                    parseError.name = 'ServerParseError';
                    parseError.response = response;
                    parseError.statusCode = response.status;
                    parseError.bodyText = bodyText;
                    return Promise.reject(parseError);
                }
            }).then(function(result) {
                if (response.status >= 300) $aed625edf13c57eb$export$c33ef9219f27efd7(response, result, "Response not successful: Received status code " + response.status);
                if (!Array.isArray(result) && !result.hasOwnProperty('data') && !result.hasOwnProperty('errors')) $aed625edf13c57eb$export$c33ef9219f27efd7(response, result, "Server response was missing for query '" + (Array.isArray(operations) ? operations.map(function(op) {
                    return op.operationName;
                }) : operations.operationName) + "'.");
                return result;
            });
        };
    };
    var $aed625edf13c57eb$export$8423f0cd3773115e = function(fetcher) {
        if (!fetcher && typeof fetch === 'undefined') {
            var library = 'unfetch';
            if (typeof window === 'undefined') library = 'node-fetch';
            throw new (0, $1DiV8.InvariantError)(1);
        }
    };
    var $aed625edf13c57eb$export$f5853cd1fc39aea6 = function() {
        if (typeof AbortController === 'undefined') return {
            controller: false,
            signal: false
        };
        var controller = new AbortController();
        var signal = controller.signal;
        return {
            controller: controller,
            signal: signal
        };
    };
    var $aed625edf13c57eb$export$a00ebfd5f1eebfb1 = function(operation, fallbackConfig) {
        var configs = [];
        for(var _i = 2; _i < arguments.length; _i++)configs[_i - 2] = arguments[_i];
        var options = (0, (0, parcelRequire("3VFsf")).__assign)({}, fallbackConfig.options, {
            headers: fallbackConfig.headers,
            credentials: fallbackConfig.credentials
        });
        var http = fallbackConfig.http;
        configs.forEach(function(config) {
            options = (0, (0, parcelRequire("3VFsf")).__assign)({}, options, config.options, {
                headers: (0, (0, parcelRequire("3VFsf")).__assign)({}, options.headers, config.headers)
            });
            if (config.credentials) options.credentials = config.credentials;
            http = (0, (0, parcelRequire("3VFsf")).__assign)({}, http, config.http);
        });
        var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
        var body = {
            operationName: operationName,
            variables: variables
        };
        if (http.includeExtensions) body.extensions = extensions;
        if (http.includeQuery) body.query = (0, (0, parcelRequire("1c8Um")).print)(query);
        return {
            options: options,
            body: body
        };
    };
    var $aed625edf13c57eb$export$5f8e80ac52052e28 = function(p, label) {
        var serialized;
        try {
            serialized = JSON.stringify(p);
        } catch (e) {
            var parseError = new (0, $1DiV8.InvariantError)(2);
            parseError.parseError = e;
            throw parseError;
        }
        return serialized;
    };
    var $aed625edf13c57eb$export$63ccc2571850f81a = function(operation, fallbackURI) {
        var context = operation.getContext();
        var contextURI = context.uri;
        if (contextURI) return contextURI;
        else if (typeof fallbackURI === 'function') return fallbackURI(operation);
        else return fallbackURI || '/graphql';
    };
});
parcelRegister("lC4FX", function(module, exports) {
    $parcel$export(module.exports, "RetryLink", ()=>$fbc0c610016bf5c5$export$943d544ad120494a);
    var $3VFsf;
    var $clSzL;
    function $fbc0c610016bf5c5$var$buildDelayFunction(delayOptions) {
        var _a = delayOptions || {}, _b = _a.initial, initial = _b === void 0 ? 300 : _b, _c = _a.jitter, jitter = _c === void 0 ? true : _c, _d = _a.max, max = _d === void 0 ? Infinity : _d;
        var baseDelay = jitter ? initial : initial / 2;
        return function delayFunction(count) {
            var delay = Math.min(max, baseDelay * Math.pow(2, count));
            if (jitter) delay = Math.random() * delay;
            return delay;
        };
    }
    function $fbc0c610016bf5c5$var$buildRetryFunction(retryOptions) {
        var _a = retryOptions || {}, retryIf = _a.retryIf, _b = _a.max, max = _b === void 0 ? 5 : _b;
        return function retryFunction(count, operation, error) {
            if (count >= max) return false;
            return retryIf ? retryIf(error, operation) : !!error;
        };
    }
    var $fbc0c610016bf5c5$var$RetryableOperation = function() {
        function RetryableOperation(operation, nextLink, delayFor, retryIf) {
            var _this = this;
            this.operation = operation;
            this.nextLink = nextLink;
            this.delayFor = delayFor;
            this.retryIf = retryIf;
            this.retryCount = 0;
            this.values = [];
            this.complete = false;
            this.canceled = false;
            this.observers = [];
            this.currentSubscription = null;
            this.onNext = function(value) {
                _this.values.push(value);
                for(var _i = 0, _a = _this.observers; _i < _a.length; _i++){
                    var observer = _a[_i];
                    if (!observer) continue;
                    observer.next(value);
                }
            };
            this.onComplete = function() {
                _this.complete = true;
                for(var _i = 0, _a = _this.observers; _i < _a.length; _i++){
                    var observer = _a[_i];
                    if (!observer) continue;
                    observer.complete();
                }
            };
            this.onError = function(error) {
                return (0, (0, parcelRequire("3VFsf")).__awaiter)(_this, void 0, void 0, function() {
                    var shouldRetry, _i, _a, observer;
                    return (0, (0, parcelRequire("3VFsf")).__generator)(this, function(_b) {
                        switch(_b.label){
                            case 0:
                                this.retryCount += 1;
                                return [
                                    4,
                                    this.retryIf(this.retryCount, this.operation, error)
                                ];
                            case 1:
                                shouldRetry = _b.sent();
                                if (shouldRetry) {
                                    this.scheduleRetry(this.delayFor(this.retryCount, this.operation, error));
                                    return [
                                        2
                                    ];
                                }
                                this.error = error;
                                for(_i = 0, _a = this.observers; _i < _a.length; _i++){
                                    observer = _a[_i];
                                    if (!observer) continue;
                                    observer.error(error);
                                }
                                return [
                                    2
                                ];
                        }
                    });
                });
            };
        }
        RetryableOperation.prototype.subscribe = function(observer) {
            if (this.canceled) throw new Error("Subscribing to a retryable link that was canceled is not supported");
            this.observers.push(observer);
            for(var _i = 0, _a = this.values; _i < _a.length; _i++){
                var value = _a[_i];
                observer.next(value);
            }
            if (this.complete) observer.complete();
            else if (this.error) observer.error(this.error);
        };
        RetryableOperation.prototype.unsubscribe = function(observer) {
            var index = this.observers.indexOf(observer);
            if (index < 0) throw new Error("RetryLink BUG! Attempting to unsubscribe unknown observer!");
            this.observers[index] = null;
            if (this.observers.every(function(o) {
                return o === null;
            })) this.cancel();
        };
        RetryableOperation.prototype.start = function() {
            if (this.currentSubscription) return;
            this.try();
        };
        RetryableOperation.prototype.cancel = function() {
            if (this.currentSubscription) this.currentSubscription.unsubscribe();
            clearTimeout(this.timerId);
            this.timerId = null;
            this.currentSubscription = null;
            this.canceled = true;
        };
        RetryableOperation.prototype.try = function() {
            this.currentSubscription = this.nextLink(this.operation).subscribe({
                next: this.onNext,
                error: this.onError,
                complete: this.onComplete
            });
        };
        RetryableOperation.prototype.scheduleRetry = function(delay) {
            var _this = this;
            if (this.timerId) throw new Error("RetryLink BUG! Encountered overlapping retries");
            this.timerId = setTimeout(function() {
                _this.timerId = null;
                _this.try();
            }, delay);
        };
        return RetryableOperation;
    }();
    var $fbc0c610016bf5c5$export$943d544ad120494a = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(RetryLink, _super);
        function RetryLink(options) {
            var _this = _super.call(this) || this;
            var _a = options || {}, attempts = _a.attempts, delay = _a.delay;
            _this.delayFor = typeof delay === 'function' ? delay : $fbc0c610016bf5c5$var$buildDelayFunction(delay);
            _this.retryIf = typeof attempts === 'function' ? attempts : $fbc0c610016bf5c5$var$buildRetryFunction(attempts);
            return _this;
        }
        RetryLink.prototype.request = function(operation, nextLink) {
            var retryable = new $fbc0c610016bf5c5$var$RetryableOperation(operation, nextLink, this.delayFor, this.retryIf);
            retryable.start();
            return new (0, (0, parcelRequire("clSzL")).Observable)(function(observer) {
                retryable.subscribe(observer);
                return function() {
                    retryable.unsubscribe(observer);
                };
            });
        };
        return RetryLink;
    }((0, (0, parcelRequire("clSzL")).ApolloLink));
});
parcelRegister("cuKXc", function(module, exports) {
    $parcel$export(module.exports, "fragmentCacheRedirect", ()=>$918cb5692ff82562$export$5133c88128301697);
    $parcel$export(module.exports, "fragmentLinkState", ()=>$918cb5692ff82562$export$3f9ecfb4d42ab23d);
    var $jojW6;
    var $9HlP2 = parcelRequire("9HlP2");
    var $ivfDv;
    function $918cb5692ff82562$export$5133c88128301697(dataIdFromObject) {
        if (dataIdFromObject === void 0) dataIdFromObject = (0, (0, parcelRequire("ivfDv")).defaultDataIdFromObject);
        return {
            getFragment: function(_, _a) {
                var id = _a.id, __typename = _a.__typename;
                return (0, (0, parcelRequire("jojW6")).toIdValue)(dataIdFromObject({
                    __typename: __typename,
                    id: id
                }));
            }
        };
    }
    function $918cb5692ff82562$export$3f9ecfb4d42ab23d(apolloCache) {
        return (0, $9HlP2.withClientState)({
            cache: apolloCache,
            resolvers: {
                Query: {
                    getFragment: function(_, _a, _b) {
                        var __typename = _a.__typename, id = _a.id;
                        var cache = _b.cache;
                        var fragmentId = cache.config.dataIdFromObject({
                            __typename: __typename,
                            id: id
                        });
                        return cache.data.data[fragmentId];
                    }
                }
            }
        });
    }
});
parcelRegister("9HlP2", function(module, exports) {
    $parcel$export(module.exports, "withClientState", ()=>$70f90ea50d538958$export$a13f755900e15d9e);
    var $clSzL;
    var $jojW6;
    var $jWd7i;
    var $b2p88 = parcelRequire("b2p88");
    var $70f90ea50d538958$var$__extends = undefined && undefined.__extends || function() {
        var extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
        };
        return function(d, b) {
            extendStatics(d, b);
            function __() {
                this.constructor = d;
            }
            d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
        };
    }();
    var $70f90ea50d538958$var$graphql = (0, parcelRequire("jWd7i")).graphql;
    var $70f90ea50d538958$var$capitalizeFirstLetter = function(str) {
        return str.charAt(0).toUpperCase() + str.slice(1);
    };
    var $70f90ea50d538958$export$a13f755900e15d9e = function(clientStateConfig) {
        if (clientStateConfig === void 0) clientStateConfig = {
            resolvers: {},
            defaults: {}
        };
        var defaults = clientStateConfig.defaults, cache = clientStateConfig.cache, typeDefs = clientStateConfig.typeDefs, fragmentMatcher = clientStateConfig.fragmentMatcher;
        if (cache && defaults) cache.writeData({
            data: defaults
        });
        return new (function(_super) {
            $70f90ea50d538958$var$__extends(StateLink, _super);
            function StateLink() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            StateLink.prototype.writeDefaults = function() {
                if (cache && defaults) cache.writeData({
                    data: defaults
                });
            };
            StateLink.prototype.request = function(operation, forward) {
                if (forward === void 0) forward = function() {
                    return (0, (0, parcelRequire("clSzL")).Observable).of({
                        data: {}
                    });
                };
                if (typeDefs) {
                    var directives_1 = 'directive @client on FIELD';
                    var definition_1 = (0, $b2p88.normalizeTypeDefs)(typeDefs);
                    operation.setContext(function(_a) {
                        var _b = _a.schemas, schemas = _b === void 0 ? [] : _b;
                        return {
                            schemas: schemas.concat([
                                {
                                    definition: definition_1,
                                    directives: directives_1
                                }
                            ])
                        };
                    });
                }
                var isClient = (0, (0, parcelRequire("jojW6")).hasDirectives)([
                    'client'
                ], operation.query);
                if (!isClient) return forward(operation);
                var resolvers = typeof clientStateConfig.resolvers === 'function' ? clientStateConfig.resolvers() : clientStateConfig.resolvers;
                var server = (0, $b2p88.removeClientSetsFromDocument)(operation.query);
                var query = operation.query;
                var type = $70f90ea50d538958$var$capitalizeFirstLetter(((0, (0, parcelRequire("jojW6")).getMainDefinition)(query) || {}).operation) || 'Query';
                var resolver = function(fieldName, rootValue, args, context, info) {
                    if (rootValue === void 0) rootValue = {};
                    var resultKey = info.resultKey;
                    var aliasedNode = rootValue[resultKey];
                    var preAliasingNode = rootValue[fieldName];
                    var aliasNeeded = resultKey !== fieldName;
                    if (aliasedNode !== undefined || preAliasingNode !== undefined) return aliasedNode || preAliasingNode;
                    var resolverMap = resolvers[rootValue.__typename || type];
                    if (resolverMap) {
                        var resolve = resolverMap[fieldName];
                        if (resolve) return resolve(rootValue, args, context, info);
                    }
                    return (aliasNeeded ? aliasedNode : preAliasingNode) || (defaults || {})[fieldName];
                };
                if (server) operation.query = server;
                var obs = server && forward ? forward(operation) : (0, (0, parcelRequire("clSzL")).Observable).of({
                    data: {}
                });
                return new (0, (0, parcelRequire("clSzL")).Observable)(function(observer) {
                    var complete = false;
                    var handlingNext = false;
                    obs.subscribe({
                        next: function(_a) {
                            var data = _a.data, errors = _a.errors;
                            var observerErrorHandler = observer.error.bind(observer);
                            var context = operation.getContext();
                            handlingNext = true;
                            $70f90ea50d538958$var$graphql(resolver, query, data, context, operation.variables, {
                                fragmentMatcher: fragmentMatcher
                            }).then(function(nextData) {
                                observer.next({
                                    data: nextData,
                                    errors: errors
                                });
                                if (complete) observer.complete();
                                handlingNext = false;
                            }).catch(observerErrorHandler);
                        },
                        error: observer.error.bind(observer),
                        complete: function() {
                            if (!handlingNext) observer.complete();
                            complete = true;
                        }
                    });
                });
            };
            return StateLink;
        }((0, (0, parcelRequire("clSzL")).ApolloLink)))();
    };
});
parcelRegister("jWd7i", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $3VFsf;
    var $jojW6;
    var $jDjTr;
    function $e83d9bca6fb9481d$var$graphql(resolver, document, rootValue, contextValue, variableValues, execOptions) {
        if (execOptions === void 0) execOptions = {};
        var mainDefinition = (0, parcelRequire("jojW6")).getMainDefinition(document);
        var fragments = (0, parcelRequire("jojW6")).getFragmentDefinitions(document);
        var fragmentMap = (0, parcelRequire("jojW6")).createFragmentMap(fragments);
        var resultMapper = execOptions.resultMapper;
        var fragmentMatcher = execOptions.fragmentMatcher || function() {
            return true;
        };
        var execContext = {
            fragmentMap: fragmentMap,
            contextValue: contextValue,
            variableValues: variableValues,
            resultMapper: resultMapper,
            resolver: resolver,
            fragmentMatcher: fragmentMatcher
        };
        return $e83d9bca6fb9481d$var$executeSelectionSet(mainDefinition.selectionSet, rootValue, execContext);
    }
    module.exports.graphql = $e83d9bca6fb9481d$var$graphql;
    function $e83d9bca6fb9481d$var$executeSelectionSet(selectionSet, rootValue, execContext) {
        return (0, parcelRequire("3VFsf")).__awaiter(this, void 0, void 0, function() {
            var fragmentMap, contextValue, variables, result, execute;
            var _this = this;
            return (0, parcelRequire("3VFsf")).__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
                        result = {};
                        execute = function(selection) {
                            return (0, parcelRequire("3VFsf")).__awaiter(_this, void 0, void 0, function() {
                                var fieldResult, resultFieldKey, fragment, typeCondition, fragmentResult;
                                return (0, parcelRequire("3VFsf")).__generator(this, function(_a) {
                                    switch(_a.label){
                                        case 0:
                                            if (!(0, parcelRequire("jojW6")).shouldInclude(selection, variables)) return [
                                                2
                                            ];
                                            if (!(0, parcelRequire("jojW6")).isField(selection)) return [
                                                3,
                                                2
                                            ];
                                            return [
                                                4,
                                                $e83d9bca6fb9481d$var$executeField(selection, rootValue, execContext)
                                            ];
                                        case 1:
                                            fieldResult = _a.sent();
                                            resultFieldKey = (0, parcelRequire("jojW6")).resultKeyNameFromField(selection);
                                            if (fieldResult !== undefined) {
                                                if (result[resultFieldKey] === undefined) result[resultFieldKey] = fieldResult;
                                                else (0, parcelRequire("jDjTr")).merge(result[resultFieldKey], fieldResult);
                                            }
                                            return [
                                                2
                                            ];
                                        case 2:
                                            if ((0, parcelRequire("jojW6")).isInlineFragment(selection)) fragment = selection;
                                            else {
                                                fragment = fragmentMap[selection.name.value];
                                                if (!fragment) throw new Error("No fragment named " + selection.name.value);
                                            }
                                            typeCondition = fragment.typeCondition.name.value;
                                            if (!execContext.fragmentMatcher(rootValue, typeCondition, contextValue)) return [
                                                3,
                                                4
                                            ];
                                            return [
                                                4,
                                                $e83d9bca6fb9481d$var$executeSelectionSet(fragment.selectionSet, rootValue, execContext)
                                            ];
                                        case 3:
                                            fragmentResult = _a.sent();
                                            (0, parcelRequire("jDjTr")).merge(result, fragmentResult);
                                            _a.label = 4;
                                        case 4:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            });
                        };
                        return [
                            4,
                            Promise.all(selectionSet.selections.map(execute))
                        ];
                    case 1:
                        _a.sent();
                        if (execContext.resultMapper) return [
                            2,
                            execContext.resultMapper(result, rootValue)
                        ];
                        return [
                            2,
                            result
                        ];
                }
            });
        });
    }
    function $e83d9bca6fb9481d$var$executeField(field, rootValue, execContext) {
        return (0, parcelRequire("3VFsf")).__awaiter(this, void 0, void 0, function() {
            var variables, contextValue, resolver, fieldName, args, info, result;
            return (0, parcelRequire("3VFsf")).__generator(this, function(_a) {
                switch(_a.label){
                    case 0:
                        variables = execContext.variableValues, contextValue = execContext.contextValue, resolver = execContext.resolver;
                        fieldName = field.name.value;
                        args = (0, parcelRequire("jojW6")).argumentsObjectFromField(field, variables);
                        info = {
                            isLeaf: !field.selectionSet,
                            resultKey: (0, parcelRequire("jojW6")).resultKeyNameFromField(field),
                            directives: (0, parcelRequire("jojW6")).getDirectiveInfoFromField(field, variables),
                            field: field
                        };
                        return [
                            4,
                            resolver(fieldName, rootValue, args, contextValue, info)
                        ];
                    case 1:
                        result = _a.sent();
                        if (!field.selectionSet) return [
                            2,
                            result
                        ];
                        if (result == null) return [
                            2,
                            result
                        ];
                        if (Array.isArray(result)) return [
                            2,
                            $e83d9bca6fb9481d$var$executeSubSelectedArray(field, result, execContext)
                        ];
                        return [
                            2,
                            $e83d9bca6fb9481d$var$executeSelectionSet(field.selectionSet, result, execContext)
                        ];
                }
            });
        });
    }
    function $e83d9bca6fb9481d$var$executeSubSelectedArray(field, result, execContext) {
        return Promise.all(result.map(function(item) {
            if (item === null) return null;
            if (Array.isArray(item)) return $e83d9bca6fb9481d$var$executeSubSelectedArray(field, item, execContext);
            return $e83d9bca6fb9481d$var$executeSelectionSet(field.selectionSet, item, execContext);
        }));
    }
});
parcelRegister("jDjTr", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    var $jojW6;
    function $e4b11739b667b187$var$graphql(resolver, document, rootValue, contextValue, variableValues, execOptions) {
        if (variableValues === void 0) variableValues = {};
        if (execOptions === void 0) execOptions = {};
        var mainDefinition = (0, parcelRequire("jojW6")).getMainDefinition(document);
        var fragments = (0, parcelRequire("jojW6")).getFragmentDefinitions(document);
        var fragmentMap = (0, parcelRequire("jojW6")).createFragmentMap(fragments);
        var resultMapper = execOptions.resultMapper;
        var fragmentMatcher = execOptions.fragmentMatcher || function() {
            return true;
        };
        var execContext = {
            fragmentMap: fragmentMap,
            contextValue: contextValue,
            variableValues: variableValues,
            resultMapper: resultMapper,
            resolver: resolver,
            fragmentMatcher: fragmentMatcher
        };
        return $e4b11739b667b187$var$executeSelectionSet(mainDefinition.selectionSet, rootValue, execContext);
    }
    module.exports.graphql = $e4b11739b667b187$var$graphql;
    function $e4b11739b667b187$var$executeSelectionSet(selectionSet, rootValue, execContext) {
        var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
        var result = {};
        selectionSet.selections.forEach(function(selection) {
            if (variables && !(0, parcelRequire("jojW6")).shouldInclude(selection, variables)) return;
            if ((0, parcelRequire("jojW6")).isField(selection)) {
                var fieldResult = $e4b11739b667b187$var$executeField(selection, rootValue, execContext);
                var resultFieldKey = (0, parcelRequire("jojW6")).resultKeyNameFromField(selection);
                if (fieldResult !== undefined) {
                    if (result[resultFieldKey] === undefined) result[resultFieldKey] = fieldResult;
                    else $e4b11739b667b187$var$merge(result[resultFieldKey], fieldResult);
                }
            } else {
                var fragment = void 0;
                if ((0, parcelRequire("jojW6")).isInlineFragment(selection)) fragment = selection;
                else {
                    fragment = fragmentMap[selection.name.value];
                    if (!fragment) throw new Error("No fragment named " + selection.name.value);
                }
                var typeCondition = fragment.typeCondition.name.value;
                if (execContext.fragmentMatcher(rootValue, typeCondition, contextValue)) {
                    var fragmentResult = $e4b11739b667b187$var$executeSelectionSet(fragment.selectionSet, rootValue, execContext);
                    $e4b11739b667b187$var$merge(result, fragmentResult);
                }
            }
        });
        if (execContext.resultMapper) return execContext.resultMapper(result, rootValue);
        return result;
    }
    function $e4b11739b667b187$var$executeField(field, rootValue, execContext) {
        var variables = execContext.variableValues, contextValue = execContext.contextValue, resolver = execContext.resolver;
        var fieldName = field.name.value;
        var args = (0, parcelRequire("jojW6")).argumentsObjectFromField(field, variables);
        var info = {
            isLeaf: !field.selectionSet,
            resultKey: (0, parcelRequire("jojW6")).resultKeyNameFromField(field),
            directives: (0, parcelRequire("jojW6")).getDirectiveInfoFromField(field, variables),
            field: field
        };
        var result = resolver(fieldName, rootValue, args, contextValue, info);
        if (!field.selectionSet) return result;
        if (result == null) return result;
        if (Array.isArray(result)) return $e4b11739b667b187$var$executeSubSelectedArray(field, result, execContext);
        return $e4b11739b667b187$var$executeSelectionSet(field.selectionSet, result, execContext);
    }
    function $e4b11739b667b187$var$executeSubSelectedArray(field, result, execContext) {
        return result.map(function(item) {
            if (item === null) return null;
            if (Array.isArray(item)) return $e4b11739b667b187$var$executeSubSelectedArray(field, item, execContext);
            return $e4b11739b667b187$var$executeSelectionSet(field.selectionSet, item, execContext);
        });
    }
    var $e4b11739b667b187$var$hasOwn = Object.prototype.hasOwnProperty;
    function $e4b11739b667b187$var$merge(dest, src) {
        if (src !== null && typeof src === 'object') Object.keys(src).forEach(function(key) {
            var srcVal = src[key];
            if (!$e4b11739b667b187$var$hasOwn.call(dest, key)) dest[key] = srcVal;
            else $e4b11739b667b187$var$merge(dest[key], srcVal);
        });
    }
    module.exports.merge = $e4b11739b667b187$var$merge;
});
parcelRegister("b2p88", function(module, exports) {
    $parcel$export(module.exports, "removeClientSetsFromDocument", ()=>$80935fed9657b3c7$export$8eae69e876ee321e);
    $parcel$export(module.exports, "normalizeTypeDefs", ()=>$80935fed9657b3c7$export$467f9c465e4ace4e);
    var $1c8Um;
    var $jojW6;
    var $80935fed9657b3c7$var$connectionRemoveConfig = {
        test: function(directive) {
            return directive.name.value === 'client';
        },
        remove: true
    };
    var $80935fed9657b3c7$var$removed = new Map();
    function $80935fed9657b3c7$export$8eae69e876ee321e(query) {
        var cached = $80935fed9657b3c7$var$removed.get(query);
        if (cached) return cached;
        (0, (0, parcelRequire("jojW6")).checkDocument)(query);
        var docClone = (0, (0, parcelRequire("jojW6")).removeDirectivesFromDocument)([
            $80935fed9657b3c7$var$connectionRemoveConfig
        ], query);
        $80935fed9657b3c7$var$removed.set(query, docClone);
        return docClone;
    }
    function $80935fed9657b3c7$export$467f9c465e4ace4e(typeDefs) {
        var defs = Array.isArray(typeDefs) ? typeDefs : [
            typeDefs
        ];
        return defs.map(function(typeDef) {
            return typeof typeDef === 'string' ? typeDef : (0, (0, parcelRequire("1c8Um")).print)(typeDef);
        }).map(function(str) {
            return str.trim();
        }).join('\n');
    }
});
parcelRegister("jQUy5", function(module, exports) {
    $parcel$export(module.exports, "UFOLoggerLink", ()=>$35ed2b5c814d0caf$export$fb326ed954631f3f);
    var $clSzL;
    var $knQnR;
    const $35ed2b5c814d0caf$export$fb326ed954631f3f = new (0, (0, parcelRequire("clSzL")).ApolloLink)((operation, forward)=>{
        const networkStart = performance.now();
        return forward(operation).map((response)=>{
            const networkComplete = performance.now();
            const operationName = operation.operationName ?? 'unnamed';
            (0, (0, parcelRequire("knQnR")).addSpanToAll)('graphql', operationName, [
                {
                    name: 'network'
                }
            ], networkStart, networkComplete);
            return response;
        });
    });
});
parcelRegister("l0T7c", function(module, exports) {
    module.exports = JSON.parse("{\"__schema\":{\"types\":[{\"kind\":\"UNION\",\"name\":\"AllActivityFeedItemUnion\",\"possibleTypes\":[{\"name\":\"HistoryItem\"},{\"name\":\"CommentItem\"},{\"name\":\"WorklogItem\"},{\"name\":\"IncidentItem\"},{\"name\":\"ApprovalItem\"},{\"name\":\"HiddenCommentItem\"}]},{\"kind\":\"UNION\",\"name\":\"ApprovalActivityValueUnion\",\"possibleTypes\":[{\"name\":\"ApprovalCreated\"},{\"name\":\"ApproverDecision\"},{\"name\":\"ApprovalCompleted\"}]},{\"kind\":\"UNION\",\"name\":\"ConfluencePageUnion\",\"possibleTypes\":[{\"name\":\"ConfluencePage\"},{\"name\":\"FailedRemoteLink\"}]},{\"kind\":\"UNION\",\"name\":\"GQLCategorizedField\",\"possibleTypes\":[{\"name\":\"GQLSortableField\"},{\"name\":\"GQLSearchableField\"}]},{\"kind\":\"UNION\",\"name\":\"GadgetParameters\",\"possibleTypes\":[{\"name\":\"VotedGadgetParameters\"},{\"name\":\"AssignedToMeGadgetParameters\"},{\"name\":\"WatchedGadgetParameters\"},{\"name\":\"InProgressGadgetParameters\"},{\"name\":\"FilterResultsGadgetParameters\"},{\"name\":\"TwoDimensionalStatisticsParameters\"},{\"name\":\"PieChartParameters\"},{\"name\":\"IssueStatisticsParameters\"},{\"name\":\"WorkloadPieChartParameters\"},{\"name\":\"ActivityStreamGadgetParameters\"},{\"name\":\"CreatedVsResolvedGadgetParameters\"},{\"name\":\"SprintGadgetParameters\"},{\"name\":\"ProjectsGadgetParameters\"},{\"name\":\"ConnectGadgetParameters\"},{\"name\":\"NotConfiguredGadgetParameters\"},{\"name\":\"UnsupportedGadgetParameters\"}]},{\"kind\":\"UNION\",\"name\":\"GroupByFieldUnion\",\"possibleTypes\":[{\"name\":\"PriorityField\"},{\"name\":\"StatusField\"},{\"name\":\"UserField\"},{\"name\":\"LabelsField\"},{\"name\":\"SelectCustomField\"},{\"name\":\"JWMCategoryCustomField\"},{\"name\":\"IssueTypeField\"},{\"name\":\"StoryPointsField\"},{\"name\":\"SprintCustomField\"},{\"name\":\"FloatCustomField\"}]},{\"kind\":\"UNION\",\"name\":\"GroupSectionItem\",\"possibleTypes\":[{\"name\":\"FieldSectionItem\"},{\"name\":\"EcosystemSectionItem\"},{\"name\":\"ForgeSectionItem\"},{\"name\":\"PanelSectionItem\"}]},{\"kind\":\"UNION\",\"name\":\"HistoryValue\",\"possibleTypes\":[{\"name\":\"AssigneeFieldValue\"},{\"name\":\"PriorityFieldValue\"},{\"name\":\"StatusFieldValue\"},{\"name\":\"WorkLogFieldValue\"},{\"name\":\"RespondersFieldValue\"},{\"name\":\"GenericFieldValue\"}]},{\"kind\":\"UNION\",\"name\":\"IncidentActivityValueUnion\",\"possibleTypes\":[{\"name\":\"ResponderAlertAssignedValue\"},{\"name\":\"AlertValue\"},{\"name\":\"ResponderAlertPriorityChangedValue\"},{\"name\":\"IccSessionValue\"},{\"name\":\"IccSessionInvitationValue\"},{\"name\":\"StakeholderUpdatedValue\"},{\"name\":\"IncidentStakeholderActionValue\"}]},{\"kind\":\"UNION\",\"name\":\"IssueFieldUnion\",\"possibleTypes\":[{\"name\":\"PriorityField\"},{\"name\":\"StatusField\"},{\"name\":\"IssueTypeField\"},{\"name\":\"ProjectComponentsField\"},{\"name\":\"LabelsField\"},{\"name\":\"WatchersField\"},{\"name\":\"UserField\"},{\"name\":\"TextField\"},{\"name\":\"VersionsField\"},{\"name\":\"DateField\"},{\"name\":\"DateTimeField\"},{\"name\":\"IssueKeyField\"},{\"name\":\"ProjectField\"},{\"name\":\"ResolutionField\"},{\"name\":\"TimeTrackingField\"},{\"name\":\"TimeOriginalEstimateField\"},{\"name\":\"TimeEstimateField\"},{\"name\":\"TimeSpentField\"},{\"name\":\"StoryPointsField\"},{\"name\":\"EpicLinkField\"},{\"name\":\"EpicNameField\"},{\"name\":\"ColorField\"},{\"name\":\"EpicColorField\"},{\"name\":\"SprintCustomField\"},{\"name\":\"SelectCustomField\"},{\"name\":\"FlaggedCustomField\"},{\"name\":\"UserPickerCustomField\"},{\"name\":\"TextAreaCustomField\"},{\"name\":\"FloatCustomField\"},{\"name\":\"DatePickerCustomField\"},{\"name\":\"TextFieldCustomField\"},{\"name\":\"MultiSelectCustomField\"},{\"name\":\"LabelsCustomField\"},{\"name\":\"MultiUserPickerCustomField\"},{\"name\":\"PeopleCustomField\"},{\"name\":\"UrlCustomField\"},{\"name\":\"VersionCustomField\"},{\"name\":\"GroupPickerCustomField\"},{\"name\":\"MultiVersionCustomField\"},{\"name\":\"MultiGroupPickerCustomField\"},{\"name\":\"CheckBoxesCustomField\"},{\"name\":\"RadioButtonsCustomField\"},{\"name\":\"DateTimeCustomField\"},{\"name\":\"SeverityField\"},{\"name\":\"AffectedServicesField\"},{\"name\":\"TechLeadField\"},{\"name\":\"AttachmentsField\"},{\"name\":\"GlancesField\"},{\"name\":\"SecurityLevelField\"},{\"name\":\"IssueLinksField\"},{\"name\":\"IssuesInEpicField\"},{\"name\":\"SubtasksField\"},{\"name\":\"ChildIssuesField\"},{\"name\":\"CascadingSelectCustomField\"},{\"name\":\"CmdbField\"},{\"name\":\"SLACustomField\"},{\"name\":\"ProjectCustomField\"},{\"name\":\"EpicStatusField\"},{\"name\":\"ParentField\"},{\"name\":\"JWMCategoryCustomField\"},{\"name\":\"CommentSummaryField\"}]},{\"kind\":\"UNION\",\"name\":\"IssueSections\",\"possibleTypes\":[{\"name\":\"PrimarySecondaryContextSections\"},{\"name\":\"JsdSections\"}]},{\"kind\":\"UNION\",\"name\":\"JiraActiveBackgroundDetailsResult\",\"possibleTypes\":[{\"name\":\"JiraColorBackground\"},{\"name\":\"JiraGradientBackground\"},{\"name\":\"JiraMediaBackground\"},{\"name\":\"JiraAttachmentBackground\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraAtlassianIntelligenceAction\",\"possibleTypes\":[{\"name\":\"JiraAccessAtlassianIntelligenceFeature\"},{\"name\":\"JiraEnableAtlassianIntelligenceDeepLink\"},{\"name\":\"JiraContactOrgAdminToEnableAtlassianIntelligence\"}]},{\"kind\":\"UNION\",\"name\":\"JiraBackgroundUploadTokenResult\",\"possibleTypes\":[{\"name\":\"JiraBackgroundUploadToken\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraBoardResult\",\"possibleTypes\":[{\"name\":\"JiraBoard\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraChildIssues\",\"possibleTypes\":[{\"name\":\"JiraChildIssuesWithinLimit\"},{\"name\":\"JiraChildIssuesExceedingLimit\"}]},{\"kind\":\"UNION\",\"name\":\"JiraCommentVisibility\",\"possibleTypes\":[{\"name\":\"JiraRoleVisibility\"},{\"name\":\"JiraGroupVisibility\"}]},{\"kind\":\"UNION\",\"name\":\"JiraContainerNavigationResult\",\"possibleTypes\":[{\"name\":\"JiraContainerNavigation\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraDefaultUnsplashImagesPageResult\",\"possibleTypes\":[{\"name\":\"JiraDefaultUnsplashImagesPage\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraFavourite\",\"possibleTypes\":[{\"name\":\"JiraProject\"},{\"name\":\"JiraSystemFilter\"},{\"name\":\"JiraCustomFilter\"},{\"name\":\"JiraDashboard\"},{\"name\":\"JiraPlan\"},{\"name\":\"JiraBoard\"},{\"name\":\"JiraServiceManagementQueue\"}]},{\"kind\":\"UNION\",\"name\":\"JiraFieldSetViewResult\",\"possibleTypes\":[{\"name\":\"JiraFieldSetView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraFormattingExpression\",\"possibleTypes\":[{\"name\":\"JiraFormattingSingleValueOperand\"},{\"name\":\"JiraFormattingTwoValueOperand\"},{\"name\":\"JiraFormattingMultipleValueOperand\"},{\"name\":\"JiraFormattingNoValueOperand\"}]},{\"kind\":\"UNION\",\"name\":\"JiraGlobalPermissionGrantsResult\",\"possibleTypes\":[{\"name\":\"JiraGlobalPermissionGrantsList\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraGrantTypeValue\",\"possibleTypes\":[{\"name\":\"JiraDefaultGrantTypeValue\"},{\"name\":\"JiraUserGrantTypeValue\"},{\"name\":\"JiraProjectRoleGrantTypeValue\"},{\"name\":\"JiraGroupGrantTypeValue\"},{\"name\":\"JiraIssueFieldGrantTypeValue\"}]},{\"kind\":\"UNION\",\"name\":\"JiraGroupLayoutItem\",\"possibleTypes\":[{\"name\":\"JiraFieldLayoutItem\"},{\"name\":\"JiraEcosystemLayoutItem\"},{\"name\":\"JiraForgeLayoutItem\"},{\"name\":\"JiraPanelLayoutItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueCreateAdditionalServicesResult\",\"possibleTypes\":[{\"name\":\"JiraIssueCreateAdditionalServices\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueCreateFieldsResult\",\"possibleTypes\":[{\"name\":\"JiraIssueCreateFields\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueCreateLayoutResult\",\"possibleTypes\":[{\"name\":\"JiraIssueCreateLayout\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueExportEvent\",\"possibleTypes\":[{\"name\":\"JiraIssueExportTaskSubmitted\"},{\"name\":\"JiraIssueExportTaskProgress\"},{\"name\":\"JiraIssueExportTaskCompleted\"},{\"name\":\"JiraIssueExportTaskTerminated\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemContainerItem\",\"possibleTypes\":[{\"name\":\"JiraIssueItemFieldItem\"},{\"name\":\"JiraIssueItemPanelItem\"},{\"name\":\"JiraIssueItemGroupContainer\"},{\"name\":\"JiraIssueItemTabContainer\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemContainersResult\",\"possibleTypes\":[{\"name\":\"JiraIssueItemContainers\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemGroupContainerItem\",\"possibleTypes\":[{\"name\":\"JiraIssueItemFieldItem\"},{\"name\":\"JiraIssueItemPanelItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemTabContainerItem\",\"possibleTypes\":[{\"name\":\"JiraIssueItemFieldItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayout\",\"possibleTypes\":[{\"name\":\"JiraDefaultIssueLayout\"},{\"name\":\"JiraIssueCreateLayout\"},{\"name\":\"JiraLegacyIssueLayout\"},{\"name\":\"JsdDefaultIssueLayout\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutConfiguration\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutConfigurationResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutFieldConfigurationHiddenIn\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutFieldConfigurationHiddenInGlobal\"},{\"name\":\"JiraIssueLayoutFieldConfigurationHiddenInLayoutOwner\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutFieldPanelItemConfiguration\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutFieldItemConfiguration\"},{\"name\":\"JiraIssueLayoutPanelItemConfiguration\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutItemConfiguration\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutContainerConfiguration\"},{\"name\":\"JiraIssueLayoutFieldItemConfiguration\"},{\"name\":\"JiraIssueLayoutGroupContainerConfiguration\"},{\"name\":\"JiraIssueLayoutTabContainerConfiguration\"},{\"name\":\"JiraIssueLayoutPanelItemConfiguration\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutOwner\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutIssueTypeOwner\"},{\"name\":\"JiraIssueLayoutRequestTypeOwner\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutOwners\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutOwnersResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueResult\",\"possibleTypes\":[{\"name\":\"JiraIssue\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchByFilterResult\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchByFilter\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchByJqlResult\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchByJql\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchError\",\"possibleTypes\":[{\"name\":\"JiraInvalidJqlError\"},{\"name\":\"JiraInvalidSyntaxError\"},{\"name\":\"JiraServerError\"},{\"name\":\"JiraCustomIssueSearchError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchViewResult\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJQLGenerationError\",\"possibleTypes\":[{\"name\":\"JiraInvalidJqlError\"},{\"name\":\"JiraInvalidSyntaxError\"},{\"name\":\"JiraServerError\"},{\"name\":\"JiraUIExposedError\"},{\"name\":\"JiraUsageLimitExceededError\"},{\"name\":\"JiraUnsupportedLanguageError\"},{\"name\":\"JiraGeneratedJqlInvalidError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJourneyParentIssueValueType\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementRequestType\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlFieldConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraJqlFieldConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlHydratedQueryResult\",\"possibleTypes\":[{\"name\":\"JiraJqlHydratedQuery\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlQueryHydratedFieldResult\",\"possibleTypes\":[{\"name\":\"JiraJqlQueryHydratedField\"},{\"name\":\"JiraJqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlQueryHydratedValueResult\",\"possibleTypes\":[{\"name\":\"JiraJqlQueryHydratedValue\"},{\"name\":\"JiraJqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraMediaUploadTokenResult\",\"possibleTypes\":[{\"name\":\"JiraMediaUploadToken\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraNavigationItemResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementSavedView\"},{\"name\":\"JiraSoftwareBuiltInNavigationItem\"},{\"name\":\"JiraAppNavigationItem\"},{\"name\":\"JiraShortcutNavigationItem\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraOnSuggestedChildIssueResult\",\"possibleTypes\":[{\"name\":\"JiraSuggestedIssue\"},{\"name\":\"JiraSuggestedChildIssueStatus\"},{\"name\":\"JiraSuggestedChildIssueError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraOverviewPlanMigrationStateResult\",\"possibleTypes\":[{\"name\":\"JiraOverviewPlanMigrationState\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraPermissionSchemeViewResult\",\"possibleTypes\":[{\"name\":\"JiraPermissionSchemeView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectConfiguration\",\"possibleTypes\":[{\"name\":\"JiraProjectConfigurationResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectNavigationMetadata\",\"possibleTypes\":[{\"name\":\"JiraSoftwareProjectNavigationMetadata\"},{\"name\":\"JiraServiceManagementProjectNavigationMetadata\"},{\"name\":\"JiraWorkManagementProjectNavigationMetadata\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectsUsingField\",\"possibleTypes\":[{\"name\":\"JiraProjectsUsingFieldResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraRemoteIssueLink\",\"possibleTypes\":[{\"name\":\"JiraIssueRemoteIssueLink\"},{\"name\":\"JiraConfluenceRemoteIssueLink\"},{\"name\":\"JiraWebRemoteIssueLink\"},{\"name\":\"JiraCustomRemoteIssueLink\"}]},{\"kind\":\"UNION\",\"name\":\"JiraSearchableEntity\",\"possibleTypes\":[{\"name\":\"JiraProject\"},{\"name\":\"JiraSystemFilter\"},{\"name\":\"JiraCustomFilter\"},{\"name\":\"JiraBoard\"},{\"name\":\"JiraDashboard\"},{\"name\":\"JiraIssue\"},{\"name\":\"JiraServiceManagementQueue\"},{\"name\":\"JiraPlan\"}]},{\"kind\":\"UNION\",\"name\":\"JiraSectionLayoutItem\",\"possibleTypes\":[{\"name\":\"JiraGroupLayout\"},{\"name\":\"JiraTabLayout\"},{\"name\":\"JiraFieldLayoutItem\"},{\"name\":\"JiraEcosystemLayoutItem\"},{\"name\":\"JiraForgeLayoutItem\"},{\"name\":\"JiraPanelLayoutItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementApproverPrincipal\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementUserApproverPrincipal\"},{\"name\":\"JiraServiceManagementGroupApproverPrincipal\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementEntitledEntity\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementEntitlementCustomer\"},{\"name\":\"JiraServiceManagementEntitlementOrganization\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementRequestTypePreviewField\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementTextPreviewField\"},{\"name\":\"JiraServiceManagementTextAreaPreviewField\"},{\"name\":\"JiraServiceManagementDueDatePreviewField\"},{\"name\":\"JiraServiceManagementDatePreviewField\"},{\"name\":\"JiraServiceManagementDateTimePreviewField\"},{\"name\":\"JiraServiceManagementAttachmentPreviewField\"},{\"name\":\"JiraServiceManagementSelectPreviewField\"},{\"name\":\"JiraServiceManagementMultiSelectPreviewField\"},{\"name\":\"JiraServiceManagementMultiUserPickerPreviewField\"},{\"name\":\"JiraServiceManagementMultiServicePickerPreviewField\"},{\"name\":\"JiraServiceManagementMultiCheckboxesPreviewField\"},{\"name\":\"JiraServiceManagementPeoplePreviewField\"},{\"name\":\"JiraServiceManagementUnknownPreviewField\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementResponder\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementUserResponder\"},{\"name\":\"JiraServiceManagementTeamResponder\"}]},{\"kind\":\"UNION\",\"name\":\"JiraShareableEntityEditGrant\",\"possibleTypes\":[{\"name\":\"JiraShareableEntityGroupGrant\"},{\"name\":\"JiraShareableEntityProjectRoleGrant\"},{\"name\":\"JiraShareableEntityUserGrant\"},{\"name\":\"JiraShareableEntityProjectGrant\"},{\"name\":\"JiraShareableEntityUnknownProjectGrant\"}]},{\"kind\":\"UNION\",\"name\":\"JiraShareableEntityShareGrant\",\"possibleTypes\":[{\"name\":\"JiraShareableEntityGroupGrant\"},{\"name\":\"JiraShareableEntityProjectRoleGrant\"},{\"name\":\"JiraShareableEntityProjectGrant\"},{\"name\":\"JiraShareableEntityAnonymousAccessGrant\"},{\"name\":\"JiraShareableEntityAnyLoggedInUserGrant\"},{\"name\":\"JiraShareableEntityUnknownProjectGrant\"},{\"name\":\"JiraShareableEntityUserGrant\"}]},{\"kind\":\"UNION\",\"name\":\"JiraSpreadsheetGroupFieldValue\",\"possibleTypes\":[{\"name\":\"AtlassianAccountUser\"},{\"name\":\"JiraOption\"},{\"name\":\"JiraStatus\"},{\"name\":\"JiraPriority\"},{\"name\":\"JiraStoryPoint\"},{\"name\":\"JiraGoal\"}]},{\"kind\":\"UNION\",\"name\":\"JiraUnsplashImageSearchPageResult\",\"possibleTypes\":[{\"name\":\"JiraUnsplashImageSearchPage\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraVersionConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraVersionConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraVersionResult\",\"possibleTypes\":[{\"name\":\"JiraVersion\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementActiveBackgroundDetailsResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementColorBackground\"},{\"name\":\"JiraWorkManagementGradientBackground\"},{\"name\":\"JiraWorkManagementMediaBackground\"},{\"name\":\"JiraWorkManagementAttachmentBackground\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementBackgroundUploadTokenResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementBackgroundUploadToken\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementCategoryOptionConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementCategoryOptionConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementFieldConfigurationConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementFieldConfigurationConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementFilterConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementFilterConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementGiraOverviewResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementGiraOverview\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementSavedViewResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementSavedView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementViewItemConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementViewItemConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlFieldConnectionResult\",\"possibleTypes\":[{\"name\":\"JqlFieldConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlHydratedQueryResult\",\"possibleTypes\":[{\"name\":\"JqlHydratedQuery\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlQueryHydratedFieldResult\",\"possibleTypes\":[{\"name\":\"JqlQueryHydratedField\"},{\"name\":\"JqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlQueryHydratedValueResult\",\"possibleTypes\":[{\"name\":\"JqlQueryHydratedValue\"},{\"name\":\"JqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"LayoutDefiner\",\"possibleTypes\":[{\"name\":\"FieldLayoutScreen\"},{\"name\":\"JiraRequestType\"}]},{\"kind\":\"UNION\",\"name\":\"MediaUploadTokenUnion\",\"possibleTypes\":[{\"name\":\"MediaUploadToken\"},{\"name\":\"FailedMediaUploadToken\"}]},{\"kind\":\"UNION\",\"name\":\"MergedFieldUnion\",\"possibleTypes\":[{\"name\":\"IssueTypeField\"},{\"name\":\"StatusField\"}]},{\"kind\":\"UNION\",\"name\":\"ProjectCategoryGadgetUnion\",\"possibleTypes\":[{\"name\":\"ProjectsGadgetItem\"},{\"name\":\"CategoriesGadgetItem\"}]},{\"kind\":\"UNION\",\"name\":\"RemoteIssueDetailsUnion\",\"possibleTypes\":[{\"name\":\"AssociatedIssueWrapper\"},{\"name\":\"FailedRemoteIssue\"}]},{\"kind\":\"UNION\",\"name\":\"SectionItem\",\"possibleTypes\":[{\"name\":\"GroupLayout\"},{\"name\":\"TabLayout\"},{\"name\":\"FieldSectionItem\"},{\"name\":\"EcosystemSectionItem\"},{\"name\":\"ForgeSectionItem\"},{\"name\":\"PanelSectionItem\"}]},{\"kind\":\"UNION\",\"name\":\"TimeSeriesChartAdditionalPropertiesUnion\",\"possibleTypes\":[{\"name\":\"CreatedVsResolvedProperties\"}]}]}}");
});
parcelRegister("9g713", function(module, exports) {
    $parcel$export(module.exports, "getErrorAnalyticsContext", ()=>$a87e716199660ede$export$bd030713895ed5e2);
    $parcel$export(module.exports, "reportErrors", ()=>$a87e716199660ede$export$a78ebe1911f50d41);
    var $9XE6b = parcelRequire("9XE6b");
    var $e3a3O;
    var $jcw0u;
    const $a87e716199660ede$export$15d632fe38832073 = 'giraErrorAnalytics';
    const $a87e716199660ede$export$fc6a71db0f9a33f9 = (errorAnalytics, context = {})=>({
            ...context,
            [$a87e716199660ede$export$15d632fe38832073]: errorAnalytics
        });
    const $a87e716199660ede$export$bd030713895ed5e2 = (context)=>{
        const errorAnalytics = (0, ($parcel$interopDefault($9XE6b)))(context, [
            $a87e716199660ede$export$15d632fe38832073
        ], undefined);
        if (typeof errorAnalytics === 'object' && typeof errorAnalytics.id === 'string' && (errorAnalytics.packageName === undefined || typeof errorAnalytics.packageName === 'string') && (errorAnalytics.teamName === undefined || typeof errorAnalytics.teamName === 'string') && (errorAnalytics.attributes === undefined || typeof errorAnalytics.attributes === 'object') && (errorAnalytics.sendToPrivacyUnsafeSplunk === undefined || typeof errorAnalytics.sendToPrivacyUnsafeSplunk === 'boolean')) return {
            id: errorAnalytics.id,
            packageName: errorAnalytics.packageName,
            teamName: errorAnalytics.teamName,
            attributes: errorAnalytics.attributes,
            sendToPrivacyUnsafeSplunk: errorAnalytics.sendToPrivacyUnsafeSplunk
        };
        return undefined;
    };
    const $a87e716199660ede$export$a78ebe1911f50d41 = ({ graphQLErrors: graphQLErrors, networkError: networkError, operation: operation })=>{
        const errorAnalytics = $a87e716199660ede$export$bd030713895ed5e2(operation.getContext());
        if (graphQLErrors !== undefined && !Array.isArray(graphQLErrors)) return;
        const hasGraphQLError = graphQLErrors !== undefined && graphQLErrors.length > 0;
        const hasNetworkError = networkError !== undefined;
        if (errorAnalytics === undefined || !hasGraphQLError && !hasNetworkError) return;
        const { id: id, packageName: packageName, teamName: teamName, attributes: attributes, sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk } = errorAnalytics;
        const error = new (0, (0, parcelRequire("e3a3O")).ApolloError)({
            graphQLErrors: graphQLErrors ? [
                ...graphQLErrors
            ] : undefined,
            networkError: networkError
        });
        const attributesWithOperationName = {
            ...attributes,
            operationName: operation.operationName,
            hasGraphQLError: hasGraphQLError,
            hasNetworkError: hasNetworkError
        };
        (0, (0, parcelRequire("jcw0u")).default)({
            error: error,
            meta: {
                id: id,
                packageName: packageName,
                teamName: teamName
            },
            attributes: attributesWithOperationName,
            sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk
        });
    };
});
parcelRegister("AeWM3", function(module, exports) {
    $parcel$export(module.exports, "resetCache", ()=>$63ae5caf575c2d55$export$6e5dca841bdf93e3);
    $parcel$export(module.exports, "getClient", ()=>$63ae5caf575c2d55$export$6bb76d6eba7e258c);
    $parcel$export(module.exports, "ApolloClientProvider", ()=>$63ae5caf575c2d55$export$8e363dbef886ff17);
    var $5uXOq = parcelRequire("5uXOq");
    var $9XE6b = parcelRequire("9XE6b");
    var $bvsgq;
    var $9OXo1;
    const $63ae5caf575c2d55$var$CLIENTS_CACHE = {};
    const $63ae5caf575c2d55$export$6e5dca841bdf93e3 = (clientId)=>{
        $63ae5caf575c2d55$var$CLIENTS_CACHE[clientId]?.clearStore();
        delete $63ae5caf575c2d55$var$CLIENTS_CACHE[clientId];
    };
    const $63ae5caf575c2d55$export$44dd3e9494f887fc = ()=>Object.keys($63ae5caf575c2d55$var$CLIENTS_CACHE).reduce((acc, key)=>Object.assign(acc, {
                [`apollo-cache/${key}`]: $63ae5caf575c2d55$var$CLIENTS_CACHE[key].extract()
            }), {});
    const $63ae5caf575c2d55$export$6bb76d6eba7e258c = (baseUrl, { clientId: clientId, clientCreator: clientCreator }, xsrfToken)=>{
        let client = $63ae5caf575c2d55$var$CLIENTS_CACHE[clientId];
        if (!client) {
            client = clientCreator(baseUrl, xsrfToken);
            $63ae5caf575c2d55$var$CLIENTS_CACHE[clientId] = client;
        }
        return client;
    };
    class $63ae5caf575c2d55$export$8e363dbef886ff17 extends (0, $5uXOq.Component) {
        getClient(baseUrl, xsrfToken) {
            return $63ae5caf575c2d55$export$6bb76d6eba7e258c(baseUrl, this.props.client, xsrfToken != null ? xsrfToken : undefined);
        }
        render() {
            const { children: children } = this.props;
            if (!(0, ($parcel$interopDefault($9XE6b)))(this.props, 'client.clientId')) throw new Error('Please provide a client configuration');
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9OXo1")).TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
                const client = this.getClient(tenantContext.baseUrl, tenantContext.xsrfToken);
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bvsgq")).ApolloProvider), {
                    client: client
                }, children);
            });
        }
    }
});
parcelRegister("bvsgq", function(module, exports) {
    $parcel$export(module.exports, "getApolloContext", ()=>$02296d7a3662bd2d$export$a47505d961ee3a1);
    $parcel$export(module.exports, "ApolloProvider", ()=>$02296d7a3662bd2d$export$c16b04c8a9956446);
    $parcel$export(module.exports, "DocumentType", ()=>$02296d7a3662bd2d$export$d1d99cf900472499);
    $parcel$export(module.exports, "operationName", ()=>$02296d7a3662bd2d$export$5db520940cf00715);
    $parcel$export(module.exports, "parser", ()=>$02296d7a3662bd2d$export$8f49e4af10703ce3);
    var $5uXOq = parcelRequire("5uXOq");
    var $1DiV8 = parcelRequire("1DiV8");
    var $02296d7a3662bd2d$var$apolloContext;
    function $02296d7a3662bd2d$export$a47505d961ee3a1() {
        if (!$02296d7a3662bd2d$var$apolloContext) $02296d7a3662bd2d$var$apolloContext = (0, ($parcel$interopDefault($5uXOq))).createContext({});
        return $02296d7a3662bd2d$var$apolloContext;
    }
    function $02296d7a3662bd2d$export$c2ee824bcc89ca6a() {
        $02296d7a3662bd2d$var$apolloContext = (0, ($parcel$interopDefault($5uXOq))).createContext({});
    }
    var $02296d7a3662bd2d$export$c16b04c8a9956446 = function(_a) {
        var client = _a.client, children = _a.children;
        var ApolloContext = $02296d7a3662bd2d$export$a47505d961ee3a1();
        return (0, ($parcel$interopDefault($5uXOq))).createElement(ApolloContext.Consumer, null, function(context) {
            if (context === void 0) context = {};
            if (client && context.client !== client) context = Object.assign({}, context, {
                client: client
            });
            (0, $1DiV8.invariant)(context.client, 5);
            return (0, ($parcel$interopDefault($5uXOq))).createElement(ApolloContext.Provider, {
                value: context
            }, children);
        });
    };
    var $02296d7a3662bd2d$export$ed5ceab8c2bb5ce4 = function(props) {
        var ApolloContext = $02296d7a3662bd2d$export$a47505d961ee3a1();
        return (0, ($parcel$interopDefault($5uXOq))).createElement(ApolloContext.Consumer, null, function(context) {
            (0, $1DiV8.invariant)(context && context.client, 6);
            return props.children(context.client);
        });
    };
    var $02296d7a3662bd2d$export$d1d99cf900472499;
    (function(DocumentType) {
        DocumentType[DocumentType["Query"] = 0] = "Query";
        DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
        DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
    })($02296d7a3662bd2d$export$d1d99cf900472499 || ($02296d7a3662bd2d$export$d1d99cf900472499 = {}));
    var $02296d7a3662bd2d$var$cache = new Map();
    function $02296d7a3662bd2d$export$5db520940cf00715(type) {
        var name;
        switch(type){
            case $02296d7a3662bd2d$export$d1d99cf900472499.Query:
                name = 'Query';
                break;
            case $02296d7a3662bd2d$export$d1d99cf900472499.Mutation:
                name = 'Mutation';
                break;
            case $02296d7a3662bd2d$export$d1d99cf900472499.Subscription:
                name = 'Subscription';
                break;
        }
        return name;
    }
    function $02296d7a3662bd2d$export$8f49e4af10703ce3(document) {
        var cached = $02296d7a3662bd2d$var$cache.get(document);
        if (cached) return cached;
        var variables, type, name;
        (0, $1DiV8.invariant)(!!document && !!document.kind, 1);
        var fragments = document.definitions.filter(function(x) {
            return x.kind === 'FragmentDefinition';
        });
        var queries = document.definitions.filter(function(x) {
            return x.kind === 'OperationDefinition' && x.operation === 'query';
        });
        var mutations = document.definitions.filter(function(x) {
            return x.kind === 'OperationDefinition' && x.operation === 'mutation';
        });
        var subscriptions = document.definitions.filter(function(x) {
            return x.kind === 'OperationDefinition' && x.operation === 'subscription';
        });
        (0, $1DiV8.invariant)(!fragments.length || queries.length || mutations.length || subscriptions.length, 2);
        (0, $1DiV8.invariant)(queries.length + mutations.length + subscriptions.length <= 1, 3);
        type = queries.length ? $02296d7a3662bd2d$export$d1d99cf900472499.Query : $02296d7a3662bd2d$export$d1d99cf900472499.Mutation;
        if (!queries.length && !mutations.length) type = $02296d7a3662bd2d$export$d1d99cf900472499.Subscription;
        var definitions = queries.length ? queries : mutations.length ? mutations : subscriptions;
        (0, $1DiV8.invariant)(definitions.length === 1, 4);
        var definition = definitions[0];
        variables = definition.variableDefinitions || [];
        if (definition.name && definition.name.kind === 'Name') name = definition.name.value;
        else name = 'data';
        var payload = {
            name: name,
            type: type,
            variables: variables
        };
        $02296d7a3662bd2d$var$cache.set(document, payload);
        return payload;
    }
});
parcelRegister("eiOkd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b98d0f47ed36cd9a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6Ll2T;
    var $99gde;
    var $6cG4N;
    var $bUSNl;
    var $lLfAu;
    var $aXDiy;
    const $b98d0f47ed36cd9a$var$BusinessAppWrapper = ({ children: children, className: className, header: header, sidebarTheme: sidebarTheme, shouldAddPadding: shouldAddPadding = true, withSidebar: withSidebar = false, withDynamicHeight: withDynamicHeight = false, withOverflow: withOverflow = false })=>{
        const [{ content: sidebarContent }] = (0, (0, parcelRequire("bUSNl")).useSidebar)();
        const isSidebarOpen = withSidebar && sidebarContent != null;
        let content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, header, children);
        if (withSidebar) content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lLfAu")).SidebarLayout), {
            theme: sidebarTheme
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            xcss: [
                $b98d0f47ed36cd9a$var$contentWrapperStyles,
                isSidebarOpen && $b98d0f47ed36cd9a$var$sidebarOpenContentWrapperStyles
            ]
        }, content));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aXDiy")).ThemedContainer), {
            shouldAddPadding: shouldAddPadding,
            isSidebarOpen: isSidebarOpen,
            withSidebar: withSidebar,
            withDynamicHeight: withDynamicHeight,
            withOverflow: withOverflow,
            id: (0, $c15b7ab4e654e0c4$export$e5e75ff4daca6597),
            className: className
        }, content);
    };
    const $b98d0f47ed36cd9a$var$contentWrapperStyles = (0, (0, parcelRequire("99gde")).xcss)({
        color: (0, (0, parcelRequire("6cG4N")).Tokens).COLOR_TEXT,
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
        flexShrink: 1,
        maxWidth: '100%',
        minWidth: '0',
        width: 'auto'
    });
    const $b98d0f47ed36cd9a$var$sidebarOpenContentWrapperStyles = (0, (0, parcelRequire("99gde")).xcss)({
        paddingRight: 'space.300',
        paddingBottom: 'space.300'
    });
    var $b98d0f47ed36cd9a$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($b98d0f47ed36cd9a$var$BusinessAppWrapper);
});
const $c15b7ab4e654e0c4$export$e5e75ff4daca6597 = 'jwm-container';
parcelRegister("bUSNl", function(module, exports) {
    $parcel$export(module.exports, "getSidebarQueryParams", ()=>$39fc2da09b28cabf$export$ddc11e4d41e7cf62);
    $parcel$export(module.exports, "useSidebar", ()=>$39fc2da09b28cabf$export$54c70f22f548bff8);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $hE5wF;
    var $3hGWp;
    var $dCm1o;
    var $3sQ5x;
    var $iXqE5;
    var $jnA4H;
    const $39fc2da09b28cabf$export$86880b4b2e1a2384 = 'jwm.sidebar';
    const $39fc2da09b28cabf$var$SIDEBAR_MIN_WIDTH_OLD = 360;
    const $39fc2da09b28cabf$var$SIDEBAR_MIN_WIDTH = 435;
    const $39fc2da09b28cabf$export$ddc11e4d41e7cf62 = ()=>[
            (0, (0, parcelRequire("hE5wF")).SELECTED_ISSUE_PARAM),
            (0, (0, parcelRequire("hE5wF")).SELECTED_COMMENT_PARAM)
        ];
    const $39fc2da09b28cabf$export$f4c7df452942956a = ()=>(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? $39fc2da09b28cabf$var$SIDEBAR_MIN_WIDTH : $39fc2da09b28cabf$var$SIDEBAR_MIN_WIDTH_OLD;
    const $39fc2da09b28cabf$var$setSidebarContent = (content)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                ...state,
                content: content
            });
        };
    const $39fc2da09b28cabf$var$setSidebarWidth = (width)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            const newWidth = Math.max(width, $39fc2da09b28cabf$export$f4c7df452942956a());
            if (newWidth === state.sidebarWidth) return;
            setState({
                ...state,
                sidebarWidth: newWidth
            });
            (0, (0, parcelRequire("jnA4H")).localStorage).set($39fc2da09b28cabf$export$86880b4b2e1a2384, newWidth);
        };
    const $39fc2da09b28cabf$var$setSidebarOnClose = (onSidebarClose)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                ...state,
                onSidebarClose: onSidebarClose
            });
        };
    const $39fc2da09b28cabf$var$closeSidebar = ()=>({ setState: setState, getState: getState })=>{
            const state = getState();
            state.onSidebarClose();
            setState({
                ...state,
                content: null,
                onSidebarClose: (0, ($parcel$interopDefault($8Rkzz)))
            });
        };
    const $39fc2da09b28cabf$var$actions = {
        setSidebarContent: $39fc2da09b28cabf$var$setSidebarContent,
        setSidebarWidth: $39fc2da09b28cabf$var$setSidebarWidth,
        setSidebarOnClose: $39fc2da09b28cabf$var$setSidebarOnClose,
        closeSidebar: $39fc2da09b28cabf$var$closeSidebar
    };
    const $39fc2da09b28cabf$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: {
            content: null,
            sidebarWidth: (0, (0, parcelRequire("jnA4H")).localStorage).get($39fc2da09b28cabf$export$86880b4b2e1a2384) || $39fc2da09b28cabf$export$f4c7df452942956a(),
            onSidebarClose: (0, ($parcel$interopDefault($8Rkzz)))
        },
        actions: $39fc2da09b28cabf$var$actions,
        name: 'JWMSidebarStore'
    });
    const $39fc2da09b28cabf$var$useHook = (0, (0, parcelRequire("3sQ5x")).createHook)($39fc2da09b28cabf$var$Store);
    const $39fc2da09b28cabf$export$54c70f22f548bff8 = ()=>{
        const [state, hookActions] = $39fc2da09b28cabf$var$useHook();
        const sidebarQueryParams = $39fc2da09b28cabf$export$ddc11e4d41e7cf62();
        const [, setQueryParams] = (0, (0, parcelRequire("3hGWp")).useQueryParams)(...sidebarQueryParams);
        const resetSidebarQueryParams = (0, $5uXOq.useCallback)(()=>{
            const newQueryParams = sidebarQueryParams.reduce((acc, param)=>Object.assign(acc, {
                    [param]: undefined
                }), {});
            setQueryParams(newQueryParams);
        }, [
            setQueryParams,
            sidebarQueryParams
        ]);
        return [
            state,
            {
                ...hookActions,
                resetSidebarQueryParams: resetSidebarQueryParams
            }
        ];
    };
});
parcelRegister("jnA4H", function(module, exports) {
    $parcel$export(module.exports, "localStorage", ()=>$301038d04a64b539$export$c2ed3351cac403d1);
    var $bSSG7;
    const $301038d04a64b539$export$c2ed3351cac403d1 = (0, (0, parcelRequire("bSSG7")).createLocalStorageProvider)('jira_business_common');
});
parcelRegister("lLfAu", function(module, exports) {
    $parcel$export(module.exports, "SidebarLayout", ()=>$1dbab6fa0f2d1b51$export$8295a33ab8a36876);
    var $5uXOq = parcelRequire("5uXOq");
    var $6Ll2T;
    var $99gde;
    var $getxR;
    var $He4jn;
    var $bUSNl;
    var $eHSp3;
    const $1dbab6fa0f2d1b51$var$Sidebar = ({ children: children, sidebarWidth: sidebarWidth, theme: theme })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            xcss: [
                $1dbab6fa0f2d1b51$var$sidebarStyles,
                theme === 'business' && $1dbab6fa0f2d1b51$var$businessSidebarStyles
            ],
            style: {
                width: sidebarWidth
            }
        }, children);
    const $1dbab6fa0f2d1b51$export$8295a33ab8a36876 = ({ children: children, theme: theme = 'business' })=>{
        (0, (0, parcelRequire("getxR")).useSidebarQueryParams)();
        const [{ content: content, sidebarWidth: sidebarWidth }, { setSidebarContent: setSidebarContent }] = (0, (0, parcelRequire("bUSNl")).useSidebar)();
        const { onMouseDown: onMouseDown, isResizing: isResizing } = (0, (0, parcelRequire("He4jn")).useResizer)();
        (0, $5uXOq.useEffect)(()=>()=>{
                setSidebarContent(null);
            }, [
            setSidebarContent
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eHSp3")).Wrapper), {
            isResizing: isResizing,
            "data-testid": "business-app-wrapper.ui.app-wrapper.sidebar-layout.sidebar-layout-wrapper"
        }, children, content && (0, ($parcel$interopDefault($5uXOq))).createElement($1dbab6fa0f2d1b51$var$Sidebar, {
            sidebarWidth: sidebarWidth,
            theme: theme
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eHSp3")).ResizeHandle), {
            onMouseDown: onMouseDown
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eHSp3")).SidebarContent), null, content)));
    };
    const $1dbab6fa0f2d1b51$var$sidebarStyles = (0, (0, parcelRequire("99gde")).xcss)({
        backgroundColor: 'elevation.surface',
        flexGrow: 0,
        flexShrink: 0,
        position: 'relative',
        zIndex: 'card',
        maxWidth: '75%'
    });
    const $1dbab6fa0f2d1b51$var$businessSidebarStyles = (0, (0, parcelRequire("99gde")).xcss)({
        borderTopLeftRadius: 'border.radius.200',
        borderTopRightRadius: 'border.radius.200',
        boxShadow: 'elevation.shadow.overlay',
        marginRight: 'space.300',
        marginTop: 'space.300'
    });
});
parcelRegister("getxR", function(module, exports) {
    $parcel$export(module.exports, "useSidebarQueryParams", ()=>$7ddee5a34b903b90$export$34adbeffbeceba68);
    var $5uXOq = parcelRequire("5uXOq");
    var $hE5wF;
    var $4R6GH;
    var $1XJ20;
    var $8zOmE;
    var $lwMsT;
    var $3hGWp;
    var $bUSNl;
    const $7ddee5a34b903b90$var$isEscapeEvent = (e)=>e.key === 'Escape' || e.key === 'Esc' || e.keyCode === 27;
    const $7ddee5a34b903b90$export$34adbeffbeceba68 = ()=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const [{ content: content }, { setSidebarContent: setSidebarContent, resetSidebarQueryParams: resetSidebarQueryParams }] = (0, (0, parcelRequire("bUSNl")).useSidebar)();
        const sidebarQueryParams = (0, (0, parcelRequire("bUSNl")).getSidebarQueryParams)();
        const [queryParams, setQueryParams] = (0, (0, parcelRequire("3hGWp")).useQueryParams)(...sidebarQueryParams);
        const prevQueryParams = (0, (0, parcelRequire("1XJ20")).usePreviousWithInitial)(queryParams);
        const closeSidebar = (0, $5uXOq.useCallback)(()=>{
            resetSidebarQueryParams();
            setSidebarContent(null);
        }, [
            resetSidebarQueryParams,
            setSidebarContent
        ]);
        (0, $5uXOq.useEffect)(()=>{
            sidebarQueryParams.forEach((queryParam)=>{
                if (!prevQueryParams[queryParam] && queryParams[queryParam]) {
                    const newQueryParams = sidebarQueryParams.filter((param)=>param !== queryParam).reduce((acc, param)=>Object.assign(acc, {
                            [param]: undefined
                        }), {});
                    setQueryParams(newQueryParams);
                }
            });
        }, [
            prevQueryParams,
            queryParams,
            setQueryParams,
            sidebarQueryParams
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const handleKeydown = (event)=>{
                if (!queryParams[0, (0, parcelRequire("hE5wF")).SELECTED_ISSUE_PARAM] && (0, (0, parcelRequire("4R6GH")).fg)('jira_list_keyboard_nav')) return;
                if (queryParams[0, (0, parcelRequire("hE5wF")).SELECTED_ISSUE_PARAM] && content?.key === 'unscheduledSidebar') return;
                if ($7ddee5a34b903b90$var$isEscapeEvent(event)) {
                    (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'sidebar closed', 'esc');
                    closeSidebar();
                }
            };
            typeof document !== 'undefined' && document.addEventListener('keydown', handleKeydown);
            return ()=>{
                typeof document !== 'undefined' && document.removeEventListener('keydown', handleKeydown);
            };
        }, [
            closeSidebar,
            content?.key,
            createAnalyticsEvent,
            queryParams
        ]);
    };
});
parcelRegister("He4jn", function(module, exports) {
    $parcel$export(module.exports, "useResizer", ()=>$80d7a99fb39f1e91$export$faede3f1542958fc);
    var $5uXOq = parcelRequire("5uXOq");
    var $34ck9 = parcelRequire("34ck9");
    var $bUSNl;
    const $80d7a99fb39f1e91$var$THROTTLE_TIME = 16;
    const $80d7a99fb39f1e91$export$faede3f1542958fc = ()=>{
        const [{ sidebarWidth: sidebarWidth }, { setSidebarWidth: setSidebarWidth }] = (0, (0, parcelRequire("bUSNl")).useSidebar)();
        const startRef = (0, $5uXOq.useRef)(0);
        const width = (0, $5uXOq.useRef)(0);
        const [isResizing, setIsResizing] = (0, $5uXOq.useState)(false);
        const resize = (0, $5uXOq.useCallback)((0, ($parcel$interopDefault($34ck9)))((clientX)=>{
            const proposedWidth = width.current + startRef.current - clientX;
            setSidebarWidth(proposedWidth);
        }, $80d7a99fb39f1e91$var$THROTTLE_TIME), [
            setSidebarWidth
        ]);
        const onMouseMove = (0, $5uXOq.useCallback)((event)=>{
            event.preventDefault();
            resize(event.clientX);
        }, [
            resize
        ]);
        const onMouseUp = (0, $5uXOq.useCallback)(()=>{
            startRef.current = 0;
            width.current = 0;
            setIsResizing(false);
            document.removeEventListener('mousemove', onMouseMove);
            document.removeEventListener('mouseup', onMouseUp);
        }, [
            onMouseMove
        ]);
        (0, $5uXOq.useEffect)(()=>()=>{
                document.removeEventListener('mousemove', onMouseMove);
                document.removeEventListener('mouseup', onMouseUp);
            }, [
            onMouseMove,
            onMouseUp
        ]);
        const onMouseDown = (0, $5uXOq.useCallback)((event)=>{
            startRef.current = event.clientX;
            width.current = sidebarWidth;
            setIsResizing(true);
            document.addEventListener('mousemove', onMouseMove);
            document.addEventListener('mouseup', onMouseUp);
        }, [
            onMouseMove,
            onMouseUp,
            sidebarWidth
        ]);
        return {
            onMouseDown: onMouseDown,
            onMouseUp: onMouseUp,
            onMouseMove: onMouseMove,
            isResizing: isResizing
        };
    };
});
parcelRegister("eHSp3", function(module, exports) {
    $parcel$export(module.exports, "Wrapper", ()=>$71d20039839e60ab$export$e6dfd72ab29f8598);
    $parcel$export(module.exports, "SidebarContent", ()=>$71d20039839e60ab$export$49e8f7b58a4df4ea);
    $parcel$export(module.exports, "ResizeHandle", ()=>$71d20039839e60ab$export$33f2411a0ad35be7);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $71d20039839e60ab$export$e6dfd72ab29f8598 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isResizing: isResizing, ...__cmpldp } = __cmplp;
        return $5uXOq.createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _4cvr1fhb _4t3i1osq",
                __cmplp.isResizing ? "_80omuf7j" : "_80om73ad",
                __cmplp.className
            ])
        });
    });
    const $71d20039839e60ab$export$49e8f7b58a4df4ea = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18m91wug _13wustnw _1igsidpf _184nidpf _bhl91osq _1j101bpf _134m1txw _sojr1h6o",
                __cmplp.className
            ])
        });
    });
    const $71d20039839e60ab$export$33f2411a0ad35be7 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bsb1tcg _80omuf7j _kqswh2mm _1wpz1fhb _1pbybfng _1ltvxmi2 _4t3i1osq _aetrb3bt _16r2glyw _qc5othzt _18postnw _z0aiyh40 _15l2idpf _19doutpp _1qdg1osq _1jju194a _5u1r194a",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("aXDiy", function(module, exports) {
    $parcel$export(module.exports, "ThemedContainer", ()=>$0d3cb0cba7f538e9$export$2a4209ec8a7db359);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $0d3cb0cba7f538e9$export$2a4209ec8a7db359 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { withSidebar: withSidebar, withDynamicHeight: withDynamicHeight, shouldAddPadding: shouldAddPadding, isSidebarOpen: isSidebarOpen, withOverflow: withOverflow, ...__cmpldp } = __cmplp;
        return $5uXOq.createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_vchhusvi _1e0c1txw _2lx21bp4 _1n261q9c _1bah1y6m _ca0qidpf",
                !__cmplp.withSidebar && "_syazfrbu",
                __cmplp.withDynamicHeight ? "_4t3i1wug" : "_4t3i1osq",
                __cmplp.withDynamicHeight ? "_1tke1osq" : "_1tke1wug",
                !__cmplp.shouldAddPadding || __cmplp.isSidebarOpen ? "_u5f3idpf" : "_u5f31ejb",
                !__cmplp.shouldAddPadding || __cmplp.isSidebarOpen ? "_n3tdidpf" : "_n3td1ejb",
                __cmplp.shouldAddPadding ? "_19bv1ejb" : "_19bvidpf",
                __cmplp.withOverflow ? "_1reo1wug _18m91wug" : "_1reoewfl _18m9ewfl",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("adJfs", function(module, exports) {
    $parcel$export(module.exports, "IssueTypesAndFieldsContext", ()=>$1c25c33c14b14fda$export$31eaf35dc72d0fa0);
    var $5uXOq = parcelRequire("5uXOq");
    var $5tTFS;
    var $8zOmE;
    var $lwMsT;
    var $1T2vX;
    const $1c25c33c14b14fda$var$noop = ()=>{};
    const $1c25c33c14b14fda$var$TRACKING_TIMEOUT = 1000;
    const $1c25c33c14b14fda$export$31eaf35dc72d0fa0 = ({ children: children })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const client = (0, (0, parcelRequire("5tTFS")).useApolloClient)();
        const IssueTypesAndFieldsViewContextProps = (0, (0, parcelRequire("1T2vX")).useIssueTypesAndFieldsService)({
            issueOperation: 'VIEW'
        });
        const IssueTypesAndFieldsCreateContextProps = (0, (0, parcelRequire("1T2vX")).useIssueTypesAndFieldsService)({
            issueOperation: 'CREATE'
        });
        const loading = IssueTypesAndFieldsViewContextProps.loading || IssueTypesAndFieldsCreateContextProps.loading;
        (0, $5uXOq.useEffect)(()=>{
            if (loading) return $1c25c33c14b14fda$var$noop;
            const timeoutId = setTimeout(()=>{
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'apolloCacheWatches created', {
                    watches: client?.cache?.watches?.size
                });
            }, $1c25c33c14b14fda$var$TRACKING_TIMEOUT);
            return ()=>{
                if (timeoutId) clearTimeout(timeoutId);
            };
        }, [
            createAnalyticsEvent,
            loading
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1T2vX")).IssueTypesAndFieldsContextView).Provider, {
            value: IssueTypesAndFieldsViewContextProps
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1T2vX")).IssueTypesAndFieldsContextCreate).Provider, {
            value: IssueTypesAndFieldsCreateContextProps
        }, children));
    };
});
parcelRegister("5tTFS", function(module, exports) {
    $parcel$export(module.exports, "useQuery", ()=>$3fdad8fd02cd9507$export$dd0a697e1782aedd);
    $parcel$export(module.exports, "useLazyQuery", ()=>$3fdad8fd02cd9507$export$fd83eea6ecd2d8fa);
    $parcel$export(module.exports, "useMutation", ()=>$3fdad8fd02cd9507$export$609860bf8b0084c);
    $parcel$export(module.exports, "useApolloClient", ()=>$3fdad8fd02cd9507$export$eb9a56e7a29e494);
    var $bvsgq;
    var $3VFsf;
    var $5uXOq = parcelRequire("5uXOq");
    var $e3a3O;
    var $bqMzA = parcelRequire("bqMzA");
    var $1DiV8 = parcelRequire("1DiV8");
    var $3fdad8fd02cd9507$var$OperationData = function() {
        function OperationData(options, context) {
            this.isMounted = false;
            this.previousOptions = {};
            this.context = {};
            this.options = {};
            this.options = options || {};
            this.context = context || {};
        }
        OperationData.prototype.getOptions = function() {
            return this.options;
        };
        OperationData.prototype.setOptions = function(newOptions, storePrevious) {
            if (storePrevious === void 0) storePrevious = false;
            if (storePrevious && !(0, $bqMzA.equal)(this.options, newOptions)) this.previousOptions = this.options;
            this.options = newOptions;
        };
        OperationData.prototype.unmount = function() {
            this.isMounted = false;
        };
        OperationData.prototype.refreshClient = function() {
            var client = this.options && this.options.client || this.context && this.context.client;
            (0, $1DiV8.invariant)(!!client, 2);
            var isNew = false;
            if (client !== this.client) {
                isNew = true;
                this.client = client;
                this.cleanup();
            }
            return {
                client: this.client,
                isNew: isNew
            };
        };
        OperationData.prototype.verifyDocumentType = function(document, type) {
            var operation = (0, (0, parcelRequire("bvsgq")).parser)(document);
            var requiredOperationName = (0, (0, parcelRequire("bvsgq")).operationName)(type);
            var usedOperationName = (0, (0, parcelRequire("bvsgq")).operationName)(operation.type);
            (0, $1DiV8.invariant)(operation.type === type, 3);
        };
        return OperationData;
    }();
    var $3fdad8fd02cd9507$var$QueryData = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(QueryData, _super);
        function QueryData(_a) {
            var options = _a.options, context = _a.context, forceUpdate = _a.forceUpdate;
            var _this = _super.call(this, options, context) || this;
            _this.previousData = {};
            _this.currentObservable = {};
            _this.runLazy = false;
            _this.runLazyQuery = function(options) {
                _this.cleanup();
                _this.runLazy = true;
                _this.lazyOptions = options;
                _this.forceUpdate();
            };
            _this.getExecuteResult = function() {
                var result = _this.getQueryResult();
                _this.startQuerySubscription();
                return result;
            };
            _this.obsRefetch = function(variables) {
                return _this.currentObservable.query.refetch(variables);
            };
            _this.obsFetchMore = function(fetchMoreOptions) {
                return _this.currentObservable.query.fetchMore(fetchMoreOptions);
            };
            _this.obsUpdateQuery = function(mapFn) {
                return _this.currentObservable.query.updateQuery(mapFn);
            };
            _this.obsStartPolling = function(pollInterval) {
                _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.startPolling(pollInterval);
            };
            _this.obsStopPolling = function() {
                _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.stopPolling();
            };
            _this.obsSubscribeToMore = function(options) {
                return _this.currentObservable.query.subscribeToMore(options);
            };
            _this.forceUpdate = forceUpdate;
            return _this;
        }
        QueryData.prototype.execute = function() {
            this.refreshClient();
            var _a = this.getOptions(), skip = _a.skip, query = _a.query;
            if (skip || query !== this.previousData.query) {
                this.removeQuerySubscription();
                this.previousData.query = query;
            }
            this.updateObservableQuery();
            if (this.isMounted) this.startQuerySubscription();
            return this.getExecuteSsrResult() || this.getExecuteResult();
        };
        QueryData.prototype.executeLazy = function() {
            return !this.runLazy ? [
                this.runLazyQuery,
                {
                    loading: false,
                    networkStatus: (0, (0, parcelRequire("e3a3O")).NetworkStatus).ready,
                    called: false,
                    data: undefined
                }
            ] : [
                this.runLazyQuery,
                this.execute()
            ];
        };
        QueryData.prototype.fetchData = function() {
            var options = this.getOptions();
            if (options.skip || options.ssr === false) return false;
            var obs = this.currentObservable.query;
            var currentResult = obs.getCurrentResult();
            return currentResult.loading ? obs.result() : false;
        };
        QueryData.prototype.afterExecute = function(_a) {
            var _this = this;
            var _b = (_a === void 0 ? {} : _a).lazy, lazy = _b === void 0 ? false : _b;
            this.isMounted = true;
            if (!lazy || this.runLazy) {
                this.handleErrorOrCompleted();
                setTimeout(function() {
                    _this.currentObservable.query && _this.currentObservable.query.resetQueryStoreErrors();
                });
            }
            this.previousOptions = this.getOptions();
            return this.unmount.bind(this);
        };
        QueryData.prototype.cleanup = function() {
            this.removeQuerySubscription();
            delete this.currentObservable.query;
            delete this.previousData.result;
        };
        QueryData.prototype.getOptions = function() {
            var options = _super.prototype.getOptions.call(this);
            if (this.lazyOptions) {
                options.variables = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, options.variables), this.lazyOptions.variables);
                options.context = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, options.context), this.lazyOptions.context);
            }
            if (this.runLazy) delete options.skip;
            return options;
        };
        QueryData.prototype.getExecuteSsrResult = function() {
            var treeRenderingInitiated = this.context && this.context.renderPromises;
            var ssrDisabled = this.getOptions().ssr === false;
            var fetchDisabled = this.refreshClient().client.disableNetworkFetches;
            var ssrLoading = {
                loading: true,
                networkStatus: (0, (0, parcelRequire("e3a3O")).NetworkStatus).loading,
                called: true,
                data: undefined
            };
            if (ssrDisabled && (treeRenderingInitiated || fetchDisabled)) return ssrLoading;
            var result;
            if (treeRenderingInitiated) result = this.context.renderPromises.addQueryPromise(this, this.getExecuteResult) || ssrLoading;
            return result;
        };
        QueryData.prototype.prepareObservableQueryOptions = function() {
            var options = this.getOptions();
            this.verifyDocumentType(options.query, (0, (0, parcelRequire("bvsgq")).DocumentType).Query);
            var displayName = options.displayName || 'Query';
            if (this.context && this.context.renderPromises && (options.fetchPolicy === 'network-only' || options.fetchPolicy === 'cache-and-network')) options.fetchPolicy = 'cache-first';
            return (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, options), {
                displayName: displayName,
                context: options.context,
                metadata: {
                    reactComponent: {
                        displayName: displayName
                    }
                }
            });
        };
        QueryData.prototype.initializeObservableQuery = function() {
            if (this.context && this.context.renderPromises) this.currentObservable.query = this.context.renderPromises.getSSRObservable(this.getOptions());
            if (!this.currentObservable.query) {
                var observableQueryOptions = this.prepareObservableQueryOptions();
                this.previousData.observableQueryOptions = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, observableQueryOptions), {
                    children: null
                });
                this.currentObservable.query = this.refreshClient().client.watchQuery((0, (0, parcelRequire("3VFsf")).__assign)({}, observableQueryOptions));
                if (this.context && this.context.renderPromises) this.context.renderPromises.registerSSRObservable(this.currentObservable.query, observableQueryOptions);
            }
        };
        QueryData.prototype.updateObservableQuery = function() {
            if (!this.currentObservable.query) {
                this.initializeObservableQuery();
                return;
            }
            var newObservableQueryOptions = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, this.prepareObservableQueryOptions()), {
                children: null
            });
            if (!(0, $bqMzA.equal)(newObservableQueryOptions, this.previousData.observableQueryOptions)) {
                this.previousData.observableQueryOptions = newObservableQueryOptions;
                this.currentObservable.query.setOptions(newObservableQueryOptions).catch(function() {});
            }
        };
        QueryData.prototype.startQuerySubscription = function() {
            var _this = this;
            if (this.currentObservable.subscription || this.getOptions().skip) return;
            var obsQuery = this.currentObservable.query;
            this.currentObservable.subscription = obsQuery.subscribe({
                next: function(_a) {
                    var loading = _a.loading, networkStatus = _a.networkStatus, data = _a.data;
                    var previousResult = _this.previousData.result;
                    if (previousResult && previousResult.loading === loading && previousResult.networkStatus === networkStatus && (0, $bqMzA.equal)(previousResult.data, data)) return;
                    _this.forceUpdate();
                },
                error: function(error) {
                    _this.resubscribeToQuery();
                    if (!error.hasOwnProperty('graphQLErrors')) throw error;
                    var previousResult = _this.previousData.result;
                    if (previousResult && previousResult.loading || !(0, $bqMzA.equal)(error, _this.previousData.error)) {
                        _this.previousData.error = error;
                        _this.forceUpdate();
                    }
                }
            });
        };
        QueryData.prototype.resubscribeToQuery = function() {
            this.removeQuerySubscription();
            var lastError = this.currentObservable.query.getLastError();
            var lastResult = this.currentObservable.query.getLastResult();
            this.currentObservable.query.resetLastResults();
            this.startQuerySubscription();
            Object.assign(this.currentObservable.query, {
                lastError: lastError,
                lastResult: lastResult
            });
        };
        QueryData.prototype.getQueryResult = function() {
            var result = this.observableQueryFields();
            var options = this.getOptions();
            if (options.skip) result = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, result), {
                data: undefined,
                error: undefined,
                loading: false,
                called: true
            });
            else {
                var currentResult = this.currentObservable.query.getCurrentResult();
                var loading = currentResult.loading, partial = currentResult.partial, networkStatus = currentResult.networkStatus, errors = currentResult.errors;
                var error = currentResult.error, data = currentResult.data;
                if (errors && errors.length > 0) error = new (0, (0, parcelRequire("e3a3O")).ApolloError)({
                    graphQLErrors: errors
                });
                result = (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, result), {
                    loading: loading,
                    networkStatus: networkStatus,
                    error: error,
                    called: true
                });
                if (loading) {
                    var previousData = this.previousData.result && this.previousData.result.data;
                    result.data = previousData && data ? (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, previousData), data) : previousData || data;
                } else if (error) Object.assign(result, {
                    data: (this.currentObservable.query.getLastResult() || {}).data
                });
                else {
                    var fetchPolicy = this.currentObservable.query.options.fetchPolicy;
                    var partialRefetch = options.partialRefetch;
                    if (partialRefetch && !data && partial && fetchPolicy !== 'cache-only') {
                        Object.assign(result, {
                            loading: true,
                            networkStatus: (0, (0, parcelRequire("e3a3O")).NetworkStatus).loading
                        });
                        result.refetch();
                        return result;
                    }
                    result.data = data;
                }
            }
            result.client = this.client;
            this.previousData.loading = this.previousData.result && this.previousData.result.loading || false;
            this.previousData.result = result;
            return result;
        };
        QueryData.prototype.handleErrorOrCompleted = function() {
            var obsQuery = this.currentObservable.query;
            if (!obsQuery) return;
            var _a = obsQuery.getCurrentResult(), data = _a.data, loading = _a.loading, error = _a.error;
            if (!loading) {
                var _b = this.getOptions(), query = _b.query, variables = _b.variables, onCompleted = _b.onCompleted, onError = _b.onError;
                if (this.previousOptions && !this.previousData.loading && (0, $bqMzA.equal)(this.previousOptions.query, query) && (0, $bqMzA.equal)(this.previousOptions.variables, variables)) return;
                if (onCompleted && !error) onCompleted(data);
                else if (onError && error) onError(error);
            }
        };
        QueryData.prototype.removeQuerySubscription = function() {
            if (this.currentObservable.subscription) {
                this.currentObservable.subscription.unsubscribe();
                delete this.currentObservable.subscription;
            }
        };
        QueryData.prototype.observableQueryFields = function() {
            var observable = this.currentObservable.query;
            return {
                variables: observable.variables,
                refetch: this.obsRefetch,
                fetchMore: this.obsFetchMore,
                updateQuery: this.obsUpdateQuery,
                startPolling: this.obsStartPolling,
                stopPolling: this.obsStopPolling,
                subscribeToMore: this.obsSubscribeToMore
            };
        };
        return QueryData;
    }($3fdad8fd02cd9507$var$OperationData);
    function $3fdad8fd02cd9507$var$useDeepMemo(memoFn, key) {
        var ref = (0, $5uXOq.useRef)();
        if (!ref.current || !(0, $bqMzA.equal)(key, ref.current.key)) ref.current = {
            key: key,
            value: memoFn()
        };
        return ref.current.value;
    }
    function $3fdad8fd02cd9507$var$useBaseQuery(query, options, lazy) {
        if (lazy === void 0) lazy = false;
        var context = (0, $5uXOq.useContext)((0, (0, parcelRequire("bvsgq")).getApolloContext)());
        var _a = (0, $5uXOq.useReducer)(function(x) {
            return x + 1;
        }, 0), tick = _a[0], forceUpdate = _a[1];
        var updatedOptions = options ? (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, options), {
            query: query
        }) : {
            query: query
        };
        var queryDataRef = (0, $5uXOq.useRef)();
        if (!queryDataRef.current) queryDataRef.current = new $3fdad8fd02cd9507$var$QueryData({
            options: updatedOptions,
            context: context,
            forceUpdate: forceUpdate
        });
        var queryData = queryDataRef.current;
        queryData.setOptions(updatedOptions);
        queryData.context = context;
        var memo = {
            options: (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, updatedOptions), {
                onError: undefined,
                onCompleted: undefined
            }),
            context: context,
            tick: tick
        };
        var result = $3fdad8fd02cd9507$var$useDeepMemo(function() {
            return lazy ? queryData.executeLazy() : queryData.execute();
        }, memo);
        var queryResult = lazy ? result[1] : result;
        (0, $5uXOq.useEffect)(function() {
            return queryData.afterExecute({
                lazy: lazy
            });
        }, [
            queryResult.loading,
            queryResult.networkStatus,
            queryResult.error,
            queryResult.data
        ]);
        (0, $5uXOq.useEffect)(function() {
            return function() {
                return queryData.cleanup();
            };
        }, []);
        return result;
    }
    function $3fdad8fd02cd9507$export$dd0a697e1782aedd(query, options) {
        return $3fdad8fd02cd9507$var$useBaseQuery(query, options, false);
    }
    function $3fdad8fd02cd9507$export$fd83eea6ecd2d8fa(query, options) {
        return $3fdad8fd02cd9507$var$useBaseQuery(query, options, true);
    }
    var $3fdad8fd02cd9507$var$MutationData = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(MutationData, _super);
        function MutationData(_a) {
            var options = _a.options, context = _a.context, result = _a.result, setResult = _a.setResult;
            var _this = _super.call(this, options, context) || this;
            _this.runMutation = function(mutationFunctionOptions) {
                if (mutationFunctionOptions === void 0) mutationFunctionOptions = {};
                _this.onMutationStart();
                var mutationId = _this.generateNewMutationId();
                return _this.mutate(mutationFunctionOptions).then(function(response) {
                    _this.onMutationCompleted(response, mutationId);
                    return response;
                }).catch(function(error) {
                    _this.onMutationError(error, mutationId);
                    if (!_this.getOptions().onError) throw error;
                });
            };
            _this.verifyDocumentType(options.mutation, (0, (0, parcelRequire("bvsgq")).DocumentType).Mutation);
            _this.result = result;
            _this.setResult = setResult;
            _this.mostRecentMutationId = 0;
            return _this;
        }
        MutationData.prototype.execute = function(result) {
            this.isMounted = true;
            this.verifyDocumentType(this.getOptions().mutation, (0, (0, parcelRequire("bvsgq")).DocumentType).Mutation);
            result.client = this.refreshClient().client;
            return [
                this.runMutation,
                result
            ];
        };
        MutationData.prototype.afterExecute = function() {
            this.isMounted = true;
            return this.unmount.bind(this);
        };
        MutationData.prototype.cleanup = function() {};
        MutationData.prototype.mutate = function(mutationFunctionOptions) {
            var _a = this.getOptions(), mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, update = _a.update, _b = _a.context, mutationContext = _b === void 0 ? {} : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, fetchPolicy = _a.fetchPolicy;
            var mutateOptions = (0, (0, parcelRequire("3VFsf")).__assign)({}, mutationFunctionOptions);
            var mutateVariables = Object.assign({}, variables, mutateOptions.variables);
            delete mutateOptions.variables;
            return this.refreshClient().client.mutate((0, (0, parcelRequire("3VFsf")).__assign)({
                mutation: mutation,
                optimisticResponse: optimisticResponse,
                refetchQueries: mutateOptions.refetchQueries || this.getOptions().refetchQueries,
                awaitRefetchQueries: awaitRefetchQueries,
                update: update,
                context: mutationContext,
                fetchPolicy: fetchPolicy,
                variables: mutateVariables
            }, mutateOptions));
        };
        MutationData.prototype.onMutationStart = function() {
            if (!this.result.loading && !this.getOptions().ignoreResults) this.updateResult({
                loading: true,
                error: undefined,
                data: undefined,
                called: true
            });
        };
        MutationData.prototype.onMutationCompleted = function(response, mutationId) {
            var _a = this.getOptions(), onCompleted = _a.onCompleted, ignoreResults = _a.ignoreResults;
            var data = response.data, errors = response.errors;
            var error = errors && errors.length > 0 ? new (0, (0, parcelRequire("e3a3O")).ApolloError)({
                graphQLErrors: errors
            }) : undefined;
            var callOncomplete = function() {
                return onCompleted ? onCompleted(data) : null;
            };
            if (this.isMostRecentMutation(mutationId) && !ignoreResults) this.updateResult({
                called: true,
                loading: false,
                data: data,
                error: error
            });
            callOncomplete();
        };
        MutationData.prototype.onMutationError = function(error, mutationId) {
            var onError = this.getOptions().onError;
            if (this.isMostRecentMutation(mutationId)) this.updateResult({
                loading: false,
                error: error,
                data: undefined,
                called: true
            });
            if (onError) onError(error);
        };
        MutationData.prototype.generateNewMutationId = function() {
            return ++this.mostRecentMutationId;
        };
        MutationData.prototype.isMostRecentMutation = function(mutationId) {
            return this.mostRecentMutationId === mutationId;
        };
        MutationData.prototype.updateResult = function(result) {
            if (this.isMounted && (!this.previousResult || !(0, $bqMzA.equal)(this.previousResult, result))) {
                this.setResult(result);
                this.previousResult = result;
            }
        };
        return MutationData;
    }($3fdad8fd02cd9507$var$OperationData);
    function $3fdad8fd02cd9507$export$609860bf8b0084c(mutation, options) {
        var context = (0, $5uXOq.useContext)((0, (0, parcelRequire("bvsgq")).getApolloContext)());
        var _a = (0, $5uXOq.useState)({
            called: false,
            loading: false
        }), result = _a[0], setResult = _a[1];
        var updatedOptions = options ? (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, options), {
            mutation: mutation
        }) : {
            mutation: mutation
        };
        var mutationDataRef = (0, $5uXOq.useRef)();
        function getMutationDataRef() {
            if (!mutationDataRef.current) mutationDataRef.current = new $3fdad8fd02cd9507$var$MutationData({
                options: updatedOptions,
                context: context,
                result: result,
                setResult: setResult
            });
            return mutationDataRef.current;
        }
        var mutationData = getMutationDataRef();
        mutationData.setOptions(updatedOptions);
        mutationData.context = context;
        (0, $5uXOq.useEffect)(function() {
            return mutationData.afterExecute();
        });
        return mutationData.execute(result);
    }
    var $3fdad8fd02cd9507$var$SubscriptionData = function(_super) {
        (0, (0, parcelRequire("3VFsf")).__extends)(SubscriptionData, _super);
        function SubscriptionData(_a) {
            var options = _a.options, context = _a.context, setResult = _a.setResult;
            var _this = _super.call(this, options, context) || this;
            _this.currentObservable = {};
            _this.setResult = setResult;
            _this.initialize(options);
            return _this;
        }
        SubscriptionData.prototype.execute = function(result) {
            if (this.getOptions().skip === true) {
                this.cleanup();
                return {
                    loading: false,
                    error: undefined,
                    data: undefined,
                    variables: this.getOptions().variables
                };
            }
            var currentResult = result;
            if (this.refreshClient().isNew) currentResult = this.getLoadingResult();
            var shouldResubscribe = this.getOptions().shouldResubscribe;
            if (typeof shouldResubscribe === 'function') shouldResubscribe = !!shouldResubscribe(this.getOptions());
            if (shouldResubscribe !== false && this.previousOptions && Object.keys(this.previousOptions).length > 0 && (this.previousOptions.subscription !== this.getOptions().subscription || !(0, $bqMzA.equal)(this.previousOptions.variables, this.getOptions().variables) || this.previousOptions.skip !== this.getOptions().skip)) {
                this.cleanup();
                currentResult = this.getLoadingResult();
            }
            this.initialize(this.getOptions());
            this.startSubscription();
            this.previousOptions = this.getOptions();
            return (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, currentResult), {
                variables: this.getOptions().variables
            });
        };
        SubscriptionData.prototype.afterExecute = function() {
            this.isMounted = true;
        };
        SubscriptionData.prototype.cleanup = function() {
            this.endSubscription();
            delete this.currentObservable.query;
        };
        SubscriptionData.prototype.initialize = function(options) {
            if (this.currentObservable.query || this.getOptions().skip === true) return;
            this.currentObservable.query = this.refreshClient().client.subscribe({
                query: options.subscription,
                variables: options.variables,
                fetchPolicy: options.fetchPolicy
            });
        };
        SubscriptionData.prototype.startSubscription = function() {
            if (this.currentObservable.subscription) return;
            this.currentObservable.subscription = this.currentObservable.query.subscribe({
                next: this.updateCurrentData.bind(this),
                error: this.updateError.bind(this),
                complete: this.completeSubscription.bind(this)
            });
        };
        SubscriptionData.prototype.getLoadingResult = function() {
            return {
                loading: true,
                error: undefined,
                data: undefined
            };
        };
        SubscriptionData.prototype.updateResult = function(result) {
            if (this.isMounted) this.setResult(result);
        };
        SubscriptionData.prototype.updateCurrentData = function(result) {
            var onSubscriptionData = this.getOptions().onSubscriptionData;
            this.updateResult({
                data: result.data,
                loading: false,
                error: undefined
            });
            if (onSubscriptionData) onSubscriptionData({
                client: this.refreshClient().client,
                subscriptionData: result
            });
        };
        SubscriptionData.prototype.updateError = function(error) {
            this.updateResult({
                error: error,
                loading: false
            });
        };
        SubscriptionData.prototype.completeSubscription = function() {
            var onSubscriptionComplete = this.getOptions().onSubscriptionComplete;
            if (onSubscriptionComplete) onSubscriptionComplete();
            this.endSubscription();
        };
        SubscriptionData.prototype.endSubscription = function() {
            if (this.currentObservable.subscription) {
                this.currentObservable.subscription.unsubscribe();
                delete this.currentObservable.subscription;
            }
        };
        return SubscriptionData;
    }($3fdad8fd02cd9507$var$OperationData);
    function $3fdad8fd02cd9507$export$368b4214baeb914c(subscription, options) {
        var context = (0, $5uXOq.useContext)((0, (0, parcelRequire("bvsgq")).getApolloContext)());
        var updatedOptions = options ? (0, (0, parcelRequire("3VFsf")).__assign)((0, (0, parcelRequire("3VFsf")).__assign)({}, options), {
            subscription: subscription
        }) : {
            subscription: subscription
        };
        var _a = (0, $5uXOq.useState)({
            loading: !updatedOptions.skip,
            error: undefined,
            data: undefined
        }), result = _a[0], setResult = _a[1];
        var subscriptionDataRef = (0, $5uXOq.useRef)();
        function getSubscriptionDataRef() {
            if (!subscriptionDataRef.current) subscriptionDataRef.current = new $3fdad8fd02cd9507$var$SubscriptionData({
                options: updatedOptions,
                context: context,
                setResult: setResult
            });
            return subscriptionDataRef.current;
        }
        var subscriptionData = getSubscriptionDataRef();
        subscriptionData.setOptions(updatedOptions, true);
        subscriptionData.context = context;
        (0, $5uXOq.useEffect)(function() {
            return subscriptionData.afterExecute();
        });
        (0, $5uXOq.useEffect)(function() {
            return subscriptionData.cleanup.bind(subscriptionData);
        }, []);
        return subscriptionData.execute(result);
    }
    function $3fdad8fd02cd9507$export$eb9a56e7a29e494() {
        var client = (0, ($parcel$interopDefault($5uXOq))).useContext((0, (0, parcelRequire("bvsgq")).getApolloContext)()).client;
        (0, $1DiV8.invariant)(client, 1);
        return client;
    }
    function $3fdad8fd02cd9507$var$makeDefaultQueryInfo() {
        return {
            seen: false,
            observable: null
        };
    }
    var $3fdad8fd02cd9507$export$260e90e395a79974 = function() {
        function RenderPromises() {
            this.queryPromises = new Map();
            this.queryInfoTrie = new Map();
        }
        RenderPromises.prototype.registerSSRObservable = function(observable, props) {
            this.lookupQueryInfo(props).observable = observable;
        };
        RenderPromises.prototype.getSSRObservable = function(props) {
            return this.lookupQueryInfo(props).observable;
        };
        RenderPromises.prototype.addQueryPromise = function(queryInstance, finish) {
            var info = this.lookupQueryInfo(queryInstance.getOptions());
            if (!info.seen) {
                this.queryPromises.set(queryInstance.getOptions(), new Promise(function(resolve) {
                    resolve(queryInstance.fetchData());
                }));
                return null;
            }
            return finish();
        };
        RenderPromises.prototype.hasPromises = function() {
            return this.queryPromises.size > 0;
        };
        RenderPromises.prototype.consumeAndAwaitPromises = function() {
            var _this = this;
            var promises = [];
            this.queryPromises.forEach(function(promise, queryInstance) {
                _this.lookupQueryInfo(queryInstance).seen = true;
                promises.push(promise);
            });
            this.queryPromises.clear();
            return Promise.all(promises);
        };
        RenderPromises.prototype.lookupQueryInfo = function(props) {
            var queryInfoTrie = this.queryInfoTrie;
            var query = props.query, variables = props.variables;
            var varMap = queryInfoTrie.get(query) || new Map();
            if (!queryInfoTrie.has(query)) queryInfoTrie.set(query, varMap);
            var variablesString = JSON.stringify(variables);
            var info = varMap.get(variablesString) || $3fdad8fd02cd9507$var$makeDefaultQueryInfo();
            if (!varMap.has(variablesString)) varMap.set(variablesString, info);
            return info;
        };
        return RenderPromises;
    }();
});
parcelRegister("1T2vX", function(module, exports) {
    $parcel$export(module.exports, "useIssueTypesAndFieldsService", ()=>$90cf08abf5e3ede7$export$3ef3324b7f7d6a38);
    $parcel$export(module.exports, "IssueTypesAndFieldsContextView", ()=>$90cf08abf5e3ede7$export$77937175321fab39);
    $parcel$export(module.exports, "IssueTypesAndFieldsContextCreate", ()=>$90cf08abf5e3ede7$export$fbd286e14113bfc);
    $parcel$export(module.exports, "useIssueTypesAndFields", ()=>$90cf08abf5e3ede7$export$d2121b02f0b65782);
    var $5uXOq = parcelRequire("5uXOq");
    var $5tTFS;
    var $gN11a;
    var $jcw0u;
    var $8zOmE;
    var $lwMsT;
    var $1nb22;
    var $doZTA;
    var $8Zw8m;
    var $8tTgF;
    const $90cf08abf5e3ede7$export$d7241b17c19f0a9c = 'PROJECT_NOT_FOUND';
    const $90cf08abf5e3ede7$export$4c72baf45fce4585 = 'VIEW_PROJECT_PERMISSION_ERROR';
    const $90cf08abf5e3ede7$var$isProjectPermissionError = (error)=>error.message.indexOf($90cf08abf5e3ede7$export$d7241b17c19f0a9c) > -1 || error.message.indexOf($90cf08abf5e3ede7$export$4c72baf45fce4585) > -1 || error.extensions?.statusCode === 403 || error.extensions?.statusCode === 404;
    const $90cf08abf5e3ede7$export$6b9bc8a33ade0736 = (input)=>{
        const [routerState] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const { projectKey: projectKey } = (0, (0, parcelRequire("1nb22")).getProjectKeyId)(routerState?.match, routerState?.query);
        const variables = (0, $5uXOq.useMemo)(()=>({
                projectKey: projectKey,
                issueOperation: input.issueOperation,
                first: 100
            }), [
            input.issueOperation,
            projectKey
        ]);
        const { query: query, view: view } = (0, (0, parcelRequire("8tTgF")).JWMQueryByRouteMap)?.[routerState?.route?.name] ?? (0, (0, parcelRequire("8tTgF")).JWMQueryByRouteMap)[0, (0, parcelRequire("8Zw8m")).DEFAULT];
        return (0, $5uXOq.useMemo)(()=>({
                loading: false,
                query: query,
                view: view,
                variables: variables
            }), [
            query,
            view,
            variables
        ]);
    };
    const $90cf08abf5e3ede7$export$1768f0a0f85b4de9 = (input)=>{
        const client = (0, (0, parcelRequire("5tTFS")).useApolloClient)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const { variables: queryVariables, query: query } = $90cf08abf5e3ede7$export$6b9bc8a33ade0736(input);
        const analyticsTaskName = 'useIssueTypesAndFieldsCacheApolloCacheActions';
        return (0, $5uXOq.useCallback)(({ findField: findField, updateItem: updateItem })=>{
            const getCacheData = ()=>{
                try {
                    const read = client.readQuery({
                        query: query,
                        variables: queryVariables
                    });
                    (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheRead taskSuccess', {
                        task: analyticsTaskName
                    });
                    return read;
                } catch (e) {
                    (0, (0, parcelRequire("jcw0u")).default)({
                        error: e instanceof Error ? e : new Error('Unknown cache read error'),
                        meta: {
                            id: 'useIssueTypesAndFieldsCache',
                            packageName: 'jiraBusinessEntityProject',
                            teamName: 'wanjel'
                        },
                        sendToPrivacyUnsafeSplunk: true,
                        skipSentry: true,
                        attributes: {
                            task: analyticsTaskName,
                            query: JSON.stringify(query),
                            variables: JSON.stringify(queryVariables),
                            eventName: 'apolloCacheRead taskFail',
                            error: JSON.stringify(e)
                        }
                    });
                    return null;
                }
            };
            const cacheData = getCacheData();
            const existingEdges = cacheData?.jiraBusinessAvailableFields?.edges;
            if (existingEdges == null) return;
            let shouldUpdate = false;
            const newEdges = existingEdges.map((edge)=>{
                const existingFields = edge?.node?.fields?.edges;
                if (existingFields == null) return edge;
                const itemToUpdateIndex = existingFields.findIndex((fieldEdge)=>findField ? findField(fieldEdge?.node) : false) ?? undefined;
                const existingField = existingFields[itemToUpdateIndex]?.node;
                if (itemToUpdateIndex === undefined || itemToUpdateIndex === -1 || existingField == null) return edge;
                const itemOverride = updateItem(existingField);
                if (itemOverride === undefined) return edge;
                const newFields = [
                    ...existingFields
                ];
                newFields[itemToUpdateIndex] = {
                    node: itemOverride,
                    __typename: 'JiraIssueFieldEdge'
                };
                shouldUpdate = true;
                return {
                    ...edge,
                    node: {
                        ...edge?.node || {},
                        fields: {
                            edges: newFields,
                            __typename: 'JiraIssueFieldConnection'
                        }
                    }
                };
            });
            if (!shouldUpdate) return;
            const newData = {
                ...cacheData,
                jiraBusinessAvailableFields: {
                    ...cacheData?.jiraBusinessAvailableFields || {},
                    edges: newEdges
                }
            };
            try {
                client.writeQuery({
                    query: query,
                    variables: queryVariables,
                    notifyOnNetworkStatusChange: true,
                    data: newData
                });
                (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheWrite taskSuccess', {
                    task: analyticsTaskName
                });
            } catch (e) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: e instanceof Error ? e : new Error('Unknown cache write error'),
                    meta: {
                        id: 'useIssueTypesAndFieldsCache',
                        packageName: 'jiraBusinessEntityProject',
                        teamName: 'wanjel'
                    },
                    sendToPrivacyUnsafeSplunk: true,
                    skipSentry: true,
                    attributes: {
                        task: analyticsTaskName,
                        query: JSON.stringify(query),
                        variables: JSON.stringify(queryVariables),
                        eventName: 'apolloCacheWrite taskFail',
                        error: JSON.stringify(e)
                    }
                });
            }
        }, [
            client,
            createAnalyticsEvent,
            query,
            queryVariables
        ]);
    };
    const $90cf08abf5e3ede7$export$3ef3324b7f7d6a38 = (input)=>{
        const [hasStartedFetchingFields, setHasStartedFetchingFields] = (0, $5uXOq.useState)(false);
        const fetchAttempts = (0, $5uXOq.useRef)(0);
        const { variables: queryVariables, loading: isQueryLoading, query: query, view: view } = $90cf08abf5e3ede7$export$6b9bc8a33ade0736(input);
        const [getAvailableFields, { data: data, called: called, loading: loading, error: error, refetch: refetchQuery }] = (0, (0, parcelRequire("5tTFS")).useLazyQuery)(query, {
            variables: queryVariables,
            errorPolicy: 'all',
            fetchPolicy: 'cache-first',
            onError: (apolloError)=>{
                (0, (0, parcelRequire("gN11a")).markViewMetric)(view.toLowerCase(), (0, $a286480ec63fa4c8$export$ac953882305d6102));
                if ($90cf08abf5e3ede7$var$isProjectPermissionError(apolloError)) return;
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: `availableFields${view}ViewQuery`,
                        packageName: 'jiraBusinessEntityProject',
                        teamName: 'wanjel'
                    },
                    attributes: {
                        message: `Failed to fetch available fields in ${view} view`
                    },
                    error: apolloError,
                    sendToPrivacyUnsafeSplunk: true
                });
            },
            onCompleted: (onCompletedData)=>{
                (0, (0, parcelRequire("gN11a")).markViewMetric)(view.toLowerCase(), (0, $a286480ec63fa4c8$export$ac953882305d6102));
                if (onCompletedData?.jiraBusinessAvailableFields == null) throw error || new Error('No available fields data');
                onCompletedData?.jiraBusinessAvailableFields?.edges?.forEach((e)=>{
                    const fieldEdges = e?.node?.fields?.edges;
                    if (fieldEdges == null || fieldEdges?.length === 0) {
                        const emptyMessage = fieldEdges == null ? 'null fields' : '0 length fields';
                        const emptyFieldsError = new Error(`availableFieldsAPI is returning ${emptyMessage} for issueType ${e?.node?.issueType.name ?? 'UNKNOWN'}`);
                        if (fetchAttempts.current < 1) {
                            fetchAttempts.current += 1;
                            refetch();
                        } else throw emptyFieldsError;
                    }
                });
            }
        });
        (0, $5uXOq.useEffect)(()=>{
            if (queryVariables && !hasStartedFetchingFields && !error) {
                setHasStartedFetchingFields(true);
                (0, (0, parcelRequire("gN11a")).markViewMetric)(view.toLowerCase(), (0, $a286480ec63fa4c8$export$7b887ee35f2b465e));
                getAvailableFields();
            }
        }, [
            error,
            getAvailableFields,
            hasStartedFetchingFields,
            queryVariables,
            view
        ]);
        const refetch = (0, $5uXOq.useCallback)(()=>{
            if (called && typeof refetchQuery === 'function') return refetchQuery(queryVariables);
            const err = new Error('availableFields refetch is undefined because the service has not been called yet');
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'availableFieldsRefetchIsUndefined',
                    packageName: 'jiraBusinessEntityProject',
                    teamName: 'wanjel'
                },
                error: err,
                sendToPrivacyUnsafeSplunk: true
            });
            throw err;
        }, [
            called,
            refetchQuery,
            queryVariables
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (hasStartedFetchingFields && error) setHasStartedFetchingFields(false);
        }, [
            hasStartedFetchingFields,
            error
        ]);
        const result = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("8tTgF")).transformResult)(data), [
            data
        ]);
        const typesWithFields = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("8tTgF")).transformResultToTypesWithFields)(data), [
            data
        ]);
        const hierarchyLevels = (0, $5uXOq.useMemo)(()=>result.issueTypes.map((issueType)=>({
                    level: issueType.hierarchyLevel,
                    name: issueType.name,
                    id: issueType.id
                })).sort((a, b)=>a.level !== b.level ? b.level - a.level : a.name.localeCompare(b.name)), [
            result.issueTypes
        ]);
        const isFieldsLoading = hasStartedFetchingFields ? loading : true;
        return {
            error: error,
            loading: error ? false : isQueryLoading || isFieldsLoading,
            data: result,
            typesWithFields: typesWithFields,
            hierarchyLevels: hierarchyLevels,
            refetch: refetch
        };
    };
    const $90cf08abf5e3ede7$var$issueTypesAndFieldsContextDefaultValue = {
        data: {
            fields: [],
            issueTypes: []
        },
        loading: false,
        error: undefined,
        typesWithFields: [],
        hierarchyLevels: []
    };
    const $90cf08abf5e3ede7$export$77937175321fab39 = (0, $5uXOq.createContext)({
        ...$90cf08abf5e3ede7$var$issueTypesAndFieldsContextDefaultValue
    });
    const $90cf08abf5e3ede7$export$fbd286e14113bfc = (0, $5uXOq.createContext)({
        ...$90cf08abf5e3ede7$var$issueTypesAndFieldsContextDefaultValue
    });
    const $90cf08abf5e3ede7$export$d2121b02f0b65782 = (input)=>{
        const issueTypesAndFieldsViewData = (0, $5uXOq.useContext)($90cf08abf5e3ede7$export$77937175321fab39);
        const issueTypesAndFieldsCreateData = (0, $5uXOq.useContext)($90cf08abf5e3ede7$export$fbd286e14113bfc);
        if (!input || input.issueOperation === 'VIEW') return issueTypesAndFieldsViewData;
        return issueTypesAndFieldsCreateData;
    };
});
const $a286480ec63fa4c8$export$747aad128920134d = 3000;
const $a286480ec63fa4c8$export$e4f8d353742c04ac = 4000;
const $a286480ec63fa4c8$export$540ffd289e5e0562 = 'timeWaitingForBackendData';
const $a286480ec63fa4c8$export$23e322eb7c526958 = 'REQUEST_START';
const $a286480ec63fa4c8$export$83ca21a50372ea3b = 'REQUEST_END';
const $a286480ec63fa4c8$export$821ca6ff41f300ec = 'jwm-availableFieldsQuery';
const $a286480ec63fa4c8$export$7b887ee35f2b465e = 'AVAILABLE_FIELDS_QUERY_START';
const $a286480ec63fa4c8$export$ac953882305d6102 = 'AVAILABLE_FIELDS_QUERY_END';
const $a286480ec63fa4c8$export$7f7f60b5526c5ee3 = 'jwm-ui-render-time';
const $a286480ec63fa4c8$export$b78f0bbf209e5f4 = 'UI_RENDER_START';
const $a286480ec63fa4c8$export$88ea1e280513690f = 'UI_RENDER_END';
parcelRegister("8Zw8m", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT", ()=>$c9bd1f086657e924$export$e6952b12ade67489);
    $parcel$export(module.exports, "HierarchyLevel", ()=>$c9bd1f086657e924$export$7faaf3222dfd10db);
    const $c9bd1f086657e924$export$e6952b12ade67489 = 'default';
    const $c9bd1f086657e924$export$7faaf3222dfd10db = Object.freeze({
        EPIC: 1,
        BASE: 0,
        SUBTASK: -1
    });
});
parcelRegister("8tTgF", function(module, exports) {
    $parcel$export(module.exports, "transformResult", ()=>$66b8ed432f1db6bc$export$f13b29f9ed0c5a03);
    $parcel$export(module.exports, "transformResultToTypesWithFields", ()=>$66b8ed432f1db6bc$export$55ab7865f91ba09b);
    $parcel$export(module.exports, "JWMQueryByRouteMap", ()=>$66b8ed432f1db6bc$export$7188da46161cbb8f);
    var $65Ltd;
    var $5fc53;
    var $8Zw8m;
    var $e3MSU;
    const $66b8ed432f1db6bc$export$b07b0d8dc0894ecf = {
        fields: [],
        issueTypes: []
    };
    const $66b8ed432f1db6bc$var$emptyArray = [];
    const $66b8ed432f1db6bc$export$bffa388e20165996 = (node, issueType)=>{
        const fieldConfig = {
            isRequired: !!node.fieldConfig?.isRequired,
            isEditable: !!node.fieldConfig?.isEditable
        };
        if (node.type === 'priority') {
            fieldConfig.options = node.priorities.nodes;
            if (node.priority) fieldConfig.defaultPriorityId = node.priority.priorityId;
            else if (fieldConfig.options.length > 0) fieldConfig.defaultPriorityId = node.priorities.nodes[Math.floor(fieldConfig.options.length / 2)].priorityId;
        }
        if (node.type === 'issuetype') {
            fieldConfig.options = node.issueTypes.nodes;
            fieldConfig.avatarId = issueType.avatarId;
            fieldConfig.avatarUrl = issueType.avatar?.medium;
        }
        if (node.type === 'issuelinks' && node.issueLinkTypeRelations) fieldConfig.defaultIssueLinkTypeId = node.issueLinkTypeRelations.nodes.find((linkNode)=>linkNode.relationName === 'is blocked by')?.linkTypeId || node.issueLinkTypeRelations.nodes[0]?.linkTypeId;
        if (node.type === (0, (0, parcelRequire("5fc53")).MULTI_SELECT_CF_TYPE) || node.type === (0, (0, parcelRequire("5fc53")).SELECT_CF_TYPE)) {
            const fieldOptions = [];
            node.fieldOptions.nodes.forEach(({ value: value, optionId: optionId })=>{
                fieldOptions.push({
                    value: value,
                    label: value,
                    optionId: optionId
                });
            });
            fieldConfig.selectOptions = fieldOptions;
        }
        if (node.type === (0, (0, parcelRequire("5fc53")).MULTI_CHECKBOXES_CF_TYPE)) {
            const fieldOptions = [];
            node.fieldOptions.nodes.forEach(({ value: value, optionId: optionId })=>{
                fieldOptions.push({
                    value: value,
                    label: value,
                    optionId: optionId
                });
            });
            fieldConfig.selectOptions = fieldOptions;
        }
        if (node.type === (0, (0, parcelRequire("5fc53")).CATEGORY_TYPE)) {
            const fieldOptions = [];
            node.fieldOptions.nodes.forEach(({ value: value, optionId: optionId, color: color })=>{
                fieldOptions.push({
                    value: value,
                    label: value,
                    optionId: optionId,
                    color: color?.colorKey ?? null
                });
            });
            fieldConfig.selectOptions = fieldOptions;
        }
        return {
            id: node.fieldId,
            aliasFieldId: node.aliasFieldId,
            name: node.name,
            type: node.type,
            fieldConfig: fieldConfig,
            issueTypes: [],
            __typename: node.__typename
        };
    };
    const $66b8ed432f1db6bc$export$f13b29f9ed0c5a03 = (data)=>{
        if (data && data.jiraBusinessAvailableFields && data.jiraBusinessAvailableFields.edges) {
            const issueFieldsById = {};
            const issueTypesById = {};
            data.jiraBusinessAvailableFields.edges.map((edge)=>edge && edge.node || {}).forEach(({ issueType: issueType, fields: fields, isDefaultIssueType: isDefaultIssueType })=>{
                issueTypesById[issueType.issueTypeId] = {
                    id: issueType.issueTypeId,
                    isDefault: isDefaultIssueType,
                    name: issueType.name,
                    subtask: issueType.type === 'SUB_TASK',
                    avatarId: issueType.avatarId,
                    avatarUrl: issueType.avatar?.medium ?? null,
                    hierarchyLevel: issueType.hierarchy?.level ?? 0
                };
                fields.edges.map((edge)=>edge && edge.node || {}).forEach((node)=>{
                    if (node.fieldId) {
                        if (!issueFieldsById[node.fieldId]) issueFieldsById[node.fieldId] = $66b8ed432f1db6bc$export$bffa388e20165996(node, issueType);
                        issueFieldsById[node.fieldId].issueTypes = issueFieldsById[node.fieldId].issueTypes || [];
                        issueFieldsById[node.fieldId].issueTypes.push(issueType.issueTypeId);
                    }
                });
            });
            return {
                fields: Object.keys(issueFieldsById).map((id)=>issueFieldsById[id]),
                issueTypes: Object.keys(issueTypesById).map((id)=>issueTypesById[id])
            };
        }
        return $66b8ed432f1db6bc$export$b07b0d8dc0894ecf;
    };
    const $66b8ed432f1db6bc$export$55ab7865f91ba09b = (data)=>{
        if (data && data.jiraBusinessAvailableFields && data.jiraBusinessAvailableFields.edges) return data.jiraBusinessAvailableFields.edges.map((edge)=>edge && edge.node || {}).map(({ issueType: issueType, fields: fields, isDefaultIssueType: isDefaultIssueType })=>({
                issueType: {
                    id: issueType.issueTypeId,
                    isDefault: isDefaultIssueType,
                    name: issueType.name,
                    subtask: issueType.type === 'SUB_TASK',
                    avatarId: issueType.avatarId,
                    avatarUrl: issueType.avatar?.medium ?? '',
                    hierarchyLevel: issueType.hierarchy?.level ?? 0
                },
                fields: fields.edges.map((edge)=>edge && edge.node || {}).map((node)=>$66b8ed432f1db6bc$export$bffa388e20165996(node, issueType))
            }));
        return $66b8ed432f1db6bc$var$emptyArray;
    };
    const $66b8ed432f1db6bc$export$7188da46161cbb8f = {
        [(0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM)]: {
            view: 'Form',
            query: (0, (0, parcelRequire("e3MSU")).ISSUE_TYPES_AND_FIELDS_FORM_QUERY)
        },
        [(0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_FORM_SUBMIT)]: {
            view: 'FormSubmit',
            query: (0, (0, parcelRequire("e3MSU")).ISSUE_TYPES_AND_FIELDS_FORM_SUBMIT_QUERY)
        },
        [(0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_CALENDAR)]: {
            view: 'Calendar',
            query: (0, (0, parcelRequire("e3MSU")).ISSUE_TYPES_AND_FIELDS_CALENDAR_QUERY)
        },
        [(0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_CALENDAR_EMBED)]: {
            view: 'CalendarEmbed',
            query: (0, (0, parcelRequire("e3MSU")).ISSUE_TYPES_AND_FIELDS_CALENDAR_QUERY)
        },
        [(0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_LIST)]: {
            view: 'List',
            query: (0, (0, parcelRequire("e3MSU")).ISSUE_TYPES_AND_FIELDS_LIST_QUERY)
        },
        [(0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_LIST_EMBED)]: {
            view: 'ListEmbed',
            query: (0, (0, parcelRequire("e3MSU")).ISSUE_TYPES_AND_FIELDS_LIST_QUERY)
        },
        [(0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_TIMELINE)]: {
            view: 'Timeline',
            query: (0, (0, parcelRequire("e3MSU")).ISSUE_TYPES_AND_FIELDS_TIMELINE_QUERY)
        },
        [(0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_TIMELINE_EMBED)]: {
            view: 'TimelineEmbed',
            query: (0, (0, parcelRequire("e3MSU")).ISSUE_TYPES_AND_FIELDS_TIMELINE_QUERY)
        },
        [(0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_BOARD)]: {
            view: 'Board',
            query: (0, (0, parcelRequire("e3MSU")).ISSUE_TYPES_AND_FIELDS_BOARD_QUERY)
        },
        [(0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_CLASSIC_BUSINESS_PROJECT_BOARD_EMBED)]: {
            view: 'BoardEmbed',
            query: (0, (0, parcelRequire("e3MSU")).ISSUE_TYPES_AND_FIELDS_BOARD_QUERY)
        },
        [(0, (0, parcelRequire("8Zw8m")).DEFAULT)]: {
            view: 'Common',
            query: (0, (0, parcelRequire("e3MSU")).ISSUE_TYPES_AND_FIELDS_LIST_QUERY)
        }
    };
});
parcelRegister("e3MSU", function(module, exports) {
    $parcel$export(module.exports, "ISSUE_TYPES_AND_FIELDS_LIST_QUERY", ()=>$32ca725097f9e68f$export$ba5f98a8d6136727);
    $parcel$export(module.exports, "ISSUE_TYPES_AND_FIELDS_CALENDAR_QUERY", ()=>$32ca725097f9e68f$export$cba408dff1091b60);
    $parcel$export(module.exports, "ISSUE_TYPES_AND_FIELDS_TIMELINE_QUERY", ()=>$32ca725097f9e68f$export$363435cea078aa93);
    $parcel$export(module.exports, "ISSUE_TYPES_AND_FIELDS_BOARD_QUERY", ()=>$32ca725097f9e68f$export$1641a42cf2cdb09a);
    $parcel$export(module.exports, "ISSUE_TYPES_AND_FIELDS_FORM_QUERY", ()=>$32ca725097f9e68f$export$7903c43b0ec55315);
    $parcel$export(module.exports, "ISSUE_TYPES_AND_FIELDS_FORM_SUBMIT_QUERY", ()=>$32ca725097f9e68f$export$79304c172f5555ae);
    var $5cllN;
    const $32ca725097f9e68f$export$ec2562ca5badac3b = (0, (0, parcelRequire("5cllN")).default)`
  fragment GetIssueTypesAndFields on JiraBusinessAvailableFields {
    issueType {
      issueTypeId
      name
      type
      avatarId
      avatar {
        medium
      }
      hierarchy {
        level
      }
    }
    isDefaultIssueType
    fields {
      edges {
        node {
          fieldId
          type
          name
          aliasFieldId
          ... on GenericIssueField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraIssueTypeField {
            fieldConfig {
              isRequired
              isEditable
            }
            issueTypes {
              nodes {
                name
                id
              }
            }
          }
          ... on JiraPriorityField {
            fieldConfig {
              isRequired
              isEditable
            }
            priority {
              priorityId
            }
            priorities {
              nodes {
                priorityId
                name
                iconUrl
              }
            }
          }
          ... on JiraLabelsField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraSingleSelectUserPickerField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraSingleLineTextField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraDatePickerField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraAffectedServicesField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraAttachmentsField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraCMDBField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraCascadingSelectField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraCheckboxesField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraColorField {
            fieldConfig {
              isRequired
              isEditable
            }
            color {
              colorKey
            }
          }
          ... on JiraComponentsField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraDateTimePickerField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraEpicLinkField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraIssueLinkField {
            fieldConfig {
              isRequired
              isEditable
            }
            issueLinkTypeRelations(first: 10) {
              nodes {
                linkTypeId
                relationName
              }
            }
          }
          ... on JiraIssueRestrictionField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraMultipleGroupPickerField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraMultipleSelectField {
            fieldConfig {
              isRequired
              isEditable
            }
            fieldOptions {
              nodes {
                id
                optionId
                value
              }
            }
          }
          ... on JiraMultipleSelectUserPickerField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraMultipleVersionPickerField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraNumberField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraPeopleField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraProjectField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraRadioSelectField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraResolutionField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraRichTextField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraSecurityLevelField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraSingleGroupPickerField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraSingleSelectField {
            fieldConfig {
              isRequired
              isEditable
            }
            fieldOptions {
              nodes {
                id
                optionId
                value
              }
            }
          }
          ... on JiraSingleVersionPickerField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraSprintField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraTeamField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraUrlField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JsmRequestTypeField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JWMCategoryField {
            fieldConfig {
              isRequired
              isEditable
            }
            fieldOptions {
              nodes {
                id
                optionId
                value
                color {
                    colorKey
                }
              }
            }
          }
          ... on JiraCheckboxesField {
            fieldConfig {
              isRequired
              isEditable
            }
            fieldOptions {
              nodes {
                id
                optionId
                value
              }
            }
          }
          ... on JiraAtlassianTeamField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
          ... on JiraGoalsField {
            fieldConfig {
              isRequired
              isEditable
            }
          }
        }
      }
    }
  }
`;
    const $32ca725097f9e68f$export$ba5f98a8d6136727 = (0, (0, parcelRequire("5cllN")).default)`
  query JiraBusinessAvailableFieldsListView ($projectKey: String!, $issueOperation: JiraBusinessIssueOperation, $first: Int, $last: Int, $before: String, $after: String) {
      jiraBusinessAvailableFields(projectKey: $projectKey, issueOperation: $issueOperation, first: $first, last: $last, before: $before, after: $after) {
        edges {
          node {
            ...GetIssueTypesAndFields
          }
        }
      }
  }
  ${$32ca725097f9e68f$export$ec2562ca5badac3b}
`;
    const $32ca725097f9e68f$export$cba408dff1091b60 = (0, (0, parcelRequire("5cllN")).default)`
  query JiraBusinessAvailableFieldsCalendarView ($projectKey: String!, $issueOperation: JiraBusinessIssueOperation, $first: Int, $last: Int, $before: String, $after: String) {
      jiraBusinessAvailableFields(projectKey: $projectKey, issueOperation: $issueOperation, first: $first, last: $last, before: $before, after: $after) {
        edges {
          node {
            ...GetIssueTypesAndFields
          }
        }
      }
  }
  ${$32ca725097f9e68f$export$ec2562ca5badac3b}
`;
    const $32ca725097f9e68f$export$363435cea078aa93 = (0, (0, parcelRequire("5cllN")).default)`
  query JiraBusinessAvailableFieldsTimelineView ($projectKey: String!, $issueOperation: JiraBusinessIssueOperation, $first: Int, $last: Int, $before: String, $after: String) {
      jiraBusinessAvailableFields(projectKey: $projectKey, issueOperation: $issueOperation, first: $first, last: $last, before: $before, after: $after) {
        edges {
          node {
            ...GetIssueTypesAndFields
          }
        }
      }
  }
  ${$32ca725097f9e68f$export$ec2562ca5badac3b}
`;
    const $32ca725097f9e68f$export$1641a42cf2cdb09a = (0, (0, parcelRequire("5cllN")).default)`
  query JiraBusinessAvailableFieldsBoardView ($projectKey: String!, $issueOperation: JiraBusinessIssueOperation, $first: Int, $last: Int, $before: String, $after: String) {
      jiraBusinessAvailableFields(projectKey: $projectKey, issueOperation: $issueOperation, first: $first, last: $last, before: $before, after: $after) {
        edges {
          node {
            ...GetIssueTypesAndFields
          }
        }
      }
  }
  ${$32ca725097f9e68f$export$ec2562ca5badac3b}
`;
    const $32ca725097f9e68f$export$7903c43b0ec55315 = (0, (0, parcelRequire("5cllN")).default)`
  query JiraBusinessAvailableFieldsFormView ($projectKey: String!, $issueOperation: JiraBusinessIssueOperation, $first: Int, $last: Int, $before: String, $after: String) {
      jiraBusinessAvailableFields(projectKey: $projectKey, issueOperation: $issueOperation, first: $first, last: $last, before: $before, after: $after) {
        edges {
          node {
            ...GetIssueTypesAndFields
          }
        }
      }
  }
  ${$32ca725097f9e68f$export$ec2562ca5badac3b}
`;
    const $32ca725097f9e68f$export$79304c172f5555ae = (0, (0, parcelRequire("5cllN")).default)`
  query JiraBusinessAvailableFieldsFormSubmitView ($projectKey: String!, $issueOperation: JiraBusinessIssueOperation, $first: Int, $last: Int, $before: String, $after: String) {
      jiraBusinessAvailableFields(projectKey: $projectKey, issueOperation: $issueOperation, first: $first, last: $last, before: $before, after: $after) {
        edges {
          node {
            ...GetIssueTypesAndFields
          }
        }
      }
  }
  ${$32ca725097f9e68f$export$ec2562ca5badac3b}
`;
});
parcelRegister("cLGgz", function(module, exports) {
    $parcel$export(module.exports, "IssueCreateProvider", ()=>$dc15b071bf2d5f6e$export$a975cd9627cdf4b6);
    $parcel$export(module.exports, "useCreateIssue", ()=>$dc15b071bf2d5f6e$export$8af2d18142c8506c);
    $parcel$export(module.exports, "isOptimisticIssue", ()=>$dc15b071bf2d5f6e$export$8512029c7fc94e58);
    $parcel$export(module.exports, "useIsHighlighted", ()=>$dc15b071bf2d5f6e$export$2ecca9d8a7f031af);
    var $5uXOq = parcelRequire("5uXOq");
    var $dqDis;
    var $4R6GH;
    var $cYlk7;
    var $ja8d8;
    var $ecPXN;
    class $dc15b071bf2d5f6e$var$IssueCreateJob {
        constructor(createParams){
            this.createParams = createParams;
            this.promise = new Promise((resolve, reject)=>{
                this.reject = reject;
                this.resolve = resolve;
            });
        }
    }
    const $dc15b071bf2d5f6e$var$IssueCreateContext = (0, $5uXOq.createContext)(null);
    const $dc15b071bf2d5f6e$var$reducer = (state, action)=>{
        switch(action.type){
            case 'enqueue':
                return {
                    ...state,
                    jobQueue: [
                        ...state.jobQueue,
                        action.job
                    ]
                };
            case 'start-job':
                return {
                    ...state,
                    runningJob: state.jobQueue[0],
                    jobQueue: state.jobQueue.slice(1)
                };
            case 'end-job':
                return {
                    ...state,
                    runningJob: null
                };
            case 'highlight':
                return {
                    ...state,
                    highlightedIssues: new Set([
                        ...state.highlightedIssues,
                        action.issueId
                    ])
                };
            case 'unhighlight':
                return {
                    ...state,
                    highlightedIssues: new Set([
                        ...state.highlightedIssues
                    ].filter((id)=>id !== action.issueId))
                };
            case 'save-summary':
                return {
                    ...state,
                    summary: action.summary
                };
            default:
                return state;
        }
    };
    const $dc15b071bf2d5f6e$var$initialState = {
        jobQueue: [],
        runningJob: null,
        highlightedIssues: new Set(),
        summary: ''
    };
    const $dc15b071bf2d5f6e$export$a975cd9627cdf4b6 = ({ onCreateIssue: onCreateIssue, onRefetchIssue: onRefetchIssue, ignoreFiltersContext: ignoreFiltersContext = false, children: children })=>{
        const { data: { user: user } } = (0, (0, parcelRequire("cYlk7")).useCurrentUser)();
        const currentUser = user;
        const nextIssueId = (0, $5uXOq.useRef)(-1);
        const [{ jobQueue: jobQueue, runningJob: runningJob, highlightedIssues: highlightedIssues, summary: summary }, dispatch] = (0, $5uXOq.useReducer)($dc15b071bf2d5f6e$var$reducer, $dc15b071bf2d5f6e$var$initialState);
        const createIssueController = (0, (0, parcelRequire("ja8d8")).useCreateIssue)(onCreateIssue, onRefetchIssue);
        const highlightIssue = (0, $5uXOq.useCallback)((issueId)=>dispatch({
                type: 'highlight',
                issueId: issueId
            }), []);
        const unhighlightIssue = (0, $5uXOq.useCallback)((issueId)=>setTimeout(()=>{
                dispatch({
                    type: 'unhighlight',
                    issueId: issueId
                });
            }, 2000), []);
        const createIssue = (0, $5uXOq.useCallback)((createParams)=>{
            const job = new $dc15b071bf2d5f6e$var$IssueCreateJob(createParams);
            dispatch({
                type: 'enqueue',
                job: job
            });
            let rank;
            if (createParams.input.rankAfter) rank = (0, (0, parcelRequire("dqDis")).getNextRank)(createParams.input.rankAfter.rank);
            else if (createParams.input.rankBefore) rank = (0, (0, parcelRequire("dqDis")).getPreviousRank)(createParams.input.rankBefore.rank);
            const reporter = {
                accountId: currentUser.accountId,
                avatarUrl: currentUser.avatarUrls['48x48'],
                displayName: currentUser.displayName
            };
            const optimisticIssuePayload = {
                issueId: nextIssueId.current--,
                rank: rank,
                reporter: reporter,
                ...createParams.input
            };
            return {
                optimisticIssuePayload: optimisticIssuePayload,
                promise: job.promise
            };
        }, [
            currentUser
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (jobQueue.length > 0 && !runningJob) {
                const job = jobQueue[0];
                dispatch({
                    type: 'start-job'
                });
                createIssueController({
                    createParams: job.createParams,
                    highlightIssue: highlightIssue,
                    unhighlightIssue: unhighlightIssue,
                    ignoreFiltersContext: ignoreFiltersContext
                }).then(job.resolve).catch(job.reject).finally(()=>dispatch({
                        type: 'end-job'
                    }));
            }
        }, [
            createIssueController,
            highlightedIssues,
            jobQueue,
            runningJob,
            highlightIssue,
            unhighlightIssue,
            ignoreFiltersContext
        ]);
        (0, (0, parcelRequire("ecPXN")).useCreateParamHandler)();
        const saveSummary = (0, $5uXOq.useCallback)((newSummary)=>{
            dispatch({
                type: 'save-summary',
                summary: newSummary
            });
        }, []);
        const value = (0, $5uXOq.useMemo)(()=>({
                createIssue: createIssue,
                highlightedIssues: highlightedIssues,
                summary: summary,
                saveSummary: saveSummary
            }), [
            createIssue,
            highlightedIssues,
            summary,
            saveSummary
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($dc15b071bf2d5f6e$var$IssueCreateContext.Provider, {
            value: value
        }, children);
    };
    const $dc15b071bf2d5f6e$export$8af2d18142c8506c = (onSubmit, onBlur)=>{
        const context = (0, $5uXOq.useContext)($dc15b071bf2d5f6e$var$IssueCreateContext);
        if (!context) throw new Error('useCreateIssue must be used within an IssueCreateProvider');
        const { createIssue: createIssue, summary: summary, saveSummary: saveSummary } = context;
        const summaryRef = (0, $5uXOq.useRef)(summary);
        const hasExitedWithoutUserAction = (0, $5uXOq.useRef)(true);
        const submit = (0, $5uXOq.useCallback)((createParams)=>{
            const result = createIssue(createParams);
            onSubmit(result);
            hasExitedWithoutUserAction.current = false;
            setTimeout(()=>{
                hasExitedWithoutUserAction.current = true;
            }, 100);
            return result;
        }, [
            createIssue,
            onSubmit
        ]);
        const blur = (0, $5uXOq.useCallback)((event)=>{
            if ((0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline_table_meatballs_menu_a11y')) onBlur?.(event);
            else onBlur?.();
            hasExitedWithoutUserAction.current = false;
        }, [
            onBlur
        ]);
        (0, $5uXOq.useEffect)(()=>()=>{
                saveSummary(hasExitedWithoutUserAction.current ? summaryRef.current : '');
            }, [
            saveSummary
        ]);
        return {
            summaryRef: summaryRef,
            submit: submit,
            blur: blur
        };
    };
    const $dc15b071bf2d5f6e$export$8512029c7fc94e58 = (issueId)=>issueId < 0;
    const $dc15b071bf2d5f6e$export$2ecca9d8a7f031af = ()=>{
        const context = (0, $5uXOq.useContext)($dc15b071bf2d5f6e$var$IssueCreateContext);
        if (!context) throw new Error('useIsHighlighted must be used within an IssueCreateProvider');
        const { highlightedIssues: highlightedIssues } = context;
        return (0, $5uXOq.useCallback)((issueId)=>$dc15b071bf2d5f6e$export$8512029c7fc94e58(issueId) || highlightedIssues.has(issueId), [
            highlightedIssues
        ]);
    };
});
parcelRegister("dqDis", function(module, exports) {
    $parcel$export(module.exports, "getNextRank", ()=>$d36f563d8781dd11$export$5c16a8b7eebff4b8);
    $parcel$export(module.exports, "getPreviousRank", ()=>$d36f563d8781dd11$export$e2047b3433d9f565);
    $parcel$export(module.exports, "useHasRankIssuePermission", ()=>$d36f563d8781dd11$export$2fbfa09555819a54);
    var $daQYX;
    const $d36f563d8781dd11$export$5c16a8b7eebff4b8 = (s)=>`${s}0`;
    const $d36f563d8781dd11$export$e2047b3433d9f565 = (s)=>{
        const lastCharCode = s.charCodeAt(s.length - 1);
        const previousLastChar = String.fromCharCode(lastCharCode - 1);
        if (lastCharCode === 0) return $d36f563d8781dd11$export$e2047b3433d9f565(s.substring(0, s.length - 1));
        return `${s.substring(0, s.length - 1)}${previousLastChar}99`;
    };
    const $d36f563d8781dd11$export$2fbfa09555819a54 = ()=>{
        const { permissions: permissions } = (0, (0, parcelRequire("daQYX")).useProject)();
        return permissions.scheduleIssues && permissions.editIssues;
    };
});
parcelRegister("ja8d8", function(module, exports) {
    $parcel$export(module.exports, "useCreateIssue", ()=>$50507bfa414423fc$export$8af2d18142c8506c);
    var $5uXOq = parcelRequire("5uXOq");
    var $1T2vX;
    var $l9KLJ;
    var $jcw0u;
    var $6s1PB;
    var $jJZqs;
    var $pa9q9;
    var $koVbs;
    var $8zOmE;
    var $lwMsT;
    var $kpiI3;
    var $8roPX;
    var $lVeTj;
    var $fb3JB;
    const $50507bfa414423fc$export$8edbb6d449614942 = ()=>{
        const workflows = (0, (0, parcelRequire("l9KLJ")).useWorkflows)();
        return (0, $5uXOq.useCallback)((createInput)=>{
            if (createInput.status && workflows != null) {
                const workflow = workflows.find((w)=>w.issueTypes.some((it)=>it.issueTypeId === createInput.issueType.id));
                const { statusId: statusId } = createInput.status;
                const transition = workflow?.transitions.find((t)=>t.to.statusId === statusId && (t.isInitial || t.isGlobal && !t.isConditional));
                return transition?.transitionId;
            }
        }, [
            workflows
        ]);
    };
    const $50507bfa414423fc$export$8af2d18142c8506c = (onCreateIssue, onRefetchIssue)=>{
        const showCreateSuccessFlag = (0, (0, parcelRequire("lVeTj")).useShowCreateSuccessFlag)();
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        const { typesWithFields: typesWithFields } = (0, (0, parcelRequire("1T2vX")).useIssueTypesAndFields)({
            issueOperation: 'CREATE'
        });
        const getTransitionId = $50507bfa414423fc$export$8edbb6d449614942();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const showCreateIssueDialog = (0, (0, parcelRequire("8roPX")).useCreateIssueDialog)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        return (0, $5uXOq.useCallback)(async ({ createParams: createParams, highlightIssue: highlightIssue, unhighlightIssue: unhighlightIssue, ignoreFiltersContext: ignoreFiltersContext })=>{
            const transitionId = getTransitionId(createParams.input);
            try {
                if (!(0, (0, parcelRequire("kpiI3")).hasAllRequiredFields)({
                    issueType: typesWithFields.find(({ issueType: issueType })=>issueType.id === createParams.input.issueType.id),
                    createInput: createParams.input
                })) throw new (0, (0, parcelRequire("jJZqs")).ValidationError)('Missing required fields');
                const response = await onCreateIssue(createParams, {
                    transitionId: transitionId
                });
                highlightIssue(response.itemIdentifiers.issueId);
                if (createParams.showSuccessFlag) showCreateSuccessFlag(response.itemIdentifiers.issueKey);
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'issue created', String(response.itemIdentifiers.issueId), {
                    location: createParams.location
                });
                unhighlightIssue(response.itemIdentifiers.issueId);
                return response.item;
            } catch (error) {
                let finalError = error;
                try {
                    if (error instanceof (0, (0, parcelRequire("jJZqs")).ValidationError)) {
                        const { issueId: issueId, issueKey: issueKey } = await showCreateIssueDialog(createParams.input, {
                            transitionId: transitionId
                        });
                        highlightIssue(issueId);
                        const issue = await onRefetchIssue(issueId, createParams.fieldIdsToReturn, !ignoreFiltersContext);
                        if (createParams.showSuccessFlag) showCreateSuccessFlag(issueKey);
                        unhighlightIssue(issueId);
                        return issue;
                    }
                    if (error instanceof Error) (0, (0, parcelRequire("jcw0u")).default)({
                        meta: {
                            id: 'JWMCreateIssueInline',
                            packageName: 'jiraBusinessIssueCreate',
                            teamName: 'deliveroo'
                        },
                        error: error,
                        sendToPrivacyUnsafeSplunk: true
                    });
                } catch (refetchError) {
                    finalError = refetchError;
                }
                if (finalError instanceof (0, (0, parcelRequire("8roPX")).CancelledError)) return null;
                showFlag({
                    type: 'error',
                    title: formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("fb3JB")).default).errorFlagTitleIssueTermRefresh : (0, (0, parcelRequire("fb3JB")).default).errorFlagTitle),
                    description: formatMessage((0, (0, parcelRequire("fb3JB")).default).errorFlagDescription)
                });
                throw finalError;
            }
        }, [
            getTransitionId,
            typesWithFields,
            onCreateIssue,
            createAnalyticsEvent,
            showCreateSuccessFlag,
            showFlag,
            formatMessage,
            showCreateIssueDialog,
            onRefetchIssue
        ]);
    };
});
parcelRegister("l9KLJ", function(module, exports) {
    $parcel$export(module.exports, "WorkflowsProvider", ()=>$a3eac8b2a2bf7ce6$export$80a1d3130ff3ec75);
    $parcel$export(module.exports, "useWorkflows", ()=>$a3eac8b2a2bf7ce6$export$437f9bd807b88beb);
    var $5uXOq = parcelRequire("5uXOq");
    var $7HGHK;
    var $pa9q9;
    var $6ZYlM;
    var $lDVEA;
    const $a3eac8b2a2bf7ce6$var$FETCH_WORKFLOW_FLAG_ID = (0, (0, parcelRequire("7HGHK")).toFlagId)('fetch-board-error-flag');
    const $a3eac8b2a2bf7ce6$var$WorkflowsContext = (0, $5uXOq.createContext)(undefined);
    const $a3eac8b2a2bf7ce6$export$80a1d3130ff3ec75 = ({ children: children, enabled: enabled = true, workflows: workflows })=>{
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        const { fetch: fetch, data: data, error: error } = (0, (0, parcelRequire("6ZYlM")).useFetchWorkflows)();
        (0, $5uXOq.useEffect)(()=>{
            if (enabled && workflows == null) fetch();
        }, [
            enabled,
            fetch,
            workflows
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (error) showFlag({
                id: $a3eac8b2a2bf7ce6$var$FETCH_WORKFLOW_FLAG_ID,
                type: 'error',
                title: (0, (0, parcelRequire("lDVEA")).default).workflowsErrorTitle,
                description: (0, (0, parcelRequire("lDVEA")).default).workflowsErrorDescription
            });
        }, [
            error,
            showFlag
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($a3eac8b2a2bf7ce6$var$WorkflowsContext.Provider, {
            value: workflows ?? data
        }, children);
    };
    const $a3eac8b2a2bf7ce6$export$437f9bd807b88beb = ()=>(0, $5uXOq.useContext)($a3eac8b2a2bf7ce6$var$WorkflowsContext);
});
parcelRegister("6ZYlM", function(module, exports) {
    $parcel$export(module.exports, "useFetchWorkflows", ()=>$8896012bd25091f7$export$41ba56ef14d1b9b1);
    var $5uXOq = parcelRequire("5uXOq");
    var $5tTFS;
    var $daQYX;
    var $jcw0u;
    var $6V9lc;
    const $8896012bd25091f7$export$41ba56ef14d1b9b1 = ()=>{
        const project = (0, (0, parcelRequire("daQYX")).useProject)();
        const [fetch, { data: data, loading: loading, error: error }] = (0, (0, parcelRequire("5tTFS")).useLazyQuery)((0, (0, parcelRequire("6V9lc")).WORKFLOWS_QUERY), {
            variables: {
                projectId: project.id,
                first: 100
            },
            onError: (apolloError)=>{
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'jwmFetchWorkflows',
                        packageName: 'jiraBusinessWorkflows',
                        teamName: 'wanjel'
                    },
                    attributes: {
                        message: 'Failed to fetch workflows'
                    },
                    error: apolloError,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        });
        const workflowsDetails = (0, $5uXOq.useMemo)(()=>data?.jwmWorkflowWithIssueTypes?.edges?.map((edge)=>{
                const { workflow: workflow, issueTypes: issueTypes } = edge?.node || {};
                return {
                    workflowId: workflow.workflowId,
                    name: workflow?.name ?? undefined,
                    transitions: workflow.transitions.edges.map((transitionEdge)=>({
                            transitionId: transitionEdge.node.transitionId,
                            name: transitionEdge.node.name ?? undefined,
                            isInitial: transitionEdge.node.isInitial,
                            isGlobal: transitionEdge.node.isGlobal,
                            isConditional: transitionEdge.node.isConditional,
                            to: {
                                statusId: transitionEdge.node.to.statusId
                            }
                        })),
                    issueTypes: issueTypes.edges.map((issueTypeEdge)=>({
                            issueTypeId: issueTypeEdge.node.issueTypeId,
                            name: issueTypeEdge.node.name,
                            avatarUrl: issueTypeEdge.node.avatar.medium,
                            hierarchyLevel: issueTypeEdge.node.hierarchy.level
                        }))
                };
            }), [
            data
        ]);
        return {
            fetch: fetch,
            data: workflowsDetails,
            loading: loading,
            error: error
        };
    };
});
parcelRegister("6V9lc", function(module, exports) {
    $parcel$export(module.exports, "WORKFLOWS_QUERY", ()=>$ece8b64659728495$export$d54deb6c2b9695b7);
    var $5cllN;
    const $ece8b64659728495$export$d54deb6c2b9695b7 = (0, (0, parcelRequire("5cllN")).default)`
    query JWMWorkflowWithIssueTypes($projectId: Long!, $filter: JWMWorkflowWithIssueTypesFilter, $first: Int, $after: String, $last: Int, $before: String) {
        jwmWorkflowWithIssueTypes(projectId: $projectId, filter: $filter, first: $first, after: $after, last: $last, before: $before) {
            edges {
                node {
                    workflow {
                        workflowId
                        name
                        transitions(first: $first) {
                            edges {
                                node {
                                    transitionId
                                    name
                                    isInitial
                                    isGlobal
                                    isConditional
                                    to {
                                        statusId
                                    }
                                }
                            }
                        }
                    }
                    issueTypes(first: $first) {
                        edges {
                            node {
                                issueTypeId
                                name
                                avatar {
                                  medium
                                }
                              	hierarchy {
                              	  level
                              	}
                            }
                        }
                    }
                }
            }
        }
    }
`;
});
parcelRegister("lDVEA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a3db26a0042253e3$export$2e2bcd8739ae039);
    var $7VHMR;
    var $a3db26a0042253e3$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        workflowsErrorTitle: {
            "id": "business-workflows.controllers.workflows-context.workflows-error-title",
            "defaultMessage": "Failed to load workflows details"
        },
        workflowsErrorDescription: {
            "id": "business-workflows.controllers.workflows-context.workflows-error-description",
            "defaultMessage": "We couldn't load your workflow details, try refreshing the page or try again later."
        }
    });
});
parcelRegister("kpiI3", function(module, exports) {
    $parcel$export(module.exports, "hasAllRequiredFields", ()=>$5d73fa9073989726$export$146976a1cbd99cd0);
    var $hE5wF;
    var $5fc53;
    const $5d73fa9073989726$export$146976a1cbd99cd0 = ({ issueType: issueType, createInput: createInput })=>{
        if (!issueType) return false;
        return issueType.fields.every((field)=>{
            if (!field.fieldConfig?.isRequired) return true;
            if (!field.type && !field.aliasFieldId) return false;
            if (field.aliasFieldId && field.aliasFieldId === (0, (0, parcelRequire("hE5wF")).START_DATE_ALIAS_FIELD_ID)) return Boolean(createInput.startDate);
            if (field.aliasFieldId === (0, (0, parcelRequire("hE5wF")).STORY_POINTS_ALIAS_FIELD_ID)) return createInput.storyPoints != null;
            if (field.type) switch(field.type){
                case 0, (0, parcelRequire("5fc53")).ISSUE_TYPE:
                case 0, (0, parcelRequire("5fc53")).REPORTER_TYPE:
                    return true;
                case 0, (0, parcelRequire("5fc53")).SUMMARY_TYPE:
                    return Boolean(createInput.summary);
                case 0, (0, parcelRequire("5fc53")).PRIORITY_TYPE:
                    return Boolean(createInput.priority);
                case 0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE:
                    return Boolean(createInput.assignee);
                case 0, (0, parcelRequire("5fc53")).DUE_DATE_TYPE:
                    return Boolean(createInput.dueDate);
                case 0, (0, parcelRequire("5fc53")).CATEGORY_TYPE:
                    return Boolean(createInput.category);
                case 0, (0, parcelRequire("5fc53")).STORY_POINT_ESTIMATE_CF_TYPE:
                    return createInput.storyPointEstimate != null;
                case 0, (0, parcelRequire("5fc53")).SPRINT_TYPE:
                    return Boolean(createInput.sprint);
                default:
                    break;
            }
            return false;
        });
    };
});
parcelRegister("8roPX", function(module, exports) {
    $parcel$export(module.exports, "CancelledError", ()=>$549ab3c244a8a20a$export$a8430ed4188f35a9);
    $parcel$export(module.exports, "useCreateIssueDialog", ()=>$549ab3c244a8a20a$export$8254d39962ec7361);
    var $5uXOq = parcelRequire("5uXOq");
    var $1T2vX;
    var $5eGnF;
    var $9svjh;
    var $hULKg;
    var $5rzqz;
    var $dAmbh;
    var $3ZKGh;
    class $549ab3c244a8a20a$export$a8430ed4188f35a9 extends Error {
    }
    const $549ab3c244a8a20a$export$8d1d8a0d2a7917ac = ()=>{
        const { typesWithFields: typesWithFields } = (0, (0, parcelRequire("1T2vX")).useIssueTypesAndFields)({
            issueOperation: 'CREATE'
        });
        return (0, $5uXOq.useCallback)((issueType, predicate)=>{
            if (!issueType) return undefined;
            const issueTypeWithFields = typesWithFields.find((typeWithFields)=>typeWithFields.issueType.id === issueType.id);
            return issueTypeWithFields?.fields.find(predicate);
        }, [
            typesWithFields
        ]);
    };
    const $549ab3c244a8a20a$export$8254d39962ec7361 = ()=>{
        const [, { openIssueCreateModal: openIssueCreateModal }] = (0, (0, parcelRequire("5rzqz")).useTriggerIssueCreateModal)();
        const { subscribe: subscribe } = (0, (0, parcelRequire("9svjh")).useGICLifeCycleEvents)();
        const getField = $549ab3c244a8a20a$export$8d1d8a0d2a7917ac();
        const { data: rankField } = (0, (0, parcelRequire("dAmbh")).useRankField)();
        return (0, $5uXOq.useCallback)((createInput, extraPayload)=>new Promise((resolve, reject)=>{
                const unsubscribe = subscribe((0, (0, parcelRequire("5eGnF")).GIC_LIFECYCLE_EVENTS).MODAL_KEEP_EDITING_EXISTING_ISSUE, ()=>{
                    onClose(null);
                });
                const onClose = (data)=>{
                    const result = data?.[0];
                    if (result) resolve(result);
                    else setTimeout(()=>{
                        reject(new $549ab3c244a8a20a$export$a8430ed4188f35a9('User cancelled'));
                    }, 100);
                    unsubscribe();
                };
                const { payload: payload, submitApiData: submitApiData } = (0, (0, parcelRequire("3ZKGh")).buildGICPayload)({
                    createInput: createInput,
                    extraPayload: extraPayload,
                    rankField: rankField,
                    getField: getField
                });
                const isSubTaskCreationOpen = createInput.issueType?.hierarchyLevel === -1;
                openIssueCreateModal({
                    id: 'jwm-create-issue-dialog',
                    onClose: onClose,
                    payload: payload,
                    context: {
                        projectId: createInput.projectId,
                        submitApiData: submitApiData
                    },
                    isSubTaskCreationOpen: isSubTaskCreationOpen,
                    triggerPointKey: (0, (0, parcelRequire("hULKg")).JWM_INLINE_CREATE),
                    disableProjectDropdown: true,
                    disableIssueTypeDropdown: Boolean(payload.issueType?.issueTypeId),
                    disableCreationSuccessFlag: true,
                    displayCreateAnotherIssueToggle: false,
                    minimizableModalView: 'mini'
                });
            }), [
            getField,
            openIssueCreateModal,
            rankField,
            subscribe
        ]);
    };
});
parcelRegister("5eGnF", function(module, exports) {
    $parcel$export(module.exports, "GIC_LIFECYCLE_EVENTS", ()=>$700db8c378cd19d9$export$876003a5b887f37e);
    const $700db8c378cd19d9$export$876003a5b887f37e = {
        MODAL_OPENED: 'MODAL_OPENED',
        MODAL_CLOSED: 'MODAL_CLOSED',
        MODAL_KEEP_EDITING_EXISTING_ISSUE: 'MODAL_KEEP_EDITING',
        MODAL_DISCARD_EXISTING_IN_PROGRESS_ISSUE: 'MODAL_DISCARD',
        MODAL_DISCARD_SUGGESTED_ISSUE: 'MODAL_DISCARD_SUGGESTED_ISSUE',
        MODAL_DISCARD_SUGGESTED_ISSUE_CHANGES: 'MODAL_DISCARD_SUGGESTED_ISSUE_CHANGES',
        MODAL_DISCARD_ALL_SUGGESTED_ISSUES: 'MODAL_DISCARD_ALL_SUGGESTED_ISSUES',
        CREATE_FORM_FIELD_CONFIG_UPDATE: 'CREATE_FORM_FIELD_CONFIG_UPDATE',
        CREATE_FORM_FIELD_VALUE_CHANGE: 'CREATE_FORM_FIELD_VALUE_CHANGE',
        ISSUE_CREATE_SUCCESS: 'ISSUE_CREATE_SUCCESS',
        PROJECT_FIELD_VALUE_CHANGE: 'PROJECT_FIELD_VALUE_CHANGE',
        ISSUE_TYPE_FIELD_VALUE_CHANGE: 'ISSUE_TYPE_FIELD_VALUE_CHANGE',
        RESET_FORM_FIELDS_FOR_CREATE_ANOTHER: 'RESET_FORM_FIELDS_FOR_CREATE_ANOTHER',
        USE_TRIGGER_ISSUE_CREATE_MODAL_STATE_CHANGE: 'USE_TRIGGER_ISSUE_CREATE_MODAL_STATE_CHANGE',
        STATUS_FIELD_STATE_CHANGE: 'STATUS_FIELD_STATE_CHANGE',
        CREATE_FORM_FIELD_BLUR: 'CREATE_FORM_FIELD_BLUR',
        CLASSIFICATION_LEVEL_FIELD_CHANGE: 'CLASSIFICATION_LEVEL_FIELD_CHANGE',
        FORM_CONTEXT_STATE_CHANGE: 'FORM_CONTEXT_STATE_CHANGE'
    };
});
parcelRegister("9svjh", function(module, exports) {
    $parcel$export(module.exports, "useGICLifeCycleEvents", ()=>$d9b2e43e4699b192$export$e3ff72f196296fcc);
    var $1mrD8;
    const $d9b2e43e4699b192$var$GICLifeCycleEventsService = new (0, (0, parcelRequire("1mrD8")).PubSubHub)();
    const $d9b2e43e4699b192$export$e3ff72f196296fcc = ()=>({
            ...$d9b2e43e4699b192$var$GICLifeCycleEventsService
        });
});
parcelRegister("1mrD8", function(module, exports) {
    $parcel$export(module.exports, "PubSubHub", ()=>$6e9a69c6f6f4fcfe$export$e3607828f8f2c01e);
    class $6e9a69c6f6f4fcfe$export$e3607828f8f2c01e {
        constructor(){
            this.subscribers = {};
            this.subscribe = (event, subscriber)=>{
                let subs = this.subscribers[event];
                if (!subs) {
                    subs = [];
                    this.subscribers[event] = subs;
                }
                subs?.push(subscriber);
                return ()=>this.unsubscribe(event, subscriber);
            };
            this.unsubscribe = (event, subscriber)=>{
                const subs = this.subscribers[event];
                if (subs) this.subscribers[event] = subs.filter((subscription)=>subscription !== subscriber);
            };
            this.publish = (event, data)=>{
                const subs = this.subscribers[event];
                if (subs?.length) subs?.forEach((subscriber)=>subscriber(data));
            };
            this.clearAll = ()=>{
                this.subscribers = {};
            };
        }
    }
});
parcelRegister("hULKg", function(module, exports) {
    $parcel$export(module.exports, "GENERIC_FORGE_USE_PRODUCT_MODALS", ()=>$62659eb193cd5c9c$export$a05673a22505d5ee);
    $parcel$export(module.exports, "GENERIC_GLOBAL_CREATE_BUTTON", ()=>$62659eb193cd5c9c$export$c78d329777576aa0);
    $parcel$export(module.exports, "MOBILE_GLOBAL_CREATE_BUTTON", ()=>$62659eb193cd5c9c$export$992ab052fd10f8e8);
    $parcel$export(module.exports, "GENERIC_KEYBOARD_SHORTCUT", ()=>$62659eb193cd5c9c$export$affdc3af7a9a4677);
    $parcel$export(module.exports, "JSW_ISSUE_VIEW_CREATE_ISSUE_IN_EPIC", ()=>$62659eb193cd5c9c$export$7e9cfd1f59e60910);
    $parcel$export(module.exports, "JSW_ISSUE_VIEW_CREATE_SUBTASK", ()=>$62659eb193cd5c9c$export$708499dcd016e5e9);
    $parcel$export(module.exports, "JSW_ISSUE_VIEW_AI_BREAKDOWN_CHILD_ISSUE", ()=>$62659eb193cd5c9c$export$e1c8789144c4c810);
    $parcel$export(module.exports, "JSW_ISSUE_VIEW_AI_BREAKDOWN_SUBTASK", ()=>$62659eb193cd5c9c$export$c5afabb7a17e802);
    $parcel$export(module.exports, "JSW_RELEASES_CREATE_ISSUE", ()=>$62659eb193cd5c9c$export$2086a63173b79b56);
    $parcel$export(module.exports, "JSW_ROADMAP_CREATE_ISSUE", ()=>$62659eb193cd5c9c$export$fe1e5e4597147709);
    $parcel$export(module.exports, "JSW_SECURITY_CREATE_ISSUE", ()=>$62659eb193cd5c9c$export$9bc326812a93707);
    $parcel$export(module.exports, "JSM_CALENDAR_CREATE_CHANGE_REQUEST", ()=>$62659eb193cd5c9c$export$f352934e06f44599);
    $parcel$export(module.exports, "JSM_CREATE_INCIDENT_FROM_ALERT_DETAIL", ()=>$62659eb193cd5c9c$export$6ae07c77acc64360);
    $parcel$export(module.exports, "JSM_CREATE_INCIDENT_FROM_ALERT_LIST", ()=>$62659eb193cd5c9c$export$b41d0684e4b6ab1);
    $parcel$export(module.exports, "JSM_EMPTY_QUEUE_CREATE_REQUEST", ()=>$62659eb193cd5c9c$export$be9b2b1329ff7ec9);
    $parcel$export(module.exports, "JSW_CREATE_ISSUE_DIALOG", ()=>$62659eb193cd5c9c$export$aa348159181703a0);
    $parcel$export(module.exports, "ISSUE_VIEW_CREATE_LINKED_ISSUE", ()=>$62659eb193cd5c9c$export$f90eec3841adf619);
    $parcel$export(module.exports, "COMMAND_PALETTE_CREATE_LINKED_ISSUE", ()=>$62659eb193cd5c9c$export$718822a309bffada);
    $parcel$export(module.exports, "SERVICE_DESK_LINKED_ISSUE_TRIGEER", ()=>$62659eb193cd5c9c$export$2753dafac81e805c);
    $parcel$export(module.exports, "JSW_INCIDENTS_CREATE_JSM_PIR_TRIGGER", ()=>$62659eb193cd5c9c$export$7c4d5cc5711d9294);
    $parcel$export(module.exports, "JPO_DIALOGS_CREATE_ISSUE_TRIGGER", ()=>$62659eb193cd5c9c$export$998dfc72404b9e14);
    $parcel$export(module.exports, "JSW_ADAPTED_GLOBAL_ISSUE_CREATE", ()=>$62659eb193cd5c9c$export$fc180a4b5785d2f4);
    $parcel$export(module.exports, "JSW_CREATE_EPIC_ISSUE", ()=>$62659eb193cd5c9c$export$946ec0b21cb84fd0);
    $parcel$export(module.exports, "CREATE_ISSUE_ACTIVE_SPRINT_EMPTY_VIEW", ()=>$62659eb193cd5c9c$export$5b97e2844e620e54);
    $parcel$export(module.exports, "CREATE_SUBTASK_NIN_TRIGGER", ()=>$62659eb193cd5c9c$export$b99842c2cf46f6be);
    $parcel$export(module.exports, "TRIGGER_POINT_KEY_NOT_DEFINED", ()=>$62659eb193cd5c9c$export$8d987f6e80b74000);
    $parcel$export(module.exports, "ISSUE_PARENT_SWITCHER_FIELD_CREATE_ISSUE", ()=>$62659eb193cd5c9c$export$8de9fa43731c4b5b);
    $parcel$export(module.exports, "POLARIS_CREATE_DELIVERY_ISSUE", ()=>$62659eb193cd5c9c$export$87249ccbfd10fb78);
    $parcel$export(module.exports, "HOME_PAGE_DEFAULT_OPEN_GIC", ()=>$62659eb193cd5c9c$export$c0eeeb31d264de76);
    $parcel$export(module.exports, "ISSUE_CREATE_EMBEDDABLE_TRIGGER", ()=>$62659eb193cd5c9c$export$f546e18e46478c84);
    $parcel$export(module.exports, "DEVELOPER_ESCALATIONS_ISSUE_CREATE_TRIGGER", ()=>$62659eb193cd5c9c$export$1784e634ba79f1f9);
    $parcel$export(module.exports, "JWM_INLINE_CREATE", ()=>$62659eb193cd5c9c$export$145eb8935a34e85e);
    $parcel$export(module.exports, "POLARIS_GLOBAL_SUBMIT_IDEA_SWITCH_PROJECTS_TRIGGER", ()=>$62659eb193cd5c9c$export$32648b574a536c8b);
    $parcel$export(module.exports, "ALLOWED_EXTERNAL_CONTROLS", ()=>$62659eb193cd5c9c$export$c0e2ab74dfaa67cc);
    const $62659eb193cd5c9c$export$a05673a22505d5ee = 'forge-open-issue-create';
    const $62659eb193cd5c9c$export$c78d329777576aa0 = 'global-create-button';
    const $62659eb193cd5c9c$export$992ab052fd10f8e8 = 'mobile-global-create-button';
    const $62659eb193cd5c9c$export$affdc3af7a9a4677 = 'keyboard-shortcut';
    const $62659eb193cd5c9c$export$7e9cfd1f59e60910 = 'jsw-issue-view-create-issue-in-epic';
    const $62659eb193cd5c9c$export$708499dcd016e5e9 = 'jsw-issue-view-create-subtask';
    const $62659eb193cd5c9c$export$e1c8789144c4c810 = 'jsw-issue-view-ai-breakdown-child-issue';
    const $62659eb193cd5c9c$export$c5afabb7a17e802 = 'jsw-issue-view-ai-breakdown-subtask';
    const $62659eb193cd5c9c$export$2086a63173b79b56 = 'jsw-releases-create-issue';
    const $62659eb193cd5c9c$export$fe1e5e4597147709 = 'jsw-roadmap-create-issue';
    const $62659eb193cd5c9c$export$9bc326812a93707 = 'jsw-security-create-issue';
    const $62659eb193cd5c9c$export$f352934e06f44599 = 'jsm-calendar-create-change-request';
    const $62659eb193cd5c9c$export$6ae07c77acc64360 = 'jsm-create-incident-from-alert-detail';
    const $62659eb193cd5c9c$export$b41d0684e4b6ab1 = 'jsm-create-incident-from-alert-list';
    const $62659eb193cd5c9c$export$be9b2b1329ff7ec9 = 'jsm-empty-queue-create-request';
    const $62659eb193cd5c9c$export$235b856f54db8916 = 'jwm-board-create-issue';
    const $62659eb193cd5c9c$export$ebbb81a0a3406bcb = 'jwm-calendar-create-issue';
    const $62659eb193cd5c9c$export$8e135b62470e5f9a = 'jwm-list-create-issue';
    const $62659eb193cd5c9c$export$21ea58e7361c33ba = 'jwm-list-create-subtask';
    const $62659eb193cd5c9c$export$d2cf44b8c67cca33 = 'jwm-timeline-create-issue';
    const $62659eb193cd5c9c$export$894285d6d13375fd = 'jwm-timeline-create-subtask';
    const $62659eb193cd5c9c$export$aa348159181703a0 = 'software-create-issue-dialog';
    const $62659eb193cd5c9c$export$f90eec3841adf619 = 'create-linked-issue-issue-view';
    const $62659eb193cd5c9c$export$718822a309bffada = 'create-linked-issue-command-palette';
    const $62659eb193cd5c9c$export$2753dafac81e805c = 'service-desk-linked-issue-trigger';
    const $62659eb193cd5c9c$export$7c4d5cc5711d9294 = 'jsw-incidents-create-jsm-pir-trigger';
    const $62659eb193cd5c9c$export$6eb7318fea2f8ce0 = 'jsw-incidents-create-issue-trigger';
    const $62659eb193cd5c9c$export$998dfc72404b9e14 = 'jpo-dialogs-jira-create-issue';
    const $62659eb193cd5c9c$export$fc180a4b5785d2f4 = 'jsw-adapted-global-issue-create-trigger';
    const $62659eb193cd5c9c$export$946ec0b21cb84fd0 = 'jsw-create-epic-issue';
    const $62659eb193cd5c9c$export$dba86c91ec4fdbf0 = 'create-issue-backlog-trigger';
    const $62659eb193cd5c9c$export$b5cdfd7f3bb79a7 = 'create-epic-issue-backlog-trigger';
    const $62659eb193cd5c9c$export$a8199da3cfab0e8 = 'create-issue-in-epic-backlog-trigger';
    const $62659eb193cd5c9c$export$5b97e2844e620e54 = 'create-issue-active-sprint-empty-view-trigger';
    const $62659eb193cd5c9c$export$569f5ff8afa08896 = 'create-linked-issue-issue-navigator-trigger';
    const $62659eb193cd5c9c$export$bafd52474e9ff4e = 'jwm-summary-create-first-issue-trigger';
    const $62659eb193cd5c9c$export$87f86192eaf0fdf = 'create-subtask-issue-navigator-trigger';
    const $62659eb193cd5c9c$export$b99842c2cf46f6be = 'create-subtask-new-issue-navigator-trigger';
    const $62659eb193cd5c9c$export$1e467d0a3f53a410 = 'jwm-board-embed-issue-create';
    const $62659eb193cd5c9c$export$8d987f6e80b74000 = 'trigger-point-key-not-defined';
    const $62659eb193cd5c9c$export$867e9a641a3c1457 = 'jwm-list-embed-issue-create';
    const $62659eb193cd5c9c$export$8de9fa43731c4b5b = 'issue-parent-switcher-field-create-issue';
    const $62659eb193cd5c9c$export$87249ccbfd10fb78 = 'polaris-create-delivery-issue';
    const $62659eb193cd5c9c$export$c0eeeb31d264de76 = 'home-page-default-open-gic';
    const $62659eb193cd5c9c$export$f546e18e46478c84 = 'issue-create-embed-trigger';
    const $62659eb193cd5c9c$export$1784e634ba79f1f9 = 'developer-escalations-issue-create-trigger';
    const $62659eb193cd5c9c$export$145eb8935a34e85e = 'jwm-inline-create';
    const $62659eb193cd5c9c$export$32648b574a536c8b = 'polaris-global-submit-idea-switch-project-trigger';
    const $62659eb193cd5c9c$export$818f24c6c32e18a = 'jira-calendar-create-issue';
    const $62659eb193cd5c9c$export$f352408886aa304b = 'connect-app-ecosystem';
    const $62659eb193cd5c9c$export$c0e2ab74dfaa67cc = {
        FIELD_IDS: [
            'description'
        ],
        TRIGGER_POINTS: [
            'service-desk-gen-ai-pir'
        ]
    };
});
parcelRegister("5rzqz", function(module, exports) {
    $parcel$export(module.exports, "useTriggerIssueCreateModal", ()=>$0a31d64d52b4b5e9$export$71e0eb7b8a91a156);
    $parcel$export(module.exports, "useOpenIssueCreateModal", ()=>$0a31d64d52b4b5e9$export$47cf258b1046080b);
    $parcel$export(module.exports, "withNewGICProvider", ()=>$0a31d64d52b4b5e9$export$558a195c5bfe3787);
    var $5uXOq = parcelRequire("5uXOq");
    var $7Jxgt = parcelRequire("7Jxgt");
    var $co1wz;
    var $4R6GH;
    var $1Nspv;
    var $bGrWH;
    var $8zOmE;
    var $lwMsT;
    var $f5nIZ;
    var $2YP9W;
    var $3sQ5x;
    var $iXqE5;
    var $51nlc;
    var $hULKg;
    var $cKWWX;
    var $6k7U1;
    const $0a31d64d52b4b5e9$export$d4c72bab9d6cc13a = {
        inProgressIssueID: undefined,
        isModalOpen: false,
        isSubsequentLoad: false,
        isSubTaskCreationOpen: false,
        isCreateLinkedIssue: false,
        wasStateRestored: false,
        payload: null,
        id: 'create-issue-dialog',
        title: null,
        sectionMessage: null,
        submitErrorMessage: undefined,
        globalEventNamespaces: [
            (0, (0, parcelRequire("bGrWH")).GLOBAL_EVENT_NAMESPACE)
        ],
        fieldsToAddInPublishedData: [],
        alertsToBeLinked: undefined,
        onIssueCreate: null,
        onClose: null,
        displayOnlyRequiredFields: false,
        disableCreationSuccessFlag: false,
        displayCreateAnotherIssueToggle: true,
        displaySitePicker: false,
        disableProjectDropdown: false,
        disableIssueTypeDropdown: false,
        triggerPointKey: (0, (0, parcelRequire("hULKg")).TRIGGER_POINT_KEY_NOT_DEFINED),
        context: undefined,
        minimizableModalView: 'modal',
        persistentModalView: undefined,
        shouldPushMiniModalDiscoverability: undefined,
        shouldShowMiniModalSpotlight: undefined,
        wasModalRetriggered: false,
        openIssueCreateModalNextState: {},
        shouldInitFetchConfig: false,
        interactedWithModalChangerButtons: false,
        isModalLoadInContext: false,
        disableMinimizableModal: false,
        displayMinimizableButtons: true,
        displayHeaderActionContainer: true,
        overrideUseRequestTypeFieldsToggleState: undefined,
        containerStyle: {},
        isMiniDesignEnabled: false,
        isEnrolledAndTargetedForGicMultipleLayouts: false,
        sessionId: undefined,
        FieldWrapperComponent: undefined,
        ExternalControls: undefined,
        isCustomBoardWithIcc: false,
        jqlSwimlaneId: undefined,
        swimlaneMode: undefined,
        prefilledCustomFields: {},
        ecosystemCallback: undefined,
        product: undefined,
        actionSource: undefined
    };
    const $0a31d64d52b4b5e9$export$e324594224ef24da = {
        restoreState: (stateToRestore)=>({ setState: setState, getState: getState })=>{
                const { isSubsequentLoad: isSubsequentLoad, isModalOpen: isModalOpen } = getState();
                if (!isModalOpen && stateToRestore.isModalOpen) (0, (0, parcelRequire("6k7U1")).startGlobalIssueCreateMetrics)(isSubsequentLoad);
                setState(stateToRestore);
            },
        openIssueCreateModal: (nextState)=>({ setState: setState, getState: getState })=>{
                const currentState = getState();
                if (currentState.isModalOpen) setState({
                    wasModalRetriggered: true,
                    openIssueCreateModalNextState: nextState
                });
                else {
                    (0, (0, parcelRequire("6k7U1")).startGlobalIssueCreateMetrics)(currentState.isSubsequentLoad);
                    const isDiscoverabilityPushEnabled = !currentState.isEnrolledAndTargetedForGicMultipleLayouts;
                    const isDiscoPushTriggerPoint = isDiscoverabilityPushEnabled && (0, (0, parcelRequire("6k7U1")).isPartOfDiscoverabilityTriggers)(nextState?.triggerPointKey);
                    const nextModalView = isDiscoverabilityPushEnabled ? (0, (0, parcelRequire("6k7U1")).getNextModalView)(isDiscoPushTriggerPoint, currentState.persistentModalView, $0a31d64d52b4b5e9$export$d4c72bab9d6cc13a.minimizableModalView) : 'modal';
                    setState({
                        ...$0a31d64d52b4b5e9$export$d4c72bab9d6cc13a,
                        ...isDiscoverabilityPushEnabled && {
                            minimizableModalView: nextModalView,
                            persistentModalView: currentState.persistentModalView,
                            ...(0, (0, parcelRequire("6k7U1")).discoverabilityPushModalViewOverride)(currentState.shouldPushMiniModalDiscoverability, isDiscoPushTriggerPoint, nextModalView)
                        },
                        inProgressIssueID: (0, ($parcel$interopDefault($7Jxgt))).v4(),
                        isSubsequentLoad: currentState.isSubsequentLoad,
                        isModalOpen: true,
                        wasModalRetriggered: currentState.isModalOpen,
                        ...nextState
                    });
                }
            },
        closeIssueCreateModal: (hasIssueCreated)=>({ setState: setState, getState: getState })=>{
                const currentState = getState();
                const isDiscoverabilityPushEnabled = !currentState.isEnrolledAndTargetedForGicMultipleLayouts;
                const isValidDiscoPushTriggerPoint = isDiscoverabilityPushEnabled && (0, (0, parcelRequire("6k7U1")).isPartOfDiscoverabilityTriggers)(currentState.triggerPointKey);
                const shouldUpdatePersistentModalView = isDiscoverabilityPushEnabled && hasIssueCreated && isValidDiscoPushTriggerPoint;
                const shouldPersistDiscoverabilityState = isDiscoverabilityPushEnabled && currentState.shouldPushMiniModalDiscoverability && !isValidDiscoPushTriggerPoint;
                setState({
                    ...$0a31d64d52b4b5e9$export$d4c72bab9d6cc13a,
                    callbackPayload: undefined,
                    ...shouldPersistDiscoverabilityState && {
                        shouldPushMiniModalDiscoverability: true
                    },
                    ...isDiscoverabilityPushEnabled && {
                        persistentModalView: currentState.persistentModalView
                    },
                    ...shouldUpdatePersistentModalView && {
                        persistentModalView: currentState.minimizableModalView === 'mini' ? 'mini' : 'modal'
                    },
                    isModalOpen: false,
                    isSubsequentLoad: true
                });
                (0, (0, parcelRequire("1Nspv")).CreateIssueUFOExperience).abort({
                    metadata: {
                        wasStateRestored: getState().wasStateRestored
                    }
                });
            },
        clearSectionMessage: ()=>({ setState: setState, getState: getState })=>{
                const currentState = getState();
                setState({
                    ...currentState,
                    sectionMessage: null
                });
            },
        setDisplayOnlyRequiredFields: (nextState)=>({ setState: setState, getState: getState })=>{
                const currentState = getState();
                setState({
                    ...currentState,
                    displayOnlyRequiredFields: nextState
                });
            },
        setMinimizableModalView: (minimizableModalView)=>({ setState: setState })=>{
                setState({
                    minimizableModalView: minimizableModalView,
                    interactedWithModalChangerButtons: true
                });
            },
        resetWasModalRetriggered: (applyNextState = false)=>({ setState: setState, getState: getState })=>{
                if (applyNextState) {
                    const currentState = getState();
                    (0, (0, parcelRequire("6k7U1")).startGlobalIssueCreateMetrics)(currentState.isSubsequentLoad);
                    setState({
                        ...$0a31d64d52b4b5e9$export$d4c72bab9d6cc13a,
                        ...!currentState.isEnrolledAndTargetedForGicMultipleLayouts && {
                            persistentModalView: currentState.persistentModalView
                        },
                        inProgressIssueID: currentState.inProgressIssueID,
                        isSubsequentLoad: currentState.isSubsequentLoad,
                        isModalOpen: true,
                        wasModalRetriggered: false,
                        minimizableModalView: 'modal',
                        openIssueCreateModalNextState: {},
                        shouldInitFetchConfig: true,
                        ...currentState.openIssueCreateModalNextState
                    });
                } else setState({
                    minimizableModalView: 'modal',
                    wasModalRetriggered: false,
                    openIssueCreateModalNextState: {}
                });
            },
        resetShouldInitFetchConfig: ()=>({ setState: setState })=>{
                setState({
                    shouldInitFetchConfig: false
                });
            },
        setCallbackPayload: (callbackPayload)=>({ setState: setState, getState: getState })=>{
                const currentState = getState();
                setState({
                    callbackPayload: {
                        id: currentState.callbackPayload?.id ?? '',
                        data: callbackPayload
                    }
                });
            },
        setShouldPushMiniModalDiscoverability: (shouldPushMiniModalDiscoverability)=>({ setState: setState, getState: getState })=>{
                const currentState = getState();
                if (currentState.isEnrolledAndTargetedForGicMultipleLayouts) return;
                setState({
                    shouldPushMiniModalDiscoverability: shouldPushMiniModalDiscoverability
                });
            },
        dismissModalSpotlight: ()=>({ setState: setState, getState: getState })=>{
                const currentState = getState();
                if (currentState.isEnrolledAndTargetedForGicMultipleLayouts) return;
                setState({
                    shouldShowMiniModalSpotlight: false
                });
            },
        setPersistentModalView: (persistentModalView)=>({ setState: setState, getState: getState })=>{
                const currentState = getState();
                if (currentState.isEnrolledAndTargetedForGicMultipleLayouts) return;
                setState({
                    persistentModalView: persistentModalView
                });
            },
        removeAlertFromAlertsToBeLinked: (alertId)=>({ setState: setState, getState: getState })=>{
                if (!(0, (0, parcelRequire("co1wz")).ff)('linked-alerts-in-gic_onvr6')) return;
                const currentState = getState();
                const alertsToBeLinked = currentState.alertsToBeLinked?.filter((entry)=>entry !== alertId);
                setState({
                    alertsToBeLinked: alertsToBeLinked
                });
            },
        setSessionId: (sessionId)=>({ setState: setState })=>{
                setState({
                    sessionId: sessionId
                });
            }
    };
    const $0a31d64d52b4b5e9$var$store = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'issue-create.issue-create-form.use-trigger-issue-create-modal',
        initialState: $0a31d64d52b4b5e9$export$d4c72bab9d6cc13a,
        actions: $0a31d64d52b4b5e9$export$e324594224ef24da
    });
    const $0a31d64d52b4b5e9$var$useTriggerIssueCreateModalState = (0, (0, parcelRequire("3sQ5x")).createStateHook)($0a31d64d52b4b5e9$var$store);
    const $0a31d64d52b4b5e9$var$useTriggerIssueCreateModalActions = (0, (0, parcelRequire("3sQ5x")).createActionsHook)($0a31d64d52b4b5e9$var$store);
    const $0a31d64d52b4b5e9$export$71e0eb7b8a91a156 = ()=>{
        const createState = $0a31d64d52b4b5e9$var$useTriggerIssueCreateModalState();
        const createActions = $0a31d64d52b4b5e9$var$useTriggerIssueCreateModalActions();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const { openIssueCreateModal: openIssueCreateModal, ...otherActions } = createActions;
        const openIssueCreateModalWithAnalytics = (0, $5uXOq.useCallback)((nextState)=>{
            const analyticsEvent = createAnalyticsEvent({});
            const attributes = {
                gicViewState: nextState?.minimizableModalView,
                isSubtask: nextState?.isSubTaskCreationOpen,
                triggerPointKey: nextState?.triggerPointKey,
                ...(0, (0, parcelRequire("4R6GH")).fg)('new-attributes-for-issue-create-anywhere') ? {
                    ...nextState?.product ? {
                        product: nextState.product
                    } : {},
                    ...nextState?.actionSource ? {
                        actionSource: nextState.actionSource
                    } : {}
                } : {}
            };
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalyticsDeferred)(analyticsEvent, 'issueCreateModal triggered', attributes);
            openIssueCreateModal(nextState);
        }, [
            createAnalyticsEvent,
            openIssueCreateModal
        ]);
        return [
            createState,
            {
                ...otherActions,
                openIssueCreateModal: openIssueCreateModalWithAnalytics
            }
        ];
    };
    const $0a31d64d52b4b5e9$export$47cf258b1046080b = ()=>{
        const { openIssueCreateModal: openIssueCreateModal } = $0a31d64d52b4b5e9$var$useTriggerIssueCreateModalActions();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const [, { setSitePickerState: setSitePickerState }] = (0, (0, parcelRequire("cKWWX")).useSitePickerContext)();
        return (0, $5uXOq.useCallback)((nextState)=>{
            const analyticsEvent = createAnalyticsEvent({});
            const attributes = {
                gicViewState: nextState?.minimizableModalView,
                isSubtask: nextState?.isSubTaskCreationOpen,
                triggerPointKey: nextState?.triggerPointKey,
                ...(0, (0, parcelRequire("4R6GH")).fg)('new-attributes-for-issue-create-anywhere') ? {
                    ...nextState?.product ? {
                        product: nextState.product
                    } : {},
                    ...nextState?.actionSource ? {
                        actionSource: nextState.actionSource
                    } : {}
                } : {}
            };
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalyticsDeferred)(analyticsEvent, 'issueCreateModal triggered', attributes);
            if (nextState?.payload?.overrideCloudId && (0, (0, parcelRequire("4R6GH")).fg)('jira_ai_issue_create_site_user_preference')) setSitePickerState({
                selectedCloudId: nextState?.payload?.overrideCloudId
            });
            openIssueCreateModal(nextState);
        }, [
            createAnalyticsEvent,
            openIssueCreateModal,
            setSitePickerState
        ]);
    };
    const $0a31d64d52b4b5e9$export$4c674fe824b8f278 = (0, (0, parcelRequire("51nlc")).createSubscriber)($0a31d64d52b4b5e9$var$store);
    function $0a31d64d52b4b5e9$export$558a195c5bfe3787(WrappedComponent) {
        return (props)=>{
            const [, { openIssueCreateModal: openIssueCreateModal, closeIssueCreateModal: closeIssueCreateModal }] = $0a31d64d52b4b5e9$export$71e0eb7b8a91a156();
            const { data: data } = (0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("f5nIZ")).gicOptInStatusResources));
            const currentIssueCreateVisibility = data && data?.gicOptInStatus;
            return (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                openIssueCreateModal: openIssueCreateModal,
                closeIssueCreateModal: closeIssueCreateModal,
                currentIssueCreateVisibility: currentIssueCreateVisibility?.isEnabled || false,
                ...props
            });
        };
    }
});
parcelRegister("1Nspv", function(module, exports) {
    $parcel$export(module.exports, "CreateIssueUFOExperience", ()=>$ff7fb599b8d98642$export$cd75c112ac11a83b);
    $parcel$export(module.exports, "StatusFieldLoad", ()=>$ff7fb599b8d98642$export$e890e797a25e655c);
    $parcel$export(module.exports, "GlobalIssueCreateModalSubmitUFOExperience", ()=>$ff7fb599b8d98642$export$70208657c8d471a7);
    $parcel$export(module.exports, "EcosystemAPIPrefillingUFOExperience", ()=>$ff7fb599b8d98642$export$b2d8f8edec75f571);
    var $cqpQr;
    var $fwViQ;
    const $ff7fb599b8d98642$export$cd75c112ac11a83b = new (0, (0, parcelRequire("fwViQ")).UFOExperience)('global-issue-create.create-issue', {
        type: (0, (0, parcelRequire("cqpQr")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("cqpQr")).ExperiencePerformanceTypes).Custom,
        category: 'global-issue-create.create-issue'
    });
    const $ff7fb599b8d98642$export$e890e797a25e655c = new (0, (0, parcelRequire("fwViQ")).UFOExperience)('global-issue-create.create-issue.status-field', {
        type: (0, (0, parcelRequire("cqpQr")).ExperienceTypes).Load,
        performanceType: (0, (0, parcelRequire("cqpQr")).ExperiencePerformanceTypes).PageSegmentLoad
    });
    const $ff7fb599b8d98642$export$70208657c8d471a7 = new (0, (0, parcelRequire("fwViQ")).UFOExperience)('modern-global-issue-create.modal.issue-submit', {
        type: (0, (0, parcelRequire("cqpQr")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("cqpQr")).ExperiencePerformanceTypes).Custom,
        category: 'modern-global-issue-create.modal.issue-submit'
    });
    const $ff7fb599b8d98642$export$b2d8f8edec75f571 = new (0, (0, parcelRequire("fwViQ")).UFOExperience)('ecosystem-api-new-gic-prefilling', {
        type: (0, (0, parcelRequire("cqpQr")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("cqpQr")).ExperiencePerformanceTypes).Custom,
        category: 'ecosystem-api-new-gic-prefilling'
    });
});
parcelRegister("bGrWH", function(module, exports) {
    $parcel$export(module.exports, "REQUIRED", ()=>$4aabf2a0e09eb856$export$b1c05b34d317c074);
    $parcel$export(module.exports, "FORM_DROPZONE_CONTAINER_ID", ()=>$4aabf2a0e09eb856$export$1a020bd73f33e5a);
    $parcel$export(module.exports, "MINIMISED_DROPZONE_CONTAINER_ID", ()=>$4aabf2a0e09eb856$export$9eadc594a5383580);
    $parcel$export(module.exports, "LOG_WORK_TIME_SPENT_ERROR_KEY", ()=>$4aabf2a0e09eb856$export$a1a7caa1e4a73c9f);
    $parcel$export(module.exports, "LOG_WORK_TIME_REMAINING_ERROR_KEY", ()=>$4aabf2a0e09eb856$export$cf70f9220e6a2f50);
    $parcel$export(module.exports, "LOG_WORK_DATE_ERROR_KEY", ()=>$4aabf2a0e09eb856$export$aac4661200ba4104);
    $parcel$export(module.exports, "LOG_WORK_DESCRIPTION_ERROR_KEY", ()=>$4aabf2a0e09eb856$export$a23c32d5cf54cba0);
    $parcel$export(module.exports, "COMMON_LOG_WORK_ERROR_KEYS", ()=>$4aabf2a0e09eb856$export$74ab3898ae683660);
    $parcel$export(module.exports, "MULTI_INPUT_FIELDS_ERROR_KEYS", ()=>$4aabf2a0e09eb856$export$983715bb9b0f9b2c);
    $parcel$export(module.exports, "DEFAULT_SCROLL_OPTIONS", ()=>$4aabf2a0e09eb856$export$40f6793dd75f4e52);
    $parcel$export(module.exports, "UNSUPPORTED_FIELD_TYPES_IN_GIC", ()=>$4aabf2a0e09eb856$export$3bf5bce483cc2c30);
    $parcel$export(module.exports, "ISSUE_CREATE_TYPE", ()=>$4aabf2a0e09eb856$export$30cc1fd33e7c7258);
    $parcel$export(module.exports, "GLOBAL_EVENT_NAMESPACE", ()=>$4aabf2a0e09eb856$export$8170252f0ea43511);
    const $4aabf2a0e09eb856$export$17bcab948893a9ba = 'worklog';
    const $4aabf2a0e09eb856$export$b1c05b34d317c074 = 'REQUIRED';
    const $4aabf2a0e09eb856$export$f10b32dfda12e96e = 'unknown';
    const $4aabf2a0e09eb856$export$e5e4b8c32e68dd0b = 'networkError';
    const $4aabf2a0e09eb856$export$2d06efb8146cd043 = 'graphQLError';
    const $4aabf2a0e09eb856$export$1a020bd73f33e5a = 'issue-create-modal-dropzone-container';
    const $4aabf2a0e09eb856$export$9eadc594a5383580 = 'minimised-issue-create-dropzone-container';
    const $4aabf2a0e09eb856$export$a1a7caa1e4a73c9f = 'worklog_timeLogged';
    const $4aabf2a0e09eb856$export$cf70f9220e6a2f50 = 'worklog_newEstimate';
    const $4aabf2a0e09eb856$export$aac4661200ba4104 = 'worklog_startDate';
    const $4aabf2a0e09eb856$export$a23c32d5cf54cba0 = 'worklog_description';
    const $4aabf2a0e09eb856$export$74ab3898ae683660 = [
        'worklog_adjustmentAmount',
        'worklog_adjustEstimate',
        'worklog_activate'
    ];
    const $4aabf2a0e09eb856$export$63fd567c1d0aca19 = [
        ...$4aabf2a0e09eb856$export$74ab3898ae683660,
        $4aabf2a0e09eb856$export$a1a7caa1e4a73c9f,
        $4aabf2a0e09eb856$export$cf70f9220e6a2f50,
        $4aabf2a0e09eb856$export$aac4661200ba4104,
        $4aabf2a0e09eb856$export$a23c32d5cf54cba0
    ];
    const $4aabf2a0e09eb856$export$983715bb9b0f9b2c = {
        [$4aabf2a0e09eb856$export$17bcab948893a9ba]: $4aabf2a0e09eb856$export$63fd567c1d0aca19
    };
    const $4aabf2a0e09eb856$export$40f6793dd75f4e52 = {
        behavior: 'auto',
        scrollMode: 'if-needed',
        block: 'start'
    };
    const $4aabf2a0e09eb856$export$3bf5bce483cc2c30 = [
        'com.atlassian.servicedesk:sd-request-participants'
    ];
    const $4aabf2a0e09eb856$export$30cc1fd33e7c7258 = {
        linkedIssue: 'LINKED_ISSUE_CREATE',
        standard: 'STANDARD'
    };
    const $4aabf2a0e09eb856$export$8170252f0ea43511 = 'QuickCreateIssue';
});
parcelRegister("cKWWX", function(module, exports) {
    $parcel$export(module.exports, "useSitePickerContext", ()=>$c8055d212e869a3c$export$f8b5aae013e4cf77);
    var $3sQ5x;
    var $iXqE5;
    const $c8055d212e869a3c$export$d4c72bab9d6cc13a = {
        selectedCloudId: '',
        siteDomain: ''
    };
    const $c8055d212e869a3c$export$e324594224ef24da = {
        setSitePickerState: ({ selectedCloudId: selectedCloudId, siteDomain: siteDomain })=>({ setState: setState, getState: getState })=>{
                const currentState = getState();
                setState({
                    ...currentState,
                    selectedCloudId: selectedCloudId || '',
                    siteDomain: siteDomain || ''
                });
            }
    };
    const $c8055d212e869a3c$export$6f57813fe9f31bf9 = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'issue.fields.site-picker',
        initialState: $c8055d212e869a3c$export$d4c72bab9d6cc13a,
        actions: $c8055d212e869a3c$export$e324594224ef24da
    });
    const $c8055d212e869a3c$export$f8b5aae013e4cf77 = (0, (0, parcelRequire("3sQ5x")).createHook)($c8055d212e869a3c$export$6f57813fe9f31bf9);
});
parcelRegister("6k7U1", function(module, exports) {
    $parcel$export(module.exports, "startGlobalIssueCreateMetrics", ()=>$8a2e4df39a48d5af$export$550b19803bc962ec);
    $parcel$export(module.exports, "isPartOfDiscoverabilityTriggers", ()=>$8a2e4df39a48d5af$export$f6bc17a4d9120156);
    $parcel$export(module.exports, "discoverabilityPushModalViewOverride", ()=>$8a2e4df39a48d5af$export$8d246e5e04f0b424);
    $parcel$export(module.exports, "getNextModalView", ()=>$8a2e4df39a48d5af$export$720579602bb055a2);
    var $5gzbX;
    var $1Nspv;
    var $gEaAu;
    var $huY3x;
    const $8a2e4df39a48d5af$export$550b19803bc962ec = (isSubsequentLoad)=>{
        (0, (0, parcelRequire("1Nspv")).CreateIssueUFOExperience).start();
        const globalIssueCreateModalLoadMetric = isSubsequentLoad ? (0, (0, parcelRequire("gEaAu")).globalIssueCreateModalLoadSubsequent) : (0, (0, parcelRequire("gEaAu")).globalIssueCreateModalLoad);
        if (isSubsequentLoad) (0, (0, parcelRequire("5gzbX")).default)('global-issue.create-modal-subsequent');
        else (0, (0, parcelRequire("5gzbX")).default)('global-issue.create-modal');
        globalIssueCreateModalLoadMetric.start();
        (0, (0, parcelRequire("huY3x")).startGlobalIssueCreateTTIWithAdjustments)();
    };
    const $8a2e4df39a48d5af$export$f6bc17a4d9120156 = (triggerPoint)=>{
        if (!triggerPoint) return false;
        const acceptedTriggerPoints = [
            'global-create-button',
            'keyboard-shortcut'
        ];
        return acceptedTriggerPoints.includes(triggerPoint);
    };
    const $8a2e4df39a48d5af$export$8d246e5e04f0b424 = (shouldPushDiscoverability, isTriggerAccepted, defaultView = 'modal')=>{
        if (!shouldPushDiscoverability) return undefined;
        return {
            minimizableModalView: isTriggerAccepted ? 'mini' : defaultView,
            shouldPushMiniModalDiscoverability: true,
            shouldShowMiniModalSpotlight: isTriggerAccepted
        };
    };
    const $8a2e4df39a48d5af$export$720579602bb055a2 = (isTriggerAccepted, persistentView, defaultView = 'modal')=>{
        if (isTriggerAccepted) return persistentView || defaultView;
        return defaultView;
    };
});
parcelRegister("gEaAu", function(module, exports) {
    $parcel$export(module.exports, "globalIssueCreateModalLoad", ()=>$ee246606338fc99e$export$5a01a7fa84b239c8);
    $parcel$export(module.exports, "globalIssueCreateModalLoadSubsequent", ()=>$ee246606338fc99e$export$c50ad3c31b6fcfc6);
    $parcel$export(module.exports, "successFlagDisplay", ()=>$ee246606338fc99e$export$4b2382574525bb0f);
    $parcel$export(module.exports, "successFlagAddToSprintAction", ()=>$ee246606338fc99e$export$7839bdaa2f6a2385);
    $parcel$export(module.exports, "successFlagClearFiltersAction", ()=>$ee246606338fc99e$export$c1592e4d8d98963e);
    var $55AbO;
    const $ee246606338fc99e$export$5a01a7fa84b239c8 = (0, (0, parcelRequire("55AbO")).metrics).interaction({
        key: 'global-issue-create-modal'
    });
    const $ee246606338fc99e$export$c50ad3c31b6fcfc6 = (0, (0, parcelRequire("55AbO")).metrics).interaction({
        key: 'global-issue-create-modal-subsequent'
    });
    const $ee246606338fc99e$export$4b2382574525bb0f = (0, (0, parcelRequire("55AbO")).metrics).interaction({
        key: 'global-issue-create-dynamic-success-flag-display'
    });
    const $ee246606338fc99e$export$7839bdaa2f6a2385 = (0, (0, parcelRequire("55AbO")).metrics).interaction({
        key: 'global-issue-create-dynamic-success-flag-add-to-sprint-action'
    });
    const $ee246606338fc99e$export$c1592e4d8d98963e = (0, (0, parcelRequire("55AbO")).metrics).interaction({
        key: 'global-issue-create-dynamic-success-flag-clear-filters-action'
    });
});
parcelRegister("huY3x", function(module, exports) {
    $parcel$export(module.exports, "globalIssueCreateTTIWithAdjustments", ()=>$06c7e44c59602f0c$export$9f3d6f17e1da7874);
    $parcel$export(module.exports, "startGlobalIssueCreateTTIWithAdjustments", ()=>$06c7e44c59602f0c$export$457c9fb71ad5b3a9);
    $parcel$export(module.exports, "markGicTti", ()=>$06c7e44c59602f0c$export$ef664dac649a716c);
    $parcel$export(module.exports, "stopTTI", ()=>$06c7e44c59602f0c$export$30ca4c461fab486c);
    $parcel$export(module.exports, "cancelTTI", ()=>$06c7e44c59602f0c$export$27f2445288b528c);
    $parcel$export(module.exports, "markIframeLoad", ()=>$06c7e44c59602f0c$export$7a2709fc1e33401a);
    $parcel$export(module.exports, "markFieldsRegistered", ()=>$06c7e44c59602f0c$export$cf3893335c93e33b);
    $parcel$export(module.exports, "markOnInitResolved", ()=>$06c7e44c59602f0c$export$d86f4868694f2aa7);
    var $55AbO;
    var $a1HyB;
    const $06c7e44c59602f0c$export$9f3d6f17e1da7874 = (0, (0, parcelRequire("55AbO")).metrics).interaction({
        key: 'global-issue-create-tti-with-adjustments',
        timings: [
            {
                key: 'gic-tti-delta',
                startMark: 'gic-tti'
            },
            {
                key: 'script-execution',
                startMark: 'iframe-load'
            },
            {
                key: 'loading-indicators-visibility',
                startMark: 'fields-registered'
            },
            {
                key: 'time-until-oninit-resolved',
                endMark: 'oninit-resolved'
            },
            {
                key: 'gic-all-fields-tti',
                endMark: 'gic-all-fields-loaded'
            }
        ],
        featureFlags: (0, (0, parcelRequire("a1HyB")).TTIFFs)
    });
    const $06c7e44c59602f0c$export$457c9fb71ad5b3a9 = ()=>{
        $06c7e44c59602f0c$export$9f3d6f17e1da7874.start();
    };
    const $06c7e44c59602f0c$export$ef664dac649a716c = ()=>$06c7e44c59602f0c$export$9f3d6f17e1da7874.mark('gic-tti');
    const $06c7e44c59602f0c$export$30ca4c461fab486c = (customData)=>{
        $06c7e44c59602f0c$export$9f3d6f17e1da7874.stop({
            customData: customData
        });
    };
    const $06c7e44c59602f0c$export$27f2445288b528c = ()=>{
        $06c7e44c59602f0c$export$9f3d6f17e1da7874.cancel();
    };
    const $06c7e44c59602f0c$export$7a2709fc1e33401a = ()=>{
        $06c7e44c59602f0c$export$9f3d6f17e1da7874.mark('iframe-load');
    };
    const $06c7e44c59602f0c$export$cf3893335c93e33b = ()=>{
        $06c7e44c59602f0c$export$9f3d6f17e1da7874.mark('fields-registered');
    };
    const $06c7e44c59602f0c$export$d86f4868694f2aa7 = ()=>{
        $06c7e44c59602f0c$export$9f3d6f17e1da7874.mark('oninit-resolved');
    };
});
parcelRegister("a1HyB", function(module, exports) {
    $parcel$export(module.exports, "TTIFFs", ()=>$aec371b77b607203$export$c396ba1504d97f3f);
    const $aec371b77b607203$export$c396ba1504d97f3f = [];
});
parcelRegister("3ZKGh", function(module, exports) {
    $parcel$export(module.exports, "buildGICPayload", ()=>$1e0041a78523c89b$export$eb18ffe6388f217a);
    var $f9ece;
    var $hE5wF;
    var $5fc53;
    const $1e0041a78523c89b$var$assigneeFieldPredicate = (field)=>field.type === (0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE);
    const $1e0041a78523c89b$var$categoryFieldPredicate = (field)=>field.type === (0, (0, parcelRequire("5fc53")).CATEGORY_TYPE);
    const $1e0041a78523c89b$var$dueDateFieldPredicate = (field)=>field.type === (0, (0, parcelRequire("5fc53")).DUE_DATE_TYPE);
    const $1e0041a78523c89b$var$priorityFieldPredicate = (field)=>field.type === (0, (0, parcelRequire("5fc53")).PRIORITY_TYPE);
    const $1e0041a78523c89b$var$startDateFieldPredicate = (field)=>field.aliasFieldId === (0, (0, parcelRequire("hE5wF")).START_DATE_ALIAS_FIELD_ID);
    const $1e0041a78523c89b$var$storyPointEstimateFieldPredicate = (field)=>field.type === (0, (0, parcelRequire("5fc53")).STORY_POINT_ESTIMATE_CF_TYPE);
    const $1e0041a78523c89b$var$storyPointsFieldPredicate = (field)=>field.type === (0, (0, parcelRequire("5fc53")).NUMBER_CF_TYPE) && field.aliasFieldId === (0, (0, parcelRequire("hE5wF")).STORY_POINTS_ALIAS_FIELD_ID);
    const $1e0041a78523c89b$var$sprintFieldPredicate = (field)=>field.type === (0, (0, parcelRequire("5fc53")).SPRINT_TYPE);
    const $1e0041a78523c89b$export$eb18ffe6388f217a = ({ createInput: createInput, extraPayload: extraPayload, rankField: rankField, getField: getField })=>{
        const payload = {
            defaultValues: {
                singleLineTextFields: [],
                singleSelectUserPickerFields: [],
                numberFields: [],
                datePickerFields: []
            },
            project: {
                projectId: createInput.projectId
            }
        };
        const additionalFields = {};
        let transition;
        if (createInput.summary) payload.defaultValues.singleLineTextFields.push({
            fieldId: (0, (0, parcelRequire("5fc53")).SUMMARY_TYPE),
            text: createInput.summary
        });
        if (createInput.issueType) payload.issueType = {
            issueTypeId: createInput.issueType.id
        };
        if (createInput.dueDate && getField(createInput.issueType, $1e0041a78523c89b$var$dueDateFieldPredicate)) {
            const formattedDueDate = (0, (0, parcelRequire("f9ece")).default)(createInput.dueDate, 'UTC', 'yyyy-MM-dd');
            payload.defaultValues.datePickerFields.push({
                fieldId: (0, (0, parcelRequire("5fc53")).DUE_DATE_TYPE),
                date: {
                    formattedDate: formattedDueDate
                }
            });
            additionalFields.duedate = formattedDueDate;
        }
        const startDateField = getField(createInput.issueType, $1e0041a78523c89b$var$startDateFieldPredicate);
        if (createInput.startDate && startDateField) {
            const formattedStartDate = (0, (0, parcelRequire("f9ece")).default)(createInput.startDate, 'UTC', 'yyyy-MM-dd');
            payload.defaultValues.datePickerFields.push({
                fieldId: startDateField.id,
                date: {
                    formattedDate: formattedStartDate
                }
            });
            additionalFields[startDateField.id] = formattedStartDate;
        }
        if (createInput.assignee && getField(createInput.issueType, $1e0041a78523c89b$var$assigneeFieldPredicate)) {
            payload.defaultValues.singleSelectUserPickerFields.push({
                fieldId: (0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE),
                user: {
                    accountId: createInput.assignee.accountId
                }
            });
            additionalFields[0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE] = {
                id: createInput.assignee.accountId
            };
        }
        if (createInput.priority && getField(createInput.issueType, $1e0041a78523c89b$var$priorityFieldPredicate)) {
            payload.defaultValues.priority = {
                priorityId: createInput.priority.priorityId
            };
            additionalFields[0, (0, parcelRequire("5fc53")).PRIORITY_TYPE] = {
                id: createInput.priority.priorityId
            };
        }
        const categoryField = getField(createInput.issueType, $1e0041a78523c89b$var$categoryFieldPredicate);
        if (createInput.category && categoryField) {
            payload.defaultValues.singleSelectFields = [
                {
                    fieldId: categoryField.id,
                    option: {
                        id: createInput.category.optionId,
                        optionId: createInput.category.optionId
                    }
                }
            ];
            additionalFields[categoryField.id] = {
                id: createInput.category.optionId,
                value: createInput.category.value
            };
        }
        const storyPointEstimateField = getField(createInput.issueType, $1e0041a78523c89b$var$storyPointEstimateFieldPredicate);
        if (createInput.storyPointEstimate && storyPointEstimateField) {
            payload.defaultValues.numberFields.push({
                fieldId: storyPointEstimateField.id,
                value: createInput.storyPointEstimate
            });
            additionalFields[storyPointEstimateField.id] = {
                id: storyPointEstimateField.id,
                value: createInput.storyPointEstimate
            };
        }
        const storyPointsField = getField(createInput.issueType, $1e0041a78523c89b$var$storyPointsFieldPredicate);
        if (createInput.storyPoints && storyPointsField) {
            payload.defaultValues.numberFields.push({
                fieldId: storyPointsField.id,
                value: createInput.storyPoints
            });
            additionalFields[storyPointsField.id] = {
                id: storyPointsField.id,
                value: createInput.storyPoints
            };
        }
        const sprintField = getField(createInput.issueType, $1e0041a78523c89b$var$sprintFieldPredicate);
        if (createInput.sprint && sprintField) {
            payload.defaultValues.sprintsField = {
                fieldId: sprintField.id,
                sprints: [
                    {
                        sprintId: createInput.sprint.id
                    }
                ]
            };
            additionalFields[sprintField.id] = {
                id: sprintField.id,
                value: createInput.sprint.id
            };
        }
        if (createInput.parentIssueId) {
            payload.parentId = {
                parentId: createInput.parentIssueId
            };
            payload.defaultValues.parentField = {
                issueId: createInput.parentIssueId
            };
        }
        if (createInput.status && extraPayload?.transitionId) {
            payload.status = {
                statusId: createInput.status.statusId
            };
            transition = {
                id: extraPayload.transitionId
            };
        }
        if (rankField && (createInput.rankAfter || createInput.rankBefore)) additionalFields[rankField.id] = {
            ...createInput.rankAfter ? {
                rankAfterIssue: createInput.rankAfter.issueId
            } : {},
            ...createInput.rankBefore ? {
                rankBeforeIssue: createInput.rankBefore.issueId
            } : {}
        };
        return {
            payload: payload,
            submitApiData: {
                additionalFields: additionalFields,
                transition: transition
            }
        };
    };
});
parcelRegister("lVeTj", function(module, exports) {
    $parcel$export(module.exports, "useShowCreateSuccessFlag", ()=>$374f26855338ec61$export$dfe953d11a91d407);
    var $5uXOq = parcelRequire("5uXOq");
    var $hE5wF;
    var $l0oHX;
    var $6s1PB;
    var $pa9q9;
    var $koVbs;
    var $ieDtd;
    var $7dMty;
    const $374f26855338ec61$export$dfe953d11a91d407 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        const [, setSelectedIssueKey] = (0, (0, parcelRequire("ieDtd")).useQueryParam)((0, (0, parcelRequire("hE5wF")).SELECTED_ISSUE_PARAM));
        return (0, $5uXOq.useCallback)((issueKey)=>{
            const flagId = `jwm-create-success-flag-${issueKey}`;
            showFlag({
                id: flagId,
                isAutoDismiss: true,
                type: 'success',
                title: formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("7dMty")).default).createSuccessFlagTitleIssueTermRefresh : (0, (0, parcelRequire("7dMty")).default).createSuccessFlagTitle, {
                    issueKey: issueKey
                }),
                actions: [
                    {
                        content: (0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("7dMty")).default).viewIssueLinkTextIssueTermRefresh : (0, (0, parcelRequire("7dMty")).default).viewIssueLinkText,
                        href: `/browse/${issueKey}`,
                        onClick: (event)=>{
                            if (event && !(0, (0, parcelRequire("l0oHX")).isModifiedEvent)(event)) {
                                setSelectedIssueKey(issueKey);
                                event.preventDefault();
                                event.stopPropagation();
                            }
                            dismissFlag(flagId);
                        }
                    }
                ]
            });
        }, [
            dismissFlag,
            formatMessage,
            setSelectedIssueKey,
            showFlag
        ]);
    };
});
parcelRegister("l0oHX", function(module, exports) {
    $parcel$export(module.exports, "isModifiedEvent", ()=>$6c9cca471f547e7f$export$642c6f14f6d4bbd5);
    const $6c9cca471f547e7f$export$642c6f14f6d4bbd5 = (event)=>Boolean(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
});
parcelRegister("7dMty", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9ecb7a23bce33f96$export$2e2bcd8739ae039);
    var $7VHMR;
    var $9ecb7a23bce33f96$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        createSuccessFlagTitle: {
            "id": "business-issue-create.controllers.show-create-success-flag.create-success-flag-title",
            "defaultMessage": "You've created issue \"{issueKey}\""
        },
        viewIssueLinkText: {
            "id": "business-issue-create.controllers.show-create-success-flag.view-issue-link-text",
            "defaultMessage": "View issue"
        },
        createSuccessFlagTitleIssueTermRefresh: {
            "id": "business-issue-create.controllers.show-create-success-flag.create-success-flag-title-issue-term-refresh",
            "defaultMessage": "You've created work item \"{issueKey}\""
        },
        viewIssueLinkTextIssueTermRefresh: {
            "id": "business-issue-create.controllers.show-create-success-flag.view-issue-link-text-issue-term-refresh",
            "defaultMessage": "View work item"
        }
    });
});
parcelRegister("fb3JB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$87c4612732d8fc8d$export$2e2bcd8739ae039);
    var $7VHMR;
    var $87c4612732d8fc8d$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        errorFlagTitle: {
            "id": "business-issue-create.controllers.create-issue.error-flag-title",
            "defaultMessage": "We weren't able to create an issue"
        },
        errorFlagDescription: {
            "id": "business-issue-create.controllers.create-issue.error-flag-description",
            "defaultMessage": "Refresh the page and try again."
        },
        errorFlagTitleIssueTermRefresh: {
            "id": "business-issue-create.controllers.create-issue.error-flag-title-issue-term-refresh",
            "defaultMessage": "We weren't able to create a work item"
        }
    });
});
parcelRegister("ecPXN", function(module, exports) {
    $parcel$export(module.exports, "useCreateParamHandler", ()=>$eb6f03408afb5aea$export$294bf5b0ba86140);
    var $5uXOq = parcelRequire("5uXOq");
    var $hE5wF;
    var $daQYX;
    var $ieDtd;
    var $8roPX;
    const $eb6f03408afb5aea$export$294bf5b0ba86140 = ()=>{
        const [inlineCreateParam, setInlineCreateParam] = (0, (0, parcelRequire("ieDtd")).useQueryParam)((0, (0, parcelRequire("hE5wF")).INLINE_CREATE_PARAM));
        const showCreateIssueDialog = (0, (0, parcelRequire("8roPX")).useCreateIssueDialog)();
        const project = (0, (0, parcelRequire("daQYX")).useProject)();
        (0, $5uXOq.useEffect)(()=>{
            if (inlineCreateParam != null) {
                showCreateIssueDialog({
                    projectId: String(project.id)
                }).catch(()=>{});
                setInlineCreateParam(undefined);
            }
        }, [
            inlineCreateParam,
            project,
            setInlineCreateParam,
            showCreateIssueDialog
        ]);
    };
});
parcelRegister("gNAqw", function(module, exports) {
    $parcel$export(module.exports, "TIMELINE_PARENT_LEVEL", ()=>$962421c2e4d155ee$export$6e8d55b449655862);
    $parcel$export(module.exports, "TIMELINE_CHILD_LEVEL", ()=>$962421c2e4d155ee$export$f6acdc1bda8a6425);
    $parcel$export(module.exports, "TIMELINE_EPIC_HIERARCHY_LEVEL", ()=>$962421c2e4d155ee$export$24a7d783c2bdcbc2);
    $parcel$export(module.exports, "TIMELINE_SUBTASK_HIERARCHY_LEVEL", ()=>$962421c2e4d155ee$export$dc01266f5a500c9e);
    $parcel$export(module.exports, "TIMELINE_ROOT_DEPTH", ()=>$962421c2e4d155ee$export$35b86881ab3777f7);
    $parcel$export(module.exports, "fieldIds", ()=>$962421c2e4d155ee$export$b5b496642be4236d);
    $parcel$export(module.exports, "DEPENDENCY_DRAG_ITEM_ID", ()=>$962421c2e4d155ee$export$48a2b55760ce2355);
    $parcel$export(module.exports, "MAIN_EXPERIENCE", ()=>$962421c2e4d155ee$export$b3d8a68bfc68a411);
    $parcel$export(module.exports, "LINK_ISSUES_EXPERIENCE", ()=>$962421c2e4d155ee$export$aea4881e85e2e4d9);
    $parcel$export(module.exports, "UNLINK_ISSUES_EXPERIENCE", ()=>$962421c2e4d155ee$export$1225c124f186defa);
    $parcel$export(module.exports, "LOAD_CHILD_ISSUES_EXPERIENCE", ()=>$962421c2e4d155ee$export$372aa8438498eb82);
    $parcel$export(module.exports, "LOAD_MORE_EXPERIENCE", ()=>$962421c2e4d155ee$export$a435f2d9a52cd0ab);
    $parcel$export(module.exports, "SCHEDULE_ITEM_EXPERIENCE", ()=>$962421c2e4d155ee$export$1f9cf4c341d296a1);
    $parcel$export(module.exports, "JIRA_SCHEDULE_ITEM_EXPERIENCE", ()=>$962421c2e4d155ee$export$6f919d9c4954fa69);
    $parcel$export(module.exports, "RANK_ISSUE_EXPERIENCE", ()=>$962421c2e4d155ee$export$1cc6cf3582688fdd);
    $parcel$export(module.exports, "EXPORT_IMAGE_EXPERIENCE", ()=>$962421c2e4d155ee$export$8cc7d26eb8be8d4b);
    $parcel$export(module.exports, "EXPORT_CSV_EXPERIENCE", ()=>$962421c2e4d155ee$export$bdaa4d19340650e7);
    const $962421c2e4d155ee$var$PACKAGE_NAME = 'jiraBusinessTimeline';
    const $962421c2e4d155ee$export$6e8d55b449655862 = 1;
    const $962421c2e4d155ee$export$f6acdc1bda8a6425 = 0;
    const $962421c2e4d155ee$export$24a7d783c2bdcbc2 = 1;
    const $962421c2e4d155ee$export$dc01266f5a500c9e = -1;
    const $962421c2e4d155ee$export$35b86881ab3777f7 = 0;
    const $962421c2e4d155ee$export$b5b496642be4236d = [
        'issuekey',
        'issuetype',
        'summary',
        'status',
        'assignee',
        'startdate',
        'duedate',
        'rank',
        'subtasks',
        'childIssues',
        'issuelinks',
        'parent'
    ];
    const $962421c2e4d155ee$export$48a2b55760ce2355 = 'dependency-drag-id';
    const $962421c2e4d155ee$export$c330e9be73819573 = 'dependencies-drop-target';
    const $962421c2e4d155ee$export$b3d8a68bfc68a411 = {
        experience: 'timelineView',
        packageName: $962421c2e4d155ee$var$PACKAGE_NAME,
        teamName: 'jira-yurree'
    };
    const $962421c2e4d155ee$export$aea4881e85e2e4d9 = {
        experience: 'linkIssues',
        packageName: $962421c2e4d155ee$var$PACKAGE_NAME,
        teamName: 'jira-yurree'
    };
    const $962421c2e4d155ee$export$1225c124f186defa = {
        experience: 'unlinkIssues',
        packageName: $962421c2e4d155ee$var$PACKAGE_NAME,
        teamName: 'jira-yurree'
    };
    const $962421c2e4d155ee$export$372aa8438498eb82 = {
        experience: 'loadChildIssues',
        packageName: $962421c2e4d155ee$var$PACKAGE_NAME,
        teamName: 'jira-yurree'
    };
    const $962421c2e4d155ee$export$a435f2d9a52cd0ab = {
        experience: 'loadMore',
        packageName: $962421c2e4d155ee$var$PACKAGE_NAME,
        teamName: 'jira-yurree'
    };
    const $962421c2e4d155ee$export$1f9cf4c341d296a1 = {
        experience: 'scheduleItem',
        packageName: $962421c2e4d155ee$var$PACKAGE_NAME,
        teamName: 'jira-yurree'
    };
    const $962421c2e4d155ee$export$6f919d9c4954fa69 = {
        experience: 'jiraScheduleItem',
        packageName: $962421c2e4d155ee$var$PACKAGE_NAME,
        teamName: 'jira-yurree'
    };
    const $962421c2e4d155ee$export$1cc6cf3582688fdd = {
        experience: 'rankIssue',
        packageName: $962421c2e4d155ee$var$PACKAGE_NAME,
        teamName: 'jira-yurree'
    };
    const $962421c2e4d155ee$export$8cc7d26eb8be8d4b = {
        experience: 'exportImage',
        packageName: $962421c2e4d155ee$var$PACKAGE_NAME,
        teamName: 'jira-yurree'
    };
    const $962421c2e4d155ee$export$bdaa4d19340650e7 = {
        experience: 'exportCsv',
        packageName: $962421c2e4d155ee$var$PACKAGE_NAME,
        teamName: 'jira-yurree'
    };
    const $962421c2e4d155ee$export$8d823d9dee471765 = {
        experience: 'updateParentIssue',
        packageName: $962421c2e4d155ee$var$PACKAGE_NAME,
        teamName: 'jira-yurree'
    };
});
parcelRegister("kjQs8", function(module, exports) {
    $parcel$export(module.exports, "useTimelineUI", ()=>$721c836380912b51$export$ea99d7f13ae5e9bd);
    var $5uXOq = parcelRequire("5uXOq");
    var $x8FYU;
    var $1kpI8;
    var $iZN6h;
    var $g11uZ;
    var $kvSZW;
    const $721c836380912b51$var$validTimelineModes = new Set([
        (0, (0, parcelRequire("iZN6h")).WEEKS),
        (0, (0, parcelRequire("iZN6h")).MONTHS),
        (0, (0, parcelRequire("iZN6h")).QUARTERS)
    ]);
    const $721c836380912b51$var$useRangeMode = ()=>{
        const [rangeModePreference, setRangeModePreference] = (0, (0, parcelRequire("1kpI8")).useViewPreference)((0, (0, parcelRequire("x8FYU")).RANGE_MODE_PREFERENCE));
        const setRangeMode = (0, $5uXOq.useCallback)((newTimelineMode)=>{
            if (newTimelineMode === (0, (0, parcelRequire("iZN6h")).MONTHS)) return setRangeModePreference(undefined);
            return setRangeModePreference(newTimelineMode.toLowerCase());
        }, [
            setRangeModePreference
        ]);
        const rangeMode = (0, $5uXOq.useMemo)(()=>{
            if (rangeModePreference != null && $721c836380912b51$var$validTimelineModes.has(rangeModePreference.toUpperCase())) return rangeModePreference.toUpperCase();
            return 0, (0, parcelRequire("iZN6h")).MONTHS;
        }, [
            rangeModePreference
        ]);
        return [
            rangeMode,
            setRangeMode
        ];
    };
    const $721c836380912b51$export$f9b761e26377fb1f = (queryParam)=>queryParam !== undefined && $721c836380912b51$var$validTimelineModes.has(queryParam) ? queryParam : (0, (0, parcelRequire("iZN6h")).MONTHS);
    const $721c836380912b51$export$ea99d7f13ae5e9bd = ()=>{
        const [rangeModeQueryParam, setRangeMode] = $721c836380912b51$var$useRangeMode();
        const timelineMode = $721c836380912b51$export$f9b761e26377fb1f(rangeModeQueryParam);
        const today = (0, (0, parcelRequire("g11uZ")).getToday)();
        const timelineDuration = (0, (0, parcelRequire("kvSZW")).getTimelineDurationFromDate)(timelineMode, today);
        const timelineOrigin = (0, (0, parcelRequire("kvSZW")).getTimelineOriginForToday)(today, timelineMode);
        const todayPosition = (0, (0, parcelRequire("kvSZW")).getDefaultTimelinePositionFromDate)(today, timelineMode, timelineDuration);
        return [
            {
                today: today,
                timelineMode: timelineMode,
                timelineDuration: timelineDuration,
                timelineOrigin: timelineOrigin,
                todayPosition: todayPosition
            },
            {
                setTimelineMode: setRangeMode
            }
        ];
    };
});
parcelRegister("iZN6h", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_DEPTH", ()=>$1080ad231b30fb16$export$7f882bb969de14a3);
    $parcel$export(module.exports, "DEFAULT_LEVEL", ()=>$1080ad231b30fb16$export$480df663967f228c);
    $parcel$export(module.exports, "RESIZE_DEBOUNCE_MS", ()=>$1080ad231b30fb16$export$747901c4619ea19c);
    $parcel$export(module.exports, "BASE_LEVEL", ()=>$1080ad231b30fb16$export$d5993e01b9439be4);
    $parcel$export(module.exports, "BASE_HEADER_HEIGHT", ()=>$1080ad231b30fb16$export$bf0adf7b400249e1);
    $parcel$export(module.exports, "HEADER_CONTENT_HEIGHT", ()=>$1080ad231b30fb16$export$46c78f5f070f677a);
    $parcel$export(module.exports, "DEFAULT_SUBHEADER_HEIGHT", ()=>$1080ad231b30fb16$export$29ae8fa7fd1c9a2f);
    $parcel$export(module.exports, "DEFAULT_ITEM_HEIGHT", ()=>$1080ad231b30fb16$export$f898a7479a35465b);
    $parcel$export(module.exports, "BASE_LEVEL_ITEM_HEIGHT", ()=>$1080ad231b30fb16$export$c4ca1a8adb6a9f07);
    $parcel$export(module.exports, "MINIMUM_LIST_WIDTH", ()=>$1080ad231b30fb16$export$6bb070ef26ec48d9);
    $parcel$export(module.exports, "DEFAULT_LIST_WIDTH", ()=>$1080ad231b30fb16$export$58590494eb7f9f92);
    $parcel$export(module.exports, "DEFAULT_HEADER_ROW_ID", ()=>$1080ad231b30fb16$export$b24bdd4190312b9);
    $parcel$export(module.exports, "UP", ()=>$1080ad231b30fb16$export$b29f845fa4b57508);
    $parcel$export(module.exports, "DOWN", ()=>$1080ad231b30fb16$export$c7c029a231f98d34);
    $parcel$export(module.exports, "ROW_DRAG_AND_DROP_ID", ()=>$1080ad231b30fb16$export$ac3c20c079db2388);
    $parcel$export(module.exports, "LIST_DRAG_AND_DROP", ()=>$1080ad231b30fb16$export$3c4f97ccd236019);
    $parcel$export(module.exports, "CHILD_LIST_DRAG_AND_DROP", ()=>$1080ad231b30fb16$export$d3793ebc963c3515);
    $parcel$export(module.exports, "LIST_RESIZE_DRAG_AND_DROP", ()=>$1080ad231b30fb16$export$ea4843d184267eb1);
    $parcel$export(module.exports, "DELAY_EXPAND_TIME", ()=>$1080ad231b30fb16$export$d165800dfbec11d6);
    $parcel$export(module.exports, "BEFORE", ()=>$1080ad231b30fb16$export$4cff6e48b6cc73b5);
    $parcel$export(module.exports, "INSIDE", ()=>$1080ad231b30fb16$export$48ea0cac79c83ca8);
    $parcel$export(module.exports, "LAST", ()=>$1080ad231b30fb16$export$5514f5adc70fa605);
    $parcel$export(module.exports, "TIMELINE_ID", ()=>$1080ad231b30fb16$export$80a4040613c38228);
    $parcel$export(module.exports, "WEEKS", ()=>$1080ad231b30fb16$export$ae0be2880fd1f23e);
    $parcel$export(module.exports, "MONTHS", ()=>$1080ad231b30fb16$export$f9a766aa2475e8ba);
    $parcel$export(module.exports, "QUARTERS", ()=>$1080ad231b30fb16$export$6bd120b531154c2a);
    $parcel$export(module.exports, "zIndex", ()=>$1080ad231b30fb16$export$56446adcecbeec34);
    $parcel$export(module.exports, "DEFAULT_CREATE_ID", ()=>$1080ad231b30fb16$export$420141f5c0e55c3e);
    $parcel$export(module.exports, "ITEM_TYPE", ()=>$1080ad231b30fb16$export$e0a522cf395aec9b);
    $parcel$export(module.exports, "CREATE_ITEM_TYPE", ()=>$1080ad231b30fb16$export$69cd3b48cdf4b6f0);
    $parcel$export(module.exports, "SCROLLED", ()=>$1080ad231b30fb16$export$9402ce0d1e070b14);
    $parcel$export(module.exports, "LIST_COLUMN_COORDINATE", ()=>$1080ad231b30fb16$export$4f0d26bf73633d25);
    $parcel$export(module.exports, "CHART_COLUMN_COORDINATE", ()=>$1080ad231b30fb16$export$3a13d2b8bb5c5942);
    $parcel$export(module.exports, "listItemMenu", ()=>$1080ad231b30fb16$export$ee28d791bd8e9db2);
    $parcel$export(module.exports, "DEFAULT_MENU_MAX_HEIGHT", ()=>$1080ad231b30fb16$export$1412163b7495b138);
    var $4R6GH;
    var $dCm1o;
    const $1080ad231b30fb16$export$7f882bb969de14a3 = 0;
    const $1080ad231b30fb16$export$480df663967f228c = 1;
    const $1080ad231b30fb16$export$747901c4619ea19c = 250;
    const $1080ad231b30fb16$export$d5993e01b9439be4 = 0;
    const $1080ad231b30fb16$export$6c5e715ac831956e = 1;
    const $1080ad231b30fb16$export$bf0adf7b400249e1 = 48;
    const $1080ad231b30fb16$export$46c78f5f070f677a = 16;
    const $1080ad231b30fb16$export$29ae8fa7fd1c9a2f = 36;
    const $1080ad231b30fb16$export$f898a7479a35465b = 40;
    const $1080ad231b30fb16$export$c4ca1a8adb6a9f07 = ()=>(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_2') ? 40 : 32;
    const $1080ad231b30fb16$export$6bb070ef26ec48d9 = ()=>(0, (0, parcelRequire("4R6GH")).fg)('project_timeline_multi-select_and_checkboxes') ? 384 : 320;
    const $1080ad231b30fb16$export$58590494eb7f9f92 = ()=>(0, (0, parcelRequire("4R6GH")).fg)('project_timeline_multi-select_and_checkboxes') ? 424 : 360;
    const $1080ad231b30fb16$export$b24bdd4190312b9 = 'DEFAULT_HEADER_ROW';
    const $1080ad231b30fb16$export$b29f845fa4b57508 = 'UP';
    const $1080ad231b30fb16$export$c7c029a231f98d34 = 'DOWN';
    const $1080ad231b30fb16$export$ac3c20c079db2388 = 'row-dnd-type-id';
    const $1080ad231b30fb16$export$3c4f97ccd236019 = 'listDnd';
    const $1080ad231b30fb16$export$d3793ebc963c3515 = 'childListDnd';
    const $1080ad231b30fb16$export$ea4843d184267eb1 = 'listResizeDnd';
    const $1080ad231b30fb16$export$d165800dfbec11d6 = 500;
    const $1080ad231b30fb16$export$4cff6e48b6cc73b5 = 'BEFORE';
    const $1080ad231b30fb16$export$48ea0cac79c83ca8 = 'INSIDE';
    const $1080ad231b30fb16$export$5514f5adc70fa605 = 'LAST';
    const $1080ad231b30fb16$export$80a4040613c38228 = 'sr-timeline';
    const $1080ad231b30fb16$export$ae0be2880fd1f23e = 'WEEKS';
    const $1080ad231b30fb16$export$f9a766aa2475e8ba = 'MONTHS';
    const $1080ad231b30fb16$export$6bd120b531154c2a = 'QUARTERS';
    const $1080ad231b30fb16$export$1041e95163fc373b = 20;
    const $1080ad231b30fb16$export$6d29db963a7e29b9 = $1080ad231b30fb16$export$1041e95163fc373b / 2;
    const $1080ad231b30fb16$var$CHART = 1;
    const $1080ad231b30fb16$var$TODAY_MARKER = 6;
    const $1080ad231b30fb16$var$HEADER = 7;
    const $1080ad231b30fb16$var$LIST_COVER = 8;
    const $1080ad231b30fb16$var$LIST = 9;
    const $1080ad231b30fb16$var$LIST_CREATE_ITEM = 10;
    const $1080ad231b30fb16$var$INLINE_INDICATOR = 11;
    const $1080ad231b30fb16$var$SCROLLBAR = 11;
    const $1080ad231b30fb16$var$ROW_HEADER = 12;
    const $1080ad231b30fb16$var$BORDER = 12;
    const $1080ad231b30fb16$var$LIST_RESIZER = 13;
    const $1080ad231b30fb16$var$DRAGGABLE = 13;
    const $1080ad231b30fb16$var$PORTAL = 13;
    const $1080ad231b30fb16$var$HIGHEST = 14;
    const $1080ad231b30fb16$export$56446adcecbeec34 = {
        CHART: $1080ad231b30fb16$var$CHART,
        BORDER: $1080ad231b30fb16$var$BORDER,
        TODAY_MARKER: $1080ad231b30fb16$var$TODAY_MARKER,
        LIST_COVER: $1080ad231b30fb16$var$LIST_COVER,
        HEADER: $1080ad231b30fb16$var$HEADER,
        LIST: $1080ad231b30fb16$var$LIST,
        LIST_CREATE_ITEM: $1080ad231b30fb16$var$LIST_CREATE_ITEM,
        INLINE_INDICATOR: $1080ad231b30fb16$var$INLINE_INDICATOR,
        SCROLLBAR: $1080ad231b30fb16$var$SCROLLBAR,
        ROW_HEADER: $1080ad231b30fb16$var$ROW_HEADER,
        LIST_RESIZER: $1080ad231b30fb16$var$LIST_RESIZER,
        DRAGGABLE: $1080ad231b30fb16$var$DRAGGABLE,
        PORTAL: $1080ad231b30fb16$var$PORTAL,
        HIGHEST: $1080ad231b30fb16$var$HIGHEST
    };
    const $1080ad231b30fb16$export$420141f5c0e55c3e = 'create-default';
    const $1080ad231b30fb16$export$e0a522cf395aec9b = 'ITEM_TYPE';
    const $1080ad231b30fb16$export$69cd3b48cdf4b6f0 = 'CREATE_ITEM_TYPE';
    const $1080ad231b30fb16$export$9402ce0d1e070b14 = 'scrolled';
    const $1080ad231b30fb16$export$4f0d26bf73633d25 = 0;
    const $1080ad231b30fb16$export$3a13d2b8bb5c5942 = 1;
    const $1080ad231b30fb16$var$ITEMS_SECTION = 'itemsSection';
    const $1080ad231b30fb16$var$CREATE_ITEM = 'createItem';
    const $1080ad231b30fb16$var$MOVE_ITEM = 'moveItem';
    const $1080ad231b30fb16$var$CREATE_CHILD_ITEM = 'createChildItem';
    const $1080ad231b30fb16$var$CREATE_ITEM_ABOVE = 'createItemAbove';
    const $1080ad231b30fb16$var$CREATE_ITEM_BELOW = 'createItemBelow';
    const $1080ad231b30fb16$var$MOVE_ITEM_UP = 'moveItemUp';
    const $1080ad231b30fb16$var$MOVE_ITEM_DOWN = 'moveItemDown';
    const $1080ad231b30fb16$var$MOVE_ITEM_TO_TOP = 'moveItemToTop';
    const $1080ad231b30fb16$var$MOVE_ITEM_TO_BOTTOM = 'moveItemToBottom';
    const $1080ad231b30fb16$var$SELECTED_ITEM_COUNTER = 'selectedItemCounter';
    const $1080ad231b30fb16$export$ee28d791bd8e9db2 = {
        SELECTED_ITEM_COUNTER: $1080ad231b30fb16$var$SELECTED_ITEM_COUNTER,
        ITEMS_SECTION: $1080ad231b30fb16$var$ITEMS_SECTION,
        CREATE_ITEM: $1080ad231b30fb16$var$CREATE_ITEM,
        MOVE_ITEM: $1080ad231b30fb16$var$MOVE_ITEM,
        CREATE_CHILD_ITEM: $1080ad231b30fb16$var$CREATE_CHILD_ITEM,
        CREATE_ITEM_ABOVE: $1080ad231b30fb16$var$CREATE_ITEM_ABOVE,
        CREATE_ITEM_BELOW: $1080ad231b30fb16$var$CREATE_ITEM_BELOW,
        MOVE_ITEM_UP: $1080ad231b30fb16$var$MOVE_ITEM_UP,
        MOVE_ITEM_DOWN: $1080ad231b30fb16$var$MOVE_ITEM_DOWN,
        MOVE_ITEM_TO_TOP: $1080ad231b30fb16$var$MOVE_ITEM_TO_TOP,
        MOVE_ITEM_TO_BOTTOM: $1080ad231b30fb16$var$MOVE_ITEM_TO_BOTTOM
    };
    const $1080ad231b30fb16$export$1412163b7495b138 = 480;
});
parcelRegister("g11uZ", function(module, exports) {
    $parcel$export(module.exports, "getToday", ()=>$dd0e6eedd8c09c8c$export$883228a582a7567d);
    $parcel$export(module.exports, "getStartOfDay", ()=>$dd0e6eedd8c09c8c$export$acfb4d8d6f22913c);
    $parcel$export(module.exports, "getClosestStartOfDay", ()=>$dd0e6eedd8c09c8c$export$3b10530a2652517a);
    $parcel$export(module.exports, "getEndOfDay", ()=>$dd0e6eedd8c09c8c$export$ba913d97bab95922);
    $parcel$export(module.exports, "getClosestEndOfDay", ()=>$dd0e6eedd8c09c8c$export$15bcb0122f94fe73);
    $parcel$export(module.exports, "getDateFromTimestamp", ()=>$dd0e6eedd8c09c8c$export$f268c901e7fab1f4);
    var $8QpSo;
    var $2gnC5 = parcelRequire("2gnC5");
    const $dd0e6eedd8c09c8c$var$HALF_DAY_IN_MS = (0, $a797a5154a1373bc$export$1f04624003d2da7d) / 2;
    const $dd0e6eedd8c09c8c$export$883228a582a7567d = (0, (0, parcelRequire("8QpSo")).default)(()=>{
        const now = new Date();
        const date = (0, ($parcel$interopDefault($2gnC5))).utc().startOf('day');
        date.set({
            year: now.getFullYear(),
            month: now.getMonth(),
            date: now.getDate()
        });
        return date.valueOf();
    });
    const $dd0e6eedd8c09c8c$export$acfb4d8d6f22913c = (date)=>(0, ($parcel$interopDefault($2gnC5))).utc(date).startOf('day').valueOf();
    const $dd0e6eedd8c09c8c$export$3b10530a2652517a = (date)=>{
        const newValue = $dd0e6eedd8c09c8c$export$acfb4d8d6f22913c(date);
        if (date - newValue > $dd0e6eedd8c09c8c$var$HALF_DAY_IN_MS) return newValue + $dd0e6eedd8c09c8c$var$HALF_DAY_IN_MS * 2;
        return newValue;
    };
    const $dd0e6eedd8c09c8c$export$ba913d97bab95922 = (date)=>(0, ($parcel$interopDefault($2gnC5))).utc(date).endOf('day').valueOf();
    const $dd0e6eedd8c09c8c$export$15bcb0122f94fe73 = (date)=>{
        const newValue = $dd0e6eedd8c09c8c$export$ba913d97bab95922(date);
        if (newValue - date > $dd0e6eedd8c09c8c$var$HALF_DAY_IN_MS) return newValue - $dd0e6eedd8c09c8c$var$HALF_DAY_IN_MS * 2;
        return newValue;
    };
    const $dd0e6eedd8c09c8c$export$b6b0beaf88b31f31 = (date)=>Math.round(date / (0, $a797a5154a1373bc$export$1f04624003d2da7d)) * (0, $a797a5154a1373bc$export$1f04624003d2da7d);
    const $dd0e6eedd8c09c8c$export$f268c901e7fab1f4 = (timestamp, format = (0, $a797a5154a1373bc$export$45c85543ba71221d))=>(0, ($parcel$interopDefault($2gnC5))).utc(timestamp).format(format);
});
parcelRegister("2gnC5", function(module, exports) {
    (function(global, factory) {
        module.exports = factory();
    })(this, function() {
        'use strict';
        var hookCallback;
        function hooks() {
            return hookCallback.apply(null, arguments);
        }
        function setHookCallback(callback) {
            hookCallback = callback;
        }
        function isArray(input) {
            return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
        }
        function isObject(input) {
            return input != null && Object.prototype.toString.call(input) === '[object Object]';
        }
        function hasOwnProp(a, b) {
            return Object.prototype.hasOwnProperty.call(a, b);
        }
        function isObjectEmpty(obj) {
            if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
            else {
                var k;
                for(k in obj){
                    if (hasOwnProp(obj, k)) return false;
                }
                return true;
            }
        }
        function isUndefined(input) {
            return input === void 0;
        }
        function isNumber(input) {
            return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
        }
        function isDate(input) {
            return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
        }
        function map(arr, fn) {
            var res = [], i, arrLen = arr.length;
            for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
            return res;
        }
        function extend(a, b) {
            for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
            if (hasOwnProp(b, 'toString')) a.toString = b.toString;
            if (hasOwnProp(b, 'valueOf')) a.valueOf = b.valueOf;
            return a;
        }
        function createUTC(input, format, locale, strict) {
            return createLocalOrUTC(input, format, locale, strict, true).utc();
        }
        function defaultParsingFlags() {
            return {
                empty: false,
                unusedTokens: [],
                unusedInput: [],
                overflow: -2,
                charsLeftOver: 0,
                nullInput: false,
                invalidEra: null,
                invalidMonth: null,
                invalidFormat: false,
                userInvalidated: false,
                iso: false,
                parsedDateParts: [],
                era: null,
                meridiem: null,
                rfc2822: false,
                weekdayMismatch: false
            };
        }
        function getParsingFlags(m) {
            if (m._pf == null) m._pf = defaultParsingFlags();
            return m._pf;
        }
        var some;
        if (Array.prototype.some) some = Array.prototype.some;
        else some = function(fun) {
            var t = Object(this), len = t.length >>> 0, i;
            for(i = 0; i < len; i++){
                if (i in t && fun.call(this, t[i], i, t)) return true;
            }
            return false;
        };
        function isValid(m) {
            var flags = null, parsedParts = false, isNowValid = m._d && !isNaN(m._d.getTime());
            if (isNowValid) {
                flags = getParsingFlags(m);
                parsedParts = some.call(flags.parsedDateParts, function(i) {
                    return i != null;
                });
                isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
                if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
            }
            if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
            else return isNowValid;
            return m._isValid;
        }
        function createInvalid(flags) {
            var m = createUTC(NaN);
            if (flags != null) extend(getParsingFlags(m), flags);
            else getParsingFlags(m).userInvalidated = true;
            return m;
        }
        var momentProperties = hooks.momentProperties = [], updateInProgress = false;
        function copyConfig(to, from) {
            var i, prop, val, momentPropertiesLen = momentProperties.length;
            if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
            if (!isUndefined(from._i)) to._i = from._i;
            if (!isUndefined(from._f)) to._f = from._f;
            if (!isUndefined(from._l)) to._l = from._l;
            if (!isUndefined(from._strict)) to._strict = from._strict;
            if (!isUndefined(from._tzm)) to._tzm = from._tzm;
            if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
            if (!isUndefined(from._offset)) to._offset = from._offset;
            if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
            if (!isUndefined(from._locale)) to._locale = from._locale;
            if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) to[prop] = val;
            }
            return to;
        }
        function Moment(config) {
            copyConfig(this, config);
            this._d = new Date(config._d != null ? config._d.getTime() : NaN);
            if (!this.isValid()) this._d = new Date(NaN);
            if (updateInProgress === false) {
                updateInProgress = true;
                hooks.updateOffset(this);
                updateInProgress = false;
            }
        }
        function isMoment(obj) {
            return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
        }
        function warn(msg) {
            if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) console.warn('Deprecation warning: ' + msg);
        }
        function deprecate(msg, fn) {
            var firstTime = true;
            return extend(function() {
                if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
                if (firstTime) {
                    var args = [], arg, i, key, argLen = arguments.length;
                    for(i = 0; i < argLen; i++){
                        arg = '';
                        if (typeof arguments[i] === 'object') {
                            arg += '\n[' + i + '] ';
                            for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ': ' + arguments[0][key] + ', ';
                            arg = arg.slice(0, -2);
                        } else arg = arguments[i];
                        args.push(arg);
                    }
                    warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
                    firstTime = false;
                }
                return fn.apply(this, arguments);
            }, fn);
        }
        var deprecations = {};
        function deprecateSimple(name, msg) {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
            if (!deprecations[name]) {
                warn(msg);
                deprecations[name] = true;
            }
        }
        hooks.suppressDeprecationWarnings = false;
        hooks.deprecationHandler = null;
        function isFunction(input) {
            return typeof Function !== 'undefined' && input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
        }
        function set(config) {
            var prop, i;
            for(i in config)if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) this[i] = prop;
                else this['_' + i] = prop;
            }
            this._config = config;
            this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
        }
        function mergeConfigs(parentConfig, childConfig) {
            var res = extend({}, parentConfig), prop;
            for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
                else delete res[prop];
            }
            for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) res[prop] = extend({}, res[prop]);
            return res;
        }
        function Locale(config) {
            if (config != null) this.set(config);
        }
        var keys;
        if (Object.keys) keys = Object.keys;
        else keys = function(obj) {
            var i, res = [];
            for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
            return res;
        };
        var defaultCalendar = {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L'
        };
        function calendar(key, mom, now) {
            var output = this._calendar[key] || this._calendar['sameElse'];
            return isFunction(output) ? output.call(mom, now) : output;
        }
        function zeroFill(number, targetLength, forceSign) {
            var absNumber = '' + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
            return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
        }
        var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
        function addFormatToken(token, padded, ordinal, callback) {
            var func = callback;
            if (typeof callback === 'string') func = function() {
                return this[callback]();
            };
            if (token) formatTokenFunctions[token] = func;
            if (padded) formatTokenFunctions[padded[0]] = function() {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
            if (ordinal) formatTokenFunctions[ordinal] = function() {
                return this.localeData().ordinal(func.apply(this, arguments), token);
            };
        }
        function removeFormattingTokens(input) {
            if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, '');
            return input.replace(/\\/g, '');
        }
        function makeFormatFunction(format) {
            var array = format.match(formattingTokens), i, length;
            for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
            else array[i] = removeFormattingTokens(array[i]);
            return function(mom) {
                var output = '', i;
                for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
                return output;
            };
        }
        function formatMoment(m, format) {
            if (!m.isValid()) return m.localeData().invalidDate();
            format = expandFormat(format, m.localeData());
            formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
            return formatFunctions[format](m);
        }
        function expandFormat(format, locale) {
            var i = 5;
            function replaceLongDateFormatTokens(input) {
                return locale.longDateFormat(input) || input;
            }
            localFormattingTokens.lastIndex = 0;
            while(i >= 0 && localFormattingTokens.test(format)){
                format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
                localFormattingTokens.lastIndex = 0;
                i -= 1;
            }
            return format;
        }
        var defaultLongDateFormat = {
            LTS: 'h:mm:ss A',
            LT: 'h:mm A',
            L: 'MM/DD/YYYY',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY h:mm A',
            LLLL: 'dddd, MMMM D, YYYY h:mm A'
        };
        function longDateFormat(key) {
            var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()];
            if (format || !formatUpper) return format;
            this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function(tok) {
                if (tok === 'MMMM' || tok === 'MM' || tok === 'DD' || tok === 'dddd') return tok.slice(1);
                return tok;
            }).join('');
            return this._longDateFormat[key];
        }
        var defaultInvalidDate = 'Invalid date';
        function invalidDate() {
            return this._invalidDate;
        }
        var defaultOrdinal = '%d', defaultDayOfMonthOrdinalParse = /\d{1,2}/;
        function ordinal(number) {
            return this._ordinal.replace('%d', number);
        }
        var defaultRelativeTime = {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            w: 'a week',
            ww: '%d weeks',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years'
        };
        function relativeTime(number, withoutSuffix, string, isFuture) {
            var output = this._relativeTime[string];
            return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
        }
        function pastFuture(diff, output) {
            var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
            return isFunction(format) ? format(output) : format.replace(/%s/i, output);
        }
        var aliases = {
            D: 'date',
            dates: 'date',
            date: 'date',
            d: 'day',
            days: 'day',
            day: 'day',
            e: 'weekday',
            weekdays: 'weekday',
            weekday: 'weekday',
            E: 'isoWeekday',
            isoweekdays: 'isoWeekday',
            isoweekday: 'isoWeekday',
            DDD: 'dayOfYear',
            dayofyears: 'dayOfYear',
            dayofyear: 'dayOfYear',
            h: 'hour',
            hours: 'hour',
            hour: 'hour',
            ms: 'millisecond',
            milliseconds: 'millisecond',
            millisecond: 'millisecond',
            m: 'minute',
            minutes: 'minute',
            minute: 'minute',
            M: 'month',
            months: 'month',
            month: 'month',
            Q: 'quarter',
            quarters: 'quarter',
            quarter: 'quarter',
            s: 'second',
            seconds: 'second',
            second: 'second',
            gg: 'weekYear',
            weekyears: 'weekYear',
            weekyear: 'weekYear',
            GG: 'isoWeekYear',
            isoweekyears: 'isoWeekYear',
            isoweekyear: 'isoWeekYear',
            w: 'week',
            weeks: 'week',
            week: 'week',
            W: 'isoWeek',
            isoweeks: 'isoWeek',
            isoweek: 'isoWeek',
            y: 'year',
            years: 'year',
            year: 'year'
        };
        function normalizeUnits(units) {
            return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
        }
        function normalizeObjectUnits(inputObject) {
            var normalizedInput = {}, normalizedProp, prop;
            for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
            }
            return normalizedInput;
        }
        var priorities = {
            date: 9,
            day: 11,
            weekday: 11,
            isoWeekday: 11,
            dayOfYear: 4,
            hour: 13,
            millisecond: 16,
            minute: 14,
            month: 8,
            quarter: 7,
            second: 15,
            weekYear: 1,
            isoWeekYear: 1,
            week: 5,
            isoWeek: 5,
            year: 1
        };
        function getPrioritizedUnits(unitsObj) {
            var units = [], u;
            for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
                unit: u,
                priority: priorities[u]
            });
            units.sort(function(a, b) {
                return a.priority - b.priority;
            });
            return units;
        }
        var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
        regexes = {};
        function addRegexToken(token, regex, strictRegex) {
            regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
                return isStrict && strictRegex ? strictRegex : regex;
            };
        }
        function getParseRegexForToken(token, config) {
            if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
            return regexes[token](config._strict, config._locale);
        }
        function unescapeFormat(s) {
            return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
                return p1 || p2 || p3 || p4;
            }));
        }
        function regexEscape(s) {
            return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
        }
        function absFloor(number) {
            if (number < 0) return Math.ceil(number) || 0;
            else return Math.floor(number);
        }
        function toInt(argumentForCoercion) {
            var coercedNumber = +argumentForCoercion, value = 0;
            if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
            return value;
        }
        var tokens = {};
        function addParseToken(token, callback) {
            var i, func = callback, tokenLen;
            if (typeof token === 'string') token = [
                token
            ];
            if (isNumber(callback)) func = function(input, array) {
                array[callback] = toInt(input);
            };
            tokenLen = token.length;
            for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
        }
        function addWeekParseToken(token, callback) {
            addParseToken(token, function(input, array, config, token) {
                config._w = config._w || {};
                callback(input, config._w, config, token);
            });
        }
        function addTimeToArrayFromToken(token, input, config) {
            if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
        }
        function isLeapYear(year) {
            return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
        }
        var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
        addFormatToken('Y', 0, 0, function() {
            var y = this.year();
            return y <= 9999 ? zeroFill(y, 4) : '+' + y;
        });
        addFormatToken(0, [
            'YY',
            2
        ], 0, function() {
            return this.year() % 100;
        });
        addFormatToken(0, [
            'YYYY',
            4
        ], 0, 'year');
        addFormatToken(0, [
            'YYYYY',
            5
        ], 0, 'year');
        addFormatToken(0, [
            'YYYYYY',
            6,
            true
        ], 0, 'year');
        addRegexToken('Y', matchSigned);
        addRegexToken('YY', match1to2, match2);
        addRegexToken('YYYY', match1to4, match4);
        addRegexToken('YYYYY', match1to6, match6);
        addRegexToken('YYYYYY', match1to6, match6);
        addParseToken([
            'YYYYY',
            'YYYYYY'
        ], YEAR);
        addParseToken('YYYY', function(input, array) {
            array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
        });
        addParseToken('YY', function(input, array) {
            array[YEAR] = hooks.parseTwoDigitYear(input);
        });
        addParseToken('Y', function(input, array) {
            array[YEAR] = parseInt(input, 10);
        });
        function daysInYear(year) {
            return isLeapYear(year) ? 366 : 365;
        }
        hooks.parseTwoDigitYear = function(input) {
            return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
        };
        var getSetYear = makeGetSet('FullYear', true);
        function getIsLeapYear() {
            return isLeapYear(this.year());
        }
        function makeGetSet(unit, keepTime) {
            return function(value) {
                if (value != null) {
                    set$1(this, unit, value);
                    hooks.updateOffset(this, keepTime);
                    return this;
                } else return get(this, unit);
            };
        }
        function get(mom, unit) {
            if (!mom.isValid()) return NaN;
            var d = mom._d, isUTC = mom._isUTC;
            switch(unit){
                case 'Milliseconds':
                    return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
                case 'Seconds':
                    return isUTC ? d.getUTCSeconds() : d.getSeconds();
                case 'Minutes':
                    return isUTC ? d.getUTCMinutes() : d.getMinutes();
                case 'Hours':
                    return isUTC ? d.getUTCHours() : d.getHours();
                case 'Date':
                    return isUTC ? d.getUTCDate() : d.getDate();
                case 'Day':
                    return isUTC ? d.getUTCDay() : d.getDay();
                case 'Month':
                    return isUTC ? d.getUTCMonth() : d.getMonth();
                case 'FullYear':
                    return isUTC ? d.getUTCFullYear() : d.getFullYear();
                default:
                    return NaN;
            }
        }
        function set$1(mom, unit, value) {
            var d, isUTC, year, month, date;
            if (!mom.isValid() || isNaN(value)) return;
            d = mom._d;
            isUTC = mom._isUTC;
            switch(unit){
                case 'Milliseconds':
                    return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
                case 'Seconds':
                    return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
                case 'Minutes':
                    return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
                case 'Hours':
                    return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
                case 'Date':
                    return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
                case 'FullYear':
                    break;
                default:
                    return;
            }
            year = value;
            month = mom.month();
            date = mom.date();
            date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
            isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date);
        }
        function stringGet(units) {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units]();
            return this;
        }
        function stringSet(units, value) {
            if (typeof units === 'object') {
                units = normalizeObjectUnits(units);
                var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
                for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
            } else {
                units = normalizeUnits(units);
                if (isFunction(this[units])) return this[units](value);
            }
            return this;
        }
        function mod(n, x) {
            return (n % x + x) % x;
        }
        var indexOf;
        if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
        else indexOf = function(o) {
            var i;
            for(i = 0; i < this.length; ++i){
                if (this[i] === o) return i;
            }
            return -1;
        };
        function daysInMonth(year, month) {
            if (isNaN(year) || isNaN(month)) return NaN;
            var modMonth = mod(month, 12);
            year += (month - modMonth) / 12;
            return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
        }
        addFormatToken('M', [
            'MM',
            2
        ], 'Mo', function() {
            return this.month() + 1;
        });
        addFormatToken('MMM', 0, 0, function(format) {
            return this.localeData().monthsShort(this, format);
        });
        addFormatToken('MMMM', 0, 0, function(format) {
            return this.localeData().months(this, format);
        });
        addRegexToken('M', match1to2, match1to2NoLeadingZero);
        addRegexToken('MM', match1to2, match2);
        addRegexToken('MMM', function(isStrict, locale) {
            return locale.monthsShortRegex(isStrict);
        });
        addRegexToken('MMMM', function(isStrict, locale) {
            return locale.monthsRegex(isStrict);
        });
        addParseToken([
            'M',
            'MM'
        ], function(input, array) {
            array[MONTH] = toInt(input) - 1;
        });
        addParseToken([
            'MMM',
            'MMMM'
        ], function(input, array, config, token) {
            var month = config._locale.monthsParse(input, token, config._strict);
            if (month != null) array[MONTH] = month;
            else getParsingFlags(config).invalidMonth = input;
        });
        var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'), defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord;
        function localeMonths(m, format) {
            if (!m) return isArray(this._months) ? this._months : this._months['standalone'];
            return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
        }
        function localeMonthsShort(m, format) {
            if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
            return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
        }
        function handleStrictParse(monthName, format, strict) {
            var i, ii, mom, llc = monthName.toLocaleLowerCase();
            if (!this._monthsParse) {
                this._monthsParse = [];
                this._longMonthsParse = [];
                this._shortMonthsParse = [];
                for(i = 0; i < 12; ++i){
                    mom = createUTC([
                        2000,
                        i
                    ]);
                    this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                    this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
                }
            }
            if (strict) {
                if (format === 'MMM') {
                    ii = indexOf.call(this._shortMonthsParse, llc);
                    return ii !== -1 ? ii : null;
                } else {
                    ii = indexOf.call(this._longMonthsParse, llc);
                    return ii !== -1 ? ii : null;
                }
            } else if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
        function localeMonthsParse(monthName, format, strict) {
            var i, mom, regex;
            if (this._monthsParseExact) return handleStrictParse.call(this, monthName, format, strict);
            if (!this._monthsParse) {
                this._monthsParse = [];
                this._longMonthsParse = [];
                this._shortMonthsParse = [];
            }
            for(i = 0; i < 12; i++){
                mom = createUTC([
                    2000,
                    i
                ]);
                if (strict && !this._longMonthsParse[i]) {
                    this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                    this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
                }
                if (!strict && !this._monthsParse[i]) {
                    regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                    this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
                }
                if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) return i;
                else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) return i;
                else if (!strict && this._monthsParse[i].test(monthName)) return i;
            }
        }
        function setMonth(mom, value) {
            if (!mom.isValid()) return mom;
            if (typeof value === 'string') {
                if (/^\d+$/.test(value)) value = toInt(value);
                else {
                    value = mom.localeData().monthsParse(value);
                    if (!isNumber(value)) return mom;
                }
            }
            var month = value, date = mom.date();
            date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
            mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date);
            return mom;
        }
        function getSetMonth(value) {
            if (value != null) {
                setMonth(this, value);
                hooks.updateOffset(this, true);
                return this;
            } else return get(this, 'Month');
        }
        function getDaysInMonth() {
            return daysInMonth(this.year(), this.month());
        }
        function monthsShortRegex(isStrict) {
            if (this._monthsParseExact) {
                if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
                if (isStrict) return this._monthsShortStrictRegex;
                else return this._monthsShortRegex;
            } else {
                if (!hasOwnProp(this, '_monthsShortRegex')) this._monthsShortRegex = defaultMonthsShortRegex;
                return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
            }
        }
        function monthsRegex(isStrict) {
            if (this._monthsParseExact) {
                if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
                if (isStrict) return this._monthsStrictRegex;
                else return this._monthsRegex;
            } else {
                if (!hasOwnProp(this, '_monthsRegex')) this._monthsRegex = defaultMonthsRegex;
                return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
            }
        }
        function computeMonthsParse() {
            function cmpLenRev(a, b) {
                return b.length - a.length;
            }
            var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
            for(i = 0; i < 12; i++){
                mom = createUTC([
                    2000,
                    i
                ]);
                shortP = regexEscape(this.monthsShort(mom, ''));
                longP = regexEscape(this.months(mom, ''));
                shortPieces.push(shortP);
                longPieces.push(longP);
                mixedPieces.push(longP);
                mixedPieces.push(shortP);
            }
            shortPieces.sort(cmpLenRev);
            longPieces.sort(cmpLenRev);
            mixedPieces.sort(cmpLenRev);
            this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
            this._monthsShortRegex = this._monthsRegex;
            this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
            this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        }
        function createDate(y, m, d, h, M, s, ms) {
            var date;
            if (y < 100 && y >= 0) {
                date = new Date(y + 400, m, d, h, M, s, ms);
                if (isFinite(date.getFullYear())) date.setFullYear(y);
            } else date = new Date(y, m, d, h, M, s, ms);
            return date;
        }
        function createUTCDate(y) {
            var date, args;
            if (y < 100 && y >= 0) {
                args = Array.prototype.slice.call(arguments);
                args[0] = y + 400;
                date = new Date(Date.UTC.apply(null, args));
                if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
            } else date = new Date(Date.UTC.apply(null, arguments));
            return date;
        }
        function firstWeekOffset(year, dow, doy) {
            var fwd = 7 + dow - doy, fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
            return -fwdlw + fwd - 1;
        }
        function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
            var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
            if (dayOfYear <= 0) {
                resYear = year - 1;
                resDayOfYear = daysInYear(resYear) + dayOfYear;
            } else if (dayOfYear > daysInYear(year)) {
                resYear = year + 1;
                resDayOfYear = dayOfYear - daysInYear(year);
            } else {
                resYear = year;
                resDayOfYear = dayOfYear;
            }
            return {
                year: resYear,
                dayOfYear: resDayOfYear
            };
        }
        function weekOfYear(mom, dow, doy) {
            var weekOffset = firstWeekOffset(mom.year(), dow, doy), week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1, resWeek, resYear;
            if (week < 1) {
                resYear = mom.year() - 1;
                resWeek = week + weeksInYear(resYear, dow, doy);
            } else if (week > weeksInYear(mom.year(), dow, doy)) {
                resWeek = week - weeksInYear(mom.year(), dow, doy);
                resYear = mom.year() + 1;
            } else {
                resYear = mom.year();
                resWeek = week;
            }
            return {
                week: resWeek,
                year: resYear
            };
        }
        function weeksInYear(year, dow, doy) {
            var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
            return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
        }
        addFormatToken('w', [
            'ww',
            2
        ], 'wo', 'week');
        addFormatToken('W', [
            'WW',
            2
        ], 'Wo', 'isoWeek');
        addRegexToken('w', match1to2, match1to2NoLeadingZero);
        addRegexToken('ww', match1to2, match2);
        addRegexToken('W', match1to2, match1to2NoLeadingZero);
        addRegexToken('WW', match1to2, match2);
        addWeekParseToken([
            'w',
            'ww',
            'W',
            'WW'
        ], function(input, week, config, token) {
            week[token.substr(0, 1)] = toInt(input);
        });
        function localeWeek(mom) {
            return weekOfYear(mom, this._week.dow, this._week.doy).week;
        }
        var defaultLocaleWeek = {
            dow: 0,
            doy: 6
        };
        function localeFirstDayOfWeek() {
            return this._week.dow;
        }
        function localeFirstDayOfYear() {
            return this._week.doy;
        }
        function getSetWeek(input) {
            var week = this.localeData().week(this);
            return input == null ? week : this.add((input - week) * 7, 'd');
        }
        function getSetISOWeek(input) {
            var week = weekOfYear(this, 1, 4).week;
            return input == null ? week : this.add((input - week) * 7, 'd');
        }
        addFormatToken('d', 0, 'do', 'day');
        addFormatToken('dd', 0, 0, function(format) {
            return this.localeData().weekdaysMin(this, format);
        });
        addFormatToken('ddd', 0, 0, function(format) {
            return this.localeData().weekdaysShort(this, format);
        });
        addFormatToken('dddd', 0, 0, function(format) {
            return this.localeData().weekdays(this, format);
        });
        addFormatToken('e', 0, 0, 'weekday');
        addFormatToken('E', 0, 0, 'isoWeekday');
        addRegexToken('d', match1to2);
        addRegexToken('e', match1to2);
        addRegexToken('E', match1to2);
        addRegexToken('dd', function(isStrict, locale) {
            return locale.weekdaysMinRegex(isStrict);
        });
        addRegexToken('ddd', function(isStrict, locale) {
            return locale.weekdaysShortRegex(isStrict);
        });
        addRegexToken('dddd', function(isStrict, locale) {
            return locale.weekdaysRegex(isStrict);
        });
        addWeekParseToken([
            'dd',
            'ddd',
            'dddd'
        ], function(input, week, config, token) {
            var weekday = config._locale.weekdaysParse(input, token, config._strict);
            if (weekday != null) week.d = weekday;
            else getParsingFlags(config).invalidWeekday = input;
        });
        addWeekParseToken([
            'd',
            'e',
            'E'
        ], function(input, week, config, token) {
            week[token] = toInt(input);
        });
        function parseWeekday(input, locale) {
            if (typeof input !== 'string') return input;
            if (!isNaN(input)) return parseInt(input, 10);
            input = locale.weekdaysParse(input);
            if (typeof input === 'number') return input;
            return null;
        }
        function parseIsoWeekday(input, locale) {
            if (typeof input === 'string') return locale.weekdaysParse(input) % 7 || 7;
            return isNaN(input) ? null : input;
        }
        function shiftWeekdays(ws, n) {
            return ws.slice(n, 7).concat(ws.slice(0, n));
        }
        var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'), defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'), defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord;
        function localeWeekdays(m, format) {
            var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? 'format' : 'standalone'];
            return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
        }
        function localeWeekdaysShort(m) {
            return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
        }
        function localeWeekdaysMin(m) {
            return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
        }
        function handleStrictParse$1(weekdayName, format, strict) {
            var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
            if (!this._weekdaysParse) {
                this._weekdaysParse = [];
                this._shortWeekdaysParse = [];
                this._minWeekdaysParse = [];
                for(i = 0; i < 7; ++i){
                    mom = createUTC([
                        2000,
                        1
                    ]).day(i);
                    this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                    this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                    this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
                }
            }
            if (strict) {
                if (format === 'dddd') {
                    ii = indexOf.call(this._weekdaysParse, llc);
                    return ii !== -1 ? ii : null;
                } else if (format === 'ddd') {
                    ii = indexOf.call(this._shortWeekdaysParse, llc);
                    return ii !== -1 ? ii : null;
                } else {
                    ii = indexOf.call(this._minWeekdaysParse, llc);
                    return ii !== -1 ? ii : null;
                }
            } else {
                if (format === 'dddd') {
                    ii = indexOf.call(this._weekdaysParse, llc);
                    if (ii !== -1) return ii;
                    ii = indexOf.call(this._shortWeekdaysParse, llc);
                    if (ii !== -1) return ii;
                    ii = indexOf.call(this._minWeekdaysParse, llc);
                    return ii !== -1 ? ii : null;
                } else if (format === 'ddd') {
                    ii = indexOf.call(this._shortWeekdaysParse, llc);
                    if (ii !== -1) return ii;
                    ii = indexOf.call(this._weekdaysParse, llc);
                    if (ii !== -1) return ii;
                    ii = indexOf.call(this._minWeekdaysParse, llc);
                    return ii !== -1 ? ii : null;
                } else {
                    ii = indexOf.call(this._minWeekdaysParse, llc);
                    if (ii !== -1) return ii;
                    ii = indexOf.call(this._weekdaysParse, llc);
                    if (ii !== -1) return ii;
                    ii = indexOf.call(this._shortWeekdaysParse, llc);
                    return ii !== -1 ? ii : null;
                }
            }
        }
        function localeWeekdaysParse(weekdayName, format, strict) {
            var i, mom, regex;
            if (this._weekdaysParseExact) return handleStrictParse$1.call(this, weekdayName, format, strict);
            if (!this._weekdaysParse) {
                this._weekdaysParse = [];
                this._minWeekdaysParse = [];
                this._shortWeekdaysParse = [];
                this._fullWeekdaysParse = [];
            }
            for(i = 0; i < 7; i++){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                if (strict && !this._fullWeekdaysParse[i]) {
                    this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                    this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                    this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
                }
                if (!this._weekdaysParse[i]) {
                    regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                    this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
                }
                if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) return i;
                else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) return i;
                else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) return i;
                else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
            }
        }
        function getSetDayOfWeek(input) {
            if (!this.isValid()) return input != null ? this : NaN;
            var day = get(this, 'Day');
            if (input != null) {
                input = parseWeekday(input, this.localeData());
                return this.add(input - day, 'd');
            } else return day;
        }
        function getSetLocaleDayOfWeek(input) {
            if (!this.isValid()) return input != null ? this : NaN;
            var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
            return input == null ? weekday : this.add(input - weekday, 'd');
        }
        function getSetISODayOfWeek(input) {
            if (!this.isValid()) return input != null ? this : NaN;
            if (input != null) {
                var weekday = parseIsoWeekday(input, this.localeData());
                return this.day(this.day() % 7 ? weekday : weekday - 7);
            } else return this.day() || 7;
        }
        function weekdaysRegex(isStrict) {
            if (this._weekdaysParseExact) {
                if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
                if (isStrict) return this._weekdaysStrictRegex;
                else return this._weekdaysRegex;
            } else {
                if (!hasOwnProp(this, '_weekdaysRegex')) this._weekdaysRegex = defaultWeekdaysRegex;
                return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
            }
        }
        function weekdaysShortRegex(isStrict) {
            if (this._weekdaysParseExact) {
                if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
                if (isStrict) return this._weekdaysShortStrictRegex;
                else return this._weekdaysShortRegex;
            } else {
                if (!hasOwnProp(this, '_weekdaysShortRegex')) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
                return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
            }
        }
        function weekdaysMinRegex(isStrict) {
            if (this._weekdaysParseExact) {
                if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
                if (isStrict) return this._weekdaysMinStrictRegex;
                else return this._weekdaysMinRegex;
            } else {
                if (!hasOwnProp(this, '_weekdaysMinRegex')) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
                return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
            }
        }
        function computeWeekdaysParse() {
            function cmpLenRev(a, b) {
                return b.length - a.length;
            }
            var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
            for(i = 0; i < 7; i++){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                minp = regexEscape(this.weekdaysMin(mom, ''));
                shortp = regexEscape(this.weekdaysShort(mom, ''));
                longp = regexEscape(this.weekdays(mom, ''));
                minPieces.push(minp);
                shortPieces.push(shortp);
                longPieces.push(longp);
                mixedPieces.push(minp);
                mixedPieces.push(shortp);
                mixedPieces.push(longp);
            }
            minPieces.sort(cmpLenRev);
            shortPieces.sort(cmpLenRev);
            longPieces.sort(cmpLenRev);
            mixedPieces.sort(cmpLenRev);
            this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
            this._weekdaysShortRegex = this._weekdaysRegex;
            this._weekdaysMinRegex = this._weekdaysRegex;
            this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
            this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
            this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
        }
        function hFormat() {
            return this.hours() % 12 || 12;
        }
        function kFormat() {
            return this.hours() || 24;
        }
        addFormatToken('H', [
            'HH',
            2
        ], 0, 'hour');
        addFormatToken('h', [
            'hh',
            2
        ], 0, hFormat);
        addFormatToken('k', [
            'kk',
            2
        ], 0, kFormat);
        addFormatToken('hmm', 0, 0, function() {
            return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
        });
        addFormatToken('hmmss', 0, 0, function() {
            return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
        });
        addFormatToken('Hmm', 0, 0, function() {
            return '' + this.hours() + zeroFill(this.minutes(), 2);
        });
        addFormatToken('Hmmss', 0, 0, function() {
            return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
        });
        function meridiem(token, lowercase) {
            addFormatToken(token, 0, 0, function() {
                return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
            });
        }
        meridiem('a', true);
        meridiem('A', false);
        function matchMeridiem(isStrict, locale) {
            return locale._meridiemParse;
        }
        addRegexToken('a', matchMeridiem);
        addRegexToken('A', matchMeridiem);
        addRegexToken('H', match1to2, match1to2HasZero);
        addRegexToken('h', match1to2, match1to2NoLeadingZero);
        addRegexToken('k', match1to2, match1to2NoLeadingZero);
        addRegexToken('HH', match1to2, match2);
        addRegexToken('hh', match1to2, match2);
        addRegexToken('kk', match1to2, match2);
        addRegexToken('hmm', match3to4);
        addRegexToken('hmmss', match5to6);
        addRegexToken('Hmm', match3to4);
        addRegexToken('Hmmss', match5to6);
        addParseToken([
            'H',
            'HH'
        ], HOUR);
        addParseToken([
            'k',
            'kk'
        ], function(input, array, config) {
            var kInput = toInt(input);
            array[HOUR] = kInput === 24 ? 0 : kInput;
        });
        addParseToken([
            'a',
            'A'
        ], function(input, array, config) {
            config._isPm = config._locale.isPM(input);
            config._meridiem = input;
        });
        addParseToken([
            'h',
            'hh'
        ], function(input, array, config) {
            array[HOUR] = toInt(input);
            getParsingFlags(config).bigHour = true;
        });
        addParseToken('hmm', function(input, array, config) {
            var pos = input.length - 2;
            array[HOUR] = toInt(input.substr(0, pos));
            array[MINUTE] = toInt(input.substr(pos));
            getParsingFlags(config).bigHour = true;
        });
        addParseToken('hmmss', function(input, array, config) {
            var pos1 = input.length - 4, pos2 = input.length - 2;
            array[HOUR] = toInt(input.substr(0, pos1));
            array[MINUTE] = toInt(input.substr(pos1, 2));
            array[SECOND] = toInt(input.substr(pos2));
            getParsingFlags(config).bigHour = true;
        });
        addParseToken('Hmm', function(input, array, config) {
            var pos = input.length - 2;
            array[HOUR] = toInt(input.substr(0, pos));
            array[MINUTE] = toInt(input.substr(pos));
        });
        addParseToken('Hmmss', function(input, array, config) {
            var pos1 = input.length - 4, pos2 = input.length - 2;
            array[HOUR] = toInt(input.substr(0, pos1));
            array[MINUTE] = toInt(input.substr(pos1, 2));
            array[SECOND] = toInt(input.substr(pos2));
        });
        function localeIsPM(input) {
            return (input + '').toLowerCase().charAt(0) === 'p';
        }
        var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, getSetHour = makeGetSet('Hours', true);
        function localeMeridiem(hours, minutes, isLower) {
            if (hours > 11) return isLower ? 'pm' : 'PM';
            else return isLower ? 'am' : 'AM';
        }
        var baseConfig = {
            calendar: defaultCalendar,
            longDateFormat: defaultLongDateFormat,
            invalidDate: defaultInvalidDate,
            ordinal: defaultOrdinal,
            dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
            relativeTime: defaultRelativeTime,
            months: defaultLocaleMonths,
            monthsShort: defaultLocaleMonthsShort,
            week: defaultLocaleWeek,
            weekdays: defaultLocaleWeekdays,
            weekdaysMin: defaultLocaleWeekdaysMin,
            weekdaysShort: defaultLocaleWeekdaysShort,
            meridiemParse: defaultLocaleMeridiemParse
        };
        var locales = {}, localeFamilies = {}, globalLocale;
        function commonPrefix(arr1, arr2) {
            var i, minl = Math.min(arr1.length, arr2.length);
            for(i = 0; i < minl; i += 1){
                if (arr1[i] !== arr2[i]) return i;
            }
            return minl;
        }
        function normalizeLocale(key) {
            return key ? key.toLowerCase().replace('_', '-') : key;
        }
        function chooseLocale(names) {
            var i = 0, j, next, locale, split;
            while(i < names.length){
                split = normalizeLocale(names[i]).split('-');
                j = split.length;
                next = normalizeLocale(names[i + 1]);
                next = next ? next.split('-') : null;
                while(j > 0){
                    locale = loadLocale(split.slice(0, j).join('-'));
                    if (locale) return locale;
                    if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                    j--;
                }
                i++;
            }
            return globalLocale;
        }
        function isLocaleNameSane(name) {
            return !!(name && name.match('^[^/\\\\]*$'));
        }
        function loadLocale(name) {
            var oldLocale = null, aliasedRequire;
            if (locales[name] === undefined && true && module && module.exports && isLocaleNameSane(name)) try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = undefined;
                aliasedRequire('./locale/' + name);
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                locales[name] = null;
            }
            return locales[name];
        }
        function getSetGlobalLocale(key, values) {
            var data;
            if (key) {
                if (isUndefined(values)) data = getLocale(key);
                else data = defineLocale(key, values);
                if (data) globalLocale = data;
                else if (typeof console !== 'undefined' && console.warn) console.warn('Locale ' + key + ' not found. Did you forget to load it?');
            }
            return globalLocale._abbr;
        }
        function defineLocale(name, config) {
            if (config !== null) {
                var locale, parentConfig = baseConfig;
                config.abbr = name;
                if (locales[name] != null) {
                    deprecateSimple('defineLocaleOverride', "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                    parentConfig = locales[name]._config;
                } else if (config.parentLocale != null) {
                    if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                    else {
                        locale = loadLocale(config.parentLocale);
                        if (locale != null) parentConfig = locale._config;
                        else {
                            if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                            localeFamilies[config.parentLocale].push({
                                name: name,
                                config: config
                            });
                            return null;
                        }
                    }
                }
                locales[name] = new Locale(mergeConfigs(parentConfig, config));
                if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                    defineLocale(x.name, x.config);
                });
                getSetGlobalLocale(name);
                return locales[name];
            } else {
                delete locales[name];
                return null;
            }
        }
        function updateLocale(name, config) {
            if (config != null) {
                var locale, tmpLocale, parentConfig = baseConfig;
                if (locales[name] != null && locales[name].parentLocale != null) locales[name].set(mergeConfigs(locales[name]._config, config));
                else {
                    tmpLocale = loadLocale(name);
                    if (tmpLocale != null) parentConfig = tmpLocale._config;
                    config = mergeConfigs(parentConfig, config);
                    if (tmpLocale == null) config.abbr = name;
                    locale = new Locale(config);
                    locale.parentLocale = locales[name];
                    locales[name] = locale;
                }
                getSetGlobalLocale(name);
            } else if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
                } else if (locales[name] != null) delete locales[name];
            }
            return locales[name];
        }
        function getLocale(key) {
            var locale;
            if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
            if (!key) return globalLocale;
            if (!isArray(key)) {
                locale = loadLocale(key);
                if (locale) return locale;
                key = [
                    key
                ];
            }
            return chooseLocale(key);
        }
        function listLocales() {
            return keys(locales);
        }
        function checkOverflow(m) {
            var overflow, a = m._a;
            if (a && getParsingFlags(m).overflow === -2) {
                overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
                if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
                if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
                if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
                getParsingFlags(m).overflow = overflow;
            }
            return m;
        }
        var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
            [
                'YYYYYY-MM-DD',
                /[+-]\d{6}-\d\d-\d\d/
            ],
            [
                'YYYY-MM-DD',
                /\d{4}-\d\d-\d\d/
            ],
            [
                'GGGG-[W]WW-E',
                /\d{4}-W\d\d-\d/
            ],
            [
                'GGGG-[W]WW',
                /\d{4}-W\d\d/,
                false
            ],
            [
                'YYYY-DDD',
                /\d{4}-\d{3}/
            ],
            [
                'YYYY-MM',
                /\d{4}-\d\d/,
                false
            ],
            [
                'YYYYYYMMDD',
                /[+-]\d{10}/
            ],
            [
                'YYYYMMDD',
                /\d{8}/
            ],
            [
                'GGGG[W]WWE',
                /\d{4}W\d{3}/
            ],
            [
                'GGGG[W]WW',
                /\d{4}W\d{2}/,
                false
            ],
            [
                'YYYYDDD',
                /\d{7}/
            ],
            [
                'YYYYMM',
                /\d{6}/,
                false
            ],
            [
                'YYYY',
                /\d{4}/,
                false
            ]
        ], isoTimes = [
            [
                'HH:mm:ss.SSSS',
                /\d\d:\d\d:\d\d\.\d+/
            ],
            [
                'HH:mm:ss,SSSS',
                /\d\d:\d\d:\d\d,\d+/
            ],
            [
                'HH:mm:ss',
                /\d\d:\d\d:\d\d/
            ],
            [
                'HH:mm',
                /\d\d:\d\d/
            ],
            [
                'HHmmss.SSSS',
                /\d\d\d\d\d\d\.\d+/
            ],
            [
                'HHmmss,SSSS',
                /\d\d\d\d\d\d,\d+/
            ],
            [
                'HHmmss',
                /\d\d\d\d\d\d/
            ],
            [
                'HHmm',
                /\d\d\d\d/
            ],
            [
                'HH',
                /\d\d/
            ]
        ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -240,
            EST: -300,
            CDT: -300,
            CST: -360,
            MDT: -360,
            MST: -420,
            PDT: -420,
            PST: -480
        };
        function configFromISO(config) {
            var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
            if (match) {
                getParsingFlags(config).iso = true;
                for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
                if (dateFormat == null) {
                    config._isValid = false;
                    return;
                }
                if (match[3]) {
                    for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                    if (timeFormat == null) {
                        config._isValid = false;
                        return;
                    }
                }
                if (!allowTime && timeFormat != null) {
                    config._isValid = false;
                    return;
                }
                if (match[4]) {
                    if (tzRegex.exec(match[4])) tzFormat = 'Z';
                    else {
                        config._isValid = false;
                        return;
                    }
                }
                config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
                configFromStringAndFormat(config);
            } else config._isValid = false;
        }
        function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
            var result = [
                untruncateYear(yearStr),
                defaultLocaleMonthsShort.indexOf(monthStr),
                parseInt(dayStr, 10),
                parseInt(hourStr, 10),
                parseInt(minuteStr, 10)
            ];
            if (secondStr) result.push(parseInt(secondStr, 10));
            return result;
        }
        function untruncateYear(yearStr) {
            var year = parseInt(yearStr, 10);
            if (year <= 49) return 2000 + year;
            else if (year <= 999) return 1900 + year;
            return year;
        }
        function preprocessRFC2822(s) {
            return s.replace(/\([^()]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
        }
        function checkWeekday(weekdayStr, parsedInput, config) {
            if (weekdayStr) {
                var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
                if (weekdayProvided !== weekdayActual) {
                    getParsingFlags(config).weekdayMismatch = true;
                    config._isValid = false;
                    return false;
                }
            }
            return true;
        }
        function calculateOffset(obsOffset, militaryOffset, numOffset) {
            if (obsOffset) return obsOffsets[obsOffset];
            else if (militaryOffset) return 0;
            else {
                var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
                return h * 60 + m;
            }
        }
        function configFromRFC2822(config) {
            var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
            if (match) {
                parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
                if (!checkWeekday(match[1], parsedArray, config)) return;
                config._a = parsedArray;
                config._tzm = calculateOffset(match[8], match[9], match[10]);
                config._d = createUTCDate.apply(null, config._a);
                config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
                getParsingFlags(config).rfc2822 = true;
            } else config._isValid = false;
        }
        function configFromString(config) {
            var matched = aspNetJsonRegex.exec(config._i);
            if (matched !== null) {
                config._d = new Date(+matched[1]);
                return;
            }
            configFromISO(config);
            if (config._isValid === false) delete config._isValid;
            else return;
            configFromRFC2822(config);
            if (config._isValid === false) delete config._isValid;
            else return;
            if (config._strict) config._isValid = false;
            else hooks.createFromInputFallback(config);
        }
        hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        });
        function defaults(a, b, c) {
            if (a != null) return a;
            if (b != null) return b;
            return c;
        }
        function currentDateArray(config) {
            var nowValue = new Date(hooks.now());
            if (config._useUTC) return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate()
            ];
            return [
                nowValue.getFullYear(),
                nowValue.getMonth(),
                nowValue.getDate()
            ];
        }
        function configFromArray(config) {
            var i, date, input = [], currentDate, expectedWeekday, yearToUse;
            if (config._d) return;
            currentDate = currentDateArray(config);
            if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config);
            if (config._dayOfYear != null) {
                yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
                if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
                date = createUTCDate(yearToUse, 0, config._dayOfYear);
                config._a[MONTH] = date.getUTCMonth();
                config._a[DATE] = date.getUTCDate();
            }
            for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
            for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
            if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
                config._nextDay = true;
                config._a[HOUR] = 0;
            }
            config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
            expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
            if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            if (config._nextDay) config._a[HOUR] = 24;
            if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
        }
        function dayOfYearFromWeekInfo(config) {
            var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
            w = config._w;
            if (w.GG != null || w.W != null || w.E != null) {
                dow = 1;
                doy = 4;
                weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
                week = defaults(w.W, 1);
                weekday = defaults(w.E, 1);
                if (weekday < 1 || weekday > 7) weekdayOverflow = true;
            } else {
                dow = config._locale._week.dow;
                doy = config._locale._week.doy;
                curWeek = weekOfYear(createLocal(), dow, doy);
                weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
                week = defaults(w.w, curWeek.week);
                if (w.d != null) {
                    weekday = w.d;
                    if (weekday < 0 || weekday > 6) weekdayOverflow = true;
                } else if (w.e != null) {
                    weekday = w.e + dow;
                    if (w.e < 0 || w.e > 6) weekdayOverflow = true;
                } else weekday = dow;
            }
            if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
            else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
            else {
                temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
                config._a[YEAR] = temp.year;
                config._dayOfYear = temp.dayOfYear;
            }
        }
        hooks.ISO_8601 = function() {};
        hooks.RFC_2822 = function() {};
        function configFromStringAndFormat(config) {
            if (config._f === hooks.ISO_8601) {
                configFromISO(config);
                return;
            }
            if (config._f === hooks.RFC_2822) {
                configFromRFC2822(config);
                return;
            }
            config._a = [];
            getParsingFlags(config).empty = true;
            var string = '' + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
            tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
            tokenLen = tokens.length;
            for(i = 0; i < tokenLen; i++){
                token = tokens[i];
                parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
                if (parsedInput) {
                    skipped = string.substr(0, string.indexOf(parsedInput));
                    if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                    string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                    totalParsedInputLength += parsedInput.length;
                }
                if (formatTokenFunctions[token]) {
                    if (parsedInput) getParsingFlags(config).empty = false;
                    else getParsingFlags(config).unusedTokens.push(token);
                    addTimeToArrayFromToken(token, parsedInput, config);
                } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
            }
            getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
            if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
            if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
            getParsingFlags(config).parsedDateParts = config._a.slice(0);
            getParsingFlags(config).meridiem = config._meridiem;
            config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
            era = getParsingFlags(config).era;
            if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
            configFromArray(config);
            checkOverflow(config);
        }
        function meridiemFixWrap(locale, hour, meridiem) {
            var isPm;
            if (meridiem == null) return hour;
            if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
            else if (locale.isPM != null) {
                isPm = locale.isPM(meridiem);
                if (isPm && hour < 12) hour += 12;
                if (!isPm && hour === 12) hour = 0;
                return hour;
            } else return hour;
        }
        function configFromStringAndArray(config) {
            var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, configfLen = config._f.length;
            if (configfLen === 0) {
                getParsingFlags(config).invalidFormat = true;
                config._d = new Date(NaN);
                return;
            }
            for(i = 0; i < configfLen; i++){
                currentScore = 0;
                validFormatFound = false;
                tempConfig = copyConfig({}, config);
                if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
                tempConfig._f = config._f[i];
                configFromStringAndFormat(tempConfig);
                if (isValid(tempConfig)) validFormatFound = true;
                currentScore += getParsingFlags(tempConfig).charsLeftOver;
                currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
                getParsingFlags(tempConfig).score = currentScore;
                if (!bestFormatIsValid) {
                    if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                        scoreToBeat = currentScore;
                        bestMoment = tempConfig;
                        if (validFormatFound) bestFormatIsValid = true;
                    }
                } else if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
            extend(config, bestMoment || tempConfig);
        }
        function configFromObject(config) {
            if (config._d) return;
            var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
            config._a = map([
                i.year,
                i.month,
                dayOrDate,
                i.hour,
                i.minute,
                i.second,
                i.millisecond
            ], function(obj) {
                return obj && parseInt(obj, 10);
            });
            configFromArray(config);
        }
        function createFromConfig(config) {
            var res = new Moment(checkOverflow(prepareConfig(config)));
            if (res._nextDay) {
                res.add(1, 'd');
                res._nextDay = undefined;
            }
            return res;
        }
        function prepareConfig(config) {
            var input = config._i, format = config._f;
            config._locale = config._locale || getLocale(config._l);
            if (input === null || format === undefined && input === '') return createInvalid({
                nullInput: true
            });
            if (typeof input === 'string') config._i = input = config._locale.preparse(input);
            if (isMoment(input)) return new Moment(checkOverflow(input));
            else if (isDate(input)) config._d = input;
            else if (isArray(format)) configFromStringAndArray(config);
            else if (format) configFromStringAndFormat(config);
            else configFromInput(config);
            if (!isValid(config)) config._d = null;
            return config;
        }
        function configFromInput(config) {
            var input = config._i;
            if (isUndefined(input)) config._d = new Date(hooks.now());
            else if (isDate(input)) config._d = new Date(input.valueOf());
            else if (typeof input === 'string') configFromString(config);
            else if (isArray(input)) {
                config._a = map(input.slice(0), function(obj) {
                    return parseInt(obj, 10);
                });
                configFromArray(config);
            } else if (isObject(input)) configFromObject(config);
            else if (isNumber(input)) config._d = new Date(input);
            else hooks.createFromInputFallback(config);
        }
        function createLocalOrUTC(input, format, locale, strict, isUTC) {
            var c = {};
            if (format === true || format === false) {
                strict = format;
                format = undefined;
            }
            if (locale === true || locale === false) {
                strict = locale;
                locale = undefined;
            }
            if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
            c._isAMomentObject = true;
            c._useUTC = c._isUTC = isUTC;
            c._l = locale;
            c._i = input;
            c._f = format;
            c._strict = strict;
            return createFromConfig(c);
        }
        function createLocal(input, format, locale, strict) {
            return createLocalOrUTC(input, format, locale, strict, false);
        }
        var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) return other < this ? this : other;
            else return createInvalid();
        }), prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
            var other = createLocal.apply(null, arguments);
            if (this.isValid() && other.isValid()) return other > this ? this : other;
            else return createInvalid();
        });
        function pickBy(fn, moments) {
            var res, i;
            if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
            if (!moments.length) return createLocal();
            res = moments[0];
            for(i = 1; i < moments.length; ++i)if (!moments[i].isValid() || moments[i][fn](res)) res = moments[i];
            return res;
        }
        function min() {
            var args = [].slice.call(arguments, 0);
            return pickBy('isBefore', args);
        }
        function max() {
            var args = [].slice.call(arguments, 0);
            return pickBy('isAfter', args);
        }
        var now = function() {
            return Date.now ? Date.now() : +new Date();
        };
        var ordering = [
            'year',
            'quarter',
            'month',
            'week',
            'day',
            'hour',
            'minute',
            'second',
            'millisecond'
        ];
        function isDurationValid(m) {
            var key, unitHasDecimal = false, i, orderLen = ordering.length;
            for(key in m){
                if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
            }
            for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
                if (unitHasDecimal) return false;
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
            }
            return true;
        }
        function isValid$1() {
            return this._isValid;
        }
        function createInvalid$1() {
            return createDuration(NaN);
        }
        function Duration(duration) {
            var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
            this._isValid = isDurationValid(normalizedInput);
            this._milliseconds = +milliseconds + seconds * 1e3 + minutes * 6e4 + hours * 3600000;
            this._days = +days + weeks * 7;
            this._months = +months + quarters * 3 + years * 12;
            this._data = {};
            this._locale = getLocale();
            this._bubble();
        }
        function isDuration(obj) {
            return obj instanceof Duration;
        }
        function absRound(number) {
            if (number < 0) return Math.round(-1 * number) * -1;
            else return Math.round(number);
        }
        function compareArrays(array1, array2, dontConvert) {
            var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
            for(i = 0; i < len; i++)if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) diffs++;
            return diffs + lengthDiff;
        }
        function offset(token, separator) {
            addFormatToken(token, 0, 0, function() {
                var offset = this.utcOffset(), sign = '+';
                if (offset < 0) {
                    offset = -offset;
                    sign = '-';
                }
                return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
            });
        }
        offset('Z', ':');
        offset('ZZ', '');
        addRegexToken('Z', matchShortOffset);
        addRegexToken('ZZ', matchShortOffset);
        addParseToken([
            'Z',
            'ZZ'
        ], function(input, array, config) {
            config._useUTC = true;
            config._tzm = offsetFromString(matchShortOffset, input);
        });
        var chunkOffset = /([\+\-]|\d\d)/gi;
        function offsetFromString(matcher, string) {
            var matches = (string || '').match(matcher), chunk, parts, minutes;
            if (matches === null) return null;
            chunk = matches[matches.length - 1] || [];
            parts = (chunk + '').match(chunkOffset) || [
                '-',
                0,
                0
            ];
            minutes = +(parts[1] * 60) + toInt(parts[2]);
            return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
        }
        function cloneWithOffset(input, model) {
            var res, diff;
            if (model._isUTC) {
                res = model.clone();
                diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
                res._d.setTime(res._d.valueOf() + diff);
                hooks.updateOffset(res, false);
                return res;
            } else return createLocal(input).local();
        }
        function getDateOffset(m) {
            return -Math.round(m._d.getTimezoneOffset());
        }
        hooks.updateOffset = function() {};
        function getSetOffset(input, keepLocalTime, keepMinutes) {
            var offset = this._offset || 0, localAdjust;
            if (!this.isValid()) return input != null ? this : NaN;
            if (input != null) {
                if (typeof input === 'string') {
                    input = offsetFromString(matchShortOffset, input);
                    if (input === null) return this;
                } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
                if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
                this._offset = input;
                this._isUTC = true;
                if (localAdjust != null) this.add(localAdjust, 'm');
                if (offset !== input) {
                    if (!keepLocalTime || this._changeInProgress) addSubtract(this, createDuration(input - offset, 'm'), 1, false);
                    else if (!this._changeInProgress) {
                        this._changeInProgress = true;
                        hooks.updateOffset(this, true);
                        this._changeInProgress = null;
                    }
                }
                return this;
            } else return this._isUTC ? offset : getDateOffset(this);
        }
        function getSetZone(input, keepLocalTime) {
            if (input != null) {
                if (typeof input !== 'string') input = -input;
                this.utcOffset(input, keepLocalTime);
                return this;
            } else return -this.utcOffset();
        }
        function setOffsetToUTC(keepLocalTime) {
            return this.utcOffset(0, keepLocalTime);
        }
        function setOffsetToLocal(keepLocalTime) {
            if (this._isUTC) {
                this.utcOffset(0, keepLocalTime);
                this._isUTC = false;
                if (keepLocalTime) this.subtract(getDateOffset(this), 'm');
            }
            return this;
        }
        function setOffsetToParsedOffset() {
            if (this._tzm != null) this.utcOffset(this._tzm, false, true);
            else if (typeof this._i === 'string') {
                var tZone = offsetFromString(matchOffset, this._i);
                if (tZone != null) this.utcOffset(tZone);
                else this.utcOffset(0, true);
            }
            return this;
        }
        function hasAlignedHourOffset(input) {
            if (!this.isValid()) return false;
            input = input ? createLocal(input).utcOffset() : 0;
            return (this.utcOffset() - input) % 60 === 0;
        }
        function isDaylightSavingTime() {
            return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
        }
        function isDaylightSavingTimeShifted() {
            if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
            var c = {}, other;
            copyConfig(c, this);
            c = prepareConfig(c);
            if (c._a) {
                other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
                this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
            } else this._isDSTShifted = false;
            return this._isDSTShifted;
        }
        function isLocal() {
            return this.isValid() ? !this._isUTC : false;
        }
        function isUtcOffset() {
            return this.isValid() ? this._isUTC : false;
        }
        function isUtc() {
            return this.isValid() ? this._isUTC && this._offset === 0 : false;
        }
        var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
        function createDuration(input, key) {
            var duration = input, match = null, sign, ret, diffRes;
            if (isDuration(input)) duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months
            };
            else if (isNumber(input) || !isNaN(+input)) {
                duration = {};
                if (key) duration[key] = +input;
                else duration.milliseconds = +input;
            } else if (match = aspNetRegex.exec(input)) {
                sign = match[1] === '-' ? -1 : 1;
                duration = {
                    y: 0,
                    d: toInt(match[DATE]) * sign,
                    h: toInt(match[HOUR]) * sign,
                    m: toInt(match[MINUTE]) * sign,
                    s: toInt(match[SECOND]) * sign,
                    ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
                };
            } else if (match = isoRegex.exec(input)) {
                sign = match[1] === '-' ? -1 : 1;
                duration = {
                    y: parseIso(match[2], sign),
                    M: parseIso(match[3], sign),
                    w: parseIso(match[4], sign),
                    d: parseIso(match[5], sign),
                    h: parseIso(match[6], sign),
                    m: parseIso(match[7], sign),
                    s: parseIso(match[8], sign)
                };
            } else if (duration == null) duration = {};
            else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
                diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
                duration = {};
                duration.ms = diffRes.milliseconds;
                duration.M = diffRes.months;
            }
            ret = new Duration(duration);
            if (isDuration(input) && hasOwnProp(input, '_locale')) ret._locale = input._locale;
            if (isDuration(input) && hasOwnProp(input, '_isValid')) ret._isValid = input._isValid;
            return ret;
        }
        createDuration.fn = Duration.prototype;
        createDuration.invalid = createInvalid$1;
        function parseIso(inp, sign) {
            var res = inp && parseFloat(inp.replace(',', '.'));
            return (isNaN(res) ? 0 : res) * sign;
        }
        function positiveMomentsDifference(base, other) {
            var res = {};
            res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
            if (base.clone().add(res.months, 'M').isAfter(other)) --res.months;
            res.milliseconds = +other - +base.clone().add(res.months, 'M');
            return res;
        }
        function momentsDifference(base, other) {
            var res;
            if (!(base.isValid() && other.isValid())) return {
                milliseconds: 0,
                months: 0
            };
            other = cloneWithOffset(other, base);
            if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
            else {
                res = positiveMomentsDifference(other, base);
                res.milliseconds = -res.milliseconds;
                res.months = -res.months;
            }
            return res;
        }
        function createAdder(direction, name) {
            return function(val, period) {
                var dur, tmp;
                if (period !== null && !isNaN(+period)) {
                    deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                    tmp = val;
                    val = period;
                    period = tmp;
                }
                dur = createDuration(val, period);
                addSubtract(this, dur, direction);
                return this;
            };
        }
        function addSubtract(mom, duration, isAdding, updateOffset) {
            var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
            if (!mom.isValid()) return;
            updateOffset = updateOffset == null ? true : updateOffset;
            if (months) setMonth(mom, get(mom, 'Month') + months * isAdding);
            if (days) set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
            if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
            if (updateOffset) hooks.updateOffset(mom, days || months);
        }
        var add = createAdder(1, 'add'), subtract = createAdder(-1, 'subtract');
        function isString(input) {
            return typeof input === 'string' || input instanceof String;
        }
        function isMomentInput(input) {
            return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
        }
        function isMomentInputObject(input) {
            var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms'
            ], i, property, propertyLen = properties.length;
            for(i = 0; i < propertyLen; i += 1){
                property = properties[i];
                propertyTest = propertyTest || hasOwnProp(input, property);
            }
            return objectTest && propertyTest;
        }
        function isNumberOrStringArray(input) {
            var arrayTest = isArray(input), dataTypeTest = false;
            if (arrayTest) dataTypeTest = input.filter(function(item) {
                return !isNumber(item) && isString(input);
            }).length === 0;
            return arrayTest && dataTypeTest;
        }
        function isCalendarSpec(input) {
            var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse'
            ], i, property;
            for(i = 0; i < properties.length; i += 1){
                property = properties[i];
                propertyTest = propertyTest || hasOwnProp(input, property);
            }
            return objectTest && propertyTest;
        }
        function getCalendarFormat(myMoment, now) {
            var diff = myMoment.diff(now, 'days', true);
            return diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
        }
        function calendar$1(time, formats) {
            if (arguments.length === 1) {
                if (!arguments[0]) {
                    time = undefined;
                    formats = undefined;
                } else if (isMomentInput(arguments[0])) {
                    time = arguments[0];
                    formats = undefined;
                } else if (isCalendarSpec(arguments[0])) {
                    formats = arguments[0];
                    time = undefined;
                }
            }
            var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf('day'), format = hooks.calendarFormat(this, sod) || 'sameElse', output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
            return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
        }
        function clone() {
            return new Moment(this);
        }
        function isAfter(input, units) {
            var localInput = isMoment(input) ? input : createLocal(input);
            if (!(this.isValid() && localInput.isValid())) return false;
            units = normalizeUnits(units) || 'millisecond';
            if (units === 'millisecond') return this.valueOf() > localInput.valueOf();
            else return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
        function isBefore(input, units) {
            var localInput = isMoment(input) ? input : createLocal(input);
            if (!(this.isValid() && localInput.isValid())) return false;
            units = normalizeUnits(units) || 'millisecond';
            if (units === 'millisecond') return this.valueOf() < localInput.valueOf();
            else return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
        function isBetween(from, to, units, inclusivity) {
            var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
            if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
            inclusivity = inclusivity || '()';
            return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
        }
        function isSame(input, units) {
            var localInput = isMoment(input) ? input : createLocal(input), inputMs;
            if (!(this.isValid() && localInput.isValid())) return false;
            units = normalizeUnits(units) || 'millisecond';
            if (units === 'millisecond') return this.valueOf() === localInput.valueOf();
            else {
                inputMs = localInput.valueOf();
                return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
            }
        }
        function isSameOrAfter(input, units) {
            return this.isSame(input, units) || this.isAfter(input, units);
        }
        function isSameOrBefore(input, units) {
            return this.isSame(input, units) || this.isBefore(input, units);
        }
        function diff(input, units, asFloat) {
            var that, zoneDelta, output;
            if (!this.isValid()) return NaN;
            that = cloneWithOffset(input, this);
            if (!that.isValid()) return NaN;
            zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
            units = normalizeUnits(units);
            switch(units){
                case 'year':
                    output = monthDiff(this, that) / 12;
                    break;
                case 'month':
                    output = monthDiff(this, that);
                    break;
                case 'quarter':
                    output = monthDiff(this, that) / 3;
                    break;
                case 'second':
                    output = (this - that) / 1e3;
                    break;
                case 'minute':
                    output = (this - that) / 6e4;
                    break;
                case 'hour':
                    output = (this - that) / 36e5;
                    break;
                case 'day':
                    output = (this - that - zoneDelta) / 864e5;
                    break;
                case 'week':
                    output = (this - that - zoneDelta) / 6048e5;
                    break;
                default:
                    output = this - that;
            }
            return asFloat ? output : absFloor(output);
        }
        function monthDiff(a, b) {
            if (a.date() < b.date()) return -monthDiff(b, a);
            var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), anchor = a.clone().add(wholeMonthDiff, 'months'), anchor2, adjust;
            if (b - anchor < 0) {
                anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
                adjust = (b - anchor) / (anchor - anchor2);
            } else {
                anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
                adjust = (b - anchor) / (anchor2 - anchor);
            }
            return -(wholeMonthDiff + adjust) || 0;
        }
        hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
        hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
        function toString() {
            return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
        }
        function toISOString(keepOffset) {
            if (!this.isValid()) return null;
            var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
            if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
            if (isFunction(Date.prototype.toISOString)) {
                if (utc) return this.toDate().toISOString();
                else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace('Z', formatMoment(m, 'Z'));
            }
            return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
        }
        function inspect() {
            if (!this.isValid()) return 'moment.invalid(/* ' + this._i + ' */)';
            var func = 'moment', zone = '', prefix, year, datetime, suffix;
            if (!this.isLocal()) {
                func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
                zone = 'Z';
            }
            prefix = '[' + func + '("]';
            year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
            datetime = '-MM-DD[T]HH:mm:ss.SSS';
            suffix = zone + '[")]';
            return this.format(prefix + year + datetime + suffix);
        }
        function format(inputString) {
            if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
            var output = formatMoment(this, inputString);
            return this.localeData().postformat(output);
        }
        function from(time, withoutSuffix) {
            if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
                to: this,
                from: time
            }).locale(this.locale()).humanize(!withoutSuffix);
            else return this.localeData().invalidDate();
        }
        function fromNow(withoutSuffix) {
            return this.from(createLocal(), withoutSuffix);
        }
        function to(time, withoutSuffix) {
            if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
                from: this,
                to: time
            }).locale(this.locale()).humanize(!withoutSuffix);
            else return this.localeData().invalidDate();
        }
        function toNow(withoutSuffix) {
            return this.to(createLocal(), withoutSuffix);
        }
        function locale(key) {
            var newLocaleData;
            if (key === undefined) return this._locale._abbr;
            else {
                newLocaleData = getLocale(key);
                if (newLocaleData != null) this._locale = newLocaleData;
                return this;
            }
        }
        var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function(key) {
            if (key === undefined) return this.localeData();
            else return this.locale(key);
        });
        function localeData() {
            return this._locale;
        }
        var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
        function mod$1(dividend, divisor) {
            return (dividend % divisor + divisor) % divisor;
        }
        function localStartOfDate(y, m, d) {
            if (y < 100 && y >= 0) return new Date(y + 400, m, d) - MS_PER_400_YEARS;
            else return new Date(y, m, d).valueOf();
        }
        function utcStartOfDate(y, m, d) {
            if (y < 100 && y >= 0) return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
            else return Date.UTC(y, m, d);
        }
        function startOf(units) {
            var time, startOfDate;
            units = normalizeUnits(units);
            if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
            startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
            switch(units){
                case 'year':
                    time = startOfDate(this.year(), 0, 1);
                    break;
                case 'quarter':
                    time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                    break;
                case 'month':
                    time = startOfDate(this.year(), this.month(), 1);
                    break;
                case 'week':
                    time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                    break;
                case 'isoWeek':
                    time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                    break;
                case 'day':
                case 'date':
                    time = startOfDate(this.year(), this.month(), this.date());
                    break;
                case 'hour':
                    time = this._d.valueOf();
                    time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                    break;
                case 'minute':
                    time = this._d.valueOf();
                    time -= mod$1(time, MS_PER_MINUTE);
                    break;
                case 'second':
                    time = this._d.valueOf();
                    time -= mod$1(time, MS_PER_SECOND);
                    break;
            }
            this._d.setTime(time);
            hooks.updateOffset(this, true);
            return this;
        }
        function endOf(units) {
            var time, startOfDate;
            units = normalizeUnits(units);
            if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
            startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
            switch(units){
                case 'year':
                    time = startOfDate(this.year() + 1, 0, 1) - 1;
                    break;
                case 'quarter':
                    time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                    break;
                case 'month':
                    time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                    break;
                case 'week':
                    time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                    break;
                case 'isoWeek':
                    time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                    break;
                case 'day':
                case 'date':
                    time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                    break;
                case 'hour':
                    time = this._d.valueOf();
                    time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                    break;
                case 'minute':
                    time = this._d.valueOf();
                    time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                    break;
                case 'second':
                    time = this._d.valueOf();
                    time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                    break;
            }
            this._d.setTime(time);
            hooks.updateOffset(this, true);
            return this;
        }
        function valueOf() {
            return this._d.valueOf() - (this._offset || 0) * 60000;
        }
        function unix() {
            return Math.floor(this.valueOf() / 1000);
        }
        function toDate() {
            return new Date(this.valueOf());
        }
        function toArray() {
            var m = this;
            return [
                m.year(),
                m.month(),
                m.date(),
                m.hour(),
                m.minute(),
                m.second(),
                m.millisecond()
            ];
        }
        function toObject() {
            var m = this;
            return {
                years: m.year(),
                months: m.month(),
                date: m.date(),
                hours: m.hours(),
                minutes: m.minutes(),
                seconds: m.seconds(),
                milliseconds: m.milliseconds()
            };
        }
        function toJSON() {
            return this.isValid() ? this.toISOString() : null;
        }
        function isValid$2() {
            return isValid(this);
        }
        function parsingFlags() {
            return extend({}, getParsingFlags(this));
        }
        function invalidAt() {
            return getParsingFlags(this).overflow;
        }
        function creationData() {
            return {
                input: this._i,
                format: this._f,
                locale: this._locale,
                isUTC: this._isUTC,
                strict: this._strict
            };
        }
        addFormatToken('N', 0, 0, 'eraAbbr');
        addFormatToken('NN', 0, 0, 'eraAbbr');
        addFormatToken('NNN', 0, 0, 'eraAbbr');
        addFormatToken('NNNN', 0, 0, 'eraName');
        addFormatToken('NNNNN', 0, 0, 'eraNarrow');
        addFormatToken('y', [
            'y',
            1
        ], 'yo', 'eraYear');
        addFormatToken('y', [
            'yy',
            2
        ], 0, 'eraYear');
        addFormatToken('y', [
            'yyy',
            3
        ], 0, 'eraYear');
        addFormatToken('y', [
            'yyyy',
            4
        ], 0, 'eraYear');
        addRegexToken('N', matchEraAbbr);
        addRegexToken('NN', matchEraAbbr);
        addRegexToken('NNN', matchEraAbbr);
        addRegexToken('NNNN', matchEraName);
        addRegexToken('NNNNN', matchEraNarrow);
        addParseToken([
            'N',
            'NN',
            'NNN',
            'NNNN',
            'NNNNN'
        ], function(input, array, config, token) {
            var era = config._locale.erasParse(input, token, config._strict);
            if (era) getParsingFlags(config).era = era;
            else getParsingFlags(config).invalidEra = input;
        });
        addRegexToken('y', matchUnsigned);
        addRegexToken('yy', matchUnsigned);
        addRegexToken('yyy', matchUnsigned);
        addRegexToken('yyyy', matchUnsigned);
        addRegexToken('yo', matchEraYearOrdinal);
        addParseToken([
            'y',
            'yy',
            'yyy',
            'yyyy'
        ], YEAR);
        addParseToken([
            'yo'
        ], function(input, array, config, token) {
            var match;
            if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
            if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
            else array[YEAR] = parseInt(input, 10);
        });
        function localeEras(m, format) {
            var i, l, date, eras = this._eras || getLocale('en')._eras;
            for(i = 0, l = eras.length; i < l; ++i){
                switch(typeof eras[i].since){
                    case 'string':
                        date = hooks(eras[i].since).startOf('day');
                        eras[i].since = date.valueOf();
                        break;
                }
                switch(typeof eras[i].until){
                    case 'undefined':
                        eras[i].until = Infinity;
                        break;
                    case 'string':
                        date = hooks(eras[i].until).startOf('day').valueOf();
                        eras[i].until = date.valueOf();
                        break;
                }
            }
            return eras;
        }
        function localeErasParse(eraName, format, strict) {
            var i, l, eras = this.eras(), name, abbr, narrow;
            eraName = eraName.toUpperCase();
            for(i = 0, l = eras.length; i < l; ++i){
                name = eras[i].name.toUpperCase();
                abbr = eras[i].abbr.toUpperCase();
                narrow = eras[i].narrow.toUpperCase();
                if (strict) switch(format){
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) return eras[i];
                        break;
                    case 'NNNN':
                        if (name === eraName) return eras[i];
                        break;
                    case 'NNNNN':
                        if (narrow === eraName) return eras[i];
                        break;
                }
                else if ([
                    name,
                    abbr,
                    narrow
                ].indexOf(eraName) >= 0) return eras[i];
            }
        }
        function localeErasConvertYear(era, year) {
            var dir = era.since <= era.until ? 1 : -1;
            if (year === undefined) return hooks(era.since).year();
            else return hooks(era.since).year() + (year - era.offset) * dir;
        }
        function getEraName() {
            var i, l, val, eras = this.localeData().eras();
            for(i = 0, l = eras.length; i < l; ++i){
                val = this.clone().startOf('day').valueOf();
                if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
                if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
            }
            return '';
        }
        function getEraNarrow() {
            var i, l, val, eras = this.localeData().eras();
            for(i = 0, l = eras.length; i < l; ++i){
                val = this.clone().startOf('day').valueOf();
                if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
                if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
            }
            return '';
        }
        function getEraAbbr() {
            var i, l, val, eras = this.localeData().eras();
            for(i = 0, l = eras.length; i < l; ++i){
                val = this.clone().startOf('day').valueOf();
                if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
                if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
            }
            return '';
        }
        function getEraYear() {
            var i, l, dir, val, eras = this.localeData().eras();
            for(i = 0, l = eras.length; i < l; ++i){
                dir = eras[i].since <= eras[i].until ? 1 : -1;
                val = this.clone().startOf('day').valueOf();
                if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
            }
            return this.year();
        }
        function erasNameRegex(isStrict) {
            if (!hasOwnProp(this, '_erasNameRegex')) computeErasParse.call(this);
            return isStrict ? this._erasNameRegex : this._erasRegex;
        }
        function erasAbbrRegex(isStrict) {
            if (!hasOwnProp(this, '_erasAbbrRegex')) computeErasParse.call(this);
            return isStrict ? this._erasAbbrRegex : this._erasRegex;
        }
        function erasNarrowRegex(isStrict) {
            if (!hasOwnProp(this, '_erasNarrowRegex')) computeErasParse.call(this);
            return isStrict ? this._erasNarrowRegex : this._erasRegex;
        }
        function matchEraAbbr(isStrict, locale) {
            return locale.erasAbbrRegex(isStrict);
        }
        function matchEraName(isStrict, locale) {
            return locale.erasNameRegex(isStrict);
        }
        function matchEraNarrow(isStrict, locale) {
            return locale.erasNarrowRegex(isStrict);
        }
        function matchEraYearOrdinal(isStrict, locale) {
            return locale._eraYearOrdinalRegex || matchUnsigned;
        }
        function computeErasParse() {
            var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
            for(i = 0, l = eras.length; i < l; ++i){
                erasName = regexEscape(eras[i].name);
                erasAbbr = regexEscape(eras[i].abbr);
                erasNarrow = regexEscape(eras[i].narrow);
                namePieces.push(erasName);
                abbrPieces.push(erasAbbr);
                narrowPieces.push(erasNarrow);
                mixedPieces.push(erasName);
                mixedPieces.push(erasAbbr);
                mixedPieces.push(erasNarrow);
            }
            this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
            this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
            this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
            this._erasNarrowRegex = new RegExp('^(' + narrowPieces.join('|') + ')', 'i');
        }
        addFormatToken(0, [
            'gg',
            2
        ], 0, function() {
            return this.weekYear() % 100;
        });
        addFormatToken(0, [
            'GG',
            2
        ], 0, function() {
            return this.isoWeekYear() % 100;
        });
        function addWeekYearFormatToken(token, getter) {
            addFormatToken(0, [
                token,
                token.length
            ], 0, getter);
        }
        addWeekYearFormatToken('gggg', 'weekYear');
        addWeekYearFormatToken('ggggg', 'weekYear');
        addWeekYearFormatToken('GGGG', 'isoWeekYear');
        addWeekYearFormatToken('GGGGG', 'isoWeekYear');
        addRegexToken('G', matchSigned);
        addRegexToken('g', matchSigned);
        addRegexToken('GG', match1to2, match2);
        addRegexToken('gg', match1to2, match2);
        addRegexToken('GGGG', match1to4, match4);
        addRegexToken('gggg', match1to4, match4);
        addRegexToken('GGGGG', match1to6, match6);
        addRegexToken('ggggg', match1to6, match6);
        addWeekParseToken([
            'gggg',
            'ggggg',
            'GGGG',
            'GGGGG'
        ], function(input, week, config, token) {
            week[token.substr(0, 2)] = toInt(input);
        });
        addWeekParseToken([
            'gg',
            'GG'
        ], function(input, week, config, token) {
            week[token] = hooks.parseTwoDigitYear(input);
        });
        function getSetWeekYear(input) {
            return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
        }
        function getSetISOWeekYear(input) {
            return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
        }
        function getISOWeeksInYear() {
            return weeksInYear(this.year(), 1, 4);
        }
        function getISOWeeksInISOWeekYear() {
            return weeksInYear(this.isoWeekYear(), 1, 4);
        }
        function getWeeksInYear() {
            var weekInfo = this.localeData()._week;
            return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
        }
        function getWeeksInWeekYear() {
            var weekInfo = this.localeData()._week;
            return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
        }
        function getSetWeekYearHelper(input, week, weekday, dow, doy) {
            var weeksTarget;
            if (input == null) return weekOfYear(this, dow, doy).year;
            else {
                weeksTarget = weeksInYear(input, dow, doy);
                if (week > weeksTarget) week = weeksTarget;
                return setWeekAll.call(this, input, week, weekday, dow, doy);
            }
        }
        function setWeekAll(weekYear, week, weekday, dow, doy) {
            var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
            this.year(date.getUTCFullYear());
            this.month(date.getUTCMonth());
            this.date(date.getUTCDate());
            return this;
        }
        addFormatToken('Q', 0, 'Qo', 'quarter');
        addRegexToken('Q', match1);
        addParseToken('Q', function(input, array) {
            array[MONTH] = (toInt(input) - 1) * 3;
        });
        function getSetQuarter(input) {
            return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
        }
        addFormatToken('D', [
            'DD',
            2
        ], 'Do', 'date');
        addRegexToken('D', match1to2, match1to2NoLeadingZero);
        addRegexToken('DD', match1to2, match2);
        addRegexToken('Do', function(isStrict, locale) {
            return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
        });
        addParseToken([
            'D',
            'DD'
        ], DATE);
        addParseToken('Do', function(input, array) {
            array[DATE] = toInt(input.match(match1to2)[0]);
        });
        var getSetDayOfMonth = makeGetSet('Date', true);
        addFormatToken('DDD', [
            'DDDD',
            3
        ], 'DDDo', 'dayOfYear');
        addRegexToken('DDD', match1to3);
        addRegexToken('DDDD', match3);
        addParseToken([
            'DDD',
            'DDDD'
        ], function(input, array, config) {
            config._dayOfYear = toInt(input);
        });
        function getSetDayOfYear(input) {
            var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
            return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
        }
        addFormatToken('m', [
            'mm',
            2
        ], 0, 'minute');
        addRegexToken('m', match1to2, match1to2HasZero);
        addRegexToken('mm', match1to2, match2);
        addParseToken([
            'm',
            'mm'
        ], MINUTE);
        var getSetMinute = makeGetSet('Minutes', false);
        addFormatToken('s', [
            'ss',
            2
        ], 0, 'second');
        addRegexToken('s', match1to2, match1to2HasZero);
        addRegexToken('ss', match1to2, match2);
        addParseToken([
            's',
            'ss'
        ], SECOND);
        var getSetSecond = makeGetSet('Seconds', false);
        addFormatToken('S', 0, 0, function() {
            return ~~(this.millisecond() / 100);
        });
        addFormatToken(0, [
            'SS',
            2
        ], 0, function() {
            return ~~(this.millisecond() / 10);
        });
        addFormatToken(0, [
            'SSS',
            3
        ], 0, 'millisecond');
        addFormatToken(0, [
            'SSSS',
            4
        ], 0, function() {
            return this.millisecond() * 10;
        });
        addFormatToken(0, [
            'SSSSS',
            5
        ], 0, function() {
            return this.millisecond() * 100;
        });
        addFormatToken(0, [
            'SSSSSS',
            6
        ], 0, function() {
            return this.millisecond() * 1000;
        });
        addFormatToken(0, [
            'SSSSSSS',
            7
        ], 0, function() {
            return this.millisecond() * 10000;
        });
        addFormatToken(0, [
            'SSSSSSSS',
            8
        ], 0, function() {
            return this.millisecond() * 100000;
        });
        addFormatToken(0, [
            'SSSSSSSSS',
            9
        ], 0, function() {
            return this.millisecond() * 1000000;
        });
        addRegexToken('S', match1to3, match1);
        addRegexToken('SS', match1to3, match2);
        addRegexToken('SSS', match1to3, match3);
        var token, getSetMillisecond;
        for(token = 'SSSS'; token.length <= 9; token += 'S')addRegexToken(token, matchUnsigned);
        function parseMs(input, array) {
            array[MILLISECOND] = toInt(('0.' + input) * 1000);
        }
        for(token = 'S'; token.length <= 9; token += 'S')addParseToken(token, parseMs);
        getSetMillisecond = makeGetSet('Milliseconds', false);
        addFormatToken('z', 0, 0, 'zoneAbbr');
        addFormatToken('zz', 0, 0, 'zoneName');
        function getZoneAbbr() {
            return this._isUTC ? 'UTC' : '';
        }
        function getZoneName() {
            return this._isUTC ? 'Coordinated Universal Time' : '';
        }
        var proto = Moment.prototype;
        proto.add = add;
        proto.calendar = calendar$1;
        proto.clone = clone;
        proto.diff = diff;
        proto.endOf = endOf;
        proto.format = format;
        proto.from = from;
        proto.fromNow = fromNow;
        proto.to = to;
        proto.toNow = toNow;
        proto.get = stringGet;
        proto.invalidAt = invalidAt;
        proto.isAfter = isAfter;
        proto.isBefore = isBefore;
        proto.isBetween = isBetween;
        proto.isSame = isSame;
        proto.isSameOrAfter = isSameOrAfter;
        proto.isSameOrBefore = isSameOrBefore;
        proto.isValid = isValid$2;
        proto.lang = lang;
        proto.locale = locale;
        proto.localeData = localeData;
        proto.max = prototypeMax;
        proto.min = prototypeMin;
        proto.parsingFlags = parsingFlags;
        proto.set = stringSet;
        proto.startOf = startOf;
        proto.subtract = subtract;
        proto.toArray = toArray;
        proto.toObject = toObject;
        proto.toDate = toDate;
        proto.toISOString = toISOString;
        proto.inspect = inspect;
        if (typeof Symbol !== 'undefined' && Symbol.for != null) proto[Symbol.for('nodejs.util.inspect.custom')] = function() {
            return 'Moment<' + this.format() + '>';
        };
        proto.toJSON = toJSON;
        proto.toString = toString;
        proto.unix = unix;
        proto.valueOf = valueOf;
        proto.creationData = creationData;
        proto.eraName = getEraName;
        proto.eraNarrow = getEraNarrow;
        proto.eraAbbr = getEraAbbr;
        proto.eraYear = getEraYear;
        proto.year = getSetYear;
        proto.isLeapYear = getIsLeapYear;
        proto.weekYear = getSetWeekYear;
        proto.isoWeekYear = getSetISOWeekYear;
        proto.quarter = proto.quarters = getSetQuarter;
        proto.month = getSetMonth;
        proto.daysInMonth = getDaysInMonth;
        proto.week = proto.weeks = getSetWeek;
        proto.isoWeek = proto.isoWeeks = getSetISOWeek;
        proto.weeksInYear = getWeeksInYear;
        proto.weeksInWeekYear = getWeeksInWeekYear;
        proto.isoWeeksInYear = getISOWeeksInYear;
        proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
        proto.date = getSetDayOfMonth;
        proto.day = proto.days = getSetDayOfWeek;
        proto.weekday = getSetLocaleDayOfWeek;
        proto.isoWeekday = getSetISODayOfWeek;
        proto.dayOfYear = getSetDayOfYear;
        proto.hour = proto.hours = getSetHour;
        proto.minute = proto.minutes = getSetMinute;
        proto.second = proto.seconds = getSetSecond;
        proto.millisecond = proto.milliseconds = getSetMillisecond;
        proto.utcOffset = getSetOffset;
        proto.utc = setOffsetToUTC;
        proto.local = setOffsetToLocal;
        proto.parseZone = setOffsetToParsedOffset;
        proto.hasAlignedHourOffset = hasAlignedHourOffset;
        proto.isDST = isDaylightSavingTime;
        proto.isLocal = isLocal;
        proto.isUtcOffset = isUtcOffset;
        proto.isUtc = isUtc;
        proto.isUTC = isUtc;
        proto.zoneAbbr = getZoneAbbr;
        proto.zoneName = getZoneName;
        proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
        proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
        proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
        proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
        proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
        function createUnix(input) {
            return createLocal(input * 1000);
        }
        function createInZone() {
            return createLocal.apply(null, arguments).parseZone();
        }
        function preParsePostFormat(string) {
            return string;
        }
        var proto$1 = Locale.prototype;
        proto$1.calendar = calendar;
        proto$1.longDateFormat = longDateFormat;
        proto$1.invalidDate = invalidDate;
        proto$1.ordinal = ordinal;
        proto$1.preparse = preParsePostFormat;
        proto$1.postformat = preParsePostFormat;
        proto$1.relativeTime = relativeTime;
        proto$1.pastFuture = pastFuture;
        proto$1.set = set;
        proto$1.eras = localeEras;
        proto$1.erasParse = localeErasParse;
        proto$1.erasConvertYear = localeErasConvertYear;
        proto$1.erasAbbrRegex = erasAbbrRegex;
        proto$1.erasNameRegex = erasNameRegex;
        proto$1.erasNarrowRegex = erasNarrowRegex;
        proto$1.months = localeMonths;
        proto$1.monthsShort = localeMonthsShort;
        proto$1.monthsParse = localeMonthsParse;
        proto$1.monthsRegex = monthsRegex;
        proto$1.monthsShortRegex = monthsShortRegex;
        proto$1.week = localeWeek;
        proto$1.firstDayOfYear = localeFirstDayOfYear;
        proto$1.firstDayOfWeek = localeFirstDayOfWeek;
        proto$1.weekdays = localeWeekdays;
        proto$1.weekdaysMin = localeWeekdaysMin;
        proto$1.weekdaysShort = localeWeekdaysShort;
        proto$1.weekdaysParse = localeWeekdaysParse;
        proto$1.weekdaysRegex = weekdaysRegex;
        proto$1.weekdaysShortRegex = weekdaysShortRegex;
        proto$1.weekdaysMinRegex = weekdaysMinRegex;
        proto$1.isPM = localeIsPM;
        proto$1.meridiem = localeMeridiem;
        function get$1(format, index, field, setter) {
            var locale = getLocale(), utc = createUTC().set(setter, index);
            return locale[field](utc, format);
        }
        function listMonthsImpl(format, index, field) {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
            if (index != null) return get$1(format, index, field, 'month');
            var i, out = [];
            for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, 'month');
            return out;
        }
        function listWeekdaysImpl(localeSorted, format, index, field) {
            if (typeof localeSorted === 'boolean') {
                if (isNumber(format)) {
                    index = format;
                    format = undefined;
                }
                format = format || '';
            } else {
                format = localeSorted;
                index = format;
                localeSorted = false;
                if (isNumber(format)) {
                    index = format;
                    format = undefined;
                }
                format = format || '';
            }
            var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
            if (index != null) return get$1(format, (index + shift) % 7, field, 'day');
            for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, 'day');
            return out;
        }
        function listMonths(format, index) {
            return listMonthsImpl(format, index, 'months');
        }
        function listMonthsShort(format, index) {
            return listMonthsImpl(format, index, 'monthsShort');
        }
        function listWeekdays(localeSorted, format, index) {
            return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
        }
        function listWeekdaysShort(localeSorted, format, index) {
            return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
        }
        function listWeekdaysMin(localeSorted, format, index) {
            return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
        }
        getSetGlobalLocale('en', {
            eras: [
                {
                    since: '0001-01-01',
                    until: Infinity,
                    offset: 1,
                    name: 'Anno Domini',
                    narrow: 'AD',
                    abbr: 'AD'
                },
                {
                    since: '0000-12-31',
                    until: -Infinity,
                    offset: 1,
                    name: 'Before Christ',
                    narrow: 'BC',
                    abbr: 'BC'
                }
            ],
            dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
            ordinal: function(number) {
                var b = number % 10, output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
                return number + output;
            }
        });
        hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
        hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
        var mathAbs = Math.abs;
        function abs() {
            var data = this._data;
            this._milliseconds = mathAbs(this._milliseconds);
            this._days = mathAbs(this._days);
            this._months = mathAbs(this._months);
            data.milliseconds = mathAbs(data.milliseconds);
            data.seconds = mathAbs(data.seconds);
            data.minutes = mathAbs(data.minutes);
            data.hours = mathAbs(data.hours);
            data.months = mathAbs(data.months);
            data.years = mathAbs(data.years);
            return this;
        }
        function addSubtract$1(duration, input, value, direction) {
            var other = createDuration(input, value);
            duration._milliseconds += direction * other._milliseconds;
            duration._days += direction * other._days;
            duration._months += direction * other._months;
            return duration._bubble();
        }
        function add$1(input, value) {
            return addSubtract$1(this, input, value, 1);
        }
        function subtract$1(input, value) {
            return addSubtract$1(this, input, value, -1);
        }
        function absCeil(number) {
            if (number < 0) return Math.floor(number);
            else return Math.ceil(number);
        }
        function bubble() {
            var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
            if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
                milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
                days = 0;
                months = 0;
            }
            data.milliseconds = milliseconds % 1000;
            seconds = absFloor(milliseconds / 1000);
            data.seconds = seconds % 60;
            minutes = absFloor(seconds / 60);
            data.minutes = minutes % 60;
            hours = absFloor(minutes / 60);
            data.hours = hours % 24;
            days += absFloor(hours / 24);
            monthsFromDays = absFloor(daysToMonths(days));
            months += monthsFromDays;
            days -= absCeil(monthsToDays(monthsFromDays));
            years = absFloor(months / 12);
            months %= 12;
            data.days = days;
            data.months = months;
            data.years = years;
            return this;
        }
        function daysToMonths(days) {
            return days * 4800 / 146097;
        }
        function monthsToDays(months) {
            return months * 146097 / 4800;
        }
        function as(units) {
            if (!this.isValid()) return NaN;
            var days, months, milliseconds = this._milliseconds;
            units = normalizeUnits(units);
            if (units === 'month' || units === 'quarter' || units === 'year') {
                days = this._days + milliseconds / 864e5;
                months = this._months + daysToMonths(days);
                switch(units){
                    case 'month':
                        return months;
                    case 'quarter':
                        return months / 3;
                    case 'year':
                        return months / 12;
                }
            } else {
                days = this._days + Math.round(monthsToDays(this._months));
                switch(units){
                    case 'week':
                        return days / 7 + milliseconds / 6048e5;
                    case 'day':
                        return days + milliseconds / 864e5;
                    case 'hour':
                        return days * 24 + milliseconds / 36e5;
                    case 'minute':
                        return days * 1440 + milliseconds / 6e4;
                    case 'second':
                        return days * 86400 + milliseconds / 1000;
                    case 'millisecond':
                        return Math.floor(days * 864e5) + milliseconds;
                    default:
                        throw new Error('Unknown unit ' + units);
                }
            }
        }
        function makeAs(alias) {
            return function() {
                return this.as(alias);
            };
        }
        var asMilliseconds = makeAs('ms'), asSeconds = makeAs('s'), asMinutes = makeAs('m'), asHours = makeAs('h'), asDays = makeAs('d'), asWeeks = makeAs('w'), asMonths = makeAs('M'), asQuarters = makeAs('Q'), asYears = makeAs('y'), valueOf$1 = asMilliseconds;
        function clone$1() {
            return createDuration(this);
        }
        function get$2(units) {
            units = normalizeUnits(units);
            return this.isValid() ? this[units + 's']() : NaN;
        }
        function makeGetter(name) {
            return function() {
                return this.isValid() ? this._data[name] : NaN;
            };
        }
        var milliseconds = makeGetter('milliseconds'), seconds = makeGetter('seconds'), minutes = makeGetter('minutes'), hours = makeGetter('hours'), days = makeGetter('days'), months = makeGetter('months'), years = makeGetter('years');
        function weeks() {
            return absFloor(this.days() / 7);
        }
        var round = Math.round, thresholds = {
            ss: 44,
            s: 45,
            m: 45,
            h: 22,
            d: 26,
            w: null,
            M: 11
        };
        function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
            return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
        }
        function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
            var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as('s')), minutes = round(duration.as('m')), hours = round(duration.as('h')), days = round(duration.as('d')), months = round(duration.as('M')), weeks = round(duration.as('w')), years = round(duration.as('y')), a = seconds <= thresholds.ss && [
                's',
                seconds
            ] || seconds < thresholds.s && [
                'ss',
                seconds
            ] || minutes <= 1 && [
                'm'
            ] || minutes < thresholds.m && [
                'mm',
                minutes
            ] || hours <= 1 && [
                'h'
            ] || hours < thresholds.h && [
                'hh',
                hours
            ] || days <= 1 && [
                'd'
            ] || days < thresholds.d && [
                'dd',
                days
            ];
            if (thresholds.w != null) a = a || weeks <= 1 && [
                'w'
            ] || weeks < thresholds.w && [
                'ww',
                weeks
            ];
            a = a || months <= 1 && [
                'M'
            ] || months < thresholds.M && [
                'MM',
                months
            ] || years <= 1 && [
                'y'
            ] || [
                'yy',
                years
            ];
            a[2] = withoutSuffix;
            a[3] = +posNegDuration > 0;
            a[4] = locale;
            return substituteTimeAgo.apply(null, a);
        }
        function getSetRelativeTimeRounding(roundingFunction) {
            if (roundingFunction === undefined) return round;
            if (typeof roundingFunction === 'function') {
                round = roundingFunction;
                return true;
            }
            return false;
        }
        function getSetRelativeTimeThreshold(threshold, limit) {
            if (thresholds[threshold] === undefined) return false;
            if (limit === undefined) return thresholds[threshold];
            thresholds[threshold] = limit;
            if (threshold === 's') thresholds.ss = limit - 1;
            return true;
        }
        function humanize(argWithSuffix, argThresholds) {
            if (!this.isValid()) return this.localeData().invalidDate();
            var withSuffix = false, th = thresholds, locale, output;
            if (typeof argWithSuffix === 'object') {
                argThresholds = argWithSuffix;
                argWithSuffix = false;
            }
            if (typeof argWithSuffix === 'boolean') withSuffix = argWithSuffix;
            if (typeof argThresholds === 'object') {
                th = Object.assign({}, thresholds, argThresholds);
                if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
            }
            locale = this.localeData();
            output = relativeTime$1(this, !withSuffix, th, locale);
            if (withSuffix) output = locale.pastFuture(+this, output);
            return locale.postformat(output);
        }
        var abs$1 = Math.abs;
        function sign(x) {
            return (x > 0) - (x < 0) || +x;
        }
        function toISOString$1() {
            if (!this.isValid()) return this.localeData().invalidDate();
            var seconds = abs$1(this._milliseconds) / 1000, days = abs$1(this._days), months = abs$1(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
            if (!total) return 'P0D';
            minutes = absFloor(seconds / 60);
            hours = absFloor(minutes / 60);
            seconds %= 60;
            minutes %= 60;
            years = absFloor(months / 12);
            months %= 12;
            s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
            totalSign = total < 0 ? '-' : '';
            ymSign = sign(this._months) !== sign(total) ? '-' : '';
            daysSign = sign(this._days) !== sign(total) ? '-' : '';
            hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
            return totalSign + 'P' + (years ? ymSign + years + 'Y' : '') + (months ? ymSign + months + 'M' : '') + (days ? daysSign + days + 'D' : '') + (hours || minutes || seconds ? 'T' : '') + (hours ? hmsSign + hours + 'H' : '') + (minutes ? hmsSign + minutes + 'M' : '') + (seconds ? hmsSign + s + 'S' : '');
        }
        var proto$2 = Duration.prototype;
        proto$2.isValid = isValid$1;
        proto$2.abs = abs;
        proto$2.add = add$1;
        proto$2.subtract = subtract$1;
        proto$2.as = as;
        proto$2.asMilliseconds = asMilliseconds;
        proto$2.asSeconds = asSeconds;
        proto$2.asMinutes = asMinutes;
        proto$2.asHours = asHours;
        proto$2.asDays = asDays;
        proto$2.asWeeks = asWeeks;
        proto$2.asMonths = asMonths;
        proto$2.asQuarters = asQuarters;
        proto$2.asYears = asYears;
        proto$2.valueOf = valueOf$1;
        proto$2._bubble = bubble;
        proto$2.clone = clone$1;
        proto$2.get = get$2;
        proto$2.milliseconds = milliseconds;
        proto$2.seconds = seconds;
        proto$2.minutes = minutes;
        proto$2.hours = hours;
        proto$2.days = days;
        proto$2.weeks = weeks;
        proto$2.months = months;
        proto$2.years = years;
        proto$2.humanize = humanize;
        proto$2.toISOString = toISOString$1;
        proto$2.toString = toISOString$1;
        proto$2.toJSON = toISOString$1;
        proto$2.locale = locale;
        proto$2.localeData = localeData;
        proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
        proto$2.lang = lang;
        addFormatToken('X', 0, 0, 'unix');
        addFormatToken('x', 0, 0, 'valueOf');
        addRegexToken('x', matchSigned);
        addRegexToken('X', matchTimestamp);
        addParseToken('X', function(input, array, config) {
            config._d = new Date(parseFloat(input) * 1000);
        });
        addParseToken('x', function(input, array, config) {
            config._d = new Date(toInt(input));
        });
        hooks.version = '2.30.1';
        setHookCallback(createLocal);
        hooks.fn = proto;
        hooks.min = min;
        hooks.max = max;
        hooks.now = now;
        hooks.utc = createUTC;
        hooks.unix = createUnix;
        hooks.months = listMonths;
        hooks.isDate = isDate;
        hooks.locale = getSetGlobalLocale;
        hooks.invalid = createInvalid;
        hooks.duration = createDuration;
        hooks.isMoment = isMoment;
        hooks.weekdays = listWeekdays;
        hooks.parseZone = createInZone;
        hooks.localeData = getLocale;
        hooks.isDuration = isDuration;
        hooks.monthsShort = listMonthsShort;
        hooks.weekdaysMin = listWeekdaysMin;
        hooks.defineLocale = defineLocale;
        hooks.updateLocale = updateLocale;
        hooks.locales = listLocales;
        hooks.weekdaysShort = listWeekdaysShort;
        hooks.normalizeUnits = normalizeUnits;
        hooks.relativeTimeRounding = getSetRelativeTimeRounding;
        hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
        hooks.calendarFormat = getCalendarFormat;
        hooks.prototype = proto;
        hooks.HTML5_FMT = {
            DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
            DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
            DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
            DATE: 'YYYY-MM-DD',
            TIME: 'HH:mm',
            TIME_SECONDS: 'HH:mm:ss',
            TIME_MS: 'HH:mm:ss.SSS',
            WEEK: 'GGGG-[W]WW',
            MONTH: 'YYYY-MM'
        };
        return hooks;
    });
});
const $a797a5154a1373bc$export$e63e1e1c17a0e8b = 'YYYY-MM-DD';
const $a797a5154a1373bc$export$316009114afd746 = 'MMM DD, YYYY';
const $a797a5154a1373bc$export$45c85543ba71221d = 'YYYY/MM/DD';
const $a797a5154a1373bc$export$1f04624003d2da7d = 86400000;
parcelRegister("kvSZW", function(module, exports) {
    $parcel$export(module.exports, "getTimelineDurationFromDate", ()=>$8eccb852de85f1ac$export$844e598264c96110);
    $parcel$export(module.exports, "getTimelineOriginForToday", ()=>$8eccb852de85f1ac$export$afef567e98d0d2bb);
    $parcel$export(module.exports, "getDefaultTimelinePositionFromDate", ()=>$8eccb852de85f1ac$export$96eeb91a52b83f6d);
    var $8QpSo;
    var $2gnC5 = parcelRequire("2gnC5");
    var $iZN6h;
    var $bFxJH;
    const $8eccb852de85f1ac$export$844e598264c96110 = (0, (0, parcelRequire("8QpSo")).default)((timelineMode, date)=>{
        let startMoment = (0, ($parcel$interopDefault($2gnC5))).utc(date).subtract(1, 'year');
        let endMoment = (0, ($parcel$interopDefault($2gnC5))).utc(date).add(2, 'year');
        if (timelineMode === (0, (0, parcelRequire("iZN6h")).QUARTERS)) {
            startMoment = startMoment.startOf('quarter');
            endMoment = endMoment.endOf('quarter');
        } else if (timelineMode === (0, (0, parcelRequire("iZN6h")).MONTHS)) {
            startMoment = startMoment.startOf('month');
            endMoment = endMoment.endOf('month');
        } else {
            startMoment = startMoment.startOf('isoWeek');
            endMoment = endMoment.endOf('isoWeek');
        }
        return {
            startMilliseconds: startMoment.valueOf(),
            endMilliseconds: endMoment.valueOf(),
            totalMilliseconds: endMoment.diff(startMoment, 'milliseconds')
        };
    });
    const $8eccb852de85f1ac$export$afef567e98d0d2bb = (0, (0, parcelRequire("8QpSo")).default)((today, timelineMode)=>{
        const todayMoment = (0, ($parcel$interopDefault($2gnC5))).utc(today);
        if (timelineMode === (0, (0, parcelRequire("iZN6h")).QUARTERS)) return todayMoment.startOf('quarter').subtract(45, 'days').valueOf();
        if (timelineMode === (0, (0, parcelRequire("iZN6h")).MONTHS)) return todayMoment.startOf('month').subtract(15, 'days').valueOf();
        return todayMoment.startOf('isoWeek').subtract(4, 'days').valueOf();
    });
    const $8eccb852de85f1ac$export$96eeb91a52b83f6d = (0, (0, parcelRequire("8QpSo")).default)((date, timelineMode, timelineDuration)=>{
        const millisecondPosition = $8eccb852de85f1ac$export$afef567e98d0d2bb(date, timelineMode);
        const relativePosition = (millisecondPosition - timelineDuration.startMilliseconds) / timelineDuration.totalMilliseconds;
        return relativePosition * (0, (0, parcelRequire("bFxJH")).getTimelineWidth)(timelineMode, timelineDuration.totalMilliseconds);
    });
});
parcelRegister("bFxJH", function(module, exports) {
    $parcel$export(module.exports, "getTimelineWidth", ()=>$a3f65a017bc2d798$export$87113eddf3515c00);
    $parcel$export(module.exports, "getTimelinePositionFromDate", ()=>$a3f65a017bc2d798$export$3d733aa4507a88f8);
    $parcel$export(module.exports, "getDateFromTimelinePosition", ()=>$a3f65a017bc2d798$export$2dd9c7d371d81aa3);
    var $8QpSo;
    var $2gnC5 = parcelRequire("2gnC5");
    var $iZN6h;
    const $a3f65a017bc2d798$var$COLUMN_BASELINE = 255;
    const $a3f65a017bc2d798$export$893f7447303d5bc0 = {
        [(0, (0, parcelRequire("iZN6h")).WEEKS)]: $a3f65a017bc2d798$var$COLUMN_BASELINE / (0, ($parcel$interopDefault($2gnC5))).duration(7, 'day').asMilliseconds(),
        [(0, (0, parcelRequire("iZN6h")).MONTHS)]: $a3f65a017bc2d798$var$COLUMN_BASELINE / (0, ($parcel$interopDefault($2gnC5))).duration(30, 'day').asMilliseconds(),
        [(0, (0, parcelRequire("iZN6h")).QUARTERS)]: $a3f65a017bc2d798$var$COLUMN_BASELINE / (0, ($parcel$interopDefault($2gnC5))).duration(91, 'day').asMilliseconds()
    };
    const $a3f65a017bc2d798$export$87113eddf3515c00 = (0, (0, parcelRequire("8QpSo")).default)((timelineMode, totalDuration)=>Math.round(totalDuration * $a3f65a017bc2d798$export$893f7447303d5bc0[timelineMode]));
    const $a3f65a017bc2d798$export$3d733aa4507a88f8 = ({ startMilliseconds: startMilliseconds, totalMilliseconds: totalMilliseconds }, timelineWidth, date)=>timelineWidth * ((date - startMilliseconds) / totalMilliseconds);
    const $a3f65a017bc2d798$export$2dd9c7d371d81aa3 = ({ startMilliseconds: startMilliseconds, totalMilliseconds: totalMilliseconds }, timelineWidth, position)=>Math.round(startMilliseconds + position / timelineWidth * totalMilliseconds);
});
parcelRegister("b8JKg", function(module, exports) {
    $parcel$export(module.exports, "useCreateIssue", ()=>$ce52ff5f735dcc54$export$8af2d18142c8506c);
    var $5uXOq = parcelRequire("5uXOq");
    var $5tTFS;
    var $egmQO;
    var $hE5wF;
    var $5YBrl;
    var $kRkJF;
    var $jlq4V;
    var $jJZqs;
    var $eCBf9;
    var $5fc53;
    var $koeKL;
    var $fqCXW;
    var $4GbhN;
    function $ce52ff5f735dcc54$export$fd83eea6ecd2d8fa(query) {
        const client = (0, (0, parcelRequire("5tTFS")).useApolloClient)();
        return (0, $5uXOq.useCallback)((variables)=>client.query({
                query: query,
                variables: variables,
                errorPolicy: 'all'
            }), [
            client,
            query
        ]);
    }
    const $ce52ff5f735dcc54$export$8af2d18142c8506c = ()=>{
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const jqlContext = (0, (0, parcelRequire("5YBrl")).useJqlContext)();
        const filtersJQL = (0, (0, parcelRequire("kRkJF")).useFilteredViewJQL)();
        const refetchIssue = $ce52ff5f735dcc54$export$fd83eea6ecd2d8fa((0, (0, parcelRequire("fqCXW")).ISSUE_REFETCH_QUERY));
        const [createIssue] = (0, (0, parcelRequire("5tTFS")).useMutation)((0, (0, parcelRequire("fqCXW")).CREATE_ISSUE_MUTATION));
        const createIssueService = (0, $5uXOq.useCallback)(async (createParams)=>{
            const input = (0, (0, parcelRequire("4GbhN")).buildInput)(createParams.input);
            const fieldIdsSet = new Set(createParams.fieldIdsToReturn);
            fieldIdsSet.delete((0, (0, parcelRequire("5fc53")).ISSUE_LINKS_TYPE));
            fieldIdsSet.delete((0, (0, parcelRequire("hE5wF")).CARD_COVERS_TYPE));
            const { data: data, errors: errors } = await createIssue({
                variables: {
                    input: input,
                    fieldIds: Array.from(fieldIdsSet)
                },
                errorPolicy: 'all'
            });
            const result = data?.createJiraBusinessIssue;
            if (result?.success !== true || !result?.item) {
                const firstMutationError = result?.errors?.[0];
                if (firstMutationError) {
                    const statusCode = firstMutationError.extensions?.statusCode;
                    if (statusCode && statusCode >= 400 && statusCode < 500) throw new (0, (0, parcelRequire("jJZqs")).ValidationError)(firstMutationError.message ?? 'Failed to create issue');
                    throw new (0, (0, parcelRequire("eCBf9")).MutationError)(firstMutationError);
                }
                throw new (0, (0, parcelRequire("jlq4V")).GraphQLErrors)(errors);
            }
            return {
                item: result.item,
                itemIdentifiers: {
                    issueId: result.itemIdentifiers.issueId,
                    issueKey: result.itemIdentifiers.issueKey[0].text
                }
            };
        }, [
            createIssue
        ]);
        const refetchIssueService = (0, $5uXOq.useCallback)(async (issueId, fieldIds, withFiltersContext)=>{
            const jql = (0, (0, parcelRequire("egmQO")).generateJql)({
                jqlContext: jqlContext,
                quickFiltersJql: withFiltersContext ? filtersJQL : undefined,
                issueIds: [
                    issueId
                ]
            });
            const fieldIdsSet = new Set(fieldIds);
            fieldIdsSet.delete((0, (0, parcelRequire("5fc53")).ISSUE_LINKS_TYPE));
            fieldIdsSet.delete((0, (0, parcelRequire("hE5wF")).CARD_COVERS_TYPE));
            const fieldIdsToRequest = Array.from(fieldIdsSet);
            const { data: data } = await refetchIssue({
                jql: jql,
                fieldIds: fieldIdsToRequest,
                cloudId: cloudId,
                first: 1
            });
            const viewItems = data?.jira?.jwmViewItems;
            if (!viewItems || viewItems.__typename === 'QueryError') throw new Error('Issue not found');
            const issue = viewItems.edges?.[0]?.node;
            return issue ?? null;
        }, [
            cloudId,
            filtersJQL,
            jqlContext,
            refetchIssue
        ]);
        return {
            createIssue: createIssueService,
            refetchIssue: refetchIssueService
        };
    };
});
parcelRegister("egmQO", function(module, exports) {
    $parcel$export(module.exports, "generateJql", ()=>$da4d6eca1d928e18$export$d43e55153d6948c0);
    $parcel$export(module.exports, "getVariables", ()=>$da4d6eca1d928e18$export$a39eddd73bba62c1);
    var $hE5wF;
    var $42GbZ;
    const $da4d6eca1d928e18$var$DEFAULT_CHILDREN_PER_PAGE = (0, (0, parcelRequire("hE5wF")).DEFAULT_PAGE_SIZE);
    const $da4d6eca1d928e18$var$IS_EMPTY = 'IS EMPTY';
    const $da4d6eca1d928e18$var$IS_NOT_EMPTY = 'IS NOT EMPTY';
    const $da4d6eca1d928e18$export$d43e55153d6948c0 = (input, parentIssueForJql)=>{
        const { groupQuery: groupQuery, hierarchyLevel: hierarchyLevel, hierarchyParent: hierarchyParent, issueIds: issueIds, jqlContext: jqlContext, projectIdOrKey: projectIdOrKey, quickFiltersJql: quickFiltersJql, sorting: sorting } = input;
        const defaultSorting = `ORDER BY Rank ${(0, (0, parcelRequire("hE5wF")).DEFAULT_RANK_SORTING_DIRECTION)}`;
        const jql = [];
        const isValidDirection = sorting?.direction?.toUpperCase() === 'ASC' || sorting?.direction?.toUpperCase() === 'DESC';
        const sortByClause = sorting != null && sorting.sortBy != null && sorting.direction != null && isValidDirection ? `ORDER By ${(0, (0, parcelRequire("42GbZ")).getJqlTerm)(sorting.sortBy)} ${sorting.direction}, Rank ${sorting.direction}` : defaultSorting;
        if (Array.isArray(issueIds) && issueIds.length > 0) jql.push(`(${issueIds.map((id)=>`id = ${id}`).join(' or ')})`);
        if (jqlContext) jql.push(jqlContext);
        else if (typeof projectIdOrKey !== 'undefined') jql.push(`project = '${projectIdOrKey}'`);
        if (typeof hierarchyLevel === 'number' && hierarchyParent === (0, $8debe7dace56daea$export$9355e489ad16f98e)) {
            if (typeof projectIdOrKey !== 'undefined') jql.push(`(hierarchyLevel = ${hierarchyLevel} OR parent ${$da4d6eca1d928e18$var$IS_EMPTY} OR (parent ${$da4d6eca1d928e18$var$IS_NOT_EMPTY} AND parentProject != '${projectIdOrKey}'))`);
            else jql.push(`(hierarchyLevel = ${hierarchyLevel} OR parent ${$da4d6eca1d928e18$var$IS_EMPTY})`);
        }
        if (hierarchyParent === (0, $8debe7dace56daea$export$9355e489ad16f98e)) jql.push('type in standardIssueTypes()');
        if (parentIssueForJql && parentIssueForJql.hierarchyType === (0, $8debe7dace56daea$export$9355e489ad16f98e)) jql.push(`parent = '${parentIssueForJql.issueId}'`);
        if (groupQuery) {
            const { jqlTerm: jqlTerm, value: value } = groupQuery;
            if (!value) jql.push(`${jqlTerm} ${$da4d6eca1d928e18$var$IS_EMPTY}`);
            else jql.push(`${jqlTerm} = ${value}`);
            if (hierarchyParent === (0, $8debe7dace56daea$export$9355e489ad16f98e)) {
                if (typeof projectIdOrKey !== 'undefined') jql.push(`(parent ${$da4d6eca1d928e18$var$IS_EMPTY} OR (parent ${$da4d6eca1d928e18$var$IS_NOT_EMPTY} AND parentProject != '${projectIdOrKey}'))`);
                else jql.push(`parent ${$da4d6eca1d928e18$var$IS_EMPTY}`);
            }
        }
        if (quickFiltersJql != null) jql.push(`(${quickFiltersJql})`);
        return `${jql.join(' AND ')} ${sortByClause}`;
    };
    const $da4d6eca1d928e18$export$a39eddd73bba62c1 = (input)=>{
        const { fieldIds: fieldIds, parentIssue: parentIssue } = input;
        const singleQueryJql = {
            jql: $da4d6eca1d928e18$export$d43e55153d6948c0(input, parentIssue)
        };
        const newFieldIds = Array.isArray(fieldIds) ? [
            ...fieldIds
        ] : [];
        const remoteIssueLinksIndex = newFieldIds.indexOf((0, (0, parcelRequire("hE5wF")).REMOTE_ISSUE_LINKS_TYPE));
        const hasConfluenceLinks = remoteIssueLinksIndex > -1;
        if (hasConfluenceLinks) newFieldIds.splice(remoteIssueLinksIndex, 1);
        return {
            ...singleQueryJql,
            first: parentIssue ? $da4d6eca1d928e18$var$DEFAULT_CHILDREN_PER_PAGE : (0, (0, parcelRequire("hE5wF")).DEFAULT_PAGE_SIZE),
            fieldIds: newFieldIds,
            withConfluenceLinks: hasConfluenceLinks,
            includeDoneItems: input.isHidingDoneItems === false,
            isParentFieldVisible: input.isParentFieldVisible ?? false,
            isDevSummaryFieldVisible: input.isDevSummaryFieldVisible ?? false
        };
    };
});
const $8debe7dace56daea$export$9355e489ad16f98e = 'TASK';
const $8debe7dace56daea$export$3cb4a99a332e4186 = 'EPIC';
parcelRegister("42GbZ", function(module, exports) {
    $parcel$export(module.exports, "getJqlTerm", ()=>$f8ba3884a7b69792$export$43330b5a5235b231);
    var $6s1PB;
    var $5fc53;
    const $f8ba3884a7b69792$export$43330b5a5235b231 = (fieldId, fieldType)=>{
        if (fieldId.indexOf('customfield_') === 0) {
            const customFieldId = fieldId.split('customfield_')[1];
            return `cf[${customFieldId}]`;
        }
        if (fieldType === (0, (0, parcelRequire("5fc53")).COMPONENTS_TYPE) && (0, (0, parcelRequire("6s1PB")).expValEquals)('list_view_conditional_formatting', 'cohort', 'variation')) return 'component';
        return fieldId;
    };
});
parcelRegister("kRkJF", function(module, exports) {
    $parcel$export(module.exports, "useFilteredViewJQL", ()=>$6b3238559c925b96$export$a50cc7c1087f7d9b);
    $parcel$export(module.exports, "useFilteredViewContextInput", ()=>$6b3238559c925b96$export$d566b5d8a729afa0);
    var $5uXOq = parcelRequire("5uXOq");
    var $5YBrl;
    var $4R6GH;
    var $5fc53;
    var $2UUq6;
    var $17ot5;
    var $l4Ejo;
    var $1T1ir;
    var $7VpiX;
    const $6b3238559c925b96$export$a50cc7c1087f7d9b = ()=>{
        const { addSimpleSearchToJQL: addSimpleSearchToJQL } = (0, (0, parcelRequire("1T1ir")).useSimpleSearchJQL)();
        const { jql: jql } = (0, (0, parcelRequire("l4Ejo")).useFilters)();
        const [isHidingDoneItems] = (0, (0, parcelRequire("17ot5")).useHideDoneItems)();
        const jqlSanitised = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("7VpiX")).sanitiseJql)(jql), [
            jql
        ]);
        const filtersJQL = (0, $5uXOq.useMemo)(()=>{
            if (isHidingDoneItems) {
                const filtersJql = [
                    jqlSanitised,
                    "StatusCategory != 'Complete'"
                ].filter(Boolean).join(' AND ');
                return addSimpleSearchToJQL(filtersJql);
            }
            return addSimpleSearchToJQL(jqlSanitised || null);
        }, [
            jqlSanitised,
            addSimpleSearchToJQL,
            isHidingDoneItems
        ]);
        return filtersJQL;
    };
    const $6b3238559c925b96$var$FIX_VERSION_SORTING_JQL = 'fixVersion';
    const $6b3238559c925b96$export$d566b5d8a729afa0 = ({ view: view })=>{
        const filtersJQL = $6b3238559c925b96$export$a50cc7c1087f7d9b();
        const { isSearching: isSearching } = (0, (0, parcelRequire("1T1ir")).useSimpleSearchJQL)();
        const [sortingBy] = (0, (0, parcelRequire("2UUq6")).useSorting)();
        const { jql: jql } = (0, (0, parcelRequire("l4Ejo")).useFilters)();
        const isFiltering = jql != null || isSearching;
        const [isHidingDoneItems] = (0, (0, parcelRequire("17ot5")).useHideDoneItems)();
        const jqlContext = (0, (0, parcelRequire("5YBrl")).useJqlContext)();
        const hierarchyParent = (view === 'list' || view === 'timeline') && !isFiltering ? (0, $8debe7dace56daea$export$9355e489ad16f98e) : undefined;
        const jqlErrors = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("7VpiX")).getJqlErrors)(jql), [
            jql
        ]);
        const sorting = (0, $5uXOq.useMemo)(()=>{
            if (sortingBy.sortBy === (0, (0, parcelRequire("5fc53")).FIX_VERSIONS_TYPE) && (0, (0, parcelRequire("4R6GH")).fg)('jsw_list_view_-_all_the_fields')) return {
                ...sortingBy,
                sortBy: $6b3238559c925b96$var$FIX_VERSION_SORTING_JQL
            };
            return sortingBy;
        }, [
            sortingBy
        ]);
        return {
            jqlContext: jqlContext,
            quickFiltersJql: filtersJQL,
            sorting: sorting,
            isFiltering: isFiltering,
            hierarchyParent: hierarchyParent,
            isHidingDoneItems: isHidingDoneItems,
            jqlErrors: jqlErrors
        };
    };
});
parcelRegister("2UUq6", function(module, exports) {
    $parcel$export(module.exports, "useSorting", ()=>$46c72127586d4f92$export$21ebc1ba2b2bee67);
    $parcel$export(module.exports, "useSorter", ()=>$46c72127586d4f92$export$f161a6f9d84a6fea);
    var $5uXOq = parcelRequire("5uXOq");
    var $ftuRD;
    var $1T2vX;
    var $x8FYU;
    var $1kpI8;
    var $8841m;
    var $h1cpf;
    var $8Yjb2;
    const $46c72127586d4f92$var$EMPTY_SORTING_ATTRIBUTE = {};
    const $46c72127586d4f92$export$21ebc1ba2b2bee67 = ()=>{
        const [sorting, setSorting] = (0, (0, parcelRequire("1kpI8")).useViewPreference)((0, (0, parcelRequire("x8FYU")).SORTING_PREFERENCE));
        return [
            sorting || $46c72127586d4f92$var$EMPTY_SORTING_ATTRIBUTE,
            setSorting
        ];
    };
    const $46c72127586d4f92$var$emptyArray = [];
    const $46c72127586d4f92$export$f161a6f9d84a6fea = ()=>{
        const [sorting] = $46c72127586d4f92$export$21ebc1ba2b2bee67();
        const [sortingFieldConfig] = (0, (0, parcelRequire("ftuRD")).useIssueTypeFieldConfig)({
            screen: 'VIEW',
            issueTypeId: 'default',
            fieldId: sorting.sortBy
        });
        const [priorityFieldConfig] = (0, (0, parcelRequire("ftuRD")).useIssueTypeFieldConfig)({
            screen: 'VIEW',
            issueTypeId: 'default',
            fieldId: 'priority'
        });
        const { data: data } = (0, (0, parcelRequire("1T2vX")).useIssueTypesAndFields)({
            issueOperation: 'VIEW'
        });
        const sortingFieldConfigFieldType = sortingFieldConfig?.fieldType ?? data?.fields?.find((field)=>field?.id === sorting.sortBy)?.type;
        const { statuses: statuses } = (0, (0, parcelRequire("8841m")).useProjectStatuses)();
        const priorities = priorityFieldConfig?.options || $46c72127586d4f92$var$emptyArray;
        const sortFunction = (0, $5uXOq.useCallback)((issues)=>{
            const getPrioritiesSortedList = ()=>[
                    ...priorities
                ].reverse().reduce((acc, next, index)=>{
                    acc[next.priorityId] = index;
                    return acc;
                }, {});
            const getIssueTypesSortedList = ()=>[
                    ...data.issueTypes
                ].sort((a, b)=>a.name.localeCompare(b.name)).reduce((acc, next, index)=>{
                    acc[next.name] = index;
                    return acc;
                }, {});
            const getStatusSortOrder = (key)=>{
                if (key in (0, (0, parcelRequire("h1cpf")).STATUS_SORT_ORDER)) return (0, (0, parcelRequire("h1cpf")).STATUS_SORT_ORDER)[key];
                return -1;
            };
            const getStatusesSortedList = ()=>[
                    ...statuses
                ].sort((a, b)=>{
                    const orderComparison = getStatusSortOrder(a.statusCategory.key) - getStatusSortOrder(b.statusCategory.key);
                    if (orderComparison !== 0) return orderComparison;
                    return a.name.localeCompare(b.name);
                }).reduce((acc, next, index)=>{
                    acc[next.name] = index;
                    return acc;
                }, {});
            const sortedLists = {
                priorities: getPrioritiesSortedList(),
                issueTypes: getIssueTypesSortedList(),
                statuses: getStatusesSortedList()
            };
            const { getters: getters, orders: orders } = (0, (0, parcelRequire("8Yjb2")).createSortingGettersAndOrders)(sorting, sortingFieldConfigFieldType, sortedLists);
            return (0, (0, parcelRequire("8Yjb2")).sortListBy)(issues, getters, orders);
        }, [
            sorting,
            sortingFieldConfigFieldType,
            priorities,
            data.issueTypes,
            statuses
        ]);
        return {
            sort: sortFunction
        };
    };
});
parcelRegister("ftuRD", function(module, exports) {
    $parcel$export(module.exports, "useIssueTypeFieldConfig", ()=>$66b06940d67822ac$export$42e875bfb69ded2);
    var $5uXOq = parcelRequire("5uXOq");
    var $9XE6b = parcelRequire("9XE6b");
    var $3sQ5x;
    var $6dDSs;
    var $iXqE5;
    var $1T2vX;
    const $66b06940d67822ac$var$merge = (screen, issueTypeId, configs)=>({ setState: setState, getState: getState })=>{
            setState({
                ...getState(),
                [screen]: {
                    ...(0, ($parcel$interopDefault($9XE6b)))(getState(), [
                        screen
                    ], {}),
                    [issueTypeId]: configs
                }
            });
        };
    const $66b06940d67822ac$var$actions = {
        merge: $66b06940d67822ac$var$merge
    };
    const $66b06940d67822ac$export$cbf0f7fe9ca42a65 = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: {},
        actions: $66b06940d67822ac$var$actions,
        name: 'issueTypeFieldConfig'
    });
    const $66b06940d67822ac$var$getIssueTypeFieldConfigSelector = (0, (0, parcelRequire("6dDSs")).createSelector)((state)=>state, (_, props)=>props?.screen ?? undefined, (_, props)=>props?.issueTypeId ?? undefined, (_, props)=>props?.fieldId ?? undefined, (state, screen, issueTypeId, fieldId)=>{
        if (screen === undefined || issueTypeId === undefined || fieldId === undefined) return null;
        return (0, ($parcel$interopDefault($9XE6b)))(state, [
            screen,
            issueTypeId,
            fieldId
        ], null);
    });
    const $66b06940d67822ac$export$47647eb426e85a25 = (0, (0, parcelRequire("3sQ5x")).createHook)($66b06940d67822ac$export$cbf0f7fe9ca42a65, {
        selector: $66b06940d67822ac$var$getIssueTypeFieldConfigSelector
    });
    const $66b06940d67822ac$export$42e875bfb69ded2 = (props)=>{
        const [state, fieldsConfigActions] = $66b06940d67822ac$export$47647eb426e85a25(props);
        const screen = props?.screen || 'VIEW';
        const { data: data, loading: loading, error: error } = (0, (0, parcelRequire("1T2vX")).useIssueTypesAndFields)({
            issueOperation: screen
        });
        return (0, $5uXOq.useMemo)(()=>{
            if (state != null) return [
                state,
                fieldsConfigActions,
                {
                    loading: false,
                    error: undefined
                }
            ];
            if (loading === false && (0, ($parcel$interopDefault($9XE6b)))(data, [
                'issueTypes'
            ], []).length > 0) data.issueTypes.forEach((issueType)=>{
                const config = {};
                data.fields.forEach((field)=>{
                    if ((field.issueTypes || []).includes(issueType.id) && field.id != null) config[field.id] = {
                        ...field.fieldConfig,
                        fieldType: field.type
                    };
                });
                fieldsConfigActions.merge(screen, issueType.id, config);
                if (issueType.isDefault) fieldsConfigActions.merge(screen, 'default', config);
            });
            return [
                state,
                fieldsConfigActions,
                {
                    loading: loading,
                    error: error
                }
            ];
        }, [
            data,
            error,
            fieldsConfigActions,
            loading,
            screen,
            state
        ]);
    };
});
parcelRegister("8841m", function(module, exports) {
    $parcel$export(module.exports, "useProjectStatuses", ()=>$f2e77b2d189a9e48$export$11ff6a520db76faf);
    var $5uXOq = parcelRequire("5uXOq");
    var $7qDUb = parcelRequire("7qDUb");
    var $3JOCw = parcelRequire("3JOCw");
    var $daQYX;
    var $dJl1T;
    var $3sQ5x;
    var $6dDSs;
    var $iXqE5;
    const $f2e77b2d189a9e48$var$PACKAGE_LOCATION = 'jira-business.common.services.project-statuses';
    const $f2e77b2d189a9e48$var$MAX_RETRIES = 3;
    const $f2e77b2d189a9e48$var$set = (projectKey, statuses)=>({ setState: setState })=>setState({
                [projectKey]: statuses
            });
    const $f2e77b2d189a9e48$var$actions = {
        set: $f2e77b2d189a9e48$var$set
    };
    const $f2e77b2d189a9e48$var$ProjectStatusesStore = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: {},
        actions: $f2e77b2d189a9e48$var$actions,
        name: 'projectStatuses'
    });
    const $f2e77b2d189a9e48$var$getProjectStatusesSelector = (0, (0, parcelRequire("6dDSs")).createSelector)((state)=>state, (_, props)=>props?.projectKey ?? undefined, (state, projectKey)=>{
        if (projectKey === undefined || state[projectKey] == null) return [];
        return state[projectKey];
    });
    const $f2e77b2d189a9e48$export$482f388228eef22c = (0, (0, parcelRequire("3sQ5x")).createHook)($f2e77b2d189a9e48$var$ProjectStatusesStore, {
        selector: $f2e77b2d189a9e48$var$getProjectStatusesSelector
    });
    const $f2e77b2d189a9e48$var$emptyArray = [];
    const $f2e77b2d189a9e48$export$11ff6a520db76faf = ()=>{
        const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
        const [hasLoaded, setHasLoaded] = (0, $5uXOq.useState)(false);
        const [retriesCount, setRetriesCount] = (0, $5uXOq.useState)(0);
        const projectData = (0, (0, parcelRequire("daQYX")).useProject)();
        const projectKey = projectData.key;
        const [statuses, statusActions] = $f2e77b2d189a9e48$export$482f388228eef22c({
            projectKey: projectKey
        });
        const retry = ()=>{
            setRetriesCount(retriesCount + 1);
            setIsLoading(false);
            setHasLoaded(false);
        };
        if (projectKey != null && Array.isArray(statuses) && statuses.length > 0) return {
            statuses: statuses,
            loading: isLoading
        };
        if (!isLoading && !hasLoaded) {
            fetch(`/rest/api/3/project/${projectKey}/statuses`).then((response)=>response.json()).then((issueTypes)=>{
                const allStatuses = issueTypes.reduce((acc, next)=>acc.concat(next.statuses), []);
                const dedupedResults = (0, ($parcel$interopDefault($3JOCw)))(allStatuses, 'id');
                return (0, ($parcel$interopDefault($7qDUb)))(dedupedResults, [
                    'name'
                ]);
            }).then((uniqueStatuses)=>{
                statusActions.set(projectKey, uniqueStatuses);
                setIsLoading(false);
                setHasLoaded(true);
            }).catch(()=>{
                (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData($f2e77b2d189a9e48$var$PACKAGE_LOCATION, `Failed to retrieve project statuses - Retry #${retriesCount}`);
                if (retriesCount < $f2e77b2d189a9e48$var$MAX_RETRIES) retry();
            });
            setIsLoading(true);
        }
        return {
            statuses: $f2e77b2d189a9e48$var$emptyArray,
            loading: isLoading
        };
    };
});
parcelRegister("h1cpf", function(module, exports) {
    $parcel$export(module.exports, "STATUS_SORT_ORDER", ()=>$20cadc5cf5f0437c$export$de9c103e53e690d1);
    const $20cadc5cf5f0437c$export$de9c103e53e690d1 = {
        new: 1,
        indeterminate: 2,
        done: 3
    };
});
parcelRegister("8Yjb2", function(module, exports) {
    $parcel$export(module.exports, "sortListBy", ()=>$9b7a6804aae1eb73$export$3793ed28be8699ad);
    $parcel$export(module.exports, "createSortingGettersAndOrders", ()=>$9b7a6804aae1eb73$export$b3fdfcb601c683c3);
    var $1AkQu = parcelRequire("1AkQu");
    var $hE5wF;
    var $ijSZT;
    var $fCkUD;
    var $57lFd;
    var $gULOk;
    var $4R6GH;
    var $5fc53;
    var $ixx6N;
    const $9b7a6804aae1eb73$var$DEFAULT_HIGHER_RANKING_VALUE = 'Z';
    const $9b7a6804aae1eb73$var$DEFAULT_LOWER_RANKING_VALUE = '~~';
    const $9b7a6804aae1eb73$var$DEFAULT_LOWER_RANKING_NUMBER_VALUE = 0;
    const $9b7a6804aae1eb73$var$toAcceptedOrder = (order)=>order != null && order.toLowerCase() === 'asc' ? 'asc' : 'desc';
    const $9b7a6804aae1eb73$export$3793ed28be8699ad = (nodes, getters, orders)=>(0, ($parcel$interopDefault($1AkQu)))(nodes, getters, orders.map($9b7a6804aae1eb73$var$toAcceptedOrder));
    const $9b7a6804aae1eb73$var$getValueMapAndJoin = (fields, fieldKey, attributeName, defaultValue, getMapValueCb)=>{
        const fieldValue = (0, (0, parcelRequire("57lFd")).safeGetValue)(fields, fieldKey, attributeName, defaultValue) ?? defaultValue;
        return fieldValue.map(getMapValueCb).join(' ') || $9b7a6804aae1eb73$var$DEFAULT_LOWER_RANKING_VALUE;
    };
    const $9b7a6804aae1eb73$var$resolvePriorityOrder = (fields, priorities)=>{
        const priorityId = (0, (0, parcelRequire("4R6GH")).fg)('jwm_list_new_copy_paste_behaviour') ? (0, (0, parcelRequire("57lFd")).safeGetValue)(fields, 'priority', 'value.priorityId', '') : (0, (0, parcelRequire("57lFd")).safeGetValue)(fields, 'priority', 'priorityId', '');
        const priorityOrder = priorities[priorityId];
        if (priorityOrder == null) return -1;
        return priorityOrder;
    };
    const $9b7a6804aae1eb73$var$resolveStatusOrder = (fields, statuses)=>{
        const statusName = (0, (0, parcelRequire("57lFd")).safeGetValue)(fields, 'status', 'name', '');
        const statusOrder = statuses[statusName];
        if (statusOrder == null) return -1;
        return statusOrder;
    };
    const $9b7a6804aae1eb73$var$resolveTypeOrder = (fields, types)=>{
        const typeName = (0, (0, parcelRequire("57lFd")).safeGetValue)(fields, 'issuetype', 'value', '');
        const typeOrder = types[typeName];
        if (typeOrder == null) return -1;
        return typeOrder;
    };
    const $9b7a6804aae1eb73$var$resolveIssueKeyOrder = (fields)=>{
        const [, issueKeyNumber = 0] = (0, (0, parcelRequire("57lFd")).safeGetValue)(fields, 'issuekey', 'value', '').split('-');
        return Number(issueKeyNumber);
    };
    const $9b7a6804aae1eb73$var$resolveCustomTextFieldOrder = (fields, sortingField)=>{
        const value = (0, (0, parcelRequire("57lFd")).safeGetValue)(fields, sortingField, 'value', null);
        return value != null ? value.toLowerCase() : $9b7a6804aae1eb73$var$DEFAULT_LOWER_RANKING_VALUE;
    };
    const $9b7a6804aae1eb73$var$createSortableGetter = (fieldType, sortingField, sortedList)=>(node)=>{
            const { rank: rank, fields: fields = [] } = node;
            if (fieldType != null && (0, (0, parcelRequire("ijSZT")).isSortingSupportedFieldTypePredicated)(fieldType) && (0, (0, parcelRequire("ijSZT")).isSortingSupported)(fieldType) && (0, (0, parcelRequire("4R6GH")).fg)('jsw_list_view_-_all_the_fields')) {
                const field = (0, (0, parcelRequire("57lFd")).getFieldValue)(fields, sortingField);
                if ((0, (0, parcelRequire("fCkUD")).isNewTransformedFieldPredicated)(field)) return (0, (0, parcelRequire("ijSZT")).getSorting)(fieldType, field) || $9b7a6804aae1eb73$var$DEFAULT_LOWER_RANKING_VALUE;
                return $9b7a6804aae1eb73$var$DEFAULT_LOWER_RANKING_VALUE;
            }
            switch(fieldType){
                case 0, (0, parcelRequire("5fc53")).LABELS_TYPE:
                case 0, (0, parcelRequire("5fc53")).LABELS_CF_TYPE:
                    return $9b7a6804aae1eb73$var$getValueMapAndJoin(fields, sortingField, 'value', [
                        ''
                    ], (label)=>label.toLowerCase());
                case 0, (0, parcelRequire("5fc53")).PRIORITY_TYPE:
                    return $9b7a6804aae1eb73$var$resolvePriorityOrder(fields, sortedList != null && sortedList.priorities || {});
                case 0, (0, parcelRequire("5fc53")).STATUS_TYPE:
                    return $9b7a6804aae1eb73$var$resolveStatusOrder(fields, sortedList != null && sortedList.statuses || {});
                case 0, (0, parcelRequire("5fc53")).ISSUE_TYPE:
                    return $9b7a6804aae1eb73$var$resolveTypeOrder(fields, sortedList != null && sortedList.issueTypes || {});
                case 0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE:
                case 0, (0, parcelRequire("5fc53")).REPORTER_TYPE:
                    return (0, (0, parcelRequire("57lFd")).safeGetValue)(fields, sortingField, 'value.name', $9b7a6804aae1eb73$var$DEFAULT_LOWER_RANKING_VALUE).toLowerCase();
                case 0, (0, parcelRequire("5fc53")).USER_CF_TYPE:
                    return (0, (0, parcelRequire("57lFd")).safeGetValue)(fields, sortingField, 'value.name', $9b7a6804aae1eb73$var$DEFAULT_LOWER_RANKING_VALUE).toLowerCase();
                case 'issuekey':
                    return $9b7a6804aae1eb73$var$resolveIssueKeyOrder(fields);
                case 0, (0, parcelRequire("5fc53")).CREATED:
                case 0, (0, parcelRequire("5fc53")).UPDATED:
                    return (0, (0, parcelRequire("57lFd")).safeGetValue)(fields, sortingField, 'value', '');
                case 0, (0, parcelRequire("5fc53")).DATE_CF_TYPE:
                    return (0, (0, parcelRequire("57lFd")).safeGetValue)(fields, sortingField, 'value', $9b7a6804aae1eb73$var$DEFAULT_HIGHER_RANKING_VALUE);
                case 0, (0, parcelRequire("5fc53")).DUE_DATE_TYPE:
                    return (0, (0, parcelRequire("57lFd")).safeGetValue)(fields, sortingField, 'value', $9b7a6804aae1eb73$var$DEFAULT_HIGHER_RANKING_VALUE);
                case 0, (0, parcelRequire("5fc53")).DATETIME_CF_TYPE:
                    return (0, (0, parcelRequire("57lFd")).safeGetValue)(fields, sortingField, 'value', $9b7a6804aae1eb73$var$DEFAULT_HIGHER_RANKING_VALUE);
                case 0, (0, parcelRequire("hE5wF")).RANK_ALIAS_FIELD_ID:
                    if ((0, (0, parcelRequire("57lFd")).safeGetValue)(fields, 'issuetype', 'level', undefined) === -1) return (0, (0, parcelRequire("ixx6N")).resolveRank)((0, (0, parcelRequire("57lFd")).safeGetValue)(fields, 'parent', 'value', undefined), rank ?? '');
                    return rank ?? '';
                case 0, (0, parcelRequire("5fc53")).SUMMARY_TYPE:
                    return (0, (0, parcelRequire("57lFd")).safeGetValue)(fields, sortingField, 'value', '').toLowerCase();
                case 0, (0, parcelRequire("5fc53")).TEXT_CF_TYPE:
                    return $9b7a6804aae1eb73$var$resolveCustomTextFieldOrder(fields, sortingField);
                case 0, (0, parcelRequire("5fc53")).SELECT_CF_TYPE:
                case 0, (0, parcelRequire("5fc53")).CATEGORY_TYPE:
                    return (0, (0, parcelRequire("57lFd")).safeGetValue)(fields, sortingField, 'value.value', $9b7a6804aae1eb73$var$DEFAULT_LOWER_RANKING_VALUE);
                case 0, (0, parcelRequire("5fc53")).MULTI_SELECT_CF_TYPE:
                case 0, (0, parcelRequire("5fc53")).MULTI_CHECKBOXES_CF_TYPE:
                    return $9b7a6804aae1eb73$var$getValueMapAndJoin(fields, sortingField, 'value', [], (selectedValue)=>selectedValue?.value.toLowerCase());
                case 0, (0, parcelRequire("5fc53")).TIME_ESTIMATE_TYPE:
                    return (0, (0, parcelRequire("57lFd")).safeGetValue)(fields, sortingField, 'value.timeInSeconds', $9b7a6804aae1eb73$var$DEFAULT_LOWER_RANKING_NUMBER_VALUE);
                case 0, (0, parcelRequire("5fc53")).URL_CF_TYPE:
                    return (0, (0, parcelRequire("57lFd")).safeGetValue)(fields, sortingField, 'value', $9b7a6804aae1eb73$var$DEFAULT_LOWER_RANKING_VALUE);
                case 0, (0, parcelRequire("5fc53")).NUMBER_CF_TYPE:
                case 0, (0, parcelRequire("5fc53")).STORY_POINTS_TYPE:
                case 0, (0, parcelRequire("5fc53")).STORY_POINT_ESTIMATE_CF_TYPE:
                    return (0, (0, parcelRequire("57lFd")).safeGetValue)(fields, sortingField, 'value', $9b7a6804aae1eb73$var$DEFAULT_LOWER_RANKING_NUMBER_VALUE);
                case 0, (0, parcelRequire("5fc53")).COMPONENTS_TYPE:
                    return $9b7a6804aae1eb73$var$getValueMapAndJoin(fields, sortingField, 'value', [], (component)=>component?.name.toLowerCase());
                case 0, (0, parcelRequire("5fc53")).SPRINT_TYPE:
                    {
                        const sprintValue = (0, (0, parcelRequire("57lFd")).safeGetValue)(fields, sortingField, 'value', $9b7a6804aae1eb73$var$DEFAULT_LOWER_RANKING_VALUE);
                        if (Array.isArray(sprintValue) && sprintValue.length) {
                            const { name: name, state: state } = sprintValue[0];
                            if (state === 'CLOSED') {
                                const statusId = (0, (0, parcelRequire("57lFd")).safeGetValue)(fields, 'status', 'value', '');
                                if (statusId?.toString() !== (0, (0, parcelRequire("gULOk")).StatusCategoryIds)[(0, (0, parcelRequire("gULOk")).StatusCategoryTypes).DONE].toString()) return $9b7a6804aae1eb73$var$DEFAULT_LOWER_RANKING_VALUE;
                            }
                            return name.toLowerCase();
                        }
                        return $9b7a6804aae1eb73$var$DEFAULT_LOWER_RANKING_VALUE;
                    }
                default:
                    return (0, (0, parcelRequire("57lFd")).safeGetValue)(fields, (0, (0, parcelRequire("hE5wF")).RANK_ALIAS_FIELD_ID), 'value', '');
            }
        };
    const $9b7a6804aae1eb73$export$b3fdfcb601c683c3 = (sorting, fieldType, sortedLists)=>{
        const getters = [];
        const orders = [];
        let sortFieldType = fieldType;
        if (sorting?.sortBy === 'key') sortFieldType = 'issuekey';
        if (sorting != null && sorting.sortBy != null) {
            orders.push(sorting.direction, sorting.direction);
            getters.push($9b7a6804aae1eb73$var$createSortableGetter(sortFieldType, sorting.sortBy, sortedLists));
            getters.push($9b7a6804aae1eb73$var$createSortableGetter((0, (0, parcelRequire("hE5wF")).RANK_ALIAS_FIELD_ID), (0, (0, parcelRequire("hE5wF")).RANK_ALIAS_FIELD_ID)));
        } else {
            orders.push((0, (0, parcelRequire("hE5wF")).DEFAULT_RANK_SORTING_DIRECTION));
            getters.push($9b7a6804aae1eb73$var$createSortableGetter((0, (0, parcelRequire("hE5wF")).RANK_ALIAS_FIELD_ID), (0, (0, parcelRequire("hE5wF")).RANK_ALIAS_FIELD_ID)));
        }
        return {
            getters: getters,
            orders: orders
        };
    };
});
parcelRegister("1AkQu", function(module, exports) {
    var $kE90z = parcelRequire("kE90z");
    var $8LQ84 = parcelRequire("8LQ84");
    function $127952ba7d4c15a6$var$orderBy(collection, iteratees, orders, guard) {
        if (collection == null) return [];
        if (!$8LQ84(iteratees)) iteratees = iteratees == null ? [] : [
            iteratees
        ];
        orders = guard ? undefined : orders;
        if (!$8LQ84(orders)) orders = orders == null ? [] : [
            orders
        ];
        return $kE90z(collection, iteratees, orders);
    }
    module.exports = $127952ba7d4c15a6$var$orderBy;
});
parcelRegister("ijSZT", function(module, exports) {
    $parcel$export(module.exports, "getSorting", ()=>$426da0baa4d91e21$export$654dceec98f3061f);
    $parcel$export(module.exports, "isSortingSupported", ()=>$426da0baa4d91e21$export$c6c6084d02f37d7e);
    $parcel$export(module.exports, "isSortingSupportedFieldTypePredicated", ()=>$426da0baa4d91e21$export$190ed2ad153b150b);
    $parcel$export(module.exports, "getSortingDisabledFields", ()=>$426da0baa4d91e21$export$56c924491e5617ad);
    var $8QpSo;
    var $1OjAh;
    var $5nNdw;
    var $cBFqc;
    var $coSD0;
    var $55FhM;
    var $gjQcQ;
    var $4CML6;
    var $WhnfX;
    var $aK7yP;
    var $7LNXH;
    var $dtcdd;
    const $426da0baa4d91e21$var$createSortingHandlers = (0, (0, parcelRequire("8QpSo")).default)(()=>({
            ...(0, (0, parcelRequire("55FhM")).parentSortingHandler),
            ...(0, (0, parcelRequire("dtcdd")).versionSortingHandler),
            ...(0, (0, parcelRequire("WhnfX")).resolutionSortingHandler),
            ...(0, (0, parcelRequire("coSD0")).groupSortingHandler),
            ...(0, (0, parcelRequire("4CML6")).radioSelectSortingHandler),
            ...(0, (0, parcelRequire("1OjAh")).cascadingSelectSortingHandler),
            ...(0, (0, parcelRequire("gjQcQ")).projectSortingHandler)
        }));
    const $426da0baa4d91e21$export$654dceec98f3061f = (fieldType, ...args)=>{
        const handlers = $426da0baa4d91e21$var$createSortingHandlers();
        if (handlers[fieldType] == null) return;
        return handlers[fieldType]?.(...args);
    };
    const $426da0baa4d91e21$export$c6c6084d02f37d7e = (fieldType)=>{
        const handlers = $426da0baa4d91e21$var$createSortingHandlers();
        return handlers[fieldType] != null;
    };
    const $426da0baa4d91e21$export$190ed2ad153b150b = (fieldType)=>true;
    const $426da0baa4d91e21$export$56c924491e5617ad = (0, (0, parcelRequire("8QpSo")).default)(()=>({
            ...(0, (0, parcelRequire("5nNdw")).devSummaryDisabledSorting),
            ...(0, (0, parcelRequire("7LNXH")).teamDisabledSorting),
            ...(0, (0, parcelRequire("aK7yP")).statusCategoryDisabledSorting),
            ...(0, (0, parcelRequire("cBFqc")).goalsDisabledSorting)
        }));
});
parcelRegister("1OjAh", function(module, exports) {
    $parcel$export(module.exports, "cascadingSelectSortingHandler", ()=>$1924a50c91a471c7$export$7b0bfc6838ff3257);
    var $5fc53;
    var $jKNTt;
    const $1924a50c91a471c7$var$getCascadingSelectSorting = (field)=>(0, (0, parcelRequire("jKNTt")).getCascadingSelectStringValue)(field.value);
    const $1924a50c91a471c7$export$7b0bfc6838ff3257 = {
        [(0, (0, parcelRequire("5fc53")).CASCADING_SELECT_CF_TYPE)]: $1924a50c91a471c7$var$getCascadingSelectSorting
    };
});
parcelRegister("jKNTt", function(module, exports) {
    $parcel$export(module.exports, "getCascadingSelectStringValue", ()=>$c7661401b6222cfb$export$f110a74eb752aa7e);
    $parcel$export(module.exports, "cascadingSelectStringValueHandler", ()=>$c7661401b6222cfb$export$f39c163ada81742a);
    $parcel$export(module.exports, "cascadingSelectRichValueHandler", ()=>$c7661401b6222cfb$export$af92c160980c340f);
    var $5fc53;
    const $c7661401b6222cfb$export$f110a74eb752aa7e = (fieldValue)=>{
        if (fieldValue && fieldValue.parentOptionValue) {
            if (fieldValue.childOptionValue) return `${fieldValue.parentOptionValue.value} - ${fieldValue.childOptionValue.value}`;
            return `${fieldValue.parentOptionValue.value}`;
        }
        return '';
    };
    const $c7661401b6222cfb$var$getCascadingSelectValue = (field)=>$c7661401b6222cfb$export$f110a74eb752aa7e(field.value);
    const $c7661401b6222cfb$var$getCascadingSelectRichValue = (field)=>field.value ?? null;
    const $c7661401b6222cfb$export$f39c163ada81742a = {
        [(0, (0, parcelRequire("5fc53")).CASCADING_SELECT_CF_TYPE)]: $c7661401b6222cfb$var$getCascadingSelectValue
    };
    const $c7661401b6222cfb$export$af92c160980c340f = {
        [(0, (0, parcelRequire("5fc53")).CASCADING_SELECT_CF_TYPE)]: $c7661401b6222cfb$var$getCascadingSelectRichValue
    };
});
parcelRegister("5nNdw", function(module, exports) {
    $parcel$export(module.exports, "devSummaryDisabledSorting", ()=>$8d45926c3e16e57e$export$8cf683615a3ccf77);
    var $5fc53;
    const $8d45926c3e16e57e$export$8cf683615a3ccf77 = {
        [(0, (0, parcelRequire("5fc53")).DEV_SUMMARY_CF_TYPE)]: false
    };
});
parcelRegister("cBFqc", function(module, exports) {
    $parcel$export(module.exports, "goalsDisabledSorting", ()=>$c7872d24a62cd4a6$export$60ff70c996f5c362);
    var $5fc53;
    const $c7872d24a62cd4a6$export$60ff70c996f5c362 = {
        [(0, (0, parcelRequire("5fc53")).GOALS_CF_TYPE)]: false
    };
});
parcelRegister("coSD0", function(module, exports) {
    $parcel$export(module.exports, "groupSortingHandler", ()=>$a9d8ecbf0dcf5f2d$export$a577fd60fa30451d);
    var $5fc53;
    const $a9d8ecbf0dcf5f2d$var$getSingleGroupSorting = (field)=>field.value?.name ?? '';
    const $a9d8ecbf0dcf5f2d$var$getMultipleGroupSorting = (field)=>field.value == null ? '' : field.value.map((v)=>v.name).join(',');
    const $a9d8ecbf0dcf5f2d$export$a577fd60fa30451d = {
        [(0, (0, parcelRequire("5fc53")).GROUP_CF_TYPE)]: $a9d8ecbf0dcf5f2d$var$getSingleGroupSorting,
        [(0, (0, parcelRequire("5fc53")).MULTI_GROUP_CF_TYPE)]: $a9d8ecbf0dcf5f2d$var$getMultipleGroupSorting
    };
});
parcelRegister("55FhM", function(module, exports) {
    $parcel$export(module.exports, "parentSortingHandler", ()=>$a7f27eceaa949fb5$export$20dbdacc158507c9);
    var $5fc53;
    const $a7f27eceaa949fb5$var$getParentSorting = (field)=>field.value ? field.value.issueKey : '';
    const $a7f27eceaa949fb5$export$20dbdacc158507c9 = {
        [(0, (0, parcelRequire("5fc53")).PARENT_TYPE)]: $a7f27eceaa949fb5$var$getParentSorting
    };
});
parcelRegister("gjQcQ", function(module, exports) {
    $parcel$export(module.exports, "projectSortingHandler", ()=>$a97b41f281e121d8$export$18c888fa7805bbf9);
    var $5fc53;
    const $a97b41f281e121d8$var$getProjectSorting = (field)=>field.value?.name ?? '';
    const $a97b41f281e121d8$export$18c888fa7805bbf9 = {
        [(0, (0, parcelRequire("5fc53")).PROJECT_PICKER_CF_TYPE)]: $a97b41f281e121d8$var$getProjectSorting
    };
});
parcelRegister("4CML6", function(module, exports) {
    $parcel$export(module.exports, "radioSelectSortingHandler", ()=>$0a650a9e38d8f12d$export$d622730346571a2b);
    var $5fc53;
    const $0a650a9e38d8f12d$var$getRadioSelectSorting = (field)=>field.value ? field.value.value : '';
    const $0a650a9e38d8f12d$export$d622730346571a2b = {
        [(0, (0, parcelRequire("5fc53")).RADIO_BUTTONS_CF_TYPE)]: $0a650a9e38d8f12d$var$getRadioSelectSorting
    };
});
parcelRegister("WhnfX", function(module, exports) {
    $parcel$export(module.exports, "resolutionSortingHandler", ()=>$5149dcabcac386a7$export$596a643f093db9a7);
    var $5fc53;
    const $5149dcabcac386a7$var$getResolutionSorting = (field)=>field.value?.name ?? '';
    const $5149dcabcac386a7$export$596a643f093db9a7 = {
        [(0, (0, parcelRequire("5fc53")).RESOLUTION_TYPE)]: $5149dcabcac386a7$var$getResolutionSorting
    };
});
parcelRegister("aK7yP", function(module, exports) {
    $parcel$export(module.exports, "statusCategoryDisabledSorting", ()=>$a8138d3f5e843f75$export$117cb43589655b27);
    var $5fc53;
    const $a8138d3f5e843f75$export$117cb43589655b27 = {
        [(0, (0, parcelRequire("5fc53")).STATUS_CATEGORY_TYPE)]: false
    };
});
parcelRegister("7LNXH", function(module, exports) {
    $parcel$export(module.exports, "teamDisabledSorting", ()=>$f566370ab4491013$export$1626c947db580b0f);
    var $5fc53;
    const $f566370ab4491013$export$1626c947db580b0f = {
        [(0, (0, parcelRequire("5fc53")).TEAMS_PLATFORM_CF_TYPE)]: false
    };
});
parcelRegister("dtcdd", function(module, exports) {
    $parcel$export(module.exports, "versionSortingHandler", ()=>$b3c9429c32861e4c$export$f2894a637a250eaa);
    var $5fc53;
    const $b3c9429c32861e4c$var$getSingleVersionSorting = (field)=>field.value?.name ?? '';
    const $b3c9429c32861e4c$var$getMultipleVersionSorting = (field)=>field.value == null ? '' : field.value.map((v)=>v.name).join(',');
    const $b3c9429c32861e4c$export$f2894a637a250eaa = {
        [(0, (0, parcelRequire("5fc53")).VERSION_CF_TYPE)]: $b3c9429c32861e4c$var$getSingleVersionSorting,
        [(0, (0, parcelRequire("5fc53")).MULTI_VERSION_CF_TYPE)]: $b3c9429c32861e4c$var$getMultipleVersionSorting,
        [(0, (0, parcelRequire("5fc53")).FIX_VERSIONS_TYPE)]: $b3c9429c32861e4c$var$getMultipleVersionSorting,
        [(0, (0, parcelRequire("5fc53")).AFFECTS_VERSIONS_TYPE)]: $b3c9429c32861e4c$var$getMultipleVersionSorting
    };
});
parcelRegister("fCkUD", function(module, exports) {
    $parcel$export(module.exports, "isNewTransformedFieldPredicated", ()=>$fb9b3f13d18b237f$export$b018c2b58ea7e0de);
    const $fb9b3f13d18b237f$export$b018c2b58ea7e0de = (field)=>field != null;
});
parcelRegister("57lFd", function(module, exports) {
    $parcel$export(module.exports, "getFieldValue", ()=>$9c93e114366691a0$export$2e85048acc9aea83);
    $parcel$export(module.exports, "safeGetValue", ()=>$9c93e114366691a0$export$f17a5eaf5fe57cff);
    $parcel$export(module.exports, "safeGetTransformedFieldValue", ()=>$9c93e114366691a0$export$16456470899ab77f);
    $parcel$export(module.exports, "safeGetTransformedValue", ()=>$9c93e114366691a0$export$c1cc7bc9b4953394);
    var $9XE6b = parcelRequire("9XE6b");
    const $9c93e114366691a0$export$2e85048acc9aea83 = (fields, fieldKey)=>{
        if (fields && fieldKey != null) return fields.find((field)=>field?.fieldKey && field.fieldKey === fieldKey || field?.fieldId && field.fieldId === fieldKey || field?.aliasFieldId && field.aliasFieldId === fieldKey);
        return undefined;
    };
    const $9c93e114366691a0$export$f17a5eaf5fe57cff = (fields, fieldKey, attributeName, defaultValue)=>{
        const field = $9c93e114366691a0$export$2e85048acc9aea83(fields, fieldKey);
        return (0, ($parcel$interopDefault($9XE6b)))(field, attributeName, defaultValue);
    };
    const $9c93e114366691a0$export$16456470899ab77f = (fields, fieldKey, attributeName, defaultValue)=>{
        const field = $9c93e114366691a0$export$2e85048acc9aea83(fields, fieldKey);
        return $9c93e114366691a0$export$c1cc7bc9b4953394(field, defaultValue);
    };
    const $9c93e114366691a0$export$c1cc7bc9b4953394 = (field, defaultValue)=>(0, ($parcel$interopDefault($9XE6b)))(field, 'value', defaultValue);
});
parcelRegister("ixx6N", function(module, exports) {
    $parcel$export(module.exports, "resolveRank", ()=>$0a08bd66273f9a8c$export$992090b26f7c7f11);
    const $0a08bd66273f9a8c$export$992090b26f7c7f11 = (parentIssue, rank)=>{
        const parentRank = parentIssue?.rank ?? '';
        return parentRank.concat(rank);
    };
});
parcelRegister("17ot5", function(module, exports) {
    $parcel$export(module.exports, "useHideDoneItems", ()=>$f683983c23bf92d0$export$c2cb7b17819b92d4);
    $parcel$export(module.exports, "useInferHideDoneItemsWithFilters", ()=>$f683983c23bf92d0$export$a14bc8305f71e469);
    var $5uXOq = parcelRequire("5uXOq");
    var $x8FYU;
    var $1kpI8;
    var $gULOk;
    var $dpQnO;
    const $f683983c23bf92d0$export$c2cb7b17819b92d4 = ()=>{
        const [hideDoneItems, persistHideDoneItems] = (0, (0, parcelRequire("1kpI8")).useViewPreference)((0, (0, parcelRequire("x8FYU")).HIDE_DONE_ITEMS_PREFERENCE));
        const setHideDoneItems = (0, $5uXOq.useCallback)((hide, action = 'push')=>persistHideDoneItems(hide ? 'true' : undefined, action), [
            persistHideDoneItems
        ]);
        return [
            hideDoneItems === 'true',
            setHideDoneItems
        ];
    };
    const $f683983c23bf92d0$export$a14bc8305f71e469 = ({ filters: filters })=>{
        const [hideDoneItems, setHideDoneItems] = $f683983c23bf92d0$export$c2cb7b17819b92d4();
        const { quickFilters: quickFilters } = (0, (0, parcelRequire("dpQnO")).useQuickFilters)();
        (0, $5uXOq.useEffect)(()=>{
            if (hideDoneItems) {
                const isFilteringByDoneStatus = (filters && filters.status)?.find((status)=>Number(status.categoryId) === (0, (0, parcelRequire("gULOk")).StatusCategoryIds)[(0, (0, parcelRequire("gULOk")).StatusCategoryTypes).DONE]);
                if (isFilteringByDoneStatus || quickFilters?.DONE) setHideDoneItems(false, 'replace');
            }
        }, [
            filters,
            quickFilters?.DONE
        ]);
    };
});
parcelRegister("dpQnO", function(module, exports) {
    $parcel$export(module.exports, "useQuickFilters", ()=>$59496077a2cce3b6$export$3dae1bb95b659fd4);
    var $5uXOq = parcelRequire("5uXOq");
    var $x8FYU;
    var $1kpI8;
    var $5fc53;
    var $g4ZHz;
    const $59496077a2cce3b6$var$quickFilterToJQLMapOld = {
        ASSIGNED_TO_ME: 'assignee = currentUser()',
        DONE: "StatusCategory = 'Complete'",
        DUE_THIS_WEEK: 'duedate <= endOfWeek() and duedate > startOfWeek()'
    };
    const $59496077a2cce3b6$export$808f76242d61e1a5 = (sprintJQLTerm)=>{
        if (sprintJQLTerm == null) return $59496077a2cce3b6$var$quickFilterToJQLMapOld;
        return {
            ...$59496077a2cce3b6$var$quickFilterToJQLMapOld,
            ACTIVE_SPRINTS: `${sprintJQLTerm} in openSprints()`
        };
    };
    const $59496077a2cce3b6$var$buildJQLFromQuickFilters = (quickFilters, { quickFilterToJQLMap: quickFilterToJQLMap = $59496077a2cce3b6$var$quickFilterToJQLMapOld } = {})=>{
        const jqlClauses = Object.entries(quickFilters).map(([key, isEnabled])=>isEnabled === true && quickFilterToJQLMap[key]);
        const enabledFilters = jqlClauses.filter((jql)=>jql);
        return enabledFilters.join(' AND ') || null;
    };
    const $59496077a2cce3b6$export$9294471da4d3c33f = {
        ASSIGNED_TO_ME: false,
        DONE: false,
        DUE_THIS_WEEK: false,
        ACTIVE_SPRINTS: false
    };
    const $59496077a2cce3b6$export$9692fc1a2fd983f5 = (jql, { quickFilterToJQLMap: quickFilterToJQLMap = $59496077a2cce3b6$var$quickFilterToJQLMapOld } = {})=>{
        const quickFilters = {
            ...$59496077a2cce3b6$export$9294471da4d3c33f
        };
        if (!jql) return quickFilters;
        if (jql.includes(quickFilterToJQLMap.ASSIGNED_TO_ME)) quickFilters.ASSIGNED_TO_ME = true;
        if (jql.includes(quickFilterToJQLMap.DONE)) quickFilters.DONE = true;
        if (jql.includes(quickFilterToJQLMap.DUE_THIS_WEEK)) quickFilters.DUE_THIS_WEEK = true;
        if (quickFilterToJQLMap.ACTIVE_SPRINTS && jql.includes(quickFilterToJQLMap.ACTIVE_SPRINTS)) quickFilters.ACTIVE_SPRINTS = true;
        return quickFilters;
    };
    const $59496077a2cce3b6$var$useSprintFieldJQLTerm = ()=>{
        const { data: fields } = (0, (0, parcelRequire("g4ZHz")).useFieldsResource)();
        return (0, $5uXOq.useMemo)(()=>{
            if (fields == null) return undefined;
            const sprintField = fields.find((field)=>field.type === (0, (0, parcelRequire("5fc53")).SPRINT_TYPE));
            return sprintField != null ? sprintField.jqlTerm : undefined;
        }, [
            fields
        ]);
    };
    const $59496077a2cce3b6$export$3dae1bb95b659fd4 = ()=>{
        const sprintFieldJQLTerm = $59496077a2cce3b6$var$useSprintFieldJQLTerm();
        const quickFilterToJQLMap = (0, $5uXOq.useMemo)(()=>$59496077a2cce3b6$export$808f76242d61e1a5(sprintFieldJQLTerm), [
            sprintFieldJQLTerm
        ]);
        const [filters, setFilters] = (0, (0, parcelRequire("1kpI8")).useViewPreference)((0, (0, parcelRequire("x8FYU")).FILTER_PREFERENCE));
        const setQuickFilters = (0, $5uXOq.useCallback)((newQuickFilters)=>{
            if (newQuickFilters) {
                const jql = $59496077a2cce3b6$var$buildJQLFromQuickFilters(newQuickFilters, {
                    quickFilterToJQLMap: quickFilterToJQLMap
                });
                if (jql == null) setFilters(undefined);
                else setFilters(jql);
            } else setFilters(undefined);
        }, [
            quickFilterToJQLMap,
            setFilters
        ]);
        const quickFilters = (0, $5uXOq.useMemo)(()=>$59496077a2cce3b6$export$9692fc1a2fd983f5(filters, {
                quickFilterToJQLMap: quickFilterToJQLMap
            }), [
            filters,
            quickFilterToJQLMap
        ]);
        return {
            quickFilters: quickFilters,
            persistQuickFilters: setQuickFilters,
            quickFiltersJql: $59496077a2cce3b6$var$buildJQLFromQuickFilters(quickFilters, {
                quickFilterToJQLMap: quickFilterToJQLMap
            })
        };
    };
});
parcelRegister("l4Ejo", function(module, exports) {
    $parcel$export(module.exports, "useFilters", ()=>$8a462d10017c11b6$export$973ca22476b0e05f);
    var $5uXOq = parcelRequire("5uXOq");
    var $x8FYU;
    var $1kpI8;
    var $1tESh;
    const $8a462d10017c11b6$export$973ca22476b0e05f = ()=>{
        const [jql, saveFilters] = (0, (0, parcelRequire("1kpI8")).useViewPreference)((0, (0, parcelRequire("x8FYU")).FILTER_PREFERENCE));
        const setFilter = (0, $5uXOq.useCallback)((filters)=>{
            const serialisedJql = (0, (0, parcelRequire("1tESh")).serialiseJql)(filters);
            saveFilters(serialisedJql !== '' ? serialisedJql : undefined);
        }, [
            saveFilters
        ]);
        return {
            setFilter: setFilter,
            jql: jql
        };
    };
});
parcelRegister("1tESh", function(module, exports) {
    $parcel$export(module.exports, "serialiseJql", ()=>$1e9d101255159a24$export$e1718e1e441cb0f6);
    $parcel$export(module.exports, "extractAnalyticsFilterDataFromJQL", ()=>$1e9d101255159a24$export$9ee6085825c9cbfa);
    var $gccSB = parcelRequire("gccSB");
    var $2nvJN = parcelRequire("2nvJN");
    var $gwejS;
    var $f9ece;
    var $jn8LC;
    var $3tbwt;
    var $g6wXc;
    var $7htvz;
    const $1e9d101255159a24$var$START_DATE_JQL = 'Start date[Date]';
    const $1e9d101255159a24$var$EMPTY = 'EMPTY';
    const $1e9d101255159a24$var$getQuotedFieldName = (fieldName)=>`"${fieldName}"`;
    const $1e9d101255159a24$var$getFieldNameForJqlRaw = (fieldName)=>{
        if (fieldName.indexOf('customfield_') === 0) {
            const customFieldId = fieldName.split('customfield_')[1];
            return `cf[${customFieldId}]`;
        }
        if (fieldName === 'dateRange') return $1e9d101255159a24$var$START_DATE_JQL;
        return fieldName;
    };
    const $1e9d101255159a24$var$getFieldNameForJql = (fieldName)=>$1e9d101255159a24$var$getQuotedFieldName($1e9d101255159a24$var$getFieldNameForJqlRaw(fieldName));
    const $1e9d101255159a24$var$getFieldIdFromJql = (rawFieldName, getShouldConvertCustomField)=>{
        const fieldName = (0, ($parcel$interopDefault($2nvJN)))(rawFieldName, '"');
        const shouldConvertCustomField = getShouldConvertCustomField ? getShouldConvertCustomField(fieldName) : true;
        if (fieldName.indexOf('cf[') === 0 && shouldConvertCustomField) {
            const extraction = new RegExp(/cf\[(.+)\]/).exec(fieldName);
            if (!extraction) return fieldName;
            const fieldId = extraction[1];
            return `customfield_${fieldId}`;
        }
        const startDateJql = $1e9d101255159a24$var$START_DATE_JQL;
        if (fieldName === startDateJql || fieldName === 'due') return 'dateRange';
        return fieldName;
    };
    const $1e9d101255159a24$var$sanitizeWord = (word)=>word.replace(/(["\\])/g, '\\$1');
    const $1e9d101255159a24$var$sanitizeWordOld = (word)=>word.replace(/'/g, "\\'");
    const $1e9d101255159a24$export$e1718e1e441cb0f6 = (filters)=>{
        const jqlQuery = (0, (0, parcelRequire("jn8LC")).default).query();
        Object.entries(filters).filter(([, options])=>options != null && (Array.isArray(options) && options.length > 0 || !Array.isArray(options) && typeof options === 'object' && (options.value == null || !(0, ($parcel$interopDefault($gccSB)))(options.value)))).forEach(([fieldId, options])=>{
            const fieldName = $1e9d101255159a24$var$getFieldNameForJqlRaw(fieldId);
            if (!Array.isArray(options) && typeof options === 'object' && !(0, ($parcel$interopDefault($gccSB)))(options?.value)) {
                const toFieldName = fieldId === 'dateRange' ? 'due' : fieldName;
                if (options.value.to != null) {
                    const toDate = (0, (0, parcelRequire("f9ece")).default)((0, (0, parcelRequire("gwejS")).default)(new Date(options.value.to), 1), 'UTC', 'yyyy-MM-dd');
                    jqlQuery.appendClause((0, (0, parcelRequire("jn8LC")).default).terminalClause((0, (0, parcelRequire("jn8LC")).default).field(toFieldName), (0, (0, parcelRequire("jn8LC")).default).operator((0, (0, parcelRequire("3tbwt")).OPERATOR_LT)), (0, (0, parcelRequire("jn8LC")).default).valueOperand(toDate)), (0, $c915714aa8f48e71$export$6d6d48d210d3ca97));
                }
                if (options.value.from != null) jqlQuery.appendClause((0, (0, parcelRequire("jn8LC")).default).terminalClause((0, (0, parcelRequire("jn8LC")).default).field(fieldName), (0, (0, parcelRequire("jn8LC")).default).operator((0, (0, parcelRequire("3tbwt")).OPERATOR_GT_EQUALS)), (0, (0, parcelRequire("jn8LC")).default).valueOperand(options.value.from)), (0, $c915714aa8f48e71$export$6d6d48d210d3ca97));
                return;
            }
            if (Array.isArray(options)) {
                const operands = options.map((option)=>{
                    if (option.isEmptyOption) return (0, (0, parcelRequire("jn8LC")).default).valueOperand((0, $230aa818ebdf534b$export$1c46dca02aac24dd));
                    if (option.value) return (0, (0, parcelRequire("jn8LC")).default).byText.valueOperand(`"${$1e9d101255159a24$var$sanitizeWord(option.value)}"`);
                    return null;
                }).filter((operand)=>operand != null);
                if (operands.length === 1) jqlQuery.appendClause((0, (0, parcelRequire("jn8LC")).default).terminalClause((0, (0, parcelRequire("jn8LC")).default).field(fieldName), (0, (0, parcelRequire("jn8LC")).default).operator((0, (0, parcelRequire("3tbwt")).OPERATOR_EQUALS)), operands[0]), (0, $c915714aa8f48e71$export$6d6d48d210d3ca97));
                else if (operands.length > 1) jqlQuery.appendClause((0, (0, parcelRequire("jn8LC")).default).terminalClause((0, (0, parcelRequire("jn8LC")).default).field(fieldName), (0, (0, parcelRequire("jn8LC")).default).operator((0, (0, parcelRequire("3tbwt")).OPERATOR_IN)), (0, (0, parcelRequire("jn8LC")).default).listOperand(operands)), (0, $c915714aa8f48e71$export$6d6d48d210d3ca97));
            }
        });
        const jast = (0, (0, parcelRequire("jn8LC")).default).jast(jqlQuery);
        return (0, (0, parcelRequire("g6wXc")).print)(jast, {
            operatorCase: 'upper',
            printWidth: null
        });
    };
    const $1e9d101255159a24$export$5bd6a523f48a18cd = (filters)=>{
        const pairs = Object.entries(filters).filter(([, options])=>options != null && (Array.isArray(options) && options.length > 0 || !Array.isArray(options) && typeof options === 'object' && (options.value == null || !(0, ($parcel$interopDefault($gccSB)))(options.value)))).map(([fieldId, options])=>{
            const fieldName = $1e9d101255159a24$var$getFieldNameForJql(fieldId);
            if (!Array.isArray(options) && typeof options === 'object' && !(0, ($parcel$interopDefault($gccSB)))(options?.value)) {
                const toFieldName = fieldId === 'dateRange' ? $1e9d101255159a24$var$getQuotedFieldName('due') : fieldName;
                let toDate;
                if (options.value.to) toDate = (0, (0, parcelRequire("f9ece")).default)((0, (0, parcelRequire("gwejS")).default)(new Date(options.value.to), 1), 'UTC', 'yyyy-MM-dd');
                else toDate = options.value.to;
                if (options.value.from != null && options.value.to != null) return `${fieldName} >= ${options.value.from} AND ${toFieldName} < ${toDate}`;
                if (options.value.from != null) return `${fieldName} >= ${options.value.from}`;
                return `${toFieldName} < ${toDate}`;
            }
            if (Array.isArray(options)) {
                const values = options.map((option)=>option.value === (0, (0, parcelRequire("7htvz")).EMPTY_FILTER_VALUE) ? $1e9d101255159a24$var$EMPTY : `'${$1e9d101255159a24$var$sanitizeWordOld(option.value)}'`).join(',');
                if (options.length > 1) return `${fieldName} in (${values})`;
                if (options.length === 1) return `${fieldName} = ${values}`;
            }
            return null;
        });
        return pairs.join(' AND ');
    };
    const $1e9d101255159a24$var$extractField = (statement)=>{
        let fieldId;
        const dateOperatorRegex = />=|</;
        if (dateOperatorRegex.test(statement)) {
            const operator = statement.includes('>=') ? ' >= ' : ' < ';
            [fieldId] = statement.split(operator);
        }
        if (statement.includes(' = ')) [fieldId] = statement.split(/ = /);
        if (statement.includes(' in ')) [fieldId] = statement.split(' in ');
        if (fieldId) return $1e9d101255159a24$var$getFieldIdFromJql(fieldId);
    };
    const $1e9d101255159a24$export$9ee6085825c9cbfa = (jql)=>{
        if (!jql) return {};
        return jql.split(/ AND | OR /).map($1e9d101255159a24$var$extractField).reduce((acc, curr)=>{
            if (curr) acc[curr] = true;
            return acc;
        }, {});
    };
});
parcelRegister("2nvJN", function(module, exports) {
    var $kHBB0 = parcelRequire("kHBB0");
    var $6wH7T = parcelRequire("6wH7T");
    var $gvFfr = parcelRequire("gvFfr");
    var $4TR1Q = parcelRequire("4TR1Q");
    var $c2mKc = parcelRequire("c2mKc");
    var $jx6Tp = parcelRequire("jx6Tp");
    var $jJVtR = parcelRequire("jJVtR");
    function $1bb6592c97235e03$var$trim(string, chars, guard) {
        string = $jJVtR(string);
        if (string && (guard || chars === undefined)) return $6wH7T(string);
        if (!string || !(chars = $kHBB0(chars))) return string;
        var strSymbols = $jx6Tp(string), chrSymbols = $jx6Tp(chars), start = $c2mKc(strSymbols, chrSymbols), end = $4TR1Q(strSymbols, chrSymbols) + 1;
        return $gvFfr(strSymbols, start, end).join('');
    }
    module.exports = $1bb6592c97235e03$var$trim;
});
parcelRegister("4TR1Q", function(module, exports) {
    var $2wwA6 = parcelRequire("2wwA6");
    function $39156edc40ecb497$var$charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while(index-- && $2wwA6(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    module.exports = $39156edc40ecb497$var$charsEndIndex;
});
parcelRegister("c2mKc", function(module, exports) {
    var $2wwA6 = parcelRequire("2wwA6");
    function $8c37507367fba30b$var$charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while(++index < length && $2wwA6(chrSymbols, strSymbols[index], 0) > -1);
        return index;
    }
    module.exports = $8c37507367fba30b$var$charsStartIndex;
});
const $c915714aa8f48e71$export$6d6d48d210d3ca97 = 'and';
const $c915714aa8f48e71$export$7b8f0a728d79a753 = 'or';
parcelRegister("jn8LC", function(module, exports) {
    $parcel$export(module.exports, "internalCreators", ()=>$6c9793fc4b22bd47$export$64d991963cfb5532);
    $parcel$export(module.exports, "default", ()=>$6c9793fc4b22bd47$export$2e2bcd8739ae039);
    var $kMF8h;
    var $4DbTM;
    var $gn7JT;
    var $1hhaf;
    var $lEFsS;
    var $f9REH;
    var $k1lgM;
    var $ivZWl;
    var $dOkTY;
    var $gqicT;
    var $fA12K;
    var $fSTjl;
    var $ebUam;
    var $iffIw;
    var $X9dfy;
    var $bjh9t;
    var $bhtV2;
    var $kYJIR;
    var $eE4GS;
    var $1A2lV;
    var $26wL6;
    var $3YEV7;
    const $6c9793fc4b22bd47$export$64d991963cfb5532 = {
        query: (0, (0, parcelRequire("1A2lV")).queryInternal),
        compoundClause: (0, (0, parcelRequire("4DbTM")).compoundClauseInternal),
        compoundOperator: (0, (0, parcelRequire("gn7JT")).compoundOperatorInternal),
        terminalClause: (0, (0, parcelRequire("26wL6")).terminalClauseInternal),
        notClause: (0, (0, parcelRequire("gqicT")).notClauseInternal),
        notClauseOperator: (0, (0, parcelRequire("fA12K")).notClauseOperatorInternal),
        predicate: (0, (0, parcelRequire("bhtV2")).predicateInternal),
        predicateOperator: (0, (0, parcelRequire("kYJIR")).predicateOperatorInternal),
        field: (0, (0, parcelRequire("1hhaf")).fieldInternal),
        property: (0, (0, parcelRequire("eE4GS")).propertyInternal),
        operator: (0, (0, parcelRequire("fSTjl")).operatorInternal),
        valueOperand: (0, (0, parcelRequire("3YEV7")).valueOperandInternal),
        keywordOperand: (0, (0, parcelRequire("ivZWl")).keywordOperandInternal),
        functionOperand: (0, (0, parcelRequire("lEFsS")).functionOperandInternal),
        functionString: (0, (0, parcelRequire("f9REH")).functionStringInternal),
        argument: (0, (0, parcelRequire("kMF8h")).argumentInternal),
        listOperand: (0, (0, parcelRequire("dOkTY")).listOperandInternal),
        orderBy: (0, (0, parcelRequire("ebUam")).orderByInternal),
        orderByOperator: (0, (0, parcelRequire("bjh9t")).orderByOperatorInternal),
        orderByField: (0, (0, parcelRequire("X9dfy")).orderByFieldInternal),
        orderByDirection: (0, (0, parcelRequire("iffIw")).orderByDirectionInternal)
    };
    var $6c9793fc4b22bd47$export$2e2bcd8739ae039 = {
        jast: (0, parcelRequire("k1lgM")).jast,
        query: (0, parcelRequire("1A2lV")).query,
        compoundClause: (0, parcelRequire("4DbTM")).compoundClause,
        compoundOperator: (0, parcelRequire("gn7JT")).compoundOperator,
        terminalClause: (0, parcelRequire("26wL6")).terminalClause,
        notClause: (0, parcelRequire("gqicT")).notClause,
        notClauseOperator: (0, parcelRequire("fA12K")).notClauseOperator,
        predicate: (0, parcelRequire("bhtV2")).predicate,
        predicateOperator: (0, parcelRequire("kYJIR")).predicateOperator,
        field: (0, parcelRequire("1hhaf")).field,
        property: (0, parcelRequire("eE4GS")).property,
        operator: (0, parcelRequire("fSTjl")).operator,
        valueOperand: (0, parcelRequire("3YEV7")).valueOperand,
        keywordOperand: (0, parcelRequire("ivZWl")).keywordOperand,
        functionOperand: (0, parcelRequire("lEFsS")).functionOperand,
        functionString: (0, parcelRequire("f9REH")).functionString,
        argument: (0, parcelRequire("kMF8h")).argument,
        listOperand: (0, parcelRequire("dOkTY")).listOperand,
        orderBy: (0, parcelRequire("ebUam")).orderBy,
        orderByOperator: (0, parcelRequire("bjh9t")).orderByOperator,
        orderByField: (0, parcelRequire("X9dfy")).orderByField,
        orderByDirection: (0, parcelRequire("iffIw")).orderByDirection,
        byText: {
            argument: (0, (0, parcelRequire("kMF8h")).argumentByText),
            valueOperand: (0, (0, parcelRequire("3YEV7")).valueOperandByText)
        }
    };
});
parcelRegister("kMF8h", function(module, exports) {
    $parcel$export(module.exports, "argument", ()=>$ef42268862c8bd50$export$6ea29ee575e3f5ff);
    $parcel$export(module.exports, "argumentInternal", ()=>$ef42268862c8bd50$export$5b341d50fa5bcdd5);
    $parcel$export(module.exports, "argumentByText", ()=>$ef42268862c8bd50$export$84c43d23f51170cb);
    var $7onwV;
    var $w8TY1;
    var $CNXg1;
    function $ef42268862c8bd50$var$acceptArgument(visitor) {
        return visitor.visitArgument ? visitor.visitArgument(this) : visitor.visitChildren(this);
    }
    function $ef42268862c8bd50$var$enterNode(listener) {
        listener.enterArgument && listener.enterArgument(this);
    }
    function $ef42268862c8bd50$var$exitNode(listener) {
        listener.exitArgument && listener.exitArgument(this);
    }
    const $ef42268862c8bd50$export$6ea29ee575e3f5ff = (value)=>$ef42268862c8bd50$export$5b341d50fa5bcdd5(value, (0, (0, parcelRequire("w8TY1")).sanitiseJqlString)(value));
    const $ef42268862c8bd50$export$84c43d23f51170cb = (text)=>$ef42268862c8bd50$export$5b341d50fa5bcdd5((0, (0, parcelRequire("7onwV")).normaliseJqlString)(text), text);
    const $ef42268862c8bd50$export$5b341d50fa5bcdd5 = (value, text, position = null)=>({
            text: text,
            value: value,
            position: position,
            accept: $ef42268862c8bd50$var$acceptArgument,
            enterNode: $ef42268862c8bd50$var$enterNode,
            exitNode: $ef42268862c8bd50$var$exitNode,
            getChildren: (0, (0, parcelRequire("CNXg1")).noChildren),
            parent: null
        });
});
parcelRegister("7onwV", function(module, exports) {
    $parcel$export(module.exports, "normaliseJqlString", ()=>$b0901b90db52a8d1$export$cecf78a779acc0ff);
    const $b0901b90db52a8d1$export$7a0b99b892e0dda8 = (maybeQuotedString)=>{
        if (maybeQuotedString.length < 2) return false;
        return maybeQuotedString[0] === "'" && maybeQuotedString[maybeQuotedString.length - 1] === "'" && maybeQuotedString[maybeQuotedString.length - 2] !== '\\';
    };
    const $b0901b90db52a8d1$export$d5efd6512db694fd = (maybeQuotedString)=>{
        if (maybeQuotedString.length < 2) return false;
        return maybeQuotedString[0] === '"' && maybeQuotedString[maybeQuotedString.length - 1] === '"' && maybeQuotedString[maybeQuotedString.length - 2] !== '\\';
    };
    const $b0901b90db52a8d1$export$b86601123607fee5 = (maybeQuotedString)=>$b0901b90db52a8d1$export$7a0b99b892e0dda8(maybeQuotedString) || $b0901b90db52a8d1$export$d5efd6512db694fd(maybeQuotedString);
    const $b0901b90db52a8d1$export$cecf78a779acc0ff = (maybeQuotedString)=>{
        if ($b0901b90db52a8d1$export$b86601123607fee5(maybeQuotedString)) return maybeQuotedString.slice(1, -1).replace(/(?:\\(.))/g, '$1');
        if (maybeQuotedString.startsWith('"') || maybeQuotedString.startsWith("'")) return maybeQuotedString.slice(1).replace(/(?:\\(.))/g, '$1');
        return maybeQuotedString;
    };
});
parcelRegister("w8TY1", function(module, exports) {
    $parcel$export(module.exports, "sanitiseJqlString", ()=>$55eacb8e3b015629$export$3eb9033c48208278);
    var $8QDwl = parcelRequire("8QDwl");
    const $55eacb8e3b015629$var$CHARS_TO_QUOTE = new RegExp(`[\\s${(0, ($parcel$interopDefault($8QDwl)))(`"'=!<>()~,[]|&{}*/%+^$#@?;`)}]`);
    const $55eacb8e3b015629$export$3eb9033c48208278 = (jqlString)=>{
        if ($55eacb8e3b015629$var$CHARS_TO_QUOTE.test(jqlString)) return `"${jqlString.replace(/"/g, '\\"')}"`;
        return jqlString;
    };
});
parcelRegister("8QDwl", function(module, exports) {
    var $jJVtR = parcelRequire("jJVtR");
    var $6711d60dd8e02df4$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g, $6711d60dd8e02df4$var$reHasRegExpChar = RegExp($6711d60dd8e02df4$var$reRegExpChar.source);
    function $6711d60dd8e02df4$var$escapeRegExp(string) {
        string = $jJVtR(string);
        return string && $6711d60dd8e02df4$var$reHasRegExpChar.test(string) ? string.replace($6711d60dd8e02df4$var$reRegExpChar, '\\$&') : string;
    }
    module.exports = $6711d60dd8e02df4$var$escapeRegExp;
});
parcelRegister("CNXg1", function(module, exports) {
    $parcel$export(module.exports, "noChildren", ()=>$bbb3af1088d8488f$export$470bef71e654b804);
    $parcel$export(module.exports, "assignParent", ()=>$bbb3af1088d8488f$export$a4685923af2913a);
    const $bbb3af1088d8488f$export$470bef71e654b804 = ()=>[];
    const $bbb3af1088d8488f$export$a4685923af2913a = (node)=>{
        node.getChildren().forEach((child)=>{
            child.parent = node;
        });
    };
});
parcelRegister("4DbTM", function(module, exports) {
    $parcel$export(module.exports, "compoundClause", ()=>$777a31802b97cae5$export$ab714e56a32c25f2);
    $parcel$export(module.exports, "compoundClauseInternal", ()=>$777a31802b97cae5$export$cd65eed8c10b0911);
    var $3SK6Z;
    var $CNXg1;
    function $777a31802b97cae5$var$acceptCompoundClause(visitor) {
        return visitor.visitCompoundClause ? visitor.visitCompoundClause(this) : visitor.visitChildren(this);
    }
    function $777a31802b97cae5$var$enterNode(listener) {
        listener.enterCompoundClause && listener.enterCompoundClause(this);
    }
    function $777a31802b97cae5$var$exitNode(listener) {
        listener.exitCompoundClause && listener.exitCompoundClause(this);
    }
    function $777a31802b97cae5$var$getChildren() {
        return [
            this.operator,
            ...this.clauses
        ];
    }
    const $777a31802b97cae5$export$ab714e56a32c25f2 = (operator, clauses)=>{
        return $777a31802b97cae5$export$cd65eed8c10b0911(operator, clauses);
    };
    const $777a31802b97cae5$export$cd65eed8c10b0911 = (operator, clauses, position = null)=>{
        const node = {
            type: (0, $98006e90dfac75d1$export$2d205682cc545947),
            clauseType: (0, $0158eec8c0615e8c$export$7a58b23488ea076b),
            operator: operator,
            clauses: clauses,
            position: position,
            accept: $777a31802b97cae5$var$acceptCompoundClause,
            enterNode: $777a31802b97cae5$var$enterNode,
            exitNode: $777a31802b97cae5$var$exitNode,
            getChildren: $777a31802b97cae5$var$getChildren,
            parent: null,
            appendClause: (0, parcelRequire("3SK6Z")).appendClause,
            remove: (0, parcelRequire("3SK6Z")).remove,
            removeClause: (0, parcelRequire("3SK6Z")).removeClause,
            replace: (0, parcelRequire("3SK6Z")).replace,
            replaceClause: (0, parcelRequire("3SK6Z")).replaceClause
        };
        (0, (0, parcelRequire("CNXg1")).assignParent)(node);
        return node;
    };
});
const $0158eec8c0615e8c$export$7a58b23488ea076b = 'compound';
const $0158eec8c0615e8c$export$ae56b4ef248a2b6a = 'terminal';
const $0158eec8c0615e8c$export$e356b89f8c8d2fcb = 'not';
const $98006e90dfac75d1$export$98dda21ec825792 = 'query';
const $98006e90dfac75d1$export$2d205682cc545947 = 'clause';
const $98006e90dfac75d1$export$d2f212d8ddbc8d1d = 'operand';
const $98006e90dfac75d1$export$da0f73edded4a63d = 'order_by';
parcelRegister("3SK6Z", function(module, exports) {
    $parcel$export(module.exports, "appendClause", ()=>appendClause);
    $parcel$export(module.exports, "remove", ()=>remove);
    $parcel$export(module.exports, "removeClause", ()=>removeClause);
    $parcel$export(module.exports, "replace", ()=>replace);
    $parcel$export(module.exports, "replaceClause", ()=>replaceClause);
    var $CNXg1;
    function appendClause(clause) {
        let clausesToAppend = [
            clause
        ];
        if (clause.clauseType === (0, $0158eec8c0615e8c$export$7a58b23488ea076b) && clause.operator.value === this.operator.value) clausesToAppend = clause.clauses;
        this.clauses.push(...clausesToAppend);
        (0, (0, parcelRequire("CNXg1")).assignParent)(this);
    }
    function remove() {
        if (this.parent) this.parent.removeClause(this);
    }
    function removeClause(clause) {
        this.clauses = this.clauses.filter((val)=>val !== clause);
        if (this.clauses.length === 1) this.replace(this.clauses[0]);
        else if (this.clauses.length === 0) this.remove();
    }
    function replace(nextClause) {
        if (this.parent) this.parent.replaceClause(this, nextClause);
    }
    function replaceClause(clause, nextClause) {
        this.clauses = this.clauses.map((child)=>{
            return child === clause ? nextClause : child;
        });
        (0, (0, parcelRequire("CNXg1")).assignParent)(this);
    }
});
parcelRegister("gn7JT", function(module, exports) {
    $parcel$export(module.exports, "compoundOperator", ()=>$608245c8956a34ef$export$84bb3ebbba491aee);
    $parcel$export(module.exports, "compoundOperatorInternal", ()=>$608245c8956a34ef$export$63c33bc3fe74fee6);
    var $CNXg1;
    function $608245c8956a34ef$var$acceptCompoundOperator(visitor) {
        return visitor.visitCompoundOperator ? visitor.visitCompoundOperator(this) : visitor.visitChildren(this);
    }
    function $608245c8956a34ef$var$enterNode(listener) {
        listener.enterCompoundOperator && listener.enterCompoundOperator(this);
    }
    function $608245c8956a34ef$var$exitNode(listener) {
        listener.exitCompoundOperator && listener.exitCompoundOperator(this);
    }
    const $608245c8956a34ef$export$84bb3ebbba491aee = (value)=>$608245c8956a34ef$export$63c33bc3fe74fee6(value, []);
    const $608245c8956a34ef$export$63c33bc3fe74fee6 = (value, operatorPositions)=>({
            value: value,
            positions: operatorPositions,
            position: null,
            accept: $608245c8956a34ef$var$acceptCompoundOperator,
            enterNode: $608245c8956a34ef$var$enterNode,
            exitNode: $608245c8956a34ef$var$exitNode,
            getChildren: (0, (0, parcelRequire("CNXg1")).noChildren),
            parent: null
        });
});
parcelRegister("1hhaf", function(module, exports) {
    $parcel$export(module.exports, "field", ()=>$f72962a578b44d22$export$e0f35d825088c098);
    $parcel$export(module.exports, "fieldInternal", ()=>$f72962a578b44d22$export$2193f8c541622b6);
    var $w8TY1;
    var $CNXg1;
    function $f72962a578b44d22$var$acceptField(visitor) {
        return visitor.visitField ? visitor.visitField(this) : visitor.visitChildren(this);
    }
    function $f72962a578b44d22$var$enterNode(listener) {
        listener.enterField && listener.enterField(this);
    }
    function $f72962a578b44d22$var$exitNode(listener) {
        listener.exitField && listener.exitField(this);
    }
    function $f72962a578b44d22$var$getChildren() {
        return this.properties ? [
            ...this.properties
        ] : [];
    }
    const $f72962a578b44d22$export$e0f35d825088c098 = (value, properties)=>{
        return $f72962a578b44d22$export$2193f8c541622b6(value, (0, (0, parcelRequire("w8TY1")).sanitiseJqlString)(value), properties);
    };
    const $f72962a578b44d22$export$2193f8c541622b6 = (value, text, properties, position = null)=>{
        const node = {
            text: text,
            value: value,
            properties: properties,
            position: position,
            accept: $f72962a578b44d22$var$acceptField,
            enterNode: $f72962a578b44d22$var$enterNode,
            exitNode: $f72962a578b44d22$var$exitNode,
            getChildren: $f72962a578b44d22$var$getChildren,
            parent: null
        };
        (0, (0, parcelRequire("CNXg1")).assignParent)(node);
        return node;
    };
});
parcelRegister("lEFsS", function(module, exports) {
    $parcel$export(module.exports, "functionOperand", ()=>$9f6ecf46a9e172aa$export$4f981b0e83488ce);
    $parcel$export(module.exports, "functionOperandInternal", ()=>$9f6ecf46a9e172aa$export$c1f2ce91dc05872a);
    var $CNXg1;
    function $9f6ecf46a9e172aa$var$acceptFunctionOperand(visitor) {
        return visitor.visitFunctionOperand ? visitor.visitFunctionOperand(this) : visitor.visitChildren(this);
    }
    function $9f6ecf46a9e172aa$var$enterNode(listener) {
        listener.enterFunctionOperand && listener.enterFunctionOperand(this);
    }
    function $9f6ecf46a9e172aa$var$exitNode(listener) {
        listener.exitFunctionOperand && listener.exitFunctionOperand(this);
    }
    function $9f6ecf46a9e172aa$var$getChildren() {
        return [
            this.function,
            ...this.arguments
        ];
    }
    const $9f6ecf46a9e172aa$export$4f981b0e83488ce = (functionString, args = [])=>$9f6ecf46a9e172aa$export$c1f2ce91dc05872a(functionString, args);
    const $9f6ecf46a9e172aa$export$c1f2ce91dc05872a = (functionString, args, position = null)=>{
        const node = {
            type: (0, $98006e90dfac75d1$export$d2f212d8ddbc8d1d),
            operandType: (0, $230aa818ebdf534b$export$19c7c729db381f9d),
            function: functionString,
            arguments: args,
            position: position,
            accept: $9f6ecf46a9e172aa$var$acceptFunctionOperand,
            enterNode: $9f6ecf46a9e172aa$var$enterNode,
            exitNode: $9f6ecf46a9e172aa$var$exitNode,
            getChildren: $9f6ecf46a9e172aa$var$getChildren,
            parent: null
        };
        (0, (0, parcelRequire("CNXg1")).assignParent)(node);
        return node;
    };
});
const $230aa818ebdf534b$export$38accfc5a5d1c113 = 'value';
const $230aa818ebdf534b$export$f6049126fd97001f = 'keyword';
const $230aa818ebdf534b$export$19c7c729db381f9d = 'function';
const $230aa818ebdf534b$export$fabec4aebba3f4df = 'list';
const $230aa818ebdf534b$export$1c46dca02aac24dd = 'empty';
parcelRegister("f9REH", function(module, exports) {
    $parcel$export(module.exports, "functionString", ()=>$bedd5f2a739cc7bd$export$4e1bb9a7ff8d0ef9);
    $parcel$export(module.exports, "functionStringInternal", ()=>$bedd5f2a739cc7bd$export$7aa9944588b7a69f);
    var $w8TY1;
    var $CNXg1;
    function $bedd5f2a739cc7bd$var$acceptFunctionString(visitor) {
        return visitor.visitFunction ? visitor.visitFunction(this) : visitor.visitChildren(this);
    }
    function $bedd5f2a739cc7bd$var$enterNode(listener) {
        listener.enterFunction && listener.enterFunction(this);
    }
    function $bedd5f2a739cc7bd$var$exitNode(listener) {
        listener.exitFunction && listener.exitFunction(this);
    }
    const $bedd5f2a739cc7bd$export$4e1bb9a7ff8d0ef9 = (value)=>$bedd5f2a739cc7bd$export$7aa9944588b7a69f(value, (0, (0, parcelRequire("w8TY1")).sanitiseJqlString)(value));
    const $bedd5f2a739cc7bd$export$7aa9944588b7a69f = (value, text, position = null)=>({
            text: text,
            value: value,
            position: position,
            accept: $bedd5f2a739cc7bd$var$acceptFunctionString,
            enterNode: $bedd5f2a739cc7bd$var$enterNode,
            exitNode: $bedd5f2a739cc7bd$var$exitNode,
            getChildren: (0, (0, parcelRequire("CNXg1")).noChildren),
            parent: null
        });
});
parcelRegister("k1lgM", function(module, exports) {
    $parcel$export(module.exports, "jast", ()=>$0b2063a2c1ea5e91$export$b9e70a00f479ff43);
    const $0b2063a2c1ea5e91$export$b9e70a00f479ff43 = (query, represents = '', errors = [])=>({
            query: query,
            represents: represents,
            errors: errors
        });
});
parcelRegister("ivZWl", function(module, exports) {
    $parcel$export(module.exports, "keywordOperand", ()=>$8c1621e5cff83a60$export$2edd4971ed69f2ce);
    $parcel$export(module.exports, "keywordOperandInternal", ()=>$8c1621e5cff83a60$export$7cc55480b054047b);
    var $CNXg1;
    function $8c1621e5cff83a60$var$acceptKeywordOperand(visitor) {
        return visitor.visitKeywordOperand ? visitor.visitKeywordOperand(this) : visitor.visitChildren(this);
    }
    function $8c1621e5cff83a60$var$enterNode(listener) {
        listener.enterKeywordOperand && listener.enterKeywordOperand(this);
    }
    function $8c1621e5cff83a60$var$exitNode(listener) {
        listener.exitKeywordOperand && listener.exitKeywordOperand(this);
    }
    const $8c1621e5cff83a60$export$2edd4971ed69f2ce = ()=>$8c1621e5cff83a60$export$7cc55480b054047b((0, $230aa818ebdf534b$export$1c46dca02aac24dd));
    const $8c1621e5cff83a60$export$7cc55480b054047b = (value, position = null)=>({
            type: (0, $98006e90dfac75d1$export$d2f212d8ddbc8d1d),
            operandType: (0, $230aa818ebdf534b$export$f6049126fd97001f),
            value: value,
            position: position,
            accept: $8c1621e5cff83a60$var$acceptKeywordOperand,
            enterNode: $8c1621e5cff83a60$var$enterNode,
            exitNode: $8c1621e5cff83a60$var$exitNode,
            getChildren: (0, (0, parcelRequire("CNXg1")).noChildren),
            parent: null
        });
});
parcelRegister("dOkTY", function(module, exports) {
    $parcel$export(module.exports, "listOperand", ()=>$22df8c659a2abc27$export$769866c3e9d41d50);
    $parcel$export(module.exports, "listOperandInternal", ()=>$22df8c659a2abc27$export$663c7831528c984b);
    var $3ATWD;
    var $CNXg1;
    function $22df8c659a2abc27$var$acceptListOperand(visitor) {
        return visitor.visitListOperand ? visitor.visitListOperand(this) : visitor.visitChildren(this);
    }
    function $22df8c659a2abc27$var$enterNode(listener) {
        listener.enterListOperand && listener.enterListOperand(this);
    }
    function $22df8c659a2abc27$var$exitNode(listener) {
        listener.exitListOperand && listener.exitListOperand(this);
    }
    function $22df8c659a2abc27$var$getChildren() {
        return [
            ...this.values
        ];
    }
    const $22df8c659a2abc27$export$769866c3e9d41d50 = (values)=>$22df8c659a2abc27$export$663c7831528c984b(values);
    const $22df8c659a2abc27$export$663c7831528c984b = (values, position = null)=>{
        const node = {
            type: (0, $98006e90dfac75d1$export$d2f212d8ddbc8d1d),
            operandType: (0, $230aa818ebdf534b$export$fabec4aebba3f4df),
            values: values,
            position: position,
            accept: $22df8c659a2abc27$var$acceptListOperand,
            enterNode: $22df8c659a2abc27$var$enterNode,
            exitNode: $22df8c659a2abc27$var$exitNode,
            getChildren: $22df8c659a2abc27$var$getChildren,
            parent: null,
            appendOperand: (0, parcelRequire("3ATWD")).appendOperand
        };
        (0, (0, parcelRequire("CNXg1")).assignParent)(node);
        return node;
    };
});
parcelRegister("3ATWD", function(module, exports) {
    $parcel$export(module.exports, "appendOperand", ()=>$4f2d52ca06addda6$export$d94c54f1aee177c4);
    var $CNXg1;
    function $4f2d52ca06addda6$export$d94c54f1aee177c4(operand) {
        this.values.push(...operand.operandType === (0, $230aa818ebdf534b$export$fabec4aebba3f4df) ? operand.values : [
            operand
        ]);
        (0, (0, parcelRequire("CNXg1")).assignParent)(this);
    }
});
parcelRegister("gqicT", function(module, exports) {
    $parcel$export(module.exports, "notClause", ()=>$22540314903c718e$export$b4734a9fedb4d44e);
    $parcel$export(module.exports, "notClauseInternal", ()=>$22540314903c718e$export$b25621824fea4548);
    var $eOmZp;
    var $CNXg1;
    var $fA12K;
    function $22540314903c718e$var$acceptNotClause(visitor) {
        return visitor.visitNotClause ? visitor.visitNotClause(this) : visitor.visitChildren(this);
    }
    function $22540314903c718e$var$enterNode(listener) {
        listener.enterNotClause && listener.enterNotClause(this);
    }
    function $22540314903c718e$var$exitNode(listener) {
        listener.exitNotClause && listener.exitNotClause(this);
    }
    function $22540314903c718e$var$getChildren() {
        return [
            this.operator,
            this.clause
        ];
    }
    const $22540314903c718e$export$b4734a9fedb4d44e = (clause)=>{
        return $22540314903c718e$export$b25621824fea4548(clause, (0, (0, parcelRequire("fA12K")).notClauseOperator)());
    };
    const $22540314903c718e$export$b25621824fea4548 = (clause, operator, position = null)=>{
        const node = {
            type: (0, $98006e90dfac75d1$export$2d205682cc545947),
            clauseType: (0, $0158eec8c0615e8c$export$e356b89f8c8d2fcb),
            clause: clause,
            operator: operator,
            position: position,
            accept: $22540314903c718e$var$acceptNotClause,
            enterNode: $22540314903c718e$var$enterNode,
            exitNode: $22540314903c718e$var$exitNode,
            getChildren: $22540314903c718e$var$getChildren,
            parent: null,
            remove: (0, parcelRequire("eOmZp")).remove,
            removeClause: (0, parcelRequire("eOmZp")).removeClause,
            replace: (0, parcelRequire("eOmZp")).replace,
            replaceClause: (0, parcelRequire("eOmZp")).replaceClause
        };
        (0, (0, parcelRequire("CNXg1")).assignParent)(node);
        return node;
    };
});
parcelRegister("eOmZp", function(module, exports) {
    $parcel$export(module.exports, "remove", ()=>remove);
    $parcel$export(module.exports, "removeClause", ()=>removeClause);
    $parcel$export(module.exports, "replace", ()=>replace);
    $parcel$export(module.exports, "replaceClause", ()=>replaceClause);
    var $CNXg1;
    function remove() {
        if (this.parent) this.parent.removeClause(this);
    }
    function removeClause(clause) {
        if (this.clause === clause) this.remove();
    }
    function replace(nextClause) {
        if (this.parent) this.parent.replaceClause(this, nextClause);
    }
    function replaceClause(clause, nextClause) {
        if (this.clause === clause) {
            this.clause = nextClause;
            (0, (0, parcelRequire("CNXg1")).assignParent)(this);
        }
    }
});
parcelRegister("fA12K", function(module, exports) {
    $parcel$export(module.exports, "notClauseOperator", ()=>$f8f80d74ce772b01$export$d2cd8239f99c13d3);
    $parcel$export(module.exports, "notClauseOperatorInternal", ()=>$f8f80d74ce772b01$export$1b15a32bb57b9020);
    var $3tbwt;
    var $CNXg1;
    function $f8f80d74ce772b01$var$acceptNotClauseOperator(visitor) {
        return visitor.visitNotClauseOperator ? visitor.visitNotClauseOperator(this) : visitor.visitChildren(this);
    }
    function $f8f80d74ce772b01$var$enterNode(listener) {
        listener.enterNotClauseOperator && listener.enterNotClauseOperator(this);
    }
    function $f8f80d74ce772b01$var$exitNode(listener) {
        listener.exitNotClauseOperator && listener.exitNotClauseOperator(this);
    }
    const $f8f80d74ce772b01$export$d2cd8239f99c13d3 = ()=>$f8f80d74ce772b01$export$1b15a32bb57b9020();
    const $f8f80d74ce772b01$export$1b15a32bb57b9020 = (position = null)=>({
            value: (0, (0, parcelRequire("3tbwt")).CLAUSE_OPERATOR_NOT),
            position: position,
            accept: $f8f80d74ce772b01$var$acceptNotClauseOperator,
            enterNode: $f8f80d74ce772b01$var$enterNode,
            exitNode: $f8f80d74ce772b01$var$exitNode,
            getChildren: (0, (0, parcelRequire("CNXg1")).noChildren),
            parent: null
        });
});
parcelRegister("3tbwt", function(module, exports) {
    $parcel$export(module.exports, "CLAUSE_OPERATOR_NOT", ()=>$dd24b70aecfb840a$export$c6c71ceedb15cda9);
    $parcel$export(module.exports, "OPERATOR_EQUALS", ()=>$dd24b70aecfb840a$export$466517a888d00195);
    $parcel$export(module.exports, "OPERATOR_NOT_EQUALS", ()=>$dd24b70aecfb840a$export$6d0d8810623974a5);
    $parcel$export(module.exports, "OPERATOR_GT", ()=>$dd24b70aecfb840a$export$bcbb090ab3c498b3);
    $parcel$export(module.exports, "OPERATOR_LT", ()=>$dd24b70aecfb840a$export$4bf1a4aa659c6ea4);
    $parcel$export(module.exports, "OPERATOR_GT_EQUALS", ()=>$dd24b70aecfb840a$export$83ce674214a54b2a);
    $parcel$export(module.exports, "OPERATOR_LT_EQUALS", ()=>$dd24b70aecfb840a$export$9629fd1727ef62ee);
    $parcel$export(module.exports, "OPERATOR_IN", ()=>$dd24b70aecfb840a$export$c4e3fb55e320e979);
    $parcel$export(module.exports, "OPERATOR_NOT_IN", ()=>$dd24b70aecfb840a$export$f9857532eaa24ddc);
    $parcel$export(module.exports, "OPERATOR_LIKE", ()=>$dd24b70aecfb840a$export$221595834b8766ab);
    $parcel$export(module.exports, "OPERATOR_NOT_LIKE", ()=>$dd24b70aecfb840a$export$fcefabf94a9bffbf);
    $parcel$export(module.exports, "OPERATOR_IS", ()=>$dd24b70aecfb840a$export$4feeb3f4ff56bcef);
    $parcel$export(module.exports, "OPERATOR_IS_NOT", ()=>$dd24b70aecfb840a$export$d08d969a0da27188);
    $parcel$export(module.exports, "OPERATOR_WAS", ()=>$dd24b70aecfb840a$export$8f907e179985256d);
    $parcel$export(module.exports, "OPERATOR_WAS_IN", ()=>$dd24b70aecfb840a$export$cc7b9d0b3ee23193);
    $parcel$export(module.exports, "OPERATOR_WAS_NOT_IN", ()=>$dd24b70aecfb840a$export$585d3c004af078bb);
    $parcel$export(module.exports, "OPERATOR_WAS_NOT", ()=>$dd24b70aecfb840a$export$123eaa9ccc2d9445);
    $parcel$export(module.exports, "OPERATOR_CHANGED", ()=>$dd24b70aecfb840a$export$15f5b446ba8c941e);
    $parcel$export(module.exports, "EQUALS_OPERATORS", ()=>$dd24b70aecfb840a$export$643c6101f3fc8547);
    $parcel$export(module.exports, "LIKE_OPERATORS", ()=>$dd24b70aecfb840a$export$329664c9cf18cca6);
    $parcel$export(module.exports, "COMPARISON_OPERATORS", ()=>$dd24b70aecfb840a$export$1b167a3705885a8b);
    $parcel$export(module.exports, "IN_OPERATORS", ()=>$dd24b70aecfb840a$export$f25cf16c2270312f);
    $parcel$export(module.exports, "IS_OPERATORS", ()=>$dd24b70aecfb840a$export$eb58cfffe4a6b805);
    $parcel$export(module.exports, "WAS_OPERATORS", ()=>$dd24b70aecfb840a$export$c22a981f581de218);
    $parcel$export(module.exports, "WAS_IN_OPERATORS", ()=>$dd24b70aecfb840a$export$6d08c4699bb75284);
    $parcel$export(module.exports, "CHANGED_OPERATORS", ()=>$dd24b70aecfb840a$export$b7dc214eef214c1c);
    $parcel$export(module.exports, "OPERATORS", ()=>$dd24b70aecfb840a$export$184799fc79ccac89);
    $parcel$export(module.exports, "LIST_OPERATORS", ()=>$dd24b70aecfb840a$export$77c793736847e030);
    const $dd24b70aecfb840a$export$c6c71ceedb15cda9 = 'not';
    const $dd24b70aecfb840a$export$466517a888d00195 = '=';
    const $dd24b70aecfb840a$export$6d0d8810623974a5 = '!=';
    const $dd24b70aecfb840a$export$bcbb090ab3c498b3 = '>';
    const $dd24b70aecfb840a$export$4bf1a4aa659c6ea4 = '<';
    const $dd24b70aecfb840a$export$83ce674214a54b2a = '>=';
    const $dd24b70aecfb840a$export$9629fd1727ef62ee = '<=';
    const $dd24b70aecfb840a$export$c4e3fb55e320e979 = 'in';
    const $dd24b70aecfb840a$export$f9857532eaa24ddc = 'not in';
    const $dd24b70aecfb840a$export$221595834b8766ab = '~';
    const $dd24b70aecfb840a$export$fcefabf94a9bffbf = '!~';
    const $dd24b70aecfb840a$export$4feeb3f4ff56bcef = 'is';
    const $dd24b70aecfb840a$export$d08d969a0da27188 = 'is not';
    const $dd24b70aecfb840a$export$8f907e179985256d = 'was';
    const $dd24b70aecfb840a$export$cc7b9d0b3ee23193 = 'was in';
    const $dd24b70aecfb840a$export$585d3c004af078bb = 'was not in';
    const $dd24b70aecfb840a$export$123eaa9ccc2d9445 = 'was not';
    const $dd24b70aecfb840a$export$15f5b446ba8c941e = 'changed';
    const $dd24b70aecfb840a$export$643c6101f3fc8547 = [
        $dd24b70aecfb840a$export$466517a888d00195,
        $dd24b70aecfb840a$export$6d0d8810623974a5
    ];
    const $dd24b70aecfb840a$export$329664c9cf18cca6 = [
        $dd24b70aecfb840a$export$221595834b8766ab,
        $dd24b70aecfb840a$export$fcefabf94a9bffbf
    ];
    const $dd24b70aecfb840a$export$1b167a3705885a8b = [
        $dd24b70aecfb840a$export$4bf1a4aa659c6ea4,
        $dd24b70aecfb840a$export$bcbb090ab3c498b3,
        $dd24b70aecfb840a$export$9629fd1727ef62ee,
        $dd24b70aecfb840a$export$83ce674214a54b2a
    ];
    const $dd24b70aecfb840a$export$f25cf16c2270312f = [
        $dd24b70aecfb840a$export$c4e3fb55e320e979,
        $dd24b70aecfb840a$export$f9857532eaa24ddc
    ];
    const $dd24b70aecfb840a$export$eb58cfffe4a6b805 = [
        $dd24b70aecfb840a$export$4feeb3f4ff56bcef,
        $dd24b70aecfb840a$export$d08d969a0da27188
    ];
    const $dd24b70aecfb840a$export$c22a981f581de218 = [
        $dd24b70aecfb840a$export$8f907e179985256d,
        $dd24b70aecfb840a$export$123eaa9ccc2d9445
    ];
    const $dd24b70aecfb840a$export$6d08c4699bb75284 = [
        $dd24b70aecfb840a$export$cc7b9d0b3ee23193,
        $dd24b70aecfb840a$export$585d3c004af078bb
    ];
    const $dd24b70aecfb840a$export$b7dc214eef214c1c = [
        $dd24b70aecfb840a$export$15f5b446ba8c941e
    ];
    const $dd24b70aecfb840a$export$184799fc79ccac89 = [
        ...$dd24b70aecfb840a$export$643c6101f3fc8547,
        ...$dd24b70aecfb840a$export$329664c9cf18cca6,
        ...$dd24b70aecfb840a$export$1b167a3705885a8b,
        ...$dd24b70aecfb840a$export$f25cf16c2270312f,
        ...$dd24b70aecfb840a$export$eb58cfffe4a6b805,
        ...$dd24b70aecfb840a$export$c22a981f581de218,
        ...$dd24b70aecfb840a$export$6d08c4699bb75284,
        ...$dd24b70aecfb840a$export$b7dc214eef214c1c
    ];
    const $dd24b70aecfb840a$export$77c793736847e030 = [
        $dd24b70aecfb840a$export$c4e3fb55e320e979,
        $dd24b70aecfb840a$export$f9857532eaa24ddc,
        $dd24b70aecfb840a$export$cc7b9d0b3ee23193,
        $dd24b70aecfb840a$export$585d3c004af078bb
    ];
});
parcelRegister("fSTjl", function(module, exports) {
    $parcel$export(module.exports, "operator", ()=>$f494227fb08190f4$export$dbd72860f701d4f3);
    $parcel$export(module.exports, "operatorInternal", ()=>$f494227fb08190f4$export$649025bc60ab9c3b);
    var $CNXg1;
    function $f494227fb08190f4$var$acceptOperator(visitor) {
        return visitor.visitOperator ? visitor.visitOperator(this) : visitor.visitChildren(this);
    }
    function $f494227fb08190f4$var$enterNode(listener) {
        listener.enterOperator && listener.enterOperator(this);
    }
    function $f494227fb08190f4$var$exitNode(listener) {
        listener.exitOperator && listener.exitOperator(this);
    }
    const $f494227fb08190f4$export$dbd72860f701d4f3 = (value)=>$f494227fb08190f4$export$649025bc60ab9c3b(value, value);
    const $f494227fb08190f4$export$649025bc60ab9c3b = (value, text, position = null)=>({
            text: text,
            value: value,
            position: position,
            accept: $f494227fb08190f4$var$acceptOperator,
            enterNode: $f494227fb08190f4$var$enterNode,
            exitNode: $f494227fb08190f4$var$exitNode,
            getChildren: (0, (0, parcelRequire("CNXg1")).noChildren),
            parent: null
        });
});
parcelRegister("ebUam", function(module, exports) {
    $parcel$export(module.exports, "orderBy", ()=>$4c615430cdcc6b94$export$f18af21d6f4dafd8);
    $parcel$export(module.exports, "orderByInternal", ()=>$4c615430cdcc6b94$export$e4eb1fa6bc8465c1);
    var $YPncX;
    var $CNXg1;
    var $bjh9t;
    function $4c615430cdcc6b94$var$acceptOrderBy(visitor) {
        return visitor.visitOrderBy ? visitor.visitOrderBy(this) : visitor.visitChildren(this);
    }
    function $4c615430cdcc6b94$var$enterNode(listener) {
        listener.enterOrderBy && listener.enterOrderBy(this);
    }
    function $4c615430cdcc6b94$var$exitNode(listener) {
        listener.exitOrderBy && listener.exitOrderBy(this);
    }
    function $4c615430cdcc6b94$var$getChildren() {
        return [
            this.operator,
            ...this.fields
        ];
    }
    const $4c615430cdcc6b94$export$f18af21d6f4dafd8 = (fields)=>{
        return $4c615430cdcc6b94$export$e4eb1fa6bc8465c1(fields, (0, (0, parcelRequire("bjh9t")).orderByOperator)());
    };
    const $4c615430cdcc6b94$export$e4eb1fa6bc8465c1 = (fields, operator, position = null)=>{
        const node = {
            type: (0, $98006e90dfac75d1$export$da0f73edded4a63d),
            operator: operator,
            fields: fields,
            position: position,
            accept: $4c615430cdcc6b94$var$acceptOrderBy,
            enterNode: $4c615430cdcc6b94$var$enterNode,
            exitNode: $4c615430cdcc6b94$var$exitNode,
            getChildren: $4c615430cdcc6b94$var$getChildren,
            parent: null,
            prependOrderField: (0, parcelRequire("YPncX")).prependOrderField,
            setOrderDirection: (0, parcelRequire("YPncX")).setOrderDirection,
            replace: (0, parcelRequire("YPncX")).replace,
            replaceOrderField: (0, parcelRequire("YPncX")).replaceOrderField,
            remove: (0, parcelRequire("YPncX")).remove,
            removeOrderField: (0, parcelRequire("YPncX")).removeOrderField
        };
        (0, (0, parcelRequire("CNXg1")).assignParent)(node);
        return node;
    };
});
parcelRegister("YPncX", function(module, exports) {
    $parcel$export(module.exports, "prependOrderField", ()=>prependOrderField);
    $parcel$export(module.exports, "setOrderDirection", ()=>setOrderDirection);
    $parcel$export(module.exports, "replace", ()=>replace);
    $parcel$export(module.exports, "replaceOrderField", ()=>replaceOrderField);
    $parcel$export(module.exports, "remove", ()=>remove);
    $parcel$export(module.exports, "removeOrderField", ()=>removeOrderField);
    var $CNXg1;
    function prependOrderField(orderField) {
        this.fields.unshift(orderField);
        (0, (0, parcelRequire("CNXg1")).assignParent)(this);
    }
    function setOrderDirection(orderDirection) {
        if (this.fields.length > 0) this.fields[0].setOrderDirection(orderDirection);
    }
    function replace(nextOrderBy) {
        if (this.parent) this.parent.replaceOrderBy(nextOrderBy);
    }
    function replaceOrderField(orderByField, nextOrderByField) {
        this.fields = this.fields.map((child)=>{
            return child === orderByField ? nextOrderByField : child;
        });
        (0, (0, parcelRequire("CNXg1")).assignParent)(this);
    }
    function remove() {
        if (this.parent) this.parent.removeOrderBy();
    }
    function removeOrderField(orderByField) {
        this.fields = this.fields.filter((field)=>field !== orderByField);
        if (this.fields.length === 0) this.remove();
    }
});
parcelRegister("bjh9t", function(module, exports) {
    $parcel$export(module.exports, "orderByOperator", ()=>$a4fbb616d2cc327b$export$c7307b67924c61ea);
    $parcel$export(module.exports, "orderByOperatorInternal", ()=>$a4fbb616d2cc327b$export$739e30af23a08da0);
    var $CNXg1;
    function $a4fbb616d2cc327b$var$acceptOrderByOperator(visitor) {
        return visitor.visitOrderByOperator ? visitor.visitOrderByOperator(this) : visitor.visitChildren(this);
    }
    function $a4fbb616d2cc327b$var$enterNode(listener) {
        listener.enterOrderByOperator && listener.enterOrderByOperator(this);
    }
    function $a4fbb616d2cc327b$var$exitNode(listener) {
        listener.exitOrderByOperator && listener.exitOrderByOperator(this);
    }
    const $a4fbb616d2cc327b$export$c7307b67924c61ea = ()=>$a4fbb616d2cc327b$export$739e30af23a08da0();
    const $a4fbb616d2cc327b$export$739e30af23a08da0 = (position = null)=>({
            value: (0, $bedc80c1e61c3512$export$ca51f5fd60a74517),
            position: position,
            accept: $a4fbb616d2cc327b$var$acceptOrderByOperator,
            enterNode: $a4fbb616d2cc327b$var$enterNode,
            exitNode: $a4fbb616d2cc327b$var$exitNode,
            getChildren: (0, (0, parcelRequire("CNXg1")).noChildren),
            parent: null
        });
});
const $bedc80c1e61c3512$export$ca51f5fd60a74517 = 'ORDER BY';
const $bedc80c1e61c3512$export$6d60017b9e092e73 = 'ASC';
const $bedc80c1e61c3512$export$2ea27ea5f2121899 = 'DESC';
parcelRegister("iffIw", function(module, exports) {
    $parcel$export(module.exports, "orderByDirection", ()=>$ff3479d70e5732d7$export$864d934efed3ccaa);
    $parcel$export(module.exports, "orderByDirectionInternal", ()=>$ff3479d70e5732d7$export$8c65cac1a7852d1f);
    var $CNXg1;
    function $ff3479d70e5732d7$var$acceptOrderByDirection(visitor) {
        return visitor.visitOrderByDirection ? visitor.visitOrderByDirection(this) : visitor.visitChildren(this);
    }
    function $ff3479d70e5732d7$var$enterNode(listener) {
        listener.enterOrderByDirection && listener.enterOrderByDirection(this);
    }
    function $ff3479d70e5732d7$var$exitNode(listener) {
        listener.exitOrderByDirection && listener.exitOrderByDirection(this);
    }
    const $ff3479d70e5732d7$export$864d934efed3ccaa = (value)=>$ff3479d70e5732d7$export$8c65cac1a7852d1f(value);
    const $ff3479d70e5732d7$export$8c65cac1a7852d1f = (value, position = null)=>({
            value: value,
            position: position,
            accept: $ff3479d70e5732d7$var$acceptOrderByDirection,
            enterNode: $ff3479d70e5732d7$var$enterNode,
            exitNode: $ff3479d70e5732d7$var$exitNode,
            getChildren: (0, (0, parcelRequire("CNXg1")).noChildren),
            parent: null
        });
});
parcelRegister("X9dfy", function(module, exports) {
    $parcel$export(module.exports, "orderByField", ()=>$3d9e6ea5c6c7cf63$export$942df63e5e3d3899);
    $parcel$export(module.exports, "orderByFieldInternal", ()=>$3d9e6ea5c6c7cf63$export$661a7786e3d15926);
    var $c71KZ;
    var $CNXg1;
    function $3d9e6ea5c6c7cf63$var$acceptOrderByField(visitor) {
        return visitor.visitOrderByField ? visitor.visitOrderByField(this) : visitor.visitChildren(this);
    }
    function $3d9e6ea5c6c7cf63$var$enterNode(listener) {
        listener.enterOrderByField && listener.enterOrderByField(this);
    }
    function $3d9e6ea5c6c7cf63$var$exitNode(listener) {
        listener.exitOrderByField && listener.exitOrderByField(this);
    }
    function $3d9e6ea5c6c7cf63$var$getChildren() {
        const children = [
            this.field
        ];
        if (this.direction) children.push(this.direction);
        return children;
    }
    const $3d9e6ea5c6c7cf63$export$942df63e5e3d3899 = (field, direction)=>$3d9e6ea5c6c7cf63$export$661a7786e3d15926(field, direction);
    const $3d9e6ea5c6c7cf63$export$661a7786e3d15926 = (field, direction, position = null)=>{
        const node = {
            field: field,
            direction: direction,
            position: position,
            accept: $3d9e6ea5c6c7cf63$var$acceptOrderByField,
            enterNode: $3d9e6ea5c6c7cf63$var$enterNode,
            exitNode: $3d9e6ea5c6c7cf63$var$exitNode,
            getChildren: $3d9e6ea5c6c7cf63$var$getChildren,
            parent: null,
            setOrderDirection: (0, parcelRequire("c71KZ")).setOrderDirection,
            replace: (0, parcelRequire("c71KZ")).replace,
            remove: (0, parcelRequire("c71KZ")).remove
        };
        (0, (0, parcelRequire("CNXg1")).assignParent)(node);
        return node;
    };
});
parcelRegister("c71KZ", function(module, exports) {
    $parcel$export(module.exports, "setOrderDirection", ()=>$7c382d364a2d67ad$export$b596730931a09703);
    $parcel$export(module.exports, "replace", ()=>$7c382d364a2d67ad$export$77ad94ebf1c2b9ed);
    $parcel$export(module.exports, "remove", ()=>$7c382d364a2d67ad$export$cd7f480d6b8286c3);
    var $CNXg1;
    function $7c382d364a2d67ad$export$b596730931a09703(orderDirection) {
        this.direction = orderDirection;
        (0, (0, parcelRequire("CNXg1")).assignParent)(this);
    }
    function $7c382d364a2d67ad$export$77ad94ebf1c2b9ed(orderByField) {
        if (this.parent) this.parent.replaceOrderField(this, orderByField);
    }
    function $7c382d364a2d67ad$export$cd7f480d6b8286c3() {
        if (this.parent) this.parent.removeOrderField(this);
    }
});
parcelRegister("bhtV2", function(module, exports) {
    $parcel$export(module.exports, "predicate", ()=>$1d0782ea37eee446$export$5fc51e445ce24faf);
    $parcel$export(module.exports, "predicateInternal", ()=>$1d0782ea37eee446$export$a767a27ad05a38a2);
    var $CNXg1;
    function $1d0782ea37eee446$var$acceptPredicate(visitor) {
        return visitor.visitPredicate ? visitor.visitPredicate(this) : visitor.visitChildren(this);
    }
    function $1d0782ea37eee446$var$enterNode(listener) {
        listener.enterPredicate && listener.enterPredicate(this);
    }
    function $1d0782ea37eee446$var$exitNode(listener) {
        listener.exitPredicate && listener.exitPredicate(this);
    }
    function $1d0782ea37eee446$var$getChildren() {
        const children = [
            this.operator
        ];
        if (this.operand) children.push(this.operand);
        return children;
    }
    const $1d0782ea37eee446$export$5fc51e445ce24faf = (operator, operand)=>$1d0782ea37eee446$export$a767a27ad05a38a2(operator, operand);
    const $1d0782ea37eee446$export$a767a27ad05a38a2 = (operator, operand, position = null)=>{
        const node = {
            operator: operator,
            operand: operand,
            position: position,
            accept: $1d0782ea37eee446$var$acceptPredicate,
            enterNode: $1d0782ea37eee446$var$enterNode,
            exitNode: $1d0782ea37eee446$var$exitNode,
            getChildren: $1d0782ea37eee446$var$getChildren,
            parent: null
        };
        (0, (0, parcelRequire("CNXg1")).assignParent)(node);
        return node;
    };
});
parcelRegister("kYJIR", function(module, exports) {
    $parcel$export(module.exports, "predicateOperator", ()=>$b7052c86c9611b83$export$5419b7f16910ea62);
    $parcel$export(module.exports, "predicateOperatorInternal", ()=>$b7052c86c9611b83$export$c69d893689716768);
    var $CNXg1;
    function $b7052c86c9611b83$var$acceptPredicateOperator(visitor) {
        return visitor.visitPredicateOperator ? visitor.visitPredicateOperator(this) : visitor.visitChildren(this);
    }
    function $b7052c86c9611b83$var$enterNode(listener) {
        listener.enterPredicateOperator && listener.enterPredicateOperator(this);
    }
    function $b7052c86c9611b83$var$exitNode(listener) {
        listener.exitPredicateOperator && listener.exitPredicateOperator(this);
    }
    const $b7052c86c9611b83$export$5419b7f16910ea62 = (value)=>$b7052c86c9611b83$export$c69d893689716768(value, value);
    const $b7052c86c9611b83$export$c69d893689716768 = (value, text, position = null)=>({
            text: text,
            value: value,
            position: position,
            accept: $b7052c86c9611b83$var$acceptPredicateOperator,
            enterNode: $b7052c86c9611b83$var$enterNode,
            exitNode: $b7052c86c9611b83$var$exitNode,
            getChildren: (0, (0, parcelRequire("CNXg1")).noChildren),
            parent: null
        });
});
parcelRegister("eE4GS", function(module, exports) {
    $parcel$export(module.exports, "property", ()=>$d6760832f453c767$export$d541bacb2bda4494);
    $parcel$export(module.exports, "propertyInternal", ()=>$d6760832f453c767$export$1cbd90994fef1fad);
    var $CNXg1;
    function $d6760832f453c767$var$acceptProperty(visitor) {
        return visitor.visitProperty ? visitor.visitProperty(this) : visitor.visitChildren(this);
    }
    function $d6760832f453c767$var$enterNode(listener) {
        listener.enterProperty && listener.enterProperty(this);
    }
    function $d6760832f453c767$var$exitNode(listener) {
        listener.exitProperty && listener.exitProperty(this);
    }
    function $d6760832f453c767$var$getChildren() {
        const children = [];
        if (this.key) children.push(this.key);
        if (this.path) return children.concat(this.path);
        return children;
    }
    const $d6760832f453c767$export$d541bacb2bda4494 = (key, path = [])=>$d6760832f453c767$export$1cbd90994fef1fad(key, path);
    const $d6760832f453c767$export$1cbd90994fef1fad = (key, path, position = null)=>{
        const node = {
            key: key,
            path: path,
            position: position,
            accept: $d6760832f453c767$var$acceptProperty,
            enterNode: $d6760832f453c767$var$enterNode,
            exitNode: $d6760832f453c767$var$exitNode,
            getChildren: $d6760832f453c767$var$getChildren,
            parent: null
        };
        (0, (0, parcelRequire("CNXg1")).assignParent)(node);
        return node;
    };
});
parcelRegister("1A2lV", function(module, exports) {
    $parcel$export(module.exports, "query", ()=>$994f1c773fe7c5e4$export$2fa187e846a241c4);
    $parcel$export(module.exports, "queryInternal", ()=>$994f1c773fe7c5e4$export$bc2d6e2e1fd9014);
    var $5pqgV;
    var $CNXg1;
    function $994f1c773fe7c5e4$var$acceptQuery(visitor) {
        return visitor.visitQuery ? visitor.visitQuery(this) : visitor.visitChildren(this);
    }
    function $994f1c773fe7c5e4$var$enterNode(listener) {
        listener.enterQuery && listener.enterQuery(this);
    }
    function $994f1c773fe7c5e4$var$exitNode(listener) {
        listener.exitQuery && listener.exitQuery(this);
    }
    function $994f1c773fe7c5e4$var$getChildren() {
        const children = [];
        if (this.where) children.push(this.where);
        if (this.orderBy) children.push(this.orderBy);
        return children;
    }
    const $994f1c773fe7c5e4$export$2fa187e846a241c4 = (where, orderBy)=>$994f1c773fe7c5e4$export$bc2d6e2e1fd9014(where, orderBy);
    const $994f1c773fe7c5e4$export$bc2d6e2e1fd9014 = (where, orderBy, position = null)=>{
        const node = {
            type: (0, $98006e90dfac75d1$export$98dda21ec825792),
            where: where,
            orderBy: orderBy,
            position: position,
            accept: $994f1c773fe7c5e4$var$acceptQuery,
            enterNode: $994f1c773fe7c5e4$var$enterNode,
            exitNode: $994f1c773fe7c5e4$var$exitNode,
            getChildren: $994f1c773fe7c5e4$var$getChildren,
            parent: null,
            appendClause: (0, parcelRequire("5pqgV")).appendClause,
            prependOrderField: (0, parcelRequire("5pqgV")).prependOrderField,
            setOrderDirection: (0, parcelRequire("5pqgV")).setOrderDirection,
            removeClause: (0, parcelRequire("5pqgV")).removeClause,
            replaceClause: (0, parcelRequire("5pqgV")).replaceClause,
            replaceOrderBy: (0, parcelRequire("5pqgV")).replaceOrderBy,
            removeOrderBy: (0, parcelRequire("5pqgV")).removeOrderBy
        };
        (0, (0, parcelRequire("CNXg1")).assignParent)(node);
        return node;
    };
});
parcelRegister("5pqgV", function(module, exports) {
    $parcel$export(module.exports, "appendClause", ()=>appendClause);
    $parcel$export(module.exports, "prependOrderField", ()=>prependOrderField);
    $parcel$export(module.exports, "setOrderDirection", ()=>setOrderDirection);
    $parcel$export(module.exports, "removeClause", ()=>removeClause);
    $parcel$export(module.exports, "replaceOrderBy", ()=>replaceOrderBy);
    $parcel$export(module.exports, "replaceClause", ()=>replaceClause);
    $parcel$export(module.exports, "removeOrderBy", ()=>removeOrderBy);
    var $jn8LC;
    var $CNXg1;
    function appendClause(clause, compoundOperatorValue) {
        if (!this.where) this.where = clause;
        else {
            const nextCompoundOperator = (0, (0, parcelRequire("jn8LC")).default).compoundOperator(compoundOperatorValue);
            const nextClause = (0, (0, parcelRequire("jn8LC")).default).compoundClause(nextCompoundOperator, []);
            nextClause.appendClause(this.where);
            nextClause.appendClause(clause);
            this.where = nextClause;
        }
        (0, (0, parcelRequire("CNXg1")).assignParent)(this);
    }
    function prependOrderField(orderField) {
        if (!this.orderBy) {
            this.orderBy = (0, (0, parcelRequire("jn8LC")).default).orderBy([
                orderField
            ]);
            (0, (0, parcelRequire("CNXg1")).assignParent)(this);
        } else this.orderBy.prependOrderField(orderField);
    }
    function setOrderDirection(orderDirection) {
        if (this.orderBy) this.orderBy.setOrderDirection(orderDirection);
    }
    function removeClause(clause) {
        if (this.where === clause) this.where = undefined;
    }
    function replaceOrderBy(orderBy) {
        if (orderBy && orderBy.fields.length === 0) this.removeOrderBy();
        else {
            this.orderBy = orderBy;
            (0, (0, parcelRequire("CNXg1")).assignParent)(this);
        }
    }
    function replaceClause(clause, nextClause) {
        if (this.where === clause) {
            this.where = nextClause;
            (0, (0, parcelRequire("CNXg1")).assignParent)(this);
        }
    }
    function removeOrderBy() {
        this.orderBy = undefined;
    }
});
parcelRegister("26wL6", function(module, exports) {
    $parcel$export(module.exports, "terminalClause", ()=>$1025fe2c08cc8c2e$export$2627cbe08dd86b00);
    $parcel$export(module.exports, "terminalClauseInternal", ()=>$1025fe2c08cc8c2e$export$cc08e43598d091fc);
    var $a6Xwe;
    var $CNXg1;
    function $1025fe2c08cc8c2e$var$acceptTerminalClause(visitor) {
        return visitor.visitTerminalClause ? visitor.visitTerminalClause(this) : visitor.visitChildren(this);
    }
    function $1025fe2c08cc8c2e$var$enterNode(listener) {
        listener.enterTerminalClause && listener.enterTerminalClause(this);
    }
    function $1025fe2c08cc8c2e$var$exitNode(listener) {
        listener.exitTerminalClause && listener.exitTerminalClause(this);
    }
    function $1025fe2c08cc8c2e$var$getChildren() {
        const children = [
            this.field
        ];
        if (this.operator) children.push(this.operator);
        if (this.operand) children.push(this.operand);
        return children.concat(this.predicates);
    }
    const $1025fe2c08cc8c2e$export$2627cbe08dd86b00 = (field, operator, operand, predicates = [])=>{
        return $1025fe2c08cc8c2e$export$cc08e43598d091fc(field, operator, operand, predicates);
    };
    const $1025fe2c08cc8c2e$export$cc08e43598d091fc = (field, operator, operand, predicates, position = null)=>{
        const node = {
            type: (0, $98006e90dfac75d1$export$2d205682cc545947),
            clauseType: (0, $0158eec8c0615e8c$export$ae56b4ef248a2b6a),
            field: field,
            operator: operator,
            operand: operand,
            predicates: predicates,
            position: position,
            accept: $1025fe2c08cc8c2e$var$acceptTerminalClause,
            enterNode: $1025fe2c08cc8c2e$var$enterNode,
            exitNode: $1025fe2c08cc8c2e$var$exitNode,
            getChildren: $1025fe2c08cc8c2e$var$getChildren,
            parent: null,
            setOperator: (0, parcelRequire("a6Xwe")).setOperator,
            setOperand: (0, parcelRequire("a6Xwe")).setOperand,
            appendOperand: (0, parcelRequire("a6Xwe")).appendOperand,
            remove: (0, parcelRequire("a6Xwe")).remove,
            replace: (0, parcelRequire("a6Xwe")).replace
        };
        (0, (0, parcelRequire("CNXg1")).assignParent)(node);
        return node;
    };
});
parcelRegister("a6Xwe", function(module, exports) {
    $parcel$export(module.exports, "setOperator", ()=>setOperator);
    $parcel$export(module.exports, "setOperand", ()=>setOperand);
    $parcel$export(module.exports, "appendOperand", ()=>appendOperand);
    $parcel$export(module.exports, "remove", ()=>remove);
    $parcel$export(module.exports, "replace", ()=>replace);
    var $jn8LC;
    var $CNXg1;
    function setOperator(operator) {
        this.operator = operator;
        (0, (0, parcelRequire("CNXg1")).assignParent)(this);
    }
    function setOperand(operand) {
        this.operand = operand;
        (0, (0, parcelRequire("CNXg1")).assignParent)(this);
    }
    function appendOperand(operand) {
        if (this.operand) {
            if (this.operand.operandType === (0, $230aa818ebdf534b$export$fabec4aebba3f4df)) this.operand.appendOperand(operand);
            else this.setOperand((0, (0, parcelRequire("jn8LC")).default).listOperand([
                this.operand,
                ...operand.operandType === (0, $230aa818ebdf534b$export$fabec4aebba3f4df) ? operand.values : [
                    operand
                ]
            ]));
        } else this.setOperand(operand);
    }
    function remove() {
        if (this.parent) this.parent.removeClause(this);
    }
    function replace(nextClause) {
        if (this.parent) this.parent.replaceClause(this, nextClause);
    }
});
parcelRegister("3YEV7", function(module, exports) {
    $parcel$export(module.exports, "valueOperand", ()=>$c27039e7f2bb2381$export$2b6e4d2ed8d53bf3);
    $parcel$export(module.exports, "valueOperandInternal", ()=>$c27039e7f2bb2381$export$79c37d97caac8627);
    $parcel$export(module.exports, "valueOperandByText", ()=>$c27039e7f2bb2381$export$3ac9155bde56a45f);
    var $7onwV;
    var $w8TY1;
    var $CNXg1;
    function $c27039e7f2bb2381$var$acceptValueOperand(visitor) {
        return visitor.visitValueOperand ? visitor.visitValueOperand(this) : visitor.visitChildren(this);
    }
    function $c27039e7f2bb2381$var$enterNode(listener) {
        listener.enterValueOperand && listener.enterValueOperand(this);
    }
    function $c27039e7f2bb2381$var$exitNode(listener) {
        listener.exitValueOperand && listener.exitValueOperand(this);
    }
    const $c27039e7f2bb2381$export$2b6e4d2ed8d53bf3 = (value)=>$c27039e7f2bb2381$export$79c37d97caac8627(value, (0, (0, parcelRequire("w8TY1")).sanitiseJqlString)(value));
    const $c27039e7f2bb2381$export$3ac9155bde56a45f = (text)=>$c27039e7f2bb2381$export$79c37d97caac8627((0, (0, parcelRequire("7onwV")).normaliseJqlString)(text), text);
    const $c27039e7f2bb2381$export$79c37d97caac8627 = (value, text, position = null)=>({
            type: (0, $98006e90dfac75d1$export$d2f212d8ddbc8d1d),
            operandType: (0, $230aa818ebdf534b$export$38accfc5a5d1c113),
            text: text,
            value: value,
            position: position,
            accept: $c27039e7f2bb2381$var$acceptValueOperand,
            enterNode: $c27039e7f2bb2381$var$enterNode,
            exitNode: $c27039e7f2bb2381$var$exitNode,
            getChildren: (0, (0, parcelRequire("CNXg1")).noChildren),
            parent: null
        });
});
parcelRegister("g6wXc", function(module, exports) {
    $parcel$export(module.exports, "print", ()=>$7548dc831fa46bfb$export$c2d084dc44961371);
    var $3NMrl = parcelRequire("3NMrl");
    var $gIeCu;
    var $aMHtb;
    const $7548dc831fa46bfb$export$c2d084dc44961371 = (jast, options = {})=>{
        return (0, (0, parcelRequire("aMHtb")).printDocToString)((0, (0, parcelRequire("gIeCu")).printAstToDoc)(jast, (0, ($parcel$interopDefault($3NMrl)))(options, [
            'operatorCase'
        ])), (0, ($parcel$interopDefault($3NMrl)))(options, [
            'printWidth'
        ]));
    };
});
parcelRegister("gIeCu", function(module, exports) {
    $parcel$export(module.exports, "printAstToDoc", ()=>$6e00fb5528191f78$export$f0ef38932978952);
    var $8rsat;
    var $3PpRH;
    const $6e00fb5528191f78$var$formatOperator = (operator, operatorCase)=>{
        switch(operatorCase){
            case 'lower':
                return operator.toLowerCase();
            case 'upper':
                return operator.toUpperCase();
            case 'preserve':
                return operator;
        }
    };
    class $6e00fb5528191f78$export$27a275559a5c8102 extends (0, (0, parcelRequire("8rsat")).AbstractJastVisitor) {
        constructor({ operatorCase: operatorCase } = {}){
            super();
            this.operatorCase = operatorCase || 'preserve';
        }
        visitArgument(argument) {
            return argument.text;
        }
        joinNodes(nodes, separator) {
            const docs = [];
            nodes.forEach((node)=>{
                if (separator !== undefined && docs.length > 0) docs.push(separator);
                docs.push(node.accept(this));
            });
            return docs;
        }
        visitCompoundClause(compoundClause) {
            const operatorDoc = compoundClause.operator.accept(this);
            const clauseDocs = [];
            compoundClause.clauses.forEach((clause)=>{
                if (clauseDocs.length > 0) clauseDocs.push((0, (0, parcelRequire("3PpRH")).ifBreak)((0, (0, parcelRequire("3PpRH")).newLine)(), ' '), operatorDoc, ' ');
                if (clause.clauseType === (0, $0158eec8c0615e8c$export$7a58b23488ea076b)) clauseDocs.push('(', clause.accept(this), ')');
                else clauseDocs.push(clause.accept(this));
            });
            return (0, (0, parcelRequire("3PpRH")).group)(clauseDocs);
        }
        visitCompoundOperator(compoundOperator) {
            return $6e00fb5528191f78$var$formatOperator(compoundOperator.value, this.operatorCase);
        }
        visitField(field) {
            const propertyDocs = field.properties ? this.joinNodes(field.properties) : [];
            return (0, (0, parcelRequire("3PpRH")).group)([
                field.text,
                ...propertyDocs
            ]);
        }
        visitFunction(functionString) {
            return functionString.text;
        }
        visitFunctionOperand(functionOperand) {
            const argumentDocs = this.joinNodes(functionOperand.arguments, ', ');
            return (0, (0, parcelRequire("3PpRH")).group)([
                functionOperand.function.accept(this),
                '(',
                ...argumentDocs,
                ')'
            ]);
        }
        visitKeywordOperand(keywordOperand) {
            return keywordOperand.value;
        }
        visitListOperand(listOperand) {
            const operandDocs = this.joinNodes(listOperand.values, ', ');
            return (0, (0, parcelRequire("3PpRH")).group)([
                '(',
                ...operandDocs,
                ')'
            ]);
        }
        visitOperator(operator) {
            return $6e00fb5528191f78$var$formatOperator(operator.text, this.operatorCase);
        }
        visitOrderBy(orderBy) {
            const fieldDocs = this.joinNodes(orderBy.fields, ', ');
            return (0, (0, parcelRequire("3PpRH")).group)([
                orderBy.operator.accept(this),
                ' ',
                ...fieldDocs
            ]);
        }
        visitOrderByDirection(orderByDirection) {
            return orderByDirection.value;
        }
        visitOrderByField(orderByField) {
            const docs = [
                orderByField.field.accept(this)
            ];
            if (orderByField.direction) docs.push(' ', orderByField.direction.accept(this));
            return (0, (0, parcelRequire("3PpRH")).group)(docs);
        }
        visitOrderByOperator(orderByOperator) {
            return $6e00fb5528191f78$var$formatOperator(orderByOperator.value, this.operatorCase);
        }
        visitPredicate(predicate) {
            const docs = [
                predicate.operator.accept(this)
            ];
            if (predicate.operand) docs.push(' ', predicate.operand.accept(this));
            return (0, (0, parcelRequire("3PpRH")).group)(docs);
        }
        visitPredicateOperator(predicateOperator) {
            return $6e00fb5528191f78$var$formatOperator(predicateOperator.text, this.operatorCase);
        }
        visitProperty(property) {
            const docs = [];
            if (property.key) docs.push('[', property.key.accept(this), ']');
            if (property.path) {
                const pathDocs = this.joinNodes(property.path, ' ');
                docs.push(...pathDocs);
            }
            return (0, (0, parcelRequire("3PpRH")).group)(docs);
        }
        visitQuery(query) {
            if (query.where && query.orderBy) return (0, (0, parcelRequire("3PpRH")).group)([
                query.where.accept(this),
                (0, (0, parcelRequire("3PpRH")).ifBreak)((0, (0, parcelRequire("3PpRH")).newLine)(), ' '),
                query.orderBy.accept(this)
            ]);
            else if (query.where) return query.where.accept(this);
            else if (query.orderBy) return query.orderBy.accept(this);
            return '';
        }
        visitTerminalClause(terminalClause) {
            const docs = [
                terminalClause.field.accept(this)
            ];
            if (terminalClause.operator) docs.push(' ', terminalClause.operator.accept(this));
            if (terminalClause.operand) docs.push(' ', terminalClause.operand.accept(this));
            terminalClause.predicates.forEach((predicate)=>{
                docs.push(' ', predicate.accept(this));
            });
            return (0, (0, parcelRequire("3PpRH")).group)(docs);
        }
        visitValueOperand(valueOperand) {
            return valueOperand.text;
        }
        visitNotClause(notClause) {
            const clauseDocs = [];
            if (notClause.clause.clauseType === (0, $0158eec8c0615e8c$export$7a58b23488ea076b)) clauseDocs.push('(', notClause.clause.accept(this), ')');
            else clauseDocs.push(notClause.clause.accept(this));
            return (0, (0, parcelRequire("3PpRH")).group)([
                notClause.operator.accept(this),
                ' ',
                ...clauseDocs
            ]);
        }
        visitNotClauseOperator(notClauseOperator) {
            return notClauseOperator.value;
        }
        visitChildren() {
            throw new Error('Required visit method not implemented for node');
        }
        defaultResult() {
            return '';
        }
    }
    const $6e00fb5528191f78$export$f0ef38932978952 = (jast, options)=>{
        const astToDocVisitor = new $6e00fb5528191f78$export$27a275559a5c8102(options);
        return jast.query ? jast.query.accept(astToDocVisitor) : '';
    };
});
parcelRegister("8rsat", function(module, exports) {
    $parcel$export(module.exports, "AbstractJastVisitor", ()=>$b13b9fee4ddc1bcf$export$51be62b46ee668fd);
    class $b13b9fee4ddc1bcf$export$51be62b46ee668fd {
        visit(node) {
            return node.accept(this);
        }
        visitChildren(node) {
            let result = this.defaultResult();
            const children = node.getChildren();
            for(let i = 0; i < children.length; i++){
                if (!this.shouldVisitNextChild(node, result)) break;
                const childResult = children[i].accept(this);
                result = this.aggregateResult(result, childResult);
            }
            return result;
        }
        aggregateResult(aggregate, nextResult) {
            return nextResult;
        }
        shouldVisitNextChild(node, currentResult) {
            return true;
        }
    }
});
parcelRegister("3PpRH", function(module, exports) {
    $parcel$export(module.exports, "group", ()=>$a355141a6b1ec326$export$e5e25fbcc1f7affe);
    $parcel$export(module.exports, "ifBreak", ()=>$a355141a6b1ec326$export$1db8e61901dcb0fa);
    $parcel$export(module.exports, "newLine", ()=>$a355141a6b1ec326$export$dc84f6841f96b7da);
    const $a355141a6b1ec326$export$e5e25fbcc1f7affe = (contents)=>{
        return {
            type: 'group',
            contents: contents
        };
    };
    const $a355141a6b1ec326$export$1db8e61901dcb0fa = (breakContents, flatContents)=>{
        return {
            type: 'if-break',
            breakContents: breakContents,
            flatContents: flatContents
        };
    };
    const $a355141a6b1ec326$export$dc84f6841f96b7da = ()=>{
        return {
            type: 'new-line'
        };
    };
});
parcelRegister("aMHtb", function(module, exports) {
    $parcel$export(module.exports, "printDocToString", ()=>$1fb9072b2ef4c8c8$export$316fc7e94b95b118);
    const $1fb9072b2ef4c8c8$var$computeFlatWidth = (doc)=>{
        if (typeof doc === 'string') return doc.length;
        if (Array.isArray(doc)) return doc.reduce((result, innerDoc)=>result + $1fb9072b2ef4c8c8$var$computeFlatWidth(innerDoc), 0);
        switch(doc.type){
            case 'group':
                return $1fb9072b2ef4c8c8$var$computeFlatWidth(doc.contents);
            case 'if-break':
                return $1fb9072b2ef4c8c8$var$computeFlatWidth(doc.flatContents);
            case 'new-line':
                return 0;
            default:
                throw new Error('Unrecognised doc type.');
        }
    };
    const $1fb9072b2ef4c8c8$var$printDoc = (doc, context)=>{
        if (typeof doc === 'string') return {
            result: doc,
            endIndex: context.startIndex + doc.length
        };
        switch(doc.type){
            case 'group':
                return $1fb9072b2ef4c8c8$var$printGroup(doc, context);
            case 'if-break':
                return $1fb9072b2ef4c8c8$var$printIfBreak(doc, context);
            case 'new-line':
                return $1fb9072b2ef4c8c8$var$printNewLine();
            default:
                throw new Error('Unrecognised doc type.');
        }
    };
    const $1fb9072b2ef4c8c8$var$printGroup = (doc, context)=>{
        const docWidth = context.startIndex + $1fb9072b2ef4c8c8$var$computeFlatWidth(doc);
        const breakContents = context.printWidth !== null && docWidth > context.printWidth;
        return doc.contents.reduce((agg, innerDoc)=>{
            const innerContext = {
                ...context,
                startIndex: agg.endIndex,
                breakContents: breakContents
            };
            const output = $1fb9072b2ef4c8c8$var$printDoc(innerDoc, innerContext);
            return {
                result: agg.result + output.result,
                endIndex: output.endIndex
            };
        }, {
            result: '',
            endIndex: context.startIndex
        });
    };
    const $1fb9072b2ef4c8c8$var$printIfBreak = (doc, context)=>{
        if (context.breakContents) return $1fb9072b2ef4c8c8$var$printDoc(doc.breakContents, context);
        return $1fb9072b2ef4c8c8$var$printDoc(doc.flatContents, context);
    };
    const $1fb9072b2ef4c8c8$var$printNewLine = ()=>{
        return {
            result: '\n',
            endIndex: 0
        };
    };
    const $1fb9072b2ef4c8c8$var$defaultPrintWidth = 100;
    const $1fb9072b2ef4c8c8$export$316fc7e94b95b118 = (doc, options = {})=>{
        const { printWidth: printWidth = $1fb9072b2ef4c8c8$var$defaultPrintWidth } = options;
        const output = $1fb9072b2ef4c8c8$var$printDoc(doc, {
            printWidth: printWidth,
            startIndex: 0,
            breakContents: false
        });
        return output.result;
    };
});
parcelRegister("7htvz", function(module, exports) {
    $parcel$export(module.exports, "OPTIMISTIC_ID", ()=>$d5b40c70d7e37442$export$6e40821019289c70);
    $parcel$export(module.exports, "CREATE_FILTER_EXPERIENCE", ()=>$d5b40c70d7e37442$export$d6ceedee35ae2c19);
    $parcel$export(module.exports, "UPDATE_FILTER_EXPERIENCE", ()=>$d5b40c70d7e37442$export$ca3691ea47eec823);
    $parcel$export(module.exports, "DELETE_FILTER_EXPERIENCE", ()=>$d5b40c70d7e37442$export$2a5fce320f18ac6c);
    $parcel$export(module.exports, "STAR_FILTER_EXPERIENCE", ()=>$d5b40c70d7e37442$export$b0ec8deb6068dc3b);
    $parcel$export(module.exports, "SAVED_FILTER_EXPERIENCE", ()=>$d5b40c70d7e37442$export$6c99c87a0ac0052a);
    $parcel$export(module.exports, "EMPTY_FILTER_VALUE", ()=>$d5b40c70d7e37442$export$9ebaf9fe814731d3);
    $parcel$export(module.exports, "SIMPLE_SEARCH_PARAM", ()=>$d5b40c70d7e37442$export$9b72011e2eb8d7d0);
    const $d5b40c70d7e37442$export$b8b9d90f9e5bd72b = 'jiraBusinessFilters';
    const $d5b40c70d7e37442$export$6e40821019289c70 = 'optimistic-filter-id';
    const $d5b40c70d7e37442$export$d6ceedee35ae2c19 = {
        experience: 'filtersCreateSavedFilters',
        packageName: $d5b40c70d7e37442$export$b8b9d90f9e5bd72b,
        teamName: 'wanjel'
    };
    const $d5b40c70d7e37442$export$ca3691ea47eec823 = {
        experience: 'filtersUpdateSavedFilters',
        packageName: $d5b40c70d7e37442$export$b8b9d90f9e5bd72b,
        teamName: 'wanjel'
    };
    const $d5b40c70d7e37442$export$2a5fce320f18ac6c = {
        experience: 'filtersDeleteSavedFilters',
        packageName: $d5b40c70d7e37442$export$b8b9d90f9e5bd72b,
        teamName: 'wanjel'
    };
    const $d5b40c70d7e37442$export$b0ec8deb6068dc3b = {
        experience: 'filtersStarSavedFilters',
        packageName: $d5b40c70d7e37442$export$b8b9d90f9e5bd72b,
        teamName: 'wanjel'
    };
    const $d5b40c70d7e37442$export$6c99c87a0ac0052a = {
        experience: 'filtersLoadSavedFilters',
        packageName: $d5b40c70d7e37442$export$b8b9d90f9e5bd72b,
        teamName: 'wanjel'
    };
    const $d5b40c70d7e37442$export$9ebaf9fe814731d3 = null;
    const $d5b40c70d7e37442$export$9b72011e2eb8d7d0 = 'text';
});
parcelRegister("1T1ir", function(module, exports) {
    $parcel$export(module.exports, "useSimpleSearch", ()=>$9ff55c3a873f98f5$export$b549f44e7ca96280);
    $parcel$export(module.exports, "useSimpleSearchHighlight", ()=>$9ff55c3a873f98f5$export$fd04dfca01137d2);
    $parcel$export(module.exports, "useSearchText", ()=>$9ff55c3a873f98f5$export$119186efd4186c93);
    $parcel$export(module.exports, "useSimpleSearchJQL", ()=>$9ff55c3a873f98f5$export$42b8d8a5ec5bc873);
    var $5uXOq = parcelRequire("5uXOq");
    var $9XS00;
    var $ieDtd;
    var $7htvz;
    const $9ff55c3a873f98f5$var$sanitize = (value)=>value.replace(/\\/g, '\\\\').replace(/'/g, "\\'").replace(/\t/g, ' ');
    const $9ff55c3a873f98f5$var$issueKeyRegex = new RegExp(`^${(0, (0, parcelRequire("9XS00")).ISSUEKEY_REGEX)}$`);
    const $9ff55c3a873f98f5$var$japaneseAndChineseRegex = /[\p{Script_Extensions=Hiragana}\p{Script_Extensions=Katakana}\p{Script_Extensions=Han}]/u;
    const $9ff55c3a873f98f5$export$b549f44e7ca96280 = ()=>{
        const [simpleSearch, persistSimpleSearch] = (0, (0, parcelRequire("ieDtd")).useQueryParam)((0, (0, parcelRequire("7htvz")).SIMPLE_SEARCH_PARAM));
        const setSimpleSearch = (0, $5uXOq.useCallback)((searchText)=>{
            searchText != null && searchText.trim() !== '' ? persistSimpleSearch(searchText) : persistSimpleSearch(undefined);
        }, [
            persistSimpleSearch
        ]);
        return [
            simpleSearch ?? '',
            setSimpleSearch
        ];
    };
    const $9ff55c3a873f98f5$export$72839f749ccf76b2 = (text)=>{
        if (text == null) return [];
        return text.split(' ').filter((word)=>word !== '');
    };
    const $9ff55c3a873f98f5$export$fd04dfca01137d2 = ()=>{
        const [simpleSearch] = $9ff55c3a873f98f5$export$b549f44e7ca96280();
        return (0, $5uXOq.useMemo)(()=>$9ff55c3a873f98f5$export$72839f749ccf76b2(simpleSearch), [
            simpleSearch
        ]);
    };
    const $9ff55c3a873f98f5$export$abb78553baf1cfac = (text)=>{
        if (text == null || text.trim() === '') return '';
        let search = $9ff55c3a873f98f5$var$sanitize(text);
        if ($9ff55c3a873f98f5$var$issueKeyRegex.test(text)) return `(summary ~ '${search}*' OR description ~ '${search}*' OR key = '${search}')`;
        if (!$9ff55c3a873f98f5$var$japaneseAndChineseRegex.test(text) && !text.endsWith(' ')) search = `${search}*`;
        return `(summary ~ '${search}' OR description ~ '${search}')`;
    };
    const $9ff55c3a873f98f5$export$119186efd4186c93 = (text)=>{
        const jql = (0, $5uXOq.useMemo)(()=>$9ff55c3a873f98f5$export$abb78553baf1cfac(text), [
            text
        ]);
        const highlight = (0, $5uXOq.useMemo)(()=>$9ff55c3a873f98f5$export$72839f749ccf76b2(text), [
            text
        ]);
        return {
            jql: jql,
            highlight: highlight
        };
    };
    const $9ff55c3a873f98f5$export$42b8d8a5ec5bc873 = ()=>{
        const [simpleSearch] = $9ff55c3a873f98f5$export$b549f44e7ca96280();
        const jql = (0, $5uXOq.useMemo)(()=>$9ff55c3a873f98f5$export$abb78553baf1cfac(simpleSearch), [
            simpleSearch
        ]);
        const addSimpleSearchToJQL = (0, $5uXOq.useCallback)((currentJQL)=>{
            if (jql === '') return currentJQL;
            if (currentJQL == null) return jql;
            return `${currentJQL} AND ${jql}`;
        }, [
            jql
        ]);
        return {
            jql: jql,
            isSearching: jql !== '',
            addSimpleSearchToJQL: addSimpleSearchToJQL
        };
    };
    var $9ff55c3a873f98f5$export$2e2bcd8739ae039 = $9ff55c3a873f98f5$export$b549f44e7ca96280;
});
parcelRegister("9XS00", function(module, exports) {
    $parcel$export(module.exports, "ISSUEKEY_REGEX", ()=>$76f8b51a225e9798$export$b52c9cee589449a8);
    $parcel$export(module.exports, "default", ()=>$76f8b51a225e9798$export$2e2bcd8739ae039);
    var $aZsz6 = parcelRequire("aZsz6");
    const $76f8b51a225e9798$export$b52c9cee589449a8 = '([A-Z][A-Z0-9_]+-\\d+)';
    var $76f8b51a225e9798$export$2e2bcd8739ae039 = (url, host)=>{
        const parsedUrl = (0, ($parcel$interopDefault($aZsz6)))(url, {});
        const isMatchingProtocol = parsedUrl.protocol === 'http:' || parsedUrl.protocol === 'https:';
        const isMatchingHost = parsedUrl.host === host;
        const matches = parsedUrl.pathname.match(new RegExp(`^\\/browse\\/${$76f8b51a225e9798$export$b52c9cee589449a8}\\/?$`));
        const issueKey = matches && matches.length > 1 ? matches[1] : null;
        return isMatchingProtocol && isMatchingHost && issueKey || null;
    };
});
parcelRegister("7VpiX", function(module, exports) {
    $parcel$export(module.exports, "sanitiseJql", ()=>$e5742a6c935cce4a$export$78c9a06ab18996fc);
    $parcel$export(module.exports, "getJqlErrors", ()=>$e5742a6c935cce4a$export$cc387523b0acb16d);
    var $6CCiu;
    var $g6wXc;
    const $e5742a6c935cce4a$export$78c9a06ab18996fc = (jql)=>{
        if (!jql) return jql;
        const builder = new (0, (0, parcelRequire("6CCiu")).JastBuilder)();
        const jast = builder.build(jql);
        if (jast.query && jast.query.orderBy) jast.query.orderBy = undefined;
        return (0, (0, parcelRequire("g6wXc")).print)(jast, {
            operatorCase: 'upper',
            printWidth: null
        });
    };
    const $e5742a6c935cce4a$export$cc387523b0acb16d = (jql)=>{
        if (!jql) return [];
        const builder = new (0, (0, parcelRequire("6CCiu")).JastBuilder)();
        const jast = builder.build(jql);
        return jast.errors;
    };
});
parcelRegister("6CCiu", function(module, exports) {
    $parcel$export(module.exports, "JastBuilder", ()=>$cbacbda12f71bad8$export$99cae18a5a6ba8cf);
    var $hCaMj = parcelRequire("hCaMj");
    var $8QpSo;
    var $hc3Z0;
    var $4qX9B;
    var $jn8LC;
    var $6vut6;
    var $fwZc8;
    var $g7xgB;
    class $cbacbda12f71bad8$export$99cae18a5a6ba8cf {
        setErrorHandler(errorHandler) {
            this.errorHandler = errorHandler;
            return this;
        }
        setErrorListeners(errorListeners) {
            this.errorListeners = this.errorListeners.concat(errorListeners);
            return this;
        }
        build(value) {
            const tokens = this.getTokens(value);
            const parser = this.getParser(tokens);
            const astErrorListener = new (0, (0, parcelRequire("6vut6")).JastBuilderErrorListener)();
            parser.removeErrorListeners();
            parser.addErrorListener(astErrorListener);
            this.errorListeners.forEach((errorListener)=>parser.addErrorListener(errorListener));
            if (this.errorHandler) {
                parser.errorHandler = this.errorHandler;
                this.errorHandler.reset(parser);
            }
            const visitor = new (0, (0, parcelRequire("g7xgB")).QueryVisitor)(tokens);
            try {
                const parseTree = parser.jqlQuery();
                const query = parseTree.accept(visitor);
                return (0, (0, parcelRequire("jn8LC")).default).jast(query, value, astErrorListener.errors);
            } catch (error) {
                return (0, (0, parcelRequire("jn8LC")).default).jast(undefined, value, [
                    new (0, (0, parcelRequire("fwZc8")).JQLParseError)(error.message, error)
                ]);
            }
        }
        constructor(){
            this.errorListeners = [];
            this.errorHandler = undefined;
            this.getTokens = (0, (0, parcelRequire("8QpSo")).default)((value)=>{
                const chars = (0, $hCaMj.CharStreams).fromString(value);
                const lexer = new (0, (0, parcelRequire("hc3Z0")).JQLLexer)(chars);
                return new (0, $hCaMj.CommonTokenStream)(lexer);
            });
            this.getParser = (0, (0, parcelRequire("8QpSo")).default)((tokens)=>new (0, (0, parcelRequire("4qX9B")).JQLParser)(tokens));
        }
    }
});
parcelRegister("hCaMj", function(module, exports) {
    "use strict";
    var $cd2e58a1d1fa972f$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
        if (k2 === undefined) k2 = k;
        Object.defineProperty(o, k2, {
            enumerable: true,
            get: function() {
                return m[k];
            }
        });
    } : function(o, m, k, k2) {
        if (k2 === undefined) k2 = k;
        o[k2] = m[k];
    });
    var $cd2e58a1d1fa972f$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
        for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $cd2e58a1d1fa972f$var$__createBinding(exports1, m, p);
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("fJ9SA")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("1lYFk")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("g8XSE")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("b0kN8")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("1UkCC")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("QidO0")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("9NnFz")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("1Olk0")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("7ufNj")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("j53rr")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("gWaB3")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("a0nC0")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("e5mHr")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("4CCJj")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("4a3G0")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("5Poq6")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("ea0YW")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("iLUMi")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("5FrZ8")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("ceaEj")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("igNLf")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("gMbxO")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("fOEQQ")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("drCaH")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("hKCjP")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("jIG0W")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("2pQQd")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("dReoi")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("6bmaO")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("65iNZ")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("5xwgp")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("fLdDn")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("kBaAZ")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("c8jEe")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("77rdV")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("5IgvW")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("1ivK9")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("2DVsz")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("eftJA")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("9rAj4")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("5jPdD")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("dIykH")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("1MVGg")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("3n2FE")), module.exports);
    $cd2e58a1d1fa972f$var$__exportStar((parcelRequire("6UcB4")), module.exports);
});
parcelRegister("fJ9SA", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
});
parcelRegister("1lYFk", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
});
parcelRegister("g8XSE", function(module, exports) {
    "use strict";
    var $bc0bd7b6659a2632$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ANTLRInputStream = void 0;
    var $bbHFU = parcelRequire("bbHFU");
    var $d6D31 = parcelRequire("d6D31");
    var $ceaEj = parcelRequire("ceaEj");
    const $bc0bd7b6659a2632$var$READ_BUFFER_SIZE = 1024;
    const $bc0bd7b6659a2632$var$INITIAL_BUFFER_SIZE = 1024;
    class $bc0bd7b6659a2632$var$ANTLRInputStream {
        constructor(input){
            this.p = 0;
            this.data = input;
            this.n = input.length;
        }
        reset() {
            this.p = 0;
        }
        consume() {
            if (this.p >= this.n) {
                $bbHFU(this.LA(1) === $ceaEj.IntStream.EOF);
                throw new Error("cannot consume EOF");
            }
            if (this.p < this.n) this.p++;
        }
        LA(i) {
            if (i === 0) return 0;
            if (i < 0) {
                i++;
                if (this.p + i - 1 < 0) return $ceaEj.IntStream.EOF;
            }
            if (this.p + i - 1 >= this.n) return $ceaEj.IntStream.EOF;
            return this.data.charCodeAt(this.p + i - 1);
        }
        LT(i) {
            return this.LA(i);
        }
        get index() {
            return this.p;
        }
        get size() {
            return this.n;
        }
        mark() {
            return -1;
        }
        release(marker) {}
        seek(index) {
            if (index <= this.p) {
                this.p = index;
                return;
            }
            index = Math.min(index, this.n);
            while(this.p < index)this.consume();
        }
        getText(interval) {
            let start = interval.a;
            let stop = interval.b;
            if (stop >= this.n) stop = this.n - 1;
            let count = stop - start + 1;
            if (start >= this.n) return "";
            return this.data.substr(start, count);
        }
        get sourceName() {
            if (!this.name) return $ceaEj.IntStream.UNKNOWN_SOURCE_NAME;
            return this.name;
        }
        toString() {
            return this.data;
        }
    }
    $bc0bd7b6659a2632$var$__decorate([
        $d6D31.Override
    ], $bc0bd7b6659a2632$var$ANTLRInputStream.prototype, "consume", null);
    $bc0bd7b6659a2632$var$__decorate([
        $d6D31.Override
    ], $bc0bd7b6659a2632$var$ANTLRInputStream.prototype, "LA", null);
    $bc0bd7b6659a2632$var$__decorate([
        $d6D31.Override
    ], $bc0bd7b6659a2632$var$ANTLRInputStream.prototype, "index", null);
    $bc0bd7b6659a2632$var$__decorate([
        $d6D31.Override
    ], $bc0bd7b6659a2632$var$ANTLRInputStream.prototype, "size", null);
    $bc0bd7b6659a2632$var$__decorate([
        $d6D31.Override
    ], $bc0bd7b6659a2632$var$ANTLRInputStream.prototype, "mark", null);
    $bc0bd7b6659a2632$var$__decorate([
        $d6D31.Override
    ], $bc0bd7b6659a2632$var$ANTLRInputStream.prototype, "release", null);
    $bc0bd7b6659a2632$var$__decorate([
        $d6D31.Override
    ], $bc0bd7b6659a2632$var$ANTLRInputStream.prototype, "seek", null);
    $bc0bd7b6659a2632$var$__decorate([
        $d6D31.Override
    ], $bc0bd7b6659a2632$var$ANTLRInputStream.prototype, "getText", null);
    $bc0bd7b6659a2632$var$__decorate([
        $d6D31.Override
    ], $bc0bd7b6659a2632$var$ANTLRInputStream.prototype, "sourceName", null);
    $bc0bd7b6659a2632$var$__decorate([
        $d6D31.Override
    ], $bc0bd7b6659a2632$var$ANTLRInputStream.prototype, "toString", null);
    module.exports.ANTLRInputStream = $bc0bd7b6659a2632$var$ANTLRInputStream;
});
parcelRegister("bbHFU", function(module, exports) {
    var $6cAn5 = parcelRequire("6cAn5");
    'use strict';
    function $825299b5d0c0a9a5$var$_typeof(o) {
        "@babel/helpers - typeof";
        return $825299b5d0c0a9a5$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
            return typeof o;
        } : function(o) {
            return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
        }, $825299b5d0c0a9a5$var$_typeof(o);
    }
    function $825299b5d0c0a9a5$var$_defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, $825299b5d0c0a9a5$var$_toPropertyKey(descriptor.key), descriptor);
        }
    }
    function $825299b5d0c0a9a5$var$_createClass(Constructor, protoProps, staticProps) {
        if (protoProps) $825299b5d0c0a9a5$var$_defineProperties(Constructor.prototype, protoProps);
        if (staticProps) $825299b5d0c0a9a5$var$_defineProperties(Constructor, staticProps);
        Object.defineProperty(Constructor, "prototype", {
            writable: false
        });
        return Constructor;
    }
    function $825299b5d0c0a9a5$var$_toPropertyKey(arg) {
        var key = $825299b5d0c0a9a5$var$_toPrimitive(arg, "string");
        return $825299b5d0c0a9a5$var$_typeof(key) === "symbol" ? key : String(key);
    }
    function $825299b5d0c0a9a5$var$_toPrimitive(input, hint) {
        if ($825299b5d0c0a9a5$var$_typeof(input) !== "object" || input === null) return input;
        var prim = input[Symbol.toPrimitive];
        if (prim !== undefined) {
            var res = prim.call(input, hint || "default");
            if ($825299b5d0c0a9a5$var$_typeof(res) !== "object") return res;
            throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (hint === "string" ? String : Number)(input);
    }
    function $825299b5d0c0a9a5$var$_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    var $8JAro = parcelRequire("8JAro");
    var $825299b5d0c0a9a5$var$_require$codes = $8JAro.codes, $825299b5d0c0a9a5$var$ERR_AMBIGUOUS_ARGUMENT = $825299b5d0c0a9a5$var$_require$codes.ERR_AMBIGUOUS_ARGUMENT, $825299b5d0c0a9a5$var$ERR_INVALID_ARG_TYPE = $825299b5d0c0a9a5$var$_require$codes.ERR_INVALID_ARG_TYPE, $825299b5d0c0a9a5$var$ERR_INVALID_ARG_VALUE = $825299b5d0c0a9a5$var$_require$codes.ERR_INVALID_ARG_VALUE, $825299b5d0c0a9a5$var$ERR_INVALID_RETURN_VALUE = $825299b5d0c0a9a5$var$_require$codes.ERR_INVALID_RETURN_VALUE, $825299b5d0c0a9a5$var$ERR_MISSING_ARGS = $825299b5d0c0a9a5$var$_require$codes.ERR_MISSING_ARGS;
    var $3ZLjA = parcelRequire("3ZLjA");
    var $9kAQu = parcelRequire("9kAQu");
    var $825299b5d0c0a9a5$var$inspect = $9kAQu.inspect;
    var $9kAQu = parcelRequire("9kAQu");
    var $825299b5d0c0a9a5$require$_require$types = $9kAQu.types;
    var $825299b5d0c0a9a5$var$isPromise = $825299b5d0c0a9a5$require$_require$types.isPromise, $825299b5d0c0a9a5$var$isRegExp = $825299b5d0c0a9a5$require$_require$types.isRegExp;
    var $825299b5d0c0a9a5$var$objectAssign = (parcelRequire("8s5ew"))();
    var $825299b5d0c0a9a5$var$objectIs = (parcelRequire("eJazH"))();
    var $825299b5d0c0a9a5$var$RegExpPrototypeTest = (parcelRequire("53KqO"))('RegExp.prototype.test');
    var $825299b5d0c0a9a5$var$errorCache = new Map();
    var $825299b5d0c0a9a5$var$isDeepEqual;
    var $825299b5d0c0a9a5$var$isDeepStrictEqual;
    var $825299b5d0c0a9a5$var$parseExpressionAt;
    var $825299b5d0c0a9a5$var$findNodeAround;
    var $825299b5d0c0a9a5$var$decoder;
    function $825299b5d0c0a9a5$var$lazyLoadComparison() {
        var comparison = (parcelRequire("dztjv"));
        $825299b5d0c0a9a5$var$isDeepEqual = comparison.isDeepEqual;
        $825299b5d0c0a9a5$var$isDeepStrictEqual = comparison.isDeepStrictEqual;
    }
    var $825299b5d0c0a9a5$var$escapeSequencesRegExp = /[\x00-\x08\x0b\x0c\x0e-\x1f]/g;
    var $825299b5d0c0a9a5$var$meta = [
        "\\u0000",
        "\\u0001",
        "\\u0002",
        "\\u0003",
        "\\u0004",
        "\\u0005",
        "\\u0006",
        "\\u0007",
        '\\b',
        '',
        '',
        "\\u000b",
        '\\f',
        '',
        "\\u000e",
        "\\u000f",
        "\\u0010",
        "\\u0011",
        "\\u0012",
        "\\u0013",
        "\\u0014",
        "\\u0015",
        "\\u0016",
        "\\u0017",
        "\\u0018",
        "\\u0019",
        "\\u001a",
        "\\u001b",
        "\\u001c",
        "\\u001d",
        "\\u001e",
        "\\u001f"
    ];
    var $825299b5d0c0a9a5$var$escapeFn = function escapeFn(str) {
        return $825299b5d0c0a9a5$var$meta[str.charCodeAt(0)];
    };
    var $825299b5d0c0a9a5$var$warned = false;
    var $825299b5d0c0a9a5$var$assert = module.exports = $825299b5d0c0a9a5$var$ok;
    var $825299b5d0c0a9a5$var$NO_EXCEPTION_SENTINEL = {};
    function $825299b5d0c0a9a5$var$innerFail(obj) {
        if (obj.message instanceof Error) throw obj.message;
        throw new $3ZLjA(obj);
    }
    function $825299b5d0c0a9a5$var$fail(actual, expected, message, operator, stackStartFn) {
        var argsLen = arguments.length;
        var internalMessage;
        if (argsLen === 0) internalMessage = 'Failed';
        else if (argsLen === 1) {
            message = actual;
            actual = undefined;
        } else {
            if ($825299b5d0c0a9a5$var$warned === false) {
                $825299b5d0c0a9a5$var$warned = true;
                var warn = $6cAn5.emitWarning ? $6cAn5.emitWarning : console.warn.bind(console);
                warn("assert.fail() with more than one argument is deprecated. Please use assert.strictEqual() instead or only pass a message.", 'DeprecationWarning', 'DEP0094');
            }
            if (argsLen === 2) operator = '!=';
        }
        if (message instanceof Error) throw message;
        var errArgs = {
            actual: actual,
            expected: expected,
            operator: operator === undefined ? 'fail' : operator,
            stackStartFn: stackStartFn || $825299b5d0c0a9a5$var$fail
        };
        if (message !== undefined) errArgs.message = message;
        var err = new $3ZLjA(errArgs);
        if (internalMessage) {
            err.message = internalMessage;
            err.generatedMessage = true;
        }
        throw err;
    }
    $825299b5d0c0a9a5$var$assert.fail = $825299b5d0c0a9a5$var$fail;
    $825299b5d0c0a9a5$var$assert.AssertionError = $3ZLjA;
    function $825299b5d0c0a9a5$var$innerOk(fn, argLen, value, message) {
        if (!value) {
            var generatedMessage = false;
            if (argLen === 0) {
                generatedMessage = true;
                message = 'No value argument passed to `assert.ok()`';
            } else if (message instanceof Error) throw message;
            var err = new $3ZLjA({
                actual: value,
                expected: true,
                message: message,
                operator: '==',
                stackStartFn: fn
            });
            err.generatedMessage = generatedMessage;
            throw err;
        }
    }
    function $825299b5d0c0a9a5$var$ok() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        $825299b5d0c0a9a5$var$innerOk.apply(void 0, [
            $825299b5d0c0a9a5$var$ok,
            args.length
        ].concat(args));
    }
    $825299b5d0c0a9a5$var$assert.ok = $825299b5d0c0a9a5$var$ok;
    $825299b5d0c0a9a5$var$assert.equal = function equal(actual, expected, message) {
        if (arguments.length < 2) throw new $825299b5d0c0a9a5$var$ERR_MISSING_ARGS('actual', 'expected');
        if (actual != expected) $825299b5d0c0a9a5$var$innerFail({
            actual: actual,
            expected: expected,
            message: message,
            operator: '==',
            stackStartFn: equal
        });
    };
    $825299b5d0c0a9a5$var$assert.notEqual = function notEqual(actual, expected, message) {
        if (arguments.length < 2) throw new $825299b5d0c0a9a5$var$ERR_MISSING_ARGS('actual', 'expected');
        if (actual == expected) $825299b5d0c0a9a5$var$innerFail({
            actual: actual,
            expected: expected,
            message: message,
            operator: '!=',
            stackStartFn: notEqual
        });
    };
    $825299b5d0c0a9a5$var$assert.deepEqual = function deepEqual(actual, expected, message) {
        if (arguments.length < 2) throw new $825299b5d0c0a9a5$var$ERR_MISSING_ARGS('actual', 'expected');
        if ($825299b5d0c0a9a5$var$isDeepEqual === undefined) $825299b5d0c0a9a5$var$lazyLoadComparison();
        if (!$825299b5d0c0a9a5$var$isDeepEqual(actual, expected)) $825299b5d0c0a9a5$var$innerFail({
            actual: actual,
            expected: expected,
            message: message,
            operator: 'deepEqual',
            stackStartFn: deepEqual
        });
    };
    $825299b5d0c0a9a5$var$assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
        if (arguments.length < 2) throw new $825299b5d0c0a9a5$var$ERR_MISSING_ARGS('actual', 'expected');
        if ($825299b5d0c0a9a5$var$isDeepEqual === undefined) $825299b5d0c0a9a5$var$lazyLoadComparison();
        if ($825299b5d0c0a9a5$var$isDeepEqual(actual, expected)) $825299b5d0c0a9a5$var$innerFail({
            actual: actual,
            expected: expected,
            message: message,
            operator: 'notDeepEqual',
            stackStartFn: notDeepEqual
        });
    };
    $825299b5d0c0a9a5$var$assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
        if (arguments.length < 2) throw new $825299b5d0c0a9a5$var$ERR_MISSING_ARGS('actual', 'expected');
        if ($825299b5d0c0a9a5$var$isDeepEqual === undefined) $825299b5d0c0a9a5$var$lazyLoadComparison();
        if (!$825299b5d0c0a9a5$var$isDeepStrictEqual(actual, expected)) $825299b5d0c0a9a5$var$innerFail({
            actual: actual,
            expected: expected,
            message: message,
            operator: 'deepStrictEqual',
            stackStartFn: deepStrictEqual
        });
    };
    $825299b5d0c0a9a5$var$assert.notDeepStrictEqual = $825299b5d0c0a9a5$var$notDeepStrictEqual;
    function $825299b5d0c0a9a5$var$notDeepStrictEqual(actual, expected, message) {
        if (arguments.length < 2) throw new $825299b5d0c0a9a5$var$ERR_MISSING_ARGS('actual', 'expected');
        if ($825299b5d0c0a9a5$var$isDeepEqual === undefined) $825299b5d0c0a9a5$var$lazyLoadComparison();
        if ($825299b5d0c0a9a5$var$isDeepStrictEqual(actual, expected)) $825299b5d0c0a9a5$var$innerFail({
            actual: actual,
            expected: expected,
            message: message,
            operator: 'notDeepStrictEqual',
            stackStartFn: $825299b5d0c0a9a5$var$notDeepStrictEqual
        });
    }
    $825299b5d0c0a9a5$var$assert.strictEqual = function strictEqual(actual, expected, message) {
        if (arguments.length < 2) throw new $825299b5d0c0a9a5$var$ERR_MISSING_ARGS('actual', 'expected');
        if (!$825299b5d0c0a9a5$var$objectIs(actual, expected)) $825299b5d0c0a9a5$var$innerFail({
            actual: actual,
            expected: expected,
            message: message,
            operator: 'strictEqual',
            stackStartFn: strictEqual
        });
    };
    $825299b5d0c0a9a5$var$assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
        if (arguments.length < 2) throw new $825299b5d0c0a9a5$var$ERR_MISSING_ARGS('actual', 'expected');
        if ($825299b5d0c0a9a5$var$objectIs(actual, expected)) $825299b5d0c0a9a5$var$innerFail({
            actual: actual,
            expected: expected,
            message: message,
            operator: 'notStrictEqual',
            stackStartFn: notStrictEqual
        });
    };
    var $825299b5d0c0a9a5$var$Comparison = $825299b5d0c0a9a5$var$_createClass(function Comparison(obj, keys, actual) {
        var _this = this;
        $825299b5d0c0a9a5$var$_classCallCheck(this, Comparison);
        keys.forEach(function(key) {
            if (key in obj) {
                if (actual !== undefined && typeof actual[key] === 'string' && $825299b5d0c0a9a5$var$isRegExp(obj[key]) && $825299b5d0c0a9a5$var$RegExpPrototypeTest(obj[key], actual[key])) _this[key] = actual[key];
                else _this[key] = obj[key];
            }
        });
    });
    function $825299b5d0c0a9a5$var$compareExceptionKey(actual, expected, key, message, keys, fn) {
        if (!(key in actual) || !$825299b5d0c0a9a5$var$isDeepStrictEqual(actual[key], expected[key])) {
            if (!message) {
                var a = new $825299b5d0c0a9a5$var$Comparison(actual, keys);
                var b = new $825299b5d0c0a9a5$var$Comparison(expected, keys, actual);
                var err = new $3ZLjA({
                    actual: a,
                    expected: b,
                    operator: 'deepStrictEqual',
                    stackStartFn: fn
                });
                err.actual = actual;
                err.expected = expected;
                err.operator = fn.name;
                throw err;
            }
            $825299b5d0c0a9a5$var$innerFail({
                actual: actual,
                expected: expected,
                message: message,
                operator: fn.name,
                stackStartFn: fn
            });
        }
    }
    function $825299b5d0c0a9a5$var$expectedException(actual, expected, msg, fn) {
        if (typeof expected !== 'function') {
            if ($825299b5d0c0a9a5$var$isRegExp(expected)) return $825299b5d0c0a9a5$var$RegExpPrototypeTest(expected, actual);
            if (arguments.length === 2) throw new $825299b5d0c0a9a5$var$ERR_INVALID_ARG_TYPE('expected', [
                'Function',
                'RegExp'
            ], expected);
            if ($825299b5d0c0a9a5$var$_typeof(actual) !== 'object' || actual === null) {
                var err = new $3ZLjA({
                    actual: actual,
                    expected: expected,
                    message: msg,
                    operator: 'deepStrictEqual',
                    stackStartFn: fn
                });
                err.operator = fn.name;
                throw err;
            }
            var keys = Object.keys(expected);
            if (expected instanceof Error) keys.push('name', 'message');
            else if (keys.length === 0) throw new $825299b5d0c0a9a5$var$ERR_INVALID_ARG_VALUE('error', expected, 'may not be an empty object');
            if ($825299b5d0c0a9a5$var$isDeepEqual === undefined) $825299b5d0c0a9a5$var$lazyLoadComparison();
            keys.forEach(function(key) {
                if (typeof actual[key] === 'string' && $825299b5d0c0a9a5$var$isRegExp(expected[key]) && $825299b5d0c0a9a5$var$RegExpPrototypeTest(expected[key], actual[key])) return;
                $825299b5d0c0a9a5$var$compareExceptionKey(actual, expected, key, msg, keys, fn);
            });
            return true;
        }
        if (expected.prototype !== undefined && actual instanceof expected) return true;
        if (Error.isPrototypeOf(expected)) return false;
        return expected.call({}, actual) === true;
    }
    function $825299b5d0c0a9a5$var$getActual(fn) {
        if (typeof fn !== 'function') throw new $825299b5d0c0a9a5$var$ERR_INVALID_ARG_TYPE('fn', 'Function', fn);
        try {
            fn();
        } catch (e) {
            return e;
        }
        return $825299b5d0c0a9a5$var$NO_EXCEPTION_SENTINEL;
    }
    function $825299b5d0c0a9a5$var$checkIsPromise(obj) {
        return $825299b5d0c0a9a5$var$isPromise(obj) || obj !== null && $825299b5d0c0a9a5$var$_typeof(obj) === 'object' && typeof obj.then === 'function' && typeof obj.catch === 'function';
    }
    function $825299b5d0c0a9a5$var$waitForActual(promiseFn) {
        return Promise.resolve().then(function() {
            var resultPromise;
            if (typeof promiseFn === 'function') {
                resultPromise = promiseFn();
                if (!$825299b5d0c0a9a5$var$checkIsPromise(resultPromise)) throw new $825299b5d0c0a9a5$var$ERR_INVALID_RETURN_VALUE('instance of Promise', 'promiseFn', resultPromise);
            } else if ($825299b5d0c0a9a5$var$checkIsPromise(promiseFn)) resultPromise = promiseFn;
            else throw new $825299b5d0c0a9a5$var$ERR_INVALID_ARG_TYPE('promiseFn', [
                'Function',
                'Promise'
            ], promiseFn);
            return Promise.resolve().then(function() {
                return resultPromise;
            }).then(function() {
                return $825299b5d0c0a9a5$var$NO_EXCEPTION_SENTINEL;
            }).catch(function(e) {
                return e;
            });
        });
    }
    function $825299b5d0c0a9a5$var$expectsError(stackStartFn, actual, error, message) {
        if (typeof error === 'string') {
            if (arguments.length === 4) throw new $825299b5d0c0a9a5$var$ERR_INVALID_ARG_TYPE('error', [
                'Object',
                'Error',
                'Function',
                'RegExp'
            ], error);
            if ($825299b5d0c0a9a5$var$_typeof(actual) === 'object' && actual !== null) {
                if (actual.message === error) throw new $825299b5d0c0a9a5$var$ERR_AMBIGUOUS_ARGUMENT('error/message', "The error message \"".concat(actual.message, "\" is identical to the message."));
            } else if (actual === error) throw new $825299b5d0c0a9a5$var$ERR_AMBIGUOUS_ARGUMENT('error/message', "The error \"".concat(actual, "\" is identical to the message."));
            message = error;
            error = undefined;
        } else if (error != null && $825299b5d0c0a9a5$var$_typeof(error) !== 'object' && typeof error !== 'function') throw new $825299b5d0c0a9a5$var$ERR_INVALID_ARG_TYPE('error', [
            'Object',
            'Error',
            'Function',
            'RegExp'
        ], error);
        if (actual === $825299b5d0c0a9a5$var$NO_EXCEPTION_SENTINEL) {
            var details = '';
            if (error && error.name) details += " (".concat(error.name, ")");
            details += message ? ": ".concat(message) : '.';
            var fnType = stackStartFn.name === 'rejects' ? 'rejection' : 'exception';
            $825299b5d0c0a9a5$var$innerFail({
                actual: undefined,
                expected: error,
                operator: stackStartFn.name,
                message: "Missing expected ".concat(fnType).concat(details),
                stackStartFn: stackStartFn
            });
        }
        if (error && !$825299b5d0c0a9a5$var$expectedException(actual, error, message, stackStartFn)) throw actual;
    }
    function $825299b5d0c0a9a5$var$expectsNoError(stackStartFn, actual, error, message) {
        if (actual === $825299b5d0c0a9a5$var$NO_EXCEPTION_SENTINEL) return;
        if (typeof error === 'string') {
            message = error;
            error = undefined;
        }
        if (!error || $825299b5d0c0a9a5$var$expectedException(actual, error)) {
            var details = message ? ": ".concat(message) : '.';
            var fnType = stackStartFn.name === 'doesNotReject' ? 'rejection' : 'exception';
            $825299b5d0c0a9a5$var$innerFail({
                actual: actual,
                expected: error,
                operator: stackStartFn.name,
                message: "Got unwanted ".concat(fnType).concat(details, "\n") + "Actual message: \"".concat(actual && actual.message, "\""),
                stackStartFn: stackStartFn
            });
        }
        throw actual;
    }
    $825299b5d0c0a9a5$var$assert.throws = function throws(promiseFn) {
        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
        $825299b5d0c0a9a5$var$expectsError.apply(void 0, [
            throws,
            $825299b5d0c0a9a5$var$getActual(promiseFn)
        ].concat(args));
    };
    $825299b5d0c0a9a5$var$assert.rejects = function rejects(promiseFn) {
        for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
        return $825299b5d0c0a9a5$var$waitForActual(promiseFn).then(function(result) {
            return $825299b5d0c0a9a5$var$expectsError.apply(void 0, [
                rejects,
                result
            ].concat(args));
        });
    };
    $825299b5d0c0a9a5$var$assert.doesNotThrow = function doesNotThrow(fn) {
        for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
        $825299b5d0c0a9a5$var$expectsNoError.apply(void 0, [
            doesNotThrow,
            $825299b5d0c0a9a5$var$getActual(fn)
        ].concat(args));
    };
    $825299b5d0c0a9a5$var$assert.doesNotReject = function doesNotReject(fn) {
        for(var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++)args[_key5 - 1] = arguments[_key5];
        return $825299b5d0c0a9a5$var$waitForActual(fn).then(function(result) {
            return $825299b5d0c0a9a5$var$expectsNoError.apply(void 0, [
                doesNotReject,
                result
            ].concat(args));
        });
    };
    $825299b5d0c0a9a5$var$assert.ifError = function ifError(err) {
        if (err !== null && err !== undefined) {
            var message = 'ifError got unwanted exception: ';
            if ($825299b5d0c0a9a5$var$_typeof(err) === 'object' && typeof err.message === 'string') {
                if (err.message.length === 0 && err.constructor) message += err.constructor.name;
                else message += err.message;
            } else message += $825299b5d0c0a9a5$var$inspect(err);
            var newErr = new $3ZLjA({
                actual: err,
                expected: null,
                operator: 'ifError',
                message: message,
                stackStartFn: ifError
            });
            var origStack = err.stack;
            if (typeof origStack === 'string') {
                var tmp2 = origStack.split('\n');
                tmp2.shift();
                var tmp1 = newErr.stack.split('\n');
                for(var i = 0; i < tmp2.length; i++){
                    var pos = tmp1.indexOf(tmp2[i]);
                    if (pos !== -1) {
                        tmp1 = tmp1.slice(0, pos);
                        break;
                    }
                }
                newErr.stack = "".concat(tmp1.join('\n'), "\n").concat(tmp2.join('\n'));
            }
            throw newErr;
        }
    };
    function $825299b5d0c0a9a5$var$internalMatch(string, regexp, message, fn, fnName) {
        if (!$825299b5d0c0a9a5$var$isRegExp(regexp)) throw new $825299b5d0c0a9a5$var$ERR_INVALID_ARG_TYPE('regexp', 'RegExp', regexp);
        var match = fnName === 'match';
        if (typeof string !== 'string' || $825299b5d0c0a9a5$var$RegExpPrototypeTest(regexp, string) !== match) {
            if (message instanceof Error) throw message;
            var generatedMessage = !message;
            message = message || (typeof string !== 'string' ? 'The "string" argument must be of type string. Received type ' + "".concat($825299b5d0c0a9a5$var$_typeof(string), " (").concat($825299b5d0c0a9a5$var$inspect(string), ")") : (match ? 'The input did not match the regular expression ' : 'The input was expected to not match the regular expression ') + "".concat($825299b5d0c0a9a5$var$inspect(regexp), ". Input:\n\n").concat($825299b5d0c0a9a5$var$inspect(string), "\n"));
            var err = new $3ZLjA({
                actual: string,
                expected: regexp,
                message: message,
                operator: fnName,
                stackStartFn: fn
            });
            err.generatedMessage = generatedMessage;
            throw err;
        }
    }
    $825299b5d0c0a9a5$var$assert.match = function match(string, regexp, message) {
        $825299b5d0c0a9a5$var$internalMatch(string, regexp, message, match, 'match');
    };
    $825299b5d0c0a9a5$var$assert.doesNotMatch = function doesNotMatch(string, regexp, message) {
        $825299b5d0c0a9a5$var$internalMatch(string, regexp, message, doesNotMatch, 'doesNotMatch');
    };
    function $825299b5d0c0a9a5$var$strict() {
        for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)args[_key6] = arguments[_key6];
        $825299b5d0c0a9a5$var$innerOk.apply(void 0, [
            $825299b5d0c0a9a5$var$strict,
            args.length
        ].concat(args));
    }
    $825299b5d0c0a9a5$var$assert.strict = $825299b5d0c0a9a5$var$objectAssign($825299b5d0c0a9a5$var$strict, $825299b5d0c0a9a5$var$assert, {
        equal: $825299b5d0c0a9a5$var$assert.strictEqual,
        deepEqual: $825299b5d0c0a9a5$var$assert.deepStrictEqual,
        notEqual: $825299b5d0c0a9a5$var$assert.notStrictEqual,
        notDeepEqual: $825299b5d0c0a9a5$var$assert.notDeepStrictEqual
    });
    $825299b5d0c0a9a5$var$assert.strict.strict = $825299b5d0c0a9a5$var$assert.strict;
});
parcelRegister("8JAro", function(module, exports) {
    $parcel$export(module.exports, "codes", ()=>$65becb1820e5a079$export$e45cb6485273080e, (v)=>$65becb1820e5a079$export$e45cb6485273080e = v);
    var $65becb1820e5a079$export$e45cb6485273080e;
    'use strict';
    function $65becb1820e5a079$var$_typeof(o) {
        "@babel/helpers - typeof";
        return $65becb1820e5a079$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
            return typeof o;
        } : function(o) {
            return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
        }, $65becb1820e5a079$var$_typeof(o);
    }
    function $65becb1820e5a079$var$_defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, $65becb1820e5a079$var$_toPropertyKey(descriptor.key), descriptor);
        }
    }
    function $65becb1820e5a079$var$_createClass(Constructor, protoProps, staticProps) {
        if (protoProps) $65becb1820e5a079$var$_defineProperties(Constructor.prototype, protoProps);
        if (staticProps) $65becb1820e5a079$var$_defineProperties(Constructor, staticProps);
        Object.defineProperty(Constructor, "prototype", {
            writable: false
        });
        return Constructor;
    }
    function $65becb1820e5a079$var$_toPropertyKey(arg) {
        var key = $65becb1820e5a079$var$_toPrimitive(arg, "string");
        return $65becb1820e5a079$var$_typeof(key) === "symbol" ? key : String(key);
    }
    function $65becb1820e5a079$var$_toPrimitive(input, hint) {
        if ($65becb1820e5a079$var$_typeof(input) !== "object" || input === null) return input;
        var prim = input[Symbol.toPrimitive];
        if (prim !== undefined) {
            var res = prim.call(input, hint || "default");
            if ($65becb1820e5a079$var$_typeof(res) !== "object") return res;
            throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (hint === "string" ? String : Number)(input);
    }
    function $65becb1820e5a079$var$_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function $65becb1820e5a079$var$_inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                writable: true,
                configurable: true
            }
        });
        Object.defineProperty(subClass, "prototype", {
            writable: false
        });
        if (superClass) $65becb1820e5a079$var$_setPrototypeOf(subClass, superClass);
    }
    function $65becb1820e5a079$var$_setPrototypeOf(o, p) {
        $65becb1820e5a079$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return $65becb1820e5a079$var$_setPrototypeOf(o, p);
    }
    function $65becb1820e5a079$var$_createSuper(Derived) {
        var hasNativeReflectConstruct = $65becb1820e5a079$var$_isNativeReflectConstruct();
        return function _createSuperInternal() {
            var Super = $65becb1820e5a079$var$_getPrototypeOf(Derived), result;
            if (hasNativeReflectConstruct) {
                var NewTarget = $65becb1820e5a079$var$_getPrototypeOf(this).constructor;
                result = Reflect.construct(Super, arguments, NewTarget);
            } else result = Super.apply(this, arguments);
            return $65becb1820e5a079$var$_possibleConstructorReturn(this, result);
        };
    }
    function $65becb1820e5a079$var$_possibleConstructorReturn(self, call) {
        if (call && ($65becb1820e5a079$var$_typeof(call) === "object" || typeof call === "function")) return call;
        else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
        return $65becb1820e5a079$var$_assertThisInitialized(self);
    }
    function $65becb1820e5a079$var$_assertThisInitialized(self) {
        if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return self;
    }
    function $65becb1820e5a079$var$_isNativeReflectConstruct() {
        if (typeof Reflect === "undefined" || !Reflect.construct) return false;
        if (Reflect.construct.sham) return false;
        if (typeof Proxy === "function") return true;
        try {
            Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            return true;
        } catch (e) {
            return false;
        }
    }
    function $65becb1820e5a079$var$_getPrototypeOf(o) {
        $65becb1820e5a079$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
            return o.__proto__ || Object.getPrototypeOf(o);
        };
        return $65becb1820e5a079$var$_getPrototypeOf(o);
    }
    var $65becb1820e5a079$var$codes = {};
    var $65becb1820e5a079$var$assert;
    var $65becb1820e5a079$var$util;
    function $65becb1820e5a079$var$createErrorType(code, message, Base) {
        if (!Base) Base = Error;
        function getMessage(arg1, arg2, arg3) {
            if (typeof message === 'string') return message;
            else return message(arg1, arg2, arg3);
        }
        var NodeError = function(_Base) {
            $65becb1820e5a079$var$_inherits(NodeError, _Base);
            var _super = $65becb1820e5a079$var$_createSuper(NodeError);
            function NodeError(arg1, arg2, arg3) {
                var _this;
                $65becb1820e5a079$var$_classCallCheck(this, NodeError);
                _this = _super.call(this, getMessage(arg1, arg2, arg3));
                _this.code = code;
                return _this;
            }
            return $65becb1820e5a079$var$_createClass(NodeError);
        }(Base);
        $65becb1820e5a079$var$codes[code] = NodeError;
    }
    function $65becb1820e5a079$var$oneOf(expected, thing) {
        if (Array.isArray(expected)) {
            var len = expected.length;
            expected = expected.map(function(i) {
                return String(i);
            });
            if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
            else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
            else return "of ".concat(thing, " ").concat(expected[0]);
        } else return "of ".concat(thing, " ").concat(String(expected));
    }
    function $65becb1820e5a079$var$startsWith(str, search, pos) {
        return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
    }
    function $65becb1820e5a079$var$endsWith(str, search, this_len) {
        if (this_len === undefined || this_len > str.length) this_len = str.length;
        return str.substring(this_len - search.length, this_len) === search;
    }
    function $65becb1820e5a079$var$includes(str, search, start) {
        if (typeof start !== 'number') start = 0;
        if (start + search.length > str.length) return false;
        else return str.indexOf(search, start) !== -1;
    }
    $65becb1820e5a079$var$createErrorType('ERR_AMBIGUOUS_ARGUMENT', 'The "%s" argument is ambiguous. %s', TypeError);
    $65becb1820e5a079$var$createErrorType('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
        if ($65becb1820e5a079$var$assert === undefined) $65becb1820e5a079$var$assert = (parcelRequire("bbHFU"));
        $65becb1820e5a079$var$assert(typeof name === 'string', "'name' must be a string");
        var determiner;
        if (typeof expected === 'string' && $65becb1820e5a079$var$startsWith(expected, 'not ')) {
            determiner = 'must not be';
            expected = expected.replace(/^not /, '');
        } else determiner = 'must be';
        var msg;
        if ($65becb1820e5a079$var$endsWith(name, ' argument')) msg = "The ".concat(name, " ").concat(determiner, " ").concat($65becb1820e5a079$var$oneOf(expected, 'type'));
        else {
            var type = $65becb1820e5a079$var$includes(name, '.') ? 'property' : 'argument';
            msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat($65becb1820e5a079$var$oneOf(expected, 'type'));
        }
        msg += ". Received type ".concat($65becb1820e5a079$var$_typeof(actual));
        return msg;
    }, TypeError);
    $65becb1820e5a079$var$createErrorType('ERR_INVALID_ARG_VALUE', function(name, value) {
        var reason = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'is invalid';
        if ($65becb1820e5a079$var$util === undefined) $65becb1820e5a079$var$util = (parcelRequire("9kAQu"));
        var inspected = $65becb1820e5a079$var$util.inspect(value);
        if (inspected.length > 128) inspected = "".concat(inspected.slice(0, 128), "...");
        return "The argument '".concat(name, "' ").concat(reason, ". Received ").concat(inspected);
    }, TypeError, RangeError);
    $65becb1820e5a079$var$createErrorType('ERR_INVALID_RETURN_VALUE', function(input, name, value) {
        var type;
        if (value && value.constructor && value.constructor.name) type = "instance of ".concat(value.constructor.name);
        else type = "type ".concat($65becb1820e5a079$var$_typeof(value));
        return "Expected ".concat(input, " to be returned from the \"").concat(name, "\"") + " function but got ".concat(type, ".");
    }, TypeError);
    $65becb1820e5a079$var$createErrorType('ERR_MISSING_ARGS', function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if ($65becb1820e5a079$var$assert === undefined) $65becb1820e5a079$var$assert = (parcelRequire("bbHFU"));
        $65becb1820e5a079$var$assert(args.length > 0, 'At least one arg needs to be specified');
        var msg = 'The ';
        var len = args.length;
        args = args.map(function(a) {
            return "\"".concat(a, "\"");
        });
        switch(len){
            case 1:
                msg += "".concat(args[0], " argument");
                break;
            case 2:
                msg += "".concat(args[0], " and ").concat(args[1], " arguments");
                break;
            default:
                msg += args.slice(0, len - 1).join(', ');
                msg += ", and ".concat(args[len - 1], " arguments");
                break;
        }
        return "".concat(msg, " must be specified");
    }, TypeError);
    $65becb1820e5a079$export$e45cb6485273080e = $65becb1820e5a079$var$codes;
});
parcelRegister("9kAQu", function(module, exports) {
    var $6cAn5 = parcelRequire("6cAn5");
    var $6cb29018fbdc8fcc$var$getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
        var keys = Object.keys(obj);
        var descriptors = {};
        for(var i = 0; i < keys.length; i++)descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
        return descriptors;
    };
    var $6cb29018fbdc8fcc$var$formatRegExp = /%[sdj%]/g;
    module.exports.format = function(f) {
        if (!$6cb29018fbdc8fcc$var$isString(f)) {
            var objects = [];
            for(var i = 0; i < arguments.length; i++)objects.push($6cb29018fbdc8fcc$var$inspect(arguments[i]));
            return objects.join(' ');
        }
        var i = 1;
        var args = arguments;
        var len = args.length;
        var str = String(f).replace($6cb29018fbdc8fcc$var$formatRegExp, function(x) {
            if (x === '%%') return '%';
            if (i >= len) return x;
            switch(x){
                case '%s':
                    return String(args[i++]);
                case '%d':
                    return Number(args[i++]);
                case '%j':
                    try {
                        return JSON.stringify(args[i++]);
                    } catch (_) {
                        return '[Circular]';
                    }
                default:
                    return x;
            }
        });
        for(var x = args[i]; i < len; x = args[++i])if ($6cb29018fbdc8fcc$var$isNull(x) || !$6cb29018fbdc8fcc$var$isObject(x)) str += ' ' + x;
        else str += ' ' + $6cb29018fbdc8fcc$var$inspect(x);
        return str;
    };
    module.exports.deprecate = function(fn, msg) {
        if (typeof $6cAn5 !== 'undefined' && $6cAn5.noDeprecation === true) return fn;
        if (typeof $6cAn5 === 'undefined') return function() {
            return module.exports.deprecate(fn, msg).apply(this, arguments);
        };
        var warned = false;
        function deprecated() {
            if (!warned) {
                if ($6cAn5.throwDeprecation) throw new Error(msg);
                else if ($6cAn5.traceDeprecation) console.trace(msg);
                else console.error(msg);
                warned = true;
            }
            return fn.apply(this, arguments);
        }
        return deprecated;
    };
    var $6cb29018fbdc8fcc$var$debugs = {};
    var $6cb29018fbdc8fcc$var$debugEnvRegex = /^$/;
    var $6cb29018fbdc8fcc$var$debugEnv;
    module.exports.debuglog = function(set) {
        set = set.toUpperCase();
        if (!$6cb29018fbdc8fcc$var$debugs[set]) {
            if ($6cb29018fbdc8fcc$var$debugEnvRegex.test(set)) {
                var pid = $6cAn5.pid;
                $6cb29018fbdc8fcc$var$debugs[set] = function() {
                    var msg = module.exports.format.apply(module.exports, arguments);
                    console.error('%s %d: %s', set, pid, msg);
                };
            } else $6cb29018fbdc8fcc$var$debugs[set] = function() {};
        }
        return $6cb29018fbdc8fcc$var$debugs[set];
    };
    function $6cb29018fbdc8fcc$var$inspect(obj, opts) {
        var ctx = {
            seen: [],
            stylize: $6cb29018fbdc8fcc$var$stylizeNoColor
        };
        if (arguments.length >= 3) ctx.depth = arguments[2];
        if (arguments.length >= 4) ctx.colors = arguments[3];
        if ($6cb29018fbdc8fcc$var$isBoolean(opts)) ctx.showHidden = opts;
        else if (opts) module.exports._extend(ctx, opts);
        if ($6cb29018fbdc8fcc$var$isUndefined(ctx.showHidden)) ctx.showHidden = false;
        if ($6cb29018fbdc8fcc$var$isUndefined(ctx.depth)) ctx.depth = 2;
        if ($6cb29018fbdc8fcc$var$isUndefined(ctx.colors)) ctx.colors = false;
        if ($6cb29018fbdc8fcc$var$isUndefined(ctx.customInspect)) ctx.customInspect = true;
        if (ctx.colors) ctx.stylize = $6cb29018fbdc8fcc$var$stylizeWithColor;
        return $6cb29018fbdc8fcc$var$formatValue(ctx, obj, ctx.depth);
    }
    module.exports.inspect = $6cb29018fbdc8fcc$var$inspect;
    $6cb29018fbdc8fcc$var$inspect.colors = {
        'bold': [
            1,
            22
        ],
        'italic': [
            3,
            23
        ],
        'underline': [
            4,
            24
        ],
        'inverse': [
            7,
            27
        ],
        'white': [
            37,
            39
        ],
        'grey': [
            90,
            39
        ],
        'black': [
            30,
            39
        ],
        'blue': [
            34,
            39
        ],
        'cyan': [
            36,
            39
        ],
        'green': [
            32,
            39
        ],
        'magenta': [
            35,
            39
        ],
        'red': [
            31,
            39
        ],
        'yellow': [
            33,
            39
        ]
    };
    $6cb29018fbdc8fcc$var$inspect.styles = {
        'special': 'cyan',
        'number': 'yellow',
        'boolean': 'yellow',
        'undefined': 'grey',
        'null': 'bold',
        'string': 'green',
        'date': 'magenta',
        'regexp': 'red'
    };
    function $6cb29018fbdc8fcc$var$stylizeWithColor(str, styleType) {
        var style = $6cb29018fbdc8fcc$var$inspect.styles[styleType];
        if (style) return '\u001b[' + $6cb29018fbdc8fcc$var$inspect.colors[style][0] + 'm' + str + '\u001b[' + $6cb29018fbdc8fcc$var$inspect.colors[style][1] + 'm';
        else return str;
    }
    function $6cb29018fbdc8fcc$var$stylizeNoColor(str, styleType) {
        return str;
    }
    function $6cb29018fbdc8fcc$var$arrayToHash(array) {
        var hash = {};
        array.forEach(function(val, idx) {
            hash[val] = true;
        });
        return hash;
    }
    function $6cb29018fbdc8fcc$var$formatValue(ctx, value, recurseTimes) {
        if (ctx.customInspect && value && $6cb29018fbdc8fcc$var$isFunction(value.inspect) && value.inspect !== module.exports.inspect && !(value.constructor && value.constructor.prototype === value)) {
            var ret = value.inspect(recurseTimes, ctx);
            if (!$6cb29018fbdc8fcc$var$isString(ret)) ret = $6cb29018fbdc8fcc$var$formatValue(ctx, ret, recurseTimes);
            return ret;
        }
        var primitive = $6cb29018fbdc8fcc$var$formatPrimitive(ctx, value);
        if (primitive) return primitive;
        var keys = Object.keys(value);
        var visibleKeys = $6cb29018fbdc8fcc$var$arrayToHash(keys);
        if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
        if ($6cb29018fbdc8fcc$var$isError(value) && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) return $6cb29018fbdc8fcc$var$formatError(value);
        if (keys.length === 0) {
            if ($6cb29018fbdc8fcc$var$isFunction(value)) {
                var name = value.name ? ': ' + value.name : '';
                return ctx.stylize('[Function' + name + ']', 'special');
            }
            if ($6cb29018fbdc8fcc$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
            if ($6cb29018fbdc8fcc$var$isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), 'date');
            if ($6cb29018fbdc8fcc$var$isError(value)) return $6cb29018fbdc8fcc$var$formatError(value);
        }
        var base = '', array = false, braces = [
            '{',
            '}'
        ];
        if ($6cb29018fbdc8fcc$var$isArray(value)) {
            array = true;
            braces = [
                '[',
                ']'
            ];
        }
        if ($6cb29018fbdc8fcc$var$isFunction(value)) {
            var n = value.name ? ': ' + value.name : '';
            base = ' [Function' + n + ']';
        }
        if ($6cb29018fbdc8fcc$var$isRegExp(value)) base = ' ' + RegExp.prototype.toString.call(value);
        if ($6cb29018fbdc8fcc$var$isDate(value)) base = ' ' + Date.prototype.toUTCString.call(value);
        if ($6cb29018fbdc8fcc$var$isError(value)) base = ' ' + $6cb29018fbdc8fcc$var$formatError(value);
        if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
        if (recurseTimes < 0) {
            if ($6cb29018fbdc8fcc$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
            else return ctx.stylize('[Object]', 'special');
        }
        ctx.seen.push(value);
        var output;
        if (array) output = $6cb29018fbdc8fcc$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys);
        else output = keys.map(function(key) {
            return $6cb29018fbdc8fcc$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
        });
        ctx.seen.pop();
        return $6cb29018fbdc8fcc$var$reduceToSingleString(output, base, braces);
    }
    function $6cb29018fbdc8fcc$var$formatPrimitive(ctx, value) {
        if ($6cb29018fbdc8fcc$var$isUndefined(value)) return ctx.stylize('undefined', 'undefined');
        if ($6cb29018fbdc8fcc$var$isString(value)) {
            var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '').replace(/'/g, "\\'").replace(/\\"/g, '"') + '\'';
            return ctx.stylize(simple, 'string');
        }
        if ($6cb29018fbdc8fcc$var$isNumber(value)) return ctx.stylize('' + value, 'number');
        if ($6cb29018fbdc8fcc$var$isBoolean(value)) return ctx.stylize('' + value, 'boolean');
        if ($6cb29018fbdc8fcc$var$isNull(value)) return ctx.stylize('null', 'null');
    }
    function $6cb29018fbdc8fcc$var$formatError(value) {
        return '[' + Error.prototype.toString.call(value) + ']';
    }
    function $6cb29018fbdc8fcc$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
        var output = [];
        for(var i = 0, l = value.length; i < l; ++i)if ($6cb29018fbdc8fcc$var$hasOwnProperty(value, String(i))) output.push($6cb29018fbdc8fcc$var$formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
        else output.push('');
        keys.forEach(function(key) {
            if (!key.match(/^\d+$/)) output.push($6cb29018fbdc8fcc$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
        });
        return output;
    }
    function $6cb29018fbdc8fcc$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
        var name, str, desc;
        desc = Object.getOwnPropertyDescriptor(value, key) || {
            value: value[key]
        };
        if (desc.get) {
            if (desc.set) str = ctx.stylize('[Getter/Setter]', 'special');
            else str = ctx.stylize('[Getter]', 'special');
        } else if (desc.set) str = ctx.stylize('[Setter]', 'special');
        if (!$6cb29018fbdc8fcc$var$hasOwnProperty(visibleKeys, key)) name = '[' + key + ']';
        if (!str) {
            if (ctx.seen.indexOf(desc.value) < 0) {
                if ($6cb29018fbdc8fcc$var$isNull(recurseTimes)) str = $6cb29018fbdc8fcc$var$formatValue(ctx, desc.value, null);
                else str = $6cb29018fbdc8fcc$var$formatValue(ctx, desc.value, recurseTimes - 1);
                if (str.indexOf('\n') > -1) {
                    if (array) str = str.split('\n').map(function(line) {
                        return '  ' + line;
                    }).join('\n').slice(2);
                    else str = '\n' + str.split('\n').map(function(line) {
                        return '   ' + line;
                    }).join('\n');
                }
            } else str = ctx.stylize('[Circular]', 'special');
        }
        if ($6cb29018fbdc8fcc$var$isUndefined(name)) {
            if (array && key.match(/^\d+$/)) return str;
            name = JSON.stringify('' + key);
            if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
                name = name.slice(1, -1);
                name = ctx.stylize(name, 'name');
            } else {
                name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
                name = ctx.stylize(name, 'string');
            }
        }
        return name + ': ' + str;
    }
    function $6cb29018fbdc8fcc$var$reduceToSingleString(output, base, braces) {
        var numLinesEst = 0;
        var length = output.reduce(function(prev, cur) {
            numLinesEst++;
            if (cur.indexOf('\n') >= 0) numLinesEst++;
            return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
        }, 0);
        if (length > 60) return braces[0] + (base === '' ? '' : base + '\n ') + ' ' + output.join(',\n  ') + ' ' + braces[1];
        return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
    }
    module.exports.types = (parcelRequire("jGyMi"));
    function $6cb29018fbdc8fcc$var$isArray(ar) {
        return Array.isArray(ar);
    }
    module.exports.isArray = $6cb29018fbdc8fcc$var$isArray;
    function $6cb29018fbdc8fcc$var$isBoolean(arg) {
        return typeof arg === 'boolean';
    }
    module.exports.isBoolean = $6cb29018fbdc8fcc$var$isBoolean;
    function $6cb29018fbdc8fcc$var$isNull(arg) {
        return arg === null;
    }
    module.exports.isNull = $6cb29018fbdc8fcc$var$isNull;
    function $6cb29018fbdc8fcc$var$isNullOrUndefined(arg) {
        return arg == null;
    }
    module.exports.isNullOrUndefined = $6cb29018fbdc8fcc$var$isNullOrUndefined;
    function $6cb29018fbdc8fcc$var$isNumber(arg) {
        return typeof arg === 'number';
    }
    module.exports.isNumber = $6cb29018fbdc8fcc$var$isNumber;
    function $6cb29018fbdc8fcc$var$isString(arg) {
        return typeof arg === 'string';
    }
    module.exports.isString = $6cb29018fbdc8fcc$var$isString;
    function $6cb29018fbdc8fcc$var$isSymbol(arg) {
        return typeof arg === 'symbol';
    }
    module.exports.isSymbol = $6cb29018fbdc8fcc$var$isSymbol;
    function $6cb29018fbdc8fcc$var$isUndefined(arg) {
        return arg === void 0;
    }
    module.exports.isUndefined = $6cb29018fbdc8fcc$var$isUndefined;
    function $6cb29018fbdc8fcc$var$isRegExp(re) {
        return $6cb29018fbdc8fcc$var$isObject(re) && $6cb29018fbdc8fcc$var$objectToString(re) === '[object RegExp]';
    }
    module.exports.isRegExp = $6cb29018fbdc8fcc$var$isRegExp;
    module.exports.types.isRegExp = $6cb29018fbdc8fcc$var$isRegExp;
    function $6cb29018fbdc8fcc$var$isObject(arg) {
        return typeof arg === 'object' && arg !== null;
    }
    module.exports.isObject = $6cb29018fbdc8fcc$var$isObject;
    function $6cb29018fbdc8fcc$var$isDate(d) {
        return $6cb29018fbdc8fcc$var$isObject(d) && $6cb29018fbdc8fcc$var$objectToString(d) === '[object Date]';
    }
    module.exports.isDate = $6cb29018fbdc8fcc$var$isDate;
    module.exports.types.isDate = $6cb29018fbdc8fcc$var$isDate;
    function $6cb29018fbdc8fcc$var$isError(e) {
        return $6cb29018fbdc8fcc$var$isObject(e) && ($6cb29018fbdc8fcc$var$objectToString(e) === '[object Error]' || e instanceof Error);
    }
    module.exports.isError = $6cb29018fbdc8fcc$var$isError;
    module.exports.types.isNativeError = $6cb29018fbdc8fcc$var$isError;
    function $6cb29018fbdc8fcc$var$isFunction(arg) {
        return typeof arg === 'function';
    }
    module.exports.isFunction = $6cb29018fbdc8fcc$var$isFunction;
    function $6cb29018fbdc8fcc$var$isPrimitive(arg) {
        return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || typeof arg === 'undefined';
    }
    module.exports.isPrimitive = $6cb29018fbdc8fcc$var$isPrimitive;
    module.exports.isBuffer = (parcelRequire("kEU0N"));
    function $6cb29018fbdc8fcc$var$objectToString(o) {
        return Object.prototype.toString.call(o);
    }
    function $6cb29018fbdc8fcc$var$pad(n) {
        return n < 10 ? '0' + n.toString(10) : n.toString(10);
    }
    var $6cb29018fbdc8fcc$var$months = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec'
    ];
    function $6cb29018fbdc8fcc$var$timestamp() {
        var d = new Date();
        var time = [
            $6cb29018fbdc8fcc$var$pad(d.getHours()),
            $6cb29018fbdc8fcc$var$pad(d.getMinutes()),
            $6cb29018fbdc8fcc$var$pad(d.getSeconds())
        ].join(':');
        return [
            d.getDate(),
            $6cb29018fbdc8fcc$var$months[d.getMonth()],
            time
        ].join(' ');
    }
    module.exports.log = function() {
        console.log('%s - %s', $6cb29018fbdc8fcc$var$timestamp(), module.exports.format.apply(module.exports, arguments));
    };
    module.exports.inherits = (parcelRequire("v3bBu"));
    module.exports._extend = function(origin, add) {
        if (!add || !$6cb29018fbdc8fcc$var$isObject(add)) return origin;
        var keys = Object.keys(add);
        var i = keys.length;
        while(i--)origin[keys[i]] = add[keys[i]];
        return origin;
    };
    function $6cb29018fbdc8fcc$var$hasOwnProperty(obj, prop) {
        return Object.prototype.hasOwnProperty.call(obj, prop);
    }
    var $6cb29018fbdc8fcc$var$kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;
    module.exports.promisify = function promisify(original) {
        if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
        if ($6cb29018fbdc8fcc$var$kCustomPromisifiedSymbol && original[$6cb29018fbdc8fcc$var$kCustomPromisifiedSymbol]) {
            var fn = original[$6cb29018fbdc8fcc$var$kCustomPromisifiedSymbol];
            if (typeof fn !== 'function') throw new TypeError('The "util.promisify.custom" argument must be of type Function');
            Object.defineProperty(fn, $6cb29018fbdc8fcc$var$kCustomPromisifiedSymbol, {
                value: fn,
                enumerable: false,
                writable: false,
                configurable: true
            });
            return fn;
        }
        function fn() {
            var promiseResolve, promiseReject;
            var promise = new Promise(function(resolve, reject) {
                promiseResolve = resolve;
                promiseReject = reject;
            });
            var args = [];
            for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
            args.push(function(err, value) {
                if (err) promiseReject(err);
                else promiseResolve(value);
            });
            try {
                original.apply(this, args);
            } catch (err) {
                promiseReject(err);
            }
            return promise;
        }
        Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
        if ($6cb29018fbdc8fcc$var$kCustomPromisifiedSymbol) Object.defineProperty(fn, $6cb29018fbdc8fcc$var$kCustomPromisifiedSymbol, {
            value: fn,
            enumerable: false,
            writable: false,
            configurable: true
        });
        return Object.defineProperties(fn, $6cb29018fbdc8fcc$var$getOwnPropertyDescriptors(original));
    };
    module.exports.promisify.custom = $6cb29018fbdc8fcc$var$kCustomPromisifiedSymbol;
    function $6cb29018fbdc8fcc$var$callbackifyOnRejected(reason, cb) {
        if (!reason) {
            var newReason = new Error('Promise was rejected with a falsy value');
            newReason.reason = reason;
            reason = newReason;
        }
        return cb(reason);
    }
    function $6cb29018fbdc8fcc$var$callbackify(original) {
        if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
        function callbackified() {
            var args = [];
            for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
            var maybeCb = args.pop();
            if (typeof maybeCb !== 'function') throw new TypeError('The last argument must be of type Function');
            var self = this;
            var cb = function() {
                return maybeCb.apply(self, arguments);
            };
            original.apply(this, args).then(function(ret) {
                $6cAn5.nextTick(cb.bind(null, null, ret));
            }, function(rej) {
                $6cAn5.nextTick($6cb29018fbdc8fcc$var$callbackifyOnRejected.bind(null, rej, cb));
            });
        }
        Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
        Object.defineProperties(callbackified, $6cb29018fbdc8fcc$var$getOwnPropertyDescriptors(original));
        return callbackified;
    }
    module.exports.callbackify = $6cb29018fbdc8fcc$var$callbackify;
});
parcelRegister("jGyMi", function(module, exports) {
    'use strict';
    var $eyPxb = parcelRequire("eyPxb");
    var $kF7vh = parcelRequire("kF7vh");
    var $hdl59;
    var $dFTgY;
    function $e54ceaba9c647d57$var$uncurryThis(f) {
        return f.call.bind(f);
    }
    var $e54ceaba9c647d57$var$BigIntSupported = typeof BigInt !== 'undefined';
    var $e54ceaba9c647d57$var$SymbolSupported = typeof Symbol !== 'undefined';
    var $e54ceaba9c647d57$var$ObjectToString = $e54ceaba9c647d57$var$uncurryThis(Object.prototype.toString);
    var $e54ceaba9c647d57$var$numberValue = $e54ceaba9c647d57$var$uncurryThis(Number.prototype.valueOf);
    var $e54ceaba9c647d57$var$stringValue = $e54ceaba9c647d57$var$uncurryThis(String.prototype.valueOf);
    var $e54ceaba9c647d57$var$booleanValue = $e54ceaba9c647d57$var$uncurryThis(Boolean.prototype.valueOf);
    if ($e54ceaba9c647d57$var$BigIntSupported) var $e54ceaba9c647d57$var$bigIntValue = $e54ceaba9c647d57$var$uncurryThis(BigInt.prototype.valueOf);
    if ($e54ceaba9c647d57$var$SymbolSupported) var $e54ceaba9c647d57$var$symbolValue = $e54ceaba9c647d57$var$uncurryThis(Symbol.prototype.valueOf);
    function $e54ceaba9c647d57$var$checkBoxedPrimitive(value, prototypeValueOf) {
        if (typeof value !== 'object') return false;
        try {
            prototypeValueOf(value);
            return true;
        } catch (e) {
            return false;
        }
    }
    module.exports.isArgumentsObject = $eyPxb;
    module.exports.isGeneratorFunction = $kF7vh;
    module.exports.isTypedArray = (0, parcelRequire("dFTgY"));
    function $e54ceaba9c647d57$var$isPromise(input) {
        return typeof Promise !== 'undefined' && input instanceof Promise || input !== null && typeof input === 'object' && typeof input.then === 'function' && typeof input.catch === 'function';
    }
    module.exports.isPromise = $e54ceaba9c647d57$var$isPromise;
    function $e54ceaba9c647d57$var$isArrayBufferView(value) {
        if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) return ArrayBuffer.isView(value);
        return (0, parcelRequire("dFTgY"))(value) || $e54ceaba9c647d57$var$isDataView(value);
    }
    module.exports.isArrayBufferView = $e54ceaba9c647d57$var$isArrayBufferView;
    function $e54ceaba9c647d57$var$isUint8Array(value) {
        return (0, parcelRequire("hdl59"))(value) === 'Uint8Array';
    }
    module.exports.isUint8Array = $e54ceaba9c647d57$var$isUint8Array;
    function $e54ceaba9c647d57$var$isUint8ClampedArray(value) {
        return (0, parcelRequire("hdl59"))(value) === 'Uint8ClampedArray';
    }
    module.exports.isUint8ClampedArray = $e54ceaba9c647d57$var$isUint8ClampedArray;
    function $e54ceaba9c647d57$var$isUint16Array(value) {
        return (0, parcelRequire("hdl59"))(value) === 'Uint16Array';
    }
    module.exports.isUint16Array = $e54ceaba9c647d57$var$isUint16Array;
    function $e54ceaba9c647d57$var$isUint32Array(value) {
        return (0, parcelRequire("hdl59"))(value) === 'Uint32Array';
    }
    module.exports.isUint32Array = $e54ceaba9c647d57$var$isUint32Array;
    function $e54ceaba9c647d57$var$isInt8Array(value) {
        return (0, parcelRequire("hdl59"))(value) === 'Int8Array';
    }
    module.exports.isInt8Array = $e54ceaba9c647d57$var$isInt8Array;
    function $e54ceaba9c647d57$var$isInt16Array(value) {
        return (0, parcelRequire("hdl59"))(value) === 'Int16Array';
    }
    module.exports.isInt16Array = $e54ceaba9c647d57$var$isInt16Array;
    function $e54ceaba9c647d57$var$isInt32Array(value) {
        return (0, parcelRequire("hdl59"))(value) === 'Int32Array';
    }
    module.exports.isInt32Array = $e54ceaba9c647d57$var$isInt32Array;
    function $e54ceaba9c647d57$var$isFloat32Array(value) {
        return (0, parcelRequire("hdl59"))(value) === 'Float32Array';
    }
    module.exports.isFloat32Array = $e54ceaba9c647d57$var$isFloat32Array;
    function $e54ceaba9c647d57$var$isFloat64Array(value) {
        return (0, parcelRequire("hdl59"))(value) === 'Float64Array';
    }
    module.exports.isFloat64Array = $e54ceaba9c647d57$var$isFloat64Array;
    function $e54ceaba9c647d57$var$isBigInt64Array(value) {
        return (0, parcelRequire("hdl59"))(value) === 'BigInt64Array';
    }
    module.exports.isBigInt64Array = $e54ceaba9c647d57$var$isBigInt64Array;
    function $e54ceaba9c647d57$var$isBigUint64Array(value) {
        return (0, parcelRequire("hdl59"))(value) === 'BigUint64Array';
    }
    module.exports.isBigUint64Array = $e54ceaba9c647d57$var$isBigUint64Array;
    function $e54ceaba9c647d57$var$isMapToString(value) {
        return $e54ceaba9c647d57$var$ObjectToString(value) === '[object Map]';
    }
    $e54ceaba9c647d57$var$isMapToString.working = typeof Map !== 'undefined' && $e54ceaba9c647d57$var$isMapToString(new Map());
    function $e54ceaba9c647d57$var$isMap(value) {
        if (typeof Map === 'undefined') return false;
        return $e54ceaba9c647d57$var$isMapToString.working ? $e54ceaba9c647d57$var$isMapToString(value) : value instanceof Map;
    }
    module.exports.isMap = $e54ceaba9c647d57$var$isMap;
    function $e54ceaba9c647d57$var$isSetToString(value) {
        return $e54ceaba9c647d57$var$ObjectToString(value) === '[object Set]';
    }
    $e54ceaba9c647d57$var$isSetToString.working = typeof Set !== 'undefined' && $e54ceaba9c647d57$var$isSetToString(new Set());
    function $e54ceaba9c647d57$var$isSet(value) {
        if (typeof Set === 'undefined') return false;
        return $e54ceaba9c647d57$var$isSetToString.working ? $e54ceaba9c647d57$var$isSetToString(value) : value instanceof Set;
    }
    module.exports.isSet = $e54ceaba9c647d57$var$isSet;
    function $e54ceaba9c647d57$var$isWeakMapToString(value) {
        return $e54ceaba9c647d57$var$ObjectToString(value) === '[object WeakMap]';
    }
    $e54ceaba9c647d57$var$isWeakMapToString.working = typeof WeakMap !== 'undefined' && $e54ceaba9c647d57$var$isWeakMapToString(new WeakMap());
    function $e54ceaba9c647d57$var$isWeakMap(value) {
        if (typeof WeakMap === 'undefined') return false;
        return $e54ceaba9c647d57$var$isWeakMapToString.working ? $e54ceaba9c647d57$var$isWeakMapToString(value) : value instanceof WeakMap;
    }
    module.exports.isWeakMap = $e54ceaba9c647d57$var$isWeakMap;
    function $e54ceaba9c647d57$var$isWeakSetToString(value) {
        return $e54ceaba9c647d57$var$ObjectToString(value) === '[object WeakSet]';
    }
    $e54ceaba9c647d57$var$isWeakSetToString.working = typeof WeakSet !== 'undefined' && $e54ceaba9c647d57$var$isWeakSetToString(new WeakSet());
    function $e54ceaba9c647d57$var$isWeakSet(value) {
        return $e54ceaba9c647d57$var$isWeakSetToString(value);
    }
    module.exports.isWeakSet = $e54ceaba9c647d57$var$isWeakSet;
    function $e54ceaba9c647d57$var$isArrayBufferToString(value) {
        return $e54ceaba9c647d57$var$ObjectToString(value) === '[object ArrayBuffer]';
    }
    $e54ceaba9c647d57$var$isArrayBufferToString.working = typeof ArrayBuffer !== 'undefined' && $e54ceaba9c647d57$var$isArrayBufferToString(new ArrayBuffer());
    function $e54ceaba9c647d57$var$isArrayBuffer(value) {
        if (typeof ArrayBuffer === 'undefined') return false;
        return $e54ceaba9c647d57$var$isArrayBufferToString.working ? $e54ceaba9c647d57$var$isArrayBufferToString(value) : value instanceof ArrayBuffer;
    }
    module.exports.isArrayBuffer = $e54ceaba9c647d57$var$isArrayBuffer;
    function $e54ceaba9c647d57$var$isDataViewToString(value) {
        return $e54ceaba9c647d57$var$ObjectToString(value) === '[object DataView]';
    }
    $e54ceaba9c647d57$var$isDataViewToString.working = typeof ArrayBuffer !== 'undefined' && typeof DataView !== 'undefined' && $e54ceaba9c647d57$var$isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
    function $e54ceaba9c647d57$var$isDataView(value) {
        if (typeof DataView === 'undefined') return false;
        return $e54ceaba9c647d57$var$isDataViewToString.working ? $e54ceaba9c647d57$var$isDataViewToString(value) : value instanceof DataView;
    }
    module.exports.isDataView = $e54ceaba9c647d57$var$isDataView;
    var $e54ceaba9c647d57$var$SharedArrayBufferCopy = typeof SharedArrayBuffer !== 'undefined' ? SharedArrayBuffer : undefined;
    function $e54ceaba9c647d57$var$isSharedArrayBufferToString(value) {
        return $e54ceaba9c647d57$var$ObjectToString(value) === '[object SharedArrayBuffer]';
    }
    function $e54ceaba9c647d57$var$isSharedArrayBuffer(value) {
        if (typeof $e54ceaba9c647d57$var$SharedArrayBufferCopy === 'undefined') return false;
        if (typeof $e54ceaba9c647d57$var$isSharedArrayBufferToString.working === 'undefined') $e54ceaba9c647d57$var$isSharedArrayBufferToString.working = $e54ceaba9c647d57$var$isSharedArrayBufferToString(new $e54ceaba9c647d57$var$SharedArrayBufferCopy());
        return $e54ceaba9c647d57$var$isSharedArrayBufferToString.working ? $e54ceaba9c647d57$var$isSharedArrayBufferToString(value) : value instanceof $e54ceaba9c647d57$var$SharedArrayBufferCopy;
    }
    module.exports.isSharedArrayBuffer = $e54ceaba9c647d57$var$isSharedArrayBuffer;
    function $e54ceaba9c647d57$var$isAsyncFunction(value) {
        return $e54ceaba9c647d57$var$ObjectToString(value) === '[object AsyncFunction]';
    }
    module.exports.isAsyncFunction = $e54ceaba9c647d57$var$isAsyncFunction;
    function $e54ceaba9c647d57$var$isMapIterator(value) {
        return $e54ceaba9c647d57$var$ObjectToString(value) === '[object Map Iterator]';
    }
    module.exports.isMapIterator = $e54ceaba9c647d57$var$isMapIterator;
    function $e54ceaba9c647d57$var$isSetIterator(value) {
        return $e54ceaba9c647d57$var$ObjectToString(value) === '[object Set Iterator]';
    }
    module.exports.isSetIterator = $e54ceaba9c647d57$var$isSetIterator;
    function $e54ceaba9c647d57$var$isGeneratorObject(value) {
        return $e54ceaba9c647d57$var$ObjectToString(value) === '[object Generator]';
    }
    module.exports.isGeneratorObject = $e54ceaba9c647d57$var$isGeneratorObject;
    function $e54ceaba9c647d57$var$isWebAssemblyCompiledModule(value) {
        return $e54ceaba9c647d57$var$ObjectToString(value) === '[object WebAssembly.Module]';
    }
    module.exports.isWebAssemblyCompiledModule = $e54ceaba9c647d57$var$isWebAssemblyCompiledModule;
    function $e54ceaba9c647d57$var$isNumberObject(value) {
        return $e54ceaba9c647d57$var$checkBoxedPrimitive(value, $e54ceaba9c647d57$var$numberValue);
    }
    module.exports.isNumberObject = $e54ceaba9c647d57$var$isNumberObject;
    function $e54ceaba9c647d57$var$isStringObject(value) {
        return $e54ceaba9c647d57$var$checkBoxedPrimitive(value, $e54ceaba9c647d57$var$stringValue);
    }
    module.exports.isStringObject = $e54ceaba9c647d57$var$isStringObject;
    function $e54ceaba9c647d57$var$isBooleanObject(value) {
        return $e54ceaba9c647d57$var$checkBoxedPrimitive(value, $e54ceaba9c647d57$var$booleanValue);
    }
    module.exports.isBooleanObject = $e54ceaba9c647d57$var$isBooleanObject;
    function $e54ceaba9c647d57$var$isBigIntObject(value) {
        return $e54ceaba9c647d57$var$BigIntSupported && $e54ceaba9c647d57$var$checkBoxedPrimitive(value, $e54ceaba9c647d57$var$bigIntValue);
    }
    module.exports.isBigIntObject = $e54ceaba9c647d57$var$isBigIntObject;
    function $e54ceaba9c647d57$var$isSymbolObject(value) {
        return $e54ceaba9c647d57$var$SymbolSupported && $e54ceaba9c647d57$var$checkBoxedPrimitive(value, $e54ceaba9c647d57$var$symbolValue);
    }
    module.exports.isSymbolObject = $e54ceaba9c647d57$var$isSymbolObject;
    function $e54ceaba9c647d57$var$isBoxedPrimitive(value) {
        return $e54ceaba9c647d57$var$isNumberObject(value) || $e54ceaba9c647d57$var$isStringObject(value) || $e54ceaba9c647d57$var$isBooleanObject(value) || $e54ceaba9c647d57$var$isBigIntObject(value) || $e54ceaba9c647d57$var$isSymbolObject(value);
    }
    module.exports.isBoxedPrimitive = $e54ceaba9c647d57$var$isBoxedPrimitive;
    function $e54ceaba9c647d57$var$isAnyArrayBuffer(value) {
        return typeof Uint8Array !== 'undefined' && ($e54ceaba9c647d57$var$isArrayBuffer(value) || $e54ceaba9c647d57$var$isSharedArrayBuffer(value));
    }
    module.exports.isAnyArrayBuffer = $e54ceaba9c647d57$var$isAnyArrayBuffer;
    [
        'isProxy',
        'isExternal',
        'isModuleNamespaceObject'
    ].forEach(function(method) {
        Object.defineProperty(module.exports, method, {
            enumerable: false,
            value: function() {
                throw new Error(method + ' is not supported in userland');
            }
        });
    });
});
parcelRegister("eyPxb", function(module, exports) {
    'use strict';
    var $a99c3747cd09063d$var$hasToStringTag = (parcelRequire("fmBzB"))();
    var $53KqO = parcelRequire("53KqO");
    var $a99c3747cd09063d$var$$toString = $53KqO('Object.prototype.toString');
    var $a99c3747cd09063d$var$isStandardArguments = function isArguments(value) {
        if ($a99c3747cd09063d$var$hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) return false;
        return $a99c3747cd09063d$var$$toString(value) === '[object Arguments]';
    };
    var $a99c3747cd09063d$var$isLegacyArguments = function isArguments(value) {
        if ($a99c3747cd09063d$var$isStandardArguments(value)) return true;
        return value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $a99c3747cd09063d$var$$toString(value) !== '[object Array]' && $a99c3747cd09063d$var$$toString(value.callee) === '[object Function]';
    };
    var $a99c3747cd09063d$var$supportsStandardArguments = function() {
        return $a99c3747cd09063d$var$isStandardArguments(arguments);
    }();
    $a99c3747cd09063d$var$isStandardArguments.isLegacyArguments = $a99c3747cd09063d$var$isLegacyArguments;
    module.exports = $a99c3747cd09063d$var$supportsStandardArguments ? $a99c3747cd09063d$var$isStandardArguments : $a99c3747cd09063d$var$isLegacyArguments;
});
parcelRegister("fmBzB", function(module, exports) {
    'use strict';
    var $9T9x9 = parcelRequire("9T9x9");
    module.exports = function hasToStringTagShams() {
        return $9T9x9() && !!Symbol.toStringTag;
    };
});
parcelRegister("kF7vh", function(module, exports) {
    'use strict';
    var $f0ad750370f41c64$var$toStr = Object.prototype.toString;
    var $f0ad750370f41c64$var$fnToStr = Function.prototype.toString;
    var $f0ad750370f41c64$var$isFnRegex = /^\s*(?:function)?\*/;
    var $f0ad750370f41c64$var$hasToStringTag = (parcelRequire("fmBzB"))();
    var $f0ad750370f41c64$var$getProto = Object.getPrototypeOf;
    var $f0ad750370f41c64$var$getGeneratorFunc = function() {
        if (!$f0ad750370f41c64$var$hasToStringTag) return false;
        try {
            return Function('return function*() {}')();
        } catch (e) {}
    };
    var $f0ad750370f41c64$var$GeneratorFunction;
    module.exports = function isGeneratorFunction(fn) {
        if (typeof fn !== 'function') return false;
        if ($f0ad750370f41c64$var$isFnRegex.test($f0ad750370f41c64$var$fnToStr.call(fn))) return true;
        if (!$f0ad750370f41c64$var$hasToStringTag) {
            var str = $f0ad750370f41c64$var$toStr.call(fn);
            return str === '[object GeneratorFunction]';
        }
        if (!$f0ad750370f41c64$var$getProto) return false;
        if (typeof $f0ad750370f41c64$var$GeneratorFunction === 'undefined') {
            var generatorFunc = $f0ad750370f41c64$var$getGeneratorFunc();
            $f0ad750370f41c64$var$GeneratorFunction = generatorFunc ? $f0ad750370f41c64$var$getProto(generatorFunc) : false;
        }
        return $f0ad750370f41c64$var$getProto(fn) === $f0ad750370f41c64$var$GeneratorFunction;
    };
});
parcelRegister("hdl59", function(module, exports) {
    'use strict';
    var $258uT = parcelRequire("258uT");
    var $9ME5O;
    var $h05ZS = parcelRequire("h05ZS");
    var $53KqO = parcelRequire("53KqO");
    var $lBvcQ;
    var $c884010d01443113$var$$toString = $53KqO('Object.prototype.toString');
    var $c884010d01443113$var$hasToStringTag = (parcelRequire("fmBzB"))();
    var $c884010d01443113$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
    var $c884010d01443113$var$typedArrays = (0, parcelRequire("9ME5O"))();
    var $c884010d01443113$var$$slice = $53KqO('String.prototype.slice');
    var $c884010d01443113$var$getPrototypeOf = Object.getPrototypeOf;
    var $c884010d01443113$var$$indexOf = $53KqO('Array.prototype.indexOf', true) || function indexOf(array, value) {
        for(var i = 0; i < array.length; i += 1){
            if (array[i] === value) return i;
        }
        return -1;
    };
    var $c884010d01443113$var$cache = {
        __proto__: null
    };
    if ($c884010d01443113$var$hasToStringTag && (0, parcelRequire("lBvcQ")) && $c884010d01443113$var$getPrototypeOf) $258uT($c884010d01443113$var$typedArrays, function(typedArray) {
        var arr = new $c884010d01443113$var$g[typedArray]();
        if (Symbol.toStringTag in arr) {
            var proto = $c884010d01443113$var$getPrototypeOf(arr);
            var descriptor = (0, parcelRequire("lBvcQ"))(proto, Symbol.toStringTag);
            if (!descriptor) {
                var superProto = $c884010d01443113$var$getPrototypeOf(proto);
                descriptor = (0, parcelRequire("lBvcQ"))(superProto, Symbol.toStringTag);
            }
            $c884010d01443113$var$cache['$' + typedArray] = $h05ZS(descriptor.get);
        }
    });
    else $258uT($c884010d01443113$var$typedArrays, function(typedArray) {
        var arr = new $c884010d01443113$var$g[typedArray]();
        var fn = arr.slice || arr.set;
        if (fn) $c884010d01443113$var$cache['$' + typedArray] = $h05ZS(fn);
    });
    var $c884010d01443113$var$tryTypedArrays = function tryAllTypedArrays(value) {
        var found = false;
        $258uT($c884010d01443113$var$cache, function(getter, typedArray) {
            if (!found) try {
                if ('$' + getter(value) === typedArray) found = $c884010d01443113$var$$slice(typedArray, 1);
            } catch (e) {}
        });
        return found;
    };
    var $c884010d01443113$var$trySlices = function tryAllSlices(value) {
        var found = false;
        $258uT($c884010d01443113$var$cache, function(getter, name) {
            if (!found) try {
                getter(value);
                found = $c884010d01443113$var$$slice(name, 1);
            } catch (e) {}
        });
        return found;
    };
    module.exports = function whichTypedArray(value) {
        if (!value || typeof value !== 'object') return false;
        if (!$c884010d01443113$var$hasToStringTag) {
            var tag = $c884010d01443113$var$$slice($c884010d01443113$var$$toString(value), 8, -1);
            if ($c884010d01443113$var$$indexOf($c884010d01443113$var$typedArrays, tag) > -1) return tag;
            if (tag !== 'Object') return false;
            return $c884010d01443113$var$trySlices(value);
        }
        if (!(0, parcelRequire("lBvcQ"))) return null;
        return $c884010d01443113$var$tryTypedArrays(value);
    };
});
parcelRegister("258uT", function(module, exports) {
    'use strict';
    var $f0Tdg = parcelRequire("f0Tdg");
    var $1842a3cb7df292b5$var$toStr = Object.prototype.toString;
    var $1842a3cb7df292b5$var$hasOwnProperty = Object.prototype.hasOwnProperty;
    var $1842a3cb7df292b5$var$forEachArray = function forEachArray(array, iterator, receiver) {
        for(var i = 0, len = array.length; i < len; i++)if ($1842a3cb7df292b5$var$hasOwnProperty.call(array, i)) {
            if (receiver == null) iterator(array[i], i, array);
            else iterator.call(receiver, array[i], i, array);
        }
    };
    var $1842a3cb7df292b5$var$forEachString = function forEachString(string, iterator, receiver) {
        for(var i = 0, len = string.length; i < len; i++)if (receiver == null) iterator(string.charAt(i), i, string);
        else iterator.call(receiver, string.charAt(i), i, string);
    };
    var $1842a3cb7df292b5$var$forEachObject = function forEachObject(object, iterator, receiver) {
        for(var k in object)if ($1842a3cb7df292b5$var$hasOwnProperty.call(object, k)) {
            if (receiver == null) iterator(object[k], k, object);
            else iterator.call(receiver, object[k], k, object);
        }
    };
    var $1842a3cb7df292b5$var$forEach = function forEach(list, iterator, thisArg) {
        if (!$f0Tdg(iterator)) throw new TypeError('iterator must be a function');
        var receiver;
        if (arguments.length >= 3) receiver = thisArg;
        if ($1842a3cb7df292b5$var$toStr.call(list) === '[object Array]') $1842a3cb7df292b5$var$forEachArray(list, iterator, receiver);
        else if (typeof list === 'string') $1842a3cb7df292b5$var$forEachString(list, iterator, receiver);
        else $1842a3cb7df292b5$var$forEachObject(list, iterator, receiver);
    };
    module.exports = $1842a3cb7df292b5$var$forEach;
});
parcelRegister("f0Tdg", function(module, exports) {
    'use strict';
    var $02d21778b0eebae4$var$fnToStr = Function.prototype.toString;
    var $02d21778b0eebae4$var$reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
    var $02d21778b0eebae4$var$badArrayLike;
    var $02d21778b0eebae4$var$isCallableMarker;
    if (typeof $02d21778b0eebae4$var$reflectApply === 'function' && typeof Object.defineProperty === 'function') try {
        $02d21778b0eebae4$var$badArrayLike = Object.defineProperty({}, 'length', {
            get: function() {
                throw $02d21778b0eebae4$var$isCallableMarker;
            }
        });
        $02d21778b0eebae4$var$isCallableMarker = {};
        $02d21778b0eebae4$var$reflectApply(function() {
            throw 42;
        }, null, $02d21778b0eebae4$var$badArrayLike);
    } catch (_) {
        if (_ !== $02d21778b0eebae4$var$isCallableMarker) $02d21778b0eebae4$var$reflectApply = null;
    }
    else $02d21778b0eebae4$var$reflectApply = null;
    var $02d21778b0eebae4$var$constructorRegex = /^\s*class\b/;
    var $02d21778b0eebae4$var$isES6ClassFn = function isES6ClassFunction(value) {
        try {
            var fnStr = $02d21778b0eebae4$var$fnToStr.call(value);
            return $02d21778b0eebae4$var$constructorRegex.test(fnStr);
        } catch (e) {
            return false;
        }
    };
    var $02d21778b0eebae4$var$tryFunctionObject = function tryFunctionToStr(value) {
        try {
            if ($02d21778b0eebae4$var$isES6ClassFn(value)) return false;
            $02d21778b0eebae4$var$fnToStr.call(value);
            return true;
        } catch (e) {
            return false;
        }
    };
    var $02d21778b0eebae4$var$toStr = Object.prototype.toString;
    var $02d21778b0eebae4$var$objectClass = '[object Object]';
    var $02d21778b0eebae4$var$fnClass = '[object Function]';
    var $02d21778b0eebae4$var$genClass = '[object GeneratorFunction]';
    var $02d21778b0eebae4$var$ddaClass = '[object HTMLAllCollection]';
    var $02d21778b0eebae4$var$ddaClass2 = '[object HTML document.all class]';
    var $02d21778b0eebae4$var$ddaClass3 = '[object HTMLCollection]';
    var $02d21778b0eebae4$var$hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag;
    var $02d21778b0eebae4$var$isIE68 = !(0 in [
        , 
    ]);
    var $02d21778b0eebae4$var$isDDA = function isDocumentDotAll() {
        return false;
    };
    if (typeof document === 'object') {
        var $02d21778b0eebae4$var$all = document.all;
        if ($02d21778b0eebae4$var$toStr.call($02d21778b0eebae4$var$all) === $02d21778b0eebae4$var$toStr.call(document.all)) $02d21778b0eebae4$var$isDDA = function isDocumentDotAll(value) {
            if (($02d21778b0eebae4$var$isIE68 || !value) && (typeof value === 'undefined' || typeof value === 'object')) try {
                var str = $02d21778b0eebae4$var$toStr.call(value);
                return (str === $02d21778b0eebae4$var$ddaClass || str === $02d21778b0eebae4$var$ddaClass2 || str === $02d21778b0eebae4$var$ddaClass3 || str === $02d21778b0eebae4$var$objectClass) && value('') == null;
            } catch (e) {}
            return false;
        };
    }
    module.exports = $02d21778b0eebae4$var$reflectApply ? function isCallable(value) {
        if ($02d21778b0eebae4$var$isDDA(value)) return true;
        if (!value) return false;
        if (typeof value !== 'function' && typeof value !== 'object') return false;
        try {
            $02d21778b0eebae4$var$reflectApply(value, null, $02d21778b0eebae4$var$badArrayLike);
        } catch (e) {
            if (e !== $02d21778b0eebae4$var$isCallableMarker) return false;
        }
        return !$02d21778b0eebae4$var$isES6ClassFn(value) && $02d21778b0eebae4$var$tryFunctionObject(value);
    } : function isCallable(value) {
        if ($02d21778b0eebae4$var$isDDA(value)) return true;
        if (!value) return false;
        if (typeof value !== 'function' && typeof value !== 'object') return false;
        if ($02d21778b0eebae4$var$hasToStringTag) return $02d21778b0eebae4$var$tryFunctionObject(value);
        if ($02d21778b0eebae4$var$isES6ClassFn(value)) return false;
        var strClass = $02d21778b0eebae4$var$toStr.call(value);
        if (strClass !== $02d21778b0eebae4$var$fnClass && strClass !== $02d21778b0eebae4$var$genClass && !/^\[object HTML/.test(strClass)) return false;
        return $02d21778b0eebae4$var$tryFunctionObject(value);
    };
});
parcelRegister("9ME5O", function(module, exports) {
    'use strict';
    var $8a51N;
    var $71f7b254c38edcde$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
    module.exports = function availableTypedArrays() {
        var out = [];
        for(var i = 0; i < (0, parcelRequire("8a51N")).length; i++)if (typeof $71f7b254c38edcde$var$g[(0, parcelRequire("8a51N"))[i]] === 'function') out[out.length] = (0, parcelRequire("8a51N"))[i];
        return out;
    };
});
parcelRegister("8a51N", function(module, exports) {
    'use strict';
    module.exports = [
        'Float32Array',
        'Float64Array',
        'Int8Array',
        'Int16Array',
        'Int32Array',
        'Uint8Array',
        'Uint8ClampedArray',
        'Uint16Array',
        'Uint32Array',
        'BigInt64Array',
        'BigUint64Array'
    ];
});
parcelRegister("dFTgY", function(module, exports) {
    'use strict';
    var $hdl59;
    module.exports = function isTypedArray(value) {
        return !!(0, parcelRequire("hdl59"))(value);
    };
});
parcelRegister("kEU0N", function(module, exports) {
    module.exports = function isBuffer(arg) {
        return arg && typeof arg === 'object' && typeof arg.copy === 'function' && typeof arg.fill === 'function' && typeof arg.readUInt8 === 'function';
    };
});
parcelRegister("v3bBu", function(module, exports) {
    if (typeof Object.create === 'function') module.exports = function inherits(ctor, superCtor) {
        if (superCtor) {
            ctor.super_ = superCtor;
            ctor.prototype = Object.create(superCtor.prototype, {
                constructor: {
                    value: ctor,
                    enumerable: false,
                    writable: true,
                    configurable: true
                }
            });
        }
    };
    else module.exports = function inherits(ctor, superCtor) {
        if (superCtor) {
            ctor.super_ = superCtor;
            var TempCtor = function() {};
            TempCtor.prototype = superCtor.prototype;
            ctor.prototype = new TempCtor();
            ctor.prototype.constructor = ctor;
        }
    };
});
parcelRegister("3ZLjA", function(module, exports) {
    var $6cAn5 = parcelRequire("6cAn5");
    'use strict';
    function $2e8bc5606025d797$var$ownKeys(e, r) {
        var t = Object.keys(e);
        if (Object.getOwnPropertySymbols) {
            var o = Object.getOwnPropertySymbols(e);
            r && (o = o.filter(function(r) {
                return Object.getOwnPropertyDescriptor(e, r).enumerable;
            })), t.push.apply(t, o);
        }
        return t;
    }
    function $2e8bc5606025d797$var$_objectSpread(e) {
        for(var r = 1; r < arguments.length; r++){
            var t = null != arguments[r] ? arguments[r] : {};
            r % 2 ? $2e8bc5606025d797$var$ownKeys(Object(t), !0).forEach(function(r) {
                $2e8bc5606025d797$var$_defineProperty(e, r, t[r]);
            }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2e8bc5606025d797$var$ownKeys(Object(t)).forEach(function(r) {
                Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
            });
        }
        return e;
    }
    function $2e8bc5606025d797$var$_defineProperty(obj, key, value) {
        key = $2e8bc5606025d797$var$_toPropertyKey(key);
        if (key in obj) Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        else obj[key] = value;
        return obj;
    }
    function $2e8bc5606025d797$var$_classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
    }
    function $2e8bc5606025d797$var$_defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, $2e8bc5606025d797$var$_toPropertyKey(descriptor.key), descriptor);
        }
    }
    function $2e8bc5606025d797$var$_createClass(Constructor, protoProps, staticProps) {
        if (protoProps) $2e8bc5606025d797$var$_defineProperties(Constructor.prototype, protoProps);
        if (staticProps) $2e8bc5606025d797$var$_defineProperties(Constructor, staticProps);
        Object.defineProperty(Constructor, "prototype", {
            writable: false
        });
        return Constructor;
    }
    function $2e8bc5606025d797$var$_toPropertyKey(arg) {
        var key = $2e8bc5606025d797$var$_toPrimitive(arg, "string");
        return $2e8bc5606025d797$var$_typeof(key) === "symbol" ? key : String(key);
    }
    function $2e8bc5606025d797$var$_toPrimitive(input, hint) {
        if ($2e8bc5606025d797$var$_typeof(input) !== "object" || input === null) return input;
        var prim = input[Symbol.toPrimitive];
        if (prim !== undefined) {
            var res = prim.call(input, hint || "default");
            if ($2e8bc5606025d797$var$_typeof(res) !== "object") return res;
            throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return (hint === "string" ? String : Number)(input);
    }
    function $2e8bc5606025d797$var$_inherits(subClass, superClass) {
        if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
        subClass.prototype = Object.create(superClass && superClass.prototype, {
            constructor: {
                value: subClass,
                writable: true,
                configurable: true
            }
        });
        Object.defineProperty(subClass, "prototype", {
            writable: false
        });
        if (superClass) $2e8bc5606025d797$var$_setPrototypeOf(subClass, superClass);
    }
    function $2e8bc5606025d797$var$_createSuper(Derived) {
        var hasNativeReflectConstruct = $2e8bc5606025d797$var$_isNativeReflectConstruct();
        return function _createSuperInternal() {
            var Super = $2e8bc5606025d797$var$_getPrototypeOf(Derived), result;
            if (hasNativeReflectConstruct) {
                var NewTarget = $2e8bc5606025d797$var$_getPrototypeOf(this).constructor;
                result = Reflect.construct(Super, arguments, NewTarget);
            } else result = Super.apply(this, arguments);
            return $2e8bc5606025d797$var$_possibleConstructorReturn(this, result);
        };
    }
    function $2e8bc5606025d797$var$_possibleConstructorReturn(self, call) {
        if (call && ($2e8bc5606025d797$var$_typeof(call) === "object" || typeof call === "function")) return call;
        else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
        return $2e8bc5606025d797$var$_assertThisInitialized(self);
    }
    function $2e8bc5606025d797$var$_assertThisInitialized(self) {
        if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return self;
    }
    function $2e8bc5606025d797$var$_wrapNativeSuper(Class) {
        var _cache = typeof Map === "function" ? new Map() : undefined;
        $2e8bc5606025d797$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
            if (Class === null || !$2e8bc5606025d797$var$_isNativeFunction(Class)) return Class;
            if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
            if (typeof _cache !== "undefined") {
                if (_cache.has(Class)) return _cache.get(Class);
                _cache.set(Class, Wrapper);
            }
            function Wrapper() {
                return $2e8bc5606025d797$var$_construct(Class, arguments, $2e8bc5606025d797$var$_getPrototypeOf(this).constructor);
            }
            Wrapper.prototype = Object.create(Class.prototype, {
                constructor: {
                    value: Wrapper,
                    enumerable: false,
                    writable: true,
                    configurable: true
                }
            });
            return $2e8bc5606025d797$var$_setPrototypeOf(Wrapper, Class);
        };
        return $2e8bc5606025d797$var$_wrapNativeSuper(Class);
    }
    function $2e8bc5606025d797$var$_construct(Parent, args, Class) {
        if ($2e8bc5606025d797$var$_isNativeReflectConstruct()) $2e8bc5606025d797$var$_construct = Reflect.construct.bind();
        else $2e8bc5606025d797$var$_construct = function _construct(Parent, args, Class) {
            var a = [
                null
            ];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();
            if (Class) $2e8bc5606025d797$var$_setPrototypeOf(instance, Class.prototype);
            return instance;
        };
        return $2e8bc5606025d797$var$_construct.apply(null, arguments);
    }
    function $2e8bc5606025d797$var$_isNativeReflectConstruct() {
        if (typeof Reflect === "undefined" || !Reflect.construct) return false;
        if (Reflect.construct.sham) return false;
        if (typeof Proxy === "function") return true;
        try {
            Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            return true;
        } catch (e) {
            return false;
        }
    }
    function $2e8bc5606025d797$var$_isNativeFunction(fn) {
        return Function.toString.call(fn).indexOf("[native code]") !== -1;
    }
    function $2e8bc5606025d797$var$_setPrototypeOf(o, p) {
        $2e8bc5606025d797$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return $2e8bc5606025d797$var$_setPrototypeOf(o, p);
    }
    function $2e8bc5606025d797$var$_getPrototypeOf(o) {
        $2e8bc5606025d797$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
            return o.__proto__ || Object.getPrototypeOf(o);
        };
        return $2e8bc5606025d797$var$_getPrototypeOf(o);
    }
    function $2e8bc5606025d797$var$_typeof(o) {
        "@babel/helpers - typeof";
        return $2e8bc5606025d797$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
            return typeof o;
        } : function(o) {
            return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
        }, $2e8bc5606025d797$var$_typeof(o);
    }
    var $9kAQu = parcelRequire("9kAQu");
    var $2e8bc5606025d797$var$inspect = $9kAQu.inspect;
    var $8JAro = parcelRequire("8JAro");
    var $2e8bc5606025d797$var$ERR_INVALID_ARG_TYPE = $8JAro.codes.ERR_INVALID_ARG_TYPE;
    function $2e8bc5606025d797$var$endsWith(str, search, this_len) {
        if (this_len === undefined || this_len > str.length) this_len = str.length;
        return str.substring(this_len - search.length, this_len) === search;
    }
    function $2e8bc5606025d797$var$repeat(str, count) {
        count = Math.floor(count);
        if (str.length == 0 || count == 0) return '';
        var maxCount = str.length * count;
        count = Math.floor(Math.log(count) / Math.log(2));
        while(count){
            str += str;
            count--;
        }
        str += str.substring(0, maxCount - str.length);
        return str;
    }
    var $2e8bc5606025d797$var$blue = '';
    var $2e8bc5606025d797$var$green = '';
    var $2e8bc5606025d797$var$red = '';
    var $2e8bc5606025d797$var$white = '';
    var $2e8bc5606025d797$var$kReadableOperator = {
        deepStrictEqual: 'Expected values to be strictly deep-equal:',
        strictEqual: 'Expected values to be strictly equal:',
        strictEqualObject: 'Expected "actual" to be reference-equal to "expected":',
        deepEqual: 'Expected values to be loosely deep-equal:',
        equal: 'Expected values to be loosely equal:',
        notDeepStrictEqual: 'Expected "actual" not to be strictly deep-equal to:',
        notStrictEqual: 'Expected "actual" to be strictly unequal to:',
        notStrictEqualObject: 'Expected "actual" not to be reference-equal to "expected":',
        notDeepEqual: 'Expected "actual" not to be loosely deep-equal to:',
        notEqual: 'Expected "actual" to be loosely unequal to:',
        notIdentical: 'Values identical but not reference-equal:'
    };
    var $2e8bc5606025d797$var$kMaxShortLength = 10;
    function $2e8bc5606025d797$var$copyError(source) {
        var keys = Object.keys(source);
        var target = Object.create(Object.getPrototypeOf(source));
        keys.forEach(function(key) {
            target[key] = source[key];
        });
        Object.defineProperty(target, 'message', {
            value: source.message
        });
        return target;
    }
    function $2e8bc5606025d797$var$inspectValue(val) {
        return $2e8bc5606025d797$var$inspect(val, {
            compact: false,
            customInspect: false,
            depth: 1000,
            maxArrayLength: Infinity,
            showHidden: false,
            breakLength: Infinity,
            showProxy: false,
            sorted: true,
            getters: true
        });
    }
    function $2e8bc5606025d797$var$createErrDiff(actual, expected, operator) {
        var other = '';
        var res = '';
        var lastPos = 0;
        var end = '';
        var skipped = false;
        var actualInspected = $2e8bc5606025d797$var$inspectValue(actual);
        var actualLines = actualInspected.split('\n');
        var expectedLines = $2e8bc5606025d797$var$inspectValue(expected).split('\n');
        var i = 0;
        var indicator = '';
        if (operator === 'strictEqual' && $2e8bc5606025d797$var$_typeof(actual) === 'object' && $2e8bc5606025d797$var$_typeof(expected) === 'object' && actual !== null && expected !== null) operator = 'strictEqualObject';
        if (actualLines.length === 1 && expectedLines.length === 1 && actualLines[0] !== expectedLines[0]) {
            var inputLength = actualLines[0].length + expectedLines[0].length;
            if (inputLength <= $2e8bc5606025d797$var$kMaxShortLength) {
                if (($2e8bc5606025d797$var$_typeof(actual) !== 'object' || actual === null) && ($2e8bc5606025d797$var$_typeof(expected) !== 'object' || expected === null) && (actual !== 0 || expected !== 0)) return "".concat($2e8bc5606025d797$var$kReadableOperator[operator], "\n\n") + "".concat(actualLines[0], " !== ").concat(expectedLines[0], "\n");
            } else if (operator !== 'strictEqualObject') {
                var maxLength = $6cAn5.stderr && $6cAn5.stderr.isTTY ? $6cAn5.stderr.columns : 80;
                if (inputLength < maxLength) {
                    while(actualLines[0][i] === expectedLines[0][i])i++;
                    if (i > 2) {
                        indicator = "\n  ".concat($2e8bc5606025d797$var$repeat(' ', i), "^");
                        i = 0;
                    }
                }
            }
        }
        var a = actualLines[actualLines.length - 1];
        var b = expectedLines[expectedLines.length - 1];
        while(a === b){
            if (i++ < 2) end = "\n  ".concat(a).concat(end);
            else other = a;
            actualLines.pop();
            expectedLines.pop();
            if (actualLines.length === 0 || expectedLines.length === 0) break;
            a = actualLines[actualLines.length - 1];
            b = expectedLines[expectedLines.length - 1];
        }
        var maxLines = Math.max(actualLines.length, expectedLines.length);
        if (maxLines === 0) {
            var _actualLines = actualInspected.split('\n');
            if (_actualLines.length > 30) {
                _actualLines[26] = "".concat($2e8bc5606025d797$var$blue, "...").concat($2e8bc5606025d797$var$white);
                while(_actualLines.length > 27)_actualLines.pop();
            }
            return "".concat($2e8bc5606025d797$var$kReadableOperator.notIdentical, "\n\n").concat(_actualLines.join('\n'), "\n");
        }
        if (i > 3) {
            end = "\n".concat($2e8bc5606025d797$var$blue, "...").concat($2e8bc5606025d797$var$white).concat(end);
            skipped = true;
        }
        if (other !== '') {
            end = "\n  ".concat(other).concat(end);
            other = '';
        }
        var printedLines = 0;
        var msg = $2e8bc5606025d797$var$kReadableOperator[operator] + "\n".concat($2e8bc5606025d797$var$green, "+ actual").concat($2e8bc5606025d797$var$white, " ").concat($2e8bc5606025d797$var$red, "- expected").concat($2e8bc5606025d797$var$white);
        var skippedMsg = " ".concat($2e8bc5606025d797$var$blue, "...").concat($2e8bc5606025d797$var$white, " Lines skipped");
        for(i = 0; i < maxLines; i++){
            var cur = i - lastPos;
            if (actualLines.length < i + 1) {
                if (cur > 1 && i > 2) {
                    if (cur > 4) {
                        res += "\n".concat($2e8bc5606025d797$var$blue, "...").concat($2e8bc5606025d797$var$white);
                        skipped = true;
                    } else if (cur > 3) {
                        res += "\n  ".concat(expectedLines[i - 2]);
                        printedLines++;
                    }
                    res += "\n  ".concat(expectedLines[i - 1]);
                    printedLines++;
                }
                lastPos = i;
                other += "\n".concat($2e8bc5606025d797$var$red, "-").concat($2e8bc5606025d797$var$white, " ").concat(expectedLines[i]);
                printedLines++;
            } else if (expectedLines.length < i + 1) {
                if (cur > 1 && i > 2) {
                    if (cur > 4) {
                        res += "\n".concat($2e8bc5606025d797$var$blue, "...").concat($2e8bc5606025d797$var$white);
                        skipped = true;
                    } else if (cur > 3) {
                        res += "\n  ".concat(actualLines[i - 2]);
                        printedLines++;
                    }
                    res += "\n  ".concat(actualLines[i - 1]);
                    printedLines++;
                }
                lastPos = i;
                res += "\n".concat($2e8bc5606025d797$var$green, "+").concat($2e8bc5606025d797$var$white, " ").concat(actualLines[i]);
                printedLines++;
            } else {
                var expectedLine = expectedLines[i];
                var actualLine = actualLines[i];
                var divergingLines = actualLine !== expectedLine && (!$2e8bc5606025d797$var$endsWith(actualLine, ',') || actualLine.slice(0, -1) !== expectedLine);
                if (divergingLines && $2e8bc5606025d797$var$endsWith(expectedLine, ',') && expectedLine.slice(0, -1) === actualLine) {
                    divergingLines = false;
                    actualLine += ',';
                }
                if (divergingLines) {
                    if (cur > 1 && i > 2) {
                        if (cur > 4) {
                            res += "\n".concat($2e8bc5606025d797$var$blue, "...").concat($2e8bc5606025d797$var$white);
                            skipped = true;
                        } else if (cur > 3) {
                            res += "\n  ".concat(actualLines[i - 2]);
                            printedLines++;
                        }
                        res += "\n  ".concat(actualLines[i - 1]);
                        printedLines++;
                    }
                    lastPos = i;
                    res += "\n".concat($2e8bc5606025d797$var$green, "+").concat($2e8bc5606025d797$var$white, " ").concat(actualLine);
                    other += "\n".concat($2e8bc5606025d797$var$red, "-").concat($2e8bc5606025d797$var$white, " ").concat(expectedLine);
                    printedLines += 2;
                } else {
                    res += other;
                    other = '';
                    if (cur === 1 || i === 0) {
                        res += "\n  ".concat(actualLine);
                        printedLines++;
                    }
                }
            }
            if (printedLines > 20 && i < maxLines - 2) return "".concat(msg).concat(skippedMsg, "\n").concat(res, "\n").concat($2e8bc5606025d797$var$blue, "...").concat($2e8bc5606025d797$var$white).concat(other, "\n") + "".concat($2e8bc5606025d797$var$blue, "...").concat($2e8bc5606025d797$var$white);
        }
        return "".concat(msg).concat(skipped ? skippedMsg : '', "\n").concat(res).concat(other).concat(end).concat(indicator);
    }
    var $2e8bc5606025d797$var$AssertionError = function(_Error, _inspect$custom) {
        $2e8bc5606025d797$var$_inherits(AssertionError, _Error);
        var _super = $2e8bc5606025d797$var$_createSuper(AssertionError);
        function AssertionError(options) {
            var _this;
            $2e8bc5606025d797$var$_classCallCheck(this, AssertionError);
            if ($2e8bc5606025d797$var$_typeof(options) !== 'object' || options === null) throw new $2e8bc5606025d797$var$ERR_INVALID_ARG_TYPE('options', 'Object', options);
            var message = options.message, operator = options.operator, stackStartFn = options.stackStartFn;
            var actual = options.actual, expected = options.expected;
            var limit = Error.stackTraceLimit;
            Error.stackTraceLimit = 0;
            if (message != null) _this = _super.call(this, String(message));
            else {
                if ($6cAn5.stderr && $6cAn5.stderr.isTTY) {
                    if ($6cAn5.stderr && $6cAn5.stderr.getColorDepth && $6cAn5.stderr.getColorDepth() !== 1) {
                        $2e8bc5606025d797$var$blue = "\x1B[34m";
                        $2e8bc5606025d797$var$green = "\x1B[32m";
                        $2e8bc5606025d797$var$white = "\x1B[39m";
                        $2e8bc5606025d797$var$red = "\x1B[31m";
                    } else {
                        $2e8bc5606025d797$var$blue = '';
                        $2e8bc5606025d797$var$green = '';
                        $2e8bc5606025d797$var$white = '';
                        $2e8bc5606025d797$var$red = '';
                    }
                }
                if ($2e8bc5606025d797$var$_typeof(actual) === 'object' && actual !== null && $2e8bc5606025d797$var$_typeof(expected) === 'object' && expected !== null && 'stack' in actual && actual instanceof Error && 'stack' in expected && expected instanceof Error) {
                    actual = $2e8bc5606025d797$var$copyError(actual);
                    expected = $2e8bc5606025d797$var$copyError(expected);
                }
                if (operator === 'deepStrictEqual' || operator === 'strictEqual') _this = _super.call(this, $2e8bc5606025d797$var$createErrDiff(actual, expected, operator));
                else if (operator === 'notDeepStrictEqual' || operator === 'notStrictEqual') {
                    var base = $2e8bc5606025d797$var$kReadableOperator[operator];
                    var res = $2e8bc5606025d797$var$inspectValue(actual).split('\n');
                    if (operator === 'notStrictEqual' && $2e8bc5606025d797$var$_typeof(actual) === 'object' && actual !== null) base = $2e8bc5606025d797$var$kReadableOperator.notStrictEqualObject;
                    if (res.length > 30) {
                        res[26] = "".concat($2e8bc5606025d797$var$blue, "...").concat($2e8bc5606025d797$var$white);
                        while(res.length > 27)res.pop();
                    }
                    if (res.length === 1) _this = _super.call(this, "".concat(base, " ").concat(res[0]));
                    else _this = _super.call(this, "".concat(base, "\n\n").concat(res.join('\n'), "\n"));
                } else {
                    var _res = $2e8bc5606025d797$var$inspectValue(actual);
                    var other = '';
                    var knownOperators = $2e8bc5606025d797$var$kReadableOperator[operator];
                    if (operator === 'notDeepEqual' || operator === 'notEqual') {
                        _res = "".concat($2e8bc5606025d797$var$kReadableOperator[operator], "\n\n").concat(_res);
                        if (_res.length > 1024) _res = "".concat(_res.slice(0, 1021), "...");
                    } else {
                        other = "".concat($2e8bc5606025d797$var$inspectValue(expected));
                        if (_res.length > 512) _res = "".concat(_res.slice(0, 509), "...");
                        if (other.length > 512) other = "".concat(other.slice(0, 509), "...");
                        if (operator === 'deepEqual' || operator === 'equal') _res = "".concat(knownOperators, "\n\n").concat(_res, "\n\nshould equal\n\n");
                        else other = " ".concat(operator, " ").concat(other);
                    }
                    _this = _super.call(this, "".concat(_res).concat(other));
                }
            }
            Error.stackTraceLimit = limit;
            _this.generatedMessage = !message;
            Object.defineProperty($2e8bc5606025d797$var$_assertThisInitialized(_this), 'name', {
                value: 'AssertionError [ERR_ASSERTION]',
                enumerable: false,
                writable: true,
                configurable: true
            });
            _this.code = 'ERR_ASSERTION';
            _this.actual = actual;
            _this.expected = expected;
            _this.operator = operator;
            if (Error.captureStackTrace) Error.captureStackTrace($2e8bc5606025d797$var$_assertThisInitialized(_this), stackStartFn);
            _this.stack;
            _this.name = 'AssertionError';
            return $2e8bc5606025d797$var$_possibleConstructorReturn(_this);
        }
        $2e8bc5606025d797$var$_createClass(AssertionError, [
            {
                key: "toString",
                value: function toString() {
                    return "".concat(this.name, " [").concat(this.code, "]: ").concat(this.message);
                }
            },
            {
                key: _inspect$custom,
                value: function value(recurseTimes, ctx) {
                    return $2e8bc5606025d797$var$inspect(this, $2e8bc5606025d797$var$_objectSpread($2e8bc5606025d797$var$_objectSpread({}, ctx), {}, {
                        customInspect: false,
                        depth: 0
                    }));
                }
            }
        ]);
        return AssertionError;
    }($2e8bc5606025d797$var$_wrapNativeSuper(Error), $2e8bc5606025d797$var$inspect.custom);
    module.exports = $2e8bc5606025d797$var$AssertionError;
});
parcelRegister("8s5ew", function(module, exports) {
    'use strict';
    var $3WQC3 = parcelRequire("3WQC3");
    var $0196883fce51d67b$var$lacksProperEnumerationOrder = function() {
        if (!Object.assign) return false;
        var str = 'abcdefghijklmnopqrst';
        var letters = str.split('');
        var map = {};
        for(var i = 0; i < letters.length; ++i)map[letters[i]] = letters[i];
        var obj = Object.assign({}, map);
        var actual = '';
        for(var k in obj)actual += k;
        return str !== actual;
    };
    var $0196883fce51d67b$var$assignHasPendingExceptions = function() {
        if (!Object.assign || !Object.preventExtensions) return false;
        var thrower = Object.preventExtensions({
            1: 2
        });
        try {
            Object.assign(thrower, 'xy');
        } catch (e) {
            return thrower[1] === 'y';
        }
        return false;
    };
    module.exports = function getPolyfill() {
        if (!Object.assign) return $3WQC3;
        if ($0196883fce51d67b$var$lacksProperEnumerationOrder()) return $3WQC3;
        if ($0196883fce51d67b$var$assignHasPendingExceptions()) return $3WQC3;
        return Object.assign;
    };
});
parcelRegister("3WQC3", function(module, exports) {
    'use strict';
    var $dZMWQ = parcelRequire("dZMWQ");
    var $2dff99ad8985d37e$var$hasSymbols = (parcelRequire("9T9x9"))();
    var $53KqO = parcelRequire("53KqO");
    var $2dff99ad8985d37e$var$toObject = Object;
    var $2dff99ad8985d37e$var$$push = $53KqO('Array.prototype.push');
    var $2dff99ad8985d37e$var$$propIsEnumerable = $53KqO('Object.prototype.propertyIsEnumerable');
    var $2dff99ad8985d37e$var$originalGetSymbols = $2dff99ad8985d37e$var$hasSymbols ? Object.getOwnPropertySymbols : null;
    module.exports = function assign(target, source1) {
        if (target == null) throw new TypeError('target must be an object');
        var to = $2dff99ad8985d37e$var$toObject(target);
        if (arguments.length === 1) return to;
        for(var s = 1; s < arguments.length; ++s){
            var from = $2dff99ad8985d37e$var$toObject(arguments[s]);
            var keys = $dZMWQ(from);
            var getSymbols = $2dff99ad8985d37e$var$hasSymbols && (Object.getOwnPropertySymbols || $2dff99ad8985d37e$var$originalGetSymbols);
            if (getSymbols) {
                var syms = getSymbols(from);
                for(var j = 0; j < syms.length; ++j){
                    var key = syms[j];
                    if ($2dff99ad8985d37e$var$$propIsEnumerable(from, key)) $2dff99ad8985d37e$var$$push(keys, key);
                }
            }
            for(var i = 0; i < keys.length; ++i){
                var nextKey = keys[i];
                if ($2dff99ad8985d37e$var$$propIsEnumerable(from, nextKey)) {
                    var propValue = from[nextKey];
                    to[nextKey] = propValue;
                }
            }
        }
        return to;
    };
});
parcelRegister("dZMWQ", function(module, exports) {
    'use strict';
    var $a306f0f1bb5f232a$var$slice = Array.prototype.slice;
    var $1Houy = parcelRequire("1Houy");
    var $a306f0f1bb5f232a$var$origKeys = Object.keys;
    var $a306f0f1bb5f232a$var$keysShim = $a306f0f1bb5f232a$var$origKeys ? function keys(o) {
        return $a306f0f1bb5f232a$var$origKeys(o);
    } : (parcelRequire("eQVXL"));
    var $a306f0f1bb5f232a$var$originalKeys = Object.keys;
    $a306f0f1bb5f232a$var$keysShim.shim = function shimObjectKeys() {
        if (Object.keys) {
            var keysWorksWithArguments = function() {
                var args = Object.keys(arguments);
                return args && args.length === arguments.length;
            }(1, 2);
            if (!keysWorksWithArguments) Object.keys = function keys(object) {
                if ($1Houy(object)) return $a306f0f1bb5f232a$var$originalKeys($a306f0f1bb5f232a$var$slice.call(object));
                return $a306f0f1bb5f232a$var$originalKeys(object);
            };
        } else Object.keys = $a306f0f1bb5f232a$var$keysShim;
        return Object.keys || $a306f0f1bb5f232a$var$keysShim;
    };
    module.exports = $a306f0f1bb5f232a$var$keysShim;
});
parcelRegister("1Houy", function(module, exports) {
    'use strict';
    var $13ccce2fa6936c75$var$toStr = Object.prototype.toString;
    module.exports = function isArguments(value) {
        var str = $13ccce2fa6936c75$var$toStr.call(value);
        var isArgs = str === '[object Arguments]';
        if (!isArgs) isArgs = str !== '[object Array]' && value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $13ccce2fa6936c75$var$toStr.call(value.callee) === '[object Function]';
        return isArgs;
    };
});
parcelRegister("eQVXL", function(module, exports) {
    'use strict';
    var $ad02e23a59d3730f$var$keysShim;
    if (!Object.keys) {
        var $ad02e23a59d3730f$var$has = Object.prototype.hasOwnProperty;
        var $ad02e23a59d3730f$var$toStr = Object.prototype.toString;
        var $ad02e23a59d3730f$var$isArgs = (parcelRequire("1Houy"));
        var $ad02e23a59d3730f$var$isEnumerable = Object.prototype.propertyIsEnumerable;
        var $ad02e23a59d3730f$var$hasDontEnumBug = !$ad02e23a59d3730f$var$isEnumerable.call({
            toString: null
        }, 'toString');
        var $ad02e23a59d3730f$var$hasProtoEnumBug = $ad02e23a59d3730f$var$isEnumerable.call(function() {}, 'prototype');
        var $ad02e23a59d3730f$var$dontEnums = [
            'toString',
            'toLocaleString',
            'valueOf',
            'hasOwnProperty',
            'isPrototypeOf',
            'propertyIsEnumerable',
            'constructor'
        ];
        var $ad02e23a59d3730f$var$equalsConstructorPrototype = function(o) {
            var ctor = o.constructor;
            return ctor && ctor.prototype === o;
        };
        var $ad02e23a59d3730f$var$excludedKeys = {
            $applicationCache: true,
            $console: true,
            $external: true,
            $frame: true,
            $frameElement: true,
            $frames: true,
            $innerHeight: true,
            $innerWidth: true,
            $onmozfullscreenchange: true,
            $onmozfullscreenerror: true,
            $outerHeight: true,
            $outerWidth: true,
            $pageXOffset: true,
            $pageYOffset: true,
            $parent: true,
            $scrollLeft: true,
            $scrollTop: true,
            $scrollX: true,
            $scrollY: true,
            $self: true,
            $webkitIndexedDB: true,
            $webkitStorageInfo: true,
            $window: true
        };
        var $ad02e23a59d3730f$var$hasAutomationEqualityBug = function() {
            if (typeof window === 'undefined') return false;
            for(var k in window)try {
                if (!$ad02e23a59d3730f$var$excludedKeys['$' + k] && $ad02e23a59d3730f$var$has.call(window, k) && window[k] !== null && typeof window[k] === 'object') try {
                    $ad02e23a59d3730f$var$equalsConstructorPrototype(window[k]);
                } catch (e) {
                    return true;
                }
            } catch (e) {
                return true;
            }
            return false;
        }();
        var $ad02e23a59d3730f$var$equalsConstructorPrototypeIfNotBuggy = function(o) {
            if (typeof window === 'undefined' || !$ad02e23a59d3730f$var$hasAutomationEqualityBug) return $ad02e23a59d3730f$var$equalsConstructorPrototype(o);
            try {
                return $ad02e23a59d3730f$var$equalsConstructorPrototype(o);
            } catch (e) {
                return false;
            }
        };
        $ad02e23a59d3730f$var$keysShim = function keys(object) {
            var isObject = object !== null && typeof object === 'object';
            var isFunction = $ad02e23a59d3730f$var$toStr.call(object) === '[object Function]';
            var isArguments = $ad02e23a59d3730f$var$isArgs(object);
            var isString = isObject && $ad02e23a59d3730f$var$toStr.call(object) === '[object String]';
            var theKeys = [];
            if (!isObject && !isFunction && !isArguments) throw new TypeError('Object.keys called on a non-object');
            var skipProto = $ad02e23a59d3730f$var$hasProtoEnumBug && isFunction;
            if (isString && object.length > 0 && !$ad02e23a59d3730f$var$has.call(object, 0)) for(var i = 0; i < object.length; ++i)theKeys.push(String(i));
            if (isArguments && object.length > 0) for(var j = 0; j < object.length; ++j)theKeys.push(String(j));
            else {
                for(var name in object)if (!(skipProto && name === 'prototype') && $ad02e23a59d3730f$var$has.call(object, name)) theKeys.push(String(name));
            }
            if ($ad02e23a59d3730f$var$hasDontEnumBug) {
                var skipConstructor = $ad02e23a59d3730f$var$equalsConstructorPrototypeIfNotBuggy(object);
                for(var k = 0; k < $ad02e23a59d3730f$var$dontEnums.length; ++k)if (!(skipConstructor && $ad02e23a59d3730f$var$dontEnums[k] === 'constructor') && $ad02e23a59d3730f$var$has.call(object, $ad02e23a59d3730f$var$dontEnums[k])) theKeys.push($ad02e23a59d3730f$var$dontEnums[k]);
            }
            return theKeys;
        };
    }
    module.exports = $ad02e23a59d3730f$var$keysShim;
});
parcelRegister("eJazH", function(module, exports) {
    'use strict';
    var $iwNFM = parcelRequire("iwNFM");
    module.exports = function getPolyfill() {
        return typeof Object.is === 'function' ? Object.is : $iwNFM;
    };
});
parcelRegister("iwNFM", function(module, exports) {
    'use strict';
    var $d7d1bf25ec690182$var$numberIsNaN = function(value) {
        return value !== value;
    };
    module.exports = function is(a, b) {
        if (a === 0 && b === 0) return 1 / a === 1 / b;
        if (a === b) return true;
        if ($d7d1bf25ec690182$var$numberIsNaN(a) && $d7d1bf25ec690182$var$numberIsNaN(b)) return true;
        return false;
    };
});
parcelRegister("dztjv", function(module, exports) {
    'use strict';
    function $9e15485748de85e6$var$_slicedToArray(arr, i) {
        return $9e15485748de85e6$var$_arrayWithHoles(arr) || $9e15485748de85e6$var$_iterableToArrayLimit(arr, i) || $9e15485748de85e6$var$_unsupportedIterableToArray(arr, i) || $9e15485748de85e6$var$_nonIterableRest();
    }
    function $9e15485748de85e6$var$_nonIterableRest() {
        throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    function $9e15485748de85e6$var$_unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return $9e15485748de85e6$var$_arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $9e15485748de85e6$var$_arrayLikeToArray(o, minLen);
    }
    function $9e15485748de85e6$var$_arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    function $9e15485748de85e6$var$_iterableToArrayLimit(r, l) {
        var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
        if (null != t) {
            var e, n, i, u, a = [], f = !0, o = !1;
            try {
                if (i = (t = t.call(r)).next, 0 === l) {
                    if (Object(t) !== t) return;
                    f = !1;
                } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
            } catch (r) {
                o = !0, n = r;
            } finally{
                try {
                    if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
                } finally{
                    if (o) throw n;
                }
            }
            return a;
        }
    }
    function $9e15485748de85e6$var$_arrayWithHoles(arr) {
        if (Array.isArray(arr)) return arr;
    }
    function $9e15485748de85e6$var$_typeof(o) {
        "@babel/helpers - typeof";
        return $9e15485748de85e6$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
            return typeof o;
        } : function(o) {
            return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
        }, $9e15485748de85e6$var$_typeof(o);
    }
    var $9e15485748de85e6$var$regexFlagsSupported = /a/g.flags !== undefined;
    var $9e15485748de85e6$var$arrayFromSet = function arrayFromSet(set) {
        var array = [];
        set.forEach(function(value) {
            return array.push(value);
        });
        return array;
    };
    var $9e15485748de85e6$var$arrayFromMap = function arrayFromMap(map) {
        var array = [];
        map.forEach(function(value, key) {
            return array.push([
                key,
                value
            ]);
        });
        return array;
    };
    var $9e15485748de85e6$var$objectIs = Object.is ? Object.is : (parcelRequire("joK88"));
    var $9e15485748de85e6$var$objectGetOwnPropertySymbols = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols : function() {
        return [];
    };
    var $9e15485748de85e6$var$numberIsNaN = Number.isNaN ? Number.isNaN : (parcelRequire("laO4W"));
    function $9e15485748de85e6$var$uncurryThis(f) {
        return f.call.bind(f);
    }
    var $9e15485748de85e6$var$hasOwnProperty = $9e15485748de85e6$var$uncurryThis(Object.prototype.hasOwnProperty);
    var $9e15485748de85e6$var$propertyIsEnumerable = $9e15485748de85e6$var$uncurryThis(Object.prototype.propertyIsEnumerable);
    var $9e15485748de85e6$var$objectToString = $9e15485748de85e6$var$uncurryThis(Object.prototype.toString);
    var $9kAQu = parcelRequire("9kAQu");
    var $9e15485748de85e6$require$_require$types = $9kAQu.types;
    var $9e15485748de85e6$var$isAnyArrayBuffer = $9e15485748de85e6$require$_require$types.isAnyArrayBuffer, $9e15485748de85e6$var$isArrayBufferView = $9e15485748de85e6$require$_require$types.isArrayBufferView, $9e15485748de85e6$var$isDate = $9e15485748de85e6$require$_require$types.isDate, $9e15485748de85e6$var$isMap = $9e15485748de85e6$require$_require$types.isMap, $9e15485748de85e6$var$isRegExp = $9e15485748de85e6$require$_require$types.isRegExp, $9e15485748de85e6$var$isSet = $9e15485748de85e6$require$_require$types.isSet, $9e15485748de85e6$var$isNativeError = $9e15485748de85e6$require$_require$types.isNativeError, $9e15485748de85e6$var$isBoxedPrimitive = $9e15485748de85e6$require$_require$types.isBoxedPrimitive, $9e15485748de85e6$var$isNumberObject = $9e15485748de85e6$require$_require$types.isNumberObject, $9e15485748de85e6$var$isStringObject = $9e15485748de85e6$require$_require$types.isStringObject, $9e15485748de85e6$var$isBooleanObject = $9e15485748de85e6$require$_require$types.isBooleanObject, $9e15485748de85e6$var$isBigIntObject = $9e15485748de85e6$require$_require$types.isBigIntObject, $9e15485748de85e6$var$isSymbolObject = $9e15485748de85e6$require$_require$types.isSymbolObject, $9e15485748de85e6$var$isFloat32Array = $9e15485748de85e6$require$_require$types.isFloat32Array, $9e15485748de85e6$var$isFloat64Array = $9e15485748de85e6$require$_require$types.isFloat64Array;
    function $9e15485748de85e6$var$isNonIndex(key) {
        if (key.length === 0 || key.length > 10) return true;
        for(var i = 0; i < key.length; i++){
            var code = key.charCodeAt(i);
            if (code < 48 || code > 57) return true;
        }
        return key.length === 10 && key >= Math.pow(2, 32);
    }
    function $9e15485748de85e6$var$getOwnNonIndexProperties(value) {
        return Object.keys(value).filter($9e15485748de85e6$var$isNonIndex).concat($9e15485748de85e6$var$objectGetOwnPropertySymbols(value).filter(Object.prototype.propertyIsEnumerable.bind(value)));
    }
    function $9e15485748de85e6$var$compare(a, b) {
        if (a === b) return 0;
        var x = a.length;
        var y = b.length;
        for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
            x = a[i];
            y = b[i];
            break;
        }
        if (x < y) return -1;
        if (y < x) return 1;
        return 0;
    }
    var $9e15485748de85e6$var$ONLY_ENUMERABLE = undefined;
    var $9e15485748de85e6$var$kStrict = true;
    var $9e15485748de85e6$var$kLoose = false;
    var $9e15485748de85e6$var$kNoIterator = 0;
    var $9e15485748de85e6$var$kIsArray = 1;
    var $9e15485748de85e6$var$kIsSet = 2;
    var $9e15485748de85e6$var$kIsMap = 3;
    function $9e15485748de85e6$var$areSimilarRegExps(a, b) {
        return $9e15485748de85e6$var$regexFlagsSupported ? a.source === b.source && a.flags === b.flags : RegExp.prototype.toString.call(a) === RegExp.prototype.toString.call(b);
    }
    function $9e15485748de85e6$var$areSimilarFloatArrays(a, b) {
        if (a.byteLength !== b.byteLength) return false;
        for(var offset = 0; offset < a.byteLength; offset++){
            if (a[offset] !== b[offset]) return false;
        }
        return true;
    }
    function $9e15485748de85e6$var$areSimilarTypedArrays(a, b) {
        if (a.byteLength !== b.byteLength) return false;
        return $9e15485748de85e6$var$compare(new Uint8Array(a.buffer, a.byteOffset, a.byteLength), new Uint8Array(b.buffer, b.byteOffset, b.byteLength)) === 0;
    }
    function $9e15485748de85e6$var$areEqualArrayBuffers(buf1, buf2) {
        return buf1.byteLength === buf2.byteLength && $9e15485748de85e6$var$compare(new Uint8Array(buf1), new Uint8Array(buf2)) === 0;
    }
    function $9e15485748de85e6$var$isEqualBoxedPrimitive(val1, val2) {
        if ($9e15485748de85e6$var$isNumberObject(val1)) return $9e15485748de85e6$var$isNumberObject(val2) && $9e15485748de85e6$var$objectIs(Number.prototype.valueOf.call(val1), Number.prototype.valueOf.call(val2));
        if ($9e15485748de85e6$var$isStringObject(val1)) return $9e15485748de85e6$var$isStringObject(val2) && String.prototype.valueOf.call(val1) === String.prototype.valueOf.call(val2);
        if ($9e15485748de85e6$var$isBooleanObject(val1)) return $9e15485748de85e6$var$isBooleanObject(val2) && Boolean.prototype.valueOf.call(val1) === Boolean.prototype.valueOf.call(val2);
        if ($9e15485748de85e6$var$isBigIntObject(val1)) return $9e15485748de85e6$var$isBigIntObject(val2) && BigInt.prototype.valueOf.call(val1) === BigInt.prototype.valueOf.call(val2);
        return $9e15485748de85e6$var$isSymbolObject(val2) && Symbol.prototype.valueOf.call(val1) === Symbol.prototype.valueOf.call(val2);
    }
    function $9e15485748de85e6$var$innerDeepEqual(val1, val2, strict, memos) {
        if (val1 === val2) {
            if (val1 !== 0) return true;
            return strict ? $9e15485748de85e6$var$objectIs(val1, val2) : true;
        }
        if (strict) {
            if ($9e15485748de85e6$var$_typeof(val1) !== 'object') return typeof val1 === 'number' && $9e15485748de85e6$var$numberIsNaN(val1) && $9e15485748de85e6$var$numberIsNaN(val2);
            if ($9e15485748de85e6$var$_typeof(val2) !== 'object' || val1 === null || val2 === null) return false;
            if (Object.getPrototypeOf(val1) !== Object.getPrototypeOf(val2)) return false;
        } else {
            if (val1 === null || $9e15485748de85e6$var$_typeof(val1) !== 'object') {
                if (val2 === null || $9e15485748de85e6$var$_typeof(val2) !== 'object') return val1 == val2;
                return false;
            }
            if (val2 === null || $9e15485748de85e6$var$_typeof(val2) !== 'object') return false;
        }
        var val1Tag = $9e15485748de85e6$var$objectToString(val1);
        var val2Tag = $9e15485748de85e6$var$objectToString(val2);
        if (val1Tag !== val2Tag) return false;
        if (Array.isArray(val1)) {
            if (val1.length !== val2.length) return false;
            var keys1 = $9e15485748de85e6$var$getOwnNonIndexProperties(val1, $9e15485748de85e6$var$ONLY_ENUMERABLE);
            var keys2 = $9e15485748de85e6$var$getOwnNonIndexProperties(val2, $9e15485748de85e6$var$ONLY_ENUMERABLE);
            if (keys1.length !== keys2.length) return false;
            return $9e15485748de85e6$var$keyCheck(val1, val2, strict, memos, $9e15485748de85e6$var$kIsArray, keys1);
        }
        if (val1Tag === '[object Object]') {
            if (!$9e15485748de85e6$var$isMap(val1) && $9e15485748de85e6$var$isMap(val2) || !$9e15485748de85e6$var$isSet(val1) && $9e15485748de85e6$var$isSet(val2)) return false;
        }
        if ($9e15485748de85e6$var$isDate(val1)) {
            if (!$9e15485748de85e6$var$isDate(val2) || Date.prototype.getTime.call(val1) !== Date.prototype.getTime.call(val2)) return false;
        } else if ($9e15485748de85e6$var$isRegExp(val1)) {
            if (!$9e15485748de85e6$var$isRegExp(val2) || !$9e15485748de85e6$var$areSimilarRegExps(val1, val2)) return false;
        } else if ($9e15485748de85e6$var$isNativeError(val1) || val1 instanceof Error) {
            if (val1.message !== val2.message || val1.name !== val2.name) return false;
        } else if ($9e15485748de85e6$var$isArrayBufferView(val1)) {
            if (!strict && ($9e15485748de85e6$var$isFloat32Array(val1) || $9e15485748de85e6$var$isFloat64Array(val1))) {
                if (!$9e15485748de85e6$var$areSimilarFloatArrays(val1, val2)) return false;
            } else if (!$9e15485748de85e6$var$areSimilarTypedArrays(val1, val2)) return false;
            var _keys = $9e15485748de85e6$var$getOwnNonIndexProperties(val1, $9e15485748de85e6$var$ONLY_ENUMERABLE);
            var _keys2 = $9e15485748de85e6$var$getOwnNonIndexProperties(val2, $9e15485748de85e6$var$ONLY_ENUMERABLE);
            if (_keys.length !== _keys2.length) return false;
            return $9e15485748de85e6$var$keyCheck(val1, val2, strict, memos, $9e15485748de85e6$var$kNoIterator, _keys);
        } else if ($9e15485748de85e6$var$isSet(val1)) {
            if (!$9e15485748de85e6$var$isSet(val2) || val1.size !== val2.size) return false;
            return $9e15485748de85e6$var$keyCheck(val1, val2, strict, memos, $9e15485748de85e6$var$kIsSet);
        } else if ($9e15485748de85e6$var$isMap(val1)) {
            if (!$9e15485748de85e6$var$isMap(val2) || val1.size !== val2.size) return false;
            return $9e15485748de85e6$var$keyCheck(val1, val2, strict, memos, $9e15485748de85e6$var$kIsMap);
        } else if ($9e15485748de85e6$var$isAnyArrayBuffer(val1)) {
            if (!$9e15485748de85e6$var$areEqualArrayBuffers(val1, val2)) return false;
        } else if ($9e15485748de85e6$var$isBoxedPrimitive(val1) && !$9e15485748de85e6$var$isEqualBoxedPrimitive(val1, val2)) return false;
        return $9e15485748de85e6$var$keyCheck(val1, val2, strict, memos, $9e15485748de85e6$var$kNoIterator);
    }
    function $9e15485748de85e6$var$getEnumerables(val, keys) {
        return keys.filter(function(k) {
            return $9e15485748de85e6$var$propertyIsEnumerable(val, k);
        });
    }
    function $9e15485748de85e6$var$keyCheck(val1, val2, strict, memos, iterationType, aKeys) {
        if (arguments.length === 5) {
            aKeys = Object.keys(val1);
            var bKeys = Object.keys(val2);
            if (aKeys.length !== bKeys.length) return false;
        }
        var i = 0;
        for(; i < aKeys.length; i++){
            if (!$9e15485748de85e6$var$hasOwnProperty(val2, aKeys[i])) return false;
        }
        if (strict && arguments.length === 5) {
            var symbolKeysA = $9e15485748de85e6$var$objectGetOwnPropertySymbols(val1);
            if (symbolKeysA.length !== 0) {
                var count = 0;
                for(i = 0; i < symbolKeysA.length; i++){
                    var key = symbolKeysA[i];
                    if ($9e15485748de85e6$var$propertyIsEnumerable(val1, key)) {
                        if (!$9e15485748de85e6$var$propertyIsEnumerable(val2, key)) return false;
                        aKeys.push(key);
                        count++;
                    } else if ($9e15485748de85e6$var$propertyIsEnumerable(val2, key)) return false;
                }
                var symbolKeysB = $9e15485748de85e6$var$objectGetOwnPropertySymbols(val2);
                if (symbolKeysA.length !== symbolKeysB.length && $9e15485748de85e6$var$getEnumerables(val2, symbolKeysB).length !== count) return false;
            } else {
                var _symbolKeysB = $9e15485748de85e6$var$objectGetOwnPropertySymbols(val2);
                if (_symbolKeysB.length !== 0 && $9e15485748de85e6$var$getEnumerables(val2, _symbolKeysB).length !== 0) return false;
            }
        }
        if (aKeys.length === 0 && (iterationType === $9e15485748de85e6$var$kNoIterator || iterationType === $9e15485748de85e6$var$kIsArray && val1.length === 0 || val1.size === 0)) return true;
        if (memos === undefined) memos = {
            val1: new Map(),
            val2: new Map(),
            position: 0
        };
        else {
            var val2MemoA = memos.val1.get(val1);
            if (val2MemoA !== undefined) {
                var val2MemoB = memos.val2.get(val2);
                if (val2MemoB !== undefined) return val2MemoA === val2MemoB;
            }
            memos.position++;
        }
        memos.val1.set(val1, memos.position);
        memos.val2.set(val2, memos.position);
        var areEq = $9e15485748de85e6$var$objEquiv(val1, val2, strict, aKeys, memos, iterationType);
        memos.val1.delete(val1);
        memos.val2.delete(val2);
        return areEq;
    }
    function $9e15485748de85e6$var$setHasEqualElement(set, val1, strict, memo) {
        var setValues = $9e15485748de85e6$var$arrayFromSet(set);
        for(var i = 0; i < setValues.length; i++){
            var val2 = setValues[i];
            if ($9e15485748de85e6$var$innerDeepEqual(val1, val2, strict, memo)) {
                set.delete(val2);
                return true;
            }
        }
        return false;
    }
    function $9e15485748de85e6$var$findLooseMatchingPrimitives(prim) {
        switch($9e15485748de85e6$var$_typeof(prim)){
            case 'undefined':
                return null;
            case 'object':
                return undefined;
            case 'symbol':
                return false;
            case 'string':
                prim = +prim;
            case 'number':
                if ($9e15485748de85e6$var$numberIsNaN(prim)) return false;
        }
        return true;
    }
    function $9e15485748de85e6$var$setMightHaveLoosePrim(a, b, prim) {
        var altValue = $9e15485748de85e6$var$findLooseMatchingPrimitives(prim);
        if (altValue != null) return altValue;
        return b.has(altValue) && !a.has(altValue);
    }
    function $9e15485748de85e6$var$mapMightHaveLoosePrim(a, b, prim, item, memo) {
        var altValue = $9e15485748de85e6$var$findLooseMatchingPrimitives(prim);
        if (altValue != null) return altValue;
        var curB = b.get(altValue);
        if (curB === undefined && !b.has(altValue) || !$9e15485748de85e6$var$innerDeepEqual(item, curB, false, memo)) return false;
        return !a.has(altValue) && $9e15485748de85e6$var$innerDeepEqual(item, curB, false, memo);
    }
    function $9e15485748de85e6$var$setEquiv(a, b, strict, memo) {
        var set = null;
        var aValues = $9e15485748de85e6$var$arrayFromSet(a);
        for(var i = 0; i < aValues.length; i++){
            var val = aValues[i];
            if ($9e15485748de85e6$var$_typeof(val) === 'object' && val !== null) {
                if (set === null) set = new Set();
                set.add(val);
            } else if (!b.has(val)) {
                if (strict) return false;
                if (!$9e15485748de85e6$var$setMightHaveLoosePrim(a, b, val)) return false;
                if (set === null) set = new Set();
                set.add(val);
            }
        }
        if (set !== null) {
            var bValues = $9e15485748de85e6$var$arrayFromSet(b);
            for(var _i = 0; _i < bValues.length; _i++){
                var _val = bValues[_i];
                if ($9e15485748de85e6$var$_typeof(_val) === 'object' && _val !== null) {
                    if (!$9e15485748de85e6$var$setHasEqualElement(set, _val, strict, memo)) return false;
                } else if (!strict && !a.has(_val) && !$9e15485748de85e6$var$setHasEqualElement(set, _val, strict, memo)) return false;
            }
            return set.size === 0;
        }
        return true;
    }
    function $9e15485748de85e6$var$mapHasEqualEntry(set, map, key1, item1, strict, memo) {
        var setValues = $9e15485748de85e6$var$arrayFromSet(set);
        for(var i = 0; i < setValues.length; i++){
            var key2 = setValues[i];
            if ($9e15485748de85e6$var$innerDeepEqual(key1, key2, strict, memo) && $9e15485748de85e6$var$innerDeepEqual(item1, map.get(key2), strict, memo)) {
                set.delete(key2);
                return true;
            }
        }
        return false;
    }
    function $9e15485748de85e6$var$mapEquiv(a, b, strict, memo) {
        var set = null;
        var aEntries = $9e15485748de85e6$var$arrayFromMap(a);
        for(var i = 0; i < aEntries.length; i++){
            var _aEntries$i = $9e15485748de85e6$var$_slicedToArray(aEntries[i], 2), key = _aEntries$i[0], item1 = _aEntries$i[1];
            if ($9e15485748de85e6$var$_typeof(key) === 'object' && key !== null) {
                if (set === null) set = new Set();
                set.add(key);
            } else {
                var item2 = b.get(key);
                if (item2 === undefined && !b.has(key) || !$9e15485748de85e6$var$innerDeepEqual(item1, item2, strict, memo)) {
                    if (strict) return false;
                    if (!$9e15485748de85e6$var$mapMightHaveLoosePrim(a, b, key, item1, memo)) return false;
                    if (set === null) set = new Set();
                    set.add(key);
                }
            }
        }
        if (set !== null) {
            var bEntries = $9e15485748de85e6$var$arrayFromMap(b);
            for(var _i2 = 0; _i2 < bEntries.length; _i2++){
                var _bEntries$_i = $9e15485748de85e6$var$_slicedToArray(bEntries[_i2], 2), _key = _bEntries$_i[0], item = _bEntries$_i[1];
                if ($9e15485748de85e6$var$_typeof(_key) === 'object' && _key !== null) {
                    if (!$9e15485748de85e6$var$mapHasEqualEntry(set, a, _key, item, strict, memo)) return false;
                } else if (!strict && (!a.has(_key) || !$9e15485748de85e6$var$innerDeepEqual(a.get(_key), item, false, memo)) && !$9e15485748de85e6$var$mapHasEqualEntry(set, a, _key, item, false, memo)) return false;
            }
            return set.size === 0;
        }
        return true;
    }
    function $9e15485748de85e6$var$objEquiv(a, b, strict, keys, memos, iterationType) {
        var i = 0;
        if (iterationType === $9e15485748de85e6$var$kIsSet) {
            if (!$9e15485748de85e6$var$setEquiv(a, b, strict, memos)) return false;
        } else if (iterationType === $9e15485748de85e6$var$kIsMap) {
            if (!$9e15485748de85e6$var$mapEquiv(a, b, strict, memos)) return false;
        } else if (iterationType === $9e15485748de85e6$var$kIsArray) for(; i < a.length; i++){
            if ($9e15485748de85e6$var$hasOwnProperty(a, i)) {
                if (!$9e15485748de85e6$var$hasOwnProperty(b, i) || !$9e15485748de85e6$var$innerDeepEqual(a[i], b[i], strict, memos)) return false;
            } else if ($9e15485748de85e6$var$hasOwnProperty(b, i)) return false;
            else {
                var keysA = Object.keys(a);
                for(; i < keysA.length; i++){
                    var key = keysA[i];
                    if (!$9e15485748de85e6$var$hasOwnProperty(b, key) || !$9e15485748de85e6$var$innerDeepEqual(a[key], b[key], strict, memos)) return false;
                }
                if (keysA.length !== Object.keys(b).length) return false;
                return true;
            }
        }
        for(i = 0; i < keys.length; i++){
            var _key2 = keys[i];
            if (!$9e15485748de85e6$var$innerDeepEqual(a[_key2], b[_key2], strict, memos)) return false;
        }
        return true;
    }
    function $9e15485748de85e6$var$isDeepEqual(val1, val2) {
        return $9e15485748de85e6$var$innerDeepEqual(val1, val2, $9e15485748de85e6$var$kLoose);
    }
    function $9e15485748de85e6$var$isDeepStrictEqual(val1, val2) {
        return $9e15485748de85e6$var$innerDeepEqual(val1, val2, $9e15485748de85e6$var$kStrict);
    }
    module.exports = {
        isDeepEqual: $9e15485748de85e6$var$isDeepEqual,
        isDeepStrictEqual: $9e15485748de85e6$var$isDeepStrictEqual
    };
});
parcelRegister("joK88", function(module, exports) {
    'use strict';
    var $d94D2 = parcelRequire("d94D2");
    var $h05ZS = parcelRequire("h05ZS");
    var $iwNFM = parcelRequire("iwNFM");
    var $eJazH = parcelRequire("eJazH");
    var $90RaO = parcelRequire("90RaO");
    var $e1f40ab7009ea590$var$polyfill = $h05ZS($eJazH(), Object);
    $d94D2($e1f40ab7009ea590$var$polyfill, {
        getPolyfill: $eJazH,
        implementation: $iwNFM,
        shim: $90RaO
    });
    module.exports = $e1f40ab7009ea590$var$polyfill;
});
parcelRegister("d94D2", function(module, exports) {
    'use strict';
    var $dZMWQ = parcelRequire("dZMWQ");
    var $991fb4ca00f3da54$var$hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';
    var $991fb4ca00f3da54$var$toStr = Object.prototype.toString;
    var $991fb4ca00f3da54$var$concat = Array.prototype.concat;
    var $le88V;
    var $991fb4ca00f3da54$var$isFunction = function(fn) {
        return typeof fn === 'function' && $991fb4ca00f3da54$var$toStr.call(fn) === '[object Function]';
    };
    var $991fb4ca00f3da54$var$supportsDescriptors = (parcelRequire("9lmlE"))();
    var $991fb4ca00f3da54$var$defineProperty = function(object, name, value, predicate) {
        if (name in object) {
            if (predicate === true) {
                if (object[name] === value) return;
            } else if (!$991fb4ca00f3da54$var$isFunction(predicate) || !predicate()) return;
        }
        if ($991fb4ca00f3da54$var$supportsDescriptors) (0, parcelRequire("le88V"))(object, name, value, true);
        else (0, parcelRequire("le88V"))(object, name, value);
    };
    var $991fb4ca00f3da54$var$defineProperties = function(object, map) {
        var predicates = arguments.length > 2 ? arguments[2] : {};
        var props = $dZMWQ(map);
        if ($991fb4ca00f3da54$var$hasSymbols) props = $991fb4ca00f3da54$var$concat.call(props, Object.getOwnPropertySymbols(map));
        for(var i = 0; i < props.length; i += 1)$991fb4ca00f3da54$var$defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
    };
    $991fb4ca00f3da54$var$defineProperties.supportsDescriptors = !!$991fb4ca00f3da54$var$supportsDescriptors;
    module.exports = $991fb4ca00f3da54$var$defineProperties;
});
parcelRegister("90RaO", function(module, exports) {
    'use strict';
    var $eJazH = parcelRequire("eJazH");
    var $d94D2 = parcelRequire("d94D2");
    module.exports = function shimObjectIs() {
        var polyfill = $eJazH();
        $d94D2(Object, {
            is: polyfill
        }, {
            is: function testObjectIs() {
                return Object.is !== polyfill;
            }
        });
        return polyfill;
    };
});
parcelRegister("laO4W", function(module, exports) {
    'use strict';
    var $h05ZS = parcelRequire("h05ZS");
    var $d94D2 = parcelRequire("d94D2");
    var $hdPWo = parcelRequire("hdPWo");
    var $gmOnv = parcelRequire("gmOnv");
    var $hXuHX = parcelRequire("hXuHX");
    var $f6a160b687432d3b$var$polyfill = $h05ZS($gmOnv(), Number);
    $d94D2($f6a160b687432d3b$var$polyfill, {
        getPolyfill: $gmOnv,
        implementation: $hdPWo,
        shim: $hXuHX
    });
    module.exports = $f6a160b687432d3b$var$polyfill;
});
parcelRegister("hdPWo", function(module, exports) {
    'use strict';
    module.exports = function isNaN(value) {
        return value !== value;
    };
});
parcelRegister("gmOnv", function(module, exports) {
    'use strict';
    var $hdPWo = parcelRequire("hdPWo");
    module.exports = function getPolyfill() {
        if (Number.isNaN && Number.isNaN(NaN) && !Number.isNaN('a')) return Number.isNaN;
        return $hdPWo;
    };
});
parcelRegister("hXuHX", function(module, exports) {
    'use strict';
    var $d94D2 = parcelRequire("d94D2");
    var $gmOnv = parcelRequire("gmOnv");
    module.exports = function shimNumberIsNaN() {
        var polyfill = $gmOnv();
        $d94D2(Number, {
            isNaN: polyfill
        }, {
            isNaN: function testIsNaN() {
                return Number.isNaN !== polyfill;
            }
        });
        return polyfill;
    };
});
parcelRegister("d6D31", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.SuppressWarnings = module.exports.Override = module.exports.Nullable = module.exports.NotNull = void 0;
    function $98aa1ff32ce30be5$var$NotNull(target, propertyKey, propertyDescriptor) {}
    module.exports.NotNull = $98aa1ff32ce30be5$var$NotNull;
    function $98aa1ff32ce30be5$var$Nullable(target, propertyKey, propertyDescriptor) {}
    module.exports.Nullable = $98aa1ff32ce30be5$var$Nullable;
    function $98aa1ff32ce30be5$var$Override(target, propertyKey, propertyDescriptor) {}
    module.exports.Override = $98aa1ff32ce30be5$var$Override;
    function $98aa1ff32ce30be5$var$SuppressWarnings(options) {
        return (target, propertyKey, descriptor)=>{};
    }
    module.exports.SuppressWarnings = $98aa1ff32ce30be5$var$SuppressWarnings;
});
parcelRegister("ceaEj", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.IntStream = void 0;
    var $8e6f0d8930cd60b2$var$IntStream;
    (function(IntStream) {
        IntStream.EOF = -1;
        IntStream.UNKNOWN_SOURCE_NAME = "<unknown>";
    })($8e6f0d8930cd60b2$var$IntStream = module.exports.IntStream || (module.exports.IntStream = {}));
});
parcelRegister("b0kN8", function(module, exports) {
    "use strict";
    var $802fd28fa76a2f4f$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.BailErrorStrategy = void 0;
    var $4CCJj = parcelRequire("4CCJj");
    var $iLUMi = parcelRequire("iLUMi");
    var $d6D31 = parcelRequire("d6D31");
    var $3kXUy = parcelRequire("3kXUy");
    class $802fd28fa76a2f4f$var$BailErrorStrategy extends $4CCJj.DefaultErrorStrategy {
        recover(recognizer, e) {
            for(let context = recognizer.context; context; context = context.parent)context.exception = e;
            throw new $3kXUy.ParseCancellationException(e);
        }
        recoverInline(recognizer) {
            let e = new $iLUMi.InputMismatchException(recognizer);
            for(let context = recognizer.context; context; context = context.parent)context.exception = e;
            throw new $3kXUy.ParseCancellationException(e);
        }
        sync(recognizer) {}
    }
    $802fd28fa76a2f4f$var$__decorate([
        $d6D31.Override
    ], $802fd28fa76a2f4f$var$BailErrorStrategy.prototype, "recover", null);
    $802fd28fa76a2f4f$var$__decorate([
        $d6D31.Override
    ], $802fd28fa76a2f4f$var$BailErrorStrategy.prototype, "recoverInline", null);
    $802fd28fa76a2f4f$var$__decorate([
        $d6D31.Override
    ], $802fd28fa76a2f4f$var$BailErrorStrategy.prototype, "sync", null);
    module.exports.BailErrorStrategy = $802fd28fa76a2f4f$var$BailErrorStrategy;
});
parcelRegister("4CCJj", function(module, exports) {
    "use strict";
    var $35d8c0fbab48edc4$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $35d8c0fbab48edc4$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.DefaultErrorStrategy = void 0;
    var $7j0Pc = parcelRequire("7j0Pc");
    var $1bs3X = parcelRequire("1bs3X");
    var $ea0YW = parcelRequire("ea0YW");
    var $iLUMi = parcelRequire("iLUMi");
    var $hGRod = parcelRequire("hGRod");
    var $hKCjP = parcelRequire("hKCjP");
    var $8DTT0 = parcelRequire("8DTT0");
    var $2DVsz = parcelRequire("2DVsz");
    var $d6D31 = parcelRequire("d6D31");
    class $35d8c0fbab48edc4$var$DefaultErrorStrategy {
        constructor(){
            this.errorRecoveryMode = false;
            this.lastErrorIndex = -1;
            this.nextTokensState = $7j0Pc.ATNState.INVALID_STATE_NUMBER;
        }
        reset(recognizer) {
            this.endErrorCondition(recognizer);
        }
        beginErrorCondition(recognizer) {
            this.errorRecoveryMode = true;
        }
        inErrorRecoveryMode(recognizer) {
            return this.errorRecoveryMode;
        }
        endErrorCondition(recognizer) {
            this.errorRecoveryMode = false;
            this.lastErrorStates = undefined;
            this.lastErrorIndex = -1;
        }
        reportMatch(recognizer) {
            this.endErrorCondition(recognizer);
        }
        reportError(recognizer, e) {
            if (this.inErrorRecoveryMode(recognizer)) return;
            this.beginErrorCondition(recognizer);
            if (e instanceof $hKCjP.NoViableAltException) this.reportNoViableAlternative(recognizer, e);
            else if (e instanceof $iLUMi.InputMismatchException) this.reportInputMismatch(recognizer, e);
            else if (e instanceof $ea0YW.FailedPredicateException) this.reportFailedPredicate(recognizer, e);
            else {
                console.error(`unknown recognition error type: ${e}`);
                this.notifyErrorListeners(recognizer, e.toString(), e);
            }
        }
        notifyErrorListeners(recognizer, message, e) {
            let offendingToken = e.getOffendingToken(recognizer);
            if (offendingToken === undefined) offendingToken = null;
            recognizer.notifyErrorListeners(message, offendingToken, e);
        }
        recover(recognizer, e) {
            if (this.lastErrorIndex === recognizer.inputStream.index && this.lastErrorStates && this.lastErrorStates.contains(recognizer.state)) recognizer.consume();
            this.lastErrorIndex = recognizer.inputStream.index;
            if (!this.lastErrorStates) this.lastErrorStates = new $hGRod.IntervalSet();
            this.lastErrorStates.add(recognizer.state);
            let followSet = this.getErrorRecoverySet(recognizer);
            this.consumeUntil(recognizer, followSet);
        }
        sync(recognizer) {
            let s = recognizer.interpreter.atn.states[recognizer.state];
            if (this.inErrorRecoveryMode(recognizer)) return;
            let tokens = recognizer.inputStream;
            let la = tokens.LA(1);
            let nextTokens = recognizer.atn.nextTokens(s);
            if (nextTokens.contains(la)) {
                this.nextTokensContext = undefined;
                this.nextTokensState = $7j0Pc.ATNState.INVALID_STATE_NUMBER;
                return;
            }
            if (nextTokens.contains($2DVsz.Token.EPSILON)) {
                if (this.nextTokensContext === undefined) {
                    this.nextTokensContext = recognizer.context;
                    this.nextTokensState = recognizer.state;
                }
                return;
            }
            switch(s.stateType){
                case $1bs3X.ATNStateType.BLOCK_START:
                case $1bs3X.ATNStateType.STAR_BLOCK_START:
                case $1bs3X.ATNStateType.PLUS_BLOCK_START:
                case $1bs3X.ATNStateType.STAR_LOOP_ENTRY:
                    if (this.singleTokenDeletion(recognizer)) return;
                    throw new $iLUMi.InputMismatchException(recognizer);
                case $1bs3X.ATNStateType.PLUS_LOOP_BACK:
                case $1bs3X.ATNStateType.STAR_LOOP_BACK:
                    this.reportUnwantedToken(recognizer);
                    let expecting = recognizer.getExpectedTokens();
                    let whatFollowsLoopIterationOrRule = expecting.or(this.getErrorRecoverySet(recognizer));
                    this.consumeUntil(recognizer, whatFollowsLoopIterationOrRule);
                    break;
                default:
                    break;
            }
        }
        reportNoViableAlternative(recognizer, e) {
            let tokens = recognizer.inputStream;
            let input;
            if (tokens) {
                if (e.startToken.type === $2DVsz.Token.EOF) input = "<EOF>";
                else input = tokens.getTextFromRange(e.startToken, e.getOffendingToken());
            } else input = "<unknown input>";
            let msg = "no viable alternative at input " + this.escapeWSAndQuote(input);
            this.notifyErrorListeners(recognizer, msg, e);
        }
        reportInputMismatch(recognizer, e) {
            let expected = e.expectedTokens;
            let expectedString = expected ? expected.toStringVocabulary(recognizer.vocabulary) : "";
            let msg = "mismatched input " + this.getTokenErrorDisplay(e.getOffendingToken(recognizer)) + " expecting " + expectedString;
            this.notifyErrorListeners(recognizer, msg, e);
        }
        reportFailedPredicate(recognizer, e) {
            let ruleName = recognizer.ruleNames[recognizer.context.ruleIndex];
            let msg = "rule " + ruleName + " " + e.message;
            this.notifyErrorListeners(recognizer, msg, e);
        }
        reportUnwantedToken(recognizer) {
            if (this.inErrorRecoveryMode(recognizer)) return;
            this.beginErrorCondition(recognizer);
            let t = recognizer.currentToken;
            let tokenName = this.getTokenErrorDisplay(t);
            let expecting = this.getExpectedTokens(recognizer);
            let msg = "extraneous input " + tokenName + " expecting " + expecting.toStringVocabulary(recognizer.vocabulary);
            recognizer.notifyErrorListeners(msg, t, undefined);
        }
        reportMissingToken(recognizer) {
            if (this.inErrorRecoveryMode(recognizer)) return;
            this.beginErrorCondition(recognizer);
            let t = recognizer.currentToken;
            let expecting = this.getExpectedTokens(recognizer);
            let msg = "missing " + expecting.toStringVocabulary(recognizer.vocabulary) + " at " + this.getTokenErrorDisplay(t);
            recognizer.notifyErrorListeners(msg, t, undefined);
        }
        recoverInline(recognizer) {
            let matchedSymbol = this.singleTokenDeletion(recognizer);
            if (matchedSymbol) {
                recognizer.consume();
                return matchedSymbol;
            }
            if (this.singleTokenInsertion(recognizer)) return this.getMissingSymbol(recognizer);
            if (this.nextTokensContext === undefined) throw new $iLUMi.InputMismatchException(recognizer);
            else throw new $iLUMi.InputMismatchException(recognizer, this.nextTokensState, this.nextTokensContext);
        }
        singleTokenInsertion(recognizer) {
            let currentSymbolType = recognizer.inputStream.LA(1);
            let currentState = recognizer.interpreter.atn.states[recognizer.state];
            let next = currentState.transition(0).target;
            let atn = recognizer.interpreter.atn;
            let expectingAtLL2 = atn.nextTokens(next, $8DTT0.PredictionContext.fromRuleContext(atn, recognizer.context));
            if (expectingAtLL2.contains(currentSymbolType)) {
                this.reportMissingToken(recognizer);
                return true;
            }
            return false;
        }
        singleTokenDeletion(recognizer) {
            let nextTokenType = recognizer.inputStream.LA(2);
            let expecting = this.getExpectedTokens(recognizer);
            if (expecting.contains(nextTokenType)) {
                this.reportUnwantedToken(recognizer);
                recognizer.consume();
                let matchedSymbol = recognizer.currentToken;
                this.reportMatch(recognizer);
                return matchedSymbol;
            }
            return undefined;
        }
        getMissingSymbol(recognizer) {
            let currentSymbol = recognizer.currentToken;
            let expecting = this.getExpectedTokens(recognizer);
            let expectedTokenType = $2DVsz.Token.INVALID_TYPE;
            if (!expecting.isNil) expectedTokenType = expecting.minElement;
            let tokenText;
            if (expectedTokenType === $2DVsz.Token.EOF) tokenText = "<missing EOF>";
            else tokenText = "<missing " + recognizer.vocabulary.getDisplayName(expectedTokenType) + ">";
            let current = currentSymbol;
            let lookback = recognizer.inputStream.tryLT(-1);
            if (current.type === $2DVsz.Token.EOF && lookback != null) current = lookback;
            return this.constructToken(recognizer.inputStream.tokenSource, expectedTokenType, tokenText, current);
        }
        constructToken(tokenSource, expectedTokenType, tokenText, current) {
            let factory = tokenSource.tokenFactory;
            let x = current.tokenSource;
            let stream = x ? x.inputStream : undefined;
            return factory.create({
                source: tokenSource,
                stream: stream
            }, expectedTokenType, tokenText, $2DVsz.Token.DEFAULT_CHANNEL, -1, -1, current.line, current.charPositionInLine);
        }
        getExpectedTokens(recognizer) {
            return recognizer.getExpectedTokens();
        }
        getTokenErrorDisplay(t) {
            if (!t) return "<no token>";
            let s = this.getSymbolText(t);
            if (!s) {
                if (this.getSymbolType(t) === $2DVsz.Token.EOF) s = "<EOF>";
                else s = `<${this.getSymbolType(t)}>`;
            }
            return this.escapeWSAndQuote(s);
        }
        getSymbolText(symbol) {
            return symbol.text;
        }
        getSymbolType(symbol) {
            return symbol.type;
        }
        escapeWSAndQuote(s) {
            s = s.replace("\n", "\\n");
            s = s.replace("\r", "\\r");
            s = s.replace("\t", "\\t");
            return "'" + s + "'";
        }
        getErrorRecoverySet(recognizer) {
            let atn = recognizer.interpreter.atn;
            let ctx = recognizer.context;
            let recoverSet = new $hGRod.IntervalSet();
            while(ctx && ctx.invokingState >= 0){
                let invokingState = atn.states[ctx.invokingState];
                let rt = invokingState.transition(0);
                let follow = atn.nextTokens(rt.followState);
                recoverSet.addAll(follow);
                ctx = ctx._parent;
            }
            recoverSet.remove($2DVsz.Token.EPSILON);
            return recoverSet;
        }
        consumeUntil(recognizer, set) {
            let ttype = recognizer.inputStream.LA(1);
            while(ttype !== $2DVsz.Token.EOF && !set.contains(ttype)){
                recognizer.consume();
                ttype = recognizer.inputStream.LA(1);
            }
        }
    }
    $35d8c0fbab48edc4$var$__decorate([
        $d6D31.Override
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "reset", null);
    $35d8c0fbab48edc4$var$__decorate([
        $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull)
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "beginErrorCondition", null);
    $35d8c0fbab48edc4$var$__decorate([
        $d6D31.Override
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "inErrorRecoveryMode", null);
    $35d8c0fbab48edc4$var$__decorate([
        $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull)
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "endErrorCondition", null);
    $35d8c0fbab48edc4$var$__decorate([
        $d6D31.Override
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "reportMatch", null);
    $35d8c0fbab48edc4$var$__decorate([
        $d6D31.Override
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "reportError", null);
    $35d8c0fbab48edc4$var$__decorate([
        $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull)
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "notifyErrorListeners", null);
    $35d8c0fbab48edc4$var$__decorate([
        $d6D31.Override
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "recover", null);
    $35d8c0fbab48edc4$var$__decorate([
        $d6D31.Override
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "sync", null);
    $35d8c0fbab48edc4$var$__decorate([
        $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull),
        $35d8c0fbab48edc4$var$__param(1, $d6D31.NotNull)
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "reportNoViableAlternative", null);
    $35d8c0fbab48edc4$var$__decorate([
        $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull),
        $35d8c0fbab48edc4$var$__param(1, $d6D31.NotNull)
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "reportInputMismatch", null);
    $35d8c0fbab48edc4$var$__decorate([
        $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull),
        $35d8c0fbab48edc4$var$__param(1, $d6D31.NotNull)
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "reportFailedPredicate", null);
    $35d8c0fbab48edc4$var$__decorate([
        $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull)
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "reportUnwantedToken", null);
    $35d8c0fbab48edc4$var$__decorate([
        $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull)
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "reportMissingToken", null);
    $35d8c0fbab48edc4$var$__decorate([
        $d6D31.Override
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "recoverInline", null);
    $35d8c0fbab48edc4$var$__decorate([
        $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull)
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "singleTokenInsertion", null);
    $35d8c0fbab48edc4$var$__decorate([
        $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull)
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "singleTokenDeletion", null);
    $35d8c0fbab48edc4$var$__decorate([
        $d6D31.NotNull,
        $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull)
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "getMissingSymbol", null);
    $35d8c0fbab48edc4$var$__decorate([
        $d6D31.NotNull,
        $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull)
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "getExpectedTokens", null);
    $35d8c0fbab48edc4$var$__decorate([
        $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull)
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "getSymbolText", null);
    $35d8c0fbab48edc4$var$__decorate([
        $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull)
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "getSymbolType", null);
    $35d8c0fbab48edc4$var$__decorate([
        $d6D31.NotNull,
        $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull)
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "escapeWSAndQuote", null);
    $35d8c0fbab48edc4$var$__decorate([
        $d6D31.NotNull,
        $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull)
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "getErrorRecoverySet", null);
    $35d8c0fbab48edc4$var$__decorate([
        $35d8c0fbab48edc4$var$__param(0, $d6D31.NotNull),
        $35d8c0fbab48edc4$var$__param(1, $d6D31.NotNull)
    ], $35d8c0fbab48edc4$var$DefaultErrorStrategy.prototype, "consumeUntil", null);
    module.exports.DefaultErrorStrategy = $35d8c0fbab48edc4$var$DefaultErrorStrategy;
});
parcelRegister("7j0Pc", function(module, exports) {
    "use strict";
    var $551af28bc8fe1b8c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ATNState = void 0;
    var $d6D31 = parcelRequire("d6D31");
    const $551af28bc8fe1b8c$var$INITIAL_NUM_TRANSITIONS = 4;
    class $551af28bc8fe1b8c$var$ATNState {
        constructor(){
            this.stateNumber = $551af28bc8fe1b8c$var$ATNState.INVALID_STATE_NUMBER;
            this.ruleIndex = 0;
            this.epsilonOnlyTransitions = false;
            this.transitions = [];
            this.optimizedTransitions = this.transitions;
        }
        getStateNumber() {
            return this.stateNumber;
        }
        get nonStopStateNumber() {
            return this.getStateNumber();
        }
        hashCode() {
            return this.stateNumber;
        }
        equals(o) {
            if (o instanceof $551af28bc8fe1b8c$var$ATNState) return this.stateNumber === o.stateNumber;
            return false;
        }
        get isNonGreedyExitState() {
            return false;
        }
        toString() {
            return String(this.stateNumber);
        }
        getTransitions() {
            return this.transitions.slice(0);
        }
        get numberOfTransitions() {
            return this.transitions.length;
        }
        addTransition(e, index) {
            if (this.transitions.length === 0) this.epsilonOnlyTransitions = e.isEpsilon;
            else if (this.epsilonOnlyTransitions !== e.isEpsilon) {
                this.epsilonOnlyTransitions = false;
                throw new Error("ATN state " + this.stateNumber + " has both epsilon and non-epsilon transitions.");
            }
            this.transitions.splice(index !== undefined ? index : this.transitions.length, 0, e);
        }
        transition(i) {
            return this.transitions[i];
        }
        setTransition(i, e) {
            this.transitions[i] = e;
        }
        removeTransition(index) {
            return this.transitions.splice(index, 1)[0];
        }
        get onlyHasEpsilonTransitions() {
            return this.epsilonOnlyTransitions;
        }
        setRuleIndex(ruleIndex) {
            this.ruleIndex = ruleIndex;
        }
        get isOptimized() {
            return this.optimizedTransitions !== this.transitions;
        }
        get numberOfOptimizedTransitions() {
            return this.optimizedTransitions.length;
        }
        getOptimizedTransition(i) {
            return this.optimizedTransitions[i];
        }
        addOptimizedTransition(e) {
            if (!this.isOptimized) this.optimizedTransitions = new Array();
            this.optimizedTransitions.push(e);
        }
        setOptimizedTransition(i, e) {
            if (!this.isOptimized) throw new Error("This ATNState is not optimized.");
            this.optimizedTransitions[i] = e;
        }
        removeOptimizedTransition(i) {
            if (!this.isOptimized) throw new Error("This ATNState is not optimized.");
            this.optimizedTransitions.splice(i, 1);
        }
    }
    $551af28bc8fe1b8c$var$__decorate([
        $d6D31.Override
    ], $551af28bc8fe1b8c$var$ATNState.prototype, "hashCode", null);
    $551af28bc8fe1b8c$var$__decorate([
        $d6D31.Override
    ], $551af28bc8fe1b8c$var$ATNState.prototype, "equals", null);
    $551af28bc8fe1b8c$var$__decorate([
        $d6D31.Override
    ], $551af28bc8fe1b8c$var$ATNState.prototype, "toString", null);
    module.exports.ATNState = $551af28bc8fe1b8c$var$ATNState;
    (function(ATNState) {
        ATNState.INVALID_STATE_NUMBER = -1;
    })($551af28bc8fe1b8c$var$ATNState = module.exports.ATNState || (module.exports.ATNState = {}));
});
parcelRegister("1bs3X", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ATNStateType = void 0;
    var $0dcc96396a04e502$var$ATNStateType;
    (function(ATNStateType) {
        ATNStateType[ATNStateType["INVALID_TYPE"] = 0] = "INVALID_TYPE";
        ATNStateType[ATNStateType["BASIC"] = 1] = "BASIC";
        ATNStateType[ATNStateType["RULE_START"] = 2] = "RULE_START";
        ATNStateType[ATNStateType["BLOCK_START"] = 3] = "BLOCK_START";
        ATNStateType[ATNStateType["PLUS_BLOCK_START"] = 4] = "PLUS_BLOCK_START";
        ATNStateType[ATNStateType["STAR_BLOCK_START"] = 5] = "STAR_BLOCK_START";
        ATNStateType[ATNStateType["TOKEN_START"] = 6] = "TOKEN_START";
        ATNStateType[ATNStateType["RULE_STOP"] = 7] = "RULE_STOP";
        ATNStateType[ATNStateType["BLOCK_END"] = 8] = "BLOCK_END";
        ATNStateType[ATNStateType["STAR_LOOP_BACK"] = 9] = "STAR_LOOP_BACK";
        ATNStateType[ATNStateType["STAR_LOOP_ENTRY"] = 10] = "STAR_LOOP_ENTRY";
        ATNStateType[ATNStateType["PLUS_LOOP_BACK"] = 11] = "PLUS_LOOP_BACK";
        ATNStateType[ATNStateType["LOOP_END"] = 12] = "LOOP_END";
    })($0dcc96396a04e502$var$ATNStateType = module.exports.ATNStateType || (module.exports.ATNStateType = {}));
});
parcelRegister("ea0YW", function(module, exports) {
    "use strict";
    var $a4f2c2ded442ae18$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $a4f2c2ded442ae18$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.FailedPredicateException = void 0;
    var $fLdDn = parcelRequire("fLdDn");
    var $d6D31 = parcelRequire("d6D31");
    var $hnaRv = parcelRequire("hnaRv");
    let $a4f2c2ded442ae18$var$FailedPredicateException = class FailedPredicateException extends $fLdDn.RecognitionException {
        constructor(recognizer, predicate, message){
            super(recognizer, recognizer.inputStream, recognizer.context, FailedPredicateException.formatMessage(predicate, message));
            let s = recognizer.interpreter.atn.states[recognizer.state];
            let trans = s.transition(0);
            if (trans instanceof $hnaRv.PredicateTransition) {
                this._ruleIndex = trans.ruleIndex;
                this._predicateIndex = trans.predIndex;
            } else {
                this._ruleIndex = 0;
                this._predicateIndex = 0;
            }
            this._predicate = predicate;
            super.setOffendingToken(recognizer, recognizer.currentToken);
        }
        get ruleIndex() {
            return this._ruleIndex;
        }
        get predicateIndex() {
            return this._predicateIndex;
        }
        get predicate() {
            return this._predicate;
        }
        static formatMessage(predicate, message) {
            if (message) return message;
            return `failed predicate: {${predicate}}?`;
        }
    };
    $a4f2c2ded442ae18$var$__decorate([
        $d6D31.NotNull
    ], $a4f2c2ded442ae18$var$FailedPredicateException, "formatMessage", null);
    $a4f2c2ded442ae18$var$FailedPredicateException = $a4f2c2ded442ae18$var$__decorate([
        $a4f2c2ded442ae18$var$__param(0, $d6D31.NotNull)
    ], $a4f2c2ded442ae18$var$FailedPredicateException);
    module.exports.FailedPredicateException = $a4f2c2ded442ae18$var$FailedPredicateException;
});
parcelRegister("fLdDn", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.RecognitionException = void 0;
    class $b795d243382c1d9c$var$RecognitionException extends Error {
        constructor(recognizer, input, ctx, message){
            super(message);
            this._offendingState = -1;
            this._recognizer = recognizer;
            this.input = input;
            this.ctx = ctx;
            if (recognizer) this._offendingState = recognizer.state;
        }
        get offendingState() {
            return this._offendingState;
        }
        setOffendingState(offendingState) {
            this._offendingState = offendingState;
        }
        get expectedTokens() {
            if (this._recognizer) return this._recognizer.atn.getExpectedTokens(this._offendingState, this.ctx);
            return undefined;
        }
        get context() {
            return this.ctx;
        }
        get inputStream() {
            return this.input;
        }
        getOffendingToken(recognizer) {
            if (recognizer && recognizer !== this._recognizer) return undefined;
            return this.offendingToken;
        }
        setOffendingToken(recognizer, offendingToken) {
            if (recognizer === this._recognizer) this.offendingToken = offendingToken;
        }
        get recognizer() {
            return this._recognizer;
        }
    }
    module.exports.RecognitionException = $b795d243382c1d9c$var$RecognitionException;
});
parcelRegister("hnaRv", function(module, exports) {
    "use strict";
    var $ca5d02a3d9cef56c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $ca5d02a3d9cef56c$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.PredicateTransition = void 0;
    var $fMVaR = parcelRequire("fMVaR");
    var $d6D31 = parcelRequire("d6D31");
    var $eHMgW = parcelRequire("eHMgW");
    let $ca5d02a3d9cef56c$var$PredicateTransition = class PredicateTransition extends $fMVaR.AbstractPredicateTransition {
        constructor(target, ruleIndex, predIndex, isCtxDependent){
            super(target);
            this.ruleIndex = ruleIndex;
            this.predIndex = predIndex;
            this.isCtxDependent = isCtxDependent;
        }
        get serializationType() {
            return 4;
        }
        get isEpsilon() {
            return true;
        }
        matches(symbol, minVocabSymbol, maxVocabSymbol) {
            return false;
        }
        get predicate() {
            return new $eHMgW.SemanticContext.Predicate(this.ruleIndex, this.predIndex, this.isCtxDependent);
        }
        toString() {
            return "pred_" + this.ruleIndex + ":" + this.predIndex;
        }
    };
    $ca5d02a3d9cef56c$var$__decorate([
        $d6D31.Override
    ], $ca5d02a3d9cef56c$var$PredicateTransition.prototype, "serializationType", null);
    $ca5d02a3d9cef56c$var$__decorate([
        $d6D31.Override
    ], $ca5d02a3d9cef56c$var$PredicateTransition.prototype, "isEpsilon", null);
    $ca5d02a3d9cef56c$var$__decorate([
        $d6D31.Override
    ], $ca5d02a3d9cef56c$var$PredicateTransition.prototype, "matches", null);
    $ca5d02a3d9cef56c$var$__decorate([
        $d6D31.Override,
        $d6D31.NotNull
    ], $ca5d02a3d9cef56c$var$PredicateTransition.prototype, "toString", null);
    $ca5d02a3d9cef56c$var$PredicateTransition = $ca5d02a3d9cef56c$var$__decorate([
        $ca5d02a3d9cef56c$var$__param(0, $d6D31.NotNull)
    ], $ca5d02a3d9cef56c$var$PredicateTransition);
    module.exports.PredicateTransition = $ca5d02a3d9cef56c$var$PredicateTransition;
});
parcelRegister("fMVaR", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.AbstractPredicateTransition = void 0;
    var $5tcOQ = parcelRequire("5tcOQ");
    class $b7e7b04ea6d15f5c$var$AbstractPredicateTransition extends $5tcOQ.Transition {
        constructor(target){
            super(target);
        }
    }
    module.exports.AbstractPredicateTransition = $b7e7b04ea6d15f5c$var$AbstractPredicateTransition;
});
parcelRegister("5tcOQ", function(module, exports) {
    "use strict";
    var $3fb99acb0a3a1848$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $3fb99acb0a3a1848$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.Transition = void 0;
    var $d6D31 = parcelRequire("d6D31");
    let $3fb99acb0a3a1848$var$Transition = class Transition {
        constructor(target){
            if (target == null) throw new Error("target cannot be null.");
            this.target = target;
        }
        get isEpsilon() {
            return false;
        }
        get label() {
            return undefined;
        }
    };
    $3fb99acb0a3a1848$var$Transition.serializationNames = [
        "INVALID",
        "EPSILON",
        "RANGE",
        "RULE",
        "PREDICATE",
        "ATOM",
        "ACTION",
        "SET",
        "NOT_SET",
        "WILDCARD",
        "PRECEDENCE"
    ];
    $3fb99acb0a3a1848$var$__decorate([
        $d6D31.NotNull
    ], $3fb99acb0a3a1848$var$Transition.prototype, "target", void 0);
    $3fb99acb0a3a1848$var$Transition = $3fb99acb0a3a1848$var$__decorate([
        $3fb99acb0a3a1848$var$__param(0, $d6D31.NotNull)
    ], $3fb99acb0a3a1848$var$Transition);
    module.exports.Transition = $3fb99acb0a3a1848$var$Transition;
});
parcelRegister("eHMgW", function(module, exports) {
    "use strict";
    var $ab4a86b5def51fe2$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $ab4a86b5def51fe2$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.SemanticContext = void 0;
    var $7Veax = parcelRequire("7Veax");
    var $3sNxf = parcelRequire("3sNxf");
    var $iXFjm = parcelRequire("iXFjm");
    var $d6D31 = parcelRequire("d6D31");
    var $a4Flx = parcelRequire("a4Flx");
    var $2IEP9 = parcelRequire("2IEP9");
    function $ab4a86b5def51fe2$var$max(items) {
        let result;
        for (let current of items){
            if (result === undefined) {
                result = current;
                continue;
            }
            let comparison = result.compareTo(current);
            if (comparison < 0) result = current;
        }
        return result;
    }
    function $ab4a86b5def51fe2$var$min(items) {
        let result;
        for (let current of items){
            if (result === undefined) {
                result = current;
                continue;
            }
            let comparison = result.compareTo(current);
            if (comparison > 0) result = current;
        }
        return result;
    }
    class $ab4a86b5def51fe2$var$SemanticContext {
        static get NONE() {
            if ($ab4a86b5def51fe2$var$SemanticContext._NONE === undefined) $ab4a86b5def51fe2$var$SemanticContext._NONE = new $ab4a86b5def51fe2$var$SemanticContext.Predicate();
            return $ab4a86b5def51fe2$var$SemanticContext._NONE;
        }
        evalPrecedence(parser, parserCallStack) {
            return this;
        }
        static and(a, b) {
            if (!a || a === $ab4a86b5def51fe2$var$SemanticContext.NONE) return b;
            if (b === $ab4a86b5def51fe2$var$SemanticContext.NONE) return a;
            let result = new $ab4a86b5def51fe2$var$SemanticContext.AND(a, b);
            if (result.opnds.length === 1) return result.opnds[0];
            return result;
        }
        static or(a, b) {
            if (!a) return b;
            if (a === $ab4a86b5def51fe2$var$SemanticContext.NONE || b === $ab4a86b5def51fe2$var$SemanticContext.NONE) return $ab4a86b5def51fe2$var$SemanticContext.NONE;
            let result = new $ab4a86b5def51fe2$var$SemanticContext.OR(a, b);
            if (result.opnds.length === 1) return result.opnds[0];
            return result;
        }
    }
    module.exports.SemanticContext = $ab4a86b5def51fe2$var$SemanticContext;
    (function(SemanticContext) {
        const AND_HASHCODE = 40363613;
        const OR_HASHCODE = 486279973;
        function filterPrecedencePredicates(collection) {
            let result = [];
            for(let i = 0; i < collection.length; i++){
                let context = collection[i];
                if (context instanceof SemanticContext.PrecedencePredicate) {
                    result.push(context);
                    collection.splice(i, 1);
                    i--;
                }
            }
            return result;
        }
        class Predicate extends SemanticContext {
            constructor(ruleIndex = -1, predIndex = -1, isCtxDependent = false){
                super();
                this.ruleIndex = ruleIndex;
                this.predIndex = predIndex;
                this.isCtxDependent = isCtxDependent;
            }
            eval(parser, parserCallStack) {
                let localctx = this.isCtxDependent ? parserCallStack : undefined;
                return parser.sempred(localctx, this.ruleIndex, this.predIndex);
            }
            hashCode() {
                let hashCode = $iXFjm.MurmurHash.initialize();
                hashCode = $iXFjm.MurmurHash.update(hashCode, this.ruleIndex);
                hashCode = $iXFjm.MurmurHash.update(hashCode, this.predIndex);
                hashCode = $iXFjm.MurmurHash.update(hashCode, this.isCtxDependent ? 1 : 0);
                hashCode = $iXFjm.MurmurHash.finish(hashCode, 3);
                return hashCode;
            }
            equals(obj) {
                if (!(obj instanceof Predicate)) return false;
                if (this === obj) return true;
                return this.ruleIndex === obj.ruleIndex && this.predIndex === obj.predIndex && this.isCtxDependent === obj.isCtxDependent;
            }
            toString() {
                return "{" + this.ruleIndex + ":" + this.predIndex + "}?";
            }
        }
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], Predicate.prototype, "eval", null);
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], Predicate.prototype, "hashCode", null);
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], Predicate.prototype, "equals", null);
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], Predicate.prototype, "toString", null);
        SemanticContext.Predicate = Predicate;
        class PrecedencePredicate extends SemanticContext {
            constructor(precedence){
                super();
                this.precedence = precedence;
            }
            eval(parser, parserCallStack) {
                return parser.precpred(parserCallStack, this.precedence);
            }
            evalPrecedence(parser, parserCallStack) {
                if (parser.precpred(parserCallStack, this.precedence)) return SemanticContext.NONE;
                else return undefined;
            }
            compareTo(o) {
                return this.precedence - o.precedence;
            }
            hashCode() {
                let hashCode = 1;
                hashCode = 31 * hashCode + this.precedence;
                return hashCode;
            }
            equals(obj) {
                if (!(obj instanceof PrecedencePredicate)) return false;
                if (this === obj) return true;
                return this.precedence === obj.precedence;
            }
            toString() {
                return "{" + this.precedence + ">=prec}?";
            }
        }
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], PrecedencePredicate.prototype, "eval", null);
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], PrecedencePredicate.prototype, "evalPrecedence", null);
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], PrecedencePredicate.prototype, "compareTo", null);
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], PrecedencePredicate.prototype, "hashCode", null);
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], PrecedencePredicate.prototype, "equals", null);
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], PrecedencePredicate.prototype, "toString", null);
        SemanticContext.PrecedencePredicate = PrecedencePredicate;
        class Operator extends SemanticContext {
        }
        SemanticContext.Operator = Operator;
        let AND = class AND extends Operator {
            constructor(a, b){
                super();
                let operands = new $7Veax.Array2DHashSet($a4Flx.ObjectEqualityComparator.INSTANCE);
                if (a instanceof AND) operands.addAll(a.opnds);
                else operands.add(a);
                if (b instanceof AND) operands.addAll(b.opnds);
                else operands.add(b);
                this.opnds = operands.toArray();
                let precedencePredicates = filterPrecedencePredicates(this.opnds);
                let reduced = $ab4a86b5def51fe2$var$min(precedencePredicates);
                if (reduced) this.opnds.push(reduced);
            }
            get operands() {
                return this.opnds;
            }
            equals(obj) {
                if (this === obj) return true;
                if (!(obj instanceof AND)) return false;
                return $3sNxf.ArrayEqualityComparator.INSTANCE.equals(this.opnds, obj.opnds);
            }
            hashCode() {
                return $iXFjm.MurmurHash.hashCode(this.opnds, AND_HASHCODE);
            }
            eval(parser, parserCallStack) {
                for (let opnd of this.opnds){
                    if (!opnd.eval(parser, parserCallStack)) return false;
                }
                return true;
            }
            evalPrecedence(parser, parserCallStack) {
                let differs = false;
                let operands = [];
                for (let context of this.opnds){
                    let evaluated = context.evalPrecedence(parser, parserCallStack);
                    differs = differs || evaluated !== context;
                    if (evaluated == null) return undefined;
                    else if (evaluated !== SemanticContext.NONE) operands.push(evaluated);
                }
                if (!differs) return this;
                if (operands.length === 0) return SemanticContext.NONE;
                let result = operands[0];
                for(let i = 1; i < operands.length; i++)result = SemanticContext.and(result, operands[i]);
                return result;
            }
            toString() {
                return $2IEP9.join(this.opnds, "&&");
            }
        };
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], AND.prototype, "operands", null);
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], AND.prototype, "equals", null);
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], AND.prototype, "hashCode", null);
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], AND.prototype, "eval", null);
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], AND.prototype, "evalPrecedence", null);
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], AND.prototype, "toString", null);
        AND = $ab4a86b5def51fe2$var$__decorate([
            $ab4a86b5def51fe2$var$__param(0, $d6D31.NotNull),
            $ab4a86b5def51fe2$var$__param(1, $d6D31.NotNull)
        ], AND);
        SemanticContext.AND = AND;
        let OR = class OR extends Operator {
            constructor(a, b){
                super();
                let operands = new $7Veax.Array2DHashSet($a4Flx.ObjectEqualityComparator.INSTANCE);
                if (a instanceof OR) operands.addAll(a.opnds);
                else operands.add(a);
                if (b instanceof OR) operands.addAll(b.opnds);
                else operands.add(b);
                this.opnds = operands.toArray();
                let precedencePredicates = filterPrecedencePredicates(this.opnds);
                let reduced = $ab4a86b5def51fe2$var$max(precedencePredicates);
                if (reduced) this.opnds.push(reduced);
            }
            get operands() {
                return this.opnds;
            }
            equals(obj) {
                if (this === obj) return true;
                if (!(obj instanceof OR)) return false;
                return $3sNxf.ArrayEqualityComparator.INSTANCE.equals(this.opnds, obj.opnds);
            }
            hashCode() {
                return $iXFjm.MurmurHash.hashCode(this.opnds, OR_HASHCODE);
            }
            eval(parser, parserCallStack) {
                for (let opnd of this.opnds){
                    if (opnd.eval(parser, parserCallStack)) return true;
                }
                return false;
            }
            evalPrecedence(parser, parserCallStack) {
                let differs = false;
                let operands = [];
                for (let context of this.opnds){
                    let evaluated = context.evalPrecedence(parser, parserCallStack);
                    differs = differs || evaluated !== context;
                    if (evaluated === SemanticContext.NONE) return SemanticContext.NONE;
                    else if (evaluated) operands.push(evaluated);
                }
                if (!differs) return this;
                if (operands.length === 0) return undefined;
                let result = operands[0];
                for(let i = 1; i < operands.length; i++)result = SemanticContext.or(result, operands[i]);
                return result;
            }
            toString() {
                return $2IEP9.join(this.opnds, "||");
            }
        };
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], OR.prototype, "operands", null);
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], OR.prototype, "equals", null);
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], OR.prototype, "hashCode", null);
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], OR.prototype, "eval", null);
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], OR.prototype, "evalPrecedence", null);
        $ab4a86b5def51fe2$var$__decorate([
            $d6D31.Override
        ], OR.prototype, "toString", null);
        OR = $ab4a86b5def51fe2$var$__decorate([
            $ab4a86b5def51fe2$var$__param(0, $d6D31.NotNull),
            $ab4a86b5def51fe2$var$__param(1, $d6D31.NotNull)
        ], OR);
        SemanticContext.OR = OR;
    })($ab4a86b5def51fe2$var$SemanticContext = module.exports.SemanticContext || (module.exports.SemanticContext = {}));
});
parcelRegister("7Veax", function(module, exports) {
    "use strict";
    var $5c48d8f2b0160dc3$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $5c48d8f2b0160dc3$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.Array2DHashSet = void 0;
    var $bbHFU = parcelRequire("bbHFU");
    var $1EUnG = parcelRequire("1EUnG");
    var $d6D31 = parcelRequire("d6D31");
    var $iXFjm = parcelRequire("iXFjm");
    const $5c48d8f2b0160dc3$var$INITAL_CAPACITY = 16;
    const $5c48d8f2b0160dc3$var$LOAD_FACTOR = 0.75;
    class $5c48d8f2b0160dc3$var$Array2DHashSet {
        constructor(comparatorOrSet, initialCapacity = $5c48d8f2b0160dc3$var$INITAL_CAPACITY){
            this.n = 0;
            this.threshold = Math.floor($5c48d8f2b0160dc3$var$INITAL_CAPACITY * $5c48d8f2b0160dc3$var$LOAD_FACTOR);
            if (comparatorOrSet instanceof $5c48d8f2b0160dc3$var$Array2DHashSet) {
                this.comparator = comparatorOrSet.comparator;
                this.buckets = comparatorOrSet.buckets.slice(0);
                for(let i = 0; i < this.buckets.length; i++){
                    let bucket = this.buckets[i];
                    if (bucket) this.buckets[i] = bucket.slice(0);
                }
                this.n = comparatorOrSet.n;
                this.threshold = comparatorOrSet.threshold;
            } else {
                this.comparator = comparatorOrSet || $1EUnG.DefaultEqualityComparator.INSTANCE;
                this.buckets = this.createBuckets(initialCapacity);
            }
        }
        getOrAdd(o) {
            if (this.n > this.threshold) this.expand();
            return this.getOrAddImpl(o);
        }
        getOrAddImpl(o) {
            let b = this.getBucket(o);
            let bucket = this.buckets[b];
            if (!bucket) {
                bucket = [
                    o
                ];
                this.buckets[b] = bucket;
                this.n++;
                return o;
            }
            for (let existing of bucket){
                if (this.comparator.equals(existing, o)) return existing;
            }
            bucket.push(o);
            this.n++;
            return o;
        }
        get(o) {
            if (o == null) return o;
            let b = this.getBucket(o);
            let bucket = this.buckets[b];
            if (!bucket) return undefined;
            for (let e of bucket){
                if (this.comparator.equals(e, o)) return e;
            }
            return undefined;
        }
        getBucket(o) {
            let hash = this.comparator.hashCode(o);
            let b = hash & this.buckets.length - 1;
            return b;
        }
        hashCode() {
            let hash = $iXFjm.MurmurHash.initialize();
            for (let bucket of this.buckets){
                if (bucket == null) continue;
                for (let o of bucket){
                    if (o == null) break;
                    hash = $iXFjm.MurmurHash.update(hash, this.comparator.hashCode(o));
                }
            }
            hash = $iXFjm.MurmurHash.finish(hash, this.size);
            return hash;
        }
        equals(o) {
            if (o === this) return true;
            if (!(o instanceof $5c48d8f2b0160dc3$var$Array2DHashSet)) return false;
            if (o.size !== this.size) return false;
            let same = this.containsAll(o);
            return same;
        }
        expand() {
            let old = this.buckets;
            let newCapacity = this.buckets.length * 2;
            let newTable = this.createBuckets(newCapacity);
            this.buckets = newTable;
            this.threshold = Math.floor(newCapacity * $5c48d8f2b0160dc3$var$LOAD_FACTOR);
            let oldSize = this.size;
            for (let bucket of old){
                if (!bucket) continue;
                for (let o of bucket){
                    let b = this.getBucket(o);
                    let newBucket = this.buckets[b];
                    if (!newBucket) {
                        newBucket = [];
                        this.buckets[b] = newBucket;
                    }
                    newBucket.push(o);
                }
            }
            $bbHFU(this.n === oldSize);
        }
        add(t) {
            let existing = this.getOrAdd(t);
            return existing === t;
        }
        get size() {
            return this.n;
        }
        get isEmpty() {
            return this.n === 0;
        }
        contains(o) {
            return this.containsFast(this.asElementType(o));
        }
        containsFast(obj) {
            if (obj == null) return false;
            return this.get(obj) != null;
        }
        *[Symbol.iterator]() {
            yield* this.toArray();
        }
        toArray() {
            const a = new Array(this.size);
            let i = 0;
            for (let bucket of this.buckets){
                if (bucket == null) continue;
                for (let o of bucket){
                    if (o == null) break;
                    a[i++] = o;
                }
            }
            return a;
        }
        containsAll(collection) {
            if (collection instanceof $5c48d8f2b0160dc3$var$Array2DHashSet) {
                let s = collection;
                for (let bucket of s.buckets){
                    if (bucket == null) continue;
                    for (let o of bucket){
                        if (o == null) break;
                        if (!this.containsFast(this.asElementType(o))) return false;
                    }
                }
            } else for (let o of collection){
                if (!this.containsFast(this.asElementType(o))) return false;
            }
            return true;
        }
        addAll(c) {
            let changed = false;
            for (let o of c){
                let existing = this.getOrAdd(o);
                if (existing !== o) changed = true;
            }
            return changed;
        }
        clear() {
            this.buckets = this.createBuckets($5c48d8f2b0160dc3$var$INITAL_CAPACITY);
            this.n = 0;
            this.threshold = Math.floor($5c48d8f2b0160dc3$var$INITAL_CAPACITY * $5c48d8f2b0160dc3$var$LOAD_FACTOR);
        }
        toString() {
            if (this.size === 0) return "{}";
            let buf = "{";
            let first = true;
            for (let bucket of this.buckets){
                if (bucket == null) continue;
                for (let o of bucket){
                    if (o == null) break;
                    if (first) first = false;
                    else buf += ", ";
                    buf += o.toString();
                }
            }
            buf += "}";
            return buf;
        }
        toTableString() {
            let buf = "";
            for (let bucket of this.buckets){
                if (bucket == null) {
                    buf += "null\n";
                    continue;
                }
                buf += "[";
                let first = true;
                for (let o of bucket){
                    if (first) first = false;
                    else buf += " ";
                    if (o == null) buf += "_";
                    else buf += o.toString();
                }
                buf += "]\n";
            }
            return buf;
        }
        asElementType(o) {
            return o;
        }
        createBuckets(capacity) {
            return new Array(capacity);
        }
    }
    $5c48d8f2b0160dc3$var$__decorate([
        $d6D31.NotNull
    ], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "comparator", void 0);
    $5c48d8f2b0160dc3$var$__decorate([
        $d6D31.Override
    ], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "hashCode", null);
    $5c48d8f2b0160dc3$var$__decorate([
        $d6D31.Override
    ], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "equals", null);
    $5c48d8f2b0160dc3$var$__decorate([
        $d6D31.Override
    ], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "add", null);
    $5c48d8f2b0160dc3$var$__decorate([
        $d6D31.Override
    ], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "size", null);
    $5c48d8f2b0160dc3$var$__decorate([
        $d6D31.Override
    ], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "isEmpty", null);
    $5c48d8f2b0160dc3$var$__decorate([
        $d6D31.Override
    ], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "contains", null);
    $5c48d8f2b0160dc3$var$__decorate([
        $5c48d8f2b0160dc3$var$__param(0, $d6D31.Nullable)
    ], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "containsFast", null);
    $5c48d8f2b0160dc3$var$__decorate([
        $d6D31.Override
    ], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, Symbol.iterator, null);
    $5c48d8f2b0160dc3$var$__decorate([
        $d6D31.Override
    ], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "toArray", null);
    $5c48d8f2b0160dc3$var$__decorate([
        $d6D31.Override
    ], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "containsAll", null);
    $5c48d8f2b0160dc3$var$__decorate([
        $d6D31.Override
    ], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "addAll", null);
    $5c48d8f2b0160dc3$var$__decorate([
        $d6D31.Override
    ], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "clear", null);
    $5c48d8f2b0160dc3$var$__decorate([
        $d6D31.Override
    ], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "toString", null);
    $5c48d8f2b0160dc3$var$__decorate([
        $d6D31.SuppressWarnings("unchecked")
    ], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "asElementType", null);
    $5c48d8f2b0160dc3$var$__decorate([
        $d6D31.SuppressWarnings("unchecked")
    ], $5c48d8f2b0160dc3$var$Array2DHashSet.prototype, "createBuckets", null);
    module.exports.Array2DHashSet = $5c48d8f2b0160dc3$var$Array2DHashSet;
});
parcelRegister("1EUnG", function(module, exports) {
    "use strict";
    var $135542f8f0124ec7$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.DefaultEqualityComparator = void 0;
    var $d6D31 = parcelRequire("d6D31");
    var $iXFjm = parcelRequire("iXFjm");
    var $a4Flx = parcelRequire("a4Flx");
    class $135542f8f0124ec7$var$DefaultEqualityComparator {
        hashCode(obj) {
            if (obj == null) return 0;
            else if (typeof obj === "string" || typeof obj === "number") return $iXFjm.MurmurHash.hashCode([
                obj
            ]);
            else return $a4Flx.ObjectEqualityComparator.INSTANCE.hashCode(obj);
        }
        equals(a, b) {
            if (a == null) return b == null;
            else if (typeof a === "string" || typeof a === "number") return a === b;
            else return $a4Flx.ObjectEqualityComparator.INSTANCE.equals(a, b);
        }
    }
    $135542f8f0124ec7$var$DefaultEqualityComparator.INSTANCE = new $135542f8f0124ec7$var$DefaultEqualityComparator();
    $135542f8f0124ec7$var$__decorate([
        $d6D31.Override
    ], $135542f8f0124ec7$var$DefaultEqualityComparator.prototype, "hashCode", null);
    $135542f8f0124ec7$var$__decorate([
        $d6D31.Override
    ], $135542f8f0124ec7$var$DefaultEqualityComparator.prototype, "equals", null);
    module.exports.DefaultEqualityComparator = $135542f8f0124ec7$var$DefaultEqualityComparator;
});
parcelRegister("iXFjm", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.MurmurHash = void 0;
    var $dcddc83c17bb111f$var$MurmurHash;
    (function(MurmurHash) {
        const DEFAULT_SEED = 0;
        function initialize(seed = DEFAULT_SEED) {
            return seed;
        }
        MurmurHash.initialize = initialize;
        function update(hash, value) {
            const c1 = 0xCC9E2D51;
            const c2 = 0x1B873593;
            const r1 = 15;
            const r2 = 13;
            const m = 5;
            const n = 0xE6546B64;
            if (value == null) value = 0;
            else if (typeof value === "string") value = hashString(value);
            else if (typeof value === "object") value = value.hashCode();
            let k = value;
            k = Math.imul(k, c1);
            k = k << r1 | k >>> 32 - r1;
            k = Math.imul(k, c2);
            hash = hash ^ k;
            hash = hash << r2 | hash >>> 32 - r2;
            hash = Math.imul(hash, m) + n;
            return hash & 0xFFFFFFFF;
        }
        MurmurHash.update = update;
        function finish(hash, numberOfWords) {
            hash = hash ^ numberOfWords * 4;
            hash = hash ^ hash >>> 16;
            hash = Math.imul(hash, 0x85EBCA6B);
            hash = hash ^ hash >>> 13;
            hash = Math.imul(hash, 0xC2B2AE35);
            hash = hash ^ hash >>> 16;
            return hash;
        }
        MurmurHash.finish = finish;
        function hashCode(data, seed = DEFAULT_SEED) {
            let hash = initialize(seed);
            let length = 0;
            for (let value of data){
                hash = update(hash, value);
                length++;
            }
            hash = finish(hash, length);
            return hash;
        }
        MurmurHash.hashCode = hashCode;
        function hashString(str) {
            let len = str.length;
            if (len === 0) return 0;
            let hash = 0;
            for(let i = 0; i < len; i++){
                let c = str.charCodeAt(i);
                hash = (hash << 5 >>> 0) - hash + c;
                hash |= 0;
            }
            return hash;
        }
    })($dcddc83c17bb111f$var$MurmurHash = module.exports.MurmurHash || (module.exports.MurmurHash = {}));
});
parcelRegister("a4Flx", function(module, exports) {
    "use strict";
    var $755a59a5b7943f39$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ObjectEqualityComparator = void 0;
    var $d6D31 = parcelRequire("d6D31");
    class $755a59a5b7943f39$var$ObjectEqualityComparator {
        hashCode(obj) {
            if (obj == null) return 0;
            return obj.hashCode();
        }
        equals(a, b) {
            if (a == null) return b == null;
            return a.equals(b);
        }
    }
    $755a59a5b7943f39$var$ObjectEqualityComparator.INSTANCE = new $755a59a5b7943f39$var$ObjectEqualityComparator();
    $755a59a5b7943f39$var$__decorate([
        $d6D31.Override
    ], $755a59a5b7943f39$var$ObjectEqualityComparator.prototype, "hashCode", null);
    $755a59a5b7943f39$var$__decorate([
        $d6D31.Override
    ], $755a59a5b7943f39$var$ObjectEqualityComparator.prototype, "equals", null);
    module.exports.ObjectEqualityComparator = $755a59a5b7943f39$var$ObjectEqualityComparator;
});
parcelRegister("3sNxf", function(module, exports) {
    "use strict";
    var $285a6946513e4d3e$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ArrayEqualityComparator = void 0;
    var $d6D31 = parcelRequire("d6D31");
    var $iXFjm = parcelRequire("iXFjm");
    var $a4Flx = parcelRequire("a4Flx");
    class $285a6946513e4d3e$var$ArrayEqualityComparator {
        hashCode(obj) {
            if (obj == null) return 0;
            return $iXFjm.MurmurHash.hashCode(obj, 0);
        }
        equals(a, b) {
            if (a == null) return b == null;
            else if (b == null) return false;
            if (a.length !== b.length) return false;
            for(let i = 0; i < a.length; i++){
                if (!$a4Flx.ObjectEqualityComparator.INSTANCE.equals(a[i], b[i])) return false;
            }
            return true;
        }
    }
    $285a6946513e4d3e$var$ArrayEqualityComparator.INSTANCE = new $285a6946513e4d3e$var$ArrayEqualityComparator();
    $285a6946513e4d3e$var$__decorate([
        $d6D31.Override
    ], $285a6946513e4d3e$var$ArrayEqualityComparator.prototype, "hashCode", null);
    $285a6946513e4d3e$var$__decorate([
        $d6D31.Override
    ], $285a6946513e4d3e$var$ArrayEqualityComparator.prototype, "equals", null);
    module.exports.ArrayEqualityComparator = $285a6946513e4d3e$var$ArrayEqualityComparator;
});
parcelRegister("2IEP9", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.toCharArray = module.exports.toMap = module.exports.equals = module.exports.join = module.exports.escapeWhitespace = void 0;
    function $1faf5ba696168af5$var$escapeWhitespace(s, escapeSpaces) {
        return escapeSpaces ? s.replace(/ /, "\u00B7") : s.replace(/\t/, "\\t").replace(/\n/, "\\n").replace(/\r/, "\\r");
    }
    module.exports.escapeWhitespace = $1faf5ba696168af5$var$escapeWhitespace;
    function $1faf5ba696168af5$var$join(collection, separator) {
        let buf = "";
        let first = true;
        for (let current of collection){
            if (first) first = false;
            else buf += separator;
            buf += current;
        }
        return buf;
    }
    module.exports.join = $1faf5ba696168af5$var$join;
    function $1faf5ba696168af5$var$equals(x, y) {
        if (x === y) return true;
        if (x === undefined || y === undefined) return false;
        return x.equals(y);
    }
    module.exports.equals = $1faf5ba696168af5$var$equals;
    function $1faf5ba696168af5$var$toMap(keys) {
        let m = new Map();
        for(let i = 0; i < keys.length; i++)m.set(keys[i], i);
        return m;
    }
    module.exports.toMap = $1faf5ba696168af5$var$toMap;
    function $1faf5ba696168af5$var$toCharArray(str) {
        if (typeof str === "string") {
            let result = new Uint16Array(str.length);
            for(let i = 0; i < str.length; i++)result[i] = str.charCodeAt(i);
            return result;
        } else return str.toCharArray();
    }
    module.exports.toCharArray = $1faf5ba696168af5$var$toCharArray;
});
parcelRegister("iLUMi", function(module, exports) {
    "use strict";
    var $daa8a8b6b270e309$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $daa8a8b6b270e309$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.InputMismatchException = void 0;
    var $fLdDn = parcelRequire("fLdDn");
    var $d6D31 = parcelRequire("d6D31");
    let $daa8a8b6b270e309$var$InputMismatchException = class InputMismatchException extends $fLdDn.RecognitionException {
        constructor(recognizer, state, context){
            if (context === undefined) context = recognizer.context;
            super(recognizer, recognizer.inputStream, context);
            if (state !== undefined) this.setOffendingState(state);
            this.setOffendingToken(recognizer, recognizer.currentToken);
        }
    };
    $daa8a8b6b270e309$var$InputMismatchException = $daa8a8b6b270e309$var$__decorate([
        $daa8a8b6b270e309$var$__param(0, $d6D31.NotNull)
    ], $daa8a8b6b270e309$var$InputMismatchException);
    module.exports.InputMismatchException = $daa8a8b6b270e309$var$InputMismatchException;
});
parcelRegister("hGRod", function(module, exports) {
    "use strict";
    var $ce0fc5f35b4fec79$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $ce0fc5f35b4fec79$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.IntervalSet = void 0;
    var $3sNxf = parcelRequire("3sNxf");
    var $37SGk = parcelRequire("37SGk");
    var $gcfUE = parcelRequire("gcfUE");
    var $igNLf = parcelRequire("igNLf");
    var $iXFjm = parcelRequire("iXFjm");
    var $d6D31 = parcelRequire("d6D31");
    var $2DVsz = parcelRequire("2DVsz");
    class $ce0fc5f35b4fec79$var$IntervalSet {
        constructor(intervals){
            this.readonly = false;
            if (intervals != null) this._intervals = intervals.slice(0);
            else this._intervals = [];
        }
        static get COMPLETE_CHAR_SET() {
            if ($ce0fc5f35b4fec79$var$IntervalSet._COMPLETE_CHAR_SET === undefined) {
                $ce0fc5f35b4fec79$var$IntervalSet._COMPLETE_CHAR_SET = $ce0fc5f35b4fec79$var$IntervalSet.of($igNLf.Lexer.MIN_CHAR_VALUE, $igNLf.Lexer.MAX_CHAR_VALUE);
                $ce0fc5f35b4fec79$var$IntervalSet._COMPLETE_CHAR_SET.setReadonly(true);
            }
            return $ce0fc5f35b4fec79$var$IntervalSet._COMPLETE_CHAR_SET;
        }
        static get EMPTY_SET() {
            if ($ce0fc5f35b4fec79$var$IntervalSet._EMPTY_SET == null) {
                $ce0fc5f35b4fec79$var$IntervalSet._EMPTY_SET = new $ce0fc5f35b4fec79$var$IntervalSet();
                $ce0fc5f35b4fec79$var$IntervalSet._EMPTY_SET.setReadonly(true);
            }
            return $ce0fc5f35b4fec79$var$IntervalSet._EMPTY_SET;
        }
        static of(a, b = a) {
            let s = new $ce0fc5f35b4fec79$var$IntervalSet();
            s.add(a, b);
            return s;
        }
        clear() {
            if (this.readonly) throw new Error("can't alter readonly IntervalSet");
            this._intervals.length = 0;
        }
        add(a, b = a) {
            this.addRange($gcfUE.Interval.of(a, b));
        }
        addRange(addition) {
            if (this.readonly) throw new Error("can't alter readonly IntervalSet");
            if (addition.b < addition.a) return;
            for(let i = 0; i < this._intervals.length; i++){
                let r = this._intervals[i];
                if (addition.equals(r)) return;
                if (addition.adjacent(r) || !addition.disjoint(r)) {
                    let bigger = addition.union(r);
                    this._intervals[i] = bigger;
                    while(i < this._intervals.length - 1){
                        i++;
                        let next = this._intervals[i];
                        if (!bigger.adjacent(next) && bigger.disjoint(next)) break;
                        this._intervals.splice(i, 1);
                        i--;
                        this._intervals[i] = bigger.union(next);
                    }
                    return;
                }
                if (addition.startsBeforeDisjoint(r)) {
                    this._intervals.splice(i, 0, addition);
                    return;
                }
            }
            this._intervals.push(addition);
        }
        static or(sets) {
            let r = new $ce0fc5f35b4fec79$var$IntervalSet();
            for (let s of sets)r.addAll(s);
            return r;
        }
        addAll(set) {
            if (set == null) return this;
            if (set instanceof $ce0fc5f35b4fec79$var$IntervalSet) {
                let other = set;
                let n = other._intervals.length;
                for(let i = 0; i < n; i++){
                    let I = other._intervals[i];
                    this.add(I.a, I.b);
                }
            } else for (let value of set.toArray())this.add(value);
            return this;
        }
        complementRange(minElement, maxElement) {
            return this.complement($ce0fc5f35b4fec79$var$IntervalSet.of(minElement, maxElement));
        }
        complement(vocabulary) {
            if (vocabulary.isNil) return $ce0fc5f35b4fec79$var$IntervalSet.EMPTY_SET;
            let vocabularyIS;
            if (vocabulary instanceof $ce0fc5f35b4fec79$var$IntervalSet) vocabularyIS = vocabulary;
            else {
                vocabularyIS = new $ce0fc5f35b4fec79$var$IntervalSet();
                vocabularyIS.addAll(vocabulary);
            }
            return vocabularyIS.subtract(this);
        }
        subtract(a) {
            if (a == null || a.isNil) return new $ce0fc5f35b4fec79$var$IntervalSet(this._intervals);
            if (a instanceof $ce0fc5f35b4fec79$var$IntervalSet) return $ce0fc5f35b4fec79$var$IntervalSet.subtract(this, a);
            let other = new $ce0fc5f35b4fec79$var$IntervalSet();
            other.addAll(a);
            return $ce0fc5f35b4fec79$var$IntervalSet.subtract(this, other);
        }
        static subtract(left, right) {
            if (left.isNil) return new $ce0fc5f35b4fec79$var$IntervalSet();
            let result = new $ce0fc5f35b4fec79$var$IntervalSet(left._intervals);
            if (right.isNil) return result;
            let resultI = 0;
            let rightI = 0;
            while(resultI < result._intervals.length && rightI < right._intervals.length){
                let resultInterval = result._intervals[resultI];
                let rightInterval = right._intervals[rightI];
                if (rightInterval.b < resultInterval.a) {
                    rightI++;
                    continue;
                }
                if (rightInterval.a > resultInterval.b) {
                    resultI++;
                    continue;
                }
                let beforeCurrent;
                let afterCurrent;
                if (rightInterval.a > resultInterval.a) beforeCurrent = new $gcfUE.Interval(resultInterval.a, rightInterval.a - 1);
                if (rightInterval.b < resultInterval.b) afterCurrent = new $gcfUE.Interval(rightInterval.b + 1, resultInterval.b);
                if (beforeCurrent) {
                    if (afterCurrent) {
                        result._intervals[resultI] = beforeCurrent;
                        result._intervals.splice(resultI + 1, 0, afterCurrent);
                        resultI++;
                        rightI++;
                        continue;
                    } else {
                        result._intervals[resultI] = beforeCurrent;
                        resultI++;
                        continue;
                    }
                } else if (afterCurrent) {
                    result._intervals[resultI] = afterCurrent;
                    rightI++;
                    continue;
                } else {
                    result._intervals.splice(resultI, 1);
                    continue;
                }
            }
            return result;
        }
        or(a) {
            let o = new $ce0fc5f35b4fec79$var$IntervalSet();
            o.addAll(this);
            o.addAll(a);
            return o;
        }
        and(other) {
            if (other.isNil) return new $ce0fc5f35b4fec79$var$IntervalSet();
            let myIntervals = this._intervals;
            let theirIntervals = other._intervals;
            let intersection;
            let mySize = myIntervals.length;
            let theirSize = theirIntervals.length;
            let i = 0;
            let j = 0;
            while(i < mySize && j < theirSize){
                let mine = myIntervals[i];
                let theirs = theirIntervals[j];
                if (mine.startsBeforeDisjoint(theirs)) i++;
                else if (theirs.startsBeforeDisjoint(mine)) j++;
                else if (mine.properlyContains(theirs)) {
                    if (!intersection) intersection = new $ce0fc5f35b4fec79$var$IntervalSet();
                    intersection.addRange(mine.intersection(theirs));
                    j++;
                } else if (theirs.properlyContains(mine)) {
                    if (!intersection) intersection = new $ce0fc5f35b4fec79$var$IntervalSet();
                    intersection.addRange(mine.intersection(theirs));
                    i++;
                } else if (!mine.disjoint(theirs)) {
                    if (!intersection) intersection = new $ce0fc5f35b4fec79$var$IntervalSet();
                    intersection.addRange(mine.intersection(theirs));
                    if (mine.startsAfterNonDisjoint(theirs)) j++;
                    else if (theirs.startsAfterNonDisjoint(mine)) i++;
                }
            }
            if (!intersection) return new $ce0fc5f35b4fec79$var$IntervalSet();
            return intersection;
        }
        contains(el) {
            let n = this._intervals.length;
            let l = 0;
            let r = n - 1;
            while(l <= r){
                let m = l + r >> 1;
                let I = this._intervals[m];
                let a = I.a;
                let b = I.b;
                if (b < el) l = m + 1;
                else if (a > el) r = m - 1;
                else return true;
            }
            return false;
        }
        get isNil() {
            return this._intervals == null || this._intervals.length === 0;
        }
        get maxElement() {
            if (this.isNil) throw new RangeError("set is empty");
            let last = this._intervals[this._intervals.length - 1];
            return last.b;
        }
        get minElement() {
            if (this.isNil) throw new RangeError("set is empty");
            return this._intervals[0].a;
        }
        get intervals() {
            return this._intervals;
        }
        hashCode() {
            let hash = $iXFjm.MurmurHash.initialize();
            for (let I of this._intervals){
                hash = $iXFjm.MurmurHash.update(hash, I.a);
                hash = $iXFjm.MurmurHash.update(hash, I.b);
            }
            hash = $iXFjm.MurmurHash.finish(hash, this._intervals.length * 2);
            return hash;
        }
        equals(o) {
            if (o == null || !(o instanceof $ce0fc5f35b4fec79$var$IntervalSet)) return false;
            return $3sNxf.ArrayEqualityComparator.INSTANCE.equals(this._intervals, o._intervals);
        }
        toString(elemAreChar = false) {
            let buf = "";
            if (this._intervals == null || this._intervals.length === 0) return "{}";
            if (this.size > 1) buf += "{";
            let first = true;
            for (let I of this._intervals){
                if (first) first = false;
                else buf += ", ";
                let a = I.a;
                let b = I.b;
                if (a === b) {
                    if (a === $2DVsz.Token.EOF) buf += "<EOF>";
                    else if (elemAreChar) buf += "'" + String.fromCodePoint(a) + "'";
                    else buf += a;
                } else if (elemAreChar) buf += "'" + String.fromCodePoint(a) + "'..'" + String.fromCodePoint(b) + "'";
                else buf += a + ".." + b;
            }
            if (this.size > 1) buf += "}";
            return buf;
        }
        toStringVocabulary(vocabulary) {
            if (this._intervals == null || this._intervals.length === 0) return "{}";
            let buf = "";
            if (this.size > 1) buf += "{";
            let first = true;
            for (let I of this._intervals){
                if (first) first = false;
                else buf += ", ";
                let a = I.a;
                let b = I.b;
                if (a === b) buf += this.elementName(vocabulary, a);
                else for(let i = a; i <= b; i++){
                    if (i > a) buf += ", ";
                    buf += this.elementName(vocabulary, i);
                }
            }
            if (this.size > 1) buf += "}";
            return buf;
        }
        elementName(vocabulary, a) {
            if (a === $2DVsz.Token.EOF) return "<EOF>";
            else if (a === $2DVsz.Token.EPSILON) return "<EPSILON>";
            else return vocabulary.getDisplayName(a);
        }
        get size() {
            let n = 0;
            let numIntervals = this._intervals.length;
            if (numIntervals === 1) {
                let firstInterval = this._intervals[0];
                return firstInterval.b - firstInterval.a + 1;
            }
            for(let i = 0; i < numIntervals; i++){
                let I = this._intervals[i];
                n += I.b - I.a + 1;
            }
            return n;
        }
        toIntegerList() {
            let values = new $37SGk.IntegerList(this.size);
            let n = this._intervals.length;
            for(let i = 0; i < n; i++){
                let I = this._intervals[i];
                let a = I.a;
                let b = I.b;
                for(let v = a; v <= b; v++)values.add(v);
            }
            return values;
        }
        toSet() {
            let s = new Set();
            for (let I of this._intervals){
                let a = I.a;
                let b = I.b;
                for(let v = a; v <= b; v++)s.add(v);
            }
            return s;
        }
        toArray() {
            let values = new Array();
            let n = this._intervals.length;
            for(let i = 0; i < n; i++){
                let I = this._intervals[i];
                let a = I.a;
                let b = I.b;
                for(let v = a; v <= b; v++)values.push(v);
            }
            return values;
        }
        remove(el) {
            if (this.readonly) throw new Error("can't alter readonly IntervalSet");
            let n = this._intervals.length;
            for(let i = 0; i < n; i++){
                let I = this._intervals[i];
                let a = I.a;
                let b = I.b;
                if (el < a) break;
                if (el === a && el === b) {
                    this._intervals.splice(i, 1);
                    break;
                }
                if (el === a) {
                    this._intervals[i] = $gcfUE.Interval.of(I.a + 1, I.b);
                    break;
                }
                if (el === b) {
                    this._intervals[i] = $gcfUE.Interval.of(I.a, I.b - 1);
                    break;
                }
                if (el > a && el < b) {
                    let oldb = I.b;
                    this._intervals[i] = $gcfUE.Interval.of(I.a, el - 1);
                    this.add(el + 1, oldb);
                }
            }
        }
        get isReadonly() {
            return this.readonly;
        }
        setReadonly(readonly) {
            if (this.readonly && !readonly) throw new Error("can't alter readonly IntervalSet");
            this.readonly = readonly;
        }
    }
    $ce0fc5f35b4fec79$var$__decorate([
        $d6D31.Override
    ], $ce0fc5f35b4fec79$var$IntervalSet.prototype, "addAll", null);
    $ce0fc5f35b4fec79$var$__decorate([
        $d6D31.Override
    ], $ce0fc5f35b4fec79$var$IntervalSet.prototype, "complement", null);
    $ce0fc5f35b4fec79$var$__decorate([
        $d6D31.Override
    ], $ce0fc5f35b4fec79$var$IntervalSet.prototype, "subtract", null);
    $ce0fc5f35b4fec79$var$__decorate([
        $d6D31.Override
    ], $ce0fc5f35b4fec79$var$IntervalSet.prototype, "or", null);
    $ce0fc5f35b4fec79$var$__decorate([
        $d6D31.Override
    ], $ce0fc5f35b4fec79$var$IntervalSet.prototype, "and", null);
    $ce0fc5f35b4fec79$var$__decorate([
        $d6D31.Override
    ], $ce0fc5f35b4fec79$var$IntervalSet.prototype, "contains", null);
    $ce0fc5f35b4fec79$var$__decorate([
        $d6D31.Override
    ], $ce0fc5f35b4fec79$var$IntervalSet.prototype, "isNil", null);
    $ce0fc5f35b4fec79$var$__decorate([
        $d6D31.Override
    ], $ce0fc5f35b4fec79$var$IntervalSet.prototype, "hashCode", null);
    $ce0fc5f35b4fec79$var$__decorate([
        $d6D31.Override
    ], $ce0fc5f35b4fec79$var$IntervalSet.prototype, "equals", null);
    $ce0fc5f35b4fec79$var$__decorate([
        $ce0fc5f35b4fec79$var$__param(0, $d6D31.NotNull)
    ], $ce0fc5f35b4fec79$var$IntervalSet.prototype, "toStringVocabulary", null);
    $ce0fc5f35b4fec79$var$__decorate([
        $d6D31.NotNull,
        $ce0fc5f35b4fec79$var$__param(0, $d6D31.NotNull)
    ], $ce0fc5f35b4fec79$var$IntervalSet.prototype, "elementName", null);
    $ce0fc5f35b4fec79$var$__decorate([
        $d6D31.Override
    ], $ce0fc5f35b4fec79$var$IntervalSet.prototype, "size", null);
    $ce0fc5f35b4fec79$var$__decorate([
        $d6D31.Override
    ], $ce0fc5f35b4fec79$var$IntervalSet.prototype, "remove", null);
    $ce0fc5f35b4fec79$var$__decorate([
        $d6D31.NotNull
    ], $ce0fc5f35b4fec79$var$IntervalSet, "of", null);
    $ce0fc5f35b4fec79$var$__decorate([
        $d6D31.NotNull
    ], $ce0fc5f35b4fec79$var$IntervalSet, "subtract", null);
    module.exports.IntervalSet = $ce0fc5f35b4fec79$var$IntervalSet;
});
parcelRegister("37SGk", function(module, exports) {
    "use strict";
    var $246c712c5583aa9c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.IntegerList = void 0;
    var $9yG1X = parcelRequire("9yG1X");
    var $d6D31 = parcelRequire("d6D31");
    const $246c712c5583aa9c$var$EMPTY_DATA = new Int32Array(0);
    const $246c712c5583aa9c$var$INITIAL_SIZE = 4;
    const $246c712c5583aa9c$var$MAX_ARRAY_SIZE = 2147483639;
    class $246c712c5583aa9c$var$IntegerList {
        constructor(arg){
            if (!arg) {
                this._data = $246c712c5583aa9c$var$EMPTY_DATA;
                this._size = 0;
            } else if (arg instanceof $246c712c5583aa9c$var$IntegerList) {
                this._data = arg._data.slice(0);
                this._size = arg._size;
            } else if (typeof arg === "number") {
                if (arg === 0) {
                    this._data = $246c712c5583aa9c$var$EMPTY_DATA;
                    this._size = 0;
                } else {
                    this._data = new Int32Array(arg);
                    this._size = 0;
                }
            } else {
                this._data = $246c712c5583aa9c$var$EMPTY_DATA;
                this._size = 0;
                for (let value of arg)this.add(value);
            }
        }
        add(value) {
            if (this._data.length === this._size) this.ensureCapacity(this._size + 1);
            this._data[this._size] = value;
            this._size++;
        }
        addAll(list) {
            if (Array.isArray(list)) {
                this.ensureCapacity(this._size + list.length);
                this._data.subarray(this._size, this._size + list.length).set(list);
                this._size += list.length;
            } else if (list instanceof $246c712c5583aa9c$var$IntegerList) {
                this.ensureCapacity(this._size + list._size);
                this._data.subarray(this._size, this._size + list.size).set(list._data);
                this._size += list._size;
            } else {
                this.ensureCapacity(this._size + list.size);
                let current = 0;
                for (let xi of list){
                    this._data[this._size + current] = xi;
                    current++;
                }
                this._size += list.size;
            }
        }
        get(index) {
            if (index < 0 || index >= this._size) throw RangeError();
            return this._data[index];
        }
        contains(value) {
            for(let i = 0; i < this._size; i++){
                if (this._data[i] === value) return true;
            }
            return false;
        }
        set(index, value) {
            if (index < 0 || index >= this._size) throw RangeError();
            let previous = this._data[index];
            this._data[index] = value;
            return previous;
        }
        removeAt(index) {
            let value = this.get(index);
            this._data.copyWithin(index, index + 1, this._size);
            this._data[this._size - 1] = 0;
            this._size--;
            return value;
        }
        removeRange(fromIndex, toIndex) {
            if (fromIndex < 0 || toIndex < 0 || fromIndex > this._size || toIndex > this._size) throw RangeError();
            if (fromIndex > toIndex) throw RangeError();
            this._data.copyWithin(toIndex, fromIndex, this._size);
            this._data.fill(0, this._size - (toIndex - fromIndex), this._size);
            this._size -= toIndex - fromIndex;
        }
        get isEmpty() {
            return this._size === 0;
        }
        get size() {
            return this._size;
        }
        trimToSize() {
            if (this._data.length === this._size) return;
            this._data = this._data.slice(0, this._size);
        }
        clear() {
            this._data.fill(0, 0, this._size);
            this._size = 0;
        }
        toArray() {
            if (this._size === 0) return [];
            return Array.from(this._data.subarray(0, this._size));
        }
        sort() {
            this._data.subarray(0, this._size).sort();
        }
        equals(o) {
            if (o === this) return true;
            if (!(o instanceof $246c712c5583aa9c$var$IntegerList)) return false;
            if (this._size !== o._size) return false;
            for(let i = 0; i < this._size; i++){
                if (this._data[i] !== o._data[i]) return false;
            }
            return true;
        }
        hashCode() {
            let hashCode = 1;
            for(let i = 0; i < this._size; i++)hashCode = 31 * hashCode + this._data[i];
            return hashCode;
        }
        toString() {
            return this._data.toString();
        }
        binarySearch(key, fromIndex, toIndex) {
            if (fromIndex === undefined) fromIndex = 0;
            if (toIndex === undefined) toIndex = this._size;
            if (fromIndex < 0 || toIndex < 0 || fromIndex > this._size || toIndex > this._size) throw new RangeError();
            if (fromIndex > toIndex) throw new RangeError();
            return $9yG1X.Arrays.binarySearch(this._data, key, fromIndex, toIndex);
        }
        ensureCapacity(capacity) {
            if (capacity < 0 || capacity > $246c712c5583aa9c$var$MAX_ARRAY_SIZE) throw new RangeError();
            let newLength;
            if (this._data.length === 0) newLength = $246c712c5583aa9c$var$INITIAL_SIZE;
            else newLength = this._data.length;
            while(newLength < capacity){
                newLength = newLength * 2;
                if (newLength < 0 || newLength > $246c712c5583aa9c$var$MAX_ARRAY_SIZE) newLength = $246c712c5583aa9c$var$MAX_ARRAY_SIZE;
            }
            let tmp = new Int32Array(newLength);
            tmp.set(this._data);
            this._data = tmp;
        }
        toCharArray() {
            let resultArray = new Uint16Array(this._size);
            let resultIdx = 0;
            let calculatedPreciseResultSize = false;
            for(let i = 0; i < this._size; i++){
                let codePoint = this._data[i];
                if (codePoint >= 0 && codePoint < 0x10000) {
                    resultArray[resultIdx] = codePoint;
                    resultIdx++;
                    continue;
                }
                if (!calculatedPreciseResultSize) {
                    let newResultArray = new Uint16Array(this.charArraySize());
                    newResultArray.set(resultArray, 0);
                    resultArray = newResultArray;
                    calculatedPreciseResultSize = true;
                }
                let pair = String.fromCodePoint(codePoint);
                resultArray[resultIdx] = pair.charCodeAt(0);
                resultArray[resultIdx + 1] = pair.charCodeAt(1);
                resultIdx += 2;
            }
            return resultArray;
        }
        charArraySize() {
            let result = 0;
            for(let i = 0; i < this._size; i++)result += this._data[i] >= 0x10000 ? 2 : 1;
            return result;
        }
    }
    $246c712c5583aa9c$var$__decorate([
        $d6D31.NotNull
    ], $246c712c5583aa9c$var$IntegerList.prototype, "_data", void 0);
    $246c712c5583aa9c$var$__decorate([
        $d6D31.Override
    ], $246c712c5583aa9c$var$IntegerList.prototype, "equals", null);
    $246c712c5583aa9c$var$__decorate([
        $d6D31.Override
    ], $246c712c5583aa9c$var$IntegerList.prototype, "hashCode", null);
    $246c712c5583aa9c$var$__decorate([
        $d6D31.Override
    ], $246c712c5583aa9c$var$IntegerList.prototype, "toString", null);
    module.exports.IntegerList = $246c712c5583aa9c$var$IntegerList;
});
parcelRegister("9yG1X", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.Arrays = void 0;
    var $6f57e46e4dc9d39b$var$Arrays;
    (function(Arrays) {
        function binarySearch(array, key, fromIndex, toIndex) {
            return binarySearch0(array, fromIndex !== undefined ? fromIndex : 0, toIndex !== undefined ? toIndex : array.length, key);
        }
        Arrays.binarySearch = binarySearch;
        function binarySearch0(array, fromIndex, toIndex, key) {
            let low = fromIndex;
            let high = toIndex - 1;
            while(low <= high){
                let mid = low + high >>> 1;
                let midVal = array[mid];
                if (midVal < key) low = mid + 1;
                else if (midVal > key) high = mid - 1;
                else return mid;
            }
            return -(low + 1);
        }
        function toString(array) {
            let result = "[";
            let first = true;
            for (let element of array){
                if (first) first = false;
                else result += ", ";
                if (element === null) result += "null";
                else if (element === undefined) result += "undefined";
                else result += element;
            }
            result += "]";
            return result;
        }
        Arrays.toString = toString;
    })($6f57e46e4dc9d39b$var$Arrays = module.exports.Arrays || (module.exports.Arrays = {}));
});
parcelRegister("gcfUE", function(module, exports) {
    "use strict";
    var $bcaa1c4749d34439$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.Interval = void 0;
    var $d6D31 = parcelRequire("d6D31");
    const $bcaa1c4749d34439$var$INTERVAL_POOL_MAX_VALUE = 1000;
    class $bcaa1c4749d34439$var$Interval {
        constructor(a, b){
            this.a = a;
            this.b = b;
        }
        static get INVALID() {
            return $bcaa1c4749d34439$var$Interval._INVALID;
        }
        static of(a, b) {
            if (a !== b || a < 0 || a > $bcaa1c4749d34439$var$INTERVAL_POOL_MAX_VALUE) return new $bcaa1c4749d34439$var$Interval(a, b);
            if ($bcaa1c4749d34439$var$Interval.cache[a] == null) $bcaa1c4749d34439$var$Interval.cache[a] = new $bcaa1c4749d34439$var$Interval(a, a);
            return $bcaa1c4749d34439$var$Interval.cache[a];
        }
        get length() {
            if (this.b < this.a) return 0;
            return this.b - this.a + 1;
        }
        equals(o) {
            if (o === this) return true;
            else if (!(o instanceof $bcaa1c4749d34439$var$Interval)) return false;
            return this.a === o.a && this.b === o.b;
        }
        hashCode() {
            let hash = 23;
            hash = hash * 31 + this.a;
            hash = hash * 31 + this.b;
            return hash;
        }
        startsBeforeDisjoint(other) {
            return this.a < other.a && this.b < other.a;
        }
        startsBeforeNonDisjoint(other) {
            return this.a <= other.a && this.b >= other.a;
        }
        startsAfter(other) {
            return this.a > other.a;
        }
        startsAfterDisjoint(other) {
            return this.a > other.b;
        }
        startsAfterNonDisjoint(other) {
            return this.a > other.a && this.a <= other.b;
        }
        disjoint(other) {
            return this.startsBeforeDisjoint(other) || this.startsAfterDisjoint(other);
        }
        adjacent(other) {
            return this.a === other.b + 1 || this.b === other.a - 1;
        }
        properlyContains(other) {
            return other.a >= this.a && other.b <= this.b;
        }
        union(other) {
            return $bcaa1c4749d34439$var$Interval.of(Math.min(this.a, other.a), Math.max(this.b, other.b));
        }
        intersection(other) {
            return $bcaa1c4749d34439$var$Interval.of(Math.max(this.a, other.a), Math.min(this.b, other.b));
        }
        differenceNotProperlyContained(other) {
            let diff;
            if (other.startsBeforeNonDisjoint(this)) diff = $bcaa1c4749d34439$var$Interval.of(Math.max(this.a, other.b + 1), this.b);
            else if (other.startsAfterNonDisjoint(this)) diff = $bcaa1c4749d34439$var$Interval.of(this.a, other.a - 1);
            return diff;
        }
        toString() {
            return this.a + ".." + this.b;
        }
    }
    $bcaa1c4749d34439$var$Interval._INVALID = new $bcaa1c4749d34439$var$Interval(-1, -2);
    $bcaa1c4749d34439$var$Interval.cache = new Array($bcaa1c4749d34439$var$INTERVAL_POOL_MAX_VALUE + 1);
    $bcaa1c4749d34439$var$__decorate([
        $d6D31.Override
    ], $bcaa1c4749d34439$var$Interval.prototype, "equals", null);
    $bcaa1c4749d34439$var$__decorate([
        $d6D31.Override
    ], $bcaa1c4749d34439$var$Interval.prototype, "hashCode", null);
    $bcaa1c4749d34439$var$__decorate([
        $d6D31.Override
    ], $bcaa1c4749d34439$var$Interval.prototype, "toString", null);
    module.exports.Interval = $bcaa1c4749d34439$var$Interval;
});
parcelRegister("igNLf", function(module, exports) {
    "use strict";
    var $d4d0521f20d9c4ac$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.Lexer = void 0;
    var $gWaB3 = parcelRequire("gWaB3");
    var $6Kebn = parcelRequire("6Kebn");
    var $gcfUE = parcelRequire("gcfUE");
    var $ceaEj = parcelRequire("ceaEj");
    var $lQecE = parcelRequire("lQecE");
    var $fOEQQ = parcelRequire("fOEQQ");
    var $d6D31 = parcelRequire("d6D31");
    var $kBaAZ = parcelRequire("kBaAZ");
    var $2DVsz = parcelRequire("2DVsz");
    class $d4d0521f20d9c4ac$var$Lexer extends $kBaAZ.Recognizer {
        constructor(input){
            super();
            this._factory = $gWaB3.CommonTokenFactory.DEFAULT;
            this._tokenStartCharIndex = -1;
            this._tokenStartLine = 0;
            this._tokenStartCharPositionInLine = 0;
            this._hitEOF = false;
            this._channel = 0;
            this._type = 0;
            this._modeStack = new $6Kebn.IntegerStack();
            this._mode = $d4d0521f20d9c4ac$var$Lexer.DEFAULT_MODE;
            this._input = input;
            this._tokenFactorySourcePair = {
                source: this,
                stream: input
            };
        }
        static get DEFAULT_TOKEN_CHANNEL() {
            return $2DVsz.Token.DEFAULT_CHANNEL;
        }
        static get HIDDEN() {
            return $2DVsz.Token.HIDDEN_CHANNEL;
        }
        reset(resetInput) {
            if (resetInput === undefined || resetInput) this._input.seek(0);
            this._token = undefined;
            this._type = $2DVsz.Token.INVALID_TYPE;
            this._channel = $2DVsz.Token.DEFAULT_CHANNEL;
            this._tokenStartCharIndex = -1;
            this._tokenStartCharPositionInLine = -1;
            this._tokenStartLine = -1;
            this._text = undefined;
            this._hitEOF = false;
            this._mode = $d4d0521f20d9c4ac$var$Lexer.DEFAULT_MODE;
            this._modeStack.clear();
            this.interpreter.reset();
        }
        nextToken() {
            if (this._input == null) throw new Error("nextToken requires a non-null input stream.");
            let tokenStartMarker = this._input.mark();
            try {
                outer: while(true){
                    if (this._hitEOF) return this.emitEOF();
                    this._token = undefined;
                    this._channel = $2DVsz.Token.DEFAULT_CHANNEL;
                    this._tokenStartCharIndex = this._input.index;
                    this._tokenStartCharPositionInLine = this.interpreter.charPositionInLine;
                    this._tokenStartLine = this.interpreter.line;
                    this._text = undefined;
                    do {
                        this._type = $2DVsz.Token.INVALID_TYPE;
                        let ttype;
                        try {
                            ttype = this.interpreter.match(this._input, this._mode);
                        } catch (e) {
                            if (e instanceof $fOEQQ.LexerNoViableAltException) {
                                this.notifyListeners(e);
                                this.recover(e);
                                ttype = $d4d0521f20d9c4ac$var$Lexer.SKIP;
                            } else throw e;
                        }
                        if (this._input.LA(1) === $ceaEj.IntStream.EOF) this._hitEOF = true;
                        if (this._type === $2DVsz.Token.INVALID_TYPE) this._type = ttype;
                        if (this._type === $d4d0521f20d9c4ac$var$Lexer.SKIP) continue outer;
                    }while (this._type === $d4d0521f20d9c4ac$var$Lexer.MORE)
                    if (this._token == null) return this.emit();
                    return this._token;
                }
            } finally{
                this._input.release(tokenStartMarker);
            }
        }
        skip() {
            this._type = $d4d0521f20d9c4ac$var$Lexer.SKIP;
        }
        more() {
            this._type = $d4d0521f20d9c4ac$var$Lexer.MORE;
        }
        mode(m) {
            this._mode = m;
        }
        pushMode(m) {
            if ($lQecE.LexerATNSimulator.debug) console.log("pushMode " + m);
            this._modeStack.push(this._mode);
            this.mode(m);
        }
        popMode() {
            if (this._modeStack.isEmpty) throw new Error("EmptyStackException");
            if ($lQecE.LexerATNSimulator.debug) console.log("popMode back to " + this._modeStack.peek());
            this.mode(this._modeStack.pop());
            return this._mode;
        }
        get tokenFactory() {
            return this._factory;
        }
        set tokenFactory(factory) {
            this._factory = factory;
        }
        get inputStream() {
            return this._input;
        }
        set inputStream(input) {
            this.reset(false);
            this._input = input;
            this._tokenFactorySourcePair = {
                source: this,
                stream: this._input
            };
        }
        get sourceName() {
            return this._input.sourceName;
        }
        emit(token) {
            if (!token) token = this._factory.create(this._tokenFactorySourcePair, this._type, this._text, this._channel, this._tokenStartCharIndex, this.charIndex - 1, this._tokenStartLine, this._tokenStartCharPositionInLine);
            this._token = token;
            return token;
        }
        emitEOF() {
            let cpos = this.charPositionInLine;
            let line = this.line;
            let eof = this._factory.create(this._tokenFactorySourcePair, $2DVsz.Token.EOF, undefined, $2DVsz.Token.DEFAULT_CHANNEL, this._input.index, this._input.index - 1, line, cpos);
            this.emit(eof);
            return eof;
        }
        get line() {
            return this.interpreter.line;
        }
        set line(line) {
            this.interpreter.line = line;
        }
        get charPositionInLine() {
            return this.interpreter.charPositionInLine;
        }
        set charPositionInLine(charPositionInLine) {
            this.interpreter.charPositionInLine = charPositionInLine;
        }
        get charIndex() {
            return this._input.index;
        }
        get text() {
            if (this._text != null) return this._text;
            return this.interpreter.getText(this._input);
        }
        set text(text) {
            this._text = text;
        }
        get token() {
            return this._token;
        }
        set token(_token) {
            this._token = _token;
        }
        set type(ttype) {
            this._type = ttype;
        }
        get type() {
            return this._type;
        }
        set channel(channel) {
            this._channel = channel;
        }
        get channel() {
            return this._channel;
        }
        getAllTokens() {
            let tokens = [];
            let t = this.nextToken();
            while(t.type !== $2DVsz.Token.EOF){
                tokens.push(t);
                t = this.nextToken();
            }
            return tokens;
        }
        notifyListeners(e) {
            let text = this._input.getText($gcfUE.Interval.of(this._tokenStartCharIndex, this._input.index));
            let msg = "token recognition error at: '" + this.getErrorDisplay(text) + "'";
            let listener = this.getErrorListenerDispatch();
            if (listener.syntaxError) listener.syntaxError(this, undefined, this._tokenStartLine, this._tokenStartCharPositionInLine, msg, e);
        }
        getErrorDisplay(s) {
            if (typeof s === "number") {
                switch(s){
                    case $2DVsz.Token.EOF:
                        return "<EOF>";
                    case 0x0a:
                        return "\\n";
                    case 0x09:
                        return "\\t";
                    case 0x0d:
                        return "\\r";
                }
                return String.fromCharCode(s);
            }
            return s.replace(/\n/g, "\\n").replace(/\t/g, "\\t").replace(/\r/g, "\\r");
        }
        getCharErrorDisplay(c) {
            let s = this.getErrorDisplay(c);
            return "'" + s + "'";
        }
        recover(re) {
            if (re instanceof $fOEQQ.LexerNoViableAltException) {
                if (this._input.LA(1) !== $ceaEj.IntStream.EOF) this.interpreter.consume(this._input);
            } else this._input.consume();
        }
    }
    $d4d0521f20d9c4ac$var$Lexer.DEFAULT_MODE = 0;
    $d4d0521f20d9c4ac$var$Lexer.MORE = -2;
    $d4d0521f20d9c4ac$var$Lexer.SKIP = -3;
    $d4d0521f20d9c4ac$var$Lexer.MIN_CHAR_VALUE = 0x0000;
    $d4d0521f20d9c4ac$var$Lexer.MAX_CHAR_VALUE = 0x10FFFF;
    $d4d0521f20d9c4ac$var$__decorate([
        $d6D31.Override
    ], $d4d0521f20d9c4ac$var$Lexer.prototype, "nextToken", null);
    $d4d0521f20d9c4ac$var$__decorate([
        $d6D31.Override
    ], $d4d0521f20d9c4ac$var$Lexer.prototype, "tokenFactory", null);
    $d4d0521f20d9c4ac$var$__decorate([
        $d6D31.Override
    ], $d4d0521f20d9c4ac$var$Lexer.prototype, "inputStream", null);
    $d4d0521f20d9c4ac$var$__decorate([
        $d6D31.Override
    ], $d4d0521f20d9c4ac$var$Lexer.prototype, "sourceName", null);
    $d4d0521f20d9c4ac$var$__decorate([
        $d6D31.Override
    ], $d4d0521f20d9c4ac$var$Lexer.prototype, "line", null);
    $d4d0521f20d9c4ac$var$__decorate([
        $d6D31.Override
    ], $d4d0521f20d9c4ac$var$Lexer.prototype, "charPositionInLine", null);
    module.exports.Lexer = $d4d0521f20d9c4ac$var$Lexer;
});
parcelRegister("gWaB3", function(module, exports) {
    "use strict";
    var $c54a4863b793dbc8$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.CommonTokenFactory = void 0;
    var $j53rr = parcelRequire("j53rr");
    var $gcfUE = parcelRequire("gcfUE");
    var $d6D31 = parcelRequire("d6D31");
    class $c54a4863b793dbc8$var$CommonTokenFactory {
        constructor(copyText = false){
            this.copyText = copyText;
        }
        create(source, type, text, channel, start, stop, line, charPositionInLine) {
            let t = new $j53rr.CommonToken(type, text, source, channel, start, stop);
            t.line = line;
            t.charPositionInLine = charPositionInLine;
            if (text == null && this.copyText && source.stream != null) t.text = source.stream.getText($gcfUE.Interval.of(start, stop));
            return t;
        }
        createSimple(type, text) {
            return new $j53rr.CommonToken(type, text);
        }
    }
    $c54a4863b793dbc8$var$__decorate([
        $d6D31.Override
    ], $c54a4863b793dbc8$var$CommonTokenFactory.prototype, "create", null);
    $c54a4863b793dbc8$var$__decorate([
        $d6D31.Override
    ], $c54a4863b793dbc8$var$CommonTokenFactory.prototype, "createSimple", null);
    module.exports.CommonTokenFactory = $c54a4863b793dbc8$var$CommonTokenFactory;
    (function(CommonTokenFactory) {
        CommonTokenFactory.DEFAULT = new CommonTokenFactory();
    })($c54a4863b793dbc8$var$CommonTokenFactory = module.exports.CommonTokenFactory || (module.exports.CommonTokenFactory = {}));
});
parcelRegister("j53rr", function(module, exports) {
    "use strict";
    var $de41275c931ca469$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $de41275c931ca469$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.CommonToken = void 0;
    var $gcfUE = parcelRequire("gcfUE");
    var $d6D31 = parcelRequire("d6D31");
    var $2DVsz = parcelRequire("2DVsz");
    let $de41275c931ca469$var$CommonToken = class CommonToken {
        constructor(type, text, source = CommonToken.EMPTY_SOURCE, channel = $2DVsz.Token.DEFAULT_CHANNEL, start = 0, stop = 0){
            this._line = 0;
            this._charPositionInLine = -1;
            this._channel = $2DVsz.Token.DEFAULT_CHANNEL;
            this.index = -1;
            this._text = text;
            this._type = type;
            this.source = source;
            this._channel = channel;
            this.start = start;
            this.stop = stop;
            if (source.source != null) {
                this._line = source.source.line;
                this._charPositionInLine = source.source.charPositionInLine;
            }
        }
        static fromToken(oldToken) {
            let result = new CommonToken(oldToken.type, undefined, CommonToken.EMPTY_SOURCE, oldToken.channel, oldToken.startIndex, oldToken.stopIndex);
            result._line = oldToken.line;
            result.index = oldToken.tokenIndex;
            result._charPositionInLine = oldToken.charPositionInLine;
            if (oldToken instanceof CommonToken) {
                result._text = oldToken._text;
                result.source = oldToken.source;
            } else {
                result._text = oldToken.text;
                result.source = {
                    source: oldToken.tokenSource,
                    stream: oldToken.inputStream
                };
            }
            return result;
        }
        get type() {
            return this._type;
        }
        set type(type) {
            this._type = type;
        }
        get line() {
            return this._line;
        }
        set line(line) {
            this._line = line;
        }
        get text() {
            if (this._text != null) return this._text;
            let input = this.inputStream;
            if (input == null) return undefined;
            let n = input.size;
            if (this.start < n && this.stop < n) return input.getText($gcfUE.Interval.of(this.start, this.stop));
            else return "<EOF>";
        }
        set text(text) {
            this._text = text;
        }
        get charPositionInLine() {
            return this._charPositionInLine;
        }
        set charPositionInLine(charPositionInLine) {
            this._charPositionInLine = charPositionInLine;
        }
        get channel() {
            return this._channel;
        }
        set channel(channel) {
            this._channel = channel;
        }
        get startIndex() {
            return this.start;
        }
        set startIndex(start) {
            this.start = start;
        }
        get stopIndex() {
            return this.stop;
        }
        set stopIndex(stop) {
            this.stop = stop;
        }
        get tokenIndex() {
            return this.index;
        }
        set tokenIndex(index) {
            this.index = index;
        }
        get tokenSource() {
            return this.source.source;
        }
        get inputStream() {
            return this.source.stream;
        }
        toString(recognizer) {
            let channelStr = "";
            if (this._channel > 0) channelStr = ",channel=" + this._channel;
            let txt = this.text;
            if (txt != null) {
                txt = txt.replace(/\n/g, "\\n");
                txt = txt.replace(/\r/g, "\\r");
                txt = txt.replace(/\t/g, "\\t");
            } else txt = "<no text>";
            let typeString = String(this._type);
            if (recognizer) typeString = recognizer.vocabulary.getDisplayName(this._type);
            return "[@" + this.tokenIndex + "," + this.start + ":" + this.stop + "='" + txt + "',<" + typeString + ">" + channelStr + "," + this._line + ":" + this.charPositionInLine + "]";
        }
    };
    $de41275c931ca469$var$CommonToken.EMPTY_SOURCE = {
        source: undefined,
        stream: undefined
    };
    $de41275c931ca469$var$__decorate([
        $d6D31.NotNull
    ], $de41275c931ca469$var$CommonToken.prototype, "source", void 0);
    $de41275c931ca469$var$__decorate([
        $d6D31.Override
    ], $de41275c931ca469$var$CommonToken.prototype, "type", null);
    $de41275c931ca469$var$__decorate([
        $d6D31.Override
    ], $de41275c931ca469$var$CommonToken.prototype, "line", null);
    $de41275c931ca469$var$__decorate([
        $d6D31.Override
    ], $de41275c931ca469$var$CommonToken.prototype, "text", null);
    $de41275c931ca469$var$__decorate([
        $d6D31.Override
    ], $de41275c931ca469$var$CommonToken.prototype, "charPositionInLine", null);
    $de41275c931ca469$var$__decorate([
        $d6D31.Override
    ], $de41275c931ca469$var$CommonToken.prototype, "channel", null);
    $de41275c931ca469$var$__decorate([
        $d6D31.Override
    ], $de41275c931ca469$var$CommonToken.prototype, "startIndex", null);
    $de41275c931ca469$var$__decorate([
        $d6D31.Override
    ], $de41275c931ca469$var$CommonToken.prototype, "stopIndex", null);
    $de41275c931ca469$var$__decorate([
        $d6D31.Override
    ], $de41275c931ca469$var$CommonToken.prototype, "tokenIndex", null);
    $de41275c931ca469$var$__decorate([
        $d6D31.Override
    ], $de41275c931ca469$var$CommonToken.prototype, "tokenSource", null);
    $de41275c931ca469$var$__decorate([
        $d6D31.Override
    ], $de41275c931ca469$var$CommonToken.prototype, "inputStream", null);
    $de41275c931ca469$var$__decorate([
        $d6D31.Override
    ], $de41275c931ca469$var$CommonToken.prototype, "toString", null);
    $de41275c931ca469$var$__decorate([
        $de41275c931ca469$var$__param(0, $d6D31.NotNull)
    ], $de41275c931ca469$var$CommonToken, "fromToken", null);
    $de41275c931ca469$var$CommonToken = $de41275c931ca469$var$__decorate([
        $de41275c931ca469$var$__param(2, $d6D31.NotNull)
    ], $de41275c931ca469$var$CommonToken);
    module.exports.CommonToken = $de41275c931ca469$var$CommonToken;
});
parcelRegister("2DVsz", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.Token = void 0;
    var $ceaEj = parcelRequire("ceaEj");
    var $1ecbcb9fde4eac7e$var$Token;
    (function(Token) {
        Token.INVALID_TYPE = 0;
        Token.EPSILON = -2;
        Token.MIN_USER_TOKEN_TYPE = 1;
        Token.EOF = $ceaEj.IntStream.EOF;
        Token.DEFAULT_CHANNEL = 0;
        Token.HIDDEN_CHANNEL = 1;
        Token.MIN_USER_CHANNEL_VALUE = 2;
    })($1ecbcb9fde4eac7e$var$Token = module.exports.Token || (module.exports.Token = {}));
});
parcelRegister("6Kebn", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.IntegerStack = void 0;
    var $37SGk = parcelRequire("37SGk");
    class $4e920a4df7f4a425$var$IntegerStack extends $37SGk.IntegerList {
        constructor(arg){
            super(arg);
        }
        push(value) {
            this.add(value);
        }
        pop() {
            return this.removeAt(this.size - 1);
        }
        peek() {
            return this.get(this.size - 1);
        }
    }
    module.exports.IntegerStack = $4e920a4df7f4a425$var$IntegerStack;
});
parcelRegister("lQecE", function(module, exports) {
    "use strict";
    var $fe6978bd928c111b$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $fe6978bd928c111b$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.LexerATNSimulator = void 0;
    var $41NTU = parcelRequire("41NTU");
    var $bcnvE = parcelRequire("bcnvE");
    var $gcX0f = parcelRequire("gcX0f");
    var $c1ClW = parcelRequire("c1ClW");
    var $kr9A1 = parcelRequire("kr9A1");
    var $2jevZ = parcelRequire("2jevZ");
    var $gcfUE = parcelRequire("gcfUE");
    var $ceaEj = parcelRequire("ceaEj");
    var $igNLf = parcelRequire("igNLf");
    var $3AYVu = parcelRequire("3AYVu");
    var $fOEQQ = parcelRequire("fOEQQ");
    var $d6D31 = parcelRequire("d6D31");
    var $9tIYC = parcelRequire("9tIYC");
    var $8DTT0 = parcelRequire("8DTT0");
    var $4kGBm = parcelRequire("4kGBm");
    var $2DVsz = parcelRequire("2DVsz");
    var $bbHFU = parcelRequire("bbHFU");
    let $fe6978bd928c111b$var$LexerATNSimulator = class LexerATNSimulator extends $kr9A1.ATNSimulator {
        constructor(atn, recog){
            super(atn);
            this.optimize_tail_calls = true;
            this.startIndex = -1;
            this._line = 1;
            this._charPositionInLine = 0;
            this.mode = $igNLf.Lexer.DEFAULT_MODE;
            this.prevAccept = new LexerATNSimulator.SimState();
            this.recog = recog;
        }
        copyState(simulator) {
            this._charPositionInLine = simulator.charPositionInLine;
            this._line = simulator._line;
            this.mode = simulator.mode;
            this.startIndex = simulator.startIndex;
        }
        match(input, mode) {
            this.mode = mode;
            let mark = input.mark();
            try {
                this.startIndex = input.index;
                this.prevAccept.reset();
                let s0 = this.atn.modeToDFA[mode].s0;
                if (s0 == null) return this.matchATN(input);
                else return this.execATN(input, s0);
            } finally{
                input.release(mark);
            }
        }
        reset() {
            this.prevAccept.reset();
            this.startIndex = -1;
            this._line = 1;
            this._charPositionInLine = 0;
            this.mode = $igNLf.Lexer.DEFAULT_MODE;
        }
        matchATN(input) {
            let startState = this.atn.modeToStartState[this.mode];
            if (LexerATNSimulator.debug) console.log(`matchATN mode ${this.mode} start: ${startState}`);
            let old_mode = this.mode;
            let s0_closure = this.computeStartState(input, startState);
            let suppressEdge = s0_closure.hasSemanticContext;
            if (suppressEdge) s0_closure.hasSemanticContext = false;
            let next = this.addDFAState(s0_closure);
            if (!suppressEdge) {
                let dfa = this.atn.modeToDFA[this.mode];
                if (!dfa.s0) dfa.s0 = next;
                else next = dfa.s0;
            }
            let predict = this.execATN(input, next);
            if (LexerATNSimulator.debug) console.log(`DFA after matchATN: ${this.atn.modeToDFA[old_mode].toLexerString()}`);
            return predict;
        }
        execATN(input, ds0) {
            if (LexerATNSimulator.debug) console.log(`start state closure=${ds0.configs}`);
            if (ds0.isAcceptState) this.captureSimState(this.prevAccept, input, ds0);
            let t = input.LA(1);
            let s = ds0;
            while(true){
                if (LexerATNSimulator.debug) console.log(`execATN loop starting closure: ${s.configs}`);
                let target = this.getExistingTargetState(s, t);
                if (target == null) target = this.computeTargetState(input, s, t);
                if (target === $kr9A1.ATNSimulator.ERROR) break;
                if (t !== $ceaEj.IntStream.EOF) this.consume(input);
                if (target.isAcceptState) {
                    this.captureSimState(this.prevAccept, input, target);
                    if (t === $ceaEj.IntStream.EOF) break;
                }
                t = input.LA(1);
                s = target;
            }
            return this.failOrAccept(this.prevAccept, input, s.configs, t);
        }
        getExistingTargetState(s, t) {
            let target = s.getTarget(t);
            if (LexerATNSimulator.debug && target != null) console.log("reuse state " + s.stateNumber + " edge to " + target.stateNumber);
            return target;
        }
        computeTargetState(input, s, t) {
            let reach = new $9tIYC.OrderedATNConfigSet();
            this.getReachableConfigSet(input, s.configs, reach, t);
            if (reach.isEmpty) {
                if (!reach.hasSemanticContext) this.addDFAEdge(s, t, $kr9A1.ATNSimulator.ERROR);
                return $kr9A1.ATNSimulator.ERROR;
            }
            return this.addDFAEdge(s, t, reach);
        }
        failOrAccept(prevAccept, input, reach, t) {
            if (prevAccept.dfaState != null) {
                let lexerActionExecutor = prevAccept.dfaState.lexerActionExecutor;
                this.accept(input, lexerActionExecutor, this.startIndex, prevAccept.index, prevAccept.line, prevAccept.charPos);
                return prevAccept.dfaState.prediction;
            } else {
                if (t === $ceaEj.IntStream.EOF && input.index === this.startIndex) return $2DVsz.Token.EOF;
                throw new $fOEQQ.LexerNoViableAltException(this.recog, input, this.startIndex, reach);
            }
        }
        getReachableConfigSet(input, closure, reach, t) {
            let skipAlt = $bcnvE.ATN.INVALID_ALT_NUMBER;
            for (let c of closure){
                let currentAltReachedAcceptState = c.alt === skipAlt;
                if (currentAltReachedAcceptState && c.hasPassedThroughNonGreedyDecision) continue;
                if (LexerATNSimulator.debug) console.log(`testing ${this.getTokenName(t)} at ${c.toString(this.recog, true)}`);
                let n = c.state.numberOfOptimizedTransitions;
                for(let ti = 0; ti < n; ti++){
                    let trans = c.state.getOptimizedTransition(ti);
                    let target = this.getReachableTarget(trans, t);
                    if (target != null) {
                        let lexerActionExecutor = c.lexerActionExecutor;
                        let config;
                        if (lexerActionExecutor != null) {
                            lexerActionExecutor = lexerActionExecutor.fixOffsetBeforeMatch(input.index - this.startIndex);
                            config = c.transform(target, true, lexerActionExecutor);
                        } else {
                            $bbHFU(c.lexerActionExecutor == null);
                            config = c.transform(target, true);
                        }
                        let treatEofAsEpsilon = t === $ceaEj.IntStream.EOF;
                        if (this.closure(input, config, reach, currentAltReachedAcceptState, true, treatEofAsEpsilon)) {
                            skipAlt = c.alt;
                            break;
                        }
                    }
                }
            }
        }
        accept(input, lexerActionExecutor, startIndex, index, line, charPos) {
            if (LexerATNSimulator.debug) console.log(`ACTION ${lexerActionExecutor}`);
            input.seek(index);
            this._line = line;
            this._charPositionInLine = charPos;
            if (lexerActionExecutor != null && this.recog != null) lexerActionExecutor.execute(this.recog, input, startIndex);
        }
        getReachableTarget(trans, t) {
            if (trans.matches(t, $igNLf.Lexer.MIN_CHAR_VALUE, $igNLf.Lexer.MAX_CHAR_VALUE)) return trans.target;
            return undefined;
        }
        computeStartState(input, p) {
            let initialContext = $8DTT0.PredictionContext.EMPTY_FULL;
            let configs = new $9tIYC.OrderedATNConfigSet();
            for(let i = 0; i < p.numberOfTransitions; i++){
                let target = p.transition(i).target;
                let c = $gcX0f.ATNConfig.create(target, i + 1, initialContext);
                this.closure(input, c, configs, false, false, false);
            }
            return configs;
        }
        closure(input, config, configs, currentAltReachedAcceptState, speculative, treatEofAsEpsilon) {
            if (LexerATNSimulator.debug) console.log("closure(" + config.toString(this.recog, true) + ")");
            if (config.state instanceof $4kGBm.RuleStopState) {
                if (LexerATNSimulator.debug) {
                    if (this.recog != null) console.log(`closure at ${this.recog.ruleNames[config.state.ruleIndex]} rule stop ${config}`);
                    else console.log(`closure at rule stop ${config}`);
                }
                let context = config.context;
                if (context.isEmpty) {
                    configs.add(config);
                    return true;
                } else if (context.hasEmpty) {
                    configs.add(config.transform(config.state, true, $8DTT0.PredictionContext.EMPTY_FULL));
                    currentAltReachedAcceptState = true;
                }
                for(let i = 0; i < context.size; i++){
                    let returnStateNumber = context.getReturnState(i);
                    if (returnStateNumber === $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY) continue;
                    let newContext = context.getParent(i);
                    let returnState = this.atn.states[returnStateNumber];
                    let c = config.transform(returnState, false, newContext);
                    currentAltReachedAcceptState = this.closure(input, c, configs, currentAltReachedAcceptState, speculative, treatEofAsEpsilon);
                }
                return currentAltReachedAcceptState;
            }
            if (!config.state.onlyHasEpsilonTransitions) {
                if (!currentAltReachedAcceptState || !config.hasPassedThroughNonGreedyDecision) configs.add(config);
            }
            let p = config.state;
            for(let i = 0; i < p.numberOfOptimizedTransitions; i++){
                let t = p.getOptimizedTransition(i);
                let c = this.getEpsilonTarget(input, config, t, configs, speculative, treatEofAsEpsilon);
                if (c != null) currentAltReachedAcceptState = this.closure(input, c, configs, currentAltReachedAcceptState, speculative, treatEofAsEpsilon);
            }
            return currentAltReachedAcceptState;
        }
        getEpsilonTarget(input, config, t, configs, speculative, treatEofAsEpsilon) {
            let c;
            switch(t.serializationType){
                case 3:
                    let ruleTransition = t;
                    if (this.optimize_tail_calls && ruleTransition.optimizedTailCall && !config.context.hasEmpty) c = config.transform(t.target, true);
                    else {
                        let newContext = config.context.getChild(ruleTransition.followState.stateNumber);
                        c = config.transform(t.target, true, newContext);
                    }
                    break;
                case 10:
                    throw new Error("Precedence predicates are not supported in lexers.");
                case 4:
                    let pt = t;
                    if (LexerATNSimulator.debug) console.log("EVAL rule " + pt.ruleIndex + ":" + pt.predIndex);
                    configs.hasSemanticContext = true;
                    if (this.evaluatePredicate(input, pt.ruleIndex, pt.predIndex, speculative)) c = config.transform(t.target, true);
                    else c = undefined;
                    break;
                case 6:
                    if (config.context.hasEmpty) {
                        let lexerActionExecutor = $3AYVu.LexerActionExecutor.append(config.lexerActionExecutor, this.atn.lexerActions[t.actionIndex]);
                        c = config.transform(t.target, true, lexerActionExecutor);
                        break;
                    } else {
                        c = config.transform(t.target, true);
                        break;
                    }
                case 1:
                    c = config.transform(t.target, true);
                    break;
                case 5:
                case 2:
                case 7:
                    if (treatEofAsEpsilon) {
                        if (t.matches($ceaEj.IntStream.EOF, $igNLf.Lexer.MIN_CHAR_VALUE, $igNLf.Lexer.MAX_CHAR_VALUE)) {
                            c = config.transform(t.target, false);
                            break;
                        }
                    }
                    c = undefined;
                    break;
                default:
                    c = undefined;
                    break;
            }
            return c;
        }
        evaluatePredicate(input, ruleIndex, predIndex, speculative) {
            if (this.recog == null) return true;
            if (!speculative) return this.recog.sempred(undefined, ruleIndex, predIndex);
            let savedCharPositionInLine = this._charPositionInLine;
            let savedLine = this._line;
            let index = input.index;
            let marker = input.mark();
            try {
                this.consume(input);
                return this.recog.sempred(undefined, ruleIndex, predIndex);
            } finally{
                this._charPositionInLine = savedCharPositionInLine;
                this._line = savedLine;
                input.seek(index);
                input.release(marker);
            }
        }
        captureSimState(settings, input, dfaState) {
            settings.index = input.index;
            settings.line = this._line;
            settings.charPos = this._charPositionInLine;
            settings.dfaState = dfaState;
        }
        addDFAEdge(p, t, q) {
            if (q instanceof $c1ClW.ATNConfigSet) {
                let suppressEdge = q.hasSemanticContext;
                if (suppressEdge) q.hasSemanticContext = false;
                let to = this.addDFAState(q);
                if (suppressEdge) return to;
                this.addDFAEdge(p, t, to);
                return to;
            } else {
                if (LexerATNSimulator.debug) console.log("EDGE " + p + " -> " + q + " upon " + String.fromCharCode(t));
                if (p != null) p.setTarget(t, q);
            }
        }
        addDFAState(configs) {
            $bbHFU(!configs.hasSemanticContext);
            let proposed = new $2jevZ.DFAState(configs);
            let existing = this.atn.modeToDFA[this.mode].states.get(proposed);
            if (existing != null) return existing;
            configs.optimizeConfigs(this);
            let newState = new $2jevZ.DFAState(configs.clone(true));
            let firstConfigWithRuleStopState;
            for (let c of configs)if (c.state instanceof $4kGBm.RuleStopState) {
                firstConfigWithRuleStopState = c;
                break;
            }
            if (firstConfigWithRuleStopState != null) {
                let prediction = this.atn.ruleToTokenType[firstConfigWithRuleStopState.state.ruleIndex];
                let lexerActionExecutor = firstConfigWithRuleStopState.lexerActionExecutor;
                newState.acceptStateInfo = new $41NTU.AcceptStateInfo(prediction, lexerActionExecutor);
            }
            return this.atn.modeToDFA[this.mode].addState(newState);
        }
        getDFA(mode) {
            return this.atn.modeToDFA[mode];
        }
        getText(input) {
            return input.getText($gcfUE.Interval.of(this.startIndex, input.index - 1));
        }
        get line() {
            return this._line;
        }
        set line(line) {
            this._line = line;
        }
        get charPositionInLine() {
            return this._charPositionInLine;
        }
        set charPositionInLine(charPositionInLine) {
            this._charPositionInLine = charPositionInLine;
        }
        consume(input) {
            let curChar = input.LA(1);
            if (curChar === "\n".charCodeAt(0)) {
                this._line++;
                this._charPositionInLine = 0;
            } else this._charPositionInLine++;
            input.consume();
        }
        getTokenName(t) {
            if (t === -1) return "EOF";
            return "'" + String.fromCharCode(t) + "'";
        }
    };
    $fe6978bd928c111b$var$__decorate([
        $d6D31.NotNull
    ], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "prevAccept", void 0);
    $fe6978bd928c111b$var$__decorate([
        $fe6978bd928c111b$var$__param(0, $d6D31.NotNull)
    ], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "copyState", null);
    $fe6978bd928c111b$var$__decorate([
        $fe6978bd928c111b$var$__param(0, $d6D31.NotNull)
    ], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "match", null);
    $fe6978bd928c111b$var$__decorate([
        $d6D31.Override
    ], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "reset", null);
    $fe6978bd928c111b$var$__decorate([
        $fe6978bd928c111b$var$__param(0, $d6D31.NotNull)
    ], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "matchATN", null);
    $fe6978bd928c111b$var$__decorate([
        $fe6978bd928c111b$var$__param(0, $d6D31.NotNull),
        $fe6978bd928c111b$var$__param(1, $d6D31.NotNull)
    ], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "execATN", null);
    $fe6978bd928c111b$var$__decorate([
        $fe6978bd928c111b$var$__param(0, $d6D31.NotNull)
    ], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "getExistingTargetState", null);
    $fe6978bd928c111b$var$__decorate([
        $d6D31.NotNull,
        $fe6978bd928c111b$var$__param(0, $d6D31.NotNull),
        $fe6978bd928c111b$var$__param(1, $d6D31.NotNull)
    ], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "computeTargetState", null);
    $fe6978bd928c111b$var$__decorate([
        $fe6978bd928c111b$var$__param(0, $d6D31.NotNull),
        $fe6978bd928c111b$var$__param(1, $d6D31.NotNull),
        $fe6978bd928c111b$var$__param(2, $d6D31.NotNull)
    ], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "getReachableConfigSet", null);
    $fe6978bd928c111b$var$__decorate([
        $fe6978bd928c111b$var$__param(0, $d6D31.NotNull)
    ], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "accept", null);
    $fe6978bd928c111b$var$__decorate([
        $d6D31.NotNull,
        $fe6978bd928c111b$var$__param(0, $d6D31.NotNull),
        $fe6978bd928c111b$var$__param(1, $d6D31.NotNull)
    ], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "computeStartState", null);
    $fe6978bd928c111b$var$__decorate([
        $fe6978bd928c111b$var$__param(0, $d6D31.NotNull),
        $fe6978bd928c111b$var$__param(1, $d6D31.NotNull),
        $fe6978bd928c111b$var$__param(2, $d6D31.NotNull)
    ], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "closure", null);
    $fe6978bd928c111b$var$__decorate([
        $fe6978bd928c111b$var$__param(0, $d6D31.NotNull),
        $fe6978bd928c111b$var$__param(1, $d6D31.NotNull),
        $fe6978bd928c111b$var$__param(2, $d6D31.NotNull),
        $fe6978bd928c111b$var$__param(3, $d6D31.NotNull)
    ], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "getEpsilonTarget", null);
    $fe6978bd928c111b$var$__decorate([
        $fe6978bd928c111b$var$__param(0, $d6D31.NotNull)
    ], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "evaluatePredicate", null);
    $fe6978bd928c111b$var$__decorate([
        $fe6978bd928c111b$var$__param(0, $d6D31.NotNull),
        $fe6978bd928c111b$var$__param(1, $d6D31.NotNull),
        $fe6978bd928c111b$var$__param(2, $d6D31.NotNull)
    ], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "captureSimState", null);
    $fe6978bd928c111b$var$__decorate([
        $d6D31.NotNull,
        $fe6978bd928c111b$var$__param(0, $d6D31.NotNull)
    ], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "addDFAState", null);
    $fe6978bd928c111b$var$__decorate([
        $d6D31.NotNull
    ], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "getDFA", null);
    $fe6978bd928c111b$var$__decorate([
        $d6D31.NotNull,
        $fe6978bd928c111b$var$__param(0, $d6D31.NotNull)
    ], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "getText", null);
    $fe6978bd928c111b$var$__decorate([
        $fe6978bd928c111b$var$__param(0, $d6D31.NotNull)
    ], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "consume", null);
    $fe6978bd928c111b$var$__decorate([
        $d6D31.NotNull
    ], $fe6978bd928c111b$var$LexerATNSimulator.prototype, "getTokenName", null);
    $fe6978bd928c111b$var$LexerATNSimulator = $fe6978bd928c111b$var$__decorate([
        $fe6978bd928c111b$var$__param(0, $d6D31.NotNull)
    ], $fe6978bd928c111b$var$LexerATNSimulator);
    module.exports.LexerATNSimulator = $fe6978bd928c111b$var$LexerATNSimulator;
    (function(LexerATNSimulator) {
        LexerATNSimulator.debug = false;
        LexerATNSimulator.dfa_debug = false;
        class SimState {
            constructor(){
                this.index = -1;
                this.line = 0;
                this.charPos = -1;
            }
            reset() {
                this.index = -1;
                this.line = 0;
                this.charPos = -1;
                this.dfaState = undefined;
            }
        }
        LexerATNSimulator.SimState = SimState;
    })($fe6978bd928c111b$var$LexerATNSimulator = module.exports.LexerATNSimulator || (module.exports.LexerATNSimulator = {}));
    module.exports.LexerATNSimulator = $fe6978bd928c111b$var$LexerATNSimulator;
});
parcelRegister("41NTU", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.AcceptStateInfo = void 0;
    class $2eedf6a56837c02c$var$AcceptStateInfo {
        constructor(prediction, lexerActionExecutor){
            this._prediction = prediction;
            this._lexerActionExecutor = lexerActionExecutor;
        }
        get prediction() {
            return this._prediction;
        }
        get lexerActionExecutor() {
            return this._lexerActionExecutor;
        }
    }
    module.exports.AcceptStateInfo = $2eedf6a56837c02c$var$AcceptStateInfo;
});
parcelRegister("bcnvE", function(module, exports) {
    "use strict";
    var $82730d2c6766359c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $82730d2c6766359c$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ATN = void 0;
    var $fP17P = parcelRequire("fP17P");
    var $jJRyp = parcelRequire("jJRyp");
    var $hGRod = parcelRequire("hGRod");
    var $l4Nh1 = parcelRequire("l4Nh1");
    var $iiE1V = parcelRequire("iiE1V");
    var $d6D31 = parcelRequire("d6D31");
    var $a4Flx = parcelRequire("a4Flx");
    var $8DTT0 = parcelRequire("8DTT0");
    var $2DVsz = parcelRequire("2DVsz");
    var $bbHFU = parcelRequire("bbHFU");
    let $82730d2c6766359c$var$ATN = class ATN {
        constructor(grammarType, maxTokenType){
            this.states = [];
            this.decisionToState = [];
            this.modeNameToStartState = new Map();
            this.modeToStartState = [];
            this.contextCache = new $fP17P.Array2DHashMap($a4Flx.ObjectEqualityComparator.INSTANCE);
            this.decisionToDFA = [];
            this.modeToDFA = [];
            this.LL1Table = new Map();
            this.grammarType = grammarType;
            this.maxTokenType = maxTokenType;
        }
        clearDFA() {
            this.decisionToDFA = new Array(this.decisionToState.length);
            for(let i = 0; i < this.decisionToDFA.length; i++)this.decisionToDFA[i] = new $jJRyp.DFA(this.decisionToState[i], i);
            this.modeToDFA = new Array(this.modeToStartState.length);
            for(let i = 0; i < this.modeToDFA.length; i++)this.modeToDFA[i] = new $jJRyp.DFA(this.modeToStartState[i]);
            this.contextCache.clear();
            this.LL1Table.clear();
        }
        get contextCacheSize() {
            return this.contextCache.size;
        }
        getCachedContext(context) {
            return $8DTT0.PredictionContext.getCachedContext(context, this.contextCache, new $8DTT0.PredictionContext.IdentityHashMap());
        }
        getDecisionToDFA() {
            $bbHFU(this.decisionToDFA != null && this.decisionToDFA.length === this.decisionToState.length);
            return this.decisionToDFA;
        }
        nextTokens(s, ctx) {
            if (ctx) {
                let anal = new $iiE1V.LL1Analyzer(this);
                let next = anal.LOOK(s, ctx);
                return next;
            } else {
                if (s.nextTokenWithinRule) return s.nextTokenWithinRule;
                s.nextTokenWithinRule = this.nextTokens(s, $8DTT0.PredictionContext.EMPTY_LOCAL);
                s.nextTokenWithinRule.setReadonly(true);
                return s.nextTokenWithinRule;
            }
        }
        addState(state) {
            state.atn = this;
            state.stateNumber = this.states.length;
            this.states.push(state);
        }
        removeState(state) {
            let invalidState = new $l4Nh1.InvalidState();
            invalidState.atn = this;
            invalidState.stateNumber = state.stateNumber;
            this.states[state.stateNumber] = invalidState;
        }
        defineMode(name, s) {
            this.modeNameToStartState.set(name, s);
            this.modeToStartState.push(s);
            this.modeToDFA.push(new $jJRyp.DFA(s));
            this.defineDecisionState(s);
        }
        defineDecisionState(s) {
            this.decisionToState.push(s);
            s.decision = this.decisionToState.length - 1;
            this.decisionToDFA.push(new $jJRyp.DFA(s, s.decision));
            return s.decision;
        }
        getDecisionState(decision) {
            if (this.decisionToState.length > 0) return this.decisionToState[decision];
            return undefined;
        }
        get numberOfDecisions() {
            return this.decisionToState.length;
        }
        getExpectedTokens(stateNumber, context) {
            if (stateNumber < 0 || stateNumber >= this.states.length) throw new RangeError("Invalid state number.");
            let ctx = context;
            let s = this.states[stateNumber];
            let following = this.nextTokens(s);
            if (!following.contains($2DVsz.Token.EPSILON)) return following;
            let expected = new $hGRod.IntervalSet();
            expected.addAll(following);
            expected.remove($2DVsz.Token.EPSILON);
            while(ctx != null && ctx.invokingState >= 0 && following.contains($2DVsz.Token.EPSILON)){
                let invokingState = this.states[ctx.invokingState];
                let rt = invokingState.transition(0);
                following = this.nextTokens(rt.followState);
                expected.addAll(following);
                expected.remove($2DVsz.Token.EPSILON);
                ctx = ctx._parent;
            }
            if (following.contains($2DVsz.Token.EPSILON)) expected.add($2DVsz.Token.EOF);
            return expected;
        }
    };
    $82730d2c6766359c$var$__decorate([
        $d6D31.NotNull
    ], $82730d2c6766359c$var$ATN.prototype, "states", void 0);
    $82730d2c6766359c$var$__decorate([
        $d6D31.NotNull
    ], $82730d2c6766359c$var$ATN.prototype, "decisionToState", void 0);
    $82730d2c6766359c$var$__decorate([
        $d6D31.NotNull
    ], $82730d2c6766359c$var$ATN.prototype, "modeNameToStartState", void 0);
    $82730d2c6766359c$var$__decorate([
        $d6D31.NotNull
    ], $82730d2c6766359c$var$ATN.prototype, "modeToStartState", void 0);
    $82730d2c6766359c$var$__decorate([
        $d6D31.NotNull
    ], $82730d2c6766359c$var$ATN.prototype, "decisionToDFA", void 0);
    $82730d2c6766359c$var$__decorate([
        $d6D31.NotNull
    ], $82730d2c6766359c$var$ATN.prototype, "modeToDFA", void 0);
    $82730d2c6766359c$var$__decorate([
        $d6D31.NotNull
    ], $82730d2c6766359c$var$ATN.prototype, "nextTokens", null);
    $82730d2c6766359c$var$__decorate([
        $82730d2c6766359c$var$__param(0, $d6D31.NotNull)
    ], $82730d2c6766359c$var$ATN.prototype, "removeState", null);
    $82730d2c6766359c$var$__decorate([
        $82730d2c6766359c$var$__param(0, $d6D31.NotNull),
        $82730d2c6766359c$var$__param(1, $d6D31.NotNull)
    ], $82730d2c6766359c$var$ATN.prototype, "defineMode", null);
    $82730d2c6766359c$var$__decorate([
        $82730d2c6766359c$var$__param(0, $d6D31.NotNull)
    ], $82730d2c6766359c$var$ATN.prototype, "defineDecisionState", null);
    $82730d2c6766359c$var$__decorate([
        $d6D31.NotNull
    ], $82730d2c6766359c$var$ATN.prototype, "getExpectedTokens", null);
    $82730d2c6766359c$var$ATN = $82730d2c6766359c$var$__decorate([
        $82730d2c6766359c$var$__param(0, $d6D31.NotNull)
    ], $82730d2c6766359c$var$ATN);
    module.exports.ATN = $82730d2c6766359c$var$ATN;
    (function(ATN) {
        ATN.INVALID_ALT_NUMBER = 0;
    })($82730d2c6766359c$var$ATN = module.exports.ATN || (module.exports.ATN = {}));
    module.exports.ATN = $82730d2c6766359c$var$ATN;
});
parcelRegister("fP17P", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.Array2DHashMap = void 0;
    var $7Veax = parcelRequire("7Veax");
    class $b84c7de35a10478c$var$MapKeyEqualityComparator {
        constructor(keyComparator){
            this.keyComparator = keyComparator;
        }
        hashCode(obj) {
            return this.keyComparator.hashCode(obj.key);
        }
        equals(a, b) {
            return this.keyComparator.equals(a.key, b.key);
        }
    }
    class $b84c7de35a10478c$var$Array2DHashMap {
        constructor(keyComparer){
            if (keyComparer instanceof $b84c7de35a10478c$var$Array2DHashMap) this.backingStore = new $7Veax.Array2DHashSet(keyComparer.backingStore);
            else this.backingStore = new $7Veax.Array2DHashSet(new $b84c7de35a10478c$var$MapKeyEqualityComparator(keyComparer));
        }
        clear() {
            this.backingStore.clear();
        }
        containsKey(key) {
            return this.backingStore.contains({
                key: key
            });
        }
        get(key) {
            let bucket = this.backingStore.get({
                key: key
            });
            if (!bucket) return undefined;
            return bucket.value;
        }
        get isEmpty() {
            return this.backingStore.isEmpty;
        }
        put(key, value) {
            let element = this.backingStore.get({
                key: key,
                value: value
            });
            let result;
            if (!element) this.backingStore.add({
                key: key,
                value: value
            });
            else {
                result = element.value;
                element.value = value;
            }
            return result;
        }
        putIfAbsent(key, value) {
            let element = this.backingStore.get({
                key: key,
                value: value
            });
            let result;
            if (!element) this.backingStore.add({
                key: key,
                value: value
            });
            else result = element.value;
            return result;
        }
        get size() {
            return this.backingStore.size;
        }
        hashCode() {
            return this.backingStore.hashCode();
        }
        equals(o) {
            if (!(o instanceof $b84c7de35a10478c$var$Array2DHashMap)) return false;
            return this.backingStore.equals(o.backingStore);
        }
    }
    module.exports.Array2DHashMap = $b84c7de35a10478c$var$Array2DHashMap;
});
parcelRegister("jJRyp", function(module, exports) {
    "use strict";
    var $e5ebc30517b3d229$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $e5ebc30517b3d229$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.DFA = void 0;
    var $7Veax = parcelRequire("7Veax");
    var $c1ClW = parcelRequire("c1ClW");
    var $yhTtv = parcelRequire("yhTtv");
    var $2jevZ = parcelRequire("2jevZ");
    var $aeRGo = parcelRequire("aeRGo");
    var $d6D31 = parcelRequire("d6D31");
    var $a4Flx = parcelRequire("a4Flx");
    var $f9raX = parcelRequire("f9raX");
    var $3n2FE = parcelRequire("3n2FE");
    let $e5ebc30517b3d229$var$DFA = class DFA {
        constructor(atnStartState, decision = 0){
            this.states = new $7Veax.Array2DHashSet($a4Flx.ObjectEqualityComparator.INSTANCE);
            this.nextStateNumber = 0;
            if (!atnStartState.atn) throw new Error("The ATNState must be associated with an ATN");
            this.atnStartState = atnStartState;
            this.atn = atnStartState.atn;
            this.decision = decision;
            let isPrecedenceDfa = false;
            if (atnStartState instanceof $f9raX.StarLoopEntryState) {
                if (atnStartState.precedenceRuleDecision) {
                    isPrecedenceDfa = true;
                    this.s0 = new $2jevZ.DFAState(new $c1ClW.ATNConfigSet());
                    this.s0full = new $2jevZ.DFAState(new $c1ClW.ATNConfigSet());
                }
            }
            this.precedenceDfa = isPrecedenceDfa;
        }
        get isPrecedenceDfa() {
            return this.precedenceDfa;
        }
        getPrecedenceStartState(precedence, fullContext) {
            if (!this.isPrecedenceDfa) throw new Error("Only precedence DFAs may contain a precedence start state.");
            if (fullContext) return this.s0full.getTarget(precedence);
            else return this.s0.getTarget(precedence);
        }
        setPrecedenceStartState(precedence, fullContext, startState) {
            if (!this.isPrecedenceDfa) throw new Error("Only precedence DFAs may contain a precedence start state.");
            if (precedence < 0) return;
            if (fullContext) this.s0full.setTarget(precedence, startState);
            else this.s0.setTarget(precedence, startState);
        }
        get isEmpty() {
            if (this.isPrecedenceDfa) return this.s0.getEdgeMap().size === 0 && this.s0full.getEdgeMap().size === 0;
            return this.s0 == null && this.s0full == null;
        }
        get isContextSensitive() {
            if (this.isPrecedenceDfa) return this.s0full.getEdgeMap().size > 0;
            return this.s0full != null;
        }
        addState(state) {
            state.stateNumber = this.nextStateNumber++;
            return this.states.getOrAdd(state);
        }
        toString(vocabulary, ruleNames) {
            if (!vocabulary) vocabulary = $3n2FE.VocabularyImpl.EMPTY_VOCABULARY;
            if (!this.s0) return "";
            let serializer;
            if (ruleNames) serializer = new $yhTtv.DFASerializer(this, vocabulary, ruleNames, this.atnStartState.atn);
            else serializer = new $yhTtv.DFASerializer(this, vocabulary);
            return serializer.toString();
        }
        toLexerString() {
            if (!this.s0) return "";
            let serializer = new $aeRGo.LexerDFASerializer(this);
            return serializer.toString();
        }
    };
    $e5ebc30517b3d229$var$__decorate([
        $d6D31.NotNull
    ], $e5ebc30517b3d229$var$DFA.prototype, "states", void 0);
    $e5ebc30517b3d229$var$__decorate([
        $d6D31.NotNull
    ], $e5ebc30517b3d229$var$DFA.prototype, "atnStartState", void 0);
    $e5ebc30517b3d229$var$__decorate([
        $d6D31.NotNull
    ], $e5ebc30517b3d229$var$DFA.prototype, "atn", void 0);
    $e5ebc30517b3d229$var$DFA = $e5ebc30517b3d229$var$__decorate([
        $e5ebc30517b3d229$var$__param(0, $d6D31.NotNull)
    ], $e5ebc30517b3d229$var$DFA);
    module.exports.DFA = $e5ebc30517b3d229$var$DFA;
});
parcelRegister("c1ClW", function(module, exports) {
    "use strict";
    var $8c13542112ebfd78$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ATNConfigSet = void 0;
    var $fP17P = parcelRequire("fP17P");
    var $7Veax = parcelRequire("7Veax");
    var $3sNxf = parcelRequire("3sNxf");
    var $bcnvE = parcelRequire("bcnvE");
    var $gcX0f = parcelRequire("gcX0f");
    var $5BPMp = parcelRequire("5BPMp");
    var $d6D31 = parcelRequire("d6D31");
    var $a4Flx = parcelRequire("a4Flx");
    var $8DTT0 = parcelRequire("8DTT0");
    var $6vF7J = parcelRequire("6vF7J");
    var $eHMgW = parcelRequire("eHMgW");
    var $bbHFU = parcelRequire("bbHFU");
    var $2IEP9 = parcelRequire("2IEP9");
    class $8c13542112ebfd78$var$KeyTypeEqualityComparer {
        hashCode(key) {
            return key.state ^ key.alt;
        }
        equals(a, b) {
            return a.state === b.state && a.alt === b.alt;
        }
    }
    $8c13542112ebfd78$var$KeyTypeEqualityComparer.INSTANCE = new $8c13542112ebfd78$var$KeyTypeEqualityComparer();
    function $8c13542112ebfd78$var$NewKeyedConfigMap(map) {
        if (map) return new $fP17P.Array2DHashMap(map);
        else return new $fP17P.Array2DHashMap($8c13542112ebfd78$var$KeyTypeEqualityComparer.INSTANCE);
    }
    class $8c13542112ebfd78$var$ATNConfigSet {
        constructor(set, readonly){
            this._uniqueAlt = 0;
            this._hasSemanticContext = false;
            this._dipsIntoOuterContext = false;
            this.outermostConfigSet = false;
            this.cachedHashCode = -1;
            if (!set) {
                this.mergedConfigs = $8c13542112ebfd78$var$NewKeyedConfigMap();
                this.unmerged = [];
                this.configs = [];
                this._uniqueAlt = $bcnvE.ATN.INVALID_ALT_NUMBER;
            } else {
                if (readonly) {
                    this.mergedConfigs = undefined;
                    this.unmerged = undefined;
                } else if (!set.isReadOnly) {
                    this.mergedConfigs = $8c13542112ebfd78$var$NewKeyedConfigMap(set.mergedConfigs);
                    this.unmerged = set.unmerged.slice(0);
                } else {
                    this.mergedConfigs = $8c13542112ebfd78$var$NewKeyedConfigMap();
                    this.unmerged = [];
                }
                this.configs = set.configs.slice(0);
                this._dipsIntoOuterContext = set._dipsIntoOuterContext;
                this._hasSemanticContext = set._hasSemanticContext;
                this.outermostConfigSet = set.outermostConfigSet;
                if (readonly || !set.isReadOnly) {
                    this._uniqueAlt = set._uniqueAlt;
                    this._conflictInfo = set._conflictInfo;
                }
            }
        }
        getRepresentedAlternatives() {
            if (this._conflictInfo != null) return this._conflictInfo.conflictedAlts.clone();
            let alts = new $5BPMp.BitSet();
            for (let config of this)alts.set(config.alt);
            return alts;
        }
        get isReadOnly() {
            return this.mergedConfigs == null;
        }
        get isOutermostConfigSet() {
            return this.outermostConfigSet;
        }
        set isOutermostConfigSet(outermostConfigSet) {
            if (this.outermostConfigSet && !outermostConfigSet) throw new Error("IllegalStateException");
            $bbHFU(!outermostConfigSet || !this._dipsIntoOuterContext);
            this.outermostConfigSet = outermostConfigSet;
        }
        getStates() {
            let states = new $7Veax.Array2DHashSet($a4Flx.ObjectEqualityComparator.INSTANCE);
            for (let c of this.configs)states.add(c.state);
            return states;
        }
        optimizeConfigs(interpreter) {
            if (this.configs.length === 0) return;
            for (let config of this.configs)config.context = interpreter.atn.getCachedContext(config.context);
        }
        clone(readonly) {
            let copy = new $8c13542112ebfd78$var$ATNConfigSet(this, readonly);
            if (!readonly && this.isReadOnly) copy.addAll(this.configs);
            return copy;
        }
        get size() {
            return this.configs.length;
        }
        get isEmpty() {
            return this.configs.length === 0;
        }
        contains(o) {
            if (!(o instanceof $gcX0f.ATNConfig)) return false;
            if (this.mergedConfigs && this.unmerged) {
                let config = o;
                let configKey = this.getKey(config);
                let mergedConfig = this.mergedConfigs.get(configKey);
                if (mergedConfig != null && this.canMerge(config, configKey, mergedConfig)) return mergedConfig.contains(config);
                for (let c of this.unmerged){
                    if (c.contains(o)) return true;
                }
            } else for (let c of this.configs){
                if (c.contains(o)) return true;
            }
            return false;
        }
        *[Symbol.iterator]() {
            yield* this.configs;
        }
        toArray() {
            return this.configs;
        }
        add(e, contextCache) {
            this.ensureWritable();
            if (!this.mergedConfigs || !this.unmerged) throw new Error("Covered by ensureWritable but duplicated here for strict null check limitation");
            $bbHFU(!this.outermostConfigSet || !e.reachesIntoOuterContext);
            if (contextCache == null) contextCache = $6vF7J.PredictionContextCache.UNCACHED;
            let addKey;
            let key = this.getKey(e);
            let mergedConfig = this.mergedConfigs.get(key);
            addKey = mergedConfig == null;
            if (mergedConfig != null && this.canMerge(e, key, mergedConfig)) {
                mergedConfig.outerContextDepth = Math.max(mergedConfig.outerContextDepth, e.outerContextDepth);
                if (e.isPrecedenceFilterSuppressed) mergedConfig.isPrecedenceFilterSuppressed = true;
                let joined = $8DTT0.PredictionContext.join(mergedConfig.context, e.context, contextCache);
                this.updatePropertiesForMergedConfig(e);
                if (mergedConfig.context === joined) return false;
                mergedConfig.context = joined;
                return true;
            }
            for(let i = 0; i < this.unmerged.length; i++){
                let unmergedConfig = this.unmerged[i];
                if (this.canMerge(e, key, unmergedConfig)) {
                    unmergedConfig.outerContextDepth = Math.max(unmergedConfig.outerContextDepth, e.outerContextDepth);
                    if (e.isPrecedenceFilterSuppressed) unmergedConfig.isPrecedenceFilterSuppressed = true;
                    let joined = $8DTT0.PredictionContext.join(unmergedConfig.context, e.context, contextCache);
                    this.updatePropertiesForMergedConfig(e);
                    if (unmergedConfig.context === joined) return false;
                    unmergedConfig.context = joined;
                    if (addKey) {
                        this.mergedConfigs.put(key, unmergedConfig);
                        this.unmerged.splice(i, 1);
                    }
                    return true;
                }
            }
            this.configs.push(e);
            if (addKey) this.mergedConfigs.put(key, e);
            else this.unmerged.push(e);
            this.updatePropertiesForAddedConfig(e);
            return true;
        }
        updatePropertiesForMergedConfig(config) {
            this._dipsIntoOuterContext = this._dipsIntoOuterContext || config.reachesIntoOuterContext;
            $bbHFU(!this.outermostConfigSet || !this._dipsIntoOuterContext);
        }
        updatePropertiesForAddedConfig(config) {
            if (this.configs.length === 1) this._uniqueAlt = config.alt;
            else if (this._uniqueAlt !== config.alt) this._uniqueAlt = $bcnvE.ATN.INVALID_ALT_NUMBER;
            this._hasSemanticContext = this._hasSemanticContext || !$eHMgW.SemanticContext.NONE.equals(config.semanticContext);
            this._dipsIntoOuterContext = this._dipsIntoOuterContext || config.reachesIntoOuterContext;
            $bbHFU(!this.outermostConfigSet || !this._dipsIntoOuterContext);
        }
        canMerge(left, leftKey, right) {
            if (left.state.stateNumber !== right.state.stateNumber) return false;
            if (leftKey.alt !== right.alt) return false;
            return left.semanticContext.equals(right.semanticContext);
        }
        getKey(e) {
            return {
                state: e.state.stateNumber,
                alt: e.alt
            };
        }
        containsAll(c) {
            for (let o of c){
                if (!(o instanceof $gcX0f.ATNConfig)) return false;
                if (!this.contains(o)) return false;
            }
            return true;
        }
        addAll(c, contextCache) {
            this.ensureWritable();
            let changed = false;
            for (let group of c)if (this.add(group, contextCache)) changed = true;
            return changed;
        }
        clear() {
            this.ensureWritable();
            if (!this.mergedConfigs || !this.unmerged) throw new Error("Covered by ensureWritable but duplicated here for strict null check limitation");
            this.mergedConfigs.clear();
            this.unmerged.length = 0;
            this.configs.length = 0;
            this._dipsIntoOuterContext = false;
            this._hasSemanticContext = false;
            this._uniqueAlt = $bcnvE.ATN.INVALID_ALT_NUMBER;
            this._conflictInfo = undefined;
        }
        equals(obj) {
            if (this === obj) return true;
            if (!(obj instanceof $8c13542112ebfd78$var$ATNConfigSet)) return false;
            return this.outermostConfigSet === obj.outermostConfigSet && $2IEP9.equals(this._conflictInfo, obj._conflictInfo) && $3sNxf.ArrayEqualityComparator.INSTANCE.equals(this.configs, obj.configs);
        }
        hashCode() {
            if (this.isReadOnly && this.cachedHashCode !== -1) return this.cachedHashCode;
            let hashCode = 1;
            hashCode = 5 * hashCode ^ (this.outermostConfigSet ? 1 : 0);
            hashCode = 5 * hashCode ^ $3sNxf.ArrayEqualityComparator.INSTANCE.hashCode(this.configs);
            if (this.isReadOnly) this.cachedHashCode = hashCode;
            return hashCode;
        }
        toString(showContext) {
            if (showContext == null) showContext = false;
            let buf = "";
            let sortedConfigs = this.configs.slice(0);
            sortedConfigs.sort((o1, o2)=>{
                if (o1.alt !== o2.alt) return o1.alt - o2.alt;
                else if (o1.state.stateNumber !== o2.state.stateNumber) return o1.state.stateNumber - o2.state.stateNumber;
                else return o1.semanticContext.toString().localeCompare(o2.semanticContext.toString());
            });
            buf += "[";
            for(let i = 0; i < sortedConfigs.length; i++){
                if (i > 0) buf += ", ";
                buf += sortedConfigs[i].toString(undefined, true, showContext);
            }
            buf += "]";
            if (this._hasSemanticContext) buf += ",hasSemanticContext=" + this._hasSemanticContext;
            if (this._uniqueAlt !== $bcnvE.ATN.INVALID_ALT_NUMBER) buf += ",uniqueAlt=" + this._uniqueAlt;
            if (this._conflictInfo != null) {
                buf += ",conflictingAlts=" + this._conflictInfo.conflictedAlts;
                if (!this._conflictInfo.isExact) buf += "*";
            }
            if (this._dipsIntoOuterContext) buf += ",dipsIntoOuterContext";
            return buf.toString();
        }
        get uniqueAlt() {
            return this._uniqueAlt;
        }
        get hasSemanticContext() {
            return this._hasSemanticContext;
        }
        set hasSemanticContext(value) {
            this.ensureWritable();
            this._hasSemanticContext = value;
        }
        get conflictInfo() {
            return this._conflictInfo;
        }
        set conflictInfo(conflictInfo) {
            this.ensureWritable();
            this._conflictInfo = conflictInfo;
        }
        get conflictingAlts() {
            if (this._conflictInfo == null) return undefined;
            return this._conflictInfo.conflictedAlts;
        }
        get isExactConflict() {
            if (this._conflictInfo == null) return false;
            return this._conflictInfo.isExact;
        }
        get dipsIntoOuterContext() {
            return this._dipsIntoOuterContext;
        }
        get(index) {
            return this.configs[index];
        }
        ensureWritable() {
            if (this.isReadOnly) throw new Error("This ATNConfigSet is read only.");
        }
    }
    $8c13542112ebfd78$var$__decorate([
        $d6D31.NotNull
    ], $8c13542112ebfd78$var$ATNConfigSet.prototype, "getRepresentedAlternatives", null);
    $8c13542112ebfd78$var$__decorate([
        $d6D31.Override
    ], $8c13542112ebfd78$var$ATNConfigSet.prototype, "size", null);
    $8c13542112ebfd78$var$__decorate([
        $d6D31.Override
    ], $8c13542112ebfd78$var$ATNConfigSet.prototype, "isEmpty", null);
    $8c13542112ebfd78$var$__decorate([
        $d6D31.Override
    ], $8c13542112ebfd78$var$ATNConfigSet.prototype, "contains", null);
    $8c13542112ebfd78$var$__decorate([
        $d6D31.Override
    ], $8c13542112ebfd78$var$ATNConfigSet.prototype, Symbol.iterator, null);
    $8c13542112ebfd78$var$__decorate([
        $d6D31.Override
    ], $8c13542112ebfd78$var$ATNConfigSet.prototype, "toArray", null);
    $8c13542112ebfd78$var$__decorate([
        $d6D31.Override
    ], $8c13542112ebfd78$var$ATNConfigSet.prototype, "containsAll", null);
    $8c13542112ebfd78$var$__decorate([
        $d6D31.Override
    ], $8c13542112ebfd78$var$ATNConfigSet.prototype, "clear", null);
    $8c13542112ebfd78$var$__decorate([
        $d6D31.Override
    ], $8c13542112ebfd78$var$ATNConfigSet.prototype, "equals", null);
    $8c13542112ebfd78$var$__decorate([
        $d6D31.Override
    ], $8c13542112ebfd78$var$ATNConfigSet.prototype, "hashCode", null);
    module.exports.ATNConfigSet = $8c13542112ebfd78$var$ATNConfigSet;
});
parcelRegister("gcX0f", function(module, exports) {
    "use strict";
    var $bccb89124e8dfda2$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $bccb89124e8dfda2$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ATNConfig = void 0;
    var $fP17P = parcelRequire("fP17P");
    var $dPYn6 = parcelRequire("dPYn6");
    var $iXFjm = parcelRequire("iXFjm");
    var $d6D31 = parcelRequire("d6D31");
    var $a4Flx = parcelRequire("a4Flx");
    var $8DTT0 = parcelRequire("8DTT0");
    var $eHMgW = parcelRequire("eHMgW");
    var $bbHFU = parcelRequire("bbHFU");
    const $bccb89124e8dfda2$var$SUPPRESS_PRECEDENCE_FILTER = 0x80000000;
    let $bccb89124e8dfda2$var$ATNConfig = class ATNConfig {
        constructor(state, altOrConfig, context){
            if (typeof altOrConfig === "number") {
                $bbHFU((altOrConfig & 0xFFFFFF) === altOrConfig);
                this._state = state;
                this.altAndOuterContextDepth = altOrConfig;
                this._context = context;
            } else {
                this._state = state;
                this.altAndOuterContextDepth = altOrConfig.altAndOuterContextDepth;
                this._context = context;
            }
        }
        static create(state, alt, context, semanticContext = $eHMgW.SemanticContext.NONE, lexerActionExecutor) {
            if (semanticContext !== $eHMgW.SemanticContext.NONE) {
                if (lexerActionExecutor != null) return new $bccb89124e8dfda2$var$ActionSemanticContextATNConfig(lexerActionExecutor, semanticContext, state, alt, context, false);
                else return new $bccb89124e8dfda2$var$SemanticContextATNConfig(semanticContext, state, alt, context);
            } else if (lexerActionExecutor != null) return new $bccb89124e8dfda2$var$ActionATNConfig(lexerActionExecutor, state, alt, context, false);
            else return new ATNConfig(state, alt, context);
        }
        get state() {
            return this._state;
        }
        get alt() {
            return this.altAndOuterContextDepth & 0x00FFFFFF;
        }
        get context() {
            return this._context;
        }
        set context(context) {
            this._context = context;
        }
        get reachesIntoOuterContext() {
            return this.outerContextDepth !== 0;
        }
        get outerContextDepth() {
            return this.altAndOuterContextDepth >>> 24 & 0x7F;
        }
        set outerContextDepth(outerContextDepth) {
            $bbHFU(outerContextDepth >= 0);
            outerContextDepth = Math.min(outerContextDepth, 0x7F);
            this.altAndOuterContextDepth = outerContextDepth << 24 | (this.altAndOuterContextDepth & -2130706433) >>> 0;
        }
        get lexerActionExecutor() {
            return undefined;
        }
        get semanticContext() {
            return $eHMgW.SemanticContext.NONE;
        }
        get hasPassedThroughNonGreedyDecision() {
            return false;
        }
        clone() {
            return this.transform(this.state, false);
        }
        transform(state, checkNonGreedy, arg2) {
            if (arg2 == null) return this.transformImpl(state, this._context, this.semanticContext, checkNonGreedy, this.lexerActionExecutor);
            else if (arg2 instanceof $8DTT0.PredictionContext) return this.transformImpl(state, arg2, this.semanticContext, checkNonGreedy, this.lexerActionExecutor);
            else if (arg2 instanceof $eHMgW.SemanticContext) return this.transformImpl(state, this._context, arg2, checkNonGreedy, this.lexerActionExecutor);
            else return this.transformImpl(state, this._context, this.semanticContext, checkNonGreedy, arg2);
        }
        transformImpl(state, context, semanticContext, checkNonGreedy, lexerActionExecutor) {
            let passedThroughNonGreedy = checkNonGreedy && ATNConfig.checkNonGreedyDecision(this, state);
            if (semanticContext !== $eHMgW.SemanticContext.NONE) {
                if (lexerActionExecutor != null || passedThroughNonGreedy) return new $bccb89124e8dfda2$var$ActionSemanticContextATNConfig(lexerActionExecutor, semanticContext, state, this, context, passedThroughNonGreedy);
                else return new $bccb89124e8dfda2$var$SemanticContextATNConfig(semanticContext, state, this, context);
            } else if (lexerActionExecutor != null || passedThroughNonGreedy) return new $bccb89124e8dfda2$var$ActionATNConfig(lexerActionExecutor, state, this, context, passedThroughNonGreedy);
            else return new ATNConfig(state, this, context);
        }
        static checkNonGreedyDecision(source, target) {
            return source.hasPassedThroughNonGreedyDecision || target instanceof $dPYn6.DecisionState && target.nonGreedy;
        }
        appendContext(context, contextCache) {
            if (typeof context === "number") {
                let appendedContext = this.context.appendSingleContext(context, contextCache);
                let result = this.transform(this.state, false, appendedContext);
                return result;
            } else {
                let appendedContext = this.context.appendContext(context, contextCache);
                let result = this.transform(this.state, false, appendedContext);
                return result;
            }
        }
        contains(subconfig) {
            if (this.state.stateNumber !== subconfig.state.stateNumber || this.alt !== subconfig.alt || !this.semanticContext.equals(subconfig.semanticContext)) return false;
            let leftWorkList = [];
            let rightWorkList = [];
            leftWorkList.push(this.context);
            rightWorkList.push(subconfig.context);
            while(true){
                let left = leftWorkList.pop();
                let right = rightWorkList.pop();
                if (!left || !right) break;
                if (left === right) return true;
                if (left.size < right.size) return false;
                if (right.isEmpty) return left.hasEmpty;
                else for(let i = 0; i < right.size; i++){
                    let index = left.findReturnState(right.getReturnState(i));
                    if (index < 0) return false;
                    leftWorkList.push(left.getParent(index));
                    rightWorkList.push(right.getParent(i));
                }
            }
            return false;
        }
        get isPrecedenceFilterSuppressed() {
            return (this.altAndOuterContextDepth & $bccb89124e8dfda2$var$SUPPRESS_PRECEDENCE_FILTER) !== 0;
        }
        set isPrecedenceFilterSuppressed(value) {
            if (value) this.altAndOuterContextDepth |= $bccb89124e8dfda2$var$SUPPRESS_PRECEDENCE_FILTER;
            else this.altAndOuterContextDepth &= ~$bccb89124e8dfda2$var$SUPPRESS_PRECEDENCE_FILTER;
        }
        equals(o) {
            if (this === o) return true;
            else if (!(o instanceof ATNConfig)) return false;
            return this.state.stateNumber === o.state.stateNumber && this.alt === o.alt && this.reachesIntoOuterContext === o.reachesIntoOuterContext && this.context.equals(o.context) && this.semanticContext.equals(o.semanticContext) && this.isPrecedenceFilterSuppressed === o.isPrecedenceFilterSuppressed && this.hasPassedThroughNonGreedyDecision === o.hasPassedThroughNonGreedyDecision && $a4Flx.ObjectEqualityComparator.INSTANCE.equals(this.lexerActionExecutor, o.lexerActionExecutor);
        }
        hashCode() {
            let hashCode = $iXFjm.MurmurHash.initialize(7);
            hashCode = $iXFjm.MurmurHash.update(hashCode, this.state.stateNumber);
            hashCode = $iXFjm.MurmurHash.update(hashCode, this.alt);
            hashCode = $iXFjm.MurmurHash.update(hashCode, this.reachesIntoOuterContext ? 1 : 0);
            hashCode = $iXFjm.MurmurHash.update(hashCode, this.context);
            hashCode = $iXFjm.MurmurHash.update(hashCode, this.semanticContext);
            hashCode = $iXFjm.MurmurHash.update(hashCode, this.hasPassedThroughNonGreedyDecision ? 1 : 0);
            hashCode = $iXFjm.MurmurHash.update(hashCode, this.lexerActionExecutor);
            hashCode = $iXFjm.MurmurHash.finish(hashCode, 7);
            return hashCode;
        }
        toDotString() {
            let builder = "";
            builder += "digraph G {\n";
            builder += "rankdir=LR;\n";
            let visited = new $fP17P.Array2DHashMap($8DTT0.PredictionContext.IdentityEqualityComparator.INSTANCE);
            let workList = [];
            function getOrAddContext(context) {
                let newNumber = visited.size;
                let result = visited.putIfAbsent(context, newNumber);
                if (result != null) return result;
                workList.push(context);
                return newNumber;
            }
            workList.push(this.context);
            visited.put(this.context, 0);
            while(true){
                let current = workList.pop();
                if (!current) break;
                for(let i = 0; i < current.size; i++){
                    builder += "  s" + getOrAddContext(current);
                    builder += "->";
                    builder += "s" + getOrAddContext(current.getParent(i));
                    builder += "[label=\"" + current.getReturnState(i) + "\"];\n";
                }
            }
            builder += "}\n";
            return builder.toString();
        }
        toString(recog, showAlt, showContext) {
            if (showContext == null) showContext = showAlt != null;
            if (showAlt == null) showAlt = true;
            let buf = "";
            let contexts;
            if (showContext) contexts = this.context.toStrings(recog, this.state.stateNumber);
            else contexts = [
                "?"
            ];
            let first = true;
            for (let contextDesc of contexts){
                if (first) first = false;
                else buf += ", ";
                buf += "(";
                buf += this.state;
                if (showAlt) {
                    buf += ",";
                    buf += this.alt;
                }
                if (this.context) {
                    buf += ",";
                    buf += contextDesc;
                }
                if (this.semanticContext !== $eHMgW.SemanticContext.NONE) {
                    buf += ",";
                    buf += this.semanticContext;
                }
                if (this.reachesIntoOuterContext) buf += ",up=" + this.outerContextDepth;
                buf += ")";
            }
            return buf.toString();
        }
    };
    $bccb89124e8dfda2$var$__decorate([
        $d6D31.NotNull
    ], $bccb89124e8dfda2$var$ATNConfig.prototype, "_state", void 0);
    $bccb89124e8dfda2$var$__decorate([
        $d6D31.NotNull
    ], $bccb89124e8dfda2$var$ATNConfig.prototype, "_context", void 0);
    $bccb89124e8dfda2$var$__decorate([
        $d6D31.NotNull
    ], $bccb89124e8dfda2$var$ATNConfig.prototype, "state", null);
    $bccb89124e8dfda2$var$__decorate([
        $d6D31.NotNull,
        $bccb89124e8dfda2$var$__param(0, $d6D31.NotNull)
    ], $bccb89124e8dfda2$var$ATNConfig.prototype, "context", null);
    $bccb89124e8dfda2$var$__decorate([
        $d6D31.NotNull
    ], $bccb89124e8dfda2$var$ATNConfig.prototype, "semanticContext", null);
    $bccb89124e8dfda2$var$__decorate([
        $d6D31.Override
    ], $bccb89124e8dfda2$var$ATNConfig.prototype, "clone", null);
    $bccb89124e8dfda2$var$__decorate([
        $bccb89124e8dfda2$var$__param(0, $d6D31.NotNull),
        $bccb89124e8dfda2$var$__param(2, $d6D31.NotNull)
    ], $bccb89124e8dfda2$var$ATNConfig.prototype, "transformImpl", null);
    $bccb89124e8dfda2$var$__decorate([
        $d6D31.Override
    ], $bccb89124e8dfda2$var$ATNConfig.prototype, "equals", null);
    $bccb89124e8dfda2$var$__decorate([
        $d6D31.Override
    ], $bccb89124e8dfda2$var$ATNConfig.prototype, "hashCode", null);
    $bccb89124e8dfda2$var$__decorate([
        $bccb89124e8dfda2$var$__param(0, $d6D31.NotNull),
        $bccb89124e8dfda2$var$__param(3, $d6D31.NotNull)
    ], $bccb89124e8dfda2$var$ATNConfig, "create", null);
    $bccb89124e8dfda2$var$ATNConfig = $bccb89124e8dfda2$var$__decorate([
        $bccb89124e8dfda2$var$__param(0, $d6D31.NotNull),
        $bccb89124e8dfda2$var$__param(2, $d6D31.NotNull)
    ], $bccb89124e8dfda2$var$ATNConfig);
    module.exports.ATNConfig = $bccb89124e8dfda2$var$ATNConfig;
    let $bccb89124e8dfda2$var$SemanticContextATNConfig = class SemanticContextATNConfig extends $bccb89124e8dfda2$var$ATNConfig {
        constructor(semanticContext, state, altOrConfig, context){
            if (typeof altOrConfig === "number") super(state, altOrConfig, context);
            else super(state, altOrConfig, context);
            this._semanticContext = semanticContext;
        }
        get semanticContext() {
            return this._semanticContext;
        }
    };
    $bccb89124e8dfda2$var$__decorate([
        $d6D31.NotNull
    ], $bccb89124e8dfda2$var$SemanticContextATNConfig.prototype, "_semanticContext", void 0);
    $bccb89124e8dfda2$var$__decorate([
        $d6D31.Override
    ], $bccb89124e8dfda2$var$SemanticContextATNConfig.prototype, "semanticContext", null);
    $bccb89124e8dfda2$var$SemanticContextATNConfig = $bccb89124e8dfda2$var$__decorate([
        $bccb89124e8dfda2$var$__param(1, $d6D31.NotNull),
        $bccb89124e8dfda2$var$__param(2, $d6D31.NotNull)
    ], $bccb89124e8dfda2$var$SemanticContextATNConfig);
    let $bccb89124e8dfda2$var$ActionATNConfig = class ActionATNConfig extends $bccb89124e8dfda2$var$ATNConfig {
        constructor(lexerActionExecutor, state, altOrConfig, context, passedThroughNonGreedyDecision){
            if (typeof altOrConfig === "number") super(state, altOrConfig, context);
            else {
                super(state, altOrConfig, context);
                if (altOrConfig.semanticContext !== $eHMgW.SemanticContext.NONE) throw new Error("Not supported");
            }
            this._lexerActionExecutor = lexerActionExecutor;
            this.passedThroughNonGreedyDecision = passedThroughNonGreedyDecision;
        }
        get lexerActionExecutor() {
            return this._lexerActionExecutor;
        }
        get hasPassedThroughNonGreedyDecision() {
            return this.passedThroughNonGreedyDecision;
        }
    };
    $bccb89124e8dfda2$var$__decorate([
        $d6D31.Override
    ], $bccb89124e8dfda2$var$ActionATNConfig.prototype, "lexerActionExecutor", null);
    $bccb89124e8dfda2$var$__decorate([
        $d6D31.Override
    ], $bccb89124e8dfda2$var$ActionATNConfig.prototype, "hasPassedThroughNonGreedyDecision", null);
    $bccb89124e8dfda2$var$ActionATNConfig = $bccb89124e8dfda2$var$__decorate([
        $bccb89124e8dfda2$var$__param(1, $d6D31.NotNull),
        $bccb89124e8dfda2$var$__param(2, $d6D31.NotNull)
    ], $bccb89124e8dfda2$var$ActionATNConfig);
    let $bccb89124e8dfda2$var$ActionSemanticContextATNConfig = class ActionSemanticContextATNConfig extends $bccb89124e8dfda2$var$SemanticContextATNConfig {
        constructor(lexerActionExecutor, semanticContext, state, altOrConfig, context, passedThroughNonGreedyDecision){
            if (typeof altOrConfig === "number") super(semanticContext, state, altOrConfig, context);
            else super(semanticContext, state, altOrConfig, context);
            this._lexerActionExecutor = lexerActionExecutor;
            this.passedThroughNonGreedyDecision = passedThroughNonGreedyDecision;
        }
        get lexerActionExecutor() {
            return this._lexerActionExecutor;
        }
        get hasPassedThroughNonGreedyDecision() {
            return this.passedThroughNonGreedyDecision;
        }
    };
    $bccb89124e8dfda2$var$__decorate([
        $d6D31.Override
    ], $bccb89124e8dfda2$var$ActionSemanticContextATNConfig.prototype, "lexerActionExecutor", null);
    $bccb89124e8dfda2$var$__decorate([
        $d6D31.Override
    ], $bccb89124e8dfda2$var$ActionSemanticContextATNConfig.prototype, "hasPassedThroughNonGreedyDecision", null);
    $bccb89124e8dfda2$var$ActionSemanticContextATNConfig = $bccb89124e8dfda2$var$__decorate([
        $bccb89124e8dfda2$var$__param(1, $d6D31.NotNull),
        $bccb89124e8dfda2$var$__param(2, $d6D31.NotNull)
    ], $bccb89124e8dfda2$var$ActionSemanticContextATNConfig);
});
parcelRegister("dPYn6", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.DecisionState = void 0;
    var $7j0Pc = parcelRequire("7j0Pc");
    class $a12ede58b33ddcba$var$DecisionState extends $7j0Pc.ATNState {
        constructor(){
            super(...arguments);
            this.decision = -1;
            this.nonGreedy = false;
            this.sll = false;
        }
    }
    module.exports.DecisionState = $a12ede58b33ddcba$var$DecisionState;
});
parcelRegister("8DTT0", function(module, exports) {
    "use strict";
    var $64ad510fde44ff92$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $64ad510fde44ff92$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.SingletonPredictionContext = module.exports.PredictionContext = void 0;
    var $fP17P = parcelRequire("fP17P");
    var $7Veax = parcelRequire("7Veax");
    var $9yG1X = parcelRequire("9yG1X");
    var $iXFjm = parcelRequire("iXFjm");
    var $d6D31 = parcelRequire("d6D31");
    var $6vF7J = parcelRequire("6vF7J");
    var $bbHFU = parcelRequire("bbHFU");
    const $64ad510fde44ff92$var$INITIAL_HASH = 1;
    class $64ad510fde44ff92$var$PredictionContext {
        constructor(cachedHashCode){
            this.cachedHashCode = cachedHashCode;
        }
        static calculateEmptyHashCode() {
            let hash = $iXFjm.MurmurHash.initialize($64ad510fde44ff92$var$INITIAL_HASH);
            hash = $iXFjm.MurmurHash.finish(hash, 0);
            return hash;
        }
        static calculateSingleHashCode(parent, returnState) {
            let hash = $iXFjm.MurmurHash.initialize($64ad510fde44ff92$var$INITIAL_HASH);
            hash = $iXFjm.MurmurHash.update(hash, parent);
            hash = $iXFjm.MurmurHash.update(hash, returnState);
            hash = $iXFjm.MurmurHash.finish(hash, 2);
            return hash;
        }
        static calculateHashCode(parents, returnStates) {
            let hash = $iXFjm.MurmurHash.initialize($64ad510fde44ff92$var$INITIAL_HASH);
            for (let parent of parents)hash = $iXFjm.MurmurHash.update(hash, parent);
            for (let returnState of returnStates)hash = $iXFjm.MurmurHash.update(hash, returnState);
            hash = $iXFjm.MurmurHash.finish(hash, 2 * parents.length);
            return hash;
        }
        static fromRuleContext(atn, outerContext, fullContext = true) {
            if (outerContext.isEmpty) return fullContext ? $64ad510fde44ff92$var$PredictionContext.EMPTY_FULL : $64ad510fde44ff92$var$PredictionContext.EMPTY_LOCAL;
            let parent;
            if (outerContext._parent) parent = $64ad510fde44ff92$var$PredictionContext.fromRuleContext(atn, outerContext._parent, fullContext);
            else parent = fullContext ? $64ad510fde44ff92$var$PredictionContext.EMPTY_FULL : $64ad510fde44ff92$var$PredictionContext.EMPTY_LOCAL;
            let state = atn.states[outerContext.invokingState];
            let transition = state.transition(0);
            return parent.getChild(transition.followState.stateNumber);
        }
        static addEmptyContext(context) {
            return context.addEmptyContext();
        }
        static removeEmptyContext(context) {
            return context.removeEmptyContext();
        }
        static join(context0, context1, contextCache = $6vF7J.PredictionContextCache.UNCACHED) {
            if (context0 === context1) return context0;
            if (context0.isEmpty) return $64ad510fde44ff92$var$PredictionContext.isEmptyLocal(context0) ? context0 : $64ad510fde44ff92$var$PredictionContext.addEmptyContext(context1);
            else if (context1.isEmpty) return $64ad510fde44ff92$var$PredictionContext.isEmptyLocal(context1) ? context1 : $64ad510fde44ff92$var$PredictionContext.addEmptyContext(context0);
            let context0size = context0.size;
            let context1size = context1.size;
            if (context0size === 1 && context1size === 1 && context0.getReturnState(0) === context1.getReturnState(0)) {
                let merged = contextCache.join(context0.getParent(0), context1.getParent(0));
                if (merged === context0.getParent(0)) return context0;
                else if (merged === context1.getParent(0)) return context1;
                else return merged.getChild(context0.getReturnState(0));
            }
            let count = 0;
            let parentsList = new Array(context0size + context1size);
            let returnStatesList = new Array(parentsList.length);
            let leftIndex = 0;
            let rightIndex = 0;
            let canReturnLeft = true;
            let canReturnRight = true;
            while(leftIndex < context0size && rightIndex < context1size){
                if (context0.getReturnState(leftIndex) === context1.getReturnState(rightIndex)) {
                    parentsList[count] = contextCache.join(context0.getParent(leftIndex), context1.getParent(rightIndex));
                    returnStatesList[count] = context0.getReturnState(leftIndex);
                    canReturnLeft = canReturnLeft && parentsList[count] === context0.getParent(leftIndex);
                    canReturnRight = canReturnRight && parentsList[count] === context1.getParent(rightIndex);
                    leftIndex++;
                    rightIndex++;
                } else if (context0.getReturnState(leftIndex) < context1.getReturnState(rightIndex)) {
                    parentsList[count] = context0.getParent(leftIndex);
                    returnStatesList[count] = context0.getReturnState(leftIndex);
                    canReturnRight = false;
                    leftIndex++;
                } else {
                    $bbHFU(context1.getReturnState(rightIndex) < context0.getReturnState(leftIndex));
                    parentsList[count] = context1.getParent(rightIndex);
                    returnStatesList[count] = context1.getReturnState(rightIndex);
                    canReturnLeft = false;
                    rightIndex++;
                }
                count++;
            }
            while(leftIndex < context0size){
                parentsList[count] = context0.getParent(leftIndex);
                returnStatesList[count] = context0.getReturnState(leftIndex);
                leftIndex++;
                canReturnRight = false;
                count++;
            }
            while(rightIndex < context1size){
                parentsList[count] = context1.getParent(rightIndex);
                returnStatesList[count] = context1.getReturnState(rightIndex);
                rightIndex++;
                canReturnLeft = false;
                count++;
            }
            if (canReturnLeft) return context0;
            else if (canReturnRight) return context1;
            if (count < parentsList.length) {
                parentsList = parentsList.slice(0, count);
                returnStatesList = returnStatesList.slice(0, count);
            }
            if (parentsList.length === 0) return $64ad510fde44ff92$var$PredictionContext.EMPTY_FULL;
            else if (parentsList.length === 1) return new $64ad510fde44ff92$var$SingletonPredictionContext(parentsList[0], returnStatesList[0]);
            else return new $64ad510fde44ff92$var$ArrayPredictionContext(parentsList, returnStatesList);
        }
        static isEmptyLocal(context) {
            return context === $64ad510fde44ff92$var$PredictionContext.EMPTY_LOCAL;
        }
        static getCachedContext(context, contextCache, visited) {
            if (context.isEmpty) return context;
            let existing = visited.get(context);
            if (existing) return existing;
            existing = contextCache.get(context);
            if (existing) {
                visited.put(context, existing);
                return existing;
            }
            let changed = false;
            let parents = new Array(context.size);
            for(let i = 0; i < parents.length; i++){
                let parent = $64ad510fde44ff92$var$PredictionContext.getCachedContext(context.getParent(i), contextCache, visited);
                if (changed || parent !== context.getParent(i)) {
                    if (!changed) {
                        parents = new Array(context.size);
                        for(let j = 0; j < context.size; j++)parents[j] = context.getParent(j);
                        changed = true;
                    }
                    parents[i] = parent;
                }
            }
            if (!changed) {
                existing = contextCache.putIfAbsent(context, context);
                visited.put(context, existing != null ? existing : context);
                return context;
            }
            let updated;
            if (parents.length === 1) updated = new $64ad510fde44ff92$var$SingletonPredictionContext(parents[0], context.getReturnState(0));
            else {
                let returnStates = new Array(context.size);
                for(let i = 0; i < context.size; i++)returnStates[i] = context.getReturnState(i);
                updated = new $64ad510fde44ff92$var$ArrayPredictionContext(parents, returnStates, context.hashCode());
            }
            existing = contextCache.putIfAbsent(updated, updated);
            visited.put(updated, existing || updated);
            visited.put(context, existing || updated);
            return updated;
        }
        appendSingleContext(returnContext, contextCache) {
            return this.appendContext($64ad510fde44ff92$var$PredictionContext.EMPTY_FULL.getChild(returnContext), contextCache);
        }
        getChild(returnState) {
            return new $64ad510fde44ff92$var$SingletonPredictionContext(this, returnState);
        }
        hashCode() {
            return this.cachedHashCode;
        }
        toStrings(recognizer, currentState, stop = $64ad510fde44ff92$var$PredictionContext.EMPTY_FULL) {
            let result = [];
            outer: for(let perm = 0;; perm++){
                let offset = 0;
                let last = true;
                let p = this;
                let stateNumber = currentState;
                let localBuffer = "";
                localBuffer += "[";
                while(!p.isEmpty && p !== stop){
                    let index = 0;
                    if (p.size > 0) {
                        let bits = 1;
                        while(1 << bits >>> 0 < p.size)bits++;
                        let mask = (1 << bits >>> 0) - 1;
                        index = perm >> offset & mask;
                        last = last && index >= p.size - 1;
                        if (index >= p.size) continue outer;
                        offset += bits;
                    }
                    if (recognizer) {
                        if (localBuffer.length > 1) localBuffer += " ";
                        let atn = recognizer.atn;
                        let s = atn.states[stateNumber];
                        let ruleName = recognizer.ruleNames[s.ruleIndex];
                        localBuffer += ruleName;
                    } else if (p.getReturnState(index) !== $64ad510fde44ff92$var$PredictionContext.EMPTY_FULL_STATE_KEY) {
                        if (!p.isEmpty) {
                            if (localBuffer.length > 1) localBuffer += " ";
                            localBuffer += p.getReturnState(index);
                        }
                    }
                    stateNumber = p.getReturnState(index);
                    p = p.getParent(index);
                }
                localBuffer += "]";
                result.push(localBuffer);
                if (last) break;
            }
            return result;
        }
    }
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$PredictionContext.prototype, "hashCode", null);
    $64ad510fde44ff92$var$__decorate([
        $64ad510fde44ff92$var$__param(0, $d6D31.NotNull),
        $64ad510fde44ff92$var$__param(1, $d6D31.NotNull),
        $64ad510fde44ff92$var$__param(2, $d6D31.NotNull)
    ], $64ad510fde44ff92$var$PredictionContext, "join", null);
    $64ad510fde44ff92$var$__decorate([
        $64ad510fde44ff92$var$__param(0, $d6D31.NotNull),
        $64ad510fde44ff92$var$__param(1, $d6D31.NotNull),
        $64ad510fde44ff92$var$__param(2, $d6D31.NotNull)
    ], $64ad510fde44ff92$var$PredictionContext, "getCachedContext", null);
    module.exports.PredictionContext = $64ad510fde44ff92$var$PredictionContext;
    class $64ad510fde44ff92$var$EmptyPredictionContext extends $64ad510fde44ff92$var$PredictionContext {
        constructor(fullContext){
            super($64ad510fde44ff92$var$PredictionContext.calculateEmptyHashCode());
            this.fullContext = fullContext;
        }
        get isFullContext() {
            return this.fullContext;
        }
        addEmptyContext() {
            return this;
        }
        removeEmptyContext() {
            throw new Error("Cannot remove the empty context from itself.");
        }
        getParent(index) {
            throw new Error("index out of bounds");
        }
        getReturnState(index) {
            throw new Error("index out of bounds");
        }
        findReturnState(returnState) {
            return -1;
        }
        get size() {
            return 0;
        }
        appendSingleContext(returnContext, contextCache) {
            return contextCache.getChild(this, returnContext);
        }
        appendContext(suffix, contextCache) {
            return suffix;
        }
        get isEmpty() {
            return true;
        }
        get hasEmpty() {
            return true;
        }
        equals(o) {
            return this === o;
        }
        toStrings(recognizer, currentState, stop) {
            return [
                "[]"
            ];
        }
    }
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$EmptyPredictionContext.prototype, "addEmptyContext", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$EmptyPredictionContext.prototype, "removeEmptyContext", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$EmptyPredictionContext.prototype, "getParent", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$EmptyPredictionContext.prototype, "getReturnState", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$EmptyPredictionContext.prototype, "findReturnState", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$EmptyPredictionContext.prototype, "size", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$EmptyPredictionContext.prototype, "appendSingleContext", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$EmptyPredictionContext.prototype, "appendContext", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$EmptyPredictionContext.prototype, "isEmpty", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$EmptyPredictionContext.prototype, "hasEmpty", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$EmptyPredictionContext.prototype, "equals", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$EmptyPredictionContext.prototype, "toStrings", null);
    let $64ad510fde44ff92$var$ArrayPredictionContext = class ArrayPredictionContext extends $64ad510fde44ff92$var$PredictionContext {
        constructor(parents, returnStates, hashCode){
            super(hashCode || $64ad510fde44ff92$var$PredictionContext.calculateHashCode(parents, returnStates));
            $bbHFU(parents.length === returnStates.length);
            $bbHFU(returnStates.length > 1 || returnStates[0] !== $64ad510fde44ff92$var$PredictionContext.EMPTY_FULL_STATE_KEY, "Should be using PredictionContext.EMPTY instead.");
            this.parents = parents;
            this.returnStates = returnStates;
        }
        getParent(index) {
            return this.parents[index];
        }
        getReturnState(index) {
            return this.returnStates[index];
        }
        findReturnState(returnState) {
            return $9yG1X.Arrays.binarySearch(this.returnStates, returnState);
        }
        get size() {
            return this.returnStates.length;
        }
        get isEmpty() {
            return false;
        }
        get hasEmpty() {
            return this.returnStates[this.returnStates.length - 1] === $64ad510fde44ff92$var$PredictionContext.EMPTY_FULL_STATE_KEY;
        }
        addEmptyContext() {
            if (this.hasEmpty) return this;
            let parents2 = this.parents.slice(0);
            let returnStates2 = this.returnStates.slice(0);
            parents2.push($64ad510fde44ff92$var$PredictionContext.EMPTY_FULL);
            returnStates2.push($64ad510fde44ff92$var$PredictionContext.EMPTY_FULL_STATE_KEY);
            return new ArrayPredictionContext(parents2, returnStates2);
        }
        removeEmptyContext() {
            if (!this.hasEmpty) return this;
            if (this.returnStates.length === 2) return new $64ad510fde44ff92$var$SingletonPredictionContext(this.parents[0], this.returnStates[0]);
            else {
                let parents2 = this.parents.slice(0, this.parents.length - 1);
                let returnStates2 = this.returnStates.slice(0, this.returnStates.length - 1);
                return new ArrayPredictionContext(parents2, returnStates2);
            }
        }
        appendContext(suffix, contextCache) {
            return ArrayPredictionContext.appendContextImpl(this, suffix, new $64ad510fde44ff92$var$PredictionContext.IdentityHashMap());
        }
        static appendContextImpl(context, suffix, visited) {
            if (suffix.isEmpty) {
                if ($64ad510fde44ff92$var$PredictionContext.isEmptyLocal(suffix)) {
                    if (context.hasEmpty) return $64ad510fde44ff92$var$PredictionContext.EMPTY_LOCAL;
                    throw new Error("what to do here?");
                }
                return context;
            }
            if (suffix.size !== 1) throw new Error("Appending a tree suffix is not yet supported.");
            let result = visited.get(context);
            if (!result) {
                if (context.isEmpty) result = suffix;
                else {
                    let parentCount = context.size;
                    if (context.hasEmpty) parentCount--;
                    let updatedParents = new Array(parentCount);
                    let updatedReturnStates = new Array(parentCount);
                    for(let i = 0; i < parentCount; i++)updatedReturnStates[i] = context.getReturnState(i);
                    for(let i = 0; i < parentCount; i++)updatedParents[i] = ArrayPredictionContext.appendContextImpl(context.getParent(i), suffix, visited);
                    if (updatedParents.length === 1) result = new $64ad510fde44ff92$var$SingletonPredictionContext(updatedParents[0], updatedReturnStates[0]);
                    else {
                        $bbHFU(updatedParents.length > 1);
                        result = new ArrayPredictionContext(updatedParents, updatedReturnStates);
                    }
                    if (context.hasEmpty) result = $64ad510fde44ff92$var$PredictionContext.join(result, suffix);
                }
                visited.put(context, result);
            }
            return result;
        }
        equals(o) {
            if (this === o) return true;
            else if (!(o instanceof ArrayPredictionContext)) return false;
            if (this.hashCode() !== o.hashCode()) return false;
            let other = o;
            return this.equalsImpl(other, new $7Veax.Array2DHashSet());
        }
        equalsImpl(other, visited) {
            let selfWorkList = [];
            let otherWorkList = [];
            selfWorkList.push(this);
            otherWorkList.push(other);
            while(true){
                let currentSelf = selfWorkList.pop();
                let currentOther = otherWorkList.pop();
                if (!currentSelf || !currentOther) break;
                let operands = new $6vF7J.PredictionContextCache.IdentityCommutativePredictionContextOperands(currentSelf, currentOther);
                if (!visited.add(operands)) continue;
                let selfSize = operands.x.size;
                if (selfSize === 0) {
                    if (!operands.x.equals(operands.y)) return false;
                    continue;
                }
                let otherSize = operands.y.size;
                if (selfSize !== otherSize) return false;
                for(let i = 0; i < selfSize; i++){
                    if (operands.x.getReturnState(i) !== operands.y.getReturnState(i)) return false;
                    let selfParent = operands.x.getParent(i);
                    let otherParent = operands.y.getParent(i);
                    if (selfParent.hashCode() !== otherParent.hashCode()) return false;
                    if (selfParent !== otherParent) {
                        selfWorkList.push(selfParent);
                        otherWorkList.push(otherParent);
                    }
                }
            }
            return true;
        }
    };
    $64ad510fde44ff92$var$__decorate([
        $d6D31.NotNull
    ], $64ad510fde44ff92$var$ArrayPredictionContext.prototype, "parents", void 0);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.NotNull
    ], $64ad510fde44ff92$var$ArrayPredictionContext.prototype, "returnStates", void 0);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$ArrayPredictionContext.prototype, "getParent", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$ArrayPredictionContext.prototype, "getReturnState", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$ArrayPredictionContext.prototype, "findReturnState", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$ArrayPredictionContext.prototype, "size", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$ArrayPredictionContext.prototype, "isEmpty", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$ArrayPredictionContext.prototype, "hasEmpty", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$ArrayPredictionContext.prototype, "addEmptyContext", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$ArrayPredictionContext.prototype, "removeEmptyContext", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$ArrayPredictionContext.prototype, "appendContext", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$ArrayPredictionContext.prototype, "equals", null);
    $64ad510fde44ff92$var$ArrayPredictionContext = $64ad510fde44ff92$var$__decorate([
        $64ad510fde44ff92$var$__param(0, $d6D31.NotNull)
    ], $64ad510fde44ff92$var$ArrayPredictionContext);
    let $64ad510fde44ff92$var$SingletonPredictionContext = class SingletonPredictionContext extends $64ad510fde44ff92$var$PredictionContext {
        constructor(parent, returnState){
            super($64ad510fde44ff92$var$PredictionContext.calculateSingleHashCode(parent, returnState));
            this.parent = parent;
            this.returnState = returnState;
        }
        getParent(index) {
            return this.parent;
        }
        getReturnState(index) {
            return this.returnState;
        }
        findReturnState(returnState) {
            return this.returnState === returnState ? 0 : -1;
        }
        get size() {
            return 1;
        }
        get isEmpty() {
            return false;
        }
        get hasEmpty() {
            return false;
        }
        appendContext(suffix, contextCache) {
            return contextCache.getChild(this.parent.appendContext(suffix, contextCache), this.returnState);
        }
        addEmptyContext() {
            let parents = [
                this.parent,
                $64ad510fde44ff92$var$PredictionContext.EMPTY_FULL
            ];
            let returnStates = [
                this.returnState,
                $64ad510fde44ff92$var$PredictionContext.EMPTY_FULL_STATE_KEY
            ];
            return new $64ad510fde44ff92$var$ArrayPredictionContext(parents, returnStates);
        }
        removeEmptyContext() {
            return this;
        }
        equals(o) {
            if (o === this) return true;
            else if (!(o instanceof SingletonPredictionContext)) return false;
            let other = o;
            if (this.hashCode() !== other.hashCode()) return false;
            return this.returnState === other.returnState && this.parent.equals(other.parent);
        }
    };
    $64ad510fde44ff92$var$__decorate([
        $d6D31.NotNull
    ], $64ad510fde44ff92$var$SingletonPredictionContext.prototype, "parent", void 0);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$SingletonPredictionContext.prototype, "getParent", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$SingletonPredictionContext.prototype, "getReturnState", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$SingletonPredictionContext.prototype, "findReturnState", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$SingletonPredictionContext.prototype, "size", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$SingletonPredictionContext.prototype, "isEmpty", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$SingletonPredictionContext.prototype, "hasEmpty", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$SingletonPredictionContext.prototype, "appendContext", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$SingletonPredictionContext.prototype, "addEmptyContext", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$SingletonPredictionContext.prototype, "removeEmptyContext", null);
    $64ad510fde44ff92$var$__decorate([
        $d6D31.Override
    ], $64ad510fde44ff92$var$SingletonPredictionContext.prototype, "equals", null);
    $64ad510fde44ff92$var$SingletonPredictionContext = $64ad510fde44ff92$var$__decorate([
        $64ad510fde44ff92$var$__param(0, $d6D31.NotNull)
    ], $64ad510fde44ff92$var$SingletonPredictionContext);
    module.exports.SingletonPredictionContext = $64ad510fde44ff92$var$SingletonPredictionContext;
    (function(PredictionContext) {
        PredictionContext.EMPTY_LOCAL = new $64ad510fde44ff92$var$EmptyPredictionContext(false);
        PredictionContext.EMPTY_FULL = new $64ad510fde44ff92$var$EmptyPredictionContext(true);
        PredictionContext.EMPTY_LOCAL_STATE_KEY = -2147483648;
        PredictionContext.EMPTY_FULL_STATE_KEY = 2147483647;
        class IdentityHashMap extends $fP17P.Array2DHashMap {
            constructor(){
                super(IdentityEqualityComparator.INSTANCE);
            }
        }
        PredictionContext.IdentityHashMap = IdentityHashMap;
        class IdentityEqualityComparator {
            IdentityEqualityComparator() {}
            hashCode(obj) {
                return obj.hashCode();
            }
            equals(a, b) {
                return a === b;
            }
        }
        IdentityEqualityComparator.INSTANCE = new IdentityEqualityComparator();
        $64ad510fde44ff92$var$__decorate([
            $d6D31.Override
        ], IdentityEqualityComparator.prototype, "hashCode", null);
        $64ad510fde44ff92$var$__decorate([
            $d6D31.Override
        ], IdentityEqualityComparator.prototype, "equals", null);
        PredictionContext.IdentityEqualityComparator = IdentityEqualityComparator;
    })($64ad510fde44ff92$var$PredictionContext = module.exports.PredictionContext || (module.exports.PredictionContext = {}));
});
parcelRegister("6vF7J", function(module, exports) {
    "use strict";
    var $4bd589a149816580$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.PredictionContextCache = void 0;
    var $fP17P = parcelRequire("fP17P");
    var $d6D31 = parcelRequire("d6D31");
    var $a4Flx = parcelRequire("a4Flx");
    var $8DTT0 = parcelRequire("8DTT0");
    var $bbHFU = parcelRequire("bbHFU");
    class $4bd589a149816580$var$PredictionContextCache {
        constructor(enableCache = true){
            this.contexts = new $fP17P.Array2DHashMap($a4Flx.ObjectEqualityComparator.INSTANCE);
            this.childContexts = new $fP17P.Array2DHashMap($a4Flx.ObjectEqualityComparator.INSTANCE);
            this.joinContexts = new $fP17P.Array2DHashMap($a4Flx.ObjectEqualityComparator.INSTANCE);
            this.enableCache = enableCache;
        }
        getAsCached(context) {
            if (!this.enableCache) return context;
            let result = this.contexts.get(context);
            if (!result) {
                result = context;
                this.contexts.put(context, context);
            }
            return result;
        }
        getChild(context, invokingState) {
            if (!this.enableCache) return context.getChild(invokingState);
            let operands = new $4bd589a149816580$var$PredictionContextCache.PredictionContextAndInt(context, invokingState);
            let result = this.childContexts.get(operands);
            if (!result) {
                result = context.getChild(invokingState);
                result = this.getAsCached(result);
                this.childContexts.put(operands, result);
            }
            return result;
        }
        join(x, y) {
            if (!this.enableCache) return $8DTT0.PredictionContext.join(x, y, this);
            let operands = new $4bd589a149816580$var$PredictionContextCache.IdentityCommutativePredictionContextOperands(x, y);
            let result = this.joinContexts.get(operands);
            if (result) return result;
            result = $8DTT0.PredictionContext.join(x, y, this);
            result = this.getAsCached(result);
            this.joinContexts.put(operands, result);
            return result;
        }
    }
    module.exports.PredictionContextCache = $4bd589a149816580$var$PredictionContextCache;
    $4bd589a149816580$var$PredictionContextCache.UNCACHED = new $4bd589a149816580$var$PredictionContextCache(false);
    (function(PredictionContextCache) {
        class PredictionContextAndInt {
            constructor(obj, value){
                this.obj = obj;
                this.value = value;
            }
            equals(obj) {
                if (!(obj instanceof PredictionContextAndInt)) return false;
                else if (obj === this) return true;
                let other = obj;
                return this.value === other.value && (this.obj === other.obj || this.obj != null && this.obj.equals(other.obj));
            }
            hashCode() {
                let hashCode = 5;
                hashCode = 7 * hashCode + (this.obj != null ? this.obj.hashCode() : 0);
                hashCode = 7 * hashCode + this.value;
                return hashCode;
            }
        }
        $4bd589a149816580$var$__decorate([
            $d6D31.Override
        ], PredictionContextAndInt.prototype, "equals", null);
        $4bd589a149816580$var$__decorate([
            $d6D31.Override
        ], PredictionContextAndInt.prototype, "hashCode", null);
        PredictionContextCache.PredictionContextAndInt = PredictionContextAndInt;
        class IdentityCommutativePredictionContextOperands {
            constructor(x, y){
                $bbHFU(x != null);
                $bbHFU(y != null);
                this._x = x;
                this._y = y;
            }
            get x() {
                return this._x;
            }
            get y() {
                return this._y;
            }
            equals(o) {
                if (!(o instanceof IdentityCommutativePredictionContextOperands)) return false;
                else if (this === o) return true;
                let other = o;
                return this._x === other._x && this._y === other._y || this._x === other._y && this._y === other._x;
            }
            hashCode() {
                return this._x.hashCode() ^ this._y.hashCode();
            }
        }
        $4bd589a149816580$var$__decorate([
            $d6D31.Override
        ], IdentityCommutativePredictionContextOperands.prototype, "equals", null);
        $4bd589a149816580$var$__decorate([
            $d6D31.Override
        ], IdentityCommutativePredictionContextOperands.prototype, "hashCode", null);
        PredictionContextCache.IdentityCommutativePredictionContextOperands = IdentityCommutativePredictionContextOperands;
    })($4bd589a149816580$var$PredictionContextCache = module.exports.PredictionContextCache || (module.exports.PredictionContextCache = {}));
});
parcelRegister("5BPMp", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.BitSet = void 0;
    var $9kAQu = parcelRequire("9kAQu");
    var $iXFjm = parcelRequire("iXFjm");
    const $415892d73e8925a4$var$EMPTY_DATA = new Uint16Array(0);
    function $415892d73e8925a4$var$getIndex(bitNumber) {
        return bitNumber >>> 4;
    }
    function $415892d73e8925a4$var$unIndex(n) {
        return n * 16;
    }
    function $415892d73e8925a4$var$findLSBSet(word) {
        let bit = 1;
        for(let i = 0; i < 16; i++){
            if ((word & bit) !== 0) return i;
            bit = bit << 1 >>> 0;
        }
        throw new RangeError("No specified bit found");
    }
    function $415892d73e8925a4$var$findMSBSet(word) {
        let bit = 32768;
        for(let i = 15; i >= 0; i--){
            if ((word & bit) !== 0) return i;
            bit = bit >>> 1;
        }
        throw new RangeError("No specified bit found");
    }
    function $415892d73e8925a4$var$bitsFor(fromBit, toBit) {
        fromBit &= 0xF;
        toBit &= 0xF;
        if (fromBit === toBit) return 1 << fromBit >>> 0;
        return 0xFFFF >>> 15 - toBit ^ 0xFFFF >>> 16 - fromBit;
    }
    const $415892d73e8925a4$var$POP_CNT = new Uint8Array(65536);
    for(let i = 0; i < 16; i++){
        const stride = 1 << i >>> 0;
        let index = 0;
        while(index < $415892d73e8925a4$var$POP_CNT.length){
            index += stride;
            for(let j = 0; j < stride; j++){
                $415892d73e8925a4$var$POP_CNT[index]++;
                index++;
            }
        }
    }
    class $415892d73e8925a4$var$BitSet {
        constructor(arg){
            if (!arg) this.data = $415892d73e8925a4$var$EMPTY_DATA;
            else if (typeof arg === "number") {
                if (arg < 0) throw new RangeError("nbits cannot be negative");
                else this.data = new Uint16Array($415892d73e8925a4$var$getIndex(arg - 1) + 1);
            } else if (arg instanceof $415892d73e8925a4$var$BitSet) this.data = arg.data.slice(0);
            else {
                let max = -1;
                for (let v of arg)if (max < v) max = v;
                this.data = new Uint16Array($415892d73e8925a4$var$getIndex(max - 1) + 1);
                for (let v of arg)this.set(v);
            }
        }
        and(set) {
            const data = this.data;
            const other = set.data;
            const words = Math.min(data.length, other.length);
            let lastWord = -1;
            for(let i = 0; i < words; i++){
                let value = data[i] &= other[i];
                if (value !== 0) lastWord = i;
            }
            if (lastWord === -1) this.data = $415892d73e8925a4$var$EMPTY_DATA;
            if (lastWord < data.length - 1) this.data = data.slice(0, lastWord + 1);
        }
        andNot(set) {
            const data = this.data;
            const other = set.data;
            const words = Math.min(data.length, other.length);
            let lastWord = -1;
            for(let i = 0; i < words; i++){
                let value = data[i] &= other[i] ^ 0xFFFF;
                if (value !== 0) lastWord = i;
            }
            if (lastWord === -1) this.data = $415892d73e8925a4$var$EMPTY_DATA;
            if (lastWord < data.length - 1) this.data = data.slice(0, lastWord + 1);
        }
        cardinality() {
            if (this.isEmpty) return 0;
            const data = this.data;
            const length = data.length;
            let result = 0;
            for(let i = 0; i < length; i++)result += $415892d73e8925a4$var$POP_CNT[data[i]];
            return result;
        }
        clear(fromIndex, toIndex) {
            if (fromIndex == null) this.data.fill(0);
            else if (toIndex == null) this.set(fromIndex, false);
            else this.set(fromIndex, toIndex, false);
        }
        flip(fromIndex, toIndex) {
            if (toIndex == null) toIndex = fromIndex;
            if (fromIndex < 0 || toIndex < fromIndex) throw new RangeError();
            let word = $415892d73e8925a4$var$getIndex(fromIndex);
            const lastWord = $415892d73e8925a4$var$getIndex(toIndex);
            if (word === lastWord) this.data[word] ^= $415892d73e8925a4$var$bitsFor(fromIndex, toIndex);
            else {
                this.data[word++] ^= $415892d73e8925a4$var$bitsFor(fromIndex, 15);
                while(word < lastWord)this.data[word++] ^= 0xFFFF;
                this.data[word++] ^= $415892d73e8925a4$var$bitsFor(0, toIndex);
            }
        }
        get(fromIndex, toIndex) {
            if (toIndex === undefined) return !!(this.data[$415892d73e8925a4$var$getIndex(fromIndex)] & $415892d73e8925a4$var$bitsFor(fromIndex, fromIndex));
            else {
                let result = new $415892d73e8925a4$var$BitSet(toIndex + 1);
                for(let i = fromIndex; i <= toIndex; i++)result.set(i, this.get(i));
                return result;
            }
        }
        intersects(set) {
            let smallerLength = Math.min(this.length(), set.length());
            if (smallerLength === 0) return false;
            let bound = $415892d73e8925a4$var$getIndex(smallerLength - 1);
            for(let i = 0; i <= bound; i++){
                if ((this.data[i] & set.data[i]) !== 0) return true;
            }
            return false;
        }
        get isEmpty() {
            return this.length() === 0;
        }
        length() {
            if (!this.data.length) return 0;
            return this.previousSetBit($415892d73e8925a4$var$unIndex(this.data.length) - 1) + 1;
        }
        nextClearBit(fromIndex) {
            if (fromIndex < 0) throw new RangeError("fromIndex cannot be negative");
            const data = this.data;
            const length = data.length;
            let word = $415892d73e8925a4$var$getIndex(fromIndex);
            if (word > length) return -1;
            let ignore = 0xFFFF ^ $415892d73e8925a4$var$bitsFor(fromIndex, 15);
            if ((data[word] | ignore) === 0xFFFF) {
                word++;
                ignore = 0;
                for(; word < length; word++){
                    if (data[word] !== 0xFFFF) break;
                }
                if (word === length) return -1;
            }
            return $415892d73e8925a4$var$unIndex(word) + $415892d73e8925a4$var$findLSBSet((data[word] | ignore) ^ 0xFFFF);
        }
        nextSetBit(fromIndex) {
            if (fromIndex < 0) throw new RangeError("fromIndex cannot be negative");
            const data = this.data;
            const length = data.length;
            let word = $415892d73e8925a4$var$getIndex(fromIndex);
            if (word > length) return -1;
            let mask = $415892d73e8925a4$var$bitsFor(fromIndex, 15);
            if ((data[word] & mask) === 0) {
                word++;
                mask = 0xFFFF;
                for(; word < length; word++){
                    if (data[word] !== 0) break;
                }
                if (word >= length) return -1;
            }
            return $415892d73e8925a4$var$unIndex(word) + $415892d73e8925a4$var$findLSBSet(data[word] & mask);
        }
        or(set) {
            const data = this.data;
            const other = set.data;
            const minWords = Math.min(data.length, other.length);
            const words = Math.max(data.length, other.length);
            const dest = data.length === words ? data : new Uint16Array(words);
            let lastWord = -1;
            for(let i = 0; i < minWords; i++){
                let value = dest[i] = data[i] | other[i];
                if (value !== 0) lastWord = i;
            }
            const longer = data.length > other.length ? data : other;
            for(let i = minWords; i < words; i++){
                let value = dest[i] = longer[i];
                if (value !== 0) lastWord = i;
            }
            if (lastWord === -1) this.data = $415892d73e8925a4$var$EMPTY_DATA;
            else if (dest.length === lastWord + 1) this.data = dest;
            else this.data = dest.slice(0, lastWord);
        }
        previousClearBit(fromIndex) {
            if (fromIndex < 0) throw new RangeError("fromIndex cannot be negative");
            const data = this.data;
            const length = data.length;
            let word = $415892d73e8925a4$var$getIndex(fromIndex);
            if (word >= length) word = length - 1;
            let ignore = 0xFFFF ^ $415892d73e8925a4$var$bitsFor(0, fromIndex);
            if ((data[word] | ignore) === 0xFFFF) {
                ignore = 0;
                word--;
                for(; word >= 0; word--){
                    if (data[word] !== 0xFFFF) break;
                }
                if (word < 0) return -1;
            }
            return $415892d73e8925a4$var$unIndex(word) + $415892d73e8925a4$var$findMSBSet((data[word] | ignore) ^ 0xFFFF);
        }
        previousSetBit(fromIndex) {
            if (fromIndex < 0) throw new RangeError("fromIndex cannot be negative");
            const data = this.data;
            const length = data.length;
            let word = $415892d73e8925a4$var$getIndex(fromIndex);
            if (word >= length) word = length - 1;
            let mask = $415892d73e8925a4$var$bitsFor(0, fromIndex);
            if ((data[word] & mask) === 0) {
                word--;
                mask = 0xFFFF;
                for(; word >= 0; word--){
                    if (data[word] !== 0) break;
                }
                if (word < 0) return -1;
            }
            return $415892d73e8925a4$var$unIndex(word) + $415892d73e8925a4$var$findMSBSet(data[word] & mask);
        }
        set(fromIndex, toIndex, value) {
            if (toIndex === undefined) {
                toIndex = fromIndex;
                value = true;
            } else if (typeof toIndex === "boolean") {
                value = toIndex;
                toIndex = fromIndex;
            }
            if (value === undefined) value = true;
            if (fromIndex < 0 || fromIndex > toIndex) throw new RangeError();
            let word = $415892d73e8925a4$var$getIndex(fromIndex);
            let lastWord = $415892d73e8925a4$var$getIndex(toIndex);
            if (value && lastWord >= this.data.length) {
                let temp = new Uint16Array(lastWord + 1);
                this.data.forEach((value, index)=>temp[index] = value);
                this.data = temp;
            } else if (!value) {
                if (word >= this.data.length) return;
                if (lastWord >= this.data.length) {
                    lastWord = this.data.length - 1;
                    toIndex = this.data.length * 16 - 1;
                }
            }
            if (word === lastWord) this._setBits(word, value, $415892d73e8925a4$var$bitsFor(fromIndex, toIndex));
            else {
                this._setBits(word++, value, $415892d73e8925a4$var$bitsFor(fromIndex, 15));
                while(word < lastWord)this.data[word++] = value ? 0xFFFF : 0;
                this._setBits(word, value, $415892d73e8925a4$var$bitsFor(0, toIndex));
            }
        }
        _setBits(word, value, mask) {
            if (value) this.data[word] |= mask;
            else this.data[word] &= 0xFFFF ^ mask;
        }
        get size() {
            return this.data.byteLength * 8;
        }
        hashCode() {
            return $iXFjm.MurmurHash.hashCode(this.data, 22);
        }
        equals(obj) {
            if (obj === this) return true;
            else if (!(obj instanceof $415892d73e8925a4$var$BitSet)) return false;
            const len = this.length();
            if (len !== obj.length()) return false;
            if (len === 0) return true;
            let bound = $415892d73e8925a4$var$getIndex(len - 1);
            for(let i = 0; i <= bound; i++){
                if (this.data[i] !== obj.data[i]) return false;
            }
            return true;
        }
        toString() {
            let result = "{";
            let first = true;
            for(let i = this.nextSetBit(0); i >= 0; i = this.nextSetBit(i + 1)){
                if (first) first = false;
                else result += ", ";
                result += i;
            }
            result += "}";
            return result;
        }
        xor(set) {
            const data = this.data;
            const other = set.data;
            const minWords = Math.min(data.length, other.length);
            const words = Math.max(data.length, other.length);
            const dest = data.length === words ? data : new Uint16Array(words);
            let lastWord = -1;
            for(let i = 0; i < minWords; i++){
                let value = dest[i] = data[i] ^ other[i];
                if (value !== 0) lastWord = i;
            }
            const longer = data.length > other.length ? data : other;
            for(let i = minWords; i < words; i++){
                let value = dest[i] = longer[i];
                if (value !== 0) lastWord = i;
            }
            if (lastWord === -1) this.data = $415892d73e8925a4$var$EMPTY_DATA;
            else if (dest.length === lastWord + 1) this.data = dest;
            else this.data = dest.slice(0, lastWord + 1);
        }
        clone() {
            return new $415892d73e8925a4$var$BitSet(this);
        }
        [Symbol.iterator]() {
            return new $415892d73e8925a4$var$BitSetIterator(this.data);
        }
        [$9kAQu.inspect.custom]() {
            return "BitSet " + this.toString();
        }
    }
    module.exports.BitSet = $415892d73e8925a4$var$BitSet;
    class $415892d73e8925a4$var$BitSetIterator {
        constructor(data){
            this.data = data;
            this.index = 0;
            this.mask = 0xFFFF;
        }
        next() {
            while(this.index < this.data.length){
                const bits = this.data[this.index] & this.mask;
                if (bits !== 0) {
                    const bitNumber = $415892d73e8925a4$var$unIndex(this.index) + $415892d73e8925a4$var$findLSBSet(bits);
                    this.mask = $415892d73e8925a4$var$bitsFor(bitNumber + 1, 15);
                    return {
                        done: false,
                        value: bitNumber
                    };
                }
                this.index++;
                this.mask = 0xFFFF;
            }
            return {
                done: true,
                value: -1
            };
        }
        [Symbol.iterator]() {
            return this;
        }
    }
});
parcelRegister("yhTtv", function(module, exports) {
    "use strict";
    var $06710e6ae1da410a$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.DFASerializer = void 0;
    var $kr9A1 = parcelRequire("kr9A1");
    var $d6D31 = parcelRequire("d6D31");
    var $8DTT0 = parcelRequire("8DTT0");
    var $kBaAZ = parcelRequire("kBaAZ");
    var $3n2FE = parcelRequire("3n2FE");
    class $06710e6ae1da410a$var$DFASerializer {
        constructor(dfa, vocabulary, ruleNames, atn){
            if (vocabulary instanceof $kBaAZ.Recognizer) {
                ruleNames = vocabulary.ruleNames;
                atn = vocabulary.atn;
                vocabulary = vocabulary.vocabulary;
            } else if (!vocabulary) vocabulary = $3n2FE.VocabularyImpl.EMPTY_VOCABULARY;
            this.dfa = dfa;
            this.vocabulary = vocabulary;
            this.ruleNames = ruleNames;
            this.atn = atn;
        }
        toString() {
            if (!this.dfa.s0) return "";
            let buf = "";
            if (this.dfa.states) {
                let states = new Array(...this.dfa.states.toArray());
                states.sort((o1, o2)=>o1.stateNumber - o2.stateNumber);
                for (let s of states){
                    let edges = s.getEdgeMap();
                    let edgeKeys = [
                        ...edges.keys()
                    ].sort((a, b)=>a - b);
                    let contextEdges = s.getContextEdgeMap();
                    let contextEdgeKeys = [
                        ...contextEdges.keys()
                    ].sort((a, b)=>a - b);
                    for (let entry of edgeKeys){
                        let value = edges.get(entry);
                        if ((value == null || value === $kr9A1.ATNSimulator.ERROR) && !s.isContextSymbol(entry)) continue;
                        let contextSymbol = false;
                        buf += this.getStateString(s) + "-" + this.getEdgeLabel(entry) + "->";
                        if (s.isContextSymbol(entry)) {
                            buf += "!";
                            contextSymbol = true;
                        }
                        let t = value;
                        if (t && t.stateNumber !== $kr9A1.ATNSimulator.ERROR.stateNumber) buf += this.getStateString(t) + "\n";
                        else if (contextSymbol) buf += "ctx\n";
                    }
                    if (s.isContextSensitive) for (let entry of contextEdgeKeys)buf += this.getStateString(s) + "-" + this.getContextLabel(entry) + "->" + this.getStateString(contextEdges.get(entry)) + "\n";
                }
            }
            let output = buf;
            if (output.length === 0) return "";
            return output;
        }
        getContextLabel(i) {
            if (i === $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY) return "ctx:EMPTY_FULL";
            else if (i === $8DTT0.PredictionContext.EMPTY_LOCAL_STATE_KEY) return "ctx:EMPTY_LOCAL";
            if (this.atn && i > 0 && i <= this.atn.states.length) {
                let state = this.atn.states[i];
                let ruleIndex = state.ruleIndex;
                if (this.ruleNames && ruleIndex >= 0 && ruleIndex < this.ruleNames.length) return "ctx:" + String(i) + "(" + this.ruleNames[ruleIndex] + ")";
            }
            return "ctx:" + String(i);
        }
        getEdgeLabel(i) {
            return this.vocabulary.getDisplayName(i);
        }
        getStateString(s) {
            if (s === $kr9A1.ATNSimulator.ERROR) return "ERROR";
            let n = s.stateNumber;
            let stateStr = "s" + n;
            if (s.isAcceptState) {
                if (s.predicates) stateStr = ":s" + n + "=>" + s.predicates;
                else stateStr = ":s" + n + "=>" + s.prediction;
            }
            if (s.isContextSensitive) {
                stateStr += "*";
                for (let config of s.configs)if (config.reachesIntoOuterContext) {
                    stateStr += "*";
                    break;
                }
            }
            return stateStr;
        }
    }
    $06710e6ae1da410a$var$__decorate([
        $d6D31.NotNull
    ], $06710e6ae1da410a$var$DFASerializer.prototype, "dfa", void 0);
    $06710e6ae1da410a$var$__decorate([
        $d6D31.NotNull
    ], $06710e6ae1da410a$var$DFASerializer.prototype, "vocabulary", void 0);
    $06710e6ae1da410a$var$__decorate([
        $d6D31.Override
    ], $06710e6ae1da410a$var$DFASerializer.prototype, "toString", null);
    module.exports.DFASerializer = $06710e6ae1da410a$var$DFASerializer;
});
parcelRegister("kr9A1", function(module, exports) {
    "use strict";
    var $ee0dc2a763a7368a$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $ee0dc2a763a7368a$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ATNSimulator = void 0;
    var $c1ClW = parcelRequire("c1ClW");
    var $2jevZ = parcelRequire("2jevZ");
    var $d6D31 = parcelRequire("d6D31");
    var $8DTT0 = parcelRequire("8DTT0");
    let $ee0dc2a763a7368a$var$ATNSimulator = class ATNSimulator {
        constructor(atn){
            this.atn = atn;
        }
        static get ERROR() {
            if (!ATNSimulator._ERROR) {
                ATNSimulator._ERROR = new $2jevZ.DFAState(new $c1ClW.ATNConfigSet());
                ATNSimulator._ERROR.stateNumber = $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY;
            }
            return ATNSimulator._ERROR;
        }
        clearDFA() {
            this.atn.clearDFA();
        }
    };
    $ee0dc2a763a7368a$var$__decorate([
        $d6D31.NotNull
    ], $ee0dc2a763a7368a$var$ATNSimulator.prototype, "atn", void 0);
    $ee0dc2a763a7368a$var$__decorate([
        $d6D31.NotNull
    ], $ee0dc2a763a7368a$var$ATNSimulator, "ERROR", null);
    $ee0dc2a763a7368a$var$ATNSimulator = $ee0dc2a763a7368a$var$__decorate([
        $ee0dc2a763a7368a$var$__param(0, $d6D31.NotNull)
    ], $ee0dc2a763a7368a$var$ATNSimulator);
    module.exports.ATNSimulator = $ee0dc2a763a7368a$var$ATNSimulator;
    (function(ATNSimulator) {
        const RULE_VARIANT_DELIMITER = "$";
        const RULE_LF_VARIANT_MARKER = "$lf$";
        const RULE_NOLF_VARIANT_MARKER = "$nolf$";
    })($ee0dc2a763a7368a$var$ATNSimulator = module.exports.ATNSimulator || (module.exports.ATNSimulator = {}));
    module.exports.ATNSimulator = $ee0dc2a763a7368a$var$ATNSimulator;
});
parcelRegister("2jevZ", function(module, exports) {
    "use strict";
    var $1ae89d7ac78d8bff$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $1ae89d7ac78d8bff$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.DFAState = void 0;
    var $bcnvE = parcelRequire("bcnvE");
    var $5BPMp = parcelRequire("5BPMp");
    var $iXFjm = parcelRequire("iXFjm");
    var $d6D31 = parcelRequire("d6D31");
    var $8DTT0 = parcelRequire("8DTT0");
    var $bbHFU = parcelRequire("bbHFU");
    class $1ae89d7ac78d8bff$var$DFAState {
        constructor(configs){
            this.stateNumber = -1;
            this.configs = configs;
            this.edges = new Map();
            this.contextEdges = new Map();
        }
        get isContextSensitive() {
            return !!this.contextSymbols;
        }
        isContextSymbol(symbol) {
            if (!this.isContextSensitive) return false;
            return this.contextSymbols.get(symbol);
        }
        setContextSymbol(symbol) {
            $bbHFU(this.isContextSensitive);
            this.contextSymbols.set(symbol);
        }
        setContextSensitive(atn) {
            $bbHFU(!this.configs.isOutermostConfigSet);
            if (this.isContextSensitive) return;
            if (!this.contextSymbols) this.contextSymbols = new $5BPMp.BitSet();
        }
        get acceptStateInfo() {
            return this._acceptStateInfo;
        }
        set acceptStateInfo(acceptStateInfo) {
            this._acceptStateInfo = acceptStateInfo;
        }
        get isAcceptState() {
            return !!this._acceptStateInfo;
        }
        get prediction() {
            if (!this._acceptStateInfo) return $bcnvE.ATN.INVALID_ALT_NUMBER;
            return this._acceptStateInfo.prediction;
        }
        get lexerActionExecutor() {
            if (!this._acceptStateInfo) return undefined;
            return this._acceptStateInfo.lexerActionExecutor;
        }
        getTarget(symbol) {
            return this.edges.get(symbol);
        }
        setTarget(symbol, target) {
            this.edges.set(symbol, target);
        }
        getEdgeMap() {
            return this.edges;
        }
        getContextTarget(invokingState) {
            if (invokingState === $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY) invokingState = -1;
            return this.contextEdges.get(invokingState);
        }
        setContextTarget(invokingState, target) {
            if (!this.isContextSensitive) throw new Error("The state is not context sensitive.");
            if (invokingState === $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY) invokingState = -1;
            this.contextEdges.set(invokingState, target);
        }
        getContextEdgeMap() {
            let map = new Map(this.contextEdges);
            let existing = map.get(-1);
            if (existing !== undefined) {
                if (map.size === 1) {
                    let result = new Map();
                    result.set($8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY, existing);
                    return result;
                } else {
                    map.delete(-1);
                    map.set($8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY, existing);
                }
            }
            return map;
        }
        hashCode() {
            let hash = $iXFjm.MurmurHash.initialize(7);
            hash = $iXFjm.MurmurHash.update(hash, this.configs.hashCode());
            hash = $iXFjm.MurmurHash.finish(hash, 1);
            return hash;
        }
        equals(o) {
            if (this === o) return true;
            if (!(o instanceof $1ae89d7ac78d8bff$var$DFAState)) return false;
            let other = o;
            let sameSet = this.configs.equals(other.configs);
            return sameSet;
        }
        toString() {
            let buf = "";
            buf += this.stateNumber + ":" + this.configs;
            if (this.isAcceptState) {
                buf += "=>";
                if (this.predicates) buf += this.predicates;
                else buf += this.prediction;
            }
            return buf.toString();
        }
    }
    $1ae89d7ac78d8bff$var$__decorate([
        $d6D31.NotNull
    ], $1ae89d7ac78d8bff$var$DFAState.prototype, "configs", void 0);
    $1ae89d7ac78d8bff$var$__decorate([
        $d6D31.NotNull
    ], $1ae89d7ac78d8bff$var$DFAState.prototype, "edges", void 0);
    $1ae89d7ac78d8bff$var$__decorate([
        $d6D31.NotNull
    ], $1ae89d7ac78d8bff$var$DFAState.prototype, "contextEdges", void 0);
    $1ae89d7ac78d8bff$var$__decorate([
        $d6D31.Override
    ], $1ae89d7ac78d8bff$var$DFAState.prototype, "hashCode", null);
    $1ae89d7ac78d8bff$var$__decorate([
        $d6D31.Override
    ], $1ae89d7ac78d8bff$var$DFAState.prototype, "equals", null);
    $1ae89d7ac78d8bff$var$__decorate([
        $d6D31.Override
    ], $1ae89d7ac78d8bff$var$DFAState.prototype, "toString", null);
    module.exports.DFAState = $1ae89d7ac78d8bff$var$DFAState;
    (function(DFAState) {
        let PredPrediction = class PredPrediction {
            constructor(pred, alt){
                this.alt = alt;
                this.pred = pred;
            }
            toString() {
                return "(" + this.pred + ", " + this.alt + ")";
            }
        };
        $1ae89d7ac78d8bff$var$__decorate([
            $d6D31.NotNull
        ], PredPrediction.prototype, "pred", void 0);
        $1ae89d7ac78d8bff$var$__decorate([
            $d6D31.Override
        ], PredPrediction.prototype, "toString", null);
        PredPrediction = $1ae89d7ac78d8bff$var$__decorate([
            $1ae89d7ac78d8bff$var$__param(0, $d6D31.NotNull)
        ], PredPrediction);
        DFAState.PredPrediction = PredPrediction;
    })($1ae89d7ac78d8bff$var$DFAState = module.exports.DFAState || (module.exports.DFAState = {}));
});
parcelRegister("kBaAZ", function(module, exports) {
    "use strict";
    var $efef7b6bec20bc2a$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $efef7b6bec20bc2a$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.Recognizer = void 0;
    var $e5mHr = parcelRequire("e5mHr");
    var $65iNZ = parcelRequire("65iNZ");
    var $d6D31 = parcelRequire("d6D31");
    var $2DVsz = parcelRequire("2DVsz");
    var $2IEP9 = parcelRequire("2IEP9");
    class $efef7b6bec20bc2a$var$Recognizer {
        constructor(){
            this._listeners = [
                $e5mHr.ConsoleErrorListener.INSTANCE
            ];
            this._stateNumber = -1;
        }
        getTokenTypeMap() {
            let vocabulary = this.vocabulary;
            let result = $efef7b6bec20bc2a$var$Recognizer.tokenTypeMapCache.get(vocabulary);
            if (result == null) {
                let intermediateResult = new Map();
                for(let i = 0; i <= this.atn.maxTokenType; i++){
                    let literalName = vocabulary.getLiteralName(i);
                    if (literalName != null) intermediateResult.set(literalName, i);
                    let symbolicName = vocabulary.getSymbolicName(i);
                    if (symbolicName != null) intermediateResult.set(symbolicName, i);
                }
                intermediateResult.set("EOF", $2DVsz.Token.EOF);
                result = intermediateResult;
                $efef7b6bec20bc2a$var$Recognizer.tokenTypeMapCache.set(vocabulary, result);
            }
            return result;
        }
        getRuleIndexMap() {
            let ruleNames = this.ruleNames;
            if (ruleNames == null) throw new Error("The current recognizer does not provide a list of rule names.");
            let result = $efef7b6bec20bc2a$var$Recognizer.ruleIndexMapCache.get(ruleNames);
            if (result == null) {
                result = $2IEP9.toMap(ruleNames);
                $efef7b6bec20bc2a$var$Recognizer.ruleIndexMapCache.set(ruleNames, result);
            }
            return result;
        }
        getTokenType(tokenName) {
            let ttype = this.getTokenTypeMap().get(tokenName);
            if (ttype != null) return ttype;
            return $2DVsz.Token.INVALID_TYPE;
        }
        get serializedATN() {
            throw new Error("there is no serialized ATN");
        }
        get atn() {
            return this._interp.atn;
        }
        get interpreter() {
            return this._interp;
        }
        set interpreter(interpreter) {
            this._interp = interpreter;
        }
        get parseInfo() {
            return Promise.resolve(undefined);
        }
        getErrorHeader(e) {
            let token = e.getOffendingToken();
            if (!token) return "";
            let line = token.line;
            let charPositionInLine = token.charPositionInLine;
            return "line " + line + ":" + charPositionInLine;
        }
        addErrorListener(listener) {
            if (!listener) throw new TypeError("listener must not be null");
            this._listeners.push(listener);
        }
        removeErrorListener(listener) {
            let position = this._listeners.indexOf(listener);
            if (position !== -1) this._listeners.splice(position, 1);
        }
        removeErrorListeners() {
            this._listeners.length = 0;
        }
        getErrorListeners() {
            return this._listeners.slice(0);
        }
        getErrorListenerDispatch() {
            return new $65iNZ.ProxyErrorListener(this.getErrorListeners());
        }
        sempred(_localctx, ruleIndex, actionIndex) {
            return true;
        }
        precpred(localctx, precedence) {
            return true;
        }
        action(_localctx, ruleIndex, actionIndex) {}
        get state() {
            return this._stateNumber;
        }
        set state(atnState) {
            this._stateNumber = atnState;
        }
    }
    $efef7b6bec20bc2a$var$Recognizer.EOF = -1;
    $efef7b6bec20bc2a$var$Recognizer.tokenTypeMapCache = new WeakMap();
    $efef7b6bec20bc2a$var$Recognizer.ruleIndexMapCache = new WeakMap();
    $efef7b6bec20bc2a$var$__decorate([
        $d6D31.SuppressWarnings("serial"),
        $d6D31.NotNull
    ], $efef7b6bec20bc2a$var$Recognizer.prototype, "_listeners", void 0);
    $efef7b6bec20bc2a$var$__decorate([
        $d6D31.NotNull
    ], $efef7b6bec20bc2a$var$Recognizer.prototype, "getTokenTypeMap", null);
    $efef7b6bec20bc2a$var$__decorate([
        $d6D31.NotNull
    ], $efef7b6bec20bc2a$var$Recognizer.prototype, "getRuleIndexMap", null);
    $efef7b6bec20bc2a$var$__decorate([
        $d6D31.NotNull
    ], $efef7b6bec20bc2a$var$Recognizer.prototype, "serializedATN", null);
    $efef7b6bec20bc2a$var$__decorate([
        $d6D31.NotNull
    ], $efef7b6bec20bc2a$var$Recognizer.prototype, "atn", null);
    $efef7b6bec20bc2a$var$__decorate([
        $d6D31.NotNull,
        $efef7b6bec20bc2a$var$__param(0, $d6D31.NotNull)
    ], $efef7b6bec20bc2a$var$Recognizer.prototype, "interpreter", null);
    $efef7b6bec20bc2a$var$__decorate([
        $d6D31.NotNull,
        $efef7b6bec20bc2a$var$__param(0, $d6D31.NotNull)
    ], $efef7b6bec20bc2a$var$Recognizer.prototype, "getErrorHeader", null);
    $efef7b6bec20bc2a$var$__decorate([
        $efef7b6bec20bc2a$var$__param(0, $d6D31.NotNull)
    ], $efef7b6bec20bc2a$var$Recognizer.prototype, "addErrorListener", null);
    $efef7b6bec20bc2a$var$__decorate([
        $efef7b6bec20bc2a$var$__param(0, $d6D31.NotNull)
    ], $efef7b6bec20bc2a$var$Recognizer.prototype, "removeErrorListener", null);
    $efef7b6bec20bc2a$var$__decorate([
        $d6D31.NotNull
    ], $efef7b6bec20bc2a$var$Recognizer.prototype, "getErrorListeners", null);
    module.exports.Recognizer = $efef7b6bec20bc2a$var$Recognizer;
});
parcelRegister("e5mHr", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ConsoleErrorListener = void 0;
    class $a413240156cc2e50$var$ConsoleErrorListener {
        syntaxError(recognizer, offendingSymbol, line, charPositionInLine, msg, e) {
            console.error(`line ${line}:${charPositionInLine} ${msg}`);
        }
    }
    module.exports.ConsoleErrorListener = $a413240156cc2e50$var$ConsoleErrorListener;
    $a413240156cc2e50$var$ConsoleErrorListener.INSTANCE = new $a413240156cc2e50$var$ConsoleErrorListener();
});
parcelRegister("65iNZ", function(module, exports) {
    "use strict";
    var $46e1cc07c7f5b3d6$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $46e1cc07c7f5b3d6$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ProxyErrorListener = void 0;
    var $d6D31 = parcelRequire("d6D31");
    class $46e1cc07c7f5b3d6$var$ProxyErrorListener {
        constructor(delegates){
            this.delegates = delegates;
            if (!delegates) throw new Error("Invalid delegates");
        }
        getDelegates() {
            return this.delegates;
        }
        syntaxError(recognizer, offendingSymbol, line, charPositionInLine, msg, e) {
            this.delegates.forEach((listener)=>{
                if (listener.syntaxError) listener.syntaxError(recognizer, offendingSymbol, line, charPositionInLine, msg, e);
            });
        }
    }
    $46e1cc07c7f5b3d6$var$__decorate([
        $d6D31.Override,
        $46e1cc07c7f5b3d6$var$__param(0, $d6D31.NotNull),
        $46e1cc07c7f5b3d6$var$__param(4, $d6D31.NotNull)
    ], $46e1cc07c7f5b3d6$var$ProxyErrorListener.prototype, "syntaxError", null);
    module.exports.ProxyErrorListener = $46e1cc07c7f5b3d6$var$ProxyErrorListener;
});
parcelRegister("3n2FE", function(module, exports) {
    "use strict";
    var $27459777e7d4e735$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.VocabularyImpl = void 0;
    var $d6D31 = parcelRequire("d6D31");
    var $2DVsz = parcelRequire("2DVsz");
    class $27459777e7d4e735$var$VocabularyImpl {
        constructor(literalNames, symbolicNames, displayNames){
            this.literalNames = literalNames;
            this.symbolicNames = symbolicNames;
            this.displayNames = displayNames;
            this._maxTokenType = Math.max(this.displayNames.length, Math.max(this.literalNames.length, this.symbolicNames.length)) - 1;
        }
        get maxTokenType() {
            return this._maxTokenType;
        }
        getLiteralName(tokenType) {
            if (tokenType >= 0 && tokenType < this.literalNames.length) return this.literalNames[tokenType];
            return undefined;
        }
        getSymbolicName(tokenType) {
            if (tokenType >= 0 && tokenType < this.symbolicNames.length) return this.symbolicNames[tokenType];
            if (tokenType === $2DVsz.Token.EOF) return "EOF";
            return undefined;
        }
        getDisplayName(tokenType) {
            if (tokenType >= 0 && tokenType < this.displayNames.length) {
                let displayName = this.displayNames[tokenType];
                if (displayName) return displayName;
            }
            let literalName = this.getLiteralName(tokenType);
            if (literalName) return literalName;
            let symbolicName = this.getSymbolicName(tokenType);
            if (symbolicName) return symbolicName;
            return String(tokenType);
        }
    }
    $27459777e7d4e735$var$VocabularyImpl.EMPTY_VOCABULARY = new $27459777e7d4e735$var$VocabularyImpl([], [], []);
    $27459777e7d4e735$var$__decorate([
        $d6D31.NotNull
    ], $27459777e7d4e735$var$VocabularyImpl.prototype, "literalNames", void 0);
    $27459777e7d4e735$var$__decorate([
        $d6D31.NotNull
    ], $27459777e7d4e735$var$VocabularyImpl.prototype, "symbolicNames", void 0);
    $27459777e7d4e735$var$__decorate([
        $d6D31.NotNull
    ], $27459777e7d4e735$var$VocabularyImpl.prototype, "displayNames", void 0);
    $27459777e7d4e735$var$__decorate([
        $d6D31.Override
    ], $27459777e7d4e735$var$VocabularyImpl.prototype, "maxTokenType", null);
    $27459777e7d4e735$var$__decorate([
        $d6D31.Override
    ], $27459777e7d4e735$var$VocabularyImpl.prototype, "getLiteralName", null);
    $27459777e7d4e735$var$__decorate([
        $d6D31.Override
    ], $27459777e7d4e735$var$VocabularyImpl.prototype, "getSymbolicName", null);
    $27459777e7d4e735$var$__decorate([
        $d6D31.Override,
        $d6D31.NotNull
    ], $27459777e7d4e735$var$VocabularyImpl.prototype, "getDisplayName", null);
    $27459777e7d4e735$var$__decorate([
        $d6D31.NotNull
    ], $27459777e7d4e735$var$VocabularyImpl, "EMPTY_VOCABULARY", void 0);
    module.exports.VocabularyImpl = $27459777e7d4e735$var$VocabularyImpl;
});
parcelRegister("aeRGo", function(module, exports) {
    "use strict";
    var $7744da7bed4bb192$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $7744da7bed4bb192$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.LexerDFASerializer = void 0;
    var $yhTtv = parcelRequire("yhTtv");
    var $d6D31 = parcelRequire("d6D31");
    var $3n2FE = parcelRequire("3n2FE");
    let $7744da7bed4bb192$var$LexerDFASerializer = class LexerDFASerializer extends $yhTtv.DFASerializer {
        constructor(dfa){
            super(dfa, $3n2FE.VocabularyImpl.EMPTY_VOCABULARY);
        }
        getEdgeLabel(i) {
            return "'" + String.fromCodePoint(i) + "'";
        }
    };
    $7744da7bed4bb192$var$__decorate([
        $d6D31.Override,
        $d6D31.NotNull
    ], $7744da7bed4bb192$var$LexerDFASerializer.prototype, "getEdgeLabel", null);
    $7744da7bed4bb192$var$LexerDFASerializer = $7744da7bed4bb192$var$__decorate([
        $7744da7bed4bb192$var$__param(0, $d6D31.NotNull)
    ], $7744da7bed4bb192$var$LexerDFASerializer);
    module.exports.LexerDFASerializer = $7744da7bed4bb192$var$LexerDFASerializer;
});
parcelRegister("f9raX", function(module, exports) {
    "use strict";
    var $b07cc6cfd56668a7$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.StarLoopEntryState = void 0;
    var $1bs3X = parcelRequire("1bs3X");
    var $5BPMp = parcelRequire("5BPMp");
    var $dPYn6 = parcelRequire("dPYn6");
    var $d6D31 = parcelRequire("d6D31");
    class $b07cc6cfd56668a7$var$StarLoopEntryState extends $dPYn6.DecisionState {
        constructor(){
            super(...arguments);
            this.precedenceRuleDecision = false;
            this.precedenceLoopbackStates = new $5BPMp.BitSet();
        }
        get stateType() {
            return $1bs3X.ATNStateType.STAR_LOOP_ENTRY;
        }
    }
    $b07cc6cfd56668a7$var$__decorate([
        $d6D31.Override
    ], $b07cc6cfd56668a7$var$StarLoopEntryState.prototype, "stateType", null);
    module.exports.StarLoopEntryState = $b07cc6cfd56668a7$var$StarLoopEntryState;
});
parcelRegister("l4Nh1", function(module, exports) {
    "use strict";
    var $f580316b3d8851ef$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.InvalidState = void 0;
    var $1bs3X = parcelRequire("1bs3X");
    var $4yiuQ = parcelRequire("4yiuQ");
    var $d6D31 = parcelRequire("d6D31");
    class $f580316b3d8851ef$var$InvalidState extends $4yiuQ.BasicState {
        get stateType() {
            return $1bs3X.ATNStateType.INVALID_TYPE;
        }
    }
    $f580316b3d8851ef$var$__decorate([
        $d6D31.Override
    ], $f580316b3d8851ef$var$InvalidState.prototype, "stateType", null);
    module.exports.InvalidState = $f580316b3d8851ef$var$InvalidState;
});
parcelRegister("4yiuQ", function(module, exports) {
    "use strict";
    var $3508af691e74fe3f$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.BasicState = void 0;
    var $7j0Pc = parcelRequire("7j0Pc");
    var $1bs3X = parcelRequire("1bs3X");
    var $d6D31 = parcelRequire("d6D31");
    class $3508af691e74fe3f$var$BasicState extends $7j0Pc.ATNState {
        get stateType() {
            return $1bs3X.ATNStateType.BASIC;
        }
    }
    $3508af691e74fe3f$var$__decorate([
        $d6D31.Override
    ], $3508af691e74fe3f$var$BasicState.prototype, "stateType", null);
    module.exports.BasicState = $3508af691e74fe3f$var$BasicState;
});
parcelRegister("iiE1V", function(module, exports) {
    "use strict";
    var $d528f592a4fe7f4e$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $d528f592a4fe7f4e$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.LL1Analyzer = void 0;
    var $fMVaR = parcelRequire("fMVaR");
    var $7Veax = parcelRequire("7Veax");
    var $gcX0f = parcelRequire("gcX0f");
    var $5BPMp = parcelRequire("5BPMp");
    var $hGRod = parcelRequire("hGRod");
    var $d6D31 = parcelRequire("d6D31");
    var $FLEKS = parcelRequire("FLEKS");
    var $a4Flx = parcelRequire("a4Flx");
    var $8DTT0 = parcelRequire("8DTT0");
    var $4kGBm = parcelRequire("4kGBm");
    var $aybFP = parcelRequire("aybFP");
    var $2DVsz = parcelRequire("2DVsz");
    var $aPmi9 = parcelRequire("aPmi9");
    let $d528f592a4fe7f4e$var$LL1Analyzer = class LL1Analyzer {
        constructor(atn){
            this.atn = atn;
        }
        getDecisionLookahead(s) {
            if (s == null) return undefined;
            let look = new Array(s.numberOfTransitions);
            for(let alt = 0; alt < s.numberOfTransitions; alt++){
                let current = new $hGRod.IntervalSet();
                look[alt] = current;
                let lookBusy = new $7Veax.Array2DHashSet($a4Flx.ObjectEqualityComparator.INSTANCE);
                let seeThruPreds = false;
                this._LOOK(s.transition(alt).target, undefined, $8DTT0.PredictionContext.EMPTY_LOCAL, current, lookBusy, new $5BPMp.BitSet(), seeThruPreds, false);
                if (current.size === 0 || current.contains(LL1Analyzer.HIT_PRED)) {
                    current = undefined;
                    look[alt] = current;
                }
            }
            return look;
        }
        LOOK(s, ctx, stopState) {
            if (stopState === undefined) {
                if (s.atn == null) throw new Error("Illegal state");
                stopState = s.atn.ruleToStopState[s.ruleIndex];
            } else if (stopState === null) stopState = undefined;
            let r = new $hGRod.IntervalSet();
            let seeThruPreds = true;
            let addEOF = true;
            this._LOOK(s, stopState, ctx, r, new $7Veax.Array2DHashSet(), new $5BPMp.BitSet(), seeThruPreds, addEOF);
            return r;
        }
        _LOOK(s, stopState, ctx, look, lookBusy, calledRuleStack, seeThruPreds, addEOF) {
            let c = $gcX0f.ATNConfig.create(s, 0, ctx);
            if (!lookBusy.add(c)) return;
            if (s === stopState) {
                if ($8DTT0.PredictionContext.isEmptyLocal(ctx)) {
                    look.add($2DVsz.Token.EPSILON);
                    return;
                } else if (ctx.isEmpty) {
                    if (addEOF) look.add($2DVsz.Token.EOF);
                    return;
                }
            }
            if (s instanceof $4kGBm.RuleStopState) {
                if (ctx.isEmpty && !$8DTT0.PredictionContext.isEmptyLocal(ctx)) {
                    if (addEOF) look.add($2DVsz.Token.EOF);
                    return;
                }
                let removed = calledRuleStack.get(s.ruleIndex);
                try {
                    calledRuleStack.clear(s.ruleIndex);
                    for(let i = 0; i < ctx.size; i++){
                        if (ctx.getReturnState(i) === $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY) continue;
                        let returnState = this.atn.states[ctx.getReturnState(i)];
                        this._LOOK(returnState, stopState, ctx.getParent(i), look, lookBusy, calledRuleStack, seeThruPreds, addEOF);
                    }
                } finally{
                    if (removed) calledRuleStack.set(s.ruleIndex);
                }
            }
            let n = s.numberOfTransitions;
            for(let i = 0; i < n; i++){
                let t = s.transition(i);
                if (t instanceof $aybFP.RuleTransition) {
                    if (calledRuleStack.get(t.ruleIndex)) continue;
                    let newContext = ctx.getChild(t.followState.stateNumber);
                    try {
                        calledRuleStack.set(t.ruleIndex);
                        this._LOOK(t.target, stopState, newContext, look, lookBusy, calledRuleStack, seeThruPreds, addEOF);
                    } finally{
                        calledRuleStack.clear(t.ruleIndex);
                    }
                } else if (t instanceof $fMVaR.AbstractPredicateTransition) {
                    if (seeThruPreds) this._LOOK(t.target, stopState, ctx, look, lookBusy, calledRuleStack, seeThruPreds, addEOF);
                    else look.add(LL1Analyzer.HIT_PRED);
                } else if (t.isEpsilon) this._LOOK(t.target, stopState, ctx, look, lookBusy, calledRuleStack, seeThruPreds, addEOF);
                else if (t instanceof $aPmi9.WildcardTransition) look.addAll($hGRod.IntervalSet.of($2DVsz.Token.MIN_USER_TOKEN_TYPE, this.atn.maxTokenType));
                else {
                    let set = t.label;
                    if (set != null) {
                        if (t instanceof $FLEKS.NotSetTransition) set = set.complement($hGRod.IntervalSet.of($2DVsz.Token.MIN_USER_TOKEN_TYPE, this.atn.maxTokenType));
                        look.addAll(set);
                    }
                }
            }
        }
    };
    $d528f592a4fe7f4e$var$LL1Analyzer.HIT_PRED = $2DVsz.Token.INVALID_TYPE;
    $d528f592a4fe7f4e$var$__decorate([
        $d6D31.NotNull
    ], $d528f592a4fe7f4e$var$LL1Analyzer.prototype, "atn", void 0);
    $d528f592a4fe7f4e$var$__decorate([
        $d6D31.NotNull,
        $d528f592a4fe7f4e$var$__param(0, $d6D31.NotNull),
        $d528f592a4fe7f4e$var$__param(1, $d6D31.NotNull)
    ], $d528f592a4fe7f4e$var$LL1Analyzer.prototype, "LOOK", null);
    $d528f592a4fe7f4e$var$__decorate([
        $d528f592a4fe7f4e$var$__param(0, $d6D31.NotNull),
        $d528f592a4fe7f4e$var$__param(2, $d6D31.NotNull),
        $d528f592a4fe7f4e$var$__param(3, $d6D31.NotNull),
        $d528f592a4fe7f4e$var$__param(4, $d6D31.NotNull),
        $d528f592a4fe7f4e$var$__param(5, $d6D31.NotNull)
    ], $d528f592a4fe7f4e$var$LL1Analyzer.prototype, "_LOOK", null);
    $d528f592a4fe7f4e$var$LL1Analyzer = $d528f592a4fe7f4e$var$__decorate([
        $d528f592a4fe7f4e$var$__param(0, $d6D31.NotNull)
    ], $d528f592a4fe7f4e$var$LL1Analyzer);
    module.exports.LL1Analyzer = $d528f592a4fe7f4e$var$LL1Analyzer;
});
parcelRegister("FLEKS", function(module, exports) {
    "use strict";
    var $07d8cc01972b24a7$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $07d8cc01972b24a7$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.NotSetTransition = void 0;
    var $d6D31 = parcelRequire("d6D31");
    var $Np2R3 = parcelRequire("Np2R3");
    let $07d8cc01972b24a7$var$NotSetTransition = class NotSetTransition extends $Np2R3.SetTransition {
        constructor(target, set){
            super(target, set);
        }
        get serializationType() {
            return 8;
        }
        matches(symbol, minVocabSymbol, maxVocabSymbol) {
            return symbol >= minVocabSymbol && symbol <= maxVocabSymbol && !super.matches(symbol, minVocabSymbol, maxVocabSymbol);
        }
        toString() {
            return "~" + super.toString();
        }
    };
    $07d8cc01972b24a7$var$__decorate([
        $d6D31.Override
    ], $07d8cc01972b24a7$var$NotSetTransition.prototype, "serializationType", null);
    $07d8cc01972b24a7$var$__decorate([
        $d6D31.Override
    ], $07d8cc01972b24a7$var$NotSetTransition.prototype, "matches", null);
    $07d8cc01972b24a7$var$__decorate([
        $d6D31.Override
    ], $07d8cc01972b24a7$var$NotSetTransition.prototype, "toString", null);
    $07d8cc01972b24a7$var$NotSetTransition = $07d8cc01972b24a7$var$__decorate([
        $07d8cc01972b24a7$var$__param(0, $d6D31.NotNull),
        $07d8cc01972b24a7$var$__param(1, $d6D31.Nullable)
    ], $07d8cc01972b24a7$var$NotSetTransition);
    module.exports.NotSetTransition = $07d8cc01972b24a7$var$NotSetTransition;
});
parcelRegister("Np2R3", function(module, exports) {
    "use strict";
    var $094801244c2d1a04$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $094801244c2d1a04$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.SetTransition = void 0;
    var $hGRod = parcelRequire("hGRod");
    var $d6D31 = parcelRequire("d6D31");
    var $2DVsz = parcelRequire("2DVsz");
    var $5tcOQ = parcelRequire("5tcOQ");
    let $094801244c2d1a04$var$SetTransition = class SetTransition extends $5tcOQ.Transition {
        constructor(target, set){
            super(target);
            if (set == null) set = $hGRod.IntervalSet.of($2DVsz.Token.INVALID_TYPE);
            this.set = set;
        }
        get serializationType() {
            return 7;
        }
        get label() {
            return this.set;
        }
        matches(symbol, minVocabSymbol, maxVocabSymbol) {
            return this.set.contains(symbol);
        }
        toString() {
            return this.set.toString();
        }
    };
    $094801244c2d1a04$var$__decorate([
        $d6D31.NotNull
    ], $094801244c2d1a04$var$SetTransition.prototype, "set", void 0);
    $094801244c2d1a04$var$__decorate([
        $d6D31.Override
    ], $094801244c2d1a04$var$SetTransition.prototype, "serializationType", null);
    $094801244c2d1a04$var$__decorate([
        $d6D31.Override,
        $d6D31.NotNull
    ], $094801244c2d1a04$var$SetTransition.prototype, "label", null);
    $094801244c2d1a04$var$__decorate([
        $d6D31.Override
    ], $094801244c2d1a04$var$SetTransition.prototype, "matches", null);
    $094801244c2d1a04$var$__decorate([
        $d6D31.Override,
        $d6D31.NotNull
    ], $094801244c2d1a04$var$SetTransition.prototype, "toString", null);
    $094801244c2d1a04$var$SetTransition = $094801244c2d1a04$var$__decorate([
        $094801244c2d1a04$var$__param(0, $d6D31.NotNull),
        $094801244c2d1a04$var$__param(1, $d6D31.Nullable)
    ], $094801244c2d1a04$var$SetTransition);
    module.exports.SetTransition = $094801244c2d1a04$var$SetTransition;
});
parcelRegister("4kGBm", function(module, exports) {
    "use strict";
    var $327a1377d5873c46$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.RuleStopState = void 0;
    var $7j0Pc = parcelRequire("7j0Pc");
    var $1bs3X = parcelRequire("1bs3X");
    var $d6D31 = parcelRequire("d6D31");
    class $327a1377d5873c46$var$RuleStopState extends $7j0Pc.ATNState {
        get nonStopStateNumber() {
            return -1;
        }
        get stateType() {
            return $1bs3X.ATNStateType.RULE_STOP;
        }
    }
    $327a1377d5873c46$var$__decorate([
        $d6D31.Override
    ], $327a1377d5873c46$var$RuleStopState.prototype, "nonStopStateNumber", null);
    $327a1377d5873c46$var$__decorate([
        $d6D31.Override
    ], $327a1377d5873c46$var$RuleStopState.prototype, "stateType", null);
    module.exports.RuleStopState = $327a1377d5873c46$var$RuleStopState;
});
parcelRegister("aybFP", function(module, exports) {
    "use strict";
    var $7ae622834621fa3c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $7ae622834621fa3c$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.RuleTransition = void 0;
    var $d6D31 = parcelRequire("d6D31");
    var $5tcOQ = parcelRequire("5tcOQ");
    let $7ae622834621fa3c$var$RuleTransition = class RuleTransition extends $5tcOQ.Transition {
        constructor(ruleStart, ruleIndex, precedence, followState){
            super(ruleStart);
            this.tailCall = false;
            this.optimizedTailCall = false;
            this.ruleIndex = ruleIndex;
            this.precedence = precedence;
            this.followState = followState;
        }
        get serializationType() {
            return 3;
        }
        get isEpsilon() {
            return true;
        }
        matches(symbol, minVocabSymbol, maxVocabSymbol) {
            return false;
        }
    };
    $7ae622834621fa3c$var$__decorate([
        $d6D31.NotNull
    ], $7ae622834621fa3c$var$RuleTransition.prototype, "followState", void 0);
    $7ae622834621fa3c$var$__decorate([
        $d6D31.Override
    ], $7ae622834621fa3c$var$RuleTransition.prototype, "serializationType", null);
    $7ae622834621fa3c$var$__decorate([
        $d6D31.Override
    ], $7ae622834621fa3c$var$RuleTransition.prototype, "isEpsilon", null);
    $7ae622834621fa3c$var$__decorate([
        $d6D31.Override
    ], $7ae622834621fa3c$var$RuleTransition.prototype, "matches", null);
    $7ae622834621fa3c$var$RuleTransition = $7ae622834621fa3c$var$__decorate([
        $7ae622834621fa3c$var$__param(0, $d6D31.NotNull),
        $7ae622834621fa3c$var$__param(3, $d6D31.NotNull)
    ], $7ae622834621fa3c$var$RuleTransition);
    module.exports.RuleTransition = $7ae622834621fa3c$var$RuleTransition;
});
parcelRegister("aPmi9", function(module, exports) {
    "use strict";
    var $7e1ff581bbf7382f$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $7e1ff581bbf7382f$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.WildcardTransition = void 0;
    var $d6D31 = parcelRequire("d6D31");
    var $5tcOQ = parcelRequire("5tcOQ");
    let $7e1ff581bbf7382f$var$WildcardTransition = class WildcardTransition extends $5tcOQ.Transition {
        constructor(target){
            super(target);
        }
        get serializationType() {
            return 9;
        }
        matches(symbol, minVocabSymbol, maxVocabSymbol) {
            return symbol >= minVocabSymbol && symbol <= maxVocabSymbol;
        }
        toString() {
            return ".";
        }
    };
    $7e1ff581bbf7382f$var$__decorate([
        $d6D31.Override
    ], $7e1ff581bbf7382f$var$WildcardTransition.prototype, "serializationType", null);
    $7e1ff581bbf7382f$var$__decorate([
        $d6D31.Override
    ], $7e1ff581bbf7382f$var$WildcardTransition.prototype, "matches", null);
    $7e1ff581bbf7382f$var$__decorate([
        $d6D31.Override,
        $d6D31.NotNull
    ], $7e1ff581bbf7382f$var$WildcardTransition.prototype, "toString", null);
    $7e1ff581bbf7382f$var$WildcardTransition = $7e1ff581bbf7382f$var$__decorate([
        $7e1ff581bbf7382f$var$__param(0, $d6D31.NotNull)
    ], $7e1ff581bbf7382f$var$WildcardTransition);
    module.exports.WildcardTransition = $7e1ff581bbf7382f$var$WildcardTransition;
});
parcelRegister("3AYVu", function(module, exports) {
    "use strict";
    var $29e3fe8db7459e78$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $29e3fe8db7459e78$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.LexerActionExecutor = void 0;
    var $3sNxf = parcelRequire("3sNxf");
    var $4LVXs = parcelRequire("4LVXs");
    var $iXFjm = parcelRequire("iXFjm");
    var $d6D31 = parcelRequire("d6D31");
    let $29e3fe8db7459e78$var$LexerActionExecutor = class LexerActionExecutor {
        constructor(lexerActions){
            this._lexerActions = lexerActions;
            let hash = $iXFjm.MurmurHash.initialize();
            for (let lexerAction of lexerActions)hash = $iXFjm.MurmurHash.update(hash, lexerAction);
            this.cachedHashCode = $iXFjm.MurmurHash.finish(hash, lexerActions.length);
        }
        static append(lexerActionExecutor, lexerAction) {
            if (!lexerActionExecutor) return new LexerActionExecutor([
                lexerAction
            ]);
            let lexerActions = lexerActionExecutor._lexerActions.slice(0);
            lexerActions.push(lexerAction);
            return new LexerActionExecutor(lexerActions);
        }
        fixOffsetBeforeMatch(offset) {
            let updatedLexerActions;
            for(let i = 0; i < this._lexerActions.length; i++)if (this._lexerActions[i].isPositionDependent && !(this._lexerActions[i] instanceof $4LVXs.LexerIndexedCustomAction)) {
                if (!updatedLexerActions) updatedLexerActions = this._lexerActions.slice(0);
                updatedLexerActions[i] = new $4LVXs.LexerIndexedCustomAction(offset, this._lexerActions[i]);
            }
            if (!updatedLexerActions) return this;
            return new LexerActionExecutor(updatedLexerActions);
        }
        get lexerActions() {
            return this._lexerActions;
        }
        execute(lexer, input, startIndex) {
            let requiresSeek = false;
            let stopIndex = input.index;
            try {
                for (let lexerAction of this._lexerActions){
                    if (lexerAction instanceof $4LVXs.LexerIndexedCustomAction) {
                        let offset = lexerAction.offset;
                        input.seek(startIndex + offset);
                        lexerAction = lexerAction.action;
                        requiresSeek = startIndex + offset !== stopIndex;
                    } else if (lexerAction.isPositionDependent) {
                        input.seek(stopIndex);
                        requiresSeek = false;
                    }
                    lexerAction.execute(lexer);
                }
            } finally{
                if (requiresSeek) input.seek(stopIndex);
            }
        }
        hashCode() {
            return this.cachedHashCode;
        }
        equals(obj) {
            if (obj === this) return true;
            else if (!(obj instanceof LexerActionExecutor)) return false;
            return this.cachedHashCode === obj.cachedHashCode && $3sNxf.ArrayEqualityComparator.INSTANCE.equals(this._lexerActions, obj._lexerActions);
        }
    };
    $29e3fe8db7459e78$var$__decorate([
        $d6D31.NotNull
    ], $29e3fe8db7459e78$var$LexerActionExecutor.prototype, "_lexerActions", void 0);
    $29e3fe8db7459e78$var$__decorate([
        $d6D31.NotNull
    ], $29e3fe8db7459e78$var$LexerActionExecutor.prototype, "lexerActions", null);
    $29e3fe8db7459e78$var$__decorate([
        $29e3fe8db7459e78$var$__param(0, $d6D31.NotNull)
    ], $29e3fe8db7459e78$var$LexerActionExecutor.prototype, "execute", null);
    $29e3fe8db7459e78$var$__decorate([
        $d6D31.Override
    ], $29e3fe8db7459e78$var$LexerActionExecutor.prototype, "hashCode", null);
    $29e3fe8db7459e78$var$__decorate([
        $d6D31.Override
    ], $29e3fe8db7459e78$var$LexerActionExecutor.prototype, "equals", null);
    $29e3fe8db7459e78$var$__decorate([
        $d6D31.NotNull,
        $29e3fe8db7459e78$var$__param(1, $d6D31.NotNull)
    ], $29e3fe8db7459e78$var$LexerActionExecutor, "append", null);
    $29e3fe8db7459e78$var$LexerActionExecutor = $29e3fe8db7459e78$var$__decorate([
        $29e3fe8db7459e78$var$__param(0, $d6D31.NotNull)
    ], $29e3fe8db7459e78$var$LexerActionExecutor);
    module.exports.LexerActionExecutor = $29e3fe8db7459e78$var$LexerActionExecutor;
});
parcelRegister("4LVXs", function(module, exports) {
    "use strict";
    var $3798827adeb28bf0$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $3798827adeb28bf0$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.LexerIndexedCustomAction = void 0;
    var $iXFjm = parcelRequire("iXFjm");
    var $d6D31 = parcelRequire("d6D31");
    let $3798827adeb28bf0$var$LexerIndexedCustomAction = class LexerIndexedCustomAction {
        constructor(offset, action){
            this._offset = offset;
            this._action = action;
        }
        get offset() {
            return this._offset;
        }
        get action() {
            return this._action;
        }
        get actionType() {
            return this._action.actionType;
        }
        get isPositionDependent() {
            return true;
        }
        execute(lexer) {
            this._action.execute(lexer);
        }
        hashCode() {
            let hash = $iXFjm.MurmurHash.initialize();
            hash = $iXFjm.MurmurHash.update(hash, this._offset);
            hash = $iXFjm.MurmurHash.update(hash, this._action);
            return $iXFjm.MurmurHash.finish(hash, 2);
        }
        equals(obj) {
            if (obj === this) return true;
            else if (!(obj instanceof LexerIndexedCustomAction)) return false;
            return this._offset === obj._offset && this._action.equals(obj._action);
        }
    };
    $3798827adeb28bf0$var$__decorate([
        $d6D31.NotNull
    ], $3798827adeb28bf0$var$LexerIndexedCustomAction.prototype, "action", null);
    $3798827adeb28bf0$var$__decorate([
        $d6D31.Override
    ], $3798827adeb28bf0$var$LexerIndexedCustomAction.prototype, "actionType", null);
    $3798827adeb28bf0$var$__decorate([
        $d6D31.Override
    ], $3798827adeb28bf0$var$LexerIndexedCustomAction.prototype, "isPositionDependent", null);
    $3798827adeb28bf0$var$__decorate([
        $d6D31.Override
    ], $3798827adeb28bf0$var$LexerIndexedCustomAction.prototype, "execute", null);
    $3798827adeb28bf0$var$__decorate([
        $d6D31.Override
    ], $3798827adeb28bf0$var$LexerIndexedCustomAction.prototype, "hashCode", null);
    $3798827adeb28bf0$var$__decorate([
        $d6D31.Override
    ], $3798827adeb28bf0$var$LexerIndexedCustomAction.prototype, "equals", null);
    $3798827adeb28bf0$var$LexerIndexedCustomAction = $3798827adeb28bf0$var$__decorate([
        $3798827adeb28bf0$var$__param(1, $d6D31.NotNull)
    ], $3798827adeb28bf0$var$LexerIndexedCustomAction);
    module.exports.LexerIndexedCustomAction = $3798827adeb28bf0$var$LexerIndexedCustomAction;
});
parcelRegister("fOEQQ", function(module, exports) {
    "use strict";
    var $b83b36c534666cfd$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $b83b36c534666cfd$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.LexerNoViableAltException = void 0;
    var $fLdDn = parcelRequire("fLdDn");
    var $d6D31 = parcelRequire("d6D31");
    var $gcfUE = parcelRequire("gcfUE");
    var $2IEP9 = parcelRequire("2IEP9");
    let $b83b36c534666cfd$var$LexerNoViableAltException = class LexerNoViableAltException extends $fLdDn.RecognitionException {
        constructor(lexer, input, startIndex, deadEndConfigs){
            super(lexer, input);
            this._startIndex = startIndex;
            this._deadEndConfigs = deadEndConfigs;
        }
        get startIndex() {
            return this._startIndex;
        }
        get deadEndConfigs() {
            return this._deadEndConfigs;
        }
        get inputStream() {
            return super.inputStream;
        }
        toString() {
            let symbol = "";
            if (this._startIndex >= 0 && this._startIndex < this.inputStream.size) {
                symbol = this.inputStream.getText($gcfUE.Interval.of(this._startIndex, this._startIndex));
                symbol = $2IEP9.escapeWhitespace(symbol, false);
            }
            return `LexerNoViableAltException('${symbol}')`;
        }
    };
    $b83b36c534666cfd$var$__decorate([
        $d6D31.Override
    ], $b83b36c534666cfd$var$LexerNoViableAltException.prototype, "inputStream", null);
    $b83b36c534666cfd$var$__decorate([
        $d6D31.Override
    ], $b83b36c534666cfd$var$LexerNoViableAltException.prototype, "toString", null);
    $b83b36c534666cfd$var$LexerNoViableAltException = $b83b36c534666cfd$var$__decorate([
        $b83b36c534666cfd$var$__param(1, $d6D31.NotNull)
    ], $b83b36c534666cfd$var$LexerNoViableAltException);
    module.exports.LexerNoViableAltException = $b83b36c534666cfd$var$LexerNoViableAltException;
});
parcelRegister("9tIYC", function(module, exports) {
    "use strict";
    var $6e69b5e962f238b8$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.OrderedATNConfigSet = void 0;
    var $c1ClW = parcelRequire("c1ClW");
    var $d6D31 = parcelRequire("d6D31");
    class $6e69b5e962f238b8$var$OrderedATNConfigSet extends $c1ClW.ATNConfigSet {
        constructor(set, readonly){
            if (set != null && readonly != null) super(set, readonly);
            else super();
        }
        clone(readonly) {
            let copy = new $6e69b5e962f238b8$var$OrderedATNConfigSet(this, readonly);
            if (!readonly && this.isReadOnly) copy.addAll(this);
            return copy;
        }
        getKey(e) {
            return {
                state: 0,
                alt: e.hashCode()
            };
        }
        canMerge(left, leftKey, right) {
            return left.equals(right);
        }
    }
    $6e69b5e962f238b8$var$__decorate([
        $d6D31.Override
    ], $6e69b5e962f238b8$var$OrderedATNConfigSet.prototype, "clone", null);
    $6e69b5e962f238b8$var$__decorate([
        $d6D31.Override
    ], $6e69b5e962f238b8$var$OrderedATNConfigSet.prototype, "getKey", null);
    $6e69b5e962f238b8$var$__decorate([
        $d6D31.Override
    ], $6e69b5e962f238b8$var$OrderedATNConfigSet.prototype, "canMerge", null);
    module.exports.OrderedATNConfigSet = $6e69b5e962f238b8$var$OrderedATNConfigSet;
});
parcelRegister("hKCjP", function(module, exports) {
    "use strict";
    var $cec474d99a10f341$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.NoViableAltException = void 0;
    var $jIG0W = parcelRequire("jIG0W");
    var $fLdDn = parcelRequire("fLdDn");
    var $d6D31 = parcelRequire("d6D31");
    class $cec474d99a10f341$var$NoViableAltException extends $fLdDn.RecognitionException {
        constructor(recognizer, input, startToken, offendingToken, deadEndConfigs, ctx){
            if (recognizer instanceof $jIG0W.Parser) {
                if (input === undefined) input = recognizer.inputStream;
                if (startToken === undefined) startToken = recognizer.currentToken;
                if (offendingToken === undefined) offendingToken = recognizer.currentToken;
                if (ctx === undefined) ctx = recognizer.context;
            }
            super(recognizer, input, ctx);
            this._deadEndConfigs = deadEndConfigs;
            this._startToken = startToken;
            this.setOffendingToken(recognizer, offendingToken);
        }
        get startToken() {
            return this._startToken;
        }
        get deadEndConfigs() {
            return this._deadEndConfigs;
        }
    }
    $cec474d99a10f341$var$__decorate([
        $d6D31.NotNull
    ], $cec474d99a10f341$var$NoViableAltException.prototype, "_startToken", void 0);
    module.exports.NoViableAltException = $cec474d99a10f341$var$NoViableAltException;
});
parcelRegister("jIG0W", function(module, exports) {
    var $6cAn5 = parcelRequire("6cAn5");
    "use strict";
    var $e5b2b780657df507$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $e5b2b780657df507$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    var $e5b2b780657df507$var$__awaiter = module.exports && module.exports.__awaiter || function(thisArg, _arguments, P, generator) {
        function adopt(value) {
            return value instanceof P ? value : new P(function(resolve) {
                resolve(value);
            });
        }
        return new (P || (P = Promise))(function(resolve, reject) {
            function fulfilled(value) {
                try {
                    step(generator.next(value));
                } catch (e) {
                    reject(e);
                }
            }
            function rejected(value) {
                try {
                    step(generator["throw"](value));
                } catch (e) {
                    reject(e);
                }
            }
            function step(result) {
                result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
            }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.Parser = void 0;
    var $2IEP9 = parcelRequire("2IEP9");
    var $2M2qJ = parcelRequire("2M2qJ");
    var $dvgsl = parcelRequire("dvgsl");
    var $4CCJj = parcelRequire("4CCJj");
    var $cdCft = parcelRequire("cdCft");
    var $6Kebn = parcelRequire("6Kebn");
    var $igNLf = parcelRequire("igNLf");
    var $d6D31 = parcelRequire("d6D31");
    var $3iOjI = parcelRequire("3iOjI");
    var $kzbnL = parcelRequire("kzbnL");
    var $5xwgp = parcelRequire("5xwgp");
    var $kBaAZ = parcelRequire("kBaAZ");
    var $kYC92 = parcelRequire("kYC92");
    var $2DVsz = parcelRequire("2DVsz");
    class $e5b2b780657df507$var$TraceListener {
        constructor(ruleNames, tokenStream){
            this.ruleNames = ruleNames;
            this.tokenStream = tokenStream;
        }
        enterEveryRule(ctx) {
            console.log("enter   " + this.ruleNames[ctx.ruleIndex] + ", LT(1)=" + this.tokenStream.LT(1).text);
        }
        exitEveryRule(ctx) {
            console.log("exit    " + this.ruleNames[ctx.ruleIndex] + ", LT(1)=" + this.tokenStream.LT(1).text);
        }
        visitErrorNode(node) {}
        visitTerminal(node) {
            let parent = node.parent.ruleContext;
            let token = node.symbol;
            console.log("consume " + token + " rule " + this.ruleNames[parent.ruleIndex]);
        }
    }
    $e5b2b780657df507$var$__decorate([
        $d6D31.Override
    ], $e5b2b780657df507$var$TraceListener.prototype, "enterEveryRule", null);
    $e5b2b780657df507$var$__decorate([
        $d6D31.Override
    ], $e5b2b780657df507$var$TraceListener.prototype, "exitEveryRule", null);
    $e5b2b780657df507$var$__decorate([
        $d6D31.Override
    ], $e5b2b780657df507$var$TraceListener.prototype, "visitErrorNode", null);
    $e5b2b780657df507$var$__decorate([
        $d6D31.Override
    ], $e5b2b780657df507$var$TraceListener.prototype, "visitTerminal", null);
    class $e5b2b780657df507$var$Parser extends $kBaAZ.Recognizer {
        constructor(input){
            super();
            this._errHandler = new $4CCJj.DefaultErrorStrategy();
            this._precedenceStack = new $6Kebn.IntegerStack();
            this._buildParseTrees = true;
            this._parseListeners = [];
            this._syntaxErrors = 0;
            this.matchedEOF = false;
            this._precedenceStack.push(0);
            this.inputStream = input;
        }
        reset(resetInput) {
            if (resetInput === undefined || resetInput) this.inputStream.seek(0);
            this._errHandler.reset(this);
            this._ctx = undefined;
            this._syntaxErrors = 0;
            this.matchedEOF = false;
            this.isTrace = false;
            this._precedenceStack.clear();
            this._precedenceStack.push(0);
            let interpreter = this.interpreter;
            if (interpreter != null) interpreter.reset();
        }
        match(ttype) {
            let t = this.currentToken;
            if (t.type === ttype) {
                if (ttype === $2DVsz.Token.EOF) this.matchedEOF = true;
                this._errHandler.reportMatch(this);
                this.consume();
            } else {
                t = this._errHandler.recoverInline(this);
                if (this._buildParseTrees && t.tokenIndex === -1) this._ctx.addErrorNode(this.createErrorNode(this._ctx, t));
            }
            return t;
        }
        matchWildcard() {
            let t = this.currentToken;
            if (t.type > 0) {
                this._errHandler.reportMatch(this);
                this.consume();
            } else {
                t = this._errHandler.recoverInline(this);
                if (this._buildParseTrees && t.tokenIndex === -1) this._ctx.addErrorNode(this.createErrorNode(this._ctx, t));
            }
            return t;
        }
        set buildParseTree(buildParseTrees) {
            this._buildParseTrees = buildParseTrees;
        }
        get buildParseTree() {
            return this._buildParseTrees;
        }
        getParseListeners() {
            return this._parseListeners;
        }
        addParseListener(listener) {
            if (listener == null) throw new TypeError("listener cannot be null");
            this._parseListeners.push(listener);
        }
        removeParseListener(listener) {
            let index = this._parseListeners.findIndex((l)=>l === listener);
            if (index !== -1) this._parseListeners.splice(index, 1);
        }
        removeParseListeners() {
            this._parseListeners.length = 0;
        }
        triggerEnterRuleEvent() {
            for (let listener of this._parseListeners){
                if (listener.enterEveryRule) listener.enterEveryRule(this._ctx);
                this._ctx.enterRule(listener);
            }
        }
        triggerExitRuleEvent() {
            for(let i = this._parseListeners.length - 1; i >= 0; i--){
                let listener = this._parseListeners[i];
                this._ctx.exitRule(listener);
                if (listener.exitEveryRule) listener.exitEveryRule(this._ctx);
            }
        }
        get numberOfSyntaxErrors() {
            return this._syntaxErrors;
        }
        get tokenFactory() {
            return this._input.tokenSource.tokenFactory;
        }
        getATNWithBypassAlts() {
            let serializedAtn = this.serializedATN;
            if (serializedAtn == null) throw new Error("The current parser does not support an ATN with bypass alternatives.");
            let result = $e5b2b780657df507$var$Parser.bypassAltsAtnCache.get(serializedAtn);
            if (result == null) {
                let deserializationOptions = new $2M2qJ.ATNDeserializationOptions();
                deserializationOptions.isGenerateRuleBypassTransitions = true;
                result = new $dvgsl.ATNDeserializer(deserializationOptions).deserialize($2IEP9.toCharArray(serializedAtn));
                $e5b2b780657df507$var$Parser.bypassAltsAtnCache.set(serializedAtn, result);
            }
            return result;
        }
        compileParseTreePattern(pattern, patternRuleIndex, lexer) {
            return $e5b2b780657df507$var$__awaiter(this, void 0, void 0, function*() {
                if (!lexer) {
                    if (this.inputStream) {
                        let tokenSource = this.inputStream.tokenSource;
                        if (tokenSource instanceof $igNLf.Lexer) lexer = tokenSource;
                    }
                    if (!lexer) throw new Error("Parser can't discover a lexer to use");
                }
                let currentLexer = lexer;
                let m = yield Promise.resolve().then(()=>(parcelRequire("dE6Cn")));
                let matcher = new m.ParseTreePatternMatcher(currentLexer, this);
                return matcher.compile(pattern, patternRuleIndex);
            });
        }
        get errorHandler() {
            return this._errHandler;
        }
        set errorHandler(handler) {
            this._errHandler = handler;
        }
        get inputStream() {
            return this._input;
        }
        set inputStream(input) {
            this.reset(false);
            this._input = input;
        }
        get currentToken() {
            return this._input.LT(1);
        }
        notifyErrorListeners(msg, offendingToken, e) {
            if (offendingToken === undefined) offendingToken = this.currentToken;
            else if (offendingToken === null) offendingToken = undefined;
            this._syntaxErrors++;
            let line = -1;
            let charPositionInLine = -1;
            if (offendingToken != null) {
                line = offendingToken.line;
                charPositionInLine = offendingToken.charPositionInLine;
            }
            let listener = this.getErrorListenerDispatch();
            if (listener.syntaxError) listener.syntaxError(this, offendingToken, line, charPositionInLine, msg, e);
        }
        consume() {
            let o = this.currentToken;
            if (o.type !== $e5b2b780657df507$var$Parser.EOF) this.inputStream.consume();
            let hasListener = this._parseListeners.length !== 0;
            if (this._buildParseTrees || hasListener) {
                if (this._errHandler.inErrorRecoveryMode(this)) {
                    let node = this._ctx.addErrorNode(this.createErrorNode(this._ctx, o));
                    if (hasListener) {
                        for (let listener of this._parseListeners)if (listener.visitErrorNode) listener.visitErrorNode(node);
                    }
                } else {
                    let node = this.createTerminalNode(this._ctx, o);
                    this._ctx.addChild(node);
                    if (hasListener) {
                        for (let listener of this._parseListeners)if (listener.visitTerminal) listener.visitTerminal(node);
                    }
                }
            }
            return o;
        }
        createTerminalNode(parent, t) {
            return new $kYC92.TerminalNode(t);
        }
        createErrorNode(parent, t) {
            return new $cdCft.ErrorNode(t);
        }
        addContextToParseTree() {
            let parent = this._ctx._parent;
            if (parent != null) parent.addChild(this._ctx);
        }
        enterRule(localctx, state, ruleIndex) {
            this.state = state;
            this._ctx = localctx;
            this._ctx._start = this._input.LT(1);
            if (this._buildParseTrees) this.addContextToParseTree();
            this.triggerEnterRuleEvent();
        }
        enterLeftFactoredRule(localctx, state, ruleIndex) {
            this.state = state;
            if (this._buildParseTrees) {
                let factoredContext = this._ctx.getChild(this._ctx.childCount - 1);
                this._ctx.removeLastChild();
                factoredContext._parent = localctx;
                localctx.addChild(factoredContext);
            }
            this._ctx = localctx;
            this._ctx._start = this._input.LT(1);
            if (this._buildParseTrees) this.addContextToParseTree();
            this.triggerEnterRuleEvent();
        }
        exitRule() {
            if (this.matchedEOF) this._ctx._stop = this._input.LT(1);
            else this._ctx._stop = this._input.tryLT(-1);
            this.triggerExitRuleEvent();
            this.state = this._ctx.invokingState;
            this._ctx = this._ctx._parent;
        }
        enterOuterAlt(localctx, altNum) {
            localctx.altNumber = altNum;
            if (this._buildParseTrees && this._ctx !== localctx) {
                let parent = this._ctx._parent;
                if (parent != null) {
                    parent.removeLastChild();
                    parent.addChild(localctx);
                }
            }
            this._ctx = localctx;
        }
        get precedence() {
            if (this._precedenceStack.isEmpty) return -1;
            return this._precedenceStack.peek();
        }
        enterRecursionRule(localctx, state, ruleIndex, precedence) {
            this.state = state;
            this._precedenceStack.push(precedence);
            this._ctx = localctx;
            this._ctx._start = this._input.LT(1);
            this.triggerEnterRuleEvent();
        }
        pushNewRecursionContext(localctx, state, ruleIndex) {
            let previous = this._ctx;
            previous._parent = localctx;
            previous.invokingState = state;
            previous._stop = this._input.tryLT(-1);
            this._ctx = localctx;
            this._ctx._start = previous._start;
            if (this._buildParseTrees) this._ctx.addChild(previous);
            this.triggerEnterRuleEvent();
        }
        unrollRecursionContexts(_parentctx) {
            this._precedenceStack.pop();
            this._ctx._stop = this._input.tryLT(-1);
            let retctx = this._ctx;
            if (this._parseListeners.length > 0) while(this._ctx !== _parentctx){
                this.triggerExitRuleEvent();
                this._ctx = this._ctx._parent;
            }
            else this._ctx = _parentctx;
            retctx._parent = _parentctx;
            if (this._buildParseTrees && _parentctx != null) _parentctx.addChild(retctx);
        }
        getInvokingContext(ruleIndex) {
            let p = this._ctx;
            while(p && p.ruleIndex !== ruleIndex)p = p._parent;
            return p;
        }
        get context() {
            return this._ctx;
        }
        set context(ctx) {
            this._ctx = ctx;
        }
        precpred(localctx, precedence) {
            return precedence >= this._precedenceStack.peek();
        }
        getErrorListenerDispatch() {
            return new $5xwgp.ProxyParserErrorListener(this.getErrorListeners());
        }
        inContext(context) {
            return false;
        }
        isExpectedToken(symbol) {
            let atn = this.interpreter.atn;
            let ctx = this._ctx;
            let s = atn.states[this.state];
            let following = atn.nextTokens(s);
            if (following.contains(symbol)) return true;
            if (!following.contains($2DVsz.Token.EPSILON)) return false;
            while(ctx != null && ctx.invokingState >= 0 && following.contains($2DVsz.Token.EPSILON)){
                let invokingState = atn.states[ctx.invokingState];
                let rt = invokingState.transition(0);
                following = atn.nextTokens(rt.followState);
                if (following.contains(symbol)) return true;
                ctx = ctx._parent;
            }
            if (following.contains($2DVsz.Token.EPSILON) && symbol === $2DVsz.Token.EOF) return true;
            return false;
        }
        get isMatchedEOF() {
            return this.matchedEOF;
        }
        getExpectedTokens() {
            return this.atn.getExpectedTokens(this.state, this.context);
        }
        getExpectedTokensWithinCurrentRule() {
            let atn = this.interpreter.atn;
            let s = atn.states[this.state];
            return atn.nextTokens(s);
        }
        getRuleIndex(ruleName) {
            let ruleIndex = this.getRuleIndexMap().get(ruleName);
            if (ruleIndex != null) return ruleIndex;
            return -1;
        }
        get ruleContext() {
            return this._ctx;
        }
        getRuleInvocationStack(ctx = this._ctx) {
            let p = ctx;
            let ruleNames = this.ruleNames;
            let stack = [];
            while(p != null){
                let ruleIndex = p.ruleIndex;
                if (ruleIndex < 0) stack.push("n/a");
                else stack.push(ruleNames[ruleIndex]);
                p = p._parent;
            }
            return stack;
        }
        getDFAStrings() {
            let s = [];
            for (let dfa of this._interp.atn.decisionToDFA)s.push(dfa.toString(this.vocabulary, this.ruleNames));
            return s;
        }
        dumpDFA() {
            let seenOne = false;
            for (let dfa of this._interp.atn.decisionToDFA)if (!dfa.isEmpty) {
                if (seenOne) console.log();
                console.log("Decision " + dfa.decision + ":");
                $6cAn5.stdout.write(dfa.toString(this.vocabulary, this.ruleNames));
                seenOne = true;
            }
        }
        get sourceName() {
            return this._input.sourceName;
        }
        get parseInfo() {
            return Promise.resolve().then(()=>(parcelRequire("kSEFX"))).then((m)=>{
                let interp = this.interpreter;
                if (interp instanceof m.ProfilingATNSimulator) return new $3iOjI.ParseInfo(interp);
                return undefined;
            });
        }
        setProfile(profile) {
            return $e5b2b780657df507$var$__awaiter(this, void 0, void 0, function*() {
                let m = yield Promise.resolve().then(()=>(parcelRequire("kSEFX")));
                let interp = this.interpreter;
                if (profile) {
                    if (!(interp instanceof m.ProfilingATNSimulator)) this.interpreter = new m.ProfilingATNSimulator(this);
                } else if (interp instanceof m.ProfilingATNSimulator) this.interpreter = new $kzbnL.ParserATNSimulator(this.atn, this);
                this.interpreter.setPredictionMode(interp.getPredictionMode());
            });
        }
        set isTrace(trace) {
            if (!trace) {
                if (this._tracer) {
                    this.removeParseListener(this._tracer);
                    this._tracer = undefined;
                }
            } else {
                if (this._tracer) this.removeParseListener(this._tracer);
                else this._tracer = new $e5b2b780657df507$var$TraceListener(this.ruleNames, this._input);
                this.addParseListener(this._tracer);
            }
        }
        get isTrace() {
            return this._tracer != null;
        }
    }
    $e5b2b780657df507$var$Parser.bypassAltsAtnCache = new Map();
    $e5b2b780657df507$var$__decorate([
        $d6D31.NotNull
    ], $e5b2b780657df507$var$Parser.prototype, "_errHandler", void 0);
    $e5b2b780657df507$var$__decorate([
        $d6D31.NotNull
    ], $e5b2b780657df507$var$Parser.prototype, "match", null);
    $e5b2b780657df507$var$__decorate([
        $d6D31.NotNull
    ], $e5b2b780657df507$var$Parser.prototype, "matchWildcard", null);
    $e5b2b780657df507$var$__decorate([
        $d6D31.NotNull
    ], $e5b2b780657df507$var$Parser.prototype, "getParseListeners", null);
    $e5b2b780657df507$var$__decorate([
        $e5b2b780657df507$var$__param(0, $d6D31.NotNull)
    ], $e5b2b780657df507$var$Parser.prototype, "addParseListener", null);
    $e5b2b780657df507$var$__decorate([
        $d6D31.NotNull
    ], $e5b2b780657df507$var$Parser.prototype, "getATNWithBypassAlts", null);
    $e5b2b780657df507$var$__decorate([
        $d6D31.NotNull,
        $e5b2b780657df507$var$__param(0, $d6D31.NotNull)
    ], $e5b2b780657df507$var$Parser.prototype, "errorHandler", null);
    $e5b2b780657df507$var$__decorate([
        $d6D31.Override
    ], $e5b2b780657df507$var$Parser.prototype, "inputStream", null);
    $e5b2b780657df507$var$__decorate([
        $d6D31.NotNull
    ], $e5b2b780657df507$var$Parser.prototype, "currentToken", null);
    $e5b2b780657df507$var$__decorate([
        $e5b2b780657df507$var$__param(0, $d6D31.NotNull)
    ], $e5b2b780657df507$var$Parser.prototype, "enterRule", null);
    $e5b2b780657df507$var$__decorate([
        $d6D31.Override,
        $e5b2b780657df507$var$__param(0, $d6D31.Nullable)
    ], $e5b2b780657df507$var$Parser.prototype, "precpred", null);
    $e5b2b780657df507$var$__decorate([
        $d6D31.Override
    ], $e5b2b780657df507$var$Parser.prototype, "getErrorListenerDispatch", null);
    $e5b2b780657df507$var$__decorate([
        $d6D31.NotNull
    ], $e5b2b780657df507$var$Parser.prototype, "getExpectedTokens", null);
    $e5b2b780657df507$var$__decorate([
        $d6D31.NotNull
    ], $e5b2b780657df507$var$Parser.prototype, "getExpectedTokensWithinCurrentRule", null);
    $e5b2b780657df507$var$__decorate([
        $d6D31.Override
    ], $e5b2b780657df507$var$Parser.prototype, "parseInfo", null);
    module.exports.Parser = $e5b2b780657df507$var$Parser;
});
parcelRegister("2M2qJ", function(module, exports) {
    "use strict";
    var $2051f30d0c577226$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ATNDeserializationOptions = void 0;
    var $d6D31 = parcelRequire("d6D31");
    class $2051f30d0c577226$var$ATNDeserializationOptions {
        constructor(options){
            this.readOnly = false;
            if (options) {
                this.verifyATN = options.verifyATN;
                this.generateRuleBypassTransitions = options.generateRuleBypassTransitions;
                this.optimize = options.optimize;
            } else {
                this.verifyATN = true;
                this.generateRuleBypassTransitions = false;
                this.optimize = true;
            }
        }
        static get defaultOptions() {
            if ($2051f30d0c577226$var$ATNDeserializationOptions._defaultOptions == null) {
                $2051f30d0c577226$var$ATNDeserializationOptions._defaultOptions = new $2051f30d0c577226$var$ATNDeserializationOptions();
                $2051f30d0c577226$var$ATNDeserializationOptions._defaultOptions.makeReadOnly();
            }
            return $2051f30d0c577226$var$ATNDeserializationOptions._defaultOptions;
        }
        get isReadOnly() {
            return this.readOnly;
        }
        makeReadOnly() {
            this.readOnly = true;
        }
        get isVerifyATN() {
            return this.verifyATN;
        }
        set isVerifyATN(verifyATN) {
            this.throwIfReadOnly();
            this.verifyATN = verifyATN;
        }
        get isGenerateRuleBypassTransitions() {
            return this.generateRuleBypassTransitions;
        }
        set isGenerateRuleBypassTransitions(generateRuleBypassTransitions) {
            this.throwIfReadOnly();
            this.generateRuleBypassTransitions = generateRuleBypassTransitions;
        }
        get isOptimize() {
            return this.optimize;
        }
        set isOptimize(optimize) {
            this.throwIfReadOnly();
            this.optimize = optimize;
        }
        throwIfReadOnly() {
            if (this.isReadOnly) throw new Error("The object is read only.");
        }
    }
    $2051f30d0c577226$var$__decorate([
        $d6D31.NotNull
    ], $2051f30d0c577226$var$ATNDeserializationOptions, "defaultOptions", null);
    module.exports.ATNDeserializationOptions = $2051f30d0c577226$var$ATNDeserializationOptions;
});
parcelRegister("dvgsl", function(module, exports) {
    "use strict";
    var $9d4aef733dce84f9$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $9d4aef733dce84f9$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ATNDeserializer = void 0;
    var $gxlfY = parcelRequire("gxlfY");
    var $7Veax = parcelRequire("7Veax");
    var $bcnvE = parcelRequire("bcnvE");
    var $2M2qJ = parcelRequire("2M2qJ");
    var $1bs3X = parcelRequire("1bs3X");
    var $5r7n7 = parcelRequire("5r7n7");
    var $gAm9p = parcelRequire("gAm9p");
    var $4yiuQ = parcelRequire("4yiuQ");
    var $5BPMp = parcelRequire("5BPMp");
    var $loKp0 = parcelRequire("loKp0");
    var $65vNG = parcelRequire("65vNG");
    var $dPYn6 = parcelRequire("dPYn6");
    var $jJRyp = parcelRequire("jJRyp");
    var $bpnRH = parcelRequire("bpnRH");
    var $hGRod = parcelRequire("hGRod");
    var $l4Nh1 = parcelRequire("l4Nh1");
    var $iw4Ko = parcelRequire("iw4Ko");
    var $RgRAX = parcelRequire("RgRAX");
    var $jgJtt = parcelRequire("jgJtt");
    var $l606e = parcelRequire("l606e");
    var $6hIs4 = parcelRequire("6hIs4");
    var $a9nIX = parcelRequire("a9nIX");
    var $2Gb96 = parcelRequire("2Gb96");
    var $ayRdK = parcelRequire("ayRdK");
    var $kfqEk = parcelRequire("kfqEk");
    var $d6D31 = parcelRequire("d6D31");
    var $FLEKS = parcelRequire("FLEKS");
    var $kzbnL = parcelRequire("kzbnL");
    var $d1V7w = parcelRequire("d1V7w");
    var $7qlbM = parcelRequire("7qlbM");
    var $7KGEQ = parcelRequire("7KGEQ");
    var $hnaRv = parcelRequire("hnaRv");
    var $aISkF = parcelRequire("aISkF");
    var $j2zc8 = parcelRequire("j2zc8");
    var $4kGBm = parcelRequire("4kGBm");
    var $aybFP = parcelRequire("aybFP");
    var $Np2R3 = parcelRequire("Np2R3");
    var $jEsaF = parcelRequire("jEsaF");
    var $bjwd1 = parcelRequire("bjwd1");
    var $f9raX = parcelRequire("f9raX");
    var $2DVsz = parcelRequire("2DVsz");
    var $WS4d7 = parcelRequire("WS4d7");
    var $kWxOc = parcelRequire("kWxOc");
    var $aPmi9 = parcelRequire("aPmi9");
    var $9d4aef733dce84f9$var$UnicodeDeserializingMode;
    (function(UnicodeDeserializingMode) {
        UnicodeDeserializingMode[UnicodeDeserializingMode["UNICODE_BMP"] = 0] = "UNICODE_BMP";
        UnicodeDeserializingMode[UnicodeDeserializingMode["UNICODE_SMP"] = 1] = "UNICODE_SMP";
    })($9d4aef733dce84f9$var$UnicodeDeserializingMode || ($9d4aef733dce84f9$var$UnicodeDeserializingMode = {}));
    class $9d4aef733dce84f9$var$ATNDeserializer {
        constructor(deserializationOptions){
            if (deserializationOptions === undefined) deserializationOptions = $2M2qJ.ATNDeserializationOptions.defaultOptions;
            this.deserializationOptions = deserializationOptions;
        }
        static get SERIALIZED_VERSION() {
            return 3;
        }
        static isFeatureSupported(feature, actualUuid) {
            let featureIndex = $9d4aef733dce84f9$var$ATNDeserializer.SUPPORTED_UUIDS.findIndex((e)=>e.equals(feature));
            if (featureIndex < 0) return false;
            return $9d4aef733dce84f9$var$ATNDeserializer.SUPPORTED_UUIDS.findIndex((e)=>e.equals(actualUuid)) >= featureIndex;
        }
        static getUnicodeDeserializer(mode) {
            if (mode === 0) return {
                readUnicode: (data, p)=>{
                    return $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p]);
                },
                size: 1
            };
            else return {
                readUnicode: (data, p)=>{
                    return $9d4aef733dce84f9$var$ATNDeserializer.toInt32(data, p);
                },
                size: 2
            };
        }
        deserialize(data) {
            data = data.slice(0);
            for(let i = 1; i < data.length; i++)data[i] = data[i] - 2 & 0xFFFF;
            let p = 0;
            let version = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
            if (version !== $9d4aef733dce84f9$var$ATNDeserializer.SERIALIZED_VERSION) {
                let reason = `Could not deserialize ATN with version ${version} (expected ${$9d4aef733dce84f9$var$ATNDeserializer.SERIALIZED_VERSION}).`;
                throw new Error(reason);
            }
            let uuid = $9d4aef733dce84f9$var$ATNDeserializer.toUUID(data, p);
            p += 8;
            if ($9d4aef733dce84f9$var$ATNDeserializer.SUPPORTED_UUIDS.findIndex((e)=>e.equals(uuid)) < 0) {
                let reason = `Could not deserialize ATN with UUID ${uuid} (expected ${$9d4aef733dce84f9$var$ATNDeserializer.SERIALIZED_UUID} or a legacy UUID).`;
                throw new Error(reason);
            }
            let supportsLexerActions = $9d4aef733dce84f9$var$ATNDeserializer.isFeatureSupported($9d4aef733dce84f9$var$ATNDeserializer.ADDED_LEXER_ACTIONS, uuid);
            let grammarType = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
            let maxTokenType = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
            let atn = new $bcnvE.ATN(grammarType, maxTokenType);
            let loopBackStateNumbers = [];
            let endStateNumbers = [];
            let nstates = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
            for(let i = 0; i < nstates; i++){
                let stype = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
                if (stype === $1bs3X.ATNStateType.INVALID_TYPE) {
                    atn.addState(new $l4Nh1.InvalidState());
                    continue;
                }
                let ruleIndex = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
                if (ruleIndex === 0xFFFF) ruleIndex = -1;
                let s = this.stateFactory(stype, ruleIndex);
                if (stype === $1bs3X.ATNStateType.LOOP_END) {
                    let loopBackStateNumber = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
                    loopBackStateNumbers.push([
                        s,
                        loopBackStateNumber
                    ]);
                } else if (s instanceof $65vNG.BlockStartState) {
                    let endStateNumber = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
                    endStateNumbers.push([
                        s,
                        endStateNumber
                    ]);
                }
                atn.addState(s);
            }
            for (let pair of loopBackStateNumbers)pair[0].loopBackState = atn.states[pair[1]];
            for (let pair of endStateNumbers)pair[0].endState = atn.states[pair[1]];
            let numNonGreedyStates = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
            for(let i = 0; i < numNonGreedyStates; i++){
                let stateNumber = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
                atn.states[stateNumber].nonGreedy = true;
            }
            let numSllDecisions = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
            for(let i = 0; i < numSllDecisions; i++){
                let stateNumber = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
                atn.states[stateNumber].sll = true;
            }
            let numPrecedenceStates = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
            for(let i = 0; i < numPrecedenceStates; i++){
                let stateNumber = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
                atn.states[stateNumber].isPrecedenceRule = true;
            }
            let nrules = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
            if (atn.grammarType === 0) atn.ruleToTokenType = new Int32Array(nrules);
            atn.ruleToStartState = new Array(nrules);
            for(let i = 0; i < nrules; i++){
                let s = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
                let startState = atn.states[s];
                startState.leftFactored = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]) !== 0;
                atn.ruleToStartState[i] = startState;
                if (atn.grammarType === 0) {
                    let tokenType = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
                    if (tokenType === 0xFFFF) tokenType = $2DVsz.Token.EOF;
                    atn.ruleToTokenType[i] = tokenType;
                    if (!$9d4aef733dce84f9$var$ATNDeserializer.isFeatureSupported($9d4aef733dce84f9$var$ATNDeserializer.ADDED_LEXER_ACTIONS, uuid)) {
                        let actionIndexIgnored = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
                        if (actionIndexIgnored === 0xFFFF) actionIndexIgnored = -1;
                    }
                }
            }
            atn.ruleToStopState = new Array(nrules);
            for (let state of atn.states){
                if (!(state instanceof $4kGBm.RuleStopState)) continue;
                atn.ruleToStopState[state.ruleIndex] = state;
                atn.ruleToStartState[state.ruleIndex].stopState = state;
            }
            let nmodes = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
            for(let i = 0; i < nmodes; i++){
                let s = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
                atn.modeToStartState.push(atn.states[s]);
            }
            atn.modeToDFA = new Array(nmodes);
            for(let i = 0; i < nmodes; i++)atn.modeToDFA[i] = new $jJRyp.DFA(atn.modeToStartState[i]);
            let sets = [];
            p = this.deserializeSets(data, p, sets, $9d4aef733dce84f9$var$ATNDeserializer.getUnicodeDeserializer(0));
            if ($9d4aef733dce84f9$var$ATNDeserializer.isFeatureSupported($9d4aef733dce84f9$var$ATNDeserializer.ADDED_UNICODE_SMP, uuid)) p = this.deserializeSets(data, p, sets, $9d4aef733dce84f9$var$ATNDeserializer.getUnicodeDeserializer(1));
            let nedges = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
            for(let i = 0; i < nedges; i++){
                let src = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p]);
                let trg = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p + 1]);
                let ttype = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p + 2]);
                let arg1 = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p + 3]);
                let arg2 = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p + 4]);
                let arg3 = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p + 5]);
                let trans = this.edgeFactory(atn, ttype, src, trg, arg1, arg2, arg3, sets);
                let srcState = atn.states[src];
                srcState.addTransition(trans);
                p += 6;
            }
            let returnTransitionsSet = new $7Veax.Array2DHashSet({
                hashCode: (o)=>o.stopState ^ o.returnState ^ o.outermostPrecedenceReturn,
                equals: (a, b)=>{
                    return a.stopState === b.stopState && a.returnState === b.returnState && a.outermostPrecedenceReturn === b.outermostPrecedenceReturn;
                }
            });
            let returnTransitions = [];
            for (let state of atn.states){
                let returningToLeftFactored = state.ruleIndex >= 0 && atn.ruleToStartState[state.ruleIndex].leftFactored;
                for(let i = 0; i < state.numberOfTransitions; i++){
                    let t = state.transition(i);
                    if (!(t instanceof $aybFP.RuleTransition)) continue;
                    let ruleTransition = t;
                    let returningFromLeftFactored = atn.ruleToStartState[ruleTransition.target.ruleIndex].leftFactored;
                    if (!returningFromLeftFactored && returningToLeftFactored) continue;
                    let outermostPrecedenceReturn = -1;
                    if (atn.ruleToStartState[ruleTransition.target.ruleIndex].isPrecedenceRule) {
                        if (ruleTransition.precedence === 0) outermostPrecedenceReturn = ruleTransition.target.ruleIndex;
                    }
                    let current = {
                        stopState: ruleTransition.target.ruleIndex,
                        returnState: ruleTransition.followState.stateNumber,
                        outermostPrecedenceReturn: outermostPrecedenceReturn
                    };
                    if (returnTransitionsSet.add(current)) returnTransitions.push(current);
                }
            }
            for (let returnTransition of returnTransitions){
                let transition = new $bpnRH.EpsilonTransition(atn.states[returnTransition.returnState], returnTransition.outermostPrecedenceReturn);
                atn.ruleToStopState[returnTransition.stopState].addTransition(transition);
            }
            for (let state of atn.states){
                if (state instanceof $65vNG.BlockStartState) {
                    if (state.endState === undefined) throw new Error("IllegalStateException");
                    if (state.endState.startState !== undefined) throw new Error("IllegalStateException");
                    state.endState.startState = state;
                }
                if (state instanceof $7qlbM.PlusLoopbackState) {
                    let loopbackState = state;
                    for(let i = 0; i < loopbackState.numberOfTransitions; i++){
                        let target = loopbackState.transition(i).target;
                        if (target instanceof $d1V7w.PlusBlockStartState) target.loopBackState = loopbackState;
                    }
                } else if (state instanceof $bjwd1.StarLoopbackState) {
                    let loopbackState = state;
                    for(let i = 0; i < loopbackState.numberOfTransitions; i++){
                        let target = loopbackState.transition(i).target;
                        if (target instanceof $f9raX.StarLoopEntryState) target.loopBackState = loopbackState;
                    }
                }
            }
            let ndecisions = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
            for(let i = 1; i <= ndecisions; i++){
                let s = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
                let decState = atn.states[s];
                atn.decisionToState.push(decState);
                decState.decision = i - 1;
            }
            if (atn.grammarType === 0) {
                if (supportsLexerActions) {
                    atn.lexerActions = new Array($9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]));
                    for(let i = 0; i < atn.lexerActions.length; i++){
                        let actionType = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
                        let data1 = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
                        if (data1 === 0xFFFF) data1 = -1;
                        let data2 = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
                        if (data2 === 0xFFFF) data2 = -1;
                        let lexerAction = this.lexerActionFactory(actionType, data1, data2);
                        atn.lexerActions[i] = lexerAction;
                    }
                } else {
                    let legacyLexerActions = [];
                    for (let state of atn.states)for(let i = 0; i < state.numberOfTransitions; i++){
                        let transition = state.transition(i);
                        if (!(transition instanceof $gxlfY.ActionTransition)) continue;
                        let ruleIndex = transition.ruleIndex;
                        let actionIndex = transition.actionIndex;
                        let lexerAction = new $RgRAX.LexerCustomAction(ruleIndex, actionIndex);
                        state.setTransition(i, new $gxlfY.ActionTransition(transition.target, ruleIndex, legacyLexerActions.length, false));
                        legacyLexerActions.push(lexerAction);
                    }
                    atn.lexerActions = legacyLexerActions;
                }
            }
            this.markPrecedenceDecisions(atn);
            atn.decisionToDFA = new Array(ndecisions);
            for(let i = 0; i < ndecisions; i++)atn.decisionToDFA[i] = new $jJRyp.DFA(atn.decisionToState[i], i);
            if (this.deserializationOptions.isVerifyATN) this.verifyATN(atn);
            if (this.deserializationOptions.isGenerateRuleBypassTransitions && atn.grammarType === 1) {
                atn.ruleToTokenType = new Int32Array(atn.ruleToStartState.length);
                for(let i = 0; i < atn.ruleToStartState.length; i++)atn.ruleToTokenType[i] = atn.maxTokenType + i + 1;
                for(let i = 0; i < atn.ruleToStartState.length; i++){
                    let bypassStart = new $gAm9p.BasicBlockStartState();
                    bypassStart.ruleIndex = i;
                    atn.addState(bypassStart);
                    let bypassStop = new $loKp0.BlockEndState();
                    bypassStop.ruleIndex = i;
                    atn.addState(bypassStop);
                    bypassStart.endState = bypassStop;
                    atn.defineDecisionState(bypassStart);
                    bypassStop.startState = bypassStart;
                    let endState;
                    let excludeTransition;
                    if (atn.ruleToStartState[i].isPrecedenceRule) {
                        endState = undefined;
                        for (let state of atn.states){
                            if (state.ruleIndex !== i) continue;
                            if (!(state instanceof $f9raX.StarLoopEntryState)) continue;
                            let maybeLoopEndState = state.transition(state.numberOfTransitions - 1).target;
                            if (!(maybeLoopEndState instanceof $kfqEk.LoopEndState)) continue;
                            if (maybeLoopEndState.epsilonOnlyTransitions && maybeLoopEndState.transition(0).target instanceof $4kGBm.RuleStopState) {
                                endState = state;
                                break;
                            }
                        }
                        if (!endState) throw new Error("Couldn't identify final state of the precedence rule prefix section.");
                        excludeTransition = endState.loopBackState.transition(0);
                    } else endState = atn.ruleToStopState[i];
                    for (let state of atn.states)for(let i = 0; i < state.numberOfTransitions; i++){
                        let transition = state.transition(i);
                        if (transition === excludeTransition) continue;
                        if (transition.target === endState) transition.target = bypassStop;
                    }
                    while(atn.ruleToStartState[i].numberOfTransitions > 0){
                        let transition = atn.ruleToStartState[i].removeTransition(atn.ruleToStartState[i].numberOfTransitions - 1);
                        bypassStart.addTransition(transition);
                    }
                    atn.ruleToStartState[i].addTransition(new $bpnRH.EpsilonTransition(bypassStart));
                    bypassStop.addTransition(new $bpnRH.EpsilonTransition(endState));
                    let matchState = new $4yiuQ.BasicState();
                    atn.addState(matchState);
                    matchState.addTransition(new $5r7n7.AtomTransition(bypassStop, atn.ruleToTokenType[i]));
                    bypassStart.addTransition(new $bpnRH.EpsilonTransition(matchState));
                }
                if (this.deserializationOptions.isVerifyATN) this.verifyATN(atn);
            }
            if (this.deserializationOptions.isOptimize) {
                while(true){
                    let optimizationCount = 0;
                    optimizationCount += $9d4aef733dce84f9$var$ATNDeserializer.inlineSetRules(atn);
                    optimizationCount += $9d4aef733dce84f9$var$ATNDeserializer.combineChainedEpsilons(atn);
                    let preserveOrder = atn.grammarType === 0;
                    optimizationCount += $9d4aef733dce84f9$var$ATNDeserializer.optimizeSets(atn, preserveOrder);
                    if (optimizationCount === 0) break;
                }
                if (this.deserializationOptions.isVerifyATN) this.verifyATN(atn);
            }
            $9d4aef733dce84f9$var$ATNDeserializer.identifyTailCalls(atn);
            return atn;
        }
        deserializeSets(data, p, sets, unicodeDeserializer) {
            let nsets = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]);
            for(let i = 0; i < nsets; i++){
                let nintervals = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p]);
                p++;
                let set = new $hGRod.IntervalSet();
                sets.push(set);
                let containsEof = $9d4aef733dce84f9$var$ATNDeserializer.toInt(data[p++]) !== 0;
                if (containsEof) set.add(-1);
                for(let j = 0; j < nintervals; j++){
                    let a = unicodeDeserializer.readUnicode(data, p);
                    p += unicodeDeserializer.size;
                    let b = unicodeDeserializer.readUnicode(data, p);
                    p += unicodeDeserializer.size;
                    set.add(a, b);
                }
            }
            return p;
        }
        markPrecedenceDecisions(atn) {
            let rulePrecedenceDecisions = new Map();
            for (let state of atn.states){
                if (!(state instanceof $f9raX.StarLoopEntryState)) continue;
                if (atn.ruleToStartState[state.ruleIndex].isPrecedenceRule) {
                    let maybeLoopEndState = state.transition(state.numberOfTransitions - 1).target;
                    if (maybeLoopEndState instanceof $kfqEk.LoopEndState) {
                        if (maybeLoopEndState.epsilonOnlyTransitions && maybeLoopEndState.transition(0).target instanceof $4kGBm.RuleStopState) {
                            rulePrecedenceDecisions.set(state.ruleIndex, state);
                            state.precedenceRuleDecision = true;
                            state.precedenceLoopbackStates = new $5BPMp.BitSet(atn.states.length);
                        }
                    }
                }
            }
            for (let precedenceDecision of rulePrecedenceDecisions)for (let transition of atn.ruleToStopState[precedenceDecision[0]].getTransitions()){
                if (transition.serializationType !== 1) continue;
                let epsilonTransition = transition;
                if (epsilonTransition.outermostPrecedenceReturn !== -1) continue;
                precedenceDecision[1].precedenceLoopbackStates.set(transition.target.stateNumber);
            }
        }
        verifyATN(atn) {
            for (let state of atn.states){
                this.checkCondition(state !== undefined, "ATN states should not be undefined.");
                if (state.stateType === $1bs3X.ATNStateType.INVALID_TYPE) continue;
                this.checkCondition(state.onlyHasEpsilonTransitions || state.numberOfTransitions <= 1);
                if (state instanceof $d1V7w.PlusBlockStartState) this.checkCondition(state.loopBackState !== undefined);
                if (state instanceof $f9raX.StarLoopEntryState) {
                    let starLoopEntryState = state;
                    this.checkCondition(starLoopEntryState.loopBackState !== undefined);
                    this.checkCondition(starLoopEntryState.numberOfTransitions === 2);
                    if (starLoopEntryState.transition(0).target instanceof $jEsaF.StarBlockStartState) {
                        this.checkCondition(starLoopEntryState.transition(1).target instanceof $kfqEk.LoopEndState);
                        this.checkCondition(!starLoopEntryState.nonGreedy);
                    } else if (starLoopEntryState.transition(0).target instanceof $kfqEk.LoopEndState) {
                        this.checkCondition(starLoopEntryState.transition(1).target instanceof $jEsaF.StarBlockStartState);
                        this.checkCondition(starLoopEntryState.nonGreedy);
                    } else throw new Error("IllegalStateException");
                }
                if (state instanceof $bjwd1.StarLoopbackState) {
                    this.checkCondition(state.numberOfTransitions === 1);
                    this.checkCondition(state.transition(0).target instanceof $f9raX.StarLoopEntryState);
                }
                if (state instanceof $kfqEk.LoopEndState) this.checkCondition(state.loopBackState !== undefined);
                if (state instanceof $j2zc8.RuleStartState) this.checkCondition(state.stopState !== undefined);
                if (state instanceof $65vNG.BlockStartState) this.checkCondition(state.endState !== undefined);
                if (state instanceof $loKp0.BlockEndState) this.checkCondition(state.startState !== undefined);
                if (state instanceof $dPYn6.DecisionState) {
                    let decisionState = state;
                    this.checkCondition(decisionState.numberOfTransitions <= 1 || decisionState.decision >= 0);
                } else this.checkCondition(state.numberOfTransitions <= 1 || state instanceof $4kGBm.RuleStopState);
            }
        }
        checkCondition(condition, message) {
            if (!condition) throw new Error("IllegalStateException: " + message);
        }
        static inlineSetRules(atn) {
            let inlinedCalls = 0;
            let ruleToInlineTransition = new Array(atn.ruleToStartState.length);
            for(let i = 0; i < atn.ruleToStartState.length; i++){
                let startState = atn.ruleToStartState[i];
                let middleState = startState;
                while(middleState.onlyHasEpsilonTransitions && middleState.numberOfOptimizedTransitions === 1 && middleState.getOptimizedTransition(0).serializationType === 1)middleState = middleState.getOptimizedTransition(0).target;
                if (middleState.numberOfOptimizedTransitions !== 1) continue;
                let matchTransition = middleState.getOptimizedTransition(0);
                let matchTarget = matchTransition.target;
                if (matchTransition.isEpsilon || !matchTarget.onlyHasEpsilonTransitions || matchTarget.numberOfOptimizedTransitions !== 1 || !(matchTarget.getOptimizedTransition(0).target instanceof $4kGBm.RuleStopState)) continue;
                switch(matchTransition.serializationType){
                    case 5:
                    case 2:
                    case 7:
                        ruleToInlineTransition[i] = matchTransition;
                        break;
                    case 8:
                    case 9:
                        continue;
                    default:
                        continue;
                }
            }
            for (let state of atn.states){
                if (state.ruleIndex < 0) continue;
                let optimizedTransitions;
                for(let i = 0; i < state.numberOfOptimizedTransitions; i++){
                    let transition = state.getOptimizedTransition(i);
                    if (!(transition instanceof $aybFP.RuleTransition)) {
                        if (optimizedTransitions !== undefined) optimizedTransitions.push(transition);
                        continue;
                    }
                    let ruleTransition = transition;
                    let effective = ruleToInlineTransition[ruleTransition.target.ruleIndex];
                    if (effective === undefined) {
                        if (optimizedTransitions !== undefined) optimizedTransitions.push(transition);
                        continue;
                    }
                    if (optimizedTransitions === undefined) {
                        optimizedTransitions = [];
                        for(let j = 0; j < i; j++)optimizedTransitions.push(state.getOptimizedTransition(i));
                    }
                    inlinedCalls++;
                    let target = ruleTransition.followState;
                    let intermediateState = new $4yiuQ.BasicState();
                    intermediateState.setRuleIndex(target.ruleIndex);
                    atn.addState(intermediateState);
                    optimizedTransitions.push(new $bpnRH.EpsilonTransition(intermediateState));
                    switch(effective.serializationType){
                        case 5:
                            intermediateState.addTransition(new $5r7n7.AtomTransition(target, effective._label));
                            break;
                        case 2:
                            intermediateState.addTransition(new $aISkF.RangeTransition(target, effective.from, effective.to));
                            break;
                        case 7:
                            intermediateState.addTransition(new $Np2R3.SetTransition(target, effective.label));
                            break;
                        default:
                            throw new Error("UnsupportedOperationException");
                    }
                }
                if (optimizedTransitions !== undefined) {
                    if (state.isOptimized) while(state.numberOfOptimizedTransitions > 0)state.removeOptimizedTransition(state.numberOfOptimizedTransitions - 1);
                    for (let transition of optimizedTransitions)state.addOptimizedTransition(transition);
                }
            }
            if ($kzbnL.ParserATNSimulator.debug) console.log("ATN runtime optimizer removed " + inlinedCalls + " rule invocations by inlining sets.");
            return inlinedCalls;
        }
        static combineChainedEpsilons(atn) {
            let removedEdges = 0;
            for (let state of atn.states){
                if (!state.onlyHasEpsilonTransitions || state instanceof $4kGBm.RuleStopState) continue;
                let optimizedTransitions;
                nextTransition: for(let i = 0; i < state.numberOfOptimizedTransitions; i++){
                    let transition = state.getOptimizedTransition(i);
                    let intermediate = transition.target;
                    if (transition.serializationType !== 1 || transition.outermostPrecedenceReturn !== -1 || intermediate.stateType !== $1bs3X.ATNStateType.BASIC || !intermediate.onlyHasEpsilonTransitions) {
                        if (optimizedTransitions !== undefined) optimizedTransitions.push(transition);
                        continue nextTransition;
                    }
                    for(let j = 0; j < intermediate.numberOfOptimizedTransitions; j++)if (intermediate.getOptimizedTransition(j).serializationType !== 1 || intermediate.getOptimizedTransition(j).outermostPrecedenceReturn !== -1) {
                        if (optimizedTransitions !== undefined) optimizedTransitions.push(transition);
                        continue nextTransition;
                    }
                    removedEdges++;
                    if (optimizedTransitions === undefined) {
                        optimizedTransitions = [];
                        for(let j = 0; j < i; j++)optimizedTransitions.push(state.getOptimizedTransition(j));
                    }
                    for(let j = 0; j < intermediate.numberOfOptimizedTransitions; j++){
                        let target = intermediate.getOptimizedTransition(j).target;
                        optimizedTransitions.push(new $bpnRH.EpsilonTransition(target));
                    }
                }
                if (optimizedTransitions !== undefined) {
                    if (state.isOptimized) while(state.numberOfOptimizedTransitions > 0)state.removeOptimizedTransition(state.numberOfOptimizedTransitions - 1);
                    for (let transition of optimizedTransitions)state.addOptimizedTransition(transition);
                }
            }
            if ($kzbnL.ParserATNSimulator.debug) console.log("ATN runtime optimizer removed " + removedEdges + " transitions by combining chained epsilon transitions.");
            return removedEdges;
        }
        static optimizeSets(atn, preserveOrder) {
            if (preserveOrder) return 0;
            let removedPaths = 0;
            let decisions = atn.decisionToState;
            for (let decision of decisions){
                let setTransitions = new $hGRod.IntervalSet();
                for(let i = 0; i < decision.numberOfOptimizedTransitions; i++){
                    let epsTransition = decision.getOptimizedTransition(i);
                    if (!(epsTransition instanceof $bpnRH.EpsilonTransition)) continue;
                    if (epsTransition.target.numberOfOptimizedTransitions !== 1) continue;
                    let transition = epsTransition.target.getOptimizedTransition(0);
                    if (!(transition.target instanceof $loKp0.BlockEndState)) continue;
                    if (transition instanceof $FLEKS.NotSetTransition) continue;
                    if (transition instanceof $5r7n7.AtomTransition || transition instanceof $aISkF.RangeTransition || transition instanceof $Np2R3.SetTransition) setTransitions.add(i);
                }
                if (setTransitions.size <= 1) continue;
                let optimizedTransitions = [];
                for(let i = 0; i < decision.numberOfOptimizedTransitions; i++)if (!setTransitions.contains(i)) optimizedTransitions.push(decision.getOptimizedTransition(i));
                let blockEndState = decision.getOptimizedTransition(setTransitions.minElement).target.getOptimizedTransition(0).target;
                let matchSet = new $hGRod.IntervalSet();
                for (let interval of setTransitions.intervals)for(let j = interval.a; j <= interval.b; j++){
                    let matchTransition = decision.getOptimizedTransition(j).target.getOptimizedTransition(0);
                    if (matchTransition instanceof $FLEKS.NotSetTransition) throw new Error("Not yet implemented.");
                    else matchSet.addAll(matchTransition.label);
                }
                let newTransition;
                if (matchSet.intervals.length === 1) {
                    if (matchSet.size === 1) newTransition = new $5r7n7.AtomTransition(blockEndState, matchSet.minElement);
                    else {
                        let matchInterval = matchSet.intervals[0];
                        newTransition = new $aISkF.RangeTransition(blockEndState, matchInterval.a, matchInterval.b);
                    }
                } else newTransition = new $Np2R3.SetTransition(blockEndState, matchSet);
                let setOptimizedState = new $4yiuQ.BasicState();
                setOptimizedState.setRuleIndex(decision.ruleIndex);
                atn.addState(setOptimizedState);
                setOptimizedState.addTransition(newTransition);
                optimizedTransitions.push(new $bpnRH.EpsilonTransition(setOptimizedState));
                removedPaths += decision.numberOfOptimizedTransitions - optimizedTransitions.length;
                if (decision.isOptimized) while(decision.numberOfOptimizedTransitions > 0)decision.removeOptimizedTransition(decision.numberOfOptimizedTransitions - 1);
                for (let transition of optimizedTransitions)decision.addOptimizedTransition(transition);
            }
            if ($kzbnL.ParserATNSimulator.debug) console.log("ATN runtime optimizer removed " + removedPaths + " paths by collapsing sets.");
            return removedPaths;
        }
        static identifyTailCalls(atn) {
            for (let state of atn.states){
                for(let i = 0; i < state.numberOfTransitions; i++){
                    let transition = state.transition(i);
                    if (!(transition instanceof $aybFP.RuleTransition)) continue;
                    transition.tailCall = this.testTailCall(atn, transition, false);
                    transition.optimizedTailCall = this.testTailCall(atn, transition, true);
                }
                if (!state.isOptimized) continue;
                for(let i = 0; i < state.numberOfOptimizedTransitions; i++){
                    let transition = state.getOptimizedTransition(i);
                    if (!(transition instanceof $aybFP.RuleTransition)) continue;
                    transition.tailCall = this.testTailCall(atn, transition, false);
                    transition.optimizedTailCall = this.testTailCall(atn, transition, true);
                }
            }
        }
        static testTailCall(atn, transition, optimizedPath) {
            if (!optimizedPath && transition.tailCall) return true;
            if (optimizedPath && transition.optimizedTailCall) return true;
            let reachable = new $5BPMp.BitSet(atn.states.length);
            let worklist = [];
            worklist.push(transition.followState);
            while(true){
                let state = worklist.pop();
                if (!state) break;
                if (reachable.get(state.stateNumber)) continue;
                if (state instanceof $4kGBm.RuleStopState) continue;
                if (!state.onlyHasEpsilonTransitions) return false;
                let transitionCount = optimizedPath ? state.numberOfOptimizedTransitions : state.numberOfTransitions;
                for(let i = 0; i < transitionCount; i++){
                    let t = optimizedPath ? state.getOptimizedTransition(i) : state.transition(i);
                    if (t.serializationType !== 1) return false;
                    worklist.push(t.target);
                }
            }
            return true;
        }
        static toInt(c) {
            return c;
        }
        static toInt32(data, offset) {
            return (data[offset] | data[offset + 1] << 16) >>> 0;
        }
        static toUUID(data, offset) {
            let leastSigBits = $9d4aef733dce84f9$var$ATNDeserializer.toInt32(data, offset);
            let lessSigBits = $9d4aef733dce84f9$var$ATNDeserializer.toInt32(data, offset + 2);
            let moreSigBits = $9d4aef733dce84f9$var$ATNDeserializer.toInt32(data, offset + 4);
            let mostSigBits = $9d4aef733dce84f9$var$ATNDeserializer.toInt32(data, offset + 6);
            return new $kWxOc.UUID(mostSigBits, moreSigBits, lessSigBits, leastSigBits);
        }
        edgeFactory(atn, type, src, trg, arg1, arg2, arg3, sets) {
            let target = atn.states[trg];
            switch(type){
                case 1:
                    return new $bpnRH.EpsilonTransition(target);
                case 2:
                    if (arg3 !== 0) return new $aISkF.RangeTransition(target, $2DVsz.Token.EOF, arg2);
                    else return new $aISkF.RangeTransition(target, arg1, arg2);
                case 3:
                    let rt = new $aybFP.RuleTransition(atn.states[arg1], arg2, arg3, target);
                    return rt;
                case 4:
                    let pt = new $hnaRv.PredicateTransition(target, arg1, arg2, arg3 !== 0);
                    return pt;
                case 10:
                    return new $7KGEQ.PrecedencePredicateTransition(target, arg1);
                case 5:
                    if (arg3 !== 0) return new $5r7n7.AtomTransition(target, $2DVsz.Token.EOF);
                    else return new $5r7n7.AtomTransition(target, arg1);
                case 6:
                    let a = new $gxlfY.ActionTransition(target, arg1, arg2, arg3 !== 0);
                    return a;
                case 7:
                    return new $Np2R3.SetTransition(target, sets[arg1]);
                case 8:
                    return new $FLEKS.NotSetTransition(target, sets[arg1]);
                case 9:
                    return new $aPmi9.WildcardTransition(target);
            }
            throw new Error("The specified transition type is not valid.");
        }
        stateFactory(type, ruleIndex) {
            let s;
            switch(type){
                case $1bs3X.ATNStateType.INVALID_TYPE:
                    return new $l4Nh1.InvalidState();
                case $1bs3X.ATNStateType.BASIC:
                    s = new $4yiuQ.BasicState();
                    break;
                case $1bs3X.ATNStateType.RULE_START:
                    s = new $j2zc8.RuleStartState();
                    break;
                case $1bs3X.ATNStateType.BLOCK_START:
                    s = new $gAm9p.BasicBlockStartState();
                    break;
                case $1bs3X.ATNStateType.PLUS_BLOCK_START:
                    s = new $d1V7w.PlusBlockStartState();
                    break;
                case $1bs3X.ATNStateType.STAR_BLOCK_START:
                    s = new $jEsaF.StarBlockStartState();
                    break;
                case $1bs3X.ATNStateType.TOKEN_START:
                    s = new $WS4d7.TokensStartState();
                    break;
                case $1bs3X.ATNStateType.RULE_STOP:
                    s = new $4kGBm.RuleStopState();
                    break;
                case $1bs3X.ATNStateType.BLOCK_END:
                    s = new $loKp0.BlockEndState();
                    break;
                case $1bs3X.ATNStateType.STAR_LOOP_BACK:
                    s = new $bjwd1.StarLoopbackState();
                    break;
                case $1bs3X.ATNStateType.STAR_LOOP_ENTRY:
                    s = new $f9raX.StarLoopEntryState();
                    break;
                case $1bs3X.ATNStateType.PLUS_LOOP_BACK:
                    s = new $7qlbM.PlusLoopbackState();
                    break;
                case $1bs3X.ATNStateType.LOOP_END:
                    s = new $kfqEk.LoopEndState();
                    break;
                default:
                    let message = `The specified state type ${type} is not valid.`;
                    throw new Error(message);
            }
            s.ruleIndex = ruleIndex;
            return s;
        }
        lexerActionFactory(type, data1, data2) {
            switch(type){
                case 0:
                    return new $iw4Ko.LexerChannelAction(data1);
                case 1:
                    return new $RgRAX.LexerCustomAction(data1, data2);
                case 2:
                    return new $jgJtt.LexerModeAction(data1);
                case 3:
                    return $l606e.LexerMoreAction.INSTANCE;
                case 4:
                    return $6hIs4.LexerPopModeAction.INSTANCE;
                case 5:
                    return new $a9nIX.LexerPushModeAction(data1);
                case 6:
                    return $2Gb96.LexerSkipAction.INSTANCE;
                case 7:
                    return new $ayRdK.LexerTypeAction(data1);
                default:
                    let message = `The specified lexer action type ${type} is not valid.`;
                    throw new Error(message);
            }
        }
    }
    $9d4aef733dce84f9$var$ATNDeserializer.BASE_SERIALIZED_UUID = $kWxOc.UUID.fromString("E4178468-DF95-44D0-AD87-F22A5D5FB6D3");
    $9d4aef733dce84f9$var$ATNDeserializer.ADDED_LEXER_ACTIONS = $kWxOc.UUID.fromString("AB35191A-1603-487E-B75A-479B831EAF6D");
    $9d4aef733dce84f9$var$ATNDeserializer.ADDED_UNICODE_SMP = $kWxOc.UUID.fromString("C23FEA89-0605-4f51-AFB8-058BCAB8C91B");
    $9d4aef733dce84f9$var$ATNDeserializer.SUPPORTED_UUIDS = [
        $9d4aef733dce84f9$var$ATNDeserializer.BASE_SERIALIZED_UUID,
        $9d4aef733dce84f9$var$ATNDeserializer.ADDED_LEXER_ACTIONS,
        $9d4aef733dce84f9$var$ATNDeserializer.ADDED_UNICODE_SMP
    ];
    $9d4aef733dce84f9$var$ATNDeserializer.SERIALIZED_UUID = $9d4aef733dce84f9$var$ATNDeserializer.ADDED_UNICODE_SMP;
    $9d4aef733dce84f9$var$__decorate([
        $d6D31.NotNull
    ], $9d4aef733dce84f9$var$ATNDeserializer.prototype, "deserializationOptions", void 0);
    $9d4aef733dce84f9$var$__decorate([
        $9d4aef733dce84f9$var$__param(0, $d6D31.NotNull)
    ], $9d4aef733dce84f9$var$ATNDeserializer.prototype, "deserialize", null);
    $9d4aef733dce84f9$var$__decorate([
        $9d4aef733dce84f9$var$__param(0, $d6D31.NotNull)
    ], $9d4aef733dce84f9$var$ATNDeserializer.prototype, "markPrecedenceDecisions", null);
    $9d4aef733dce84f9$var$__decorate([
        $d6D31.NotNull,
        $9d4aef733dce84f9$var$__param(0, $d6D31.NotNull)
    ], $9d4aef733dce84f9$var$ATNDeserializer.prototype, "edgeFactory", null);
    module.exports.ATNDeserializer = $9d4aef733dce84f9$var$ATNDeserializer;
});
parcelRegister("gxlfY", function(module, exports) {
    "use strict";
    var $c0a0378a1b984eee$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $c0a0378a1b984eee$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ActionTransition = void 0;
    var $d6D31 = parcelRequire("d6D31");
    var $5tcOQ = parcelRequire("5tcOQ");
    let $c0a0378a1b984eee$var$ActionTransition = class ActionTransition extends $5tcOQ.Transition {
        constructor(target, ruleIndex, actionIndex = -1, isCtxDependent = false){
            super(target);
            this.ruleIndex = ruleIndex;
            this.actionIndex = actionIndex;
            this.isCtxDependent = isCtxDependent;
        }
        get serializationType() {
            return 6;
        }
        get isEpsilon() {
            return true;
        }
        matches(symbol, minVocabSymbol, maxVocabSymbol) {
            return false;
        }
        toString() {
            return "action_" + this.ruleIndex + ":" + this.actionIndex;
        }
    };
    $c0a0378a1b984eee$var$__decorate([
        $d6D31.Override
    ], $c0a0378a1b984eee$var$ActionTransition.prototype, "serializationType", null);
    $c0a0378a1b984eee$var$__decorate([
        $d6D31.Override
    ], $c0a0378a1b984eee$var$ActionTransition.prototype, "isEpsilon", null);
    $c0a0378a1b984eee$var$__decorate([
        $d6D31.Override
    ], $c0a0378a1b984eee$var$ActionTransition.prototype, "matches", null);
    $c0a0378a1b984eee$var$__decorate([
        $d6D31.Override
    ], $c0a0378a1b984eee$var$ActionTransition.prototype, "toString", null);
    $c0a0378a1b984eee$var$ActionTransition = $c0a0378a1b984eee$var$__decorate([
        $c0a0378a1b984eee$var$__param(0, $d6D31.NotNull)
    ], $c0a0378a1b984eee$var$ActionTransition);
    module.exports.ActionTransition = $c0a0378a1b984eee$var$ActionTransition;
});
parcelRegister("5r7n7", function(module, exports) {
    "use strict";
    var $010580cb6b5878c3$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $010580cb6b5878c3$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.AtomTransition = void 0;
    var $hGRod = parcelRequire("hGRod");
    var $d6D31 = parcelRequire("d6D31");
    var $5tcOQ = parcelRequire("5tcOQ");
    let $010580cb6b5878c3$var$AtomTransition = class AtomTransition extends $5tcOQ.Transition {
        constructor(target, label){
            super(target);
            this._label = label;
        }
        get serializationType() {
            return 5;
        }
        get label() {
            return $hGRod.IntervalSet.of(this._label);
        }
        matches(symbol, minVocabSymbol, maxVocabSymbol) {
            return this._label === symbol;
        }
        toString() {
            return String(this.label);
        }
    };
    $010580cb6b5878c3$var$__decorate([
        $d6D31.Override
    ], $010580cb6b5878c3$var$AtomTransition.prototype, "serializationType", null);
    $010580cb6b5878c3$var$__decorate([
        $d6D31.Override,
        $d6D31.NotNull
    ], $010580cb6b5878c3$var$AtomTransition.prototype, "label", null);
    $010580cb6b5878c3$var$__decorate([
        $d6D31.Override
    ], $010580cb6b5878c3$var$AtomTransition.prototype, "matches", null);
    $010580cb6b5878c3$var$__decorate([
        $d6D31.Override,
        $d6D31.NotNull
    ], $010580cb6b5878c3$var$AtomTransition.prototype, "toString", null);
    $010580cb6b5878c3$var$AtomTransition = $010580cb6b5878c3$var$__decorate([
        $010580cb6b5878c3$var$__param(0, $d6D31.NotNull)
    ], $010580cb6b5878c3$var$AtomTransition);
    module.exports.AtomTransition = $010580cb6b5878c3$var$AtomTransition;
});
parcelRegister("gAm9p", function(module, exports) {
    "use strict";
    var $c13130ce46eb4f6a$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.BasicBlockStartState = void 0;
    var $1bs3X = parcelRequire("1bs3X");
    var $65vNG = parcelRequire("65vNG");
    var $d6D31 = parcelRequire("d6D31");
    class $c13130ce46eb4f6a$var$BasicBlockStartState extends $65vNG.BlockStartState {
        get stateType() {
            return $1bs3X.ATNStateType.BLOCK_START;
        }
    }
    $c13130ce46eb4f6a$var$__decorate([
        $d6D31.Override
    ], $c13130ce46eb4f6a$var$BasicBlockStartState.prototype, "stateType", null);
    module.exports.BasicBlockStartState = $c13130ce46eb4f6a$var$BasicBlockStartState;
});
parcelRegister("65vNG", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.BlockStartState = void 0;
    var $dPYn6 = parcelRequire("dPYn6");
    class $46ebe09d19265106$var$BlockStartState extends $dPYn6.DecisionState {
    }
    module.exports.BlockStartState = $46ebe09d19265106$var$BlockStartState;
});
parcelRegister("loKp0", function(module, exports) {
    "use strict";
    var $f93fd5601d243552$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.BlockEndState = void 0;
    var $7j0Pc = parcelRequire("7j0Pc");
    var $1bs3X = parcelRequire("1bs3X");
    var $d6D31 = parcelRequire("d6D31");
    class $f93fd5601d243552$var$BlockEndState extends $7j0Pc.ATNState {
        get stateType() {
            return $1bs3X.ATNStateType.BLOCK_END;
        }
    }
    $f93fd5601d243552$var$__decorate([
        $d6D31.Override
    ], $f93fd5601d243552$var$BlockEndState.prototype, "stateType", null);
    module.exports.BlockEndState = $f93fd5601d243552$var$BlockEndState;
});
parcelRegister("bpnRH", function(module, exports) {
    "use strict";
    var $84e48a9cb4812173$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $84e48a9cb4812173$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.EpsilonTransition = void 0;
    var $d6D31 = parcelRequire("d6D31");
    var $5tcOQ = parcelRequire("5tcOQ");
    let $84e48a9cb4812173$var$EpsilonTransition = class EpsilonTransition extends $5tcOQ.Transition {
        constructor(target, outermostPrecedenceReturn = -1){
            super(target);
            this._outermostPrecedenceReturn = outermostPrecedenceReturn;
        }
        get outermostPrecedenceReturn() {
            return this._outermostPrecedenceReturn;
        }
        get serializationType() {
            return 1;
        }
        get isEpsilon() {
            return true;
        }
        matches(symbol, minVocabSymbol, maxVocabSymbol) {
            return false;
        }
        toString() {
            return "epsilon";
        }
    };
    $84e48a9cb4812173$var$__decorate([
        $d6D31.Override
    ], $84e48a9cb4812173$var$EpsilonTransition.prototype, "serializationType", null);
    $84e48a9cb4812173$var$__decorate([
        $d6D31.Override
    ], $84e48a9cb4812173$var$EpsilonTransition.prototype, "isEpsilon", null);
    $84e48a9cb4812173$var$__decorate([
        $d6D31.Override
    ], $84e48a9cb4812173$var$EpsilonTransition.prototype, "matches", null);
    $84e48a9cb4812173$var$__decorate([
        $d6D31.Override,
        $d6D31.NotNull
    ], $84e48a9cb4812173$var$EpsilonTransition.prototype, "toString", null);
    $84e48a9cb4812173$var$EpsilonTransition = $84e48a9cb4812173$var$__decorate([
        $84e48a9cb4812173$var$__param(0, $d6D31.NotNull)
    ], $84e48a9cb4812173$var$EpsilonTransition);
    module.exports.EpsilonTransition = $84e48a9cb4812173$var$EpsilonTransition;
});
parcelRegister("iw4Ko", function(module, exports) {
    "use strict";
    var $d7aee5df2113a2bc$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $d7aee5df2113a2bc$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.LexerChannelAction = void 0;
    var $iXFjm = parcelRequire("iXFjm");
    var $d6D31 = parcelRequire("d6D31");
    class $d7aee5df2113a2bc$var$LexerChannelAction {
        constructor(channel){
            this._channel = channel;
        }
        get channel() {
            return this._channel;
        }
        get actionType() {
            return 0;
        }
        get isPositionDependent() {
            return false;
        }
        execute(lexer) {
            lexer.channel = this._channel;
        }
        hashCode() {
            let hash = $iXFjm.MurmurHash.initialize();
            hash = $iXFjm.MurmurHash.update(hash, this.actionType);
            hash = $iXFjm.MurmurHash.update(hash, this._channel);
            return $iXFjm.MurmurHash.finish(hash, 2);
        }
        equals(obj) {
            if (obj === this) return true;
            else if (!(obj instanceof $d7aee5df2113a2bc$var$LexerChannelAction)) return false;
            return this._channel === obj._channel;
        }
        toString() {
            return `channel(${this._channel})`;
        }
    }
    $d7aee5df2113a2bc$var$__decorate([
        $d6D31.Override
    ], $d7aee5df2113a2bc$var$LexerChannelAction.prototype, "actionType", null);
    $d7aee5df2113a2bc$var$__decorate([
        $d6D31.Override
    ], $d7aee5df2113a2bc$var$LexerChannelAction.prototype, "isPositionDependent", null);
    $d7aee5df2113a2bc$var$__decorate([
        $d6D31.Override,
        $d7aee5df2113a2bc$var$__param(0, $d6D31.NotNull)
    ], $d7aee5df2113a2bc$var$LexerChannelAction.prototype, "execute", null);
    $d7aee5df2113a2bc$var$__decorate([
        $d6D31.Override
    ], $d7aee5df2113a2bc$var$LexerChannelAction.prototype, "hashCode", null);
    $d7aee5df2113a2bc$var$__decorate([
        $d6D31.Override
    ], $d7aee5df2113a2bc$var$LexerChannelAction.prototype, "equals", null);
    $d7aee5df2113a2bc$var$__decorate([
        $d6D31.Override
    ], $d7aee5df2113a2bc$var$LexerChannelAction.prototype, "toString", null);
    module.exports.LexerChannelAction = $d7aee5df2113a2bc$var$LexerChannelAction;
});
parcelRegister("RgRAX", function(module, exports) {
    "use strict";
    var $0a0208144418eb04$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $0a0208144418eb04$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.LexerCustomAction = void 0;
    var $iXFjm = parcelRequire("iXFjm");
    var $d6D31 = parcelRequire("d6D31");
    class $0a0208144418eb04$var$LexerCustomAction {
        constructor(ruleIndex, actionIndex){
            this._ruleIndex = ruleIndex;
            this._actionIndex = actionIndex;
        }
        get ruleIndex() {
            return this._ruleIndex;
        }
        get actionIndex() {
            return this._actionIndex;
        }
        get actionType() {
            return 1;
        }
        get isPositionDependent() {
            return true;
        }
        execute(lexer) {
            lexer.action(undefined, this._ruleIndex, this._actionIndex);
        }
        hashCode() {
            let hash = $iXFjm.MurmurHash.initialize();
            hash = $iXFjm.MurmurHash.update(hash, this.actionType);
            hash = $iXFjm.MurmurHash.update(hash, this._ruleIndex);
            hash = $iXFjm.MurmurHash.update(hash, this._actionIndex);
            return $iXFjm.MurmurHash.finish(hash, 3);
        }
        equals(obj) {
            if (obj === this) return true;
            else if (!(obj instanceof $0a0208144418eb04$var$LexerCustomAction)) return false;
            return this._ruleIndex === obj._ruleIndex && this._actionIndex === obj._actionIndex;
        }
    }
    $0a0208144418eb04$var$__decorate([
        $d6D31.Override
    ], $0a0208144418eb04$var$LexerCustomAction.prototype, "actionType", null);
    $0a0208144418eb04$var$__decorate([
        $d6D31.Override
    ], $0a0208144418eb04$var$LexerCustomAction.prototype, "isPositionDependent", null);
    $0a0208144418eb04$var$__decorate([
        $d6D31.Override,
        $0a0208144418eb04$var$__param(0, $d6D31.NotNull)
    ], $0a0208144418eb04$var$LexerCustomAction.prototype, "execute", null);
    $0a0208144418eb04$var$__decorate([
        $d6D31.Override
    ], $0a0208144418eb04$var$LexerCustomAction.prototype, "hashCode", null);
    $0a0208144418eb04$var$__decorate([
        $d6D31.Override
    ], $0a0208144418eb04$var$LexerCustomAction.prototype, "equals", null);
    module.exports.LexerCustomAction = $0a0208144418eb04$var$LexerCustomAction;
});
parcelRegister("jgJtt", function(module, exports) {
    "use strict";
    var $e072c93b157fdb6e$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $e072c93b157fdb6e$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.LexerModeAction = void 0;
    var $iXFjm = parcelRequire("iXFjm");
    var $d6D31 = parcelRequire("d6D31");
    class $e072c93b157fdb6e$var$LexerModeAction {
        constructor(mode){
            this._mode = mode;
        }
        get mode() {
            return this._mode;
        }
        get actionType() {
            return 2;
        }
        get isPositionDependent() {
            return false;
        }
        execute(lexer) {
            lexer.mode(this._mode);
        }
        hashCode() {
            let hash = $iXFjm.MurmurHash.initialize();
            hash = $iXFjm.MurmurHash.update(hash, this.actionType);
            hash = $iXFjm.MurmurHash.update(hash, this._mode);
            return $iXFjm.MurmurHash.finish(hash, 2);
        }
        equals(obj) {
            if (obj === this) return true;
            else if (!(obj instanceof $e072c93b157fdb6e$var$LexerModeAction)) return false;
            return this._mode === obj._mode;
        }
        toString() {
            return `mode(${this._mode})`;
        }
    }
    $e072c93b157fdb6e$var$__decorate([
        $d6D31.Override
    ], $e072c93b157fdb6e$var$LexerModeAction.prototype, "actionType", null);
    $e072c93b157fdb6e$var$__decorate([
        $d6D31.Override
    ], $e072c93b157fdb6e$var$LexerModeAction.prototype, "isPositionDependent", null);
    $e072c93b157fdb6e$var$__decorate([
        $d6D31.Override,
        $e072c93b157fdb6e$var$__param(0, $d6D31.NotNull)
    ], $e072c93b157fdb6e$var$LexerModeAction.prototype, "execute", null);
    $e072c93b157fdb6e$var$__decorate([
        $d6D31.Override
    ], $e072c93b157fdb6e$var$LexerModeAction.prototype, "hashCode", null);
    $e072c93b157fdb6e$var$__decorate([
        $d6D31.Override
    ], $e072c93b157fdb6e$var$LexerModeAction.prototype, "equals", null);
    $e072c93b157fdb6e$var$__decorate([
        $d6D31.Override
    ], $e072c93b157fdb6e$var$LexerModeAction.prototype, "toString", null);
    module.exports.LexerModeAction = $e072c93b157fdb6e$var$LexerModeAction;
});
parcelRegister("l606e", function(module, exports) {
    "use strict";
    var $f5ba3c4a18e49934$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $f5ba3c4a18e49934$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.LexerMoreAction = void 0;
    var $iXFjm = parcelRequire("iXFjm");
    var $d6D31 = parcelRequire("d6D31");
    class $f5ba3c4a18e49934$var$LexerMoreAction {
        constructor(){}
        get actionType() {
            return 3;
        }
        get isPositionDependent() {
            return false;
        }
        execute(lexer) {
            lexer.more();
        }
        hashCode() {
            let hash = $iXFjm.MurmurHash.initialize();
            hash = $iXFjm.MurmurHash.update(hash, this.actionType);
            return $iXFjm.MurmurHash.finish(hash, 1);
        }
        equals(obj) {
            return obj === this;
        }
        toString() {
            return "more";
        }
    }
    $f5ba3c4a18e49934$var$__decorate([
        $d6D31.Override
    ], $f5ba3c4a18e49934$var$LexerMoreAction.prototype, "actionType", null);
    $f5ba3c4a18e49934$var$__decorate([
        $d6D31.Override
    ], $f5ba3c4a18e49934$var$LexerMoreAction.prototype, "isPositionDependent", null);
    $f5ba3c4a18e49934$var$__decorate([
        $d6D31.Override,
        $f5ba3c4a18e49934$var$__param(0, $d6D31.NotNull)
    ], $f5ba3c4a18e49934$var$LexerMoreAction.prototype, "execute", null);
    $f5ba3c4a18e49934$var$__decorate([
        $d6D31.Override
    ], $f5ba3c4a18e49934$var$LexerMoreAction.prototype, "hashCode", null);
    $f5ba3c4a18e49934$var$__decorate([
        $d6D31.Override
    ], $f5ba3c4a18e49934$var$LexerMoreAction.prototype, "equals", null);
    $f5ba3c4a18e49934$var$__decorate([
        $d6D31.Override
    ], $f5ba3c4a18e49934$var$LexerMoreAction.prototype, "toString", null);
    module.exports.LexerMoreAction = $f5ba3c4a18e49934$var$LexerMoreAction;
    (function(LexerMoreAction) {
        LexerMoreAction.INSTANCE = new LexerMoreAction();
    })($f5ba3c4a18e49934$var$LexerMoreAction = module.exports.LexerMoreAction || (module.exports.LexerMoreAction = {}));
});
parcelRegister("6hIs4", function(module, exports) {
    "use strict";
    var $4936cfc70a1820aa$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $4936cfc70a1820aa$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.LexerPopModeAction = void 0;
    var $iXFjm = parcelRequire("iXFjm");
    var $d6D31 = parcelRequire("d6D31");
    class $4936cfc70a1820aa$var$LexerPopModeAction {
        constructor(){}
        get actionType() {
            return 4;
        }
        get isPositionDependent() {
            return false;
        }
        execute(lexer) {
            lexer.popMode();
        }
        hashCode() {
            let hash = $iXFjm.MurmurHash.initialize();
            hash = $iXFjm.MurmurHash.update(hash, this.actionType);
            return $iXFjm.MurmurHash.finish(hash, 1);
        }
        equals(obj) {
            return obj === this;
        }
        toString() {
            return "popMode";
        }
    }
    $4936cfc70a1820aa$var$__decorate([
        $d6D31.Override
    ], $4936cfc70a1820aa$var$LexerPopModeAction.prototype, "actionType", null);
    $4936cfc70a1820aa$var$__decorate([
        $d6D31.Override
    ], $4936cfc70a1820aa$var$LexerPopModeAction.prototype, "isPositionDependent", null);
    $4936cfc70a1820aa$var$__decorate([
        $d6D31.Override,
        $4936cfc70a1820aa$var$__param(0, $d6D31.NotNull)
    ], $4936cfc70a1820aa$var$LexerPopModeAction.prototype, "execute", null);
    $4936cfc70a1820aa$var$__decorate([
        $d6D31.Override
    ], $4936cfc70a1820aa$var$LexerPopModeAction.prototype, "hashCode", null);
    $4936cfc70a1820aa$var$__decorate([
        $d6D31.Override
    ], $4936cfc70a1820aa$var$LexerPopModeAction.prototype, "equals", null);
    $4936cfc70a1820aa$var$__decorate([
        $d6D31.Override
    ], $4936cfc70a1820aa$var$LexerPopModeAction.prototype, "toString", null);
    module.exports.LexerPopModeAction = $4936cfc70a1820aa$var$LexerPopModeAction;
    (function(LexerPopModeAction) {
        LexerPopModeAction.INSTANCE = new LexerPopModeAction();
    })($4936cfc70a1820aa$var$LexerPopModeAction = module.exports.LexerPopModeAction || (module.exports.LexerPopModeAction = {}));
});
parcelRegister("a9nIX", function(module, exports) {
    "use strict";
    var $763d25c4cd7cf3b5$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $763d25c4cd7cf3b5$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.LexerPushModeAction = void 0;
    var $iXFjm = parcelRequire("iXFjm");
    var $d6D31 = parcelRequire("d6D31");
    class $763d25c4cd7cf3b5$var$LexerPushModeAction {
        constructor(mode){
            this._mode = mode;
        }
        get mode() {
            return this._mode;
        }
        get actionType() {
            return 5;
        }
        get isPositionDependent() {
            return false;
        }
        execute(lexer) {
            lexer.pushMode(this._mode);
        }
        hashCode() {
            let hash = $iXFjm.MurmurHash.initialize();
            hash = $iXFjm.MurmurHash.update(hash, this.actionType);
            hash = $iXFjm.MurmurHash.update(hash, this._mode);
            return $iXFjm.MurmurHash.finish(hash, 2);
        }
        equals(obj) {
            if (obj === this) return true;
            else if (!(obj instanceof $763d25c4cd7cf3b5$var$LexerPushModeAction)) return false;
            return this._mode === obj._mode;
        }
        toString() {
            return `pushMode(${this._mode})`;
        }
    }
    $763d25c4cd7cf3b5$var$__decorate([
        $d6D31.Override
    ], $763d25c4cd7cf3b5$var$LexerPushModeAction.prototype, "actionType", null);
    $763d25c4cd7cf3b5$var$__decorate([
        $d6D31.Override
    ], $763d25c4cd7cf3b5$var$LexerPushModeAction.prototype, "isPositionDependent", null);
    $763d25c4cd7cf3b5$var$__decorate([
        $d6D31.Override,
        $763d25c4cd7cf3b5$var$__param(0, $d6D31.NotNull)
    ], $763d25c4cd7cf3b5$var$LexerPushModeAction.prototype, "execute", null);
    $763d25c4cd7cf3b5$var$__decorate([
        $d6D31.Override
    ], $763d25c4cd7cf3b5$var$LexerPushModeAction.prototype, "hashCode", null);
    $763d25c4cd7cf3b5$var$__decorate([
        $d6D31.Override
    ], $763d25c4cd7cf3b5$var$LexerPushModeAction.prototype, "equals", null);
    $763d25c4cd7cf3b5$var$__decorate([
        $d6D31.Override
    ], $763d25c4cd7cf3b5$var$LexerPushModeAction.prototype, "toString", null);
    module.exports.LexerPushModeAction = $763d25c4cd7cf3b5$var$LexerPushModeAction;
});
parcelRegister("2Gb96", function(module, exports) {
    "use strict";
    var $1f3826579173f858$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $1f3826579173f858$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.LexerSkipAction = void 0;
    var $iXFjm = parcelRequire("iXFjm");
    var $d6D31 = parcelRequire("d6D31");
    class $1f3826579173f858$var$LexerSkipAction {
        constructor(){}
        get actionType() {
            return 6;
        }
        get isPositionDependent() {
            return false;
        }
        execute(lexer) {
            lexer.skip();
        }
        hashCode() {
            let hash = $iXFjm.MurmurHash.initialize();
            hash = $iXFjm.MurmurHash.update(hash, this.actionType);
            return $iXFjm.MurmurHash.finish(hash, 1);
        }
        equals(obj) {
            return obj === this;
        }
        toString() {
            return "skip";
        }
    }
    $1f3826579173f858$var$__decorate([
        $d6D31.Override
    ], $1f3826579173f858$var$LexerSkipAction.prototype, "actionType", null);
    $1f3826579173f858$var$__decorate([
        $d6D31.Override
    ], $1f3826579173f858$var$LexerSkipAction.prototype, "isPositionDependent", null);
    $1f3826579173f858$var$__decorate([
        $d6D31.Override,
        $1f3826579173f858$var$__param(0, $d6D31.NotNull)
    ], $1f3826579173f858$var$LexerSkipAction.prototype, "execute", null);
    $1f3826579173f858$var$__decorate([
        $d6D31.Override
    ], $1f3826579173f858$var$LexerSkipAction.prototype, "hashCode", null);
    $1f3826579173f858$var$__decorate([
        $d6D31.Override
    ], $1f3826579173f858$var$LexerSkipAction.prototype, "equals", null);
    $1f3826579173f858$var$__decorate([
        $d6D31.Override
    ], $1f3826579173f858$var$LexerSkipAction.prototype, "toString", null);
    module.exports.LexerSkipAction = $1f3826579173f858$var$LexerSkipAction;
    (function(LexerSkipAction) {
        LexerSkipAction.INSTANCE = new LexerSkipAction();
    })($1f3826579173f858$var$LexerSkipAction = module.exports.LexerSkipAction || (module.exports.LexerSkipAction = {}));
});
parcelRegister("ayRdK", function(module, exports) {
    "use strict";
    var $7b065cdfc5f207e7$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $7b065cdfc5f207e7$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.LexerTypeAction = void 0;
    var $iXFjm = parcelRequire("iXFjm");
    var $d6D31 = parcelRequire("d6D31");
    class $7b065cdfc5f207e7$var$LexerTypeAction {
        constructor(type){
            this._type = type;
        }
        get type() {
            return this._type;
        }
        get actionType() {
            return 7;
        }
        get isPositionDependent() {
            return false;
        }
        execute(lexer) {
            lexer.type = this._type;
        }
        hashCode() {
            let hash = $iXFjm.MurmurHash.initialize();
            hash = $iXFjm.MurmurHash.update(hash, this.actionType);
            hash = $iXFjm.MurmurHash.update(hash, this._type);
            return $iXFjm.MurmurHash.finish(hash, 2);
        }
        equals(obj) {
            if (obj === this) return true;
            else if (!(obj instanceof $7b065cdfc5f207e7$var$LexerTypeAction)) return false;
            return this._type === obj._type;
        }
        toString() {
            return `type(${this._type})`;
        }
    }
    $7b065cdfc5f207e7$var$__decorate([
        $d6D31.Override
    ], $7b065cdfc5f207e7$var$LexerTypeAction.prototype, "actionType", null);
    $7b065cdfc5f207e7$var$__decorate([
        $d6D31.Override
    ], $7b065cdfc5f207e7$var$LexerTypeAction.prototype, "isPositionDependent", null);
    $7b065cdfc5f207e7$var$__decorate([
        $d6D31.Override,
        $7b065cdfc5f207e7$var$__param(0, $d6D31.NotNull)
    ], $7b065cdfc5f207e7$var$LexerTypeAction.prototype, "execute", null);
    $7b065cdfc5f207e7$var$__decorate([
        $d6D31.Override
    ], $7b065cdfc5f207e7$var$LexerTypeAction.prototype, "hashCode", null);
    $7b065cdfc5f207e7$var$__decorate([
        $d6D31.Override
    ], $7b065cdfc5f207e7$var$LexerTypeAction.prototype, "equals", null);
    $7b065cdfc5f207e7$var$__decorate([
        $d6D31.Override
    ], $7b065cdfc5f207e7$var$LexerTypeAction.prototype, "toString", null);
    module.exports.LexerTypeAction = $7b065cdfc5f207e7$var$LexerTypeAction;
});
parcelRegister("kfqEk", function(module, exports) {
    "use strict";
    var $ebd9e16490628daf$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.LoopEndState = void 0;
    var $7j0Pc = parcelRequire("7j0Pc");
    var $1bs3X = parcelRequire("1bs3X");
    var $d6D31 = parcelRequire("d6D31");
    class $ebd9e16490628daf$var$LoopEndState extends $7j0Pc.ATNState {
        get stateType() {
            return $1bs3X.ATNStateType.LOOP_END;
        }
    }
    $ebd9e16490628daf$var$__decorate([
        $d6D31.Override
    ], $ebd9e16490628daf$var$LoopEndState.prototype, "stateType", null);
    module.exports.LoopEndState = $ebd9e16490628daf$var$LoopEndState;
});
parcelRegister("kzbnL", function(module, exports) {
    "use strict";
    var $ef8fe7d2bd819f1c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $ef8fe7d2bd819f1c$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ParserATNSimulator = void 0;
    var $41NTU = parcelRequire("41NTU");
    var $gxlfY = parcelRequire("gxlfY");
    var $7Veax = parcelRequire("7Veax");
    var $9yG1X = parcelRequire("9yG1X");
    var $bcnvE = parcelRequire("bcnvE");
    var $gcX0f = parcelRequire("gcX0f");
    var $c1ClW = parcelRequire("c1ClW");
    var $kr9A1 = parcelRequire("kr9A1");
    var $1bs3X = parcelRequire("1bs3X");
    var $5r7n7 = parcelRequire("5r7n7");
    var $5BPMp = parcelRequire("5BPMp");
    var $gsRaX = parcelRequire("gsRaX");
    var $dPYn6 = parcelRequire("dPYn6");
    var $2jevZ = parcelRequire("2jevZ");
    var $37SGk = parcelRequire("37SGk");
    var $gcfUE = parcelRequire("gcfUE");
    var $ceaEj = parcelRequire("ceaEj");
    var $d6D31 = parcelRequire("d6D31");
    var $FLEKS = parcelRequire("FLEKS");
    var $hKCjP = parcelRequire("hKCjP");
    var $a4Flx = parcelRequire("a4Flx");
    var $6bmaO = parcelRequire("6bmaO");
    var $8DTT0 = parcelRequire("8DTT0");
    var $6vF7J = parcelRequire("6vF7J");
    var $gDZVV = parcelRequire("gDZVV");
    var $4kGBm = parcelRequire("4kGBm");
    var $aybFP = parcelRequire("aybFP");
    var $eHMgW = parcelRequire("eHMgW");
    var $Np2R3 = parcelRequire("Np2R3");
    var $g7SCF = parcelRequire("g7SCF");
    var $2DVsz = parcelRequire("2DVsz");
    var $3n2FE = parcelRequire("3n2FE");
    var $bbHFU = parcelRequire("bbHFU");
    const $ef8fe7d2bd819f1c$var$MAX_SHORT_VALUE = 0xFFFF;
    const $ef8fe7d2bd819f1c$var$MIN_INTEGER_VALUE = -2147483648;
    let $ef8fe7d2bd819f1c$var$ParserATNSimulator = class ParserATNSimulator extends $kr9A1.ATNSimulator {
        constructor(atn, parser){
            super(atn);
            this.predictionMode = $gDZVV.PredictionMode.LL;
            this.force_global_context = false;
            this.always_try_local_context = true;
            this.enable_global_context_dfa = false;
            this.optimize_unique_closure = true;
            this.optimize_ll1 = true;
            this.optimize_tail_calls = true;
            this.tail_call_preserves_sll = true;
            this.treat_sllk1_conflict_as_ambiguity = false;
            this.reportAmbiguities = false;
            this.userWantsCtxSensitive = true;
            this._parser = parser;
        }
        getPredictionMode() {
            return this.predictionMode;
        }
        setPredictionMode(predictionMode) {
            this.predictionMode = predictionMode;
        }
        reset() {}
        adaptivePredict(input, decision, outerContext, useContext) {
            if (useContext === undefined) useContext = false;
            let dfa = this.atn.decisionToDFA[decision];
            $bbHFU(dfa != null);
            if (this.optimize_ll1 && !dfa.isPrecedenceDfa && !dfa.isEmpty) {
                let ll_1 = input.LA(1);
                if (ll_1 >= 0 && ll_1 <= 0xFFFF) {
                    let key = (decision << 16 >>> 0) + ll_1;
                    let alt = this.atn.LL1Table.get(key);
                    if (alt != null) return alt;
                }
            }
            this.dfa = dfa;
            if (this.force_global_context) useContext = true;
            else if (!this.always_try_local_context) useContext = useContext || dfa.isContextSensitive;
            this.userWantsCtxSensitive = useContext || this.predictionMode !== $gDZVV.PredictionMode.SLL && outerContext != null && !this.atn.decisionToState[decision].sll;
            if (outerContext == null) outerContext = $6bmaO.ParserRuleContext.emptyContext();
            let state;
            if (!dfa.isEmpty) state = this.getStartState(dfa, input, outerContext, useContext);
            if (state == null) {
                if (outerContext == null) outerContext = $6bmaO.ParserRuleContext.emptyContext();
                if (ParserATNSimulator.debug) console.log("ATN decision " + dfa.decision + " exec LA(1)==" + this.getLookaheadName(input) + ", outerContext=" + outerContext.toString(this._parser));
                state = this.computeStartState(dfa, outerContext, useContext);
            }
            let m = input.mark();
            let index = input.index;
            try {
                let alt = this.execDFA(dfa, input, index, state);
                if (ParserATNSimulator.debug) console.log("DFA after predictATN: " + dfa.toString(this._parser.vocabulary, this._parser.ruleNames));
                return alt;
            } finally{
                this.dfa = undefined;
                input.seek(index);
                input.release(m);
            }
        }
        getStartState(dfa, input, outerContext, useContext) {
            if (!useContext) {
                if (dfa.isPrecedenceDfa) {
                    let state = dfa.getPrecedenceStartState(this._parser.precedence, false);
                    if (state == null) return undefined;
                    return new $g7SCF.SimulatorState(outerContext, state, false, outerContext);
                } else {
                    if (dfa.s0 == null) return undefined;
                    return new $g7SCF.SimulatorState(outerContext, dfa.s0, false, outerContext);
                }
            }
            if (!this.enable_global_context_dfa) return undefined;
            let remainingContext = outerContext;
            $bbHFU(outerContext != null);
            let s0;
            if (dfa.isPrecedenceDfa) s0 = dfa.getPrecedenceStartState(this._parser.precedence, true);
            else s0 = dfa.s0full;
            while(remainingContext != null && s0 != null && s0.isContextSensitive){
                remainingContext = this.skipTailCalls(remainingContext);
                s0 = s0.getContextTarget(this.getReturnState(remainingContext));
                if (remainingContext.isEmpty) $bbHFU(s0 == null || !s0.isContextSensitive);
                else remainingContext = remainingContext.parent;
            }
            if (s0 == null) return undefined;
            return new $g7SCF.SimulatorState(outerContext, s0, useContext, remainingContext);
        }
        execDFA(dfa, input, startIndex, state) {
            let outerContext = state.outerContext;
            if (ParserATNSimulator.dfa_debug) console.log("DFA decision " + dfa.decision + " exec LA(1)==" + this.getLookaheadName(input) + ", outerContext=" + outerContext.toString(this._parser));
            if (ParserATNSimulator.dfa_debug) console.log(dfa.toString(this._parser.vocabulary, this._parser.ruleNames));
            let s = state.s0;
            let t = input.LA(1);
            let remainingOuterContext = state.remainingOuterContext;
            while(true){
                if (ParserATNSimulator.dfa_debug) console.log("DFA state " + s.stateNumber + " LA(1)==" + this.getLookaheadName(input));
                if (state.useContext) while(s.isContextSymbol(t)){
                    let next;
                    if (remainingOuterContext != null) {
                        remainingOuterContext = this.skipTailCalls(remainingOuterContext);
                        next = s.getContextTarget(this.getReturnState(remainingOuterContext));
                    }
                    if (next == null) {
                        let initialState = new $g7SCF.SimulatorState(state.outerContext, s, state.useContext, remainingOuterContext);
                        return this.execATN(dfa, input, startIndex, initialState);
                    }
                    $bbHFU(remainingOuterContext != null);
                    remainingOuterContext = remainingOuterContext.parent;
                    s = next;
                }
                if (this.isAcceptState(s, state.useContext)) {
                    if (s.predicates != null) {
                        if (ParserATNSimulator.dfa_debug) console.log("accept " + s);
                    } else if (ParserATNSimulator.dfa_debug) console.log("accept; predict " + s.prediction + " in state " + s.stateNumber);
                    break;
                }
                $bbHFU(!this.isAcceptState(s, state.useContext));
                let target = this.getExistingTargetState(s, t);
                if (target == null) {
                    if (ParserATNSimulator.dfa_debug && t >= 0) console.log("no edge for " + this._parser.vocabulary.getDisplayName(t));
                    let alt;
                    if (ParserATNSimulator.dfa_debug) {
                        let interval = $gcfUE.Interval.of(startIndex, this._parser.inputStream.index);
                        console.log("ATN exec upon " + this._parser.inputStream.getText(interval) + " at DFA state " + s.stateNumber);
                    }
                    let initialState = new $g7SCF.SimulatorState(outerContext, s, state.useContext, remainingOuterContext);
                    alt = this.execATN(dfa, input, startIndex, initialState);
                    if (ParserATNSimulator.dfa_debug) console.log("back from DFA update, alt=" + alt + ", dfa=\n" + dfa.toString(this._parser.vocabulary, this._parser.ruleNames));
                    if (ParserATNSimulator.dfa_debug) console.log("DFA decision " + dfa.decision + " predicts " + alt);
                    return alt;
                } else if (target === $kr9A1.ATNSimulator.ERROR) {
                    let errorState = new $g7SCF.SimulatorState(outerContext, s, state.useContext, remainingOuterContext);
                    return this.handleNoViableAlt(input, startIndex, errorState);
                }
                s = target;
                if (!this.isAcceptState(s, state.useContext) && t !== $ceaEj.IntStream.EOF) {
                    input.consume();
                    t = input.LA(1);
                }
            }
            if (!state.useContext && s.configs.conflictInfo != null) {
                if (dfa.atnStartState instanceof $dPYn6.DecisionState) {
                    if (!this.userWantsCtxSensitive || !s.configs.dipsIntoOuterContext && s.configs.isExactConflict || this.treat_sllk1_conflict_as_ambiguity && input.index === startIndex) ;
                    else {
                        $bbHFU(!state.useContext);
                        let conflictingAlts;
                        let predicates = s.predicates;
                        if (predicates != null) {
                            let conflictIndex = input.index;
                            if (conflictIndex !== startIndex) input.seek(startIndex);
                            conflictingAlts = this.evalSemanticContext(predicates, outerContext, true);
                            if (conflictingAlts.cardinality() === 1) return conflictingAlts.nextSetBit(0);
                            if (conflictIndex !== startIndex) input.seek(conflictIndex);
                        }
                        if (this.reportAmbiguities) {
                            let conflictState = new $g7SCF.SimulatorState(outerContext, s, state.useContext, remainingOuterContext);
                            this.reportAttemptingFullContext(dfa, conflictingAlts, conflictState, startIndex, input.index);
                        }
                        input.seek(startIndex);
                        return this.adaptivePredict(input, dfa.decision, outerContext, true);
                    }
                }
            }
            let predicates = s.predicates;
            if (predicates != null) {
                let stopIndex = input.index;
                if (startIndex !== stopIndex) input.seek(startIndex);
                let alts = this.evalSemanticContext(predicates, outerContext, this.reportAmbiguities && this.predictionMode === $gDZVV.PredictionMode.LL_EXACT_AMBIG_DETECTION);
                switch(alts.cardinality()){
                    case 0:
                        throw this.noViableAlt(input, outerContext, s.configs, startIndex);
                    case 1:
                        return alts.nextSetBit(0);
                    default:
                        if (startIndex !== stopIndex) input.seek(stopIndex);
                        this.reportAmbiguity(dfa, s, startIndex, stopIndex, s.configs.isExactConflict, alts, s.configs);
                        return alts.nextSetBit(0);
                }
            }
            if (ParserATNSimulator.dfa_debug) console.log("DFA decision " + dfa.decision + " predicts " + s.prediction);
            return s.prediction;
        }
        isAcceptState(state, useContext) {
            if (!state.isAcceptState) return false;
            if (state.configs.conflictingAlts == null) return true;
            if (useContext && this.predictionMode === $gDZVV.PredictionMode.LL_EXACT_AMBIG_DETECTION) return state.configs.isExactConflict;
            return true;
        }
        execATN(dfa, input, startIndex, initialState) {
            if (ParserATNSimulator.debug) console.log("execATN decision " + dfa.decision + " exec LA(1)==" + this.getLookaheadName(input));
            let outerContext = initialState.outerContext;
            let useContext = initialState.useContext;
            let t = input.LA(1);
            let previous = initialState;
            let contextCache = new $6vF7J.PredictionContextCache();
            while(true){
                let nextState = this.computeReachSet(dfa, previous, t, contextCache);
                if (nextState == null) {
                    this.setDFAEdge(previous.s0, input.LA(1), $kr9A1.ATNSimulator.ERROR);
                    return this.handleNoViableAlt(input, startIndex, previous);
                }
                let D = nextState.s0;
                $bbHFU(D.isAcceptState || D.prediction === $bcnvE.ATN.INVALID_ALT_NUMBER);
                $bbHFU(D.isAcceptState || D.configs.conflictInfo == null);
                if (this.isAcceptState(D, useContext)) {
                    let conflictingAlts = D.configs.conflictingAlts;
                    let predictedAlt = conflictingAlts == null ? D.prediction : $bcnvE.ATN.INVALID_ALT_NUMBER;
                    if (predictedAlt !== $bcnvE.ATN.INVALID_ALT_NUMBER) {
                        if (this.optimize_ll1 && input.index === startIndex && !dfa.isPrecedenceDfa && nextState.outerContext === nextState.remainingOuterContext && dfa.decision >= 0 && !D.configs.hasSemanticContext) {
                            if (t >= 0 && t <= $ef8fe7d2bd819f1c$var$MAX_SHORT_VALUE) {
                                let key = (dfa.decision << 16 >>> 0) + t;
                                this.atn.LL1Table.set(key, predictedAlt);
                            }
                        }
                        if (useContext && this.always_try_local_context) this.reportContextSensitivity(dfa, predictedAlt, nextState, startIndex, input.index);
                    }
                    predictedAlt = D.prediction;
                    let attemptFullContext = conflictingAlts != null && this.userWantsCtxSensitive;
                    if (attemptFullContext) attemptFullContext = !useContext && (D.configs.dipsIntoOuterContext || !D.configs.isExactConflict) && (!this.treat_sllk1_conflict_as_ambiguity || input.index !== startIndex);
                    if (D.configs.hasSemanticContext) {
                        let predPredictions = D.predicates;
                        if (predPredictions != null) {
                            let conflictIndex = input.index;
                            if (conflictIndex !== startIndex) input.seek(startIndex);
                            conflictingAlts = this.evalSemanticContext(predPredictions, outerContext, attemptFullContext || this.reportAmbiguities);
                            switch(conflictingAlts.cardinality()){
                                case 0:
                                    throw this.noViableAlt(input, outerContext, D.configs, startIndex);
                                case 1:
                                    return conflictingAlts.nextSetBit(0);
                                default:
                                    break;
                            }
                            if (conflictIndex !== startIndex) input.seek(conflictIndex);
                        }
                    }
                    if (!attemptFullContext) {
                        if (conflictingAlts != null) {
                            if (this.reportAmbiguities && conflictingAlts.cardinality() > 1) this.reportAmbiguity(dfa, D, startIndex, input.index, D.configs.isExactConflict, conflictingAlts, D.configs);
                            predictedAlt = conflictingAlts.nextSetBit(0);
                        }
                        return predictedAlt;
                    } else {
                        $bbHFU(!useContext);
                        $bbHFU(this.isAcceptState(D, false));
                        if (ParserATNSimulator.debug) console.log("RETRY with outerContext=" + outerContext);
                        let fullContextState = this.computeStartState(dfa, outerContext, true);
                        if (this.reportAmbiguities) this.reportAttemptingFullContext(dfa, conflictingAlts, nextState, startIndex, input.index);
                        input.seek(startIndex);
                        return this.execATN(dfa, input, startIndex, fullContextState);
                    }
                }
                previous = nextState;
                if (t !== $ceaEj.IntStream.EOF) {
                    input.consume();
                    t = input.LA(1);
                }
            }
        }
        handleNoViableAlt(input, startIndex, previous) {
            if (previous.s0 != null) {
                let alts = new $5BPMp.BitSet();
                let maxAlt = 0;
                for (let config of previous.s0.configs)if (config.reachesIntoOuterContext || config.state instanceof $4kGBm.RuleStopState) {
                    alts.set(config.alt);
                    maxAlt = Math.max(maxAlt, config.alt);
                }
                switch(alts.cardinality()){
                    case 0:
                        break;
                    case 1:
                        return alts.nextSetBit(0);
                    default:
                        if (!previous.s0.configs.hasSemanticContext) return alts.nextSetBit(0);
                        let filteredConfigs = new $c1ClW.ATNConfigSet();
                        for (let config of previous.s0.configs)if (config.reachesIntoOuterContext || config.state instanceof $4kGBm.RuleStopState) filteredConfigs.add(config);
                        let altToPred = this.getPredsForAmbigAlts(alts, filteredConfigs, maxAlt);
                        if (altToPred != null) {
                            let predicates = this.getPredicatePredictions(alts, altToPred);
                            if (predicates != null) {
                                let stopIndex = input.index;
                                try {
                                    input.seek(startIndex);
                                    let filteredAlts = this.evalSemanticContext(predicates, previous.outerContext, false);
                                    if (!filteredAlts.isEmpty) return filteredAlts.nextSetBit(0);
                                } finally{
                                    input.seek(stopIndex);
                                }
                            }
                        }
                        return alts.nextSetBit(0);
                }
            }
            throw this.noViableAlt(input, previous.outerContext, previous.s0.configs, startIndex);
        }
        computeReachSet(dfa, previous, t, contextCache) {
            let useContext = previous.useContext;
            let remainingGlobalContext = previous.remainingOuterContext;
            let s = previous.s0;
            if (useContext) while(s.isContextSymbol(t)){
                let next;
                if (remainingGlobalContext != null) {
                    remainingGlobalContext = this.skipTailCalls(remainingGlobalContext);
                    next = s.getContextTarget(this.getReturnState(remainingGlobalContext));
                }
                if (next == null) break;
                $bbHFU(remainingGlobalContext != null);
                remainingGlobalContext = remainingGlobalContext.parent;
                s = next;
            }
            $bbHFU(!this.isAcceptState(s, useContext));
            if (this.isAcceptState(s, useContext)) return new $g7SCF.SimulatorState(previous.outerContext, s, useContext, remainingGlobalContext);
            let s0 = s;
            let target = this.getExistingTargetState(s0, t);
            if (target == null) {
                let result = this.computeTargetState(dfa, s0, remainingGlobalContext, t, useContext, contextCache);
                target = result[0];
                remainingGlobalContext = result[1];
            }
            if (target === $kr9A1.ATNSimulator.ERROR) return undefined;
            $bbHFU(!useContext || !target.configs.dipsIntoOuterContext);
            return new $g7SCF.SimulatorState(previous.outerContext, target, useContext, remainingGlobalContext);
        }
        getExistingTargetState(s, t) {
            return s.getTarget(t);
        }
        computeTargetState(dfa, s, remainingGlobalContext, t, useContext, contextCache) {
            let closureConfigs = s.configs.toArray();
            let contextElements;
            let reach = new $c1ClW.ATNConfigSet();
            let stepIntoGlobal;
            do {
                let hasMoreContext = !useContext || remainingGlobalContext != null;
                if (!hasMoreContext) reach.isOutermostConfigSet = true;
                let reachIntermediate = new $c1ClW.ATNConfigSet();
                let skippedStopStates;
                for (let c of closureConfigs){
                    if (ParserATNSimulator.debug) console.log("testing " + this.getTokenName(t) + " at " + c.toString());
                    if (c.state instanceof $4kGBm.RuleStopState) {
                        $bbHFU(c.context.isEmpty);
                        if (useContext && !c.reachesIntoOuterContext || t === $ceaEj.IntStream.EOF) {
                            if (skippedStopStates == null) skippedStopStates = [];
                            skippedStopStates.push(c);
                        }
                        continue;
                    }
                    let n = c.state.numberOfOptimizedTransitions;
                    for(let ti = 0; ti < n; ti++){
                        let trans = c.state.getOptimizedTransition(ti);
                        let target = this.getReachableTarget(c, trans, t);
                        if (target != null) reachIntermediate.add(c.transform(target, false), contextCache);
                    }
                }
                if (this.optimize_unique_closure && skippedStopStates == null && t !== $2DVsz.Token.EOF && reachIntermediate.uniqueAlt !== $bcnvE.ATN.INVALID_ALT_NUMBER) {
                    reachIntermediate.isOutermostConfigSet = reach.isOutermostConfigSet;
                    reach = reachIntermediate;
                    break;
                }
                let collectPredicates = false;
                let treatEofAsEpsilon = t === $2DVsz.Token.EOF;
                this.closure(reachIntermediate, reach, collectPredicates, hasMoreContext, contextCache, treatEofAsEpsilon);
                stepIntoGlobal = reach.dipsIntoOuterContext;
                if (t === $ceaEj.IntStream.EOF) reach = this.removeAllConfigsNotInRuleStopState(reach, contextCache);
                if (skippedStopStates != null && (!useContext || !$gDZVV.PredictionMode.hasConfigInRuleStopState(reach))) {
                    $bbHFU(skippedStopStates.length > 0);
                    for (let c of skippedStopStates)reach.add(c, contextCache);
                }
                if (useContext && stepIntoGlobal) {
                    reach.clear();
                    remainingGlobalContext;
                    remainingGlobalContext = this.skipTailCalls(remainingGlobalContext);
                    let nextContextElement = this.getReturnState(remainingGlobalContext);
                    if (contextElements == null) contextElements = new $37SGk.IntegerList();
                    if (remainingGlobalContext.isEmpty) remainingGlobalContext = undefined;
                    else remainingGlobalContext = remainingGlobalContext.parent;
                    contextElements.add(nextContextElement);
                    if (nextContextElement !== $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY) for(let i = 0; i < closureConfigs.length; i++)closureConfigs[i] = closureConfigs[i].appendContext(nextContextElement, contextCache);
                }
            }while (useContext && stepIntoGlobal)
            if (reach.isEmpty) {
                this.setDFAEdge(s, t, $kr9A1.ATNSimulator.ERROR);
                return [
                    $kr9A1.ATNSimulator.ERROR,
                    remainingGlobalContext
                ];
            }
            let result = this.addDFAEdge(dfa, s, t, contextElements, reach, contextCache);
            return [
                result,
                remainingGlobalContext
            ];
        }
        removeAllConfigsNotInRuleStopState(configs, contextCache) {
            if ($gDZVV.PredictionMode.allConfigsInRuleStopStates(configs)) return configs;
            let result = new $c1ClW.ATNConfigSet();
            for (let config of configs){
                if (!(config.state instanceof $4kGBm.RuleStopState)) continue;
                result.add(config, contextCache);
            }
            return result;
        }
        computeStartState(dfa, globalContext, useContext) {
            let s0 = dfa.isPrecedenceDfa ? dfa.getPrecedenceStartState(this._parser.precedence, useContext) : useContext ? dfa.s0full : dfa.s0;
            if (s0 != null) {
                if (!useContext) return new $g7SCF.SimulatorState(globalContext, s0, useContext, globalContext);
                s0.setContextSensitive(this.atn);
            }
            let decision = dfa.decision;
            let p = dfa.atnStartState;
            let previousContext = 0;
            let remainingGlobalContext = globalContext;
            let initialContext = useContext ? $8DTT0.PredictionContext.EMPTY_FULL : $8DTT0.PredictionContext.EMPTY_LOCAL;
            let contextCache = new $6vF7J.PredictionContextCache();
            if (useContext) {
                if (!this.enable_global_context_dfa) {
                    while(remainingGlobalContext != null)if (remainingGlobalContext.isEmpty) {
                        previousContext = $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY;
                        remainingGlobalContext = undefined;
                    } else {
                        previousContext = this.getReturnState(remainingGlobalContext);
                        initialContext = initialContext.appendSingleContext(previousContext, contextCache);
                        remainingGlobalContext = remainingGlobalContext.parent;
                    }
                }
                while(s0 != null && s0.isContextSensitive && remainingGlobalContext != null){
                    let next;
                    remainingGlobalContext = this.skipTailCalls(remainingGlobalContext);
                    if (remainingGlobalContext.isEmpty) {
                        next = s0.getContextTarget($8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY);
                        previousContext = $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY;
                        remainingGlobalContext = undefined;
                    } else {
                        previousContext = this.getReturnState(remainingGlobalContext);
                        next = s0.getContextTarget(previousContext);
                        initialContext = initialContext.appendSingleContext(previousContext, contextCache);
                        remainingGlobalContext = remainingGlobalContext.parent;
                    }
                    if (next == null) break;
                    s0 = next;
                }
            }
            if (s0 != null && !s0.isContextSensitive) return new $g7SCF.SimulatorState(globalContext, s0, useContext, remainingGlobalContext);
            let configs = new $c1ClW.ATNConfigSet();
            while(true){
                let reachIntermediate = new $c1ClW.ATNConfigSet();
                let n = p.numberOfTransitions;
                for(let ti = 0; ti < n; ti++){
                    let target = p.transition(ti).target;
                    reachIntermediate.add($gcX0f.ATNConfig.create(target, ti + 1, initialContext));
                }
                let hasMoreContext = remainingGlobalContext != null;
                if (!hasMoreContext) configs.isOutermostConfigSet = true;
                let collectPredicates = true;
                this.closure(reachIntermediate, configs, collectPredicates, hasMoreContext, contextCache, false);
                let stepIntoGlobal = configs.dipsIntoOuterContext;
                let next;
                if (useContext && !this.enable_global_context_dfa) {
                    s0 = this.addDFAState(dfa, configs, contextCache);
                    break;
                } else if (s0 == null) {
                    if (!dfa.isPrecedenceDfa) {
                        next = this.addDFAState(dfa, configs, contextCache);
                        if (useContext) {
                            if (!dfa.s0full) dfa.s0full = next;
                            else next = dfa.s0full;
                        } else if (!dfa.s0) dfa.s0 = next;
                        else next = dfa.s0;
                    } else {
                        configs = this.applyPrecedenceFilter(configs, globalContext, contextCache);
                        next = this.addDFAState(dfa, configs, contextCache);
                        dfa.setPrecedenceStartState(this._parser.precedence, useContext, next);
                    }
                } else {
                    if (dfa.isPrecedenceDfa) configs = this.applyPrecedenceFilter(configs, globalContext, contextCache);
                    next = this.addDFAState(dfa, configs, contextCache);
                    s0.setContextTarget(previousContext, next);
                }
                s0 = next;
                if (!useContext || !stepIntoGlobal) break;
                next.setContextSensitive(this.atn);
                remainingGlobalContext;
                configs.clear();
                remainingGlobalContext = this.skipTailCalls(remainingGlobalContext);
                let nextContextElement = this.getReturnState(remainingGlobalContext);
                if (remainingGlobalContext.isEmpty) remainingGlobalContext = undefined;
                else remainingGlobalContext = remainingGlobalContext.parent;
                if (nextContextElement !== $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY) initialContext = initialContext.appendSingleContext(nextContextElement, contextCache);
                previousContext = nextContextElement;
            }
            return new $g7SCF.SimulatorState(globalContext, s0, useContext, remainingGlobalContext);
        }
        applyPrecedenceFilter(configs, globalContext, contextCache) {
            let statesFromAlt1 = new Map();
            let configSet = new $c1ClW.ATNConfigSet();
            for (let config of configs){
                if (config.alt !== 1) continue;
                let updatedContext = config.semanticContext.evalPrecedence(this._parser, globalContext);
                if (updatedContext == null) continue;
                statesFromAlt1.set(config.state.stateNumber, config.context);
                if (updatedContext !== config.semanticContext) configSet.add(config.transform(config.state, false, updatedContext), contextCache);
                else configSet.add(config, contextCache);
            }
            for (let config of configs){
                if (config.alt === 1) continue;
                if (!config.isPrecedenceFilterSuppressed) {
                    let context = statesFromAlt1.get(config.state.stateNumber);
                    if (context != null && context.equals(config.context)) continue;
                }
                configSet.add(config, contextCache);
            }
            return configSet;
        }
        getReachableTarget(source, trans, ttype) {
            if (trans.matches(ttype, 0, this.atn.maxTokenType)) return trans.target;
            return undefined;
        }
        predicateDFAState(D, configs, nalts) {
            let conflictingAlts = this.getConflictingAltsFromConfigSet(configs);
            if (!conflictingAlts) throw new Error("This unhandled scenario is intended to be unreachable, but I'm currently not sure of why we know that's the case.");
            if (ParserATNSimulator.debug) console.log("predicateDFAState " + D);
            let altToPred = this.getPredsForAmbigAlts(conflictingAlts, configs, nalts);
            let predPredictions;
            if (altToPred != null) {
                predPredictions = this.getPredicatePredictions(conflictingAlts, altToPred);
                D.predicates = predPredictions;
            }
            return predPredictions;
        }
        getPredsForAmbigAlts(ambigAlts, configs, nalts) {
            let altToPred = new Array(nalts + 1);
            let n = altToPred.length;
            for (let c of configs)if (ambigAlts.get(c.alt)) altToPred[c.alt] = $eHMgW.SemanticContext.or(altToPred[c.alt], c.semanticContext);
            let nPredAlts = 0;
            for(let i = 0; i < n; i++){
                if (altToPred[i] == null) altToPred[i] = $eHMgW.SemanticContext.NONE;
                else if (altToPred[i] !== $eHMgW.SemanticContext.NONE) nPredAlts++;
            }
            let result = altToPred;
            if (nPredAlts === 0) result = undefined;
            if (ParserATNSimulator.debug) console.log("getPredsForAmbigAlts result " + (result ? $9yG1X.Arrays.toString(result) : "undefined"));
            return result;
        }
        getPredicatePredictions(ambigAlts, altToPred) {
            let pairs = [];
            let containsPredicate = false;
            for(let i = 1; i < altToPred.length; i++){
                let pred = altToPred[i];
                $bbHFU(pred != null);
                if (ambigAlts != null && ambigAlts.get(i) && pred === $eHMgW.SemanticContext.NONE) pairs.push(new $2jevZ.DFAState.PredPrediction(pred, i));
                else if (pred !== $eHMgW.SemanticContext.NONE) {
                    containsPredicate = true;
                    pairs.push(new $2jevZ.DFAState.PredPrediction(pred, i));
                }
            }
            if (!containsPredicate) return undefined;
            return pairs;
        }
        evalSemanticContext(predPredictions, outerContext, complete) {
            let predictions = new $5BPMp.BitSet();
            for (let pair of predPredictions){
                if (pair.pred === $eHMgW.SemanticContext.NONE) {
                    predictions.set(pair.alt);
                    if (!complete) break;
                    continue;
                }
                let evaluatedResult = this.evalSemanticContextImpl(pair.pred, outerContext, pair.alt);
                if (ParserATNSimulator.debug || ParserATNSimulator.dfa_debug) console.log("eval pred " + pair + "=" + evaluatedResult);
                if (evaluatedResult) {
                    if (ParserATNSimulator.debug || ParserATNSimulator.dfa_debug) console.log("PREDICT " + pair.alt);
                    predictions.set(pair.alt);
                    if (!complete) break;
                }
            }
            return predictions;
        }
        evalSemanticContextImpl(pred, parserCallStack, alt) {
            return pred.eval(this._parser, parserCallStack);
        }
        closure(sourceConfigs, configs, collectPredicates, hasMoreContext, contextCache, treatEofAsEpsilon) {
            if (contextCache == null) contextCache = $6vF7J.PredictionContextCache.UNCACHED;
            let currentConfigs = sourceConfigs;
            let closureBusy = new $7Veax.Array2DHashSet($a4Flx.ObjectEqualityComparator.INSTANCE);
            while(currentConfigs.size > 0){
                let intermediate = new $c1ClW.ATNConfigSet();
                for (let config of currentConfigs)this.closureImpl(config, configs, intermediate, closureBusy, collectPredicates, hasMoreContext, contextCache, 0, treatEofAsEpsilon);
                currentConfigs = intermediate;
            }
        }
        closureImpl(config, configs, intermediate, closureBusy, collectPredicates, hasMoreContexts, contextCache, depth, treatEofAsEpsilon) {
            if (ParserATNSimulator.debug) console.log("closure(" + config.toString(this._parser, true) + ")");
            if (config.state instanceof $4kGBm.RuleStopState) {
                if (!config.context.isEmpty) {
                    let hasEmpty = config.context.hasEmpty;
                    let nonEmptySize = config.context.size - (hasEmpty ? 1 : 0);
                    for(let i = 0; i < nonEmptySize; i++){
                        let newContext = config.context.getParent(i);
                        let returnState = this.atn.states[config.context.getReturnState(i)];
                        let c = $gcX0f.ATNConfig.create(returnState, config.alt, newContext, config.semanticContext);
                        c.outerContextDepth = config.outerContextDepth;
                        c.isPrecedenceFilterSuppressed = config.isPrecedenceFilterSuppressed;
                        $bbHFU(depth > $ef8fe7d2bd819f1c$var$MIN_INTEGER_VALUE);
                        this.closureImpl(c, configs, intermediate, closureBusy, collectPredicates, hasMoreContexts, contextCache, depth - 1, treatEofAsEpsilon);
                    }
                    if (!hasEmpty || !hasMoreContexts) return;
                    config = config.transform(config.state, false, $8DTT0.PredictionContext.EMPTY_LOCAL);
                } else if (!hasMoreContexts) {
                    configs.add(config, contextCache);
                    return;
                } else {
                    if (ParserATNSimulator.debug) console.log("FALLING off rule " + this.getRuleName(config.state.ruleIndex));
                    if (config.context === $8DTT0.PredictionContext.EMPTY_FULL) config = config.transform(config.state, false, $8DTT0.PredictionContext.EMPTY_LOCAL);
                    else if (!config.reachesIntoOuterContext && $8DTT0.PredictionContext.isEmptyLocal(config.context)) configs.add(config, contextCache);
                }
            }
            let p = config.state;
            if (!p.onlyHasEpsilonTransitions) {
                configs.add(config, contextCache);
                if (ParserATNSimulator.debug) console.log("added config " + configs);
            }
            for(let i = 0; i < p.numberOfOptimizedTransitions; i++){
                if (i === 0 && p.stateType === $1bs3X.ATNStateType.STAR_LOOP_ENTRY && p.precedenceRuleDecision && !config.context.hasEmpty) {
                    let precedenceDecision = p;
                    let suppress = true;
                    for(let j = 0; j < config.context.size; j++)if (!precedenceDecision.precedenceLoopbackStates.get(config.context.getReturnState(j))) {
                        suppress = false;
                        break;
                    }
                    if (suppress) continue;
                }
                let t = p.getOptimizedTransition(i);
                let continueCollecting = !(t instanceof $gxlfY.ActionTransition) && collectPredicates;
                let c = this.getEpsilonTarget(config, t, continueCollecting, depth === 0, contextCache, treatEofAsEpsilon);
                if (c != null) {
                    if (t instanceof $aybFP.RuleTransition) {
                        if (intermediate != null && !collectPredicates) {
                            intermediate.add(c, contextCache);
                            continue;
                        }
                    }
                    let newDepth = depth;
                    if (config.state instanceof $4kGBm.RuleStopState) {
                        if (this.dfa != null && this.dfa.isPrecedenceDfa) {
                            let outermostPrecedenceReturn = t.outermostPrecedenceReturn;
                            if (outermostPrecedenceReturn === this.dfa.atnStartState.ruleIndex) c.isPrecedenceFilterSuppressed = true;
                        }
                        c.outerContextDepth = c.outerContextDepth + 1;
                        if (!closureBusy.add(c)) continue;
                        $bbHFU(newDepth > $ef8fe7d2bd819f1c$var$MIN_INTEGER_VALUE);
                        newDepth--;
                        if (ParserATNSimulator.debug) console.log("dips into outer ctx: " + c);
                    } else if (t instanceof $aybFP.RuleTransition) {
                        if (this.optimize_tail_calls && t.optimizedTailCall && (!this.tail_call_preserves_sll || !$8DTT0.PredictionContext.isEmptyLocal(config.context))) {
                            $bbHFU(c.context === config.context);
                            if (newDepth === 0) {
                                newDepth--;
                                if (!this.tail_call_preserves_sll && $8DTT0.PredictionContext.isEmptyLocal(config.context)) c.outerContextDepth = c.outerContextDepth + 1;
                            }
                        } else if (newDepth >= 0) newDepth++;
                    } else {
                        if (!t.isEpsilon && !closureBusy.add(c)) continue;
                    }
                    this.closureImpl(c, configs, intermediate, closureBusy, continueCollecting, hasMoreContexts, contextCache, newDepth, treatEofAsEpsilon);
                }
            }
        }
        getRuleName(index) {
            if (this._parser != null && index >= 0) return this._parser.ruleNames[index];
            return "<rule " + index + ">";
        }
        getEpsilonTarget(config, t, collectPredicates, inContext, contextCache, treatEofAsEpsilon) {
            switch(t.serializationType){
                case 3:
                    return this.ruleTransition(config, t, contextCache);
                case 10:
                    return this.precedenceTransition(config, t, collectPredicates, inContext);
                case 4:
                    return this.predTransition(config, t, collectPredicates, inContext);
                case 6:
                    return this.actionTransition(config, t);
                case 1:
                    return config.transform(t.target, false);
                case 5:
                case 2:
                case 7:
                    if (treatEofAsEpsilon) {
                        if (t.matches($2DVsz.Token.EOF, 0, 1)) return config.transform(t.target, false);
                    }
                    return undefined;
                default:
                    return undefined;
            }
        }
        actionTransition(config, t) {
            if (ParserATNSimulator.debug) console.log("ACTION edge " + t.ruleIndex + ":" + t.actionIndex);
            return config.transform(t.target, false);
        }
        precedenceTransition(config, pt, collectPredicates, inContext) {
            if (ParserATNSimulator.debug) {
                console.log("PRED (collectPredicates=" + collectPredicates + ") " + pt.precedence + ">=_p" + ", ctx dependent=true");
                if (this._parser != null) console.log("context surrounding pred is " + this._parser.getRuleInvocationStack());
            }
            let c;
            if (collectPredicates && inContext) {
                let newSemCtx = $eHMgW.SemanticContext.and(config.semanticContext, pt.predicate);
                c = config.transform(pt.target, false, newSemCtx);
            } else c = config.transform(pt.target, false);
            if (ParserATNSimulator.debug) console.log("config from pred transition=" + c);
            return c;
        }
        predTransition(config, pt, collectPredicates, inContext) {
            if (ParserATNSimulator.debug) {
                console.log("PRED (collectPredicates=" + collectPredicates + ") " + pt.ruleIndex + ":" + pt.predIndex + ", ctx dependent=" + pt.isCtxDependent);
                if (this._parser != null) console.log("context surrounding pred is " + this._parser.getRuleInvocationStack());
            }
            let c;
            if (collectPredicates && (!pt.isCtxDependent || pt.isCtxDependent && inContext)) {
                let newSemCtx = $eHMgW.SemanticContext.and(config.semanticContext, pt.predicate);
                c = config.transform(pt.target, false, newSemCtx);
            } else c = config.transform(pt.target, false);
            if (ParserATNSimulator.debug) console.log("config from pred transition=" + c);
            return c;
        }
        ruleTransition(config, t, contextCache) {
            if (ParserATNSimulator.debug) console.log("CALL rule " + this.getRuleName(t.target.ruleIndex) + ", ctx=" + config.context);
            let returnState = t.followState;
            let newContext;
            if (this.optimize_tail_calls && t.optimizedTailCall && (!this.tail_call_preserves_sll || !$8DTT0.PredictionContext.isEmptyLocal(config.context))) newContext = config.context;
            else if (contextCache != null) newContext = contextCache.getChild(config.context, returnState.stateNumber);
            else newContext = config.context.getChild(returnState.stateNumber);
            return config.transform(t.target, false, newContext);
        }
        isConflicted(configset, contextCache) {
            if (configset.uniqueAlt !== $bcnvE.ATN.INVALID_ALT_NUMBER || configset.size <= 1) return undefined;
            let configs = configset.toArray();
            configs.sort(ParserATNSimulator.STATE_ALT_SORT_COMPARATOR);
            let exact = !configset.dipsIntoOuterContext;
            let alts = new $5BPMp.BitSet();
            let minAlt = configs[0].alt;
            alts.set(minAlt);
            let currentState = configs[0].state.nonStopStateNumber;
            for (let config of configs){
                let stateNumber = config.state.nonStopStateNumber;
                if (stateNumber !== currentState) {
                    if (config.alt !== minAlt) return undefined;
                    currentState = stateNumber;
                }
            }
            let representedAlts;
            if (exact) {
                currentState = configs[0].state.nonStopStateNumber;
                representedAlts = new $5BPMp.BitSet();
                let maxAlt = minAlt;
                for (let config of configs){
                    if (config.state.nonStopStateNumber !== currentState) break;
                    let alt = config.alt;
                    representedAlts.set(alt);
                    maxAlt = alt;
                }
                currentState = configs[0].state.nonStopStateNumber;
                let currentAlt = minAlt;
                for (let config of configs){
                    let stateNumber = config.state.nonStopStateNumber;
                    let alt = config.alt;
                    if (stateNumber !== currentState) {
                        if (currentAlt !== maxAlt) {
                            exact = false;
                            break;
                        }
                        currentState = stateNumber;
                        currentAlt = minAlt;
                    } else if (alt !== currentAlt) {
                        if (alt !== representedAlts.nextSetBit(currentAlt + 1)) {
                            exact = false;
                            break;
                        }
                        currentAlt = alt;
                    }
                }
            }
            currentState = configs[0].state.nonStopStateNumber;
            let firstIndexCurrentState = 0;
            let lastIndexCurrentStateMinAlt = 0;
            let joinedCheckContext = configs[0].context;
            for(let i = 1; i < configs.length; i++){
                let config = configs[i];
                if (config.alt !== minAlt) break;
                if (config.state.nonStopStateNumber !== currentState) break;
                lastIndexCurrentStateMinAlt = i;
                joinedCheckContext = contextCache.join(joinedCheckContext, configs[i].context);
            }
            for(let i = lastIndexCurrentStateMinAlt + 1; i < configs.length; i++){
                let config = configs[i];
                let state = config.state;
                alts.set(config.alt);
                if (state.nonStopStateNumber !== currentState) {
                    currentState = state.nonStopStateNumber;
                    firstIndexCurrentState = i;
                    lastIndexCurrentStateMinAlt = i;
                    joinedCheckContext = config.context;
                    for(let j = firstIndexCurrentState + 1; j < configs.length; j++){
                        let config2 = configs[j];
                        if (config2.alt !== minAlt) break;
                        if (config2.state.nonStopStateNumber !== currentState) break;
                        lastIndexCurrentStateMinAlt = j;
                        joinedCheckContext = contextCache.join(joinedCheckContext, config2.context);
                    }
                    i = lastIndexCurrentStateMinAlt;
                    continue;
                }
                let joinedCheckContext2 = config.context;
                let currentAlt = config.alt;
                let lastIndexCurrentStateCurrentAlt = i;
                for(let j = lastIndexCurrentStateCurrentAlt + 1; j < configs.length; j++){
                    let config2 = configs[j];
                    if (config2.alt !== currentAlt) break;
                    if (config2.state.nonStopStateNumber !== currentState) break;
                    lastIndexCurrentStateCurrentAlt = j;
                    joinedCheckContext2 = contextCache.join(joinedCheckContext2, config2.context);
                }
                i = lastIndexCurrentStateCurrentAlt;
                let check = contextCache.join(joinedCheckContext, joinedCheckContext2);
                if (!joinedCheckContext.equals(check)) return undefined;
                exact = exact && joinedCheckContext.equals(joinedCheckContext2);
            }
            return new $gsRaX.ConflictInfo(alts, exact);
        }
        getConflictingAltsFromConfigSet(configs) {
            let conflictingAlts = configs.conflictingAlts;
            if (conflictingAlts == null && configs.uniqueAlt !== $bcnvE.ATN.INVALID_ALT_NUMBER) {
                conflictingAlts = new $5BPMp.BitSet();
                conflictingAlts.set(configs.uniqueAlt);
            }
            return conflictingAlts;
        }
        getTokenName(t) {
            if (t === $2DVsz.Token.EOF) return "EOF";
            let vocabulary = this._parser != null ? this._parser.vocabulary : $3n2FE.VocabularyImpl.EMPTY_VOCABULARY;
            let displayName = vocabulary.getDisplayName(t);
            if (displayName === String(t)) return displayName;
            return displayName + "<" + t + ">";
        }
        getLookaheadName(input) {
            return this.getTokenName(input.LA(1));
        }
        dumpDeadEndConfigs(nvae) {
            console.log("dead end configs: ");
            let deadEndConfigs = nvae.deadEndConfigs;
            if (!deadEndConfigs) return;
            for (let c of deadEndConfigs){
                let trans = "no edges";
                if (c.state.numberOfOptimizedTransitions > 0) {
                    let t = c.state.getOptimizedTransition(0);
                    if (t instanceof $5r7n7.AtomTransition) trans = "Atom " + this.getTokenName(t._label);
                    else if (t instanceof $Np2R3.SetTransition) {
                        let not = t instanceof $FLEKS.NotSetTransition;
                        trans = (not ? "~" : "") + "Set " + t.set.toString();
                    }
                }
                console.log(c.toString(this._parser, true) + ":" + trans);
            }
        }
        noViableAlt(input, outerContext, configs, startIndex) {
            return new $hKCjP.NoViableAltException(this._parser, input, input.get(startIndex), input.LT(1), configs, outerContext);
        }
        getUniqueAlt(configs) {
            let alt = $bcnvE.ATN.INVALID_ALT_NUMBER;
            for (let c of configs){
                if (alt === $bcnvE.ATN.INVALID_ALT_NUMBER) alt = c.alt;
                else if (c.alt !== alt) return $bcnvE.ATN.INVALID_ALT_NUMBER;
            }
            return alt;
        }
        configWithAltAtStopState(configs, alt) {
            for (let c of configs)if (c.alt === alt) {
                if (c.state instanceof $4kGBm.RuleStopState) return true;
            }
            return false;
        }
        addDFAEdge(dfa, fromState, t, contextTransitions, toConfigs, contextCache) {
            $bbHFU(contextTransitions == null || contextTransitions.isEmpty || dfa.isContextSensitive);
            let from = fromState;
            let to = this.addDFAState(dfa, toConfigs, contextCache);
            if (contextTransitions != null) for (let context of contextTransitions.toArray()){
                if (context === $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY) {
                    if (from.configs.isOutermostConfigSet) continue;
                }
                from.setContextSensitive(this.atn);
                from.setContextSymbol(t);
                let next = from.getContextTarget(context);
                if (next != null) {
                    from = next;
                    continue;
                }
                next = this.addDFAContextState(dfa, from.configs, context, contextCache);
                $bbHFU(context !== $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY || next.configs.isOutermostConfigSet);
                from.setContextTarget(context, next);
                from = next;
            }
            if (ParserATNSimulator.debug) console.log("EDGE " + from + " -> " + to + " upon " + this.getTokenName(t));
            this.setDFAEdge(from, t, to);
            if (ParserATNSimulator.debug) console.log("DFA=\n" + dfa.toString(this._parser != null ? this._parser.vocabulary : $3n2FE.VocabularyImpl.EMPTY_VOCABULARY, this._parser != null ? this._parser.ruleNames : undefined));
            return to;
        }
        setDFAEdge(p, t, q) {
            if (p != null) p.setTarget(t, q);
        }
        addDFAContextState(dfa, configs, returnContext, contextCache) {
            if (returnContext !== $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY) {
                let contextConfigs = new $c1ClW.ATNConfigSet();
                for (let config of configs)contextConfigs.add(config.appendContext(returnContext, contextCache));
                return this.addDFAState(dfa, contextConfigs, contextCache);
            } else {
                $bbHFU(!configs.isOutermostConfigSet, "Shouldn't be adding a duplicate edge.");
                configs = configs.clone(true);
                configs.isOutermostConfigSet = true;
                return this.addDFAState(dfa, configs, contextCache);
            }
        }
        addDFAState(dfa, configs, contextCache) {
            let enableDfa = this.enable_global_context_dfa || !configs.isOutermostConfigSet;
            if (enableDfa) {
                if (!configs.isReadOnly) configs.optimizeConfigs(this);
                let proposed = this.createDFAState(dfa, configs);
                let existing = dfa.states.get(proposed);
                if (existing != null) return existing;
            }
            if (!configs.isReadOnly) {
                if (configs.conflictInfo == null) configs.conflictInfo = this.isConflicted(configs, contextCache);
            }
            let newState = this.createDFAState(dfa, configs.clone(true));
            let decisionState = this.atn.getDecisionState(dfa.decision);
            let predictedAlt = this.getUniqueAlt(configs);
            if (predictedAlt !== $bcnvE.ATN.INVALID_ALT_NUMBER) newState.acceptStateInfo = new $41NTU.AcceptStateInfo(predictedAlt);
            else if (configs.conflictingAlts != null) {
                let conflictingAlts = configs.conflictingAlts;
                if (conflictingAlts) newState.acceptStateInfo = new $41NTU.AcceptStateInfo(conflictingAlts.nextSetBit(0));
            }
            if (newState.isAcceptState && configs.hasSemanticContext) this.predicateDFAState(newState, configs, decisionState.numberOfTransitions);
            if (!enableDfa) return newState;
            let added = dfa.addState(newState);
            if (ParserATNSimulator.debug && added === newState) console.log("adding new DFA state: " + newState);
            return added;
        }
        createDFAState(dfa, configs) {
            return new $2jevZ.DFAState(configs);
        }
        reportAttemptingFullContext(dfa, conflictingAlts, conflictState, startIndex, stopIndex) {
            if (ParserATNSimulator.debug || ParserATNSimulator.retry_debug) {
                let interval = $gcfUE.Interval.of(startIndex, stopIndex);
                console.log("reportAttemptingFullContext decision=" + dfa.decision + ":" + conflictState.s0.configs + ", input=" + this._parser.inputStream.getText(interval));
            }
            if (this._parser != null) {
                let listener = this._parser.getErrorListenerDispatch();
                if (listener.reportAttemptingFullContext) listener.reportAttemptingFullContext(this._parser, dfa, startIndex, stopIndex, conflictingAlts, conflictState);
            }
        }
        reportContextSensitivity(dfa, prediction, acceptState, startIndex, stopIndex) {
            if (ParserATNSimulator.debug || ParserATNSimulator.retry_debug) {
                let interval = $gcfUE.Interval.of(startIndex, stopIndex);
                console.log("reportContextSensitivity decision=" + dfa.decision + ":" + acceptState.s0.configs + ", input=" + this._parser.inputStream.getText(interval));
            }
            if (this._parser != null) {
                let listener = this._parser.getErrorListenerDispatch();
                if (listener.reportContextSensitivity) listener.reportContextSensitivity(this._parser, dfa, startIndex, stopIndex, prediction, acceptState);
            }
        }
        reportAmbiguity(dfa, D, startIndex, stopIndex, exact, ambigAlts, configs) {
            if (ParserATNSimulator.debug || ParserATNSimulator.retry_debug) {
                let interval = $gcfUE.Interval.of(startIndex, stopIndex);
                console.log("reportAmbiguity " + ambigAlts + ":" + configs + ", input=" + this._parser.inputStream.getText(interval));
            }
            if (this._parser != null) {
                let listener = this._parser.getErrorListenerDispatch();
                if (listener.reportAmbiguity) listener.reportAmbiguity(this._parser, dfa, startIndex, stopIndex, exact, ambigAlts, configs);
            }
        }
        getReturnState(context) {
            if (context.isEmpty) return $8DTT0.PredictionContext.EMPTY_FULL_STATE_KEY;
            let state = this.atn.states[context.invokingState];
            let transition = state.transition(0);
            return transition.followState.stateNumber;
        }
        skipTailCalls(context) {
            if (!this.optimize_tail_calls) return context;
            while(!context.isEmpty){
                let state = this.atn.states[context.invokingState];
                $bbHFU(state.numberOfTransitions === 1 && state.transition(0).serializationType === 3);
                let transition = state.transition(0);
                if (!transition.tailCall) break;
                context = context.parent;
            }
            return context;
        }
        get parser() {
            return this._parser;
        }
    };
    $ef8fe7d2bd819f1c$var$ParserATNSimulator.debug = false;
    $ef8fe7d2bd819f1c$var$ParserATNSimulator.dfa_debug = false;
    $ef8fe7d2bd819f1c$var$ParserATNSimulator.retry_debug = false;
    $ef8fe7d2bd819f1c$var$ParserATNSimulator.STATE_ALT_SORT_COMPARATOR = (o1, o2)=>{
        let diff = o1.state.nonStopStateNumber - o2.state.nonStopStateNumber;
        if (diff !== 0) return diff;
        diff = o1.alt - o2.alt;
        if (diff !== 0) return diff;
        return 0;
    };
    $ef8fe7d2bd819f1c$var$__decorate([
        $d6D31.NotNull
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "predictionMode", void 0);
    $ef8fe7d2bd819f1c$var$__decorate([
        $d6D31.NotNull
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "getPredictionMode", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "setPredictionMode", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $d6D31.Override
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "reset", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "adaptivePredict", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(2, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "getStartState", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(3, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "execDFA", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(3, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "execATN", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(2, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "handleNoViableAlt", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "getExistingTargetState", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $d6D31.NotNull,
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "computeTargetState", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $d6D31.NotNull,
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "removeAllConfigsNotInRuleStopState", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $d6D31.NotNull
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "computeStartState", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $d6D31.NotNull,
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "applyPrecedenceFilter", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "getReachableTarget", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "getPredsForAmbigAlts", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "evalSemanticContext", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "evalSemanticContextImpl", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(4, $d6D31.Nullable)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "closure", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(2, $d6D31.Nullable),
        $ef8fe7d2bd819f1c$var$__param(3, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(6, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "closureImpl", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $d6D31.NotNull
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "getRuleName", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "getEpsilonTarget", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $d6D31.NotNull,
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "actionTransition", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $d6D31.Nullable,
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "precedenceTransition", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $d6D31.Nullable,
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "predTransition", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $d6D31.NotNull,
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(2, $d6D31.Nullable)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "ruleTransition", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "isConflicted", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $d6D31.NotNull
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "getTokenName", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "dumpDeadEndConfigs", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $d6D31.NotNull,
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(2, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "noViableAlt", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "getUniqueAlt", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "configWithAltAtStopState", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $d6D31.NotNull,
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(4, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "addDFAEdge", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.Nullable),
        $ef8fe7d2bd819f1c$var$__param(2, $d6D31.Nullable)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "setDFAEdge", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $d6D31.NotNull,
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "addDFAContextState", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $d6D31.NotNull,
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "addDFAState", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $d6D31.NotNull,
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(1, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "createDFAState", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(2, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "reportAttemptingFullContext", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(2, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "reportContextSensitivity", null);
    $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(5, $d6D31.NotNull),
        $ef8fe7d2bd819f1c$var$__param(6, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator.prototype, "reportAmbiguity", null);
    $ef8fe7d2bd819f1c$var$ParserATNSimulator = $ef8fe7d2bd819f1c$var$__decorate([
        $ef8fe7d2bd819f1c$var$__param(0, $d6D31.NotNull)
    ], $ef8fe7d2bd819f1c$var$ParserATNSimulator);
    module.exports.ParserATNSimulator = $ef8fe7d2bd819f1c$var$ParserATNSimulator;
});
parcelRegister("gsRaX", function(module, exports) {
    "use strict";
    var $bfc8827830a146f2$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ConflictInfo = void 0;
    var $d6D31 = parcelRequire("d6D31");
    var $2IEP9 = parcelRequire("2IEP9");
    class $bfc8827830a146f2$var$ConflictInfo {
        constructor(conflictedAlts, exact){
            this._conflictedAlts = conflictedAlts;
            this.exact = exact;
        }
        get conflictedAlts() {
            return this._conflictedAlts;
        }
        get isExact() {
            return this.exact;
        }
        equals(obj) {
            if (obj === this) return true;
            else if (!(obj instanceof $bfc8827830a146f2$var$ConflictInfo)) return false;
            return this.isExact === obj.isExact && $2IEP9.equals(this.conflictedAlts, obj.conflictedAlts);
        }
        hashCode() {
            return this.conflictedAlts.hashCode();
        }
    }
    $bfc8827830a146f2$var$__decorate([
        $d6D31.Override
    ], $bfc8827830a146f2$var$ConflictInfo.prototype, "equals", null);
    $bfc8827830a146f2$var$__decorate([
        $d6D31.Override
    ], $bfc8827830a146f2$var$ConflictInfo.prototype, "hashCode", null);
    module.exports.ConflictInfo = $bfc8827830a146f2$var$ConflictInfo;
});
parcelRegister("6bmaO", function(module, exports) {
    "use strict";
    var $4804f857ecc73c01$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ParserRuleContext = void 0;
    var $cdCft = parcelRequire("cdCft");
    var $gcfUE = parcelRequire("gcfUE");
    var $d6D31 = parcelRequire("d6D31");
    var $c8jEe = parcelRequire("c8jEe");
    var $kYC92 = parcelRequire("kYC92");
    class $4804f857ecc73c01$var$ParserRuleContext extends $c8jEe.RuleContext {
        constructor(parent, invokingStateNumber){
            if (invokingStateNumber == null) super();
            else super(parent, invokingStateNumber);
        }
        static emptyContext() {
            return $4804f857ecc73c01$var$ParserRuleContext.EMPTY;
        }
        copyFrom(ctx) {
            this._parent = ctx._parent;
            this.invokingState = ctx.invokingState;
            this._start = ctx._start;
            this._stop = ctx._stop;
            if (ctx.children) {
                this.children = [];
                for (let child of ctx.children)if (child instanceof $cdCft.ErrorNode) this.addChild(child);
            }
        }
        enterRule(listener) {}
        exitRule(listener) {}
        addAnyChild(t) {
            if (!this.children) this.children = [
                t
            ];
            else this.children.push(t);
            return t;
        }
        addChild(t) {
            let result;
            if (t instanceof $kYC92.TerminalNode) {
                t.setParent(this);
                this.addAnyChild(t);
                return;
            } else if (t instanceof $c8jEe.RuleContext) {
                this.addAnyChild(t);
                return;
            } else {
                t = new $kYC92.TerminalNode(t);
                this.addAnyChild(t);
                t.setParent(this);
                return t;
            }
        }
        addErrorNode(node) {
            if (node instanceof $cdCft.ErrorNode) {
                const errorNode = node;
                errorNode.setParent(this);
                return this.addAnyChild(errorNode);
            } else {
                const badToken = node;
                let t = new $cdCft.ErrorNode(badToken);
                this.addAnyChild(t);
                t.setParent(this);
                return t;
            }
        }
        removeLastChild() {
            if (this.children) this.children.pop();
        }
        get parent() {
            let parent = super.parent;
            if (parent === undefined || parent instanceof $4804f857ecc73c01$var$ParserRuleContext) return parent;
            throw new TypeError("Invalid parent type for ParserRuleContext");
        }
        getChild(i, ctxType) {
            if (!this.children || i < 0 || i >= this.children.length) throw new RangeError("index parameter must be between >= 0 and <= number of children.");
            if (ctxType == null) return this.children[i];
            let result = this.tryGetChild(i, ctxType);
            if (result === undefined) throw new Error("The specified node does not exist");
            return result;
        }
        tryGetChild(i, ctxType) {
            if (!this.children || i < 0 || i >= this.children.length) return undefined;
            let j = -1;
            for (let o of this.children)if (o instanceof ctxType) {
                j++;
                if (j === i) return o;
            }
            return undefined;
        }
        getToken(ttype, i) {
            let result = this.tryGetToken(ttype, i);
            if (result === undefined) throw new Error("The specified token does not exist");
            return result;
        }
        tryGetToken(ttype, i) {
            if (!this.children || i < 0 || i >= this.children.length) return undefined;
            let j = -1;
            for (let o of this.children)if (o instanceof $kYC92.TerminalNode) {
                let symbol = o.symbol;
                if (symbol.type === ttype) {
                    j++;
                    if (j === i) return o;
                }
            }
            return undefined;
        }
        getTokens(ttype) {
            let tokens = [];
            if (!this.children) return tokens;
            for (let o of this.children)if (o instanceof $kYC92.TerminalNode) {
                let symbol = o.symbol;
                if (symbol.type === ttype) tokens.push(o);
            }
            return tokens;
        }
        get ruleContext() {
            return this;
        }
        getRuleContext(i, ctxType) {
            return this.getChild(i, ctxType);
        }
        tryGetRuleContext(i, ctxType) {
            return this.tryGetChild(i, ctxType);
        }
        getRuleContexts(ctxType) {
            let contexts = [];
            if (!this.children) return contexts;
            for (let o of this.children)if (o instanceof ctxType) contexts.push(o);
            return contexts;
        }
        get childCount() {
            return this.children ? this.children.length : 0;
        }
        get sourceInterval() {
            if (!this._start) return $gcfUE.Interval.INVALID;
            if (!this._stop || this._stop.tokenIndex < this._start.tokenIndex) return $gcfUE.Interval.of(this._start.tokenIndex, this._start.tokenIndex - 1);
            return $gcfUE.Interval.of(this._start.tokenIndex, this._stop.tokenIndex);
        }
        get start() {
            return this._start;
        }
        get stop() {
            return this._stop;
        }
        toInfoString(recognizer) {
            let rules = recognizer.getRuleInvocationStack(this).reverse();
            return "ParserRuleContext" + rules + "{" + "start=" + this._start + ", stop=" + this._stop + "}";
        }
    }
    $4804f857ecc73c01$var$ParserRuleContext.EMPTY = new $4804f857ecc73c01$var$ParserRuleContext();
    $4804f857ecc73c01$var$__decorate([
        $d6D31.Override
    ], $4804f857ecc73c01$var$ParserRuleContext.prototype, "parent", null);
    $4804f857ecc73c01$var$__decorate([
        $d6D31.Override
    ], $4804f857ecc73c01$var$ParserRuleContext.prototype, "childCount", null);
    $4804f857ecc73c01$var$__decorate([
        $d6D31.Override
    ], $4804f857ecc73c01$var$ParserRuleContext.prototype, "sourceInterval", null);
    module.exports.ParserRuleContext = $4804f857ecc73c01$var$ParserRuleContext;
});
parcelRegister("cdCft", function(module, exports) {
    "use strict";
    var $8e545e4dd69efabc$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ErrorNode = void 0;
    var $d6D31 = parcelRequire("d6D31");
    var $kYC92 = parcelRequire("kYC92");
    class $8e545e4dd69efabc$var$ErrorNode extends $kYC92.TerminalNode {
        constructor(token){
            super(token);
        }
        accept(visitor) {
            return visitor.visitErrorNode(this);
        }
    }
    $8e545e4dd69efabc$var$__decorate([
        $d6D31.Override
    ], $8e545e4dd69efabc$var$ErrorNode.prototype, "accept", null);
    module.exports.ErrorNode = $8e545e4dd69efabc$var$ErrorNode;
});
parcelRegister("kYC92", function(module, exports) {
    "use strict";
    var $f4570001c9e8b34c$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.TerminalNode = void 0;
    var $gcfUE = parcelRequire("gcfUE");
    var $d6D31 = parcelRequire("d6D31");
    var $2DVsz = parcelRequire("2DVsz");
    class $f4570001c9e8b34c$var$TerminalNode {
        constructor(symbol){
            this._symbol = symbol;
        }
        getChild(i) {
            throw new RangeError("Terminal Node has no children.");
        }
        get symbol() {
            return this._symbol;
        }
        get parent() {
            return this._parent;
        }
        setParent(parent) {
            this._parent = parent;
        }
        get payload() {
            return this._symbol;
        }
        get sourceInterval() {
            let tokenIndex = this._symbol.tokenIndex;
            return new $gcfUE.Interval(tokenIndex, tokenIndex);
        }
        get childCount() {
            return 0;
        }
        accept(visitor) {
            return visitor.visitTerminal(this);
        }
        get text() {
            return this._symbol.text || "";
        }
        toStringTree(parser) {
            return this.toString();
        }
        toString() {
            if (this._symbol.type === $2DVsz.Token.EOF) return "<EOF>";
            return this._symbol.text || "";
        }
    }
    $f4570001c9e8b34c$var$__decorate([
        $d6D31.Override
    ], $f4570001c9e8b34c$var$TerminalNode.prototype, "getChild", null);
    $f4570001c9e8b34c$var$__decorate([
        $d6D31.Override
    ], $f4570001c9e8b34c$var$TerminalNode.prototype, "parent", null);
    $f4570001c9e8b34c$var$__decorate([
        $d6D31.Override
    ], $f4570001c9e8b34c$var$TerminalNode.prototype, "setParent", null);
    $f4570001c9e8b34c$var$__decorate([
        $d6D31.Override
    ], $f4570001c9e8b34c$var$TerminalNode.prototype, "payload", null);
    $f4570001c9e8b34c$var$__decorate([
        $d6D31.Override
    ], $f4570001c9e8b34c$var$TerminalNode.prototype, "sourceInterval", null);
    $f4570001c9e8b34c$var$__decorate([
        $d6D31.Override
    ], $f4570001c9e8b34c$var$TerminalNode.prototype, "childCount", null);
    $f4570001c9e8b34c$var$__decorate([
        $d6D31.Override
    ], $f4570001c9e8b34c$var$TerminalNode.prototype, "accept", null);
    $f4570001c9e8b34c$var$__decorate([
        $d6D31.Override
    ], $f4570001c9e8b34c$var$TerminalNode.prototype, "text", null);
    $f4570001c9e8b34c$var$__decorate([
        $d6D31.Override
    ], $f4570001c9e8b34c$var$TerminalNode.prototype, "toStringTree", null);
    $f4570001c9e8b34c$var$__decorate([
        $d6D31.Override
    ], $f4570001c9e8b34c$var$TerminalNode.prototype, "toString", null);
    module.exports.TerminalNode = $f4570001c9e8b34c$var$TerminalNode;
});
parcelRegister("c8jEe", function(module, exports) {
    "use strict";
    var $8d557908ece2e6d0$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.RuleContext = void 0;
    var $bcnvE = parcelRequire("bcnvE");
    var $kBaAZ = parcelRequire("kBaAZ");
    var $2WQcE = parcelRequire("2WQcE");
    var $gcfUE = parcelRequire("gcfUE");
    var $d6D31 = parcelRequire("d6D31");
    var $axprj = parcelRequire("axprj");
    var $6bmaO = parcelRequire("6bmaO");
    class $8d557908ece2e6d0$var$RuleContext extends $2WQcE.RuleNode {
        constructor(parent, invokingState){
            super();
            this._parent = parent;
            this.invokingState = invokingState != null ? invokingState : -1;
        }
        static getChildContext(parent, invokingState) {
            return new $8d557908ece2e6d0$var$RuleContext(parent, invokingState);
        }
        depth() {
            let n = 0;
            let p = this;
            while(p){
                p = p._parent;
                n++;
            }
            return n;
        }
        get isEmpty() {
            return this.invokingState === -1;
        }
        get sourceInterval() {
            return $gcfUE.Interval.INVALID;
        }
        get ruleContext() {
            return this;
        }
        get parent() {
            return this._parent;
        }
        setParent(parent) {
            this._parent = parent;
        }
        get payload() {
            return this;
        }
        get text() {
            if (this.childCount === 0) return "";
            let builder = "";
            for(let i = 0; i < this.childCount; i++)builder += this.getChild(i).text;
            return builder.toString();
        }
        get ruleIndex() {
            return -1;
        }
        get altNumber() {
            return $bcnvE.ATN.INVALID_ALT_NUMBER;
        }
        set altNumber(altNumber) {}
        getChild(i) {
            throw new RangeError("i must be greater than or equal to 0 and less than childCount");
        }
        get childCount() {
            return 0;
        }
        accept(visitor) {
            return visitor.visitChildren(this);
        }
        toStringTree(recog) {
            return $axprj.Trees.toStringTree(this, recog);
        }
        toString(arg1, stop) {
            const ruleNames = arg1 instanceof $kBaAZ.Recognizer ? arg1.ruleNames : arg1;
            stop = stop || $6bmaO.ParserRuleContext.emptyContext();
            let buf = "";
            let p = this;
            buf += "[";
            while(p && p !== stop){
                if (!ruleNames) {
                    if (!p.isEmpty) buf += p.invokingState;
                } else {
                    let ruleIndex = p.ruleIndex;
                    let ruleName = ruleIndex >= 0 && ruleIndex < ruleNames.length ? ruleNames[ruleIndex] : ruleIndex.toString();
                    buf += ruleName;
                }
                if (p._parent && (ruleNames || !p._parent.isEmpty)) buf += " ";
                p = p._parent;
            }
            buf += "]";
            return buf.toString();
        }
    }
    $8d557908ece2e6d0$var$__decorate([
        $d6D31.Override
    ], $8d557908ece2e6d0$var$RuleContext.prototype, "sourceInterval", null);
    $8d557908ece2e6d0$var$__decorate([
        $d6D31.Override
    ], $8d557908ece2e6d0$var$RuleContext.prototype, "ruleContext", null);
    $8d557908ece2e6d0$var$__decorate([
        $d6D31.Override
    ], $8d557908ece2e6d0$var$RuleContext.prototype, "parent", null);
    $8d557908ece2e6d0$var$__decorate([
        $d6D31.Override
    ], $8d557908ece2e6d0$var$RuleContext.prototype, "setParent", null);
    $8d557908ece2e6d0$var$__decorate([
        $d6D31.Override
    ], $8d557908ece2e6d0$var$RuleContext.prototype, "payload", null);
    $8d557908ece2e6d0$var$__decorate([
        $d6D31.Override
    ], $8d557908ece2e6d0$var$RuleContext.prototype, "text", null);
    $8d557908ece2e6d0$var$__decorate([
        $d6D31.Override
    ], $8d557908ece2e6d0$var$RuleContext.prototype, "getChild", null);
    $8d557908ece2e6d0$var$__decorate([
        $d6D31.Override
    ], $8d557908ece2e6d0$var$RuleContext.prototype, "childCount", null);
    $8d557908ece2e6d0$var$__decorate([
        $d6D31.Override
    ], $8d557908ece2e6d0$var$RuleContext.prototype, "accept", null);
    $8d557908ece2e6d0$var$__decorate([
        $d6D31.Override
    ], $8d557908ece2e6d0$var$RuleContext.prototype, "toStringTree", null);
    module.exports.RuleContext = $8d557908ece2e6d0$var$RuleContext;
});
parcelRegister("2WQcE", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.RuleNode = void 0;
    class $22597dffc9942eb7$var$RuleNode {
    }
    module.exports.RuleNode = $22597dffc9942eb7$var$RuleNode;
});
parcelRegister("axprj", function(module, exports) {
    "use strict";
    var $7ac0b835c35ad12a$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $7ac0b835c35ad12a$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.Trees = void 0;
    var $bcnvE = parcelRequire("bcnvE");
    var $j53rr = parcelRequire("j53rr");
    var $cdCft = parcelRequire("cdCft");
    var $d6D31 = parcelRequire("d6D31");
    var $jIG0W = parcelRequire("jIG0W");
    var $6bmaO = parcelRequire("6bmaO");
    var $2WQcE = parcelRequire("2WQcE");
    var $kYC92 = parcelRequire("kYC92");
    var $2DVsz = parcelRequire("2DVsz");
    var $2IEP9 = parcelRequire("2IEP9");
    class $7ac0b835c35ad12a$var$Trees {
        static toStringTree(t, arg2) {
            let ruleNames;
            if (arg2 instanceof $jIG0W.Parser) ruleNames = arg2.ruleNames;
            else ruleNames = arg2;
            let s = $2IEP9.escapeWhitespace(this.getNodeText(t, ruleNames), false);
            if (t.childCount === 0) return s;
            let buf = "";
            buf += "(";
            s = $2IEP9.escapeWhitespace(this.getNodeText(t, ruleNames), false);
            buf += s;
            buf += " ";
            for(let i = 0; i < t.childCount; i++){
                if (i > 0) buf += " ";
                buf += this.toStringTree(t.getChild(i), ruleNames);
            }
            buf += ")";
            return buf;
        }
        static getNodeText(t, arg2) {
            let ruleNames;
            if (arg2 instanceof $jIG0W.Parser) ruleNames = arg2.ruleNames;
            else if (arg2) ruleNames = arg2;
            else {
                let payload = t.payload;
                if (typeof payload.text === "string") return payload.text;
                return t.payload.toString();
            }
            if (t instanceof $2WQcE.RuleNode) {
                let ruleContext = t.ruleContext;
                let ruleIndex = ruleContext.ruleIndex;
                let ruleName = ruleNames[ruleIndex];
                let altNumber = ruleContext.altNumber;
                if (altNumber !== $bcnvE.ATN.INVALID_ALT_NUMBER) return ruleName + ":" + altNumber;
                return ruleName;
            } else if (t instanceof $cdCft.ErrorNode) return t.toString();
            else if (t instanceof $kYC92.TerminalNode) {
                let symbol = t.symbol;
                return symbol.text || "";
            }
            throw new TypeError("Unexpected node type");
        }
        static getChildren(t) {
            let kids = [];
            for(let i = 0; i < t.childCount; i++)kids.push(t.getChild(i));
            return kids;
        }
        static getAncestors(t) {
            let ancestors = [];
            let p = t.parent;
            while(p){
                ancestors.unshift(p);
                p = p.parent;
            }
            return ancestors;
        }
        static isAncestorOf(t, u) {
            if (!t || !u || !t.parent) return false;
            let p = u.parent;
            while(p){
                if (t === p) return true;
                p = p.parent;
            }
            return false;
        }
        static findAllTokenNodes(t, ttype) {
            return $7ac0b835c35ad12a$var$Trees.findAllNodes(t, ttype, true);
        }
        static findAllRuleNodes(t, ruleIndex) {
            return $7ac0b835c35ad12a$var$Trees.findAllNodes(t, ruleIndex, false);
        }
        static findAllNodes(t, index, findTokens) {
            let nodes = [];
            $7ac0b835c35ad12a$var$Trees._findAllNodes(t, index, findTokens, nodes);
            return nodes;
        }
        static _findAllNodes(t, index, findTokens, nodes) {
            if (findTokens && t instanceof $kYC92.TerminalNode) {
                if (t.symbol.type === index) nodes.push(t);
            } else if (!findTokens && t instanceof $6bmaO.ParserRuleContext) {
                if (t.ruleIndex === index) nodes.push(t);
            }
            for(let i = 0; i < t.childCount; i++)$7ac0b835c35ad12a$var$Trees._findAllNodes(t.getChild(i), index, findTokens, nodes);
        }
        static getDescendants(t) {
            let nodes = [];
            function recurse(e) {
                nodes.push(e);
                const n = e.childCount;
                for(let i = 0; i < n; i++)recurse(e.getChild(i));
            }
            recurse(t);
            return nodes;
        }
        static getRootOfSubtreeEnclosingRegion(t, startTokenIndex, stopTokenIndex) {
            let n = t.childCount;
            for(let i = 0; i < n; i++){
                let child = t.getChild(i);
                let r = $7ac0b835c35ad12a$var$Trees.getRootOfSubtreeEnclosingRegion(child, startTokenIndex, stopTokenIndex);
                if (r) return r;
            }
            if (t instanceof $6bmaO.ParserRuleContext) {
                let stopToken = t.stop;
                if (startTokenIndex >= t.start.tokenIndex && (stopToken == null || stopTokenIndex <= stopToken.tokenIndex)) return t;
            }
            return undefined;
        }
        static stripChildrenOutOfRange(t, root, startIndex, stopIndex) {
            if (!t) return;
            let count = t.childCount;
            for(let i = 0; i < count; i++){
                let child = t.getChild(i);
                let range = child.sourceInterval;
                if (child instanceof $6bmaO.ParserRuleContext && (range.b < startIndex || range.a > stopIndex)) {
                    if ($7ac0b835c35ad12a$var$Trees.isAncestorOf(child, root)) {
                        let abbrev = new $j53rr.CommonToken($2DVsz.Token.INVALID_TYPE, "...");
                        t.children[i] = new $kYC92.TerminalNode(abbrev);
                    }
                }
            }
        }
        static findNodeSuchThat(t, pred) {
            if (pred(t)) return t;
            let n = t.childCount;
            for(let i = 0; i < n; i++){
                let u = $7ac0b835c35ad12a$var$Trees.findNodeSuchThat(t.getChild(i), pred);
                if (u !== undefined) return u;
            }
            return undefined;
        }
    }
    $7ac0b835c35ad12a$var$__decorate([
        $7ac0b835c35ad12a$var$__param(0, $d6D31.NotNull)
    ], $7ac0b835c35ad12a$var$Trees, "toStringTree", null);
    $7ac0b835c35ad12a$var$__decorate([
        $d6D31.NotNull,
        $7ac0b835c35ad12a$var$__param(0, $d6D31.NotNull)
    ], $7ac0b835c35ad12a$var$Trees, "getAncestors", null);
    $7ac0b835c35ad12a$var$__decorate([
        $7ac0b835c35ad12a$var$__param(0, $d6D31.NotNull)
    ], $7ac0b835c35ad12a$var$Trees, "getRootOfSubtreeEnclosingRegion", null);
    module.exports.Trees = $7ac0b835c35ad12a$var$Trees;
});
parcelRegister("gDZVV", function(module, exports) {
    "use strict";
    var $c1e05489d1cdbc78$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.PredictionMode = void 0;
    var $fP17P = parcelRequire("fP17P");
    var $iXFjm = parcelRequire("iXFjm");
    var $d6D31 = parcelRequire("d6D31");
    var $4kGBm = parcelRequire("4kGBm");
    var $c1e05489d1cdbc78$var$PredictionMode;
    (function(PredictionMode) {
        PredictionMode[PredictionMode["SLL"] = 0] = "SLL";
        PredictionMode[PredictionMode["LL"] = 1] = "LL";
        PredictionMode[PredictionMode["LL_EXACT_AMBIG_DETECTION"] = 2] = "LL_EXACT_AMBIG_DETECTION";
    })($c1e05489d1cdbc78$var$PredictionMode = module.exports.PredictionMode || (module.exports.PredictionMode = {}));
    (function(PredictionMode) {
        class AltAndContextMap extends $fP17P.Array2DHashMap {
            constructor(){
                super(AltAndContextConfigEqualityComparator.INSTANCE);
            }
        }
        class AltAndContextConfigEqualityComparator {
            AltAndContextConfigEqualityComparator() {}
            hashCode(o) {
                let hashCode = $iXFjm.MurmurHash.initialize(7);
                hashCode = $iXFjm.MurmurHash.update(hashCode, o.state.stateNumber);
                hashCode = $iXFjm.MurmurHash.update(hashCode, o.context);
                hashCode = $iXFjm.MurmurHash.finish(hashCode, 2);
                return hashCode;
            }
            equals(a, b) {
                if (a === b) return true;
                if (a == null || b == null) return false;
                return a.state.stateNumber === b.state.stateNumber && a.context.equals(b.context);
            }
        }
        AltAndContextConfigEqualityComparator.INSTANCE = new AltAndContextConfigEqualityComparator();
        $c1e05489d1cdbc78$var$__decorate([
            $d6D31.Override
        ], AltAndContextConfigEqualityComparator.prototype, "hashCode", null);
        $c1e05489d1cdbc78$var$__decorate([
            $d6D31.Override
        ], AltAndContextConfigEqualityComparator.prototype, "equals", null);
        function hasConfigInRuleStopState(configs) {
            for (let c of configs){
                if (c.state instanceof $4kGBm.RuleStopState) return true;
            }
            return false;
        }
        PredictionMode.hasConfigInRuleStopState = hasConfigInRuleStopState;
        function allConfigsInRuleStopStates(configs) {
            for (let config of configs){
                if (!(config.state instanceof $4kGBm.RuleStopState)) return false;
            }
            return true;
        }
        PredictionMode.allConfigsInRuleStopStates = allConfigsInRuleStopStates;
    })($c1e05489d1cdbc78$var$PredictionMode = module.exports.PredictionMode || (module.exports.PredictionMode = {}));
});
parcelRegister("g7SCF", function(module, exports) {
    "use strict";
    var $bbd7abb561fe52b9$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $bbd7abb561fe52b9$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.SimulatorState = void 0;
    var $d6D31 = parcelRequire("d6D31");
    var $6bmaO = parcelRequire("6bmaO");
    let $bbd7abb561fe52b9$var$SimulatorState = class SimulatorState {
        constructor(outerContext, s0, useContext, remainingOuterContext){
            this.outerContext = outerContext != null ? outerContext : $6bmaO.ParserRuleContext.emptyContext();
            this.s0 = s0;
            this.useContext = useContext;
            this.remainingOuterContext = remainingOuterContext;
        }
    };
    $bbd7abb561fe52b9$var$SimulatorState = $bbd7abb561fe52b9$var$__decorate([
        $bbd7abb561fe52b9$var$__param(1, $d6D31.NotNull)
    ], $bbd7abb561fe52b9$var$SimulatorState);
    module.exports.SimulatorState = $bbd7abb561fe52b9$var$SimulatorState;
});
parcelRegister("d1V7w", function(module, exports) {
    "use strict";
    var $97c7ad4039a43616$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.PlusBlockStartState = void 0;
    var $1bs3X = parcelRequire("1bs3X");
    var $65vNG = parcelRequire("65vNG");
    var $d6D31 = parcelRequire("d6D31");
    class $97c7ad4039a43616$var$PlusBlockStartState extends $65vNG.BlockStartState {
        get stateType() {
            return $1bs3X.ATNStateType.PLUS_BLOCK_START;
        }
    }
    $97c7ad4039a43616$var$__decorate([
        $d6D31.Override
    ], $97c7ad4039a43616$var$PlusBlockStartState.prototype, "stateType", null);
    module.exports.PlusBlockStartState = $97c7ad4039a43616$var$PlusBlockStartState;
});
parcelRegister("7qlbM", function(module, exports) {
    "use strict";
    var $567b65d0d9bb1bcd$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.PlusLoopbackState = void 0;
    var $1bs3X = parcelRequire("1bs3X");
    var $dPYn6 = parcelRequire("dPYn6");
    var $d6D31 = parcelRequire("d6D31");
    class $567b65d0d9bb1bcd$var$PlusLoopbackState extends $dPYn6.DecisionState {
        get stateType() {
            return $1bs3X.ATNStateType.PLUS_LOOP_BACK;
        }
    }
    $567b65d0d9bb1bcd$var$__decorate([
        $d6D31.Override
    ], $567b65d0d9bb1bcd$var$PlusLoopbackState.prototype, "stateType", null);
    module.exports.PlusLoopbackState = $567b65d0d9bb1bcd$var$PlusLoopbackState;
});
parcelRegister("7KGEQ", function(module, exports) {
    "use strict";
    var $5a4deb3ba0fdbe62$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $5a4deb3ba0fdbe62$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.PrecedencePredicateTransition = void 0;
    var $fMVaR = parcelRequire("fMVaR");
    var $d6D31 = parcelRequire("d6D31");
    var $eHMgW = parcelRequire("eHMgW");
    let $5a4deb3ba0fdbe62$var$PrecedencePredicateTransition = class PrecedencePredicateTransition extends $fMVaR.AbstractPredicateTransition {
        constructor(target, precedence){
            super(target);
            this.precedence = precedence;
        }
        get serializationType() {
            return 10;
        }
        get isEpsilon() {
            return true;
        }
        matches(symbol, minVocabSymbol, maxVocabSymbol) {
            return false;
        }
        get predicate() {
            return new $eHMgW.SemanticContext.PrecedencePredicate(this.precedence);
        }
        toString() {
            return this.precedence + " >= _p";
        }
    };
    $5a4deb3ba0fdbe62$var$__decorate([
        $d6D31.Override
    ], $5a4deb3ba0fdbe62$var$PrecedencePredicateTransition.prototype, "serializationType", null);
    $5a4deb3ba0fdbe62$var$__decorate([
        $d6D31.Override
    ], $5a4deb3ba0fdbe62$var$PrecedencePredicateTransition.prototype, "isEpsilon", null);
    $5a4deb3ba0fdbe62$var$__decorate([
        $d6D31.Override
    ], $5a4deb3ba0fdbe62$var$PrecedencePredicateTransition.prototype, "matches", null);
    $5a4deb3ba0fdbe62$var$__decorate([
        $d6D31.Override
    ], $5a4deb3ba0fdbe62$var$PrecedencePredicateTransition.prototype, "toString", null);
    $5a4deb3ba0fdbe62$var$PrecedencePredicateTransition = $5a4deb3ba0fdbe62$var$__decorate([
        $5a4deb3ba0fdbe62$var$__param(0, $d6D31.NotNull)
    ], $5a4deb3ba0fdbe62$var$PrecedencePredicateTransition);
    module.exports.PrecedencePredicateTransition = $5a4deb3ba0fdbe62$var$PrecedencePredicateTransition;
});
parcelRegister("aISkF", function(module, exports) {
    "use strict";
    var $7ce828b1bf424f49$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $7ce828b1bf424f49$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.RangeTransition = void 0;
    var $hGRod = parcelRequire("hGRod");
    var $d6D31 = parcelRequire("d6D31");
    var $5tcOQ = parcelRequire("5tcOQ");
    let $7ce828b1bf424f49$var$RangeTransition = class RangeTransition extends $5tcOQ.Transition {
        constructor(target, from, to){
            super(target);
            this.from = from;
            this.to = to;
        }
        get serializationType() {
            return 2;
        }
        get label() {
            return $hGRod.IntervalSet.of(this.from, this.to);
        }
        matches(symbol, minVocabSymbol, maxVocabSymbol) {
            return symbol >= this.from && symbol <= this.to;
        }
        toString() {
            return "'" + String.fromCodePoint(this.from) + "'..'" + String.fromCodePoint(this.to) + "'";
        }
    };
    $7ce828b1bf424f49$var$__decorate([
        $d6D31.Override
    ], $7ce828b1bf424f49$var$RangeTransition.prototype, "serializationType", null);
    $7ce828b1bf424f49$var$__decorate([
        $d6D31.Override,
        $d6D31.NotNull
    ], $7ce828b1bf424f49$var$RangeTransition.prototype, "label", null);
    $7ce828b1bf424f49$var$__decorate([
        $d6D31.Override
    ], $7ce828b1bf424f49$var$RangeTransition.prototype, "matches", null);
    $7ce828b1bf424f49$var$__decorate([
        $d6D31.Override,
        $d6D31.NotNull
    ], $7ce828b1bf424f49$var$RangeTransition.prototype, "toString", null);
    $7ce828b1bf424f49$var$RangeTransition = $7ce828b1bf424f49$var$__decorate([
        $7ce828b1bf424f49$var$__param(0, $d6D31.NotNull)
    ], $7ce828b1bf424f49$var$RangeTransition);
    module.exports.RangeTransition = $7ce828b1bf424f49$var$RangeTransition;
});
parcelRegister("j2zc8", function(module, exports) {
    "use strict";
    var $ddc981289e81a506$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.RuleStartState = void 0;
    var $7j0Pc = parcelRequire("7j0Pc");
    var $1bs3X = parcelRequire("1bs3X");
    var $d6D31 = parcelRequire("d6D31");
    class $ddc981289e81a506$var$RuleStartState extends $7j0Pc.ATNState {
        constructor(){
            super(...arguments);
            this.isPrecedenceRule = false;
            this.leftFactored = false;
        }
        get stateType() {
            return $1bs3X.ATNStateType.RULE_START;
        }
    }
    $ddc981289e81a506$var$__decorate([
        $d6D31.Override
    ], $ddc981289e81a506$var$RuleStartState.prototype, "stateType", null);
    module.exports.RuleStartState = $ddc981289e81a506$var$RuleStartState;
});
parcelRegister("jEsaF", function(module, exports) {
    "use strict";
    var $e4e79af439480b0e$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.StarBlockStartState = void 0;
    var $1bs3X = parcelRequire("1bs3X");
    var $65vNG = parcelRequire("65vNG");
    var $d6D31 = parcelRequire("d6D31");
    class $e4e79af439480b0e$var$StarBlockStartState extends $65vNG.BlockStartState {
        get stateType() {
            return $1bs3X.ATNStateType.STAR_BLOCK_START;
        }
    }
    $e4e79af439480b0e$var$__decorate([
        $d6D31.Override
    ], $e4e79af439480b0e$var$StarBlockStartState.prototype, "stateType", null);
    module.exports.StarBlockStartState = $e4e79af439480b0e$var$StarBlockStartState;
});
parcelRegister("bjwd1", function(module, exports) {
    "use strict";
    var $83ca741f127bc1b0$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.StarLoopbackState = void 0;
    var $7j0Pc = parcelRequire("7j0Pc");
    var $1bs3X = parcelRequire("1bs3X");
    var $d6D31 = parcelRequire("d6D31");
    class $83ca741f127bc1b0$var$StarLoopbackState extends $7j0Pc.ATNState {
        get loopEntryState() {
            return this.transition(0).target;
        }
        get stateType() {
            return $1bs3X.ATNStateType.STAR_LOOP_BACK;
        }
    }
    $83ca741f127bc1b0$var$__decorate([
        $d6D31.Override
    ], $83ca741f127bc1b0$var$StarLoopbackState.prototype, "stateType", null);
    module.exports.StarLoopbackState = $83ca741f127bc1b0$var$StarLoopbackState;
});
parcelRegister("WS4d7", function(module, exports) {
    "use strict";
    var $0b0f5b750847d473$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.TokensStartState = void 0;
    var $1bs3X = parcelRequire("1bs3X");
    var $dPYn6 = parcelRequire("dPYn6");
    var $d6D31 = parcelRequire("d6D31");
    class $0b0f5b750847d473$var$TokensStartState extends $dPYn6.DecisionState {
        get stateType() {
            return $1bs3X.ATNStateType.TOKEN_START;
        }
    }
    $0b0f5b750847d473$var$__decorate([
        $d6D31.Override
    ], $0b0f5b750847d473$var$TokensStartState.prototype, "stateType", null);
    module.exports.TokensStartState = $0b0f5b750847d473$var$TokensStartState;
});
parcelRegister("kWxOc", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.UUID = void 0;
    var $iXFjm = parcelRequire("iXFjm");
    class $f3f3731a7838b7f9$var$UUID {
        constructor(mostSigBits, moreSigBits, lessSigBits, leastSigBits){
            this.data = new Uint32Array(4);
            this.data[0] = mostSigBits;
            this.data[1] = moreSigBits;
            this.data[2] = lessSigBits;
            this.data[3] = leastSigBits;
        }
        static fromString(data) {
            if (!/^[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/.test(data)) throw new Error("Incorrectly formatted UUID");
            let segments = data.split("-");
            let mostSigBits = parseInt(segments[0], 16);
            let moreSigBits = (parseInt(segments[1], 16) << 16 >>> 0) + parseInt(segments[2], 16);
            let lessSigBits = (parseInt(segments[3], 16) << 16 >>> 0) + parseInt(segments[4].substr(0, 4), 16);
            let leastSigBits = parseInt(segments[4].substr(-8), 16);
            return new $f3f3731a7838b7f9$var$UUID(mostSigBits, moreSigBits, lessSigBits, leastSigBits);
        }
        hashCode() {
            return $iXFjm.MurmurHash.hashCode([
                this.data[0],
                this.data[1],
                this.data[2],
                this.data[3]
            ]);
        }
        equals(obj) {
            if (obj === this) return true;
            else if (!(obj instanceof $f3f3731a7838b7f9$var$UUID)) return false;
            return this.data[0] === obj.data[0] && this.data[1] === obj.data[1] && this.data[2] === obj.data[2] && this.data[3] === obj.data[3];
        }
        toString() {
            return ("00000000" + this.data[0].toString(16)).substr(-8) + "-" + ("0000" + (this.data[1] >>> 16).toString(16)).substr(-4) + "-" + ("0000" + this.data[1].toString(16)).substr(-4) + "-" + ("0000" + (this.data[2] >>> 16).toString(16)).substr(-4) + "-" + ("0000" + this.data[2].toString(16)).substr(-4) + ("00000000" + this.data[3].toString(16)).substr(-8);
        }
    }
    module.exports.UUID = $f3f3731a7838b7f9$var$UUID;
});
parcelRegister("3iOjI", function(module, exports) {
    "use strict";
    var $267a15775466fb93$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $267a15775466fb93$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ParseInfo = void 0;
    var $d6D31 = parcelRequire("d6D31");
    let $267a15775466fb93$var$ParseInfo = class ParseInfo {
        constructor(atnSimulator){
            this.atnSimulator = atnSimulator;
        }
        getDecisionInfo() {
            return this.atnSimulator.getDecisionInfo();
        }
        getLLDecisions() {
            let decisions = this.atnSimulator.getDecisionInfo();
            let LL = [];
            for(let i = 0; i < decisions.length; i++){
                let fallBack = decisions[i].LL_Fallback;
                if (fallBack > 0) LL.push(i);
            }
            return LL;
        }
        getTotalTimeInPrediction() {
            let decisions = this.atnSimulator.getDecisionInfo();
            let t = 0;
            for (let decision of decisions)t += decision.timeInPrediction;
            return t;
        }
        getTotalSLLLookaheadOps() {
            let decisions = this.atnSimulator.getDecisionInfo();
            let k = 0;
            for (let decision of decisions)k += decision.SLL_TotalLook;
            return k;
        }
        getTotalLLLookaheadOps() {
            let decisions = this.atnSimulator.getDecisionInfo();
            let k = 0;
            for (let decision of decisions)k += decision.LL_TotalLook;
            return k;
        }
        getTotalSLLATNLookaheadOps() {
            let decisions = this.atnSimulator.getDecisionInfo();
            let k = 0;
            for (let decision of decisions)k += decision.SLL_ATNTransitions;
            return k;
        }
        getTotalLLATNLookaheadOps() {
            let decisions = this.atnSimulator.getDecisionInfo();
            let k = 0;
            for (let decision of decisions)k += decision.LL_ATNTransitions;
            return k;
        }
        getTotalATNLookaheadOps() {
            let decisions = this.atnSimulator.getDecisionInfo();
            let k = 0;
            for (let decision of decisions){
                k += decision.SLL_ATNTransitions;
                k += decision.LL_ATNTransitions;
            }
            return k;
        }
        getDFASize(decision) {
            if (decision) {
                let decisionToDFA = this.atnSimulator.atn.decisionToDFA[decision];
                return decisionToDFA.states.size;
            } else {
                let n = 0;
                let decisionToDFA = this.atnSimulator.atn.decisionToDFA;
                for(let i = 0; i < decisionToDFA.length; i++)n += this.getDFASize(i);
                return n;
            }
        }
    };
    $267a15775466fb93$var$__decorate([
        $d6D31.NotNull
    ], $267a15775466fb93$var$ParseInfo.prototype, "getDecisionInfo", null);
    $267a15775466fb93$var$__decorate([
        $d6D31.NotNull
    ], $267a15775466fb93$var$ParseInfo.prototype, "getLLDecisions", null);
    $267a15775466fb93$var$ParseInfo = $267a15775466fb93$var$__decorate([
        $267a15775466fb93$var$__param(0, $d6D31.NotNull)
    ], $267a15775466fb93$var$ParseInfo);
    module.exports.ParseInfo = $267a15775466fb93$var$ParseInfo;
});
parcelRegister("5xwgp", function(module, exports) {
    "use strict";
    var $40890fafca7801d5$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ProxyParserErrorListener = void 0;
    var $65iNZ = parcelRequire("65iNZ");
    var $d6D31 = parcelRequire("d6D31");
    class $40890fafca7801d5$var$ProxyParserErrorListener extends $65iNZ.ProxyErrorListener {
        constructor(delegates){
            super(delegates);
        }
        reportAmbiguity(recognizer, dfa, startIndex, stopIndex, exact, ambigAlts, configs) {
            this.getDelegates().forEach((listener)=>{
                if (listener.reportAmbiguity) listener.reportAmbiguity(recognizer, dfa, startIndex, stopIndex, exact, ambigAlts, configs);
            });
        }
        reportAttemptingFullContext(recognizer, dfa, startIndex, stopIndex, conflictingAlts, conflictState) {
            this.getDelegates().forEach((listener)=>{
                if (listener.reportAttemptingFullContext) listener.reportAttemptingFullContext(recognizer, dfa, startIndex, stopIndex, conflictingAlts, conflictState);
            });
        }
        reportContextSensitivity(recognizer, dfa, startIndex, stopIndex, prediction, acceptState) {
            this.getDelegates().forEach((listener)=>{
                if (listener.reportContextSensitivity) listener.reportContextSensitivity(recognizer, dfa, startIndex, stopIndex, prediction, acceptState);
            });
        }
    }
    $40890fafca7801d5$var$__decorate([
        $d6D31.Override
    ], $40890fafca7801d5$var$ProxyParserErrorListener.prototype, "reportAmbiguity", null);
    $40890fafca7801d5$var$__decorate([
        $d6D31.Override
    ], $40890fafca7801d5$var$ProxyParserErrorListener.prototype, "reportAttemptingFullContext", null);
    $40890fafca7801d5$var$__decorate([
        $d6D31.Override
    ], $40890fafca7801d5$var$ProxyParserErrorListener.prototype, "reportContextSensitivity", null);
    module.exports.ProxyParserErrorListener = $40890fafca7801d5$var$ProxyParserErrorListener;
});
parcelRegister("dE6Cn", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1rIkv").then(()=>parcelRequire('gpWGO'));
});
parcelRegister("kSEFX", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("d6qIW").then(()=>parcelRequire('cJzXV'));
});
parcelRegister("3kXUy", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ParseCancellationException = void 0;
    class $26e1b6704997a3f4$var$ParseCancellationException extends Error {
        constructor(cause){
            super(cause.message);
            this.cause = cause;
            this.stack = cause.stack;
        }
        getCause() {
            return this.cause;
        }
    }
    module.exports.ParseCancellationException = $26e1b6704997a3f4$var$ParseCancellationException;
});
parcelRegister("1UkCC", function(module, exports) {
    "use strict";
    var $163b0480402006d6$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $163b0480402006d6$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.BufferedTokenStream = void 0;
    var $bbHFU = parcelRequire("bbHFU");
    var $j53rr = parcelRequire("j53rr");
    var $gcfUE = parcelRequire("gcfUE");
    var $igNLf = parcelRequire("igNLf");
    var $d6D31 = parcelRequire("d6D31");
    var $2DVsz = parcelRequire("2DVsz");
    let $163b0480402006d6$var$BufferedTokenStream = class BufferedTokenStream {
        constructor(tokenSource){
            this.tokens = [];
            this.p = -1;
            this.fetchedEOF = false;
            if (tokenSource == null) throw new Error("tokenSource cannot be null");
            this._tokenSource = tokenSource;
        }
        get tokenSource() {
            return this._tokenSource;
        }
        set tokenSource(tokenSource) {
            this._tokenSource = tokenSource;
            this.tokens.length = 0;
            this.p = -1;
            this.fetchedEOF = false;
        }
        get index() {
            return this.p;
        }
        mark() {
            return 0;
        }
        release(marker) {}
        seek(index) {
            this.lazyInit();
            this.p = this.adjustSeekIndex(index);
        }
        get size() {
            return this.tokens.length;
        }
        consume() {
            let skipEofCheck;
            if (this.p >= 0) {
                if (this.fetchedEOF) skipEofCheck = this.p < this.tokens.length - 1;
                else skipEofCheck = this.p < this.tokens.length;
            } else skipEofCheck = false;
            if (!skipEofCheck && this.LA(1) === $2DVsz.Token.EOF) throw new Error("cannot consume EOF");
            if (this.sync(this.p + 1)) this.p = this.adjustSeekIndex(this.p + 1);
        }
        sync(i) {
            $bbHFU(i >= 0);
            let n = i - this.tokens.length + 1;
            if (n > 0) {
                let fetched = this.fetch(n);
                return fetched >= n;
            }
            return true;
        }
        fetch(n) {
            if (this.fetchedEOF) return 0;
            for(let i = 0; i < n; i++){
                let t = this.tokenSource.nextToken();
                if (this.isWritableToken(t)) t.tokenIndex = this.tokens.length;
                this.tokens.push(t);
                if (t.type === $2DVsz.Token.EOF) {
                    this.fetchedEOF = true;
                    return i + 1;
                }
            }
            return n;
        }
        get(i) {
            if (i < 0 || i >= this.tokens.length) throw new RangeError("token index " + i + " out of range 0.." + (this.tokens.length - 1));
            return this.tokens[i];
        }
        getRange(start, stop) {
            if (start < 0 || stop < 0) return [];
            this.lazyInit();
            let subset = new Array();
            if (stop >= this.tokens.length) stop = this.tokens.length - 1;
            for(let i = start; i <= stop; i++){
                let t = this.tokens[i];
                if (t.type === $2DVsz.Token.EOF) break;
                subset.push(t);
            }
            return subset;
        }
        LA(i) {
            let token = this.LT(i);
            if (!token) return $2DVsz.Token.INVALID_TYPE;
            return token.type;
        }
        tryLB(k) {
            if (this.p - k < 0) return undefined;
            return this.tokens[this.p - k];
        }
        LT(k) {
            let result = this.tryLT(k);
            if (result === undefined) throw new RangeError("requested lookback index out of range");
            return result;
        }
        tryLT(k) {
            this.lazyInit();
            if (k === 0) throw new RangeError("0 is not a valid lookahead index");
            if (k < 0) return this.tryLB(-k);
            let i = this.p + k - 1;
            this.sync(i);
            if (i >= this.tokens.length) return this.tokens[this.tokens.length - 1];
            return this.tokens[i];
        }
        adjustSeekIndex(i) {
            return i;
        }
        lazyInit() {
            if (this.p === -1) this.setup();
        }
        setup() {
            this.sync(0);
            this.p = this.adjustSeekIndex(0);
        }
        getTokens(start, stop, types) {
            this.lazyInit();
            if (start === undefined) {
                $bbHFU(stop === undefined && types === undefined);
                return this.tokens;
            } else if (stop === undefined) stop = this.tokens.length - 1;
            if (start < 0 || stop >= this.tokens.length || stop < 0 || start >= this.tokens.length) throw new RangeError("start " + start + " or stop " + stop + " not in 0.." + (this.tokens.length - 1));
            if (start > stop) return [];
            if (types === undefined) return this.tokens.slice(start, stop + 1);
            else if (typeof types === "number") types = new Set().add(types);
            let typesSet = types;
            let filteredTokens = this.tokens.slice(start, stop + 1);
            filteredTokens = filteredTokens.filter((value)=>typesSet.has(value.type));
            return filteredTokens;
        }
        nextTokenOnChannel(i, channel) {
            this.sync(i);
            if (i >= this.size) return this.size - 1;
            let token = this.tokens[i];
            while(token.channel !== channel){
                if (token.type === $2DVsz.Token.EOF) return i;
                i++;
                this.sync(i);
                token = this.tokens[i];
            }
            return i;
        }
        previousTokenOnChannel(i, channel) {
            this.sync(i);
            if (i >= this.size) return this.size - 1;
            while(i >= 0){
                let token = this.tokens[i];
                if (token.type === $2DVsz.Token.EOF || token.channel === channel) return i;
                i--;
            }
            return i;
        }
        getHiddenTokensToRight(tokenIndex, channel = -1) {
            this.lazyInit();
            if (tokenIndex < 0 || tokenIndex >= this.tokens.length) throw new RangeError(tokenIndex + " not in 0.." + (this.tokens.length - 1));
            let nextOnChannel = this.nextTokenOnChannel(tokenIndex + 1, $igNLf.Lexer.DEFAULT_TOKEN_CHANNEL);
            let to;
            let from = tokenIndex + 1;
            if (nextOnChannel === -1) to = this.size - 1;
            else to = nextOnChannel;
            return this.filterForChannel(from, to, channel);
        }
        getHiddenTokensToLeft(tokenIndex, channel = -1) {
            this.lazyInit();
            if (tokenIndex < 0 || tokenIndex >= this.tokens.length) throw new RangeError(tokenIndex + " not in 0.." + (this.tokens.length - 1));
            if (tokenIndex === 0) return [];
            let prevOnChannel = this.previousTokenOnChannel(tokenIndex - 1, $igNLf.Lexer.DEFAULT_TOKEN_CHANNEL);
            if (prevOnChannel === tokenIndex - 1) return [];
            let from = prevOnChannel + 1;
            let to = tokenIndex - 1;
            return this.filterForChannel(from, to, channel);
        }
        filterForChannel(from, to, channel) {
            let hidden = new Array();
            for(let i = from; i <= to; i++){
                let t = this.tokens[i];
                if (channel === -1) {
                    if (t.channel !== $igNLf.Lexer.DEFAULT_TOKEN_CHANNEL) hidden.push(t);
                } else if (t.channel === channel) hidden.push(t);
            }
            return hidden;
        }
        get sourceName() {
            return this.tokenSource.sourceName;
        }
        getText(interval) {
            if (interval === undefined) interval = $gcfUE.Interval.of(0, this.size - 1);
            else if (!(interval instanceof $gcfUE.Interval)) interval = interval.sourceInterval;
            let start = interval.a;
            let stop = interval.b;
            if (start < 0 || stop < 0) return "";
            this.fill();
            if (stop >= this.tokens.length) stop = this.tokens.length - 1;
            let buf = "";
            for(let i = start; i <= stop; i++){
                let t = this.tokens[i];
                if (t.type === $2DVsz.Token.EOF) break;
                buf += t.text;
            }
            return buf.toString();
        }
        getTextFromRange(start, stop) {
            if (this.isToken(start) && this.isToken(stop)) return this.getText($gcfUE.Interval.of(start.tokenIndex, stop.tokenIndex));
            return "";
        }
        fill() {
            this.lazyInit();
            const blockSize = 1000;
            while(true){
                let fetched = this.fetch(blockSize);
                if (fetched < blockSize) return;
            }
        }
        isWritableToken(t) {
            return t instanceof $j53rr.CommonToken;
        }
        isToken(t) {
            return t instanceof $j53rr.CommonToken;
        }
    };
    $163b0480402006d6$var$__decorate([
        $d6D31.NotNull
    ], $163b0480402006d6$var$BufferedTokenStream.prototype, "_tokenSource", void 0);
    $163b0480402006d6$var$__decorate([
        $d6D31.Override
    ], $163b0480402006d6$var$BufferedTokenStream.prototype, "tokenSource", null);
    $163b0480402006d6$var$__decorate([
        $d6D31.Override
    ], $163b0480402006d6$var$BufferedTokenStream.prototype, "index", null);
    $163b0480402006d6$var$__decorate([
        $d6D31.Override
    ], $163b0480402006d6$var$BufferedTokenStream.prototype, "mark", null);
    $163b0480402006d6$var$__decorate([
        $d6D31.Override
    ], $163b0480402006d6$var$BufferedTokenStream.prototype, "release", null);
    $163b0480402006d6$var$__decorate([
        $d6D31.Override
    ], $163b0480402006d6$var$BufferedTokenStream.prototype, "seek", null);
    $163b0480402006d6$var$__decorate([
        $d6D31.Override
    ], $163b0480402006d6$var$BufferedTokenStream.prototype, "size", null);
    $163b0480402006d6$var$__decorate([
        $d6D31.Override
    ], $163b0480402006d6$var$BufferedTokenStream.prototype, "consume", null);
    $163b0480402006d6$var$__decorate([
        $d6D31.Override
    ], $163b0480402006d6$var$BufferedTokenStream.prototype, "get", null);
    $163b0480402006d6$var$__decorate([
        $d6D31.Override
    ], $163b0480402006d6$var$BufferedTokenStream.prototype, "LA", null);
    $163b0480402006d6$var$__decorate([
        $d6D31.NotNull,
        $d6D31.Override
    ], $163b0480402006d6$var$BufferedTokenStream.prototype, "LT", null);
    $163b0480402006d6$var$__decorate([
        $d6D31.Override
    ], $163b0480402006d6$var$BufferedTokenStream.prototype, "sourceName", null);
    $163b0480402006d6$var$__decorate([
        $d6D31.NotNull,
        $d6D31.Override
    ], $163b0480402006d6$var$BufferedTokenStream.prototype, "getText", null);
    $163b0480402006d6$var$__decorate([
        $d6D31.NotNull,
        $d6D31.Override
    ], $163b0480402006d6$var$BufferedTokenStream.prototype, "getTextFromRange", null);
    $163b0480402006d6$var$BufferedTokenStream = $163b0480402006d6$var$__decorate([
        $163b0480402006d6$var$__param(0, $d6D31.NotNull)
    ], $163b0480402006d6$var$BufferedTokenStream);
    module.exports.BufferedTokenStream = $163b0480402006d6$var$BufferedTokenStream;
});
parcelRegister("QidO0", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
});
parcelRegister("9NnFz", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.CharStreams = void 0;
    var $1Olk0 = parcelRequire("1Olk0");
    var $7ufNj = parcelRequire("7ufNj");
    var $ceaEj = parcelRequire("ceaEj");
    var $721b0cebe5798117$var$CharStreams;
    (function(CharStreams) {
        function fromString(s, sourceName) {
            if (sourceName === undefined || sourceName.length === 0) sourceName = $ceaEj.IntStream.UNKNOWN_SOURCE_NAME;
            let codePointBufferBuilder = $1Olk0.CodePointBuffer.builder(s.length);
            let cb = new Uint16Array(s.length);
            for(let i = 0; i < s.length; i++)cb[i] = s.charCodeAt(i);
            codePointBufferBuilder.append(cb);
            return $7ufNj.CodePointCharStream.fromBuffer(codePointBufferBuilder.build(), sourceName);
        }
        CharStreams.fromString = fromString;
    })($721b0cebe5798117$var$CharStreams = module.exports.CharStreams || (module.exports.CharStreams = {}));
});
parcelRegister("1Olk0", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.CodePointBuffer = void 0;
    var $bbHFU = parcelRequire("bbHFU");
    var $gIRNa = parcelRequire("gIRNa");
    class $151b0001e5dcadf1$var$CodePointBuffer {
        constructor(buffer, size){
            this.buffer = buffer;
            this._position = 0;
            this._size = size;
        }
        static withArray(buffer) {
            return new $151b0001e5dcadf1$var$CodePointBuffer(buffer, buffer.length);
        }
        get position() {
            return this._position;
        }
        set position(newPosition) {
            if (newPosition < 0 || newPosition > this._size) throw new RangeError();
            this._position = newPosition;
        }
        get remaining() {
            return this._size - this.position;
        }
        get(offset) {
            return this.buffer[offset];
        }
        array() {
            return this.buffer.slice(0, this._size);
        }
        static builder(initialBufferSize) {
            return new $151b0001e5dcadf1$var$CodePointBuffer.Builder(initialBufferSize);
        }
    }
    module.exports.CodePointBuffer = $151b0001e5dcadf1$var$CodePointBuffer;
    (function(CodePointBuffer) {
        let Type;
        (function(Type) {
            Type[Type["BYTE"] = 0] = "BYTE";
            Type[Type["CHAR"] = 1] = "CHAR";
            Type[Type["INT"] = 2] = "INT";
        })(Type || (Type = {}));
        class Builder {
            constructor(initialBufferSize){
                this.type = 0;
                this.buffer = new Uint8Array(initialBufferSize);
                this.prevHighSurrogate = -1;
                this.position = 0;
            }
            build() {
                return new CodePointBuffer(this.buffer, this.position);
            }
            static roundUpToNextPowerOfTwo(i) {
                let nextPowerOfTwo = 32 - Math.clz32(i - 1);
                return Math.pow(2, nextPowerOfTwo);
            }
            ensureRemaining(remainingNeeded) {
                switch(this.type){
                    case 0:
                        if (this.buffer.length - this.position < remainingNeeded) {
                            let newCapacity = Builder.roundUpToNextPowerOfTwo(this.buffer.length + remainingNeeded);
                            let newBuffer = new Uint8Array(newCapacity);
                            newBuffer.set(this.buffer.subarray(0, this.position), 0);
                            this.buffer = newBuffer;
                        }
                        break;
                    case 1:
                        if (this.buffer.length - this.position < remainingNeeded) {
                            let newCapacity = Builder.roundUpToNextPowerOfTwo(this.buffer.length + remainingNeeded);
                            let newBuffer = new Uint16Array(newCapacity);
                            newBuffer.set(this.buffer.subarray(0, this.position), 0);
                            this.buffer = newBuffer;
                        }
                        break;
                    case 2:
                        if (this.buffer.length - this.position < remainingNeeded) {
                            let newCapacity = Builder.roundUpToNextPowerOfTwo(this.buffer.length + remainingNeeded);
                            let newBuffer = new Int32Array(newCapacity);
                            newBuffer.set(this.buffer.subarray(0, this.position), 0);
                            this.buffer = newBuffer;
                        }
                        break;
                }
            }
            append(utf16In) {
                this.ensureRemaining(utf16In.length);
                this.appendArray(utf16In);
            }
            appendArray(utf16In) {
                switch(this.type){
                    case 0:
                        this.appendArrayByte(utf16In);
                        break;
                    case 1:
                        this.appendArrayChar(utf16In);
                        break;
                    case 2:
                        this.appendArrayInt(utf16In);
                        break;
                }
            }
            appendArrayByte(utf16In) {
                $bbHFU(this.prevHighSurrogate === -1);
                let input = utf16In;
                let inOffset = 0;
                let inLimit = utf16In.length;
                let outByte = this.buffer;
                let outOffset = this.position;
                while(inOffset < inLimit){
                    let c = input[inOffset];
                    if (c <= 0xFF) outByte[outOffset] = c;
                    else {
                        utf16In = utf16In.subarray(inOffset, inLimit);
                        this.position = outOffset;
                        if (!$gIRNa.isHighSurrogate(c)) {
                            this.byteToCharBuffer(utf16In.length);
                            this.appendArrayChar(utf16In);
                            return;
                        } else {
                            this.byteToIntBuffer(utf16In.length);
                            this.appendArrayInt(utf16In);
                            return;
                        }
                    }
                    inOffset++;
                    outOffset++;
                }
                this.position = outOffset;
            }
            appendArrayChar(utf16In) {
                $bbHFU(this.prevHighSurrogate === -1);
                let input = utf16In;
                let inOffset = 0;
                let inLimit = utf16In.length;
                let outChar = this.buffer;
                let outOffset = this.position;
                while(inOffset < inLimit){
                    let c = input[inOffset];
                    if (!$gIRNa.isHighSurrogate(c)) outChar[outOffset] = c;
                    else {
                        utf16In = utf16In.subarray(inOffset, inLimit);
                        this.position = outOffset;
                        this.charToIntBuffer(utf16In.length);
                        this.appendArrayInt(utf16In);
                        return;
                    }
                    inOffset++;
                    outOffset++;
                }
                this.position = outOffset;
            }
            appendArrayInt(utf16In) {
                let input = utf16In;
                let inOffset = 0;
                let inLimit = utf16In.length;
                let outInt = this.buffer;
                let outOffset = this.position;
                while(inOffset < inLimit){
                    let c = input[inOffset];
                    inOffset++;
                    if (this.prevHighSurrogate !== -1) {
                        if ($gIRNa.isLowSurrogate(c)) {
                            outInt[outOffset] = String.fromCharCode(this.prevHighSurrogate, c).codePointAt(0);
                            outOffset++;
                            this.prevHighSurrogate = -1;
                        } else {
                            outInt[outOffset] = this.prevHighSurrogate;
                            outOffset++;
                            if ($gIRNa.isHighSurrogate(c)) this.prevHighSurrogate = c;
                            else {
                                outInt[outOffset] = c;
                                outOffset++;
                                this.prevHighSurrogate = -1;
                            }
                        }
                    } else if ($gIRNa.isHighSurrogate(c)) this.prevHighSurrogate = c;
                    else {
                        outInt[outOffset] = c;
                        outOffset++;
                    }
                }
                if (this.prevHighSurrogate !== -1) {
                    outInt[outOffset] = this.prevHighSurrogate;
                    outOffset++;
                }
                this.position = outOffset;
            }
            byteToCharBuffer(toAppend) {
                let newBuffer = new Uint16Array(Math.max(this.position + toAppend, this.buffer.length >> 1));
                newBuffer.set(this.buffer.subarray(0, this.position), 0);
                this.type = 1;
                this.buffer = newBuffer;
            }
            byteToIntBuffer(toAppend) {
                let newBuffer = new Int32Array(Math.max(this.position + toAppend, this.buffer.length >> 2));
                newBuffer.set(this.buffer.subarray(0, this.position), 0);
                this.type = 2;
                this.buffer = newBuffer;
            }
            charToIntBuffer(toAppend) {
                let newBuffer = new Int32Array(Math.max(this.position + toAppend, this.buffer.length >> 1));
                newBuffer.set(this.buffer.subarray(0, this.position), 0);
                this.type = 2;
                this.buffer = newBuffer;
            }
        }
        CodePointBuffer.Builder = Builder;
    })($151b0001e5dcadf1$var$CodePointBuffer = module.exports.CodePointBuffer || (module.exports.CodePointBuffer = {}));
});
parcelRegister("gIRNa", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.isSupplementaryCodePoint = module.exports.isLowSurrogate = module.exports.isHighSurrogate = void 0;
    function $c2ca7b5ca2fc06e2$var$isHighSurrogate(ch) {
        return ch >= 0xD800 && ch <= 0xDBFF;
    }
    module.exports.isHighSurrogate = $c2ca7b5ca2fc06e2$var$isHighSurrogate;
    function $c2ca7b5ca2fc06e2$var$isLowSurrogate(ch) {
        return ch >= 0xDC00 && ch <= 0xDFFF;
    }
    module.exports.isLowSurrogate = $c2ca7b5ca2fc06e2$var$isLowSurrogate;
    function $c2ca7b5ca2fc06e2$var$isSupplementaryCodePoint(ch) {
        return ch >= 0x10000;
    }
    module.exports.isSupplementaryCodePoint = $c2ca7b5ca2fc06e2$var$isSupplementaryCodePoint;
});
parcelRegister("7ufNj", function(module, exports) {
    "use strict";
    var $57379632ac21bb89$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.CodePointCharStream = void 0;
    var $bbHFU = parcelRequire("bbHFU");
    var $ceaEj = parcelRequire("ceaEj");
    var $gcfUE = parcelRequire("gcfUE");
    var $d6D31 = parcelRequire("d6D31");
    class $57379632ac21bb89$var$CodePointCharStream {
        constructor(array, position, remaining, name){
            $bbHFU(position === 0);
            this._array = array;
            this._size = remaining;
            this._name = name;
            this._position = 0;
        }
        get internalStorage() {
            return this._array;
        }
        static fromBuffer(codePointBuffer, name) {
            if (name === undefined || name.length === 0) name = $ceaEj.IntStream.UNKNOWN_SOURCE_NAME;
            return new $57379632ac21bb89$var$CodePointCharStream(codePointBuffer.array(), codePointBuffer.position, codePointBuffer.remaining, name);
        }
        consume() {
            if (this._size - this._position === 0) {
                $bbHFU(this.LA(1) === $ceaEj.IntStream.EOF);
                throw new RangeError("cannot consume EOF");
            }
            this._position++;
        }
        get index() {
            return this._position;
        }
        get size() {
            return this._size;
        }
        mark() {
            return -1;
        }
        release(marker) {}
        seek(index) {
            this._position = index;
        }
        get sourceName() {
            return this._name;
        }
        toString() {
            return this.getText($gcfUE.Interval.of(0, this.size - 1));
        }
        LA(i) {
            let offset;
            switch(Math.sign(i)){
                case -1:
                    offset = this.index + i;
                    if (offset < 0) return $ceaEj.IntStream.EOF;
                    return this._array[offset];
                case 0:
                    return 0;
                case 1:
                    offset = this.index + i - 1;
                    if (offset >= this.size) return $ceaEj.IntStream.EOF;
                    return this._array[offset];
            }
            throw new RangeError("Not reached");
        }
        getText(interval) {
            const startIdx = Math.min(interval.a, this.size);
            const len = Math.min(interval.b - interval.a + 1, this.size - startIdx);
            if (this._array instanceof Int32Array) return String.fromCodePoint(...Array.from(this._array.subarray(startIdx, startIdx + len)));
            else return String.fromCharCode(...Array.from(this._array.subarray(startIdx, startIdx + len)));
        }
    }
    $57379632ac21bb89$var$__decorate([
        $d6D31.Override
    ], $57379632ac21bb89$var$CodePointCharStream.prototype, "consume", null);
    $57379632ac21bb89$var$__decorate([
        $d6D31.Override
    ], $57379632ac21bb89$var$CodePointCharStream.prototype, "index", null);
    $57379632ac21bb89$var$__decorate([
        $d6D31.Override
    ], $57379632ac21bb89$var$CodePointCharStream.prototype, "size", null);
    $57379632ac21bb89$var$__decorate([
        $d6D31.Override
    ], $57379632ac21bb89$var$CodePointCharStream.prototype, "mark", null);
    $57379632ac21bb89$var$__decorate([
        $d6D31.Override
    ], $57379632ac21bb89$var$CodePointCharStream.prototype, "release", null);
    $57379632ac21bb89$var$__decorate([
        $d6D31.Override
    ], $57379632ac21bb89$var$CodePointCharStream.prototype, "seek", null);
    $57379632ac21bb89$var$__decorate([
        $d6D31.Override
    ], $57379632ac21bb89$var$CodePointCharStream.prototype, "sourceName", null);
    $57379632ac21bb89$var$__decorate([
        $d6D31.Override
    ], $57379632ac21bb89$var$CodePointCharStream.prototype, "toString", null);
    $57379632ac21bb89$var$__decorate([
        $d6D31.Override
    ], $57379632ac21bb89$var$CodePointCharStream.prototype, "LA", null);
    $57379632ac21bb89$var$__decorate([
        $d6D31.Override
    ], $57379632ac21bb89$var$CodePointCharStream.prototype, "getText", null);
    module.exports.CodePointCharStream = $57379632ac21bb89$var$CodePointCharStream;
});
parcelRegister("a0nC0", function(module, exports) {
    "use strict";
    var $748c38524e2afd86$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $748c38524e2afd86$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.CommonTokenStream = void 0;
    var $1UkCC = parcelRequire("1UkCC");
    var $d6D31 = parcelRequire("d6D31");
    var $2DVsz = parcelRequire("2DVsz");
    let $748c38524e2afd86$var$CommonTokenStream = class CommonTokenStream extends $1UkCC.BufferedTokenStream {
        constructor(tokenSource, channel = $2DVsz.Token.DEFAULT_CHANNEL){
            super(tokenSource);
            this.channel = channel;
        }
        adjustSeekIndex(i) {
            return this.nextTokenOnChannel(i, this.channel);
        }
        tryLB(k) {
            if (this.p - k < 0) return undefined;
            let i = this.p;
            let n = 1;
            while(n <= k && i > 0){
                i = this.previousTokenOnChannel(i - 1, this.channel);
                n++;
            }
            if (i < 0) return undefined;
            return this.tokens[i];
        }
        tryLT(k) {
            this.lazyInit();
            if (k === 0) throw new RangeError("0 is not a valid lookahead index");
            if (k < 0) return this.tryLB(-k);
            let i = this.p;
            let n = 1;
            while(n < k){
                if (this.sync(i + 1)) i = this.nextTokenOnChannel(i + 1, this.channel);
                n++;
            }
            return this.tokens[i];
        }
        getNumberOfOnChannelTokens() {
            let n = 0;
            this.fill();
            for (let t of this.tokens){
                if (t.channel === this.channel) n++;
                if (t.type === $2DVsz.Token.EOF) break;
            }
            return n;
        }
    };
    $748c38524e2afd86$var$__decorate([
        $d6D31.Override
    ], $748c38524e2afd86$var$CommonTokenStream.prototype, "adjustSeekIndex", null);
    $748c38524e2afd86$var$__decorate([
        $d6D31.Override
    ], $748c38524e2afd86$var$CommonTokenStream.prototype, "tryLB", null);
    $748c38524e2afd86$var$__decorate([
        $d6D31.Override
    ], $748c38524e2afd86$var$CommonTokenStream.prototype, "tryLT", null);
    $748c38524e2afd86$var$CommonTokenStream = $748c38524e2afd86$var$__decorate([
        $748c38524e2afd86$var$__param(0, $d6D31.NotNull)
    ], $748c38524e2afd86$var$CommonTokenStream);
    module.exports.CommonTokenStream = $748c38524e2afd86$var$CommonTokenStream;
});
parcelRegister("4a3G0", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.Dependents = void 0;
    var $307af2a6cd217eb5$var$Dependents;
    (function(Dependents) {
        Dependents[Dependents["SELF"] = 0] = "SELF";
        Dependents[Dependents["PARENTS"] = 1] = "PARENTS";
        Dependents[Dependents["CHILDREN"] = 2] = "CHILDREN";
        Dependents[Dependents["ANCESTORS"] = 3] = "ANCESTORS";
        Dependents[Dependents["DESCENDANTS"] = 4] = "DESCENDANTS";
        Dependents[Dependents["SIBLINGS"] = 5] = "SIBLINGS";
        Dependents[Dependents["PRECEEDING_SIBLINGS"] = 6] = "PRECEEDING_SIBLINGS";
        Dependents[Dependents["FOLLOWING_SIBLINGS"] = 7] = "FOLLOWING_SIBLINGS";
        Dependents[Dependents["PRECEEDING"] = 8] = "PRECEEDING";
        Dependents[Dependents["FOLLOWING"] = 9] = "FOLLOWING";
    })($307af2a6cd217eb5$var$Dependents = module.exports.Dependents || (module.exports.Dependents = {}));
});
parcelRegister("5Poq6", function(module, exports) {
    "use strict";
    var $43e4a87e035cc726$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $43e4a87e035cc726$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.DiagnosticErrorListener = void 0;
    var $5BPMp = parcelRequire("5BPMp");
    var $d6D31 = parcelRequire("d6D31");
    var $gcfUE = parcelRequire("gcfUE");
    class $43e4a87e035cc726$var$DiagnosticErrorListener {
        constructor(exactOnly = true){
            this.exactOnly = exactOnly;
            this.exactOnly = exactOnly;
        }
        syntaxError(recognizer, offendingSymbol, line, charPositionInLine, msg, e) {}
        reportAmbiguity(recognizer, dfa, startIndex, stopIndex, exact, ambigAlts, configs) {
            if (this.exactOnly && !exact) return;
            let decision = this.getDecisionDescription(recognizer, dfa);
            let conflictingAlts = this.getConflictingAlts(ambigAlts, configs);
            let text = recognizer.inputStream.getText($gcfUE.Interval.of(startIndex, stopIndex));
            let message = `reportAmbiguity d=${decision}: ambigAlts=${conflictingAlts}, input='${text}'`;
            recognizer.notifyErrorListeners(message);
        }
        reportAttemptingFullContext(recognizer, dfa, startIndex, stopIndex, conflictingAlts, conflictState) {
            let format = "reportAttemptingFullContext d=%s, input='%s'";
            let decision = this.getDecisionDescription(recognizer, dfa);
            let text = recognizer.inputStream.getText($gcfUE.Interval.of(startIndex, stopIndex));
            let message = `reportAttemptingFullContext d=${decision}, input='${text}'`;
            recognizer.notifyErrorListeners(message);
        }
        reportContextSensitivity(recognizer, dfa, startIndex, stopIndex, prediction, acceptState) {
            let format = "reportContextSensitivity d=%s, input='%s'";
            let decision = this.getDecisionDescription(recognizer, dfa);
            let text = recognizer.inputStream.getText($gcfUE.Interval.of(startIndex, stopIndex));
            let message = `reportContextSensitivity d=${decision}, input='${text}'`;
            recognizer.notifyErrorListeners(message);
        }
        getDecisionDescription(recognizer, dfa) {
            let decision = dfa.decision;
            let ruleIndex = dfa.atnStartState.ruleIndex;
            let ruleNames = recognizer.ruleNames;
            if (ruleIndex < 0 || ruleIndex >= ruleNames.length) return decision.toString();
            let ruleName = ruleNames[ruleIndex];
            if (!ruleName) return decision.toString();
            return `${decision} (${ruleName})`;
        }
        getConflictingAlts(reportedAlts, configs) {
            if (reportedAlts != null) return reportedAlts;
            let result = new $5BPMp.BitSet();
            for (let config of configs)result.set(config.alt);
            return result;
        }
    }
    $43e4a87e035cc726$var$__decorate([
        $d6D31.Override
    ], $43e4a87e035cc726$var$DiagnosticErrorListener.prototype, "syntaxError", null);
    $43e4a87e035cc726$var$__decorate([
        $d6D31.Override,
        $43e4a87e035cc726$var$__param(0, $d6D31.NotNull),
        $43e4a87e035cc726$var$__param(1, $d6D31.NotNull),
        $43e4a87e035cc726$var$__param(6, $d6D31.NotNull)
    ], $43e4a87e035cc726$var$DiagnosticErrorListener.prototype, "reportAmbiguity", null);
    $43e4a87e035cc726$var$__decorate([
        $d6D31.Override,
        $43e4a87e035cc726$var$__param(0, $d6D31.NotNull),
        $43e4a87e035cc726$var$__param(1, $d6D31.NotNull),
        $43e4a87e035cc726$var$__param(5, $d6D31.NotNull)
    ], $43e4a87e035cc726$var$DiagnosticErrorListener.prototype, "reportAttemptingFullContext", null);
    $43e4a87e035cc726$var$__decorate([
        $d6D31.Override,
        $43e4a87e035cc726$var$__param(0, $d6D31.NotNull),
        $43e4a87e035cc726$var$__param(1, $d6D31.NotNull),
        $43e4a87e035cc726$var$__param(5, $d6D31.NotNull)
    ], $43e4a87e035cc726$var$DiagnosticErrorListener.prototype, "reportContextSensitivity", null);
    $43e4a87e035cc726$var$__decorate([
        $43e4a87e035cc726$var$__param(0, $d6D31.NotNull),
        $43e4a87e035cc726$var$__param(1, $d6D31.NotNull)
    ], $43e4a87e035cc726$var$DiagnosticErrorListener.prototype, "getDecisionDescription", null);
    $43e4a87e035cc726$var$__decorate([
        $d6D31.NotNull,
        $43e4a87e035cc726$var$__param(1, $d6D31.NotNull)
    ], $43e4a87e035cc726$var$DiagnosticErrorListener.prototype, "getConflictingAlts", null);
    module.exports.DiagnosticErrorListener = $43e4a87e035cc726$var$DiagnosticErrorListener;
});
parcelRegister("5FrZ8", function(module, exports) {
    "use strict";
    var $42067d58e54221f4$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.InterpreterRuleContext = void 0;
    var $d6D31 = parcelRequire("d6D31");
    var $6bmaO = parcelRequire("6bmaO");
    class $42067d58e54221f4$var$InterpreterRuleContext extends $6bmaO.ParserRuleContext {
        constructor(ruleIndex, parent, invokingStateNumber){
            if (invokingStateNumber !== undefined) super(parent, invokingStateNumber);
            else super();
            this._ruleIndex = ruleIndex;
        }
        get ruleIndex() {
            return this._ruleIndex;
        }
    }
    $42067d58e54221f4$var$__decorate([
        $d6D31.Override
    ], $42067d58e54221f4$var$InterpreterRuleContext.prototype, "ruleIndex", null);
    module.exports.InterpreterRuleContext = $42067d58e54221f4$var$InterpreterRuleContext;
});
parcelRegister("gMbxO", function(module, exports) {
    "use strict";
    var $c36a1586c540a239$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $c36a1586c540a239$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.LexerInterpreter = void 0;
    var $igNLf = parcelRequire("igNLf");
    var $lQecE = parcelRequire("lQecE");
    var $d6D31 = parcelRequire("d6D31");
    var $d6D31 = parcelRequire("d6D31");
    let $c36a1586c540a239$var$LexerInterpreter = class LexerInterpreter extends $igNLf.Lexer {
        constructor(grammarFileName, vocabulary, ruleNames, channelNames, modeNames, atn, input){
            super(input);
            if (atn.grammarType !== 0) throw new Error("IllegalArgumentException: The ATN must be a lexer ATN.");
            this._grammarFileName = grammarFileName;
            this._atn = atn;
            this._ruleNames = ruleNames.slice(0);
            this._channelNames = channelNames.slice(0);
            this._modeNames = modeNames.slice(0);
            this._vocabulary = vocabulary;
            this._interp = new $lQecE.LexerATNSimulator(atn, this);
        }
        get atn() {
            return this._atn;
        }
        get grammarFileName() {
            return this._grammarFileName;
        }
        get ruleNames() {
            return this._ruleNames;
        }
        get channelNames() {
            return this._channelNames;
        }
        get modeNames() {
            return this._modeNames;
        }
        get vocabulary() {
            return this._vocabulary;
        }
    };
    $c36a1586c540a239$var$__decorate([
        $d6D31.NotNull
    ], $c36a1586c540a239$var$LexerInterpreter.prototype, "_vocabulary", void 0);
    $c36a1586c540a239$var$__decorate([
        $d6D31.Override
    ], $c36a1586c540a239$var$LexerInterpreter.prototype, "atn", null);
    $c36a1586c540a239$var$__decorate([
        $d6D31.Override
    ], $c36a1586c540a239$var$LexerInterpreter.prototype, "grammarFileName", null);
    $c36a1586c540a239$var$__decorate([
        $d6D31.Override
    ], $c36a1586c540a239$var$LexerInterpreter.prototype, "ruleNames", null);
    $c36a1586c540a239$var$__decorate([
        $d6D31.Override
    ], $c36a1586c540a239$var$LexerInterpreter.prototype, "channelNames", null);
    $c36a1586c540a239$var$__decorate([
        $d6D31.Override
    ], $c36a1586c540a239$var$LexerInterpreter.prototype, "modeNames", null);
    $c36a1586c540a239$var$__decorate([
        $d6D31.Override
    ], $c36a1586c540a239$var$LexerInterpreter.prototype, "vocabulary", null);
    $c36a1586c540a239$var$LexerInterpreter = $c36a1586c540a239$var$__decorate([
        $c36a1586c540a239$var$__param(1, $d6D31.NotNull)
    ], $c36a1586c540a239$var$LexerInterpreter);
    module.exports.LexerInterpreter = $c36a1586c540a239$var$LexerInterpreter;
});
parcelRegister("drCaH", function(module, exports) {
    "use strict";
    var $9c9b68135c38f0cc$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $9c9b68135c38f0cc$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ListTokenSource = void 0;
    var $gWaB3 = parcelRequire("gWaB3");
    var $d6D31 = parcelRequire("d6D31");
    var $2DVsz = parcelRequire("2DVsz");
    let $9c9b68135c38f0cc$var$ListTokenSource = class ListTokenSource {
        constructor(tokens, sourceName){
            this.i = 0;
            this._factory = $gWaB3.CommonTokenFactory.DEFAULT;
            if (tokens == null) throw new Error("tokens cannot be null");
            this.tokens = tokens;
            this._sourceName = sourceName;
        }
        get charPositionInLine() {
            if (this.i < this.tokens.length) return this.tokens[this.i].charPositionInLine;
            else if (this.eofToken != null) return this.eofToken.charPositionInLine;
            else if (this.tokens.length > 0) {
                let lastToken = this.tokens[this.tokens.length - 1];
                let tokenText = lastToken.text;
                if (tokenText != null) {
                    let lastNewLine = tokenText.lastIndexOf("\n");
                    if (lastNewLine >= 0) return tokenText.length - lastNewLine - 1;
                }
                return lastToken.charPositionInLine + lastToken.stopIndex - lastToken.startIndex + 1;
            }
            return 0;
        }
        nextToken() {
            if (this.i >= this.tokens.length) {
                if (this.eofToken == null) {
                    let start = -1;
                    if (this.tokens.length > 0) {
                        let previousStop = this.tokens[this.tokens.length - 1].stopIndex;
                        if (previousStop !== -1) start = previousStop + 1;
                    }
                    let stop = Math.max(-1, start - 1);
                    this.eofToken = this._factory.create({
                        source: this,
                        stream: this.inputStream
                    }, $2DVsz.Token.EOF, "EOF", $2DVsz.Token.DEFAULT_CHANNEL, start, stop, this.line, this.charPositionInLine);
                }
                return this.eofToken;
            }
            let t = this.tokens[this.i];
            if (this.i === this.tokens.length - 1 && t.type === $2DVsz.Token.EOF) this.eofToken = t;
            this.i++;
            return t;
        }
        get line() {
            if (this.i < this.tokens.length) return this.tokens[this.i].line;
            else if (this.eofToken != null) return this.eofToken.line;
            else if (this.tokens.length > 0) {
                let lastToken = this.tokens[this.tokens.length - 1];
                let line = lastToken.line;
                let tokenText = lastToken.text;
                if (tokenText != null) {
                    for(let i = 0; i < tokenText.length; i++)if (tokenText.charAt(i) === "\n") line++;
                }
                return line;
            }
            return 1;
        }
        get inputStream() {
            if (this.i < this.tokens.length) return this.tokens[this.i].inputStream;
            else if (this.eofToken != null) return this.eofToken.inputStream;
            else if (this.tokens.length > 0) return this.tokens[this.tokens.length - 1].inputStream;
            return undefined;
        }
        get sourceName() {
            if (this._sourceName) return this._sourceName;
            let inputStream = this.inputStream;
            if (inputStream != null) return inputStream.sourceName;
            return "List";
        }
        set tokenFactory(factory) {
            this._factory = factory;
        }
        get tokenFactory() {
            return this._factory;
        }
    };
    $9c9b68135c38f0cc$var$__decorate([
        $d6D31.Override
    ], $9c9b68135c38f0cc$var$ListTokenSource.prototype, "charPositionInLine", null);
    $9c9b68135c38f0cc$var$__decorate([
        $d6D31.Override
    ], $9c9b68135c38f0cc$var$ListTokenSource.prototype, "nextToken", null);
    $9c9b68135c38f0cc$var$__decorate([
        $d6D31.Override
    ], $9c9b68135c38f0cc$var$ListTokenSource.prototype, "line", null);
    $9c9b68135c38f0cc$var$__decorate([
        $d6D31.Override
    ], $9c9b68135c38f0cc$var$ListTokenSource.prototype, "inputStream", null);
    $9c9b68135c38f0cc$var$__decorate([
        $d6D31.Override
    ], $9c9b68135c38f0cc$var$ListTokenSource.prototype, "sourceName", null);
    $9c9b68135c38f0cc$var$__decorate([
        $d6D31.Override,
        $d6D31.NotNull,
        $9c9b68135c38f0cc$var$__param(0, $d6D31.NotNull)
    ], $9c9b68135c38f0cc$var$ListTokenSource.prototype, "tokenFactory", null);
    $9c9b68135c38f0cc$var$ListTokenSource = $9c9b68135c38f0cc$var$__decorate([
        $9c9b68135c38f0cc$var$__param(0, $d6D31.NotNull)
    ], $9c9b68135c38f0cc$var$ListTokenSource);
    module.exports.ListTokenSource = $9c9b68135c38f0cc$var$ListTokenSource;
});
parcelRegister("2pQQd", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
});
parcelRegister("dReoi", function(module, exports) {
    "use strict";
    var $a16b634f90dd81f4$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    var $a16b634f90dd81f4$var$__param = module.exports && module.exports.__param || function(paramIndex, decorator) {
        return function(target, key) {
            decorator(target, key, paramIndex);
        };
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.ParserInterpreter = void 0;
    var $7j0Pc = parcelRequire("7j0Pc");
    var $1bs3X = parcelRequire("1bs3X");
    var $5BPMp = parcelRequire("5BPMp");
    var $ea0YW = parcelRequire("ea0YW");
    var $iLUMi = parcelRequire("iLUMi");
    var $5FrZ8 = parcelRequire("5FrZ8");
    var $kfqEk = parcelRequire("kfqEk");
    var $d6D31 = parcelRequire("d6D31");
    var $d6D31 = parcelRequire("d6D31");
    var $jIG0W = parcelRequire("jIG0W");
    var $kzbnL = parcelRequire("kzbnL");
    var $fLdDn = parcelRequire("fLdDn");
    var $f9raX = parcelRequire("f9raX");
    var $2DVsz = parcelRequire("2DVsz");
    let $a16b634f90dd81f4$var$ParserInterpreter = class ParserInterpreter extends $jIG0W.Parser {
        constructor(grammarFileName, vocabulary, ruleNames, atn, input){
            super(grammarFileName instanceof ParserInterpreter ? grammarFileName.inputStream : input);
            this._parentContextStack = [];
            this.overrideDecision = -1;
            this.overrideDecisionInputIndex = -1;
            this.overrideDecisionAlt = -1;
            this.overrideDecisionReached = false;
            this._overrideDecisionRoot = undefined;
            if (grammarFileName instanceof ParserInterpreter) {
                let old = grammarFileName;
                this._grammarFileName = old._grammarFileName;
                this._atn = old._atn;
                this.pushRecursionContextStates = old.pushRecursionContextStates;
                this._ruleNames = old._ruleNames;
                this._vocabulary = old._vocabulary;
                this.interpreter = new $kzbnL.ParserATNSimulator(this._atn, this);
            } else {
                vocabulary;
                ruleNames;
                atn;
                this._grammarFileName = grammarFileName;
                this._atn = atn;
                this._ruleNames = ruleNames.slice(0);
                this._vocabulary = vocabulary;
                this.pushRecursionContextStates = new $5BPMp.BitSet(atn.states.length);
                for (let state of atn.states){
                    if (!(state instanceof $f9raX.StarLoopEntryState)) continue;
                    if (state.precedenceRuleDecision) this.pushRecursionContextStates.set(state.stateNumber);
                }
                this.interpreter = new $kzbnL.ParserATNSimulator(atn, this);
            }
        }
        reset(resetInput) {
            if (resetInput === undefined) super.reset();
            else super.reset(resetInput);
            this.overrideDecisionReached = false;
            this._overrideDecisionRoot = undefined;
        }
        get atn() {
            return this._atn;
        }
        get vocabulary() {
            return this._vocabulary;
        }
        get ruleNames() {
            return this._ruleNames;
        }
        get grammarFileName() {
            return this._grammarFileName;
        }
        parse(startRuleIndex) {
            let startRuleStartState = this._atn.ruleToStartState[startRuleIndex];
            this._rootContext = this.createInterpreterRuleContext(undefined, $7j0Pc.ATNState.INVALID_STATE_NUMBER, startRuleIndex);
            if (startRuleStartState.isPrecedenceRule) this.enterRecursionRule(this._rootContext, startRuleStartState.stateNumber, startRuleIndex, 0);
            else this.enterRule(this._rootContext, startRuleStartState.stateNumber, startRuleIndex);
            while(true){
                let p = this.atnState;
                switch(p.stateType){
                    case $1bs3X.ATNStateType.RULE_STOP:
                        if (this._ctx.isEmpty) {
                            if (startRuleStartState.isPrecedenceRule) {
                                let result = this._ctx;
                                let parentContext = this._parentContextStack.pop();
                                this.unrollRecursionContexts(parentContext[0]);
                                return result;
                            } else {
                                this.exitRule();
                                return this._rootContext;
                            }
                        }
                        this.visitRuleStopState(p);
                        break;
                    default:
                        try {
                            this.visitState(p);
                        } catch (e) {
                            if (e instanceof $fLdDn.RecognitionException) {
                                this.state = this._atn.ruleToStopState[p.ruleIndex].stateNumber;
                                this.context.exception = e;
                                this.errorHandler.reportError(this, e);
                                this.recover(e);
                            } else throw e;
                        }
                        break;
                }
            }
        }
        enterRecursionRule(localctx, state, ruleIndex, precedence) {
            this._parentContextStack.push([
                this._ctx,
                localctx.invokingState
            ]);
            super.enterRecursionRule(localctx, state, ruleIndex, precedence);
        }
        get atnState() {
            return this._atn.states[this.state];
        }
        visitState(p) {
            let predictedAlt = 1;
            if (p.numberOfTransitions > 1) predictedAlt = this.visitDecisionState(p);
            let transition = p.transition(predictedAlt - 1);
            switch(transition.serializationType){
                case 1:
                    if (this.pushRecursionContextStates.get(p.stateNumber) && !(transition.target instanceof $kfqEk.LoopEndState)) {
                        let parentContext = this._parentContextStack[this._parentContextStack.length - 1];
                        let localctx = this.createInterpreterRuleContext(parentContext[0], parentContext[1], this._ctx.ruleIndex);
                        this.pushNewRecursionContext(localctx, this._atn.ruleToStartState[p.ruleIndex].stateNumber, this._ctx.ruleIndex);
                    }
                    break;
                case 5:
                    this.match(transition._label);
                    break;
                case 2:
                case 7:
                case 8:
                    if (!transition.matches(this._input.LA(1), $2DVsz.Token.MIN_USER_TOKEN_TYPE, 65535)) this.recoverInline();
                    this.matchWildcard();
                    break;
                case 9:
                    this.matchWildcard();
                    break;
                case 3:
                    let ruleStartState = transition.target;
                    let ruleIndex = ruleStartState.ruleIndex;
                    let newctx = this.createInterpreterRuleContext(this._ctx, p.stateNumber, ruleIndex);
                    if (ruleStartState.isPrecedenceRule) this.enterRecursionRule(newctx, ruleStartState.stateNumber, ruleIndex, transition.precedence);
                    else this.enterRule(newctx, transition.target.stateNumber, ruleIndex);
                    break;
                case 4:
                    let predicateTransition = transition;
                    if (!this.sempred(this._ctx, predicateTransition.ruleIndex, predicateTransition.predIndex)) throw new $ea0YW.FailedPredicateException(this);
                    break;
                case 6:
                    let actionTransition = transition;
                    this.action(this._ctx, actionTransition.ruleIndex, actionTransition.actionIndex);
                    break;
                case 10:
                    if (!this.precpred(this._ctx, transition.precedence)) {
                        let precedence = transition.precedence;
                        throw new $ea0YW.FailedPredicateException(this, `precpred(_ctx, ${precedence})`);
                    }
                    break;
                default:
                    throw new Error("UnsupportedOperationException: Unrecognized ATN transition type.");
            }
            this.state = transition.target.stateNumber;
        }
        visitDecisionState(p) {
            let predictedAlt;
            this.errorHandler.sync(this);
            let decision = p.decision;
            if (decision === this.overrideDecision && this._input.index === this.overrideDecisionInputIndex && !this.overrideDecisionReached) {
                predictedAlt = this.overrideDecisionAlt;
                this.overrideDecisionReached = true;
            } else predictedAlt = this.interpreter.adaptivePredict(this._input, decision, this._ctx);
            return predictedAlt;
        }
        createInterpreterRuleContext(parent, invokingStateNumber, ruleIndex) {
            return new $5FrZ8.InterpreterRuleContext(ruleIndex, parent, invokingStateNumber);
        }
        visitRuleStopState(p) {
            let ruleStartState = this._atn.ruleToStartState[p.ruleIndex];
            if (ruleStartState.isPrecedenceRule) {
                let parentContext = this._parentContextStack.pop();
                this.unrollRecursionContexts(parentContext[0]);
                this.state = parentContext[1];
            } else this.exitRule();
            let ruleTransition = this._atn.states[this.state].transition(0);
            this.state = ruleTransition.followState.stateNumber;
        }
        addDecisionOverride(decision, tokenIndex, forcedAlt) {
            this.overrideDecision = decision;
            this.overrideDecisionInputIndex = tokenIndex;
            this.overrideDecisionAlt = forcedAlt;
        }
        get overrideDecisionRoot() {
            return this._overrideDecisionRoot;
        }
        recover(e) {
            let i = this._input.index;
            this.errorHandler.recover(this, e);
            if (this._input.index === i) {
                let tok = e.getOffendingToken();
                if (!tok) throw new Error("Expected exception to have an offending token");
                let source = tok.tokenSource;
                let stream = source !== undefined ? source.inputStream : undefined;
                let sourcePair = {
                    source: source,
                    stream: stream
                };
                if (e instanceof $iLUMi.InputMismatchException) {
                    let expectedTokens = e.expectedTokens;
                    if (expectedTokens === undefined) throw new Error("Expected the exception to provide expected tokens");
                    let expectedTokenType = $2DVsz.Token.INVALID_TYPE;
                    if (!expectedTokens.isNil) expectedTokenType = expectedTokens.minElement;
                    let errToken = this.tokenFactory.create(sourcePair, expectedTokenType, tok.text, $2DVsz.Token.DEFAULT_CHANNEL, -1, -1, tok.line, tok.charPositionInLine);
                    this._ctx.addErrorNode(this.createErrorNode(this._ctx, errToken));
                } else {
                    let source = tok.tokenSource;
                    let errToken = this.tokenFactory.create(sourcePair, $2DVsz.Token.INVALID_TYPE, tok.text, $2DVsz.Token.DEFAULT_CHANNEL, -1, -1, tok.line, tok.charPositionInLine);
                    this._ctx.addErrorNode(this.createErrorNode(this._ctx, errToken));
                }
            }
        }
        recoverInline() {
            return this._errHandler.recoverInline(this);
        }
        get rootContext() {
            return this._rootContext;
        }
    };
    $a16b634f90dd81f4$var$__decorate([
        $d6D31.NotNull
    ], $a16b634f90dd81f4$var$ParserInterpreter.prototype, "_vocabulary", void 0);
    $a16b634f90dd81f4$var$__decorate([
        $d6D31.Override
    ], $a16b634f90dd81f4$var$ParserInterpreter.prototype, "reset", null);
    $a16b634f90dd81f4$var$__decorate([
        $d6D31.Override
    ], $a16b634f90dd81f4$var$ParserInterpreter.prototype, "atn", null);
    $a16b634f90dd81f4$var$__decorate([
        $d6D31.Override
    ], $a16b634f90dd81f4$var$ParserInterpreter.prototype, "vocabulary", null);
    $a16b634f90dd81f4$var$__decorate([
        $d6D31.Override
    ], $a16b634f90dd81f4$var$ParserInterpreter.prototype, "ruleNames", null);
    $a16b634f90dd81f4$var$__decorate([
        $d6D31.Override
    ], $a16b634f90dd81f4$var$ParserInterpreter.prototype, "grammarFileName", null);
    $a16b634f90dd81f4$var$__decorate([
        $d6D31.Override
    ], $a16b634f90dd81f4$var$ParserInterpreter.prototype, "enterRecursionRule", null);
    $a16b634f90dd81f4$var$ParserInterpreter = $a16b634f90dd81f4$var$__decorate([
        $a16b634f90dd81f4$var$__param(1, $d6D31.NotNull)
    ], $a16b634f90dd81f4$var$ParserInterpreter);
    module.exports.ParserInterpreter = $a16b634f90dd81f4$var$ParserInterpreter;
});
parcelRegister("77rdV", function(module, exports) {
    "use strict";
    var $52ee4de454858848$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.RuleContextWithAltNum = void 0;
    var $bcnvE = parcelRequire("bcnvE");
    var $d6D31 = parcelRequire("d6D31");
    var $6bmaO = parcelRequire("6bmaO");
    class $52ee4de454858848$var$RuleContextWithAltNum extends $6bmaO.ParserRuleContext {
        constructor(parent, invokingStateNumber){
            if (invokingStateNumber !== undefined) super(parent, invokingStateNumber);
            else super();
            this._altNumber = $bcnvE.ATN.INVALID_ALT_NUMBER;
        }
        get altNumber() {
            return this._altNumber;
        }
        set altNumber(altNum) {
            this._altNumber = altNum;
        }
    }
    $52ee4de454858848$var$__decorate([
        $d6D31.Override
    ], $52ee4de454858848$var$RuleContextWithAltNum.prototype, "altNumber", null);
    module.exports.RuleContextWithAltNum = $52ee4de454858848$var$RuleContextWithAltNum;
});
parcelRegister("5IgvW", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.RuleDependency = void 0;
    function $428ddf2e82bfc6fb$var$RuleDependency(dependency) {
        return (target, propertyKey, propertyDescriptor)=>{};
    }
    module.exports.RuleDependency = $428ddf2e82bfc6fb$var$RuleDependency;
});
parcelRegister("1ivK9", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.RuleVersion = void 0;
    function $0f201872a8ca959f$var$RuleVersion(version) {
        return (target, propertyKey, propertyDescriptor)=>{};
    }
    module.exports.RuleVersion = $0f201872a8ca959f$var$RuleVersion;
});
parcelRegister("eftJA", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
});
parcelRegister("9rAj4", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
});
parcelRegister("5jPdD", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
});
parcelRegister("dIykH", function(module, exports) {
    "use strict";
    var $9fca043c2d5f0853$var$__decorate = module.exports && module.exports.__decorate || function(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    };
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.RewriteOperation = module.exports.TokenStreamRewriter = void 0;
    var $gcfUE = parcelRequire("gcfUE");
    var $d6D31 = parcelRequire("d6D31");
    var $2DVsz = parcelRequire("2DVsz");
    class $9fca043c2d5f0853$var$TokenStreamRewriter {
        constructor(tokens){
            this.tokens = tokens;
            this.programs = new Map();
            this.programs.set($9fca043c2d5f0853$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME, []);
            this.lastRewriteTokenIndexes = new Map();
        }
        getTokenStream() {
            return this.tokens;
        }
        rollback(instructionIndex, programName = $9fca043c2d5f0853$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
            let is = this.programs.get(programName);
            if (is != null) this.programs.set(programName, is.slice($9fca043c2d5f0853$var$TokenStreamRewriter.MIN_TOKEN_INDEX, instructionIndex));
        }
        deleteProgram(programName = $9fca043c2d5f0853$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
            this.rollback($9fca043c2d5f0853$var$TokenStreamRewriter.MIN_TOKEN_INDEX, programName);
        }
        insertAfter(tokenOrIndex, text, programName = $9fca043c2d5f0853$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
            let index;
            if (typeof tokenOrIndex === "number") index = tokenOrIndex;
            else index = tokenOrIndex.tokenIndex;
            let rewrites = this.getProgram(programName);
            let op = new $9fca043c2d5f0853$var$InsertAfterOp(this.tokens, index, rewrites.length, text);
            rewrites.push(op);
        }
        insertBefore(tokenOrIndex, text, programName = $9fca043c2d5f0853$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
            let index;
            if (typeof tokenOrIndex === "number") index = tokenOrIndex;
            else index = tokenOrIndex.tokenIndex;
            let rewrites = this.getProgram(programName);
            let op = new $9fca043c2d5f0853$var$InsertBeforeOp(this.tokens, index, rewrites.length, text);
            rewrites.push(op);
        }
        replaceSingle(index, text) {
            if (typeof index === "number") this.replace(index, index, text);
            else this.replace(index, index, text);
        }
        replace(from, to, text, programName = $9fca043c2d5f0853$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
            if (typeof from !== "number") from = from.tokenIndex;
            if (typeof to !== "number") to = to.tokenIndex;
            if (from > to || from < 0 || to < 0 || to >= this.tokens.size) throw new RangeError(`replace: range invalid: ${from}..${to}(size=${this.tokens.size})`);
            let rewrites = this.getProgram(programName);
            let op = new $9fca043c2d5f0853$var$ReplaceOp(this.tokens, from, to, rewrites.length, text);
            rewrites.push(op);
        }
        delete(from, to, programName = $9fca043c2d5f0853$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
            if (to === undefined) to = from;
            if (typeof from === "number") this.replace(from, to, "", programName);
            else this.replace(from, to, "", programName);
        }
        getLastRewriteTokenIndex(programName = $9fca043c2d5f0853$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
            let I = this.lastRewriteTokenIndexes.get(programName);
            if (I == null) return -1;
            return I;
        }
        setLastRewriteTokenIndex(programName, i) {
            this.lastRewriteTokenIndexes.set(programName, i);
        }
        getProgram(name) {
            let is = this.programs.get(name);
            if (is == null) is = this.initializeProgram(name);
            return is;
        }
        initializeProgram(name) {
            let is = [];
            this.programs.set(name, is);
            return is;
        }
        getText(intervalOrProgram, programName = $9fca043c2d5f0853$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME) {
            let interval;
            if (intervalOrProgram instanceof $gcfUE.Interval) interval = intervalOrProgram;
            else interval = $gcfUE.Interval.of(0, this.tokens.size - 1);
            if (typeof intervalOrProgram === "string") programName = intervalOrProgram;
            let rewrites = this.programs.get(programName);
            let start = interval.a;
            let stop = interval.b;
            if (stop > this.tokens.size - 1) stop = this.tokens.size - 1;
            if (start < 0) start = 0;
            if (rewrites == null || rewrites.length === 0) return this.tokens.getText(interval);
            let buf = [];
            let indexToOp = this.reduceToSingleOperationPerIndex(rewrites);
            let i = start;
            while(i <= stop && i < this.tokens.size){
                let op = indexToOp.get(i);
                indexToOp.delete(i);
                let t = this.tokens.get(i);
                if (op == null) {
                    if (t.type !== $2DVsz.Token.EOF) buf.push(String(t.text));
                    i++;
                } else i = op.execute(buf);
            }
            if (stop === this.tokens.size - 1) {
                for (let op of indexToOp.values())if (op.index >= this.tokens.size - 1) buf.push(op.text.toString());
            }
            return buf.join("");
        }
        reduceToSingleOperationPerIndex(rewrites) {
            for(let i = 0; i < rewrites.length; i++){
                let op = rewrites[i];
                if (op == null) continue;
                if (!(op instanceof $9fca043c2d5f0853$var$ReplaceOp)) continue;
                let rop = op;
                let inserts = this.getKindOfOps(rewrites, $9fca043c2d5f0853$var$InsertBeforeOp, i);
                for (let iop of inserts){
                    if (iop.index === rop.index) {
                        rewrites[iop.instructionIndex] = undefined;
                        rop.text = iop.text.toString() + (rop.text != null ? rop.text.toString() : "");
                    } else if (iop.index > rop.index && iop.index <= rop.lastIndex) rewrites[iop.instructionIndex] = undefined;
                }
                let prevReplaces = this.getKindOfOps(rewrites, $9fca043c2d5f0853$var$ReplaceOp, i);
                for (let prevRop of prevReplaces){
                    if (prevRop.index >= rop.index && prevRop.lastIndex <= rop.lastIndex) {
                        rewrites[prevRop.instructionIndex] = undefined;
                        continue;
                    }
                    let disjoint = prevRop.lastIndex < rop.index || prevRop.index > rop.lastIndex;
                    if (prevRop.text == null && rop.text == null && !disjoint) {
                        rewrites[prevRop.instructionIndex] = undefined;
                        rop.index = Math.min(prevRop.index, rop.index);
                        rop.lastIndex = Math.max(prevRop.lastIndex, rop.lastIndex);
                    } else if (!disjoint) throw new Error(`replace op boundaries of ${rop} overlap with previous ${prevRop}`);
                }
            }
            for(let i = 0; i < rewrites.length; i++){
                let op = rewrites[i];
                if (op == null) continue;
                if (!(op instanceof $9fca043c2d5f0853$var$InsertBeforeOp)) continue;
                let iop = op;
                let prevInserts = this.getKindOfOps(rewrites, $9fca043c2d5f0853$var$InsertBeforeOp, i);
                for (let prevIop of prevInserts)if (prevIop.index === iop.index) {
                    if (prevIop instanceof $9fca043c2d5f0853$var$InsertAfterOp) {
                        iop.text = this.catOpText(prevIop.text, iop.text);
                        rewrites[prevIop.instructionIndex] = undefined;
                    } else if (prevIop instanceof $9fca043c2d5f0853$var$InsertBeforeOp) {
                        iop.text = this.catOpText(iop.text, prevIop.text);
                        rewrites[prevIop.instructionIndex] = undefined;
                    }
                }
                let prevReplaces = this.getKindOfOps(rewrites, $9fca043c2d5f0853$var$ReplaceOp, i);
                for (let rop of prevReplaces){
                    if (iop.index === rop.index) {
                        rop.text = this.catOpText(iop.text, rop.text);
                        rewrites[i] = undefined;
                        continue;
                    }
                    if (iop.index >= rop.index && iop.index <= rop.lastIndex) throw new Error(`insert op ${iop} within boundaries of previous ${rop}`);
                }
            }
            let m = new Map();
            for (let op of rewrites){
                if (op == null) continue;
                if (m.get(op.index) != null) throw new Error("should only be one op per index");
                m.set(op.index, op);
            }
            return m;
        }
        catOpText(a, b) {
            let x = "";
            let y = "";
            if (a != null) x = a.toString();
            if (b != null) y = b.toString();
            return x + y;
        }
        getKindOfOps(rewrites, kind, before) {
            let ops = [];
            for(let i = 0; i < before && i < rewrites.length; i++){
                let op = rewrites[i];
                if (op == null) continue;
                if (op instanceof kind) ops.push(op);
            }
            return ops;
        }
    }
    module.exports.TokenStreamRewriter = $9fca043c2d5f0853$var$TokenStreamRewriter;
    $9fca043c2d5f0853$var$TokenStreamRewriter.DEFAULT_PROGRAM_NAME = "default";
    $9fca043c2d5f0853$var$TokenStreamRewriter.PROGRAM_INIT_SIZE = 100;
    $9fca043c2d5f0853$var$TokenStreamRewriter.MIN_TOKEN_INDEX = 0;
    class $9fca043c2d5f0853$var$RewriteOperation {
        constructor(tokens, index, instructionIndex, text){
            this.tokens = tokens;
            this.instructionIndex = instructionIndex;
            this.index = index;
            this.text = text === undefined ? "" : text;
        }
        execute(buf) {
            return this.index;
        }
        toString() {
            let opName = this.constructor.name;
            let $index = opName.indexOf("$");
            opName = opName.substring($index + 1, opName.length);
            return "<" + opName + "@" + this.tokens.get(this.index) + ":\"" + this.text + "\">";
        }
    }
    $9fca043c2d5f0853$var$__decorate([
        $d6D31.Override
    ], $9fca043c2d5f0853$var$RewriteOperation.prototype, "toString", null);
    module.exports.RewriteOperation = $9fca043c2d5f0853$var$RewriteOperation;
    class $9fca043c2d5f0853$var$InsertBeforeOp extends $9fca043c2d5f0853$var$RewriteOperation {
        constructor(tokens, index, instructionIndex, text){
            super(tokens, index, instructionIndex, text);
        }
        execute(buf) {
            buf.push(this.text.toString());
            if (this.tokens.get(this.index).type !== $2DVsz.Token.EOF) buf.push(String(this.tokens.get(this.index).text));
            return this.index + 1;
        }
    }
    $9fca043c2d5f0853$var$__decorate([
        $d6D31.Override
    ], $9fca043c2d5f0853$var$InsertBeforeOp.prototype, "execute", null);
    class $9fca043c2d5f0853$var$InsertAfterOp extends $9fca043c2d5f0853$var$InsertBeforeOp {
        constructor(tokens, index, instructionIndex, text){
            super(tokens, index + 1, instructionIndex, text);
        }
    }
    class $9fca043c2d5f0853$var$ReplaceOp extends $9fca043c2d5f0853$var$RewriteOperation {
        constructor(tokens, from, to, instructionIndex, text){
            super(tokens, from, instructionIndex, text);
            this.lastIndex = to;
        }
        execute(buf) {
            if (this.text != null) buf.push(this.text.toString());
            return this.lastIndex + 1;
        }
        toString() {
            if (this.text == null) return "<DeleteOp@" + this.tokens.get(this.index) + ".." + this.tokens.get(this.lastIndex) + ">";
            return "<ReplaceOp@" + this.tokens.get(this.index) + ".." + this.tokens.get(this.lastIndex) + ":\"" + this.text + "\">";
        }
    }
    $9fca043c2d5f0853$var$__decorate([
        $d6D31.Override
    ], $9fca043c2d5f0853$var$ReplaceOp.prototype, "execute", null);
    $9fca043c2d5f0853$var$__decorate([
        $d6D31.Override
    ], $9fca043c2d5f0853$var$ReplaceOp.prototype, "toString", null);
});
parcelRegister("1MVGg", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
});
parcelRegister("6UcB4", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
});
parcelRegister("hc3Z0", function(module, exports) {
    $parcel$export(module.exports, "JQLLexer", ()=>$a012d4d52c1b9f90$export$375c79404cc64c7f);
    var $dvgsl = parcelRequire("dvgsl");
    var $igNLf = parcelRequire("igNLf");
    var $lQecE = parcelRequire("lQecE");
    var $3n2FE = parcelRequire("3n2FE");
    var $2IEP9 = parcelRequire("2IEP9");
    class $a012d4d52c1b9f90$export$375c79404cc64c7f extends (0, $igNLf.Lexer) {
        static{
            this.LPAREN = 1;
        }
        static{
            this.RPAREN = 2;
        }
        static{
            this.COMMA = 3;
        }
        static{
            this.LBRACKET = 4;
        }
        static{
            this.RBRACKET = 5;
        }
        static{
            this.BANG = 6;
        }
        static{
            this.LT = 7;
        }
        static{
            this.GT = 8;
        }
        static{
            this.GTEQ = 9;
        }
        static{
            this.LTEQ = 10;
        }
        static{
            this.EQUALS = 11;
        }
        static{
            this.NOT_EQUALS = 12;
        }
        static{
            this.LIKE = 13;
        }
        static{
            this.NOT_LIKE = 14;
        }
        static{
            this.IN = 15;
        }
        static{
            this.IS = 16;
        }
        static{
            this.AND = 17;
        }
        static{
            this.OR = 18;
        }
        static{
            this.NOT = 19;
        }
        static{
            this.EMPTY = 20;
        }
        static{
            this.WAS = 21;
        }
        static{
            this.CHANGED = 22;
        }
        static{
            this.BEFORE = 23;
        }
        static{
            this.AFTER = 24;
        }
        static{
            this.FROM = 25;
        }
        static{
            this.TO = 26;
        }
        static{
            this.ON = 27;
        }
        static{
            this.DURING = 28;
        }
        static{
            this.ORDER = 29;
        }
        static{
            this.BY = 30;
        }
        static{
            this.ASC = 31;
        }
        static{
            this.DESC = 32;
        }
        static{
            this.POSNUMBER = 33;
        }
        static{
            this.NEGNUMBER = 34;
        }
        static{
            this.CUSTOMFIELD = 35;
        }
        static{
            this.RESERVED_WORD = 36;
        }
        static{
            this.STRING = 37;
        }
        static{
            this.MATCHWS = 38;
        }
        static{
            this.ERROR_RESERVED = 39;
        }
        static{
            this.ERRORCHAR = 40;
        }
        static{
            this.QUOTE_STRING = 41;
        }
        static{
            this.UNCLOSED_QUOTE_STRING = 42;
        }
        static{
            this.INVALID_QUOTE_STRING = 43;
        }
        static{
            this.SQUOTE_STRING = 44;
        }
        static{
            this.UNCLOSED_SQUOTE_STRING = 45;
        }
        static{
            this.INVALID_SQUOTE_STRING = 46;
        }
        static{
            this.QUOTED_STR = 1;
        }
        static{
            this.SQUOTED_STR = 2;
        }
        static{
            this.channelNames = [
                'DEFAULT_TOKEN_CHANNEL',
                'HIDDEN'
            ];
        }
        static{
            this.modeNames = [
                'DEFAULT_MODE',
                'QUOTED_STR',
                'SQUOTED_STR'
            ];
        }
        static{
            this.ruleNames = [
                'LPAREN',
                'RPAREN',
                'COMMA',
                'LBRACKET',
                'RBRACKET',
                'LQUOTE',
                'LSQUOTE',
                'BANG',
                'LT',
                'GT',
                'GTEQ',
                'LTEQ',
                'EQUALS',
                'NOT_EQUALS',
                'LIKE',
                'NOT_LIKE',
                'IN',
                'IS',
                'AND',
                'OR',
                'NOT',
                'EMPTY',
                'WAS',
                'CHANGED',
                'BEFORE',
                'AFTER',
                'FROM',
                'TO',
                'ON',
                'DURING',
                'ORDER',
                'BY',
                'ASC',
                'DESC',
                'POSNUMBER',
                'NEGNUMBER',
                'CUSTOMFIELD',
                'RESERVED_WORD',
                'STRING',
                'MATCHWS',
                'ERROR_RESERVED',
                'ERRORCHAR',
                'QUOTE_STRING',
                'QUOTED_CONTENT',
                'UNCLOSED_QUOTE_STRING',
                'INVALID_QUOTE_STRING',
                'SQUOTE_STRING',
                'SQUOTED_CONTENT',
                'UNCLOSED_SQUOTE_STRING',
                'INVALID_SQUOTE_STRING',
                'VALID_UNQUOTED_CHARS',
                'VALID_QUOTED_CHARS',
                'VALID_SQUOTED_CHARS',
                'RESERVED_CHARS',
                'QUOTE',
                'SQUOTE',
                'BSLASH',
                'NL',
                'CR',
                'SPACE',
                'AMPER',
                'AMPER_AMPER',
                'PIPE',
                'PIPE_PIPE',
                'ESCAPE',
                'NEWLINE',
                'HEXDIGIT',
                'WS',
                'MINUS',
                'DIGIT',
                'A',
                'B',
                'C',
                'D',
                'E',
                'F',
                'G',
                'H',
                'I',
                'J',
                'K',
                'L',
                'M',
                'N',
                'O',
                'P',
                'Q',
                'R',
                'S',
                'T',
                'U',
                'V',
                'W',
                'X',
                'Y',
                'Z'
            ];
        }
        static{
            this._LITERAL_NAMES = [
                undefined,
                "'('",
                "')'",
                "','",
                "'['",
                "']'",
                "'!'",
                "'<'",
                "'>'",
                "'>='",
                "'<='",
                "'='",
                "'!='",
                "'~'",
                "'!~'"
            ];
        }
        static{
            this._SYMBOLIC_NAMES = [
                undefined,
                'LPAREN',
                'RPAREN',
                'COMMA',
                'LBRACKET',
                'RBRACKET',
                'BANG',
                'LT',
                'GT',
                'GTEQ',
                'LTEQ',
                'EQUALS',
                'NOT_EQUALS',
                'LIKE',
                'NOT_LIKE',
                'IN',
                'IS',
                'AND',
                'OR',
                'NOT',
                'EMPTY',
                'WAS',
                'CHANGED',
                'BEFORE',
                'AFTER',
                'FROM',
                'TO',
                'ON',
                'DURING',
                'ORDER',
                'BY',
                'ASC',
                'DESC',
                'POSNUMBER',
                'NEGNUMBER',
                'CUSTOMFIELD',
                'RESERVED_WORD',
                'STRING',
                'MATCHWS',
                'ERROR_RESERVED',
                'ERRORCHAR',
                'QUOTE_STRING',
                'UNCLOSED_QUOTE_STRING',
                'INVALID_QUOTE_STRING',
                'SQUOTE_STRING',
                'UNCLOSED_SQUOTE_STRING',
                'INVALID_SQUOTE_STRING'
            ];
        }
        static{
            this.VOCABULARY = new (0, $3n2FE.VocabularyImpl)($a012d4d52c1b9f90$export$375c79404cc64c7f._LITERAL_NAMES, $a012d4d52c1b9f90$export$375c79404cc64c7f._SYMBOLIC_NAMES, []);
        }
        get vocabulary() {
            return $a012d4d52c1b9f90$export$375c79404cc64c7f.VOCABULARY;
        }
        constructor(input){
            super(input);
            this._interp = new (0, $lQecE.LexerATNSimulator)($a012d4d52c1b9f90$export$375c79404cc64c7f._ATN, this);
        }
        get grammarFileName() {
            return 'JQLLexer.g4';
        }
        get ruleNames() {
            return $a012d4d52c1b9f90$export$375c79404cc64c7f.ruleNames;
        }
        get serializedATN() {
            return $a012d4d52c1b9f90$export$375c79404cc64c7f._serializedATN;
        }
        get channelNames() {
            return $a012d4d52c1b9f90$export$375c79404cc64c7f.channelNames;
        }
        get modeNames() {
            return $a012d4d52c1b9f90$export$375c79404cc64c7f.modeNames;
        }
        static{
            this._serializedATNSegments = 3;
        }
        static{
            this._serializedATNSegment0 = "\x03\uC91D\uCABA\u058D\uAFBA\u4F53\u0607\uEA8B\uC241\x020\u062E\b\x01\b\x01\b\x01\x04\x02	\x02\x04\x03	\x03\x04\x04	\x04\x04\x05	\x05\x04\x06	\x06\x04\x07	\x07\x04\b	\b\x04			\x04\n	\n\x04\v	\v\x04\f	\f\x04\r	\r\x04\x0e	\x0e\x04\x0f	\x0f\x04\x10	\x10\x04\x11	\x11\x04\x12	\x12\x04\x13	\x13\x04\x14	\x14\x04\x15	\x15\x04\x16	\x16\x04\x17	\x17\x04\x18	\x18\x04\x19	\x19\x04\x1a	\x1a\x04\x1b	\x1b\x04\x1c	\x1c\x04\x1d	\x1d\x04\x1e	\x1e\x04\x1f	\x1f\x04 	 \x04!	!\x04\"	\"\x04#	#\x04$	$\x04%	%\x04&	&\x04'	'\x04(	(\x04)	)\x04*	*\x04+	+\x04,	,\x04-	-\x04.	.\x04/	/\x040	0\x041	1\x042	2\x043	3\x044	4\x045	5\x046	6\x047	7\x048	8\x049	9\x04:	:\x04;	;\x04<	<\x04=	=\x04>	>\x04?	?\x04@	@\x04A	A\x04B	B\x04C	C\x04D	D\x04E	E\x04F	F\x04G	G\x04H	H\x04I	I\x04J	J\x04K	K\x04L	L\x04M	M\x04N	N\x04O	O\x04P	P\x04Q	Q\x04R	R\x04S	S\x04T	T\x04U	U\x04V	V\x04W	W\x04X	X\x04Y	Y\x04Z	Z\x04[	[\x04\\	\\\x04]	]\x04^	^\x04_	_\x04`	`\x04a	a\x03\x02\x03\x02\x03\x03\x03\x03\x03\x04\x03\x04\x03\x05\x03\x05\x03\x06\x03\x06\x03\x07\x03\x07\x03\x07\x03\x07\x03\x07\x03\b\x03\b\x03\b\x03\b\x03\b\x03	\x03	\x03\n\x03\n\x03\v\x03\v\x03\f\x03\f\x03\f\x03\r\x03\r\x03\r\x03\x0e\x03\x0e\x03\x0f\x03\x0f\x03\x0f\x03\x10\x03\x10\x03\x11\x03\x11\x03\x11\x03\x12\x03\x12\x03\x12\x03\x13\x03\x13\x03\x13\x03\x14\x03\x14\x03\x14\x03\x14\x03\x14\x03\x14\x05\x14\xfc\n\x14\x03\x15\x03\x15\x03\x15\x03\x15\x03\x15\x05\x15\u0103\n\x15\x03\x16\x03\x16\x03\x16\x03\x16\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x03\x17\x05\x17\u0114\n\x17\x03\x18\x03\x18\x03\x18\x03\x18\x03\x19\x03\x19\x03\x19\x03\x19\x03\x19\x03\x19\x03\x19\x03\x19\x03\x1a\x03\x1a\x03\x1a\x03\x1a\x03\x1a\x03\x1a\x03\x1a\x03\x1b\x03\x1b\x03\x1b\x03\x1b\x03\x1b\x03\x1b\x03\x1c\x03\x1c\x03\x1c\x03\x1c\x03\x1c\x03\x1d\x03\x1d\x03\x1d\x03\x1e\x03\x1e\x03\x1e\x03\x1f\x03\x1f\x03\x1f\x03\x1f\x03\x1f\x03\x1f\x03\x1f\x03 \x03 \x03 \x03 \x03 \x03 \x03!\x03!\x03!\x03\"\x03\"\x03\"\x03\"\x03#\x03#\x03#\x03#\x03#\x03$\x06$\u0154\n$\r$\x0e$\u0155\x03%\x03%\x06%\u015A\n%\r%\x0e%\u015B\x03&\x03&\x03&\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x03'\x05'\u0582\n'\x03(\x03(\x06(\u0586\n(\r(\x0e(\u0587\x03)\x06)\u058B\n)\r)\x0e)\u058C\x03)\x03)\x03*\x03*\x03+\x03+\x03,\x03,\x03,\x03,\x03-\x03-\x05-\u059B\n-\x03-\x03-\x03.\x03.\x03.\x03.\x03/\x03/\x03/\x03/\x030\x030\x030\x030\x031\x031\x051\u05AD\n1\x031\x031\x032\x032\x032\x032\x033\x033\x033\x033\x034\x034\x035\x035\x036\x036\x037\x037\x038\x038\x039\x039\x03:\x03:\x03;\x03;\x03<\x03<\x03=\x03=\x03>\x03>\x03?\x03?\x03?\x03@\x03@\x03A\x03A\x03A\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x03B\x05B\u05E3\nB\x03C\x03C\x05C\u05E7\nC\x03D\x03D\x03D\x03D\x03D\x03D\x03D\x05D\u05F0\nD\x03E\x03E\x03E\x05E\u05F5\nE\x03F\x03F\x03G\x03G\x03H\x03H\x03I\x03I\x03J\x03J\x03K\x03K\x03L\x03L\x03M\x03M\x03N\x03N\x03O\x03O\x03P\x03P\x03Q\x03Q\x03R\x03R\x03S\x03S\x03T\x03T\x03U\x03U\x03V\x03V\x03W\x03W\x03X\x03X\x03Y\x03Y\x03Z\x03Z\x03[\x03[\x03\\\x03\\\x03]\x03]\x03^\x03^\x03_\x03_\x03`\x03`\x03a\x03a\x02\x02\x02b\x05\x02\x03\x07\x02\x04	\x02\x05\v\x02\x06\r\x02\x07\x0f\x02\x02\x11\x02\x02\x13\x02\b\x15\x02	\x17\x02\n\x19\x02\v\x1b\x02\f\x1d\x02\r\x1f\x02\x0e!\x02\x0f#\x02\x10%\x02\x11'\x02\x12)\x02\x13+\x02\x14-\x02\x15/\x02\x161\x02\x173\x02\x185\x02\x197\x02\x1a9\x02\x1b;\x02\x1c=\x02\x1d?\x02\x1eA\x02\x1fC\x02 E\x02!G\x02\"I\x02#K\x02$M\x02%O\x02&Q\x02'S\x02(U\x02)W\x02*Y\x02+[\x02\x02]\x02,_\x02-a\x02.c\x02\x02e\x02/g\x020i\x02\x02k\x02\x02m\x02\x02o\x02\x02q\x02\x02s\x02\x02u\x02\x02w\x02\x02y\x02\x02{\x02\x02}\x02\x02\x7f\x02\x02\x81\x02\x02\x83\x02\x02\x85\x02\x02\x87\x02\x02\x89\x02\x02\x8b\x02\x02\x8d\x02\x02\x8f\x02\x02\x91\x02\x02\x93\x02\x02\x95\x02\x02\x97\x02\x02\x99\x02\x02\x9b\x02\x02\x9d\x02\x02\x9f\x02\x02\xa1\x02\x02\xa3\x02\x02\xa5\x02\x02\xa7\x02\x02\xa9\x02\x02\xab\x02\x02\xad\x02\x02\xaf\x02\x02\xb1\x02\x02\xb3\x02\x02\xb5\x02\x02\xb7\x02\x02\xb9\x02\x02\xbb\x02\x02\xbd\x02\x02\xbf\x02\x02\xc1\x02\x02\xc3\x02\x02\x05\x02\x03\x04\"	\x02\x02.11=B]`}\xa1\uFDD2\uFDF1\0\x01\n\x02\x02\v\r\x0e\x10!$$^^\x81\xa1\uFDD2\uFDF1\0\x01\n\x02\x02\v\r\x0e\x10!))^^\x81\xa1\uFDD2\uFDF1\0\x01\n\x02%',-11==AB``}}\x7f\x7f\x05\x02ppttvv\x03\x022;\x04\x02CCcc\x04\x02DDdd\x04\x02EEee\x04\x02FFff\x04\x02GGgg\x04\x02HHhh\x04\x02IIii\x04\x02JJjj\x04\x02KKkk\x04\x02LLll\x04\x02MMmm\x04\x02NNnn\x04\x02OOoo\x04\x02PPpp\x04\x02QQqq\x04\x02RRrr\x04\x02SSss\x04\x02TTtt\x04\x02UUuu\x04\x02VVvv\x04\x02WWww\x04\x02XXxx\x04\x02YYyy\x04\x02ZZzz\x04\x02[[{{\x04\x02\\\\||\x02\u06B5\x02\x05\x03\x02\x02\x02\x02\x07\x03\x02\x02\x02\x02	\x03\x02\x02\x02\x02\v\x03\x02\x02\x02\x02\r\x03\x02\x02\x02\x02\x0f\x03\x02\x02\x02\x02\x11\x03\x02\x02\x02\x02\x13\x03\x02\x02\x02\x02\x15\x03\x02\x02\x02\x02\x17\x03\x02\x02\x02\x02\x19\x03\x02\x02\x02\x02\x1b\x03\x02\x02\x02\x02\x1d\x03\x02\x02\x02\x02\x1f\x03\x02\x02\x02\x02!\x03\x02\x02\x02\x02#\x03\x02\x02\x02\x02%\x03\x02\x02\x02\x02'\x03\x02\x02\x02\x02)\x03\x02\x02\x02\x02+\x03\x02\x02\x02\x02-\x03\x02\x02\x02\x02/\x03\x02\x02\x02\x021\x03\x02\x02\x02\x023\x03\x02\x02\x02\x025\x03\x02\x02\x02\x027\x03\x02\x02\x02\x029\x03\x02\x02\x02\x02;\x03\x02\x02\x02\x02=\x03\x02\x02\x02\x02?\x03\x02\x02\x02\x02A\x03\x02\x02\x02\x02C\x03\x02\x02\x02\x02E\x03\x02\x02\x02\x02G\x03\x02\x02\x02\x02I\x03\x02\x02\x02\x02K\x03\x02\x02\x02\x02M\x03\x02\x02\x02\x02O\x03\x02\x02\x02\x02Q\x03\x02\x02\x02\x02S\x03\x02\x02\x02\x02U\x03\x02\x02\x02\x02W\x03\x02\x02\x02\x03Y\x03\x02\x02\x02\x03[\x03\x02\x02\x02\x03]\x03\x02\x02\x02\x03_\x03\x02\x02\x02\x04a\x03\x02\x02\x02\x04c\x03\x02\x02\x02\x04e\x03\x02\x02\x02\x04g\x03\x02\x02\x02\x05\xc5\x03\x02\x02\x02\x07\xc7\x03\x02\x02\x02	\xc9\x03\x02\x02\x02\v\xcb\x03\x02\x02\x02\r\xcd\x03\x02\x02\x02\x0f\xcf\x03\x02\x02\x02\x11\xd4\x03\x02\x02\x02\x13\xd9\x03\x02\x02\x02\x15\xdb\x03\x02\x02\x02\x17\xdd\x03\x02\x02\x02\x19\xdf\x03\x02\x02\x02\x1b\xe2\x03\x02\x02\x02\x1d\xe5\x03\x02\x02\x02\x1f\xe7\x03\x02\x02\x02!\xea\x03\x02\x02\x02#\xec\x03\x02\x02\x02%\xef\x03\x02\x02\x02'\xf2\x03\x02\x02\x02)\xfb\x03\x02\x02\x02+\u0102\x03\x02\x02\x02-\u0104\x03\x02\x02\x02/\u0113\x03\x02\x02\x021\u0115\x03\x02\x02\x023\u0119\x03\x02\x02\x025\u0121\x03\x02\x02\x027\u0128\x03\x02\x02\x029\u012E\x03\x02\x02\x02;\u0133\x03\x02\x02\x02=\u0136\x03\x02\x02\x02?\u0139\x03\x02\x02\x02A\u0140\x03\x02\x02\x02C\u0146\x03\x02\x02\x02E\u0149\x03\x02\x02\x02G\u014D\x03\x02\x02\x02I\u0153\x03\x02\x02\x02K\u0157\x03\x02\x02\x02M\u015D\x03\x02\x02\x02O\u0581\x03\x02\x02\x02Q\u0585\x03\x02\x02\x02S\u058A\x03\x02\x02\x02U\u0590\x03\x02\x02\x02W\u0592\x03\x02\x02\x02Y\u0594\x03\x02\x02\x02[\u059A\x03\x02\x02\x02]\u059E\x03\x02\x02\x02_\u05A2\x03\x02\x02\x02a\u05A6\x03\x02\x02\x02c\u05AC\x03\x02\x02\x02e\u05B0\x03\x02\x02\x02g\u05B4\x03\x02\x02\x02i\u05B8\x03\x02\x02\x02k\u05BA\x03\x02\x02\x02m\u05BC\x03\x02\x02\x02o\u05BE\x03\x02\x02\x02q\u05C0\x03\x02\x02\x02s\u05C2\x03\x02\x02\x02u\u05C4\x03\x02\x02\x02w\u05C6\x03\x02\x02\x02y\u05C8\x03\x02\x02\x02{\u05CA\x03\x02\x02\x02}\u05CC\x03\x02\x02\x02\x7f\u05CE\x03\x02\x02\x02\x81\u05D1\x03\x02\x02\x02\x83\u05D3\x03\x02\x02\x02\x85\u05D6\x03\x02\x02\x02\x87\u05E6\x03\x02\x02\x02\x89\u05EF\x03\x02\x02\x02\x8b\u05F4\x03\x02\x02\x02\x8d\u05F6\x03\x02\x02\x02\x8f\u05F8\x03\x02\x02\x02\x91\u05FA\x03\x02\x02\x02\x93\u05FC\x03\x02\x02\x02\x95\u05FE\x03\x02\x02\x02\x97\u0600\x03\x02\x02\x02\x99\u0602\x03\x02\x02\x02\x9b\u0604\x03\x02\x02\x02\x9d\u0606\x03\x02\x02\x02\x9f\u0608\x03\x02\x02\x02\xa1\u060A\x03\x02\x02\x02\xa3\u060C\x03\x02\x02\x02\xa5\u060E\x03\x02\x02\x02\xa7\u0610\x03\x02\x02\x02\xa9\u0612\x03\x02\x02\x02\xab\u0614\x03\x02\x02\x02\xad\u0616\x03\x02\x02\x02\xaf\u0618\x03\x02\x02\x02\xb1\u061A\x03\x02\x02\x02\xb3\u061C\x03\x02\x02\x02\xb5\u061E\x03\x02\x02\x02\xb7\u0620\x03\x02\x02\x02\xb9\u0622\x03\x02\x02\x02\xbb\u0624\x03\x02\x02\x02\xbd\u0626\x03\x02\x02\x02\xbf\u0628\x03\x02\x02\x02\xc1\u062A\x03\x02\x02\x02\xc3\u062C\x03\x02\x02\x02\xc5\xc6\x07*\x02\x02\xc6\x06\x03\x02\x02\x02\xc7\xc8\x07+\x02\x02\xc8\b\x03\x02\x02\x02\xc9\xca\x07.\x02\x02\xca\n\x03\x02\x02\x02\xcb\xcc\x07]\x02\x02\xcc\f\x03\x02\x02\x02\xcd\xce\x07_\x02\x02\xce\x0e\x03\x02\x02\x02\xcf\xd0\x05q8\x02\xd0\xd1\x03\x02\x02\x02\xd1\xd2\b\x07\x02\x02\xd2\xd3\b\x07\x03\x02\xd3\x10\x03\x02\x02\x02\xd4\xd5\x05s9\x02\xd5\xd6\x03\x02\x02\x02\xd6\xd7\b\b\x02\x02\xd7\xd8\b\b\x04\x02\xd8\x12\x03\x02\x02\x02\xd9\xda\x07#\x02\x02\xda\x14\x03\x02\x02\x02\xdb\xdc\x07>\x02\x02\xdc\x16\x03\x02\x02\x02\xdd\xde\x07@\x02\x02\xde\x18\x03\x02\x02\x02\xdf\xe0\x07@\x02\x02\xe0\xe1\x07?\x02\x02\xe1\x1a\x03\x02\x02\x02\xe2\xe3\x07>\x02\x02\xe3\xe4\x07?\x02\x02\xe4\x1c\x03\x02\x02\x02\xe5\xe6\x07?\x02\x02\xe6\x1e\x03\x02\x02\x02\xe7\xe8\x07#\x02\x02\xe8\xe9\x07?\x02\x02\xe9 \x03\x02\x02\x02\xea\xeb\x07\x80\x02\x02\xeb\"\x03\x02\x02\x02\xec\xed\x07#\x02\x02\xed\xee\x07\x80\x02\x02\xee$\x03\x02\x02\x02\xef\xf0\x05\xa1P\x02\xf0\xf1\x05\xabU\x02\xf1&\x03\x02\x02\x02\xf2\xf3\x05\xa1P\x02\xf3\xf4\x05\xb5Z\x02\xf4(\x03\x02\x02\x02\xf5\xf6\x05\x91H\x02\xf6\xf7\x05\xabU\x02\xf7\xf8\x05\x97K\x02\xf8\xfc\x03\x02\x02\x02\xf9\xfc\x05}>\x02\xfa\xfc\x05\x7f?\x02\xfb\xf5\x03\x02\x02\x02\xfb\xf9\x03\x02\x02\x02\xfb\xfa\x03\x02\x02\x02\xfc*\x03\x02\x02\x02\xfd\xfe\x05\xadV\x02\xfe\xff\x05\xb3Y\x02\xff\u0103\x03\x02\x02\x02\u0100\u0103\x05\x81@\x02\u0101\u0103\x05\x83A\x02\u0102\xfd\x03\x02\x02\x02\u0102\u0100\x03\x02\x02\x02\u0102\u0101\x03\x02\x02\x02\u0103";
        }
        static{
            this._serializedATNSegment1 = ",\x03\x02\x02\x02\u0104\u0105\x05\xabU\x02\u0105\u0106\x05\xadV\x02\u0106\u0107\x05\xb7[\x02\u0107.\x03\x02\x02\x02\u0108\u0109\x05\x99L\x02\u0109\u010A\x05\xa9T\x02\u010A\u010B\x05\xafW\x02\u010B\u010C\x05\xb7[\x02\u010C\u010D\x05\xc1`\x02\u010D\u0114\x03\x02\x02\x02\u010E\u010F\x05\xabU\x02\u010F\u0110\x05\xb9\\\x02\u0110\u0111\x05\xa7S\x02\u0111\u0112\x05\xa7S\x02\u0112\u0114\x03\x02\x02\x02\u0113\u0108\x03\x02\x02\x02\u0113\u010E\x03\x02\x02\x02\u01140\x03\x02\x02\x02\u0115\u0116\x05\xbd^\x02\u0116\u0117\x05\x91H\x02\u0117\u0118\x05\xb5Z\x02\u01182\x03\x02\x02\x02\u0119\u011A\x05\x95J\x02\u011A\u011B\x05\x9fO\x02\u011B\u011C\x05\x91H\x02\u011C\u011D\x05\xabU\x02\u011D\u011E\x05\x9dN\x02\u011E\u011F\x05\x99L\x02\u011F\u0120\x05\x97K\x02\u01204\x03\x02\x02\x02\u0121\u0122\x05\x93I\x02\u0122\u0123\x05\x99L\x02\u0123\u0124\x05\x9bM\x02\u0124\u0125\x05\xadV\x02\u0125\u0126\x05\xb3Y\x02\u0126\u0127\x05\x99L\x02\u01276\x03\x02\x02\x02\u0128\u0129\x05\x91H\x02\u0129\u012A\x05\x9bM\x02\u012A\u012B\x05\xb7[\x02\u012B\u012C\x05\x99L\x02\u012C\u012D\x05\xb3Y\x02\u012D8\x03\x02\x02\x02\u012E\u012F\x05\x9bM\x02\u012F\u0130\x05\xb3Y\x02\u0130\u0131\x05\xadV\x02\u0131\u0132\x05\xa9T\x02\u0132:\x03\x02\x02\x02\u0133\u0134\x05\xb7[\x02\u0134\u0135\x05\xadV\x02\u0135<\x03\x02\x02\x02\u0136\u0137\x05\xadV\x02\u0137\u0138\x05\xabU\x02\u0138>\x03\x02\x02\x02\u0139\u013A\x05\x97K\x02\u013A\u013B\x05\xb9\\\x02\u013B\u013C\x05\xb3Y\x02\u013C\u013D\x05\xa1P\x02\u013D\u013E\x05\xabU\x02\u013E\u013F\x05\x9dN\x02\u013F@\x03\x02\x02\x02\u0140\u0141\x05\xadV\x02\u0141\u0142\x05\xb3Y\x02\u0142\u0143\x05\x97K\x02\u0143\u0144\x05\x99L\x02\u0144\u0145\x05\xb3Y\x02\u0145B\x03\x02\x02\x02\u0146\u0147\x05\x93I\x02\u0147\u0148\x05\xc1`\x02\u0148D\x03\x02\x02\x02\u0149\u014A\x05\x91H\x02\u014A\u014B\x05\xb5Z\x02\u014B\u014C\x05\x95J\x02\u014CF\x03\x02\x02\x02\u014D\u014E\x05\x97K\x02\u014E\u014F\x05\x99L\x02\u014F\u0150\x05\xb5Z\x02\u0150\u0151\x05\x95J\x02\u0151H\x03\x02\x02\x02\u0152\u0154\x05\x8fG\x02\u0153\u0152\x03\x02\x02\x02\u0154\u0155\x03\x02\x02\x02\u0155\u0153\x03\x02\x02\x02\u0155\u0156\x03\x02\x02\x02\u0156J\x03\x02\x02\x02\u0157\u0159\x05\x8dF\x02\u0158\u015A\x05\x8fG\x02\u0159\u0158\x03\x02\x02\x02\u015A\u015B\x03\x02\x02\x02\u015B\u0159\x03\x02\x02\x02\u015B\u015C\x03\x02\x02\x02\u015CL\x03\x02\x02\x02\u015D\u015E\x05\x95J\x02\u015E\u015F\x05\x9bM\x02\u015FN\x03\x02\x02\x02\u0160\u0161\x05\x91H\x02\u0161\u0162\x05\x93I\x02\u0162\u0163\x05\xadV\x02\u0163\u0164\x05\xb3Y\x02\u0164\u0165\x05\xb7[\x02\u0165\u0582\x03\x02\x02\x02\u0166\u0167\x05\x91H\x02\u0167\u0168\x05\x95J\x02\u0168\u0169\x05\x95J\x02\u0169\u016A\x05\x99L\x02\u016A\u016B\x05\xb5Z\x02\u016B\u016C\x05\xb5Z\x02\u016C\u0582\x03\x02\x02\x02\u016D\u016E\x05\x91H\x02\u016E\u016F\x05\x97K\x02\u016F\u0170\x05\x97K\x02\u0170\u0582\x03\x02\x02\x02\u0171\u0172\x05\x91H\x02\u0172\u0173\x05\xa7S\x02\u0173\u0174\x05\xa1P\x02\u0174\u0175\x05\x91H\x02\u0175\u0176\x05\xb5Z\x02\u0176\u0582\x03\x02\x02\x02\u0177\u0178\x05\x91H\x02\u0178\u0179\x05\xa7S\x02\u0179\u017A\x05\xb7[\x02\u017A\u017B\x05\x99L\x02\u017B\u017C\x05\xb3Y\x02\u017C\u0582\x03\x02\x02\x02\u017D\u017E\x05\x91H\x02\u017E\u017F\x05\xabU\x02\u017F\u0180\x05\xc1`\x02\u0180\u0582\x03\x02\x02\x02\u0181\u0182\x05\x91H\x02\u0182\u0183\x05\xb5Z\x02\u0183\u0582\x03\x02\x02\x02\u0184\u0185\x05\x91H\x02\u0185\u0186\x05\xb9\\\x02\u0186\u0187\x05\x97K\x02\u0187\u0188\x05\xa1P\x02\u0188\u0189\x05\xb7[\x02\u0189\u0582\x03\x02\x02\x02\u018A\u018B\x05\x91H\x02\u018B\u018C\x05\xbb]\x02\u018C\u018D\x05\x9dN\x02\u018D\u0582\x03\x02\x02\x02\u018E\u018F\x05\x93I\x02\u018F\u0190\x05\x99L\x02\u0190\u0191\x05\x9dN\x02\u0191\u0192\x05\xa1P\x02\u0192\u0193\x05\xabU\x02\u0193\u0582\x03\x02\x02\x02\u0194\u0195\x05\x93I\x02\u0195\u0196\x05\x99L\x02\u0196\u0197\x05\xb7[\x02\u0197\u0198\x05\xbd^\x02\u0198\u0199\x05\x99L\x02\u0199\u019A\x05\x99L\x02\u019A\u019B\x05\xabU\x02\u019B\u0582\x03\x02\x02\x02\u019C\u019D\x05\x93I\x02\u019D\u019E\x05\xadV\x02\u019E\u019F\x05\xadV\x02\u019F\u01A0\x05\xa7S\x02\u01A0\u01A1\x05\x99L\x02\u01A1\u01A2\x05\x91H\x02\u01A2\u01A3\x05\xabU\x02\u01A3\u0582\x03\x02\x02\x02\u01A4\u01A5\x05\x93I\x02\u01A5\u01A6\x05\xb3Y\x02\u01A6\u01A7\x05\x99L\x02\u01A7\u01A8\x05\x91H\x02\u01A8\u01A9\x05\xa5R\x02\u01A9\u0582\x03\x02\x02\x02\u01AA\u01AB\x05\x93I\x02\u01AB\u01AC\x05\xc1`\x02\u01AC\u01AD\x05\xb7[\x02\u01AD\u01AE\x05\x99L\x02\u01AE\u0582\x03\x02\x02\x02\u01AF\u01B0\x05\x95J\x02\u01B0\u01B1\x05\x91H\x02\u01B1\u01B2\x05\xb7[\x02\u01B2\u01B3\x05\x95J\x02\u01B3\u01B4\x05\x9fO\x02\u01B4\u0582\x03\x02\x02\x02\u01B5\u01B6\x05\x95J\x02\u01B6\u01B7\x05\x9fO\x02\u01B7\u01B8\x05\x91H\x02\u01B8\u01B9\x05\xb3Y\x02\u01B9\u0582\x03\x02\x02\x02\u01BA\u01BB\x05\x95J\x02\u01BB\u01BC\x05\x9fO\x02\u01BC\u01BD\x05\x91H\x02\u01BD\u01BE\x05\xb3Y\x02\u01BE\u01BF\x05\x91H\x02\u01BF\u01C0\x05\x95J\x02\u01C0\u01C1\x05\xb7[\x02\u01C1\u01C2\x05\x99L\x02\u01C2\u01C3\x05\xb3Y\x02\u01C3\u0582\x03\x02\x02\x02\u01C4\u01C5\x05\x95J\x02\u01C5\u01C6\x05\x9fO\x02\u01C6\u01C7\x05\x99L\x02\u01C7\u01C8\x05\x95J\x02\u01C8\u01C9\x05\xa5R\x02\u01C9\u0582\x03\x02\x02\x02\u01CA\u01CB\x05\x95J\x02\u01CB\u01CC\x05\x9fO\x02\u01CC\u01CD\x05\x99L\x02\u01CD\u01CE\x05\x95J\x02\u01CE\u01CF\x05\xa5R\x02\u01CF\u01D0\x05\xafW\x02\u01D0\u01D1\x05\xadV\x02\u01D1\u01D2\x05\xa1P\x02\u01D2\u01D3\x05\xabU\x02\u01D3\u01D4\x05\xb7[\x02\u01D4\u0582\x03\x02\x02\x02\u01D5\u01D6\x05\x95J\x02\u01D6\u01D7\x05\xadV\x02\u01D7\u01D8\x05\xa7S\x02\u01D8\u01D9\x05\xa7S\x02\u01D9\u01DA\x05\x91H\x02\u01DA\u01DB\x05\xb7[\x02\u01DB\u01DC\x05\x99L\x02\u01DC\u0582\x03\x02\x02\x02\u01DD\u01DE\x05\x95J\x02\u01DE\u01DF\x05\xadV\x02\u01DF\u01E0\x05\xa7S\x02\u01E0\u01E1\x05\xa7S\x02\u01E1\u01E2\x05\x91H\x02\u01E2\u01E3\x05\xb7[\x02\u01E3\u01E4\x05\xa1P\x02\u01E4\u01E5\x05\xadV\x02\u01E5\u01E6\x05\xabU\x02\u01E6\u0582\x03\x02\x02\x02\u01E7\u01E8\x05\x95J\x02\u01E8\u01E9\x05\xadV\x02\u01E9\u01EA\x05\xa7S\x02\u01EA\u01EB\x05\xb9\\\x02\u01EB\u01EC\x05\xa9T\x02\u01EC\u01ED\x05\xabU\x02\u01ED\u0582\x03\x02\x02\x02\u01EE\u01EF\x05\x95J\x02\u01EF\u01F0\x05\xadV\x02\u01F0\u01F1\x05\xa9T\x02\u01F1\u01F2\x05\xa9T\x02\u01F2\u01F3\x05\xa1P\x02\u01F3\u01F4\x05\xb7[\x02\u01F4\u0582\x03\x02\x02\x02\u01F5\u01F6\x05\x95J\x02\u01F6\u01F7\x05\xadV\x02\u01F7\u01F8\x05\xabU\x02\u01F8\u01F9\x05\xabU\x02\u01F9\u01FA\x05\x99L\x02\u01FA\u01FB\x05\x95J\x02\u01FB\u01FC\x05\xb7[\x02\u01FC\u0582\x03\x02\x02\x02\u01FD\u01FE\x05\x95J\x02\u01FE\u01FF\x05\xadV\x02\u01FF\u0200\x05\xabU\x02\u0200\u0201\x05\xb7[\x02\u0201\u0202\x05\xa1P\x02\u0202\u0203\x05\xabU\x02\u0203\u0204\x05\xb9\\\x02\u0204\u0205\x05\x99L\x02\u0205\u0582\x03\x02\x02\x02\u0206\u0207\x05\x95J\x02\u0207\u0208\x05\xadV\x02\u0208\u0209\x05\xb9\\\x02\u0209\u020A\x05\xabU\x02\u020A\u020B\x05\xb7[\x02\u020B\u0582\x03\x02\x02\x02\u020C\u020D\x05\x95J\x02\u020D\u020E\x05\xb3Y\x02\u020E\u020F\x05\x99L\x02\u020F\u0210\x05\x91H\x02\u0210\u0211\x05\xb7[\x02\u0211\u0212\x05\x99L\x02\u0212\u0582\x03\x02\x02\x02\u0213\u0214\x05\x95J\x02\u0214\u0215\x05\xb9\\\x02\u0215\u0216\x05\xb3Y\x02\u0216\u0217\x05\xb3Y\x02\u0217\u0218\x05\x99L\x02\u0218\u0219\x05\xabU\x02\u0219\u021A\x05\xb7[\x02\u021A\u0582\x03\x02\x02\x02\u021B\u021C\x05\x97K\x02\u021C\u021D\x05\x91H\x02\u021D\u021E\x05\xb7[\x02\u021E\u021F\x05\x99L\x02\u021F\u0582\x03\x02\x02\x02\u0220\u0221\x05\x97K\x02\u0221\u0222\x05\x99L\x02\u0222\u0223\x05\x95J\x02\u0223\u0224\x05\xa1P\x02\u0224\u0225\x05\xa9T\x02\u0225\u0226\x05\x91H\x02\u0226\u0227\x05\xa7S\x02\u0227\u0582\x03\x02\x02\x02\u0228\u0229\x05\x97K\x02\u0229\u022A\x05\x99L\x02\u022A\u022B\x05\x95J\x02\u022B\u022C\x05\xa7S\x02\u022C\u022D\x05\x91H\x02\u022D\u022E\x05\xb3Y\x02\u022E\u022F\x05\x99L\x02\u022F\u0582\x03\x02\x02\x02\u0230\u0231\x05\x97K\x02\u0231\u0232\x05\x99L\x02\u0232\u0233\x05\x95J\x02\u0233\u0234\x05\xb3Y\x02\u0234\u0235\x05\x99L\x02\u0235\u0236\x05\xa9T\x02\u0236\u0237\x05\x99L\x02\u0237\u0238\x05\xabU\x02\u0238\u0239\x05\xb7[\x02\u0239\u0582\x03\x02\x02\x02\u023A\u023B\x05\x97K\x02\u023B\u023C\x05\x99L\x02\u023C\u023D\x05\x9bM\x02\u023D\u023E\x05\x91H\x02\u023E\u023F\x05\xb9\\\x02\u023F\u0240\x05\xa7S\x02\u0240\u0241\x05\xb7[\x02\u0241\u0582\x03\x02\x02\x02\u0242\u0243\x05\x97K\x02\u0243\u0244\x05\x99L\x02\u0244\u0245\x05\x9bM\x02\u0245\u0246\x05\x91H\x02\u0246\u0247\x05\xb9\\\x02\u0247\u0248\x05\xa7S\x02\u0248\u0249\x05\xb7[\x02\u0249\u024A\x05\xb5Z\x02\u024A\u0582\x03\x02\x02\x02\u024B\u024C\x05\x97K\x02\u024C\u024D\x05\x99L\x02\u024D\u024E\x05\x9bM\x02\u024E\u024F\x05\xa1P\x02\u024F\u0250\x05\xabU\x02\u0250\u0251\x05\x99L\x02\u0251\u0582\x03\x02\x02\x02\u0252\u0253\x05\x97K\x02\u0253\u0254\x05\x99L\x02\u0254\u0255\x05\xa7S\x02\u0255\u0256\x05\x99L\x02\u0256\u0257\x05\xb7[\x02\u0257\u0258\x05\x99L\x02\u0258\u0582\x03\x02\x02\x02\u0259\u025A\x05\x97K\x02\u025A\u025B\x05\x99L\x02\u025B\u025C\x05\xa7S\x02\u025C\u025D\x05\xa1P\x02\u025D\u025E\x05\xa9T\x02\u025E\u025F\x05\xa1P\x02\u025F\u0260\x05\xb7[\x02\u0260\u0261\x05\x99L\x02\u0261\u0262\x05\xb3Y\x02\u0262\u0582\x03\x02\x02\x02\u0263\u0264\x05\x97K\x02\u0264\u0265\x05\xa1P\x02\u0265\u0266\x05\x9bM\x02\u0266\u0267\x05\x9bM\x02\u0267\u0268\x05\x99L\x02\u0268\u0269\x05\xb3Y\x02\u0269\u026A\x05\x99L\x02\u026A\u026B\x05\xabU\x02\u026B\u026C\x05\x95J\x02\u026C\u026D\x05\x99L\x02\u026D\u0582\x03\x02\x02\x02\u026E\u026F\x05\x97K\x02\u026F\u0270\x05\xa1P\x02\u0270\u0271\x05\xb5Z\x02\u0271\u0272\x05\xb7[\x02\u0272\u0273\x05\xa1P\x02\u0273\u0274\x05\xabU\x02\u0274\u0275\x05\x95J\x02\u0275\u0276\x05\xb7[\x02\u0276\u0582\x03\x02\x02\x02\u0277\u0278\x05\x97K\x02\u0278\u0279\x05\xa1P\x02\u0279\u027A\x05\xbb]\x02\u027A\u027B\x05\xa1P\x02\u027B\u027C\x05\x97K\x02\u027C\u027D\x05\x99L\x02\u027D\u0582\x03\x02\x02\x02\u027E\u027F\x05\x97K\x02\u027F\u0280\x05\xadV\x02\u0280\u0582\x03\x02\x02\x02\u0281\u0282\x05\x97K\x02\u0282\u0283\x05\xadV\x02\u0283\u0284\x05\xb9\\\x02\u0284\u0285\x05\x93I\x02\u0285\u0286\x05\xa7S\x02\u0286\u0287\x05\x99L\x02\u0287\u0582\x03\x02\x02\x02\u0288\u0289\x05\x97K\x02\u0289\u028A\x05\xb3Y\x02\u028A\u028B\x05\xadV\x02\u028B\u028C\x05\xafW\x02\u028C\u0582\x03\x02\x02\x02\u028D\u028E\x05\x99L\x02\u028E\u028F\x05\xa7S\x02\u028F\u0290\x05\xb5Z\x02\u0290\u0291\x05\x99L\x02\u0291\u0582\x03\x02\x02\x02\u0292\u0293\x05\x99L\x02\u0293\u0294\x05\xabU\x02\u0294\u0295\x05\x95J\x02\u0295\u0296\x05\xadV\x02\u0296\u0297\x05\x97K\x02\u0297\u0298\x05\xa1P\x02\u0298\u0299\x05\xabU\x02\u0299\u029A\x05\x9dN\x02\u029A\u0582\x03\x02\x02\x02\u029B\u029C\x05\x99L\x02\u029C\u029D\x05\xabU\x02\u029D\u029E\x05\x97K\x02\u029E\u0582\x03\x02\x02\x02\u029F\u02A0\x05\x99L\x02\u02A0\u02A1\x05\xb1X\x02\u02A1\u02A2\x05\xb9\\\x02\u02A2\u02A3\x05\x91H\x02\u02A3\u02A4\x05\xa7S\x02\u02A4\u02A5\x05\xb5Z\x02\u02A5\u0582\x03\x02\x02\x02\u02A6\u02A7\x05\x99L\x02\u02A7\u02A8\x05\xb5Z\x02\u02A8\u02A9\x05\x95J\x02\u02A9\u02AA\x05\x91H\x02\u02AA\u02AB\x05\xafW\x02\u02AB\u02AC\x05\x99L\x02\u02AC\u0582\x03\x02\x02\x02\u02AD\u02AE\x05\x99L\x02\u02AE\u02AF\x05\xbf_\x02\u02AF\u02B0\x05\x95J\x02\u02B0\u02B1\x05\xa7S\x02\u02B1\u02B2\x05\xb9\\\x02\u02B2\u02B3\x05\xb5Z\x02\u02B3\u02B4\x05\xa1P\x02\u02B4\u02B5\x05\xbb]\x02\u02B5\u02B6\x05\x99L\x02\u02B6\u0582\x03\x02\x02\x02\u02B7\u02B8\x05\x99L\x02\u02B8\u02B9\x05\xbf_\x02\u02B9\u02BA\x05\x99L\x02\u02BA\u02BB\x05\x95J\x02\u02BB\u0582\x03\x02\x02\x02\u02BC\u02BD\x05\x99L\x02\u02BD\u02BE\x05\xbf_\x02\u02BE\u02BF\x05\x99L\x02\u02BF\u02C0\x05\x95J\x02\u02C0\u02C1\x05\xb9\\\x02\u02C1\u02C2\x05\xb7[\x02\u02C2\u02C3\x05\x99L\x02\u02C3\u0582\x03\x02\x02\x02\u02C4\u02C5\x05\x99L\x02\u02C5\u02C6\x05\xbf_\x02\u02C6\u02C7\x05\xa1P\x02\u02C7\u02C8\x05\xb5Z\x02\u02C8\u02C9\x05\xb7[\x02\u02C9\u02CA\x05\xb5Z\x02\u02CA\u0582\x03\x02\x02\x02\u02CB\u02CC\x05\x99L\x02\u02CC\u02CD\x05\xbf_\x02\u02CD\u02CE\x05\xafW\x02\u02CE\u02CF\x05\xa7S\x02\u02CF\u02D0\x05\x91H\x02\u02D0\u02D1\x05\xa1P\x02\u02D1\u02D2\x05\xabU\x02\u02D2\u0582\x03\x02\x02\x02\u02D3\u02D4\x05\x9bM\x02\u02D4\u02D5\x05\x91H\x02\u02D5\u02D6\x05\xa7S\x02\u02D6\u02D7\x05\xb5Z\x02\u02D7\u02D8\x05\x99L\x02\u02D8\u0582\x03\x02\x02\x02\u02D9\u02DA\x05\x9bM\x02\u02DA\u02DB\x05\x99L\x02\u02DB\u02DC\x05\xb7[\x02\u02DC\u02DD\x05\x95J\x02\u02DD\u02DE\x05\x9fO\x02\u02DE\u0582\x03\x02\x02\x02\u02DF\u02E0\x05\x9bM\x02\u02E0\u02E1\x05\xa1P\x02\u02E1\u02E2\x05\xa7S\x02\u02E2\u02E3\x05\x99L\x02\u02E3\u0582\x03\x02\x02\x02\u02E4\u02E5\x05\x9bM\x02\u02E5\u02E6\x05\xa1P\x02\u02E6\u02E7\x05\x99L\x02\u02E7\u02E8\x05\xa7S\x02\u02E8\u02E9\x05\x97K\x02\u02E9\u0582\x03\x02\x02\x02\u02EA\u02EB\x05\x9bM\x02\u02EB\u02EC\x05\xa1P\x02\u02EC\u02ED\x05\xb3Y\x02\u02ED\u02EE\x05\xb5Z\x02\u02EE\u02EF\x05\xb7[\x02\u02EF\u0582\x03\x02\x02\x02\u02F0\u02F1\x05\x9bM\x02\u02F1\u02F2\x05\xa7S\x02\u02F2\u02F3\x05\xadV\x02\u02F3\u02F4\x05\x91H\x02\u02F4\u02F5\x05\xb7[\x02\u02F5\u0582\x03\x02\x02\x02\u02F6\u02F7\x05\x9bM\x02\u02F7\u02F8\x05\xadV\x02\u02F8\u02F9\x05\xb3Y\x02\u02F9\u0582\x03\x02\x02\x02\u02FA\u02FB\x05\x9bM\x02\u02FB\u02FC\x05\xb9\\\x02\u02FC\u02FD\x05\xabU\x02\u02FD\u02FE\x05\x95J\x02\u02FE\u02FF\x05\xb7[\x02\u02FF\u0300\x05\xa1P\x02\u0300\u0301\x05\xadV\x02\u0301\u0302\x05\xabU\x02\u0302\u0582\x03\x02\x02\x02\u0303\u0304\x05\x9dN\x02\u0304\u0305\x05\xadV\x02\u0305\u0582\x03\x02\x02\x02\u0306\u0307\x05\x9dN\x02\u0307\u0308\x05\xadV\x02\u0308\u0309\x05\xb7[\x02\u0309\u030A\x05\xadV\x02\u030A\u0582\x03\x02\x02\x02\u030B\u030C\x05\x9dN\x02\u030C\u030D\x05\xb3Y\x02\u030D\u030E\x05\x91H\x02\u030E\u030F\x05\xabU\x02\u030F\u0310\x05\xb7[\x02\u0310\u0582\x03\x02\x02\x02\u0311\u0312\x05\x9dN\x02\u0312\u0313\x05\xb3Y\x02\u0313\u0314\x05\x99L\x02\u0314\u0315\x05\x91H\x02\u0315\u0316\x05\xb7[\x02\u0316\u0317\x05\x99L\x02\u0317\u0318\x05\xb3Y\x02\u0318\u0582\x03\x02\x02\x02\u0319\u031A\x05\x9dN\x02\u031A\u031B\x05\xb3Y\x02\u031B\u031C\x05\xadV\x02\u031C\u031D\x05\xb9\\\x02\u031D\u031E\x05\xafW\x02\u031E\u0582\x03\x02\x02\x02\u031F\u0320\x05\x9fO\x02\u0320\u0321\x05\x91H\x02\u0321\u0322\x05\xbb]\x02\u0322\u0323\x05\xa1P\x02\u0323\u0324\x05\xabU\x02\u0324\u0325\x05\x9dN\x02\u0325\u0582\x03\x02\x02\x02\u0326\u0327\x05\xa1P\x02\u0327\u0328\x05\x97K\x02\u0328\u0329\x05\x99L\x02\u0329\u032A\x05\xabU\x02\u032A\u032B\x05\xb7[\x02\u032B\u032C\x05\xa1P\x02\u032C\u032D\x05\x9bM\x02\u032D\u032E\x05\xa1P\x02\u032E\u032F\x05\x99L\x02\u032F\u0330\x05\x97K\x02\u0330\u0582\x03\x02\x02\x02\u0331\u0332\x05\xa1P\x02\u0332\u0333\x05\x9bM\x02\u0333\u0582\x03\x02\x02\x02\u0334\u0335\x05\xa1P\x02\u0335\u0336\x05\xa9T\x02\u0336\u0337\x05\xa9T\x02\u0337\u0338\x05\x99L\x02\u0338\u0339\x05\x97K\x02\u0339\u033A\x05\xa1P\x02\u033A\u033B\x05\x91H\x02\u033B\u033C\x05\xb7[\x02\u033C\u033D\x05\x99L\x02\u033D\u0582\x03\x02\x02\x02\u033E\u033F\x05\xa1P\x02\u033F\u0340\x05\xabU\x02\u0340\u0341\x05\x95J\x02\u0341\u0342\x05\xb3Y\x02\u0342\u0343\x05\x99L\x02\u0343\u0344\x05\xa9T\x02\u0344\u0345\x05\x99L\x02\u0345\u0346\x05\xabU\x02\u0346\u0347\x05\xb7[\x02\u0347\u0582\x03\x02\x02\x02\u0348\u0349\x05\xa1P\x02\u0349\u034A\x05\xabU\x02\u034A\u034B\x05\x97K\x02\u034B\u034C\x05\x99L\x02\u034C\u034D\x05\xbf_\x02\u034D\u0582\x03\x02\x02\x02\u034E\u034F\x05\xa1P\x02\u034F\u0350\x05\xabU\x02\u0350\u0351\x05\xa1P\x02\u0351\u0352\x05\xb7[\x02\u0352\u0353\x05\xa1P\x02\u0353\u0354\x05\x91H\x02\u0354\u0355\x05\xa7S\x02\u0355\u0582\x03\x02\x02\x02\u0356\u0357\x05\xa1P\x02\u0357\u0358\x05\xabU\x02\u0358\u0359\x05\xabU\x02\u0359\u035A\x05\x99L\x02\u035A\u035B\x05\xb3Y\x02\u035B\u0582\x03\x02\x02\x02\u035C\u035D\x05\xa1P\x02\u035D\u035E\x05\xabU\x02\u035E\u035F\x05\xadV\x02\u035F\u0360\x05\xb9\\\x02\u0360\u0361\x05\xb7[\x02\u0361\u0582\x03\x02\x02\x02\u0362\u0363\x05\xa1P\x02\u0363\u0364\x05\xabU\x02\u0364\u0365\x05\xafW\x02\u0365\u0366\x05\xb9\\\x02\u0366\u0367\x05\xb7[\x02\u0367\u0582\x03\x02\x02\x02\u0368\u0369\x05\xa1P\x02\u0369\u036A\x05\xabU\x02\u036A\u036B\x05\xb5Z\x02\u036B\u036C\x05\x99L\x02\u036C\u036D\x05\xb3Y\x02\u036D\u036E\x05\xb7[\x02\u036E\u0582\x03\x02\x02\x02\u036F\u0370\x05\xa1P\x02\u0370\u0371\x05\xabU\x02\u0371\u0372\x05\xb7[\x02\u0372\u0582\x03\x02\x02\x02\u0373\u0374\x05\xa1P\x02\u0374\u0375\x05\xabU\x02\u0375\u0376\x05\xb7[\x02\u0376\u0377\x05\x99L\x02\u0377\u0378\x05\x9dN\x02\u0378\u0379\x05\x99L\x02\u0379\u037A\x05\xb3Y\x02\u037A\u0582\x03\x02\x02\x02\u037B\u037C\x05\xa1P\x02\u037C\u037D\x05\xabU\x02\u037D\u037E\x05\xb7[\x02\u037E\u037F\x05\x99L\x02\u037F\u0380\x05\xb3Y\x02\u0380\u0381\x05\xb5Z\x02\u0381\u0382\x05\x99L\x02\u0382\u0383\x05\x95J\x02\u0383\u0384\x05\xb7[\x02\u0384\u0582\x03\x02\x02\x02\u0385\u0386\x05\xa1P\x02\u0386\u0387\x05\xabU\x02\u0387\u0388\x05\xb7[\x02\u0388\u0389\x05\x99L\x02\u0389\u038A\x05\xb3Y\x02\u038A\u038B\x05\xb5Z\x02\u038B\u038C\x05\x99L\x02\u038C\u038D\x05\x95J\x02\u038D\u038E\x05\xb7[\x02\u038E\u038F\x05\xa1P\x02\u038F\u0390\x05\xadV\x02\u0390\u0391\x05\xabU\x02\u0391\u0582\x03\x02\x02\x02\u0392\u0393\x05\xa1P\x02\u0393\u0394\x05\xabU\x02\u0394\u0395\x05\xb7[\x02\u0395\u0396\x05\xadV\x02\u0396\u0582\x03\x02\x02\x02\u0397\u0398\x05\xa1P\x02\u0398\u0399\x05\xb5Z\x02\u0399\u039A\x05\x99L\x02\u039A\u039B\x05\xa9T\x02\u039B\u039C\x05\xafW\x02\u039C\u039D\x05\xb7[\x02\u039D\u039E\x05\xc1`\x02\u039E\u0582\x03\x02\x02\x02\u039F\u03A0\x05\xa1P\x02\u03A0\u03A1\x05\xb5Z\x02\u03A1\u03A2\x05\xabU\x02\u03A2\u03A3\x05\xb9\\\x02\u03A3\u03A4\x05\xa7S\x02\u03A4\u03A5\x05\xa7S\x02\u03A5\u0582\x03\x02\x02\x02\u03A6\u03A7\x05\xa3Q\x02\u03A7\u03A8\x05\xadV\x02\u03A8\u03A9\x05\xa1P\x02\u03A9\u03AA\x05\xabU\x02\u03AA\u0582\x03\x02\x02\x02\u03AB\u03AC\x05\xa7S\x02\u03AC\u03AD\x05\x91H\x02\u03AD\u03AE\x05\xb5Z\x02\u03AE\u03AF\x05\xb7[\x02\u03AF\u0582\x03\x02\x02\x02\u03B0\u03B1\x05\xa7S\x02\u03B1\u03B2\x05\x99L\x02\u03B2\u03B3\x05\x9bM\x02\u03B3\u03B4\x05\xb7[\x02\u03B4\u0582\x03\x02\x02\x02\u03B5\u03B6\x05\xa7S\x02\u03B6\u03B7\x05\x99L\x02\u03B7\u03B8\x05\xb5Z\x02\u03B8\u03B9\x05\xb5Z\x02\u03B9\u0582\x03\x02\x02\x02\u03BA\u03BB\x05\xa7S\x02\u03BB\u03BC\x05\xa1P\x02\u03BC\u03BD\x05\xa5R\x02\u03BD\u03BE\x05\x99L\x02\u03BE\u0582\x03\x02\x02\x02\u03BF\u03C0\x05\xa7S\x02\u03C0\u03C1\x05\xa1P\x02\u03C1\u03C2\x05\xa9T\x02\u03C2\u03C3\x05\xa1P\x02\u03C3\u03C4\x05\xb7[\x02\u03C4\u0582\x03\x02\x02\x02\u03C5\u03C6\x05\xa7S\x02\u03C6\u03C7\x05\xadV\x02\u03C7\u03C8\x05\x95J\x02\u03C8\u03C9\x05\xa5R\x02\u03C9\u0582\x03\x02\x02\x02\u03CA\u03CB\x05\xa7S\x02\u03CB\u03CC\x05\xadV\x02\u03CC\u03CD\x05\xabU\x02\u03CD\u03CE\x05\x9dN\x02\u03CE\u0582\x03\x02\x02\x02\u03CF\u03D0\x05\xa9T\x02\u03D0\u03D1\x05\x91H\x02\u03D1\u03D2\x05\xbf_\x02\u03D2\u0582\x03\x02\x02\x02\u03D3\u03D4\x05\xa9T\x02\u03D4\u03D5\x05\xa1P\x02\u03D5\u03D6\x05\xabU\x02\u03D6\u0582\x03\x02\x02\x02\u03D7\u03D8\x05\xa9T\x02\u03D8\u03D9\x05\xa1P\x02\u03D9\u03DA\x05\xabU\x02\u03DA\u03DB\x05\xb9\\\x02\u03DB\u03DC\x05\xb5Z\x02\u03DC\u0582\x03\x02\x02\x02\u03DD\u03DE\x05\xa9T\x02\u03DE\u03DF\x05\xadV\x02\u03DF\u03E0\x05\x97K\x02\u03E0\u03E1\x05\x99L\x02\u03E1\u0582\x03\x02\x02\x02\u03E2\u03E3\x05\xa9T\x02\u03E3\u03E4\x05\xadV\x02\u03E4\u03E5\x05\x97K\x02\u03E5\u03E6\x05\xa1P\x02\u03E6\u03E7\x05\x9bM\x02\u03E7\u03E8\x05\xc1`\x02\u03E8\u0582\x03\x02\x02\x02\u03E9\u03EA\x05\xa9T\x02\u03EA\u03EB\x05\xadV\x02\u03EB\u03EC\x05\x97K\x02\u03EC\u03ED\x05\xb9\\\x02\u03ED\u03EE\x05\xa7S\x02\u03EE\u03EF\x05\xadV\x02\u03EF\u0582\x03\x02\x02\x02\u03F0\u03F1\x05\xa9T\x02\u03F1\u03F2\x05\xadV\x02\u03F2\u03F3\x05\xb3Y\x02\u03F3\u03F4\x05\x99L\x02\u03F4\u0582\x03\x02\x02\x02\u03F5\u03F6\x05\xa9T\x02\u03F6\u03F7\x05\xb9\\\x02\u03F7\u03F8\x05\xa7S\x02\u03F8\u03F9\x05\xb7[\x02\u03F9\u03FA\x05\xa1P\x02\u03FA\u03FB\x05\xafW\x02\u03FB\u03FC\x05\xa7S\x02\u03FC\u03FD\x05\xc1`\x02\u03FD\u0582\x03\x02\x02\x02\u03FE\u03FF\x05\xabU\x02\u03FF\u0400\x05\x99L\x02\u0400\u0401\x05\xbf_\x02\u0401\u0402\x05\xb7[\x02\u0402\u0582\x03\x02\x02\x02\u0403\u0404\x05\xabU\x02\u0404\u0405\x05\xadV\x02\u0405\u0406\x05\x91H\x02\u0406\u0407\x05\xb9\\\x02\u0407\u0408\x05\x97K\x02\u0408\u0409\x05\xa1P\x02\u0409\u040A\x05\xb7[\x02\u040A\u0582\x03\x02\x02\x02\u040B\u040C\x05\xabU\x02\u040C\u040D\x05\xadV\x02\u040D\u040E\x05\xb7[\x02\u040E\u040F\x05\xa1P\x02\u040F\u0410\x05\xabU\x02\u0410\u0582\x03\x02\x02\x02\u0411\u0412\x05\xabU\x02\u0412\u0413\x05\xadV\x02\u0413\u0414\x05\xbd^\x02\u0414\u0415\x05\x91H\x02\u0415\u0416\x05\xa1P\x02\u0416\u0417\x05\xb7[\x02\u0417\u0582\x03\x02\x02\x02\u0418\u0419\x05\xabU\x02\u0419\u041A\x05\xb9\\\x02\u041A\u041B\x05\xa9T\x02\u041B\u041C\x05\x93I\x02\u041C\u041D\x05\x99L\x02\u041D\u041E\x05\xb3Y\x02\u041E\u0582\x03\x02\x02\x02\u041F\u0420\x05\xadV\x02\u0420\u0421\x05\x93I\x02\u0421\u0422\x05\xa3Q\x02\u0422\u0423\x05\x99L\x02\u0423\u0424\x05\x95J\x02\u0424\u0425\x05\xb7[\x02\u0425\u0582\x03\x02\x02\x02\u0426\u0427\x05\xadV\x02\u0427\u0428\x05\x9bM\x02\u0428\u0582\x03\x02\x02\x02\u0429\u042A\x05\xadV\x02\u042A\u042B\x05\xafW\x02\u042B\u042C\x05\xb7[\x02\u042C\u042D\x05\xa1P\x02\u042D\u042E\x05\xadV\x02\u042E\u042F\x05\xabU\x02\u042F\u0582\x03\x02\x02\x02\u0430\u0431\x05\xadV\x02\u0431\u0432\x05\xb9\\\x02\u0432\u0433\x05\xb7[\x02\u0433\u0434\x05\x99L\x02\u0434\u0435\x05\xb3Y\x02\u0435\u0582\x03\x02\x02\x02\u0436\u0437\x05\xadV\x02\u0437\u0438\x05\xb9\\\x02\u0438\u0439\x05\xb7[\x02\u0439\u043A\x05\xafW\x02\u043A\u043B\x05\xb9\\\x02\u043B\u043C\x05\xb7[\x02\u043C\u0582\x03\x02\x02\x02\u043D\u043E\x05\xafW\x02\u043E\u043F\x05\xadV\x02\u043F\u0440\x05\xbd^\x02\u0440\u0441\x05\x99L\x02\u0441\u0442\x05";
        }
        static{
            this._serializedATNSegment2 = '\xb3Y\x02\u0442\u0582\x03\x02\x02\x02\u0443\u0444\x05\xafW\x02\u0444\u0445\x05\xb3Y\x02\u0445\u0446\x05\x99L\x02\u0446\u0447\x05\xbb]\x02\u0447\u0448\x05\xa1P\x02\u0448\u0449\x05\xadV\x02\u0449\u044A\x05\xb9\\\x02\u044A\u044B\x05\xb5Z\x02\u044B\u0582\x03\x02\x02\x02\u044C\u044D\x05\xafW\x02\u044D\u044E\x05\xb3Y\x02\u044E\u044F\x05\xa1P\x02\u044F\u0450\x05\xadV\x02\u0450\u0451\x05\xb3Y\x02\u0451\u0582\x03\x02\x02\x02\u0452\u0453\x05\xafW\x02\u0453\u0454\x05\xb3Y\x02\u0454\u0455\x05\xa1P\x02\u0455\u0456\x05\xbb]\x02\u0456\u0457\x05\xa1P\x02\u0457\u0458\x05\xa7S\x02\u0458\u0459\x05\x99L\x02\u0459\u045A\x05\x9dN\x02\u045A\u045B\x05\x99L\x02\u045B\u045C\x05\xb5Z\x02\u045C\u0582\x03\x02\x02\x02\u045D\u045E\x05\xafW\x02\u045E\u045F\x05\xb9\\\x02\u045F\u0460\x05\x93I\x02\u0460\u0461\x05\xa7S\x02\u0461\u0462\x05\xa1P\x02\u0462\u0463\x05\x95J\x02\u0463\u0582\x03\x02\x02\x02\u0464\u0465\x05\xb3Y\x02\u0465\u0466\x05\x91H\x02\u0466\u0467\x05\xa1P\x02\u0467\u0468\x05\xb5Z\x02\u0468\u0469\x05\x99L\x02\u0469\u0582\x03\x02\x02\x02\u046A\u046B\x05\xb3Y\x02\u046B\u046C\x05\x91H\x02\u046C\u046D\x05\xbd^\x02\u046D\u0582\x03\x02\x02\x02\u046E\u046F\x05\xb3Y\x02\u046F\u0470\x05\x99L\x02\u0470\u0471\x05\xa9T\x02\u0471\u0472\x05\x91H\x02\u0472\u0473\x05\xa1P\x02\u0473\u0474\x05\xabU\x02\u0474\u0475\x05\x97K\x02\u0475\u0476\x05\x99L\x02\u0476\u0477\x05\xb3Y\x02\u0477\u0582\x03\x02\x02\x02\u0478\u0479\x05\xb3Y\x02\u0479\u047A\x05\x99L\x02\u047A\u047B\x05\xabU\x02\u047B\u047C\x05\x91H\x02\u047C\u047D\x05\xa9T\x02\u047D\u047E\x05\x99L\x02\u047E\u0582\x03\x02\x02\x02\u047F\u0480\x05\xb3Y\x02\u0480\u0481\x05\x99L\x02\u0481\u0482\x05\xb5Z\x02\u0482\u0483\x05\xadV\x02\u0483\u0484\x05\xb9\\\x02\u0484\u0485\x05\xb3Y\x02\u0485\u0486\x05\x95J\x02\u0486\u0487\x05\x99L\x02\u0487\u0582\x03\x02\x02\x02\u0488\u0489\x05\xb3Y\x02\u0489\u048A\x05\x99L\x02\u048A\u048B\x05\xb7[\x02\u048B\u048C\x05\xb9\\\x02\u048C\u048D\x05\xb3Y\x02\u048D\u048E\x05\xabU\x02\u048E\u0582\x03\x02\x02\x02\u048F\u0490\x05\xb3Y\x02\u0490\u0491\x05\x99L\x02\u0491\u0492\x05\xb7[\x02\u0492\u0493\x05\xb9\\\x02\u0493\u0494\x05\xb3Y\x02\u0494\u0495\x05\xabU\x02\u0495\u0496\x05\xb5Z\x02\u0496\u0582\x03\x02\x02\x02\u0497\u0498\x05\xb3Y\x02\u0498\u0499\x05\x99L\x02\u0499\u049A\x05\xbb]\x02\u049A\u049B\x05\xadV\x02\u049B\u049C\x05\xa5R\x02\u049C\u049D\x05\x99L\x02\u049D\u0582\x03\x02\x02\x02\u049E\u049F\x05\xb3Y\x02\u049F\u04A0\x05\xa1P\x02\u04A0\u04A1\x05\x9dN\x02\u04A1\u04A2\x05\x9fO\x02\u04A2\u04A3\x05\xb7[\x02\u04A3\u0582\x03\x02\x02\x02\u04A4\u04A5\x05\xb3Y\x02\u04A5\u04A6\x05\xadV\x02\u04A6\u04A7\x05\xbd^\x02\u04A7\u0582\x03\x02\x02\x02\u04A8\u04A9\x05\xb3Y\x02\u04A9\u04AA\x05\xadV\x02\u04AA\u04AB\x05\xbd^\x02\u04AB\u04AC\x05\xa1P\x02\u04AC\u04AD\x05\x97K\x02\u04AD\u0582\x03\x02\x02\x02\u04AE\u04AF\x05\xb3Y\x02\u04AF\u04B0\x05\xadV\x02\u04B0\u04B1\x05\xbd^\x02\u04B1\u04B2\x05\xabU\x02\u04B2\u04B3\x05\xb9\\\x02\u04B3\u04B4\x05\xa9T\x02\u04B4\u0582\x03\x02\x02\x02\u04B5\u04B6\x05\xb3Y\x02\u04B6\u04B7\x05\xadV\x02\u04B7\u04B8\x05\xbd^\x02\u04B8\u04B9\x05\xb5Z\x02\u04B9\u0582\x03\x02\x02\x02\u04BA\u04BB\x05\xb5Z\x02\u04BB\u04BC\x05\x99L\x02\u04BC\u04BD\x05\xa7S\x02\u04BD\u04BE\x05\x99L\x02\u04BE\u04BF\x05\x95J\x02\u04BF\u04C0\x05\xb7[\x02\u04C0\u0582\x03\x02\x02\x02\u04C1\u04C2\x05\xb5Z\x02\u04C2\u04C3\x05\x99L\x02\u04C3\u04C4\x05\xb5Z\x02\u04C4\u04C5\x05\xb5Z\x02\u04C5\u04C6\x05\xa1P\x02\u04C6\u04C7\x05\xadV\x02\u04C7\u04C8\x05\xabU\x02\u04C8\u0582\x03\x02\x02\x02\u04C9\u04CA\x05\xb5Z\x02\u04CA\u04CB\x05\x99L\x02\u04CB\u04CC\x05\xb7[\x02\u04CC\u0582\x03\x02\x02\x02\u04CD\u04CE\x05\xb5Z\x02\u04CE\u04CF\x05\x9fO\x02\u04CF\u04D0\x05\x91H\x02\u04D0\u04D1\x05\xb3Y\x02\u04D1\u04D2\x05\x99L\x02\u04D2\u0582\x03\x02\x02\x02\u04D3\u04D4\x05\xb5Z\x02\u04D4\u04D5\x05\xa1P\x02\u04D5\u04D6\x05\xc3a\x02\u04D6\u04D7\x05\x99L\x02\u04D7\u0582\x03\x02\x02\x02\u04D8\u04D9\x05\xb5Z\x02\u04D9\u04DA\x05\xb1X\x02\u04DA\u04DB\x05\xb3Y\x02\u04DB\u04DC\x05\xb7[\x02\u04DC\u0582\x03\x02\x02\x02\u04DD\u04DE\x05\xb5Z\x02\u04DE\u04DF\x05\xb7[\x02\u04DF\u04E0\x05\x91H\x02\u04E0\u04E1\x05\xb3Y\x02\u04E1\u04E2\x05\xb7[\x02\u04E2\u0582\x03\x02\x02\x02\u04E3\u04E4\x05\xb5Z\x02\u04E4\u04E5\x05\xb7[\x02\u04E5\u04E6\x05\xb3Y\x02\u04E6\u04E7\x05\xa1P\x02\u04E7\u04E8\x05\x95J\x02\u04E8\u04E9\x05\xb7[\x02\u04E9\u0582\x03\x02\x02\x02\u04EA\u04EB\x05\xb5Z\x02\u04EB\u04EC\x05\xb7[\x02\u04EC\u04ED\x05\xb3Y\x02\u04ED\u04EE\x05\xa1P\x02\u04EE\u04EF\x05\xabU\x02\u04EF\u04F0\x05\x9dN\x02\u04F0\u0582\x03\x02\x02\x02\u04F1\u04F2\x05\xb5Z\x02\u04F2\u04F3\x05\xb9\\\x02\u04F3\u04F4\x05\x93I\x02\u04F4\u04F5\x05\xb7[\x02\u04F5\u04F6\x05\xb3Y\x02\u04F6\u04F7\x05\x91H\x02\u04F7\u04F8\x05\x95J\x02\u04F8\u04F9\x05\xb7[\x02\u04F9\u0582\x03\x02\x02\x02\u04FA\u04FB\x05\xb5Z\x02\u04FB\u04FC\x05\xb9\\\x02\u04FC\u04FD\x05\xa9T\x02\u04FD\u0582\x03\x02\x02\x02\u04FE\u04FF\x05\xb5Z\x02\u04FF\u0500\x05\xc1`\x02\u0500\u0501\x05\xabU\x02\u0501\u0502\x05\xadV\x02\u0502\u0503\x05\xabU\x02\u0503\u0504\x05\xc1`\x02\u0504\u0505\x05\xa9T\x02\u0505\u0582\x03\x02\x02\x02\u0506\u0507\x05\xb7[\x02\u0507\u0508\x05\x91H\x02\u0508\u0509\x05\x93I\x02\u0509\u050A\x05\xa7S\x02\u050A\u050B\x05\x99L\x02\u050B\u0582\x03\x02\x02\x02\u050C\u050D\x05\xb7[\x02\u050D\u050E\x05\x9fO\x02\u050E\u050F\x05\x99L\x02\u050F\u0510\x05\xabU\x02\u0510\u0582\x03\x02\x02\x02\u0511\u0512\x05\xb7[\x02\u0512\u0513\x05\xb3Y\x02\u0513\u0514\x05\x91H\x02\u0514\u0515\x05\xabU\x02\u0515\u0516\x05\xb5Z\x02\u0516\u0582\x03\x02\x02\x02\u0517\u0518\x05\xb7[\x02\u0518\u0519\x05\xb3Y\x02\u0519\u051A\x05\x91H\x02\u051A\u051B\x05\xabU\x02\u051B\u051C\x05\xb5Z\x02\u051C\u051D\x05\x91H\x02\u051D\u051E\x05\x95J\x02\u051E\u051F\x05\xb7[\x02\u051F\u0520\x05\xa1P\x02\u0520\u0521\x05\xadV\x02\u0521\u0522\x05\xabU\x02\u0522\u0582\x03\x02\x02\x02\u0523\u0524\x05\xb7[\x02\u0524\u0525\x05\xb3Y\x02\u0525\u0526\x05\xa1P\x02\u0526\u0527\x05\x9dN\x02\u0527\u0528\x05\x9dN\x02\u0528\u0529\x05\x99L\x02\u0529\u052A\x05\xb3Y\x02\u052A\u0582\x03\x02\x02\x02\u052B\u052C\x05\xb7[\x02\u052C\u052D\x05\xb3Y\x02\u052D\u052E\x05\xb9\\\x02\u052E\u052F\x05\x99L\x02\u052F\u0582\x03\x02\x02\x02\u0530\u0531\x05\xb9\\\x02\u0531\u0532\x05\xa1P\x02\u0532\u0533\x05\x97K\x02\u0533\u0582\x03\x02\x02\x02\u0534\u0535\x05\xb9\\\x02\u0535\u0536\x05\xabU\x02\u0536\u0537\x05\xa1P\x02\u0537\u0538\x05\xadV\x02\u0538\u0539\x05\xabU\x02\u0539\u0582\x03\x02\x02\x02\u053A\u053B\x05\xb9\\\x02\u053B\u053C\x05\xabU\x02\u053C\u053D\x05\xa1P\x02\u053D\u053E\x05\xb1X\x02\u053E\u053F\x05\xb9\\\x02\u053F\u0540\x05\x99L\x02\u0540\u0582\x03\x02\x02\x02\u0541\u0542\x05\xb9\\\x02\u0542\u0543\x05\xafW\x02\u0543\u0544\x05\x97K\x02\u0544\u0545\x05\x91H\x02\u0545\u0546\x05\xb7[\x02\u0546\u0547\x05\x99L\x02\u0547\u0582\x03\x02\x02\x02\u0548\u0549\x05\xb9\\\x02\u0549\u054A\x05\xb5Z\x02\u054A\u054B\x05\x99L\x02\u054B\u054C\x05\xb3Y\x02\u054C\u0582\x03\x02\x02\x02\u054D\u054E\x05\xbb]\x02\u054E\u054F\x05\x91H\x02\u054F\u0550\x05\xa7S\x02\u0550\u0551\x05\xa1P\x02\u0551\u0552\x05\x97K\x02\u0552\u0553\x05\x91H\x02\u0553\u0554\x05\xb7[\x02\u0554\u0555\x05\x99L\x02\u0555\u0582\x03\x02\x02\x02\u0556\u0557\x05\xbb]\x02\u0557\u0558\x05\x91H\x02\u0558\u0559\x05\xa7S\x02\u0559\u055A\x05\xb9\\\x02\u055A\u055B\x05\x99L\x02\u055B\u055C\x05\xb5Z\x02\u055C\u0582\x03\x02\x02\x02\u055D\u055E\x05\xbb]\x02\u055E\u055F\x05\xa1P\x02\u055F\u0560\x05\x99L\x02\u0560\u0561\x05\xbd^\x02\u0561\u0582\x03\x02\x02\x02\u0562\u0563\x05\xbd^\x02\u0563\u0564\x05\x9fO\x02\u0564\u0565\x05\x99L\x02\u0565\u0566\x05\xabU\x02\u0566\u0582\x03\x02\x02\x02\u0567\u0568\x05\xbd^\x02\u0568\u0569\x05\x9fO\x02\u0569\u056A\x05\x99L\x02\u056A\u056B\x05\xabU\x02\u056B\u056C\x05\x99L\x02\u056C\u056D\x05\xbb]\x02\u056D\u056E\x05\x99L\x02\u056E\u056F\x05\xb3Y\x02\u056F\u0582\x03\x02\x02\x02\u0570\u0571\x05\xbd^\x02\u0571\u0572\x05\x9fO\x02\u0572\u0573\x05\x99L\x02\u0573\u0574\x05\xb3Y\x02\u0574\u0575\x05\x99L\x02\u0575\u0582\x03\x02\x02\x02\u0576\u0577\x05\xbd^\x02\u0577\u0578\x05\x9fO\x02\u0578\u0579\x05\xa1P\x02\u0579\u057A\x05\xa7S\x02\u057A\u057B\x05\x99L\x02\u057B\u0582\x03\x02\x02\x02\u057C\u057D\x05\xbd^\x02\u057D\u057E\x05\xa1P\x02\u057E\u057F\x05\xb7[\x02\u057F\u0580\x05\x9fO\x02\u0580\u0582\x03\x02\x02\x02\u0581\u0160\x03\x02\x02\x02\u0581\u0166\x03\x02\x02\x02\u0581\u016D\x03\x02\x02\x02\u0581\u0171\x03\x02\x02\x02\u0581\u0177\x03\x02\x02\x02\u0581\u017D\x03\x02\x02\x02\u0581\u0181\x03\x02\x02\x02\u0581\u0184\x03\x02\x02\x02\u0581\u018A\x03\x02\x02\x02\u0581\u018E\x03\x02\x02\x02\u0581\u0194\x03\x02\x02\x02\u0581\u019C\x03\x02\x02\x02\u0581\u01A4\x03\x02\x02\x02\u0581\u01AA\x03\x02\x02\x02\u0581\u01AF\x03\x02\x02\x02\u0581\u01B5\x03\x02\x02\x02\u0581\u01BA\x03\x02\x02\x02\u0581\u01C4\x03\x02\x02\x02\u0581\u01CA\x03\x02\x02\x02\u0581\u01D5\x03\x02\x02\x02\u0581\u01DD\x03\x02\x02\x02\u0581\u01E7\x03\x02\x02\x02\u0581\u01EE\x03\x02\x02\x02\u0581\u01F5\x03\x02\x02\x02\u0581\u01FD\x03\x02\x02\x02\u0581\u0206\x03\x02\x02\x02\u0581\u020C\x03\x02\x02\x02\u0581\u0213\x03\x02\x02\x02\u0581\u021B\x03\x02\x02\x02\u0581\u0220\x03\x02\x02\x02\u0581\u0228\x03\x02\x02\x02\u0581\u0230\x03\x02\x02\x02\u0581\u023A\x03\x02\x02\x02\u0581\u0242\x03\x02\x02\x02\u0581\u024B\x03\x02\x02\x02\u0581\u0252\x03\x02\x02\x02\u0581\u0259\x03\x02\x02\x02\u0581\u0263\x03\x02\x02\x02\u0581\u026E\x03\x02\x02\x02\u0581\u0277\x03\x02\x02\x02\u0581\u027E\x03\x02\x02\x02\u0581\u0281\x03\x02\x02\x02\u0581\u0288\x03\x02\x02\x02\u0581\u028D\x03\x02\x02\x02\u0581\u0292\x03\x02\x02\x02\u0581\u029B\x03\x02\x02\x02\u0581\u029F\x03\x02\x02\x02\u0581\u02A6\x03\x02\x02\x02\u0581\u02AD\x03\x02\x02\x02\u0581\u02B7\x03\x02\x02\x02\u0581\u02BC\x03\x02\x02\x02\u0581\u02C4\x03\x02\x02\x02\u0581\u02CB\x03\x02\x02\x02\u0581\u02D3\x03\x02\x02\x02\u0581\u02D9\x03\x02\x02\x02\u0581\u02DF\x03\x02\x02\x02\u0581\u02E4\x03\x02\x02\x02\u0581\u02EA\x03\x02\x02\x02\u0581\u02F0\x03\x02\x02\x02\u0581\u02F6\x03\x02\x02\x02\u0581\u02FA\x03\x02\x02\x02\u0581\u0303\x03\x02\x02\x02\u0581\u0306\x03\x02\x02\x02\u0581\u030B\x03\x02\x02\x02\u0581\u0311\x03\x02\x02\x02\u0581\u0319\x03\x02\x02\x02\u0581\u031F\x03\x02\x02\x02\u0581\u0326\x03\x02\x02\x02\u0581\u0331\x03\x02\x02\x02\u0581\u0334\x03\x02\x02\x02\u0581\u033E\x03\x02\x02\x02\u0581\u0348\x03\x02\x02\x02\u0581\u034E\x03\x02\x02\x02\u0581\u0356\x03\x02\x02\x02\u0581\u035C\x03\x02\x02\x02\u0581\u0362\x03\x02\x02\x02\u0581\u0368\x03\x02\x02\x02\u0581\u036F\x03\x02\x02\x02\u0581\u0373\x03\x02\x02\x02\u0581\u037B\x03\x02\x02\x02\u0581\u0385\x03\x02\x02\x02\u0581\u0392\x03\x02\x02\x02\u0581\u0397\x03\x02\x02\x02\u0581\u039F\x03\x02\x02\x02\u0581\u03A6\x03\x02\x02\x02\u0581\u03AB\x03\x02\x02\x02\u0581\u03B0\x03\x02\x02\x02\u0581\u03B5\x03\x02\x02\x02\u0581\u03BA\x03\x02\x02\x02\u0581\u03BF\x03\x02\x02\x02\u0581\u03C5\x03\x02\x02\x02\u0581\u03CA\x03\x02\x02\x02\u0581\u03CF\x03\x02\x02\x02\u0581\u03D3\x03\x02\x02\x02\u0581\u03D7\x03\x02\x02\x02\u0581\u03DD\x03\x02\x02\x02\u0581\u03E2\x03\x02\x02\x02\u0581\u03E9\x03\x02\x02\x02\u0581\u03F0\x03\x02\x02\x02\u0581\u03F5\x03\x02\x02\x02\u0581\u03FE\x03\x02\x02\x02\u0581\u0403\x03\x02\x02\x02\u0581\u040B\x03\x02\x02\x02\u0581\u0411\x03\x02\x02\x02\u0581\u0418\x03\x02\x02\x02\u0581\u041F\x03\x02\x02\x02\u0581\u0426\x03\x02\x02\x02\u0581\u0429\x03\x02\x02\x02\u0581\u0430\x03\x02\x02\x02\u0581\u0436\x03\x02\x02\x02\u0581\u043D\x03\x02\x02\x02\u0581\u0443\x03\x02\x02\x02\u0581\u044C\x03\x02\x02\x02\u0581\u0452\x03\x02\x02\x02\u0581\u045D\x03\x02\x02\x02\u0581\u0464\x03\x02\x02\x02\u0581\u046A\x03\x02\x02\x02\u0581\u046E\x03\x02\x02\x02\u0581\u0478\x03\x02\x02\x02\u0581\u047F\x03\x02\x02\x02\u0581\u0488\x03\x02\x02\x02\u0581\u048F\x03\x02\x02\x02\u0581\u0497\x03\x02\x02\x02\u0581\u049E\x03\x02\x02\x02\u0581\u04A4\x03\x02\x02\x02\u0581\u04A8\x03\x02\x02\x02\u0581\u04AE\x03\x02\x02\x02\u0581\u04B5\x03\x02\x02\x02\u0581\u04BA\x03\x02\x02\x02\u0581\u04C1\x03\x02\x02\x02\u0581\u04C9\x03\x02\x02\x02\u0581\u04CD\x03\x02\x02\x02\u0581\u04D3\x03\x02\x02\x02\u0581\u04D8\x03\x02\x02\x02\u0581\u04DD\x03\x02\x02\x02\u0581\u04E3\x03\x02\x02\x02\u0581\u04EA\x03\x02\x02\x02\u0581\u04F1\x03\x02\x02\x02\u0581\u04FA\x03\x02\x02\x02\u0581\u04FE\x03\x02\x02\x02\u0581\u0506\x03\x02\x02\x02\u0581\u050C\x03\x02\x02\x02\u0581\u0511\x03\x02\x02\x02\u0581\u0517\x03\x02\x02\x02\u0581\u0523\x03\x02\x02\x02\u0581\u052B\x03\x02\x02\x02\u0581\u0530\x03\x02\x02\x02\u0581\u0534\x03\x02\x02\x02\u0581\u053A\x03\x02\x02\x02\u0581\u0541\x03\x02\x02\x02\u0581\u0548\x03\x02\x02\x02\u0581\u054D\x03\x02\x02\x02\u0581\u0556\x03\x02\x02\x02\u0581\u055D\x03\x02\x02\x02\u0581\u0562\x03\x02\x02\x02\u0581\u0567\x03\x02\x02\x02\u0581\u0570\x03\x02\x02\x02\u0581\u0576\x03\x02\x02\x02\u0581\u057C\x03\x02\x02\x02\u0582P\x03\x02\x02\x02\u0583\u0586\x05\x85B\x02\u0584\u0586\x05i4\x02\u0585\u0583\x03\x02\x02\x02\u0585\u0584\x03\x02\x02\x02\u0586\u0587\x03\x02\x02\x02\u0587\u0585\x03\x02\x02\x02\u0587\u0588\x03\x02\x02\x02\u0588R\x03\x02\x02\x02\u0589\u058B\x05\x8bE\x02\u058A\u0589\x03\x02\x02\x02\u058B\u058C\x03\x02\x02\x02\u058C\u058A\x03\x02\x02\x02\u058C\u058D\x03\x02\x02\x02\u058D\u058E\x03\x02\x02\x02\u058E\u058F\b)\x05\x02\u058FT\x03\x02\x02\x02\u0590\u0591\x05o7\x02\u0591V\x03\x02\x02\x02\u0592\u0593\v\x02\x02\x02\u0593X\x03\x02\x02\x02\u0594\u0595\x05q8\x02\u0595\u0596\x03\x02\x02\x02\u0596\u0597\b,\x06\x02\u0597Z\x03\x02\x02\x02\u0598\u059B\x05\x85B\x02\u0599\u059B\x05k5\x02\u059A\u0598\x03\x02\x02\x02\u059A\u0599\x03\x02\x02\x02\u059B\u059C\x03\x02\x02\x02\u059C\u059D\b-\x02\x02\u059D\\\x03\x02\x02\x02\u059E\u059F\x07\x02\x02\x03\u059F\u05A0\x03\x02\x02\x02\u05A0\u05A1\b.\x06\x02\u05A1^\x03\x02\x02\x02\u05A2\u05A3\v\x02\x02\x02\u05A3\u05A4\x03\x02\x02\x02\u05A4\u05A5\b/\x06\x02\u05A5`\x03\x02\x02\x02\u05A6\u05A7\x05s9\x02\u05A7\u05A8\x03\x02\x02\x02\u05A8\u05A9\b0\x06\x02\u05A9b\x03\x02\x02\x02\u05AA\u05AD\x05\x85B\x02\u05AB\u05AD\x05m6\x02\u05AC\u05AA\x03\x02\x02\x02\u05AC\u05AB\x03\x02\x02\x02\u05AD\u05AE\x03\x02\x02\x02\u05AE\u05AF\b1\x02\x02\u05AFd\x03\x02\x02\x02\u05B0\u05B1\x07\x02\x02\x03\u05B1\u05B2\x03\x02\x02\x02\u05B2\u05B3\b2\x06\x02\u05B3f\x03\x02\x02\x02\u05B4\u05B5\v\x02\x02\x02\u05B5\u05B6\x03\x02\x02\x02\u05B6\u05B7\b3\x06\x02\u05B7h\x03\x02\x02\x02\u05B8\u05B9\n\x02\x02\x02\u05B9j\x03\x02\x02\x02\u05BA\u05BB\n\x03\x02\x02\u05BBl\x03\x02\x02\x02\u05BC\u05BD\n\x04\x02\x02\u05BDn\x03\x02\x02\x02\u05BE\u05BF	\x05\x02\x02\u05BFp\x03\x02\x02\x02\u05C0\u05C1\x07$\x02\x02\u05C1r\x03\x02\x02\x02\u05C2\u05C3\x07)\x02\x02\u05C3t\x03\x02\x02\x02\u05C4\u05C5\x07^\x02\x02\u05C5v\x03\x02\x02\x02\u05C6\u05C7\x07\x0f\x02\x02\u05C7x\x03\x02\x02\x02\u05C8\u05C9\x07\f\x02\x02\u05C9z\x03\x02\x02\x02\u05CA\u05CB\x07"\x02\x02\u05CB|\x03\x02\x02\x02\u05CC\u05CD\x07(\x02\x02\u05CD~\x03\x02\x02\x02\u05CE\u05CF\x07(\x02\x02\u05CF\u05D0\x07(\x02\x02\u05D0\x80\x03\x02\x02\x02\u05D1\u05D2\x07~\x02\x02\u05D2\x82\x03\x02\x02\x02\u05D3\u05D4\x07~\x02\x02\u05D4\u05D5\x07~\x02\x02\u05D5\x84\x03\x02\x02\x02\u05D6\u05E2\x05u:\x02\u05D7\u05E3	\x06\x02\x02\u05D8\u05E3\x05q8\x02\u05D9\u05E3\x05s9\x02\u05DA\u05E3\x05u:\x02\u05DB\u05E3\x05{=\x02\u05DC\u05DD\x07w\x02\x02\u05DD\u05DE\x05\x89D\x02\u05DE\u05DF\x05\x89D\x02\u05DF\u05E0\x05\x89D\x02\u05E0\u05E1\x05\x89D\x02\u05E1\u05E3\x03\x02\x02\x02\u05E2\u05D7\x03\x02\x02\x02\u05E2\u05D8\x03\x02\x02\x02\u05E2\u05D9\x03\x02\x02\x02\u05E2\u05DA\x03\x02\x02\x02\u05E2\u05DB\x03\x02\x02\x02\u05E2\u05DC\x03\x02\x02\x02\u05E3\x86\x03\x02\x02\x02\u05E4\u05E7\x05w;\x02\u05E5\u05E7\x05y<\x02\u05E6\u05E4\x03\x02\x02\x02\u05E6\u05E5\x03\x02\x02\x02\u05E7\x88\x03\x02\x02\x02\u05E8\u05F0\x05\x8fG\x02\u05E9\u05F0\x05\x91H\x02\u05EA\u05F0\x05\x93I\x02\u05EB\u05F0\x05\x95J\x02\u05EC\u05F0\x05\x97K\x02\u05ED\u05F0\x05\x99L\x02\u05EE\u05F0\x05\x9bM\x02\u05EF\u05E8\x03\x02\x02\x02\u05EF\u05E9\x03\x02\x02\x02\u05EF\u05EA\x03\x02\x02\x02\u05EF\u05EB\x03\x02\x02\x02\u05EF\u05EC\x03\x02\x02\x02\u05EF\u05ED\x03\x02\x02\x02\u05EF\u05EE\x03\x02\x02\x02\u05F0\x8a\x03\x02\x02\x02\u05F1\u05F5\x05{=\x02\u05F2\u05F5\x07\v\x02\x02\u05F3\u05F5\x05\x87C\x02\u05F4\u05F1\x03\x02\x02\x02\u05F4\u05F2\x03\x02\x02\x02\u05F4\u05F3\x03\x02\x02\x02\u05F5\x8c\x03\x02\x02\x02\u05F6\u05F7\x07/\x02\x02\u05F7\x8e\x03\x02\x02\x02\u05F8\u05F9	\x07\x02\x02\u05F9\x90\x03\x02\x02\x02\u05FA\u05FB	\b\x02\x02\u05FB\x92\x03\x02\x02\x02\u05FC\u05FD		\x02\x02\u05FD\x94\x03\x02\x02\x02\u05FE\u05FF	\n\x02\x02\u05FF\x96\x03\x02\x02\x02\u0600\u0601	\v\x02\x02\u0601\x98\x03\x02\x02\x02\u0602\u0603	\f\x02\x02\u0603\x9a\x03\x02\x02\x02\u0604\u0605	\r\x02\x02\u0605\x9c\x03\x02\x02\x02\u0606\u0607	\x0e\x02\x02\u0607\x9e\x03\x02\x02\x02\u0608\u0609	\x0f\x02\x02\u0609\xa0\x03\x02\x02\x02\u060A\u060B	\x10\x02\x02\u060B\xa2\x03\x02\x02\x02\u060C\u060D	\x11\x02\x02\u060D\xa4\x03\x02\x02\x02\u060E\u060F	\x12\x02\x02\u060F\xa6\x03\x02\x02\x02\u0610\u0611	\x13\x02\x02\u0611\xa8\x03\x02\x02\x02\u0612\u0613	\x14\x02\x02\u0613\xaa\x03\x02\x02\x02\u0614\u0615	\x15\x02\x02\u0615\xac\x03\x02\x02\x02\u0616\u0617	\x16\x02\x02\u0617\xae\x03\x02\x02\x02\u0618\u0619	\x17\x02\x02\u0619\xb0\x03\x02\x02\x02\u061A\u061B	\x18\x02\x02\u061B\xb2\x03\x02\x02\x02\u061C\u061D	\x19\x02\x02\u061D\xb4\x03\x02\x02\x02\u061E\u061F	\x1a\x02\x02\u061F\xb6\x03\x02\x02\x02\u0620\u0621	\x1b\x02\x02\u0621\xb8\x03\x02\x02\x02\u0622\u0623	\x1c\x02\x02\u0623\xba\x03\x02\x02\x02\u0624\u0625	\x1d\x02\x02\u0625\xbc\x03\x02\x02\x02\u0626\u0627	\x1e\x02\x02\u0627\xbe\x03\x02\x02\x02\u0628\u0629	\x1f\x02\x02\u0629\xc0\x03\x02\x02\x02\u062A\u062B	 \x02\x02\u062B\xc2\x03\x02\x02\x02\u062C\u062D	!\x02\x02\u062D\xc4\x03\x02\x02\x02\x14\x02\x03\x04\xfb\u0102\u0113\u0155\u015B\u0581\u0585\u0587\u058C\u059A\u05AC\u05E2\u05E6\u05EF\u05F4\x07\x05\x02\x02\x04\x03\x02\x04\x04\x02\x02\x03\x02\x04\x02\x02';
        }
        static{
            this._serializedATN = $2IEP9.join([
                $a012d4d52c1b9f90$export$375c79404cc64c7f._serializedATNSegment0,
                $a012d4d52c1b9f90$export$375c79404cc64c7f._serializedATNSegment1,
                $a012d4d52c1b9f90$export$375c79404cc64c7f._serializedATNSegment2
            ], '');
        }
        static get _ATN() {
            if (!$a012d4d52c1b9f90$export$375c79404cc64c7f.__ATN) $a012d4d52c1b9f90$export$375c79404cc64c7f.__ATN = new (0, $dvgsl.ATNDeserializer)().deserialize($2IEP9.toCharArray($a012d4d52c1b9f90$export$375c79404cc64c7f._serializedATN));
            return $a012d4d52c1b9f90$export$375c79404cc64c7f.__ATN;
        }
    }
});
parcelRegister("4qX9B", function(module, exports) {
    $parcel$export(module.exports, "JQLParser", ()=>$69b00e3e489fb6d8$export$9c4772e191bdb810);
    var $dvgsl = parcelRequire("dvgsl");
    var $hKCjP = parcelRequire("hKCjP");
    var $jIG0W = parcelRequire("jIG0W");
    var $6bmaO = parcelRequire("6bmaO");
    var $kzbnL = parcelRequire("kzbnL");
    var $fLdDn = parcelRequire("fLdDn");
    var $2DVsz = parcelRequire("2DVsz");
    var $3n2FE = parcelRequire("3n2FE");
    var $2IEP9 = parcelRequire("2IEP9");
    class $69b00e3e489fb6d8$export$9c4772e191bdb810 extends (0, $jIG0W.Parser) {
        static{
            this.LPAREN = 1;
        }
        static{
            this.RPAREN = 2;
        }
        static{
            this.COMMA = 3;
        }
        static{
            this.LBRACKET = 4;
        }
        static{
            this.RBRACKET = 5;
        }
        static{
            this.BANG = 6;
        }
        static{
            this.LT = 7;
        }
        static{
            this.GT = 8;
        }
        static{
            this.GTEQ = 9;
        }
        static{
            this.LTEQ = 10;
        }
        static{
            this.EQUALS = 11;
        }
        static{
            this.NOT_EQUALS = 12;
        }
        static{
            this.LIKE = 13;
        }
        static{
            this.NOT_LIKE = 14;
        }
        static{
            this.IN = 15;
        }
        static{
            this.IS = 16;
        }
        static{
            this.AND = 17;
        }
        static{
            this.OR = 18;
        }
        static{
            this.NOT = 19;
        }
        static{
            this.EMPTY = 20;
        }
        static{
            this.WAS = 21;
        }
        static{
            this.CHANGED = 22;
        }
        static{
            this.BEFORE = 23;
        }
        static{
            this.AFTER = 24;
        }
        static{
            this.FROM = 25;
        }
        static{
            this.TO = 26;
        }
        static{
            this.ON = 27;
        }
        static{
            this.DURING = 28;
        }
        static{
            this.ORDER = 29;
        }
        static{
            this.BY = 30;
        }
        static{
            this.ASC = 31;
        }
        static{
            this.DESC = 32;
        }
        static{
            this.POSNUMBER = 33;
        }
        static{
            this.NEGNUMBER = 34;
        }
        static{
            this.CUSTOMFIELD = 35;
        }
        static{
            this.RESERVED_WORD = 36;
        }
        static{
            this.STRING = 37;
        }
        static{
            this.MATCHWS = 38;
        }
        static{
            this.ERROR_RESERVED = 39;
        }
        static{
            this.ERRORCHAR = 40;
        }
        static{
            this.QUOTE_STRING = 41;
        }
        static{
            this.UNCLOSED_QUOTE_STRING = 42;
        }
        static{
            this.INVALID_QUOTE_STRING = 43;
        }
        static{
            this.SQUOTE_STRING = 44;
        }
        static{
            this.UNCLOSED_SQUOTE_STRING = 45;
        }
        static{
            this.INVALID_SQUOTE_STRING = 46;
        }
        static{
            this.RULE_jqlQuery = 0;
        }
        static{
            this.RULE_jqlWhere = 1;
        }
        static{
            this.RULE_jqlOrClause = 2;
        }
        static{
            this.RULE_jqlAndClause = 3;
        }
        static{
            this.RULE_jqlNotClause = 4;
        }
        static{
            this.RULE_jqlSubClause = 5;
        }
        static{
            this.RULE_jqlTerminalClause = 6;
        }
        static{
            this.RULE_jqlTerminalClauseRhs = 7;
        }
        static{
            this.RULE_jqlEqualsOperator = 8;
        }
        static{
            this.RULE_jqlLikeOperator = 9;
        }
        static{
            this.RULE_jqlComparisonOperator = 10;
        }
        static{
            this.RULE_jqlInOperator = 11;
        }
        static{
            this.RULE_jqlIsOperator = 12;
        }
        static{
            this.RULE_jqlWasOperator = 13;
        }
        static{
            this.RULE_jqlWasInOperator = 14;
        }
        static{
            this.RULE_jqlChangedOperator = 15;
        }
        static{
            this.RULE_jqlField = 16;
        }
        static{
            this.RULE_jqlFieldProperty = 17;
        }
        static{
            this.RULE_jqlCustomField = 18;
        }
        static{
            this.RULE_jqlString = 19;
        }
        static{
            this.RULE_jqlNumber = 20;
        }
        static{
            this.RULE_jqlOperand = 21;
        }
        static{
            this.RULE_jqlEmpty = 22;
        }
        static{
            this.RULE_jqlValue = 23;
        }
        static{
            this.RULE_jqlFunction = 24;
        }
        static{
            this.RULE_jqlFunctionName = 25;
        }
        static{
            this.RULE_jqlArgumentList = 26;
        }
        static{
            this.RULE_jqlList = 27;
        }
        static{
            this.RULE_jqlListStart = 28;
        }
        static{
            this.RULE_jqlListEnd = 29;
        }
        static{
            this.RULE_jqlPropertyArgument = 30;
        }
        static{
            this.RULE_jqlArgument = 31;
        }
        static{
            this.RULE_jqlWasPredicate = 32;
        }
        static{
            this.RULE_jqlChangedPredicate = 33;
        }
        static{
            this.RULE_jqlDatePredicateOperator = 34;
        }
        static{
            this.RULE_jqlDateRangePredicateOperator = 35;
        }
        static{
            this.RULE_jqlUserPredicateOperator = 36;
        }
        static{
            this.RULE_jqlValuePredicateOperator = 37;
        }
        static{
            this.RULE_jqlPredicateOperand = 38;
        }
        static{
            this.RULE_jqlOrderBy = 39;
        }
        static{
            this.RULE_jqlSearchSort = 40;
        }
        static{
            this.ruleNames = [
                'jqlQuery',
                'jqlWhere',
                'jqlOrClause',
                'jqlAndClause',
                'jqlNotClause',
                'jqlSubClause',
                'jqlTerminalClause',
                'jqlTerminalClauseRhs',
                'jqlEqualsOperator',
                'jqlLikeOperator',
                'jqlComparisonOperator',
                'jqlInOperator',
                'jqlIsOperator',
                'jqlWasOperator',
                'jqlWasInOperator',
                'jqlChangedOperator',
                'jqlField',
                'jqlFieldProperty',
                'jqlCustomField',
                'jqlString',
                'jqlNumber',
                'jqlOperand',
                'jqlEmpty',
                'jqlValue',
                'jqlFunction',
                'jqlFunctionName',
                'jqlArgumentList',
                'jqlList',
                'jqlListStart',
                'jqlListEnd',
                'jqlPropertyArgument',
                'jqlArgument',
                'jqlWasPredicate',
                'jqlChangedPredicate',
                'jqlDatePredicateOperator',
                'jqlDateRangePredicateOperator',
                'jqlUserPredicateOperator',
                'jqlValuePredicateOperator',
                'jqlPredicateOperand',
                'jqlOrderBy',
                'jqlSearchSort'
            ];
        }
        static{
            this._LITERAL_NAMES = [
                undefined,
                "'('",
                "')'",
                "','",
                "'['",
                "']'",
                "'!'",
                "'<'",
                "'>'",
                "'>='",
                "'<='",
                "'='",
                "'!='",
                "'~'",
                "'!~'"
            ];
        }
        static{
            this._SYMBOLIC_NAMES = [
                undefined,
                'LPAREN',
                'RPAREN',
                'COMMA',
                'LBRACKET',
                'RBRACKET',
                'BANG',
                'LT',
                'GT',
                'GTEQ',
                'LTEQ',
                'EQUALS',
                'NOT_EQUALS',
                'LIKE',
                'NOT_LIKE',
                'IN',
                'IS',
                'AND',
                'OR',
                'NOT',
                'EMPTY',
                'WAS',
                'CHANGED',
                'BEFORE',
                'AFTER',
                'FROM',
                'TO',
                'ON',
                'DURING',
                'ORDER',
                'BY',
                'ASC',
                'DESC',
                'POSNUMBER',
                'NEGNUMBER',
                'CUSTOMFIELD',
                'RESERVED_WORD',
                'STRING',
                'MATCHWS',
                'ERROR_RESERVED',
                'ERRORCHAR',
                'QUOTE_STRING',
                'UNCLOSED_QUOTE_STRING',
                'INVALID_QUOTE_STRING',
                'SQUOTE_STRING',
                'UNCLOSED_SQUOTE_STRING',
                'INVALID_SQUOTE_STRING'
            ];
        }
        static{
            this.VOCABULARY = new (0, $3n2FE.VocabularyImpl)($69b00e3e489fb6d8$export$9c4772e191bdb810._LITERAL_NAMES, $69b00e3e489fb6d8$export$9c4772e191bdb810._SYMBOLIC_NAMES, []);
        }
        get vocabulary() {
            return $69b00e3e489fb6d8$export$9c4772e191bdb810.VOCABULARY;
        }
        get grammarFileName() {
            return 'JQLParser.g4';
        }
        get ruleNames() {
            return $69b00e3e489fb6d8$export$9c4772e191bdb810.ruleNames;
        }
        get serializedATN() {
            return $69b00e3e489fb6d8$export$9c4772e191bdb810._serializedATN;
        }
        constructor(input){
            super(input);
            this._interp = new (0, $kzbnL.ParserATNSimulator)($69b00e3e489fb6d8$export$9c4772e191bdb810._ATN, this);
        }
        jqlQuery() {
            let _localctx = new $69b00e3e489fb6d8$export$ff413535b9575c8(this._ctx, this.state);
            this.enterRule(_localctx, 0, $69b00e3e489fb6d8$export$9c4772e191bdb810.RULE_jqlQuery);
            let _la;
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 83;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if ((_la & -32) === 0 && (1 << _la & (1 << $69b00e3e489fb6d8$export$9c4772e191bdb810.LPAREN | 1 << $69b00e3e489fb6d8$export$9c4772e191bdb810.BANG | 1 << $69b00e3e489fb6d8$export$9c4772e191bdb810.NOT)) !== 0 || (_la - 33 & -32) === 0 && (1 << _la - 33 & (1 << $69b00e3e489fb6d8$export$9c4772e191bdb810.POSNUMBER - 33 | 1 << $69b00e3e489fb6d8$export$9c4772e191bdb810.NEGNUMBER - 33 | 1 << $69b00e3e489fb6d8$export$9c4772e191bdb810.CUSTOMFIELD - 33 | 1 << $69b00e3e489fb6d8$export$9c4772e191bdb810.STRING - 33 | 1 << $69b00e3e489fb6d8$export$9c4772e191bdb810.QUOTE_STRING - 33 | 1 << $69b00e3e489fb6d8$export$9c4772e191bdb810.SQUOTE_STRING - 33)) !== 0) {
                    this.state = 82;
                    this.jqlWhere();
                }
                this.state = 86;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === $69b00e3e489fb6d8$export$9c4772e191bdb810.ORDER) {
                    this.state = 85;
                    this.jqlOrderBy();
                }
                this.state = 88;
                this.match($69b00e3e489fb6d8$export$9c4772e191bdb810.EOF);
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlWhere() {
            let _localctx = new $69b00e3e489fb6d8$export$4148a879cab28017(this._ctx, this.state);
            this.enterRule(_localctx, 2, $69b00e3e489fb6d8$export$9c4772e191bdb810.RULE_jqlWhere);
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 90;
                this.jqlOrClause();
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlOrClause() {
            let _localctx = new $69b00e3e489fb6d8$export$d69831d387793480(this._ctx, this.state);
            this.enterRule(_localctx, 4, $69b00e3e489fb6d8$export$9c4772e191bdb810.RULE_jqlOrClause);
            let _la;
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 92;
                this.jqlAndClause();
                this.state = 97;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                while(_la === $69b00e3e489fb6d8$export$9c4772e191bdb810.OR){
                    this.state = 93;
                    this.match($69b00e3e489fb6d8$export$9c4772e191bdb810.OR);
                    this.state = 94;
                    this.jqlAndClause();
                    this.state = 99;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlAndClause() {
            let _localctx = new $69b00e3e489fb6d8$export$f16819001158b9e(this._ctx, this.state);
            this.enterRule(_localctx, 6, $69b00e3e489fb6d8$export$9c4772e191bdb810.RULE_jqlAndClause);
            let _la;
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 100;
                this.jqlNotClause();
                this.state = 105;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                while(_la === $69b00e3e489fb6d8$export$9c4772e191bdb810.AND){
                    this.state = 101;
                    this.match($69b00e3e489fb6d8$export$9c4772e191bdb810.AND);
                    this.state = 102;
                    this.jqlNotClause();
                    this.state = 107;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlNotClause() {
            let _localctx = new $69b00e3e489fb6d8$export$5e9146f8d5cf1330(this._ctx, this.state);
            this.enterRule(_localctx, 8, $69b00e3e489fb6d8$export$9c4772e191bdb810.RULE_jqlNotClause);
            let _la;
            try {
                this.state = 112;
                this._errHandler.sync(this);
                switch(this._input.LA(1)){
                    case $69b00e3e489fb6d8$export$9c4772e191bdb810.BANG:
                    case $69b00e3e489fb6d8$export$9c4772e191bdb810.NOT:
                        this.enterOuterAlt(_localctx, 1);
                        this.state = 108;
                        _la = this._input.LA(1);
                        if (!(_la === $69b00e3e489fb6d8$export$9c4772e191bdb810.BANG || _la === $69b00e3e489fb6d8$export$9c4772e191bdb810.NOT)) this._errHandler.recoverInline(this);
                        else {
                            if (this._input.LA(1) === (0, $2DVsz.Token).EOF) this.matchedEOF = true;
                            this._errHandler.reportMatch(this);
                            this.consume();
                        }
                        this.state = 109;
                        this.jqlNotClause();
                        break;
                    case $69b00e3e489fb6d8$export$9c4772e191bdb810.LPAREN:
                        this.enterOuterAlt(_localctx, 2);
                        this.state = 110;
                        this.jqlSubClause();
                        break;
                    case $69b00e3e489fb6d8$export$9c4772e191bdb810.POSNUMBER:
                    case $69b00e3e489fb6d8$export$9c4772e191bdb810.NEGNUMBER:
                    case $69b00e3e489fb6d8$export$9c4772e191bdb810.CUSTOMFIELD:
                    case $69b00e3e489fb6d8$export$9c4772e191bdb810.STRING:
                    case $69b00e3e489fb6d8$export$9c4772e191bdb810.QUOTE_STRING:
                    case $69b00e3e489fb6d8$export$9c4772e191bdb810.SQUOTE_STRING:
                        this.enterOuterAlt(_localctx, 3);
                        this.state = 111;
                        this.jqlTerminalClause();
                        break;
                    default:
                        throw new (0, $hKCjP.NoViableAltException)(this);
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlSubClause() {
            let _localctx = new $69b00e3e489fb6d8$export$a136a0e9655bfb04(this._ctx, this.state);
            this.enterRule(_localctx, 10, $69b00e3e489fb6d8$export$9c4772e191bdb810.RULE_jqlSubClause);
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 114;
                this.match($69b00e3e489fb6d8$export$9c4772e191bdb810.LPAREN);
                this.state = 115;
                this.jqlOrClause();
                this.state = 116;
                this.match($69b00e3e489fb6d8$export$9c4772e191bdb810.RPAREN);
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlTerminalClause() {
            let _localctx = new $69b00e3e489fb6d8$export$23486a2f2ddd5bcd(this._ctx, this.state);
            this.enterRule(_localctx, 12, $69b00e3e489fb6d8$export$9c4772e191bdb810.RULE_jqlTerminalClause);
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 118;
                this.jqlField();
                this.state = 119;
                this.jqlTerminalClauseRhs();
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlTerminalClauseRhs() {
            let _localctx = new $69b00e3e489fb6d8$export$93924a205c12d32c(this._ctx, this.state);
            this.enterRule(_localctx, 14, $69b00e3e489fb6d8$export$9c4772e191bdb810.RULE_jqlTerminalClauseRhs);
            let _la;
            try {
                this.state = 176;
                this._errHandler.sync(this);
                switch(this.interpreter.adaptivePredict(this._input, 14, this._ctx)){
                    case 1:
                        _localctx = new $69b00e3e489fb6d8$export$c428f709a58396e5(_localctx);
                        this.enterOuterAlt(_localctx, 1);
                        this.state = 121;
                        this.jqlEqualsOperator();
                        this.state = 125;
                        this._errHandler.sync(this);
                        switch(this.interpreter.adaptivePredict(this._input, 5, this._ctx)){
                            case 1:
                                this.state = 122;
                                this.jqlEmpty();
                                break;
                            case 2:
                                this.state = 123;
                                this.jqlValue();
                                break;
                            case 3:
                                this.state = 124;
                                this.jqlFunction();
                                break;
                        }
                        break;
                    case 2:
                        _localctx = new $69b00e3e489fb6d8$export$1b131204ef9fa33d(_localctx);
                        this.enterOuterAlt(_localctx, 2);
                        this.state = 127;
                        this.jqlLikeOperator();
                        this.state = 131;
                        this._errHandler.sync(this);
                        switch(this.interpreter.adaptivePredict(this._input, 6, this._ctx)){
                            case 1:
                                this.state = 128;
                                this.jqlEmpty();
                                break;
                            case 2:
                                this.state = 129;
                                this.jqlValue();
                                break;
                            case 3:
                                this.state = 130;
                                this.jqlFunction();
                                break;
                        }
                        break;
                    case 3:
                        _localctx = new $69b00e3e489fb6d8$export$d83706ee80a9852a(_localctx);
                        this.enterOuterAlt(_localctx, 3);
                        this.state = 133;
                        this.jqlComparisonOperator();
                        this.state = 136;
                        this._errHandler.sync(this);
                        switch(this.interpreter.adaptivePredict(this._input, 7, this._ctx)){
                            case 1:
                                this.state = 134;
                                this.jqlValue();
                                break;
                            case 2:
                                this.state = 135;
                                this.jqlFunction();
                                break;
                        }
                        break;
                    case 4:
                        _localctx = new $69b00e3e489fb6d8$export$2934b8ff22fddd2d(_localctx);
                        this.enterOuterAlt(_localctx, 4);
                        this.state = 138;
                        this.jqlInOperator();
                        this.state = 141;
                        this._errHandler.sync(this);
                        switch(this._input.LA(1)){
                            case $69b00e3e489fb6d8$export$9c4772e191bdb810.LPAREN:
                                this.state = 139;
                                this.jqlList();
                                break;
                            case $69b00e3e489fb6d8$export$9c4772e191bdb810.POSNUMBER:
                            case $69b00e3e489fb6d8$export$9c4772e191bdb810.NEGNUMBER:
                            case $69b00e3e489fb6d8$export$9c4772e191bdb810.STRING:
                            case $69b00e3e489fb6d8$export$9c4772e191bdb810.QUOTE_STRING:
                            case $69b00e3e489fb6d8$export$9c4772e191bdb810.SQUOTE_STRING:
                                this.state = 140;
                                this.jqlFunction();
                                break;
                            default:
                                throw new (0, $hKCjP.NoViableAltException)(this);
                        }
                        break;
                    case 5:
                        _localctx = new $69b00e3e489fb6d8$export$8b84310182afcf93(_localctx);
                        this.enterOuterAlt(_localctx, 5);
                        this.state = 143;
                        this.jqlIsOperator();
                        this.state = 144;
                        this.jqlEmpty();
                        break;
                    case 6:
                        _localctx = new $69b00e3e489fb6d8$export$5df295dc7a2cac7c(_localctx);
                        this.enterOuterAlt(_localctx, 6);
                        this.state = 146;
                        this.jqlWasOperator();
                        this.state = 150;
                        this._errHandler.sync(this);
                        switch(this.interpreter.adaptivePredict(this._input, 9, this._ctx)){
                            case 1:
                                this.state = 147;
                                this.jqlEmpty();
                                break;
                            case 2:
                                this.state = 148;
                                this.jqlValue();
                                break;
                            case 3:
                                this.state = 149;
                                this.jqlFunction();
                                break;
                        }
                        this.state = 155;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                        while((_la & -32) === 0 && (1 << _la & (1 << $69b00e3e489fb6d8$export$9c4772e191bdb810.BEFORE | 1 << $69b00e3e489fb6d8$export$9c4772e191bdb810.AFTER | 1 << $69b00e3e489fb6d8$export$9c4772e191bdb810.ON | 1 << $69b00e3e489fb6d8$export$9c4772e191bdb810.DURING | 1 << $69b00e3e489fb6d8$export$9c4772e191bdb810.BY)) !== 0){
                            this.state = 152;
                            this.jqlWasPredicate();
                            this.state = 157;
                            this._errHandler.sync(this);
                            _la = this._input.LA(1);
                        }
                        break;
                    case 7:
                        _localctx = new $69b00e3e489fb6d8$export$9ac3367aee261b32(_localctx);
                        this.enterOuterAlt(_localctx, 7);
                        this.state = 158;
                        this.jqlWasInOperator();
                        this.state = 161;
                        this._errHandler.sync(this);
                        switch(this._input.LA(1)){
                            case $69b00e3e489fb6d8$export$9c4772e191bdb810.LPAREN:
                                this.state = 159;
                                this.jqlList();
                                break;
                            case $69b00e3e489fb6d8$export$9c4772e191bdb810.POSNUMBER:
                            case $69b00e3e489fb6d8$export$9c4772e191bdb810.NEGNUMBER:
                            case $69b00e3e489fb6d8$export$9c4772e191bdb810.STRING:
                            case $69b00e3e489fb6d8$export$9c4772e191bdb810.QUOTE_STRING:
                            case $69b00e3e489fb6d8$export$9c4772e191bdb810.SQUOTE_STRING:
                                this.state = 160;
                                this.jqlFunction();
                                break;
                            default:
                                throw new (0, $hKCjP.NoViableAltException)(this);
                        }
                        this.state = 166;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                        while((_la & -32) === 0 && (1 << _la & (1 << $69b00e3e489fb6d8$export$9c4772e191bdb810.BEFORE | 1 << $69b00e3e489fb6d8$export$9c4772e191bdb810.AFTER | 1 << $69b00e3e489fb6d8$export$9c4772e191bdb810.ON | 1 << $69b00e3e489fb6d8$export$9c4772e191bdb810.DURING | 1 << $69b00e3e489fb6d8$export$9c4772e191bdb810.BY)) !== 0){
                            this.state = 163;
                            this.jqlWasPredicate();
                            this.state = 168;
                            this._errHandler.sync(this);
                            _la = this._input.LA(1);
                        }
                        break;
                    case 8:
                        _localctx = new $69b00e3e489fb6d8$export$7a7defca8628a13c(_localctx);
                        this.enterOuterAlt(_localctx, 8);
                        this.state = 169;
                        this.jqlChangedOperator();
                        this.state = 173;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                        while((_la & -32) === 0 && (1 << _la & (1 << $69b00e3e489fb6d8$export$9c4772e191bdb810.BEFORE | 1 << $69b00e3e489fb6d8$export$9c4772e191bdb810.AFTER | 1 << $69b00e3e489fb6d8$export$9c4772e191bdb810.FROM | 1 << $69b00e3e489fb6d8$export$9c4772e191bdb810.TO | 1 << $69b00e3e489fb6d8$export$9c4772e191bdb810.ON | 1 << $69b00e3e489fb6d8$export$9c4772e191bdb810.DURING | 1 << $69b00e3e489fb6d8$export$9c4772e191bdb810.BY)) !== 0){
                            this.state = 170;
                            this.jqlChangedPredicate();
                            this.state = 175;
                            this._errHandler.sync(this);
                            _la = this._input.LA(1);
                        }
                        break;
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlEqualsOperator() {
            let _localctx = new $69b00e3e489fb6d8$export$41e475fc1988e413(this._ctx, this.state);
            this.enterRule(_localctx, 16, $69b00e3e489fb6d8$export$9c4772e191bdb810.RULE_jqlEqualsOperator);
            let _la;
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 178;
                _la = this._input.LA(1);
                if (!(_la === $69b00e3e489fb6d8$export$9c4772e191bdb810.EQUALS || _la === $69b00e3e489fb6d8$export$9c4772e191bdb810.NOT_EQUALS)) this._errHandler.recoverInline(this);
                else {
                    if (this._input.LA(1) === (0, $2DVsz.Token).EOF) this.matchedEOF = true;
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlLikeOperator() {
            let _localctx = new $69b00e3e489fb6d8$export$b76fe5387fdd7efd(this._ctx, this.state);
            this.enterRule(_localctx, 18, $69b00e3e489fb6d8$export$9c4772e191bdb810.RULE_jqlLikeOperator);
            let _la;
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 180;
                _la = this._input.LA(1);
                if (!(_la === $69b00e3e489fb6d8$export$9c4772e191bdb810.LIKE || _la === $69b00e3e489fb6d8$export$9c4772e191bdb810.NOT_LIKE)) this._errHandler.recoverInline(this);
                else {
                    if (this._input.LA(1) === (0, $2DVsz.Token).EOF) this.matchedEOF = true;
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlComparisonOperator() {
            let _localctx = new $69b00e3e489fb6d8$export$d821da0716b3ec95(this._ctx, this.state);
            this.enterRule(_localctx, 20, $69b00e3e489fb6d8$export$9c4772e191bdb810.RULE_jqlComparisonOperator);
            let _la;
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 182;
                _la = this._input.LA(1);
                if (!((_la & -32) === 0 && (1 << _la & (1 << $69b00e3e489fb6d8$export$9c4772e191bdb810.LT | 1 << $69b00e3e489fb6d8$export$9c4772e191bdb810.GT | 1 << $69b00e3e489fb6d8$export$9c4772e191bdb810.GTEQ | 1 << $69b00e3e489fb6d8$export$9c4772e191bdb810.LTEQ)) !== 0)) this._errHandler.recoverInline(this);
                else {
                    if (this._input.LA(1) === (0, $2DVsz.Token).EOF) this.matchedEOF = true;
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlInOperator() {
            let _localctx = new $69b00e3e489fb6d8$export$178478bfa8292f72(this._ctx, this.state);
            this.enterRule(_localctx, 22, $69b00e3e489fb6d8$export$9c4772e191bdb810.RULE_jqlInOperator);
            try {
                this.state = 187;
                this._errHandler.sync(this);
                switch(this._input.LA(1)){
                    case $69b00e3e489fb6d8$export$9c4772e191bdb810.IN:
                        this.enterOuterAlt(_localctx, 1);
                        this.state = 184;
                        this.match($69b00e3e489fb6d8$export$9c4772e191bdb810.IN);
                        break;
                    case $69b00e3e489fb6d8$export$9c4772e191bdb810.NOT:
                        this.enterOuterAlt(_localctx, 2);
                        this.state = 185;
                        this.match($69b00e3e489fb6d8$export$9c4772e191bdb810.NOT);
                        this.state = 186;
                        this.match($69b00e3e489fb6d8$export$9c4772e191bdb810.IN);
                        break;
                    default:
                        throw new (0, $hKCjP.NoViableAltException)(this);
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlIsOperator() {
            let _localctx = new $69b00e3e489fb6d8$export$e64c31d2830b66e4(this._ctx, this.state);
            this.enterRule(_localctx, 24, $69b00e3e489fb6d8$export$9c4772e191bdb810.RULE_jqlIsOperator);
            try {
                this.state = 192;
                this._errHandler.sync(this);
                switch(this.interpreter.adaptivePredict(this._input, 16, this._ctx)){
                    case 1:
                        this.enterOuterAlt(_localctx, 1);
                        this.state = 189;
                        this.match($69b00e3e489fb6d8$export$9c4772e191bdb810.IS);
                        break;
                    case 2:
                        this.enterOuterAlt(_localctx, 2);
                        this.state = 190;
                        this.match($69b00e3e489fb6d8$export$9c4772e191bdb810.IS);
                        this.state = 191;
                        this.match($69b00e3e489fb6d8$export$9c4772e191bdb810.NOT);
                        break;
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlWasOperator() {
            let _localctx = new $69b00e3e489fb6d8$export$7e283636700e4a6c(this._ctx, this.state);
            this.enterRule(_localctx, 26, $69b00e3e489fb6d8$export$9c4772e191bdb810.RULE_jqlWasOperator);
            try {
                this.state = 197;
                this._errHandler.sync(this);
                switch(this.interpreter.adaptivePredict(this._input, 17, this._ctx)){
                    case 1:
                        this.enterOuterAlt(_localctx, 1);
                        this.state = 194;
                        this.match($69b00e3e489fb6d8$export$9c4772e191bdb810.WAS);
                        break;
                    case 2:
                        this.enterOuterAlt(_localctx, 2);
                        this.state = 195;
                        this.match($69b00e3e489fb6d8$export$9c4772e191bdb810.WAS);
                        this.state = 196;
                        this.match($69b00e3e489fb6d8$export$9c4772e191bdb810.NOT);
                        break;
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlWasInOperator() {
            let _localctx = new $69b00e3e489fb6d8$export$b9118b1ed9a78d66(this._ctx, this.state);
            this.enterRule(_localctx, 28, $69b00e3e489fb6d8$export$9c4772e191bdb810.RULE_jqlWasInOperator);
            try {
                this.state = 204;
                this._errHandler.sync(this);
                switch(this.interpreter.adaptivePredict(this._input, 18, this._ctx)){
                    case 1:
                        this.enterOuterAlt(_localctx, 1);
                        this.state = 199;
                        this.match($69b00e3e489fb6d8$export$9c4772e191bdb810.WAS);
                        this.state = 200;
                        this.match($69b00e3e489fb6d8$export$9c4772e191bdb810.IN);
                        break;
                    case 2:
                        this.enterOuterAlt(_localctx, 2);
                        this.state = 201;
                        this.match($69b00e3e489fb6d8$export$9c4772e191bdb810.WAS);
                        this.state = 202;
                        this.match($69b00e3e489fb6d8$export$9c4772e191bdb810.NOT);
                        this.state = 203;
                        this.match($69b00e3e489fb6d8$export$9c4772e191bdb810.IN);
                        break;
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlChangedOperator() {
            let _localctx = new $69b00e3e489fb6d8$export$493d626ed78ca66(this._ctx, this.state);
            this.enterRule(_localctx, 30, $69b00e3e489fb6d8$export$9c4772e191bdb810.RULE_jqlChangedOperator);
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 206;
                this.match($69b00e3e489fb6d8$export$9c4772e191bdb810.CHANGED);
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlField() {
            let _localctx = new $69b00e3e489fb6d8$export$b33300c3d916229a(this._ctx, this.state);
            this.enterRule(_localctx, 32, $69b00e3e489fb6d8$export$9c4772e191bdb810.RULE_jqlField);
            let _la;
            try {
                this.state = 219;
                this._errHandler.sync(this);
                switch(this._input.LA(1)){
                    case $69b00e3e489fb6d8$export$9c4772e191bdb810.POSNUMBER:
                    case $69b00e3e489fb6d8$export$9c4772e191bdb810.NEGNUMBER:
                        _localctx = new $69b00e3e489fb6d8$export$11fec15307d2e17b(_localctx);
                        this.enterOuterAlt(_localctx, 1);
                        this.state = 208;
                        this.jqlNumber();
                        break;
                    case $69b00e3e489fb6d8$export$9c4772e191bdb810.CUSTOMFIELD:
                    case $69b00e3e489fb6d8$export$9c4772e191bdb810.STRING:
                    case $69b00e3e489fb6d8$export$9c4772e191bdb810.QUOTE_STRING:
                    case $69b00e3e489fb6d8$export$9c4772e191bdb810.SQUOTE_STRING:
                        _localctx = new $69b00e3e489fb6d8$export$b8b24f99f985ebb3(_localctx);
                        this.enterOuterAlt(_localctx, 2);
                        this.state = 211;
                        this._errHandler.sync(this);
                        switch(this._input.LA(1)){
                            case $69b00e3e489fb6d8$export$9c4772e191bdb810.STRING:
                            case $69b00e3e489fb6d8$export$9c4772e191bdb810.QUOTE_STRING:
                            case $69b00e3e489fb6d8$export$9c4772e191bdb810.SQUOTE_STRING:
                                this.state = 209;
                                this.jqlString();
                                break;
                            case $69b00e3e489fb6d8$export$9c4772e191bdb810.CUSTOMFIELD:
                                this.state = 210;
                                this.jqlCustomField();
                                break;
                            default:
                                throw new (0, $hKCjP.NoViableAltException)(this);
                        }
                        this.state = 216;
                        this._errHandler.sync(this);
                        _la = this._input.LA(1);
                        while(_la === $69b00e3e489fb6d8$export$9c4772e191bdb810.LBRACKET){
                            this.state = 213;
                            this.jqlFieldProperty();
                            this.state = 218;
                            this._errHandler.sync(this);
                            _la = this._input.LA(1);
                        }
                        break;
                    default:
                        throw new (0, $hKCjP.NoViableAltException)(this);
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlFieldProperty() {
            let _localctx = new $69b00e3e489fb6d8$export$b02d0b6637ce0593(this._ctx, this.state);
            this.enterRule(_localctx, 34, $69b00e3e489fb6d8$export$9c4772e191bdb810.RULE_jqlFieldProperty);
            let _la;
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 221;
                this.match($69b00e3e489fb6d8$export$9c4772e191bdb810.LBRACKET);
                this.state = 222;
                this.jqlArgument();
                this.state = 223;
                this.match($69b00e3e489fb6d8$export$9c4772e191bdb810.RBRACKET);
                this.state = 228;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                while((_la - 33 & -32) === 0 && (1 << _la - 33 & (1 << $69b00e3e489fb6d8$export$9c4772e191bdb810.POSNUMBER - 33 | 1 << $69b00e3e489fb6d8$export$9c4772e191bdb810.NEGNUMBER - 33 | 1 << $69b00e3e489fb6d8$export$9c4772e191bdb810.STRING - 33 | 1 << $69b00e3e489fb6d8$export$9c4772e191bdb810.QUOTE_STRING - 33 | 1 << $69b00e3e489fb6d8$export$9c4772e191bdb810.SQUOTE_STRING - 33)) !== 0){
                    this.state = 225;
                    this.jqlPropertyArgument();
                    this.state = 230;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlCustomField() {
            let _localctx = new $69b00e3e489fb6d8$export$401a038855cc5b15(this._ctx, this.state);
            this.enterRule(_localctx, 36, $69b00e3e489fb6d8$export$9c4772e191bdb810.RULE_jqlCustomField);
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 231;
                this.match($69b00e3e489fb6d8$export$9c4772e191bdb810.CUSTOMFIELD);
                this.state = 232;
                this.match($69b00e3e489fb6d8$export$9c4772e191bdb810.LBRACKET);
                this.state = 233;
                this.match($69b00e3e489fb6d8$export$9c4772e191bdb810.POSNUMBER);
                this.state = 234;
                this.match($69b00e3e489fb6d8$export$9c4772e191bdb810.RBRACKET);
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlString() {
            let _localctx = new $69b00e3e489fb6d8$export$bde73d8ad7c8b71e(this._ctx, this.state);
            this.enterRule(_localctx, 38, $69b00e3e489fb6d8$export$9c4772e191bdb810.RULE_jqlString);
            let _la;
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 236;
                _la = this._input.LA(1);
                if (!((_la - 37 & -32) === 0 && (1 << _la - 37 & (1 << $69b00e3e489fb6d8$export$9c4772e191bdb810.STRING - 37 | 1 << $69b00e3e489fb6d8$export$9c4772e191bdb810.QUOTE_STRING - 37 | 1 << $69b00e3e489fb6d8$export$9c4772e191bdb810.SQUOTE_STRING - 37)) !== 0)) this._errHandler.recoverInline(this);
                else {
                    if (this._input.LA(1) === (0, $2DVsz.Token).EOF) this.matchedEOF = true;
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlNumber() {
            let _localctx = new $69b00e3e489fb6d8$export$8737d94a1880e8b3(this._ctx, this.state);
            this.enterRule(_localctx, 40, $69b00e3e489fb6d8$export$9c4772e191bdb810.RULE_jqlNumber);
            let _la;
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 238;
                _localctx._jqlNum = this._input.LT(1);
                _la = this._input.LA(1);
                if (!(_la === $69b00e3e489fb6d8$export$9c4772e191bdb810.POSNUMBER || _la === $69b00e3e489fb6d8$export$9c4772e191bdb810.NEGNUMBER)) _localctx._jqlNum = this._errHandler.recoverInline(this);
                else {
                    if (this._input.LA(1) === (0, $2DVsz.Token).EOF) this.matchedEOF = true;
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlOperand() {
            let _localctx = new $69b00e3e489fb6d8$export$2eaac5a9828bf647(this._ctx, this.state);
            this.enterRule(_localctx, 42, $69b00e3e489fb6d8$export$9c4772e191bdb810.RULE_jqlOperand);
            try {
                this.state = 244;
                this._errHandler.sync(this);
                switch(this.interpreter.adaptivePredict(this._input, 23, this._ctx)){
                    case 1:
                        this.enterOuterAlt(_localctx, 1);
                        this.state = 240;
                        this.jqlEmpty();
                        break;
                    case 2:
                        this.enterOuterAlt(_localctx, 2);
                        this.state = 241;
                        this.jqlValue();
                        break;
                    case 3:
                        this.enterOuterAlt(_localctx, 3);
                        this.state = 242;
                        this.jqlFunction();
                        break;
                    case 4:
                        this.enterOuterAlt(_localctx, 4);
                        this.state = 243;
                        this.jqlList();
                        break;
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlEmpty() {
            let _localctx = new $69b00e3e489fb6d8$export$d85a062f90025e5c(this._ctx, this.state);
            this.enterRule(_localctx, 44, $69b00e3e489fb6d8$export$9c4772e191bdb810.RULE_jqlEmpty);
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 246;
                this.match($69b00e3e489fb6d8$export$9c4772e191bdb810.EMPTY);
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlValue() {
            let _localctx = new $69b00e3e489fb6d8$export$2e17d457b0933bec(this._ctx, this.state);
            this.enterRule(_localctx, 46, $69b00e3e489fb6d8$export$9c4772e191bdb810.RULE_jqlValue);
            try {
                this.state = 250;
                this._errHandler.sync(this);
                switch(this._input.LA(1)){
                    case $69b00e3e489fb6d8$export$9c4772e191bdb810.STRING:
                    case $69b00e3e489fb6d8$export$9c4772e191bdb810.QUOTE_STRING:
                    case $69b00e3e489fb6d8$export$9c4772e191bdb810.SQUOTE_STRING:
                        this.enterOuterAlt(_localctx, 1);
                        this.state = 248;
                        this.jqlString();
                        break;
                    case $69b00e3e489fb6d8$export$9c4772e191bdb810.POSNUMBER:
                    case $69b00e3e489fb6d8$export$9c4772e191bdb810.NEGNUMBER:
                        this.enterOuterAlt(_localctx, 2);
                        this.state = 249;
                        this.jqlNumber();
                        break;
                    default:
                        throw new (0, $hKCjP.NoViableAltException)(this);
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlFunction() {
            let _localctx = new $69b00e3e489fb6d8$export$ebf0cc785e9ee41a(this._ctx, this.state);
            this.enterRule(_localctx, 48, $69b00e3e489fb6d8$export$9c4772e191bdb810.RULE_jqlFunction);
            let _la;
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 252;
                this.jqlFunctionName();
                this.state = 253;
                this.match($69b00e3e489fb6d8$export$9c4772e191bdb810.LPAREN);
                this.state = 255;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if ((_la - 33 & -32) === 0 && (1 << _la - 33 & (1 << $69b00e3e489fb6d8$export$9c4772e191bdb810.POSNUMBER - 33 | 1 << $69b00e3e489fb6d8$export$9c4772e191bdb810.NEGNUMBER - 33 | 1 << $69b00e3e489fb6d8$export$9c4772e191bdb810.STRING - 33 | 1 << $69b00e3e489fb6d8$export$9c4772e191bdb810.QUOTE_STRING - 33 | 1 << $69b00e3e489fb6d8$export$9c4772e191bdb810.SQUOTE_STRING - 33)) !== 0) {
                    this.state = 254;
                    this.jqlArgumentList();
                }
                this.state = 257;
                this.match($69b00e3e489fb6d8$export$9c4772e191bdb810.RPAREN);
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlFunctionName() {
            let _localctx = new $69b00e3e489fb6d8$export$1f5f7ac816788f44(this._ctx, this.state);
            this.enterRule(_localctx, 50, $69b00e3e489fb6d8$export$9c4772e191bdb810.RULE_jqlFunctionName);
            try {
                this.state = 261;
                this._errHandler.sync(this);
                switch(this._input.LA(1)){
                    case $69b00e3e489fb6d8$export$9c4772e191bdb810.STRING:
                    case $69b00e3e489fb6d8$export$9c4772e191bdb810.QUOTE_STRING:
                    case $69b00e3e489fb6d8$export$9c4772e191bdb810.SQUOTE_STRING:
                        this.enterOuterAlt(_localctx, 1);
                        this.state = 259;
                        this.jqlString();
                        break;
                    case $69b00e3e489fb6d8$export$9c4772e191bdb810.POSNUMBER:
                    case $69b00e3e489fb6d8$export$9c4772e191bdb810.NEGNUMBER:
                        this.enterOuterAlt(_localctx, 2);
                        this.state = 260;
                        this.jqlNumber();
                        break;
                    default:
                        throw new (0, $hKCjP.NoViableAltException)(this);
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlArgumentList() {
            let _localctx = new $69b00e3e489fb6d8$export$83d7c13849b931c3(this._ctx, this.state);
            this.enterRule(_localctx, 52, $69b00e3e489fb6d8$export$9c4772e191bdb810.RULE_jqlArgumentList);
            let _la;
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 263;
                this.jqlArgument();
                this.state = 268;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                while(_la === $69b00e3e489fb6d8$export$9c4772e191bdb810.COMMA){
                    this.state = 264;
                    this.match($69b00e3e489fb6d8$export$9c4772e191bdb810.COMMA);
                    this.state = 265;
                    this.jqlArgument();
                    this.state = 270;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlList() {
            let _localctx = new $69b00e3e489fb6d8$export$9cb97a63f2be4864(this._ctx, this.state);
            this.enterRule(_localctx, 54, $69b00e3e489fb6d8$export$9c4772e191bdb810.RULE_jqlList);
            let _la;
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 271;
                this.jqlListStart();
                this.state = 272;
                this.jqlOperand();
                this.state = 277;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                while(_la === $69b00e3e489fb6d8$export$9c4772e191bdb810.COMMA){
                    this.state = 273;
                    this.match($69b00e3e489fb6d8$export$9c4772e191bdb810.COMMA);
                    this.state = 274;
                    this.jqlOperand();
                    this.state = 279;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                }
                this.state = 280;
                this.jqlListEnd();
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlListStart() {
            let _localctx = new $69b00e3e489fb6d8$export$c419f717bfc46a5d(this._ctx, this.state);
            this.enterRule(_localctx, 56, $69b00e3e489fb6d8$export$9c4772e191bdb810.RULE_jqlListStart);
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 282;
                this.match($69b00e3e489fb6d8$export$9c4772e191bdb810.LPAREN);
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlListEnd() {
            let _localctx = new $69b00e3e489fb6d8$export$f6cd3e372f5ab120(this._ctx, this.state);
            this.enterRule(_localctx, 58, $69b00e3e489fb6d8$export$9c4772e191bdb810.RULE_jqlListEnd);
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 284;
                this.match($69b00e3e489fb6d8$export$9c4772e191bdb810.RPAREN);
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlPropertyArgument() {
            let _localctx = new $69b00e3e489fb6d8$export$e20ce4a2ed16372c(this._ctx, this.state);
            this.enterRule(_localctx, 60, $69b00e3e489fb6d8$export$9c4772e191bdb810.RULE_jqlPropertyArgument);
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 286;
                this.jqlArgument();
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlArgument() {
            let _localctx = new $69b00e3e489fb6d8$export$a95583953c237f88(this._ctx, this.state);
            this.enterRule(_localctx, 62, $69b00e3e489fb6d8$export$9c4772e191bdb810.RULE_jqlArgument);
            try {
                this.state = 290;
                this._errHandler.sync(this);
                switch(this._input.LA(1)){
                    case $69b00e3e489fb6d8$export$9c4772e191bdb810.STRING:
                    case $69b00e3e489fb6d8$export$9c4772e191bdb810.QUOTE_STRING:
                    case $69b00e3e489fb6d8$export$9c4772e191bdb810.SQUOTE_STRING:
                        this.enterOuterAlt(_localctx, 1);
                        this.state = 288;
                        this.jqlString();
                        break;
                    case $69b00e3e489fb6d8$export$9c4772e191bdb810.POSNUMBER:
                    case $69b00e3e489fb6d8$export$9c4772e191bdb810.NEGNUMBER:
                        this.enterOuterAlt(_localctx, 2);
                        this.state = 289;
                        this.jqlNumber();
                        break;
                    default:
                        throw new (0, $hKCjP.NoViableAltException)(this);
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlWasPredicate() {
            let _localctx = new $69b00e3e489fb6d8$export$9fa1e4d63f31b911(this._ctx, this.state);
            this.enterRule(_localctx, 64, $69b00e3e489fb6d8$export$9c4772e191bdb810.RULE_jqlWasPredicate);
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 295;
                this._errHandler.sync(this);
                switch(this._input.LA(1)){
                    case $69b00e3e489fb6d8$export$9c4772e191bdb810.BEFORE:
                    case $69b00e3e489fb6d8$export$9c4772e191bdb810.AFTER:
                    case $69b00e3e489fb6d8$export$9c4772e191bdb810.ON:
                        this.state = 292;
                        this.jqlDatePredicateOperator();
                        break;
                    case $69b00e3e489fb6d8$export$9c4772e191bdb810.DURING:
                        this.state = 293;
                        this.jqlDateRangePredicateOperator();
                        break;
                    case $69b00e3e489fb6d8$export$9c4772e191bdb810.BY:
                        this.state = 294;
                        this.jqlUserPredicateOperator();
                        break;
                    default:
                        throw new (0, $hKCjP.NoViableAltException)(this);
                }
                this.state = 297;
                this.jqlPredicateOperand();
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlChangedPredicate() {
            let _localctx = new $69b00e3e489fb6d8$export$e77e479a48133015(this._ctx, this.state);
            this.enterRule(_localctx, 66, $69b00e3e489fb6d8$export$9c4772e191bdb810.RULE_jqlChangedPredicate);
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 303;
                this._errHandler.sync(this);
                switch(this._input.LA(1)){
                    case $69b00e3e489fb6d8$export$9c4772e191bdb810.BEFORE:
                    case $69b00e3e489fb6d8$export$9c4772e191bdb810.AFTER:
                    case $69b00e3e489fb6d8$export$9c4772e191bdb810.ON:
                        this.state = 299;
                        this.jqlDatePredicateOperator();
                        break;
                    case $69b00e3e489fb6d8$export$9c4772e191bdb810.DURING:
                        this.state = 300;
                        this.jqlDateRangePredicateOperator();
                        break;
                    case $69b00e3e489fb6d8$export$9c4772e191bdb810.BY:
                        this.state = 301;
                        this.jqlUserPredicateOperator();
                        break;
                    case $69b00e3e489fb6d8$export$9c4772e191bdb810.FROM:
                    case $69b00e3e489fb6d8$export$9c4772e191bdb810.TO:
                        this.state = 302;
                        this.jqlValuePredicateOperator();
                        break;
                    default:
                        throw new (0, $hKCjP.NoViableAltException)(this);
                }
                this.state = 305;
                this.jqlPredicateOperand();
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlDatePredicateOperator() {
            let _localctx = new $69b00e3e489fb6d8$export$dc01290aee731418(this._ctx, this.state);
            this.enterRule(_localctx, 68, $69b00e3e489fb6d8$export$9c4772e191bdb810.RULE_jqlDatePredicateOperator);
            let _la;
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 307;
                _la = this._input.LA(1);
                if (!((_la & -32) === 0 && (1 << _la & (1 << $69b00e3e489fb6d8$export$9c4772e191bdb810.BEFORE | 1 << $69b00e3e489fb6d8$export$9c4772e191bdb810.AFTER | 1 << $69b00e3e489fb6d8$export$9c4772e191bdb810.ON)) !== 0)) this._errHandler.recoverInline(this);
                else {
                    if (this._input.LA(1) === (0, $2DVsz.Token).EOF) this.matchedEOF = true;
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlDateRangePredicateOperator() {
            let _localctx = new $69b00e3e489fb6d8$export$75412b8b6a6442e1(this._ctx, this.state);
            this.enterRule(_localctx, 70, $69b00e3e489fb6d8$export$9c4772e191bdb810.RULE_jqlDateRangePredicateOperator);
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 309;
                this.match($69b00e3e489fb6d8$export$9c4772e191bdb810.DURING);
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlUserPredicateOperator() {
            let _localctx = new $69b00e3e489fb6d8$export$ad402332075c8656(this._ctx, this.state);
            this.enterRule(_localctx, 72, $69b00e3e489fb6d8$export$9c4772e191bdb810.RULE_jqlUserPredicateOperator);
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 311;
                this.match($69b00e3e489fb6d8$export$9c4772e191bdb810.BY);
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlValuePredicateOperator() {
            let _localctx = new $69b00e3e489fb6d8$export$4239d7c0fbafd3f1(this._ctx, this.state);
            this.enterRule(_localctx, 74, $69b00e3e489fb6d8$export$9c4772e191bdb810.RULE_jqlValuePredicateOperator);
            let _la;
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 313;
                _la = this._input.LA(1);
                if (!(_la === $69b00e3e489fb6d8$export$9c4772e191bdb810.FROM || _la === $69b00e3e489fb6d8$export$9c4772e191bdb810.TO)) this._errHandler.recoverInline(this);
                else {
                    if (this._input.LA(1) === (0, $2DVsz.Token).EOF) this.matchedEOF = true;
                    this._errHandler.reportMatch(this);
                    this.consume();
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlPredicateOperand() {
            let _localctx = new $69b00e3e489fb6d8$export$6b796c5a4b8c18e(this._ctx, this.state);
            this.enterRule(_localctx, 76, $69b00e3e489fb6d8$export$9c4772e191bdb810.RULE_jqlPredicateOperand);
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 315;
                this.jqlOperand();
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlOrderBy() {
            let _localctx = new $69b00e3e489fb6d8$export$534469b9c8f44139(this._ctx, this.state);
            this.enterRule(_localctx, 78, $69b00e3e489fb6d8$export$9c4772e191bdb810.RULE_jqlOrderBy);
            let _la;
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 317;
                this.match($69b00e3e489fb6d8$export$9c4772e191bdb810.ORDER);
                this.state = 318;
                this.match($69b00e3e489fb6d8$export$9c4772e191bdb810.BY);
                this.state = 319;
                this.jqlSearchSort();
                this.state = 324;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                while(_la === $69b00e3e489fb6d8$export$9c4772e191bdb810.COMMA){
                    this.state = 320;
                    this.match($69b00e3e489fb6d8$export$9c4772e191bdb810.COMMA);
                    this.state = 321;
                    this.jqlSearchSort();
                    this.state = 326;
                    this._errHandler.sync(this);
                    _la = this._input.LA(1);
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        jqlSearchSort() {
            let _localctx = new $69b00e3e489fb6d8$export$c7d8f03f36952a46(this._ctx, this.state);
            this.enterRule(_localctx, 80, $69b00e3e489fb6d8$export$9c4772e191bdb810.RULE_jqlSearchSort);
            let _la;
            try {
                this.enterOuterAlt(_localctx, 1);
                this.state = 327;
                this.jqlField();
                this.state = 329;
                this._errHandler.sync(this);
                _la = this._input.LA(1);
                if (_la === $69b00e3e489fb6d8$export$9c4772e191bdb810.ASC || _la === $69b00e3e489fb6d8$export$9c4772e191bdb810.DESC) {
                    this.state = 328;
                    _la = this._input.LA(1);
                    if (!(_la === $69b00e3e489fb6d8$export$9c4772e191bdb810.ASC || _la === $69b00e3e489fb6d8$export$9c4772e191bdb810.DESC)) this._errHandler.recoverInline(this);
                    else {
                        if (this._input.LA(1) === (0, $2DVsz.Token).EOF) this.matchedEOF = true;
                        this._errHandler.reportMatch(this);
                        this.consume();
                    }
                }
            } catch (re) {
                if (re instanceof (0, $fLdDn.RecognitionException)) {
                    _localctx.exception = re;
                    this._errHandler.reportError(this, re);
                    this._errHandler.recover(this, re);
                } else throw re;
            } finally{
                this.exitRule();
            }
            return _localctx;
        }
        static{
            this._serializedATN = '\x03\uC91D\uCABA\u058D\uAFBA\u4F53\u0607\uEA8B\uC241\x030\u014E\x04\x02	\x02\x04\x03	\x03\x04\x04	\x04\x04\x05	\x05\x04\x06	\x06\x04\x07	\x07\x04\b	\b\x04			\x04\n	\n\x04\v	\v\x04\f	\f\x04\r	\r\x04\x0e	\x0e\x04\x0f	\x0f\x04\x10	\x10\x04\x11	\x11\x04\x12	\x12\x04\x13	\x13\x04\x14	\x14\x04\x15	\x15\x04\x16	\x16\x04\x17	\x17\x04\x18	\x18\x04\x19	\x19\x04\x1a	\x1a\x04\x1b	\x1b\x04\x1c	\x1c\x04\x1d	\x1d\x04\x1e	\x1e\x04\x1f	\x1f\x04 	 \x04!	!\x04"	"\x04#	#\x04$	$\x04%	%\x04&	&\x04\'	\'\x04(	(\x04)	)\x04*	*\x03\x02\x05\x02V\n\x02\x03\x02\x05\x02Y\n\x02\x03\x02\x03\x02\x03\x03\x03\x03\x03\x04\x03\x04\x03\x04\x07\x04b\n\x04\f\x04\x0e\x04e\v\x04\x03\x05\x03\x05\x03\x05\x07\x05j\n\x05\f\x05\x0e\x05m\v\x05\x03\x06\x03\x06\x03\x06\x03\x06\x05\x06s\n\x06\x03\x07\x03\x07\x03\x07\x03\x07\x03\b\x03\b\x03\b\x03	\x03	\x03	\x03	\x05	\x80\n	\x03	\x03	\x03	\x03	\x05	\x86\n	\x03	\x03	\x03	\x05	\x8b\n	\x03	\x03	\x03	\x05	\x90\n	\x03	\x03	\x03	\x03	\x03	\x03	\x03	\x05	\x99\n	\x03	\x07	\x9c\n	\f	\x0e	\x9f\v	\x03	\x03	\x03	\x05	\xa4\n	\x03	\x07	\xa7\n	\f	\x0e	\xaa\v	\x03	\x03	\x07	\xae\n	\f	\x0e	\xb1\v	\x05	\xb3\n	\x03\n\x03\n\x03\v\x03\v\x03\f\x03\f\x03\r\x03\r\x03\r\x05\r\xbe\n\r\x03\x0e\x03\x0e\x03\x0e\x05\x0e\xc3\n\x0e\x03\x0f\x03\x0f\x03\x0f\x05\x0f\xc8\n\x0f\x03\x10\x03\x10\x03\x10\x03\x10\x03\x10\x05\x10\xcf\n\x10\x03\x11\x03\x11\x03\x12\x03\x12\x03\x12\x05\x12\xd6\n\x12\x03\x12\x07\x12\xd9\n\x12\f\x12\x0e\x12\xdc\v\x12\x05\x12\xde\n\x12\x03\x13\x03\x13\x03\x13\x03\x13\x03\x13\x07\x13\xe5\n\x13\f\x13\x0e\x13\xe8\v\x13\x03\x14\x03\x14\x03\x14\x03\x14\x03\x14\x03\x15\x03\x15\x03\x16\x03\x16\x03\x17\x03\x17\x03\x17\x03\x17\x05\x17\xf7\n\x17\x03\x18\x03\x18\x03\x19\x03\x19\x05\x19\xfd\n\x19\x03\x1a\x03\x1a\x03\x1a\x05\x1a\u0102\n\x1a\x03\x1a\x03\x1a\x03\x1b\x03\x1b\x05\x1b\u0108\n\x1b\x03\x1c\x03\x1c\x03\x1c\x07\x1c\u010D\n\x1c\f\x1c\x0e\x1c\u0110\v\x1c\x03\x1d\x03\x1d\x03\x1d\x03\x1d\x07\x1d\u0116\n\x1d\f\x1d\x0e\x1d\u0119\v\x1d\x03\x1d\x03\x1d\x03\x1e\x03\x1e\x03\x1f\x03\x1f\x03 \x03 \x03!\x03!\x05!\u0125\n!\x03"\x03"\x03"\x05"\u012A\n"\x03"\x03"\x03#\x03#\x03#\x03#\x05#\u0132\n#\x03#\x03#\x03$\x03$\x03%\x03%\x03&\x03&\x03\'\x03\'\x03(\x03(\x03)\x03)\x03)\x03)\x03)\x07)\u0145\n)\f)\x0e)\u0148\v)\x03*\x03*\x05*\u014C\n*\x03*\x02\x02\x02+\x02\x02\x04\x02\x06\x02\b\x02\n\x02\f\x02\x0e\x02\x10\x02\x12\x02\x14\x02\x16\x02\x18\x02\x1a\x02\x1c\x02\x1e\x02 \x02"\x02$\x02&\x02(\x02*\x02,\x02.\x020\x022\x024\x026\x028\x02:\x02<\x02>\x02@\x02B\x02D\x02F\x02H\x02J\x02L\x02N\x02P\x02R\x02\x02\v\x04\x02\b\b\x15\x15\x03\x02\r\x0e\x03\x02\x0f\x10\x03\x02	\f\x05\x02\'\'++..\x03\x02#$\x04\x02\x19\x1a\x1d\x1d\x03\x02\x1b\x1c\x03\x02!"\x02\u0155\x02U\x03\x02\x02\x02\x04\\\x03\x02\x02\x02\x06^\x03\x02\x02\x02\bf\x03\x02\x02\x02\nr\x03\x02\x02\x02\ft\x03\x02\x02\x02\x0ex\x03\x02\x02\x02\x10\xb2\x03\x02\x02\x02\x12\xb4\x03\x02\x02\x02\x14\xb6\x03\x02\x02\x02\x16\xb8\x03\x02\x02\x02\x18\xbd\x03\x02\x02\x02\x1a\xc2\x03\x02\x02\x02\x1c\xc7\x03\x02\x02\x02\x1e\xce\x03\x02\x02\x02 \xd0\x03\x02\x02\x02"\xdd\x03\x02\x02\x02$\xdf\x03\x02\x02\x02&\xe9\x03\x02\x02\x02(\xee\x03\x02\x02\x02*\xf0\x03\x02\x02\x02,\xf6\x03\x02\x02\x02.\xf8\x03\x02\x02\x020\xfc\x03\x02\x02\x022\xfe\x03\x02\x02\x024\u0107\x03\x02\x02\x026\u0109\x03\x02\x02\x028\u0111\x03\x02\x02\x02:\u011C\x03\x02\x02\x02<\u011E\x03\x02\x02\x02>\u0120\x03\x02\x02\x02@\u0124\x03\x02\x02\x02B\u0129\x03\x02\x02\x02D\u0131\x03\x02\x02\x02F\u0135\x03\x02\x02\x02H\u0137\x03\x02\x02\x02J\u0139\x03\x02\x02\x02L\u013B\x03\x02\x02\x02N\u013D\x03\x02\x02\x02P\u013F\x03\x02\x02\x02R\u0149\x03\x02\x02\x02TV\x05\x04\x03\x02UT\x03\x02\x02\x02UV\x03\x02\x02\x02VX\x03\x02\x02\x02WY\x05P)\x02XW\x03\x02\x02\x02XY\x03\x02\x02\x02YZ\x03\x02\x02\x02Z[\x07\x02\x02\x03[\x03\x03\x02\x02\x02\\]\x05\x06\x04\x02]\x05\x03\x02\x02\x02^c\x05\b\x05\x02_`\x07\x14\x02\x02`b\x05\b\x05\x02a_\x03\x02\x02\x02be\x03\x02\x02\x02ca\x03\x02\x02\x02cd\x03\x02\x02\x02d\x07\x03\x02\x02\x02ec\x03\x02\x02\x02fk\x05\n\x06\x02gh\x07\x13\x02\x02hj\x05\n\x06\x02ig\x03\x02\x02\x02jm\x03\x02\x02\x02ki\x03\x02\x02\x02kl\x03\x02\x02\x02l	\x03\x02\x02\x02mk\x03\x02\x02\x02no	\x02\x02\x02os\x05\n\x06\x02ps\x05\f\x07\x02qs\x05\x0e\b\x02rn\x03\x02\x02\x02rp\x03\x02\x02\x02rq\x03\x02\x02\x02s\v\x03\x02\x02\x02tu\x07\x03\x02\x02uv\x05\x06\x04\x02vw\x07\x04\x02\x02w\r\x03\x02\x02\x02xy\x05"\x12\x02yz\x05\x10	\x02z\x0f\x03\x02\x02\x02{\x7f\x05\x12\n\x02|\x80\x05.\x18\x02}\x80\x050\x19\x02~\x80\x052\x1a\x02\x7f|\x03\x02\x02\x02\x7f}\x03\x02\x02\x02\x7f~\x03\x02\x02\x02\x80\xb3\x03\x02\x02\x02\x81\x85\x05\x14\v\x02\x82\x86\x05.\x18\x02\x83\x86\x050\x19\x02\x84\x86\x052\x1a\x02\x85\x82\x03\x02\x02\x02\x85\x83\x03\x02\x02\x02\x85\x84\x03\x02\x02\x02\x86\xb3\x03\x02\x02\x02\x87\x8a\x05\x16\f\x02\x88\x8b\x050\x19\x02\x89\x8b\x052\x1a\x02\x8a\x88\x03\x02\x02\x02\x8a\x89\x03\x02\x02\x02\x8b\xb3\x03\x02\x02\x02\x8c\x8f\x05\x18\r\x02\x8d\x90\x058\x1d\x02\x8e\x90\x052\x1a\x02\x8f\x8d\x03\x02\x02\x02\x8f\x8e\x03\x02\x02\x02\x90\xb3\x03\x02\x02\x02\x91\x92\x05\x1a\x0e\x02\x92\x93\x05.\x18\x02\x93\xb3\x03\x02\x02\x02\x94\x98\x05\x1c\x0f\x02\x95\x99\x05.\x18\x02\x96\x99\x050\x19\x02\x97\x99\x052\x1a\x02\x98\x95\x03\x02\x02\x02\x98\x96\x03\x02\x02\x02\x98\x97\x03\x02\x02\x02\x99\x9d\x03\x02\x02\x02\x9a\x9c\x05B"\x02\x9b\x9a\x03\x02\x02\x02\x9c\x9f\x03\x02\x02\x02\x9d\x9b\x03\x02\x02\x02\x9d\x9e\x03\x02\x02\x02\x9e\xb3\x03\x02\x02\x02\x9f\x9d\x03\x02\x02\x02\xa0\xa3\x05\x1e\x10\x02\xa1\xa4\x058\x1d\x02\xa2\xa4\x052\x1a\x02\xa3\xa1\x03\x02\x02\x02\xa3\xa2\x03\x02\x02\x02\xa4\xa8\x03\x02\x02\x02\xa5\xa7\x05B"\x02\xa6\xa5\x03\x02\x02\x02\xa7\xaa\x03\x02\x02\x02\xa8\xa6\x03\x02\x02\x02\xa8\xa9\x03\x02\x02\x02\xa9\xb3\x03\x02\x02\x02\xaa\xa8\x03\x02\x02\x02\xab\xaf\x05 \x11\x02\xac\xae\x05D#\x02\xad\xac\x03\x02\x02\x02\xae\xb1\x03\x02\x02\x02\xaf\xad\x03\x02\x02\x02\xaf\xb0\x03\x02\x02\x02\xb0\xb3\x03\x02\x02\x02\xb1\xaf\x03\x02\x02\x02\xb2{\x03\x02\x02\x02\xb2\x81\x03\x02\x02\x02\xb2\x87\x03\x02\x02\x02\xb2\x8c\x03\x02\x02\x02\xb2\x91\x03\x02\x02\x02\xb2\x94\x03\x02\x02\x02\xb2\xa0\x03\x02\x02\x02\xb2\xab\x03\x02\x02\x02\xb3\x11\x03\x02\x02\x02\xb4\xb5	\x03\x02\x02\xb5\x13\x03\x02\x02\x02\xb6\xb7	\x04\x02\x02\xb7\x15\x03\x02\x02\x02\xb8\xb9	\x05\x02\x02\xb9\x17\x03\x02\x02\x02\xba\xbe\x07\x11\x02\x02\xbb\xbc\x07\x15\x02\x02\xbc\xbe\x07\x11\x02\x02\xbd\xba\x03\x02\x02\x02\xbd\xbb\x03\x02\x02\x02\xbe\x19\x03\x02\x02\x02\xbf\xc3\x07\x12\x02\x02\xc0\xc1\x07\x12\x02\x02\xc1\xc3\x07\x15\x02\x02\xc2\xbf\x03\x02\x02\x02\xc2\xc0\x03\x02\x02\x02\xc3\x1b\x03\x02\x02\x02\xc4\xc8\x07\x17\x02\x02\xc5\xc6\x07\x17\x02\x02\xc6\xc8\x07\x15\x02\x02\xc7\xc4\x03\x02\x02\x02\xc7\xc5\x03\x02\x02\x02\xc8\x1d\x03\x02\x02\x02\xc9\xca\x07\x17\x02\x02\xca\xcf\x07\x11\x02\x02\xcb\xcc\x07\x17\x02\x02\xcc\xcd\x07\x15\x02\x02\xcd\xcf\x07\x11\x02\x02\xce\xc9\x03\x02\x02\x02\xce\xcb\x03\x02\x02\x02\xcf\x1f\x03\x02\x02\x02\xd0\xd1\x07\x18\x02\x02\xd1!\x03\x02\x02\x02\xd2\xde\x05*\x16\x02\xd3\xd6\x05(\x15\x02\xd4\xd6\x05&\x14\x02\xd5\xd3\x03\x02\x02\x02\xd5\xd4\x03\x02\x02\x02\xd6\xda\x03\x02\x02\x02\xd7\xd9\x05$\x13\x02\xd8\xd7\x03\x02\x02\x02\xd9\xdc\x03\x02\x02\x02\xda\xd8\x03\x02\x02\x02\xda\xdb\x03\x02\x02\x02\xdb\xde\x03\x02\x02\x02\xdc\xda\x03\x02\x02\x02\xdd\xd2\x03\x02\x02\x02\xdd\xd5\x03\x02\x02\x02\xde#\x03\x02\x02\x02\xdf\xe0\x07\x06\x02\x02\xe0\xe1\x05@!\x02\xe1\xe2\x07\x07\x02\x02\xe2\xe6\x03\x02\x02\x02\xe3\xe5\x05> \x02\xe4\xe3\x03\x02\x02\x02\xe5\xe8\x03\x02\x02\x02\xe6\xe4\x03\x02\x02\x02\xe6\xe7\x03\x02\x02\x02\xe7%\x03\x02\x02\x02\xe8\xe6\x03\x02\x02\x02\xe9\xea\x07%\x02\x02\xea\xeb\x07\x06\x02\x02\xeb\xec\x07#\x02\x02\xec\xed\x07\x07\x02\x02\xed\'\x03\x02\x02\x02\xee\xef	\x06\x02\x02\xef)\x03\x02\x02\x02\xf0\xf1	\x07\x02\x02\xf1+\x03\x02\x02\x02\xf2\xf7\x05.\x18\x02\xf3\xf7\x050\x19\x02\xf4\xf7\x052\x1a\x02\xf5\xf7\x058\x1d\x02\xf6\xf2\x03\x02\x02\x02\xf6\xf3\x03\x02\x02\x02\xf6\xf4\x03\x02\x02\x02\xf6\xf5\x03\x02\x02\x02\xf7-\x03\x02\x02\x02\xf8\xf9\x07\x16\x02\x02\xf9/\x03\x02\x02\x02\xfa\xfd\x05(\x15\x02\xfb\xfd\x05*\x16\x02\xfc\xfa\x03\x02\x02\x02\xfc\xfb\x03\x02\x02\x02\xfd1\x03\x02\x02\x02\xfe\xff\x054\x1b\x02\xff\u0101\x07\x03\x02\x02\u0100\u0102\x056\x1c\x02\u0101\u0100\x03\x02\x02\x02\u0101\u0102\x03\x02\x02\x02\u0102\u0103\x03\x02\x02\x02\u0103\u0104\x07\x04\x02\x02\u01043\x03\x02\x02\x02\u0105\u0108\x05(\x15\x02\u0106\u0108\x05*\x16\x02\u0107\u0105\x03\x02\x02\x02\u0107\u0106\x03\x02\x02\x02\u01085\x03\x02\x02\x02\u0109\u010E\x05@!\x02\u010A\u010B\x07\x05\x02\x02\u010B\u010D\x05@!\x02\u010C\u010A\x03\x02\x02\x02\u010D\u0110\x03\x02\x02\x02\u010E\u010C\x03\x02\x02\x02\u010E\u010F\x03\x02\x02\x02\u010F7\x03\x02\x02\x02\u0110\u010E\x03\x02\x02\x02\u0111\u0112\x05:\x1e\x02\u0112\u0117\x05,\x17\x02\u0113\u0114\x07\x05\x02\x02\u0114\u0116\x05,\x17\x02\u0115\u0113\x03\x02\x02\x02\u0116\u0119\x03\x02\x02\x02\u0117\u0115\x03\x02\x02\x02\u0117\u0118\x03\x02\x02\x02\u0118\u011A\x03\x02\x02\x02\u0119\u0117\x03\x02\x02\x02\u011A\u011B\x05<\x1f\x02\u011B9\x03\x02\x02\x02\u011C\u011D\x07\x03\x02\x02\u011D;\x03\x02\x02\x02\u011E\u011F\x07\x04\x02\x02\u011F=\x03\x02\x02\x02\u0120\u0121\x05@!\x02\u0121?\x03\x02\x02\x02\u0122\u0125\x05(\x15\x02\u0123\u0125\x05*\x16\x02\u0124\u0122\x03\x02\x02\x02\u0124\u0123\x03\x02\x02\x02\u0125A\x03\x02\x02\x02\u0126\u012A\x05F$\x02\u0127\u012A\x05H%\x02\u0128\u012A\x05J&\x02\u0129\u0126\x03\x02\x02\x02\u0129\u0127\x03\x02\x02\x02\u0129\u0128\x03\x02\x02\x02\u012A\u012B\x03\x02\x02\x02\u012B\u012C\x05N(\x02\u012CC\x03\x02\x02\x02\u012D\u0132\x05F$\x02\u012E\u0132\x05H%\x02\u012F\u0132\x05J&\x02\u0130\u0132\x05L\'\x02\u0131\u012D\x03\x02\x02\x02\u0131\u012E\x03\x02\x02\x02\u0131\u012F\x03\x02\x02\x02\u0131\u0130\x03\x02\x02\x02\u0132\u0133\x03\x02\x02\x02\u0133\u0134\x05N(\x02\u0134E\x03\x02\x02\x02\u0135\u0136	\b\x02\x02\u0136G\x03\x02\x02\x02\u0137\u0138\x07\x1e\x02\x02\u0138I\x03\x02\x02\x02\u0139\u013A\x07 \x02\x02\u013AK\x03\x02\x02\x02\u013B\u013C		\x02\x02\u013CM\x03\x02\x02\x02\u013D\u013E\x05,\x17\x02\u013EO\x03\x02\x02\x02\u013F\u0140\x07\x1f\x02\x02\u0140\u0141\x07 \x02\x02\u0141\u0146\x05R*\x02\u0142\u0143\x07\x05\x02\x02\u0143\u0145\x05R*\x02\u0144\u0142\x03\x02\x02\x02\u0145\u0148\x03\x02\x02\x02\u0146\u0144\x03\x02\x02\x02\u0146\u0147\x03\x02\x02\x02\u0147Q\x03\x02\x02\x02\u0148\u0146\x03\x02\x02\x02\u0149\u014B\x05"\x12\x02\u014A\u014C	\n\x02\x02\u014B\u014A\x03\x02\x02\x02\u014B\u014C\x03\x02\x02\x02\u014CS\x03\x02\x02\x02$UXckr\x7f\x85\x8a\x8f\x98\x9d\xa3\xa8\xaf\xb2\xbd\xc2\xc7\xce\xd5\xda\xdd\xe6\xf6\xfc\u0101\u0107\u010E\u0117\u0124\u0129\u0131\u0146\u014B';
        }
        static get _ATN() {
            if (!$69b00e3e489fb6d8$export$9c4772e191bdb810.__ATN) $69b00e3e489fb6d8$export$9c4772e191bdb810.__ATN = new (0, $dvgsl.ATNDeserializer)().deserialize($2IEP9.toCharArray($69b00e3e489fb6d8$export$9c4772e191bdb810._serializedATN));
            return $69b00e3e489fb6d8$export$9c4772e191bdb810.__ATN;
        }
    }
    class $69b00e3e489fb6d8$export$ff413535b9575c8 extends (0, $6bmaO.ParserRuleContext) {
        EOF() {
            return this.getToken($69b00e3e489fb6d8$export$9c4772e191bdb810.EOF, 0);
        }
        jqlWhere() {
            return this.tryGetRuleContext(0, $69b00e3e489fb6d8$export$4148a879cab28017);
        }
        jqlOrderBy() {
            return this.tryGetRuleContext(0, $69b00e3e489fb6d8$export$534469b9c8f44139);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $69b00e3e489fb6d8$export$9c4772e191bdb810.RULE_jqlQuery;
        }
        enterRule(listener) {
            if (listener.enterJqlQuery) listener.enterJqlQuery(this);
        }
        exitRule(listener) {
            if (listener.exitJqlQuery) listener.exitJqlQuery(this);
        }
        accept(visitor) {
            if (visitor.visitJqlQuery) return visitor.visitJqlQuery(this);
            else return visitor.visitChildren(this);
        }
    }
    class $69b00e3e489fb6d8$export$4148a879cab28017 extends (0, $6bmaO.ParserRuleContext) {
        jqlOrClause() {
            return this.getRuleContext(0, $69b00e3e489fb6d8$export$d69831d387793480);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $69b00e3e489fb6d8$export$9c4772e191bdb810.RULE_jqlWhere;
        }
        enterRule(listener) {
            if (listener.enterJqlWhere) listener.enterJqlWhere(this);
        }
        exitRule(listener) {
            if (listener.exitJqlWhere) listener.exitJqlWhere(this);
        }
        accept(visitor) {
            if (visitor.visitJqlWhere) return visitor.visitJqlWhere(this);
            else return visitor.visitChildren(this);
        }
    }
    class $69b00e3e489fb6d8$export$d69831d387793480 extends (0, $6bmaO.ParserRuleContext) {
        jqlAndClause(i) {
            if (i === undefined) return this.getRuleContexts($69b00e3e489fb6d8$export$f16819001158b9e);
            else return this.getRuleContext(i, $69b00e3e489fb6d8$export$f16819001158b9e);
        }
        OR(i) {
            if (i === undefined) return this.getTokens($69b00e3e489fb6d8$export$9c4772e191bdb810.OR);
            else return this.getToken($69b00e3e489fb6d8$export$9c4772e191bdb810.OR, i);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $69b00e3e489fb6d8$export$9c4772e191bdb810.RULE_jqlOrClause;
        }
        enterRule(listener) {
            if (listener.enterJqlOrClause) listener.enterJqlOrClause(this);
        }
        exitRule(listener) {
            if (listener.exitJqlOrClause) listener.exitJqlOrClause(this);
        }
        accept(visitor) {
            if (visitor.visitJqlOrClause) return visitor.visitJqlOrClause(this);
            else return visitor.visitChildren(this);
        }
    }
    class $69b00e3e489fb6d8$export$f16819001158b9e extends (0, $6bmaO.ParserRuleContext) {
        jqlNotClause(i) {
            if (i === undefined) return this.getRuleContexts($69b00e3e489fb6d8$export$5e9146f8d5cf1330);
            else return this.getRuleContext(i, $69b00e3e489fb6d8$export$5e9146f8d5cf1330);
        }
        AND(i) {
            if (i === undefined) return this.getTokens($69b00e3e489fb6d8$export$9c4772e191bdb810.AND);
            else return this.getToken($69b00e3e489fb6d8$export$9c4772e191bdb810.AND, i);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $69b00e3e489fb6d8$export$9c4772e191bdb810.RULE_jqlAndClause;
        }
        enterRule(listener) {
            if (listener.enterJqlAndClause) listener.enterJqlAndClause(this);
        }
        exitRule(listener) {
            if (listener.exitJqlAndClause) listener.exitJqlAndClause(this);
        }
        accept(visitor) {
            if (visitor.visitJqlAndClause) return visitor.visitJqlAndClause(this);
            else return visitor.visitChildren(this);
        }
    }
    class $69b00e3e489fb6d8$export$5e9146f8d5cf1330 extends (0, $6bmaO.ParserRuleContext) {
        jqlNotClause() {
            return this.tryGetRuleContext(0, $69b00e3e489fb6d8$export$5e9146f8d5cf1330);
        }
        NOT() {
            return this.tryGetToken($69b00e3e489fb6d8$export$9c4772e191bdb810.NOT, 0);
        }
        BANG() {
            return this.tryGetToken($69b00e3e489fb6d8$export$9c4772e191bdb810.BANG, 0);
        }
        jqlSubClause() {
            return this.tryGetRuleContext(0, $69b00e3e489fb6d8$export$a136a0e9655bfb04);
        }
        jqlTerminalClause() {
            return this.tryGetRuleContext(0, $69b00e3e489fb6d8$export$23486a2f2ddd5bcd);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $69b00e3e489fb6d8$export$9c4772e191bdb810.RULE_jqlNotClause;
        }
        enterRule(listener) {
            if (listener.enterJqlNotClause) listener.enterJqlNotClause(this);
        }
        exitRule(listener) {
            if (listener.exitJqlNotClause) listener.exitJqlNotClause(this);
        }
        accept(visitor) {
            if (visitor.visitJqlNotClause) return visitor.visitJqlNotClause(this);
            else return visitor.visitChildren(this);
        }
    }
    class $69b00e3e489fb6d8$export$a136a0e9655bfb04 extends (0, $6bmaO.ParserRuleContext) {
        LPAREN() {
            return this.getToken($69b00e3e489fb6d8$export$9c4772e191bdb810.LPAREN, 0);
        }
        jqlOrClause() {
            return this.getRuleContext(0, $69b00e3e489fb6d8$export$d69831d387793480);
        }
        RPAREN() {
            return this.getToken($69b00e3e489fb6d8$export$9c4772e191bdb810.RPAREN, 0);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $69b00e3e489fb6d8$export$9c4772e191bdb810.RULE_jqlSubClause;
        }
        enterRule(listener) {
            if (listener.enterJqlSubClause) listener.enterJqlSubClause(this);
        }
        exitRule(listener) {
            if (listener.exitJqlSubClause) listener.exitJqlSubClause(this);
        }
        accept(visitor) {
            if (visitor.visitJqlSubClause) return visitor.visitJqlSubClause(this);
            else return visitor.visitChildren(this);
        }
    }
    class $69b00e3e489fb6d8$export$23486a2f2ddd5bcd extends (0, $6bmaO.ParserRuleContext) {
        jqlField() {
            return this.getRuleContext(0, $69b00e3e489fb6d8$export$b33300c3d916229a);
        }
        jqlTerminalClauseRhs() {
            return this.getRuleContext(0, $69b00e3e489fb6d8$export$93924a205c12d32c);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $69b00e3e489fb6d8$export$9c4772e191bdb810.RULE_jqlTerminalClause;
        }
        enterRule(listener) {
            if (listener.enterJqlTerminalClause) listener.enterJqlTerminalClause(this);
        }
        exitRule(listener) {
            if (listener.exitJqlTerminalClause) listener.exitJqlTerminalClause(this);
        }
        accept(visitor) {
            if (visitor.visitJqlTerminalClause) return visitor.visitJqlTerminalClause(this);
            else return visitor.visitChildren(this);
        }
    }
    class $69b00e3e489fb6d8$export$93924a205c12d32c extends (0, $6bmaO.ParserRuleContext) {
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $69b00e3e489fb6d8$export$9c4772e191bdb810.RULE_jqlTerminalClauseRhs;
        }
        copyFrom(ctx) {
            super.copyFrom(ctx);
        }
    }
    class $69b00e3e489fb6d8$export$c428f709a58396e5 extends $69b00e3e489fb6d8$export$93924a205c12d32c {
        jqlEqualsOperator() {
            return this.getRuleContext(0, $69b00e3e489fb6d8$export$41e475fc1988e413);
        }
        jqlEmpty() {
            return this.tryGetRuleContext(0, $69b00e3e489fb6d8$export$d85a062f90025e5c);
        }
        jqlValue() {
            return this.tryGetRuleContext(0, $69b00e3e489fb6d8$export$2e17d457b0933bec);
        }
        jqlFunction() {
            return this.tryGetRuleContext(0, $69b00e3e489fb6d8$export$ebf0cc785e9ee41a);
        }
        constructor(ctx){
            super(ctx.parent, ctx.invokingState);
            this.copyFrom(ctx);
        }
        enterRule(listener) {
            if (listener.enterJqlEqualsClause) listener.enterJqlEqualsClause(this);
        }
        exitRule(listener) {
            if (listener.exitJqlEqualsClause) listener.exitJqlEqualsClause(this);
        }
        accept(visitor) {
            if (visitor.visitJqlEqualsClause) return visitor.visitJqlEqualsClause(this);
            else return visitor.visitChildren(this);
        }
    }
    class $69b00e3e489fb6d8$export$1b131204ef9fa33d extends $69b00e3e489fb6d8$export$93924a205c12d32c {
        jqlLikeOperator() {
            return this.getRuleContext(0, $69b00e3e489fb6d8$export$b76fe5387fdd7efd);
        }
        jqlEmpty() {
            return this.tryGetRuleContext(0, $69b00e3e489fb6d8$export$d85a062f90025e5c);
        }
        jqlValue() {
            return this.tryGetRuleContext(0, $69b00e3e489fb6d8$export$2e17d457b0933bec);
        }
        jqlFunction() {
            return this.tryGetRuleContext(0, $69b00e3e489fb6d8$export$ebf0cc785e9ee41a);
        }
        constructor(ctx){
            super(ctx.parent, ctx.invokingState);
            this.copyFrom(ctx);
        }
        enterRule(listener) {
            if (listener.enterJqlLikeClause) listener.enterJqlLikeClause(this);
        }
        exitRule(listener) {
            if (listener.exitJqlLikeClause) listener.exitJqlLikeClause(this);
        }
        accept(visitor) {
            if (visitor.visitJqlLikeClause) return visitor.visitJqlLikeClause(this);
            else return visitor.visitChildren(this);
        }
    }
    class $69b00e3e489fb6d8$export$d83706ee80a9852a extends $69b00e3e489fb6d8$export$93924a205c12d32c {
        jqlComparisonOperator() {
            return this.getRuleContext(0, $69b00e3e489fb6d8$export$d821da0716b3ec95);
        }
        jqlValue() {
            return this.tryGetRuleContext(0, $69b00e3e489fb6d8$export$2e17d457b0933bec);
        }
        jqlFunction() {
            return this.tryGetRuleContext(0, $69b00e3e489fb6d8$export$ebf0cc785e9ee41a);
        }
        constructor(ctx){
            super(ctx.parent, ctx.invokingState);
            this.copyFrom(ctx);
        }
        enterRule(listener) {
            if (listener.enterJqlComparisonClause) listener.enterJqlComparisonClause(this);
        }
        exitRule(listener) {
            if (listener.exitJqlComparisonClause) listener.exitJqlComparisonClause(this);
        }
        accept(visitor) {
            if (visitor.visitJqlComparisonClause) return visitor.visitJqlComparisonClause(this);
            else return visitor.visitChildren(this);
        }
    }
    class $69b00e3e489fb6d8$export$2934b8ff22fddd2d extends $69b00e3e489fb6d8$export$93924a205c12d32c {
        jqlInOperator() {
            return this.getRuleContext(0, $69b00e3e489fb6d8$export$178478bfa8292f72);
        }
        jqlList() {
            return this.tryGetRuleContext(0, $69b00e3e489fb6d8$export$9cb97a63f2be4864);
        }
        jqlFunction() {
            return this.tryGetRuleContext(0, $69b00e3e489fb6d8$export$ebf0cc785e9ee41a);
        }
        constructor(ctx){
            super(ctx.parent, ctx.invokingState);
            this.copyFrom(ctx);
        }
        enterRule(listener) {
            if (listener.enterJqlInClause) listener.enterJqlInClause(this);
        }
        exitRule(listener) {
            if (listener.exitJqlInClause) listener.exitJqlInClause(this);
        }
        accept(visitor) {
            if (visitor.visitJqlInClause) return visitor.visitJqlInClause(this);
            else return visitor.visitChildren(this);
        }
    }
    class $69b00e3e489fb6d8$export$8b84310182afcf93 extends $69b00e3e489fb6d8$export$93924a205c12d32c {
        jqlIsOperator() {
            return this.getRuleContext(0, $69b00e3e489fb6d8$export$e64c31d2830b66e4);
        }
        jqlEmpty() {
            return this.getRuleContext(0, $69b00e3e489fb6d8$export$d85a062f90025e5c);
        }
        constructor(ctx){
            super(ctx.parent, ctx.invokingState);
            this.copyFrom(ctx);
        }
        enterRule(listener) {
            if (listener.enterJqlIsClause) listener.enterJqlIsClause(this);
        }
        exitRule(listener) {
            if (listener.exitJqlIsClause) listener.exitJqlIsClause(this);
        }
        accept(visitor) {
            if (visitor.visitJqlIsClause) return visitor.visitJqlIsClause(this);
            else return visitor.visitChildren(this);
        }
    }
    class $69b00e3e489fb6d8$export$5df295dc7a2cac7c extends $69b00e3e489fb6d8$export$93924a205c12d32c {
        jqlWasOperator() {
            return this.getRuleContext(0, $69b00e3e489fb6d8$export$7e283636700e4a6c);
        }
        jqlEmpty() {
            return this.tryGetRuleContext(0, $69b00e3e489fb6d8$export$d85a062f90025e5c);
        }
        jqlValue() {
            return this.tryGetRuleContext(0, $69b00e3e489fb6d8$export$2e17d457b0933bec);
        }
        jqlFunction() {
            return this.tryGetRuleContext(0, $69b00e3e489fb6d8$export$ebf0cc785e9ee41a);
        }
        jqlWasPredicate(i) {
            if (i === undefined) return this.getRuleContexts($69b00e3e489fb6d8$export$9fa1e4d63f31b911);
            else return this.getRuleContext(i, $69b00e3e489fb6d8$export$9fa1e4d63f31b911);
        }
        constructor(ctx){
            super(ctx.parent, ctx.invokingState);
            this.copyFrom(ctx);
        }
        enterRule(listener) {
            if (listener.enterJqlWasClause) listener.enterJqlWasClause(this);
        }
        exitRule(listener) {
            if (listener.exitJqlWasClause) listener.exitJqlWasClause(this);
        }
        accept(visitor) {
            if (visitor.visitJqlWasClause) return visitor.visitJqlWasClause(this);
            else return visitor.visitChildren(this);
        }
    }
    class $69b00e3e489fb6d8$export$9ac3367aee261b32 extends $69b00e3e489fb6d8$export$93924a205c12d32c {
        jqlWasInOperator() {
            return this.getRuleContext(0, $69b00e3e489fb6d8$export$b9118b1ed9a78d66);
        }
        jqlList() {
            return this.tryGetRuleContext(0, $69b00e3e489fb6d8$export$9cb97a63f2be4864);
        }
        jqlFunction() {
            return this.tryGetRuleContext(0, $69b00e3e489fb6d8$export$ebf0cc785e9ee41a);
        }
        jqlWasPredicate(i) {
            if (i === undefined) return this.getRuleContexts($69b00e3e489fb6d8$export$9fa1e4d63f31b911);
            else return this.getRuleContext(i, $69b00e3e489fb6d8$export$9fa1e4d63f31b911);
        }
        constructor(ctx){
            super(ctx.parent, ctx.invokingState);
            this.copyFrom(ctx);
        }
        enterRule(listener) {
            if (listener.enterJqlWasInClause) listener.enterJqlWasInClause(this);
        }
        exitRule(listener) {
            if (listener.exitJqlWasInClause) listener.exitJqlWasInClause(this);
        }
        accept(visitor) {
            if (visitor.visitJqlWasInClause) return visitor.visitJqlWasInClause(this);
            else return visitor.visitChildren(this);
        }
    }
    class $69b00e3e489fb6d8$export$7a7defca8628a13c extends $69b00e3e489fb6d8$export$93924a205c12d32c {
        jqlChangedOperator() {
            return this.getRuleContext(0, $69b00e3e489fb6d8$export$493d626ed78ca66);
        }
        jqlChangedPredicate(i) {
            if (i === undefined) return this.getRuleContexts($69b00e3e489fb6d8$export$e77e479a48133015);
            else return this.getRuleContext(i, $69b00e3e489fb6d8$export$e77e479a48133015);
        }
        constructor(ctx){
            super(ctx.parent, ctx.invokingState);
            this.copyFrom(ctx);
        }
        enterRule(listener) {
            if (listener.enterJqlChangedClause) listener.enterJqlChangedClause(this);
        }
        exitRule(listener) {
            if (listener.exitJqlChangedClause) listener.exitJqlChangedClause(this);
        }
        accept(visitor) {
            if (visitor.visitJqlChangedClause) return visitor.visitJqlChangedClause(this);
            else return visitor.visitChildren(this);
        }
    }
    class $69b00e3e489fb6d8$export$41e475fc1988e413 extends (0, $6bmaO.ParserRuleContext) {
        EQUALS() {
            return this.tryGetToken($69b00e3e489fb6d8$export$9c4772e191bdb810.EQUALS, 0);
        }
        NOT_EQUALS() {
            return this.tryGetToken($69b00e3e489fb6d8$export$9c4772e191bdb810.NOT_EQUALS, 0);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $69b00e3e489fb6d8$export$9c4772e191bdb810.RULE_jqlEqualsOperator;
        }
        enterRule(listener) {
            if (listener.enterJqlEqualsOperator) listener.enterJqlEqualsOperator(this);
        }
        exitRule(listener) {
            if (listener.exitJqlEqualsOperator) listener.exitJqlEqualsOperator(this);
        }
        accept(visitor) {
            if (visitor.visitJqlEqualsOperator) return visitor.visitJqlEqualsOperator(this);
            else return visitor.visitChildren(this);
        }
    }
    class $69b00e3e489fb6d8$export$b76fe5387fdd7efd extends (0, $6bmaO.ParserRuleContext) {
        LIKE() {
            return this.tryGetToken($69b00e3e489fb6d8$export$9c4772e191bdb810.LIKE, 0);
        }
        NOT_LIKE() {
            return this.tryGetToken($69b00e3e489fb6d8$export$9c4772e191bdb810.NOT_LIKE, 0);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $69b00e3e489fb6d8$export$9c4772e191bdb810.RULE_jqlLikeOperator;
        }
        enterRule(listener) {
            if (listener.enterJqlLikeOperator) listener.enterJqlLikeOperator(this);
        }
        exitRule(listener) {
            if (listener.exitJqlLikeOperator) listener.exitJqlLikeOperator(this);
        }
        accept(visitor) {
            if (visitor.visitJqlLikeOperator) return visitor.visitJqlLikeOperator(this);
            else return visitor.visitChildren(this);
        }
    }
    class $69b00e3e489fb6d8$export$d821da0716b3ec95 extends (0, $6bmaO.ParserRuleContext) {
        LT() {
            return this.tryGetToken($69b00e3e489fb6d8$export$9c4772e191bdb810.LT, 0);
        }
        GT() {
            return this.tryGetToken($69b00e3e489fb6d8$export$9c4772e191bdb810.GT, 0);
        }
        LTEQ() {
            return this.tryGetToken($69b00e3e489fb6d8$export$9c4772e191bdb810.LTEQ, 0);
        }
        GTEQ() {
            return this.tryGetToken($69b00e3e489fb6d8$export$9c4772e191bdb810.GTEQ, 0);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $69b00e3e489fb6d8$export$9c4772e191bdb810.RULE_jqlComparisonOperator;
        }
        enterRule(listener) {
            if (listener.enterJqlComparisonOperator) listener.enterJqlComparisonOperator(this);
        }
        exitRule(listener) {
            if (listener.exitJqlComparisonOperator) listener.exitJqlComparisonOperator(this);
        }
        accept(visitor) {
            if (visitor.visitJqlComparisonOperator) return visitor.visitJqlComparisonOperator(this);
            else return visitor.visitChildren(this);
        }
    }
    class $69b00e3e489fb6d8$export$178478bfa8292f72 extends (0, $6bmaO.ParserRuleContext) {
        IN() {
            return this.getToken($69b00e3e489fb6d8$export$9c4772e191bdb810.IN, 0);
        }
        NOT() {
            return this.tryGetToken($69b00e3e489fb6d8$export$9c4772e191bdb810.NOT, 0);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $69b00e3e489fb6d8$export$9c4772e191bdb810.RULE_jqlInOperator;
        }
        enterRule(listener) {
            if (listener.enterJqlInOperator) listener.enterJqlInOperator(this);
        }
        exitRule(listener) {
            if (listener.exitJqlInOperator) listener.exitJqlInOperator(this);
        }
        accept(visitor) {
            if (visitor.visitJqlInOperator) return visitor.visitJqlInOperator(this);
            else return visitor.visitChildren(this);
        }
    }
    class $69b00e3e489fb6d8$export$e64c31d2830b66e4 extends (0, $6bmaO.ParserRuleContext) {
        IS() {
            return this.getToken($69b00e3e489fb6d8$export$9c4772e191bdb810.IS, 0);
        }
        NOT() {
            return this.tryGetToken($69b00e3e489fb6d8$export$9c4772e191bdb810.NOT, 0);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $69b00e3e489fb6d8$export$9c4772e191bdb810.RULE_jqlIsOperator;
        }
        enterRule(listener) {
            if (listener.enterJqlIsOperator) listener.enterJqlIsOperator(this);
        }
        exitRule(listener) {
            if (listener.exitJqlIsOperator) listener.exitJqlIsOperator(this);
        }
        accept(visitor) {
            if (visitor.visitJqlIsOperator) return visitor.visitJqlIsOperator(this);
            else return visitor.visitChildren(this);
        }
    }
    class $69b00e3e489fb6d8$export$7e283636700e4a6c extends (0, $6bmaO.ParserRuleContext) {
        WAS() {
            return this.getToken($69b00e3e489fb6d8$export$9c4772e191bdb810.WAS, 0);
        }
        NOT() {
            return this.tryGetToken($69b00e3e489fb6d8$export$9c4772e191bdb810.NOT, 0);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $69b00e3e489fb6d8$export$9c4772e191bdb810.RULE_jqlWasOperator;
        }
        enterRule(listener) {
            if (listener.enterJqlWasOperator) listener.enterJqlWasOperator(this);
        }
        exitRule(listener) {
            if (listener.exitJqlWasOperator) listener.exitJqlWasOperator(this);
        }
        accept(visitor) {
            if (visitor.visitJqlWasOperator) return visitor.visitJqlWasOperator(this);
            else return visitor.visitChildren(this);
        }
    }
    class $69b00e3e489fb6d8$export$b9118b1ed9a78d66 extends (0, $6bmaO.ParserRuleContext) {
        WAS() {
            return this.getToken($69b00e3e489fb6d8$export$9c4772e191bdb810.WAS, 0);
        }
        IN() {
            return this.getToken($69b00e3e489fb6d8$export$9c4772e191bdb810.IN, 0);
        }
        NOT() {
            return this.tryGetToken($69b00e3e489fb6d8$export$9c4772e191bdb810.NOT, 0);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $69b00e3e489fb6d8$export$9c4772e191bdb810.RULE_jqlWasInOperator;
        }
        enterRule(listener) {
            if (listener.enterJqlWasInOperator) listener.enterJqlWasInOperator(this);
        }
        exitRule(listener) {
            if (listener.exitJqlWasInOperator) listener.exitJqlWasInOperator(this);
        }
        accept(visitor) {
            if (visitor.visitJqlWasInOperator) return visitor.visitJqlWasInOperator(this);
            else return visitor.visitChildren(this);
        }
    }
    class $69b00e3e489fb6d8$export$493d626ed78ca66 extends (0, $6bmaO.ParserRuleContext) {
        CHANGED() {
            return this.getToken($69b00e3e489fb6d8$export$9c4772e191bdb810.CHANGED, 0);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $69b00e3e489fb6d8$export$9c4772e191bdb810.RULE_jqlChangedOperator;
        }
        enterRule(listener) {
            if (listener.enterJqlChangedOperator) listener.enterJqlChangedOperator(this);
        }
        exitRule(listener) {
            if (listener.exitJqlChangedOperator) listener.exitJqlChangedOperator(this);
        }
        accept(visitor) {
            if (visitor.visitJqlChangedOperator) return visitor.visitJqlChangedOperator(this);
            else return visitor.visitChildren(this);
        }
    }
    class $69b00e3e489fb6d8$export$b33300c3d916229a extends (0, $6bmaO.ParserRuleContext) {
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $69b00e3e489fb6d8$export$9c4772e191bdb810.RULE_jqlField;
        }
        copyFrom(ctx) {
            super.copyFrom(ctx);
        }
    }
    class $69b00e3e489fb6d8$export$11fec15307d2e17b extends $69b00e3e489fb6d8$export$b33300c3d916229a {
        jqlNumber() {
            return this.getRuleContext(0, $69b00e3e489fb6d8$export$8737d94a1880e8b3);
        }
        constructor(ctx){
            super(ctx.parent, ctx.invokingState);
            this.copyFrom(ctx);
        }
        enterRule(listener) {
            if (listener.enterJqlNumberField) listener.enterJqlNumberField(this);
        }
        exitRule(listener) {
            if (listener.exitJqlNumberField) listener.exitJqlNumberField(this);
        }
        accept(visitor) {
            if (visitor.visitJqlNumberField) return visitor.visitJqlNumberField(this);
            else return visitor.visitChildren(this);
        }
    }
    class $69b00e3e489fb6d8$export$b8b24f99f985ebb3 extends $69b00e3e489fb6d8$export$b33300c3d916229a {
        jqlString() {
            return this.tryGetRuleContext(0, $69b00e3e489fb6d8$export$bde73d8ad7c8b71e);
        }
        jqlCustomField() {
            return this.tryGetRuleContext(0, $69b00e3e489fb6d8$export$401a038855cc5b15);
        }
        jqlFieldProperty(i) {
            if (i === undefined) return this.getRuleContexts($69b00e3e489fb6d8$export$b02d0b6637ce0593);
            else return this.getRuleContext(i, $69b00e3e489fb6d8$export$b02d0b6637ce0593);
        }
        constructor(ctx){
            super(ctx.parent, ctx.invokingState);
            this.copyFrom(ctx);
        }
        enterRule(listener) {
            if (listener.enterJqlNonNumberField) listener.enterJqlNonNumberField(this);
        }
        exitRule(listener) {
            if (listener.exitJqlNonNumberField) listener.exitJqlNonNumberField(this);
        }
        accept(visitor) {
            if (visitor.visitJqlNonNumberField) return visitor.visitJqlNonNumberField(this);
            else return visitor.visitChildren(this);
        }
    }
    class $69b00e3e489fb6d8$export$b02d0b6637ce0593 extends (0, $6bmaO.ParserRuleContext) {
        LBRACKET() {
            return this.tryGetToken($69b00e3e489fb6d8$export$9c4772e191bdb810.LBRACKET, 0);
        }
        RBRACKET() {
            return this.tryGetToken($69b00e3e489fb6d8$export$9c4772e191bdb810.RBRACKET, 0);
        }
        jqlPropertyArgument(i) {
            if (i === undefined) return this.getRuleContexts($69b00e3e489fb6d8$export$e20ce4a2ed16372c);
            else return this.getRuleContext(i, $69b00e3e489fb6d8$export$e20ce4a2ed16372c);
        }
        jqlArgument() {
            return this.tryGetRuleContext(0, $69b00e3e489fb6d8$export$a95583953c237f88);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $69b00e3e489fb6d8$export$9c4772e191bdb810.RULE_jqlFieldProperty;
        }
        enterRule(listener) {
            if (listener.enterJqlFieldProperty) listener.enterJqlFieldProperty(this);
        }
        exitRule(listener) {
            if (listener.exitJqlFieldProperty) listener.exitJqlFieldProperty(this);
        }
        accept(visitor) {
            if (visitor.visitJqlFieldProperty) return visitor.visitJqlFieldProperty(this);
            else return visitor.visitChildren(this);
        }
    }
    class $69b00e3e489fb6d8$export$401a038855cc5b15 extends (0, $6bmaO.ParserRuleContext) {
        CUSTOMFIELD() {
            return this.getToken($69b00e3e489fb6d8$export$9c4772e191bdb810.CUSTOMFIELD, 0);
        }
        LBRACKET() {
            return this.getToken($69b00e3e489fb6d8$export$9c4772e191bdb810.LBRACKET, 0);
        }
        POSNUMBER() {
            return this.getToken($69b00e3e489fb6d8$export$9c4772e191bdb810.POSNUMBER, 0);
        }
        RBRACKET() {
            return this.getToken($69b00e3e489fb6d8$export$9c4772e191bdb810.RBRACKET, 0);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $69b00e3e489fb6d8$export$9c4772e191bdb810.RULE_jqlCustomField;
        }
        enterRule(listener) {
            if (listener.enterJqlCustomField) listener.enterJqlCustomField(this);
        }
        exitRule(listener) {
            if (listener.exitJqlCustomField) listener.exitJqlCustomField(this);
        }
        accept(visitor) {
            if (visitor.visitJqlCustomField) return visitor.visitJqlCustomField(this);
            else return visitor.visitChildren(this);
        }
    }
    class $69b00e3e489fb6d8$export$bde73d8ad7c8b71e extends (0, $6bmaO.ParserRuleContext) {
        STRING() {
            return this.tryGetToken($69b00e3e489fb6d8$export$9c4772e191bdb810.STRING, 0);
        }
        QUOTE_STRING() {
            return this.tryGetToken($69b00e3e489fb6d8$export$9c4772e191bdb810.QUOTE_STRING, 0);
        }
        SQUOTE_STRING() {
            return this.tryGetToken($69b00e3e489fb6d8$export$9c4772e191bdb810.SQUOTE_STRING, 0);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $69b00e3e489fb6d8$export$9c4772e191bdb810.RULE_jqlString;
        }
        enterRule(listener) {
            if (listener.enterJqlString) listener.enterJqlString(this);
        }
        exitRule(listener) {
            if (listener.exitJqlString) listener.exitJqlString(this);
        }
        accept(visitor) {
            if (visitor.visitJqlString) return visitor.visitJqlString(this);
            else return visitor.visitChildren(this);
        }
    }
    class $69b00e3e489fb6d8$export$8737d94a1880e8b3 extends (0, $6bmaO.ParserRuleContext) {
        POSNUMBER() {
            return this.tryGetToken($69b00e3e489fb6d8$export$9c4772e191bdb810.POSNUMBER, 0);
        }
        NEGNUMBER() {
            return this.tryGetToken($69b00e3e489fb6d8$export$9c4772e191bdb810.NEGNUMBER, 0);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $69b00e3e489fb6d8$export$9c4772e191bdb810.RULE_jqlNumber;
        }
        enterRule(listener) {
            if (listener.enterJqlNumber) listener.enterJqlNumber(this);
        }
        exitRule(listener) {
            if (listener.exitJqlNumber) listener.exitJqlNumber(this);
        }
        accept(visitor) {
            if (visitor.visitJqlNumber) return visitor.visitJqlNumber(this);
            else return visitor.visitChildren(this);
        }
    }
    class $69b00e3e489fb6d8$export$2eaac5a9828bf647 extends (0, $6bmaO.ParserRuleContext) {
        jqlEmpty() {
            return this.tryGetRuleContext(0, $69b00e3e489fb6d8$export$d85a062f90025e5c);
        }
        jqlValue() {
            return this.tryGetRuleContext(0, $69b00e3e489fb6d8$export$2e17d457b0933bec);
        }
        jqlFunction() {
            return this.tryGetRuleContext(0, $69b00e3e489fb6d8$export$ebf0cc785e9ee41a);
        }
        jqlList() {
            return this.tryGetRuleContext(0, $69b00e3e489fb6d8$export$9cb97a63f2be4864);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $69b00e3e489fb6d8$export$9c4772e191bdb810.RULE_jqlOperand;
        }
        enterRule(listener) {
            if (listener.enterJqlOperand) listener.enterJqlOperand(this);
        }
        exitRule(listener) {
            if (listener.exitJqlOperand) listener.exitJqlOperand(this);
        }
        accept(visitor) {
            if (visitor.visitJqlOperand) return visitor.visitJqlOperand(this);
            else return visitor.visitChildren(this);
        }
    }
    class $69b00e3e489fb6d8$export$d85a062f90025e5c extends (0, $6bmaO.ParserRuleContext) {
        EMPTY() {
            return this.getToken($69b00e3e489fb6d8$export$9c4772e191bdb810.EMPTY, 0);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $69b00e3e489fb6d8$export$9c4772e191bdb810.RULE_jqlEmpty;
        }
        enterRule(listener) {
            if (listener.enterJqlEmpty) listener.enterJqlEmpty(this);
        }
        exitRule(listener) {
            if (listener.exitJqlEmpty) listener.exitJqlEmpty(this);
        }
        accept(visitor) {
            if (visitor.visitJqlEmpty) return visitor.visitJqlEmpty(this);
            else return visitor.visitChildren(this);
        }
    }
    class $69b00e3e489fb6d8$export$2e17d457b0933bec extends (0, $6bmaO.ParserRuleContext) {
        jqlString() {
            return this.tryGetRuleContext(0, $69b00e3e489fb6d8$export$bde73d8ad7c8b71e);
        }
        jqlNumber() {
            return this.tryGetRuleContext(0, $69b00e3e489fb6d8$export$8737d94a1880e8b3);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $69b00e3e489fb6d8$export$9c4772e191bdb810.RULE_jqlValue;
        }
        enterRule(listener) {
            if (listener.enterJqlValue) listener.enterJqlValue(this);
        }
        exitRule(listener) {
            if (listener.exitJqlValue) listener.exitJqlValue(this);
        }
        accept(visitor) {
            if (visitor.visitJqlValue) return visitor.visitJqlValue(this);
            else return visitor.visitChildren(this);
        }
    }
    class $69b00e3e489fb6d8$export$ebf0cc785e9ee41a extends (0, $6bmaO.ParserRuleContext) {
        jqlFunctionName() {
            return this.getRuleContext(0, $69b00e3e489fb6d8$export$1f5f7ac816788f44);
        }
        LPAREN() {
            return this.getToken($69b00e3e489fb6d8$export$9c4772e191bdb810.LPAREN, 0);
        }
        RPAREN() {
            return this.getToken($69b00e3e489fb6d8$export$9c4772e191bdb810.RPAREN, 0);
        }
        jqlArgumentList() {
            return this.tryGetRuleContext(0, $69b00e3e489fb6d8$export$83d7c13849b931c3);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $69b00e3e489fb6d8$export$9c4772e191bdb810.RULE_jqlFunction;
        }
        enterRule(listener) {
            if (listener.enterJqlFunction) listener.enterJqlFunction(this);
        }
        exitRule(listener) {
            if (listener.exitJqlFunction) listener.exitJqlFunction(this);
        }
        accept(visitor) {
            if (visitor.visitJqlFunction) return visitor.visitJqlFunction(this);
            else return visitor.visitChildren(this);
        }
    }
    class $69b00e3e489fb6d8$export$1f5f7ac816788f44 extends (0, $6bmaO.ParserRuleContext) {
        jqlString() {
            return this.tryGetRuleContext(0, $69b00e3e489fb6d8$export$bde73d8ad7c8b71e);
        }
        jqlNumber() {
            return this.tryGetRuleContext(0, $69b00e3e489fb6d8$export$8737d94a1880e8b3);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $69b00e3e489fb6d8$export$9c4772e191bdb810.RULE_jqlFunctionName;
        }
        enterRule(listener) {
            if (listener.enterJqlFunctionName) listener.enterJqlFunctionName(this);
        }
        exitRule(listener) {
            if (listener.exitJqlFunctionName) listener.exitJqlFunctionName(this);
        }
        accept(visitor) {
            if (visitor.visitJqlFunctionName) return visitor.visitJqlFunctionName(this);
            else return visitor.visitChildren(this);
        }
    }
    class $69b00e3e489fb6d8$export$83d7c13849b931c3 extends (0, $6bmaO.ParserRuleContext) {
        jqlArgument(i) {
            if (i === undefined) return this.getRuleContexts($69b00e3e489fb6d8$export$a95583953c237f88);
            else return this.getRuleContext(i, $69b00e3e489fb6d8$export$a95583953c237f88);
        }
        COMMA(i) {
            if (i === undefined) return this.getTokens($69b00e3e489fb6d8$export$9c4772e191bdb810.COMMA);
            else return this.getToken($69b00e3e489fb6d8$export$9c4772e191bdb810.COMMA, i);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $69b00e3e489fb6d8$export$9c4772e191bdb810.RULE_jqlArgumentList;
        }
        enterRule(listener) {
            if (listener.enterJqlArgumentList) listener.enterJqlArgumentList(this);
        }
        exitRule(listener) {
            if (listener.exitJqlArgumentList) listener.exitJqlArgumentList(this);
        }
        accept(visitor) {
            if (visitor.visitJqlArgumentList) return visitor.visitJqlArgumentList(this);
            else return visitor.visitChildren(this);
        }
    }
    class $69b00e3e489fb6d8$export$9cb97a63f2be4864 extends (0, $6bmaO.ParserRuleContext) {
        jqlListStart() {
            return this.getRuleContext(0, $69b00e3e489fb6d8$export$c419f717bfc46a5d);
        }
        jqlOperand(i) {
            if (i === undefined) return this.getRuleContexts($69b00e3e489fb6d8$export$2eaac5a9828bf647);
            else return this.getRuleContext(i, $69b00e3e489fb6d8$export$2eaac5a9828bf647);
        }
        jqlListEnd() {
            return this.getRuleContext(0, $69b00e3e489fb6d8$export$f6cd3e372f5ab120);
        }
        COMMA(i) {
            if (i === undefined) return this.getTokens($69b00e3e489fb6d8$export$9c4772e191bdb810.COMMA);
            else return this.getToken($69b00e3e489fb6d8$export$9c4772e191bdb810.COMMA, i);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $69b00e3e489fb6d8$export$9c4772e191bdb810.RULE_jqlList;
        }
        enterRule(listener) {
            if (listener.enterJqlList) listener.enterJqlList(this);
        }
        exitRule(listener) {
            if (listener.exitJqlList) listener.exitJqlList(this);
        }
        accept(visitor) {
            if (visitor.visitJqlList) return visitor.visitJqlList(this);
            else return visitor.visitChildren(this);
        }
    }
    class $69b00e3e489fb6d8$export$c419f717bfc46a5d extends (0, $6bmaO.ParserRuleContext) {
        LPAREN() {
            return this.getToken($69b00e3e489fb6d8$export$9c4772e191bdb810.LPAREN, 0);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $69b00e3e489fb6d8$export$9c4772e191bdb810.RULE_jqlListStart;
        }
        enterRule(listener) {
            if (listener.enterJqlListStart) listener.enterJqlListStart(this);
        }
        exitRule(listener) {
            if (listener.exitJqlListStart) listener.exitJqlListStart(this);
        }
        accept(visitor) {
            if (visitor.visitJqlListStart) return visitor.visitJqlListStart(this);
            else return visitor.visitChildren(this);
        }
    }
    class $69b00e3e489fb6d8$export$f6cd3e372f5ab120 extends (0, $6bmaO.ParserRuleContext) {
        RPAREN() {
            return this.getToken($69b00e3e489fb6d8$export$9c4772e191bdb810.RPAREN, 0);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $69b00e3e489fb6d8$export$9c4772e191bdb810.RULE_jqlListEnd;
        }
        enterRule(listener) {
            if (listener.enterJqlListEnd) listener.enterJqlListEnd(this);
        }
        exitRule(listener) {
            if (listener.exitJqlListEnd) listener.exitJqlListEnd(this);
        }
        accept(visitor) {
            if (visitor.visitJqlListEnd) return visitor.visitJqlListEnd(this);
            else return visitor.visitChildren(this);
        }
    }
    class $69b00e3e489fb6d8$export$e20ce4a2ed16372c extends (0, $6bmaO.ParserRuleContext) {
        jqlArgument() {
            return this.getRuleContext(0, $69b00e3e489fb6d8$export$a95583953c237f88);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $69b00e3e489fb6d8$export$9c4772e191bdb810.RULE_jqlPropertyArgument;
        }
        enterRule(listener) {
            if (listener.enterJqlPropertyArgument) listener.enterJqlPropertyArgument(this);
        }
        exitRule(listener) {
            if (listener.exitJqlPropertyArgument) listener.exitJqlPropertyArgument(this);
        }
        accept(visitor) {
            if (visitor.visitJqlPropertyArgument) return visitor.visitJqlPropertyArgument(this);
            else return visitor.visitChildren(this);
        }
    }
    class $69b00e3e489fb6d8$export$a95583953c237f88 extends (0, $6bmaO.ParserRuleContext) {
        jqlString() {
            return this.tryGetRuleContext(0, $69b00e3e489fb6d8$export$bde73d8ad7c8b71e);
        }
        jqlNumber() {
            return this.tryGetRuleContext(0, $69b00e3e489fb6d8$export$8737d94a1880e8b3);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $69b00e3e489fb6d8$export$9c4772e191bdb810.RULE_jqlArgument;
        }
        enterRule(listener) {
            if (listener.enterJqlArgument) listener.enterJqlArgument(this);
        }
        exitRule(listener) {
            if (listener.exitJqlArgument) listener.exitJqlArgument(this);
        }
        accept(visitor) {
            if (visitor.visitJqlArgument) return visitor.visitJqlArgument(this);
            else return visitor.visitChildren(this);
        }
    }
    class $69b00e3e489fb6d8$export$9fa1e4d63f31b911 extends (0, $6bmaO.ParserRuleContext) {
        jqlPredicateOperand() {
            return this.getRuleContext(0, $69b00e3e489fb6d8$export$6b796c5a4b8c18e);
        }
        jqlDatePredicateOperator() {
            return this.tryGetRuleContext(0, $69b00e3e489fb6d8$export$dc01290aee731418);
        }
        jqlDateRangePredicateOperator() {
            return this.tryGetRuleContext(0, $69b00e3e489fb6d8$export$75412b8b6a6442e1);
        }
        jqlUserPredicateOperator() {
            return this.tryGetRuleContext(0, $69b00e3e489fb6d8$export$ad402332075c8656);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $69b00e3e489fb6d8$export$9c4772e191bdb810.RULE_jqlWasPredicate;
        }
        enterRule(listener) {
            if (listener.enterJqlWasPredicate) listener.enterJqlWasPredicate(this);
        }
        exitRule(listener) {
            if (listener.exitJqlWasPredicate) listener.exitJqlWasPredicate(this);
        }
        accept(visitor) {
            if (visitor.visitJqlWasPredicate) return visitor.visitJqlWasPredicate(this);
            else return visitor.visitChildren(this);
        }
    }
    class $69b00e3e489fb6d8$export$e77e479a48133015 extends (0, $6bmaO.ParserRuleContext) {
        jqlPredicateOperand() {
            return this.getRuleContext(0, $69b00e3e489fb6d8$export$6b796c5a4b8c18e);
        }
        jqlDatePredicateOperator() {
            return this.tryGetRuleContext(0, $69b00e3e489fb6d8$export$dc01290aee731418);
        }
        jqlDateRangePredicateOperator() {
            return this.tryGetRuleContext(0, $69b00e3e489fb6d8$export$75412b8b6a6442e1);
        }
        jqlUserPredicateOperator() {
            return this.tryGetRuleContext(0, $69b00e3e489fb6d8$export$ad402332075c8656);
        }
        jqlValuePredicateOperator() {
            return this.tryGetRuleContext(0, $69b00e3e489fb6d8$export$4239d7c0fbafd3f1);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $69b00e3e489fb6d8$export$9c4772e191bdb810.RULE_jqlChangedPredicate;
        }
        enterRule(listener) {
            if (listener.enterJqlChangedPredicate) listener.enterJqlChangedPredicate(this);
        }
        exitRule(listener) {
            if (listener.exitJqlChangedPredicate) listener.exitJqlChangedPredicate(this);
        }
        accept(visitor) {
            if (visitor.visitJqlChangedPredicate) return visitor.visitJqlChangedPredicate(this);
            else return visitor.visitChildren(this);
        }
    }
    class $69b00e3e489fb6d8$export$dc01290aee731418 extends (0, $6bmaO.ParserRuleContext) {
        AFTER() {
            return this.tryGetToken($69b00e3e489fb6d8$export$9c4772e191bdb810.AFTER, 0);
        }
        BEFORE() {
            return this.tryGetToken($69b00e3e489fb6d8$export$9c4772e191bdb810.BEFORE, 0);
        }
        ON() {
            return this.tryGetToken($69b00e3e489fb6d8$export$9c4772e191bdb810.ON, 0);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $69b00e3e489fb6d8$export$9c4772e191bdb810.RULE_jqlDatePredicateOperator;
        }
        enterRule(listener) {
            if (listener.enterJqlDatePredicateOperator) listener.enterJqlDatePredicateOperator(this);
        }
        exitRule(listener) {
            if (listener.exitJqlDatePredicateOperator) listener.exitJqlDatePredicateOperator(this);
        }
        accept(visitor) {
            if (visitor.visitJqlDatePredicateOperator) return visitor.visitJqlDatePredicateOperator(this);
            else return visitor.visitChildren(this);
        }
    }
    class $69b00e3e489fb6d8$export$75412b8b6a6442e1 extends (0, $6bmaO.ParserRuleContext) {
        DURING() {
            return this.getToken($69b00e3e489fb6d8$export$9c4772e191bdb810.DURING, 0);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $69b00e3e489fb6d8$export$9c4772e191bdb810.RULE_jqlDateRangePredicateOperator;
        }
        enterRule(listener) {
            if (listener.enterJqlDateRangePredicateOperator) listener.enterJqlDateRangePredicateOperator(this);
        }
        exitRule(listener) {
            if (listener.exitJqlDateRangePredicateOperator) listener.exitJqlDateRangePredicateOperator(this);
        }
        accept(visitor) {
            if (visitor.visitJqlDateRangePredicateOperator) return visitor.visitJqlDateRangePredicateOperator(this);
            else return visitor.visitChildren(this);
        }
    }
    class $69b00e3e489fb6d8$export$ad402332075c8656 extends (0, $6bmaO.ParserRuleContext) {
        BY() {
            return this.getToken($69b00e3e489fb6d8$export$9c4772e191bdb810.BY, 0);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $69b00e3e489fb6d8$export$9c4772e191bdb810.RULE_jqlUserPredicateOperator;
        }
        enterRule(listener) {
            if (listener.enterJqlUserPredicateOperator) listener.enterJqlUserPredicateOperator(this);
        }
        exitRule(listener) {
            if (listener.exitJqlUserPredicateOperator) listener.exitJqlUserPredicateOperator(this);
        }
        accept(visitor) {
            if (visitor.visitJqlUserPredicateOperator) return visitor.visitJqlUserPredicateOperator(this);
            else return visitor.visitChildren(this);
        }
    }
    class $69b00e3e489fb6d8$export$4239d7c0fbafd3f1 extends (0, $6bmaO.ParserRuleContext) {
        FROM() {
            return this.tryGetToken($69b00e3e489fb6d8$export$9c4772e191bdb810.FROM, 0);
        }
        TO() {
            return this.tryGetToken($69b00e3e489fb6d8$export$9c4772e191bdb810.TO, 0);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $69b00e3e489fb6d8$export$9c4772e191bdb810.RULE_jqlValuePredicateOperator;
        }
        enterRule(listener) {
            if (listener.enterJqlValuePredicateOperator) listener.enterJqlValuePredicateOperator(this);
        }
        exitRule(listener) {
            if (listener.exitJqlValuePredicateOperator) listener.exitJqlValuePredicateOperator(this);
        }
        accept(visitor) {
            if (visitor.visitJqlValuePredicateOperator) return visitor.visitJqlValuePredicateOperator(this);
            else return visitor.visitChildren(this);
        }
    }
    class $69b00e3e489fb6d8$export$6b796c5a4b8c18e extends (0, $6bmaO.ParserRuleContext) {
        jqlOperand() {
            return this.getRuleContext(0, $69b00e3e489fb6d8$export$2eaac5a9828bf647);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $69b00e3e489fb6d8$export$9c4772e191bdb810.RULE_jqlPredicateOperand;
        }
        enterRule(listener) {
            if (listener.enterJqlPredicateOperand) listener.enterJqlPredicateOperand(this);
        }
        exitRule(listener) {
            if (listener.exitJqlPredicateOperand) listener.exitJqlPredicateOperand(this);
        }
        accept(visitor) {
            if (visitor.visitJqlPredicateOperand) return visitor.visitJqlPredicateOperand(this);
            else return visitor.visitChildren(this);
        }
    }
    class $69b00e3e489fb6d8$export$534469b9c8f44139 extends (0, $6bmaO.ParserRuleContext) {
        ORDER() {
            return this.getToken($69b00e3e489fb6d8$export$9c4772e191bdb810.ORDER, 0);
        }
        BY() {
            return this.getToken($69b00e3e489fb6d8$export$9c4772e191bdb810.BY, 0);
        }
        jqlSearchSort(i) {
            if (i === undefined) return this.getRuleContexts($69b00e3e489fb6d8$export$c7d8f03f36952a46);
            else return this.getRuleContext(i, $69b00e3e489fb6d8$export$c7d8f03f36952a46);
        }
        COMMA(i) {
            if (i === undefined) return this.getTokens($69b00e3e489fb6d8$export$9c4772e191bdb810.COMMA);
            else return this.getToken($69b00e3e489fb6d8$export$9c4772e191bdb810.COMMA, i);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $69b00e3e489fb6d8$export$9c4772e191bdb810.RULE_jqlOrderBy;
        }
        enterRule(listener) {
            if (listener.enterJqlOrderBy) listener.enterJqlOrderBy(this);
        }
        exitRule(listener) {
            if (listener.exitJqlOrderBy) listener.exitJqlOrderBy(this);
        }
        accept(visitor) {
            if (visitor.visitJqlOrderBy) return visitor.visitJqlOrderBy(this);
            else return visitor.visitChildren(this);
        }
    }
    class $69b00e3e489fb6d8$export$c7d8f03f36952a46 extends (0, $6bmaO.ParserRuleContext) {
        jqlField() {
            return this.getRuleContext(0, $69b00e3e489fb6d8$export$b33300c3d916229a);
        }
        DESC() {
            return this.tryGetToken($69b00e3e489fb6d8$export$9c4772e191bdb810.DESC, 0);
        }
        ASC() {
            return this.tryGetToken($69b00e3e489fb6d8$export$9c4772e191bdb810.ASC, 0);
        }
        constructor(parent, invokingState){
            super(parent, invokingState);
        }
        get ruleIndex() {
            return $69b00e3e489fb6d8$export$9c4772e191bdb810.RULE_jqlSearchSort;
        }
        enterRule(listener) {
            if (listener.enterJqlSearchSort) listener.enterJqlSearchSort(this);
        }
        exitRule(listener) {
            if (listener.exitJqlSearchSort) listener.exitJqlSearchSort(this);
        }
        accept(visitor) {
            if (visitor.visitJqlSearchSort) return visitor.visitJqlSearchSort(this);
            else return visitor.visitChildren(this);
        }
    }
});
parcelRegister("6vut6", function(module, exports) {
    $parcel$export(module.exports, "JastBuilderErrorListener", ()=>$bd352a1b8b820bf3$export$d0857f60ff1f385);
    var $fwZc8;
    var $2uB7v;
    class $bd352a1b8b820bf3$export$d0857f60ff1f385 {
        constructor(){
            this.errors = [];
            this.syntaxError = (recognizer, offendingSymbol, line, charPositionInLine, msg)=>{
                if (offendingSymbol === undefined) this.errors.push(new (0, (0, parcelRequire("fwZc8")).JQLParseError)(msg));
                else this.errors.push(new (0, (0, parcelRequire("2uB7v")).JQLSyntaxError)(msg, offendingSymbol.startIndex, offendingSymbol.stopIndex + 1, line, charPositionInLine));
            };
        }
    }
});
parcelRegister("fwZc8", function(module, exports) {
    $parcel$export(module.exports, "JQLParseError", ()=>$9cc5a4a4b87c4748$export$e8cfe2b2c93fbd4b);
    class $9cc5a4a4b87c4748$export$e8cfe2b2c93fbd4b extends Error {
        constructor(message, cause){
            super(message);
            this.name = 'JQLParseError';
            this.cause = cause;
            this.description = message;
        }
    }
});
parcelRegister("2uB7v", function(module, exports) {
    $parcel$export(module.exports, "JQLSyntaxError", ()=>$6112200af33c29ca$export$3276184116160c41);
    var $fwZc8;
    class $6112200af33c29ca$export$3276184116160c41 extends (0, (0, parcelRequire("fwZc8")).JQLParseError) {
        constructor(message, start, stop, line, charPositionInLine){
            super(message);
            this.name = 'JQLSyntaxError';
            this.start = start;
            this.stop = stop;
            this.line = line;
            this.charPositionInLine = charPositionInLine;
        }
    }
});
parcelRegister("g7xgB", function(module, exports) {
    $parcel$export(module.exports, "QueryVisitor", ()=>$4e71ef0749d6c48f$export$418003b930734805);
    var $jn8LC;
    var $c92ia;
    var $9qxev;
    var $iz0qL;
    class $4e71ef0749d6c48f$export$418003b930734805 extends (0, (0, parcelRequire("c92ia")).JastBuildingVisitor) {
        constructor(...args){
            super(...args);
            this.whereVisitor = new (0, (0, parcelRequire("iz0qL")).WhereVisitor)(this.tokens);
            this.orderByVisitor = new (0, (0, parcelRequire("9qxev")).OrderByVisitor)(this.tokens);
            this.visitJqlQuery = (ctx)=>{
                const whereContext = ctx.jqlWhere();
                const orderByContext = ctx.jqlOrderBy();
                return (0, (0, parcelRequire("jn8LC")).internalCreators).query(whereContext && whereContext.accept(this.whereVisitor), orderByContext && orderByContext.accept(this.orderByVisitor), (0, (0, parcelRequire("c92ia")).getPositionFromContext)(ctx));
            };
        }
    }
});
parcelRegister("c92ia", function(module, exports) {
    $parcel$export(module.exports, "JastBuildingVisitor", ()=>$7d58a797784392a9$export$d3c14d7188b09387);
    $parcel$export(module.exports, "getPositionFromToken", ()=>$7d58a797784392a9$export$85a4e6d858dbc6fb);
    $parcel$export(module.exports, "getPositionFromContext", ()=>$7d58a797784392a9$export$264629d4cd3cad3f);
    $parcel$export(module.exports, "getPositionsFromTerminalNodes", ()=>$7d58a797784392a9$export$30d51184879cbaa8);
    $parcel$export(module.exports, "normalizeText", ()=>$7d58a797784392a9$export$7c2714a5250b9239);
    class $7d58a797784392a9$export$d3c14d7188b09387 {
        constructor(tokens){
            this.tokens = tokens;
        }
        visit(tree) {
            throw new Error('Unsupported operation visit(ParseTree)');
        }
        visitChildren(node) {
            throw new Error('Unsupported operation visitChildren(RuleNode)');
        }
        visitErrorNode(node) {
            throw new Error('Unsupported operation visitErrorNode(ErrorNode)');
        }
        visitTerminal(node) {
            throw new Error('Unsupported operation visitTerminal(TerminalNode)');
        }
    }
    const $7d58a797784392a9$export$85a4e6d858dbc6fb = (startToken, stopToken)=>[
            startToken.startIndex,
            (stopToken || startToken).stopIndex + 1
        ];
    const $7d58a797784392a9$export$264629d4cd3cad3f = (ctx)=>[
            ctx.start.startIndex,
            ctx.stop ? ctx.stop.stopIndex + 1 : ctx.start.stopIndex
        ];
    const $7d58a797784392a9$export$30d51184879cbaa8 = (terminalNodes)=>terminalNodes.map((node)=>$7d58a797784392a9$export$85a4e6d858dbc6fb(node.payload));
    const $7d58a797784392a9$export$7c2714a5250b9239 = (text)=>text.toLowerCase().replace(/\s+/g, ' ');
});
parcelRegister("9qxev", function(module, exports) {
    $parcel$export(module.exports, "OrderByVisitor", ()=>$c309e9b71b428845$export$2774b71b99734811);
    var $jn8LC;
    var $4UDBy;
    var $c92ia;
    var $cWl3X;
    class $c309e9b71b428845$export$2774b71b99734811 extends (0, (0, parcelRequire("c92ia")).JastBuildingVisitor) {
        constructor(...args){
            super(...args);
            this.searchSortVisitor = new $c309e9b71b428845$var$SearchSortVisitor(this.tokens);
            this.visitJqlOrderBy = (ctx)=>{
                if (ctx.exception) return undefined;
                const operator = (0, (0, parcelRequire("jn8LC")).internalCreators).orderByOperator((0, (0, parcelRequire("c92ia")).getPositionFromToken)(ctx.ORDER().payload, ctx.BY().payload));
                const fields = ctx.jqlSearchSort().map((searchSortCtx)=>searchSortCtx.accept(this.searchSortVisitor)).filter((0, (0, parcelRequire("4UDBy")).notUndefined));
                return (0, (0, parcelRequire("jn8LC")).internalCreators).orderBy(fields, operator, (0, (0, parcelRequire("c92ia")).getPositionFromContext)(ctx));
            };
        }
    }
    class $c309e9b71b428845$var$SearchSortVisitor extends (0, (0, parcelRequire("c92ia")).JastBuildingVisitor) {
        constructor(...args){
            super(...args);
            this.fieldVisitor = new (0, (0, parcelRequire("cWl3X")).FieldVisitor)(this.tokens);
            this.visitJqlSearchSort = (ctx)=>{
                const fieldCtx = ctx.jqlField();
                if (fieldCtx.exception) return undefined;
                let direction;
                const desc = ctx.DESC();
                const asc = ctx.ASC();
                if (desc !== undefined) direction = (0, (0, parcelRequire("jn8LC")).internalCreators).orderByDirection((0, $bedc80c1e61c3512$export$2ea27ea5f2121899), (0, (0, parcelRequire("c92ia")).getPositionFromToken)(desc.payload));
                else if (asc !== undefined) direction = (0, (0, parcelRequire("jn8LC")).internalCreators).orderByDirection((0, $bedc80c1e61c3512$export$6d60017b9e092e73), (0, (0, parcelRequire("c92ia")).getPositionFromToken)(asc.payload));
                return (0, (0, parcelRequire("jn8LC")).internalCreators).orderByField(ctx.jqlField().accept(this.fieldVisitor), direction, (0, (0, parcelRequire("c92ia")).getPositionFromContext)(ctx));
            };
        }
    }
});
parcelRegister("4UDBy", function(module, exports) {
    $parcel$export(module.exports, "notUndefined", ()=>$de154d56cd7a78bc$export$9a1adf421b69c6a);
    function $de154d56cd7a78bc$export$9a1adf421b69c6a(x) {
        return x !== undefined;
    }
});
parcelRegister("cWl3X", function(module, exports) {
    $parcel$export(module.exports, "FieldVisitor", ()=>$9f901686e0fc4820$export$c6a85c4c3bf2317d);
    var $jn8LC;
    var $hHuh8;
    var $c92ia;
    var $8mU47;
    class $9f901686e0fc4820$export$c6a85c4c3bf2317d extends (0, (0, parcelRequire("c92ia")).JastBuildingVisitor) {
        constructor(...args){
            super(...args);
            this.stringVisitor = new (0, (0, parcelRequire("8mU47")).StringVisitor)(this.tokens);
            this.fieldPropertyVisitor = new $9f901686e0fc4820$var$FieldPropertyVisitor(this.tokens);
            this.visitJqlNumberField = (ctx)=>{
                const text = this.tokens.getText(ctx);
                return (0, (0, parcelRequire("jn8LC")).internalCreators).field(text, text, undefined, (0, (0, parcelRequire("c92ia")).getPositionFromContext)(ctx));
            };
            this.visitJqlNonNumberField = (ctx)=>{
                const stringContext = ctx.jqlString();
                const properties = ctx.jqlFieldProperty().map((context)=>context.accept(this.fieldPropertyVisitor));
                if (stringContext !== undefined) {
                    const stringValue = stringContext.accept(this.stringVisitor);
                    return (0, (0, parcelRequire("jn8LC")).internalCreators).field(stringValue.value, stringValue.text, properties, (0, (0, parcelRequire("c92ia")).getPositionFromContext)(ctx));
                }
                const text = this.tokens.getText(ctx);
                return (0, (0, parcelRequire("jn8LC")).internalCreators).field(text, text, properties, (0, (0, parcelRequire("c92ia")).getPositionFromContext)(ctx));
            };
        }
    }
    class $9f901686e0fc4820$var$FieldPropertyVisitor extends (0, (0, parcelRequire("c92ia")).JastBuildingVisitor) {
        constructor(...args){
            super(...args);
            this.argumentVisitor = new (0, (0, parcelRequire("hHuh8")).ArgumentVisitor)(this.tokens);
            this.propertyArgumentVisitor = new $9f901686e0fc4820$var$PropertyArgumentVisitor(this.tokens);
            this.visitJqlFieldProperty = (ctx)=>{
                const argumentContext = ctx.jqlArgument();
                const propertyArgumentContext = ctx.jqlPropertyArgument();
                const path = propertyArgumentContext.map((context)=>context.accept(this.propertyArgumentVisitor));
                return (0, (0, parcelRequire("jn8LC")).internalCreators).property(argumentContext && argumentContext.accept(this.argumentVisitor), path, (0, (0, parcelRequire("c92ia")).getPositionFromContext)(ctx));
            };
        }
    }
    class $9f901686e0fc4820$var$PropertyArgumentVisitor extends (0, (0, parcelRequire("c92ia")).JastBuildingVisitor) {
        constructor(...args){
            super(...args);
            this.argumentVisitor = new (0, (0, parcelRequire("hHuh8")).ArgumentVisitor)(this.tokens);
            this.visitJqlPropertyArgument = (ctx)=>{
                return ctx.jqlArgument().accept(this.argumentVisitor);
            };
        }
    }
});
parcelRegister("hHuh8", function(module, exports) {
    $parcel$export(module.exports, "ArgumentVisitor", ()=>$6a33ca7907a91bbe$export$46b5a1f6d962d533);
    var $jn8LC;
    var $c92ia;
    var $8mU47;
    class $6a33ca7907a91bbe$export$46b5a1f6d962d533 extends (0, (0, parcelRequire("c92ia")).JastBuildingVisitor) {
        constructor(...args){
            super(...args);
            this.stringVisitor = new (0, (0, parcelRequire("8mU47")).StringVisitor)(this.tokens);
            this.visitJqlArgument = (ctx)=>{
                const stringContext = ctx.jqlString();
                if (stringContext !== undefined) {
                    const stringValue = stringContext.accept(this.stringVisitor);
                    return (0, (0, parcelRequire("jn8LC")).internalCreators).argument(stringValue.value, stringValue.text, stringValue.position);
                } else {
                    const text = this.tokens.getText(ctx);
                    return (0, (0, parcelRequire("jn8LC")).internalCreators).argument(text, text, (0, (0, parcelRequire("c92ia")).getPositionFromContext)(ctx));
                }
            };
        }
    }
});
parcelRegister("8mU47", function(module, exports) {
    $parcel$export(module.exports, "StringVisitor", ()=>$a52eeb546e63ac21$export$617850cb96304515);
    var $c92ia;
    class $a52eeb546e63ac21$export$617850cb96304515 extends (0, (0, parcelRequire("c92ia")).JastBuildingVisitor) {
        constructor(...args){
            super(...args);
            this.visitJqlString = (ctx)=>{
                const text = this.tokens.getText(ctx);
                const position = (0, (0, parcelRequire("c92ia")).getPositionFromContext)(ctx);
                let value;
                if (ctx.QUOTE_STRING()) value = text.replace(/^"|"$/g, '').replace(/(?:\\(.))/g, '$1');
                else if (ctx.SQUOTE_STRING()) value = text.replace(/^'|'$/g, '').replace(/(?:\\(.))/g, '$1');
                else value = text;
                return {
                    text: text,
                    value: value,
                    position: position
                };
            };
        }
    }
});
parcelRegister("iz0qL", function(module, exports) {
    $parcel$export(module.exports, "WhereVisitor", ()=>$dfbe701fae5b041c$export$c573472f1d20e15d);
    var $jn8LC;
    var $4UDBy;
    var $c92ia;
    var $3cYsz;
    class $dfbe701fae5b041c$export$c573472f1d20e15d extends (0, (0, parcelRequire("c92ia")).JastBuildingVisitor) {
        constructor(...args){
            super(...args);
            this.terminalClauseVisitor = new (0, (0, parcelRequire("3cYsz")).TerminalClauseVisitor)(this.tokens);
            this.visitJqlWhere = (ctx)=>{
                return this.visitJqlOrClause(ctx.jqlOrClause());
            };
            this.visitJqlOrClause = (ctx)=>{
                const clauses = ctx.jqlAndClause().map((andClauseContext)=>andClauseContext.accept(this)).filter((0, (0, parcelRequire("4UDBy")).notUndefined));
                if (clauses.length > 1) {
                    const operator = (0, (0, parcelRequire("jn8LC")).internalCreators).compoundOperator((0, $c915714aa8f48e71$export$7b8f0a728d79a753), (0, (0, parcelRequire("c92ia")).getPositionsFromTerminalNodes)(ctx.OR()));
                    return (0, (0, parcelRequire("jn8LC")).internalCreators).compoundClause(operator, clauses, (0, (0, parcelRequire("c92ia")).getPositionFromContext)(ctx));
                }
                return clauses.length === 0 ? undefined : clauses[0];
            };
            this.visitJqlAndClause = (ctx)=>{
                const clauses = ctx.jqlNotClause().map((notClauseContext)=>notClauseContext.accept(this)).filter((0, (0, parcelRequire("4UDBy")).notUndefined));
                if (clauses.length > 1) {
                    const operator = (0, (0, parcelRequire("jn8LC")).internalCreators).compoundOperator((0, $c915714aa8f48e71$export$6d6d48d210d3ca97), (0, (0, parcelRequire("c92ia")).getPositionsFromTerminalNodes)(ctx.AND()));
                    return (0, (0, parcelRequire("jn8LC")).internalCreators).compoundClause(operator, clauses, (0, (0, parcelRequire("c92ia")).getPositionFromContext)(ctx));
                }
                return clauses.length === 0 ? undefined : clauses[0];
            };
            this.visitJqlNotClause = (ctx)=>{
                const notClauseContext = ctx.jqlNotClause();
                const subClauseContext = ctx.jqlSubClause();
                const terminalClauseContext = ctx.jqlTerminalClause();
                let clause;
                if (notClauseContext !== undefined) clause = notClauseContext.accept(this) || undefined;
                else if (subClauseContext !== undefined) clause = subClauseContext.accept(this) || undefined;
                else if (terminalClauseContext !== undefined) clause = terminalClauseContext.accept(this.terminalClauseVisitor);
                let notToken = ctx.NOT();
                notToken = notToken === undefined ? ctx.BANG() : notToken;
                if (notToken && clause) return (0, (0, parcelRequire("jn8LC")).internalCreators).notClause(clause, (0, (0, parcelRequire("jn8LC")).internalCreators).notClauseOperator((0, (0, parcelRequire("c92ia")).getPositionFromToken)(notToken.payload)), (0, (0, parcelRequire("c92ia")).getPositionFromContext)(ctx));
                return clause;
            };
            this.visitJqlSubClause = (ctx)=>{
                return this.visitJqlOrClause(ctx.jqlOrClause());
            };
        }
    }
});
parcelRegister("3cYsz", function(module, exports) {
    $parcel$export(module.exports, "TerminalClauseVisitor", ()=>$cb1ea5fc35e98d72$export$14576ae5bd1874a9);
    var $jn8LC;
    var $4UDBy;
    var $c92ia;
    var $cWl3X;
    var $jKLTS;
    var $fbCyO;
    var $7RpDb;
    class $cb1ea5fc35e98d72$export$14576ae5bd1874a9 extends (0, (0, parcelRequire("c92ia")).JastBuildingVisitor) {
        constructor(...args){
            super(...args);
            this.fieldVisitor = new (0, (0, parcelRequire("cWl3X")).FieldVisitor)(this.tokens);
            this.terminalClauseRhsVisitor = new $cb1ea5fc35e98d72$var$TerminalClauseRhsVisitor(this.tokens);
            this.visitJqlTerminalClause = (ctx)=>{
                const field = ctx.jqlField().accept(this.fieldVisitor);
                const { operator: operator, operand: operand, predicates: predicates } = ctx.jqlTerminalClauseRhs().accept(this.terminalClauseRhsVisitor);
                const position = (0, (0, parcelRequire("c92ia")).getPositionFromContext)(ctx);
                return (0, (0, parcelRequire("jn8LC")).internalCreators).terminalClause(field, operator, operand, predicates, position);
            };
        }
    }
    class $cb1ea5fc35e98d72$var$TerminalClauseRhsVisitor extends (0, (0, parcelRequire("c92ia")).JastBuildingVisitor) {
        constructor(...args){
            super(...args);
            this.operatorVisitor = new (0, (0, parcelRequire("fbCyO")).OperatorVisitor)(this.tokens);
            this.terminalClauseOperandVisitor = new $cb1ea5fc35e98d72$var$TerminalClauseOperandVisitor(this.tokens);
            this.predicateVisitor = new (0, (0, parcelRequire("7RpDb")).PredicateVisitor)(this.tokens);
            this.visitJqlEqualsClause = (ctx)=>{
                const operator = ctx.jqlEqualsOperator().accept(this.operatorVisitor);
                const operand = ctx.accept(this.terminalClauseOperandVisitor);
                return {
                    operator: operator,
                    operand: operand,
                    predicates: []
                };
            };
            this.visitJqlLikeClause = (ctx)=>{
                const operator = ctx.jqlLikeOperator().accept(this.operatorVisitor);
                const operand = ctx.accept(this.terminalClauseOperandVisitor);
                return {
                    operator: operator,
                    operand: operand,
                    predicates: []
                };
            };
            this.visitJqlComparisonClause = (ctx)=>{
                const operator = ctx.jqlComparisonOperator().accept(this.operatorVisitor);
                const operand = ctx.accept(this.terminalClauseOperandVisitor);
                return {
                    operator: operator,
                    operand: operand,
                    predicates: []
                };
            };
            this.visitJqlInClause = (ctx)=>{
                const operator = ctx.jqlInOperator().accept(this.operatorVisitor);
                const operand = ctx.accept(this.terminalClauseOperandVisitor);
                return {
                    operator: operator,
                    operand: operand,
                    predicates: []
                };
            };
            this.visitJqlIsClause = (ctx)=>{
                const operator = ctx.jqlIsOperator().accept(this.operatorVisitor);
                const operand = ctx.accept(this.terminalClauseOperandVisitor);
                return {
                    operator: operator,
                    operand: operand,
                    predicates: []
                };
            };
            this.visitJqlWasClause = (ctx)=>{
                const operator = ctx.jqlWasOperator().accept(this.operatorVisitor);
                const operand = ctx.accept(this.terminalClauseOperandVisitor);
                const predicates = ctx.jqlWasPredicate().map((predicate)=>predicate.accept(this.predicateVisitor)).filter((0, (0, parcelRequire("4UDBy")).notUndefined));
                return {
                    operator: operator,
                    operand: operand,
                    predicates: predicates
                };
            };
            this.visitJqlWasInClause = (ctx)=>{
                const operator = ctx.jqlWasInOperator().accept(this.operatorVisitor);
                const operand = ctx.accept(this.terminalClauseOperandVisitor);
                const predicates = ctx.jqlWasPredicate().map((predicate)=>predicate.accept(this.predicateVisitor)).filter((0, (0, parcelRequire("4UDBy")).notUndefined));
                return {
                    operator: operator,
                    operand: operand,
                    predicates: predicates
                };
            };
            this.visitJqlChangedClause = (ctx)=>{
                const operator = ctx.jqlChangedOperator().accept(this.operatorVisitor);
                const predicates = ctx.jqlChangedPredicate().map((predicate)=>predicate.accept(this.predicateVisitor)).filter((0, (0, parcelRequire("4UDBy")).notUndefined));
                return {
                    operator: operator,
                    operand: undefined,
                    predicates: predicates
                };
            };
            this.visitChildren = (node)=>{
                const operator = node.accept(this.operatorVisitor);
                return {
                    operator: operator,
                    operand: undefined,
                    predicates: []
                };
            };
        }
    }
    class $cb1ea5fc35e98d72$var$TerminalClauseOperandVisitor extends (0, (0, parcelRequire("c92ia")).JastBuildingVisitor) {
        constructor(...args){
            super(...args);
            this.operandVisitor = new (0, (0, parcelRequire("jKLTS")).OperandVisitor)(this.tokens);
            this.visitJqlEqualsClause = (ctx)=>{
                return this.getOperandForContexts([
                    ctx.jqlEmpty(),
                    ctx.jqlValue(),
                    ctx.jqlFunction()
                ]);
            };
            this.visitJqlLikeClause = (ctx)=>{
                return this.getOperandForContexts([
                    ctx.jqlEmpty(),
                    ctx.jqlValue(),
                    ctx.jqlFunction()
                ]);
            };
            this.visitJqlComparisonClause = (ctx)=>{
                return this.getOperandForContexts([
                    ctx.jqlValue(),
                    ctx.jqlFunction()
                ]);
            };
            this.visitJqlInClause = (ctx)=>{
                return this.getOperandForContexts([
                    ctx.jqlList(),
                    ctx.jqlFunction()
                ]);
            };
            this.visitJqlIsClause = (ctx)=>{
                return this.getOperandForContexts([
                    ctx.jqlEmpty()
                ]);
            };
            this.visitJqlWasClause = (ctx)=>{
                return this.getOperandForContexts([
                    ctx.jqlEmpty(),
                    ctx.jqlValue(),
                    ctx.jqlFunction()
                ]);
            };
            this.visitJqlWasInClause = (ctx)=>{
                return this.getOperandForContexts([
                    ctx.jqlList(),
                    ctx.jqlFunction()
                ]);
            };
            this.getOperandForContexts = (contexts)=>{
                const operandContext = contexts.find((0, (0, parcelRequire("4UDBy")).notUndefined));
                return operandContext?.accept(this.operandVisitor);
            };
        }
    }
});
parcelRegister("jKLTS", function(module, exports) {
    $parcel$export(module.exports, "OperandVisitor", ()=>$06ef9a425900f933$export$ef8ae1aa15d9c9af);
    var $jn8LC;
    var $4UDBy;
    var $hHuh8;
    var $c92ia;
    var $l7dSE;
    var $8mU47;
    class $06ef9a425900f933$export$ef8ae1aa15d9c9af extends (0, (0, parcelRequire("c92ia")).JastBuildingVisitor) {
        constructor(...args){
            super(...args);
            this.stringVisitor = new (0, (0, parcelRequire("8mU47")).StringVisitor)(this.tokens);
            this.numberVisitor = new (0, (0, parcelRequire("l7dSE")).NumberVisitor)(this.tokens);
            this.functionNameVisitor = new $06ef9a425900f933$var$FunctionNameVisitor(this.tokens);
            this.argumentListVisitor = new $06ef9a425900f933$var$ArgumentListVisitor(this.tokens);
            this.visitJqlOperand = (ctx)=>{
                const operandContext = [
                    ctx.jqlEmpty(),
                    ctx.jqlValue(),
                    ctx.jqlList(),
                    ctx.jqlFunction()
                ].find((0, (0, parcelRequire("4UDBy")).notUndefined));
                return operandContext?.accept(this);
            };
            this.visitJqlEmpty = (ctx)=>{
                if (ctx.exception) return undefined;
                return (0, (0, parcelRequire("jn8LC")).internalCreators).keywordOperand((0, $230aa818ebdf534b$export$1c46dca02aac24dd), (0, (0, parcelRequire("c92ia")).getPositionFromToken)(ctx.EMPTY().payload));
            };
            this.visitJqlValue = (ctx)=>{
                const stringContext = ctx.jqlString();
                if (stringContext !== undefined) {
                    const stringValue = stringContext.accept(this.stringVisitor);
                    return (0, (0, parcelRequire("jn8LC")).internalCreators).valueOperand(stringValue.value, stringValue.text, stringValue.position);
                }
                const numberContext = ctx.jqlNumber();
                if (numberContext !== undefined) return numberContext.accept(this.numberVisitor);
            };
            this.visitJqlList = (ctx)=>{
                const values = ctx.jqlOperand().map((operandCtx)=>operandCtx.accept(this)).filter((0, (0, parcelRequire("4UDBy")).notUndefined));
                return (0, (0, parcelRequire("jn8LC")).internalCreators).listOperand(values, (0, (0, parcelRequire("c92ia")).getPositionFromContext)(ctx));
            };
            this.visitJqlFunction = (ctx)=>{
                const argumentListContext = ctx.jqlArgumentList();
                return (0, (0, parcelRequire("jn8LC")).internalCreators).functionOperand(ctx.jqlFunctionName().accept(this.functionNameVisitor), argumentListContext === undefined ? [] : argumentListContext.accept(this.argumentListVisitor), (0, (0, parcelRequire("c92ia")).getPositionFromContext)(ctx));
            };
        }
    }
    class $06ef9a425900f933$var$FunctionNameVisitor extends (0, (0, parcelRequire("c92ia")).JastBuildingVisitor) {
        constructor(...args){
            super(...args);
            this.stringVisitor = new (0, (0, parcelRequire("8mU47")).StringVisitor)(this.tokens);
            this.visitJqlFunctionName = (ctx)=>{
                const stringContext = ctx.jqlString();
                if (stringContext !== undefined) {
                    const stringValue = stringContext.accept(this.stringVisitor);
                    return (0, (0, parcelRequire("jn8LC")).internalCreators).functionString(stringValue.value, stringValue.text, stringValue.position);
                } else {
                    const text = this.tokens.getText(ctx);
                    return (0, (0, parcelRequire("jn8LC")).internalCreators).functionString(text, text, (0, (0, parcelRequire("c92ia")).getPositionFromContext)(ctx));
                }
            };
        }
    }
    class $06ef9a425900f933$var$ArgumentListVisitor extends (0, (0, parcelRequire("c92ia")).JastBuildingVisitor) {
        constructor(...args){
            super(...args);
            this.argumentVisitor = new (0, (0, parcelRequire("hHuh8")).ArgumentVisitor)(this.tokens);
            this.visitJqlArgumentList = (ctx)=>{
                return ctx.jqlArgument().map((argumentCtx)=>argumentCtx.accept(this.argumentVisitor));
            };
        }
    }
});
parcelRegister("l7dSE", function(module, exports) {
    $parcel$export(module.exports, "NumberVisitor", ()=>$b49ad822e1e8e7cb$export$a55432f0884633e4);
    var $jn8LC;
    var $c92ia;
    class $b49ad822e1e8e7cb$export$a55432f0884633e4 extends (0, (0, parcelRequire("c92ia")).JastBuildingVisitor) {
        constructor(...args){
            super(...args);
            this.visitJqlNumber = (ctx)=>{
                const text = this.tokens.getText(ctx);
                return (0, (0, parcelRequire("jn8LC")).internalCreators).valueOperand(text, text, (0, (0, parcelRequire("c92ia")).getPositionFromContext)(ctx));
            };
        }
    }
});
parcelRegister("fbCyO", function(module, exports) {
    $parcel$export(module.exports, "OperatorVisitor", ()=>$b9054c7051da8eb0$export$e56f89ba95b51d2a);
    var $jn8LC;
    var $gR9a3;
    var $c92ia;
    class $b9054c7051da8eb0$export$e56f89ba95b51d2a extends (0, (0, parcelRequire("c92ia")).JastBuildingVisitor) {
        visitJqlEqualsOperator(ctx) {
            const text = this.tokens.getText(ctx);
            if (!(0, (0, parcelRequire("gR9a3")).isEqualsOperator)(text)) throw new Error(`'${text}' does not match any of the recognised equals operators`);
            return (0, (0, parcelRequire("jn8LC")).internalCreators).operator(text, text, (0, (0, parcelRequire("c92ia")).getPositionFromContext)(ctx));
        }
        visitJqlLikeOperator(ctx) {
            const text = this.tokens.getText(ctx);
            if (!(0, (0, parcelRequire("gR9a3")).isLikeOperator)(text)) throw new Error(`'${text}' does not match any of the recognised like operators`);
            return (0, (0, parcelRequire("jn8LC")).internalCreators).operator(text, text, (0, (0, parcelRequire("c92ia")).getPositionFromContext)(ctx));
        }
        visitJqlComparisonOperator(ctx) {
            const text = this.tokens.getText(ctx);
            if (!(0, (0, parcelRequire("gR9a3")).isComparisonOperator)(text)) throw new Error(`'${text}' does not match any of the recognised comparison operators`);
            return (0, (0, parcelRequire("jn8LC")).internalCreators).operator(text, text, (0, (0, parcelRequire("c92ia")).getPositionFromContext)(ctx));
        }
        visitJqlInOperator(ctx) {
            const text = this.tokens.getText(ctx);
            const value = (0, (0, parcelRequire("c92ia")).normalizeText)(text);
            if (!(0, (0, parcelRequire("gR9a3")).isInOperator)(value)) return undefined;
            return (0, (0, parcelRequire("jn8LC")).internalCreators).operator(value, text, (0, (0, parcelRequire("c92ia")).getPositionFromContext)(ctx));
        }
        visitJqlIsOperator(ctx) {
            const text = this.tokens.getText(ctx);
            const value = (0, (0, parcelRequire("c92ia")).normalizeText)(text);
            if (!(0, (0, parcelRequire("gR9a3")).isIsOperator)(value)) throw new Error(`'${text}' does not match any of the recognised is operators`);
            return (0, (0, parcelRequire("jn8LC")).internalCreators).operator(value, text, (0, (0, parcelRequire("c92ia")).getPositionFromContext)(ctx));
        }
        visitJqlWasOperator(ctx) {
            const text = this.tokens.getText(ctx);
            const value = (0, (0, parcelRequire("c92ia")).normalizeText)(text);
            if (!(0, (0, parcelRequire("gR9a3")).isWasOperator)(value)) throw new Error(`'${text}' does not match any of the recognised was operators`);
            return (0, (0, parcelRequire("jn8LC")).internalCreators).operator(value, text, (0, (0, parcelRequire("c92ia")).getPositionFromContext)(ctx));
        }
        visitJqlWasInOperator(ctx) {
            const text = this.tokens.getText(ctx);
            const value = (0, (0, parcelRequire("c92ia")).normalizeText)(text);
            if (!(0, (0, parcelRequire("gR9a3")).isWasInOperator)(value)) throw new Error(`'${text}' does not match any of the recognised was in operators`);
            return (0, (0, parcelRequire("jn8LC")).internalCreators).operator(value, text, (0, (0, parcelRequire("c92ia")).getPositionFromContext)(ctx));
        }
        visitJqlChangedOperator(ctx) {
            const text = this.tokens.getText(ctx);
            const value = (0, (0, parcelRequire("c92ia")).normalizeText)(text);
            if (!(0, (0, parcelRequire("gR9a3")).isChangedOperator)(value)) throw new Error(`'${text}' does not match any of the recognised changed operators`);
            return (0, (0, parcelRequire("jn8LC")).internalCreators).operator(value, text, (0, (0, parcelRequire("c92ia")).getPositionFromContext)(ctx));
        }
        constructor(...args){
            super(...args);
            this.visitChildren = (node)=>{
                const { sourceInterval: sourceInterval } = node;
                const text = this.tokens.getText(sourceInterval);
                if (text) {
                    const value = (0, (0, parcelRequire("c92ia")).normalizeText)(text);
                    const { a: startIndex, b: stopIndex } = sourceInterval;
                    const startToken = this.tokens.get(startIndex);
                    const stopToken = this.tokens.get(stopIndex);
                    const position = (0, (0, parcelRequire("c92ia")).getPositionFromToken)(startToken, stopToken);
                    if ((0, (0, parcelRequire("gR9a3")).isOperator)(value)) return (0, (0, parcelRequire("jn8LC")).internalCreators).operator(value, text, position);
                }
            };
        }
    }
});
parcelRegister("gR9a3", function(module, exports) {
    $parcel$export(module.exports, "isOperator", ()=>$bd0f688c6baddcca$export$4e40859592ee7ac2);
    $parcel$export(module.exports, "isEqualsOperator", ()=>$bd0f688c6baddcca$export$6d0fc196fa8a1673);
    $parcel$export(module.exports, "isLikeOperator", ()=>$bd0f688c6baddcca$export$ad91b6d6a89cb64e);
    $parcel$export(module.exports, "isComparisonOperator", ()=>$bd0f688c6baddcca$export$4477c442bd5c2a6d);
    $parcel$export(module.exports, "isInOperator", ()=>$bd0f688c6baddcca$export$c5e1cdef30e30bff);
    $parcel$export(module.exports, "isIsOperator", ()=>$bd0f688c6baddcca$export$ccc3334744e395c7);
    $parcel$export(module.exports, "isWasOperator", ()=>$bd0f688c6baddcca$export$2b1c5d7e7856f91d);
    $parcel$export(module.exports, "isWasInOperator", ()=>$bd0f688c6baddcca$export$55d8c9b20d99509f);
    $parcel$export(module.exports, "isChangedOperator", ()=>$bd0f688c6baddcca$export$b65d23d23ade534b);
    $parcel$export(module.exports, "isListOperator", ()=>$bd0f688c6baddcca$export$b09522e4061bbdd6);
    var $3tbwt;
    const $bd0f688c6baddcca$export$4e40859592ee7ac2 = (operator)=>(0, (0, parcelRequire("3tbwt")).OPERATORS).includes(operator);
    const $bd0f688c6baddcca$export$6d0fc196fa8a1673 = (operator)=>(0, (0, parcelRequire("3tbwt")).EQUALS_OPERATORS).includes(operator);
    const $bd0f688c6baddcca$export$ad91b6d6a89cb64e = (operator)=>(0, (0, parcelRequire("3tbwt")).LIKE_OPERATORS).includes(operator);
    const $bd0f688c6baddcca$export$4477c442bd5c2a6d = (operator)=>(0, (0, parcelRequire("3tbwt")).COMPARISON_OPERATORS).includes(operator);
    const $bd0f688c6baddcca$export$c5e1cdef30e30bff = (operator)=>(0, (0, parcelRequire("3tbwt")).IN_OPERATORS).includes(operator);
    const $bd0f688c6baddcca$export$ccc3334744e395c7 = (operator)=>(0, (0, parcelRequire("3tbwt")).IS_OPERATORS).includes(operator);
    const $bd0f688c6baddcca$export$2b1c5d7e7856f91d = (operator)=>(0, (0, parcelRequire("3tbwt")).WAS_OPERATORS).includes(operator);
    const $bd0f688c6baddcca$export$55d8c9b20d99509f = (operator)=>(0, (0, parcelRequire("3tbwt")).WAS_IN_OPERATORS).includes(operator);
    const $bd0f688c6baddcca$export$b65d23d23ade534b = (operator)=>(0, (0, parcelRequire("3tbwt")).CHANGED_OPERATORS).includes(operator);
    const $bd0f688c6baddcca$export$b09522e4061bbdd6 = (operator)=>(0, (0, parcelRequire("3tbwt")).LIST_OPERATORS).includes(operator);
});
parcelRegister("7RpDb", function(module, exports) {
    $parcel$export(module.exports, "PredicateVisitor", ()=>$762442cee6f3ea95$export$33bb52a35c693109);
    var $jn8LC;
    var $fChkh;
    var $4UDBy;
    var $c92ia;
    var $jKLTS;
    class $762442cee6f3ea95$export$33bb52a35c693109 extends (0, (0, parcelRequire("c92ia")).JastBuildingVisitor) {
        constructor(...args){
            super(...args);
            this.predicateOperatorVisitor = new $762442cee6f3ea95$var$PredicateOperatorVisitor(this.tokens);
            this.predicateOperandVisitor = new $762442cee6f3ea95$var$PredicateOperandVisitor(this.tokens);
            this.visitJqlWasPredicate = (ctx)=>{
                const operator = this.getOperatorForContexts([
                    ctx.jqlDatePredicateOperator(),
                    ctx.jqlDateRangePredicateOperator(),
                    ctx.jqlUserPredicateOperator()
                ]);
                const operand = ctx.jqlPredicateOperand().accept(this.predicateOperandVisitor);
                const position = (0, (0, parcelRequire("c92ia")).getPositionFromContext)(ctx);
                return (0, (0, parcelRequire("jn8LC")).internalCreators).predicate(operator, operand, position);
            };
            this.visitJqlChangedPredicate = (ctx)=>{
                const operator = this.getOperatorForContexts([
                    ctx.jqlDatePredicateOperator(),
                    ctx.jqlDateRangePredicateOperator(),
                    ctx.jqlUserPredicateOperator(),
                    ctx.jqlValuePredicateOperator()
                ]);
                const operand = ctx.jqlPredicateOperand().accept(this.predicateOperandVisitor);
                const position = (0, (0, parcelRequire("c92ia")).getPositionFromContext)(ctx);
                return (0, (0, parcelRequire("jn8LC")).internalCreators).predicate(operator, operand, position);
            };
            this.getOperatorForContexts = (contexts)=>{
                const operatorContext = contexts.find((0, (0, parcelRequire("4UDBy")).notUndefined));
                if (operatorContext !== undefined) return operatorContext.accept(this.predicateOperatorVisitor);
                else throw new Error('Undefined predicate operator context');
            };
        }
    }
    class $762442cee6f3ea95$var$PredicateOperatorVisitor extends (0, (0, parcelRequire("c92ia")).JastBuildingVisitor) {
        constructor(...args){
            super(...args);
            this.visitJqlDatePredicateOperator = (ctx)=>{
                return this.getPredicateOperator(ctx);
            };
            this.visitJqlDateRangePredicateOperator = (ctx)=>{
                return this.getPredicateOperator(ctx);
            };
            this.visitJqlUserPredicateOperator = (ctx)=>{
                return this.getPredicateOperator(ctx);
            };
            this.visitJqlValuePredicateOperator = (ctx)=>{
                return this.getPredicateOperator(ctx);
            };
            this.getPredicateOperator = (ctx)=>{
                const text = this.tokens.getText(ctx);
                const value = text.toLowerCase().replace(/\s+/g, ' ');
                if (!(0, (0, parcelRequire("fChkh")).isPredicateOperator)(value)) throw new Error(`Found a history predicate operator which does not map to a changed time predicate operator in the ast: ${text}`);
                return (0, (0, parcelRequire("jn8LC")).internalCreators).predicateOperator(value, text, (0, (0, parcelRequire("c92ia")).getPositionFromContext)(ctx));
            };
        }
    }
    class $762442cee6f3ea95$var$PredicateOperandVisitor extends (0, (0, parcelRequire("c92ia")).JastBuildingVisitor) {
        constructor(...args){
            super(...args);
            this.operandVisitor = new (0, (0, parcelRequire("jKLTS")).OperandVisitor)(this.tokens);
            this.visitJqlPredicateOperand = (ctx)=>{
                return ctx.jqlOperand().accept(this.operandVisitor);
            };
        }
    }
});
parcelRegister("fChkh", function(module, exports) {
    $parcel$export(module.exports, "isPredicateOperator", ()=>$3e4e9720d8ed3215$export$188978ad94919403);
    var $g6XTc;
    const $3e4e9720d8ed3215$export$188978ad94919403 = (operator)=>(0, (0, parcelRequire("g6XTc")).PREDICATE_OPERATORS).includes(operator);
});
parcelRegister("g6XTc", function(module, exports) {
    $parcel$export(module.exports, "PREDICATE_OPERATORS", ()=>$e4aafdb069c79359$export$e200440af9f1d9f);
    const $e4aafdb069c79359$export$3d56e2ae1b4bbbf9 = 'after';
    const $e4aafdb069c79359$export$f0a816341603bb63 = 'before';
    const $e4aafdb069c79359$export$cdc81c84f768d513 = 'by';
    const $e4aafdb069c79359$export$8a5280c65e704c3d = 'during';
    const $e4aafdb069c79359$export$71f882dcac65f97a = 'from';
    const $e4aafdb069c79359$export$5685a35c6b0a7ee8 = 'on';
    const $e4aafdb069c79359$export$5a83c4789e531a = 'to';
    const $e4aafdb069c79359$export$e200440af9f1d9f = [
        $e4aafdb069c79359$export$3d56e2ae1b4bbbf9,
        $e4aafdb069c79359$export$f0a816341603bb63,
        $e4aafdb069c79359$export$cdc81c84f768d513,
        $e4aafdb069c79359$export$8a5280c65e704c3d,
        $e4aafdb069c79359$export$71f882dcac65f97a,
        $e4aafdb069c79359$export$5685a35c6b0a7ee8,
        $e4aafdb069c79359$export$5a83c4789e531a
    ];
});
parcelRegister("eCBf9", function(module, exports) {
    $parcel$export(module.exports, "MutationError", ()=>$5fe48c9a5d56428c$export$10c788363424e94e);
    const $5fe48c9a5d56428c$export$bd0568a021288e41 = 'MutationError';
    class $5fe48c9a5d56428c$export$10c788363424e94e extends Error {
        constructor(payload){
            super(payload.message ?? undefined);
            this.message = payload.message ?? '';
            this.extensions = payload.extensions;
            this.statusCode = payload.extensions?.statusCode ?? null;
        }
    }
});
parcelRegister("fqCXW", function(module, exports) {
    $parcel$export(module.exports, "CREATE_ISSUE_MUTATION", ()=>$818953c4eb0a218e$export$f5c1cac020b22be4);
    $parcel$export(module.exports, "ISSUE_REFETCH_QUERY", ()=>$818953c4eb0a218e$export$834c81726d4c51eb);
    var $5cllN;
    var $kkA5E;
    var $6qNs0;
    const $818953c4eb0a218e$var$CREATED_ITEM_FRAGMENT = (0, (0, parcelRequire("5cllN")).default)`
fragment CreatedTimelineItemFragment on JiraWorkManagementViewItem {
    id
    issueId
    childSummary {
        hasChildren
    }
    issueLinks(first: 10) {
        edges {
            node {
                issue {
                    issueId
                }
                issueLinkId
                relationName
                direction
            }
        }
    }
    ... JWMTimelineViewItem
}
${(0, (0, parcelRequire("6qNs0")).TIMELINE_VIEW_ITEM_FRAGMENT)}
`;
    const $818953c4eb0a218e$export$f5c1cac020b22be4 = (0, (0, parcelRequire("5cllN")).default)`
mutation JWMTimelineInlineCreateIssue($input: JiraCreateIssueInput!, $fieldIds: [String]!) {
    createJiraBusinessIssue(input: $input, fieldIdsToReturn: $fieldIds) {
        item {
            ...CreatedTimelineItemFragment
        }
        ...CreateIssueFragment
    }
}
${(0, (0, parcelRequire("kkA5E")).CREATE_ISSUE_FRAGMENT)}
${$818953c4eb0a218e$var$CREATED_ITEM_FRAGMENT}
`;
    const $818953c4eb0a218e$export$834c81726d4c51eb = (0, (0, parcelRequire("5cllN")).default)`
query JWMTimelineInlineCreateRefetchQuery($cloudId: ID!, $jql: String!, $fieldIds: [String]!, $first: Int) {
    jira {
        jwmViewItems(cloudId: $cloudId, jql: $jql, first: $first) {
            ... on JiraWorkManagementViewItemConnection {
                edges {
                    node {
                        ...CreatedTimelineItemFragment
                    }
                }
            }
        }
    }
}
${$818953c4eb0a218e$var$CREATED_ITEM_FRAGMENT}
`;
});
parcelRegister("kkA5E", function(module, exports) {
    $parcel$export(module.exports, "CREATE_ISSUE_FRAGMENT", ()=>$22484cc131c517f0$export$47232071d0e9dfb);
    var $5cllN;
    const $22484cc131c517f0$export$47232071d0e9dfb = (0, (0, parcelRequire("5cllN")).default)`
fragment CreateIssueFragment on JiraBusinessCreateIssuePayload {
  itemIdentifiers: item @connection (key: "issue-create-ids") {
    issueId
    issueKey: fieldsByIdOrAlias(idsOrAliases: ["issuekey"]) {
      ... on JiraSingleLineTextField {
          text
      }
    }
  }
  success
  errors {
    message
    extensions {
      ...on MutationErrorExtension {
        statusCode
        errorType
      }
    }
  }
}`;
});
parcelRegister("6qNs0", function(module, exports) {
    $parcel$export(module.exports, "TIMELINE_VIEW_ITEM_FRAGMENT", ()=>$0bae08afdfc8f60e$export$b3df6971b0b88fa5);
    $parcel$export(module.exports, "TIMELINE_VIEW_ITEMS_QUERY", ()=>$0bae08afdfc8f60e$export$bd866b553c924711);
    var $5cllN;
    const $0bae08afdfc8f60e$export$b3df6971b0b88fa5 = (0, (0, parcelRequire("5cllN")).default)`
    fragment JWMTimelineViewItem on JiraWorkManagementViewItem {
        fields: fieldsByIdOrAlias(idsOrAliases: $fieldIds, ignoreMissingFields: true) @connection (key: "fields") {
            id
            fieldId
            aliasFieldId
            type
            ... on JiraSingleLineTextField {
                text
            }
            ... on JiraStatusField {
                status {
                    name
                    statusId
                    statusCategory {
                        statusCategoryId
                    }
                }
            }
            ... on JiraIssueTypeField {
                issueType {
                    issueTypeId
                    name
                    avatar {
                        medium
                    }
                    hierarchy {
                        level
                    }
                }
            }
            ... on JiraSingleSelectUserPickerField {
                user {
                    accountId
                    picture
                    name
                }
            }
            ... on JiraDatePickerField {
                date
            }
            ... on JiraParentIssueField {
                parentIssue {
                    issueId
                    key
                    rankField: fieldsByIdOrAlias(idsOrAliases: ["rank"], ignoreMissingFields: true) @connection (key: "parentRankField") {
						... on JiraSingleLineTextField {
							text
						}
					}
                }
            }
        }
    }
`;
    const $0bae08afdfc8f60e$export$bd866b553c924711 = (0, (0, parcelRequire("5cllN")).default)`
    query JWMTimelineViewItems ($cloudId: ID!, $jql: String!, $includeDoneItems: Boolean!, $fieldIds: [String]!, $first: Int, $after: String) {
        jira {
            list: jwmViewItems(
                cloudId: $cloudId,
                jql: $jql,
                first: $first,
                after: $after,
                ) @connection (key: "timelineList", filter:["jql"]) {
                ... on JiraWorkManagementViewItemConnection {
                    edges {
                        node {
                            id
                            issueId
                            childSummary(includeDone: $includeDoneItems) {
                                hasChildren
                            }
                            issueLinks(first: 10) {
                                edges {
                                    node {
                                        issue {
                                            issueId
                                        }
                                        issueLinkId
                                        relationName
                                        direction
                                    }
                                }
                            }
                            ... JWMTimelineViewItem
                        }
                    }
                    pageInfo {
                        hasNextPage
                        endCursor
                    }
                }
            }
        }
    }
    ${$0bae08afdfc8f60e$export$b3df6971b0b88fa5}
`;
});
parcelRegister("4GbhN", function(module, exports) {
    $parcel$export(module.exports, "createOptimisticIssue", ()=>$679b3cf3ca7a825a$export$4c62dfdc23f8a071);
    $parcel$export(module.exports, "buildInput", ()=>$679b3cf3ca7a825a$export$f4db126e014728a3);
    var $deqCE;
    var $5fc53;
    const $679b3cf3ca7a825a$var$RANK_BEFORE_ID = 'rankBefore';
    const $679b3cf3ca7a825a$var$RANK_AFTER_ID = 'rankAfter';
    const $679b3cf3ca7a825a$export$4c62dfdc23f8a071 = ({ issueId: issueId, summary: summary, issueType: issueType, rank: rank, status: status })=>({
            id: `${0, (0, parcelRequire("deqCE")).OPTIMISTIC_ID_PREFIX}${issueId}`,
            issueId: issueId,
            __typename: 'JiraWorkManagementViewItem',
            childSummary: {
                __typename: 'JiraWorkManagementChildSummary',
                hasChildren: false
            },
            issueLinks: {
                edges: [],
                __typename: 'JiraIssueLinkConnection'
            },
            fields: [
                {
                    aliasFieldId: null,
                    fieldId: 'summary',
                    id: `${(0, (0, parcelRequire("deqCE")).OPTIMISTIC_ID_PREFIX)}${issueId}${(0, (0, parcelRequire("5fc53")).SUMMARY_TYPE)}`,
                    text: summary ?? null,
                    type: (0, (0, parcelRequire("5fc53")).SUMMARY_TYPE),
                    __typename: (0, (0, parcelRequire("5fc53")).TEXT_GQL_FIELD)
                },
                {
                    fieldId: 'issuekey',
                    aliasFieldId: null,
                    id: `${(0, (0, parcelRequire("deqCE")).OPTIMISTIC_ID_PREFIX)}${issueId}${(0, (0, parcelRequire("5fc53")).ISSUE_KEY_TYPE)}`,
                    type: (0, (0, parcelRequire("5fc53")).ISSUE_KEY_TYPE),
                    text: '',
                    __typename: (0, (0, parcelRequire("5fc53")).TEXT_GQL_FIELD)
                },
                {
                    fieldId: 'issuetype',
                    aliasFieldId: null,
                    id: `${(0, (0, parcelRequire("deqCE")).OPTIMISTIC_ID_PREFIX)}${issueId}issuetype`,
                    type: 'issuetype',
                    issueType: {
                        __typename: 'JiraIssueType',
                        issueTypeId: issueType.id,
                        name: issueType.name,
                        hierarchy: {
                            level: issueType.hierarchyLevel,
                            __typename: 'JiraIssueTypeHierarchyLevel'
                        },
                        avatar: {
                            __typename: 'JiraAvatar',
                            medium: issueType.avatarUrl
                        }
                    },
                    __typename: (0, (0, parcelRequire("5fc53")).ISSUE_TYPE_GQL_FIELD)
                },
                {
                    fieldId: 'customfield_10019',
                    id: `${(0, (0, parcelRequire("deqCE")).OPTIMISTIC_ID_PREFIX)}${issueId}${(0, (0, parcelRequire("5fc53")).RANK_CF_TYPE)}`,
                    aliasFieldId: 'rank',
                    type: (0, (0, parcelRequire("5fc53")).RANK_CF_TYPE),
                    text: rank ?? 'z',
                    __typename: (0, (0, parcelRequire("5fc53")).TEXT_GQL_FIELD)
                },
                {
                    fieldId: 'status',
                    aliasFieldId: null,
                    id: `${(0, (0, parcelRequire("deqCE")).OPTIMISTIC_ID_PREFIX)}${issueId}${(0, (0, parcelRequire("5fc53")).STATUS_TYPE)}`,
                    type: (0, (0, parcelRequire("5fc53")).STATUS_TYPE),
                    status: {
                        name: status?.name ?? 'To Do',
                        statusId: status?.statusId ?? '0',
                        statusCategory: {
                            statusCategoryId: String(status?.statusCategoryId ?? 2),
                            __typename: 'JiraStatusCategory'
                        },
                        __typename: 'JiraStatus'
                    },
                    __typename: (0, (0, parcelRequire("5fc53")).STATUS_GQL_FIELD)
                },
                {
                    fieldId: 'duedate',
                    aliasFieldId: null,
                    id: `${(0, (0, parcelRequire("deqCE")).OPTIMISTIC_ID_PREFIX)}${issueId}${(0, (0, parcelRequire("5fc53")).DUE_DATE_TYPE)}`,
                    type: (0, (0, parcelRequire("5fc53")).DUE_DATE_TYPE),
                    date: null,
                    __typename: (0, (0, parcelRequire("5fc53")).DATE_PICKER_GQL_FIELD)
                },
                {
                    fieldId: 'assignee',
                    aliasFieldId: null,
                    id: `${(0, (0, parcelRequire("deqCE")).OPTIMISTIC_ID_PREFIX)}${issueId}${(0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE)}`,
                    type: (0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE),
                    user: null,
                    __typename: (0, (0, parcelRequire("5fc53")).USER_PICKER_GQL_FIELD)
                },
                {
                    fieldId: 'customfield_10015',
                    aliasFieldId: 'startdate',
                    id: `${(0, (0, parcelRequire("deqCE")).OPTIMISTIC_ID_PREFIX)}${issueId}${(0, (0, parcelRequire("5fc53")).DATE_CF_TYPE)}`,
                    type: (0, (0, parcelRequire("5fc53")).DATE_CF_TYPE),
                    date: null,
                    __typename: (0, (0, parcelRequire("5fc53")).DATE_PICKER_GQL_FIELD)
                }
            ]
        });
    const $679b3cf3ca7a825a$export$f4db126e014728a3 = (input)=>{
        const singleLineTextFields = [
            {
                fieldId: (0, (0, parcelRequire("5fc53")).SUMMARY_TYPE),
                text: input.summary
            }
        ];
        const fields = {
            singleLineTextFields: singleLineTextFields,
            ...input.parentIssueId && {
                parentField: {
                    issueId: input.parentIssueId
                }
            }
        };
        const rank = {
            ...input.rankBefore && {
                before: {
                    id: $679b3cf3ca7a825a$var$RANK_BEFORE_ID,
                    issueId: input.rankBefore.issueId
                }
            },
            ...input.rankAfter && {
                after: {
                    id: $679b3cf3ca7a825a$var$RANK_AFTER_ID,
                    issueId: input.rankAfter.issueId
                }
            }
        };
        const result = {
            projectId: input.projectId,
            issueType: input.issueType.id,
            fields: fields,
            rank: rank
        };
        return result;
    };
});
parcelRegister("deqCE", function(module, exports) {
    $parcel$export(module.exports, "OPTIMISTIC_ID_PREFIX", ()=>$13edc00a14335139$export$a76c6afcd77fffd8);
    $parcel$export(module.exports, "OPTIMISTIC_ISSUE_ID", ()=>$13edc00a14335139$export$2bc461aaabcabfc9);
    $parcel$export(module.exports, "ROOT_LEVEL", ()=>$13edc00a14335139$export$d24bbd23c8a5d65e);
    $parcel$export(module.exports, "GROUP_ITEM_PREFIX", ()=>$13edc00a14335139$export$b29b9e70f9850100);
    const $13edc00a14335139$export$a76c6afcd77fffd8 = '-optimistic';
    const $13edc00a14335139$export$2bc461aaabcabfc9 = -1;
    const $13edc00a14335139$export$d24bbd23c8a5d65e = 'rootLevel';
    const $13edc00a14335139$export$b29b9e70f9850100 = 'GROUP_BY';
});
parcelRegister("k91Ah", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ca1439bbc073c02b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $7NUKB;
    var $hE5wF;
    var $e21nk;
    var $1T2vX;
    var $9pdbW;
    var $cm8b5;
    var $kRkJF;
    var $exeAk;
    var $3kVj2;
    var $ksKCJ;
    var $fel5A;
    var $34tvt;
    var $8HvEs;
    var $7Wnap;
    var $7yduy;
    var $4R6GH;
    var $koVbs;
    var $2gCtH;
    var $dAmbh;
    var $g5X3G;
    var $lS7Bl;
    var $iZN6h;
    var $g3prf;
    var $fMv2d;
    var $l8ruj;
    var $dCm1o;
    var $ieDtd;
    var $gNAqw;
    var $fWZbP;
    var $dadh5;
    var $1bZXb;
    var $1o48H;
    var $qFFvI;
    var $hLy6t;
    var $afmVm;
    var $1lN06;
    var $hZlg3;
    var $b4BqL;
    var $jxKr9;
    var $iNLbM;
    var $kjQs8;
    var $gEkZt;
    var $dnpKx;
    var $7bPJP;
    var $gW8GI;
    var $gSLj9;
    var $bZkBl;
    var $34FeG;
    var $kHUUS;
    var $k09y7;
    var $3aigE;
    var $lypli;
    var $jxXX4;
    var $8LDjp;
    var $hB1Xb;
    var $d8IhD;
    var $lwgY1;
    var $iIo17;
    var $5V7mf;
    var $kxC7J;
    var $dupdF;
    var $9jHuQ;
    var $ft7xI;
    var $6El6u;
    var $iQqkW;
    const $ca1439bbc073c02b$var$getTimelineRenderers = ({ childrenQueryData: childrenQueryData = {}, dependencies: dependencies, hasScheduleIssues: hasScheduleIssues, interactiveChartItems: interactiveChartItems, isExportTable: isExportTable, issuesMap: issuesMap, items: items, onCreateClick: onCreateClick, onItemUpdate: onItemUpdate, onJiraItemUpdate: onJiraItemUpdate, setInfiniteScrollerRef: setInfiniteScrollerRef, setSelectedIssueKey: setSelectedIssueKey, updateIssueParent: updateIssueParent })=>{
        if (false) return {};
        return {
            renderListItemMenuOption: (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iIo17")).default), {
                    ...props,
                    updateIssueParent: updateIssueParent,
                    onItemUpdate: onJiraItemUpdate
                }),
            renderListItemModal: (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5V7mf")).default), {
                    ...props,
                    onItemUpdate: onJiraItemUpdate
                }),
            renderListHeaderItem: ({ id: id })=>id === (0, (0, parcelRequire("iZN6h")).DEFAULT_HEADER_ROW_ID) ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d8IhD")).ListHeader), null) : null,
            renderListItemContent: ({ id: id }, state)=>{
                if ((0, (0, parcelRequire("hLy6t")).isItemSkeleton)(id)) return ((0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fWZbP")).LoadingItem), {
                    "data-testid": "business-timeline.ui.timeline-view.loading-icon"
                }));
                const issue = issuesMap.get(id);
                if (!issue) return null;
                const { summary: summary, ...issueProps } = issue;
                const isFirstItem = id === issuesMap.values().next().value?.issueId;
                const isLastItem = id === Array.from(issuesMap.values()).pop()?.issueId;
                if (state?.isVirtual) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lS7Bl")).RoadmapListItemContentLite), {
                    title: summary || '',
                    iconUrl: issue.issueType.iconUrl,
                    itemKey: issue.key
                });
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lwgY1")).ListItemContent), {
                    isFirstItem: isFirstItem,
                    isLastItem: isLastItem,
                    title: summary,
                    issue: issueProps,
                    setSelectedIssueKey: setSelectedIssueKey,
                    onCreateClick: onCreateClick,
                    setInfiniteScrollerRef: setInfiniteScrollerRef
                });
            },
            renderListItemCreate: ({ anchorId: anchorId, canCreateChildOverride: canCreateChildOverride })=>{
                if (!anchorId && !canCreateChildOverride) return null;
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6El6u")).TimelineTableInlineCreate), {
                    childrenQueryData: childrenQueryData,
                    issuesMap: issuesMap,
                    items: items
                });
            },
            renderChartItemContent: ({ id: id }, state)=>{
                if ((0, (0, parcelRequire("hLy6t")).isItemSkeleton)(id)) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kHUUS")).ChartItemContentSkeleton), null);
                const issue = issuesMap.get(id);
                if (!issue) return null;
                const interactiveItem = interactiveChartItems.find((item)=>item.id === id);
                if (!interactiveItem) return null;
                if (state?.isVirtual) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("34FeG")).ChartItemContentLite), {
                    issue: issue,
                    startDate: interactiveItem.startDate,
                    dueDate: interactiveItem.dueDate,
                    level: interactiveItem.level
                });
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k09y7")).ChartItemContent), {
                    dueDate: interactiveItem.dueDate,
                    isExportTable: isExportTable,
                    isHovered: Boolean(state?.isHovered),
                    isReadOnly: !hasScheduleIssues,
                    issue: issue,
                    level: interactiveItem.level,
                    onItemUpdate: onItemUpdate,
                    placeholder: interactiveItem.placeholder,
                    setSelectedIssueKey: setSelectedIssueKey,
                    startDate: interactiveItem.startDate
                });
            },
            renderChartTimelineOverlay: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lypli")).ChartTimelineOverlay), {
                    issuesMap: issuesMap,
                    dependencies: dependencies
                }),
            ...!isExportTable ? {
                renderProvider: (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ft7xI")).TableProvider), {
                        ...props,
                        items: interactiveChartItems
                    }),
                renderChartOverlay: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3aigE")).ChartOverlay), {
                        issuesMap: issuesMap
                    })
            } : {}
        };
    };
    const $ca1439bbc073c02b$var$useListWidth = ()=>(0, $5uXOq.useState)((0, (0, parcelRequire("4R6GH")).fg)('project_timeline_multi-select_and_checkboxes') ? (0, (0, parcelRequire("iZN6h")).DEFAULT_LIST_WIDTH)() : (0, (0, parcelRequire("iZN6h")).DEFAULT_LIST_WIDTH)() + 40);
    const $ca1439bbc073c02b$export$4e254246a3a175f9 = (0, $5uXOq.memo)(()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const pageHeading = formatMessage((0, (0, parcelRequire("kxC7J")).default).timelineHeading);
        const timelineRef = (0, $5uXOq.useRef)(null);
        const [hierarchyState, hierarchyActions] = (0, (0, parcelRequire("iNLbM")).useHierarchyStore)();
        const childrenQueryData = hierarchyState.childrenQueryData;
        const expandedItems = hierarchyState.expandedItems;
        const setChildrenQueryData = hierarchyActions.setChildrenQueryData;
        const setIssueExpanded = hierarchyActions.setIssueExpanded;
        const { data: { items: items, issuesMap: issuesMap, issueParentMap: issueParentMap, dependencies: dependencies, interactiveChartItems: interactiveChartItems }, error: error, loading: loading, rankIssue: rankIssue, updateItemsInCache: updateItemsInCache, loadNextPage: loadNextPage, isLoadingNextPage: isLoadingNextPage, updateIssueParent: updateIssueParent, csvProps: csvProps } = (0, (0, parcelRequire("dnpKx")).useTimelineViewIssues)({
            childrenQueryData: childrenQueryData,
            expandedItems: expandedItems
        });
        const [{ shouldExpandAllItems: shouldExpandAllItems }, { disableExpandCollapseAllItems: disableExpandCollapseAllItems }] = (0, (0, parcelRequire("9pdbW")).useExpandCollapseAllItems)({
            view: 'timeline'
        });
        const listItemMenuOptions = (0, (0, parcelRequire("bZkBl")).useListItemMenuOptions)();
        const { isFiltering: isFiltering } = (0, (0, parcelRequire("kRkJF")).useFilteredViewContextInput)({
            view: 'timeline'
        });
        const onItemDrop = (0, $5uXOq.useCallback)((id, payload, analyticsEvent)=>{
            const { parentId: parentId, rankRequest: rankRequest } = payload;
            const isUpdateParent = 'parentId' in payload;
            if (isFiltering || !isUpdateParent && rankRequest) return rankIssue(id, payload, analyticsEvent);
            if (parentId && !expandedItems[parentId]) setIssueExpanded(parentId, true);
            return updateIssueParent(id, payload, analyticsEvent);
        }, [
            expandedItems,
            isFiltering,
            rankIssue,
            setIssueExpanded,
            updateIssueParent
        ]);
        const { loading: startDateFieldLoading } = (0, (0, parcelRequire("dAmbh")).useStartDateField)();
        const viewMode = (0, (0, parcelRequire("2gCtH")).useViewMode)();
        const isViewModeSideBar = viewMode === 'SIDEBAR';
        const [{ createItemAnchor: createItemAnchor }, { setCreateItemAnchor: setCreateItemAnchor }] = (0, (0, parcelRequire("1lN06")).useCreateItemAnchor)();
        const { data: { issueTypes: issueTypes } } = (0, (0, parcelRequire("1T2vX")).useIssueTypesAndFields)({
            issueOperation: 'CREATE'
        });
        const { hasInlineCreate: hasInlineCreate, hasCreateSubtask: hasCreateSubtask, featureView: featureView, hasScheduleIssues: hasScheduleIssues } = (0, (0, parcelRequire("jxKr9")).useTimelineFeatures)();
        const interactionMetrics = (0, (0, parcelRequire("qFFvI")).useInteractionMetrics)();
        const [{ timelineMode: timelineMode, today: today, timelineDuration: timelineDuration, timelineOrigin: timelineOrigin }] = (0, (0, parcelRequire("kjQs8")).useTimelineUI)();
        const [selectedIssueKey, setSelectedIssueKey] = (0, (0, parcelRequire("ieDtd")).useQueryParam)((0, (0, parcelRequire("hE5wF")).SELECTED_ISSUE_PARAM));
        const [listWidth, setListWidth] = $ca1439bbc073c02b$var$useListWidth();
        const selectedItemIds = (0, $5uXOq.useMemo)(()=>{
            if (!selectedIssueKey) return [];
            const selectedIssueId = Array.from(issuesMap.values()).find((issue)=>issue.key === selectedIssueKey)?.issueId;
            return selectedIssueId ? [
                selectedIssueId
            ] : [];
        }, [
            items,
            selectedIssueKey
        ]);
        const setRef = (0, (0, parcelRequire("gSLj9")).useIntersectionObserver)(loadNextPage);
        const setInfiniteScrollerRef = (0, $5uXOq.useCallback)((element)=>setRef(element), [
            setRef
        ]);
        const hasSubtasks = issueTypes.some((issueType)=>issueType.hierarchyLevel === -1);
        const { onBentoChange: onBentoChange, onBentoDelete: onBentoDelete } = (0, (0, parcelRequire("hZlg3")).useDependencyUpdater)({
            childrenQueryData: childrenQueryData
        });
        const { onItemUpdate: onItemUpdate } = (0, (0, parcelRequire("7bPJP")).useUpdateItem)({
            issuesMap: issuesMap,
            updateItemsInCache: updateItemsInCache,
            childrenQueryData: childrenQueryData
        });
        const { onItemUpdate: onJiraItemUpdate } = (0, (0, parcelRequire("gW8GI")).useUpdateItem)({
            issuesMap: issuesMap,
            updateItemsInCache: updateItemsInCache,
            childrenQueryData: childrenQueryData
        });
        const onBentoClose = (0, $5uXOq.useCallback)(()=>{
            setSelectedIssueKey(undefined);
        }, [
            setSelectedIssueKey
        ]);
        const onDeleteSuccess = (0, $5uXOq.useCallback)(({ issueId: issueId })=>{
            const parentId = issueParentMap.get(issueId);
            onBentoDelete({
                issueId: Number(issueId),
                parentId: Number(parentId)
            });
        }, [
            onBentoDelete,
            issueParentMap
        ]);
        const bentoView = (0, $5uXOq.useMemo)(()=>selectedIssueKey != null && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3kVj2")).default), {
                issueKey: (0, (0, parcelRequire("g5X3G")).toIssueKey)(selectedIssueKey),
                onClose: onBentoClose,
                onChange: onBentoChange,
                onDeleteSuccess: onDeleteSuccess,
                analyticsSource: (0, $fcf97b7a09088940$export$f6cf06aaaeb58a54)
            }), [
            onBentoChange,
            selectedIssueKey,
            onBentoClose,
            onDeleteSuccess
        ]);
        const onItemExpandChanged = (0, $5uXOq.useCallback)((issueId, isExpanded)=>{
            if (expandedItems[issueId] && shouldExpandAllItems) disableExpandCollapseAllItems();
            interactionMetrics[0, (0, parcelRequire("qFFvI")).EXPAND_CHANGED].start();
            setIssueExpanded(issueId, !isExpanded);
        }, [
            disableExpandCollapseAllItems,
            expandedItems,
            interactionMetrics,
            setIssueExpanded,
            shouldExpandAllItems
        ]);
        const onCreateClick = (0, $5uXOq.useCallback)((anchor)=>{
            interactionMetrics[0, (0, parcelRequire("qFFvI")).ADD_ITEM_CLICKED].start();
            if (anchor?.position === (0, (0, parcelRequire("iZN6h")).INSIDE) && anchor?.parentId) setIssueExpanded(anchor.parentId, true);
            setCreateItemAnchor(anchor);
        }, [
            interactionMetrics,
            setCreateItemAnchor,
            setIssueExpanded
        ]);
        const itemsProp = (0, $5uXOq.useMemo)(()=>{
            const extendedItems = createItemAnchor != null ? [
                ...items,
                {}
            ] : items;
            return loading ? (0, (0, parcelRequire("hLy6t")).LOADING_ITEMS) : extendedItems;
        }, [
            createItemAnchor,
            items,
            loading
        ]);
        const getRenderers = (0, $5uXOq.useCallback)(({ isExportTable: isExportTable })=>$ca1439bbc073c02b$var$getTimelineRenderers({
                childrenQueryData: childrenQueryData,
                dependencies: loading ? [] : dependencies,
                hasScheduleIssues: hasScheduleIssues,
                interactiveChartItems: interactiveChartItems,
                isExportTable: isExportTable,
                issuesMap: issuesMap,
                items: items,
                onCreateClick: onCreateClick,
                onItemUpdate: onItemUpdate,
                onJiraItemUpdate: onJiraItemUpdate,
                setInfiniteScrollerRef: setInfiniteScrollerRef,
                setSelectedIssueKey: setSelectedIssueKey,
                updateIssueParent: updateIssueParent
            }), [
            childrenQueryData,
            loading,
            dependencies,
            hasScheduleIssues,
            interactiveChartItems,
            issuesMap,
            items,
            onCreateClick,
            onItemUpdate,
            onJiraItemUpdate,
            setInfiniteScrollerRef,
            setSelectedIssueKey,
            updateIssueParent
        ]);
        const [{ headerHeight: headerHeight }] = (0, (0, parcelRequire("g3prf")).useHeaderState)();
        const listHeight = (0, (0, parcelRequire("1o48H")).getTimelineTableItemsHeight)(itemsProp, expandedItems) + headerHeight;
        const exportButton = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hB1Xb")).Export), {
            csvProps: csvProps,
            tableProps: {
                items: itemsProp,
                expandedItems: expandedItems,
                listWidth: listWidth,
                listHeight: listHeight,
                itemHeight: (0, (0, parcelRequire("jxXX4")).timelineProps).itemHeight,
                today: today,
                renderers: getRenderers({
                    isExportTable: true
                })
            }
        });
        const isReady = !loading && !error;
        const isCreateChildEnabled = !isFiltering && hasInlineCreate === true && hasSubtasks && hasCreateSubtask;
        let stickyInlineCreate;
        if (hasInlineCreate) stickyInlineCreate = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dupdF")).StickyInlineCreate), {
            expandedItems: expandedItems,
            height: (0, (0, parcelRequire("jxXX4")).timelineProps).itemHeight,
            issuesMap: issuesMap,
            items: items,
            listWidth: listWidth,
            loading: loading,
            timelineRef: timelineRef.current
        });
        const content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "business-timeline-table"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fMv2d")).default), {
            ...(0, (0, parcelRequire("jxXX4")).timelineProps),
            isDragEnabled: !startDateFieldLoading,
            createItemAnchor: createItemAnchor,
            DndLongTaskMetric: (0, (0, parcelRequire("dadh5")).DndLongTaskMetric),
            expandedItems: expandedItems,
            isCreateChildEnabled: isCreateChildEnabled,
            isCreateLastEnabled: hasInlineCreate,
            isCreateSiblingEnabled: hasInlineCreate === true,
            isSelectEnabled: true,
            isVirtualiseEnabled: true,
            items: itemsProp,
            listWidth: listWidth,
            onCreateClick: onCreateClick,
            onItemDrop: onItemDrop,
            onItemExpandChanged: onItemExpandChanged,
            onSetListWidth: setListWidth,
            renderers: getRenderers({
                isExportTable: false
            }),
            selectedItemIds: selectedItemIds,
            marshalOptions: (0, (0, parcelRequire("8LDjp")).marshalOptions),
            timelineDuration: timelineDuration,
            timelineMode: timelineMode,
            timelineOrigin: timelineOrigin,
            today: today,
            isTreeDrag: true,
            isMeatballsButtonEnabled: (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline_table_meatballs_menu_a11y'),
            ...(0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline_table_meatballs_menu_a11y') && {
                listItemMenuOptions: listItemMenuOptions
            }
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9jHuQ")).StickyInlineNudge), {
            height: (0, (0, parcelRequire("jxXX4")).timelineProps).itemHeight,
            isEmpty: items.length === 0,
            listWidth: listWidth,
            loading: loading,
            timelineRef: timelineRef.current
        }), stickyInlineCreate, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("34tvt")).LoadingMoreSpinner), {
            isLoading: isLoadingNextPage,
            loadingMessage: formatMessage((0, (0, parcelRequire("kxC7J")).default).loadingMoreItems)
        }));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, !isFiltering && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fel5A")).ChildrenController), {
            expandedItemIssueIds: Object.keys(expandedItems),
            setChildrenQueryData: setChildrenQueryData,
            ChildQueryController: (0, (0, parcelRequire("afmVm")).TimelineViewChildQueryController)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7NUKB")).default), {
            name: "timeline-view",
            hold: loading
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7Wnap")).RenderStartMark), {
            view: featureView,
            loading: loading
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e21nk")).BusinessDocumentTitle), {
            pageHeading: pageHeading
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iQqkW")).default), {
            exportToImageButton: exportButton
        }), (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_1') ? (0, ($parcel$interopDefault($5uXOq))).createElement($ca1439bbc073c02b$export$bbea409da9cbdc02, {
            visualRefresh: (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_2'),
            ref: timelineRef
        }, content) : (0, ($parcel$interopDefault($5uXOq))).createElement($ca1439bbc073c02b$export$715f9ebe027e6dd1, {
            ref: timelineRef
        }, content), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8HvEs")).PerformanceAnalytics), {
            view: featureView,
            loading: loading,
            itemsCount: items.length
        }), !loading && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7yduy")).JWMSpaStatePageReady), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1bZXb")).InteractionMetrics), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gEkZt")).TimelineViewUpdater), {
            childrenQueryData: childrenQueryData
        }), isViewModeSideBar ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ksKCJ")).SidebarIssueView), {
            issueKey: selectedIssueKey,
            onClose: onBentoClose,
            onChange: onBentoChange,
            onIssueDeleteSuccess: onDeleteSuccess,
            analyticsSource: (0, $fcf97b7a09088940$export$f6cf06aaaeb58a54)
        }) : bentoView, isReady && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cm8b5")).ExperienceSuccess), {
            experience: (0, (0, parcelRequire("gNAqw")).MAIN_EXPERIENCE)
        }), error && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cm8b5")).ExperienceFailed), {
            experience: (0, (0, parcelRequire("gNAqw")).MAIN_EXPERIENCE),
            error: error
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("exeAk")).PrefetchIssueDataController), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b4BqL")).ExpandCollapseAllController), null));
    });
    var $ca1439bbc073c02b$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gEkZt")).TimelineViewUpdaterProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement($ca1439bbc073c02b$export$4e254246a3a175f9, null));
    const $ca1439bbc073c02b$var$fakeBorder = {
        content: '',
        background: 'transparent',
        border: `1px solid ${`var(--ds-border, ${(0, $72ba03e317f3d228$exports).N40})`}`,
        borderBottom: 'none',
        width: "var(--ds-space-100, 8px)",
        height: "var(--ds-space-100, 8px)",
        position: 'absolute',
        display: 'block',
        top: 0,
        zIndex: (0, (0, parcelRequire("iZN6h")).zIndex).HIGHEST
    };
    const $ca1439bbc073c02b$export$bbea409da9cbdc02 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { visualRefresh: visualRefresh, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_bfhkvuon _13lipd34 _1s7zqvwq _n7zlqvwq _syaz1fxt _16jlkb7n _1o9zkb7n _i0dl1wug _1reo15vq _18m915vq _vchhusvi _kqswh2mm _1yt4u2gc _aetrb3bt _1hfk18uv _eq43h6cr _2kncglyw _z0aiu2gc _1qdgu2gc _18postnw _1ywu1ule _15l2idpf _1bqq1o8a _14mjqssn _qzgtglyw _19doidpf _7rifglyw",
                __cmplp.visualRefresh && "_1oj4wxmy",
                __cmplp.className
            ])
        });
    });
    const $ca1439bbc073c02b$export$715f9ebe027e6dd1 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_bfhkvuon _2rkopd34 _1s7zqvwq _n7zlqvwq _syaz1fxt _16jlkb7n _1o9zkb7n _i0dl1wug _1reo15vq _18m915vq _vchhusvi _kqswh2mm _1yt4u2gc _aetrb3bt _1hfk18uv _eq43h6cr _2kncglyw _z0aiu2gc _1qdgu2gc _18postnw _1ywu1ule _15l2idpf _1bqq1o8a _14mjqssn _qzgtglyw _19doidpf _1kt9b3bt _1rus18uv _14h8h6cr _4k1cglyw _1mp4u2gc _kfgtu2gc _1cs8stnw _cfu11ule _1aukidpf _1g0v1o8a _rfx3eg5i _1n1jglyw _oounze3t _7rifglyw",
                __cmplp.className
            ])
        });
    });
});
var $72ba03e317f3d228$exports = {};
$parcel$export($72ba03e317f3d228$exports, "R50", ()=>$72ba03e317f3d228$export$4b84fd0e2c617bd);
$parcel$export($72ba03e317f3d228$exports, "R75", ()=>$72ba03e317f3d228$export$b34b069eff244586);
$parcel$export($72ba03e317f3d228$exports, "R100", ()=>$72ba03e317f3d228$export$be802dd0d8b57f35);
$parcel$export($72ba03e317f3d228$exports, "R200", ()=>$72ba03e317f3d228$export$60847d42f9da92a6);
$parcel$export($72ba03e317f3d228$exports, "R300", ()=>$72ba03e317f3d228$export$4a7404f376229999);
$parcel$export($72ba03e317f3d228$exports, "R400", ()=>$72ba03e317f3d228$export$2010d0fb4295b346);
$parcel$export($72ba03e317f3d228$exports, "R500", ()=>$72ba03e317f3d228$export$2837b5a1a71d5c02);
$parcel$export($72ba03e317f3d228$exports, "Y50", ()=>$72ba03e317f3d228$export$8d9596b529bbb9cf);
$parcel$export($72ba03e317f3d228$exports, "Y75", ()=>$72ba03e317f3d228$export$41060a744ab0b7ae);
$parcel$export($72ba03e317f3d228$exports, "Y100", ()=>$72ba03e317f3d228$export$1cc05bbbf340e559);
$parcel$export($72ba03e317f3d228$exports, "Y200", ()=>$72ba03e317f3d228$export$5aae31392d72caaa);
$parcel$export($72ba03e317f3d228$exports, "Y300", ()=>$72ba03e317f3d228$export$c6930421db9fa514);
$parcel$export($72ba03e317f3d228$exports, "Y400", ()=>$72ba03e317f3d228$export$59619663aa6500fb);
$parcel$export($72ba03e317f3d228$exports, "Y500", ()=>$72ba03e317f3d228$export$874739ea9e379ab6);
$parcel$export($72ba03e317f3d228$exports, "G50", ()=>$72ba03e317f3d228$export$8a6341c32b6a3ee6);
$parcel$export($72ba03e317f3d228$exports, "G75", ()=>$72ba03e317f3d228$export$69a3bf21b9686c2b);
$parcel$export($72ba03e317f3d228$exports, "G100", ()=>$72ba03e317f3d228$export$afbce1382ec95f73);
$parcel$export($72ba03e317f3d228$exports, "G200", ()=>$72ba03e317f3d228$export$747d86715d4175de);
$parcel$export($72ba03e317f3d228$exports, "G300", ()=>$72ba03e317f3d228$export$940e1f69e873f202);
$parcel$export($72ba03e317f3d228$exports, "G400", ()=>$72ba03e317f3d228$export$a49394138f7b8e85);
$parcel$export($72ba03e317f3d228$exports, "G500", ()=>$72ba03e317f3d228$export$6fa04827ac68a4fb);
$parcel$export($72ba03e317f3d228$exports, "B50", ()=>$72ba03e317f3d228$export$226de0355ed012f8);
$parcel$export($72ba03e317f3d228$exports, "B75", ()=>$72ba03e317f3d228$export$8c13c2ee36917869);
$parcel$export($72ba03e317f3d228$exports, "B100", ()=>$72ba03e317f3d228$export$ecfc1dff386a3e7a);
$parcel$export($72ba03e317f3d228$exports, "B200", ()=>$72ba03e317f3d228$export$215b7063051591f1);
$parcel$export($72ba03e317f3d228$exports, "B300", ()=>$72ba03e317f3d228$export$e62e8919cca44969);
$parcel$export($72ba03e317f3d228$exports, "B400", ()=>$72ba03e317f3d228$export$b3de0ae08da2ce64);
$parcel$export($72ba03e317f3d228$exports, "B500", ()=>$72ba03e317f3d228$export$a6ee3d71bc067634);
$parcel$export($72ba03e317f3d228$exports, "B600", ()=>$72ba03e317f3d228$export$67f15409e87642a1);
$parcel$export($72ba03e317f3d228$exports, "B700", ()=>$72ba03e317f3d228$export$f0539dbc42dbb067);
$parcel$export($72ba03e317f3d228$exports, "P50", ()=>$72ba03e317f3d228$export$363e4475840015bb);
$parcel$export($72ba03e317f3d228$exports, "P75", ()=>$72ba03e317f3d228$export$4b0a4417ed59760f);
$parcel$export($72ba03e317f3d228$exports, "P100", ()=>$72ba03e317f3d228$export$6011520a64d9a187);
$parcel$export($72ba03e317f3d228$exports, "P200", ()=>$72ba03e317f3d228$export$a7175d4e9206bc80);
$parcel$export($72ba03e317f3d228$exports, "P300", ()=>$72ba03e317f3d228$export$b48405b95304b5a1);
$parcel$export($72ba03e317f3d228$exports, "P400", ()=>$72ba03e317f3d228$export$c71e4279dd54a18d);
$parcel$export($72ba03e317f3d228$exports, "P500", ()=>$72ba03e317f3d228$export$147899de772240ec);
$parcel$export($72ba03e317f3d228$exports, "T50", ()=>$72ba03e317f3d228$export$2cf711fe14c66f06);
$parcel$export($72ba03e317f3d228$exports, "T75", ()=>$72ba03e317f3d228$export$7a8f4d33f6f9772c);
$parcel$export($72ba03e317f3d228$exports, "T100", ()=>$72ba03e317f3d228$export$776c9c497ef08533);
$parcel$export($72ba03e317f3d228$exports, "T200", ()=>$72ba03e317f3d228$export$69cb3ca10c1e330e);
$parcel$export($72ba03e317f3d228$exports, "T300", ()=>$72ba03e317f3d228$export$9dc1ef0f3f48059b);
$parcel$export($72ba03e317f3d228$exports, "T400", ()=>$72ba03e317f3d228$export$7c835c78b6fcdef8);
$parcel$export($72ba03e317f3d228$exports, "T500", ()=>$72ba03e317f3d228$export$6036577f95c3877e);
$parcel$export($72ba03e317f3d228$exports, "N0", ()=>$72ba03e317f3d228$export$29a4f05edc054374);
$parcel$export($72ba03e317f3d228$exports, "N10", ()=>$72ba03e317f3d228$export$e655ef011c4aa1a2);
$parcel$export($72ba03e317f3d228$exports, "N20", ()=>$72ba03e317f3d228$export$9fdfb749e33cdf97);
$parcel$export($72ba03e317f3d228$exports, "N30", ()=>$72ba03e317f3d228$export$3e51e8f1440314ba);
$parcel$export($72ba03e317f3d228$exports, "N40", ()=>$72ba03e317f3d228$export$1ce2d1575d444ceb);
$parcel$export($72ba03e317f3d228$exports, "N50", ()=>$72ba03e317f3d228$export$8754fc7e6d8b3000);
$parcel$export($72ba03e317f3d228$exports, "N60", ()=>$72ba03e317f3d228$export$c2e91cbeada39b8b);
$parcel$export($72ba03e317f3d228$exports, "N70", ()=>$72ba03e317f3d228$export$5f71e19f3a7ad9de);
$parcel$export($72ba03e317f3d228$exports, "N80", ()=>$72ba03e317f3d228$export$eaa8c8a70ac22806);
$parcel$export($72ba03e317f3d228$exports, "N90", ()=>$72ba03e317f3d228$export$7c87d337fb91a97d);
$parcel$export($72ba03e317f3d228$exports, "N100", ()=>$72ba03e317f3d228$export$d6447c357493214f);
$parcel$export($72ba03e317f3d228$exports, "N200", ()=>$72ba03e317f3d228$export$f563ee71e9ee74cd);
$parcel$export($72ba03e317f3d228$exports, "N300", ()=>$72ba03e317f3d228$export$e2ef2124cf4024b1);
$parcel$export($72ba03e317f3d228$exports, "N400", ()=>$72ba03e317f3d228$export$eece5f492e429f08);
$parcel$export($72ba03e317f3d228$exports, "N500", ()=>$72ba03e317f3d228$export$c39c0fe0f26207ae);
$parcel$export($72ba03e317f3d228$exports, "N600", ()=>$72ba03e317f3d228$export$7090862dc3038a9f);
$parcel$export($72ba03e317f3d228$exports, "N700", ()=>$72ba03e317f3d228$export$ad0bacf983b7ddaa);
$parcel$export($72ba03e317f3d228$exports, "N800", ()=>$72ba03e317f3d228$export$7d61b15e0da132af);
$parcel$export($72ba03e317f3d228$exports, "N900", ()=>$72ba03e317f3d228$export$fbda843f0a27fe96);
$parcel$export($72ba03e317f3d228$exports, "N10A", ()=>$72ba03e317f3d228$export$791e57b27ca738ef);
$parcel$export($72ba03e317f3d228$exports, "N20A", ()=>$72ba03e317f3d228$export$8d43898f60b96a82);
$parcel$export($72ba03e317f3d228$exports, "N30A", ()=>$72ba03e317f3d228$export$920c0d5c49070351);
$parcel$export($72ba03e317f3d228$exports, "N40A", ()=>$72ba03e317f3d228$export$46987b49aab6d1a8);
$parcel$export($72ba03e317f3d228$exports, "N50A", ()=>$72ba03e317f3d228$export$7d3359664e8bb0e5);
$parcel$export($72ba03e317f3d228$exports, "N60A", ()=>$72ba03e317f3d228$export$d2d3bedfb276cac0);
$parcel$export($72ba03e317f3d228$exports, "N70A", ()=>$72ba03e317f3d228$export$6e5e7499ff054f6d);
$parcel$export($72ba03e317f3d228$exports, "N80A", ()=>$72ba03e317f3d228$export$59264b346c877fa7);
$parcel$export($72ba03e317f3d228$exports, "N90A", ()=>$72ba03e317f3d228$export$d092757d7c64925c);
$parcel$export($72ba03e317f3d228$exports, "N100A", ()=>$72ba03e317f3d228$export$486ab785e4bac3c6);
$parcel$export($72ba03e317f3d228$exports, "N200A", ()=>$72ba03e317f3d228$export$fba592bbc6419fea);
$parcel$export($72ba03e317f3d228$exports, "N300A", ()=>$72ba03e317f3d228$export$13609db0e6812ab8);
$parcel$export($72ba03e317f3d228$exports, "N400A", ()=>$72ba03e317f3d228$export$fbae4efaa892d883);
$parcel$export($72ba03e317f3d228$exports, "N500A", ()=>$72ba03e317f3d228$export$f13946d26f440ce6);
$parcel$export($72ba03e317f3d228$exports, "N600A", ()=>$72ba03e317f3d228$export$19f58225ac52a306);
$parcel$export($72ba03e317f3d228$exports, "N700A", ()=>$72ba03e317f3d228$export$6384f09da70e7b62);
$parcel$export($72ba03e317f3d228$exports, "N800A", ()=>$72ba03e317f3d228$export$d0dccc730683edc2);
$parcel$export($72ba03e317f3d228$exports, "DN900", ()=>$72ba03e317f3d228$export$2f6319cf7d736c2a);
$parcel$export($72ba03e317f3d228$exports, "DN800", ()=>$72ba03e317f3d228$export$95126bc8884d6634);
$parcel$export($72ba03e317f3d228$exports, "DN700", ()=>$72ba03e317f3d228$export$8338d8c35d44ff1);
$parcel$export($72ba03e317f3d228$exports, "DN600", ()=>$72ba03e317f3d228$export$5368d76ae4fbbda7);
$parcel$export($72ba03e317f3d228$exports, "DN500", ()=>$72ba03e317f3d228$export$9f0a771d16ec8d36);
$parcel$export($72ba03e317f3d228$exports, "DN400", ()=>$72ba03e317f3d228$export$abcf8c38338b4aa5);
$parcel$export($72ba03e317f3d228$exports, "DN300", ()=>$72ba03e317f3d228$export$97e81faa16a182c7);
$parcel$export($72ba03e317f3d228$exports, "DN200", ()=>$72ba03e317f3d228$export$bfe21c59123ecf33);
$parcel$export($72ba03e317f3d228$exports, "DN100", ()=>$72ba03e317f3d228$export$ee82aa2ea6a1558);
$parcel$export($72ba03e317f3d228$exports, "DN90", ()=>$72ba03e317f3d228$export$682927c6ed76be02);
$parcel$export($72ba03e317f3d228$exports, "DN80", ()=>$72ba03e317f3d228$export$91fd9994c5be9757);
$parcel$export($72ba03e317f3d228$exports, "DN70", ()=>$72ba03e317f3d228$export$d281fbfe3cff2df6);
$parcel$export($72ba03e317f3d228$exports, "DN60", ()=>$72ba03e317f3d228$export$3902c91d8b98a753);
$parcel$export($72ba03e317f3d228$exports, "DN50", ()=>$72ba03e317f3d228$export$8e8133c1ba5845b5);
$parcel$export($72ba03e317f3d228$exports, "DN40", ()=>$72ba03e317f3d228$export$33ff357f6620b39);
$parcel$export($72ba03e317f3d228$exports, "DN30", ()=>$72ba03e317f3d228$export$633847cf062b69e0);
$parcel$export($72ba03e317f3d228$exports, "DN20", ()=>$72ba03e317f3d228$export$9776a6e503bdbf76);
$parcel$export($72ba03e317f3d228$exports, "DN10", ()=>$72ba03e317f3d228$export$6c813d5160dff5db);
$parcel$export($72ba03e317f3d228$exports, "DN0", ()=>$72ba03e317f3d228$export$3d4f271a500072a);
$parcel$export($72ba03e317f3d228$exports, "DN800A", ()=>$72ba03e317f3d228$export$fe151285c22759ec);
$parcel$export($72ba03e317f3d228$exports, "DN700A", ()=>$72ba03e317f3d228$export$a101c6190d0da34);
$parcel$export($72ba03e317f3d228$exports, "DN600A", ()=>$72ba03e317f3d228$export$4b16f52932fda51);
$parcel$export($72ba03e317f3d228$exports, "DN500A", ()=>$72ba03e317f3d228$export$a74bcd7b9845b0d8);
$parcel$export($72ba03e317f3d228$exports, "DN400A", ()=>$72ba03e317f3d228$export$9209c179316d1751);
$parcel$export($72ba03e317f3d228$exports, "DN300A", ()=>$72ba03e317f3d228$export$88f55133f636c8dd);
$parcel$export($72ba03e317f3d228$exports, "DN200A", ()=>$72ba03e317f3d228$export$51126f85d1009512);
$parcel$export($72ba03e317f3d228$exports, "DN100A", ()=>$72ba03e317f3d228$export$a069b547bd23af78);
$parcel$export($72ba03e317f3d228$exports, "DN90A", ()=>$72ba03e317f3d228$export$40cce05af3b2600a);
$parcel$export($72ba03e317f3d228$exports, "DN80A", ()=>$72ba03e317f3d228$export$b78942185925a0d);
$parcel$export($72ba03e317f3d228$exports, "DN70A", ()=>$72ba03e317f3d228$export$e058fb44b8eaafca);
$parcel$export($72ba03e317f3d228$exports, "DN60A", ()=>$72ba03e317f3d228$export$92b0b8de26920c18);
$parcel$export($72ba03e317f3d228$exports, "DN50A", ()=>$72ba03e317f3d228$export$67564f7459d3fc9e);
$parcel$export($72ba03e317f3d228$exports, "DN40A", ()=>$72ba03e317f3d228$export$77868e1ca884ffa3);
$parcel$export($72ba03e317f3d228$exports, "DN30A", ()=>$72ba03e317f3d228$export$2afd71d7d3ea2cd5);
$parcel$export($72ba03e317f3d228$exports, "DN20A", ()=>$72ba03e317f3d228$export$f2a0acaab9972c70);
$parcel$export($72ba03e317f3d228$exports, "DN10A", ()=>$72ba03e317f3d228$export$9ab70e67d6475361);
$parcel$export($72ba03e317f3d228$exports, "T30", ()=>$72ba03e317f3d228$export$d2adc5dedf09fced);
$parcel$export($72ba03e317f3d228$exports, "L50", ()=>$72ba03e317f3d228$export$f51762073d2bb381);
$parcel$export($72ba03e317f3d228$exports, "L75", ()=>$72ba03e317f3d228$export$95e26d54def96891);
const $72ba03e317f3d228$export$4b84fd0e2c617bd = '#FFEBE6';
const $72ba03e317f3d228$export$b34b069eff244586 = '#FFBDAD';
const $72ba03e317f3d228$export$be802dd0d8b57f35 = '#FF8F73';
const $72ba03e317f3d228$export$60847d42f9da92a6 = '#FF7452';
const $72ba03e317f3d228$export$4a7404f376229999 = '#FF5630';
const $72ba03e317f3d228$export$2010d0fb4295b346 = '#DE350B';
const $72ba03e317f3d228$export$2837b5a1a71d5c02 = '#BF2600';
const $72ba03e317f3d228$export$8d9596b529bbb9cf = '#FFFAE6';
const $72ba03e317f3d228$export$41060a744ab0b7ae = '#FFF0B3';
const $72ba03e317f3d228$export$1cc05bbbf340e559 = '#FFE380';
const $72ba03e317f3d228$export$5aae31392d72caaa = '#FFC400';
const $72ba03e317f3d228$export$c6930421db9fa514 = '#FFAB00';
const $72ba03e317f3d228$export$59619663aa6500fb = '#FF991F';
const $72ba03e317f3d228$export$874739ea9e379ab6 = '#FF8B00';
const $72ba03e317f3d228$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $72ba03e317f3d228$export$69a3bf21b9686c2b = '#ABF5D1';
const $72ba03e317f3d228$export$afbce1382ec95f73 = '#79F2C0';
const $72ba03e317f3d228$export$747d86715d4175de = '#57D9A3';
const $72ba03e317f3d228$export$940e1f69e873f202 = '#36B37E';
const $72ba03e317f3d228$export$a49394138f7b8e85 = '#00875A';
const $72ba03e317f3d228$export$6fa04827ac68a4fb = '#006644';
const $72ba03e317f3d228$export$226de0355ed012f8 = '#DEEBFF';
const $72ba03e317f3d228$export$8c13c2ee36917869 = '#B3D4FF';
const $72ba03e317f3d228$export$ecfc1dff386a3e7a = '#4C9AFF';
const $72ba03e317f3d228$export$215b7063051591f1 = '#2684FF';
const $72ba03e317f3d228$export$e62e8919cca44969 = '#0065FF';
const $72ba03e317f3d228$export$b3de0ae08da2ce64 = '#0052CC';
const $72ba03e317f3d228$export$a6ee3d71bc067634 = '#0747A6';
const $72ba03e317f3d228$export$67f15409e87642a1 = '#669DF1';
const $72ba03e317f3d228$export$f0539dbc42dbb067 = '#8FB8F6';
const $72ba03e317f3d228$export$363e4475840015bb = '#EAE6FF';
const $72ba03e317f3d228$export$4b0a4417ed59760f = '#C0B6F2';
const $72ba03e317f3d228$export$6011520a64d9a187 = '#998DD9';
const $72ba03e317f3d228$export$a7175d4e9206bc80 = '#8777D9';
const $72ba03e317f3d228$export$b48405b95304b5a1 = '#6554C0';
const $72ba03e317f3d228$export$c71e4279dd54a18d = '#5243AA';
const $72ba03e317f3d228$export$147899de772240ec = '#403294';
const $72ba03e317f3d228$export$2cf711fe14c66f06 = '#E6FCFF';
const $72ba03e317f3d228$export$7a8f4d33f6f9772c = '#B3F5FF';
const $72ba03e317f3d228$export$776c9c497ef08533 = '#79E2F2';
const $72ba03e317f3d228$export$69cb3ca10c1e330e = '#00C7E6';
const $72ba03e317f3d228$export$9dc1ef0f3f48059b = '#00B8D9';
const $72ba03e317f3d228$export$7c835c78b6fcdef8 = '#00A3BF';
const $72ba03e317f3d228$export$6036577f95c3877e = '#008DA6';
const $72ba03e317f3d228$export$29a4f05edc054374 = '#FFFFFF';
const $72ba03e317f3d228$export$e655ef011c4aa1a2 = '#FAFBFC';
const $72ba03e317f3d228$export$9fdfb749e33cdf97 = '#F4F5F7';
const $72ba03e317f3d228$export$3e51e8f1440314ba = '#EBECF0';
const $72ba03e317f3d228$export$1ce2d1575d444ceb = '#DFE1E6';
const $72ba03e317f3d228$export$8754fc7e6d8b3000 = '#C1C7D0';
const $72ba03e317f3d228$export$c2e91cbeada39b8b = '#B3BAC5';
const $72ba03e317f3d228$export$5f71e19f3a7ad9de = '#A5ADBA';
const $72ba03e317f3d228$export$eaa8c8a70ac22806 = '#97A0AF';
const $72ba03e317f3d228$export$7c87d337fb91a97d = '#8993A4';
const $72ba03e317f3d228$export$d6447c357493214f = '#7A869A';
const $72ba03e317f3d228$export$f563ee71e9ee74cd = '#6B778C';
const $72ba03e317f3d228$export$e2ef2124cf4024b1 = '#5E6C84';
const $72ba03e317f3d228$export$eece5f492e429f08 = '#505F79';
const $72ba03e317f3d228$export$c39c0fe0f26207ae = '#42526E';
const $72ba03e317f3d228$export$7090862dc3038a9f = '#344563';
const $72ba03e317f3d228$export$ad0bacf983b7ddaa = '#253858';
const $72ba03e317f3d228$export$7d61b15e0da132af = '#172B4D';
const $72ba03e317f3d228$export$fbda843f0a27fe96 = '#091E42';
const $72ba03e317f3d228$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $72ba03e317f3d228$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $72ba03e317f3d228$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $72ba03e317f3d228$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $72ba03e317f3d228$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $72ba03e317f3d228$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $72ba03e317f3d228$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $72ba03e317f3d228$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $72ba03e317f3d228$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $72ba03e317f3d228$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $72ba03e317f3d228$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $72ba03e317f3d228$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $72ba03e317f3d228$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $72ba03e317f3d228$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $72ba03e317f3d228$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $72ba03e317f3d228$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $72ba03e317f3d228$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $72ba03e317f3d228$export$2f6319cf7d736c2a = '#E6EDFA';
const $72ba03e317f3d228$export$95126bc8884d6634 = '#DCE5F5';
const $72ba03e317f3d228$export$8338d8c35d44ff1 = '#CED9EB';
const $72ba03e317f3d228$export$5368d76ae4fbbda7 = '#B8C7E0';
const $72ba03e317f3d228$export$9f0a771d16ec8d36 = '#ABBBD6';
const $72ba03e317f3d228$export$abcf8c38338b4aa5 = '#9FB0CC';
const $72ba03e317f3d228$export$97e81faa16a182c7 = '#8C9CB8';
const $72ba03e317f3d228$export$bfe21c59123ecf33 = '#7988A3';
const $72ba03e317f3d228$export$ee82aa2ea6a1558 = '#67758F';
const $72ba03e317f3d228$export$682927c6ed76be02 = '#56637A';
const $72ba03e317f3d228$export$91fd9994c5be9757 = '#455166';
const $72ba03e317f3d228$export$d281fbfe3cff2df6 = '#3B475C';
const $72ba03e317f3d228$export$3902c91d8b98a753 = '#313D52';
const $72ba03e317f3d228$export$8e8133c1ba5845b5 = '#283447';
const $72ba03e317f3d228$export$33ff357f6620b39 = '#202B3D';
const $72ba03e317f3d228$export$633847cf062b69e0 = '#1B2638';
const $72ba03e317f3d228$export$9776a6e503bdbf76 = '#121A29';
const $72ba03e317f3d228$export$6c813d5160dff5db = '#0E1624';
const $72ba03e317f3d228$export$3d4f271a500072a = '#0D1424';
const $72ba03e317f3d228$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $72ba03e317f3d228$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $72ba03e317f3d228$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $72ba03e317f3d228$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $72ba03e317f3d228$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $72ba03e317f3d228$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $72ba03e317f3d228$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $72ba03e317f3d228$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $72ba03e317f3d228$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $72ba03e317f3d228$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $72ba03e317f3d228$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $72ba03e317f3d228$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $72ba03e317f3d228$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $72ba03e317f3d228$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $72ba03e317f3d228$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $72ba03e317f3d228$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $72ba03e317f3d228$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $72ba03e317f3d228$export$d2adc5dedf09fced = '#292A2E';
const $72ba03e317f3d228$export$f51762073d2bb381 = '#94C748';
const $72ba03e317f3d228$export$95e26d54def96891 = '#B3DF72';
parcelRegister("e21nk", function(module, exports) {
    $parcel$export(module.exports, "BusinessDocumentTitle", ()=>$aa5670652f17dfc4$export$416064ba09d98e69);
    var $5uXOq = parcelRequire("5uXOq");
    var $ew1Lk;
    var $54qG5;
    const $aa5670652f17dfc4$export$416064ba09d98e69 = (0, $5uXOq.memo)(({ pageHeading: pageHeading })=>{
        const { data: entity } = (0, (0, parcelRequire("54qG5")).useBusinessEntity)();
        const documentTitle = entity?.name ? `${pageHeading} - ${entity.name}` : pageHeading;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ew1Lk")).DocumentTitle), {
            title: documentTitle
        });
    });
});
parcelRegister("ew1Lk", function(module, exports) {
    $parcel$export(module.exports, "DocumentTitle", ()=>$41b549fa18234081$export$dd5ad0b65cf665da);
    var $5uXOq = parcelRequire("5uXOq");
    var $6nkVm;
    class $41b549fa18234081$export$dd5ad0b65cf665da extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                TitleSubscriber: (0, (0, parcelRequire("6nkVm")).DocumentTitleSubscriber)
            };
        }
        shouldComponentUpdate(nextProps) {
            return nextProps.title !== this.props.title;
        }
        render() {
            const { title: title, TitleSubscriber: TitleSubscriber } = this.props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6nkVm")).DocumentTitleHelper), {
                    title: title,
                    setTitle: setTitle,
                    addDocumentTitle: addDocumentTitle,
                    contextArray: contextArray,
                    removeDocumentTitle: removeDocumentTitle,
                    TitleSubscriber: TitleSubscriber
                }));
        }
    }
});
parcelRegister("9pdbW", function(module, exports) {
    $parcel$export(module.exports, "useExpandCollapseAllItems", ()=>$3b02fa0a8e1492e4$export$38cfcb71ce0d3b89);
    var $5uXOq = parcelRequire("5uXOq");
    var $3sQ5x;
    var $iXqE5;
    const $3b02fa0a8e1492e4$var$actions = {
        toggleExpanding: (view)=>({ setState: setState, getState: getState })=>{
                const state = getState();
                setState({
                    [view]: {
                        ...state[view],
                        shouldExpandAllItems: !state[view].shouldExpandAllItems,
                        shouldCollapseAllItems: false
                    }
                });
            },
        setCollapsing: (view)=>({ setState: setState, getState: getState })=>{
                const state = getState();
                setState({
                    [view]: {
                        ...state[view],
                        shouldExpandAllItems: false,
                        shouldCollapseAllItems: true
                    }
                });
            },
        disableExpandCollapse: (view)=>({ setState: setState, getState: getState })=>{
                const state = getState();
                setState({
                    [view]: {
                        ...state[view],
                        shouldExpandAllItems: false,
                        shouldCollapseAllItems: false
                    }
                });
            },
        setHasExpandedAllItems: (view, hasExpanded)=>({ setState: setState, getState: getState })=>{
                const state = getState();
                setState({
                    [view]: {
                        ...state[view],
                        hasExpandedAllItems: hasExpanded
                    }
                });
            },
        setHasCollapsedAllItems: (view, hasCollapsed)=>({ setState: setState, getState: getState })=>{
                const state = getState();
                setState({
                    [view]: {
                        ...state[view],
                        hasCollapsedAllItems: hasCollapsed
                    }
                });
            }
    };
    const $3b02fa0a8e1492e4$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: {
            list: {
                shouldExpandAllItems: false,
                shouldCollapseAllItems: false,
                hasExpandedAllItems: false,
                hasCollapsedAllItems: false
            },
            timeline: {
                shouldExpandAllItems: false,
                shouldCollapseAllItems: false,
                hasExpandedAllItems: false,
                hasCollapsedAllItems: false
            }
        },
        actions: $3b02fa0a8e1492e4$var$actions,
        name: 'JWMExpandCollapseStore'
    });
    const $3b02fa0a8e1492e4$var$useHook = (0, (0, parcelRequire("3sQ5x")).createHook)($3b02fa0a8e1492e4$var$Store);
    const $3b02fa0a8e1492e4$export$38cfcb71ce0d3b89 = ({ view: view, onCollapse: onCollapse })=>{
        const [state, { toggleExpanding: toggleExpanding, setCollapsing: setCollapsing, disableExpandCollapse: disableExpandCollapse, setHasExpandedAllItems: setHasExpandedAllItems, setHasCollapsedAllItems: setHasCollapsedAllItems }] = $3b02fa0a8e1492e4$var$useHook();
        const { shouldExpandAllItems: shouldExpandAllItems, shouldCollapseAllItems: shouldCollapseAllItems, hasExpandedAllItems: hasExpandedAllItems, hasCollapsedAllItems: hasCollapsedAllItems } = state[view];
        const toggleExpandingForView = (0, $5uXOq.useCallback)(()=>toggleExpanding(view), [
            toggleExpanding,
            view
        ]);
        const setCollapsingForView = (0, $5uXOq.useCallback)(()=>setCollapsing(view), [
            setCollapsing,
            view
        ]);
        const setHasCollapsedAllItemsForView = (0, $5uXOq.useCallback)((hasCollapsed)=>setHasCollapsedAllItems(view, hasCollapsed), [
            setHasCollapsedAllItems,
            view
        ]);
        const setHasExpandedAllItemsForView = (0, $5uXOq.useCallback)((hasExpanded)=>setHasExpandedAllItems(view, hasExpanded), [
            setHasExpandedAllItems,
            view
        ]);
        const disableExpandCollapseForView = (0, $5uXOq.useCallback)(()=>disableExpandCollapse(view), [
            disableExpandCollapse,
            view
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (onCollapse && shouldCollapseAllItems) {
                onCollapse();
                disableExpandCollapseForView();
            }
        }, [
            disableExpandCollapseForView,
            onCollapse,
            shouldCollapseAllItems
        ]);
        return [
            {
                shouldExpandAllItems: shouldExpandAllItems,
                shouldCollapseAllItems: shouldCollapseAllItems,
                hasExpandedAllItems: hasExpandedAllItems,
                hasCollapsedAllItems: hasCollapsedAllItems
            },
            {
                toggleExpandAllItems: toggleExpandingForView,
                collapseAllItems: setCollapsingForView,
                disableExpandCollapseAllItems: disableExpandCollapseForView,
                setHasExpandedAllItems: setHasExpandedAllItemsForView,
                setHasCollapsedAllItems: setHasCollapsedAllItemsForView
            }
        ];
    };
});
parcelRegister("exeAk", function(module, exports) {
    $parcel$export(module.exports, "PrefetchIssueDataController", ()=>$77c62695b59f030f$export$1e95fb877713bf5e);
    var $5uXOq = parcelRequire("5uXOq");
    var $hE5wF;
    var $1XJ20;
    var $ieDtd;
    var $1JH9w;
    var $l1hWj;
    const $77c62695b59f030f$var$IssueDataLoader = (0, $5uXOq.memo)(({ issues: issues })=>issues.map((issueKey)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l1hWj")).AsyncIssueViewCriticalDataLoader), {
                key: issueKey,
                issueKey: issueKey
            })));
    const $77c62695b59f030f$export$1e95fb877713bf5e = ()=>{
        const { prefetchedIssues: prefetchedIssues } = (0, (0, parcelRequire("1JH9w")).usePrefetchIssueViewData)();
        const { clearCache: clearCache } = (0, (0, parcelRequire("1JH9w")).usePrefetchIssueViewDataActions)();
        const [selectedIssueKey] = (0, (0, parcelRequire("ieDtd")).useQueryParam)((0, (0, parcelRequire("hE5wF")).SELECTED_ISSUE_PARAM));
        const prevSelectedIssueKey = (0, (0, parcelRequire("1XJ20")).usePreviousWithInitial)(selectedIssueKey);
        (0, $5uXOq.useEffect)(()=>{
            const isIssueAppClosed = prevSelectedIssueKey && !selectedIssueKey;
            const isIssueKeyUpdated = selectedIssueKey && prevSelectedIssueKey && selectedIssueKey !== prevSelectedIssueKey;
            if (isIssueAppClosed || isIssueKeyUpdated) clearCache();
        }, [
            clearCache,
            prevSelectedIssueKey,
            selectedIssueKey
        ]);
        (0, $5uXOq.useEffect)(()=>()=>{
                clearCache();
            }, [
            clearCache
        ]);
        const issues = (0, $5uXOq.useMemo)(()=>Object.keys(prefetchedIssues), [
            prefetchedIssues
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($77c62695b59f030f$var$IssueDataLoader, {
            issues: issues
        });
    };
});
parcelRegister("1JH9w", function(module, exports) {
    $parcel$export(module.exports, "usePrefetchIssueViewData", ()=>$a3ad7c51df3f2dbe$export$519e056a921d9691);
    $parcel$export(module.exports, "usePrefetchIssueViewDataActions", ()=>$a3ad7c51df3f2dbe$export$fee97ccc4dadacbb);
    var $3sQ5x;
    var $iXqE5;
    const $a3ad7c51df3f2dbe$var$ALLOWED_TIME_BETWEEN_PREFETCHES = 500;
    const $a3ad7c51df3f2dbe$var$MAX_DELAY = 300;
    const $a3ad7c51df3f2dbe$var$MIN_DELAY = 0;
    const $a3ad7c51df3f2dbe$export$a87749ac92873cf7 = ()=>100;
    const $a3ad7c51df3f2dbe$var$actions = {
        prefetchIssue: (issueKey)=>({ getState: getState, setState: setState })=>{
                const { timestampOfTheLastPrefetch: timestampOfTheLastPrefetch, prefetchedIssues: prefetchedIssues } = getState();
                const currentTimestamp = Date.now();
                const delay = timestampOfTheLastPrefetch !== null && currentTimestamp - timestampOfTheLastPrefetch < $a3ad7c51df3f2dbe$var$ALLOWED_TIME_BETWEEN_PREFETCHES ? $a3ad7c51df3f2dbe$var$MAX_DELAY : $a3ad7c51df3f2dbe$var$MIN_DELAY;
                const nextPrefetchedIssues = Object.keys(prefetchedIssues).length === $a3ad7c51df3f2dbe$export$a87749ac92873cf7() ? {} : prefetchedIssues;
                setState({
                    prefetchedIssues: delay === $a3ad7c51df3f2dbe$var$MIN_DELAY && !prefetchedIssues[issueKey] ? {
                        ...nextPrefetchedIssues,
                        [issueKey]: true
                    } : prefetchedIssues,
                    timestampOfTheLastPrefetch: currentTimestamp
                });
            },
        clearCache: ()=>({ setState: setState })=>{
                setState({
                    timestampOfTheLastPrefetch: null,
                    prefetchedIssues: {}
                });
            }
    };
    const $a3ad7c51df3f2dbe$var$PrefetchIssueViewStore = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: {
            timestampOfTheLastPrefetch: null,
            prefetchedIssues: {}
        },
        actions: $a3ad7c51df3f2dbe$var$actions,
        name: 'JWMPrefetchIssueViewStore'
    });
    const $a3ad7c51df3f2dbe$export$519e056a921d9691 = (0, (0, parcelRequire("3sQ5x")).createStateHook)($a3ad7c51df3f2dbe$var$PrefetchIssueViewStore);
    const $a3ad7c51df3f2dbe$export$fee97ccc4dadacbb = (0, (0, parcelRequire("3sQ5x")).createActionsHook)($a3ad7c51df3f2dbe$var$PrefetchIssueViewStore);
});
parcelRegister("l1hWj", function(module, exports) {
    $parcel$export(module.exports, "AsyncIssueViewCriticalDataLoader", ()=>$4e841b6ce3a4317a$export$15a49d6c068f7356);
    var $5uXOq = parcelRequire("5uXOq");
    var $7XluA;
    var $4mO32;
    var $bNCEz;
    const $4e841b6ce3a4317a$var$entryPointParams = {};
    const $4e841b6ce3a4317a$export$15a49d6c068f7356 = (0, $5uXOq.memo)((props)=>{
        const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, (0, parcelRequire("4mO32")).useEntryPoint)((0, (0, parcelRequire("bNCEz")).asyncIssueViewCriticalDataLoaderEntrypoint), $4e841b6ce3a4317a$var$entryPointParams);
        (0, $5uXOq.useEffect)(()=>{
            entryPointActions.load();
        }, [
            entryPointActions
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7XluA")).JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "jwm-issue-view-critical-data-loader",
            packageName: "jiraBusinessIssueViewCriticalDataLoader",
            runtimeProps: props
        });
    });
});
parcelRegister("bNCEz", function(module, exports) {
    $parcel$export(module.exports, "asyncIssueViewCriticalDataLoaderEntrypoint", ()=>$4dc1e3141aa0750a$export$6254258f84be452a);
    var $evanD;
    var $7KfpL;
    const $4dc1e3141aa0750a$export$6254258f84be452a = (0, (0, parcelRequire("7KfpL")).createEntryPoint)({
        root: (0, (0, parcelRequire("evanD")).JSResourceForInteraction)(()=>(parcelRequire("Nte5g")), {
            moduleId: "1f53773a"
        }),
        getPreloadProps: ()=>({})
    });
});
parcelRegister("Nte5g", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("93c9T").then(()=>parcelRequire('5h1fq'));
});
parcelRegister("3kVj2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e9988a92625a64f1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bUSNl;
    var $hE5wF;
    var $2gCtH;
    var $gjEtj;
    var $lfTZh;
    var $iXVV6;
    var $8zOmE;
    var $lwMsT;
    var $l8ruj;
    var $1jUsD;
    var $ieDtd;
    const $e9988a92625a64f1$export$843a6e93936e3b60 = (0, (0, parcelRequire("1jUsD")).lazyForPaint)(()=>(parcelRequire("apmLb")), {
        ssr: false,
        moduleId: "./src/packages/issue/issue-view/src/views/issue-details/modal-issue-app.tsx"
    });
    const $e9988a92625a64f1$var$ModalIssueAppWrapper = ({ issueKey: issueKey, onClose: onClose, onChange: onChange, onDeleteSuccess: onDeleteSuccess, analyticsSource: analyticsSource = (0, $fcf97b7a09088940$export$82540942fb014b0a), viewModeSwitchDisabled: viewModeSwitchDisabled, isSoftwareProject: isSoftwareProject })=>{
        const [, setSelectedIssue] = (0, (0, parcelRequire("ieDtd")).useQueryParam)((0, (0, parcelRequire("hE5wF")).SELECTED_ISSUE_PARAM));
        const onIssueKeyChange = (0, $5uXOq.useCallback)(({ toIssueKey: toIssueKey })=>setSelectedIssue(toIssueKey), [
            setSelectedIssue
        ]);
        const [, { setSidebarContent: setSidebarContent }] = (0, (0, parcelRequire("bUSNl")).useSidebar)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const [, { setDetailViewAsSidebar: setDetailViewAsSidebar, setDetailViewAsModal: setDetailViewAsModal }] = (0, (0, parcelRequire("2gCtH")).useIssueContextActions)();
        const onSwitchToModal = (0, $5uXOq.useCallback)(()=>{
            setDetailViewAsModal();
            setSidebarContent(null);
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'issueAppMenuItem clicked', 'switchToModal');
        }, [
            createAnalyticsEvent,
            setDetailViewAsModal,
            setSidebarContent
        ]);
        const onSwitchToSidebar = (0, $5uXOq.useCallback)(()=>{
            setSidebarContent(null);
            setDetailViewAsSidebar();
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'issueAppMenuItem clicked', 'switchToSidebar');
        }, [
            createAnalyticsEvent,
            setDetailViewAsSidebar,
            setSidebarContent
        ]);
        const viewModeOptions = (0, $5uXOq.useMemo)(()=>!viewModeSwitchDisabled ? {
                viewModeSwitchEnabled: true,
                onSwitchToModal: onSwitchToModal,
                onSwitchToSidebar: onSwitchToSidebar
            } : undefined, [
            onSwitchToModal,
            onSwitchToSidebar,
            viewModeSwitchDisabled
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "business-modal-issue-app"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
            sourceName: isSoftwareProject ? 'jswModalIssueApp' : 'jwmModalIssueApp'
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjEtj")).ModalBoundary), {
            packageName: isSoftwareProject ? 'software' : 'business',
            id: "issue-modal"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "modal-issue-app",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($e9988a92625a64f1$export$843a6e93936e3b60, {
            analyticsSource: analyticsSource,
            issueKey: issueKey,
            onClose: onClose,
            onChange: onChange,
            onIssueDeleteSuccess: onDeleteSuccess,
            onIssueKeyChange: onIssueKeyChange,
            viewModeOptions: viewModeOptions
        })))));
    };
    var $e9988a92625a64f1$export$2e2bcd8739ae039 = $e9988a92625a64f1$var$ModalIssueAppWrapper;
});
const $fcf97b7a09088940$export$53d41ff2666118e1 = 'agility-backlog';
const $fcf97b7a09088940$export$7552fe2669628499 = 'bitbucket-issue';
const $fcf97b7a09088940$export$41a718da0a8636f4 = 'connect-issue';
const $fcf97b7a09088940$export$cebf0bc8b2ccaf57 = 'core-issue';
const $fcf97b7a09088940$export$5e91e17726e54450 = 'jiraCalendar';
const $fcf97b7a09088940$export$82540942fb014b0a = 'business-calendar';
const $fcf97b7a09088940$export$7ca28938a07e0c33 = 'business-list';
const $fcf97b7a09088940$export$f6cf06aaaeb58a54 = 'business-timeline';
const $fcf97b7a09088940$export$b2c0462ff17aa26e = 'business-board';
const $fcf97b7a09088940$export$a607850ebccd28ac = 'business-approvals';
const $fcf97b7a09088940$export$1da6cede3561048f = 'business-files';
const $fcf97b7a09088940$export$b19f949fb9713614 = 'full-issue';
const $fcf97b7a09088940$export$a5132300c5214280 = 'embed-issue';
const $fcf97b7a09088940$export$710114090a811b37 = 'global-issue-navigator-issue';
const $fcf97b7a09088940$export$ce88447986394f2d = 'mobile-issue';
const $fcf97b7a09088940$export$6a90d9196d330040 = 'project-issue-navigator';
const $fcf97b7a09088940$export$2247c9059c171db1 = 'roadmap-issue';
const $fcf97b7a09088940$export$cd16d39c55c569d0 = 'simple-software-board';
const $fcf97b7a09088940$export$f72626bf0d75dfad = 'software-backlog-issue';
const $fcf97b7a09088940$export$778b4609e784cb27 = 'software-deployments-issue';
const $fcf97b7a09088940$export$5b73d694a6048002 = 'version-detail-issue';
const $fcf97b7a09088940$export$accce97178e4e049 = 'software-cycle-time-report-issue';
const $fcf97b7a09088940$export$21b5b7189add7861 = 'software-incidents-issue';
const $fcf97b7a09088940$export$9c5d81b901471b27 = 'software-issue';
const $fcf97b7a09088940$export$1735f6ad917dc411 = 'change-calendar';
const $fcf97b7a09088940$export$7063ee6d0035a982 = 'queues-issue-view';
const $fcf97b7a09088940$export$5bd5011b6596a0e7 = 'reports-issue-view';
const $fcf97b7a09088940$export$9dfa9e993d3e0520 = 'forge-full-page-extension';
const $fcf97b7a09088940$export$14a8072f422804fd = 'issue-navigator-next';
parcelRegister("gjEtj", function(module, exports) {
    $parcel$export(module.exports, "ModalBoundary", ()=>$c322f875acea1654$export$c3f500e812fb1bb3);
    var $5uXOq = parcelRequire("5uXOq");
    var $gAeCk;
    var $iqr2y;
    var $heNNl;
    var $lfTZh;
    const $c322f875acea1654$export$c3f500e812fb1bb3 = ({ children: children, id: id, metricKey: metricKey, packageName: packageName, onError: onError })=>{
        const ErrorState = (0, $5uXOq.useCallback)((args)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iqr2y")).ErrorFlagRenderer), {
                id: id,
                error: args.error
            }), [
            id
        ]);
        const fallback = typeof metricKey === 'string' && metricKey.length > 0 ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gAeCk")).default), {
            metricKey: metricKey
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: id,
            packageName: packageName,
            render: ErrorState,
            onError: onError
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: id,
            fallback: fallback
        }, children));
    };
});
parcelRegister("apmLb", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("8SBrF")
    ]).then(()=>parcelRequire('2555l'));
});
parcelRegister("ksKCJ", function(module, exports) {
    $parcel$export(module.exports, "SidebarIssueView", ()=>$15a07712b759f270$export$ccdf533f42a8d6f8);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $bUSNl;
    var $1XJ20;
    var $8zOmE;
    var $lwMsT;
    var $g5X3G;
    var $cZ5o7;
    var $2ax5r;
    const $15a07712b759f270$var$ISSUE_VIEW_SIDEBAR_CONTENT_KEY = 'issueViewSidebar';
    const $15a07712b759f270$var$callWhenIdle = (callback)=>{
        if (typeof window.requestIdleCallback === 'function') window.requestIdleCallback(callback);
        else setTimeout(callback, 3000);
    };
    const $15a07712b759f270$export$ccdf533f42a8d6f8 = (0, $5uXOq.memo)(({ issueKey: issueKey, onClose: onClose, analyticsSource: analyticsSource, onChange: onChange, onIssueDeleteSuccess: onIssueDeleteSuccess, isSoftwareProject: isSoftwareProject })=>{
        const [{ content: content }, { setSidebarContent: setSidebarContent }] = (0, (0, parcelRequire("bUSNl")).useSidebar)();
        const prevIssueKey = (0, (0, parcelRequire("1XJ20")).usePreviousWithInitial)(issueKey);
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        (0, (0, parcelRequire("2ax5r")).useSetSidebarStyleVar)();
        const onCloseSidebar = (0, $5uXOq.useCallback)(()=>{
            onClose();
        }, [
            onClose
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (issueKey === prevIssueKey && !!content) return;
            if (issueKey) {
                const newContent = (0, ($parcel$interopDefault($5uXOq))).createElement($15a07712b759f270$var$CSSAntiCorruptionLayer, {
                    key: $15a07712b759f270$var$ISSUE_VIEW_SIDEBAR_CONTENT_KEY
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cZ5o7")).SidebarIssueApp), {
                    issueKey: (0, (0, parcelRequire("g5X3G")).toIssueKey)(issueKey),
                    onClose: onCloseSidebar,
                    analyticsSource: analyticsSource,
                    onChange: onChange,
                    onIssueDeleteSuccess: onIssueDeleteSuccess,
                    isSoftwareProject: isSoftwareProject
                }));
                setSidebarContent(newContent);
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'sidebarIssueApp opened');
            } else {
                if (content?.key === $15a07712b759f270$var$ISSUE_VIEW_SIDEBAR_CONTENT_KEY) setSidebarContent(null);
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'sidebarIssueApp closed');
            }
        }, [
            analyticsSource,
            content,
            createAnalyticsEvent,
            isSoftwareProject,
            issueKey,
            onChange,
            onCloseSidebar,
            onIssueDeleteSuccess,
            prevIssueKey,
            setSidebarContent
        ]);
        (0, $5uXOq.useEffect)(()=>{
            $15a07712b759f270$var$callWhenIdle(()=>{
                (0, (0, parcelRequire("cZ5o7")).IssueApp).preload();
            });
        }, []);
        return null;
    });
    const $15a07712b759f270$var$CSSAntiCorruptionLayer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1osq _vchhusvi",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("cZ5o7", function(module, exports) {
    $parcel$export(module.exports, "IssueApp", ()=>$f0984329e6d3d9e6$export$35dd9ab573b87c3f);
    $parcel$export(module.exports, "SidebarIssueApp", ()=>$f0984329e6d3d9e6$export$e402f7c18d4d7f37);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $bUSNl;
    var $2gCtH;
    var $7eqRV;
    var $lfTZh;
    var $1XJ20;
    var $iXVV6;
    var $8zOmE;
    var $lwMsT;
    var $c65JB;
    var $l8ruj;
    var $1jUsD;
    const $f0984329e6d3d9e6$export$35dd9ab573b87c3f = (0, (0, parcelRequire("1jUsD")).lazy)(()=>(parcelRequire("jO7eF")), {
        ssr: false,
        moduleId: "./src/packages/issue/issue-view/src/views/issue-details/issue-app.tsx"
    });
    const $f0984329e6d3d9e6$export$e402f7c18d4d7f37 = ({ analyticsSource: analyticsSource, issueKey: issueKey, onClose: onClose, onIssueDeleteSuccess: onIssueDeleteSuccess, onChange: onChange, isSoftwareProject: isSoftwareProject })=>{
        const [currentIssueKey, setCurrentIssueKey] = (0, $5uXOq.useState)(issueKey);
        const prevIssueKey = (0, (0, parcelRequire("1XJ20")).usePreviousWithInitial)(issueKey);
        const onIssueKeyChange = (0, $5uXOq.useCallback)(({ toIssueKey: nextIssueKey })=>{
            setCurrentIssueKey(nextIssueKey);
        }, []);
        const [, { setDetailViewAsSidebar: setDetailViewAsSidebar, setDetailViewAsModal: setDetailViewAsModal }] = (0, (0, parcelRequire("2gCtH")).useIssueContextActions)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const [, { setSidebarContent: setSidebarContent }] = (0, (0, parcelRequire("bUSNl")).useSidebar)();
        (0, $5uXOq.useEffect)(()=>{
            if (prevIssueKey !== issueKey) setCurrentIssueKey(issueKey);
        }, [
            currentIssueKey,
            issueKey,
            prevIssueKey
        ]);
        const onSwitchToModal = (0, $5uXOq.useCallback)(()=>{
            setDetailViewAsModal();
            setSidebarContent(null);
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'issueAppMenuItem clicked', 'switchToModal');
        }, [
            createAnalyticsEvent,
            setDetailViewAsModal,
            setSidebarContent
        ]);
        const onSwitchToSidebar = (0, $5uXOq.useCallback)(()=>{
            setDetailViewAsSidebar();
            setSidebarContent(null);
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'issueAppMenuItem clicked', 'switchToSidebar');
        }, [
            createAnalyticsEvent,
            setDetailViewAsSidebar,
            setSidebarContent
        ]);
        const PACKAGE_NAME = (0, $5uXOq.useMemo)(()=>isSoftwareProject ? 'jswSidebarIssueApp' : 'jwmSidebarIssueApp', [
            isSoftwareProject
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "business-sidebar-issue-app"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
            sourceName: PACKAGE_NAME
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "issue-app",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c65JB")).IssueViewSkeleton), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7eqRV")).IssueBoundary), {
            packageName: PACKAGE_NAME
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($f0984329e6d3d9e6$export$35dd9ab573b87c3f, {
            viewModeOptions: {
                viewMode: 'SIDEBAR',
                viewModeSwitchEnabled: true,
                onSwitchToModal: onSwitchToModal,
                onSwitchToSidebar: onSwitchToSidebar
            },
            issueKey: currentIssueKey,
            analyticsSource: analyticsSource,
            shouldShowCloseButton: true,
            onClose: onClose,
            onIssueKeyChange: onIssueKeyChange,
            shouldSetInitialFocus: true,
            shouldShowRootProjectsBreadcrumb: true,
            onIssueDeleteSuccess: onIssueDeleteSuccess,
            onIssueDeleteFailure: (0, ($parcel$interopDefault($8Rkzz))),
            isSpaEnabled: false,
            isLoadedWithPage: false,
            onChange: onChange
        })))));
    };
});
parcelRegister("7eqRV", function(module, exports) {
    $parcel$export(module.exports, "IssueBoundary", ()=>$e3c8771effba3477$export$fbf48ede0cf52b5a);
    $parcel$export(module.exports, "IssueModalBoundary", ()=>$e3c8771effba3477$export$74d408982642a541);
    var $5uXOq = parcelRequire("5uXOq");
    var $heNNl;
    var $gjEtj;
    var $lfTZh;
    var $c65JB;
    const $e3c8771effba3477$export$fbf48ede0cf52b5a = ({ children: children, isEmbedView: isEmbedView = true, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: "issue",
            ...props
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "issue-boundary",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c65JB")).IssueViewSkeleton), {
                isEmbedView: isEmbedView
            })
        }, children));
    const $e3c8771effba3477$export$74d408982642a541 = ({ children: children, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gjEtj")).ModalBoundary), {
            id: "issue-modal",
            ...props
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "issue-modal-boundary",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c65JB")).IssueViewSkeleton), {
                isModalView: true
            })
        }, children));
});
parcelRegister("jO7eF", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("i5RRW"),
        $6fhBS("dsiAd"),
        $6fhBS("kWrFZ"),
        $6fhBS("kfXhT"),
        $6fhBS("2Lfdl"),
        $6fhBS("eNmuD"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cggv6")
    ]).then(()=>parcelRequire('6qbjz'));
});
parcelRegister("2ax5r", function(module, exports) {
    $parcel$export(module.exports, "useSetSidebarStyleVar", ()=>$f33586d1e0f68dde$export$70b20cd72362e39d);
    var $5uXOq = parcelRequire("5uXOq");
    var $bUSNl;
    var $5e5zm;
    const $f33586d1e0f68dde$var$MARGIN = 24;
    const $f33586d1e0f68dde$export$70b20cd72362e39d = ()=>{
        const [{ content: content, sidebarWidth: sidebarWidth }] = (0, (0, parcelRequire("bUSNl")).useSidebar)();
        const { setWidth: setWidth } = (0, (0, parcelRequire("5e5zm")).useDetailPanelActions)();
        (0, $5uXOq.useEffect)(()=>{
            if (content !== null) {
                document.documentElement?.style.setProperty((0, $563deb1efef5771e$export$c83c5cba188418d8), `${sidebarWidth}px`);
                setWidth(sidebarWidth + $f33586d1e0f68dde$var$MARGIN);
            } else document.documentElement?.style.removeProperty((0, $563deb1efef5771e$export$c83c5cba188418d8));
            return ()=>{
                setWidth(0);
            };
        }, [
            content,
            setWidth,
            sidebarWidth
        ]);
    };
});
const $563deb1efef5771e$export$c83c5cba188418d8 = '--detailPanelWidth';
parcelRegister("fel5A", function(module, exports) {
    $parcel$export(module.exports, "ChildrenController", ()=>$0a07eaf715c6ad45$export$8c3512dd18e9e8f);
    var $5uXOq = parcelRequire("5uXOq");
    const $0a07eaf715c6ad45$export$8c3512dd18e9e8f = (0, $5uXOq.memo)(({ expandedItemIssueIds: expandedItemIssueIds, setChildrenQueryData: setChildrenQueryData, ChildQueryController: ChildQueryController, getHierarchyLevel: getHierarchyLevel })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, expandedItemIssueIds.map((expandedItemIssueId)=>(0, ($parcel$interopDefault($5uXOq))).createElement(ChildQueryController, {
                parentIssueId: expandedItemIssueId,
                parentHierarchyType: (0, $8debe7dace56daea$export$9355e489ad16f98e),
                parentHierarchyLevel: getHierarchyLevel ? getHierarchyLevel(expandedItemIssueId) : undefined,
                onDataChange: setChildrenQueryData,
                key: expandedItemIssueId
            }))), (prevProps, nextProps)=>{
        const prevIssueIds = prevProps.expandedItemIssueIds.sort();
        const nextIssueIds = nextProps.expandedItemIssueIds.sort();
        const prevLoadingIssueIds = prevProps.loadingIssueIds?.sort();
        const nextLoadingIssueIds = nextProps.loadingIssueIds?.sort();
        let loadingIssuesMatch = true;
        if (prevLoadingIssueIds === undefined || nextLoadingIssueIds === undefined) loadingIssuesMatch = prevLoadingIssueIds === nextLoadingIssueIds;
        else loadingIssuesMatch = prevLoadingIssueIds?.length === nextLoadingIssueIds?.length && prevLoadingIssueIds.every((_, id)=>prevLoadingIssueIds[id] === nextLoadingIssueIds[id]);
        return prevProps.setChildrenQueryData === nextProps.setChildrenQueryData && prevIssueIds.length === nextIssueIds.length && prevIssueIds.every((_, id)=>prevIssueIds[id] === nextIssueIds[id]) && loadingIssuesMatch;
    });
});
parcelRegister("34tvt", function(module, exports) {
    $parcel$export(module.exports, "LoadingMoreSpinner", ()=>$776b33c539b903b3$export$3b637ef4fd5e113c);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $6Ll2T;
    var $99gde;
    var $113Tq;
    const $776b33c539b903b3$export$3b637ef4fd5e113c = ({ isLoading: isLoading, loadingMessage: loadingMessage })=>{
        const [isVisible, setIsVisible] = (0, $5uXOq.useState)(false);
        (0, $5uXOq.useEffect)(()=>{
            if (isLoading) setIsVisible(true);
        }, [
            isLoading
        ]);
        const onAnimationEnd = ()=>{
            if (!isLoading) setIsVisible(false);
        };
        if (!isVisible) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($776b33c539b903b3$var$SpinnerContainer, {
            "data-testid": "business-load-more-spinner"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($776b33c539b903b3$var$SpinnerWrapper, {
            isVisible: isLoading,
            onAnimationEnd: onAnimationEnd
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("113Tq")).default), {
            appearance: "invert",
            size: "small"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            xcss: $776b33c539b903b3$var$spinnerTextStyles
        }, loadingMessage)));
    };
    const $776b33c539b903b3$var$appear = null;
    const $776b33c539b903b3$var$disappear = null;
    const $776b33c539b903b3$var$SpinnerContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _94n5xncg _1e0c1txw _4cvr1h6o _1bah1h6o _1bsb1osq _1pbyb4wl",
                __cmplp.className
            ])
        });
    });
    const $776b33c539b903b3$var$SpinnerWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isVisible: isVisible, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1b1v _1yt42uwm _11q7gkf6 _syaz15cr _2rko1sit _k48pbfng _1wyb1skh _16qsozdn",
                __cmplp.isVisible && "",
                __cmplp.isVisible && "_y44v1d47",
                !__cmplp.isVisible && "",
                !__cmplp.isVisible && "_y44vj404",
                __cmplp.className
            ])
        });
    });
    const $776b33c539b903b3$var$spinnerTextStyles = (0, (0, parcelRequire("99gde")).xcss)({
        marginLeft: 'space.100'
    });
});
parcelRegister("8HvEs", function(module, exports) {
    $parcel$export(module.exports, "PerformanceAnalytics", ()=>$0eced7986dcab954$export$ec3c3b39c046a620);
    var $5uXOq = parcelRequire("5uXOq");
    var $7NUKB;
    var $2nbdU;
    var $3vR0I;
    var $7Wnap;
    const $0eced7986dcab954$export$ec3c3b39c046a620 = (0, $5uXOq.memo)(({ view: view, loading: loading, itemsCount: itemsCount, attributes: attributes })=>{
        const loadingRef = (0, $5uXOq.useRef)(loading);
        loadingRef.current = loading;
        if (loading === true) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7NUKB")).default), {
            name: "performance-analytics-loading"
        });
        const scrollElement = false ? null : document.getElementById((0, $c15b7ab4e654e0c4$export$e5e75ff4daca6597));
        const product = view.startsWith('software') ? 'jsw' : 'jwm';
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7Wnap")).PageLoadMetrics), {
            view: view,
            attributes: attributes,
            product: product
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3vR0I")).FirstInteractionMetric), {
            view: view,
            product: product
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2nbdU")).default), {
            viewId: `${product}.${view}`,
            scrollElement: scrollElement,
            itemsCount: itemsCount,
            attributes: attributes
        }));
    });
});
parcelRegister("2nbdU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$551da07557368f71$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8zOmE;
    var $lwMsT;
    const $551da07557368f71$export$df7175b69b5630dd = (frames, elapsedMs)=>Math.min(Math.floor(1000 * (frames / elapsedMs)), (0, $ed1164448c2018a0$export$9d3e6d8a99023567));
    const $551da07557368f71$export$46962be62755f053 = (0, $5uXOq.memo)(({ viewId: viewId, itemsCount: itemsCount, samplingRate: samplingRate = (0, $ed1164448c2018a0$export$71d024136796e395), scrollElement: scrollElement, attributes: attributes })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const samplingCount = (0, $5uXOq.useRef)(0);
        const frames = (0, $5uXOq.useRef)(0);
        const rafId = (0, $5uXOq.useRef)(null);
        const start = (0, $5uXOq.useRef)(0);
        (0, $5uXOq.useEffect)(()=>{
            const container = scrollElement ?? document;
            const hasScrollCapture = true;
            const tick = ()=>{
                if (frames.current < (0, $ed1164448c2018a0$export$299249b1dad3b14a)) {
                    frames.current += 1;
                    rafId.current = requestAnimationFrame(tick);
                } else {
                    const stopTime = performance.now();
                    const elapsedMs = stopTime - start.current;
                    const fps = $551da07557368f71$export$df7175b69b5630dd(frames.current, elapsedMs);
                    const avgFrameDuration = Math.floor(elapsedMs / frames.current);
                    frames.current = 0;
                    const attr = {
                        ...attributes || {},
                        itemsCount: itemsCount,
                        avgFrameDuration: avgFrameDuration,
                        fps: fps
                    };
                    (0, (0, parcelRequire("8zOmE")).fireOperationalAnalyticsDeferred)(createAnalyticsEvent({}), `${viewId} scrolled`, attr);
                }
            };
            const handleOnScroll = ()=>{
                samplingCount.current += 1;
                if (samplingCount.current !== samplingRate) return;
                samplingCount.current = 0;
                start.current = performance.now();
                tick();
            };
            container.addEventListener('scroll', handleOnScroll, hasScrollCapture);
            return ()=>{
                container.removeEventListener('scroll', handleOnScroll, hasScrollCapture);
                if (rafId.current) cancelAnimationFrame(rafId.current);
            };
        }, [
            scrollElement,
            createAnalyticsEvent,
            itemsCount,
            samplingRate,
            viewId,
            attributes
        ]);
        return null;
    });
    var $551da07557368f71$export$2e2bcd8739ae039 = $551da07557368f71$export$46962be62755f053;
});
const $ed1164448c2018a0$export$71d024136796e395 = 100;
const $ed1164448c2018a0$export$299249b1dad3b14a = 20;
const $ed1164448c2018a0$export$9d3e6d8a99023567 = 60;
parcelRegister("3vR0I", function(module, exports) {
    $parcel$export(module.exports, "FirstInteractionMetric", ()=>$43e497a79074b7d0$export$70b569bf2edd0b7f);
    var $5uXOq = parcelRequire("5uXOq");
    var $8zOmE;
    var $lwMsT;
    const $43e497a79074b7d0$export$70b569bf2edd0b7f = ({ view: view, product: product = 'jwm' })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        (0, $5uXOq.useEffect)(()=>{
            const container = document.getElementById((0, $c15b7ab4e654e0c4$export$e5e75ff4daca6597)) ?? document;
            const hasScrollCapture = true;
            const startTime = performance.now();
            const handleFirstClick = ()=>{
                (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), `${product}.${view}.first-interaction clicked`, {
                    duration: performance.now() - startTime
                });
                container.removeEventListener('click', handleFirstClick);
            };
            const handleFirstScroll = ()=>{
                (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), `${product}.${view}.first-interaction scrolled`, {
                    duration: performance.now() - startTime
                });
                container.removeEventListener('scroll', handleFirstScroll, hasScrollCapture);
            };
            container.addEventListener('click', handleFirstClick);
            container.addEventListener('scroll', handleFirstScroll, hasScrollCapture);
            return ()=>{
                container.removeEventListener('click', handleFirstClick);
                container.removeEventListener('scroll', handleFirstScroll, hasScrollCapture);
            };
        }, [
            createAnalyticsEvent,
            view,
            product
        ]);
        return null;
    };
});
parcelRegister("7Wnap", function(module, exports) {
    $parcel$export(module.exports, "RenderStartMark", ()=>$4c177752bab6a832$export$2128f295d6adb861);
    $parcel$export(module.exports, "PageLoadMetrics", ()=>$4c177752bab6a832$export$66b33c055cbb625e);
    var $5uXOq = parcelRequire("5uXOq");
    var $5rqex;
    var $gN11a;
    const $4c177752bab6a832$export$2128f295d6adb861 = ({ view: view, loading: loading })=>{
        if (loading === true) return null;
        (0, (0, parcelRequire("gN11a")).markViewMetric)(view, (0, $a286480ec63fa4c8$export$b78f0bbf209e5f4));
        return null;
    };
    const $4c177752bab6a832$export$66b33c055cbb625e = (0, $5uXOq.memo)(({ view: view, attributes: attributes, product: product = 'jwm' })=>{
        (0, (0, parcelRequire("gN11a")).markViewMetric)(view, (0, $a286480ec63fa4c8$export$88ea1e280513690f));
        const metric = (0, (0, parcelRequire("gN11a")).pageLoadMetrics)[view];
        return metric && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5rqex")).default), {
            appName: `${product}.${view}`,
            metric: metric,
            extra: attributes
        });
    });
});
parcelRegister("5rqex", function(module, exports) {
    $parcel$export(module.exports, "checkAndEmitApdexSignal", ()=>$ab527e70454bab7e$export$3082c88b693a5230);
    $parcel$export(module.exports, "default", ()=>$ab527e70454bab7e$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "baseDefaultProps", ()=>$ab527e70454bab7e$export$9b3029ee6188a41f);
    var $5uXOq = parcelRequire("5uXOq");
    var $czVoz;
    var $9TpzN;
    var $d7oXH;
    var $co1wz;
    var $2m0sQ;
    var $6G6w0;
    var $3wLoG;
    var $gtdbK;
    var $zbAs4;
    var $3B7oW;
    const $ab527e70454bab7e$export$3082c88b693a5230 = (appName, metricKey)=>{
        var emitSignal;
    };
    class $ab527e70454bab7e$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = {
                isExpectedToHaveSsr: false,
                withMarks: [],
                extra: {},
                emitOnAnimationFrame: false
            };
        }
        render() {
            const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
            $ab527e70454bab7e$export$3082c88b693a5230(appName, metricKey);
            const isUFODefined = (0, (0, parcelRequire("co1wz")).ff)('uip.ufo') && (0, (0, parcelRequire("2m0sQ")).GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
            if (isUFODefined) (0, (0, parcelRequire("zbAs4")).addUFOSSRDoneAsFMPToInteraction)();
            if (metric) {
                (0, (0, parcelRequire("gtdbK")).addBM3SSRDoneAsFMPToInteraction)(metric);
                (0, (0, parcelRequire("3B7oW")).trackBM3FeatureFlagsAccessed)(metric);
            }
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("czVoz")).default), {
                data: extra
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9TpzN")).UFOBM3TimingsToUFO), {
                marks: metric?.getData()?.marks,
                timings: metric?.getData()?.config?.timings
            }), isUFODefined ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3wLoG")).StopUfo), {
                appName: appName,
                customData: extra,
                key: (0, (0, parcelRequire("d7oXH")).getInteractionId)().current
            }) : metric && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6G6w0")).StopBrowserMetrics3), {
                metric: metric,
                customData: extra,
                emitOnAnimationFrame: emitOnAnimationFrame
            }));
        }
    }
    const $ab527e70454bab7e$export$9b3029ee6188a41f = $ab527e70454bab7e$export$2e2bcd8739ae039.defaultProps;
});
parcelRegister("9TpzN", function(module, exports) {
    $parcel$export(module.exports, "getBm3Timings", ()=>$886eecd9178dd67d$export$f02972da195a43bb);
    $parcel$export(module.exports, "UFOBM3TimingsToUFO", ()=>$886eecd9178dd67d$export$30f0b5e5acd268bf);
    $parcel$export(module.exports, "addBM3TimingsToUFO", ()=>$886eecd9178dd67d$export$d93d677ef2f33c5c);
    var $5uXOq = parcelRequire("5uXOq");
    var $bvsv1;
    var $d7oXH;
    var $knQnR;
    function $886eecd9178dd67d$export$f02972da195a43bb(marks, timingConfigs) {
        const bm3Timings = {};
        if (!marks || !timingConfigs) return bm3Timings;
        timingConfigs.forEach((item)=>{
            if (!item.startMark || !item.endMark) return;
            const startTime = marks[item.startMark];
            if (!startTime) return;
            const endTime = marks[item.endMark];
            if (!endTime) return;
            bm3Timings[item.key] = {
                startTime: startTime,
                endTime: endTime
            };
        });
        return bm3Timings;
    }
    function $886eecd9178dd67d$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
        const interactionContext = (0, $5uXOq.useContext)((0, (0, parcelRequire("bvsv1")).default));
        const interactionId = (0, (0, parcelRequire("d7oXH")).getInteractionId)().current;
        (0, $5uXOq.useMemo)(()=>{
            if (interactionContext != null && interactionId != null && marks != null && timings != null) {
                const interactionType = (0, (0, parcelRequire("knQnR")).getCurrentInteractionType)(interactionId);
                if (interactionType === 'press') return;
                const bm3Timings = $886eecd9178dd67d$export$f02972da195a43bb(marks, timings);
                interactionContext.addCustomTimings(bm3Timings);
            }
        }, [
            interactionContext,
            interactionId,
            marks,
            timings
        ]);
        return null;
    }
    function $886eecd9178dd67d$export$d93d677ef2f33c5c(marks, timingsConfig) {
        const interactionId = (0, (0, parcelRequire("d7oXH")).getInteractionId)().current;
        if (interactionId) {
            const interactionType = (0, (0, parcelRequire("knQnR")).getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $886eecd9178dd67d$export$f02972da195a43bb(marks, timingsConfig);
            (0, (0, parcelRequire("knQnR")).addCustomTiming)(interactionId, [], bm3Timings);
        }
    }
});
parcelRegister("6G6w0", function(module, exports) {
    $parcel$export(module.exports, "StopBrowserMetrics3", ()=>$84d0d168ebb35c8a$export$575e93c0f9905999);
    var $5uXOq = parcelRequire("5uXOq");
    var $bvsv1;
    var $9efn2;
    var $x9xyg;
    var $7N30e;
    var $co1wz;
    var $4dRjY;
    var $2SVPM;
    var $6b6Tk;
    const $84d0d168ebb35c8a$var$emitMetrics = (metric, customData, stopTime)=>{
        !(0, (0, parcelRequire("co1wz")).ff)('bm3.emit-on-raf.top-experiences') && (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, (0, parcelRequire("4dRjY")).PRODUCT_START_MARK), true);
        (0, (0, parcelRequire("2SVPM")).setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
        if (stopTime !== undefined) {
            if (!(0, (0, parcelRequire("co1wz")).ff)('bm3.wait-for-long-task')) {
                metric.mark((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, (0, parcelRequire("x9xyg")).setMark)((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, (0, parcelRequire("x9xyg")).setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $ce556f125dee8174$export$99c08ec92759c71c));
            }
            metric.stop({
                customData: customData,
                stopTime: stopTime
            });
        } else metric.stop({
            customData: customData
        });
        if ((0, (0, parcelRequire("6b6Tk")).isAutomaticExposureCollectionEnabled)()) (0, (0, parcelRequire("7N30e")).stopLowPriorityEventDelay)();
    };
    class $84d0d168ebb35c8a$export$575e93c0f9905999 extends (0, $5uXOq.Component) {
        componentDidMount() {
            const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
            if (!metric) return;
            const start = (0, (0, parcelRequire("co1wz")).ff)('bm3.wait-for-long-task') ? (0, (0, parcelRequire("9efn2")).browserMetrics).getPageLoadMetric().getData()?.start || 0 : 0;
            (0, (0, parcelRequire("x9xyg")).setMark)('BROWSER_METRICS_TTI_START', {
                startTime: start
            });
            (0, (0, parcelRequire("x9xyg")).setMark)('BROWSER_METRICS_TTI_END');
            (0, (0, parcelRequire("x9xyg")).setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
            const bm3Data = metric.getData();
            if (emitOnAnimationFrame) {
                const stopTime = performance.now();
                (0, (0, parcelRequire("co1wz")).ff)('bm3.emit-on-raf.top-experiences') && (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, (0, parcelRequire("4dRjY")).PRODUCT_START_MARK), true);
                if (bm3Data) this.context?.addApdex({
                    key: bm3Data.key,
                    startTime: bm3Data.start,
                    stopTime: stopTime
                });
                if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                    (0, (0, parcelRequire("x9xyg")).setMark)('BROWSER_METRICS_TTI_TASK_END');
                    (0, (0, parcelRequire("x9xyg")).setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
                });
                requestAnimationFrame(()=>{
                    if ((0, (0, parcelRequire("co1wz")).ff)('bm3.wait-for-long-task')) {
                        metric.mark((0, $ce556f125dee8174$export$99c08ec92759c71c));
                        (0, (0, parcelRequire("x9xyg")).setMark)((0, $ce556f125dee8174$export$99c08ec92759c71c));
                        (0, (0, parcelRequire("x9xyg")).setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $ce556f125dee8174$export$99c08ec92759c71c));
                    }
                    if ((0, (0, parcelRequire("co1wz")).ff)('bm3.wait-for-long-task')) setTimeout(()=>{
                        $84d0d168ebb35c8a$var$emitMetrics(metric, customData, stopTime);
                    }, 500);
                    else $84d0d168ebb35c8a$var$emitMetrics(metric, customData, stopTime);
                });
            } else {
                if (bm3Data) this.context?.addApdex({
                    key: bm3Data.key,
                    startTime: bm3Data.start,
                    stopTime: performance.now()
                });
                (0, (0, parcelRequire("co1wz")).ff)('bm3.emit-on-raf.top-experiences') && (0, (0, parcelRequire("2SVPM")).stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, (0, parcelRequire("4dRjY")).PRODUCT_START_MARK), true);
                $84d0d168ebb35c8a$var$emitMetrics(metric, customData);
            }
        }
        static{
            this.contextType = (0, (0, parcelRequire("bvsv1")).default);
        }
        render() {
            return null;
        }
    }
});
parcelRegister("4dRjY", function(module, exports) {
    $parcel$export(module.exports, "PRODUCT_START_MARK", ()=>$9953c23a4f71adac$export$8e54fca0a680fdfd);
    $parcel$export(module.exports, "MarkProductStart", ()=>$9953c23a4f71adac$export$2a999c5f84501025);
    var $x9xyg;
    const $9953c23a4f71adac$export$8e54fca0a680fdfd = 'PRODUCT_START';
    const $9953c23a4f71adac$export$2a999c5f84501025 = ()=>{
        if (!false) {
            performance.clearMarks($9953c23a4f71adac$export$8e54fca0a680fdfd);
            (0, (0, parcelRequire("x9xyg")).setMark)($9953c23a4f71adac$export$8e54fca0a680fdfd);
        }
        return null;
    };
});
const $ce556f125dee8174$export$56940a9488e85199 = 'jira.fe.spa-';
const $ce556f125dee8174$export$45c4b6bf7935c69a = `${$ce556f125dee8174$export$56940a9488e85199}start`;
const $ce556f125dee8174$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $ce556f125dee8174$export$ff834eccc35b9089 = 'appBundleReady';
const $ce556f125dee8174$export$86b05e34d462ead8 = 'prefetchApiReady';
const $ce556f125dee8174$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $ce556f125dee8174$export$1211adfff27a31fe = 'issueViewInitialDataReady';
const $ce556f125dee8174$export$3ae43cc1782d058f = 'jswRenderStart';
const $ce556f125dee8174$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $ce556f125dee8174$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $ce556f125dee8174$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $ce556f125dee8174$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $ce556f125dee8174$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $ce556f125dee8174$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $ce556f125dee8174$export$99c08ec92759c71c = 'tti-raf-mark';
const $ce556f125dee8174$export$48552baa9db8ce1d = 'tti-raf';
parcelRegister("3wLoG", function(module, exports) {
    $parcel$export(module.exports, "StopUfo", ()=>$bc9c50f4292c4530$export$d91154f099475c5);
    var $5uXOq = parcelRequire("5uXOq");
    var $bvsv1;
    var $2m0sQ;
    class $bc9c50f4292c4530$export$d91154f099475c5 extends (0, $5uXOq.Component) {
        componentDidMount() {
            const { customData: customData, appName: appName } = this.props;
            (0, (0, parcelRequire("2m0sQ")).GlobalPageLoadExperience).success({
                force: true,
                metadata: customData
            });
            const name = appName || (0, (0, parcelRequire("2m0sQ")).GlobalPageLoadExperience).loadingPageLoadId;
            if (name) this.context?.addApdex({
                key: name,
                stopTime: performance.now()
            });
        }
        static{
            this.contextType = (0, (0, parcelRequire("bvsv1")).default);
        }
        render() {
            return null;
        }
    }
});
parcelRegister("gtdbK", function(module, exports) {
    $parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", ()=>$9088c71f7c9189f4$export$bf239ac2bfb04967);
    var $d7oXH;
    var $knQnR;
    function $9088c71f7c9189f4$export$bf239ac2bfb04967(metric) {
        const interactionId = (0, (0, parcelRequire("d7oXH")).getInteractionId)();
        const currentInteractionId = interactionId.current;
        if (!currentInteractionId) return;
        const data = metric.getData();
        const config = data?.config;
        if (config && data?.isInitial) (0, (0, parcelRequire("knQnR")).addMetadata)(currentInteractionId, {
            __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
        });
    }
});
parcelRegister("zbAs4", function(module, exports) {
    $parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", ()=>$30d390cd1767d57f$export$e63862cd888fe05a);
    var $d7oXH;
    var $knQnR;
    var $2m0sQ;
    var $h9AzB;
    async function $30d390cd1767d57f$export$e63862cd888fe05a() {
        const interactionId = (0, (0, parcelRequire("d7oXH")).getInteractionId)();
        const currentInteractionId = interactionId.current;
        if (!currentInteractionId) return;
        const data = await (0, (0, parcelRequire("2m0sQ")).GlobalPageLoadExperience).exportData();
        const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, (0, parcelRequire("h9AzB")).payloadPublisher).ssr?.getDoneMark();
        if (data.initial && fmpMark) (0, (0, parcelRequire("knQnR")).addMetadata)(currentInteractionId, {
            __legacy__ufoConfigSSRDoneAsFmp: true
        });
    }
});
parcelRegister("3B7oW", function(module, exports) {
    $parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", ()=>$afa764d83f81f55e$export$f00f1e874ce869e9);
    var $d7oXH;
    var $y7eb2;
    const $afa764d83f81f55e$var$startsAsObject = (value)=>{
        try {
            if (value.charAt(0) === '{') return true;
        } catch (e) {
            return false;
        }
        return false;
    };
    const $afa764d83f81f55e$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
    const $afa764d83f81f55e$var$isString = (input)=>{
        let result;
        try {
            result = typeof input === 'string' || input instanceof String;
        } catch (err) {
            result = false;
        }
        return result;
    };
    const $afa764d83f81f55e$export$7b4abba432e57989 = (value)=>$afa764d83f81f55e$var$isString(value) && $afa764d83f81f55e$var$startsAsObject(value) || $afa764d83f81f55e$var$isObject(value);
    const $afa764d83f81f55e$export$fcc03ee4c944962f = (featureFlagValue)=>$afa764d83f81f55e$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
    const $afa764d83f81f55e$export$d2818866b4acbea4 = new Map();
    const $afa764d83f81f55e$export$f00f1e874ce869e9 = (metric)=>{
        const interactionId = (0, (0, parcelRequire("d7oXH")).getInteractionId)();
        const currentInteractionId = interactionId.current;
        if (!currentInteractionId) return;
        const data = metric.getData();
        const config = data?.config;
        if (config && config?.featureFlags?.length) {
            const allFeatureFlags = (0, (0, parcelRequire("y7eb2")).default)();
            config.featureFlags.forEach((featureFlagName)=>{
                const value = allFeatureFlags[featureFlagName];
                if (value === undefined) return;
                const featureFlagValue = $afa764d83f81f55e$export$fcc03ee4c944962f(value);
                $afa764d83f81f55e$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
            });
        }
    };
});
parcelRegister("7yduy", function(module, exports) {
    $parcel$export(module.exports, "JWMSpaStatePageReady", ()=>$150b436063f0aaae$export$d54524c142a057f);
    var $5uXOq = parcelRequire("5uXOq");
    var $dZw8H;
    const $150b436063f0aaae$export$d54524c142a057f = ()=>{
        const [isReady, setIsReady] = (0, $5uXOq.useState)(false);
        (0, $5uXOq.useEffect)(()=>{
            let id = window.requestAnimationFrame(()=>{
                id = window.requestAnimationFrame(()=>{
                    setIsReady(true);
                });
            });
            return ()=>{
                window.cancelAnimationFrame(id);
            };
        }, []);
        if (!isReady) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dZw8H")).SpaStatePageReady), null);
    };
});
parcelRegister("lS7Bl", function(module, exports) {
    $parcel$export(module.exports, "RoadmapListItemContentLite", ()=>$bb868b29a8434a13$export$6049b0f2a203677);
    var $5uXOq = parcelRequire("5uXOq");
    var $kVRrg;
    const $bb868b29a8434a13$export$6049b0f2a203677 = ({ title: title, iconUrl: iconUrl, itemKey: itemKey, isDone: isDone })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kVRrg")).SummaryContainer), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kVRrg")).SummaryIcon), {
            src: iconUrl,
            alt: ""
        }), itemKey && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kVRrg")).SummaryKeyLabel), {
            isDone: isDone
        }, itemKey), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kVRrg")).SummaryTitle), {
            type: "div"
        }, title));
    $bb868b29a8434a13$export$6049b0f2a203677.defaultProps = {
        iconUrl: '',
        isDone: false
    };
});
parcelRegister("kVRrg", function(module, exports) {
    $parcel$export(module.exports, "SummaryContainer", ()=>$d63c83f876afad24$export$bd55427d3650a1b0);
    $parcel$export(module.exports, "SummaryIcon", ()=>$d63c83f876afad24$export$ced6452f422b797e);
    $parcel$export(module.exports, "SummaryKeyLink", ()=>$d63c83f876afad24$export$a0a8cbd1a9f0ffc8);
    $parcel$export(module.exports, "SummaryKeyLabel", ()=>$d63c83f876afad24$export$f769aedd3eaca4c3);
    $parcel$export(module.exports, "SummaryTitle", ()=>$d63c83f876afad24$export$ec39b3a5dbed0806);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $3srSR;
    var $99gde;
    var $loZC0;
    var $6s1PB;
    var $4R6GH;
    var $koVbs;
    var $dCm1o;
    var $2zNw6;
    const $d63c83f876afad24$var$containerStylesCompiledStylesOld = null;
    const $d63c83f876afad24$var$iconStylesCompiledStyles = null;
    const $d63c83f876afad24$var$keyStylesCompiledStyles = null;
    const $d63c83f876afad24$var$keyStylesCompiledStylesOld = null;
    const $d63c83f876afad24$var$doneStylesCompiledStyles = null;
    const $d63c83f876afad24$var$titleStylesCompiledStyles = null;
    const $d63c83f876afad24$var$titleStylesCompiledStylesOld = null;
    const $d63c83f876afad24$export$bd55427d3650a1b0 = ({ children: children })=>(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_1') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3srSR")).default), {
            alignItems: "center",
            xcss: $d63c83f876afad24$var$containerStylesCompiledStyles
        }, children) : (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx2vrvc _1reo15vq _18m915vq _4cvr1h6o _1bto1l2s _1bsb1osq _1yt4swc3"
            ])
        }, children);
    const $d63c83f876afad24$export$ced6452f422b797e = ({ alt: alt, src: src })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const iconLabelMessage = (0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("2zNw6")).default).iconLabelIssueTermRefresh : (0, (0, parcelRequire("2zNw6")).default).iconLabel;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("loZC0")).default), {
            content: alt
        }, (tooltipProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement("img", {
                src: src,
                alt: alt,
                "aria-label": alt ? formatMessage(iconLabelMessage, {
                    issueType: alt
                }) : undefined,
                "data-testid": "roadmap.timeline-table-kit.common.ui.summary.icon",
                ...tooltipProps,
                className: (0, (0, parcelRequire("bwpsq")).default)([
                    "_1bsbpxbi _4t3ipxbi _2rko1l7b _16jlidpf _1o9zidpf _i0dl1wug"
                ])
            }));
    };
    const $d63c83f876afad24$export$a0a8cbd1a9f0ffc8 = ({ children: children, isDone: isDone, testId: testId, ...rest })=>{
        const shouldApplyVisualRefreshChanges = (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_1');
        return (0, ($parcel$interopDefault($5uXOq))).createElement("a", {
            "data-testid": testId,
            ...rest,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                shouldApplyVisualRefreshChanges ? "_1wyb1lkt _12ji1r31 _1qu2glyw _12y31o36 _18s84w17 _o5721q9c _syaz131l _k48p1wq8 _4bfu18uv _1nrm18uv _1a3b18uv _9oik18uv _1hmsglyw _c2waglyw _4fprglyw _1bnxglyw _ajmmnqa1 _1iohnqa1 _5goinqa1 _jf4cnqa1 _9h8h131l _f8pj131l _30l3131l" : "_1wybdlk8 _12ji1r31 _1qu2glyw _12y31o36 _18s8171m _o5721q9c _syaz1rc1 _9h8h1rc1 _f8pj1rc1 _30l31rc1 _4bfu18uv _1nrm18uv _1a3b18uv _9oik18uv _1hmsglyw _c2waglyw _4fprglyw _1bnxglyw _ajmmnqa1 _1iohnqa1 _5goinqa1 _jf4cnqa1",
                isDone && "_4bfu18uv _1nrm18uv _1a3b18uv _9oik18uv _1hms1911 _c2wa1911 _4fpr1911 _1bnx1911 _ajmmnqa1 _1iohnqa1 _5goinqa1 _jf4cnqa1"
            ])
        }, children);
    };
    const $d63c83f876afad24$export$f769aedd3eaca4c3 = ({ children: children, isDone: isDone, testId: testId, ...rest })=>{
        const shouldApplyVisualRefreshChanges = (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_1');
        return (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            "data-testid": testId,
            ...rest,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                shouldApplyVisualRefreshChanges ? "_1wyb1lkt _12ji1r31 _1qu2glyw _12y31o36 _18s84w17 _o5721q9c _syaz131l _k48p1wq8 _4bfu18uv _1nrm18uv _1a3b18uv _9oik18uv _1hmsglyw _c2waglyw _4fprglyw _1bnxglyw _ajmmnqa1 _1iohnqa1 _5goinqa1 _jf4cnqa1 _9h8h131l _f8pj131l _30l3131l" : "_1wybdlk8 _12ji1r31 _1qu2glyw _12y31o36 _18s8171m _o5721q9c _syaz1rc1 _9h8h1rc1 _f8pj1rc1 _30l31rc1 _4bfu18uv _1nrm18uv _1a3b18uv _9oik18uv _1hmsglyw _c2waglyw _4fprglyw _1bnxglyw _ajmmnqa1 _1iohnqa1 _5goinqa1 _jf4cnqa1",
                isDone && "_4bfu18uv _1nrm18uv _1a3b18uv _9oik18uv _1hms1911 _c2wa1911 _4fpr1911 _1bnx1911 _ajmmnqa1 _1iohnqa1 _5goinqa1 _jf4cnqa1"
            ])
        }, children);
    };
    const $d63c83f876afad24$export$ec39b3a5dbed0806 = ({ type: type, testId: testId, children: children })=>{
        const shouldApplyVisualRefreshChanges = (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_1');
        switch(type){
            case 'div':
                return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    "data-testid": testId,
                    className: (0, (0, parcelRequire("bwpsq")).default)([
                        shouldApplyVisualRefreshChanges ? "_18s84w17 _1reo15vq _18m915vq _1bto1l2s _o5721q9c _16jlkb7n" : "_18s8171m _1reo15vq _18m915vq _1bto1l2s _o5721q9c _16jlkb7n"
                    ])
                }, children);
            case 'p':
            default:
                return (0, ($parcel$interopDefault($5uXOq))).createElement("p", {
                    "data-testid": testId,
                    className: (0, (0, parcelRequire("bwpsq")).default)([
                        shouldApplyVisualRefreshChanges ? "_18s84w17 _1reo15vq _18m915vq _1bto1l2s _o5721q9c _16jlkb7n" : "_18s8171m _1reo15vq _18m915vq _1bto1l2s _o5721q9c _16jlkb7n"
                    ])
                }, children);
        }
    };
    const $d63c83f876afad24$var$containerStylesCompiledStyles = (0, (0, parcelRequire("99gde")).xcss)({
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        width: '100%',
        paddingLeft: 'space.050',
        paddingTop: 'space.050',
        paddingBottom: 'space.050'
    });
});
parcelRegister("2zNw6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f9e58619800ac14e$export$2e2bcd8739ae039);
    var $7VHMR;
    var $f9e58619800ac14e$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        iconLabel: {
            "id": "roadmap.timeline-table-kit.common.summary.icon-label",
            "defaultMessage": "issue type {issueType}"
        },
        iconLabelIssueTermRefresh: {
            "id": "roadmap.timeline-table-kit.common.summary.icon-label-issue-term-refresh",
            "defaultMessage": "{issueType}"
        }
    });
});
parcelRegister("g3prf", function(module, exports) {
    $parcel$export(module.exports, "useHeaderState", ()=>$2776b7d6c4501657$export$704ca874967743c3);
    $parcel$export(module.exports, "useAriaRowOffset", ()=>$2776b7d6c4501657$export$21de272f1555a588);
    $parcel$export(module.exports, "useHeaderItemIndexes", ()=>$2776b7d6c4501657$export$665cd3c10cd5eb7);
    $parcel$export(module.exports, "default", ()=>$2776b7d6c4501657$export$2e2bcd8739ae039);
    var $gg7kZ;
    var $3sQ5x;
    var $iXqE5;
    var $iZN6h;
    var $kKwEI;
    var $1Abrp;
    const $2776b7d6c4501657$var$initialState = {
        headerItems: [],
        headerHeight: (0, (0, parcelRequire("iZN6h")).BASE_HEADER_HEIGHT),
        headerItemsOffsetTop: {},
        isRowCountKnown: true
    };
    const $2776b7d6c4501657$export$52342bdf89fb39e7 = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $2776b7d6c4501657$var$initialState,
        actions: (0, parcelRequire("kKwEI")).actions,
        name: 'timeline-table.header'
    });
    const $2776b7d6c4501657$export$704ca874967743c3 = (0, (0, parcelRequire("3sQ5x")).createHook)($2776b7d6c4501657$export$52342bdf89fb39e7);
    const $2776b7d6c4501657$export$21de272f1555a588 = (0, (0, parcelRequire("3sQ5x")).createHook)($2776b7d6c4501657$export$52342bdf89fb39e7, {
        selector: ({ isRowCountKnown: isRowCountKnown, headerItems: headerItems })=>isRowCountKnown ? headerItems.length : undefined
    });
    const $2776b7d6c4501657$export$665cd3c10cd5eb7 = (0, (0, parcelRequire("3sQ5x")).createHook)($2776b7d6c4501657$export$52342bdf89fb39e7, {
        selector: ({ headerItems: headerItems })=>headerItems.reduce((acc, item, index)=>{
                acc[item.id] = index;
                return acc;
            }, {})
    });
    const $2776b7d6c4501657$var$handleState = ()=>({ setState: setState }, { headerItems: headerItems, isRowCountKnown: isRowCountKnown })=>{
            const derivedHeaderState = (0, (0, parcelRequire("1Abrp")).getDerivedHeaderState)(headerItems);
            setState({
                ...derivedHeaderState,
                isRowCountKnown: isRowCountKnown
            });
        };
    const $2776b7d6c4501657$var$HeaderProvider = (0, (0, parcelRequire("gg7kZ")).createContainer)($2776b7d6c4501657$export$52342bdf89fb39e7, {
        onInit: $2776b7d6c4501657$var$handleState,
        onUpdate: $2776b7d6c4501657$var$handleState
    });
    var $2776b7d6c4501657$export$2e2bcd8739ae039 = $2776b7d6c4501657$var$HeaderProvider;
});
parcelRegister("kKwEI", function(module, exports) {
    $parcel$export(module.exports, "actions", ()=>$e19c33e323b398e1$export$e324594224ef24da);
    const $e19c33e323b398e1$export$e324594224ef24da = {};
});
parcelRegister("1Abrp", function(module, exports) {
    $parcel$export(module.exports, "getDerivedHeaderState", ()=>$0c737e962e2aa7d1$export$cde087a6551ccf85);
    var $iZN6h;
    const $0c737e962e2aa7d1$export$cde087a6551ccf85 = (customHeaderItems)=>{
        const combinedHeaderItems = [
            {
                id: (0, (0, parcelRequire("iZN6h")).DEFAULT_HEADER_ROW_ID),
                height: (0, (0, parcelRequire("iZN6h")).BASE_HEADER_HEIGHT)
            },
            ...customHeaderItems
        ];
        const sanitizedHeaderItems = combinedHeaderItems.map(({ id: id, height: height })=>({
                id: id,
                height: height ?? (0, (0, parcelRequire("iZN6h")).DEFAULT_SUBHEADER_HEIGHT)
            }));
        const headerItemsOffsetTop = {};
        const headerHeight = sanitizedHeaderItems.reduce((total, { id: id, height: height })=>{
            headerItemsOffsetTop[id] = total;
            return total + height;
        }, 0);
        return {
            headerItems: sanitizedHeaderItems,
            headerHeight: headerHeight,
            headerItemsOffsetTop: headerItemsOffsetTop
        };
    };
});
parcelRegister("fMv2d", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9572c37c42355ae0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $iZN6h;
    var $WPwAA;
    var $g3prf;
    var $hGh1Z;
    var $9puhl;
    var $cQx6e;
    var $3ruU1;
    var $lGdZu;
    var $biT18;
    var $5SIwg;
    const $9572c37c42355ae0$var$EMPTY_ARRAY = [];
    function $9572c37c42355ae0$export$2e2bcd8739ae039(props) {
        const { marshalOptions: marshalOptions, isCreateLastEnabled: isCreateLastEnabled, isCreateChildEnabled: isCreateChildEnabled, isCreateSiblingEnabled: isCreateSiblingEnabled, isDragEnabled: isDragEnabled, isSelectEnabled: isSelectEnabled, isMultiSelectEnabled: isMultiSelectEnabled, isHighlightToday: isHighlightToday, listWidth: listWidth, items: items, headerItems: headerItems, itemHeight: itemHeight, activeItemId: activeItemId, onItemActivate: onItemActivate, selectedItemIds: selectedItemIds, onItemMultiSelect: onItemMultiSelect, expandedItems: expandedItems, today: today, timelineMode: timelineMode, timelineDuration: timelineDuration, timelineOrigin: timelineOrigin, createItemAnchor: createItemAnchor, ariaRowCount: ariaRowCount, ariaLabel: ariaLabel, ariaReadOnly: ariaReadOnly, isTreeDrag: isTreeDrag = false, listItemMenuOptions: listItemMenuOptions, isMeatballsButtonEnabled: isMeatballsButtonEnabled = false, ...mainProps } = props;
        const safeSelectedItemIds = isSelectEnabled ? selectedItemIds : $9572c37c42355ae0$var$EMPTY_ARRAY;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cQx6e")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lGdZu")).TimelineViewportProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("WPwAA")).EnablementProvider), {
            isDragEnabled: isDragEnabled,
            isSelectEnabled: isSelectEnabled,
            isMultiSelectEnabled: isSelectEnabled && isMultiSelectEnabled,
            isCreateLastEnabled: isCreateLastEnabled,
            isCreateSiblingEnabled: isCreateSiblingEnabled,
            isCreateChildEnabled: isCreateChildEnabled,
            isMeatballsButtonEnabled: isMeatballsButtonEnabled,
            isHighlightToday: isHighlightToday,
            isTreeDrag: isTreeDrag
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("g3prf")).default), {
            headerItems: headerItems,
            isRowCountKnown: ariaRowCount !== -1
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hGh1Z")).ItemsProvider), {
            items: items,
            createItemAnchor: createItemAnchor,
            isCreateLastEnabled: isCreateLastEnabled,
            isCreateSiblingEnabled: isCreateSiblingEnabled,
            isCreateChildEnabled: isCreateChildEnabled,
            expandedItems: expandedItems,
            selectedItemIdsWithPermission: isSelectEnabled ? selectedItemIds : undefined,
            onItemMultiSelect: onItemMultiSelect,
            activeItemId: activeItemId,
            onItemActivate: onItemActivate,
            itemHeight: itemHeight
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("biT18")).TimelineProviderSweetState), {
            timelineMode: timelineMode,
            timelineDuration: timelineDuration,
            timelineOrigin: timelineOrigin,
            today: today
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9puhl")).default), {
            listWidth: listWidth,
            listItemMenuOptions: listItemMenuOptions
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3ruU1")).default), {
            scope: mainProps.scope,
            ariaLabel: ariaLabel,
            ariaReadOnly: ariaReadOnly,
            ariaMultiselectable: isSelectEnabled ? isMultiSelectEnabled : undefined,
            ...marshalOptions
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5SIwg")).default), {
            ...mainProps,
            selectedItemIds: safeSelectedItemIds
        })))))))));
    }
    $9572c37c42355ae0$export$2e2bcd8739ae039.defaultProps = {
        isVirtualiseEnabled: false,
        isCreateLastEnabled: true,
        isCreateSiblingEnabled: true,
        isCreateChildEnabled: true,
        isDragEnabled: true,
        isSelectEnabled: true,
        isMultiSelectEnabled: false,
        isResizeEnabled: true,
        isHighlightToday: true,
        isHideScrollbar: false,
        items: [],
        headerItems: [],
        expandedItems: {},
        renderers: {},
        marshalOptions: {},
        createItemAnchor: undefined,
        activeItemId: undefined,
        selectedItemIds: [],
        itemHeight: (0, (0, parcelRequire("iZN6h")).DEFAULT_ITEM_HEIGHT),
        listWidth: (0, (0, parcelRequire("iZN6h")).DEFAULT_LIST_WIDTH)(),
        DndLongTaskMetric: undefined,
        onItemSelect: (0, ($parcel$interopDefault($8Rkzz))),
        onItemMultiSelect: (0, ($parcel$interopDefault($8Rkzz))),
        onItemActivate: (0, ($parcel$interopDefault($8Rkzz))),
        onItemDrop: (0, ($parcel$interopDefault($8Rkzz))),
        onCreateClick: (0, ($parcel$interopDefault($8Rkzz))),
        onItemExpandChanged: (0, ($parcel$interopDefault($8Rkzz))),
        onSetListWidth: (0, ($parcel$interopDefault($8Rkzz))),
        ariaRowCount: undefined,
        ariaLabel: undefined,
        ariaReadOnly: undefined,
        listItemMenuOptions: {
            overrideLabels: {},
            customSections: []
        }
    };
});
parcelRegister("WPwAA", function(module, exports) {
    $parcel$export(module.exports, "useEnablements", ()=>$eccd758798ebd83c$export$f6bfb0ec6efae17b);
    $parcel$export(module.exports, "EnablementProvider", ()=>$eccd758798ebd83c$export$221a50e4a5e2cf12);
    var $gg7kZ;
    var $3sQ5x;
    var $iXqE5;
    var $i7qsd;
    const $eccd758798ebd83c$var$initialState = {
        isDragEnabled: false,
        isSelectEnabled: false,
        isMultiSelectEnabled: false,
        isCreateLastEnabled: false,
        isCreateSiblingEnabled: false,
        isCreateChildEnabled: false,
        isHighlightToday: true,
        isTreeDrag: false,
        isMeatballsButtonEnabled: false
    };
    const $eccd758798ebd83c$export$faca84be7efd165 = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $eccd758798ebd83c$var$initialState,
        actions: (0, parcelRequire("i7qsd")).actions,
        name: 'timeline-table.enablements'
    });
    const $eccd758798ebd83c$export$f6bfb0ec6efae17b = (0, (0, parcelRequire("3sQ5x")).createHook)($eccd758798ebd83c$export$faca84be7efd165);
    const $eccd758798ebd83c$export$221a50e4a5e2cf12 = (0, (0, parcelRequire("gg7kZ")).createContainer)($eccd758798ebd83c$export$faca84be7efd165, {
        onInit: ()=>({ setState: setState }, enablements)=>{
                setState({
                    ...enablements
                });
            },
        onUpdate: ()=>({ setState: setState }, enablements)=>{
                setState({
                    ...enablements
                });
            }
    });
});
parcelRegister("i7qsd", function(module, exports) {
    $parcel$export(module.exports, "actions", ()=>$4dd51ff8d4f8c8e2$export$e324594224ef24da);
    const $4dd51ff8d4f8c8e2$export$e324594224ef24da = {};
});
parcelRegister("hGh1Z", function(module, exports) {
    $parcel$export(module.exports, "useItems", ()=>$cf7a1679ad005897$export$7bfdd97581ca93c);
    $parcel$export(module.exports, "useItemIndexes", ()=>$cf7a1679ad005897$export$bd1eaa5808f71a42);
    $parcel$export(module.exports, "useIsItemSelected", ()=>$cf7a1679ad005897$export$3d9fe48014f19d8a);
    $parcel$export(module.exports, "useIsItemMultiSelected", ()=>$cf7a1679ad005897$export$e452b1d46f765b84);
    $parcel$export(module.exports, "useItemsSelectionCount", ()=>$cf7a1679ad005897$export$fd6d33cbb99af134);
    $parcel$export(module.exports, "useIsTableEmpty", ()=>$cf7a1679ad005897$export$ad9c09bad4bdddda);
    $parcel$export(module.exports, "useItemsCount", ()=>$cf7a1679ad005897$export$29409325c4d1aa3a);
    $parcel$export(module.exports, "useAriaRowCount", ()=>$cf7a1679ad005897$export$35cd36afbcd5e208);
    $parcel$export(module.exports, "useItemHeight", ()=>$cf7a1679ad005897$export$1d47b041c6ce1962);
    $parcel$export(module.exports, "useItemsContainerStyles", ()=>$cf7a1679ad005897$export$4d54f7a51148a517);
    $parcel$export(module.exports, "useCreateItemAnchor", ()=>$cf7a1679ad005897$export$79c0b16424e10cdb);
    $parcel$export(module.exports, "useCreateItemAnchorIndex", ()=>$cf7a1679ad005897$export$97b98339b446b4f4);
    $parcel$export(module.exports, "useSelectedItemIds", ()=>$cf7a1679ad005897$export$c9fc8524b88d56df);
    $parcel$export(module.exports, "useActiveItemId", ()=>$cf7a1679ad005897$export$6962c376bd636b65);
    $parcel$export(module.exports, "useIsItemActive", ()=>$cf7a1679ad005897$export$22302ddf52c3b4c2);
    $parcel$export(module.exports, "useIsItemSelectable", ()=>$cf7a1679ad005897$export$a431ef15e96621e9);
    $parcel$export(module.exports, "ItemsProvider", ()=>$cf7a1679ad005897$export$dab1678cbe62d3ff);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $gg7kZ;
    var $3sQ5x;
    var $iXqE5;
    var $iZN6h;
    var $7ouUj;
    var $iymwf;
    var $daR3B;
    var $g3prf;
    var $g1EyU;
    var $2vEiN;
    const $cf7a1679ad005897$var$DEFAULT_STATE = {
        items: [],
        itemIndexes: {},
        selectedItemIds: [],
        rangeAnchorItemId: undefined,
        onItemMultiSelect: (0, ($parcel$interopDefault($8Rkzz))),
        activeItemId: undefined,
        onItemActivate: (0, ($parcel$interopDefault($8Rkzz))),
        itemsSelectionState: {},
        itemsSelectionCount: 0,
        ariaRowCount: 0,
        isTableEmpty: false,
        itemsBackground: 'none',
        totalHeight: 0,
        itemHeight: (0, (0, parcelRequire("iZN6h")).DEFAULT_ITEM_HEIGHT),
        createItemAnchor: undefined
    };
    const $cf7a1679ad005897$var$store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $cf7a1679ad005897$var$DEFAULT_STATE,
        actions: (0, parcelRequire("g1EyU")).actions,
        name: 'timeline-table.items'
    });
    const $cf7a1679ad005897$export$fbd09c28377f1868 = (0, (0, parcelRequire("3sQ5x")).createHook)($cf7a1679ad005897$var$store);
    const $cf7a1679ad005897$export$7bfdd97581ca93c = (0, (0, parcelRequire("3sQ5x")).createHook)($cf7a1679ad005897$var$store, {
        selector: (0, (0, parcelRequire("2vEiN")).getItems)
    });
    const $cf7a1679ad005897$export$bd1eaa5808f71a42 = (0, (0, parcelRequire("3sQ5x")).createHook)($cf7a1679ad005897$var$store, {
        selector: (0, (0, parcelRequire("2vEiN")).getItemIndexes)
    });
    const $cf7a1679ad005897$export$3d9fe48014f19d8a = (0, (0, parcelRequire("3sQ5x")).createHook)($cf7a1679ad005897$var$store, {
        selector: (0, (0, parcelRequire("2vEiN")).getIsItemSelected)
    });
    const $cf7a1679ad005897$export$e452b1d46f765b84 = (0, (0, parcelRequire("3sQ5x")).createHook)($cf7a1679ad005897$var$store, {
        selector: (0, (0, parcelRequire("2vEiN")).getIsItemMultiSelected)
    });
    const $cf7a1679ad005897$export$fd6d33cbb99af134 = (0, (0, parcelRequire("3sQ5x")).createHook)($cf7a1679ad005897$var$store, {
        selector: (0, (0, parcelRequire("2vEiN")).getItemsSelectionCount)
    });
    const $cf7a1679ad005897$export$ad9c09bad4bdddda = (0, (0, parcelRequire("3sQ5x")).createHook)($cf7a1679ad005897$var$store, {
        selector: (0, (0, parcelRequire("2vEiN")).getIsTableEmpty)
    });
    const $cf7a1679ad005897$export$29409325c4d1aa3a = (0, (0, parcelRequire("3sQ5x")).createHook)($cf7a1679ad005897$var$store, {
        selector: (0, (0, parcelRequire("2vEiN")).getItemsCount)
    });
    const $cf7a1679ad005897$export$35cd36afbcd5e208 = (0, (0, parcelRequire("3sQ5x")).createHook)($cf7a1679ad005897$var$store, {
        selector: (0, (0, parcelRequire("2vEiN")).getAriaRowCount)
    });
    const $cf7a1679ad005897$export$1d47b041c6ce1962 = (0, (0, parcelRequire("3sQ5x")).createHook)($cf7a1679ad005897$var$store, {
        selector: (0, (0, parcelRequire("2vEiN")).getItemHeight)
    });
    const $cf7a1679ad005897$export$4d54f7a51148a517 = (0, (0, parcelRequire("3sQ5x")).createHook)($cf7a1679ad005897$var$store, {
        selector: (0, (0, parcelRequire("2vEiN")).getItemsContainerStyles)
    });
    const $cf7a1679ad005897$export$79c0b16424e10cdb = (0, (0, parcelRequire("3sQ5x")).createHook)($cf7a1679ad005897$var$store, {
        selector: (0, (0, parcelRequire("2vEiN")).getCreateItemAnchor)
    });
    const $cf7a1679ad005897$export$97b98339b446b4f4 = (0, (0, parcelRequire("3sQ5x")).createStateHook)($cf7a1679ad005897$var$store, {
        selector: (0, (0, parcelRequire("2vEiN")).getCreateItemAnchorIndex)
    });
    const $cf7a1679ad005897$export$51a276b6d0945af7 = (0, (0, parcelRequire("3sQ5x")).createHook)($cf7a1679ad005897$var$store, {
        selector: (0, (0, parcelRequire("2vEiN")).getHasActiveCreate)
    });
    const $cf7a1679ad005897$export$c9fc8524b88d56df = (0, (0, parcelRequire("3sQ5x")).createHook)($cf7a1679ad005897$var$store, {
        selector: (0, (0, parcelRequire("2vEiN")).getSelectedItemIds)
    });
    const $cf7a1679ad005897$export$6962c376bd636b65 = (0, (0, parcelRequire("3sQ5x")).createHook)($cf7a1679ad005897$var$store, {
        selector: (0, (0, parcelRequire("2vEiN")).getActiveItemId)
    });
    const $cf7a1679ad005897$export$22302ddf52c3b4c2 = (0, (0, parcelRequire("3sQ5x")).createHook)($cf7a1679ad005897$var$store, {
        selector: (0, (0, parcelRequire("2vEiN")).getIsItemActive)
    });
    const $cf7a1679ad005897$export$a431ef15e96621e9 = (0, (0, parcelRequire("3sQ5x")).createHook)($cf7a1679ad005897$var$store, {
        selector: (0, (0, parcelRequire("2vEiN")).getIsItemSelectable)
    });
    const $cf7a1679ad005897$var$updateState = ()=>({ setState: setState }, { items: items, createItemAnchor: createItemAnchor, expandedItems: expandedItems, activeItemId: activeItemId, onItemActivate: onItemActivate, selectedItemIdsWithPermission: selectedItemIdsWithPermission, onItemMultiSelect: onItemMultiSelect, isCreateLastEnabled: isCreateLastEnabled, isCreateSiblingEnabled: isCreateSiblingEnabled, isCreateChildEnabled: isCreateChildEnabled, itemHeight: itemHeight, ariaRowOffset: ariaRowOffset })=>{
            const { flatItems: flatItems, itemIndexes: itemIndexes, ariaRowCount: ariaRowCount } = (0, (0, parcelRequire("7ouUj")).getHierarchyEnrichedItems)(items, createItemAnchor, expandedItems, isCreateLastEnabled, isCreateSiblingEnabled, isCreateChildEnabled, itemHeight, ariaRowOffset);
            const itemsSelectionState = (0, (0, parcelRequire("daR3B")).getSelectedItemIdsHash)(selectedItemIdsWithPermission);
            const { itemsBackground: itemsBackground, totalHeight: totalHeight } = (0, (0, parcelRequire("iymwf")).getItemsContainerStyle)(flatItems, itemHeight);
            setState({
                items: flatItems,
                itemIndexes: itemIndexes,
                itemsSelectionState: itemsSelectionState,
                itemsSelectionCount: selectedItemIdsWithPermission?.length,
                activeItemId: activeItemId,
                onItemActivate: onItemActivate,
                selectedItemIds: selectedItemIdsWithPermission ?? [],
                onItemMultiSelect: onItemMultiSelect,
                ariaRowCount: ariaRowCount,
                isTableEmpty: items.length === 0,
                itemsBackground: itemsBackground,
                totalHeight: totalHeight,
                itemHeight: itemHeight,
                createItemAnchor: createItemAnchor
            });
        };
    const $cf7a1679ad005897$var$ItemsProviderContainer = (0, (0, parcelRequire("gg7kZ")).createContainer)($cf7a1679ad005897$var$store, {
        onInit: $cf7a1679ad005897$var$updateState,
        onUpdate: $cf7a1679ad005897$var$updateState
    });
    const $cf7a1679ad005897$export$dab1678cbe62d3ff = (props)=>{
        const [ariaRowOffset] = (0, (0, parcelRequire("g3prf")).useAriaRowOffset)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($cf7a1679ad005897$var$ItemsProviderContainer, {
            ...props,
            ariaRowOffset: ariaRowOffset
        });
    };
});
parcelRegister("7ouUj", function(module, exports) {
    $parcel$export(module.exports, "isRoot", ()=>$cf73b6cf34ba63b7$export$e3140dc7d0c35e48);
    $parcel$export(module.exports, "isBaseLevel", ()=>$cf73b6cf34ba63b7$export$3f3fbf12338c09a4);
    $parcel$export(module.exports, "getItemLevel", ()=>$cf73b6cf34ba63b7$export$aabd95853648484e);
    $parcel$export(module.exports, "getHierarchyEnrichedItems", ()=>$cf73b6cf34ba63b7$export$29090c866cb2cf07);
    var $8QpSo;
    var $iZN6h;
    const $cf73b6cf34ba63b7$export$e3140dc7d0c35e48 = (depth)=>depth === (0, (0, parcelRequire("iZN6h")).DEFAULT_DEPTH);
    const $cf73b6cf34ba63b7$export$3f3fbf12338c09a4 = (level)=>level === (0, (0, parcelRequire("iZN6h")).BASE_LEVEL);
    const $cf73b6cf34ba63b7$var$shouldCreateBeforeItem = (createItemAnchor, id)=>createItemAnchor !== undefined && createItemAnchor.position === (0, (0, parcelRequire("iZN6h")).BEFORE) && createItemAnchor.beforeId === id;
    const $cf73b6cf34ba63b7$var$shouldCreateInsideItem = (createItemAnchor, id)=>{
        if (createItemAnchor === undefined) return false;
        const createChildLast = createItemAnchor.position === (0, (0, parcelRequire("iZN6h")).INSIDE) && createItemAnchor.parentId === id;
        const createChildSibling = createItemAnchor.position === (0, (0, parcelRequire("iZN6h")).BEFORE) && createItemAnchor.parentId === id;
        return createChildLast || createChildSibling;
    };
    const $cf73b6cf34ba63b7$var$shouldCreateLast = (createItemAnchor)=>createItemAnchor === undefined || createItemAnchor.position === (0, (0, parcelRequire("iZN6h")).LAST);
    const $cf73b6cf34ba63b7$var$getItemBackgroundColor = (rootIndex)=>rootIndex % 2 === 0 ? `var(--ds-surface, ${0, $72ba03e317f3d228$export$29a4f05edc054374})` : `var(--ds-surface-sunken, ${0, $72ba03e317f3d228$export$9fdfb749e33cdf97})`;
    const $cf73b6cf34ba63b7$var$getStableCreateId = (createItemAnchor)=>{
        if (createItemAnchor === undefined) return 0, (0, parcelRequire("iZN6h")).DEFAULT_CREATE_ID;
        if (!('beforeId' in createItemAnchor) && createItemAnchor.position === (0, (0, parcelRequire("iZN6h")).LAST)) return 0, (0, parcelRequire("iZN6h")).DEFAULT_CREATE_ID;
        if (createItemAnchor.position === (0, (0, parcelRequire("iZN6h")).INSIDE) && createItemAnchor.parentId) return `create-${createItemAnchor.position}${createItemAnchor.parentId}`;
        return `create-${createItemAnchor.position}${'beforeId' in createItemAnchor && createItemAnchor.beforeId ? createItemAnchor.beforeId : ''}`;
    };
    const $cf73b6cf34ba63b7$var$getCreateLevel = (createItemAnchor, anchorItem)=>{
        if (anchorItem === undefined) return 0, (0, parcelRequire("iZN6h")).DEFAULT_LEVEL;
        const { id: id, level: level } = anchorItem;
        return $cf73b6cf34ba63b7$var$shouldCreateBeforeItem(createItemAnchor, id) ? level : level - 1;
    };
    const $cf73b6cf34ba63b7$var$getCreateDepth = (createItemAnchor, anchorItem)=>{
        if (anchorItem === undefined) return 0, (0, parcelRequire("iZN6h")).DEFAULT_DEPTH;
        const { id: id, depth: depth = 0 } = anchorItem;
        return $cf73b6cf34ba63b7$var$shouldCreateBeforeItem(createItemAnchor, id) ? depth : depth + 1;
    };
    const $cf73b6cf34ba63b7$var$enrichCreateItem = ({ anchorItem: anchorItem, parentId: parentId, createItemAnchor: createItemAnchor, rootIndex: rootIndex, ariaRowIndex: ariaRowIndex, startOffset: startOffset, topOffset: topOffset, flatIndex: flatIndex })=>({
            id: $cf73b6cf34ba63b7$var$getStableCreateId(createItemAnchor),
            type: (0, (0, parcelRequire("iZN6h")).CREATE_ITEM_TYPE),
            anchorItem: anchorItem,
            meta: {
                level: $cf73b6cf34ba63b7$var$getCreateLevel(createItemAnchor, anchorItem),
                isActive: createItemAnchor !== undefined,
                backgroundColor: $cf73b6cf34ba63b7$var$getItemBackgroundColor(rootIndex),
                parentId: parentId,
                ariaRowIndex: ariaRowIndex,
                topOffset: topOffset + startOffset,
                depth: $cf73b6cf34ba63b7$var$getCreateDepth(createItemAnchor, anchorItem)
            },
            flatIndex: flatIndex
        });
    const $cf73b6cf34ba63b7$var$countDescendants = (item)=>{
        const { childItems: childItems = [] } = item;
        return childItems.length + childItems.reduce((acc, child)=>acc + $cf73b6cf34ba63b7$var$countDescendants(child), 0);
    };
    const $cf73b6cf34ba63b7$var$enrichItem = ({ item: item, expandedItems: expandedItems, rootIndex: rootIndex, flatIndex: flatIndex, ariaRowIndex: ariaRowIndex, isParent: isParent, numChildren: numChildren, startOffset: startOffset, childItemsHeight: childItemsHeight, parentItem: parentItem, ariaControls: ariaControls })=>({
            type: (0, (0, parcelRequire("iZN6h")).ITEM_TYPE),
            item: item,
            meta: {
                parentId: parentItem?.item.id,
                backgroundColor: $cf73b6cf34ba63b7$var$getItemBackgroundColor(rootIndex),
                isParent: isParent,
                isExpanded: Boolean(expandedItems[item.id]),
                ariaRowIndex: ariaRowIndex,
                numChildren: numChildren,
                childItemsHeight: childItemsHeight,
                rootIndex: rootIndex,
                topOffset: (parentItem?.meta.topOffset ?? 0) + startOffset,
                ariaControls: ariaControls
            },
            flatIndex: flatIndex
        });
    const $cf73b6cf34ba63b7$export$aabd95853648484e = (enrichedItem)=>{
        switch(enrichedItem.type){
            case 0, (0, parcelRequire("iZN6h")).CREATE_ITEM_TYPE:
                return enrichedItem.meta.level;
            case 0, (0, parcelRequire("iZN6h")).ITEM_TYPE:
                return enrichedItem.item.level;
            default:
                {
                    const _exhaustiveCheck = enrichedItem;
                    return -1;
                }
        }
    };
    const $cf73b6cf34ba63b7$export$29090c866cb2cf07 = (0, (0, parcelRequire("8QpSo")).default)((items, createItemAnchor, expandedItems, isCreateLastEnabled, isCreateSiblingEnabled, isCreateChildEnabled, rootItemHeight, ariaRowOffset, lastFlatIndex = 0, parentItem)=>{
        const depth = parentItem ? (parentItem.item.depth ?? 0) + 1 : 0;
        let offset = 0;
        if (depth > 0) offset += depth > 1 ? (0, (0, parcelRequire("iZN6h")).BASE_LEVEL_ITEM_HEIGHT)() : rootItemHeight;
        let flatIndex = lastFlatIndex;
        const isRowCountKnown = ariaRowOffset !== undefined;
        let ariaRowIndex = (ariaRowOffset ?? 0) + 1;
        const flattenedItems = [];
        const itemIndexes = {};
        items.forEach((item, index)=>{
            const rootIndex = parentItem?.meta.rootIndex ?? index;
            const itemHeight = depth > 0 ? (0, (0, parcelRequire("iZN6h")).BASE_LEVEL_ITEM_HEIGHT)() : rootItemHeight;
            const { id: id, level: level = (0, (0, parcelRequire("iZN6h")).DEFAULT_LEVEL), isInTransition: isInTransition, canCreateChildOverride: canCreateChildOverride = true, childItems: childItems = [] } = item;
            const itemProps = {
                id: id,
                level: level,
                depth: depth,
                isInTransition: isInTransition,
                canCreateChildOverride: canCreateChildOverride
            };
            if (isCreateSiblingEnabled && $cf73b6cf34ba63b7$var$shouldCreateBeforeItem(createItemAnchor, id)) {
                const createItem = $cf73b6cf34ba63b7$var$enrichCreateItem({
                    anchorItem: itemProps,
                    parentId: parentItem?.item.id,
                    createItemAnchor: createItemAnchor,
                    rootIndex: rootIndex,
                    ariaRowIndex: isRowCountKnown ? ariaRowIndex : undefined,
                    startOffset: offset,
                    topOffset: parentItem?.meta?.topOffset ?? 0,
                    flatIndex: flatIndex
                });
                flattenedItems.push(createItem);
                itemIndexes[createItem.id] = flatIndex;
                ariaRowIndex += 1;
                offset += rootItemHeight;
                flatIndex += 1;
            }
            const isChildCreate = isCreateChildEnabled && canCreateChildOverride && $cf73b6cf34ba63b7$var$shouldCreateInsideItem(createItemAnchor, id);
            const isChildCreateInside = Boolean(isChildCreate && createItemAnchor && createItemAnchor.position === (0, (0, parcelRequire("iZN6h")).INSIDE));
            const numChildren = childItems.length + (isChildCreate ? 1 : 0);
            const flattenedItem = $cf73b6cf34ba63b7$var$enrichItem({
                item: itemProps,
                expandedItems: expandedItems,
                rootIndex: rootIndex,
                flatIndex: flatIndex,
                ariaRowIndex: isRowCountKnown ? ariaRowIndex : undefined,
                isParent: childItems.length > 0,
                numChildren: numChildren,
                startOffset: offset,
                childItemsHeight: 0,
                parentItem: parentItem,
                ...childItems.length > 0 && {
                    ariaControls: childItems.map((child)=>child.id).join(' ')
                }
            });
            flatIndex += 1;
            ariaRowIndex += 1;
            offset += itemHeight;
            let innerHierarchyEnrichedItems;
            let itemsHeight = 0;
            let childEnrichedItems = [];
            if (expandedItems[id]) {
                innerHierarchyEnrichedItems = $cf73b6cf34ba63b7$export$29090c866cb2cf07(childItems, createItemAnchor, expandedItems, isCreateLastEnabled, isCreateSiblingEnabled, isCreateChildEnabled, rootItemHeight, isRowCountKnown ? ariaRowIndex - 1 : -1, flatIndex, flattenedItem);
                ariaRowIndex = innerHierarchyEnrichedItems?.ariaRowIndex ?? 0;
                itemsHeight = (innerHierarchyEnrichedItems?.offset ?? itemHeight) - itemHeight;
                childEnrichedItems = innerHierarchyEnrichedItems?.flatItems ?? [];
                flatIndex = innerHierarchyEnrichedItems?.flatIndex ?? flatIndex;
                if (isChildCreateInside) {
                    const createChildItem = $cf73b6cf34ba63b7$var$enrichCreateItem({
                        anchorItem: itemProps,
                        parentId: id,
                        createItemAnchor: createItemAnchor,
                        rootIndex: rootIndex,
                        ariaRowIndex: isRowCountKnown ? ariaRowIndex : undefined,
                        startOffset: itemsHeight + itemHeight,
                        topOffset: flattenedItem?.meta?.topOffset ?? 0,
                        flatIndex: flatIndex
                    });
                    childEnrichedItems.push(createChildItem);
                    itemsHeight += rootItemHeight;
                    ariaRowIndex += 1;
                    flatIndex += 1;
                }
            } else ariaRowIndex += $cf73b6cf34ba63b7$var$countDescendants(item);
            flattenedItems.push({
                ...flattenedItem,
                meta: {
                    ...flattenedItem.meta,
                    childItemsHeight: itemsHeight
                }
            });
            itemIndexes[flattenedItem.item.id] = flattenedItem.flatIndex;
            childEnrichedItems.forEach((enrichedChildItem)=>{
                flattenedItems.push(enrichedChildItem);
                const key = 'id' in enrichedChildItem ? enrichedChildItem.id : enrichedChildItem.item.id;
                itemIndexes[key] = enrichedChildItem.flatIndex;
            });
            offset += itemsHeight;
        });
        if (depth === (0, (0, parcelRequire("iZN6h")).DEFAULT_DEPTH) && isCreateLastEnabled && $cf73b6cf34ba63b7$var$shouldCreateLast(createItemAnchor)) {
            const createItem = $cf73b6cf34ba63b7$var$enrichCreateItem({
                anchorItem: undefined,
                parentId: undefined,
                createItemAnchor: createItemAnchor,
                rootIndex: items.length,
                ariaRowIndex: isRowCountKnown ? ariaRowIndex : undefined,
                startOffset: offset,
                topOffset: parentItem?.meta?.topOffset ?? 0,
                flatIndex: flatIndex
            });
            flattenedItems.push(createItem);
            itemIndexes[createItem.id] = flatIndex;
            ariaRowIndex += 1;
            offset += rootItemHeight;
            flatIndex += 1;
        }
        return {
            flatItems: flattenedItems,
            itemIndexes: itemIndexes,
            ariaRowCount: isRowCountKnown ? ariaRowIndex - 1 : -1,
            offset: offset,
            flatIndex: flatIndex,
            ariaRowIndex: ariaRowIndex
        };
    });
});
parcelRegister("iymwf", function(module, exports) {
    $parcel$export(module.exports, "getItemsContainerStyle", ()=>$4e2c895bb0f5fef2$export$30f72c856f253ec5);
    var $8QpSo;
    var $iZN6h;
    const $4e2c895bb0f5fef2$export$38a59fc64a33c476 = (0, (0, parcelRequire("8QpSo")).default)((items, itemHeight)=>{
        if (!items.length) return [];
        const rows = [];
        let createItemIndex = -1;
        items.filter(({ meta: meta })=>meta?.parentId === undefined).forEach((item, index)=>{
            if (item.type === (0, (0, parcelRequire("iZN6h")).CREATE_ITEM_TYPE)) {
                if (index === items.length - 1) rows.push(itemHeight);
                else createItemIndex = index;
            } else rows.push((item.meta?.childItemsHeight || 0) + itemHeight);
        });
        if (createItemIndex !== -1) rows[Math.max(0, createItemIndex - 1)] += itemHeight;
        return rows;
    });
    const $4e2c895bb0f5fef2$export$115273ef5e87cd0c = (0, (0, parcelRequire("8QpSo")).default)((rows)=>{
        if (!rows.length) return {
            itemsBackground: `var(--ds-background-neutral, ${0, $72ba03e317f3d228$export$7d3359664e8bb0e5})`,
            totalHeight: 0
        };
        const prefix = 'linear-gradient(to bottom,';
        let position = 0;
        let count = 0;
        const chunkSize = 4;
        const rowsBackground = rows.reduce((accum, curr, index)=>{
            const bgColor = index % 2 === 0 ? `var(--ds-surface, ${0, $72ba03e317f3d228$export$29a4f05edc054374})` : `var(--ds-surface-sunken, ${0, $72ba03e317f3d228$export$9fdfb749e33cdf97})`;
            let rowStyle = `${bgColor} ${position}px ${position + curr}px`;
            if (count === chunkSize || index === rows.length - 1) {
                count = 0;
                rowStyle += `,transparent ${position + curr}px)`;
                rowStyle += index !== rows.length - 1 ? `,${prefix}` : '';
            } else {
                count += 1;
                rowStyle += ',';
            }
            position += curr;
            return accum + rowStyle;
        }, prefix);
        return {
            itemsBackground: rowsBackground,
            totalHeight: position
        };
    });
    const $4e2c895bb0f5fef2$export$30f72c856f253ec5 = (0, (0, parcelRequire("8QpSo")).default)((items, itemHeight)=>{
        const rows = $4e2c895bb0f5fef2$export$38a59fc64a33c476(items, itemHeight);
        return $4e2c895bb0f5fef2$export$115273ef5e87cd0c(rows);
    });
});
parcelRegister("daR3B", function(module, exports) {
    $parcel$export(module.exports, "getSelectedItemIdsHash", ()=>$6750a8bfabc945ae$export$6147ec740e92f913);
    var $8QpSo;
    const $6750a8bfabc945ae$export$6147ec740e92f913 = (0, (0, parcelRequire("8QpSo")).default)((selectedItemIdsWithPermission)=>selectedItemIdsWithPermission ? selectedItemIdsWithPermission.reduce((itemsSelectionState, selectedItemId)=>{
            Object.assign(itemsSelectionState, {
                [selectedItemId]: true
            });
            return itemsSelectionState;
        }, {}) : undefined);
});
parcelRegister("g1EyU", function(module, exports) {
    $parcel$export(module.exports, "actions", ()=>$a27bae9f28f172b9$export$e324594224ef24da);
    var $9PCp5 = parcelRequire("9PCp5");
    var $4R6GH;
    var $7ouUj;
    const $a27bae9f28f172b9$export$e324594224ef24da = {
        toggleItem: (id, { analyticsEvent: analyticsEvent, deselectOthers: deselectOthers, withRange: withRange })=>({ setState: setState, getState: getState })=>{
                const { items: items, selectedItemIds: selectedItemIds, activeItemId: activeItemId, rangeAnchorItemId: rangeAnchorItemId = activeItemId, itemIndexes: itemIndexes, onItemMultiSelect: onItemMultiSelect } = getState();
                const current = new Set(selectedItemIds);
                const next = deselectOthers ? new Set() : current;
                if (selectedItemIds.some((itemId)=>itemIndexes[itemId] === undefined)) next.clear();
                const selected = !current.has(id);
                const anchorIndex = withRange && rangeAnchorItemId ? itemIndexes[rangeAnchorItemId] : undefined;
                const targetIndex = withRange ? itemIndexes[id] : undefined;
                if (anchorIndex !== undefined && targetIndex !== undefined) {
                    const anchorItem = items[anchorIndex];
                    let itemIdsInRange = [];
                    let isRangeCancelled = false;
                    const indexRange = [
                        ...(0, ($parcel$interopDefault($9PCp5)))(anchorIndex, targetIndex),
                        targetIndex
                    ];
                    for (const index of indexRange){
                        const item = items[index];
                        if ('item' in item && (0, (0, parcelRequire("7ouUj")).getItemLevel)(item) === (0, (0, parcelRequire("7ouUj")).getItemLevel)(anchorItem)) itemIdsInRange.push(item.item.id);
                        if ((0, (0, parcelRequire("7ouUj")).getItemLevel)(item) > (0, (0, parcelRequire("7ouUj")).getItemLevel)(anchorItem)) {
                            isRangeCancelled = true;
                            break;
                        }
                    }
                    if (isRangeCancelled) itemIdsInRange = [
                        id
                    ];
                    itemIdsInRange.forEach((itemIdInRange)=>{
                        selected ? next.add(itemIdInRange) : next.delete(itemIdInRange);
                    });
                } else selected ? next.add(id) : next.delete(id);
                setState({
                    rangeAnchorItemId: id
                });
                onItemMultiSelect(analyticsEvent, [
                    ...next
                ]);
            },
        activateItem: (id, ref)=>({ getState: getState, setState: setState })=>{
                (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps-timeline-bento-refocusing') ? getState().onItemActivate(id, ref) : getState().onItemActivate(id);
                setState({
                    rangeAnchorItemId: id
                });
            }
    };
});
parcelRegister("9PCp5", function(module, exports) {
    var $lVx1a = parcelRequire("lVx1a");
    var $7286aa9f89a20bb7$var$func = $lVx1a('range', (parcelRequire("iASWI")));
    $7286aa9f89a20bb7$var$func.placeholder = (parcelRequire("aPsMW"));
    module.exports = $7286aa9f89a20bb7$var$func;
});
parcelRegister("lVx1a", function(module, exports) {
    var $iIayQ = parcelRequire("iIayQ");
    var $7sR67 = parcelRequire("7sR67");
    function $ff688881095ae098$var$convert(name, func, options) {
        return $iIayQ($7sR67, name, func, options);
    }
    module.exports = $ff688881095ae098$var$convert;
});
parcelRegister("iIayQ", function(module, exports) {
    var $lTdwm = parcelRequire("lTdwm");
    var $aPsMW = parcelRequire("aPsMW");
    var $d9f487426e0f9b59$var$push = Array.prototype.push;
    function $d9f487426e0f9b59$var$baseArity(func, n) {
        return n == 2 ? function(a, b) {
            return func.apply(undefined, arguments);
        } : function(a) {
            return func.apply(undefined, arguments);
        };
    }
    function $d9f487426e0f9b59$var$baseAry(func, n) {
        return n == 2 ? function(a, b) {
            return func(a, b);
        } : function(a) {
            return func(a);
        };
    }
    function $d9f487426e0f9b59$var$cloneArray(array) {
        var length = array ? array.length : 0, result = Array(length);
        while(length--)result[length] = array[length];
        return result;
    }
    function $d9f487426e0f9b59$var$createCloner(func) {
        return function(object) {
            return func({}, object);
        };
    }
    function $d9f487426e0f9b59$var$flatSpread(func, start) {
        return function() {
            var length = arguments.length, lastIndex = length - 1, args = Array(length);
            while(length--)args[length] = arguments[length];
            var array = args[start], otherArgs = args.slice(0, start);
            if (array) $d9f487426e0f9b59$var$push.apply(otherArgs, array);
            if (start != lastIndex) $d9f487426e0f9b59$var$push.apply(otherArgs, args.slice(start + 1));
            return func.apply(this, otherArgs);
        };
    }
    function $d9f487426e0f9b59$var$wrapImmutable(func, cloner) {
        return function() {
            var length = arguments.length;
            if (!length) return;
            var args = Array(length);
            while(length--)args[length] = arguments[length];
            var result = args[0] = cloner.apply(undefined, args);
            func.apply(undefined, args);
            return result;
        };
    }
    function $d9f487426e0f9b59$var$baseConvert(util, name, func, options) {
        var isLib = typeof name == 'function', isObj = name === Object(name);
        if (isObj) {
            options = func;
            func = name;
            name = undefined;
        }
        if (func == null) throw new TypeError;
        options || (options = {});
        var config = {
            'cap': 'cap' in options ? options.cap : true,
            'curry': 'curry' in options ? options.curry : true,
            'fixed': 'fixed' in options ? options.fixed : true,
            'immutable': 'immutable' in options ? options.immutable : true,
            'rearg': 'rearg' in options ? options.rearg : true
        };
        var defaultHolder = isLib ? func : $aPsMW, forceCurry = 'curry' in options && options.curry, forceFixed = 'fixed' in options && options.fixed, forceRearg = 'rearg' in options && options.rearg, pristine = isLib ? func.runInContext() : undefined;
        var helpers = isLib ? func : {
            'ary': util.ary,
            'assign': util.assign,
            'clone': util.clone,
            'curry': util.curry,
            'forEach': util.forEach,
            'isArray': util.isArray,
            'isError': util.isError,
            'isFunction': util.isFunction,
            'isWeakMap': util.isWeakMap,
            'iteratee': util.iteratee,
            'keys': util.keys,
            'rearg': util.rearg,
            'toInteger': util.toInteger,
            'toPath': util.toPath
        };
        var ary = helpers.ary, assign = helpers.assign, clone = helpers.clone, curry = helpers.curry, each = helpers.forEach, isArray = helpers.isArray, isError = helpers.isError, isFunction = helpers.isFunction, isWeakMap = helpers.isWeakMap, keys = helpers.keys, rearg = helpers.rearg, toInteger = helpers.toInteger, toPath = helpers.toPath;
        var aryMethodKeys = keys($lTdwm.aryMethod);
        var wrappers = {
            'castArray': function(castArray) {
                return function() {
                    var value = arguments[0];
                    return isArray(value) ? castArray($d9f487426e0f9b59$var$cloneArray(value)) : castArray.apply(undefined, arguments);
                };
            },
            'iteratee': function(iteratee) {
                return function() {
                    var func = arguments[0], arity = arguments[1], result = iteratee(func, arity), length = result.length;
                    if (config.cap && typeof arity == 'number') {
                        arity = arity > 2 ? arity - 2 : 1;
                        return length && length <= arity ? result : $d9f487426e0f9b59$var$baseAry(result, arity);
                    }
                    return result;
                };
            },
            'mixin': function(mixin) {
                return function(source) {
                    var func = this;
                    if (!isFunction(func)) return mixin(func, Object(source));
                    var pairs = [];
                    each(keys(source), function(key) {
                        if (isFunction(source[key])) pairs.push([
                            key,
                            func.prototype[key]
                        ]);
                    });
                    mixin(func, Object(source));
                    each(pairs, function(pair) {
                        var value = pair[1];
                        if (isFunction(value)) func.prototype[pair[0]] = value;
                        else delete func.prototype[pair[0]];
                    });
                    return func;
                };
            },
            'nthArg': function(nthArg) {
                return function(n) {
                    var arity = n < 0 ? 1 : toInteger(n) + 1;
                    return curry(nthArg(n), arity);
                };
            },
            'rearg': function(rearg) {
                return function(func, indexes) {
                    var arity = indexes ? indexes.length : 0;
                    return curry(rearg(func, indexes), arity);
                };
            },
            'runInContext': function(runInContext) {
                return function(context) {
                    return $d9f487426e0f9b59$var$baseConvert(util, runInContext(context), options);
                };
            }
        };
        function castCap(name, func) {
            if (config.cap) {
                var indexes = $lTdwm.iterateeRearg[name];
                if (indexes) return iterateeRearg(func, indexes);
                var n = !isLib && $lTdwm.iterateeAry[name];
                if (n) return iterateeAry(func, n);
            }
            return func;
        }
        function castCurry(name, func, n) {
            return forceCurry || config.curry && n > 1 ? curry(func, n) : func;
        }
        function castFixed(name, func, n) {
            if (config.fixed && (forceFixed || !$lTdwm.skipFixed[name])) {
                var data = $lTdwm.methodSpread[name], start = data && data.start;
                return start === undefined ? ary(func, n) : $d9f487426e0f9b59$var$flatSpread(func, start);
            }
            return func;
        }
        function castRearg(name, func, n) {
            return config.rearg && n > 1 && (forceRearg || !$lTdwm.skipRearg[name]) ? rearg(func, $lTdwm.methodRearg[name] || $lTdwm.aryRearg[n]) : func;
        }
        function cloneByPath(object, path) {
            path = toPath(path);
            var index = -1, length = path.length, lastIndex = length - 1, result = clone(Object(object)), nested = result;
            while(nested != null && ++index < length){
                var key = path[index], value = nested[key];
                if (value != null && !(isFunction(value) || isError(value) || isWeakMap(value))) nested[key] = clone(index == lastIndex ? value : Object(value));
                nested = nested[key];
            }
            return result;
        }
        function convertLib(options) {
            return _.runInContext.convert(options)(undefined);
        }
        function createConverter(name, func) {
            var realName = $lTdwm.aliasToReal[name] || name, methodName = $lTdwm.remap[realName] || realName, oldOptions = options;
            return function(options) {
                var newUtil = isLib ? pristine : helpers, newFunc = isLib ? pristine[methodName] : func, newOptions = assign(assign({}, oldOptions), options);
                return $d9f487426e0f9b59$var$baseConvert(newUtil, realName, newFunc, newOptions);
            };
        }
        function iterateeAry(func, n) {
            return overArg(func, function(func) {
                return typeof func == 'function' ? $d9f487426e0f9b59$var$baseAry(func, n) : func;
            });
        }
        function iterateeRearg(func, indexes) {
            return overArg(func, function(func) {
                var n = indexes.length;
                return $d9f487426e0f9b59$var$baseArity(rearg($d9f487426e0f9b59$var$baseAry(func, n), indexes), n);
            });
        }
        function overArg(func, transform) {
            return function() {
                var length = arguments.length;
                if (!length) return func();
                var args = Array(length);
                while(length--)args[length] = arguments[length];
                var index = config.rearg ? 0 : length - 1;
                args[index] = transform(args[index]);
                return func.apply(undefined, args);
            };
        }
        function wrap(name, func, placeholder) {
            var result, realName = $lTdwm.aliasToReal[name] || name, wrapped = func, wrapper = wrappers[realName];
            if (wrapper) wrapped = wrapper(func);
            else if (config.immutable) {
                if ($lTdwm.mutate.array[realName]) wrapped = $d9f487426e0f9b59$var$wrapImmutable(func, $d9f487426e0f9b59$var$cloneArray);
                else if ($lTdwm.mutate.object[realName]) wrapped = $d9f487426e0f9b59$var$wrapImmutable(func, $d9f487426e0f9b59$var$createCloner(func));
                else if ($lTdwm.mutate.set[realName]) wrapped = $d9f487426e0f9b59$var$wrapImmutable(func, cloneByPath);
            }
            each(aryMethodKeys, function(aryKey) {
                each($lTdwm.aryMethod[aryKey], function(otherName) {
                    if (realName == otherName) {
                        var data = $lTdwm.methodSpread[realName], afterRearg = data && data.afterRearg;
                        result = afterRearg ? castFixed(realName, castRearg(realName, wrapped, aryKey), aryKey) : castRearg(realName, castFixed(realName, wrapped, aryKey), aryKey);
                        result = castCap(realName, result);
                        result = castCurry(realName, result, aryKey);
                        return false;
                    }
                });
                return !result;
            });
            result || (result = wrapped);
            if (result == func) result = forceCurry ? curry(result, 1) : function() {
                return func.apply(this, arguments);
            };
            result.convert = createConverter(realName, func);
            result.placeholder = func.placeholder = placeholder;
            return result;
        }
        if (!isObj) return wrap(name, func, defaultHolder);
        var _ = func;
        var pairs = [];
        each(aryMethodKeys, function(aryKey) {
            each($lTdwm.aryMethod[aryKey], function(key) {
                var func = _[$lTdwm.remap[key] || key];
                if (func) pairs.push([
                    key,
                    wrap(key, func, _)
                ]);
            });
        });
        each(keys(_), function(key) {
            var func = _[key];
            if (typeof func == 'function') {
                var length = pairs.length;
                while(length--){
                    if (pairs[length][0] == key) return;
                }
                func.convert = createConverter(key, func);
                pairs.push([
                    key,
                    func
                ]);
            }
        });
        each(pairs, function(pair) {
            _[pair[0]] = pair[1];
        });
        _.convert = convertLib;
        _.placeholder = _;
        each(keys(_), function(key) {
            each($lTdwm.realToAlias[key] || [], function(alias) {
                _[alias] = _[key];
            });
        });
        return _;
    }
    module.exports = $d9f487426e0f9b59$var$baseConvert;
});
parcelRegister("lTdwm", function(module, exports) {
    $parcel$export(module.exports, "aliasToReal", ()=>$fef938fb92c31507$export$bd0f5e6e44efa6b4, (v)=>$fef938fb92c31507$export$bd0f5e6e44efa6b4 = v);
    $parcel$export(module.exports, "aryMethod", ()=>$fef938fb92c31507$export$85c665b4d7da9cb4, (v)=>$fef938fb92c31507$export$85c665b4d7da9cb4 = v);
    $parcel$export(module.exports, "aryRearg", ()=>$fef938fb92c31507$export$42564e045b285e32, (v)=>$fef938fb92c31507$export$42564e045b285e32 = v);
    $parcel$export(module.exports, "iterateeAry", ()=>$fef938fb92c31507$export$81e17196e6a22b07, (v)=>$fef938fb92c31507$export$81e17196e6a22b07 = v);
    $parcel$export(module.exports, "iterateeRearg", ()=>$fef938fb92c31507$export$30975ceb42167ebd, (v)=>$fef938fb92c31507$export$30975ceb42167ebd = v);
    $parcel$export(module.exports, "methodRearg", ()=>$fef938fb92c31507$export$8ceb0ad7e94d3801, (v)=>$fef938fb92c31507$export$8ceb0ad7e94d3801 = v);
    $parcel$export(module.exports, "methodSpread", ()=>$fef938fb92c31507$export$fbaeb3f87df3cf26, (v)=>$fef938fb92c31507$export$fbaeb3f87df3cf26 = v);
    $parcel$export(module.exports, "mutate", ()=>$fef938fb92c31507$export$57e795267c26e600, (v)=>$fef938fb92c31507$export$57e795267c26e600 = v);
    $parcel$export(module.exports, "realToAlias", ()=>$fef938fb92c31507$export$1eb71a7e27943e71, (v)=>$fef938fb92c31507$export$1eb71a7e27943e71 = v);
    $parcel$export(module.exports, "remap", ()=>$fef938fb92c31507$export$aee1dbae5de2db9d, (v)=>$fef938fb92c31507$export$aee1dbae5de2db9d = v);
    $parcel$export(module.exports, "skipFixed", ()=>$fef938fb92c31507$export$87ffbe4821a5d5e0, (v)=>$fef938fb92c31507$export$87ffbe4821a5d5e0 = v);
    $parcel$export(module.exports, "skipRearg", ()=>$fef938fb92c31507$export$b4d07413ce528c90, (v)=>$fef938fb92c31507$export$b4d07413ce528c90 = v);
    var $fef938fb92c31507$export$bd0f5e6e44efa6b4;
    var $fef938fb92c31507$export$85c665b4d7da9cb4;
    var $fef938fb92c31507$export$42564e045b285e32;
    var $fef938fb92c31507$export$81e17196e6a22b07;
    var $fef938fb92c31507$export$30975ceb42167ebd;
    var $fef938fb92c31507$export$8ceb0ad7e94d3801;
    var $fef938fb92c31507$export$fbaeb3f87df3cf26;
    var $fef938fb92c31507$export$57e795267c26e600;
    var $fef938fb92c31507$export$1eb71a7e27943e71;
    var $fef938fb92c31507$export$aee1dbae5de2db9d;
    var $fef938fb92c31507$export$87ffbe4821a5d5e0;
    var $fef938fb92c31507$export$b4d07413ce528c90;
    $fef938fb92c31507$export$bd0f5e6e44efa6b4 = {
        'each': 'forEach',
        'eachRight': 'forEachRight',
        'entries': 'toPairs',
        'entriesIn': 'toPairsIn',
        'extend': 'assignIn',
        'extendAll': 'assignInAll',
        'extendAllWith': 'assignInAllWith',
        'extendWith': 'assignInWith',
        'first': 'head',
        'conforms': 'conformsTo',
        'matches': 'isMatch',
        'property': 'get',
        '__': 'placeholder',
        'F': 'stubFalse',
        'T': 'stubTrue',
        'all': 'every',
        'allPass': 'overEvery',
        'always': 'constant',
        'any': 'some',
        'anyPass': 'overSome',
        'apply': 'spread',
        'assoc': 'set',
        'assocPath': 'set',
        'complement': 'negate',
        'compose': 'flowRight',
        'contains': 'includes',
        'dissoc': 'unset',
        'dissocPath': 'unset',
        'dropLast': 'dropRight',
        'dropLastWhile': 'dropRightWhile',
        'equals': 'isEqual',
        'identical': 'eq',
        'indexBy': 'keyBy',
        'init': 'initial',
        'invertObj': 'invert',
        'juxt': 'over',
        'omitAll': 'omit',
        'nAry': 'ary',
        'path': 'get',
        'pathEq': 'matchesProperty',
        'pathOr': 'getOr',
        'paths': 'at',
        'pickAll': 'pick',
        'pipe': 'flow',
        'pluck': 'map',
        'prop': 'get',
        'propEq': 'matchesProperty',
        'propOr': 'getOr',
        'props': 'at',
        'symmetricDifference': 'xor',
        'symmetricDifferenceBy': 'xorBy',
        'symmetricDifferenceWith': 'xorWith',
        'takeLast': 'takeRight',
        'takeLastWhile': 'takeRightWhile',
        'unapply': 'rest',
        'unnest': 'flatten',
        'useWith': 'overArgs',
        'where': 'conformsTo',
        'whereEq': 'isMatch',
        'zipObj': 'zipObject'
    };
    $fef938fb92c31507$export$85c665b4d7da9cb4 = {
        '1': [
            'assignAll',
            'assignInAll',
            'attempt',
            'castArray',
            'ceil',
            'create',
            'curry',
            'curryRight',
            'defaultsAll',
            'defaultsDeepAll',
            'floor',
            'flow',
            'flowRight',
            'fromPairs',
            'invert',
            'iteratee',
            'memoize',
            'method',
            'mergeAll',
            'methodOf',
            'mixin',
            'nthArg',
            'over',
            'overEvery',
            'overSome',
            'rest',
            'reverse',
            'round',
            'runInContext',
            'spread',
            'template',
            'trim',
            'trimEnd',
            'trimStart',
            'uniqueId',
            'words',
            'zipAll'
        ],
        '2': [
            'add',
            'after',
            'ary',
            'assign',
            'assignAllWith',
            'assignIn',
            'assignInAllWith',
            'at',
            'before',
            'bind',
            'bindAll',
            'bindKey',
            'chunk',
            'cloneDeepWith',
            'cloneWith',
            'concat',
            'conformsTo',
            'countBy',
            'curryN',
            'curryRightN',
            'debounce',
            'defaults',
            'defaultsDeep',
            'defaultTo',
            'delay',
            'difference',
            'divide',
            'drop',
            'dropRight',
            'dropRightWhile',
            'dropWhile',
            'endsWith',
            'eq',
            'every',
            'filter',
            'find',
            'findIndex',
            'findKey',
            'findLast',
            'findLastIndex',
            'findLastKey',
            'flatMap',
            'flatMapDeep',
            'flattenDepth',
            'forEach',
            'forEachRight',
            'forIn',
            'forInRight',
            'forOwn',
            'forOwnRight',
            'get',
            'groupBy',
            'gt',
            'gte',
            'has',
            'hasIn',
            'includes',
            'indexOf',
            'intersection',
            'invertBy',
            'invoke',
            'invokeMap',
            'isEqual',
            'isMatch',
            'join',
            'keyBy',
            'lastIndexOf',
            'lt',
            'lte',
            'map',
            'mapKeys',
            'mapValues',
            'matchesProperty',
            'maxBy',
            'meanBy',
            'merge',
            'mergeAllWith',
            'minBy',
            'multiply',
            'nth',
            'omit',
            'omitBy',
            'overArgs',
            'pad',
            'padEnd',
            'padStart',
            'parseInt',
            'partial',
            'partialRight',
            'partition',
            'pick',
            'pickBy',
            'propertyOf',
            'pull',
            'pullAll',
            'pullAt',
            'random',
            'range',
            'rangeRight',
            'rearg',
            'reject',
            'remove',
            'repeat',
            'restFrom',
            'result',
            'sampleSize',
            'some',
            'sortBy',
            'sortedIndex',
            'sortedIndexOf',
            'sortedLastIndex',
            'sortedLastIndexOf',
            'sortedUniqBy',
            'split',
            'spreadFrom',
            'startsWith',
            'subtract',
            'sumBy',
            'take',
            'takeRight',
            'takeRightWhile',
            'takeWhile',
            'tap',
            'throttle',
            'thru',
            'times',
            'trimChars',
            'trimCharsEnd',
            'trimCharsStart',
            'truncate',
            'union',
            'uniqBy',
            'uniqWith',
            'unset',
            'unzipWith',
            'without',
            'wrap',
            'xor',
            'zip',
            'zipObject',
            'zipObjectDeep'
        ],
        '3': [
            'assignInWith',
            'assignWith',
            'clamp',
            'differenceBy',
            'differenceWith',
            'findFrom',
            'findIndexFrom',
            'findLastFrom',
            'findLastIndexFrom',
            'getOr',
            'includesFrom',
            'indexOfFrom',
            'inRange',
            'intersectionBy',
            'intersectionWith',
            'invokeArgs',
            'invokeArgsMap',
            'isEqualWith',
            'isMatchWith',
            'flatMapDepth',
            'lastIndexOfFrom',
            'mergeWith',
            'orderBy',
            'padChars',
            'padCharsEnd',
            'padCharsStart',
            'pullAllBy',
            'pullAllWith',
            'rangeStep',
            'rangeStepRight',
            'reduce',
            'reduceRight',
            'replace',
            'set',
            'slice',
            'sortedIndexBy',
            'sortedLastIndexBy',
            'transform',
            'unionBy',
            'unionWith',
            'update',
            'xorBy',
            'xorWith',
            'zipWith'
        ],
        '4': [
            'fill',
            'setWith',
            'updateWith'
        ]
    };
    $fef938fb92c31507$export$42564e045b285e32 = {
        '2': [
            1,
            0
        ],
        '3': [
            2,
            0,
            1
        ],
        '4': [
            3,
            2,
            0,
            1
        ]
    };
    $fef938fb92c31507$export$81e17196e6a22b07 = {
        'dropRightWhile': 1,
        'dropWhile': 1,
        'every': 1,
        'filter': 1,
        'find': 1,
        'findFrom': 1,
        'findIndex': 1,
        'findIndexFrom': 1,
        'findKey': 1,
        'findLast': 1,
        'findLastFrom': 1,
        'findLastIndex': 1,
        'findLastIndexFrom': 1,
        'findLastKey': 1,
        'flatMap': 1,
        'flatMapDeep': 1,
        'flatMapDepth': 1,
        'forEach': 1,
        'forEachRight': 1,
        'forIn': 1,
        'forInRight': 1,
        'forOwn': 1,
        'forOwnRight': 1,
        'map': 1,
        'mapKeys': 1,
        'mapValues': 1,
        'partition': 1,
        'reduce': 2,
        'reduceRight': 2,
        'reject': 1,
        'remove': 1,
        'some': 1,
        'takeRightWhile': 1,
        'takeWhile': 1,
        'times': 1,
        'transform': 2
    };
    $fef938fb92c31507$export$30975ceb42167ebd = {
        'mapKeys': [
            1
        ],
        'reduceRight': [
            1,
            0
        ]
    };
    $fef938fb92c31507$export$8ceb0ad7e94d3801 = {
        'assignInAllWith': [
            1,
            0
        ],
        'assignInWith': [
            1,
            2,
            0
        ],
        'assignAllWith': [
            1,
            0
        ],
        'assignWith': [
            1,
            2,
            0
        ],
        'differenceBy': [
            1,
            2,
            0
        ],
        'differenceWith': [
            1,
            2,
            0
        ],
        'getOr': [
            2,
            1,
            0
        ],
        'intersectionBy': [
            1,
            2,
            0
        ],
        'intersectionWith': [
            1,
            2,
            0
        ],
        'isEqualWith': [
            1,
            2,
            0
        ],
        'isMatchWith': [
            2,
            1,
            0
        ],
        'mergeAllWith': [
            1,
            0
        ],
        'mergeWith': [
            1,
            2,
            0
        ],
        'padChars': [
            2,
            1,
            0
        ],
        'padCharsEnd': [
            2,
            1,
            0
        ],
        'padCharsStart': [
            2,
            1,
            0
        ],
        'pullAllBy': [
            2,
            1,
            0
        ],
        'pullAllWith': [
            2,
            1,
            0
        ],
        'rangeStep': [
            1,
            2,
            0
        ],
        'rangeStepRight': [
            1,
            2,
            0
        ],
        'setWith': [
            3,
            1,
            2,
            0
        ],
        'sortedIndexBy': [
            2,
            1,
            0
        ],
        'sortedLastIndexBy': [
            2,
            1,
            0
        ],
        'unionBy': [
            1,
            2,
            0
        ],
        'unionWith': [
            1,
            2,
            0
        ],
        'updateWith': [
            3,
            1,
            2,
            0
        ],
        'xorBy': [
            1,
            2,
            0
        ],
        'xorWith': [
            1,
            2,
            0
        ],
        'zipWith': [
            1,
            2,
            0
        ]
    };
    $fef938fb92c31507$export$fbaeb3f87df3cf26 = {
        'assignAll': {
            'start': 0
        },
        'assignAllWith': {
            'start': 0
        },
        'assignInAll': {
            'start': 0
        },
        'assignInAllWith': {
            'start': 0
        },
        'defaultsAll': {
            'start': 0
        },
        'defaultsDeepAll': {
            'start': 0
        },
        'invokeArgs': {
            'start': 2
        },
        'invokeArgsMap': {
            'start': 2
        },
        'mergeAll': {
            'start': 0
        },
        'mergeAllWith': {
            'start': 0
        },
        'partial': {
            'start': 1
        },
        'partialRight': {
            'start': 1
        },
        'without': {
            'start': 1
        },
        'zipAll': {
            'start': 0
        }
    };
    $fef938fb92c31507$export$57e795267c26e600 = {
        'array': {
            'fill': true,
            'pull': true,
            'pullAll': true,
            'pullAllBy': true,
            'pullAllWith': true,
            'pullAt': true,
            'remove': true,
            'reverse': true
        },
        'object': {
            'assign': true,
            'assignAll': true,
            'assignAllWith': true,
            'assignIn': true,
            'assignInAll': true,
            'assignInAllWith': true,
            'assignInWith': true,
            'assignWith': true,
            'defaults': true,
            'defaultsAll': true,
            'defaultsDeep': true,
            'defaultsDeepAll': true,
            'merge': true,
            'mergeAll': true,
            'mergeAllWith': true,
            'mergeWith': true
        },
        'set': {
            'set': true,
            'setWith': true,
            'unset': true,
            'update': true,
            'updateWith': true
        }
    };
    $fef938fb92c31507$export$1eb71a7e27943e71 = function() {
        var hasOwnProperty = Object.prototype.hasOwnProperty, object = $fef938fb92c31507$export$bd0f5e6e44efa6b4, result = {};
        for(var key in object){
            var value = object[key];
            if (hasOwnProperty.call(result, value)) result[value].push(key);
            else result[value] = [
                key
            ];
        }
        return result;
    }();
    $fef938fb92c31507$export$aee1dbae5de2db9d = {
        'assignAll': 'assign',
        'assignAllWith': 'assignWith',
        'assignInAll': 'assignIn',
        'assignInAllWith': 'assignInWith',
        'curryN': 'curry',
        'curryRightN': 'curryRight',
        'defaultsAll': 'defaults',
        'defaultsDeepAll': 'defaultsDeep',
        'findFrom': 'find',
        'findIndexFrom': 'findIndex',
        'findLastFrom': 'findLast',
        'findLastIndexFrom': 'findLastIndex',
        'getOr': 'get',
        'includesFrom': 'includes',
        'indexOfFrom': 'indexOf',
        'invokeArgs': 'invoke',
        'invokeArgsMap': 'invokeMap',
        'lastIndexOfFrom': 'lastIndexOf',
        'mergeAll': 'merge',
        'mergeAllWith': 'mergeWith',
        'padChars': 'pad',
        'padCharsEnd': 'padEnd',
        'padCharsStart': 'padStart',
        'propertyOf': 'get',
        'rangeStep': 'range',
        'rangeStepRight': 'rangeRight',
        'restFrom': 'rest',
        'spreadFrom': 'spread',
        'trimChars': 'trim',
        'trimCharsEnd': 'trimEnd',
        'trimCharsStart': 'trimStart',
        'zipAll': 'zip'
    };
    $fef938fb92c31507$export$87ffbe4821a5d5e0 = {
        'castArray': true,
        'flow': true,
        'flowRight': true,
        'iteratee': true,
        'mixin': true,
        'rearg': true,
        'runInContext': true
    };
    $fef938fb92c31507$export$b4d07413ce528c90 = {
        'add': true,
        'assign': true,
        'assignIn': true,
        'bind': true,
        'bindKey': true,
        'concat': true,
        'difference': true,
        'divide': true,
        'eq': true,
        'gt': true,
        'gte': true,
        'isEqual': true,
        'lt': true,
        'lte': true,
        'matchesProperty': true,
        'merge': true,
        'multiply': true,
        'overArgs': true,
        'partial': true,
        'partialRight': true,
        'propertyOf': true,
        'random': true,
        'range': true,
        'rangeRight': true,
        'subtract': true,
        'zip': true,
        'zipObject': true,
        'zipObjectDeep': true
    };
});
parcelRegister("aPsMW", function(module, exports) {
    module.exports = {};
});
parcelRegister("7sR67", function(module, exports) {
    module.exports = {
        'ary': (parcelRequire("lEyvi")),
        'assign': (parcelRequire("bqJNK")),
        'clone': (parcelRequire("91VA7")),
        'curry': (parcelRequire("a7NzZ")),
        'forEach': (parcelRequire("fmP8r")),
        'isArray': (parcelRequire("8LQ84")),
        'isError': (parcelRequire("aZFhV")),
        'isFunction': (parcelRequire("5vD8v")),
        'isWeakMap': (parcelRequire("5UxIS")),
        'iteratee': (parcelRequire("5qDt4")),
        'keys': (parcelRequire("hR3Ue")),
        'rearg': (parcelRequire("iZlmO")),
        'toInteger': (parcelRequire("kPZpS")),
        'toPath': (parcelRequire("6TYHJ"))
    };
});
parcelRegister("lEyvi", function(module, exports) {
    var $5oTQF = parcelRequire("5oTQF");
    var $fc3819207d6eebc6$var$WRAP_ARY_FLAG = 128;
    function $fc3819207d6eebc6$var$ary(func, n, guard) {
        n = guard ? undefined : n;
        n = func && n == null ? func.length : n;
        return $5oTQF(func, $fc3819207d6eebc6$var$WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }
    module.exports = $fc3819207d6eebc6$var$ary;
});
parcelRegister("5oTQF", function(module, exports) {
    var $g1o5k = parcelRequire("g1o5k");
    var $1BSxH = parcelRequire("1BSxH");
    var $gQoGK = parcelRequire("gQoGK");
    var $2pq1V = parcelRequire("2pq1V");
    var $cwXqG = parcelRequire("cwXqG");
    var $dzqxs = parcelRequire("dzqxs");
    var $c8pf3 = parcelRequire("c8pf3");
    var $4EzKU = parcelRequire("4EzKU");
    var $iKqmZ = parcelRequire("iKqmZ");
    var $kPZpS = parcelRequire("kPZpS");
    var $3eea84024a50d6cf$var$FUNC_ERROR_TEXT = 'Expected a function';
    var $3eea84024a50d6cf$var$WRAP_BIND_FLAG = 1, $3eea84024a50d6cf$var$WRAP_BIND_KEY_FLAG = 2, $3eea84024a50d6cf$var$WRAP_CURRY_FLAG = 8, $3eea84024a50d6cf$var$WRAP_CURRY_RIGHT_FLAG = 16, $3eea84024a50d6cf$var$WRAP_PARTIAL_FLAG = 32, $3eea84024a50d6cf$var$WRAP_PARTIAL_RIGHT_FLAG = 64;
    var $3eea84024a50d6cf$var$nativeMax = Math.max;
    function $3eea84024a50d6cf$var$createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
        var isBindKey = bitmask & $3eea84024a50d6cf$var$WRAP_BIND_KEY_FLAG;
        if (!isBindKey && typeof func != 'function') throw new TypeError($3eea84024a50d6cf$var$FUNC_ERROR_TEXT);
        var length = partials ? partials.length : 0;
        if (!length) {
            bitmask &= ~($3eea84024a50d6cf$var$WRAP_PARTIAL_FLAG | $3eea84024a50d6cf$var$WRAP_PARTIAL_RIGHT_FLAG);
            partials = holders = undefined;
        }
        ary = ary === undefined ? ary : $3eea84024a50d6cf$var$nativeMax($kPZpS(ary), 0);
        arity = arity === undefined ? arity : $kPZpS(arity);
        length -= holders ? holders.length : 0;
        if (bitmask & $3eea84024a50d6cf$var$WRAP_PARTIAL_RIGHT_FLAG) {
            var partialsRight = partials, holdersRight = holders;
            partials = holders = undefined;
        }
        var data = isBindKey ? undefined : $dzqxs(func);
        var newData = [
            func,
            bitmask,
            thisArg,
            partials,
            holders,
            partialsRight,
            holdersRight,
            argPos,
            ary,
            arity
        ];
        if (data) $c8pf3(newData, data);
        func = newData[0];
        bitmask = newData[1];
        thisArg = newData[2];
        partials = newData[3];
        holders = newData[4];
        arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : $3eea84024a50d6cf$var$nativeMax(newData[9] - length, 0);
        if (!arity && bitmask & ($3eea84024a50d6cf$var$WRAP_CURRY_FLAG | $3eea84024a50d6cf$var$WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~($3eea84024a50d6cf$var$WRAP_CURRY_FLAG | $3eea84024a50d6cf$var$WRAP_CURRY_RIGHT_FLAG);
        if (!bitmask || bitmask == $3eea84024a50d6cf$var$WRAP_BIND_FLAG) var result = $1BSxH(func, bitmask, thisArg);
        else if (bitmask == $3eea84024a50d6cf$var$WRAP_CURRY_FLAG || bitmask == $3eea84024a50d6cf$var$WRAP_CURRY_RIGHT_FLAG) result = $gQoGK(func, bitmask, arity);
        else if ((bitmask == $3eea84024a50d6cf$var$WRAP_PARTIAL_FLAG || bitmask == ($3eea84024a50d6cf$var$WRAP_BIND_FLAG | $3eea84024a50d6cf$var$WRAP_PARTIAL_FLAG)) && !holders.length) result = $cwXqG(func, bitmask, thisArg, partials);
        else result = $2pq1V.apply(undefined, newData);
        var setter = data ? $g1o5k : $4EzKU;
        return $iKqmZ(setter(result, newData), func, bitmask);
    }
    module.exports = $3eea84024a50d6cf$var$createWrap;
});
parcelRegister("g1o5k", function(module, exports) {
    var $etyzk = parcelRequire("etyzk");
    var $hQCy5 = parcelRequire("hQCy5");
    var $ba9f6c1d52531584$var$baseSetData = !$hQCy5 ? $etyzk : function(func, data) {
        $hQCy5.set(func, data);
        return func;
    };
    module.exports = $ba9f6c1d52531584$var$baseSetData;
});
parcelRegister("1BSxH", function(module, exports) {
    var $iJkMv = parcelRequire("iJkMv");
    var $1V15E = parcelRequire("1V15E");
    var $12c38e2c5009183b$var$WRAP_BIND_FLAG = 1;
    function $12c38e2c5009183b$var$createBind(func, bitmask, thisArg) {
        var isBind = bitmask & $12c38e2c5009183b$var$WRAP_BIND_FLAG, Ctor = $iJkMv(func);
        function wrapper() {
            var fn = this && this !== $1V15E && this instanceof wrapper ? Ctor : func;
            return fn.apply(isBind ? thisArg : this, arguments);
        }
        return wrapper;
    }
    module.exports = $12c38e2c5009183b$var$createBind;
});
parcelRegister("iJkMv", function(module, exports) {
    var $ady43 = parcelRequire("ady43");
    var $k0qYG = parcelRequire("k0qYG");
    function $da2c8caf7ae3955a$var$createCtor(Ctor) {
        return function() {
            var args = arguments;
            switch(args.length){
                case 0:
                    return new Ctor;
                case 1:
                    return new Ctor(args[0]);
                case 2:
                    return new Ctor(args[0], args[1]);
                case 3:
                    return new Ctor(args[0], args[1], args[2]);
                case 4:
                    return new Ctor(args[0], args[1], args[2], args[3]);
                case 5:
                    return new Ctor(args[0], args[1], args[2], args[3], args[4]);
                case 6:
                    return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
                case 7:
                    return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
            }
            var thisBinding = $ady43(Ctor.prototype), result = Ctor.apply(thisBinding, args);
            return $k0qYG(result) ? result : thisBinding;
        };
    }
    module.exports = $da2c8caf7ae3955a$var$createCtor;
});
parcelRegister("gQoGK", function(module, exports) {
    var $hlchF = parcelRequire("hlchF");
    var $iJkMv = parcelRequire("iJkMv");
    var $2pq1V = parcelRequire("2pq1V");
    var $6fuEo = parcelRequire("6fuEo");
    var $8ZIC5 = parcelRequire("8ZIC5");
    var $kBUUu = parcelRequire("kBUUu");
    var $1V15E = parcelRequire("1V15E");
    function $c434a7442e0e841e$var$createCurry(func, bitmask, arity) {
        var Ctor = $iJkMv(func);
        function wrapper() {
            var length = arguments.length, args = Array(length), index = length, placeholder = $8ZIC5(wrapper);
            while(index--)args[index] = arguments[index];
            var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : $kBUUu(args, placeholder);
            length -= holders.length;
            if (length < arity) return $6fuEo(func, bitmask, $2pq1V, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
            var fn = this && this !== $1V15E && this instanceof wrapper ? Ctor : func;
            return $hlchF(fn, this, args);
        }
        return wrapper;
    }
    module.exports = $c434a7442e0e841e$var$createCurry;
});
parcelRegister("2pq1V", function(module, exports) {
    var $k8MLc = parcelRequire("k8MLc");
    var $eqXBf = parcelRequire("eqXBf");
    var $khpbX = parcelRequire("khpbX");
    var $iJkMv = parcelRequire("iJkMv");
    var $6fuEo = parcelRequire("6fuEo");
    var $8ZIC5 = parcelRequire("8ZIC5");
    var $3Prcz = parcelRequire("3Prcz");
    var $kBUUu = parcelRequire("kBUUu");
    var $1V15E = parcelRequire("1V15E");
    var $1c121b92b9034c1f$var$WRAP_BIND_FLAG = 1, $1c121b92b9034c1f$var$WRAP_BIND_KEY_FLAG = 2, $1c121b92b9034c1f$var$WRAP_CURRY_FLAG = 8, $1c121b92b9034c1f$var$WRAP_CURRY_RIGHT_FLAG = 16, $1c121b92b9034c1f$var$WRAP_ARY_FLAG = 128, $1c121b92b9034c1f$var$WRAP_FLIP_FLAG = 512;
    function $1c121b92b9034c1f$var$createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
        var isAry = bitmask & $1c121b92b9034c1f$var$WRAP_ARY_FLAG, isBind = bitmask & $1c121b92b9034c1f$var$WRAP_BIND_FLAG, isBindKey = bitmask & $1c121b92b9034c1f$var$WRAP_BIND_KEY_FLAG, isCurried = bitmask & ($1c121b92b9034c1f$var$WRAP_CURRY_FLAG | $1c121b92b9034c1f$var$WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & $1c121b92b9034c1f$var$WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : $iJkMv(func);
        function wrapper() {
            var length = arguments.length, args = Array(length), index = length;
            while(index--)args[index] = arguments[index];
            if (isCurried) var placeholder = $8ZIC5(wrapper), holdersCount = $khpbX(args, placeholder);
            if (partials) args = $k8MLc(args, partials, holders, isCurried);
            if (partialsRight) args = $eqXBf(args, partialsRight, holdersRight, isCurried);
            length -= holdersCount;
            if (isCurried && length < arity) {
                var newHolders = $kBUUu(args, placeholder);
                return $6fuEo(func, bitmask, $1c121b92b9034c1f$var$createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
            }
            var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
            length = args.length;
            if (argPos) args = $3Prcz(args, argPos);
            else if (isFlip && length > 1) args.reverse();
            if (isAry && ary < length) args.length = ary;
            if (this && this !== $1V15E && this instanceof wrapper) fn = Ctor || $iJkMv(fn);
            return fn.apply(thisBinding, args);
        }
        return wrapper;
    }
    module.exports = $1c121b92b9034c1f$var$createHybrid;
});
parcelRegister("k8MLc", function(module, exports) {
    var $ea9a60ca966f8da9$var$nativeMax = Math.max;
    function $ea9a60ca966f8da9$var$composeArgs(args, partials, holders, isCurried) {
        var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = $ea9a60ca966f8da9$var$nativeMax(argsLength - holdersLength, 0), result = Array(leftLength + rangeLength), isUncurried = !isCurried;
        while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
        while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
        while(rangeLength--)result[leftIndex++] = args[argsIndex++];
        return result;
    }
    module.exports = $ea9a60ca966f8da9$var$composeArgs;
});
parcelRegister("eqXBf", function(module, exports) {
    var $a821b9ab167c5b82$var$nativeMax = Math.max;
    function $a821b9ab167c5b82$var$composeArgsRight(args, partials, holders, isCurried) {
        var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = $a821b9ab167c5b82$var$nativeMax(argsLength - holdersLength, 0), result = Array(rangeLength + rightLength), isUncurried = !isCurried;
        while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
        var offset = argsIndex;
        while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
        while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
        return result;
    }
    module.exports = $a821b9ab167c5b82$var$composeArgsRight;
});
parcelRegister("khpbX", function(module, exports) {
    function $ec38efbc1ab3f809$var$countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while(length--)if (array[length] === placeholder) ++result;
        return result;
    }
    module.exports = $ec38efbc1ab3f809$var$countHolders;
});
parcelRegister("6fuEo", function(module, exports) {
    var $2dCKt = parcelRequire("2dCKt");
    var $4EzKU = parcelRequire("4EzKU");
    var $iKqmZ = parcelRequire("iKqmZ");
    var $48cbeb57943323d5$var$WRAP_BIND_FLAG = 1, $48cbeb57943323d5$var$WRAP_BIND_KEY_FLAG = 2, $48cbeb57943323d5$var$WRAP_CURRY_BOUND_FLAG = 4, $48cbeb57943323d5$var$WRAP_CURRY_FLAG = 8, $48cbeb57943323d5$var$WRAP_PARTIAL_FLAG = 32, $48cbeb57943323d5$var$WRAP_PARTIAL_RIGHT_FLAG = 64;
    function $48cbeb57943323d5$var$createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
        var isCurry = bitmask & $48cbeb57943323d5$var$WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
        bitmask |= isCurry ? $48cbeb57943323d5$var$WRAP_PARTIAL_FLAG : $48cbeb57943323d5$var$WRAP_PARTIAL_RIGHT_FLAG;
        bitmask &= ~(isCurry ? $48cbeb57943323d5$var$WRAP_PARTIAL_RIGHT_FLAG : $48cbeb57943323d5$var$WRAP_PARTIAL_FLAG);
        if (!(bitmask & $48cbeb57943323d5$var$WRAP_CURRY_BOUND_FLAG)) bitmask &= ~($48cbeb57943323d5$var$WRAP_BIND_FLAG | $48cbeb57943323d5$var$WRAP_BIND_KEY_FLAG);
        var newData = [
            func,
            bitmask,
            thisArg,
            newPartials,
            newHolders,
            newPartialsRight,
            newHoldersRight,
            argPos,
            ary,
            arity
        ];
        var result = wrapFunc.apply(undefined, newData);
        if ($2dCKt(func)) $4EzKU(result, newData);
        result.placeholder = placeholder;
        return $iKqmZ(result, func, bitmask);
    }
    module.exports = $48cbeb57943323d5$var$createRecurry;
});
parcelRegister("4EzKU", function(module, exports) {
    var $g1o5k = parcelRequire("g1o5k");
    var $eqv0t = parcelRequire("eqv0t");
    var $3636a22a88d50b78$var$setData = $eqv0t($g1o5k);
    module.exports = $3636a22a88d50b78$var$setData;
});
parcelRegister("iKqmZ", function(module, exports) {
    var $d25DY = parcelRequire("d25DY");
    var $iPKwQ = parcelRequire("iPKwQ");
    var $8pgNR = parcelRequire("8pgNR");
    var $1ZcUe = parcelRequire("1ZcUe");
    function $da60fa5a8c702882$var$setWrapToString(wrapper, reference, bitmask) {
        var source = reference + '';
        return $8pgNR(wrapper, $iPKwQ(source, $1ZcUe($d25DY(source), bitmask)));
    }
    module.exports = $da60fa5a8c702882$var$setWrapToString;
});
parcelRegister("d25DY", function(module, exports) {
    var $97cfd7023a392295$var$reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, $97cfd7023a392295$var$reSplitDetails = /,? & /;
    function $97cfd7023a392295$var$getWrapDetails(source) {
        var match = source.match($97cfd7023a392295$var$reWrapDetails);
        return match ? match[1].split($97cfd7023a392295$var$reSplitDetails) : [];
    }
    module.exports = $97cfd7023a392295$var$getWrapDetails;
});
parcelRegister("iPKwQ", function(module, exports) {
    var $db61150bcd231438$var$reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;
    function $db61150bcd231438$var$insertWrapDetails(source, details) {
        var length = details.length;
        if (!length) return source;
        var lastIndex = length - 1;
        details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
        details = details.join(length > 2 ? ', ' : ' ');
        return source.replace($db61150bcd231438$var$reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }
    module.exports = $db61150bcd231438$var$insertWrapDetails;
});
parcelRegister("1ZcUe", function(module, exports) {
    var $fmP8r = parcelRequire("fmP8r");
    var $fUP98 = parcelRequire("fUP98");
    var $17257fcfcc231370$var$WRAP_BIND_FLAG = 1, $17257fcfcc231370$var$WRAP_BIND_KEY_FLAG = 2, $17257fcfcc231370$var$WRAP_CURRY_FLAG = 8, $17257fcfcc231370$var$WRAP_CURRY_RIGHT_FLAG = 16, $17257fcfcc231370$var$WRAP_PARTIAL_FLAG = 32, $17257fcfcc231370$var$WRAP_PARTIAL_RIGHT_FLAG = 64, $17257fcfcc231370$var$WRAP_ARY_FLAG = 128, $17257fcfcc231370$var$WRAP_REARG_FLAG = 256, $17257fcfcc231370$var$WRAP_FLIP_FLAG = 512;
    var $17257fcfcc231370$var$wrapFlags = [
        [
            'ary',
            $17257fcfcc231370$var$WRAP_ARY_FLAG
        ],
        [
            'bind',
            $17257fcfcc231370$var$WRAP_BIND_FLAG
        ],
        [
            'bindKey',
            $17257fcfcc231370$var$WRAP_BIND_KEY_FLAG
        ],
        [
            'curry',
            $17257fcfcc231370$var$WRAP_CURRY_FLAG
        ],
        [
            'curryRight',
            $17257fcfcc231370$var$WRAP_CURRY_RIGHT_FLAG
        ],
        [
            'flip',
            $17257fcfcc231370$var$WRAP_FLIP_FLAG
        ],
        [
            'partial',
            $17257fcfcc231370$var$WRAP_PARTIAL_FLAG
        ],
        [
            'partialRight',
            $17257fcfcc231370$var$WRAP_PARTIAL_RIGHT_FLAG
        ],
        [
            'rearg',
            $17257fcfcc231370$var$WRAP_REARG_FLAG
        ]
    ];
    function $17257fcfcc231370$var$updateWrapDetails(details, bitmask) {
        $fmP8r($17257fcfcc231370$var$wrapFlags, function(pair) {
            var value = '_.' + pair[0];
            if (bitmask & pair[1] && !$fUP98(details, value)) details.push(value);
        });
        return details.sort();
    }
    module.exports = $17257fcfcc231370$var$updateWrapDetails;
});
parcelRegister("8ZIC5", function(module, exports) {
    function $68c6a086039b9437$var$getHolder(func) {
        var object = func;
        return object.placeholder;
    }
    module.exports = $68c6a086039b9437$var$getHolder;
});
parcelRegister("3Prcz", function(module, exports) {
    var $jHlUS = parcelRequire("jHlUS");
    var $e8U1z = parcelRequire("e8U1z");
    var $2c9b3c36ffa24094$var$nativeMin = Math.min;
    function $2c9b3c36ffa24094$var$reorder(array, indexes) {
        var arrLength = array.length, length = $2c9b3c36ffa24094$var$nativeMin(indexes.length, arrLength), oldArray = $jHlUS(array);
        while(length--){
            var index = indexes[length];
            array[length] = $e8U1z(index, arrLength) ? oldArray[index] : undefined;
        }
        return array;
    }
    module.exports = $2c9b3c36ffa24094$var$reorder;
});
parcelRegister("kBUUu", function(module, exports) {
    var $f0136883d4267917$var$PLACEHOLDER = '__lodash_placeholder__';
    function $f0136883d4267917$var$replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while(++index < length){
            var value = array[index];
            if (value === placeholder || value === $f0136883d4267917$var$PLACEHOLDER) {
                array[index] = $f0136883d4267917$var$PLACEHOLDER;
                result[resIndex++] = index;
            }
        }
        return result;
    }
    module.exports = $f0136883d4267917$var$replaceHolders;
});
parcelRegister("cwXqG", function(module, exports) {
    var $hlchF = parcelRequire("hlchF");
    var $iJkMv = parcelRequire("iJkMv");
    var $1V15E = parcelRequire("1V15E");
    var $91f6929c17575724$var$WRAP_BIND_FLAG = 1;
    function $91f6929c17575724$var$createPartial(func, bitmask, thisArg, partials) {
        var isBind = bitmask & $91f6929c17575724$var$WRAP_BIND_FLAG, Ctor = $iJkMv(func);
        function wrapper() {
            var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array(leftLength + argsLength), fn = this && this !== $1V15E && this instanceof wrapper ? Ctor : func;
            while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
            while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
            return $hlchF(fn, isBind ? thisArg : this, args);
        }
        return wrapper;
    }
    module.exports = $91f6929c17575724$var$createPartial;
});
parcelRegister("c8pf3", function(module, exports) {
    var $k8MLc = parcelRequire("k8MLc");
    var $eqXBf = parcelRequire("eqXBf");
    var $kBUUu = parcelRequire("kBUUu");
    var $8d59cfe3586d6695$var$PLACEHOLDER = '__lodash_placeholder__';
    var $8d59cfe3586d6695$var$WRAP_BIND_FLAG = 1, $8d59cfe3586d6695$var$WRAP_BIND_KEY_FLAG = 2, $8d59cfe3586d6695$var$WRAP_CURRY_BOUND_FLAG = 4, $8d59cfe3586d6695$var$WRAP_CURRY_FLAG = 8, $8d59cfe3586d6695$var$WRAP_ARY_FLAG = 128, $8d59cfe3586d6695$var$WRAP_REARG_FLAG = 256;
    var $8d59cfe3586d6695$var$nativeMin = Math.min;
    function $8d59cfe3586d6695$var$mergeData(data, source) {
        var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < ($8d59cfe3586d6695$var$WRAP_BIND_FLAG | $8d59cfe3586d6695$var$WRAP_BIND_KEY_FLAG | $8d59cfe3586d6695$var$WRAP_ARY_FLAG);
        var isCombo = srcBitmask == $8d59cfe3586d6695$var$WRAP_ARY_FLAG && bitmask == $8d59cfe3586d6695$var$WRAP_CURRY_FLAG || srcBitmask == $8d59cfe3586d6695$var$WRAP_ARY_FLAG && bitmask == $8d59cfe3586d6695$var$WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == ($8d59cfe3586d6695$var$WRAP_ARY_FLAG | $8d59cfe3586d6695$var$WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == $8d59cfe3586d6695$var$WRAP_CURRY_FLAG;
        if (!(isCommon || isCombo)) return data;
        if (srcBitmask & $8d59cfe3586d6695$var$WRAP_BIND_FLAG) {
            data[2] = source[2];
            newBitmask |= bitmask & $8d59cfe3586d6695$var$WRAP_BIND_FLAG ? 0 : $8d59cfe3586d6695$var$WRAP_CURRY_BOUND_FLAG;
        }
        var value = source[3];
        if (value) {
            var partials = data[3];
            data[3] = partials ? $k8MLc(partials, value, source[4]) : value;
            data[4] = partials ? $kBUUu(data[3], $8d59cfe3586d6695$var$PLACEHOLDER) : source[4];
        }
        value = source[5];
        if (value) {
            partials = data[5];
            data[5] = partials ? $eqXBf(partials, value, source[6]) : value;
            data[6] = partials ? $kBUUu(data[5], $8d59cfe3586d6695$var$PLACEHOLDER) : source[6];
        }
        value = source[7];
        if (value) data[7] = value;
        if (srcBitmask & $8d59cfe3586d6695$var$WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : $8d59cfe3586d6695$var$nativeMin(data[8], source[8]);
        if (data[9] == null) data[9] = source[9];
        data[0] = source[0];
        data[1] = newBitmask;
        return data;
    }
    module.exports = $8d59cfe3586d6695$var$mergeData;
});
parcelRegister("91VA7", function(module, exports) {
    var $7MmCC = parcelRequire("7MmCC");
    var $6930df867851495d$var$CLONE_SYMBOLS_FLAG = 4;
    function $6930df867851495d$var$clone(value) {
        return $7MmCC(value, $6930df867851495d$var$CLONE_SYMBOLS_FLAG);
    }
    module.exports = $6930df867851495d$var$clone;
});
parcelRegister("a7NzZ", function(module, exports) {
    var $5oTQF = parcelRequire("5oTQF");
    var $75f10447dad5f8f2$var$WRAP_CURRY_FLAG = 8;
    function $75f10447dad5f8f2$var$curry(func, arity, guard) {
        arity = guard ? undefined : arity;
        var result = $5oTQF(func, $75f10447dad5f8f2$var$WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
        result.placeholder = $75f10447dad5f8f2$var$curry.placeholder;
        return result;
    }
    $75f10447dad5f8f2$var$curry.placeholder = {};
    module.exports = $75f10447dad5f8f2$var$curry;
});
parcelRegister("aZFhV", function(module, exports) {
    var $beQoo = parcelRequire("beQoo");
    var $fC1Kz = parcelRequire("fC1Kz");
    var $1QOns = parcelRequire("1QOns");
    var $800fa0dabdb52684$var$domExcTag = '[object DOMException]', $800fa0dabdb52684$var$errorTag = '[object Error]';
    function $800fa0dabdb52684$var$isError(value) {
        if (!$fC1Kz(value)) return false;
        var tag = $beQoo(value);
        return tag == $800fa0dabdb52684$var$errorTag || tag == $800fa0dabdb52684$var$domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !$1QOns(value);
    }
    module.exports = $800fa0dabdb52684$var$isError;
});
parcelRegister("5UxIS", function(module, exports) {
    var $jtBGw = parcelRequire("jtBGw");
    var $fC1Kz = parcelRequire("fC1Kz");
    var $44dc5758474a5c9f$var$weakMapTag = '[object WeakMap]';
    function $44dc5758474a5c9f$var$isWeakMap(value) {
        return $fC1Kz(value) && $jtBGw(value) == $44dc5758474a5c9f$var$weakMapTag;
    }
    module.exports = $44dc5758474a5c9f$var$isWeakMap;
});
parcelRegister("5qDt4", function(module, exports) {
    var $7MmCC = parcelRequire("7MmCC");
    var $bxDef = parcelRequire("bxDef");
    var $3f3dfefad45dde4d$var$CLONE_DEEP_FLAG = 1;
    function $3f3dfefad45dde4d$var$iteratee(func) {
        return $bxDef(typeof func == 'function' ? func : $7MmCC(func, $3f3dfefad45dde4d$var$CLONE_DEEP_FLAG));
    }
    module.exports = $3f3dfefad45dde4d$var$iteratee;
});
parcelRegister("iZlmO", function(module, exports) {
    var $5oTQF = parcelRequire("5oTQF");
    var $9SRAA = parcelRequire("9SRAA");
    var $dd2e7f874e5ccea3$var$WRAP_REARG_FLAG = 256;
    var $dd2e7f874e5ccea3$var$rearg = $9SRAA(function(func, indexes) {
        return $5oTQF(func, $dd2e7f874e5ccea3$var$WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });
    module.exports = $dd2e7f874e5ccea3$var$rearg;
});
parcelRegister("6TYHJ", function(module, exports) {
    var $1nIHN = parcelRequire("1nIHN");
    var $jHlUS = parcelRequire("jHlUS");
    var $8LQ84 = parcelRequire("8LQ84");
    var $4faK3 = parcelRequire("4faK3");
    var $h5JBK = parcelRequire("h5JBK");
    var $gzebZ = parcelRequire("gzebZ");
    var $jJVtR = parcelRequire("jJVtR");
    function $5066f7c1bc1a55ec$var$toPath(value) {
        if ($8LQ84(value)) return $1nIHN(value, $gzebZ);
        return $4faK3(value) ? [
            value
        ] : $jHlUS($h5JBK($jJVtR(value)));
    }
    module.exports = $5066f7c1bc1a55ec$var$toPath;
});
parcelRegister("iASWI", function(module, exports) {
    var $irTmi = parcelRequire("irTmi");
    var $d89635f071f7433a$var$range = $irTmi();
    module.exports = $d89635f071f7433a$var$range;
});
parcelRegister("irTmi", function(module, exports) {
    var $7DMj9 = parcelRequire("7DMj9");
    var $4rDUz = parcelRequire("4rDUz");
    var $kJ0Lf = parcelRequire("kJ0Lf");
    function $d6e5b0af0cc26ead$var$createRange(fromRight) {
        return function(start, end, step) {
            if (step && typeof step != 'number' && $4rDUz(start, end, step)) end = step = undefined;
            start = $kJ0Lf(start);
            if (end === undefined) {
                end = start;
                start = 0;
            } else end = $kJ0Lf(end);
            step = step === undefined ? start < end ? 1 : -1 : $kJ0Lf(step);
            return $7DMj9(start, end, step, fromRight);
        };
    }
    module.exports = $d6e5b0af0cc26ead$var$createRange;
});
parcelRegister("7DMj9", function(module, exports) {
    var $5901a5dd7694a169$var$nativeCeil = Math.ceil, $5901a5dd7694a169$var$nativeMax = Math.max;
    function $5901a5dd7694a169$var$baseRange(start, end, step, fromRight) {
        var index = -1, length = $5901a5dd7694a169$var$nativeMax($5901a5dd7694a169$var$nativeCeil((end - start) / (step || 1)), 0), result = Array(length);
        while(length--){
            result[fromRight ? length : ++index] = start;
            start += step;
        }
        return result;
    }
    module.exports = $5901a5dd7694a169$var$baseRange;
});
parcelRegister("2vEiN", function(module, exports) {
    $parcel$export(module.exports, "getIsTableEmpty", ()=>$334022f4a2ef522c$export$b8347bf00a122737);
    $parcel$export(module.exports, "getItemsSelectionCount", ()=>$334022f4a2ef522c$export$a3c7ec1348b0395b);
    $parcel$export(module.exports, "getItems", ()=>$334022f4a2ef522c$export$d2f92acf417bbf5d);
    $parcel$export(module.exports, "getItemIndexes", ()=>$334022f4a2ef522c$export$b3e7f67495a21c55);
    $parcel$export(module.exports, "getItemsContainerStyles", ()=>$334022f4a2ef522c$export$cc1469a0793758e9);
    $parcel$export(module.exports, "getItemHeight", ()=>$334022f4a2ef522c$export$ddd834f23fa82fc4);
    $parcel$export(module.exports, "getItemsCount", ()=>$334022f4a2ef522c$export$dd01a43948d7de86);
    $parcel$export(module.exports, "getAriaRowCount", ()=>$334022f4a2ef522c$export$3d62f784b6f09127);
    $parcel$export(module.exports, "getHasActiveCreate", ()=>$334022f4a2ef522c$export$37a764c3aa026241);
    $parcel$export(module.exports, "getCreateItemAnchor", ()=>$334022f4a2ef522c$export$136936d41252875f);
    $parcel$export(module.exports, "getCreateItemAnchorIndex", ()=>$334022f4a2ef522c$export$32b1b971ba5fa108);
    $parcel$export(module.exports, "getSelectedItemIds", ()=>$334022f4a2ef522c$export$e9f0552305c19203);
    $parcel$export(module.exports, "getActiveItemId", ()=>$334022f4a2ef522c$export$b40482e3ca743b81);
    $parcel$export(module.exports, "getIsItemActive", ()=>$334022f4a2ef522c$export$4b209aa328dc6c69);
    $parcel$export(module.exports, "getIsItemSelected", ()=>$334022f4a2ef522c$export$eacf042ab4fde4a7);
    $parcel$export(module.exports, "getIsItemMultiSelected", ()=>$334022f4a2ef522c$export$1c36f8ddcf135195);
    $parcel$export(module.exports, "getIsItemSelectable", ()=>$334022f4a2ef522c$export$b3fb6474950e2ea0);
    var $4R6GH;
    var $6dDSs;
    var $iZN6h;
    var $7ouUj;
    const $334022f4a2ef522c$export$b8347bf00a122737 = (state)=>state.isTableEmpty;
    const $334022f4a2ef522c$export$71297f0abe09788f = ({ itemsSelectionState: itemsSelectionState }, id)=>itemsSelectionState ? itemsSelectionState[id] ?? false : undefined;
    const $334022f4a2ef522c$export$42fccc645f404e95 = ({ itemsSelectionState: itemsSelectionState, itemsSelectionCount: itemsSelectionCount }, id)=>{
        if (!itemsSelectionState || itemsSelectionCount === undefined) return undefined;
        return itemsSelectionCount > 1 && itemsSelectionState[id] || false;
    };
    const $334022f4a2ef522c$export$a3c7ec1348b0395b = (state)=>state.selectedItemIds.length;
    const $334022f4a2ef522c$export$d2f92acf417bbf5d = (state)=>state.items;
    const $334022f4a2ef522c$export$b3e7f67495a21c55 = (state)=>state.itemIndexes;
    const $334022f4a2ef522c$export$cc1469a0793758e9 = (state)=>({
            itemsBackground: state.itemsBackground,
            totalHeight: state.totalHeight
        });
    const $334022f4a2ef522c$export$ddd834f23fa82fc4 = (state)=>state.itemHeight;
    const $334022f4a2ef522c$export$dd01a43948d7de86 = (state)=>state.items.length;
    const $334022f4a2ef522c$export$3d62f784b6f09127 = (state)=>state.ariaRowCount;
    const $334022f4a2ef522c$export$37a764c3aa026241 = (state)=>state.createItemAnchor !== undefined;
    const $334022f4a2ef522c$export$136936d41252875f = (state)=>state.createItemAnchor;
    const $334022f4a2ef522c$export$32b1b971ba5fa108 = ({ createItemAnchor: createItemAnchor, itemIndexes: itemIndexes })=>{
        if (!createItemAnchor || createItemAnchor.position === (0, (0, parcelRequire("iZN6h")).LAST)) return undefined;
        if (createItemAnchor.beforeId) return itemIndexes[createItemAnchor.beforeId];
        if (createItemAnchor.parentId) return itemIndexes[createItemAnchor.parentId];
    };
    const $334022f4a2ef522c$export$e9f0552305c19203 = (state)=>state.selectedItemIds;
    const $334022f4a2ef522c$export$b40482e3ca743b81 = (state)=>state.activeItemId;
    const $334022f4a2ef522c$export$4b209aa328dc6c69 = (state, id)=>state.activeItemId === id;
    const $334022f4a2ef522c$export$6c44f432f7ffa367 = (0, (0, parcelRequire("6dDSs")).createSelector)([
        $334022f4a2ef522c$export$e9f0552305c19203
    ], (selectedItemIds)=>new Set(selectedItemIds));
    const $334022f4a2ef522c$export$eacf042ab4fde4a7 = (state, id)=>{
        if (!(0, (0, parcelRequire("4R6GH")).fg)('project_timeline_multi-select_and_checkboxes')) return $334022f4a2ef522c$export$71297f0abe09788f(state, id);
        return $334022f4a2ef522c$export$6c44f432f7ffa367(state).has(id);
    };
    const $334022f4a2ef522c$export$1c36f8ddcf135195 = (state, id)=>{
        if (!(0, (0, parcelRequire("4R6GH")).fg)('project_timeline_multi-select_and_checkboxes')) return $334022f4a2ef522c$export$42fccc645f404e95(state, id);
        const selection = $334022f4a2ef522c$export$6c44f432f7ffa367(state);
        return selection.size > 1 && selection.has(id);
    };
    const $334022f4a2ef522c$var$getFirstSelectedItem = ({ items: items, itemIndexes: itemIndexes, selectedItemIds: selectedItemIds })=>selectedItemIds.length > 0 ? items[itemIndexes[selectedItemIds[0]]] : undefined;
    const $334022f4a2ef522c$export$b3fb6474950e2ea0 = (0, (0, parcelRequire("6dDSs")).createSelector)([
        $334022f4a2ef522c$export$d2f92acf417bbf5d,
        $334022f4a2ef522c$export$b3e7f67495a21c55,
        $334022f4a2ef522c$var$getFirstSelectedItem,
        (_, itemId)=>itemId
    ], (items, itemIndexes, firstSelectedItem, itemId)=>{
        if (!firstSelectedItem) return true;
        const item = items[itemIndexes[itemId]];
        if (!item) return false;
        return (0, (0, parcelRequire("7ouUj")).getItemLevel)(firstSelectedItem) === (0, (0, parcelRequire("7ouUj")).getItemLevel)(item) && firstSelectedItem.meta.parentId === item.meta.parentId;
    });
});
parcelRegister("9puhl", function(module, exports) {
    $parcel$export(module.exports, "useListWidth", ()=>$8908d54a7209f6db$export$55c090d16aa0f75d);
    $parcel$export(module.exports, "useListItemMenuOptions", ()=>$8908d54a7209f6db$export$1951ac3cbf4049a0);
    $parcel$export(module.exports, "default", ()=>$8908d54a7209f6db$export$2e2bcd8739ae039);
    var $4R6GH;
    var $3sQ5x;
    var $gg7kZ;
    var $iXqE5;
    var $iZN6h;
    var $8blQT;
    var $45N9l;
    const $8908d54a7209f6db$var$initialState = {
        listWidth: 0,
        listItemMenuOptions: {
            overrideLabels: {},
            customSections: [],
            customSectionsBulk: []
        }
    };
    const $8908d54a7209f6db$export$3e2081a696ef1795 = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $8908d54a7209f6db$var$initialState,
        actions: (0, parcelRequire("8blQT")).actions,
        name: 'timeline-table.list'
    });
    const $8908d54a7209f6db$export$469df0dd4929d037 = (0, (0, parcelRequire("3sQ5x")).createActionsHook)($8908d54a7209f6db$export$3e2081a696ef1795);
    const $8908d54a7209f6db$export$55c090d16aa0f75d = (0, (0, parcelRequire("3sQ5x")).createHook)($8908d54a7209f6db$export$3e2081a696ef1795, {
        selector: (0, (0, parcelRequire("45N9l")).getListWidth)
    });
    const $8908d54a7209f6db$export$1951ac3cbf4049a0 = (0, (0, parcelRequire("3sQ5x")).createHook)($8908d54a7209f6db$export$3e2081a696ef1795, {
        selector: (0, (0, parcelRequire("45N9l")).getListItemMenuOptions)
    });
    const $8908d54a7209f6db$export$2f645645f7bca764 = (0, (0, parcelRequire("3sQ5x")).createHook)($8908d54a7209f6db$export$3e2081a696ef1795);
    const $8908d54a7209f6db$export$9b0a72e5d41d62ec = (0, (0, parcelRequire("gg7kZ")).createContainer)($8908d54a7209f6db$export$3e2081a696ef1795, {
        onInit: ()=>({ setState: setState }, listState)=>{
                setState({
                    ...listState,
                    ...(0, (0, parcelRequire("4R6GH")).fg)('project_timeline_multi-select_and_checkboxes') && {
                        listWidth: Math.max((0, (0, parcelRequire("iZN6h")).MINIMUM_LIST_WIDTH)(), listState.listWidth)
                    }
                });
            },
        onUpdate: ()=>({ setState: setState }, listState)=>{
                setState({
                    ...listState,
                    ...(0, (0, parcelRequire("4R6GH")).fg)('project_timeline_multi-select_and_checkboxes') && {
                        listWidth: Math.max((0, (0, parcelRequire("iZN6h")).MINIMUM_LIST_WIDTH)(), listState.listWidth)
                    }
                });
            }
    });
    var $8908d54a7209f6db$export$2e2bcd8739ae039 = $8908d54a7209f6db$export$9b0a72e5d41d62ec;
});
parcelRegister("8blQT", function(module, exports) {
    $parcel$export(module.exports, "actions", ()=>$248b6a58cffa4e63$export$e324594224ef24da);
    var $34Zjv;
    const $248b6a58cffa4e63$export$e324594224ef24da = {
        setListWidth: (0, parcelRequire("34Zjv")).setListWidth
    };
});
parcelRegister("34Zjv", function(module, exports) {
    $parcel$export(module.exports, "setListWidth", ()=>$a7e782f1b950c324$export$e9fd6c0c57a999a3);
    const $a7e782f1b950c324$export$e9fd6c0c57a999a3 = (listWidth)=>({ setState: setState })=>{
            setState({
                listWidth: listWidth
            });
        };
});
parcelRegister("45N9l", function(module, exports) {
    $parcel$export(module.exports, "getListWidth", ()=>$c72198c17c460390$export$546faffca0a891d);
    $parcel$export(module.exports, "getListItemMenuOptions", ()=>$c72198c17c460390$export$2d38f26d6331442e);
    const $c72198c17c460390$export$546faffca0a891d = (state)=>state.listWidth;
    const $c72198c17c460390$export$2d38f26d6331442e = (state)=>state.listItemMenuOptions;
});
parcelRegister("cQx6e", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6fd9ed6ab2b605b2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $c7Iuw;
    const $6fd9ed6ab2b605b2$var$TablePortalProvider = (props)=>{
        const [portalContainerElement, setPortalContainerElement] = (0, $5uXOq.useState)(null);
        const portalState = (0, $5uXOq.useMemo)(()=>({
                setPortalContainerElement: setPortalContainerElement,
                portalContainerElement: portalContainerElement
            }), [
            portalContainerElement
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c7Iuw")).PortalScopeContext).Provider, {
            value: portalState
        }, props.children);
    };
    var $6fd9ed6ab2b605b2$export$2e2bcd8739ae039 = $6fd9ed6ab2b605b2$var$TablePortalProvider;
});
parcelRegister("c7Iuw", function(module, exports) {
    $parcel$export(module.exports, "PortalScopeContext", ()=>$4da8629c07fd2ab2$export$c9ecc14d092a6ed0);
    $parcel$export(module.exports, "usePortalScope", ()=>$4da8629c07fd2ab2$export$ed9db44bbd000055);
    var $5uXOq = parcelRequire("5uXOq");
    const $4da8629c07fd2ab2$export$c9ecc14d092a6ed0 = (0, $5uXOq.createContext)({
        setPortalContainerElement: ()=>undefined,
        portalContainerElement: null
    });
    const $4da8629c07fd2ab2$export$ed9db44bbd000055 = ()=>(0, $5uXOq.useContext)($4da8629c07fd2ab2$export$c9ecc14d092a6ed0);
});
parcelRegister("3ruU1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3d93168080b8ac44$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "useSideEffectMarshal", ()=>$3d93168080b8ac44$export$b2476fd3df1b06b6);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $4R6GH;
    var $3MKmR;
    var $82CeN;
    var $7de6U;
    var $7OK0c;
    var $hS1s8;
    var $ehMvl;
    var $93fNo;
    var $2SP8o;
    const $3d93168080b8ac44$var$SideEffectMarshal = ({ scope: scope, customActions: customActions, overrideActions: overrideActions, ariaLabel: ariaLabel, ariaReadOnly: ariaReadOnly, ariaMultiselectable: ariaMultiselectable, children: children })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const styleAPI = (0, (0, parcelRequire("93fNo")).useStyleMarshal)(scope);
        const rowState = (0, (0, parcelRequire("ehMvl")).useRowState)();
        const defaultActions = (0, $5uXOq.useMemo)(()=>{
            const onRowMouseEnter = (id)=>{
                if (rowState.get(id) || rowState.isAnyRowDragging()) return;
                styleAPI.hoverRow(id);
            };
            const onRowMouseLeave = (id)=>{
                if (rowState.get(id) || rowState.isAnyRowDragging()) return;
                styleAPI.leaveRow(id);
            };
            const onRowFocus = (id)=>{
                if (!(0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline_table_meatballs_menu_a11y')) return;
                if (rowState.get(id) || rowState.isAnyRowDragging()) return;
                rowState.set(id, (0, (0, parcelRequire("hS1s8")).ROW_STATES).FOCUSED);
                styleAPI.hoverRow(id);
            };
            const onRowBlur = (id)=>{
                if (!(0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline_table_meatballs_menu_a11y')) return;
                if (rowState.get(id) !== (0, (0, parcelRequire("hS1s8")).ROW_STATES).FOCUSED || rowState.isAnyRowDragging()) return;
                rowState.clear(id);
                styleAPI.leaveRow(id);
            };
            const onRowSelect = (ids)=>{
                ids.forEach((id)=>rowState.set(id, (0, (0, parcelRequire("hS1s8")).ROW_STATES).SELECTED));
                styleAPI.selectRow(ids);
            };
            const onRowDeselect = (ids)=>{
                ids.forEach((id)=>rowState.clear(id));
                styleAPI.deselectRow();
            };
            const onRowGenerateDragPreview = ()=>{
                styleAPI.hideChildCreate();
            };
            const onRowDragStart = (id)=>{
                rowState.set(id, (0, (0, parcelRequire("hS1s8")).ROW_STATES).DRAGGED);
                styleAPI.dragRow(id);
            };
            const onRowDragEnd = (id)=>{
                const wasRowSelected = rowState.wasRowSelected(id);
                wasRowSelected ? rowState.set(id, (0, (0, parcelRequire("hS1s8")).ROW_STATES).SELECTED) : rowState.clear(id);
                styleAPI.dropRow(id, wasRowSelected);
            };
            const onRowDragOver = (id, top, left)=>{
                rowState.set(id, (0, (0, parcelRequire("hS1s8")).ROW_STATES).DRAGGED_OVER);
                styleAPI.showDragIndicator(top, left);
            };
            const onRowDragChildOverParent = (id, parentId)=>{
                rowState.set(id, (0, (0, parcelRequire("hS1s8")).ROW_STATES).DRAGGED_OVER);
                styleAPI.dragOverParent(parentId, rowState.get(parentId) === (0, (0, parcelRequire("hS1s8")).ROW_STATES).SELECTED);
            };
            const onRowDragChildOverParentEnd = (parentId)=>{
                styleAPI.leaveRow(parentId);
            };
            const onRowDragOutOfBounds = (id)=>{
                rowState.set(id, (0, (0, parcelRequire("hS1s8")).ROW_STATES).DRAGGED_OUT);
                styleAPI.dragOutOfBounds();
            };
            const onAddButtonMouseEnter = (top, tabFocused)=>{
                if (rowState.isAnyRowDragging()) return;
                styleAPI.showInlineCreate(top, tabFocused);
            };
            const onAddButtonMouseLeave = ()=>{
                if (rowState.isAnyRowDragging()) return;
                styleAPI.hideInlineCreate();
            };
            const onScrollStateChanged = (isScrolling)=>{
                if (rowState.isAnyRowDragging()) return;
                isScrolling ? styleAPI.blockPointerEvents() : styleAPI.allowPointerEvents();
            };
            return {
                onRowMouseEnter: onRowMouseEnter,
                onRowMouseLeave: onRowMouseLeave,
                onRowSelect: onRowSelect,
                onRowDeselect: onRowDeselect,
                onRowFocus: onRowFocus,
                onRowBlur: onRowBlur,
                onRowGenerateDragPreview: onRowGenerateDragPreview,
                onRowDragStart: onRowDragStart,
                onRowDragEnd: onRowDragEnd,
                onRowDragOver: onRowDragOver,
                onRowDragChildOverParent: onRowDragChildOverParent,
                onRowDragChildOverParentEnd: onRowDragChildOverParentEnd,
                onRowDragOutOfBounds: onRowDragOutOfBounds,
                onAddButtonMouseEnter: onAddButtonMouseEnter,
                onAddButtonMouseLeave: onAddButtonMouseLeave,
                onScrollStateChanged: onScrollStateChanged
            };
        }, [
            rowState,
            styleAPI
        ]);
        const combinedActions = (0, $5uXOq.useMemo)(()=>({
                ...(0, (0, parcelRequire("2SP8o")).bindOverrideActions)(defaultActions, overrideActions, styleAPI),
                custom: (0, (0, parcelRequire("2SP8o")).bindCustomActions)(customActions, styleAPI)
            }), [
            defaultActions,
            customActions,
            overrideActions,
            styleAPI
        ]);
        const GridComponent = (0, (0, parcelRequire("4R6GH")).fg)('timeline_grid_navigation_m2') ? (0, (0, parcelRequire("7de6U")).Grid) : (0, (0, parcelRequire("7de6U")).GridOld);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3MKmR")).SideEffectContext).Provider, {
            value: combinedActions
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("82CeN")).FocusMarshalProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement(GridComponent, {
            scope: scope,
            ariaReadOnly: ariaReadOnly,
            ariaMultiselectable: ariaMultiselectable,
            ariaLabel: ariaLabel ?? formatMessage((0, (0, parcelRequire("7OK0c")).default).defaultLabel)
        }, children)));
    };
    $3d93168080b8ac44$var$SideEffectMarshal.defaultProps = {
        customActions: {},
        overrideActions: {},
        ariaLabel: undefined,
        ariaReadOnly: undefined,
        ariaMultiselectable: undefined
    };
    var $3d93168080b8ac44$export$2e2bcd8739ae039 = $3d93168080b8ac44$var$SideEffectMarshal;
    const $3d93168080b8ac44$export$b2476fd3df1b06b6 = ()=>(0, $5uXOq.useContext)((0, (0, parcelRequire("3MKmR")).SideEffectContext));
});
parcelRegister("3MKmR", function(module, exports) {
    $parcel$export(module.exports, "SideEffectContext", ()=>$dc4147209a0266e0$export$f87600ce6f9a1288);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    const $dc4147209a0266e0$export$f87600ce6f9a1288 = (0, $5uXOq.createContext)({
        custom: {},
        onRowMouseEnter: (0, ($parcel$interopDefault($8Rkzz))),
        onRowMouseLeave: (0, ($parcel$interopDefault($8Rkzz))),
        onRowSelect: (0, ($parcel$interopDefault($8Rkzz))),
        onRowDeselect: (0, ($parcel$interopDefault($8Rkzz))),
        onRowFocus: (0, ($parcel$interopDefault($8Rkzz))),
        onRowBlur: (0, ($parcel$interopDefault($8Rkzz))),
        onRowGenerateDragPreview: (0, ($parcel$interopDefault($8Rkzz))),
        onRowDragStart: (0, ($parcel$interopDefault($8Rkzz))),
        onRowDragEnd: (0, ($parcel$interopDefault($8Rkzz))),
        onRowDragOver: (0, ($parcel$interopDefault($8Rkzz))),
        onRowDragChildOverParent: (0, ($parcel$interopDefault($8Rkzz))),
        onRowDragChildOverParentEnd: (0, ($parcel$interopDefault($8Rkzz))),
        onRowDragOutOfBounds: (0, ($parcel$interopDefault($8Rkzz))),
        onAddButtonMouseEnter: (0, ($parcel$interopDefault($8Rkzz))),
        onAddButtonMouseLeave: (0, ($parcel$interopDefault($8Rkzz))),
        onScrollStateChanged: (0, ($parcel$interopDefault($8Rkzz)))
    });
});
parcelRegister("82CeN", function(module, exports) {
    $parcel$export(module.exports, "useFocusMarshal", ()=>$ad6f6f91368ea63b$export$c8db889fd790e2d0);
    $parcel$export(module.exports, "useIsNavigationEnabled", ()=>$ad6f6f91368ea63b$export$197de480eb3dcfb5);
    $parcel$export(module.exports, "useIsNavigationPrevented", ()=>$ad6f6f91368ea63b$export$f0f577624c158cba);
    $parcel$export(module.exports, "useIsCreateTriggerActive", ()=>$ad6f6f91368ea63b$export$1d8ad99a41e9aa75);
    $parcel$export(module.exports, "FocusMarshalProvider", ()=>$ad6f6f91368ea63b$export$835dc2bb3cd0a80a);
    var $5uXOq = parcelRequire("5uXOq");
    var $4R6GH;
    var $3sQ5x;
    var $gg7kZ;
    var $iXqE5;
    var $g3prf;
    var $hGh1Z;
    var $2YsNz;
    var $kon0h;
    var $1osZ4;
    const $ad6f6f91368ea63b$var$initialState = {
        gridCells: new (0, (0, parcelRequire("kon0h")).CellMap)(),
        focusedCell: undefined,
        activeCreateTrigger: undefined,
        rovingCell: undefined,
        isNavigationEnabled: true,
        isNavigationPrevented: false
    };
    const $ad6f6f91368ea63b$var$FocusContainer = (0, (0, parcelRequire("gg7kZ")).createContainer)();
    const $ad6f6f91368ea63b$var$focusStore = (0, (0, parcelRequire("iXqE5")).createStore)({
        containedBy: $ad6f6f91368ea63b$var$FocusContainer,
        initialState: $ad6f6f91368ea63b$var$initialState,
        actions: (0, parcelRequire("2YsNz")).actions,
        name: 'timeline-table.focus',
        handlers: {
            onContainerUpdate: (nextProps, prevProps)=>({ getState: getState })=>{
                    if ((0, (0, parcelRequire("4R6GH")).fg)('timeline_grid_navigation_m2')) {
                        if (nextProps.headerIndexes !== prevProps.headerIndexes || nextProps.itemIndexes !== prevProps.itemIndexes) {
                            const cellMap = getState().gridCells;
                            cellMap.setIsDirty(true);
                        }
                    }
                }
        }
    });
    const $ad6f6f91368ea63b$export$c8db889fd790e2d0 = (0, (0, parcelRequire("3sQ5x")).createActionsHook)($ad6f6f91368ea63b$var$focusStore);
    const $ad6f6f91368ea63b$export$ae79915617215704 = (0, (0, parcelRequire("3sQ5x")).createStateHook)($ad6f6f91368ea63b$var$focusStore);
    const $ad6f6f91368ea63b$export$197de480eb3dcfb5 = (0, (0, parcelRequire("3sQ5x")).createStateHook)($ad6f6f91368ea63b$var$focusStore, {
        selector: (0, (0, parcelRequire("1osZ4")).isNavigationEnabled)
    });
    const $ad6f6f91368ea63b$export$f0f577624c158cba = (0, (0, parcelRequire("3sQ5x")).createStateHook)($ad6f6f91368ea63b$var$focusStore, {
        selector: (0, (0, parcelRequire("1osZ4")).isNavigationPrevented)
    });
    const $ad6f6f91368ea63b$export$1d8ad99a41e9aa75 = (0, (0, parcelRequire("3sQ5x")).createHook)($ad6f6f91368ea63b$var$focusStore, {
        selector: (0, (0, parcelRequire("1osZ4")).isCreateTriggerActiveForItem)
    });
    const $ad6f6f91368ea63b$export$835dc2bb3cd0a80a = ({ children: children })=>{
        const [headerIndexesUnstable] = (0, (0, parcelRequire("g3prf")).useHeaderItemIndexes)();
        const [itemIndexesUnstable] = (0, (0, parcelRequire("hGh1Z")).useItemIndexes)();
        const headerIndexes = (0, $5uXOq.useRef)(headerIndexesUnstable);
        const itemIndexes = (0, $5uXOq.useRef)(itemIndexesUnstable);
        (0, $5uXOq.useEffect)(()=>{
            headerIndexes.current = headerIndexesUnstable;
            itemIndexes.current = itemIndexesUnstable;
        });
        const getCoordinates = (0, $5uXOq.useCallback)((getRowData)=>{
            const { column: column, rowId: rowId } = getRowData();
            const itemIndexOffset = Object.keys(headerIndexes.current).length;
            const row = headerIndexes.current[rowId] ?? itemIndexes.current[rowId] + itemIndexOffset;
            return [
                column,
                row
            ];
        }, []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($ad6f6f91368ea63b$var$FocusContainer, {
            getCoordinates: getCoordinates,
            ...(0, (0, parcelRequire("4R6GH")).fg)('timeline_grid_navigation_m2') ? {
                headerIndexes: headerIndexes.current,
                itemIndexes: itemIndexes.current
            } : {}
        }, children);
    };
});
parcelRegister("2YsNz", function(module, exports) {
    $parcel$export(module.exports, "actions", ()=>$58d14c3de517b7e4$export$e324594224ef24da);
    var $4R6GH;
    const $58d14c3de517b7e4$var$rove = (current, next)=>({ setState: setState })=>{
            current?.setAttribute('tabindex', '-1');
            next.setAttribute('tabindex', '0');
            setState({
                rovingCell: next
            });
        };
    const $58d14c3de517b7e4$var$reconcile = (previous)=>({ getState: getState, dispatch: dispatch })=>{
            const { gridCells: gridCells, rovingCell: rovingCell, focusedCell: focusedCell } = getState();
            if (previous === rovingCell) {
                const nextCell = gridCells.getStart(rovingCell, true);
                if (nextCell) {
                    dispatch($58d14c3de517b7e4$var$rove(undefined, nextCell));
                    previous === focusedCell && nextCell.focus();
                }
            }
        };
    const $58d14c3de517b7e4$var$toggleNavigation = (cell, shouldEnable, autofocus)=>({ getState: getState, setState: setState })=>{
            const { gridCells: gridCells } = getState();
            const cellContent = gridCells.get(cell)?.getContent();
            if (!cellContent) return;
            if (shouldEnable) {
                setState({
                    isNavigationEnabled: true
                });
                autofocus && cell.focus();
            } else if (!shouldEnable && cellContent.length > 0) {
                setState({
                    isNavigationEnabled: false
                });
                autofocus && cellContent[0].focus();
            }
        };
    const $58d14c3de517b7e4$var$enableNavigation = ({ autofocus: autofocus } = {
        autofocus: true
    })=>({ getState: getState, dispatch: dispatch })=>{
            const { rovingCell: rovingCell, isNavigationEnabled: isNavigationEnabled } = getState();
            if (!isNavigationEnabled && rovingCell) dispatch($58d14c3de517b7e4$var$toggleNavigation(rovingCell, true, autofocus));
        };
    const $58d14c3de517b7e4$var$disableNavigation = ({ autofocus: autofocus } = {
        autofocus: true
    })=>({ getState: getState, dispatch: dispatch })=>{
            const { focusedCell: focusedCell, isNavigationEnabled: isNavigationEnabled } = getState();
            if (isNavigationEnabled && focusedCell) dispatch($58d14c3de517b7e4$var$toggleNavigation(focusedCell, false, autofocus));
        };
    const $58d14c3de517b7e4$var$initialiseRovingCell = (elem)=>({ getState: getState, setState: setState })=>{
            if (!getState().rovingCell) setState({
                rovingCell: elem
            });
        };
    const $58d14c3de517b7e4$var$createGetCoordinates = (getData, { getCoordinates: getCoordinates })=>()=>getCoordinates(getData);
    const $58d14c3de517b7e4$var$trackCell = (elem, getData, getContent)=>({ getState: getState }, containerProps)=>{
            const getCoordinates = $58d14c3de517b7e4$var$createGetCoordinates(getData, containerProps);
            getState().gridCells.set(elem, {
                getCoordinates: getCoordinates,
                getContent: getContent
            });
        };
    const $58d14c3de517b7e4$var$untrackCell = (elem)=>({ getState: getState, dispatch: dispatch })=>{
            const { gridCells: gridCells } = getState();
            gridCells.delete(elem);
            dispatch($58d14c3de517b7e4$var$reconcile(elem));
        };
    const $58d14c3de517b7e4$var$focusCellOld = (elem)=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
            const { gridCells: gridCells, rovingCell: rovingCell } = getState();
            if (gridCells.has(elem)) {
                setState({
                    focusedCell: elem
                });
                if (elem !== rovingCell) dispatch($58d14c3de517b7e4$var$rove(rovingCell, elem));
            }
        };
    const $58d14c3de517b7e4$var$focusCell = (cell, focusing)=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
            const { gridCells: gridCells, rovingCell: rovingCell, isNavigationEnabled: isNavigationEnabled } = getState();
            if (isNavigationEnabled && gridCells.has(focusing)) {
                setState({
                    focusedCell: focusing
                });
                if (focusing !== rovingCell) dispatch($58d14c3de517b7e4$var$rove(rovingCell, focusing));
            } else if (isNavigationEnabled && cell.contains(focusing)) {
                setState({
                    focusedCell: cell
                });
                if (cell !== rovingCell) dispatch($58d14c3de517b7e4$var$rove(rovingCell, cell));
            } else if (!isNavigationEnabled && rovingCell) {
                const cellContent = gridCells.get(rovingCell)?.getContent();
                const isContentToFocus = cellContent && cellContent.length > 0;
                if (isContentToFocus && focusing === rovingCell) cellContent[cellContent.length - 1].focus();
                else if (isContentToFocus && !rovingCell.contains(focusing)) cellContent[0].focus();
            }
        };
    const $58d14c3de517b7e4$var$blurCell = (blurring)=>({ getState: getState, setState: setState })=>{
            const { gridCells: gridCells, focusedCell: focusedCell } = getState();
            if (gridCells.has(blurring) && focusedCell === blurring) setState({
                focusedCell: undefined
            });
        };
    const $58d14c3de517b7e4$var$navigateCell = (type, { ctrlKey: ctrlKey })=>({ getState: getState, dispatch: dispatch })=>{
            const { isNavigationEnabled: isNavigationEnabled, gridCells: gridCells, focusedCell: focusedCell } = getState();
            if (!isNavigationEnabled && (0, (0, parcelRequire("4R6GH")).fg)('timeline_grid_navigation_m2')) return;
            if (!focusedCell) return;
            let nextCell;
            switch(type){
                case 'ArrowLeft':
                    nextCell = gridCells.getBefore(focusedCell);
                    break;
                case 'ArrowRight':
                    nextCell = gridCells.getAfter(focusedCell);
                    break;
                case 'ArrowUp':
                    nextCell = gridCells.getAbove(focusedCell);
                    break;
                case 'ArrowDown':
                    nextCell = gridCells.getBelow(focusedCell);
                    break;
                case 'PageUp':
                    nextCell = gridCells.getAbove(focusedCell, (0, $d9d2477c67cdc919$export$25f3022e3913e948));
                    break;
                case 'PageDown':
                    nextCell = gridCells.getBelow(focusedCell, (0, $d9d2477c67cdc919$export$25f3022e3913e948));
                    break;
                case 'Home':
                    nextCell = gridCells.getStart(focusedCell, ctrlKey);
                    break;
                case 'End':
                    nextCell = gridCells.getEnd(focusedCell, ctrlKey);
                    break;
                default:
                    break;
            }
            if (nextCell && nextCell !== focusedCell) {
                dispatch($58d14c3de517b7e4$var$rove(focusedCell, nextCell));
                nextCell.focus();
            }
        };
    const $58d14c3de517b7e4$var$setActiveCreateTrigger = (rowId, type, element)=>({ setState: setState })=>{
            if ((0, (0, parcelRequire("4R6GH")).fg)('timeline_grid_navigation_m2')) setState({
                isNavigationEnabled: true,
                activeCreateTrigger: {
                    rowId: rowId,
                    type: type,
                    element: element
                }
            });
            else setState({
                activeCreateTrigger: {
                    rowId: rowId,
                    type: type,
                    element: element
                }
            });
        };
    const $58d14c3de517b7e4$var$resetRovingCell = ()=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
            const { gridCells: gridCells, rovingCell: rovingCell } = getState();
            if (rovingCell) {
                const origin = gridCells.getClosestStartOrEnd(rovingCell);
                if (origin) {
                    setState({
                        isNavigationEnabled: true
                    });
                    dispatch($58d14c3de517b7e4$var$rove(rovingCell, origin));
                }
            }
        };
    const $58d14c3de517b7e4$var$removeActiveCreateTrigger = ()=>({ setState: setState })=>{
            setState({
                activeCreateTrigger: undefined
            });
        };
    const $58d14c3de517b7e4$var$focusCreateTrigger = ()=>({ getState: getState, setState: setState })=>{
            const activeCreateTrigger = getState().activeCreateTrigger;
            if (activeCreateTrigger && !(0, (0, parcelRequire("4R6GH")).fg)('timeline_grid_navigation_m2')) {
                setState({
                    activeCreateTrigger: undefined
                });
                activeCreateTrigger.element?.focus();
            } else if (activeCreateTrigger && (0, (0, parcelRequire("4R6GH")).fg)('timeline_grid_navigation_m2')) {
                activeCreateTrigger.element?.focus();
                setState({
                    isNavigationEnabled: false,
                    activeCreateTrigger: undefined
                });
            }
        };
    const $58d14c3de517b7e4$var$shouldPreventNavigation = (isNavigationPrevented)=>({ setState: setState })=>{
            setState({
                isNavigationPrevented: isNavigationPrevented
            });
        };
    const $58d14c3de517b7e4$export$e324594224ef24da = {
        enableNavigation: $58d14c3de517b7e4$var$enableNavigation,
        disableNavigation: $58d14c3de517b7e4$var$disableNavigation,
        shouldPreventNavigation: $58d14c3de517b7e4$var$shouldPreventNavigation,
        initialiseRovingCell: $58d14c3de517b7e4$var$initialiseRovingCell,
        resetRovingCell: $58d14c3de517b7e4$var$resetRovingCell,
        trackCell: $58d14c3de517b7e4$var$trackCell,
        untrackCell: $58d14c3de517b7e4$var$untrackCell,
        focusCellOld: $58d14c3de517b7e4$var$focusCellOld,
        focusCell: $58d14c3de517b7e4$var$focusCell,
        blurCell: $58d14c3de517b7e4$var$blurCell,
        navigateCell: $58d14c3de517b7e4$var$navigateCell,
        setActiveCreateTrigger: $58d14c3de517b7e4$var$setActiveCreateTrigger,
        focusCreateTrigger: $58d14c3de517b7e4$var$focusCreateTrigger,
        removeActiveCreateTrigger: $58d14c3de517b7e4$var$removeActiveCreateTrigger
    };
});
const $d9d2477c67cdc919$export$25f3022e3913e948 = 5;
parcelRegister("kon0h", function(module, exports) {
    $parcel$export(module.exports, "CellMap", ()=>$489e7d6098a5dd71$export$8c5f03eb5739ef16);
    var $4R6GH;
    var $73cx7;
    class $489e7d6098a5dd71$export$8c5f03eb5739ef16 extends Map {
        set(key, value) {
            this.isDirty = true;
            return super.set(key, value);
        }
        delete(key) {
            this.isDirty = true;
            return super.delete(key);
        }
        clear() {
            this.isDirty = true;
            return super.clear();
        }
        setIsDirty(value) {
            this.isDirty = value;
        }
        getBefore(key) {
            const cell = this.get(key);
            if (!cell) return;
            this.prepareCoordinates();
            const [column, row] = cell.getCoordinates();
            return this.getClosestByColumn(column - 1, row);
        }
        getAfter(key) {
            const cell = this.get(key);
            if (!cell) return;
            this.prepareCoordinates();
            const [column, row] = cell.getCoordinates();
            return this.getClosestByColumn(column + 1, row);
        }
        getAbove(key, offset = 1) {
            const cell = this.get(key);
            if (!cell) return;
            this.prepareCoordinates();
            const [column, row] = cell.getCoordinates();
            return this.getClosestByRow(column, row - offset);
        }
        getBelow(key, offset = 1) {
            const cell = this.get(key);
            if (!cell) return;
            this.prepareCoordinates();
            const [column, row] = cell.getCoordinates();
            return this.getClosestByRow(column, row + offset);
        }
        getStart(key, isGlobal = false) {
            this.prepareCoordinates();
            const cell = this.get(key);
            if (isGlobal || !cell) return this.elementLookup.get((0, (0, parcelRequire("73cx7")).coordToString)(...this.globalMin));
            const [, row] = cell.getCoordinates();
            const columnBoundary = this.columnBoundaries.get(row);
            if (columnBoundary) return this.getClosestByColumn(columnBoundary.min, row);
        }
        getEnd(key, isGlobal = false) {
            this.prepareCoordinates();
            const cell = this.get(key);
            if (isGlobal || !cell) return this.elementLookup.get((0, (0, parcelRequire("73cx7")).coordToString)(...this.globalMax));
            const [, row] = cell.getCoordinates();
            const columnBoundary = this.columnBoundaries.get(row);
            if (columnBoundary) return this.getClosestByColumn(columnBoundary.max, row);
        }
        getClosestStartOrEnd(key) {
            const cell = this.get(key);
            if (!cell) return;
            this.prepareCoordinates();
            const [column, row] = cell.getCoordinates();
            const rowBoundary = this.rowBoundaries.get(column);
            if (rowBoundary) {
                const isClosestToStart = Math.abs(row - rowBoundary.min) <= Math.abs(row - rowBoundary.max);
                return isClosestToStart ? this.getStart(key, true) : this.getEnd(key, true);
            }
        }
        clean() {
            this.elementLookup.clear();
            this.rowBoundaries.clear();
            this.columnBoundaries.clear();
            this.globalMin = [
                0,
                0
            ];
            this.globalMax = [
                0,
                0
            ];
            this.isDirty = false;
        }
        prepareCoordinates() {
            if (!this.isDirty) return;
            this.clean();
            for (const [key, value] of this){
                const [column, row] = value.getCoordinates();
                this.elementLookup.set((0, (0, parcelRequire("73cx7")).coordToString)(column, row), key);
                const rowBoundary = this.rowBoundaries.get(column);
                const columnBoundary = this.columnBoundaries.get(row);
                if (rowBoundary === undefined) this.rowBoundaries.set(column, {
                    min: row,
                    max: row
                });
                else {
                    const min = Math.min(rowBoundary.min, row);
                    const max = Math.max(rowBoundary.max, row);
                    this.rowBoundaries.set(column, {
                        min: min,
                        max: max
                    });
                }
                if (columnBoundary === undefined) this.columnBoundaries.set(row, {
                    min: column,
                    max: column
                });
                else {
                    const min = Math.min(columnBoundary.min, column);
                    const max = Math.max(columnBoundary.max, column);
                    this.columnBoundaries.set(row, {
                        min: min,
                        max: max
                    });
                }
                if (row <= this.globalMin[1]) {
                    const updatedColumnBoundary = this.columnBoundaries.get(row);
                    const minColumn = updatedColumnBoundary?.min ?? this.globalMin[0];
                    this.globalMin = [
                        minColumn,
                        row
                    ];
                }
                if (row >= this.globalMax[1]) {
                    const updatedColumnBoundary = this.columnBoundaries.get(row);
                    const maxColumn = updatedColumnBoundary?.max ?? this.globalMax[0];
                    this.globalMax = [
                        maxColumn,
                        row
                    ];
                }
            }
        }
        getClosestByRow(column, row) {
            const happyCell = this.elementLookup.get((0, (0, parcelRequire("73cx7")).coordToString)(column, row));
            if (happyCell) return happyCell;
            const columnBoundary = this.columnBoundaries.get(row);
            const rowBoundary = this.rowBoundaries.get(column);
            if (columnBoundary) {
                const clampedColumn = columnBoundary.max;
                return this.elementLookup.get((0, (0, parcelRequire("73cx7")).coordToString)(clampedColumn, row));
            }
            if (rowBoundary && (row > rowBoundary.max || row < rowBoundary.min)) {
                const isClosestToStart = Math.abs(row - rowBoundary.min) <= Math.abs(row - rowBoundary.max);
                const closestRow = isClosestToStart ? rowBoundary.min : rowBoundary.max;
                return this.elementLookup.get((0, (0, parcelRequire("73cx7")).coordToString)(column, closestRow));
            }
            if (rowBoundary && row <= rowBoundary.max && row >= rowBoundary.min && (0, (0, parcelRequire("4R6GH")).fg)('timeline_grid_navigation_m2')) {
                const possibleRows = [];
                for (const [, value] of this){
                    const coordinates = value.getCoordinates();
                    if (coordinates[0] === column && coordinates[1] > row) possibleRows.push(coordinates[1]);
                }
                const fastSortArray = Uint32Array.from(possibleRows).sort();
                return this.elementLookup.get((0, (0, parcelRequire("73cx7")).coordToString)(column, fastSortArray[0]));
            }
            return undefined;
        }
        getClosestByColumn(column, row) {
            return this.elementLookup.get((0, (0, parcelRequire("73cx7")).coordToString)(column, row));
        }
        constructor(...args){
            super(...args);
            this.isDirty = false;
            this.elementLookup = new Map();
            this.rowBoundaries = new Map();
            this.columnBoundaries = new Map();
            this.globalMin = [
                0,
                0
            ];
            this.globalMax = [
                0,
                0
            ];
        }
    }
});
parcelRegister("73cx7", function(module, exports) {
    $parcel$export(module.exports, "coordToString", ()=>$f9b93de51acf695d$export$ad1ba9454d886ee3);
    const $f9b93de51acf695d$export$ad1ba9454d886ee3 = (column, row)=>String([
            column,
            row
        ]);
});
parcelRegister("1osZ4", function(module, exports) {
    $parcel$export(module.exports, "isCreateTriggerActiveForItem", ()=>$cd0c6342bed88239$export$e90c69d47d50701f);
    $parcel$export(module.exports, "isNavigationEnabled", ()=>$cd0c6342bed88239$export$146dfdd989f678b);
    $parcel$export(module.exports, "isNavigationPrevented", ()=>$cd0c6342bed88239$export$627dcd18967df965);
    const $cd0c6342bed88239$export$e90c69d47d50701f = (state, { id: id, type: type })=>{
        const activeCreateTrigger = state.activeCreateTrigger;
        if (activeCreateTrigger) return activeCreateTrigger.rowId === id && activeCreateTrigger.type === type;
    };
    const $cd0c6342bed88239$export$146dfdd989f678b = (state)=>state.isNavigationEnabled;
    const $cd0c6342bed88239$export$627dcd18967df965 = (state)=>state.isNavigationPrevented;
});
parcelRegister("7de6U", function(module, exports) {
    $parcel$export(module.exports, "GridOld", ()=>$9902ab059fcf964a$export$9e141a01a3e47f8e);
    $parcel$export(module.exports, "Grid", ()=>$9902ab059fcf964a$export$ef2184bd89960b14);
    var $5uXOq = parcelRequire("5uXOq");
    var $4R6GH;
    var $WPwAA;
    var $hGh1Z;
    var $cvOvx;
    const $9902ab059fcf964a$export$9e141a01a3e47f8e = ({ scope: scope, ariaMultiselectable: ariaMultiselectable, ariaLabel: ariaLabel, ariaReadOnly: ariaReadOnly, children: children })=>{
        const [ariaRowCount] = (0, (0, parcelRequire("hGh1Z")).useAriaRowCount)();
        const eventHandlers = (0, (0, parcelRequire("cvOvx")).useGridContainerOld)();
        const [{ isMultiSelectEnabled: isMultiSelectEnabled }] = (0, (0, parcelRequire("WPwAA")).useEnablements)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            role: "grid",
            "aria-rowcount": ariaRowCount,
            "aria-multiselectable": (0, (0, parcelRequire("4R6GH")).fg)('project_timeline_multi-select_and_checkboxes') ? isMultiSelectEnabled || undefined : ariaMultiselectable,
            "aria-label": ariaLabel,
            "aria-readonly": ariaReadOnly,
            className: scope,
            ...eventHandlers
        }, children);
    };
    const $9902ab059fcf964a$export$ef2184bd89960b14 = ({ scope: scope, ariaMultiselectable: ariaMultiselectable, ariaLabel: ariaLabel, ariaReadOnly: ariaReadOnly, children: children })=>{
        const [ariaRowCount] = (0, (0, parcelRequire("hGh1Z")).useAriaRowCount)();
        const containerProps = (0, (0, parcelRequire("cvOvx")).useGridContainer)();
        const [{ isMultiSelectEnabled: isMultiSelectEnabled }] = (0, (0, parcelRequire("WPwAA")).useEnablements)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            role: "grid",
            "aria-rowcount": ariaRowCount,
            "aria-multiselectable": (0, (0, parcelRequire("4R6GH")).fg)('project_timeline_multi-select_and_checkboxes') ? isMultiSelectEnabled || undefined : ariaMultiselectable,
            "aria-label": ariaLabel,
            "aria-readonly": ariaReadOnly,
            className: scope,
            ...containerProps
        }, children);
    };
});
parcelRegister("cvOvx", function(module, exports) {
    $parcel$export(module.exports, "useGridContainer", ()=>$351d3b3ca22da7aa$export$89cacf57f4ae1143);
    $parcel$export(module.exports, "useGridContainerOld", ()=>$351d3b3ca22da7aa$export$ed776ebfb0fadaa3);
    var $5uXOq = parcelRequire("5uXOq");
    var $82CeN;
    const $351d3b3ca22da7aa$var$isElementInGrid = (grid, target)=>{
        let current = target;
        while(current){
            if (current === grid) return true;
            current = current.parentElement;
        }
        return false;
    };
    const $351d3b3ca22da7aa$export$89cacf57f4ae1143 = ()=>{
        const element = (0, $5uXOq.useRef)(null);
        const { enableNavigation: enableNavigation, disableNavigation: disableNavigation, navigateCell: navigateCell, resetRovingCell: resetRovingCell } = (0, (0, parcelRequire("82CeN")).useFocusMarshal)();
        const isNavigationEnabled = (0, (0, parcelRequire("82CeN")).useIsNavigationEnabled)();
        const isNavigationPrevented = (0, (0, parcelRequire("82CeN")).useIsNavigationPrevented)();
        const setGridRef = (0, $5uXOq.useCallback)((ref)=>{
            element.current = ref;
        }, []);
        const onKeyDown = (0, $5uXOq.useCallback)((event)=>{
            const { key: key, ctrlKey: ctrlKey } = event;
            if (isNavigationPrevented) return;
            switch(key){
                case 'Enter':
                    if (isNavigationEnabled) {
                        event.preventDefault();
                        disableNavigation();
                    }
                    break;
                case 'Escape':
                    if (!isNavigationEnabled) {
                        event.preventDefault();
                        enableNavigation();
                    }
                    break;
                case 'ArrowLeft':
                case 'ArrowRight':
                case 'ArrowUp':
                case 'ArrowDown':
                case 'PageUp':
                case 'PageDown':
                case 'Home':
                case 'End':
                    if (isNavigationEnabled) {
                        event.preventDefault();
                        navigateCell(key, {
                            ctrlKey: ctrlKey
                        });
                    }
                    break;
                default:
                    break;
            }
        }, [
            isNavigationPrevented,
            isNavigationEnabled,
            disableNavigation,
            enableNavigation,
            navigateCell
        ]);
        const onKeyUp = (0, $5uXOq.useCallback)(({ key: key })=>{
            if (isNavigationPrevented) return;
            switch(key){
                case 'Tab':
                    if (isNavigationEnabled) disableNavigation({
                        autofocus: false
                    });
                    break;
                default:
                    break;
            }
        }, [
            isNavigationEnabled,
            isNavigationPrevented,
            disableNavigation
        ]);
        const onBlur = (0, $5uXOq.useCallback)(({ relatedTarget: relatedTarget })=>{
            if (isNavigationPrevented) return;
            if (element.current && relatedTarget instanceof HTMLElement && !$351d3b3ca22da7aa$var$isElementInGrid(element.current, relatedTarget)) resetRovingCell();
        }, [
            isNavigationPrevented,
            resetRovingCell
        ]);
        return {
            ref: setGridRef,
            onKeyDown: onKeyDown,
            onKeyUp: onKeyUp,
            onBlur: onBlur
        };
    };
    const $351d3b3ca22da7aa$export$ed776ebfb0fadaa3 = ()=>{
        const { focusCellOld: focusCellOld, blurCell: blurCell, navigateCell: navigateCell } = (0, (0, parcelRequire("82CeN")).useFocusMarshal)();
        const onFocus = (0, $5uXOq.useCallback)((event)=>{
            if (event.target instanceof HTMLElement) focusCellOld(event.target);
        }, [
            focusCellOld
        ]);
        const onBlur = (0, $5uXOq.useCallback)((event)=>{
            if (event.target instanceof HTMLElement) blurCell(event.target);
        }, [
            blurCell
        ]);
        const onKeyDown = (0, $5uXOq.useCallback)((event)=>{
            const { key: key, ctrlKey: ctrlKey } = event;
            switch(key){
                case 'ArrowLeft':
                case 'ArrowRight':
                case 'ArrowUp':
                case 'ArrowDown':
                case 'PageUp':
                case 'PageDown':
                case 'Home':
                case 'End':
                    event.preventDefault();
                    navigateCell(key, {
                        ctrlKey: ctrlKey
                    });
                    break;
                default:
                    break;
            }
        }, [
            navigateCell
        ]);
        return {
            onKeyDown: onKeyDown,
            onFocus: onFocus,
            onBlur: onBlur
        };
    };
});
parcelRegister("7OK0c", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2891709b7dcc590c$export$2e2bcd8739ae039);
    var $7VHMR;
    var $2891709b7dcc590c$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        defaultLabel: {
            id: 'roadmap.timeline-table.common.context.side-effect-marshal.default-label',
            defaultMessage: 'Timeline',
            description: "Default label for assistive technology. Describes in short the purpose of the Timeline's table component"
        }
    });
});
parcelRegister("hS1s8", function(module, exports) {
    $parcel$export(module.exports, "ROW_STATES", ()=>$1ecc5aefc8a6d1ca$export$d17c451ccb229dcb);
    $parcel$export(module.exports, "VALID_INITIAL_STATES", ()=>$1ecc5aefc8a6d1ca$export$43acf26460204930);
    $parcel$export(module.exports, "VALID_TRANSITIONS", ()=>$1ecc5aefc8a6d1ca$export$682b071fc4ac4b0c);
    $parcel$export(module.exports, "DEFAULT_COUNTS", ()=>$1ecc5aefc8a6d1ca$export$ccc216ff57ae82b9);
    const $1ecc5aefc8a6d1ca$export$d17c451ccb229dcb = {
        FOCUSED: 'FOCUSED',
        SELECTED: 'SELECTED',
        DRAGGED: 'DRAGGED',
        DRAGGED_OUT: 'DRAGGED_OUT',
        DRAGGED_OVER: 'DRAGGED_OVER'
    };
    const $1ecc5aefc8a6d1ca$export$43acf26460204930 = {
        FOCUSED: true,
        SELECTED: true,
        DRAGGED: true,
        DRAGGED_OUT: false,
        DRAGGED_OVER: false
    };
    const $1ecc5aefc8a6d1ca$export$682b071fc4ac4b0c = {
        FOCUSED: {
            SELECTED: true,
            DRAGGED: true
        },
        SELECTED: {
            DRAGGED: true
        },
        DRAGGED: {
            SELECTED: true,
            DRAGGED_OUT: true,
            DRAGGED_OVER: true
        },
        DRAGGED_OUT: {
            SELECTED: true,
            DRAGGED_OVER: true
        },
        DRAGGED_OVER: {
            SELECTED: true,
            DRAGGED_OUT: true
        }
    };
    const $1ecc5aefc8a6d1ca$export$ccc216ff57ae82b9 = {
        FOCUSED: 0,
        SELECTED: 0,
        DRAGGED: 0,
        DRAGGED_OUT: 0,
        DRAGGED_OVER: 0
    };
});
parcelRegister("ehMvl", function(module, exports) {
    $parcel$export(module.exports, "useRowState", ()=>$b70c7282056e1f4e$export$b2440517e54eabc);
    var $5uXOq = parcelRequire("5uXOq");
    var $lwMsT;
    var $hUAzM;
    var $hS1s8;
    const $b70c7282056e1f4e$export$b2440517e54eabc = ()=>{
        const rowState = (0, $5uXOq.useRef)({});
        const stateCount = (0, $5uXOq.useRef)({
            ...(0, (0, parcelRequire("hS1s8")).DEFAULT_COUNTS)
        });
        const previouslySelected = (0, $5uXOq.useRef)({});
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const fireInvalidRowTransitionEvent = (0, $5uXOq.useCallback)((message)=>{
            const event = createAnalyticsEvent({
                action: 'invalidRowTransition',
                actionSubject: 'timelineTable.sideEffectMarshall',
                attributes: {
                    message: message
                }
            });
            (0, (0, parcelRequire("hUAzM")).fireOperationalAnalyticsEvent)(event);
        }, [
            createAnalyticsEvent
        ]);
        const fireEmptyRowEntryEvent = (0, $5uXOq.useCallback)(()=>{
            const event = createAnalyticsEvent({
                action: 'emptyRowEntry',
                actionSubject: 'timelineTable.sideEffectMarshall'
            });
            (0, (0, parcelRequire("hUAzM")).fireOperationalAnalyticsEvent)(event);
        }, [
            createAnalyticsEvent
        ]);
        const updateStateCount = (0, $5uXOq.useCallback)((currentState, nextState)=>{
            if (currentState) stateCount.current[currentState] -= 1;
            if (nextState) stateCount.current[nextState] += 1;
        }, []);
        const isAnyRowDragging = (0, $5uXOq.useCallback)(()=>stateCount.current[(0, (0, parcelRequire("hS1s8")).ROW_STATES).DRAGGED] > 0 || stateCount.current[(0, (0, parcelRequire("hS1s8")).ROW_STATES).DRAGGED_OVER] > 0 || stateCount.current[(0, (0, parcelRequire("hS1s8")).ROW_STATES).DRAGGED_OUT] > 0, []);
        const updatePreviouslySelected = (0, $5uXOq.useCallback)((id, currentState, nextState)=>{
            if (nextState && currentState === (0, (0, parcelRequire("hS1s8")).ROW_STATES).SELECTED) previouslySelected.current[id] = true;
            if (!nextState || nextState === (0, (0, parcelRequire("hS1s8")).ROW_STATES).SELECTED) delete previouslySelected.current[id];
        }, []);
        const wasRowSelected = (0, $5uXOq.useCallback)((id)=>previouslySelected.current[id] ?? false, []);
        const get = (0, $5uXOq.useCallback)((id)=>rowState.current[id], []);
        const set = (0, $5uXOq.useCallback)((id, nextState)=>{
            const currentState = get(id);
            if (!currentState && (0, (0, parcelRequire("hS1s8")).VALID_INITIAL_STATES)[nextState] || currentState && (0, (0, parcelRequire("hS1s8")).VALID_TRANSITIONS)[currentState][nextState]) {
                updateStateCount(currentState, nextState);
                updatePreviouslySelected(id, currentState, nextState);
                rowState.current[id] = nextState;
            } else if (currentState !== nextState) fireInvalidRowTransitionEvent(`Invalid transition from ${currentState} to ${nextState}`);
        }, [
            get,
            updateStateCount,
            updatePreviouslySelected,
            fireInvalidRowTransitionEvent
        ]);
        const clear = (0, $5uXOq.useCallback)((id)=>{
            const currentState = get(id);
            if (currentState) {
                updateStateCount(currentState);
                updatePreviouslySelected(id, currentState);
                delete rowState.current[id];
            } else fireEmptyRowEntryEvent();
        }, [
            get,
            updateStateCount,
            updatePreviouslySelected,
            fireEmptyRowEntryEvent
        ]);
        return (0, $5uXOq.useMemo)(()=>({
                get: get,
                set: set,
                clear: clear,
                isAnyRowDragging: isAnyRowDragging,
                wasRowSelected: wasRowSelected
            }), [
            get,
            set,
            clear,
            isAnyRowDragging,
            wasRowSelected
        ]);
    };
});
parcelRegister("hUAzM", function(module, exports) {
    $parcel$export(module.exports, "fireOperationalAnalyticsEvent", ()=>$5566e8787897db11$export$4e7937b444ac21e8);
    $parcel$export(module.exports, "fireUIAnalyticsEvent", ()=>$5566e8787897db11$export$47e016b53a5f0465);
    const $5566e8787897db11$var$EVENT_TYPES = {
        UI: 'UI',
        TRACK: 'TRACK',
        SCREEN: 'SCREEN',
        OPERATIONAL: 'OPERATIONAL'
    };
    const $5566e8787897db11$var$createFireAnalytics = (analyticsType)=>(event)=>{
            const clonedEvent = event.clone();
            if (clonedEvent) clonedEvent.update({
                ...event.payload,
                analyticsType: analyticsType
            }).fire('productAnalytics');
        };
    const $5566e8787897db11$export$4e7937b444ac21e8 = $5566e8787897db11$var$createFireAnalytics($5566e8787897db11$var$EVENT_TYPES.OPERATIONAL);
    const $5566e8787897db11$export$47e016b53a5f0465 = $5566e8787897db11$var$createFireAnalytics($5566e8787897db11$var$EVENT_TYPES.UI);
});
parcelRegister("93fNo", function(module, exports) {
    $parcel$export(module.exports, "useStyleMarshal", ()=>$82aa8295b40d45f4$export$984a1617ce4cc44b);
    var $5uXOq = parcelRequire("5uXOq");
    var $4R6GH;
    var $ghKWA;
    const $82aa8295b40d45f4$export$984a1617ce4cc44b = (scope)=>{
        const styleEl = (0, $5uXOq.useRef)();
        (0, $5uXOq.useLayoutEffect)(()=>{
            if (typeof document !== 'undefined') {
                styleEl.current = document.createElement('style');
                styleEl.current.id = 'roadmap-data-styles';
                const head = document.querySelector('head');
                head && head.appendChild(styleEl.current);
            }
            return ()=>{
                styleEl.current?.parentNode?.removeChild(styleEl.current);
            };
        }, []);
        const styleUtils = (0, $5uXOq.useMemo)(()=>{
            const insertStyle = (className, rule)=>{
                removeStyle(className);
                addToStylesheet((0, (0, parcelRequire("ghKWA")).toSelector)(className), rule);
            };
            const removeStyle = (className)=>{
                if (!styleEl.current || !styleEl.current.sheet) return;
                const ruleIndex = (0, (0, parcelRequire("ghKWA")).getIndexBySelector)(scope, styleEl.current.sheet.cssRules, (0, (0, parcelRequire("ghKWA")).toSelector)(className));
                if (ruleIndex !== -1) styleEl.current.sheet.deleteRule(ruleIndex);
            };
            const updateStyle = (targetClassNames, style)=>{
                if (!styleEl.current || !styleEl.current.sheet) return;
                const ruleIndex = (0, (0, parcelRequire("ghKWA")).getIndexByRule)(styleEl.current.sheet.cssRules, style);
                const selectors = (0, (0, parcelRequire("ghKWA")).toSelectors)(targetClassNames, scope);
                ruleIndex !== -1 && styleEl.current.sheet.deleteRule(ruleIndex);
                if (selectors.length > 0) styleEl.current.sheet.insertRule(`${selectors.join(', ')} {${(0, (0, parcelRequire("ghKWA")).toRule)(style)}}`, styleEl.current.sheet.cssRules.length);
            };
            const addToStylesheet = (selector, rule)=>{
                styleEl.current?.sheet?.insertRule(`.${scope} ${String(selector)} {${rule.replace('\n', ' ')}}`, styleEl.current.sheet.cssRules.length);
            };
            return {
                insertStyle: insertStyle,
                removeStyle: removeStyle,
                updateStyle: updateStyle
            };
        }, [
            scope
        ]);
        const styleAPI = (0, $5uXOq.useMemo)(()=>{
            const hoverRow = (id)=>{
                styleUtils.insertStyle((0, (0, parcelRequire("ghKWA")).classNames).row(id), (0, (0, parcelRequire("ghKWA")).styles).itemHover);
            };
            const leaveRow = (id)=>{
                styleUtils.removeStyle((0, (0, parcelRequire("ghKWA")).classNames).row(id));
            };
            const selectRow = (ids)=>{
                const selectedClasses = ids.map((id)=>(0, (0, parcelRequire("ghKWA")).classNames).row(id));
                styleUtils.updateStyle([], (0, (0, parcelRequire("ghKWA")).styles).itemHover);
                styleUtils.updateStyle(selectedClasses, (0, (0, parcelRequire("ghKWA")).styles).itemSelected);
            };
            const deselectRow = ()=>{
                styleUtils.updateStyle([], (0, (0, parcelRequire("ghKWA")).styles).itemSelected);
            };
            const dragRow = (id)=>{
                styleUtils.removeStyle((0, (0, parcelRequire("ghKWA")).classNames).inlineCreate);
                styleUtils.insertStyle((0, (0, parcelRequire("ghKWA")).classNames).row(id), (0, (0, parcelRequire("ghKWA")).styles).itemDragging);
                styleUtils.insertStyle((0, (0, parcelRequire("ghKWA")).classNames).rowChild(id), (0, (0, parcelRequire("ghKWA")).styles).itemDragging);
                styleUtils.insertStyle((0, (0, parcelRequire("ghKWA")).classNames).itemsContainer, (0, (0, parcelRequire("ghKWA")).styles).itemsContainerDragging);
            };
            const dropRow = (id, wasSelected)=>{
                styleUtils.removeStyle((0, (0, parcelRequire("ghKWA")).classNames).createChild);
                styleUtils.removeStyle((0, (0, parcelRequire("ghKWA")).classNames).row(id));
                styleUtils.removeStyle((0, (0, parcelRequire("ghKWA")).classNames).rowChild(id));
                styleUtils.removeStyle((0, (0, parcelRequire("ghKWA")).classNames).dragIndicator);
                styleUtils.removeStyle((0, (0, parcelRequire("ghKWA")).classNames).itemsContainer);
                wasSelected && styleUtils.insertStyle((0, (0, parcelRequire("ghKWA")).classNames).row(id), (0, (0, parcelRequire("ghKWA")).styles).itemSelected);
            };
            const showDragIndicator = (top, left)=>{
                styleUtils.insertStyle((0, (0, parcelRequire("ghKWA")).classNames).dragIndicator, (0, (0, parcelRequire("ghKWA")).styles).getDragIndicator(top, left));
            };
            const dragOverParent = (parentId, isSelected)=>{
                styleUtils.removeStyle((0, (0, parcelRequire("ghKWA")).classNames).dragIndicator);
                const style = isSelected ? (0, (0, parcelRequire("ghKWA")).styles).selectedItemCanBeCombined : (0, (0, parcelRequire("ghKWA")).styles).itemCanBeCombined;
                styleUtils.updateStyle([
                    (0, (0, parcelRequire("ghKWA")).classNames).row(parentId)
                ], style);
            };
            const dragOutOfBounds = ()=>{
                styleUtils.removeStyle((0, (0, parcelRequire("ghKWA")).classNames).dragIndicator);
            };
            const showInlineCreate = (top, tabFocused)=>{
                styleUtils.insertStyle((0, (0, parcelRequire("ghKWA")).classNames).inlineCreate, (0, (0, parcelRequire("ghKWA")).styles).getInlineCreateButton(top));
                if (tabFocused) styleUtils.insertStyle((0, (0, parcelRequire("ghKWA")).classNames).inlineCreateIcon, (0, (0, parcelRequire("ghKWA")).styles).getInlineCreateIcon());
                if (!tabFocused && (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline_table_meatballs_menu_a11y')) styleUtils.removeStyle((0, (0, parcelRequire("ghKWA")).classNames).inlineCreateIcon);
            };
            const hideInlineCreate = ()=>{
                styleUtils.removeStyle((0, (0, parcelRequire("ghKWA")).classNames).inlineCreate);
                styleUtils.removeStyle((0, (0, parcelRequire("ghKWA")).classNames).inlineCreateIcon);
            };
            const hideChildCreate = ()=>{
                styleUtils.insertStyle((0, (0, parcelRequire("ghKWA")).classNames).createChild, (0, (0, parcelRequire("ghKWA")).styles).itemDragging);
            };
            const blockPointerEvents = ()=>{
                styleUtils.insertStyle((0, (0, parcelRequire("ghKWA")).classNames).itemsContainer, (0, (0, parcelRequire("ghKWA")).styles).itemsContainerScrolling);
            };
            const allowPointerEvents = ()=>{
                styleAPI.removeStyle((0, (0, parcelRequire("ghKWA")).classNames).itemsContainer);
            };
            return {
                ...styleUtils,
                hoverRow: hoverRow,
                leaveRow: leaveRow,
                selectRow: selectRow,
                deselectRow: deselectRow,
                dragRow: dragRow,
                dropRow: dropRow,
                showDragIndicator: showDragIndicator,
                dragOverParent: dragOverParent,
                dragOutOfBounds: dragOutOfBounds,
                showInlineCreate: showInlineCreate,
                hideInlineCreate: hideInlineCreate,
                hideChildCreate: hideChildCreate,
                blockPointerEvents: blockPointerEvents,
                allowPointerEvents: allowPointerEvents
            };
        }, [
            styleUtils
        ]);
        return styleAPI;
    };
});
parcelRegister("ghKWA", function(module, exports) {
    $parcel$export(module.exports, "getIndexBySelector", ()=>$b963b9a538f75606$export$531566c459a9453);
    $parcel$export(module.exports, "getIndexByRule", ()=>$b963b9a538f75606$export$5e88903c48b9b53);
    $parcel$export(module.exports, "toRule", ()=>$b963b9a538f75606$export$f9a10e11cef4ed80);
    $parcel$export(module.exports, "toSelector", ()=>$b963b9a538f75606$export$fef48429545ba792);
    $parcel$export(module.exports, "toSelectors", ()=>$b963b9a538f75606$export$fea3972019a1b6b0);
    $parcel$export(module.exports, "classNames", ()=>$b963b9a538f75606$export$ce4ab0c55987d1ff);
    $parcel$export(module.exports, "styles", ()=>$b963b9a538f75606$export$9dd6ff9ea0189349);
    $parcel$export(module.exports, "getDragIndicatorClassName", ()=>$b963b9a538f75606$export$5295be4f68791c03);
    $parcel$export(module.exports, "getInlineCreateButtonClassName", ()=>$b963b9a538f75606$export$c6b1c9f0aaabd326);
    $parcel$export(module.exports, "getInlineCreateIconClassName", ()=>$b963b9a538f75606$export$36993ff9ff59e588);
    $parcel$export(module.exports, "getItemsBackgroundClassName", ()=>$b963b9a538f75606$export$db96af0fdcbdbc30);
    $parcel$export(module.exports, "getCreateChildButtonClassName", ()=>$b963b9a538f75606$export$30e1e4b30ec4d53);
    $parcel$export(module.exports, "getRowClassName", ()=>$b963b9a538f75606$export$d435f2dd2e4838a0);
    const $b963b9a538f75606$export$5a544e13ad4e1fa5 = (hexColor, alpha = 1)=>{
        const parsed = hexColor.match(/[a-f0-9]{2}/gi);
        if (!parsed || parsed && parsed.length !== 3 || hexColor.indexOf('#') < 0) return hexColor;
        const rgb = parsed.map((hex)=>parseInt(hex, 16));
        if (alpha < 1 && alpha >= 0) return `rgba(${rgb.concat(alpha).join(',')})`;
        return `rgb(${rgb.join()})`;
    };
    const $b963b9a538f75606$export$307b18b61172f7ed = (className)=>({
            className: Array.isArray(className) ? className.join(' ') : className
        });
    const $b963b9a538f75606$export$531566c459a9453 = (scope, cssRules, target)=>Array.from(cssRules || []).findIndex((cssRule)=>'selectorText' in cssRule && cssRule.selectorText === `.${scope} ${target}`);
    const $b963b9a538f75606$export$5e88903c48b9b53 = (cssRules, target)=>Array.from(cssRules || []).findIndex(({ cssText: cssText })=>$b963b9a538f75606$export$f9a10e11cef4ed80(cssText).endsWith(`{${$b963b9a538f75606$export$f9a10e11cef4ed80(target)}}`));
    const $b963b9a538f75606$export$fef48429545ba792 = (className)=>`.${className}`;
    const $b963b9a538f75606$export$fea3972019a1b6b0 = (targetClassNames, scope)=>targetClassNames.map((className)=>`.${scope} .${className}`);
    const $b963b9a538f75606$export$f9a10e11cef4ed80 = (style)=>style.replace(/#\w+/g, (hexColor)=>$b963b9a538f75606$export$5a544e13ad4e1fa5(hexColor)).replace(/[\r\n\s]/g, '');
    const $b963b9a538f75606$var$row = (id)=>`row-${id}`;
    const $b963b9a538f75606$var$rowChild = (id)=>`row-child-${id}`;
    const $b963b9a538f75606$var$inlineCreate = 'inline-create-button';
    const $b963b9a538f75606$var$inlineCreateIcon = 'inline-create-button-icon';
    const $b963b9a538f75606$var$dragIndicator = 'inline-drag-indicator';
    const $b963b9a538f75606$var$dragIndicatorTop = 'inline-drag-indicator-top';
    const $b963b9a538f75606$var$itemsContainer = 'items-container';
    const $b963b9a538f75606$var$createChild = 'create-child-button';
    const $b963b9a538f75606$export$ce4ab0c55987d1ff = {
        row: $b963b9a538f75606$var$row,
        rowChild: $b963b9a538f75606$var$rowChild,
        inlineCreate: $b963b9a538f75606$var$inlineCreate,
        inlineCreateIcon: $b963b9a538f75606$var$inlineCreateIcon,
        dragIndicator: $b963b9a538f75606$var$dragIndicator,
        dragIndicatorTop: $b963b9a538f75606$var$dragIndicatorTop,
        itemsContainer: $b963b9a538f75606$var$itemsContainer,
        createChild: $b963b9a538f75606$var$createChild
    };
    const $b963b9a538f75606$var$itemHover = `
    background-color: ${`var(--ds-background-neutral-subtle-hovered, ${(0, $72ba03e317f3d228$export$3e51e8f1440314ba)})`} !important;
`;
    const $b963b9a538f75606$var$itemSelected = `
    background-color: ${`var(--ds-background-selected, ${(0, $72ba03e317f3d228$export$226de0355ed012f8)})`} !important;
`;
    const $b963b9a538f75606$var$itemDragging = `
    opacity: 0;
`;
    const $b963b9a538f75606$var$itemsContainerDragging = `
    background: ${`var(--ds-surface-pressed, ${(0, $72ba03e317f3d228$export$8754fc7e6d8b3000)})`} !important;
`;
    const $b963b9a538f75606$var$itemsContainerScrolling = `
    pointer-events: none;
`;
    const $b963b9a538f75606$var$itemCanBeCombined = `
    background-color: ${`var(--ds-background-selected, ${(0, $72ba03e317f3d228$export$3e51e8f1440314ba)})`} !important;
`;
    const $b963b9a538f75606$var$selectedItemCanBeCombined = `
    background-color: ${`var(--ds-background-selected-hovered, ${(0, $72ba03e317f3d228$export$3e51e8f1440314ba)})`} !important;
`;
    const $b963b9a538f75606$var$getDragIndicator = (top, left)=>`
    display: block;
    position: fixed;
    right: 0;
    transform: ${left ? `translate(${left}px, ${top}px)` : `translateY(${top}px)`};
    pointer-events: none;
`;
    const $b963b9a538f75606$var$getInlineCreateButton = (top)=>`
    display: block;
    position: fixed;
    right: 0;
    transform: translateY(${top}px);
    pointer-events: none;
`;
    const $b963b9a538f75606$var$getInlineCreateIcon = ()=>`
	outline: 2px solid ${`var(--ds-border-focused, ${0, $72ba03e317f3d228$export$e62e8919cca44969})`};
	outline-offset: 2px;
`;
    const $b963b9a538f75606$export$9dd6ff9ea0189349 = {
        itemHover: $b963b9a538f75606$var$itemHover,
        itemSelected: $b963b9a538f75606$var$itemSelected,
        itemDragging: $b963b9a538f75606$var$itemDragging,
        itemsContainerDragging: $b963b9a538f75606$var$itemsContainerDragging,
        itemsContainerScrolling: $b963b9a538f75606$var$itemsContainerScrolling,
        itemCanBeCombined: $b963b9a538f75606$var$itemCanBeCombined,
        selectedItemCanBeCombined: $b963b9a538f75606$var$selectedItemCanBeCombined,
        getDragIndicator: $b963b9a538f75606$var$getDragIndicator,
        getInlineCreateButton: $b963b9a538f75606$var$getInlineCreateButton,
        getInlineCreateIcon: $b963b9a538f75606$var$getInlineCreateIcon
    };
    const $b963b9a538f75606$export$5295be4f68791c03 = ()=>$b963b9a538f75606$export$307b18b61172f7ed([
            $b963b9a538f75606$var$dragIndicator,
            $b963b9a538f75606$var$dragIndicatorTop
        ]);
    const $b963b9a538f75606$export$c6b1c9f0aaabd326 = ()=>$b963b9a538f75606$export$307b18b61172f7ed($b963b9a538f75606$var$inlineCreate);
    const $b963b9a538f75606$export$36993ff9ff59e588 = ()=>$b963b9a538f75606$export$307b18b61172f7ed($b963b9a538f75606$var$inlineCreateIcon);
    const $b963b9a538f75606$export$db96af0fdcbdbc30 = ()=>$b963b9a538f75606$export$307b18b61172f7ed($b963b9a538f75606$var$itemsContainer);
    const $b963b9a538f75606$export$30e1e4b30ec4d53 = ()=>$b963b9a538f75606$export$307b18b61172f7ed($b963b9a538f75606$var$createChild);
    const $b963b9a538f75606$export$d435f2dd2e4838a0 = (id, parentId)=>{
        const classes = parentId !== undefined ? [
            $b963b9a538f75606$var$row(id),
            $b963b9a538f75606$var$rowChild(parentId)
        ] : $b963b9a538f75606$var$row(id);
        return $b963b9a538f75606$export$307b18b61172f7ed(classes);
    };
});
parcelRegister("2SP8o", function(module, exports) {
    $parcel$export(module.exports, "bindCustomActions", ()=>$ca453860589f2160$export$85d352c410f2eb84);
    $parcel$export(module.exports, "bindOverrideActions", ()=>$ca453860589f2160$export$d27110202ae8442b);
    const $ca453860589f2160$var$getPublicStyleAPI = (styleAPI)=>({
            insertStyle: styleAPI.insertStyle,
            removeStyle: styleAPI.removeStyle,
            updateStyle: styleAPI.updateStyle
        });
    const $ca453860589f2160$export$85d352c410f2eb84 = (customActions, styleAPI)=>Object.keys(customActions).reduce((acc, key)=>{
            acc[key] = customActions[key].bind(null, {
                styleAPI: $ca453860589f2160$var$getPublicStyleAPI(styleAPI)
            });
            return acc;
        }, {});
    const $ca453860589f2160$var$combineActions = (actionOne, actionTwo, styleAPI)=>(...args)=>{
            actionOne(...args);
            actionTwo?.bind(null, {
                styleAPI: $ca453860589f2160$var$getPublicStyleAPI(styleAPI)
            })(...args);
        };
    const $ca453860589f2160$export$d27110202ae8442b = (defaultActions, overrideActions, styleAPI)=>Object.keys(defaultActions).reduce((acc, key)=>{
            const defaults = defaultActions[key];
            const overrides = overrideActions[key];
            acc[key] = $ca453860589f2160$var$combineActions(defaults, overrides, styleAPI);
            return acc;
        }, {});
});
parcelRegister("lGdZu", function(module, exports) {
    $parcel$export(module.exports, "useTimelineViewportActions", ()=>$cf6bb10d35944ef2$export$93c2697e07ec9389);
    $parcel$export(module.exports, "useTimelineViewport", ()=>$cf6bb10d35944ef2$export$408aa890bc70d3dc);
    $parcel$export(module.exports, "TimelineViewportProvider", ()=>$cf6bb10d35944ef2$export$f521cde558624422);
    var $3sQ5x;
    var $gg7kZ;
    var $iXqE5;
    var $gO8Eu;
    const $cf6bb10d35944ef2$var$initialState = {
        left: 0,
        clientWidth: 0,
        indicatorLineOffset: 0
    };
    const $cf6bb10d35944ef2$export$d474af741f65a5d3 = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $cf6bb10d35944ef2$var$initialState,
        actions: (0, parcelRequire("gO8Eu")).actions,
        name: 'timeline-table.timeline-viewport'
    });
    const $cf6bb10d35944ef2$export$93c2697e07ec9389 = (0, (0, parcelRequire("3sQ5x")).createActionsHook)($cf6bb10d35944ef2$export$d474af741f65a5d3);
    const $cf6bb10d35944ef2$export$408aa890bc70d3dc = (0, (0, parcelRequire("3sQ5x")).createHook)($cf6bb10d35944ef2$export$d474af741f65a5d3);
    const $cf6bb10d35944ef2$export$f521cde558624422 = (0, (0, parcelRequire("gg7kZ")).createContainer)($cf6bb10d35944ef2$export$d474af741f65a5d3);
});
parcelRegister("gO8Eu", function(module, exports) {
    $parcel$export(module.exports, "actions", ()=>$7d7b8bc61e5302e0$export$e324594224ef24da);
    var $8JuJr;
    const $7d7b8bc61e5302e0$export$e324594224ef24da = {
        onResize: (0, parcelRequire("8JuJr")).onResize
    };
});
parcelRegister("8JuJr", function(module, exports) {
    $parcel$export(module.exports, "onResize", ()=>$67bfbb484d77eed1$export$45b39e67d4ce4921);
    const $67bfbb484d77eed1$export$45b39e67d4ce4921 = (params)=>({ setState: setState })=>{
            setState({
                ...params
            });
        };
});
parcelRegister("biT18", function(module, exports) {
    $parcel$export(module.exports, "useTimelineState", ()=>$11ae6e482458e57a$export$f92f0bc83b35c17b);
    $parcel$export(module.exports, "TimelineProviderSweetState", ()=>$11ae6e482458e57a$export$4f33ace85fd289c5);
    var $gg7kZ;
    var $3sQ5x;
    var $iXqE5;
    var $iZN6h;
    var $iwcO1;
    var $bFxJH;
    var $h5O3P;
    const $11ae6e482458e57a$var$initialState = {
        today: 0,
        timelineMode: (0, (0, parcelRequire("iZN6h")).MONTHS),
        timelineDuration: {
            startMilliseconds: 0,
            endMilliseconds: 0,
            totalMilliseconds: 0
        },
        timelineOrigin: 0,
        timelineWidth: 0,
        timelineOriginPosition: 0,
        columnDurations: [],
        columnPositions: []
    };
    const $11ae6e482458e57a$export$2ce7f0e10391f4 = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $11ae6e482458e57a$var$initialState,
        actions: (0, parcelRequire("h5O3P")).actions,
        name: 'timeline-table.timeline'
    });
    const $11ae6e482458e57a$export$f92f0bc83b35c17b = (0, (0, parcelRequire("3sQ5x")).createHook)($11ae6e482458e57a$export$2ce7f0e10391f4);
    const $11ae6e482458e57a$var$handleState = ()=>({ setState: setState }, timelineData)=>{
            const { timelineMode: timelineMode, timelineDuration: timelineDuration, timelineOrigin: timelineOrigin } = timelineData;
            const timelineWidth = (0, (0, parcelRequire("bFxJH")).getTimelineWidth)(timelineMode, timelineDuration.totalMilliseconds);
            const columnDurations = (0, (0, parcelRequire("iwcO1")).getColumnDurations)(timelineMode, timelineDuration);
            const columnPositions = (0, (0, parcelRequire("iwcO1")).getColumnPositions)(timelineDuration, columnDurations);
            const timelineOriginPosition = (0, (0, parcelRequire("bFxJH")).getTimelinePositionFromDate)(timelineDuration, timelineWidth, timelineOrigin);
            setState({
                ...timelineData,
                timelineWidth: timelineWidth,
                timelineOriginPosition: timelineOriginPosition,
                columnDurations: columnDurations,
                columnPositions: columnPositions
            });
        };
    const $11ae6e482458e57a$export$4f33ace85fd289c5 = (0, (0, parcelRequire("gg7kZ")).createContainer)($11ae6e482458e57a$export$2ce7f0e10391f4, {
        onInit: $11ae6e482458e57a$var$handleState,
        onUpdate: $11ae6e482458e57a$var$handleState
    });
});
parcelRegister("iwcO1", function(module, exports) {
    $parcel$export(module.exports, "getColumnDurations", ()=>$83f6cf322fa93419$export$97c232fe861416fb);
    $parcel$export(module.exports, "getColumnPositions", ()=>$83f6cf322fa93419$export$1f04562dc761554b);
    $parcel$export(module.exports, "getTodayColumnIndex", ()=>$83f6cf322fa93419$export$ce237023318dfe05);
    var $8QpSo;
    var $2gnC5 = parcelRequire("2gnC5");
    var $iZN6h;
    const $83f6cf322fa93419$var$getColumnDurationsForMode = (timelineDuration, momentIdentifier)=>{
        const columnDurations = [];
        const { startMilliseconds: startMilliseconds, endMilliseconds: endMilliseconds } = timelineDuration;
        const momentAddIdentifier = momentIdentifier === 'isoWeek' ? 'week' : momentIdentifier;
        const startMoment = (0, ($parcel$interopDefault($2gnC5))).utc(startMilliseconds).startOf(momentIdentifier);
        while(startMoment.valueOf() < endMilliseconds){
            const endMoment = startMoment.clone().endOf(momentIdentifier);
            columnDurations.push({
                startMilliseconds: startMoment.valueOf(),
                endMilliseconds: endMoment.valueOf(),
                totalMilliseconds: endMoment.diff(startMoment, 'milliseconds')
            });
            startMoment.add(1, momentAddIdentifier);
        }
        return columnDurations;
    };
    const $83f6cf322fa93419$export$97c232fe861416fb = (0, (0, parcelRequire("8QpSo")).default)((timelineMode, timelineDuration)=>{
        if (timelineMode === (0, (0, parcelRequire("iZN6h")).QUARTERS)) return $83f6cf322fa93419$var$getColumnDurationsForMode(timelineDuration, 'quarter');
        if (timelineMode === (0, (0, parcelRequire("iZN6h")).MONTHS)) return $83f6cf322fa93419$var$getColumnDurationsForMode(timelineDuration, 'month');
        return $83f6cf322fa93419$var$getColumnDurationsForMode(timelineDuration, 'isoWeek');
    });
    const $83f6cf322fa93419$export$1f04562dc761554b = (0, (0, parcelRequire("8QpSo")).default)((timelineDuration, columnDurations)=>{
        let left = 0;
        if (columnDurations.length > 0) left = (columnDurations[0].startMilliseconds - timelineDuration.startMilliseconds) / timelineDuration.totalMilliseconds * 100;
        return columnDurations.map((columnDuration)=>{
            const width = columnDuration.totalMilliseconds / timelineDuration.totalMilliseconds * 100;
            left += width;
            return [
                left - width,
                100 - left
            ];
        });
    });
    const $83f6cf322fa93419$export$ce237023318dfe05 = (0, (0, parcelRequire("8QpSo")).default)((today, columnDurations)=>{
        let todayColumnIndex = 0;
        columnDurations.some(({ startMilliseconds: startMilliseconds, endMilliseconds: endMilliseconds })=>{
            if (today >= startMilliseconds && today <= endMilliseconds) return true;
            todayColumnIndex += 1;
            return false;
        });
        return todayColumnIndex;
    });
});
parcelRegister("h5O3P", function(module, exports) {
    $parcel$export(module.exports, "actions", ()=>$9d7b09dc8acd079d$export$e324594224ef24da);
    const $9d7b09dc8acd079d$export$e324594224ef24da = {};
});
parcelRegister("5SIwg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c85e5a25a380b891$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $4R6GH;
    var $6iqcY;
    var $58xNR;
    var $hEf85;
    var $2VHr3;
    var $4nLPh;
    var $a79cp;
    var $2MYv1;
    var $aaAik;
    var $cdyDR;
    var $lTlao;
    var $gc064;
    const $c85e5a25a380b891$var$containerStyles = null;
    const $c85e5a25a380b891$var$TableMain = ({ isVirtualiseEnabled: isVirtualiseEnabled, isResizeEnabled: isResizeEnabled, isHideScrollbar: isHideScrollbar, scope: scope, selectedItemIds: selectedItemIds, onItemDrop: onItemDrop, onItemSelect: onItemSelect, onItemExpandChanged: onItemExpandChanged, onCreateClick: onCreateClick, onSetListWidth: onSetListWidth, DndLongTaskMetric: DndLongTaskMetric, renderers: renderers })=>{
        const { listRenderers: listRenderers, chartRenderers: chartRenderers, renderProvider: renderProvider } = (0, (0, parcelRequire("gc064")).getRenderersWithDefaults)(renderers);
        const { renderListEmptyContent: renderListEmptyContent, renderListHeaderItem: renderListHeaderItem, renderListItemContent: renderListItemContent, renderListItemSecondaryContent: renderListItemSecondaryContent, renderListItemCreate: renderListItemCreate, renderListItemMenuOption: renderListItemMenuOption, renderListItemModal: renderListItemModal } = listRenderers;
        const { renderChartHeaderItem: renderChartHeaderItem, renderChartItemContent: renderChartItemContent, renderChartOverlay: renderChartOverlay, renderChartTimelineOverlay: renderChartTimelineOverlay } = chartRenderers;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2VHr3")).default), {
            isHideScrollbar: isHideScrollbar
        }, ({ scrollElement: scrollElement, onContentResize: onContentResize })=>{
            const containerContent = (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: (0, (0, parcelRequire("bwpsq")).default)([
                    "_kqswh2mm _1e0c1txw _2lx21bp4 _16jlkb7n _1o9zkb7n _i0dl1wug _1bsb1ns9 _4t3i1ns9 _1tke1osq"
                ])
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("a79cp")).default), {
                renderListHeaderItem: renderListHeaderItem,
                renderChartHeaderItem: renderChartHeaderItem
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hEf85")).default), {
                isResizeEnabled: isResizeEnabled,
                DndLongTaskMetric: DndLongTaskMetric,
                onItemDrop: onItemDrop,
                onItemSelect: onItemSelect,
                onItemExpandChanged: onItemExpandChanged,
                onCreateClick: onCreateClick,
                onSetListWidth: onSetListWidth,
                onContentResize: onContentResize,
                renderListEmptyContent: renderListEmptyContent,
                renderListItemContent: renderListItemContent,
                renderListItemSecondaryContent: renderListItemSecondaryContent,
                renderListItemCreate: renderListItemCreate,
                renderChartItemContent: renderChartItemContent,
                renderChartTimelineOverlay: renderChartTimelineOverlay,
                renderListItemMenuOption: renderListItemMenuOption,
                renderListItemModal: renderListItemModal
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cdyDR")).default), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4nLPh")).default), {
                DndLongTaskMetric: DndLongTaskMetric
            }), (0, (0, parcelRequire("4R6GH")).fg)('project_timeline_multi-select_and_checkboxes') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2MYv1")).default), null) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aaAik")).default), {
                selectedItemIds: selectedItemIds
            }));
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6iqcY")).default), {
                scope: scope,
                scrollElement: scrollElement
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("58xNR")).default), {
                scrollElement: scrollElement,
                isEnabled: isVirtualiseEnabled
            }, renderProvider({
                children: containerContent
            })));
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lTlao")).default), {
            renderChartOverlay: renderChartOverlay
        }));
    };
    $c85e5a25a380b891$var$TableMain.displayName = 'TableMain';
    $c85e5a25a380b891$var$TableMain.whyDidYouRender = true;
    var $c85e5a25a380b891$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($c85e5a25a380b891$var$TableMain);
});
parcelRegister("6iqcY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2e3d7da017f31045$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $7wqBZ;
    var $8CsHB;
    var $26JJs;
    var $iZN6h;
    var $g3prf;
    var $hGh1Z;
    var $3Kr5N;
    var $3ruU1;
    var $cRUzn;
    var $d1oik;
    var $de769;
    const $2e3d7da017f31045$var$start = (scope)=>{
        (0, (0, parcelRequire("7wqBZ")).getLongTasksMetrics)((0, (0, parcelRequire("iZN6h")).SCROLLED)).start(scope);
    };
    const $2e3d7da017f31045$var$stop = (scope)=>{
        let reporter = (0, (0, parcelRequire("8CsHB")).genericReporter);
        reporter = (0, (0, parcelRequire("26JJs")).scrollReporterWithSlo)();
        (0, (0, parcelRequire("7wqBZ")).getLongTasksMetrics)(scope).stop(reporter);
    };
    const $2e3d7da017f31045$var$SCROLL_COUNT_THRESHOLD = 5;
    const $2e3d7da017f31045$var$Container = ({ scope: scope, scrollElement: scrollElement })=>{
        const [{ headerHeight: headerHeight }] = (0, (0, parcelRequire("g3prf")).useHeaderState)();
        const { onScrollStateChanged: onScrollStateChanged } = (0, (0, parcelRequire("3ruU1")).useSideEffectMarshal)();
        const [, { updateScrollMeta: updateScrollMeta, updateScrollPosition: updateScrollPosition }] = (0, (0, parcelRequire("3Kr5N")).useScrollMetaActions)();
        const [{ totalHeight: totalHeight }] = (0, (0, parcelRequire("hGh1Z")).useItemsContainerStyles)();
        const isScrolling = (0, $5uXOq.useRef)(false);
        const scrollCount = (0, $5uXOq.useRef)(0);
        const getAndUpdateScrollPosition = (0, $5uXOq.useCallback)(()=>{
            const { scrollTop: scrollTop, clientHeight: clientHeight } = scrollElement;
            const tableHeight = totalHeight + headerHeight;
            const scrollBottom = Math.max(0, tableHeight - (scrollTop + clientHeight));
            updateScrollPosition({
                scrollTop: scrollTop,
                scrollBottom: scrollBottom
            });
        }, [
            scrollElement,
            totalHeight,
            updateScrollPosition,
            headerHeight
        ]);
        const onScrollChange = (0, $5uXOq.useCallback)((scrollingState)=>{
            if (isScrolling.current !== scrollingState.isScrollingY) {
                if (scrollCount.current === $2e3d7da017f31045$var$SCROLL_COUNT_THRESHOLD) {
                    if (scrollingState.isScrollingY) $2e3d7da017f31045$var$start(scope);
                    else {
                        $2e3d7da017f31045$var$stop(scope);
                        scrollCount.current = 0;
                    }
                    isScrolling.current = scrollingState.isScrollingY;
                } else scrollCount.current += 1;
            }
            updateScrollMeta(scrollingState);
            if (!scrollingState.isScrollingY) getAndUpdateScrollPosition();
            onScrollStateChanged(scrollingState.isScrollingY);
        }, [
            updateScrollMeta,
            getAndUpdateScrollPosition,
            onScrollStateChanged,
            scope
        ]);
        (0, (0, parcelRequire("de769")).useIsScrolling)(scrollElement, onScrollChange);
        (0, (0, parcelRequire("cRUzn")).useResizeObserver)(scrollElement, getAndUpdateScrollPosition);
        return null;
    };
    const $2e3d7da017f31045$var$ScrollMetaContainer = ({ scope: scope, scrollElement: scrollElement, children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3Kr5N")).ScrollMetaProviderSweetState), null, scrollElement && (0, ($parcel$interopDefault($5uXOq))).createElement($2e3d7da017f31045$var$Container, {
            scope: scope,
            scrollElement: scrollElement
        }), scrollElement && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d1oik")).default), {
            scope: scope,
            scrollElement: scrollElement
        }), children);
    var $2e3d7da017f31045$export$2e2bcd8739ae039 = $2e3d7da017f31045$var$ScrollMetaContainer;
});
parcelRegister("7wqBZ", function(module, exports) {
    $parcel$export(module.exports, "getLongTasksMetrics", ()=>$f85af650a825558e$export$b092a8653a66aa5e);
    var $gJBT6 = parcelRequire("gJBT6");
    var $x9xyg;
    var $6RCeq;
    var $cJpFl;
    let $f85af650a825558e$var$observer = null;
    const $f85af650a825558e$var$stopObserver = ()=>{
        if ($f85af650a825558e$var$observer) {
            $f85af650a825558e$var$observer.disconnect();
            $f85af650a825558e$var$observer = null;
        }
    };
    const $f85af650a825558e$export$b092a8653a66aa5e = (0, ($parcel$interopDefault($gJBT6)))((type)=>{
        const clearData = {
            type: type
        };
        let isStarted = false;
        let observationData = {
            ...clearData
        };
        const isDnd = /dnd$/.test(type.toLowerCase());
        return {
            start: (appName, startPerformanceMark, extra = {})=>{
                if (window.PerformanceObserver && !isStarted) try {
                    const startTimestamp = (0, (0, parcelRequire("6RCeq")).default).now();
                    observationData = {
                        type: observationData.type,
                        startTimestamp: startTimestamp,
                        dragStartEndTimestamp: startTimestamp,
                        eventStartPerformanceMark: startPerformanceMark,
                        events: [],
                        appName: appName,
                        extra: extra
                    };
                    isStarted = true;
                    $f85af650a825558e$var$stopObserver();
                    $f85af650a825558e$var$observer = new window.PerformanceObserver((list)=>{
                        list.getEntries().forEach((entry)=>{
                            if (entry.entryType === 'longtask') {
                                if (!(0, (0, parcelRequire("cJpFl")).isExpandedObservationData)(observationData) || observationData.events.find((item)=>item.timestamp === entry.startTime && item.duration === entry.duration)) return;
                                observationData.events.push({
                                    timestamp: entry.startTime,
                                    duration: entry.duration
                                });
                            } else if (entry.entryType === 'event' && entry.name === 'dragstart') observationData.dragStartEndTimestamp = entry.startTime + entry.duration;
                        });
                    });
                    $f85af650a825558e$var$observer.observe({
                        type: 'longtask'
                    });
                    if (isDnd) $f85af650a825558e$var$observer.observe({
                        type: 'event',
                        durationThreshold: 48
                    });
                } catch (e) {}
            },
            stop: (callback, extra = {})=>{
                if ((0, (0, parcelRequire("6RCeq")).default).now && isStarted) {
                    const stopTimestamp = (0, (0, parcelRequire("6RCeq")).default).now();
                    setTimeout(()=>{
                        $f85af650a825558e$var$stopObserver();
                        callback({
                            ...observationData
                        }, extra, stopTimestamp);
                        observationData = {
                            ...clearData
                        };
                        isStarted = false;
                    });
                }
            },
            stopIfNoMark: (performanceMark)=>{
                if ($f85af650a825558e$var$observer && performanceMark) {
                    const perfMark = (0, (0, parcelRequire("x9xyg")).getMark)(performanceMark);
                    if (!perfMark) {
                        $f85af650a825558e$var$stopObserver();
                        observationData = {
                            ...clearData
                        };
                        isStarted = false;
                    }
                }
            }
        };
    });
});
parcelRegister("cJpFl", function(module, exports) {
    $parcel$export(module.exports, "isExpandedObservationData", ()=>$3e1de7ace69512d1$export$3d38a87309e205a4);
    const $3e1de7ace69512d1$export$3d38a87309e205a4 = (observationData)=>observationData !== undefined && 'events' in observationData && observationData.events !== undefined;
});
parcelRegister("8CsHB", function(module, exports) {
    $parcel$export(module.exports, "genericReporter", ()=>$fb974fbed382ceb2$export$bf7963bc28dd02c2);
    var $cJpFl;
    var $if7bx;
    const $fb974fbed382ceb2$export$bf7963bc28dd02c2 = (observationData, featureFlags = {})=>{
        if ((0, (0, parcelRequire("cJpFl")).isExpandedObservationData)(observationData)) {
            const triggerSoftwareAnalytics = (0, (0, parcelRequire("if7bx")).triggerAnalytics)(`software.${observationData.appName}`);
            const startTime = observationData.events.map((event)=>event.timestamp);
            const analyticsData = {
                ...(0, (0, parcelRequire("if7bx")).generateLongTaskAnalyticsSummary)(`${observationData.type}`, observationData.events),
                measureTimespan: performance.now() - Math.min(observationData.startTimestamp, ...startTime),
                ...featureFlags
            };
            triggerSoftwareAnalytics(`long-tasks-${observationData.type}`, analyticsData);
        }
    };
});
parcelRegister("if7bx", function(module, exports) {
    $parcel$export(module.exports, "triggerAnalytics", ()=>$3a39af364070fc96$export$2c57de8a70f64057);
    $parcel$export(module.exports, "generateLongTaskAnalyticsSummary", ()=>$3a39af364070fc96$export$2be2635781d23aab);
    $parcel$export(module.exports, "generateLongTaskAnalyticsSummaryWithSlo", ()=>$3a39af364070fc96$export$c674a20081e82c6a);
    $parcel$export(module.exports, "getAverageResultsFromContinuousActions", ()=>$3a39af364070fc96$export$c36fdc326d0c207c);
    $parcel$export(module.exports, "generateLongTaskAnalyticsContinuousActionSummary", ()=>$3a39af364070fc96$export$7e5f2df95eca342a);
    var $gZFbt = parcelRequire("gZFbt");
    var $iThRn = parcelRequire("iThRn");
    var $6oxJH = parcelRequire("6oxJH");
    const $3a39af364070fc96$export$2c57de8a70f64057 = (_appName)=>(_eventNameSuffix, _eventData)=>Promise.resolve(undefined);
    const $3a39af364070fc96$export$2be2635781d23aab = (prefix, longTasks)=>{
        const durations = longTasks.map((task)=>task.duration);
        return {
            [`${prefix}LongTaskCount`]: longTasks.length,
            [`${prefix}LongTaskAvg`]: longTasks.length > 0 ? durations.reduce((sumAcc, duration)=>sumAcc + duration, 0) / longTasks.length : 0,
            [`${prefix}LongTaskMax`]: longTasks.length > 0 ? Math.max(...durations) : 0
        };
    };
    const $3a39af364070fc96$export$c674a20081e82c6a = (prefix, longTasks, sloSettings)=>{
        const summary = $3a39af364070fc96$export$2be2635781d23aab(prefix, longTasks);
        if (!sloSettings) return summary;
        const framerate = summary[`${prefix}LongTaskCount`] === 0 ? 20 : 1000 / summary[`${prefix}LongTaskAvg`];
        const blocktime = summary[`${prefix}LongTaskCount`] === 0 ? 0 : summary[`${prefix}LongTaskCount`] * summary[`${prefix}LongTaskAvg`];
        const isSuccess = framerate >= sloSettings.framerateThreshold && blocktime < sloSettings.blocktimeThreshold;
        return {
            [`${prefix}LongTaskSloIsSuccess`]: isSuccess,
            ...summary
        };
    };
    const $3a39af364070fc96$export$c36fdc326d0c207c = (prefix, data)=>({
            [`${prefix}ClusterCount`]: (0, ($parcel$interopDefault($6oxJH)))(data, `${prefix}ClusterCount`) || 0,
            [`${prefix}ClusterCountAvg`]: (0, ($parcel$interopDefault($gZFbt)))(data, `${prefix}ClusterCount`) || 0,
            [`${prefix}ClusterAvg`]: (0, ($parcel$interopDefault($gZFbt)))(data, `${prefix}ClusterAvg`) || 0,
            [`${prefix}ClusterDistanceAvg`]: (0, ($parcel$interopDefault($gZFbt)))(data, `${prefix}ClusterDistanceAvg`) || 0,
            [`${prefix}ClusterAvgLongTaskCount`]: (0, ($parcel$interopDefault($gZFbt)))(data, `${prefix}ClusterAvgLongTaskCount`) || 0,
            [`${prefix}ClusterAvgLongTaskAvg`]: data.length > 0 ? (0, ($parcel$interopDefault($iThRn)))(data.map((entry)=>entry[`${prefix}ClusterAvgLongTaskCount`] * entry[`${prefix}ClusterAvgLongTaskAvg`])) / (0, ($parcel$interopDefault($6oxJH)))(data, `${prefix}ClusterAvgLongTaskCount`) : 0,
            [`${prefix}Count`]: data.length
        });
    const $3a39af364070fc96$export$7e5f2df95eca342a = (prefix, longTasks)=>{
        const clusters = longTasks.reduce((foundClusters, task)=>{
            if (foundClusters.length === 0) foundClusters.push({
                tasks: [],
                start: 0,
                stop: 0
            });
            const prevCluster = foundClusters[foundClusters.length - 1];
            const taskEnd = task.timestamp + task.duration;
            if (prevCluster.tasks.length === 0) {
                prevCluster.tasks.push(task);
                prevCluster.start = task.timestamp;
                prevCluster.stop = taskEnd;
            } else if (task.timestamp - prevCluster.stop < 100) {
                prevCluster.tasks.push(task);
                prevCluster.stop = taskEnd;
            } else foundClusters.push({
                tasks: [
                    task
                ],
                start: task.timestamp,
                stop: taskEnd
            });
            return foundClusters;
        }, []);
        const clusterDurations = clusters.map((cluster)=>cluster.stop - cluster.start);
        const tasksDurations = longTasks.map((task)=>task.duration);
        const gapsBetweenClusters = clusters.length > 1 ? clusters.reduce((gaps, cluster, i)=>{
            if (gaps.length === 0) {
                gaps.push({
                    start: cluster.stop,
                    stop: null
                });
                return gaps;
            }
            gaps[gaps.length - 1].stop = cluster.start;
            if (i !== clusters.length - 1) gaps.push({
                start: cluster.stop,
                stop: null
            });
            return gaps;
        }, []).map((gap)=>gap.stop - gap.start) : [];
        return {
            [`${prefix}ClusterCount`]: clusters.length,
            [`${prefix}ClusterAvg`]: clusters.length > 0 ? clusterDurations.reduce((sumAcc, duration)=>sumAcc + duration, 0) / clusters.length : 0,
            [`${prefix}ClusterDistanceAvg`]: gapsBetweenClusters.length > 0 ? gapsBetweenClusters.reduce((sumAcc, duration)=>sumAcc + duration, 0) / gapsBetweenClusters.length : 0,
            [`${prefix}ClusterAvgLongTaskCount`]: clusters.length > 0 ? clusters.map((cluster)=>cluster.tasks.length).reduce((sumAcc, count)=>sumAcc + count, 0) / clusters.length : 0,
            [`${prefix}ClusterAvgLongTaskAvg`]: longTasks.length > 0 ? tasksDurations.reduce((sumAcc, duration)=>sumAcc + duration, 0) / longTasks.length : 0
        };
    };
});
parcelRegister("gZFbt", function(module, exports) {
    var $bxDef = parcelRequire("bxDef");
    var $520Yb = parcelRequire("520Yb");
    function $c5f24a2590a3cbef$var$meanBy(array, iteratee) {
        return $520Yb(array, $bxDef(iteratee, 2));
    }
    module.exports = $c5f24a2590a3cbef$var$meanBy;
});
parcelRegister("520Yb", function(module, exports) {
    var $gBzAF = parcelRequire("gBzAF");
    var $3a9de433504d679a$var$NAN = 0 / 0;
    function $3a9de433504d679a$var$baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? $gBzAF(array, iteratee) / length : $3a9de433504d679a$var$NAN;
    }
    module.exports = $3a9de433504d679a$var$baseMean;
});
parcelRegister("gBzAF", function(module, exports) {
    function $c16bb58eedefe4cd$var$baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while(++index < length){
            var current = iteratee(array[index]);
            if (current !== undefined) result = result === undefined ? current : result + current;
        }
        return result;
    }
    module.exports = $c16bb58eedefe4cd$var$baseSum;
});
parcelRegister("iThRn", function(module, exports) {
    var $gBzAF = parcelRequire("gBzAF");
    var $etyzk = parcelRequire("etyzk");
    function $dc0b37ac120f9bb6$var$sum(array) {
        return array && array.length ? $gBzAF(array, $etyzk) : 0;
    }
    module.exports = $dc0b37ac120f9bb6$var$sum;
});
parcelRegister("6oxJH", function(module, exports) {
    var $bxDef = parcelRequire("bxDef");
    var $gBzAF = parcelRequire("gBzAF");
    function $4a7f273a61dd10a7$var$sumBy(array, iteratee) {
        return array && array.length ? $gBzAF(array, $bxDef(iteratee, 2)) : 0;
    }
    module.exports = $4a7f273a61dd10a7$var$sumBy;
});
parcelRegister("26JJs", function(module, exports) {
    $parcel$export(module.exports, "scrollReporterWithSlo", ()=>$7e711f579f27813b$export$4cfca7ce0b67bede);
    var $fjcgS;
    var $cJpFl;
    var $if7bx;
    const $7e711f579f27813b$export$4cfca7ce0b67bede = (sloSettings)=>(observationData, extraProps)=>{
            if (!(0, (0, parcelRequire("cJpFl")).isExpandedObservationData)(observationData) || sloSettings === undefined) return;
            const startTime = observationData.events.map((event)=>event.timestamp);
            const analyticsData = {
                ...extraProps,
                ...(0, (0, parcelRequire("if7bx")).generateLongTaskAnalyticsSummaryWithSlo)('scroll', observationData.events, sloSettings),
                type: observationData.type || 'unknown',
                measureTimespan: performance.now() - Math.min(observationData.startTimestamp, ...startTime)
            };
            const attributes = {
                ...extraProps,
                type: observationData.type || 'unknown',
                isSuccess: analyticsData.scrollLongTaskSloIsSuccess,
                ...sloSettings
            };
            (0, (0, parcelRequire("fjcgS")).getAnalyticsWebClientPromise)().then((client)=>{
                const payload = {
                    source: observationData.appName,
                    action: 'complete',
                    actionSubject: 'scroll operation',
                    attributes: attributes
                };
                client.getInstance().sendOperationalEvent(payload);
            });
        };
});
parcelRegister("3Kr5N", function(module, exports) {
    $parcel$export(module.exports, "useScrollMetaActions", ()=>$b162d083ad3dce4e$export$ad4800a08d9776a3);
    $parcel$export(module.exports, "ScrollMetaProviderSweetState", ()=>$b162d083ad3dce4e$export$e0f28de8d4016f86);
    $parcel$export(module.exports, "isScrollToTop", ()=>$b162d083ad3dce4e$export$5a36b1e9643b5cf2);
    $parcel$export(module.exports, "useIsScrollingY", ()=>$b162d083ad3dce4e$export$b4e5a0824bff5bca);
    $parcel$export(module.exports, "useIsScrollingX", ()=>$b162d083ad3dce4e$export$b8a077e56392e785);
    var $gg7kZ;
    var $3sQ5x;
    var $iXqE5;
    var $28eI8;
    var $02ckh;
    const $b162d083ad3dce4e$var$DEFAULT_STATE = {
        isScrollingX: false,
        isScrollingY: false,
        positions: {
            top: 0,
            bottom: 0
        }
    };
    const $b162d083ad3dce4e$var$store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $b162d083ad3dce4e$var$DEFAULT_STATE,
        actions: (0, (0, parcelRequire("28eI8")).scrollMetaActions),
        name: 'timeline-table.scroll-meta'
    });
    const $b162d083ad3dce4e$export$ad4800a08d9776a3 = (0, (0, parcelRequire("3sQ5x")).createHook)($b162d083ad3dce4e$var$store, {
        selector: null
    });
    const $b162d083ad3dce4e$export$e0f28de8d4016f86 = (0, (0, parcelRequire("gg7kZ")).createContainer)($b162d083ad3dce4e$var$store);
    const $b162d083ad3dce4e$export$5a36b1e9643b5cf2 = (0, (0, parcelRequire("3sQ5x")).createHook)($b162d083ad3dce4e$var$store, {
        selector: (0, (0, parcelRequire("02ckh")).getIsScrollToTop)
    });
    const $b162d083ad3dce4e$export$b4e5a0824bff5bca = (0, (0, parcelRequire("3sQ5x")).createHook)($b162d083ad3dce4e$var$store, {
        selector: (0, (0, parcelRequire("02ckh")).getIsScrollingY)
    });
    const $b162d083ad3dce4e$export$b8a077e56392e785 = (0, (0, parcelRequire("3sQ5x")).createHook)($b162d083ad3dce4e$var$store, {
        selector: (0, (0, parcelRequire("02ckh")).getIsScrollingX)
    });
});
parcelRegister("28eI8", function(module, exports) {
    $parcel$export(module.exports, "scrollMetaActions", ()=>$83aaef37d3b5b1cd$export$a0445084aaf6bbad);
    const $83aaef37d3b5b1cd$var$updateScrollMeta = ({ isScrollingX: isScrollingX, isScrollingY: isScrollingY })=>({ setState: setState })=>{
            setState({
                isScrollingX: isScrollingX,
                isScrollingY: isScrollingY
            });
        };
    const $83aaef37d3b5b1cd$var$updateScrollPosition = ({ scrollTop: scrollTop, scrollBottom: scrollBottom })=>({ setState: setState })=>{
            const positions = {
                top: scrollTop,
                bottom: scrollBottom
            };
            setState({
                positions: positions
            });
        };
    const $83aaef37d3b5b1cd$export$a0445084aaf6bbad = {
        updateScrollMeta: $83aaef37d3b5b1cd$var$updateScrollMeta,
        updateScrollPosition: $83aaef37d3b5b1cd$var$updateScrollPosition
    };
});
parcelRegister("02ckh", function(module, exports) {
    $parcel$export(module.exports, "getIsScrollingX", ()=>$42a3363cc610a84e$export$1b889f4869aca117);
    $parcel$export(module.exports, "getIsScrollingY", ()=>$42a3363cc610a84e$export$ca3dc64117d091c8);
    $parcel$export(module.exports, "getIsScrollToTop", ()=>$42a3363cc610a84e$export$2119597e6872810a);
    const $42a3363cc610a84e$export$1b889f4869aca117 = (state)=>state.isScrollingX;
    const $42a3363cc610a84e$export$ca3dc64117d091c8 = (state)=>state.isScrollingY;
    const $42a3363cc610a84e$export$2119597e6872810a = (state)=>state.positions.top === 0;
});
parcelRegister("cRUzn", function(module, exports) {
    $parcel$export(module.exports, "useResizeObserver", ()=>$86448c82fe51ac99$export$683480f191c0e3ea);
    var $5uXOq = parcelRequire("5uXOq");
    var $8U1C6;
    let $86448c82fe51ac99$var$resizeObserver;
    const $86448c82fe51ac99$export$683480f191c0e3ea = (element, callback)=>{
        (0, $5uXOq.useLayoutEffect)(()=>{
            if (typeof ResizeObserver !== 'undefined') {
                if (!$86448c82fe51ac99$var$resizeObserver) $86448c82fe51ac99$var$resizeObserver = new ResizeObserver((0, (0, parcelRequire("8U1C6")).runCallbacks));
                element && (0, (0, parcelRequire("8U1C6")).observeElement)($86448c82fe51ac99$var$resizeObserver, element, callback);
            }
            return ()=>{
                if (element && $86448c82fe51ac99$var$resizeObserver) (0, (0, parcelRequire("8U1C6")).unobserveElement)($86448c82fe51ac99$var$resizeObserver, element, callback);
            };
        }, [
            element,
            callback
        ]);
    };
});
parcelRegister("8U1C6", function(module, exports) {
    $parcel$export(module.exports, "runCallbacks", ()=>$74e3391927aa1bb5$export$4219acf616175acb);
    $parcel$export(module.exports, "observeElement", ()=>$74e3391927aa1bb5$export$9137ee61fe58d50e);
    $parcel$export(module.exports, "unobserveElement", ()=>$74e3391927aa1bb5$export$4d125402ac99f1b);
    const $74e3391927aa1bb5$var$elementsForCallback = new Map();
    const $74e3391927aa1bb5$export$4219acf616175acb = (entries)=>{
        $74e3391927aa1bb5$var$elementsForCallback.forEach((elements, callback)=>{
            const relevantEntries = [];
            entries.forEach((entry)=>{
                if (elements.includes(entry.target)) relevantEntries.push(entry);
            });
            if (relevantEntries.length > 0) callback(relevantEntries);
        });
    };
    const $74e3391927aa1bb5$export$9137ee61fe58d50e = (resizeObserver, element, callback)=>{
        const existingElements = $74e3391927aa1bb5$var$elementsForCallback.get(callback);
        if (existingElements) $74e3391927aa1bb5$var$elementsForCallback.set(callback, [
            ...existingElements,
            element
        ]);
        else $74e3391927aa1bb5$var$elementsForCallback.set(callback, [
            element
        ]);
        resizeObserver.observe(element);
    };
    const $74e3391927aa1bb5$export$4d125402ac99f1b = (resizeObserver, element, callback)=>{
        $74e3391927aa1bb5$var$elementsForCallback.delete(callback);
        resizeObserver.unobserve(element);
    };
});
parcelRegister("d1oik", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7cab0141580aca4a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $4R6GH;
    var $2nbdU;
    var $hGh1Z;
    const $7cab0141580aca4a$var$TimelineTableScrollFPSMetric = ({ scope: scope, scrollElement: scrollElement })=>{
        const [itemsCount] = (0, (0, parcelRequire("hGh1Z")).useItemsCount)();
        const attributes = {
            isCustomScrollbarPdnd: (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline_table_custom_scroll_pdnd')
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2nbdU")).default), {
            viewId: scope,
            itemsCount: itemsCount,
            scrollElement: scrollElement,
            attributes: attributes
        });
    };
    var $7cab0141580aca4a$export$2e2bcd8739ae039 = $7cab0141580aca4a$var$TimelineTableScrollFPSMetric;
});
parcelRegister("de769", function(module, exports) {
    $parcel$export(module.exports, "useIsScrolling", ()=>$e0c492fa7660c72b$export$fde36fcfab14caba);
    var $5uXOq = parcelRequire("5uXOq");
    var $e76oB;
    var $k9k0z;
    const $e0c492fa7660c72b$export$fde36fcfab14caba = (scrollElement, onScrollChange)=>{
        const rafId = (0, $5uXOq.useRef)(null);
        const startTime = (0, $5uXOq.useRef)(-1);
        const isScrolling = (0, $5uXOq.useRef)(false);
        const lastPosition = (0, $5uXOq.useRef)({
            x: 0,
            y: 0
        });
        const lastScrollState = (0, $5uXOq.useRef)((0, (0, parcelRequire("e76oB")).DEFAULT_STATE));
        const scrollEnd = (0, $5uXOq.useCallback)(()=>{
            if (isScrolling.current) {
                startTime.current = -1;
                isScrolling.current = false;
                lastScrollState.current = (0, (0, parcelRequire("e76oB")).DEFAULT_STATE);
                onScrollChange((0, (0, parcelRequire("e76oB")).DEFAULT_STATE));
            }
            if (rafId.current !== null) {
                cancelAnimationFrame(rafId.current);
                rafId.current = null;
            }
        }, [
            onScrollChange
        ]);
        const tick = (0, $5uXOq.useCallback)(()=>{
            if (isScrolling.current) {
                const stopTime = performance.now();
                const time = stopTime - startTime.current;
                const { scrollTop: scrollTop, scrollLeft: scrollLeft } = scrollElement;
                const scrollState = {
                    ...lastScrollState.current
                };
                if (scrollTop !== lastPosition.current.y) scrollState.isScrollingY = true;
                if (scrollLeft !== lastPosition.current.x) scrollState.isScrollingX = true;
                lastPosition.current = {
                    x: scrollLeft,
                    y: scrollTop
                };
                if (time >= (0, (0, parcelRequire("e76oB")).IDLE_THRESHOLD)) scrollEnd();
                else {
                    if ((0, (0, parcelRequire("k9k0z")).hasStateChanged)(lastScrollState.current, scrollState)) {
                        lastScrollState.current = {
                            ...scrollState
                        };
                        onScrollChange(scrollState);
                    }
                    rafId.current = requestAnimationFrame(tick);
                }
            }
        }, [
            scrollElement,
            scrollEnd,
            onScrollChange
        ]);
        const onScroll = (0, $5uXOq.useCallback)(()=>{
            isScrolling.current = true;
            startTime.current = performance.now();
            if (!rafId.current) rafId.current = requestAnimationFrame(tick);
        }, [
            tick
        ]);
        (0, $5uXOq.useEffect)(()=>{
            scrollElement.addEventListener('scroll', onScroll);
            return ()=>{
                scrollElement.removeEventListener('scroll', onScroll);
                if (rafId.current !== null) {
                    cancelAnimationFrame(rafId.current);
                    rafId.current = null;
                }
            };
        }, [
            scrollElement,
            onScroll
        ]);
    };
});
parcelRegister("e76oB", function(module, exports) {
    $parcel$export(module.exports, "IDLE_THRESHOLD", ()=>$9e06f723d94dcb9e$export$a9b912713512229e);
    $parcel$export(module.exports, "DEFAULT_STATE", ()=>$9e06f723d94dcb9e$export$a3a6a28ae8823b06);
    const $9e06f723d94dcb9e$export$a9b912713512229e = 150;
    const $9e06f723d94dcb9e$export$a3a6a28ae8823b06 = {
        isScrollingX: false,
        isScrollingY: false
    };
});
parcelRegister("k9k0z", function(module, exports) {
    $parcel$export(module.exports, "hasStateChanged", ()=>$0f21825f1e10a969$export$ba6070bd39de76e0);
    const $0f21825f1e10a969$export$ba6070bd39de76e0 = (oldState, newState)=>!oldState.isScrollingX && newState.isScrollingX || !oldState.isScrollingY && newState.isScrollingY;
});
parcelRegister("58xNR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$105ef404676cd478$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9suPc;
    var $iZN6h;
    var $g3prf;
    var $hGh1Z;
    var $jlrVi;
    var $kJTbm;
    const $105ef404676cd478$var$useVirtualItems = ({ scrollElement: scrollElement, itemHeights: itemHeights })=>{
        const [, { generateVirtualMeta: generateVirtualMeta }] = (0, (0, parcelRequire("jlrVi")).useVirtualisedActions)();
        const parentRef = (0, $5uXOq.useRef)(scrollElement);
        const getRowHeight = (0, $5uXOq.useCallback)((index)=>itemHeights[index], [
            itemHeights
        ]);
        const [{ headerHeight: headerHeight }] = (0, (0, parcelRequire("g3prf")).useHeaderState)();
        const virtualizer = (0, (0, parcelRequire("9suPc")).useVirtualizer)({
            count: itemHeights.length,
            getScrollElement: ()=>parentRef.current,
            estimateSize: getRowHeight,
            overscan: 0,
            paddingStart: headerHeight
        });
        (0, $5uXOq.useLayoutEffect)(()=>{
            const virtualItems = virtualizer.getVirtualItems();
            if (virtualizer.getVirtualItems().length > 0) {
                const { index: startIndex } = virtualItems[0];
                const { index: endIndex } = virtualItems[virtualItems.length - 1];
                const visibleItemCount = endIndex - startIndex;
                const roundedStart = Math.round(startIndex / 5) * 5;
                generateVirtualMeta(roundedStart, Math.min(roundedStart + visibleItemCount, endIndex));
            } else generateVirtualMeta(0, itemHeights.length - 1);
        }, [
            generateVirtualMeta,
            virtualizer.getVirtualItems(),
            itemHeights
        ]);
    };
    const $105ef404676cd478$var$Container = ({ itemHeights: itemHeights, scrollElement: scrollElement })=>{
        $105ef404676cd478$var$useVirtualItems({
            itemHeights: itemHeights,
            scrollElement: scrollElement
        });
        return null;
    };
    const $105ef404676cd478$var$VirtualiseContainer = ({ isEnabled: isEnabled, children: children, scrollElement: scrollElement })=>{
        const [items] = (0, (0, parcelRequire("hGh1Z")).useItems)();
        const [itemHeight] = (0, (0, parcelRequire("hGh1Z")).useItemHeight)();
        const itemHeights = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("kJTbm")).getItemHeights)(items, itemHeight), [
            items,
            itemHeight
        ]);
        const createItemIndex = (0, $5uXOq.useMemo)(()=>items.findIndex((item)=>item.type === (0, (0, parcelRequire("iZN6h")).CREATE_ITEM_TYPE)), [
            items
        ]);
        if (typeof ResizeObserver === 'undefined') return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jlrVi")).VirtualiseProviderSweetState), {
            itemHeights: itemHeights,
            createItemIndex: createItemIndex,
            isEnabled: isEnabled,
            items: items
        }, scrollElement && isEnabled && (0, ($parcel$interopDefault($5uXOq))).createElement($105ef404676cd478$var$Container, {
            itemHeights: itemHeights,
            scrollElement: scrollElement
        }), children);
    };
    var $105ef404676cd478$export$2e2bcd8739ae039 = $105ef404676cd478$var$VirtualiseContainer;
});
parcelRegister("9suPc", function(module, exports) {
    $parcel$export(module.exports, "elementScroll", ()=>(parcelRequire("lASGB")).elementScroll);
    $parcel$export(module.exports, "notUndefined", ()=>(parcelRequire("cDbvq")).notUndefined);
    $parcel$export(module.exports, "observeElementOffset", ()=>(parcelRequire("lASGB")).observeElementOffset);
    $parcel$export(module.exports, "observeElementRect", ()=>(parcelRequire("lASGB")).observeElementRect);
    $parcel$export(module.exports, "observeWindowOffset", ()=>(parcelRequire("lASGB")).observeWindowOffset);
    $parcel$export(module.exports, "observeWindowRect", ()=>(parcelRequire("lASGB")).observeWindowRect);
    $parcel$export(module.exports, "Virtualizer", ()=>(parcelRequire("lASGB")).Virtualizer);
    $parcel$export(module.exports, "windowScroll", ()=>(parcelRequire("lASGB")).windowScroll);
    $parcel$export(module.exports, "useVirtualizer", ()=>$6e2ea3c4609c52d6$export$dd6d526d88b5a137);
    var $5uXOq = parcelRequire("5uXOq");
    var $7nsd3 = parcelRequire("7nsd3");
    var $lASGB;
    const $6e2ea3c4609c52d6$var$useIsomorphicLayoutEffect = typeof document !== "undefined" ? $5uXOq.useLayoutEffect : $5uXOq.useEffect;
    function $6e2ea3c4609c52d6$var$useVirtualizerBase(options) {
        const rerender = $5uXOq.useReducer(()=>({}), {})[1];
        const resolvedOptions = {
            ...options,
            onChange: (instance2, sync)=>{
                var _a;
                if (sync) (0, $7nsd3.flushSync)(rerender);
                else rerender();
                (_a = options.onChange) == null || _a.call(options, instance2, sync);
            }
        };
        const [instance] = $5uXOq.useState(()=>new (0, (0, parcelRequire("lASGB")).Virtualizer)(resolvedOptions));
        instance.setOptions(resolvedOptions);
        $5uXOq.useEffect(()=>{
            return instance._didMount();
        }, []);
        $6e2ea3c4609c52d6$var$useIsomorphicLayoutEffect(()=>{
            return instance._willUpdate();
        });
        return instance;
    }
    function $6e2ea3c4609c52d6$export$dd6d526d88b5a137(options) {
        return $6e2ea3c4609c52d6$var$useVirtualizerBase({
            observeElementRect: (0, parcelRequire("lASGB")).observeElementRect,
            observeElementOffset: (0, parcelRequire("lASGB")).observeElementOffset,
            scrollToFn: (0, (0, parcelRequire("lASGB")).elementScroll),
            ...options
        });
    }
    function $6e2ea3c4609c52d6$export$645722dcac657cb9(options) {
        return $6e2ea3c4609c52d6$var$useVirtualizerBase({
            getScrollElement: ()=>typeof document !== "undefined" ? window : null,
            observeElementRect: (0, (0, parcelRequire("lASGB")).observeWindowRect),
            observeElementOffset: (0, (0, parcelRequire("lASGB")).observeWindowOffset),
            scrollToFn: (0, (0, parcelRequire("lASGB")).windowScroll),
            initialOffset: ()=>typeof document !== "undefined" ? window.scrollY : 0,
            ...options
        });
    }
});
parcelRegister("lASGB", function(module, exports) {
    $parcel$export(module.exports, "observeElementRect", ()=>$fb876145852c2505$export$5a50ff2cde8c3802);
    $parcel$export(module.exports, "observeWindowRect", ()=>$fb876145852c2505$export$e911b82c7a99311);
    $parcel$export(module.exports, "observeElementOffset", ()=>$fb876145852c2505$export$fbc040aee017375a);
    $parcel$export(module.exports, "observeWindowOffset", ()=>$fb876145852c2505$export$518998f8c5d09287);
    $parcel$export(module.exports, "windowScroll", ()=>$fb876145852c2505$export$2162c5b3eeedd27);
    $parcel$export(module.exports, "elementScroll", ()=>$fb876145852c2505$export$1cdb988e5ab69fe7);
    $parcel$export(module.exports, "Virtualizer", ()=>$fb876145852c2505$export$89be5a243e59c4b2);
    $parcel$export(module.exports, "notUndefined", ()=>(parcelRequire("cDbvq")).notUndefined);
    var $cDbvq;
    const $fb876145852c2505$export$76974b428a49f15b = (index)=>index;
    const $fb876145852c2505$export$7eb7cb13fd21e5e1 = (range)=>{
        const start = Math.max(range.startIndex - range.overscan, 0);
        const end = Math.min(range.endIndex + range.overscan, range.count - 1);
        const arr = [];
        for(let i = start; i <= end; i++)arr.push(i);
        return arr;
    };
    const $fb876145852c2505$export$5a50ff2cde8c3802 = (instance, cb)=>{
        const element = instance.scrollElement;
        if (!element) return;
        const targetWindow = instance.targetWindow;
        if (!targetWindow) return;
        const handler = (rect)=>{
            const { width: width, height: height } = rect;
            cb({
                width: Math.round(width),
                height: Math.round(height)
            });
        };
        handler(element.getBoundingClientRect());
        if (!targetWindow.ResizeObserver) return ()=>{};
        const observer = new targetWindow.ResizeObserver((entries)=>{
            const entry = entries[0];
            if (entry == null ? void 0 : entry.borderBoxSize) {
                const box = entry.borderBoxSize[0];
                if (box) {
                    handler({
                        width: box.inlineSize,
                        height: box.blockSize
                    });
                    return;
                }
            }
            handler(element.getBoundingClientRect());
        });
        observer.observe(element, {
            box: "border-box"
        });
        return ()=>{
            observer.unobserve(element);
        };
    };
    const $fb876145852c2505$var$addEventListenerOptions = {
        passive: true
    };
    const $fb876145852c2505$export$e911b82c7a99311 = (instance, cb)=>{
        const element = instance.scrollElement;
        if (!element) return;
        const handler = ()=>{
            cb({
                width: element.innerWidth,
                height: element.innerHeight
            });
        };
        handler();
        element.addEventListener("resize", handler, $fb876145852c2505$var$addEventListenerOptions);
        return ()=>{
            element.removeEventListener("resize", handler);
        };
    };
    const $fb876145852c2505$var$supportsScrollend = typeof window == "undefined" ? true : "onscrollend" in window;
    const $fb876145852c2505$export$fbc040aee017375a = (instance, cb)=>{
        const element = instance.scrollElement;
        if (!element) return;
        const targetWindow = instance.targetWindow;
        if (!targetWindow) return;
        let offset = 0;
        const fallback = $fb876145852c2505$var$supportsScrollend ? ()=>void 0 : (0, (0, parcelRequire("cDbvq")).debounce)(targetWindow, ()=>{
            cb(offset, false);
        }, instance.options.isScrollingResetDelay);
        const createHandler = (isScrolling)=>()=>{
                const { horizontal: horizontal, isRtl: isRtl } = instance.options;
                offset = horizontal ? element["scrollLeft"] * (isRtl && -1 || 1) : element["scrollTop"];
                fallback();
                cb(offset, isScrolling);
            };
        const handler = createHandler(true);
        const endHandler = createHandler(false);
        endHandler();
        element.addEventListener("scroll", handler, $fb876145852c2505$var$addEventListenerOptions);
        element.addEventListener("scrollend", endHandler, $fb876145852c2505$var$addEventListenerOptions);
        return ()=>{
            element.removeEventListener("scroll", handler);
            element.removeEventListener("scrollend", endHandler);
        };
    };
    const $fb876145852c2505$export$518998f8c5d09287 = (instance, cb)=>{
        const element = instance.scrollElement;
        if (!element) return;
        const targetWindow = instance.targetWindow;
        if (!targetWindow) return;
        let offset = 0;
        const fallback = $fb876145852c2505$var$supportsScrollend ? ()=>void 0 : (0, (0, parcelRequire("cDbvq")).debounce)(targetWindow, ()=>{
            cb(offset, false);
        }, instance.options.isScrollingResetDelay);
        const createHandler = (isScrolling)=>()=>{
                offset = element[instance.options.horizontal ? "scrollX" : "scrollY"];
                fallback();
                cb(offset, isScrolling);
            };
        const handler = createHandler(true);
        const endHandler = createHandler(false);
        endHandler();
        element.addEventListener("scroll", handler, $fb876145852c2505$var$addEventListenerOptions);
        element.addEventListener("scrollend", endHandler, $fb876145852c2505$var$addEventListenerOptions);
        return ()=>{
            element.removeEventListener("scroll", handler);
            element.removeEventListener("scrollend", endHandler);
        };
    };
    const $fb876145852c2505$export$6aa9c23c0f5932af = (element, entry, instance)=>{
        if (entry == null ? void 0 : entry.borderBoxSize) {
            const box = entry.borderBoxSize[0];
            if (box) {
                const size = Math.round(box[instance.options.horizontal ? "inlineSize" : "blockSize"]);
                return size;
            }
        }
        return Math.round(element.getBoundingClientRect()[instance.options.horizontal ? "width" : "height"]);
    };
    const $fb876145852c2505$export$2162c5b3eeedd27 = (offset, { adjustments: adjustments = 0, behavior: behavior }, instance)=>{
        var _a, _b;
        const toOffset = offset + adjustments;
        (_b = (_a = instance.scrollElement) == null ? void 0 : _a.scrollTo) == null || _b.call(_a, {
            [instance.options.horizontal ? "left" : "top"]: toOffset,
            behavior: behavior
        });
    };
    const $fb876145852c2505$export$1cdb988e5ab69fe7 = (offset, { adjustments: adjustments = 0, behavior: behavior }, instance)=>{
        var _a, _b;
        const toOffset = offset + adjustments;
        (_b = (_a = instance.scrollElement) == null ? void 0 : _a.scrollTo) == null || _b.call(_a, {
            [instance.options.horizontal ? "left" : "top"]: toOffset,
            behavior: behavior
        });
    };
    class $fb876145852c2505$export$89be5a243e59c4b2 {
        constructor(opts){
            this.unsubs = [];
            this.scrollElement = null;
            this.targetWindow = null;
            this.isScrolling = false;
            this.scrollToIndexTimeoutId = null;
            this.measurementsCache = [];
            this.itemSizeCache = new Map();
            this.pendingMeasuredCacheIndexes = [];
            this.scrollRect = null;
            this.scrollOffset = null;
            this.scrollDirection = null;
            this.scrollAdjustments = 0;
            this.elementsCache = new Map();
            this.observer = (()=>{
                let _ro = null;
                const get = ()=>{
                    if (_ro) return _ro;
                    if (!this.targetWindow || !this.targetWindow.ResizeObserver) return null;
                    return _ro = new this.targetWindow.ResizeObserver((entries)=>{
                        entries.forEach((entry)=>{
                            this._measureElement(entry.target, entry);
                        });
                    });
                };
                return {
                    disconnect: ()=>{
                        var _a;
                        (_a = get()) == null || _a.disconnect();
                        _ro = null;
                    },
                    observe: (target)=>{
                        var _a;
                        return (_a = get()) == null ? void 0 : _a.observe(target, {
                            box: "border-box"
                        });
                    },
                    unobserve: (target)=>{
                        var _a;
                        return (_a = get()) == null ? void 0 : _a.unobserve(target);
                    }
                };
            })();
            this.range = null;
            this.setOptions = (opts2)=>{
                Object.entries(opts2).forEach(([key, value])=>{
                    if (typeof value === "undefined") delete opts2[key];
                });
                this.options = {
                    debug: false,
                    initialOffset: 0,
                    overscan: 1,
                    paddingStart: 0,
                    paddingEnd: 0,
                    scrollPaddingStart: 0,
                    scrollPaddingEnd: 0,
                    horizontal: false,
                    getItemKey: $fb876145852c2505$export$76974b428a49f15b,
                    rangeExtractor: $fb876145852c2505$export$7eb7cb13fd21e5e1,
                    onChange: ()=>{},
                    measureElement: $fb876145852c2505$export$6aa9c23c0f5932af,
                    initialRect: {
                        width: 0,
                        height: 0
                    },
                    scrollMargin: 0,
                    gap: 0,
                    indexAttribute: "data-index",
                    initialMeasurementsCache: [],
                    lanes: 1,
                    isScrollingResetDelay: 150,
                    enabled: true,
                    isRtl: false,
                    ...opts2
                };
            };
            this.notify = (sync)=>{
                var _a, _b;
                (_b = (_a = this.options).onChange) == null || _b.call(_a, this, sync);
            };
            this.maybeNotify = (0, (0, parcelRequire("cDbvq")).memo)(()=>{
                this.calculateRange();
                return [
                    this.isScrolling,
                    this.range ? this.range.startIndex : null,
                    this.range ? this.range.endIndex : null
                ];
            }, (isScrolling)=>{
                this.notify(isScrolling);
            }, {
                key: false,
                debug: ()=>this.options.debug,
                initialDeps: [
                    this.isScrolling,
                    this.range ? this.range.startIndex : null,
                    this.range ? this.range.endIndex : null
                ]
            });
            this.cleanup = ()=>{
                this.unsubs.filter(Boolean).forEach((d)=>d());
                this.unsubs = [];
                this.observer.disconnect();
                this.scrollElement = null;
                this.targetWindow = null;
            };
            this._didMount = ()=>{
                return ()=>{
                    this.cleanup();
                };
            };
            this._willUpdate = ()=>{
                var _a;
                const scrollElement = this.options.enabled ? this.options.getScrollElement() : null;
                if (this.scrollElement !== scrollElement) {
                    this.cleanup();
                    if (!scrollElement) {
                        this.maybeNotify();
                        return;
                    }
                    this.scrollElement = scrollElement;
                    if (this.scrollElement && "ownerDocument" in this.scrollElement) this.targetWindow = this.scrollElement.ownerDocument.defaultView;
                    else this.targetWindow = ((_a = this.scrollElement) == null ? void 0 : _a.window) ?? null;
                    this.elementsCache.forEach((cached)=>{
                        this.observer.observe(cached);
                    });
                    this._scrollToOffset(this.getScrollOffset(), {
                        adjustments: void 0,
                        behavior: void 0
                    });
                    this.unsubs.push(this.options.observeElementRect(this, (rect)=>{
                        this.scrollRect = rect;
                        this.maybeNotify();
                    }));
                    this.unsubs.push(this.options.observeElementOffset(this, (offset, isScrolling)=>{
                        this.scrollAdjustments = 0;
                        this.scrollDirection = isScrolling ? this.getScrollOffset() < offset ? "forward" : "backward" : null;
                        this.scrollOffset = offset;
                        this.isScrolling = isScrolling;
                        this.maybeNotify();
                    }));
                }
            };
            this.getSize = ()=>{
                if (!this.options.enabled) {
                    this.scrollRect = null;
                    return 0;
                }
                this.scrollRect = this.scrollRect ?? this.options.initialRect;
                return this.scrollRect[this.options.horizontal ? "width" : "height"];
            };
            this.getScrollOffset = ()=>{
                if (!this.options.enabled) {
                    this.scrollOffset = null;
                    return 0;
                }
                this.scrollOffset = this.scrollOffset ?? (typeof this.options.initialOffset === "function" ? this.options.initialOffset() : this.options.initialOffset);
                return this.scrollOffset;
            };
            this.getFurthestMeasurement = (measurements, index)=>{
                const furthestMeasurementsFound = new Map();
                const furthestMeasurements = new Map();
                for(let m = index - 1; m >= 0; m--){
                    const measurement = measurements[m];
                    if (furthestMeasurementsFound.has(measurement.lane)) continue;
                    const previousFurthestMeasurement = furthestMeasurements.get(measurement.lane);
                    if (previousFurthestMeasurement == null || measurement.end > previousFurthestMeasurement.end) furthestMeasurements.set(measurement.lane, measurement);
                    else if (measurement.end < previousFurthestMeasurement.end) furthestMeasurementsFound.set(measurement.lane, true);
                    if (furthestMeasurementsFound.size === this.options.lanes) break;
                }
                return furthestMeasurements.size === this.options.lanes ? Array.from(furthestMeasurements.values()).sort((a, b)=>{
                    if (a.end === b.end) return a.index - b.index;
                    return a.end - b.end;
                })[0] : void 0;
            };
            this.getMeasurementOptions = (0, (0, parcelRequire("cDbvq")).memo)(()=>[
                    this.options.count,
                    this.options.paddingStart,
                    this.options.scrollMargin,
                    this.options.getItemKey,
                    this.options.enabled
                ], (count, paddingStart, scrollMargin, getItemKey, enabled)=>{
                this.pendingMeasuredCacheIndexes = [];
                return {
                    count: count,
                    paddingStart: paddingStart,
                    scrollMargin: scrollMargin,
                    getItemKey: getItemKey,
                    enabled: enabled
                };
            }, {
                key: false
            });
            this.getMeasurements = (0, (0, parcelRequire("cDbvq")).memo)(()=>[
                    this.getMeasurementOptions(),
                    this.itemSizeCache
                ], ({ count: count, paddingStart: paddingStart, scrollMargin: scrollMargin, getItemKey: getItemKey, enabled: enabled }, itemSizeCache)=>{
                if (!enabled) {
                    this.measurementsCache = [];
                    this.itemSizeCache.clear();
                    return [];
                }
                if (this.measurementsCache.length === 0) {
                    this.measurementsCache = this.options.initialMeasurementsCache;
                    this.measurementsCache.forEach((item)=>{
                        this.itemSizeCache.set(item.key, item.size);
                    });
                }
                const min = this.pendingMeasuredCacheIndexes.length > 0 ? Math.min(...this.pendingMeasuredCacheIndexes) : 0;
                this.pendingMeasuredCacheIndexes = [];
                const measurements = this.measurementsCache.slice(0, min);
                for(let i = min; i < count; i++){
                    const key = getItemKey(i);
                    const furthestMeasurement = this.options.lanes === 1 ? measurements[i - 1] : this.getFurthestMeasurement(measurements, i);
                    const start = furthestMeasurement ? furthestMeasurement.end + this.options.gap : paddingStart + scrollMargin;
                    const measuredSize = itemSizeCache.get(key);
                    const size = typeof measuredSize === "number" ? measuredSize : this.options.estimateSize(i);
                    const end = start + size;
                    const lane = furthestMeasurement ? furthestMeasurement.lane : i % this.options.lanes;
                    measurements[i] = {
                        index: i,
                        start: start,
                        size: size,
                        end: end,
                        key: key,
                        lane: lane
                    };
                }
                this.measurementsCache = measurements;
                return measurements;
            }, {
                key: false,
                debug: ()=>this.options.debug
            });
            this.calculateRange = (0, (0, parcelRequire("cDbvq")).memo)(()=>[
                    this.getMeasurements(),
                    this.getSize(),
                    this.getScrollOffset()
                ], (measurements, outerSize, scrollOffset)=>{
                return this.range = measurements.length > 0 && outerSize > 0 ? $fb876145852c2505$var$calculateRange({
                    measurements: measurements,
                    outerSize: outerSize,
                    scrollOffset: scrollOffset
                }) : null;
            }, {
                key: false,
                debug: ()=>this.options.debug
            });
            this.getIndexes = (0, (0, parcelRequire("cDbvq")).memo)(()=>[
                    this.options.rangeExtractor,
                    this.calculateRange(),
                    this.options.overscan,
                    this.options.count
                ], (rangeExtractor, range, overscan, count)=>{
                return range === null ? [] : rangeExtractor({
                    startIndex: range.startIndex,
                    endIndex: range.endIndex,
                    overscan: overscan,
                    count: count
                });
            }, {
                key: false,
                debug: ()=>this.options.debug
            });
            this.indexFromElement = (node)=>{
                const attributeName = this.options.indexAttribute;
                const indexStr = node.getAttribute(attributeName);
                if (!indexStr) {
                    console.warn(`Missing attribute name '${attributeName}={index}' on measured element.`);
                    return -1;
                }
                return parseInt(indexStr, 10);
            };
            this._measureElement = (node, entry)=>{
                const index = this.indexFromElement(node);
                const item = this.measurementsCache[index];
                if (!item) return;
                const key = item.key;
                const prevNode = this.elementsCache.get(key);
                if (prevNode !== node) {
                    if (prevNode) this.observer.unobserve(prevNode);
                    this.observer.observe(node);
                    this.elementsCache.set(key, node);
                }
                if (node.isConnected) this.resizeItem(index, this.options.measureElement(node, entry, this));
            };
            this.resizeItem = (index, size)=>{
                const item = this.measurementsCache[index];
                if (!item) return;
                const itemSize = this.itemSizeCache.get(item.key) ?? item.size;
                const delta = size - itemSize;
                if (delta !== 0) {
                    if (this.shouldAdjustScrollPositionOnItemSizeChange !== void 0 ? this.shouldAdjustScrollPositionOnItemSizeChange(item, delta, this) : item.start < this.getScrollOffset() + this.scrollAdjustments) this._scrollToOffset(this.getScrollOffset(), {
                        adjustments: this.scrollAdjustments += delta,
                        behavior: void 0
                    });
                    this.pendingMeasuredCacheIndexes.push(item.index);
                    this.itemSizeCache = new Map(this.itemSizeCache.set(item.key, size));
                    this.notify(false);
                }
            };
            this.measureElement = (node)=>{
                if (!node) {
                    this.elementsCache.forEach((cached, key)=>{
                        if (!cached.isConnected) {
                            this.observer.unobserve(cached);
                            this.elementsCache.delete(key);
                        }
                    });
                    return;
                }
                this._measureElement(node, void 0);
            };
            this.getVirtualItems = (0, (0, parcelRequire("cDbvq")).memo)(()=>[
                    this.getIndexes(),
                    this.getMeasurements()
                ], (indexes, measurements)=>{
                const virtualItems = [];
                for(let k = 0, len = indexes.length; k < len; k++){
                    const i = indexes[k];
                    const measurement = measurements[i];
                    virtualItems.push(measurement);
                }
                return virtualItems;
            }, {
                key: false,
                debug: ()=>this.options.debug
            });
            this.getVirtualItemForOffset = (offset)=>{
                const measurements = this.getMeasurements();
                if (measurements.length === 0) return void 0;
                return (0, (0, parcelRequire("cDbvq")).notUndefined)(measurements[$fb876145852c2505$var$findNearestBinarySearch(0, measurements.length - 1, (index)=>(0, (0, parcelRequire("cDbvq")).notUndefined)(measurements[index]).start, offset)]);
            };
            this.getOffsetForAlignment = (toOffset, align)=>{
                const size = this.getSize();
                const scrollOffset = this.getScrollOffset();
                if (align === "auto") {
                    if (toOffset <= scrollOffset) align = "start";
                    else if (toOffset >= scrollOffset + size) align = "end";
                    else align = "start";
                }
                if (align === "start") toOffset;
                else if (align === "end") toOffset = toOffset - size;
                else if (align === "center") toOffset = toOffset - size / 2;
                const scrollSizeProp = this.options.horizontal ? "scrollWidth" : "scrollHeight";
                const scrollSize = this.scrollElement ? "document" in this.scrollElement ? this.scrollElement.document.documentElement[scrollSizeProp] : this.scrollElement[scrollSizeProp] : 0;
                const maxOffset = scrollSize - size;
                return Math.max(Math.min(maxOffset, toOffset), 0);
            };
            this.getOffsetForIndex = (index, align = "auto")=>{
                index = Math.max(0, Math.min(index, this.options.count - 1));
                const item = this.measurementsCache[index];
                if (!item) return void 0;
                const size = this.getSize();
                const scrollOffset = this.getScrollOffset();
                if (align === "auto") {
                    if (item.end >= scrollOffset + size - this.options.scrollPaddingEnd) align = "end";
                    else if (item.start <= scrollOffset + this.options.scrollPaddingStart) align = "start";
                    else return [
                        scrollOffset,
                        align
                    ];
                }
                const toOffset = align === "end" ? item.end + this.options.scrollPaddingEnd : item.start - this.options.scrollPaddingStart;
                return [
                    this.getOffsetForAlignment(toOffset, align),
                    align
                ];
            };
            this.isDynamicMode = ()=>this.elementsCache.size > 0;
            this.cancelScrollToIndex = ()=>{
                if (this.scrollToIndexTimeoutId !== null && this.targetWindow) {
                    this.targetWindow.clearTimeout(this.scrollToIndexTimeoutId);
                    this.scrollToIndexTimeoutId = null;
                }
            };
            this.scrollToOffset = (toOffset, { align: align = "start", behavior: behavior } = {})=>{
                this.cancelScrollToIndex();
                if (behavior === "smooth" && this.isDynamicMode()) console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
                this._scrollToOffset(this.getOffsetForAlignment(toOffset, align), {
                    adjustments: void 0,
                    behavior: behavior
                });
            };
            this.scrollToIndex = (index, { align: initialAlign = "auto", behavior: behavior } = {})=>{
                index = Math.max(0, Math.min(index, this.options.count - 1));
                this.cancelScrollToIndex();
                if (behavior === "smooth" && this.isDynamicMode()) console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
                const offsetAndAlign = this.getOffsetForIndex(index, initialAlign);
                if (!offsetAndAlign) return;
                const [offset, align] = offsetAndAlign;
                this._scrollToOffset(offset, {
                    adjustments: void 0,
                    behavior: behavior
                });
                if (behavior !== "smooth" && this.isDynamicMode() && this.targetWindow) this.scrollToIndexTimeoutId = this.targetWindow.setTimeout(()=>{
                    this.scrollToIndexTimeoutId = null;
                    const elementInDOM = this.elementsCache.has(this.options.getItemKey(index));
                    if (elementInDOM) {
                        const [latestOffset] = (0, (0, parcelRequire("cDbvq")).notUndefined)(this.getOffsetForIndex(index, align));
                        if (!(0, (0, parcelRequire("cDbvq")).approxEqual)(latestOffset, this.getScrollOffset())) this.scrollToIndex(index, {
                            align: align,
                            behavior: behavior
                        });
                    } else this.scrollToIndex(index, {
                        align: align,
                        behavior: behavior
                    });
                });
            };
            this.scrollBy = (delta, { behavior: behavior } = {})=>{
                this.cancelScrollToIndex();
                if (behavior === "smooth" && this.isDynamicMode()) console.warn("The `smooth` scroll behavior is not fully supported with dynamic size.");
                this._scrollToOffset(this.getScrollOffset() + delta, {
                    adjustments: void 0,
                    behavior: behavior
                });
            };
            this.getTotalSize = ()=>{
                var _a;
                const measurements = this.getMeasurements();
                let end;
                if (measurements.length === 0) end = this.options.paddingStart;
                else end = this.options.lanes === 1 ? ((_a = measurements[measurements.length - 1]) == null ? void 0 : _a.end) ?? 0 : Math.max(...measurements.slice(-this.options.lanes).map((m)=>m.end));
                return Math.max(end - this.options.scrollMargin + this.options.paddingEnd, 0);
            };
            this._scrollToOffset = (offset, { adjustments: adjustments, behavior: behavior })=>{
                this.options.scrollToFn(offset, {
                    behavior: behavior,
                    adjustments: adjustments
                }, this);
            };
            this.measure = ()=>{
                this.itemSizeCache = new Map();
                this.notify(false);
            };
            this.setOptions(opts);
        }
    }
    const $fb876145852c2505$var$findNearestBinarySearch = (low, high, getCurrentValue, value)=>{
        while(low <= high){
            const middle = (low + high) / 2 | 0;
            const currentValue = getCurrentValue(middle);
            if (currentValue < value) low = middle + 1;
            else if (currentValue > value) high = middle - 1;
            else return middle;
        }
        if (low > 0) return low - 1;
        else return 0;
    };
    function $fb876145852c2505$var$calculateRange({ measurements: measurements, outerSize: outerSize, scrollOffset: scrollOffset }) {
        const count = measurements.length - 1;
        const getOffset = (index)=>measurements[index].start;
        const startIndex = $fb876145852c2505$var$findNearestBinarySearch(0, count, getOffset, scrollOffset);
        let endIndex = startIndex;
        while(endIndex < count && measurements[endIndex].end < scrollOffset + outerSize)endIndex++;
        return {
            startIndex: startIndex,
            endIndex: endIndex
        };
    }
});
parcelRegister("cDbvq", function(module, exports) {
    $parcel$export(module.exports, "memo", ()=>$93220d646a94e11c$export$7c73462e0d25e514);
    $parcel$export(module.exports, "notUndefined", ()=>$93220d646a94e11c$export$9a1adf421b69c6a);
    $parcel$export(module.exports, "approxEqual", ()=>$93220d646a94e11c$export$8a4f1dcc58a69dbd);
    $parcel$export(module.exports, "debounce", ()=>$93220d646a94e11c$export$61fc7d43ac8f84b0);
    function $93220d646a94e11c$export$7c73462e0d25e514(getDeps, fn, opts) {
        let deps = opts.initialDeps ?? [];
        let result;
        return ()=>{
            var _a, _b, _c, _d;
            let depTime;
            if (opts.key && ((_a = opts.debug) == null ? void 0 : _a.call(opts))) depTime = Date.now();
            const newDeps = getDeps();
            const depsChanged = newDeps.length !== deps.length || newDeps.some((dep, index)=>deps[index] !== dep);
            if (!depsChanged) return result;
            deps = newDeps;
            let resultTime;
            if (opts.key && ((_b = opts.debug) == null ? void 0 : _b.call(opts))) resultTime = Date.now();
            result = fn(...newDeps);
            if (opts.key && ((_c = opts.debug) == null ? void 0 : _c.call(opts))) {
                const depEndTime = Math.round((Date.now() - depTime) * 100) / 100;
                const resultEndTime = Math.round((Date.now() - resultTime) * 100) / 100;
                const resultFpsPercentage = resultEndTime / 16;
                const pad = (str, num)=>{
                    str = String(str);
                    while(str.length < num)str = " " + str;
                    return str;
                };
                console.info(`%c\u{23F1} ${pad(resultEndTime, 5)} /${pad(depEndTime, 5)} ms`, `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(0, Math.min(120 - 120 * resultFpsPercentage, 120))}deg 100% 31%);`, opts == null ? void 0 : opts.key);
            }
            (_d = opts == null ? void 0 : opts.onChange) == null || _d.call(opts, result);
            return result;
        };
    }
    function $93220d646a94e11c$export$9a1adf421b69c6a(value, msg) {
        if (value === void 0) throw new Error(`Unexpected undefined${msg ? `: ${msg}` : ""}`);
        else return value;
    }
    const $93220d646a94e11c$export$8a4f1dcc58a69dbd = (a, b)=>Math.abs(a - b) < 1;
    const $93220d646a94e11c$export$61fc7d43ac8f84b0 = (targetWindow, fn, ms)=>{
        let timeoutId;
        return function(...args) {
            targetWindow.clearTimeout(timeoutId);
            timeoutId = targetWindow.setTimeout(()=>fn.apply(this, args), ms);
        };
    };
});
parcelRegister("jlrVi", function(module, exports) {
    $parcel$export(module.exports, "useVirtualisedActions", ()=>$471e093fab4fea6e$export$affb102126dcde2a);
    $parcel$export(module.exports, "useVirtualisedItems", ()=>$471e093fab4fea6e$export$a4da365e237701e3);
    $parcel$export(module.exports, "VirtualiseProviderSweetState", ()=>$471e093fab4fea6e$export$6754b86f75c8ce1a);
    var $gg7kZ;
    var $3sQ5x;
    var $iXqE5;
    var $iZN6h;
    var $284CM;
    var $6ulzk;
    var $cgSxA;
    const $471e093fab4fea6e$var$store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: (0, (0, parcelRequire("6ulzk")).DEFAULT_VALUE),
        actions: (0, (0, parcelRequire("284CM")).virtualiserActions),
        name: 'timeline-table.virtualise'
    });
    const $471e093fab4fea6e$export$affb102126dcde2a = (0, (0, parcelRequire("3sQ5x")).createHook)($471e093fab4fea6e$var$store, {
        selector: null
    });
    const $471e093fab4fea6e$export$a4da365e237701e3 = (0, (0, parcelRequire("3sQ5x")).createHook)($471e093fab4fea6e$var$store, {
        selector: (0, (0, parcelRequire("cgSxA")).getVirtualisedItems)
    });
    const $471e093fab4fea6e$export$34f4621b58d3fbc8 = ()=>({ dispatch: dispatch }, { itemHeights: itemHeights, isEnabled: isEnabled })=>{
            if (isEnabled) {
                const fallbackItemsCount = Math.round(window.innerHeight / (0, (0, parcelRequire("iZN6h")).DEFAULT_ITEM_HEIGHT));
                const fallbackEnd = Math.min(itemHeights.length - 1, fallbackItemsCount);
                dispatch((0, (0, parcelRequire("284CM")).virtualiserActions).generateVirtualMeta(0, fallbackEnd));
            } else dispatch((0, (0, parcelRequire("284CM")).virtualiserActions).generateVirtualMeta(0, itemHeights.length - 1));
        };
    const $471e093fab4fea6e$export$ab8f0de40a3a2d2d = ()=>({ dispatch: dispatch }, { itemHeights: itemHeights, isEnabled: isEnabled })=>{
            if (!isEnabled) dispatch((0, (0, parcelRequire("284CM")).virtualiserActions).generateVirtualMeta(0, itemHeights.length - 1));
        };
    const $471e093fab4fea6e$export$6754b86f75c8ce1a = (0, (0, parcelRequire("gg7kZ")).createContainer)($471e093fab4fea6e$var$store, {
        onInit: $471e093fab4fea6e$export$34f4621b58d3fbc8,
        onUpdate: $471e093fab4fea6e$export$ab8f0de40a3a2d2d
    });
});
parcelRegister("284CM", function(module, exports) {
    $parcel$export(module.exports, "virtualiserActions", ()=>$b9b0869fd0fa9f88$export$e8a8e63a5a7f1929);
    var $6ulzk;
    const $b9b0869fd0fa9f88$export$e8a8e63a5a7f1929 = {
        generateVirtualMeta: (0, parcelRequire("6ulzk")).generateVirtualMeta
    };
});
parcelRegister("6ulzk", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_VALUE", ()=>$fe837ba7e74306bb$export$66a151256d4631f5);
    $parcel$export(module.exports, "generateVirtualMeta", ()=>$fe837ba7e74306bb$export$ac5dd8f3ecc3f3f9);
    var $k0IsY;
    const $fe837ba7e74306bb$export$66a151256d4631f5 = {
        overscan: (0, $31e198dce5c86093$export$def0e365218ffa1e),
        requiredItems: [],
        overscanRange: {
            start: 0,
            end: 0
        }
    };
    const $fe837ba7e74306bb$export$ac5dd8f3ecc3f3f9 = (startIndex, endIndex)=>({ setState: setState }, { createItemIndex: createItemIndex, itemHeights: itemHeights, items: items })=>{
            if (startIndex !== undefined && endIndex !== undefined) {
                const virtualMeta = (0, (0, parcelRequire("k0IsY")).getVisibleItemsFromIndexes)({
                    createItemIndex: createItemIndex,
                    itemHeights: itemHeights,
                    startIndex: startIndex,
                    endIndex: endIndex,
                    items: items
                });
                setState(virtualMeta);
            } else setState($fe837ba7e74306bb$export$66a151256d4631f5);
        };
});
const $31e198dce5c86093$export$793ed84f5e13fedc = 'TOP';
const $31e198dce5c86093$export$84e1549b474f1b93 = 'BOTTOM';
const $31e198dce5c86093$export$def0e365218ffa1e = 5;
parcelRegister("k0IsY", function(module, exports) {
    $parcel$export(module.exports, "getVisibleItemsFromIndexes", ()=>$5caaafdb8f3b6d57$export$aefb967ef9d43391);
    var $8QpSo;
    var $iZN6h;
    const $5caaafdb8f3b6d57$var$getAccumulateHeight = (0, (0, parcelRequire("8QpSo")).default)((itemHeights)=>itemHeights.reduce((acc, current, index)=>{
            acc.push(current + (index > 0 ? acc[index - 1] : 0));
            return acc;
        }, []));
    const $5caaafdb8f3b6d57$export$b55fce277fa0884f = (startIndex, endIndex, itemHeights)=>{
        if (endIndex <= startIndex) return 0;
        const accumHeight = $5caaafdb8f3b6d57$var$getAccumulateHeight(itemHeights);
        return accumHeight[endIndex - 1] - (startIndex === 0 ? 0 : accumHeight[startIndex - 1]);
    };
    const $5caaafdb8f3b6d57$export$1101758ce03ba6b1 = (index, itemHeights, start, end)=>{
        const before = $5caaafdb8f3b6d57$export$b55fce277fa0884f(start, index, itemHeights);
        const after = $5caaafdb8f3b6d57$export$b55fce277fa0884f(index + 1, end, itemHeights);
        return {
            before: before,
            after: after
        };
    };
    const $5caaafdb8f3b6d57$export$c6fd3ab3f44300d0 = (items, item)=>{
        const ancestors = [];
        if (item) {
            let currentParentId = item.meta.parentId;
            const startingIndex = item.flatIndex - 1;
            for(let i = startingIndex; i >= 0 && currentParentId; i--){
                const currentItem = items[i];
                if (currentItem.type === (0, (0, parcelRequire("iZN6h")).ITEM_TYPE) && currentItem.item.id === currentParentId) {
                    ancestors.push(currentItem);
                    currentParentId = items[i].meta.parentId;
                }
            }
        }
        return ancestors.reverse();
    };
    const $5caaafdb8f3b6d57$export$7adcff1c9f66e792 = (items, createItemIndex)=>{
        const createItem = items[createItemIndex];
        if (createItem === undefined || createItem.type !== (0, (0, parcelRequire("iZN6h")).CREATE_ITEM_TYPE)) return undefined;
        return createItem;
    };
    const $5caaafdb8f3b6d57$export$aefb967ef9d43391 = ({ startIndex: startIndex, endIndex: endIndex, itemHeights: itemHeights, createItemIndex: createItemIndex, items: items, overscan: overscan = (0, $31e198dce5c86093$export$def0e365218ffa1e) })=>{
        const totalCount = itemHeights.length;
        const overscanStart = Math.max(startIndex - overscan, 0);
        const overscanEnd = Math.min(endIndex + overscan, totalCount - 1);
        let createPosition;
        if (createItemIndex > -1 && createItemIndex < overscanStart) createPosition = (0, $31e198dce5c86093$export$793ed84f5e13fedc);
        else if (createItemIndex > overscanEnd) createPosition = (0, $31e198dce5c86093$export$84e1549b474f1b93);
        const createItem = $5caaafdb8f3b6d57$export$7adcff1c9f66e792(items, createItemIndex);
        const invisibleAncestors = $5caaafdb8f3b6d57$export$c6fd3ab3f44300d0(items, items[overscanStart]);
        const createItemAncestors = createPosition && createItem ? $5caaafdb8f3b6d57$export$c6fd3ab3f44300d0(items, createItem) : [];
        const requiredItems = items.filter((item, index)=>index >= overscanStart && index <= overscanEnd || index === createItemIndex || item.type === (0, (0, parcelRequire("iZN6h")).ITEM_TYPE) && (createItemAncestors?.includes(item) || invisibleAncestors?.includes(item)));
        return {
            requiredItems: requiredItems,
            overscanRange: {
                start: overscanStart,
                end: overscanEnd
            },
            overscan: overscan
        };
    };
});
parcelRegister("cgSxA", function(module, exports) {
    $parcel$export(module.exports, "getVirtualisedItems", ()=>$81d149403e50db79$export$fab83018e0db4fa8);
    const $81d149403e50db79$export$fab83018e0db4fa8 = (state)=>state;
});
parcelRegister("kJTbm", function(module, exports) {
    $parcel$export(module.exports, "getItemHeights", ()=>$7089fa4beeab56f9$export$b0c1b33ea0acf206);
    var $iZN6h;
    const $7089fa4beeab56f9$export$b0c1b33ea0acf206 = (items, itemHeight)=>items.map((item)=>{
            const depth = item.type === (0, (0, parcelRequire("iZN6h")).ITEM_TYPE) && item?.item?.depth;
            if (item.type === (0, (0, parcelRequire("iZN6h")).ITEM_TYPE) && depth === 0) return itemHeight;
            if (item.type === (0, (0, parcelRequire("iZN6h")).CREATE_ITEM_TYPE)) return itemHeight;
            return (0, (0, parcelRequire("iZN6h")).BASE_LEVEL_ITEM_HEIGHT)();
        });
});
parcelRegister("hEf85", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1131366f450d3aa8$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $lwMsT;
    var $4R6GH;
    var $l8ruj;
    var $fcOMi;
    var $WPwAA;
    var $hGh1Z;
    var $hUAzM;
    var $cRUzn;
    var $iNpaX;
    var $d6NhP;
    var $iFc7j;
    var $kY4b5;
    var $l75uJ;
    var $3yTFv;
    var $6lHwb;
    var $fepzL;
    var $jIXeo;
    var $kBjnL;
    var $anfdB;
    const $1131366f450d3aa8$var$contentContainerStyles = null;
    const $1131366f450d3aa8$var$Content = ({ isResizeEnabled: isResizeEnabled, DndLongTaskMetric: DndLongTaskMetric, onItemDrop: onItemDrop, onItemSelect: onItemSelect, onItemExpandChanged: onItemExpandChanged, onCreateClick: onCreateClick, onSetListWidth: onSetListWidth, onContentResize: onContentResize, renderListEmptyContent: renderListEmptyContent, renderListItemContent: renderListItemContent, renderListItemSecondaryContent: renderListItemSecondaryContent, renderListItemCreate: renderListItemCreate, renderChartItemContent: renderChartItemContent, renderChartTimelineOverlay: renderChartTimelineOverlay, renderListItemMenuOption: renderListItemMenuOption, renderListItemModal: renderListItemModal })=>{
        const contentContainerRef = (0, $5uXOq.useRef)(null);
        const [{ isDragEnabled: isDragEnabled, isSelectEnabled: isSelectEnabled, isMultiSelectEnabled: isMultiSelectEnabled, isCreateSiblingEnabled: isCreateSiblingEnabled, isCreateChildEnabled: isCreateChildEnabled, isMeatballsButtonEnabled: isMeatballsButtonEnabled }] = (0, (0, parcelRequire("WPwAA")).useEnablements)();
        const [createItemAnchor] = (0, (0, parcelRequire("hGh1Z")).useCreateItemAnchor)();
        const [itemHeight] = (0, (0, parcelRequire("hGh1Z")).useItemHeight)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const onSelect = (0, $5uXOq.useCallback)((id, payload)=>{
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'listItem',
                actionSubjectId: 'issueListItem',
                attributes: payload
            });
            (0, (0, parcelRequire("hUAzM")).fireUIAnalyticsEvent)(analyticsEvent);
            onItemSelect(id, payload, analyticsEvent);
        }, [
            onItemSelect,
            createAnalyticsEvent
        ]);
        const onExpandChanged = (0, $5uXOq.useCallback)((id, isItemExpanded)=>{
            const analyticsEvent = createAnalyticsEvent({
                action: 'expansionStateChanged',
                actionSubject: 'listItem',
                actionSubjectId: 'issueListItem',
                attributes: {
                    type: isItemExpanded ? 'collapsed' : 'expanded'
                }
            });
            (0, (0, parcelRequire("hUAzM")).fireUIAnalyticsEvent)(analyticsEvent);
            onItemExpandChanged(id, isItemExpanded);
        }, [
            onItemExpandChanged,
            createAnalyticsEvent
        ]);
        const onDrop = (0, $5uXOq.useCallback)((id, payload)=>{
            const analyticsEvent = createAnalyticsEvent({
                action: 'dragEnded',
                actionSubject: 'listItem',
                actionSubjectId: 'issueListItem',
                attributes: {
                    level: payload.level,
                    isReparent: Boolean(payload.parentId),
                    ...(0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline_table_meatballs_menu_a11y') ? {
                        isMeatballsAction: payload.isMeatballsAction
                    } : {}
                }
            });
            (0, (0, parcelRequire("hUAzM")).fireUIAnalyticsEvent)(analyticsEvent);
            onItemDrop(id, payload, analyticsEvent);
        }, [
            onItemDrop,
            createAnalyticsEvent
        ]);
        const renderCreateItem = (id, anchorItem, { level: level, depth: depth = 0, backgroundColor: backgroundColor, isActive: isActive, ariaRowIndex: ariaRowIndex, topOffset: topOffset })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l75uJ")).default), {
                key: id,
                id: id,
                level: level,
                canCreateChildOverride: Boolean(anchorItem?.canCreateChildOverride),
                depth: depth,
                anchorId: anchorItem?.id,
                itemHeight: itemHeight,
                backgroundColor: backgroundColor,
                isActive: isActive,
                ariaRowIndex: ariaRowIndex,
                topOffset: topOffset,
                onCreateClick: onCreateClick,
                renderListItemCreate: renderListItemCreate
            });
        const renderItem = ({ id: id, level: level, isInTransition: isInTransition, canCreateChildOverride: canCreateChildOverride = true, depth: depth = 0 }, { parentId: parentId, backgroundColor: backgroundColor, isParent: isParent, isExpanded: isExpanded, ariaControls: ariaControls }, index, isVirtual = false)=>{
            if (isVirtual) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fepzL")).default), {
                key: `list-item-lite-${id}`,
                id: id,
                depth: depth,
                itemHeight: itemHeight,
                backgroundColor: backgroundColor,
                renderListItemContent: renderListItemContent,
                renderListItemSecondaryContent: renderListItemSecondaryContent
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d6NhP")).default), {
                id: id,
                key: `chart-item-lite-${id}`,
                depth: depth,
                itemHeight: itemHeight,
                backgroundColor: backgroundColor,
                renderChartItemContent: renderChartItemContent
            }));
            const canCreateChild = (0, (0, parcelRequire("anfdB")).canItemCreateChild)({
                id: id,
                createItemAnchor: createItemAnchor,
                isInTransition: isInTransition,
                isCreateChildEnabled: isCreateChildEnabled,
                canCreateChildOverride: canCreateChildOverride
            });
            const canCreateSibling = (0, (0, parcelRequire("anfdB")).canItemCreateSibling)({
                id: id,
                index: index,
                depth: depth,
                createItemAnchor: createItemAnchor,
                isInTransition: isInTransition,
                isCreateChildEnabled: isCreateChildEnabled,
                isCreateSiblingEnabled: isCreateSiblingEnabled
            });
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jIXeo")).default), {
                ariaControls: ariaControls,
                key: `list-item-${id}`,
                id: id,
                parentId: parentId,
                level: level,
                depth: depth,
                itemHeight: itemHeight,
                backgroundColor: backgroundColor,
                isParent: isParent,
                isExpanded: isExpanded,
                isDragEnabled: isDragEnabled,
                isInTransition: isInTransition,
                isSelectEnabled: isSelectEnabled,
                isMultiSelectEnabled: isMultiSelectEnabled,
                isCreateChildEnabled: canCreateChild,
                isCreateSiblingEnabled: canCreateSibling,
                isMeatballsButtonEnabled: isMeatballsButtonEnabled,
                onSelect: onSelect,
                onDrop: onDrop,
                onExpandChanged: onExpandChanged,
                onInlineCreateClicked: onCreateClick,
                renderListItemContent: renderListItemContent,
                renderListItemSecondaryContent: renderListItemSecondaryContent,
                renderListItemMenuOption: renderListItemMenuOption,
                renderListItemModal: renderListItemModal
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iFc7j")).default), {
                id: id,
                key: `chart-item-${id}`,
                depth: depth,
                parentId: parentId,
                itemHeight: itemHeight,
                backgroundColor: backgroundColor,
                renderChartItemContent: renderChartItemContent
            }));
        };
        const renderItemContainer = ({ parentId: parentId, isExpanded: isExpanded, isParent: isParent, id: id, level: level, depth: depth = 0, topOffset: topOffset, ariaRowIndex: ariaRowIndex, childItemsHeight: childItemsHeight, isInTransition: isInTransition }, _, children)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3yTFv")).default), {
                id: id,
                key: `drop-target-${id}`,
                ariaRowIndex: ariaRowIndex,
                topOffset: topOffset,
                level: level,
                depth: depth,
                parentId: parentId,
                isExpanded: isExpanded,
                isParent: isParent,
                itemHeight: itemHeight,
                childItemsHeight: childItemsHeight,
                isInTransition: isInTransition,
                onDrop: onDrop,
                onExpandChanged: onExpandChanged
            }, children);
        (0, (0, parcelRequire("cRUzn")).useResizeObserver)(contentContainerRef.current, onContentResize);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "timeline-table-content"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            role: "rowgroup",
            ref: contentContainerRef,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kY4b5")).ItemsBackground), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fcOMi")).default), {
            renderItem: renderItem,
            renderItemContainer: renderItemContainer,
            renderCreateItem: renderCreateItem
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6lHwb")).default), {
            renderListEmptyContent: renderListEmptyContent
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iNpaX")).default), {
            renderChartTimelineOverlay: renderChartTimelineOverlay
        }), isResizeEnabled && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kBjnL")).default), {
            DndLongTaskMetric: DndLongTaskMetric,
            onSetListWidth: onSetListWidth
        }));
    };
    $1131366f450d3aa8$var$Content.defaultProps = {
        isResizeEnabled: true,
        onItemDrop: (0, ($parcel$interopDefault($8Rkzz))),
        onItemSelect: (0, ($parcel$interopDefault($8Rkzz))),
        onItemExpandChanged: (0, ($parcel$interopDefault($8Rkzz))),
        onCreateClick: (0, ($parcel$interopDefault($8Rkzz))),
        onSetListWidth: (0, ($parcel$interopDefault($8Rkzz))),
        onContentResize: (0, ($parcel$interopDefault($8Rkzz)))
    };
    $1131366f450d3aa8$var$Content.displayName = 'Content';
    $1131366f450d3aa8$var$Content.whyDidYouRender = true;
    var $1131366f450d3aa8$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($1131366f450d3aa8$var$Content);
});
parcelRegister("fcOMi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d1c4dd68c4d10c32$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $4R6GH;
    var $iZN6h;
    var $hGh1Z;
    var $jlrVi;
    const $d1c4dd68c4d10c32$var$ItemsRenderer = ({ renderItem: renderItem, renderItemContainer: renderItemContainer, renderCreateItem: renderCreateItem })=>{
        const [virtualisedData] = (0, (0, parcelRequire("jlrVi")).useVirtualisedItems)();
        const createItemAnchorIndex = (0, (0, parcelRequire("hGh1Z")).useCreateItemAnchorIndex)();
        const { requiredItems: requiredItems = [], overscanRange: overscanRange } = virtualisedData;
        const getIsVirtual = (flatIndex)=>(flatIndex < overscanRange.start || flatIndex > overscanRange.end) && flatIndex !== createItemAnchorIndex;
        const getIsVirtualOld = (flatIndex)=>flatIndex < overscanRange.start || flatIndex > overscanRange.end;
        const renderedItems = $d1c4dd68c4d10c32$var$renderList({
            items: requiredItems,
            getIsVirtual: (0, (0, parcelRequire("4R6GH")).fg)('timeline_grid_navigation_m2') ? getIsVirtual : getIsVirtualOld,
            parentItem: undefined,
            renderItem: renderItem,
            renderItemContainer: renderItemContainer,
            renderCreateItem: renderCreateItem
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, renderedItems);
    };
    const $d1c4dd68c4d10c32$var$renderList = ({ items: items, getIsVirtual: getIsVirtual, parentItem: parentItem, renderItem: renderItem, renderItemContainer: renderItemContainer, renderCreateItem: renderCreateItem })=>{
        const flatItemElements = [];
        const getItemsToRender = (parentFlatItem, flatItems)=>{
            if (parentFlatItem === undefined) return flatItems.filter(({ meta: meta })=>!meta.parentId);
            return flatItems.filter(({ meta: meta })=>meta.parentId === parentFlatItem.item.id);
        };
        const itemsToRender = getItemsToRender(parentItem, items);
        itemsToRender?.forEach((enrichedItem)=>{
            if (enrichedItem.type === (0, (0, parcelRequire("iZN6h")).ITEM_TYPE)) {
                const itemContainerChildren = [];
                const { item: item, meta: meta, flatIndex: flatIndex } = enrichedItem;
                itemContainerChildren.push(renderItem(item, meta, flatIndex, getIsVirtual(flatIndex)));
                const { isExpanded: isExpanded, isParent: isParent, numChildren: numChildren = 0, ariaRowIndex: ariaRowIndex, topOffset: topOffset, childItemsHeight: childItemsHeight } = meta;
                const parentItemContainerMeta = {
                    parentId: parentItem?.item.id,
                    isExpanded: isExpanded,
                    isParent: isParent,
                    id: item.id,
                    level: item.level,
                    depth: item.depth,
                    ariaRowIndex: ariaRowIndex,
                    topOffset: topOffset,
                    childItemsHeight: childItemsHeight,
                    isInTransition: item.isInTransition
                };
                flatItemElements.push(renderItemContainer(parentItemContainerMeta, 0, itemContainerChildren));
                if (isExpanded && numChildren > 0) {
                    const renderedChildItems = $d1c4dd68c4d10c32$var$renderList({
                        items: items,
                        getIsVirtual: getIsVirtual,
                        parentItem: enrichedItem,
                        renderItem: renderItem,
                        renderItemContainer: renderItemContainer,
                        renderCreateItem: renderCreateItem
                    });
                    flatItemElements.push(...renderedChildItems);
                }
            } else if (enrichedItem.type === (0, (0, parcelRequire("iZN6h")).CREATE_ITEM_TYPE)) flatItemElements.push(renderCreateItem(enrichedItem.id, enrichedItem.anchorItem, enrichedItem.meta));
        });
        return flatItemElements;
    };
    var $d1c4dd68c4d10c32$export$2e2bcd8739ae039 = $d1c4dd68c4d10c32$var$ItemsRenderer;
});
parcelRegister("iNpaX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$180762d2c6c2429a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $4R6GH;
    var $dCm1o;
    var $iZN6h;
    var $WPwAA;
    var $g3prf;
    var $biT18;
    var $1III9;
    var $6Z5oR;
    var $8ZDUa;
    const $180762d2c6c2429a$var$containerStyles = null;
    const $180762d2c6c2429a$var$chartContainerStyles = null;
    const $180762d2c6c2429a$var$ScrollableOverlay = ({ isOverlayInHeader: isOverlayInHeader, renderChartTimelineOverlay: renderChartTimelineOverlay })=>{
        const columnsOverlayElementsRef = (0, $5uXOq.useRef)({});
        const [{ today: today, timelineMode: timelineMode, timelineDuration: timelineDuration, columnDurations: columnDurations, timelineWidth: timelineWidth }] = (0, (0, parcelRequire("biT18")).useTimelineState)();
        const [{ headerHeight: headerHeight }] = (0, (0, parcelRequire("g3prf")).useHeaderState)();
        const [{ isHighlightToday: isHighlightToday }] = (0, (0, parcelRequire("WPwAA")).useEnablements)();
        if (!columnsOverlayElementsRef.current[timelineMode]) columnsOverlayElementsRef.current[timelineMode] = $5uXOq.createElement((0, (0, parcelRequire("1III9")).default), {
            isHighlightToday: isHighlightToday,
            today: today,
            timelineDuration: timelineDuration,
            columnDurations: columnDurations,
            ...(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_2') ? {
                isOverlayInHeader: isOverlayInHeader ?? false,
                subheaderHeight: headerHeight - (0, (0, parcelRequire("iZN6h")).BASE_HEADER_HEIGHT)
            } : {}
        });
        return $5uXOq.createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _1e0c1txw _154iidpf _94n5idpf _1ltvidpf _1bsb1osq _lcxvglyw"
            ])
        }, $5uXOq.createElement((0, (0, parcelRequire("6Z5oR")).default), null), $5uXOq.createElement("div", {
            style: {
                ...isOverlayInHeader ? {
                    position: 'sticky',
                    top: 0
                } : {
                    position: 'relative',
                    top: `${headerHeight}px`,
                    height: `calc(100% - ${headerHeight}px)`
                },
                width: `${timelineWidth}px`
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jlidpf _1o9zidpf _i0dl1wug"
            ])
        }, columnsOverlayElementsRef.current[timelineMode], !isOverlayInHeader && renderChartTimelineOverlay(), !isOverlayInHeader && isHighlightToday && $5uXOq.createElement((0, (0, parcelRequire("8ZDUa")).default), {
            today: today,
            timelineMode: timelineMode,
            timelineDuration: timelineDuration
        })));
    };
    var $180762d2c6c2429a$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($180762d2c6c2429a$var$ScrollableOverlay);
});
parcelRegister("1III9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b31806079c71ac72$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $4R6GH;
    var $dCm1o;
    var $iwcO1;
    var $jKvH8;
    const $b31806079c71ac72$var$ColumnsOverlay = ({ isHighlightToday: isHighlightToday, today: today, timelineDuration: timelineDuration, columnDurations: columnDurations, isOverlayInHeader: isOverlayInHeader, subheaderHeight: subheaderHeight })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jKvH8")).default), {
            isHighlightToday: isHighlightToday,
            columnPositions: (0, (0, parcelRequire("iwcO1")).getColumnPositions)(timelineDuration, columnDurations),
            todayColumnIndex: (0, (0, parcelRequire("iwcO1")).getTodayColumnIndex)(today, columnDurations),
            ...(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_2') ? {
                isOverlayInHeader: isOverlayInHeader,
                subheaderHeight: subheaderHeight
            } : {}
        });
    var $b31806079c71ac72$export$2e2bcd8739ae039 = $b31806079c71ac72$var$ColumnsOverlay;
});
parcelRegister("jKvH8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$091b57fdf9854bbb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $6Ll2T;
    var $99gde;
    var $4R6GH;
    var $dCm1o;
    var $jfF8l;
    const $091b57fdf9854bbb$var$Columns = ({ isHighlightToday: isHighlightToday, todayColumnIndex: todayColumnIndex, columnPositions: columnPositions, isOverlayInHeader: isOverlayInHeader, subheaderHeight: subheaderHeight })=>{
        const visuallyRefreshedContent = (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_2') ? $5uXOq.createElement((0, (0, parcelRequire("6Ll2T")).default), {
            xcss: $091b57fdf9854bbb$var$todayColumnBorderStyles
        }, $5uXOq.createElement((0, (0, parcelRequire("6Ll2T")).default), {
            xcss: [
                isOverlayInHeader ? $091b57fdf9854bbb$var$todayHeaderColumnStyles : $091b57fdf9854bbb$var$todayColumnStyles
            ],
            style: {
                ...isOverlayInHeader && {
                    height: `calc(100% - ${subheaderHeight}px)`
                }
            }
        })) : $5uXOq.createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _vchhusvi _154iidpf _1xi21n1a _1ltv1n1a _4t3i1osq _bfhkiw92 _1kl71xde _1s7z1xde"
            ])
        });
        return $5uXOq.createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _1e0c1txw _154iidpf _1bsb1osq _4t3i1osq _lcxvglyw"
            ])
        }, columnPositions.map(([left, right], index)=>$5uXOq.createElement("div", {
                key: `column-position-${index}`,
                className: (0, (0, parcelRequire("bwpsq")).default)([
                    "_kqswstnw _vchhusvi _16jlidpf _1o9zidpf _i0dl1wug _154iidpf _94n5idpf _1s7z1hum"
                ]),
                style: {
                    left: `${left}%`,
                    right: `${right}%`,
                    "--_1p5ufam": (0, (0, parcelRequire("lD23V")).default)((0, (0, parcelRequire("jfF8l")).secondaryBorder))
                }
            }, todayColumnIndex === index && isHighlightToday ? visuallyRefreshedContent : null)));
    };
    var $091b57fdf9854bbb$export$2e2bcd8739ae039 = $091b57fdf9854bbb$var$Columns;
    const $091b57fdf9854bbb$var$containerStyles = null;
    const $091b57fdf9854bbb$var$columnStyles = null;
    const $091b57fdf9854bbb$var$todayColumnStylesOld = null;
    const $091b57fdf9854bbb$var$todayColumnStyles = (0, (0, parcelRequire("99gde")).xcss)({
        position: 'absolute',
        boxSizing: 'border-box',
        top: '0',
        right: '-1px',
        left: '-1px',
        height: '100%',
        backgroundColor: 'color.background.neutral'
    });
    const $091b57fdf9854bbb$var$todayHeaderColumnStyles = (0, (0, parcelRequire("99gde")).xcss)({
        position: 'absolute',
        boxSizing: 'border-box',
        top: '0',
        right: '-1px',
        left: '-1px',
        backgroundColor: 'color.background.neutral'
    });
    const $091b57fdf9854bbb$var$todayColumnBorderStyles = (0, (0, parcelRequire("99gde")).xcss)({
        position: 'absolute',
        boxSizing: 'border-box',
        top: '0',
        right: '-1px',
        left: '-1px',
        height: '100%',
        borderLeft: `1px solid ${`var(--ds-border, ${(0, $72ba03e317f3d228$export$791e57b27ca738ef)})`}`,
        borderRight: `1px solid ${`var(--ds-border, ${(0, $72ba03e317f3d228$export$791e57b27ca738ef)})`}`
    });
});
parcelRegister("jfF8l", function(module, exports) {
    $parcel$export(module.exports, "secondaryBorderColor", ()=>$e1127bc9a1fd77e3$export$95d9e829dbec7e8b);
    $parcel$export(module.exports, "secondaryBorder", ()=>$e1127bc9a1fd77e3$export$a84a730095edc78);
    const $e1127bc9a1fd77e3$export$12879c7697ed953d = 1;
    const $e1127bc9a1fd77e3$export$95d9e829dbec7e8b = `var(--ds-border, ${(0, $72ba03e317f3d228$export$1ce2d1575d444ceb)})`;
    const $e1127bc9a1fd77e3$export$a84a730095edc78 = `${$e1127bc9a1fd77e3$export$12879c7697ed953d}px solid ${$e1127bc9a1fd77e3$export$95d9e829dbec7e8b}`;
    const $e1127bc9a1fd77e3$export$d1cf5418fbd2830d = 'background-color 100ms linear';
});
parcelRegister("6Z5oR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1f006b9c4cd5a6e5$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $9puhl;
    const $1f006b9c4cd5a6e5$var$containerStyles = null;
    const $1f006b9c4cd5a6e5$var$ListCover = ()=>{
        const [listWidth] = (0, (0, parcelRequire("9puhl")).useListWidth)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            style: {
                width: `${listWidth}px`
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqsw1if8 _16jlidpf _1o9zidpf _i0dl1wug _1ltvidpf _11q7vuon _1pby37uc"
            ])
        });
    };
    var $1f006b9c4cd5a6e5$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($1f006b9c4cd5a6e5$var$ListCover);
});
parcelRegister("8ZDUa", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$00b0778a4e9de6b9$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bFxJH;
    var $d23XT;
    var $8Z2vH;
    const $00b0778a4e9de6b9$var$TodayMarker = ({ today: today, timelineMode: timelineMode, timelineDuration: timelineDuration })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8Z2vH")).default), {
            todayPosition: (0, (0, parcelRequire("d23XT")).getTodayPosition)(today, timelineDuration, (0, (0, parcelRequire("bFxJH")).getTimelineWidth)(timelineMode, timelineDuration.totalMilliseconds))
        });
    var $00b0778a4e9de6b9$export$2e2bcd8739ae039 = $00b0778a4e9de6b9$var$TodayMarker;
});
parcelRegister("d23XT", function(module, exports) {
    $parcel$export(module.exports, "getTodayPosition", ()=>$68f530816a63571f$export$1c4a20ec05eb2ad0);
    var $2gnC5 = parcelRequire("2gnC5");
    const $68f530816a63571f$export$1c4a20ec05eb2ad0 = (today, timelineDuration, timelineWidth)=>{
        const middleOfToday = (0, ($parcel$interopDefault($2gnC5))).utc(today).add(12, 'hour').valueOf();
        const relativePosition = (middleOfToday - timelineDuration.startMilliseconds) / timelineDuration.totalMilliseconds;
        return relativePosition * timelineWidth - 2;
    };
});
parcelRegister("8Z2vH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8bfe7f2a3f57a3af$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $g3prf;
    const $8bfe7f2a3f57a3af$var$MARKER_LINE_WIDTH = 2;
    const $8bfe7f2a3f57a3af$var$POINTER_WIDTH = 4;
    const $8bfe7f2a3f57a3af$var$containerStyles = null;
    const $8bfe7f2a3f57a3af$var$markerStyles = null;
    const $8bfe7f2a3f57a3af$var$pointerStyles = null;
    const $8bfe7f2a3f57a3af$var$TodayMarkerLine = ({ todayPosition: todayPosition })=>{
        const [{ headerHeight: headerHeight }] = (0, (0, parcelRequire("g3prf")).useHeaderState)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "roadmap.timeline-table.main.scrollable-overlay.today-marker.container",
            style: {
                left: `${todayPosition}px`
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _1e0c1txw _154iidpf _94n5idpf _1pbyouyt _lcxvglyw"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            role: "presentation",
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsbyh40 _4t3i1osq _bfhk1sn9"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            style: {
                top: `${headerHeight}px`
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqsw1if8 _1bsbidpf _4t3iidpf _18u0j39m _x3dom65w _1s7z12me _1kl712me"
            ])
        })));
    };
    var $8bfe7f2a3f57a3af$export$2e2bcd8739ae039 = $8bfe7f2a3f57a3af$var$TodayMarkerLine;
});
parcelRegister("d6NhP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$416a82879be86d97$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6Ll2T;
    var $99gde;
    var $biT18;
    var $6MiMm;
    const $416a82879be86d97$var$ChartItemLite = ({ id: id, depth: depth, itemHeight: itemHeight, backgroundColor: backgroundColor, renderChartItemContent: renderChartItemContent })=>{
        const rendererProps = {
            id: id
        };
        const rendererState = {
            isVirtual: true,
            isHovered: false
        };
        const [{ timelineWidth: timelineWidth }] = (0, (0, parcelRequire("biT18")).useTimelineState)();
        const height = (0, (0, parcelRequire("6MiMm")).getContainerHeight)({
            itemHeight: itemHeight,
            depth: depth
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            role: "gridcell",
            tabIndex: -1,
            xcss: $416a82879be86d97$var$chartItemLiteContainerStyles,
            style: {
                width: `${timelineWidth}px`,
                height: height,
                backgroundColor: backgroundColor
            }
        }, renderChartItemContent(rendererProps, rendererState));
    };
    const $416a82879be86d97$var$chartItemLiteContainerStyles = (0, (0, parcelRequire("99gde")).xcss)({
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        overflow: 'hidden'
    });
    var $416a82879be86d97$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($416a82879be86d97$var$ChartItemLite);
});
parcelRegister("6MiMm", function(module, exports) {
    $parcel$export(module.exports, "getContainerHeight", ()=>$fb592467990ecf1e$export$cf6292b4985d86a5);
    var $4R6GH;
    var $dCm1o;
    const $fb592467990ecf1e$export$cf6292b4985d86a5 = ({ itemHeight: itemHeight, depth: depth })=>{
        const height = depth > 0 ? (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_2') ? "var(--ds-space-500, 40px)" : "var(--ds-space-400, 32px)" : `${itemHeight}px`;
        return height;
    };
});
parcelRegister("iFc7j", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9f6cda27f063330d$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $lwMsT;
    var $4R6GH;
    var $iZN6h;
    var $5BWo9;
    var $3ruU1;
    var $ghKWA;
    var $biT18;
    var $kCVTH;
    var $6MiMm;
    const $9f6cda27f063330d$var$itemBaseStyles = null;
    const $9f6cda27f063330d$var$chartItemContainer = null;
    const $9f6cda27f063330d$var$ChartItem = ({ id: id, parentId: parentId, depth: depth, itemHeight: itemHeight, backgroundColor: backgroundColor, renderChartItemContent: renderChartItemContent })=>{
        const [isHovered, setIsHovered] = (0, $5uXOq.useState)(false);
        const { onRowMouseEnter: onRowMouseEnter, onRowMouseLeave: onRowMouseLeave } = (0, (0, parcelRequire("3ruU1")).useSideEffectMarshal)();
        const [{ timelineWidth: timelineWidth }] = (0, (0, parcelRequire("biT18")).useTimelineState)();
        const cellRef = (0, (0, parcelRequire("5BWo9")).useGridCell)(id, (0, (0, parcelRequire("iZN6h")).CHART_COLUMN_COORDINATE));
        let onCellKeyDown;
        if ((0, (0, parcelRequire("4R6GH")).fg)('project_timeline_multi-select_and_checkboxes')) {
            const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
            const { handleKeyDown: handleKeyDown } = (0, (0, parcelRequire("kCVTH")).useItemSelect)(id);
            onCellKeyDown = (0, $5uXOq.useCallback)((event)=>{
                if (event.target === event.currentTarget) {
                    const analyticsEvent = createAnalyticsEvent({
                        action: 'keydown',
                        actionSubject: 'chartItem',
                        actionSubjectId: 'issueChartItem'
                    });
                    handleKeyDown(event, analyticsEvent);
                }
            }, [
                createAnalyticsEvent,
                handleKeyDown
            ]);
        }
        const onMouseEnter = (0, $5uXOq.useCallback)(()=>{
            onRowMouseEnter(id);
            setIsHovered(true);
        }, [
            id,
            onRowMouseEnter
        ]);
        const onMouseLeave = (0, $5uXOq.useCallback)(()=>{
            onRowMouseLeave(id);
            setIsHovered(false);
        }, [
            id,
            onRowMouseLeave
        ]);
        const rendererProps = {
            id: id
        };
        const rendererState = {
            isVirtual: false,
            isHovered: isHovered
        };
        const height = (0, (0, parcelRequire("6MiMm")).getContainerHeight)({
            itemHeight: itemHeight,
            depth: depth
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            ref: cellRef,
            role: "gridcell",
            tabIndex: -1,
            "data-testid": `roadmap.timeline-table.components.chart-item.container-${id}`,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _v564lfip _nt751r31 _49pcglyw _1hvw1o36 _1ejj168b",
                "_kqswh2mm _1reo15vq _18m915vq",
                (0, (0, parcelRequire("ghKWA")).getRowClassName)(id, parentId).className
            ]),
            style: {
                width: `${timelineWidth}px`,
                height: `${height}`,
                backgroundColor: backgroundColor
            },
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onKeyDown: onCellKeyDown,
            ...(0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-row-highlight-bar-focus') ? {
                onFocus: onMouseEnter,
                onBlur: onMouseLeave
            } : {}
        }, renderChartItemContent(rendererProps, rendererState));
    };
    $9f6cda27f063330d$var$ChartItem.displayName = 'ChartItem';
    $9f6cda27f063330d$var$ChartItem.whyDidYouRender = true;
    var $9f6cda27f063330d$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($9f6cda27f063330d$var$ChartItem);
});
parcelRegister("5BWo9", function(module, exports) {
    $parcel$export(module.exports, "useGridCell", ()=>$d785e5aac36d54e8$export$c7e10bfc0c59f67c);
    var $5uXOq = parcelRequire("5uXOq");
    var $4R6GH;
    var $82CeN;
    const $d785e5aac36d54e8$export$c7e10bfc0c59f67c = (rowId, column, isOriginCell = false)=>{
        const element = (0, $5uXOq.useRef)(null);
        const { trackCell: trackCell, untrackCell: untrackCell, focusCell: focusCell, blurCell: blurCell, initialiseRovingCell: initialiseRovingCell } = (0, (0, parcelRequire("82CeN")).useFocusMarshal)();
        const setCellRef = (0, $5uXOq.useCallback)((ref)=>{
            element.current = ref;
        }, []);
        const getData = (0, $5uXOq.useCallback)(()=>({
                rowId: rowId,
                column: column
            }), [
            rowId,
            column
        ]);
        const getContent = (0, $5uXOq.useCallback)(()=>{
            if (!element.current) return [];
            const keyboardFocusable = element.current.querySelectorAll('a[href], button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])');
            return Array.from(keyboardFocusable).filter((e)=>e instanceof HTMLElement && !e.hasAttribute('disabled'));
        }, []);
        const onFocus = (0, $5uXOq.useCallback)((event)=>{
            if (element.current && event.target instanceof HTMLElement) focusCell(element.current, event.target);
        }, [
            focusCell
        ]);
        const onBlur = (0, $5uXOq.useCallback)((event)=>{
            if (event.target instanceof HTMLElement) blurCell(event.target);
        }, [
            blurCell
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!element.current || !(0, (0, parcelRequire("4R6GH")).fg)('timeline_grid_navigation_m2')) return;
            const setup = (safeElement)=>{
                trackCell(safeElement, getData, getContent);
                isOriginCell && initialiseRovingCell(safeElement);
                safeElement.addEventListener('focusin', onFocus);
                safeElement.addEventListener('focusout', onBlur);
                return ()=>{
                    untrackCell(safeElement);
                    safeElement.removeEventListener('focusin', onFocus);
                    safeElement.removeEventListener('focusout', onBlur);
                };
            };
            const cleanup = setup(element.current);
            return ()=>{
                cleanup();
            };
        }, [
            rowId,
            column,
            isOriginCell,
            getData,
            getContent,
            trackCell,
            untrackCell,
            initialiseRovingCell,
            onFocus,
            onBlur
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!element.current || (0, (0, parcelRequire("4R6GH")).fg)('timeline_grid_navigation_m2')) return;
            const setup = (safeElement)=>{
                trackCell(safeElement, getData, ()=>[]);
                isOriginCell && initialiseRovingCell(safeElement);
                return ()=>untrackCell(safeElement);
            };
            const cleanup = setup(element.current);
            return ()=>{
                cleanup();
            };
        }, [
            rowId,
            column,
            isOriginCell,
            getData,
            trackCell,
            untrackCell,
            initialiseRovingCell
        ]);
        return setCellRef;
    };
});
parcelRegister("kCVTH", function(module, exports) {
    $parcel$export(module.exports, "useItemSelect", ()=>$b5f5b1b1288d26b4$export$a7ddc5029ca778e1);
    var $5uXOq = parcelRequire("5uXOq");
    var $4R6GH;
    var $WPwAA;
    var $hGh1Z;
    const $b5f5b1b1288d26b4$export$a7ddc5029ca778e1 = (id)=>{
        const [{ isMultiSelectEnabled: isMultiSelectEnabled, isSelectEnabled: isSelectEnabled }] = (0, (0, parcelRequire("WPwAA")).useEnablements)();
        const [selected = false, { toggleItem: toggleItem, activateItem: activateItem }] = (0, (0, parcelRequire("hGh1Z")).useIsItemSelected)(id);
        const [isItemSelectable = false] = (0, (0, parcelRequire("hGh1Z")).useIsItemSelectable)(id);
        const handleClick = (0, $5uXOq.useCallback)(({ ctrlKey: ctrlKey, metaKey: metaKey, shiftKey: shiftKey, currentTarget: currentTarget }, analyticsEvent, ref)=>{
            const isCheckbox = currentTarget instanceof HTMLInputElement && currentTarget.type === 'checkbox';
            const shouldOnlyToggleItem = isMultiSelectEnabled && (isCheckbox || ctrlKey || metaKey || shiftKey);
            if (shouldOnlyToggleItem && isItemSelectable) return toggleItem(id, {
                analyticsEvent: analyticsEvent,
                withRange: shiftKey
            });
            if (isSelectEnabled && !shouldOnlyToggleItem) return (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps-timeline-bento-refocusing') ? activateItem(id, ref) : activateItem(id);
        }, [
            isSelectEnabled,
            isMultiSelectEnabled,
            activateItem,
            id,
            isItemSelectable,
            toggleItem
        ]);
        const handleKeyDown = (0, $5uXOq.useCallback)(({ shiftKey: shiftKey, ctrlKey: ctrlKey, metaKey: metaKey, altKey: altKey, key: key }, analyticsEvent)=>{
            if (isMultiSelectEnabled && isItemSelectable && shiftKey && key === ' ' && !(ctrlKey || metaKey || altKey)) toggleItem(id, {
                analyticsEvent: analyticsEvent
            });
        }, [
            id,
            isItemSelectable,
            isMultiSelectEnabled,
            toggleItem
        ]);
        return {
            selectable: isItemSelectable,
            selected: selected,
            handleClick: handleClick,
            handleKeyDown: handleKeyDown
        };
    };
});
parcelRegister("kY4b5", function(module, exports) {
    $parcel$export(module.exports, "ItemsBackground", ()=>$c0fd3dbe9b4d507e$export$2473dc1b5c75a4f);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $iZN6h;
    var $hGh1Z;
    var $9puhl;
    var $ghKWA;
    const $c0fd3dbe9b4d507e$var$container = null;
    const $c0fd3dbe9b4d507e$var$sticky = null;
    const $c0fd3dbe9b4d507e$var$widthApproximation = null;
    const $c0fd3dbe9b4d507e$export$2473dc1b5c75a4f = ()=>{
        const [{ itemsBackground: itemsBackground, totalHeight: totalHeight }] = (0, (0, parcelRequire("hGh1Z")).useItemsContainerStyles)();
        const [listWidth] = (0, (0, parcelRequire("9puhl")).useListWidth)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            role: "presentation",
            style: {
                height: `${totalHeight}px`
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqsw1if8 _1ltvidpf _lcxvglyw",
                (0, (0, parcelRequire("ghKWA")).getItemsBackgroundClassName)().className
            ]),
            style: {
                background: itemsBackground,
                width: listWidth,
                zIndex: (0, (0, parcelRequire("iZN6h")).zIndex).LIST
            }
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqsw1if8 _1ltvidpf _lcxvglyw",
                "_1bsbauwl",
                (0, (0, parcelRequire("ghKWA")).getItemsBackgroundClassName)().className
            ]),
            style: {
                background: itemsBackground
            }
        }));
    };
});
parcelRegister("l75uJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3b9acaadbd20ff30$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $biT18;
    var $7ouUj;
    var $bzkdK;
    const $3b9acaadbd20ff30$var$itemBaseStyles = null;
    const $3b9acaadbd20ff30$var$containerStyles = null;
    const $3b9acaadbd20ff30$var$chartCreateItemStyles = null;
    const $3b9acaadbd20ff30$var$CreateItem = ({ id: id, level: level, depth: depth, anchorId: anchorId, canCreateChildOverride: canCreateChildOverride, itemHeight: itemHeight, topOffset: topOffset, ariaRowIndex: ariaRowIndex, backgroundColor: backgroundColor, isActive: isActive, onCreateClick: onCreateClick, renderListItemCreate: renderListItemCreate })=>{
        const [{ timelineWidth: timelineWidth }] = (0, (0, parcelRequire("biT18")).useTimelineState)();
        const createItemBackgroundColor = isActive && (0, (0, parcelRequire("7ouUj")).isRoot)(depth) ? `var(--ds-surface-pressed, ${0, $72ba03e317f3d228$export$1ce2d1575d444ceb})` : backgroundColor;
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "roadmap.timeline-table.main.content.list.create-item.button",
            role: "row",
            "aria-rowindex": ariaRowIndex,
            style: {
                top: `${topOffset}px`,
                height: `${itemHeight}px`
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _v564lfip",
                "_kqswstnw _1bsb1osq"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bzkdK")).default), {
            id: id,
            isActive: isActive,
            anchorId: anchorId,
            canCreateChildOverride: canCreateChildOverride,
            level: level,
            depth: depth,
            itemHeight: itemHeight,
            backgroundColor: backgroundColor,
            onCreateClick: onCreateClick,
            renderListItemCreate: renderListItemCreate
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            style: {
                width: `${timelineWidth}px`,
                height: `${itemHeight}px`,
                backgroundColor: createItemBackgroundColor
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm _16jlidpf _1o9zidpf _i0dl1wug"
            ])
        }));
    };
    var $3b9acaadbd20ff30$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($3b9acaadbd20ff30$var$CreateItem);
});
parcelRegister("bzkdK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d55020d2502d8e47$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $lwMsT;
    var $6Ll2T;
    var $99gde;
    var $5gzbX;
    var $4R6GH;
    var $dCm1o;
    var $iZN6h;
    var $WPwAA;
    var $hGh1Z;
    var $9puhl;
    var $5BWo9;
    var $a7L1o;
    var $hUAzM;
    var $7ouUj;
    const $d55020d2502d8e47$var$listCreateItemCellStylesOld = null;
    const $d55020d2502d8e47$var$listCreateItemCellStyles = (0, (0, parcelRequire("99gde")).xcss)({
        display: 'flex',
        alignItems: 'center',
        position: 'sticky',
        flex: '0 0 auto',
        boxSizing: 'border-box',
        left: 'space.0',
        ':focus': {
            outline: 'none'
        },
        ':focus-visible': {
            outline: `2px solid ${`var(--ds-border-focused, ${(0, $72ba03e317f3d228$export$ecfc1dff386a3e7a)})`}`
        }
    });
    const $d55020d2502d8e47$var$ListCreateItem = ({ id: id, isActive: isActive, anchorId: anchorId, level: level, depth: depth, itemHeight: itemHeight, backgroundColor: backgroundColor, onCreateClick: onCreateClick, renderListItemCreate: renderListItemCreate, canCreateChildOverride: canCreateChildOverride })=>{
        let isMultiSelectEnabled;
        if ((0, (0, parcelRequire("4R6GH")).fg)('project_timeline_multi-select_and_checkboxes')) [{ isMultiSelectEnabled: isMultiSelectEnabled }] = (0, (0, parcelRequire("WPwAA")).useEnablements)();
        const [isListEmpty] = (0, (0, parcelRequire("hGh1Z")).useIsTableEmpty)();
        const [listWidth] = (0, (0, parcelRequire("9puhl")).useListWidth)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const cellRef = (0, (0, parcelRequire("5BWo9")).useGridCell)(id, (0, (0, parcelRequire("iZN6h")).LIST_COLUMN_COORDINATE));
        (0, $5uXOq.useEffect)(()=>{
            if (isListEmpty) onCreateClick({
                position: (0, (0, parcelRequire("iZN6h")).LAST)
            });
        }, []);
        const onClick = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("5gzbX")).default)('timeline-add-item-clicked');
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'issueCreateButton',
                attributes: {
                    position: (0, (0, parcelRequire("iZN6h")).LAST)
                }
            });
            (0, (0, parcelRequire("hUAzM")).fireUIAnalyticsEvent)(analyticsEvent);
            onCreateClick({
                position: (0, (0, parcelRequire("iZN6h")).LAST)
            });
        }, [
            onCreateClick,
            createAnalyticsEvent
        ]);
        const createItemBackgroundColor = isActive && (0, (0, parcelRequire("7ouUj")).isRoot)(depth) ? `var(--ds-surface-pressed, ${0, $72ba03e317f3d228$export$1ce2d1575d444ceb})` : backgroundColor;
        const paddingLeftStyle = !(0, (0, parcelRequire("7ouUj")).isRoot)(depth) ? {
            paddingLeft: `${(0, (0, parcelRequire("a7L1o")).getListContentPaddingLeft)({
                depth: depth,
                ...(0, (0, parcelRequire("4R6GH")).fg)('project_timeline_multi-select_and_checkboxes') && {
                    hasCheckbox: isMultiSelectEnabled
                },
                isCreate: true,
                isParent: false
            })}px`
        } : {};
        return (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_1') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            ref: cellRef,
            role: "gridcell",
            tabIndex: -1,
            paddingInline: "space.050",
            paddingBlock: "space.0",
            xcss: $d55020d2502d8e47$var$listCreateItemCellStyles,
            style: {
                zIndex: (0, (0, parcelRequire("iZN6h")).zIndex).LIST_CREATE_ITEM,
                width: `${listWidth}px`,
                height: `${itemHeight}px`,
                ...paddingLeftStyle,
                backgroundColor: createItemBackgroundColor
            }
        }, renderListItemCreate({
            anchorId: anchorId,
            level: level,
            onClick: onClick,
            canCreateChildOverride: canCreateChildOverride
        }, {
            isActive: isActive
        })) : (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            ref: cellRef,
            role: "gridcell",
            tabIndex: -1,
            style: {
                width: `${listWidth}px`,
                height: `${itemHeight}px`,
                ...paddingLeftStyle,
                backgroundColor: createItemBackgroundColor
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqsw1if8 _1e0c1txw _4cvr1h6o _16jlidpf _1o9zidpf _i0dl1wug _vchhusvi _1ltvidpf _1yt4s8vo _1pbyzo7u _nt751r31 _49pcglyw _1hvw1o36 _1ejj168b"
            ])
        }, renderListItemCreate({
            anchorId: anchorId,
            level: level,
            onClick: onClick,
            canCreateChildOverride: canCreateChildOverride
        }, {
            isActive: isActive
        }));
    };
    var $d55020d2502d8e47$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($d55020d2502d8e47$var$ListCreateItem);
});
parcelRegister("a7L1o", function(module, exports) {
    $parcel$export(module.exports, "getListContentPaddingLeft", ()=>$f6631d4525bf464e$export$ca5712918dfd7d6b);
    var $4R6GH;
    var $dCm1o;
    const $f6631d4525bf464e$var$GRID_SIZE = 8;
    const $f6631d4525bf464e$var$DEFAULT_LIST_CONTENT_PADDING = $f6631d4525bf464e$var$GRID_SIZE * 3;
    const $f6631d4525bf464e$var$NON_BASE_LEVEL_LIST_CONTENT_PADDING = 0;
    const $f6631d4525bf464e$var$DEFAULT_LIST_CREATE_OFFSET = -12;
    const $f6631d4525bf464e$var$CHECKBOX_SPACE = 36;
    const $f6631d4525bf464e$var$CHECKBOX_SPACE_OLD = 32;
    const $f6631d4525bf464e$export$ca5712918dfd7d6b = ({ isCreate: isCreate = false, hasCheckbox: hasCheckbox = false, depth: depth, isParent: isParent, offset: offset })=>{
        let result = depth * $f6631d4525bf464e$var$DEFAULT_LIST_CONTENT_PADDING;
        const checkboxSpace = (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_1') ? $f6631d4525bf464e$var$CHECKBOX_SPACE : $f6631d4525bf464e$var$CHECKBOX_SPACE_OLD;
        if (hasCheckbox) result += checkboxSpace;
        if ((0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)()) result += offset || 0;
        if (isParent) result += $f6631d4525bf464e$var$NON_BASE_LEVEL_LIST_CONTENT_PADDING;
        else result += $f6631d4525bf464e$var$DEFAULT_LIST_CONTENT_PADDING;
        if (isCreate) result += $f6631d4525bf464e$var$DEFAULT_LIST_CREATE_OFFSET;
        return result;
    };
});
parcelRegister("3yTFv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cb1293cd631ffada$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $iZN6h;
    var $WPwAA;
    var $hGh1Z;
    var $bf58Z;
    const $cb1293cd631ffada$var$containerStyles = null;
    const $cb1293cd631ffada$var$DropTarget = ({ id: id, parentId: parentId, level: level, depth: depth, ariaRowIndex: ariaRowIndex, topOffset: topOffset, children: children, itemHeight: itemHeight, childItemsHeight: childItemsHeight, isParent: isParent, isExpanded: isExpanded, isInTransition: isInTransition, onDrop: onDrop, onExpandChanged: onExpandChanged })=>{
        const [{ isTreeDrag: isTreeDrag }] = (0, (0, parcelRequire("WPwAA")).useEnablements)();
        const [setDropRef, clearDropRef] = (0, (0, parcelRequire("bf58Z")).useListDropTarget)({
            id: id,
            level: level,
            depth: depth,
            parentId: parentId,
            isParent: isParent,
            isExpanded: isExpanded,
            isInTransition: isInTransition,
            isTreeDrag: isTreeDrag,
            childItemsHeight: childItemsHeight,
            onDrop: onDrop,
            onExpandChanged: onExpandChanged
        });
        const [isItemSelected] = (0, (0, parcelRequire("hGh1Z")).useIsItemSelected)(id);
        (0, $5uXOq.useEffect)(()=>()=>{
                clearDropRef();
            }, [
            clearDropRef
        ]);
        const height = depth > 0 ? (0, (0, parcelRequire("iZN6h")).BASE_LEVEL_ITEM_HEIGHT)() : itemHeight;
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            role: "row",
            "aria-rowindex": ariaRowIndex,
            "aria-selected": isItemSelected,
            ref: setDropRef,
            style: {
                top: `${topOffset}px`,
                height: `${height}px`
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _1e0c1txw _1bsb1osq"
            ])
        }, children);
    };
    var $cb1293cd631ffada$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($cb1293cd631ffada$var$DropTarget);
});
parcelRegister("bf58Z", function(module, exports) {
    $parcel$export(module.exports, "useListDropTarget", ()=>$e85fc38aaf8ff858$export$4aeed369644ffdbb);
    var $5uXOq = parcelRequire("5uXOq");
    var $aSBAh;
    var $5EOne = parcelRequire("5EOne");
    var $gOxHv = parcelRequire("gOxHv");
    var $iZN6h;
    var $3ruU1;
    var $lGdZu;
    var $a7L1o;
    var $hvBZZ;
    const $e85fc38aaf8ff858$export$4aeed369644ffdbb = ({ id: id, level: level, depth: depth, parentId: parentId, isParent: isParent, isExpanded: isExpanded, isInTransition: isInTransition, isTreeDrag: isTreeDrag, childItemsHeight: childItemsHeight = 0, onDrop: onDrop, onExpandChanged: onExpandChanged })=>{
        const directionRef = (0, $5uXOq.useRef)((0, (0, parcelRequire("iZN6h")).DOWN));
        const cleanupDragAndDrop = (0, $5uXOq.useRef)(null);
        const isDraggedOver = (0, $5uXOq.useRef)(false);
        const timerRef = (0, $5uXOq.useRef)(undefined);
        const instructionRef = (0, $5uXOq.useRef)(null);
        const { onResize: onResize } = (0, (0, parcelRequire("lGdZu")).useTimelineViewportActions)();
        const isDragChildOverParent = (0, $5uXOq.useRef)(false);
        const { onRowDragOver: onRowDragOver, onRowDragChildOverParent: onRowDragChildOverParent, onRowDragChildOverParentEnd: onRowDragChildOverParentEnd } = (0, (0, parcelRequire("3ruU1")).useSideEffectMarshal)();
        const makeDroppable = (0, $5uXOq.useCallback)((dragElement)=>{
            const el = dragElement;
            if (el === null) return;
            const getData = ()=>({
                    id: id,
                    level: level,
                    isInTransition: isInTransition
                });
            const canDrop = ({ source: source })=>{
                const item = source.data;
                return item.type === (0, (0, parcelRequire("iZN6h")).ROW_DRAG_AND_DROP_ID) && !(0, (0, parcelRequire("hvBZZ")).getIsDragParentOverChild)(item.level, level) && isInTransition !== true;
            };
            const onDragEnter = ({ source: source })=>{
                const item = source.data;
                if (item.type === (0, (0, parcelRequire("iZN6h")).ROW_DRAG_AND_DROP_ID) && item.id !== id) {
                    isDraggedOver.current = true;
                    if ((0, (0, parcelRequire("hvBZZ")).getIsDragChildOverParent)(item.level, level)) {
                        onRowDragChildOverParent(item.id, id);
                        if (isParent && !isExpanded) {
                            timerRef.current && clearTimeout(timerRef.current);
                            timerRef.current = setTimeout(()=>{
                                onExpandChanged(id, false);
                                clearTimeout(timerRef.current);
                                timerRef.current = undefined;
                            }, (0, (0, parcelRequire("iZN6h")).DELAY_EXPAND_TIME));
                        }
                    }
                }
            };
            const onDrag = ({ source: source, location: location })=>{
                const item = source.data;
                const { current: { input: current } } = location;
                if (isDraggedOver.current && !(0, (0, parcelRequire("hvBZZ")).getIsDragChildOverParent)(item.level, level)) {
                    const { top: top, bottom: bottom } = el.getBoundingClientRect();
                    const midpoint = top + (bottom - top) / 2;
                    directionRef.current = current.pageY <= midpoint ? (0, (0, parcelRequire("iZN6h")).UP) : (0, (0, parcelRequire("iZN6h")).DOWN);
                    const bottomWithOffset = bottom + childItemsHeight;
                    const relativeTop = directionRef.current === (0, (0, parcelRequire("iZN6h")).DOWN) ? bottomWithOffset : top;
                    onRowDragOver(item.id, relativeTop);
                }
            };
            const onItemDrop = ({ source: source, location: { current: { dropTargets: dropTargets } } })=>{
                const isShallowDrop = dropTargets.length > 0 && dropTargets[0].data.id === id;
                const item = source.data;
                if (item.id !== id && isShallowDrop) {
                    const rankRequest = directionRef.current === (0, (0, parcelRequire("iZN6h")).DOWN) ? {
                        rankAfterId: id
                    } : {
                        rankBeforeId: id
                    };
                    const updateType = (0, (0, parcelRequire("hvBZZ")).getUpdateType)({
                        level: item.level,
                        parentId: item.parentId,
                        id: item.id,
                        depth: item.depth
                    }, {
                        level: level,
                        parentId: parentId,
                        id: id,
                        depth: depth
                    });
                    switch(updateType){
                        case 0, (0, parcelRequire("hvBZZ")).UPDATE_RANK:
                            onDrop(item.id, {
                                level: item.level,
                                rankRequest: rankRequest
                            });
                            break;
                        case 0, (0, parcelRequire("hvBZZ")).UPDATE_PARENT:
                            onDrop(item.id, {
                                level: item.level,
                                parentId: id
                            });
                            break;
                        case 0, (0, parcelRequire("hvBZZ")).UPDATE_RANK_AND_PARENT:
                            onDrop(item.id, {
                                level: item.level,
                                parentId: parentId,
                                rankRequest: rankRequest
                            });
                            break;
                        default:
                            break;
                    }
                }
            };
            const treeGetData = ({ source: source, input: input, element: element })=>{
                const data = {
                    id: id,
                    level: level,
                    isInTransition: isInTransition
                };
                const draggedItem = source.data;
                const dropTarget = {
                    id: id,
                    parentId: parentId,
                    level: level,
                    depth: depth
                };
                const blockedInstructions = (0, (0, parcelRequire("hvBZZ")).getBlockedInstructions)({
                    dropTarget: dropTarget,
                    draggedItem: draggedItem
                });
                return (0, (0, parcelRequire("aSBAh")).attachInstruction)(data, {
                    input: input,
                    element: element,
                    indentPerLevel: (0, (0, parcelRequire("hvBZZ")).INDENT_PER_LEVEL),
                    currentLevel: depth || 0,
                    mode: isParent && isExpanded ? 'expanded' : 'standard',
                    block: blockedInstructions
                });
            };
            const treeCanDrop = ({ source: source })=>source.data.type === (0, (0, parcelRequire("iZN6h")).ROW_DRAG_AND_DROP_ID) && isInTransition !== true;
            const onTreeDrag = ({ source: source, self: self, location: location })=>{
                const { dropTargets: dropTargets } = location.current;
                const item = source.data;
                const dropTarget = dropTargets[0];
                if (dropTarget.data.id === id) {
                    const extractedInstruction = (0, (0, parcelRequire("aSBAh")).extractInstruction)(self.data);
                    if (extractedInstruction?.type !== 'instruction-blocked') {
                        if (extractedInstruction?.type === 'reorder-above' || extractedInstruction?.type === 'reorder-below') {
                            const { top: top, bottom: bottom } = el.getBoundingClientRect();
                            const relativeTop = extractedInstruction?.type === 'reorder-below' ? bottom : top;
                            const paddingLeft = (0, (0, parcelRequire("a7L1o")).getListContentPaddingLeft)({
                                isParent: true,
                                depth: depth
                            });
                            onResize({
                                indicatorLineOffset: paddingLeft
                            });
                            onRowDragOver(item.id, relativeTop, paddingLeft);
                            if (isDragChildOverParent.current) {
                                onRowDragChildOverParentEnd(parentId ?? id);
                                isDragChildOverParent.current = false;
                            }
                        }
                        if (extractedInstruction?.type === 'make-child') {
                            onRowDragChildOverParent(item.id, id);
                            isDragChildOverParent.current = true;
                        }
                        instructionRef.current = extractedInstruction;
                    }
                }
            };
            const onTreeDrop = ({ source: source, location: { current: { dropTargets: dropTargets } } })=>{
                const isShallowDrop = dropTargets.length > 0 && dropTargets[0].data.id === id;
                const item = source.data;
                if (instructionRef.current && item.id !== id && isShallowDrop) {
                    const isReparent = item.parentId !== parentId;
                    switch(instructionRef.current.type){
                        case 'make-child':
                            onDrop(item.id, {
                                level: item.level,
                                parentId: id
                            });
                            if (isDragChildOverParent.current) {
                                onRowDragChildOverParentEnd(id);
                                isDragChildOverParent.current = false;
                            }
                            break;
                        case 'reorder-above':
                        case 'reorder-below':
                            onDrop(item.id, {
                                level: item.level,
                                rankRequest: instructionRef.current.type === 'reorder-above' ? {
                                    rankBeforeId: id
                                } : {
                                    rankAfterId: id
                                },
                                ...isReparent ? {
                                    parentId: parentId
                                } : {}
                            });
                            break;
                        default:
                            break;
                    }
                }
                instructionRef.current = null;
            };
            const onTreeDragEnter = ({ source: source })=>{
                const item = source.data;
                if (item.type === (0, (0, parcelRequire("iZN6h")).ROW_DRAG_AND_DROP_ID) && item.id !== id) {
                    isDraggedOver.current = true;
                    if ((0, (0, parcelRequire("hvBZZ")).getTreeItemIsDragChildOverParent)(item.level, level)) {
                        if (isParent && !isExpanded) {
                            timerRef.current && clearTimeout(timerRef.current);
                            timerRef.current = setTimeout(()=>{
                                onExpandChanged(id, false);
                                clearTimeout(timerRef.current);
                                timerRef.current = undefined;
                            }, (0, (0, parcelRequire("iZN6h")).DELAY_EXPAND_TIME));
                        }
                    }
                }
            };
            const onTreeDropTargetChange = ({ location: location })=>{
                const previousDropTargetId = location.previous?.dropTargets[0]?.data.id;
                if (isDragChildOverParent.current && previousDropTargetId) {
                    onRowDragChildOverParentEnd(previousDropTargetId);
                    isDragChildOverParent.current = false;
                }
            };
            cleanupDragAndDrop.current = (0, $5EOne.combine)((0, $gOxHv.dropTargetForElements)({
                element: el,
                getData: isTreeDrag ? treeGetData : getData,
                canDrop: isTreeDrag ? treeCanDrop : canDrop,
                onDragEnter: isTreeDrag ? onTreeDragEnter : onDragEnter,
                onDrag: isTreeDrag ? onTreeDrag : onDrag,
                onDrop: isTreeDrag ? onTreeDrop : onItemDrop,
                onDragLeave: ()=>{
                    if (isDraggedOver.current || timerRef.current) {
                        isDraggedOver.current = false;
                        clearTimeout(timerRef.current);
                        timerRef.current = undefined;
                    }
                },
                ...isTreeDrag ? {
                    onDropTargetChange: onTreeDropTargetChange
                } : {}
            }));
        }, [
            id,
            level,
            isParent,
            isExpanded,
            isInTransition,
            isTreeDrag,
            parentId,
            depth,
            childItemsHeight,
            onExpandChanged,
            onRowDragOver,
            onRowDragChildOverParent,
            onDrop,
            onResize,
            onRowDragChildOverParentEnd
        ]);
        const cleanupDroppable = (0, $5uXOq.useCallback)(()=>{
            cleanupDragAndDrop.current?.();
        }, []);
        return [
            makeDroppable,
            cleanupDroppable
        ];
    };
});
parcelRegister("aSBAh", function(module, exports) {
    $parcel$export(module.exports, "attachInstruction", ()=>$89c899db826cdb59$export$267ad49d812c2c7f);
    $parcel$export(module.exports, "extractInstruction", ()=>$89c899db826cdb59$export$c8ffecbe249dc8f8);
    const $89c899db826cdb59$var$uniqueKey = Symbol('tree-item-instruction');
    function $89c899db826cdb59$var$getCenter(rect) {
        return {
            x: (rect.right + rect.left) / 2,
            y: (rect.bottom + rect.top) / 2
        };
    }
    function $89c899db826cdb59$var$standardHitbox({ client: client, borderBox: borderBox }) {
        const quarterOfHeight = borderBox.height / 4;
        if (client.y <= borderBox.top + quarterOfHeight) return 'reorder-above';
        if (client.y >= borderBox.bottom - quarterOfHeight) return 'reorder-below';
        return 'make-child';
    }
    function $89c899db826cdb59$var$getInstruction({ element: element, input: input, currentLevel: currentLevel, indentPerLevel: indentPerLevel, mode: mode }) {
        const client = {
            x: input.clientX,
            y: input.clientY
        };
        const borderBox = element.getBoundingClientRect();
        if (mode === 'standard') {
            const type = $89c899db826cdb59$var$standardHitbox({
                borderBox: borderBox,
                client: client
            });
            return {
                type: type,
                indentPerLevel: indentPerLevel,
                currentLevel: currentLevel
            };
        }
        const center = $89c899db826cdb59$var$getCenter(borderBox);
        if (mode === 'expanded') {
            const type = $89c899db826cdb59$var$standardHitbox({
                borderBox: borderBox,
                client: client
            });
            return {
                type: type === 'reorder-above' ? type : 'make-child',
                indentPerLevel: indentPerLevel,
                currentLevel: currentLevel
            };
        }
        const visibleInset = indentPerLevel * currentLevel;
        if (client.x < borderBox.left + visibleInset) {
            if (client.y < center.y) return {
                type: 'reorder-above',
                indentPerLevel: indentPerLevel,
                currentLevel: currentLevel
            };
            const rawLevel = (client.x - borderBox.left) / indentPerLevel;
            const desiredLevel = Math.max(Math.floor(rawLevel), 0);
            return {
                type: 'reparent',
                desiredLevel: desiredLevel,
                indentPerLevel: indentPerLevel,
                currentLevel: currentLevel
            };
        }
        return {
            type: $89c899db826cdb59$var$standardHitbox({
                borderBox: borderBox,
                client: client
            }),
            indentPerLevel: indentPerLevel,
            currentLevel: currentLevel
        };
    }
    function $89c899db826cdb59$var$isShallowEqual(a, b) {
        const aKeys = Object.keys(a).sort();
        const bKeys = Object.keys(b).sort();
        if (aKeys.length !== bKeys.length) return false;
        return aKeys.every((key)=>a[key] === b[key]);
    }
    function $89c899db826cdb59$var$areInstructionsEqual(a, b) {
        if (a.type !== b.type) return false;
        if (a.type === 'instruction-blocked' && b.type === 'instruction-blocked') return $89c899db826cdb59$var$areInstructionsEqual(a.desired, b.desired);
        return $89c899db826cdb59$var$isShallowEqual(a, b);
    }
    const $89c899db826cdb59$var$memoizeInstruction = (()=>{
        let last = null;
        return (instruction)=>{
            if (last && $89c899db826cdb59$var$areInstructionsEqual(last, instruction)) return last;
            last = instruction;
            return instruction;
        };
    })();
    function $89c899db826cdb59$var$applyInstructionBlock({ desired: desired, block: block }) {
        if (block?.includes(desired.type) && desired.type !== 'instruction-blocked') {
            const blocked = {
                type: 'instruction-blocked',
                desired: desired
            };
            return blocked;
        }
        return desired;
    }
    function $89c899db826cdb59$export$267ad49d812c2c7f(userData, { block: block, ...rest }) {
        const desired = $89c899db826cdb59$var$getInstruction(rest);
        const withBlock = $89c899db826cdb59$var$applyInstructionBlock({
            desired: desired,
            block: block
        });
        const memoized = $89c899db826cdb59$var$memoizeInstruction(withBlock);
        return {
            ...userData,
            [$89c899db826cdb59$var$uniqueKey]: memoized
        };
    }
    function $89c899db826cdb59$export$c8ffecbe249dc8f8(userData) {
        return userData[$89c899db826cdb59$var$uniqueKey] ?? null;
    }
});
parcelRegister("hvBZZ", function(module, exports) {
    $parcel$export(module.exports, "UPDATE_RANK", ()=>$5caf6c2fa64366cf$export$576ea426c903d7e1);
    $parcel$export(module.exports, "UPDATE_PARENT", ()=>$5caf6c2fa64366cf$export$44bc1fe1c2a61c81);
    $parcel$export(module.exports, "UPDATE_RANK_AND_PARENT", ()=>$5caf6c2fa64366cf$export$14628ae53fe631c7);
    $parcel$export(module.exports, "INDENT_PER_LEVEL", ()=>$5caf6c2fa64366cf$export$130b26c73bb9d040);
    $parcel$export(module.exports, "getUpdateType", ()=>$5caf6c2fa64366cf$export$df2aa842dc5172b0);
    $parcel$export(module.exports, "getIsDragChildOverParent", ()=>$5caf6c2fa64366cf$export$64e82cf96e63ddf2);
    $parcel$export(module.exports, "getIsDragParentOverChild", ()=>$5caf6c2fa64366cf$export$fa3830d8bd814624);
    $parcel$export(module.exports, "getTreeItemIsDragChildOverParent", ()=>$5caf6c2fa64366cf$export$466f5fb38504576b);
    $parcel$export(module.exports, "getBlockedInstructions", ()=>$5caf6c2fa64366cf$export$44539271c2e3abc8);
    var $7ouUj;
    const $5caf6c2fa64366cf$export$576ea426c903d7e1 = 'UPDATE_RANK';
    const $5caf6c2fa64366cf$export$44bc1fe1c2a61c81 = 'UPDATE_PARENT';
    const $5caf6c2fa64366cf$export$14628ae53fe631c7 = 'UPDATE_RANK_AND_PARENT';
    const $5caf6c2fa64366cf$export$5b388ccfa29be01 = -1;
    const $5caf6c2fa64366cf$export$130b26c73bb9d040 = 25;
    const $5caf6c2fa64366cf$export$df2aa842dc5172b0 = (draggedItem, dropTarget)=>{
        if (draggedItem.level === dropTarget.level) {
            if ((0, (0, parcelRequire("7ouUj")).isBaseLevel)(draggedItem.level) && dropTarget.parentId !== draggedItem.parentId) return $5caf6c2fa64366cf$export$14628ae53fe631c7;
            return $5caf6c2fa64366cf$export$576ea426c903d7e1;
        }
        if ((0, (0, parcelRequire("7ouUj")).isBaseLevel)(draggedItem.level) && !(0, (0, parcelRequire("7ouUj")).isBaseLevel)(dropTarget.level) && dropTarget.id !== draggedItem.parentId) return $5caf6c2fa64366cf$export$44bc1fe1c2a61c81;
        return undefined;
    };
    const $5caf6c2fa64366cf$export$64e82cf96e63ddf2 = (itemLevel, overItemLevel)=>(0, (0, parcelRequire("7ouUj")).isBaseLevel)(itemLevel) && !(0, (0, parcelRequire("7ouUj")).isBaseLevel)(overItemLevel);
    const $5caf6c2fa64366cf$export$fa3830d8bd814624 = (itemLevel, overItemLevel)=>!(0, (0, parcelRequire("7ouUj")).isBaseLevel)(itemLevel) && (0, (0, parcelRequire("7ouUj")).isBaseLevel)(overItemLevel);
    const $5caf6c2fa64366cf$export$466f5fb38504576b = (draggedItemLevel, dropTargetLevel)=>dropTargetLevel - draggedItemLevel === 1;
    const $5caf6c2fa64366cf$export$244c1f40d1decdb6 = (draggedItemLevel, dropTargetLevel)=>dropTargetLevel - draggedItemLevel === 0 || dropTargetLevel - draggedItemLevel === 1;
    const $5caf6c2fa64366cf$export$98df7fcf26a10604 = (draggedItemLevel, dropTargetLevel)=>dropTargetLevel === draggedItemLevel;
    const $5caf6c2fa64366cf$export$df097d1d7a83adbb = (draggedItemLevel, dropTargetLevel)=>dropTargetLevel - draggedItemLevel === 1;
    const $5caf6c2fa64366cf$export$44539271c2e3abc8 = ({ dropTarget: dropTarget, draggedItem: draggedItem })=>{
        const { level: dropTargetLevel, parentId: dropTargetParentId } = dropTarget;
        const { level: draggedItemLevel } = draggedItem;
        const isOnSameLevel = $5caf6c2fa64366cf$export$98df7fcf26a10604(draggedItemLevel, dropTargetLevel);
        const isWithinOneLevel = $5caf6c2fa64366cf$export$244c1f40d1decdb6(draggedItemLevel, dropTargetLevel);
        const isOneLevelBelow = $5caf6c2fa64366cf$export$df097d1d7a83adbb(draggedItemLevel, dropTargetLevel);
        const isSubTask = draggedItemLevel === $5caf6c2fa64366cf$export$5b388ccfa29be01;
        if (isOnSameLevel) return [
            'make-child'
        ];
        if (!isWithinOneLevel) {
            if (dropTargetParentId || isSubTask) return [
                'make-child',
                'reorder-below',
                'reorder-above'
            ];
            return [
                'make-child'
            ];
        }
        if (isOneLevelBelow) {
            if (isSubTask) return [
                'reorder-below',
                'reorder-above'
            ];
            if (dropTargetParentId) return [
                'reorder-below',
                'reorder-above'
            ];
        }
        return [];
    };
});
parcelRegister("6lHwb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$02b304f1b298804c$export$2e2bcd8739ae039);
    var $bwpsq;
    var $lD23V;
    var $5uXOq = parcelRequire("5uXOq");
    var $hGh1Z;
    var $9puhl;
    var $biT18;
    var $jfF8l;
    const $02b304f1b298804c$var$listEmptyContentStyles = null;
    const $02b304f1b298804c$var$bottomBorderContainerStyles = null;
    const $02b304f1b298804c$var$listBottomBorderStyles = null;
    const $02b304f1b298804c$var$chartBottomBorderStyles = null;
    const $02b304f1b298804c$var$Footer = ({ renderListEmptyContent: renderListEmptyContent })=>{
        const [isTableEmpty] = (0, (0, parcelRequire("hGh1Z")).useIsTableEmpty)();
        const [{ timelineWidth: timelineWidth }] = (0, (0, parcelRequire("biT18")).useTimelineState)();
        const [listWidth] = (0, (0, parcelRequire("9puhl")).useListWidth)();
        return isTableEmpty ? (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            style: {
                width: `${listWidth}px`
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqsw1if8 _1ltvidpf _1pby1406"
            ])
        }, renderListEmptyContent()) : (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm _1e0c1txw _1bsb1osq _4t3it94y"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqsw1if8 _16jlidpf _1o9zidpf _i0dl1wug _1ltvidpf _4t3it94y _bfhk14l7 _1pby1406"
            ]),
            style: {
                width: `${listWidth}px`,
                "--_drom5x": (0, (0, parcelRequire("lD23V")).default)((0, (0, parcelRequire("jfF8l")).secondaryBorderColor))
            }
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm _16jlidpf _1o9zidpf _i0dl1wug _4t3it94y _bfhk14l7"
            ]),
            style: {
                width: `${timelineWidth}px`,
                "--_drom5x": (0, (0, parcelRequire("lD23V")).default)((0, (0, parcelRequire("jfF8l")).secondaryBorderColor))
            }
        }));
    };
    var $02b304f1b298804c$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($02b304f1b298804c$var$Footer);
});
parcelRegister("fepzL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$48c9da01ac495983$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $iZN6h;
    var $9puhl;
    var $a7L1o;
    const $48c9da01ac495983$var$listItemLiteCellStyles = null;
    const $48c9da01ac495983$var$ListItemLite = ({ id: id, depth: depth, itemHeight: itemHeight, backgroundColor: backgroundColor, renderListItemContent: renderListItemContent, renderListItemSecondaryContent: renderListItemSecondaryContent })=>{
        const [listWidth] = (0, (0, parcelRequire("9puhl")).useListWidth)();
        const rendererProps = {
            id: id
        };
        const rendererState = {
            isVirtual: true,
            isHoveredOrFocused: false
        };
        const height = depth > 0 ? (0, (0, parcelRequire("iZN6h")).BASE_LEVEL_ITEM_HEIGHT)() : itemHeight;
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            role: "gridcell",
            tabIndex: -1,
            style: {
                width: `${listWidth}px`,
                height: `${height}px`,
                paddingLeft: `${(0, (0, parcelRequire("a7L1o")).getListContentPaddingLeft)({
                    isParent: false,
                    depth: depth
                })}px`,
                backgroundColor: backgroundColor
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqsw1if8 _1e0c1txw _vchhusvi _4cvr1h6o _16jlidpf _1o9zidpf _i0dl1wug _1ltvidpf _u5f3u2gc _1reo15vq _18m915vq _1pby1406"
            ])
        }, renderListItemContent(rendererProps, rendererState), renderListItemSecondaryContent(rendererProps, rendererState));
    };
    var $48c9da01ac495983$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($48c9da01ac495983$var$ListItemLite);
});
parcelRegister("jIXeo", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0fd87eb677e3673f$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $koVbs;
    var $lwMsT;
    var $6Ll2T;
    var $99gde;
    var $5gzbX;
    var $113Tq;
    var $6s1PB;
    var $4R6GH;
    var $dCm1o;
    var $iZN6h;
    var $hGh1Z;
    var $9puhl;
    var $82CeN;
    var $5BWo9;
    var $3ruU1;
    var $ghKWA;
    var $a7L1o;
    var $hUAzM;
    var $1YcpO;
    var $kCVTH;
    var $df6UD;
    var $4Rpjg;
    var $hQYX7;
    var $e3R1o;
    var $jU4rh;
    var $3euyd;
    var $4vwx2;
    var $bNMH3;
    const $0fd87eb677e3673f$var$secondaryContentStyles = null;
    const $0fd87eb677e3673f$var$listItemContainerStyles = null;
    const $0fd87eb677e3673f$var$getCursor = (isInTransition, isSelectEnabled)=>{
        if (isInTransition) return 'not-allowed';
        if (isSelectEnabled) return 'pointer';
        return 'default';
    };
    const $0fd87eb677e3673f$var$PADDING_LEFT_INCREMENT = 12;
    const $0fd87eb677e3673f$var$ListItem = ({ id: id, parentId: parentId, level: level, depth: depth, itemHeight: itemHeight, backgroundColor: backgroundColor, ariaControls: ariaControls, isParent: isParent, isExpanded: isExpanded, isDragEnabled: isDragEnabled, isInTransition: isInTransition, isSelectEnabled: isSelectEnabled, isMultiSelectEnabled: isMultiSelectEnabled, isCreateChildEnabled: isCreateChildEnabled, isCreateSiblingEnabled: isCreateSiblingEnabled, isMeatballsButtonEnabled: isMeatballsButtonEnabled, onSelect: onSelect, onDrop: onDrop, onExpandChanged: onExpandChanged, onInlineCreateClicked: onInlineCreateClicked, renderListItemContent: renderListItemContent, renderListItemSecondaryContent: renderListItemSecondaryContent, renderListItemMenuOption: renderListItemMenuOption, renderListItemModal: renderListItemModal })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const sideEffectMarshal = (0, (0, parcelRequire("3ruU1")).useSideEffectMarshal)();
        const [listWidth] = (0, (0, parcelRequire("9puhl")).useListWidth)();
        const [isHoveredOrFocused, setIsHoveredOrFocused] = (0, $5uXOq.useState)(false);
        const [isMenuOpen, setIsMenuOpen] = (0, $5uXOq.useState)(false);
        const isContainerInFocus = (0, $5uXOq.useRef)(false);
        const element = (0, $5uXOq.useRef)(null);
        const cellRef = (0, (0, parcelRequire("5BWo9")).useGridCell)(id, (0, (0, parcelRequire("iZN6h")).LIST_COLUMN_COORDINATE));
        const isFocused = (0, $5uXOq.useRef)(false);
        const [isActive] = (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline_table_meatballs_menu_a11y') ? (0, (0, parcelRequire("hGh1Z")).useIsItemActive)(id) : [
            false
        ];
        const { selectable: selectable, selected: selected, handleClick: handleClick, handleKeyDown: handleKeyDown } = (()=>{
            if ((0, (0, parcelRequire("4R6GH")).fg)('project_timeline_multi-select_and_checkboxes')) return (0, (0, parcelRequire("kCVTH")).useItemSelect)(id);
            const [isItemSelected = false] = (0, (0, parcelRequire("hGh1Z")).useIsItemSelected)(id);
            return {
                selectable: false,
                selected: isItemSelected,
                handleClick: (0, ($parcel$interopDefault($8Rkzz))),
                handleKeyDown: (0, ($parcel$interopDefault($8Rkzz)))
            };
        })();
        const { onRowMouseEnter: onRowMouseEnter, onRowMouseLeave: onRowMouseLeave, onRowFocus: onRowFocus, onRowBlur: onRowBlur } = sideEffectMarshal;
        const [isActiveCreateChildTrigger] = (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline_table_meatballs_menu_a11y') ? (0, (0, parcelRequire("82CeN")).useIsCreateTriggerActive)({
            id: id,
            type: 'CHILD'
        }) : [
            false
        ];
        const canDrag = isDragEnabled && !isInTransition;
        const [makeDraggable, cleanupDraggable] = (0, (0, parcelRequire("bNMH3")).default)({
            id: id,
            level: level,
            depth: depth,
            parentId: parentId,
            canDrag: canDrag,
            sideEffectMarshal: sideEffectMarshal
        });
        (0, $5uXOq.useEffect)(()=>{
            makeDraggable(element.current);
            return ()=>{
                cleanupDraggable();
            };
        }, [
            makeDraggable,
            cleanupDraggable
        ]);
        const onHoverOrFocus = (0, $5uXOq.useCallback)(()=>{
            onRowMouseEnter(id);
            setIsHoveredOrFocused(true);
        }, [
            id,
            onRowMouseEnter
        ]);
        const onStopHoverOrFocus = (0, $5uXOq.useCallback)(()=>{
            if (isFocused.current && (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline_table_meatballs_menu_a11y')) {
                onRowBlur(id);
                isFocused.current = false;
            }
            onRowMouseLeave(id);
            setIsMenuOpen(false);
            setIsHoveredOrFocused(false);
        }, [
            id,
            onRowMouseLeave,
            onRowBlur
        ]);
        const onFocus = (0, $5uXOq.useCallback)(()=>{
            onRowFocus(id);
            onHoverOrFocus();
            isFocused.current = true;
        }, [
            id,
            onHoverOrFocus,
            onRowFocus
        ]);
        const onContainerBlurOld = (0, $5uXOq.useCallback)(({ relatedTarget: relatedTarget })=>{
            if (!element.current?.contains(relatedTarget) && !isContainerInFocus.current) onStopHoverOrFocus();
            isContainerInFocus.current = false;
        }, [
            onStopHoverOrFocus
        ]);
        const onContainerBlur = (0, $5uXOq.useCallback)(({ relatedTarget: relatedTarget })=>{
            if (!element.current?.contains(relatedTarget)) onStopHoverOrFocus();
        }, [
            onStopHoverOrFocus
        ]);
        const onContainerClickOld = (0, $5uXOq.useCallback)((event)=>{
            const { timeStamp: timeStamp, metaKey: metaKey, ctrlKey: ctrlKey, shiftKey: shiftKey } = event;
            (0, (0, parcelRequire("5gzbX")).default)('timeline-item-clicked', timeStamp);
            const withCmd = ctrlKey || metaKey;
            const withShift = shiftKey;
            onSelect(id, {
                level: level,
                withCmd: withCmd,
                withShift: withShift,
                depth: depth
            });
        }, [
            id,
            level,
            depth,
            onSelect
        ]);
        const onContainerClickNew = (0, $5uXOq.useCallback)((event)=>{
            const { timeStamp: timeStamp, metaKey: metaKey, ctrlKey: ctrlKey, shiftKey: shiftKey } = event;
            (0, (0, parcelRequire("5gzbX")).default)('timeline-item-clicked', timeStamp);
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'listItem',
                actionSubjectId: 'issueListItem',
                attributes: {
                    level: level,
                    depth: depth,
                    withCmd: ctrlKey || metaKey,
                    withShift: shiftKey
                }
            });
            (0, (0, parcelRequire("hUAzM")).fireUIAnalyticsEvent)(analyticsEvent);
            (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps-timeline-bento-refocusing') ? handleClick(event, analyticsEvent, element) : handleClick(event, analyticsEvent);
        }, [
            createAnalyticsEvent,
            level,
            depth,
            handleClick
        ]);
        const onContainerClick = (0, (0, parcelRequire("4R6GH")).fg)('project_timeline_multi-select_and_checkboxes') ? onContainerClickNew : onContainerClickOld;
        const onSelectCheckboxToggle = (0, $5uXOq.useCallback)((event)=>{
            const { timeStamp: timeStamp, shiftKey: shiftKey } = event;
            (0, (0, parcelRequire("5gzbX")).default)('timeline-item-select-checkbox-toggled', timeStamp);
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'checkbox',
                actionSubjectId: 'issueListItemSelect',
                attributes: {
                    level: level,
                    depth: depth,
                    withShift: shiftKey
                }
            });
            (0, (0, parcelRequire("hUAzM")).fireUIAnalyticsEvent)(analyticsEvent);
            handleClick(event, analyticsEvent);
        }, [
            createAnalyticsEvent,
            depth,
            handleClick,
            level
        ]);
        const onContainerMouseLeave = (0, $5uXOq.useCallback)(()=>{
            if (!element.current?.contains(document.activeElement)) onStopHoverOrFocus();
        }, [
            onStopHoverOrFocus
        ]);
        const onContainerMouseDown = (0, $5uXOq.useCallback)(()=>{
            isContainerInFocus.current = true;
        }, []);
        let onContainerKeyDown = (0, $5uXOq.useCallback)((event)=>{
            if ((0, (0, parcelRequire("1YcpO")).isEnterOrSpaceKey)(event) && !(0, (0, parcelRequire("1YcpO")).isBubbledEvent)(event)) {
                event.preventDefault();
                onContainerClick(event);
            }
        }, [
            onContainerClick
        ]);
        if ((0, (0, parcelRequire("4R6GH")).fg)('timeline_grid_navigation_m2')) onContainerKeyDown = undefined;
        if ((0, (0, parcelRequire("4R6GH")).fg)('project_timeline_multi-select_and_checkboxes')) onContainerKeyDown = (0, $5uXOq.useCallback)((event)=>{
            if (event.target === event.currentTarget) {
                const analyticsEvent = createAnalyticsEvent({
                    action: 'keydown',
                    actionSubject: 'listItem',
                    actionSubjectId: 'issueListItem'
                });
                handleKeyDown(event, analyticsEvent);
            }
        }, [
            createAnalyticsEvent,
            handleKeyDown
        ]);
        const setItemRef = (0, $5uXOq.useCallback)((ref)=>{
            element.current = ref;
            cellRef(ref);
        }, [
            cellRef
        ]);
        const rendererProps = {
            id: id
        };
        const rendererState = {
            isVirtual: false,
            isHoveredOrFocused: isHoveredOrFocused
        };
        const renderSecondaryContent = ()=>{
            if (isInTransition) return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: (0, (0, parcelRequire("bwpsq")).default)([
                    "_1e0c116y _4cvr1h6o _18u01b66"
                ])
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("113Tq")).default), {
                size: "small",
                testId: `roadmap.timeline-table.components.list-item.spinner.${id}`
            }));
            return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: (0, (0, parcelRequire("bwpsq")).default)([
                    "_1e0c116y _4cvr1h6o _18u01b66"
                ])
            }, renderListItemSecondaryContent(rendererProps, rendererState), renderListItemMenuOption && isMeatballsButtonEnabled && (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (isCreateChildEnabled && isHoveredOrFocused || isActiveCreateChildTrigger) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("df6UD")).default), {
                parentId: id,
                label: formatMessage((0, (0, parcelRequire("3euyd")).default).createChild),
                onInlineCreateClicked: onInlineCreateClicked,
                isVisible: !isActiveCreateChildTrigger
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jU4rh")).default), {
                isTriggerVisible: isHoveredOrFocused,
                isMenuOpen: isMenuOpen,
                id: id,
                level: level,
                depth: depth,
                parentId: parentId,
                isCreateChildEnabled: isCreateChildEnabled,
                isCreateSiblingEnabled: isCreateSiblingEnabled,
                renderListItemMenuOption: renderListItemMenuOption,
                renderListItemModal: renderListItemModal,
                onStopHoverOrFocus: onStopHoverOrFocus,
                onInlineCreateClicked: onInlineCreateClicked,
                onDrop: onDrop,
                setIsMenuOpen: setIsMenuOpen,
                cellRef: element
            })));
        };
        const renderSecondaryContentOld = ()=>{
            let innerElement;
            if (isInTransition) innerElement = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("113Tq")).default), {
                size: "small",
                testId: `roadmap.timeline-table.components.list-item.spinner.${id}`
            });
            else if (isCreateChildEnabled) innerElement = isHoveredOrFocused ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("df6UD")).default), {
                parentId: id,
                label: formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("3euyd")).default).createChildIssueTermRefresh : (0, (0, parcelRequire("3euyd")).default).createChild),
                onInlineCreateClicked: onInlineCreateClicked
            }) : null;
            if (innerElement) return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: (0, (0, parcelRequire("bwpsq")).default)([
                    "_1e0c116y _4cvr1h6o _18u01b66"
                ])
            }, innerElement);
            return renderListItemSecondaryContent(rendererProps, rendererState);
        };
        const height = depth > 0 ? (0, (0, parcelRequire("iZN6h")).BASE_LEVEL_ITEM_HEIGHT)() : itemHeight;
        const listContentPaddingLeft = (0, (0, parcelRequire("a7L1o")).getListContentPaddingLeft)({
            isParent: isParent,
            depth: depth,
            ...(0, (0, parcelRequire("4R6GH")).fg)('project_timeline_multi-select_and_checkboxes') && {
                hasCheckbox: isMultiSelectEnabled
            },
            offset: !isMultiSelectEnabled && (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? $0fd87eb677e3673f$var$PADDING_LEFT_INCREMENT : undefined
        });
        const ExpandComponent = (0, (0, parcelRequire("4R6GH")).fg)('timeline_grid_navigation_m2') ? (0, (0, parcelRequire("e3R1o")).default) : (0, (0, parcelRequire("hQYX7")).default);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            id: id,
            "data-testid": `roadmap.timeline-table.components.list-item.container-${id}`,
            role: "gridcell",
            tabIndex: -1,
            ref: setItemRef,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqsw1if8 _1ltvidpf _1e0c1txw _4cvr1h6o _vchhusvi _u5f3u2gc _v564lfip _nt751r31 _49pcglyw _1hvw1o36 _1ejj168b",
                (0, (0, parcelRequire("ghKWA")).getRowClassName)(id, parentId).className
            ]),
            style: {
                width: `${listWidth}px`,
                height: `${height}px`,
                backgroundColor: backgroundColor,
                paddingLeft: `${listContentPaddingLeft}px`,
                zIndex: isMenuOpen && (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline_table_meatballs_menu_a11y') ? (0, (0, parcelRequire("iZN6h")).zIndex).PORTAL : (0, (0, parcelRequire("iZN6h")).zIndex).LIST,
                cursor: $0fd87eb677e3673f$var$getCursor(isInTransition, isSelectEnabled)
            },
            onClick: isSelectEnabled && !isInTransition ? onContainerClick : undefined,
            onKeyDown: onContainerKeyDown,
            onMouseEnter: onHoverOrFocus,
            onMouseLeave: (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline_table_meatballs_menu_a11y') ? onContainerMouseLeave : onStopHoverOrFocus,
            ...!(0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline_table_meatballs_menu_a11y') && {
                onMouseDown: onContainerMouseDown
            },
            onFocus: (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline_table_meatballs_menu_a11y') ? onFocus : onHoverOrFocus,
            onBlur: (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline_table_meatballs_menu_a11y') ? onContainerBlur : onContainerBlurOld
        }, isSelectEnabled && (selected || isActive) && isMenuOpen && (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline_table_meatballs_menu_a11y') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            xcss: $0fd87eb677e3673f$var$borderOverlayStyles
        }) : null, isMultiSelectEnabled && (0, (0, parcelRequire("4R6GH")).fg)('project_timeline_multi-select_and_checkboxes') && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            xcss: [
                (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_1') ? $0fd87eb677e3673f$var$checkboxWrapperStyles : $0fd87eb677e3673f$var$checkboxWrapperStylesOld
            ]
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4vwx2")).default), {
            id: id,
            isChecked: selected,
            isDisabled: !selectable,
            onToggle: onSelectCheckboxToggle
        })), isCreateSiblingEnabled && !(0, (0, parcelRequire("4R6GH")).fg)('timeline_grid_navigation_m2') && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4Rpjg")).default), {
            id: id,
            level: level,
            depth: depth,
            parentId: parentId,
            label: formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("3euyd")).default).createSiblingIssueTermRefresh : (0, (0, parcelRequire("3euyd")).default).createSibling),
            onInlineCreateClicked: onInlineCreateClicked
        }), isParent && (0, ($parcel$interopDefault($5uXOq))).createElement(ExpandComponent, {
            id: id,
            label: isExpanded && !(0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-post-project-a11y-fix') ? formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("3euyd")).default).collapseIssueTermRefresh : (0, (0, parcelRequire("3euyd")).default).collapse) : formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("3euyd")).default).expandIssueTermRefresh : (0, (0, parcelRequire("3euyd")).default).expand),
            isExpanded: isExpanded,
            isRichContentEnabled: isHoveredOrFocused,
            onExpandChanged: onExpandChanged,
            ariaControls: ariaControls
        }), renderListItemContent(rendererProps, rendererState), (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline_table_meatballs_menu_a11y') ? renderSecondaryContent() : renderSecondaryContentOld(), isCreateSiblingEnabled && (0, (0, parcelRequire("4R6GH")).fg)('timeline_grid_navigation_m2') && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4Rpjg")).default), {
            id: id,
            level: level,
            depth: depth,
            parentId: parentId,
            label: formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("3euyd")).default).createSiblingIssueTermRefresh : (0, (0, parcelRequire("3euyd")).default).createSibling),
            onInlineCreateClicked: onInlineCreateClicked
        }));
    };
    const $0fd87eb677e3673f$var$borderOverlayStyles = (0, (0, parcelRequire("99gde")).xcss)({
        width: '100%',
        height: '100%',
        position: 'absolute',
        top: '0',
        left: '0',
        pointerEvents: 'none',
        borderLeft: `1px solid ${"var(--ds-border, #091E4224)"}`,
        borderRight: `2px solid ${"var(--ds-border, #091E4224)"}`
    });
    $0fd87eb677e3673f$var$ListItem.defaultProps = {
        isInTransition: false
    };
    $0fd87eb677e3673f$var$ListItem.displayName = 'ListItem';
    $0fd87eb677e3673f$var$ListItem.whyDidYouRender = true;
    var $0fd87eb677e3673f$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($0fd87eb677e3673f$var$ListItem);
    const $0fd87eb677e3673f$var$checkboxWrapperStylesOld = (0, (0, parcelRequire("99gde")).xcss)({
        position: 'absolute',
        left: 'space.0',
        marginLeft: 'space.050',
        marginRight: 'space.050'
    });
    const $0fd87eb677e3673f$var$checkboxWrapperStyles = (0, (0, parcelRequire("99gde")).xcss)({
        position: 'absolute',
        left: 'space.0',
        marginLeft: 'space.150'
    });
});
parcelRegister("1YcpO", function(module, exports) {
    $parcel$export(module.exports, "isEnterOrSpaceKey", ()=>$caebb734c61a2262$export$f6deda1cc2672a2e);
    $parcel$export(module.exports, "isBubbledEvent", ()=>$caebb734c61a2262$export$6cc56ae238ebd443);
    const $caebb734c61a2262$export$f6deda1cc2672a2e = (event)=>event.keyCode === 13 || event.keyCode === 32;
    const $caebb734c61a2262$export$a6587fe901c3baf7 = (event)=>event.key === 'Escape' || event.key === 'Esc' || event.keyCode === 27;
    const $caebb734c61a2262$export$6cc56ae238ebd443 = (event)=>event.currentTarget !== event.target;
    const $caebb734c61a2262$export$9c580eee50acd9e2 = (e)=>{
        const event = e || window.event;
        if ('buttons' in event) return event.buttons === 1;
        if (event) {
            const { button: button } = event;
            return button === 1;
        }
        return false;
    };
});
parcelRegister("df6UD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$06bd428ce6408342$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $bWn3s;
    var $lwMsT;
    var $9jNMw;
    var $4CC2v;
    var $k7hw1;
    var $6Ll2T;
    var $99gde;
    var $5gzbX;
    var $loZC0;
    var $cSD7y;
    var $4R6GH;
    var $dCm1o;
    var $iZN6h;
    var $f28cG;
    var $ghKWA;
    var $hUAzM;
    const $06bd428ce6408342$var$CreateChildButtonNew = ({ parentId: parentId, label: label, onInlineCreateClicked: onInlineCreateClicked, isVisible: isVisible })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const { createTriggerRef: createTriggerRef, onCreateTriggerClick: onCreateTriggerClick } = (0, (0, parcelRequire("f28cG")).useCreateTrigger)(parentId, 'CHILD');
        const onClick = (0, $5uXOq.useCallback)((event)=>{
            event.stopPropagation();
            onCreateTriggerClick();
            (0, (0, parcelRequire("5gzbX")).default)('timeline-add-item-clicked', event.timeStamp);
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'childIssueCreateButton',
                attributes: {
                    position: (0, (0, parcelRequire("iZN6h")).INSIDE)
                }
            });
            (0, (0, parcelRequire("hUAzM")).fireUIAnalyticsEvent)(analyticsEvent);
            onInlineCreateClicked({
                parentId: parentId,
                position: (0, (0, parcelRequire("iZN6h")).INSIDE)
            });
        }, [
            onCreateTriggerClick,
            createAnalyticsEvent,
            onInlineCreateClicked,
            parentId
        ]);
        const stopPropagation = (0, $5uXOq.useCallback)((e)=>{
            if (e.key === 'Escape') e.stopPropagation();
        }, []);
        return (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_2') ? $5uXOq.createElement("div", {
            className: (0, (0, parcelRequire("ghKWA")).getCreateChildButtonClassName)().className
        }, $5uXOq.createElement((0, (0, parcelRequire("6Ll2T")).default), {
            xcss: !isVisible && $06bd428ce6408342$var$hideButtonStyles
        }, $5uXOq.createElement((0, (0, parcelRequire("9jNMw")).default), {
            ref: createTriggerRef,
            icon: (0, ($parcel$interopDefault((0, parcelRequire("4CC2v"))))),
            testId: `roadmap.timeline-table.components.list-item.create-child-button.container-${parentId}`,
            label: label,
            onClick: onClick,
            onKeyUp: stopPropagation,
            appearance: "subtle",
            spacing: "compact",
            isTooltipDisabled: false
        }))) : $5uXOq.createElement((0, (0, parcelRequire("loZC0")).default), {
            content: label
        }, ({ ref: tooltipRef, ...tooltipProps })=>$5uXOq.createElement("button", {
                ...tooltipProps,
                ref: (0, (0, parcelRequire("bWn3s")).mergeRefs)([
                    tooltipRef,
                    createTriggerRef
                ]),
                "data-testid": `roadmap.timeline-table.components.list-item.create-child-button.container-${parentId}`,
                "aria-label": label,
                onClick: onClick,
                onKeyUp: stopPropagation,
                className: (0, (0, parcelRequire("bwpsq")).default)([
                    "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _19itglyw _80omtlke _1bsb1ejb _4t3i1ejb _2rko1sit _s7n4jp4b _bfhklecj _syazjjyb _12ji1r31 _1qu2glyw _12y31o36 _nt751r31 _49pcglyw _1hvw1o36 _1ejj168b _jomrfj8p _irr3fj8p _1di61elt _9h8h85f4",
                    !isVisible && "_tzy4idpf _lcxvglyw",
                    (0, (0, parcelRequire("ghKWA")).getCreateChildButtonClassName)().className
                ])
            }, $5uXOq.createElement((0, ($parcel$interopDefault((0, parcelRequire("k7hw1"))))), {
                label: "",
                size: "medium"
            })));
    };
    const $06bd428ce6408342$var$CreateChildButtonOld = ({ parentId: parentId, label: label, onInlineCreateClicked: onInlineCreateClicked })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const onClick = (0, $5uXOq.useCallback)((event)=>{
            event.stopPropagation();
            (0, (0, parcelRequire("5gzbX")).default)('timeline-add-item-clicked', event.timeStamp);
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'childIssueCreateButton',
                attributes: {
                    position: (0, (0, parcelRequire("iZN6h")).INSIDE)
                }
            });
            (0, (0, parcelRequire("hUAzM")).fireUIAnalyticsEvent)(analyticsEvent);
            onInlineCreateClicked({
                parentId: parentId,
                position: (0, (0, parcelRequire("iZN6h")).INSIDE)
            });
        }, [
            createAnalyticsEvent,
            parentId,
            onInlineCreateClicked
        ]);
        return (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_2') ? $5uXOq.createElement("div", {
            className: (0, (0, parcelRequire("ghKWA")).getCreateChildButtonClassName)().className
        }, $5uXOq.createElement((0, (0, parcelRequire("9jNMw")).default), {
            icon: (0, ($parcel$interopDefault((0, parcelRequire("4CC2v"))))),
            testId: `roadmap.timeline-table.components.list-item.create-child-button.container-${parentId}`,
            label: label,
            onClick: onClick,
            appearance: "subtle",
            spacing: "compact",
            isTooltipDisabled: false
        })) : $5uXOq.createElement((0, (0, parcelRequire("loZC0")).default), {
            content: label
        }, (tooltipProps)=>$5uXOq.createElement("button", {
                ...tooltipProps,
                "data-testid": `roadmap.timeline-table.components.list-item.create-child-button.container-${parentId}`,
                "aria-label": label,
                onClick: onClick,
                className: (0, (0, parcelRequire("bwpsq")).default)([
                    "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _19itglyw _80omtlke _1bsb1ejb _4t3i1ejb _2rko1sit _s7n4jp4b _bfhklecj _syazjjyb _12ji1r31 _1qu2glyw _12y31o36 _nt751r31 _49pcglyw _1hvw1o36 _1ejj168b _jomrfj8p _irr3fj8p _1di61elt _9h8h85f4",
                    (0, (0, parcelRequire("ghKWA")).getCreateChildButtonClassName)().className
                ])
            }, $5uXOq.createElement((0, ($parcel$interopDefault((0, parcelRequire("k7hw1"))))), {
                label: "",
                size: "medium"
            })));
    };
    const $06bd428ce6408342$var$CreateChildButton = (0, (0, parcelRequire("cSD7y")).componentWithFG)('jsw_roadmaps_timeline_table_meatballs_menu_a11y', $06bd428ce6408342$var$CreateChildButtonNew, $06bd428ce6408342$var$CreateChildButtonOld);
    var $06bd428ce6408342$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($06bd428ce6408342$var$CreateChildButton);
    const $06bd428ce6408342$var$hideButtonStyles = (0, (0, parcelRequire("99gde")).xcss)({
        opacity: 0,
        pointerEvents: 'none'
    });
    const $06bd428ce6408342$var$buttonStyles = null;
    const $06bd428ce6408342$var$hideButtonStylesOld = null;
});
parcelRegister("bWn3s", function(module, exports) {
    $parcel$export(module.exports, "mergeRefs", ()=>$8b16fea90e636ddb$export$c9058316764c140e);
    var $dv0OY;
    var $3XwZB;
    function $8b16fea90e636ddb$export$c9058316764c140e(refs) {
        return (0, (0, parcelRequire("3XwZB")).createCallbackRef)((newValue)=>refs.forEach((ref)=>(0, (0, parcelRequire("dv0OY")).assignRef)(ref, newValue)));
    }
});
parcelRegister("3XwZB", function(module, exports) {
    $parcel$export(module.exports, "createCallbackRef", ()=>$2e2079715de82b22$export$35a19128eb4acba4);
    function $2e2079715de82b22$export$35a19128eb4acba4(callback) {
        let current = null;
        return {
            get current () {
                return current;
            },
            set current (value){
                const last = current;
                if (last !== value) {
                    current = value;
                    callback(value, last);
                }
            }
        };
    }
});
parcelRegister("f28cG", function(module, exports) {
    $parcel$export(module.exports, "useCreateTrigger", ()=>$a352d29754ee84b9$export$91c6835e1a79c0e7);
    var $5uXOq = parcelRequire("5uXOq");
    var $82CeN;
    const $a352d29754ee84b9$export$91c6835e1a79c0e7 = (rowId, type)=>{
        const element = (0, $5uXOq.useRef)(null);
        const { setActiveCreateTrigger: setActiveCreateTrigger } = (0, (0, parcelRequire("82CeN")).useFocusMarshal)();
        const setCreateTriggerRef = (0, $5uXOq.useCallback)((ref)=>{
            element.current = ref;
        }, []);
        const onCreateTriggerClick = (0, $5uXOq.useCallback)(()=>{
            if (element.current) setActiveCreateTrigger(rowId, type, element.current);
        }, [
            rowId,
            setActiveCreateTrigger,
            type
        ]);
        return {
            createTriggerRef: setCreateTriggerRef,
            onCreateTriggerClick: onCreateTriggerClick
        };
    };
});
parcelRegister("4Rpjg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$45f9bd1b7bbd9b4e$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $bWn3s;
    var $lwMsT;
    var $5gzbX;
    var $loZC0;
    var $cSD7y;
    var $iZN6h;
    var $f28cG;
    var $3ruU1;
    var $hUAzM;
    const $45f9bd1b7bbd9b4e$var$buttonStyles = null;
    const $45f9bd1b7bbd9b4e$var$zIndexStyle = null;
    const $45f9bd1b7bbd9b4e$var$CreateSiblingButton = ({ id: id, level: level, depth: depth, parentId: parentId, label: label, onInlineCreateClicked: onInlineCreateClicked })=>{
        const element = (0, $5uXOq.useRef)(null);
        const { onAddButtonMouseEnter: onAddButtonMouseEnter, onAddButtonMouseLeave: onAddButtonMouseLeave } = (0, (0, parcelRequire("3ruU1")).useSideEffectMarshal)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const { createTriggerRef: createTriggerRef, onCreateTriggerClick: onCreateTriggerClick } = (0, (0, parcelRequire("f28cG")).useCreateTrigger)(id, 'SIBLING');
        const onClick = (0, $5uXOq.useCallback)((event)=>{
            event.stopPropagation();
            onCreateTriggerClick();
            (0, (0, parcelRequire("5gzbX")).default)('timeline-add-item-clicked', event.timeStamp);
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'issueCreateButton',
                attributes: {
                    position: (0, (0, parcelRequire("iZN6h")).BEFORE),
                    level: level,
                    depth: depth
                }
            });
            (0, (0, parcelRequire("hUAzM")).fireUIAnalyticsEvent)(analyticsEvent);
            onAddButtonMouseLeave();
            onInlineCreateClicked({
                beforeId: id,
                parentId: parentId,
                position: (0, (0, parcelRequire("iZN6h")).BEFORE)
            });
        }, [
            onCreateTriggerClick,
            createAnalyticsEvent,
            level,
            depth,
            onAddButtonMouseLeave,
            onInlineCreateClicked,
            id,
            parentId
        ]);
        const updateVisualIndicator = (0, $5uXOq.useCallback)((tabFocused)=>{
            if (element.current) {
                const { top: top } = element.current.getBoundingClientRect();
                onAddButtonMouseEnter(top, tabFocused);
            }
        }, [
            onAddButtonMouseEnter
        ]);
        const onActiveHandler = (0, $5uXOq.useCallback)((tabFocused)=>{
            if (tabFocused) setTimeout(()=>updateVisualIndicator(true), 10);
            else updateVisualIndicator(false);
        }, [
            updateVisualIndicator
        ]);
        const onActive = (0, $5uXOq.useCallback)(()=>{
            onActiveHandler(false);
        }, [
            onActiveHandler
        ]);
        const onActiveFocus = (0, $5uXOq.useCallback)(()=>{
            onActiveHandler(true);
        }, [
            onActiveHandler
        ]);
        const onInactive = (0, $5uXOq.useCallback)(()=>{
            onAddButtonMouseLeave();
        }, [
            onAddButtonMouseLeave
        ]);
        const createOnFocus = (tooltipCallback)=>(e)=>{
                onActiveFocus();
                tooltipCallback(e);
            };
        const createOnBlur = (tooltipCallback)=>(e)=>{
                onInactive();
                tooltipCallback(e);
            };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("loZC0")).default), {
            content: label,
            position: "left"
        }, (tooltipProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement("button", {
                ...tooltipProps,
                ref: (0, (0, parcelRequire("bWn3s")).mergeRefs)([
                    tooltipProps.ref,
                    element,
                    createTriggerRef
                ]),
                "data-testid": `roadmap.timeline-table.components.list-item.create-sibling-button.container-${id}`,
                "aria-label": label,
                onMouseEnter: onActive,
                onMouseLeave: onInactive,
                onClick: onClick,
                onFocus: createOnFocus(tooltipProps.onFocus),
                onBlur: createOnBlur(tooltipProps.onBlur),
                className: (0, (0, parcelRequire("bwpsq")).default)([
                    "_kqswstnw _154i1lpd _1ltv14id _1bsb1r7l _4t3i19bv _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _bfhk18uv _19itglyw _80omtlke _nt751r31 _49pcglyw _1hvw1o36",
                    "_1pbyibnn"
                ])
            }));
    };
    const $45f9bd1b7bbd9b4e$var$CreateSiblingButtonOld = ({ id: id, level: level, depth: depth, parentId: parentId, label: label, onInlineCreateClicked: onInlineCreateClicked })=>{
        const element = (0, $5uXOq.useRef)(null);
        const { onAddButtonMouseEnter: onAddButtonMouseEnter, onAddButtonMouseLeave: onAddButtonMouseLeave } = (0, (0, parcelRequire("3ruU1")).useSideEffectMarshal)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const onClick = (0, $5uXOq.useCallback)((event)=>{
            event.stopPropagation();
            (0, (0, parcelRequire("5gzbX")).default)('timeline-add-item-clicked', event.timeStamp);
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'issueCreateButton',
                attributes: {
                    position: (0, (0, parcelRequire("iZN6h")).BEFORE),
                    level: level,
                    depth: depth
                }
            });
            (0, (0, parcelRequire("hUAzM")).fireUIAnalyticsEvent)(analyticsEvent);
            onAddButtonMouseLeave();
            onInlineCreateClicked({
                beforeId: id,
                parentId: parentId,
                position: (0, (0, parcelRequire("iZN6h")).BEFORE)
            });
        }, [
            createAnalyticsEvent,
            level,
            depth,
            onAddButtonMouseLeave,
            onInlineCreateClicked,
            id,
            parentId
        ]);
        const onActiveHandler = (0, $5uXOq.useCallback)((tabFocused)=>{
            if (element.current) {
                const { top: top } = element.current.getBoundingClientRect();
                onAddButtonMouseEnter(top, tabFocused);
            }
        }, [
            onAddButtonMouseEnter
        ]);
        const onActive = (0, $5uXOq.useCallback)(()=>{
            onActiveHandler(false);
        }, [
            onActiveHandler
        ]);
        const onActiveFocus = (0, $5uXOq.useCallback)(()=>{
            onActiveHandler(true);
        }, [
            onActiveHandler
        ]);
        const onInactive = (0, $5uXOq.useCallback)(()=>{
            onAddButtonMouseLeave();
        }, [
            onAddButtonMouseLeave
        ]);
        const createOnFocus = (tooltipCallback)=>(e)=>{
                onActiveFocus();
                tooltipCallback(e);
            };
        const createOnBlur = (tooltipCallback)=>(e)=>{
                onInactive();
                tooltipCallback(e);
            };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("loZC0")).default), {
            content: label,
            position: "left"
        }, (tooltipProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement("button", {
                ...tooltipProps,
                ref: (0, (0, parcelRequire("bWn3s")).mergeRefs)([
                    tooltipProps.ref,
                    element
                ]),
                "data-testid": `roadmap.timeline-table.components.list-item.create-sibling-button.container-${id}`,
                "aria-label": label,
                onMouseEnter: onActive,
                onMouseLeave: onInactive,
                onClick: onClick,
                onFocus: createOnFocus(tooltipProps.onFocus),
                onBlur: createOnBlur(tooltipProps.onBlur),
                className: (0, (0, parcelRequire("bwpsq")).default)([
                    "_kqswstnw _154i1lpd _1ltv14id _1bsb1r7l _4t3i19bv _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _bfhk18uv _19itglyw _80omtlke _nt751r31 _49pcglyw _1hvw1o36",
                    "_1pbyibnn"
                ])
            }));
    };
    var $45f9bd1b7bbd9b4e$export$2e2bcd8739ae039 = (0, $5uXOq.memo)((0, (0, parcelRequire("cSD7y")).componentWithFG)('jsw_roadmaps_timeline_table_meatballs_menu_a11y', $45f9bd1b7bbd9b4e$var$CreateSiblingButton, $45f9bd1b7bbd9b4e$var$CreateSiblingButtonOld));
});
parcelRegister("hQYX7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$756a5e7051e31a8c$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $h8Wzd;
    var $73MDu;
    var $3srSR;
    var $99gde;
    var $5gzbX;
    var $dCm1o;
    const $756a5e7051e31a8c$var$buttonStyles = null;
    const $756a5e7051e31a8c$var$ChevronWrapper = ({ children: children })=>(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3srSR")).default), {
            testId: "roadmap.timeline-table.main.content.list.list-item.expand-button.wrapper",
            justifyContent: "center",
            alignItems: "center",
            xcss: $756a5e7051e31a8c$var$containerStyles
        }, children) : children;
    const $756a5e7051e31a8c$var$ExpandButton = ({ id: id, label: label, isRichContentEnabled: isRichContentEnabled, isExpanded: isExpanded, ariaControls: ariaControls, onExpandChanged: onExpandChanged })=>{
        const onClick = (0, $5uXOq.useCallback)((event)=>{
            event.stopPropagation();
            (0, (0, parcelRequire("5gzbX")).default)('timeline-expand-changed', event.timeStamp);
            onExpandChanged(id, isExpanded);
        }, [
            id,
            isExpanded,
            onExpandChanged
        ]);
        const Chevron = isExpanded ? (0, ($parcel$interopDefault((0, parcelRequire("h8Wzd"))))) : (0, ($parcel$interopDefault((0, parcelRequire("73MDu")))));
        const chevronElement = (0, ($parcel$interopDefault($5uXOq))).createElement($756a5e7051e31a8c$var$ChevronWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement(Chevron, {
            testId: `roadmap.timeline-table.components.list-item.expand-button.container-${id}`,
            color: `var(--ds-icon, ${(0, $72ba03e317f3d228$export$c39c0fe0f26207ae)})`,
            label: label
        }));
        if (!isRichContentEnabled) return chevronElement;
        return (0, ($parcel$interopDefault($5uXOq))).createElement("button", {
            onClick: onClick,
            "aria-expanded": isExpanded,
            "aria-label": label,
            ...isExpanded && ariaControls && {
                'aria-controls': ariaControls
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _19itglyw _bfhk18uv _80omtlke _1e0c1txw _16jlidpf _1o9zidpf _i0dl1wug _12ji1r31 _1qu2glyw _12y31o36 _nt751r31 _49pcglyw _1hvw1o36 _1ejj168b"
            ])
        }, chevronElement);
    };
    var $756a5e7051e31a8c$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($756a5e7051e31a8c$var$ExpandButton);
    const $756a5e7051e31a8c$var$containerStyles = (0, (0, parcelRequire("99gde")).xcss)({
        width: '24px',
        height: '24px'
    });
});
parcelRegister("e3R1o", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a6d75372fa4bcf21$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $64gLq;
    var $jkePi;
    var $5gzbX;
    var $4R6GH;
    const $a6d75372fa4bcf21$var$buttonStyles = null;
    const $a6d75372fa4bcf21$var$ExpandButton = ({ id: id, label: label, isExpanded: isExpanded, ariaControls: ariaControls, onExpandChanged: onExpandChanged })=>{
        const onClick = (0, $5uXOq.useCallback)((event)=>{
            event.stopPropagation();
            (0, (0, parcelRequire("5gzbX")).default)('timeline-expand-changed', event.timeStamp);
            onExpandChanged(id, isExpanded);
        }, [
            id,
            isExpanded,
            onExpandChanged
        ]);
        const Chevron = isExpanded ? (0, ($parcel$interopDefault((0, parcelRequire("64gLq"))))) : (0, ($parcel$interopDefault((0, parcelRequire("jkePi")))));
        const chevronElement = (0, ($parcel$interopDefault($5uXOq))).createElement(Chevron, {
            testId: `roadmap.timeline-table.components.list-item.expand-button.container-${id}`,
            label: (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-post-project-a11y-fix') ? '' : label
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement("button", {
            onClick: onClick,
            "aria-expanded": isExpanded,
            "aria-label": label,
            ...isExpanded && ariaControls && {
                'aria-controls': ariaControls
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1tcg _1bsb1tcg _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf _19itglyw _bfhk18uv _80omtlke _16jlidpf _1o9zidpf _i0dl1wug _12ji1r31 _1qu2glyw _12y31o36 _nt751r31 _49pcglyw _1hvw1o36 _1ejj168b"
            ])
        }, chevronElement);
    };
    var $a6d75372fa4bcf21$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($a6d75372fa4bcf21$var$ExpandButton);
});
parcelRegister("jU4rh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a4b5018ddc89c433$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $39xOx;
    var $fiCSn;
    const $a4b5018ddc89c433$var$ListItemMeatBallsButton = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "timeline-table-list-item-meatballs-button",
            packageName: "timelineTable",
            fallback: "flag"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fiCSn")).default), props));
    var $a4b5018ddc89c433$export$2e2bcd8739ae039 = $a4b5018ddc89c433$var$ListItemMeatBallsButton;
});
parcelRegister("fiCSn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$86827779df6f3ef5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $4R6GH;
    var $iZN6h;
    var $WPwAA;
    var $9puhl;
    var $82CeN;
    var $dhWQP;
    var $8FneZ;
    const $86827779df6f3ef5$var$MeatBallsButton = ({ isTriggerVisible: isTriggerVisible = true, isMenuOpen: isMenuOpen, id: id, level: level, depth: depth, parentId: parentId, isCreateChildEnabled: isCreateChildEnabled, isCreateSiblingEnabled: isCreateSiblingEnabled, renderListItemMenuOption: renderListItemMenuOption, renderListItemModal: renderListItemModal, onStopHoverOrFocus: onStopHoverOrFocus, onInlineCreateClicked: onInlineCreateClicked, onDrop: onDrop, setIsMenuOpen: setIsMenuOpen, cellRef: cellRef })=>{
        const [activeOptionId, setActiveOptionId] = (0, $5uXOq.useState)('');
        const [{ customSections: customSections }] = (0, (0, parcelRequire("9puhl")).useListItemMenuOptions)();
        const [{ isDragEnabled: isDragEnabled }] = (0, (0, parcelRequire("WPwAA")).useEnablements)();
        const [isActiveMeatballTrigger] = (0, (0, parcelRequire("82CeN")).useIsCreateTriggerActive)({
            id: id,
            type: 'MEATBALLS'
        });
        const { shouldPreventNavigation: shouldPreventNavigation } = (0, (0, parcelRequire("82CeN")).useFocusMarshal)();
        const returnFocus = (0, $5uXOq.useRef)(false);
        const ref = (0, $5uXOq.useRef)(null);
        const menuRef = (0, $5uXOq.useRef)(null);
        const closeMenu = (0, $5uXOq.useCallback)(()=>{
            setIsMenuOpen(false);
        }, [
            setIsMenuOpen
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!isMenuOpen && returnFocus.current) {
                returnFocus.current = false;
                setTimeout(()=>{
                    ref.current?.focus();
                }, 0);
            }
        }, [
            isMenuOpen
        ]);
        (0, (0, parcelRequire("dhWQP")).useOnClickOutside)({
            cellRef: cellRef,
            menuRef: menuRef,
            triggerRef: ref,
            closeMenu: closeMenu,
            isMenuOpen: isMenuOpen,
            onStopHoverOrFocus: onStopHoverOrFocus
        });
        const [customItemsSections, customOtherSections] = (0, $5uXOq.useMemo)(()=>{
            const itemsSections = [];
            const otherSections = [];
            customSections.forEach((section)=>{
                if (section.id === (0, (0, parcelRequire("iZN6h")).listItemMenu).ITEMS_SECTION) itemsSections.push(section);
                else otherSections.push(section);
            });
            return [
                itemsSections,
                otherSections
            ];
        }, [
            customSections
        ]);
        const setCloseMenu = (0, $5uXOq.useCallback)((event, { shouldReturnFocus: shouldReturnFocus, shouldEnableNavigation: shouldEnableNavigation } = {
            shouldReturnFocus: true,
            shouldEnableNavigation: true
        })=>{
            const isMouseClick = event?.detail && event.detail > 0;
            const shouldStopFocus = isMouseClick || shouldReturnFocus === false;
            returnFocus.current = !shouldStopFocus;
            setIsMenuOpen(false);
            if (shouldStopFocus) onStopHoverOrFocus();
            if (shouldEnableNavigation && (0, (0, parcelRequire("4R6GH")).fg)('timeline_grid_navigation_m2')) shouldPreventNavigation(false);
        }, [
            shouldPreventNavigation,
            onStopHoverOrFocus,
            setIsMenuOpen
        ]);
        const onMenuToggle = (0, $5uXOq.useCallback)(()=>{
            setIsMenuOpen((currentState)=>!currentState);
        }, [
            setIsMenuOpen
        ]);
        const setOpenModal = (0, $5uXOq.useCallback)((event, optionId)=>{
            (0, (0, parcelRequire("4R6GH")).fg)('timeline_grid_navigation_m2') ? setCloseMenu(event, {
                shouldEnableNavigation: false
            }) : setCloseMenu(event);
            setActiveOptionId(optionId);
        }, [
            setCloseMenu
        ]);
        const setCloseModal = (0, $5uXOq.useCallback)(()=>{
            setActiveOptionId('');
            if ((0, (0, parcelRequire("4R6GH")).fg)('timeline_grid_navigation_m2')) shouldPreventNavigation(false);
        }, [
            shouldPreventNavigation
        ]);
        const onStopPropagation = (0, $5uXOq.useCallback)((event)=>{
            event.stopPropagation();
        }, []);
        const onStopDragging = (0, $5uXOq.useCallback)((event)=>{
            event.preventDefault();
            event.stopPropagation();
        }, []);
        const prebuiltOptions = (0, $5uXOq.useMemo)(()=>{
            const options = [];
            if (isCreateChildEnabled || isCreateSiblingEnabled) options.push({
                id: (0, (0, parcelRequire("iZN6h")).listItemMenu).CREATE_ITEM
            });
            if ((0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmap_timeline_meatball_move_menu')) {
                if (isDragEnabled) options.push({
                    id: (0, (0, parcelRequire("iZN6h")).listItemMenu).MOVE_ITEM
                });
            }
            return options;
        }, [
            isCreateChildEnabled,
            isCreateSiblingEnabled,
            isDragEnabled
        ]);
        const issuesSectionOptions = (0, $5uXOq.useMemo)(()=>{
            const issuesSectionCustomOptions = customItemsSections.reduce((acc, { options: options })=>{
                acc.push(...options);
                return acc;
            }, []);
            return [
                ...prebuiltOptions,
                ...issuesSectionCustomOptions
            ];
        }, [
            customItemsSections,
            prebuiltOptions
        ]);
        if (issuesSectionOptions.length > 0 || customSections.length > 0) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            role: "presentation",
            onClick: onStopPropagation,
            draggable: true,
            onDragStart: onStopDragging
        }, isTriggerVisible || isActiveMeatballTrigger ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8FneZ")).default), {
            id: id,
            isOpen: isMenuOpen,
            onMenuToggle: onMenuToggle,
            setCloseMenu: setCloseMenu,
            setOpenModal: setOpenModal,
            issuesSectionOptions: issuesSectionOptions,
            customOtherSections: customOtherSections,
            parentId: parentId,
            level: level,
            depth: depth,
            isCreateChildEnabled: isCreateChildEnabled,
            isCreateSiblingEnabled: isCreateSiblingEnabled,
            onInlineCreateClicked: onInlineCreateClicked,
            renderListItemMenuOption: renderListItemMenuOption,
            onDrop: onDrop,
            ref: ref,
            menuRef: menuRef
        }) : null), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            role: "presentation",
            onClick: onStopPropagation,
            onKeyUp: onStopPropagation
        }, renderListItemModal?.({
            id: id,
            optionId: activeOptionId,
            setCloseModal: setCloseModal,
            triggerRef: ref
        })));
        return null;
    };
    var $86827779df6f3ef5$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($86827779df6f3ef5$var$MeatBallsButton);
});
parcelRegister("dhWQP", function(module, exports) {
    $parcel$export(module.exports, "useOnClickOutside", ()=>$a54593f463a3e35b$export$9afc64c180e82dc4);
    var $5uXOq = parcelRequire("5uXOq");
    const $a54593f463a3e35b$export$9afc64c180e82dc4 = ({ menuRef: menuRef, cellRef: cellRef, triggerRef: triggerRef, closeMenu: closeMenu, isMenuOpen: isMenuOpen, onStopHoverOrFocus: onStopHoverOrFocus })=>{
        (0, $5uXOq.useEffect)(()=>{
            const handleOnClickOutsideMenu = ({ target: target })=>{
                if (target instanceof Node) {
                    if (isMenuOpen && cellRef && !cellRef.current?.contains(target)) onStopHoverOrFocus?.();
                    else if (isMenuOpen && !triggerRef.current?.contains(target) && !menuRef.current?.contains(target)) closeMenu();
                }
            };
            if (typeof document !== 'undefined') document.addEventListener('mousedown', handleOnClickOutsideMenu);
            return ()=>{
                if (typeof document !== 'undefined') document.removeEventListener('mousedown', handleOnClickOutsideMenu);
            };
        }, [
            cellRef,
            closeMenu,
            isMenuOpen,
            menuRef,
            onStopHoverOrFocus,
            triggerRef
        ]);
    };
});
parcelRegister("8FneZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$910dcbf94700408d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $bWn3s;
    var $9jNMw;
    var $f1DUh;
    var $l75AK;
    var $7qVt8;
    var $6Ll2T;
    var $99gde;
    var $4R6GH;
    var $dCm1o;
    var $iZN6h;
    var $hGh1Z;
    var $3Kr5N;
    var $82CeN;
    var $f28cG;
    var $c2ZwS;
    var $hJ7HI;
    var $daGMH;
    const $910dcbf94700408d$var$MeatballPopup = (0, $5uXOq.forwardRef)(({ id: id, isOpen: isOpen, issuesSectionOptions: issuesSectionOptions, customOtherSections: customOtherSections, parentId: parentId, level: level, depth: depth, onDrop: onDrop, menuRef: menuRef, isCreateChildEnabled: isCreateChildEnabled, isCreateSiblingEnabled: isCreateSiblingEnabled, onInlineCreateClicked: onInlineCreateClicked, renderListItemMenuOption: renderListItemMenuOption, onMenuToggle: onMenuToggle, setCloseMenu: setCloseMenu, setOpenModal: setOpenModal }, ref)=>{
        const { createTriggerRef: createTriggerRef, onCreateTriggerClick: onCreateTriggerClick } = (0, (0, parcelRequire("f28cG")).useCreateTrigger)(id, 'MEATBALLS');
        const [isMultiSelected] = (0, (0, parcelRequire("hGh1Z")).useIsItemMultiSelected)(id);
        const [isScrollingY] = (0, (0, parcelRequire("3Kr5N")).useIsScrollingY)();
        const [itemsSelectionCount] = (0, (0, parcelRequire("hGh1Z")).useItemsSelectionCount)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        let itemsSelectionAriaLabel = '';
        if (isMultiSelected) itemsSelectionAriaLabel = formatMessage((0, (0, parcelRequire("c2ZwS")).default).itemsSelectionCount, {
            count: itemsSelectionCount
        });
        const { shouldPreventNavigation: shouldPreventNavigation } = (0, (0, parcelRequire("82CeN")).useFocusMarshal)();
        (0, $5uXOq.useEffect)(()=>{
            if (isScrollingY && isOpen) setCloseMenu();
        }, [
            isOpen,
            isScrollingY,
            setCloseMenu
        ]);
        const renderMenu = (0, $5uXOq.useCallback)(({ setInitialFocusRef: setInitialFocusRef })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
                ref: menuRef,
                xcss: $910dcbf94700408d$var$menuWrapStyles
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l75AK")).default), {
                testId: `roadmap.timeline-table.main.content.list.list-item.meatballs-button.meatball-popup.menu-${id}`,
                maxHeight: (0, (0, parcelRequire("iZN6h")).DEFAULT_MENU_MAX_HEIGHT)
            }, isMultiSelected && (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmap_timeline_meatball_selected_item_option') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hJ7HI")).default), {
                id: id,
                renderListItemMenuOption: renderListItemMenuOption,
                setOpenModal: setOpenModal,
                onCreateTriggerClick: onCreateTriggerClick,
                setInitialFocusRef: setInitialFocusRef,
                setCloseMenu: setCloseMenu
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("daGMH")).default), {
                issuesSectionOptions: issuesSectionOptions,
                customOtherSections: customOtherSections,
                id: id,
                parentId: parentId,
                level: level,
                depth: depth,
                isCreateChildEnabled: isCreateChildEnabled,
                isCreateSiblingEnabled: isCreateSiblingEnabled,
                onInlineCreateClicked: onInlineCreateClicked,
                setInitialFocusRef: setInitialFocusRef,
                onDrop: onDrop,
                renderListItemMenuOption: renderListItemMenuOption,
                setCloseMenu: setCloseMenu,
                setOpenModal: setOpenModal,
                onCreateTriggerClick: onCreateTriggerClick
            }))), [
            customOtherSections,
            depth,
            id,
            isCreateChildEnabled,
            isCreateSiblingEnabled,
            isMultiSelected,
            issuesSectionOptions,
            level,
            menuRef,
            onCreateTriggerClick,
            onDrop,
            onInlineCreateClicked,
            parentId,
            renderListItemMenuOption,
            setCloseMenu,
            setOpenModal
        ]);
        const onClick = (0, $5uXOq.useCallback)((e)=>{
            shouldPreventNavigation(true);
            onMenuToggle(e);
        }, [
            shouldPreventNavigation,
            onMenuToggle
        ]);
        const trigger = (0, $5uXOq.useCallback)(({ ref: triggerRef, ...triggerProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
                xcss: $910dcbf94700408d$var$buttonWrapStyles
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9jNMw")).default), {
                ...triggerProps,
                ref: (0, (0, parcelRequire("bWn3s")).mergeRefs)([
                    ref,
                    createTriggerRef,
                    triggerRef
                ]),
                onClick: (0, (0, parcelRequire("4R6GH")).fg)('timeline_grid_navigation_m2') ? onClick : onMenuToggle,
                spacing: "compact",
                testId: `roadmap.timeline-table.main.content.list.list-item.more-options-button.meatballs-menu-${id}`,
                label: itemsSelectionAriaLabel && (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmap_timeline_meatball_selected_item_option') ? `${formatMessage((0, (0, parcelRequire("c2ZwS")).default).meatballsButtonLabel)} ${itemsSelectionAriaLabel}` : formatMessage((0, (0, parcelRequire("c2ZwS")).default).meatballsButtonLabel),
                icon: (0, ($parcel$interopDefault((0, parcelRequire("f1DUh"))))),
                interactionName: "timeline-meatballs-trigger-clicked",
                appearance: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? 'subtle' : 'default'
            })), [
            createTriggerRef,
            formatMessage,
            id,
            itemsSelectionAriaLabel,
            onClick,
            onMenuToggle,
            ref
        ]);
        const onPopupClose = (0, $5uXOq.useCallback)((event)=>setCloseMenu(event), [
            setCloseMenu
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7qVt8")).default), {
            role: "dialog",
            shouldFlip: false,
            shouldRenderToParent: true,
            shouldReturnFocus: false,
            shouldUseCaptureOnOutsideClick: true,
            onClose: onPopupClose,
            placement: "right-start",
            isOpen: isOpen,
            content: renderMenu,
            trigger: trigger
        });
    });
    const $910dcbf94700408d$var$buttonWrapStyles = (0, (0, parcelRequire("99gde")).xcss)({
        marginLeft: 'space.050'
    });
    const $910dcbf94700408d$var$menuWrapStyles = (0, (0, parcelRequire("99gde")).xcss)({
        cursor: 'default'
    });
    var $910dcbf94700408d$export$2e2bcd8739ae039 = $910dcbf94700408d$var$MeatballPopup;
});
parcelRegister("f1DUh", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $af05e7a3f87d52ab$var$_react = $af05e7a3f87d52ab$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $af05e7a3f87d52ab$var$_showMoreHorizontal = $af05e7a3f87d52ab$var$_interopRequireDefault((parcelRequire("4mxtl")));
    var $af05e7a3f87d52ab$var$_more = $af05e7a3f87d52ab$var$_interopRequireDefault((parcelRequire("hxbUj")));
    function $af05e7a3f87d52ab$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $af05e7a3f87d52ab$var$ShowMoreHorizontalIcon = (props)=>$af05e7a3f87d52ab$var$_react.default.createElement($af05e7a3f87d52ab$var$_showMoreHorizontal.default, Object.assign({
            LEGACY_fallbackIcon: $af05e7a3f87d52ab$var$_more.default
        }, props));
    $af05e7a3f87d52ab$var$ShowMoreHorizontalIcon.Name = 'ShowMoreHorizontalIconMigration';
    var $af05e7a3f87d52ab$var$_default = module.exports.default = $af05e7a3f87d52ab$var$ShowMoreHorizontalIcon;
});
parcelRegister("c2ZwS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$39aaa2bfa3ac9243$export$2e2bcd8739ae039);
    var $7VHMR;
    const $39aaa2bfa3ac9243$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        meatballsButtonLabel: {
            id: 'roadmap.timeline-table.main.content.list.list-item.meatballs-button.meatball-popup.meatballs-button-label',
            defaultMessage: 'More actions',
            description: 'Label for the more options button in the list item'
        },
        itemsSectionHeader: {
            id: 'roadmap.timeline-table.main.content.list.list-item.meatballs-button.meatball-popup.items-section-header',
            defaultMessage: 'Items',
            description: 'Header for the item section in the list item'
        },
        itemsSelectionCount: {
            id: 'roadmap.timeline-table.main.content.list.list-item.meatballs-button.meatball-popup.items-selection-count',
            defaultMessage: '{count} {count, plural, one {item selected} other {items selected}}',
            description: 'Label to indicate the count of selected items on a meatballs button'
        }
    });
    var $39aaa2bfa3ac9243$export$2e2bcd8739ae039 = $39aaa2bfa3ac9243$var$messages;
});
parcelRegister("hJ7HI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0cedfc9508758fa3$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $ousew;
    var $3bk6K;
    var $6Ll2T;
    var $99gde;
    var $iZN6h;
    var $hGh1Z;
    var $9puhl;
    var $dedQ1;
    var $8AXBg;
    const $0cedfc9508758fa3$var$MultiSelectOptions = ({ id: id, onCreateTriggerClick: onCreateTriggerClick, setCloseMenu: setCloseMenu, setInitialFocusRef: setInitialFocusRef, setOpenModal: setOpenModal, renderListItemMenuOption: renderListItemMenuOption })=>{
        const [{ overrideLabels: overrideLabels, customSectionsBulk: customSectionsBulk }] = (0, (0, parcelRequire("9puhl")).useListItemMenuOptions)();
        const [itemsSelectionCount] = (0, (0, parcelRequire("hGh1Z")).useItemsSelectionCount)();
        const isLabelOverridden = Boolean(overrideLabels[(0, (0, parcelRequire("iZN6h")).listItemMenu).SELECTED_ITEM_COUNTER]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            testId: "roadmap.timeline-table.main.content.list.list-item.meatballs-button.meatball-popup.multi-select-options.section"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            xcss: $0cedfc9508758fa3$var$bulkIndicatorContainer,
            "aria-hidden": true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
            ...isLabelOverridden ? overrideLabels[(0, (0, parcelRequire("iZN6h")).listItemMenu).SELECTED_ITEM_COUNTER] : (0, (0, parcelRequire("8AXBg")).default).selected,
            values: {
                count: itemsSelectionCount,
                badge: (chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bk6K")).default), {
                        appearance: "primary"
                    }, chunks)
            }
        }))), customSectionsBulk.length > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dedQ1")).default), {
            id: id,
            customOtherSections: customSectionsBulk,
            onCreateTriggerClick: onCreateTriggerClick,
            setCloseMenu: setCloseMenu,
            setInitialFocusRef: setInitialFocusRef,
            setOpenModal: setOpenModal,
            renderListItemMenuOption: renderListItemMenuOption
        }));
    };
    const $0cedfc9508758fa3$var$bulkIndicatorContainer = (0, (0, parcelRequire("99gde")).xcss)({
        display: 'flex',
        paddingLeft: 'space.250',
        paddingRight: 'space.250',
        textTransform: 'uppercase',
        alignItems: 'center',
        height: "var(--ds-space-400, 32px)",
        color: 'color.text.subtle',
        font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        fontWeight: "var(--ds-font-weight-medium, 500)",
        gap: 'space.100'
    });
    var $0cedfc9508758fa3$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($0cedfc9508758fa3$var$MultiSelectOptions);
});
parcelRegister("3bk6K", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b0e21e09b41dc4ab$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $2oS3b;
    var $6Ll2T;
    var $ZuPvl;
    var $99gde;
    var $3dnXk;
    function $b0e21e09b41dc4ab$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $b0e21e09b41dc4ab$var$boxStyles = (0, (0, parcelRequire("99gde")).xcss)({
        borderRadius: 'border.radius.200',
        display: 'inline-flex',
        blockSize: 'min-content',
        flexShrink: 0
    });
    const $b0e21e09b41dc4ab$var$neutral300 = '#DDDEE1';
    const $b0e21e09b41dc4ab$var$red300 = '#FD9891';
    const $b0e21e09b41dc4ab$var$blue300 = '#8FB8F6';
    const $b0e21e09b41dc4ab$var$neutral1000 = '#292A2E';
    const $b0e21e09b41dc4ab$var$styles = {
        root: {
            name: "85bcg3",
            styles: "display:inline-flex;box-sizing:border-box;min-width:var(--ds-space-300, 24px);justify-content:center;flex-shrink:0;block-size:min-content;border-radius:var(--ds-border-radius-050, 2px);padding-inline:var(--ds-space-050, 4px)"
        },
        added: {
            name: "4x7cmh",
            styles: "background-color:var(--ds-background-success, #DCFFF1);color:var(--ds-text, #172B4D)"
        },
        default: (0, (0, parcelRequire("f8Sb3")).css)({
            backgroundColor: $b0e21e09b41dc4ab$var$neutral300,
            color: $b0e21e09b41dc4ab$var$neutral1000
        }),
        important: (0, (0, parcelRequire("f8Sb3")).css)({
            backgroundColor: $b0e21e09b41dc4ab$var$red300,
            color: $b0e21e09b41dc4ab$var$neutral1000
        }),
        primary: (0, (0, parcelRequire("f8Sb3")).css)({
            backgroundColor: $b0e21e09b41dc4ab$var$blue300,
            color: $b0e21e09b41dc4ab$var$neutral1000
        }),
        primaryInverted: {
            name: "1425qmy",
            styles: "background-color:var(--ds-surface, #FFFFFF);color:var(--ds-text-brand, #0C66E4)"
        },
        removed: {
            name: "10hiq01",
            styles: "background-color:var(--ds-background-danger, #FFECEB);color:var(--ds-text, #172B4D)"
        }
    };
    const $b0e21e09b41dc4ab$var$Badge = (0, $5uXOq.memo)(function Badge({ appearance: appearance = 'default', children: children = 0, max: max = 99, style: style, testId: testId }) {
        if ((0, (0, parcelRequire("2oS3b")).fg)('platform-component-visual-refresh')) return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            "data-testid": testId,
            css: [
                $b0e21e09b41dc4ab$var$styles.root,
                $b0e21e09b41dc4ab$var$styles[appearance]
            ],
            style: {
                background: style?.backgroundColor,
                color: style?.color
            }
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ZuPvl")).default), {
            size: "small",
            align: "center",
            color: "inherit"
        }, typeof children === 'number' && max ? (0, (0, parcelRequire("3dnXk")).formatValue)(children, max) : children));
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("6Ll2T")).default), {
            testId: testId,
            as: "span",
            backgroundColor: $b0e21e09b41dc4ab$var$backgroundColors[appearance],
            xcss: $b0e21e09b41dc4ab$var$boxStyles,
            style: {
                background: style?.backgroundColor,
                color: style?.color
            },
            paddingInline: "space.075"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("ZuPvl")).default), {
            size: "UNSAFE_small",
            align: "center",
            color: style?.color ? 'inherit' : $b0e21e09b41dc4ab$var$textColors[appearance]
        }, typeof children === 'number' && max ? (0, (0, parcelRequire("3dnXk")).formatValue)(children, max) : children));
    });
    $b0e21e09b41dc4ab$var$Badge.displayName = 'Badge';
    var $b0e21e09b41dc4ab$export$2e2bcd8739ae039 = $b0e21e09b41dc4ab$var$Badge;
    const $b0e21e09b41dc4ab$var$backgroundColors = {
        added: 'color.background.success',
        default: 'color.background.neutral',
        important: 'color.background.danger.bold',
        primary: 'color.background.brand.bold',
        primaryInverted: 'elevation.surface',
        removed: 'color.background.danger'
    };
    const $b0e21e09b41dc4ab$var$textColors = {
        added: 'color.text.success',
        default: 'color.text',
        important: 'color.text.inverse',
        primary: 'color.text.inverse',
        primaryInverted: 'color.text.brand',
        removed: 'color.text.danger'
    };
});
parcelRegister("3dnXk", function(module, exports) {
    $parcel$export(module.exports, "formatValue", ()=>$43e54f6ab449209d$export$7c4d25c0c3217d8c);
    function $43e54f6ab449209d$var$getSafeValue(value = 0) {
        const numericValue = +value;
        if (numericValue < 0) return 0;
        return value;
    }
    function $43e54f6ab449209d$export$7c4d25c0c3217d8c(value, max) {
        const safeValue = $43e54f6ab449209d$var$getSafeValue(value);
        const safeMax = $43e54f6ab449209d$var$getSafeValue(max);
        if (safeMax && safeMax < safeValue) return `${safeMax}+`;
        if (safeValue === Infinity) return "\u221E";
        return safeValue.toString();
    }
});
parcelRegister("dedQ1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$50b9289e9e8f41bb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $6jrGg;
    var $6Ll2T;
    var $99gde;
    var $hyeSr;
    var $lgz7j;
    const $50b9289e9e8f41bb$var$CustomOptions = ({ id: id, customOtherSections: customOtherSections, onCreateTriggerClick: onCreateTriggerClick, setCloseMenu: setCloseMenu, setInitialFocusRef: setInitialFocusRef, setOpenModal: setOpenModal, renderListItemMenuOption: renderListItemMenuOption })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, customOtherSections.map(({ id: sectionId, title: title, options: options })=>{
            if (!options || options.length === 0) return null;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
                xcss: $50b9289e9e8f41bb$var$sectionWrap,
                key: sectionId,
                testId: `roadmap.timeline-table.main.content.list.list-item.meatballs-button.meatball-popup.custom-options.${sectionId}`
            }, title && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
                xcss: $50b9289e9e8f41bb$var$headingWrap
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6jrGg")).default), {
                size: "xxsmall",
                as: "div"
            }, (0, (0, parcelRequire("lgz7j")).renderOverrideLabel)(formatMessage, title))), options.map(({ id: optionId }, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                    key: optionId
                }, renderListItemMenuOption({
                    id: id,
                    optionId: optionId,
                    setInitialFocusRef: index === 0 ? setInitialFocusRef : undefined,
                    setOpenModal: (event)=>{
                        setOpenModal(event, optionId);
                    },
                    Option: (0, (0, parcelRequire("hyeSr")).ListItemMenuOption),
                    onCreateTriggerClick: onCreateTriggerClick,
                    setCloseMenu: setCloseMenu
                }))));
        }));
    };
    const $50b9289e9e8f41bb$var$headingWrap = (0, (0, parcelRequire("99gde")).xcss)({
        marginTop: 'space.250',
        marginBottom: 'space.075',
        paddingLeft: 'space.200',
        paddingRight: 'space.200'
    });
    const $50b9289e9e8f41bb$var$sectionWrap = (0, (0, parcelRequire("99gde")).xcss)({
        borderTop: '1px solid',
        borderColor: 'color.border',
        marginTop: 'space.075'
    });
    var $50b9289e9e8f41bb$export$2e2bcd8739ae039 = $50b9289e9e8f41bb$var$CustomOptions;
});
parcelRegister("hyeSr", function(module, exports) {
    $parcel$export(module.exports, "ListItemMenuOption", ()=>$896c724a6a983c05$export$6c14ffa7379dfa2e);
    var $5uXOq = parcelRequire("5uXOq");
    var $bWn3s;
    var $3IisA;
    var $loZC0;
    var $4R6GH;
    var $cAWit;
    const $896c724a6a983c05$export$6c14ffa7379dfa2e = ({ isDisabled: isDisabled, label: label, disabledTooltip: disabledTooltip, triggerRef: triggerRef, interactionName: interactionName, onClick: onClick, setInitialFocusRef: setInitialFocusRef, children: children })=>{
        const renderButtonItem = (0, $5uXOq.useCallback)((triggerProps)=>{
            const refs = [];
            if (setInitialFocusRef) refs.push(setInitialFocusRef);
            if (triggerProps?.ref) refs.push(triggerProps.ref);
            if (triggerRef) refs.push(triggerRef);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3IisA")).default), {
                ...triggerProps,
                isDisabled: isDisabled,
                onClick: onClick,
                ref: (0, (0, parcelRequire("bWn3s")).mergeRefs)(refs),
                ...(0, (0, parcelRequire("4R6GH")).fg)('platform_button_item-add-ufo-metrics') ? {
                    interactionName: interactionName
                } : {}
            }, label);
        }, [
            setInitialFocusRef,
            triggerRef,
            isDisabled,
            onClick,
            interactionName,
            label
        ]);
        if (children) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cAWit")).default), {
            isDisabled: isDisabled,
            disabledTooltip: disabledTooltip,
            label: label,
            setInitialFocusRef: setInitialFocusRef,
            triggerRef: triggerRef,
            ...(0, (0, parcelRequire("4R6GH")).fg)('platform_button_item-add-ufo-metrics') ? {
                interactionName: interactionName
            } : {}
        }, children);
        return isDisabled && disabledTooltip ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("loZC0")).default), {
            content: disabledTooltip
        }, renderButtonItem) : renderButtonItem();
    };
});
parcelRegister("cAWit", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d30d299666541606$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bWn3s;
    var $73MDu;
    var $3IisA;
    var $7qVt8;
    var $6Ll2T;
    var $loZC0;
    var $4R6GH;
    var $dhWQP;
    const $d30d299666541606$var$PopupButton = ({ label: label, isDisabled: isDisabled, disabledTooltip: disabledTooltip, triggerRef: triggerRef, interactionName: interactionName, setInitialFocusRef: setInitialFocusRef, children: children })=>{
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
        const menuRef = (0, $5uXOq.useRef)(null);
        const ref = (0, $5uXOq.useRef)(null);
        const onClose = (0, $5uXOq.useCallback)(()=>{
            setIsOpen(false);
        }, []);
        const onMenuToggle = (0, $5uXOq.useCallback)((e)=>{
            e.stopPropagation();
            setIsOpen((currentState)=>!currentState);
        }, []);
        (0, (0, parcelRequire("dhWQP")).useOnClickOutside)({
            menuRef: menuRef,
            closeMenu: onClose,
            isMenuOpen: isOpen,
            triggerRef: ref
        });
        const renderContent = (0, $5uXOq.useCallback)(({ setInitialFocusRef: setFocusRef })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
                ref: menuRef,
                testId: "roadmap.timeline-table.main.content.list.list-item.list-item-menu-option.popup-button.content"
            }, children({
                setInitialFocusRef: setFocusRef
            })), [
            children
        ]);
        const renderButtonItem = (0, $5uXOq.useCallback)((popupTriggerProps, tooltipTriggerProps)=>{
            const refs = [
                popupTriggerProps.ref
            ];
            if (tooltipTriggerProps?.ref) refs.push(tooltipTriggerProps.ref);
            if (setInitialFocusRef) refs.push(setInitialFocusRef);
            if (triggerRef) refs.push(triggerRef);
            refs.push(ref);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3IisA")).default), {
                ...tooltipTriggerProps,
                ...popupTriggerProps,
                onClick: onMenuToggle,
                isDisabled: isDisabled,
                iconAfter: !isDisabled ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("73MDu"))))), {
                    color: "var(--ds-icon-subtle)",
                    label: "",
                    testId: "roadmap.timeline-table.main.content.list.list-item.list-item-menu-option.popup-button.chevron-right-icon"
                }) : undefined,
                ref: (0, (0, parcelRequire("bWn3s")).mergeRefs)(refs),
                ...(0, (0, parcelRequire("4R6GH")).fg)('platform_button_item-add-ufo-metrics') ? {
                    interactionName: interactionName
                } : {}
            }, label);
        }, [
            interactionName,
            isDisabled,
            label,
            onMenuToggle,
            setInitialFocusRef,
            triggerRef
        ]);
        const trigger = (0, $5uXOq.useCallback)((triggerProps)=>isDisabled && disabledTooltip ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("loZC0")).default), {
                content: disabledTooltip
            }, (tooltipProps)=>renderButtonItem(triggerProps, tooltipProps)) : renderButtonItem(triggerProps), [
            isDisabled,
            disabledTooltip,
            renderButtonItem
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7qVt8")).default), {
            role: "dialog",
            shouldRenderToParent: true,
            shouldUseCaptureOnOutsideClick: true,
            isOpen: isOpen,
            placement: "right-start",
            onClose: onClose,
            content: renderContent,
            trigger: trigger
        });
    };
    var $d30d299666541606$export$2e2bcd8739ae039 = $d30d299666541606$var$PopupButton;
});
parcelRegister("lgz7j", function(module, exports) {
    $parcel$export(module.exports, "renderOverrideLabel", ()=>$081cd1d18b8e60f3$export$9f99feb062b3eb64);
    const $081cd1d18b8e60f3$export$9f99feb062b3eb64 = (formatMessage, descriptor, values)=>{
        if (descriptor) return formatMessage(descriptor, values);
    };
});
parcelRegister("8AXBg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5ced3165e49d91ff$export$2e2bcd8739ae039);
    var $7VHMR;
    const $5ced3165e49d91ff$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        selected: {
            id: 'roadmap.timeline-table.main.content.list.list-item.meatballs-button.meatball-popup.multi-select-options.selected',
            description: 'Label to indicate the number of selected item on a meatballs menu',
            defaultMessage: '<badge>{count}</badge> selected'
        }
    });
    var $5ced3165e49d91ff$export$2e2bcd8739ae039 = $5ced3165e49d91ff$var$messages;
});
parcelRegister("daGMH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d23221329fab77af$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $6jrGg;
    var $6Ll2T;
    var $99gde;
    var $iZN6h;
    var $9puhl;
    var $lgz7j;
    var $dedQ1;
    var $4Eawx;
    var $c2ZwS;
    const $d23221329fab77af$var$SingleSelectOptions = ({ issuesSectionOptions: issuesSectionOptions, customOtherSections: customOtherSections, id: id, parentId: parentId, level: level, depth: depth, isCreateChildEnabled: isCreateChildEnabled, isCreateSiblingEnabled: isCreateSiblingEnabled, renderListItemMenuOption: renderListItemMenuOption, onInlineCreateClicked: onInlineCreateClicked, onDrop: onDrop, setCloseMenu: setCloseMenu, setInitialFocusRef: setInitialFocusRef, setOpenModal: setOpenModal, onCreateTriggerClick: onCreateTriggerClick })=>{
        const [{ overrideLabels: overrideLabels }] = (0, (0, parcelRequire("9puhl")).useListItemMenuOptions)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const headingLabel = (0, (0, parcelRequire("lgz7j")).renderOverrideLabel)(formatMessage, overrideLabels[(0, (0, parcelRequire("iZN6h")).listItemMenu).ITEMS_SECTION]) || formatMessage((0, (0, parcelRequire("c2ZwS")).default).itemsSectionHeader);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, issuesSectionOptions.length > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            testId: "roadmap.timeline-table.main.content.list.list-item.meatballs-button.meatball-popup.single-select-options.items-section"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            xcss: $d23221329fab77af$var$headingWrap
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6jrGg")).default), {
            size: "xxsmall",
            as: "div",
            testId: "roadmap.timeline-table.main.content.list.list-item.meatballs-button.meatball-popup.single-select-options.heading"
        }, headingLabel)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4Eawx")).default), {
            issuesSectionOptions: issuesSectionOptions,
            id: id,
            parentId: parentId,
            level: level,
            depth: depth,
            isCreateChildEnabled: isCreateChildEnabled,
            isCreateSiblingEnabled: isCreateSiblingEnabled,
            onInlineCreateClicked: onInlineCreateClicked,
            setInitialFocusRef: setInitialFocusRef,
            onDrop: onDrop,
            renderListItemMenuOption: renderListItemMenuOption,
            onCreateTriggerClick: onCreateTriggerClick,
            setCloseMenu: setCloseMenu,
            setOpenModal: setOpenModal
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dedQ1")).default), {
            id: id,
            customOtherSections: customOtherSections,
            onCreateTriggerClick: onCreateTriggerClick,
            setCloseMenu: setCloseMenu,
            setInitialFocusRef: issuesSectionOptions.length === 0 ? setInitialFocusRef : undefined,
            setOpenModal: setOpenModal,
            renderListItemMenuOption: renderListItemMenuOption
        }));
    };
    const $d23221329fab77af$var$headingWrap = (0, (0, parcelRequire("99gde")).xcss)({
        marginTop: 'space.250',
        marginBottom: 'space.075',
        paddingLeft: 'space.200',
        paddingRight: 'space.200'
    });
    var $d23221329fab77af$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($d23221329fab77af$var$SingleSelectOptions);
});
parcelRegister("4Eawx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$99ab925a6af54be0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $iZN6h;
    var $hyeSr;
    var $iup31;
    var $ek5AF;
    const $99ab925a6af54be0$var$ItemSectionOptions = ({ id: id, parentId: parentId, level: level, depth: depth, isCreateChildEnabled: isCreateChildEnabled, isCreateSiblingEnabled: isCreateSiblingEnabled, onInlineCreateClicked: onInlineCreateClicked, issuesSectionOptions: issuesSectionOptions, setInitialFocusRef: setInitialFocusRef, renderListItemMenuOption: renderListItemMenuOption, setCloseMenu: setCloseMenu, setOpenModal: setOpenModal, onDrop: onDrop, onCreateTriggerClick: onCreateTriggerClick })=>issuesSectionOptions.map(({ id: optionId }, index)=>{
            switch(optionId){
                case (0, (0, parcelRequire("iZN6h")).listItemMenu).CREATE_ITEM:
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iup31")).default), {
                        key: optionId,
                        id: id,
                        parentId: parentId,
                        level: level,
                        depth: depth,
                        isCreateChildEnabled: isCreateChildEnabled,
                        isCreateSiblingEnabled: isCreateSiblingEnabled,
                        onInlineCreateClicked: onInlineCreateClicked,
                        setInitialFocusRef: index === 0 ? setInitialFocusRef : undefined,
                        onCreateTriggerClick: onCreateTriggerClick,
                        setCloseMenu: setCloseMenu
                    });
                case (0, (0, parcelRequire("iZN6h")).listItemMenu).MOVE_ITEM:
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ek5AF")).default), {
                        id: id,
                        key: optionId,
                        level: level,
                        parentId: parentId,
                        setInitialFocusRef: index === 0 ? setInitialFocusRef : undefined,
                        onDrop: onDrop,
                        setCloseMenu: setCloseMenu
                    });
                default:
                    return (0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), {
                        key: optionId
                    }, renderListItemMenuOption({
                        id: id,
                        optionId: optionId,
                        setOpenModal: (event)=>setOpenModal(event, optionId),
                        setInitialFocusRef: index === 0 ? setInitialFocusRef : undefined,
                        Option: (0, (0, parcelRequire("hyeSr")).ListItemMenuOption),
                        onCreateTriggerClick: onCreateTriggerClick,
                        setCloseMenu: setCloseMenu
                    }));
            }
        });
    var $99ab925a6af54be0$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($99ab925a6af54be0$var$ItemSectionOptions);
});
parcelRegister("iup31", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c5fa1c1ac7ef259e$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $lwMsT;
    var $5gzbX;
    var $4R6GH;
    var $iZN6h;
    var $9puhl;
    var $hUAzM;
    var $hyeSr;
    var $lgz7j;
    var $7tmdB;
    const $c5fa1c1ac7ef259e$var$CreateItemMenu = ({ id: id, level: level, depth: depth, parentId: parentId, isCreateChildEnabled: isCreateChildEnabled, isCreateSiblingEnabled: isCreateSiblingEnabled, onInlineCreateClicked: onInlineCreateClicked, setInitialFocusRef: setInitialFocusRef, onCreateTriggerClick: onCreateTriggerClick, setCloseMenu: setCloseMenu })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [{ overrideLabels: overrideLabels }] = (0, (0, parcelRequire("9puhl")).useListItemMenuOptions)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const onClickCreateChildOption = (0, $5uXOq.useCallback)((event)=>{
            onCreateTriggerClick();
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'createChildMenuOption',
                attributes: {
                    position: (0, (0, parcelRequire("iZN6h")).INSIDE)
                }
            });
            (0, (0, parcelRequire("hUAzM")).fireUIAnalyticsEvent)(analyticsEvent);
            if (!(0, (0, parcelRequire("4R6GH")).fg)('platform_button_item-add-ufo-metrics')) (0, (0, parcelRequire("5gzbX")).default)('timeline-create-child-option-clicked', event.timeStamp);
            onInlineCreateClicked({
                parentId: id,
                position: (0, (0, parcelRequire("iZN6h")).INSIDE)
            });
            setCloseMenu(event, {
                shouldReturnFocus: false
            });
        }, [
            createAnalyticsEvent,
            id,
            onCreateTriggerClick,
            onInlineCreateClicked,
            setCloseMenu
        ]);
        const onClickCreateSiblingAboveOption = (0, $5uXOq.useCallback)((event)=>{
            onCreateTriggerClick();
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'createAboveMenuOption',
                attributes: {
                    position: (0, (0, parcelRequire("iZN6h")).BEFORE),
                    level: level,
                    depth: depth
                }
            });
            (0, (0, parcelRequire("hUAzM")).fireUIAnalyticsEvent)(analyticsEvent);
            if (!(0, (0, parcelRequire("4R6GH")).fg)('platform_button_item-add-ufo-metrics')) (0, (0, parcelRequire("5gzbX")).default)('timeline-create-above-option-clicked', event.timeStamp);
            onInlineCreateClicked({
                beforeId: id,
                parentId: parentId,
                position: (0, (0, parcelRequire("iZN6h")).BEFORE)
            });
            setCloseMenu(event, {
                shouldReturnFocus: false
            });
        }, [
            createAnalyticsEvent,
            depth,
            id,
            level,
            onCreateTriggerClick,
            onInlineCreateClicked,
            parentId,
            setCloseMenu
        ]);
        const createItemChildOptions = (0, $5uXOq.useMemo)(()=>{
            const options = [];
            if (isCreateChildEnabled) options.push({
                id: (0, (0, parcelRequire("iZN6h")).listItemMenu).CREATE_CHILD_ITEM,
                onClick: onClickCreateChildOption,
                ...(0, (0, parcelRequire("4R6GH")).fg)('platform_button_item-add-ufo-metrics') ? {
                    interactionName: 'timeline-create-child-option-clicked'
                } : {}
            });
            if (isCreateSiblingEnabled) options.push({
                id: (0, (0, parcelRequire("iZN6h")).listItemMenu).CREATE_ITEM_ABOVE,
                onClick: onClickCreateSiblingAboveOption,
                ...(0, (0, parcelRequire("4R6GH")).fg)('platform_button_item-add-ufo-metrics') ? {
                    interactionName: 'timeline-create-above-option-clicked'
                } : {}
            });
            return options;
        }, [
            isCreateChildEnabled,
            isCreateSiblingEnabled,
            onClickCreateChildOption,
            onClickCreateSiblingAboveOption
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hyeSr")).ListItemMenuOption), {
            setInitialFocusRef: setInitialFocusRef,
            label: (0, (0, parcelRequire("lgz7j")).renderOverrideLabel)(formatMessage, overrideLabels[(0, (0, parcelRequire("iZN6h")).listItemMenu).CREATE_ITEM]) || formatMessage((0, (0, parcelRequire("7tmdB")).default).createItem),
            ...(0, (0, parcelRequire("4R6GH")).fg)('platform_button_item-add-ufo-metrics') ? {
                interactionName: 'timeline-create-primary-option-clicked'
            } : {}
        }, ({ setInitialFocusRef: setChildFocusRef })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, createItemChildOptions.map(({ id: optionId, onClick: onClick, interactionName: interactionName }, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hyeSr")).ListItemMenuOption), {
                    key: optionId,
                    label: (0, (0, parcelRequire("lgz7j")).renderOverrideLabel)(formatMessage, overrideLabels[optionId]) || formatMessage((0, (0, parcelRequire("7tmdB")).default)[optionId]),
                    setInitialFocusRef: index === 0 ? setChildFocusRef : undefined,
                    ...(0, (0, parcelRequire("4R6GH")).fg)('platform_button_item-add-ufo-metrics') ? {
                        interactionName: interactionName
                    } : {},
                    onClick: onClick
                }))));
    };
    var $c5fa1c1ac7ef259e$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($c5fa1c1ac7ef259e$var$CreateItemMenu);
});
parcelRegister("7tmdB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$27ecaadd4d148c02$export$2e2bcd8739ae039);
    var $7VHMR;
    const $27ecaadd4d148c02$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        createItem: {
            id: 'roadmap.timeline-table.main.content.list.list-item.meatballs-button.meatball-popup.item-section-options.create-item-menu.create-item',
            defaultMessage: 'Create',
            description: 'Label for the create option in the list item menu'
        },
        createChildItem: {
            id: 'roadmap.timeline-table.main.content.list.list-item.meatballs-button.meatball-popup.item-section-options.create-item-menu.create-child-item',
            defaultMessage: 'Create child',
            description: 'Label for the create child option in the list item menu'
        },
        createItemAbove: {
            id: 'roadmap.timeline-table.main.content.list.list-item.meatballs-button.meatball-popup.item-section-options.create-item-menu.create-item-above',
            defaultMessage: 'Create above',
            description: 'Label for the create above option in the list item menu'
        },
        createItemBelow: {
            id: 'roadmap.timeline-table.main.content.list.list-item.meatballs-button.meatball-popup.item-section-options.create-item-menu.create-item-below',
            defaultMessage: 'Create below',
            description: 'Label for the create below option in the list item menu'
        }
    });
    var $27ecaadd4d148c02$export$2e2bcd8739ae039 = $27ecaadd4d148c02$var$messages;
});
parcelRegister("ek5AF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0c96c8479590de46$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $5gzbX;
    var $4R6GH;
    var $iZN6h;
    var $hGh1Z;
    var $9puhl;
    var $hyeSr;
    var $lgz7j;
    var $J8O27;
    const $0c96c8479590de46$var$MoveItemMenu = ({ id: id, level: level, parentId: parentId, onDrop: onDrop, setCloseMenu: setCloseMenu, setInitialFocusRef: setInitialFocusRef })=>{
        const [items] = (0, (0, parcelRequire("hGh1Z")).useItems)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [{ overrideLabels: overrideLabels }] = (0, (0, parcelRequire("9puhl")).useListItemMenuOptions)();
        const siblingItemIds = (0, $5uXOq.useMemo)(()=>{
            const siblingIds = [];
            items.forEach((item)=>{
                const { type: type, meta: meta } = item;
                if (type === (0, (0, parcelRequire("iZN6h")).ITEM_TYPE)) {
                    if (meta.parentId === parentId) siblingIds.push(item.item.id);
                }
            });
            return siblingIds;
        }, [
            items,
            parentId
        ]);
        const siblingItemsLength = siblingItemIds.length;
        const onMoveUp = (0, $5uXOq.useCallback)((event)=>{
            const currentIndex = siblingItemIds.findIndex((itemId)=>itemId === id);
            if (currentIndex > 0) {
                if (!(0, (0, parcelRequire("4R6GH")).fg)('platform_button_item-add-ufo-metrics')) (0, (0, parcelRequire("5gzbX")).default)('timeline-move-up-option-clicked', event.timeStamp);
                onDrop(id, {
                    level: level,
                    rankRequest: {
                        rankBeforeId: siblingItemIds[currentIndex - 1]
                    },
                    isMeatballsAction: true
                });
            }
        }, [
            id,
            level,
            siblingItemIds,
            onDrop
        ]);
        const onMoveDown = (0, $5uXOq.useCallback)((event)=>{
            const currentIndex = siblingItemIds.findIndex((itemId)=>itemId === id);
            if (currentIndex < siblingItemsLength - 1) {
                if (!(0, (0, parcelRequire("4R6GH")).fg)('platform_button_item-add-ufo-metrics')) (0, (0, parcelRequire("5gzbX")).default)('timeline-move-down-option-clicked', event.timeStamp);
                onDrop(id, {
                    level: level,
                    rankRequest: {
                        rankAfterId: siblingItemIds[currentIndex + 1]
                    },
                    isMeatballsAction: true
                });
            }
        }, [
            siblingItemIds,
            siblingItemsLength,
            id,
            onDrop,
            level
        ]);
        const onMoveToTop = (0, $5uXOq.useCallback)((event)=>{
            if (siblingItemsLength > 0) {
                if (!(0, (0, parcelRequire("4R6GH")).fg)('platform_button_item-add-ufo-metrics')) (0, (0, parcelRequire("5gzbX")).default)('timeline-move-to-top-option-clicked', event.timeStamp);
                onDrop(id, {
                    level: level,
                    rankRequest: {
                        rankBeforeId: siblingItemIds[0]
                    },
                    isMeatballsAction: true
                });
            }
        }, [
            siblingItemsLength,
            onDrop,
            id,
            level,
            siblingItemIds
        ]);
        const onMoveToBottom = (0, $5uXOq.useCallback)((event)=>{
            if (siblingItemsLength > 0) {
                if (!(0, (0, parcelRequire("4R6GH")).fg)('platform_button_item-add-ufo-metrics')) (0, (0, parcelRequire("5gzbX")).default)('timeline-move-to-bottom-option-clicked', event.timeStamp);
                onDrop(id, {
                    level: level,
                    rankRequest: {
                        rankAfterId: siblingItemIds[siblingItemsLength - 1]
                    },
                    isMeatballsAction: true
                });
            }
        }, [
            onDrop,
            id,
            level,
            siblingItemIds,
            siblingItemsLength
        ]);
        const moveItemChildOptions = (0, $5uXOq.useMemo)(()=>{
            const isMoveUpDisabled = !siblingItemsLength || id === siblingItemIds?.[0];
            const isMoveDownDisabled = !siblingItemsLength || id === siblingItemIds[siblingItemsLength - 1];
            const options = [
                {
                    id: (0, (0, parcelRequire("iZN6h")).listItemMenu).MOVE_ITEM_UP,
                    onClick: onMoveUp,
                    isDisabled: isMoveUpDisabled,
                    ...(0, (0, parcelRequire("4R6GH")).fg)('platform_button_item-add-ufo-metrics') ? {
                        interactionName: 'timeline-move-up-option-clicked'
                    } : {}
                },
                {
                    id: (0, (0, parcelRequire("iZN6h")).listItemMenu).MOVE_ITEM_DOWN,
                    onClick: onMoveDown,
                    isDisabled: isMoveDownDisabled,
                    ...(0, (0, parcelRequire("4R6GH")).fg)('platform_button_item-add-ufo-metrics') ? {
                        interactionName: 'timeline-move-down-option-clicked'
                    } : {}
                },
                {
                    id: (0, (0, parcelRequire("iZN6h")).listItemMenu).MOVE_ITEM_TO_TOP,
                    onClick: onMoveToTop,
                    isDisabled: isMoveUpDisabled,
                    ...(0, (0, parcelRequire("4R6GH")).fg)('platform_button_item-add-ufo-metrics') ? {
                        interactionName: 'timeline-move-to-top-option-clicked'
                    } : {}
                },
                {
                    id: (0, (0, parcelRequire("iZN6h")).listItemMenu).MOVE_ITEM_TO_BOTTOM,
                    onClick: onMoveToBottom,
                    isDisabled: isMoveDownDisabled,
                    ...(0, (0, parcelRequire("4R6GH")).fg)('platform_button_item-add-ufo-metrics') ? {
                        interactionName: 'timeline-move-to-bottom-option-clicked'
                    } : {}
                }
            ];
            return options;
        }, [
            id,
            onMoveDown,
            onMoveToBottom,
            onMoveToTop,
            onMoveUp,
            siblingItemIds,
            siblingItemsLength
        ]);
        const firstEnabledOptionIndex = moveItemChildOptions.findIndex((option)=>!option.isDisabled);
        const renderMoveItemChildOptions = (0, $5uXOq.useCallback)(({ id: optionId, onClick: onClick, isDisabled: isDisabled, interactionName: interactionName }, index, setChildFocusRef)=>{
            const handleClick = (e)=>{
                onClick(e);
                setCloseMenu(e);
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hyeSr")).ListItemMenuOption), {
                key: optionId,
                label: (0, (0, parcelRequire("lgz7j")).renderOverrideLabel)(formatMessage, overrideLabels[optionId]) || formatMessage((0, (0, parcelRequire("J8O27")).default)[optionId]),
                setInitialFocusRef: firstEnabledOptionIndex === index ? setChildFocusRef : undefined,
                isDisabled: isDisabled,
                ...(0, (0, parcelRequire("4R6GH")).fg)('platform_button_item-add-ufo-metrics') ? {
                    interactionName: interactionName
                } : {},
                onClick: handleClick
            });
        }, [
            firstEnabledOptionIndex,
            formatMessage,
            overrideLabels,
            setCloseMenu
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hyeSr")).ListItemMenuOption), {
            setInitialFocusRef: setInitialFocusRef,
            isDisabled: siblingItemsLength <= 1,
            label: (0, (0, parcelRequire("lgz7j")).renderOverrideLabel)(formatMessage, overrideLabels[(0, (0, parcelRequire("iZN6h")).listItemMenu).MOVE_ITEM]) || formatMessage((0, (0, parcelRequire("J8O27")).default).moveItem),
            ...(0, (0, parcelRequire("4R6GH")).fg)('platform_button_item-add-ufo-metrics') ? {
                interactionName: 'timeline-move-primary-option-clicked'
            } : {}
        }, ({ setInitialFocusRef: setChildFocusRef })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, moveItemChildOptions.map((option, index)=>renderMoveItemChildOptions(option, index, setChildFocusRef))));
    };
    var $0c96c8479590de46$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($0c96c8479590de46$var$MoveItemMenu);
});
parcelRegister("J8O27", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$999988b18591c272$export$2e2bcd8739ae039);
    var $7VHMR;
    const $999988b18591c272$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        moveItem: {
            id: 'roadmap.timeline-table.main.content.list.list-item.meatballs-button.meatball-popup.item-section-options.move-item-menu.move-item',
            defaultMessage: 'Move',
            description: 'Label for the move option in the list item menu'
        },
        moveItemUp: {
            id: 'roadmap.timeline-table.main.content.list.list-item.meatballs-button.meatball-popup.item-section-options.move-item-menu.move-item-up',
            defaultMessage: 'Move up',
            description: 'Label for the move up option in the list item menu'
        },
        moveItemDown: {
            id: 'roadmap.timeline-table.main.content.list.list-item.meatballs-button.meatball-popup.item-section-options.move-item-menu.move-item-down',
            defaultMessage: 'Move down',
            description: 'Label for the move down option in the list item menu'
        },
        moveItemToTop: {
            id: 'roadmap.timeline-table.main.content.list.list-item.meatballs-button.meatball-popup.item-section-options.move-item-menu.move-item-to-top',
            defaultMessage: 'Move to top',
            description: 'Label for the move to top option in the list item menu'
        },
        moveItemToBottom: {
            id: 'roadmap.timeline-table.main.content.list.list-item.meatballs-button.meatball-popup.item-section-options.move-item-menu.move-item-to-bottom',
            defaultMessage: 'Move to bottom',
            description: 'Label for the move to bottom option in the list item menu'
        }
    });
    var $999988b18591c272$export$2e2bcd8739ae039 = $999988b18591c272$var$messages;
});
parcelRegister("3euyd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$56d53d8a5184a382$export$2e2bcd8739ae039);
    var $7VHMR;
    var $56d53d8a5184a382$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        expand: {
            id: 'roadmap.timeline-table.main.content.list.list-item.expand',
            defaultMessage: 'Show child issues',
            description: 'Button label. Button expands and collapses a list item on Timelines issue list.'
        },
        collapse: {
            id: 'roadmap.timeline-table.main.content.list.list-item.collapse',
            defaultMessage: 'Hide child issues',
            description: 'Button label. Button expands and collapses a list item on Timelines issue list.'
        },
        createSibling: {
            id: 'roadmap.timeline-table.main.content.list.list-item.create-sibling',
            defaultMessage: 'Create issue',
            description: 'Button label. Button begins issue creation process inline on Timelines issue list.'
        },
        createChild: {
            id: 'roadmap.timeline-table.main.content.list.list-item.create-child',
            defaultMessage: 'Create child issue',
            description: 'Button label. Button begins issue creation process inline on Timelines issue list.'
        },
        done: {
            id: 'roadmap.timeline-table.main.content.list.list-item.done',
            defaultMessage: 'Done',
            description: 'Icon label. Icon appears when issue is in the done status category.'
        },
        expandIssueTermRefresh: {
            id: 'roadmap.timeline-table.main.content.list.list-item.expand-issue-term-refresh',
            defaultMessage: 'Show work items',
            description: 'Button label. Button expands and collapses a list item on Timelines issue list.'
        },
        collapseIssueTermRefresh: {
            id: 'roadmap.timeline-table.main.content.list.list-item.collapse-issue-term-refresh',
            defaultMessage: 'Hide work items',
            description: 'Button label. Button expands and collapses a list item on Timelines issue list.'
        },
        createSiblingIssueTermRefresh: {
            id: 'roadmap.timeline-table.main.content.list.list-item.create-sibling-issue-term-refresh',
            defaultMessage: 'Create work item',
            description: 'Button label. Button begins issue creation process inline on Timelines issue list.'
        },
        createChildIssueTermRefresh: {
            id: 'roadmap.timeline-table.main.content.list.list-item.create-child-issue-term-refresh',
            defaultMessage: 'Create child work item',
            description: 'Button label. Button begins issue creation process inline on Timelines issue list.'
        }
    });
});
parcelRegister("4vwx2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$13a5365f09f08fff$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $iKImW;
    var $3C8rg;
    const $13a5365f09f08fff$var$ListItemSelectCheckbox = ({ id: id, onToggle: onToggle, isChecked: isChecked, isDisabled: isDisabled })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const handleClick = (0, $5uXOq.useCallback)((e)=>{
            e.stopPropagation();
            onToggle(e);
        }, [
            onToggle
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iKImW")).default), {
            value: `${id} selected`,
            "aria-label": formatMessage((0, (0, parcelRequire("3C8rg")).default).label),
            isChecked: isChecked,
            isDisabled: isDisabled,
            onClick: handleClick
        });
    };
    var $13a5365f09f08fff$export$2e2bcd8739ae039 = $13a5365f09f08fff$var$ListItemSelectCheckbox;
});
parcelRegister("iKImW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ec5980beae429bf0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $2cjvv;
    var $jXXts;
    var $99ZKq;
    var $c8uX8;
    var $8U8U2;
    var $7TKqh;
    const $ec5980beae429bf0$var$checkboxStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        width: '100%',
        height: '100%',
        margin: "var(--ds-space-0, 0px)",
        appearance: 'none',
        border: 'none',
        gridArea: '1 / 1 / 2 / 2',
        opacity: 0,
        outline: 'none',
        '& + svg': {
            '--checkbox-background-color': 'var(--local-background)',
            '--checkbox-border-color': 'var(--local-border)',
            '--checkbox-tick-color': 'var(--local-tick-rest)',
            color: 'var(--checkbox-background-color)',
            fill: 'var(--checkbox-tick-color)',
            gridArea: '1 / 1 / 2 / 2',
            pointerEvents: 'none',
            transition: 'color 0.2s ease-in-out, fill 0.2s ease-in-out',
            'rect:first-of-type': {
                stroke: 'var(--checkbox-border-color)',
                strokeWidth: "var(--ds-border-width, 1px)",
                transition: 'stroke 0.2s ease-in-out'
            }
        },
        '&&:focus + svg, &&:checked:focus + svg': {
            borderRadius: "var(--ds-border-radius, 0.25rem)",
            outline: `${"var(--ds-border-width-outline, 2px)"} solid ${`var(--ds-border-focused, ${(0, $72ba03e317f3d228$export$215b7063051591f1)})`}`,
            outlineOffset: "var(--ds-space-negative-025, -2px)"
        },
        '&:hover + svg': {
            '--checkbox-background-color': 'var(--local-background-hover)',
            '--checkbox-border-color': 'var(--local-border-hover)'
        },
        '&:checked:hover + svg': {
            '--checkbox-background-color': 'var(--local-background-checked-hover)',
            '--checkbox-border-color': 'var(--local-border-checked-hover)'
        },
        '&:checked + svg': {
            '--checkbox-background-color': 'var(--local-background-checked)',
            '--checkbox-border-color': 'var(--local-border-checked)',
            '--checkbox-tick-color': 'var(--local-tick-checked)'
        },
        '&[data-invalid] + svg': {
            '--checkbox-border-color': 'var(--local-border-invalid)'
        },
        '&:checked[data-invalid] + svg': {
            '--checkbox-border-color': 'var(--local-border-checked-invalid)'
        },
        '&:active + svg': {
            '--checkbox-background-color': 'var(--local-background-active)',
            '--checkbox-border-color': 'var(--local-border-active)'
        },
        '&:checked:active + svg': {
            '--checkbox-background-color': 'var(--local-background-active)',
            '--checkbox-border-color': 'var(--local-border-active)',
            '--checkbox-tick-color': 'var(--local-tick-active)'
        },
        '&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg': {
            '--checkbox-background-color': 'var(--local-background-disabled)',
            '--checkbox-border-color': 'var(--local-border-disabled)',
            cursor: 'not-allowed',
            pointerEvents: 'none'
        },
        '&:disabled:checked + svg': {
            '--checkbox-tick-color': 'var(--local-tick-disabled)'
        },
        '&:indeterminate + svg': {
            '--checkbox-background-color': 'var(--local-background-checked)',
            '--checkbox-border-color': 'var(--local-border-checked)',
            '--checkbox-tick-color': 'var(--local-tick-checked)'
        },
        '&:disabled:indeterminate + svg': {
            '--checkbox-background-color': 'var(--local-background-disabled)',
            '--checkbox-border-color': 'var(--local-border-disabled)',
            '--checkbox-tick-color': 'var(--local-tick-disabled)'
        },
        '@media screen and (forced-colors: active)': {
            '& + svg': {
                '--checkbox-background-color': 'Canvas',
                '--checkbox-border-color': 'CanvasText',
                '--checkbox-tick-color': 'CanvasText'
            },
            '&:checked + svg, &:checked:hover + svg': {
                '--checkbox-background-color': 'Canvas',
                '--checkbox-border-color': 'CanvasText',
                '--checkbox-tick-color': 'CanvasText'
            },
            '&:focus + svg rect:first-of-type': {
                stroke: 'Highlight'
            },
            '&[data-invalid] + svg': {
                '--checkbox-border-color': 'Highlight'
            },
            '&:checked[data-invalid] + svg': {
                '--checkbox-border-color': 'Highlight'
            },
            '&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg': {
                '--checkbox-background-color': 'Canvas',
                '--checkbox-border-color': 'GrayText',
                '--checkbox-tick-color': 'GrayText'
            }
        }
    });
    const $ec5980beae429bf0$var$Checkbox = (0, $5uXOq.memo)((0, $5uXOq.forwardRef)(function Checkbox(props, ref) {
        const { isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, ...rest } = props;
        const [isCheckedState, setIsCheckedState] = (0, $5uXOq.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
        const onChange = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
            setIsCheckedState(e.target.checked);
            if (onChangeProps) onChangeProps(e, analyticsEvent);
        }, [
            onChangeProps
        ]);
        const onChangeAnalytics = (0, (0, parcelRequire("2cjvv")).usePlatformLeafEventHandler)({
            fn: onChange,
            action: 'changed',
            analyticsData: analyticsContext,
            componentName: 'checkbox',
            packageName: "platform-pkg",
            packageVersion: "0.0.0-use.local"
        });
        const internalRef = (0, $5uXOq.useRef)(null);
        const mergedRefs = (0, (0, parcelRequire("jXXts")).default)([
            internalRef,
            ref
        ]);
        const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
        (0, $5uXOq.useEffect)(()=>{
            if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
        }, [
            isIndeterminate
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("c8uX8")).default), {
            isDisabled: isDisabled,
            label: label,
            id: rest.id ? `${rest.id}-label` : undefined,
            testId: testId && `${testId}--checkbox-label`,
            xcss: xcss
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            tabIndex: 0,
            ...rest,
            type: "checkbox",
            ref: mergedRefs,
            disabled: isDisabled,
            checked: isChecked,
            value: value,
            name: name,
            required: isRequired,
            css: $ec5980beae429bf0$var$checkboxStyles,
            onChange: onChangeAnalytics,
            "aria-invalid": isInvalid ? 'true' : undefined,
            "data-testid": testId && `${testId}--hidden-checkbox`,
            "data-invalid": isInvalid ? 'true' : undefined
        }), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("99ZKq")).default), {
            isIndeterminate: isIndeterminate,
            isChecked: isChecked
        }), label && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("8U8U2")).default), null, label, isRequired && (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("7TKqh")).default), null)));
    }));
    $ec5980beae429bf0$var$Checkbox.displayName = 'Checkbox';
    var $ec5980beae429bf0$export$2e2bcd8739ae039 = $ec5980beae429bf0$var$Checkbox;
});
parcelRegister("99ZKq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4db890d47c10939a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $dqbQ1;
    function $4db890d47c10939a$var$getIcon(isIndeterminate, isChecked) {
        if (isIndeterminate) return (0, (0, parcelRequire("f8Sb3")).jsx)("rect", {
            fill: "inherit",
            x: "8",
            y: "11",
            width: "8",
            height: "2",
            rx: "1"
        });
        if (isChecked) return (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
            d: "M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
            fill: "inherit"
        });
        return null;
    }
    const $4db890d47c10939a$var$CheckboxIcon = (0, $5uXOq.memo)(({ isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
        const icon = (0, $5uXOq.useMemo)(()=>$4db890d47c10939a$var$getIcon(isIndeterminate, isChecked), [
            isIndeterminate,
            isChecked
        ]);
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("dqbQ1")).default), {
            label: "",
            primaryColor: "var(--checkbox-background-color)",
            secondaryColor: "var(--checkbox-tick-color)"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("g", {
            fillRule: "evenodd"
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("rect", {
            fill: "currentColor",
            x: "6",
            y: "6",
            width: "12",
            height: "12",
            rx: "2"
        }), icon));
    });
    var $4db890d47c10939a$export$2e2bcd8739ae039 = $4db890d47c10939a$var$CheckboxIcon;
});
parcelRegister("c8uX8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9767db9a5c3364bd$export$2e2bcd8739ae039);
    var $f8Sb3;
    const $9767db9a5c3364bd$var$baseStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        display: 'grid',
        gridAutoColumns: '1fr',
        gridAutoRows: 'min-content',
        color: `var(--ds-text, ${(0, $72ba03e317f3d228$export$fbda843f0a27fe96)})`,
        cursor: 'default',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
    });
    const $9767db9a5c3364bd$var$textLabelLayoutStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        gap: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-050, 4px)"}`,
        gridTemplateColumns: 'min-content auto'
    });
    const $9767db9a5c3364bd$var$disabledStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        color: `var(--ds-text-disabled, ${(0, $72ba03e317f3d228$export$eaa8c8a70ac22806)})`,
        cursor: 'not-allowed'
    });
    const $9767db9a5c3364bd$var$labelStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        '--local-background': `var(--ds-background-input, ${(0, $72ba03e317f3d228$export$e655ef011c4aa1a2)})`,
        '--local-background-active': `var(--ds-background-input-pressed, ${(0, $72ba03e317f3d228$export$226de0355ed012f8)})`,
        '--local-background-checked': `var(--ds-background-selected-bold, ${(0, $72ba03e317f3d228$export$b3de0ae08da2ce64)})`,
        '--local-background-checked-hover': `var(--ds-background-selected-bold-hovered, ${(0, $72ba03e317f3d228$export$e62e8919cca44969)})`,
        '--local-background-disabled': `var(--ds-background-disabled, ${(0, $72ba03e317f3d228$export$9fdfb749e33cdf97)})`,
        '--local-background-hover': `var(--ds-background-input-hovered, ${(0, $72ba03e317f3d228$export$3e51e8f1440314ba)})`,
        '--local-border': `var(--ds-border-input, ${(0, $72ba03e317f3d228$export$d6447c357493214f)})`,
        '--local-border-active': `var(--ds-border, ${(0, $72ba03e317f3d228$export$226de0355ed012f8)})`,
        '--local-border-checked': `var(--ds-background-selected-bold, ${(0, $72ba03e317f3d228$export$b3de0ae08da2ce64)})`,
        '--local-border-checked-hover': `var(--ds-background-selected-bold-hovered, ${(0, $72ba03e317f3d228$export$e62e8919cca44969)})`,
        '--local-border-checked-invalid': `var(--ds-border-danger, ${(0, $72ba03e317f3d228$export$4a7404f376229999)})`,
        '--local-border-disabled': `var(--ds-background-disabled, ${(0, $72ba03e317f3d228$export$9fdfb749e33cdf97)})`,
        '--local-border-focus': `var(--ds-border-focused, ${(0, $72ba03e317f3d228$export$215b7063051591f1)})`,
        '--local-border-hover': `var(--ds-border-input, ${(0, $72ba03e317f3d228$export$d6447c357493214f)})`,
        '--local-border-invalid': `var(--ds-border-danger, ${(0, $72ba03e317f3d228$export$4a7404f376229999)})`,
        '--local-tick-active': `var(--ds-icon-inverse, ${(0, $72ba03e317f3d228$export$b3de0ae08da2ce64)})`,
        '--local-tick-checked': `var(--ds-icon-inverse, ${(0, $72ba03e317f3d228$export$e655ef011c4aa1a2)})`,
        '--local-tick-disabled': `var(--ds-icon-disabled, ${(0, $72ba03e317f3d228$export$5f71e19f3a7ad9de)})`,
        '--local-tick-rest': 'transparent'
    });
    function $9767db9a5c3364bd$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, testId: testId, label: label, id: id, xcss: xcss }) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)("label", {
            className: xcss,
            css: [
                $9767db9a5c3364bd$var$baseStyles,
                label && $9767db9a5c3364bd$var$textLabelLayoutStyles,
                isDisabled && $9767db9a5c3364bd$var$disabledStyles,
                $9767db9a5c3364bd$var$labelStyles
            ],
            "data-testid": testId,
            "data-disabled": isDisabled || undefined,
            id: id
        }, children);
    }
});
parcelRegister("8U8U2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e82f3710f559a90a$export$2e2bcd8739ae039);
    var $f8Sb3;
    function $e82f3710f559a90a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $e82f3710f559a90a$var$labelTextStyles = {
        name: "12hofyr",
        styles: "align-self:center;grid-area:1 / 2 / 2 / 3"
    };
    function $e82f3710f559a90a$export$2e2bcd8739ae039({ children: children }) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $e82f3710f559a90a$var$labelTextStyles
        }, children);
    }
});
parcelRegister("7TKqh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$75f0ce159cbebe91$export$2e2bcd8739ae039);
    var $f8Sb3;
    const $75f0ce159cbebe91$var$requiredIndicatorStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        color: `var(--ds-text-danger, ${(0, $72ba03e317f3d228$export$2837b5a1a71d5c02)})`,
        paddingInlineStart: "var(--ds-space-025, 2px)"
    });
    function $75f0ce159cbebe91$export$2e2bcd8739ae039() {
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $75f0ce159cbebe91$var$requiredIndicatorStyles,
            "aria-hidden": true
        }, "*");
    }
});
parcelRegister("3C8rg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4a60fe46a29e758c$export$2e2bcd8739ae039);
    var $7VHMR;
    var $4a60fe46a29e758c$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        label: {
            id: 'roadmap.timeline-table.main.content.list.list-item.select-checkbox.label',
            defaultMessage: 'Row selection',
            description: 'Label for the select checkbox on each of the rows.'
        }
    });
});
parcelRegister("bNMH3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$83c79864653d2022$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5EOne = parcelRequire("5EOne");
    var $gOxHv = parcelRequire("gOxHv");
    var $iZN6h;
    const $83c79864653d2022$var$useListItemDrag = ({ id: id, level: level, depth: depth, parentId: parentId, canDrag: canDrag, sideEffectMarshal: sideEffectMarshal })=>{
        const cleanupDragAndDrop = (0, $5uXOq.useRef)(null);
        const { onRowGenerateDragPreview: onRowGenerateDragPreview } = sideEffectMarshal;
        const makeDraggable = (0, $5uXOq.useCallback)((dragElement)=>{
            const el = dragElement;
            if (el === null) return;
            cleanupDragAndDrop.current = (0, $5EOne.combine)((0, $gOxHv.draggable)({
                element: el,
                canDrag: ()=>canDrag,
                getInitialData: ()=>({
                        type: (0, (0, parcelRequire("iZN6h")).ROW_DRAG_AND_DROP_ID),
                        id: id,
                        level: level,
                        depth: depth,
                        parentId: parentId
                    }),
                onGenerateDragPreview: ()=>{
                    onRowGenerateDragPreview();
                }
            }));
        }, [
            canDrag,
            id,
            level,
            depth,
            parentId,
            onRowGenerateDragPreview
        ]);
        const cleanupDraggable = (0, $5uXOq.useCallback)(()=>{
            cleanupDragAndDrop.current?.();
        }, []);
        return [
            makeDraggable,
            cleanupDraggable
        ];
    };
    var $83c79864653d2022$export$2e2bcd8739ae039 = $83c79864653d2022$var$useListItemDrag;
});
parcelRegister("kBjnL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9dd0b3fbe7e8d4fa$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $cSD7y;
    var $9puhl;
    var $8wpG6;
    var $5qL6X;
    const $9dd0b3fbe7e8d4fa$var$ResizerComponent = (0, (0, parcelRequire("cSD7y")).componentWithFG)('jsw_roadmaps_timeline_table_custom_scroll_pdnd', (0, (0, parcelRequire("5qL6X")).default), (0, (0, parcelRequire("8wpG6")).default));
    const $9dd0b3fbe7e8d4fa$var$containerStyles = null;
    const $9dd0b3fbe7e8d4fa$var$listResizerContainerStyles = null;
    const $9dd0b3fbe7e8d4fa$var$ListResizer = ({ DndLongTaskMetric: DndLongTaskMetric, onSetListWidth: onSetListWidth })=>{
        const [listWidth, { setListWidth: setListWidth }] = (0, (0, parcelRequire("9puhl")).useListWidth)();
        const onResize = (0, $5uXOq.useCallback)((width)=>{
            setListWidth(width);
        }, [
            setListWidth
        ]);
        const onResizeEnd = (0, $5uXOq.useCallback)(()=>{
            onSetListWidth(listWidth);
        }, [
            listWidth,
            onSetListWidth
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _1e0c1txw _154iidpf _94n5idpf _1ltvidpf _1bsb1osq _lcxvglyw"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            style: {
                width: `${listWidth}px`
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqsw1if8 _1ltvidpf _1pbyilow"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($9dd0b3fbe7e8d4fa$var$ResizerComponent, {
            width: listWidth,
            DndLongTaskMetric: DndLongTaskMetric,
            onResize: onResize,
            onResizeEnd: onResizeEnd
        })));
    };
    var $9dd0b3fbe7e8d4fa$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($9dd0b3fbe7e8d4fa$var$ListResizer);
});
parcelRegister("8wpG6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bdf3f3af3b07f0a5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $3PELs = parcelRequire("3PELs");
    var $lwMsT;
    var $iZN6h;
    var $hUAzM;
    var $h7CQc;
    var $9qpVA;
    const $bdf3f3af3b07f0a5$var$Resizer = ({ width: width, DndLongTaskMetric: DndLongTaskMetric, onResize: onResize, onResizeEnd: onResizeEnd })=>{
        const initialWidth = (0, $5uXOq.useRef)(width);
        const [isDragging, setIsDragging] = (0, $5uXOq.useState)(false);
        const maxWidth = (0, (0, parcelRequire("9qpVA")).useMaxWidth)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        (0, $5uXOq.useEffect)(()=>{
            width > maxWidth && onResize(maxWidth);
        }, [
            width,
            maxWidth,
            onResize
        ]);
        const onDragStart = (0, $5uXOq.useCallback)(()=>{
            initialWidth.current = width;
            setIsDragging(true);
        }, [
            width
        ]);
        const onDrag = (0, $5uXOq.useCallback)((_from, to, start)=>{
            const newWidth = Math.round(initialWidth.current + to.x - start.x);
            const saneWidth = (0, ($parcel$interopDefault($3PELs)))(newWidth, (0, (0, parcelRequire("iZN6h")).MINIMUM_LIST_WIDTH)(), maxWidth);
            onResize(saneWidth);
        }, [
            maxWidth,
            onResize
        ]);
        const onDragEnd = (0, $5uXOq.useCallback)((from, to)=>{
            const analyticsEvent = createAnalyticsEvent({
                action: 'resized',
                actionSubject: 'list',
                actionSubjectId: 'resizedList',
                attributes: {
                    didExpand: to.x > from.x
                }
            });
            (0, (0, parcelRequire("hUAzM")).fireUIAnalyticsEvent)(analyticsEvent);
            setIsDragging(false);
            onResizeEnd(initialWidth.current);
        }, [
            createAnalyticsEvent,
            onResizeEnd
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("h7CQc")).default), {
            onDragStart: onDragStart,
            onDrag: onDrag,
            onDragEnd: onDragEnd
        }), DndLongTaskMetric !== undefined && (0, ($parcel$interopDefault($5uXOq))).createElement(DndLongTaskMetric, {
            isDragging: isDragging,
            metricType: (0, (0, parcelRequire("iZN6h")).LIST_RESIZE_DRAG_AND_DROP)
        }));
    };
    var $bdf3f3af3b07f0a5$export$2e2bcd8739ae039 = $bdf3f3af3b07f0a5$var$Resizer;
});
parcelRegister("3PELs", function(module, exports) {
    var $gPWEE = parcelRequire("gPWEE");
    var $1sXeC = parcelRequire("1sXeC");
    function $2ca5c181afe24ac6$var$clamp(number, lower, upper) {
        if (upper === undefined) {
            upper = lower;
            lower = undefined;
        }
        if (upper !== undefined) {
            upper = $1sXeC(upper);
            upper = upper === upper ? upper : 0;
        }
        if (lower !== undefined) {
            lower = $1sXeC(lower);
            lower = lower === lower ? lower : 0;
        }
        return $gPWEE($1sXeC(number), lower, upper);
    }
    module.exports = $2ca5c181afe24ac6$var$clamp;
});
parcelRegister("gPWEE", function(module, exports) {
    function $c41ee85d08292e29$var$baseClamp(number, lower, upper) {
        if (number === number) {
            if (upper !== undefined) number = number <= upper ? number : upper;
            if (lower !== undefined) number = number >= lower ? number : lower;
        }
        return number;
    }
    module.exports = $c41ee85d08292e29$var$baseClamp;
});
parcelRegister("h7CQc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$949c73c24e654306$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $fNuuD;
    const $949c73c24e654306$var$ResizeHandler = ({ isDragging: isDragging, children: children, ...props })=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            ...props,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _154iidpf _1xi21i6y _1bsbu2gc _4t3i1osq _1pbyilow _v564ryu7 _lcxv1rj4 _80omuf7j _18postnw _1ywu1ule _aetrb3bt _15l2idpf _32rxv77o _z0aiv77o _1qdg1osq _16r21can _11fnglyw",
                isDragging ? "_tzy4kb7n" : "_tzy4idpf _16l4kb7n"
            ])
        }, children);
    var $949c73c24e654306$export$2e2bcd8739ae039 = (0, (0, parcelRequire("fNuuD")).withDragObserver)($949c73c24e654306$var$ResizeHandler);
    const $949c73c24e654306$var$resizeHandlerStyles = null;
    const $949c73c24e654306$var$staticStyles = null;
    const $949c73c24e654306$var$draggingStyles = null;
});
parcelRegister("fNuuD", function(module, exports) {
    $parcel$export(module.exports, "withDragObserver", ()=>$6a9466b713e40645$export$a0ae95ab2800c7f2);
    var $5uXOq = parcelRequire("5uXOq");
    var $7nsd3 = parcelRequire("7nsd3");
    var $fr1K2 = parcelRequire("fr1K2");
    var $aRGMp;
    const $6a9466b713e40645$export$13171b62aaa278f9 = 3;
    const $6a9466b713e40645$var$DISABLED_DRAG_PROPS = [
        'onMouseDown',
        'onDragStart',
        'onDrag',
        'onDragEnd'
    ];
    const $6a9466b713e40645$var$ENABLED_DRAG_PROPS = [
        'onMouseDown',
        'onClick',
        'onDragStart',
        'onDrag',
        'onDragEnd'
    ];
    const $6a9466b713e40645$var$getMousePosition = (event)=>({
            x: event.pageX,
            y: event.pageY
        });
    const $6a9466b713e40645$var$requestAnimationFrame = (0, (0, parcelRequire("aRGMp")).createRaf)();
    const $6a9466b713e40645$export$a0ae95ab2800c7f2 = (WrappedComponent, threshold = $6a9466b713e40645$export$13171b62aaa278f9)=>{
        class DragObserver extends (0, $5uXOq.PureComponent) {
            static{
                this.defaultProps = {
                    isDisabled: false,
                    onMouseDown: undefined,
                    onDragStart: undefined,
                    onDrag: undefined,
                    onDragEnd: undefined,
                    onClick: undefined
                };
            }
            constructor(props){
                super(props);
                this.onChildMouseDown = (event)=>{
                    if (this.props.isDisabled || event.button !== 0) return;
                    event.preventDefault();
                    event.stopPropagation();
                    this.addWindowEventListeners();
                    const dragStart = $6a9466b713e40645$var$getMousePosition(event);
                    this.setState({
                        isDragging: false,
                        dragStart: dragStart,
                        previousDragPosition: dragStart
                    }, ()=>this.onMouseDown(event));
                };
                this.onWindowMouseMove = (event)=>{
                    event.preventDefault();
                    const mouse = $6a9466b713e40645$var$getMousePosition(event);
                    const { isDragging: isDragging, dragStart: dragStart, previousDragPosition: previousDragPosition } = this.state;
                    if (!isDragging) {
                        if (Math.abs(mouse.x - dragStart.x) > threshold || Math.abs(mouse.y - dragStart.y) > threshold) {
                            this.setState({
                                isDragging: true
                            });
                            this.onDragStart(dragStart);
                        }
                    } else {
                        const from = previousDragPosition;
                        const to = mouse;
                        this.setState({
                            previousDragPosition: mouse
                        });
                        this.onDrag(from, to, dragStart);
                    }
                };
                this.onWindowMouseUp = (event)=>{
                    const { isDragging: isDragging, dragStart: dragStart } = this.state;
                    if (isDragging) {
                        const mouse = $6a9466b713e40645$var$getMousePosition(event);
                        const start = dragStart;
                        const end = mouse;
                        if (this.mounted) this.setState({
                            isDragging: false
                        });
                        this.onDragEnd(start, end);
                    } else if (event.button === 0 && ((navigator?.userAgent ?? '').includes('Mac') ? !event.ctrlKey : true)) this.onClick(event);
                    this.removeWindowEventListeners();
                };
                this.animationId = undefined;
                this.mounted = false;
                this.state = {
                    isDragging: false,
                    dragStart: {
                        x: 0,
                        y: 0
                    },
                    previousDragPosition: {
                        x: 0,
                        y: 0
                    }
                };
            }
            componentDidMount() {
                this.mounted = true;
                this.ref = (0, ($parcel$interopDefault($7nsd3))).findDOMNode(this);
                if (this.ref) this.ref.addEventListener('mousedown', this.onChildMouseDown);
            }
            componentWillUnmount() {
                if (this.ref) this.ref.removeEventListener('mousedown', this.onChildMouseDown);
                this.removeWindowEventListeners();
                if (this.animationId !== undefined) {
                    cancelAnimationFrame(this.animationId);
                    this.animationId = undefined;
                }
                this.mounted = false;
            }
            addWindowEventListeners() {
                window.addEventListener('mousemove', this.onWindowMouseMove);
                window.addEventListener('mouseup', this.onWindowMouseUp);
            }
            removeWindowEventListeners() {
                window.removeEventListener('mousemove', this.onWindowMouseMove);
                window.removeEventListener('mouseup', this.onWindowMouseUp);
            }
            onMouseDown(event) {
                if (this.props.onMouseDown) this.props.onMouseDown(event);
            }
            onDragStart(from) {
                if (this.props.onDragStart) this.props.onDragStart(from);
            }
            onDrag(from, to, start) {
                if (this.props.onDrag) this.animationId = $6a9466b713e40645$var$requestAnimationFrame(()=>{
                    if (this.props.onDrag && this.state.isDragging) this.props.onDrag(from, to, start);
                });
            }
            onDragEnd(from, to) {
                if (this.props.onDragEnd) this.props.onDragEnd(from, to);
            }
            onClick(event) {
                if (this.props.onClick) this.props.onClick(event);
            }
            render() {
                const { isDisabled: isDisabled } = this.props;
                const { isDragging: isDragging } = this.state;
                const safeProps = (0, ($parcel$interopDefault($fr1K2)))(this.props, isDisabled ? $6a9466b713e40645$var$DISABLED_DRAG_PROPS : $6a9466b713e40645$var$ENABLED_DRAG_PROPS);
                return (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                    isDragging: isDragging,
                    ...safeProps
                });
            }
        }
        return DragObserver;
    };
});
parcelRegister("aRGMp", function(module, exports) {
    $parcel$export(module.exports, "createRaf", ()=>$98d827f74bc46e8c$export$adfe8e38eaee509d);
    const $98d827f74bc46e8c$export$adfe8e38eaee509d = ()=>{
        let frameId = null;
        return (callback)=>{
            if (frameId) cancelAnimationFrame(frameId);
            frameId = requestAnimationFrame(callback);
            return frameId;
        };
    };
});
parcelRegister("9qpVA", function(module, exports) {
    $parcel$export(module.exports, "useMaxWidth", ()=>$2175711dbc5f67dd$export$f8d842793af60bfe);
    var $5uXOq = parcelRequire("5uXOq");
    var $lFKmC = parcelRequire("lFKmC");
    var $iZN6h;
    var $kyahI;
    var $fY8ne;
    const $2175711dbc5f67dd$export$f8d842793af60bfe = ()=>{
        const [maxWidth, setMaxWidth] = (0, $5uXOq.useState)(Infinity);
        const { requestViewportBoundingClient: requestViewportBoundingClient } = (0, (0, parcelRequire("kyahI")).useViewport)();
        const setMaxWidthFromViewport = (0, $5uXOq.useCallback)(()=>{
            const viewportBoundingClient = requestViewportBoundingClient({
                withTimelineOffset: false
            });
            if (viewportBoundingClient) {
                const newMaxWidth = (0, (0, parcelRequire("fY8ne")).getMaxListWidth)(viewportBoundingClient.width);
                setMaxWidth(newMaxWidth);
            }
        }, [
            requestViewportBoundingClient
        ]);
        (0, $5uXOq.useEffect)(()=>{
            setMaxWidthFromViewport();
        }, [
            setMaxWidthFromViewport
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const onWindowResize = (0, ($parcel$interopDefault($lFKmC)))(()=>{
                setMaxWidthFromViewport();
            }, (0, (0, parcelRequire("iZN6h")).RESIZE_DEBOUNCE_MS));
            window.addEventListener('resize', onWindowResize);
            return ()=>{
                window.removeEventListener('resize', onWindowResize);
                onWindowResize.cancel();
            };
        }, [
            setMaxWidthFromViewport
        ]);
        return maxWidth;
    };
});
parcelRegister("kyahI", function(module, exports) {
    $parcel$export(module.exports, "useViewport", ()=>$40329f63f37d38cb$export$297ec8eb77d6211d);
    $parcel$export(module.exports, "default", ()=>$40329f63f37d38cb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $eA5c9;
    const $40329f63f37d38cb$var$ViewportContext = (0, $5uXOq.createContext)({
        requestViewportBoundingClient: ()=>(0, (0, parcelRequire("eA5c9")).DEFAULT_BOUNDING_CLIENT),
        requestViewportScrollBounding: ()=>(0, (0, parcelRequire("eA5c9")).DEFAULT_SCROLL_BOUNDING),
        listenToViewportScroll: (0, ($parcel$interopDefault($8Rkzz))),
        stopListeningToViewportScroll: (0, ($parcel$interopDefault($8Rkzz))),
        setViewportScroll: (0, ($parcel$interopDefault($8Rkzz)))
    });
    const $40329f63f37d38cb$export$297ec8eb77d6211d = ()=>(0, $5uXOq.useContext)($40329f63f37d38cb$var$ViewportContext);
    var $40329f63f37d38cb$export$2e2bcd8739ae039 = $40329f63f37d38cb$var$ViewportContext;
});
parcelRegister("eA5c9", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_BOUNDING_CLIENT", ()=>$54aa9414eabfde0c$export$2b0ecbff0a0d633b);
    $parcel$export(module.exports, "DEFAULT_SCROLL_BOUNDING", ()=>$54aa9414eabfde0c$export$2f9f19f71eef1ceb);
    const $54aa9414eabfde0c$export$2b0ecbff0a0d633b = {
        width: 0,
        height: 0,
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
    const $54aa9414eabfde0c$export$2f9f19f71eef1ceb = {
        scrollTop: 0,
        scrollLeft: 0,
        scrollRight: 0,
        scrollBottom: 0,
        scrollHeight: 0,
        scrollWidth: 0,
        isOverflowY: false
    };
});
parcelRegister("fY8ne", function(module, exports) {
    $parcel$export(module.exports, "getMaxListWidth", ()=>$ace114e12ea74984$export$5db3ad0238a5a9b3);
    var $iZN6h;
    const $ace114e12ea74984$var$MAX_WIDTH_RATIO = 0.9;
    const $ace114e12ea74984$export$5db3ad0238a5a9b3 = (viewportWidth)=>{
        const tableLimitedWidth = Math.round(viewportWidth * $ace114e12ea74984$var$MAX_WIDTH_RATIO);
        return Math.max((0, (0, parcelRequire("iZN6h")).MINIMUM_LIST_WIDTH)(), tableLimitedWidth);
    };
});
parcelRegister("5qL6X", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5c8bcaa39410cf1d$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $3joPi = parcelRequire("3joPi");
    var $lwMsT;
    var $gOxHv = parcelRequire("gOxHv");
    var $2o71Q = parcelRequire("2o71Q");
    var $lFzC1 = parcelRequire("lFzC1");
    var $iZN6h;
    var $hUAzM;
    var $9qpVA;
    const $5c8bcaa39410cf1d$var$getProposedWidth = ({ initialWidth: initialWidth, maxWidth: maxWidth, location: location })=>{
        const diffX = location.current.input.clientX - location.initial.input.clientX;
        const proposedWidth = initialWidth + diffX;
        return Math.min(Math.max((0, (0, parcelRequire("iZN6h")).MINIMUM_LIST_WIDTH)(), proposedWidth), maxWidth);
    };
    const $5c8bcaa39410cf1d$var$Resizer = ({ width: width, DndLongTaskMetric: DndLongTaskMetric, onResize: onResize, onResizeEnd: onResizeEnd })=>{
        const [isDragging, setIsDragging] = (0, $5uXOq.useState)(false);
        const dividerRef = (0, $5uXOq.useRef)(null);
        const initialWidth = (0, $5uXOq.useRef)(width);
        const maxWidth = (0, (0, parcelRequire("9qpVA")).useMaxWidth)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const onDragStart = (0, $5uXOq.useCallback)(()=>{
            initialWidth.current = width;
            setIsDragging(true);
        }, [
            width
        ]);
        const onDrag = (0, $5uXOq.useCallback)(({ location: location })=>{
            onResize($5c8bcaa39410cf1d$var$getProposedWidth({
                initialWidth: initialWidth.current,
                maxWidth: maxWidth,
                location: location
            }));
        }, [
            onResize,
            maxWidth
        ]);
        const onDrop = (0, $5uXOq.useCallback)(({ location: location })=>{
            (0, $lFzC1.preventUnhandled).stop();
            setIsDragging(false);
            const analyticsEvent = createAnalyticsEvent({
                action: 'resized',
                actionSubject: 'list',
                actionSubjectId: 'resizedList',
                attributes: {
                    didExpand: location.current.input.clientX > location.initial.input.clientX
                }
            });
            (0, (0, parcelRequire("hUAzM")).fireUIAnalyticsEvent)(analyticsEvent);
            onResizeEnd(initialWidth.current);
        }, [
            createAnalyticsEvent,
            onResizeEnd
        ]);
        (0, $5uXOq.useEffect)(()=>{
            width > maxWidth && onResize(maxWidth);
        }, [
            width,
            maxWidth,
            onResize
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const divider = dividerRef.current;
            (0, $3joPi.default)(divider);
            return (0, $gOxHv.draggable)({
                element: divider,
                onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                    (0, $2o71Q.disableNativeDragPreview)({
                        nativeSetDragImage: nativeSetDragImage
                    });
                    (0, $lFzC1.preventUnhandled).start();
                },
                onDragStart: onDragStart,
                onDrag: onDrag,
                onDrop: onDrop
            });
        }, [
            onDragStart,
            onDrag,
            onDrop
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            ref: dividerRef,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _154iidpf _1xi21i6y _1bsbu2gc _4t3i1osq _1pbyilow _v564ryu7 _lcxv1rj4 _80omuf7j _18postnw _1ywu1ule _aetrb3bt _15l2idpf _32rxv77o _z0aiv77o _1qdg1osq _16r21can _11fnglyw",
                isDragging ? "_tzy4kb7n" : "_tzy4idpf _16l4kb7n"
            ])
        }), DndLongTaskMetric !== undefined && (0, ($parcel$interopDefault($5uXOq))).createElement(DndLongTaskMetric, {
            isDragging: isDragging,
            metricType: (0, (0, parcelRequire("iZN6h")).LIST_RESIZE_DRAG_AND_DROP)
        }));
    };
    const $5c8bcaa39410cf1d$var$resizeHandlerStyles = null;
    const $5c8bcaa39410cf1d$var$staticStyles = null;
    const $5c8bcaa39410cf1d$var$draggingStyles = null;
    var $5c8bcaa39410cf1d$export$2e2bcd8739ae039 = $5c8bcaa39410cf1d$var$Resizer;
});
parcelRegister("anfdB", function(module, exports) {
    $parcel$export(module.exports, "canItemCreateSibling", ()=>$73a9297f2613259d$export$a638fd397c012b84);
    $parcel$export(module.exports, "canItemCreateChild", ()=>$73a9297f2613259d$export$8d944d58a048c0d4);
    var $4R6GH;
    var $iZN6h;
    var $7ouUj;
    const $73a9297f2613259d$var$isItemAlreadyInCreate = (id, createItemAnchor)=>createItemAnchor && (createItemAnchor.position === (0, (0, parcelRequire("iZN6h")).BEFORE) || createItemAnchor.position === (0, (0, parcelRequire("iZN6h")).INSIDE)) && (createItemAnchor.beforeId === id || createItemAnchor.parentId === id);
    const $73a9297f2613259d$var$canItemCreate = ({ id: id, createItemAnchor: createItemAnchor, isInTransition: isInTransition })=>!isInTransition && !$73a9297f2613259d$var$isItemAlreadyInCreate(id, createItemAnchor);
    const $73a9297f2613259d$export$a638fd397c012b84 = ({ index: index, isCreateChildEnabled: isCreateChildEnabled, isCreateSiblingEnabled: isCreateSiblingEnabled, depth: depth, ...createCheckParams })=>isCreateSiblingEnabled && ($73a9297f2613259d$var$canItemCreate(createCheckParams) || !createCheckParams.isInTransition && (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline_table_meatballs_menu_a11y')) && ((0, (0, parcelRequire("7ouUj")).isRoot)(depth) && index !== 0 || !(0, (0, parcelRequire("7ouUj")).isRoot)(depth) && isCreateChildEnabled);
    const $73a9297f2613259d$export$8d944d58a048c0d4 = ({ isCreateChildEnabled: isCreateChildEnabled, canCreateChildOverride: canCreateChildOverride, ...createCheckParams })=>isCreateChildEnabled && canCreateChildOverride && ($73a9297f2613259d$var$canItemCreate(createCheckParams) || !createCheckParams.isInTransition && (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline_table_meatballs_menu_a11y'));
});
parcelRegister("2VHr3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$62929fb6c6b4c8d9$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $cSD7y;
    var $iZN6h;
    var $g3prf;
    var $9puhl;
    var $lGdZu;
    var $biT18;
    var $iCvEL;
    var $eWv2M;
    var $cRUzn;
    var $6DX98;
    var $695Hr;
    var $6NWvS;
    var $csiwd;
    const $62929fb6c6b4c8d9$var$ThumbTrackComponent = (0, (0, parcelRequire("cSD7y")).componentWithFG)('jsw_roadmaps_timeline_table_custom_scroll_pdnd', (0, (0, parcelRequire("6NWvS")).default), (0, (0, parcelRequire("695Hr")).default));
    const $62929fb6c6b4c8d9$var$containerStyles = null;
    const $62929fb6c6b4c8d9$var$hiddenScrollbarPanelStyles = null;
    const $62929fb6c6b4c8d9$var$HiddenScrollbarPanel = ({ scrollbarSize: scrollbarSize, innerRef: innerRef, children: children, ...rest })=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            ref: innerRef,
            style: scrollbarSize > 0 ? {
                right: `-${scrollbarSize}px`,
                bottom: `-${scrollbarSize}px`
            } : undefined,
            ...rest,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _kqswstnw _154iidpf _1xi2idpf _94n5idpf _1ltvidpf _1reo15zi _18m915zi"
            ])
        }, children);
    const $62929fb6c6b4c8d9$var$requestAnimationFrame = (0, (0, parcelRequire("eWv2M")).createRaf)();
    const $62929fb6c6b4c8d9$var$Viewport = (0, (0, parcelRequire("iCvEL")).default)($62929fb6c6b4c8d9$var$HiddenScrollbarPanel);
    const $62929fb6c6b4c8d9$var$CustomScrollbars = ({ isHideScrollbar: isHideScrollbar, children: children })=>{
        const [{ timelineOriginPosition: timelineOriginPosition }] = (0, (0, parcelRequire("biT18")).useTimelineState)();
        const [{ headerHeight: headerHeight }] = (0, (0, parcelRequire("g3prf")).useHeaderState)();
        const [listWidth] = (0, (0, parcelRequire("9puhl")).useListWidth)();
        const [scrollbarSize, setScrollbarSize] = (0, $5uXOq.useState)(-1);
        const viewportRef = (0, $5uXOq.useRef)(null);
        const thumbTracksRef = (0, $5uXOq.useRef)(null);
        const lastScrollY = (0, $5uXOq.useRef)(0);
        const lastScrollX = (0, $5uXOq.useRef)(0);
        const frameId = (0, $5uXOq.useRef)();
        const [setupDragScroller, teardownDragScroller] = (0, (0, parcelRequire("6DX98")).useDragScroller)(headerHeight);
        const { onResize: onResize } = (0, (0, parcelRequire("lGdZu")).useTimelineViewportActions)();
        const onSetViewportRef = (elem)=>{
            viewportRef.current = elem;
            setupDragScroller(elem);
        };
        const onSetScrollLeft = (0, $5uXOq.useCallback)((relativePosition)=>{
            if (!viewportRef.current || !thumbTracksRef.current) throw new Error('An element required to set the scroll left position was null');
            const { scrollWidth: scrollWidth } = viewportRef.current;
            viewportRef.current.scrollLeft = relativePosition * scrollWidth;
        }, []);
        const onSetScrollTop = (0, $5uXOq.useCallback)((relativePosition)=>{
            if (!viewportRef.current || !thumbTracksRef.current) throw new Error('An element required to set the scroll top position was null');
            const { scrollHeight: scrollHeight } = viewportRef.current;
            viewportRef.current.scrollTop = relativePosition * scrollHeight;
        }, []);
        const onScroll = ({ currentTarget: currentTarget })=>{
            frameId.current = $62929fb6c6b4c8d9$var$requestAnimationFrame(()=>{
                const { scrollLeft: scrollLeft, scrollTop: scrollTop, scrollWidth: scrollWidth, scrollHeight: scrollHeight, clientWidth: clientWidth, clientHeight: clientHeight } = currentTarget;
                let horizontalScrollRatio = -1;
                let verticalScrollRatio = -1;
                if (lastScrollX.current !== scrollLeft) {
                    lastScrollX.current = scrollLeft;
                    horizontalScrollRatio = (0, (0, parcelRequire("csiwd")).getScrollOffsetRatio)(scrollLeft, scrollWidth, clientWidth);
                }
                if (lastScrollY.current !== scrollTop) {
                    lastScrollY.current = scrollTop;
                    verticalScrollRatio = (0, (0, parcelRequire("csiwd")).getScrollOffsetRatio)(scrollTop, scrollHeight, clientHeight);
                }
                thumbTracksRef.current?.setThumbPositions({
                    horizontalScrollRatio: horizontalScrollRatio,
                    verticalScrollRatio: verticalScrollRatio
                });
            });
        };
        const updateScrollbars = (0, $5uXOq.useCallback)(()=>{
            if (!viewportRef.current || !thumbTracksRef.current) throw new Error('An element required to set the custom scroll parameters was null');
            const { scrollWidth: scrollWidth, scrollHeight: scrollHeight, clientWidth: clientWidth, clientHeight: clientHeight, scrollLeft: scrollLeft, scrollTop: scrollTop } = viewportRef.current;
            const { left: left } = viewportRef.current.getBoundingClientRect();
            onResize({
                left: left,
                clientWidth: clientWidth
            });
            const horizontalScrollRatio = (0, (0, parcelRequire("csiwd")).getScrollOffsetRatio)(scrollLeft, scrollWidth, clientWidth);
            const verticalScrollRatio = (0, (0, parcelRequire("csiwd")).getScrollOffsetRatio)(scrollTop, scrollHeight, clientHeight);
            const horizontalContentRatio = (0, (0, parcelRequire("csiwd")).getContentToViewportRatio)(scrollWidth, clientWidth);
            const verticalContentRatio = (0, (0, parcelRequire("csiwd")).getContentToViewportRatio)(scrollHeight, clientHeight);
            thumbTracksRef.current?.update({
                horizontalScrollRatio: horizontalScrollRatio,
                verticalScrollRatio: verticalScrollRatio
            }, {
                horizontalContentRatio: horizontalContentRatio,
                verticalContentRatio: verticalContentRatio
            });
        }, [
            onResize
        ]);
        const onContentResize = scrollbarSize > 0 ? updateScrollbars : (0, ($parcel$interopDefault($8Rkzz)));
        (0, $5uXOq.useLayoutEffect)(()=>{
            if (!viewportRef.current) throw new Error('An element required to initialise the custom scrollbars was null');
            const initialScrollbarSize = (0, (0, parcelRequire("csiwd")).getScrollbarSize)(viewportRef.current);
            const integerTimelineDefaultPosition = Math.round(timelineOriginPosition);
            viewportRef.current.scrollLeft = integerTimelineDefaultPosition;
            lastScrollX.current = integerTimelineDefaultPosition;
            setScrollbarSize(initialScrollbarSize);
        }, [
            timelineOriginPosition
        ]);
        (0, (0, parcelRequire("cRUzn")).useResizeObserver)(viewportRef.current, onContentResize);
        (0, $5uXOq.useEffect)(()=>()=>{
                frameId.current && cancelAnimationFrame(frameId.current);
                teardownDragScroller(null);
            }, [
            teardownDragScroller
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _154iidpf _1xi2idpf _94n5idpf _1ltvidpf _1reo15vq _18m915vq _2rkoo8o8"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($62929fb6c6b4c8d9$var$Viewport, {
            id: (0, (0, parcelRequire("iZN6h")).TIMELINE_ID),
            "data-testid": (0, (0, parcelRequire("iZN6h")).TIMELINE_ID),
            innerRef: onSetViewportRef,
            scrollbarSize: scrollbarSize,
            offsets: (0, (0, parcelRequire("csiwd")).getViewportOffsets)(scrollbarSize, listWidth, headerHeight),
            onScroll: scrollbarSize > 0 ? onScroll : undefined
        }, children({
            scrollElement: viewportRef.current,
            onContentResize: onContentResize
        })), scrollbarSize > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement($62929fb6c6b4c8d9$var$ThumbTrackComponent, {
            ref: thumbTracksRef,
            listWidth: listWidth,
            timelineTop: headerHeight,
            isHideScrollbar: isHideScrollbar,
            onSetScrollLeft: onSetScrollLeft,
            onSetScrollTop: onSetScrollTop
        }));
    };
    var $62929fb6c6b4c8d9$export$2e2bcd8739ae039 = $62929fb6c6b4c8d9$var$CustomScrollbars;
});
parcelRegister("iCvEL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$91051642b8e26938$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $kyahI;
    var $8Pr6K;
    var $6y462;
    const $91051642b8e26938$var$withViewportProvider = (WrappedComponent)=>{
        class WithViewportProvider extends (0, $5uXOq.Component) {
            static{
                this.defaultProps = {
                    offsets: (0, (0, parcelRequire("8Pr6K")).DEFAULT_OFFSETS),
                    innerRef: (0, ($parcel$interopDefault($8Rkzz)))
                };
            }
            constructor(props){
                super(props);
                this.requestBoundingClient = ({ withTimelineOffset: withTimelineOffset } = (0, (0, parcelRequire("8Pr6K")).DEFAULT_BOUNDING_OPTIONS))=>{
                    if (!this.ref) throw new Error((0, (0, parcelRequire("8Pr6K")).MISSING_REF_ERROR_MESSAGE));
                    return (0, (0, parcelRequire("6y462")).calculateClientBounding)({
                        element: this.ref,
                        offsets: this.props.offsets,
                        withTimelineOffset: withTimelineOffset
                    });
                };
                this.requestScrollBounding = ({ withTimelineOffset: withTimelineOffset } = (0, (0, parcelRequire("8Pr6K")).DEFAULT_BOUNDING_OPTIONS))=>{
                    if (!this.ref) throw new Error((0, (0, parcelRequire("8Pr6K")).MISSING_REF_ERROR_MESSAGE));
                    return (0, (0, parcelRequire("6y462")).calculateScrollBounding)({
                        element: this.ref,
                        offsets: this.props.offsets,
                        withTimelineOffset: withTimelineOffset
                    });
                };
                this.listenToScroll = (callback)=>{
                    if (!this.ref) throw new Error((0, (0, parcelRequire("8Pr6K")).MISSING_REF_ERROR_MESSAGE));
                    this.ref.addEventListener('scroll', callback);
                };
                this.stopListeningToScroll = (callback)=>{
                    if (this.ref) this.ref.removeEventListener('scroll', callback);
                };
                this.setScroll = ({ scrollLeft: scrollLeft, scrollTop: scrollTop })=>{
                    if (!this.ref) throw new Error((0, (0, parcelRequire("8Pr6K")).MISSING_REF_ERROR_MESSAGE));
                    if (scrollLeft !== undefined) this.ref.scrollLeft = scrollLeft;
                    if (scrollTop !== undefined) this.ref.scrollTop = scrollTop;
                };
                this.onSetRef = (elem)=>{
                    const { innerRef: innerRef } = this.props;
                    this.ref = elem;
                    innerRef(elem);
                };
                this.ref = null;
                this.state = {
                    requestViewportBoundingClient: this.requestBoundingClient,
                    requestViewportScrollBounding: this.requestScrollBounding,
                    listenToViewportScroll: this.listenToScroll,
                    stopListeningToViewportScroll: this.stopListeningToScroll,
                    setViewportScroll: this.setScroll
                };
            }
            render() {
                const { children: children, ...props } = this.props;
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kyahI")).default).Provider, {
                    value: this.state
                }, (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                    ...props,
                    innerRef: this.onSetRef
                }, children));
            }
        }
        return WithViewportProvider;
    };
    var $91051642b8e26938$export$2e2bcd8739ae039 = $91051642b8e26938$var$withViewportProvider;
});
parcelRegister("8Pr6K", function(module, exports) {
    $parcel$export(module.exports, "MISSING_REF_ERROR_MESSAGE", ()=>$f55409c99ca305b3$export$a374b3d597cc8a2f);
    $parcel$export(module.exports, "DEFAULT_BOUNDING_OPTIONS", ()=>$f55409c99ca305b3$export$411ca18ef48ec0a9);
    $parcel$export(module.exports, "DEFAULT_OFFSETS", ()=>$f55409c99ca305b3$export$86c907556a515793);
    const $f55409c99ca305b3$export$a374b3d597cc8a2f = 'Viewport element was null. Only make this request when it is certain to be available (e.g. not in componentDidMount)';
    const $f55409c99ca305b3$export$411ca18ef48ec0a9 = {
        withTimelineOffset: true
    };
    const $f55409c99ca305b3$export$86c907556a515793 = {
        scrollbar: 0,
        timelineTop: 0,
        timelineLeft: 0
    };
});
parcelRegister("6y462", function(module, exports) {
    $parcel$export(module.exports, "calculateClientBounding", ()=>$3992543d55e71f7e$export$787a1f452b87b38);
    $parcel$export(module.exports, "calculateScrollBounding", ()=>$3992543d55e71f7e$export$7bc284cde09cb25);
    const $3992543d55e71f7e$export$787a1f452b87b38 = ({ element: element, offsets: offsets, withTimelineOffset: withTimelineOffset })=>{
        const { width: width, height: height, right: right, bottom: bottom, left: left, top: top } = element.getBoundingClientRect();
        const { timelineTop: timelineTop, timelineLeft: timelineLeft, scrollbar: scrollbar } = offsets;
        const effectiveTimelineTop = withTimelineOffset ? timelineTop : 0;
        const effectiveTimelineLeft = withTimelineOffset ? timelineLeft : 0;
        return {
            width: width - scrollbar - effectiveTimelineLeft,
            height: height - scrollbar - effectiveTimelineTop,
            right: right - scrollbar,
            bottom: bottom - scrollbar,
            left: left + effectiveTimelineLeft,
            top: top + effectiveTimelineTop
        };
    };
    const $3992543d55e71f7e$export$7bc284cde09cb25 = ({ element: element, offsets: offsets, withTimelineOffset: withTimelineOffset })=>{
        const { scrollTop: scrollTop, scrollLeft: scrollLeft, scrollHeight: scrollHeight, scrollWidth: scrollWidth, clientWidth: clientWidth, clientHeight: clientHeight } = element;
        const { timelineTop: timelineTop, timelineLeft: timelineLeft } = offsets;
        const effectiveTimelineTop = withTimelineOffset ? timelineTop : 0;
        const effectiveTimelineLeft = withTimelineOffset ? timelineLeft : 0;
        return {
            scrollTop: scrollTop,
            scrollLeft: scrollLeft,
            scrollRight: Math.max(scrollWidth - clientWidth - scrollLeft, 0),
            scrollBottom: Math.max(scrollHeight - clientHeight - scrollTop, 0),
            scrollHeight: scrollHeight - effectiveTimelineTop,
            scrollWidth: scrollWidth - effectiveTimelineLeft,
            isOverflowY: scrollHeight > clientHeight
        };
    };
});
parcelRegister("eWv2M", function(module, exports) {
    $parcel$export(module.exports, "createRaf", ()=>$5369a1e296f60979$export$adfe8e38eaee509d);
    const $5369a1e296f60979$export$adfe8e38eaee509d = ()=>{
        let frameId = null;
        return (callback)=>{
            if (frameId) cancelAnimationFrame(frameId);
            frameId = requestAnimationFrame(callback);
            return frameId;
        };
    };
});
parcelRegister("6DX98", function(module, exports) {
    $parcel$export(module.exports, "useDragScroller", ()=>$0804fa8fad232017$export$ef7372695b4ed2f3);
    var $5uXOq = parcelRequire("5uXOq");
    var $4d5mq;
    var $5EOne = parcelRequire("5EOne");
    var $gOxHv = parcelRequire("gOxHv");
    var $iZN6h;
    const $0804fa8fad232017$export$ef7372695b4ed2f3 = (timelineTop)=>{
        const cleanupDragAndDrop = (0, $5uXOq.useRef)(null);
        const clientXPos = (0, $5uXOq.useRef)(0);
        const thresholdTop = (0, $5uXOq.useRef)(0);
        const setupDragScroller = (0, $5uXOq.useCallback)((viewportElement)=>{
            cleanupDragAndDrop.current = (0, $5EOne.combine)((0, $gOxHv.monitorForElements)({
                onDragStart: ({ source: source, location: location })=>{
                    const item = source.data;
                    if (item.type === (0, (0, parcelRequire("iZN6h")).ROW_DRAG_AND_DROP_ID) && viewportElement !== null) {
                        const viewportBoundingRect = viewportElement?.getBoundingClientRect();
                        const offsetTop = viewportBoundingRect?.top ?? 0;
                        clientXPos.current = (viewportBoundingRect?.left ?? 0) + (viewportBoundingRect?.width ?? 0) / 2;
                        thresholdTop.current = offsetTop / 2 + timelineTop + offsetTop;
                        (0, (0, parcelRequire("4d5mq")).autoScroller).start({
                            input: {
                                ...location.current.input,
                                pageX: clientXPos.current,
                                clientX: clientXPos.current
                            }
                        });
                    }
                },
                onDrop: ({ source: source })=>{
                    const item = source.data;
                    if (item.type === (0, (0, parcelRequire("iZN6h")).ROW_DRAG_AND_DROP_ID) && viewportElement !== null) (0, (0, parcelRequire("4d5mq")).autoScroller).stop();
                },
                onDrag: ({ source: source, location: location })=>{
                    const item = source.data;
                    if (item.type === (0, (0, parcelRequire("iZN6h")).ROW_DRAG_AND_DROP_ID) && viewportElement !== null) {
                        const { clientY: clientY, pageX: pageX, clientX: clientX, pageY: pageY, ...restInputs } = location.current.input;
                        const newClientY = clientY < thresholdTop.current ? clientY - timelineTop : clientY;
                        const input = {
                            ...restInputs,
                            pageX: clientXPos.current,
                            clientX: clientXPos.current,
                            pageY: newClientY,
                            clientY: newClientY
                        };
                        (0, (0, parcelRequire("4d5mq")).autoScroller).updateInput({
                            input: input
                        });
                    }
                }
            }));
        }, [
            timelineTop
        ]);
        const teardownDragScroller = (0, $5uXOq.useCallback)(()=>{
            cleanupDragAndDrop.current?.();
        }, []);
        return [
            setupDragScroller,
            teardownDragScroller
        ];
    };
});
parcelRegister("4d5mq", function(module, exports) {
    $parcel$export(module.exports, "createAutoScroller", ()=>$28021e718877f2c9$export$fbda4b72e803ec38);
    $parcel$export(module.exports, "autoScroller", ()=>$28021e718877f2c9$export$d19940cfc7560cd8);
    var $dsGln;
    const $28021e718877f2c9$var$scrollElement = (element, change)=>{
        element.scrollBy(change.x, change.y);
    };
    const $28021e718877f2c9$var$scrollWindow = (change)=>{
        window.scrollBy(change.x, change.y);
    };
    const $28021e718877f2c9$export$fbda4b72e803ec38 = ()=>{
        let dragging = null;
        function tryScroll(fakeScrollCallback) {
            if (dragging == null) return;
            (0, (0, parcelRequire("dsGln")).scroll)({
                input: dragging.latestInput,
                dragStartTime: dragging.dragStartTime,
                shouldUseTimeDampening: dragging.shouldUseTimeDampening,
                behavior: dragging.behavior,
                scrollElement: fakeScrollCallback ?? $28021e718877f2c9$var$scrollElement,
                scrollWindow: fakeScrollCallback ?? $28021e718877f2c9$var$scrollWindow
            });
        }
        function loop() {
            if (!dragging) return;
            dragging.loopFrameId = requestAnimationFrame(()=>{
                tryScroll();
                loop();
            });
        }
        const start = ({ input: input, behavior: behavior = 'window-then-container' })=>{
            const dragStartTime = Date.now();
            dragging = {
                dragStartTime: dragStartTime,
                latestInput: input,
                loopFrameId: null,
                shouldUseTimeDampening: false,
                behavior: behavior
            };
            const fakeScrollCallback = ()=>{
                if (dragging) dragging.shouldUseTimeDampening = true;
            };
            tryScroll(fakeScrollCallback);
            loop();
        };
        function updateInput({ input: input }) {
            if (!dragging) return;
            dragging.latestInput = input;
        }
        const stop = ()=>{
            if (!dragging) return;
            if (dragging.loopFrameId) cancelAnimationFrame(dragging.loopFrameId);
            dragging = null;
        };
        return {
            start: start,
            updateInput: updateInput,
            stop: stop
        };
    };
    const $28021e718877f2c9$export$d19940cfc7560cd8 = $28021e718877f2c9$export$fbda4b72e803ec38();
});
parcelRegister("dsGln", function(module, exports) {
    $parcel$export(module.exports, "scroll", ()=>$44439a4fa9e4b07e$export$209876d7b1ac8f3);
    parcelRequire("aNHRY");
    var $glfnK = parcelRequire("glfnK");
    var $hZIc5;
    var $f1VAm;
    var $hs9ox;
    var $fwuJo;
    var $ddXS9;
    const $44439a4fa9e4b07e$export$209876d7b1ac8f3 = ({ input: input, dragStartTime: dragStartTime, shouldUseTimeDampening: shouldUseTimeDampening, scrollElement: scrollElement, scrollWindow: scrollWindow, behavior: behavior })=>{
        const tryScrollWindow = ()=>{
            const viewport = (0, (0, parcelRequire("ddXS9")).default)();
            const windowScrollChange = (0, (0, parcelRequire("fwuJo")).default)({
                dragStartTime: dragStartTime,
                viewport: viewport,
                center: {
                    x: input.clientX + viewport.scroll.current.x,
                    y: input.clientY + viewport.scroll.current.y
                },
                shouldUseTimeDampening: shouldUseTimeDampening
            });
            if (windowScrollChange) {
                scrollWindow(windowScrollChange);
                return true;
            }
            return false;
        };
        const tryScrollContainer = ()=>{
            const over = (0, $glfnK.getElementFromPointWithoutHoneypot)({
                x: input.clientX,
                y: input.clientY
            });
            const closestScrollable = (0, (0, parcelRequire("hZIc5")).getClosestScrollableElement)(over);
            if (!closestScrollable) return false;
            const scrollable = (0, (0, parcelRequire("f1VAm")).getScrollable)({
                closestScrollable: closestScrollable
            });
            const scrollableScrollChange = (0, (0, parcelRequire("hs9ox")).default)({
                dragStartTime: dragStartTime,
                scrollable: scrollable,
                center: {
                    x: input.clientX,
                    y: input.clientY
                },
                shouldUseTimeDampening: shouldUseTimeDampening
            });
            if (scrollableScrollChange) {
                scrollElement(closestScrollable, scrollableScrollChange);
                return true;
            }
            return false;
        };
        if (behavior === 'container-only') tryScrollContainer();
        if (behavior === 'window-only') tryScrollWindow();
        if (behavior === 'container-then-window') tryScrollContainer() || tryScrollWindow();
        if (behavior === 'window-then-container') tryScrollWindow() || tryScrollContainer();
    };
});
parcelRegister("aNHRY", function(module, exports) {
    $parcel$export(module.exports, "getElementFromPointWithoutHoneypot", ()=>(parcelRequire("glfnK")).getElementFromPointWithoutHoneypot);
    var $glfnK = parcelRequire("glfnK");
});
parcelRegister("hZIc5", function(module, exports) {
    $parcel$export(module.exports, "getClosestScrollableElement", ()=>$aaee5e87f3cd9075$export$f39f407dd5a0ebdb);
    const $aaee5e87f3cd9075$var$isEqual = (base)=>(value)=>base === value;
    const $aaee5e87f3cd9075$var$isScroll = $aaee5e87f3cd9075$var$isEqual('scroll');
    const $aaee5e87f3cd9075$var$isAuto = $aaee5e87f3cd9075$var$isEqual('auto');
    const $aaee5e87f3cd9075$var$isEither = (overflow, fn)=>fn(overflow.overflowX) || fn(overflow.overflowY);
    const $aaee5e87f3cd9075$var$isElementScrollable = (el)=>{
        const style = window.getComputedStyle(el);
        const overflow = {
            overflowX: style.overflowX,
            overflowY: style.overflowY
        };
        return $aaee5e87f3cd9075$var$isEither(overflow, $aaee5e87f3cd9075$var$isScroll) || $aaee5e87f3cd9075$var$isEither(overflow, $aaee5e87f3cd9075$var$isAuto);
    };
    const $aaee5e87f3cd9075$export$f39f407dd5a0ebdb = (el)=>{
        if (!el) return null;
        if (el === document.body || el === document.documentElement) return null;
        if (!$aaee5e87f3cd9075$var$isElementScrollable(el)) return $aaee5e87f3cd9075$export$f39f407dd5a0ebdb(el.parentElement);
        return el;
    };
});
parcelRegister("f1VAm", function(module, exports) {
    $parcel$export(module.exports, "getScrollable", ()=>$2eb849b1c7f02b43$export$9b7238c949d126e9);
    var $3YKxB;
    const $2eb849b1c7f02b43$export$9b7238c949d126e9 = ({ closestScrollable: closestScrollable })=>{
        const rect = closestScrollable.getBoundingClientRect();
        const scrollPosition = {
            x: closestScrollable.scrollLeft,
            y: closestScrollable.scrollTop
        };
        return {
            container: (0, (0, parcelRequire("3YKxB")).getRect)(rect),
            scroll: {
                current: scrollPosition,
                max: {
                    x: closestScrollable.scrollWidth - closestScrollable.clientWidth,
                    y: closestScrollable.scrollHeight - closestScrollable.clientHeight
                }
            }
        };
    };
});
parcelRegister("3YKxB", function(module, exports) {
    $parcel$export(module.exports, "getRect", ()=>$2e5b13c1f6ee9f8a$export$4b834cebd9e5cebe);
    $parcel$export(module.exports, "expand", ()=>$2e5b13c1f6ee9f8a$export$9f77e0932fb78f72);
    $parcel$export(module.exports, "createBox", ()=>$2e5b13c1f6ee9f8a$export$6459fc9e86be362e);
    $parcel$export(module.exports, "offset", ()=>$2e5b13c1f6ee9f8a$export$cc800923e997bb8);
    $parcel$export(module.exports, "withScroll", ()=>$2e5b13c1f6ee9f8a$export$1d0caec378d7d0ae);
    $parcel$export(module.exports, "calculateBox", ()=>$2e5b13c1f6ee9f8a$export$b8dfc5d4e552b8e1);
    $parcel$export(module.exports, "getBox", ()=>$2e5b13c1f6ee9f8a$export$34928e660d2a8702);
    var $3joPi = parcelRequire("3joPi");
    var $2e5b13c1f6ee9f8a$export$4b834cebd9e5cebe = function getRect(_ref) {
        var top = _ref.top, right = _ref.right, bottom = _ref.bottom, left = _ref.left;
        var width = right - left;
        var height = bottom - top;
        var rect = {
            top: top,
            right: right,
            bottom: bottom,
            left: left,
            width: width,
            height: height,
            x: left,
            y: top,
            center: {
                x: (right + left) / 2,
                y: (bottom + top) / 2
            }
        };
        return rect;
    };
    var $2e5b13c1f6ee9f8a$export$9f77e0932fb78f72 = function expand(target, expandBy) {
        return {
            top: target.top - expandBy.top,
            left: target.left - expandBy.left,
            bottom: target.bottom + expandBy.bottom,
            right: target.right + expandBy.right
        };
    };
    var $2e5b13c1f6ee9f8a$export$8b1f3092f5e28575 = function shrink(target, shrinkBy) {
        return {
            top: target.top + shrinkBy.top,
            left: target.left + shrinkBy.left,
            bottom: target.bottom - shrinkBy.bottom,
            right: target.right - shrinkBy.right
        };
    };
    var $2e5b13c1f6ee9f8a$var$shift = function shift(target, shiftBy) {
        return {
            top: target.top + shiftBy.y,
            left: target.left + shiftBy.x,
            bottom: target.bottom + shiftBy.y,
            right: target.right + shiftBy.x
        };
    };
    var $2e5b13c1f6ee9f8a$var$noSpacing = {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
    var $2e5b13c1f6ee9f8a$export$6459fc9e86be362e = function createBox(_ref2) {
        var borderBox = _ref2.borderBox, _ref2$margin = _ref2.margin, margin = _ref2$margin === void 0 ? $2e5b13c1f6ee9f8a$var$noSpacing : _ref2$margin, _ref2$border = _ref2.border, border = _ref2$border === void 0 ? $2e5b13c1f6ee9f8a$var$noSpacing : _ref2$border, _ref2$padding = _ref2.padding, padding = _ref2$padding === void 0 ? $2e5b13c1f6ee9f8a$var$noSpacing : _ref2$padding;
        var marginBox = $2e5b13c1f6ee9f8a$export$4b834cebd9e5cebe($2e5b13c1f6ee9f8a$export$9f77e0932fb78f72(borderBox, margin));
        var paddingBox = $2e5b13c1f6ee9f8a$export$4b834cebd9e5cebe($2e5b13c1f6ee9f8a$export$8b1f3092f5e28575(borderBox, border));
        var contentBox = $2e5b13c1f6ee9f8a$export$4b834cebd9e5cebe($2e5b13c1f6ee9f8a$export$8b1f3092f5e28575(paddingBox, padding));
        return {
            marginBox: marginBox,
            borderBox: $2e5b13c1f6ee9f8a$export$4b834cebd9e5cebe(borderBox),
            paddingBox: paddingBox,
            contentBox: contentBox,
            margin: margin,
            border: border,
            padding: padding
        };
    };
    var $2e5b13c1f6ee9f8a$var$parse = function parse(raw) {
        var value = raw.slice(0, -2);
        var suffix = raw.slice(-2);
        if (suffix !== 'px') return 0;
        var result = Number(value);
        !!isNaN(result) && (0, $3joPi.default)(false);
        return result;
    };
    var $2e5b13c1f6ee9f8a$var$getWindowScroll = function getWindowScroll() {
        return {
            x: window.pageXOffset,
            y: window.pageYOffset
        };
    };
    var $2e5b13c1f6ee9f8a$export$cc800923e997bb8 = function offset(original, change) {
        var borderBox = original.borderBox, border = original.border, margin = original.margin, padding = original.padding;
        var shifted = $2e5b13c1f6ee9f8a$var$shift(borderBox, change);
        return $2e5b13c1f6ee9f8a$export$6459fc9e86be362e({
            borderBox: shifted,
            border: border,
            margin: margin,
            padding: padding
        });
    };
    var $2e5b13c1f6ee9f8a$export$1d0caec378d7d0ae = function withScroll(original, scroll) {
        if (scroll === void 0) scroll = $2e5b13c1f6ee9f8a$var$getWindowScroll();
        return $2e5b13c1f6ee9f8a$export$cc800923e997bb8(original, scroll);
    };
    var $2e5b13c1f6ee9f8a$export$b8dfc5d4e552b8e1 = function calculateBox(borderBox, styles) {
        var margin = {
            top: $2e5b13c1f6ee9f8a$var$parse(styles.marginTop),
            right: $2e5b13c1f6ee9f8a$var$parse(styles.marginRight),
            bottom: $2e5b13c1f6ee9f8a$var$parse(styles.marginBottom),
            left: $2e5b13c1f6ee9f8a$var$parse(styles.marginLeft)
        };
        var padding = {
            top: $2e5b13c1f6ee9f8a$var$parse(styles.paddingTop),
            right: $2e5b13c1f6ee9f8a$var$parse(styles.paddingRight),
            bottom: $2e5b13c1f6ee9f8a$var$parse(styles.paddingBottom),
            left: $2e5b13c1f6ee9f8a$var$parse(styles.paddingLeft)
        };
        var border = {
            top: $2e5b13c1f6ee9f8a$var$parse(styles.borderTopWidth),
            right: $2e5b13c1f6ee9f8a$var$parse(styles.borderRightWidth),
            bottom: $2e5b13c1f6ee9f8a$var$parse(styles.borderBottomWidth),
            left: $2e5b13c1f6ee9f8a$var$parse(styles.borderLeftWidth)
        };
        return $2e5b13c1f6ee9f8a$export$6459fc9e86be362e({
            borderBox: borderBox,
            margin: margin,
            padding: padding,
            border: border
        });
    };
    var $2e5b13c1f6ee9f8a$export$34928e660d2a8702 = function getBox(el) {
        var borderBox = el.getBoundingClientRect();
        var styles = window.getComputedStyle(el);
        return $2e5b13c1f6ee9f8a$export$b8dfc5d4e552b8e1(borderBox, styles);
    };
});
parcelRegister("hs9ox", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0a530381299205c1$export$2e2bcd8739ae039);
    var $1gIxK;
    var $aqWIJ;
    var $0a530381299205c1$export$2e2bcd8739ae039 = ({ scrollable: scrollable, center: center, dragStartTime: dragStartTime, shouldUseTimeDampening: shouldUseTimeDampening })=>{
        const scroll = (0, (0, parcelRequire("aqWIJ")).default)({
            dragStartTime: dragStartTime,
            container: scrollable.container,
            center: center,
            shouldUseTimeDampening: shouldUseTimeDampening
        });
        return scroll && (0, (0, parcelRequire("1gIxK")).canScrollScrollable)(scrollable, scroll) ? scroll : null;
    };
});
parcelRegister("1gIxK", function(module, exports) {
    $parcel$export(module.exports, "canScrollWindow", ()=>$b922061e77f21bee$export$cbd1e6fd5e887f10);
    $parcel$export(module.exports, "canScrollScrollable", ()=>$b922061e77f21bee$export$57c21b61d76c9819);
    var $8X9I6;
    const $b922061e77f21bee$var$smallestSigned = (0, (0, parcelRequire("8X9I6")).apply)((value)=>{
        if (value === 0) return 0;
        return value > 0 ? 1 : -1;
    });
    const $b922061e77f21bee$export$6b13012b06f8f95b = (()=>{
        const getRemainder = (target, max)=>{
            if (target < 0) return target;
            if (target > max) return target - max;
            return 0;
        };
        return ({ current: current, max: max, change: change })=>{
            const targetScroll = (0, (0, parcelRequire("8X9I6")).add)(current, change);
            const overlap = {
                x: getRemainder(targetScroll.x, max.x),
                y: getRemainder(targetScroll.y, max.y)
            };
            if ((0, (0, parcelRequire("8X9I6")).isEqual)(overlap, (0, (0, parcelRequire("8X9I6")).origin))) return null;
            return overlap;
        };
    })();
    const $b922061e77f21bee$export$dbc3ad6130556cf6 = ({ max: rawMax, current: current, change: change })=>{
        const max = {
            x: Math.max(current.x, rawMax.x),
            y: Math.max(current.y, rawMax.y)
        };
        const smallestChange = $b922061e77f21bee$var$smallestSigned(change);
        const overlap = $b922061e77f21bee$export$6b13012b06f8f95b({
            max: max,
            current: current,
            change: smallestChange
        });
        if (!overlap) return true;
        if (smallestChange.x !== 0 && overlap.x === 0) return true;
        if (smallestChange.y !== 0 && overlap.y === 0) return true;
        return false;
    };
    const $b922061e77f21bee$export$cbd1e6fd5e887f10 = (viewport, change)=>$b922061e77f21bee$export$dbc3ad6130556cf6({
            current: viewport.scroll.current,
            max: viewport.scroll.max,
            change: change
        });
    const $b922061e77f21bee$export$2f1f3b9e315c6096 = (viewport, change)=>{
        if (!$b922061e77f21bee$export$cbd1e6fd5e887f10(viewport, change)) return null;
        const max = viewport.scroll.max;
        const current = viewport.scroll.current;
        return $b922061e77f21bee$export$6b13012b06f8f95b({
            current: current,
            max: max,
            change: change
        });
    };
    const $b922061e77f21bee$export$57c21b61d76c9819 = (scrollable, change)=>{
        return $b922061e77f21bee$export$dbc3ad6130556cf6({
            current: scrollable.scroll.current,
            max: scrollable.scroll.max,
            change: change
        });
    };
    const $b922061e77f21bee$export$d88a6b2979421049 = (scrollable, change)=>{
        if (!$b922061e77f21bee$export$57c21b61d76c9819(scrollable, change)) return null;
        return $b922061e77f21bee$export$6b13012b06f8f95b({
            current: scrollable.scroll.current,
            max: scrollable.scroll.max,
            change: change
        });
    };
});
parcelRegister("8X9I6", function(module, exports) {
    $parcel$export(module.exports, "origin", ()=>$0db797563961ba17$export$f710a83a91838a36);
    $parcel$export(module.exports, "apply", ()=>$0db797563961ba17$export$5635d7ef4b8fee1c);
    $parcel$export(module.exports, "isEqual", ()=>$0db797563961ba17$export$248d38f6296296c5);
    $parcel$export(module.exports, "add", ()=>$0db797563961ba17$export$e16d8520af44a096);
    $parcel$export(module.exports, "subtract", ()=>$0db797563961ba17$export$4e2d2ead65e5f7e3);
    const $0db797563961ba17$export$f710a83a91838a36 = {
        x: 0,
        y: 0
    };
    const $0db797563961ba17$export$5635d7ef4b8fee1c = (fn)=>(point)=>({
                x: fn(point.x),
                y: fn(point.y)
            });
    const $0db797563961ba17$export$248d38f6296296c5 = (point1, point2)=>point1.x === point2.x && point1.y === point2.y;
    const $0db797563961ba17$export$e16d8520af44a096 = (point1, point2)=>({
            x: point1.x + point2.x,
            y: point1.y + point2.y
        });
    const $0db797563961ba17$export$4e2d2ead65e5f7e3 = (point1, point2)=>({
            x: point1.x - point2.x,
            y: point1.y - point2.y
        });
});
parcelRegister("aqWIJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$84d0e6a001965c89$export$2e2bcd8739ae039);
    var $c7MxM;
    var $8X9I6;
    var $gncH6;
    const $84d0e6a001965c89$var$clean = (0, (0, parcelRequire("8X9I6")).apply)((value)=>value === 0 ? 0 : value);
    var $84d0e6a001965c89$export$2e2bcd8739ae039 = ({ dragStartTime: dragStartTime, container: container, center: center, shouldUseTimeDampening: shouldUseTimeDampening })=>{
        const distanceToEdges = {
            top: center.y - container.top,
            right: container.right - center.x,
            bottom: container.bottom - center.y,
            left: center.x - container.left
        };
        const y = (0, (0, parcelRequire("gncH6")).default)({
            container: container,
            distanceToEdges: distanceToEdges,
            dragStartTime: dragStartTime,
            axis: (0, (0, parcelRequire("c7MxM")).vertical),
            shouldUseTimeDampening: shouldUseTimeDampening
        });
        const x = (0, (0, parcelRequire("gncH6")).default)({
            container: container,
            distanceToEdges: distanceToEdges,
            dragStartTime: dragStartTime,
            axis: (0, (0, parcelRequire("c7MxM")).horizontal),
            shouldUseTimeDampening: shouldUseTimeDampening
        });
        const required = $84d0e6a001965c89$var$clean({
            x: x,
            y: y
        });
        if ((0, (0, parcelRequire("8X9I6")).isEqual)(required, (0, (0, parcelRequire("8X9I6")).origin))) return null;
        return required;
    };
});
parcelRegister("c7MxM", function(module, exports) {
    $parcel$export(module.exports, "minScroll", ()=>$e15f0f04b63c8ec5$export$67e2de1e1e796844);
    $parcel$export(module.exports, "vertical", ()=>$e15f0f04b63c8ec5$export$32f8a6eb41d46820);
    $parcel$export(module.exports, "horizontal", ()=>$e15f0f04b63c8ec5$export$641ecd0b2bc39508);
    const $e15f0f04b63c8ec5$export$67e2de1e1e796844 = 1;
    const $e15f0f04b63c8ec5$export$32f8a6eb41d46820 = {
        direction: 'vertical',
        start: 'top',
        end: 'bottom',
        size: 'height',
        scrollAxis: 'scrollTop'
    };
    const $e15f0f04b63c8ec5$export$641ecd0b2bc39508 = {
        direction: 'horizontal',
        start: 'left',
        end: 'right',
        size: 'width',
        scrollAxis: 'scrollLeft'
    };
    const $e15f0f04b63c8ec5$export$1a8fc111f6979e7a = [
        $e15f0f04b63c8ec5$export$641ecd0b2bc39508.direction,
        $e15f0f04b63c8ec5$export$32f8a6eb41d46820.direction
    ];
});
parcelRegister("gncH6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$33082cb7de21710e$export$2e2bcd8739ae039);
    var $hlcrb;
    var $8ijmj;
    var $33082cb7de21710e$export$2e2bcd8739ae039 = ({ container: container, distanceToEdges: distanceToEdges, dragStartTime: dragStartTime, axis: axis, shouldUseTimeDampening: shouldUseTimeDampening })=>{
        const thresholds = (0, (0, parcelRequire("hlcrb")).default)(container, axis);
        const isCloserToEnd = distanceToEdges[axis.end] < distanceToEdges[axis.start];
        if (isCloserToEnd) return (0, (0, parcelRequire("8ijmj")).default)({
            distanceToEdge: distanceToEdges[axis.end],
            thresholds: thresholds,
            dragStartTime: dragStartTime,
            shouldUseTimeDampening: shouldUseTimeDampening
        });
        return -1 * (0, (0, parcelRequire("8ijmj")).default)({
            distanceToEdge: distanceToEdges[axis.start],
            thresholds: thresholds,
            dragStartTime: dragStartTime,
            shouldUseTimeDampening: shouldUseTimeDampening
        });
    };
});
parcelRegister("hlcrb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$243e6b964b6ea749$export$2e2bcd8739ae039);
    var $5dPhU;
    const $243e6b964b6ea749$export$79446fee27934459 = (container, axis)=>{
        const startScrollingFrom = container[axis.size] * (0, (0, parcelRequire("5dPhU")).default).startFromPercentage;
        const maxScrollValueAt = container[axis.size] * (0, (0, parcelRequire("5dPhU")).default).maxScrollAtPercentage;
        const thresholds = {
            startScrollingFrom: startScrollingFrom,
            maxScrollValueAt: maxScrollValueAt
        };
        return thresholds;
    };
    var $243e6b964b6ea749$export$2e2bcd8739ae039 = $243e6b964b6ea749$export$79446fee27934459;
});
parcelRegister("5dPhU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$89b6176ecf918c48$export$2e2bcd8739ae039);
    const $89b6176ecf918c48$var$config = {
        startFromPercentage: 0.25,
        maxScrollAtPercentage: 0.05,
        maxPixelScroll: 28,
        ease: (percentage)=>Math.pow(percentage, 2),
        durationDampening: {
            stopDampeningAt: 1200,
            accelerateAt: 360
        }
    };
    var $89b6176ecf918c48$export$2e2bcd8739ae039 = $89b6176ecf918c48$var$config;
});
parcelRegister("8ijmj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d2a6702a6f10b8dd$export$2e2bcd8739ae039);
    var $c7MxM;
    var $9fQ0O;
    var $7PLLn;
    const $d2a6702a6f10b8dd$export$bf7199a9ebcb84a9 = ({ distanceToEdge: distanceToEdge, thresholds: thresholds, dragStartTime: dragStartTime, shouldUseTimeDampening: shouldUseTimeDampening })=>{
        const scroll = (0, (0, parcelRequire("7PLLn")).getValueFromDistance)(distanceToEdge, thresholds);
        if (scroll === 0) return 0;
        if (!shouldUseTimeDampening) return scroll;
        return Math.max((0, (0, parcelRequire("9fQ0O")).dampenValueByTime)(scroll, dragStartTime), (0, (0, parcelRequire("c7MxM")).minScroll));
    };
    var $d2a6702a6f10b8dd$export$2e2bcd8739ae039 = $d2a6702a6f10b8dd$export$bf7199a9ebcb84a9;
});
parcelRegister("9fQ0O", function(module, exports) {
    $parcel$export(module.exports, "dampenValueByTime", ()=>$cf175a255231ad78$export$2fe468ff7a999ed6);
    var $5dPhU;
    var $c7MxM;
    var $1nJb5;
    const $cf175a255231ad78$var$accelerateAt = (0, (0, parcelRequire("5dPhU")).default).durationDampening.accelerateAt;
    const $cf175a255231ad78$var$stopAt = (0, (0, parcelRequire("5dPhU")).default).durationDampening.stopDampeningAt;
    const $cf175a255231ad78$export$2fe468ff7a999ed6 = (proposedScroll, dragStartTime)=>{
        const startOfRange = dragStartTime;
        const endOfRange = $cf175a255231ad78$var$stopAt;
        const now = Date.now();
        const runTime = now - startOfRange;
        if (runTime >= $cf175a255231ad78$var$stopAt) return proposedScroll;
        if (runTime < $cf175a255231ad78$var$accelerateAt) return 0, (0, parcelRequire("c7MxM")).minScroll;
        const betweenAccelerateAtAndStopAtPercentage = (0, (0, parcelRequire("1nJb5")).getPercentage)({
            startOfRange: $cf175a255231ad78$var$accelerateAt,
            endOfRange: endOfRange,
            current: runTime
        });
        const scroll = proposedScroll * (0, (0, parcelRequire("5dPhU")).default).ease(betweenAccelerateAtAndStopAtPercentage);
        return Math.ceil(scroll);
    };
});
parcelRegister("1nJb5", function(module, exports) {
    $parcel$export(module.exports, "getPercentage", ()=>$97c2cc5b45cd05f2$export$6712e0f6cd0ea03);
    const $97c2cc5b45cd05f2$export$6712e0f6cd0ea03 = ({ startOfRange: startOfRange, endOfRange: endOfRange, current: current })=>{
        const range = endOfRange - startOfRange;
        if (range === 0) return 0;
        const currentInRange = current - startOfRange;
        const percentage = currentInRange / range;
        return percentage;
    };
});
parcelRegister("7PLLn", function(module, exports) {
    $parcel$export(module.exports, "getValueFromDistance", ()=>$cae7c45366044077$export$f3e495573a199c91);
    var $5dPhU;
    var $c7MxM;
    var $1nJb5;
    const $cae7c45366044077$export$f3e495573a199c91 = (distanceToEdge, thresholds)=>{
        if (distanceToEdge > thresholds.startScrollingFrom) return 0;
        if (distanceToEdge <= thresholds.maxScrollValueAt) return (0, (0, parcelRequire("5dPhU")).default).maxPixelScroll;
        if (distanceToEdge === thresholds.startScrollingFrom) return 0, (0, parcelRequire("c7MxM")).minScroll;
        const percentageFromMaxScrollValueAt = (0, (0, parcelRequire("1nJb5")).getPercentage)({
            startOfRange: thresholds.maxScrollValueAt,
            endOfRange: thresholds.startScrollingFrom,
            current: distanceToEdge
        });
        const percentageFromStartScrollingFrom = 1 - percentageFromMaxScrollValueAt;
        const scroll = (0, (0, parcelRequire("5dPhU")).default).maxPixelScroll * (0, (0, parcelRequire("5dPhU")).default).ease(percentageFromStartScrollingFrom);
        return Math.ceil(scroll);
    };
});
parcelRegister("fwuJo", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a586d2b9c4fa1764$export$2e2bcd8739ae039);
    var $1gIxK;
    var $aqWIJ;
    var $a586d2b9c4fa1764$export$2e2bcd8739ae039 = ({ viewport: viewport, center: center, dragStartTime: dragStartTime, shouldUseTimeDampening: shouldUseTimeDampening })=>{
        const scroll = (0, (0, parcelRequire("aqWIJ")).default)({
            dragStartTime: dragStartTime,
            container: viewport.container,
            center: center,
            shouldUseTimeDampening: shouldUseTimeDampening
        });
        return scroll && (0, (0, parcelRequire("1gIxK")).canScrollWindow)(viewport, scroll) ? scroll : null;
    };
});
parcelRegister("ddXS9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4a59f93a06f47e0a$export$2e2bcd8739ae039);
    var $3YKxB;
    var $kyWMf;
    var $1ErMw;
    var $4a59f93a06f47e0a$export$2e2bcd8739ae039 = ()=>{
        const scroll = (0, (0, parcelRequire("1ErMw")).default)();
        const maxScroll = (0, (0, parcelRequire("kyWMf")).default)();
        const top = scroll.y;
        const left = scroll.x;
        const doc = document.documentElement;
        const width = doc.clientWidth;
        const height = doc.clientHeight;
        const right = left + width;
        const bottom = top + height;
        const container = (0, (0, parcelRequire("3YKxB")).getRect)({
            top: top,
            left: left,
            right: right,
            bottom: bottom
        });
        const viewport = {
            container: container,
            scroll: {
                current: scroll,
                max: maxScroll
            }
        };
        return viewport;
    };
});
parcelRegister("kyWMf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$04c9a2af10e8306d$export$2e2bcd8739ae039);
    var $4T0S8;
    var $04c9a2af10e8306d$export$2e2bcd8739ae039 = ()=>{
        const doc = document.documentElement;
        const maxScroll = (0, (0, parcelRequire("4T0S8")).default)({
            scrollHeight: doc.scrollHeight,
            scrollWidth: doc.scrollWidth,
            width: doc.clientWidth,
            height: doc.clientHeight
        });
        return maxScroll;
    };
});
parcelRegister("4T0S8", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$658a12619734eef4$export$2e2bcd8739ae039);
    var $8X9I6;
    var $658a12619734eef4$export$2e2bcd8739ae039 = ({ scrollHeight: scrollHeight, scrollWidth: scrollWidth, height: height, width: width })=>{
        const maxScroll = (0, (0, parcelRequire("8X9I6")).subtract)({
            x: scrollWidth,
            y: scrollHeight
        }, {
            x: width,
            y: height
        });
        const adjustedMaxScroll = {
            x: Math.max(0, maxScroll.x),
            y: Math.max(0, maxScroll.y)
        };
        return adjustedMaxScroll;
    };
});
parcelRegister("1ErMw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$dcec96e23ef942fa$export$2e2bcd8739ae039);
    var $dcec96e23ef942fa$export$2e2bcd8739ae039 = ()=>({
            x: window.pageXOffset,
            y: window.pageYOffset
        });
});
parcelRegister("695Hr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$55f5b8e4f5cdd430$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $fNuuD;
    var $3SHG6;
    var $khH0q;
    const $55f5b8e4f5cdd430$var$baseTrackStyles = null;
    const $55f5b8e4f5cdd430$var$baseThumbStyles = null;
    const $55f5b8e4f5cdd430$var$visibleStyles = null;
    const $55f5b8e4f5cdd430$var$notVisibleStyles = null;
    const $55f5b8e4f5cdd430$var$verticalTrackStyles = null;
    const $55f5b8e4f5cdd430$var$horizontalTrackStyles = null;
    const $55f5b8e4f5cdd430$var$verticalThumbStyles = null;
    const $55f5b8e4f5cdd430$var$horizontalThumbStyles = null;
    const $55f5b8e4f5cdd430$var$HorizontalThumb = ({ size: size, innerRef: innerRef, children: children, ...rest })=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "roadmap.timeline-table.main.custom-scrollbars.thumb-tracks.horizontal-thumb",
            ref: innerRef,
            style: {
                width: `${size}px`
            },
            ...rest,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm _2rko19bv _bfhkvrk4",
                "_4t3i1osq"
            ])
        }, children);
    const $55f5b8e4f5cdd430$var$VerticalThumb = ({ size: size, innerRef: innerRef, children: children, ...rest })=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "roadmap.timeline-table.main.custom-scrollbars.thumb-tracks.vertical-thumb",
            ref: innerRef,
            style: {
                height: `${size}px`
            },
            ...rest,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm _2rko19bv _bfhkvrk4",
                "_1bsb1osq"
            ])
        }, children);
    const $55f5b8e4f5cdd430$var$DraggableHorizontalThumb = (0, (0, parcelRequire("fNuuD")).withDragObserver)($55f5b8e4f5cdd430$var$HorizontalThumb, (0, (0, parcelRequire("3SHG6")).THUMB_DRAG_THRESHOLD));
    const $55f5b8e4f5cdd430$var$DraggableVerticalThumb = (0, (0, parcelRequire("fNuuD")).withDragObserver)($55f5b8e4f5cdd430$var$VerticalThumb, (0, (0, parcelRequire("3SHG6")).THUMB_DRAG_THRESHOLD));
    const $55f5b8e4f5cdd430$var$ScrollbarThumbTracks = ({ listWidth: listWidth, isHideScrollbar: isHideScrollbar, timelineTop: timelineTop, onSetScrollLeft: onSetScrollLeft, onSetScrollTop: onSetScrollTop }, ref)=>{
        const horizontalTrackRef = (0, $5uXOq.useRef)(null);
        const horizontalThumbRef = (0, $5uXOq.useRef)(null);
        const verticalTrackRef = (0, $5uXOq.useRef)(null);
        const verticalThumbRef = (0, $5uXOq.useRef)(null);
        const dragCache = (0, $5uXOq.useRef)((0, (0, parcelRequire("3SHG6")).DEFAULT_DRAG_CACHE));
        const [{ horizontalThumbSize: horizontalThumbSize, verticalThumbSize: verticalThumbSize }, setThumbSizes] = (0, $5uXOq.useState)({
            horizontalThumbSize: 0,
            verticalThumbSize: 0
        });
        const setHorizontalThumbPosition = (0, $5uXOq.useCallback)((trackSize, scrollRatio, thumbSize)=>{
            if (scrollRatio >= 0) {
                const position = (0, (0, parcelRequire("khH0q")).getThumbPosition)(scrollRatio, trackSize, thumbSize);
                if (horizontalThumbRef.current) horizontalThumbRef.current.style.transform = `translateX(${position}px)`;
            }
        }, []);
        const setVerticalThumbPosition = (0, $5uXOq.useCallback)((trackSize, scrollRatio, thumbSize)=>{
            if (scrollRatio >= 0) {
                const position = (0, (0, parcelRequire("khH0q")).getThumbPosition)(scrollRatio, trackSize, thumbSize);
                if (verticalThumbRef.current) verticalThumbRef.current.style.transform = `translateY(${position}px)`;
            }
        }, []);
        (0, $5uXOq.useImperativeHandle)(ref, ()=>({
                setThumbPositions: ({ horizontalScrollRatio: horizontalScrollRatio, verticalScrollRatio: verticalScrollRatio })=>{
                    if (!horizontalTrackRef.current || !verticalTrackRef.current) throw new Error('An element required to set the thumb positions were null');
                    const { clientWidth: clientWidth } = horizontalTrackRef.current;
                    const { clientHeight: clientHeight } = verticalTrackRef.current;
                    setHorizontalThumbPosition(clientWidth, horizontalScrollRatio, horizontalThumbSize);
                    setVerticalThumbPosition(clientHeight, verticalScrollRatio, verticalThumbSize);
                },
                update: ({ horizontalScrollRatio: horizontalScrollRatio, verticalScrollRatio: verticalScrollRatio }, { horizontalContentRatio: horizontalContentRatio, verticalContentRatio: verticalContentRatio })=>{
                    if (!horizontalTrackRef.current || !verticalTrackRef.current) throw new Error('An element required to update the thumb tracks were null');
                    const { clientWidth: clientWidth } = horizontalTrackRef.current;
                    const { clientHeight: clientHeight } = verticalTrackRef.current;
                    let hThumbSize = 0;
                    let vThumbSize = 0;
                    if (horizontalContentRatio < 1) {
                        hThumbSize = (0, (0, parcelRequire("khH0q")).getThumbSize)(horizontalContentRatio, clientWidth);
                        setHorizontalThumbPosition(clientWidth, horizontalScrollRatio, hThumbSize);
                    }
                    if (verticalContentRatio < 1) {
                        vThumbSize = (0, (0, parcelRequire("khH0q")).getThumbSize)(verticalContentRatio, clientHeight);
                        setVerticalThumbPosition(clientHeight, verticalScrollRatio, vThumbSize);
                    }
                    setThumbSizes((0, (0, parcelRequire("khH0q")).getMemoisedThumbState)(hThumbSize, vThumbSize));
                }
            }), [
            horizontalThumbSize,
            verticalThumbSize,
            setHorizontalThumbPosition,
            setVerticalThumbPosition
        ]);
        const onStartDragHorizontalThumb = ({ x: x })=>{
            if (!horizontalTrackRef.current || !horizontalThumbRef.current) throw new Error('An element required to drag the horizontal scroll thumb was null');
            const { left: left, width: width } = horizontalTrackRef.current.getBoundingClientRect();
            const thumbClientRect = horizontalThumbRef.current.getBoundingClientRect();
            const relativeMousePosition = x - thumbClientRect.left;
            dragCache.current = {
                thumbOrigin: Math.round(horizontalThumbSize / 2 - relativeMousePosition),
                trackPosition: left,
                trackSize: width
            };
        };
        const onDragHorizontalThumb = (from, to)=>{
            const { thumbOrigin: thumbOrigin, trackPosition: trackPosition, trackSize: trackSize } = dragCache.current;
            const relativeScrollPosition = (0, (0, parcelRequire("khH0q")).getRelativeScrollPosition)({
                thumbPosition: thumbOrigin + to.x,
                thumbSize: horizontalThumbSize,
                trackPosition: trackPosition,
                trackSize: trackSize
            });
            onSetScrollLeft(relativeScrollPosition);
        };
        const onMouseDownHorizontalTrack = (event)=>{
            const { left: left, width: width } = event.currentTarget.getBoundingClientRect();
            const relativeScrollPosition = (0, (0, parcelRequire("khH0q")).getRelativeScrollPosition)({
                thumbPosition: event.pageX,
                thumbSize: horizontalThumbSize,
                trackPosition: left,
                trackSize: width
            });
            onSetScrollLeft(relativeScrollPosition);
        };
        const onStartDragVerticalThumb = ({ y: y })=>{
            if (!verticalTrackRef.current || !verticalThumbRef.current) throw new Error('An element required to drag the vertical scroll thumb was null');
            const { top: top, height: height } = verticalTrackRef.current.getBoundingClientRect();
            const thumbClientRect = verticalThumbRef.current.getBoundingClientRect();
            const relativeMousePosition = y - thumbClientRect.top;
            dragCache.current = {
                thumbOrigin: Math.round(verticalThumbSize / 2 - relativeMousePosition),
                trackPosition: top,
                trackSize: height
            };
        };
        const onDragVerticalThumb = (from, to)=>{
            const { thumbOrigin: thumbOrigin, trackPosition: trackPosition, trackSize: trackSize } = dragCache.current;
            const relativeScrollPosition = (0, (0, parcelRequire("khH0q")).getRelativeScrollPosition)({
                thumbPosition: thumbOrigin + to.y,
                thumbSize: verticalThumbSize,
                trackPosition: trackPosition,
                trackSize: trackSize
            });
            onSetScrollTop(relativeScrollPosition);
        };
        const onMouseDownVerticalTrack = (event)=>{
            const { top: top, height: height } = event.currentTarget.getBoundingClientRect();
            const relativeScrollPosition = (0, (0, parcelRequire("khH0q")).getRelativeScrollPosition)({
                thumbPosition: event.pageY,
                thumbSize: verticalThumbSize,
                trackPosition: top,
                trackSize: height
            });
            onSetScrollTop(relativeScrollPosition);
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            ref: horizontalTrackRef,
            "data-testid": "roadmap.timeline-table.main.custom-scrollbars.thumb-tracks.horizontal-track",
            style: {
                left: `${listWidth + (0, (0, parcelRequire("3SHG6")).SCROLLBAR_OFFSET)}px`
            },
            onMouseDown: onMouseDownHorizontalTrack,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _2rko19bv _1pbyibnn _o7ks1fkz _irr31409 _1di61409",
                horizontalThumbSize > 0 && !isHideScrollbar ? "_3um0ewfl" : "_3um015vq",
                "_1xi21v6z _4t3i19bv _94n5idpf"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($55f5b8e4f5cdd430$var$DraggableHorizontalThumb, {
            innerRef: horizontalThumbRef,
            size: horizontalThumbSize,
            onDrag: onDragHorizontalThumb,
            onDragStart: onStartDragHorizontalThumb
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            ref: verticalTrackRef,
            "data-testid": "roadmap.timeline-table.main.custom-scrollbars.thumb-tracks.vertical-track",
            style: {
                top: `${timelineTop + (0, (0, parcelRequire("3SHG6")).SCROLLBAR_OFFSET)}px`
            },
            onMouseDown: onMouseDownVerticalTrack,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _2rko19bv _1pbyibnn _o7ks1fkz _irr31409 _1di61409",
                verticalThumbSize > 0 && !isHideScrollbar ? "_3um0ewfl" : "_3um015vq",
                "_94n51v6z _1bsb19bv _1xi2idpf"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($55f5b8e4f5cdd430$var$DraggableVerticalThumb, {
            innerRef: verticalThumbRef,
            size: verticalThumbSize,
            onDrag: onDragVerticalThumb,
            onDragStart: onStartDragVerticalThumb
        })));
    };
    var $55f5b8e4f5cdd430$export$2e2bcd8739ae039 = (0, $5uXOq.forwardRef)($55f5b8e4f5cdd430$var$ScrollbarThumbTracks);
});
parcelRegister("3SHG6", function(module, exports) {
    $parcel$export(module.exports, "THUMB_DRAG_THRESHOLD", ()=>$c24fc9f6483454d6$export$e42a8c8f5541f7b0);
    $parcel$export(module.exports, "THUMB_MINIMUM_SIZE", ()=>$c24fc9f6483454d6$export$e68be48bcc227668);
    $parcel$export(module.exports, "SCROLLBAR_OFFSET", ()=>$c24fc9f6483454d6$export$b902a3a0053e40b);
    $parcel$export(module.exports, "DEFAULT_DRAG_CACHE", ()=>$c24fc9f6483454d6$export$1580f12b2bee9a05);
    const $c24fc9f6483454d6$export$e42a8c8f5541f7b0 = 0.1;
    const $c24fc9f6483454d6$export$e68be48bcc227668 = 20;
    const $c24fc9f6483454d6$export$d83d7e5e215aa7f9 = 10;
    const $c24fc9f6483454d6$export$b902a3a0053e40b = 7;
    const $c24fc9f6483454d6$export$1580f12b2bee9a05 = {
        thumbOrigin: 0,
        trackPosition: 0,
        trackSize: 0
    };
});
parcelRegister("khH0q", function(module, exports) {
    $parcel$export(module.exports, "getRelativeScrollPosition", ()=>$1f21e85cd42fa368$export$2bc8e9ae2ef96ba4);
    $parcel$export(module.exports, "getThumbPosition", ()=>$1f21e85cd42fa368$export$1bcd41904c090870);
    $parcel$export(module.exports, "getThumbSize", ()=>$1f21e85cd42fa368$export$7b14c3f3cc4d1eca);
    $parcel$export(module.exports, "getMemoisedThumbState", ()=>$1f21e85cd42fa368$export$1c021ba4dc4fcf31);
    var $8QpSo;
    var $3SHG6;
    const $1f21e85cd42fa368$export$2bc8e9ae2ef96ba4 = ({ thumbPosition: thumbPosition, thumbSize: thumbSize, trackPosition: trackPosition, trackSize: trackSize })=>{
        const relativePosition = thumbPosition - trackPosition;
        const newThumbOffset = relativePosition - thumbSize / 2;
        return newThumbOffset / trackSize;
    };
    const $1f21e85cd42fa368$export$1bcd41904c090870 = (scrollOffsetRatio, trackSize, thumbSize)=>scrollOffsetRatio * (trackSize - thumbSize);
    const $1f21e85cd42fa368$export$7b14c3f3cc4d1eca = (contentToViewportRatio, trackSize)=>{
        const size = Math.round(contentToViewportRatio * trackSize);
        return Math.max((0, (0, parcelRequire("3SHG6")).THUMB_MINIMUM_SIZE), size);
    };
    const $1f21e85cd42fa368$export$1c021ba4dc4fcf31 = (0, (0, parcelRequire("8QpSo")).default)((horizontalThumbSize, verticalThumbSize)=>({
            horizontalThumbSize: horizontalThumbSize,
            verticalThumbSize: verticalThumbSize
        }));
});
parcelRegister("6NWvS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a4792843849a449a$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $3joPi = parcelRequire("3joPi");
    var $gOxHv = parcelRequire("gOxHv");
    var $2o71Q = parcelRequire("2o71Q");
    var $lFzC1 = parcelRequire("lFzC1");
    var $3SHG6;
    var $khH0q;
    const $a4792843849a449a$var$baseTrackStyles = null;
    const $a4792843849a449a$var$baseThumbStyles = null;
    const $a4792843849a449a$var$visibleStyles = null;
    const $a4792843849a449a$var$notVisibleStyles = null;
    const $a4792843849a449a$var$verticalTrackStyles = null;
    const $a4792843849a449a$var$horizontalTrackStyles = null;
    const $a4792843849a449a$var$verticalThumbStyles = null;
    const $a4792843849a449a$var$horizontalThumbStyles = null;
    const $a4792843849a449a$var$useImperativeTracksAndThumbs = ({ mainComponentRef: mainComponentRef })=>{
        const horizontalTrackRef = (0, $5uXOq.useRef)(null);
        const horizontalThumbRef = (0, $5uXOq.useRef)(null);
        const verticalTrackRef = (0, $5uXOq.useRef)(null);
        const verticalThumbRef = (0, $5uXOq.useRef)(null);
        const [{ horizontalThumbSize: horizontalThumbSize, verticalThumbSize: verticalThumbSize }, setThumbSizes] = (0, $5uXOq.useState)({
            horizontalThumbSize: 0,
            verticalThumbSize: 0
        });
        const setHorizontalThumbPosition = (0, $5uXOq.useCallback)((trackSize, scrollRatio, thumbSize)=>{
            if (scrollRatio >= 0) {
                const position = (0, (0, parcelRequire("khH0q")).getThumbPosition)(scrollRatio, trackSize, thumbSize);
                if (horizontalThumbRef.current) horizontalThumbRef.current.style.transform = `translateX(${position}px)`;
            }
        }, []);
        const setVerticalThumbPosition = (0, $5uXOq.useCallback)((trackSize, scrollRatio, thumbSize)=>{
            if (scrollRatio >= 0) {
                const position = (0, (0, parcelRequire("khH0q")).getThumbPosition)(scrollRatio, trackSize, thumbSize);
                if (verticalThumbRef.current) verticalThumbRef.current.style.transform = `translateY(${position}px)`;
            }
        }, []);
        (0, $5uXOq.useImperativeHandle)(mainComponentRef, ()=>({
                setThumbPositions: ({ horizontalScrollRatio: horizontalScrollRatio, verticalScrollRatio: verticalScrollRatio })=>{
                    if (!horizontalTrackRef.current || !verticalTrackRef.current) throw new Error('An element required to set the thumb positions were null');
                    const { clientWidth: clientWidth } = horizontalTrackRef.current;
                    const { clientHeight: clientHeight } = verticalTrackRef.current;
                    setHorizontalThumbPosition(clientWidth, horizontalScrollRatio, horizontalThumbSize);
                    setVerticalThumbPosition(clientHeight, verticalScrollRatio, verticalThumbSize);
                },
                update: ({ horizontalScrollRatio: horizontalScrollRatio, verticalScrollRatio: verticalScrollRatio }, { horizontalContentRatio: horizontalContentRatio, verticalContentRatio: verticalContentRatio })=>{
                    if (!horizontalTrackRef.current || !verticalTrackRef.current) throw new Error('An element required to update the thumb tracks were null');
                    const { clientWidth: clientWidth } = horizontalTrackRef.current;
                    const { clientHeight: clientHeight } = verticalTrackRef.current;
                    let hThumbSize = 0;
                    let vThumbSize = 0;
                    if (horizontalContentRatio < 1) {
                        hThumbSize = (0, (0, parcelRequire("khH0q")).getThumbSize)(horizontalContentRatio, clientWidth);
                        setHorizontalThumbPosition(clientWidth, horizontalScrollRatio, hThumbSize);
                    }
                    if (verticalContentRatio < 1) {
                        vThumbSize = (0, (0, parcelRequire("khH0q")).getThumbSize)(verticalContentRatio, clientHeight);
                        setVerticalThumbPosition(clientHeight, verticalScrollRatio, vThumbSize);
                    }
                    setThumbSizes((0, (0, parcelRequire("khH0q")).getMemoisedThumbState)(hThumbSize, vThumbSize));
                }
            }), [
            horizontalThumbSize,
            verticalThumbSize,
            setHorizontalThumbPosition,
            setVerticalThumbPosition
        ]);
        return {
            horizontalThumbRef: horizontalThumbRef,
            horizontalTrackRef: horizontalTrackRef,
            verticalTrackRef: verticalTrackRef,
            verticalThumbRef: verticalThumbRef,
            horizontalThumbSize: horizontalThumbSize,
            verticalThumbSize: verticalThumbSize
        };
    };
    const $a4792843849a449a$var$handleThumbMouseDown = (event)=>{
        event.stopPropagation();
    };
    const $a4792843849a449a$var$CustomScrollbarThumbTracks = ({ listWidth: listWidth, isHideScrollbar: isHideScrollbar, timelineTop: timelineTop, onSetScrollLeft: onSetScrollLeft, onSetScrollTop: onSetScrollTop }, ref)=>{
        const dragCache = (0, $5uXOq.useRef)((0, (0, parcelRequire("3SHG6")).DEFAULT_DRAG_CACHE));
        const { horizontalThumbRef: horizontalThumbRef, horizontalTrackRef: horizontalTrackRef, verticalTrackRef: verticalTrackRef, verticalThumbRef: verticalThumbRef, horizontalThumbSize: horizontalThumbSize, verticalThumbSize: verticalThumbSize } = $a4792843849a449a$var$useImperativeTracksAndThumbs({
            mainComponentRef: ref
        });
        const onStartDragHorizontalThumb = (0, $5uXOq.useCallback)(({ location: location })=>{
            if (!horizontalTrackRef.current || !horizontalThumbRef.current) throw new Error('An element required to drag the horizontal scroll thumb was null');
            const { left: left, width: width } = horizontalTrackRef.current.getBoundingClientRect();
            const thumbClientRect = horizontalThumbRef.current.getBoundingClientRect();
            const relativeMousePosition = location.initial.input.clientX - thumbClientRect.left;
            dragCache.current = {
                thumbOrigin: Math.round(horizontalThumbSize / 2 - relativeMousePosition),
                trackPosition: left,
                trackSize: width
            };
        }, [
            horizontalThumbRef,
            horizontalThumbSize,
            horizontalTrackRef
        ]);
        const onDragHorizontalThumb = (0, $5uXOq.useCallback)(({ location: location })=>{
            const { thumbOrigin: thumbOrigin, trackPosition: trackPosition, trackSize: trackSize } = dragCache.current;
            const relativeScrollPosition = (0, (0, parcelRequire("khH0q")).getRelativeScrollPosition)({
                thumbPosition: thumbOrigin + location.current.input.clientX,
                thumbSize: horizontalThumbSize,
                trackPosition: trackPosition,
                trackSize: trackSize
            });
            onSetScrollLeft(relativeScrollPosition);
        }, [
            horizontalThumbSize,
            onSetScrollLeft
        ]);
        const onMouseDownHorizontalTrack = (event)=>{
            const { left: left, width: width } = event.currentTarget.getBoundingClientRect();
            const relativeScrollPosition = (0, (0, parcelRequire("khH0q")).getRelativeScrollPosition)({
                thumbPosition: event.pageX,
                thumbSize: horizontalThumbSize,
                trackPosition: left,
                trackSize: width
            });
            onSetScrollLeft(relativeScrollPosition);
        };
        const onMouseDownVerticalTrack = (event)=>{
            const { top: top, height: height } = event.currentTarget.getBoundingClientRect();
            const relativeScrollPosition = (0, (0, parcelRequire("khH0q")).getRelativeScrollPosition)({
                thumbPosition: event.pageY,
                thumbSize: verticalThumbSize,
                trackPosition: top,
                trackSize: height
            });
            onSetScrollTop(relativeScrollPosition);
        };
        const onStartDragVerticalThumb = (0, $5uXOq.useCallback)(({ location: location })=>{
            if (!verticalTrackRef.current || !verticalThumbRef.current) throw new Error('An element required to drag the vertical scroll thumb was null');
            const { top: top, height: height } = verticalTrackRef.current.getBoundingClientRect();
            const thumbClientRect = verticalThumbRef.current.getBoundingClientRect();
            const relativeMousePosition = location.initial.input.clientY - thumbClientRect.top;
            dragCache.current = {
                thumbOrigin: Math.round(verticalThumbSize / 2 - relativeMousePosition),
                trackPosition: top,
                trackSize: height
            };
        }, [
            verticalThumbRef,
            verticalThumbSize,
            verticalTrackRef
        ]);
        const onDragVerticalThumb = (0, $5uXOq.useCallback)(({ location: location })=>{
            const { thumbOrigin: thumbOrigin, trackPosition: trackPosition, trackSize: trackSize } = dragCache.current;
            const relativeScrollPosition = (0, (0, parcelRequire("khH0q")).getRelativeScrollPosition)({
                thumbPosition: thumbOrigin + location.current.input.clientY,
                thumbSize: verticalThumbSize,
                trackPosition: trackPosition,
                trackSize: trackSize
            });
            onSetScrollTop(relativeScrollPosition);
        }, [
            verticalThumbSize,
            onSetScrollTop
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const horizontalThumb = horizontalThumbRef.current;
            (0, $3joPi.default)(horizontalThumb);
            return (0, $gOxHv.draggable)({
                element: horizontalThumb,
                onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                    (0, $2o71Q.disableNativeDragPreview)({
                        nativeSetDragImage: nativeSetDragImage
                    });
                    (0, $lFzC1.preventUnhandled).start();
                },
                onDragStart: onStartDragHorizontalThumb,
                onDrag: onDragHorizontalThumb
            });
        }, [
            onStartDragHorizontalThumb,
            onDragHorizontalThumb,
            horizontalThumbRef
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const verticalThumb = verticalThumbRef.current;
            (0, $3joPi.default)(verticalThumb);
            return (0, $gOxHv.draggable)({
                element: verticalThumb,
                onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                    (0, $2o71Q.disableNativeDragPreview)({
                        nativeSetDragImage: nativeSetDragImage
                    });
                    (0, $lFzC1.preventUnhandled).start();
                },
                onDragStart: onStartDragVerticalThumb,
                onDrag: onDragVerticalThumb
            });
        }, [
            onStartDragVerticalThumb,
            onDragVerticalThumb,
            verticalThumbRef
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            ref: horizontalTrackRef,
            "data-testid": "roadmap.timeline-table.main.custom-scrollbars.thumb-tracks.horizontal-track",
            style: {
                left: `${listWidth + (0, (0, parcelRequire("3SHG6")).SCROLLBAR_OFFSET)}px`
            },
            onMouseDown: onMouseDownHorizontalTrack,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _2rko19bv _1pbyibnn _o7ks1fkz _irr31409 _1di61409",
                horizontalThumbSize > 0 && !isHideScrollbar ? "_3um0ewfl" : "_3um015vq",
                "_1xi21v6z _4t3i19bv _94n5idpf"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "roadmap.timeline-table.main.custom-scrollbars.thumb-tracks.horizontal-thumb",
            ref: horizontalThumbRef,
            onMouseDown: $a4792843849a449a$var$handleThumbMouseDown,
            style: {
                width: `${horizontalThumbSize}px`
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm _2rko19bv _bfhkvrk4",
                "_4t3i1osq"
            ])
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            ref: verticalTrackRef,
            "data-testid": "roadmap.timeline-table.main.custom-scrollbars.thumb-tracks.vertical-track",
            style: {
                top: `${timelineTop + (0, (0, parcelRequire("3SHG6")).SCROLLBAR_OFFSET)}px`
            },
            onMouseDown: onMouseDownVerticalTrack,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _2rko19bv _1pbyibnn _o7ks1fkz _irr31409 _1di61409",
                verticalThumbSize > 0 && !isHideScrollbar ? "_3um0ewfl" : "_3um015vq",
                "_94n51v6z _1bsb19bv _1xi2idpf"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "roadmap.timeline-table.main.custom-scrollbars.thumb-tracks.vertical-thumb",
            ref: verticalThumbRef,
            onMouseDown: $a4792843849a449a$var$handleThumbMouseDown,
            style: {
                height: `${verticalThumbSize}px`
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm _2rko19bv _bfhkvrk4",
                "_1bsb1osq"
            ])
        })));
    };
    var $a4792843849a449a$export$2e2bcd8739ae039 = (0, $5uXOq.forwardRef)($a4792843849a449a$var$CustomScrollbarThumbTracks);
});
parcelRegister("csiwd", function(module, exports) {
    $parcel$export(module.exports, "getScrollbarSize", ()=>$2cd1680e9e2fd335$export$728dbf35b325565b);
    $parcel$export(module.exports, "getScrollOffsetRatio", ()=>$2cd1680e9e2fd335$export$1fb2953abd799768);
    $parcel$export(module.exports, "getContentToViewportRatio", ()=>$2cd1680e9e2fd335$export$e27ceda66fe97870);
    $parcel$export(module.exports, "getViewportOffsets", ()=>$2cd1680e9e2fd335$export$af20ae2261e1a891);
    var $8QpSo;
    const $2cd1680e9e2fd335$export$728dbf35b325565b = (scrollElement)=>scrollElement.offsetWidth - scrollElement.clientWidth;
    const $2cd1680e9e2fd335$export$1fb2953abd799768 = (scrollOffset, scrollSize, clientSize)=>scrollOffset / (scrollSize - clientSize);
    const $2cd1680e9e2fd335$export$e27ceda66fe97870 = (scrollSize, clientSize)=>clientSize / scrollSize;
    const $2cd1680e9e2fd335$export$af20ae2261e1a891 = (0, (0, parcelRequire("8QpSo")).default)((scrollbarSize, listWidth, timelineTop)=>({
            scrollbar: scrollbarSize,
            timelineLeft: listWidth,
            timelineTop: timelineTop
        }));
});
parcelRegister("4nLPh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$73bac808c32ccbec$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $5EOne = parcelRequire("5EOne");
    var $gOxHv = parcelRequire("gOxHv");
    var $iZN6h;
    var $WPwAA;
    var $3ruU1;
    var $lGdZu;
    var $7ouUj;
    const $73bac808c32ccbec$var$DragMonitor = ({ DndLongTaskMetric: DndLongTaskMetric })=>{
        const [{ isTreeDrag: isTreeDrag }] = (0, (0, parcelRequire("WPwAA")).useEnablements)();
        const [dragState, setDragState] = (0, $5uXOq.useState)({
            level: (0, (0, parcelRequire("iZN6h")).DEFAULT_LEVEL),
            isDragging: false
        });
        const { onRowDragStart: onRowDragStart, onRowDragEnd: onRowDragEnd, onRowDragOutOfBounds: onRowDragOutOfBounds } = (0, (0, parcelRequire("3ruU1")).useSideEffectMarshal)();
        const { onResize: onResize } = (0, (0, parcelRequire("lGdZu")).useTimelineViewportActions)();
        (0, $5uXOq.useEffect)(()=>(0, $5EOne.combine)((0, $gOxHv.monitorForElements)({
                onDragStart: ({ source: source })=>{
                    const item = source.data;
                    if (item.type === (0, (0, parcelRequire("iZN6h")).ROW_DRAG_AND_DROP_ID)) {
                        onRowDragStart(item.id);
                        setDragState({
                            level: item.level,
                            isDragging: true
                        });
                    }
                },
                onDropTargetChange: ({ source: source, location: location })=>{
                    const item = source.data;
                    if (item.type === (0, (0, parcelRequire("iZN6h")).ROW_DRAG_AND_DROP_ID)) {
                        const { dropTargets: dropTargets } = location.current;
                        if (dropTargets.length === 0) onRowDragOutOfBounds(item.id);
                    }
                },
                onDrop: ({ source: source })=>{
                    const item = source.data;
                    if (item.type === (0, (0, parcelRequire("iZN6h")).ROW_DRAG_AND_DROP_ID)) {
                        onRowDragEnd(item.id);
                        setDragState({
                            level: item.level,
                            isDragging: false
                        });
                        if (isTreeDrag) onResize({
                            indicatorLineOffset: 0
                        });
                    }
                }
            })), [
            onRowDragStart,
            onRowDragEnd,
            onRowDragOutOfBounds,
            onResize,
            isTreeDrag
        ]);
        return DndLongTaskMetric ? (0, ($parcel$interopDefault($5uXOq))).createElement(DndLongTaskMetric, {
            isDragging: dragState.isDragging,
            metricType: (0, (0, parcelRequire("7ouUj")).isBaseLevel)(dragState.level) ? (0, (0, parcelRequire("iZN6h")).CHILD_LIST_DRAG_AND_DROP) : (0, (0, parcelRequire("iZN6h")).LIST_DRAG_AND_DROP)
        }) : null;
    };
    const $73bac808c32ccbec$var$DragMonitorEnabler = (props)=>{
        const [{ isDragEnabled: isDragEnabled }] = (0, (0, parcelRequire("WPwAA")).useEnablements)();
        return isDragEnabled ? (0, ($parcel$interopDefault($5uXOq))).createElement($73bac808c32ccbec$var$DragMonitor, props) : null;
    };
    var $73bac808c32ccbec$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($73bac808c32ccbec$var$DragMonitorEnabler);
});
parcelRegister("a79cp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b70bfe2d939251cd$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $l8ruj;
    var $iZN6h;
    var $g3prf;
    var $3Kr5N;
    var $iNpaX;
    var $7x4gL;
    var $bwj2C;
    const $b70bfe2d939251cd$var$headerContainerStyles = null;
    const $b70bfe2d939251cd$var$headerRowStyles = null;
    const $b70bfe2d939251cd$var$headerShadow = null;
    const $b70bfe2d939251cd$var$defaultBackground = null;
    const $b70bfe2d939251cd$var$Header = ({ renderListHeaderItem: renderListHeaderItem, renderChartHeaderItem: renderChartHeaderItem })=>{
        const [{ headerItems: headerItems, headerHeight: headerHeight, isRowCountKnown: isRowCountKnown }] = (0, (0, parcelRequire("g3prf")).useHeaderState)();
        const [isAtTop] = (0, (0, parcelRequire("3Kr5N")).isScrollToTop)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "timeline-table-header"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            role: "rowgroup",
            style: {
                height: headerHeight
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqsw1if8 _vchhusvi _1bsb1osq _154iidpf _11q7vuon _2rkoo8o8 _1pby1ial",
                !isAtTop && "_16qs157p"
            ])
        }, headerItems.map(({ height: height = (0, (0, parcelRequire("iZN6h")).DEFAULT_SUBHEADER_HEIGHT), id: id }, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                key: id,
                "data-testid": `roadmap.timeline-table.main.header.sub-header-${id.toLowerCase()}`,
                role: "row",
                "aria-rowindex": isRowCountKnown ? index + 1 : undefined,
                style: {
                    height: height
                },
                className: (0, (0, parcelRequire("bwpsq")).default)([
                    "_kqswh2mm _1e0c1txw",
                    id === (0, (0, parcelRequire("iZN6h")).DEFAULT_HEADER_ROW_ID) && "_bfhk1s4m"
                ])
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bwj2C")).default), {
                id: id,
                itemHeight: height,
                renderListHeaderItem: renderListHeaderItem
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7x4gL")).ChartHeaderCell), {
                id: id,
                itemHeight: height,
                renderChartHeaderItem: renderChartHeaderItem
            }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iNpaX")).default), {
            isOverlayInHeader: true
        })));
    };
    $b70bfe2d939251cd$var$Header.displayName = 'Header';
    $b70bfe2d939251cd$var$Header.whyDidYouRender = true;
    var $b70bfe2d939251cd$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($b70bfe2d939251cd$var$Header);
});
parcelRegister("7x4gL", function(module, exports) {
    $parcel$export(module.exports, "ChartHeaderCell", ()=>$79e5f0136d703cf2$export$da889e50c82c0962);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $iZN6h;
    var $WPwAA;
    var $5BWo9;
    var $biT18;
    var $l5t89;
    const $79e5f0136d703cf2$var$defaultHeaderCellsContainer = null;
    const $79e5f0136d703cf2$var$subHeaderCellsContainer = null;
    const $79e5f0136d703cf2$export$da889e50c82c0962 = ({ id: id, itemHeight: itemHeight, renderChartHeaderItem: renderChartHeaderItem })=>{
        const [{ timelineWidth: timelineWidth, timelineMode: timelineMode, timelineDuration: timelineDuration, columnDurations: columnDurations, today: today }] = (0, (0, parcelRequire("biT18")).useTimelineState)();
        const [{ isHighlightToday: isHighlightToday }] = (0, (0, parcelRequire("WPwAA")).useEnablements)();
        const cellRef = (0, (0, parcelRequire("5BWo9")).useGridCell)(id, (0, (0, parcelRequire("iZN6h")).CHART_COLUMN_COORDINATE));
        if (id === (0, (0, parcelRequire("iZN6h")).DEFAULT_HEADER_ROW_ID)) return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            style: {
                width: timelineWidth,
                height: itemHeight
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm _vchhusvi _x3doh6cr _n7zlh6cr _1pby1ohn"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l5t89")).default), {
            today: today,
            timelineMode: timelineMode,
            timelineDuration: timelineDuration,
            columnDurations: columnDurations,
            isHighlightToday: isHighlightToday
        }));
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            ref: cellRef,
            role: "gridcell",
            tabIndex: -1,
            style: {
                width: timelineWidth,
                height: itemHeight
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm _vchhusvi _1e0c1txw _4cvr1h6o _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _n7zlh6cr _1pby1ohn _nt751r31 _49pcglyw _1hvw1o36 _1ejj168b"
            ])
        }, renderChartHeaderItem({
            id: id
        }));
    };
});
parcelRegister("l5t89", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$36f809feb4beb8ef$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $cSD7y;
    var $iZN6h;
    var $iwcO1;
    var $lztNT;
    var $fFQYa;
    var $E9dZI;
    var $gORsc;
    var $ayXBh;
    const $36f809feb4beb8ef$var$containerStyles = null;
    const $36f809feb4beb8ef$var$ChartCalendarCellsNew = ({ isHighlightToday: isHighlightToday, today: today, timelineMode: timelineMode, timelineDuration: timelineDuration, columnDurations: columnDurations })=>{
        const todayColumnIndex = (0, (0, parcelRequire("iwcO1")).getTodayColumnIndex)(today, columnDurations);
        const getIsHighlighted = (0, $5uXOq.useCallback)((index)=>isHighlightToday && todayColumnIndex === index, [
            isHighlightToday,
            todayColumnIndex
        ]);
        const renderWeekCells = (0, $5uXOq.useCallback)((columnPositions)=>{
            const todayCoordinates = isHighlightToday ? (0, (0, parcelRequire("lztNT")).getTodayCoordinates)(today, columnDurations) : undefined;
            const columnWeekNumbers = (0, (0, parcelRequire("lztNT")).getColumnWeekNumbers)(columnDurations);
            const yearCaptions = (0, (0, parcelRequire("lztNT")).getColumnYearCaptions)(today, columnDurations);
            return columnPositions.map(([left, right], index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fFQYa")).CalendarCellWrapper), {
                    key: index,
                    left: left,
                    right: right,
                    column: index
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ayXBh")).default), {
                    columnIndex: index,
                    isHighlightToday: isHighlightToday,
                    todayCoordinates: todayCoordinates,
                    weekNumbers: columnWeekNumbers[index],
                    yearCaption: yearCaptions[index],
                    isHighlighted: getIsHighlighted(index)
                })));
        }, [
            isHighlightToday,
            today,
            columnDurations,
            getIsHighlighted
        ]);
        const renderMonthCells = (0, $5uXOq.useCallback)((columnPositions)=>{
            const columnMonthNumbers = (0, (0, parcelRequire("lztNT")).getColumnMonthNumbers)(columnDurations);
            const yearCaptions = (0, (0, parcelRequire("lztNT")).getColumnYearCaptions)(today, columnDurations);
            return columnPositions.map(([left, right], index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fFQYa")).CalendarCellWrapper), {
                    key: index,
                    left: left,
                    right: right,
                    column: index
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("E9dZI")).default), {
                    monthNumber: columnMonthNumbers[index],
                    yearCaption: yearCaptions[index],
                    isHighlighted: getIsHighlighted(index)
                })));
        }, [
            columnDurations,
            today,
            getIsHighlighted
        ]);
        const renderQuarterCells = (0, $5uXOq.useCallback)((columnPositions)=>{
            const columnQuarterNumbers = (0, (0, parcelRequire("lztNT")).getColumnQuarterNumbers)(columnDurations);
            const yearCaptions = (0, (0, parcelRequire("lztNT")).getColumnYearCaptions)(today, columnDurations);
            return columnPositions.map(([left, right], index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fFQYa")).CalendarCellWrapper), {
                    key: index,
                    left: left,
                    right: right,
                    column: index
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gORsc")).default), {
                    quarterNumber: columnQuarterNumbers[index],
                    yearCaption: yearCaptions[index],
                    isHighlighted: getIsHighlighted(index)
                })));
        }, [
            columnDurations,
            today,
            getIsHighlighted
        ]);
        const renderColumnsForMode = (0, $5uXOq.useCallback)(()=>{
            const columnPositions = (0, (0, parcelRequire("iwcO1")).getColumnPositions)(timelineDuration, columnDurations);
            if (timelineMode === (0, (0, parcelRequire("iZN6h")).WEEKS)) return renderWeekCells(columnPositions);
            if (timelineMode === (0, (0, parcelRequire("iZN6h")).MONTHS)) return renderMonthCells(columnPositions);
            return renderQuarterCells(columnPositions);
        }, [
            timelineMode,
            columnDurations,
            timelineDuration,
            renderWeekCells,
            renderMonthCells,
            renderQuarterCells
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm _1bsb1osq _4t3i1osq"
            ])
        }, renderColumnsForMode());
    };
    const $36f809feb4beb8ef$var$ChartCalendarCellsOld = ({ isHighlightToday: isHighlightToday, today: today, timelineMode: timelineMode, timelineDuration: timelineDuration, columnDurations: columnDurations })=>{
        const renderWeekCells = (0, $5uXOq.useCallback)((columnPositions)=>{
            const todayCoordinates = isHighlightToday ? (0, (0, parcelRequire("lztNT")).getTodayCoordinates)(today, columnDurations) : undefined;
            const columnWeekNumbers = (0, (0, parcelRequire("lztNT")).getColumnWeekNumbers)(columnDurations);
            const yearCaptions = (0, (0, parcelRequire("lztNT")).getColumnYearCaptions)(today, columnDurations);
            return columnPositions.map(([left, right], index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fFQYa")).CalendarCellWrapper), {
                    key: index,
                    left: left,
                    right: right,
                    column: index
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ayXBh")).default), {
                    columnIndex: index,
                    isHighlightToday: isHighlightToday,
                    todayCoordinates: todayCoordinates,
                    weekNumbers: columnWeekNumbers[index],
                    yearCaption: yearCaptions[index]
                })));
        }, [
            isHighlightToday,
            today,
            columnDurations
        ]);
        const renderMonthCells = (0, $5uXOq.useCallback)((columnPositions)=>{
            const columnMonthNumbers = (0, (0, parcelRequire("lztNT")).getColumnMonthNumbers)(columnDurations);
            const yearCaptions = (0, (0, parcelRequire("lztNT")).getColumnYearCaptions)(today, columnDurations);
            return columnPositions.map(([left, right], index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fFQYa")).CalendarCellWrapper), {
                    key: index,
                    left: left,
                    right: right,
                    column: index
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("E9dZI")).default), {
                    monthNumber: columnMonthNumbers[index],
                    yearCaption: yearCaptions[index]
                })));
        }, [
            today,
            columnDurations
        ]);
        const renderQuarterCells = (0, $5uXOq.useCallback)((columnPositions)=>{
            const columnQuarterNumbers = (0, (0, parcelRequire("lztNT")).getColumnQuarterNumbers)(columnDurations);
            const yearCaptions = (0, (0, parcelRequire("lztNT")).getColumnYearCaptions)(today, columnDurations);
            return columnPositions.map(([left, right], index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fFQYa")).CalendarCellWrapper), {
                    key: index,
                    left: left,
                    right: right,
                    column: index
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gORsc")).default), {
                    quarterNumber: columnQuarterNumbers[index],
                    yearCaption: yearCaptions[index]
                })));
        }, [
            today,
            columnDurations
        ]);
        const renderColumnsForMode = (0, $5uXOq.useCallback)(()=>{
            const columnPositions = (0, (0, parcelRequire("iwcO1")).getColumnPositions)(timelineDuration, columnDurations);
            if (timelineMode === (0, (0, parcelRequire("iZN6h")).WEEKS)) return renderWeekCells(columnPositions);
            if (timelineMode === (0, (0, parcelRequire("iZN6h")).MONTHS)) return renderMonthCells(columnPositions);
            return renderQuarterCells(columnPositions);
        }, [
            timelineMode,
            columnDurations,
            timelineDuration,
            renderWeekCells,
            renderMonthCells,
            renderQuarterCells
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm _1bsb1osq _4t3i1osq"
            ])
        }, renderColumnsForMode());
    };
    $36f809feb4beb8ef$var$ChartCalendarCellsNew.whyDidYouRender = true;
    $36f809feb4beb8ef$var$ChartCalendarCellsOld.whyDidYouRender = true;
    const $36f809feb4beb8ef$var$ChartCalendarCells = (0, (0, parcelRequire("cSD7y")).componentWithFG)('jsw_roadmaps_timeline-gridcell-header-contrast', $36f809feb4beb8ef$var$ChartCalendarCellsNew, $36f809feb4beb8ef$var$ChartCalendarCellsOld);
    $36f809feb4beb8ef$var$ChartCalendarCells.displayName = 'ChartCalendarCells';
    var $36f809feb4beb8ef$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($36f809feb4beb8ef$var$ChartCalendarCells);
});
parcelRegister("lztNT", function(module, exports) {
    $parcel$export(module.exports, "getColumnMonthNumbers", ()=>$23b15552ebbcdf45$export$2db9691736ad99a0);
    $parcel$export(module.exports, "getColumnQuarterNumbers", ()=>$23b15552ebbcdf45$export$f8f2585f7189f116);
    $parcel$export(module.exports, "getColumnYearCaptions", ()=>$23b15552ebbcdf45$export$318e116da7ff1363);
    $parcel$export(module.exports, "getColumnWeekNumbers", ()=>$23b15552ebbcdf45$export$a1fb8a69eea17cba);
    $parcel$export(module.exports, "getTodayCoordinates", ()=>$23b15552ebbcdf45$export$1c186d1bc45d38b7);
    var $8QpSo;
    var $2gnC5 = parcelRequire("2gnC5");
    var $iwcO1;
    const $23b15552ebbcdf45$export$2db9691736ad99a0 = (0, (0, parcelRequire("8QpSo")).default)((columnDurations)=>columnDurations.map((columnDuration)=>(0, ($parcel$interopDefault($2gnC5))).utc(columnDuration.startMilliseconds).month()));
    const $23b15552ebbcdf45$export$f8f2585f7189f116 = (0, (0, parcelRequire("8QpSo")).default)((columnDurations)=>columnDurations.map((columnDuration)=>(0, ($parcel$interopDefault($2gnC5))).utc(columnDuration.startMilliseconds).quarter() - 1));
    const $23b15552ebbcdf45$export$318e116da7ff1363 = (0, (0, parcelRequire("8QpSo")).default)((today, columnDurations)=>{
        const startOfCurrentYear = (0, ($parcel$interopDefault($2gnC5))).utc(today).startOf('year').valueOf();
        const endOfCurrentYear = (0, ($parcel$interopDefault($2gnC5))).utc(today).endOf('year').valueOf();
        let cachedYear;
        let nextYear;
        return columnDurations.map(({ startMilliseconds: startMilliseconds })=>{
            if (startMilliseconds < startOfCurrentYear || startMilliseconds > endOfCurrentYear) {
                if (!cachedYear || startMilliseconds >= nextYear) {
                    const columnMoment = (0, ($parcel$interopDefault($2gnC5))).utc(startMilliseconds);
                    cachedYear = `'${columnMoment.year().toString().slice(2)}`;
                    nextYear = columnMoment.add(1, 'year').startOf('year').valueOf();
                }
                return cachedYear;
            }
            return undefined;
        });
    });
    const $23b15552ebbcdf45$export$a1fb8a69eea17cba = (0, (0, parcelRequire("8QpSo")).default)((columnDurations)=>{
        const daysArray = [
            ...new Array(7)
        ];
        return columnDurations.map(({ startMilliseconds: startMilliseconds })=>{
            const columnMoment = (0, ($parcel$interopDefault($2gnC5))).utc(startMilliseconds);
            const weekNumbers = daysArray.map(()=>{
                const data = {
                    day: columnMoment.date(),
                    month: columnMoment.month()
                };
                columnMoment.add(1, 'day');
                return data;
            });
            return weekNumbers;
        });
    });
    const $23b15552ebbcdf45$export$1c186d1bc45d38b7 = (0, (0, parcelRequire("8QpSo")).default)((today, columnDurations)=>{
        let todayDayIndex = 0;
        const todayNumber = (0, ($parcel$interopDefault($2gnC5))).utc(today).date();
        const todayColumnIndex = (0, (0, parcelRequire("iwcO1")).getTodayColumnIndex)(today, columnDurations);
        const weekNumbers = $23b15552ebbcdf45$export$a1fb8a69eea17cba(columnDurations);
        const weekOfToday = weekNumbers[todayColumnIndex];
        weekOfToday.forEach((weekNumber, index)=>{
            if (weekNumber.day === todayNumber) todayDayIndex = index;
        });
        return [
            todayColumnIndex,
            todayDayIndex
        ];
    });
});
parcelRegister("fFQYa", function(module, exports) {
    $parcel$export(module.exports, "CalendarCellWrapper", ()=>$6a1307db1731318b$export$68256deaaec8dcee);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $iZN6h;
    var $5BWo9;
    const $6a1307db1731318b$var$wrapperStyles = null;
    const $6a1307db1731318b$export$68256deaaec8dcee = ({ left: left, right: right, column: column, children: children })=>{
        const cellRef = (0, (0, parcelRequire("5BWo9")).useGridCell)((0, (0, parcelRequire("iZN6h")).DEFAULT_HEADER_ROW_ID), (0, (0, parcelRequire("iZN6h")).CHART_COLUMN_COORDINATE) + column);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            ref: cellRef,
            role: "columnheader",
            tabIndex: -1,
            style: {
                left: `${left}%`,
                right: `${right}%`
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _154ize3t _94n5ze3t _16jlidpf _1o9zidpf _i0dl1wug _1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o _vchhusvi _nt751r31 _49pcglyw _1hvw1o36 _1ejj168b"
            ])
        }, children);
    };
});
parcelRegister("E9dZI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e20f87b556e66ee7$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $4R6GH;
    var $dCm1o;
    var $kGL3e;
    const $e20f87b556e66ee7$var$headerStyles = null;
    const $e20f87b556e66ee7$var$headerTextTransformStyles = null;
    const $e20f87b556e66ee7$var$contrastStyles = null;
    const $e20f87b556e66ee7$var$MonthCell = ({ monthNumber: monthNumber, yearCaption: yearCaption, isHighlighted: isHighlighted })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement("small", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_11c8qk37 _k48p1wq8 _syaz1rc1 _19pkidpf",
                !(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && "_1p1dangw",
                isHighlighted && (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-gridcell-header-contrast') && "_syaz1x9z"
            ])
        }, formatMessage((0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? (0, (0, parcelRequire("kGL3e")).inMonthOrder)[monthNumber] : (0, (0, parcelRequire("kGL3e")).inMonthOrderOld)[monthNumber]), ' ', yearCaption);
    };
    $e20f87b556e66ee7$var$MonthCell.defaultProps = {
        yearCaption: null
    };
    var $e20f87b556e66ee7$export$2e2bcd8739ae039 = $e20f87b556e66ee7$var$MonthCell;
});
parcelRegister("kGL3e", function(module, exports) {
    $parcel$export(module.exports, "inMonthOrder", ()=>$ad857913bcc6dfb7$export$12c2656d1700ed6e);
    $parcel$export(module.exports, "inMonthOrderOld", ()=>$ad857913bcc6dfb7$export$21620c71d33a251c);
    $parcel$export(module.exports, "inQuarterOrder", ()=>$ad857913bcc6dfb7$export$62f5e462247f69c8);
    $parcel$export(module.exports, "inQuarterOrderOld", ()=>$ad857913bcc6dfb7$export$51eb1b094826ff0c);
    var $7VHMR;
    const $ad857913bcc6dfb7$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        january: {
            id: 'roadmap.timeline-table.main.header.chart.calendar-cells.january',
            defaultMessage: 'January',
            description: 'Column heading text. Column is a visual guide for a users relative position on a timeline. Proper noun. Header for the month of January'
        },
        february: {
            id: 'roadmap.timeline-table.main.header.chart.calendar-cells.february',
            defaultMessage: 'February',
            description: 'Column heading text. Column is a visual guide for a users relative position on a timeline. Proper noun. Header for the month of February'
        },
        march: {
            id: 'roadmap.timeline-table.main.header.chart.calendar-cells.march',
            defaultMessage: 'March',
            description: 'Column heading text. Column is a visual guide for a users relative position on a timeline. Proper noun. Header for the month of March'
        },
        april: {
            id: 'roadmap.timeline-table.main.header.chart.calendar-cells.april',
            defaultMessage: 'April',
            description: 'Column heading text. Column is a visual guide for a users relative position on a timeline. Proper noun. Header for the month of April'
        },
        may: {
            id: 'roadmap.timeline-table.main.header.chart.calendar-cells.may',
            defaultMessage: 'May',
            description: 'Column heading text. Column is a visual guide for a users relative position on a timeline. Proper noun. Header for the month of May'
        },
        june: {
            id: 'roadmap.timeline-table.main.header.chart.calendar-cells.june',
            defaultMessage: 'June',
            description: 'Column heading text. Column is a visual guide for a users relative position on a timeline. Proper noun. Header for the month of June'
        },
        july: {
            id: 'roadmap.timeline-table.main.header.chart.calendar-cells.july',
            defaultMessage: 'July',
            description: 'Column heading text. Column is a visual guide for a users relative position on a timeline. Proper noun. Header for the month of July'
        },
        august: {
            id: 'roadmap.timeline-table.main.header.chart.calendar-cells.august',
            defaultMessage: 'August',
            description: 'Column heading text. Column is a visual guide for a users relative position on a timeline. Proper noun. Header for the month of August'
        },
        september: {
            id: 'roadmap.timeline-table.main.header.chart.calendar-cells.september',
            defaultMessage: 'September',
            description: 'Column heading text. Column is a visual guide for a users relative position on a timeline. Proper noun. Header for the month of September'
        },
        october: {
            id: 'roadmap.timeline-table.main.header.chart.calendar-cells.october',
            defaultMessage: 'October',
            description: 'Column heading text. Column is a visual guide for a users relative position on a timeline. Proper noun. Header for the month of October'
        },
        november: {
            id: 'roadmap.timeline-table.main.header.chart.calendar-cells.november',
            defaultMessage: 'November',
            description: 'Column heading text. Column is a visual guide for a users relative position on a timeline. Proper noun. Header for the month of November'
        },
        december: {
            id: 'roadmap.timeline-table.main.header.chart.calendar-cells.december',
            defaultMessage: 'December',
            description: 'Column heading text. Column is a visual guide for a users relative position on a timeline. Proper noun. Header for the month of December'
        },
        januaryOld: {
            id: 'roadmap.timeline-table.main.header.chart.calendar-cells.january-old',
            defaultMessage: 'Jan',
            description: 'Column heading text. Column is a visual guide for a users relative position on a timeline. Proper noun. Abbreviation for the month of January'
        },
        februaryOld: {
            id: 'roadmap.timeline-table.main.header.chart.calendar-cells.february-old',
            defaultMessage: 'Feb',
            description: 'Column heading text. Column is a visual guide for a users relative position on a timeline. Proper noun. Abbreviation for the month of February'
        },
        marchOld: {
            id: 'roadmap.timeline-table.main.header.chart.calendar-cells.march-old',
            defaultMessage: 'Mar',
            description: 'Column heading text. Column is a visual guide for a users relative position on a timeline. Proper noun. Abbreviation for the month of March'
        },
        aprilOld: {
            id: 'roadmap.timeline-table.main.header.chart.calendar-cells.april-old',
            defaultMessage: 'Apr',
            description: 'Column heading text. Column is a visual guide for a users relative position on a timeline. Proper noun. Abbreviation for the month of April'
        },
        mayOld: {
            id: 'roadmap.timeline-table.main.header.chart.calendar-cells.may-old',
            defaultMessage: 'May',
            description: 'Column heading text. Column is a visual guide for a users relative position on a timeline. Proper noun. Abbreviation for the month of May'
        },
        juneOld: {
            id: 'roadmap.timeline-table.main.header.chart.calendar-cells.june-old',
            defaultMessage: 'Jun',
            description: 'Column heading text. Column is a visual guide for a users relative position on a timeline. Proper noun. Abbreviation for the month of June'
        },
        julyOld: {
            id: 'roadmap.timeline-table.main.header.chart.calendar-cells.july-old',
            defaultMessage: 'Jul',
            description: 'Column heading text. Column is a visual guide for a users relative position on a timeline. Proper noun. Abbreviation for the month of July'
        },
        augustOld: {
            id: 'roadmap.timeline-table.main.header.chart.calendar-cells.august-old',
            defaultMessage: 'Aug',
            description: 'Column heading text. Column is a visual guide for a users relative position on a timeline. Proper noun. Abbreviation for the month of August'
        },
        septemberOld: {
            id: 'roadmap.timeline-table.main.header.chart.calendar-cells.september-old',
            defaultMessage: 'Sep',
            description: 'Column heading text. Column is a visual guide for a users relative position on a timeline. Proper noun. Abbreviation for the month of September'
        },
        octoberOld: {
            id: 'roadmap.timeline-table.main.header.chart.calendar-cells.october-old',
            defaultMessage: 'Oct',
            description: 'Column heading text. Column is a visual guide for a users relative position on a timeline. Proper noun. Abbreviation for the month of October'
        },
        novemberOld: {
            id: 'roadmap.timeline-table.main.header.chart.calendar-cells.november-old',
            defaultMessage: 'Nov',
            description: 'Column heading text. Column is a visual guide for a users relative position on a timeline. Proper noun. Abbreviation for the month of November'
        },
        decemberOld: {
            id: 'roadmap.timeline-table.main.header.chart.calendar-cells.december-old',
            defaultMessage: 'Dec',
            description: 'Column heading text. Column is a visual guide for a users relative position on a timeline. Proper noun. Abbreviation for the month of December'
        },
        monday: {
            id: 'roadmap.timeline-table.main.header.chart.calendar-cells.monday',
            defaultMessage: 'M',
            description: 'Column sub-heading text. High fidelity visual guide for a users relative position timeline. Proper noun. Abbreviation for the day of Monday'
        },
        tuesday: {
            id: 'roadmap.timeline-table.main.header.chart.calendar-cells.tuesday',
            defaultMessage: 'T',
            description: 'Column sub-heading text. High fidelity visual guide for a users relative position timeline. Proper noun. Abbreviation for the day of Tuesday'
        },
        wednesday: {
            id: 'roadmap.timeline-table.main.header.chart.calendar-cells.wednesday',
            defaultMessage: 'W',
            description: 'Column sub-heading text. High fidelity visual guide for a users relative position timeline. Proper noun. Abbreviation for the day of Wednesday'
        },
        thursday: {
            id: 'roadmap.timeline-table.main.header.chart.calendar-cells.thursday',
            defaultMessage: 'T',
            description: 'Column sub-heading text. High fidelity visual guide for a users relative position timeline. Proper noun. Abbreviation for the day of Thursday'
        },
        friday: {
            id: 'roadmap.timeline-table.main.header.chart.calendar-cells.friday',
            defaultMessage: 'F',
            description: 'Column sub-heading text. High fidelity visual guide for a users relative position timeline. Proper noun. Abbreviation for the day of Friday'
        },
        saturday: {
            id: 'roadmap.timeline-table.main.header.chart.calendar-cells.saturday',
            defaultMessage: 'S',
            description: 'Column sub-heading text. High fidelity visual guide for a users relative position timeline. Proper noun. Abbreviation for the day of Saturday'
        },
        sunday: {
            id: 'roadmap.timeline-table.main.header.chart.calendar-cells.sunday',
            defaultMessage: 'S',
            description: 'Column sub-heading text. High fidelity visual guide for a users relative position timeline. Proper noun. Abbreviation for the day of Sunday'
        }
    });
    const $ad857913bcc6dfb7$export$b7dd7c64470aa506 = [
        $ad857913bcc6dfb7$var$messages.monday,
        $ad857913bcc6dfb7$var$messages.tuesday,
        $ad857913bcc6dfb7$var$messages.wednesday,
        $ad857913bcc6dfb7$var$messages.thursday,
        $ad857913bcc6dfb7$var$messages.friday,
        $ad857913bcc6dfb7$var$messages.saturday,
        $ad857913bcc6dfb7$var$messages.sunday
    ];
    const $ad857913bcc6dfb7$export$12c2656d1700ed6e = [
        $ad857913bcc6dfb7$var$messages.january,
        $ad857913bcc6dfb7$var$messages.february,
        $ad857913bcc6dfb7$var$messages.march,
        $ad857913bcc6dfb7$var$messages.april,
        $ad857913bcc6dfb7$var$messages.may,
        $ad857913bcc6dfb7$var$messages.june,
        $ad857913bcc6dfb7$var$messages.july,
        $ad857913bcc6dfb7$var$messages.august,
        $ad857913bcc6dfb7$var$messages.september,
        $ad857913bcc6dfb7$var$messages.october,
        $ad857913bcc6dfb7$var$messages.november,
        $ad857913bcc6dfb7$var$messages.december
    ];
    const $ad857913bcc6dfb7$export$21620c71d33a251c = [
        $ad857913bcc6dfb7$var$messages.januaryOld,
        $ad857913bcc6dfb7$var$messages.februaryOld,
        $ad857913bcc6dfb7$var$messages.marchOld,
        $ad857913bcc6dfb7$var$messages.aprilOld,
        $ad857913bcc6dfb7$var$messages.mayOld,
        $ad857913bcc6dfb7$var$messages.juneOld,
        $ad857913bcc6dfb7$var$messages.julyOld,
        $ad857913bcc6dfb7$var$messages.augustOld,
        $ad857913bcc6dfb7$var$messages.septemberOld,
        $ad857913bcc6dfb7$var$messages.octoberOld,
        $ad857913bcc6dfb7$var$messages.novemberOld,
        $ad857913bcc6dfb7$var$messages.decemberOld
    ];
    const $ad857913bcc6dfb7$export$62f5e462247f69c8 = [
        {
            startMonth: $ad857913bcc6dfb7$var$messages.january,
            endMonth: $ad857913bcc6dfb7$var$messages.march
        },
        {
            startMonth: $ad857913bcc6dfb7$var$messages.april,
            endMonth: $ad857913bcc6dfb7$var$messages.june
        },
        {
            startMonth: $ad857913bcc6dfb7$var$messages.july,
            endMonth: $ad857913bcc6dfb7$var$messages.september
        },
        {
            startMonth: $ad857913bcc6dfb7$var$messages.october,
            endMonth: $ad857913bcc6dfb7$var$messages.december
        }
    ];
    const $ad857913bcc6dfb7$export$51eb1b094826ff0c = [
        {
            startMonth: $ad857913bcc6dfb7$var$messages.januaryOld,
            endMonth: $ad857913bcc6dfb7$var$messages.marchOld
        },
        {
            startMonth: $ad857913bcc6dfb7$var$messages.aprilOld,
            endMonth: $ad857913bcc6dfb7$var$messages.juneOld
        },
        {
            startMonth: $ad857913bcc6dfb7$var$messages.julyOld,
            endMonth: $ad857913bcc6dfb7$var$messages.septemberOld
        },
        {
            startMonth: $ad857913bcc6dfb7$var$messages.octoberOld,
            endMonth: $ad857913bcc6dfb7$var$messages.decemberOld
        }
    ];
    var $ad857913bcc6dfb7$export$2e2bcd8739ae039 = $ad857913bcc6dfb7$var$messages;
});
parcelRegister("gORsc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$25c5a578600dd859$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $4R6GH;
    var $dCm1o;
    var $kGL3e;
    const $25c5a578600dd859$var$headerStyles = null;
    const $25c5a578600dd859$var$headerTextTransformStyles = null;
    const $25c5a578600dd859$var$contrastStyles = null;
    const $25c5a578600dd859$var$QuarterCell = ({ quarterNumber: quarterNumber, yearCaption: yearCaption, isHighlighted: isHighlighted })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { startMonth: startMonth, endMonth: endMonth } = (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? (0, (0, parcelRequire("kGL3e")).inQuarterOrder)[quarterNumber] : (0, (0, parcelRequire("kGL3e")).inQuarterOrderOld)[quarterNumber];
        return (0, ($parcel$interopDefault($5uXOq))).createElement("small", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_11c8qk37 _syaz1rc1 _19pkidpf",
                !(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && "_1p1dangw",
                isHighlighted && (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-gridcell-header-contrast') && "_syaz1x9z"
            ])
        }, `${formatMessage(startMonth)} \u{2013} ${formatMessage(endMonth)}`, " ", yearCaption);
    };
    $25c5a578600dd859$var$QuarterCell.defaultProps = {
        yearCaption: null
    };
    var $25c5a578600dd859$export$2e2bcd8739ae039 = $25c5a578600dd859$var$QuarterCell;
});
parcelRegister("ayXBh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9dee9da93d060bfb$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $6Ll2T;
    var $99gde;
    var $4R6GH;
    var $dCm1o;
    var $kGL3e;
    const $9dee9da93d060bfb$var$dayWidth = 1 / 7 * 100;
    const $9dee9da93d060bfb$var$headerStyles = null;
    const $9dee9da93d060bfb$var$headerTextTransformStyles = null;
    const $9dee9da93d060bfb$var$dayContainerStylesOld = null;
    const $9dee9da93d060bfb$var$dayChildTodayStylesOld = null;
    const $9dee9da93d060bfb$var$dayContainerStyles = null;
    const $9dee9da93d060bfb$var$dayChildWeekendStyles = null;
    const $9dee9da93d060bfb$var$dayChildTodayStyles = null;
    const $9dee9da93d060bfb$var$dayChildStyles = null;
    const $9dee9da93d060bfb$var$dayChildHighlightedStyles = null;
    const $9dee9da93d060bfb$var$WeekCell = ({ columnIndex: columnIndex, weekNumbers: weekNumbers, todayCoordinates: todayCoordinates, yearCaption: yearCaption, isHighlightToday: isHighlightToday, isHighlighted: isHighlighted })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const monthNumber = weekNumbers[3].month;
        const todayIndex = weekNumbers.findIndex((element, i)=>isHighlightToday && todayCoordinates && todayCoordinates[0] === columnIndex && todayCoordinates[1] === i);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("small", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pk1b66 _11c81vlj _syaz1rc1",
                !(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && "_1p1dangw"
            ])
        }, (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-gridcell-header-contrast') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            as: "span",
            xcss: [
                isHighlighted && (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-gridcell-header-contrast') && $9dee9da93d060bfb$var$contrastStyles
            ]
        }, formatMessage((0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? (0, (0, parcelRequire("kGL3e")).inMonthOrder)[monthNumber] : (0, (0, parcelRequire("kGL3e")).inMonthOrderOld)[monthNumber]), ' ', yearCaption) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, formatMessage((0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? (0, (0, parcelRequire("kGL3e")).inMonthOrder)[monthNumber] : (0, (0, parcelRequire("kGL3e")).inMonthOrderOld)[monthNumber]), ' ', yearCaption)), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                !(0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-gridcell-header-contrast') && "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dl1wug _4cvr1h6o _1bsb1osq _4t3i1y7b _e2oo14zn _1sc11vlj _13t319ii _15ai1h6o _c8i51hna _k907c5fp _kgm11nxw _1tjq1rc1 _1e85hkel _1pzyhkel _1fl41sit _u2op1sit",
                (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-gridcell-header-contrast') && "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dl1wug _4cvr1h6o _1bsb1osq _4t3i1y7b"
            ])
        }, weekNumbers.map(({ day: day }, dayIndex)=>(0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-gridcell-header-contrast') ? (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                key: `week-number-${dayIndex}`,
                className: (0, (0, parcelRequire("bwpsq")).default)([
                    "_1bsb14zn _11c81vlj _y3gn1h6o _1i4q1hna _18s8c5fp _1yt41nxw _syaz1rc1",
                    (dayIndex === 5 || dayIndex === 6) && "_bfhkhkel _2rko1sit",
                    isHighlighted && "_syaz16ez",
                    todayIndex === dayIndex && "_2rko1sit _bfhk1hdx _syaz1pqp"
                ])
            }, day) : (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
                key: `week-number-${dayIndex}`,
                className: (0, (0, parcelRequire("bwpsq")).default)([
                    todayIndex === dayIndex && "_2rko1sit _bfhk1hdx _syazkmhu"
                ])
            }, day))));
    };
    const $9dee9da93d060bfb$var$contrastStyles = (0, (0, parcelRequire("99gde")).xcss)({
        color: 'color.text.accent.gray.bolder'
    });
    $9dee9da93d060bfb$var$WeekCell.defaultProps = {
        yearCaption: null
    };
    var $9dee9da93d060bfb$export$2e2bcd8739ae039 = $9dee9da93d060bfb$var$WeekCell;
});
parcelRegister("bwj2C", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$db4ac71a2cd48743$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $iZN6h;
    var $9puhl;
    var $5BWo9;
    const $db4ac71a2cd48743$var$rowHeaderCellStyles = null;
    const $db4ac71a2cd48743$var$dateRowHeaderContainerStyles = null;
    const $db4ac71a2cd48743$var$subRowHeaderContainerStyles = null;
    const $db4ac71a2cd48743$var$ListHeaderCell = ({ id: id, itemHeight: itemHeight, renderListHeaderItem: renderListHeaderItem })=>{
        const [listWidth] = (0, (0, parcelRequire("9puhl")).useListWidth)();
        const isDefaultHeader = id === (0, (0, parcelRequire("iZN6h")).DEFAULT_HEADER_ROW_ID);
        const cellRef = (0, (0, parcelRequire("5BWo9")).useGridCell)(id, (0, (0, parcelRequire("iZN6h")).LIST_COLUMN_COORDINATE), isDefaultHeader);
        const tabIndex = isDefaultHeader ? 0 : -1;
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            ref: cellRef,
            role: "rowheader",
            tabIndex: tabIndex,
            style: {
                width: `${listWidth}px`,
                height: `${itemHeight}px`
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqsw1if8 _16jlidpf _1o9zidpf _i0dl1wug _1ltvidpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _bfhkvuon _2rkoo8o8 _1pby1ial _nt751r31 _49pcglyw _1hvw1o36 _1ejj168b"
            ])
        }, id === (0, (0, parcelRequire("iZN6h")).DEFAULT_HEADER_ROW_ID) ? (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _vchhusvi _1bsb1osq _4t3i1osq _bfhk1s4m _2rkoo8o8 _x3doh6cr _n7zlh6cr"
            ])
        }, renderListHeaderItem({
            id: id
        })) : (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _1e0c1txw _16jlidpf _1o9zidpf _i0dl1wug _4cvr1h6o _vchhusvi _1bsb1osq _4t3i1osq _1yt4pn94 _n7zlh6cr"
            ])
        }, renderListHeaderItem({
            id: id
        })));
    };
    var $db4ac71a2cd48743$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($db4ac71a2cd48743$var$ListHeaderCell);
});
parcelRegister("2MYv1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1e827aea62556d07$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $k8IPx = parcelRequire("k8IPx");
    var $8GOx7 = parcelRequire("8GOx7");
    var $ajpes = parcelRequire("ajpes");
    var $hGh1Z;
    var $3ruU1;
    const $1e827aea62556d07$export$130b459525f81fe1 = ()=>{
        const [selectedItemIds] = (0, (0, parcelRequire("hGh1Z")).useSelectedItemIds)();
        const [activeItemId] = (0, (0, parcelRequire("hGh1Z")).useActiveItemId)();
        const { onRowSelect: onRowSelect, onRowDeselect: onRowDeselect } = (0, (0, parcelRequire("3ruU1")).useSideEffectMarshal)();
        const highlighted = (0, $5uXOq.useMemo)(()=>(0, ($parcel$interopDefault($8GOx7)))(selectedItemIds.concat(activeItemId ? [
                activeItemId
            ] : [])), [
            selectedItemIds,
            activeItemId
        ]);
        const prevHighlighted = (0, $5uXOq.useRef)(highlighted);
        (0, $5uXOq.useEffect)(()=>{
            const toBeDehighlighted = (0, ($parcel$interopDefault($k8IPx)))(prevHighlighted.current, highlighted);
            onRowDeselect(toBeDehighlighted);
            onRowSelect(highlighted);
        }, [
            selectedItemIds,
            onRowSelect,
            onRowDeselect,
            highlighted
        ]);
        (0, $5uXOq.useEffect)(()=>{
            prevHighlighted.current = highlighted;
        }, [
            highlighted
        ]);
        return null;
    };
    var $1e827aea62556d07$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($1e827aea62556d07$export$130b459525f81fe1, (0, ($parcel$interopDefault($ajpes))));
});
parcelRegister("8GOx7", function(module, exports) {
    var $lVx1a = parcelRequire("lVx1a");
    var $653971d100474755$var$func = $lVx1a('uniq', (parcelRequire("kGsr8")), (parcelRequire("bUoRH")));
    $653971d100474755$var$func.placeholder = (parcelRequire("aPsMW"));
    module.exports = $653971d100474755$var$func;
});
parcelRegister("bUoRH", function(module, exports) {
    module.exports = {
        'cap': false,
        'curry': false,
        'fixed': false,
        'immutable': false,
        'rearg': false
    };
});
parcelRegister("aaAik", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$75e273f76ce6f6de$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $k8IPx = parcelRequire("k8IPx");
    var $ajpes = parcelRequire("ajpes");
    var $3ruU1;
    const $75e273f76ce6f6de$var$ItemsSelector = ({ selectedItemIds: selectedItemIds })=>{
        const { onRowSelect: onRowSelect, onRowDeselect: onRowDeselect } = (0, (0, parcelRequire("3ruU1")).useSideEffectMarshal)();
        const previousSelectedItemIds = (0, $5uXOq.useRef)(selectedItemIds);
        (0, $5uXOq.useEffect)(()=>{
            const unselectedItemIds = (0, ($parcel$interopDefault($k8IPx)))(previousSelectedItemIds.current, selectedItemIds);
            onRowDeselect(unselectedItemIds);
            onRowSelect(selectedItemIds);
        }, [
            previousSelectedItemIds,
            selectedItemIds,
            onRowSelect,
            onRowDeselect
        ]);
        (0, $5uXOq.useEffect)(()=>{
            previousSelectedItemIds.current = selectedItemIds;
        }, [
            selectedItemIds
        ]);
        return null;
    };
    var $75e273f76ce6f6de$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($75e273f76ce6f6de$var$ItemsSelector, (0, ($parcel$interopDefault($ajpes))));
});
parcelRegister("cdyDR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$359ceda11fd51304$export$2e2bcd8739ae039);
    var $bwpsq;
    var $lD23V;
    var $5uXOq = parcelRequire("5uXOq");
    var $9puhl;
    var $jfF8l;
    const $359ceda11fd51304$var$containerStyles = null;
    const $359ceda11fd51304$var$listContainerStyles = null;
    const $359ceda11fd51304$var$Borders = ()=>{
        const [listWidth] = (0, (0, parcelRequire("9puhl")).useListWidth)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _154iidpf _94n5idpf _1ltvidpf _1bsb1osq _1pby1ial _lcxvglyw"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqsw1if8 _vchhusvi _1ltvidpf _4t3i1osq _2rkoo8o8 _1s7z9fei _1kl71hum"
            ]),
            style: {
                width: `${listWidth}px`,
                "--_drom5x": (0, (0, parcelRequire("lD23V")).default)((0, (0, parcelRequire("jfF8l")).secondaryBorderColor)),
                "--_1p5ufam": (0, (0, parcelRequire("lD23V")).default)((0, (0, parcelRequire("jfF8l")).secondaryBorder))
            }
        }));
    };
    var $359ceda11fd51304$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($359ceda11fd51304$var$Borders);
});
parcelRegister("lTlao", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3e9230eea482b27b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9puhl;
    var $cC9dj;
    var $73Gyu;
    const $3e9230eea482b27b$var$StaticOverlay = ({ renderChartOverlay: renderChartOverlay })=>{
        const [listWidth] = (0, (0, parcelRequire("9puhl")).useListWidth)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("73Gyu")).default), null), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cC9dj")).default), {
            listWidth: listWidth,
            renderChartOverlay: renderChartOverlay
        }));
    };
    $3e9230eea482b27b$var$StaticOverlay.displayName = 'StaticOverlay';
    $3e9230eea482b27b$var$StaticOverlay.whyDidYouRender = true;
    var $3e9230eea482b27b$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($3e9230eea482b27b$var$StaticOverlay);
});
parcelRegister("cC9dj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$822144dc27a4c851$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $cmHWc;
    const $822144dc27a4c851$var$containerStyles = null;
    const $822144dc27a4c851$var$ChartOverlay = ({ listWidth: listWidth, renderChartOverlay: renderChartOverlay })=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            style: {
                left: `${listWidth}px`
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _154iidpf _1xi2idpf _94n5idpf _1pby1o8a _lcxvglyw"
            ])
        }, renderChartOverlay(), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cmHWc")).default), null));
    var $822144dc27a4c851$export$2e2bcd8739ae039 = $822144dc27a4c851$var$ChartOverlay;
});
parcelRegister("cmHWc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$25e54f730e3352bc$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $c7Iuw;
    const $25e54f730e3352bc$var$containerStyles = null;
    const $25e54f730e3352bc$var$PortalContainer = ()=>{
        const { setPortalContainerElement: setPortalContainerElement } = (0, (0, parcelRequire("c7Iuw")).usePortalScope)();
        const containerRef = (0, $5uXOq.useRef)(null);
        (0, $5uXOq.useEffect)(()=>{
            setPortalContainerElement(containerRef.current);
            return ()=>{
                setPortalContainerElement(null);
            };
        }, [
            setPortalContainerElement
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            ref: containerRef,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _lcxvglyw _1ltvidpf _154iidpf _94n5idpf _1xi2idpf _1pbyilow _ogto1994 _mkrz1fck"
            ])
        });
    };
    var $25e54f730e3352bc$export$2e2bcd8739ae039 = $25e54f730e3352bc$var$PortalContainer;
});
parcelRegister("73Gyu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cee2fb79426596ee$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $WPwAA;
    var $3Kr5N;
    var $eF50C;
    var $ehSu7;
    var $1QY8L;
    const $cee2fb79426596ee$var$InlineIndicators = ()=>{
        const [{ isCreateSiblingEnabled: isCreateSiblingEnabled, isDragEnabled: isDragEnabled }] = (0, (0, parcelRequire("WPwAA")).useEnablements)();
        const [isScrollingY] = (0, (0, parcelRequire("3Kr5N")).useIsScrollingY)();
        const inlineIndicatorParams = (0, (0, parcelRequire("1QY8L")).useInlineIndicator)();
        if (isScrollingY) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, isCreateSiblingEnabled && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eF50C")).default), inlineIndicatorParams), isDragEnabled && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ehSu7")).default), inlineIndicatorParams));
    };
    var $cee2fb79426596ee$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($cee2fb79426596ee$var$InlineIndicators);
});
parcelRegister("eF50C", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bc9d92dc26c0df72$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $k7hw1;
    var $ghKWA;
    var $4X5Iv;
    const $bc9d92dc26c0df72$var$appear = null;
    const $bc9d92dc26c0df72$var$opacityTransitionStyles = null;
    const $bc9d92dc26c0df72$var$iconWrapperStyles = null;
    const $bc9d92dc26c0df72$var$iconContainerStyles = null;
    const $bc9d92dc26c0df72$var$lineStyles = null;
    const $bc9d92dc26c0df72$var$containerStyles = null;
    const $bc9d92dc26c0df72$var$outerButtonStyles = null;
    const $bc9d92dc26c0df72$var$InlineCreateIndicator = ({ left: left, width: width })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0cglyw _kqswstnw _154iidpf _1bsb1osq _1pbyibnn",
                "_j7hq1wwu _tzy4idpf _5sagfnf5 _ju25188d _1o51q7pw",
                (0, (0, parcelRequire("ghKWA")).getInlineCreateButtonClassName)().className
            ]),
            style: {
                left: `${left}px`
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm _154i1lpd _1ltvidpf _4t3igktf _1bsb1r7l _80omtlke _7momkb7n _b59ukb7n"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-component-selector": "line",
            style: {
                width: `${width}px`
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm _154irdoj _4t3iyh40 _bfhki2p0"
            ])
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _4t3igktf _1bsbgktf _154iidpf _1ltv14id _bfhk1ffm _syaz15cr _2rko1sit",
                (0, (0, parcelRequire("ghKWA")).getInlineCreateIconClassName)().className
            ]),
            "data-component-selector": "icon-wrapper"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1tcg _1bsb1tcg _kqswh2mm _18u01i6y _19pk1i6y"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("k7hw1"))))), {
            label: formatMessage((0, (0, parcelRequire("4X5Iv")).default).label)
        })))));
    };
    var $bc9d92dc26c0df72$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($bc9d92dc26c0df72$var$InlineCreateIndicator);
});
parcelRegister("4X5Iv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5bc81b62b196143f$export$2e2bcd8739ae039);
    var $7VHMR;
    var $5bc81b62b196143f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        label: {
            id: 'roadmap.timeline-table.main.static-overlay.inline-indicators.create.label',
            defaultMessage: 'What needs to be done?',
            description: 'Icon label. Appears when the epics list is too long. Activates epic creation input at the bottom of the list'
        }
    });
});
parcelRegister("ehSu7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$395cffd1fd62174a$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $ghKWA;
    const $395cffd1fd62174a$var$containerStyles = null;
    const $395cffd1fd62174a$var$lineStyles = null;
    const $395cffd1fd62174a$var$InlineDragIndicator = ({ left: left, width: width })=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "roadmap.timeline-table.main.static-overlay.inline-indicators.drag.inline-drag-indicator",
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0cglyw _kqswstnw _154iidpf _1bsb1osq _1pbyibnn",
                (0, (0, parcelRequire("ghKWA")).getDragIndicatorClassName)().className
            ]),
            style: {
                left: `${left}px`
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            style: {
                width: `${width}px`
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3iyh40 _bfhk1r2e _1kt9b3bt _1cs8stnw _kfgtidpf _1mp4idpf _1aukj39m _qnec1lpd _1pq812me _4k1c12me _1n1j18is"
            ])
        }));
    var $395cffd1fd62174a$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($395cffd1fd62174a$var$InlineDragIndicator);
});
parcelRegister("1QY8L", function(module, exports) {
    $parcel$export(module.exports, "useInlineIndicator", ()=>$e2e1d2521d9b4f80$export$27583fc2bcba0ca1);
    var $5uXOq = parcelRequire("5uXOq");
    var $iZN6h;
    var $lGdZu;
    var $cRUzn;
    const $e2e1d2521d9b4f80$export$27583fc2bcba0ca1 = ()=>{
        const [{ left: left, clientWidth: clientWidth, indicatorLineOffset: indicatorLineOffset }] = (0, (0, parcelRequire("lGdZu")).useTimelineViewport)();
        const [params, setParams] = (0, $5uXOq.useState)({
            left: 0,
            width: 0
        });
        const viewportRef = (0, $5uXOq.useRef)(null);
        const setInlineIndicatorParams = (viewport)=>{
            if (viewport) setParams({
                left: viewport.getBoundingClientRect().left,
                width: viewport.clientWidth
            });
        };
        (0, $5uXOq.useEffect)(()=>{
            if (!clientWidth) {
                const viewport = document.getElementById((0, (0, parcelRequire("iZN6h")).TIMELINE_ID));
                viewportRef.current = viewport;
                setInlineIndicatorParams(viewport);
            }
        }, []);
        const onContentResize = (0, $5uXOq.useCallback)(()=>{
            setInlineIndicatorParams(viewportRef.current);
        }, []);
        (0, (0, parcelRequire("cRUzn")).useResizeObserver)(viewportRef.current, onContentResize);
        const inlineIndicatorParams = (0, $5uXOq.useMemo)(()=>({
                left: viewportRef.current ? params.left : left,
                width: viewportRef.current ? params.width - indicatorLineOffset : clientWidth - indicatorLineOffset
            }), [
            params.left,
            params.width,
            left,
            indicatorLineOffset,
            clientWidth
        ]);
        return inlineIndicatorParams;
    };
});
parcelRegister("gc064", function(module, exports) {
    $parcel$export(module.exports, "getRenderersWithDefaults", ()=>$1d12dd1471f35dce$export$59f24ad0cf4048d7);
    var $8QpSo;
    var $jZppz;
    const $1d12dd1471f35dce$export$59f24ad0cf4048d7 = (0, (0, parcelRequire("8QpSo")).default)((customRenderers)=>{
        const safeRenderers = {
            ...(0, (0, parcelRequire("jZppz")).defaultRenderers),
            ...customRenderers
        };
        return {
            listRenderers: {
                renderListEmptyContent: safeRenderers.renderListEmptyContent,
                renderListItemContent: safeRenderers.renderListItemContent,
                renderListItemSecondaryContent: safeRenderers.renderListItemSecondaryContent,
                renderListItemCreate: safeRenderers.renderListItemCreate,
                renderListHeaderItem: safeRenderers.renderListHeaderItem,
                renderListItemMenuOption: customRenderers?.renderListItemMenuOption,
                renderListItemModal: customRenderers?.renderListItemModal
            },
            chartRenderers: {
                renderChartOverlay: safeRenderers.renderChartOverlay,
                renderChartItemContent: safeRenderers.renderChartItemContent,
                renderChartTimelineOverlay: safeRenderers.renderChartTimelineOverlay,
                renderChartHeaderItem: safeRenderers.renderChartHeaderItem
            },
            renderProvider: safeRenderers.renderProvider
        };
    });
});
parcelRegister("jZppz", function(module, exports) {
    $parcel$export(module.exports, "defaultRenderers", ()=>$57507187b2991c68$export$2d95bc3f1f7b3d23);
    const $57507187b2991c68$var$DEFAULT_RENDERER = ()=>null;
    const $57507187b2991c68$export$2d95bc3f1f7b3d23 = {
        renderListItemMenuOption: $57507187b2991c68$var$DEFAULT_RENDERER,
        renderListItemModal: $57507187b2991c68$var$DEFAULT_RENDERER,
        renderListHeaderItem: $57507187b2991c68$var$DEFAULT_RENDERER,
        renderListEmptyContent: $57507187b2991c68$var$DEFAULT_RENDERER,
        renderListItemContent: $57507187b2991c68$var$DEFAULT_RENDERER,
        renderListItemSecondaryContent: $57507187b2991c68$var$DEFAULT_RENDERER,
        renderListItemCreate: $57507187b2991c68$var$DEFAULT_RENDERER,
        renderChartHeaderItem: $57507187b2991c68$var$DEFAULT_RENDERER,
        renderChartOverlay: $57507187b2991c68$var$DEFAULT_RENDERER,
        renderChartItemContent: $57507187b2991c68$var$DEFAULT_RENDERER,
        renderChartTimelineOverlay: $57507187b2991c68$var$DEFAULT_RENDERER,
        renderProvider: ({ children: children })=>children
    };
});
parcelRegister("fWZbP", function(module, exports) {
    $parcel$export(module.exports, "LoadingBar", ()=>$93af88f04b046011$export$6665614bc5d690f6);
    $parcel$export(module.exports, "LoadingItem", ()=>$93af88f04b046011$export$a16bfd7fb92e211d);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    const $93af88f04b046011$export$6665614bc5d690f6 = ({ itemHeight: itemHeight, leftPosition: leftPosition, rightPosition: rightPosition })=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            style: {
                height: `${itemHeight - 16}px`,
                left: `${leftPosition}px`,
                right: `${rightPosition}px`
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _1e0c1txw _4cvr1h6o _1bahesu3 _2rko1sit _1reo15vq _18m915vq",
                "_aetrf705 _1kt9f705 _z0ai1osq _1mp41osq _1qdg1osq _kfgt1osq _1ywu1ule _cfu11ule _1rus1yrq _3p6mguu2 _clh3jq3t _46ts1wl4 _18postnw _15l21ob8"
            ])
        });
    const $93af88f04b046011$var$shimmer = null;
    const $93af88f04b046011$var$loadingBarBaseStyles = null;
    const $93af88f04b046011$var$loadingAnimationStyles = null;
    const $93af88f04b046011$var$loadingAnimation = {
        '::before, ::after': {
            content: ' ',
            width: '100%',
            height: '100%',
            display: 'block'
        },
        '::before': {
            backgroundColor: `var(--ds-background-neutral, ${(0, $72ba03e317f3d228$exports).N30})`
        },
        '::after': {
            backgroundImage: `
        linear-gradient(
            90deg,
            ${`var(--ds-surface, ${(0, $72ba03e317f3d228$exports).N0})`} 0,
            ${"var(--ds-skeleton-subtle, rgba(255, 255, 255, 0.2))"} 20%,
            ${"var(--ds-skeleton-subtle, rgba(255, 255, 255, 0.5))"} 60%,
            ${`var(--ds-surface, ${(0, $72ba03e317f3d228$exports).N0})`}
        )
        `,
            transform: 'translateX(-100%)',
            animation: `${$93af88f04b046011$var$shimmer} 2s infinite`,
            position: 'absolute',
            top: 0
        }
    };
    const $93af88f04b046011$export$a16bfd7fb92e211d = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { backgroundColor: backgroundColor, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_1hphqkz": (0, (0, parcelRequire("lD23V")).default)(__cmplp.backgroundColor)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i11dc _1bsb1osq _bfhk3qkl _kqswh2mm _1reo15vq _18m915vq _2rko1sit _aetrf705 _1kt9f705 _z0ai1osq _1mp41osq _1qdg1osq _kfgt1osq _1ywu1ule _cfu11ule _1rus1yrq _3p6mw01n _clh3jq3t _46ts1wl4 _18postnw _15l2idpf",
                __cmplp.className
            ])
        });
    });
    $93af88f04b046011$export$a16bfd7fb92e211d.displayName = 'LoadingItem';
});
parcelRegister("dadh5", function(module, exports) {
    $parcel$export(module.exports, "DndLongTaskMetric", ()=>$b9be92f72441621f$export$5e5ce79ba08a39a0);
    var $5uXOq = parcelRequire("5uXOq");
    var $55AbO;
    var $iZN6h;
    const $b9be92f72441621f$var$camelCaseToKebabCase = (str)=>str.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase();
    const $b9be92f72441621f$export$cc578d681954a356 = {
        [(0, $8038b72ffd5aa8d4$export$2475592765cae5b0)]: (0, (0, parcelRequire("55AbO")).metrics).interaction({
            key: `jwm.timeline.${$b9be92f72441621f$var$camelCaseToKebabCase((0, $8038b72ffd5aa8d4$export$2475592765cae5b0))}`
        }),
        [(0, (0, parcelRequire("iZN6h")).LIST_RESIZE_DRAG_AND_DROP)]: (0, (0, parcelRequire("55AbO")).metrics).interaction({
            key: `jwm.timeline.${$b9be92f72441621f$var$camelCaseToKebabCase((0, (0, parcelRequire("iZN6h")).LIST_RESIZE_DRAG_AND_DROP))}`
        }),
        [(0, (0, parcelRequire("iZN6h")).LIST_DRAG_AND_DROP)]: (0, (0, parcelRequire("55AbO")).metrics).interaction({
            key: `jwm.timeline.${$b9be92f72441621f$var$camelCaseToKebabCase((0, (0, parcelRequire("iZN6h")).LIST_DRAG_AND_DROP))}`
        }),
        [(0, (0, parcelRequire("iZN6h")).CHILD_LIST_DRAG_AND_DROP)]: (0, (0, parcelRequire("55AbO")).metrics).interaction({
            key: `jwm.timeline.${$b9be92f72441621f$var$camelCaseToKebabCase((0, (0, parcelRequire("iZN6h")).CHILD_LIST_DRAG_AND_DROP))}`
        }),
        [(0, $8038b72ffd5aa8d4$export$3ac90e7f239a7193)]: (0, (0, parcelRequire("55AbO")).metrics).interaction({
            key: `jwm.timeline.${$b9be92f72441621f$var$camelCaseToKebabCase((0, $8038b72ffd5aa8d4$export$3ac90e7f239a7193))}`
        })
    };
    const $b9be92f72441621f$export$5e5ce79ba08a39a0 = ({ isDragging: isDragging, metricType: metricType })=>{
        (0, $5uXOq.useEffect)(()=>{
            if (!$b9be92f72441621f$export$cc578d681954a356[metricType]) return;
            if (isDragging) $b9be92f72441621f$export$cc578d681954a356[metricType].start();
            else $b9be92f72441621f$export$cc578d681954a356[metricType].stop({
                stopTime: performance.now()
            });
        }, [
            isDragging,
            metricType
        ]);
        return null;
    };
});
const $8038b72ffd5aa8d4$export$3ac90e7f239a7193 = 'dependencyDnd';
const $8038b72ffd5aa8d4$export$eedef6333f320132 = 'issueViewResizeDnd';
const $8038b72ffd5aa8d4$export$2475592765cae5b0 = 'chartBarResize';
const $8038b72ffd5aa8d4$export$2afae5ee414caffb = 'persistItem';
const $8038b72ffd5aa8d4$export$26d8759f6f1c8e13 = 'exportImageGenerated';
const $8038b72ffd5aa8d4$export$e04dc5133fcac555 = 'issueUpdated';
const $8038b72ffd5aa8d4$export$5913ec3a0f9505fe = 'dependencyAdded';
const $8038b72ffd5aa8d4$export$488a6fa9078615df = 'dependencyRemoved';
const $8038b72ffd5aa8d4$export$315e0cbd8c7bfbd4 = 'bulkIssuesScheduled';
const $8038b72ffd5aa8d4$export$f096bf13c1d89b91 = 'resolveHealthcheck';
const $8038b72ffd5aa8d4$export$12daf7ce2c179397 = 'criticalData';
const $8038b72ffd5aa8d4$export$ede40e627a0cbf14 = 'versionDetails';
const $8038b72ffd5aa8d4$export$1df1eb270f208354 = 'sprintDetails';
const $8038b72ffd5aa8d4$export$bd4cd00ee0750c9a = 'filterConfiguration';
const $8038b72ffd5aa8d4$export$9e57feecc7b4c365 = 'deriveFields';
const $8038b72ffd5aa8d4$export$d21f08c0570f92f7 = 'filterRoadmapItems';
const $8038b72ffd5aa8d4$export$72305db43681d1de = 'getIssueIds';
const $8038b72ffd5aa8d4$export$51617034fb6f2e3a = 'getItemsByIds';
const $8038b72ffd5aa8d4$export$d959a123e6ceb778 = 'getSubtasks';
const $8038b72ffd5aa8d4$export$2e07b3a26c033d37 = 'healthcheckIssueTypes';
const $8038b72ffd5aa8d4$export$a0d61e9ea4ad5a05 = 'jqlFiltersReapply';
const $8038b72ffd5aa8d4$export$57a4171901f1c15b = 'getGoals';
parcelRegister("1bZXb", function(module, exports) {
    $parcel$export(module.exports, "InteractionMetrics", ()=>$028b40d2795accfe$export$341b330828bd3906);
    var $qFFvI;
    const $028b40d2795accfe$export$341b330828bd3906 = ()=>{
        const interactionMetrics = (0, (0, parcelRequire("qFFvI")).useInteractionMetrics)();
        if (interactionMetrics[0, (0, parcelRequire("qFFvI")).ADD_ITEM_CLICKED].state === 'started') interactionMetrics[0, (0, parcelRequire("qFFvI")).ADD_ITEM_CLICKED].stop({
            stopTime: Math.floor(performance.now())
        });
        if (interactionMetrics[0, (0, parcelRequire("qFFvI")).TIMELINE_MODE_CHANGED].state === 'started') interactionMetrics[0, (0, parcelRequire("qFFvI")).TIMELINE_MODE_CHANGED].stop({
            stopTime: Math.floor(performance.now())
        });
        if (interactionMetrics[0, (0, parcelRequire("qFFvI")).EXPAND_CHANGED].state === 'started') interactionMetrics[0, (0, parcelRequire("qFFvI")).EXPAND_CHANGED].stop({
            stopTime: Math.floor(performance.now())
        });
        return null;
    };
});
parcelRegister("qFFvI", function(module, exports) {
    $parcel$export(module.exports, "EXPAND_CHANGED", ()=>$a59181380367d1eb$export$715f6df7460cc565);
    $parcel$export(module.exports, "ADD_ITEM_CLICKED", ()=>$a59181380367d1eb$export$d9bd7736120cba41);
    $parcel$export(module.exports, "TIMELINE_MODE_CHANGED", ()=>$a59181380367d1eb$export$993f98b1d13f512);
    $parcel$export(module.exports, "TODAY_BUTTON_CLICKED", ()=>$a59181380367d1eb$export$9d8c4a3386e395f0);
    $parcel$export(module.exports, "EXPORT_IMAGE_GENERATED", ()=>$a59181380367d1eb$export$26d8759f6f1c8e13);
    $parcel$export(module.exports, "useInteractionMetrics", ()=>$a59181380367d1eb$export$6f239bf5d81555c8);
    var $8Rkzz = parcelRequire("8Rkzz");
    var $55AbO;
    const $a59181380367d1eb$export$715f6df7460cc565 = 'expand-changed';
    const $a59181380367d1eb$export$d9bd7736120cba41 = 'add-item-clicked';
    const $a59181380367d1eb$export$993f98b1d13f512 = 'timeline-mode-changed';
    const $a59181380367d1eb$export$9d8c4a3386e395f0 = 'today-clicked';
    const $a59181380367d1eb$export$26d8759f6f1c8e13 = 'exportImageGenerated';
    const $a59181380367d1eb$var$interactionMetrics = {
        [$a59181380367d1eb$export$715f6df7460cc565]: (0, (0, parcelRequire("55AbO")).metrics).interaction({
            key: `jwm.timeline.${$a59181380367d1eb$export$715f6df7460cc565}`
        }),
        [$a59181380367d1eb$export$d9bd7736120cba41]: (0, (0, parcelRequire("55AbO")).metrics).interaction({
            key: `jwm.timeline.${$a59181380367d1eb$export$d9bd7736120cba41}`
        }),
        [$a59181380367d1eb$export$993f98b1d13f512]: (0, (0, parcelRequire("55AbO")).metrics).interaction({
            key: `jwm.timeline.${$a59181380367d1eb$export$993f98b1d13f512}`
        }),
        [$a59181380367d1eb$export$9d8c4a3386e395f0]: (0, (0, parcelRequire("55AbO")).metrics).interaction({
            key: `jwm.timeline.${$a59181380367d1eb$export$9d8c4a3386e395f0}`
        }),
        [$a59181380367d1eb$export$26d8759f6f1c8e13]: (0, (0, parcelRequire("55AbO")).metrics).interaction({
            key: `jwm.timeline.${$a59181380367d1eb$export$26d8759f6f1c8e13}`
        })
    };
    const $a59181380367d1eb$export$6f239bf5d81555c8 = ()=>$a59181380367d1eb$var$interactionMetrics;
    const $a59181380367d1eb$var$interactionMock = {
        start: (0, ($parcel$interopDefault($8Rkzz))),
        stop: (0, ($parcel$interopDefault($8Rkzz)))
    };
    const $a59181380367d1eb$export$3b262e78c27d1154 = ()=>({
            [$a59181380367d1eb$export$715f6df7460cc565]: $a59181380367d1eb$var$interactionMock,
            [$a59181380367d1eb$export$d9bd7736120cba41]: $a59181380367d1eb$var$interactionMock,
            [$a59181380367d1eb$export$993f98b1d13f512]: $a59181380367d1eb$var$interactionMock,
            [$a59181380367d1eb$export$9d8c4a3386e395f0]: $a59181380367d1eb$var$interactionMock,
            [$a59181380367d1eb$export$26d8759f6f1c8e13]: $a59181380367d1eb$var$interactionMock
        });
});
parcelRegister("1o48H", function(module, exports) {
    $parcel$export(module.exports, "getTimelineTableItemsHeight", ()=>$1dbdf9c0748723b0$export$ff45b5996f11b55d);
    var $8QpSo;
    var $iZN6h;
    const $1dbdf9c0748723b0$export$ff45b5996f11b55d = (0, (0, parcelRequire("8QpSo")).default)((siblingItems, expandedItems, rootItemHeight = (0, (0, parcelRequire("iZN6h")).DEFAULT_ITEM_HEIGHT), isRoot = true)=>(siblingItems || []).reduce((sum, { childItems: childItems, id: id })=>(isRoot ? rootItemHeight : (0, (0, parcelRequire("iZN6h")).BASE_LEVEL_ITEM_HEIGHT)()) + sum + (expandedItems[id] ? $1dbdf9c0748723b0$export$ff45b5996f11b55d(childItems, expandedItems, rootItemHeight, false) : 0), 0));
});
parcelRegister("hLy6t", function(module, exports) {
    $parcel$export(module.exports, "isItemSkeleton", ()=>$0d1102f5d8314627$export$121c11fd7ecbe3e1);
    $parcel$export(module.exports, "createItemSkeleton", ()=>$0d1102f5d8314627$export$ac4443ed642486ab);
    $parcel$export(module.exports, "LOADING_ITEMS", ()=>$0d1102f5d8314627$export$1398abf6030da1ab);
    var $g5X3G;
    var $gNAqw;
    const $0d1102f5d8314627$export$8764542593218704 = 'SKELETON-ITEM-';
    const $0d1102f5d8314627$export$121c11fd7ecbe3e1 = (issueId)=>String(issueId).startsWith($0d1102f5d8314627$export$8764542593218704);
    const $0d1102f5d8314627$export$ac4443ed642486ab = ({ id: id, level: level })=>({
            id: (0, (0, parcelRequire("g5X3G")).toIssueId)(`${$0d1102f5d8314627$export$8764542593218704}${id}`),
            level: level
        });
    const $0d1102f5d8314627$export$1398abf6030da1ab = Array.from({
        length: 20
    }, (_, i)=>({
            id: (0, (0, parcelRequire("g5X3G")).toIssueId)(`${$0d1102f5d8314627$export$8764542593218704}${i}`),
            level: (0, (0, parcelRequire("gNAqw")).TIMELINE_PARENT_LEVEL),
            isInTransition: false,
            childItems: undefined
        }));
});
parcelRegister("afmVm", function(module, exports) {
    $parcel$export(module.exports, "TimelineViewChildQueryController", ()=>$fa6302fd5bb7b37b$export$ccc3e15517bf984c);
    var $5uXOq = parcelRequire("5uXOq");
    var $daQYX;
    var $cm8b5;
    var $kRkJF;
    var $4R6GH;
    var $8zOmE;
    var $lwMsT;
    var $jrO9m;
    var $gNAqw;
    var $hfFPh;
    const $fa6302fd5bb7b37b$export$ccc3e15517bf984c = ({ parentHierarchyType: parentHierarchyType, parentIssueId: parentIssueId, onDataChange: onDataChange, parentHierarchyLevel: parentHierarchyLevel })=>{
        const startExperience = (0, (0, parcelRequire("cm8b5")).useExperienceStart)((0, (0, parcelRequire("gNAqw")).LOAD_CHILD_ISSUES_EXPERIENCE));
        const markExperienceSuccess = (0, (0, parcelRequire("cm8b5")).useExperienceSuccess)((0, (0, parcelRequire("gNAqw")).LOAD_CHILD_ISSUES_EXPERIENCE));
        const markExperienceFailed = (0, (0, parcelRequire("cm8b5")).useExperienceFail)((0, (0, parcelRequire("gNAqw")).LOAD_CHILD_ISSUES_EXPERIENCE));
        startExperience();
        const { quickFiltersJql: quickFiltersJql, jqlContext: jqlContext } = (0, (0, parcelRequire("kRkJF")).useFilteredViewContextInput)({
            view: 'timeline'
        });
        let projectKey;
        const { data: overview } = (0, (0, parcelRequire("jrO9m")).useOverview)();
        const isOverview = overview != null && Array.isArray(overview.projects);
        if (!isOverview && (0, (0, parcelRequire("4R6GH")).fg)('timeline-uses-new-jql-parent-project-directive')) {
            const { key: key } = (0, (0, parcelRequire("daQYX")).useProject)();
            projectKey = key;
        }
        const { data: data, rankIssue: rankIssue, updateInCache: updateInCache, updateItemsInCache: updateItemsInCache, loading: loading, error: error, loadNextPage: loadNextPage, isLoadingNextPage: isLoadingNextPage } = (0, (0, parcelRequire("hfFPh")).useTimelineViewIssues)({
            input: {
                jqlContext: jqlContext,
                fieldIds: (0, parcelRequire("gNAqw")).fieldIds,
                quickFiltersJql: quickFiltersJql,
                parentIssue: {
                    hierarchyType: parentHierarchyType,
                    hierarchyLevel: parentHierarchyLevel,
                    issueId: parentIssueId
                },
                ...projectKey ? {
                    projectIdOrKey: projectKey
                } : {}
            }
        });
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const totalIssues = data?.issues.length;
        (0, $5uXOq.useEffect)(()=>{
            if (loading) return;
            if (error || typeof totalIssues !== 'number') {
                markExperienceFailed('timeline children query controller', error || Error('data.issues.length is not a number'));
                return;
            }
            markExperienceSuccess();
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'timelineChildrenData fetched', {
                totalChildren: totalIssues,
                parentIssueId: parentIssueId,
                parentHierarchyLevel: parentHierarchyLevel
            });
        }, [
            loading,
            createAnalyticsEvent,
            totalIssues,
            parentIssueId,
            error,
            markExperienceSuccess,
            markExperienceFailed,
            parentHierarchyLevel
        ]);
        (0, $5uXOq.useEffect)(()=>{
            onDataChange(parentIssueId, {
                data: data,
                updateInCache: updateInCache,
                rankIssue: rankIssue,
                updateItemsInCache: updateItemsInCache,
                loading: loading,
                error: error,
                loadNextPage: loadNextPage,
                isLoadingNextPage: isLoadingNextPage
            });
        }, [
            data,
            error,
            isLoadingNextPage,
            loadNextPage,
            loading,
            onDataChange,
            parentIssueId,
            updateInCache,
            rankIssue,
            updateItemsInCache
        ]);
        return null;
    };
});
parcelRegister("hfFPh", function(module, exports) {
    $parcel$export(module.exports, "useTimelineViewIssues", ()=>$d00d864c3b686a0c$export$66a1bd5ceb40f186);
    var $5uXOq = parcelRequire("5uXOq");
    var $7qDUb = parcelRequire("7qDUb");
    var $5tTFS;
    var $8Wswo;
    var $cm8b5;
    var $kRkJF;
    var $hlKA4;
    var $cvbVg;
    var $9SwwX;
    var $gN11a;
    var $jcw0u;
    var $4R6GH;
    var $8zOmE;
    var $lwMsT;
    var $koeKL;
    var $gNAqw;
    var $9A32U;
    var $b180B;
    var $6qNs0;
    var $2qV0a;
    const $d00d864c3b686a0c$var$getIndexById = (list, issueId)=>{
        if (list == null || !Array.isArray(list?.edges)) return -1;
        return list.edges.findIndex(({ node: node })=>node?.issueId === Number(issueId));
    };
    const $d00d864c3b686a0c$var$emptyArray = [];
    const $d00d864c3b686a0c$export$66a1bd5ceb40f186 = ({ input: input, onComplete: onComplete })=>{
        const analyticsTaskName = 'useTimelineViewIssuesApolloCacheActions';
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const { isHidingDoneItems: isHidingDoneItems } = (0, (0, parcelRequire("kRkJF")).useFilteredViewContextInput)({
            view: 'timeline'
        });
        const queryVariables = (0, $5uXOq.useMemo)(()=>{
            return {
                ...(0, (0, parcelRequire("9A32U")).getVariables)({
                    ...input,
                    isHidingDoneItems: isHidingDoneItems
                }),
                cloudId: cloudId
            };
        }, [
            JSON.stringify(input)
        ]);
        const [hasLoadingStarted, setHasLoadingStarted] = (0, $5uXOq.useState)(false);
        const client = (0, (0, parcelRequire("5tTFS")).useApolloClient)();
        const { updateItemsInCache: updateItemsInCacheAction } = (0, (0, parcelRequire("hlKA4")).useCacheActions)();
        const startExperience = (0, (0, parcelRequire("cm8b5")).useExperienceStart)((0, (0, parcelRequire("gNAqw")).LOAD_MORE_EXPERIENCE));
        const markExperienceSuccess = (0, (0, parcelRequire("cm8b5")).useExperienceSuccess)((0, (0, parcelRequire("gNAqw")).LOAD_MORE_EXPERIENCE));
        const markExperienceFailed = (0, (0, parcelRequire("cm8b5")).useExperienceFail)((0, (0, parcelRequire("gNAqw")).LOAD_MORE_EXPERIENCE));
        const { rankIssue: rankIssue } = (0, (0, parcelRequire("b180B")).useRankTimelineIssue)({
            query: (0, (0, parcelRequire("6qNs0")).TIMELINE_VIEW_ITEMS_QUERY),
            queryVariables: queryVariables
        });
        const onCompleted = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("gN11a")).markViewMetric)('timeline', (0, $a286480ec63fa4c8$export$83ca21a50372ea3b));
            if (onComplete) onComplete();
        }, [
            onComplete
        ]);
        const onError = (0, $5uXOq.useCallback)((apolloError)=>{
            (0, (0, parcelRequire("gN11a")).markViewMetric)('timeline', (0, $a286480ec63fa4c8$export$83ca21a50372ea3b));
            if (!(0, (0, parcelRequire("8Wswo")).shouldHandleTheError)(apolloError)) return;
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'timelineViewItemsQuery',
                    packageName: 'jiraBusinessTimeline',
                    teamName: 'jira-yurree'
                },
                attributes: {
                    message: 'Failed to fetch issues in timeline view'
                },
                error: apolloError,
                sendToPrivacyUnsafeSplunk: true
            });
        }, []);
        const onNextPageLoaded = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'timelineMoreItems loaded');
            markExperienceSuccess();
        }, [
            createAnalyticsEvent,
            markExperienceSuccess
        ]);
        const onPaginationError = (0, $5uXOq.useCallback)((apolloError)=>{
            if (!(0, (0, parcelRequire("8Wswo")).shouldHandleTheError)(apolloError)) return;
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'timelineViewPaginationQuery',
                    packageName: 'jiraBusinessTimeline',
                    teamName: 'jira-yurree'
                },
                attributes: {
                    message: 'Failed to fetch more issues in timeline view'
                },
                error: apolloError,
                sendToPrivacyUnsafeSplunk: true
            });
            markExperienceFailed('get timeline view issues service', apolloError);
        }, [
            markExperienceFailed
        ]);
        const { data: data, loadFirstPage: loadFirstPage, loading: loading, error: error, loadNextPage: loadNextPage, isLoadingNextPage: isLoadingNextPage } = (0, (0, parcelRequire("cvbVg")).useJqlPagination)({
            variables: queryVariables,
            query: (0, (0, parcelRequire("6qNs0")).TIMELINE_VIEW_ITEMS_QUERY),
            errorPolicy: 'all',
            onCompleted: onCompleted,
            onError: onError,
            onPaginationError: onPaginationError,
            onNextPageLoaded: onNextPageLoaded
        });
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("gN11a")).markViewMetric)('timeline', (0, $a286480ec63fa4c8$export$23e322eb7c526958));
            loadFirstPage();
            setHasLoadingStarted(true);
        }, []);
        const updateInCache = (0, $5uXOq.useCallback)(({ id: id, fields: { startDate: startDate, dueDate: dueDate } })=>{
            const getCachedListData = ()=>{
                try {
                    const read = client.readQuery({
                        query: (0, (0, parcelRequire("6qNs0")).TIMELINE_VIEW_ITEMS_QUERY),
                        variables: queryVariables
                    });
                    (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheRead taskSuccess', {
                        task: analyticsTaskName
                    });
                    return read;
                } catch (e) {
                    (0, (0, parcelRequire("jcw0u")).default)({
                        error: e instanceof Error ? e : new Error('Unknown cache read error'),
                        meta: {
                            id: 'updateInCache',
                            packageName: 'jiraBusinessTimeline',
                            teamName: 'jira-yurree'
                        },
                        sendToPrivacyUnsafeSplunk: true,
                        skipSentry: true,
                        attributes: {
                            task: analyticsTaskName,
                            query: JSON.stringify((0, (0, parcelRequire("6qNs0")).TIMELINE_VIEW_ITEMS_QUERY)),
                            variables: JSON.stringify(queryVariables),
                            eventName: 'apolloCacheRead taskFail',
                            error: JSON.stringify(e)
                        }
                    });
                    return null;
                }
            };
            const listData = getCachedListData();
            const _list = (0, (0, parcelRequire("9SwwX")).getAGGCompliantData)(listData ?? undefined, 'list');
            const index = $d00d864c3b686a0c$var$getIndexById(_list ?? undefined, id);
            if (index === -1 || index == null) return;
            const edges = [
                ..._list?.edges || []
            ].map((edge)=>{
                if (edge?.node?.issueId === Number(id)) {
                    const { node: node } = edge;
                    return {
                        node: {
                            ...node,
                            fields: (node?.fields || []).map((field)=>{
                                const newField = {};
                                if (field != null && 'aliasFieldId' in field) {
                                    if (startDate != null && field?.aliasFieldId === 'startdate') newField.date = startDate;
                                }
                                if (field != null && 'fieldId' in field) {
                                    if (dueDate != null && field?.fieldId === 'duedate') newField.date = dueDate;
                                }
                                return {
                                    ...field,
                                    ...newField
                                };
                            })
                        }
                    };
                }
                return edge;
            });
            try {
                client.writeQuery({
                    query: (0, (0, parcelRequire("6qNs0")).TIMELINE_VIEW_ITEMS_QUERY),
                    variables: queryVariables,
                    data: {
                        ...listData,
                        jira: {
                            ...listData?.jira,
                            list: {
                                ...listData?.jira?.list || {},
                                edges: edges
                            }
                        }
                    }
                });
                (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheWrite taskSuccess', {
                    task: analyticsTaskName
                });
            } catch (e) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: e instanceof Error ? e : new Error('Unknown cache write error'),
                    meta: {
                        id: 'updateInCache',
                        packageName: 'jiraBusinessTimeline',
                        teamName: 'jira-yurree'
                    },
                    sendToPrivacyUnsafeSplunk: true,
                    skipSentry: true,
                    attributes: {
                        task: analyticsTaskName,
                        query: JSON.stringify((0, (0, parcelRequire("6qNs0")).TIMELINE_VIEW_ITEMS_QUERY)),
                        variables: JSON.stringify(queryVariables),
                        eventName: 'apolloCacheWrite taskFail',
                        error: JSON.stringify(e)
                    }
                });
            }
        }, [
            client,
            createAnalyticsEvent,
            queryVariables
        ]);
        const updateItemsInCache = (0, $5uXOq.useCallback)((updates)=>{
            updateItemsInCacheAction({
                query: (0, (0, parcelRequire("6qNs0")).TIMELINE_VIEW_ITEMS_QUERY),
                variables: queryVariables,
                issueIds: updates.map((i)=>i.id),
                updateItem: (existingIssue)=>{
                    const update = updates.find((i)=>Number(i.id) === existingIssue.issueId);
                    if (!update) return existingIssue;
                    const { fields: { startDate: startDate, dueDate: dueDate } } = update;
                    const fields = existingIssue.fields?.map((field)=>{
                        if (field != null && 'aliasFieldId' in field) {
                            if (startDate != null && field.aliasFieldId === 'startdate') {
                                if ((0, (0, parcelRequire("4R6GH")).fg)('jwm_timeline_meatballs_date_update')) {
                                    if (typeof startDate === 'string') return {
                                        ...field,
                                        date: startDate
                                    };
                                    return {
                                        ...field,
                                        date: startDate.date
                                    };
                                }
                                return {
                                    ...field,
                                    date: startDate
                                };
                            }
                        }
                        if (field != null && 'fieldId' in field) {
                            if (dueDate != null && field.fieldId === 'duedate') {
                                if ((0, (0, parcelRequire("4R6GH")).fg)('jwm_timeline_meatballs_date_update')) {
                                    if (typeof dueDate === 'string') return {
                                        ...field,
                                        date: dueDate
                                    };
                                    return {
                                        ...field,
                                        date: dueDate.date
                                    };
                                }
                                return {
                                    ...field,
                                    date: dueDate
                                };
                            }
                        }
                        return field;
                    }) ?? null;
                    return {
                        ...existingIssue,
                        fields: fields
                    };
                }
            });
        }, [
            queryVariables,
            updateItemsInCacheAction
        ]);
        const _data = (0, (0, parcelRequire("9SwwX")).getAGGCompliantData)(data, 'list');
        const edges = _data?.edges || $d00d864c3b686a0c$var$emptyArray;
        const result = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("2qV0a")).transformResult)((0, ($parcel$interopDefault($7qDUb)))(edges, (0, (0, parcelRequire("2qV0a")).rankSorter))), [
            edges
        ]);
        const loadNextPageWithExperienceMetrics = (0, $5uXOq.useCallback)(()=>{
            startExperience();
            loadNextPage();
        }, [
            loadNextPage,
            startExperience
        ]);
        return {
            data: result,
            updateInCache: updateInCache,
            updateItemsInCache: updateItemsInCache,
            loading: hasLoadingStarted ? loading : true,
            error: (0, (0, parcelRequire("8Wswo")).shouldHandleTheError)(error) ? error : undefined,
            loadNextPage: loadNextPageWithExperienceMetrics,
            isLoadingNextPage: isLoadingNextPage,
            rankIssue: rankIssue
        };
    };
});
parcelRegister("hlKA4", function(module, exports) {
    $parcel$export(module.exports, "useCacheActions", ()=>$f61770b894122deb$export$f79bd85e41a6298f);
    var $5uXOq = parcelRequire("5uXOq");
    var $9XE6b = parcelRequire("9XE6b");
    var $5tTFS;
    var $hE5wF;
    var $57lFd;
    var $jcw0u;
    var $3fAi8;
    var $8zOmE;
    var $lwMsT;
    var $g5X3G;
    var $ieDtd;
    var $deqCE;
    var $jDUax;
    var $9SwwX;
    const $f61770b894122deb$var$getIssueKey = (fields)=>(0, (0, parcelRequire("57lFd")).safeGetValue)(fields, 'issuekey', 'text', '');
    const $f61770b894122deb$var$getIndexById = (listData, issueId)=>{
        if (listData == null || listData.edges == null) return -1;
        const { edges: edges } = listData;
        return edges.findIndex((edge)=>edge != null && edge.node != null && edge.node.issueId != null && edge.node.issueId === issueId);
    };
    const $f61770b894122deb$export$f79bd85e41a6298f = ()=>{
        const analyticsTaskName = 'useCacheActionsApolloCacheActions';
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const client = (0, (0, parcelRequire("5tTFS")).useApolloClient)();
        const [, extractedFieldValueActions] = (0, (0, parcelRequire("3fAi8")).useFieldsValuesActions)();
        const [currentIssueKey] = (0, (0, parcelRequire("ieDtd")).useQueryParam)((0, (0, parcelRequire("hE5wF")).SELECTED_ISSUE_PARAM));
        const removeIssueFromExtractedFieldsCache = (0, $5uXOq.useCallback)(({ currentIssueId: currentIssueId, issueKey: issueKey, parentIssueId: parentIssueId })=>{
            issueKey != null && issueKey !== currentIssueKey && `${parentIssueId}` !== `${currentIssueId}` && extractedFieldValueActions.setIssue((0, (0, parcelRequire("g5X3G")).toIssueKey)(issueKey), {});
        }, [
            currentIssueKey,
            extractedFieldValueActions
        ]);
        const addToCache = (0, $5uXOq.useCallback)(({ query: query, variables: variables, newNodes: newNodes })=>{
            const getCachedListData = ()=>{
                try {
                    const read = client.readQuery({
                        query: query,
                        variables: variables
                    });
                    (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheRead taskSuccess', {
                        task: analyticsTaskName
                    });
                    return read;
                } catch (e) {
                    (0, (0, parcelRequire("jcw0u")).default)({
                        error: e instanceof Error ? e : new Error('Unknown cache read error'),
                        meta: {
                            id: 'addToCache',
                            packageName: 'jiraBusinessListHandlers',
                            teamName: 'keystone'
                        },
                        sendToPrivacyUnsafeSplunk: true,
                        skipSentry: true,
                        attributes: {
                            task: analyticsTaskName,
                            query: JSON.stringify(query),
                            variables: JSON.stringify(variables),
                            eventName: 'apolloCacheRead taskFail',
                            error: JSON.stringify(e)
                        }
                    });
                    return null;
                }
            };
            const data = getCachedListData();
            const listData = (0, (0, parcelRequire("9SwwX")).getAGGCompliantData)(data ?? undefined, 'list');
            if (listData == null || listData.edges == null || !Array.isArray(newNodes) || newNodes.length === 0) return;
            try {
                const newIssueIds = new Set(newNodes.map((item)=>{
                    if (item != null && item.issueId != null) return item.issueId;
                    return undefined;
                }).filter(Boolean));
                newNodes.forEach((item)=>{
                    if (item == null || item.fields == null) return;
                    const issueKey = $f61770b894122deb$var$getIssueKey(item.fields);
                    if (issueKey != null && issueKey !== '') {
                        const parentIssueId = (0, (0, parcelRequire("jDUax")).getParentIssueId)(item);
                        const currentIssueId = item.issueId;
                        removeIssueFromExtractedFieldsCache({
                            currentIssueId: currentIssueId,
                            issueKey: issueKey,
                            parentIssueId: parentIssueId
                        });
                    }
                });
                const isOptimisticIssueWithRealIssueInNewNodes = (issue)=>{
                    const issueSummary = issue.fields?.find((field)=>field.fieldId === 'summary');
                    const newNodeWithSameSummary = newNodes.find((newNode)=>newNode.fields?.find((field)=>field.fieldId === 'summary' && issueSummary != null && field.text === issueSummary.text));
                    return issue.id.toString().startsWith((0, (0, parcelRequire("deqCE")).OPTIMISTIC_ID_PREFIX)) && newNodeWithSameSummary != null;
                };
                const newIssues = listData.edges.filter((edge)=>edge != null && edge.node != null && edge.node.issueId != null && !newIssueIds.has(edge.node.issueId) && !isOptimisticIssueWithRealIssueInNewNodes(edge.node)).concat(newNodes.map((node)=>({
                        node: node,
                        __typename: 'JiraWorkManagementViewItemEdge'
                    }))) ?? [];
                client.writeQuery({
                    query: query,
                    variables: variables,
                    data: {
                        ...data,
                        jira: {
                            ...data?.jira ?? {},
                            list: {
                                ...listData,
                                edges: newIssues,
                                totalCount: newIssues.length
                            }
                        }
                    }
                });
                (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheWrite taskSuccess', {
                    task: analyticsTaskName
                });
                (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloAddToCache taskSuccess', {
                    task: analyticsTaskName
                });
            } catch (e) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: e instanceof Error ? e : new Error('Unknown cache write error'),
                    meta: {
                        id: 'addToCache',
                        packageName: 'jiraBusinessListHandlers',
                        teamName: 'keystone'
                    },
                    sendToPrivacyUnsafeSplunk: true,
                    skipSentry: true,
                    attributes: {
                        task: analyticsTaskName,
                        query: JSON.stringify(query),
                        variables: JSON.stringify(variables),
                        eventName: 'apolloCacheWrite taskFail',
                        error: JSON.stringify(e)
                    }
                });
            }
        }, [
            client,
            createAnalyticsEvent,
            removeIssueFromExtractedFieldsCache
        ]);
        const removeFromCache = (0, $5uXOq.useCallback)(({ query: query, variables: variables, issueId: issueId })=>{
            const issueIds = Array.isArray(issueId) ? issueId : [
                issueId
            ];
            const getCachedListData = ()=>{
                try {
                    const read = client.readQuery({
                        query: query,
                        variables: variables
                    });
                    (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheRead taskSuccess', {
                        task: analyticsTaskName
                    });
                    return read;
                } catch (e) {
                    (0, (0, parcelRequire("jcw0u")).default)({
                        error: e instanceof Error ? e : new Error('Unknown cache read error'),
                        meta: {
                            id: 'removeFromCache',
                            packageName: 'jiraBusinessListHandlers',
                            teamName: 'keystone'
                        },
                        sendToPrivacyUnsafeSplunk: true,
                        skipSentry: true,
                        attributes: {
                            task: analyticsTaskName,
                            query: JSON.stringify(query),
                            variables: JSON.stringify(variables),
                            eventName: 'apolloCacheRead taskFail',
                            error: JSON.stringify(e)
                        }
                    });
                    return null;
                }
            };
            const data = getCachedListData();
            const listData = (0, (0, parcelRequire("9SwwX")).getAGGCompliantData)(data ?? undefined, 'list');
            if (!listData?.edges || !Array.isArray(listData.edges)) return;
            try {
                const updatedEdges = listData.edges?.filter((edge)=>edge?.node && !issueIds.includes(edge.node.issueId));
                client.writeQuery({
                    query: query,
                    variables: variables,
                    data: {
                        ...data,
                        jira: {
                            ...data?.jira ?? {},
                            list: {
                                ...listData,
                                edges: updatedEdges,
                                totalCount: updatedEdges.length
                            }
                        }
                    }
                });
                (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheWrite taskSuccess', {
                    task: analyticsTaskName
                });
                issueIds.forEach((issue)=>{
                    const index = $f61770b894122deb$var$getIndexById(listData ?? undefined, issue);
                    const item = updatedEdges[index];
                    const issueKey = $f61770b894122deb$var$getIssueKey(item?.node?.fields ?? []);
                    const currentIssueId = (0, ($parcel$interopDefault($9XE6b)))(item, 'issueId', 0);
                    if (issueKey !== '') removeIssueFromExtractedFieldsCache({
                        currentIssueId: currentIssueId,
                        issueKey: issueKey
                    });
                });
                (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloRemoveFromCache taskSuccess', {
                    task: analyticsTaskName
                });
            } catch (e) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: e instanceof Error ? e : new Error('Unknown cache Write error'),
                    meta: {
                        id: 'removeFromCache',
                        packageName: 'jiraBusinessListHandlers',
                        teamName: 'keystone'
                    },
                    sendToPrivacyUnsafeSplunk: true,
                    skipSentry: true,
                    attributes: {
                        task: analyticsTaskName,
                        query: JSON.stringify(query),
                        variables: JSON.stringify(variables),
                        eventName: 'apolloCacheWrite taskFail',
                        error: JSON.stringify(e)
                    }
                });
            }
        }, [
            client,
            createAnalyticsEvent,
            removeIssueFromExtractedFieldsCache
        ]);
        const getCachedIssueById = (0, $5uXOq.useCallback)(({ query: query, variables: variables, issueId: issueId })=>{
            const getCachedListData = ()=>{
                try {
                    const read = client.readQuery({
                        query: query,
                        variables: variables
                    });
                    (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheRead taskSuccess', {
                        task: analyticsTaskName
                    });
                    return read;
                } catch (e) {
                    (0, (0, parcelRequire("jcw0u")).default)({
                        error: e instanceof Error ? e : new Error('Unknown cache read error'),
                        meta: {
                            id: 'getCachedIssueById',
                            packageName: 'jiraBusinessListHandlers',
                            teamName: 'keystone'
                        },
                        sendToPrivacyUnsafeSplunk: true,
                        skipSentry: true,
                        attributes: {
                            task: analyticsTaskName,
                            query: JSON.stringify(query),
                            variables: JSON.stringify(variables),
                            eventName: 'apolloCacheRead taskFail',
                            error: JSON.stringify(e)
                        }
                    });
                    return null;
                }
            };
            const data = getCachedListData();
            const listData = (0, (0, parcelRequire("9SwwX")).getAGGCompliantData)(data ?? undefined, 'list');
            (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloGetCachedIssueById taskSuccess', {
                task: analyticsTaskName
            });
            return listData?.edges?.find((issue)=>issue?.node?.issueId === Number(issueId))?.node ?? null;
        }, [
            client,
            createAnalyticsEvent
        ]);
        const updateItemsInCache = (0, $5uXOq.useCallback)(({ query: query, variables: variables, issueIds: issueIds, updateItem: updateItem })=>{
            const getCachedListData = ()=>{
                try {
                    const read = client.readQuery({
                        query: query,
                        variables: variables
                    });
                    (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheRead taskSuccess', {
                        task: analyticsTaskName
                    });
                    return read;
                } catch (e) {
                    (0, (0, parcelRequire("jcw0u")).default)({
                        error: e instanceof Error ? e : new Error('Unknown cache read error'),
                        meta: {
                            id: 'updateItemsInCache',
                            packageName: 'jiraBusinessListHandlers',
                            teamName: 'keystone'
                        },
                        sendToPrivacyUnsafeSplunk: true,
                        skipSentry: true,
                        attributes: {
                            task: analyticsTaskName,
                            query: JSON.stringify(query),
                            variables: JSON.stringify(variables),
                            eventName: 'apolloCacheRead taskFail',
                            error: JSON.stringify(e)
                        }
                    });
                    return null;
                }
            };
            const data = getCachedListData();
            const listData = (0, (0, parcelRequire("9SwwX")).getAGGCompliantData)(data ?? undefined, 'list');
            const existingEdges = listData?.edges;
            if (existingEdges == null) return;
            try {
                const newEdges = [
                    ...existingEdges
                ];
                let hasItemOverride = false;
                issueIds.forEach((issueId)=>{
                    const issueToUpdateIndex = existingEdges.findIndex((issue)=>issue?.node?.issueId === Number(issueId)) ?? undefined;
                    const existingIssue = existingEdges[issueToUpdateIndex];
                    if (existingIssue?.node == null || issueToUpdateIndex === undefined || issueToUpdateIndex === -1 || existingIssue == null) return;
                    const itemOverride = updateItem(existingIssue.node);
                    if (itemOverride === undefined) return;
                    hasItemOverride = true;
                    newEdges[issueToUpdateIndex] = {
                        node: itemOverride,
                        __typename: 'JiraWorkManagementViewItemEdge'
                    };
                });
                if (!hasItemOverride) return;
                client.writeQuery({
                    query: query,
                    variables: variables,
                    data: {
                        ...data,
                        jira: {
                            ...data?.jira ?? {},
                            list: {
                                ...listData,
                                edges: newEdges,
                                totalCount: newEdges.length
                            }
                        }
                    }
                });
                (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloCacheWrite taskSuccess', {
                    task: analyticsTaskName
                });
                (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'apolloUpdateItemsInCache taskSuccess', {
                    task: analyticsTaskName
                });
            } catch (e) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    error: e instanceof Error ? e : new Error('Unknown cache write error'),
                    meta: {
                        id: 'updateItemsInCache',
                        packageName: 'jiraBusinessListHandlers',
                        teamName: 'keystone'
                    },
                    sendToPrivacyUnsafeSplunk: true,
                    skipSentry: true,
                    attributes: {
                        task: analyticsTaskName,
                        query: JSON.stringify(query),
                        variables: JSON.stringify(variables),
                        eventName: 'apolloCacheWrite taskFail',
                        error: JSON.stringify(e)
                    }
                });
            }
        }, [
            client,
            createAnalyticsEvent
        ]);
        return {
            addToCache: addToCache,
            removeFromCache: removeFromCache,
            getCachedIssueById: getCachedIssueById,
            updateItemsInCache: updateItemsInCache
        };
    };
});
parcelRegister("3fAi8", function(module, exports) {
    $parcel$export(module.exports, "useFieldValue", ()=>$ddbc380ab4ee430c$export$b79fae7fbe3ac392);
    $parcel$export(module.exports, "useFieldsValues", ()=>$ddbc380ab4ee430c$export$25b73e671fe7a8fa);
    $parcel$export(module.exports, "useFieldValuesForIssues", ()=>$ddbc380ab4ee430c$export$ac289b84121829df);
    $parcel$export(module.exports, "useMultiFieldValuesForIssues", ()=>$ddbc380ab4ee430c$export$915cdeec521b54f7);
    $parcel$export(module.exports, "FieldValueSubscriber", ()=>$ddbc380ab4ee430c$export$4e5f1f4ed08d155e);
    $parcel$export(module.exports, "useFieldsValuesActions", ()=>$ddbc380ab4ee430c$export$612d9bcb0c9d8976);
    var $5uXOq = parcelRequire("5uXOq");
    var $1UikQ = parcelRequire("1UikQ");
    var $3sQ5x;
    var $iXqE5;
    var $51nlc;
    const $ddbc380ab4ee430c$var$setIssue = (issueKey, fields)=>({ setState: setState })=>{
            setState({
                [issueKey]: fields
            });
        };
    const $ddbc380ab4ee430c$var$setIssues = (issues)=>({ setState: setState })=>{
            const newIssues = {};
            issues.forEach((issue)=>{
                Object.assign(newIssues, issue);
            });
            setState(newIssues);
        };
    const $ddbc380ab4ee430c$var$setFieldValue = (issueKey, fieldKey, value)=>({ setState: setState, getState: getState })=>{
            setState({
                [issueKey]: {
                    ...getState()[issueKey],
                    [fieldKey]: value
                }
            });
        };
    const $ddbc380ab4ee430c$var$getFieldValue = (issueKey, fieldKey)=>({ getState: getState })=>{
            const issueFieldValues = getState()[issueKey];
            return issueFieldValues && issueFieldValues[fieldKey];
        };
    const $ddbc380ab4ee430c$var$mergeIssue = (issueKey, fields)=>({ setState: setState, getState: getState })=>{
            setState({
                [issueKey]: (0, ($parcel$interopDefault($1UikQ)))({}, getState()[issueKey], fields)
            });
        };
    const $ddbc380ab4ee430c$export$11aa02e14fdf7753 = (issues)=>({ setState: setState, getState: getState })=>{
            if (issues.length === 0) return;
            const newIssues = {};
            issues.forEach((issue)=>{
                Object.assign(newIssues, issue);
            });
            setState((0, ($parcel$interopDefault($1UikQ)))({}, getState(), newIssues));
        };
    const $ddbc380ab4ee430c$var$actions = {
        setFieldValue: $ddbc380ab4ee430c$var$setFieldValue,
        getFieldValue: $ddbc380ab4ee430c$var$getFieldValue,
        setIssue: $ddbc380ab4ee430c$var$setIssue,
        mergeIssue: $ddbc380ab4ee430c$var$mergeIssue,
        setIssues: $ddbc380ab4ee430c$var$setIssues,
        mergeIssues: $ddbc380ab4ee430c$export$11aa02e14fdf7753
    };
    const $ddbc380ab4ee430c$var$store = (0, (0, parcelRequire("iXqE5")).createStore)({
        name: 'issue-fields',
        initialState: {},
        actions: $ddbc380ab4ee430c$var$actions
    });
    const $ddbc380ab4ee430c$var$getFieldValueSelector = (state, { issueKey: issueKey, fieldKey: fieldKey })=>{
        const issueFieldValues = state[issueKey];
        return issueFieldValues && issueFieldValues[fieldKey];
    };
    const $ddbc380ab4ee430c$var$getFieldValuesForIssuesSelector = (state, { issueKeys: issueKeys, fieldKey: fieldKey })=>(issueKeys || []).map((issueKey)=>$ddbc380ab4ee430c$var$getFieldValueSelector(state, {
                fieldKey: fieldKey,
                issueKey: issueKey
            }));
    const $ddbc380ab4ee430c$var$getMultiFieldValuesForIssuesSelector = (state, { issueKeys: issueKeys, fieldKeys: fieldKeys })=>(issueKeys || []).reduce((accumulator, issueKey)=>{
            if (!state[issueKey]) return accumulator;
            const fieldValue = fieldKeys.reduce((acc, fieldKey)=>{
                acc[fieldKey] = $ddbc380ab4ee430c$var$getFieldValueSelector(state, {
                    fieldKey: fieldKey,
                    issueKey: issueKey
                });
                return acc;
            }, {});
            accumulator[issueKey] = fieldValue;
            return accumulator;
        }, {});
    const $ddbc380ab4ee430c$var$getAllFields = (state, issueKey)=>state[issueKey];
    const $ddbc380ab4ee430c$export$b79fae7fbe3ac392 = (0, (0, parcelRequire("3sQ5x")).createHook)($ddbc380ab4ee430c$var$store, {
        selector: $ddbc380ab4ee430c$var$getFieldValueSelector
    });
    const $ddbc380ab4ee430c$export$25b73e671fe7a8fa = (0, (0, parcelRequire("3sQ5x")).createHook)($ddbc380ab4ee430c$var$store, {
        selector: $ddbc380ab4ee430c$var$getAllFields
    });
    const $ddbc380ab4ee430c$export$ac289b84121829df = (0, (0, parcelRequire("3sQ5x")).createHook)($ddbc380ab4ee430c$var$store, {
        selector: $ddbc380ab4ee430c$var$getFieldValuesForIssuesSelector
    });
    const $ddbc380ab4ee430c$export$915cdeec521b54f7 = (0, (0, parcelRequire("3sQ5x")).createHook)($ddbc380ab4ee430c$var$store, {
        selector: $ddbc380ab4ee430c$var$getMultiFieldValuesForIssuesSelector
    });
    const $ddbc380ab4ee430c$export$4e5f1f4ed08d155e = (0, (0, parcelRequire("51nlc")).createSubscriber)($ddbc380ab4ee430c$var$store, {
        selector: $ddbc380ab4ee430c$var$getFieldValueSelector
    });
    const $ddbc380ab4ee430c$var$useFieldValueStoreActions = (0, (0, parcelRequire("3sQ5x")).createHook)($ddbc380ab4ee430c$var$store, {
        selector: null
    });
    const $ddbc380ab4ee430c$export$612d9bcb0c9d8976 = ()=>{
        const [, fieldValueStoreActions] = $ddbc380ab4ee430c$var$useFieldValueStoreActions();
        const fieldsValuesActions = (0, $5uXOq.useMemo)(()=>{
            const setIssueAction = (issueKey, fields)=>fieldValueStoreActions.setIssue(issueKey, fields);
            const setFieldValueAction = (issueKey, fieldKey, value)=>fieldValueStoreActions.setFieldValue(issueKey, fieldKey, value);
            const getFieldValueAction = (issueKey, fieldKey)=>fieldValueStoreActions.getFieldValue(issueKey, fieldKey);
            const mergeIssueAction = (issueKey, fields)=>fieldValueStoreActions.mergeIssue(issueKey, fields);
            const setIssuesAction = (issues)=>fieldValueStoreActions.setIssues(issues);
            const mergeIssuesAction = (issues)=>fieldValueStoreActions.mergeIssues(issues);
            return {
                setIssue: setIssueAction,
                setFieldValue: setFieldValueAction,
                getFieldValue: getFieldValueAction,
                mergeIssue: mergeIssueAction,
                setIssues: setIssuesAction,
                mergeIssues: mergeIssuesAction
            };
        }, [
            fieldValueStoreActions
        ]);
        return [
            null,
            fieldsValuesActions
        ];
    };
});
parcelRegister("jDUax", function(module, exports) {
    $parcel$export(module.exports, "getParentIssueId", ()=>$6e16617835cc2337$export$846a0afb93794223);
    $parcel$export(module.exports, "isGroupItem", ()=>$6e16617835cc2337$export$dcc23ed179776a3b);
    $parcel$export(module.exports, "getGroupItemId", ()=>$6e16617835cc2337$export$4f6368343f5d1a95);
    $parcel$export(module.exports, "isRootLevel", ()=>$6e16617835cc2337$export$7044e84e19490c29);
    var $57lFd;
    var $4R6GH;
    var $deqCE;
    const $6e16617835cc2337$export$3ba5d152e044664d = (parentIssue, subtaskFieldIssue)=>{
        const parentIssueFields = parentIssue.fields || [];
        const subtasksFieldIndex = parentIssueFields.findIndex((field)=>field?.fieldKey === 'subtasks');
        const subtasksField = typeof subtasksFieldIndex === 'number' && subtasksFieldIndex !== -1 ? parentIssueFields[subtasksFieldIndex] : undefined;
        if (subtasksFieldIndex === -1 || subtasksField == null) return parentIssue;
        const updatedFields = [
            ...parentIssueFields
        ];
        updatedFields[subtasksFieldIndex] = {
            ...updatedFields[subtasksFieldIndex],
            issues: [
                subtaskFieldIssue,
                ...subtasksField?.issues || []
            ].filter((issue, index, issueArray)=>issueArray.findIndex((current)=>current.issueId === issue.issueId) === index)
        };
        return {
            ...parentIssue,
            fields: updatedFields
        };
    };
    const $6e16617835cc2337$export$30019f8058090ccb = (isFiltering, id)=>{
        if (id === (0, (0, parcelRequire("deqCE")).OPTIMISTIC_ISSUE_ID)) return false;
        return !isFiltering;
    };
    const $6e16617835cc2337$export$d9893aac42f29b60 = (node)=>{
        const issueKey = (0, (0, parcelRequire("57lFd")).safeGetValue)(node.fields, 'issuekey', 'text', undefined);
        const parentIssue = (0, (0, parcelRequire("57lFd")).safeGetValue)(node.fields, 'parent', 'parentIssue', undefined);
        const projectKey1 = (issueKey ?? '').split('-')[0];
        const projectKey2 = (parentIssue?.key ?? '').split('-')[0];
        const sameProject = projectKey1 && projectKey2 ? projectKey1 === projectKey2 : false;
        return sameProject ? parentIssue?.issueId : undefined;
    };
    const $6e16617835cc2337$export$846a0afb93794223 = (node)=>{
        if ((0, (0, parcelRequire("4R6GH")).fg)('list_-_get_parent_id_should_support_group')) {
            const parentIssue = (0, (0, parcelRequire("57lFd")).safeGetValue)(node.fields, 'parent', 'parentIssue', undefined);
            if ($6e16617835cc2337$export$dcc23ed179776a3b(parentIssue?.issueId)) return parentIssue?.issueId;
        }
        return $6e16617835cc2337$export$d9893aac42f29b60(node);
    };
    const $6e16617835cc2337$export$dcc23ed179776a3b = (issueId = '')=>typeof issueId === 'string' && issueId.startsWith((0, (0, parcelRequire("deqCE")).GROUP_ITEM_PREFIX));
    const $6e16617835cc2337$export$4f6368343f5d1a95 = (issueId)=>{
        const [_, groupItemId] = issueId.split(`${(0, (0, parcelRequire("deqCE")).GROUP_ITEM_PREFIX)}_`);
        return groupItemId ?? issueId;
    };
    const $6e16617835cc2337$export$7044e84e19490c29 = (issueId)=>issueId === (0, (0, parcelRequire("deqCE")).ROOT_LEVEL);
});
parcelRegister("9SwwX", function(module, exports) {
    $parcel$export(module.exports, "useFetchMore", ()=>$0f8617a70c5d6b6c$export$d84f34af2f3f5d9f);
    $parcel$export(module.exports, "getAGGCompliantData", ()=>$0f8617a70c5d6b6c$export$5a178cf599565b50);
    var $5tTFS;
    var $e3a3O;
    var $8Qi2I;
    var $c9Ur7;
    var $fPruT;
    function $0f8617a70c5d6b6c$export$2b602b4ab6fde7b6({ after: after, onError: onError, errorPolicy: errorPolicy = 'none', updateQuery: updateQuery, query: query, variables: variables, client: client }) {
        const variablesWithAfter = {
            ...variables,
            after: after
        };
        return client.query({
            query: query,
            variables: variablesWithAfter,
            fetchPolicy: 'no-cache',
            errorPolicy: errorPolicy
        }).then((response)=>{
            if (!response) return;
            if (response.errors) {
                onError && onError(new (0, (0, parcelRequire("e3a3O")).ApolloError)({
                    graphQLErrors: response.errors
                }));
                if (errorPolicy === 'none') return;
            }
            if (response.data == null) return;
            const prevData = client.readQuery({
                query: query,
                variables: variables
            });
            if (prevData == null) return;
            const newData = updateQuery(prevData, {
                fetchMoreResult: response.data,
                variables: variablesWithAfter
            });
            client.writeQuery({
                query: query,
                variables: variables,
                notifyOnNetworkStatusChange: true,
                data: newData
            });
        }).catch((err)=>{
            onError && onError(err);
        });
    }
    function $0f8617a70c5d6b6c$export$d84f34af2f3f5d9f({ variables: variables, query: query }) {
        const client = (0, (0, parcelRequire("5tTFS")).useApolloClient)();
        return (0, (0, parcelRequire("8Qi2I")).useDeepMemo)(()=>(options)=>$0f8617a70c5d6b6c$export$2b602b4ab6fde7b6({
                    ...options,
                    variables: variables,
                    query: query,
                    client: client
                }), [
            client,
            variables,
            query
        ]);
    }
    function $0f8617a70c5d6b6c$export$5a178cf599565b50(data, listName, onError) {
        if (listName && data?.jira?.[listName]) {
            const _data = data.jira[listName];
            if (_data?.__typename === 'QueryError') {
                const queryError = new (0, (0, parcelRequire("c9Ur7")).QueryError)(_data);
                if (queryError.extensions?.find((ex)=>ex.statusCode === 401)) throw new (0, (0, parcelRequire("fPruT")).AuthenticationError)(_data.message);
                if (onError) {
                    onError(_data);
                    return undefined;
                }
                throw new (0, (0, parcelRequire("c9Ur7")).QueryError)(_data);
            }
            return _data;
        }
        return undefined;
    }
});
parcelRegister("8Qi2I", function(module, exports) {
    $parcel$export(module.exports, "useDeepMemo", ()=>$5b0bf94477e3396a$export$722debc0e56fea39);
    var $5uXOq = parcelRequire("5uXOq");
    var $ajpes = parcelRequire("ajpes");
    const $5b0bf94477e3396a$export$722debc0e56fea39 = (memoFn, deps)=>{
        const ref = (0, $5uXOq.useRef)();
        if (!ref.current || !(0, ($parcel$interopDefault($ajpes)))(ref.current.deps, deps)) ref.current = {
            value: memoFn(),
            deps: deps
        };
        return ref.current.value;
    };
});
parcelRegister("c9Ur7", function(module, exports) {
    $parcel$export(module.exports, "QueryError", ()=>$835bdf2aa5daa049$export$83dcbdfe8cbc1e17);
    const $835bdf2aa5daa049$export$f215947b3d76a6b7 = 'QueryError';
    class $835bdf2aa5daa049$export$83dcbdfe8cbc1e17 extends Error {
        constructor(payload){
            super(payload.message ?? undefined);
            this.extensions = payload.extensions;
            this.message = payload.message ?? '';
            this.statusCode = payload.extensions?.[0]?.statusCode ?? -1;
        }
    }
});
parcelRegister("fPruT", function(module, exports) {
    $parcel$export(module.exports, "AuthenticationError", ()=>$95af1b43dc18895e$export$cf0c46b07324e9c5);
    class $95af1b43dc18895e$export$cf0c46b07324e9c5 extends Error {
        constructor(message){
            super(message);
            this.name = 'AuthenticationError';
            this.skipSentry = true;
            this.statusCode = 401;
        }
    }
});
parcelRegister("cvbVg", function(module, exports) {
    $parcel$export(module.exports, "useIssuePagination", ()=>$0bf39943290cab91$export$b49565a42289e6b);
    $parcel$export(module.exports, "useJqlPagination", ()=>$0bf39943290cab91$export$9408824d9baedabc);
    $parcel$export(module.exports, "useRefreshInterval", ()=>$0bf39943290cab91$export$7cfdc4e3bbeb1790);
    var $5uXOq = parcelRequire("5uXOq");
    var $3JOCw = parcelRequire("3JOCw");
    var $5tTFS;
    var $9SwwX;
    const $0bf39943290cab91$var$paginationOptionsForIssuesByJql = {
        uniqueId: 'issueId',
        filter: 'jql'
    };
    function $0bf39943290cab91$export$f80c710216eae131({ data: data, variables: variables, listName: listName, query: query, onError: onError, errorPolicy: errorPolicy = 'none', uniqueId: uniqueId, filter: filter }) {
        const [isLoadingNextPage, setIsLoadingNextPage] = (0, $5uXOq.useState)(false);
        const _data = data && (0, (0, parcelRequire("9SwwX")).getAGGCompliantData)(data, listName, onError);
        const hasNextPage = _data?.pageInfo?.hasNextPage || false;
        const endCursor = _data?.pageInfo?.endCursor || '';
        const fetchMore = (0, (0, parcelRequire("9SwwX")).useFetchMore)({
            query: query,
            variables: variables
        });
        const onErrorRef = (0, $5uXOq.useRef)();
        onErrorRef.current = onError;
        const resetWhenChanged = filter ? variables[filter] : variables;
        (0, $5uXOq.useEffect)(()=>{
            setIsLoadingNextPage(false);
        }, [
            resetWhenChanged
        ]);
        const updateQueryAGGCompliant = (0, $5uXOq.useCallback)((prev, { fetchMoreResult: fetchMoreResult })=>{
            setIsLoadingNextPage(false);
            if (!fetchMoreResult) return prev;
            const edges = [
                ...(0, (0, parcelRequire("9SwwX")).getAGGCompliantData)(prev, listName)?.edges || [],
                ...(0, (0, parcelRequire("9SwwX")).getAGGCompliantData)(fetchMoreResult, listName)?.edges || []
            ];
            return {
                jira: {
                    ...fetchMoreResult.jira,
                    [listName]: {
                        ...(0, (0, parcelRequire("9SwwX")).getAGGCompliantData)(fetchMoreResult, listName),
                        edges: (0, ($parcel$interopDefault($3JOCw)))(edges, (edge)=>edge?.node && edge.node[uniqueId])
                    }
                }
            };
        }, [
            setIsLoadingNextPage,
            listName,
            uniqueId
        ]);
        const next = (0, $5uXOq.useCallback)((after)=>{
            setIsLoadingNextPage(true);
            fetchMore({
                after: after,
                onError: onErrorRef.current,
                errorPolicy: errorPolicy,
                updateQuery: updateQueryAGGCompliant
            });
        }, [
            fetchMore,
            updateQueryAGGCompliant,
            errorPolicy
        ]);
        return {
            hasNextPage: hasNextPage,
            endCursor: endCursor,
            isLoadingNextPage: isLoadingNextPage,
            next: next
        };
    }
    const $0bf39943290cab91$export$b49565a42289e6b = (options)=>$0bf39943290cab91$export$f80c710216eae131({
            ...options,
            ...$0bf39943290cab91$var$paginationOptionsForIssuesByJql
        });
    const $0bf39943290cab91$export$ea10f704343077db = ({ variables: variables, query: query, onCompleted: onCompleted, onError: onError, onPaginationError: onPaginationError, onNextPageLoaded: onNextPageLoaded, uniqueId: uniqueId, filter: filter, fetchPolicy: fetchPolicy, errorPolicy: errorPolicy = 'none' })=>{
        const [inFlightPage, setInFlightPage] = (0, $5uXOq.useState)();
        const resetWhenChanged = filter ? variables[filter] : variables;
        (0, $5uXOq.useEffect)(()=>{
            setInFlightPage(null);
        }, [
            resetWhenChanged
        ]);
        const [loadFirstPage, { data: data, loading: loading, error: error, refetch: refetch }] = (0, (0, parcelRequire("5tTFS")).useLazyQuery)(query, {
            variables: variables,
            errorPolicy: errorPolicy,
            fetchPolicy: fetchPolicy || 'network-only',
            onCompleted: onCompleted,
            onError: onError
        });
        if (data?.jira?.list?.__typename === 'QueryError') onError && onError(data?.jira?.list);
        const { next: next, hasNextPage: hasNextPage, endCursor: endCursor, isLoadingNextPage: isLoadingNextPage } = $0bf39943290cab91$export$f80c710216eae131({
            data: data,
            variables: variables,
            listName: 'list',
            onError: onPaginationError,
            errorPolicy: errorPolicy,
            query: query,
            uniqueId: uniqueId,
            filter: filter
        });
        const loadNextPage = (0, $5uXOq.useCallback)(()=>{
            if (!hasNextPage || endCursor === inFlightPage || loading) return;
            setInFlightPage(endCursor);
            next(endCursor);
            onNextPageLoaded && onNextPageLoaded();
        }, [
            endCursor,
            hasNextPage,
            inFlightPage,
            next,
            onNextPageLoaded,
            loading
        ]);
        return {
            loading: loading,
            error: error,
            data: data,
            loadFirstPage: loadFirstPage,
            hasNextPage: hasNextPage,
            isLoadingNextPage: isLoadingNextPage,
            loadNextPage: loadNextPage,
            refetch: refetch
        };
    };
    const $0bf39943290cab91$export$9408824d9baedabc = (options)=>$0bf39943290cab91$export$ea10f704343077db({
            ...options,
            ...$0bf39943290cab91$var$paginationOptionsForIssuesByJql
        });
    const $0bf39943290cab91$export$7cfdc4e3bbeb1790 = (callback, condition, interval)=>{
        (0, $5uXOq.useEffect)(()=>{
            if (interval == null) return ()=>{};
            const timer = setTimeout(()=>{
                if (condition) callback();
            }, interval * 1000);
            return ()=>{
                clearTimeout(timer);
            };
        }, [
            interval,
            callback,
            condition
        ]);
    };
});
parcelRegister("9A32U", function(module, exports) {
    $parcel$export(module.exports, "getVariables", ()=>$df7608f055c367f9$export$a39eddd73bba62c1);
    var $egmQO;
    const $df7608f055c367f9$var$DEFAULT_CHILDREN_PER_PAGE = 100;
    const $df7608f055c367f9$export$a39eddd73bba62c1 = (input)=>{
        const overriddenVariables = input.parentIssue ? {
            first: $df7608f055c367f9$var$DEFAULT_CHILDREN_PER_PAGE
        } : {};
        return {
            ...(0, (0, parcelRequire("egmQO")).getVariables)(input),
            ...overriddenVariables
        };
    };
});
parcelRegister("b180B", function(module, exports) {
    $parcel$export(module.exports, "useRankTimelineIssue", ()=>$9935a1bcf5e8438d$export$6c4394ff949c90b);
    var $5uXOq = parcelRequire("5uXOq");
    var $cm8b5;
    var $krCqe;
    var $pa9q9;
    var $8zOmE;
    var $lwMsT;
    var $gNAqw;
    var $3ByJB;
    const $9935a1bcf5e8438d$export$8d4e704b1891708c = {
        type: 'error',
        title: (0, (0, parcelRequire("3ByJB")).default).rankItemErrorTitle,
        description: (0, (0, parcelRequire("3ByJB")).default).rankItemGenericErrorDescription
    };
    const $9935a1bcf5e8438d$export$3d4660e65f55cbb9 = {
        type: 'error',
        title: (0, (0, parcelRequire("3ByJB")).default).rankItemErrorTitle,
        description: (0, (0, parcelRequire("3ByJB")).default).rankItem404ErrorDescription
    };
    const $9935a1bcf5e8438d$export$8e1bffd4c5401c9e = {
        type: 'error',
        title: (0, (0, parcelRequire("3ByJB")).default).rankItemErrorTitle,
        description: (0, (0, parcelRequire("3ByJB")).default).rankItem403ErrorDescription
    };
    const $9935a1bcf5e8438d$export$6c4394ff949c90b = ({ queryVariables: queryVariables, query: query })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const startExperience = (0, (0, parcelRequire("cm8b5")).useExperienceStart)((0, (0, parcelRequire("gNAqw")).RANK_ISSUE_EXPERIENCE));
        const markExperienceSuccess = (0, (0, parcelRequire("cm8b5")).useExperienceSuccess)((0, (0, parcelRequire("gNAqw")).RANK_ISSUE_EXPERIENCE));
        const markExperienceFailed = (0, (0, parcelRequire("cm8b5")).useExperienceFail)((0, (0, parcelRequire("gNAqw")).RANK_ISSUE_EXPERIENCE));
        const issueToRankRef = (0, $5uXOq.useRef)();
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagService)();
        const { rank: rank } = (0, (0, parcelRequire("krCqe")).useRankIssue)({
            query: query,
            variables: queryVariables,
            onError: (error)=>{
                if (error.statusCode === 403) showFlag($9935a1bcf5e8438d$export$8e1bffd4c5401c9e);
                else if (error.statusCode === 404) showFlag($9935a1bcf5e8438d$export$3d4660e65f55cbb9);
                else {
                    showFlag($9935a1bcf5e8438d$export$8d4e704b1891708c);
                    if (error.statusCode >= 500) {
                        markExperienceFailed('Issue rank failed.', error);
                        return;
                    }
                }
                markExperienceSuccess();
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'timelineRankIssue failure');
            },
            onSuccess: ()=>{
                markExperienceSuccess();
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'timelineRankIssue success');
                issueToRankRef.current = null;
            },
            onStart: ()=>{
                startExperience();
            }
        });
        return {
            rankIssue: rank
        };
    };
});
parcelRegister("krCqe", function(module, exports) {
    $parcel$export(module.exports, "useRankIssue", ()=>$25d51d58b2db8192$export$dbe3d15eebe7e64c);
    var $5uXOq = parcelRequire("5uXOq");
    var $dqDis;
    var $eusud;
    var $8zOmE;
    var $lwMsT;
    var $hlKA4;
    var $eVIe2;
    const $25d51d58b2db8192$var$performRestCall = (performRequest, url, issueId, relativeIssueId, setLoading, onError, onSuccess)=>{
        performRequest(url, {
            body: JSON.stringify({
                issueId: Number(issueId),
                relativeIssueId: Number(relativeIssueId)
            })
        }).then(()=>{
            setLoading(false);
            onSuccess && onSuccess();
        }).catch((error)=>{
            setLoading(false);
            onError && onError(error);
        });
    };
    const $25d51d58b2db8192$export$dbe3d15eebe7e64c = ({ query: query, variables: variables, onError: onError, onSuccess: onSuccess, onStart: onStart })=>{
        const [loading, setLoading] = (0, $5uXOq.useState)(false);
        const { getCachedIssueById: getCachedIssueById, updateItemsInCache: updateItemsInCache } = (0, (0, parcelRequire("hlKA4")).useCacheActions)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const queryRef = (0, $5uXOq.useRef)(query);
        queryRef.current = query;
        const variablesRef = (0, $5uXOq.useRef)(variables);
        variablesRef.current = variables;
        const rank = (0, $5uXOq.useCallback)(({ issueId: issueId, relativeIssue: relativeIssue, rankCall: rankCall, skipUpdateCache: skipUpdateCache, variablesInput: variablesInput })=>{
            setLoading(true);
            onStart && onStart();
            const cacheVariables = variablesInput ?? variablesRef.current;
            const issueToRank = getCachedIssueById({
                issueId: issueId,
                query: queryRef.current,
                variables: cacheVariables
            });
            const relativeIssueRank = relativeIssue.rank;
            if (issueToRank && relativeIssueRank) {
                const optimisticRank = rankCall === 'rankBefore' ? (0, (0, parcelRequire("dqDis")).getPreviousRank)(relativeIssueRank) : (0, (0, parcelRequire("dqDis")).getNextRank)(relativeIssueRank);
                if (!skipUpdateCache) updateItemsInCache({
                    query: queryRef.current,
                    variables: cacheVariables,
                    issueIds: [
                        issueToRank?.issueId
                    ],
                    updateItem: ()=>(0, (0, parcelRequire("eVIe2")).getOptimisticRanked)(issueToRank, optimisticRank)
                });
                $25d51d58b2db8192$var$performRestCall((0, (0, parcelRequire("eusud")).performPutRequest), `/rest/board-api/1/rank/${rankCall}`, Number(issueToRank.issueId), Number(relativeIssue.issueId), setLoading, (error)=>{
                    onError(error);
                    updateItemsInCache({
                        query: query,
                        variables: cacheVariables,
                        issueIds: [
                            issueToRank?.issueId
                        ],
                        updateItem: (existingIssue)=>({
                                ...existingIssue,
                                fields: existingIssue.fields?.filter((field)=>field?.aliasFieldId !== 'rank').concat(issueToRank.fields?.find((field)=>field?.aliasFieldId === 'rank'))
                            })
                    });
                }, ()=>{
                    onSuccess && onSuccess();
                    (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'issueRank succeeded');
                });
            } else setLoading(false);
        }, [
            createAnalyticsEvent,
            getCachedIssueById,
            onError,
            onStart,
            onSuccess,
            query,
            updateItemsInCache
        ]);
        const rankListViewIssue = (0, $5uXOq.useCallback)(({ newIndex: newIndex, oldIndex: oldIndex, issues: issues, issueToRank: prevIssueToRank, variables: variablesInput, skipUpdateCache: skipUpdateCache, instruction: instruction, relativeIssueOverride: relativeIssueOverride })=>{
            const rankingIssue = prevIssueToRank ?? issues[oldIndex];
            const { rankCall: rankCall, relativeIssue: relativeIssue } = (0, (0, parcelRequire("eVIe2")).getListViewRelativeIssueInfo)({
                newIndex: newIndex,
                oldIndex: oldIndex,
                issues: issues,
                instruction: instruction,
                relativeIssueOverride: relativeIssueOverride
            });
            if (relativeIssue) rank({
                relativeIssue: relativeIssue,
                issueId: rankingIssue.issueId,
                rankCall: rankCall,
                variablesInput: variablesInput,
                skipUpdateCache: skipUpdateCache
            });
        }, [
            rank
        ]);
        return {
            loading: loading,
            rank: rank,
            rankListViewIssue: rankListViewIssue
        };
    };
});
parcelRegister("eVIe2", function(module, exports) {
    $parcel$export(module.exports, "getOptimisticRanked", ()=>$c396479aef7761d0$export$44963c8ed1f74aef);
    $parcel$export(module.exports, "getListViewRelativeIssueInfo", ()=>$c396479aef7761d0$export$caf645882630a6c1);
    var $5fc53;
    const $c396479aef7761d0$export$44963c8ed1f74aef = (issue, rank)=>{
        const newRank = {
            ...issue?.fields?.find((field)=>field.type === (0, (0, parcelRequire("5fc53")).RANK_CF_TYPE) || field.aliasFieldId === 'rank')
        };
        newRank.text = rank;
        return {
            ...issue,
            fields: [
                ...issue?.fields?.filter((field)=>field.type !== (0, (0, parcelRequire("5fc53")).RANK_CF_TYPE) && field.aliasFieldId !== 'rank') || [],
                newRank
            ]
        };
    };
    const $c396479aef7761d0$export$caf645882630a6c1 = ({ newIndex: newIndex, oldIndex: oldIndex, issues: issues, instruction: instruction, relativeIssueOverride: relativeIssueOverride })=>{
        let rankCall = newIndex === 0 ? 'rankBefore' : 'rankAfter';
        if (instruction) rankCall = instruction === 'reorder-below' ? 'rankAfter' : 'rankBefore';
        let afterIndex = newIndex > oldIndex ? newIndex : Math.max(0, newIndex - 1);
        if (newIndex === oldIndex) afterIndex = rankCall === 'rankAfter' ? Math.max(0, newIndex - 1) : newIndex;
        let relativeIssue = relativeIssueOverride ?? issues[afterIndex];
        if (!relativeIssue?.rank) {
            const beforeIndex = newIndex > oldIndex ? Math.min(issues.length - 1, newIndex + 1) : newIndex;
            relativeIssue = issues[beforeIndex];
            rankCall = 'rankBefore';
        }
        return {
            rankCall: rankCall,
            relativeIssue: relativeIssue
        };
    };
});
parcelRegister("3ByJB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$59c4c5d70df36a7d$export$2e2bcd8739ae039);
    var $7VHMR;
    var $59c4c5d70df36a7d$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        rankItemErrorTitle: {
            "id": "business-timeline.services.rank-issue.rank-item-error-title",
            "defaultMessage": "Something's gone wrong"
        },
        rankItemGenericErrorDescription: {
            "id": "business-timeline.services.rank-issue.rank-item-generic-error-description",
            "defaultMessage": "Refresh the page and try again."
        },
        rankItem403ErrorDescription: {
            "id": "business-timeline.services.rank-issue.rank-item-403-error-description",
            "defaultMessage": "You don\u2019t have permission to move this issue. Contact a project admin."
        },
        rankItem404ErrorDescription: {
            "id": "business-timeline.services.rank-issue.rank-item-404-error-description",
            "defaultMessage": "We\u2019re having trouble moving this issue. To continue, refresh the page."
        }
    });
});
parcelRegister("2qV0a", function(module, exports) {
    $parcel$export(module.exports, "transformResult", ()=>$6157a0cd911c977d$export$f13b29f9ed0c5a03);
    $parcel$export(module.exports, "addChildToParentTimeline", ()=>$6157a0cd911c977d$export$d85b7ed06474d572);
    $parcel$export(module.exports, "rankSorter", ()=>$6157a0cd911c977d$export$3aa46dde0a2e6e47);
    var $hE5wF;
    var $5fc53;
    var $4kK95;
    const $6157a0cd911c977d$var$transformField = (field)=>{
        if (!field) return {};
        const fieldId = field?.aliasFieldId || field?.fieldId;
        switch(fieldId){
            case 'issuekey':
                return {
                    key: field.text
                };
            case 0, (0, parcelRequire("5fc53")).SUMMARY_TYPE:
                return {
                    summary: field?.text
                };
            case 0, (0, parcelRequire("5fc53")).STATUS_TYPE:
                {
                    const { status: status } = field;
                    return {
                        status: {
                            id: status.statusId,
                            name: status.name,
                            categoryId: status.statusCategory?.statusCategoryId
                        }
                    };
                }
            case 0, (0, parcelRequire("5fc53")).ISSUE_TYPE:
                {
                    const { issueType: issueType } = field;
                    return {
                        issueType: {
                            id: issueType?.issueTypeId,
                            name: issueType?.name,
                            iconUrl: issueType?.avatar?.medium,
                            hierarchyLevel: issueType?.hierarchy?.level ?? 0
                        }
                    };
                }
            case 'rank':
                return {
                    rank: field?.text
                };
            case 0, (0, parcelRequire("hE5wF")).START_DATE_ALIAS_FIELD_ID:
                {
                    const { date: date } = field;
                    return {
                        startDate: (0, (0, parcelRequire("4kK95")).toDateOnly)(date)?.toUTCDate().valueOf()
                    };
                }
            case 0, (0, parcelRequire("5fc53")).DUE_DATE_TYPE:
                {
                    const { date: date } = field;
                    return {
                        dueDate: (0, (0, parcelRequire("4kK95")).toDateOnly)(date)?.toUTCDate().valueOf()
                    };
                }
            case 0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE:
                {
                    const { user: user } = field;
                    return {
                        assignee: (user && {
                            avatarUrl: user.picture,
                            displayName: user.name,
                            accountId: user.accountId
                        }) ?? undefined
                    };
                }
            default:
                return {};
        }
    };
    const $6157a0cd911c977d$var$INWARD = 'INWARD';
    const $6157a0cd911c977d$var$transformIssueLinks = (edges)=>{
        if (edges == null || !Array.isArray(edges) || edges.length === 0) return [];
        return edges.filter((edge)=>edge?.node).map((edge)=>{
            const { issueLinkId: issueLinkId, direction: direction, relationName: relationName, issue: issue } = edge.node;
            return {
                issueLinkId: issueLinkId || null,
                type: {
                    inward: direction === $6157a0cd911c977d$var$INWARD ? relationName || '' : '',
                    outward: direction === $6157a0cd911c977d$var$INWARD ? '' : relationName || ''
                },
                inward: direction === $6157a0cd911c977d$var$INWARD ? {
                    issueId: issue?.issueId ?? null
                } : null,
                outward: direction === $6157a0cd911c977d$var$INWARD ? null : {
                    issueId: issue?.issueId ?? null
                }
            };
        });
    };
    const $6157a0cd911c977d$var$emptyArray = [];
    const $6157a0cd911c977d$export$f13b29f9ed0c5a03 = (edges)=>{
        if (edges == null || !Array.isArray(edges)) return {
            issues: []
        };
        const issues = edges.reduce((transformedData, edge)=>{
            const populateItem = (acc, field)=>({
                    ...acc,
                    ...$6157a0cd911c977d$var$transformField(field)
                });
            if (edge && edge.node && Array.isArray(edge.node?.fields)) {
                const issueLinkEdges = edge.node?.issueLinks?.edges || $6157a0cd911c977d$var$emptyArray;
                const item = edge.node.fields.reduce(populateItem, {
                    id: edge.node.id,
                    issueId: String(edge.node.issueId),
                    hasChildren: !!edge.node?.childSummary?.hasChildren,
                    issueLinks: $6157a0cd911c977d$var$transformIssueLinks(issueLinkEdges),
                    originalIssueLinks: issueLinkEdges
                });
                transformedData.push(item);
            }
            return transformedData;
        }, []);
        return {
            issues: issues
        };
    };
    const $6157a0cd911c977d$export$d85b7ed06474d572 = (parentIssue)=>({
            ...parentIssue,
            childSummary: {
                __typename: 'JiraWorkManagementChildSummary',
                hasChildren: true
            }
        });
    const $6157a0cd911c977d$var$getIssueFieldByName = (edge, targetField)=>edge?.node?.fields?.find((field)=>(field?.aliasFieldId || field?.fieldId) === targetField);
    const $6157a0cd911c977d$var$issueIsSubTask = (edge)=>$6157a0cd911c977d$var$getIssueFieldByName(edge, 'issuetype')?.issueType?.name === 'Sub-task';
    const $6157a0cd911c977d$var$getParentRank = (edge)=>$6157a0cd911c977d$var$getIssueFieldByName(edge, 'parent')?.parentIssue?.rankField?.[0].text ?? '';
    const $6157a0cd911c977d$export$3aa46dde0a2e6e47 = (edge)=>{
        const rank = $6157a0cd911c977d$var$getIssueFieldByName(edge, 'rank')?.text;
        if ($6157a0cd911c977d$var$issueIsSubTask(edge)) {
            const parentRank = $6157a0cd911c977d$var$getParentRank(edge);
            return parentRank.concat(rank ?? '');
        }
        return rank;
    };
});
parcelRegister("4kK95", function(module, exports) {
    $parcel$export(module.exports, "DateOnly", ()=>$a1048e23edd181e2$export$988b361b394263b6);
    $parcel$export(module.exports, "toDateOnly", ()=>$a1048e23edd181e2$export$b0961ad8aee63b8b);
    const $a1048e23edd181e2$export$9cda9b56d134780f = 'Invalid date or date format';
    const $a1048e23edd181e2$var$toISOString = (year, month, day)=>`${String(year).padStart(4, '0')}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
    const $a1048e23edd181e2$var$isLeapYear = (year)=>year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    const $a1048e23edd181e2$var$daysInMonth = [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ];
    const $a1048e23edd181e2$var$isDateValid = (year, month, day)=>{
        if ([
            year,
            month,
            day
        ].findIndex((n)=>typeof n !== 'number' || Number.isNaN(n)) !== -1) return false;
        if (year < 0) return false;
        if (month < 1 || month > 12) return false;
        if (day < 1) return false;
        if (day > (month === 2 && $a1048e23edd181e2$var$isLeapYear(year) ? 29 : $a1048e23edd181e2$var$daysInMonth[month - 1])) return false;
        return true;
    };
    const $a1048e23edd181e2$var$dateFormatRegExp = /^([0-9][0-9][0-9][0-9])-([0-1][0-9])-([0-3][0-9])$/;
    class $a1048e23edd181e2$export$988b361b394263b6 {
        static isISODateString(dateString) {
            try {
                $a1048e23edd181e2$export$988b361b394263b6.fromISODateString(dateString);
            } catch (e) {
                if (e?.message === $a1048e23edd181e2$export$9cda9b56d134780f) return false;
                throw e;
            }
            return true;
        }
        static fromISODateString(dateString) {
            const matches = $a1048e23edd181e2$var$dateFormatRegExp.exec(dateString);
            if (matches === null) throw new Error($a1048e23edd181e2$export$9cda9b56d134780f);
            const [, year, month, day] = matches;
            return new $a1048e23edd181e2$export$988b361b394263b6(...[
                year,
                month,
                day
            ].map((s)=>Number.parseInt(s, 10)));
        }
        static fromDateAccordingToLocalTime(date) {
            return new $a1048e23edd181e2$export$988b361b394263b6(date.getFullYear(), date.getMonth() + 1, date.getDate());
        }
        static fromDateAccordingToUTC(date) {
            return new $a1048e23edd181e2$export$988b361b394263b6(date.getUTCFullYear(), date.getUTCMonth() + 1, date.getUTCDate());
        }
        static compare(a, b) {
            if (a.year === b.year) {
                if (a.month === b.month) {
                    if (a.day === b.day) return 0;
                    return a.day < b.day ? -1 : 1;
                }
                return a.month < b.month ? -1 : 1;
            }
            return a.year < b.year ? -1 : 1;
        }
        constructor(year, month, day){
            if (!$a1048e23edd181e2$var$isDateValid(year, month, day)) throw new Error($a1048e23edd181e2$export$9cda9b56d134780f);
            this.year = year;
            this.month = month;
            this.day = day;
        }
        getYear() {
            return this.year;
        }
        getMonth() {
            return this.month;
        }
        getDay() {
            return this.day;
        }
        toISOString() {
            return $a1048e23edd181e2$var$toISOString(this.year, this.month, this.day);
        }
        toUTCDate() {
            return new Date(Date.UTC(this.year, this.month - 1, this.day));
        }
        toLocalDate() {
            const localDate = new Date();
            const currentMonth = localDate.getMonth();
            localDate.setFullYear(this.year);
            localDate.setHours(0);
            localDate.setMinutes(0);
            localDate.setSeconds(0);
            localDate.setMilliseconds(0);
            localDate.setDate(this.day);
            if (localDate.getMonth() !== currentMonth) {
                localDate.setMonth(this.month - 1);
                localDate.setDate(this.day);
            } else localDate.setMonth(this.month - 1);
            return localDate;
        }
        equals(dateOnly) {
            return $a1048e23edd181e2$export$988b361b394263b6.compare(this, dateOnly) === 0;
        }
    }
    const $a1048e23edd181e2$export$b0961ad8aee63b8b = (date)=>typeof date === 'string' ? $a1048e23edd181e2$export$988b361b394263b6.fromISODateString(date.replace(/T.*/, '')) : null;
});
parcelRegister("1lN06", function(module, exports) {
    $parcel$export(module.exports, "useCreateItemAnchor", ()=>$2d071c2487ffdb61$export$79c0b16424e10cdb);
    var $3sQ5x;
    var $iXqE5;
    const $2d071c2487ffdb61$var$actions = {
        setCreateItemAnchor: (createItemAnchor)=>({ setState: setState, getState: getState })=>setState({
                    ...getState(),
                    createItemAnchor: createItemAnchor
                })
    };
    const $2d071c2487ffdb61$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: {
            createItemAnchor: undefined
        },
        actions: $2d071c2487ffdb61$var$actions,
        name: 'JWMTimelineViewCreateItemAnchorStore'
    });
    const $2d071c2487ffdb61$export$79c0b16424e10cdb = (0, (0, parcelRequire("3sQ5x")).createHook)($2d071c2487ffdb61$var$Store);
});
parcelRegister("hZlg3", function(module, exports) {
    $parcel$export(module.exports, "useDependencyUpdater", ()=>$a3e746469b0bf588$export$cbe1bc5fd7675b9b);
    var $5uXOq = parcelRequire("5uXOq");
    var $FTaAj;
    var $ctQtp;
    const $a3e746469b0bf588$export$cbe1bc5fd7675b9b = ({ childrenQueryData: childrenQueryData })=>{
        const { onIssueUpdated: onIssueUpdated, onIssueRemoved: onIssueRemoved } = (0, (0, parcelRequire("ctQtp")).useTimelineViewUpdater)({
            childrenQueryData: childrenQueryData
        });
        const onBentoChange = (0, $5uXOq.useCallback)((event)=>{
            if (event.type === (0, (0, parcelRequire("FTaAj")).ChangeEventTypes).ISSUE_LINK_DELETED) onIssueUpdated([
                Number(event.issueId),
                Number(event.meta.linkedIssueId)
            ]);
            if (event.type === (0, (0, parcelRequire("FTaAj")).ChangeEventTypes).ISSUE_LINKS_CREATED) onIssueUpdated([
                Number(event.issueId)
            ].concat(event.meta.links.map((link)=>Number(link.linkedIssueId))));
            if (event.type === (0, (0, parcelRequire("FTaAj")).ChangeEventTypes).ISSUE_RELATIONSHIP_UPDATED) {
                const { issueId: issueId, meta: { oldParentIssueId: oldParentIssueId } } = event;
                onIssueRemoved({
                    issueId: Number(issueId),
                    parentId: oldParentIssueId ?? undefined
                });
            }
        }, [
            onIssueRemoved,
            onIssueUpdated
        ]);
        const onBentoDelete = (0, $5uXOq.useCallback)(({ issueId: issueId, parentId: parentId })=>{
            onIssueRemoved({
                issueId: issueId,
                parentId: parentId
            });
        }, [
            onIssueRemoved
        ]);
        return {
            onBentoChange: onBentoChange,
            onBentoDelete: onBentoDelete
        };
    };
});
parcelRegister("FTaAj", function(module, exports) {
    $parcel$export(module.exports, "ChangeEventTypes", ()=>$0a7f3a2a8450d0c8$export$8db21fc94823e1cc);
    const $0a7f3a2a8450d0c8$var$FIELD_CHANGE_REQUESTED = 'FIELD_CHANGE_REQUESTED';
    const $0a7f3a2a8450d0c8$var$FIELD_CHANGED = 'FIELD_CHANGED';
    const $0a7f3a2a8450d0c8$var$FIELD_CHANGE_FAILED = 'FIELD_CHANGE_FAILED';
    const $0a7f3a2a8450d0c8$var$ISSUE_TYPE_CHANGED = 'ISSUE_TYPE_CHANGED';
    const $0a7f3a2a8450d0c8$var$ISSUE_RELATIONSHIP_UPDATED = 'ISSUE_RELATIONSHIP_UPDATED';
    const $0a7f3a2a8450d0c8$var$ISSUE_LINKS_CREATED = 'ISSUE_LINKS_CREATED';
    const $0a7f3a2a8450d0c8$var$ISSUE_LINK_DELETED = 'ISSUE_LINK_DELETED';
    const $0a7f3a2a8450d0c8$var$CHILD_ISSUE_ADDED = 'CHILD_ISSUE_ADDED';
    const $0a7f3a2a8450d0c8$var$SUBTASK_ADDED = 'SUBTASK_ADDED';
    const $0a7f3a2a8450d0c8$var$ISSUE_CHILDREN_ORDER_CHANGED = 'ISSUE_CHILDREN_ORDER_CHANGED';
    const $0a7f3a2a8450d0c8$var$CHILD_ISSUE_FIELD_UPDATED = 'CHILD_ISSUE_FIELD_UPDATED';
    const $0a7f3a2a8450d0c8$var$CREATE_CONFLUENCE_PAGE_LINK_SUCCESS = 'CREATE_CONFLUENCE_PAGE_LINK_SUCCESS';
    const $0a7f3a2a8450d0c8$var$DELETE_CONFLUENCE_PAGE_LINK_SUCCESS = 'DELETE_CONFLUENCE_PAGE_LINK_SUCCESS';
    const $0a7f3a2a8450d0c8$export$8db21fc94823e1cc = {
        [$0a7f3a2a8450d0c8$var$FIELD_CHANGE_REQUESTED]: $0a7f3a2a8450d0c8$var$FIELD_CHANGE_REQUESTED,
        [$0a7f3a2a8450d0c8$var$FIELD_CHANGE_FAILED]: $0a7f3a2a8450d0c8$var$FIELD_CHANGE_FAILED,
        [$0a7f3a2a8450d0c8$var$FIELD_CHANGED]: $0a7f3a2a8450d0c8$var$FIELD_CHANGED,
        [$0a7f3a2a8450d0c8$var$ISSUE_TYPE_CHANGED]: $0a7f3a2a8450d0c8$var$ISSUE_TYPE_CHANGED,
        [$0a7f3a2a8450d0c8$var$ISSUE_RELATIONSHIP_UPDATED]: $0a7f3a2a8450d0c8$var$ISSUE_RELATIONSHIP_UPDATED,
        [$0a7f3a2a8450d0c8$var$ISSUE_LINKS_CREATED]: $0a7f3a2a8450d0c8$var$ISSUE_LINKS_CREATED,
        [$0a7f3a2a8450d0c8$var$ISSUE_LINK_DELETED]: $0a7f3a2a8450d0c8$var$ISSUE_LINK_DELETED,
        [$0a7f3a2a8450d0c8$var$CHILD_ISSUE_ADDED]: $0a7f3a2a8450d0c8$var$CHILD_ISSUE_ADDED,
        [$0a7f3a2a8450d0c8$var$SUBTASK_ADDED]: $0a7f3a2a8450d0c8$var$SUBTASK_ADDED,
        [$0a7f3a2a8450d0c8$var$ISSUE_CHILDREN_ORDER_CHANGED]: $0a7f3a2a8450d0c8$var$ISSUE_CHILDREN_ORDER_CHANGED,
        [$0a7f3a2a8450d0c8$var$CHILD_ISSUE_FIELD_UPDATED]: $0a7f3a2a8450d0c8$var$CHILD_ISSUE_FIELD_UPDATED,
        [$0a7f3a2a8450d0c8$var$CREATE_CONFLUENCE_PAGE_LINK_SUCCESS]: $0a7f3a2a8450d0c8$var$CREATE_CONFLUENCE_PAGE_LINK_SUCCESS,
        [$0a7f3a2a8450d0c8$var$DELETE_CONFLUENCE_PAGE_LINK_SUCCESS]: $0a7f3a2a8450d0c8$var$DELETE_CONFLUENCE_PAGE_LINK_SUCCESS
    };
});
parcelRegister("ctQtp", function(module, exports) {
    $parcel$export(module.exports, "useTimelineViewUpdater", ()=>$c111f68fa7089a93$export$e47ce03a9ecfdc38);
    var $5uXOq = parcelRequire("5uXOq");
    var $daQYX;
    var $1T2vX;
    var $8Wswo;
    var $kRkJF;
    var $jDUax;
    var $hlKA4;
    var $dCjtG;
    var $gwNxS;
    var $jcw0u;
    var $4R6GH;
    var $jrO9m;
    var $g5X3G;
    var $koeKL;
    var $gNAqw;
    var $9A32U;
    var $evzMt;
    var $cl738;
    var $6qNs0;
    var $2qV0a;
    const $c111f68fa7089a93$export$e47ce03a9ecfdc38 = ({ childrenQueryData: childrenQueryData })=>{
        const issueTypesAndFields = (0, (0, parcelRequire("1T2vX")).useIssueTypesAndFields)({
            issueOperation: 'VIEW'
        });
        const hierarchyLevels = issueTypesAndFields.hierarchyLevels;
        const { quickFiltersJql: quickFiltersJql, hierarchyParent: hierarchyParent, sorting: sorting, jqlContext: jqlContext, isHidingDoneItems: isHidingDoneItems } = (0, (0, parcelRequire("kRkJF")).useFilteredViewContextInput)({
            view: 'timeline'
        });
        const { addToCache: addToCache, removeFromCache: removeFromCache, updateItemsInCache: updateItemsInCache } = (0, (0, parcelRequire("hlKA4")).useCacheActions)();
        const [{ issueParentMap: issueParentMap }] = (0, (0, parcelRequire("evzMt")).useIssueParentMap)();
        const [{ issuesMap: issuesMap }] = (0, (0, parcelRequire("cl738")).useIssuesMap)();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const { data: overview } = (0, (0, parcelRequire("jrO9m")).useOverview)();
        const isOverview = overview != null && Array.isArray(overview.projects);
        let projectKey;
        if (!isOverview && (0, (0, parcelRequire("4R6GH")).fg)('timeline-uses-new-jql-parent-project-directive')) {
            const { key: key } = (0, (0, parcelRequire("daQYX")).useProject)();
            projectKey = key;
        }
        const topLevelVariables = {
            ...(0, (0, parcelRequire("9A32U")).getVariables)({
                jqlContext: jqlContext,
                fieldIds: (0, parcelRequire("gNAqw")).fieldIds,
                quickFiltersJql: quickFiltersJql,
                isHidingDoneItems: isHidingDoneItems,
                hierarchyParent: hierarchyParent,
                ...hierarchyLevels !== undefined && {
                    hierarchyLevel: hierarchyLevels[0]?.level
                },
                sorting: sorting,
                ...projectKey ? {
                    projectIdOrKey: projectKey
                } : {}
            })
        };
        const { addToCacheCallback: addToCacheCallback, removeFromCacheCallback: removeFromCacheCallback } = (0, (0, parcelRequire("gwNxS")).createViewUpdaterCallbacksWithCacheActions)({
            query: (0, (0, parcelRequire("6qNs0")).TIMELINE_VIEW_ITEMS_QUERY),
            addToCache: addToCache,
            updateItemsInCache: updateItemsInCache,
            removeFromCache: removeFromCache,
            isHierarchyEnabled: ()=>typeof hierarchyParent !== 'undefined',
            isInfiniteHierarchyEnabled: ()=>true,
            createVariablesForItemWithoutParent: ()=>topLevelVariables,
            createVariablesForItemWithParent: (parentIssueId)=>{
                if (!hierarchyParent) return topLevelVariables;
                return {
                    ...(0, (0, parcelRequire("9A32U")).getVariables)({
                        jqlContext: jqlContext,
                        fieldIds: (0, parcelRequire("gNAqw")).fieldIds,
                        quickFiltersJql: quickFiltersJql,
                        isHidingDoneItems: isHidingDoneItems,
                        sorting: sorting,
                        hierarchyParent: undefined,
                        parentIssue: {
                            hierarchyType: hierarchyParent,
                            issueId: parentIssueId
                        },
                        ...projectKey ? {
                            projectIdOrKey: projectKey
                        } : {}
                    }),
                    cloudId: cloudId
                };
            },
            shouldChildItemBeAddedToOrRemovedFromCache: (parentIssueId)=>Boolean(childrenQueryData && childrenQueryData[(0, (0, parcelRequire("g5X3G")).toIssueId)(parentIssueId)] !== undefined),
            onUpdateParentWithNewChild: (0, (0, parcelRequire("2qV0a")).addChildToParentTimeline),
            getParentOfIssueIfExist: (issueId)=>{
                const maybeIssue = issuesMap.get(issueId);
                if (!maybeIssue) return undefined;
                return (0, (0, parcelRequire("jDUax")).getParentIssueId)(maybeIssue);
            },
            getPrevParentOfIssueIfExists: (issueId)=>issueParentMap.get(String(issueId))
        });
        return (0, (0, parcelRequire("dCjtG")).useViewUpdater)({
            input: {
                fieldIds: (0, parcelRequire("gNAqw")).fieldIds,
                quickFiltersJql: quickFiltersJql,
                isHidingDoneItems: isHidingDoneItems
            },
            query: (0, (0, parcelRequire("6qNs0")).TIMELINE_VIEW_ITEMS_QUERY),
            actions: [
                {
                    addToCache: addToCacheCallback,
                    removeFromCache: removeFromCacheCallback
                }
            ],
            onError: (0, $5uXOq.useCallback)((apolloError)=>{
                if (!(0, (0, parcelRequire("8Wswo")).shouldHandleTheError)(apolloError)) return;
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'timelineViewUpdaterQuery',
                        packageName: 'jiraBusinessTimeline',
                        teamName: 'jira-yurree'
                    },
                    attributes: {
                        message: 'Failed to fetch issues in timeline view updater'
                    },
                    error: apolloError,
                    sendToPrivacyUnsafeSplunk: true
                });
            }, []),
            onAppendItemsError: (0, $5uXOq.useCallback)((apolloError)=>{
                if (!(0, (0, parcelRequire("8Wswo")).shouldHandleTheError)(apolloError)) return;
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'timelineViewAppendItemsQuery',
                        packageName: 'jiraBusinessTimeline',
                        teamName: 'jira-yurree'
                    },
                    attributes: {
                        message: 'Failed to append issues by id in timeline view updater'
                    },
                    error: apolloError,
                    sendToPrivacyUnsafeSplunk: true
                });
            }, [])
        });
    };
});
parcelRegister("dCjtG", function(module, exports) {
    $parcel$export(module.exports, "useViewUpdater", ()=>$92d86c8da94b73a1$export$a7d7c9fa51f6f9e6);
    var $5uXOq = parcelRequire("5uXOq");
    var $5tTFS;
    var $egmQO;
    var $5YBrl;
    var $3ItGl;
    var $5fc53;
    var $koeKL;
    var $9SwwX;
    var $1TVaR;
    var $1RfvD;
    const $92d86c8da94b73a1$export$a7d7c9fa51f6f9e6 = ({ input: input, query: query, actions: actions, onError: onError, onAppendItemsError: onAppendItemsError })=>{
        const jqlContext = (0, (0, parcelRequire("5YBrl")).useJqlContext)();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const [updateInFlightList, setUpdateInFlightList] = (0, $5uXOq.useState)([]);
        const [cacheActionIssues, dispatch] = (0, (0, parcelRequire("1RfvD")).useCacheActionsReducer)();
        const getIssuesByIdVariablesRef = (0, $5uXOq.useRef)();
        const getIssuesByIdOnCompletedRef = (0, $5uXOq.useRef)(null);
        const [fetchIssueToRemove, { loading: fetchIssueToRemoveLoading }] = (0, (0, parcelRequire("5tTFS")).useLazyQuery)(query, {
            fetchPolicy: 'network-only',
            errorPolicy: 'all',
            onCompleted: (0, $5uXOq.useCallback)((result)=>{
                const items = (0, (0, parcelRequire("9SwwX")).getAGGCompliantData)(result, 'list');
                const validNodes = items?.edges?.map((edge)=>edge?.node).filter(Boolean);
                if (validNodes && validNodes.length > 0) dispatch({
                    type: 'REMOVE_FROM_CACHE',
                    issues: validNodes
                });
            }, [
                dispatch
            ]),
            onError: onAppendItemsError
        });
        const [getIssuesById, { variables: getIssuesByIdVariables, loading: getIssuesByIdLoading }] = (0, (0, parcelRequire("5tTFS")).useLazyQuery)(query, {
            fetchPolicy: 'no-cache',
            errorPolicy: 'all',
            onError: (0, $5uXOq.useCallback)((error)=>{
                if ((0, (0, parcelRequire("3ItGl")).isAbortError)(error.networkError)) return;
                onError(error);
            }, [
                onError
            ]),
            onCompleted: (0, $5uXOq.useCallback)((result)=>getIssuesByIdOnCompletedRef.current?.(result), [])
        });
        if (getIssuesByIdVariablesRef.current !== getIssuesByIdVariables) getIssuesByIdVariablesRef.current = getIssuesByIdVariables;
        const [appendIssuesById, { loading: appendIssuesByIdLoading }] = (0, (0, parcelRequire("5tTFS")).useLazyQuery)(query, {
            fetchPolicy: 'network-only',
            errorPolicy: 'all',
            onCompleted: (0, $5uXOq.useCallback)((result)=>{
                const items = (0, (0, parcelRequire("9SwwX")).getAGGCompliantData)(result, 'list', onError);
                const validNodes = items?.edges?.map((edge)=>edge?.node).filter(Boolean);
                if (validNodes && validNodes.length > 0) dispatch({
                    type: 'ADD_TO_CACHE',
                    issues: validNodes
                });
            }, [
                dispatch,
                onError
            ]),
            onError: onAppendItemsError
        });
        const { addRequestToQueue: addRequestToQueue, addRequestToAbortableQueue: addRequestToAbortableQueue } = (0, (0, parcelRequire("1TVaR")).useRequestQueue)({
            isRequestLoading: fetchIssueToRemoveLoading || getIssuesByIdLoading || appendIssuesByIdLoading
        });
        const removeIssueById = (0, $5uXOq.useCallback)((issueIdsToRemove)=>{
            addRequestToQueue(()=>fetchIssueToRemove({
                    variables: {
                        ...(0, (0, parcelRequire("egmQO")).getVariables)({
                            jqlContext: jqlContext,
                            issueIds: issueIdsToRemove,
                            fieldIds: input.fieldIds,
                            isHidingDoneItems: input.isHidingDoneItems,
                            isParentFieldVisible: input.isParentFieldVisible,
                            isDevSummaryFieldVisible: input.isDevSummaryFieldVisible,
                            projectIdOrKey: input.projectKey,
                            quickFiltersJql: null
                        }),
                        cloudId: cloudId
                    }
                }));
        }, [
            addRequestToQueue,
            fetchIssueToRemove,
            jqlContext,
            input.fieldIds,
            input.isHidingDoneItems,
            input.isParentFieldVisible,
            input.isDevSummaryFieldVisible,
            input.projectKey,
            cloudId
        ]);
        const removeIssue = (0, $5uXOq.useCallback)(({ issueId: issueId, parentId: parentId })=>{
            const issueNode = {
                issueId: issueId,
                fields: parentId != null ? [
                    {
                        fieldId: 'parent',
                        type: (0, (0, parcelRequire("5fc53")).PARENT_TYPE),
                        parentIssue: {
                            issueId: parentId
                        }
                    }
                ] : []
            };
            dispatch({
                type: 'REMOVE_FROM_CACHE',
                issues: [
                    issueNode
                ]
            });
        }, [
            dispatch
        ]);
        const handleFilterMismatch = (0, $5uXOq.useCallback)((variables, result)=>{
            if (!variables.jql) return;
            if (!result || !result.jira) return;
            const updateIndex = updateInFlightList.findIndex((updateInput)=>(0, (0, parcelRequire("egmQO")).getVariables)(updateInput).jql === variables.jql);
            if (updateIndex === -1) return;
            const currentUpdate = updateInFlightList[updateIndex];
            const isUsingSameFilter = currentUpdate.quickFiltersJql === input.quickFiltersJql;
            const issueIds = [
                ...currentUpdate.issueIds || []
            ];
            const items = (0, (0, parcelRequire("9SwwX")).getAGGCompliantData)(result, 'list');
            const validNodes = items?.edges?.map((edge)=>edge?.node).filter(Boolean);
            if (isUsingSameFilter) {
                const issueIdsToRemove = [];
                issueIds.forEach((issueId, idIndex)=>{
                    const item = validNodes?.find((node)=>node?.issueId === issueId);
                    if (item == null) issueIdsToRemove.push(issueId);
                    issueIds.splice(idIndex, 0);
                    updateInFlightList[updateIndex] = {
                        ...currentUpdate,
                        issueIds: issueIds
                    };
                });
                if (issueIdsToRemove.length > 0) removeIssueById(issueIdsToRemove);
            }
            setUpdateInFlightList((prevUpdateInFlightList)=>{
                prevUpdateInFlightList.splice(updateIndex, 1);
                return prevUpdateInFlightList;
            });
            if (validNodes && validNodes.length > 0) dispatch({
                type: 'ADD_TO_CACHE',
                issues: validNodes
            });
            const filteredIssueIds = issueIds.filter((issueId)=>!(validNodes ?? []).find((node)=>node?.issueId === issueId));
            if (filteredIssueIds.length > 0) dispatch({
                type: 'HANDLE_FILTERED_UPDATE',
                issues: filteredIssueIds
            });
        }, [
            updateInFlightList,
            input,
            removeIssueById,
            dispatch
        ]);
        getIssuesByIdOnCompletedRef.current = (result)=>handleFilterMismatch(getIssuesByIdVariables, result);
        (0, $5uXOq.useEffect)(()=>{
            if (cacheActionIssues.addToCache.length === 0 && cacheActionIssues.removeFromCache.length === 0 && cacheActionIssues.handleFilteredUpdate.length === 0) return;
            Object.entries(cacheActionIssues).forEach(([actionName, issues])=>{
                if (Array.isArray(issues) && issues.length > 0) actions.forEach((actionEntry)=>{
                    actionEntry?.[actionName]?.(issues);
                });
            });
            dispatch({
                type: 'CLEAR'
            });
        }, [
            cacheActionIssues,
            actions,
            dispatch
        ]);
        return {
            onIssueUpdated: (issueIds)=>{
                const updateInput = {
                    jqlContext: jqlContext,
                    issueIds: issueIds,
                    fieldIds: input.fieldIds,
                    quickFiltersJql: input.quickFiltersJql,
                    isHidingDoneItems: input.isHidingDoneItems,
                    isParentFieldVisible: input.isParentFieldVisible,
                    isDevSummaryFieldVisible: input.isDevSummaryFieldVisible,
                    projectIdOrKey: input.projectKey
                };
                setUpdateInFlightList((prevUpdateInFlightList)=>[
                        ...prevUpdateInFlightList,
                        updateInput
                    ]);
                addRequestToAbortableQueue(issueIds, getIssuesById, {
                    variables: {
                        ...(0, (0, parcelRequire("egmQO")).getVariables)(updateInput),
                        cloudId: cloudId
                    }
                });
            },
            onIssueCreated: (issueIds)=>{
                addRequestToQueue(()=>appendIssuesById({
                        variables: {
                            ...(0, (0, parcelRequire("egmQO")).getVariables)({
                                jqlContext: jqlContext,
                                issueIds: issueIds,
                                fieldIds: input.fieldIds,
                                quickFiltersJql: input.quickFiltersJql,
                                isHidingDoneItems: input.isHidingDoneItems,
                                isParentFieldVisible: input.isParentFieldVisible,
                                isDevSummaryFieldVisible: input.isDevSummaryFieldVisible,
                                projectIdOrKey: input.projectKey
                            }),
                            cloudId: cloudId
                        }
                    }));
            },
            onIssueRemoved: (params)=>removeIssue(params)
        };
    };
});
parcelRegister("3ItGl", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_ABORT_ERROR_MESSAGE", ()=>$d72d9e0bee84c3ed$export$6131a8d209a21250);
    $parcel$export(module.exports, "AbortError", ()=>$d72d9e0bee84c3ed$export$18b052ffd8c84d7);
    $parcel$export(module.exports, "isAbortError", ()=>$d72d9e0bee84c3ed$export$d2c30ea522b3259e);
    const $d72d9e0bee84c3ed$export$6131a8d209a21250 = 'The operation was aborted.';
    class $d72d9e0bee84c3ed$export$18b052ffd8c84d7 extends Error {
        constructor(message, statusCode = 499){
            super(message);
            this.name = 'AbortError';
            this.statusCode = statusCode;
        }
    }
    const $d72d9e0bee84c3ed$export$d2c30ea522b3259e = (error)=>error instanceof $d72d9e0bee84c3ed$export$18b052ffd8c84d7;
});
parcelRegister("1TVaR", function(module, exports) {
    $parcel$export(module.exports, "useRequestQueue", ()=>$c49911f50c422071$export$a90df70eeafb262f);
    var $5uXOq = parcelRequire("5uXOq");
    var $3ItGl;
    const $c49911f50c422071$export$a90df70eeafb262f = ({ isRequestLoading: isRequestLoading })=>{
        const [abortableQueueMap, setAbortableQueueMap] = (0, $5uXOq.useState)(new Map());
        const abortControllerMap = (0, $5uXOq.useRef)(new Map());
        const inProgressRequestId = (0, $5uXOq.useRef)(null);
        const addRequestToAbortableQueue = (0, $5uXOq.useCallback)((issueIds, queryFunction, queryOptions)=>{
            const id = issueIds.join('-');
            const existingAbortController = abortControllerMap.current.get(id);
            existingAbortController?.abort(new (0, (0, parcelRequire("3ItGl")).AbortError)((0, (0, parcelRequire("3ItGl")).DEFAULT_ABORT_ERROR_MESSAGE)));
            const abortController = new AbortController();
            abortControllerMap.current.set(id, abortController);
            const request = ()=>{
                queryFunction({
                    ...queryOptions,
                    context: {
                        ...queryOptions.context,
                        fetchOptions: {
                            ...queryOptions.context?.fetchOptions,
                            signal: abortController.signal
                        }
                    }
                });
            };
            setAbortableQueueMap((prevQueueMap)=>new Map([
                    ...prevQueueMap,
                    [
                        id,
                        request
                    ]
                ]));
        }, []);
        (0, $5uXOq.useEffect)(()=>{
            if (!isRequestLoading && abortableQueueMap.size) {
                const iterator = abortableQueueMap.entries();
                const nextResult = iterator.next();
                if (!nextResult.done) {
                    const [id, request] = nextResult.value;
                    inProgressRequestId.current = id;
                    request();
                }
                setAbortableQueueMap(new Map(iterator));
            }
        }, [
            abortableQueueMap,
            isRequestLoading
        ]);
        const [queue, setQueue] = (0, $5uXOq.useState)([]);
        (0, $5uXOq.useEffect)(()=>{
            if (!isRequestLoading && queue.length > 0) setQueue((prevQueue)=>{
                const [nextItem, ...restOfQueue] = prevQueue;
                nextItem();
                return restOfQueue;
            });
        }, [
            queue,
            isRequestLoading
        ]);
        const addRequestToQueue = (request)=>setQueue((prevQueue)=>[
                    ...prevQueue,
                    request
                ]);
        return {
            addRequestToQueue: addRequestToQueue,
            addRequestToAbortableQueue: addRequestToAbortableQueue
        };
    };
});
parcelRegister("1RfvD", function(module, exports) {
    $parcel$export(module.exports, "useCacheActionsReducer", ()=>$9eb3afdf1d8deb15$export$83303d410e8412eb);
    var $5uXOq = parcelRequire("5uXOq");
    const $9eb3afdf1d8deb15$var$cacheActionsReducer = (state, action)=>{
        switch(action.type){
            case 'ADD_TO_CACHE':
                return {
                    ...state,
                    addToCache: [
                        ...state.addToCache,
                        ...action.issues
                    ]
                };
            case 'REMOVE_FROM_CACHE':
                return {
                    ...state,
                    removeFromCache: [
                        ...state.removeFromCache,
                        ...action.issues
                    ]
                };
            case 'HANDLE_FILTERED_UPDATE':
                return {
                    ...state,
                    handleFilteredUpdate: [
                        ...state.handleFilteredUpdate,
                        ...action.issues
                    ]
                };
            case 'CLEAR':
                return {
                    addToCache: [],
                    removeFromCache: [],
                    handleFilteredUpdate: []
                };
            default:
                return state;
        }
    };
    const $9eb3afdf1d8deb15$export$83303d410e8412eb = ()=>(0, $5uXOq.useReducer)($9eb3afdf1d8deb15$var$cacheActionsReducer, {
            addToCache: [],
            removeFromCache: [],
            handleFilteredUpdate: []
        });
});
parcelRegister("gwNxS", function(module, exports) {
    $parcel$export(module.exports, "createViewUpdaterCallbacksWithCacheActions", ()=>$65b2bcc93c8e1166$export$cc1c02509eec9edb);
    $parcel$export(module.exports, "createGroupingViewUpdaterCacheActions", ()=>$65b2bcc93c8e1166$export$c410d2a23de7830a);
    var $jDUax;
    const $65b2bcc93c8e1166$export$cc1c02509eec9edb = ({ isHierarchyEnabled: isHierarchyEnabled, isInfiniteHierarchyEnabled: isInfiniteHierarchyEnabled, query: query, addToCache: addToCache, removeFromCache: removeFromCache, updateItemsInCache: updateItemsInCache, createVariablesForItemWithParent: createVariablesForItemWithParent, createVariablesForItemWithoutParent: createVariablesForItemWithoutParent, shouldChildItemBeAddedToOrRemovedFromCache: shouldChildItemBeAddedToOrRemovedFromCache, onUpdateParentWithNewChild: onUpdateParentWithNewChild, getParentOfIssueIfExist: getParentOfIssueIfExist, isItemHierarchySupported: isItemHierarchySupported, removeChildFromParent: removeChildFromParent, updateIssueParentMap: updateIssueParentMap, getPrevParentOfIssueIfExists: getPrevParentOfIssueIfExists, createVariablesForGroupItem: createVariablesForGroupItem, isGroupingByStatus: isGroupingByStatus = false, isGrouping: isGrouping = false })=>{
        const getParentVariables = (parentId)=>{
            const variables = createVariablesForItemWithoutParent();
            if (!parentId) return variables;
            if (createVariablesForGroupItem && (0, (0, parcelRequire("jDUax")).isGroupItem)(parentId)) return createVariablesForGroupItem(parentId);
            return createVariablesForItemWithParent(parentId);
        };
        const updateIssueParent = ({ prevParentIssueId: prevParentIssueId, parentIssueId: parentIssueId, item: item })=>{
            updateIssueParentMap && updateIssueParentMap(item.issueId, parentIssueId);
            if (!prevParentIssueId && !isGrouping || isGrouping && prevParentIssueId || prevParentIssueId && shouldChildItemBeAddedToOrRemovedFromCache(prevParentIssueId)) removeFromCache({
                query: query,
                variables: getParentVariables(prevParentIssueId),
                issueId: Number(item.issueId)
            });
            if (isGroupingByStatus) return;
            const hasParentToRemove = getParentOfIssueIfExist && !!getParentOfIssueIfExist(item.issueId);
            if (removeChildFromParent && prevParentIssueId && hasParentToRemove) {
                const grandParentId = getParentOfIssueIfExist ? getParentOfIssueIfExist(String(prevParentIssueId)) : undefined;
                if ((0, (0, parcelRequire("jDUax")).isGroupItem)(grandParentId) || (0, (0, parcelRequire("jDUax")).isGroupItem)(prevParentIssueId)) return;
                updateItemsInCache({
                    query: query,
                    variables: getParentVariables(grandParentId),
                    issueIds: [
                        String(prevParentIssueId)
                    ],
                    updateItem: (existingParentIssue)=>removeChildFromParent(existingParentIssue, 1)
                });
            }
            if (!parentIssueId) return;
            const newGrandParentId = getParentOfIssueIfExist ? getParentOfIssueIfExist(parentIssueId.toString()) : undefined;
            if ((0, (0, parcelRequire("jDUax")).isGroupItem)(newGrandParentId) || (0, (0, parcelRequire("jDUax")).isGroupItem)(parentIssueId)) return;
            updateItemsInCache({
                query: query,
                variables: getParentVariables(newGrandParentId),
                issueIds: [
                    parentIssueId
                ],
                updateItem: (existingIssue)=>{
                    const updatedIssueWithNewChild = onUpdateParentWithNewChild(existingIssue, item);
                    return updatedIssueWithNewChild;
                }
            });
        };
        const addToCacheCallback = (items)=>{
            if (isHierarchyEnabled()) {
                const itemsWithoutParent = items.filter((i)=>(0, (0, parcelRequire("jDUax")).getParentIssueId)(i) === undefined);
                const itemsWithParent = items.filter((i)=>(0, (0, parcelRequire("jDUax")).getParentIssueId)(i) !== undefined);
                if (itemsWithoutParent.length > 0) {
                    addToCache({
                        newNodes: itemsWithoutParent,
                        query: query,
                        variables: createVariablesForItemWithoutParent()
                    });
                    items.forEach((item)=>{
                        const parentIssueId = undefined;
                        const prevParentIssueId = getPrevParentOfIssueIfExists ? getPrevParentOfIssueIfExists(item.issueId) : undefined;
                        if (isInfiniteHierarchyEnabled() && prevParentIssueId !== parentIssueId) updateIssueParent({
                            prevParentIssueId: prevParentIssueId,
                            parentIssueId: parentIssueId,
                            item: item
                        });
                    });
                }
                itemsWithParent.forEach((item)=>{
                    const parentIssueId = (0, (0, parcelRequire("jDUax")).getParentIssueId)(item);
                    if (parentIssueId === undefined) return;
                    if (isItemHierarchySupported && !isItemHierarchySupported(item)) {
                        addToCache({
                            newNodes: [
                                item
                            ],
                            query: query,
                            variables: createVariablesForItemWithoutParent()
                        });
                        return;
                    }
                    const prevParentIssueId = getPrevParentOfIssueIfExists ? getPrevParentOfIssueIfExists(item.issueId) : undefined;
                    const shouldUpdateIssueParent = isInfiniteHierarchyEnabled() && prevParentIssueId !== parentIssueId;
                    const shouldChildItemBeAddedOrRemovedFromCache = shouldChildItemBeAddedToOrRemovedFromCache(parentIssueId);
                    if (shouldUpdateIssueParent) updateIssueParent({
                        prevParentIssueId: prevParentIssueId,
                        parentIssueId: parentIssueId,
                        item: item
                    });
                    if (shouldChildItemBeAddedOrRemovedFromCache) addToCache({
                        newNodes: [
                            item
                        ],
                        query: query,
                        variables: createVariablesForItemWithParent(parentIssueId)
                    });
                    else if (!shouldChildItemBeAddedOrRemovedFromCache && !shouldUpdateIssueParent) {
                        let variables = createVariablesForItemWithoutParent();
                        if (isInfiniteHierarchyEnabled() && getParentOfIssueIfExist) {
                            const grandParentId = getParentOfIssueIfExist(parentIssueId.toString());
                            if (grandParentId != null) variables = createVariablesForItemWithParent(grandParentId);
                        }
                        updateItemsInCache({
                            query: query,
                            variables: variables,
                            issueIds: [
                                parentIssueId
                            ],
                            updateItem: (existingIssue)=>{
                                const updatedIssueWithNewChild = onUpdateParentWithNewChild(existingIssue, item);
                                return updatedIssueWithNewChild;
                            }
                        });
                    }
                });
                return;
            }
            addToCache({
                newNodes: items,
                query: query,
                variables: createVariablesForItemWithoutParent()
            });
        };
        const removeFromCacheCallback = (items)=>{
            items.forEach((item)=>{
                if (isHierarchyEnabled()) {
                    const parentIssueId = (0, (0, parcelRequire("jDUax")).getParentIssueId)(item);
                    if (parentIssueId !== undefined) {
                        if (shouldChildItemBeAddedToOrRemovedFromCache(parentIssueId)) removeFromCache({
                            issueId: item.issueId,
                            query: query,
                            variables: createVariablesForItemWithParent(parentIssueId)
                        });
                        return;
                    }
                }
                removeFromCache({
                    issueId: item.issueId,
                    query: query,
                    variables: createVariablesForItemWithoutParent()
                });
            });
        };
        return {
            addToCacheCallback: addToCacheCallback,
            removeFromCacheCallback: removeFromCacheCallback
        };
    };
    const $65b2bcc93c8e1166$export$c410d2a23de7830a = ({ query: query, groupsQuery: groupsQuery, addToCache: addToCache, removeFromCache: removeFromCache, addGroupItemToCache: addGroupItemToCache, updateGroupItemInCache: updateGroupItemInCache, updateItemsInCache: updateItemsInCache, createVariablesForGroups: createVariablesForGroups, createVariablesForGroupItem: createVariablesForGroupItem, createItemGroup: createItemGroup, findItemGroup: findItemGroup, findGroupById: findGroupById, canUpdateGroupCache: canUpdateGroupCache, getParentOfIssueIfExist: getParentOfIssueIfExist, getPrevParentOfIssueIfExists: getPrevParentOfIssueIfExists, onUpdateParentWithNewChild: onUpdateParentWithNewChild, removeChildFromParent: removeChildFromParent, createVariablesForItemWithParent: createVariablesForItemWithParent, updateIssueParentMap: updateIssueParentMap })=>{
        const getReparentingInfo = (item)=>{
            const currentParent = (0, (0, parcelRequire("jDUax")).getParentIssueId)(item);
            const prevParent = getPrevParentOfIssueIfExists(String(item.issueId));
            const isUnlinkParent = (!currentParent || (0, (0, parcelRequire("jDUax")).isGroupItem)(currentParent)) && prevParent && currentParent !== prevParent;
            const isReparenting = currentParent && currentParent !== prevParent;
            return {
                isReparenting: isReparenting,
                isUnlinkParent: isUnlinkParent,
                currentParent: currentParent,
                prevParent: prevParent
            };
        };
        const removeItemFromCache = (item, currentGroupIssueId)=>{
            const { isReparenting: isReparenting, prevParent: prevParent, isUnlinkParent: isUnlinkParent } = getReparentingInfo(item);
            if (canUpdateGroupCache(currentGroupIssueId) && (!isReparenting && !isUnlinkParent || prevParent && (0, (0, parcelRequire("jDUax")).isGroupItem)(prevParent))) removeFromCache({
                issueId: item.issueId,
                query: query,
                variables: createVariablesForGroupItem(currentGroupIssueId)
            });
            else if (prevParent && (isReparenting || isUnlinkParent) && !(0, (0, parcelRequire("jDUax")).isGroupItem)(prevParent)) removeFromCache({
                issueId: item.issueId,
                query: query,
                variables: createVariablesForItemWithParent(prevParent)
            });
            const groupItem = findGroupById(currentGroupIssueId);
            const prevGrandParent = prevParent ? getParentOfIssueIfExist(prevParent) : undefined;
            if (groupItem) {
                if (prevParent && (isReparenting || isUnlinkParent) && prevGrandParent && removeChildFromParent) updateItemsInCache({
                    query: query,
                    variables: (0, (0, parcelRequire("jDUax")).isGroupItem)(prevGrandParent) ? createVariablesForGroupItem(prevGrandParent) : createVariablesForItemWithParent(prevGrandParent),
                    issueIds: [
                        prevParent
                    ],
                    updateItem: (existingParentIssue)=>removeChildFromParent(existingParentIssue, 1)
                });
                else if (isChildIssueInGroup(groupItem, item.issueId)) updateGroupItemInCache({
                    query: groupsQuery,
                    variables: createVariablesForGroups(),
                    id: groupItem.id,
                    updateItem: (group)=>({
                            ...group,
                            totalCount: group.totalCount !== undefined ? Math.max(0, group.totalCount - 1) : undefined
                        })
                });
            }
        };
        const getGroupIssueId = (issueId)=>{
            if ((0, (0, parcelRequire("jDUax")).isGroupItem)(issueId)) return issueId;
            const parentId = getParentOfIssueIfExist ? getParentOfIssueIfExist(issueId) : undefined;
            if (!parentId) return null;
            if ((0, (0, parcelRequire("jDUax")).isGroupItem)(parentId)) return parentId;
            return getGroupIssueId(parentId);
        };
        const isChildIssueInGroup = (group, childIssueId)=>group.children?.some((issue)=>issue.issueId === childIssueId);
        const addToGroupCache = (items, { updateCountOnly: updateCountOnly = false } = {
            updateCountOnly: false
        })=>{
            items.forEach((item)=>{
                const { isReparenting: isReparenting, currentParent: currentParent, prevParent: prevParent } = getReparentingInfo(item);
                const currentGroupIssueId = prevParent ? getGroupIssueId(prevParent) : undefined;
                const nextGroup = findItemGroup(item);
                if (currentGroupIssueId != null && !updateCountOnly) removeItemFromCache(item, currentGroupIssueId);
                if (nextGroup != null) {
                    const shouldAddToCache = canUpdateGroupCache(nextGroup.issueId) && !updateCountOnly;
                    if (shouldAddToCache) {
                        addToCache({
                            newNodes: [
                                item
                            ],
                            query: query,
                            variables: createVariablesForGroupItem(nextGroup.issueId)
                        });
                        updateIssueParentMap(item.issueId);
                    }
                    const newGrandParentId = currentParent ? getParentOfIssueIfExist(currentParent) : undefined;
                    if (currentParent && isReparenting && newGrandParentId) updateItemsInCache({
                        query: query,
                        variables: (0, (0, parcelRequire("jDUax")).isGroupItem)(newGrandParentId) ? createVariablesForGroupItem(newGrandParentId) : createVariablesForItemWithParent(newGrandParentId),
                        issueIds: [
                            currentParent
                        ],
                        updateItem: (existingIssue)=>{
                            const updatedIssueWithNewChild = onUpdateParentWithNewChild(existingIssue, item);
                            return updatedIssueWithNewChild;
                        }
                    });
                    else updateGroupItemInCache({
                        query: groupsQuery,
                        variables: createVariablesForGroups(),
                        id: nextGroup.id,
                        updateItem: (group)=>({
                                ...group,
                                totalCount: group.totalCount !== undefined ? Math.max(0, group.totalCount + 1) : undefined
                            })
                    });
                } else {
                    const newGroup = createItemGroup(item);
                    if (newGroup != null) addGroupItemToCache({
                        query: groupsQuery,
                        variables: createVariablesForGroups(),
                        newNodes: [
                            newGroup
                        ]
                    });
                }
            });
        };
        const removeFromGroupCache = (items)=>{
            items.forEach((item)=>{
                const prevParent = getPrevParentOfIssueIfExists(String(item.issueId));
                const currentGroupIssueId = prevParent ? getGroupIssueId(prevParent) : undefined;
                if (currentGroupIssueId != null) removeItemFromCache(item, currentGroupIssueId);
            });
        };
        return {
            addToCache: addToGroupCache,
            removeFromCache: removeFromGroupCache
        };
    };
});
parcelRegister("evzMt", function(module, exports) {
    $parcel$export(module.exports, "useIssueParentMap", ()=>$87691c8b875de259$export$103bc684cb3b9090);
    var $3sQ5x;
    var $iXqE5;
    const $87691c8b875de259$var$actions = {
        setIssueParentMap: (issueParentMap)=>({ setState: setState, getState: getState })=>setState({
                    ...getState(),
                    issueParentMap: issueParentMap
                })
    };
    const $87691c8b875de259$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: {
            issueParentMap: new Map()
        },
        actions: $87691c8b875de259$var$actions,
        name: 'JWMTimelineViewIssueParentMapStore'
    });
    const $87691c8b875de259$export$103bc684cb3b9090 = (0, (0, parcelRequire("3sQ5x")).createHook)($87691c8b875de259$var$Store);
});
parcelRegister("cl738", function(module, exports) {
    $parcel$export(module.exports, "useIssuesMap", ()=>$ed20c672d5d336f8$export$d5c966ec437d4fa9);
    var $3sQ5x;
    var $iXqE5;
    const $ed20c672d5d336f8$export$e324594224ef24da = {
        setIssuesMap: (issuesMap)=>({ setState: setState, getState: getState })=>setState({
                    ...getState(),
                    issuesMap: issuesMap
                })
    };
    const $ed20c672d5d336f8$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: {
            issuesMap: new Map()
        },
        actions: $ed20c672d5d336f8$export$e324594224ef24da,
        name: 'JWMTimelineViewIssuesMapStore'
    });
    const $ed20c672d5d336f8$export$d5c966ec437d4fa9 = (0, (0, parcelRequire("3sQ5x")).createHook)($ed20c672d5d336f8$var$Store);
});
parcelRegister("b4BqL", function(module, exports) {
    $parcel$export(module.exports, "ExpandCollapseAllController", ()=>$9287d1d14347d1a9$export$8f00a40f797e641c);
    var $5uXOq = parcelRequire("5uXOq");
    var $9pdbW;
    var $g5X3G;
    var $iNLbM;
    var $dnpKx;
    const $9287d1d14347d1a9$var$issueHasChildren = (issue)=>issue.childItems && issue.childItems.length > 0;
    const $9287d1d14347d1a9$export$8f00a40f797e641c = ()=>{
        const [{ childrenQueryData: childrenQueryData, expandedItems: expandedItems }, { setIssueExpanded: setIssueExpanded, clearExpandedItems: clearExpandedItems }] = (0, (0, parcelRequire("iNLbM")).useHierarchyStore)();
        const handleCollapseAllItems = (0, $5uXOq.useCallback)(()=>{
            clearExpandedItems();
        }, [
            clearExpandedItems
        ]);
        const [{ shouldExpandAllItems: shouldExpandAllItems }, { setHasExpandedAllItems: setHasExpandedAllItems, setHasCollapsedAllItems: setHasCollapsedAllItems, disableExpandCollapseAllItems: disableExpandCollapseAllItems }] = (0, (0, parcelRequire("9pdbW")).useExpandCollapseAllItems)({
            view: 'timeline',
            onCollapse: handleCollapseAllItems
        });
        const { flattenedItems: flattenedItems } = (0, (0, parcelRequire("dnpKx")).useTimelineViewIssues)({
            childrenQueryData: childrenQueryData,
            expandedItems: expandedItems
        });
        (0, $5uXOq.useEffect)(()=>{
            disableExpandCollapseAllItems();
        }, [
            disableExpandCollapseAllItems
        ]);
        const handleExpandAllItems = (0, $5uXOq.useCallback)(()=>{
            if (shouldExpandAllItems) flattenedItems.forEach((item)=>{
                const isIssueExpanded = expandedItems[(0, (0, parcelRequire("g5X3G")).toIssueId)(item.id)] === true;
                const hasChildren = $9287d1d14347d1a9$var$issueHasChildren(item);
                if (hasChildren && !isIssueExpanded) setIssueExpanded((0, (0, parcelRequire("g5X3G")).toIssueId)(item.id), true);
            });
        }, [
            expandedItems,
            flattenedItems,
            setIssueExpanded,
            shouldExpandAllItems
        ]);
        const hasNestedItems = (0, $5uXOq.useMemo)(()=>flattenedItems.some((item)=>$9287d1d14347d1a9$var$issueHasChildren(item)), [
            flattenedItems
        ]);
        const hasExpandedAllItems = (0, $5uXOq.useMemo)(()=>{
            const checkItemsExpanded = (item)=>{
                if (!$9287d1d14347d1a9$var$issueHasChildren(item)) return true;
                const isExpanded = expandedItems[(0, (0, parcelRequire("g5X3G")).toIssueId)(item.id)] === true;
                if (isExpanded) return !!item.childItems?.every((child)=>checkItemsExpanded(child));
                return shouldExpandAllItems;
            };
            return hasNestedItems && flattenedItems.every((item)=>checkItemsExpanded(item));
        }, [
            expandedItems,
            flattenedItems,
            hasNestedItems,
            shouldExpandAllItems
        ]);
        const hasCollapsedAllItems = (0, $5uXOq.useMemo)(()=>hasNestedItems && flattenedItems.every((item)=>expandedItems[(0, (0, parcelRequire("g5X3G")).toIssueId)(item.id)] !== true), [
            expandedItems,
            flattenedItems,
            hasNestedItems
        ]);
        (0, $5uXOq.useEffect)(()=>{
            setHasExpandedAllItems(hasExpandedAllItems);
        }, [
            hasExpandedAllItems,
            setHasExpandedAllItems
        ]);
        (0, $5uXOq.useEffect)(()=>{
            setHasCollapsedAllItems(hasCollapsedAllItems);
        }, [
            hasCollapsedAllItems,
            setHasCollapsedAllItems
        ]);
        (0, $5uXOq.useEffect)(()=>{
            handleExpandAllItems();
        }, [
            handleExpandAllItems
        ]);
        return null;
    };
});
parcelRegister("iNLbM", function(module, exports) {
    $parcel$export(module.exports, "useHierarchyStore", ()=>$944b44be5c5b7a2c$export$2fc259d06066fab6);
    var $3sQ5x;
    var $iXqE5;
    const $944b44be5c5b7a2c$var$getInitialState = ()=>({
            childrenQueryData: {},
            expandedItems: {}
        });
    const $944b44be5c5b7a2c$var$initialState = $944b44be5c5b7a2c$var$getInitialState();
    const $944b44be5c5b7a2c$var$setChildrenQueryData = (issueId, newData)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            const prevChildrenQueryData = state.childrenQueryData;
            setState({
                ...state,
                childrenQueryData: {
                    ...prevChildrenQueryData,
                    [issueId]: newData
                }
            });
        };
    const $944b44be5c5b7a2c$var$setIssueExpanded = (issueId, isExpanded)=>({ setState: setState, getState: getState })=>{
            const state = getState();
            const prevExpandedItems = state.expandedItems;
            setState({
                ...state,
                expandedItems: {
                    ...prevExpandedItems,
                    [issueId]: isExpanded
                }
            });
        };
    const $944b44be5c5b7a2c$var$clearExpandedItems = ()=>({ setState: setState, getState: getState })=>{
            const state = getState();
            setState({
                ...state,
                expandedItems: {}
            });
        };
    const $944b44be5c5b7a2c$var$actions = {
        setChildrenQueryData: $944b44be5c5b7a2c$var$setChildrenQueryData,
        setIssueExpanded: $944b44be5c5b7a2c$var$setIssueExpanded,
        clearExpandedItems: $944b44be5c5b7a2c$var$clearExpandedItems
    };
    const $944b44be5c5b7a2c$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: $944b44be5c5b7a2c$var$initialState,
        actions: $944b44be5c5b7a2c$var$actions,
        name: 'TimelineHierarchyStore'
    });
    const $944b44be5c5b7a2c$export$2fc259d06066fab6 = (0, (0, parcelRequire("3sQ5x")).createHook)($944b44be5c5b7a2c$var$Store);
});
parcelRegister("dnpKx", function(module, exports) {
    $parcel$export(module.exports, "useTimelineViewIssues", ()=>$771e841f83ca1590$export$66a1bd5ceb40f186);
    var $5uXOq = parcelRequire("5uXOq");
    var $daQYX;
    var $1T2vX;
    var $kRkJF;
    var $1T1ir;
    var $6eSqc;
    var $5VgIi;
    var $4R6GH;
    var $pa9q9;
    var $8zOmE;
    var $lwMsT;
    var $dAmbh;
    var $jrO9m;
    var $dxCvy;
    var $g5X3G;
    var $2YP9W;
    var $gNAqw;
    var $evzMt;
    var $cl738;
    var $6qNs0;
    var $hfFPh;
    var $2qV0a;
    var $1lN06;
    var $4d1Nl;
    var $2wjBl;
    var $6js85;
    const $771e841f83ca1590$var$SUBTASK_LEVEL = -1;
    const $771e841f83ca1590$export$529ba515dbd4b5b9 = {
        type: 'error',
        title: (0, (0, parcelRequire("4d1Nl")).default).loadingItemsErrorTitle,
        description: (0, (0, parcelRequire("4d1Nl")).default).loadingItemsErrorDescription
    };
    const $771e841f83ca1590$var$RANK_ERROR_FLAG = {
        type: 'error',
        title: (0, (0, parcelRequire("4d1Nl")).default).rankingErrorTitle,
        description: (0, (0, parcelRequire("4d1Nl")).default).rankingErrorMessage
    };
    const $771e841f83ca1590$export$66a1bd5ceb40f186 = ({ childrenQueryData: childrenQueryData = {}, expandedItems: expandedItems } = {})=>{
        const { hierarchyLevelsWithCache: hierarchyLevelsWithCache } = (0, (0, parcelRequire("6eSqc")).useHierarchyCache)({
            view: 'timeline'
        });
        const isLinkingEnabled = (0, (0, parcelRequire("dAmbh")).useIsLinkingEnabled)();
        const [{ issuesMap: issuesMap }] = (0, (0, parcelRequire("cl738")).useIssuesMap)();
        const [{ issueParentMap: issueParentMap }] = (0, (0, parcelRequire("evzMt")).useIssueParentMap)();
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagService)();
        const [{ createItemAnchor: createItemAnchor }] = (0, (0, parcelRequire("1lN06")).useCreateItemAnchor)();
        const { quickFiltersJql: quickFiltersJql, hierarchyParent: hierarchyParent, isFiltering: isFiltering, jqlContext: jqlContext } = (0, (0, parcelRequire("kRkJF")).useFilteredViewContextInput)({
            view: 'timeline'
        });
        const { isSearching: isSearching } = (0, (0, parcelRequire("1T1ir")).useSimpleSearchJQL)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const { data: overview } = (0, (0, parcelRequire("jrO9m")).useOverview)();
        const isOverview = overview != null && Array.isArray(overview.projects);
        const issueFields = (0, (0, parcelRequire("1T2vX")).useIssueTypesAndFields)({
            issueOperation: 'VIEW'
        });
        const projectContext = (0, (0, parcelRequire("2YP9W")).useResource)((0, (0, parcelRequire("dxCvy")).projectContextResource));
        const onComplete = (0, $5uXOq.useCallback)(()=>{
            if (isSearching) (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'timelineSimpleSearchQuery succeeded');
        }, [
            createAnalyticsEvent,
            isSearching
        ]);
        let projectKey;
        if (!isOverview && (0, (0, parcelRequire("4R6GH")).fg)('timeline-uses-new-jql-parent-project-directive')) {
            const { key: key } = (0, (0, parcelRequire("daQYX")).useProject)();
            projectKey = key;
        }
        const { data: timelineViewIssuesData, loadNextPage: loadNextPage, loading: issuesLoading, isLoadingNextPage: isLoadingNextPage, updateInCache: updateInCacheTopLevel, rankIssue: rankIssueTopLevel, updateItemsInCache: updateItemsInCacheTopLevel, error: error } = (0, (0, parcelRequire("hfFPh")).useTimelineViewIssues)({
            input: {
                jqlContext: jqlContext,
                fieldIds: (0, parcelRequire("gNAqw")).fieldIds,
                quickFiltersJql: quickFiltersJql,
                hierarchyParent: hierarchyParent,
                hierarchyLevel: hierarchyLevelsWithCache[0]?.level,
                ...projectKey ? {
                    projectIdOrKey: projectKey
                } : {}
            },
            onComplete: onComplete
        });
        const { updateIssueParent: reparentIssue, unlinkParentIssue: unlinkParentIssue } = (0, (0, parcelRequire("5VgIi")).useUpdateIssueParent)({
            childrenQueryData: childrenQueryData,
            fieldIds: (0, parcelRequire("gNAqw")).fieldIds,
            issueParentMap: issueParentMap,
            issuesMap: issuesMap,
            cacheQuery: (0, (0, parcelRequire("6qNs0")).TIMELINE_VIEW_ITEMS_QUERY),
            addChildToParent: (0, (0, parcelRequire("2qV0a")).addChildToParentTimeline),
            view: 'timeline',
            packageName: 'jiraBusinessTimeline',
            ...projectKey ? {
                projectKey: projectKey
            } : {}
        });
        (0, $5uXOq.useEffect)(()=>{
            if (error) showFlag($771e841f83ca1590$export$529ba515dbd4b5b9);
        }, [
            showFlag,
            error
        ]);
        const data = (0, (0, parcelRequire("6js85")).toTimelineData)({
            timelineViewIssuesData: timelineViewIssuesData,
            childrenQueryData: childrenQueryData,
            expandedItems: expandedItems,
            createItemAnchor: createItemAnchor,
            issuesMap: issuesMap,
            issueParentMap: issueParentMap,
            isLinkingEnabled: isLinkingEnabled,
            isFiltering: isFiltering,
            isOverview: isOverview
        });
        const updateInCache = (0, $5uXOq.useCallback)((params)=>{
            const updatedIssueParentIssueId = issueParentMap.get(params.id);
            if (updatedIssueParentIssueId === undefined) {
                updateInCacheTopLevel(params);
                return;
            }
            if (childrenQueryData[updatedIssueParentIssueId]) childrenQueryData[updatedIssueParentIssueId].updateInCache(params);
        }, [
            childrenQueryData,
            issueParentMap,
            updateInCacheTopLevel
        ]);
        const updateItemsInCache = (0, $5uXOq.useCallback)((params)=>{
            const firstIssue = params[0];
            const updatedIssueParentIssueId = issueParentMap.get(firstIssue.id);
            if (updatedIssueParentIssueId === undefined) {
                updateItemsInCacheTopLevel(params);
                return;
            }
            if (childrenQueryData[updatedIssueParentIssueId]) childrenQueryData[updatedIssueParentIssueId].updateItemsInCache(params);
        }, [
            childrenQueryData,
            issueParentMap,
            updateItemsInCacheTopLevel
        ]);
        const rankIssue = (0, $5uXOq.useCallback)((id, { rankRequest: rankRequest }, event, skipUpdateCache)=>{
            if (!rankRequest) {
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(event, 'rankIssue invalidRequest');
                return;
            }
            const updatedIssueParentIssueId = issueParentMap.get(id);
            const relativeIssueId = rankRequest.rankAfterId || rankRequest.rankBeforeId;
            const relativeIssue = issuesMap.get(relativeIssueId);
            if (!relativeIssue) {
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(event, 'rankIssue invalidRequest', {
                    relativeIssue: relativeIssueId
                });
                showFlag($771e841f83ca1590$var$RANK_ERROR_FLAG);
                return;
            }
            const params = {
                issueId: id,
                relativeIssue: relativeIssue,
                skipUpdateCache: skipUpdateCache,
                rankCall: rankRequest.rankBeforeId ? 'rankBefore' : 'rankAfter'
            };
            if (updatedIssueParentIssueId === undefined) {
                rankIssueTopLevel(params);
                return;
            }
            if (childrenQueryData[updatedIssueParentIssueId]) childrenQueryData[updatedIssueParentIssueId].rankIssue(params);
        }, [
            issueParentMap,
            issuesMap,
            childrenQueryData,
            showFlag,
            rankIssueTopLevel
        ]);
        const updateIssueParent = (0, $5uXOq.useCallback)(async (id, payload, event)=>{
            const { parentId: parentId, rankRequest: rankRequest, level: level, isMeatballsAction: isMeatballsAction } = payload;
            const parentIssue = parentId ? issuesMap.get(parentId) : undefined;
            const parentIdOld = issueParentMap.get(id);
            if (level === $771e841f83ca1590$var$SUBTASK_LEVEL && !parentId) return;
            if (!parentId) await unlinkParentIssue({
                issueKey: id,
                rankRequest: rankRequest
            });
            else {
                if (parentIdOld === parentId) return;
                if (!parentIssue) {
                    (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(event, 'reparent invalidRequest', {
                        parentId: parentId
                    });
                    return;
                }
                await reparentIssue({
                    issueKey: id,
                    parentIssue: parentIssue,
                    rankRequest: rankRequest,
                    ...(0, (0, parcelRequire("4R6GH")).fg)('jwm_timeline_meatball_reparent_menu') ? {
                        isMeatballsAction: isMeatballsAction
                    } : {}
                });
            }
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'timelineDragAndDrop reparent', {
                action: (0, (0, parcelRequire("2wjBl")).getReparentAction)(parentId, parentIdOld),
                isRanking: !!rankRequest,
                hierarchyLevel: level,
                parentHierarchyLevel: parentIssue?.issueType?.hierarchyLevel,
                ...(0, (0, parcelRequire("4R6GH")).fg)('jwm_timeline_meatball_reparent_menu') ? {
                    isMeatballsAction: isMeatballsAction
                } : {}
            });
            if (rankRequest) rankIssue(id, payload, event, true);
        }, [
            createAnalyticsEvent,
            issueParentMap,
            issuesMap,
            rankIssue,
            reparentIssue,
            unlinkParentIssue
        ]);
        const flattenItems = (0, $5uXOq.useCallback)((items)=>{
            if (!items) return [];
            return items.flatMap((item)=>{
                const isExpanded = expandedItems[(0, (0, parcelRequire("g5X3G")).toIssueId)(item.id)];
                const children = isExpanded ? flattenItems(item.childItems) : [];
                return [
                    item,
                    ...children
                ];
            });
        }, [
            expandedItems
        ]);
        const flattenedItems = (0, $5uXOq.useMemo)(()=>flattenItems(data?.items), [
            data?.items,
            flattenItems
        ]);
        const issueIds = (0, $5uXOq.useMemo)(()=>{
            return Array.from(data.issuesMap.keys());
        }, [
            data
        ]);
        const issuesHash = (0, $5uXOq.useMemo)(()=>{
            const issuesParentMap = data.issueParentMap;
            const issueHashReturn = {};
            data.issuesMap.forEach((value, key)=>{
                issueHashReturn[key] = {
                    id: value.id,
                    issueId: value.issueId,
                    key: value.key,
                    rank: value.rank,
                    issueType: value.issueType,
                    hasChildren: value.hasChildren,
                    status: value.status,
                    summary: {
                        value: value.summary
                    },
                    startDate: {
                        value: value.startDate
                    },
                    dueDate: {
                        value: value.dueDate
                    },
                    assignee: value.assignee?.accountId,
                    issueTypeId: value.issueType.id,
                    flagged: false,
                    color: {
                        value: 'GREY'
                    }
                };
                const parentId = {
                    value: issuesParentMap.has(key) ? issuesParentMap.get(key) : undefined
                };
                issueHashReturn[key] = {
                    ...issueHashReturn[key],
                    parentId: parentId
                };
            });
            return issueHashReturn;
        }, [
            data
        ]);
        const userDisplayNameHash = (0, $5uXOq.useMemo)(()=>{
            const displayNameHash = {};
            data.issuesMap.forEach((value)=>{
                if (value.assignee) displayNameHash[value.assignee.accountId] = value.assignee.displayName;
            });
            return displayNameHash;
        }, [
            data
        ]);
        const issueTypesHash = (0, $5uXOq.useMemo)(()=>{
            const issueTypes = {};
            data.issuesMap.forEach((value)=>{
                const type = value.issueType;
                if (!issueTypes[type.id]) issueTypes[type.id] = {
                    name: type.name,
                    iconUrl: type.iconUrl
                };
            });
            return issueTypes;
        }, [
            data
        ]);
        const issueFieldsHash = (0, $5uXOq.useMemo)(()=>{
            const { data: { fields: fields } } = issueFields;
            const fieldsHash = {
                issuekey: 'Key',
                parent: 'Parent'
            };
            fields.forEach((field)=>{
                fieldsHash[field.id] = field.name;
            });
            return fieldsHash;
        }, [
            issueFields
        ]);
        const projectName = (0, $5uXOq.useMemo)(()=>projectContext?.data?.projectName || 'Untitled project', [
            projectContext
        ]);
        return {
            loading: issuesLoading,
            error: error,
            data: data,
            loadNextPage: loadNextPage,
            isLoadingNextPage: isLoadingNextPage,
            updateInCache: updateInCache,
            rankIssue: rankIssue,
            updateItemsInCache: updateItemsInCache,
            isLinkingEnabled: isLinkingEnabled,
            updateIssueParent: updateIssueParent,
            flattenedItems: flattenedItems,
            csvProps: {
                issueIds: issueIds,
                issuesHash: issuesHash,
                userDisplayNameHash: userDisplayNameHash,
                issueTypesHash: issueTypesHash,
                issueFields: issueFieldsHash,
                projectName: projectName,
                startDateCustomFieldId: 'Start date',
                hasInferredStartDueDateFields: false
            }
        };
    };
});
parcelRegister("6eSqc", function(module, exports) {
    $parcel$export(module.exports, "useHierarchyCache", ()=>$bd31eaa7cf3733ec$export$c2cd1510e81d00ce);
    var $5uXOq = parcelRequire("5uXOq");
    var $ajpes = parcelRequire("ajpes");
    var $54qG5;
    var $1T2vX;
    var $ae0ja;
    const $bd31eaa7cf3733ec$export$c2cd1510e81d00ce = ({ view: view })=>{
        const { loading: loading, error: error, hierarchyLevels: newHierarchyLevels } = (0, (0, parcelRequire("1T2vX")).useIssueTypesAndFields)({
            issueOperation: 'VIEW'
        });
        const { data: entity } = (0, (0, parcelRequire("54qG5")).useBusinessEntity)();
        const localStorage = (0, (0, parcelRequire("ae0ja")).getLocalStorage)(view);
        const hierarchyStorageKey = `${entity.id}_${(0, $17d9937555b623d9$export$2cab30374aa79c41)}`;
        const [hierarchyLevels, setHierarchyLevels] = (0, $5uXOq.useState)(localStorage.get(hierarchyStorageKey));
        (0, $5uXOq.useEffect)(()=>{
            if (!loading && !error) {
                if (!(0, ($parcel$interopDefault($ajpes)))(hierarchyLevels, newHierarchyLevels)) {
                    setHierarchyLevels(newHierarchyLevels);
                    localStorage.set(hierarchyStorageKey, newHierarchyLevels);
                }
            }
        }, [
            loading,
            error,
            hierarchyLevels,
            hierarchyStorageKey,
            setHierarchyLevels,
            localStorage,
            newHierarchyLevels
        ]);
        const hierarchyLevelsWithCache = (0, $5uXOq.useMemo)(()=>{
            if (hierarchyLevels && Array.isArray(hierarchyLevels)) return hierarchyLevels;
            if (loading) return [];
            return newHierarchyLevels;
        }, [
            hierarchyLevels,
            loading,
            newHierarchyLevels
        ]);
        return {
            hierarchyLevelsWithCache: hierarchyLevelsWithCache
        };
    };
});
const $17d9937555b623d9$export$2cab30374aa79c41 = 'hierarchy_levels';
parcelRegister("ae0ja", function(module, exports) {
    $parcel$export(module.exports, "getLocalStorage", ()=>$d865db96ae8c3b63$export$d3720feff416e85b);
    var $bSSG7;
    const $d865db96ae8c3b63$export$d3720feff416e85b = (view)=>(0, (0, parcelRequire("bSSG7")).createLocalStorageProvider)(`jira_business_${view}-view`);
});
parcelRegister("5VgIi", function(module, exports) {
    $parcel$export(module.exports, "useUpdateIssueParent", ()=>$31f00dbe71d3540f$export$346cb12ae0ad6251);
    var $5uXOq = parcelRequire("5uXOq");
    var $egmQO;
    var $1T2vX;
    var $cm8b5;
    var $kRkJF;
    var $dqDis;
    var $jcw0u;
    var $6s1PB;
    var $4R6GH;
    var $pa9q9;
    var $5fc53;
    var $hlKA4;
    var $eVIe2;
    var $cM59n;
    var $4KWeK;
    var $keaDy;
    const $31f00dbe71d3540f$export$346cb12ae0ad6251 = ({ childrenQueryData: childrenQueryData = {}, fieldIds: fieldIds, issueParentMap: issueParentMap, issuesMap: issuesMap, cacheQuery: cacheQuery, addChildToParent: addChildToParent, removeChildFromParent: removeChildFromParent, view: view, packageName: packageName, shouldOnlyUpdateCache: shouldOnlyUpdateCache = false, projectKey: projectKey })=>{
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagService)();
        const { hierarchyLevels: hierarchyLevels } = (0, (0, parcelRequire("1T2vX")).useIssueTypesAndFields)({
            issueOperation: 'VIEW'
        });
        const { quickFiltersJql: quickFiltersJql, hierarchyParent: hierarchyParent, jqlContext: jqlContext, isHidingDoneItems: isHidingDoneItems } = (0, (0, parcelRequire("kRkJF")).useFilteredViewContextInput)({
            view: view
        });
        const { addToCache: addToCache, getCachedIssueById: getCachedIssueById, removeFromCache: removeFromCache, updateItemsInCache: updateItemsInCache } = (0, (0, parcelRequire("hlKA4")).useCacheActions)();
        const [newParentIssue, setNewParentIssue] = (0, $5uXOq.useState)();
        const [reparentIssue, setReparentIssue] = (0, $5uXOq.useState)();
        const [optimisticRank, setOptimisticRank] = (0, $5uXOq.useState)('');
        const shouldAddToCache = (0, $5uXOq.useRef)(false);
        const [revertData, setRevertData] = (0, $5uXOq.useState)(null);
        const updateParentIssueExperience = (0, (0, parcelRequire("4KWeK")).getUpdateParentIssueExperience)(packageName);
        const startExperience = (0, (0, parcelRequire("cm8b5")).useExperienceStart)(updateParentIssueExperience);
        const markExperienceSuccess = (0, (0, parcelRequire("cm8b5")).useExperienceSuccess)(updateParentIssueExperience);
        const markExperienceFailed = (0, (0, parcelRequire("cm8b5")).useExperienceFail)(updateParentIssueExperience);
        const updateIssueField = (0, (0, parcelRequire("cM59n")).useUpdateIssueField)({
            onSuccess: ()=>{
                markExperienceSuccess();
            },
            onError: (error)=>{
                if (error.statusCode === 400) showFlag((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("4KWeK")).UPDATE_ITEM_PARENT_FAIL_400_FLAG_WITH_ISSUE_TERM) : (0, (0, parcelRequire("4KWeK")).UPDATE_ITEM_PARENT_FAIL_400_FLAG));
                else if (error.statusCode === 404) showFlag((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("4KWeK")).UPDATE_ITEM_PARENT_FAIL_404_FLAG_WITH_ISSUE_TERM) : (0, (0, parcelRequire("4KWeK")).UPDATE_ITEM_PARENT_FAIL_404_FLAG));
                else {
                    showFlag((0, (0, parcelRequire("4KWeK")).UPDATE_ITEM_PARENT_FAIL_GENERIC_FLAG));
                    markExperienceFailed('update issue parent failed', error);
                }
                throw error;
            }
        });
        const getRankPosition = (0, $5uXOq.useCallback)((rankRequest)=>{
            if (!rankRequest) return;
            const relativeIssueId = rankRequest.rankAfterId || rankRequest.rankBeforeId;
            if (relativeIssueId) {
                const relativeIssue = issuesMap.get(relativeIssueId);
                const relativeIssueRank = rankRequest.rankPosition || relativeIssue?.rank;
                if (relativeIssueRank) {
                    const { rankBeforeId: rankBeforeId } = rankRequest;
                    return rankBeforeId ? (0, (0, parcelRequire("dqDis")).getPreviousRank)(relativeIssueRank) : (0, (0, parcelRequire("dqDis")).getNextRank)(relativeIssueRank);
                }
            }
        }, [
            issuesMap
        ]);
        const getVariablesInput = (0, $5uXOq.useCallback)((parentId)=>{
            const defaultVariableInput = {
                jqlContext: jqlContext,
                fieldIds: fieldIds,
                quickFiltersJql: quickFiltersJql,
                isHidingDoneItems: isHidingDoneItems,
                ...hierarchyLevels !== undefined && {
                    hierarchyLevel: hierarchyLevels[0]?.level
                },
                projectIdOrKey: projectKey
            };
            if (hierarchyParent && parentId) return {
                ...defaultVariableInput,
                hierarchyParent: undefined,
                parentIssue: {
                    hierarchyType: hierarchyParent,
                    issueId: parentId
                }
            };
            return {
                ...defaultVariableInput,
                hierarchyParent: hierarchyParent
            };
        }, [
            jqlContext,
            fieldIds,
            quickFiltersJql,
            isHidingDoneItems,
            hierarchyLevels,
            projectKey,
            hierarchyParent
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (hierarchyParent && newParentIssue && reparentIssue) {
                const { issueId: newParentId, hasChildren: hasChildren, childSummary: childSummary } = newParentIssue;
                if (childrenQueryData[newParentId] && childrenQueryData[newParentId].loading === false) {
                    const grandParentId = issueParentMap?.get(newParentId) ?? newParentIssue?.parentIssueId;
                    if (!hasChildren || typeof childSummary?.totalCount === 'number') updateItemsInCache({
                        query: cacheQuery,
                        variables: (0, (0, parcelRequire("egmQO")).getVariables)(getVariablesInput(grandParentId)),
                        issueIds: [
                            newParentIssue.issueId
                        ],
                        updateItem: (existingIssue)=>addChildToParent(existingIssue)
                    });
                    if ((0, (0, parcelRequire("4R6GH")).fg)('jwm_timeline_meatball_reparent_menu')) {
                        if (shouldAddToCache.current) {
                            const variables = (0, (0, parcelRequire("egmQO")).getVariables)(getVariablesInput(newParentId));
                            const newNode = (0, (0, parcelRequire("keaDy")).generateIssueWithUpdatedParent)(reparentIssue, newParentIssue, view);
                            addToCache({
                                query: cacheQuery,
                                variables: variables,
                                newNodes: [
                                    optimisticRank ? (0, (0, parcelRequire("eVIe2")).getOptimisticRanked)(newNode, optimisticRank) : newNode
                                ]
                            });
                            shouldAddToCache.current = false;
                            setReparentIssue(undefined);
                            setNewParentIssue(undefined);
                            setOptimisticRank('');
                        }
                    } else {
                        const variables = (0, (0, parcelRequire("egmQO")).getVariables)(getVariablesInput(newParentId));
                        const newNode = (0, (0, parcelRequire("keaDy")).generateIssueWithUpdatedParent)(reparentIssue, newParentIssue, view);
                        addToCache({
                            query: cacheQuery,
                            variables: variables,
                            newNodes: [
                                optimisticRank ? (0, (0, parcelRequire("eVIe2")).getOptimisticRanked)(newNode, optimisticRank) : newNode
                            ]
                        });
                        setReparentIssue(undefined);
                        setNewParentIssue(undefined);
                        setOptimisticRank('');
                    }
                }
            }
        }, [
            addToCache,
            childrenQueryData,
            getVariablesInput,
            hierarchyParent,
            isHidingDoneItems,
            jqlContext,
            quickFiltersJql,
            newParentIssue,
            reparentIssue,
            updateItemsInCache,
            getCachedIssueById,
            issueParentMap,
            optimisticRank,
            cacheQuery,
            addChildToParent,
            issuesMap,
            view
        ]);
        const updateIssueParentCache = (0, $5uXOq.useCallback)(({ oldParentId: oldParentId, issueKey: issueKey, parentIssue: parentIssue, isMeatballsAction: isMeatballsAction })=>{
            const variables = (0, (0, parcelRequire("egmQO")).getVariables)(getVariablesInput(oldParentId));
            const issue = getCachedIssueById({
                issueId: issueKey,
                query: cacheQuery,
                variables: variables
            });
            setNewParentIssue(parentIssue);
            if (issue) {
                setReparentIssue(issue);
                if (isMeatballsAction && !(childrenQueryData[parentIssue.issueId] && childrenQueryData[parentIssue.issueId].loading === false) && (0, (0, parcelRequire("4R6GH")).fg)('jwm_timeline_meatball_reparent_menu')) return;
                removeFromCache({
                    query: cacheQuery,
                    variables: variables,
                    issueId: Number(issueKey)
                });
                if ((0, (0, parcelRequire("4R6GH")).fg)('jwm_timeline_meatball_reparent_menu')) {
                    if (childrenQueryData[parentIssue.issueId] && childrenQueryData[parentIssue.issueId].loading === false) {
                        const originalRank = issuesMap.get(String(issueKey))?.rank;
                        const newVariable = (0, (0, parcelRequire("egmQO")).getVariables)(getVariablesInput(parentIssue.issueId));
                        const newNode = (0, (0, parcelRequire("keaDy")).generateIssueWithUpdatedParent)(issue, parentIssue, view);
                        addToCache({
                            query: cacheQuery,
                            variables: newVariable,
                            newNodes: [
                                originalRank ? (0, (0, parcelRequire("eVIe2")).getOptimisticRanked)(newNode, originalRank) : newNode
                            ]
                        });
                    } else shouldAddToCache.current = true;
                }
                if (oldParentId && removeChildFromParent) {
                    const grandParentId = issuesMap.get(oldParentId)?.parentIssueId;
                    const queryVariables = (0, (0, parcelRequire("egmQO")).getVariables)(getVariablesInput(grandParentId));
                    updateItemsInCache({
                        query: cacheQuery,
                        variables: queryVariables,
                        issueIds: [
                            String(oldParentId)
                        ],
                        updateItem: (existingParentIssue)=>removeChildFromParent(existingParentIssue, 1)
                    });
                }
            }
        }, [
            getVariablesInput,
            getCachedIssueById,
            cacheQuery,
            removeFromCache,
            childrenQueryData,
            removeChildFromParent,
            view,
            addToCache,
            issuesMap,
            updateItemsInCache
        ]);
        const unlinkParentIssueCache = (0, $5uXOq.useCallback)(({ issueKey: issueKey, oldParentId: oldParentId, updateRank: updateRank })=>{
            const variables = (0, (0, parcelRequire("egmQO")).getVariables)(getVariablesInput(oldParentId));
            const issue = getCachedIssueById({
                issueId: issueKey,
                query: cacheQuery,
                variables: variables
            });
            removeFromCache({
                query: cacheQuery,
                variables: variables,
                issueId: Number(issueKey)
            });
            if (oldParentId && removeChildFromParent) {
                const grandParentId = issuesMap.get(oldParentId)?.parentIssueId;
                const queryVariables = (0, (0, parcelRequire("egmQO")).getVariables)(getVariablesInput(grandParentId));
                updateItemsInCache({
                    query: cacheQuery,
                    variables: queryVariables,
                    issueIds: [
                        String(oldParentId)
                    ],
                    updateItem: (parentIssue)=>removeChildFromParent(parentIssue, 1)
                });
            }
            const reparentIssueVariable = (0, (0, parcelRequire("egmQO")).getVariables)(getVariablesInput());
            if (issue) {
                const newNode = (0, (0, parcelRequire("keaDy")).generateIssueWithUpdatedParent)(issue, undefined, view);
                addToCache({
                    query: cacheQuery,
                    variables: reparentIssueVariable,
                    newNodes: [
                        updateRank ? (0, (0, parcelRequire("eVIe2")).getOptimisticRanked)(newNode, updateRank) : newNode
                    ]
                });
            }
        }, [
            getVariablesInput,
            getCachedIssueById,
            cacheQuery,
            removeFromCache,
            removeChildFromParent,
            issuesMap,
            updateItemsInCache,
            view,
            addToCache
        ]);
        const revertOptimisticCacheUpdate = (0, $5uXOq.useCallback)(({ originalParentId: originalParentId, parentIssue: parentIssue, issueKey: issueKey, originalRank: originalRank })=>{
            const originalParent = originalParentId && issuesMap.get(originalParentId);
            if (originalParent) updateIssueParentCache({
                oldParentId: parentIssue?.issueId,
                issueKey: issueKey,
                parentIssue: originalParent
            });
            else if (originalRank && parentIssue) unlinkParentIssueCache({
                oldParentId: parentIssue.issueId,
                issueKey: issueKey,
                updateRank: originalRank
            });
        }, [
            issuesMap,
            unlinkParentIssueCache,
            updateIssueParentCache
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (revertData && revertData.parentIssue?.issueId && childrenQueryData[revertData.parentIssue.issueId] && childrenQueryData[revertData.parentIssue.issueId].loading === false) {
                const { originalParentId: originalParentId, parentIssue: parentIssue, issueKey: issueKey, originalRank: originalRank } = revertData;
                originalRank && setOptimisticRank(originalRank);
                revertOptimisticCacheUpdate({
                    originalParentId: originalParentId,
                    parentIssue: parentIssue,
                    issueKey: issueKey,
                    originalRank: originalRank
                });
                setRevertData(null);
            }
        }, [
            childrenQueryData,
            revertData,
            revertOptimisticCacheUpdate
        ]);
        const updateIssueParent = (0, $5uXOq.useCallback)(async ({ issueKey: issueKey, parentIssue: parentIssue, rankRequest: rankRequest, oldParentIssueId: oldParentIssueId, isMeatballsAction: isMeatballsAction })=>{
            !shouldOnlyUpdateCache && startExperience();
            const updateRank = getRankPosition(rankRequest);
            if (updateRank) setOptimisticRank(updateRank);
            const issue = issuesMap.get(String(issueKey));
            const originalRank = issue?.rank;
            const oldParentId = oldParentIssueId ?? issueParentMap?.get(issueKey);
            updateIssueParentCache({
                oldParentId: oldParentId,
                issueKey: issueKey,
                parentIssue: parentIssue,
                isMeatballsAction: isMeatballsAction
            });
            if (shouldOnlyUpdateCache) {
                await Promise.resolve();
                return {
                    updateStatus: (0, (0, parcelRequire("4KWeK")).SUCCEEDED)
                };
            }
            try {
                await updateIssueField({
                    issueKey: issueKey,
                    fieldKey: (0, (0, parcelRequire("5fc53")).PARENT_TYPE),
                    newValue: {
                        id: String(parentIssue.issueId)
                    }
                });
            } catch (error) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: (0, (0, parcelRequire("4KWeK")).ERROR_ID),
                        packageName: (0, (0, parcelRequire("4KWeK")).PACKAGE_NAME),
                        teamName: (0, (0, parcelRequire("4KWeK")).TEAM_NAME)
                    },
                    attributes: {
                        message: 'update issue parent failed',
                        parentLevel: parentIssue?.issueType?.hierarchyLevel,
                        issueLevel: issue?.issueType?.hierarchyLevel,
                        view: view
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
                setRevertData({
                    originalParentId: oldParentId,
                    parentIssue: parentIssue,
                    issueKey: issueKey,
                    originalRank: originalRank
                });
                return {
                    updateStatus: (0, (0, parcelRequire("4KWeK")).FAILED)
                };
            }
            return {
                updateStatus: (0, (0, parcelRequire("4KWeK")).SUCCEEDED)
            };
        }, [
            shouldOnlyUpdateCache,
            startExperience,
            getRankPosition,
            issuesMap,
            issueParentMap,
            updateIssueParentCache,
            updateIssueField,
            view
        ]);
        const unlinkParentIssue = (0, $5uXOq.useCallback)(async ({ issueKey: issueKey, rankRequest: rankRequest, oldParentIssueId: oldParentIssueId })=>{
            !shouldOnlyUpdateCache && startExperience();
            const oldParentId = oldParentIssueId || issueParentMap?.get(issueKey);
            const updateRank = getRankPosition(rankRequest);
            const originalRank = issuesMap.get(String(issueKey))?.rank;
            unlinkParentIssueCache({
                issueKey: issueKey,
                oldParentId: oldParentId,
                updateRank: updateRank
            });
            if (shouldOnlyUpdateCache) {
                await Promise.resolve();
                return {
                    updateStatus: (0, (0, parcelRequire("4KWeK")).SUCCEEDED)
                };
            }
            try {
                await updateIssueField({
                    issueKey: issueKey,
                    fieldKey: (0, (0, parcelRequire("5fc53")).PARENT_TYPE),
                    newValue: {
                        id: null
                    }
                });
            } catch (error) {
                const issue = issuesMap.get(String(issueKey));
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: (0, (0, parcelRequire("4KWeK")).ERROR_ID),
                        packageName: (0, (0, parcelRequire("4KWeK")).PACKAGE_NAME),
                        teamName: (0, (0, parcelRequire("4KWeK")).TEAM_NAME)
                    },
                    attributes: {
                        message: 'unlink issue parent failed',
                        issueLevel: issue?.issueType?.hierarchyLevel,
                        view: view
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
                if (originalRank) {
                    setOptimisticRank(originalRank);
                    revertOptimisticCacheUpdate({
                        originalParentId: oldParentId,
                        issueKey: issueKey
                    });
                }
                return {
                    updateStatus: (0, (0, parcelRequire("4KWeK")).FAILED)
                };
            }
            return {
                updateStatus: (0, (0, parcelRequire("4KWeK")).SUCCEEDED)
            };
        }, [
            shouldOnlyUpdateCache,
            startExperience,
            issueParentMap,
            getRankPosition,
            issuesMap,
            unlinkParentIssueCache,
            updateIssueField,
            view,
            revertOptimisticCacheUpdate
        ]);
        return {
            updateIssueParent: updateIssueParent,
            unlinkParentIssue: unlinkParentIssue
        };
    };
});
parcelRegister("cM59n", function(module, exports) {
    $parcel$export(module.exports, "useUpdateIssueField", ()=>$9bfd5ad22b59743a$export$cc74d3329dbba44d);
    var $5uXOq = parcelRequire("5uXOq");
    var $jcw0u;
    var $99cgx;
    var $8zOmE;
    var $lwMsT;
    const $9bfd5ad22b59743a$var$JWM_ISSUE_FIELD_UPDATE = 'jwmIssueFieldUpdate';
    const $9bfd5ad22b59743a$export$cc74d3329dbba44d = ({ onError: onError, onSuccess: onSuccess })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const updateIssueField = (0, $5uXOq.useCallback)(async ({ issueKey: issueKey, fieldKey: fieldKey, newValue: newValue })=>(0, (0, parcelRequire("99cgx")).defaultSaveField)(issueKey, fieldKey, newValue, '').then((response)=>{
                (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), `${$9bfd5ad22b59743a$var$JWM_ISSUE_FIELD_UPDATE} succeeded`, {
                    field: newValue
                });
                onSuccess && onSuccess();
                return response;
            }).catch((error)=>{
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: $9bfd5ad22b59743a$var$JWM_ISSUE_FIELD_UPDATE,
                        packageName: 'jiraBusinessListHandlers',
                        teamName: 'keystone'
                    },
                    attributes: {
                        message: `${$9bfd5ad22b59743a$var$JWM_ISSUE_FIELD_UPDATE} failed`,
                        field: fieldKey.startsWith('customfield_') ? 'category' : fieldKey
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
                onError && onError(error);
            }), [
            createAnalyticsEvent,
            onError,
            onSuccess
        ]);
        return updateIssueField;
    };
});
parcelRegister("99cgx", function(module, exports) {
    $parcel$export(module.exports, "defaultSaveField", ()=>$2a246664763defba$export$b74e6b7f831f1cb2);
    $parcel$export(module.exports, "defaultSaveFieldById", ()=>$2a246664763defba$export$b2c49aae5d84cced);
    $parcel$export(module.exports, "defaultAddValuesToField", ()=>$2a246664763defba$export$c46c7284cd9c5d3);
    $parcel$export(module.exports, "defaultRemoveValuesFromField", ()=>$2a246664763defba$export$33b78476f5d734b3);
    var $eusud;
    const $2a246664763defba$var$getFieldUpdate = (fieldKey, value)=>({
            fields: {
                [fieldKey]: value
            }
        });
    const $2a246664763defba$export$b74e6b7f831f1cb2 = async (issueKey, fieldKey, newValue, _baseUrl)=>(0, (0, parcelRequire("eusud")).performPutRequest)(`/rest/api/3/issue/${issueKey}/`, {
            body: JSON.stringify($2a246664763defba$var$getFieldUpdate(fieldKey, newValue))
        });
    const $2a246664763defba$export$b2c49aae5d84cced = async (issueKey, fieldKey, newValue, _baseUrl)=>(0, (0, parcelRequire("eusud")).performPutRequest)(`/rest/api/3/issue/${issueKey}/?returnIssue=true`, {
            body: JSON.stringify($2a246664763defba$var$getFieldUpdate(fieldKey, newValue))
        });
    const $2a246664763defba$export$c46c7284cd9c5d3 = async (issueKey, fieldKey, valuesToAdd, _baseUrl)=>{
        const updateParam = {
            update: {
                [fieldKey]: [
                    {
                        operation: 'add',
                        value: valuesToAdd
                    }
                ]
            }
        };
        return (0, (0, parcelRequire("eusud")).performPutRequest)(`/rest/api/3/issue/${issueKey}/`, {
            body: JSON.stringify(updateParam)
        });
    };
    const $2a246664763defba$export$33b78476f5d734b3 = async (issueKey, fieldKey, valuesToRemove, _baseUrl)=>{
        const updateParam = {
            update: {
                [fieldKey]: [
                    {
                        operation: 'remove',
                        value: valuesToRemove
                    }
                ]
            }
        };
        return (0, (0, parcelRequire("eusud")).performPutRequest)(`/rest/api/3/issue/${issueKey}/`, {
            body: JSON.stringify(updateParam)
        });
    };
});
parcelRegister("4KWeK", function(module, exports) {
    $parcel$export(module.exports, "UPDATE_ITEM_PARENT_FAIL_GENERIC_FLAG", ()=>$524da9ace56d1024$export$e80b28191e1d3602);
    $parcel$export(module.exports, "UPDATE_ITEM_PARENT_FAIL_400_FLAG", ()=>$524da9ace56d1024$export$29d372313e7a3d7b);
    $parcel$export(module.exports, "UPDATE_ITEM_PARENT_FAIL_400_FLAG_WITH_ISSUE_TERM", ()=>$524da9ace56d1024$export$a75bfbb3fb2f437c);
    $parcel$export(module.exports, "UPDATE_ITEM_PARENT_FAIL_404_FLAG", ()=>$524da9ace56d1024$export$6a4ca5120f2baf63);
    $parcel$export(module.exports, "UPDATE_ITEM_PARENT_FAIL_404_FLAG_WITH_ISSUE_TERM", ()=>$524da9ace56d1024$export$4cba4bafd925e182);
    $parcel$export(module.exports, "getUpdateParentIssueExperience", ()=>$524da9ace56d1024$export$8f39ff4e40cb6a05);
    $parcel$export(module.exports, "SUCCEEDED", ()=>$524da9ace56d1024$export$11823571c61d4d02);
    $parcel$export(module.exports, "FAILED", ()=>$524da9ace56d1024$export$d71930f7f5807a72);
    $parcel$export(module.exports, "PACKAGE_NAME", ()=>$524da9ace56d1024$export$b8b9d90f9e5bd72b);
    $parcel$export(module.exports, "ERROR_ID", ()=>$524da9ace56d1024$export$f3390a0e172fee41);
    $parcel$export(module.exports, "TEAM_NAME", ()=>$524da9ace56d1024$export$d57b6b390e78d90f);
    var $gqQjF;
    const $524da9ace56d1024$export$e80b28191e1d3602 = {
        type: 'error',
        title: (0, (0, parcelRequire("gqQjF")).default).updateIssueParentErrorTitle,
        description: (0, (0, parcelRequire("gqQjF")).default).updateIssueParentGenericErrorDescription
    };
    const $524da9ace56d1024$export$29d372313e7a3d7b = {
        type: 'error',
        title: (0, (0, parcelRequire("gqQjF")).default).updateIssueParentErrorTitle,
        description: (0, (0, parcelRequire("gqQjF")).default).updateIssueParent400ErrorDescription
    };
    const $524da9ace56d1024$export$a75bfbb3fb2f437c = {
        type: 'error',
        title: (0, (0, parcelRequire("gqQjF")).default).updateIssueParentErrorTitle,
        description: (0, (0, parcelRequire("gqQjF")).default).updateIssueParent400ErrorDescriptionIssueTermRefresh
    };
    const $524da9ace56d1024$export$6a4ca5120f2baf63 = {
        type: 'error',
        title: (0, (0, parcelRequire("gqQjF")).default).updateIssueParentErrorTitle,
        description: (0, (0, parcelRequire("gqQjF")).default).updateIssueParent404ErrorDescription
    };
    const $524da9ace56d1024$export$4cba4bafd925e182 = {
        type: 'error',
        title: (0, (0, parcelRequire("gqQjF")).default).updateIssueParentErrorTitle,
        description: (0, (0, parcelRequire("gqQjF")).default).updateIssueParent404ErrorDescriptionIssueTermRefresh
    };
    const $524da9ace56d1024$export$8f39ff4e40cb6a05 = (packageName)=>({
            experience: 'updateParentIssue',
            packageName: packageName,
            teamName: 'keystone'
        });
    const $524da9ace56d1024$export$11823571c61d4d02 = 'SUCCEEDED';
    const $524da9ace56d1024$export$d71930f7f5807a72 = 'FAILED';
    const $524da9ace56d1024$export$b8b9d90f9e5bd72b = 'jiraBusinessListHandlers';
    const $524da9ace56d1024$export$f3390a0e172fee41 = 'useUpdateIssueParent';
    const $524da9ace56d1024$export$d57b6b390e78d90f = 'keystone';
});
parcelRegister("gqQjF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c0fc83ceaf8c6923$export$2e2bcd8739ae039);
    var $7VHMR;
    var $c0fc83ceaf8c6923$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        updateIssueParentErrorTitle: {
            "id": "business-list-handlers.controllers.update-issue-parent.update-issue-parent-error-title",
            "defaultMessage": "Something's gone wrong"
        },
        updateIssueParentGenericErrorDescription: {
            "id": "business-list-handlers.controllers.update-issue-parent.update-issue-parent-generic-error-description",
            "defaultMessage": "Refresh the page and try again."
        },
        updateIssueParent400ErrorDescription: {
            "id": "business-list-handlers.controllers.update-issue-parent.update-issue-parent-400-error-description",
            "defaultMessage": "You don\u2019t have permission to update this issue. Contact a project admin."
        },
        updateIssueParent404ErrorDescription: {
            "id": "business-list-handlers.controllers.update-issue-parent.update-issue-parent-404-error-description",
            "defaultMessage": "We\u2019re having trouble updating this issue. To continue, refresh the page."
        },
        updateIssueParent400ErrorDescriptionIssueTermRefresh: {
            "id": "business-list-handlers.controllers.update-issue-parent.update-issue-parent-400-error-description-issue-term-refresh",
            "defaultMessage": "You don\u2019t have permission to update this work item. Contact a project admin."
        },
        updateIssueParent404ErrorDescriptionIssueTermRefresh: {
            "id": "business-list-handlers.controllers.update-issue-parent.update-issue-parent-404-error-description-issue-term-refresh",
            "defaultMessage": "We\u2019re having trouble updating this work item. To continue, refresh the page."
        }
    });
});
parcelRegister("keaDy", function(module, exports) {
    $parcel$export(module.exports, "generateIssueWithUpdatedParent", ()=>$2bb42896f508435e$export$2b799a607e235a03);
    var $4R6GH;
    var $5fc53;
    const $2bb42896f508435e$export$32c176d5dc779b09 = (rank)=>rank ? [
            {
                aliasFieldId: 'rank',
                text: rank,
                __typename: 'JiraSingleLineTextField'
            }
        ] : null;
    const $2bb42896f508435e$var$generateParentField = (issueId, key, id, rank, view)=>{
        const shouldHaveIdAttribute = (0, (0, parcelRequire("4R6GH")).fg)('jsw_list_view_-_all_the_fields') && view === 'list';
        return {
            aliasFieldId: null,
            fieldId: (0, (0, parcelRequire("5fc53")).PARENT_TYPE),
            type: (0, (0, parcelRequire("5fc53")).PARENT_TYPE),
            name: 'Parent',
            parentIssue: issueId && key ? {
                __typename: 'JiraIssue',
                issueId: issueId,
                key: key,
                ...shouldHaveIdAttribute ? {
                    id: id
                } : {},
                rankField: $2bb42896f508435e$export$32c176d5dc779b09(rank)
            } : null,
            __typename: 'JiraParentIssueField'
        };
    };
    const $2bb42896f508435e$export$2b799a607e235a03 = (issue, newParentIssue, view)=>{
        const { issueId: newParentIssueId, key: newParentKey, id: newParentId, rank: newParentRank } = newParentIssue || {};
        const parentFieldIndex = issue?.fields?.findIndex((field)=>field.type === (0, (0, parcelRequire("5fc53")).PARENT_TYPE) || field.fieldId === (0, (0, parcelRequire("5fc53")).PARENT_TYPE));
        const shouldHaveIdAttribute = (0, (0, parcelRequire("4R6GH")).fg)('jsw_list_view_-_all_the_fields') && view === 'list';
        const parentField = parentFieldIndex !== -1 && parentFieldIndex !== undefined ? {
            ...issue?.fields?.[parentFieldIndex],
            parentIssue: !newParentIssueId || !newParentKey ? null : {
                ...shouldHaveIdAttribute ? {
                    id: newParentId
                } : {},
                issueId: newParentIssueId,
                rankField: $2bb42896f508435e$export$32c176d5dc779b09(newParentRank),
                key: newParentKey,
                __typename: 'JiraIssue'
            }
        } : $2bb42896f508435e$var$generateParentField(newParentIssueId, newParentKey, newParentId, newParentRank, view);
        return {
            ...issue,
            fields: [
                ...issue?.fields?.filter((field)=>field.type !== (0, (0, parcelRequire("5fc53")).PARENT_TYPE) && field.fieldId !== (0, (0, parcelRequire("5fc53")).PARENT_TYPE)) || [],
                parentField
            ]
        };
    };
});
parcelRegister("4d1Nl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ce728f62834d48f6$export$2e2bcd8739ae039);
    var $7VHMR;
    var $ce728f62834d48f6$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        rankingErrorTitle: {
            "id": "business-timeline.controllers.timeline-view-issues.ranking-error-title",
            "defaultMessage": "Something's gone wrong"
        },
        rankingErrorMessage: {
            "id": "business-timeline.controllers.timeline-view-issues.ranking-error-message",
            "defaultMessage": "Refresh the page and try again."
        },
        loadingItemsErrorTitle: {
            "id": "business-timeline.controllers.timeline-view-issues.loading-items-error-title",
            "defaultMessage": "Timeline items couldn't be retrieved"
        },
        loadingItemsErrorDescription: {
            "id": "business-timeline.controllers.timeline-view-issues.loading-items-error-description",
            "defaultMessage": "Refresh the page and try again."
        }
    });
});
parcelRegister("2wjBl", function(module, exports) {
    $parcel$export(module.exports, "getReparentAction", ()=>$0b6eb926556e8492$export$517f69c641140cf7);
    const $0b6eb926556e8492$export$517f69c641140cf7 = (parentId, parentIdOld)=>{
        if (!parentId) return 'removeParent';
        if (parentIdOld) return 'changeParent';
        return 'addParent';
    };
});
parcelRegister("6js85", function(module, exports) {
    $parcel$export(module.exports, "toTimelineData", ()=>$dfe7fee185d95b59$export$bd4e9db3df8041ab);
    var $dDkmN = parcelRequire("dDkmN");
    var $8QpSo;
    var $cLGgz;
    var $g5X3G;
    var $esmwW;
    var $d8OAB;
    var $gNAqw;
    var $28XgU;
    var $68D2c;
    var $7Cpv0;
    var $8c0Do;
    var $hLy6t;
    var $9D57m;
    const $dfe7fee185d95b59$var$shallowCompare = (newArg, lastArg)=>{
        if (typeof newArg !== 'object' || newArg === null || typeof lastArg !== 'object' || lastArg === null) return newArg === lastArg;
        return Object.keys(newArg).length === Object.keys(lastArg).length && Object.keys(newArg).every((key)=>key in lastArg && newArg[key] === lastArg[key]);
    };
    const $dfe7fee185d95b59$var$getTransformedTimelineData = ({ timelineViewIssuesData: timelineViewIssuesData, childrenQueryData: childrenQueryData, expandedItems: expandedItems, createItemAnchor: createItemAnchor, issuesMap: issuesMap, issueParentMap: issueParentMap, isLinkingEnabled: isLinkingEnabled, isFiltering: isFiltering = false, isOverview: isOverview = false })=>{
        const { issues: issues } = timelineViewIssuesData;
        const rootItemIds = !isOverview ? issues.map((item)=>item.issueId) : [];
        const childIdsHash = {};
        const chartDataHash = {};
        const startDateHash = {};
        const dueDateHash = {};
        const dependenciesHash = {};
        const interactiveChartItems = [];
        issuesMap.clear();
        issueParentMap.clear();
        const convertIssueToInteractiveChartItem = (item, parentId)=>{
            issuesMap.set(item.issueId, item);
            (isLinkingEnabled === true && item.issueLinks || []).forEach((link)=>{
                const { inward: inward, outward: outward } = link;
                const inwardId = inward?.issueId;
                const outwardId = outward?.issueId;
                if (inwardId && inwardId !== item.issueId) dependenciesHash[item.issueId] = (0, ($parcel$interopDefault($dDkmN)))(dependenciesHash[item.issueId], [
                    inwardId
                ]);
                if (outwardId && outwardId !== item.issueId) dependenciesHash[outwardId] = (0, ($parcel$interopDefault($dDkmN)))(dependenciesHash[outwardId], [
                    item.issueId
                ]);
            });
            chartDataHash[item.issueId] = {
                color: (0, (0, parcelRequire("28XgU")).getColor)(item.status?.categoryId),
                ...(0, (0, parcelRequire("9D57m")).transformDates)({
                    startDate: item.startDate,
                    dueDate: item.dueDate
                })
            };
            startDateHash[item.issueId] = item.startDate;
            dueDateHash[item.issueId] = item.dueDate;
            const hasLeftPlaceholder = !item.startDate;
            const hasRightPlaceholder = !item.dueDate;
            return {
                level: parentId ? (0, (0, parcelRequire("gNAqw")).TIMELINE_CHILD_LEVEL) : (0, (0, parcelRequire("gNAqw")).TIMELINE_PARENT_LEVEL),
                id: item.issueId,
                ...(0, (0, parcelRequire("9D57m")).transformDates)({
                    startDate: item.startDate,
                    dueDate: item.dueDate
                }),
                placeholder: (0, (0, parcelRequire("d8OAB")).getPlaceholder)(hasLeftPlaceholder, hasRightPlaceholder),
                startDateType: (0, (0, parcelRequire("esmwW")).EXPLICIT),
                dueDateType: (0, (0, parcelRequire("esmwW")).EXPLICIT),
                intervalId: undefined,
                parentId: parentId
            };
        };
        const createTimelineItem = (item)=>({
                id: (0, (0, parcelRequire("g5X3G")).toIssueId)(item.issueId),
                level: item.issueType.hierarchyLevel,
                isInTransition: (0, (0, parcelRequire("cLGgz")).isOptimisticIssue)(Number(item.issueId)),
                canCreateChildOverride: !(0, (0, parcelRequire("8c0Do")).isSubTaskLevel)(item.issueType.hierarchyLevel),
                childItems: recursivelyPopulateChildItems(item)
            });
        const recursivelyPopulateChildItems = (item)=>{
            if (isFiltering || !item.hasChildren) return undefined;
            const childrenIssuesQueryData = childrenQueryData[item.issueId];
            if (!childIdsHash[item.issueId]) childIdsHash[item.issueId] = [];
            if (!childrenIssuesQueryData || childrenIssuesQueryData.loading) {
                const skeletonChildItem = (0, (0, parcelRequire("hLy6t")).createItemSkeleton)({
                    id: item.issueId,
                    level: item.issueType.hierarchyLevel - 1
                });
                childIdsHash[item.issueId].push(skeletonChildItem.id);
                return [
                    {
                        ...skeletonChildItem,
                        isInTransition: false
                    }
                ];
            }
            return childrenIssuesQueryData.data.issues.reduce((childItems, childIssue)=>{
                childIdsHash[item.issueId].push(childIssue.issueId);
                issueParentMap.set(childIssue.issueId, item.issueId);
                interactiveChartItems.push(convertIssueToInteractiveChartItem(childIssue, item.issueId));
                childItems.push(createTimelineItem(childIssue));
                return childItems;
            }, []);
        };
        let items = [];
        if (!isOverview) items = issues.reduce((acc, item)=>{
            interactiveChartItems.push(convertIssueToInteractiveChartItem(item));
            acc.push(createTimelineItem(item));
            return acc;
        }, []);
        else issues.forEach((item)=>{
            rootItemIds.push(item.issueId);
            const populateChildItems = ()=>{
                if (!isFiltering && item.hasChildren) {
                    const childrenIssuesQueryData = childrenQueryData[item.issueId];
                    if (!childrenIssuesQueryData || childrenIssuesQueryData.loading) {
                        const skeletonChildItem = (0, (0, parcelRequire("hLy6t")).createItemSkeleton)({
                            id: item.issueId,
                            level: (0, (0, parcelRequire("gNAqw")).TIMELINE_CHILD_LEVEL)
                        });
                        return [
                            {
                                id: skeletonChildItem.id,
                                level: (0, (0, parcelRequire("gNAqw")).TIMELINE_CHILD_LEVEL),
                                isInTransition: false
                            }
                        ];
                    }
                    const childItemsNew = [];
                    childrenIssuesQueryData.data.issues.forEach((childIssue)=>{
                        if (!childIdsHash[item.issueId]) childIdsHash[item.issueId] = [];
                        childIdsHash[item.issueId].push(childIssue.issueId);
                        issueParentMap.set(childIssue.issueId, item.issueId);
                        interactiveChartItems.push(convertIssueToInteractiveChartItem(childIssue, item.issueId));
                        childItemsNew.push({
                            id: (0, (0, parcelRequire("g5X3G")).toIssueId)(childIssue.issueId),
                            level: (0, (0, parcelRequire("gNAqw")).TIMELINE_CHILD_LEVEL),
                            isInTransition: (0, (0, parcelRequire("cLGgz")).isOptimisticIssue)(Number(childIssue.issueId)),
                            canCreateChildOverride: false
                        });
                    });
                    return childItemsNew;
                }
                return undefined;
            };
            interactiveChartItems.push(convertIssueToInteractiveChartItem(item));
            const timelineItem = {
                id: (0, (0, parcelRequire("g5X3G")).toIssueId)(item.issueId),
                level: (0, (0, parcelRequire("gNAqw")).TIMELINE_PARENT_LEVEL),
                isInTransition: (0, (0, parcelRequire("cLGgz")).isOptimisticIssue)(Number(item.issueId))
            };
            if (item.issueType.hierarchyLevel >= (0, (0, parcelRequire("gNAqw")).TIMELINE_EPIC_HIERARCHY_LEVEL)) timelineItem.canCreateChildOverride = false;
            else timelineItem.childItems = populateChildItems();
            items.push(timelineItem);
        });
        const positionsHash = (0, (0, parcelRequire("7Cpv0")).getItemOffsetPositions)(rootItemIds, childIdsHash, expandedItems, createItemAnchor);
        const dependencies = isLinkingEnabled === true ? (0, (0, parcelRequire("68D2c")).getDependenciesItems)(positionsHash, chartDataHash, dependenciesHash, startDateHash, dueDateHash) : [];
        return {
            items: items,
            issuesMap: issuesMap,
            issueParentMap: issueParentMap,
            dependencies: dependencies,
            interactiveChartItems: interactiveChartItems
        };
    };
    const $dfe7fee185d95b59$export$bd4e9db3df8041ab = (0, (0, parcelRequire("8QpSo")).default)((params)=>$dfe7fee185d95b59$var$getTransformedTimelineData(params), (newArgs, lastArgs)=>{
        if (newArgs.length !== lastArgs.length) return false;
        const equalityFn = $dfe7fee185d95b59$var$shallowCompare;
        return newArgs.every((newArg, index)=>equalityFn(newArg, lastArgs[index]));
    });
});
parcelRegister("dDkmN", function(module, exports) {
    var $ekcP3 = parcelRequire("ekcP3");
    var $g7i7g = parcelRequire("g7i7g");
    var $7CoLY = parcelRequire("7CoLY");
    var $f3SOL = parcelRequire("f3SOL");
    var $9eceb74c74389aa2$var$union = $g7i7g(function(arrays) {
        return $7CoLY($ekcP3(arrays, 1, $f3SOL, true));
    });
    module.exports = $9eceb74c74389aa2$var$union;
});
parcelRegister("esmwW", function(module, exports) {
    $parcel$export(module.exports, "DATE_FORMAT", ()=>$e415a20509ddf4c7$export$45c85543ba71221d);
    $parcel$export(module.exports, "DATE_FORMAT_MOMENT", ()=>$e415a20509ddf4c7$export$98de7bb6e1f5105c);
    $parcel$export(module.exports, "DUE_DATE_OFFSET", ()=>$e415a20509ddf4c7$export$28c98c2c1f9d90de);
    $parcel$export(module.exports, "INTERVAL", ()=>$e415a20509ddf4c7$export$7dea0e6e08f87a8a);
    $parcel$export(module.exports, "ROLLUP", ()=>$e415a20509ddf4c7$export$e299765c2b7892c0);
    $parcel$export(module.exports, "EXPLICIT", ()=>$e415a20509ddf4c7$export$29c6b89b5966039e);
    const $e415a20509ddf4c7$export$45c85543ba71221d = 'yyyy/MM/dd';
    const $e415a20509ddf4c7$export$98de7bb6e1f5105c = 'yyyy/MM/DD';
    const $e415a20509ddf4c7$export$28c98c2c1f9d90de = (0, $a797a5154a1373bc$export$1f04624003d2da7d) - 1;
    const $e415a20509ddf4c7$export$7dea0e6e08f87a8a = 'INTERVAL';
    const $e415a20509ddf4c7$export$e299765c2b7892c0 = 'ROLLUP';
    const $e415a20509ddf4c7$export$29c6b89b5966039e = 'EXPLICIT';
});
parcelRegister("d8OAB", function(module, exports) {
    $parcel$export(module.exports, "isStartDatePlaceholder", ()=>$ff41fd85b688cb11$export$1673e5e0e5ff398a);
    $parcel$export(module.exports, "isDueDatePlaceholder", ()=>$ff41fd85b688cb11$export$bd9b44c69998322c);
    $parcel$export(module.exports, "getPlaceholderWhileDragging", ()=>$ff41fd85b688cb11$export$97dae3d8f882d620);
    $parcel$export(module.exports, "getPlaceholder", ()=>$ff41fd85b688cb11$export$d3f5c5e0a5023fa0);
    var $15ADj;
    var $2KlaV;
    const $ff41fd85b688cb11$export$1673e5e0e5ff398a = (placeholder)=>placeholder === (0, (0, parcelRequire("15ADj")).START_DATE_PLACEHOLDER) || placeholder === (0, (0, parcelRequire("15ADj")).START_AND_DUE_DATE_PLACEHOLDER);
    const $ff41fd85b688cb11$export$bd9b44c69998322c = (placeholder)=>placeholder === (0, (0, parcelRequire("15ADj")).DUE_DATE_PLACEHOLDER) || placeholder === (0, (0, parcelRequire("15ADj")).START_AND_DUE_DATE_PLACEHOLDER);
    const $ff41fd85b688cb11$export$97dae3d8f882d620 = (dragType, placeholder)=>{
        if (dragType === (0, (0, parcelRequire("2KlaV")).LEFT_AND_RIGHT)) return undefined;
        if (dragType === (0, (0, parcelRequire("2KlaV")).LEFT) && placeholder === (0, (0, parcelRequire("15ADj")).START_DATE_PLACEHOLDER)) return undefined;
        if (dragType === (0, (0, parcelRequire("2KlaV")).RIGHT) && placeholder === (0, (0, parcelRequire("15ADj")).DUE_DATE_PLACEHOLDER)) return undefined;
        if (dragType === (0, (0, parcelRequire("2KlaV")).RIGHT) && placeholder === (0, (0, parcelRequire("15ADj")).START_AND_DUE_DATE_PLACEHOLDER)) return 0, (0, parcelRequire("15ADj")).START_DATE_PLACEHOLDER;
        if (dragType === (0, (0, parcelRequire("2KlaV")).LEFT) && placeholder === (0, (0, parcelRequire("15ADj")).START_AND_DUE_DATE_PLACEHOLDER)) return 0, (0, parcelRequire("15ADj")).DUE_DATE_PLACEHOLDER;
        return placeholder;
    };
    const $ff41fd85b688cb11$export$d3f5c5e0a5023fa0 = (hasLeftPlaceholder, hasRightPlaceholder)=>{
        if (hasLeftPlaceholder && hasRightPlaceholder) return 0, (0, parcelRequire("15ADj")).START_AND_DUE_DATE_PLACEHOLDER;
        if (hasLeftPlaceholder) return 0, (0, parcelRequire("15ADj")).START_DATE_PLACEHOLDER;
        if (hasRightPlaceholder) return 0, (0, parcelRequire("15ADj")).DUE_DATE_PLACEHOLDER;
        return undefined;
    };
});
parcelRegister("15ADj", function(module, exports) {
    $parcel$export(module.exports, "BAR_HEIGHT", ()=>$104fb1be4fcec117$export$4f2f40eb3120c);
    $parcel$export(module.exports, "BASE_BAR_HEIGHT", ()=>$104fb1be4fcec117$export$c8c47b136dc7ac05);
    $parcel$export(module.exports, "MINIMUM_BAR_LENGTH", ()=>$104fb1be4fcec117$export$729e677ca5ac2f4f);
    $parcel$export(module.exports, "DEFAULT_BORDER_RADIUS", ()=>$104fb1be4fcec117$export$f2926bd20425bb0d);
    $parcel$export(module.exports, "LEFT_PLACEHOLDER_BORDER_RADIUS", ()=>$104fb1be4fcec117$export$df860cf23132dfbb);
    $parcel$export(module.exports, "RIGHT_PLACEHOLDER_BORDER_RADIUS", ()=>$104fb1be4fcec117$export$a822ec327ef716a4);
    $parcel$export(module.exports, "LEFT_AND_RIGHT_PLACEHOLDER_BORDER_RADIUS", ()=>$104fb1be4fcec117$export$5b9db862a15e1457);
    $parcel$export(module.exports, "START_DATE_PLACEHOLDER", ()=>$104fb1be4fcec117$export$cfcf3497a5711f2c);
    $parcel$export(module.exports, "DUE_DATE_PLACEHOLDER", ()=>$104fb1be4fcec117$export$42702a43f0325a0c);
    $parcel$export(module.exports, "START_AND_DUE_DATE_PLACEHOLDER", ()=>$104fb1be4fcec117$export$1b72784d953fe9b3);
    var $gwIPs;
    const $104fb1be4fcec117$export$4f2f40eb3120c = (0, (0, parcelRequire("gwIPs")).gridSize) * 3;
    const $104fb1be4fcec117$export$c8c47b136dc7ac05 = (0, (0, parcelRequire("gwIPs")).gridSize) * 2.5;
    const $104fb1be4fcec117$export$729e677ca5ac2f4f = 36;
    const $104fb1be4fcec117$export$f2926bd20425bb0d = `${(0, (0, parcelRequire("gwIPs")).borderRadius)}px`;
    const $104fb1be4fcec117$export$deb313264d4a6a20 = `${(0, (0, parcelRequire("gwIPs")).borderRadius) * 3}px`;
    const $104fb1be4fcec117$export$df860cf23132dfbb = `${$104fb1be4fcec117$export$deb313264d4a6a20} ${$104fb1be4fcec117$export$f2926bd20425bb0d} ${$104fb1be4fcec117$export$f2926bd20425bb0d} ${$104fb1be4fcec117$export$deb313264d4a6a20}`;
    const $104fb1be4fcec117$export$a822ec327ef716a4 = `${$104fb1be4fcec117$export$f2926bd20425bb0d} ${$104fb1be4fcec117$export$deb313264d4a6a20} ${$104fb1be4fcec117$export$deb313264d4a6a20} ${$104fb1be4fcec117$export$f2926bd20425bb0d}`;
    const $104fb1be4fcec117$export$5b9db862a15e1457 = `${$104fb1be4fcec117$export$deb313264d4a6a20}`;
    const $104fb1be4fcec117$export$cfcf3497a5711f2c = 'START_DATE_PLACEHOLDER';
    const $104fb1be4fcec117$export$42702a43f0325a0c = 'DUE_DATE_PLACEHOLDER';
    const $104fb1be4fcec117$export$1b72784d953fe9b3 = 'START_AND_DUE_DATE_PLACEHOLDER';
});
parcelRegister("2KlaV", function(module, exports) {
    $parcel$export(module.exports, "TOP", ()=>$d2a0dd3547e5ef21$export$793ed84f5e13fedc);
    $parcel$export(module.exports, "BOTTOM", ()=>$d2a0dd3547e5ef21$export$84e1549b474f1b93);
    $parcel$export(module.exports, "LEFT", ()=>$d2a0dd3547e5ef21$export$f981f70d61d1405a);
    $parcel$export(module.exports, "RIGHT", ()=>$d2a0dd3547e5ef21$export$1cac5500365a4eb4);
    $parcel$export(module.exports, "LEFT_AND_RIGHT", ()=>$d2a0dd3547e5ef21$export$15a640865ed23fd6);
    $parcel$export(module.exports, "START_DATE_RELATIVE", ()=>$d2a0dd3547e5ef21$export$9353e50b864bcf30);
    $parcel$export(module.exports, "DUE_DATE_RELATIVE", ()=>$d2a0dd3547e5ef21$export$37796aed858ea4df);
    $parcel$export(module.exports, "START_DATE_AND_DUE_DATE_RELATIVE", ()=>$d2a0dd3547e5ef21$export$a7d970936077567f);
    $parcel$export(module.exports, "RELEASES_HEADER_ID", ()=>$d2a0dd3547e5ef21$export$c44d80b675e16f76);
    $parcel$export(module.exports, "SPRINTS_HEADER_ID", ()=>$d2a0dd3547e5ef21$export$8b5a447b30b83d68);
    $parcel$export(module.exports, "DEFAULT_RENDERER", ()=>$d2a0dd3547e5ef21$export$8c50c502a6dae24);
    const $d2a0dd3547e5ef21$export$793ed84f5e13fedc = 'TOP';
    const $d2a0dd3547e5ef21$export$84e1549b474f1b93 = 'BOTTOM';
    const $d2a0dd3547e5ef21$export$f981f70d61d1405a = 'LEFT';
    const $d2a0dd3547e5ef21$export$1cac5500365a4eb4 = 'RIGHT';
    const $d2a0dd3547e5ef21$export$15a640865ed23fd6 = 'LEFT_AND_RIGHT';
    const $d2a0dd3547e5ef21$export$9353e50b864bcf30 = 'START_DATE_RELATIVE';
    const $d2a0dd3547e5ef21$export$37796aed858ea4df = 'DUE_DATE_RELATIVE';
    const $d2a0dd3547e5ef21$export$a7d970936077567f = 'START_DATE_AND_DUE_DATE_RELATIVE';
    const $d2a0dd3547e5ef21$export$c44d80b675e16f76 = 'RELEASES_HEADER_ID';
    const $d2a0dd3547e5ef21$export$8b5a447b30b83d68 = 'SPRINTS_HEADER_ID';
    const $d2a0dd3547e5ef21$export$8c50c502a6dae24 = ()=>null;
});
parcelRegister("28XgU", function(module, exports) {
    $parcel$export(module.exports, "getColor", ()=>$06f933d777b80eee$export$5551a2d24ff40153);
    var $gULOk;
    var $kFsv3;
    const $06f933d777b80eee$var$colorMap = {
        [(0, (0, parcelRequire("gULOk")).UNDEFINED)]: (0, (0, parcelRequire("kFsv3")).DARK_GREY),
        [(0, (0, parcelRequire("gULOk")).TODO)]: (0, (0, parcelRequire("kFsv3")).DARK_GREY),
        [(0, (0, parcelRequire("gULOk")).DONE)]: (0, (0, parcelRequire("kFsv3")).DARK_GREEN),
        [(0, (0, parcelRequire("gULOk")).IN_PROGRESS)]: (0, (0, parcelRequire("kFsv3")).DARK_BLUE)
    };
    const $06f933d777b80eee$export$5551a2d24ff40153 = (categoryId)=>$06f933d777b80eee$var$colorMap[(0, (0, parcelRequire("gULOk")).statusCategoryForId)(categoryId)];
});
parcelRegister("kFsv3", function(module, exports) {
    $parcel$export(module.exports, "PURPLE", ()=>$da8a77f13d52b186$export$7ffdeca4b2f927a2);
    $parcel$export(module.exports, "DARK_PURPLE", ()=>$da8a77f13d52b186$export$c815fe495e8174a0);
    $parcel$export(module.exports, "BLUE", ()=>$da8a77f13d52b186$export$738c3b9a44c87ecc);
    $parcel$export(module.exports, "DARK_BLUE", ()=>$da8a77f13d52b186$export$1225f83626261b80);
    $parcel$export(module.exports, "GREEN", ()=>$da8a77f13d52b186$export$48d4b2cd5bc0e88b);
    $parcel$export(module.exports, "DARK_GREEN", ()=>$da8a77f13d52b186$export$c6f4cf2e5768eb78);
    $parcel$export(module.exports, "TEAL", ()=>$da8a77f13d52b186$export$d0446fe88325854e);
    $parcel$export(module.exports, "DARK_TEAL", ()=>$da8a77f13d52b186$export$bb848c92687e69dc);
    $parcel$export(module.exports, "YELLOW", ()=>$da8a77f13d52b186$export$aab610c505c06a8f);
    $parcel$export(module.exports, "DARK_YELLOW", ()=>$da8a77f13d52b186$export$466af87757d343a2);
    $parcel$export(module.exports, "ORANGE", ()=>$da8a77f13d52b186$export$3de5e29ed1757f9b);
    $parcel$export(module.exports, "DARK_ORANGE", ()=>$da8a77f13d52b186$export$da02e4820b6ab753);
    $parcel$export(module.exports, "GREY", ()=>$da8a77f13d52b186$export$7d278ca694634874);
    $parcel$export(module.exports, "DARK_GREY", ()=>$da8a77f13d52b186$export$26453300bfc61cb8);
    $parcel$export(module.exports, "COLORS", ()=>$da8a77f13d52b186$export$56d196d2844d1ca1);
    $parcel$export(module.exports, "SERVER_PURPLE", ()=>$da8a77f13d52b186$export$792af22a0198af8d);
    $parcel$export(module.exports, "SERVER_DARK_PURPLE", ()=>$da8a77f13d52b186$export$588af712afdcb006);
    $parcel$export(module.exports, "SERVER_BLUE", ()=>$da8a77f13d52b186$export$84c4918645391802);
    $parcel$export(module.exports, "SERVER_DARK_BLUE", ()=>$da8a77f13d52b186$export$b8f1f5838352a33a);
    $parcel$export(module.exports, "SERVER_GREEN", ()=>$da8a77f13d52b186$export$9384b7e350ee6542);
    $parcel$export(module.exports, "SERVER_DARK_GREEN", ()=>$da8a77f13d52b186$export$87d3fb8d8656d38b);
    $parcel$export(module.exports, "SERVER_TEAL", ()=>$da8a77f13d52b186$export$b0b4ce3e99e66aae);
    $parcel$export(module.exports, "SERVER_DARK_TEAL", ()=>$da8a77f13d52b186$export$a89b77a449bd223e);
    $parcel$export(module.exports, "SERVER_YELLOW", ()=>$da8a77f13d52b186$export$9a33b5e3cde94885);
    $parcel$export(module.exports, "SERVER_DARK_YELLOW", ()=>$da8a77f13d52b186$export$33253d7862bceb8a);
    $parcel$export(module.exports, "SERVER_ORANGE", ()=>$da8a77f13d52b186$export$6609c2b23fc42f39);
    $parcel$export(module.exports, "SERVER_DARK_ORANGE", ()=>$da8a77f13d52b186$export$cd994662b5911917);
    $parcel$export(module.exports, "SERVER_GREY", ()=>$da8a77f13d52b186$export$1793d43e13e078c5);
    $parcel$export(module.exports, "SERVER_DARK_GREY", ()=>$da8a77f13d52b186$export$487a6e9145526564);
    $parcel$export(module.exports, "GHX_LABEL_1", ()=>$da8a77f13d52b186$export$e4bdf2d4c4bbb15e);
    $parcel$export(module.exports, "GHX_LABEL_2", ()=>$da8a77f13d52b186$export$8f5c1c5512278dc6);
    $parcel$export(module.exports, "GHX_LABEL_3", ()=>$da8a77f13d52b186$export$94ac87c81ed074a7);
    $parcel$export(module.exports, "GHX_LABEL_4", ()=>$da8a77f13d52b186$export$6bc9ab1f489f76f7);
    $parcel$export(module.exports, "GHX_LABEL_5", ()=>$da8a77f13d52b186$export$610a2c132b6fcf96);
    $parcel$export(module.exports, "GHX_LABEL_6", ()=>$da8a77f13d52b186$export$8e4997dba71f1c40);
    $parcel$export(module.exports, "GHX_LABEL_7", ()=>$da8a77f13d52b186$export$18a545b4e69b27b4);
    $parcel$export(module.exports, "GHX_LABEL_8", ()=>$da8a77f13d52b186$export$27fff1a0d295292a);
    $parcel$export(module.exports, "GHX_LABEL_9", ()=>$da8a77f13d52b186$export$e57aa662a56724e1);
    $parcel$export(module.exports, "GHX_LABEL_10", ()=>$da8a77f13d52b186$export$4b0d63e2c3be2072);
    $parcel$export(module.exports, "GHX_LABEL_11", ()=>$da8a77f13d52b186$export$457ecb9560f2bf83);
    $parcel$export(module.exports, "GHX_LABEL_12", ()=>$da8a77f13d52b186$export$a866db37165a696c);
    $parcel$export(module.exports, "GHX_LABEL_13", ()=>$da8a77f13d52b186$export$9b18447c1168a1b6);
    $parcel$export(module.exports, "GHX_LABEL_14", ()=>$da8a77f13d52b186$export$93b9ad4020e271b7);
    $parcel$export(module.exports, "AGILE_COLOR_1", ()=>$da8a77f13d52b186$export$5cd2af17b34de3e3);
    $parcel$export(module.exports, "AGILE_COLOR_2", ()=>$da8a77f13d52b186$export$987671fa69482a7b);
    $parcel$export(module.exports, "AGILE_COLOR_3", ()=>$da8a77f13d52b186$export$70ba8a5b1f4c7446);
    $parcel$export(module.exports, "AGILE_COLOR_4", ()=>$da8a77f13d52b186$export$fcd1c42d8d3ebd36);
    $parcel$export(module.exports, "AGILE_COLOR_5", ()=>$da8a77f13d52b186$export$f80a5bd2fa0ba256);
    $parcel$export(module.exports, "AGILE_COLOR_6", ()=>$da8a77f13d52b186$export$37ad5ce8d2aeaf78);
    $parcel$export(module.exports, "AGILE_COLOR_7", ()=>$da8a77f13d52b186$export$9dc62d5d151cb355);
    $parcel$export(module.exports, "AGILE_COLOR_8", ()=>$da8a77f13d52b186$export$1ed15b30f5663f92);
    $parcel$export(module.exports, "AGILE_COLOR_9", ()=>$da8a77f13d52b186$export$5d23a84d55ac1644);
    $parcel$export(module.exports, "AGILE_COLOR_10", ()=>$da8a77f13d52b186$export$bf08c9a6ed42e349);
    $parcel$export(module.exports, "AGILE_COLOR_11", ()=>$da8a77f13d52b186$export$66c5d8f0b5ff279c);
    $parcel$export(module.exports, "AGILE_COLOR_12", ()=>$da8a77f13d52b186$export$da30755a37c3a597);
    $parcel$export(module.exports, "AGILE_COLOR_13", ()=>$da8a77f13d52b186$export$721cf84faff6bf19);
    $parcel$export(module.exports, "AGILE_COLOR_14", ()=>$da8a77f13d52b186$export$4b8f8666bd7b61dd);
    $parcel$export(module.exports, "Colors", ()=>$da8a77f13d52b186$export$c537fa0d021d010b);
    $parcel$export(module.exports, "ServerColors", ()=>$da8a77f13d52b186$export$d33d39828a18210a);
    $parcel$export(module.exports, "ClassicEpicColors", ()=>$da8a77f13d52b186$export$f476e6e43e0101e7);
    $parcel$export(module.exports, "AgileColors", ()=>$da8a77f13d52b186$export$4b7407b8700035bd);
    const $da8a77f13d52b186$export$7ffdeca4b2f927a2 = 'PURPLE';
    const $da8a77f13d52b186$export$c815fe495e8174a0 = 'DARK_PURPLE';
    const $da8a77f13d52b186$export$738c3b9a44c87ecc = 'BLUE';
    const $da8a77f13d52b186$export$1225f83626261b80 = 'DARK_BLUE';
    const $da8a77f13d52b186$export$48d4b2cd5bc0e88b = 'GREEN';
    const $da8a77f13d52b186$export$c6f4cf2e5768eb78 = 'DARK_GREEN';
    const $da8a77f13d52b186$export$d0446fe88325854e = 'TEAL';
    const $da8a77f13d52b186$export$bb848c92687e69dc = 'DARK_TEAL';
    const $da8a77f13d52b186$export$aab610c505c06a8f = 'YELLOW';
    const $da8a77f13d52b186$export$466af87757d343a2 = 'DARK_YELLOW';
    const $da8a77f13d52b186$export$3de5e29ed1757f9b = 'ORANGE';
    const $da8a77f13d52b186$export$da02e4820b6ab753 = 'DARK_ORANGE';
    const $da8a77f13d52b186$export$7d278ca694634874 = 'GREY';
    const $da8a77f13d52b186$export$26453300bfc61cb8 = 'DARK_GREY';
    const $da8a77f13d52b186$export$56d196d2844d1ca1 = [
        $da8a77f13d52b186$export$7ffdeca4b2f927a2,
        $da8a77f13d52b186$export$c815fe495e8174a0,
        $da8a77f13d52b186$export$738c3b9a44c87ecc,
        $da8a77f13d52b186$export$1225f83626261b80,
        $da8a77f13d52b186$export$48d4b2cd5bc0e88b,
        $da8a77f13d52b186$export$c6f4cf2e5768eb78,
        $da8a77f13d52b186$export$d0446fe88325854e,
        $da8a77f13d52b186$export$bb848c92687e69dc,
        $da8a77f13d52b186$export$aab610c505c06a8f,
        $da8a77f13d52b186$export$466af87757d343a2,
        $da8a77f13d52b186$export$3de5e29ed1757f9b,
        $da8a77f13d52b186$export$da02e4820b6ab753,
        $da8a77f13d52b186$export$7d278ca694634874,
        $da8a77f13d52b186$export$26453300bfc61cb8
    ];
    const $da8a77f13d52b186$export$792af22a0198af8d = 'purple';
    const $da8a77f13d52b186$export$588af712afdcb006 = 'dark_purple';
    const $da8a77f13d52b186$export$84c4918645391802 = 'blue';
    const $da8a77f13d52b186$export$b8f1f5838352a33a = 'dark_blue';
    const $da8a77f13d52b186$export$9384b7e350ee6542 = 'green';
    const $da8a77f13d52b186$export$87d3fb8d8656d38b = 'dark_green';
    const $da8a77f13d52b186$export$b0b4ce3e99e66aae = 'teal';
    const $da8a77f13d52b186$export$a89b77a449bd223e = 'dark_teal';
    const $da8a77f13d52b186$export$9a33b5e3cde94885 = 'yellow';
    const $da8a77f13d52b186$export$33253d7862bceb8a = 'dark_yellow';
    const $da8a77f13d52b186$export$6609c2b23fc42f39 = 'orange';
    const $da8a77f13d52b186$export$cd994662b5911917 = 'dark_orange';
    const $da8a77f13d52b186$export$1793d43e13e078c5 = 'grey';
    const $da8a77f13d52b186$export$487a6e9145526564 = 'dark_grey';
    const $da8a77f13d52b186$export$e4bdf2d4c4bbb15e = 'ghx-label-1';
    const $da8a77f13d52b186$export$8f5c1c5512278dc6 = 'ghx-label-2';
    const $da8a77f13d52b186$export$94ac87c81ed074a7 = 'ghx-label-3';
    const $da8a77f13d52b186$export$6bc9ab1f489f76f7 = 'ghx-label-4';
    const $da8a77f13d52b186$export$610a2c132b6fcf96 = 'ghx-label-5';
    const $da8a77f13d52b186$export$8e4997dba71f1c40 = 'ghx-label-6';
    const $da8a77f13d52b186$export$18a545b4e69b27b4 = 'ghx-label-7';
    const $da8a77f13d52b186$export$27fff1a0d295292a = 'ghx-label-8';
    const $da8a77f13d52b186$export$e57aa662a56724e1 = 'ghx-label-9';
    const $da8a77f13d52b186$export$4b0d63e2c3be2072 = 'ghx-label-10';
    const $da8a77f13d52b186$export$457ecb9560f2bf83 = 'ghx-label-11';
    const $da8a77f13d52b186$export$a866db37165a696c = 'ghx-label-12';
    const $da8a77f13d52b186$export$9b18447c1168a1b6 = 'ghx-label-13';
    const $da8a77f13d52b186$export$93b9ad4020e271b7 = 'ghx-label-14';
    const $da8a77f13d52b186$export$5cd2af17b34de3e3 = 'color_1';
    const $da8a77f13d52b186$export$987671fa69482a7b = 'color_2';
    const $da8a77f13d52b186$export$70ba8a5b1f4c7446 = 'color_3';
    const $da8a77f13d52b186$export$fcd1c42d8d3ebd36 = 'color_4';
    const $da8a77f13d52b186$export$f80a5bd2fa0ba256 = 'color_5';
    const $da8a77f13d52b186$export$37ad5ce8d2aeaf78 = 'color_6';
    const $da8a77f13d52b186$export$9dc62d5d151cb355 = 'color_7';
    const $da8a77f13d52b186$export$1ed15b30f5663f92 = 'color_8';
    const $da8a77f13d52b186$export$5d23a84d55ac1644 = 'color_9';
    const $da8a77f13d52b186$export$bf08c9a6ed42e349 = 'color_10';
    const $da8a77f13d52b186$export$66c5d8f0b5ff279c = 'color_11';
    const $da8a77f13d52b186$export$da30755a37c3a597 = 'color_12';
    const $da8a77f13d52b186$export$721cf84faff6bf19 = 'color_13';
    const $da8a77f13d52b186$export$4b8f8666bd7b61dd = 'color_14';
    const $da8a77f13d52b186$export$c537fa0d021d010b = {
        PURPLE: $da8a77f13d52b186$export$7ffdeca4b2f927a2,
        DARK_PURPLE: $da8a77f13d52b186$export$c815fe495e8174a0,
        BLUE: $da8a77f13d52b186$export$738c3b9a44c87ecc,
        DARK_BLUE: $da8a77f13d52b186$export$1225f83626261b80,
        GREEN: $da8a77f13d52b186$export$48d4b2cd5bc0e88b,
        DARK_GREEN: $da8a77f13d52b186$export$c6f4cf2e5768eb78,
        TEAL: $da8a77f13d52b186$export$d0446fe88325854e,
        DARK_TEAL: $da8a77f13d52b186$export$bb848c92687e69dc,
        YELLOW: $da8a77f13d52b186$export$aab610c505c06a8f,
        DARK_YELLOW: $da8a77f13d52b186$export$466af87757d343a2,
        ORANGE: $da8a77f13d52b186$export$3de5e29ed1757f9b,
        DARK_ORANGE: $da8a77f13d52b186$export$da02e4820b6ab753,
        GREY: $da8a77f13d52b186$export$7d278ca694634874,
        DARK_GREY: $da8a77f13d52b186$export$26453300bfc61cb8
    };
    const $da8a77f13d52b186$export$d33d39828a18210a = {
        SERVER_PURPLE: $da8a77f13d52b186$export$792af22a0198af8d,
        SERVER_DARK_PURPLE: $da8a77f13d52b186$export$588af712afdcb006,
        SERVER_BLUE: $da8a77f13d52b186$export$84c4918645391802,
        SERVER_DARK_BLUE: $da8a77f13d52b186$export$b8f1f5838352a33a,
        SERVER_GREEN: $da8a77f13d52b186$export$9384b7e350ee6542,
        SERVER_DARK_GREEN: $da8a77f13d52b186$export$87d3fb8d8656d38b,
        SERVER_TEAL: $da8a77f13d52b186$export$b0b4ce3e99e66aae,
        SERVER_DARK_TEAL: $da8a77f13d52b186$export$a89b77a449bd223e,
        SERVER_YELLOW: $da8a77f13d52b186$export$9a33b5e3cde94885,
        SERVER_DARK_YELLOW: $da8a77f13d52b186$export$33253d7862bceb8a,
        SERVER_ORANGE: $da8a77f13d52b186$export$6609c2b23fc42f39,
        SERVER_DARK_ORANGE: $da8a77f13d52b186$export$cd994662b5911917,
        SERVER_GREY: $da8a77f13d52b186$export$1793d43e13e078c5,
        SERVER_DARK_GREY: $da8a77f13d52b186$export$487a6e9145526564
    };
    const $da8a77f13d52b186$export$f476e6e43e0101e7 = {
        GHX_LABEL_1: $da8a77f13d52b186$export$e4bdf2d4c4bbb15e,
        GHX_LABEL_2: $da8a77f13d52b186$export$8f5c1c5512278dc6,
        GHX_LABEL_3: $da8a77f13d52b186$export$94ac87c81ed074a7,
        GHX_LABEL_4: $da8a77f13d52b186$export$6bc9ab1f489f76f7,
        GHX_LABEL_5: $da8a77f13d52b186$export$610a2c132b6fcf96,
        GHX_LABEL_6: $da8a77f13d52b186$export$8e4997dba71f1c40,
        GHX_LABEL_7: $da8a77f13d52b186$export$18a545b4e69b27b4,
        GHX_LABEL_8: $da8a77f13d52b186$export$27fff1a0d295292a,
        GHX_LABEL_9: $da8a77f13d52b186$export$e57aa662a56724e1,
        GHX_LABEL_10: $da8a77f13d52b186$export$4b0d63e2c3be2072,
        GHX_LABEL_11: $da8a77f13d52b186$export$457ecb9560f2bf83,
        GHX_LABEL_12: $da8a77f13d52b186$export$a866db37165a696c,
        GHX_LABEL_13: $da8a77f13d52b186$export$9b18447c1168a1b6,
        GHX_LABEL_14: $da8a77f13d52b186$export$93b9ad4020e271b7
    };
    const $da8a77f13d52b186$export$4b7407b8700035bd = {
        AGILE_COLOR_1: $da8a77f13d52b186$export$5cd2af17b34de3e3,
        AGILE_COLOR_2: $da8a77f13d52b186$export$987671fa69482a7b,
        AGILE_COLOR_3: $da8a77f13d52b186$export$70ba8a5b1f4c7446,
        AGILE_COLOR_4: $da8a77f13d52b186$export$fcd1c42d8d3ebd36,
        AGILE_COLOR_5: $da8a77f13d52b186$export$f80a5bd2fa0ba256,
        AGILE_COLOR_6: $da8a77f13d52b186$export$37ad5ce8d2aeaf78,
        AGILE_COLOR_7: $da8a77f13d52b186$export$9dc62d5d151cb355,
        AGILE_COLOR_8: $da8a77f13d52b186$export$1ed15b30f5663f92,
        AGILE_COLOR_9: $da8a77f13d52b186$export$5d23a84d55ac1644,
        AGILE_COLOR_10: $da8a77f13d52b186$export$bf08c9a6ed42e349,
        AGILE_COLOR_11: $da8a77f13d52b186$export$66c5d8f0b5ff279c,
        AGILE_COLOR_12: $da8a77f13d52b186$export$da30755a37c3a597,
        AGILE_COLOR_13: $da8a77f13d52b186$export$721cf84faff6bf19,
        AGILE_COLOR_14: $da8a77f13d52b186$export$4b8f8666bd7b61dd
    };
});
parcelRegister("68D2c", function(module, exports) {
    $parcel$export(module.exports, "getDependenciesItems", ()=>$1d502069c4b2d02e$export$675e7796a0dd4b1e);
    var $g5X3G;
    var $iZN6h;
    var $lPsAi;
    var $5t3NS;
    const $1d502069c4b2d02e$export$675e7796a0dd4b1e = (positionsHash, itemsHash, dependenciesHash, startDateHash, dueDateHash)=>{
        const dependencies = [];
        Object.keys(dependenciesHash).forEach((issueId)=>{
            const targetIssueId = (0, (0, parcelRequire("g5X3G")).toIssueId)(issueId);
            const issueDependencies = dependenciesHash[targetIssueId];
            if (itemsHash[targetIssueId] && positionsHash[targetIssueId] !== undefined) {
                const targetItem = itemsHash[targetIssueId];
                const targetDate = (0, (0, parcelRequire("lPsAi")).evaluateTargetDependencyDate)(targetItem);
                if (targetDate !== undefined) {
                    const to = {
                        id: (0, (0, parcelRequire("g5X3G")).toIssueId)(targetIssueId),
                        startDate: targetDate,
                        y: positionsHash[targetIssueId],
                        color: targetItem.color
                    };
                    issueDependencies.forEach((sourceIssueId)=>{
                        if (itemsHash[sourceIssueId] && positionsHash[sourceIssueId] !== undefined) {
                            const sourceItem = itemsHash[sourceIssueId];
                            const sourceDate = (0, (0, parcelRequire("lPsAi")).evaluateSourceDependencyDate)(sourceItem);
                            if (sourceDate !== undefined) {
                                const itemHeight = (0, (0, parcelRequire("iZN6h")).DEFAULT_ITEM_HEIGHT);
                                dependencies.push({
                                    itemHeight: itemHeight,
                                    from: {
                                        id: sourceIssueId,
                                        dueDate: sourceDate,
                                        y: positionsHash[sourceIssueId],
                                        color: sourceItem.color
                                    },
                                    to: to,
                                    isOverlapping: (0, (0, parcelRequire("5t3NS")).isDependencyDatesOverlapping)(startDateHash[sourceIssueId], dueDateHash[sourceIssueId], startDateHash[issueId], dueDateHash[issueId])
                                });
                            }
                        }
                    });
                }
            }
        });
        return dependencies;
    };
});
parcelRegister("lPsAi", function(module, exports) {
    $parcel$export(module.exports, "evaluateTargetDependencyDate", ()=>$36bff8f03676a1bb$export$81334eb3d1727c87);
    $parcel$export(module.exports, "evaluateSourceDependencyDate", ()=>$36bff8f03676a1bb$export$5bed6e237e54824f);
    const $36bff8f03676a1bb$export$81334eb3d1727c87 = (targetItem)=>{
        const { startDate: start, dueDate: due } = targetItem;
        if (due !== undefined && start !== undefined && due < start) return due;
        return start;
    };
    const $36bff8f03676a1bb$export$5bed6e237e54824f = (sourceItem)=>{
        const { startDate: start, dueDate: due } = sourceItem;
        if (due !== undefined && start !== undefined && due < start) return start;
        return due;
    };
});
parcelRegister("5t3NS", function(module, exports) {
    $parcel$export(module.exports, "isDependencyDatesOverlapping", ()=>$4ce2b3890f6536f8$export$9fb40a5a7e47a5dd);
    const $4ce2b3890f6536f8$export$9fb40a5a7e47a5dd = (dependencyStartDate = -1, dependencyDueDate = -1, dependeeStartDate = -1, dependeeDueDate = -1)=>{
        if (dependencyDueDate > -1 && dependeeStartDate > -1) return dependencyDueDate > dependeeStartDate;
        if (dependencyStartDate === -1 && dependencyDueDate === -1 || dependeeStartDate === -1 && dependeeDueDate === -1) return false;
        if (dependencyDueDate === -1 && dependeeStartDate === -1) return dependencyStartDate > dependeeDueDate;
        if (dependencyDueDate !== -1) return dependencyDueDate > dependeeDueDate;
        if (dependencyStartDate !== -1) return dependencyStartDate > dependeeStartDate;
        return false;
    };
});
parcelRegister("7Cpv0", function(module, exports) {
    $parcel$export(module.exports, "getItemOffsetPositions", ()=>$de695bd802acd2a8$export$1c16f71ecb9378cb);
    var $8QpSo;
    var $iZN6h;
    var $8c0Do;
    const $de695bd802acd2a8$export$1c16f71ecb9378cb = (0, (0, parcelRequire("8QpSo")).default)((itemIds, childIdsHash, expandedItems, createItemAnchor)=>{
        const positions = {};
        let cumulativeOffset = 0;
        const calculateOffsetPositions = (id, depth)=>{
            if ((0, (0, parcelRequire("8c0Do")).isCreateBeforeItem)(createItemAnchor, id)) cumulativeOffset += (0, (0, parcelRequire("iZN6h")).DEFAULT_ITEM_HEIGHT);
            const itemHeight = (0, (0, parcelRequire("8c0Do")).isRootDepth)(depth) ? (0, (0, parcelRequire("iZN6h")).DEFAULT_ITEM_HEIGHT) : (0, (0, parcelRequire("iZN6h")).BASE_LEVEL_ITEM_HEIGHT)();
            positions[id] = cumulativeOffset + itemHeight / 2;
            cumulativeOffset += itemHeight;
            const childIds = childIdsHash[id];
            if (childIds && expandedItems[id]) childIds.forEach((childId)=>calculateOffsetPositions(childId, depth + 1));
            if ((0, (0, parcelRequire("8c0Do")).isCreateInsideItem)(createItemAnchor, id)) cumulativeOffset += (0, (0, parcelRequire("iZN6h")).DEFAULT_ITEM_HEIGHT);
        };
        itemIds.forEach((id)=>calculateOffsetPositions(id, 0));
        return positions;
    });
});
parcelRegister("8c0Do", function(module, exports) {
    $parcel$export(module.exports, "isSubTaskLevel", ()=>$7ce2d479b0572eed$export$aebc411043116683);
    $parcel$export(module.exports, "isRootDepth", ()=>$7ce2d479b0572eed$export$6bb8bb5846dfcbbf);
    $parcel$export(module.exports, "isCreateBeforeItem", ()=>$7ce2d479b0572eed$export$f914dd0333de5d26);
    $parcel$export(module.exports, "isCreateInsideItem", ()=>$7ce2d479b0572eed$export$193d1b66e1b4992a);
    var $iZN6h;
    var $gNAqw;
    const $7ce2d479b0572eed$export$aebc411043116683 = (level)=>level === (0, (0, parcelRequire("gNAqw")).TIMELINE_SUBTASK_HIERARCHY_LEVEL);
    const $7ce2d479b0572eed$export$6bb8bb5846dfcbbf = (depth)=>depth === (0, (0, parcelRequire("gNAqw")).TIMELINE_ROOT_DEPTH);
    const $7ce2d479b0572eed$export$f914dd0333de5d26 = (createItemAnchor, id)=>createItemAnchor && createItemAnchor.position === (0, (0, parcelRequire("iZN6h")).BEFORE) && createItemAnchor.beforeId === id;
    const $7ce2d479b0572eed$export$193d1b66e1b4992a = (createItemAnchor, id)=>createItemAnchor && createItemAnchor.position === (0, (0, parcelRequire("iZN6h")).INSIDE) && createItemAnchor.parentId === id;
});
parcelRegister("9D57m", function(module, exports) {
    $parcel$export(module.exports, "transformDates", ()=>$fc6f780ca08ac4ac$export$5501ec26d974b092);
    var $gwejS;
    var $b77vc;
    var $it1wb;
    var $pyK8a;
    var $7CMcV;
    var $3Mgup;
    const $fc6f780ca08ac4ac$export$b7c7dc1344e0909e = (startDate, dueDate)=>{
        if (startDate !== undefined && dueDate !== undefined) return startDate > dueDate;
        return false;
    };
    const $fc6f780ca08ac4ac$export$5501ec26d974b092 = ({ startDate: startDate, dueDate: dueDate })=>{
        if (startDate !== undefined && dueDate !== undefined) return {
            startDate: startDate,
            dueDate: dueDate
        };
        if (startDate !== undefined) return {
            startDate: startDate,
            dueDate: (0, (0, parcelRequire("b77vc")).default)((0, (0, parcelRequire("3Mgup")).default)((0, (0, parcelRequire("it1wb")).default)((0, (0, parcelRequire("gwejS")).default)((0, (0, parcelRequire("7CMcV")).default)(new Date(startDate), 'utc'), 7)), 'utc'))
        };
        if (dueDate !== undefined) return {
            startDate: (0, (0, parcelRequire("b77vc")).default)((0, (0, parcelRequire("3Mgup")).default)((0, (0, parcelRequire("it1wb")).default)((0, (0, parcelRequire("pyK8a")).default)((0, (0, parcelRequire("7CMcV")).default)(new Date(dueDate), 'utc'), 7)), 'utc')),
            dueDate: dueDate
        };
        return {
            startDate: startDate,
            dueDate: dueDate
        };
    };
});
parcelRegister("gEkZt", function(module, exports) {
    $parcel$export(module.exports, "TimelineViewUpdaterProvider", ()=>$2e373233539ed5a6$export$1efd096d14ad6572);
    $parcel$export(module.exports, "useLockIssue", ()=>$2e373233539ed5a6$export$edf8e8c123aeceda);
    $parcel$export(module.exports, "TimelineViewUpdater", ()=>$2e373233539ed5a6$export$a1432e92b20e37ea);
    var $5uXOq = parcelRequire("5uXOq");
    var $54qG5;
    var $1T4FF;
    var $6sVa1;
    var $3qoA4;
    var $ctQtp;
    const $2e373233539ed5a6$var$LOCK_DELAY = 2000;
    const $2e373233539ed5a6$export$ef5e6bae537251a2 = 'jira-business-timeline-view';
    const $2e373233539ed5a6$var$Context = (0, $5uXOq.createContext)(null);
    const $2e373233539ed5a6$export$1efd096d14ad6572 = ({ children: children })=>{
        const value = (0, $5uXOq.useState)(new Map());
        return (0, ($parcel$interopDefault($5uXOq))).createElement($2e373233539ed5a6$var$Context.Provider, {
            value: value
        }, children);
    };
    const $2e373233539ed5a6$export$edf8e8c123aeceda = ()=>{
        const [, setLockedIssueMap] = (0, $5uXOq.useContext)($2e373233539ed5a6$var$Context);
        return (0, $5uXOq.useCallback)((issueId)=>{
            setLockedIssueMap((prev)=>{
                const existingTimeoutId = prev.get(issueId);
                if (existingTimeoutId != null) clearTimeout(existingTimeoutId);
                const timeoutId = setTimeout(()=>{
                    setLockedIssueMap((prev2)=>{
                        const newMap = new Map(prev2);
                        newMap.delete(issueId);
                        return newMap;
                    });
                }, $2e373233539ed5a6$var$LOCK_DELAY);
                return new Map(prev).set(issueId, timeoutId);
            });
        }, [
            setLockedIssueMap
        ]);
    };
    const $2e373233539ed5a6$export$a1432e92b20e37ea = (0, $5uXOq.memo)(({ childrenQueryData: childrenQueryData })=>{
        const { data: entity } = (0, (0, parcelRequire("54qG5")).useBusinessEntity)();
        const [lockedIssuesMap] = (0, $5uXOq.useContext)($2e373233539ed5a6$var$Context);
        const { onIssueUpdated: onIssueUpdated, onIssueCreated: onIssueCreated } = (0, (0, parcelRequire("ctQtp")).useTimelineViewUpdater)({
            childrenQueryData: childrenQueryData
        });
        const onRealtimeEvent = (event)=>{
            if ((0, (0, parcelRequire("3qoA4")).isIssueEvent)(event)) {
                const issueId = Number(event.payload.issueId);
                if (lockedIssuesMap.has(issueId)) return;
                if (event.type === (0, (0, parcelRequire("1T4FF")).ISSUE_CREATED_EVENT)) onIssueCreated([
                    issueId
                ]);
                else onIssueUpdated([
                    issueId
                ]);
            }
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6sVa1")).GqlsRealtime), {
            appId: $2e373233539ed5a6$export$ef5e6bae537251a2,
            entityId: entity.id,
            onReceive: onRealtimeEvent
        });
    });
});
parcelRegister("1T4FF", function(module, exports) {
    $parcel$export(module.exports, "ISSUE_CREATED_EVENT", ()=>$ac829f3b425e0434$export$b22a14d5dac59664);
    $parcel$export(module.exports, "ISSUE_DELETED_EVENT", ()=>$ac829f3b425e0434$export$25fa37e5059c5a99);
    $parcel$export(module.exports, "ISSUE_UPDATED_EVENT", ()=>$ac829f3b425e0434$export$b22142e61b3fdbee);
    $parcel$export(module.exports, "FIELD_MUTATION_EVENT", ()=>$ac829f3b425e0434$export$eddbca92a5bee91f);
    $parcel$export(module.exports, "ISSUE_EVENTS", ()=>$ac829f3b425e0434$export$f01b4f4e297998a0);
    $parcel$export(module.exports, "DEFAULT_EVENTS_TO_SUBSCRIBE_TO", ()=>$ac829f3b425e0434$export$edc58098c8ddf4cb);
    $parcel$export(module.exports, "CREATE_SUBSCRIPTIONS_EXPERIENCE", ()=>$ac829f3b425e0434$export$75b82bac1ec985d9);
    $parcel$export(module.exports, "REALTIME_EVENT_EXPERIENCE", ()=>$ac829f3b425e0434$export$245947dc0e8c134b);
    const $ac829f3b425e0434$export$b22a14d5dac59664 = 'avi:jira:created:issue';
    const $ac829f3b425e0434$export$25fa37e5059c5a99 = 'avi:jira:deleted:issue';
    const $ac829f3b425e0434$export$b22142e61b3fdbee = 'avi:jira:updated:issue';
    const $ac829f3b425e0434$export$eddbca92a5bee91f = 'avi:jira:field:updated';
    const $ac829f3b425e0434$export$f01b4f4e297998a0 = [
        $ac829f3b425e0434$export$b22a14d5dac59664,
        $ac829f3b425e0434$export$25fa37e5059c5a99,
        $ac829f3b425e0434$export$b22142e61b3fdbee
    ];
    const $ac829f3b425e0434$export$edc58098c8ddf4cb = $ac829f3b425e0434$export$f01b4f4e297998a0;
    const $ac829f3b425e0434$export$b8b9d90f9e5bd72b = 'jiraBusinessGqlsRealtime';
    const $ac829f3b425e0434$export$75b82bac1ec985d9 = {
        experience: 'createSubscriptions',
        packageName: $ac829f3b425e0434$export$b8b9d90f9e5bd72b,
        teamName: 'jira-warepil'
    };
    const $ac829f3b425e0434$export$245947dc0e8c134b = {
        experience: 'realtimeEvent',
        packageName: $ac829f3b425e0434$export$b8b9d90f9e5bd72b,
        teamName: 'jira-warepil'
    };
});
parcelRegister("6sVa1", function(module, exports) {
    $parcel$export(module.exports, "GqlsRealtime", ()=>$c64a00289bd38048$export$ad092969d774a1ab);
    var $5uXOq = parcelRequire("5uXOq");
    var $1Zr0i;
    var $cm8b5;
    var $heNNl;
    var $dXq4S;
    var $8zOmE;
    var $lwMsT;
    var $9OXo1;
    var $1T4FF;
    var $x3opw;
    var $8EXvJ;
    var $8hBpB;
    var $bGo96;
    const $c64a00289bd38048$export$ad092969d774a1ab = (0, $5uXOq.memo)(({ appId: appId, entityId: entityId, onReceive: onReceive, eventsToSubscribeTo: eventsToSubscribeTo = (0, (0, parcelRequire("1T4FF")).DEFAULT_EVENTS_TO_SUBSCRIBE_TO) })=>{
        const { cloudId: cloudId } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const siteId = (0, (0, parcelRequire("dXq4S")).createAri)({
            resourceOwner: 'jira',
            resourceType: 'site',
            resourceId: cloudId
        });
        const realtimeIds = (0, (0, parcelRequire("1Zr0i")).useRealtimeContext)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const createSubsExperienceStart = (0, (0, parcelRequire("cm8b5")).useExperienceStart)((0, (0, parcelRequire("1T4FF")).CREATE_SUBSCRIPTIONS_EXPERIENCE));
        const createSubsExperienceSuccess = (0, (0, parcelRequire("cm8b5")).useExperienceSuccess)((0, (0, parcelRequire("1T4FF")).CREATE_SUBSCRIPTIONS_EXPERIENCE));
        const createSubsExperienceFail = (0, (0, parcelRequire("cm8b5")).useExperienceFail)((0, (0, parcelRequire("1T4FF")).CREATE_SUBSCRIPTIONS_EXPERIENCE));
        const realtimeEventExperienceStart = (0, (0, parcelRequire("cm8b5")).useExperienceStart)((0, (0, parcelRequire("1T4FF")).REALTIME_EVENT_EXPERIENCE));
        const realtimeEventExperienceSuccess = (0, (0, parcelRequire("cm8b5")).useExperienceSuccess)((0, (0, parcelRequire("1T4FF")).REALTIME_EVENT_EXPERIENCE));
        const realtimeEventExperienceFail = (0, (0, parcelRequire("cm8b5")).useExperienceFail)((0, (0, parcelRequire("1T4FF")).REALTIME_EVENT_EXPERIENCE));
        createSubsExperienceStart();
        const extraEventDataRef = (0, $5uXOq.useRef)({
            appId: appId,
            entityId: entityId
        });
        extraEventDataRef.current.appId = appId;
        extraEventDataRef.current.entityId = entityId;
        const onReceiveRef = (0, $5uXOq.useRef)(onReceive);
        onReceiveRef.current = onReceive;
        const handleReceive = (0, $5uXOq.useCallback)((event)=>{
            realtimeEventExperienceStart();
            try {
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'subscription next', {
                    ...extraEventDataRef.current,
                    realtimeEvent: event.type
                });
                onReceiveRef.current(event);
                realtimeEventExperienceSuccess({
                    realtimeEvent: event.type
                });
            } catch (error) {
                realtimeEventExperienceFail('jiraBusinessGqlsRealtime.gqlsRealtime', error, {
                    realtimeEvent: event.type
                });
            }
        }, [
            createAnalyticsEvent,
            realtimeEventExperienceStart,
            realtimeEventExperienceSuccess,
            realtimeEventExperienceFail
        ]);
        const handleReactError = (0, $5uXOq.useCallback)((_location, error, event)=>{
            (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'jiraBusinessGqlsRealtime.gqlsRealtime failed', event);
            createSubsExperienceFail('jiraBusinessGqlsRealtime.gqlsRealtime', error);
        }, [
            createAnalyticsEvent,
            createSubsExperienceFail
        ]);
        const handleSubscriptionError = (0, $5uXOq.useCallback)((errorMessage, operationName)=>{
            (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), 'jiraBusinessGqlsRealtime.subscription failed', {
                errorMessage: errorMessage,
                operationName: operationName,
                ...extraEventDataRef.current
            });
        }, [
            createAnalyticsEvent
        ]);
        const subscriptions = (0, $5uXOq.useMemo)(()=>!realtimeIds.length ? null : realtimeIds.map((projectId)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, eventsToSubscribeTo.includes((0, (0, parcelRequire("1T4FF")).ISSUE_UPDATED_EVENT)) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bGo96")).UpdateIssueSubscription), {
                    cloudId: cloudId,
                    projectId: projectId,
                    onReceive: handleReceive,
                    onError: handleSubscriptionError
                }), eventsToSubscribeTo.includes((0, (0, parcelRequire("1T4FF")).ISSUE_CREATED_EVENT)) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("x3opw")).CreateIssueSubscription), {
                    cloudId: cloudId,
                    projectId: projectId,
                    onReceive: handleReceive,
                    onError: handleSubscriptionError
                }), eventsToSubscribeTo.includes((0, (0, parcelRequire("1T4FF")).ISSUE_DELETED_EVENT)) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8EXvJ")).DeleteIssueSubscription), {
                    cloudId: cloudId,
                    projectId: projectId,
                    onReceive: handleReceive,
                    onError: handleSubscriptionError
                }), eventsToSubscribeTo.includes((0, (0, parcelRequire("1T4FF")).FIELD_MUTATION_EVENT)) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8hBpB")).FieldMutationSubscription), {
                    siteId: siteId,
                    onReceive: handleReceive,
                    onError: handleSubscriptionError
                }))), [
            cloudId,
            siteId,
            realtimeIds,
            eventsToSubscribeTo,
            handleReceive,
            handleSubscriptionError
        ]);
        (0, $5uXOq.useEffect)(()=>{
            const realtimeEvents = {
                issueCreated: eventsToSubscribeTo.includes((0, (0, parcelRequire("1T4FF")).ISSUE_CREATED_EVENT)),
                issueUpdated: eventsToSubscribeTo.includes((0, (0, parcelRequire("1T4FF")).ISSUE_UPDATED_EVENT)),
                issueDeleted: eventsToSubscribeTo.includes((0, (0, parcelRequire("1T4FF")).ISSUE_DELETED_EVENT)),
                fieldMutation: eventsToSubscribeTo.includes((0, (0, parcelRequire("1T4FF")).FIELD_MUTATION_EVENT))
            };
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'subscriptions created', {
                ...extraEventDataRef.current,
                ...realtimeEvents,
                subscriptions: realtimeIds.length * eventsToSubscribeTo.length
            });
            createSubsExperienceSuccess();
        }, [
            subscriptions,
            createAnalyticsEvent,
            realtimeIds,
            eventsToSubscribeTo,
            createSubsExperienceSuccess
        ]);
        (0, $5uXOq.useEffect)(()=>{
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'subscriptions init', extraEventDataRef.current);
            const extraEventData = extraEventDataRef.current;
            return ()=>{
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'subscriptions closed', extraEventData);
            };
        }, []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: "gqlsRealtime",
            packageName: "jiraBusinessGqlsRealtime",
            extraEventData: extraEventDataRef.current,
            onError: handleReactError
        }, subscriptions);
    });
});
parcelRegister("x3opw", function(module, exports) {
    $parcel$export(module.exports, "CreateIssueSubscription", ()=>$04c21e90a72c6b66$export$7876efe7a86fd4f1);
    var $5uXOq = parcelRequire("5uXOq");
    var $WnsY2;
    var $1T4FF;
    var $3qoA4;
    const $04c21e90a72c6b66$var$operationName = 'JwmIssueCreatedSubscription';
    const $04c21e90a72c6b66$export$7876efe7a86fd4f1 = (0, $5uXOq.memo)(({ cloudId: cloudId, projectId: projectId, onReceive: onReceive, onError: onError })=>{
        (0, (0, parcelRequire("WnsY2")).useSubscribe)({
            query: (0, $d3fb5f72d359d914$export$89cddb5ca4c806e4),
            variables: {
                cloudId: cloudId,
                projectId: projectId
            },
            operationName: $04c21e90a72c6b66$var$operationName
        }, {
            next: (value)=>{
                const error = (0, (0, parcelRequire("3qoA4")).getResponseError)(value);
                if (error) onError(error, $04c21e90a72c6b66$var$operationName);
                else {
                    const payload = value.data?.jira?.onIssueCreatedByProject;
                    if (payload) onReceive({
                        type: (0, (0, parcelRequire("1T4FF")).ISSUE_CREATED_EVENT),
                        payload: payload
                    });
                }
            }
        });
        return null;
    });
});
parcelRegister("WnsY2", function(module, exports) {
    $parcel$export(module.exports, "useSubscribe", ()=>$292b86c5ae12bc26$export$d3d523392640272);
    var $5uXOq = parcelRequire("5uXOq");
    var $laTox;
    var $jcw0u;
    var $cfDZ3;
    var $lWhTC;
    var $hoQbP;
    var $1Uhm6;
    const $292b86c5ae12bc26$var$noop = ()=>{};
    const $292b86c5ae12bc26$var$subscribe = (payload, sink)=>{
        const client = (0, (0, parcelRequire("lWhTC")).getClient)();
        if (!client) return;
        const { query: query, variables: variables, operationName: operationName, extensions: extensions } = payload;
        const { next: next, error: error, complete: complete = $292b86c5ae12bc26$var$noop } = sink;
        let requestId;
        return client.subscribe({
            query: query,
            variables: variables,
            operationName: operationName,
            extensions: {
                ...extensions ?? {}
            }
        }, {
            next: (value)=>{
                const aggRequestId = value?.extensions?.agg?.request_id;
                if (aggRequestId) requestId = aggRequestId;
                next(value);
            },
            complete: complete,
            error: (sinkError)=>{
                const errorInfo = (0, (0, parcelRequire("1Uhm6")).getSinkError)(sinkError);
                const attributes = {
                    operationName: operationName,
                    requestId: requestId,
                    userLocation: (0, (0, parcelRequire("cfDZ3")).getUserLocation)()
                };
                error?.(errorInfo, attributes);
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'subscription',
                        packageName: 'jiraGraphqlSubscription',
                        teamName: 'uip-graphql'
                    },
                    error: errorInfo,
                    attributes: attributes,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
        });
    };
    const $292b86c5ae12bc26$export$d3d523392640272 = (payload, sink)=>{
        (0, $5uXOq.useEffect)(()=>{
            let unsubscribe = $292b86c5ae12bc26$var$subscribe(payload, sink);
            let timeout;
            const onVisibilityChange = ()=>{
                if ((0, (0, parcelRequire("laTox")).isPageVisible)()) {
                    if (timeout) {
                        clearTimeout(timeout);
                        timeout = undefined;
                    } else unsubscribe = $292b86c5ae12bc26$var$subscribe(payload, sink);
                } else if (!timeout) timeout = setTimeout(()=>{
                    unsubscribe?.();
                    unsubscribe = undefined;
                    timeout = undefined;
                }, (0, $37d1b046897e548f$export$1ad8434180c5936c));
            };
            if (!(0, (0, parcelRequire("hoQbP")).isSSR)()) window.addEventListener((0, (0, parcelRequire("laTox")).supportedVisiblityEvent), onVisibilityChange);
            return ()=>{
                window.removeEventListener((0, (0, parcelRequire("laTox")).supportedVisiblityEvent), onVisibilityChange);
                unsubscribe?.();
            };
        }, [
            payload,
            sink
        ]);
    };
});
const $37d1b046897e548f$export$8b012b965402e06a = 580000;
const $37d1b046897e548f$export$bf6cd96e19b2987f = 100;
const $37d1b046897e548f$export$1ad8434180c5936c = 300000;
parcelRegister("3qoA4", function(module, exports) {
    $parcel$export(module.exports, "isIssueEvent", ()=>$ca6633b6fecadea7$export$734ba008b9d9e61c);
    $parcel$export(module.exports, "getResponseError", ()=>$ca6633b6fecadea7$export$135f2bf83a3d73b1);
    var $1T4FF;
    const $ca6633b6fecadea7$export$734ba008b9d9e61c = (event)=>(0, (0, parcelRequire("1T4FF")).ISSUE_EVENTS).includes(event.type);
    const $ca6633b6fecadea7$export$135f2bf83a3d73b1 = (response)=>Array.isArray(response.errors) && response.errors.length && response.errors[0].message;
});
const $d3fb5f72d359d914$export$89cddb5ca4c806e4 = `
  subscription JwmIssueCreatedSubscription(
    $cloudId: ID!
    $projectId: String!
  ) {
    jira {
      onIssueCreatedByProject(cloudId: $cloudId, projectId: $projectId) @optIn(to: ["JiraIssueSubscriptions"]) {
        issueId
      }
    }
  }
`;
parcelRegister("8EXvJ", function(module, exports) {
    $parcel$export(module.exports, "DeleteIssueSubscription", ()=>$642754f18ab6266b$export$cba4fc39801f6792);
    var $5uXOq = parcelRequire("5uXOq");
    var $WnsY2;
    var $dXq4S;
    var $1T4FF;
    var $3qoA4;
    const $642754f18ab6266b$var$operationName = 'JwmIssueDeletedSubscription';
    const $642754f18ab6266b$export$cba4fc39801f6792 = (0, $5uXOq.memo)(({ cloudId: cloudId, projectId: projectId, onReceive: onReceive, onError: onError })=>{
        (0, (0, parcelRequire("WnsY2")).useSubscribe)({
            query: (0, $36128e87a5f55340$export$9c299c317f46fdc4),
            variables: {
                cloudId: cloudId,
                projectId: projectId
            },
            operationName: $642754f18ab6266b$var$operationName
        }, {
            next: (value)=>{
                const error = (0, (0, parcelRequire("3qoA4")).getResponseError)(value);
                if (error) onError(error, $642754f18ab6266b$var$operationName);
                else {
                    const payload = value.data?.jira?.onIssueDeletedByProject;
                    if (payload) onReceive({
                        type: (0, (0, parcelRequire("1T4FF")).ISSUE_DELETED_EVENT),
                        payload: {
                            ...payload,
                            issueId: (0, (0, parcelRequire("dXq4S")).getAriConfig)(payload.resource).resourceId
                        }
                    });
                }
            }
        });
        return null;
    });
});
const $36128e87a5f55340$export$9c299c317f46fdc4 = `
  subscription JwmIssueDeletedSubscription(
    $cloudId: ID!
    $projectId: String!
  ) {
    jira {
      onIssueDeletedByProject(cloudId: $cloudId, projectId: $projectId) @optIn(to: ["JiraIssueSubscriptions"]) {
        resource
      }
    }
  }
`;
parcelRegister("8hBpB", function(module, exports) {
    $parcel$export(module.exports, "FieldMutationSubscription", ()=>$4521bfd09c42e07c$export$d82ea923ea48fa52);
    var $5uXOq = parcelRequire("5uXOq");
    var $WnsY2;
    var $1T4FF;
    var $3qoA4;
    const $4521bfd09c42e07c$var$operationName = 'JwmFieldMutationSubscription';
    const $4521bfd09c42e07c$export$d82ea923ea48fa52 = (0, $5uXOq.memo)(({ siteId: siteId, onReceive: onReceive, onError: onError })=>{
        (0, (0, parcelRequire("WnsY2")).useSubscribe)({
            query: (0, $0831eb0e06b13614$export$2e75a8174f7cddb8),
            operationName: $4521bfd09c42e07c$var$operationName,
            variables: {
                siteId: siteId
            }
        }, {
            next: (value)=>{
                const error = (0, (0, parcelRequire("3qoA4")).getResponseError)(value);
                if (error) onError(error, $4521bfd09c42e07c$var$operationName);
                else if (value.data?.jira?.onJwmFieldMutation) onReceive({
                    type: (0, (0, parcelRequire("1T4FF")).FIELD_MUTATION_EVENT),
                    payload: {}
                });
            }
        });
        return null;
    });
});
const $0831eb0e06b13614$export$2e75a8174f7cddb8 = `
  subscription JwmFieldMutationSubscription($siteId: ID!) {
    jira {
      onJwmFieldMutation(siteId: $siteId) {
        encryptedData
      }
    }
  }
`;
parcelRegister("bGo96", function(module, exports) {
    $parcel$export(module.exports, "UpdateIssueSubscription", ()=>$0971ff6ea0a776a8$export$51fac6481c0b4595);
    var $5uXOq = parcelRequire("5uXOq");
    var $WnsY2;
    var $1T4FF;
    var $3qoA4;
    const $0971ff6ea0a776a8$var$operationName = 'JwmIssueUpdatedSubscription';
    const $0971ff6ea0a776a8$export$51fac6481c0b4595 = (0, $5uXOq.memo)(({ cloudId: cloudId, projectId: projectId, onReceive: onReceive, onError: onError })=>{
        (0, (0, parcelRequire("WnsY2")).useSubscribe)({
            query: (0, $fabb0a5a91b2db55$export$54c41e3133084b81),
            variables: {
                cloudId: cloudId,
                projectId: projectId
            },
            operationName: $0971ff6ea0a776a8$var$operationName
        }, {
            next: (value)=>{
                const error = (0, (0, parcelRequire("3qoA4")).getResponseError)(value);
                if (error) onError(error, $0971ff6ea0a776a8$var$operationName);
                else {
                    const payload = value.data?.jira?.onIssueUpdatedByProject;
                    if (payload) onReceive({
                        type: (0, (0, parcelRequire("1T4FF")).ISSUE_UPDATED_EVENT),
                        payload: payload
                    });
                }
            }
        });
        return null;
    });
});
const $fabb0a5a91b2db55$export$54c41e3133084b81 = `
  subscription JwmIssueUpdatedSubscription(
    $cloudId: ID!
    $projectId: String!
  ) {
    jira {
      onIssueUpdatedByProject(cloudId: $cloudId, projectId: $projectId) @optIn(to: ["JiraIssueSubscriptions"]) {
        issueId
      }
    }
  }
`;
parcelRegister("7bPJP", function(module, exports) {
    $parcel$export(module.exports, "useUpdateItem", ()=>$c782c6d4e7d3b9a6$export$9e926802efff7290);
    var $5uXOq = parcelRequire("5uXOq");
    var $3ItGl;
    var $cm8b5;
    var $jJZqs;
    var $fZneA;
    var $pa9q9;
    var $8zOmE;
    var $lwMsT;
    var $dAmbh;
    var $gNAqw;
    var $7rrGn;
    var $kjQs8;
    var $gEkZt;
    var $9wk2s;
    var $lPFae;
    const $c782c6d4e7d3b9a6$export$9e926802efff7290 = ({ issuesMap: issuesMap, updateItemsInCache: updateItemsInCache, childrenQueryData: childrenQueryData })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagService)();
        const lockIssue = (0, (0, parcelRequire("gEkZt")).useLockIssue)();
        const [{ timelineDuration: timelineDuration }] = (0, (0, parcelRequire("kjQs8")).useTimelineUI)();
        const { onScheduleItem: onScheduleItem } = (0, (0, parcelRequire("7rrGn")).useScheduleItem)();
        const { data: startDateField } = (0, (0, parcelRequire("dAmbh")).useStartDateField)();
        const startExperience = (0, (0, parcelRequire("cm8b5")).useExperienceStart)((0, (0, parcelRequire("gNAqw")).SCHEDULE_ITEM_EXPERIENCE));
        const markExperienceAborted = (0, (0, parcelRequire("cm8b5")).useExperienceAbort)((0, (0, parcelRequire("gNAqw")).SCHEDULE_ITEM_EXPERIENCE));
        const markExperienceSuccess = (0, (0, parcelRequire("cm8b5")).useExperienceSuccess)((0, (0, parcelRequire("gNAqw")).SCHEDULE_ITEM_EXPERIENCE));
        const markExperienceFailed = (0, (0, parcelRequire("cm8b5")).useExperienceFail)((0, (0, parcelRequire("gNAqw")).SCHEDULE_ITEM_EXPERIENCE));
        const onItemUpdate = (0, $5uXOq.useCallback)((id, param)=>{
            const issue = issuesMap.get(id);
            if (!issue || !param.dates) return;
            const { dates: dates } = param;
            const startDate = dates?.startDate != null ? (0, (0, parcelRequire("lPFae")).toISOString)(dates.startDate) : null;
            const dueDate = dates?.dueDate != null ? (0, (0, parcelRequire("lPFae")).toISOString)(dates.dueDate) : null;
            if (!startDate && !dueDate) return;
            const issueStartDate = issue.startDate != null ? (0, (0, parcelRequire("lPFae")).toISOString)(issue.startDate) : null;
            const issueDueDate = issue.dueDate != null ? (0, (0, parcelRequire("lPFae")).toISOString)(issue.dueDate) : null;
            lockIssue(Number(id));
            const updateItemsInCacheList = [];
            updateItemsInCacheList.push({
                bulkUpdates: [
                    {
                        id: id,
                        fields: {
                            startDate: startDate,
                            dueDate: dueDate
                        }
                    }
                ],
                originalValues: [
                    {
                        id: id,
                        fields: {
                            startDate: issueStartDate,
                            dueDate: issueDueDate
                        }
                    }
                ]
            });
            const shouldScheduleChildren = (0, (0, parcelRequire("lPFae")).shouldScheduleChildrenIssues)({
                issue: issue,
                modifiedDates: dates
            });
            if (shouldScheduleChildren) {
                const populateChildUpdates = (parentIssueId)=>{
                    const childrenOnCache = childrenQueryData[parentIssueId]?.data?.issues;
                    if (childrenOnCache) {
                        const { bulkUpdates: bulkUpdates, originalValues: originalValues } = (0, (0, parcelRequire("lPFae")).getIssuesBulkDatesUpdate)({
                            issue: issue,
                            issueChildren: childrenOnCache,
                            dates: dates,
                            timelineDuration: timelineDuration
                        });
                        updateItemsInCacheList.push({
                            bulkUpdates: bulkUpdates,
                            originalValues: originalValues
                        });
                        childrenOnCache.forEach((child)=>populateChildUpdates(child.issueId));
                    }
                };
                populateChildUpdates(id);
            }
            updateItemsInCacheList.forEach(({ bulkUpdates: bulkUpdates })=>{
                if (bulkUpdates.length) updateItemsInCache(bulkUpdates);
            });
            const rollbackUpdates = ()=>{
                updateItemsInCacheList.forEach(({ originalValues: originalValues })=>{
                    if (originalValues.length) updateItemsInCache(originalValues);
                });
            };
            const isDragOperation = startDate != null && dueDate != null && (issueStartDate != null || issueDueDate != null);
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'itemDates updated', {
                startDate: startDate,
                dueDate: dueDate,
                shouldScheduleChildren: shouldScheduleChildren
            });
            startExperience();
            let isParentItemSuccessfullyUpdated = false;
            const onComplete = ()=>{
                markExperienceSuccess();
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'scheduleItem success', {
                    issueId: id,
                    startDate: startDate,
                    dueDate: dueDate
                });
                if (!isParentItemSuccessfullyUpdated) {
                    showFlag((0, (0, parcelRequire("9wk2s")).SCHEDULE_ITEM_FAIL_FLAG));
                    rollbackUpdates();
                }
            };
            const onError = (err)=>{
                if (err instanceof (0, (0, parcelRequire("3ItGl")).AbortError)) {
                    markExperienceAborted(err.message || 'scheduleItem aborted');
                    (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'scheduleItem aborted', {
                        error: err,
                        startDate: startDate,
                        dueDate: dueDate
                    });
                    return;
                }
                if ('statusCode' in err && err.statusCode === 404) {
                    showFlag((0, (0, parcelRequire("9wk2s")).SCHEDULE_ITEM_NOT_FOUND));
                    return;
                }
                if ((0, (0, parcelRequire("fZneA")).isClientFetchError)(err) || (0, (0, parcelRequire("jJZqs")).isValidationError)(err) || (0, (0, parcelRequire("fZneA")).isHttpClientErrorResponse)(err)) markExperienceSuccess();
                else markExperienceFailed('schedule item failed', err);
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'scheduleItem failed', {
                    error: err,
                    startDate: startDate,
                    dueDate: dueDate
                });
                showFlag((0, (0, parcelRequire("9wk2s")).SCHEDULE_ITEM_FAIL_FLAG));
                rollbackUpdates();
            };
            const finalise = ()=>{
                if (startDate != null && !startDateField) showFlag((0, (0, parcelRequire("9wk2s")).START_DATE_MISSING_FLAG));
            };
            onScheduleItem({
                issueId: id,
                isDragOperation: isDragOperation,
                ...dates
            }).then((success)=>{
                if (success === true) isParentItemSuccessfullyUpdated = true;
                onComplete();
            }).catch(onError).finally(finalise);
        }, [
            issuesMap,
            lockIssue,
            createAnalyticsEvent,
            startExperience,
            updateItemsInCache,
            childrenQueryData,
            timelineDuration,
            onScheduleItem,
            markExperienceSuccess,
            showFlag,
            markExperienceAborted,
            markExperienceFailed,
            startDateField
        ]);
        return {
            onItemUpdate: onItemUpdate
        };
    };
});
parcelRegister("7rrGn", function(module, exports) {
    $parcel$export(module.exports, "useScheduleItem", ()=>$236e595f44cea528$export$62e208b89a8c71ad);
    var $5uXOq = parcelRequire("5uXOq");
    var $2HfxU = parcelRequire("2HfxU");
    var $5tTFS;
    var $k7m40;
    var $eZDAP;
    var $3ItGl;
    var $jcw0u;
    var $jJZqs;
    var $eCBf9;
    var $4kK95;
    var $8zOmE;
    var $lwMsT;
    var $dAmbh;
    var $koeKL;
    var $4IWra;
    const $236e595f44cea528$var$DATE_FORMAT = 'dd/MMM/yyyy';
    const $236e595f44cea528$var$QUERY_NAME = 'scheduleTimelineJwmItem';
    const $236e595f44cea528$var$mapDateToValidDateVariable = (date)=>{
        const mappedDate = (0, (0, parcelRequire("4kK95")).DateOnly).fromDateAccordingToUTC(new Date(date)).toISOString();
        return (0, (0, parcelRequire("k7m40")).default)((0, (0, parcelRequire("eZDAP")).default)(mappedDate), $236e595f44cea528$var$DATE_FORMAT);
    };
    class $236e595f44cea528$export$78c95b58762d2106 extends (0, (0, parcelRequire("jJZqs")).ValidationError) {
        constructor(){
            super('Issue not found');
        }
    }
    const $236e595f44cea528$export$62e208b89a8c71ad = ()=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const { data: startDateField } = (0, (0, parcelRequire("dAmbh")).useStartDateField)();
        const abortController = (0, $5uXOq.useRef)(new AbortController());
        const doFireErrorAnalytics = (error)=>{
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: $236e595f44cea528$var$QUERY_NAME,
                    packageName: 'jiraBusinessTimeline',
                    teamName: 'jira-yurree'
                },
                error: Array.isArray(error) ? error[0] : error,
                attributes: {
                    message: 'Failed to schedule item'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        };
        const [scheduleItem] = (0, (0, parcelRequire("5tTFS")).useMutation)((0, (0, parcelRequire("4IWra")).SCHEDULE_TIMELINE_ITEM_MUTATION), {
            onError: (apolloError)=>{
                if ((0, (0, parcelRequire("3ItGl")).isAbortError)(apolloError.networkError)) throw apolloError.networkError;
                const not4xxErrors = apolloError.graphQLErrors?.filter((error)=>!error.extensions?.statusCode || error.extensions.statusCode >= 500);
                if (not4xxErrors?.length > 0) doFireErrorAnalytics(apolloError);
                const firstError = (0, ($parcel$interopDefault($2HfxU)))(apolloError?.graphQLErrors);
                throw new (0, (0, parcelRequire("jJZqs")).default)(firstError?.extensions?.statusCode || 500, firstError?.message || 'Timeline schedule item mutation returned an error');
            },
            onCompleted: (onCompletedData)=>{
                (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), `${$236e595f44cea528$var$QUERY_NAME} succeeded`, {});
                if (onCompletedData.scheduleTimelineJwmItem?.errors?.length) doFireErrorAnalytics(onCompletedData.scheduleTimelineJwmItem.errors.map((e)=>new (0, (0, parcelRequire("eCBf9")).MutationError)({
                        message: e.message
                    })));
                else if (onCompletedData?.scheduleTimelineJwmItem?.success === false) doFireErrorAnalytics([
                    new (0, (0, parcelRequire("eCBf9")).MutationError)({
                        message: 'Success mutation value as false without error'
                    })
                ]);
            }
        });
        const onScheduleItem = (0, $5uXOq.useCallback)(({ issueId: issueId, startDate: startDate, dueDate: dueDate, isDragOperation: isDragOperation })=>{
            abortController.current.abort(new (0, (0, parcelRequire("3ItGl")).AbortError)((0, (0, parcelRequire("3ItGl")).DEFAULT_ABORT_ERROR_MESSAGE)));
            abortController.current = new AbortController();
            const variables = {
                input: {
                    issueId: `ari:cloud:jira:${cloudId}:issue/${issueId}`,
                    operation: isDragOperation ? 'DRAG' : 'SET',
                    ...startDate != null && startDateField?.id ? {
                        startDate: {
                            fieldId: startDateField.id,
                            date: {
                                formattedDate: $236e595f44cea528$var$mapDateToValidDateVariable(startDate)
                            }
                        }
                    } : {},
                    ...dueDate != null ? {
                        dueDate: {
                            fieldId: 'duedate',
                            date: {
                                formattedDate: $236e595f44cea528$var$mapDateToValidDateVariable(dueDate)
                            }
                        }
                    } : {}
                }
            };
            return scheduleItem({
                variables: variables,
                context: {
                    fetchOptions: {
                        signal: abortController.current.signal
                    }
                }
            }).then((result)=>{
                const error = (0, ($parcel$interopDefault($2HfxU)))(result?.data?.scheduleTimelineJwmItem?.errors);
                if (error || result?.data?.scheduleTimelineJwmItem?.success !== true) throw new Error(error?.message || 'Timeline schedule item mutation result data included an error or success was not true');
                return result?.data?.scheduleTimelineJwmItem?.success;
            });
        }, [
            cloudId,
            startDateField,
            scheduleItem
        ]);
        return {
            onScheduleItem: onScheduleItem
        };
    };
});
parcelRegister("2HfxU", function(module, exports) {
    module.exports = (parcelRequire("bH3EF"));
});
parcelRegister("bH3EF", function(module, exports) {
    function $88368ba58341d518$var$head(array) {
        return array && array.length ? array[0] : undefined;
    }
    module.exports = $88368ba58341d518$var$head;
});
parcelRegister("4IWra", function(module, exports) {
    $parcel$export(module.exports, "SCHEDULE_TIMELINE_ITEM_MUTATION", ()=>$130252a86048fe97$export$31219886be2a5896);
    var $5cllN;
    const $130252a86048fe97$export$31219886be2a5896 = (0, (0, parcelRequire("5cllN")).default)`
    mutation ScheduleTimelineJwmItem($input: JWMScheduleTimelineItemInput!) {
        scheduleTimelineJwmItem(input: $input) {
            success
            errors {
                message
                extensions {
                    statusCode
                    errorType
                }
            }
        }
    }
`;
});
parcelRegister("9wk2s", function(module, exports) {
    $parcel$export(module.exports, "START_DATE_MISSING_FLAG", ()=>$10c74008a10ff40d$export$c4d0266ea6d22734);
    $parcel$export(module.exports, "SCHEDULE_ITEM_FAIL_FLAG", ()=>$10c74008a10ff40d$export$56d33b992984cd75);
    $parcel$export(module.exports, "SCHEDULE_ITEM_NOT_FOUND", ()=>$10c74008a10ff40d$export$2e974dce72b69a83);
    var $ilpdD;
    const $10c74008a10ff40d$export$c4d0266ea6d22734 = {
        type: 'error',
        title: (0, (0, parcelRequire("ilpdD")).default).startDateMissingErrorTitle,
        description: (0, (0, parcelRequire("ilpdD")).default).startDateMissingErrorMessage
    };
    const $10c74008a10ff40d$export$56d33b992984cd75 = {
        type: 'error',
        title: (0, (0, parcelRequire("ilpdD")).default).scheduleItemErrorTitle,
        description: (0, (0, parcelRequire("ilpdD")).default).scheduleItemErrorDescription
    };
    const $10c74008a10ff40d$export$2e974dce72b69a83 = {
        type: 'error',
        title: (0, (0, parcelRequire("ilpdD")).default).scheduleItemNotFound,
        description: (0, (0, parcelRequire("ilpdD")).default).scheduleItemRemoved
    };
});
parcelRegister("ilpdD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d43efcd7f9993a33$export$2e2bcd8739ae039);
    var $7VHMR;
    var $d43efcd7f9993a33$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        startDateMissingErrorTitle: {
            "id": "business-timeline.controllers.update-item.start-date-missing-error-title",
            "defaultMessage": "We couldn't save the item"
        },
        startDateMissingErrorMessage: {
            "id": "business-timeline.controllers.update-item.start-date-missing-error-message",
            "defaultMessage": "Field 'Start date' cannot be set. It is not on the appropriate screen."
        },
        scheduleItemErrorTitle: {
            "id": "business-timeline.controllers.update-item.schedule-item-error-title",
            "defaultMessage": "Something's gone wrong"
        },
        scheduleItemErrorDescription: {
            "id": "business-timeline.controllers.update-item.schedule-item-error-description",
            "defaultMessage": "Refresh the page and try again."
        },
        scheduleItemNotFound: {
            "id": "business-timeline.controllers.update-item.schedule-item-not-found",
            "defaultMessage": "Issue not found"
        },
        scheduleItemRemoved: {
            "id": "business-timeline.controllers.update-item.schedule-item-removed",
            "defaultMessage": "Looks like this issue has been removed."
        }
    });
});
parcelRegister("lPFae", function(module, exports) {
    $parcel$export(module.exports, "toISOString", ()=>$fec24454abf3f199$export$dfaaa8705752128f);
    $parcel$export(module.exports, "shouldScheduleChildrenIssues", ()=>$fec24454abf3f199$export$f98ee0b182e34597);
    $parcel$export(module.exports, "getSafeScheduleDates", ()=>$fec24454abf3f199$export$a43c8446bad60ee);
    $parcel$export(module.exports, "getIssuesBulkDatesUpdate", ()=>$fec24454abf3f199$export$6fad4cd647ef6c8c);
    var $4kK95;
    const $fec24454abf3f199$export$dfaaa8705752128f = (timestamp)=>(0, (0, parcelRequire("4kK95")).DateOnly).fromDateAccordingToUTC(new Date(timestamp)).toISOString();
    const $fec24454abf3f199$export$f98ee0b182e34597 = ({ issue: issue, modifiedDates: { startDate: startDate, dueDate: dueDate } })=>{
        const { startDate: oldStartDate, dueDate: oldDueDate, hasChildren: hasChildren } = issue;
        const isBothDatesPopulated = startDate !== undefined && dueDate !== undefined;
        const isBothDatesUpdated = startDate !== oldStartDate && dueDate !== oldDueDate;
        return hasChildren && isBothDatesPopulated && isBothDatesUpdated;
    };
    const $fec24454abf3f199$export$1f04624003d2da7d = 86400000;
    const $fec24454abf3f199$export$28c98c2c1f9d90de = $fec24454abf3f199$export$1f04624003d2da7d - 1;
    const $fec24454abf3f199$var$LEFT = 'LEFT';
    const $fec24454abf3f199$var$RIGHT = 'RIGHT';
    const $fec24454abf3f199$export$a43c8446bad60ee = ({ startDate: startDate, dueDate: dueDate, timelineDuration: timelineDuration, offset: offset })=>{
        const direction = offset < 0 ? $fec24454abf3f199$var$LEFT : $fec24454abf3f199$var$RIGHT;
        const { startMilliseconds: startMilliseconds, endMilliseconds: endMilliseconds } = timelineDuration;
        let newOffset = offset;
        if (direction === $fec24454abf3f199$var$LEFT && startDate !== undefined) {
            const maxLeftOffset = -Math.max(0, startDate - startMilliseconds);
            newOffset = Math.max(maxLeftOffset, offset);
        } else if (direction === $fec24454abf3f199$var$RIGHT && dueDate !== undefined) {
            const maxRightOffset = Math.max(0, endMilliseconds - dueDate - $fec24454abf3f199$export$28c98c2c1f9d90de);
            newOffset = Math.min(maxRightOffset, offset);
        }
        const newStartDate = startDate !== undefined ? startDate + newOffset : undefined;
        const newDueDate = dueDate !== undefined ? dueDate + newOffset : undefined;
        return {
            startDate: newStartDate,
            dueDate: newDueDate
        };
    };
    const $fec24454abf3f199$export$6fad4cd647ef6c8c = ({ issue: issue, issueChildren: issueChildren, dates: { startDate: startDate, dueDate: dueDate }, timelineDuration: timelineDuration })=>{
        const bulkUpdates = [];
        const originalValues = [];
        if (issueChildren.length && startDate !== undefined && dueDate !== undefined) {
            let offset = 0;
            const oldStartDate = issue.startDate ?? null;
            const oldDueDate = issue.dueDate ?? null;
            if (oldStartDate != null) offset = startDate - oldStartDate;
            else if (oldDueDate != null) offset = dueDate - oldDueDate;
            if (offset) issueChildren.forEach((issueChild)=>{
                const { startDate: childStartDate, dueDate: childDueDate } = issueChild;
                const { startDate: safeStartDate, dueDate: safeDueDate } = $fec24454abf3f199$export$a43c8446bad60ee({
                    startDate: childStartDate,
                    dueDate: childDueDate,
                    timelineDuration: timelineDuration,
                    offset: offset
                });
                const newStartDate = safeStartDate != null ? $fec24454abf3f199$export$dfaaa8705752128f(safeStartDate) : null;
                const newDueDate = safeDueDate != null ? $fec24454abf3f199$export$dfaaa8705752128f(safeDueDate) : null;
                if (childStartDate !== safeStartDate || childDueDate !== safeDueDate) {
                    originalValues.push({
                        id: issueChild.issueId,
                        fields: {
                            startDate: childStartDate ? $fec24454abf3f199$export$dfaaa8705752128f(childStartDate) : null,
                            dueDate: childDueDate ? $fec24454abf3f199$export$dfaaa8705752128f(childDueDate) : null
                        }
                    });
                    bulkUpdates.push({
                        id: issueChild.issueId,
                        fields: {
                            startDate: newStartDate,
                            dueDate: newDueDate
                        }
                    });
                }
            });
        }
        return {
            bulkUpdates: bulkUpdates,
            originalValues: originalValues
        };
    };
});
parcelRegister("gW8GI", function(module, exports) {
    $parcel$export(module.exports, "useUpdateItem", ()=>$7f6ac164d242af7b$export$9e926802efff7290);
    var $5uXOq = parcelRequire("5uXOq");
    var $3ItGl;
    var $cm8b5;
    var $jJZqs;
    var $fZneA;
    var $pa9q9;
    var $8zOmE;
    var $lwMsT;
    var $dAmbh;
    var $gNAqw;
    var $1wHCP;
    var $kjQs8;
    var $gEkZt;
    var $9wk2s;
    var $lPFae;
    var $fvodk;
    const $7f6ac164d242af7b$export$9e926802efff7290 = ({ issuesMap: issuesMap, updateItemsInCache: updateItemsInCache, childrenQueryData: childrenQueryData })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagService)();
        const lockIssue = (0, (0, parcelRequire("gEkZt")).useLockIssue)();
        const [{ timelineDuration: timelineDuration }] = (0, (0, parcelRequire("kjQs8")).useTimelineUI)();
        const { onScheduleItem: onScheduleItem } = (0, (0, parcelRequire("1wHCP")).useScheduleItem)();
        const { data: startDateField } = (0, (0, parcelRequire("dAmbh")).useStartDateField)();
        const startExperience = (0, (0, parcelRequire("cm8b5")).useExperienceStart)((0, (0, parcelRequire("gNAqw")).JIRA_SCHEDULE_ITEM_EXPERIENCE));
        const markExperienceAborted = (0, (0, parcelRequire("cm8b5")).useExperienceAbort)((0, (0, parcelRequire("gNAqw")).JIRA_SCHEDULE_ITEM_EXPERIENCE));
        const markExperienceSuccess = (0, (0, parcelRequire("cm8b5")).useExperienceSuccess)((0, (0, parcelRequire("gNAqw")).JIRA_SCHEDULE_ITEM_EXPERIENCE));
        const markExperienceFailed = (0, (0, parcelRequire("cm8b5")).useExperienceFail)((0, (0, parcelRequire("gNAqw")).JIRA_SCHEDULE_ITEM_EXPERIENCE));
        const onItemUpdate = (0, $5uXOq.useCallback)((id, param)=>{
            const issue = issuesMap.get(id);
            if (!issue || !param.dates) return;
            const { dates: dates } = param;
            if (!dates?.startDate && !dates?.dueDate) return;
            const startDate = dates?.startDate?.date != null ? (0, (0, parcelRequire("lPFae")).toISOString)(dates.startDate.date) : null;
            const dueDate = dates?.dueDate?.date != null ? (0, (0, parcelRequire("lPFae")).toISOString)(dates.dueDate.date) : null;
            const bulkStartDateUpdate = dates?.startDate ? {
                date: startDate
            } : null;
            const bulkDueDateUpdate = dates?.dueDate ? {
                date: dueDate
            } : null;
            const issueStartDate = issue.startDate != null ? (0, (0, parcelRequire("lPFae")).toISOString)(issue.startDate) : null;
            const issueDueDate = issue.dueDate != null ? (0, (0, parcelRequire("lPFae")).toISOString)(issue.dueDate) : null;
            lockIssue(Number(id));
            const updateItemsInCacheList = [];
            updateItemsInCacheList.push({
                bulkUpdates: [
                    {
                        id: id,
                        fields: {
                            startDate: bulkStartDateUpdate,
                            dueDate: bulkDueDateUpdate
                        }
                    }
                ],
                originalValues: [
                    {
                        id: id,
                        fields: {
                            startDate: issueStartDate,
                            dueDate: issueDueDate
                        }
                    }
                ]
            });
            const shouldScheduleChildren = (0, (0, parcelRequire("fvodk")).shouldScheduleChildrenIssues)({
                issue: issue,
                modifiedDates: dates
            });
            if (shouldScheduleChildren) {
                const populateChildUpdates = (parentIssueId)=>{
                    const childrenOnCache = childrenQueryData[parentIssueId]?.data?.issues;
                    if (childrenOnCache) {
                        const { bulkUpdates: bulkUpdates, originalValues: originalValues } = (0, (0, parcelRequire("fvodk")).getIssuesBulkDatesUpdate)({
                            issue: issue,
                            issueChildren: childrenOnCache,
                            dates: dates,
                            timelineDuration: timelineDuration
                        });
                        updateItemsInCacheList.push({
                            bulkUpdates: bulkUpdates,
                            originalValues: originalValues
                        });
                        childrenOnCache.forEach((child)=>populateChildUpdates(child.issueId));
                    }
                };
                populateChildUpdates(id);
            }
            updateItemsInCacheList.forEach(({ bulkUpdates: bulkUpdates })=>{
                if (bulkUpdates.length) updateItemsInCache(bulkUpdates);
            });
            const rollbackUpdates = ()=>{
                updateItemsInCacheList.forEach(({ originalValues: originalValues })=>{
                    if (originalValues.length) updateItemsInCache(originalValues);
                });
            };
            const isDragOperation = startDate != null && dueDate != null && (issueStartDate != null || issueDueDate != null);
            startExperience();
            let isParentItemSuccessfullyUpdated = false;
            const onComplete = ()=>{
                markExperienceSuccess();
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'scheduleItem success', {
                    issueId: id,
                    startDate: startDate,
                    dueDate: dueDate
                });
                if (!isParentItemSuccessfullyUpdated) {
                    showFlag((0, (0, parcelRequire("9wk2s")).SCHEDULE_ITEM_FAIL_FLAG));
                    rollbackUpdates();
                }
            };
            const onError = (err)=>{
                if (err instanceof (0, (0, parcelRequire("3ItGl")).AbortError)) {
                    markExperienceAborted(err.message || 'scheduleItem aborted');
                    (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'scheduleItem aborted', {
                        error: err,
                        startDate: startDate,
                        dueDate: dueDate
                    });
                    return;
                }
                if ('statusCode' in err && err.statusCode === 404) {
                    showFlag((0, (0, parcelRequire("9wk2s")).SCHEDULE_ITEM_NOT_FOUND));
                    return;
                }
                if ((0, (0, parcelRequire("fZneA")).isClientFetchError)(err) || (0, (0, parcelRequire("jJZqs")).isValidationError)(err) || (0, (0, parcelRequire("fZneA")).isHttpClientErrorResponse)(err)) markExperienceSuccess();
                else markExperienceFailed('schedule item failed', err);
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'scheduleItem failed', {
                    error: err,
                    startDate: startDate,
                    dueDate: dueDate
                });
                showFlag((0, (0, parcelRequire("9wk2s")).SCHEDULE_ITEM_FAIL_FLAG));
                rollbackUpdates();
            };
            const finalise = ()=>{
                if (startDate != null && !startDateField) showFlag((0, (0, parcelRequire("9wk2s")).START_DATE_MISSING_FLAG));
            };
            onScheduleItem({
                issueId: id,
                isDragOperation: isDragOperation,
                ...dates
            }).then((success)=>{
                if (success === true) isParentItemSuccessfullyUpdated = true;
                onComplete();
            }).catch(onError).finally(finalise);
        }, [
            issuesMap,
            lockIssue,
            createAnalyticsEvent,
            startExperience,
            onScheduleItem,
            childrenQueryData,
            timelineDuration,
            updateItemsInCache,
            markExperienceSuccess,
            showFlag,
            markExperienceAborted,
            markExperienceFailed,
            startDateField
        ]);
        return {
            onItemUpdate: onItemUpdate
        };
    };
});
parcelRegister("1wHCP", function(module, exports) {
    $parcel$export(module.exports, "useScheduleItem", ()=>$9b6cd3b79be82381$export$62e208b89a8c71ad);
    var $5uXOq = parcelRequire("5uXOq");
    var $2HfxU = parcelRequire("2HfxU");
    var $5tTFS;
    var $k7m40;
    var $eZDAP;
    var $3ItGl;
    var $jcw0u;
    var $jJZqs;
    var $eCBf9;
    var $4kK95;
    var $8zOmE;
    var $lwMsT;
    var $dAmbh;
    var $koeKL;
    var $fD5PT;
    const $9b6cd3b79be82381$var$DATE_FORMAT = 'dd/MMM/yyyy';
    const $9b6cd3b79be82381$var$QUERY_NAME = 'scheduleTimelineItem';
    const $9b6cd3b79be82381$var$mapDateToValidDateVariable = (date)=>{
        const mappedDate = (0, (0, parcelRequire("4kK95")).DateOnly).fromDateAccordingToUTC(new Date(date)).toISOString();
        return (0, (0, parcelRequire("k7m40")).default)((0, (0, parcelRequire("eZDAP")).default)(mappedDate), $9b6cd3b79be82381$var$DATE_FORMAT);
    };
    class $9b6cd3b79be82381$export$78c95b58762d2106 extends (0, (0, parcelRequire("jJZqs")).ValidationError) {
        constructor(){
            super('Issue not found');
        }
    }
    const $9b6cd3b79be82381$export$62e208b89a8c71ad = ()=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const { data: startDateField } = (0, (0, parcelRequire("dAmbh")).useStartDateField)();
        const abortController = (0, $5uXOq.useRef)(new AbortController());
        const doFireErrorAnalytics = (error)=>{
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: $9b6cd3b79be82381$var$QUERY_NAME,
                    packageName: 'jiraBusinessTimeline',
                    teamName: 'jira-yurree'
                },
                error: Array.isArray(error) ? error[0] : error,
                attributes: {
                    message: 'Failed to schedule item'
                },
                sendToPrivacyUnsafeSplunk: true
            });
        };
        const [jiraScheduleItem] = (0, (0, parcelRequire("5tTFS")).useMutation)((0, (0, parcelRequire("fD5PT")).SCHEDULE_TIMELINE_ITEM_MUTATION), {
            onError: (apolloError)=>{
                if ((0, (0, parcelRequire("3ItGl")).isAbortError)(apolloError.networkError)) throw apolloError.networkError;
                const not4xxErrors = apolloError.graphQLErrors?.filter((error)=>!error.extensions?.statusCode || error.extensions.statusCode >= 500);
                if (not4xxErrors?.length > 0) doFireErrorAnalytics(apolloError);
                const firstError = (0, ($parcel$interopDefault($2HfxU)))(apolloError?.graphQLErrors);
                throw new (0, (0, parcelRequire("jJZqs")).default)(firstError?.extensions?.statusCode || 500, firstError?.message || 'Timeline schedule item mutation returned an error');
            },
            onCompleted: (onCompletedData)=>{
                (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), `${$9b6cd3b79be82381$var$QUERY_NAME} succeeded`, {});
                if (onCompletedData.jira?.scheduleTimelineItem?.errors?.length) doFireErrorAnalytics(onCompletedData.jira.scheduleTimelineItem.errors.map((e)=>new (0, (0, parcelRequire("eCBf9")).MutationError)({
                        message: e.message
                    })));
                else if (onCompletedData?.jira?.scheduleTimelineItem?.success === false) doFireErrorAnalytics([
                    new (0, (0, parcelRequire("eCBf9")).MutationError)({
                        message: 'Success mutation value as false without error'
                    })
                ]);
            }
        });
        const onScheduleItem = (0, $5uXOq.useCallback)(({ issueId: issueId, startDate: startDate, dueDate: dueDate, isDragOperation: isDragOperation })=>{
            abortController.current.abort(new (0, (0, parcelRequire("3ItGl")).AbortError)((0, (0, parcelRequire("3ItGl")).DEFAULT_ABORT_ERROR_MESSAGE)));
            abortController.current = new AbortController();
            const variables = {
                input: {
                    issueId: `ari:cloud:jira:${cloudId}:issue/${issueId}`,
                    operation: isDragOperation ? 'DRAG' : 'SET',
                    ...startDate != null && startDateField?.id ? {
                        startDate: {
                            fieldId: startDateField.id,
                            date: startDate.date ? {
                                formattedDate: $9b6cd3b79be82381$var$mapDateToValidDateVariable(startDate.date)
                            } : null
                        }
                    } : {},
                    ...dueDate != null ? {
                        dueDate: {
                            fieldId: 'duedate',
                            date: dueDate.date ? {
                                formattedDate: $9b6cd3b79be82381$var$mapDateToValidDateVariable(dueDate.date)
                            } : null
                        }
                    } : {}
                }
            };
            return jiraScheduleItem({
                variables: variables,
                context: {
                    fetchOptions: {
                        signal: abortController.current.signal
                    }
                }
            }).then((result)=>{
                const error = (0, ($parcel$interopDefault($2HfxU)))(result?.data?.jira?.scheduleTimelineItem?.errors);
                if (error || result?.data?.jira?.scheduleTimelineItem?.success !== true) throw new Error(error?.message || 'Timeline schedule item mutation result data included an error or success was not true');
                return result?.data?.jira?.scheduleTimelineItem?.success;
            });
        }, [
            cloudId,
            startDateField,
            jiraScheduleItem
        ]);
        return {
            onScheduleItem: onScheduleItem
        };
    };
});
parcelRegister("fD5PT", function(module, exports) {
    $parcel$export(module.exports, "SCHEDULE_TIMELINE_ITEM_MUTATION", ()=>$857a833340c7246c$export$31219886be2a5896);
    var $5cllN;
    const $857a833340c7246c$export$31219886be2a5896 = (0, (0, parcelRequire("5cllN")).default)`
    mutation ScheduleTimelineItem($input: ScheduleTimelineItemInput!) {
		jira{
			scheduleTimelineItem(input: $input) {
				success
				errors {
					message
					extensions {
						statusCode
						errorType
					}
				}
			}
		}
    }
`;
});
parcelRegister("fvodk", function(module, exports) {
    $parcel$export(module.exports, "shouldScheduleChildrenIssues", ()=>$cabecdbd858998cf$export$f98ee0b182e34597);
    $parcel$export(module.exports, "getIssuesBulkDatesUpdate", ()=>$cabecdbd858998cf$export$6fad4cd647ef6c8c);
    var $lPFae;
    const $cabecdbd858998cf$export$f98ee0b182e34597 = ({ issue: issue, modifiedDates: { startDate: startDate, dueDate: dueDate } })=>{
        const { startDate: oldStartDate, dueDate: oldDueDate, hasChildren: hasChildren } = issue;
        const isBothDatesPopulated = startDate !== undefined && dueDate !== undefined && startDate.date !== null && dueDate.date !== null;
        const isBothDatesUpdated = startDate?.date !== oldStartDate && dueDate?.date !== oldDueDate;
        return hasChildren && isBothDatesPopulated && isBothDatesUpdated;
    };
    const $cabecdbd858998cf$export$6fad4cd647ef6c8c = ({ issue: issue, issueChildren: issueChildren, dates: { startDate: startDate, dueDate: dueDate }, timelineDuration: timelineDuration })=>{
        const bulkUpdates = [];
        const originalValues = [];
        if (issueChildren.length && startDate !== undefined && startDate.date !== null && dueDate !== undefined && dueDate.date !== null) {
            let offset = 0;
            const oldStartDate = issue.startDate ?? null;
            const oldDueDate = issue.dueDate ?? null;
            if (oldStartDate != null) offset = startDate.date - oldStartDate;
            else if (oldDueDate != null) offset = dueDate.date - oldDueDate;
            if (offset) issueChildren.forEach((issueChild)=>{
                const { startDate: childStartDate, dueDate: childDueDate } = issueChild;
                const { startDate: safeStartDate, dueDate: safeDueDate } = (0, (0, parcelRequire("lPFae")).getSafeScheduleDates)({
                    startDate: childStartDate,
                    dueDate: childDueDate,
                    timelineDuration: timelineDuration,
                    offset: offset
                });
                const newStartDate = safeStartDate != null ? (0, (0, parcelRequire("lPFae")).toISOString)(safeStartDate) : null;
                const newDueDate = safeDueDate != null ? (0, (0, parcelRequire("lPFae")).toISOString)(safeDueDate) : null;
                if (childStartDate !== safeStartDate || childDueDate !== safeDueDate) {
                    originalValues.push({
                        id: issueChild.issueId,
                        fields: {
                            startDate: childStartDate ? (0, (0, parcelRequire("lPFae")).toISOString)(childStartDate) : null,
                            dueDate: childDueDate ? (0, (0, parcelRequire("lPFae")).toISOString)(childDueDate) : null
                        }
                    });
                    bulkUpdates.push({
                        id: issueChild.issueId,
                        fields: {
                            startDate: {
                                date: newStartDate
                            },
                            dueDate: {
                                date: newDueDate
                            }
                        }
                    });
                }
            });
        }
        return {
            bulkUpdates: bulkUpdates,
            originalValues: originalValues
        };
    };
});
parcelRegister("gSLj9", function(module, exports) {
    $parcel$export(module.exports, "useIntersectionObserver", ()=>$8b0dcea2d5da14f8$export$a7395f9832c00176);
    var $5uXOq = parcelRequire("5uXOq");
    const $8b0dcea2d5da14f8$export$a7395f9832c00176 = (onIntersection)=>{
        const [ref, setRef] = (0, $5uXOq.useState)(null);
        const handleObserver = (0, $5uXOq.useCallback)((entries)=>{
            entries.forEach(({ isIntersecting: isIntersecting })=>{
                if (isIntersecting) onIntersection();
            });
        }, [
            onIntersection
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!ref || false) return undefined;
            const observer = new IntersectionObserver(handleObserver, {
                root: null,
                rootMargin: '20px',
                threshold: 0
            });
            if (ref) observer.observe(ref);
            return ()=>{
                observer.disconnect();
            };
        }, [
            ref,
            onIntersection,
            handleObserver
        ]);
        return setRef;
    };
});
parcelRegister("bZkBl", function(module, exports) {
    $parcel$export(module.exports, "useListItemMenuOptions", ()=>$f260b7b0af2678d0$export$1951ac3cbf4049a0);
    var $5uXOq = parcelRequire("5uXOq");
    var $4R6GH;
    var $dAmbh;
    var $iZN6h;
    var $jxXX4;
    var $jxKr9;
    var $8g1ru;
    const $f260b7b0af2678d0$export$1951ac3cbf4049a0 = ()=>{
        const isLinkingEnabled = (0, (0, parcelRequire("dAmbh")).useIsLinkingEnabled)();
        const { hasScheduleIssues: hasScheduleIssues, hasIssueLinking: hasIssueLinking } = (0, (0, parcelRequire("jxKr9")).useTimelineFeatures)();
        const { ITEMS_SECTION: ITEMS_SECTION, MOVE_ITEM: MOVE_ITEM, CREATE_ITEM: CREATE_ITEM, CREATE_CHILD_ITEM: CREATE_CHILD_ITEM, CREATE_ITEM_ABOVE: CREATE_ITEM_ABOVE, MOVE_ITEM_UP: MOVE_ITEM_UP, MOVE_ITEM_DOWN: MOVE_ITEM_DOWN, MOVE_ITEM_TO_TOP: MOVE_ITEM_TO_TOP, MOVE_ITEM_TO_BOTTOM: MOVE_ITEM_TO_BOTTOM, SELECTED_ITEM_COUNTER: SELECTED_ITEM_COUNTER } = (0, (0, parcelRequire("iZN6h")).listItemMenu);
        const overrideLabels = (0, $5uXOq.useMemo)(()=>({
                [ITEMS_SECTION]: (0, (0, parcelRequire("8g1ru")).default)[ITEMS_SECTION],
                [CREATE_ITEM]: (0, (0, parcelRequire("8g1ru")).default)[CREATE_ITEM],
                [MOVE_ITEM]: (0, (0, parcelRequire("8g1ru")).default)[MOVE_ITEM],
                [CREATE_CHILD_ITEM]: (0, (0, parcelRequire("8g1ru")).default)[CREATE_CHILD_ITEM],
                [CREATE_ITEM_ABOVE]: (0, (0, parcelRequire("8g1ru")).default)[CREATE_ITEM_ABOVE],
                [MOVE_ITEM_UP]: (0, (0, parcelRequire("8g1ru")).default)[MOVE_ITEM_UP],
                [MOVE_ITEM_DOWN]: (0, (0, parcelRequire("8g1ru")).default)[MOVE_ITEM_DOWN],
                [MOVE_ITEM_TO_TOP]: (0, (0, parcelRequire("8g1ru")).default)[MOVE_ITEM_TO_TOP],
                [MOVE_ITEM_TO_BOTTOM]: (0, (0, parcelRequire("8g1ru")).default)[MOVE_ITEM_TO_BOTTOM],
                [SELECTED_ITEM_COUNTER]: (0, (0, parcelRequire("8g1ru")).default)[SELECTED_ITEM_COUNTER]
            }), [
            CREATE_CHILD_ITEM,
            CREATE_ITEM,
            CREATE_ITEM_ABOVE,
            ITEMS_SECTION,
            MOVE_ITEM,
            MOVE_ITEM_DOWN,
            MOVE_ITEM_TO_BOTTOM,
            MOVE_ITEM_TO_TOP,
            MOVE_ITEM_UP,
            SELECTED_ITEM_COUNTER
        ]);
        const schedulingOptions = (0, $5uXOq.useMemo)(()=>[
                ...hasScheduleIssues && (0, (0, parcelRequire("4R6GH")).fg)('jwm_timeline_meatballs_date_update') ? [
                    {
                        id: (0, (0, parcelRequire("jxXX4")).EDIT_DATES)
                    },
                    {
                        id: (0, (0, parcelRequire("jxXX4")).REMOVE_DATES)
                    }
                ] : [],
                ...hasIssueLinking && isLinkingEnabled && (0, (0, parcelRequire("4R6GH")).fg)('jwm_timeline_meatballs_edit_dependency') ? [
                    {
                        id: (0, (0, parcelRequire("jxXX4")).EDIT_DEPENDENCY)
                    }
                ] : []
            ], [
            hasIssueLinking,
            hasScheduleIssues,
            isLinkingEnabled
        ]);
        const listItemMenuOptions = (0, $5uXOq.useMemo)(()=>({
                overrideLabels: overrideLabels,
                customSections: [
                    {
                        id: ITEMS_SECTION,
                        title: (0, (0, parcelRequire("8g1ru")).default)[ITEMS_SECTION],
                        options: [
                            ...(0, (0, parcelRequire("4R6GH")).fg)('jwm_timeline_meatball_reparent_menu') ? [
                                {
                                    id: (0, (0, parcelRequire("jxXX4")).CHANGE_PARENT_ISSUE)
                                }
                            ] : []
                        ]
                    },
                    ...schedulingOptions.length > 0 ? [
                        {
                            id: (0, (0, parcelRequire("jxXX4")).SCHEDULING_SECTION),
                            title: (0, (0, parcelRequire("8g1ru")).default)[0, (0, parcelRequire("jxXX4")).SCHEDULING_SECTION],
                            options: schedulingOptions
                        }
                    ] : []
                ],
                customSectionsBulk: []
            }), [
            ITEMS_SECTION,
            overrideLabels,
            schedulingOptions
        ]);
        return listItemMenuOptions;
    };
});
parcelRegister("jxXX4", function(module, exports) {
    $parcel$export(module.exports, "timelineProps", ()=>$e52c3ac42395c371$export$3043dd4bffe33000);
    $parcel$export(module.exports, "CHANGE_PARENT_ISSUE", ()=>$e52c3ac42395c371$export$5a0f05a726955e4b);
    $parcel$export(module.exports, "REMOVE_DATES", ()=>$e52c3ac42395c371$export$7fdcec4cf891105d);
    $parcel$export(module.exports, "REMOVE_DUE_DATE", ()=>$e52c3ac42395c371$export$3d55939abaccfa3a);
    $parcel$export(module.exports, "REMOVE_START_DATE", ()=>$e52c3ac42395c371$export$8bfecf0f063625c9);
    $parcel$export(module.exports, "REMOVE_START_DATE_AND_DUE_DATE", ()=>$e52c3ac42395c371$export$9a2eb0ee3249713e);
    $parcel$export(module.exports, "EDIT_DATES", ()=>$e52c3ac42395c371$export$cbfaa2b9201694be);
    $parcel$export(module.exports, "EDIT_DEPENDENCY", ()=>$e52c3ac42395c371$export$1cdd104841f05601);
    $parcel$export(module.exports, "SCHEDULING_SECTION", ()=>$e52c3ac42395c371$export$621948a1f95448a3);
    var $iZN6h;
    const $e52c3ac42395c371$export$9767e017b05e6b70 = (0, (0, parcelRequire("iZN6h")).DEFAULT_ITEM_HEIGHT);
    const $e52c3ac42395c371$var$scope = 'jwm-timeline';
    const $e52c3ac42395c371$var$isCreateLastEnabled = true;
    const $e52c3ac42395c371$var$isResizeEnabled = true;
    const $e52c3ac42395c371$var$isSelectEnabled = false;
    const $e52c3ac42395c371$var$isDragEnabled = true;
    const $e52c3ac42395c371$var$isHighlightToday = true;
    const $e52c3ac42395c371$var$isHideScrollbar = false;
    const $e52c3ac42395c371$export$3043dd4bffe33000 = {
        itemHeight: $e52c3ac42395c371$export$9767e017b05e6b70,
        scope: $e52c3ac42395c371$var$scope,
        isCreateLastEnabled: $e52c3ac42395c371$var$isCreateLastEnabled,
        isResizeEnabled: $e52c3ac42395c371$var$isResizeEnabled,
        isSelectEnabled: $e52c3ac42395c371$var$isSelectEnabled,
        isDragEnabled: $e52c3ac42395c371$var$isDragEnabled,
        isHighlightToday: $e52c3ac42395c371$var$isHighlightToday,
        isHideScrollbar: $e52c3ac42395c371$var$isHideScrollbar
    };
    const $e52c3ac42395c371$export$5a0f05a726955e4b = 'CHANGE_PARENT_ISSUE';
    const $e52c3ac42395c371$export$7fdcec4cf891105d = 'REMOVE_DATES';
    const $e52c3ac42395c371$export$3d55939abaccfa3a = 'REMOVE_DUE_DATE';
    const $e52c3ac42395c371$export$8bfecf0f063625c9 = 'REMOVE_START_DATE';
    const $e52c3ac42395c371$export$9a2eb0ee3249713e = 'REMOVE_START_DATE_AND_DUE_DATE';
    const $e52c3ac42395c371$export$cbfaa2b9201694be = 'EDIT_DATES';
    const $e52c3ac42395c371$export$1cdd104841f05601 = 'EDIT_DEPENDENCY';
    const $e52c3ac42395c371$export$621948a1f95448a3 = 'schedulingSection';
});
parcelRegister("8g1ru", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$05d9166e439d14ee$export$2e2bcd8739ae039);
    var $7VHMR;
    var $05d9166e439d14ee$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        itemsSection: {
            "id": "business-timeline.controllers.use-list-item-menu-options.items-section",
            "defaultMessage": "Issues"
        },
        schedulingSection: {
            "id": "business-timeline.controllers.use-list-item-menu-options.scheduling-section",
            "defaultMessage": "Scheduling"
        },
        createItem: {
            "id": "business-timeline.controllers.use-list-item-menu-options.create-item",
            "defaultMessage": "Create issue"
        },
        createChildItem: {
            "id": "business-timeline.controllers.use-list-item-menu-options.create-child-item",
            "defaultMessage": "Create child issue"
        },
        createItemAbove: {
            "id": "business-timeline.controllers.use-list-item-menu-options.create-item-above",
            "defaultMessage": "Create issue above"
        },
        moveItem: {
            "id": "business-timeline.controllers.use-list-item-menu-options.move-item",
            "defaultMessage": "Move issue"
        },
        moveItemUp: {
            "id": "business-timeline.controllers.use-list-item-menu-options.move-item-up",
            "defaultMessage": "Move issue up"
        },
        moveItemDown: {
            "id": "business-timeline.controllers.use-list-item-menu-options.move-item-down",
            "defaultMessage": "Move issue down"
        },
        moveItemToTop: {
            "id": "business-timeline.controllers.use-list-item-menu-options.move-item-to-top",
            "defaultMessage": "Move issue to top"
        },
        moveItemToBottom: {
            "id": "business-timeline.controllers.use-list-item-menu-options.move-item-to-bottom",
            "defaultMessage": "Move issue to bottom"
        },
        selectedItemCounter: {
            "id": "business-timeline.controllers.use-list-item-menu-options.selected-item-counter",
            "defaultMessage": "<badge>{count}</badge> {count, plural, one {issue selected} other {issues selected}}"
        }
    });
});
parcelRegister("34FeG", function(module, exports) {
    $parcel$export(module.exports, "ChartItemContentLite", ()=>$1a46956024f8cc2b$export$5e423deb824db21b);
    var $5uXOq = parcelRequire("5uXOq");
    var $d8OAB;
    var $gvxNC;
    var $28XgU;
    const $1a46956024f8cc2b$export$5e423deb824db21b = (props)=>{
        const { issue: issue, startDate: startDate, dueDate: dueDate, level: level } = props;
        const { status: status, startDate: actualStartDate, dueDate: actualDueDate } = issue;
        const color = (0, (0, parcelRequire("28XgU")).getColor)(status.categoryId);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gvxNC")).RoadmapChartItemContentLite), {
            color: color,
            startDate: startDate,
            dueDate: dueDate,
            placeholder: (0, (0, parcelRequire("d8OAB")).getPlaceholder)(!actualStartDate, !actualDueDate),
            level: level
        });
    };
});
parcelRegister("gvxNC", function(module, exports) {
    $parcel$export(module.exports, "RoadmapChartItemContentLite", ()=>$75b34b09b609a7e6$export$440d1bc6878927ac);
    var $5uXOq = parcelRequire("5uXOq");
    var $biT18;
    var $3yzcQ;
    var $apjDv;
    var $9KS0U;
    const $75b34b09b609a7e6$var$DateItemLite = ({ startDate: startDate, dueDate: dueDate, level: level, placeholder: placeholder, color: color })=>{
        const [{ timelineDuration: timelineDuration, timelineWidth: timelineWidth }] = (0, (0, parcelRequire("biT18")).useTimelineState)();
        const barLeftPosition = (0, (0, parcelRequire("apjDv")).getBarLeftPosition)(startDate, timelineDuration, timelineWidth);
        const barRightPosition = (0, (0, parcelRequire("apjDv")).getBarRightPosition)(dueDate, timelineDuration, timelineWidth);
        const isBarVisible = (0, (0, parcelRequire("apjDv")).getIsBarVisible)(barLeftPosition, barRightPosition, timelineWidth);
        if (!isBarVisible) return null;
        const theme = (0, (0, parcelRequire("9KS0U")).getBarTheme)(color);
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            style: {
                ...(0, (0, parcelRequire("3yzcQ")).getBaseBarStyles)({
                    level: level,
                    theme: theme,
                    placeholder: placeholder
                }),
                left: `${barLeftPosition}px`,
                right: `${barRightPosition}px`
            }
        });
    };
    const $75b34b09b609a7e6$export$440d1bc6878927ac = ({ startDate: startDate, dueDate: dueDate, ...restProps })=>{
        if (startDate !== undefined && dueDate !== undefined) return (0, ($parcel$interopDefault($5uXOq))).createElement($75b34b09b609a7e6$var$DateItemLite, {
            ...restProps,
            startDate: startDate,
            dueDate: dueDate
        });
        return null;
    };
});
parcelRegister("3yzcQ", function(module, exports) {
    $parcel$export(module.exports, "getBaseBarStyles", ()=>$aae92349744e78b7$export$bbdfdd7c08708e05);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $joGLY;
    var $15ADj;
    var $knkJA;
    var $4tYfO;
    const $aae92349744e78b7$var$generateBarBackground = ({ theme: theme, placeholder: placeholder })=>{
        if (placeholder === (0, (0, parcelRequire("15ADj")).START_AND_DUE_DATE_PLACEHOLDER)) return `linear-gradient(90deg, ${theme.gradient} 0%, ${theme.background} 30%, ${theme.background} 70%, ${theme.gradient} 100%)`;
        if (placeholder === (0, (0, parcelRequire("15ADj")).START_DATE_PLACEHOLDER)) return `linear-gradient(90deg, ${theme.gradient} 0%, ${theme.background} 30%)`;
        if (placeholder === (0, (0, parcelRequire("15ADj")).DUE_DATE_PLACEHOLDER)) return `linear-gradient(90deg, ${theme.background} 70%, ${theme.gradient} 100%)`;
        return theme.background;
    };
    const $aae92349744e78b7$export$bbdfdd7c08708e05 = ({ level: level, placeholder: placeholder, theme: theme })=>({
            position: 'absolute',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            minWidth: '3px',
            padding: 0,
            zIndex: `${0, (0, parcelRequire("knkJA")).CHART_BAR_Z_INDEX}`,
            height: `${(0, (0, parcelRequire("joGLY")).isBaseLevel)(level) ? `${0, (0, parcelRequire("15ADj")).BASE_BAR_HEIGHT}px` : `${0, (0, parcelRequire("15ADj")).BAR_HEIGHT}px`}`,
            borderRadius: `${(0, (0, parcelRequire("4tYfO")).generateBarBorderRadius)(placeholder)}`,
            background: `${$aae92349744e78b7$var$generateBarBackground({
                placeholder: placeholder,
                theme: theme
            })}`
        });
    const $aae92349744e78b7$export$8759e0e73077886f = ({ placeholder: placeholder, left: left, right: right, theme: theme, level: level, children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            style: {
                left: `${left}px`,
                right: `${right}px`,
                height: `${(0, (0, parcelRequire("joGLY")).isBaseLevel)(level) ? `${0, (0, parcelRequire("15ADj")).BASE_BAR_HEIGHT}px` : `${0, (0, parcelRequire("15ADj")).BAR_HEIGHT}px`}`,
                borderRadius: `${(0, (0, parcelRequire("4tYfO")).generateBarBorderRadius)(placeholder)}`,
                background: `${$aae92349744e78b7$var$generateBarBackground({
                    placeholder: placeholder,
                    theme: theme
                })}`
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _1e0c1txw _4cvr1h6o _1bahesu3 _1ul91b66 _1yt4otz2 _1pby11wp"
            ])
        }, children);
    const $aae92349744e78b7$var$baseBarStyles = null;
});
parcelRegister("joGLY", function(module, exports) {
    $parcel$export(module.exports, "BASE_LEVEL", ()=>$b8fe24bf60ed4875$export$d5993e01b9439be4);
    $parcel$export(module.exports, "PARENT_LEVEL", ()=>$b8fe24bf60ed4875$export$6c5e715ac831956e);
    $parcel$export(module.exports, "isBaseLevel", ()=>$b8fe24bf60ed4875$export$3f3fbf12338c09a4);
    $parcel$export(module.exports, "isParentLevel", ()=>$b8fe24bf60ed4875$export$dbfe1bb564ec5b98);
    const $b8fe24bf60ed4875$export$7f882bb969de14a3 = 0;
    const $b8fe24bf60ed4875$export$d5993e01b9439be4 = 0;
    const $b8fe24bf60ed4875$export$6c5e715ac831956e = 1;
    const $b8fe24bf60ed4875$export$e3140dc7d0c35e48 = (depth)=>depth === $b8fe24bf60ed4875$export$7f882bb969de14a3;
    const $b8fe24bf60ed4875$export$3f3fbf12338c09a4 = (level)=>level === $b8fe24bf60ed4875$export$d5993e01b9439be4;
    const $b8fe24bf60ed4875$export$dbfe1bb564ec5b98 = (level)=>level === $b8fe24bf60ed4875$export$6c5e715ac831956e;
});
parcelRegister("knkJA", function(module, exports) {
    $parcel$export(module.exports, "CHART_BAR_Z_INDEX", ()=>$cd07191b9c4a43cd$export$b769e19d85a0dd1f);
    $parcel$export(module.exports, "OVERLAY_FLYOUT_Z_INDEX", ()=>$cd07191b9c4a43cd$export$607b7b6549bb844a);
    var $gwIPs;
    const $cd07191b9c4a43cd$export$b8c38275349a321a = 2;
    const $cd07191b9c4a43cd$export$bf7c4b09e1259e0c = 2;
    const $cd07191b9c4a43cd$export$b769e19d85a0dd1f = 3;
    const $cd07191b9c4a43cd$export$e3452b0e8cf45d94 = 3;
    const $cd07191b9c4a43cd$export$fd0eb84f1cc64bd1 = 4;
    const $cd07191b9c4a43cd$export$ccfab360c3bec41f = 5;
    const $cd07191b9c4a43cd$export$d0b62675e5ca73fd = 6;
    const $cd07191b9c4a43cd$export$952b9e656bb22739 = 6;
    const $cd07191b9c4a43cd$export$bf33c90eb728615a = 8;
    const $cd07191b9c4a43cd$export$d2c2571c3482d99f = 15;
    const $cd07191b9c4a43cd$export$607b7b6549bb844a = (0, (0, parcelRequire("gwIPs")).layers).navigation;
});
parcelRegister("4tYfO", function(module, exports) {
    $parcel$export(module.exports, "generateBarBorderRadius", ()=>$4a72d727054ccffc$export$f984deddd1b0e289);
    var $15ADj;
    const $4a72d727054ccffc$export$f984deddd1b0e289 = (placeholder)=>{
        if (placeholder === (0, (0, parcelRequire("15ADj")).START_AND_DUE_DATE_PLACEHOLDER)) return 0, (0, parcelRequire("15ADj")).LEFT_AND_RIGHT_PLACEHOLDER_BORDER_RADIUS;
        if (placeholder === (0, (0, parcelRequire("15ADj")).START_DATE_PLACEHOLDER)) return 0, (0, parcelRequire("15ADj")).LEFT_PLACEHOLDER_BORDER_RADIUS;
        if (placeholder === (0, (0, parcelRequire("15ADj")).DUE_DATE_PLACEHOLDER)) return 0, (0, parcelRequire("15ADj")).RIGHT_PLACEHOLDER_BORDER_RADIUS;
        return 0, (0, parcelRequire("15ADj")).DEFAULT_BORDER_RADIUS;
    };
});
parcelRegister("apjDv", function(module, exports) {
    $parcel$export(module.exports, "getBarLeftPosition", ()=>$bc5642321ea52013$export$7515da295c144459);
    $parcel$export(module.exports, "getBarRightPosition", ()=>$bc5642321ea52013$export$6d1b18b85e7cc7aa);
    $parcel$export(module.exports, "getStartDate", ()=>$bc5642321ea52013$export$3ee8fbdbeceaef0e);
    $parcel$export(module.exports, "getDueDate", ()=>$bc5642321ea52013$export$813ac50a60a492f2);
    $parcel$export(module.exports, "getIsBarVisible", ()=>$bc5642321ea52013$export$4a4fadfd0dbb59d8);
    var $bFxJH;
    var $esmwW;
    const $bc5642321ea52013$export$7515da295c144459 = (startDate, timelineDuration, timelineWidth)=>(0, (0, parcelRequire("bFxJH")).getTimelinePositionFromDate)(timelineDuration, timelineWidth, startDate);
    const $bc5642321ea52013$export$6d1b18b85e7cc7aa = (dueDate, timelineDuration, timelineWidth)=>{
        const endOfDueDate = dueDate + (0, (0, parcelRequire("esmwW")).DUE_DATE_OFFSET);
        const leftPosition = (0, (0, parcelRequire("bFxJH")).getTimelinePositionFromDate)(timelineDuration, timelineWidth, endOfDueDate);
        return timelineWidth - leftPosition;
    };
    const $bc5642321ea52013$export$b6b0beaf88b31f31 = (date)=>Math.round(date / (0, $a797a5154a1373bc$export$1f04624003d2da7d)) * (0, $a797a5154a1373bc$export$1f04624003d2da7d);
    const $bc5642321ea52013$export$3ee8fbdbeceaef0e = (leftPosition, timelineDuration, timelineWidth)=>{
        const startDate = (0, (0, parcelRequire("bFxJH")).getDateFromTimelinePosition)(timelineDuration, timelineWidth, leftPosition);
        return $bc5642321ea52013$export$b6b0beaf88b31f31(startDate);
    };
    const $bc5642321ea52013$export$813ac50a60a492f2 = (rightPosition, timelineDuration, timelineWidth)=>{
        const dueDate = (0, (0, parcelRequire("bFxJH")).getDateFromTimelinePosition)(timelineDuration, timelineWidth, timelineWidth - rightPosition) - (0, (0, parcelRequire("esmwW")).DUE_DATE_OFFSET);
        return $bc5642321ea52013$export$b6b0beaf88b31f31(dueDate);
    };
    const $bc5642321ea52013$export$4a4fadfd0dbb59d8 = (barLeftPosition, barRightPosition, timelineWidth)=>{
        const isBeforeTimeline = barLeftPosition < 0 && barRightPosition >= timelineWidth;
        const isAfterTimeline = barLeftPosition >= timelineWidth && barRightPosition < 0;
        return !isBeforeTimeline && !isAfterTimeline;
    };
});
parcelRegister("9KS0U", function(module, exports) {
    $parcel$export(module.exports, "getBarTheme", ()=>$b5f81983fbd88c96$export$9f7946b895cedb51);
    var $iHPnC;
    const $b5f81983fbd88c96$var$colorToBarTheme = (color)=>({
            background: color.primary,
            gradient: color.primaryGradient,
            handle: color.secondary,
            hasContrastSecondaryGradient: color.hasContrastSecondaryGradient
        });
    const $b5f81983fbd88c96$var$barThemes = (0, (0, parcelRequire("iHPnC")).transformColorToTheme)($b5f81983fbd88c96$var$colorToBarTheme);
    const $b5f81983fbd88c96$export$9f7946b895cedb51 = (color)=>$b5f81983fbd88c96$var$barThemes[color] || $b5f81983fbd88c96$var$barThemes.PURPLE;
});
parcelRegister("iHPnC", function(module, exports) {
    $parcel$export(module.exports, "asColor", ()=>$e626bf77f0e696c5$export$b74af6529f09947);
    $parcel$export(module.exports, "asServerColor", ()=>$e626bf77f0e696c5$export$442690a499ee9598);
    $parcel$export(module.exports, "asClassicEpicColor", ()=>$e626bf77f0e696c5$export$eb754032c0b9698c);
    $parcel$export(module.exports, "transformColorToTheme", ()=>$e626bf77f0e696c5$export$37c9bd72afe7f286);
    $parcel$export(module.exports, "getValueFromColor", ()=>$e626bf77f0e696c5$export$a00423580059ae28);
    $parcel$export(module.exports, "getColorFromValue", ()=>$e626bf77f0e696c5$export$6d14528e40cbe34b);
    $parcel$export(module.exports, "toFrontendColor", ()=>$e626bf77f0e696c5$export$574e4dbf3c01f0ad);
    $parcel$export(module.exports, "toBackendColor", ()=>$e626bf77f0e696c5$export$47af25386a01de1);
    $parcel$export(module.exports, "classicToFrontendColor", ()=>$e626bf77f0e696c5$export$8f81207f7ac5fb9a);
    $parcel$export(module.exports, "classicToBackendColor", ()=>$e626bf77f0e696c5$export$28fb68bb1de025d5);
    $parcel$export(module.exports, "getDefaultColorPalette", ()=>$e626bf77f0e696c5$export$f6e067d5c418081a);
    $parcel$export(module.exports, "getLozengeThemeByColor", ()=>$e626bf77f0e696c5$export$949dc67535a8ff2);
    $parcel$export(module.exports, "getRandomColor", ()=>$e626bf77f0e696c5$export$e4369cabd7e84cd9);
    var $ggSx2 = parcelRequire("ggSx2");
    var $heWHN;
    var $ehxiD;
    var $kFsv3;
    const $e626bf77f0e696c5$export$b74af6529f09947 = (color)=>{
        if (color == null) return (0, (0, parcelRequire("kFsv3")).Colors).PURPLE;
        if (color in (0, (0, parcelRequire("kFsv3")).Colors)) return color;
        if (color in (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_COLOR)) return (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_COLOR)[color];
        if (color in (0, (0, parcelRequire("heWHN")).MAP_FROM_AGILE_COLOR)) return (0, (0, parcelRequire("heWHN")).MAP_FROM_AGILE_COLOR)[color];
        if (color in (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_CLASSIC_COLOR)) return (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_CLASSIC_COLOR)[color];
        return (0, (0, parcelRequire("kFsv3")).Colors).PURPLE;
    };
    const $e626bf77f0e696c5$export$442690a499ee9598 = (color)=>{
        if (color == null) return (0, (0, parcelRequire("kFsv3")).ServerColors).SERVER_PURPLE;
        if (color in (0, (0, parcelRequire("kFsv3")).ServerColors)) return color;
        if (color in (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_SERVER_COLOR)) return (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_SERVER_COLOR)[color];
        if (color in (0, (0, parcelRequire("heWHN")).MAP_FROM_AGILE_COLOR) && (0, (0, parcelRequire("heWHN")).MAP_FROM_AGILE_COLOR)[color] in (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_SERVER_COLOR)) return (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_SERVER_COLOR)[(0, (0, parcelRequire("heWHN")).MAP_FROM_AGILE_COLOR)[color]];
        if (color in (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_CLASSIC_COLOR) && (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_CLASSIC_COLOR)[color] in (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_SERVER_COLOR)) return (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_SERVER_COLOR)[(0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_CLASSIC_COLOR)[color]];
        return (0, (0, parcelRequire("kFsv3")).ServerColors).SERVER_PURPLE;
    };
    const $e626bf77f0e696c5$export$eb754032c0b9698c = (color)=>{
        if (color === null) return (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, (0, parcelRequire("kFsv3")).Colors).PURPLE];
        if (color in (0, (0, parcelRequire("kFsv3")).ClassicEpicColors)) return color;
        if (color in (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_CLASSIC_COLOR)) return (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_CLASSIC_COLOR)[color];
        if (color in (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_COLOR) && (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_COLOR)[color] in (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_CLASSIC_COLOR)) return (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_COLOR)[color]];
        if (color in (0, (0, parcelRequire("heWHN")).MAP_FROM_AGILE_COLOR) && (0, (0, parcelRequire("heWHN")).MAP_FROM_AGILE_COLOR)[color] in (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_CLASSIC_COLOR)) return (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, (0, parcelRequire("heWHN")).MAP_FROM_AGILE_COLOR)[color]];
        return (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, (0, parcelRequire("kFsv3")).Colors).PURPLE];
    };
    const $e626bf77f0e696c5$export$1a0a4af71e00cea4 = (color)=>{
        if (color === null) return (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_AGILE_COLOR)[(0, (0, parcelRequire("kFsv3")).Colors).PURPLE];
        if (color in (0, (0, parcelRequire("kFsv3")).AgileColors)) return color;
        if (color in (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_AGILE_COLOR)) return (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_AGILE_COLOR)[color];
        if (color in (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_COLOR) && (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_COLOR)[color] in (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_AGILE_COLOR)) return (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_AGILE_COLOR)[(0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_COLOR)[color]];
        if (color in (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_CLASSIC_COLOR) && (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_CLASSIC_COLOR)[color] in (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_AGILE_COLOR)) return (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_AGILE_COLOR)[(0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_CLASSIC_COLOR)[color]];
        return (0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_AGILE_COLOR)[(0, (0, parcelRequire("kFsv3")).Colors).PURPLE];
    };
    const $e626bf77f0e696c5$export$37c9bd72afe7f286 = (transformation, colorSchemaExtension)=>{
        const newColorSchema = {
            ...(0, (0, parcelRequire("heWHN")).BASE_COLOR_SCHEMA),
            ...colorSchemaExtension
        };
        const extendedColors = (colorSchemaExtension ? Object.keys(colorSchemaExtension) : []).concat(Object.keys((0, (0, parcelRequire("kFsv3")).Colors)));
        return extendedColors.reduce((obj, color)=>({
                ...obj,
                [color]: transformation(newColorSchema[color])
            }), {});
    };
    const $e626bf77f0e696c5$export$a00423580059ae28 = (color)=>(0, (0, parcelRequire("heWHN")).MAP_COLORS_TO_VALUE)[color] || (0, (0, parcelRequire("heWHN")).MAP_COLORS_TO_VALUE)[0, (0, parcelRequire("kFsv3")).PURPLE];
    const $e626bf77f0e696c5$export$6d14528e40cbe34b = (value)=>(0, ($parcel$interopDefault($ggSx2)))((0, (0, parcelRequire("heWHN")).MAP_COLORS_TO_VALUE))[value] || (0, (0, parcelRequire("kFsv3")).PURPLE);
    const $e626bf77f0e696c5$export$574e4dbf3c01f0ad = (colorStr)=>colorStr !== '' && colorStr !== undefined && colorStr !== null && colorStr in (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_COLOR) ? (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_COLOR)[colorStr] : (0, (0, parcelRequire("kFsv3")).PURPLE);
    const $e626bf77f0e696c5$export$47af25386a01de1 = (color)=>(0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_SERVER_COLOR)[color];
    const $e626bf77f0e696c5$export$8f81207f7ac5fb9a = (colorStr)=>colorStr !== '' && colorStr !== undefined && colorStr !== null && colorStr in (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_CLASSIC_COLOR) ? (0, (0, parcelRequire("heWHN")).MAP_FROM_SERVER_CLASSIC_COLOR)[colorStr] : (0, (0, parcelRequire("kFsv3")).PURPLE);
    const $e626bf77f0e696c5$export$28fb68bb1de025d5 = (color)=>(0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_CLASSIC_COLOR)[color];
    const $e626bf77f0e696c5$var$paletteColorValues = $e626bf77f0e696c5$export$37c9bd72afe7f286((colorSchema)=>colorSchema.primary);
    const $e626bf77f0e696c5$export$f6e067d5c418081a = (formatMessage)=>[
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).purpleLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).PURPLE]
            },
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).blueLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).BLUE]
            },
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).greenLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).GREEN]
            },
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).tealLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).TEAL]
            },
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).yellowLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).YELLOW]
            },
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).orangeLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).ORANGE]
            },
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).greyLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).GREY]
            },
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).darkPurpleLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).DARK_PURPLE]
            },
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).darkBlueLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).DARK_BLUE]
            },
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).darkGreenLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).DARK_GREEN]
            },
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).darkTealLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).DARK_TEAL]
            },
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).darkYellowLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).DARK_YELLOW]
            },
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).darkOrangeLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).DARK_ORANGE]
            },
            {
                label: formatMessage((0, (0, parcelRequire("ehxiD")).default).darkGreyLabel),
                value: $e626bf77f0e696c5$var$paletteColorValues[(0, (0, parcelRequire("kFsv3")).Colors).DARK_GREY]
            }
        ];
    const $e626bf77f0e696c5$export$9b822862d986dfdf = $e626bf77f0e696c5$export$37c9bd72afe7f286((colorSchema)=>({
            color: colorSchema.text,
            backgroundColor: colorSchema.textBackground
        }));
    const $e626bf77f0e696c5$export$949dc67535a8ff2 = (color = (0, (0, parcelRequire("heWHN")).DEFAULT_EPIC_COLOR))=>$e626bf77f0e696c5$export$9b822862d986dfdf[color] ?? $e626bf77f0e696c5$export$9b822862d986dfdf[0, (0, parcelRequire("heWHN")).DEFAULT_EPIC_COLOR];
    const $e626bf77f0e696c5$export$e4369cabd7e84cd9 = ()=>{
        const colorKeys = Object.keys((0, (0, parcelRequire("kFsv3")).Colors));
        return colorKeys[Math.floor(Math.random() * colorKeys.length)];
    };
});
parcelRegister("heWHN", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_EPIC_COLOR", ()=>$3a4ee6f2b0ce40ab$export$c2357bec51c5cf5b);
    $parcel$export(module.exports, "MAP_COLORS_TO_VALUE", ()=>$3a4ee6f2b0ce40ab$export$db33d74b098e3da9);
    $parcel$export(module.exports, "MAP_COLORS_TO_TOKEN", ()=>$3a4ee6f2b0ce40ab$export$fc5fe4213a5703f1);
    $parcel$export(module.exports, "MAP_VALUE_TO_COLOR", ()=>$3a4ee6f2b0ce40ab$export$a6cb26e106674600);
    $parcel$export(module.exports, "MAP_FROM_SERVER_COLOR", ()=>$3a4ee6f2b0ce40ab$export$43264b0781f10167);
    $parcel$export(module.exports, "MAP_FROM_CLIENT_SERVER_COLOR", ()=>$3a4ee6f2b0ce40ab$export$aedca9f3a1ee43d7);
    $parcel$export(module.exports, "MAP_FROM_SERVER_CLASSIC_COLOR", ()=>$3a4ee6f2b0ce40ab$export$fb5d051fe1b2bccc);
    $parcel$export(module.exports, "MAP_FROM_CLIENT_CLASSIC_COLOR", ()=>$3a4ee6f2b0ce40ab$export$c13af2d9629c53d8);
    $parcel$export(module.exports, "MAP_FROM_AGILE_COLOR", ()=>$3a4ee6f2b0ce40ab$export$994d3ffa39be04fd);
    $parcel$export(module.exports, "MAP_FROM_CLIENT_AGILE_COLOR", ()=>$3a4ee6f2b0ce40ab$export$db17671bf37971e7);
    $parcel$export(module.exports, "MAP_CLASSIC_COLOR_TO_AGILE_COLOR", ()=>$3a4ee6f2b0ce40ab$export$1fdd5a248b5f697c);
    $parcel$export(module.exports, "MAP_COLOR_TO_AK_COLOR", ()=>$3a4ee6f2b0ce40ab$export$82fc3b0b98905453);
    $parcel$export(module.exports, "MAP_AGILE_COLOR_TO_AK_COLOR", ()=>$3a4ee6f2b0ce40ab$export$703aca53c431bb88);
    $parcel$export(module.exports, "BASE_COLOR_SCHEMA", ()=>$3a4ee6f2b0ce40ab$export$92b6aebfb522f0d9);
    var $ggSx2 = parcelRequire("ggSx2");
    var $kFsv3;
    const $3a4ee6f2b0ce40ab$export$c2357bec51c5cf5b = 'PURPLE';
    const $3a4ee6f2b0ce40ab$export$db33d74b098e3da9 = {
        [(0, (0, parcelRequire("kFsv3")).PURPLE)]: `var(--ds-background-accent-purple-subtle, ${(0, $72ba03e317f3d228$exports).P200})`,
        [(0, (0, parcelRequire("kFsv3")).BLUE)]: `var(--ds-background-accent-blue-subtle, ${(0, $72ba03e317f3d228$exports).B200})`,
        [(0, (0, parcelRequire("kFsv3")).GREEN)]: `var(--ds-background-accent-green-subtle, ${(0, $72ba03e317f3d228$exports).G200})`,
        [(0, (0, parcelRequire("kFsv3")).TEAL)]: `var(--ds-background-accent-teal-subtle, ${(0, $72ba03e317f3d228$exports).T200})`,
        [(0, (0, parcelRequire("kFsv3")).YELLOW)]: `var(--ds-background-accent-yellow-subtle, ${(0, $72ba03e317f3d228$exports).Y200})`,
        [(0, (0, parcelRequire("kFsv3")).ORANGE)]: `var(--ds-background-accent-red-subtle, ${(0, $72ba03e317f3d228$exports).R200})`,
        [(0, (0, parcelRequire("kFsv3")).GREY)]: `var(--ds-background-accent-gray-subtle, ${(0, $72ba03e317f3d228$exports).N200})`,
        [(0, (0, parcelRequire("kFsv3")).DARK_PURPLE)]: `var(--ds-background-accent-purple-bolder, ${(0, $72ba03e317f3d228$exports).P400})`,
        [(0, (0, parcelRequire("kFsv3")).DARK_BLUE)]: `var(--ds-background-accent-blue-bolder, ${(0, $72ba03e317f3d228$exports).B400})`,
        [(0, (0, parcelRequire("kFsv3")).DARK_GREEN)]: `var(--ds-background-accent-green-bolder, ${(0, $72ba03e317f3d228$exports).G400})`,
        [(0, (0, parcelRequire("kFsv3")).DARK_TEAL)]: `var(--ds-background-accent-teal-bolder, ${(0, $72ba03e317f3d228$exports).T400})`,
        [(0, (0, parcelRequire("kFsv3")).DARK_YELLOW)]: `var(--ds-background-accent-orange-bolder, ${(0, $72ba03e317f3d228$exports).Y400})`,
        [(0, (0, parcelRequire("kFsv3")).DARK_ORANGE)]: `var(--ds-background-accent-red-bolder, ${(0, $72ba03e317f3d228$exports).R400})`,
        [(0, (0, parcelRequire("kFsv3")).DARK_GREY)]: `var(--ds-background-accent-gray-bolder, ${(0, $72ba03e317f3d228$exports).N700})`
    };
    const $3a4ee6f2b0ce40ab$export$fc5fe4213a5703f1 = {
        [(0, $72ba03e317f3d228$exports).P200]: `var(--ds-background-accent-purple-subtle, ${(0, $72ba03e317f3d228$exports).P200})`,
        [(0, $72ba03e317f3d228$exports).B200]: `var(--ds-background-accent-blue-subtle, ${(0, $72ba03e317f3d228$exports).B200})`,
        [(0, $72ba03e317f3d228$exports).G200]: `var(--ds-background-accent-green-subtle, ${(0, $72ba03e317f3d228$exports).G200})`,
        [(0, $72ba03e317f3d228$exports).T200]: `var(--ds-background-accent-teal-subtle, ${(0, $72ba03e317f3d228$exports).T200})`,
        [(0, $72ba03e317f3d228$exports).Y200]: `var(--ds-background-accent-yellow-subtle, ${(0, $72ba03e317f3d228$exports).Y200})`,
        [(0, $72ba03e317f3d228$exports).R200]: `var(--ds-background-accent-red-subtle, ${(0, $72ba03e317f3d228$exports).R200})`,
        [(0, $72ba03e317f3d228$exports).N200]: `var(--ds-background-accent-gray-subtle, ${(0, $72ba03e317f3d228$exports).N200})`,
        [(0, $72ba03e317f3d228$exports).P400]: `var(--ds-background-accent-purple-bolder, ${(0, $72ba03e317f3d228$exports).P400})`,
        [(0, $72ba03e317f3d228$exports).B400]: `var(--ds-background-accent-blue-bolder, ${(0, $72ba03e317f3d228$exports).B400})`,
        [(0, $72ba03e317f3d228$exports).G400]: `var(--ds-background-accent-green-bolder, ${(0, $72ba03e317f3d228$exports).G400})`,
        [(0, $72ba03e317f3d228$exports).T400]: `var(--ds-background-accent-teal-bolder, ${(0, $72ba03e317f3d228$exports).T400})`,
        [(0, $72ba03e317f3d228$exports).Y400]: `var(--ds-background-accent-orange-bolder, ${(0, $72ba03e317f3d228$exports).Y400})`,
        [(0, $72ba03e317f3d228$exports).R400]: `var(--ds-background-accent-red-bolder, ${(0, $72ba03e317f3d228$exports).R400})`,
        [(0, $72ba03e317f3d228$exports).N700]: `var(--ds-background-accent-gray-bolder, ${(0, $72ba03e317f3d228$exports).N700})`
    };
    const $3a4ee6f2b0ce40ab$export$a6cb26e106674600 = (0, ($parcel$interopDefault($ggSx2)))($3a4ee6f2b0ce40ab$export$db33d74b098e3da9);
    const $3a4ee6f2b0ce40ab$export$43264b0781f10167 = {
        [(0, (0, parcelRequire("kFsv3")).SERVER_PURPLE)]: (0, (0, parcelRequire("kFsv3")).PURPLE),
        [(0, (0, parcelRequire("kFsv3")).SERVER_DARK_PURPLE)]: (0, (0, parcelRequire("kFsv3")).DARK_PURPLE),
        [(0, (0, parcelRequire("kFsv3")).SERVER_BLUE)]: (0, (0, parcelRequire("kFsv3")).BLUE),
        [(0, (0, parcelRequire("kFsv3")).SERVER_DARK_BLUE)]: (0, (0, parcelRequire("kFsv3")).DARK_BLUE),
        [(0, (0, parcelRequire("kFsv3")).SERVER_GREEN)]: (0, (0, parcelRequire("kFsv3")).GREEN),
        [(0, (0, parcelRequire("kFsv3")).SERVER_DARK_GREEN)]: (0, (0, parcelRequire("kFsv3")).DARK_GREEN),
        [(0, (0, parcelRequire("kFsv3")).SERVER_TEAL)]: (0, (0, parcelRequire("kFsv3")).TEAL),
        [(0, (0, parcelRequire("kFsv3")).SERVER_DARK_TEAL)]: (0, (0, parcelRequire("kFsv3")).DARK_TEAL),
        [(0, (0, parcelRequire("kFsv3")).SERVER_YELLOW)]: (0, (0, parcelRequire("kFsv3")).YELLOW),
        [(0, (0, parcelRequire("kFsv3")).SERVER_DARK_YELLOW)]: (0, (0, parcelRequire("kFsv3")).DARK_YELLOW),
        [(0, (0, parcelRequire("kFsv3")).SERVER_ORANGE)]: (0, (0, parcelRequire("kFsv3")).ORANGE),
        [(0, (0, parcelRequire("kFsv3")).SERVER_DARK_ORANGE)]: (0, (0, parcelRequire("kFsv3")).DARK_ORANGE),
        [(0, (0, parcelRequire("kFsv3")).SERVER_GREY)]: (0, (0, parcelRequire("kFsv3")).GREY),
        [(0, (0, parcelRequire("kFsv3")).SERVER_DARK_GREY)]: (0, (0, parcelRequire("kFsv3")).DARK_GREY)
    };
    const $3a4ee6f2b0ce40ab$export$aedca9f3a1ee43d7 = (0, ($parcel$interopDefault($ggSx2)))($3a4ee6f2b0ce40ab$export$43264b0781f10167);
    const $3a4ee6f2b0ce40ab$export$fb5d051fe1b2bccc = {
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_1)]: (0, (0, parcelRequire("kFsv3")).DARK_GREY),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_2)]: (0, (0, parcelRequire("kFsv3")).DARK_YELLOW),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_3)]: (0, (0, parcelRequire("kFsv3")).YELLOW),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_4)]: (0, (0, parcelRequire("kFsv3")).DARK_BLUE),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_5)]: (0, (0, parcelRequire("kFsv3")).DARK_TEAL),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_6)]: (0, (0, parcelRequire("kFsv3")).GREEN),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_7)]: (0, (0, parcelRequire("kFsv3")).PURPLE),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_8)]: (0, (0, parcelRequire("kFsv3")).DARK_PURPLE),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_9)]: (0, (0, parcelRequire("kFsv3")).ORANGE),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_10)]: (0, (0, parcelRequire("kFsv3")).BLUE),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_11)]: (0, (0, parcelRequire("kFsv3")).TEAL),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_12)]: (0, (0, parcelRequire("kFsv3")).GREY),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_13)]: (0, (0, parcelRequire("kFsv3")).DARK_GREEN),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_14)]: (0, (0, parcelRequire("kFsv3")).DARK_ORANGE)
    };
    const $3a4ee6f2b0ce40ab$export$c13af2d9629c53d8 = (0, ($parcel$interopDefault($ggSx2)))($3a4ee6f2b0ce40ab$export$fb5d051fe1b2bccc);
    const $3a4ee6f2b0ce40ab$export$994d3ffa39be04fd = {
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_1)]: (0, (0, parcelRequire("kFsv3")).DARK_GREY),
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_2)]: (0, (0, parcelRequire("kFsv3")).DARK_YELLOW),
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_3)]: (0, (0, parcelRequire("kFsv3")).YELLOW),
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_4)]: (0, (0, parcelRequire("kFsv3")).DARK_BLUE),
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_5)]: (0, (0, parcelRequire("kFsv3")).DARK_TEAL),
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_6)]: (0, (0, parcelRequire("kFsv3")).GREEN),
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_7)]: (0, (0, parcelRequire("kFsv3")).PURPLE),
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_8)]: (0, (0, parcelRequire("kFsv3")).DARK_PURPLE),
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_9)]: (0, (0, parcelRequire("kFsv3")).ORANGE),
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_10)]: (0, (0, parcelRequire("kFsv3")).BLUE),
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_11)]: (0, (0, parcelRequire("kFsv3")).TEAL),
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_12)]: (0, (0, parcelRequire("kFsv3")).GREY),
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_13)]: (0, (0, parcelRequire("kFsv3")).DARK_GREEN),
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_14)]: (0, (0, parcelRequire("kFsv3")).DARK_ORANGE)
    };
    const $3a4ee6f2b0ce40ab$export$db17671bf37971e7 = (0, ($parcel$interopDefault($ggSx2)))($3a4ee6f2b0ce40ab$export$994d3ffa39be04fd);
    const $3a4ee6f2b0ce40ab$export$1fdd5a248b5f697c = {
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_1)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_1),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_2)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_2),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_3)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_3),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_4)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_4),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_5)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_5),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_6)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_6),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_7)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_7),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_8)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_8),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_9)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_9),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_10)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_10),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_11)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_11),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_12)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_12),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_13)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_13),
        [(0, (0, parcelRequire("kFsv3")).GHX_LABEL_14)]: (0, (0, parcelRequire("kFsv3")).AGILE_COLOR_14)
    };
    const $3a4ee6f2b0ce40ab$export$82fc3b0b98905453 = {
        [(0, (0, parcelRequire("kFsv3")).DARK_GREY)]: 'grey',
        [(0, (0, parcelRequire("kFsv3")).DARK_YELLOW)]: 'yellow',
        [(0, (0, parcelRequire("kFsv3")).YELLOW)]: 'yellowLight',
        [(0, (0, parcelRequire("kFsv3")).DARK_BLUE)]: 'blue',
        [(0, (0, parcelRequire("kFsv3")).DARK_TEAL)]: 'teal',
        [(0, (0, parcelRequire("kFsv3")).GREEN)]: 'greenLight',
        [(0, (0, parcelRequire("kFsv3")).PURPLE)]: 'purpleLight',
        [(0, (0, parcelRequire("kFsv3")).DARK_PURPLE)]: 'purple',
        [(0, (0, parcelRequire("kFsv3")).ORANGE)]: 'redLight',
        [(0, (0, parcelRequire("kFsv3")).BLUE)]: 'blueLight',
        [(0, (0, parcelRequire("kFsv3")).TEAL)]: 'tealLight',
        [(0, (0, parcelRequire("kFsv3")).GREY)]: 'greyLight',
        [(0, (0, parcelRequire("kFsv3")).DARK_GREEN)]: 'green',
        [(0, (0, parcelRequire("kFsv3")).DARK_ORANGE)]: 'red'
    };
    const $3a4ee6f2b0ce40ab$export$703aca53c431bb88 = {
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_1)]: 'grey',
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_2)]: 'yellow',
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_3)]: 'yellowLight',
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_4)]: 'blue',
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_5)]: 'teal',
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_6)]: 'greenLight',
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_7)]: 'purpleLight',
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_8)]: 'purple',
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_9)]: 'redLight',
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_10)]: 'blueLight',
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_11)]: 'tealLight',
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_12)]: 'greyLight',
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_13)]: 'green',
        [(0, (0, parcelRequire("kFsv3")).AGILE_COLOR_14)]: 'red'
    };
    const $3a4ee6f2b0ce40ab$export$92b6aebfb522f0d9 = {
        [(0, (0, parcelRequire("kFsv3")).PURPLE)]: {
            primary: `var(--ds-background-accent-purple-subtle, ${(0, $72ba03e317f3d228$exports).P200})`,
            secondary: `var(--ds-background-accent-purple-bolder, ${(0, $72ba03e317f3d228$exports).P500})`,
            text: `var(--ds-text-accent-purple, ${(0, $72ba03e317f3d228$exports).P500})`,
            textBackground: `var(--ds-background-accent-purple-subtler, ${(0, $72ba03e317f3d228$exports).P50})`,
            border: `var(--ds-border-accent-purple, ${(0, $72ba03e317f3d228$exports).P400})`,
            line: `var(--ds-border-accent-purple, ${(0, $72ba03e317f3d228$exports).P300})`,
            primaryGradient: `var(--ds-background-accent-purple-subtler, ${(0, $72ba03e317f3d228$exports).P75})`,
            hasContrastSecondaryGradient: true
        },
        [(0, (0, parcelRequire("kFsv3")).BLUE)]: {
            primary: `var(--ds-background-accent-blue-subtle, ${(0, $72ba03e317f3d228$exports).B200})`,
            secondary: `var(--ds-background-accent-blue-bolder, ${(0, $72ba03e317f3d228$exports).B500})`,
            text: `var(--ds-text-accent-blue, ${(0, $72ba03e317f3d228$exports).B500})`,
            textBackground: `var(--ds-background-accent-blue-subtler, ${(0, $72ba03e317f3d228$exports).B50})`,
            border: `var(--ds-border-accent-blue, ${(0, $72ba03e317f3d228$exports).B400})`,
            line: `var(--ds-border-accent-blue, ${(0, $72ba03e317f3d228$exports).B300})`,
            primaryGradient: `var(--ds-background-accent-blue-subtler, ${(0, $72ba03e317f3d228$exports).B75})`,
            hasContrastSecondaryGradient: true
        },
        [(0, (0, parcelRequire("kFsv3")).GREEN)]: {
            primary: `var(--ds-background-accent-green-subtle, ${(0, $72ba03e317f3d228$exports).G200})`,
            secondary: `var(--ds-background-accent-green-bolder, ${(0, $72ba03e317f3d228$exports).G500})`,
            text: `var(--ds-text-accent-green, ${(0, $72ba03e317f3d228$exports).G500})`,
            textBackground: `var(--ds-background-accent-green-subtler, ${(0, $72ba03e317f3d228$exports).G50})`,
            border: `var(--ds-border-accent-green, ${(0, $72ba03e317f3d228$exports).G400})`,
            line: `var(--ds-border-accent-green, ${(0, $72ba03e317f3d228$exports).G300})`,
            primaryGradient: `var(--ds-background-accent-green-subtler, ${(0, $72ba03e317f3d228$exports).G75})`,
            hasContrastSecondaryGradient: true
        },
        [(0, (0, parcelRequire("kFsv3")).TEAL)]: {
            primary: `var(--ds-background-accent-teal-subtle, ${(0, $72ba03e317f3d228$exports).T200})`,
            secondary: `var(--ds-background-accent-teal-bolder, ${(0, $72ba03e317f3d228$exports).T500})`,
            text: `var(--ds-text-accent-teal, ${(0, $72ba03e317f3d228$exports).T500})`,
            textBackground: `var(--ds-background-accent-teal-subtler, ${(0, $72ba03e317f3d228$exports).T50})`,
            border: `var(--ds-border-accent-teal, ${(0, $72ba03e317f3d228$exports).T400})`,
            line: `var(--ds-border-accent-teal, ${(0, $72ba03e317f3d228$exports).T300})`,
            primaryGradient: `var(--ds-background-accent-teal-subtler, ${(0, $72ba03e317f3d228$exports).T75})`,
            hasContrastSecondaryGradient: true
        },
        [(0, (0, parcelRequire("kFsv3")).YELLOW)]: {
            primary: `var(--ds-background-accent-yellow-subtle, ${(0, $72ba03e317f3d228$exports).Y200})`,
            secondary: `var(--ds-background-accent-yellow-bolder, ${(0, $72ba03e317f3d228$exports).Y500})`,
            text: `var(--ds-text-accent-yellow, ${(0, $72ba03e317f3d228$exports).Y500})`,
            textBackground: `var(--ds-background-accent-yellow-subtler, ${(0, $72ba03e317f3d228$exports).Y50})`,
            border: `var(--ds-border-accent-yellow, ${(0, $72ba03e317f3d228$exports).Y400})`,
            line: `var(--ds-border-accent-yellow, ${(0, $72ba03e317f3d228$exports).Y300})`,
            primaryGradient: `var(--ds-background-accent-yellow-subtler, ${(0, $72ba03e317f3d228$exports).Y75})`,
            hasContrastSecondaryGradient: true
        },
        [(0, (0, parcelRequire("kFsv3")).ORANGE)]: {
            primary: `var(--ds-background-accent-red-subtle, ${(0, $72ba03e317f3d228$exports).R200})`,
            secondary: `var(--ds-background-accent-red-bolder, ${(0, $72ba03e317f3d228$exports).R500})`,
            text: `var(--ds-text-accent-red, ${(0, $72ba03e317f3d228$exports).R500})`,
            textBackground: `var(--ds-background-accent-red-subtler, ${(0, $72ba03e317f3d228$exports).R50})`,
            border: `var(--ds-border-accent-red, ${(0, $72ba03e317f3d228$exports).R400})`,
            line: `var(--ds-border-accent-red, ${(0, $72ba03e317f3d228$exports).R300})`,
            primaryGradient: `var(--ds-background-accent-red-subtler, ${(0, $72ba03e317f3d228$exports).R75})`,
            hasContrastSecondaryGradient: true
        },
        [(0, (0, parcelRequire("kFsv3")).GREY)]: {
            primary: `var(--ds-background-accent-gray-subtle, ${(0, $72ba03e317f3d228$exports).N200})`,
            secondary: `var(--ds-background-accent-gray-bolder, ${(0, $72ba03e317f3d228$exports).N500})`,
            text: `var(--ds-text-accent-gray, ${(0, $72ba03e317f3d228$exports).N500})`,
            textBackground: `var(--ds-background-accent-gray-subtler, ${(0, $72ba03e317f3d228$exports).N30})`,
            border: `var(--ds-border-accent-gray, ${(0, $72ba03e317f3d228$exports).N700})`,
            line: `var(--ds-border-accent-gray, ${(0, $72ba03e317f3d228$exports).N500})`,
            primaryGradient: `var(--ds-background-accent-gray-subtler, ${(0, $72ba03e317f3d228$exports).N50})`,
            hasContrastSecondaryGradient: true
        },
        [(0, (0, parcelRequire("kFsv3")).DARK_PURPLE)]: {
            primary: `var(--ds-background-accent-purple-bolder, ${(0, $72ba03e317f3d228$exports).P400})`,
            secondary: `var(--ds-background-accent-purple-subtle, ${(0, $72ba03e317f3d228$exports).P200})`,
            text: `var(--ds-text-inverse, ${(0, $72ba03e317f3d228$exports).N0})`,
            textBackground: `var(--ds-background-accent-purple-bolder, ${(0, $72ba03e317f3d228$exports).P400})`,
            border: `var(--ds-border-accent-purple, ${(0, $72ba03e317f3d228$exports).P100})`,
            line: `var(--ds-border-accent-purple, ${(0, $72ba03e317f3d228$exports).P300})`,
            primaryGradient: `var(--ds-background-accent-purple-subtle, ${(0, $72ba03e317f3d228$exports).P100})`,
            hasContrastSecondaryGradient: false
        },
        [(0, (0, parcelRequire("kFsv3")).DARK_BLUE)]: {
            primary: `var(--ds-background-accent-blue-bolder, ${(0, $72ba03e317f3d228$exports).B400})`,
            secondary: `var(--ds-background-accent-blue-subtle, ${(0, $72ba03e317f3d228$exports).B200})`,
            text: `var(--ds-text-inverse, ${(0, $72ba03e317f3d228$exports).N0})`,
            textBackground: `var(--ds-background-accent-blue-bolder, ${(0, $72ba03e317f3d228$exports).B400})`,
            border: `var(--ds-border-accent-blue, ${(0, $72ba03e317f3d228$exports).B200})`,
            line: `var(--ds-border-accent-blue, ${(0, $72ba03e317f3d228$exports).B100})`,
            primaryGradient: `var(--ds-background-accent-blue-subtle, ${(0, $72ba03e317f3d228$exports).B100})`,
            hasContrastSecondaryGradient: false
        },
        [(0, (0, parcelRequire("kFsv3")).DARK_GREEN)]: {
            primary: `var(--ds-background-accent-green-bolder, ${(0, $72ba03e317f3d228$exports).G400})`,
            secondary: `var(--ds-background-accent-green-subtle, ${(0, $72ba03e317f3d228$exports).G200})`,
            text: `var(--ds-text-inverse, ${(0, $72ba03e317f3d228$exports).N0})`,
            textBackground: `var(--ds-background-accent-green-bolder, ${(0, $72ba03e317f3d228$exports).G400})`,
            border: `var(--ds-border-accent-green, ${(0, $72ba03e317f3d228$exports).G200})`,
            line: `var(--ds-border-accent-green, ${(0, $72ba03e317f3d228$exports).G300})`,
            primaryGradient: `var(--ds-background-accent-green-subtle, ${(0, $72ba03e317f3d228$exports).G200})`,
            hasContrastSecondaryGradient: false
        },
        [(0, (0, parcelRequire("kFsv3")).DARK_TEAL)]: {
            primary: `var(--ds-background-accent-teal-bolder, ${(0, $72ba03e317f3d228$exports).T400})`,
            secondary: `var(--ds-background-accent-teal-subtle, ${(0, $72ba03e317f3d228$exports).T200})`,
            text: `var(--ds-text-inverse, ${(0, $72ba03e317f3d228$exports).N0})`,
            textBackground: `var(--ds-background-accent-teal-bolder, ${(0, $72ba03e317f3d228$exports).T400})`,
            border: `var(--ds-border-accent-teal, ${(0, $72ba03e317f3d228$exports).T200})`,
            line: `var(--ds-border-accent-teal, ${(0, $72ba03e317f3d228$exports).T300})`,
            primaryGradient: `var(--ds-background-accent-teal-subtle, ${(0, $72ba03e317f3d228$exports).T100})`,
            hasContrastSecondaryGradient: false
        },
        [(0, (0, parcelRequire("kFsv3")).DARK_YELLOW)]: {
            primary: `var(--ds-background-accent-orange-bolder, ${(0, $72ba03e317f3d228$exports).Y400})`,
            secondary: `var(--ds-background-accent-orange-subtle, ${(0, $72ba03e317f3d228$exports).Y200})`,
            text: `var(--ds-text-inverse, ${(0, $72ba03e317f3d228$exports).N0})`,
            textBackground: `var(--ds-background-accent-orange-bolder, ${(0, $72ba03e317f3d228$exports).Y400})`,
            border: `var(--ds-background-accent-orange-subtle, ${(0, $72ba03e317f3d228$exports).Y200})`,
            line: `var(--ds-border-accent-orange, ${(0, $72ba03e317f3d228$exports).Y300})`,
            primaryGradient: `var(--ds-background-accent-orange-subtle, ${(0, $72ba03e317f3d228$exports).Y100})`,
            hasContrastSecondaryGradient: false
        },
        [(0, (0, parcelRequire("kFsv3")).DARK_ORANGE)]: {
            primary: `var(--ds-background-accent-red-bolder, ${(0, $72ba03e317f3d228$exports).R400})`,
            secondary: `var(--ds-background-accent-red-subtle, ${(0, $72ba03e317f3d228$exports).R200})`,
            text: `var(--ds-text-inverse, ${(0, $72ba03e317f3d228$exports).N0})`,
            textBackground: `var(--ds-background-accent-red-bolder, ${(0, $72ba03e317f3d228$exports).R400})`,
            border: `var(--ds-background-accent-red-subtle, ${(0, $72ba03e317f3d228$exports).R100})`,
            line: `var(--ds-border-accent-red, ${(0, $72ba03e317f3d228$exports).R300})`,
            primaryGradient: `var(--ds-background-accent-red-subtle, ${(0, $72ba03e317f3d228$exports).R100})`,
            hasContrastSecondaryGradient: false
        },
        [(0, (0, parcelRequire("kFsv3")).DARK_GREY)]: {
            primary: `var(--ds-background-accent-gray-bolder, ${(0, $72ba03e317f3d228$exports).N700})`,
            secondary: `var(--ds-background-accent-gray-subtle, ${(0, $72ba03e317f3d228$exports).N300})`,
            text: `var(--ds-text-inverse, ${(0, $72ba03e317f3d228$exports).N0})`,
            textBackground: `var(--ds-background-accent-gray-bolder, ${(0, $72ba03e317f3d228$exports).N500})`,
            border: `var(--ds-background-accent-gray-subtle, ${(0, $72ba03e317f3d228$exports).N100})`,
            line: `var(--ds-border-accent-gray, ${(0, $72ba03e317f3d228$exports).N500})`,
            primaryGradient: `var(--ds-background-accent-gray-subtle, ${(0, $72ba03e317f3d228$exports).N100})`,
            hasContrastSecondaryGradient: false
        }
    };
});
parcelRegister("ehxiD", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$50b7e3d933c7b9f7$export$2e2bcd8739ae039);
    var $7VHMR;
    var $50b7e3d933c7b9f7$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        purpleLabel: {
            "id": "issue-epic-color.common.purple-label",
            "defaultMessage": "purple"
        },
        blueLabel: {
            "id": "issue-epic-color.common.blue-label",
            "defaultMessage": "blue"
        },
        greenLabel: {
            "id": "issue-epic-color.common.green-label",
            "defaultMessage": "green"
        },
        tealLabel: {
            "id": "issue-epic-color.common.teal-label",
            "defaultMessage": "teal"
        },
        yellowLabel: {
            "id": "issue-epic-color.common.yellow-label",
            "defaultMessage": "yellow"
        },
        orangeLabel: {
            "id": "issue-epic-color.common.orange-label",
            "defaultMessage": "orange"
        },
        greyLabel: {
            "id": "issue-epic-color.common.grey-label",
            "defaultMessage": "grey"
        },
        darkPurpleLabel: {
            "id": "issue-epic-color.common.dark-purple-label",
            "defaultMessage": "dark purple"
        },
        darkBlueLabel: {
            "id": "issue-epic-color.common.dark-blue-label",
            "defaultMessage": "dark blue"
        },
        darkGreenLabel: {
            "id": "issue-epic-color.common.dark-green-label",
            "defaultMessage": "dark green"
        },
        darkTealLabel: {
            "id": "issue-epic-color.common.dark-teal-label",
            "defaultMessage": "dark teal"
        },
        darkYellowLabel: {
            "id": "issue-epic-color.common.dark-yellow-label",
            "defaultMessage": "dark yellow"
        },
        darkOrangeLabel: {
            "id": "issue-epic-color.common.dark-orange-label",
            "defaultMessage": "dark orange"
        },
        darkGreyLabel: {
            "id": "issue-epic-color.common.dark-grey-label",
            "defaultMessage": "dark grey"
        }
    });
});
parcelRegister("kHUUS", function(module, exports) {
    $parcel$export(module.exports, "ChartItemContentSkeleton", ()=>$59cca86e4f226d4a$export$e1058ec667e297ea);
    var $5uXOq = parcelRequire("5uXOq");
    var $gwejS;
    var $b77vc;
    var $pyK8a;
    var $apjDv;
    var $iZN6h;
    var $biT18;
    var $fWZbP;
    const $59cca86e4f226d4a$export$e1058ec667e297ea = (0, $5uXOq.memo)(()=>{
        const [{ timelineDuration: timelineDuration, timelineWidth: timelineWidth }] = (0, (0, parcelRequire("biT18")).useTimelineState)();
        const today = Date.now();
        const startDate = (0, (0, parcelRequire("b77vc")).default)((0, (0, parcelRequire("pyK8a")).default)(today, Math.floor(Math.random() * 10) + 1));
        const dueDate = (0, (0, parcelRequire("b77vc")).default)((0, (0, parcelRequire("gwejS")).default)(today, Math.floor(Math.random() * 10) + 30));
        const leftPosition = (0, (0, parcelRequire("apjDv")).getBarLeftPosition)(startDate, timelineDuration, timelineWidth);
        const rightPosition = (0, (0, parcelRequire("apjDv")).getBarRightPosition)(dueDate, timelineDuration, timelineWidth);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fWZbP")).LoadingBar), {
            leftPosition: leftPosition,
            rightPosition: rightPosition,
            itemHeight: (0, (0, parcelRequire("iZN6h")).DEFAULT_ITEM_HEIGHT)
        });
    });
});
parcelRegister("k09y7", function(module, exports) {
    $parcel$export(module.exports, "ChartItemContent", ()=>$987acf2cd616f1a3$export$ef51232970f03d8e);
    var $5uXOq = parcelRequire("5uXOq");
    var $deqCE;
    var $g5X3G;
    var $joGLY;
    var $esmwW;
    var $9yxkx;
    var $dadh5;
    var $28XgU;
    var $jxKr9;
    var $6SGOe;
    var $9con3;
    const $987acf2cd616f1a3$var$DndLongTaskMetricComponent = ({ level: level, isDragging: isDragging })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dadh5")).DndLongTaskMetric), {
            isDragging: isDragging,
            metricType: (0, $8038b72ffd5aa8d4$export$2475592765cae5b0),
            extraProps: {
                isBaseLevel: (0, (0, parcelRequire("joGLY")).isBaseLevel)(level)
            }
        });
    const $987acf2cd616f1a3$export$ef51232970f03d8e = (0, $5uXOq.memo)((props)=>{
        const { isExportTable: isExportTable, isHovered: isHovered, isReadOnly: isReadOnly, issue: issue, level: level, onItemUpdate: onItemUpdate, placeholder: placeholder, setSelectedIssueKey: setSelectedIssueKey } = props;
        let { dueDate: dueDate, startDate: startDate } = props;
        const warnings = [];
        if (dueDate !== undefined && startDate !== undefined && dueDate < startDate) {
            warnings.push((0, (0, parcelRequire("9con3")).START_DATE_LATER_DUE_DATE_MESSAGE_ID));
            [startDate, dueDate] = [
                dueDate,
                startDate
            ];
        }
        const { status: status, issueId: issueId } = issue;
        const color = (0, (0, parcelRequire("28XgU")).getColor)(status.categoryId);
        const { issueViewInteraction: issueViewInteraction } = (0, (0, parcelRequire("jxKr9")).useTimelineFeatures)();
        const onUpdate = (0, $5uXOq.useCallback)((id, param, analyticEvent)=>{
            onItemUpdate((0, (0, parcelRequire("g5X3G")).toIssueId)(id), param, analyticEvent);
        }, [
            onItemUpdate
        ]);
        const leftClickHandler = (0, $5uXOq.useCallback)((_id, meta)=>{
            if (issue.id.startsWith((0, (0, parcelRequire("deqCE")).OPTIMISTIC_ID_PREFIX))) return;
            if (issueViewInteraction === 'openNewTab' || meta.withCmd || meta.withShift) {
                window.open(`/browse/${issue.key}`, '_blank');
                return;
            }
            setSelectedIssueKey(issue.key);
        }, [
            issue.id,
            issue.key,
            issueViewInteraction,
            setSelectedIssueKey
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9yxkx")).RoadmapChartItemContent), {
            renderBarContent: isExportTable ? undefined : (0, (0, parcelRequire("6SGOe")).renderBarContent),
            onUpdate: onUpdate,
            level: level,
            isHovered: isHovered,
            id: issueId,
            color: color,
            startDate: startDate,
            dueDate: dueDate,
            startDateType: (0, (0, parcelRequire("esmwW")).EXPLICIT),
            dueDateType: (0, (0, parcelRequire("esmwW")).EXPLICIT),
            placeholder: placeholder,
            DndLongTaskMetric: $987acf2cd616f1a3$var$DndLongTaskMetricComponent,
            isReadOnly: isReadOnly,
            onLeftClick: leftClickHandler,
            warnings: warnings
        });
    });
});
parcelRegister("9yxkx", function(module, exports) {
    $parcel$export(module.exports, "RoadmapChartItemContent", ()=>$b80a259a3f2cb3dd$export$3b537bb5a0afaee4);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $esmwW;
    var $2KlaV;
    var $bbHVB;
    var $4lsbG;
    var $8Pp9Z;
    const $b80a259a3f2cb3dd$export$3b537bb5a0afaee4 = ({ id: id, startDate: startDate, dueDate: dueDate, color: color, level: level, startDateType: startDateType, dueDateType: dueDateType, placeholder: placeholder, DndLongTaskMetric: DndLongTaskMetric, warnings: warnings, intervals: intervals, isHovered: isHovered, isReadOnly: isReadOnly, onLeftClick: onLeftClick, onRightClick: onRightClick, onUpdate: onUpdate, renderBarContent: renderBarContent })=>{
        if (startDate !== undefined && dueDate !== undefined) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, !isReadOnly && intervals.length > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4lsbG")).IntervalDropZones), {
            id: id,
            intervals: intervals
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bbHVB")).DateContent), {
            id: id,
            color: color,
            level: level,
            startDate: startDate,
            dueDate: dueDate,
            startDateType: startDateType,
            dueDateType: dueDateType,
            warnings: warnings,
            placeholder: placeholder,
            isHovered: isHovered,
            isReadOnly: isReadOnly,
            onLeftClick: onLeftClick,
            onRightClick: onRightClick,
            onUpdate: onUpdate,
            renderBarContent: renderBarContent,
            DndLongTaskMetric: DndLongTaskMetric
        }));
        return !isReadOnly ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8Pp9Z")).NoDateContent), {
            id: id,
            level: level,
            color: color,
            startDateType: startDateType,
            dueDateType: dueDateType,
            isHovered: isHovered,
            onUpdate: onUpdate
        }, intervals.length > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4lsbG")).IntervalDropZones), {
            id: id,
            intervals: intervals,
            onClick: onUpdate
        }))) : null;
    };
    $b80a259a3f2cb3dd$export$3b537bb5a0afaee4.defaultProps = {
        startDateType: (0, (0, parcelRequire("esmwW")).EXPLICIT),
        dueDateType: (0, (0, parcelRequire("esmwW")).EXPLICIT),
        DndLongTaskMetric: ()=>null,
        warnings: [],
        intervals: [],
        isReadOnly: false,
        onLeftClick: (0, ($parcel$interopDefault($8Rkzz))),
        renderBarContent: (0, (0, parcelRequire("2KlaV")).DEFAULT_RENDERER)
    };
});
parcelRegister("bbHVB", function(module, exports) {
    $parcel$export(module.exports, "DateContent", ()=>$5d0b3ad119245818$export$cede4067c9cec7c9);
    var $5uXOq = parcelRequire("5uXOq");
    var $biT18;
    var $esmwW;
    var $6gIAo;
    var $apjDv;
    var $hjVf3;
    var $Aa6uS;
    const $5d0b3ad119245818$export$cede4067c9cec7c9 = ({ id: id, color: color, level: level, startDate: startDate, dueDate: dueDate, startDateType: startDateType, dueDateType: dueDateType, warnings: warnings, placeholder: placeholder, isHovered: isHovered, isReadOnly: isReadOnly, DndLongTaskMetric: DndLongTaskMetric, renderBarContent: renderBarContent, onUpdate: onUpdate, onLeftClick: onLeftClick, onRightClick: onRightClick })=>{
        const [{ timelineDuration: timelineDuration, timelineWidth: timelineWidth }] = (0, (0, parcelRequire("biT18")).useTimelineState)();
        const barLeftPosition = (0, (0, parcelRequire("apjDv")).getBarLeftPosition)(startDate, timelineDuration, timelineWidth);
        const barRightPosition = (0, (0, parcelRequire("apjDv")).getBarRightPosition)(dueDate, timelineDuration, timelineWidth);
        const isBarVisible = (0, (0, parcelRequire("apjDv")).getIsBarVisible)(barLeftPosition, barRightPosition, timelineWidth);
        if (!isBarVisible) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hjVf3")).RoadmapBar), {
            id: id,
            left: barLeftPosition,
            right: barRightPosition,
            color: color,
            level: level,
            startDateType: startDateType,
            dueDateType: dueDateType,
            warnings: warnings,
            placeholder: placeholder,
            isReadOnly: isReadOnly,
            onUpdate: onUpdate,
            onLeftClick: onLeftClick,
            onRightClick: onRightClick,
            renderBarContent: renderBarContent,
            DndLongTaskMetric: DndLongTaskMetric
        }), isHovered && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("Aa6uS")).RoadmapNavigateButton), {
            itemMinLeftPosition: barLeftPosition,
            itemMaxRightPosition: barRightPosition,
            label: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6gIAo")).FormattedDate), {
                startDate: startDate,
                startDateType: startDateType,
                dueDate: dueDate,
                dueDateType: dueDateType,
                placeholder: placeholder,
                isDurationVisible: !placeholder
            })
        }));
    };
    $5d0b3ad119245818$export$cede4067c9cec7c9.defaultProps = {
        startDateType: (0, (0, parcelRequire("esmwW")).EXPLICIT),
        dueDateType: (0, (0, parcelRequire("esmwW")).EXPLICIT)
    };
});
parcelRegister("6gIAo", function(module, exports) {
    $parcel$export(module.exports, "FormattedDate", ()=>$56f9e8a00236f718$export$40ae3194919d16b);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $4R6GH;
    var $koVbs;
    var $g11uZ;
    var $dCm1o;
    var $esmwW;
    var $2KlaV;
    var $d8OAB;
    var $cNXyp;
    var $d6q2B;
    var $fRvoq;
    const $56f9e8a00236f718$export$40ae3194919d16b = ({ startDate: startDate, dueDate: dueDate, startDateType: startDateType = (0, (0, parcelRequire("esmwW")).EXPLICIT), dueDateType: dueDateType = (0, (0, parcelRequire("esmwW")).EXPLICIT), placeholder: placeholder, isDurationVisible: isDurationVisible = false, placement: placement, renderDuration: renderDuration })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const startDatePlaceholderMessage = (0, (0, parcelRequire("d8OAB")).isStartDatePlaceholder)(placeholder) ? formatMessage((0, (0, parcelRequire("fRvoq")).default).noStartDate) : undefined;
        const dueDatePlaceholderMessage = (0, (0, parcelRequire("d8OAB")).isDueDatePlaceholder)(placeholder) ? formatMessage((0, (0, parcelRequire("fRvoq")).default).noDueDate) : undefined;
        const renderDurationLabel = (shouldRender = true)=>{
            const isDurationValid = startDate !== undefined || dueDate !== undefined;
            return isDurationVisible && isDurationValid && shouldRender ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('visual-refresh_drop_1') ? undefined : ' ', renderDuration ? renderDuration() : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cNXyp")).Duration), {
                fromDate: startDate ?? 0,
                toDate: dueDate ?? 0
            })) : null;
        };
        const renderDate = (dateType, date, placeholderMessage)=>{
            if (date === undefined) return null;
            const DateContainer = (0, (0, parcelRequire("d6q2B")).DATE_CONTAINER_LOOKUP)[dateType];
            const DateIcon = (0, (0, parcelRequire("d6q2B")).DATE_ICON_LOOKUP)[dateType];
            const visuallyRefreshedDate = placeholderMessage ? (0, ($parcel$interopDefault($5uXOq))).createElement("small", {
                className: (0, (0, parcelRequire("bwpsq")).default)([
                    "_o572qvpr _syaz97m5"
                ])
            }, placeholderMessage) : (0, ($parcel$interopDefault($5uXOq))).createElement(DateContainer, null, (0, (0, parcelRequire("g11uZ")).getDateFromTimestamp)(date, (0, $a797a5154a1373bc$export$316009114afd746)));
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement(DateIcon, null), (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('visual-refresh_drop_1') ? visuallyRefreshedDate : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, placeholderMessage ?? (0, ($parcel$interopDefault($5uXOq))).createElement(DateContainer, null, (0, (0, parcelRequire("g11uZ")).getDateFromTimestamp)(date))));
        };
        if (placement === (0, (0, parcelRequire("2KlaV")).LEFT_AND_RIGHT)) {
            const startDateContent = renderDate(startDateType, startDate, startDatePlaceholderMessage);
            const endDateContent = renderDate(dueDateType, dueDate, dueDatePlaceholderMessage);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('visual-refresh_drop_1') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("small", {
                className: (0, (0, parcelRequire("bwpsq")).default)([
                    "_1e0c1txw _4cvr1h6o _1bah1h6o _19pkidpf _o572qvpr _1pby37uc _bfhkv9pe _syaz97m5 _2rko1l7b _jr2u1qyh",
                    startDateContent !== null && "_ca0qyh40 _u5f3i2wt _n3tdyh40 _19bvi2wt",
                    "_kqswstnw",
                    "_1xi21osq _2hwxv77o",
                    "notranslate"
                ])
            }, startDateContent, renderDurationLabel(startDate !== undefined && dueDate === undefined)), (0, ($parcel$interopDefault($5uXOq))).createElement("small", {
                className: (0, (0, parcelRequire("bwpsq")).default)([
                    "_1e0c1txw _4cvr1h6o _1bah1h6o _19pkidpf _o572qvpr _1pby37uc _bfhkv9pe _syaz97m5 _2rko1l7b _jr2u1qyh",
                    endDateContent !== null && "_ca0qyh40 _u5f3i2wt _n3tdyh40 _19bvi2wt",
                    "_kqswstnw",
                    "_1ltv1osq _18u0v77o",
                    "notranslate"
                ])
            }, endDateContent, renderDurationLabel(dueDate !== undefined))) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("small", {
                className: (0, (0, parcelRequire("bwpsq")).default)([
                    "_1e0c1txw _4cvr1h6o _19pkidpf _1p1dangw _o572qvpr _1pby37uc _jr2u1qyh",
                    "_kqswstnw",
                    "_1xi21osq _u5f3u2gc",
                    "notranslate"
                ])
            }, startDateContent, renderDurationLabel(startDate !== undefined && dueDate === undefined)), (0, ($parcel$interopDefault($5uXOq))).createElement("small", {
                className: (0, (0, parcelRequire("bwpsq")).default)([
                    "_1e0c1txw _4cvr1h6o _19pkidpf _1p1dangw _o572qvpr _1pby37uc _jr2u1qyh",
                    "_kqswstnw",
                    "_1ltv1osq _19bvu2gc",
                    "notranslate"
                ])
            }, endDateContent, renderDurationLabel(dueDate !== undefined))));
        }
        const content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, renderDate(startDateType, startDate, startDatePlaceholderMessage), startDate !== undefined && dueDate !== undefined && ' - ', renderDate(dueDateType, dueDate, dueDatePlaceholderMessage), renderDurationLabel());
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('visual-refresh_drop_1') ? (0, ($parcel$interopDefault($5uXOq))).createElement("small", {
            "data-testid": "roadmap.timeline-table-kit.common.ui.formatted-date.formatted-date",
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _19pkidpf _o572qvpr _1pby37uc _bfhkv9pe _syaz97m5 _2rko1l7b _jr2u1qyh",
                "_ca0qyh40 _u5f3i2wt _n3tdyh40 _19bvi2wt",
                placement && "_kqswstnw",
                placement === (0, (0, parcelRequire("2KlaV")).LEFT) && "_1xi21osq _2hwxv77o",
                placement === (0, (0, parcelRequire("2KlaV")).RIGHT) && "_1ltv1osq _18u0v77o",
                "notranslate"
            ])
        }, content) : (0, ($parcel$interopDefault($5uXOq))).createElement("small", {
            "data-testid": "roadmap.timeline-table-kit.common.ui.formatted-date.formatted-date",
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _19pkidpf _1p1dangw _o572qvpr _1pby37uc _jr2u1qyh",
                placement && "_kqswstnw",
                placement === (0, (0, parcelRequire("2KlaV")).LEFT) && "_1xi21osq _u5f3u2gc",
                placement === (0, (0, parcelRequire("2KlaV")).RIGHT) && "_1ltv1osq _19bvu2gc",
                "notranslate"
            ])
        }, content));
    };
    const $56f9e8a00236f718$var$placemenetLeftStyles = null;
    const $56f9e8a00236f718$var$placemenetRightStyles = null;
    const $56f9e8a00236f718$var$placemenetLeftStylesOld = null;
    const $56f9e8a00236f718$var$placemenetRightStylesOld = null;
    const $56f9e8a00236f718$var$defaultPlacementStyles = null;
    const $56f9e8a00236f718$var$placementOuterContainerStyles = null;
    const $56f9e8a00236f718$var$outerContainerStyles = null;
    const $56f9e8a00236f718$var$outerContainerExtraPaddingStyles = null;
    const $56f9e8a00236f718$var$outerContainerStylesOld = null;
});
parcelRegister("cNXyp", function(module, exports) {
    $parcel$export(module.exports, "Duration", ()=>$a32f1b2b9e522298$export$3b11bc38611c5941);
    var $5uXOq = parcelRequire("5uXOq");
    var $4R6GH;
    var $koVbs;
    var $dCm1o;
    var $86dU9;
    var $gHgzb;
    var $15oyE;
    const $a32f1b2b9e522298$export$3b11bc38611c5941 = ({ fromDate: fromDate, toDate: toDate, isSigned: isSigned, isToDateExcluded: isToDateExcluded })=>{
        const sign = toDate < fromDate ? '-' : '+';
        const duration = (0, (0, parcelRequire("15oyE")).getDaysInBetween)(fromDate, toDate, isToDateExcluded);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const visuallyRefreshedDuration = (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('visual-refresh_drop_1') ? duration !== 0 ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, `${' '}`, formatMessage((0, (0, parcelRequire("gHgzb")).default).duration, {
            duration: `${isSigned ? sign : ''}${duration}`
        })) : null : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("86dU9")).default), {
            duration: duration,
            sign: isSigned ? sign : undefined
        });
        return duration ? visuallyRefreshedDuration : null;
    };
    $a32f1b2b9e522298$export$3b11bc38611c5941.defaultProps = {
        isSigned: false,
        isToDateExcluded: false
    };
});
parcelRegister("86dU9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a6f452643cc9662d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $3bk6K;
    var $koVbs;
    var $gHgzb;
    const $a6f452643cc9662d$var$DurationBadge = ({ duration: duration, sign: sign })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return duration ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3bk6K")).default), null, formatMessage((0, (0, parcelRequire("gHgzb")).default).durationOld, {
            duration: `${sign ?? ''}${duration}`
        })) : null;
    };
    var $a6f452643cc9662d$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($a6f452643cc9662d$var$DurationBadge);
});
parcelRegister("gHgzb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2fbe47442e60766c$export$2e2bcd8739ae039);
    var $7VHMR;
    var $2fbe47442e60766c$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        duration: {
            "id": "roadmap.timeline-table-kit.common.date-labels.duration.duration",
            "defaultMessage": "({duration} days)"
        },
        durationOld: {
            "id": "roadmap.timeline-table-kit.common.date-labels.duration.duration-old",
            "defaultMessage": "{duration}d"
        }
    });
});
parcelRegister("15oyE", function(module, exports) {
    $parcel$export(module.exports, "getDaysInBetween", ()=>$e6965f13b49c846a$export$ae6ef52daacfecd3);
    $parcel$export(module.exports, "getDurationProps", ()=>$e6965f13b49c846a$export$100189a9c6d8b999);
    const $e6965f13b49c846a$export$ae6ef52daacfecd3 = (fromDate, toDate, isToDateExcluded = false)=>Math.round(Math.abs(fromDate - toDate) / (0, $a797a5154a1373bc$export$1f04624003d2da7d)) + (isToDateExcluded ? 0 : 1);
    const $e6965f13b49c846a$export$100189a9c6d8b999 = (prevStartDate, prevDueDate, startDate, dueDate, dragType, currentStartDate, currentDueDate)=>{
        if (dragType === undefined || dragType === 'LEFT_AND_RIGHT') return {
            fromDate: currentStartDate,
            toDate: currentDueDate,
            isSigned: false,
            isToDateExcluded: false
        };
        const isDurationDiff = prevStartDate !== undefined && prevDueDate !== undefined && startDate !== undefined && dueDate !== undefined;
        const isStartDateFixed = prevDueDate !== undefined && startDate === undefined && dueDate !== undefined;
        const isDueDateFixed = prevStartDate !== undefined && startDate !== undefined && dueDate === undefined;
        const isDurationMeta = prevStartDate === undefined && prevDueDate === undefined && startDate !== undefined && dueDate !== undefined;
        if (isDurationDiff || isStartDateFixed) return {
            fromDate: prevDueDate,
            toDate: dueDate,
            isSigned: true,
            isToDateExcluded: true
        };
        if (isDueDateFixed) return {
            fromDate: startDate,
            toDate: prevStartDate,
            isSigned: true,
            isToDateExcluded: true
        };
        if (isDurationMeta) return {
            fromDate: startDate,
            toDate: dueDate,
            isSigned: false,
            isToDateExcluded: false
        };
        return {
            fromDate: startDate ?? 0,
            toDate: dueDate ?? 0,
            isSigned: false,
            isToDateExcluded: false
        };
    };
});
parcelRegister("d6q2B", function(module, exports) {
    $parcel$export(module.exports, "DATE_ICON_LOOKUP", ()=>$db9ef26425ad815b$export$b6abe4b9e409dfb2);
    $parcel$export(module.exports, "DATE_CONTAINER_LOOKUP", ()=>$db9ef26425ad815b$export$f3b594588fe8a99e);
    var $5uXOq = parcelRequire("5uXOq");
    var $esmwW;
    var $caQD3;
    var $6dG5H;
    const $db9ef26425ad815b$export$b6abe4b9e409dfb2 = {
        [(0, (0, parcelRequire("esmwW")).EXPLICIT)]: (0, $5uXOq.Fragment),
        [(0, (0, parcelRequire("esmwW")).ROLLUP)]: (0, (0, parcelRequire("caQD3")).RollupIcon),
        [(0, (0, parcelRequire("esmwW")).INTERVAL)]: (0, (0, parcelRequire("6dG5H")).SprintIcon)
    };
    const $db9ef26425ad815b$export$f3b594588fe8a99e = {
        [(0, (0, parcelRequire("esmwW")).EXPLICIT)]: (0, $5uXOq.Fragment),
        [(0, (0, parcelRequire("esmwW")).ROLLUP)]: 'i',
        [(0, (0, parcelRequire("esmwW")).INTERVAL)]: 'i'
    };
});
parcelRegister("caQD3", function(module, exports) {
    $parcel$export(module.exports, "RollupIcon", ()=>$2d66613b8d0cd878$export$a33e84c97d0c570c);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $1h2s1;
    var $koVbs;
    var $fZAx6;
    const $2d66613b8d0cd878$var$getRollupIconGlyph = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "24",
            height: "24",
            viewBox: "0 0 24 24"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fill: "currentColor",
            d: "M14.586 11l-2.293-2.293a1 1 0 1 1 1.414-1.414l4 4a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414-1.414L14.586 13H10a1 1 0 0 0-1 1v7a1 1 0 0 1-2 0v-7a3 3 0 0 1 3-3h4.586z"
        }));
    const $2d66613b8d0cd878$export$a33e84c97d0c570c = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($2d66613b8d0cd878$var$Container, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1h2s1")).default), {
            glyph: $2d66613b8d0cd878$var$getRollupIconGlyph,
            label: formatMessage((0, (0, parcelRequire("fZAx6")).default).rollUpIconLabel),
            size: "small"
        }));
    };
    const $2d66613b8d0cd878$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3igktf _1bsb7vkz _2hwxv77o",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("fZAx6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$330047c05926d5ce$export$2e2bcd8739ae039);
    var $7VHMR;
    const $330047c05926d5ce$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        rollUpIconLabel: {
            "id": "roadmap.timeline-table-kit.common.rollup-icon.roll-up-icon-label",
            "defaultMessage": "Roll-up"
        }
    });
    var $330047c05926d5ce$export$2e2bcd8739ae039 = $330047c05926d5ce$var$messages;
});
parcelRegister("6dG5H", function(module, exports) {
    $parcel$export(module.exports, "SprintIcon", ()=>$e8fd5f283ee29689$export$8c2ca4d5c7ca94da);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $gSH2C;
    var $4R6GH;
    var $koVbs;
    var $sUcA7;
    const $e8fd5f283ee29689$var$getIconSize = (iconSize)=>iconSize === 'small' ? 16 : 24;
    const $e8fd5f283ee29689$var$wrapperStyles = null;
    const $e8fd5f283ee29689$export$8c2ca4d5c7ca94da = ({ size: size })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            style: {
                height: `${$e8fd5f283ee29689$var$getIconSize(size)}px`,
                width: `${$e8fd5f283ee29689$var$getIconSize(size)}px`
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_2hwxv77o"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("gSH2C"))))), {
            testId: "roadmap.timeline-table-kit.common.ui.sprint-icon",
            label: (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-post-project-a11y-fix') ? '' : formatMessage((0, (0, parcelRequire("sUcA7")).default).sprintLabel),
            spacing: size === 'medium' ? 'spacious' : 'none',
            color: "currentColor",
            LEGACY_size: size
        }));
    };
    $e8fd5f283ee29689$export$8c2ca4d5c7ca94da.defaultProps = {
        size: 'small'
    };
});
parcelRegister("gSH2C", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $c4a31392f3fbc9f4$var$_react = $c4a31392f3fbc9f4$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $c4a31392f3fbc9f4$var$_sprint = $c4a31392f3fbc9f4$var$_interopRequireDefault((parcelRequire("lvWkV")));
    var $c4a31392f3fbc9f4$var$_sprint2 = $c4a31392f3fbc9f4$var$_interopRequireDefault((parcelRequire("cC5Sv")));
    function $c4a31392f3fbc9f4$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $c4a31392f3fbc9f4$var$SprintIcon = (props)=>$c4a31392f3fbc9f4$var$_react.default.createElement($c4a31392f3fbc9f4$var$_sprint.default, Object.assign({
            LEGACY_fallbackIcon: $c4a31392f3fbc9f4$var$_sprint2.default
        }, props));
    $c4a31392f3fbc9f4$var$SprintIcon.Name = 'SprintIconMigration';
    var $c4a31392f3fbc9f4$var$_default = module.exports.default = $c4a31392f3fbc9f4$var$SprintIcon;
});
parcelRegister("lvWkV", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $fa99bea734a9d293$var$_react = $fa99bea734a9d293$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $fa99bea734a9d293$var$_UNSAFE_baseNew = $fa99bea734a9d293$var$_interopRequireDefault((parcelRequire("dTInF")));
    function $fa99bea734a9d293$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $fa99bea734a9d293$var$SprintIcon = (props)=>$fa99bea734a9d293$var$_react.default.createElement($fa99bea734a9d293$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M13.5 6.25a5.5 5.5 0 1 0-5.5 5.5m0 0H0m8 0h6.75m-3-3.5 3.5 3.5-3.5 3.5"/>`
        }, props));
    $fa99bea734a9d293$var$SprintIcon.displayName = 'SprintIcon';
    var $fa99bea734a9d293$var$_default = module.exports.default = $fa99bea734a9d293$var$SprintIcon;
});
parcelRegister("cC5Sv", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $92ed97e4dfc768ad$var$_react = $92ed97e4dfc768ad$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $7p1ve;
    var $92ed97e4dfc768ad$var$_sprint = $92ed97e4dfc768ad$var$_interopRequireDefault((parcelRequire("lvWkV")));
    function $92ed97e4dfc768ad$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $92ed97e4dfc768ad$var$SprintIcon = (props)=>$92ed97e4dfc768ad$var$_react.default.createElement((0, parcelRequire("7p1ve")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="m17.717 17.137-1.436-1.438a1.003 1.003 0 0 1 1.418-1.418l3.007 3.01a1 1 0 0 1 0 1.417l-3.007 3.01a1.003 1.003 0 0 1-1.417-1.42l1.3-1.3-6.072-.003A8 8 0 0 1 4 11.01C4 6.587 7.582 3 12 3s8 3.587 8 8.01a8 8 0 0 1-.789 3.451l-1.438-1.44a6.1 6.1 0 0 0 .345-2.01A6.12 6.12 0 0 0 12 4.884a6.12 6.12 0 0 0-6.118 6.125 6.12 6.12 0 0 0 5.647 6.102zm-12.163-.119c.561.759 1.456 1.49 2.457 1.981L3.937 19C3.42 19 3 18.552 3 18s.42-1 .937-1l1.614.005z"/></svg>`
        }, props, {
            newIcon: $92ed97e4dfc768ad$var$_sprint.default
        }));
    $92ed97e4dfc768ad$var$SprintIcon.displayName = 'SprintIcon';
    var $92ed97e4dfc768ad$var$_default = module.exports.default = $92ed97e4dfc768ad$var$SprintIcon;
});
parcelRegister("sUcA7", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d1365b6c26a062f3$export$2e2bcd8739ae039);
    var $7VHMR;
    const $d1365b6c26a062f3$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        sprintLabel: {
            "id": "roadmap.timeline-table-kit.common.sprint-icon.sprint-label",
            "defaultMessage": "Sprint"
        }
    });
    var $d1365b6c26a062f3$export$2e2bcd8739ae039 = $d1365b6c26a062f3$var$messages;
});
parcelRegister("fRvoq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$95dc3801f4e0c608$export$2e2bcd8739ae039);
    var $7VHMR;
    var $95dc3801f4e0c608$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        noStartDate: {
            "id": "roadmap.timeline-table-kit.common.formatted-date.no-start-date",
            "defaultMessage": "No start date"
        },
        noDueDate: {
            "id": "roadmap.timeline-table-kit.common.formatted-date.no-due-date",
            "defaultMessage": "No due date"
        }
    });
});
parcelRegister("hjVf3", function(module, exports) {
    $parcel$export(module.exports, "RoadmapBar", ()=>$6a9289d21e612fae$export$9335a0f7fb12b232);
    var $5uXOq = parcelRequire("5uXOq");
    var $6Ll2T;
    var $99gde;
    var $AHUyh;
    var $fNuuD;
    var $4R6GH;
    var $koVbs;
    var $8zOmE;
    var $lwMsT;
    var $WPwAA;
    var $biT18;
    var $1YcpO;
    var $kCVTH;
    var $g11uZ;
    var $15ADj;
    var $esmwW;
    var $2KlaV;
    var $3yzcQ;
    var $d8OAB;
    var $apjDv;
    var $9KS0U;
    var $gXfPZ;
    var $aZ1r7;
    var $a3omN;
    var $8QqqZ;
    var $inYGI;
    const $6a9289d21e612fae$var$StyledBar = ({ left: left, right: right, placeholder: placeholder, theme: theme, level: level, shouldAnimate: shouldAnimate, isSelectEnabled: isSelectEnabled, innerRef: innerRef, containerRef: containerRef, children: children, startDate: startDate, dueDate: dueDate, color: color, 'data-testid': testId, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onContextMenu: onContextMenu, ...rest })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            ref: containerRef,
            testId: `${testId}-container`,
            style: {
                ...(0, (0, parcelRequire("3yzcQ")).getBaseBarStyles)({
                    level: level,
                    theme: theme,
                    placeholder: placeholder
                }),
                left: `${left}px`,
                right: `${right}px`,
                cursor: isSelectEnabled ? 'pointer' : 'default',
                transition: shouldAnimate ? 'left 0.1s ease, right 0.1s ease' : 'none'
            },
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            ref: innerRef,
            xcss: $6a9289d21e612fae$var$focusedBarStyles,
            "aria-label": formatMessage((0, (0, parcelRequire("a3omN")).default).gridCellAriaLabel, {
                startDate: (0, (0, parcelRequire("g11uZ")).getDateFromTimestamp)(startDate),
                dueDate: (0, (0, parcelRequire("g11uZ")).getDateFromTimestamp)(dueDate),
                color: color
            }),
            onContextMenu: onContextMenu,
            testId: testId,
            ...rest
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            xcss: $6a9289d21e612fae$var$barContentOverlayStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            xcss: $6a9289d21e612fae$var$barContentWrapperStyles
        }, children)));
    };
    const $6a9289d21e612fae$var$DraggableBar = (0, (0, parcelRequire("fNuuD")).withDragObserver)($6a9289d21e612fae$var$StyledBar);
    const $6a9289d21e612fae$export$9335a0f7fb12b232 = ({ id: id, color: color, level: level, left: initialLeftPosition, right: initialRightPosition, startDateType: startDateType, dueDateType: dueDateType, warnings: warnings, placeholder: placeholder, isReadOnly: isReadOnly, DndLongTaskMetric: DndLongTaskMetric, onUpdate: onUpdate, onLeftClick: onLeftClick, onRightClick: onRightClick, renderBarContent: renderBarContent })=>{
        const [{ isSelectEnabled: isSelectEnabled }] = (0, (0, parcelRequire("WPwAA")).useEnablements)();
        let handleClick;
        if ((0, (0, parcelRequire("4R6GH")).fg)('project_timeline_multi-select_and_checkboxes')) ({ handleClick: handleClick } = (0, (0, parcelRequire("kCVTH")).useItemSelect)(id));
        const [{ timelineDuration: timelineDuration, timelineWidth: timelineWidth }] = (0, (0, parcelRequire("biT18")).useTimelineState)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const barContainerRef = (0, $5uXOq.useRef)(null);
        const barButtonRef = (0, $5uXOq.useRef)(null);
        const [{ isActive: isActive, dragType: dragType, ...interactionState }, { onDragStart: onDragStart, onDrag: onDrag, onDragEnd: onDragEnd, onLingerStart: onLingerStart, onLingerEnd: onLingerEnd }] = (0, (0, parcelRequire("gXfPZ")).useChartItemInteractions)(id);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const isHovered = isActive && !dragType;
        const isDragging = dragType !== undefined;
        const isDragExplicit = isDragging && isActive;
        const isResizeEnabled = startDateType !== (0, (0, parcelRequire("esmwW")).INTERVAL) && dueDateType !== (0, (0, parcelRequire("esmwW")).INTERVAL);
        const leftPosition = interactionState.leftPosition ?? initialLeftPosition;
        const rightPosition = interactionState.rightPosition ?? initialRightPosition;
        const { minimumLeft: minimumLeft, minimumRight: minimumRight } = (0, (0, parcelRequire("8QqqZ")).getMinimumPositions)(leftPosition, rightPosition, timelineWidth);
        const isMinimumBar = minimumLeft !== undefined && minimumRight !== undefined;
        const newLeft = (isDragExplicit || isHovered) && minimumLeft !== undefined ? minimumLeft : leftPosition;
        const newRight = (isDragExplicit || isHovered) && minimumRight !== undefined ? minimumRight : rightPosition;
        const newPlaceholder = isDragExplicit ? (0, (0, parcelRequire("d8OAB")).getPlaceholderWhileDragging)(dragType, placeholder) : placeholder;
        const prevStartDate = (0, (0, parcelRequire("apjDv")).getStartDate)(initialLeftPosition, timelineDuration, timelineWidth);
        const prevDueDate = (0, (0, parcelRequire("apjDv")).getDueDate)(initialRightPosition, timelineDuration, timelineWidth);
        const startDate = (0, (0, parcelRequire("apjDv")).getStartDate)(leftPosition, timelineDuration, timelineWidth);
        const dueDate = (0, (0, parcelRequire("apjDv")).getDueDate)(rightPosition, timelineDuration, timelineWidth);
        const theme = (0, (0, parcelRequire("9KS0U")).getBarTheme)(color);
        const getBarBoundingClientRect = (0, $5uXOq.useCallback)(()=>barContainerRef.current?.getBoundingClientRect(), []);
        const onResizeStartLeft = ()=>{
            onDragStart((0, (0, parcelRequire("2KlaV")).LEFT));
        };
        const onResizeStartRight = ()=>{
            onDragStart((0, (0, parcelRequire("2KlaV")).RIGHT));
        };
        const onBarDragStart = ()=>{
            onDragStart((0, (0, parcelRequire("2KlaV")).LEFT_AND_RIGHT));
        };
        const onBarDragEnd = ()=>{
            const updatedDates = (0, (0, parcelRequire("8QqqZ")).getUpdatedDates)(startDate, dueDate, dragType);
            const analyticsEvent = createAnalyticsEvent({
                action: 'dragEnded',
                actionSubject: 'bar'
            });
            const attributes = {
                type: (0, (0, parcelRequire("8QqqZ")).getAnalyticsType)(updatedDates),
                level: level,
                isStartDateInferred: startDateType === (0, (0, parcelRequire("esmwW")).ROLLUP) || startDateType === (0, (0, parcelRequire("esmwW")).INTERVAL),
                isDueDateInferred: dueDateType === (0, (0, parcelRequire("esmwW")).ROLLUP) || dueDateType === (0, (0, parcelRequire("esmwW")).INTERVAL)
            };
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'issueBar', attributes);
            onDragEnd();
            onUpdate(id, {
                dates: updatedDates,
                meta: {
                    isDragged: true
                }
            }, analyticsEvent);
        };
        const onBarRightClick = (event)=>{
            if (onRightClick !== undefined) {
                event.preventDefault();
                const { top: top, height: height } = event.currentTarget.getBoundingClientRect();
                const analyticsEvent = createAnalyticsEvent({
                    action: 'rightClicked',
                    actionSubject: 'bar'
                });
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'issueBar');
                onRightClick(id, {
                    x: event.clientX,
                    y: top + height
                });
            }
        };
        const onBarLeftClickOld = (0, $5uXOq.useCallback)(({ target: target, ctrlKey: ctrlKey, metaKey: metaKey, shiftKey: shiftKey })=>{
            if (target === barButtonRef.current) {
                const withCmd = ctrlKey || metaKey;
                const withShift = shiftKey;
                const analyticsEvent = createAnalyticsEvent({
                    action: 'clicked',
                    actionSubject: 'bar'
                });
                const itemClickMeta = {
                    level: level,
                    withCmd: withCmd,
                    withShift: withShift
                };
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'issueBar', itemClickMeta);
                onLeftClick?.(id, itemClickMeta, analyticsEvent);
            }
        }, [
            createAnalyticsEvent,
            id,
            level,
            onLeftClick
        ]);
        const onBarLeftClickNew = (0, $5uXOq.useCallback)((event)=>{
            const { target: target, metaKey: metaKey, ctrlKey: ctrlKey, shiftKey: shiftKey } = event;
            if (target !== barButtonRef.current) return;
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'bar',
                actionSubjectId: 'issueBar',
                attributes: {
                    level: level,
                    withCmd: ctrlKey || metaKey,
                    withShift: shiftKey
                }
            });
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent);
            (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps-timeline-bento-refocusing') ? handleClick?.(event, analyticsEvent, barButtonRef) : handleClick?.(event, analyticsEvent);
            const itemClickMeta = {
                level: level,
                withCmd: ctrlKey || metaKey,
                withShift: shiftKey
            };
            onLeftClick?.(id, itemClickMeta, analyticsEvent);
        }, [
            createAnalyticsEvent,
            level,
            handleClick,
            onLeftClick,
            id
        ]);
        const onBarLeftClick = (0, (0, parcelRequire("4R6GH")).fg)('project_timeline_multi-select_and_checkboxes') ? onBarLeftClickNew : onBarLeftClickOld;
        const renderDragHandle = (type, hasPlaceholder)=>{
            const shouldRenderHandle = isHovered && dragType === undefined || dragType === type && isDragExplicit;
            return shouldRenderHandle && isResizeEnabled && !isReadOnly ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aZ1r7")).RoadmapDragHandle), {
                id: id,
                type: type,
                theme: theme,
                hasPlaceholder: hasPlaceholder,
                onDragStart: type === (0, (0, parcelRequire("2KlaV")).LEFT) ? onResizeStartLeft : onResizeStartRight,
                onDrag: onDrag,
                onDragEnd: onBarDragEnd
            }) : null;
        };
        const renderGhostBar = ()=>{
            if (!isDragging) return null;
            return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                style: {
                    ...(0, (0, parcelRequire("3yzcQ")).getBaseBarStyles)({
                        level: level,
                        theme: theme,
                        placeholder: placeholder
                    }),
                    left: `${initialLeftPosition}px`,
                    right: `${initialRightPosition}px`,
                    backgroundColor: theme.background,
                    opacity: '0.3'
                }
            });
        };
        const barContentProps = {
            id: id,
            dragType: dragType,
            prevStartDate: prevStartDate,
            prevDueDate: prevDueDate,
            startDate: startDate,
            dueDate: dueDate,
            startDateType: startDateType,
            dueDateType: dueDateType,
            leftPosition: newLeft,
            rightPosition: newRight,
            placeholder: newPlaceholder,
            isReadOnly: isReadOnly,
            isMinimumBar: isMinimumBar,
            ...(0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-post-project-a11y-fix') ? {
                isColorInverted: (0, (0, parcelRequire("8QqqZ")).shouldInvertColor)(color)
            } : {},
            getBarBoundingClientRect: getBarBoundingClientRect,
            onBarMouseLeave: onLingerEnd
        };
        const barContentState = {
            isActive: isActive,
            isHovered: isHovered
        };
        const warningsDescription = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("AHUyh")).default), {
                id: `roadmap.timeline-table-kit.ui.chart-item-content.date-content.bar.warning-desc-${id}`
            }, warnings.length > 0 && `${formatMessage((0, (0, parcelRequire("a3omN")).default).warningsCount, {
                count: warnings.length
            })} `, warnings.map((errorMessage)=>`${formatMessage(errorMessage)} `));
        const onKeyDown = (0, $5uXOq.useCallback)((e)=>{
            if ((0, (0, parcelRequire("1YcpO")).isEnterOrSpaceKey)(e) && isSelectEnabled) {
                e.preventDefault();
                onBarLeftClick(e);
            }
        }, [
            isSelectEnabled,
            onBarLeftClick
        ]);
        const renderDraggableBar = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($6a9289d21e612fae$var$DraggableBar, {
                "data-testid": `roadmap.timeline-table-kit.ui.chart-item-content.date-content.bar.draggable-bar-${id}`,
                innerRef: barButtonRef,
                left: newLeft,
                right: newRight,
                level: level,
                theme: theme,
                placeholder: newPlaceholder,
                shouldAnimate: isHovered && isMinimumBar && !isDragging,
                isSelectEnabled: isSelectEnabled,
                isDisabled: isReadOnly,
                onMouseEnter: onLingerStart,
                onMouseLeave: onLingerEnd,
                onDrag: onDrag,
                onDragStart: onBarDragStart,
                onDragEnd: onBarDragEnd,
                onContextMenu: !isReadOnly ? onBarRightClick : undefined,
                onClick: isSelectEnabled ? onBarLeftClick : undefined,
                containerRef: barContainerRef,
                onKeyDown: onKeyDown,
                tabIndex: 0,
                startDate: startDate,
                dueDate: dueDate,
                color: color,
                role: "button",
                "aria-describedby": `roadmap.timeline-table-kit.ui.chart-item-content.date-content.bar.warning-desc-${id}`
            }, renderBarContent(barContentProps, barContentState), renderDragHandle((0, (0, parcelRequire("2KlaV")).LEFT), placeholder === (0, (0, parcelRequire("15ADj")).START_DATE_PLACEHOLDER) || placeholder === (0, (0, parcelRequire("15ADj")).START_AND_DUE_DATE_PLACEHOLDER)), renderDragHandle((0, (0, parcelRequire("2KlaV")).RIGHT), placeholder === (0, (0, parcelRequire("15ADj")).DUE_DATE_PLACEHOLDER) || placeholder === (0, (0, parcelRequire("15ADj")).START_AND_DUE_DATE_PLACEHOLDER)));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, renderGhostBar(), renderDraggableBar(), warningsDescription(), !isDragExplicit && !isHovered && warnings.length > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("inYGI")).RoadmapBarWarnings), {
            warnings: warnings,
            right: newRight
        }), (0, ($parcel$interopDefault($5uXOq))).createElement(DndLongTaskMetric, {
            isDragging: isDragging,
            level: level
        }));
    };
    const $6a9289d21e612fae$var$focusedBarStyles = (0, (0, parcelRequire("99gde")).xcss)({
        borderRadius: 'border.radius',
        boxSizing: 'border-box',
        width: '100%',
        height: '100%',
        ':focus-visible': {
            outline: `2px solid ${`var(--ds-border-focused, ${(0, $72ba03e317f3d228$export$ecfc1dff386a3e7a)})`}`,
            outlineOffset: 'space.025'
        }
    });
    const $6a9289d21e612fae$var$barContentOverlayStyles = (0, (0, parcelRequire("99gde")).xcss)({
        padding: '0',
        paddingLeft: 'space.075',
        paddingRight: 'space.075',
        position: 'absolute',
        top: '0',
        left: '0',
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        pointerEvents: 'none'
    });
    const $6a9289d21e612fae$var$barContentWrapperStyles = (0, (0, parcelRequire("99gde")).xcss)({
        display: 'flex',
        alignItems: 'center',
        pointerEvents: 'auto'
    });
});
parcelRegister("gXfPZ", function(module, exports) {
    $parcel$export(module.exports, "useChartItemInteractions", ()=>$a0949660cbdabb90$export$7de9fc62a8d2ea96);
    var $5uXOq = parcelRequire("5uXOq");
    var $gPXTo;
    const $a0949660cbdabb90$export$7de9fc62a8d2ea96 = (id)=>{
        const timeoutId = (0, $5uXOq.useRef)(undefined);
        const frameId = (0, $5uXOq.useRef)(undefined);
        const [interactionState, interactionActions] = (0, (0, parcelRequire("gPXTo")).useInteractionData)(id);
        (0, $5uXOq.useEffect)(()=>()=>{
                frameId.current && cancelAnimationFrame(frameId.current);
                clearTimeout(timeoutId.current);
            }, []);
        const onDragStart = (0, $5uXOq.useCallback)((dragType)=>{
            interactionActions.onDragStart(id, dragType);
        }, [
            id,
            interactionActions
        ]);
        const onLingerStart = (0, $5uXOq.useCallback)(()=>{
            interactionActions.onLingerStart(id);
            timeoutId.current = setTimeout(()=>interactionActions.onLinger(), 200);
        }, [
            id,
            interactionActions
        ]);
        const onLingerEnd = (0, $5uXOq.useCallback)(()=>{
            clearTimeout(timeoutId.current);
            interactionActions.onLingerEnd();
        }, [
            interactionActions
        ]);
        const onPreview = (0, $5uXOq.useCallback)((previewX)=>{
            if (!frameId.current) frameId.current = requestAnimationFrame(()=>{
                frameId.current = undefined;
                interactionActions.onPreview(previewX);
            });
        }, [
            interactionActions
        ]);
        return [
            interactionState,
            {
                ...interactionActions,
                onDragStart: onDragStart,
                onLingerStart: onLingerStart,
                onLingerEnd: onLingerEnd,
                onPreview: onPreview
            }
        ];
    };
});
parcelRegister("gPXTo", function(module, exports) {
    $parcel$export(module.exports, "useResetChartInteractionState", ()=>$663cda5abab042f5$export$fc4108d49b02ba94);
    $parcel$export(module.exports, "useInteractionData", ()=>$663cda5abab042f5$export$2f4e7606a05110d7);
    $parcel$export(module.exports, "useTargetIntervalId", ()=>$663cda5abab042f5$export$a93e57268029ba2d);
    $parcel$export(module.exports, "useIntervalDropZoneData", ()=>$663cda5abab042f5$export$6814590c602b8a2a);
    $parcel$export(module.exports, "useIsHeaderModalActive", ()=>$663cda5abab042f5$export$5eb5fe0fd641b668);
    $parcel$export(module.exports, "useHeaderItemActions", ()=>$663cda5abab042f5$export$fad9cd2384b134e0);
    $parcel$export(module.exports, "RoadmapChartItemInteractionProvider", ()=>$663cda5abab042f5$export$9d4771cc037ac267);
    var $5uXOq = parcelRequire("5uXOq");
    var $3ruU1;
    var $biT18;
    var $3sQ5x;
    var $gg7kZ;
    var $iXqE5;
    var $bdtf9;
    var $5GeZM;
    var $10N8P;
    var $aTYP2;
    var $g85ud;
    const $663cda5abab042f5$export$c830a1fa415103b0 = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: (0, (0, parcelRequire("10N8P")).DEFAULT_STATE),
        actions: (0, parcelRequire("5GeZM")).actions,
        name: 'timeline-table-kit.table-providers.chart-item-interactions'
    });
    const $663cda5abab042f5$var$useChartInteractionActions = (0, (0, parcelRequire("3sQ5x")).createHook)($663cda5abab042f5$export$c830a1fa415103b0, {
        selector: null
    });
    const $663cda5abab042f5$export$fc4108d49b02ba94 = ()=>{
        const [, chartInteractionActions] = $663cda5abab042f5$var$useChartInteractionActions();
        return {
            resetChartInteractionState: chartInteractionActions.onLingerEnd
        };
    };
    const $663cda5abab042f5$export$2f4e7606a05110d7 = (0, (0, parcelRequire("3sQ5x")).createHook)($663cda5abab042f5$export$c830a1fa415103b0, {
        selector: (0, (0, parcelRequire("aTYP2")).getInteractionDataById)
    });
    const $663cda5abab042f5$export$a93e57268029ba2d = (0, (0, parcelRequire("3sQ5x")).createHook)($663cda5abab042f5$export$c830a1fa415103b0, {
        selector: (0, (0, parcelRequire("aTYP2")).getTargetIntervalId)
    });
    const $663cda5abab042f5$export$6814590c602b8a2a = (0, (0, parcelRequire("3sQ5x")).createHook)($663cda5abab042f5$export$c830a1fa415103b0, {
        selector: (0, (0, parcelRequire("aTYP2")).getIntervalDropZoneDataById)
    });
    const $663cda5abab042f5$export$5eb5fe0fd641b668 = (0, (0, parcelRequire("3sQ5x")).createHook)($663cda5abab042f5$export$c830a1fa415103b0, {
        selector: (0, (0, parcelRequire("aTYP2")).getIsHeaderModalActive)
    });
    const $663cda5abab042f5$export$fad9cd2384b134e0 = (0, (0, parcelRequire("3sQ5x")).createActionsHook)($663cda5abab042f5$export$c830a1fa415103b0);
    const $663cda5abab042f5$var$Container = (0, (0, parcelRequire("gg7kZ")).createContainer)($663cda5abab042f5$export$c830a1fa415103b0);
    const $663cda5abab042f5$export$9d4771cc037ac267 = ({ items: items, selectedItemIds: selectedItemIds, isDragAlongEnabled: isDragAlongEnabled, intervals: intervals, children: children })=>{
        const sideEffectMarshal = (0, (0, parcelRequire("3ruU1")).useSideEffectMarshal)();
        const [{ timelineMode: timelineMode, timelineDuration: timelineDuration, timelineWidth: timelineWidth }] = (0, (0, parcelRequire("biT18")).useTimelineState)();
        const { updateViewportCache: updateViewportCache, adjustScrollPositionAndGetOffset: adjustScrollPositionAndGetOffset } = (0, (0, parcelRequire("bdtf9")).useAdjustScrollPosition)();
        const simpleIntervals = (0, (0, parcelRequire("g85ud")).getSimpleIntervals)(intervals, timelineDuration, timelineWidth);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($663cda5abab042f5$var$Container, {
            items: items,
            selectedItemIds: selectedItemIds,
            sideEffectMarshal: sideEffectMarshal,
            timelineMode: timelineMode,
            timelineWidth: timelineWidth,
            timelineDuration: timelineDuration,
            setViewportCache: updateViewportCache,
            getScrollOffset: adjustScrollPositionAndGetOffset,
            isDragAlongEnabled: isDragAlongEnabled,
            simpleIntervals: simpleIntervals
        }, children);
    };
    $663cda5abab042f5$export$9d4771cc037ac267.defaultProps = {
        selectedItemIds: []
    };
});
parcelRegister("bdtf9", function(module, exports) {
    $parcel$export(module.exports, "adjustScrollPosition", ()=>$b460cd5b76919591$export$9b07bbd51c0d1d84);
    $parcel$export(module.exports, "useAdjustScrollPosition", ()=>$b460cd5b76919591$export$6853243092b02409);
    var $5uXOq = parcelRequire("5uXOq");
    var $kyahI;
    var $er2y9;
    const $b460cd5b76919591$var$calculateScrollOnDragLeft = (0, (0, parcelRequire("er2y9")).createCalculateScrollOnDragWithOffset)(120);
    const $b460cd5b76919591$var$calculateScrollOnDragTop = (0, (0, parcelRequire("er2y9")).createCalculateScrollOnDragWithOffset)(40);
    const $b460cd5b76919591$var$DEFAULT_VIEWPORT_CACHE = {
        scrollBoundingRect: undefined,
        viewportBoundingRect: undefined
    };
    const $b460cd5b76919591$export$9b07bbd51c0d1d84 = (from, to, setViewportScroll, initialScrollBoundingRect, requestViewportScrollBounding, viewportBoundingRect, newScrollLeft, newScrollTop)=>{
        const initialScrollLeft = initialScrollBoundingRect ? initialScrollBoundingRect.scrollLeft : 0;
        const initialScrollTop = initialScrollBoundingRect ? initialScrollBoundingRect.scrollTop : 0;
        const { scrollLeft: scrollLeft, scrollWidth: scrollWidth, scrollTop: scrollTop, scrollHeight: scrollHeight } = requestViewportScrollBounding();
        let topScroll;
        let leftScroll;
        if (viewportBoundingRect) {
            const { width: width, left: left, right: right, top: top, height: height, bottom: bottom } = viewportBoundingRect;
            const newScrollTopValue = $b460cd5b76919591$var$calculateScrollOnDragTop(height, top, bottom, to.y, to.y - from.y, scrollTop, scrollHeight - height);
            if (newScrollTopValue !== scrollTop && newScrollTopValue > 0) {
                setViewportScroll({
                    scrollTop: newScrollTopValue
                });
                topScroll = newScrollTopValue;
            }
            const newScrollLeftValue = $b460cd5b76919591$var$calculateScrollOnDragLeft(width, left, right, to.x, to.x - from.x, scrollLeft, scrollWidth - width);
            if (newScrollLeftValue !== scrollLeft && newScrollLeftValue > 0) {
                setViewportScroll({
                    scrollLeft: newScrollLeftValue
                });
                leftScroll = newScrollLeftValue;
            }
        }
        return {
            scrollLeft: initialScrollLeft - (newScrollLeft !== undefined ? newScrollLeft : scrollLeft),
            scrollTop: initialScrollTop - (newScrollTop !== undefined ? newScrollTop : scrollTop),
            updatedScrollLeft: leftScroll,
            updatedScrollTop: topScroll
        };
    };
    const $b460cd5b76919591$export$6853243092b02409 = ()=>{
        const viewportContext = (0, (0, parcelRequire("kyahI")).useViewport)();
        const viewportCache = (0, $5uXOq.useRef)($b460cd5b76919591$var$DEFAULT_VIEWPORT_CACHE);
        const baselineScrollLeft = (0, $5uXOq.useRef)(0);
        const baselineScrollTop = (0, $5uXOq.useRef)(0);
        const { requestViewportBoundingClient: requestViewportBoundingClient, requestViewportScrollBounding: requestViewportScrollBounding, setViewportScroll: setViewportScroll } = viewportContext;
        const updateViewportCache = (0, $5uXOq.useCallback)(()=>{
            const scrollBoundingRect = requestViewportScrollBounding();
            const viewportBoundingRect = requestViewportBoundingClient();
            viewportCache.current = {
                viewportBoundingRect: viewportBoundingRect,
                scrollBoundingRect: scrollBoundingRect
            };
            baselineScrollLeft.current = scrollBoundingRect.scrollLeft;
            baselineScrollTop.current = scrollBoundingRect.scrollTop;
        }, [
            requestViewportBoundingClient,
            requestViewportScrollBounding
        ]);
        const adjustScrollPositionAndGetOffset = (0, $5uXOq.useCallback)((from, to)=>{
            const { scrollBoundingRect: scrollBoundingRect, viewportBoundingRect: viewportBoundingRect } = viewportCache.current;
            const { scrollLeft: scrollLeft, updatedScrollLeft: updatedScrollLeft } = $b460cd5b76919591$export$9b07bbd51c0d1d84(from, to, setViewportScroll, scrollBoundingRect, requestViewportScrollBounding, viewportBoundingRect, baselineScrollLeft.current, baselineScrollTop.current);
            if (updatedScrollLeft !== undefined) baselineScrollLeft.current = updatedScrollLeft;
            return scrollLeft;
        }, [
            setViewportScroll,
            requestViewportScrollBounding
        ]);
        return {
            updateViewportCache: updateViewportCache,
            adjustScrollPositionAndGetOffset: adjustScrollPositionAndGetOffset
        };
    };
});
parcelRegister("er2y9", function(module, exports) {
    $parcel$export(module.exports, "createCalculateScrollOnDragWithOffset", ()=>$4c40bb85342ca2db$export$62b7f59ff4b39d81);
    const $4c40bb85342ca2db$var$SCROLL_SCALE_WITH_OFFSET = 2;
    const $4c40bb85342ca2db$var$getWeightedScrollAmountWithOffset = (scrollAmount)=>Math.round(scrollAmount ** $4c40bb85342ca2db$var$SCROLL_SCALE_WITH_OFFSET);
    const $4c40bb85342ca2db$var$SCROLL_MAX = 150;
    const $4c40bb85342ca2db$var$getThrottledScrollAmount = (scrollAmount)=>Math.min($4c40bb85342ca2db$var$SCROLL_MAX, scrollAmount);
    const $4c40bb85342ca2db$export$62b7f59ff4b39d81 = (scrollThreshold)=>(height, top, bottom, cursorOffset, cursorOffsetDiff, scrollPosition, scrollSize)=>{
            let newScrollPosition = scrollPosition;
            const threshold = Math.min(height / 2, scrollThreshold);
            if (cursorOffset > top && cursorOffset <= top + threshold && cursorOffsetDiff < 0) {
                const scrollAmount = $4c40bb85342ca2db$var$getWeightedScrollAmountWithOffset(1 / ((cursorOffset - top) / threshold));
                const throttledScrollAmount = $4c40bb85342ca2db$var$getThrottledScrollAmount(scrollAmount);
                newScrollPosition = Math.max(0, scrollPosition - throttledScrollAmount);
            } else if (cursorOffset < bottom && cursorOffset >= bottom - threshold && cursorOffset > 0) {
                const scrollAmount = $4c40bb85342ca2db$var$getWeightedScrollAmountWithOffset(1 / ((bottom - cursorOffset) / threshold));
                const throttledScrollAmount = $4c40bb85342ca2db$var$getThrottledScrollAmount(scrollAmount);
                newScrollPosition = Math.min(scrollSize, scrollPosition + throttledScrollAmount);
            }
            return newScrollPosition;
        };
});
parcelRegister("5GeZM", function(module, exports) {
    $parcel$export(module.exports, "actions", ()=>$f71adb117d5d1a76$export$e324594224ef24da);
    var $hwFXB;
    var $kC16z;
    var $3wUU2;
    var $35zaD;
    var $6lhlv;
    var $l8ERH;
    var $7aEbA;
    var $f5seX;
    const $f71adb117d5d1a76$export$e324594224ef24da = {
        onDrag: (0, parcelRequire("3wUU2")).onDrag,
        onDragEnd: (0, parcelRequire("hwFXB")).onDragEnd,
        onDragStart: (0, parcelRequire("kC16z")).onDragStart,
        onLinger: (0, parcelRequire("l8ERH")).onLinger,
        onLingerEnd: (0, parcelRequire("35zaD")).onLingerEnd,
        onLingerStart: (0, parcelRequire("6lhlv")).onLingerStart,
        onPreview: (0, parcelRequire("7aEbA")).onPreview,
        onToggleHeaderModal: (0, parcelRequire("f5seX")).onToggleHeaderModal
    };
});
parcelRegister("hwFXB", function(module, exports) {
    $parcel$export(module.exports, "onDragEnd", ()=>$9113ed4f231daa8f$export$8566066e92caa8a);
    var $10N8P;
    const $9113ed4f231daa8f$export$8566066e92caa8a = ()=>({ setState: setState }, { sideEffectMarshal: sideEffectMarshal })=>{
            sideEffectMarshal.custom.onBarInteractionEnd();
            const { activeItem: activeItem, hasLingered: hasLingered, ...defaultState } = (0, (0, parcelRequire("10N8P")).DEFAULT_STATE);
            setState(defaultState);
        };
});
parcelRegister("10N8P", function(module, exports) {
    $parcel$export(module.exports, "DEFAULT_STATE", ()=>$14da3dcec3f581f5$export$a3a6a28ae8823b06);
    const $14da3dcec3f581f5$export$a3a6a28ae8823b06 = {
        activeItem: undefined,
        hasLingered: false,
        dragType: undefined,
        itemPositions: {},
        targetIntervalId: undefined,
        isHeaderModalActive: false,
        previewBaselinePosition: undefined
    };
});
parcelRegister("kC16z", function(module, exports) {
    $parcel$export(module.exports, "onDragStart", ()=>$84ce831abd593bf8$export$b00174fdb6a6ab8f);
    var $esmwW;
    var $jdJcB;
    const $84ce831abd593bf8$export$b00174fdb6a6ab8f = (id, dragType)=>({ getState: getState, setState: setState }, { items: items, sideEffectMarshal: sideEffectMarshal, setViewportCache: setViewportCache })=>{
            const activeItem = items.find((item)=>item.id === id);
            if (activeItem) {
                const { itemPositions: itemPositions, hasLingered: hasLingeredFromState } = getState();
                const previewBaselinePosition = (0, (0, parcelRequire("jdJcB")).getPreviewBaselinePosition)(activeItem, itemPositions);
                const hasLingered = activeItem.startDateType === (0, (0, parcelRequire("esmwW")).INTERVAL) && activeItem.dueDateType === (0, (0, parcelRequire("esmwW")).INTERVAL) ? hasLingeredFromState : false;
                setViewportCache();
                sideEffectMarshal.custom.onBarInteractionStart();
                setState({
                    activeItem: activeItem,
                    dragType: dragType,
                    previewBaselinePosition: previewBaselinePosition,
                    hasLingered: hasLingered
                });
            }
        };
});
parcelRegister("jdJcB", function(module, exports) {
    $parcel$export(module.exports, "getPreviewBaselinePosition", ()=>$2c057e9eb67186b9$export$6e65532e85c8e991);
    const $2c057e9eb67186b9$export$6e65532e85c8e991 = (activeItem, itemPositions)=>{
        let previewBaselinePosition;
        const { id: id, startDate: startDate, dueDate: dueDate } = activeItem;
        if (startDate === undefined && dueDate === undefined && itemPositions[id]) {
            const { leftPosition: leftPosition, rightPosition: rightPosition } = itemPositions[id];
            if (leftPosition !== undefined && rightPosition !== undefined) previewBaselinePosition = {
                leftPosition: leftPosition,
                rightPosition: rightPosition
            };
        }
        return previewBaselinePosition;
    };
});
parcelRegister("3wUU2", function(module, exports) {
    $parcel$export(module.exports, "onDrag", ()=>$a004b6600311e0d8$export$11a07b18d6f8f6d2);
    var $bJRKQ;
    var $fFUUs;
    const $a004b6600311e0d8$export$11a07b18d6f8f6d2 = (from, to, start)=>({ setState: setState, getState: getState }, containerProps)=>{
            const { activeItem: activeItem, dragType: dragType, itemPositions: itemPositions, previewBaselinePosition: previewBaselinePosition } = getState();
            if (!activeItem || !dragType) return;
            let dragResult;
            const { startDate: startDate, dueDate: dueDate } = activeItem;
            if (startDate === undefined && dueDate === undefined && previewBaselinePosition) {
                const noDateActiveItem = {
                    ...activeItem,
                    startDate: startDate,
                    dueDate: dueDate
                };
                dragResult = (0, (0, parcelRequire("fFUUs")).onNoDateDrag)({
                    from: from,
                    to: to,
                    start: start
                }, {
                    activeItem: noDateActiveItem,
                    dragType: dragType,
                    previewBaselinePosition: previewBaselinePosition
                }, containerProps);
            } else if (startDate !== undefined && dueDate !== undefined) {
                const dateActiveItem = {
                    ...activeItem,
                    startDate: startDate,
                    dueDate: dueDate
                };
                dragResult = (0, (0, parcelRequire("bJRKQ")).onDateDrag)({
                    from: from,
                    to: to,
                    start: start
                }, {
                    activeItem: dateActiveItem,
                    dragType: dragType,
                    itemPositions: itemPositions
                }, containerProps);
            }
            dragResult && setState(dragResult);
        };
});
parcelRegister("bJRKQ", function(module, exports) {
    $parcel$export(module.exports, "onDateDrag", ()=>$4b640855180a9ba7$export$6abaacf95e615b18);
    var $gccSB = parcelRequire("gccSB");
    var $esmwW;
    var $2KlaV;
    var $7Vii8;
    var $jeYNi;
    const $4b640855180a9ba7$export$6abaacf95e615b18 = (dragPosition, { activeItem: activeItem, dragType: dragType, itemPositions: itemPositions }, { items: items, selectedItemIds: selectedItemIds, timelineDuration: timelineDuration, timelineWidth: timelineWidth, isDragAlongEnabled: isDragAlongEnabled, getScrollOffset: getScrollOffset, simpleIntervals: simpleIntervals })=>{
        const gridSize = (0, (0, parcelRequire("7Vii8")).getGridSize)(timelineDuration, timelineWidth);
        const scrollOffset = getScrollOffset(dragPosition.from, dragPosition.to);
        const { selectedItems: selectedItems, childItemsHash: childItemsHash } = (0, (0, parcelRequire("jeYNi")).getItemsCollection)(items, selectedItemIds);
        const newItemPositions = {};
        const handleDrag = (targetItem)=>{
            const { leftPosition: leftPosition, rightPosition: rightPosition } = (0, (0, parcelRequire("jeYNi")).getDragPosition)(dragType, targetItem, timelineDuration, timelineWidth, dragPosition, gridSize, scrollOffset);
            if (leftPosition === undefined && rightPosition === undefined) return;
            newItemPositions[targetItem.id] = {
                leftPosition: leftPosition,
                rightPosition: rightPosition
            };
            if (isDragAlongEnabled && dragType === (0, (0, parcelRequire("2KlaV")).LEFT_AND_RIGHT)) {
                const childItems = childItemsHash[targetItem.id] || [];
                childItems.forEach((childItem)=>{
                    const { leftPosition: childLeftPosition, rightPosition: childRightPosition } = (0, (0, parcelRequire("jeYNi")).getDragPosition)(dragType, childItem, timelineDuration, timelineWidth, dragPosition, gridSize, scrollOffset);
                    if (childLeftPosition !== undefined || childRightPosition !== undefined) newItemPositions[childItem.id] = {
                        leftPosition: childLeftPosition,
                        rightPosition: childRightPosition
                    };
                });
            }
        };
        let targetIntervalId;
        const { id: id, intervalId: intervalId, startDateType: startDateType, dueDateType: dueDateType } = activeItem;
        if (selectedItemIds.length > 1 && selectedItemIds.includes(id) && startDateType !== (0, (0, parcelRequire("esmwW")).INTERVAL) && dueDateType !== (0, (0, parcelRequire("esmwW")).INTERVAL)) {
            selectedItems.forEach((item)=>{
                handleDrag(item);
            });
            if ((0, ($parcel$interopDefault($gccSB)))(newItemPositions)) return undefined;
        } else {
            handleDrag(activeItem);
            if ((0, ($parcel$interopDefault($gccSB)))(newItemPositions)) return undefined;
            const { leftPosition: leftPosition, rightPosition: rightPosition } = newItemPositions[id];
            if (intervalId !== undefined && dragType === (0, (0, parcelRequire("2KlaV")).LEFT_AND_RIGHT) && leftPosition !== undefined && rightPosition !== undefined) {
                const midPosition = (timelineWidth - rightPosition - leftPosition) / 2 + leftPosition;
                const unsafeTargetIntervalId = (0, (0, parcelRequire("7Vii8")).getTargetIntervalId)(simpleIntervals, timelineWidth, midPosition);
                if (unsafeTargetIntervalId !== intervalId) targetIntervalId = unsafeTargetIntervalId;
            }
        }
        return {
            itemPositions: {
                ...itemPositions,
                ...newItemPositions
            },
            targetIntervalId: targetIntervalId
        };
    };
});
parcelRegister("7Vii8", function(module, exports) {
    $parcel$export(module.exports, "to1DP", ()=>$c3012527d6a31ffc$export$6c9c23d367dcea0f);
    $parcel$export(module.exports, "getTargetIntervalId", ()=>$c3012527d6a31ffc$export$fd188f2e31f7a51c);
    $parcel$export(module.exports, "getGridSize", ()=>$c3012527d6a31ffc$export$3a0507da8b146ff1);
    $parcel$export(module.exports, "snapToGrid", ()=>$c3012527d6a31ffc$export$195604d042fd3f87);
    var $8QpSo;
    var $2gnC5 = parcelRequire("2gnC5");
    const $c3012527d6a31ffc$export$6c9c23d367dcea0f = (value)=>Math.round((value + Number.EPSILON) * 10) / 10;
    const $c3012527d6a31ffc$export$fd188f2e31f7a51c = (simpleIntervals, timelineWidth, posX)=>{
        const overlappingIntervals = simpleIntervals.filter(({ leftPosition: leftPosition, rightPosition: rightPosition })=>{
            const isItemStartEqualToOrGreaterThanIntervalStart = $c3012527d6a31ffc$export$6c9c23d367dcea0f(posX) >= $c3012527d6a31ffc$export$6c9c23d367dcea0f(leftPosition);
            const isItemStartLessThanIntervalEnd = $c3012527d6a31ffc$export$6c9c23d367dcea0f(posX) < $c3012527d6a31ffc$export$6c9c23d367dcea0f(timelineWidth - rightPosition);
            return isItemStartEqualToOrGreaterThanIntervalStart && isItemStartLessThanIntervalEnd;
        });
        return overlappingIntervals.length > 0 ? overlappingIntervals[0].targetId : undefined;
    };
    const $c3012527d6a31ffc$export$3a0507da8b146ff1 = (0, (0, parcelRequire("8QpSo")).default)(({ endMilliseconds: endMilliseconds, startMilliseconds: startMilliseconds }, timelineWidth)=>{
        const numberOfDaysInTimeline = (0, ($parcel$interopDefault($2gnC5)))(endMilliseconds).diff(startMilliseconds, 'days') + 1;
        return timelineWidth / numberOfDaysInTimeline;
    });
    const $c3012527d6a31ffc$export$195604d042fd3f87 = (position, gridSize, offset = 0)=>{
        const roundedOffset = Math.round(offset / gridSize) * gridSize;
        return position + roundedOffset;
    };
});
parcelRegister("jeYNi", function(module, exports) {
    $parcel$export(module.exports, "getDragPosition", ()=>$9f9a455828c38dc2$export$43fc86aa4efa07b0);
    $parcel$export(module.exports, "getItemsCollection", ()=>$9f9a455828c38dc2$export$68a20f16cafe8131);
    var $8QpSo;
    var $15ADj;
    var $esmwW;
    var $2KlaV;
    var $apjDv;
    var $7Vii8;
    const $9f9a455828c38dc2$export$38e26b36381469ee = (dragType, hasLeftPlaceholder, dateType)=>dragType === (0, (0, parcelRequire("2KlaV")).LEFT_AND_RIGHT) || dragType === (0, (0, parcelRequire("2KlaV")).LEFT) || dragType === (0, (0, parcelRequire("2KlaV")).RIGHT) && hasLeftPlaceholder && dateType !== (0, (0, parcelRequire("esmwW")).ROLLUP);
    const $9f9a455828c38dc2$export$40ce9920ffc376d2 = (dragType, hasRightPlaceholder, dateType)=>dragType === (0, (0, parcelRequire("2KlaV")).LEFT_AND_RIGHT) || dragType === (0, (0, parcelRequire("2KlaV")).RIGHT) || dragType === (0, (0, parcelRequire("2KlaV")).LEFT) && hasRightPlaceholder && dateType !== (0, (0, parcelRequire("esmwW")).ROLLUP);
    const $9f9a455828c38dc2$export$94ff4f58995a561 = (dragType, leftPosition, rightPosition, timelineWidth, direction)=>{
        if (dragType === (0, (0, parcelRequire("2KlaV")).LEFT_AND_RIGHT) && leftPosition < 0 && direction === (0, (0, parcelRequire("2KlaV")).LEFT)) return false;
        if (dragType === (0, (0, parcelRequire("2KlaV")).LEFT_AND_RIGHT) && rightPosition < 0 && direction === (0, (0, parcelRequire("2KlaV")).RIGHT)) return false;
        if (dragType === (0, (0, parcelRequire("2KlaV")).LEFT) && (leftPosition < 0 || leftPosition > timelineWidth)) return false;
        if (dragType === (0, (0, parcelRequire("2KlaV")).RIGHT) && (rightPosition < 0 || rightPosition > timelineWidth)) return false;
        if (dragType === (0, (0, parcelRequire("2KlaV")).LEFT) || dragType === (0, (0, parcelRequire("2KlaV")).RIGHT)) return timelineWidth - rightPosition - leftPosition > (0, (0, parcelRequire("15ADj")).MINIMUM_BAR_LENGTH);
        return true;
    };
    const $9f9a455828c38dc2$var$getDragDirection = (dragType, leftPosition, baselineLeftPosition)=>{
        if (dragType === (0, (0, parcelRequire("2KlaV")).LEFT_AND_RIGHT)) return leftPosition !== undefined && leftPosition < baselineLeftPosition ? (0, (0, parcelRequire("2KlaV")).LEFT) : (0, (0, parcelRequire("2KlaV")).RIGHT);
        if (dragType === (0, (0, parcelRequire("2KlaV")).LEFT)) return 0, (0, parcelRequire("2KlaV")).LEFT;
        return 0, (0, parcelRequire("2KlaV")).RIGHT;
    };
    const $9f9a455828c38dc2$export$43fc86aa4efa07b0 = (dragType, item, timelineDuration, timelineWidth, { to: to, start: start }, gridSize, scrollOffset)=>{
        let leftPosition;
        let rightPosition;
        const { startDate: startDate, dueDate: dueDate, placeholder: placeholder, startDateType: startDateType, dueDateType: dueDateType } = item;
        const baselineLeftPosition = (0, (0, parcelRequire("apjDv")).getBarLeftPosition)(startDate, timelineDuration, timelineWidth);
        const baselineRightPosition = (0, (0, parcelRequire("apjDv")).getBarRightPosition)(dueDate, timelineDuration, timelineWidth);
        const hasLeftPlaceholder = placeholder === (0, (0, parcelRequire("15ADj")).START_DATE_PLACEHOLDER) || placeholder === (0, (0, parcelRequire("15ADj")).START_AND_DUE_DATE_PLACEHOLDER);
        const hasRightPlaceholder = placeholder === (0, (0, parcelRequire("15ADj")).DUE_DATE_PLACEHOLDER) || placeholder === (0, (0, parcelRequire("15ADj")).START_AND_DUE_DATE_PLACEHOLDER);
        if ($9f9a455828c38dc2$export$38e26b36381469ee(dragType, hasLeftPlaceholder, startDateType)) {
            const offset = to.x - start.x - scrollOffset;
            leftPosition = (0, (0, parcelRequire("7Vii8")).snapToGrid)(baselineLeftPosition, gridSize, offset);
        }
        if ($9f9a455828c38dc2$export$40ce9920ffc376d2(dragType, hasRightPlaceholder, dueDateType)) {
            const offset = start.x - to.x + scrollOffset;
            rightPosition = (0, (0, parcelRequire("7Vii8")).snapToGrid)(baselineRightPosition, gridSize, offset);
        }
        const actualLeftPosition = leftPosition ?? baselineLeftPosition;
        const actualRightPosition = rightPosition ?? baselineRightPosition;
        const direction = $9f9a455828c38dc2$var$getDragDirection(dragType, leftPosition, baselineLeftPosition);
        if ($9f9a455828c38dc2$export$94ff4f58995a561(dragType, actualLeftPosition, actualRightPosition, timelineWidth, direction)) return {
            leftPosition: leftPosition,
            rightPosition: rightPosition
        };
        return {
            leftPosition: undefined,
            rightPosition: undefined
        };
    };
    const $9f9a455828c38dc2$var$isDateInteractiveChartItem = (item)=>item.startDate !== undefined && item.dueDate !== undefined;
    const $9f9a455828c38dc2$export$68a20f16cafe8131 = (0, (0, parcelRequire("8QpSo")).default)((items, selectedItemIds)=>{
        const itemsTree = items.reduce((acc, item)=>{
            if (item.parentId && $9f9a455828c38dc2$var$isDateInteractiveChartItem(item)) {
                const childItems = acc[item.parentId] ?? [];
                childItems.push(item);
                acc[item.parentId] = childItems;
            }
            return acc;
        }, {});
        const descendantItemsHash = {};
        const findDescendants = (parentId)=>{
            if (descendantItemsHash[parentId]) return descendantItemsHash[parentId];
            const children = itemsTree[parentId] ?? [];
            const descendants = children.flatMap((child)=>[
                    child,
                    ...findDescendants(child.id)
                ]);
            descendantItemsHash[parentId] = descendants;
            return descendants;
        };
        return items.reduce((acc, item)=>{
            if (!$9f9a455828c38dc2$var$isDateInteractiveChartItem(item)) return acc;
            if (selectedItemIds.includes(item.id)) acc.selectedItems.push(item);
            if (item.parentId) acc.childItemsHash[item.parentId] = findDescendants(item.parentId);
            return acc;
        }, {
            selectedItems: [],
            childItemsHash: {}
        });
    });
});
parcelRegister("fFUUs", function(module, exports) {
    $parcel$export(module.exports, "onNoDateDrag", ()=>$bdfedcd5913d8d4c$export$30770ba27cbf606f);
    var $2KlaV;
    var $7Vii8;
    var $3Fuwz;
    const $bdfedcd5913d8d4c$export$30770ba27cbf606f = ({ from: from, to: to, start: start }, { activeItem: activeItem, dragType: dragType, previewBaselinePosition: previewBaselinePosition }, { timelineDuration: timelineDuration, timelineWidth: timelineWidth, getScrollOffset: getScrollOffset, simpleIntervals: simpleIntervals })=>{
        const gridSize = (0, (0, parcelRequire("7Vii8")).getGridSize)(timelineDuration, timelineWidth);
        const scrollOffset = getScrollOffset(from, to);
        const startPosition = previewBaselinePosition.leftPosition;
        let leftPosition;
        let rightPosition;
        let nextDragType;
        if (dragType === (0, (0, parcelRequire("2KlaV")).LEFT)) {
            const offset = to.x - start.x - scrollOffset;
            rightPosition = timelineWidth - startPosition;
            leftPosition = (0, (0, parcelRequire("7Vii8")).snapToGrid)(startPosition, gridSize, offset);
            nextDragType = leftPosition < startPosition ? (0, (0, parcelRequire("2KlaV")).LEFT) : (0, (0, parcelRequire("2KlaV")).RIGHT);
        } else {
            const offset = to.x - start.x - scrollOffset;
            leftPosition = startPosition;
            rightPosition = timelineWidth - (0, (0, parcelRequire("7Vii8")).snapToGrid)(startPosition, gridSize, offset);
            nextDragType = timelineWidth - rightPosition < startPosition ? (0, (0, parcelRequire("2KlaV")).LEFT) : (0, (0, parcelRequire("2KlaV")).RIGHT);
        }
        if (!(0, (0, parcelRequire("3Fuwz")).isValidDrag)(leftPosition, rightPosition, gridSize, timelineWidth)) return undefined;
        const targetIntervalId = (0, (0, parcelRequire("7Vii8")).getTargetIntervalId)(simpleIntervals, timelineWidth, leftPosition);
        return {
            itemPositions: {
                [`${activeItem.id}`]: {
                    leftPosition: leftPosition,
                    rightPosition: rightPosition
                }
            },
            targetIntervalId: targetIntervalId,
            dragType: nextDragType
        };
    };
});
parcelRegister("3Fuwz", function(module, exports) {
    $parcel$export(module.exports, "isValidDrag", ()=>$24cf25217aee2184$export$94ff4f58995a561);
    var $7Vii8;
    const $24cf25217aee2184$export$94ff4f58995a561 = (leftPosition, rightPosition, gridSize, timelineWidth)=>{
        const distance = Math.abs(timelineWidth - rightPosition - leftPosition);
        return (0, (0, parcelRequire("7Vii8")).to1DP)(distance) >= (0, (0, parcelRequire("7Vii8")).to1DP)(gridSize);
    };
});
parcelRegister("35zaD", function(module, exports) {
    $parcel$export(module.exports, "onLingerEnd", ()=>$a562fef7e4da64db$export$5066f5e6e6738857);
    var $10N8P;
    const $a562fef7e4da64db$export$5066f5e6e6738857 = ()=>({ getState: getState, setState: setState })=>{
            const { dragType: dragType } = getState();
            if (dragType === undefined) setState((0, (0, parcelRequire("10N8P")).DEFAULT_STATE));
        };
});
parcelRegister("6lhlv", function(module, exports) {
    $parcel$export(module.exports, "onLingerStart", ()=>$d37a815130e6b7c6$export$bb211627ff50e51b);
    const $d37a815130e6b7c6$export$bb211627ff50e51b = (id)=>({ getState: getState, setState: setState }, { items: items })=>{
            const { dragType: dragType } = getState();
            const activeItem = items.find((item)=>item.id === id);
            if (activeItem !== undefined && dragType === undefined) setState({
                activeItem: activeItem
            });
        };
});
parcelRegister("l8ERH", function(module, exports) {
    $parcel$export(module.exports, "onLinger", ()=>$6c72e0444690396b$export$c9ef8a8ee2b7f513);
    var $esmwW;
    var $7Vii8;
    const $6c72e0444690396b$export$c9ef8a8ee2b7f513 = ()=>({ getState: getState, setState: setState }, { timelineWidth: timelineWidth, simpleIntervals: simpleIntervals })=>{
            const { activeItem: activeItem, itemPositions: itemPositions } = getState();
            if (activeItem?.startDateType === (0, (0, parcelRequire("esmwW")).INTERVAL) && activeItem?.dueDateType === (0, (0, parcelRequire("esmwW")).INTERVAL) || activeItem?.intervalId !== undefined) {
                let targetIntervalId;
                const { id: id, startDate: startDate, dueDate: dueDate, intervalId: intervalId } = activeItem;
                const leftPosition = itemPositions[id]?.leftPosition;
                if (startDate !== undefined && dueDate !== undefined) {
                    const isIntervalExists = simpleIntervals.find(({ intervalIds: intervalIds })=>intervalId && intervalIds.includes(intervalId));
                    if (isIntervalExists) targetIntervalId = intervalId;
                } else if (leftPosition !== undefined && activeItem.startDateType === (0, (0, parcelRequire("esmwW")).INTERVAL) && activeItem.dueDateType === (0, (0, parcelRequire("esmwW")).INTERVAL)) targetIntervalId = (0, (0, parcelRequire("7Vii8")).getTargetIntervalId)(simpleIntervals, timelineWidth, leftPosition);
                setState({
                    hasLingered: true,
                    targetIntervalId: targetIntervalId
                });
            }
        };
});
parcelRegister("7aEbA", function(module, exports) {
    $parcel$export(module.exports, "onPreview", ()=>$bfa3eb54673fbc8b$export$9d4a8aef590e6b33);
    var $iZN6h;
    var $esmwW;
    var $7Vii8;
    const $bfa3eb54673fbc8b$var$TIMELINE_MODE_OFFSET = {
        [(0, (0, parcelRequire("iZN6h")).WEEKS)]: 7,
        [(0, (0, parcelRequire("iZN6h")).MONTHS)]: 14,
        [(0, (0, parcelRequire("iZN6h")).QUARTERS)]: 30
    };
    const $bfa3eb54673fbc8b$export$9d4a8aef590e6b33 = (previewX)=>({ getState: getState, setState: setState }, { timelineMode: timelineMode, timelineDuration: timelineDuration, timelineWidth: timelineWidth, simpleIntervals: simpleIntervals })=>{
            const { activeItem: activeItem, dragType: dragType } = getState();
            if (!activeItem || activeItem && dragType) return;
            const isInterval = activeItem.startDateType === (0, (0, parcelRequire("esmwW")).INTERVAL) && activeItem.dueDateType === (0, (0, parcelRequire("esmwW")).INTERVAL);
            let leftPosition;
            let rightPosition;
            let targetIntervalId;
            const gridSize = (0, (0, parcelRequire("7Vii8")).getGridSize)(timelineDuration, timelineWidth);
            const leftPositionSnapToGrid = (0, (0, parcelRequire("7Vii8")).snapToGrid)(0, gridSize, previewX);
            if (!isInterval) {
                const rightOffset = $bfa3eb54673fbc8b$var$TIMELINE_MODE_OFFSET[timelineMode] * gridSize;
                leftPosition = leftPositionSnapToGrid;
                rightPosition = timelineWidth - (leftPosition + rightOffset);
            } else targetIntervalId = (0, (0, parcelRequire("7Vii8")).getTargetIntervalId)(simpleIntervals, timelineWidth, previewX);
            setState({
                itemPositions: {
                    [`${activeItem.id}`]: {
                        leftPosition: leftPosition,
                        rightPosition: rightPosition
                    }
                },
                targetIntervalId: targetIntervalId
            });
        };
});
parcelRegister("f5seX", function(module, exports) {
    $parcel$export(module.exports, "onToggleHeaderModal", ()=>$00ee78e6442dbb43$export$8560de0545726746);
    const $00ee78e6442dbb43$export$8560de0545726746 = (isActive)=>({ setState: setState })=>{
            setState({
                isHeaderModalActive: isActive
            });
        };
});
parcelRegister("aTYP2", function(module, exports) {
    $parcel$export(module.exports, "getTargetIntervalId", ()=>$4e401c79111c6cdb$export$fd188f2e31f7a51c);
    $parcel$export(module.exports, "getInteractionDataById", ()=>$4e401c79111c6cdb$export$56ac7aa92dc17fde);
    $parcel$export(module.exports, "getIsHeaderModalActive", ()=>$4e401c79111c6cdb$export$1c272fb440996072);
    $parcel$export(module.exports, "getIntervalDropZoneDataById", ()=>$4e401c79111c6cdb$export$416f05e681eaec5b);
    var $esmwW;
    const $4e401c79111c6cdb$export$fd188f2e31f7a51c = ({ targetIntervalId: targetIntervalId, hasLingered: hasLingered }, intervals)=>{
        if (hasLingered) {
            const targetInterval = intervals.find(({ id: id })=>id === targetIntervalId);
            return targetInterval?.id;
        }
        return undefined;
    };
    const $4e401c79111c6cdb$export$56ac7aa92dc17fde = ({ activeItem: activeItem, dragType: dragType, itemPositions: itemPositions }, id)=>{
        const leftPosition = itemPositions[id]?.leftPosition;
        const rightPosition = itemPositions[id]?.rightPosition;
        const hasAnyPosition = leftPosition !== undefined || rightPosition !== undefined;
        return {
            isActive: activeItem?.id === id,
            leftPosition: leftPosition,
            rightPosition: rightPosition,
            dragType: hasAnyPosition ? dragType : undefined
        };
    };
    const $4e401c79111c6cdb$export$1c272fb440996072 = ({ isHeaderModalActive: isHeaderModalActive })=>({
            isHeaderModalActive: isHeaderModalActive
        });
    const $4e401c79111c6cdb$export$416f05e681eaec5b = ({ activeItem: activeItem, dragType: dragType, hasLingered: hasLingered }, id)=>{
        if (!activeItem || activeItem.id !== id || activeItem.startDateType !== (0, (0, parcelRequire("esmwW")).INTERVAL) && activeItem.dueDateType !== (0, (0, parcelRequire("esmwW")).INTERVAL)) return {
            isVisible: false,
            currentIntervalId: undefined
        };
        if (activeItem.startDate !== undefined && activeItem.dueDate !== undefined) return {
            isVisible: dragType !== undefined,
            currentIntervalId: activeItem.intervalId
        };
        return {
            isVisible: hasLingered,
            currentIntervalId: activeItem.intervalId
        };
    };
});
parcelRegister("g85ud", function(module, exports) {
    $parcel$export(module.exports, "getSimpleIntervals", ()=>$e5507fe0fa149fbb$export$ba37947e5e9cffea);
    var $8QpSo;
    var $igUC7;
    const $e5507fe0fa149fbb$export$ba37947e5e9cffea = (0, (0, parcelRequire("8QpSo")).default)((intervals, timelineDuration, timelineWidth)=>{
        const intervalGroups = (0, (0, parcelRequire("igUC7")).getIntervalGroupPositions)(intervals, timelineDuration, timelineWidth);
        const simpleIntervals = [];
        intervalGroups.forEach((intervalGroup)=>{
            const leftPosition = Math.max(intervalGroup.left, intervalGroup.targetIntervalLeft);
            const rightPosition = Math.max(intervalGroup.right, intervalGroup.targetIntervalRight);
            const targetInterval = intervalGroup.intervals.find((interval)=>interval.state !== (0, $8e299570902dfa36$export$19c4f83398a8dbce));
            const intervalIds = intervals.map((interval)=>interval.id);
            if (targetInterval) simpleIntervals.push({
                targetId: targetInterval.id,
                leftPosition: leftPosition,
                rightPosition: rightPosition,
                intervalIds: intervalIds
            });
        });
        return simpleIntervals;
    });
});
const $8e299570902dfa36$export$19c4f83398a8dbce = 'CLOSED';
const $8e299570902dfa36$export$2b35adb71b3f6143 = 'ACTIVE';
const $8e299570902dfa36$export$47b7b82714c61a7c = 'FUTURE';
parcelRegister("igUC7", function(module, exports) {
    $parcel$export(module.exports, "getIntervalGroupPositions", ()=>$d4cefde65ec9525a$export$209e346bf640604);
    var $esmwW;
    var $apjDv;
    var $20Qxl;
    const $d4cefde65ec9525a$export$cd3d993a5aa1490e = (intervals, timelineDuration)=>{
        const saneIntervals = [];
        intervals.forEach((interval)=>{
            const saneStartDate = Math.min(interval.startDate, interval.endDate);
            const saneEndDate = Math.max(interval.startDate, interval.endDate) + (0, (0, parcelRequire("esmwW")).DUE_DATE_OFFSET);
            const isStartInTimeline = saneStartDate >= timelineDuration.startMilliseconds && saneStartDate <= timelineDuration.endMilliseconds;
            const isEndInTimeline = saneEndDate >= timelineDuration.startMilliseconds && saneEndDate <= timelineDuration.endMilliseconds;
            const isLongerThanTimeline = saneStartDate <= timelineDuration.startMilliseconds && saneEndDate >= timelineDuration.endMilliseconds;
            if (isStartInTimeline || isEndInTimeline || isLongerThanTimeline) saneIntervals.push({
                id: interval.id,
                name: interval.name,
                state: interval.state,
                startDate: saneStartDate,
                endDate: saneEndDate
            });
        });
        return saneIntervals;
    };
    const $d4cefde65ec9525a$export$487a26b15ffb2465 = (intervalGroup, timelineDuration, timelineWidth)=>{
        const { startDate: startDate, endDate: endDate, expandedEndDate: expandedEndDate, intervals: intervals } = intervalGroup;
        const intervalsPositions = {};
        intervals.forEach((interval)=>{
            const left = (0, (0, parcelRequire("apjDv")).getBarLeftPosition)(interval.startDate, timelineDuration, timelineWidth);
            const right = (0, (0, parcelRequire("apjDv")).getBarRightPosition)(interval.endDate - (0, (0, parcelRequire("esmwW")).DUE_DATE_OFFSET), timelineDuration, timelineWidth);
            intervalsPositions[interval.id] = {
                left: Math.max(0, left),
                right: Math.max(0, right)
            };
        });
        const left = (0, (0, parcelRequire("apjDv")).getBarLeftPosition)(startDate, timelineDuration, timelineWidth);
        const right = (0, (0, parcelRequire("apjDv")).getBarRightPosition)(endDate - (0, (0, parcelRequire("esmwW")).DUE_DATE_OFFSET), timelineDuration, timelineWidth);
        const rightExpanded = (0, (0, parcelRequire("apjDv")).getBarRightPosition)(expandedEndDate - (0, (0, parcelRequire("esmwW")).DUE_DATE_OFFSET), timelineDuration, timelineWidth);
        let targetIntervalLeft = left;
        let targetIntervalRight = right;
        const targetInterval = intervals.find((interval)=>interval.state !== (0, $8e299570902dfa36$export$19c4f83398a8dbce));
        if (targetInterval !== undefined && intervalsPositions[targetInterval.id]) {
            targetIntervalLeft = intervalsPositions[targetInterval.id].left;
            targetIntervalRight = intervalsPositions[targetInterval.id].right;
        }
        const clippedLeft = Math.max(0, left);
        const clippedRight = Math.max(0, right);
        const clippedTargetLeft = Math.max(0, targetIntervalLeft);
        const clippedTargetRight = Math.max(0, targetIntervalRight);
        const clippedRightExpanded = Math.max(0, rightExpanded);
        const width = timelineWidth - clippedLeft - clippedRight;
        const widthExpanded = timelineWidth - clippedLeft - clippedRightExpanded;
        return {
            isLeftClipped: left !== clippedLeft,
            isRightClipped: right !== clippedRight,
            isRightExpandedClipped: rightExpanded !== clippedRightExpanded,
            left: clippedLeft,
            right: clippedRight,
            targetIntervalLeft: clippedTargetLeft,
            targetIntervalRight: clippedTargetRight,
            rightExpanded: clippedRightExpanded,
            width: width,
            widthExpanded: widthExpanded,
            intervalsPositions: intervalsPositions,
            intervals: intervals
        };
    };
    const $d4cefde65ec9525a$export$209e346bf640604 = (intervals, timelineDuration, timelineWidth)=>{
        const saneIntervals = $d4cefde65ec9525a$export$cd3d993a5aa1490e(intervals, timelineDuration);
        const intervalGroups = (0, (0, parcelRequire("20Qxl")).groupOverlappingIntervals)(saneIntervals);
        return intervalGroups.map((intervalGroup)=>$d4cefde65ec9525a$export$487a26b15ffb2465(intervalGroup, timelineDuration, timelineWidth));
    };
});
parcelRegister("20Qxl", function(module, exports) {
    $parcel$export(module.exports, "groupOverlappingIntervals", ()=>$4793e10e3de30786$export$1b45218c7b9e570f);
    const $4793e10e3de30786$export$1b45218c7b9e570f = (intervals)=>{
        const intervalsWithIndex = intervals.map((interval, index)=>({
                ...interval,
                index: index
            }));
        const sortedIntervals = [
            ...intervalsWithIndex
        ].sort((interval, otherInterval)=>{
            const endComparison = interval.endDate - otherInterval.endDate;
            if (endComparison !== 0) return endComparison;
            return otherInterval.startDate - interval.startDate;
        });
        let result = [];
        let i = sortedIntervals.length - 1;
        while(i >= 0){
            const currentInterval = sortedIntervals[i];
            let groupedIntervals = [
                currentInterval
            ];
            let j = i - 1;
            while(j >= 0){
                const nextInterval = sortedIntervals[j];
                const isNextIntervalCompletelyOverlapped = currentInterval.startDate <= nextInterval.startDate;
                if (isNextIntervalCompletelyOverlapped) groupedIntervals = [
                    nextInterval
                ].concat(groupedIntervals);
                else break;
                j -= 1;
            }
            const groupedIntervalsInOriginalOrdering = groupedIntervals.sort((interval, otherInterval)=>interval.index - otherInterval.index).map(({ index: index, ...interval })=>interval);
            result = [
                {
                    startDate: currentInterval.startDate,
                    endDate: currentInterval.endDate,
                    expandedEndDate: currentInterval.endDate,
                    intervals: groupedIntervalsInOriginalOrdering
                }
            ].concat(result);
            i = j;
        }
        if (result.length >= 2) for(let k = 0; k < result.length - 1; k += 1){
            const currentIntervalGroup = result[k];
            const nextIntervalGroup = result[k + 1];
            if (currentIntervalGroup.endDate > nextIntervalGroup.startDate) currentIntervalGroup.endDate = nextIntervalGroup.startDate;
        }
        return result;
    };
});
parcelRegister("aZ1r7", function(module, exports) {
    $parcel$export(module.exports, "RoadmapDragHandle", ()=>$69ad6bcb1105aeca$export$fd31a6ac7f6022ac);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $fNuuD;
    var $4R6GH;
    var $dCm1o;
    const $69ad6bcb1105aeca$var$Handle = ({ type: type, hasPlaceholder: hasPlaceholder, theme: theme, children: children, testid: testid })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('visual-refresh_drop_1') ? (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            style: {
                [type]: 0,
                backgroundColor: !theme.hasContrastSecondaryGradient && hasPlaceholder ? theme.background : theme.handle
            },
            "data-testid": testid,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _154iidpf _94n5idpf _1yt41b66 _1bsb1y44 _2rkoftgi _1y1m1ntv _80om11mm"
            ])
        }, children) : (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            style: {
                [type]: 0,
                backgroundColor: !theme.hasContrastSecondaryGradient && hasPlaceholder ? theme.background : theme.handle
            },
            "data-testid": testid,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _154iidpf _94n5idpf _1yt41b66 _1bsbi2wt _2rkoftgi _1y1m1ntv _80om11mm"
            ])
        }, children));
    };
    const $69ad6bcb1105aeca$var$DraggableHandle = (0, (0, parcelRequire("fNuuD")).withDragObserver)($69ad6bcb1105aeca$var$Handle, 0.1);
    const $69ad6bcb1105aeca$export$fd31a6ac7f6022ac = ({ id: id, type: type, theme: theme, hasPlaceholder: hasPlaceholder, onDragStart: onDragStart, onDrag: onDrag, onDragEnd: onDragEnd })=>{
        const onDragHandleStart = (0, $5uXOq.useCallback)(()=>{
            onDragStart(type);
        }, [
            type,
            onDragStart
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($69ad6bcb1105aeca$var$DraggableHandle, {
            testid: `roadmap.timeline-table.components.bar.draggable.${type.toLowerCase()}-draggable-handle-${id}`,
            theme: theme,
            type: type.toLowerCase(),
            hasPlaceholder: hasPlaceholder,
            onDragStart: onDragHandleStart,
            onDrag: onDrag,
            onDragEnd: onDragEnd
        });
    };
    const $69ad6bcb1105aeca$var$handleStyles = null;
    const $69ad6bcb1105aeca$var$handleStylesOld = null;
});
parcelRegister("a3omN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ec23fd2b82a0df55$export$2e2bcd8739ae039);
    var $7VHMR;
    var $ec23fd2b82a0df55$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        gridCellAriaLabel: {
            "id": "roadmap.timeline-table-kit.chart-item-content.date-content.bar.grid-cell-aria-label",
            "defaultMessage": "Start date {startDate} until due date {dueDate} with color {color}"
        },
        warningsCount: {
            "id": "roadmap.timeline-table-kit.chart-item-content.date-content.bar.warnings-count",
            "defaultMessage": "{count, plural, one {# warning} other {# warnings}}"
        }
    });
});
parcelRegister("8QqqZ", function(module, exports) {
    $parcel$export(module.exports, "getMinimumPositions", ()=>$e7915a82df4b26c5$export$c1b6dd342ed8c79c);
    $parcel$export(module.exports, "getUpdatedDates", ()=>$e7915a82df4b26c5$export$3aa346efaf981bb1);
    $parcel$export(module.exports, "getAnalyticsType", ()=>$e7915a82df4b26c5$export$a3569ac53b82a914);
    $parcel$export(module.exports, "shouldInvertColor", ()=>$e7915a82df4b26c5$export$cf3d4bbc98af47e0);
    var $kFsv3;
    var $15ADj;
    var $2KlaV;
    const $e7915a82df4b26c5$export$c1b6dd342ed8c79c = (leftPosition, rightPosition, timelineWidth)=>{
        const barLength = timelineWidth - rightPosition - leftPosition;
        if (barLength < (0, (0, parcelRequire("15ADj")).MINIMUM_BAR_LENGTH)) {
            const minimumOffset = ((0, (0, parcelRequire("15ADj")).MINIMUM_BAR_LENGTH) - barLength) / 2;
            return {
                minimumLeft: leftPosition - minimumOffset,
                minimumRight: rightPosition - minimumOffset
            };
        }
        return {
            minimumLeft: undefined,
            minimumRight: undefined
        };
    };
    const $e7915a82df4b26c5$export$3aa346efaf981bb1 = (startDate, dueDate, dragType)=>{
        if (dragType === (0, (0, parcelRequire("2KlaV")).LEFT)) return {
            startDate: startDate
        };
        if (dragType === (0, (0, parcelRequire("2KlaV")).RIGHT)) return {
            dueDate: dueDate
        };
        if (dragType === (0, (0, parcelRequire("2KlaV")).LEFT_AND_RIGHT)) return {
            startDate: startDate,
            dueDate: dueDate
        };
        return {};
    };
    const $e7915a82df4b26c5$export$a3569ac53b82a914 = (updatedDates)=>{
        const { startDate: startDate, dueDate: dueDate } = updatedDates;
        if (startDate && !dueDate) return 'resizeLeft';
        if (!startDate && dueDate) return 'resizeRight';
        return 'moveBar';
    };
    const $e7915a82df4b26c5$var$lightColors = [
        (0, (0, parcelRequire("kFsv3")).PURPLE),
        (0, (0, parcelRequire("kFsv3")).BLUE),
        (0, (0, parcelRequire("kFsv3")).GREEN),
        (0, (0, parcelRequire("kFsv3")).TEAL),
        (0, (0, parcelRequire("kFsv3")).YELLOW),
        (0, (0, parcelRequire("kFsv3")).ORANGE),
        (0, (0, parcelRequire("kFsv3")).GREY)
    ];
    const $e7915a82df4b26c5$export$cf3d4bbc98af47e0 = (color)=>{
        return $e7915a82df4b26c5$var$lightColors.includes(color);
    };
});
parcelRegister("inYGI", function(module, exports) {
    $parcel$export(module.exports, "RoadmapBarWarnings", ()=>$06d67bd6df49e4bf$export$a4e6ea3b919ca9a9);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $1fJir;
    var $loZC0;
    var $2dKrm;
    var $aWse0;
    const $06d67bd6df49e4bf$var$containerStyles = null;
    const $06d67bd6df49e4bf$var$contentWrapperStyles = null;
    const $06d67bd6df49e4bf$var$tooltipTextStyles = null;
    const $06d67bd6df49e4bf$var$iconContainerStyles = null;
    const $06d67bd6df49e4bf$var$TooltipTag = (0, $5uXOq.forwardRef)((props, ref)=>$5uXOq.createElement("span", {
            ref: ref,
            ...props,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_syaz2owi _1e0c1txw"
            ])
        }));
    const $06d67bd6df49e4bf$export$a4e6ea3b919ca9a9 = ({ right: right, warnings: warnings })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("aWse0")).useIntlV2)();
        const TooltipComponent = (0, $5uXOq.forwardRef)((tooltipProps, ref)=>$5uXOq.createElement((0, (0, parcelRequire("2dKrm")).default), {
                ...tooltipProps,
                ref: ref
            }));
        const tooltipContent = warnings.map((errorMessage)=>$5uXOq.createElement("div", {
                key: `${errorMessage.id}`,
                className: (0, (0, parcelRequire("bwpsq")).default)([
                    "_1e0c1txw _1bsbp3fh _otyr1b66 _1yt41pyq _2rko1l7b _11q71bhr _16qsac02 _syaz1rn8"
                ])
            }, $5uXOq.createElement((0, ($parcel$interopDefault((0, parcelRequire("1fJir"))))), {
                color: `var(--ds-icon-warning, ${(0, $72ba03e317f3d228$export$c6930421db9fa514)})`,
                LEGACY_size: "medium",
                label: "",
                spacing: "spacious"
            }), $5uXOq.createElement("div", {
                className: (0, (0, parcelRequire("bwpsq")).default)([
                    "_1yt4swc3 _11c816g6 _18u0u2gc"
                ])
            }, formatMessage(errorMessage))));
        return $5uXOq.createElement("div", {
            style: {
                right: `${right}px`
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _1e0c1ule _t9ecwq5g _80omtlke _1pby11wp"
            ])
        }, $5uXOq.createElement((0, (0, parcelRequire("loZC0")).default), {
            component: TooltipComponent,
            content: tooltipContent,
            position: "bottom-start",
            delay: 0,
            hideTooltipOnClick: true,
            tag: $06d67bd6df49e4bf$var$TooltipTag
        }, $5uXOq.createElement((0, ($parcel$interopDefault((0, parcelRequire("1fJir"))))), {
            color: `var(--ds-icon-warning, ${(0, $72ba03e317f3d228$export$c6930421db9fa514)})`,
            label: "",
            spacing: "spacious"
        })));
    };
});
parcelRegister("Aa6uS", function(module, exports) {
    $parcel$export(module.exports, "RoadmapNavigateButton", ()=>$5c049fb6f05e980c$export$f4de1542efe44c4);
    var $bwpsq;
    var $lD23V;
    var $5uXOq = parcelRequire("5uXOq");
    var $9gGFr;
    var $7zdf7;
    var $gwIPs;
    var $4R6GH;
    var $8zOmE;
    var $lwMsT;
    var $3Kr5N;
    var $kyahI;
    var $dCm1o;
    const $5c049fb6f05e980c$var$BUTTON_SIZE = 3 * (0, (0, parcelRequire("gwIPs")).gridSize);
    const $5c049fb6f05e980c$var$DATE_OFFSET = $5c049fb6f05e980c$var$BUTTON_SIZE + (0, (0, parcelRequire("gwIPs")).gridSize);
    const $5c049fb6f05e980c$var$SCROLL_BAR_OFFSET = 10;
    const $5c049fb6f05e980c$var$PAST_BORDER_RADIUS = `0 ${(0, (0, parcelRequire("gwIPs")).borderRadius)}px ${(0, (0, parcelRequire("gwIPs")).borderRadius)}px 0`;
    const $5c049fb6f05e980c$var$FUTURE_BORDER_RADIUS = `${(0, (0, parcelRequire("gwIPs")).borderRadius)}px 0 0 ${(0, (0, parcelRequire("gwIPs")).borderRadius)}px`;
    const $5c049fb6f05e980c$export$f4de1542efe44c4 = ({ itemMinLeftPosition: itemMinLeftPosition, itemMaxRightPosition: itemMaxRightPosition, label: label })=>{
        const { requestViewportScrollBounding: requestViewportScrollBounding, setViewportScroll: setViewportScroll } = (0, (0, parcelRequire("kyahI")).useViewport)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const [isScrollingX] = (0, (0, parcelRequire("3Kr5N")).useIsScrollingX)();
        const [isHovered, setIsHovered] = (0, $5uXOq.useState)(false);
        if (isScrollingX) return null;
        const { scrollLeft: scrollLeft, scrollRight: scrollRight, scrollWidth: scrollWidth, isOverflowY: isOverflowY } = requestViewportScrollBounding();
        const isItemInPast = scrollWidth - itemMaxRightPosition < scrollLeft;
        const isItemInFuture = scrollWidth - itemMinLeftPosition < scrollRight;
        if (!isItemInPast && !isItemInFuture) return null;
        const onMouseEnter = ()=>{
            setIsHovered(true);
        };
        const onMouseLeave = ()=>{
            setIsHovered(false);
        };
        const onClick = ()=>{
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button'
            });
            const analyticsAttributes = {
                direction: isItemInPast ? 'past' : 'future'
            };
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'navigateButton', analyticsAttributes);
            setViewportScroll({
                scrollLeft: itemMinLeftPosition - (0, $3f221b37ec60a4b6$export$6053dd7bb292e51e)
            });
        };
        const shouldApplyVisualRefreshChanges = (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_1');
        const renderArrowIcon = (Icon)=>(0, ($parcel$interopDefault($5uXOq))).createElement(Icon, {
                label: "",
                color: shouldApplyVisualRefreshChanges ? "var(--ds-icon-inverse, #FFFFFF)" : "var(--ds-icon, #44546F)"
            });
        if (isItemInPast) return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "roadmap.timeline-table-kit.ui.chart-item-content.date-content.navigate-button.navigate",
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            onKeyDown: (e)=>(e.key === 'Enter' || e.key === 'Space') && onClick(),
            role: "presentation",
            className: (0, (0, parcelRequire("bwpsq")).default)([
                shouldApplyVisualRefreshChanges ? "_kqswstnw _1e0c1txw _4cvr1h6o _4t3i1tcg _1bsb1tcg _vchhusvi _18u01b66 _2hwx1b66 _2rkoglpi _1yt41b66 _bfhk165m _1pbyouyt _80omtlke _irr31pce" : "_kqswstnw _1e0c1txw _4cvr1h6o _4t3i1tcg _vchhusvi _1yt41b66 _bfhk1i4r _1pbyouyt _80omtlke _irr3arkb",
                !shouldApplyVisualRefreshChanges && "_2rko1gaq"
            ]),
            style: {
                left: `${scrollLeft}px`,
                width: `${$5c049fb6f05e980c$var$BUTTON_SIZE}px`,
                "--_3j09fn": (0, (0, parcelRequire("lD23V")).default)($5c049fb6f05e980c$var$PAST_BORDER_RADIUS)
            }
        }, renderArrowIcon((0, ($parcel$interopDefault((0, parcelRequire("9gGFr")))))), isHovered && (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _1ltvxy5q"
            ])
        }, label));
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "roadmap.timeline-table-kit.ui.chart-item-content.date-content.navigate-button.navigate",
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            onMouseLeave: onMouseLeave,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                shouldApplyVisualRefreshChanges ? "_kqswstnw _1e0c1txw _4cvr1h6o _4t3i1tcg _1bsb1tcg _vchhusvi _18u01b66 _2hwx1b66 _2rkoglpi _1yt41b66 _bfhk165m _1pbyouyt _80omtlke _irr31pce" : "_kqswstnw _1e0c1txw _4cvr1h6o _4t3i1tcg _vchhusvi _1yt41b66 _bfhk1i4r _1pbyouyt _80omtlke _irr3arkb",
                !shouldApplyVisualRefreshChanges && "_2rkoff7z"
            ]),
            style: {
                right: `${scrollRight}px`,
                width: shouldApplyVisualRefreshChanges ? undefined : `${$5c049fb6f05e980c$var$BUTTON_SIZE + (isOverflowY ? $5c049fb6f05e980c$var$SCROLL_BAR_OFFSET : 0)}px`,
                "--_kwbool": (0, (0, parcelRequire("lD23V")).default)($5c049fb6f05e980c$var$FUTURE_BORDER_RADIUS)
            }
        }, renderArrowIcon((0, ($parcel$interopDefault((0, parcelRequire("7zdf7")))))), isHovered && (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            style: {
                right: `${$5c049fb6f05e980c$var$DATE_OFFSET + (isOverflowY ? $5c049fb6f05e980c$var$SCROLL_BAR_OFFSET : 0)}px`
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw"
            ])
        }, label));
    };
    const $5c049fb6f05e980c$var$baseButtonStyles = null;
    const $5c049fb6f05e980c$var$baseButtonStylesOld = null;
    const $5c049fb6f05e980c$var$pastButtonBorderRadiusStyles = null;
    const $5c049fb6f05e980c$var$futureButtonBorderRadiusStyles = null;
    const $5c049fb6f05e980c$var$pastLabelContainerStyles = null;
    const $5c049fb6f05e980c$var$futureLabelContainerStyles = null;
});
parcelRegister("7zdf7", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $5826130b1897de21$var$_react = $5826130b1897de21$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $5826130b1897de21$var$_arrowRight = $5826130b1897de21$var$_interopRequireDefault((parcelRequire("hRg5q")));
    var $5826130b1897de21$var$_arrowRight2 = $5826130b1897de21$var$_interopRequireDefault((parcelRequire("iTmvY")));
    function $5826130b1897de21$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $5826130b1897de21$var$ArrowRightIcon = (props)=>$5826130b1897de21$var$_react.default.createElement($5826130b1897de21$var$_arrowRight.default, Object.assign({
            LEGACY_fallbackIcon: $5826130b1897de21$var$_arrowRight2.default
        }, props));
    $5826130b1897de21$var$ArrowRightIcon.Name = 'ArrowRightIconMigration';
    var $5826130b1897de21$var$_default = module.exports.default = $5826130b1897de21$var$ArrowRightIcon;
});
parcelRegister("hRg5q", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $d003dd5cbd380d88$var$_react = $d003dd5cbd380d88$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $d003dd5cbd380d88$var$_UNSAFE_baseNew = $d003dd5cbd380d88$var$_interopRequireDefault((parcelRequire("dTInF")));
    function $d003dd5cbd380d88$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $d003dd5cbd380d88$var$ArrowRightIcon = (props)=>$d003dd5cbd380d88$var$_react.default.createElement($d003dd5cbd380d88$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1 8h12.75m-4.5-5 5 5-5 5"/>`
        }, props));
    $d003dd5cbd380d88$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
    var $d003dd5cbd380d88$var$_default = module.exports.default = $d003dd5cbd380d88$var$ArrowRightIcon;
});
parcelRegister("iTmvY", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $dc0ed3fb35dabeb9$var$_react = $dc0ed3fb35dabeb9$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $7p1ve;
    var $dc0ed3fb35dabeb9$var$_arrowRight = $dc0ed3fb35dabeb9$var$_interopRequireDefault((parcelRequire("hRg5q")));
    function $dc0ed3fb35dabeb9$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $dc0ed3fb35dabeb9$var$ArrowRightIcon = (props)=>$dc0ed3fb35dabeb9$var$_react.default.createElement((0, parcelRequire("7p1ve")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.793 5.793a1 1 0 0 0 0 1.414L15.586 11H6a1 1 0 0 0 0 2h9.586l-3.793 3.793a1 1 0 0 0 0 1.414c.39.39 1.024.39 1.415 0l5.499-5.5a1 1 0 0 0 .293-.679v-.057a1 1 0 0 0-.293-.678l-5.499-5.5a1 1 0 0 0-1.415 0"/></svg>`
        }, props, {
            newIcon: $dc0ed3fb35dabeb9$var$_arrowRight.default
        }));
    $dc0ed3fb35dabeb9$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
    var $dc0ed3fb35dabeb9$var$_default = module.exports.default = $dc0ed3fb35dabeb9$var$ArrowRightIcon;
});
const $3f221b37ec60a4b6$export$6053dd7bb292e51e = 32;
parcelRegister("4lsbG", function(module, exports) {
    $parcel$export(module.exports, "IntervalDropZones", ()=>$6aa54da9fb003258$export$f18d47ee39e90aec);
    var $5uXOq = parcelRequire("5uXOq");
    var $biT18;
    var $gPXTo;
    var $fjTKQ;
    var $fLTaH;
    const $6aa54da9fb003258$var$VisibleIntervalDropZones = ({ id: id, intervals: intervals, currentIntervalId: currentIntervalId, onClick: onClick })=>{
        const [{ timelineDuration: timelineDuration, timelineWidth: timelineWidth }] = (0, (0, parcelRequire("biT18")).useTimelineState)();
        const activeOrFutureGroups = (0, (0, parcelRequire("fLTaH")).getActiveOrFutureIntervalGroups)({
            intervals: intervals,
            currentIntervalId: currentIntervalId,
            timelineDuration: timelineDuration,
            timelineWidth: timelineWidth
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, activeOrFutureGroups.map((intervalGroup, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fjTKQ")).default), {
                id: id,
                key: index,
                left: Math.max(intervalGroup.left, intervalGroup.targetIntervalLeft),
                right: Math.max(intervalGroup.right, intervalGroup.targetIntervalRight),
                intervals: intervalGroup.intervals,
                onClick: onClick
            })));
    };
    const $6aa54da9fb003258$export$f18d47ee39e90aec = ({ id: id, intervals: intervals, onClick: onClick })=>{
        const [{ isVisible: isVisible, currentIntervalId: currentIntervalId }] = (0, (0, parcelRequire("gPXTo")).useIntervalDropZoneData)(id);
        return isVisible ? (0, ($parcel$interopDefault($5uXOq))).createElement($6aa54da9fb003258$var$VisibleIntervalDropZones, {
            id: id,
            intervals: intervals,
            currentIntervalId: currentIntervalId,
            onClick: onClick
        }) : null;
    };
    var $6aa54da9fb003258$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($6aa54da9fb003258$export$f18d47ee39e90aec);
});
parcelRegister("fjTKQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b024a0b09429ca52$export$2e2bcd8739ae039);
    var $bwpsq;
    var $lD23V;
    var $5uXOq = parcelRequire("5uXOq");
    var $8zOmE;
    var $lwMsT;
    var $gPXTo;
    const $b024a0b09429ca52$var$DROPZONE_BACKGROUND = `var(--ds-background-accent-blue-bolder, ${`${(0, $72ba03e317f3d228$export$ecfc1dff386a3e7a)}`})`;
    const $b024a0b09429ca52$var$INTERVAL_DROPZONE_WIDTH_EXPANSION = 2;
    const $b024a0b09429ca52$var$dropZoneStyles = null;
    const $b024a0b09429ca52$export$ad226bf0b5a21555 = ({ id: id, left: left, right: right, intervals: intervals, onClick: onClickDropZone })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const [targetIntervalId] = (0, (0, parcelRequire("gPXTo")).useTargetIntervalId)(intervals);
        const { resetChartInteractionState: resetChartInteractionState } = (0, (0, parcelRequire("gPXTo")).useResetChartInteractionState)();
        const onClick = ()=>{
            if (onClickDropZone && targetIntervalId !== undefined) {
                const analyticsEvent = createAnalyticsEvent({
                    action: 'clicked',
                    actionSubject: 'dropzone'
                });
                onClickDropZone(id, {
                    intervalId: targetIntervalId
                }, analyticsEvent);
                resetChartInteractionState();
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'intervalDropzone');
            }
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            onClick: onClick,
            onKeyDown: (e)=>(e.key === 'Enter' || e.key === 'Space') && onClick(),
            role: "presentation",
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _4t3igktf _2rko1l7b _1pbycs5v _189eyh40 _1dqonqa1 _1h6duyzt _bfhkuyzt _v5641ql7"
            ]),
            style: {
                left: `${targetIntervalId !== undefined ? left - $b024a0b09429ca52$var$INTERVAL_DROPZONE_WIDTH_EXPANSION : left + 1}px`,
                right: `${targetIntervalId !== undefined ? right - $b024a0b09429ca52$var$INTERVAL_DROPZONE_WIDTH_EXPANSION : right + 1}px`,
                opacity: targetIntervalId !== undefined ? 0.38 : 0.13,
                cursor: targetIntervalId !== undefined ? 'pointer' : 'default',
                borderWidth: targetIntervalId !== undefined ? `${$b024a0b09429ca52$var$INTERVAL_DROPZONE_WIDTH_EXPANSION}px` : 0,
                "--_1m5or25": (0, (0, parcelRequire("lD23V")).default)($b024a0b09429ca52$var$DROPZONE_BACKGROUND)
            }
        });
    };
    var $b024a0b09429ca52$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($b024a0b09429ca52$export$ad226bf0b5a21555);
});
parcelRegister("fLTaH", function(module, exports) {
    $parcel$export(module.exports, "getActiveOrFutureIntervalGroups", ()=>$d88fdd46704e2efe$export$8d82d19c3a1af9a2);
    var $igUC7;
    const $d88fdd46704e2efe$export$8d82d19c3a1af9a2 = ({ intervals: intervals, currentIntervalId: currentIntervalId, timelineDuration: timelineDuration, timelineWidth: timelineWidth })=>{
        let unassignedIntervals = intervals;
        if (currentIntervalId !== undefined) unassignedIntervals = intervals.filter((interval)=>interval.id !== currentIntervalId);
        const intervalGroups = (0, (0, parcelRequire("igUC7")).getIntervalGroupPositions)(unassignedIntervals, timelineDuration, timelineWidth);
        return intervalGroups.filter((intervalGroup)=>intervalGroup.intervals.some((interval)=>interval.state !== (0, $8e299570902dfa36$export$19c4f83398a8dbce)));
    };
});
parcelRegister("8Pp9Z", function(module, exports) {
    $parcel$export(module.exports, "NoDateContent", ()=>$2f0a34bfe061100d$export$372da41cc9735180);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $1XJ20;
    var $3Kr5N;
    var $kyahI;
    var $gXfPZ;
    var $ju548;
    const $2f0a34bfe061100d$var$previewContainerStyles = null;
    const $2f0a34bfe061100d$export$372da41cc9735180 = ({ id: id, level: level, color: color, startDateType: startDateType, dueDateType: dueDateType, isHovered: isHovered, onUpdate: onUpdate, children: children })=>{
        const lastScrollLeft = (0, $5uXOq.useRef)(0);
        const [isScrollingX] = (0, (0, parcelRequire("3Kr5N")).useIsScrollingX)();
        const wasScrollingX = (0, (0, parcelRequire("1XJ20")).usePreviousWithInitial)(isScrollingX);
        const { requestViewportScrollBounding: requestViewportScrollBounding } = (0, (0, parcelRequire("kyahI")).useViewport)();
        const [{ isActive: isActive, leftPosition: leftPosition, rightPosition: rightPosition, dragType: dragType }, { onDragStart: onDragStart, onDrag: onDrag, onDragEnd: onDragEnd, onLingerStart: onLingerStart, onLingerEnd: onLingerEnd, onPreview: onPreview }] = (0, (0, parcelRequire("gXfPZ")).useChartItemInteractions)(id);
        (0, $5uXOq.useEffect)(()=>{
            if (isActive && !dragType) {
                const { scrollLeft: scrollLeft } = requestViewportScrollBounding();
                if (!wasScrollingX && isScrollingX) lastScrollLeft.current = scrollLeft;
                else if (wasScrollingX && !isScrollingX && leftPosition !== undefined) {
                    const scrollOffset = scrollLeft - lastScrollLeft.current;
                    lastScrollLeft.current = scrollLeft;
                    onPreview(leftPosition + scrollOffset);
                }
            }
        });
        const onContainerMouseMove = ({ pageX: pageX, currentTarget: currentTarget })=>{
            onPreview(pageX - currentTarget.getBoundingClientRect().left);
        };
        const onPreviewClick = (params, analyticsEvent)=>{
            onUpdate(id, params, analyticsEvent);
            onLingerEnd();
        };
        const onPreviewDragEnd = (params, analyticsEvent)=>{
            onUpdate(id, params, analyticsEvent);
            onDragEnd();
        };
        if (isHovered && !isScrollingX || isActive && dragType) return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": `roadmap.timeline-table-kit.ui.chart-item-content.no-date-content.preview-container-${id}`,
            onMouseMove: onContainerMouseMove,
            onMouseEnter: onLingerStart,
            onMouseLeave: onLingerEnd,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1osq _4t3i1osq _1e0c1txw _4cvr1h6o _1pbyouyt"
            ])
        }, children, leftPosition !== undefined && rightPosition !== undefined && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ju548")).PreviewBar), {
            level: level,
            color: color,
            startDateType: startDateType,
            dueDateType: dueDateType,
            leftPosition: leftPosition,
            rightPosition: rightPosition,
            onDrag: onDrag,
            onDragStart: onDragStart,
            onDragEnd: onPreviewDragEnd,
            onClick: onPreviewClick
        }));
        return null;
    };
});
parcelRegister("ju548", function(module, exports) {
    $parcel$export(module.exports, "PreviewBar", ()=>$aba5b98745058b32$export$cf6bba1afb8df9b7);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $fNuuD;
    var $8zOmE;
    var $lwMsT;
    var $joGLY;
    var $biT18;
    var $esmwW;
    var $2KlaV;
    var $8QVIw;
    var $apjDv;
    var $9KS0U;
    const $aba5b98745058b32$var$Bar = ({ left: left, right: right, level: level, color: color, children: children, 'data-testid': dataTestId })=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            style: {
                left: `${left}px`,
                right: `${right}px`
            },
            "data-testid": dataTestId,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _1ul91b66 _4t3i1tcg _1e0c1txw _4cvr1h6o _2rko1l7b _tzy4idpf _ju25fnf5 _5sagfnf5 _j7hq3v5s _1pgl1ytf _1o51q7pw _80omtlke",
                (0, (0, parcelRequire("joGLY")).isBaseLevel)(level) && "_4t3igktf"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            style: {
                backgroundColor: (0, (0, parcelRequire("9KS0U")).getBarTheme)(color).background
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1sb2b3bt _kqswstnw _154iidpf _1ltvidpf _94n5idpf _1xi2idpf _tzy4105o _2rko1l7b"
            ])
        }), children);
    const $aba5b98745058b32$var$DraggableBar = (0, (0, parcelRequire("fNuuD")).withDragObserver)($aba5b98745058b32$var$Bar);
    const $aba5b98745058b32$export$cf6bba1afb8df9b7 = ({ level: level, color: color, startDateType: startDateType, dueDateType: dueDateType, leftPosition: leftPosition, rightPosition: rightPosition, onDrag: onDrag, onDragStart: onDragStart, onDragEnd: onDragEnd, onClick: onClick })=>{
        const elemRef = (0, $5uXOq.useRef)(null);
        const [{ timelineDuration: timelineDuration, timelineWidth: timelineWidth }] = (0, (0, parcelRequire("biT18")).useTimelineState)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const startDate = (0, (0, parcelRequire("apjDv")).getStartDate)(leftPosition, timelineDuration, timelineWidth);
        const dueDate = (0, (0, parcelRequire("apjDv")).getDueDate)(rightPosition, timelineDuration, timelineWidth);
        const onHandleDragStart = ()=>{
            onDragStart((0, (0, parcelRequire("2KlaV")).RIGHT));
        };
        const onHandleDragEnd = ()=>{
            const analyticsEvent = createAnalyticsEvent({
                action: 'dragged',
                actionSubject: 'previewBar'
            });
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'previewBar', {
                level: level
            });
            onDragEnd({
                dates: {
                    startDate: startDate,
                    dueDate: dueDate
                }
            }, analyticsEvent);
        };
        const onHandleClick = ()=>{
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'previewBar'
            });
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'previewBar', {
                level: level
            });
            onClick({
                dates: {
                    startDate: startDate,
                    dueDate: dueDate
                }
            }, analyticsEvent);
        };
        const getBarBoundingClientRect = ()=>elemRef.current?.getBoundingClientRect();
        const isIntervalDateType = startDateType === (0, (0, parcelRequire("esmwW")).INTERVAL) && dueDateType === (0, (0, parcelRequire("esmwW")).INTERVAL);
        return ((0, ($parcel$interopDefault($5uXOq))).createElement($aba5b98745058b32$var$DraggableBar, {
            "data-testid": "roadmap.timeline-table-kit.ui.chart-item-content.no-date-content.preview-bar.preview-bar",
            innerRef: elemRef,
            color: color,
            left: leftPosition,
            right: rightPosition,
            isDisabled: isIntervalDateType,
            onDrag: onDrag,
            onDragStart: onHandleDragStart,
            onDragEnd: onHandleDragEnd,
            onClick: onHandleClick
        }, !isIntervalDateType && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8QVIw")).RoadmapDateLabels), {
            startDate: startDate,
            dueDate: dueDate,
            getBarBoundingClientRect: getBarBoundingClientRect
        })));
    };
    const $aba5b98745058b32$var$fadeInStyles = null;
    const $aba5b98745058b32$var$baseLevelStyles = null;
    const $aba5b98745058b32$var$barStyles = null;
    const $aba5b98745058b32$var$indicatorStyles = null;
});
parcelRegister("8QVIw", function(module, exports) {
    $parcel$export(module.exports, "RoadmapDateLabels", ()=>$8c8256320fa62b99$export$b6e3ec15be9e500e);
    var $5uXOq = parcelRequire("5uXOq");
    var $esmwW;
    var $2KlaV;
    var $6gIAo;
    var $cNXyp;
    var $15oyE;
    var $iW5q3;
    const $8c8256320fa62b99$export$b6e3ec15be9e500e = ({ prevStartDate: prevStartDate, prevDueDate: prevDueDate, startDate: startDate, dueDate: dueDate, startDateType: startDateType, dueDateType: dueDateType, placeholder: placeholder, dragType: dragType, getBarBoundingClientRect: getBarBoundingClientRect })=>{
        const displayStartDateType = dragType === (0, (0, parcelRequire("2KlaV")).LEFT) || dragType === (0, (0, parcelRequire("2KlaV")).LEFT_AND_RIGHT) ? (0, (0, parcelRequire("esmwW")).EXPLICIT) : startDateType;
        const displayDueDateType = dragType === (0, (0, parcelRequire("2KlaV")).RIGHT) || dragType === (0, (0, parcelRequire("2KlaV")).LEFT_AND_RIGHT) ? (0, (0, parcelRequire("esmwW")).EXPLICIT) : dueDateType;
        const displayPrevStartDate = dragType !== (0, (0, parcelRequire("2KlaV")).RIGHT) ? prevStartDate : undefined;
        const displayPrevDueDate = dragType !== (0, (0, parcelRequire("2KlaV")).LEFT) ? prevDueDate : undefined;
        const displayStartDate = dragType !== (0, (0, parcelRequire("2KlaV")).RIGHT) ? startDate : undefined;
        const displayDueDate = dragType !== (0, (0, parcelRequire("2KlaV")).LEFT) ? dueDate : undefined;
        const isDurationVisible = !placeholder;
        const placement = (0, (0, parcelRequire("iW5q3")).useDatePlacement)({
            dragType: dragType,
            startDateType: displayStartDateType,
            dueDateType: displayDueDateType,
            placeholder: placeholder,
            isDurationVisible: isDurationVisible,
            getBarBoundingClientRect: getBarBoundingClientRect
        });
        const renderDuration = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cNXyp")).Duration), (0, (0, parcelRequire("15oyE")).getDurationProps)(displayPrevStartDate, displayPrevDueDate, displayStartDate, displayDueDate, dragType, startDate, dueDate));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6gIAo")).FormattedDate), {
            placement: placement,
            startDate: displayStartDate,
            dueDate: displayDueDate,
            startDateType: displayStartDateType,
            dueDateType: displayDueDateType,
            placeholder: placeholder,
            isDurationVisible: isDurationVisible,
            renderDuration: renderDuration
        });
    };
    $8c8256320fa62b99$export$b6e3ec15be9e500e.defaultProps = {
        startDateType: (0, (0, parcelRequire("esmwW")).EXPLICIT),
        dueDateType: (0, (0, parcelRequire("esmwW")).EXPLICIT)
    };
});
parcelRegister("iW5q3", function(module, exports) {
    $parcel$export(module.exports, "useDatePlacement", ()=>$d185f496f15bad19$export$469d58375b7706b3);
    var $kyahI;
    var $2KlaV;
    var $aU7Qz;
    const $d185f496f15bad19$export$469d58375b7706b3 = ({ dragType: dragType, placeholder: placeholder, startDateType: startDateType, dueDateType: dueDateType, isDurationVisible: isDurationVisible, getBarBoundingClientRect: getBarBoundingClientRect })=>{
        const { requestViewportBoundingClient: requestViewportBoundingClient } = (0, (0, parcelRequire("kyahI")).useViewport)();
        const rect = getBarBoundingClientRect();
        if (!rect) return 0, (0, parcelRequire("2KlaV")).LEFT_AND_RIGHT;
        const { isStartDateVisible: isStartDateVisible, isDueDateVisible: isDueDateVisible } = (0, (0, parcelRequire("aU7Qz")).calculateDateVisibilities)(rect, requestViewportBoundingClient(), placeholder, startDateType, dueDateType, isDurationVisible);
        return (0, (0, parcelRequire("aU7Qz")).getDatePlacement)(dragType, isStartDateVisible, isDueDateVisible);
    };
});
parcelRegister("aU7Qz", function(module, exports) {
    $parcel$export(module.exports, "calculateDateVisibilities", ()=>$e9b4be47a370b3b5$export$883141a0ed8178c0);
    $parcel$export(module.exports, "getDatePlacement", ()=>$e9b4be47a370b3b5$export$af34474977f1fefb);
    var $esmwW;
    var $2KlaV;
    var $d8OAB;
    const $e9b4be47a370b3b5$var$APPROX_DATE_PIXELS = 85;
    const $e9b4be47a370b3b5$var$APPROX_PLACEHOLDER_PIXELS = 98;
    const $e9b4be47a370b3b5$var$APPROX_ICON_PIXELS = 20;
    const $e9b4be47a370b3b5$var$APPOX_DURATION_PIXELS = 33;
    const $e9b4be47a370b3b5$var$add = (accumulator, nextValue)=>accumulator + nextValue;
    const $e9b4be47a370b3b5$export$883141a0ed8178c0 = (barRect, viewportRect, placeholder, startDateType, dueDateType, isDurationVisible)=>{
        const { left: barLeft, right: barRight } = barRect;
        const { left: viewportLeft, right: viewportRight } = viewportRect;
        const availableLeftSpace = barLeft - viewportLeft;
        const availableRightSpace = viewportRight - barRight;
        const hasStartDateIcon = startDateType !== (0, (0, parcelRequire("esmwW")).EXPLICIT);
        const hasDueDateIcon = dueDateType !== (0, (0, parcelRequire("esmwW")).EXPLICIT);
        const spaceRequiredLeft = [
            (0, (0, parcelRequire("d8OAB")).isStartDatePlaceholder)(placeholder) ? $e9b4be47a370b3b5$var$APPROX_PLACEHOLDER_PIXELS : $e9b4be47a370b3b5$var$APPROX_DATE_PIXELS,
            hasStartDateIcon ? $e9b4be47a370b3b5$var$APPROX_ICON_PIXELS : 0
        ];
        const spaceRequiredRight = [
            (0, (0, parcelRequire("d8OAB")).isDueDatePlaceholder)(placeholder) ? $e9b4be47a370b3b5$var$APPROX_PLACEHOLDER_PIXELS : $e9b4be47a370b3b5$var$APPROX_DATE_PIXELS,
            hasDueDateIcon ? $e9b4be47a370b3b5$var$APPROX_ICON_PIXELS : 0,
            isDurationVisible ? $e9b4be47a370b3b5$var$APPOX_DURATION_PIXELS : 0
        ];
        return {
            isStartDateVisible: spaceRequiredLeft.reduce($e9b4be47a370b3b5$var$add, 0) <= availableLeftSpace,
            isDueDateVisible: spaceRequiredRight.reduce($e9b4be47a370b3b5$var$add, 0) <= availableRightSpace
        };
    };
    const $e9b4be47a370b3b5$export$af34474977f1fefb = (dragType, isStartDateVisible, isDueDateVisible)=>{
        if (dragType === (0, (0, parcelRequire("2KlaV")).LEFT_AND_RIGHT) || isStartDateVisible && isDueDateVisible || !isStartDateVisible && !isDueDateVisible) return 0, (0, parcelRequire("2KlaV")).LEFT_AND_RIGHT;
        return isStartDateVisible ? (0, (0, parcelRequire("2KlaV")).LEFT) : (0, (0, parcelRequire("2KlaV")).RIGHT);
    };
});
parcelRegister("6SGOe", function(module, exports) {
    $parcel$export(module.exports, "renderBarContent", ()=>$d7c896d1a2121b3d$export$2c88996aa786b971);
    var $5uXOq = parcelRequire("5uXOq");
    var $8QVIw;
    var $lkDhD;
    var $hMIs7;
    var $aWBPr;
    const $d7c896d1a2121b3d$export$2c88996aa786b971 = (barContentProps, barContentState)=>{
        const barContentRenderers = {
            renderBarIcon: (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hMIs7")).BarIcon), {
                    ...props,
                    isHovered: barContentState.isHovered
                }),
            renderDependencyHandler: (props, state)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aWBPr")).DependencyHandler), {
                    ...props,
                    ...state
                }),
            renderDateLabel: (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8QVIw")).RoadmapDateLabels), props)
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lkDhD")).RoadmapBarContent), {
            ...barContentProps,
            ...barContentState,
            ...barContentRenderers
        });
    };
});
parcelRegister("lkDhD", function(module, exports) {
    $parcel$export(module.exports, "RoadmapBarContent", ()=>$30e77cb4b5d52032$export$6ad7b40eb111e24e);
    var $5uXOq = parcelRequire("5uXOq");
    var $4R6GH;
    var $2KlaV;
    const $30e77cb4b5d52032$export$6ad7b40eb111e24e = ({ id: id, dragType: dragType, leftPosition: leftPosition, rightPosition: rightPosition, prevStartDate: prevStartDate, prevDueDate: prevDueDate, startDate: startDate, dueDate: dueDate, startDateType: startDateType, dueDateType: dueDateType, placeholder: placeholder, isActive: isActive, isReadOnly: isReadOnly, isMinimumBar: isMinimumBar, isColorInverted: isColorInverted, renderBarIcon: renderBarIcon, renderDateLabel: renderDateLabel, renderDependencyHandler: renderDependencyHandler, onBarMouseLeave: onBarMouseLeave, getBarBoundingClientRect: getBarBoundingClientRect })=>{
        const isHovered = isActive && !dragType;
        const isDraggingExplicit = isActive && dragType !== undefined;
        const isDragging = dragType !== undefined;
        const getRenderDependencyHandler = ()=>!isDragging && !isReadOnly && renderDependencyHandler({
                id: id,
                leftPosition: leftPosition,
                rightPosition: rightPosition,
                placeholder: placeholder,
                isColorInverted: isColorInverted,
                getBarBoundingClientRect: getBarBoundingClientRect,
                onBarMouseLeave: onBarMouseLeave
            }, {
                isHovered: isHovered
            });
        const getRenderDateLabel = ()=>isDraggingExplicit || isHovered ? renderDateLabel({
                prevStartDate: prevStartDate,
                prevDueDate: prevDueDate,
                startDate: startDate,
                dueDate: dueDate,
                startDateType: startDateType,
                dueDateType: dueDateType,
                placeholder: placeholder,
                getBarBoundingClientRect: getBarBoundingClientRect,
                dragType: dragType
            }) : null;
        const getRenderBarIcon = ()=>!isMinimumBar && !isDraggingExplicit && renderBarIcon({
                id: id,
                leftPosition: leftPosition,
                rightPosition: rightPosition,
                ...(0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-post-project-a11y-fix') ? {
                    isColorInverted: isColorInverted
                } : {}
            });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, getRenderDependencyHandler(), getRenderDateLabel(), getRenderBarIcon());
    };
    $30e77cb4b5d52032$export$6ad7b40eb111e24e.defaultProps = {
        renderBarIcon: (0, (0, parcelRequire("2KlaV")).DEFAULT_RENDERER),
        renderDateLabel: (0, (0, parcelRequire("2KlaV")).DEFAULT_RENDERER),
        renderDependencyHandler: (0, (0, parcelRequire("2KlaV")).DEFAULT_RENDERER)
    };
});
parcelRegister("hMIs7", function(module, exports) {
    $parcel$export(module.exports, "BarIcon", ()=>$b2efab210ffc5a6a$export$48fe3a86c9f0baf3);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $1IqIJ;
    var $cQ0ub;
    var $5nOGd;
    var $6Ll2T;
    var $3srSR;
    var $99gde;
    var $loZC0;
    var $gULOk;
    var $koVbs;
    var $8zOmE;
    var $lwMsT;
    var $dAmbh;
    var $g5X3G;
    var $biT18;
    var $dCm1o;
    var $cl738;
    var $bLz0W;
    var $1l30I;
    const $b2efab210ffc5a6a$var$ICON_SIZE = 20;
    const $b2efab210ffc5a6a$var$BAR_PADDING = 24;
    const $b2efab210ffc5a6a$export$9b0440c731c2c8d1 = (0, $5uXOq.memo)(({ dependees: dependees, dependencies: dependencies, id: id, isHovered: isHovered, issue: issue, withAvatar: withAvatar, withDoneIcon: withDoneIcon, withLinksIcon: withLinksIcon })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const [, { setTooltipParams: setTooltipParams }] = (0, (0, parcelRequire("bLz0W")).useDependencyTooltip)();
        const onLinkIconClick = (0, $5uXOq.useCallback)((event)=>{
            const target = event.currentTarget;
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'icon'
            });
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'dependencyIcon');
            const links = {
                fromIds: dependencies,
                toIds: dependees
            };
            setTimeout(()=>{
                if (target != null) {
                    const { top: top, left: left, height: height } = target.getBoundingClientRect();
                    const position = {
                        x: left,
                        y: top + height
                    };
                    setTooltipParams({
                        id: id,
                        type: (0, $12de84cd008e33eb$export$4b680a32bbb87a28),
                        links: links,
                        position: position
                    });
                }
            });
        }, [
            createAnalyticsEvent,
            dependencies,
            dependees,
            setTooltipParams,
            id
        ]);
        const detailsIcon = (0, ($parcel$interopDefault($5uXOq))).createElement($b2efab210ffc5a6a$var$LinkIconWrapper, {
            onClick: onLinkIconClick
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("loZC0")).default), {
            position: "top",
            content: formatMessage((0, (0, parcelRequire("1l30I")).default).viewDetail),
            hideTooltipOnClick: true
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("5nOGd"))))), {
            size: "small",
            label: "",
            primaryColor: `var(--ds-icon-inverse, ${(0, $72ba03e317f3d228$exports).N0})`
        })));
        return (0, ($parcel$interopDefault($5uXOq))).createElement($b2efab210ffc5a6a$var$BarContentWrapper, {
            isHovered: isHovered,
            withAvatar: withAvatar
        }, withAvatar && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1IqIJ")).default), {
            borderColor: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? 'transparent' : undefined,
            appearance: "circle",
            src: issue?.assignee?.avatarUrl,
            size: "xsmall"
        }), (withDoneIcon || withLinksIcon) && ((0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            xcss: [
                $b2efab210ffc5a6a$var$iconsWrapperStyles
            ]
        }, withDoneIcon && (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("cQ0ub"))))), {
            label: formatMessage((0, (0, parcelRequire("1l30I")).default).doneLabel),
            primaryColor: `var(--ds-icon-inverse, ${(0, $72ba03e317f3d228$exports).N0})`,
            size: "small"
        }), withLinksIcon && detailsIcon) : (0, ($parcel$interopDefault($5uXOq))).createElement($b2efab210ffc5a6a$var$IconsWrapper, null, withDoneIcon && (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("cQ0ub"))))), {
            label: formatMessage((0, (0, parcelRequire("1l30I")).default).doneLabel),
            primaryColor: `var(--ds-icon-inverse, ${(0, $72ba03e317f3d228$exports).N0})`,
            size: "small"
        }), withLinksIcon && detailsIcon)));
    });
    const $b2efab210ffc5a6a$export$48fe3a86c9f0baf3 = ({ id: id, isHovered: isHovered, leftPosition: leftPosition, rightPosition: rightPosition })=>{
        const [{ timelineWidth: timelineWidth }] = (0, (0, parcelRequire("biT18")).useTimelineState)();
        const [{ issuesMap: issuesMap }] = (0, (0, parcelRequire("cl738")).useIssuesMap)();
        const isLinkingEnabled = (0, (0, parcelRequire("dAmbh")).useIsLinkingEnabled)();
        const issue = issuesMap.get(id);
        const [dependencies, dependees] = (0, $5uXOq.useMemo)(()=>{
            const [inwards, outwards] = [
                [],
                []
            ];
            (issue?.issueLinks || []).forEach((link)=>{
                const { inward: inward, outward: outward } = link;
                const inwardId = inward?.issueId;
                const outwardId = outward?.issueId;
                if (inwardId && inwardId !== issue?.issueId && issuesMap.has(inwardId)) inwards.push(inwardId);
                if (outwardId && outwardId !== issue?.issueId && issuesMap.has(outwardId)) outwards.push(outwardId);
            });
            return [
                inwards,
                outwards
            ];
        }, [
            issuesMap,
            issue
        ]);
        const isDone = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("gULOk")).statusCategoryForId)(issue?.status?.categoryId) === (0, (0, parcelRequire("gULOk")).DONE), [
            issue
        ]);
        const hasLinks = isLinkingEnabled && (dependencies.length > 0 || dependees.length > 0);
        if (!issue) return null;
        const barWidth = timelineWidth - leftPosition - rightPosition;
        let shouldShowDone = false;
        let shouldShowAvatar = false;
        let availableIconSpaces = (barWidth - $b2efab210ffc5a6a$var$BAR_PADDING) / $b2efab210ffc5a6a$var$ICON_SIZE;
        if (hasLinks) availableIconSpaces -= 1;
        if (isDone) {
            shouldShowDone = availableIconSpaces >= 1;
            availableIconSpaces -= 1;
        }
        if (availableIconSpaces >= 1) shouldShowAvatar = true;
        const content = (0, ($parcel$interopDefault($5uXOq))).createElement($b2efab210ffc5a6a$export$9b0440c731c2c8d1, {
            dependees: dependees,
            dependencies: dependencies,
            id: (0, (0, parcelRequire("g5X3G")).toIssueId)(id),
            isHovered: isHovered,
            issue: issue,
            withAvatar: shouldShowAvatar,
            withDoneIcon: shouldShowDone,
            withLinksIcon: hasLinks
        });
        return content;
    };
    const $b2efab210ffc5a6a$var$barContentWrapperBaseStylesOld = (0, (0, parcelRequire("99gde")).xcss)({
        flex: 1,
        transition: 'padding-left 100ms ease-in-out',
        pointerEvents: 'none',
        marginRight: 'space.0',
        paddingLeft: 'space.0'
    });
    const $b2efab210ffc5a6a$var$barContentWrapperBaseStyles = (0, (0, parcelRequire("99gde")).xcss)({
        flex: 1,
        transition: 'padding-left 100ms ease-in-out',
        pointerEvents: 'none',
        marginRight: 'space.0',
        paddingLeft: 'space.0',
        gap: 'space.050'
    });
    const $b2efab210ffc5a6a$var$barContentWrapperWithAvatarStyles = (0, (0, parcelRequire("99gde")).xcss)({
        marginRight: 'space.100'
    });
    const $b2efab210ffc5a6a$var$barContentWrapperWithAvatarAndHoverStyles = (0, (0, parcelRequire("99gde")).xcss)({
        paddingLeft: 'space.100'
    });
    const $b2efab210ffc5a6a$var$BarContentWrapper = ({ isHovered: isHovered, withAvatar: withAvatar, children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3srSR")).default), {
            alignItems: "center",
            justifyContent: withAvatar ? 'space-between' : 'center',
            xcss: [
                (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? $b2efab210ffc5a6a$var$barContentWrapperBaseStyles : $b2efab210ffc5a6a$var$barContentWrapperBaseStylesOld,
                withAvatar && $b2efab210ffc5a6a$var$barContentWrapperWithAvatarStyles,
                isHovered && withAvatar && $b2efab210ffc5a6a$var$barContentWrapperWithAvatarAndHoverStyles
            ]
        }, children);
    const $b2efab210ffc5a6a$var$LinkIconWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _1bsbgktf _4t3igktf _2rko1ssb _1pbyegat _80omtlke _p7r11txw _irr3178z",
                __cmplp.className
            ])
        });
    });
    const $b2efab210ffc5a6a$var$IconsWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1yb4",
                __cmplp.className
            ])
        });
    });
    const $b2efab210ffc5a6a$var$iconsWrapperStyles = (0, (0, parcelRequire("99gde")).xcss)({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 'space.050'
    });
});
parcelRegister("cQ0ub", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $958ab7d49d641312$var$_react = $958ab7d49d641312$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $7p1ve;
    var $958ab7d49d641312$var$_checkMark = $958ab7d49d641312$var$_interopRequireDefault((parcelRequire("bZUh6")));
    function $958ab7d49d641312$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $958ab7d49d641312$var$EditorDoneIcon = (props)=>$958ab7d49d641312$var$_react.default.createElement((0, parcelRequire("7p1ve")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M7.356 10.942a.497.497 0 0 0-.713 0l-.7.701a.5.5 0 0 0-.003.71l3.706 3.707a.5.5 0 0 0 .705.003l7.712-7.712a.493.493 0 0 0-.006-.708l-.7-.7a.504.504 0 0 0-.714 0l-6.286 6.286a.506.506 0 0 1-.713 0z"/></svg>`
        }, props, {
            newIcon: $958ab7d49d641312$var$_checkMark.default
        }));
    $958ab7d49d641312$var$EditorDoneIcon.displayName = 'EditorDoneIcon';
    var $958ab7d49d641312$var$_default = module.exports.default = $958ab7d49d641312$var$EditorDoneIcon;
});
parcelRegister("bZUh6", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $8bc10b3745ba142a$var$_react = $8bc10b3745ba142a$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $8bc10b3745ba142a$var$_UNSAFE_baseNew = $8bc10b3745ba142a$var$_interopRequireDefault((parcelRequire("dTInF")));
    function $8bc10b3745ba142a$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $8bc10b3745ba142a$var$CheckMarkIcon = (props)=>$8bc10b3745ba142a$var$_react.default.createElement($8bc10b3745ba142a$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m1.5 8 4.25 5.25 8.75-10.5"/>`
        }, props));
    $8bc10b3745ba142a$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
    var $8bc10b3745ba142a$var$_default = module.exports.default = $8bc10b3745ba142a$var$CheckMarkIcon;
});
parcelRegister("5nOGd", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $3eb669b27c378597$var$_react = $3eb669b27c378597$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $7p1ve;
    var $3eb669b27c378597$var$_link = $3eb669b27c378597$var$_interopRequireDefault((parcelRequire("lF2mK")));
    function $3eb669b27c378597$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $3eb669b27c378597$var$LinkIcon = (props)=>$3eb669b27c378597$var$_react.default.createElement((0, parcelRequire("7p1ve")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="m12.856 5.457-.937.92a1 1 0 0 0 0 1.437 1.047 1.047 0 0 0 1.463 0l.984-.966c.967-.95 2.542-1.135 3.602-.288a2.54 2.54 0 0 1 .203 3.81l-2.903 2.852a2.646 2.646 0 0 1-3.696 0l-1.11-1.09L9 13.57l1.108 1.089c1.822 1.788 4.802 1.788 6.622 0l2.905-2.852a4.558 4.558 0 0 0-.357-6.82c-1.893-1.517-4.695-1.226-6.422.47"/><path d="m11.144 19.543.937-.92a1 1 0 0 0 0-1.437 1.047 1.047 0 0 0-1.462 0l-.985.966c-.967.95-2.542 1.135-3.602.288a2.54 2.54 0 0 1-.203-3.81l2.903-2.852a2.646 2.646 0 0 1 3.696 0l1.11 1.09L15 11.43l-1.108-1.089c-1.822-1.788-4.802-1.788-6.622 0l-2.905 2.852a4.558 4.558 0 0 0 .357 6.82c1.893 1.517 4.695 1.226 6.422-.47"/></g></svg>`
        }, props, {
            newIcon: $3eb669b27c378597$var$_link.default
        }));
    $3eb669b27c378597$var$LinkIcon.displayName = 'LinkIcon';
    var $3eb669b27c378597$var$_default = module.exports.default = $3eb669b27c378597$var$LinkIcon;
});
parcelRegister("lF2mK", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $fc4f431cbf5e81e8$var$_react = $fc4f431cbf5e81e8$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $fc4f431cbf5e81e8$var$_UNSAFE_baseNew = $fc4f431cbf5e81e8$var$_interopRequireDefault((parcelRequire("dTInF")));
    function $fc4f431cbf5e81e8$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $fc4f431cbf5e81e8$var$LinkIcon = (props)=>$fc4f431cbf5e81e8$var$_react.default.createElement($fc4f431cbf5e81e8$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="m5.25 10.75 5.5-5.5M5 6.5 2.75 8.75a3.182 3.182 0 0 0 4.5 4.5L9.5 11m-3-6 2.25-2.25a3.182 3.182 0 0 1 4.5 4.5L11 9.5"/>`
        }, props));
    $fc4f431cbf5e81e8$var$LinkIcon.displayName = 'LinkIcon';
    var $fc4f431cbf5e81e8$var$_default = module.exports.default = $fc4f431cbf5e81e8$var$LinkIcon;
});
const $12de84cd008e33eb$export$4b680a32bbb87a28 = 'DEPENDENCIES_FLYOUT';
const $12de84cd008e33eb$export$a9487b0be9740846 = 'CONTEXT_MENU';
parcelRegister("bLz0W", function(module, exports) {
    $parcel$export(module.exports, "useDependencyTooltip", ()=>$22fd9e4cf6223a57$export$8a5ed5a9e3a93595);
    var $3sQ5x;
    var $iXqE5;
    var $j44uL;
    const $22fd9e4cf6223a57$var$actions = {
        setTooltipParams: (tooltip)=>({ setState: setState, getState: getState })=>setState({
                    ...getState(),
                    tooltipParams: (0, (0, parcelRequire("j44uL")).getDependenciesTooltipParams)({
                        tooltip: tooltip
                    })
                }),
        onCloseTooltip: ()=>({ setState: setState, getState: getState })=>{
                setState({
                    ...getState(),
                    tooltipParams: undefined
                });
            }
    };
    const $22fd9e4cf6223a57$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: {
            tooltipParams: undefined
        },
        actions: $22fd9e4cf6223a57$var$actions,
        name: 'JWMTimelineViewDependencyTooltipStore'
    });
    const $22fd9e4cf6223a57$export$8a5ed5a9e3a93595 = (0, (0, parcelRequire("3sQ5x")).createHook)($22fd9e4cf6223a57$var$Store);
});
parcelRegister("j44uL", function(module, exports) {
    $parcel$export(module.exports, "getDependenciesTooltipParams", ()=>$af1bc718517e71d8$export$9b579a6f4b6af263);
    const $af1bc718517e71d8$export$9b579a6f4b6af263 = ({ tooltip: tooltip })=>{
        if (tooltip && tooltip.type === (0, $12de84cd008e33eb$export$4b680a32bbb87a28)) {
            const { id: id, position: position, links: { fromIds: fromIds, toIds: toIds } } = tooltip;
            return {
                position: position,
                issueId: id,
                dependencies: fromIds,
                dependees: toIds
            };
        }
        return undefined;
    };
});
parcelRegister("1l30I", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$05e944282dfa60d6$export$2e2bcd8739ae039);
    var $7VHMR;
    var $05e944282dfa60d6$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        doneLabel: {
            "id": "business-timeline.timeline-view.chart-item-content.bar-content.bar-icon.done-label",
            "defaultMessage": "Done"
        },
        viewDetail: {
            "id": "business-timeline.timeline-view.chart-item-content.bar-content.bar-icon.view-detail",
            "defaultMessage": "View dependency details"
        }
    });
});
parcelRegister("aWBPr", function(module, exports) {
    $parcel$export(module.exports, "DependencyHandler", ()=>$8b998b6a10fb04ca$export$15fb125bf375b8e5);
    var $5uXOq = parcelRequire("5uXOq");
    var $jJZqs;
    var $pa9q9;
    var $dAmbh;
    var $g5X3G;
    var $geIoM;
    var $28XgU;
    var $cl738;
    var $jxKr9;
    var $7zHmC;
    var $eTzhO;
    const $8b998b6a10fb04ca$export$15fb125bf375b8e5 = (props)=>{
        const { id: id } = props;
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagService)();
        const [{ issuesMap: issuesMap }] = (0, (0, parcelRequire("cl738")).useIssuesMap)();
        const isLinkingEnabled = (0, (0, parcelRequire("dAmbh")).useIsLinkingEnabled)();
        const { hasIssueLinking: hasIssueLinking } = (0, (0, parcelRequire("jxKr9")).useTimelineFeatures)();
        const { create: create } = (0, (0, parcelRequire("7zHmC")).useCreateDependency)();
        const issue = issuesMap.get(id);
        const color = (0, (0, parcelRequire("28XgU")).getColor)(issue?.status.categoryId);
        const onCreateDependency = (from, to)=>{
            if (from !== to) requestAnimationFrame(()=>{
                create({
                    input: {
                        inwardIssueId: (0, (0, parcelRequire("g5X3G")).toIssueId)(to),
                        outwardIssueId: (0, (0, parcelRequire("g5X3G")).toIssueId)(from)
                    }
                }).catch((createError)=>{
                    showFlag({
                        type: 'error',
                        title: (0, (0, parcelRequire("eTzhO")).default).createDependencyErrorTitle,
                        description: createError instanceof (0, (0, parcelRequire("jJZqs")).ValidationError) ? [
                            (0, (0, parcelRequire("eTzhO")).default).createDependencyDynamicErrorMessage,
                            {
                                error: createError.message
                            }
                        ] : (0, (0, parcelRequire("eTzhO")).default).createDependencyErrorMessage
                    });
                });
            });
        };
        if (!hasIssueLinking || isLinkingEnabled !== true) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("geIoM")).RoadmapDependencyHandlers), {
            color: color,
            onCreateDependency: onCreateDependency,
            ...props
        });
    };
});
parcelRegister("geIoM", function(module, exports) {
    $parcel$export(module.exports, "RoadmapDependencyHandlers", ()=>$e41434601f8ce556$export$14c359ef0e13a4a6);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $4R6GH;
    var $2KlaV;
    var $4tYfO;
    var $2XdbK;
    var $c9DTf;
    var $ifO57;
    const $e41434601f8ce556$var$containerStyles = null;
    const $e41434601f8ce556$var$suffixElementStyles = null;
    const $e41434601f8ce556$export$14c359ef0e13a4a6 = ({ id: id, color: color, leftPosition: leftPosition, rightPosition: rightPosition, isHovered: isHovered, placeholder: placeholder, isColorInverted: isColorInverted, onCreateDependency: onCreateDependency, getBarBoundingClientRect: getBarBoundingClientRect, onBarMouseLeave: onBarMouseLeave })=>{
        const [{ isDraggedOver: isDraggedOver }, makeDroppable, cleanupDroppable] = (0, (0, parcelRequire("ifO57")).useDependenciesDrop)(id, onCreateDependency);
        const [currentDragHandle, setCurrentDragHandle] = (0, $5uXOq.useState)(undefined);
        const isDragging = currentDragHandle !== undefined;
        const theme = (0, (0, parcelRequire("2XdbK")).dependencyThemes)?.[color];
        const onDragStart = (0, $5uXOq.useCallback)((type)=>{
            setCurrentDragHandle(type);
            onBarMouseLeave();
        }, [
            onBarMouseLeave
        ]);
        const onDragEnd = (0, $5uXOq.useCallback)(()=>{
            setCurrentDragHandle(undefined);
        }, []);
        (0, $5uXOq.useEffect)(()=>()=>{
                cleanupDroppable();
            }, [
            cleanupDroppable
        ]);
        const renderDragHandle = (type)=>{
            const isHandleInteractive = isHovered || currentDragHandle === type;
            if (!isHandleInteractive) return null;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c9DTf")).default), {
                id: id,
                type: type,
                theme: theme,
                ...(0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-post-project-a11y-fix') ? {
                    isColorInverted: isColorInverted
                } : {},
                leftPosition: leftPosition,
                rightPosition: rightPosition,
                onDrop: onCreateDependency,
                onDragEnd: onDragEnd,
                onDragStart: onDragStart,
                getBarBoundingClientRect: getBarBoundingClientRect
            });
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            style: {
                borderRadius: (0, (0, parcelRequire("4tYfO")).generateBarBorderRadius)(placeholder)
            },
            "data-testid": `roadmap.timeline-table-kit.ui.chart-item-content.date-content.bar.dependency-drop-target-${id}`,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _154iidpf _1ltvidpf _1xi2idpf _94n5idpf _lcxvglyw _1pbyqfx8",
                (0, $708c0d50a54aba38$export$c330e9be73819573)
            ]),
            ref: makeDroppable
        }, renderDragHandle((0, (0, parcelRequire("2KlaV")).TOP)), renderDragHandle((0, (0, parcelRequire("2KlaV")).BOTTOM)), (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            style: {
                borderRadius: (0, (0, parcelRequire("4tYfO")).generateBarBorderRadius)(placeholder),
                boxShadow: `inset 0 0 0 2px ${theme?.border}`,
                opacity: isDragging || isDraggedOver ? 1 : 0
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1sb2b3bt _kqswstnw _1bsb1osq _4t3i1osq _v5641w7c"
            ])
        }));
    };
});
const $708c0d50a54aba38$export$48a2b55760ce2355 = 'dependency-drag-id';
const $708c0d50a54aba38$export$c330e9be73819573 = 'dependencies-drop-target';
const $708c0d50a54aba38$export$920d6feba87a57ed = 'INCOMING';
const $708c0d50a54aba38$export$2c998d8d93f14e97 = 'OUTGOING';
parcelRegister("2XdbK", function(module, exports) {
    $parcel$export(module.exports, "dependencyThemes", ()=>$de083d5b3ad6e702$export$895cd5f608903fe5);
    var $iHPnC;
    const $de083d5b3ad6e702$export$895cd5f608903fe5 = (0, (0, parcelRequire("iHPnC")).transformColorToTheme)((cs)=>({
            icon: cs.primary,
            line: cs.line,
            border: cs.border,
            handle: {
                shadow: cs.primary,
                background: cs.primary
            }
        }));
});
parcelRegister("c9DTf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a90190be4f2816b8$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $lFKmC = parcelRequire("lFKmC");
    var $34ck9 = parcelRequire("34ck9");
    var $4R6GH;
    var $1XJ20;
    var $a7FTH;
    var $3ruU1;
    var $kyahI;
    var $dCm1o;
    var $2KlaV;
    var $bNS7k;
    var $dUhbI;
    var $cNBuF;
    const $a90190be4f2816b8$var$DependenciesDragHandles = ({ theme: theme, id: id, type: type, leftPosition: leftPosition, rightPosition: rightPosition, isColorInverted: isColorInverted, getBarBoundingClientRect: getBarBoundingClientRect, onDrop: onDrop, onDragStart: onDragStart, onDragEnd: onDragEnd })=>{
        const [handlePosition, setHandlePosition] = (0, $5uXOq.useState)(undefined);
        const { custom: custom } = (0, (0, parcelRequire("3ruU1")).useSideEffectMarshal)();
        const { listenToViewportScroll: listenToViewportScroll, stopListeningToViewportScroll: stopListeningToViewportScroll } = (0, (0, parcelRequire("kyahI")).useViewport)();
        const [{ isDragging: isDragging }, makeDraggable, cleanupDraggable] = (0, (0, parcelRequire("cNBuF")).useDependenciesDrag)({
            id: id,
            type: type,
            leftPosition: leftPosition,
            rightPosition: rightPosition,
            getBarBoundingClientRect: getBarBoundingClientRect,
            onDrop: onDrop
        });
        const wasDragging = (0, (0, parcelRequire("1XJ20")).usePreviousWithInitial)(isDragging);
        const onUpdateBarRectPosition = (0, $5uXOq.useCallback)(()=>{
            const barClientRect = getBarBoundingClientRect();
            if (barClientRect) {
                const fixedHandlePosition = (0, (0, parcelRequire("dUhbI")).getFixedHandlePosition)(type, barClientRect);
                setHandlePosition(fixedHandlePosition);
            }
        }, [
            type,
            getBarBoundingClientRect
        ]);
        const onScrollEnd = (0, $5uXOq.useCallback)((0, ($parcel$interopDefault($lFKmC)))(()=>{
            onUpdateBarRectPosition();
        }, 100), []);
        const onScroll = (0, $5uXOq.useCallback)((0, ($parcel$interopDefault($34ck9)))(()=>{
            setHandlePosition(undefined);
            onScrollEnd();
        }, 100), []);
        (0, $5uXOq.useEffect)(()=>{
            listenToViewportScroll(onScroll);
            return ()=>{
                stopListeningToViewportScroll(onScroll);
                cleanupDraggable();
            };
        }, [
            onScroll,
            cleanupDraggable,
            listenToViewportScroll,
            stopListeningToViewportScroll
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!wasDragging && isDragging) {
                onDragStart(type);
                custom.onDependencyDragStart();
            } else if (wasDragging && !isDragging) {
                onDragEnd();
                custom.onDependencyDragEnd();
            }
        }, [
            type,
            isDragging,
            wasDragging,
            onDragEnd,
            onDragStart,
            custom
        ]);
        (0, $5uXOq.useEffect)(()=>{
            onUpdateBarRectPosition();
        }, [
            onUpdateBarRectPosition
        ]);
        if (!handlePosition) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("a7FTH")).default), null, (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('visual-refresh_drop_1') ? (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            style: {
                visibility: isDragging ? 'hidden' : 'visible',
                left: handlePosition.left,
                top: handlePosition.top
            },
            "data-testid": "roadmap.timeline-table-kit.ui.chart-item-content.date-content.bar.bar-content.dependency-handler.handle",
            ref: makeDraggable,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqsw1n9t _1e0c1txw _2lx21bp4 _1bsb1ejb _4t3i1ejb _1bah1h6o _2rko1ssb _lcxv1rj4 _t9ec1ooe _zdyikb7n _f1zwidpf",
                type === (0, (0, parcelRequire("2KlaV")).TOP) && "_18u0t94y _4cvr1y6m",
                type !== (0, (0, parcelRequire("2KlaV")).TOP) && "_18u01n1a _4cvresu3"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-component-selector": "timeline-data-dot",
            style: {
                backgroundColor: theme.handle.background
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1y44 _4t3i1y44 _2rko1ssb _80omtlke _tip8kb7n _v564m7ou",
                type === (0, (0, parcelRequire("2KlaV")).TOP) && "",
                type === (0, (0, parcelRequire("2KlaV")).TOP) && "_y44v1plm _19pk19bv _2hwxidpf _otyryh40 _18u0idpf",
                type !== (0, (0, parcelRequire("2KlaV")).TOP) && "",
                type !== (0, (0, parcelRequire("2KlaV")).TOP) && "_y44v18br _19pkyh40 _2hwxidpf _otyr19bv _18u0idpf"
            ])
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-component-selector": "timeline-drag-handler",
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _154iv77o _1ltvv77o _80omtlke _tzy4idpf _v564m7ou",
                type === (0, (0, parcelRequire("2KlaV")).TOP) && "_18u014id",
                type !== (0, (0, parcelRequire("2KlaV")).TOP) && "_18u019bv"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bNS7k")).DependencyDragHandler), {
            color: theme.icon,
            ...(0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-post-project-a11y-fix') ? {
                isColorInverted: isColorInverted
            } : {}
        }))) : (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            style: {
                visibility: isDragging ? 'hidden' : 'visible',
                left: handlePosition.left,
                top: handlePosition.top
            },
            "data-testid": "roadmap.timeline-table-kit.ui.chart-item-content.date-content.bar.bar-content.dependency-handler.handle",
            ref: makeDraggable,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqsw1n9t _1e0c1txw _2lx21bp4 _1bsb1ejb _4t3i1ejb _4cvr1h6o _1bah1h6o _2rko1ssb _lcxv1rj4 _t9ec1ooe _zdyikb7n _f1zwidpf"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-component-selector": "timeline-data-dot",
            style: {
                backgroundColor: theme.handle.background
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsbu2gc _4t3iu2gc _2rko1ssb _80omtlke _tip8kb7n _v564m7ou",
                type === (0, (0, parcelRequire("2KlaV")).TOP) && "",
                type === (0, (0, parcelRequire("2KlaV")).TOP) && "_y44vmujb",
                type !== (0, (0, parcelRequire("2KlaV")).TOP) && "",
                type !== (0, (0, parcelRequire("2KlaV")).TOP) && "_y44v1rg8"
            ])
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-component-selector": "timeline-drag-handler",
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _154iv77o _1ltvv77o _80omtlke _tzy4idpf _v564m7ou"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bNS7k")).DependencyDragHandler), {
            color: theme.icon,
            ...(0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-post-project-a11y-fix') ? {
                isColorInverted: isColorInverted
            } : {}
        }))));
    };
    var $a90190be4f2816b8$export$2e2bcd8739ae039 = $a90190be4f2816b8$var$DependenciesDragHandles;
    const $a90190be4f2816b8$var$slideInTop = null;
    const $a90190be4f2816b8$var$slideInBottom = null;
    const $a90190be4f2816b8$var$SLIDE_OFFSET_OLD = 15;
    const $a90190be4f2816b8$var$slideInTopOld = null;
    const $a90190be4f2816b8$var$slideInBottomOld = null;
    const $a90190be4f2816b8$var$slideInTopStyles = null;
    const $a90190be4f2816b8$var$slideInBottomStyles = null;
    const $a90190be4f2816b8$var$slideInTopStylesOld = null;
    const $a90190be4f2816b8$var$slideInBottomStylesOld = null;
    const $a90190be4f2816b8$var$dragHandleDotStyles = null;
    const $a90190be4f2816b8$var$dragHandleDotStylesOld = null;
    const $a90190be4f2816b8$var$dragHandleWrapperStyles = null;
    const $a90190be4f2816b8$var$dragHandleTopWrapperStyles = null;
    const $a90190be4f2816b8$var$dragHandleBottomWrapperStyles = null;
    const $a90190be4f2816b8$var$dragHandleContainerStyles = null;
    const $a90190be4f2816b8$var$dragHandleTopContainerStyles = null;
    const $a90190be4f2816b8$var$dragHandleBottomContainerStyles = null;
    const $a90190be4f2816b8$var$dragHandleContainerStylesOld = null;
});
parcelRegister("a7FTH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ce15445016e20ca9$export$2e2bcd8739ae039);
    var $7nsd3 = parcelRequire("7nsd3");
    var $c7Iuw;
    const $ce15445016e20ca9$var$Portal = ({ children: children })=>{
        const { portalContainerElement: portalContainerElement } = (0, (0, parcelRequire("c7Iuw")).usePortalScope)();
        if (portalContainerElement) return (0, $7nsd3.createPortal)(children, portalContainerElement);
        return null;
    };
    var $ce15445016e20ca9$export$2e2bcd8739ae039 = $ce15445016e20ca9$var$Portal;
});
parcelRegister("bNS7k", function(module, exports) {
    $parcel$export(module.exports, "DependencyDragHandler", ()=>$e3bd8fe480a533e4$export$df820fc059ab8cf4);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $fVt6v;
    var $4R6GH;
    var $dCm1o;
    const $e3bd8fe480a533e4$var$iconWrapperStyles = null;
    const $e3bd8fe480a533e4$var$iconWrapperExtraPadding = null;
    const $e3bd8fe480a533e4$var$iconWrapperExtraBorderRadius = null;
    const $e3bd8fe480a533e4$export$df820fc059ab8cf4 = ({ color: color, isColorInverted: isColorInverted })=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            style: {
                backgroundColor: color
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bsbgktf _4t3igktf _2rko1ssb _4cvr1h6o _1bah1h6o _16qsanr3",
                (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && !(0, (0, parcelRequire("4R6GH")).fg)('visual-refresh_drop_1') && "_1yt4v77o",
                (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('visual-refresh_drop_1') && "_2rko1l7b"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("fVt6v"))))), {
            LEGACY_size: "small",
            label: "",
            color: isColorInverted && (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-post-project-a11y-fix') ? "var(--ds-icon, #44546F)" : `var(--ds-icon-inverse, ${0, $72ba03e317f3d228$export$29a4f05edc054374})`
        }));
});
parcelRegister("fVt6v", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $b982c15245ccb96e$var$_react = $b982c15245ccb96e$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $b982c15245ccb96e$var$_link = $b982c15245ccb96e$var$_interopRequireDefault((parcelRequire("lF2mK")));
    var $b982c15245ccb96e$var$_link2 = $b982c15245ccb96e$var$_interopRequireDefault((parcelRequire("5nOGd")));
    function $b982c15245ccb96e$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $b982c15245ccb96e$var$LinkIcon = (props)=>$b982c15245ccb96e$var$_react.default.createElement($b982c15245ccb96e$var$_link.default, Object.assign({
            LEGACY_fallbackIcon: $b982c15245ccb96e$var$_link2.default
        }, props));
    $b982c15245ccb96e$var$LinkIcon.Name = 'LinkIconMigration';
    var $b982c15245ccb96e$var$_default = module.exports.default = $b982c15245ccb96e$var$LinkIcon;
});
parcelRegister("dUhbI", function(module, exports) {
    $parcel$export(module.exports, "getFixedHandlePosition", ()=>$522af83740958082$export$cdacaba1feb143c8);
    $parcel$export(module.exports, "getRelativeHandlePosition", ()=>$522af83740958082$export$eb8d2bc119196ff0);
    var $2KlaV;
    const $522af83740958082$var$FIXED_OFFSET_X = 15;
    const $522af83740958082$var$FIXED_OFFSET_Y = 8;
    const $522af83740958082$export$cdacaba1feb143c8 = (type, barClientRect)=>{
        const { top: top, left: left, width: width, height: height } = barClientRect;
        if (type === (0, (0, parcelRequire("2KlaV")).TOP)) return {
            top: top - $522af83740958082$var$FIXED_OFFSET_Y,
            left: left + $522af83740958082$var$FIXED_OFFSET_X
        };
        return {
            top: top + height + $522af83740958082$var$FIXED_OFFSET_Y,
            left: left + width - $522af83740958082$var$FIXED_OFFSET_X
        };
    };
    const $522af83740958082$export$eb8d2bc119196ff0 = (type, timelineWidth, barLeftPosition, barRightPosition)=>type === (0, (0, parcelRequire("2KlaV")).TOP) ? barLeftPosition : timelineWidth - barRightPosition;
});
parcelRegister("cNBuF", function(module, exports) {
    $parcel$export(module.exports, "useDependenciesDrag", ()=>$9cde0a6c943a8eca$export$8d873462c415f4c3);
    var $5uXOq = parcelRequire("5uXOq");
    var $5EOne = parcelRequire("5EOne");
    var $gOxHv = parcelRequire("gOxHv");
    var $biT18;
    var $kyahI;
    var $dUhbI;
    const $9cde0a6c943a8eca$export$8d873462c415f4c3 = ({ id: id, type: type, getBarBoundingClientRect: getBarBoundingClientRect, leftPosition: leftPosition, rightPosition: rightPosition })=>{
        const cleanupDragAndDrop = (0, $5uXOq.useRef)(null);
        const [dragState, setDragState] = (0, $5uXOq.useState)({
            isDragging: false
        });
        const [{ timelineWidth: timelineWidth }] = (0, (0, parcelRequire("biT18")).useTimelineState)();
        const { requestViewportBoundingClient: requestViewportBoundingClient, requestViewportScrollBounding: requestViewportScrollBounding, setViewportScroll: setViewportScroll } = (0, (0, parcelRequire("kyahI")).useViewport)();
        const makeDraggable = (0, $5uXOq.useCallback)((dragElement)=>{
            const el = dragElement;
            if (el === null) return;
            cleanupDragAndDrop.current = (0, $5EOne.combine)((0, $gOxHv.draggable)({
                element: el,
                getInitialData: ()=>({
                        type: (0, $708c0d50a54aba38$export$48a2b55760ce2355),
                        id: id,
                        handleType: type,
                        barRect: getBarBoundingClientRect(),
                        leftPosition: (0, (0, parcelRequire("dUhbI")).getRelativeHandlePosition)(type, timelineWidth, leftPosition, rightPosition),
                        viewportBoundingRect: requestViewportBoundingClient(),
                        initialScrollBoundingRect: requestViewportScrollBounding(),
                        requestViewportScrollBounding: requestViewportScrollBounding,
                        setViewportScroll: setViewportScroll
                    }),
                onGenerateDragPreview: ({ source: source })=>{
                    const { element: draggedElement } = source;
                    draggedElement.style.opacity = '0';
                },
                onDragStart: ({ source: source })=>{
                    const { element: draggedElement } = source;
                    draggedElement.style.opacity = '1';
                    setDragState({
                        isDragging: true
                    });
                },
                onDrop: ()=>{
                    setDragState({
                        isDragging: false
                    });
                }
            }));
        }, [
            id,
            type,
            leftPosition,
            rightPosition,
            timelineWidth,
            setViewportScroll,
            requestViewportScrollBounding,
            requestViewportBoundingClient,
            getBarBoundingClientRect
        ]);
        const cleanupDraggable = (0, $5uXOq.useCallback)(()=>{
            cleanupDragAndDrop.current?.();
        }, []);
        return [
            dragState,
            makeDraggable,
            cleanupDraggable
        ];
    };
});
parcelRegister("ifO57", function(module, exports) {
    $parcel$export(module.exports, "useDependenciesDrop", ()=>$759cf80b74020be8$export$52e673c9910da4de);
    var $5uXOq = parcelRequire("5uXOq");
    var $5EOne = parcelRequire("5EOne");
    var $gOxHv = parcelRequire("gOxHv");
    var $8zOmE;
    var $lwMsT;
    var $2KlaV;
    const $759cf80b74020be8$export$52e673c9910da4de = (id, onDrop)=>{
        const cleanupDropTarget = (0, $5uXOq.useRef)(null);
        const [dragState, setDragState] = (0, $5uXOq.useState)({
            isDraggedOver: false
        });
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const makeDroppable = (0, $5uXOq.useCallback)((dropTargetElement)=>{
            const el = dropTargetElement;
            if (el === null) return;
            cleanupDropTarget.current = (0, $5EOne.combine)((0, $gOxHv.dropTargetForElements)({
                element: el,
                canDrop: ({ source: source })=>{
                    const item = source.data;
                    return item.type === (0, $708c0d50a54aba38$export$48a2b55760ce2355) && item.id !== id;
                },
                onDragEnter: ({ source: source })=>{
                    const item = source.data;
                    if (item.type === (0, $708c0d50a54aba38$export$48a2b55760ce2355) && item.id !== id) setDragState({
                        isDraggedOver: true
                    });
                },
                onDragLeave: ({ source: source })=>{
                    const item = source.data;
                    if (item.type === (0, $708c0d50a54aba38$export$48a2b55760ce2355) && item.id !== id) setDragState({
                        isDraggedOver: false
                    });
                },
                onDrop: ({ source: source })=>{
                    const item = source.data;
                    const analyticsEvent = createAnalyticsEvent({
                        action: 'dropped',
                        actionSubject: 'dropArea'
                    });
                    (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'dependencyDropArea');
                    const from = item.handleType === (0, (0, parcelRequire("2KlaV")).TOP) ? item.id : id;
                    const to = item.handleType === (0, (0, parcelRequire("2KlaV")).TOP) ? id : item.id;
                    onDrop(from, to, analyticsEvent);
                    setDragState({
                        isDraggedOver: false
                    });
                }
            }));
        }, [
            id,
            onDrop,
            createAnalyticsEvent
        ]);
        const cleanupDroppable = (0, $5uXOq.useCallback)(()=>{
            cleanupDropTarget.current?.();
        }, []);
        return [
            dragState,
            makeDroppable,
            cleanupDroppable
        ];
    };
});
parcelRegister("7zHmC", function(module, exports) {
    $parcel$export(module.exports, "useCreateDependency", ()=>$71bb22464fd74aa9$export$8194a3b2b545a3ed);
    var $5tTFS;
    var $cm8b5;
    var $jcw0u;
    var $4R6GH;
    var $jJZqs;
    var $8zOmE;
    var $lwMsT;
    var $gNAqw;
    var $iZWCl;
    var $cl738;
    var $iYWZH;
    var $ah6g1;
    var $2APUN;
    const $71bb22464fd74aa9$export$5dfc3c3db5e1e7f6 = [
        'issuelinks'
    ];
    const $71bb22464fd74aa9$var$LOCATION = 'timeline create dependency service';
    const $71bb22464fd74aa9$var$QUERY_NAME = 'createDependencyTimelineView';
    const $71bb22464fd74aa9$var$findMutationBadRequestError = (data)=>data?.linkJwmItems?.errors?.find((e)=>e.message);
    const $71bb22464fd74aa9$export$8194a3b2b545a3ed = ()=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const { updateIssueLinksInCache: updateIssueLinksInCache } = (0, (0, parcelRequire("iYWZH")).useUpdateIssueLinksInCache)();
        const [{ issuesMap: issuesMap }] = (0, (0, parcelRequire("cl738")).useIssuesMap)();
        const startExperience = (0, (0, parcelRequire("cm8b5")).useExperienceStart)((0, (0, parcelRequire("gNAqw")).LINK_ISSUES_EXPERIENCE));
        const markExperienceSuccess = (0, (0, parcelRequire("cm8b5")).useExperienceSuccess)((0, (0, parcelRequire("gNAqw")).LINK_ISSUES_EXPERIENCE));
        const markExperienceFailed = (0, (0, parcelRequire("cm8b5")).useExperienceFail)((0, (0, parcelRequire("gNAqw")).LINK_ISSUES_EXPERIENCE));
        const [createDependency, { data: data, loading: loading, error: error }] = (0, (0, parcelRequire("5tTFS")).useMutation)((0, (0, parcelRequire("ah6g1")).CREATE_DEPENDENCY_TIMELINE_MUTATION), {
            onError: (apolloError)=>{
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: $71bb22464fd74aa9$var$QUERY_NAME,
                        packageName: 'jiraBusinessTimeline',
                        teamName: 'jira-yurree'
                    },
                    error: apolloError,
                    attributes: {
                        message: 'Failed to create dependency in timeline view'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                markExperienceFailed($71bb22464fd74aa9$var$LOCATION, apolloError);
                if ((0, (0, parcelRequire("4R6GH")).fg)('business_timeline_dependency_performance_metric')) (0, (0, parcelRequire("iZWCl")).createDependencyExperience).failure({
                    metadata: {
                        error: apolloError.message,
                        location: $71bb22464fd74aa9$var$LOCATION
                    }
                });
            },
            onCompleted: (apolloData)=>{
                const mutationBadRequestError = $71bb22464fd74aa9$var$findMutationBadRequestError(apolloData);
                if (mutationBadRequestError) {
                    const message = mutationBadRequestError.message ?? 'MutationBadRequestError';
                    markExperienceFailed($71bb22464fd74aa9$var$LOCATION, Error(message));
                    if ((0, (0, parcelRequire("4R6GH")).fg)('business_timeline_dependency_performance_metric')) (0, (0, parcelRequire("iZWCl")).createDependencyExperience).failure({
                        metadata: {
                            error: message,
                            location: $71bb22464fd74aa9$var$LOCATION
                        }
                    });
                } else {
                    (0, (0, parcelRequire("8zOmE")).fireOperationalAnalytics)(createAnalyticsEvent({}), `${$71bb22464fd74aa9$var$QUERY_NAME} succeeded`, {});
                    markExperienceSuccess();
                    if ((0, (0, parcelRequire("4R6GH")).fg)('business_timeline_dependency_performance_metric')) (0, (0, parcelRequire("iZWCl")).createDependencyExperience).success();
                }
            }
        });
        const create = async ({ input: input })=>{
            startExperience();
            if ((0, (0, parcelRequire("4R6GH")).fg)('business_timeline_dependency_performance_metric')) (0, (0, parcelRequire("iZWCl")).createDependencyExperience).start();
            const optimisticResponse = {
                linkJwmItems: (0, (0, parcelRequire("2APUN")).createOptimisticLinkItems)({
                    inwardIssueId: input.inwardIssueId,
                    outwardIssueId: input.outwardIssueId,
                    issuesMap: issuesMap
                })
            };
            const response = await createDependency({
                variables: {
                    input: input,
                    fieldIdsToReturn: []
                },
                optimisticResponse: optimisticResponse,
                update: (proxy, result)=>{
                    const linkJwmItems = result.data?.linkJwmItems;
                    if (linkJwmItems) {
                        updateIssueLinksInCache({
                            issueId: linkJwmItems.inwardItem?.issueId,
                            issueLinks: linkJwmItems.inwardItem?.issueLinks
                        });
                        updateIssueLinksInCache({
                            issueId: linkJwmItems.outwardItem?.issueId,
                            issueLinks: linkJwmItems.outwardItem?.issueLinks
                        });
                    }
                }
            });
            const mutationError = $71bb22464fd74aa9$var$findMutationBadRequestError(response.data);
            if (mutationError) throw new (0, (0, parcelRequire("jJZqs")).ValidationError)(mutationError.message ?? '');
        };
        return {
            loading: loading,
            error: error || $71bb22464fd74aa9$var$findMutationBadRequestError(data),
            create: create
        };
    };
});
parcelRegister("iZWCl", function(module, exports) {
    $parcel$export(module.exports, "createDependencyExperience", ()=>$dd267743ae24ff09$export$3af5353323f6a061);
    $parcel$export(module.exports, "removeDependencyExperience", ()=>$dd267743ae24ff09$export$42a9bc49f133586f);
    var $cqpQr;
    var $fwViQ;
    const $dd267743ae24ff09$export$3af5353323f6a061 = new (0, (0, parcelRequire("fwViQ")).UFOExperience)('jira-business.timeline.linkIssues', {
        type: (0, (0, parcelRequire("cqpQr")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("cqpQr")).ExperiencePerformanceTypes).Custom
    });
    const $dd267743ae24ff09$export$42a9bc49f133586f = new (0, (0, parcelRequire("fwViQ")).UFOExperience)('jira-business.timeline.unlinkIssues', {
        type: (0, (0, parcelRequire("cqpQr")).ExperienceTypes).Experience,
        performanceType: (0, (0, parcelRequire("cqpQr")).ExperiencePerformanceTypes).Custom
    });
});
parcelRegister("iYWZH", function(module, exports) {
    $parcel$export(module.exports, "useUpdateIssueLinksInCache", ()=>$bd42ccbb04538f03$export$a74cd4b680b6b775);
    var $daQYX;
    var $1T2vX;
    var $kRkJF;
    var $hlKA4;
    var $4R6GH;
    var $jrO9m;
    var $gNAqw;
    var $9A32U;
    var $evzMt;
    var $6qNs0;
    const $bd42ccbb04538f03$export$a74cd4b680b6b775 = ()=>{
        const { updateItemsInCache: updateItemsInCache } = (0, (0, parcelRequire("hlKA4")).useCacheActions)();
        const [{ issueParentMap: issueParentMap }] = (0, (0, parcelRequire("evzMt")).useIssueParentMap)();
        const { hierarchyLevels: hierarchyLevels } = (0, (0, parcelRequire("1T2vX")).useIssueTypesAndFields)({
            issueOperation: 'VIEW'
        });
        const { quickFiltersJql: quickFiltersJql, hierarchyParent: hierarchyParent, jqlContext: jqlContext, isHidingDoneItems: isHidingDoneItems } = (0, (0, parcelRequire("kRkJF")).useFilteredViewContextInput)({
            view: 'timeline'
        });
        const hierarchyLevel = hierarchyLevels[0]?.level;
        const { data: overview } = (0, (0, parcelRequire("jrO9m")).useOverview)();
        const isOverview = overview != null && Array.isArray(overview.projects);
        let projectKey;
        if (!isOverview && (0, (0, parcelRequire("4R6GH")).fg)('timeline-uses-new-jql-parent-project-directive')) {
            const { key: key } = (0, (0, parcelRequire("daQYX")).useProject)();
            projectKey = key;
        }
        const updateIssueLinksInCache = ({ issueId: issueId, issueLinks: issueLinks })=>{
            if (!issueId) return;
            const parentIssueId = issueParentMap.get(String(issueId));
            const hasParentIssue = parentIssueId != null && hierarchyParent != null;
            updateItemsInCache({
                query: (0, (0, parcelRequire("6qNs0")).TIMELINE_VIEW_ITEMS_QUERY),
                variables: {
                    ...(0, (0, parcelRequire("9A32U")).getVariables)({
                        jqlContext: jqlContext,
                        fieldIds: (0, parcelRequire("gNAqw")).fieldIds,
                        quickFiltersJql: quickFiltersJql,
                        isHidingDoneItems: isHidingDoneItems,
                        hierarchyLevel: hierarchyLevel,
                        hierarchyParent: hierarchyParent,
                        ...hasParentIssue ? {
                            hierarchyParent: undefined,
                            parentIssue: {
                                hierarchyType: hierarchyParent,
                                issueId: parentIssueId
                            }
                        } : {},
                        ...projectKey ? {
                            projectIdOrKey: projectKey
                        } : {}
                    })
                },
                issueIds: [
                    issueId
                ],
                updateItem: (existingIssue)=>({
                        ...existingIssue,
                        issueLinks: issueLinks ?? null
                    })
            });
        };
        return {
            updateIssueLinksInCache: updateIssueLinksInCache
        };
    };
});
parcelRegister("ah6g1", function(module, exports) {
    $parcel$export(module.exports, "CREATE_DEPENDENCY_TIMELINE_MUTATION", ()=>$f84e4dc51bc3e126$export$aca1ef0fe554e695);
    var $5cllN;
    const $f84e4dc51bc3e126$export$aca1ef0fe554e695 = (0, (0, parcelRequire("5cllN")).default)`
    mutation CreateJWMDependencyTimelineView($input: JWMLinkItemsInput!, $fieldIdsToReturn: [String]!) {
        linkJwmItems(input: $input, fieldIdsToReturn: $fieldIdsToReturn) {
            inwardItem {
                issueId
                issueLinks(first: 10) {
                    edges {
                        node {
                            issue {
                                issueId
                            }
                            issueLinkId
                            relationName
                            direction
                        }
                    }
                }	
            }
            outwardItem {
                issueId
                issueLinks(first: 10) {
                    edges {
                        node {
                            issue {
                                issueId
                            }
                            issueLinkId
                            relationName
                            direction
                        }
                    }
                }	
            }
            success
            errors {
                message
                extensions {
                    statusCode
                    errorType
                }
            }
        }
    }
`;
});
parcelRegister("2APUN", function(module, exports) {
    $parcel$export(module.exports, "createOptimisticLinkItems", ()=>$af0f0069d9da9cb6$export$f5f603284bb2b3c7);
    const $af0f0069d9da9cb6$var$OPTIMISTIC_ID_PREFIX = 'optimistic-issuelink-id-';
    const $af0f0069d9da9cb6$export$f5f603284bb2b3c7 = ({ inwardIssueId: inwardIssueId, outwardIssueId: outwardIssueId, issuesMap: issuesMap })=>({
            inwardItem: {
                issueId: Number(inwardIssueId),
                issueLinks: {
                    edges: [
                        ...issuesMap.get(inwardIssueId)?.originalIssueLinks || [],
                        {
                            node: {
                                issue: {
                                    issueId: outwardIssueId,
                                    __typename: 'JiraIssue'
                                },
                                issueLinkId: `${$af0f0069d9da9cb6$var$OPTIMISTIC_ID_PREFIX}${outwardIssueId}`,
                                relationName: 'is blocked by',
                                direction: 'OUTWARD',
                                __typename: 'JiraIssueLink'
                            },
                            __typename: 'JiraIssueLinkEdge'
                        }
                    ],
                    __typename: 'JiraIssueLinkConnection'
                },
                __typename: 'JiraWorkManagementViewItem'
            },
            outwardItem: {
                issueId: Number(outwardIssueId),
                issueLinks: {
                    edges: [
                        ...issuesMap.get(outwardIssueId)?.originalIssueLinks || [],
                        {
                            node: {
                                issue: {
                                    issueId: inwardIssueId,
                                    __typename: 'JiraIssue'
                                },
                                issueLinkId: `${$af0f0069d9da9cb6$var$OPTIMISTIC_ID_PREFIX}${inwardIssueId}`,
                                relationName: 'blocks',
                                direction: 'INWARD',
                                __typename: 'JiraIssueLink'
                            },
                            __typename: 'JiraIssueLinkEdge'
                        }
                    ],
                    __typename: 'JiraIssueLinkConnection'
                },
                __typename: 'JiraWorkManagementViewItem'
            },
            success: true,
            errors: null,
            __typename: 'JWMLinkItemsPayload'
        });
});
parcelRegister("eTzhO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$93ce94d103d0f7dc$export$2e2bcd8739ae039);
    var $7VHMR;
    var $93ce94d103d0f7dc$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        createDependencyErrorTitle: {
            "id": "business-timeline.timeline-view.chart-item-content.bar-content.dependency-handler.create-dependency-error-title",
            "defaultMessage": "We couldn't link items"
        },
        createDependencyErrorMessage: {
            "id": "business-timeline.timeline-view.chart-item-content.bar-content.dependency-handler.create-dependency-error-message",
            "defaultMessage": "Check your connection, then give it another try."
        },
        createDependencyDynamicErrorMessage: {
            "id": "business-timeline.timeline-view.chart-item-content.bar-content.dependency-handler.create-dependency-dynamic-error-message",
            "defaultMessage": "{error}"
        }
    });
});
parcelRegister("9con3", function(module, exports) {
    $parcel$export(module.exports, "START_DATE_LATER_DUE_DATE_MESSAGE_ID", ()=>$55048661ebf896be$export$92d02ff4a955dc9b);
    var $kpGOA;
    const $55048661ebf896be$export$92d02ff4a955dc9b = (0, (0, parcelRequire("kpGOA")).default).startDateLaterDueDate;
});
parcelRegister("kpGOA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$01bfb3b0afbba964$export$2e2bcd8739ae039);
    var $7VHMR;
    var $01bfb3b0afbba964$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        startDateLaterDueDate: {
            "id": "business-timeline.timeline-view.chart-item-content.start-date-later-due-date",
            "defaultMessage": "Start date must be before Due date."
        }
    });
});
parcelRegister("3aigE", function(module, exports) {
    $parcel$export(module.exports, "ChartOverlay", ()=>$38d364ca72bb5728$export$bc9910710930e66a);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $kFsv3;
    var $3eHnk;
    var $9XUGm;
    var $g3prf;
    var $gNAqw;
    var $dadh5;
    var $28XgU;
    var $kXAqX;
    var $bIpGm;
    var $sMiWE;
    const $38d364ca72bb5728$var$DndLongTaskMetricComponent = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dadh5")).DndLongTaskMetric), {
            ...props,
            metricType: (0, $8038b72ffd5aa8d4$export$3ac90e7f239a7193)
        });
    const $38d364ca72bb5728$var$renderOverlayButton = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bIpGm")).ChartOverlayButton), null);
    const $38d364ca72bb5728$export$bc9910710930e66a = ({ issuesMap: issuesMap })=>{
        const [{ headerHeight: headerHeight }] = (0, (0, parcelRequire("g3prf")).useHeaderState)();
        const renderPreview = (props)=>{
            const previewProps = (0, (0, parcelRequire("sMiWE")).getPreviewProps)(props);
            if (!previewProps) return null;
            const item = issuesMap.get(previewProps.id);
            const color = item ? (0, (0, parcelRequire("28XgU")).getColor)(item.status.categoryId) : (0, (0, parcelRequire("kFsv3")).PURPLE);
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kXAqX")).DependencyLinePreview), {
                ...previewProps,
                color: color
            });
        };
        const renderChartDragLayer = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3eHnk")).RoadmapChartDragLayer), {
                type: (0, (0, parcelRequire("gNAqw")).DEPENDENCY_DRAG_ITEM_ID),
                renderPreview: renderPreview,
                DndLongTaskMetric: $38d364ca72bb5728$var$DndLongTaskMetricComponent
            });
        return (0, ($parcel$interopDefault($5uXOq))).createElement($38d364ca72bb5728$var$DragLayerContainer, {
            top: headerHeight
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9XUGm")).RoadmapChartOverlay), {
            renderChartDragLayer: renderChartDragLayer,
            renderOverlayButton: $38d364ca72bb5728$var$renderOverlayButton
        }));
    };
    const $38d364ca72bb5728$var$dragLayerContainerBaseStyles = null;
    const $38d364ca72bb5728$var$DragLayerContainer = ({ top: top, children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            style: {
                top: `${top}px`
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _1xi2idpf _94n5idpf _1ltvidpf _1pby1o8a"
            ])
        }, children);
});
parcelRegister("3eHnk", function(module, exports) {
    $parcel$export(module.exports, "RoadmapChartDragLayer", ()=>$3c28ef0c3dfa742a$export$f32354274fa76e25);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $8QpSo;
    var $5EOne = parcelRequire("5EOne");
    var $gOxHv = parcelRequire("gOxHv");
    var $bdtf9;
    const $3c28ef0c3dfa742a$var$getDefaultPreviewProps = (0, (0, parcelRequire("8QpSo")).default)(()=>({
            item: undefined,
            clientOffset: {
                x: 0,
                y: 0
            },
            scrollOffset: {
                scrollLeft: 0,
                scrollTop: 0
            }
        }));
    const $3c28ef0c3dfa742a$export$f32354274fa76e25 = ({ type: type, renderPreview: renderPreview, DndLongTaskMetric: DndLongTaskMetric = ()=>null })=>{
        const defaultPreviewProps = (0, $5uXOq.useMemo)(()=>$3c28ef0c3dfa742a$var$getDefaultPreviewProps(), []);
        const [isDragging, setIsDragging] = (0, $5uXOq.useState)(false);
        const [previewProps, setPreviewProps] = (0, $5uXOq.useState)(defaultPreviewProps);
        (0, $5uXOq.useEffect)(()=>(0, $5EOne.combine)((0, $gOxHv.monitorForElements)({
                onDrag: ({ source: source, location: location })=>{
                    const item = source.data;
                    const { current: { input: current }, initial: { input: initial } } = location;
                    if (item.type === type) {
                        const { viewportBoundingRect: viewportBoundingRect, initialScrollBoundingRect: initialScrollBoundingRect, requestViewportScrollBounding: requestViewportScrollBounding, setViewportScroll: setViewportScroll } = item;
                        const initialOffset = {
                            x: initial.pageX,
                            y: initial.pageY
                        };
                        const clientOffset = {
                            x: current.pageX,
                            y: current.pageY
                        };
                        if (initialOffset && clientOffset) {
                            const { scrollLeft: scrollLeft, scrollTop: scrollTop } = (0, (0, parcelRequire("bdtf9")).adjustScrollPosition)(initialOffset, clientOffset, setViewportScroll, initialScrollBoundingRect, requestViewportScrollBounding, viewportBoundingRect);
                            const previewItem = source.data;
                            setPreviewProps({
                                item: previewItem,
                                clientOffset: clientOffset,
                                scrollOffset: {
                                    scrollLeft: scrollLeft,
                                    scrollTop: scrollTop
                                }
                            });
                        }
                        setIsDragging(true);
                    }
                },
                onDrop ({ source: source }) {
                    const item = source.data;
                    if (item.type === type) {
                        setPreviewProps(defaultPreviewProps);
                        setIsDragging(false);
                    }
                }
            })), [
            type,
            defaultPreviewProps
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($3c28ef0c3dfa742a$var$Container, null, renderPreview(previewProps), (0, ($parcel$interopDefault($5uXOq))).createElement(DndLongTaskMetric, {
            isDragging: isDragging
        }));
    };
    const $3c28ef0c3dfa742a$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _1ltvidpf _154iidpf _1xi2idpf _94n5idpf _1reo15vq _18m915vq",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("9XUGm", function(module, exports) {
    $parcel$export(module.exports, "RoadmapChartOverlay", ()=>$4ea548ad2a1681c4$export$74441df56fec708f);
    var $5uXOq = parcelRequire("5uXOq");
    const $4ea548ad2a1681c4$export$74441df56fec708f = ({ renderChartDragLayer: renderChartDragLayer = ()=>null, renderOverlayButton: renderOverlayButton = ()=>null })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, renderOverlayButton(), renderChartDragLayer());
});
parcelRegister("kXAqX", function(module, exports) {
    $parcel$export(module.exports, "DependencyLinePreview", ()=>$0a253ef59cc7013e$export$893df8e27c9969cb);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $kFsv3;
    var $cUvhQ;
    var $h03uX;
    const $0a253ef59cc7013e$export$893df8e27c9969cb = ({ x0: x0, y0: y0, x: x, y: y, width: width, height: height, color: color })=>{
        const theme = (0, (0, parcelRequire("cUvhQ")).dependencyThemes)[color];
        const top = y - 5;
        const left = x - 5;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("h03uX")).Icon), {
            color: theme.icon,
            top: top,
            left: left
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: width,
            height: height
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($0a253ef59cc7013e$export$17d680238e50603e, {
            x1: x0,
            y1: y0,
            x2: left,
            y2: top,
            color: theme.line
        })));
    };
    $0a253ef59cc7013e$export$893df8e27c9969cb.defaultProps = {
        color: (0, (0, parcelRequire("kFsv3")).PURPLE)
    };
    const $0a253ef59cc7013e$export$17d680238e50603e = (0, $5uXOq.forwardRef)(({ as: C = "line", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: {
                ...__cmpls,
                "--_xexnhp": (0, (0, parcelRequire("lD23V")).default)(__cmplp.color)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1s171cj8 _1snbcs5v _134c892t _lswuglyw",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("cUvhQ", function(module, exports) {
    $parcel$export(module.exports, "dependencyThemes", ()=>$8e9b945e6e9a8482$export$895cd5f608903fe5);
    var $iHPnC;
    const $8e9b945e6e9a8482$export$895cd5f608903fe5 = (0, (0, parcelRequire("iHPnC")).transformColorToTheme)((cs)=>({
            icon: cs.primary,
            line: cs.line,
            border: cs.border,
            handle: {
                shadow: cs.primary,
                background: cs.primary
            }
        }));
});
parcelRegister("h03uX", function(module, exports) {
    $parcel$export(module.exports, "Icon", ()=>$bc5fac4928e90f35$export$f04a61298a47a40f);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $boqJs;
    const $bc5fac4928e90f35$export$f04a61298a47a40f = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement($bc5fac4928e90f35$var$Wrapper, {
            top: props.top,
            left: props.left
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("boqJs")).DependencyIcon), {
            color: props.color
        }));
    const $bc5fac4928e90f35$var$ICON_SIZE = 20;
    const $bc5fac4928e90f35$var$wrapperBaseStyles = null;
    const $bc5fac4928e90f35$var$Wrapper = ({ top: top, left: left, children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            style: {
                top: `${top}px`,
                left: `${left}px`
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _1bsbgktf _4t3igktf _t9ec8aj6"
            ])
        }, children);
});
parcelRegister("boqJs", function(module, exports) {
    $parcel$export(module.exports, "DependencyIcon", ()=>$e019f9f55a1b4f82$export$1ebee5633231798d);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $5nOGd;
    var $koVbs;
    var $avff1;
    const $e019f9f55a1b4f82$export$1ebee5633231798d = (props)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($e019f9f55a1b4f82$var$Wrapper, {
            color: props.color
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("5nOGd"))))), {
            size: "small",
            primaryColor: `var(--ds-icon-inverse, ${(0, $72ba03e317f3d228$export$29a4f05edc054374)})`,
            label: formatMessage((0, (0, parcelRequire("avff1")).default).tooltip)
        }));
    };
    const $e019f9f55a1b4f82$var$ICON_SIZE = 20;
    const $e019f9f55a1b4f82$var$Wrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: {
                ...__cmpls,
                "--_xexnhp": (0, (0, parcelRequire("lD23V")).default)(__cmplp.color)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_bfhk1cj8 _1e0c1txw _1bsbgktf _4t3igktf _2rko1ssb _4cvr1h6o _1bah1h6o _16qsanr3",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("avff1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ceb4fb76891bd79a$export$2e2bcd8739ae039);
    var $7VHMR;
    var $ceb4fb76891bd79a$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        tooltip: {
            "id": "business-timeline.common.dependency-icon.tooltip",
            "defaultMessage": "Create a dependency"
        }
    });
});
parcelRegister("bIpGm", function(module, exports) {
    $parcel$export(module.exports, "ChartOverlayButton", ()=>$41f11afb7dc62e39$export$b17a49730a3f0177);
    var $5uXOq = parcelRequire("5uXOq");
    var $dPzs1;
    var $4R6GH;
    var $99BAr;
    var $ACELo;
    var $dL11T;
    var $dCm1o;
    var $qFFvI;
    var $kjQs8;
    var $41NW4;
    const $41f11afb7dc62e39$var$getFullscreenRefs = ()=>{
        return Array.from(document.querySelectorAll('[data-fullscreen-id]'));
    };
    const $41f11afb7dc62e39$export$b17a49730a3f0177 = ()=>{
        const interactionMetrics = (0, (0, parcelRequire("qFFvI")).useInteractionMetrics)();
        const [, { setTimelineMode: setTimelineMode }] = (0, (0, parcelRequire("kjQs8")).useTimelineUI)();
        const toolbarItems = [
            ...(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_1') ? [
                {
                    id: 'today-button',
                    element: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("41NW4")).default), null),
                    showDivider: true,
                    isVisible: true
                }
            ] : [],
            {
                id: 'timeline-mode-switcher',
                element: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dL11T")).RoadmapTimelineMode), {
                    onClick: (mode)=>{
                        interactionMetrics[0, (0, parcelRequire("qFFvI")).TIMELINE_MODE_CHANGED].start();
                        setTimelineMode(mode);
                    }
                }),
                showDivider: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_1') && false
            },
            {
                id: 'fullscreen-button',
                element: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("99BAr")).default), {
                    testId: "business-timeline.ui.timeline-view.chart-overlay.overlay-button.fullscreen-button",
                    withContainerStyles: false,
                    getCustomRefs: $41f11afb7dc62e39$var$getFullscreenRefs,
                    isSubtle: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)()
                })
            }
        ];
        const toolbar = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dPzs1")).default), {
            items: toolbarItems
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ACELo")).JiraBottomRightCornerOutlet), {
            orderFromRight: 2,
            id: "business-timeline-overlay"
        }, toolbar);
    };
});
parcelRegister("dPzs1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$009921c45d78ef32$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $2APCZ;
    var $9jNMw;
    var $7W2Zb;
    var $hdv9O;
    var $fY25f;
    var $jkePi;
    var $4R6GH;
    var $koVbs;
    var $dCm1o;
    var $aaUcm;
    var $6rGzM;
    const $009921c45d78ef32$var$renderItem = (key, component, showDivider)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, {
            key: key
        }, showDivider && (0, ($parcel$interopDefault($5uXOq))).createElement($009921c45d78ef32$var$Divider, {
            "data-testid": "aais-timeline-toolbar.ui.container.divider"
        }), component);
    const $009921c45d78ef32$var$Toolbar = ({ items: items, isCollapsible: isCollapsible = true })=>{
        const [isExpanded, setIsExpanded] = (0, $5uXOq.useState)(true);
        const toggleIsExpanded = (0, $5uXOq.useCallback)(()=>{
            if (isCollapsible) setIsExpanded(!isExpanded);
        }, [
            isExpanded,
            isCollapsible,
            setIsExpanded
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!isExpanded && !isCollapsible) setIsExpanded(true);
        }, [
            isExpanded,
            isCollapsible,
            setIsExpanded
        ]);
        const renderContent = ()=>items.filter(({ isVisible: isVisible = true })=>isVisible).map(({ id: id, element: element, showDivider: showDivider }, index)=>{
                return $009921c45d78ef32$var$renderItem(id, element, (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && showDivider !== undefined ? showDivider : isCollapsible || index !== 0);
            });
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const COLLAPSED_WIDTH = (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? '0px' : '32px';
        return (0, ($parcel$interopDefault($5uXOq))).createElement($009921c45d78ef32$var$TimelineToolbarWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6rGzM")).default), {
            isExpanded: isExpanded,
            collapsedWidth: COLLAPSED_WIDTH
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($009921c45d78ef32$var$TimelineToolbarContainer, null, !(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && isCollapsible && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2APCZ")).default), {
            testId: "aais-timeline-toolbar.ui.container.expand-button",
            appearance: "subtle",
            onClick: toggleIsExpanded,
            iconBefore: isExpanded ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("hdv9O"))))), {
                label: formatMessage((0, (0, parcelRequire("aaUcm")).default).expandButtonLabel)
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("7W2Zb"))))), {
                label: formatMessage((0, (0, parcelRequire("aaUcm")).default).collapseButtonLabel)
            }),
            "aria-expanded": isExpanded,
            ...(0, (0, parcelRequire("4R6GH")).fg)('platform_button_item-add-ufo-metrics') ? {
                interactionName: 'timeline-toolbar-expand-clicked'
            } : {}
        }), renderContent())), (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9jNMw")).default), {
            label: isExpanded ? formatMessage((0, (0, parcelRequire("aaUcm")).default).expandButtonLabel) : formatMessage((0, (0, parcelRequire("aaUcm")).default).collapseButtonLabel),
            "aria-expanded": isExpanded,
            testId: "aais-timeline-toolbar.ui.container.expand-button",
            appearance: "subtle",
            onClick: toggleIsExpanded,
            icon: ()=>isExpanded ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("jkePi"))))), {
                    label: "",
                    color: "currentColor"
                }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("fY25f"))))), {
                    label: "",
                    color: "currentColor"
                }),
            ...(0, (0, parcelRequire("4R6GH")).fg)('platform_button_item-add-ufo-metrics') ? {
                interactionName: 'timeline-toolbar-expand-clicked'
            } : {}
        }));
    };
    var $009921c45d78ef32$export$2e2bcd8739ae039 = $009921c45d78ef32$var$Toolbar;
    const $009921c45d78ef32$var$Divider = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_bfhkb5v6 _4t3i1tcg _1bsbt94y",
                __cmplp.className
            ])
        });
    });
    const $009921c45d78ef32$var$TimelineToolbarWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_bfhkhp5a _1yt41b66 _1e0c1txw _2rko1l7b _1reo15vq _18m915vq _189et94y _1dqonqa1 _1h6db5v6 _16qscbcv",
                __cmplp.className
            ])
        });
    });
    const $009921c45d78ef32$var$TimelineToolbarContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _zulp1b66 _1o9zidpf _1puhidpf",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("7W2Zb", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $5c70442189aee7f4$var$_react = $5c70442189aee7f4$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $7p1ve;
    var $5c70442189aee7f4$var$_chevronLeft = $5c70442189aee7f4$var$_interopRequireDefault((parcelRequire("fY25f")));
    function $5c70442189aee7f4$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $5c70442189aee7f4$var$ChevronLeftCircleIcon = (props)=>$5c70442189aee7f4$var$_react.default.createElement((0, parcelRequire("7p1ve")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M13.706 9.698a.99.99 0 0 0 0-1.407 1.01 1.01 0 0 0-1.419 0l-2.965 2.94a1.09 1.09 0 0 0 0 1.548l2.955 2.93a1.01 1.01 0 0 0 1.42 0 .99.99 0 0 0 0-1.407l-2.318-2.297z"/></g></svg>`
        }, props, {
            newIcon: $5c70442189aee7f4$var$_chevronLeft.default,
            iconType: "utility"
        }));
    $5c70442189aee7f4$var$ChevronLeftCircleIcon.displayName = 'ChevronLeftCircleIcon';
    var $5c70442189aee7f4$var$_default = module.exports.default = $5c70442189aee7f4$var$ChevronLeftCircleIcon;
});
parcelRegister("fY25f", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $b9fe135dcc94eb49$var$_react = $b9fe135dcc94eb49$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $b9fe135dcc94eb49$var$_UNSAFE_baseNew = $b9fe135dcc94eb49$var$_interopRequireDefault((parcelRequire("dTInF")));
    function $b9fe135dcc94eb49$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $b9fe135dcc94eb49$var$ChevronLeftIcon = (props)=>$b9fe135dcc94eb49$var$_react.default.createElement($b9fe135dcc94eb49$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M7.5 10.5 3 6l4.5-4.5"/>`,
            type: 'utility'
        }, props));
    $b9fe135dcc94eb49$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
    var $b9fe135dcc94eb49$var$_default = module.exports.default = $b9fe135dcc94eb49$var$ChevronLeftIcon;
});
parcelRegister("hdv9O", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $c88bd1c4cae28117$var$_react = $c88bd1c4cae28117$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $7p1ve;
    var $c88bd1c4cae28117$var$_chevronRight = $c88bd1c4cae28117$var$_interopRequireDefault((parcelRequire("jkePi")));
    function $c88bd1c4cae28117$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $c88bd1c4cae28117$var$ChevronRightCircleIcon = (props)=>$c88bd1c4cae28117$var$_react.default.createElement((0, parcelRequire("7p1ve")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M10.294 9.698a.99.99 0 0 1 0-1.407 1.01 1.01 0 0 1 1.419 0l2.965 2.94a1.09 1.09 0 0 1 0 1.548l-2.955 2.93a1.01 1.01 0 0 1-1.42 0 .99.99 0 0 1 0-1.407l2.318-2.297z"/></g></svg>`
        }, props, {
            newIcon: $c88bd1c4cae28117$var$_chevronRight.default,
            iconType: "utility"
        }));
    $c88bd1c4cae28117$var$ChevronRightCircleIcon.displayName = 'ChevronRightCircleIcon';
    var $c88bd1c4cae28117$var$_default = module.exports.default = $c88bd1c4cae28117$var$ChevronRightCircleIcon;
});
parcelRegister("aaUcm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2ec76cd846c1264c$export$2e2bcd8739ae039);
    var $7VHMR;
    var $2ec76cd846c1264c$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        expandButtonLabel: {
            "id": "aais-timeline-toolbar.container.expand-button-label",
            "defaultMessage": "Expand timeline time period buttons"
        },
        collapseButtonLabel: {
            "id": "aais-timeline-toolbar.container.collapse-button-label",
            "defaultMessage": "Collapse timeline time period buttons"
        }
    });
});
parcelRegister("6rGzM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3c037e2fcf2c9120$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $8Rkzz = parcelRequire("8Rkzz");
    var $hQy28;
    var $6PHzB;
    var $7XYc4;
    var $dCm1o;
    const $3c037e2fcf2c9120$var$WidthExpander = ({ isExpanded: isExpanded, collapsedWidth: collapsedWidth, children: children })=>{
        const [width, setWidth] = (0, $5uXOq.useState)(isExpanded ? 'auto' : collapsedWidth);
        const prefersReducedMotion = (0, (0, parcelRequire("6PHzB")).useIsReducedMotion)();
        const duration = prefersReducedMotion ? 0 : (0, (0, parcelRequire("hQy28")).mediumDurationMs);
        const isFirstRender = (0, $5uXOq.useRef)(true);
        const state = (0, $5uXOq.useRef)(isExpanded ? 'expanded' : 'collapsed');
        const ref = (0, $5uXOq.useRef)(null);
        (0, $5uXOq.useLayoutEffect)(()=>{
            if (ref.current === null) return 0, ($parcel$interopDefault($8Rkzz));
            if (isFirstRender.current) {
                isFirstRender.current = false;
                return 0, ($parcel$interopDefault($8Rkzz));
            }
            if (prefersReducedMotion) {
                setWidth(isExpanded ? 'auto' : collapsedWidth);
                return 0, ($parcel$interopDefault($8Rkzz));
            }
            const expandedWidth = `${ref.current.offsetWidth}px`;
            if (state.current === 'transitioning') setWidth(isExpanded ? expandedWidth : collapsedWidth);
            else setWidth(expandedWidth);
            const immediate = setTimeout(()=>{
                if (!isExpanded) setWidth(collapsedWidth);
                state.current = 'transitioning';
            }, 1);
            const afterDuration = setTimeout(()=>{
                if (isExpanded) setWidth('auto');
                state.current = isExpanded ? 'expanded' : 'collapsed';
            }, (0, (0, parcelRequire("hQy28")).mediumDurationMs));
            return ()=>{
                clearTimeout(immediate);
                clearTimeout(afterDuration);
            };
        }, [
            isExpanded,
            collapsedWidth,
            duration,
            prefersReducedMotion
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($3c037e2fcf2c9120$var$OuterWrapper, {
            width: width,
            duration: duration,
            "data-testid": "aais-timeline-toolbar.ui.container.width-expander"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($3c037e2fcf2c9120$var$InnerWrapper, {
            ref: ref
        }, children));
    };
    var $3c037e2fcf2c9120$export$2e2bcd8739ae039 = $3c037e2fcf2c9120$var$WidthExpander;
    const $3c037e2fcf2c9120$var$OuterWrapperOld = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { duration: duration, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_1gljcou": (0, (0, parcelRequire("lD23V")).default)(__cmplp.width),
                "--_7nn7wk": (0, (0, parcelRequire("lD23V")).default)(`width ${__cmplp.duration}ms ${(0, $8ca9235fc648952f$export$c07234257a03d5e9)}`)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _njlp1rql _1bsb1rkg _v5641lsu",
                __cmplp.className
            ])
        });
    });
    const $3c037e2fcf2c9120$var$OuterWrapperNew = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { duration: duration, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_1gljcou": (0, (0, parcelRequire("lD23V")).default)(__cmplp.width),
                "--_7nn7wk": (0, (0, parcelRequire("lD23V")).default)(`width ${__cmplp.duration}ms ${(0, $8ca9235fc648952f$export$c07234257a03d5e9)}`)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _njlp1rql _1bsb1rkg _v5641lsu _1reo15vq _18m915vq",
                __cmplp.className
            ])
        });
    });
    const $3c037e2fcf2c9120$var$OuterWrapper = (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled), $3c037e2fcf2c9120$var$OuterWrapperNew, $3c037e2fcf2c9120$var$OuterWrapperOld);
    const $3c037e2fcf2c9120$var$InnerWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1o9zidpf",
                __cmplp.className
            ])
        });
    });
});
const $8ca9235fc648952f$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
const $8ca9235fc648952f$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
const $8ca9235fc648952f$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';
parcelRegister("99BAr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d6d923fac0cd07eb$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $gucb2;
    const $d6d923fac0cd07eb$var$FullscreenButton = ({ testId: testId, onToggle: onToggle, getCustomRefs: getCustomRefs, analyticsAttributes: analyticsAttributes, withContainerStyles: withContainerStyles = true, defaultFullscreen: defaultFullscreen = false, isFullscreen: isFullscreenProp, renderAsResponsiveButton: renderAsResponsiveButton = false, shouldRenderContent: shouldRenderContent = true, isSubtle: isSubtle })=>{
        const [isFullscreenState, setIsFullscreenState] = (0, $5uXOq.useState)(isFullscreenProp ?? defaultFullscreen);
        const isFullscreen = isFullscreenProp ?? isFullscreenState;
        const handleToggle = (wasFullscreen, globalStyle)=>{
            onToggle(wasFullscreen, globalStyle);
            setIsFullscreenState(!wasFullscreen);
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gucb2")).default), {
            testId: testId,
            onToggle: handleToggle,
            getCustomRefs: getCustomRefs,
            analyticsAttributes: analyticsAttributes,
            withContainerStyles: withContainerStyles,
            defaultFullscreen: defaultFullscreen,
            isFullscreen: isFullscreen,
            renderAsResponsiveButton: renderAsResponsiveButton,
            shouldRenderContent: shouldRenderContent,
            isSubtle: isSubtle
        });
    };
    $d6d923fac0cd07eb$var$FullscreenButton.defaultProps = {
        onToggle: (0, ($parcel$interopDefault($8Rkzz))),
        getCustomRefs: ()=>[],
        analyticsAttributes: {}
    };
    var $d6d923fac0cd07eb$export$2e2bcd8739ae039 = $d6d923fac0cd07eb$var$FullscreenButton;
});
parcelRegister("gucb2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f59079bf3589c5a6$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $2APCZ;
    var $9jNMw;
    var $6mooq;
    var $9RB46;
    var $loZC0;
    var $3Tty1;
    var $4R6GH;
    var $koVbs;
    var $g7crU;
    var $3HwlS;
    var $8zOmE;
    var $6lmg7;
    var $dCm1o;
    var $gydfO;
    const $f59079bf3589c5a6$var$removeFullScreenStyle = (customRefs)=>{
        document.getElementById('fullscreen-global-style')?.remove();
        if (customRefs) customRefs.forEach((ref)=>{
            if (ref !== null) ref.classList.remove('fullscreen');
        });
    };
    const $f59079bf3589c5a6$var$FullscreenButton = ({ testId: testId, onToggle: onToggle, getCustomRefs: getCustomRefs, analyticsAttributes: extraAnalyticsAttributes, withContainerStyles: withContainerStyles = true, defaultFullscreen: defaultFullscreen = false, isFullscreen: isFullscreenProp, renderAsResponsiveButton: renderAsResponsiveButton = false, shouldRenderContent: shouldRenderContent = true, isSubtle: isSubtle = false })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const customRefElements = (0, $5uXOq.useRef)(null);
        const [isFullscreenLayout, { setIsFullscreen: setIsFullScreenLayout }] = (0, (0, parcelRequire("g7crU")).useIsFullscreen)();
        const globalStyle = document.createElement('style');
        const isFullscreen = (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() ? isFullscreenLayout : isFullscreenProp;
        const handleKeysInFullScreen = (0, $5uXOq.useCallback)((e)=>{
            if (e.target instanceof HTMLElement && ([
                'INPUT',
                'TEXTAREA',
                'SELECT'
            ].includes(e.target.tagName.toUpperCase()) || e.target.hasAttribute('contenteditable'))) return;
            const shortcutKeysToPrevent = [
                '/',
                'h'
            ];
            if (shortcutKeysToPrevent.includes(e.key)) e.stopPropagation();
            const navigationShortcuts = [
                '1',
                '2',
                '3',
                '4'
            ];
            if (!(0, (0, parcelRequire("3HwlS")).getWillShowNav4)() && navigationShortcuts.includes(e.key)) {
                onToggle(true, globalStyle);
                const customRefs = customRefElements.current;
                $f59079bf3589c5a6$var$removeFullScreenStyle(customRefs);
            }
        }, [
            globalStyle,
            onToggle
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (isFullscreen) window?.addEventListener('keydown', handleKeysInFullScreen, true);
            else window?.removeEventListener('keydown', handleKeysInFullScreen, true);
            return ()=>window?.removeEventListener('keydown', handleKeysInFullScreen, true);
        }, [
            isFullscreen,
            handleKeysInFullScreen
        ]);
        const createFullScreenStyle = (0, $5uXOq.useCallback)(()=>{
            const customElements = customRefElements.current;
            const hiddenStyles = "#ak-jira-navigation, #ak-side-navigation, #right-sidebar-panel-wrapper, [data-skip-link-wrapper='true'] { display: none }";
            const hiddenStylesNode = document.createTextNode(hiddenStyles);
            globalStyle.id = 'fullscreen-global-style';
            globalStyle.appendChild(hiddenStylesNode);
            if (customElements) customElements.forEach((ref)=>{
                if (ref !== null) ref.classList.add('fullscreen');
            });
            document.head?.appendChild(globalStyle);
        }, [
            globalStyle
        ]);
        const onClick = (event, analyticsEvent)=>{
            if ((0, (0, parcelRequire("3HwlS")).getWillShowNav4)()) {
                const analyticsAttributes = {
                    ...extraAnalyticsAttributes,
                    expandToFullscreen: !isFullscreenLayout
                };
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'fullscreenButton', analyticsAttributes);
                setIsFullScreenLayout(!isFullscreenLayout);
                onToggle(!isFullscreenLayout);
            } else {
                customRefElements.current = getCustomRefs();
                const customElements = customRefElements.current;
                const analyticsAttributes = {
                    ...extraAnalyticsAttributes,
                    expandToFullscreen: !isFullscreen
                };
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'fullscreenButton', analyticsAttributes);
                onToggle(isFullscreen, globalStyle);
                if (isFullscreen) $f59079bf3589c5a6$var$removeFullScreenStyle(customElements);
                else createFullScreenStyle();
            }
        };
        (0, $5uXOq.useEffect)(()=>{
            customRefElements.current = getCustomRefs();
            const customElements = customRefElements.current;
            if (isFullscreen) createFullScreenStyle();
            else $f59079bf3589c5a6$var$removeFullScreenStyle(customElements);
            return ()=>$f59079bf3589c5a6$var$removeFullScreenStyle(customElements);
        }, [
            createFullScreenStyle,
            getCustomRefs,
            isFullscreen
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (defaultFullscreen) createFullScreenStyle();
        }, []);
        (0, $5uXOq.useEffect)(()=>{
            return ()=>{
                if ((0, (0, parcelRequire("3HwlS")).getWillShowNav4)() && !(0, (0, parcelRequire("4R6GH")).fg)('blu-5747-fullscreen-in-nav-header')) setIsFullScreenLayout(false);
            };
        }, []);
        const renderButtonWithTooltip = ()=>{
            if ((0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)()) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9jNMw")).default), {
                ...withContainerStyles ? {
                    testId: testId
                } : {
                    testId: 'platform.ui.fullscreen-button.fullscreen-button'
                },
                label: isFullscreen ? formatMessage((0, (0, parcelRequire("gydfO")).default).exitFullScreen) : formatMessage((0, (0, parcelRequire("gydfO")).default).enterFullScreen),
                onClick: onClick,
                icon: isFullscreen ? (0, ($parcel$interopDefault((0, parcelRequire("9RB46"))))) : (0, ($parcel$interopDefault((0, parcelRequire("6mooq"))))),
                appearance: isSubtle ? 'subtle' : 'default',
                isTooltipDisabled: false
            });
            if (renderAsResponsiveButton && !(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)()) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6lmg7")).ResponsiveButton), {
                label: isFullscreen ? formatMessage((0, (0, parcelRequire("gydfO")).default).exitFullScreen) : formatMessage((0, (0, parcelRequire("gydfO")).default).enterFullScreen),
                icon: isFullscreen ? (0, ($parcel$interopDefault((0, parcelRequire("9RB46"))))) : (0, ($parcel$interopDefault((0, parcelRequire("6mooq"))))),
                onClick: onClick,
                testId: testId ?? 'platform.ui.fullscreen-button.fullscreen-button'
            });
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("loZC0")).default), {
                content: formatMessage(isFullscreen ? (0, (0, parcelRequire("gydfO")).default).exitFullScreen : (0, (0, parcelRequire("gydfO")).default).enterFullScreen),
                position: "top-end"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2APCZ")).default), {
                ...withContainerStyles ? {
                    testId: testId
                } : {
                    testId: 'platform.ui.fullscreen-button.fullscreen-button'
                },
                appearance: "subtle",
                onClick: onClick,
                iconBefore: isFullscreen ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("9RB46"))))), {
                    color: "var(--ds-icon, #44546F)",
                    label: formatMessage((0, (0, parcelRequire("gydfO")).default).exitFullScreen),
                    spacing: "spacious"
                }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("6mooq"))))), {
                    color: "var(--ds-icon, #44546F)",
                    label: formatMessage((0, (0, parcelRequire("gydfO")).default).enterFullScreen),
                    spacing: "spacious"
                })
            }));
        };
        const keyMap = {
            z: {
                callback: ()=>{
                    setIsFullScreenLayout(!isFullscreenLayout);
                }
            }
        };
        if (!shouldRenderContent) return null;
        return withContainerStyles ? (0, ($parcel$interopDefault($5uXOq))).createElement($f59079bf3589c5a6$var$FullscreenButtonContainer, {
            "data-testid": "platform.ui.fullscreen-button.fullscreen-button"
        }, renderButtonWithTooltip(), (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3Tty1")).default), {
            keyMap: keyMap
        })) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, renderButtonWithTooltip(), (0, (0, parcelRequire("3HwlS")).getWillShowNav4)() && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3Tty1")).default), {
            keyMap: keyMap
        }));
    };
    var $f59079bf3589c5a6$export$2e2bcd8739ae039 = $f59079bf3589c5a6$var$FullscreenButton;
    const $f59079bf3589c5a6$var$FullscreenButtonContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c116y _bfhk1bhr _16qsrs09 _2rko1sit",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("6mooq", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $4a17b8101063d8da$var$_react = $4a17b8101063d8da$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $4a17b8101063d8da$var$_growDiagonal = $4a17b8101063d8da$var$_interopRequireDefault((parcelRequire("lhF21")));
    var $4a17b8101063d8da$var$_actualSize = $4a17b8101063d8da$var$_interopRequireDefault((parcelRequire("2yLeU")));
    function $4a17b8101063d8da$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $4a17b8101063d8da$var$GrowDiagonalIcon = (props)=>$4a17b8101063d8da$var$_react.default.createElement($4a17b8101063d8da$var$_growDiagonal.default, Object.assign({
            LEGACY_fallbackIcon: $4a17b8101063d8da$var$_actualSize.default
        }, props));
    $4a17b8101063d8da$var$GrowDiagonalIcon.Name = 'GrowDiagonalIconMigration';
    var $4a17b8101063d8da$var$_default = module.exports.default = $4a17b8101063d8da$var$GrowDiagonalIcon;
});
parcelRegister("lhF21", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $f7eb03818f8ade36$var$_react = $f7eb03818f8ade36$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $f7eb03818f8ade36$var$_UNSAFE_baseNew = $f7eb03818f8ade36$var$_interopRequireDefault((parcelRequire("dTInF")));
    function $f7eb03818f8ade36$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $f7eb03818f8ade36$var$GrowDiagonalIcon = (props)=>$f7eb03818f8ade36$var$_react.default.createElement($f7eb03818f8ade36$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m7 9-4.75 4.75M9 7l4.75-4.75m-12 7.25v4.75H6.5m7.75-7.75V1.75H9.5"/>`
        }, props));
    $f7eb03818f8ade36$var$GrowDiagonalIcon.displayName = 'GrowDiagonalIcon';
    var $f7eb03818f8ade36$var$_default = module.exports.default = $f7eb03818f8ade36$var$GrowDiagonalIcon;
});
parcelRegister("2yLeU", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $1dd36681417326b8$var$_react = $1dd36681417326b8$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $7p1ve;
    var $1dd36681417326b8$var$_growDiagonal = $1dd36681417326b8$var$_interopRequireDefault((parcelRequire("lhF21")));
    function $1dd36681417326b8$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $1dd36681417326b8$var$MediaServicesActualSizeIcon = (props)=>$1dd36681417326b8$var$_react.default.createElement((0, parcelRequire("7p1ve")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M16.587 6.003H15A1 1 0 0 1 15 4h3.9l.047.001a.98.98 0 0 1 .736.285l.032.032c.2.2.296.47.284.736l.001.048v3.896a1 1 0 1 1-2 0V7.411l-3.309 3.308a.977.977 0 0 1-1.374-.005l-.032-.032a.976.976 0 0 1-.005-1.374zM7.413 17.997H9A1 1 0 0 1 9 20H5.1l-.047-.001a.98.98 0 0 1-.736-.285l-.032-.032A.98.98 0 0 1 4 18.946v-3.944a1 1 0 1 1 2 0v1.587l3.309-3.308a.977.977 0 0 1 1.374.005l.032.032a.976.976 0 0 1 .005 1.374z"/></svg>`
        }, props, {
            newIcon: $1dd36681417326b8$var$_growDiagonal.default
        }));
    $1dd36681417326b8$var$MediaServicesActualSizeIcon.displayName = 'MediaServicesActualSizeIcon';
    var $1dd36681417326b8$var$_default = module.exports.default = $1dd36681417326b8$var$MediaServicesActualSizeIcon;
});
parcelRegister("9RB46", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $72e5d0ac187f49fb$var$_react = $72e5d0ac187f49fb$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $72e5d0ac187f49fb$var$_shrinkDiagonal = $72e5d0ac187f49fb$var$_interopRequireDefault((parcelRequire("blK93")));
    var $72e5d0ac187f49fb$var$_fitToPage = $72e5d0ac187f49fb$var$_interopRequireDefault((parcelRequire("d2NX4")));
    function $72e5d0ac187f49fb$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $72e5d0ac187f49fb$var$ShrinkDiagonalIcon = (props)=>$72e5d0ac187f49fb$var$_react.default.createElement($72e5d0ac187f49fb$var$_shrinkDiagonal.default, Object.assign({
            LEGACY_fallbackIcon: $72e5d0ac187f49fb$var$_fitToPage.default
        }, props));
    $72e5d0ac187f49fb$var$ShrinkDiagonalIcon.Name = 'ShrinkDiagonalIconMigration';
    var $72e5d0ac187f49fb$var$_default = module.exports.default = $72e5d0ac187f49fb$var$ShrinkDiagonalIcon;
});
parcelRegister("blK93", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $84357354ecb14393$var$_react = $84357354ecb14393$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $84357354ecb14393$var$_UNSAFE_baseNew = $84357354ecb14393$var$_interopRequireDefault((parcelRequire("dTInF")));
    function $84357354ecb14393$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $84357354ecb14393$var$ShrinkDiagonalIcon = (props)=>$84357354ecb14393$var$_react.default.createElement($84357354ecb14393$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m1.5 14.5 5.25-5.25M14.5 1.5 9.25 6.75M6.75 14V9.25H2M9.25 2v4.75H14"/>`
        }, props));
    $84357354ecb14393$var$ShrinkDiagonalIcon.displayName = 'ShrinkDiagonalIcon';
    var $84357354ecb14393$var$_default = module.exports.default = $84357354ecb14393$var$ShrinkDiagonalIcon;
});
parcelRegister("d2NX4", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $97f235a462fecbc5$var$_react = $97f235a462fecbc5$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $7p1ve;
    var $97f235a462fecbc5$var$_shrinkDiagonal = $97f235a462fecbc5$var$_interopRequireDefault((parcelRequire("blK93")));
    function $97f235a462fecbc5$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $97f235a462fecbc5$var$MediaServicesFitToPageIcon = (props)=>$97f235a462fecbc5$var$_react.default.createElement((0, parcelRequire("7p1ve")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M16.413 8.997H18A1 1 0 0 1 18 11h-3.9l-.047-.001a.98.98 0 0 1-.736-.285l-.032-.032A.98.98 0 0 1 13 9.946V6.002a1 1 0 1 1 2 0v1.587l3.309-3.308a.977.977 0 0 1 1.374.005l.032.032a.976.976 0 0 1 .005 1.374zm-8.826 6.006H6A1 1 0 0 1 6 13h3.9l.047.001a.98.98 0 0 1 .736.285l.032.032c.2.2.296.47.284.736l.001.048v3.896a1 1 0 1 1-2 0v-1.587l-3.309 3.308a.977.977 0 0 1-1.374-.005l-.032-.032a.976.976 0 0 1-.005-1.374z"/></svg>`
        }, props, {
            newIcon: $97f235a462fecbc5$var$_shrinkDiagonal.default
        }));
    $97f235a462fecbc5$var$MediaServicesFitToPageIcon.displayName = 'MediaServicesFitToPageIcon';
    var $97f235a462fecbc5$var$_default = module.exports.default = $97f235a462fecbc5$var$MediaServicesFitToPageIcon;
});
parcelRegister("3Tty1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6ba57d5dc6c0de0a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9IeM0;
    var $4lkOX;
    var $h0GOb;
    var $k4r7E;
    var $9fuVs;
    var $kspvB;
    let $6ba57d5dc6c0de0a$var$shortcutsCount = 0;
    let $6ba57d5dc6c0de0a$var$subscription = null;
    const $6ba57d5dc6c0de0a$var$ShortcutsSubscriber = false ? ()=>null : ({ keyMap: keyMap, label: label, location: location })=>{
        const parentRegistry = (0, $5uXOq.useContext)((0, (0, parcelRequire("9fuVs")).ShortcutRegistryContext)) || (0, (0, parcelRequire("k4r7E")).rootRegistry);
        const addKeyMap = (0, $5uXOq.useCallback)(()=>parentRegistry.addKeyMap(()=>({
                    keyMap: (0, (0, parcelRequire("kspvB")).bindKeyMapWithErrorHandling)(keyMap, location),
                    label: label
                })), [
            label,
            parentRegistry,
            keyMap,
            location
        ]);
        (0, $5uXOq.useEffect)(()=>{
            $6ba57d5dc6c0de0a$var$shortcutsCount += 1;
            const removeKeyMap = addKeyMap();
            return ()=>{
                removeKeyMap();
                $6ba57d5dc6c0de0a$var$shortcutsCount -= 1;
                if ($6ba57d5dc6c0de0a$var$subscription && $6ba57d5dc6c0de0a$var$shortcutsCount === 0) {
                    $6ba57d5dc6c0de0a$var$subscription.unsubscribe();
                    $6ba57d5dc6c0de0a$var$subscription = null;
                }
            };
        }, [
            addKeyMap
        ]);
        (0, $5uXOq.useEffect)(()=>{
            $6ba57d5dc6c0de0a$var$subscription = $6ba57d5dc6c0de0a$var$subscription || (0, (0, parcelRequire("h0GOb")).default)().subscribe((0, (0, parcelRequire("4lkOX")).default));
        }, [
            parentRegistry,
            keyMap
        ]);
        return null;
    };
    var $6ba57d5dc6c0de0a$export$2e2bcd8739ae039 = ({ useKeyboardShortcutsToggle: useKeyboardShortcutsToggle = (0, (0, parcelRequire("9IeM0")).useKeyboardShortcutsToggle), ...props })=>{
        const [{ isEnabled: isEnabled }] = useKeyboardShortcutsToggle();
        return isEnabled && !false ? (0, ($parcel$interopDefault($5uXOq))).createElement($6ba57d5dc6c0de0a$var$ShortcutsSubscriber, props) : null;
    };
});
parcelRegister("9IeM0", function(module, exports) {
    $parcel$export(module.exports, "useKeyboardShortcutsToggle", ()=>$dc712fc9bec05022$export$a33a81f1fc5458ad);
    var $jcw0u;
    var $eusud;
    var $j8DrX;
    var $8zOmE;
    var $3sQ5x;
    var $iXqE5;
    const $dc712fc9bec05022$var$URL_FRAGMENT = '/rest/internal/latest/user/preferences/keyboardShortcuts?turn=';
    const $dc712fc9bec05022$export$b62f67be35e65859 = (analyticsEvent)=>async ({ setState: setState, getState: getState })=>{
            const currentState = getState().isEnabled;
            const status = currentState ? 'off' : 'on';
            const url = `${$dc712fc9bec05022$var$URL_FRAGMENT}${status}`;
            try {
                await (0, (0, parcelRequire("eusud")).performPutRequest)(url);
                setState({
                    isEnabled: !currentState,
                    error: null
                });
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'keyboardShortcutsToggle', {
                    isEnabled: !currentState
                });
            } catch (err) {
                setState({
                    error: err
                });
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'keyboardShortcutToggleFailure',
                        packageName: 'jiraCommonLegacyDoNotAddAnythingNew'
                    },
                    error: err
                });
            }
        };
    const $dc712fc9bec05022$var$Store = (0, (0, parcelRequire("iXqE5")).createStore)({
        initialState: {
            isEnabled: false ? false : !((0, (0, parcelRequire("j8DrX")).default)('ajs-keyboard-shortcuts-enabled') === 'false'),
            error: null
        },
        actions: {
            toggle: $dc712fc9bec05022$export$b62f67be35e65859
        }
    });
    const $dc712fc9bec05022$export$a33a81f1fc5458ad = (0, (0, parcelRequire("3sQ5x")).createHook)($dc712fc9bec05022$var$Store);
});
parcelRegister("4lkOX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f11d50ddafbb6f85$export$2e2bcd8739ae039);
    var $h0GOb;
    var $k4r7E;
    const $f11d50ddafbb6f85$var$matches = (prefix)=>(definedSequence)=>definedSequence.startsWith(`${prefix} `);
    var $f11d50ddafbb6f85$export$2e2bcd8739ae039 = (keySequence)=>{
        const { sequence: sequence, e: e } = keySequence || {};
        const activeKeyMap = (0, (0, parcelRequire("k4r7E")).rootRegistry).getActiveKeyMap();
        if (sequence !== undefined && activeKeyMap[sequence]) {
            activeKeyMap[sequence].callback(e);
            (0, (0, parcelRequire("h0GOb")).flush)();
        } else {
            const isFutureMatchPossible = sequence !== undefined && Object.keys(activeKeyMap).some($f11d50ddafbb6f85$var$matches(sequence));
            if (!isFutureMatchPossible) (0, (0, parcelRequire("h0GOb")).flush)();
        }
    };
});
parcelRegister("h0GOb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$849cd54ac4017470$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "flush", ()=>$849cd54ac4017470$export$4909b86c8034bf73);
    var $kVLXA = parcelRequire("kVLXA");
    var $cab1K = parcelRequire("cab1K");
    parcelRequire("jG6Un");
    parcelRequire("eSGL3");
    parcelRequire("1oQta");
    parcelRequire("4kRRr");
    parcelRequire("d0pqD");
    parcelRequire("iQCJJ");
    parcelRequire("fjPtF");
    parcelRequire("2R2to");
    var $lIZQG;
    const $849cd54ac4017470$var$ignoredKeys = {
        Control: true,
        Meta: true,
        Shift: true,
        Alt: true,
        AltGraph: true,
        CapsLock: true,
        Fn: true,
        FnLock: true,
        Hyper: true,
        NumLock: true,
        OS: true,
        ScrollLock: true,
        Super: true,
        Symbol: true,
        SymbolLock: true
    };
    const $849cd54ac4017470$var$isNonTextInput = ({ inputMode: inputMode = '', type: type })=>inputMode === 'none' || type === 'checkbox';
    const $849cd54ac4017470$var$isEditable = (node)=>node.nodeName === 'INPUT' && !$849cd54ac4017470$var$isNonTextInput(node) || node.nodeName === 'TEXTAREA' || node.isContentEditable === true;
    const $849cd54ac4017470$var$isRelevantKeyEvent = (e)=>typeof e.key === 'string' && (e.key === 'Escape' || !$849cd54ac4017470$var$isEditable(e.target) && !$849cd54ac4017470$var$ignoredKeys[e.key]);
    const $849cd54ac4017470$export$25d1b8252b4c49b7 = ()=>{
        const elBlankets = document.querySelectorAll('.aui-blanket');
        if (elBlankets.length === 0) return true;
        const isAllHidden = Array.from(elBlankets || []).every((el)=>{
            if (el.getAttribute('aria-hidden') === 'true' || el.getAttribute('hidden') !== null) return true;
            return false;
        });
        return isAllHidden;
    };
    let $849cd54ac4017470$var$key$;
    const $849cd54ac4017470$var$flush$ = new (0, $cab1K.Subject)();
    var $849cd54ac4017470$export$2e2bcd8739ae039 = ()=>{
        if (!$849cd54ac4017470$var$key$) {
            $849cd54ac4017470$var$key$ = false ? new (0, $cab1K.Subject)() : (0, $kVLXA.Observable).fromEvent(document, 'keydown').filter($849cd54ac4017470$var$isRelevantKeyEvent).filter($849cd54ac4017470$export$25d1b8252b4c49b7).map((0, (0, parcelRequire("lIZQG")).toKeyWithModifiers));
            const sequence$ = $849cd54ac4017470$var$key$.scan((seq, key)=>{
                if (!key || !seq) return undefined;
                return {
                    sequence: `${String(seq.sequence)} ${String(key.sequence)}`,
                    e: key.e
                };
            });
            $849cd54ac4017470$var$key$ = $849cd54ac4017470$var$key$.debounceTime(1000).startWith(null).merge($849cd54ac4017470$var$flush$).switchMapTo(sequence$);
        }
        return $849cd54ac4017470$var$key$;
    };
    const $849cd54ac4017470$export$4909b86c8034bf73 = ()=>{
        $849cd54ac4017470$var$flush$.next();
    };
});
parcelRegister("lIZQG", function(module, exports) {
    $parcel$export(module.exports, "toKeyWithModifiers", ()=>$ca3344250c7b7406$export$8cf0d2c3d060a0c2);
    $parcel$export(module.exports, "isValidShortcut", ()=>$ca3344250c7b7406$export$8e231506c5580162);
    $parcel$export(module.exports, "isShortcutCollision", ()=>$ca3344250c7b7406$export$4add9e50cb49d130);
    const $ca3344250c7b7406$var$isNonCharacterKey = (e)=>e.key.length > 1 || e.key === ' ';
    const $ca3344250c7b7406$var$modifiers = [
        {
            name: 'ctrl',
            test: (e)=>e.ctrlKey
        },
        {
            name: 'shift',
            test: (e)=>e.shiftKey && $ca3344250c7b7406$var$isNonCharacterKey(e)
        },
        {
            name: 'meta',
            test: (e)=>e.metaKey || e.getModifierState && e.getModifierState('OS')
        }
    ];
    const $ca3344250c7b7406$var$toKey = (e)=>{
        if ($ca3344250c7b7406$var$isNonCharacterKey(e)) return e.key.toLowerCase();
        return e.shiftKey ? e.key.toUpperCase() : e.key.toLowerCase();
    };
    const $ca3344250c7b7406$export$8cf0d2c3d060a0c2 = (e)=>{
        if (!e || !e.key) return {
            sequence: '',
            e: e
        };
        return {
            sequence: $ca3344250c7b7406$var$modifiers.filter((modifier)=>modifier.test(e)).map((modifier)=>modifier.name).concat($ca3344250c7b7406$var$toKey(e)).join('+'),
            e: e
        };
    };
    const $ca3344250c7b7406$var$orSpecialChars = ' |arrowdown|arrowleft|arrowright|arrowup|backspace|clear|delete|end|enter|escape|home|insert|pagedown|pageup|pause|printscreen|tab';
    const $ca3344250c7b7406$var$singleShortcutEntry = `(ctrl\\+)?(shift\\+(?=(?:(?:meta\\+)?(?:${$ca3344250c7b7406$var$orSpecialChars}))))?(meta\\+)?(${$ca3344250c7b7406$var$orSpecialChars}|[!-~])`;
    const $ca3344250c7b7406$var$shortcutRegex = RegExp(`^${$ca3344250c7b7406$var$singleShortcutEntry}( ${$ca3344250c7b7406$var$singleShortcutEntry})*$`);
    const $ca3344250c7b7406$export$8e231506c5580162 = (shortcut)=>$ca3344250c7b7406$var$shortcutRegex.test(shortcut);
    const $ca3344250c7b7406$export$4add9e50cb49d130 = (leftShortcut, rightShortcut)=>{
        if (!leftShortcut || !rightShortcut) return leftShortcut === rightShortcut;
        if (rightShortcut === leftShortcut) return true;
        if (leftShortcut.indexOf(rightShortcut) === 0) return leftShortcut[rightShortcut.length] === ' ';
        if (rightShortcut.indexOf(leftShortcut) === 0) return rightShortcut[leftShortcut.length] === ' ';
        return false;
    };
});
parcelRegister("k4r7E", function(module, exports) {
    $parcel$export(module.exports, "ShortcutRegistry", ()=>$a65fecdbaed23de2$export$ca1c75b575abf5ff);
    $parcel$export(module.exports, "rootRegistry", ()=>$a65fecdbaed23de2$export$1dd4c61d1ce1fa15);
    var $lbWm4 = parcelRequire("lbWm4");
    var $561FV = parcelRequire("561FV");
    var $hGgHi = parcelRequire("hGgHi");
    var $FISJv = parcelRequire("FISJv");
    var $lIZQG;
    const $a65fecdbaed23de2$var$validateKeyMaps = (keyMaps)=>{
        (0, ($parcel$interopDefault($lbWm4)))(keyMaps, (keyMap, keyMapIndex)=>{
            const shortcuts = Object.keys(keyMap);
            (0, ($parcel$interopDefault($lbWm4)))(shortcuts, (shortcut, shortcutIndex)=>{
                if (!(0, (0, parcelRequire("lIZQG")).isValidShortcut)(shortcut)) console.error(`"${shortcut}" is an incorrect shortcut. Please, update it according to a playbook entry on shortcuts.`);
                for(let indexForOtherKeymaps = keyMapIndex + 1; indexForOtherKeymaps < keyMaps.length; indexForOtherKeymaps += 1){
                    const anotherKeyMap = keyMaps[indexForOtherKeymaps];
                    (0, ($parcel$interopDefault($lbWm4)))(anotherKeyMap, (anotherAction, anotherShortcut)=>{
                        if ((0, (0, parcelRequire("lIZQG")).isShortcutCollision)(anotherShortcut, shortcut)) {
                            if ((0, ($parcel$interopDefault($hGgHi)))(keyMap[shortcut].priority) && (0, ($parcel$interopDefault($hGgHi)))(anotherKeyMap[anotherShortcut].priority) || keyMap[shortcut].priority === anotherKeyMap[anotherShortcut].priority) console.error(`"${shortcut}" has a collision with "${anotherShortcut}" shortcut from another keyMap.`);
                        }
                    });
                }
                for(let indexToCompareSelf = shortcutIndex + 1; indexToCompareSelf < shortcuts.length; indexToCompareSelf += 1)if ((0, (0, parcelRequire("lIZQG")).isShortcutCollision)(shortcut, shortcuts[indexToCompareSelf])) console.error(`"${shortcut}" has a collision with "${shortcuts[indexToCompareSelf]}" shortcut from the same keyMap.`);
            });
        });
    };
    const $a65fecdbaed23de2$var$mergeKeyMaps = (keyMapsToMerge)=>keyMapsToMerge.reduce((prev, keyMap)=>({
                ...prev,
                ...Object.keys(keyMap).reduce((newAccumulator, newKey)=>{
                    if (!(0, ($parcel$interopDefault($561FV)))(prev, newKey) || (prev[newKey].priority ?? 0) < (keyMap[newKey].priority ?? 1)) return {
                        ...newAccumulator,
                        [newKey]: keyMap[newKey]
                    };
                    return newAccumulator;
                }, {})
            }), {});
    class $a65fecdbaed23de2$export$ca1c75b575abf5ff {
        addChildRegistry(child) {
            this.children.push(child);
            return ()=>{
                (0, ($parcel$interopDefault($FISJv)))(this.children, child);
            };
        }
        addKeyMap(getKeyMap) {
            this.keyMapRetrievers.push(getKeyMap);
            return ()=>{
                (0, ($parcel$interopDefault($FISJv)))(this.keyMapRetrievers, getKeyMap);
            };
        }
        getActiveKeyMap() {
            const keyMaps = this.children.length ? this.children.map((child)=>child.getActiveKeyMap()) : this.keyMapRetrievers.map((getKeyMap)=>getKeyMap().keyMap);
            return {
                ...$a65fecdbaed23de2$var$mergeKeyMaps(keyMaps)
            };
        }
        getKeyMapInfo() {
            const info = this.children.length ? this.children.map((child)=>child.getKeyMapInfo()) : this.keyMapRetrievers.map((getInfo)=>getInfo());
            const flattenedInfo = [].concat(...info);
            return flattenedInfo;
        }
        constructor(){
            this.children = [];
            this.keyMapRetrievers = [];
        }
    }
    const $a65fecdbaed23de2$export$1dd4c61d1ce1fa15 = new $a65fecdbaed23de2$export$ca1c75b575abf5ff();
});
parcelRegister("9fuVs", function(module, exports) {
    $parcel$export(module.exports, "ShortcutRegistryContext", ()=>$1dd87679d9ca363b$export$ebbb59327adb551a);
    $parcel$export(module.exports, "default", ()=>$1dd87679d9ca363b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $k4r7E;
    const $1dd87679d9ca363b$export$ebbb59327adb551a = (0, $5uXOq.createContext)((0, (0, parcelRequire("k4r7E")).rootRegistry));
    const $1dd87679d9ca363b$var$ShortcutScope = ({ children: children = null })=>{
        const registry = (0, $5uXOq.useMemo)(()=>new (0, (0, parcelRequire("k4r7E")).ShortcutRegistry)(), []);
        const parentRegistry = (0, $5uXOq.useContext)($1dd87679d9ca363b$export$ebbb59327adb551a) || (0, (0, parcelRequire("k4r7E")).rootRegistry);
        (0, $5uXOq.useEffect)(()=>{
            const removeRegistry = parentRegistry.addChildRegistry(registry);
            return removeRegistry;
        }, []);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($1dd87679d9ca363b$export$ebbb59327adb551a.Provider, {
            value: registry
        }, children);
    };
    var $1dd87679d9ca363b$export$2e2bcd8739ae039 = false ? ({ children: children = null })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, children) : $1dd87679d9ca363b$var$ShortcutScope;
});
parcelRegister("kspvB", function(module, exports) {
    $parcel$export(module.exports, "bindKeyMapWithErrorHandling", ()=>$f9e30ab2465f6f16$export$77477772a9b904da);
    var $dJl1T;
    const $f9e30ab2465f6f16$var$wrapCallbackWithErrorHandling = (key, callback, location = 'keyboard-shortcuts.common')=>(e)=>{
            try {
                callback(e);
            } catch (error) {
                (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData(location, `Error firing shortcut '${key}': ${error.message} (commandPaletteBlockNativeShortcutFF=true)`, error);
            }
        };
    const $f9e30ab2465f6f16$export$77477772a9b904da = (keyMap, location)=>Object.keys(keyMap).reduce((map, key)=>({
                ...map,
                [key]: {
                    ...keyMap[key],
                    callback: $f9e30ab2465f6f16$var$wrapCallbackWithErrorHandling(key, keyMap[key].callback, location)
                }
            }), {});
});
parcelRegister("6lmg7", function(module, exports) {
    $parcel$export(module.exports, "ResponsiveButton", ()=>$aeaed609d1db7293$export$47e82d861696e68c);
    $parcel$export(module.exports, "ResponsiveLinkButton", ()=>$aeaed609d1db7293$export$50fd17babcd996ef);
    var $5uXOq = parcelRequire("5uXOq");
    var $42Si9;
    var $9jNMw;
    var $bjfoJ;
    var $aFbf0;
    var $fm763;
    var $dzw7L;
    var $9aspn;
    var $loZC0;
    const $aeaed609d1db7293$export$47e82d861696e68c = (0, $5uXOq.forwardRef)((props, ref)=>{
        const { icon: icon, label: label, iconAfter: iconAfter, breakpoint: breakpoint = 'lg', appearance: appearance, testId: testId, 'aria-label': ariaLabel, iconButtonSpacing: iconButtonSpacing, buttonSpacing: buttonSpacing, ...restProps } = props;
        const mediaQueryBreakpoint = (0, (0, parcelRequire("9aspn")).UNSAFE_useMediaQuery)(`above.${breakpoint}`, (event)=>setIsAboveBreakpoint(event.matches));
        const [isAboveBreakpoint, setIsAboveBreakpoint] = (0, $5uXOq.useState)(mediaQueryBreakpoint?.matches);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fm763")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dzw7L")).Show), {
            below: breakpoint
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("loZC0")).default), {
            content: label
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9jNMw")).default), {
            ...restProps,
            icon: icon,
            appearance: appearance ?? 'default',
            label: label,
            testId: `${testId ?? (0, $7c15fdea32a398a0$export$9c51afe8741be906)}.collapsed`,
            ref: !isAboveBreakpoint ? ref : undefined,
            spacing: iconButtonSpacing
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dzw7L")).Show), {
            above: breakpoint
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42Si9")).default), {
            ...restProps,
            iconBefore: icon,
            iconAfter: iconAfter,
            appearance: appearance ?? 'default',
            testId: `${testId ?? (0, $7c15fdea32a398a0$export$9c51afe8741be906)}.expanded`,
            ref: isAboveBreakpoint ? ref : undefined,
            "aria-label": ariaLabel,
            spacing: buttonSpacing
        }, label)));
    });
    const $aeaed609d1db7293$export$50fd17babcd996ef = (0, $5uXOq.forwardRef)((props, ref)=>{
        const { icon: icon, label: label, iconAfter: iconAfter, breakpoint: breakpoint = 'lg', appearance: appearance, testId: testId, 'aria-label': ariaLabel, iconButtonSpacing: iconButtonSpacing, buttonSpacing: buttonSpacing, ...restProps } = props;
        const mediaQueryBreakpoint = (0, (0, parcelRequire("9aspn")).UNSAFE_useMediaQuery)(`above.${breakpoint}`, (event)=>setIsAboveBreakpoint(event.matches));
        const [isAboveBreakpoint, setIsAboveBreakpoint] = (0, $5uXOq.useState)(mediaQueryBreakpoint?.matches);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fm763")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dzw7L")).Show), {
            below: breakpoint
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("loZC0")).default), {
            content: label
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aFbf0")).default), {
            ...restProps,
            icon: icon,
            appearance: appearance ?? 'default',
            label: label,
            testId: `${testId ?? (0, $7c15fdea32a398a0$export$9c51afe8741be906)}.collapsed`,
            href: restProps.href,
            ref: !isAboveBreakpoint ? ref : undefined,
            spacing: iconButtonSpacing
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dzw7L")).Show), {
            above: breakpoint
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bjfoJ")).default), {
            ...restProps,
            iconBefore: icon,
            iconAfter: iconAfter,
            appearance: appearance ?? 'default',
            testId: `${testId ?? (0, $7c15fdea32a398a0$export$9c51afe8741be906)}.expanded`,
            href: restProps.href,
            ref: isAboveBreakpoint ? ref : undefined,
            "aria-label": ariaLabel,
            spacing: buttonSpacing
        }, label)));
    });
});
parcelRegister("bjfoJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f7588122d6645d5d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $aPPLm;
    var $guTo4;
    const $f7588122d6645d5d$var$LinkButtonBase = ({ analyticsContext: analyticsContext, appearance: appearance, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, autoFocus: autoFocus, children: children, href: href, iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shouldFitContainer: shouldFitContainer, spacing: spacing, testId: testId, ...unsafeRest }, ref)=>{
        const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
        const baseProps = (0, (0, parcelRequire("guTo4")).default)({
            analyticsContext: analyticsContext,
            appearance: appearance,
            ariaLabel: ariaLabel,
            ariaLabelledBy: ariaLabelledBy,
            autoFocus: autoFocus,
            buttonType: 'link',
            children: children,
            iconAfter: iconAfter,
            iconBefore: iconBefore,
            interactionName: interactionName,
            isDisabled: isDisabled,
            isSelected: isSelected,
            onClick: onClick,
            onClickCapture: onClickCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onTouchEndCapture: onTouchEndCapture,
            onTouchStartCapture: onTouchStartCapture,
            ref: ref,
            shouldFitContainer: shouldFitContainer,
            spacing: spacing,
            testId: testId
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aPPLm")).default), {
            ...saferRest,
            "aria-label": baseProps['aria-label'],
            "aria-labelledby": baseProps['aria-labelledby'],
            ref: baseProps.ref,
            xcss: baseProps.xcss,
            onClick: baseProps.onClick,
            onMouseDownCapture: baseProps.onMouseDownCapture,
            onMouseUpCapture: baseProps.onMouseUpCapture,
            onKeyDownCapture: baseProps.onKeyDownCapture,
            onKeyUpCapture: baseProps.onKeyUpCapture,
            onTouchStartCapture: baseProps.onTouchStartCapture,
            onTouchEndCapture: baseProps.onTouchEndCapture,
            onPointerDownCapture: baseProps.onPointerDownCapture,
            onPointerUpCapture: baseProps.onPointerUpCapture,
            onClickCapture: baseProps.onClickCapture,
            testId: testId,
            href: baseProps.isDisabled ? undefined : href,
            role: baseProps.isDisabled ? 'link' : undefined,
            "aria-disabled": baseProps.isDisabled === true ? true : undefined,
            analyticsContext: analyticsContext,
            interactionName: interactionName,
            componentName: "LinkButton"
        }, baseProps.children);
    };
    const $f7588122d6645d5d$var$WithRef = (0, $5uXOq.forwardRef)($f7588122d6645d5d$var$LinkButtonBase);
    const $f7588122d6645d5d$var$LinkButton = (0, $5uXOq.memo)($f7588122d6645d5d$var$WithRef);
    var $f7588122d6645d5d$export$2e2bcd8739ae039 = $f7588122d6645d5d$var$LinkButton;
});
parcelRegister("dzw7L", function(module, exports) {
    $parcel$export(module.exports, "Show", ()=>$a81026e302fc624c$export$f6a3d19be20f5819);
    var $f8Sb3;
    var $99gde;
    var $25mnC;
    function $a81026e302fc624c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $a81026e302fc624c$var$showAboveQueries = (0, (0, parcelRequire("25mnC")).UNSAFE_buildAboveMediaQueryCSS)({
        display: 'revert'
    });
    const $a81026e302fc624c$var$showBelowQueries = (0, (0, parcelRequire("25mnC")).UNSAFE_buildBelowMediaQueryCSS)({
        display: 'revert'
    });
    const $a81026e302fc624c$var$defaultHiddenStyles = {
        name: "eivff4",
        styles: "display:none"
    };
    const $a81026e302fc624c$export$f6a3d19be20f5819 = ({ above: above, below: below, children: children, as: AsElement = 'div', xcss: xcss })=>{
        const resolvedStyles = (0, (0, parcelRequire("99gde")).parseXcss)(xcss);
        return (0, (0, parcelRequire("f8Sb3")).jsx)(AsElement, {
            className: resolvedStyles.static,
            css: [
                $a81026e302fc624c$var$defaultHiddenStyles,
                above && $a81026e302fc624c$var$showAboveQueries[above],
                below && $a81026e302fc624c$var$showBelowQueries[below],
                resolvedStyles.emotion
            ]
        }, children);
    };
});
parcelRegister("25mnC", function(module, exports) {
    $parcel$export(module.exports, "UNSAFE_buildAboveMediaQueryCSS", ()=>$c4d77edbcd9abba8$export$918f8818cfbbeb2c);
    $parcel$export(module.exports, "UNSAFE_buildBelowMediaQueryCSS", ()=>$c4d77edbcd9abba8$export$b2a4e2b0c6417297);
    var $f8Sb3;
    var $k5zBm;
    var $i65TN;
    const $c4d77edbcd9abba8$export$918f8818cfbbeb2c = (input)=>{
        return (0, (0, parcelRequire("k5zBm")).UNSAFE_BREAKPOINTS_ORDERED_LIST).reduce((acc, breakpoint)=>({
                ...acc,
                [breakpoint]: (0, (0, parcelRequire("f8Sb3")).css)({
                    [(0, (0, parcelRequire("i65TN")).media).above[breakpoint]]: typeof input === 'function' ? input(breakpoint) : input
                })
            }), {});
    };
    const $c4d77edbcd9abba8$export$b2a4e2b0c6417297 = (input)=>{
        return (0, (0, parcelRequire("k5zBm")).UNSAFE_BREAKPOINTS_ORDERED_LIST).reduce((acc, breakpoint)=>{
            if (breakpoint === 'xxs') return acc;
            return {
                ...acc,
                [breakpoint]: (0, (0, parcelRequire("f8Sb3")).css)({
                    [(0, (0, parcelRequire("i65TN")).UNSAFE_media).below[breakpoint]]: typeof input === 'function' ? input(breakpoint) : input
                })
            };
        }, {});
    };
});
parcelRegister("k5zBm", function(module, exports) {
    $parcel$export(module.exports, "UNSAFE_BREAKPOINTS_ORDERED_LIST", ()=>$0a116a0f2a0d9d1d$export$2d293d9871c38e91);
    const $0a116a0f2a0d9d1d$export$e5ee4fe8b989fd09 = {
        xxs: {
            gridItemGutter: "var(--ds-space-200, 16px)",
            gridMargin: "var(--ds-space-200, 16px)",
            min: '0rem',
            max: '29.99rem'
        },
        xs: {
            gridItemGutter: "var(--ds-space-200, 16px)",
            gridMargin: "var(--ds-space-200, 16px)",
            min: '30rem',
            max: '47.99rem'
        },
        sm: {
            gridItemGutter: "var(--ds-space-200, 16px)",
            gridMargin: "var(--ds-space-300, 24px)",
            min: '48rem',
            max: '63.99rem'
        },
        md: {
            gridItemGutter: "var(--ds-space-300, 24px)",
            gridMargin: "var(--ds-space-400, 32px)",
            min: '64rem',
            max: '89.99rem'
        },
        lg: {
            gridItemGutter: "var(--ds-space-400, 32px)",
            gridMargin: "var(--ds-space-400, 32px)",
            min: '90rem',
            max: '110.49rem'
        },
        xl: {
            gridItemGutter: "var(--ds-space-400, 32px)",
            gridMargin: "var(--ds-space-500, 40px)",
            min: '110.5rem',
            max: null
        }
    };
    const $0a116a0f2a0d9d1d$export$2d293d9871c38e91 = Object.keys($0a116a0f2a0d9d1d$export$e5ee4fe8b989fd09);
    const $0a116a0f2a0d9d1d$export$b7ed752a57b4177b = $0a116a0f2a0d9d1d$export$2d293d9871c38e91[0];
});
const $7c15fdea32a398a0$export$9c51afe8741be906 = 'responsive-button.ui.responsive-button';
parcelRegister("gydfO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$50014cef8f43c127$export$2e2bcd8739ae039);
    var $7VHMR;
    var $50014cef8f43c127$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        enterFullScreen: {
            "id": "platform.fullscreen-button.enter-full-screen",
            "defaultMessage": "Enter full screen"
        },
        exitFullScreen: {
            "id": "platform.fullscreen-button.exit-full-screen",
            "defaultMessage": "Exit full screen"
        }
    });
});
parcelRegister("ACELo", function(module, exports) {
    $parcel$export(module.exports, "JiraBottomRightCornerOutlet", ()=>$8d24666022201b4c$export$ee54e6ed235df65e);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $7nsd3 = parcelRequire("7nsd3");
    var $heNNl;
    var $hvrWv;
    const $8d24666022201b4c$var$OutletWithPortal = ({ orderFromRight: orderFromRight, children: children, id: id })=>{
        const portalWrapper = (0, $5uXOq.useRef)(document.createElement('div'));
        const container = (0, (0, parcelRequire("hvrWv")).useBottomRightCornerContainer)();
        if (!container) throw new Error('GlobalBottomRightContainer could not be found. Please ensure that this container was rendered on the page.');
        const { insertBottomRightCornerPortal: insertBottomRightCornerPortal, removeBottomRightCornerPortal: removeBottomRightCornerPortal } = (0, (0, parcelRequire("hvrWv")).useBottomRightCornerActions)();
        (0, $5uXOq.useEffect)(()=>{
            if (container) {
                const indexToRender = insertBottomRightCornerPortal({
                    orderFromRight: orderFromRight,
                    id: id
                });
                container.insertBefore(portalWrapper.current, container.children[indexToRender]);
            }
            const portalCurrent = portalWrapper.current;
            return ()=>{
                container?.removeChild(portalCurrent);
                removeBottomRightCornerPortal(id);
            };
        }, [
            container,
            id,
            orderFromRight,
            insertBottomRightCornerPortal,
            removeBottomRightCornerPortal
        ]);
        return (0, $7nsd3.createPortal)((0, ($parcel$interopDefault($5uXOq))).createElement($8d24666022201b4c$var$StyledOutlet, null, children), portalWrapper.current);
    };
    const $8d24666022201b4c$export$ee54e6ed235df65e = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: "bottom-right-corner-outlet",
            packageName: "jira-bottom-right-corner-controller",
            extraEventData: {
                portalId: props.id
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($8d24666022201b4c$var$OutletWithPortal, props));
    const $8d24666022201b4c$var$StyledOutlet = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1vgl1wug _1ko9pxbi",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("dL11T", function(module, exports) {
    $parcel$export(module.exports, "RoadmapTimelineMode", ()=>$0d19feb93646d416$export$d1eb62afe3c5898c);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $5gzbX;
    var $lfTZh;
    var $iZN6h;
    var $biT18;
    var $1jUsD;
    var $lrbz9;
    var $8FJpd;
    const $0d19feb93646d416$var$LazyTimelineModeSwitcher = (0, (0, parcelRequire("1jUsD")).lazyAfterPaint)(()=>(parcelRequire("2lH7Q")), {
        moduleId: "./src/packages/aais/timeline-toolbar/src/ui/timeline-mode-switcher/index.tsx"
    });
    const $0d19feb93646d416$var$MODE_DESCRIPTORS = [
        {
            type: (0, (0, parcelRequire("iZN6h")).WEEKS),
            title: (0, (0, parcelRequire("lrbz9")).default).weeks
        },
        {
            type: (0, (0, parcelRequire("iZN6h")).MONTHS),
            title: (0, (0, parcelRequire("lrbz9")).default).months
        },
        {
            type: (0, (0, parcelRequire("iZN6h")).QUARTERS),
            title: (0, (0, parcelRequire("lrbz9")).default).quarters
        }
    ];
    const $0d19feb93646d416$var$timelineModeContainerStyles = null;
    const $0d19feb93646d416$export$d1eb62afe3c5898c = ({ onClick: onClick, withContainerStyles: withContainerStyles = false })=>{
        const [{ timelineMode: timelineMode }] = (0, (0, parcelRequire("biT18")).useTimelineState)();
        const changeMode = (0, $5uXOq.useCallback)((mode, event)=>{
            (0, (0, parcelRequire("5gzbX")).default)('timeline-mode', event.timeStamp);
            onClick(mode);
        }, [
            onClick
        ]);
        const element = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "timeline-mode-switcher",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8FJpd")).default), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($0d19feb93646d416$var$LazyTimelineModeSwitcher, {
            modes: $0d19feb93646d416$var$MODE_DESCRIPTORS,
            onModeChange: changeMode,
            currentMode: timelineMode
        }));
        return withContainerStyles ? (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c116y _bfhk1bhr _16qsrs09 _2rko1l7b _1ul91lit _1yt41b66"
            ])
        }, element) : element;
    };
});
parcelRegister("lrbz9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$31adc5c8e68efe7b$export$2e2bcd8739ae039);
    var $7VHMR;
    var $31adc5c8e68efe7b$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        weeks: {
            "id": "roadmap.timeline-table-kit.chart-overlay.timeline-mode.weeks",
            "defaultMessage": "Weeks"
        },
        months: {
            "id": "roadmap.timeline-table-kit.chart-overlay.timeline-mode.months",
            "defaultMessage": "Months"
        },
        quarters: {
            "id": "roadmap.timeline-table-kit.chart-overlay.timeline-mode.quarters",
            "defaultMessage": "Quarters"
        }
    });
});
parcelRegister("8FJpd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c3642ee154acff7a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $1wbtX;
    const $c3642ee154acff7a$var$TimelineModeSwitcherSkeleton = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($c3642ee154acff7a$var$Container, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1wbtX")).Skeleton), {
            width: "74px",
            height: "32px"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1wbtX")).Skeleton), {
            width: "74px",
            height: "32px"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1wbtX")).Skeleton), {
            width: "74px",
            height: "32px"
        }));
    var $c3642ee154acff7a$export$2e2bcd8739ae039 = $c3642ee154acff7a$var$TimelineModeSwitcherSkeleton;
    const $c3642ee154acff7a$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _zulp1b66",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("1wbtX", function(module, exports) {
    $parcel$export(module.exports, "getKeyframes", ()=>$39c21c8edc6f2616$export$b2b5e866b2fbf2ec);
    $parcel$export(module.exports, "Skeleton", ()=>$39c21c8edc6f2616$export$8f31e4c4a37b8e9c);
    $parcel$export(module.exports, "Spacer", ()=>$39c21c8edc6f2616$export$d7a54cba636a8cd6);
    $parcel$export(module.exports, "SkeletonCompiled", ()=>$39c21c8edc6f2616$export$dc84d515085190e);
    $parcel$export(module.exports, "SpacerCompiled", ()=>$39c21c8edc6f2616$export$e477bb7d17087f28);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $47bDC = parcelRequire("47bDC");
    const $39c21c8edc6f2616$export$b2b5e866b2fbf2ec = (offsetX = 0)=>{
        const fromPositionX = -Math.abs(offsetX) - 300;
        const toPositionX = fromPositionX + 2000;
        return (0, $47bDC.keyframes)({
            '0%': {
                backgroundPosition: `${fromPositionX}px 0`
            },
            '100%': {
                backgroundPosition: `${toPositionX}px 0`
            }
        });
    };
    const $39c21c8edc6f2616$var$shimmer = $39c21c8edc6f2616$export$b2b5e866b2fbf2ec();
    const $39c21c8edc6f2616$export$8f31e4c4a37b8e9c = (0, $47bDC.default).div.withConfig({
        componentId: "ieqbub-0"
    })((props)=>({
            animationDelay: props.theme.animationDelay || '0s',
            animationDuration: '1s',
            animationFillMode: 'forwards',
            animationIterationCount: 'infinite',
            animationName: props.theme.animationName || $39c21c8edc6f2616$var$shimmer,
            animationTimingFunction: 'linear',
            backgroundColor: `var(--ds-skeleton, ${(0, $72ba03e317f3d228$exports).N30})`,
            backgroundImage: `linear-gradient( to right, ${`var(--ds-skeleton, ${(0, $72ba03e317f3d228$exports).N30})`} 10%, ${`var(--ds-skeleton-subtle, ${(0, $72ba03e317f3d228$exports).N20})`} 30%, ${`var(--ds-skeleton, ${(0, $72ba03e317f3d228$exports).N30})`} 50% )`,
            backgroundRepeat: 'no-repeat',
            borderRadius: '2px',
            height: props.height,
            width: props.width
        }));
    const $39c21c8edc6f2616$export$d7a54cba636a8cd6 = (0, $47bDC.default).div.withConfig({
        componentId: "ieqbub-1"
    })((props)=>({
            height: props.height
        }));
    const $39c21c8edc6f2616$export$dc84d515085190e = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: {
                ...__cmpls,
                "--_8jvb0j": (0, (0, parcelRequire("lD23V")).default)(__cmplp.height),
                "--_1gljcou": (0, (0, parcelRequire("lD23V")).default)(__cmplp.width)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_ju25ru3m _5sag9cwz _1o51q7pw _tip812c5 _j7hq1245 _1pglp3kn _bfhkqrzy _1itk1ipn _12vemgnk _2rkoyh40 _4t3i1474 _1bsb1rkg",
                __cmplp.className
            ])
        });
    });
    const $39c21c8edc6f2616$export$e477bb7d17087f28 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: {
                ...__cmpls,
                "--_8jvb0j": (0, (0, parcelRequire("lD23V")).default)(__cmplp.height)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1474",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("2lH7Q", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("19PNG")
    ]).then(()=>parcelRequire('gskNf'));
});
parcelRegister("41NW4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6adf7e420ddfc1a3$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $42Si9;
    var $4R6GH;
    var $koVbs;
    var $8zOmE;
    var $22OQR;
    var $MXbPK;
    var $dCm1o;
    var $qFFvI;
    var $kjQs8;
    var $alxcf;
    const $6adf7e420ddfc1a3$var$TodayButton = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const interactionMetrics = (0, (0, parcelRequire("qFFvI")).useInteractionMetrics)();
        const { scrollTo: scrollTo } = (0, (0, parcelRequire("MXbPK")).useTimelineScroller)();
        const [{ todayPosition: todayPosition }] = (0, (0, parcelRequire("kjQs8")).useTimelineUI)();
        const fireInteractionMetrics = (0, $5uXOq.useCallback)(()=>{
            interactionMetrics[0, (0, parcelRequire("qFFvI")).TODAY_BUTTON_CLICKED].start();
            requestAnimationFrame(()=>{
                interactionMetrics[0, (0, parcelRequire("qFFvI")).TODAY_BUTTON_CLICKED].stop({
                    stopTime: Math.floor(performance.now())
                });
            });
        }, [
            interactionMetrics
        ]);
        const onClick = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'todayButton');
            scrollTo({
                left: todayPosition
            });
        }, [
            scrollTo,
            todayPosition
        ]);
        return (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_1') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42Si9")).default), {
            onClick: onClick,
            onMouseDown: fireInteractionMetrics,
            appearance: "subtle"
        }, formatMessage((0, (0, parcelRequire("alxcf")).default).today)) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("22OQR")).ThemedButton), {
            onClick: onClick,
            onMouseDown: fireInteractionMetrics
        }, formatMessage((0, (0, parcelRequire("alxcf")).default).today));
    };
    var $6adf7e420ddfc1a3$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($6adf7e420ddfc1a3$var$TodayButton);
});
parcelRegister("22OQR", function(module, exports) {
    $parcel$export(module.exports, "ThemedButton", ()=>$87e6157378e1cf19$export$f67fb575035cc7d0);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $4EETE;
    const $87e6157378e1cf19$export$f67fb575035cc7d0 = (0, $5uXOq.memo)((0, $5uXOq.forwardRef)(({ as: as, ...props }, ref)=>(0, ($parcel$interopDefault($5uXOq))).createElement($87e6157378e1cf19$var$CustomButton, {
            ...props,
            as: as,
            ref: ref
        })));
    const $87e6157378e1cf19$var$CustomButton = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("4EETE")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1qt3kjry _1g9h1tex _1umfuwj9 _6l8r3x59 _9se5176f _12rallho _zk5uzt2a _18vg2zyf _192e1jcw _fnp717ga _1xjgvy9e _1u0u14e8 _17z218zq _7n83frbu _n2ul1jo4 _1cf1r7td _1d7c1ag4 _nwukvy9e _fsjd4zrn _z1i3eyly",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("MXbPK", function(module, exports) {
    $parcel$export(module.exports, "timelineScroller", ()=>$f56251be9f02e352$export$e3f9523c9658dc67);
    $parcel$export(module.exports, "useTimelineScroller", ()=>$f56251be9f02e352$export$8b6469154a100351);
    var $iZN6h;
    const $f56251be9f02e352$var$scrollTo = ({ left: left, top: top })=>{
        const timelineElem = document.getElementById((0, (0, parcelRequire("iZN6h")).TIMELINE_ID));
        if (timelineElem !== null) {
            if (left !== undefined) timelineElem.scrollLeft = left;
            if (top !== undefined) timelineElem.scrollTop = top;
        }
    };
    const $f56251be9f02e352$var$getScrollLeft = ()=>{
        const timelineElem = document.getElementById((0, (0, parcelRequire("iZN6h")).TIMELINE_ID));
        if (timelineElem !== null) return timelineElem.scrollLeft;
        return 0;
    };
    const $f56251be9f02e352$var$getVisibleWidth = ()=>{
        const timelineElem = document.getElementById((0, (0, parcelRequire("iZN6h")).TIMELINE_ID));
        if (timelineElem !== null) return timelineElem.clientWidth;
        return 0;
    };
    const $f56251be9f02e352$export$e3f9523c9658dc67 = {
        scrollTo: $f56251be9f02e352$var$scrollTo,
        getScrollLeft: $f56251be9f02e352$var$getScrollLeft,
        getVisibleWidth: $f56251be9f02e352$var$getVisibleWidth
    };
    const $f56251be9f02e352$export$8b6469154a100351 = ()=>$f56251be9f02e352$export$e3f9523c9658dc67;
});
parcelRegister("alxcf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1b95d6e1ffa9c354$export$2e2bcd8739ae039);
    var $7VHMR;
    var $1b95d6e1ffa9c354$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        today: {
            "id": "business-timeline.timeline-view.toolbar.today-button.today",
            "defaultMessage": "Today"
        }
    });
});
parcelRegister("sMiWE", function(module, exports) {
    $parcel$export(module.exports, "getPreviewProps", ()=>$d2e387ec08e32352$export$746e70e91ead5d94);
    const $d2e387ec08e32352$export$746e70e91ead5d94 = ({ clientOffset: clientOffset, scrollOffset: scrollOffset, item: item })=>{
        if (!item) return undefined;
        const { id: id, barRect: barRect, leftPosition: leftPosition, viewportBoundingRect: viewportBoundingRect, requestViewportScrollBounding: requestViewportScrollBounding } = item;
        const scrollBounding = requestViewportScrollBounding();
        return {
            id: id,
            x0: leftPosition - scrollBounding.scrollLeft,
            y0: barRect.top + barRect.height / 2 - viewportBoundingRect.top + scrollOffset.scrollTop,
            x: clientOffset.x - viewportBoundingRect.left,
            y: clientOffset.y - viewportBoundingRect.top,
            width: viewportBoundingRect.width,
            height: viewportBoundingRect.height
        };
    };
});
parcelRegister("lypli", function(module, exports) {
    $parcel$export(module.exports, "ChartTimelineOverlay", ()=>$a1fa49cea3d5ab1c$export$85741b7831292a19);
    var $5uXOq = parcelRequire("5uXOq");
    var $jJZqs;
    var $pa9q9;
    var $dAmbh;
    var $g5X3G;
    var $6mo8w;
    var $8TimZ;
    var $bLz0W;
    var $jxKr9;
    var $400cb;
    var $lNKHg;
    var $fguIv;
    var $1AOMQ;
    const $a1fa49cea3d5ab1c$export$85741b7831292a19 = ({ issuesMap: issuesMap, dependencies: dependencies })=>{
        const isLinkingEnabled = (0, (0, parcelRequire("dAmbh")).useIsLinkingEnabled)();
        const { hasIssueLinking: hasIssueLinking } = (0, (0, parcelRequire("jxKr9")).useTimelineFeatures)();
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagService)();
        const { remove: remove, error: removeDependencyError } = (0, (0, parcelRequire("400cb")).useRemoveDependency)();
        const [{ tooltipParams: tooltipParams }, { onCloseTooltip: onCloseTooltip, setTooltipParams: setTooltipParams }] = (0, (0, parcelRequire("bLz0W")).useDependencyTooltip)();
        const { issueId: issueId, position: tooltipPosition, dependencies: tooltipDependencies = [], dependees: tooltipDependees = [] } = tooltipParams || {};
        const onUnlink = (0, $5uXOq.useCallback)(({ dependency: dependency, dependee: dependee })=>{
            const inwardLinkId = (issuesMap.get(dependee)?.issueLinks || []).find((link)=>link.inward?.issueId === dependency)?.issueLinkId;
            const outwardLinkId = (issuesMap.get(dependency)?.issueLinks || []).find((link)=>link.outward?.issueId === dependee)?.issueLinkId;
            const linkId = inwardLinkId || outwardLinkId;
            if (!linkId) return;
            const fromIds = inwardLinkId ? tooltipDependencies.filter((id)=>String(id) !== String(dependency)) : tooltipDependencies;
            const toIds = outwardLinkId ? tooltipDependees.filter((id)=>String(id) !== String(dependee)) : tooltipDependees;
            setTooltipParams({
                id: issueId,
                position: tooltipPosition,
                type: (0, $12de84cd008e33eb$export$4b680a32bbb87a28),
                links: {
                    fromIds: fromIds,
                    toIds: toIds
                }
            });
            remove({
                linkId: linkId,
                inwardIssueId: dependee,
                outwardIssueId: dependency
            });
        }, [
            issueId,
            issuesMap,
            remove,
            setTooltipParams,
            tooltipDependees,
            tooltipDependencies,
            tooltipPosition
        ]);
        const renderDependencyFlyout = (0, $5uXOq.useCallback)(({ id: id, position: position })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lNKHg")).DependencyFlyout), {
                id: id,
                position: position,
                issueId: issueId,
                issuesMap: issuesMap,
                dependees: tooltipDependees,
                dependencies: tooltipDependencies,
                canUnlink: hasIssueLinking && isLinkingEnabled,
                onUnlink: onUnlink,
                onCloseTooltip: onCloseTooltip
            }), [
            issueId,
            issuesMap,
            tooltipDependees,
            tooltipDependencies,
            hasIssueLinking,
            isLinkingEnabled,
            onUnlink,
            onCloseTooltip
        ]);
        const onDependencyClick = (0, $5uXOq.useCallback)(({ fromId: fromId, toId: toId }, position)=>{
            setTooltipParams({
                id: (0, (0, parcelRequire("g5X3G")).toIssueId)(fromId),
                type: (0, $12de84cd008e33eb$export$4b680a32bbb87a28),
                links: {
                    fromIds: [],
                    toIds: [
                        (0, (0, parcelRequire("g5X3G")).toIssueId)(toId)
                    ]
                },
                position: position
            });
        }, [
            setTooltipParams
        ]);
        const renderDependencyLines = (0, $5uXOq.useCallback)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6mo8w")).RoadmapDependencyLines), {
                dependencies: (0, (0, parcelRequire("1AOMQ")).transformDependencies)(dependencies),
                selectedDependency: (0, (0, parcelRequire("1AOMQ")).getSelectedDependency)(issueId, tooltipDependees),
                onDependencyClick: onDependencyClick
            }), [
            dependencies,
            issueId,
            tooltipDependees,
            onDependencyClick
        ]);
        const id = tooltipParams ? String(issueId) : undefined;
        (0, $5uXOq.useEffect)(()=>{
            if (removeDependencyError) showFlag({
                type: 'error',
                title: (0, (0, parcelRequire("fguIv")).default).removeDependencyErrorTitle,
                description: removeDependencyError instanceof (0, (0, parcelRequire("jJZqs")).ValidationError) ? [
                    (0, (0, parcelRequire("fguIv")).default).removeDependencyDynamicErrorMessage,
                    {
                        error: removeDependencyError.message
                    }
                ] : (0, (0, parcelRequire("fguIv")).default).removeDependencyErrorMessage
            });
        }, [
            removeDependencyError,
            showFlag
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8TimZ")).RoadmapChartTimelineOverlay), {
            id: id,
            type: (0, $12de84cd008e33eb$export$4b680a32bbb87a28),
            position: tooltipPosition,
            isDependenciesVisible: isLinkingEnabled,
            renderDependencyFlyout: renderDependencyFlyout,
            renderDependencyLines: renderDependencyLines
        });
    };
});
parcelRegister("6mo8w", function(module, exports) {
    $parcel$export(module.exports, "RoadmapDependencyLines", ()=>$eb164e7806d6b08e$export$ef4d1c7f7fde068f);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $c32Ax;
    var $biT18;
    var $h5d6K;
    const $eb164e7806d6b08e$var$containerStyles = null;
    const $eb164e7806d6b08e$export$ef4d1c7f7fde068f = ({ dependencies: dependencies, selectedDependency: selectedDependency, onDependencyClick: onDependencyClick })=>{
        const [{ timelineDuration: timelineDuration, timelineWidth: timelineWidth }] = (0, (0, parcelRequire("biT18")).useTimelineState)();
        const dependenciesWithPositionsAndIsOverlap = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("h5d6K")).getDependenciesWithPositions)(dependencies, timelineDuration, timelineWidth), [
            dependencies,
            timelineDuration,
            timelineWidth
        ]);
        const onHandleDependencyClick = ({ pageX: pageX, pageY: pageY }, { toId: toId, fromId: fromId })=>{
            onDependencyClick && onDependencyClick({
                toId: toId,
                fromId: fromId
            }, {
                x: pageX,
                y: pageY
            });
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1pbycs5v"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("c32Ax")).default), {
            dependencies: dependenciesWithPositionsAndIsOverlap,
            selectedDependency: selectedDependency,
            onDependencyClick: onHandleDependencyClick
        }));
    };
    $eb164e7806d6b08e$export$ef4d1c7f7fde068f.defaultProps = {
        selectedDependency: undefined
    };
});
parcelRegister("c32Ax", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$abcd90738f5b2cb5$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $47bDC = parcelRequire("47bDC");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $9cikT;
    const $abcd90738f5b2cb5$var$SvgOverlay = ({ dependencies: dependencies, selectedDependency: selectedDependency, onDependencyClick: onDependencyClick })=>{
        const selectedDependencyLine = selectedDependency && dependencies.find((dependency)=>dependency.from.id === selectedDependency.fromId && dependency.to.id === selectedDependency.toId && dependency.from.indexOnScope === selectedDependency.fromIndex && dependency.to.indexOnScope === selectedDependency.toIndex);
        return ((0, ($parcel$interopDefault($5uXOq))).createElement($abcd90738f5b2cb5$var$SvgContainer, {
            className: (0, $0afb8a62e53619f1$export$1e54f8b472a07d8d)
        }, dependencies.map((dependency)=>{
            if (dependency !== selectedDependencyLine) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9cikT")).default), {
                key: `${dependency.from.id}-${dependency.to.id}-${dependency.from.y}-${dependency.to.y}`,
                ...dependency,
                onClick: onDependencyClick,
                isSelected: false
            });
            return null;
        }), selectedDependencyLine && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9cikT")).default), {
            ...selectedDependencyLine,
            onClick: onDependencyClick,
            isSelected: true
        })));
    };
    $abcd90738f5b2cb5$var$SvgOverlay.defaultProps = {
        selectedDependency: undefined,
        onDependencyClick: (0, ($parcel$interopDefault($8Rkzz))),
        dependencies: []
    };
    var $abcd90738f5b2cb5$export$2e2bcd8739ae039 = $abcd90738f5b2cb5$var$SvgOverlay;
    const $abcd90738f5b2cb5$var$SvgContainer = (0, $47bDC.default).svg.withConfig({
        componentId: "sc-7b34v9-0"
    })({
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        transition: 'opacity 0.2s ease-in-out',
        overflow: 'visible',
        pointerEvents: 'none'
    });
});
const $0afb8a62e53619f1$export$1e54f8b472a07d8d = 'dependencies-overlay';
const $0afb8a62e53619f1$export$cd944e09ecad5145 = 'dependency-line';
parcelRegister("9cikT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7dcd03412ef5592d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $ajpes = parcelRequire("ajpes");
    var $5gzbX;
    var $loZC0;
    var $koVbs;
    var $iHPnC;
    var $8zOmE;
    var $lwMsT;
    var $eGwbr;
    var $6k94P;
    const $7dcd03412ef5592d$var$DependencyLine = ({ from: from, to: to, itemHeight: itemHeight, isOverlapping: isOverlapping, isSelected: isSelected, onClick: onClick })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const [isHovered, setIsHovered] = (0, $5uXOq.useState)(false);
        const onPathClick = (0, $5uXOq.useCallback)((event)=>{
            (0, (0, parcelRequire("5gzbX")).default)('timeline-dependency-clicked', event.timeStamp);
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'line'
            });
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'dependencyLine', {
                isOverlapping: isOverlapping
            });
            onClick(event, {
                fromId: from.id,
                toId: to.id,
                isOverlapping: isOverlapping,
                fromIndexOnScope: from.indexOnScope,
                toIndexOnScope: to.indexOnScope
            });
        }, [
            createAnalyticsEvent,
            isOverlapping,
            from,
            to,
            onClick
        ]);
        const onPathMouseEnter = (0, $5uXOq.useCallback)(()=>{
            setIsHovered(true);
        }, []);
        const onPathMouseLeave = (0, $5uXOq.useCallback)(()=>{
            setIsHovered(false);
        }, []);
        const path = (0, (0, parcelRequire("6k94P")).getPath)(from, to, itemHeight);
        const gradientId = `linear-gradient-${from.id}-${to.id}`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (isHovered || isSelected) && (0, ($parcel$interopDefault($5uXOq))).createElement("linearGradient", {
            id: gradientId,
            x1: from.x,
            x2: to.x,
            y1: from.y,
            y2: to.y,
            gradientUnits: "userSpaceOnUse"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "0%",
            stopColor: (0, (0, parcelRequire("iHPnC")).getValueFromColor)(from.color)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("stop", {
            offset: "100%",
            stopColor: (0, (0, parcelRequire("iHPnC")).getValueFromColor)(to.color)
        })), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: path,
            fill: "transparent",
            strokeWidth: "2",
            stroke: $7dcd03412ef5592d$export$a73db48ef11a2bc3({
                isOverlapping: isOverlapping,
                isSelected: isSelected,
                isHovered: isHovered,
                gradientId: gradientId
            }),
            pointerEvents: "none",
            "data-testid": "aais-dependency-lines-overlay.common.ui.line.dependency-line"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("loZC0")).default), {
            position: "mouse",
            mousePosition: "top",
            content: formatMessage((0, (0, parcelRequire("eGwbr")).default).viewDetail),
            tag: "g"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($7dcd03412ef5592d$var$InteractivePath, {
            className: (0, $0afb8a62e53619f1$export$cd944e09ecad5145),
            d: path,
            stroke: "transparent",
            strokeWidth: "9",
            fill: "none",
            cursor: "pointer",
            onClick: onPathClick,
            onMouseEnter: onPathMouseEnter,
            onMouseLeave: onPathMouseLeave,
            "data-testid": "aais-dependency-lines-overlay.common.ui.line.interactive-path"
        })));
    };
    $7dcd03412ef5592d$var$DependencyLine.whyDidYouRender = true;
    var $7dcd03412ef5592d$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($7dcd03412ef5592d$var$DependencyLine, (0, ($parcel$interopDefault($ajpes))));
    const $7dcd03412ef5592d$var$InteractivePath = (0, $5uXOq.forwardRef)(({ as: C = "path", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_lcxv1yxs",
                __cmplp.className
            ])
        });
    });
    const $7dcd03412ef5592d$export$a73db48ef11a2bc3 = ({ isOverlapping: isOverlapping, isSelected: isSelected, isHovered: isHovered, gradientId: gradientId })=>{
        const isHighlighted = isSelected || isHovered;
        if (isOverlapping) {
            if (isHighlighted) return `var(--ds-background-danger-bold-hovered, ${(0, $72ba03e317f3d228$exports).R500})`;
            return `var(--ds-background-danger-bold, ${(0, $72ba03e317f3d228$exports).R300})`;
        }
        if (isHighlighted) return `url(#${gradientId})`;
        return `var(--ds-border-bold, ${(0, $72ba03e317f3d228$exports).N50})`;
    };
});
parcelRegister("eGwbr", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$188f0fa73c4b9066$export$2e2bcd8739ae039);
    var $7VHMR;
    var $188f0fa73c4b9066$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        viewDetail: {
            "id": "aais-dependency-lines-overlay.common.line.view-detail",
            "defaultMessage": "View dependency detail"
        }
    });
});
parcelRegister("6k94P", function(module, exports) {
    $parcel$export(module.exports, "getPath", ()=>$eb5c0917a150e0bd$export$2aa3fd96c49a84a8);
    var $8QpSo;
    const $eb5c0917a150e0bd$var$calculateMidPoint = (from, to)=>({
            x: (from.x + to.x) / 2,
            y: (from.y + to.y) / 2
        });
    const $eb5c0917a150e0bd$var$getY = (p1, p2, x)=>{
        const m = (p2.y - p1.y) / (p2.x - p1.x);
        return m * (x - p1.x) + p1.y;
    };
    const $eb5c0917a150e0bd$var$generateSegment = (start, end, offset)=>{
        const c1 = {
            x: start.x + offset.x,
            y: start.y
        };
        const c2 = {
            x: start.x + offset.x,
            y: start.y + offset.y
        };
        const s1 = {
            x: start.x,
            y: $eb5c0917a150e0bd$var$getY(c2, end, start.x)
        };
        return `M${start.x} ${start.y} C${c1.x} ${c1.y} ${c2.x} ${c2.y} ${s1.x} ${s1.y} L${s1.x} ${s1.y} ${end.x} ${end.y}`;
    };
    const $eb5c0917a150e0bd$var$getSegmentOffsets = (from, to, halfItemHeight)=>{
        const fromOffset = {
            x: halfItemHeight,
            y: from.y <= to.y ? halfItemHeight : -halfItemHeight
        };
        const toOffset = {
            x: -fromOffset.x,
            y: -fromOffset.y
        };
        return [
            fromOffset,
            toOffset
        ];
    };
    const $eb5c0917a150e0bd$var$generateComplexPath = (from, to, halfItemHeight)=>{
        const middle = $eb5c0917a150e0bd$var$calculateMidPoint(from, to);
        const [fromOffset, toOffset] = $eb5c0917a150e0bd$var$getSegmentOffsets(from, to, halfItemHeight);
        return `${$eb5c0917a150e0bd$var$generateSegment(from, middle, fromOffset)} ${$eb5c0917a150e0bd$var$generateSegment(to, middle, toOffset)}`;
    };
    const $eb5c0917a150e0bd$var$generateSinglePath = (from, to, itemHeight)=>{
        const diffX = Math.abs(from.x - to.x);
        const progression = itemHeight + diffX * 0.1;
        return `M${from.x} ${from.y} C${from.x + progression} ${from.y} ${to.x - progression} ${to.y} ${to.x} ${to.y}`;
    };
    const $eb5c0917a150e0bd$export$2aa3fd96c49a84a8 = (0, (0, parcelRequire("8QpSo")).default)((from, to, itemHeight)=>from.x > to.x ? $eb5c0917a150e0bd$var$generateComplexPath(from, to, itemHeight / 2) : $eb5c0917a150e0bd$var$generateSinglePath(from, to, itemHeight));
});
parcelRegister("h5d6K", function(module, exports) {
    $parcel$export(module.exports, "getDependenciesWithPositions", ()=>$87e96561891a7532$export$2503ae09d0c5f74);
    var $esmwW;
    var $apjDv;
    var $5VKn0;
    const $87e96561891a7532$export$2503ae09d0c5f74 = (dependencies, timelineDuration, timelineWidth)=>dependencies.map(({ itemHeight: itemHeight, from: from, to: to })=>({
                isOverlapping: (0, (0, parcelRequire("5VKn0")).isDependencyDatesOverlapping)(undefined, from.dueDate, to.startDate, undefined),
                itemHeight: itemHeight,
                to: {
                    id: to.id,
                    y: to.y,
                    x: (0, (0, parcelRequire("apjDv")).getBarLeftPosition)(to.startDate, timelineDuration, timelineWidth),
                    color: to.color
                },
                from: {
                    id: from.id,
                    y: from.y,
                    x: (0, (0, parcelRequire("apjDv")).getBarLeftPosition)(from.dueDate + (0, (0, parcelRequire("esmwW")).DUE_DATE_OFFSET), timelineDuration, timelineWidth),
                    color: from.color
                }
            }));
});
parcelRegister("5VKn0", function(module, exports) {
    $parcel$export(module.exports, "isDependencyDatesOverlapping", ()=>$8b5d59bbe66a3f5f$export$9fb40a5a7e47a5dd);
    const $8b5d59bbe66a3f5f$export$9fb40a5a7e47a5dd = (dependencyStartDate = -1, dependencyDueDate = -1, dependeeStartDate = -1, dependeeDueDate = -1)=>{
        if (dependencyDueDate > -1 && dependeeStartDate > -1) return dependencyDueDate > dependeeStartDate;
        if (dependencyStartDate === -1 && dependencyDueDate === -1 || dependeeStartDate === -1 && dependeeDueDate === -1) return false;
        if (dependencyDueDate === -1 && dependeeStartDate === -1) return dependencyStartDate > dependeeDueDate;
        if (dependencyDueDate !== -1) return dependencyDueDate > dependeeDueDate;
        if (dependencyStartDate !== -1) return dependencyStartDate > dependeeStartDate;
        return false;
    };
});
parcelRegister("8TimZ", function(module, exports) {
    $parcel$export(module.exports, "RoadmapChartTimelineOverlay", ()=>$c36334e492ce3d03$export$8858e3c7842aaf2);
    var $5uXOq = parcelRequire("5uXOq");
    var $2KlaV;
    const $c36334e492ce3d03$export$8858e3c7842aaf2 = ({ id: id, position: position, type: type, isDependenciesVisible: isDependenciesVisible, renderDependencyFlyout: renderDependencyFlyout, renderDependencyLines: renderDependencyLines, renderHighlightLines: renderHighlightLines, renderContextMenu: renderContextMenu })=>{
        const renderFlyout = ()=>{
            if (id !== undefined && type !== undefined && position !== undefined) switch(type){
                case 0, $12de84cd008e33eb$export$4b680a32bbb87a28:
                    return renderDependencyFlyout({
                        id: id,
                        position: position
                    });
                case 0, $12de84cd008e33eb$export$a9487b0be9740846:
                    return renderContextMenu({
                        id: id,
                        position: position
                    });
                default:
                    return null;
            }
            return null;
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, renderFlyout(), isDependenciesVisible && renderDependencyLines(), renderHighlightLines());
    };
    $c36334e492ce3d03$export$8858e3c7842aaf2.defaultProps = {
        renderDependencyFlyout: (0, (0, parcelRequire("2KlaV")).DEFAULT_RENDERER),
        renderDependencyLines: (0, (0, parcelRequire("2KlaV")).DEFAULT_RENDERER),
        renderHighlightLines: (0, (0, parcelRequire("2KlaV")).DEFAULT_RENDERER),
        renderContextMenu: (0, (0, parcelRequire("2KlaV")).DEFAULT_RENDERER)
    };
});
parcelRegister("400cb", function(module, exports) {
    $parcel$export(module.exports, "useRemoveDependency", ()=>$40d2dd2fe99bba51$export$4e34ad0a8569f3f5);
    var $5uXOq = parcelRequire("5uXOq");
    var $5tTFS;
    var $cm8b5;
    var $jcw0u;
    var $4R6GH;
    var $jJZqs;
    var $gNAqw;
    var $iZWCl;
    var $cl738;
    var $iYWZH;
    var $eAHE6;
    var $ah9Pv;
    const $40d2dd2fe99bba51$export$5dfc3c3db5e1e7f6 = [
        'issuelinks'
    ];
    const $40d2dd2fe99bba51$var$LOCATION = 'timeline remove dependency service';
    const $40d2dd2fe99bba51$var$QUERY_NAME = 'removeDependencyTimelineView';
    const $40d2dd2fe99bba51$var$getRelevantError = (data)=>{
        if (data == null || data.unlinkJwmItems?.success === true) return undefined;
        const firstError = data.unlinkJwmItems?.errors?.[0];
        if (firstError != null) {
            if (firstError.extensions?.statusCode === 404) return undefined;
            if (firstError.message != null) return new (0, (0, parcelRequire("jJZqs")).ValidationError)(firstError.message);
        }
        return undefined;
    };
    const $40d2dd2fe99bba51$export$4e34ad0a8569f3f5 = ()=>{
        const { updateIssueLinksInCache: updateIssueLinksInCache } = (0, (0, parcelRequire("iYWZH")).useUpdateIssueLinksInCache)();
        const [{ issuesMap: issuesMap }] = (0, (0, parcelRequire("cl738")).useIssuesMap)();
        const start = (0, (0, parcelRequire("cm8b5")).useExperienceStart)((0, (0, parcelRequire("gNAqw")).UNLINK_ISSUES_EXPERIENCE));
        const onSuccess = (0, (0, parcelRequire("cm8b5")).useExperienceSuccess)((0, (0, parcelRequire("gNAqw")).UNLINK_ISSUES_EXPERIENCE));
        const onFail = (0, (0, parcelRequire("cm8b5")).useExperienceFail)((0, (0, parcelRequire("gNAqw")).UNLINK_ISSUES_EXPERIENCE));
        const [removeDependency, { data: data, loading: loading, error: error }] = (0, (0, parcelRequire("5tTFS")).useMutation)((0, (0, parcelRequire("eAHE6")).REMOVE_DEPENDENCY_TIMELINE_MUTATION), {
            onError: (apolloError)=>{
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: $40d2dd2fe99bba51$var$QUERY_NAME,
                        packageName: 'jiraBusinessTimeline',
                        teamName: 'jira-yurree'
                    },
                    error: apolloError,
                    attributes: {
                        message: 'Failed to remove dependency in timeline view'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                onFail('timeline remove dependency service', apolloError);
                if ((0, (0, parcelRequire("4R6GH")).fg)('business_timeline_dependency_performance_metric')) (0, (0, parcelRequire("iZWCl")).removeDependencyExperience).failure({
                    metadata: {
                        error: apolloError.message,
                        location: $40d2dd2fe99bba51$var$LOCATION
                    }
                });
            },
            onCompleted: (apolloData)=>{
                const relevantError = $40d2dd2fe99bba51$var$getRelevantError(apolloData);
                if (relevantError) {
                    onFail('timeline remove dependency service', relevantError);
                    if ((0, (0, parcelRequire("4R6GH")).fg)('business_timeline_dependency_performance_metric')) (0, (0, parcelRequire("iZWCl")).removeDependencyExperience).failure({
                        metadata: {
                            error: relevantError.message,
                            location: $40d2dd2fe99bba51$var$LOCATION
                        }
                    });
                } else {
                    onSuccess();
                    if ((0, (0, parcelRequire("4R6GH")).fg)('business_timeline_dependency_performance_metric')) (0, (0, parcelRequire("iZWCl")).removeDependencyExperience).success();
                }
            }
        });
        const remove = async ({ linkId: linkId, inwardIssueId: inwardIssueId, outwardIssueId: outwardIssueId })=>{
            start();
            if ((0, (0, parcelRequire("4R6GH")).fg)('business_timeline_dependency_performance_metric')) (0, (0, parcelRequire("iZWCl")).removeDependencyExperience).start();
            const optimisticResponse = {
                unlinkJwmItems: (0, (0, parcelRequire("ah9Pv")).createOptimisticLinkItems)({
                    linkId: linkId,
                    issuesMap: issuesMap
                })
            };
            await removeDependency({
                variables: {
                    fieldIdsToReturn: $40d2dd2fe99bba51$export$5dfc3c3db5e1e7f6,
                    input: {
                        linkId: linkId
                    }
                },
                optimisticResponse: optimisticResponse,
                update: (proxy, result)=>{
                    if (!$40d2dd2fe99bba51$var$getRelevantError(result.data)) {
                        updateIssueLinksInCache({
                            issueId: inwardIssueId,
                            issueLinks: {
                                edges: (issuesMap.get(inwardIssueId)?.originalIssueLinks ?? []).filter((edge)=>edge?.node?.issueLinkId !== linkId),
                                __typename: 'JiraIssueLinkConnection'
                            }
                        });
                        updateIssueLinksInCache({
                            issueId: outwardIssueId,
                            issueLinks: {
                                edges: (issuesMap.get(outwardIssueId)?.originalIssueLinks ?? []).filter((edge)=>edge?.node?.issueLinkId !== linkId),
                                __typename: 'JiraIssueLinkConnection'
                            }
                        });
                    }
                }
            });
        };
        const relevantError = (0, $5uXOq.useMemo)(()=>$40d2dd2fe99bba51$var$getRelevantError(data) || error, [
            data,
            error
        ]);
        return {
            loading: loading,
            error: relevantError,
            remove: remove
        };
    };
});
parcelRegister("eAHE6", function(module, exports) {
    $parcel$export(module.exports, "REMOVE_DEPENDENCY_TIMELINE_MUTATION", ()=>$352e63cc271b2ad4$export$deba7c477fa9c7e9);
    var $5cllN;
    const $352e63cc271b2ad4$export$deba7c477fa9c7e9 = (0, (0, parcelRequire("5cllN")).default)`
mutation RemoveJWMDependencyTimelineView($input: JWMUnlinkItemsInput!, $fieldIdsToReturn: [String]) {
    unlinkJwmItems(input: $input, fieldIdsToReturn: $fieldIdsToReturn) {
        inwardItem {
            issueId
            issueLinks(first: 10) {
                edges {
                    node {
                        issue {
                            issueId
                        }
                        issueLinkId
                        relationName
                        direction
                    }
                }
            }	
        }
        outwardItem {
            issueId
            issueLinks(first: 10) {
                edges {
                    node {
                        issue {
                            issueId
                        }
                        issueLinkId
                        relationName
                        direction
                    }
                }
            }	
        }
        success
        errors {
            message
            extensions {
                statusCode
                errorType
            }
        }
    }
}
`;
});
parcelRegister("ah9Pv", function(module, exports) {
    $parcel$export(module.exports, "createOptimisticLinkItems", ()=>$2035c169fb828f63$export$f5f603284bb2b3c7);
    const $2035c169fb828f63$export$f5f603284bb2b3c7 = ({ linkId: linkId, issuesMap: issuesMap })=>{
        const [inwardIssue, outwardIssue] = Array.from(issuesMap.values()).filter((issue)=>!!issue.originalIssueLinks.find((edge)=>edge.node?.issueLinkId === linkId));
        return {
            inwardItem: {
                issueId: Number(inwardIssue?.issueId),
                issueLinks: {
                    edges: inwardIssue?.originalIssueLinks.filter((edge)=>edge.node?.issueLinkId !== linkId),
                    __typename: 'JiraIssueLinkConnection'
                },
                __typename: 'JiraWorkManagementViewItem'
            },
            outwardItem: {
                issueId: Number(outwardIssue?.issueId),
                issueLinks: {
                    edges: outwardIssue?.originalIssueLinks.filter((edge)=>edge.node?.issueLinkId !== linkId),
                    __typename: 'JiraIssueLinkConnection'
                },
                __typename: 'JiraWorkManagementViewItem'
            },
            success: true,
            errors: null,
            __typename: 'JWMUnlinkItemsPayload'
        };
    };
});
parcelRegister("lNKHg", function(module, exports) {
    $parcel$export(module.exports, "DependencyFlyout", ()=>$5f7a0efef1fa9c71$export$7358cd3eeab0484b);
    var $5uXOq = parcelRequire("5uXOq");
    var $5fjsJ;
    var $1vbpx;
    const $5f7a0efef1fa9c71$export$7358cd3eeab0484b = ({ id: id, position: position, issueId: issueId, issuesMap: issuesMap, dependees: dependees, dependencies: dependencies, canUnlink: canUnlink, onUnlink: onUnlink, onCloseTooltip: onCloseTooltip })=>{
        const fromIssue = issueId ? (0, (0, parcelRequire("1vbpx")).getIssueFromMap)(issueId, issuesMap) : undefined;
        const toIssue = (0, (0, parcelRequire("1vbpx")).getIssueFromMap)(Number(dependees[0]), issuesMap);
        const dependency = (fromIssue?.issueLinks || []).find((fromLink)=>(toIssue?.issueLinks || []).map((toLink)=>toLink.issueLinkId).includes(fromLink.issueLinkId));
        const item = (0, (0, parcelRequire("1vbpx")).getOverlayIssueItem)(fromIssue);
        if (!item) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5fjsJ")).RoadmapDependencyFlyout), {
            id: id,
            item: item,
            position: position,
            dependencies: (0, (0, parcelRequire("1vbpx")).getDepsItem)({
                issuesMap: issuesMap,
                issueIds: dependencies
            }),
            dependees: (0, (0, parcelRequire("1vbpx")).getDepsItem)({
                issuesMap: issuesMap,
                issueIds: dependees
            }),
            implicitDependencyItems: [],
            maybeInwardDependencyDescription: dependency?.type.inward,
            maybeOutwardDependencyDescription: dependency?.type.outward,
            onClose: onCloseTooltip,
            ...canUnlink ? {
                onUnlink: onUnlink
            } : undefined
        }));
    };
});
parcelRegister("5fjsJ", function(module, exports) {
    $parcel$export(module.exports, "RoadmapDependencyFlyout", ()=>$1e58d695df4364a1$export$d59848488912363);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $ao4Ml = parcelRequire("ao4Ml");
    var $6jrGg;
    var $6Ll2T;
    var $ZuPvl;
    var $99gde;
    var $4R6GH;
    var $ousew;
    var $aWse0;
    var $82CeN;
    var $dCm1o;
    var $jabXi;
    var $aZ1lM;
    var $1zbLT;
    var $3VmqD;
    var $5VKn0;
    var $38z2g;
    var $dXkNq;
    var $hCsOd;
    var $8nXAF;
    var $efoCi;
    const $1e58d695df4364a1$export$d59848488912363 = ({ position: position, triggerRef: triggerRef, ...contentProps })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("aWse0")).useIntlV2)();
        const dialogContentRef = (0, $5uXOq.useRef)(null);
        const { id: id, item: item, dependencies: dependencies, dependees: dependees, implicitDependencyItems: implicitDependencyItems, onUnlink: onUnlink, onClose: onClose, maybeInwardDependencyDescription: maybeInwardDependencyDescription, maybeOutwardDependencyDescription: maybeOutwardDependencyDescription } = contentProps;
        const hasDependencies = dependencies.length > 0;
        const hasDependees = dependees.length > 0;
        const hasImplicitDependencies = implicitDependencyItems ? implicitDependencyItems.length > 0 : false;
        const { shouldPreventNavigation: shouldPreventNavigation } = (0, (0, parcelRequire("82CeN")).useFocusMarshal)();
        const onUnlinkClick = (0, $5uXOq.useCallback)((input, analyticsEvent)=>{
            onUnlink?.(input, analyticsEvent);
            dialogContentRef.current?.focus();
        }, [
            onUnlink
        ]);
        const handleClose = (0, $5uXOq.useCallback)(()=>{
            shouldPreventNavigation(false);
            onClose();
        }, [
            shouldPreventNavigation,
            onClose
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!hasDependencies && !hasDependees && !hasImplicitDependencies) {
                if ((0, (0, parcelRequire("4R6GH")).fg)('timeline_grid_navigation_m2')) handleClose();
                else onClose();
            }
        }, [
            hasDependencies,
            hasDependees,
            hasImplicitDependencies,
            onClose,
            handleClose
        ]);
        const defaultInwardDependencyDescription = `${formatMessage((0, (0, parcelRequire("8nXAF")).default).blockedBy)}`;
        const defaultOutwardDependencyDescription = `${formatMessage((0, (0, parcelRequire("8nXAF")).default).blocks)}`;
        const inwardDependencyDescription = maybeInwardDependencyDescription ?? defaultInwardDependencyDescription;
        const outwardDependencyDescription = maybeOutwardDependencyDescription ?? defaultOutwardDependencyDescription;
        const renderDepsBlock = (deps, appearance, label)=>{
            if (!deps.length) return null;
            const isOverlapping = deps.some(({ startDate: startDate, dueDate: dueDate })=>appearance === (0, $708c0d50a54aba38$export$920d6feba87a57ed) ? (0, (0, parcelRequire("5VKn0")).isDependencyDatesOverlapping)(startDate, dueDate, item.startDate, item.dueDate) : (0, (0, parcelRequire("5VKn0")).isDependencyDatesOverlapping)(item.startDate, item.dueDate, startDate, dueDate));
            const isFiltered = deps.some(({ isHidden: isHidden })=>isHidden);
            const hasDepItems = appearance === (0, $708c0d50a54aba38$export$920d6feba87a57ed) ? hasDependees : hasDependencies;
            const closeHandler = (0, (0, parcelRequire("4R6GH")).fg)('timeline_grid_navigation_m2') ? handleClose : onClose;
            const DependencyCardContainerComponent = (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && deps.length > 1 && (0, (0, parcelRequire("4R6GH")).fg)('visual-refresh_drop_1') ? (0, (0, parcelRequire("jabXi")).default) : 'div';
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aZ1lM")).default), {
                appearance: appearance,
                ...item
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1zbLT")).default), {
                label: label,
                ...(0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-post-project-a11y-fix') ? {
                    unlinkLabel: deps.length === 1 ? `${item.itemKey} ${item.title} ${label} ${deps[0].itemKey} ${deps[0].title}` : undefined
                } : {},
                isOverlapping: isOverlapping,
                isFiltered: isFiltered,
                ...onUnlink && deps.length === 1 ? {
                    onUnlink: (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-dependency-flyout-refocus') ? (0, (0, parcelRequire("38z2g")).createUnlinkHandlerByAppearance)(item.id, deps[0].id, appearance, onUnlinkClick, hasDepItems || hasImplicitDependencies ? undefined : closeHandler) : (0, (0, parcelRequire("38z2g")).createUnlinkHandlerByAppearance)(item.id, deps[0].id, appearance, onUnlink, hasDepItems ? undefined : closeHandler)
                } : undefined
            }), (0, ($parcel$interopDefault($5uXOq))).createElement(DependencyCardContainerComponent, null, deps.map((dep, index)=>{
                const shouldApplyVisualRefreshChanges = (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('visual-refresh_drop_1');
                return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aZ1lM")).default), {
                    isBottomCard: shouldApplyVisualRefreshChanges && deps.length > 1 ? index === deps.length - 1 : undefined,
                    isStacked: shouldApplyVisualRefreshChanges && deps.length > 1,
                    key: dep.id,
                    appearance: appearance === (0, $708c0d50a54aba38$export$920d6feba87a57ed) ? (0, $708c0d50a54aba38$export$2c998d8d93f14e97) : (0, $708c0d50a54aba38$export$920d6feba87a57ed),
                    ...(0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-post-project-a11y-fix') ? {
                        unlinkLabel: `${item.itemKey} ${item.title} ${label} ${dep.itemKey} ${dep.title}`
                    } : {},
                    ...dep,
                    isOverlapping: appearance === (0, $708c0d50a54aba38$export$920d6feba87a57ed) ? (0, (0, parcelRequire("5VKn0")).isDependencyDatesOverlapping)(dep.startDate, dep.dueDate, item.startDate, item.dueDate) : (0, (0, parcelRequire("5VKn0")).isDependencyDatesOverlapping)(item.startDate, item.dueDate, dep.startDate, dep.dueDate),
                    ...onUnlink && deps.length > 1 ? {
                        onUnlink: (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-dependency-flyout-refocus') ? (0, (0, parcelRequire("38z2g")).createUnlinkHandlerByAppearance)(item.id, dep.id, appearance, onUnlinkClick, undefined) : (0, (0, parcelRequire("38z2g")).createUnlinkHandlerByAppearance)(item.id, dep.id, appearance, onUnlink, undefined)
                    } : undefined
                });
            })));
        };
        const { itemKey: itemKey, title: title } = item;
        const incomingIssuesDesc = (0, (0, parcelRequire("efoCi")).useDependencyFlyoutLabel)(item, dependencies, (0, $708c0d50a54aba38$export$920d6feba87a57ed), inwardDependencyDescription);
        const outgoingIssuesDesc = (0, (0, parcelRequire("efoCi")).useDependencyFlyoutLabel)(item, dependees, (0, $708c0d50a54aba38$export$2c998d8d93f14e97), outwardDependencyDescription);
        const implicitDependenciesLabel = (0, (0, parcelRequire("efoCi")).useImplicitDependencyLabel)(itemKey, title, implicitDependencyItems);
        const flyoutAriaLabel = `${incomingIssuesDesc} ${outgoingIssuesDesc} ${implicitDependenciesLabel}`;
        const hasInteractiveContent = hasImplicitDependencies || (hasDependencies || hasDependees) && onUnlink !== undefined;
        const content = (0, ($parcel$interopDefault($5uXOq))).createElement((0, $ao4Ml.default), {
            returnFocus: false
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "roadmap.timeline-table-kit.ui.chart-timeline-overlay.dependency-flyout.container",
            role: "dialog",
            tabIndex: hasInteractiveContent ? -1 : 0,
            ref: dialogContentRef,
            "aria-label": flyoutAriaLabel,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt4v47k _bfhkexu1 _16qsbnrv _2rko1l7b _c71l1mjv _1reo1wug _18m91wug _1pby3ced",
                hasImplicitDependencies && "_1bsbeo28",
                !hasImplicitDependencies && "_1bsb1178"
            ])
        }, (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-post-project-a11y-fix') ? (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1178",
                "_1e0c1txw _2lx21bp4 _zulpv47k"
            ])
        }, (hasDependencies || hasDependees) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), null, hasImplicitDependencies && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            xcss: $1e58d695df4364a1$var$styledDependencyStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6jrGg")).default), {
            as: "h2",
            size: "xsmall"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ZuPvl")).default), {
            weight: "regular"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
            ...(0, (0, parcelRequire("8nXAF")).default).dependencyOf,
            values: {
                itemKey: itemKey,
                title: title,
                b: (chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement("b", null, chunks)
            }
        })))), renderDepsBlock(dependencies, (0, $708c0d50a54aba38$export$920d6feba87a57ed), inwardDependencyDescription), hasDependencies && hasDependees && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hCsOd")).default), null), renderDepsBlock(dependees, (0, $708c0d50a54aba38$export$2c998d8d93f14e97), outwardDependencyDescription)), hasImplicitDependencies && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dXkNq")).default), {
            parentItem: item,
            implicitDependencyItems: implicitDependencyItems,
            onClose: onClose,
            ...onUnlink ? {
                onUnlink: (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-dependency-flyout-refocus') ? onUnlinkClick : onUnlink
            } : undefined,
            inwardDependencyDescription: inwardDependencyDescription,
            outwardDependencyDescription: outwardDependencyDescription
        }))) : (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1178"
            ])
        }, hasImplicitDependencies && (hasDependencies || hasDependees) && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            xcss: $1e58d695df4364a1$var$styledDependencyStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
            ...(0, (0, parcelRequire("8nXAF")).default).dependencyOf,
            values: {
                itemKey: itemKey,
                title: title,
                b: (chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement("b", null, chunks)
            }
        })), renderDepsBlock(dependencies, (0, $708c0d50a54aba38$export$920d6feba87a57ed), inwardDependencyDescription), hasDependencies && hasDependees && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hCsOd")).default), null), renderDepsBlock(dependees, (0, $708c0d50a54aba38$export$2c998d8d93f14e97), outwardDependencyDescription), hasImplicitDependencies && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dXkNq")).default), {
            parentItem: item,
            implicitDependencyItems: implicitDependencyItems,
            onClose: onClose,
            ...onUnlink ? {
                onUnlink: (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-dependency-flyout-refocus') ? onUnlinkClick : onUnlink
            } : undefined,
            inwardDependencyDescription: inwardDependencyDescription,
            outwardDependencyDescription: outwardDependencyDescription
        }))));
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3VmqD")).OverlayFlyout), {
            key: id,
            position: position,
            content: content,
            onClose: (0, (0, parcelRequire("4R6GH")).fg)('timeline_grid_navigation_m2') ? handleClose : onClose,
            triggerRef: (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-dependency-flyout-refocus') ? triggerRef : undefined
        });
    };
    $1e58d695df4364a1$export$d59848488912363.defaultProps = {
        dependencies: [],
        dependees: [],
        onClose: ()=>{}
    };
    const $1e58d695df4364a1$var$containerWideWidthStyles = null;
    const $1e58d695df4364a1$var$containerNotWideWidthStyles = null;
    const $1e58d695df4364a1$var$flexStyles = null;
    const $1e58d695df4364a1$var$containerStyles = null;
    const $1e58d695df4364a1$var$styledDependencyStyles = (0, (0, parcelRequire("99gde")).xcss)({
        marginBottom: 'space.100'
    });
});
parcelRegister("jabXi", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ab9395a12c67d2ae$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $k0Jvh;
    var $99gde;
    const $ab9395a12c67d2ae$var$DependencyCardContainer = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0Jvh")).default), {
            xcss: $ab9395a12c67d2ae$var$dependencyCardContainerStyles
        }, children);
    var $ab9395a12c67d2ae$export$2e2bcd8739ae039 = $ab9395a12c67d2ae$var$DependencyCardContainer;
    const $ab9395a12c67d2ae$var$dependencyCardContainerStyles = (0, (0, parcelRequire("99gde")).xcss)({
        borderRadius: 'border.radius',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: 'color.border'
    });
});
parcelRegister("aZ1lM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5abd28b8f7d05bab$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $1fJir;
    var $6Ll2T;
    var $3srSR;
    var $k0Jvh;
    var $ZuPvl;
    var $99gde;
    var $6s1PB;
    var $4R6GH;
    var $aWse0;
    var $dCm1o;
    var $esmwW;
    var $eYNCs;
    var $gTiLe;
    var $jabXi;
    var $lQUon;
    var $lHTuc;
    const $5abd28b8f7d05bab$var$WarningMessage = ({ warningKey: warningKey, message: message })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3srSR")).default), {
            gap: "space.100",
            testId: "roadmap.timeline-table-kit.common.ui.dependency.card.test",
            alignItems: "center",
            xcss: $5abd28b8f7d05bab$var$warningMessageStyles,
            key: warningKey
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("1fJir"))))), {
            color: `var(--ds-icon-warning, ${(0, $72ba03e317f3d228$export$c6930421db9fa514)})`,
            LEGACY_size: "small",
            label: message
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ZuPvl")).default), {
            size: "small",
            weight: "semibold"
        }, message));
    const $5abd28b8f7d05bab$var$DependenciesCardContent = ({ appearance: appearance, isOverlapping: isOverlapping = false, startDateType: startDateType, dueDateType: dueDateType, title: title, iconUrl: iconUrl, typeName: typeName, startDate: startDate, dueDate: dueDate, onUnlink: onUnlink, intervalName: intervalName, warningMessages: warningMessages, unlinkLabel: unlinkLabel })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("aWse0")).useIntlV2)();
        const getCardDateLabelProps = ()=>{
            let labelProps = {
                caption: '',
                noDateMessage: ''
            };
            const isIncoming = appearance === (0, $708c0d50a54aba38$export$920d6feba87a57ed);
            const dateType = isIncoming ? startDateType : dueDateType;
            switch(dateType){
                case 0, (0, parcelRequire("esmwW")).INTERVAL:
                    labelProps = {
                        caption: formatMessage(isIncoming ? (0, (0, parcelRequire("lHTuc")).default).sprintStartDateCaption : (0, (0, parcelRequire("lHTuc")).default).sprintEndDateCaption),
                        noDateMessage: formatMessage((0, (0, parcelRequire("lHTuc")).default).noSprintAssigned)
                    };
                    break;
                case 0, (0, parcelRequire("esmwW")).ROLLUP:
                case 0, (0, parcelRequire("esmwW")).EXPLICIT:
                default:
                    labelProps = {
                        caption: formatMessage(isIncoming ? (0, (0, parcelRequire("lHTuc")).default).startDateCaption : (0, (0, parcelRequire("lHTuc")).default).dueDateCaption),
                        noDateMessage: formatMessage(isIncoming ? (0, (0, parcelRequire("lHTuc")).default).noStartDateSet : (0, (0, parcelRequire("lHTuc")).default).noDueDateSet)
                    };
                    break;
            }
            return {
                dateType: dateType,
                date: isIncoming ? startDate : dueDate,
                intervalName: intervalName,
                ...labelProps
            };
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3srSR")).default), {
            gap: "space.050",
            direction: "column"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3srSR")).default), {
            gap: "space.100",
            alignItems: "center"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eYNCs")).default), {
            src: iconUrl || '',
            alt: formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("lHTuc")).default).iconAltTextIssueTermRefresh : (0, (0, parcelRequire("lHTuc")).default).iconAltText, {
                typeName: typeName
            })
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0Jvh")).default), {
            grow: "fill"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ZuPvl")).default), {
            size: "medium",
            maxLines: 1
        }, title)), onUnlink && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gTiLe")).default), {
            onClick: onUnlink,
            ...(0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-post-project-a11y-fix') ? {
                label: unlinkLabel
            } : {}
        }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lQUon")).default), getCardDateLabelProps())), isOverlapping && (0, ($parcel$interopDefault($5uXOq))).createElement($5abd28b8f7d05bab$var$WarningMessage, {
            warningKey: (0, (0, parcelRequire("lHTuc")).default).datesOverlapWarning.id,
            message: formatMessage((0, (0, parcelRequire("lHTuc")).default).datesOverlapWarning)
        }), warningMessages.map((message)=>(0, ($parcel$interopDefault($5uXOq))).createElement($5abd28b8f7d05bab$var$WarningMessage, {
                key: message.id,
                warningKey: message.id,
                message: formatMessage(message)
            })));
    };
    const $5abd28b8f7d05bab$var$DependencyCard = ({ parent: parent, isBottomCard: isBottomCard, isStacked: isStacked, ...props })=>{
        const dependenciesCardContent = (0, ($parcel$interopDefault($5uXOq))).createElement($5abd28b8f7d05bab$var$DependenciesCardContent, props);
        const content = parent !== undefined ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _kqswh2mm _2lx2vrvc _4cvr1h6o _1reo15vq _18m915vq"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2hwxu2gc"
            ])
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eYNCs")).default), {
            src: parent.iconUrl
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            paddingBlock: "space.075"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ZuPvl")).default), {
            size: "UNSAFE_small",
            maxLines: 1,
            color: "color.text.subtlest"
        }, parent.title, " /"))), (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm _19bv1ejb _19pk1b66"
            ])
        }, dependenciesCardContent)) : dependenciesCardContent;
        if ((0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('visual-refresh_drop_1')) return isStacked ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            xcss: [
                $5abd28b8f7d05bab$var$containerStyles,
                !isBottomCard && $5abd28b8f7d05bab$var$withBorderBottomStyles
            ]
        }, content) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jabXi")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            xcss: $5abd28b8f7d05bab$var$containerStyles
        }, content));
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx21bp4 _kqswh2mm _1yt41pyq _bfhkhp5a _16qsuole"
            ])
        }, content);
    };
    $5abd28b8f7d05bab$var$DependencyCard.displayName = 'DependencyCard';
    var $5abd28b8f7d05bab$export$2e2bcd8739ae039 = $5abd28b8f7d05bab$var$DependencyCard;
    const $5abd28b8f7d05bab$var$containerStylesOld = null;
    const $5abd28b8f7d05bab$var$containerStyles = (0, (0, parcelRequire("99gde")).xcss)({
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        padding: 'space.150'
    });
    const $5abd28b8f7d05bab$var$withBorderBottomStyles = (0, (0, parcelRequire("99gde")).xcss)({
        borderBottom: `1px solid ${"var(--ds-border, #091E4224)"}`
    });
    const $5abd28b8f7d05bab$var$titleContainerStyles = null;
    const $5abd28b8f7d05bab$var$typeIconContainerStyles = null;
    const $5abd28b8f7d05bab$var$warningMessageStyles = (0, (0, parcelRequire("99gde")).xcss)({
        paddingTop: 'space.100'
    });
    const $5abd28b8f7d05bab$var$childContainerStyles = null;
});
parcelRegister("eYNCs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9fcbc2bc3dd94cb8$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    const $9fcbc2bc3dd94cb8$var$iconImageStyles = null;
    const $9fcbc2bc3dd94cb8$var$Icon = ({ src: src, alt: alt = '', size: size = '16px' })=>(0, ($parcel$interopDefault($5uXOq))).createElement("img", {
            src: src,
            alt: alt,
            style: {
                width: size,
                height: size
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jlidpf _1o9zidpf _i0dl1wug _2rko1sit"
            ])
        });
    var $9fcbc2bc3dd94cb8$export$2e2bcd8739ae039 = $9fcbc2bc3dd94cb8$var$Icon;
});
parcelRegister("gTiLe", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2fb86317940cfc3c$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $9jNMw;
    var $2APCZ;
    var $bcHs4;
    var $loZC0;
    var $6s1PB;
    var $4R6GH;
    var $koVbs;
    var $8zOmE;
    var $04TxK;
    const $2fb86317940cfc3c$var$UnlinkButton = ({ onClick: onClick, label: label })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const onClickCallback = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
            event.stopPropagation();
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'dependencyUnlinkButton');
            onClick(analyticsEvent);
        }, [
            onClick
        ]);
        const unlinkMessage = (0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("04TxK")).default).unlinkIssueTermRefresh : (0, (0, parcelRequire("04TxK")).default).unlink;
        const unlinkItemMessage = (0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("04TxK")).default).unlinkItemIssueTermRefresh : (0, (0, parcelRequire("04TxK")).default).unlinkItem;
        return (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-post-project-a11y-fix') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("loZC0")).default), {
            content: formatMessage((0, (0, parcelRequire("04TxK")).default).unlink)
        }, (tooltipProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9jNMw")).default), {
                ...tooltipProps,
                label: label ? formatMessage(unlinkItemMessage, {
                    issue: label
                }) : formatMessage(unlinkMessage),
                icon: (0, ($parcel$interopDefault((0, parcelRequire("bcHs4"))))),
                testId: "roadmap.timeline-table-kit.common.ui.dependency.unlink-button.unlink-button",
                spacing: "compact",
                appearance: "subtle",
                onClick: onClickCallback,
                ...(0, (0, parcelRequire("4R6GH")).fg)('platform_button_item-add-ufo-metrics') ? {
                    interactionName: 'timeline-dependency-unlink-clicked'
                } : {}
            })) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("loZC0")).default), {
            content: formatMessage((0, (0, parcelRequire("04TxK")).default).unlink)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2APCZ")).default), {
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("bcHs4"))))), {
                LEGACY_size: "small",
                label: formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("04TxK")).default).unlinkIssueTermRefresh : (0, (0, parcelRequire("04TxK")).default).unlink),
                testId: "roadmap.timeline-table-kit.common.ui.dependency.unlink-button.unlink-button",
                color: "currentColor"
            }),
            spacing: "compact",
            appearance: "subtle",
            onClick: onClickCallback
        }));
    };
    var $2fb86317940cfc3c$export$2e2bcd8739ae039 = $2fb86317940cfc3c$var$UnlinkButton;
});
parcelRegister("bcHs4", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $82828553b0421179$var$_react = $82828553b0421179$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $82828553b0421179$var$_linkBroken = $82828553b0421179$var$_interopRequireDefault((parcelRequire("dxJhf")));
    var $82828553b0421179$var$_unlink = $82828553b0421179$var$_interopRequireDefault((parcelRequire("J0seQ")));
    function $82828553b0421179$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $82828553b0421179$var$LinkBrokenIcon = (props)=>$82828553b0421179$var$_react.default.createElement($82828553b0421179$var$_linkBroken.default, Object.assign({
            LEGACY_fallbackIcon: $82828553b0421179$var$_unlink.default
        }, props));
    $82828553b0421179$var$LinkBrokenIcon.Name = 'LinkBrokenIconMigration';
    var $82828553b0421179$var$_default = module.exports.default = $82828553b0421179$var$LinkBrokenIcon;
});
parcelRegister("dxJhf", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $9dc17a8a0c17d3ac$var$_react = $9dc17a8a0c17d3ac$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $9dc17a8a0c17d3ac$var$_UNSAFE_baseNew = $9dc17a8a0c17d3ac$var$_interopRequireDefault((parcelRequire("dTInF")));
    function $9dc17a8a0c17d3ac$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $9dc17a8a0c17d3ac$var$LinkBrokenIcon = (props)=>$9dc17a8a0c17d3ac$var$_react.default.createElement($9dc17a8a0c17d3ac$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m3.5 8-.75.75a3.182 3.182 0 0 0 4.5 4.5L8 12.5m0-9 .75-.75a3.182 3.182 0 0 1 4.5 4.5L12.5 8M5.25 1v3M1 5.25h3m11 5.5h-3M10.75 15v-3"/>`
        }, props));
    $9dc17a8a0c17d3ac$var$LinkBrokenIcon.displayName = 'LinkBrokenIcon';
    var $9dc17a8a0c17d3ac$var$_default = module.exports.default = $9dc17a8a0c17d3ac$var$LinkBrokenIcon;
});
parcelRegister("J0seQ", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $08748e54720e366b$var$_react = $08748e54720e366b$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $7p1ve;
    var $08748e54720e366b$var$_linkBroken = $08748e54720e366b$var$_interopRequireDefault((parcelRequire("dxJhf")));
    function $08748e54720e366b$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $08748e54720e366b$var$UnlinkIcon = (props)=>$08748e54720e366b$var$_react.default.createElement((0, parcelRequire("7p1ve")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M13.72 14.43a.97.97 0 0 0-1.37 0l-2.09 2.06a1.93 1.93 0 0 1-1.37.57c-.59 0-1.13-.26-1.52-.74-.63-.78-.5-1.93.2-2.64l1.32-1.32.69-.69a.97.97 0 0 0 0-1.38.97.97 0 0 0-1.37 0l-2.07 2.07a3.89 3.89 0 0 0 0 5.5l.01.01A3.87 3.87 0 0 0 8.89 19a3.87 3.87 0 0 0 2.75-1.14l2.08-2.08a.95.95 0 0 0 0-1.34m-3.44-4.87a.97.97 0 0 0 1.37 0l2.09-2.06c.37-.37.85-.57 1.37-.57.59 0 1.14.26 1.53.74.63.78.51 1.93-.2 2.64l-1.32 1.32-.69.69a.97.97 0 0 0 0 1.38c.38.38 1 .38 1.38 0l2.07-2.07a3.89 3.89 0 0 0 0-5.5l-.01-.01A3.87 3.87 0 0 0 15.11 5a3.87 3.87 0 0 0-2.75 1.14l-2.08 2.09a.95.95 0 0 0 0 1.35M8.92 4.62l.4.97a1 1 0 1 1-1.85.77l-.4-.97a1 1 0 1 1 1.85-.76M5.38 7.08l.97.4a1 1 0 0 1-.77 1.85l-.97-.4a1 1 0 0 1 .77-1.85m9.94 10.41a1 1 0 0 0-.54 1.31l.4.97a1 1 0 1 0 1.84-.77l-.4-.97a1 1 0 0 0-1.31-.54m2.18-2.17a1 1 0 0 0 .54 1.31l.97.4a1 1 0 0 0 .77-1.85l-.97-.4a1 1 0 0 0-1.31.54"/></svg>`
        }, props, {
            newIcon: $08748e54720e366b$var$_linkBroken.default
        }));
    $08748e54720e366b$var$UnlinkIcon.displayName = 'UnlinkIcon';
    var $08748e54720e366b$var$_default = module.exports.default = $08748e54720e366b$var$UnlinkIcon;
});
parcelRegister("04TxK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$16432c8a2c58c787$export$2e2bcd8739ae039);
    var $7VHMR;
    var $16432c8a2c58c787$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        unlink: {
            "id": "roadmap.timeline-table-kit.common.dependency.unlink-button.unlink",
            "defaultMessage": "Unlink issue"
        },
        unlinkIssueTermRefresh: {
            "id": "roadmap.timeline-table-kit.common.dependency.unlink-button.unlink-issue-term-refresh",
            "defaultMessage": "Unlink work item"
        },
        unlinkItem: {
            "id": "roadmap.timeline-table-kit.common.dependency.unlink-button.unlink-item",
            "defaultMessage": "Unlink - {issue}"
        },
        unlinkItemIssueTermRefresh: {
            "id": "roadmap.timeline-table-kit.common.dependency.unlink-button.unlink-item-issue-term-refresh",
            "defaultMessage": "Unlink - {issue}"
        }
    });
});
parcelRegister("lQUon", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9f633b38e3c9013b$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $2gnC5 = parcelRequire("2gnC5");
    var $3srSR;
    var $99gde;
    var $esmwW;
    var $caQD3;
    var $6dG5H;
    const $9f633b38e3c9013b$var$DependencyCardDateLabel = ({ dateType: dateType, date: date, intervalName: intervalName, caption: caption, noDateMessage: noDateMessage })=>{
        const label = date !== undefined ? (0, ($parcel$interopDefault($2gnC5))).utc(date).format((0, (0, parcelRequire("esmwW")).DATE_FORMAT_MOMENT)) : noDateMessage;
        const renderExplicitDate = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($9f633b38e3c9013b$var$Container, {
                testId: "roadmap.timeline-table-kit.common.ui.dependency.card.date-label.explicit-date"
            }, date !== undefined && `${caption} `, label);
        const renderIntervalDate = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, intervalName !== undefined && (0, ($parcel$interopDefault($5uXOq))).createElement($9f633b38e3c9013b$var$Container, {
                testId: "roadmap.timeline-table-kit.common.ui.dependency.card.date-label.interval-date"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6dG5H")).SprintIcon), null), intervalName), renderExplicitDate());
        const renderRollupDate = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($9f633b38e3c9013b$var$Container, {
                testId: "roadmap.timeline-table-kit.common.ui.dependency.card.date-label.rollup-date"
            }, date !== undefined && `${caption} `, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("caQD3")).RollupIcon), null), label);
        switch(dateType){
            case 0, (0, parcelRequire("esmwW")).INTERVAL:
                return renderIntervalDate();
            case 0, (0, parcelRequire("esmwW")).ROLLUP:
                return renderRollupDate();
            case 0, (0, parcelRequire("esmwW")).EXPLICIT:
            default:
                return renderExplicitDate();
        }
    };
    var $9f633b38e3c9013b$export$2e2bcd8739ae039 = $9f633b38e3c9013b$var$DependencyCardDateLabel;
    const $9f633b38e3c9013b$var$Container = ({ children: children, testId: testId })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3srSR")).default), {
            xcss: $9f633b38e3c9013b$var$ContainerStyles,
            direction: "row",
            alignItems: "center",
            testId: testId
        }, children);
    const $9f633b38e3c9013b$var$ContainerStyles = (0, (0, parcelRequire("99gde")).xcss)({
        font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        paddingLeft: 'space.300',
        color: 'color.text.subtlest'
    });
});
parcelRegister("lHTuc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bd2615e762c6e0f0$export$2e2bcd8739ae039);
    var $7VHMR;
    var $bd2615e762c6e0f0$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        iconAltText: {
            "id": "roadmap.timeline-table-kit.common.dependency.card.icon-alt-text",
            "defaultMessage": "{typeName} issue type"
        },
        datesOverlapWarning: {
            "id": "roadmap.timeline-table-kit.common.dependency.card.dates-overlap-warning",
            "defaultMessage": "Dates overlap"
        },
        startDateCaption: {
            "id": "roadmap.timeline-table-kit.common.dependency.card.start-date-caption",
            "defaultMessage": "Start date"
        },
        dueDateCaption: {
            "id": "roadmap.timeline-table-kit.common.dependency.card.due-date-caption",
            "defaultMessage": "Due date"
        },
        sprintStartDateCaption: {
            "id": "roadmap.timeline-table-kit.common.dependency.card.sprint-start-date-caption",
            "defaultMessage": "Sprint starts on"
        },
        sprintEndDateCaption: {
            "id": "roadmap.timeline-table-kit.common.dependency.card.sprint-end-date-caption",
            "defaultMessage": "Sprint ends on"
        },
        noStartDateSet: {
            "id": "roadmap.timeline-table-kit.common.dependency.card.no-start-date-set",
            "defaultMessage": "No start date set"
        },
        noDueDateSet: {
            "id": "roadmap.timeline-table-kit.common.dependency.card.no-due-date-set",
            "defaultMessage": "No due date set"
        },
        noSprintAssigned: {
            "id": "roadmap.timeline-table-kit.common.dependency.card.no-sprint-assigned",
            "defaultMessage": "No sprint assigned"
        },
        iconAltTextIssueTermRefresh: {
            "id": "roadmap.timeline-table-kit.common.dependency.card.icon-alt-text-issue-term-refresh",
            "defaultMessage": "{typeName}"
        }
    });
});
parcelRegister("1zbLT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5aa6d183e29dc46d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lF2mK;
    var $fVt6v;
    var $6Ll2T;
    var $3srSR;
    var $ZuPvl;
    var $99gde;
    var $4R6GH;
    var $dCm1o;
    var $gTiLe;
    const $5aa6d183e29dc46d$var$getBackgroundColor = (isOverlapping)=>isOverlapping ? `var(--ds-background-danger-bold, ${0, $72ba03e317f3d228$export$4a7404f376229999})` : `var(--ds-background-neutral-bold, ${0, $72ba03e317f3d228$export$eece5f492e429f08})`;
    const $5aa6d183e29dc46d$var$Separator = ({ label: label, isOverlapping: isOverlapping, isFiltered: isFiltered, unlinkLabel: unlinkLabel, onUnlink: onUnlink })=>(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('visual-refresh_drop_1') ? $5uXOq.createElement((0, (0, parcelRequire("3srSR")).default), {
            xcss: $5aa6d183e29dc46d$var$containerStyles,
            testId: "roadmap.timeline-table-kit.common.ui.dependency.separator"
        }, $5uXOq.createElement((0, (0, parcelRequire("3srSR")).default), {
            xcss: $5aa6d183e29dc46d$var$separatorContainerStyles,
            direction: "column",
            alignItems: "center"
        }, $5uXOq.createElement((0, (0, parcelRequire("6Ll2T")).default), {
            xcss: $5aa6d183e29dc46d$var$lineStyles,
            style: {
                border: `0.5px ${isFiltered ? 'dashed' : 'solid'} ${isOverlapping ? "var(--ds-icon-danger, #C9372C)" : "var(--ds-icon, #44546F)"}`
            }
        }), $5uXOq.createElement((0, (0, parcelRequire("6Ll2T")).default), {
            xcss: $5aa6d183e29dc46d$var$iconWrapperStyles,
            style: {
                backgroundColor: isOverlapping ? "var(--ds-background-accent-red-subtlest, #FFECEB)" : "var(--ds-background-neutral, #091E420F)",
                border: `1px solid ${isOverlapping ? "var(--ds-icon-danger, #C9372C)" : "var(--ds-icon, #44546F)"}`
            }
        }, $5uXOq.createElement((0, ($parcel$interopDefault((0, parcelRequire("lF2mK"))))), {
            label: (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-post-project-a11y-fix') ? '' : label,
            color: isOverlapping ? "var(--ds-icon-danger, #C9372C)" : "var(--ds-icon, #44546F)"
        })), $5uXOq.createElement((0, (0, parcelRequire("6Ll2T")).default), {
            xcss: $5aa6d183e29dc46d$var$lineStyles,
            style: {
                border: `0.5px ${isFiltered ? 'dashed' : 'solid'} ${isOverlapping ? "var(--ds-icon-danger, #C9372C)" : "var(--ds-icon, #44546F)"}`
            }
        })), $5uXOq.createElement((0, (0, parcelRequire("3srSR")).default), {
            xcss: $5aa6d183e29dc46d$var$textContainerStyles,
            alignItems: "center"
        }, $5uXOq.createElement((0, (0, parcelRequire("ZuPvl")).default), {
            size: "UNSAFE_small",
            weight: "semibold"
        }, label)), onUnlink && $5uXOq.createElement((0, (0, parcelRequire("6Ll2T")).default), {
            xcss: $5aa6d183e29dc46d$var$unlinkButtonWrapperStyles
        }, $5uXOq.createElement((0, (0, parcelRequire("gTiLe")).default), {
            onClick: onUnlink,
            ...(0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-post-project-a11y-fix') ? {
                label: unlinkLabel
            } : {}
        }))) : $5uXOq.createElement("div", {
            "data-testid": "roadmap.timeline-table-kit.common.ui.dependency.separator",
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx2vrvc _kqswh2mm"
            ])
        }, $5uXOq.createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx21bp4 _18u0pxbi _2hwxu2gc _4cvr1h6o"
            ])
        }, $5uXOq.createElement("div", {
            style: {
                border: `1px ${isFiltered ? 'dashed' : 'solid'} ${$5aa6d183e29dc46d$var$getBackgroundColor(isOverlapping)}`
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3iutpp"
            ])
        }), $5uXOq.createElement("div", {
            style: {
                backgroundColor: $5aa6d183e29dc46d$var$getBackgroundColor(isOverlapping)
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _1bsbv47k _4t3iv47k _16qs14w9 _2rko1ssb"
            ])
        }, $5uXOq.createElement((0, ($parcel$interopDefault((0, parcelRequire("fVt6v"))))), {
            LEGACY_size: "small",
            label: (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-post-project-a11y-fix') ? '' : label,
            color: `var(--ds-icon-inverse, ${(0, $72ba03e317f3d228$export$29a4f05edc054374)})`
        })), $5uXOq.createElement("div", {
            style: {
                border: `1px ${isFiltered ? 'dashed' : 'solid'} ${$5aa6d183e29dc46d$var$getBackgroundColor(isOverlapping)}`
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3iutpp"
            ])
        })), $5uXOq.createElement((0, (0, parcelRequire("3srSR")).default), {
            xcss: $5aa6d183e29dc46d$var$textContainerStyles,
            alignItems: "center"
        }, $5uXOq.createElement((0, (0, parcelRequire("ZuPvl")).default), {
            size: "UNSAFE_small",
            weight: "semibold"
        }, label)), onUnlink && $5uXOq.createElement("div", {
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _154iutpp _1xi2idpf"
            ])
        }, $5uXOq.createElement((0, (0, parcelRequire("gTiLe")).default), {
            onClick: onUnlink,
            ...(0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-post-project-a11y-fix') ? {
                label: unlinkLabel
            } : {}
        })));
    var $5aa6d183e29dc46d$export$2e2bcd8739ae039 = $5aa6d183e29dc46d$var$Separator;
    const $5aa6d183e29dc46d$var$containerStylesOld = null;
    const $5aa6d183e29dc46d$var$containerStyles = (0, (0, parcelRequire("99gde")).xcss)({
        position: 'relative'
    });
    const $5aa6d183e29dc46d$var$separatorContainerStylesOld = null;
    const $5aa6d183e29dc46d$var$separatorContainerStyles = (0, (0, parcelRequire("99gde")).xcss)({
        marginLeft: 'space.100',
        marginRight: 'space.100'
    });
    const $5aa6d183e29dc46d$var$textContainerStyles = (0, (0, parcelRequire("99gde")).xcss)({
        flexGrow: 1
    });
    const $5aa6d183e29dc46d$var$iconWrapperStylesOld = null;
    const $5aa6d183e29dc46d$var$iconWrapperStyles = (0, (0, parcelRequire("99gde")).xcss)({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '24px',
        height: '24px',
        borderRadius: '50%'
    });
    const $5aa6d183e29dc46d$var$lineStylesOld = null;
    const $5aa6d183e29dc46d$var$lineStyles = (0, (0, parcelRequire("99gde")).xcss)({
        height: '12px'
    });
    const $5aa6d183e29dc46d$var$unlinkButtonWrapperStylesOld = null;
    const $5aa6d183e29dc46d$var$unlinkButtonWrapperStyles = (0, (0, parcelRequire("99gde")).xcss)({
        position: 'absolute',
        top: 'space.150',
        right: 'space.0'
    });
});
parcelRegister("3VmqD", function(module, exports) {
    $parcel$export(module.exports, "OverlayFlyout", ()=>$6e660ffa8986d4aa$export$66ffd5d51c2b84d0);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $dKgvg;
    var $9lczq;
    var $kyahI;
    var $knkJA;
    const $6e660ffa8986d4aa$export$66ffd5d51c2b84d0 = ({ position: position, content: content, testId: testId, onClose: onClose, triggerRef: triggerRef, openFocusRef: openFocusRef })=>{
        const { listenToViewportScroll: listenToViewportScroll, stopListeningToViewportScroll: stopListeningToViewportScroll } = (0, (0, parcelRequire("kyahI")).useViewport)();
        const onCloseInternal = (0, $5uXOq.useCallback)(()=>{
            stopListeningToViewportScroll(onCloseInternal);
            onClose?.();
        }, [
            onClose,
            stopListeningToViewportScroll
        ]);
        const onCloseDialog = (0, $5uXOq.useCallback)(({ event: event })=>{
            if (triggerRef?.current === null || !(triggerRef?.current && event.target instanceof Node && triggerRef?.current.contains(event.target))) {
                onCloseInternal();
                triggerRef?.current?.focus();
            }
        }, [
            onCloseInternal,
            triggerRef
        ]);
        (0, $5uXOq.useEffect)(()=>{
            listenToViewportScroll(onCloseInternal);
            return ()=>{
                stopListeningToViewportScroll(onCloseInternal);
            };
        }, [
            listenToViewportScroll,
            onCloseInternal,
            stopListeningToViewportScroll
        ]);
        (0, $5uXOq.useEffect)(()=>{
            setTimeout(()=>{
                openFocusRef?.current?.focus();
            }, 0);
        }, [
            openFocusRef,
            triggerRef
        ]);
        return $5uXOq.createElement((0, (0, parcelRequire("9lczq")).default), {
            zIndex: (0, (0, parcelRequire("knkJA")).OVERLAY_FLYOUT_Z_INDEX)
        }, $5uXOq.createElement("div", {
            ...testId ? {
                'data-testid': testId
            } : {},
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_ogwtidpf _6tinidpf _1cezidpf _m3zkidpf _hc7q15vq _njtz15vq _bp7o1ceh"
            ])
        }, $5uXOq.createElement((0, (0, parcelRequire("dKgvg")).default), {
            isOpen: true,
            content: content,
            onClose: onCloseDialog
        }, $5uXOq.createElement("div", {
            style: {
                left: position.x,
                top: position.y
            },
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqsw1n9t"
            ])
        }))));
    };
    const $6e660ffa8986d4aa$var$defaultProps = {
        triggerRef: {
            current: null
        },
        openFocusRef: {
            current: null
        }
    };
    $6e660ffa8986d4aa$export$66ffd5d51c2b84d0.defaultProps = $6e660ffa8986d4aa$var$defaultProps;
    const $6e660ffa8986d4aa$var$inlineDialogWrapperStyles = null;
    const $6e660ffa8986d4aa$var$anchorStyles = null;
});
parcelRegister("38z2g", function(module, exports) {
    $parcel$export(module.exports, "createUnlinkHandlerByAppearance", ()=>$d08941b64350fdbd$export$988c496a68d093d3);
    const $d08941b64350fdbd$export$878bf38ae07e22f8 = (fromId, toId, onUnlink, callback)=>(analyticsEvent)=>{
            onUnlink({
                dependency: fromId,
                dependee: toId
            }, analyticsEvent);
            if (callback) callback();
        };
    const $d08941b64350fdbd$export$988c496a68d093d3 = (fromId, toId, appearance, onUnlink, callback)=>appearance === (0, $708c0d50a54aba38$export$920d6feba87a57ed) ? $d08941b64350fdbd$export$878bf38ae07e22f8(toId, fromId, onUnlink, callback) : $d08941b64350fdbd$export$878bf38ae07e22f8(fromId, toId, onUnlink, callback);
});
parcelRegister("dXkNq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$57bb481e1b2a43a8$export$2e2bcd8739ae039);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $6jrGg;
    var $ZuPvl;
    var $6s1PB;
    var $4R6GH;
    var $ousew;
    var $iydoh;
    var $8eBbA;
    const $57bb481e1b2a43a8$var$implicitTitleStylesOld = null;
    const $57bb481e1b2a43a8$var$implicitTitleStyles = null;
    const $57bb481e1b2a43a8$var$ImplicitDependency = ({ parentItem: { itemKey: itemKey, title: title }, implicitDependencyItems: implicitDependencyItems, inwardDependencyDescription: inwardDependencyDescription, outwardDependencyDescription: outwardDependencyDescription, ...otherProps })=>{
        const incoming = implicitDependencyItems.filter(({ dependencies: dependencies })=>dependencies.length > 0);
        const outgoing = implicitDependencyItems.filter(({ dependees: dependees })=>dependees.length > 0);
        if (incoming.length === 0 && outgoing.length === 0) return null;
        const renderDependencyItems = (items, appearance, messageDescriptorSingular, messageDescriptorPlural, description)=>{
            if (!items.length) return null;
            const messageDescriptor = items.length === 1 ? messageDescriptorSingular : messageDescriptorPlural;
            const dependencyItemsKey = appearance === (0, $708c0d50a54aba38$export$920d6feba87a57ed) ? 'dependencies' : 'dependees';
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-post-project-a11y-fix') ? (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: (0, (0, parcelRequire("bwpsq")).default)([
                    "_18s8h2s3"
                ])
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6jrGg")).default), {
                as: "h2",
                size: "xsmall"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ZuPvl")).default), {
                weight: "regular"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                ...messageDescriptor,
                values: {
                    count: items.length,
                    itemKey: itemKey,
                    title: title,
                    b: (chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement("b", null, chunks)
                }
            })))) : (0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                className: (0, (0, parcelRequire("bwpsq")).default)([
                    "_18s81rf7 _1hk5idpf"
                ])
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ousew")).default), {
                ...messageDescriptor,
                values: {
                    count: items.length,
                    itemKey: itemKey,
                    title: title,
                    b: (chunks)=>(0, ($parcel$interopDefault($5uXOq))).createElement("b", null, chunks)
                }
            })), items.map(({ item: item, ...rest })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iydoh")).default), {
                    key: item.id,
                    appearance: appearance,
                    ...otherProps,
                    item: item,
                    dependencyItems: rest[dependencyItemsKey],
                    description: description
                })));
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, renderDependencyItems(incoming, (0, $708c0d50a54aba38$export$920d6feba87a57ed), (0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("8eBbA")).default).singleIncomingDependencyIssueTermRefresh : (0, (0, parcelRequire("8eBbA")).default).singleIncomingDependency, (0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("8eBbA")).default).incomingDependenciesIssueTermRefresh : (0, (0, parcelRequire("8eBbA")).default).incomingDependencies, inwardDependencyDescription), renderDependencyItems(outgoing, (0, $708c0d50a54aba38$export$2c998d8d93f14e97), (0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("8eBbA")).default).singleOutgoingDependencyIssueTermRefresh : (0, (0, parcelRequire("8eBbA")).default).singleOutgoingDependency, (0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("8eBbA")).default).outgoingDependenciesIssueTermRefresh : (0, (0, parcelRequire("8eBbA")).default).outgoingDependencies, outwardDependencyDescription));
    };
    var $57bb481e1b2a43a8$export$2e2bcd8739ae039 = $57bb481e1b2a43a8$var$ImplicitDependency;
});
parcelRegister("iydoh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c80f25b89b39d849$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $9jNMw;
    var $2APCZ;
    var $h8Wzd;
    var $4LJds;
    var $4R6GH;
    var $koVbs;
    var $8zOmE;
    var $5VKn0;
    var $38z2g;
    var $aZ1lM;
    var $1zbLT;
    var $7vKBH;
    const $c80f25b89b39d849$var$ExpandableCard = ({ dependencyItems: dependencyItems, item: item, description: description, appearance: appearance, onUnlink: onUnlink, onClose: onClose, isExpanded: isExpanded = false })=>{
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(isExpanded);
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const Chevron = isOpen ? (0, ($parcel$interopDefault((0, parcelRequire("4LJds"))))) : (0, ($parcel$interopDefault((0, parcelRequire("h8Wzd")))));
        const hasFilteredItems = dependencyItems.some((dependencyItem)=>dependencyItem.isHidden);
        const onToggleExpand = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
            const toggleOn = !isOpen;
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'expandDependencySummaryButton', {
                toggle: toggleOn
            });
            setIsOpen(toggleOn);
        }, [
            isOpen
        ]);
        const isItemDatesOverlap = (startDate, dueDate)=>appearance === (0, $708c0d50a54aba38$export$920d6feba87a57ed) ? (0, (0, parcelRequire("5VKn0")).isDependencyDatesOverlapping)(startDate, dueDate, item.startDate, item.dueDate) : (0, (0, parcelRequire("5VKn0")).isDependencyDatesOverlapping)(item.startDate, item.dueDate, startDate, dueDate);
        const hasOverlapDate = dependencyItems.some((dependencyItem)=>isItemDatesOverlap(dependencyItem.startDate, dependencyItem.dueDate));
        return (0, ($parcel$interopDefault($5uXOq))).createElement($c80f25b89b39d849$var$DependencyDetailContainer, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aZ1lM")).default), {
            appearance: appearance,
            ...item
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($c80f25b89b39d849$var$ExpandButton, null, (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-post-project-a11y-fix') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9jNMw")).default), {
            icon: Chevron,
            spacing: "compact",
            appearance: "subtle",
            testId: "roadmap.timeline-table-kit.common.ui.dependency.expandable-card.button",
            onClick: onToggleExpand,
            label: `${item.itemKey} ${item.title}`,
            "aria-expanded": isOpen,
            ...(0, (0, parcelRequire("4R6GH")).fg)('platform_button_item-add-ufo-metrics') ? {
                interactionName: 'timeline-dependency-expandable-card-expand-clicked'
            } : {}
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2APCZ")).default), {
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement(Chevron, {
                color: `var(--ds-icon, ${(0, $72ba03e317f3d228$export$e2ef2124cf4024b1)})`,
                label: ""
            }),
            spacing: "compact",
            appearance: "subtle",
            testId: "roadmap.timeline-table-kit.common.ui.dependency.expandable-card.button",
            onClick: onToggleExpand,
            "aria-label": formatMessage((0, (0, parcelRequire("7vKBH")).default).expand)
        })), isOpen && (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1zbLT")).default), {
            label: description,
            ...(0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-post-project-a11y-fix') ? {
                unlinkLabel: dependencyItems.length === 1 ? `${item.itemKey} ${item.title} ${description} ${dependencyItems[0].itemKey} ${dependencyItems[0].title}` : undefined
            } : {},
            isOverlapping: hasOverlapDate,
            isFiltered: hasFilteredItems,
            ...onUnlink && dependencyItems.length === 1 ? {
                onUnlink: (0, (0, parcelRequire("38z2g")).createUnlinkHandlerByAppearance)(item.id, dependencyItems[0].id, appearance, onUnlink, dependencyItems.length ? undefined : onClose)
            } : undefined
        }), dependencyItems.map((dependencyItem)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aZ1lM")).default), {
                key: dependencyItem.id,
                ...(0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-post-project-a11y-fix') ? {
                    unlinkLabel: `${item.itemKey} ${item.title} ${description} ${dependencyItem.itemKey} ${dependencyItem.title}`
                } : {},
                appearance: appearance === (0, $708c0d50a54aba38$export$920d6feba87a57ed) ? (0, $708c0d50a54aba38$export$2c998d8d93f14e97) : (0, $708c0d50a54aba38$export$920d6feba87a57ed),
                ...dependencyItem,
                isOverlapping: isItemDatesOverlap(dependencyItem.startDate, dependencyItem.dueDate),
                ...onUnlink && dependencyItems.length > 1 ? {
                    onUnlink: (0, (0, parcelRequire("38z2g")).createUnlinkHandlerByAppearance)(item.id, dependencyItem.id, appearance, onUnlink)
                } : undefined
            }))));
    };
    var $c80f25b89b39d849$export$2e2bcd8739ae039 = $c80f25b89b39d849$var$ExpandableCard;
    const $c80f25b89b39d849$var$DependencyDetailContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm _19pku2gc _otyru2gc",
                __cmplp.className
            ])
        });
    });
    const $c80f25b89b39d849$var$ExpandButton = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1ule _kqswstnw _154iidpf _1xi2ukr8 _1bsb1tcg",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("4LJds", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $378ea026f3c5d6b1$var$_react = $378ea026f3c5d6b1$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $378ea026f3c5d6b1$var$_chevronUp = $378ea026f3c5d6b1$var$_interopRequireDefault((parcelRequire("jx8BF")));
    var $378ea026f3c5d6b1$var$_chevronUp2 = $378ea026f3c5d6b1$var$_interopRequireDefault((parcelRequire("alDmu")));
    function $378ea026f3c5d6b1$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $378ea026f3c5d6b1$var$ChevronUpIcon = (props)=>$378ea026f3c5d6b1$var$_react.default.createElement($378ea026f3c5d6b1$var$_chevronUp.default, Object.assign({
            LEGACY_fallbackIcon: $378ea026f3c5d6b1$var$_chevronUp2.default
        }, props));
    $378ea026f3c5d6b1$var$ChevronUpIcon.Name = 'ChevronUpIconMigration';
    var $378ea026f3c5d6b1$var$_default = module.exports.default = $378ea026f3c5d6b1$var$ChevronUpIcon;
});
parcelRegister("alDmu", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $788a65f61eb9d469$var$_react = $788a65f61eb9d469$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $7p1ve;
    var $788a65f61eb9d469$var$_chevronUp = $788a65f61eb9d469$var$_interopRequireDefault((parcelRequire("jx8BF")));
    function $788a65f61eb9d469$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $788a65f61eb9d469$var$ChevronUpIcon = (props)=>$788a65f61eb9d469$var$_react.default.createElement((0, parcelRequire("7p1ve")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m11.221 9.322-2.929 2.955a1.01 1.01 0 0 0 0 1.419.986.986 0 0 0 1.405 0l2.298-2.317 2.307 2.327a.99.99 0 0 0 1.407 0 1.01 1.01 0 0 0 0-1.419l-2.94-2.965A1.1 1.1 0 0 0 11.991 9c-.279 0-.557.107-.77.322"/></svg>`
        }, props, {
            newIcon: $788a65f61eb9d469$var$_chevronUp.default,
            iconType: "utility"
        }));
    $788a65f61eb9d469$var$ChevronUpIcon.displayName = 'ChevronUpIcon';
    var $788a65f61eb9d469$var$_default = module.exports.default = $788a65f61eb9d469$var$ChevronUpIcon;
});
parcelRegister("7vKBH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f3ff9867569beade$export$2e2bcd8739ae039);
    var $7VHMR;
    var $f3ff9867569beade$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        expand: {
            "id": "roadmap.timeline-table-kit.common.dependency.expandable-card.expand",
            "defaultMessage": "Expand"
        }
    });
});
parcelRegister("8eBbA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9770b8769efeca60$export$2e2bcd8739ae039);
    var $7VHMR;
    var $9770b8769efeca60$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        incomingDependencies: {
            "id": "roadmap.timeline-table-kit.chart-timeline-overlay.dependency-flyout.implicit-dependencies.incoming-dependencies",
            "defaultMessage": "{count} child {count, plural, one {issue} other {issues}} of <b>{itemKey} {title}</b> have incoming dependencies"
        },
        singleIncomingDependency: {
            "id": "roadmap.timeline-table-kit.chart-timeline-overlay.dependency-flyout.implicit-dependencies.single-incoming-dependency",
            "defaultMessage": "{count} child {count, plural, one {issue} other {issues}} of <b>{itemKey} {title}</b> has an incoming dependency"
        },
        outgoingDependencies: {
            "id": "roadmap.timeline-table-kit.chart-timeline-overlay.dependency-flyout.implicit-dependencies.outgoing-dependencies",
            "defaultMessage": "{count} child {count, plural, one {issue} other {issues}} of <b>{itemKey} {title}</b> have outgoing dependencies"
        },
        singleOutgoingDependency: {
            "id": "roadmap.timeline-table-kit.chart-timeline-overlay.dependency-flyout.implicit-dependencies.single-outgoing-dependency",
            "defaultMessage": "{count} child {count, plural, one {issue} other {issues}} of <b>{itemKey} {title}</b> has an outgoing dependency"
        },
        incomingDependenciesIssueTermRefresh: {
            "id": "roadmap.timeline-table-kit.chart-timeline-overlay.dependency-flyout.implicit-dependencies.incoming-dependencies-issue-term-refresh",
            "defaultMessage": "{count} child {count, plural, one {work item} other {work items}} of <b>{itemKey} {title}</b> have incoming dependencies"
        },
        singleIncomingDependencyIssueTermRefresh: {
            "id": "roadmap.timeline-table-kit.chart-timeline-overlay.dependency-flyout.implicit-dependencies.single-incoming-dependency-issue-term-refresh",
            "defaultMessage": "{count} child {count, plural, one {work item} other {work items}} of <b>{itemKey} {title}</b> has an incoming dependency"
        },
        outgoingDependenciesIssueTermRefresh: {
            "id": "roadmap.timeline-table-kit.chart-timeline-overlay.dependency-flyout.implicit-dependencies.outgoing-dependencies-issue-term-refresh",
            "defaultMessage": "{count} child {count, plural, one {work item} other {work items}} of <b>{itemKey} {title}</b> have outgoing dependencies"
        },
        singleOutgoingDependencyIssueTermRefresh: {
            "id": "roadmap.timeline-table-kit.chart-timeline-overlay.dependency-flyout.implicit-dependencies.single-outgoing-dependency-issue-term-refresh",
            "defaultMessage": "{count} child {count, plural, one {work item} other {work items}} of <b>{itemKey} {title}</b> has an outgoing dependency"
        }
    });
});
parcelRegister("hCsOd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$36e267f13e0e3418$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $36e267f13e0e3418$var$Line = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($36e267f13e0e3418$var$Container, null, (0, ($parcel$interopDefault($5uXOq))).createElement($36e267f13e0e3418$var$FlyoutLine, null));
    var $36e267f13e0e3418$export$2e2bcd8739ae039 = $36e267f13e0e3418$var$Line;
    const $36e267f13e0e3418$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1yt4pxbi",
                __cmplp.className
            ])
        });
    });
    const $36e267f13e0e3418$var$FlyoutLine = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _vchhusvi _4t3it94y _1bsb1osq _189et94y _1dqonqa1 _1h6db5v6",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("8nXAF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$12cf947f04ff2fdd$export$2e2bcd8739ae039);
    var $7VHMR;
    var $12cf947f04ff2fdd$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        blockedBy: {
            "id": "roadmap.timeline-table-kit.chart-timeline-overlay.dependency-flyout.blocked-by",
            "defaultMessage": "blocked by"
        },
        blocks: {
            "id": "roadmap.timeline-table-kit.chart-timeline-overlay.dependency-flyout.blocks",
            "defaultMessage": "blocks"
        },
        dependencyOf: {
            "id": "roadmap.timeline-table-kit.chart-timeline-overlay.dependency-flyout.dependency-of",
            "defaultMessage": "Dependency of <b>{itemKey} {title}</b>"
        },
        datesOverlapWarning: {
            "id": "roadmap.timeline-table-kit.chart-timeline-overlay.dependency-flyout.dates-overlap-warning",
            "defaultMessage": "Dates overlap"
        },
        warningsText: {
            "id": "roadmap.timeline-table-kit.chart-timeline-overlay.dependency-flyout.warnings-text",
            "defaultMessage": "Warnings"
        },
        issueWithStartDateLabel: {
            "id": "roadmap.timeline-table-kit.chart-timeline-overlay.dependency-flyout.issue-with-start-date-label",
            "defaultMessage": "{issueType} {issueTitle} starts on {issueDate}"
        },
        issueWithDueDateLabel: {
            "id": "roadmap.timeline-table-kit.chart-timeline-overlay.dependency-flyout.issue-with-due-date-label",
            "defaultMessage": "{issueType} {issueTitle} ends on {issueDate}"
        }
    });
});
parcelRegister("efoCi", function(module, exports) {
    $parcel$export(module.exports, "useDependencyFlyoutLabel", ()=>$6808357e4bb26ff2$export$2e692aada5726b0b);
    $parcel$export(module.exports, "useImplicitDependencyLabel", ()=>$6808357e4bb26ff2$export$a5a3f8f25ab8bef3);
    var $koVbs;
    var $g11uZ;
    var $5VKn0;
    var $8eBbA;
    var $8nXAF;
    const $6808357e4bb26ff2$export$2e692aada5726b0b = (item, deps, issueAppearance, dependencyType)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        if (!deps.length) return '';
        const createIssueLabelDesc = (typeName, title, startDate, dueDate, appearance, isOverlapping, warningMessages)=>{
            const startDateIssueLabel = formatMessage((0, (0, parcelRequire("8nXAF")).default).issueWithStartDateLabel, {
                issueType: typeName,
                issueTitle: title,
                issueDate: startDate !== undefined ? (0, (0, parcelRequire("g11uZ")).getDateFromTimestamp)(startDate) : undefined
            });
            const dudeDateIssueLabel = formatMessage((0, (0, parcelRequire("8nXAF")).default).issueWithDueDateLabel, {
                issueType: typeName,
                issueTitle: title,
                issueDate: dueDate !== undefined ? (0, (0, parcelRequire("g11uZ")).getDateFromTimestamp)(dueDate) : undefined
            });
            const issueLabel = appearance === (0, $708c0d50a54aba38$export$920d6feba87a57ed) ? startDateIssueLabel : dudeDateIssueLabel;
            const warnings = warningMessages?.length ? warningMessages.map((message)=>formatMessage(message)).join(', ') : '';
            const overlapWarning = isOverlapping ? formatMessage((0, (0, parcelRequire("8nXAF")).default).datesOverlapWarning) : '';
            const result = isOverlapping || warnings ? `${issueLabel} ${formatMessage((0, (0, parcelRequire("8nXAF")).default).warningsText)}: ${overlapWarning} ${warnings}` : issueLabel;
            return result;
        };
        const itemLabel = createIssueLabelDesc(item.typeName, item.title, item.startDate, item.dueDate, issueAppearance);
        const depsLabels = deps.map((dep)=>{
            const isOverlapping = issueAppearance === (0, $708c0d50a54aba38$export$920d6feba87a57ed) ? (0, (0, parcelRequire("5VKn0")).isDependencyDatesOverlapping)(dep.startDate, dep.dueDate, item.startDate, item.dueDate) : (0, (0, parcelRequire("5VKn0")).isDependencyDatesOverlapping)(item.startDate, item.dueDate, dep.startDate, dep.dueDate);
            return createIssueLabelDesc(dep.typeName, dep.title, dep.startDate, dep.dueDate, issueAppearance === (0, $708c0d50a54aba38$export$920d6feba87a57ed) ? (0, $708c0d50a54aba38$export$2c998d8d93f14e97) : (0, $708c0d50a54aba38$export$920d6feba87a57ed), isOverlapping, dep.warningMessages);
        }).join(' ');
        const labelDesc = `${itemLabel} ${dependencyType}: ${depsLabels}`;
        return labelDesc;
    };
    const $6808357e4bb26ff2$export$a5a3f8f25ab8bef3 = (itemKey, title, implicitDependencyItems)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { incoming: incoming, outgoing: outgoing } = implicitDependencyItems.reduce((acc, item)=>{
            if (item.dependencies.length > 0) acc.incoming.push(item);
            if (item.dependees.length > 0) acc.outgoing.push(item);
            return acc;
        }, {
            incoming: [],
            outgoing: []
        });
        if (incoming.length === 0 && outgoing.length === 0) return '';
        const dependencyItemsLabel = (items, messageDescriptorSingular, messageDescriptorPlural)=>{
            if (!items.length) return '';
            const messageDescriptor = items.length === 1 ? messageDescriptorSingular : messageDescriptorPlural;
            return formatMessage({
                ...messageDescriptor
            }, {
                count: items.length,
                itemKey: itemKey,
                title: title,
                b: (chunks)=>chunks
            });
        };
        const incomingLabel = dependencyItemsLabel(incoming, (0, (0, parcelRequire("8eBbA")).default).singleIncomingDependency, (0, (0, parcelRequire("8eBbA")).default).incomingDependencies);
        const outgoingLabel = dependencyItemsLabel(outgoing, (0, (0, parcelRequire("8eBbA")).default).singleOutgoingDependency, (0, (0, parcelRequire("8eBbA")).default).outgoingDependencies);
        return `${incomingLabel}\n${outgoingLabel}`;
    };
});
parcelRegister("1vbpx", function(module, exports) {
    $parcel$export(module.exports, "getOverlayIssueItem", ()=>$0bcf471c9e24bafb$export$8dc7a148cdc283f7);
    $parcel$export(module.exports, "getIssueFromMap", ()=>$0bcf471c9e24bafb$export$8cf9d303c3d4d4bb);
    $parcel$export(module.exports, "getDepsItem", ()=>$0bcf471c9e24bafb$export$a6f1c27790748d15);
    var $esmwW;
    const $0bcf471c9e24bafb$export$8dc7a148cdc283f7 = (issue)=>issue && {
            id: issue.issueId,
            itemKey: issue.key,
            title: issue.summary || '',
            typeName: issue.issueType.name,
            iconUrl: issue.issueType.iconUrl,
            startDateType: (0, (0, parcelRequire("esmwW")).EXPLICIT),
            startDate: issue.startDate,
            dueDateType: (0, (0, parcelRequire("esmwW")).EXPLICIT),
            dueDate: issue.dueDate,
            isHidden: false,
            intervalName: undefined,
            warningMessages: []
        };
    const $0bcf471c9e24bafb$export$8cf9d303c3d4d4bb = (issueId, issuesMap)=>issuesMap.get(issueId) || issuesMap.get(`${issueId}`);
    const $0bcf471c9e24bafb$export$a6f1c27790748d15 = ({ issuesMap: issuesMap, issueIds: issueIds })=>issueIds.map((issueId)=>$0bcf471c9e24bafb$export$8dc7a148cdc283f7($0bcf471c9e24bafb$export$8cf9d303c3d4d4bb(Number(issueId), issuesMap))).filter(Boolean);
});
parcelRegister("fguIv", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$41bf71be4da6fc42$export$2e2bcd8739ae039);
    var $7VHMR;
    var $41bf71be4da6fc42$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        removeDependencyErrorTitle: {
            "id": "business-timeline.timeline-view.chart-timeline-overlay.remove-dependency-error-title",
            "defaultMessage": "We couldn't unlink items"
        },
        removeDependencyErrorMessage: {
            "id": "business-timeline.timeline-view.chart-timeline-overlay.remove-dependency-error-message",
            "defaultMessage": "Check your connection, then give it another try."
        },
        removeDependencyDynamicErrorMessage: {
            "id": "business-timeline.timeline-view.chart-timeline-overlay.remove-dependency-dynamic-error-message",
            "defaultMessage": "{error}"
        }
    });
});
parcelRegister("1AOMQ", function(module, exports) {
    $parcel$export(module.exports, "transformDependencies", ()=>$f5aabd4e2b5977f1$export$afd306a2b7dc4cc1);
    $parcel$export(module.exports, "getSelectedDependency", ()=>$f5aabd4e2b5977f1$export$aff715abe5e6e33c);
    var $8QpSo;
    const $f5aabd4e2b5977f1$export$afd306a2b7dc4cc1 = (0, (0, parcelRequire("8QpSo")).default)((dependencies)=>dependencies.map(({ from: from, to: to, itemHeight: itemHeight })=>({
                itemHeight: itemHeight,
                from: from,
                to: to
            })));
    const $f5aabd4e2b5977f1$export$aff715abe5e6e33c = (0, (0, parcelRequire("8QpSo")).default)((issueId, dependees)=>({
            fromId: issueId,
            toId: dependees[0]
        }));
});
parcelRegister("8LDjp", function(module, exports) {
    $parcel$export(module.exports, "marshalOptions", ()=>$26ae571d3fe8160f$export$57eb6ddea50ecba1);
    const $26ae571d3fe8160f$var$dependenciesOverlayHiddenStyles = `
    opacity: 0;
`;
    const $26ae571d3fe8160f$var$dependencyLinesHiddenStyles = `
    pointer-events: none;
`;
    const $26ae571d3fe8160f$var$dependenciesDropTargetStyles = `
    pointer-events: all;
`;
    const $26ae571d3fe8160f$var$onRowDragStart = ({ styleAPI: styleAPI })=>{
        styleAPI.insertStyle((0, $0afb8a62e53619f1$export$1e54f8b472a07d8d), $26ae571d3fe8160f$var$dependenciesOverlayHiddenStyles);
        styleAPI.insertStyle((0, $0afb8a62e53619f1$export$cd944e09ecad5145), $26ae571d3fe8160f$var$dependencyLinesHiddenStyles);
    };
    const $26ae571d3fe8160f$var$onRowDragEnd = ({ styleAPI: styleAPI })=>{
        styleAPI.removeStyle((0, $0afb8a62e53619f1$export$1e54f8b472a07d8d));
        styleAPI.removeStyle((0, $0afb8a62e53619f1$export$cd944e09ecad5145));
    };
    const $26ae571d3fe8160f$var$onDependencyDragStart = ({ styleAPI: styleAPI })=>{
        styleAPI.insertStyle((0, $708c0d50a54aba38$export$c330e9be73819573), $26ae571d3fe8160f$var$dependenciesDropTargetStyles);
    };
    const $26ae571d3fe8160f$var$onDependencyDragEnd = ({ styleAPI: styleAPI })=>{
        styleAPI.removeStyle((0, $708c0d50a54aba38$export$c330e9be73819573));
    };
    const $26ae571d3fe8160f$var$onBarInteractionStart = ({ styleAPI: styleAPI })=>{
        styleAPI.insertStyle((0, $0afb8a62e53619f1$export$1e54f8b472a07d8d), $26ae571d3fe8160f$var$dependenciesOverlayHiddenStyles);
        styleAPI.insertStyle((0, $0afb8a62e53619f1$export$cd944e09ecad5145), $26ae571d3fe8160f$var$dependencyLinesHiddenStyles);
    };
    const $26ae571d3fe8160f$var$onBarInteractionEnd = ({ styleAPI: styleAPI })=>{
        styleAPI.removeStyle((0, $0afb8a62e53619f1$export$1e54f8b472a07d8d));
        styleAPI.removeStyle((0, $0afb8a62e53619f1$export$cd944e09ecad5145));
    };
    const $26ae571d3fe8160f$export$57eb6ddea50ecba1 = {
        customActions: {
            onDependencyDragStart: $26ae571d3fe8160f$var$onDependencyDragStart,
            onDependencyDragEnd: $26ae571d3fe8160f$var$onDependencyDragEnd,
            onBarInteractionStart: $26ae571d3fe8160f$var$onBarInteractionStart,
            onBarInteractionEnd: $26ae571d3fe8160f$var$onBarInteractionEnd
        },
        overrideActions: {
            onRowDragStart: $26ae571d3fe8160f$var$onRowDragStart,
            onRowDragEnd: $26ae571d3fe8160f$var$onRowDragEnd
        }
    };
});
parcelRegister("hB1Xb", function(module, exports) {
    $parcel$export(module.exports, "Export", ()=>$381ebedccbd8cea6$export$f883e605db67eacf);
    var $5uXOq = parcelRequire("5uXOq");
    var $cm8b5;
    var $93jKl;
    var $kaHBi;
    var $3bQtK;
    var $8zOmE;
    var $lwMsT;
    var $2WFZU;
    var $d38Sb;
    var $gNAqw;
    var $rfnJx;
    const $381ebedccbd8cea6$export$f883e605db67eacf = ({ csvProps: csvProps, tableProps: tableProps })=>{
        const [open, setOpen] = (0, $5uXOq.useState)(false);
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const onCsvFail = (0, (0, parcelRequire("93jKl")).useExperienceFail)((0, (0, parcelRequire("gNAqw")).EXPORT_CSV_EXPERIENCE));
        const onCsvSuccess = (0, (0, parcelRequire("3bQtK")).useExperienceSuccess)((0, (0, parcelRequire("gNAqw")).EXPORT_CSV_EXPERIENCE));
        const onCsvStart = (0, (0, parcelRequire("kaHBi")).useExperienceStart)({
            ...(0, (0, parcelRequire("gNAqw")).EXPORT_CSV_EXPERIENCE),
            analyticsSource: 'timeline'
        });
        const exportButton = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("d38Sb")).ExportButton), {
            onExportCsv: ()=>{
                if (csvProps) {
                    onCsvStart();
                    try {
                        (0, (0, parcelRequire("2WFZU")).onGenerateCsv)(csvProps);
                        onCsvSuccess();
                        (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'csv exported');
                    } catch (error) {
                        onCsvFail((0, (0, parcelRequire("gNAqw")).EXPORT_CSV_EXPERIENCE).experience, error);
                    }
                }
            },
            onExportAsImageClick: ()=>setOpen(true),
            isThemedButton: true
        });
        const onOpenChange = (isOpen)=>{
            setOpen(isOpen);
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cm8b5")).ExperienceErrorBoundary), {
            experience: (0, (0, parcelRequire("gNAqw")).EXPORT_IMAGE_EXPERIENCE)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("rfnJx")).ExportImageModal), {
            open: open,
            onOpenChange: onOpenChange,
            tableProps: tableProps
        }), exportButton);
    };
});
parcelRegister("2WFZU", function(module, exports) {
    $parcel$export(module.exports, "onGenerateCsv", ()=>$722a9f49589bb970$export$e8a9be234322a768);
    parcelRequire("fp4O3");
    parcelRequire("fPS7b");
    parcelRequire("6hSeW");
    var $jpUKq = parcelRequire("jpUKq");
    var $2gnC5 = parcelRequire("2gnC5");
    var $kVLXA = parcelRequire("kVLXA");
    var $930Ym;
    const $722a9f49589bb970$var$BASE_LEVEL_PARENT = '[NO_PARENT]';
    const $722a9f49589bb970$var$generatePartialCsv = (columnTransformers, context, parentId)=>{
        const { chartDataHash: chartDataHash, issuesByParent: issuesByParent } = context;
        let csv = '';
        (issuesByParent[parentId] ?? []).forEach(({ issueId: issueId, issue: issue })=>{
            const chartData = chartDataHash?.[issueId];
            csv += `${columnTransformers.map((column)=>column.transform({
                    issueId: issueId,
                    issue: issue,
                    chartData: chartData
                }, context)).join(',')}\r\n`;
            csv += $722a9f49589bb970$var$generatePartialCsv(columnTransformers, context, issueId);
        });
        return csv;
    };
    const $722a9f49589bb970$export$d4b63bab9e1886d8 = (columnTransformers, context)=>`${columnTransformers.map((column)=>(0, (0, parcelRequire("930Ym")).escapeValue)(context.issueFields[column.fieldId ?? ''] ?? column.fieldId)).join(',')}\r\n`;
    const $722a9f49589bb970$export$bf12c6f7f076b36f = (columnTransformers, context)=>{
        let csv = '';
        csv += $722a9f49589bb970$export$d4b63bab9e1886d8(columnTransformers, context);
        csv += $722a9f49589bb970$var$generatePartialCsv(columnTransformers, context, $722a9f49589bb970$var$BASE_LEVEL_PARENT);
        const safeFileName = context.projectName.replace(/[^a-z0-9]/gi, '_').toLowerCase();
        const dateNow = (0, ($parcel$interopDefault($2gnC5)))().format('YYYY-MM-DD_hh.mma');
        const blob = new Blob([
            csv
        ], {
            type: 'text/plain;charset=utf-8'
        });
        (0, $jpUKq.saveAs)(blob, `${safeFileName}_${dateNow}.csv`);
    };
    const $722a9f49589bb970$export$e8a9be234322a768 = ({ issueIds: issueIds, issuesHash: issuesHash, userDisplayNameHash: userDisplayNameHash, issueTypesHash: issueTypesHash, startDateCustomFieldId: startDateCustomFieldId, colorCustomFieldId: colorCustomFieldId, sprintCustomFieldId: sprintCustomFieldId, issueFields: issueFields, issueSprintsHash: issueSprintsHash, chartDataHash: chartDataHash, projectName: projectName, isSprintsFeatureEnabled: isSprintsFeatureEnabled = false, hasInferredStartDueDateFields: hasInferredStartDueDateFields = true })=>{
        if (issueIds.length === 0) return (0, $kVLXA.Observable).empty();
        const issuesByParent = {
            BASE_LEVEL_PARENT: []
        };
        issueIds.forEach((issueId)=>{
            const issue = issuesHash[issueId];
            const parentId = issue.parentId?.value ?? $722a9f49589bb970$var$BASE_LEVEL_PARENT;
            const issueList = issuesByParent[parentId] ?? [];
            issueList.push({
                issueId: issueId,
                issue: issue
            });
            issuesByParent[parentId] = issueList;
        });
        const customFields = {
            startDateCustomFieldId: startDateCustomFieldId,
            colorCustomFieldId: colorCustomFieldId,
            sprintCustomFieldId: sprintCustomFieldId,
            isSprintsFeatureEnabled: isSprintsFeatureEnabled,
            hasInferredStartDueDateFields: hasInferredStartDueDateFields
        };
        const columnTransformers = (0, (0, parcelRequire("930Ym")).getColumnTransformers)(customFields);
        const transformationContext = {
            issueIds: issueIds,
            issuesByParent: issuesByParent,
            issuesHash: issuesHash,
            userDisplayNameHash: userDisplayNameHash,
            issueTypesHash: issueTypesHash,
            issueFields: issueFields,
            issueSprintsHash: issueSprintsHash,
            customFields: customFields,
            chartDataHash: chartDataHash,
            projectName: projectName
        };
        $722a9f49589bb970$export$bf12c6f7f076b36f(columnTransformers, transformationContext);
    };
});
parcelRegister("jpUKq", function(module, exports) {
    var $e22c5f112f49df3f$var$saveAs = $e22c5f112f49df3f$var$saveAs || function(view) {
        "use strict";
        if (typeof view === "undefined" || typeof navigator !== "undefined" && /MSIE [1-9]\./.test(navigator.userAgent)) return;
        var doc = view.document, get_URL = function() {
            return view.URL || view.webkitURL || view;
        }, save_link = doc.createElementNS("http://www.w3.org/1999/xhtml", "a"), can_use_save_link = "download" in save_link, click = function(node) {
            var event = new MouseEvent("click");
            node.dispatchEvent(event);
        }, is_safari = /constructor/i.test(view.HTMLElement) || view.safari, is_chrome_ios = /CriOS\/[\d]+/.test(navigator.userAgent), throw_outside = function(ex) {
            (view.setImmediate || view.setTimeout)(function() {
                throw ex;
            }, 0);
        }, force_saveable_type = "application/octet-stream", arbitrary_revoke_timeout = 40000, revoke = function(file) {
            var revoker = function() {
                if (typeof file === "string") get_URL().revokeObjectURL(file);
                else file.remove();
            };
            setTimeout(revoker, arbitrary_revoke_timeout);
        }, dispatch = function(filesaver, event_types, event) {
            event_types = [].concat(event_types);
            var i = event_types.length;
            while(i--){
                var listener = filesaver["on" + event_types[i]];
                if (typeof listener === "function") try {
                    listener.call(filesaver, event || filesaver);
                } catch (ex) {
                    throw_outside(ex);
                }
            }
        }, auto_bom = function(blob) {
            if (/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(blob.type)) return new Blob([
                String.fromCharCode(0xFEFF),
                blob
            ], {
                type: blob.type
            });
            return blob;
        }, FileSaver = function(blob, name, no_auto_bom) {
            if (!no_auto_bom) blob = auto_bom(blob);
            var filesaver = this, type = blob.type, force = type === force_saveable_type, object_url, dispatch_all = function() {
                dispatch(filesaver, "writestart progress write writeend".split(" "));
            }, fs_error = function() {
                if ((is_chrome_ios || force && is_safari) && view.FileReader) {
                    var reader = new FileReader();
                    reader.onloadend = function() {
                        var url = is_chrome_ios ? reader.result : reader.result.replace(/^data:[^;]*;/, 'data:attachment/file;');
                        var popup = view.open(url, '_blank');
                        if (!popup) view.location.href = url;
                        url = undefined;
                        filesaver.readyState = filesaver.DONE;
                        dispatch_all();
                    };
                    reader.readAsDataURL(blob);
                    filesaver.readyState = filesaver.INIT;
                    return;
                }
                if (!object_url) object_url = get_URL().createObjectURL(blob);
                if (force) view.location.href = object_url;
                else {
                    var opened = view.open(object_url, "_blank");
                    if (!opened) view.location.href = object_url;
                }
                filesaver.readyState = filesaver.DONE;
                dispatch_all();
                revoke(object_url);
            };
            filesaver.readyState = filesaver.INIT;
            if (can_use_save_link) {
                object_url = get_URL().createObjectURL(blob);
                setTimeout(function() {
                    save_link.href = object_url;
                    save_link.download = name;
                    click(save_link);
                    dispatch_all();
                    revoke(object_url);
                    filesaver.readyState = filesaver.DONE;
                });
                return;
            }
            fs_error();
        }, FS_proto = FileSaver.prototype, saveAs = function(blob, name, no_auto_bom) {
            return new FileSaver(blob, name || blob.name || "download", no_auto_bom);
        };
        if (typeof navigator !== "undefined" && navigator.msSaveOrOpenBlob) return function(blob, name, no_auto_bom) {
            name = name || blob.name || "download";
            if (!no_auto_bom) blob = auto_bom(blob);
            return navigator.msSaveOrOpenBlob(blob, name);
        };
        FS_proto.abort = function() {};
        FS_proto.readyState = FS_proto.INIT = 0;
        FS_proto.WRITING = 1;
        FS_proto.DONE = 2;
        FS_proto.error = FS_proto.onwritestart = FS_proto.onprogress = FS_proto.onwrite = FS_proto.onabort = FS_proto.onerror = FS_proto.onwriteend = null;
        return saveAs;
    }(typeof self !== "undefined" && self || typeof window !== "undefined" && window || module.exports.content);
    if (0, module.exports) module.exports.saveAs = $e22c5f112f49df3f$var$saveAs;
    else if (typeof define !== "undefined" && define !== null && define.amd !== null) define("FileSaver.js", function() {
        return $e22c5f112f49df3f$var$saveAs;
    });
});
parcelRegister("930Ym", function(module, exports) {
    $parcel$export(module.exports, "escapeValue", ()=>$96c8854850ab7fcc$export$ea39ee3092b88584);
    $parcel$export(module.exports, "getColumnTransformers", ()=>$96c8854850ab7fcc$export$8275ddb83241f041);
    var $2gnC5 = parcelRequire("2gnC5");
    var $f9Owr;
    var $heWHN;
    var $15ADj;
    const $96c8854850ab7fcc$export$98de7bb6e1f5105c = 'yyyy/MM/DD';
    const $96c8854850ab7fcc$export$ea39ee3092b88584 = (value)=>{
        if (value === undefined) return '""';
        if (value.includes('"')) return `"${value.replace(/"/g, '""')}"`;
        return `"${value}"`;
    };
    const $96c8854850ab7fcc$export$3ae94a2503e890a1 = (date)=>$96c8854850ab7fcc$export$ea39ee3092b88584(date !== undefined ? (0, ($parcel$interopDefault($2gnC5))).utc(date).format($96c8854850ab7fcc$export$98de7bb6e1f5105c) : '');
    const $96c8854850ab7fcc$export$8275ddb83241f041 = ({ startDateCustomFieldId: startDateCustomFieldId, colorCustomFieldId: colorCustomFieldId, sprintCustomFieldId: sprintCustomFieldId, isSprintsFeatureEnabled: isSprintsFeatureEnabled, hasInferredStartDueDateFields: hasInferredStartDueDateFields })=>[
            {
                fieldId: 'issuekey',
                transform: ({ issue: issue })=>$96c8854850ab7fcc$export$ea39ee3092b88584(issue.key)
            },
            {
                fieldId: 'issuetype',
                transform: ({ issue: issue }, { issueTypesHash: issueTypesHash })=>$96c8854850ab7fcc$export$ea39ee3092b88584(issueTypesHash[issue.issueTypeId]?.name)
            },
            {
                fieldId: 'parent',
                transform: ({ issue: issue }, { issuesHash: issuesHash })=>$96c8854850ab7fcc$export$ea39ee3092b88584(issue.parentId?.value ? issuesHash[issue.parentId.value]?.key : undefined)
            },
            {
                fieldId: 'summary',
                transform: ({ issue: issue })=>$96c8854850ab7fcc$export$ea39ee3092b88584(issue.summary.value)
            },
            ...(0, (0, parcelRequire("f9Owr")).ff)('jsw.timeline.return-flagged-attribute-fe') ? [
                {
                    fieldId: 'flagged',
                    transform: ({ issue: issue })=>$96c8854850ab7fcc$export$ea39ee3092b88584(issue.flagged.toString().toLowerCase())
                }
            ] : [],
            {
                fieldId: 'status',
                transform: ({ issue: issue })=>$96c8854850ab7fcc$export$ea39ee3092b88584(issue?.status?.name)
            },
            {
                fieldId: 'assignee',
                transform: ({ issue: issue }, { userDisplayNameHash: userDisplayNameHash })=>$96c8854850ab7fcc$export$ea39ee3092b88584(issue.assignee ? userDisplayNameHash[issue.assignee] : undefined)
            },
            ...isSprintsFeatureEnabled ? [
                {
                    fieldId: sprintCustomFieldId,
                    transform: ({ issueId: issueId }, { issueSprintsHash: issueSprintsHash })=>$96c8854850ab7fcc$export$ea39ee3092b88584(issueSprintsHash?.[issueId]?.at(0)?.name)
                }
            ] : [],
            {
                fieldId: startDateCustomFieldId,
                transform: ({ issue: issue })=>$96c8854850ab7fcc$export$3ae94a2503e890a1(issue.startDate?.value)
            },
            ...hasInferredStartDueDateFields ? [
                {
                    fieldId: 'inferredStartDate',
                    transform: ({ chartData: chartData })=>$96c8854850ab7fcc$export$3ae94a2503e890a1(chartData?.startDate && chartData.placeholder !== (0, (0, parcelRequire("15ADj")).START_AND_DUE_DATE_PLACEHOLDER) && chartData.placeholder !== (0, (0, parcelRequire("15ADj")).START_DATE_PLACEHOLDER) ? chartData.startDate : undefined)
                }
            ] : [],
            {
                fieldId: 'duedate',
                transform: ({ issue: issue })=>$96c8854850ab7fcc$export$3ae94a2503e890a1(issue.dueDate.value)
            },
            ...hasInferredStartDueDateFields ? [
                {
                    fieldId: 'inferredDueDate',
                    transform: ({ chartData: chartData })=>$96c8854850ab7fcc$export$3ae94a2503e890a1(chartData?.dueDate && chartData.placeholder !== (0, (0, parcelRequire("15ADj")).START_AND_DUE_DATE_PLACEHOLDER) && chartData.placeholder !== (0, (0, parcelRequire("15ADj")).DUE_DATE_PLACEHOLDER) ? chartData.dueDate : undefined)
                }
            ] : [],
            ...colorCustomFieldId ? [
                {
                    fieldId: colorCustomFieldId,
                    transform: ({ issue: issue })=>$96c8854850ab7fcc$export$ea39ee3092b88584((0, (0, parcelRequire("heWHN")).MAP_FROM_CLIENT_SERVER_COLOR)[issue.color.value])
                }
            ] : []
        ];
});
parcelRegister("d38Sb", function(module, exports) {
    $parcel$export(module.exports, "ExportButton", ()=>$56c018896df0ff06$export$bec7fd3dce2f28c0);
    var $5uXOq = parcelRequire("5uXOq");
    var $9jNMw;
    var $iriM5;
    var $lUP1Q;
    var $6ESxT;
    var $bBpJp;
    var $koVbs;
    var $8zOmE;
    var $lwMsT;
    var $22OQR;
    var $6lmg7;
    var $dCm1o;
    var $8YMED;
    const $56c018896df0ff06$export$bec7fd3dce2f28c0 = ({ onExportCsv: onExportCsv, onExportAsImageClick: onExportAsImageClick, isThemedButton: isThemedButton })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const onExportCsvCallback = (0, $5uXOq.useCallback)(()=>{
            const analyticsEvent = createAnalyticsEvent({});
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'exportCsv clicked');
            onExportCsv({
                inferredStartDateHeader: formatMessage((0, (0, parcelRequire("8YMED")).default).exportSpreadsheetInferredStartDate),
                inferredDueDateHeader: formatMessage((0, (0, parcelRequire("8YMED")).default).exportSpreadsheetInferredDueDate)
            });
        }, [
            createAnalyticsEvent,
            onExportCsv,
            formatMessage
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iriM5")).default), {
            trigger: ({ triggerRef: triggerRef, ...props })=>(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? isThemedButton ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("22OQR")).ThemedButton), {
                    "aria-label": formatMessage((0, (0, parcelRequire("8YMED")).default).exportButton),
                    label: formatMessage((0, (0, parcelRequire("8YMED")).default).exportButton),
                    iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("bBpJp"))))), {
                        label: "",
                        color: "currentColor",
                        spacing: "spacious"
                    }),
                    ref: triggerRef,
                    ...props,
                    testId: "roadmap.timeline-table-kit.ui.header.export.export-button"
                }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9jNMw")).default), {
                    label: formatMessage((0, (0, parcelRequire("8YMED")).default).exportButton),
                    icon: (0, ($parcel$interopDefault((0, parcelRequire("bBpJp"))))),
                    ref: triggerRef,
                    isTooltipDisabled: false,
                    ...props,
                    testId: "roadmap.timeline-table-kit.ui.header.export.export-button"
                }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6lmg7")).ResponsiveButton), {
                    label: formatMessage((0, (0, parcelRequire("8YMED")).default).exportButton),
                    icon: (0, ($parcel$interopDefault((0, parcelRequire("bBpJp"))))),
                    ref: triggerRef,
                    ...props
                })
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6ESxT")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lUP1Q")).default), {
            onClick: onExportAsImageClick
        }, formatMessage((0, (0, parcelRequire("8YMED")).default).exportImagePng)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lUP1Q")).default), {
            onClick: onExportCsvCallback
        }, formatMessage((0, (0, parcelRequire("8YMED")).default).exportSpreadsheetCsv))));
    };
});
parcelRegister("lUP1Q", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f4df1eec061f00ce$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $jXXts;
    var $3IisA;
    var $6iX1e;
    var $2uy6c;
    var $2oS3b;
    var $dIGjU;
    const $f4df1eec061f00ce$var$DropdownMenuItem = (0, $5uXOq.forwardRef)(({ children: children, component: component, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, rel: rel, shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, target: target, testId: testId, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, returnFocusRef: returnFocusRef, interactionName: interactionName, ...rest }, ref)=>{
        const itemRef = (0, (0, parcelRequire("dIGjU")).default)();
        const handleItemClick = (0, $5uXOq.useCallback)((event)=>{
            if (returnFocusRef?.current) returnFocusRef.current.focus();
            if (onClick) onClick(event);
        }, [
            onClick,
            returnFocusRef
        ]);
        if (component) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6iX1e")).default), {
            component: component,
            description: description,
            iconAfter: elemAfter,
            iconBefore: elemBefore,
            isDisabled: isDisabled,
            isSelected: isSelected,
            onClick: handleItemClick,
            ref: (0, (0, parcelRequire("jXXts")).default)([
                ref,
                itemRef
            ]),
            shouldDescriptionWrap: shouldDescriptionWrap,
            shouldTitleWrap: shouldTitleWrap,
            testId: testId,
            href: href,
            target: target,
            rel: rel,
            ...(0, (0, parcelRequire("2oS3b")).fg)('platform_button_item-add-ufo-metrics') && {
                interactionName: interactionName
            },
            ...rest
        }, children);
        else if (href) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2uy6c")).default), {
            description: description,
            href: href,
            iconAfter: elemAfter,
            iconBefore: elemBefore,
            isDisabled: isDisabled,
            isSelected: isSelected,
            onClick: handleItemClick,
            ref: (0, (0, parcelRequire("jXXts")).default)([
                ref,
                itemRef
            ]),
            rel: rel,
            role: "menuitem",
            shouldDescriptionWrap: shouldDescriptionWrap,
            shouldTitleWrap: shouldTitleWrap,
            target: target,
            testId: testId,
            UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink,
            ...(0, (0, parcelRequire("2oS3b")).fg)('platform_button_item-add-ufo-metrics') && {
                interactionName: interactionName
            },
            ...rest
        }, children);
        else return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3IisA")).default), {
            description: description,
            iconAfter: elemAfter,
            iconBefore: elemBefore,
            isDisabled: isDisabled,
            isSelected: isSelected,
            onClick: handleItemClick,
            ref: (0, (0, parcelRequire("jXXts")).default)([
                ref,
                itemRef
            ]),
            role: "menuitem",
            shouldDescriptionWrap: shouldDescriptionWrap,
            shouldTitleWrap: shouldTitleWrap,
            testId: testId,
            target: target,
            rel: rel,
            ...(0, (0, parcelRequire("2oS3b")).fg)('platform_button_item-add-ufo-metrics') && {
                interactionName: interactionName
            },
            ...rest
        }, children);
    });
    var $f4df1eec061f00ce$export$2e2bcd8739ae039 = $f4df1eec061f00ce$var$DropdownMenuItem;
});
parcelRegister("6ESxT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e37f61b5921ce569$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bkJDg;
    var $pbV7V;
    var $3c7E2;
    const $e37f61b5921ce569$var$DropdownMenuItemGroup = (0, $5uXOq.forwardRef)(({ children: children, id: id, isList: isList, isScrollable: isScrollable, title: title, testId: testId, hasSeparator: hasSeparator, overrides: overrides, ...rest }, ref)=>{
        const uid = (0, (0, parcelRequire("bkJDg")).useId)();
        const titleId = `dropdown-menu-item-group-title-${uid}`;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("pbV7V")).default), {
            id: id,
            ref: ref,
            isList: isList,
            isScrollable: isScrollable,
            hasSeparator: hasSeparator,
            testId: testId,
            titleId: title ? titleId : undefined,
            overrides: overrides,
            ...rest
        }, title && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3c7E2")).default), {
            id: titleId,
            title: title
        }), children);
    });
    var $e37f61b5921ce569$export$2e2bcd8739ae039 = $e37f61b5921ce569$var$DropdownMenuItemGroup;
});
parcelRegister("bBpJp", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $87271c1fef1233a4$var$_react = $87271c1fef1233a4$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $87271c1fef1233a4$var$_upload = $87271c1fef1233a4$var$_interopRequireDefault((parcelRequire("2vsTO")));
    var $87271c1fef1233a4$var$_export = $87271c1fef1233a4$var$_interopRequireDefault((parcelRequire("gEg1t")));
    function $87271c1fef1233a4$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $87271c1fef1233a4$var$UploadIcon = (props)=>$87271c1fef1233a4$var$_react.default.createElement($87271c1fef1233a4$var$_upload.default, Object.assign({
            LEGACY_fallbackIcon: $87271c1fef1233a4$var$_export.default
        }, props));
    $87271c1fef1233a4$var$UploadIcon.Name = 'UploadIconMigration';
    var $87271c1fef1233a4$var$_default = module.exports.default = $87271c1fef1233a4$var$UploadIcon;
});
parcelRegister("2vsTO", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $1d34e4cf863f6bac$var$_react = $1d34e4cf863f6bac$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $1d34e4cf863f6bac$var$_UNSAFE_baseNew = $1d34e4cf863f6bac$var$_interopRequireDefault((parcelRequire("dTInF")));
    function $1d34e4cf863f6bac$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $1d34e4cf863f6bac$var$UploadIcon = (props)=>$1d34e4cf863f6bac$var$_react.default.createElement($1d34e4cf863f6bac$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.75 9v4c0 .69.56 1.25 1.25 1.25h10c.69 0 1.25-.56 1.25-1.25V9M8 11V2.25m-4 3.5 4-4 4 4"/>`
        }, props));
    $1d34e4cf863f6bac$var$UploadIcon.displayName = 'UploadIcon';
    var $1d34e4cf863f6bac$var$_default = module.exports.default = $1d34e4cf863f6bac$var$UploadIcon;
});
parcelRegister("gEg1t", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $c1eccf93360de5f5$var$_react = $c1eccf93360de5f5$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $7p1ve;
    var $c1eccf93360de5f5$var$_upload = $c1eccf93360de5f5$var$_interopRequireDefault((parcelRequire("2vsTO")));
    function $c1eccf93360de5f5$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $c1eccf93360de5f5$var$ExportIcon = (props)=>$c1eccf93360de5f5$var$_react.default.createElement((0, parcelRequire("7p1ve")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M13 6.491V16a1 1 0 0 1-2 0V6.491L9.784 7.697a1.05 1.05 0 0 1-1.478 0 1.03 1.03 0 0 1 0-1.465l2.955-2.929a1.05 1.05 0 0 1 1.478 0l2.955 2.93c.408.404.408 1.06 0 1.464a1.05 1.05 0 0 1-1.478 0zM9 9v2H7c-.002 0 0 7.991 0 7.991 0 .004 9.994.009 9.994.009.003 0 .006-7.991.006-7.991 0-.006-2-.009-2-.009V9h2c1.105 0 2 .902 2 2.009v7.982c0 1.11-.897 2.009-2.006 2.009H7.006A2.01 2.01 0 0 1 5 18.991V11.01A2 2 0 0 1 7 9z"/></svg>`
        }, props, {
            newIcon: $c1eccf93360de5f5$var$_upload.default
        }));
    $c1eccf93360de5f5$var$ExportIcon.displayName = 'ExportIcon';
    var $c1eccf93360de5f5$var$_default = module.exports.default = $c1eccf93360de5f5$var$ExportIcon;
});
parcelRegister("8YMED", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3d73b218592e519f$export$2e2bcd8739ae039);
    var $7VHMR;
    var $3d73b218592e519f$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        exportButton: {
            "id": "roadmap.timeline-table-kit.header.export.export-button",
            "defaultMessage": "Export"
        },
        exportImagePng: {
            "id": "roadmap.timeline-table-kit.header.export.export-image-png",
            "defaultMessage": "Image (.png)"
        },
        exportSpreadsheetCsv: {
            "id": "roadmap.timeline-table-kit.header.export.export-spreadsheet-csv",
            "defaultMessage": "Spreadsheet (.csv)"
        },
        exportSpreadsheetInferredStartDate: {
            "id": "roadmap.timeline-table-kit.header.export.export-spreadsheet-inferred-start-date",
            "defaultMessage": "Inferred start date"
        },
        exportSpreadsheetInferredDueDate: {
            "id": "roadmap.timeline-table-kit.header.export.export-spreadsheet-inferred-due-date",
            "defaultMessage": "Inferred due date"
        }
    });
});
parcelRegister("rfnJx", function(module, exports) {
    $parcel$export(module.exports, "ExportImageModal", ()=>$5dd8e857eed56cd3$export$33354fb057e1382d);
    var $5uXOq = parcelRequire("5uXOq");
    var $cm8b5;
    var $lfTZh;
    var $iXVV6;
    var $8zOmE;
    var $lwMsT;
    var $1jUsD;
    var $gNAqw;
    var $9X5bV;
    const $5dd8e857eed56cd3$export$80d473a3298c2f82 = (0, (0, parcelRequire("1jUsD")).lazy)(()=>(parcelRequire("dkoMz")), {
        ssr: false,
        moduleId: "./src/packages/software/roadmap/image-export/src/modal/index.tsx"
    });
    const $5dd8e857eed56cd3$export$33354fb057e1382d = ({ open: open, onOpenChange: onOpenChange, tableProps: tableProps })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, open && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iXVV6")).ContextualAnalyticsData), {
            sourceName: "exportImageShare",
            sourceType: (0, $4d5e0871c06cee03$export$1171103ea9083ffa)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cm8b5")).ExperienceStart), {
            experience: (0, (0, parcelRequire("gNAqw")).EXPORT_IMAGE_EXPERIENCE)
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "sharing-modal",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($5dd8e857eed56cd3$export$80d473a3298c2f82, {
            ExportImage: (0, (0, parcelRequire("9X5bV")).LazySharingExport),
            tableProps: tableProps,
            onClickDownload: (_, analyticsEvent)=>{
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'saveImageButton');
            },
            onClose: ()=>{
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'exportImageShare closed');
                onOpenChange(false);
            }
        }))));
    };
});
parcelRegister("9X5bV", function(module, exports) {
    $parcel$export(module.exports, "LazySharingExport", ()=>$a1687f564d85c879$export$5c8de0d1658b214);
    var $1jUsD;
    const $a1687f564d85c879$export$5c8de0d1658b214 = (0, (0, parcelRequire("1jUsD")).lazyAfterPaint)(()=>(parcelRequire("ijmt4")), {
        ssr: false,
        moduleId: "./src/packages/business/timeline/src/ui/timeline-view/export/export-image/export-share/main.tsx"
    });
});
parcelRegister("ijmt4", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("9pZgw").then(()=>parcelRequire('hjVIe'));
});
parcelRegister("dkoMz", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("h1tfx").then(()=>parcelRequire('H32TO'));
});
parcelRegister("d8IhD", function(module, exports) {
    $parcel$export(module.exports, "ListHeader", ()=>$4462f09a94f24107$export$3d6ed0715468a113);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $koVbs;
    var $efuIu;
    const $4462f09a94f24107$export$3d6ed0715468a113 = ()=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($4462f09a94f24107$var$Container, null, (0, ($parcel$interopDefault($5uXOq))).createElement($4462f09a94f24107$var$Title, null, formatMessage((0, (0, parcelRequire("efuIu")).default).itemsListHeader)));
    };
    const $4462f09a94f24107$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _16jlidpf _1o9zidpf _i0dl1wug _4cvr1h6o _4t3i1osq _1yt41g30",
                __cmplp.className
            ])
        });
    });
    const $4462f09a94f24107$var$Title = (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _1reo15vq _18m915vq _1bto1l2s _o5721q9c",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("efuIu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c02652501c80c658$export$2e2bcd8739ae039);
    var $7VHMR;
    var $c02652501c80c658$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        itemsListHeader: {
            "id": "business-timeline.timeline-view.list-header.items-list-header",
            "defaultMessage": "Items"
        }
    });
});
parcelRegister("lwgY1", function(module, exports) {
    $parcel$export(module.exports, "ListItemContent", ()=>$90725e85f6f9a196$export$a09b9fc02aa00007);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lfaZL;
    var $loZC0;
    var $bG3pQ;
    var $hE5wF;
    var $1T1ir;
    var $1JH9w;
    var $deqCE;
    var $l0oHX;
    var $gSExi;
    var $4R6GH;
    var $koVbs;
    var $cE2Qr;
    var $8zOmE;
    var $lwMsT;
    var $k2wwp;
    var $adopm;
    var $iZN6h;
    var $dCm1o;
    var $1lN06;
    var $jxKr9;
    var $5ZRDB;
    var $1bKy6;
    const $90725e85f6f9a196$var$noop = ()=>{};
    const $90725e85f6f9a196$export$213890d52566537e = (0, $5uXOq.memo)(({ onChildCreateClick: onChildCreateClick })=>{
        const [nudgeStep] = (0, (0, parcelRequire("cE2Qr")).useNudgeStep)();
        const [{ createItemAnchor: createItemAnchor }] = (0, (0, parcelRequire("1lN06")).useCreateItemAnchor)();
        const shouldShowAddChildItemNudge = nudgeStep === 'timelineAddChildItemNudge' && !createItemAnchor;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, shouldShowAddChildItemNudge && (0, ($parcel$interopDefault($5uXOq))).createElement($90725e85f6f9a196$var$AddItemNudgeWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("adopm")).TimelineAddChildItemNudgeAsync), null, (0, ($parcel$interopDefault($5uXOq))).createElement($90725e85f6f9a196$export$4a45809d2280850, {
            onClick: onChildCreateClick
        }))));
    });
    const $90725e85f6f9a196$export$b3e18ebdf3899c38 = (props)=>{
        const highlight = (0, (0, parcelRequire("1T1ir")).useSimpleSearchHighlight)();
        const { title: title } = props;
        if (title == null) return null;
        const shouldHighlight = highlight.length > 0;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($90725e85f6f9a196$var$IssueTitleWrapper, null, shouldHighlight ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k2wwp")).default), {
            highlight: highlight,
            text: title
        }) : title);
    };
    const $90725e85f6f9a196$export$a09b9fc02aa00007 = (0, $5uXOq.memo)(({ title: title, setSelectedIssueKey: setSelectedIssueKey = $90725e85f6f9a196$var$noop, issue: issue, isFirstItem: isFirstItem, onCreateClick: onCreateClick, isLastItem: isLastItem, setInfiniteScrollerRef: setInfiniteScrollerRef })=>{
        const ufoPressTracing = (0, (0, parcelRequire("lfaZL")).default)('jwm.timeline.issue-view-opened');
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { prefetchIssue: prefetchIssue } = (0, (0, parcelRequire("1JH9w")).usePrefetchIssueViewDataActions)();
        const handleIssueKeyMouseEnter = (0, $5uXOq.useCallback)(()=>{
            if (issue?.key) prefetchIssue(issue?.key);
        }, [
            issue?.key,
            prefetchIssue
        ]);
        const { issueViewInteraction: issueViewInteraction } = (0, (0, parcelRequire("jxKr9")).useTimelineFeatures)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const openIssueModal = (0, $5uXOq.useCallback)((event)=>{
            if (issue && issue.id && !issue.id.startsWith((0, (0, parcelRequire("deqCE")).OPTIMISTIC_ID_PREFIX)) && issue.key) {
                ufoPressTracing(event.timeStamp);
                if (issueViewInteraction === 'openNewTab') {
                    (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'timelineEmbedIssueKey clicked');
                    (0, (0, parcelRequire("bG3pQ")).openViewFromEmbed)({
                        key: (0, (0, parcelRequire("hE5wF")).SELECTED_ISSUE_PARAM),
                        value: issue.key
                    });
                    event.preventDefault();
                    event.stopPropagation();
                } else if (!(0, (0, parcelRequire("l0oHX")).isModifiedEvent)(event)) {
                    setSelectedIssueKey(issue.key);
                    event.preventDefault();
                    event.stopPropagation();
                    (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'timelineIssueKey clicked');
                }
            }
        }, [
            issue,
            issueViewInteraction,
            createAnalyticsEvent,
            setSelectedIssueKey,
            ufoPressTracing
        ]);
        const onChildCreate = (0, $5uXOq.useCallback)(()=>{
            if (issue) onCreateClick({
                parentId: issue.issueId,
                position: (0, (0, parcelRequire("iZN6h")).INSIDE)
            });
        }, [
            onCreateClick,
            issue
        ]);
        if (!issue) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement($90725e85f6f9a196$var$ListItemContentWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5ZRDB")).default), {
            src: issue.issueType.iconUrl,
            alt: issue.issueType.name
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("loZC0")).default), {
            content: formatMessage((0, (0, parcelRequire("1bKy6")).default).toolTip)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($90725e85f6f9a196$var$IssueKeyLink, {
            onClick: openIssueModal,
            onMouseEnter: handleIssueKeyMouseEnter,
            href: `/browse/${issue.key}`,
            "data-test-id": "business-timeline.ui.timeline-view.list-item-content.issue-key",
            "data-testid": "business-timeline.ui.timeline-view.list-item-content.issue-key",
            isVisualRefresh: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_eap_drop_2')
        }, issue.key)), (0, ($parcel$interopDefault($5uXOq))).createElement($90725e85f6f9a196$export$b3e18ebdf3899c38, {
            title: title
        })), isFirstItem && (0, ($parcel$interopDefault($5uXOq))).createElement($90725e85f6f9a196$export$213890d52566537e, {
            onChildCreateClick: onChildCreate
        }), isLastItem && (0, ($parcel$interopDefault($5uXOq))).createElement("span", {
            ref: setInfiniteScrollerRef
        }));
    });
    $90725e85f6f9a196$export$a09b9fc02aa00007.displayName = 'ListItemContent';
    const $90725e85f6f9a196$var$NUDGE_SIZE = 24;
    const $90725e85f6f9a196$var$AddItemNudgeWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _1r041l7b _lcxvglyw",
                __cmplp.className
            ])
        });
    });
    const $90725e85f6f9a196$var$IssueKeyLink = (0, $5uXOq.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isVisualRefresh: isVisualRefresh, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_o5721q9c _80omtlke _18u0u2gc _hc7q15vq _njtz15vq _1xnh1l2s _1aaynkob _f8pj1v9b _7ehiglyw _9oik18uv _1bnx8stv _jf4cnqa1 _30l31v9b",
                __cmplp.isVisualRefresh ? "_k48p1wq8" : "_k48pbfng",
                __cmplp.isVisualRefresh ? "_syaz1be1" : "_syaz1v9b",
                __cmplp.isVisualRefresh ? "_2hwx1b66" : "_2hwxpxbi",
                __cmplp.className
            ])
        });
    });
    const $90725e85f6f9a196$var$IssueTitleWrapper = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_o5721q9c _1bto1l2s _1reo15vq _18m915vq",
                __cmplp.className
            ])
        });
    });
    const $90725e85f6f9a196$var$ListItemContentWrapperNew = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _4cvr1h6o _1rjc1b66",
                __cmplp.className
            ])
        });
    });
    const $90725e85f6f9a196$var$ListItemContentWrapperOld = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
    const $90725e85f6f9a196$var$ListItemContentWrapper = (0, (0, parcelRequire("gSExi")).styledComponentWithCondition)(()=>(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_2'), $90725e85f6f9a196$var$ListItemContentWrapperNew, $90725e85f6f9a196$var$ListItemContentWrapperOld);
    const $90725e85f6f9a196$export$4a45809d2280850 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqsw7079 _154i1grp _1xi212x7 _1bsb1tcg _4t3i1tcg _lcxv1wug _80omtlke _1ywuglyw _cfu1glyw",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("bG3pQ", function(module, exports) {
    $parcel$export(module.exports, "openViewFromEmbed", ()=>$b6fc163d26910ed9$export$a29603f2eb9b6da6);
    const $b6fc163d26910ed9$export$a29603f2eb9b6da6 = (param)=>{
        const cleanUrl = window.location.href.replace('/embed', '');
        const currentUrl = new URL(cleanUrl);
        if (param != null) currentUrl.searchParams.append(param.key, param.value);
        window.open(currentUrl.href, '_blank');
    };
});
parcelRegister("gSExi", function(module, exports) {
    $parcel$export(module.exports, "styledComponentWithCondition", ()=>$cd06fcc13efa32a5$export$62d8d8fbf238d6af);
    var $5uXOq = parcelRequire("5uXOq");
    const $cd06fcc13efa32a5$export$62d8d8fbf238d6af = (useCompiled, CompiledComponent, StyledComponent)=>({ innerRef: innerRef, ...rest })=>useCompiled() ? (0, ($parcel$interopDefault($5uXOq))).createElement(CompiledComponent, {
                ...rest,
                ref: innerRef
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement(StyledComponent, {
                ...rest,
                innerRef: innerRef
            });
    const $cd06fcc13efa32a5$export$f5b752428255ba78 = (useCompiled, CompiledComponent, StyledComponent)=>({ innerRef: innerRef, ...rest })=>useCompiled() ? (0, ($parcel$interopDefault($5uXOq))).createElement(CompiledComponent, {
                ...rest,
                ref: innerRef
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement(StyledComponent, {
                ...rest,
                innerRef: innerRef
            });
});
parcelRegister("k2wwp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5e37bd657627b5db$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1H6kL;
    var $cM7El;
    const $5e37bd657627b5db$var$HighlightTextWithParser = (0, $5uXOq.memo)(({ text: text, highlight: highlight })=>{
        const parts = (0, (0, parcelRequire("1H6kL")).getParts)(highlight, text);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cM7El")).default), {
            parts: parts
        });
    });
    var $5e37bd657627b5db$export$2e2bcd8739ae039 = $5e37bd657627b5db$var$HighlightTextWithParser;
});
parcelRegister("1H6kL", function(module, exports) {
    $parcel$export(module.exports, "removeAccents", ()=>$0b92ef830f5aa8e4$export$f3f2882e8b11d731);
    $parcel$export(module.exports, "getParts", ()=>$0b92ef830f5aa8e4$export$a3aee8a24a54661f);
    var $8QDwl = parcelRequire("8QDwl");
    var $ajpes = parcelRequire("ajpes");
    var $3JOCw = parcelRequire("3JOCw");
    var $8QpSo;
    const $0b92ef830f5aa8e4$export$f3f2882e8b11d731 = (0, (0, parcelRequire("8QpSo")).default)((text)=>text.normalize('NFD').replace(/[\u0300-\u036f]/g, ''));
    const $0b92ef830f5aa8e4$export$1633667427d99697 = (0, (0, parcelRequire("8QpSo")).default)((highlight)=>{
        const escapedFilter = highlight.map((phrase)=>(0, ($parcel$interopDefault($8QDwl)))(phrase)).join('|');
        return new RegExp(escapedFilter, 'gmi');
    }, (newArgs, lastArgs)=>{
        if (newArgs.length !== lastArgs.length) return false;
        const equalityFn = (0, ($parcel$interopDefault($ajpes)));
        return newArgs.every((newArg, index)=>equalityFn(newArg, lastArgs[index]));
    });
    const $0b92ef830f5aa8e4$export$2235873b95f89ea = (content)=>({
            type: 'text',
            content: content
        });
    const $0b92ef830f5aa8e4$export$39ae7d355c29b45f = (content)=>({
            type: 'highlight',
            content: content
        });
    const $0b92ef830f5aa8e4$export$c05c39859172f90c = (str, regExp)=>{
        const ms = [];
        let m = regExp.exec(str);
        while(m){
            ms.push(m);
            m = regExp.exec(str);
        }
        return ms;
    };
    const $0b92ef830f5aa8e4$export$a3aee8a24a54661f = (highlight, text)=>{
        if (highlight == null || highlight.filter((phrase)=>phrase !== '').length === 0) return [
            $0b92ef830f5aa8e4$export$2235873b95f89ea(text)
        ];
        const parts = [];
        const truncatedHighlight = highlight.map((phrase)=>phrase.substring(0, 255));
        const highlightRegExp = $0b92ef830f5aa8e4$export$1633667427d99697(truncatedHighlight.filter((phrase)=>phrase !== ''));
        const textWithoutAccents = $0b92ef830f5aa8e4$export$f3f2882e8b11d731(text);
        const textMatches = $0b92ef830f5aa8e4$export$c05c39859172f90c(text, highlightRegExp);
        const textWithoutAccentsMatches = $0b92ef830f5aa8e4$export$c05c39859172f90c(textWithoutAccents, highlightRegExp);
        const highlightMatches = (0, ($parcel$interopDefault($3JOCw)))([
            ...textWithoutAccentsMatches,
            ...textMatches
        ], 'index');
        let currentPosition = 0;
        highlightMatches.forEach((match)=>{
            const matchText = text.slice(match.index, match.index + match[0].length);
            const leading = text.slice(currentPosition, match.index);
            if (leading !== '') parts.push($0b92ef830f5aa8e4$export$2235873b95f89ea(leading));
            parts.push($0b92ef830f5aa8e4$export$39ae7d355c29b45f(matchText));
            currentPosition = match.index + matchText.length;
        });
        const trailing = text.slice(currentPosition);
        if (trailing !== '') parts.push($0b92ef830f5aa8e4$export$2235873b95f89ea(trailing));
        return parts;
    };
});
parcelRegister("cM7El", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$328475be93221885$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $328475be93221885$var$Mark = (0, $5uXOq.forwardRef)(({ as: C = "mark", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_bfhkwtfv _syaz1fxt",
                __cmplp.className
            ])
        });
    });
    const $328475be93221885$var$HighlightText = ({ parts: parts })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, parts.map((part, i)=>{
            if (part.type === 'text') return part.content;
            return (0, ($parcel$interopDefault($5uXOq))).createElement($328475be93221885$var$Mark, {
                key: i
            }, part.content);
        }));
    var $328475be93221885$export$2e2bcd8739ae039 = $328475be93221885$var$HighlightText;
});
parcelRegister("adopm", function(module, exports) {
    $parcel$export(module.exports, "TimelineAddChildItemNudgeAsync", ()=>$55120071d322ed64$export$1ed63402e1f87c79);
    var $5uXOq = parcelRequire("5uXOq");
    var $bBbEG;
    var $lfTZh;
    var $1jUsD;
    const $55120071d322ed64$var$TimelineAddChildItemNudgeLazy = (0, (0, parcelRequire("1jUsD")).lazyAfterPaint)(()=>(parcelRequire("ciM2n")).then((exportedModule)=>exportedModule.TimelineAddChildItemNudge), {
        ssr: false,
        moduleId: "./src/packages/software/onboarding-nudges/src/ui/jwm-timeline-nudge-tour/timeline-add-child-item/index.tsx"
    });
    const $55120071d322ed64$export$1ed63402e1f87c79 = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bBbEG")).OnboardingNudgeErrorBoundary), {
            id: (0, $dbbf68c32d8c4308$export$2f06a16c987cc1a2),
            fallback: children,
            attributes: {
                nudgeId: (0, $dbbf68c32d8c4308$export$aac6e5779d47ef37)
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "timeline-add-child-item-onboarding-nudge",
            fallback: children
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($55120071d322ed64$var$TimelineAddChildItemNudgeLazy, null, children)));
    $55120071d322ed64$export$1ed63402e1f87c79.displayName = 'TimelineAddChildItemNudgeAsync';
});
const $dbbf68c32d8c4308$export$64d75060ee6ba425 = 'backlogCreateIssueNudge';
const $dbbf68c32d8c4308$export$e0197e09cccd4e50 = 'backlogCreateSprintNudge';
const $dbbf68c32d8c4308$export$6770a2081a63fc15 = 'backlogStartSprintNudge';
const $dbbf68c32d8c4308$export$63b61f654ce3da3d = 'backlogCompleteSprintNudge';
const $dbbf68c32d8c4308$export$1c7a80b00ad9619 = 'backlogInsightsNudge';
const $dbbf68c32d8c4308$export$b8b9d90f9e5bd72b = 'jiraSoftwareOnboardingNudges';
const $dbbf68c32d8c4308$export$65fb0c4e534f03fc = 'asyncScrumTourNudge';
const $dbbf68c32d8c4308$export$f2fe211acb4aa81a = 'asyncKanbanTourNudge';
const $dbbf68c32d8c4308$export$fb9c6e63a7490968 = 'asyncJWMCalendarTourNudge';
const $dbbf68c32d8c4308$export$df53a339af97f102 = 'asyncJWMCalendarAndTimelineTourNudge';
const $dbbf68c32d8c4308$export$573d4bf1da6d2bc6 = 'asyncJWMBoardTourNudge';
const $dbbf68c32d8c4308$export$501e36925fa10eef = 'asyncJWMListTourNudge';
const $dbbf68c32d8c4308$export$2f06a16c987cc1a2 = 'asyncJWMTimelineTourNudge';
const $dbbf68c32d8c4308$export$226bdcb034c75951 = 'asyncJWMFormTourNudge';
const $dbbf68c32d8c4308$export$b72fce9f4cf11b5c = 'asyncJWMTrelloKeyDifferencesTourNudge';
const $dbbf68c32d8c4308$export$306510c7b1760652 = 'asyncJWMSummaryAndReportsTabNudge';
const $dbbf68c32d8c4308$export$cf1943561be3a3c2 = 'asyncJWMSummaryViewNudge';
const $dbbf68c32d8c4308$export$f8bf435a6066832c = 'button clicked';
const $dbbf68c32d8c4308$export$3bc551fe07069f89 = 'asyncJWMInviteTeamNudge';
const $dbbf68c32d8c4308$export$d99767a37baddfc = 'sampleProjectDataNudge';
const $dbbf68c32d8c4308$export$4db327e1949c2108 = 'boardInProgressColumnNudge';
const $dbbf68c32d8c4308$export$a402f2c11da96cd7 = 'boardCreateIssueNudge';
const $dbbf68c32d8c4308$export$1e174cd1e0212f3a = 'navigateCalendarNudge';
const $dbbf68c32d8c4308$export$6ffa29e74c0304c4 = 'tailorBoardColumnsNudge';
const $dbbf68c32d8c4308$export$a1398a6ef9526001 = 'inlineEditListNudge';
const $dbbf68c32d8c4308$export$5908fa8acd2c0739 = 'filterListNudge';
const $dbbf68c32d8c4308$export$50192b0fdc9bdacf = 'moreDropdownListNudge';
const $dbbf68c32d8c4308$export$e34e81ed4f255f6e = 'timelineAddDateNudge';
const $dbbf68c32d8c4308$export$aac6e5779d47ef37 = 'timelineAddChildItemNudge';
const $dbbf68c32d8c4308$export$69aca8ebee0d34c8 = 'trelloCrossflowAddItemsCalendarNudge';
const $dbbf68c32d8c4308$export$dd4b359b5a58cdc0 = 'trelloCrossflowTimelineTabNudge';
const $dbbf68c32d8c4308$export$1e0e647cc08bb4d8 = 'trelloKeyDifferencesIssueNudge';
const $dbbf68c32d8c4308$export$762576896c225bd6 = 'trelloKeyDifferencesSummaryNudge';
const $dbbf68c32d8c4308$export$5a96f813312dc7fa = 'trelloKeyDifferencesBoardNudge';
const $dbbf68c32d8c4308$export$ae8eeb04e0b1e9af = 'availableFieldsFormNudge';
const $dbbf68c32d8c4308$export$a54d77300f1dddea = 'changeIssueTypeFormNudge';
const $dbbf68c32d8c4308$export$6afdc7e5f6d2e915 = 'previewSaveFormNudge';
const $dbbf68c32d8c4308$export$eb0b199de90a7ec2 = 'backgroundColorNudge';
const $dbbf68c32d8c4308$export$e9e47a7ad42e71f5 = 'feedbackNudge';
const $dbbf68c32d8c4308$export$791f56b3d78403cc = 'calendarReleasesNudge';
const $dbbf68c32d8c4308$export$a1be34032ee24f78 = 'shareProjectNudge';
const $dbbf68c32d8c4308$export$29fe6611cc093756 = 'summaryTabNudge';
const $dbbf68c32d8c4308$export$f107c06c0830f09d = 'reportsTabNudge';
const $dbbf68c32d8c4308$export$9749a972a54ad7ba = 'boardContainerNudge';
parcelRegister("ciM2n", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("cYrQx")
    ]).then(()=>parcelRequire('9a43O'));
});
parcelRegister("5ZRDB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1f8af66558ed5594$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $gwIPs;
    const $1f8af66558ed5594$var$Icon = ({ src: src, alt: alt, size: size })=>(0, ($parcel$interopDefault($5uXOq))).createElement($1f8af66558ed5594$var$IconImage, {
            src: src,
            alt: alt,
            size: size
        });
    $1f8af66558ed5594$var$Icon.defaultProps = {
        alt: '',
        size: `${(0, (0, parcelRequire("gwIPs")).gridSize) * 2}px`
    };
    var $1f8af66558ed5594$export$2e2bcd8739ae039 = $1f8af66558ed5594$var$Icon;
    const $1f8af66558ed5594$var$IconImage = (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: {
                ...__cmpls,
                "--_1frub2c": (0, (0, parcelRequire("lD23V")).default)(__cmplp.size)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1vpm _4t3i1vpm _16jlidpf _1o9zidpf _i0dl1wug _2rko1sit",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("1bKy6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$801016bb62c8ddff$export$2e2bcd8739ae039);
    var $7VHMR;
    var $801016bb62c8ddff$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        toolTip: {
            "id": "business-timeline.timeline-view.list-item-content.tool-tip",
            "defaultMessage": "View Details"
        }
    });
});
parcelRegister("iIo17", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$902b5c03e639eb7f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $4R6GH;
    var $jxXX4;
    var $jHXy0;
    var $aAcPf;
    var $5MkRn;
    var $4Enec;
    const $902b5c03e639eb7f$var$ListItemMenuOption = ({ optionId: optionId, id: id, Option: Option, setCloseMenu: setCloseMenu, setOpenModal: setOpenModal, updateIssueParent: updateIssueParent, onItemUpdate: onItemUpdate })=>{
        switch(optionId){
            case 0, (0, parcelRequire("jxXX4")).CHANGE_PARENT_ISSUE:
                return (0, (0, parcelRequire("4R6GH")).fg)('jwm_timeline_meatball_reparent_menu') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4Enec")).default), {
                    id: id,
                    Option: Option,
                    setCloseMenu: setCloseMenu,
                    updateIssueParent: updateIssueParent
                }) : null;
            case 0, (0, parcelRequire("jxXX4")).REMOVE_DATES:
                return (0, (0, parcelRequire("4R6GH")).fg)('jwm_timeline_meatballs_date_update') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5MkRn")).default), {
                    id: id,
                    Option: Option,
                    setCloseMenu: setCloseMenu,
                    onItemUpdate: onItemUpdate
                }) : null;
            case 0, (0, parcelRequire("jxXX4")).EDIT_DATES:
                return (0, (0, parcelRequire("4R6GH")).fg)('jwm_timeline_meatballs_date_update') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("jHXy0")).default), {
                    id: id,
                    setOpenModal: setOpenModal,
                    Option: Option
                }) : null;
            case 0, (0, parcelRequire("jxXX4")).EDIT_DEPENDENCY:
                return (0, (0, parcelRequire("4R6GH")).fg)('jwm_timeline_meatballs_edit_dependency') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aAcPf")).default), {
                    id: id,
                    setOpenModal: setOpenModal,
                    Option: Option
                }) : null;
            default:
                return null;
        }
    };
    var $902b5c03e639eb7f$export$2e2bcd8739ae039 = $902b5c03e639eb7f$var$ListItemMenuOption;
});
parcelRegister("jHXy0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bf523965333cada0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $hYGQR;
    const $bf523965333cada0$var$EditDatesOption = ({ Option: Option, setOpenModal: setOpenModal })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const onClick = (0, $5uXOq.useCallback)((event)=>{
            event.preventDefault();
            setOpenModal(event);
        }, [
            setOpenModal
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement(Option, {
            label: formatMessage((0, (0, parcelRequire("hYGQR")).default).editDates),
            onClick: onClick
        });
    };
    var $bf523965333cada0$export$2e2bcd8739ae039 = $bf523965333cada0$var$EditDatesOption;
});
parcelRegister("hYGQR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$53ef96800055cdef$export$2e2bcd8739ae039);
    var $7VHMR;
    const $53ef96800055cdef$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        editDates: {
            "id": "business-timeline.timeline-view.list-item-menu-option.edit-dates-option.edit-dates",
            "defaultMessage": "Edit dates"
        }
    });
    var $53ef96800055cdef$export$2e2bcd8739ae039 = $53ef96800055cdef$var$messages;
});
parcelRegister("aAcPf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a9d6288b8b23d946$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $b3dLb;
    const $a9d6288b8b23d946$var$EditDependencyOption = ({ Option: Option, setOpenModal: setOpenModal })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const onClick = (0, $5uXOq.useCallback)((event)=>{
            event.preventDefault();
            setOpenModal(event);
        }, [
            setOpenModal
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement(Option, {
            label: formatMessage((0, (0, parcelRequire("b3dLb")).default).editDependencies),
            onClick: onClick
        });
    };
    var $a9d6288b8b23d946$export$2e2bcd8739ae039 = $a9d6288b8b23d946$var$EditDependencyOption;
});
parcelRegister("b3dLb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1931e6c0f1918774$export$2e2bcd8739ae039);
    var $7VHMR;
    const $1931e6c0f1918774$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        editDependencies: {
            "id": "business-timeline.timeline-view.list-item-menu-option.edit-dependency-option.edit-dependencies",
            "defaultMessage": "Edit dependencies"
        }
    });
    var $1931e6c0f1918774$export$2e2bcd8739ae039 = $1931e6c0f1918774$var$messages;
});
parcelRegister("5MkRn", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8223782321ae1a37$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $l75AK;
    var $pbV7V;
    var $koVbs;
    var $8zOmE;
    var $lwMsT;
    var $g5X3G;
    var $cl738;
    var $jxXX4;
    var $g26cN;
    const $8223782321ae1a37$var$RemoveDatesOption = ({ id: id, Option: Option, setCloseMenu: setCloseMenu, onItemUpdate: onItemUpdate })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const [{ issuesMap: issuesMap }] = (0, (0, parcelRequire("cl738")).useIssuesMap)();
        const issue = issuesMap.get(id);
        const isStartDateClearable = Boolean(issue?.startDate);
        const isDueDateClearable = Boolean(issue?.dueDate);
        const handleOnClick = (0, $5uXOq.useCallback)((isStartDateCleared, isDueDateCleared)=>(event)=>{
                const analyticsEvent = createAnalyticsEvent({
                    action: 'clicked',
                    actionSubject: 'option'
                });
                event.preventDefault();
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'removeDatesOption', {
                    isStartDateCleared: isStartDateCleared,
                    isDueDateCleared: isDueDateCleared
                });
                onItemUpdate((0, (0, parcelRequire("g5X3G")).toIssueId)(id), {
                    dates: {
                        ...isStartDateCleared && {
                            startDate: {
                                date: null
                            }
                        },
                        ...isDueDateCleared && {
                            dueDate: {
                                date: null
                            }
                        }
                    },
                    meta: {
                        isDragged: false
                    }
                }, analyticsEvent);
                setCloseMenu(event);
            }, [
            createAnalyticsEvent,
            id,
            onItemUpdate,
            setCloseMenu
        ]);
        const options = (0, $5uXOq.useMemo)(()=>[
                {
                    optionId: (0, (0, parcelRequire("jxXX4")).REMOVE_START_DATE),
                    isEnabled: isStartDateClearable,
                    label: formatMessage((0, (0, parcelRequire("g26cN")).default).removeStartDate),
                    onClick: handleOnClick(true, false)
                },
                {
                    optionId: (0, (0, parcelRequire("jxXX4")).REMOVE_DUE_DATE),
                    isEnabled: isDueDateClearable,
                    label: formatMessage((0, (0, parcelRequire("g26cN")).default).removeDueDate),
                    onClick: handleOnClick(false, true)
                },
                {
                    optionId: (0, (0, parcelRequire("jxXX4")).REMOVE_START_DATE_AND_DUE_DATE),
                    isEnabled: isStartDateClearable && isDueDateClearable,
                    label: formatMessage((0, (0, parcelRequire("g26cN")).default).removeBothDates),
                    onClick: handleOnClick(true, true)
                }
            ], [
            formatMessage,
            handleOnClick,
            isDueDateClearable,
            isStartDateClearable
        ]);
        const initialFocusIndex = (0, $5uXOq.useMemo)(()=>options.findIndex(({ isEnabled: isEnabled })=>isEnabled === true), [
            options
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement(Option, {
            label: formatMessage((0, (0, parcelRequire("g26cN")).default).removeDates),
            isDisabled: !isStartDateClearable && !isDueDateClearable
        }, ({ setInitialFocusRef: setInitialFocusRef })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l75AK")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("pbV7V")).default), null, options.map(({ optionId: optionId, isEnabled: isEnabled, ...optionProps }, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement(Option, {
                    key: optionId,
                    isDisabled: !isEnabled,
                    setInitialFocusRef: index === initialFocusIndex ? setInitialFocusRef : undefined,
                    ...optionProps
                })))));
    };
    var $8223782321ae1a37$export$2e2bcd8739ae039 = $8223782321ae1a37$var$RemoveDatesOption;
});
parcelRegister("g26cN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b773b891fdee25eb$export$2e2bcd8739ae039);
    var $7VHMR;
    const $b773b891fdee25eb$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        removeDates: {
            "id": "business-timeline.timeline-view.list-item-menu-option.remove-dates-option.remove-dates",
            "defaultMessage": "Remove dates"
        },
        removeStartDate: {
            "id": "business-timeline.timeline-view.list-item-menu-option.remove-dates-option.remove-start-date",
            "defaultMessage": "Remove start date"
        },
        removeDueDate: {
            "id": "business-timeline.timeline-view.list-item-menu-option.remove-dates-option.remove-due-date",
            "defaultMessage": "Remove due date"
        },
        removeBothDates: {
            "id": "business-timeline.timeline-view.list-item-menu-option.remove-dates-option.remove-both-dates",
            "defaultMessage": "Remove both dates"
        },
        requiredDates: {
            "id": "business-timeline.timeline-view.list-item-menu-option.remove-dates-option.required-dates",
            "defaultMessage": "Dates are required for this issue"
        }
    });
    var $b773b891fdee25eb$export$2e2bcd8739ae039 = $b773b891fdee25eb$var$messages;
});
parcelRegister("4Enec", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a5c1e583c567a3b0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $koVbs;
    var $evzMt;
    var $cl738;
    var $3FdtR;
    var $djUsO;
    const $a5c1e583c567a3b0$var$ReparentMenuOption = ({ id: id, Option: MenuOption, setCloseMenu: setCloseMenu, updateIssueParent: updateIssueParent })=>{
        const [{ issueParentMap: issueParentMap }] = (0, (0, parcelRequire("evzMt")).useIssueParentMap)();
        const parentId = issueParentMap.get(id);
        const [{ issuesMap: issuesMap }] = (0, (0, parcelRequire("cl738")).useIssuesMap)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const issue = issuesMap.get(id);
        if (!issue || !parentId) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(MenuOption, {
            label: formatMessage((0, (0, parcelRequire("3FdtR")).default).changeParentIssue)
        }, ({ setInitialFocusRef: setInitialFocusRef })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("djUsO")).default), {
                id: id,
                level: issue.issueType.hierarchyLevel,
                parentId: parentId,
                setInitialFocusRef: setInitialFocusRef,
                setCloseMenu: setCloseMenu,
                updateIssueParent: updateIssueParent
            }));
    };
    var $a5c1e583c567a3b0$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($a5c1e583c567a3b0$var$ReparentMenuOption);
});
parcelRegister("3FdtR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$82c3b9aa1a482908$export$2e2bcd8739ae039);
    var $7VHMR;
    const $82c3b9aa1a482908$var$messages = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        changeParentIssue: {
            "id": "business-timeline.timeline-view.list-item-menu-option.reparent-menu-option.change-parent-issue",
            "defaultMessage": "Change parent issue"
        }
    });
    var $82c3b9aa1a482908$export$2e2bcd8739ae039 = $82c3b9aa1a482908$var$messages;
});
parcelRegister("djUsO", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ab4e4e0fb0fa90e2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lwMsT;
    var $7x24C;
    var $cl738;
    var $iNLbM;
    const $ab4e4e0fb0fa90e2$var$ReparentMenu = ({ id: id, parentId: parentId, level: level, setInitialFocusRef: setFocusRef, updateIssueParent: updateIssueParent, setCloseMenu: setCloseMenu })=>{
        const [{ issuesMap: issuesMap }] = (0, (0, parcelRequire("cl738")).useIssuesMap)();
        const [{ expandedItems: expandedItems }, { setIssueExpanded: setIssueExpanded }] = (0, (0, parcelRequire("iNLbM")).useHierarchyStore)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'option'
        });
        const filteredParentOptions = (0, $5uXOq.useMemo)(()=>{
            const candidateIssues = [];
            issuesMap.forEach((value, key)=>{
                if (parentId !== key && value.issueType.hierarchyLevel === level + 1) candidateIssues.push({
                    id: key,
                    iconUrl: value.issueType.iconUrl,
                    key: value.key,
                    summary: value.summary || '',
                    issueType: value.issueType.name
                });
            });
            return candidateIssues;
        }, [
            issuesMap,
            level,
            parentId
        ]);
        const onOptionSelect = (0, $5uXOq.useCallback)((event, option)=>{
            if (!expandedItems[option.id]) setIssueExpanded(option.id, true);
            updateIssueParent(id, {
                level: level,
                parentId: option.id,
                isMeatballsAction: true
            }, analyticsEvent);
            setCloseMenu(event);
        }, [
            analyticsEvent,
            expandedItems,
            id,
            level,
            setCloseMenu,
            setIssueExpanded,
            updateIssueParent
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7x24C")).default), {
            options: filteredParentOptions,
            onOptionSelect: onOptionSelect,
            inputRef: setFocusRef
        });
    };
    var $ab4e4e0fb0fa90e2$export$2e2bcd8739ae039 = $ab4e4e0fb0fa90e2$var$ReparentMenu;
});
parcelRegister("7x24C", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b2f86c65f8f1adb1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bWn3s;
    var $682zz;
    var $3IisA;
    var $l75AK;
    var $pbV7V;
    var $6Ll2T;
    var $ZuPvl;
    var $99gde;
    var $113Tq;
    var $8mGGj;
    var $loZC0;
    var $dqoiX;
    var $6s1PB;
    var $4R6GH;
    var $koVbs;
    var $coaU9;
    const $b2f86c65f8f1adb1$var$ChangeParentMenu = ({ searchTerm: searchTerm = '', options: options, actions: actions, isLoading: isLoading = false, isLocalFilterEnabled: isLocalFilterEnabled = true, inputRef: inputRef, onOptionSelect: onOptionSelect, onSearchChange: onSearchChange })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [filteredOptions, setFilteredOptions] = (0, $5uXOq.useState)(options);
        const [query, setQuery] = (0, $5uXOq.useState)((0, (0, parcelRequire("4R6GH")).fg)('jwm_timeline_meatball_reparent_menu') ? searchTerm : '');
        const ref = (0, $5uXOq.useRef)(null);
        (0, $5uXOq.useEffect)(()=>{
            if ((0, (0, parcelRequire("4R6GH")).fg)('jwm_timeline_meatball_reparent_menu')) {
                setQuery(searchTerm);
                if (!isLoading) setFilteredOptions(options);
            } else if (!isLoading) {
                setQuery('');
                setFilteredOptions(options);
            }
        }, [
            actions,
            options,
            isLoading,
            searchTerm
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!inputRef) ref.current?.focus();
        }, [
            inputRef
        ]);
        const handleChange = (0, $5uXOq.useCallback)((e)=>{
            const { value: value } = e.target;
            if ((0, (0, parcelRequire("4R6GH")).fg)('jwm_timeline_meatball_reparent_menu')) {
                onSearchChange?.(value);
                if (isLocalFilterEnabled) {
                    const lowerCaseValue = String(value.toLocaleLowerCase());
                    setQuery(value);
                    setFilteredOptions(options.filter((option)=>`${option.key} ${option.summary}`.toLocaleLowerCase().includes(lowerCaseValue)));
                }
            } else {
                const lowerCaseValue = String(value.toLocaleLowerCase());
                setQuery(value);
                setFilteredOptions(options.filter((option)=>`${option.key} ${option.summary}`.toLocaleLowerCase().includes(lowerCaseValue)));
            }
        }, [
            isLocalFilterEnabled,
            onSearchChange,
            options
        ]);
        const handleKeyDown = (0, $5uXOq.useCallback)((e)=>{
            if (e.key === 'Escape' && query !== '') {
                setQuery('');
                setFilteredOptions(options);
            }
        }, [
            options,
            query
        ]);
        const renderActionButton = (0, $5uXOq.useCallback)((action, tooltipProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3IisA")).default), {
                ...tooltipProps,
                key: action.label,
                onClick: action.callback,
                ...(0, (0, parcelRequire("4R6GH")).fg)('platform_button_item-add-ufo-metrics') ? {
                    interactionName: 'timeline-reparent-option-clicked'
                } : {}
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
                xcss: $b2f86c65f8f1adb1$var$optionContainerStyles
            }, action.label)), []);
        const renderOptionButton = (0, $5uXOq.useCallback)((option, tooltipProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3IisA")).default), {
                ...tooltipProps,
                "aria-label": formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("coaU9")).default).optionLabelIssueTermRefresh : (0, (0, parcelRequire("coaU9")).default).optionLabel, {
                    type: option.issueType,
                    key: option.key,
                    summary: option.summary
                }),
                key: option.id,
                onClick: (e)=>onOptionSelect(e, option),
                ...(0, (0, parcelRequire("4R6GH")).fg)('platform_button_item-add-ufo-metrics') ? {
                    interactionName: 'timeline-reparent-option-clicked'
                } : {}
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
                xcss: $b2f86c65f8f1adb1$var$optionContainerStyles
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("img", {
                src: option.iconUrl,
                alt: option.issueType
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
                as: "span"
            }, option.key), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
                as: "span",
                xcss: $b2f86c65f8f1adb1$var$optionStyles
            }, option.summary))), [
            formatMessage,
            onOptionSelect
        ]);
        const hasActions = actions && actions.length !== 0;
        const hasOptions = filteredOptions.length !== 0;
        const renderedOptions = (0, $5uXOq.useMemo)(()=>filteredOptions.slice(0, 20), [
            filteredOptions
        ]);
        const searchIssueMessage = (0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("coaU9")).default).searchIssuesIssueTermRefresh : (0, (0, parcelRequire("coaU9")).default).searchIssues;
        const inputLabelWithLoadingMessage = (0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("coaU9")).default).inputLabelWithLoadingIssueTermRefresh : (0, (0, parcelRequire("coaU9")).default).inputLabelWithLoading;
        const inputPlaceholderMessage = (0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("coaU9")).default).inputPlaceholderIssueTermRefresh : (0, (0, parcelRequire("coaU9")).default).inputPlaceholder;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            xcss: $b2f86c65f8f1adb1$var$containerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l75AK")).default), {
            spacing: "compact"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            xcss: $b2f86c65f8f1adb1$var$inputWrapperStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8mGGj")).default), {
            ref: inputRef ? (0, (0, parcelRequire("bWn3s")).mergeRefs)([
                inputRef,
                ref
            ]) : ref,
            value: query,
            ...(0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-post-project-a11y-fix') ? {
                'aria-label': isLoading ? formatMessage(inputLabelWithLoadingMessage) : formatMessage(searchIssueMessage),
                'aria-describedby': 'timeline-change-parent-menu-search-instructions'
            } : {
                ...isLoading ? {
                    'aria-label': formatMessage(inputLabelWithLoadingMessage)
                } : {}
            },
            placeholder: (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-post-project-a11y-fix') ? formatMessage(searchIssueMessage) : formatMessage(inputPlaceholderMessage),
            elemBeforeInput: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
                xcss: $b2f86c65f8f1adb1$var$iconContainerStyles
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("682zz"))))), {
                label: (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-post-project-a11y-fix') ? '' : formatMessage((0, (0, parcelRequire("coaU9")).default).searchIconLabel),
                color: "var(--ds-icon, #44546F)"
            })),
            role: "searchbox",
            onChange: handleChange,
            onKeyDown: handleKeyDown
        }), (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-post-project-a11y-fix') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dqoiX")).ScreenReaderText), {
            as: "span",
            id: "timeline-change-parent-menu-search-instructions"
        }, formatMessage((0, (0, parcelRequire("coaU9")).default).searchDescribedBy)) : null), isLoading ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("pbV7V")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            xcss: $b2f86c65f8f1adb1$var$emptyWrapperStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("113Tq")).default), {
            interactionName: "load",
            label: formatMessage((0, (0, parcelRequire("coaU9")).default).loading)
        }))) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-post-project-a11y-fix') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dqoiX")).ScreenReaderText), {
            role: "status",
            "aria-atomic": "true"
        }, formatMessage((0, (0, parcelRequire("coaU9")).default).optionsAvailable, {
            count: filteredOptions.length + (actions ? actions.length : 0)
        })) : null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            xcss: $b2f86c65f8f1adb1$var$optionListStyles,
            ...(0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-post-project-a11y-fix') ? {
                role: 'presentation'
            } : {}
        }, !hasOptions && !hasActions ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("pbV7V")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            xcss: [
                $b2f86c65f8f1adb1$var$emptyWrapperStyles,
                $b2f86c65f8f1adb1$var$noOptionStyles
            ]
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ZuPvl")).default), {
            color: "color.text.subtle"
        }, formatMessage((0, (0, parcelRequire("coaU9")).default).noResults)))) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, hasOptions ? (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-post-project-a11y-fix') ? renderedOptions.map((option)=>option.summary.length > 16 ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("loZC0")).default), {
                key: option.id,
                content: option.summary
            }, (tooltipProps)=>renderOptionButton(option, tooltipProps)) : renderOptionButton(option)) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("pbV7V")).default), null, renderedOptions.map((option)=>option.summary.length > 16 ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("loZC0")).default), {
                key: option.id,
                content: option.summary
            }, (tooltipProps)=>renderOptionButton(option, tooltipProps)) : renderOptionButton(option))) : null)), hasActions ? (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-post-project-a11y-fix') ? actions.map((action)=>action.label.length > 16 ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("loZC0")).default), {
                key: action.label,
                content: action.label
            }, (tooltipProps)=>renderActionButton(action, tooltipProps)) : renderActionButton(action)) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("pbV7V")).default), {
            hasSeparator: hasOptions
        }, actions.map((action)=>action.label.length > 16 ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("loZC0")).default), {
                key: action.label,
                content: action.label
            }, (tooltipProps)=>renderActionButton(action, tooltipProps)) : renderActionButton(action))) : null)));
    };
    const $b2f86c65f8f1adb1$var$containerStyles = (0, (0, parcelRequire("99gde")).xcss)({
        width: '275px',
        backgroundColor: 'elevation.surface',
        boxShadow: 'elevation.shadow.overlay',
        borderRadius: '5px'
    });
    const $b2f86c65f8f1adb1$var$inputWrapperStyles = (0, (0, parcelRequire("99gde")).xcss)({
        padding: 'space.150',
        paddingLeft: 'space.200',
        paddingRight: 'space.200',
        borderBottom: '2px solid',
        borderColor: 'color.border'
    });
    const $b2f86c65f8f1adb1$var$iconContainerStyles = (0, (0, parcelRequire("99gde")).xcss)({
        display: 'flex',
        padding: 'space.100',
        paddingRight: 'space.025'
    });
    const $b2f86c65f8f1adb1$var$optionListStyles = (0, (0, parcelRequire("99gde")).xcss)({
        maxHeight: '252px',
        overflow: 'auto'
    });
    const $b2f86c65f8f1adb1$var$optionContainerStyles = (0, (0, parcelRequire("99gde")).xcss)({
        display: 'flex',
        alignItems: 'center',
        width: '100%',
        gap: 'space.150',
        paddingTop: 'space.100',
        paddingBottom: 'space.100',
        paddingLeft: 'space.050',
        paddingRight: 'space.050'
    });
    const $b2f86c65f8f1adb1$var$optionStyles = (0, (0, parcelRequire("99gde")).xcss)({
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis'
    });
    const $b2f86c65f8f1adb1$var$emptyWrapperStyles = (0, (0, parcelRequire("99gde")).xcss)({
        display: 'flex',
        width: '100%',
        height: '100%',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: 'space.100',
        marginBottom: 'space.100'
    });
    const $b2f86c65f8f1adb1$var$noOptionStyles = (0, (0, parcelRequire("99gde")).xcss)({
        paddingTop: 'space.025',
        paddingBottom: 'space.025'
    });
    var $b2f86c65f8f1adb1$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($b2f86c65f8f1adb1$var$ChangeParentMenu);
});
parcelRegister("8mGGj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$af711023521e2d75$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $2cjvv;
    var $9EfCw;
    const $af711023521e2d75$var$analyticsParams = {
        componentName: 'textField',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    };
    const $af711023521e2d75$var$Textfield = (0, $5uXOq.forwardRef)((props, ref)=>{
        const { appearance: appearance = 'standard', className: className, elemAfterInput: elemAfterInput, elemBeforeInput: elemBeforeInput, isCompact: isCompact = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, isReadOnly: isReadOnly = false, isRequired: isRequired = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onMouseDown: onMouseDown, placeholder: placeholder, testId: testId, width: width, ...spreadProps } = props;
        const inputRef = (0, $5uXOq.useRef)(null);
        const handleOnFocus = (0, (0, parcelRequire("2cjvv")).usePlatformLeafEventHandler)({
            fn: (event)=>{
                onFocus && onFocus(event);
            },
            action: 'focused',
            ...$af711023521e2d75$var$analyticsParams
        });
        const handleOnBlur = (0, (0, parcelRequire("2cjvv")).usePlatformLeafEventHandler)({
            fn: (event)=>{
                onBlur && onBlur(event);
            },
            action: 'blurred',
            ...$af711023521e2d75$var$analyticsParams
        });
        const handleOnMouseDown = (0, $5uXOq.useCallback)((event)=>{
            const target = event.target;
            if (target.tagName !== 'INPUT') event.preventDefault();
            if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
            onMouseDown && onMouseDown(event);
        }, [
            onMouseDown,
            isDisabled
        ]);
        const setInputRef = (0, $5uXOq.useCallback)((inputElement)=>{
            inputRef.current = inputElement;
            if (!ref) return;
            if (typeof ref === 'object') ref.current = inputElement;
            if (typeof ref === 'function') ref(inputElement);
        }, [
            ref
        ]);
        const containerStyles = (0, $5uXOq.useMemo)(()=>(0, (0, parcelRequire("9EfCw")).containerStyles)(appearance, width), [
            appearance,
            width
        ]);
        const inputStyle = (0, (0, parcelRequire("9EfCw")).inputStyles)();
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            role: "presentation",
            "data-disabled": isDisabled ? isDisabled : undefined,
            "data-invalid": isInvalid ? isInvalid : undefined,
            "data-ds--text-field--container": true,
            "data-testid": testId && `${testId}-container`,
            onMouseDown: handleOnMouseDown,
            css: containerStyles,
            className: className
        }, elemBeforeInput, (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            ...spreadProps,
            "aria-invalid": isInvalid ? isInvalid : undefined,
            css: inputStyle,
            "data-compact": isCompact ? isCompact : undefined,
            "data-ds--text-field--input": true,
            "data-monospaced": isMonospaced ? isMonospaced : undefined,
            "data-testid": testId,
            disabled: isDisabled,
            name: name,
            onBlur: handleOnBlur,
            onChange: onChange,
            onFocus: handleOnFocus,
            placeholder: placeholder,
            readOnly: isReadOnly,
            ref: setInputRef,
            required: isRequired
        }), elemAfterInput));
    });
    var $af711023521e2d75$export$2e2bcd8739ae039 = $af711023521e2d75$var$Textfield;
});
parcelRegister("9EfCw", function(module, exports) {
    $parcel$export(module.exports, "containerStyles", ()=>$a7502c1f5abf97ed$export$5972a68b6e54f38f);
    $parcel$export(module.exports, "inputStyles", ()=>$a7502c1f5abf97ed$export$3eeb47dc8e6249d9);
    const $a7502c1f5abf97ed$var$backgroundColor = {
        standard: `var(--ds-background-input, ${(0, $72ba03e317f3d228$export$e655ef011c4aa1a2)})`,
        subtle: 'transparent',
        none: 'transparent'
    };
    const $a7502c1f5abf97ed$var$backgroundColorFocus = {
        standard: `var(--ds-background-input-pressed, ${(0, $72ba03e317f3d228$export$29a4f05edc054374)})`,
        subtle: `var(--ds-background-input-pressed, ${(0, $72ba03e317f3d228$export$29a4f05edc054374)})`,
        none: 'transparent'
    };
    const $a7502c1f5abf97ed$var$backgroundColorHover = {
        standard: `var(--ds-background-input-hovered, ${(0, $72ba03e317f3d228$export$3e51e8f1440314ba)})`,
        subtle: `var(--ds-background-input-hovered, ${(0, $72ba03e317f3d228$export$3e51e8f1440314ba)})`,
        none: 'transparent'
    };
    const $a7502c1f5abf97ed$var$borderColor = {
        standard: `var(--ds-border-input, ${(0, $72ba03e317f3d228$export$d6447c357493214f)})`,
        subtle: 'transparent',
        none: 'transparent'
    };
    const $a7502c1f5abf97ed$var$borderColorFocus = {
        standard: `var(--ds-border-focused, ${(0, $72ba03e317f3d228$export$215b7063051591f1)})`,
        subtle: `var(--ds-border-focused, ${(0, $72ba03e317f3d228$export$215b7063051591f1)})`,
        none: 'transparent'
    };
    const $a7502c1f5abf97ed$var$borderColorHover = {
        standard: `var(--ds-border-input, ${(0, $72ba03e317f3d228$export$d6447c357493214f)})`,
        subtle: "var(--ds-border-input, transparent)",
        none: 'transparent'
    };
    const $a7502c1f5abf97ed$var$getContainerTextBgAndBorderColor = (appearance)=>({
            backgroundColor: $a7502c1f5abf97ed$var$backgroundColor[appearance],
            borderColor: $a7502c1f5abf97ed$var$borderColor[appearance],
            color: `var(--ds-text, ${0, $72ba03e317f3d228$export$fbda843f0a27fe96})`,
            cursor: 'text',
            '&:hover:not([data-disabled])': {
                backgroundColor: $a7502c1f5abf97ed$var$backgroundColorHover[appearance],
                borderColor: $a7502c1f5abf97ed$var$borderColorHover[appearance]
            },
            '&:focus-within:not([data-disabled])': {
                backgroundColor: $a7502c1f5abf97ed$var$backgroundColorFocus[appearance],
                borderColor: $a7502c1f5abf97ed$var$borderColorFocus[appearance],
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$a7502c1f5abf97ed$var$borderColorFocus[appearance]}`
            },
            '&[data-disabled]': {
                color: `var(--ds-text-disabled, ${0, $72ba03e317f3d228$export$5f71e19f3a7ad9de})`,
                cursor: 'not-allowed',
                ...appearance === 'standard' && {
                    backgroundColor: `var(--ds-background-disabled, ${0, $72ba03e317f3d228$export$e655ef011c4aa1a2})`,
                    borderColor: `var(--ds-background-disabled, ${0, $72ba03e317f3d228$export$e655ef011c4aa1a2})`
                }
            },
            '&[data-invalid], &[data-invalid]:hover': {
                borderColor: `var(--ds-border-danger, ${0, $72ba03e317f3d228$export$2010d0fb4295b346})`,
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-danger, ${0, $72ba03e317f3d228$export$2010d0fb4295b346})`}`
            },
            '&[data-invalid]:focus-within': {
                backgroundColor: `var(--ds-background-input-pressed, ${0, $72ba03e317f3d228$export$29a4f05edc054374})`,
                borderColor: `var(--ds-border-focused, ${0, $72ba03e317f3d228$export$215b7063051591f1})`,
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-focused, ${0, $72ba03e317f3d228$export$215b7063051591f1})`}`
            },
            '@media screen and (-ms-high-contrast: active)': {
                '&[data-invalid]:focus-within': {
                    borderColor: 'Highlight'
                },
                '&:focus-within': {
                    borderColor: 'Highlight'
                },
                '&[data-disabled]': {
                    borderColor: 'GrayText'
                }
            }
        });
    const $a7502c1f5abf97ed$var$widthMap = {
        xsmall: 80,
        small: 160,
        medium: 240,
        large: 320,
        xlarge: 480
    };
    const $a7502c1f5abf97ed$var$getMaxWidth = (width)=>!width ? `100%` : width in $a7502c1f5abf97ed$var$widthMap ? $a7502c1f5abf97ed$var$widthMap[width] : +width;
    const $a7502c1f5abf97ed$export$5972a68b6e54f38f = (appearance, width)=>({
            alignItems: 'center',
            ...$a7502c1f5abf97ed$var$getContainerTextBgAndBorderColor(appearance),
            borderRadius: 3,
            borderWidth: "var(--ds-border-width, 1px)",
            ...appearance !== 'none' ? {
                padding: `${"var(--ds-border-width, 1px)"} 0`
            } : {},
            borderStyle: appearance === 'none' ? 'none' : 'solid',
            boxSizing: 'border-box',
            display: 'flex',
            flex: '1 1 100%',
            font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
            justifyContent: 'space-between',
            maxWidth: $a7502c1f5abf97ed$var$getMaxWidth(width),
            overflow: 'hidden',
            transition: `background-color 0.2s ease-in-out, border-color 0.2s ease-in-out`,
            wordWrap: 'break-word',
            verticalAlign: 'top',
            pointerEvents: 'auto'
        });
    const $a7502c1f5abf97ed$export$3eeb47dc8e6249d9 = ()=>({
            backgroundColor: 'transparent',
            border: 0,
            boxSizing: 'border-box',
            color: 'inherit',
            cursor: 'inherit',
            font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
            minWidth: '0',
            outline: 'none',
            width: '100%',
            '&[data-monospaced]': {
                fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)"
            },
            '&[data-compact]': {
                padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}`
            },
            '&:not([data-compact])': {
                padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-075, 6px)"}`
            },
            '&[disabled]': {
                WebkitTextFillColor: `var(--ds-text-disabled, ${0, $72ba03e317f3d228$export$5f71e19f3a7ad9de})`
            },
            '&::-ms-clear': {
                display: 'none'
            },
            '&:invalid': {
                boxShadow: 'none'
            },
            '&:placeholder-shown': {
                textOverflow: 'ellipsis'
            },
            '&::placeholder': {
                color: `var(--ds-text-subtlest, ${0, $72ba03e317f3d228$export$f563ee71e9ee74cd})`,
                '&:disabled': {
                    color: `var(--ds-text-disabled, ${0, $72ba03e317f3d228$export$5f71e19f3a7ad9de})`
                }
            },
            '@media screen and (-ms-high-contrast: active)': {
                '&[disabled]': {
                    color: 'GrayText'
                }
            }
        });
});
parcelRegister("dqoiX", function(module, exports) {
    $parcel$export(module.exports, "visuallyHiddenStyles", ()=>$11827e0613b04108$export$8dd524ceb40e3d16);
    $parcel$export(module.exports, "ScreenReaderText", ()=>$11827e0613b04108$export$88fad6aa294f111c);
    $parcel$export(module.exports, "ScreenReaderCaption", ()=>$11827e0613b04108$export$200c8e5d652aa9af);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $11827e0613b04108$export$8dd524ceb40e3d16 = {
        clip: 'rect(1px, 1px, 1px, 1px)',
        clipPath: 'inset(50%)',
        height: '1px',
        width: '1px',
        margin: '-1px',
        overflow: 'hidden',
        padding: 0,
        position: 'absolute'
    };
    const $11827e0613b04108$export$88fad6aa294f111c = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_ogto7mnp _mkrz1wmp _4t3it94y _1bsbt94y _19pk1n1a _2hwx1n1a _otyr1n1a _18u01n1a _1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswstnw",
                __cmplp.className
            ])
        });
    });
    const $11827e0613b04108$export$200c8e5d652aa9af = (0, $5uXOq.forwardRef)(({ as: C = "caption", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_ogto7mnp _mkrz1wmp _4t3it94y _1bsbt94y _19pk1n1a _2hwx1n1a _otyr1n1a _18u01n1a _1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswstnw",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("coaU9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cf59bd23a53c723c$export$2e2bcd8739ae039);
    var $7VHMR;
    var $cf59bd23a53c723c$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        noResults: {
            "id": "roadmap.timeline-table-kit.change-parent-menu.no-results",
            "defaultMessage": "No results"
        },
        optionsAvailable: {
            "id": "roadmap.timeline-table-kit.change-parent-menu.options-available",
            "defaultMessage": "{count} {count, plural, one {option} other {options}} available."
        },
        inputPlaceholder: {
            "id": "roadmap.timeline-table-kit.change-parent-menu.input-placeholder",
            "defaultMessage": "Select issue"
        },
        searchIssues: {
            "id": "roadmap.timeline-table-kit.change-parent-menu.search-issues",
            "defaultMessage": "Search issues"
        },
        searchDescribedBy: {
            "id": "roadmap.timeline-table-kit.change-parent-menu.search-described-by",
            "defaultMessage": "Typing any character in this field will update the search"
        },
        inputLabelWithLoading: {
            "id": "roadmap.timeline-table-kit.change-parent-menu.input-label-with-loading",
            "defaultMessage": "Currently loading issues."
        },
        searchIconLabel: {
            "id": "roadmap.timeline-table-kit.change-parent-menu.search-icon-label",
            "defaultMessage": "Search icon"
        },
        loading: {
            "id": "roadmap.timeline-table-kit.change-parent-menu.loading",
            "defaultMessage": "Loading"
        },
        optionLabel: {
            "id": "roadmap.timeline-table-kit.change-parent-menu.option-label",
            "defaultMessage": "Issue {type} {key} {summary}"
        },
        inputPlaceholderIssueTermRefresh: {
            "id": "roadmap.timeline-table-kit.change-parent-menu.input-placeholder-issue-term-refresh",
            "defaultMessage": "Select work item"
        },
        inputLabelWithLoadingIssueTermRefresh: {
            "id": "roadmap.timeline-table-kit.change-parent-menu.input-label-with-loading-issue-term-refresh",
            "defaultMessage": "Currently loading work item."
        },
        searchIssuesIssueTermRefresh: {
            "id": "roadmap.timeline-table-kit.change-parent-menu.search-issues-issue-term-refresh",
            "defaultMessage": "Search work items"
        },
        optionLabelIssueTermRefresh: {
            "id": "roadmap.timeline-table-kit.change-parent-menu.option-label-issue-term-refresh",
            "defaultMessage": "{type} {key} {summary}"
        }
    });
});
parcelRegister("5V7mf", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a69bd5799021630a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $4R6GH;
    var $jxXX4;
    var $f49Ec;
    var $1BygW;
    const $a69bd5799021630a$var$ListItemModal = ({ id: id, optionId: optionId, triggerRef: triggerRef, onItemUpdate: onItemUpdate, setCloseModal: setCloseModal })=>{
        switch(optionId){
            case 0, (0, parcelRequire("jxXX4")).EDIT_DATES:
                return (0, (0, parcelRequire("4R6GH")).fg)('jwm_timeline_meatballs_date_update') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("f49Ec")).AsyncEditDatesModal), {
                    id: id,
                    isOpen: true,
                    setCloseModal: setCloseModal,
                    triggerRef: triggerRef,
                    onItemUpdate: onItemUpdate
                }) : null;
            case 0, (0, parcelRequire("jxXX4")).EDIT_DEPENDENCY:
                return (0, (0, parcelRequire("4R6GH")).fg)('jwm_timeline_meatballs_edit_dependency') ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1BygW")).default), {
                    id: id,
                    isOpen: true,
                    setCloseModal: setCloseModal,
                    triggerRef: triggerRef
                }) : null;
            default:
                return null;
        }
    };
    var $a69bd5799021630a$export$2e2bcd8739ae039 = $a69bd5799021630a$var$ListItemModal;
});
parcelRegister("f49Ec", function(module, exports) {
    $parcel$export(module.exports, "AsyncEditDatesModal", ()=>$333454c2f8e9fea7$export$2df1e612e7d0be8c);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $1jUsD;
    const $333454c2f8e9fea7$export$d0a2df64dacd307 = (0, (0, parcelRequire("1jUsD")).lazyAfterPaint)(()=>(parcelRequire("ffPnK")), {
        ssr: false,
        moduleId: "./src/packages/business/timeline/src/ui/timeline-view/list-item-modal/edit-dates-modal/index.tsx"
    });
    const $333454c2f8e9fea7$export$2df1e612e7d0be8c = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "edit-dates-modal",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($333454c2f8e9fea7$export$d0a2df64dacd307, props));
});
parcelRegister("ffPnK", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("3nOh0").then(()=>parcelRequire('6MFry'));
});
parcelRegister("1BygW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a1c54636ffdf5d22$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bkUsp;
    var $8zOmE;
    var $g5X3G;
    var $g4Eew;
    var $cl738;
    var $7zHmC;
    var $400cb;
    const $a1c54636ffdf5d22$var$EditDependencyModal = ({ id: id, isOpen: isOpen, triggerRef: triggerRef, setCloseModal: setCloseModal })=>{
        const [{ issuesMap: issuesMap }] = (0, (0, parcelRequire("cl738")).useIssuesMap)();
        const issue = issuesMap.get(id);
        const { create: create } = (0, (0, parcelRequire("7zHmC")).useCreateDependency)();
        const { remove: remove } = (0, (0, parcelRequire("400cb")).useRemoveDependency)();
        const options = (0, $5uXOq.useMemo)(()=>{
            const candidateIssues = [];
            issuesMap.forEach((value, key)=>{
                if (key !== id) candidateIssues.push({
                    id: key,
                    iconUrl: value.issueType.iconUrl,
                    issueKey: value.key,
                    issueSummary: value.summary || '',
                    issueType: value.issueType.name
                });
            });
            return candidateIssues;
        }, [
            id,
            issuesMap
        ]);
        const dependencies = (0, $5uXOq.useMemo)(()=>{
            const linkedDependencies = [];
            issue?.issueLinks?.forEach((link)=>{
                const { inward: inward, outward: outward } = link;
                const issueId = inward ? inward.issueId : outward?.issueId;
                const linkedIssue = issuesMap.get(issueId);
                if (linkedIssue) linkedDependencies.push({
                    id: issueId,
                    iconUrl: linkedIssue.issueType.iconUrl,
                    issueKey: linkedIssue.key,
                    issueSummary: linkedIssue.summary || '',
                    issueType: linkedIssue.issueType.name,
                    link: inward ? (0, (0, parcelRequire("bkUsp")).INWARD_LINK_DIRECTION) : (0, (0, parcelRequire("bkUsp")).OUTWARD_LINK_DIRECTION)
                });
            });
            return linkedDependencies;
        }, [
            issue?.issueLinks,
            issuesMap
        ]);
        const createDependencyPayload = (0, $5uXOq.useCallback)((dependency)=>dependency.link === (0, (0, parcelRequire("bkUsp")).OUTWARD_LINK_DIRECTION) ? {
                inwardIssueId: (0, (0, parcelRequire("g5X3G")).toIssueId)(id),
                outwardIssueId: (0, (0, parcelRequire("g5X3G")).toIssueId)(dependency.id)
            } : {
                inwardIssueId: (0, (0, parcelRequire("g5X3G")).toIssueId)(dependency.id),
                outwardIssueId: (0, (0, parcelRequire("g5X3G")).toIssueId)(id)
            }, [
            id
        ]);
        const onAddDependency = (0, $5uXOq.useCallback)(({ dependency: dependency, analyticsEvent: analyticsEvent })=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'editDependencyModalAdd');
            create({
                input: createDependencyPayload(dependency)
            });
            return true;
        }, [
            create,
            createDependencyPayload
        ]);
        const onUnlinkDependency = (0, $5uXOq.useCallback)(({ dependency: dependency, analyticsEvent: analyticsEvent })=>{
            const unlinkedDependency = issue?.issueLinks?.find((link)=>{
                const { inward: inward, outward: outward } = link;
                return dependency.link === (0, (0, parcelRequire("bkUsp")).OUTWARD_LINK_DIRECTION) ? outward?.issueId : inward?.issueId;
            });
            if (unlinkedDependency) {
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(analyticsEvent, 'editDependencyModalUnlink');
                const payload = createDependencyPayload(dependency);
                remove({
                    ...payload,
                    linkId: unlinkedDependency.issueLinkId
                });
            }
        }, [
            createDependencyPayload,
            issue,
            remove
        ]);
        if (!issue) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("g4Eew")).default), {
            isOpen: isOpen,
            issueType: issue.issueType.name,
            issueKey: issue.key,
            issueSummary: issue.summary || '',
            iconUrl: issue.issueType.iconUrl,
            dependencies: dependencies,
            options: options,
            shouldReturnFocus: triggerRef,
            setCloseModal: setCloseModal,
            onAddDependency: onAddDependency,
            onUnlinkDependency: onUnlinkDependency
        });
    };
    var $a1c54636ffdf5d22$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($a1c54636ffdf5d22$var$EditDependencyModal);
});
parcelRegister("bkUsp", function(module, exports) {
    $parcel$export(module.exports, "INWARD_LINK_DIRECTION", ()=>$1e4a31a537751af2$export$b5e2b68b0fa7f1c8);
    $parcel$export(module.exports, "OUTWARD_LINK_DIRECTION", ()=>$1e4a31a537751af2$export$5dec99d71ec794ba);
    $parcel$export(module.exports, "BOTH_LINK_DIRECTION", ()=>$1e4a31a537751af2$export$6cdcf74878b11d34);
    $parcel$export(module.exports, "IssueLinkDirectionTypes", ()=>$1e4a31a537751af2$export$4b7bcc27238c61b9);
    const $1e4a31a537751af2$export$b5e2b68b0fa7f1c8 = 'INWARD';
    const $1e4a31a537751af2$export$5dec99d71ec794ba = 'OUTWARD';
    const $1e4a31a537751af2$export$6cdcf74878b11d34 = 'BOTH';
    const $1e4a31a537751af2$export$4b7bcc27238c61b9 = {
        [$1e4a31a537751af2$export$b5e2b68b0fa7f1c8]: $1e4a31a537751af2$export$b5e2b68b0fa7f1c8,
        [$1e4a31a537751af2$export$5dec99d71ec794ba]: $1e4a31a537751af2$export$5dec99d71ec794ba,
        [$1e4a31a537751af2$export$6cdcf74878b11d34]: $1e4a31a537751af2$export$6cdcf74878b11d34
    };
});
parcelRegister("g4Eew", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0fe5b5b89f32d1f0$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $42Si9;
    var $9jNMw;
    var $7VnW8;
    var $8mTwd;
    var $2X0Jj;
    var $lF2mK;
    var $y2I8T;
    var $bTmOP;
    var $2Yyer;
    var $4qSaV;
    var $i9cxd;
    var $2TrWf;
    var $4uJJm;
    var $6Ll2T;
    var $3srSR;
    var $2NYPZ;
    var $k0Jvh;
    var $ZuPvl;
    var $99gde;
    var $gN6Vx;
    var $113Tq;
    var $loZC0;
    var $dqoiX;
    var $6s1PB;
    var $4R6GH;
    var $koVbs;
    var $bkUsp;
    var $3RqVj;
    var $6EaIJ;
    var $eLoZY;
    var $kKx5I;
    const $0fe5b5b89f32d1f0$var$EditDependencyModal = ({ isOpen: isOpen, issueType: issueType, issueKey: issueKey, issueSummary: issueSummary, iconUrl: iconUrl, dependencies: dependencies, options: options, isLoading: isLoading, errors: errors, shouldReturnFocus: shouldReturnFocus, onClose: onClose, setCloseModal: setCloseModal, onAddDependency: onAddDependency, onUnlinkDependency: onUnlinkDependency })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4uJJm")).default), null, isOpen ? (0, ($parcel$interopDefault($5uXOq))).createElement($0fe5b5b89f32d1f0$var$EditDependencyModalContent, {
            issueType: issueType,
            issueKey: issueKey,
            issueSummary: issueSummary,
            iconUrl: iconUrl,
            dependencies: dependencies,
            options: options,
            isLoading: isLoading,
            errors: errors,
            shouldReturnFocus: shouldReturnFocus,
            onClose: onClose,
            setCloseModal: setCloseModal,
            onAddDependency: onAddDependency,
            onUnlinkDependency: onUnlinkDependency
        }) : null);
    const $0fe5b5b89f32d1f0$var$EditDependencyModalContent = ({ issueType: issueType, issueKey: issueKey, issueSummary: issueSummary, iconUrl: iconUrl, dependencies: dependencies, options: options, errors: errors, isLoading: isLoading, shouldReturnFocus: shouldReturnFocus, onClose: onClose, setCloseModal: setCloseModal, onAddDependency: onAddDependency, onUnlinkDependency: onUnlinkDependency })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [linkType, setLinkType] = (0, $5uXOq.useState)(null);
        const [linkIssue, setLinkIssue] = (0, $5uXOq.useState)(null);
        const [isAddButtonLoading, setIsAddButtonLoading] = (0, $5uXOq.useState)(false);
        const linkTypeSelect = (0, $5uXOq.useRef)(null);
        const unlinkButtonRefs = (0, $5uXOq.useMemo)(()=>dependencies.map(()=>(0, $5uXOq.createRef)()), [
            dependencies
        ]);
        const focusNextUnlinkButton = (0, $5uXOq.useCallback)((index)=>{
            if (unlinkButtonRefs.length - 1 !== index) for(let i = index + 1; i < unlinkButtonRefs.length; i++){
                if (!unlinkButtonRefs?.[i].current?.disabled) return unlinkButtonRefs[i].current?.focus();
            }
            linkTypeSelect.current?.focus();
        }, [
            unlinkButtonRefs
        ]);
        const linkTypeOptions = (0, $5uXOq.useMemo)(()=>[
                {
                    value: (0, (0, parcelRequire("bkUsp")).INWARD_LINK_DIRECTION),
                    label: formatMessage((0, (0, parcelRequire("eLoZY")).default).blockedBy)
                },
                {
                    value: (0, (0, parcelRequire("bkUsp")).OUTWARD_LINK_DIRECTION),
                    label: formatMessage((0, (0, parcelRequire("eLoZY")).default).blocks)
                }
            ], [
            formatMessage
        ]);
        const addDependencyOptions = (0, $5uXOq.useMemo)(()=>options.filter((option)=>option.issueKey !== issueKey && !dependencies.find((dependency)=>dependency.issueKey === option.issueKey)), [
            options,
            issueKey,
            dependencies
        ]);
        (0, $5uXOq.useEffect)(()=>{
            setLinkType(null);
            setLinkIssue(null);
        }, [
            dependencies
        ]);
        const handleOnClose = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
            setCloseModal();
            onClose?.({
                event: event,
                analyticsEvent: analyticsEvent
            });
        }, [
            onClose,
            setCloseModal
        ]);
        const handleLinkTypeChange = (0, $5uXOq.useCallback)((value)=>{
            setLinkType(value);
        }, []);
        const handleLinkIssueChange = (0, $5uXOq.useCallback)((value)=>{
            setLinkIssue(value);
        }, []);
        const handleAddDependency = (0, $5uXOq.useCallback)(async (event, analyticsEvent)=>{
            if (linkIssue && linkType) {
                linkTypeSelect.current?.focus();
                const newDependency = {
                    ...linkIssue,
                    link: linkType.value
                };
                setIsAddButtonLoading(true);
                const success = await onAddDependency({
                    dependency: newDependency,
                    event: event,
                    analyticsEvent: analyticsEvent
                });
                setIsAddButtonLoading(false);
                if (success) {
                    setLinkIssue(null);
                    setLinkType(null);
                }
            }
        }, [
            linkIssue,
            linkType,
            onAddDependency
        ]);
        const getLinkIssueLabel = (0, $5uXOq.useCallback)((option)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6EaIJ")).default), {
                issueType: option.issueType,
                issueKey: option.issueKey,
                issueSummary: option.issueSummary,
                iconUrl: option.iconUrl
            }), []);
        const onStopPropagation = (0, $5uXOq.useCallback)((event)=>{
            event.stopPropagation();
        }, []);
        const isLoadingLabelMessage = (0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("eLoZY")).default).isLoadingLabelIssueTermRefresh : (0, (0, parcelRequire("eLoZY")).default).isLoadingLabel;
        const finishedLoadingLabelMessage = (0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("eLoZY")).default).finishedLoadingLabelIssueTermRefresh : (0, (0, parcelRequire("eLoZY")).default).finishedLoadingLabel;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bTmOP")).default), {
            onClose: handleOnClose,
            label: formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("eLoZY")).default).modalLabelIssueTermRefresh : (0, (0, parcelRequire("eLoZY")).default).modalLabel, {
                issueType: issueType,
                issueKey: issueKey,
                issueSummary: issueSummary,
                isLoading: isLoading ? formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("eLoZY")).default).isLoadingLabelIssueTermRefresh : (0, (0, parcelRequire("eLoZY")).default).isLoadingLabel) : ''
            }),
            shouldReturnFocus: shouldReturnFocus
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("i9cxd")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2TrWf")).default), null, formatMessage((0, (0, parcelRequire("eLoZY")).default).title)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9jNMw")).default), {
            appearance: "subtle",
            label: formatMessage((0, (0, parcelRequire("eLoZY")).default).closeIconLabel),
            spacing: "compact",
            icon: (0, ($parcel$interopDefault((0, parcelRequire("2X0Jj"))))),
            onClick: handleOnClose,
            interactionName: "timeline-edit-dependency-close-clicked"
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2Yyer")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dqoiX")).ScreenReaderText), {
            "aria-live": "polite"
        }, errors.length === 0 ? formatMessage((0, (0, parcelRequire("eLoZY")).default).fixedWarnings) : '', errors.map((error)=>formatMessage((0, (0, parcelRequire("eLoZY")).default).errorMessage, {
                error: error
            }))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("dqoiX")).ScreenReaderText), {
            "aria-live": "polite"
        }, formatMessage(isLoading ? isLoadingLabelMessage : finishedLoadingLabelMessage)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0Jvh")).default), {
            space: "space.300"
        }, errors.length !== 0 ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("k0Jvh")).default), {
            space: "space.150"
        }, errors.map((error)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
                xcss: $0fe5b5b89f32d1f0$var$warningStyles,
                key: error
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("y2I8T"))))), {
                color: "var(--ds-icon-warning, #E56910)",
                label: formatMessage((0, (0, parcelRequire("eLoZY")).default).warning)
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ZuPvl")).default), {
                weight: "medium"
            }, error)))) : null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            as: "span"
        }, formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("eLoZY")).default).descriptionIssueTermRefresh : (0, (0, parcelRequire("eLoZY")).default).description)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7VnW8")).Label), {
            htmlFor: ""
        }, formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("eLoZY")).default).selectedIssueLabelIssueTermRefresh : (0, (0, parcelRequire("eLoZY")).default).selectedIssueLabel)), issueSummary.length > 16 ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("loZC0")).default), {
            content: issueSummary
        }, (tooltipProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3RqVj")).default), {
                tooltipProps: tooltipProps,
                issueType: issueType,
                issueKey: issueKey,
                issueSummary: issueSummary,
                iconUrl: iconUrl
            })) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3RqVj")).default), {
            issueType: issueType,
            issueKey: issueKey,
            issueSummary: issueSummary,
            iconUrl: iconUrl
        })), !isLoading ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, dependencies.length !== 0 ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7VnW8")).Label), {
            htmlFor: ""
        }, formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("eLoZY")).default).linkedIssuesLabelIssueTermRefresh : (0, (0, parcelRequire("eLoZY")).default).linkedIssuesLabel)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2NYPZ")).default), {
            templateColumns: "auto minmax(0, 1fr) auto",
            alignItems: "center",
            rowGap: "space.100",
            columnGap: "space.150",
            xcss: $0fe5b5b89f32d1f0$var$linkedIssuesContainer,
            testId: "roadmap.timeline-table-kit.ui.edit-dependency-modal.linked-issues"
        }, dependencies.map((dependency, index)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), {
                key: dependency.link + dependency.issueKey
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3srSR")).default), {
                alignItems: "center",
                gap: "space.075"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8mTwd")).default), {
                icon: (0, ($parcel$interopDefault((0, parcelRequire("lF2mK"))))),
                appearance: "grayBold",
                shape: "circle",
                size: "24",
                label: ""
            }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
                xcss: $0fe5b5b89f32d1f0$var$noWrapStyles
            }, formatMessage(dependency.link === (0, (0, parcelRequire("bkUsp")).OUTWARD_LINK_DIRECTION) ? (0, (0, parcelRequire("eLoZY")).default).blocks : (0, (0, parcelRequire("eLoZY")).default).blockedBy))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("loZC0")).default), {
                content: dependency.issueSummary
            }, (tooltipProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3RqVj")).default), {
                    tooltipProps: tooltipProps,
                    issueType: dependency.issueType,
                    issueKey: dependency.issueKey,
                    issueSummary: dependency.issueSummary,
                    iconUrl: dependency.iconUrl
                })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
                xcss: $0fe5b5b89f32d1f0$var$unlinkButtonStyles
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kKx5I")).default), {
                ref: unlinkButtonRefs[index],
                dependency: dependency,
                onUnlinkDependency: onUnlinkDependency,
                focusNextUnlinkButton: ()=>focusNextUnlinkButton(index)
            })))))) : null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7VnW8")).Label), {
            htmlFor: ""
        }, formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("eLoZY")).default).linkIssueLabelIssueTermRefresh : (0, (0, parcelRequire("eLoZY")).default).linkIssueLabel)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3srSR")).default), {
            gap: "space.150",
            alignItems: "center",
            xcss: $0fe5b5b89f32d1f0$var$linkIssueContainerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            xcss: [
                $0fe5b5b89f32d1f0$var$noWrapStyles,
                $0fe5b5b89f32d1f0$var$directionSelectStyles
            ],
            onKeyDown: onStopPropagation
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gN6Vx")).default), {
            ref: linkTypeSelect,
            value: linkType,
            isClearable: true,
            placeholder: formatMessage((0, (0, parcelRequire("eLoZY")).default).linkTypePlaceholder),
            menuPosition: "fixed",
            options: linkTypeOptions,
            onChange: handleLinkTypeChange,
            label: (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-post-project-a11y-fix') ? formatMessage((0, (0, parcelRequire("eLoZY")).default).linkTypePlaceholder) : formatMessage((0, (0, parcelRequire("eLoZY")).default).selectLabel)
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            xcss: [
                $0fe5b5b89f32d1f0$var$noWrapStyles,
                $0fe5b5b89f32d1f0$var$flexGrow
            ],
            onKeyDown: onStopPropagation
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gN6Vx")).default), {
            value: linkIssue,
            isClearable: true,
            placeholder: formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("eLoZY")).default).selectIssuePlaceholderIssueTermRefresh : (0, (0, parcelRequire("eLoZY")).default).selectIssuePlaceholder),
            menuPosition: "fixed",
            options: addDependencyOptions,
            formatOptionLabel: getLinkIssueLabel,
            getOptionValue: (option)=>option.issueKey,
            getOptionLabel: (option)=>formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("eLoZY")).default).issueInfoLabelIssueTermRefresh : (0, (0, parcelRequire("eLoZY")).default).issueInfoLabel, {
                    issueType: option.issueType,
                    issueKey: option.issueKey,
                    issueSummary: option.issueSummary
                }),
            onChange: handleLinkIssueChange,
            label: (0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline-post-project-a11y-fix') ? formatMessage((0, (0, parcelRequire("eLoZY")).default).selectIssuePlaceholder) : formatMessage((0, (0, parcelRequire("eLoZY")).default).selectLabel)
        })), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42Si9")).default), {
            appearance: "primary",
            isLoading: isAddButtonLoading,
            isDisabled: !linkType || !linkIssue,
            onClick: handleAddDependency,
            "aria-label": formatMessage((0, (0, parcelRequire("eLoZY")).default).addAriaLabel),
            interactionName: "timeline-edit-dependency-add-clicked"
        }, formatMessage((0, (0, parcelRequire("eLoZY")).default).add))))) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            xcss: $0fe5b5b89f32d1f0$var$spinnerStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("113Tq")).default), {
            interactionName: "load",
            size: "large",
            label: formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("eLoZY")).default).isLoadingLabelIssueTermRefresh : (0, (0, parcelRequire("eLoZY")).default).isLoadingLabel)
        })))), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4qSaV")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42Si9")).default), {
            appearance: "subtle",
            onClick: handleOnClose,
            interactionName: "timeline-edit-dependency-ok-clicked"
        }, formatMessage((0, (0, parcelRequire("eLoZY")).default).close)))));
    };
    const $0fe5b5b89f32d1f0$var$warningStyles = (0, (0, parcelRequire("99gde")).xcss)({
        display: 'flex',
        alignItems: 'center',
        gap: 'space.100'
    });
    const $0fe5b5b89f32d1f0$var$noWrapStyles = (0, (0, parcelRequire("99gde")).xcss)({
        whiteSpace: 'nowrap'
    });
    const $0fe5b5b89f32d1f0$var$linkedIssuesContainer = (0, (0, parcelRequire("99gde")).xcss)({
        overflow: 'auto',
        maxHeight: '194px',
        paddingBottom: 'space.050'
    });
    const $0fe5b5b89f32d1f0$var$unlinkButtonStyles = (0, (0, parcelRequire("99gde")).xcss)({
        marginRight: 'space.050',
        marginTop: 'space.050',
        marginBottom: 'space.050'
    });
    const $0fe5b5b89f32d1f0$var$directionSelectStyles = (0, (0, parcelRequire("99gde")).xcss)({
        minWidth: '160px'
    });
    const $0fe5b5b89f32d1f0$var$flexGrow = (0, (0, parcelRequire("99gde")).xcss)({
        flex: '1'
    });
    const $0fe5b5b89f32d1f0$var$linkIssueContainerStyles = (0, (0, parcelRequire("99gde")).xcss)({
        marginBottom: 'space.025'
    });
    const $0fe5b5b89f32d1f0$var$spinnerStyles = (0, (0, parcelRequire("99gde")).xcss)({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 'space.300'
    });
    $0fe5b5b89f32d1f0$var$EditDependencyModal.defaultProps = {
        errors: [],
        isLoading: false,
        shouldReturnFocus: true
    };
    var $0fe5b5b89f32d1f0$export$2e2bcd8739ae039 = $0fe5b5b89f32d1f0$var$EditDependencyModal;
});
parcelRegister("7VnW8", function(module, exports) {
    $parcel$export(module.exports, "Label", ()=>$bc5fcc4d894aeca1$export$b04be29aa201d4f5);
    $parcel$export(module.exports, "Legend", ()=>$bc5fcc4d894aeca1$export$ed247974535929c7);
    var $f8Sb3;
    function $bc5fcc4d894aeca1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $bc5fcc4d894aeca1$var$fieldsetLabelStyles = {
        name: "zjewl9",
        styles: "display:inline-block;color:var(--ds-text-subtle, #44546F);font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);font-weight:var(--ds-font-weight-bold, 700);margin-block-end:var(--ds-space-050, 4px);margin-block-start:var(--ds-space-0, 0px)"
    };
    const $bc5fcc4d894aeca1$export$b04be29aa201d4f5 = ({ children: children, htmlFor: htmlFor, id: id, testId: testId })=>(0, (0, parcelRequire("f8Sb3")).jsx)("label", {
            css: $bc5fcc4d894aeca1$var$fieldsetLabelStyles,
            id: id,
            htmlFor: htmlFor,
            "data-testid": testId
        }, children);
    const $bc5fcc4d894aeca1$export$ed247974535929c7 = ({ children: children })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("legend", {
            css: $bc5fcc4d894aeca1$var$fieldsetLabelStyles
        }, children);
    };
    var $bc5fcc4d894aeca1$export$2e2bcd8739ae039 = $bc5fcc4d894aeca1$export$b04be29aa201d4f5;
});
parcelRegister("8mTwd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0a09f664556613cb$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $2oS3b;
    function $0a09f664556613cb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $0a09f664556613cb$var$sizeMap = {
        '16': {
            name: "157xhr7",
            styles: "width:16px;height:16px"
        },
        '24': {
            name: "rrel8y",
            styles: "width:24px;height:24px"
        },
        '32': {
            name: "68x97p",
            styles: "width:32px;height:32px"
        },
        '40': {
            name: "1mfsro6",
            styles: "width:40px;height:40px"
        },
        '48': {
            name: "18jhpep",
            styles: "width:48px;height:48px"
        }
    };
    const $0a09f664556613cb$var$appearanceMap = {
        grayBold: {
            name: "algye9",
            styles: "background-color:var(--ds-background-accent-gray-bolder, #626F86);color:var(--ds-icon-inverse, #FFFFFF)"
        },
        limeBold: {
            name: "a86nvv",
            styles: "background-color:var(--ds-background-accent-lime-bolder, #5B7F24);color:var(--ds-icon-inverse, #FFFFFF)"
        },
        greenBold: {
            name: "13e2qqr",
            styles: "background-color:var(--ds-background-accent-green-bolder, #1F845A);color:var(--ds-icon-inverse, #FFFFFF)"
        },
        blueBold: {
            name: "jpsdma",
            styles: "background-color:var(--ds-background-accent-blue-bolder, #0C66E4);color:var(--ds-icon-inverse, #FFFFFF)"
        },
        redBold: {
            name: "1bg8y7a",
            styles: "background-color:var(--ds-background-accent-red-bolder, #C9372C);color:var(--ds-icon-inverse, #FFFFFF)"
        },
        purpleBold: {
            name: "19bo3lb",
            styles: "background-color:var(--ds-background-accent-purple-bolder, #6E5DC6);color:var(--ds-icon-inverse, #FFFFFF)"
        },
        magentaBold: {
            name: "1l16rgo",
            styles: "background-color:var(--ds-background-accent-magenta-bolder, #AE4787);color:var(--ds-icon-inverse, #FFFFFF)"
        },
        tealBold: {
            name: "7kw5zl",
            styles: "background-color:var(--ds-background-accent-teal-bolder, #227D9B);color:var(--ds-icon-inverse, #FFFFFF)"
        },
        orangeBold: {
            name: "h77eay",
            styles: "background-color:var(--ds-background-accent-orange-bolder, #C25100);color:var(--ds-icon-inverse, #FFFFFF)"
        },
        yellowBold: {
            name: "sbe4w3",
            styles: "background-color:var(--ds-background-accent-yellow-bolder, #946F00);color:var(--ds-icon-inverse, #FFFFFF)"
        },
        gray: {
            name: "yxgei8",
            styles: "background-color:var(--ds-background-accent-gray-subtler, #DCDFE4);color:var(--ds-icon-accent-gray, #758195)"
        },
        lime: {
            name: "o9c6oh",
            styles: "background-color:var(--ds-background-accent-lime-subtler, #D3F1A7);color:var(--ds-icon-accent-lime, #6A9A23)"
        },
        orange: {
            name: "szqzk5",
            styles: "background-color:var(--ds-background-accent-orange-subtler, #FEDEC8);color:var(--ds-icon-accent-orange, #E56910)"
        },
        magenta: {
            name: "o6ptuw",
            styles: "background-color:var(--ds-background-accent-magenta-subtler, #FDD0EC);color:var(--ds-icon-accent-magenta, #CD519D)"
        },
        green: {
            name: "157dg7e",
            styles: "background-color:var(--ds-background-accent-green-subtler, #BAF3DB);color:var(--ds-icon-accent-green, #22A06B)"
        },
        blue: {
            name: "x3nujl",
            styles: "background-color:var(--ds-background-accent-blue-subtler, #CCE0FF);color:var(--ds-icon-accent-blue, #1D7AFC)"
        },
        red: {
            name: "zqoyws",
            styles: "background-color:var(--ds-background-accent-red-subtler, #FFD5D2);color:var(--ds-icon-accent-red, #C9372C)"
        },
        purple: {
            name: "fitjkd",
            styles: "background-color:var(--ds-background-accent-purple-subtler, #DFD8FD);color:var(--ds-icon-accent-purple, #8270DB)"
        },
        teal: {
            name: "b3m1ww",
            styles: "background-color:var(--ds-background-accent-teal-subtler, #C6EDFB);color:var(--ds-icon-accent-teal, #2898BD)"
        },
        yellow: {
            name: "1j18jub",
            styles: "background-color:var(--ds-background-accent-yellow-subtler, #F8E6A0);color:var(--ds-icon-accent-yellow, #B38600)"
        }
    };
    const $0a09f664556613cb$var$shapeMap = {
        square: {
            name: "vwdoqr",
            styles: "border-radius:var(--ds-border-radius-100, 4px)"
        },
        circle: {
            name: "i2ucdk",
            styles: "border-radius:var(--ds-border-radius-circle, 32032px)"
        }
    };
    const $0a09f664556613cb$var$iconTileStyles = {
        name: "ykimcl",
        styles: "display:inline-flex;box-sizing:border-box;align-items:center;justify-content:center"
    };
    function $0a09f664556613cb$export$2e2bcd8739ae039(props) {
        const { icon: Icon, label: label, appearance: appearance, size: size = '24', shape: shape = 'square', LEGACY_fallbackComponent: LEGACY_fallbackComponent } = props;
        const ExpandedIcon = Icon;
        if (LEGACY_fallbackComponent && !(0, (0, parcelRequire("2oS3b")).fg)('platform-visual-refresh-icons')) return LEGACY_fallbackComponent;
        else return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: [
                $0a09f664556613cb$var$iconTileStyles,
                $0a09f664556613cb$var$appearanceMap[appearance],
                $0a09f664556613cb$var$sizeMap[size],
                $0a09f664556613cb$var$shapeMap[shape]
            ]
        }, (0, (0, parcelRequire("f8Sb3")).jsx)(ExpandedIcon, {
            color: "currentColor",
            label: label,
            spacing: "spacious",
            shouldScale: true
        }));
    }
});
parcelRegister("gN6Vx", function(module, exports) {
    $parcel$export(module.exports, "SelectWithoutAnalytics", ()=>$8c2db7d5c814622a$export$d1de3b251ccaa8a3);
    $parcel$export(module.exports, "default", ()=>$8c2db7d5c814622a$export$2e2bcd8739ae039);
    var $4ZiMV;
    var $dvXtt;
    var $7GEKO;
    var $kWDSl;
    var $2s2ld;
    const $8c2db7d5c814622a$var$packageName = "platform-pkg";
    const $8c2db7d5c814622a$var$packageVersion = "0.0.0-use.local";
    const $8c2db7d5c814622a$export$d1de3b251ccaa8a3 = (0, (0, parcelRequire("2s2ld")).default)((0, (0, parcelRequire("kWDSl")).default));
    const $8c2db7d5c814622a$var$createAndFireEventOnAtlaskit = (0, (0, parcelRequire("4ZiMV")).default)('atlaskit');
    const $8c2db7d5c814622a$var$Select = (0, (0, parcelRequire("dvXtt")).default)({
        componentName: 'select',
        packageName: $8c2db7d5c814622a$var$packageName,
        packageVersion: $8c2db7d5c814622a$var$packageVersion
    })((0, (0, parcelRequire("7GEKO")).default)({
        onChange: $8c2db7d5c814622a$var$createAndFireEventOnAtlaskit({
            action: 'changed',
            actionSubject: 'option',
            attributes: {
                componentName: 'select',
                packageName: $8c2db7d5c814622a$var$packageName,
                packageVersion: $8c2db7d5c814622a$var$packageVersion
            }
        })
    })($8c2db7d5c814622a$export$d1de3b251ccaa8a3));
    var $8c2db7d5c814622a$export$2e2bcd8739ae039 = $8c2db7d5c814622a$var$Select;
});
parcelRegister("kWDSl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4f69c74a471c03f5$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "useAsync", ()=>(parcelRequire("6vVYA")).default);
    var $5uXOq = parcelRequire("5uXOq");
    var $3uzTK;
    var $6vVYA;
    var $dIVa9;
    const $4f69c74a471c03f5$var$AsyncSelect = (0, $5uXOq.forwardRef)((props, ref)=>{
        const isAsyncEnabledInBaseSelect = props.isAsync && !props.options && (!!props.loadOptions || !!props.defaultOptions);
        const stateManagedProps = (0, (0, parcelRequire("6vVYA")).default)(props);
        let selectAsyncProps = !props.isAsync || isAsyncEnabledInBaseSelect ? stateManagedProps : props;
        const selectProps = (0, (0, parcelRequire("dIVa9")).default)(selectAsyncProps);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3uzTK")).default), {
            ref: ref,
            ...selectProps
        });
    });
    var $4f69c74a471c03f5$export$2e2bcd8739ae039 = $4f69c74a471c03f5$var$AsyncSelect;
});
parcelRegister("3uzTK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9c6e1da0a778b1ba$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $2oS3b;
    var $3vyhk;
    var $g6yke;
    var $2JKLA;
    var $aFNBY;
    var $gSXak;
    var $iTuaH;
    var $fenYw;
    var $b4pnV;
    var $by9Y7;
    var $crsHE;
    var $gZxD5;
    var $g2UN3;
    const $9c6e1da0a778b1ba$export$9c21a3269931e1e6 = {
        'aria-live': 'polite',
        backspaceRemovesValue: true,
        blurInputOnSelect: (0, (0, parcelRequire("g2UN3")).isTouchCapable)(),
        captureMenuScroll: !(0, (0, parcelRequire("g2UN3")).isTouchCapable)(),
        classNames: {},
        closeMenuOnSelect: true,
        closeMenuOnScroll: false,
        components: {},
        controlShouldRenderValue: true,
        escapeClearsValue: false,
        filterOption: (0, (0, parcelRequire("by9Y7")).createFilter)(),
        formatGroupLabel: (0, (0, parcelRequire("g6yke")).formatGroupLabel),
        getOptionLabel: (0, (0, parcelRequire("g6yke")).getOptionLabel),
        getOptionValue: (0, (0, parcelRequire("g6yke")).getOptionValue),
        isDisabled: false,
        isLoading: false,
        isMulti: false,
        isRtl: false,
        isSearchable: true,
        isOptionDisabled: (0, (0, parcelRequire("g6yke")).isOptionDisabled),
        loadingMessage: ()=>'Loading...',
        maxMenuHeight: 300,
        minMenuHeight: 140,
        menuIsOpen: false,
        menuPlacement: 'bottom',
        menuPosition: 'absolute',
        menuShouldBlockScroll: false,
        menuShouldScrollIntoView: !(0, (0, parcelRequire("g2UN3")).isMobileDevice)(),
        noOptionsMessage: ()=>'No options',
        openMenuOnFocus: false,
        openMenuOnClick: true,
        options: [],
        pageSize: 5,
        placeholder: 'Select...',
        screenReaderStatus: ({ count: count })=>`${count} result${count !== 1 ? 's' : ''} available`,
        styles: {},
        tabIndex: 0,
        tabSelectsValue: true,
        unstyled: false
    };
    function $9c6e1da0a778b1ba$var$toCategorizedOption(props, option, selectValue, index) {
        const isDisabled = $9c6e1da0a778b1ba$var$isOptionDisabled(props, option, selectValue);
        const isSelected = $9c6e1da0a778b1ba$var$isOptionSelected(props, option, selectValue);
        const label = $9c6e1da0a778b1ba$var$getOptionLabel(props, option);
        const value = $9c6e1da0a778b1ba$var$getOptionValue(props, option);
        return {
            type: 'option',
            data: option,
            isDisabled: isDisabled,
            isSelected: isSelected,
            label: label,
            value: value,
            index: index
        };
    }
    function $9c6e1da0a778b1ba$var$buildCategorizedOptions(props, selectValue) {
        return props.options.map((groupOrOption, groupOrOptionIndex)=>{
            if ('options' in groupOrOption) {
                const categorizedOptions = groupOrOption.options.map((option, optionIndex)=>$9c6e1da0a778b1ba$var$toCategorizedOption(props, option, selectValue, optionIndex)).filter((categorizedOption)=>$9c6e1da0a778b1ba$var$isFocusable(props, categorizedOption));
                return categorizedOptions.length > 0 ? {
                    type: 'group',
                    data: groupOrOption,
                    options: categorizedOptions,
                    index: groupOrOptionIndex
                } : undefined;
            }
            const categorizedOption = $9c6e1da0a778b1ba$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
            return $9c6e1da0a778b1ba$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
        }).filter((0, (0, parcelRequire("g2UN3")).notNullish));
    }
    function $9c6e1da0a778b1ba$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
        return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
            if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>option.data));
            else optionsAccumulator.push(categorizedOption.data);
            return optionsAccumulator;
        }, []);
    }
    function $9c6e1da0a778b1ba$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
        return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
            if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>({
                    data: option.data,
                    id: `${optionId}-${categorizedOption.index}-${option.index}`
                })));
            else optionsAccumulator.push({
                data: categorizedOption.data,
                id: `${optionId}-${categorizedOption.index}`
            });
            return optionsAccumulator;
        }, []);
    }
    function $9c6e1da0a778b1ba$var$buildFocusableOptions(props, selectValue) {
        return $9c6e1da0a778b1ba$var$buildFocusableOptionsFromCategorizedOptions($9c6e1da0a778b1ba$var$buildCategorizedOptions(props, selectValue));
    }
    function $9c6e1da0a778b1ba$var$isFocusable(props, categorizedOption) {
        const { inputValue: inputValue = '' } = props;
        const { data: data, isSelected: isSelected, label: label, value: value } = categorizedOption;
        return (!$9c6e1da0a778b1ba$var$shouldHideSelectedOptions(props) || !isSelected) && $9c6e1da0a778b1ba$var$filterOption(props, {
            label: label,
            value: value,
            data: data
        }, inputValue);
    }
    function $9c6e1da0a778b1ba$var$getNextFocusedValue(state, nextSelectValue) {
        const { focusedValue: focusedValue, selectValue: lastSelectValue } = state;
        const lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
        if (lastFocusedIndex > -1) {
            const nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
            if (nextFocusedIndex > -1) return focusedValue;
            else if (lastFocusedIndex < nextSelectValue.length) return nextSelectValue[lastFocusedIndex];
        }
        return null;
    }
    function $9c6e1da0a778b1ba$var$getNextFocusedOption(state, options) {
        const { focusedOption: lastFocusedOption } = state;
        return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
    }
    const $9c6e1da0a778b1ba$var$getFocusedOptionId = (focusableOptionsWithIds, focusedOption)=>{
        const focusedOptionId = focusableOptionsWithIds.find((option)=>option.data === focusedOption)?.id;
        return focusedOptionId || null;
    };
    const $9c6e1da0a778b1ba$var$getOptionLabel = (props, data)=>{
        return props.getOptionLabel(data);
    };
    const $9c6e1da0a778b1ba$var$getOptionValue = (props, data)=>{
        return props.getOptionValue(data);
    };
    function $9c6e1da0a778b1ba$var$isOptionDisabled(props, option, selectValue) {
        return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
    }
    function $9c6e1da0a778b1ba$var$isOptionSelected(props, option, selectValue) {
        if (selectValue.indexOf(option) > -1) return true;
        if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
        const candidate = $9c6e1da0a778b1ba$var$getOptionValue(props, option);
        return selectValue.some((i)=>$9c6e1da0a778b1ba$var$getOptionValue(props, i) === candidate);
    }
    function $9c6e1da0a778b1ba$var$filterOption(props, option, inputValue) {
        return props.filterOption ? props.filterOption(option, inputValue) : true;
    }
    const $9c6e1da0a778b1ba$var$shouldHideSelectedOptions = (props)=>{
        const { hideSelectedOptions: hideSelectedOptions, isMulti: isMulti } = props;
        if (hideSelectedOptions === undefined) return isMulti;
        return hideSelectedOptions;
    };
    let $9c6e1da0a778b1ba$var$instanceId = 1;
    class $9c6e1da0a778b1ba$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
        static{
            this.defaultProps = $9c6e1da0a778b1ba$export$9c21a3269931e1e6;
        }
        constructor(props){
            super(props);
            this.state = {
                ariaSelection: null,
                focusedOption: null,
                focusedOptionId: null,
                focusableOptionsWithIds: [],
                focusedValue: null,
                inputIsHidden: false,
                isFocused: false,
                selectValue: [],
                clearFocusValueOnUpdate: false,
                prevWasFocused: false,
                inputIsHiddenAfterUpdate: undefined,
                prevProps: undefined,
                instancePrefix: ''
            };
            this.blockOptionHover = false;
            this.isComposing = false;
            this.initialTouchX = 0;
            this.initialTouchY = 0;
            this.openAfterFocus = false;
            this.scrollToFocusedOptionOnUpdate = false;
            this.isAppleDevice = (0, (0, parcelRequire("2oS3b")).fg)('design_system_select-a11y-improvement') ? (0, (0, parcelRequire("3vyhk")).isSafari)() : (0, (0, parcelRequire("3vyhk")).isAppleDevice)();
            this.controlRef = null;
            this.getControlRef = (ref)=>{
                this.controlRef = ref;
            };
            this.focusedOptionRef = null;
            this.getFocusedOptionRef = (ref)=>{
                this.focusedOptionRef = ref;
            };
            this.menuListRef = null;
            this.getMenuListRef = (ref)=>{
                this.menuListRef = ref;
            };
            this.inputRef = null;
            this.getInputRef = (ref)=>{
                this.inputRef = ref;
            };
            this.focus = this.focusInput;
            this.blur = this.blurInput;
            this.onChange = (newValue, actionMeta)=>{
                const { onChange: onChange, name: name } = this.props;
                actionMeta.name = name;
                this.ariaOnChange(newValue, actionMeta);
                onChange(newValue, actionMeta);
            };
            this.setValue = (newValue, action, option)=>{
                const { closeMenuOnSelect: closeMenuOnSelect, isMulti: isMulti, inputValue: inputValue } = this.props;
                this.onInputChange('', {
                    action: 'set-value',
                    prevInputValue: inputValue
                });
                if (closeMenuOnSelect) {
                    this.setState({
                        inputIsHiddenAfterUpdate: !isMulti
                    });
                    this.onMenuClose();
                }
                this.setState({
                    clearFocusValueOnUpdate: true
                });
                this.onChange(newValue, {
                    action: action,
                    option: option
                });
            };
            this.selectOption = (newValue)=>{
                const { blurInputOnSelect: blurInputOnSelect, isMulti: isMulti, name: name } = this.props;
                const { selectValue: selectValue } = this.state;
                const deselected = isMulti && this.isOptionSelected(newValue, selectValue);
                const isDisabled = this.isOptionDisabled(newValue, selectValue);
                if (deselected) {
                    const candidate = this.getOptionValue(newValue);
                    this.setValue((0, (0, parcelRequire("g2UN3")).multiValueAsValue)(selectValue.filter((i)=>this.getOptionValue(i) !== candidate)), 'deselect-option', newValue);
                } else if (!isDisabled) {
                    if (isMulti) this.setValue((0, (0, parcelRequire("g2UN3")).multiValueAsValue)([
                        ...selectValue,
                        newValue
                    ]), 'select-option', newValue);
                    else this.setValue((0, (0, parcelRequire("g2UN3")).singleValueAsValue)(newValue), 'select-option');
                } else {
                    this.ariaOnChange((0, (0, parcelRequire("g2UN3")).singleValueAsValue)(newValue), {
                        action: 'select-option',
                        option: newValue,
                        name: name
                    });
                    return;
                }
                if (blurInputOnSelect) this.blurInput();
            };
            this.removeValue = (removedValue)=>{
                const { isMulti: isMulti } = this.props;
                const { selectValue: selectValue } = this.state;
                const candidate = this.getOptionValue(removedValue);
                const newValueArray = selectValue.filter((i)=>this.getOptionValue(i) !== candidate);
                const newValue = (0, (0, parcelRequire("g2UN3")).valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
                this.onChange(newValue, {
                    action: 'remove-value',
                    removedValue: removedValue
                });
                this.focusInput();
            };
            this.clearValue = ()=>{
                const { selectValue: selectValue } = this.state;
                this.onChange((0, (0, parcelRequire("g2UN3")).valueTernary)(this.props.isMulti, [], null), {
                    action: 'clear',
                    removedValues: selectValue
                });
            };
            this.popValue = ()=>{
                const { isMulti: isMulti } = this.props;
                const { selectValue: selectValue } = this.state;
                const lastSelectedValue = selectValue[selectValue.length - 1];
                const newValueArray = selectValue.slice(0, selectValue.length - 1);
                const newValue = (0, (0, parcelRequire("g2UN3")).valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
                this.onChange(newValue, {
                    action: 'pop-value',
                    removedValue: lastSelectedValue
                });
            };
            this.getFocusedOptionId = (focusedOption)=>{
                return $9c6e1da0a778b1ba$var$getFocusedOptionId(this.state.focusableOptionsWithIds, focusedOption);
            };
            this.getFocusableOptionsWithIds = ()=>{
                return $9c6e1da0a778b1ba$var$buildFocusableOptionsWithIds($9c6e1da0a778b1ba$var$buildCategorizedOptions(this.props, this.state.selectValue), this.getElementId('option'));
            };
            this.getValue = ()=>this.state.selectValue;
            this.cx = (...args)=>(0, (0, parcelRequire("g2UN3")).classNames)(this.props.classNamePrefix, ...args);
            this.getOptionLabel = (data)=>{
                return $9c6e1da0a778b1ba$var$getOptionLabel(this.props, data);
            };
            this.getOptionValue = (data)=>{
                return $9c6e1da0a778b1ba$var$getOptionValue(this.props, data);
            };
            this.getStyles = (key, props)=>{
                const { unstyled: unstyled } = this.props;
                const base = (0, (0, parcelRequire("crsHE")).defaultStyles)[key](props, unstyled);
                base.boxSizing = 'border-box';
                const custom = this.props.styles[key];
                return custom ? custom(base, props) : base;
            };
            this.getClassNames = (key, props)=>this.props.classNames[key]?.(props);
            this.getElementId = (element)=>{
                return `${this.state.instancePrefix}-${element}`;
            };
            this.getComponents = ()=>{
                return (0, (0, parcelRequire("2JKLA")).defaultComponents)(this.props);
            };
            this.buildCategorizedOptions = ()=>$9c6e1da0a778b1ba$var$buildCategorizedOptions(this.props, this.state.selectValue);
            this.getCategorizedOptions = ()=>this.props.menuIsOpen ? this.buildCategorizedOptions() : [];
            this.buildFocusableOptions = ()=>$9c6e1da0a778b1ba$var$buildFocusableOptionsFromCategorizedOptions(this.buildCategorizedOptions());
            this.getFocusableOptions = ()=>this.props.menuIsOpen ? this.buildFocusableOptions() : [];
            this.ariaOnChange = (value, actionMeta)=>{
                this.setState({
                    ariaSelection: {
                        value: value,
                        ...actionMeta
                    }
                });
            };
            this.onMenuMouseDown = (event)=>{
                if (event.button !== 0) return;
                event.stopPropagation();
                event.preventDefault();
                this.focusInput();
            };
            this.onMenuMouseMove = (event)=>{
                this.blockOptionHover = false;
            };
            this.onControlMouseDown = (event)=>{
                if (event.defaultPrevented) {
                    if (!this.controlRef?.closest('[data-rbd-draggable-context-id]')) return;
                }
                const { openMenuOnClick: openMenuOnClick } = this.props;
                if (!this.state.isFocused) {
                    if (openMenuOnClick) this.openAfterFocus = true;
                    this.focusInput();
                } else if (!this.props.menuIsOpen) {
                    if (openMenuOnClick) this.openMenu('first');
                } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') this.onMenuClose();
                if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
            };
            this.onDropdownIndicatorMouseDown = (event)=>{
                if (event && event.type === 'mousedown' && event.button !== 0) return;
                if (this.props.isDisabled) return;
                const { isMulti: isMulti, menuIsOpen: menuIsOpen } = this.props;
                this.focusInput();
                if (menuIsOpen) {
                    this.setState({
                        inputIsHiddenAfterUpdate: !isMulti
                    });
                    this.onMenuClose();
                } else this.openMenu('first');
                event.preventDefault();
            };
            this.onClearIndicatorMouseDown = (event)=>{
                if (event && event.type === 'mousedown' && event.button !== 0) return;
                this.clearValue();
                event.preventDefault();
                this.openAfterFocus = false;
                if (event.type === 'touchend') this.focusInput();
                else setTimeout(()=>this.focusInput());
            };
            this.onScroll = (event)=>{
                if (typeof this.props.closeMenuOnScroll === 'boolean') {
                    if (event.target instanceof HTMLElement && (0, (0, parcelRequire("g2UN3")).isDocumentElement)(event.target)) this.props.onMenuClose();
                } else if (typeof this.props.closeMenuOnScroll === 'function') {
                    if (this.props.closeMenuOnScroll(event)) this.props.onMenuClose();
                }
            };
            this.onCompositionStart = ()=>{
                this.isComposing = true;
            };
            this.onCompositionEnd = ()=>{
                this.isComposing = false;
            };
            this.onTouchStart = ({ touches: touches })=>{
                const touch = touches && touches.item(0);
                if (!touch) return;
                this.initialTouchX = touch.clientX;
                this.initialTouchY = touch.clientY;
                this.userIsDragging = false;
            };
            this.onTouchMove = ({ touches: touches })=>{
                const touch = touches && touches.item(0);
                if (!touch) return;
                const deltaX = Math.abs(touch.clientX - this.initialTouchX);
                const deltaY = Math.abs(touch.clientY - this.initialTouchY);
                const moveThreshold = 5;
                this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
            };
            this.onTouchEnd = (event)=>{
                if (this.userIsDragging) return;
                if (this.controlRef && !this.controlRef.contains(event.target) && this.menuListRef && !this.menuListRef.contains(event.target)) this.blurInput();
                this.initialTouchX = 0;
                this.initialTouchY = 0;
            };
            this.onControlTouchEnd = (event)=>{
                if (this.userIsDragging) return;
                this.onControlMouseDown(event);
            };
            this.onClearIndicatorTouchEnd = (event)=>{
                if (this.userIsDragging) return;
                this.onClearIndicatorMouseDown(event);
            };
            this.onDropdownIndicatorTouchEnd = (event)=>{
                if (this.userIsDragging) return;
                this.onDropdownIndicatorMouseDown(event);
            };
            this.handleInputChange = (event)=>{
                const { inputValue: prevInputValue } = this.props;
                const inputValue = event.currentTarget.value;
                this.setState({
                    inputIsHiddenAfterUpdate: false
                });
                this.onInputChange(inputValue, {
                    action: 'input-change',
                    prevInputValue: prevInputValue
                });
                if (!this.props.menuIsOpen) this.onMenuOpen();
            };
            this.onInputFocus = (event)=>{
                if (this.props.onFocus) this.props.onFocus(event);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    isFocused: true
                });
                if (this.openAfterFocus || this.props.openMenuOnFocus) this.openMenu('first');
                this.openAfterFocus = false;
            };
            this.onInputBlur = (event)=>{
                const { inputValue: prevInputValue } = this.props;
                if (this.menuListRef && this.menuListRef.contains(document.activeElement)) {
                    this.inputRef.focus();
                    return;
                }
                if (this.props.onBlur) this.props.onBlur(event);
                this.onInputChange('', {
                    action: 'input-blur',
                    prevInputValue: prevInputValue
                });
                this.onMenuClose();
                this.setState({
                    focusedValue: null,
                    isFocused: false
                });
            };
            this.onOptionHover = (focusedOption)=>{
                if (this.blockOptionHover || this.state.focusedOption === focusedOption) return;
                const options = this.getFocusableOptions();
                const focusedOptionIndex = options.indexOf(focusedOption);
                this.setState({
                    focusedOption: focusedOption,
                    focusedOptionId: focusedOptionIndex > -1 ? this.getFocusedOptionId(focusedOption) : null
                });
            };
            this.shouldHideSelectedOptions = ()=>{
                return $9c6e1da0a778b1ba$var$shouldHideSelectedOptions(this.props);
            };
            this.onValueInputFocus = (e)=>{
                e.preventDefault();
                e.stopPropagation();
                this.focus();
            };
            this.onKeyDown = (event)=>{
                const { isMulti: isMulti, backspaceRemovesValue: backspaceRemovesValue, escapeClearsValue: escapeClearsValue, inputValue: inputValue, isClearable: isClearable, isDisabled: isDisabled, menuIsOpen: menuIsOpen, onKeyDown: onKeyDown, tabSelectsValue: tabSelectsValue, openMenuOnFocus: openMenuOnFocus } = this.props;
                const { focusedOption: focusedOption, focusedValue: focusedValue, selectValue: selectValue } = this.state;
                if (isDisabled) return;
                if (typeof onKeyDown === 'function') {
                    onKeyDown(event);
                    if (event.defaultPrevented) return;
                }
                this.blockOptionHover = true;
                switch(event.key){
                    case 'ArrowLeft':
                        if (!isMulti || inputValue) return;
                        this.focusValue('previous');
                        break;
                    case 'ArrowRight':
                        if (!isMulti || inputValue) return;
                        this.focusValue('next');
                        break;
                    case 'Delete':
                    case 'Backspace':
                        if (inputValue) return;
                        if (focusedValue) this.removeValue(focusedValue);
                        else {
                            if (!backspaceRemovesValue) return;
                            if (isMulti) this.popValue();
                            else if (isClearable) this.clearValue();
                        }
                        break;
                    case 'Tab':
                        if (this.isComposing) return;
                        if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || openMenuOnFocus && this.isOptionSelected(focusedOption, selectValue)) return;
                        this.selectOption(focusedOption);
                        break;
                    case 'Enter':
                        if (event.keyCode === 229) break;
                        if (menuIsOpen) {
                            if (!focusedOption) return;
                            if (this.isComposing) return;
                            this.selectOption(focusedOption);
                            break;
                        }
                        return;
                    case 'Escape':
                        if (menuIsOpen) {
                            this.setState({
                                inputIsHiddenAfterUpdate: false
                            });
                            this.onInputChange('', {
                                action: 'menu-close',
                                prevInputValue: inputValue
                            });
                            this.onMenuClose();
                        } else if (isClearable && escapeClearsValue) this.clearValue();
                        break;
                    case ' ':
                        if (inputValue) return;
                        if (!menuIsOpen) {
                            this.openMenu('first');
                            break;
                        }
                        if (!focusedOption) return;
                        this.selectOption(focusedOption);
                        break;
                    case 'ArrowUp':
                        if (menuIsOpen) this.focusOption('up');
                        else this.openMenu('last');
                        break;
                    case 'ArrowDown':
                        if (menuIsOpen) this.focusOption('down');
                        else this.openMenu('first');
                        break;
                    case 'PageUp':
                        if (!menuIsOpen) return;
                        this.focusOption('pageup');
                        break;
                    case 'PageDown':
                        if (!menuIsOpen) return;
                        this.focusOption('pagedown');
                        break;
                    case 'Home':
                        if (!menuIsOpen) return;
                        this.focusOption('first');
                        break;
                    case 'End':
                        if (!menuIsOpen) return;
                        this.focusOption('last');
                        break;
                    default:
                        return;
                }
                event.preventDefault();
            };
            this.state.instancePrefix = 'react-select-' + (this.props.instanceId || ++$9c6e1da0a778b1ba$var$instanceId);
            this.state.selectValue = (0, (0, parcelRequire("g2UN3")).cleanValue)(props.value);
            if (props.menuIsOpen && this.state.selectValue.length) {
                const focusableOptionsWithIds = this.getFocusableOptionsWithIds();
                const focusableOptions = this.buildFocusableOptions();
                const optionIndex = focusableOptions.indexOf(this.state.selectValue[0]);
                this.state.focusableOptionsWithIds = focusableOptionsWithIds;
                this.state.focusedOption = focusableOptions[optionIndex];
                this.state.focusedOptionId = $9c6e1da0a778b1ba$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
            }
        }
        static getDerivedStateFromProps(props, state) {
            const { prevProps: prevProps, clearFocusValueOnUpdate: clearFocusValueOnUpdate, inputIsHiddenAfterUpdate: inputIsHiddenAfterUpdate, ariaSelection: ariaSelection, isFocused: isFocused, prevWasFocused: prevWasFocused, instancePrefix: instancePrefix } = state;
            const { options: options, value: value, menuIsOpen: menuIsOpen, inputValue: inputValue, isMulti: isMulti } = props;
            const selectValue = (0, (0, parcelRequire("g2UN3")).cleanValue)(value);
            let newMenuOptionsState = {};
            if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                const focusableOptions = menuIsOpen ? $9c6e1da0a778b1ba$var$buildFocusableOptions(props, selectValue) : [];
                const focusableOptionsWithIds = menuIsOpen ? $9c6e1da0a778b1ba$var$buildFocusableOptionsWithIds($9c6e1da0a778b1ba$var$buildCategorizedOptions(props, selectValue), `${instancePrefix}-option`) : [];
                const focusedValue = clearFocusValueOnUpdate ? $9c6e1da0a778b1ba$var$getNextFocusedValue(state, selectValue) : null;
                const focusedOption = $9c6e1da0a778b1ba$var$getNextFocusedOption(state, focusableOptions);
                const focusedOptionId = $9c6e1da0a778b1ba$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
                newMenuOptionsState = {
                    selectValue: selectValue,
                    focusedOption: focusedOption,
                    focusedOptionId: focusedOptionId,
                    focusableOptionsWithIds: focusableOptionsWithIds,
                    focusedValue: focusedValue,
                    clearFocusValueOnUpdate: false
                };
            }
            const newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                inputIsHidden: inputIsHiddenAfterUpdate,
                inputIsHiddenAfterUpdate: undefined
            } : {};
            let newAriaSelection = ariaSelection;
            let hasKeptFocus = isFocused && prevWasFocused;
            if (isFocused && !hasKeptFocus) {
                newAriaSelection = {
                    value: (0, (0, parcelRequire("g2UN3")).valueTernary)(isMulti, selectValue, selectValue[0] || null),
                    options: selectValue,
                    action: 'initial-input-focus'
                };
                hasKeptFocus = !prevWasFocused;
            }
            if (ariaSelection?.action === 'initial-input-focus') newAriaSelection = null;
            return {
                ...newMenuOptionsState,
                ...newInputIsHiddenState,
                prevProps: props,
                ariaSelection: newAriaSelection,
                prevWasFocused: hasKeptFocus
            };
        }
        componentDidMount() {
            this.startListeningComposition();
            this.startListeningToTouch();
            if (this.props.closeMenuOnScroll && document && document.addEventListener) document.addEventListener('scroll', this.onScroll, true);
            if (this.props.autoFocus) this.focusInput();
            if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, (0, parcelRequire("g2UN3")).scrollIntoView)(this.menuListRef, this.focusedOptionRef);
        }
        componentDidUpdate(prevProps) {
            const { isDisabled: isDisabled, menuIsOpen: menuIsOpen } = this.props;
            const { isFocused: isFocused } = this.state;
            if (isFocused && !isDisabled && prevProps.isDisabled || isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
            if (isFocused && isDisabled && !prevProps.isDisabled) this.setState({
                isFocused: false
            }, this.onMenuClose);
            else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) this.setState({
                isFocused: true
            });
            if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                (0, (0, parcelRequire("g2UN3")).scrollIntoView)(this.menuListRef, this.focusedOptionRef);
                this.scrollToFocusedOptionOnUpdate = false;
            }
        }
        componentWillUnmount() {
            this.stopListeningComposition();
            this.stopListeningToTouch();
            document.removeEventListener('scroll', this.onScroll, true);
        }
        onMenuOpen() {
            this.props.onMenuOpen();
        }
        onMenuClose() {
            this.onInputChange('', {
                action: 'menu-close',
                prevInputValue: this.props.inputValue
            });
            this.props.onMenuClose();
        }
        onInputChange(newValue, actionMeta) {
            this.props.onInputChange(newValue, actionMeta);
        }
        focusInput() {
            if (!this.inputRef) return;
            this.inputRef.focus();
        }
        blurInput() {
            if (!this.inputRef) return;
            this.inputRef.blur();
        }
        openMenu(focusOption) {
            const { selectValue: selectValue, isFocused: isFocused } = this.state;
            const focusableOptions = this.buildFocusableOptions();
            let openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
            if (!this.props.isMulti) {
                const selectedIndex = focusableOptions.indexOf(selectValue[0]);
                if (selectedIndex > -1) openAtIndex = selectedIndex;
            }
            this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
            this.setState({
                inputIsHiddenAfterUpdate: false,
                focusedValue: null,
                focusedOption: focusableOptions[openAtIndex],
                focusedOptionId: this.getFocusedOptionId(focusableOptions[openAtIndex])
            }, ()=>this.onMenuOpen());
        }
        focusValue(direction) {
            const { selectValue: selectValue, focusedValue: focusedValue } = this.state;
            if (!this.props.isMulti) return;
            this.setState({
                focusedOption: null
            });
            let focusedIndex = selectValue.indexOf(focusedValue);
            if (!focusedValue) focusedIndex = -1;
            const lastIndex = selectValue.length - 1;
            let nextFocus = -1;
            if (!selectValue.length) return;
            switch(direction){
                case 'previous':
                    if (focusedIndex === 0) nextFocus = 0;
                    else if (focusedIndex === -1) nextFocus = lastIndex;
                    else nextFocus = focusedIndex - 1;
                    break;
                case 'next':
                    if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                    break;
            }
            this.setState({
                inputIsHidden: nextFocus !== -1,
                focusedValue: selectValue[nextFocus]
            });
        }
        focusOption(direction = 'first') {
            const { pageSize: pageSize } = this.props;
            const { focusedOption: focusedOption } = this.state;
            const options = this.getFocusableOptions();
            if (!options.length) return;
            let nextFocus = 0;
            let focusedIndex = options.indexOf(focusedOption);
            if (!focusedOption) focusedIndex = -1;
            if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
            else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
            else if (direction === 'pageup') {
                nextFocus = focusedIndex - pageSize;
                if (nextFocus < 0) nextFocus = 0;
            } else if (direction === 'pagedown') {
                nextFocus = focusedIndex + pageSize;
                if (nextFocus > options.length - 1) nextFocus = options.length - 1;
            } else if (direction === 'last') nextFocus = options.length - 1;
            this.scrollToFocusedOptionOnUpdate = true;
            this.setState({
                focusedOption: options[nextFocus],
                focusedValue: null,
                focusedOptionId: this.getFocusedOptionId(options[nextFocus])
            });
        }
        getTheme() {
            if (!this.props.theme) return 0, (0, parcelRequire("gZxD5")).defaultTheme;
            if (typeof this.props.theme === 'function') return this.props.theme((0, (0, parcelRequire("gZxD5")).defaultTheme));
            return {
                ...(0, (0, parcelRequire("gZxD5")).defaultTheme),
                ...this.props.theme
            };
        }
        getCommonProps() {
            const { clearValue: clearValue, cx: cx, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, selectOption: selectOption, setValue: setValue, props: props } = this;
            const { isMulti: isMulti, isRtl: isRtl, options: options } = props;
            const hasValue = this.hasValue();
            return {
                clearValue: clearValue,
                cx: cx,
                getStyles: getStyles,
                getClassNames: getClassNames,
                getValue: getValue,
                hasValue: hasValue,
                isMulti: isMulti,
                isRtl: isRtl,
                options: options,
                selectOption: selectOption,
                selectProps: props,
                setValue: setValue,
                theme: this.getTheme()
            };
        }
        hasValue() {
            const { selectValue: selectValue } = this.state;
            return selectValue.length > 0;
        }
        hasOptions() {
            return !!this.getFocusableOptions().length;
        }
        isClearable() {
            const { isClearable: isClearable, isMulti: isMulti } = this.props;
            if (isClearable === undefined) return isMulti;
            return isClearable;
        }
        isOptionDisabled(option, selectValue) {
            return $9c6e1da0a778b1ba$var$isOptionDisabled(this.props, option, selectValue);
        }
        isOptionSelected(option, selectValue) {
            return $9c6e1da0a778b1ba$var$isOptionSelected(this.props, option, selectValue);
        }
        filterOption(option, inputValue) {
            return $9c6e1da0a778b1ba$var$filterOption(this.props, option, inputValue);
        }
        formatOptionLabel(data, context) {
            if (typeof this.props.formatOptionLabel === 'function') {
                const { inputValue: inputValue } = this.props;
                const { selectValue: selectValue } = this.state;
                return this.props.formatOptionLabel(data, {
                    context: context,
                    inputValue: inputValue,
                    selectValue: selectValue
                });
            } else return this.getOptionLabel(data);
        }
        formatGroupLabel(data) {
            return this.props.formatGroupLabel(data);
        }
        startListeningComposition() {
            if (document && document.addEventListener) {
                document.addEventListener('compositionstart', this.onCompositionStart, false);
                document.addEventListener('compositionend', this.onCompositionEnd, false);
            }
        }
        stopListeningComposition() {
            if (document && document.removeEventListener) {
                document.removeEventListener('compositionstart', this.onCompositionStart);
                document.removeEventListener('compositionend', this.onCompositionEnd);
            }
        }
        startListeningToTouch() {
            if (document && document.addEventListener) {
                document.addEventListener('touchstart', this.onTouchStart, false);
                document.addEventListener('touchmove', this.onTouchMove, false);
                document.addEventListener('touchend', this.onTouchEnd, false);
            }
        }
        stopListeningToTouch() {
            if (document && document.removeEventListener) {
                document.removeEventListener('touchstart', this.onTouchStart);
                document.removeEventListener('touchmove', this.onTouchMove);
                document.removeEventListener('touchend', this.onTouchEnd);
            }
        }
        renderInput() {
            const { descriptionId: descriptionId, form: form, inputId: inputId, inputValue: inputValue, isDisabled: isDisabled, isInvalid: isInvalid, isRequired: isRequired, isSearchable: isSearchable, label: label, labelId: labelId, menuIsOpen: menuIsOpen, required: required, tabIndex: tabIndex = 0 } = this.props;
            const { Input: Input } = this.getComponents();
            const { inputIsHidden: inputIsHidden, ariaSelection: ariaSelection } = this.state;
            const { commonProps: commonProps } = this;
            const id = inputId || this.getElementId('input');
            const description = this.props['aria-describedby'] || descriptionId;
            const ariaAttributes = {
                'aria-autocomplete': 'both',
                'aria-errormessage': this.props['aria-errormessage'],
                'aria-expanded': menuIsOpen,
                'aria-haspopup': 'listbox',
                'aria-describedby': description,
                'aria-invalid': this.props['aria-invalid'] || isInvalid,
                'aria-label': this.props['aria-label'] || label,
                'aria-labelledby': this.props['aria-labelledby'] || labelId,
                'aria-required': required || isRequired,
                role: 'combobox',
                'aria-activedescendant': this.state.focusedOptionId || undefined,
                ...menuIsOpen && {
                    'aria-controls': this.getElementId('listbox')
                },
                ...!isSearchable && {
                    'aria-readonly': true
                },
                ...this.hasValue() ? ariaSelection?.action === 'initial-input-focus' && {
                    'aria-describedby': description ? [
                        description,
                        this.getElementId('live-region')
                    ].join(' ') : this.getElementId('live-region')
                } : {
                    'aria-describedby': description ? [
                        description,
                        this.getElementId('placeholder')
                    ].join(' ') : this.getElementId('placeholder')
                }
            };
            if (!isSearchable) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("aFNBY")).default), {
                id: id,
                innerRef: this.getInputRef,
                onBlur: this.onInputBlur,
                onChange: (0, (0, parcelRequire("g2UN3")).noop),
                onFocus: this.onInputFocus,
                disabled: isDisabled,
                tabIndex: tabIndex,
                inputMode: "none",
                form: form,
                value: "",
                ...ariaAttributes
            });
            return (0, ($parcel$interopDefault($5uXOq))).createElement(Input, {
                ...commonProps,
                autoCapitalize: "none",
                autoComplete: "off",
                autoCorrect: "off",
                id: id,
                innerRef: this.getInputRef,
                isDisabled: isDisabled,
                isHidden: inputIsHidden,
                onBlur: this.onInputBlur,
                onChange: this.handleInputChange,
                onFocus: this.onInputFocus,
                spellCheck: "false",
                tabIndex: tabIndex,
                form: form,
                type: "text",
                value: inputValue,
                ...ariaAttributes
            });
        }
        renderPlaceholderOrValue() {
            const { MultiValue: MultiValue, MultiValueContainer: MultiValueContainer, MultiValueLabel: MultiValueLabel, MultiValueRemove: MultiValueRemove, SingleValue: SingleValue, Placeholder: Placeholder } = this.getComponents();
            const { commonProps: commonProps } = this;
            const { controlShouldRenderValue: controlShouldRenderValue, isDisabled: isDisabled, isMulti: isMulti, inputValue: inputValue, placeholder: placeholder } = this.props;
            const { selectValue: selectValue, focusedValue: focusedValue, isFocused: isFocused } = this.state;
            if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : (0, ($parcel$interopDefault($5uXOq))).createElement(Placeholder, {
                ...commonProps,
                key: "placeholder",
                isDisabled: isDisabled,
                isFocused: isFocused,
                innerProps: {
                    id: this.getElementId('placeholder')
                }
            }, placeholder);
            if (isMulti) return selectValue.map((opt, index)=>{
                const isOptionFocused = opt === focusedValue;
                const key = `${this.getOptionLabel(opt)}-${this.getOptionValue(opt)}`;
                return (0, ($parcel$interopDefault($5uXOq))).createElement(MultiValue, {
                    ...commonProps,
                    components: {
                        Container: MultiValueContainer,
                        Label: MultiValueLabel,
                        Remove: MultiValueRemove
                    },
                    isFocused: isOptionFocused,
                    isDisabled: isDisabled,
                    key: key,
                    index: index,
                    removeProps: {
                        onClick: ()=>this.removeValue(opt),
                        onTouchEnd: ()=>this.removeValue(opt),
                        onMouseDown: (e)=>{
                            e.preventDefault();
                        }
                    },
                    data: opt
                }, this.formatOptionLabel(opt, 'value'));
            });
            if (inputValue) return null;
            const singleValue = selectValue[0];
            return (0, ($parcel$interopDefault($5uXOq))).createElement(SingleValue, {
                ...commonProps,
                data: singleValue,
                isDisabled: isDisabled
            }, this.formatOptionLabel(singleValue, 'value'));
        }
        renderClearIndicator() {
            const { ClearIndicator: ClearIndicator } = this.getComponents();
            const { commonProps: commonProps } = this;
            const { clearControlLabel: clearControlLabel, isDisabled: isDisabled, isLoading: isLoading } = this.props;
            const { isFocused: isFocused } = this.state;
            if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
            const innerProps = {
                onMouseDown: this.onClearIndicatorMouseDown,
                onTouchEnd: this.onClearIndicatorTouchEnd,
                'aria-hidden': 'true'
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement(ClearIndicator, {
                clearControlLabel: clearControlLabel,
                ...commonProps,
                innerProps: innerProps,
                isFocused: isFocused
            });
        }
        renderLoadingIndicator() {
            const { LoadingIndicator: LoadingIndicator } = this.getComponents();
            const { commonProps: commonProps } = this;
            const { isDisabled: isDisabled, isLoading: isLoading } = this.props;
            const { isFocused: isFocused } = this.state;
            if (!LoadingIndicator || !isLoading) return null;
            const innerProps = {
                'aria-hidden': 'true'
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement(LoadingIndicator, {
                ...commonProps,
                innerProps: innerProps,
                isDisabled: isDisabled,
                isFocused: isFocused
            });
        }
        renderIndicatorSeparator() {
            const { DropdownIndicator: DropdownIndicator, IndicatorSeparator: IndicatorSeparator } = this.getComponents();
            if (!DropdownIndicator || !IndicatorSeparator) return null;
            const { commonProps: commonProps } = this;
            const { isDisabled: isDisabled } = this.props;
            const { isFocused: isFocused } = this.state;
            return (0, ($parcel$interopDefault($5uXOq))).createElement(IndicatorSeparator, {
                ...commonProps,
                isDisabled: isDisabled,
                isFocused: isFocused
            });
        }
        renderDropdownIndicator() {
            const { DropdownIndicator: DropdownIndicator } = this.getComponents();
            if (!DropdownIndicator) return null;
            const { commonProps: commonProps } = this;
            const { isDisabled: isDisabled } = this.props;
            const { isFocused: isFocused } = this.state;
            const innerProps = {
                onMouseDown: this.onDropdownIndicatorMouseDown,
                onTouchEnd: this.onDropdownIndicatorTouchEnd,
                'aria-hidden': 'true'
            };
            return (0, ($parcel$interopDefault($5uXOq))).createElement(DropdownIndicator, {
                ...commonProps,
                innerProps: innerProps,
                isDisabled: isDisabled,
                isFocused: isFocused
            });
        }
        renderMenu() {
            const { Group: Group, GroupHeading: GroupHeading, Menu: Menu, MenuList: MenuList, MenuPortal: MenuPortal, LoadingMessage: LoadingMessage, NoOptionsMessage: NoOptionsMessage, Option: Option } = this.getComponents();
            const { commonProps: commonProps } = this;
            const { focusedOption: focusedOption } = this.state;
            const { captureMenuScroll: captureMenuScroll, inputValue: inputValue, isLoading: isLoading, loadingMessage: loadingMessage, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuIsOpen: menuIsOpen, menuPlacement: menuPlacement, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, menuShouldBlockScroll: menuShouldBlockScroll, menuShouldScrollIntoView: menuShouldScrollIntoView, noOptionsMessage: noOptionsMessage, onMenuScrollToTop: onMenuScrollToTop, onMenuScrollToBottom: onMenuScrollToBottom, labelId: labelId, label: label } = this.props;
            if (!menuIsOpen) return null;
            const render = (props, id, headingId)=>{
                const { type: type, data: data, isDisabled: isDisabled, isSelected: isSelected, label: label, value: value } = props;
                const isFocused = focusedOption === data;
                const onHover = isDisabled ? undefined : ()=>this.onOptionHover(data);
                const onSelect = isDisabled ? undefined : ()=>this.selectOption(data);
                const optionId = `${this.getElementId('option')}-${id}`;
                const innerProps = {
                    id: optionId,
                    onClick: onSelect,
                    onMouseMove: onHover,
                    onMouseOver: onHover,
                    role: 'option',
                    'aria-selected': !commonProps.isMulti && (0, (0, parcelRequire("2oS3b")).fg)('design_system_select-a11y-improvement') ? isSelected || undefined : isSelected,
                    'aria-describedby': (0, (0, parcelRequire("2oS3b")).fg)('design_system_select-a11y-improvement') ? headingId : undefined
                };
                return (0, ($parcel$interopDefault($5uXOq))).createElement(Option, {
                    ...commonProps,
                    innerProps: innerProps,
                    data: data,
                    isDisabled: isDisabled,
                    isSelected: isSelected,
                    key: optionId,
                    label: label,
                    type: type,
                    value: value,
                    isFocused: isFocused,
                    innerRef: isFocused ? this.getFocusedOptionRef : undefined
                }, this.formatOptionLabel(props.data, 'menu'));
            };
            let menuUI;
            if (this.hasOptions()) {
                const items = this.getCategorizedOptions();
                menuUI = items.map((item)=>{
                    if (item.type === 'group') {
                        const { data: data, options: options, index: groupIndex } = item;
                        const groupId = `${this.getElementId('group')}-${groupIndex}`;
                        const headingId = `${groupId}-heading`;
                        return (0, ($parcel$interopDefault($5uXOq))).createElement(Group, {
                            ...commonProps,
                            key: groupId,
                            data: data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: this.formatGroupLabel(item.data)
                        }, item.options.map((option)=>render(option, `${groupIndex}-${option.index}`, headingId)));
                    } else if (item.type === 'option') return render(item, `${item.index}`);
                });
            } else if (isLoading) {
                const message = loadingMessage({
                    inputValue: inputValue
                });
                if (message === null) return null;
                menuUI = (0, ($parcel$interopDefault($5uXOq))).createElement(LoadingMessage, commonProps, message);
            } else {
                const message = noOptionsMessage({
                    inputValue: inputValue
                });
                if (message === null) return null;
                menuUI = (0, ($parcel$interopDefault($5uXOq))).createElement(NoOptionsMessage, commonProps, message);
            }
            const menuPlacementProps = {
                minMenuHeight: minMenuHeight,
                maxMenuHeight: maxMenuHeight,
                menuPlacement: menuPlacement,
                menuPosition: menuPosition,
                menuShouldScrollIntoView: menuShouldScrollIntoView
            };
            const menuElement = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("b4pnV")).MenuPlacer), {
                ...commonProps,
                ...menuPlacementProps
            }, ({ ref: ref, placerProps: { placement: placement, maxHeight: maxHeight } })=>(0, ($parcel$interopDefault($5uXOq))).createElement(Menu, {
                    ...commonProps,
                    ...menuPlacementProps,
                    innerRef: ref,
                    innerProps: {
                        onMouseDown: this.onMenuMouseDown,
                        onMouseMove: this.onMenuMouseMove,
                        id: this.props.components.Menu ? this.getElementId('listbox') : undefined
                    },
                    isLoading: isLoading,
                    placement: placement
                }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iTuaH")).default), {
                    captureEnabled: captureMenuScroll,
                    onTopArrive: onMenuScrollToTop,
                    onBottomArrive: onMenuScrollToBottom,
                    lockEnabled: menuShouldBlockScroll
                }, (scrollTargetRef)=>(0, ($parcel$interopDefault($5uXOq))).createElement(MenuList, {
                        ...commonProps,
                        innerRef: (instance)=>{
                            this.getMenuListRef(instance);
                            scrollTargetRef(instance);
                        },
                        innerProps: {
                            role: 'listbox',
                            'aria-multiselectable': (0, (0, parcelRequire("2oS3b")).fg)('design_system_select-a11y-improvement') ? commonProps.isMulti || undefined : commonProps.isMulti,
                            id: this.getElementId('listbox'),
                            ...(0, (0, parcelRequire("2oS3b")).fg)('design_system_select-a11y-improvement') && {
                                'aria-label': label,
                                'aria-labelledby': labelId
                            }
                        },
                        isLoading: isLoading,
                        maxHeight: maxHeight,
                        focusedOption: focusedOption
                    }, menuUI))));
            return menuPortalTarget || menuPosition === 'fixed' ? (0, ($parcel$interopDefault($5uXOq))).createElement(MenuPortal, {
                ...commonProps,
                appendTo: menuPortalTarget,
                controlElement: this.controlRef,
                menuPlacement: menuPlacement,
                menuPosition: menuPosition
            }, menuElement) : menuElement;
        }
        renderFormField() {
            const { delimiter: delimiter, isDisabled: isDisabled, isMulti: isMulti, required: required, name: name } = this.props;
            const { selectValue: selectValue } = this.state;
            if (required && !this.hasValue() && !isDisabled) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gSXak")).default), {
                name: name,
                onFocus: this.onValueInputFocus
            });
            if (!name || isDisabled) return;
            if (isMulti) {
                if (delimiter) {
                    const value = selectValue.map((opt)=>this.getOptionValue(opt)).join(delimiter);
                    return (0, ($parcel$interopDefault($5uXOq))).createElement("input", {
                        name: name,
                        type: "hidden",
                        value: value
                    });
                } else {
                    const input = selectValue.length > 0 ? selectValue.map((opt, i)=>(0, ($parcel$interopDefault($5uXOq))).createElement("input", {
                            key: `i-${i}`,
                            name: name,
                            type: "hidden",
                            value: this.getOptionValue(opt)
                        })) : (0, ($parcel$interopDefault($5uXOq))).createElement("input", {
                        name: name,
                        type: "hidden",
                        value: ""
                    });
                    return (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, input);
                }
            } else {
                const value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
                return (0, ($parcel$interopDefault($5uXOq))).createElement("input", {
                    name: name,
                    type: "hidden",
                    value: value
                });
            }
        }
        renderLiveRegion() {
            const { commonProps: commonProps } = this;
            const { ariaSelection: ariaSelection, focusedOption: focusedOption, focusedValue: focusedValue, isFocused: isFocused, selectValue: selectValue } = this.state;
            const focusableOptions = this.getFocusableOptions();
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fenYw")).default), {
                ...commonProps,
                id: this.getElementId('live-region'),
                ariaSelection: ariaSelection,
                focusedOption: focusedOption,
                focusedValue: focusedValue,
                isFocused: isFocused,
                selectValue: selectValue,
                focusableOptions: focusableOptions,
                isAppleDevice: this.isAppleDevice
            });
        }
        render() {
            const { Control: Control, IndicatorsContainer: IndicatorsContainer, SelectContainer: SelectContainer, ValueContainer: ValueContainer } = this.getComponents();
            const { className: className, id: id, isDisabled: isDisabled, menuIsOpen: menuIsOpen } = this.props;
            const { isFocused: isFocused } = this.state;
            const commonProps = this.commonProps = this.getCommonProps();
            return (0, ($parcel$interopDefault($5uXOq))).createElement(SelectContainer, {
                ...commonProps,
                className: className,
                innerProps: {
                    id: id,
                    onKeyDown: this.onKeyDown
                },
                isDisabled: isDisabled,
                isFocused: isFocused
            }, this.renderLiveRegion(), (0, ($parcel$interopDefault($5uXOq))).createElement(Control, {
                ...commonProps,
                innerRef: this.getControlRef,
                innerProps: {
                    onMouseDown: this.onControlMouseDown,
                    onTouchEnd: this.onControlTouchEnd
                },
                isDisabled: isDisabled,
                isFocused: isFocused,
                menuIsOpen: menuIsOpen
            }, (0, ($parcel$interopDefault($5uXOq))).createElement(ValueContainer, {
                ...commonProps,
                isDisabled: isDisabled
            }, this.renderPlaceholderOrValue(), this.renderInput()), (0, ($parcel$interopDefault($5uXOq))).createElement(IndicatorsContainer, {
                ...commonProps,
                isDisabled: isDisabled
            }, this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
        }
    }
});
parcelRegister("3vyhk", function(module, exports) {
    $parcel$export(module.exports, "isSafari", ()=>$2274fb9bfe3ef11a$export$95df08bae54cb4df);
    $parcel$export(module.exports, "isAppleDevice", ()=>$2274fb9bfe3ef11a$export$e1865c3bedcd822b);
    function $2274fb9bfe3ef11a$var$testPlatform(re) {
        return typeof window !== 'undefined' && window.navigator != null ? re.test(window.navigator['userAgentData']?.platform || window.navigator.platform) : false;
    }
    function $2274fb9bfe3ef11a$export$186c6964ca17d99() {
        return $2274fb9bfe3ef11a$var$testPlatform(/^iPhone/i);
    }
    function $2274fb9bfe3ef11a$export$95df08bae54cb4df() {
        if (typeof window !== 'undefined' && window.navigator != null) {
            const ua = window.navigator.userAgent?.toLowerCase();
            return ua ? ua.includes('safari') && !ua.includes('chrome') : false;
        }
        return false;
    }
    function $2274fb9bfe3ef11a$export$9ac100e40613ea10() {
        return $2274fb9bfe3ef11a$var$testPlatform(/^Mac/i);
    }
    function $2274fb9bfe3ef11a$export$7bef049ce92e4224() {
        return $2274fb9bfe3ef11a$var$testPlatform(/^iPad/i) || $2274fb9bfe3ef11a$export$9ac100e40613ea10() && navigator.maxTouchPoints > 1;
    }
    function $2274fb9bfe3ef11a$export$fedb369cb70207f1() {
        return $2274fb9bfe3ef11a$export$186c6964ca17d99() || $2274fb9bfe3ef11a$export$7bef049ce92e4224();
    }
    function $2274fb9bfe3ef11a$export$e1865c3bedcd822b() {
        return $2274fb9bfe3ef11a$export$9ac100e40613ea10() || $2274fb9bfe3ef11a$export$fedb369cb70207f1();
    }
});
parcelRegister("g6yke", function(module, exports) {
    $parcel$export(module.exports, "formatGroupLabel", ()=>$949b2d8695786188$export$f4da216a6ca54656);
    $parcel$export(module.exports, "getOptionLabel", ()=>$949b2d8695786188$export$dac6ace3020563ca);
    $parcel$export(module.exports, "getOptionValue", ()=>$949b2d8695786188$export$40be908210c5a79c);
    $parcel$export(module.exports, "isOptionDisabled", ()=>$949b2d8695786188$export$56bd0c8d90db075);
    const $949b2d8695786188$export$f4da216a6ca54656 = (group)=>group.label;
    const $949b2d8695786188$export$dac6ace3020563ca = (option)=>option.label;
    const $949b2d8695786188$export$40be908210c5a79c = (option)=>option.value;
    const $949b2d8695786188$export$56bd0c8d90db075 = (option)=>!!option.isDisabled;
});
parcelRegister("2JKLA", function(module, exports) {
    $parcel$export(module.exports, "components", ()=>$d8841908a1a3116c$export$9b5ac10f59f76296);
    $parcel$export(module.exports, "defaultComponents", ()=>$d8841908a1a3116c$export$71abc632aa29e6fe);
    var $hekcY;
    var $5EgAF;
    var $5dHSO;
    var $8KLo7;
    var $loRFz;
    var $b4pnV;
    var $hti3c;
    var $1MDaa;
    var $hklN8;
    var $7SnYw;
    const $d8841908a1a3116c$export$9b5ac10f59f76296 = {
        ClearIndicator: (0, (0, parcelRequire("8KLo7")).ClearIndicator),
        Control: (0, (0, parcelRequire("5EgAF")).default),
        DropdownIndicator: (0, (0, parcelRequire("8KLo7")).DropdownIndicator),
        DownChevron: (0, (0, parcelRequire("8KLo7")).DownChevron),
        CrossIcon: (0, (0, parcelRequire("8KLo7")).CrossIcon),
        Group: (0, (0, parcelRequire("5dHSO")).default),
        GroupHeading: (0, (0, parcelRequire("5dHSO")).GroupHeading),
        IndicatorsContainer: (0, (0, parcelRequire("hekcY")).IndicatorsContainer),
        IndicatorSeparator: (0, (0, parcelRequire("8KLo7")).IndicatorSeparator),
        Input: (0, (0, parcelRequire("loRFz")).default),
        LoadingIndicator: (0, (0, parcelRequire("8KLo7")).LoadingIndicator),
        Menu: (0, (0, parcelRequire("b4pnV")).default),
        MenuList: (0, (0, parcelRequire("b4pnV")).MenuList),
        MenuPortal: (0, (0, parcelRequire("b4pnV")).MenuPortal),
        LoadingMessage: (0, (0, parcelRequire("b4pnV")).LoadingMessage),
        NoOptionsMessage: (0, (0, parcelRequire("b4pnV")).NoOptionsMessage),
        MultiValue: (0, (0, parcelRequire("hti3c")).default),
        MultiValueContainer: (0, (0, parcelRequire("hti3c")).MultiValueContainer),
        MultiValueLabel: (0, (0, parcelRequire("hti3c")).MultiValueLabel),
        MultiValueRemove: (0, (0, parcelRequire("hti3c")).MultiValueRemove),
        Option: (0, (0, parcelRequire("1MDaa")).default),
        Placeholder: (0, (0, parcelRequire("hklN8")).default),
        SelectContainer: (0, (0, parcelRequire("hekcY")).SelectContainer),
        SingleValue: (0, (0, parcelRequire("7SnYw")).default),
        ValueContainer: (0, (0, parcelRequire("hekcY")).ValueContainer)
    };
    const $d8841908a1a3116c$export$71abc632aa29e6fe = (props)=>({
            ...$d8841908a1a3116c$export$9b5ac10f59f76296,
            ...props.components
        });
});
parcelRegister("hekcY", function(module, exports) {
    $parcel$export(module.exports, "containerCSS", ()=>$c0357af0bdb2c3e2$export$949392aeaf7d2e3a);
    $parcel$export(module.exports, "SelectContainer", ()=>$c0357af0bdb2c3e2$export$446eebadefe1123b);
    $parcel$export(module.exports, "valueContainerCSS", ()=>$c0357af0bdb2c3e2$export$47aec73c7aa6b9aa);
    $parcel$export(module.exports, "ValueContainer", ()=>$c0357af0bdb2c3e2$export$4dc9f58ad9a1a000);
    $parcel$export(module.exports, "indicatorsContainerCSS", ()=>$c0357af0bdb2c3e2$export$9d74e3c8b5868ad7);
    $parcel$export(module.exports, "IndicatorsContainer", ()=>$c0357af0bdb2c3e2$export$d0ffd7e649cab6f);
    var $f8Sb3;
    var $g2UN3;
    const $c0357af0bdb2c3e2$export$949392aeaf7d2e3a = ({ isDisabled: isDisabled, isRtl: isRtl })=>({
            label: 'container',
            direction: isRtl ? 'rtl' : undefined,
            pointerEvents: isDisabled ? 'none' : undefined,
            position: 'relative'
        });
    const $c0357af0bdb2c3e2$export$446eebadefe1123b = (props)=>{
        const { children: children, innerProps: innerProps, isDisabled: isDisabled, isRtl: isRtl } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("g2UN3")).getStyleProps)(props, 'container', {
                '--is-disabled': isDisabled,
                '--is-rtl': isRtl
            }),
            ...innerProps
        }, children);
    };
    const $c0357af0bdb2c3e2$export$47aec73c7aa6b9aa = ({ theme: { spacing: spacing }, isMulti: isMulti, hasValue: hasValue, selectProps: { controlShouldRenderValue: controlShouldRenderValue } }, unstyled)=>({
            alignItems: 'center',
            display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
            flex: 1,
            flexWrap: 'wrap',
            WebkitOverflowScrolling: 'touch',
            position: 'relative',
            overflow: 'hidden',
            ...unstyled ? {} : {
                padding: `${spacing.baseUnit / 2}px ${spacing.baseUnit * 2}px`
            }
        });
    const $c0357af0bdb2c3e2$export$4dc9f58ad9a1a000 = (props)=>{
        const { children: children, innerProps: innerProps, isMulti: isMulti, hasValue: hasValue } = props;
        const styles = (0, (0, parcelRequire("g2UN3")).getStyleProps)(props, 'valueContainer', {
            'value-container': true,
            'value-container--is-multi': isMulti,
            'value-container--has-value': hasValue
        });
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: styles.css,
            className: styles.className || 'value-container',
            ...innerProps
        }, children);
    };
    const $c0357af0bdb2c3e2$export$9d74e3c8b5868ad7 = ()=>({
            alignItems: 'center',
            alignSelf: 'stretch',
            display: 'flex',
            flexShrink: 0
        });
    const $c0357af0bdb2c3e2$export$d0ffd7e649cab6f = (props)=>{
        const { children: children, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("g2UN3")).getStyleProps)(props, 'indicatorsContainer', {
                indicators: true
            }),
            ...innerProps
        }, children);
    };
});
parcelRegister("g2UN3", function(module, exports) {
    $parcel$export(module.exports, "noop", ()=>$d301bcbf5bee5718$export$8793edee2d425525);
    $parcel$export(module.exports, "classNames", ()=>$d301bcbf5bee5718$export$ce4ab0c55987d1ff);
    $parcel$export(module.exports, "cleanValue", ()=>$d301bcbf5bee5718$export$33f062f47f21a01);
    $parcel$export(module.exports, "cleanCommonProps", ()=>$d301bcbf5bee5718$export$8e9fd4287627890c);
    $parcel$export(module.exports, "getStyleProps", ()=>$d301bcbf5bee5718$export$26417cabd806a658);
    $parcel$export(module.exports, "handleInputChange", ()=>$d301bcbf5bee5718$export$2096bae78ecda911);
    $parcel$export(module.exports, "isDocumentElement", ()=>$d301bcbf5bee5718$export$d8a62a489b442872);
    $parcel$export(module.exports, "normalizedHeight", ()=>$d301bcbf5bee5718$export$2e0654fad740d2e4);
    $parcel$export(module.exports, "getScrollTop", ()=>$d301bcbf5bee5718$export$c4a223a8ba9e4ea5);
    $parcel$export(module.exports, "scrollTo", ()=>$d301bcbf5bee5718$export$3f99968195accfaf);
    $parcel$export(module.exports, "getScrollParent", ()=>$d301bcbf5bee5718$export$cfa2225e87938781);
    $parcel$export(module.exports, "animatedScrollTo", ()=>$d301bcbf5bee5718$export$858c30343199f3af);
    $parcel$export(module.exports, "scrollIntoView", ()=>$d301bcbf5bee5718$export$53a0910f038337bd);
    $parcel$export(module.exports, "getBoundingClientObj", ()=>$d301bcbf5bee5718$export$7807c2a424c2f6d1);
    $parcel$export(module.exports, "isTouchCapable", ()=>$d301bcbf5bee5718$export$56963d77dbffdde7);
    $parcel$export(module.exports, "isMobileDevice", ()=>$d301bcbf5bee5718$export$44f917bf91becd01);
    $parcel$export(module.exports, "supportsPassiveEvents", ()=>$d301bcbf5bee5718$export$b0622a6911dbeaf5);
    $parcel$export(module.exports, "notNullish", ()=>$d301bcbf5bee5718$export$aedb69ff3e31596c);
    $parcel$export(module.exports, "valueTernary", ()=>$d301bcbf5bee5718$export$40fb9515c784cc3b);
    $parcel$export(module.exports, "singleValueAsValue", ()=>$d301bcbf5bee5718$export$dea4763e29237f4c);
    $parcel$export(module.exports, "multiValueAsValue", ()=>$d301bcbf5bee5718$export$d1ca752ec761b95b);
    $parcel$export(module.exports, "removeProps", ()=>$d301bcbf5bee5718$export$4213b25a1c4e877);
    const $d301bcbf5bee5718$export$8793edee2d425525 = ()=>{};
    const $d301bcbf5bee5718$export$1643ccb46f49255c = ()=>'';
    function $d301bcbf5bee5718$var$applyPrefixToName(prefix, name) {
        if (!name) return prefix;
        else if (name[0] === '-') return prefix + name;
        else return prefix + '__' + name;
    }
    function $d301bcbf5bee5718$export$ce4ab0c55987d1ff(prefix, state, ...classNameList) {
        const arr = [
            ...classNameList
        ];
        if (state && prefix) {
            for(let key in state)if (state.hasOwnProperty(key) && state[key]) arr.push(`${$d301bcbf5bee5718$var$applyPrefixToName(prefix, key)}`);
        }
        return arr.filter((i)=>i).map((i)=>String(i).trim()).join(' ');
    }
    const $d301bcbf5bee5718$export$33f062f47f21a01 = (value)=>{
        if ($d301bcbf5bee5718$export$43bee75e5e14138e(value)) return value.filter(Boolean);
        if (typeof value === 'object' && value !== null) return [
            value
        ];
        return [];
    };
    const $d301bcbf5bee5718$export$8e9fd4287627890c = (props)=>{
        const { className: className, clearValue: clearValue, cx: cx, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, hasValue: hasValue, isMulti: isMulti, isRtl: isRtl, options: options, selectOption: selectOption, selectProps: selectProps, setValue: setValue, theme: theme, ...innerProps } = props;
        return {
            ...innerProps
        };
    };
    const $d301bcbf5bee5718$export$26417cabd806a658 = (props, name, classNamesState)=>{
        const { cx: cx, getStyles: getStyles, getClassNames: getClassNames, className: className } = props;
        return {
            css: getStyles(name, props),
            className: cx(classNamesState ?? {}, getClassNames(name, props), className)
        };
    };
    function $d301bcbf5bee5718$export$2096bae78ecda911(inputValue, actionMeta, onInputChange) {
        if (onInputChange) {
            const newValue = onInputChange(inputValue, actionMeta);
            if (typeof newValue === 'string') return newValue;
        }
        return inputValue;
    }
    function $d301bcbf5bee5718$export$d8a62a489b442872(el) {
        return [
            document.documentElement,
            document.body,
            window
        ].indexOf(el) > -1;
    }
    function $d301bcbf5bee5718$export$2e0654fad740d2e4(el) {
        if ($d301bcbf5bee5718$export$d8a62a489b442872(el)) return window.innerHeight;
        return el.clientHeight;
    }
    function $d301bcbf5bee5718$export$c4a223a8ba9e4ea5(el) {
        if ($d301bcbf5bee5718$export$d8a62a489b442872(el)) return window.pageYOffset;
        return el.scrollTop;
    }
    function $d301bcbf5bee5718$export$3f99968195accfaf(el, top) {
        if ($d301bcbf5bee5718$export$d8a62a489b442872(el)) {
            window.scrollTo(0, top);
            return;
        }
        el.scrollTop = top;
    }
    function $d301bcbf5bee5718$export$cfa2225e87938781(element) {
        let style = getComputedStyle(element);
        const excludeStaticParent = style.position === 'absolute';
        const overflowRx = /(auto|scroll)/;
        if (style.position === 'fixed') return document.documentElement;
        for(let parent = element; parent = parent.parentElement;){
            style = getComputedStyle(parent);
            if (excludeStaticParent && style.position === 'static') continue;
            if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
        }
        return document.documentElement;
    }
    function $d301bcbf5bee5718$var$easeOutCubic(t, b, c, d) {
        return c * ((t = t / d - 1) * t * t + 1) + b;
    }
    function $d301bcbf5bee5718$export$858c30343199f3af(element, to, duration = 200, callback = $d301bcbf5bee5718$export$8793edee2d425525) {
        const start = $d301bcbf5bee5718$export$c4a223a8ba9e4ea5(element);
        const change = to - start;
        const increment = 10;
        let currentTime = 0;
        function animateScroll() {
            currentTime += increment;
            const val = $d301bcbf5bee5718$var$easeOutCubic(currentTime, start, change, duration);
            $d301bcbf5bee5718$export$3f99968195accfaf(element, val);
            if (currentTime < duration) window.requestAnimationFrame(animateScroll);
            else callback(element);
        }
        animateScroll();
    }
    function $d301bcbf5bee5718$export$53a0910f038337bd(menuEl, focusedEl) {
        const menuRect = menuEl.getBoundingClientRect();
        const focusedRect = focusedEl.getBoundingClientRect();
        const overScroll = focusedEl.offsetHeight / 3;
        if (focusedRect.bottom + overScroll > menuRect.bottom) $d301bcbf5bee5718$export$3f99968195accfaf(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
        else if (focusedRect.top - overScroll < menuRect.top) $d301bcbf5bee5718$export$3f99968195accfaf(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
    }
    function $d301bcbf5bee5718$export$7807c2a424c2f6d1(element) {
        const rect = element.getBoundingClientRect();
        return {
            bottom: rect.bottom,
            height: rect.height,
            left: rect.left,
            right: rect.right,
            top: rect.top,
            width: rect.width
        };
    }
    function $d301bcbf5bee5718$export$c0d0115e766e14c3(str) {
        return str.replace(/\W/g, '-');
    }
    function $d301bcbf5bee5718$export$56963d77dbffdde7() {
        try {
            document.createEvent('TouchEvent');
            return true;
        } catch (e) {
            return false;
        }
    }
    function $d301bcbf5bee5718$export$44f917bf91becd01() {
        try {
            return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        } catch (e) {
            return false;
        }
    }
    let $d301bcbf5bee5718$var$passiveOptionAccessed = false;
    const $d301bcbf5bee5718$var$options = {
        get passive () {
            return $d301bcbf5bee5718$var$passiveOptionAccessed = true;
        }
    };
    const $d301bcbf5bee5718$var$w = typeof window !== 'undefined' ? window : {};
    if ($d301bcbf5bee5718$var$w.addEventListener && $d301bcbf5bee5718$var$w.removeEventListener) {
        $d301bcbf5bee5718$var$w.addEventListener('p', $d301bcbf5bee5718$export$8793edee2d425525, $d301bcbf5bee5718$var$options);
        $d301bcbf5bee5718$var$w.removeEventListener('p', $d301bcbf5bee5718$export$8793edee2d425525, false);
    }
    const $d301bcbf5bee5718$export$b0622a6911dbeaf5 = $d301bcbf5bee5718$var$passiveOptionAccessed;
    function $d301bcbf5bee5718$export$aedb69ff3e31596c(item) {
        return item != null;
    }
    function $d301bcbf5bee5718$export$43bee75e5e14138e(arg) {
        return Array.isArray(arg);
    }
    function $d301bcbf5bee5718$export$40fb9515c784cc3b(isMulti, multiValue, singleValue) {
        return isMulti ? multiValue : singleValue;
    }
    function $d301bcbf5bee5718$export$dea4763e29237f4c(singleValue) {
        return singleValue;
    }
    function $d301bcbf5bee5718$export$d1ca752ec761b95b(multiValue) {
        return multiValue;
    }
    const $d301bcbf5bee5718$export$4213b25a1c4e877 = (propsObj, ...properties)=>{
        let propsMap = Object.entries(propsObj).filter(([key])=>!properties.includes(key));
        return propsMap.reduce((newProps, [key, val])=>{
            newProps[key] = val;
            return newProps;
        }, {});
    };
});
parcelRegister("5EgAF", function(module, exports) {
    $parcel$export(module.exports, "css", ()=>$112794acdb2bce64$export$dbf350e5966cf602);
    $parcel$export(module.exports, "default", ()=>$112794acdb2bce64$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $g2UN3;
    const $112794acdb2bce64$export$dbf350e5966cf602 = ({ isDisabled: isDisabled, isFocused: isFocused, theme: { colors: colors, borderRadius: borderRadius, spacing: spacing } }, unstyled)=>({
            label: 'control',
            alignItems: 'center',
            cursor: 'default',
            display: 'flex',
            flexWrap: 'wrap',
            justifyContent: 'space-between',
            minHeight: spacing.controlHeight,
            outline: '0 !important',
            position: 'relative',
            transition: 'all 100ms',
            ...unstyled ? {} : {
                backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
                borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
                borderRadius: borderRadius,
                borderStyle: 'solid',
                borderWidth: 1,
                boxShadow: isFocused ? `0 0 0 1px ${colors.primary}` : undefined,
                '&:hover': {
                    borderColor: isFocused ? colors.primary : colors.neutral30
                }
            }
        });
    const $112794acdb2bce64$var$Control = (props)=>{
        const { children: children, isDisabled: isDisabled, isFocused: isFocused, innerRef: innerRef, innerProps: innerProps, menuIsOpen: menuIsOpen } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ref: innerRef,
            ...(0, (0, parcelRequire("g2UN3")).getStyleProps)(props, 'control', {
                control: true,
                'control--is-disabled': isDisabled,
                'control--is-focused': isFocused,
                'control--menu-is-open': menuIsOpen
            }),
            ...innerProps,
            "aria-disabled": isDisabled || undefined
        }, children);
    };
    var $112794acdb2bce64$export$2e2bcd8739ae039 = $112794acdb2bce64$var$Control;
});
parcelRegister("5dHSO", function(module, exports) {
    $parcel$export(module.exports, "groupCSS", ()=>$f6fdd3148ce7aff3$export$b6794329c1460634);
    $parcel$export(module.exports, "groupHeadingCSS", ()=>$f6fdd3148ce7aff3$export$e5a7fbb542efcb7d);
    $parcel$export(module.exports, "GroupHeading", ()=>$f6fdd3148ce7aff3$export$85c8b41a3cd87edc);
    $parcel$export(module.exports, "default", ()=>$f6fdd3148ce7aff3$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $g2UN3;
    const $f6fdd3148ce7aff3$export$b6794329c1460634 = ({ theme: { spacing: spacing } }, unstyled)=>unstyled ? {} : {
            paddingBottom: spacing.baseUnit * 2,
            paddingTop: spacing.baseUnit * 2
        };
    const $f6fdd3148ce7aff3$var$Group = (props)=>{
        const { children: children, cx: cx, getStyles: getStyles, getClassNames: getClassNames, Heading: Heading, headingProps: headingProps, innerProps: innerProps, label: label, theme: theme, selectProps: selectProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("g2UN3")).getStyleProps)(props, 'group', {
                group: true
            }),
            ...innerProps
        }, (0, (0, parcelRequire("f8Sb3")).jsx)(Heading, {
            ...headingProps,
            selectProps: selectProps,
            theme: theme,
            getStyles: getStyles,
            getClassNames: getClassNames,
            cx: cx
        }, label), (0, (0, parcelRequire("f8Sb3")).jsx)("div", null, children));
    };
    const $f6fdd3148ce7aff3$export$e5a7fbb542efcb7d = ({ theme: { colors: colors, spacing: spacing } }, unstyled)=>({
            label: 'group',
            cursor: 'default',
            display: 'block',
            ...unstyled ? {} : {
                color: colors.neutral40,
                fontSize: '75%',
                fontWeight: 500,
                marginBottom: '0.25em',
                paddingLeft: spacing.baseUnit * 3,
                paddingRight: spacing.baseUnit * 3,
                textTransform: 'uppercase'
            }
        });
    const $f6fdd3148ce7aff3$export$85c8b41a3cd87edc = (props)=>{
        const { data: data, ...innerProps } = (0, (0, parcelRequire("g2UN3")).cleanCommonProps)(props);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("g2UN3")).getStyleProps)(props, 'groupHeading', {
                'group-heading': true
            }),
            ...innerProps
        });
    };
    var $f6fdd3148ce7aff3$export$2e2bcd8739ae039 = $f6fdd3148ce7aff3$var$Group;
});
parcelRegister("8KLo7", function(module, exports) {
    $parcel$export(module.exports, "CrossIcon", ()=>$c5c80ec94c3996b7$export$3b621d86b1566b2);
    $parcel$export(module.exports, "DownChevron", ()=>$c5c80ec94c3996b7$export$c5cbe1656ba71e6c);
    $parcel$export(module.exports, "dropdownIndicatorCSS", ()=>$c5c80ec94c3996b7$export$e1687335805e1230);
    $parcel$export(module.exports, "DropdownIndicator", ()=>$c5c80ec94c3996b7$export$ec98719d3db7f2e4);
    $parcel$export(module.exports, "clearIndicatorCSS", ()=>$c5c80ec94c3996b7$export$9c0419fd944c1def);
    $parcel$export(module.exports, "ClearIndicator", ()=>$c5c80ec94c3996b7$export$ecf9cf59142dd54a);
    $parcel$export(module.exports, "indicatorSeparatorCSS", ()=>$c5c80ec94c3996b7$export$ec39646155d07fdd);
    $parcel$export(module.exports, "IndicatorSeparator", ()=>$c5c80ec94c3996b7$export$bd638c2ba7915668);
    $parcel$export(module.exports, "loadingIndicatorCSS", ()=>$c5c80ec94c3996b7$export$1d3f24cde248e6b5);
    $parcel$export(module.exports, "LoadingIndicator", ()=>$c5c80ec94c3996b7$export$7c20be4c1d342248);
    var $f8Sb3;
    var $g2UN3;
    function $c5c80ec94c3996b7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $c5c80ec94c3996b7$var$styles = {
        name: "8mmkcg",
        styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
    };
    const $c5c80ec94c3996b7$var$Svg = ({ size: size, ...props })=>(0, (0, parcelRequire("f8Sb3")).jsx)("svg", {
            height: size,
            width: size,
            viewBox: "0 0 20 20",
            "aria-hidden": "true",
            focusable: "false",
            css: $c5c80ec94c3996b7$var$styles,
            ...props
        });
    const $c5c80ec94c3996b7$export$3b621d86b1566b2 = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)($c5c80ec94c3996b7$var$Svg, {
            size: 20,
            ...props
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
            d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
        }));
    const $c5c80ec94c3996b7$export$c5cbe1656ba71e6c = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)($c5c80ec94c3996b7$var$Svg, {
            size: 20,
            ...props
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("path", {
            d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
        }));
    const $c5c80ec94c3996b7$var$baseCSS = ({ isFocused: isFocused, theme: { spacing: { baseUnit: baseUnit }, colors: colors } }, unstyled)=>({
            label: 'indicatorContainer',
            display: 'flex',
            transition: 'color 150ms',
            ...unstyled ? {} : {
                color: isFocused ? colors.neutral60 : colors.neutral20,
                padding: baseUnit * 2,
                ':hover': {
                    color: isFocused ? colors.neutral80 : colors.neutral40
                }
            }
        });
    const $c5c80ec94c3996b7$export$e1687335805e1230 = $c5c80ec94c3996b7$var$baseCSS;
    const $c5c80ec94c3996b7$export$ec98719d3db7f2e4 = (props)=>{
        const { children: children, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("g2UN3")).getStyleProps)(props, 'dropdownIndicator', {
                indicator: true,
                'dropdown-indicator': true
            }),
            ...innerProps
        }, children || (0, (0, parcelRequire("f8Sb3")).jsx)($c5c80ec94c3996b7$export$c5cbe1656ba71e6c, null));
    };
    const $c5c80ec94c3996b7$export$9c0419fd944c1def = $c5c80ec94c3996b7$var$baseCSS;
    const $c5c80ec94c3996b7$export$ecf9cf59142dd54a = (props)=>{
        const { children: children, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("g2UN3")).getStyleProps)(props, 'clearIndicator', {
                indicator: true,
                'clear-indicator': true
            }),
            ...innerProps
        }, children || (0, (0, parcelRequire("f8Sb3")).jsx)($c5c80ec94c3996b7$export$3b621d86b1566b2, null));
    };
    const $c5c80ec94c3996b7$export$ec39646155d07fdd = ({ isDisabled: isDisabled, theme: { spacing: { baseUnit: baseUnit }, colors: colors } }, unstyled)=>({
            label: 'indicatorSeparator',
            alignSelf: 'stretch',
            width: 1,
            ...unstyled ? {} : {
                backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
                marginBottom: baseUnit * 2,
                marginTop: baseUnit * 2
            }
        });
    const $c5c80ec94c3996b7$export$bd638c2ba7915668 = (props)=>{
        const { innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            ...innerProps,
            ...(0, (0, parcelRequire("g2UN3")).getStyleProps)(props, 'indicatorSeparator', {
                'indicator-separator': true
            })
        });
    };
    const $c5c80ec94c3996b7$var$loadingDotAnimations = (0, (0, parcelRequire("f8Sb3")).keyframes)({
        '0%, 80%, 100%': {
            opacity: 0
        },
        '40%': {
            opacity: 1
        }
    });
    const $c5c80ec94c3996b7$export$1d3f24cde248e6b5 = ({ isFocused: isFocused, size: size, theme: { colors: colors, spacing: { baseUnit: baseUnit } } }, unstyled)=>({
            label: 'loadingIndicator',
            display: 'flex',
            transition: 'color 150ms',
            alignSelf: 'center',
            fontSize: size,
            lineHeight: 1,
            marginRight: size,
            textAlign: 'center',
            verticalAlign: 'middle',
            ...unstyled ? {} : {
                color: isFocused ? colors.neutral60 : colors.neutral20,
                padding: baseUnit * 2
            }
        });
    const $c5c80ec94c3996b7$var$LoadingDot = ({ delay: delay, offset: offset })=>(0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: (0, (0, parcelRequire("f8Sb3")).css)({
                animation: `${$c5c80ec94c3996b7$var$loadingDotAnimations} 1s ease-in-out ${delay}ms infinite;`,
                backgroundColor: 'currentColor',
                borderRadius: '1em',
                display: 'inline-block',
                marginLeft: offset ? '1em' : undefined,
                height: '1em',
                verticalAlign: 'top',
                width: '1em'
            })
        });
    const $c5c80ec94c3996b7$export$7c20be4c1d342248 = ({ innerProps: innerProps, isRtl: isRtl, size: size = 4, ...restProps })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("g2UN3")).getStyleProps)({
                ...restProps,
                innerProps: innerProps,
                isRtl: isRtl,
                size: size
            }, 'loadingIndicator', {
                indicator: true,
                'loading-indicator': true
            }),
            ...innerProps
        }, (0, (0, parcelRequire("f8Sb3")).jsx)($c5c80ec94c3996b7$var$LoadingDot, {
            delay: 0,
            offset: isRtl
        }), (0, (0, parcelRequire("f8Sb3")).jsx)($c5c80ec94c3996b7$var$LoadingDot, {
            delay: 160,
            offset: true
        }), (0, (0, parcelRequire("f8Sb3")).jsx)($c5c80ec94c3996b7$var$LoadingDot, {
            delay: 320,
            offset: !isRtl
        }));
    };
});
parcelRegister("loRFz", function(module, exports) {
    $parcel$export(module.exports, "inputCSS", ()=>$722f6bdaf9005a3c$export$14a7781d0ca7abea);
    $parcel$export(module.exports, "default", ()=>$722f6bdaf9005a3c$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $g2UN3;
    const $722f6bdaf9005a3c$export$14a7781d0ca7abea = ({ isDisabled: isDisabled, value: value, theme: { spacing: spacing, colors: colors } }, unstyled)=>({
            visibility: isDisabled ? 'hidden' : 'visible',
            transform: value ? 'translateZ(0)' : '',
            ...$722f6bdaf9005a3c$var$containerStyle,
            ...unstyled ? {} : {
                margin: spacing.baseUnit / 2,
                paddingBottom: spacing.baseUnit / 2,
                paddingTop: spacing.baseUnit / 2,
                color: colors.neutral80
            }
        });
    const $722f6bdaf9005a3c$var$spacingStyle = {
        gridArea: '1 / 2',
        font: 'inherit',
        minWidth: '2px',
        border: 0,
        margin: 0,
        outline: 0,
        padding: 0
    };
    const $722f6bdaf9005a3c$var$containerStyle = {
        flex: '1 1 auto',
        display: 'inline-grid',
        gridArea: '1 / 1 / 2 / 3',
        gridTemplateColumns: '0 min-content',
        '&:after': {
            content: 'attr(data-value) " "',
            visibility: 'hidden',
            whiteSpace: 'pre',
            ...$722f6bdaf9005a3c$var$spacingStyle
        }
    };
    const $722f6bdaf9005a3c$var$inputStyle = (isHidden)=>({
            label: 'input',
            color: 'inherit',
            background: 0,
            opacity: isHidden ? 0 : 1,
            width: '100%',
            ...$722f6bdaf9005a3c$var$spacingStyle
        });
    const $722f6bdaf9005a3c$var$Input = (props)=>{
        const { cx: cx, value: value } = props;
        const { innerRef: innerRef, isDisabled: isDisabled, isHidden: isHidden, inputClassName: inputClassName, ...innerProps } = (0, (0, parcelRequire("g2UN3")).cleanCommonProps)(props);
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("g2UN3")).getStyleProps)(props, 'input', {
                'input-container': true
            }),
            "data-value": value || ''
        }, (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            className: cx({
                input: true
            }, inputClassName),
            ref: innerRef,
            style: $722f6bdaf9005a3c$var$inputStyle(isHidden),
            disabled: isDisabled,
            ...innerProps
        }));
    };
    var $722f6bdaf9005a3c$export$2e2bcd8739ae039 = $722f6bdaf9005a3c$var$Input;
});
parcelRegister("b4pnV", function(module, exports) {
    $parcel$export(module.exports, "menuCSS", ()=>$b1a905a6e7ee6f32$export$a228922d5ca42a79);
    $parcel$export(module.exports, "MenuPlacer", ()=>$b1a905a6e7ee6f32$export$f32337f3a7617699);
    $parcel$export(module.exports, "default", ()=>$b1a905a6e7ee6f32$export$2e2bcd8739ae039);
    $parcel$export(module.exports, "menuListCSS", ()=>$b1a905a6e7ee6f32$export$abafed69cff95d5e);
    $parcel$export(module.exports, "MenuList", ()=>$b1a905a6e7ee6f32$export$d4c4e98c5044dc8);
    $parcel$export(module.exports, "noOptionsMessageCSS", ()=>$b1a905a6e7ee6f32$export$cf0e22534d8b0074);
    $parcel$export(module.exports, "loadingMessageCSS", ()=>$b1a905a6e7ee6f32$export$98ec46397a8cb3cd);
    $parcel$export(module.exports, "NoOptionsMessage", ()=>$b1a905a6e7ee6f32$export$d58b72b7d3c4072c);
    $parcel$export(module.exports, "LoadingMessage", ()=>$b1a905a6e7ee6f32$export$e928a71d039d3102);
    $parcel$export(module.exports, "menuPortalCSS", ()=>$b1a905a6e7ee6f32$export$1dbbeb9648d1fdc9);
    $parcel$export(module.exports, "MenuPortal", ()=>$b1a905a6e7ee6f32$export$793392f970497feb);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $g9RrE;
    var $7nsd3 = parcelRequire("7nsd3");
    var $hrqx3 = parcelRequire("hrqx3");
    var $g2UN3;
    function $b1a905a6e7ee6f32$export$bd649b913ec78e4a({ maxHeight: preferredMaxHeight, menuEl: menuEl, minHeight: minHeight, placement: preferredPlacement, shouldScroll: shouldScroll, isFixedPosition: isFixedPosition, controlHeight: controlHeight }) {
        const scrollParent = (0, (0, parcelRequire("g2UN3")).getScrollParent)(menuEl);
        const defaultState = {
            placement: 'bottom',
            maxHeight: preferredMaxHeight
        };
        if (!menuEl || !menuEl.offsetParent) return defaultState;
        const { height: scrollHeight } = scrollParent.getBoundingClientRect();
        const { bottom: menuBottom, height: menuHeight, top: menuTop } = menuEl.getBoundingClientRect();
        const { top: containerTop } = menuEl.offsetParent.getBoundingClientRect();
        const viewHeight = isFixedPosition ? window.innerHeight : (0, (0, parcelRequire("g2UN3")).normalizedHeight)(scrollParent);
        const scrollTop = (0, (0, parcelRequire("g2UN3")).getScrollTop)(scrollParent);
        const marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
        const marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
        const viewSpaceAbove = containerTop - marginTop;
        const viewSpaceBelow = viewHeight - menuTop;
        const scrollSpaceAbove = viewSpaceAbove + scrollTop;
        const scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
        const scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
        const scrollUp = scrollTop + menuTop - marginTop;
        const scrollDuration = 160;
        switch(preferredPlacement){
            case 'auto':
            case 'bottom':
                if (viewSpaceBelow >= menuHeight) return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
                if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                    if (shouldScroll) (0, (0, parcelRequire("g2UN3")).animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                    return {
                        placement: 'bottom',
                        maxHeight: preferredMaxHeight
                    };
                }
                if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                    if (shouldScroll) (0, (0, parcelRequire("g2UN3")).animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                    const constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                    return {
                        placement: 'bottom',
                        maxHeight: constrainedHeight
                    };
                }
                if (preferredPlacement === 'auto' || isFixedPosition) {
                    let constrainedHeight = preferredMaxHeight;
                    const spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                    if (spaceAbove >= minHeight) constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                    return {
                        placement: 'top',
                        maxHeight: constrainedHeight
                    };
                }
                if (preferredPlacement === 'bottom') {
                    if (shouldScroll) (0, (0, parcelRequire("g2UN3")).scrollTo)(scrollParent, scrollDown);
                    return {
                        placement: 'bottom',
                        maxHeight: preferredMaxHeight
                    };
                }
                break;
            case 'top':
                if (viewSpaceAbove >= menuHeight) return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
                if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                    if (shouldScroll) (0, (0, parcelRequire("g2UN3")).animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                    return {
                        placement: 'top',
                        maxHeight: preferredMaxHeight
                    };
                }
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                    let constrainedHeight = preferredMaxHeight;
                    if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) constrainedHeight = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                    if (shouldScroll) (0, (0, parcelRequire("g2UN3")).animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                    return {
                        placement: 'top',
                        maxHeight: constrainedHeight
                    };
                }
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            default:
                throw new Error(`Invalid placement provided "${preferredPlacement}".`);
        }
        return defaultState;
    }
    function $b1a905a6e7ee6f32$var$alignToControl(placement) {
        const placementToCSSProp = {
            bottom: 'top',
            top: 'bottom'
        };
        return placement ? placementToCSSProp[placement] : 'bottom';
    }
    const $b1a905a6e7ee6f32$var$coercePlacement = (p)=>p === 'auto' ? 'bottom' : p;
    const $b1a905a6e7ee6f32$export$a228922d5ca42a79 = ({ placement: placement, theme: { borderRadius: borderRadius, spacing: spacing, colors: colors } }, unstyled)=>({
            label: 'menu',
            [$b1a905a6e7ee6f32$var$alignToControl(placement)]: '100%',
            position: 'absolute',
            width: '100%',
            zIndex: 1,
            ...unstyled ? {} : {
                backgroundColor: colors.neutral0,
                borderRadius: borderRadius,
                boxShadow: '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)',
                marginBottom: spacing.menuGutter,
                marginTop: spacing.menuGutter
            }
        });
    const $b1a905a6e7ee6f32$var$PortalPlacementContext = (0, $5uXOq.createContext)(null);
    const $b1a905a6e7ee6f32$export$f32337f3a7617699 = (props)=>{
        const { children: children, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuPlacement: menuPlacement, menuPosition: menuPosition, menuShouldScrollIntoView: menuShouldScrollIntoView, theme: theme } = props;
        const { setPortalPlacement: setPortalPlacement } = (0, $5uXOq.useContext)($b1a905a6e7ee6f32$var$PortalPlacementContext) || {};
        const ref = (0, $5uXOq.useRef)(null);
        const [maxHeight, setMaxHeight] = (0, $5uXOq.useState)(maxMenuHeight);
        const [placement, setPlacement] = (0, $5uXOq.useState)(null);
        const { controlHeight: controlHeight } = theme.spacing;
        (0, $hrqx3.default)(()=>{
            const menuEl = ref.current;
            if (!menuEl) return;
            const isFixedPosition = menuPosition === 'fixed';
            const shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
            const state = $b1a905a6e7ee6f32$export$bd649b913ec78e4a({
                maxHeight: maxMenuHeight,
                menuEl: menuEl,
                minHeight: minMenuHeight,
                placement: menuPlacement,
                shouldScroll: shouldScroll,
                isFixedPosition: isFixedPosition,
                controlHeight: controlHeight
            });
            setMaxHeight(state.maxHeight);
            setPlacement(state.placement);
            setPortalPlacement?.(state.placement);
        }, [
            maxMenuHeight,
            menuPlacement,
            menuPosition,
            menuShouldScrollIntoView,
            minMenuHeight,
            setPortalPlacement,
            controlHeight
        ]);
        return children({
            ref: ref,
            placerProps: {
                ...props,
                placement: placement || $b1a905a6e7ee6f32$var$coercePlacement(menuPlacement),
                maxHeight: maxHeight
            }
        });
    };
    const $b1a905a6e7ee6f32$var$Menu = (props)=>{
        const { children: children, innerRef: innerRef, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("g2UN3")).getStyleProps)(props, 'menu', {
                menu: true
            }),
            ref: innerRef,
            ...innerProps
        }, children);
    };
    var $b1a905a6e7ee6f32$export$2e2bcd8739ae039 = $b1a905a6e7ee6f32$var$Menu;
    const $b1a905a6e7ee6f32$export$abafed69cff95d5e = ({ maxHeight: maxHeight, theme: { spacing: { baseUnit: baseUnit } } }, unstyled)=>({
            maxHeight: maxHeight,
            overflowY: 'auto',
            position: 'relative',
            WebkitOverflowScrolling: 'touch',
            ...unstyled ? {} : {
                paddingBottom: baseUnit,
                paddingTop: baseUnit
            }
        });
    const $b1a905a6e7ee6f32$export$d4c4e98c5044dc8 = (props)=>{
        const { children: children, innerProps: innerProps, innerRef: innerRef, isMulti: isMulti } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("g2UN3")).getStyleProps)(props, 'menuList', {
                'menu-list': true,
                'menu-list--is-multi': isMulti
            }),
            ref: innerRef,
            ...innerProps,
            tabIndex: -1
        }, children);
    };
    const $b1a905a6e7ee6f32$var$noticeCSS = ({ theme: { spacing: { baseUnit: baseUnit }, colors: colors } }, unstyled)=>({
            textAlign: 'center',
            ...unstyled ? {} : {
                color: colors.neutral40,
                padding: `${baseUnit * 2}px ${baseUnit * 3}px`
            }
        });
    const $b1a905a6e7ee6f32$export$cf0e22534d8b0074 = $b1a905a6e7ee6f32$var$noticeCSS;
    const $b1a905a6e7ee6f32$export$98ec46397a8cb3cd = $b1a905a6e7ee6f32$var$noticeCSS;
    const $b1a905a6e7ee6f32$export$d58b72b7d3c4072c = ({ children: children = 'No options', innerProps: innerProps, ...restProps })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("g2UN3")).getStyleProps)({
                ...restProps,
                children: children,
                innerProps: innerProps
            }, 'noOptionsMessage', {
                'menu-notice': true,
                'menu-notice--no-options': true
            }),
            role: "option",
            ...innerProps
        }, children);
    };
    const $b1a905a6e7ee6f32$export$e928a71d039d3102 = ({ children: children = 'Loading...', innerProps: innerProps, ...restProps })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("g2UN3")).getStyleProps)({
                ...restProps,
                children: children,
                innerProps: innerProps
            }, 'loadingMessage', {
                'menu-notice': true,
                'menu-notice--loading': true
            }),
            ...innerProps,
            role: "option"
        }, children);
    };
    const $b1a905a6e7ee6f32$export$1dbbeb9648d1fdc9 = ({ rect: rect, offset: offset, position: position })=>({
            left: rect.left,
            position: position,
            top: offset,
            width: rect.width,
            zIndex: 1
        });
    const $b1a905a6e7ee6f32$export$793392f970497feb = (props)=>{
        const { appendTo: appendTo, children: children, controlElement: controlElement, innerProps: innerProps, menuPlacement: menuPlacement, menuPosition: menuPosition } = props;
        const menuPortalRef = (0, $5uXOq.useRef)(null);
        const cleanupRef = (0, $5uXOq.useRef)(null);
        const [placement, setPortalPlacement] = (0, $5uXOq.useState)($b1a905a6e7ee6f32$var$coercePlacement(menuPlacement));
        const portalPlacementContext = (0, $5uXOq.useMemo)(()=>({
                setPortalPlacement: setPortalPlacement
            }), []);
        const [computedPosition, setComputedPosition] = (0, $5uXOq.useState)(null);
        const updateComputedPosition = (0, $5uXOq.useCallback)(()=>{
            if (!controlElement) return;
            const rect = (0, (0, parcelRequire("g2UN3")).getBoundingClientObj)(controlElement);
            const scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
            const offset = rect[placement] + scrollDistance;
            if (offset !== computedPosition?.offset || rect.left !== computedPosition?.rect.left || rect.width !== computedPosition?.rect.width) setComputedPosition({
                offset: offset,
                rect: rect
            });
        }, [
            controlElement,
            menuPosition,
            placement,
            computedPosition?.offset,
            computedPosition?.rect.left,
            computedPosition?.rect.width
        ]);
        (0, $hrqx3.default)(()=>{
            updateComputedPosition();
        }, [
            updateComputedPosition
        ]);
        const runAutoUpdate = (0, $5uXOq.useCallback)(()=>{
            if (typeof cleanupRef.current === 'function') {
                cleanupRef.current();
                cleanupRef.current = null;
            }
            if (controlElement && menuPortalRef.current) cleanupRef.current = (0, (0, parcelRequire("g9RrE")).autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
                elementResize: 'ResizeObserver' in window
            });
        }, [
            controlElement,
            updateComputedPosition
        ]);
        (0, $hrqx3.default)(()=>{
            runAutoUpdate();
        }, [
            runAutoUpdate
        ]);
        const setMenuPortalElement = (0, $5uXOq.useCallback)((menuPortalElement)=>{
            menuPortalRef.current = menuPortalElement;
            runAutoUpdate();
        }, [
            runAutoUpdate
        ]);
        if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
        const menuWrapper = (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ref: setMenuPortalElement,
            ...(0, (0, parcelRequire("g2UN3")).getStyleProps)({
                ...props,
                offset: computedPosition.offset,
                position: menuPosition,
                rect: computedPosition.rect
            }, 'menuPortal', {
                'menu-portal': true
            }),
            ...innerProps
        }, children);
        return (0, (0, parcelRequire("f8Sb3")).jsx)($b1a905a6e7ee6f32$var$PortalPlacementContext.Provider, {
            value: portalPlacementContext
        }, appendTo ? (0, $7nsd3.createPortal)(menuWrapper, appendTo) : menuWrapper);
    };
});
parcelRegister("g9RrE", function(module, exports) {
    $parcel$export(module.exports, "autoUpdate", ()=>$bc36f1aefc070984$export$deee3a793edee05f);
    var $gSfPF;
    var $cVo0M;
    var $cVo0M;
    var $f8LYQ;
    function $bc36f1aefc070984$var$getCssDimensions(element) {
        const css = (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(element);
        let width = parseFloat(css.width) || 0;
        let height = parseFloat(css.height) || 0;
        const hasOffset = (0, (0, parcelRequire("f8LYQ")).isHTMLElement)(element);
        const offsetWidth = hasOffset ? element.offsetWidth : width;
        const offsetHeight = hasOffset ? element.offsetHeight : height;
        const shouldFallback = (0, (0, parcelRequire("cVo0M")).round)(width) !== offsetWidth || (0, (0, parcelRequire("cVo0M")).round)(height) !== offsetHeight;
        if (shouldFallback) {
            width = offsetWidth;
            height = offsetHeight;
        }
        return {
            width: width,
            height: height,
            $: shouldFallback
        };
    }
    function $bc36f1aefc070984$var$unwrapElement(element) {
        return !(0, (0, parcelRequire("f8LYQ")).isElement)(element) ? element.contextElement : element;
    }
    function $bc36f1aefc070984$var$getScale(element) {
        const domElement = $bc36f1aefc070984$var$unwrapElement(element);
        if (!(0, (0, parcelRequire("f8LYQ")).isHTMLElement)(domElement)) return (0, (0, parcelRequire("cVo0M")).createCoords)(1);
        const rect = domElement.getBoundingClientRect();
        const { width: width, height: height, $: $ } = $bc36f1aefc070984$var$getCssDimensions(domElement);
        let x = ($ ? (0, (0, parcelRequire("cVo0M")).round)(rect.width) : rect.width) / width;
        let y = ($ ? (0, (0, parcelRequire("cVo0M")).round)(rect.height) : rect.height) / height;
        if (!x || !Number.isFinite(x)) x = 1;
        if (!y || !Number.isFinite(y)) y = 1;
        return {
            x: x,
            y: y
        };
    }
    const $bc36f1aefc070984$var$noOffsets = (0, (0, parcelRequire("cVo0M")).createCoords)(0);
    function $bc36f1aefc070984$var$getVisualOffsets(element) {
        const win = (0, (0, parcelRequire("f8LYQ")).getWindow)(element);
        if (!(0, (0, parcelRequire("f8LYQ")).isWebKit)() || !win.visualViewport) return $bc36f1aefc070984$var$noOffsets;
        return {
            x: win.visualViewport.offsetLeft,
            y: win.visualViewport.offsetTop
        };
    }
    function $bc36f1aefc070984$var$shouldAddVisualOffsets(element, isFixed, floatingOffsetParent) {
        if (isFixed === void 0) isFixed = false;
        if (!floatingOffsetParent || isFixed && floatingOffsetParent !== (0, (0, parcelRequire("f8LYQ")).getWindow)(element)) return false;
        return isFixed;
    }
    function $bc36f1aefc070984$var$getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
        if (includeScale === void 0) includeScale = false;
        if (isFixedStrategy === void 0) isFixedStrategy = false;
        const clientRect = element.getBoundingClientRect();
        const domElement = $bc36f1aefc070984$var$unwrapElement(element);
        let scale = (0, (0, parcelRequire("cVo0M")).createCoords)(1);
        if (includeScale) {
            if (offsetParent) {
                if ((0, (0, parcelRequire("f8LYQ")).isElement)(offsetParent)) scale = $bc36f1aefc070984$var$getScale(offsetParent);
            } else scale = $bc36f1aefc070984$var$getScale(element);
        }
        const visualOffsets = $bc36f1aefc070984$var$shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? $bc36f1aefc070984$var$getVisualOffsets(domElement) : (0, (0, parcelRequire("cVo0M")).createCoords)(0);
        let x = (clientRect.left + visualOffsets.x) / scale.x;
        let y = (clientRect.top + visualOffsets.y) / scale.y;
        let width = clientRect.width / scale.x;
        let height = clientRect.height / scale.y;
        if (domElement) {
            const win = (0, (0, parcelRequire("f8LYQ")).getWindow)(domElement);
            const offsetWin = offsetParent && (0, (0, parcelRequire("f8LYQ")).isElement)(offsetParent) ? (0, (0, parcelRequire("f8LYQ")).getWindow)(offsetParent) : offsetParent;
            let currentWin = win;
            let currentIFrame = (0, (0, parcelRequire("f8LYQ")).getFrameElement)(currentWin);
            while(currentIFrame && offsetParent && offsetWin !== currentWin){
                const iframeScale = $bc36f1aefc070984$var$getScale(currentIFrame);
                const iframeRect = currentIFrame.getBoundingClientRect();
                const css = (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(currentIFrame);
                const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
                const top = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
                x *= iframeScale.x;
                y *= iframeScale.y;
                width *= iframeScale.x;
                height *= iframeScale.y;
                x += left;
                y += top;
                currentWin = (0, (0, parcelRequire("f8LYQ")).getWindow)(currentIFrame);
                currentIFrame = (0, (0, parcelRequire("f8LYQ")).getFrameElement)(currentWin);
            }
        }
        return (0, (0, parcelRequire("cVo0M")).rectToClientRect)({
            width: width,
            height: height,
            x: x,
            y: y
        });
    }
    function $bc36f1aefc070984$var$getWindowScrollBarX(element, rect) {
        const leftScroll = (0, (0, parcelRequire("f8LYQ")).getNodeScroll)(element).scrollLeft;
        if (!rect) return $bc36f1aefc070984$var$getBoundingClientRect((0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element)).left + leftScroll;
        return rect.left + leftScroll;
    }
    function $bc36f1aefc070984$var$getHTMLOffset(documentElement, scroll, ignoreScrollbarX) {
        if (ignoreScrollbarX === void 0) ignoreScrollbarX = false;
        const htmlRect = documentElement.getBoundingClientRect();
        const x = htmlRect.left + scroll.scrollLeft - (ignoreScrollbarX ? 0 : $bc36f1aefc070984$var$getWindowScrollBarX(documentElement, htmlRect));
        const y = htmlRect.top + scroll.scrollTop;
        return {
            x: x,
            y: y
        };
    }
    function $bc36f1aefc070984$var$convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
        let { elements: elements, rect: rect, offsetParent: offsetParent, strategy: strategy } = _ref;
        const isFixed = strategy === 'fixed';
        const documentElement = (0, (0, parcelRequire("f8LYQ")).getDocumentElement)(offsetParent);
        const topLayer = elements ? (0, (0, parcelRequire("f8LYQ")).isTopLayer)(elements.floating) : false;
        if (offsetParent === documentElement || topLayer && isFixed) return rect;
        let scroll = {
            scrollLeft: 0,
            scrollTop: 0
        };
        let scale = (0, (0, parcelRequire("cVo0M")).createCoords)(1);
        const offsets = (0, (0, parcelRequire("cVo0M")).createCoords)(0);
        const isOffsetParentAnElement = (0, (0, parcelRequire("f8LYQ")).isHTMLElement)(offsetParent);
        if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
            if ((0, (0, parcelRequire("f8LYQ")).getNodeName)(offsetParent) !== 'body' || (0, (0, parcelRequire("f8LYQ")).isOverflowElement)(documentElement)) scroll = (0, (0, parcelRequire("f8LYQ")).getNodeScroll)(offsetParent);
            if ((0, (0, parcelRequire("f8LYQ")).isHTMLElement)(offsetParent)) {
                const offsetRect = $bc36f1aefc070984$var$getBoundingClientRect(offsetParent);
                scale = $bc36f1aefc070984$var$getScale(offsetParent);
                offsets.x = offsetRect.x + offsetParent.clientLeft;
                offsets.y = offsetRect.y + offsetParent.clientTop;
            }
        }
        const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $bc36f1aefc070984$var$getHTMLOffset(documentElement, scroll, true) : (0, (0, parcelRequire("cVo0M")).createCoords)(0);
        return {
            width: rect.width * scale.x,
            height: rect.height * scale.y,
            x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
            y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
        };
    }
    function $bc36f1aefc070984$var$getClientRects(element) {
        return Array.from(element.getClientRects());
    }
    function $bc36f1aefc070984$var$getDocumentRect(element) {
        const html = (0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element);
        const scroll = (0, (0, parcelRequire("f8LYQ")).getNodeScroll)(element);
        const body = element.ownerDocument.body;
        const width = (0, (0, parcelRequire("cVo0M")).max)(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
        const height = (0, (0, parcelRequire("cVo0M")).max)(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
        let x = -scroll.scrollLeft + $bc36f1aefc070984$var$getWindowScrollBarX(element);
        const y = -scroll.scrollTop;
        if ((0, (0, parcelRequire("f8LYQ")).getComputedStyle)(body).direction === 'rtl') x += (0, (0, parcelRequire("cVo0M")).max)(html.clientWidth, body.clientWidth) - width;
        return {
            width: width,
            height: height,
            x: x,
            y: y
        };
    }
    function $bc36f1aefc070984$var$getViewportRect(element, strategy) {
        const win = (0, (0, parcelRequire("f8LYQ")).getWindow)(element);
        const html = (0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element);
        const visualViewport = win.visualViewport;
        let width = html.clientWidth;
        let height = html.clientHeight;
        let x = 0;
        let y = 0;
        if (visualViewport) {
            width = visualViewport.width;
            height = visualViewport.height;
            const visualViewportBased = (0, (0, parcelRequire("f8LYQ")).isWebKit)();
            if (!visualViewportBased || visualViewportBased && strategy === 'fixed') {
                x = visualViewport.offsetLeft;
                y = visualViewport.offsetTop;
            }
        }
        return {
            width: width,
            height: height,
            x: x,
            y: y
        };
    }
    function $bc36f1aefc070984$var$getInnerBoundingClientRect(element, strategy) {
        const clientRect = $bc36f1aefc070984$var$getBoundingClientRect(element, true, strategy === 'fixed');
        const top = clientRect.top + element.clientTop;
        const left = clientRect.left + element.clientLeft;
        const scale = (0, (0, parcelRequire("f8LYQ")).isHTMLElement)(element) ? $bc36f1aefc070984$var$getScale(element) : (0, (0, parcelRequire("cVo0M")).createCoords)(1);
        const width = element.clientWidth * scale.x;
        const height = element.clientHeight * scale.y;
        const x = left * scale.x;
        const y = top * scale.y;
        return {
            width: width,
            height: height,
            x: x,
            y: y
        };
    }
    function $bc36f1aefc070984$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
        let rect;
        if (clippingAncestor === 'viewport') rect = $bc36f1aefc070984$var$getViewportRect(element, strategy);
        else if (clippingAncestor === 'document') rect = $bc36f1aefc070984$var$getDocumentRect((0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element));
        else if ((0, (0, parcelRequire("f8LYQ")).isElement)(clippingAncestor)) rect = $bc36f1aefc070984$var$getInnerBoundingClientRect(clippingAncestor, strategy);
        else {
            const visualOffsets = $bc36f1aefc070984$var$getVisualOffsets(element);
            rect = {
                x: clippingAncestor.x - visualOffsets.x,
                y: clippingAncestor.y - visualOffsets.y,
                width: clippingAncestor.width,
                height: clippingAncestor.height
            };
        }
        return (0, (0, parcelRequire("cVo0M")).rectToClientRect)(rect);
    }
    function $bc36f1aefc070984$var$hasFixedPositionAncestor(element, stopNode) {
        const parentNode = (0, (0, parcelRequire("f8LYQ")).getParentNode)(element);
        if (parentNode === stopNode || !(0, (0, parcelRequire("f8LYQ")).isElement)(parentNode) || (0, (0, parcelRequire("f8LYQ")).isLastTraversableNode)(parentNode)) return false;
        return (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(parentNode).position === 'fixed' || $bc36f1aefc070984$var$hasFixedPositionAncestor(parentNode, stopNode);
    }
    function $bc36f1aefc070984$var$getClippingElementAncestors(element, cache) {
        const cachedResult = cache.get(element);
        if (cachedResult) return cachedResult;
        let result = (0, (0, parcelRequire("f8LYQ")).getOverflowAncestors)(element, [], false).filter((el)=>(0, (0, parcelRequire("f8LYQ")).isElement)(el) && (0, (0, parcelRequire("f8LYQ")).getNodeName)(el) !== 'body');
        let currentContainingBlockComputedStyle = null;
        const elementIsFixed = (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(element).position === 'fixed';
        let currentNode = elementIsFixed ? (0, (0, parcelRequire("f8LYQ")).getParentNode)(element) : element;
        while((0, (0, parcelRequire("f8LYQ")).isElement)(currentNode) && !(0, (0, parcelRequire("f8LYQ")).isLastTraversableNode)(currentNode)){
            const computedStyle = (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(currentNode);
            const currentNodeIsContaining = (0, (0, parcelRequire("f8LYQ")).isContainingBlock)(currentNode);
            if (!currentNodeIsContaining && computedStyle.position === 'fixed') currentContainingBlockComputedStyle = null;
            const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === 'static' && !!currentContainingBlockComputedStyle && [
                'absolute',
                'fixed'
            ].includes(currentContainingBlockComputedStyle.position) || (0, (0, parcelRequire("f8LYQ")).isOverflowElement)(currentNode) && !currentNodeIsContaining && $bc36f1aefc070984$var$hasFixedPositionAncestor(element, currentNode);
            if (shouldDropCurrentNode) result = result.filter((ancestor)=>ancestor !== currentNode);
            else currentContainingBlockComputedStyle = computedStyle;
            currentNode = (0, (0, parcelRequire("f8LYQ")).getParentNode)(currentNode);
        }
        cache.set(element, result);
        return result;
    }
    function $bc36f1aefc070984$var$getClippingRect(_ref) {
        let { element: element, boundary: boundary, rootBoundary: rootBoundary, strategy: strategy } = _ref;
        const elementClippingAncestors = boundary === 'clippingAncestors' ? (0, (0, parcelRequire("f8LYQ")).isTopLayer)(element) ? [] : $bc36f1aefc070984$var$getClippingElementAncestors(element, this._c) : [].concat(boundary);
        const clippingAncestors = [
            ...elementClippingAncestors,
            rootBoundary
        ];
        const firstClippingAncestor = clippingAncestors[0];
        const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor)=>{
            const rect = $bc36f1aefc070984$var$getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
            accRect.top = (0, (0, parcelRequire("cVo0M")).max)(rect.top, accRect.top);
            accRect.right = (0, (0, parcelRequire("cVo0M")).min)(rect.right, accRect.right);
            accRect.bottom = (0, (0, parcelRequire("cVo0M")).min)(rect.bottom, accRect.bottom);
            accRect.left = (0, (0, parcelRequire("cVo0M")).max)(rect.left, accRect.left);
            return accRect;
        }, $bc36f1aefc070984$var$getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
        return {
            width: clippingRect.right - clippingRect.left,
            height: clippingRect.bottom - clippingRect.top,
            x: clippingRect.left,
            y: clippingRect.top
        };
    }
    function $bc36f1aefc070984$var$getDimensions(element) {
        const { width: width, height: height } = $bc36f1aefc070984$var$getCssDimensions(element);
        return {
            width: width,
            height: height
        };
    }
    function $bc36f1aefc070984$var$getRectRelativeToOffsetParent(element, offsetParent, strategy) {
        const isOffsetParentAnElement = (0, (0, parcelRequire("f8LYQ")).isHTMLElement)(offsetParent);
        const documentElement = (0, (0, parcelRequire("f8LYQ")).getDocumentElement)(offsetParent);
        const isFixed = strategy === 'fixed';
        const rect = $bc36f1aefc070984$var$getBoundingClientRect(element, true, isFixed, offsetParent);
        let scroll = {
            scrollLeft: 0,
            scrollTop: 0
        };
        const offsets = (0, (0, parcelRequire("cVo0M")).createCoords)(0);
        if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
            if ((0, (0, parcelRequire("f8LYQ")).getNodeName)(offsetParent) !== 'body' || (0, (0, parcelRequire("f8LYQ")).isOverflowElement)(documentElement)) scroll = (0, (0, parcelRequire("f8LYQ")).getNodeScroll)(offsetParent);
            if (isOffsetParentAnElement) {
                const offsetRect = $bc36f1aefc070984$var$getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
                offsets.x = offsetRect.x + offsetParent.clientLeft;
                offsets.y = offsetRect.y + offsetParent.clientTop;
            } else if (documentElement) offsets.x = $bc36f1aefc070984$var$getWindowScrollBarX(documentElement);
        }
        const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? $bc36f1aefc070984$var$getHTMLOffset(documentElement, scroll) : (0, (0, parcelRequire("cVo0M")).createCoords)(0);
        const x = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
        const y = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
        return {
            x: x,
            y: y,
            width: rect.width,
            height: rect.height
        };
    }
    function $bc36f1aefc070984$var$isStaticPositioned(element) {
        return (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(element).position === 'static';
    }
    function $bc36f1aefc070984$var$getTrueOffsetParent(element, polyfill) {
        if (!(0, (0, parcelRequire("f8LYQ")).isHTMLElement)(element) || (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(element).position === 'fixed') return null;
        if (polyfill) return polyfill(element);
        let rawOffsetParent = element.offsetParent;
        if ((0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element) === rawOffsetParent) rawOffsetParent = rawOffsetParent.ownerDocument.body;
        return rawOffsetParent;
    }
    function $bc36f1aefc070984$var$getOffsetParent(element, polyfill) {
        const win = (0, (0, parcelRequire("f8LYQ")).getWindow)(element);
        if ((0, (0, parcelRequire("f8LYQ")).isTopLayer)(element)) return win;
        if (!(0, (0, parcelRequire("f8LYQ")).isHTMLElement)(element)) {
            let svgOffsetParent = (0, (0, parcelRequire("f8LYQ")).getParentNode)(element);
            while(svgOffsetParent && !(0, (0, parcelRequire("f8LYQ")).isLastTraversableNode)(svgOffsetParent)){
                if ((0, (0, parcelRequire("f8LYQ")).isElement)(svgOffsetParent) && !$bc36f1aefc070984$var$isStaticPositioned(svgOffsetParent)) return svgOffsetParent;
                svgOffsetParent = (0, (0, parcelRequire("f8LYQ")).getParentNode)(svgOffsetParent);
            }
            return win;
        }
        let offsetParent = $bc36f1aefc070984$var$getTrueOffsetParent(element, polyfill);
        while(offsetParent && (0, (0, parcelRequire("f8LYQ")).isTableElement)(offsetParent) && $bc36f1aefc070984$var$isStaticPositioned(offsetParent))offsetParent = $bc36f1aefc070984$var$getTrueOffsetParent(offsetParent, polyfill);
        if (offsetParent && (0, (0, parcelRequire("f8LYQ")).isLastTraversableNode)(offsetParent) && $bc36f1aefc070984$var$isStaticPositioned(offsetParent) && !(0, (0, parcelRequire("f8LYQ")).isContainingBlock)(offsetParent)) return win;
        return offsetParent || (0, (0, parcelRequire("f8LYQ")).getContainingBlock)(element) || win;
    }
    const $bc36f1aefc070984$var$getElementRects = async function(data) {
        const getOffsetParentFn = this.getOffsetParent || $bc36f1aefc070984$var$getOffsetParent;
        const getDimensionsFn = this.getDimensions;
        const floatingDimensions = await getDimensionsFn(data.floating);
        return {
            reference: $bc36f1aefc070984$var$getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
            floating: {
                x: 0,
                y: 0,
                width: floatingDimensions.width,
                height: floatingDimensions.height
            }
        };
    };
    function $bc36f1aefc070984$var$isRTL(element) {
        return (0, (0, parcelRequire("f8LYQ")).getComputedStyle)(element).direction === 'rtl';
    }
    const $bc36f1aefc070984$export$722a64dea1b767dc = {
        convertOffsetParentRelativeRectToViewportRelativeRect: $bc36f1aefc070984$var$convertOffsetParentRelativeRectToViewportRelativeRect,
        getDocumentElement: (0, parcelRequire("f8LYQ")).getDocumentElement,
        getClippingRect: $bc36f1aefc070984$var$getClippingRect,
        getOffsetParent: $bc36f1aefc070984$var$getOffsetParent,
        getElementRects: $bc36f1aefc070984$var$getElementRects,
        getClientRects: $bc36f1aefc070984$var$getClientRects,
        getDimensions: $bc36f1aefc070984$var$getDimensions,
        getScale: $bc36f1aefc070984$var$getScale,
        isElement: (0, parcelRequire("f8LYQ")).isElement,
        isRTL: $bc36f1aefc070984$var$isRTL
    };
    function $bc36f1aefc070984$var$observeMove(element, onMove) {
        let io = null;
        let timeoutId;
        const root = (0, (0, parcelRequire("f8LYQ")).getDocumentElement)(element);
        function cleanup() {
            var _io;
            clearTimeout(timeoutId);
            (_io = io) == null || _io.disconnect();
            io = null;
        }
        function refresh(skip, threshold) {
            if (skip === void 0) skip = false;
            if (threshold === void 0) threshold = 1;
            cleanup();
            const { left: left, top: top, width: width, height: height } = element.getBoundingClientRect();
            if (!skip) onMove();
            if (!width || !height) return;
            const insetTop = (0, (0, parcelRequire("cVo0M")).floor)(top);
            const insetRight = (0, (0, parcelRequire("cVo0M")).floor)(root.clientWidth - (left + width));
            const insetBottom = (0, (0, parcelRequire("cVo0M")).floor)(root.clientHeight - (top + height));
            const insetLeft = (0, (0, parcelRequire("cVo0M")).floor)(left);
            const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
            const options = {
                rootMargin: rootMargin,
                threshold: (0, (0, parcelRequire("cVo0M")).max)(0, (0, (0, parcelRequire("cVo0M")).min)(1, threshold)) || 1
            };
            let isFirstUpdate = true;
            function handleObserve(entries) {
                const ratio = entries[0].intersectionRatio;
                if (ratio !== threshold) {
                    if (!isFirstUpdate) return refresh();
                    if (!ratio) timeoutId = setTimeout(()=>{
                        refresh(false, 1e-7);
                    }, 1000);
                    else refresh(false, ratio);
                }
                isFirstUpdate = false;
            }
            try {
                io = new IntersectionObserver(handleObserve, {
                    ...options,
                    root: root.ownerDocument
                });
            } catch (e) {
                io = new IntersectionObserver(handleObserve, options);
            }
            io.observe(element);
        }
        refresh(true);
        return cleanup;
    }
    function $bc36f1aefc070984$export$deee3a793edee05f(reference, floating, update, options) {
        if (options === void 0) options = {};
        const { ancestorScroll: ancestorScroll = true, ancestorResize: ancestorResize = true, elementResize: elementResize = typeof ResizeObserver === 'function', layoutShift: layoutShift = typeof IntersectionObserver === 'function', animationFrame: animationFrame = false } = options;
        const referenceEl = $bc36f1aefc070984$var$unwrapElement(reference);
        const ancestors = ancestorScroll || ancestorResize ? [
            ...referenceEl ? (0, (0, parcelRequire("f8LYQ")).getOverflowAncestors)(referenceEl) : [],
            ...(0, (0, parcelRequire("f8LYQ")).getOverflowAncestors)(floating)
        ] : [];
        ancestors.forEach((ancestor)=>{
            ancestorScroll && ancestor.addEventListener('scroll', update, {
                passive: true
            });
            ancestorResize && ancestor.addEventListener('resize', update);
        });
        const cleanupIo = referenceEl && layoutShift ? $bc36f1aefc070984$var$observeMove(referenceEl, update) : null;
        let reobserveFrame = -1;
        let resizeObserver = null;
        if (elementResize) {
            resizeObserver = new ResizeObserver((_ref)=>{
                let [firstEntry] = _ref;
                if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
                    resizeObserver.unobserve(floating);
                    cancelAnimationFrame(reobserveFrame);
                    reobserveFrame = requestAnimationFrame(()=>{
                        var _resizeObserver;
                        (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
                    });
                }
                update();
            });
            if (referenceEl && !animationFrame) resizeObserver.observe(referenceEl);
            resizeObserver.observe(floating);
        }
        let frameId;
        let prevRefRect = animationFrame ? $bc36f1aefc070984$var$getBoundingClientRect(reference) : null;
        if (animationFrame) frameLoop();
        function frameLoop() {
            const nextRefRect = $bc36f1aefc070984$var$getBoundingClientRect(reference);
            if (prevRefRect && (nextRefRect.x !== prevRefRect.x || nextRefRect.y !== prevRefRect.y || nextRefRect.width !== prevRefRect.width || nextRefRect.height !== prevRefRect.height)) update();
            prevRefRect = nextRefRect;
            frameId = requestAnimationFrame(frameLoop);
        }
        update();
        return ()=>{
            var _resizeObserver2;
            ancestors.forEach((ancestor)=>{
                ancestorScroll && ancestor.removeEventListener('scroll', update);
                ancestorResize && ancestor.removeEventListener('resize', update);
            });
            cleanupIo == null || cleanupIo();
            (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
            resizeObserver = null;
            if (animationFrame) cancelAnimationFrame(frameId);
        };
    }
    const $bc36f1aefc070984$export$37b6bde19b108ecc = (0, (0, parcelRequire("gSfPF")).detectOverflow);
    const $bc36f1aefc070984$export$cc800923e997bb8 = (0, (0, parcelRequire("gSfPF")).offset);
    const $bc36f1aefc070984$export$91fb6ecbd551914 = (0, (0, parcelRequire("gSfPF")).autoPlacement);
    const $bc36f1aefc070984$export$fba63a578e423eb = (0, (0, parcelRequire("gSfPF")).shift);
    const $bc36f1aefc070984$export$8a83211c878a3f1f = (0, (0, parcelRequire("gSfPF")).flip);
    const $bc36f1aefc070984$export$346677f925de839c = (0, (0, parcelRequire("gSfPF")).size);
    const $bc36f1aefc070984$export$fe8985bb6374093c = (0, (0, parcelRequire("gSfPF")).hide);
    const $bc36f1aefc070984$export$f2120bbfa5450bd2 = (0, (0, parcelRequire("gSfPF")).arrow);
    const $bc36f1aefc070984$export$18c8ad048e32c7d5 = (0, (0, parcelRequire("gSfPF")).inline);
    const $bc36f1aefc070984$export$7bf07e38f3dc4b69 = (0, (0, parcelRequire("gSfPF")).limitShift);
    const $bc36f1aefc070984$export$48a53dcb22e581d0 = (reference, floating, options)=>{
        const cache = new Map();
        const mergedOptions = {
            platform: $bc36f1aefc070984$export$722a64dea1b767dc,
            ...options
        };
        const platformWithCache = {
            ...mergedOptions.platform,
            _c: cache
        };
        return (0, (0, parcelRequire("gSfPF")).computePosition)(reference, floating, {
            ...mergedOptions,
            platform: platformWithCache
        });
    };
});
parcelRegister("gSfPF", function(module, exports) {
    $parcel$export(module.exports, "computePosition", ()=>$c48df878d8118962$export$48a53dcb22e581d0);
    $parcel$export(module.exports, "detectOverflow", ()=>$c48df878d8118962$export$37b6bde19b108ecc);
    $parcel$export(module.exports, "arrow", ()=>$c48df878d8118962$export$f2120bbfa5450bd2);
    $parcel$export(module.exports, "autoPlacement", ()=>$c48df878d8118962$export$91fb6ecbd551914);
    $parcel$export(module.exports, "flip", ()=>$c48df878d8118962$export$8a83211c878a3f1f);
    $parcel$export(module.exports, "hide", ()=>$c48df878d8118962$export$fe8985bb6374093c);
    $parcel$export(module.exports, "inline", ()=>$c48df878d8118962$export$18c8ad048e32c7d5);
    $parcel$export(module.exports, "offset", ()=>$c48df878d8118962$export$cc800923e997bb8);
    $parcel$export(module.exports, "shift", ()=>$c48df878d8118962$export$fba63a578e423eb);
    $parcel$export(module.exports, "limitShift", ()=>$c48df878d8118962$export$7bf07e38f3dc4b69);
    $parcel$export(module.exports, "size", ()=>$c48df878d8118962$export$346677f925de839c);
    $parcel$export(module.exports, "rectToClientRect", ()=>(parcelRequire("cVo0M")).rectToClientRect);
    var $cVo0M;
    function $c48df878d8118962$var$computeCoordsFromPlacement(_ref, placement, rtl) {
        let { reference: reference, floating: floating } = _ref;
        const sideAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)(placement);
        const alignmentAxis = (0, (0, parcelRequire("cVo0M")).getAlignmentAxis)(placement);
        const alignLength = (0, (0, parcelRequire("cVo0M")).getAxisLength)(alignmentAxis);
        const side = (0, (0, parcelRequire("cVo0M")).getSide)(placement);
        const isVertical = sideAxis === 'y';
        const commonX = reference.x + reference.width / 2 - floating.width / 2;
        const commonY = reference.y + reference.height / 2 - floating.height / 2;
        const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
        let coords;
        switch(side){
            case 'top':
                coords = {
                    x: commonX,
                    y: reference.y - floating.height
                };
                break;
            case 'bottom':
                coords = {
                    x: commonX,
                    y: reference.y + reference.height
                };
                break;
            case 'right':
                coords = {
                    x: reference.x + reference.width,
                    y: commonY
                };
                break;
            case 'left':
                coords = {
                    x: reference.x - floating.width,
                    y: commonY
                };
                break;
            default:
                coords = {
                    x: reference.x,
                    y: reference.y
                };
        }
        switch((0, (0, parcelRequire("cVo0M")).getAlignment)(placement)){
            case 'start':
                coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
                break;
            case 'end':
                coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
                break;
        }
        return coords;
    }
    const $c48df878d8118962$export$48a53dcb22e581d0 = async (reference, floating, config)=>{
        const { placement: placement = 'bottom', strategy: strategy = 'absolute', middleware: middleware = [], platform: platform } = config;
        const validMiddleware = middleware.filter(Boolean);
        const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(floating));
        let rects = await platform.getElementRects({
            reference: reference,
            floating: floating,
            strategy: strategy
        });
        let { x: x, y: y } = $c48df878d8118962$var$computeCoordsFromPlacement(rects, placement, rtl);
        let statefulPlacement = placement;
        let middlewareData = {};
        let resetCount = 0;
        for(let i = 0; i < validMiddleware.length; i++){
            const { name: name, fn: fn } = validMiddleware[i];
            const { x: nextX, y: nextY, data: data, reset: reset } = await fn({
                x: x,
                y: y,
                initialPlacement: placement,
                placement: statefulPlacement,
                strategy: strategy,
                middlewareData: middlewareData,
                rects: rects,
                platform: platform,
                elements: {
                    reference: reference,
                    floating: floating
                }
            });
            x = nextX != null ? nextX : x;
            y = nextY != null ? nextY : y;
            middlewareData = {
                ...middlewareData,
                [name]: {
                    ...middlewareData[name],
                    ...data
                }
            };
            if (reset && resetCount <= 50) {
                resetCount++;
                if (typeof reset === 'object') {
                    if (reset.placement) statefulPlacement = reset.placement;
                    if (reset.rects) rects = reset.rects === true ? await platform.getElementRects({
                        reference: reference,
                        floating: floating,
                        strategy: strategy
                    }) : reset.rects;
                    ({ x: x, y: y } = $c48df878d8118962$var$computeCoordsFromPlacement(rects, statefulPlacement, rtl));
                }
                i = -1;
            }
        }
        return {
            x: x,
            y: y,
            placement: statefulPlacement,
            strategy: strategy,
            middlewareData: middlewareData
        };
    };
    async function $c48df878d8118962$export$37b6bde19b108ecc(state, options) {
        var _await$platform$isEle;
        if (options === void 0) options = {};
        const { x: x, y: y, platform: platform, rects: rects, elements: elements, strategy: strategy } = state;
        const { boundary: boundary = 'clippingAncestors', rootBoundary: rootBoundary = 'viewport', elementContext: elementContext = 'floating', altBoundary: altBoundary = false, padding: padding = 0 } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
        const paddingObject = (0, (0, parcelRequire("cVo0M")).getPaddingObject)(padding);
        const altContext = elementContext === 'floating' ? 'reference' : 'floating';
        const element = elements[altBoundary ? altContext : elementContext];
        const clippingClientRect = (0, (0, parcelRequire("cVo0M")).rectToClientRect)(await platform.getClippingRect({
            element: ((_await$platform$isEle = await (platform.isElement == null ? void 0 : platform.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform.getDocumentElement == null ? void 0 : platform.getDocumentElement(elements.floating)),
            boundary: boundary,
            rootBoundary: rootBoundary,
            strategy: strategy
        }));
        const rect = elementContext === 'floating' ? {
            x: x,
            y: y,
            width: rects.floating.width,
            height: rects.floating.height
        } : rects.reference;
        const offsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(elements.floating));
        const offsetScale = await (platform.isElement == null ? void 0 : platform.isElement(offsetParent)) ? await (platform.getScale == null ? void 0 : platform.getScale(offsetParent)) || {
            x: 1,
            y: 1
        } : {
            x: 1,
            y: 1
        };
        const elementClientRect = (0, (0, parcelRequire("cVo0M")).rectToClientRect)(platform.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform.convertOffsetParentRelativeRectToViewportRelativeRect({
            elements: elements,
            rect: rect,
            offsetParent: offsetParent,
            strategy: strategy
        }) : rect);
        return {
            top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
            bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
            left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
            right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
        };
    }
    const $c48df878d8118962$export$f2120bbfa5450bd2 = (options)=>({
            name: 'arrow',
            options: options,
            async fn (state) {
                const { x: x, y: y, placement: placement, rects: rects, platform: platform, elements: elements, middlewareData: middlewareData } = state;
                const { element: element, padding: padding = 0 } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state) || {};
                if (element == null) return {};
                const paddingObject = (0, (0, parcelRequire("cVo0M")).getPaddingObject)(padding);
                const coords = {
                    x: x,
                    y: y
                };
                const axis = (0, (0, parcelRequire("cVo0M")).getAlignmentAxis)(placement);
                const length = (0, (0, parcelRequire("cVo0M")).getAxisLength)(axis);
                const arrowDimensions = await platform.getDimensions(element);
                const isYAxis = axis === 'y';
                const minProp = isYAxis ? 'top' : 'left';
                const maxProp = isYAxis ? 'bottom' : 'right';
                const clientProp = isYAxis ? 'clientHeight' : 'clientWidth';
                const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
                const startDiff = coords[axis] - rects.reference[axis];
                const arrowOffsetParent = await (platform.getOffsetParent == null ? void 0 : platform.getOffsetParent(element));
                let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
                if (!clientSize || !await (platform.isElement == null ? void 0 : platform.isElement(arrowOffsetParent))) clientSize = elements.floating[clientProp] || rects.floating[length];
                const centerToReference = endDiff / 2 - startDiff / 2;
                const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
                const minPadding = (0, (0, parcelRequire("cVo0M")).min)(paddingObject[minProp], largestPossiblePadding);
                const maxPadding = (0, (0, parcelRequire("cVo0M")).min)(paddingObject[maxProp], largestPossiblePadding);
                const min$1 = minPadding;
                const max = clientSize - arrowDimensions[length] - maxPadding;
                const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
                const offset = (0, (0, parcelRequire("cVo0M")).clamp)(min$1, center, max);
                const shouldAddOffset = !middlewareData.arrow && (0, (0, parcelRequire("cVo0M")).getAlignment)(placement) != null && center !== offset && rects.reference[length] / 2 - (center < min$1 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
                const alignmentOffset = shouldAddOffset ? center < min$1 ? center - min$1 : center - max : 0;
                return {
                    [axis]: coords[axis] + alignmentOffset,
                    data: {
                        [axis]: offset,
                        centerOffset: center - offset - alignmentOffset,
                        ...shouldAddOffset && {
                            alignmentOffset: alignmentOffset
                        }
                    },
                    reset: shouldAddOffset
                };
            }
        });
    function $c48df878d8118962$var$getPlacementList(alignment, autoAlignment, allowedPlacements) {
        const allowedPlacementsSortedByAlignment = alignment ? [
            ...allowedPlacements.filter((placement)=>(0, (0, parcelRequire("cVo0M")).getAlignment)(placement) === alignment),
            ...allowedPlacements.filter((placement)=>(0, (0, parcelRequire("cVo0M")).getAlignment)(placement) !== alignment)
        ] : allowedPlacements.filter((placement)=>(0, (0, parcelRequire("cVo0M")).getSide)(placement) === placement);
        return allowedPlacementsSortedByAlignment.filter((placement)=>{
            if (alignment) return (0, (0, parcelRequire("cVo0M")).getAlignment)(placement) === alignment || (autoAlignment ? (0, (0, parcelRequire("cVo0M")).getOppositeAlignmentPlacement)(placement) !== placement : false);
            return true;
        });
    }
    const $c48df878d8118962$export$91fb6ecbd551914 = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'autoPlacement',
            options: options,
            async fn (state) {
                var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
                const { rects: rects, middlewareData: middlewareData, placement: placement, platform: platform, elements: elements } = state;
                const { crossAxis: crossAxis = false, alignment: alignment, allowedPlacements: allowedPlacements = (0, (0, parcelRequire("cVo0M")).placements), autoAlignment: autoAlignment = true, ...detectOverflowOptions } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                const placements$1 = alignment !== undefined || allowedPlacements === (0, (0, parcelRequire("cVo0M")).placements) ? $c48df878d8118962$var$getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
                const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
                const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
                const currentPlacement = placements$1[currentIndex];
                if (currentPlacement == null) return {};
                const alignmentSides = (0, (0, parcelRequire("cVo0M")).getAlignmentSides)(currentPlacement, rects, await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)));
                if (placement !== currentPlacement) return {
                    reset: {
                        placement: placements$1[0]
                    }
                };
                const currentOverflows = [
                    overflow[(0, (0, parcelRequire("cVo0M")).getSide)(currentPlacement)],
                    overflow[alignmentSides[0]],
                    overflow[alignmentSides[1]]
                ];
                const allOverflows = [
                    ...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [],
                    {
                        placement: currentPlacement,
                        overflows: currentOverflows
                    }
                ];
                const nextPlacement = placements$1[currentIndex + 1];
                if (nextPlacement) return {
                    data: {
                        index: currentIndex + 1,
                        overflows: allOverflows
                    },
                    reset: {
                        placement: nextPlacement
                    }
                };
                const placementsSortedByMostSpace = allOverflows.map((d)=>{
                    const alignment = (0, (0, parcelRequire("cVo0M")).getAlignment)(d.placement);
                    return [
                        d.placement,
                        alignment && crossAxis ? d.overflows.slice(0, 2).reduce((acc, v)=>acc + v, 0) : d.overflows[0],
                        d.overflows
                    ];
                }).sort((a, b)=>a[1] - b[1]);
                const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d)=>d[2].slice(0, (0, (0, parcelRequire("cVo0M")).getAlignment)(d[0]) ? 2 : 3).every((v)=>v <= 0));
                const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
                if (resetPlacement !== placement) return {
                    data: {
                        index: currentIndex + 1,
                        overflows: allOverflows
                    },
                    reset: {
                        placement: resetPlacement
                    }
                };
                return {};
            }
        };
    };
    const $c48df878d8118962$export$8a83211c878a3f1f = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'flip',
            options: options,
            async fn (state) {
                var _middlewareData$arrow, _middlewareData$flip;
                const { placement: placement, middlewareData: middlewareData, rects: rects, initialPlacement: initialPlacement, platform: platform, elements: elements } = state;
                const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true, fallbackPlacements: specifiedFallbackPlacements, fallbackStrategy: fallbackStrategy = 'bestFit', fallbackAxisSideDirection: fallbackAxisSideDirection = 'none', flipAlignment: flipAlignment = true, ...detectOverflowOptions } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
                const side = (0, (0, parcelRequire("cVo0M")).getSide)(placement);
                const initialSideAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)(initialPlacement);
                const isBasePlacement = (0, (0, parcelRequire("cVo0M")).getSide)(initialPlacement) === initialPlacement;
                const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
                const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [
                    (0, (0, parcelRequire("cVo0M")).getOppositePlacement)(initialPlacement)
                ] : (0, (0, parcelRequire("cVo0M")).getExpandedPlacements)(initialPlacement));
                const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== 'none';
                if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) fallbackPlacements.push(...(0, (0, parcelRequire("cVo0M")).getOppositeAxisPlacements)(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
                const placements = [
                    initialPlacement,
                    ...fallbackPlacements
                ];
                const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
                const overflows = [];
                let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
                if (checkMainAxis) overflows.push(overflow[side]);
                if (checkCrossAxis) {
                    const sides = (0, (0, parcelRequire("cVo0M")).getAlignmentSides)(placement, rects, rtl);
                    overflows.push(overflow[sides[0]], overflow[sides[1]]);
                }
                overflowsData = [
                    ...overflowsData,
                    {
                        placement: placement,
                        overflows: overflows
                    }
                ];
                if (!overflows.every((side)=>side <= 0)) {
                    var _middlewareData$flip2, _overflowsData$filter;
                    const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
                    const nextPlacement = placements[nextIndex];
                    if (nextPlacement) return {
                        data: {
                            index: nextIndex,
                            overflows: overflowsData
                        },
                        reset: {
                            placement: nextPlacement
                        }
                    };
                    let resetPlacement = (_overflowsData$filter = overflowsData.filter((d)=>d.overflows[0] <= 0).sort((a, b)=>a.overflows[1] - b.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
                    if (!resetPlacement) switch(fallbackStrategy){
                        case 'bestFit':
                            {
                                var _overflowsData$filter2;
                                const placement = (_overflowsData$filter2 = overflowsData.filter((d)=>{
                                    if (hasFallbackAxisSideDirection) {
                                        const currentSideAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)(d.placement);
                                        return currentSideAxis === initialSideAxis || currentSideAxis === 'y';
                                    }
                                    return true;
                                }).map((d)=>[
                                        d.placement,
                                        d.overflows.filter((overflow)=>overflow > 0).reduce((acc, overflow)=>acc + overflow, 0)
                                    ]).sort((a, b)=>a[1] - b[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
                                if (placement) resetPlacement = placement;
                                break;
                            }
                        case 'initialPlacement':
                            resetPlacement = initialPlacement;
                            break;
                    }
                    if (placement !== resetPlacement) return {
                        reset: {
                            placement: resetPlacement
                        }
                    };
                }
                return {};
            }
        };
    };
    function $c48df878d8118962$var$getSideOffsets(overflow, rect) {
        return {
            top: overflow.top - rect.height,
            right: overflow.right - rect.width,
            bottom: overflow.bottom - rect.height,
            left: overflow.left - rect.width
        };
    }
    function $c48df878d8118962$var$isAnySideFullyClipped(overflow) {
        return (0, (0, parcelRequire("cVo0M")).sides).some((side)=>overflow[side] >= 0);
    }
    const $c48df878d8118962$export$fe8985bb6374093c = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'hide',
            options: options,
            async fn (state) {
                const { rects: rects } = state;
                const { strategy: strategy = 'referenceHidden', ...detectOverflowOptions } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                switch(strategy){
                    case 'referenceHidden':
                        {
                            const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, {
                                ...detectOverflowOptions,
                                elementContext: 'reference'
                            });
                            const offsets = $c48df878d8118962$var$getSideOffsets(overflow, rects.reference);
                            return {
                                data: {
                                    referenceHiddenOffsets: offsets,
                                    referenceHidden: $c48df878d8118962$var$isAnySideFullyClipped(offsets)
                                }
                            };
                        }
                    case 'escaped':
                        {
                            const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, {
                                ...detectOverflowOptions,
                                altBoundary: true
                            });
                            const offsets = $c48df878d8118962$var$getSideOffsets(overflow, rects.floating);
                            return {
                                data: {
                                    escapedOffsets: offsets,
                                    escaped: $c48df878d8118962$var$isAnySideFullyClipped(offsets)
                                }
                            };
                        }
                    default:
                        return {};
                }
            }
        };
    };
    function $c48df878d8118962$var$getBoundingRect(rects) {
        const minX = (0, (0, parcelRequire("cVo0M")).min)(...rects.map((rect)=>rect.left));
        const minY = (0, (0, parcelRequire("cVo0M")).min)(...rects.map((rect)=>rect.top));
        const maxX = (0, (0, parcelRequire("cVo0M")).max)(...rects.map((rect)=>rect.right));
        const maxY = (0, (0, parcelRequire("cVo0M")).max)(...rects.map((rect)=>rect.bottom));
        return {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        };
    }
    function $c48df878d8118962$var$getRectsByLine(rects) {
        const sortedRects = rects.slice().sort((a, b)=>a.y - b.y);
        const groups = [];
        let prevRect = null;
        for(let i = 0; i < sortedRects.length; i++){
            const rect = sortedRects[i];
            if (!prevRect || rect.y - prevRect.y > prevRect.height / 2) groups.push([
                rect
            ]);
            else groups[groups.length - 1].push(rect);
            prevRect = rect;
        }
        return groups.map((rect)=>(0, (0, parcelRequire("cVo0M")).rectToClientRect)($c48df878d8118962$var$getBoundingRect(rect)));
    }
    const $c48df878d8118962$export$18c8ad048e32c7d5 = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'inline',
            options: options,
            async fn (state) {
                const { placement: placement, elements: elements, rects: rects, platform: platform, strategy: strategy } = state;
                const { padding: padding = 2, x: x, y: y } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                const nativeClientRects = Array.from(await (platform.getClientRects == null ? void 0 : platform.getClientRects(elements.reference)) || []);
                const clientRects = $c48df878d8118962$var$getRectsByLine(nativeClientRects);
                const fallback = (0, (0, parcelRequire("cVo0M")).rectToClientRect)($c48df878d8118962$var$getBoundingRect(nativeClientRects));
                const paddingObject = (0, (0, parcelRequire("cVo0M")).getPaddingObject)(padding);
                function getBoundingClientRect() {
                    if (clientRects.length === 2 && clientRects[0].left > clientRects[1].right && x != null && y != null) return clientRects.find((rect)=>x > rect.left - paddingObject.left && x < rect.right + paddingObject.right && y > rect.top - paddingObject.top && y < rect.bottom + paddingObject.bottom) || fallback;
                    if (clientRects.length >= 2) {
                        if ((0, (0, parcelRequire("cVo0M")).getSideAxis)(placement) === 'y') {
                            const firstRect = clientRects[0];
                            const lastRect = clientRects[clientRects.length - 1];
                            const isTop = (0, (0, parcelRequire("cVo0M")).getSide)(placement) === 'top';
                            const top = firstRect.top;
                            const bottom = lastRect.bottom;
                            const left = isTop ? firstRect.left : lastRect.left;
                            const right = isTop ? firstRect.right : lastRect.right;
                            const width = right - left;
                            const height = bottom - top;
                            return {
                                top: top,
                                bottom: bottom,
                                left: left,
                                right: right,
                                width: width,
                                height: height,
                                x: left,
                                y: top
                            };
                        }
                        const isLeftSide = (0, (0, parcelRequire("cVo0M")).getSide)(placement) === 'left';
                        const maxRight = (0, (0, parcelRequire("cVo0M")).max)(...clientRects.map((rect)=>rect.right));
                        const minLeft = (0, (0, parcelRequire("cVo0M")).min)(...clientRects.map((rect)=>rect.left));
                        const measureRects = clientRects.filter((rect)=>isLeftSide ? rect.left === minLeft : rect.right === maxRight);
                        const top = measureRects[0].top;
                        const bottom = measureRects[measureRects.length - 1].bottom;
                        const left = minLeft;
                        const right = maxRight;
                        const width = right - left;
                        const height = bottom - top;
                        return {
                            top: top,
                            bottom: bottom,
                            left: left,
                            right: right,
                            width: width,
                            height: height,
                            x: left,
                            y: top
                        };
                    }
                    return fallback;
                }
                const resetRects = await platform.getElementRects({
                    reference: {
                        getBoundingClientRect: getBoundingClientRect
                    },
                    floating: elements.floating,
                    strategy: strategy
                });
                if (rects.reference.x !== resetRects.reference.x || rects.reference.y !== resetRects.reference.y || rects.reference.width !== resetRects.reference.width || rects.reference.height !== resetRects.reference.height) return {
                    reset: {
                        rects: resetRects
                    }
                };
                return {};
            }
        };
    };
    async function $c48df878d8118962$var$convertValueToCoords(state, options) {
        const { placement: placement, platform: platform, elements: elements } = state;
        const rtl = await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating));
        const side = (0, (0, parcelRequire("cVo0M")).getSide)(placement);
        const alignment = (0, (0, parcelRequire("cVo0M")).getAlignment)(placement);
        const isVertical = (0, (0, parcelRequire("cVo0M")).getSideAxis)(placement) === 'y';
        const mainAxisMulti = [
            'left',
            'top'
        ].includes(side) ? -1 : 1;
        const crossAxisMulti = rtl && isVertical ? -1 : 1;
        const rawValue = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
        let { mainAxis: mainAxis, crossAxis: crossAxis, alignmentAxis: alignmentAxis } = typeof rawValue === 'number' ? {
            mainAxis: rawValue,
            crossAxis: 0,
            alignmentAxis: null
        } : {
            mainAxis: rawValue.mainAxis || 0,
            crossAxis: rawValue.crossAxis || 0,
            alignmentAxis: rawValue.alignmentAxis
        };
        if (alignment && typeof alignmentAxis === 'number') crossAxis = alignment === 'end' ? alignmentAxis * -1 : alignmentAxis;
        return isVertical ? {
            x: crossAxis * crossAxisMulti,
            y: mainAxis * mainAxisMulti
        } : {
            x: mainAxis * mainAxisMulti,
            y: crossAxis * crossAxisMulti
        };
    }
    const $c48df878d8118962$export$cc800923e997bb8 = function(options) {
        if (options === void 0) options = 0;
        return {
            name: 'offset',
            options: options,
            async fn (state) {
                var _middlewareData$offse, _middlewareData$arrow;
                const { x: x, y: y, placement: placement, middlewareData: middlewareData } = state;
                const diffCoords = await $c48df878d8118962$var$convertValueToCoords(state, options);
                if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) return {};
                return {
                    x: x + diffCoords.x,
                    y: y + diffCoords.y,
                    data: {
                        ...diffCoords,
                        placement: placement
                    }
                };
            }
        };
    };
    const $c48df878d8118962$export$fba63a578e423eb = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'shift',
            options: options,
            async fn (state) {
                const { x: x, y: y, placement: placement } = state;
                const { mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = false, limiter: limiter = {
                    fn: (_ref)=>{
                        let { x: x, y: y } = _ref;
                        return {
                            x: x,
                            y: y
                        };
                    }
                }, ...detectOverflowOptions } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                const coords = {
                    x: x,
                    y: y
                };
                const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
                const crossAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)((0, (0, parcelRequire("cVo0M")).getSide)(placement));
                const mainAxis = (0, (0, parcelRequire("cVo0M")).getOppositeAxis)(crossAxis);
                let mainAxisCoord = coords[mainAxis];
                let crossAxisCoord = coords[crossAxis];
                if (checkMainAxis) {
                    const minSide = mainAxis === 'y' ? 'top' : 'left';
                    const maxSide = mainAxis === 'y' ? 'bottom' : 'right';
                    const min = mainAxisCoord + overflow[minSide];
                    const max = mainAxisCoord - overflow[maxSide];
                    mainAxisCoord = (0, (0, parcelRequire("cVo0M")).clamp)(min, mainAxisCoord, max);
                }
                if (checkCrossAxis) {
                    const minSide = crossAxis === 'y' ? 'top' : 'left';
                    const maxSide = crossAxis === 'y' ? 'bottom' : 'right';
                    const min = crossAxisCoord + overflow[minSide];
                    const max = crossAxisCoord - overflow[maxSide];
                    crossAxisCoord = (0, (0, parcelRequire("cVo0M")).clamp)(min, crossAxisCoord, max);
                }
                const limitedCoords = limiter.fn({
                    ...state,
                    [mainAxis]: mainAxisCoord,
                    [crossAxis]: crossAxisCoord
                });
                return {
                    ...limitedCoords,
                    data: {
                        x: limitedCoords.x - x,
                        y: limitedCoords.y - y,
                        enabled: {
                            [mainAxis]: checkMainAxis,
                            [crossAxis]: checkCrossAxis
                        }
                    }
                };
            }
        };
    };
    const $c48df878d8118962$export$7bf07e38f3dc4b69 = function(options) {
        if (options === void 0) options = {};
        return {
            options: options,
            fn (state) {
                const { x: x, y: y, placement: placement, rects: rects, middlewareData: middlewareData } = state;
                const { offset: offset = 0, mainAxis: checkMainAxis = true, crossAxis: checkCrossAxis = true } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                const coords = {
                    x: x,
                    y: y
                };
                const crossAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)(placement);
                const mainAxis = (0, (0, parcelRequire("cVo0M")).getOppositeAxis)(crossAxis);
                let mainAxisCoord = coords[mainAxis];
                let crossAxisCoord = coords[crossAxis];
                const rawOffset = (0, (0, parcelRequire("cVo0M")).evaluate)(offset, state);
                const computedOffset = typeof rawOffset === 'number' ? {
                    mainAxis: rawOffset,
                    crossAxis: 0
                } : {
                    mainAxis: 0,
                    crossAxis: 0,
                    ...rawOffset
                };
                if (checkMainAxis) {
                    const len = mainAxis === 'y' ? 'height' : 'width';
                    const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
                    const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
                    if (mainAxisCoord < limitMin) mainAxisCoord = limitMin;
                    else if (mainAxisCoord > limitMax) mainAxisCoord = limitMax;
                }
                if (checkCrossAxis) {
                    var _middlewareData$offse, _middlewareData$offse2;
                    const len = mainAxis === 'y' ? 'width' : 'height';
                    const isOriginSide = [
                        'top',
                        'left'
                    ].includes((0, (0, parcelRequire("cVo0M")).getSide)(placement));
                    const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
                    const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
                    if (crossAxisCoord < limitMin) crossAxisCoord = limitMin;
                    else if (crossAxisCoord > limitMax) crossAxisCoord = limitMax;
                }
                return {
                    [mainAxis]: mainAxisCoord,
                    [crossAxis]: crossAxisCoord
                };
            }
        };
    };
    const $c48df878d8118962$export$346677f925de839c = function(options) {
        if (options === void 0) options = {};
        return {
            name: 'size',
            options: options,
            async fn (state) {
                var _state$middlewareData, _state$middlewareData2;
                const { placement: placement, rects: rects, platform: platform, elements: elements } = state;
                const { apply: apply = ()=>{}, ...detectOverflowOptions } = (0, (0, parcelRequire("cVo0M")).evaluate)(options, state);
                const overflow = await $c48df878d8118962$export$37b6bde19b108ecc(state, detectOverflowOptions);
                const side = (0, (0, parcelRequire("cVo0M")).getSide)(placement);
                const alignment = (0, (0, parcelRequire("cVo0M")).getAlignment)(placement);
                const isYAxis = (0, (0, parcelRequire("cVo0M")).getSideAxis)(placement) === 'y';
                const { width: width, height: height } = rects.floating;
                let heightSide;
                let widthSide;
                if (side === 'top' || side === 'bottom') {
                    heightSide = side;
                    widthSide = alignment === (await (platform.isRTL == null ? void 0 : platform.isRTL(elements.floating)) ? 'start' : 'end') ? 'left' : 'right';
                } else {
                    widthSide = side;
                    heightSide = alignment === 'end' ? 'top' : 'bottom';
                }
                const maximumClippingHeight = height - overflow.top - overflow.bottom;
                const maximumClippingWidth = width - overflow.left - overflow.right;
                const overflowAvailableHeight = (0, (0, parcelRequire("cVo0M")).min)(height - overflow[heightSide], maximumClippingHeight);
                const overflowAvailableWidth = (0, (0, parcelRequire("cVo0M")).min)(width - overflow[widthSide], maximumClippingWidth);
                const noShift = !state.middlewareData.shift;
                let availableHeight = overflowAvailableHeight;
                let availableWidth = overflowAvailableWidth;
                if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) availableWidth = maximumClippingWidth;
                if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) availableHeight = maximumClippingHeight;
                if (noShift && !alignment) {
                    const xMin = (0, (0, parcelRequire("cVo0M")).max)(overflow.left, 0);
                    const xMax = (0, (0, parcelRequire("cVo0M")).max)(overflow.right, 0);
                    const yMin = (0, (0, parcelRequire("cVo0M")).max)(overflow.top, 0);
                    const yMax = (0, (0, parcelRequire("cVo0M")).max)(overflow.bottom, 0);
                    if (isYAxis) availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : (0, (0, parcelRequire("cVo0M")).max)(overflow.left, overflow.right));
                    else availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : (0, (0, parcelRequire("cVo0M")).max)(overflow.top, overflow.bottom));
                }
                await apply({
                    ...state,
                    availableWidth: availableWidth,
                    availableHeight: availableHeight
                });
                const nextDimensions = await platform.getDimensions(elements.floating);
                if (width !== nextDimensions.width || height !== nextDimensions.height) return {
                    reset: {
                        rects: true
                    }
                };
                return {};
            }
        };
    };
});
parcelRegister("cVo0M", function(module, exports) {
    $parcel$export(module.exports, "sides", ()=>$968d6f1d7e429938$export$832b6fa47fa053d2);
    $parcel$export(module.exports, "placements", ()=>$968d6f1d7e429938$export$803cd8101b6c182b);
    $parcel$export(module.exports, "min", ()=>$968d6f1d7e429938$export$96ec731ed4dcb222);
    $parcel$export(module.exports, "max", ()=>$968d6f1d7e429938$export$8960430cfd85939f);
    $parcel$export(module.exports, "round", ()=>$968d6f1d7e429938$export$2077e0241d6afd3c);
    $parcel$export(module.exports, "floor", ()=>$968d6f1d7e429938$export$a3fe094919f356fd);
    $parcel$export(module.exports, "createCoords", ()=>$968d6f1d7e429938$export$a397704b5e280835);
    $parcel$export(module.exports, "clamp", ()=>$968d6f1d7e429938$export$7d15b64cf5a3a4c4);
    $parcel$export(module.exports, "evaluate", ()=>$968d6f1d7e429938$export$fef61f332f2c0afc);
    $parcel$export(module.exports, "getSide", ()=>$968d6f1d7e429938$export$3c915306cb7fc97a);
    $parcel$export(module.exports, "getAlignment", ()=>$968d6f1d7e429938$export$f0989780f32bfcda);
    $parcel$export(module.exports, "getOppositeAxis", ()=>$968d6f1d7e429938$export$8a000a963141ac32);
    $parcel$export(module.exports, "getAxisLength", ()=>$968d6f1d7e429938$export$320bd9d53520c68a);
    $parcel$export(module.exports, "getSideAxis", ()=>$968d6f1d7e429938$export$f28e8f882010718a);
    $parcel$export(module.exports, "getAlignmentAxis", ()=>$968d6f1d7e429938$export$2b57e0052a6d6d4c);
    $parcel$export(module.exports, "getAlignmentSides", ()=>$968d6f1d7e429938$export$be42861551f17911);
    $parcel$export(module.exports, "getOppositePlacement", ()=>$968d6f1d7e429938$export$9c5e28bad23365fa);
    $parcel$export(module.exports, "getExpandedPlacements", ()=>$968d6f1d7e429938$export$496432a3699e50b1);
    $parcel$export(module.exports, "getOppositeAlignmentPlacement", ()=>$968d6f1d7e429938$export$2b182c584985588b);
    $parcel$export(module.exports, "getOppositeAxisPlacements", ()=>$968d6f1d7e429938$export$a9b6fb18fd92c3ec);
    $parcel$export(module.exports, "getPaddingObject", ()=>$968d6f1d7e429938$export$598c291c29bc2e71);
    $parcel$export(module.exports, "rectToClientRect", ()=>$968d6f1d7e429938$export$ee05aea0aeecbad4);
    const $968d6f1d7e429938$export$832b6fa47fa053d2 = [
        'top',
        'right',
        'bottom',
        'left'
    ];
    const $968d6f1d7e429938$export$27b07d8a310ed8b5 = [
        'start',
        'end'
    ];
    const $968d6f1d7e429938$export$803cd8101b6c182b = $968d6f1d7e429938$export$832b6fa47fa053d2.reduce((acc, side)=>acc.concat(side, side + "-" + $968d6f1d7e429938$export$27b07d8a310ed8b5[0], side + "-" + $968d6f1d7e429938$export$27b07d8a310ed8b5[1]), []);
    const $968d6f1d7e429938$export$96ec731ed4dcb222 = Math.min;
    const $968d6f1d7e429938$export$8960430cfd85939f = Math.max;
    const $968d6f1d7e429938$export$2077e0241d6afd3c = Math.round;
    const $968d6f1d7e429938$export$a3fe094919f356fd = Math.floor;
    const $968d6f1d7e429938$export$a397704b5e280835 = (v)=>({
            x: v,
            y: v
        });
    const $968d6f1d7e429938$var$oppositeSideMap = {
        left: 'right',
        right: 'left',
        bottom: 'top',
        top: 'bottom'
    };
    const $968d6f1d7e429938$var$oppositeAlignmentMap = {
        start: 'end',
        end: 'start'
    };
    function $968d6f1d7e429938$export$7d15b64cf5a3a4c4(start, value, end) {
        return $968d6f1d7e429938$export$8960430cfd85939f(start, $968d6f1d7e429938$export$96ec731ed4dcb222(value, end));
    }
    function $968d6f1d7e429938$export$fef61f332f2c0afc(value, param) {
        return typeof value === 'function' ? value(param) : value;
    }
    function $968d6f1d7e429938$export$3c915306cb7fc97a(placement) {
        return placement.split('-')[0];
    }
    function $968d6f1d7e429938$export$f0989780f32bfcda(placement) {
        return placement.split('-')[1];
    }
    function $968d6f1d7e429938$export$8a000a963141ac32(axis) {
        return axis === 'x' ? 'y' : 'x';
    }
    function $968d6f1d7e429938$export$320bd9d53520c68a(axis) {
        return axis === 'y' ? 'height' : 'width';
    }
    function $968d6f1d7e429938$export$f28e8f882010718a(placement) {
        return [
            'top',
            'bottom'
        ].includes($968d6f1d7e429938$export$3c915306cb7fc97a(placement)) ? 'y' : 'x';
    }
    function $968d6f1d7e429938$export$2b57e0052a6d6d4c(placement) {
        return $968d6f1d7e429938$export$8a000a963141ac32($968d6f1d7e429938$export$f28e8f882010718a(placement));
    }
    function $968d6f1d7e429938$export$be42861551f17911(placement, rects, rtl) {
        if (rtl === void 0) rtl = false;
        const alignment = $968d6f1d7e429938$export$f0989780f32bfcda(placement);
        const alignmentAxis = $968d6f1d7e429938$export$2b57e0052a6d6d4c(placement);
        const length = $968d6f1d7e429938$export$320bd9d53520c68a(alignmentAxis);
        let mainAlignmentSide = alignmentAxis === 'x' ? alignment === (rtl ? 'end' : 'start') ? 'right' : 'left' : alignment === 'start' ? 'bottom' : 'top';
        if (rects.reference[length] > rects.floating[length]) mainAlignmentSide = $968d6f1d7e429938$export$9c5e28bad23365fa(mainAlignmentSide);
        return [
            mainAlignmentSide,
            $968d6f1d7e429938$export$9c5e28bad23365fa(mainAlignmentSide)
        ];
    }
    function $968d6f1d7e429938$export$496432a3699e50b1(placement) {
        const oppositePlacement = $968d6f1d7e429938$export$9c5e28bad23365fa(placement);
        return [
            $968d6f1d7e429938$export$2b182c584985588b(placement),
            oppositePlacement,
            $968d6f1d7e429938$export$2b182c584985588b(oppositePlacement)
        ];
    }
    function $968d6f1d7e429938$export$2b182c584985588b(placement) {
        return placement.replace(/start|end/g, (alignment)=>$968d6f1d7e429938$var$oppositeAlignmentMap[alignment]);
    }
    function $968d6f1d7e429938$var$getSideList(side, isStart, rtl) {
        const lr = [
            'left',
            'right'
        ];
        const rl = [
            'right',
            'left'
        ];
        const tb = [
            'top',
            'bottom'
        ];
        const bt = [
            'bottom',
            'top'
        ];
        switch(side){
            case 'top':
            case 'bottom':
                if (rtl) return isStart ? rl : lr;
                return isStart ? lr : rl;
            case 'left':
            case 'right':
                return isStart ? tb : bt;
            default:
                return [];
        }
    }
    function $968d6f1d7e429938$export$a9b6fb18fd92c3ec(placement, flipAlignment, direction, rtl) {
        const alignment = $968d6f1d7e429938$export$f0989780f32bfcda(placement);
        let list = $968d6f1d7e429938$var$getSideList($968d6f1d7e429938$export$3c915306cb7fc97a(placement), direction === 'start', rtl);
        if (alignment) {
            list = list.map((side)=>side + "-" + alignment);
            if (flipAlignment) list = list.concat(list.map($968d6f1d7e429938$export$2b182c584985588b));
        }
        return list;
    }
    function $968d6f1d7e429938$export$9c5e28bad23365fa(placement) {
        return placement.replace(/left|right|bottom|top/g, (side)=>$968d6f1d7e429938$var$oppositeSideMap[side]);
    }
    function $968d6f1d7e429938$export$1c66dbf1a9e34223(padding) {
        return {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            ...padding
        };
    }
    function $968d6f1d7e429938$export$598c291c29bc2e71(padding) {
        return typeof padding !== 'number' ? $968d6f1d7e429938$export$1c66dbf1a9e34223(padding) : {
            top: padding,
            right: padding,
            bottom: padding,
            left: padding
        };
    }
    function $968d6f1d7e429938$export$ee05aea0aeecbad4(rect) {
        const { x: x, y: y, width: width, height: height } = rect;
        return {
            width: width,
            height: height,
            top: y,
            left: x,
            right: x + width,
            bottom: y + height,
            x: x,
            y: y
        };
    }
});
parcelRegister("f8LYQ", function(module, exports) {
    $parcel$export(module.exports, "getNodeName", ()=>$b05cd24baa7455b6$export$651544f548703224);
    $parcel$export(module.exports, "getWindow", ()=>$b05cd24baa7455b6$export$38b2d434cce3ea22);
    $parcel$export(module.exports, "getDocumentElement", ()=>$b05cd24baa7455b6$export$e495491855dc5418);
    $parcel$export(module.exports, "isElement", ()=>$b05cd24baa7455b6$export$45a5e7f76e0caa8d);
    $parcel$export(module.exports, "isHTMLElement", ()=>$b05cd24baa7455b6$export$1b3bfaa9684536aa);
    $parcel$export(module.exports, "isOverflowElement", ()=>$b05cd24baa7455b6$export$989e911fa9af580a);
    $parcel$export(module.exports, "getComputedStyle", ()=>$b05cd24baa7455b6$export$3735103072e4a80);
    $parcel$export(module.exports, "isTableElement", ()=>$b05cd24baa7455b6$export$71535ffaa902797f);
    $parcel$export(module.exports, "isTopLayer", ()=>$b05cd24baa7455b6$export$89e651af02346cd4);
    $parcel$export(module.exports, "isContainingBlock", ()=>$b05cd24baa7455b6$export$d6c4e8150c35fed1);
    $parcel$export(module.exports, "isWebKit", ()=>$b05cd24baa7455b6$export$78551043582a6a98);
    $parcel$export(module.exports, "getContainingBlock", ()=>$b05cd24baa7455b6$export$940d8225183e1404);
    $parcel$export(module.exports, "getParentNode", ()=>$b05cd24baa7455b6$export$4e12058fc4d51d56);
    $parcel$export(module.exports, "isLastTraversableNode", ()=>$b05cd24baa7455b6$export$d1162fb0b6d4cd51);
    $parcel$export(module.exports, "getNodeScroll", ()=>$b05cd24baa7455b6$export$dc8fc79fa2800137);
    $parcel$export(module.exports, "getOverflowAncestors", ()=>$b05cd24baa7455b6$export$3b57c1601291186b);
    $parcel$export(module.exports, "getFrameElement", ()=>$b05cd24baa7455b6$export$7bf1f8740e3e34af);
    function $b05cd24baa7455b6$var$hasWindow() {
        return typeof window !== 'undefined';
    }
    function $b05cd24baa7455b6$export$651544f548703224(node) {
        if ($b05cd24baa7455b6$export$8ee0fc9ee280b4ee(node)) return (node.nodeName || '').toLowerCase();
        return '#document';
    }
    function $b05cd24baa7455b6$export$38b2d434cce3ea22(node) {
        var _node$ownerDocument;
        return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
    }
    function $b05cd24baa7455b6$export$e495491855dc5418(node) {
        var _ref;
        return (_ref = ($b05cd24baa7455b6$export$8ee0fc9ee280b4ee(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
    }
    function $b05cd24baa7455b6$export$8ee0fc9ee280b4ee(value) {
        if (!$b05cd24baa7455b6$var$hasWindow()) return false;
        return value instanceof Node || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).Node;
    }
    function $b05cd24baa7455b6$export$45a5e7f76e0caa8d(value) {
        if (!$b05cd24baa7455b6$var$hasWindow()) return false;
        return value instanceof Element || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).Element;
    }
    function $b05cd24baa7455b6$export$1b3bfaa9684536aa(value) {
        if (!$b05cd24baa7455b6$var$hasWindow()) return false;
        return value instanceof HTMLElement || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).HTMLElement;
    }
    function $b05cd24baa7455b6$export$af51f0f06c0f328a(value) {
        if (!$b05cd24baa7455b6$var$hasWindow() || typeof ShadowRoot === 'undefined') return false;
        return value instanceof ShadowRoot || value instanceof $b05cd24baa7455b6$export$38b2d434cce3ea22(value).ShadowRoot;
    }
    function $b05cd24baa7455b6$export$989e911fa9af580a(element) {
        const { overflow: overflow, overflowX: overflowX, overflowY: overflowY, display: display } = $b05cd24baa7455b6$export$3735103072e4a80(element);
        return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && ![
            'inline',
            'contents'
        ].includes(display);
    }
    function $b05cd24baa7455b6$export$71535ffaa902797f(element) {
        return [
            'table',
            'td',
            'th'
        ].includes($b05cd24baa7455b6$export$651544f548703224(element));
    }
    function $b05cd24baa7455b6$export$89e651af02346cd4(element) {
        return [
            ':popover-open',
            ':modal'
        ].some((selector)=>{
            try {
                return element.matches(selector);
            } catch (e) {
                return false;
            }
        });
    }
    function $b05cd24baa7455b6$export$d6c4e8150c35fed1(elementOrCss) {
        const webkit = $b05cd24baa7455b6$export$78551043582a6a98();
        const css = $b05cd24baa7455b6$export$45a5e7f76e0caa8d(elementOrCss) ? $b05cd24baa7455b6$export$3735103072e4a80(elementOrCss) : elementOrCss;
        return css.transform !== 'none' || css.perspective !== 'none' || (css.containerType ? css.containerType !== 'normal' : false) || !webkit && (css.backdropFilter ? css.backdropFilter !== 'none' : false) || !webkit && (css.filter ? css.filter !== 'none' : false) || [
            'transform',
            'perspective',
            'filter'
        ].some((value)=>(css.willChange || '').includes(value)) || [
            'paint',
            'layout',
            'strict',
            'content'
        ].some((value)=>(css.contain || '').includes(value));
    }
    function $b05cd24baa7455b6$export$940d8225183e1404(element) {
        let currentNode = $b05cd24baa7455b6$export$4e12058fc4d51d56(element);
        while($b05cd24baa7455b6$export$1b3bfaa9684536aa(currentNode) && !$b05cd24baa7455b6$export$d1162fb0b6d4cd51(currentNode)){
            if ($b05cd24baa7455b6$export$d6c4e8150c35fed1(currentNode)) return currentNode;
            else if ($b05cd24baa7455b6$export$89e651af02346cd4(currentNode)) return null;
            currentNode = $b05cd24baa7455b6$export$4e12058fc4d51d56(currentNode);
        }
        return null;
    }
    function $b05cd24baa7455b6$export$78551043582a6a98() {
        if (typeof CSS === 'undefined' || !CSS.supports) return false;
        return CSS.supports('-webkit-backdrop-filter', 'none');
    }
    function $b05cd24baa7455b6$export$d1162fb0b6d4cd51(node) {
        return [
            'html',
            'body',
            '#document'
        ].includes($b05cd24baa7455b6$export$651544f548703224(node));
    }
    function $b05cd24baa7455b6$export$3735103072e4a80(element) {
        return $b05cd24baa7455b6$export$38b2d434cce3ea22(element).getComputedStyle(element);
    }
    function $b05cd24baa7455b6$export$dc8fc79fa2800137(element) {
        if ($b05cd24baa7455b6$export$45a5e7f76e0caa8d(element)) return {
            scrollLeft: element.scrollLeft,
            scrollTop: element.scrollTop
        };
        return {
            scrollLeft: element.scrollX,
            scrollTop: element.scrollY
        };
    }
    function $b05cd24baa7455b6$export$4e12058fc4d51d56(node) {
        if ($b05cd24baa7455b6$export$651544f548703224(node) === 'html') return node;
        const result = node.assignedSlot || node.parentNode || $b05cd24baa7455b6$export$af51f0f06c0f328a(node) && node.host || $b05cd24baa7455b6$export$e495491855dc5418(node);
        return $b05cd24baa7455b6$export$af51f0f06c0f328a(result) ? result.host : result;
    }
    function $b05cd24baa7455b6$export$7cd01a57c8ca906c(node) {
        const parentNode = $b05cd24baa7455b6$export$4e12058fc4d51d56(node);
        if ($b05cd24baa7455b6$export$d1162fb0b6d4cd51(parentNode)) return node.ownerDocument ? node.ownerDocument.body : node.body;
        if ($b05cd24baa7455b6$export$1b3bfaa9684536aa(parentNode) && $b05cd24baa7455b6$export$989e911fa9af580a(parentNode)) return parentNode;
        return $b05cd24baa7455b6$export$7cd01a57c8ca906c(parentNode);
    }
    function $b05cd24baa7455b6$export$3b57c1601291186b(node, list, traverseIframes) {
        var _node$ownerDocument2;
        if (list === void 0) list = [];
        if (traverseIframes === void 0) traverseIframes = true;
        const scrollableAncestor = $b05cd24baa7455b6$export$7cd01a57c8ca906c(node);
        const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
        const win = $b05cd24baa7455b6$export$38b2d434cce3ea22(scrollableAncestor);
        if (isBody) {
            const frameElement = $b05cd24baa7455b6$export$7bf1f8740e3e34af(win);
            return list.concat(win, win.visualViewport || [], $b05cd24baa7455b6$export$989e911fa9af580a(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? $b05cd24baa7455b6$export$3b57c1601291186b(frameElement) : []);
        }
        return list.concat(scrollableAncestor, $b05cd24baa7455b6$export$3b57c1601291186b(scrollableAncestor, [], traverseIframes));
    }
    function $b05cd24baa7455b6$export$7bf1f8740e3e34af(win) {
        return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
    }
});
parcelRegister("hrqx3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$cb2989fd9beaabfa$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cb2989fd9beaabfa$var$index = (0, $5uXOq.useLayoutEffect);
    var $cb2989fd9beaabfa$export$2e2bcd8739ae039 = $cb2989fd9beaabfa$var$index;
});
parcelRegister("hti3c", function(module, exports) {
    $parcel$export(module.exports, "multiValueCSS", ()=>$04718750df22b9a9$export$23c213f7717186af);
    $parcel$export(module.exports, "multiValueLabelCSS", ()=>$04718750df22b9a9$export$f40612612e0af964);
    $parcel$export(module.exports, "multiValueRemoveCSS", ()=>$04718750df22b9a9$export$283467f6c4ac142b);
    $parcel$export(module.exports, "MultiValueContainer", ()=>$04718750df22b9a9$export$cf9cf2a30a59265c);
    $parcel$export(module.exports, "MultiValueLabel", ()=>$04718750df22b9a9$export$544aeea2a5ce08ee);
    $parcel$export(module.exports, "MultiValueRemove", ()=>$04718750df22b9a9$export$8e1fd1a40e7a2f4a);
    $parcel$export(module.exports, "default", ()=>$04718750df22b9a9$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $g2UN3;
    var $8KLo7;
    const $04718750df22b9a9$export$23c213f7717186af = ({ theme: { spacing: spacing, borderRadius: borderRadius, colors: colors } }, unstyled)=>({
            label: 'multiValue',
            display: 'flex',
            minWidth: 0,
            ...unstyled ? {} : {
                backgroundColor: colors.neutral10,
                borderRadius: borderRadius / 2,
                margin: spacing.baseUnit / 2
            }
        });
    const $04718750df22b9a9$export$f40612612e0af964 = ({ theme: { borderRadius: borderRadius, colors: colors }, cropWithEllipsis: cropWithEllipsis }, unstyled)=>({
            overflow: 'hidden',
            textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
            whiteSpace: 'nowrap',
            ...unstyled ? {} : {
                borderRadius: borderRadius / 2,
                color: colors.neutral80,
                fontSize: '85%',
                padding: 3,
                paddingLeft: 6
            }
        });
    const $04718750df22b9a9$export$283467f6c4ac142b = ({ theme: { spacing: spacing, borderRadius: borderRadius, colors: colors }, isFocused: isFocused }, unstyled)=>({
            alignItems: 'center',
            display: 'flex',
            ...unstyled ? {} : {
                borderRadius: borderRadius / 2,
                backgroundColor: isFocused ? colors.dangerLight : undefined,
                paddingLeft: spacing.baseUnit,
                paddingRight: spacing.baseUnit,
                ':hover': {
                    backgroundColor: colors.dangerLight,
                    color: colors.danger
                }
            }
        });
    const $04718750df22b9a9$export$e1de505c1242dc1a = ({ children: children, innerProps: innerProps })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", innerProps, children);
    const $04718750df22b9a9$export$cf9cf2a30a59265c = $04718750df22b9a9$export$e1de505c1242dc1a;
    const $04718750df22b9a9$export$544aeea2a5ce08ee = $04718750df22b9a9$export$e1de505c1242dc1a;
    function $04718750df22b9a9$export$8e1fd1a40e7a2f4a({ children: children, innerProps: innerProps }) {
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            role: "button",
            ...innerProps
        }, children || (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("8KLo7")).CrossIcon), {
            size: 14
        }));
    }
    const $04718750df22b9a9$var$MultiValue = (props)=>{
        const { children: children, components: components, data: data, innerProps: innerProps, isDisabled: isDisabled, removeProps: removeProps, selectProps: selectProps } = props;
        const { Container: Container, Label: Label, Remove: Remove } = components;
        return (0, (0, parcelRequire("f8Sb3")).jsx)(Container, {
            data: data,
            innerProps: {
                ...(0, (0, parcelRequire("g2UN3")).getStyleProps)(props, 'multiValue', {
                    'multi-value': true,
                    'multi-value--is-disabled': isDisabled
                }),
                ...innerProps
            },
            selectProps: selectProps
        }, (0, (0, parcelRequire("f8Sb3")).jsx)(Label, {
            data: data,
            innerProps: {
                ...(0, (0, parcelRequire("g2UN3")).getStyleProps)(props, 'multiValueLabel', {
                    'multi-value__label': true
                })
            },
            selectProps: selectProps
        }, children), (0, (0, parcelRequire("f8Sb3")).jsx)(Remove, {
            data: data,
            innerProps: {
                ...(0, (0, parcelRequire("g2UN3")).getStyleProps)(props, 'multiValueRemove', {
                    'multi-value__remove': true
                }),
                'aria-label': `Remove ${children || 'option'}`,
                ...removeProps
            },
            selectProps: selectProps
        }));
    };
    var $04718750df22b9a9$export$2e2bcd8739ae039 = $04718750df22b9a9$var$MultiValue;
});
parcelRegister("1MDaa", function(module, exports) {
    $parcel$export(module.exports, "optionCSS", ()=>$32784da36597034c$export$ef897119b7e920ba);
    $parcel$export(module.exports, "default", ()=>$32784da36597034c$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $g2UN3;
    const $32784da36597034c$export$ef897119b7e920ba = ({ isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected, theme: { spacing: spacing, colors: colors } }, unstyled)=>({
            label: 'option',
            cursor: 'default',
            display: 'block',
            fontSize: 'inherit',
            width: '100%',
            userSelect: 'none',
            WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
            ...unstyled ? {} : {
                backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
                color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
                padding: `${spacing.baseUnit * 2}px ${spacing.baseUnit * 3}px`,
                ':active': {
                    backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
                }
            }
        });
    const $32784da36597034c$var$Option = (props)=>{
        const { children: children, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected, innerRef: innerRef, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("g2UN3")).getStyleProps)(props, 'option', {
                option: true,
                'option--is-disabled': isDisabled,
                'option--is-focused': isFocused,
                'option--is-selected': isSelected
            }),
            ref: innerRef,
            "aria-disabled": isDisabled,
            ...innerProps,
            tabIndex: -1
        }, children);
    };
    var $32784da36597034c$export$2e2bcd8739ae039 = $32784da36597034c$var$Option;
});
parcelRegister("hklN8", function(module, exports) {
    $parcel$export(module.exports, "placeholderCSS", ()=>$897d07c49a2fc3b7$export$5f3ffacd6594d90f);
    $parcel$export(module.exports, "default", ()=>$897d07c49a2fc3b7$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $g2UN3;
    const $897d07c49a2fc3b7$export$5f3ffacd6594d90f = ({ theme: { spacing: spacing, colors: colors } }, unstyled)=>({
            label: 'placeholder',
            gridArea: '1 / 1 / 2 / 3',
            ...unstyled ? {} : {
                color: colors.neutral50,
                marginLeft: spacing.baseUnit / 2,
                marginRight: spacing.baseUnit / 2
            }
        });
    const $897d07c49a2fc3b7$var$Placeholder = (props)=>{
        const { children: children, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("g2UN3")).getStyleProps)(props, 'placeholder', {
                placeholder: true
            }),
            ...innerProps
        }, children);
    };
    var $897d07c49a2fc3b7$export$2e2bcd8739ae039 = $897d07c49a2fc3b7$var$Placeholder;
});
parcelRegister("7SnYw", function(module, exports) {
    $parcel$export(module.exports, "css", ()=>$8be3a115a328f6d6$export$dbf350e5966cf602);
    $parcel$export(module.exports, "default", ()=>$8be3a115a328f6d6$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $g2UN3;
    const $8be3a115a328f6d6$export$dbf350e5966cf602 = ({ isDisabled: isDisabled, theme: { spacing: spacing, colors: colors } }, unstyled)=>({
            label: 'singleValue',
            gridArea: '1 / 1 / 2 / 3',
            maxWidth: '100%',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            ...unstyled ? {} : {
                color: isDisabled ? colors.neutral40 : colors.neutral80,
                marginLeft: spacing.baseUnit / 2,
                marginRight: spacing.baseUnit / 2
            }
        });
    const $8be3a115a328f6d6$var$SingleValue = (props)=>{
        const { children: children, isDisabled: isDisabled, innerProps: innerProps } = props;
        return (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ...(0, (0, parcelRequire("g2UN3")).getStyleProps)(props, 'singleValue', {
                'single-value': true,
                'single-value--is-disabled': isDisabled
            }),
            ...innerProps
        }, children);
    };
    var $8be3a115a328f6d6$export$2e2bcd8739ae039 = $8be3a115a328f6d6$var$SingleValue;
});
parcelRegister("aFNBY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$53a19d4b009f6971$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $g2UN3;
    const $53a19d4b009f6971$var$dummyInputStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        width: 1,
        padding: 0,
        position: 'relative',
        background: 0,
        border: 0,
        caretColor: 'transparent',
        color: 'transparent',
        fontSize: 'inherit',
        gridArea: '1 / 1 / 2 / 3',
        insetInlineStart: -100,
        label: 'dummyInput',
        opacity: 0,
        outline: 0,
        transform: 'scale(.01)'
    });
    function $53a19d4b009f6971$export$2e2bcd8739ae039({ innerRef: innerRef, ...props }) {
        const filteredProps = (0, (0, parcelRequire("g2UN3")).removeProps)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
        return (0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            ref: innerRef,
            ...filteredProps,
            css: $53a19d4b009f6971$var$dummyInputStyles
        });
    }
});
parcelRegister("gSXak", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5cda2f07a4dd034e$export$2e2bcd8739ae039);
    var $f8Sb3;
    var $gCBvJ;
    function $5cda2f07a4dd034e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $5cda2f07a4dd034e$var$styles = {
        name: "1fj9brw-requiredInput",
        styles: "width:100%;position:absolute;inset-block-end:0;inset-inline-end:0;inset-inline-start:0;label:requiredInput;opacity:0;pointer-events:none"
    };
    const $5cda2f07a4dd034e$var$RequiredInput = ({ name: name, onFocus: onFocus })=>(0, (0, parcelRequire("f8Sb3")).jsx)("input", {
            required: true,
            name: name,
            tabIndex: -1,
            "aria-hidden": "true",
            onFocus: onFocus,
            css: $5cda2f07a4dd034e$var$styles,
            value: "",
            onChange: (0, (0, parcelRequire("gCBvJ")).default)
        });
    var $5cda2f07a4dd034e$export$2e2bcd8739ae039 = $5cda2f07a4dd034e$var$RequiredInput;
});
parcelRegister("iTuaH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$117d781a987cee69$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $7pQpP;
    var $6QLsL;
    function $117d781a987cee69$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $117d781a987cee69$var$styles = {
        name: "qzxev8",
        styles: "position:fixed;inset-block-end:0;inset-block-start:0;inset-inline-end:0;inset-inline-start:0"
    };
    const $117d781a987cee69$var$blurSelectInput = (event)=>{
        const element = event.target;
        return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
    };
    function $117d781a987cee69$export$2e2bcd8739ae039({ children: children, lockEnabled: lockEnabled, captureEnabled: captureEnabled = true, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
        const setScrollCaptureTarget = (0, (0, parcelRequire("7pQpP")).default)({
            isEnabled: captureEnabled,
            onBottomArrive: onBottomArrive,
            onBottomLeave: onBottomLeave,
            onTopArrive: onTopArrive,
            onTopLeave: onTopLeave
        });
        const setScrollLockTarget = (0, (0, parcelRequire("6QLsL")).default)({
            isEnabled: lockEnabled
        });
        const targetRef = (element)=>{
            setScrollCaptureTarget(element);
            setScrollLockTarget(element);
        };
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, lockEnabled && (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            onClick: $117d781a987cee69$var$blurSelectInput,
            css: $117d781a987cee69$var$styles
        }), children(targetRef));
    }
});
parcelRegister("7pQpP", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$356f91d0bcb9815a$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $g2UN3;
    const $356f91d0bcb9815a$var$cancelScroll = (event)=>{
        if (event.cancelable) event.preventDefault();
        event.stopPropagation();
    };
    function $356f91d0bcb9815a$export$2e2bcd8739ae039({ isEnabled: isEnabled, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
        const isBottom = (0, $5uXOq.useRef)(false);
        const isTop = (0, $5uXOq.useRef)(false);
        const touchStart = (0, $5uXOq.useRef)(0);
        const scrollTarget = (0, $5uXOq.useRef)(null);
        const handleEventDelta = (0, $5uXOq.useCallback)((event, delta)=>{
            if (scrollTarget.current === null) return;
            const { scrollTop: scrollTop, scrollHeight: scrollHeight, clientHeight: clientHeight } = scrollTarget.current;
            const target = scrollTarget.current;
            const isDeltaPositive = delta > 0;
            const availableScroll = scrollHeight - clientHeight - scrollTop;
            let shouldCancelScroll = false;
            if (availableScroll > delta && isBottom.current) {
                if (onBottomLeave) onBottomLeave(event);
                isBottom.current = false;
            }
            if (isDeltaPositive && isTop.current) {
                if (onTopLeave) onTopLeave(event);
                isTop.current = false;
            }
            if (isDeltaPositive && delta > availableScroll) {
                if (onBottomArrive && !isBottom.current) onBottomArrive(event);
                target.scrollTop = scrollHeight;
                shouldCancelScroll = true;
                isBottom.current = true;
            } else if (!isDeltaPositive && -delta > scrollTop) {
                if (onTopArrive && !isTop.current) onTopArrive(event);
                target.scrollTop = 0;
                shouldCancelScroll = true;
                isTop.current = true;
            }
            if (shouldCancelScroll) $356f91d0bcb9815a$var$cancelScroll(event);
        }, [
            onBottomArrive,
            onBottomLeave,
            onTopArrive,
            onTopLeave
        ]);
        const onWheel = (0, $5uXOq.useCallback)((event)=>{
            handleEventDelta(event, event.deltaY);
        }, [
            handleEventDelta
        ]);
        const onTouchStart = (0, $5uXOq.useCallback)((event)=>{
            touchStart.current = event.changedTouches[0].clientY;
        }, []);
        const onTouchMove = (0, $5uXOq.useCallback)((event)=>{
            const deltaY = touchStart.current - event.changedTouches[0].clientY;
            handleEventDelta(event, deltaY);
        }, [
            handleEventDelta
        ]);
        const startListening = (0, $5uXOq.useCallback)((el)=>{
            if (!el) return;
            const notPassive = (0, (0, parcelRequire("g2UN3")).supportsPassiveEvents) ? {
                passive: false
            } : false;
            el.addEventListener('wheel', onWheel, notPassive);
            el.addEventListener('touchstart', onTouchStart, notPassive);
            el.addEventListener('touchmove', onTouchMove, notPassive);
        }, [
            onTouchMove,
            onTouchStart,
            onWheel
        ]);
        const stopListening = (0, $5uXOq.useCallback)((el)=>{
            if (!el) return;
            el.removeEventListener('wheel', onWheel, false);
            el.removeEventListener('touchstart', onTouchStart, false);
            el.removeEventListener('touchmove', onTouchMove, false);
        }, [
            onTouchMove,
            onTouchStart,
            onWheel
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!isEnabled) return;
            const element = scrollTarget.current;
            startListening(element);
            return ()=>{
                stopListening(element);
            };
        }, [
            isEnabled,
            startListening,
            stopListening
        ]);
        return (element)=>{
            scrollTarget.current = element;
        };
    }
});
parcelRegister("6QLsL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b9237a2ecafc7ea7$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    const $b9237a2ecafc7ea7$var$STYLE_KEYS = [
        'boxSizing',
        'height',
        'overflow',
        'paddingRight',
        'position'
    ];
    const $b9237a2ecafc7ea7$var$LOCK_STYLES = {
        boxSizing: 'border-box',
        overflow: 'hidden',
        position: 'relative',
        height: '100%'
    };
    function $b9237a2ecafc7ea7$var$preventTouchMove(e) {
        e.preventDefault();
    }
    function $b9237a2ecafc7ea7$var$allowTouchMove(e) {
        e.stopPropagation();
    }
    function $b9237a2ecafc7ea7$var$preventInertiaScroll() {
        const top = this.scrollTop;
        const totalScroll = this.scrollHeight;
        const currentScroll = top + this.offsetHeight;
        if (top === 0) this.scrollTop = 1;
        else if (currentScroll === totalScroll) this.scrollTop = top - 1;
    }
    function $b9237a2ecafc7ea7$var$isTouchDevice() {
        return 'ontouchstart' in window || navigator.maxTouchPoints;
    }
    const $b9237a2ecafc7ea7$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
    let $b9237a2ecafc7ea7$var$activeScrollLocks = 0;
    const $b9237a2ecafc7ea7$var$listenerOptions = {
        capture: false,
        passive: false
    };
    function $b9237a2ecafc7ea7$export$2e2bcd8739ae039({ isEnabled: isEnabled, accountForScrollbars: accountForScrollbars = true }) {
        const originalStyles = (0, $5uXOq.useRef)({});
        const scrollTarget = (0, $5uXOq.useRef)(null);
        const addScrollLock = (0, $5uXOq.useCallback)((touchScrollTarget)=>{
            if (!$b9237a2ecafc7ea7$var$canUseDOM) return;
            const target = document.body;
            const targetStyle = target && target.style;
            if (accountForScrollbars) $b9237a2ecafc7ea7$var$STYLE_KEYS.forEach((key)=>{
                const val = targetStyle && targetStyle[key];
                originalStyles.current[key] = val;
            });
            if (accountForScrollbars && $b9237a2ecafc7ea7$var$activeScrollLocks < 1) {
                const currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
                const clientWidth = document.body ? document.body.clientWidth : 0;
                const adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
                Object.keys($b9237a2ecafc7ea7$var$LOCK_STYLES).forEach((key)=>{
                    const val = $b9237a2ecafc7ea7$var$LOCK_STYLES[key];
                    if (targetStyle) targetStyle[key] = val;
                });
                if (targetStyle) targetStyle.paddingRight = `${adjustedPadding}px`;
            }
            if (target && $b9237a2ecafc7ea7$var$isTouchDevice()) {
                target.addEventListener('touchmove', $b9237a2ecafc7ea7$var$preventTouchMove, $b9237a2ecafc7ea7$var$listenerOptions);
                if (touchScrollTarget) {
                    touchScrollTarget.addEventListener('touchstart', $b9237a2ecafc7ea7$var$preventInertiaScroll, $b9237a2ecafc7ea7$var$listenerOptions);
                    touchScrollTarget.addEventListener('touchmove', $b9237a2ecafc7ea7$var$allowTouchMove, $b9237a2ecafc7ea7$var$listenerOptions);
                }
            }
            $b9237a2ecafc7ea7$var$activeScrollLocks += 1;
        }, [
            accountForScrollbars
        ]);
        const removeScrollLock = (0, $5uXOq.useCallback)((touchScrollTarget)=>{
            if (!$b9237a2ecafc7ea7$var$canUseDOM) return;
            const target = document.body;
            const targetStyle = target && target.style;
            $b9237a2ecafc7ea7$var$activeScrollLocks = Math.max($b9237a2ecafc7ea7$var$activeScrollLocks - 1, 0);
            if (accountForScrollbars && $b9237a2ecafc7ea7$var$activeScrollLocks < 1) $b9237a2ecafc7ea7$var$STYLE_KEYS.forEach((key)=>{
                const val = originalStyles.current[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (target && $b9237a2ecafc7ea7$var$isTouchDevice()) {
                target.removeEventListener('touchmove', $b9237a2ecafc7ea7$var$preventTouchMove, $b9237a2ecafc7ea7$var$listenerOptions);
                if (touchScrollTarget) {
                    touchScrollTarget.removeEventListener('touchstart', $b9237a2ecafc7ea7$var$preventInertiaScroll, $b9237a2ecafc7ea7$var$listenerOptions);
                    touchScrollTarget.removeEventListener('touchmove', $b9237a2ecafc7ea7$var$allowTouchMove, $b9237a2ecafc7ea7$var$listenerOptions);
                }
            }
        }, [
            accountForScrollbars
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!isEnabled) return;
            const element = scrollTarget.current;
            addScrollLock(element);
            return ()=>{
                removeScrollLock(element);
            };
        }, [
            isEnabled,
            addScrollLock,
            removeScrollLock
        ]);
        return (element)=>{
            scrollTarget.current = element;
        };
    }
});
parcelRegister("fenYw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8bb923c406dba917$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $2oS3b;
    var $7y9my;
    var $bsT3T;
    const $8bb923c406dba917$var$LiveRegion = (props)=>{
        const { ariaSelection: ariaSelection, focusedOption: focusedOption, focusedValue: focusedValue, focusableOptions: focusableOptions, isFocused: isFocused, selectValue: selectValue, selectProps: selectProps, id: id, isAppleDevice: isAppleDevice } = props;
        const { ariaLiveMessages: ariaLiveMessages, getOptionLabel: getOptionLabel, inputValue: inputValue, isMulti: isMulti, isOptionDisabled: isOptionDisabled, isSearchable: isSearchable, label: label, menuIsOpen: menuIsOpen, options: options, screenReaderStatus: screenReaderStatus, tabSelectsValue: tabSelectsValue, isLoading: isLoading } = selectProps;
        const ariaLabel = selectProps['aria-label'] || label;
        const ariaLive = selectProps['aria-live'];
        const isA11yImprovementEnabled = (0, (0, parcelRequire("2oS3b")).fg)('design_system_select-a11y-improvement') && !isAppleDevice;
        const messages = (0, $5uXOq.useMemo)(()=>({
                ...(0, (0, parcelRequire("7y9my")).defaultAriaLiveMessages),
                ...ariaLiveMessages || {}
            }), [
            ariaLiveMessages
        ]);
        const ariaSelected = (0, $5uXOq.useMemo)(()=>{
            let message = '';
            if (isA11yImprovementEnabled && menuIsOpen) return '';
            if (ariaSelection && messages.onChange) {
                const { option: option, options: selectedOptions, removedValue: removedValue, removedValues: removedValues, value: value } = ariaSelection;
                const asOption = (val)=>!Array.isArray(val) ? val : null;
                const selected = removedValue || option || asOption(value);
                const label = selected ? getOptionLabel(selected) : '';
                const multiSelected = selectedOptions || removedValues || undefined;
                const labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
                if (isA11yImprovementEnabled && !label && !labels.length) return '';
                const onChangeProps = {
                    isDisabled: selected && isOptionDisabled(selected, selectValue),
                    label: label,
                    labels: labels,
                    ...ariaSelection
                };
                message = messages.onChange(onChangeProps);
            }
            return message;
        }, [
            ariaSelection,
            messages,
            isOptionDisabled,
            selectValue,
            getOptionLabel,
            isA11yImprovementEnabled,
            menuIsOpen
        ]);
        const prevInputValue = (0, $5uXOq.useRef)('');
        const ariaFocused = (0, $5uXOq.useMemo)(()=>{
            let focusMsg = '';
            const focused = focusedOption || focusedValue;
            const isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
            if (inputValue === prevInputValue.current && isA11yImprovementEnabled) return '';
            if (focused && messages.onFocus) {
                const onFocusProps = {
                    focused: focused,
                    label: getOptionLabel(focused),
                    isDisabled: isOptionDisabled(focused, selectValue),
                    isSelected: isSelected,
                    options: focusableOptions,
                    context: focused === focusedOption ? 'menu' : 'value',
                    selectValue: selectValue,
                    isMulti: isMulti
                };
                focusMsg = messages.onFocus(onFocusProps);
            }
            prevInputValue.current = inputValue;
            return focusMsg;
        }, [
            inputValue,
            focusedOption,
            focusedValue,
            getOptionLabel,
            isOptionDisabled,
            messages,
            focusableOptions,
            selectValue,
            isA11yImprovementEnabled,
            isMulti
        ]);
        const ariaResults = (0, $5uXOq.useMemo)(()=>{
            let resultsMsg = '';
            if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
                const shouldAnnounceAvailableResults = !focusableOptions.length;
                if (shouldAnnounceAvailableResults && (0, (0, parcelRequire("2oS3b")).fg)('design_system_select-a11y-improvement') || !(0, (0, parcelRequire("2oS3b")).fg)('design_system_select-a11y-improvement')) {
                    const resultsMessage = screenReaderStatus({
                        count: focusableOptions.length
                    });
                    resultsMsg = messages.onFilter({
                        inputValue: inputValue,
                        resultsMessage: resultsMessage
                    });
                }
            }
            return resultsMsg;
        }, [
            focusableOptions,
            inputValue,
            menuIsOpen,
            messages,
            options,
            screenReaderStatus,
            isLoading
        ]);
        const isInitialFocus = ariaSelection?.action === 'initial-input-focus';
        const ariaGuidance = (0, $5uXOq.useMemo)(()=>{
            if ((0, (0, parcelRequire("2oS3b")).fg)('design_system_select-a11y-improvement')) return '';
            let guidanceMsg = '';
            if (messages.guidance) {
                const context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
                guidanceMsg = messages.guidance({
                    'aria-label': ariaLabel,
                    context: context,
                    isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                    isMulti: isMulti,
                    isSearchable: isSearchable,
                    tabSelectsValue: tabSelectsValue,
                    isInitialFocus: isInitialFocus
                });
            }
            return guidanceMsg;
        }, [
            ariaLabel,
            focusedOption,
            focusedValue,
            isMulti,
            isOptionDisabled,
            isSearchable,
            menuIsOpen,
            messages,
            selectValue,
            tabSelectsValue,
            isInitialFocus
        ]);
        const ScreenReaderText = (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            id: "aria-selection"
        }, ariaSelected), (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            id: "aria-focused"
        }, ariaFocused), (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            id: "aria-results"
        }, ariaResults), !(0, (0, parcelRequire("2oS3b")).fg)('design_system_select-a11y-improvement') && (0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            id: "aria-guidance"
        }, ariaGuidance));
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, $5uXOq.Fragment), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bsT3T")).default), {
            id: id
        }, isInitialFocus && ScreenReaderText), (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("bsT3T")).default), {
            "aria-live": isA11yImprovementEnabled ? 'polite' : ariaLive,
            role: isA11yImprovementEnabled ? 'status' : 'log'
        }, isFocused && !isInitialFocus && ScreenReaderText));
    };
    var $8bb923c406dba917$export$2e2bcd8739ae039 = $8bb923c406dba917$var$LiveRegion;
});
parcelRegister("7y9my", function(module, exports) {
    $parcel$export(module.exports, "defaultAriaLiveMessages", ()=>$a7b3e13a3bcf9c77$export$a7265767c78f9bae);
    var $2oS3b;
    const $a7b3e13a3bcf9c77$export$a7265767c78f9bae = {
        guidance: (props)=>{
            const { isSearchable: isSearchable, isMulti: isMulti, tabSelectsValue: tabSelectsValue, context: context, isInitialFocus: isInitialFocus } = props;
            switch(context){
                case 'menu':
                    return `Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu${tabSelectsValue ? ', press Tab to select the option and exit the menu' : ''}.`;
                case 'input':
                    return isInitialFocus ? `${props['aria-label'] || 'Select'} is focused ${isSearchable ? ',type to refine list' : ''}, press Down to open the menu, ${isMulti ? ' press left to focus selected values' : ''}` : '';
                case 'value':
                    return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
                default:
                    return '';
            }
        },
        onChange: (props)=>{
            const { action: action, label: label = '', labels: labels, isDisabled: isDisabled } = props;
            switch(action){
                case 'deselect-option':
                case 'pop-value':
                case 'remove-value':
                    return `option ${label}, deselected.`;
                case 'clear':
                    return 'All selected options have been cleared.';
                case 'initial-input-focus':
                    return `option${labels.length > 1 ? 's' : ''} ${labels.join(',')}, selected.`;
                case 'select-option':
                    return isDisabled ? `option ${label} is disabled. Select another option.` : `option ${label}, selected.`;
                default:
                    return '';
            }
        },
        onFocus: (props)=>{
            const { context: context, focused: focused, options: options, label: label = '', selectValue: selectValue, isMulti: isMulti, isDisabled: isDisabled, isSelected: isSelected } = props;
            const getArrayIndex = (arr, item)=>arr && arr.length ? `(${arr.indexOf(item) + 1} of ${arr.length})` : '';
            if (context === 'value' && selectValue) return `value ${label} focused, ${getArrayIndex(selectValue, focused)}.`;
            if (context === 'menu') {
                const disabled = isDisabled ? ' disabled' : '';
                const notSelectedStatus = !isMulti && (0, (0, parcelRequire("2oS3b")).fg)('design_system_select-a11y-improvement') ? '' : ' not selected';
                const status = `${isSelected ? ' selected' : notSelectedStatus}${disabled}`;
                return `${label}${status}, ${getArrayIndex(options, focused)}, completion selected`;
            }
            return '';
        },
        onFilter: (props)=>{
            const { inputValue: inputValue, resultsMessage: resultsMessage } = props;
            return `${resultsMessage}${inputValue ? ' for search term ' + inputValue : ''}.`;
        }
    };
});
parcelRegister("bsT3T", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$974422c50fb59952$export$2e2bcd8739ae039);
    var $f8Sb3;
    function $974422c50fb59952$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $974422c50fb59952$var$styles = {
        name: "1j8j4w4-a11yText",
        styles: "width:1px;height:1px;padding:0;position:absolute;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);label:a11yText;overflow:hidden;white-space:nowrap"
    };
    const $974422c50fb59952$var$A11yText = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)("span", {
            css: $974422c50fb59952$var$styles,
            ...props
        });
    var $974422c50fb59952$export$2e2bcd8739ae039 = $974422c50fb59952$var$A11yText;
});
parcelRegister("by9Y7", function(module, exports) {
    $parcel$export(module.exports, "createFilter", ()=>$1012133c72ff468e$export$5d81789ff4aeccdf);
    var $8QpSo;
    var $4PUAy;
    const $1012133c72ff468e$var$memoizedStripDiacriticsForInput = (0, (0, parcelRequire("8QpSo")).default)((0, (0, parcelRequire("4PUAy")).stripDiacritics));
    const $1012133c72ff468e$var$trimString = (str)=>str.replace(/^\s+|\s+$/g, '');
    const $1012133c72ff468e$var$defaultStringify = (option)=>`${option.label} ${option.value}`;
    const $1012133c72ff468e$export$5d81789ff4aeccdf = (config)=>(option, rawInput)=>{
            if (option.data.__isNew__) return true;
            const { ignoreCase: ignoreCase, ignoreAccents: ignoreAccents, stringify: stringify, trim: trim, matchFrom: matchFrom } = {
                ignoreCase: true,
                ignoreAccents: true,
                stringify: $1012133c72ff468e$var$defaultStringify,
                trim: true,
                matchFrom: 'any',
                ...config
            };
            let input = trim ? $1012133c72ff468e$var$trimString(rawInput) : rawInput;
            let candidate = trim ? $1012133c72ff468e$var$trimString(stringify(option)) : stringify(option);
            if (ignoreCase) {
                input = input.toLowerCase();
                candidate = candidate.toLowerCase();
            }
            if (ignoreAccents) {
                input = $1012133c72ff468e$var$memoizedStripDiacriticsForInput(input);
                candidate = (0, (0, parcelRequire("4PUAy")).stripDiacritics)(candidate);
            }
            return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
        };
});
parcelRegister("4PUAy", function(module, exports) {
    $parcel$export(module.exports, "stripDiacritics", ()=>$a5a026396014cf91$export$b5bee4b27048330b);
    const $a5a026396014cf91$var$diacritics = [
        {
            base: 'A',
            letters: '\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F'
        },
        {
            base: 'AA',
            letters: '\uA732'
        },
        {
            base: 'AE',
            letters: '\u00C6\u01FC\u01E2'
        },
        {
            base: 'AO',
            letters: '\uA734'
        },
        {
            base: 'AU',
            letters: '\uA736'
        },
        {
            base: 'AV',
            letters: '\uA738\uA73A'
        },
        {
            base: 'AY',
            letters: '\uA73C'
        },
        {
            base: 'B',
            letters: '\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181'
        },
        {
            base: 'C',
            letters: '\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E'
        },
        {
            base: 'D',
            letters: '\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779'
        },
        {
            base: 'DZ',
            letters: '\u01F1\u01C4'
        },
        {
            base: 'Dz',
            letters: '\u01F2\u01C5'
        },
        {
            base: 'E',
            letters: '\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E'
        },
        {
            base: 'F',
            letters: '\u0046\u24BB\uFF26\u1E1E\u0191\uA77B'
        },
        {
            base: 'G',
            letters: '\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E'
        },
        {
            base: 'H',
            letters: '\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D'
        },
        {
            base: 'I',
            letters: '\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197'
        },
        {
            base: 'J',
            letters: '\u004A\u24BF\uFF2A\u0134\u0248'
        },
        {
            base: 'K',
            letters: '\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2'
        },
        {
            base: 'L',
            letters: '\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780'
        },
        {
            base: 'LJ',
            letters: '\u01C7'
        },
        {
            base: 'Lj',
            letters: '\u01C8'
        },
        {
            base: 'M',
            letters: '\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C'
        },
        {
            base: 'N',
            letters: '\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4'
        },
        {
            base: 'NJ',
            letters: '\u01CA'
        },
        {
            base: 'Nj',
            letters: '\u01CB'
        },
        {
            base: 'O',
            letters: '\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C'
        },
        {
            base: 'OI',
            letters: '\u01A2'
        },
        {
            base: 'OO',
            letters: '\uA74E'
        },
        {
            base: 'OU',
            letters: '\u0222'
        },
        {
            base: 'P',
            letters: '\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754'
        },
        {
            base: 'Q',
            letters: '\u0051\u24C6\uFF31\uA756\uA758\u024A'
        },
        {
            base: 'R',
            letters: '\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782'
        },
        {
            base: 'S',
            letters: '\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784'
        },
        {
            base: 'T',
            letters: '\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786'
        },
        {
            base: 'TZ',
            letters: '\uA728'
        },
        {
            base: 'U',
            letters: '\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244'
        },
        {
            base: 'V',
            letters: '\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245'
        },
        {
            base: 'VY',
            letters: '\uA760'
        },
        {
            base: 'W',
            letters: '\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72'
        },
        {
            base: 'X',
            letters: '\u0058\u24CD\uFF38\u1E8A\u1E8C'
        },
        {
            base: 'Y',
            letters: '\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE'
        },
        {
            base: 'Z',
            letters: '\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762'
        },
        {
            base: 'a',
            letters: '\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250'
        },
        {
            base: 'aa',
            letters: '\uA733'
        },
        {
            base: 'ae',
            letters: '\u00E6\u01FD\u01E3'
        },
        {
            base: 'ao',
            letters: '\uA735'
        },
        {
            base: 'au',
            letters: '\uA737'
        },
        {
            base: 'av',
            letters: '\uA739\uA73B'
        },
        {
            base: 'ay',
            letters: '\uA73D'
        },
        {
            base: 'b',
            letters: '\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253'
        },
        {
            base: 'c',
            letters: '\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184'
        },
        {
            base: 'd',
            letters: '\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A'
        },
        {
            base: 'dz',
            letters: '\u01F3\u01C6'
        },
        {
            base: 'e',
            letters: '\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD'
        },
        {
            base: 'f',
            letters: '\u0066\u24D5\uFF46\u1E1F\u0192\uA77C'
        },
        {
            base: 'g',
            letters: '\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F'
        },
        {
            base: 'h',
            letters: '\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265'
        },
        {
            base: 'hv',
            letters: '\u0195'
        },
        {
            base: 'i',
            letters: '\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131'
        },
        {
            base: 'j',
            letters: '\u006A\u24D9\uFF4A\u0135\u01F0\u0249'
        },
        {
            base: 'k',
            letters: '\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3'
        },
        {
            base: 'l',
            letters: '\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747'
        },
        {
            base: 'lj',
            letters: '\u01C9'
        },
        {
            base: 'm',
            letters: '\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F'
        },
        {
            base: 'n',
            letters: '\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5'
        },
        {
            base: 'nj',
            letters: '\u01CC'
        },
        {
            base: 'o',
            letters: '\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275'
        },
        {
            base: 'oi',
            letters: '\u01A3'
        },
        {
            base: 'ou',
            letters: '\u0223'
        },
        {
            base: 'oo',
            letters: '\uA74F'
        },
        {
            base: 'p',
            letters: '\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755'
        },
        {
            base: 'q',
            letters: '\u0071\u24E0\uFF51\u024B\uA757\uA759'
        },
        {
            base: 'r',
            letters: '\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783'
        },
        {
            base: 's',
            letters: '\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B'
        },
        {
            base: 't',
            letters: '\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787'
        },
        {
            base: 'tz',
            letters: '\uA729'
        },
        {
            base: 'u',
            letters: '\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289'
        },
        {
            base: 'v',
            letters: '\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C'
        },
        {
            base: 'vy',
            letters: '\uA761'
        },
        {
            base: 'w',
            letters: '\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73'
        },
        {
            base: 'x',
            letters: '\u0078\u24E7\uFF58\u1E8B\u1E8D'
        },
        {
            base: 'y',
            letters: '\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF'
        },
        {
            base: 'z',
            letters: '\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763'
        }
    ];
    const $a5a026396014cf91$var$anyDiacritic = new RegExp('[' + $a5a026396014cf91$var$diacritics.map((d)=>d.letters).join('') + ']', 'g');
    const $a5a026396014cf91$var$diacriticToBase = {};
    for(let i = 0; i < $a5a026396014cf91$var$diacritics.length; i++){
        let diacritic = $a5a026396014cf91$var$diacritics[i];
        for(let j = 0; j < diacritic.letters.length; j++)$a5a026396014cf91$var$diacriticToBase[diacritic.letters[j]] = diacritic.base;
    }
    const $a5a026396014cf91$export$b5bee4b27048330b = (str)=>{
        return str.replace($a5a026396014cf91$var$anyDiacritic, (match)=>$a5a026396014cf91$var$diacriticToBase[match]);
    };
});
parcelRegister("crsHE", function(module, exports) {
    $parcel$export(module.exports, "defaultStyles", ()=>$b3155602f5f642fc$export$214b055320e0bf32);
    $parcel$export(module.exports, "mergeStyles", ()=>$b3155602f5f642fc$export$e618dc39ac9ad607);
    var $hekcY;
    var $5EgAF;
    var $5dHSO;
    var $8KLo7;
    var $loRFz;
    var $b4pnV;
    var $hti3c;
    var $1MDaa;
    var $hklN8;
    var $7SnYw;
    const $b3155602f5f642fc$export$214b055320e0bf32 = {
        clearIndicator: (0, (0, parcelRequire("8KLo7")).clearIndicatorCSS),
        container: (0, (0, parcelRequire("hekcY")).containerCSS),
        control: (0, (0, parcelRequire("5EgAF")).css),
        dropdownIndicator: (0, (0, parcelRequire("8KLo7")).dropdownIndicatorCSS),
        group: (0, (0, parcelRequire("5dHSO")).groupCSS),
        groupHeading: (0, (0, parcelRequire("5dHSO")).groupHeadingCSS),
        indicatorsContainer: (0, (0, parcelRequire("hekcY")).indicatorsContainerCSS),
        indicatorSeparator: (0, (0, parcelRequire("8KLo7")).indicatorSeparatorCSS),
        input: (0, (0, parcelRequire("loRFz")).inputCSS),
        loadingIndicator: (0, (0, parcelRequire("8KLo7")).loadingIndicatorCSS),
        loadingMessage: (0, (0, parcelRequire("b4pnV")).loadingMessageCSS),
        menu: (0, (0, parcelRequire("b4pnV")).menuCSS),
        menuList: (0, (0, parcelRequire("b4pnV")).menuListCSS),
        menuPortal: (0, (0, parcelRequire("b4pnV")).menuPortalCSS),
        multiValue: (0, (0, parcelRequire("hti3c")).multiValueCSS),
        multiValueLabel: (0, (0, parcelRequire("hti3c")).multiValueLabelCSS),
        multiValueRemove: (0, (0, parcelRequire("hti3c")).multiValueRemoveCSS),
        noOptionsMessage: (0, (0, parcelRequire("b4pnV")).noOptionsMessageCSS),
        option: (0, (0, parcelRequire("1MDaa")).optionCSS),
        placeholder: (0, (0, parcelRequire("hklN8")).placeholderCSS),
        singleValue: (0, (0, parcelRequire("7SnYw")).css),
        valueContainer: (0, (0, parcelRequire("hekcY")).valueContainerCSS)
    };
    function $b3155602f5f642fc$export$e618dc39ac9ad607(source, target = {}) {
        const styles = {
            ...source
        };
        Object.keys(target).forEach((keyAsString)=>{
            const key = keyAsString;
            if (source[key]) styles[key] = (rsCss, props)=>{
                return target[key](source[key](rsCss, props), props);
            };
            else styles[key] = target[key];
        });
        return styles;
    }
});
parcelRegister("gZxD5", function(module, exports) {
    $parcel$export(module.exports, "defaultTheme", ()=>$87a511a775a34fb9$export$164de7ab8df77ef0);
    const $87a511a775a34fb9$export$8f45430ccf837300 = {
        primary: '#2684FF',
        primary75: '#4C9AFF',
        primary50: '#B2D4FF',
        primary25: '#DEEBFF',
        danger: '#DE350B',
        dangerLight: '#FFBDAD',
        neutral0: 'hsl(0, 0%, 100%)',
        neutral5: 'hsl(0, 0%, 95%)',
        neutral10: 'hsl(0, 0%, 90%)',
        neutral20: 'hsl(0, 0%, 80%)',
        neutral30: 'hsl(0, 0%, 70%)',
        neutral40: 'hsl(0, 0%, 60%)',
        neutral50: 'hsl(0, 0%, 50%)',
        neutral60: 'hsl(0, 0%, 40%)',
        neutral70: 'hsl(0, 0%, 30%)',
        neutral80: 'hsl(0, 0%, 20%)',
        neutral90: 'hsl(0, 0%, 10%)'
    };
    const $87a511a775a34fb9$var$borderRadius = 4;
    const $87a511a775a34fb9$var$baseUnit = 4;
    const $87a511a775a34fb9$var$controlHeight = 38;
    const $87a511a775a34fb9$var$menuGutter = $87a511a775a34fb9$var$baseUnit * 2;
    const $87a511a775a34fb9$export$5458b64234d1333c = {
        baseUnit: $87a511a775a34fb9$var$baseUnit,
        controlHeight: $87a511a775a34fb9$var$controlHeight,
        menuGutter: $87a511a775a34fb9$var$menuGutter
    };
    const $87a511a775a34fb9$export$164de7ab8df77ef0 = {
        borderRadius: $87a511a775a34fb9$var$borderRadius,
        colors: $87a511a775a34fb9$export$8f45430ccf837300,
        spacing: $87a511a775a34fb9$export$5458b64234d1333c
    };
});
parcelRegister("6vVYA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9332a65322bdfb79$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $g2UN3;
    function $9332a65322bdfb79$export$2e2bcd8739ae039({ defaultOptions: propsDefaultOptions = false, cacheOptions: cacheOptions = false, loadOptions: propsLoadOptions, options: propsOptions, isLoading: propsIsLoading = false, onInputChange: propsOnInputChange, filterOption: filterOption = null, ...restSelectProps }) {
        const { inputValue: propsInputValue } = restSelectProps;
        const lastRequest = (0, $5uXOq.useRef)(undefined);
        const mounted = (0, $5uXOq.useRef)(false);
        const [defaultOptions, setDefaultOptions] = (0, $5uXOq.useState)(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
        const [stateInputValue, setStateInputValue] = (0, $5uXOq.useState)(typeof propsInputValue !== 'undefined' ? propsInputValue : '');
        const [isLoading, setIsLoading] = (0, $5uXOq.useState)(propsDefaultOptions === true);
        const [loadedInputValue, setLoadedInputValue] = (0, $5uXOq.useState)(undefined);
        const [loadedOptions, setLoadedOptions] = (0, $5uXOq.useState)([]);
        const [passEmptyOptions, setPassEmptyOptions] = (0, $5uXOq.useState)(false);
        const [optionsCache, setOptionsCache] = (0, $5uXOq.useState)({});
        const [prevDefaultOptions, setPrevDefaultOptions] = (0, $5uXOq.useState)(undefined);
        const [prevCacheOptions, setPrevCacheOptions] = (0, $5uXOq.useState)(undefined);
        if (cacheOptions !== prevCacheOptions) {
            setOptionsCache({});
            setPrevCacheOptions(cacheOptions);
        }
        if (propsDefaultOptions !== prevDefaultOptions) {
            setDefaultOptions(Array.isArray(propsDefaultOptions) ? propsDefaultOptions : undefined);
            setPrevDefaultOptions(propsDefaultOptions);
        }
        (0, $5uXOq.useEffect)(()=>{
            mounted.current = true;
            return ()=>{
                mounted.current = false;
            };
        }, []);
        const loadOptions = (0, $5uXOq.useCallback)((inputValue, callback)=>{
            if (!propsLoadOptions) return callback();
            const loader = propsLoadOptions(inputValue, callback);
            if (loader && typeof loader.then === 'function') loader.then(callback, ()=>callback());
        }, [
            propsLoadOptions
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (propsDefaultOptions === true) loadOptions(stateInputValue, (options)=>{
                if (!mounted.current) return;
                setDefaultOptions(options || []);
                setIsLoading(!!lastRequest.current);
            });
        }, []);
        const onInputChange = (0, $5uXOq.useCallback)((newValue, actionMeta)=>{
            const inputValue = (0, (0, parcelRequire("g2UN3")).handleInputChange)(newValue, actionMeta, propsOnInputChange);
            if (!inputValue) {
                lastRequest.current = undefined;
                setStateInputValue('');
                setLoadedInputValue('');
                setLoadedOptions([]);
                setIsLoading(false);
                setPassEmptyOptions(false);
                return;
            }
            if (cacheOptions && optionsCache[inputValue]) {
                setStateInputValue(inputValue);
                setLoadedInputValue(inputValue);
                setLoadedOptions(optionsCache[inputValue]);
                setIsLoading(false);
                setPassEmptyOptions(false);
            } else {
                const request = lastRequest.current = {};
                setStateInputValue(inputValue);
                setIsLoading(true);
                setPassEmptyOptions(!loadedInputValue);
                loadOptions(inputValue, (options)=>{
                    if (!mounted) return;
                    if (request !== lastRequest.current) return;
                    lastRequest.current = undefined;
                    setIsLoading(false);
                    setLoadedInputValue(inputValue);
                    setLoadedOptions(options || []);
                    setPassEmptyOptions(false);
                    setOptionsCache(options ? {
                        ...optionsCache,
                        [inputValue]: options
                    } : optionsCache);
                });
            }
        }, [
            cacheOptions,
            loadOptions,
            loadedInputValue,
            optionsCache,
            propsOnInputChange
        ]);
        const options = passEmptyOptions ? [] : stateInputValue && loadedInputValue ? loadedOptions : defaultOptions || [];
        return {
            ...restSelectProps,
            options: options,
            isLoading: isLoading || propsIsLoading,
            onInputChange: onInputChange,
            filterOption: filterOption
        };
    }
});
parcelRegister("dIVa9", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7dbf9d49c9b24aee$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    function $7dbf9d49c9b24aee$export$2e2bcd8739ae039({ defaultInputValue: defaultInputValue = '', defaultMenuIsOpen: defaultMenuIsOpen = false, defaultValue: defaultValue = null, inputValue: propsInputValue, menuIsOpen: propsMenuIsOpen, onChange: propsOnChange, onInputChange: propsOnInputChange, onMenuClose: propsOnMenuClose, onMenuOpen: propsOnMenuOpen, value: propsValue, ...restSelectProps }) {
        const [stateInputValue, setStateInputValue] = (0, $5uXOq.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue);
        const [stateMenuIsOpen, setStateMenuIsOpen] = (0, $5uXOq.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen);
        const [stateValue, setStateValue] = (0, $5uXOq.useState)(propsValue !== undefined ? propsValue : defaultValue);
        const onChange = (0, $5uXOq.useCallback)((value, actionMeta)=>{
            if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
            setStateValue(value);
        }, [
            propsOnChange
        ]);
        const onInputChange = (0, $5uXOq.useCallback)((value, actionMeta)=>{
            let newValue;
            if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
            setStateInputValue(newValue !== undefined ? newValue : value);
        }, [
            propsOnInputChange
        ]);
        const onMenuOpen = (0, $5uXOq.useCallback)(()=>{
            if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
            setStateMenuIsOpen(true);
        }, [
            propsOnMenuOpen
        ]);
        const onMenuClose = (0, $5uXOq.useCallback)(()=>{
            if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
            setStateMenuIsOpen(false);
        }, [
            propsOnMenuClose
        ]);
        const inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
        const menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
        const value = propsValue !== undefined ? propsValue : stateValue;
        return {
            ...restSelectProps,
            inputValue: inputValue,
            menuIsOpen: menuIsOpen,
            onChange: onChange,
            onInputChange: onInputChange,
            onMenuClose: onMenuClose,
            onMenuOpen: onMenuOpen,
            value: value
        };
    }
});
parcelRegister("2s2ld", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5214de49fe3c4d80$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $crsHE;
    var $hjioQ;
    var $kbK1u;
    var $aKHA6;
    var $b7a6t;
    var $imyI2;
    var $HFUaQ;
    function $5214de49fe3c4d80$export$2e2bcd8739ae039(WrappedComponent) {
        const AtlaskitSelect = (0, $5uXOq.forwardRef)(function AtlaskitSelect(props, forwardedRef) {
            const { appearance: appearance, ariaLiveMessages: ariaLiveMessages, components: componentsProp, isInvalid: isInvalid, onClickPreventDefault: onClickPreventDefault = true, spacing: spacing = 'default', styles: styles = {}, tabSelectsValue: tabSelectsValue = false, validationState: validationState = 'default', ...restProps } = props;
            const internalSelectRef = (0, $5uXOq.useRef)(null);
            const components = (0, $5uXOq.useMemo)(()=>({
                    ClearIndicator: (0, parcelRequire("hjioQ")).ClearIndicator,
                    DropdownIndicator: (0, parcelRequire("hjioQ")).DropdownIndicator,
                    LoadingIndicator: (0, parcelRequire("hjioQ")).LoadingIndicator,
                    MultiValueRemove: (0, parcelRequire("kbK1u")).MultiValueRemove,
                    IndicatorSeparator: (0, parcelRequire("kbK1u")).IndicatorSeparator,
                    Input: (0, parcelRequire("aKHA6")).Input,
                    NoOptionsMessage: (0, parcelRequire("b7a6t")).NoOptionsMessage,
                    ...componentsProp
                }), [
                componentsProp
            ]);
            const descriptionId = props['aria-describedby'];
            const isSearchable = props.isSearchable;
            (0, $5uXOq.useEffect)(()=>{
                if (!isSearchable && descriptionId) {
                    const input = internalSelectRef.current?.inputRef;
                    const ariaDescribedby = input?.getAttribute('aria-describedby');
                    if (!ariaDescribedby?.includes(descriptionId)) input?.setAttribute('aria-describedby', `${ariaDescribedby} ${descriptionId}`);
                }
            }, [
                descriptionId,
                isSearchable
            ]);
            const isCompact = spacing === 'compact';
            (0, $5uXOq.useImperativeHandle)(forwardedRef, ()=>({
                    select: internalSelectRef.current,
                    focus: ()=>internalSelectRef.current?.focus(),
                    blur: ()=>internalSelectRef.current?.blur()
                }), []);
            return (0, ($parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                ref: internalSelectRef,
                "aria-live": "assertive",
                ariaLiveMessages: (0, (0, parcelRequire("HFUaQ")).isOptionsGrouped)(props.options) ? {
                    onFocus: (data)=>(0, (0, parcelRequire("HFUaQ")).onFocus)(data, props.options),
                    ...ariaLiveMessages
                } : {
                    ...ariaLiveMessages
                },
                tabSelectsValue: tabSelectsValue,
                onClickPreventDefault: onClickPreventDefault,
                isInvalid: isInvalid,
                ...restProps,
                components: components,
                styles: (0, (0, parcelRequire("crsHE")).mergeStyles)((0, (0, parcelRequire("imyI2")).default)(typeof isInvalid !== 'undefined' ? isInvalid ? 'error' : 'default' : validationState, isCompact, appearance || 'default'), styles),
                isAsync: true
            });
        });
        AtlaskitSelect.displayName = 'AtlaskitSelect';
        return AtlaskitSelect;
    }
});
parcelRegister("hjioQ", function(module, exports) {
    $parcel$export(module.exports, "ClearIndicator", ()=>$e3b166afd75430c9$export$ecf9cf59142dd54a);
    $parcel$export(module.exports, "DropdownIndicator", ()=>$e3b166afd75430c9$export$ec98719d3db7f2e4);
    $parcel$export(module.exports, "LoadingIndicator", ()=>$e3b166afd75430c9$export$7c20be4c1d342248);
    var $f8Sb3;
    var $h8Wzd;
    var $2uz6y;
    var $fm763;
    var $a95o8;
    var $99gde;
    var $2JKLA;
    var $113Tq;
    const $e3b166afd75430c9$var$iconContainerStyles = (0, (0, parcelRequire("99gde")).xcss)({
        all: 'unset',
        outline: 'revert',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: 'space.025'
    });
    const $e3b166afd75430c9$var$dropdownWrapperStyles = (0, (0, parcelRequire("99gde")).xcss)({
        padding: 'space.075'
    });
    const $e3b166afd75430c9$export$ecf9cf59142dd54a = ({ clearControlLabel: clearControlLabel = 'clear', ...props })=>{
        return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2JKLA")).components).ClearIndicator, {
            ...props,
            innerProps: {
                ...props.innerProps,
                'aria-hidden': 'false'
            }
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("a95o8")).default), {
            xcss: $e3b166afd75430c9$var$iconContainerStyles,
            tabIndex: -1,
            "aria-label": clearControlLabel
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("2uz6y"))))), {
            label: "",
            color: "currentColor",
            LEGACY_size: "small",
            LEGACY_margin: "var(--ds-space-negative-025, -0.125rem)"
        })));
    };
    const $e3b166afd75430c9$export$ec98719d3db7f2e4 = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2JKLA")).components).DropdownIndicator, props, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("fm763")).default), {
            as: "span",
            xcss: $e3b166afd75430c9$var$dropdownWrapperStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("h8Wzd"))))), {
            color: "currentColor",
            label: "open",
            LEGACY_margin: "var(--ds-space-negative-075, -0.375rem)"
        })));
    const $e3b166afd75430c9$export$7c20be4c1d342248 = (props)=>{
        const loadingStyles = (0, (0, parcelRequire("f8Sb3")).css)(props.getStyles('loadingIndicator', props));
        return ((0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: loadingStyles,
            ...props.innerProps
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("113Tq")).default), {
            size: "small"
        })));
    };
});
parcelRegister("2uz6y", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $1d099d27a685bf63$var$_react = $1d099d27a685bf63$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $1d099d27a685bf63$var$_crossCircle = $1d099d27a685bf63$var$_interopRequireDefault((parcelRequire("2gX5A")));
    var $1d099d27a685bf63$var$_selectClear = $1d099d27a685bf63$var$_interopRequireDefault((parcelRequire("3h0rt")));
    function $1d099d27a685bf63$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $1d099d27a685bf63$var$CrossCircleIcon = (props)=>$1d099d27a685bf63$var$_react.default.createElement($1d099d27a685bf63$var$_crossCircle.default, Object.assign({
            LEGACY_fallbackIcon: $1d099d27a685bf63$var$_selectClear.default
        }, props));
    $1d099d27a685bf63$var$CrossCircleIcon.Name = 'CrossCircleIconMigration';
    var $1d099d27a685bf63$var$_default = module.exports.default = $1d099d27a685bf63$var$CrossCircleIcon;
});
parcelRegister("2gX5A", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $1a7ae93c4f2b7ce5$var$_react = $1a7ae93c4f2b7ce5$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $1a7ae93c4f2b7ce5$var$_UNSAFE_baseNew = $1a7ae93c4f2b7ce5$var$_interopRequireDefault((parcelRequire("dTInF")));
    function $1a7ae93c4f2b7ce5$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $1a7ae93c4f2b7ce5$var$CrossCircleIcon = (props)=>$1a7ae93c4f2b7ce5$var$_react.default.createElement($1a7ae93c4f2b7ce5$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 12A6 6 0 1 0 6 0a6 6 0 0 0 0 12m3.28-8.22L7.06 6l2.22 2.22-1.06 1.06L6 7.06 3.78 9.28 2.72 8.22 4.94 6 2.72 3.78l1.06-1.06L6 4.94l2.22-2.22z" clip-rule="evenodd"/>`,
            type: 'utility'
        }, props));
    $1a7ae93c4f2b7ce5$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
    var $1a7ae93c4f2b7ce5$var$_default = module.exports.default = $1a7ae93c4f2b7ce5$var$CrossCircleIcon;
});
parcelRegister("3h0rt", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $26234d72bec5adf7$var$_react = $26234d72bec5adf7$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $7p1ve;
    var $26234d72bec5adf7$var$_crossCircle = $26234d72bec5adf7$var$_interopRequireDefault((parcelRequire("hA8Dz")));
    function $26234d72bec5adf7$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $26234d72bec5adf7$var$SelectClearIcon = (props)=>$26234d72bec5adf7$var$_react.default.createElement((0, parcelRequire("7p1ve")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="9" fill="currentcolor"/><path fill="inherit" d="M16.155 14.493a1.174 1.174 0 1 1-1.662 1.663L12 13.662l-2.494 2.494a1.17 1.17 0 0 1-1.662 0 1.176 1.176 0 0 1 0-1.663L10.337 12 7.844 9.507a1.176 1.176 0 0 1 1.662-1.662L12 10.338l2.493-2.493a1.174 1.174 0 1 1 1.662 1.662L13.662 12z"/></g></svg>`
        }, props, {
            newIcon: $26234d72bec5adf7$var$_crossCircle.default
        }));
    $26234d72bec5adf7$var$SelectClearIcon.displayName = 'SelectClearIcon';
    var $26234d72bec5adf7$var$_default = module.exports.default = $26234d72bec5adf7$var$SelectClearIcon;
});
parcelRegister("hA8Dz", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $cccc7fa1583dbf38$var$_react = $cccc7fa1583dbf38$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $cccc7fa1583dbf38$var$_UNSAFE_baseNew = $cccc7fa1583dbf38$var$_interopRequireDefault((parcelRequire("dTInF")));
    function $cccc7fa1583dbf38$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $cccc7fa1583dbf38$var$CrossCircleIcon = (props)=>$cccc7fa1583dbf38$var$_react.default.createElement($cccc7fa1583dbf38$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m4.03 5.03L9.06 8l2.97 2.97-1.06 1.06L8 9.06l-2.97 2.97-1.06-1.06L6.94 8 3.97 5.03l1.06-1.06L8 6.94l2.97-2.97z" clip-rule="evenodd"/>`
        }, props));
    $cccc7fa1583dbf38$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
    var $cccc7fa1583dbf38$var$_default = module.exports.default = $cccc7fa1583dbf38$var$CrossCircleIcon;
});
parcelRegister("kbK1u", function(module, exports) {
    $parcel$export(module.exports, "MultiValueRemove", ()=>$440bbf009bc44946$export$8e1fd1a40e7a2f4a);
    $parcel$export(module.exports, "IndicatorSeparator", ()=>$440bbf009bc44946$export$bd638c2ba7915668);
    var $f8Sb3;
    var $3h0rt;
    var $eM5qw;
    var $2oS3b;
    var $fm763;
    var $99gde;
    var $2JKLA;
    var $hjioQ;
    function $440bbf009bc44946$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $440bbf009bc44946$var$disabledStyles = {
        name: "eivff4",
        styles: "display:none"
    };
    const $440bbf009bc44946$var$enabledStyles = {
        name: "ck88l6",
        styles: "display:inherit"
    };
    const $440bbf009bc44946$var$iconWrapperStyles = (0, (0, parcelRequire("99gde")).xcss)({
        padding: 'space.025'
    });
    const $440bbf009bc44946$export$8e1fd1a40e7a2f4a = (props)=>{
        const { isDisabled: isDisabled } = props.selectProps;
        const renderIcon = ()=>{
            if ((0, (0, parcelRequire("2oS3b")).fg)('platform-component-visual-refresh')) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("eM5qw"))))), {
                label: "Clear",
                color: "currentColor"
            });
            if ((0, (0, parcelRequire("2oS3b")).fg)('platform-visual-refresh-icons-legacy-facade')) return (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("fm763")).default), {
                xcss: $440bbf009bc44946$var$iconWrapperStyles
            }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("eM5qw"))))), {
                label: "Clear",
                color: "currentColor"
            }));
            return ((0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("3h0rt"))))), {
                label: "Clear",
                primaryColor: "transparent",
                size: "small",
                secondaryColor: "inherit"
            }));
        };
        return ((0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2JKLA")).components).MultiValueRemove, props, (0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: isDisabled ? $440bbf009bc44946$var$disabledStyles : $440bbf009bc44946$var$enabledStyles,
            "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon'
        }, renderIcon())));
    };
    const $440bbf009bc44946$export$bd638c2ba7915668 = null;
});
parcelRegister("eM5qw", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $ac19c20d14390f4c$var$_react = $ac19c20d14390f4c$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $ac19c20d14390f4c$var$_UNSAFE_baseNew = $ac19c20d14390f4c$var$_interopRequireDefault((parcelRequire("dTInF")));
    function $ac19c20d14390f4c$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $ac19c20d14390f4c$var$CrossIcon = (props)=>$ac19c20d14390f4c$var$_react.default.createElement($ac19c20d14390f4c$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m2 10 4-4m4-4L6 6m0 0L2 2m4 4 4 4"/>`,
            type: 'utility'
        }, props));
    $ac19c20d14390f4c$var$CrossIcon.displayName = 'CrossIcon';
    var $ac19c20d14390f4c$var$_default = module.exports.default = $ac19c20d14390f4c$var$CrossIcon;
});
parcelRegister("aKHA6", function(module, exports) {
    $parcel$export(module.exports, "Input", ()=>$54e7208482951c00$export$f5b8910cec6cf069);
    var $5uXOq = parcelRequire("5uXOq");
    var $2JKLA;
    function $54e7208482951c00$export$f5b8910cec6cf069(props) {
        let ariaDescribedByAttribute = props['aria-describedby'];
        const passed_describedby = props.selectProps['aria-describedby'] || props.selectProps.descriptionId;
        if (passed_describedby && !ariaDescribedByAttribute?.includes(passed_describedby)) ariaDescribedByAttribute = props['aria-describedby'] + ' ' + passed_describedby;
        else ariaDescribedByAttribute = props['aria-describedby'] || passed_describedby;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2JKLA")).components).Input, {
            ...props,
            "aria-describedby": ariaDescribedByAttribute
        });
    }
});
parcelRegister("b7a6t", function(module, exports) {
    $parcel$export(module.exports, "NoOptionsMessage", ()=>$cde8873635d1057d$export$d58b72b7d3c4072c);
    var $5uXOq = parcelRequire("5uXOq");
    var $ZuPvl;
    var $2JKLA;
    const $cde8873635d1057d$export$d58b72b7d3c4072c = (props)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2JKLA")).components).NoOptionsMessage, props, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ZuPvl")).default), {
            color: "color.text.subtle"
        }, props.children || `No options`));
    };
});
parcelRegister("imyI2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6b98022bba24ece5$export$2e2bcd8739ae039);
    var $2oS3b;
    function $6b98022bba24ece5$export$2e2bcd8739ae039(validationState, isCompact = false, appearance) {
        return {
            container: (css, { isDisabled: isDisabled })=>({
                    ...css,
                    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                    pointerEvents: 'all',
                    cursor: isDisabled ? 'not-allowed' : css.cursor
                }),
            input: (css)=>({
                    ...css,
                    color: "var(--ds-text, hsl(0, 0%, 20%))"
                }),
            control: (css, { isFocused: isFocused, isDisabled: isDisabled })=>{
                let borderColor = isFocused ? `var(--ds-border-focused, ${0, $72ba03e317f3d228$export$ecfc1dff386a3e7a})` : `var(--ds-border-input, ${0, $72ba03e317f3d228$export$d6447c357493214f})`;
                let backgroundColor = isFocused ? `var(--ds-background-input-pressed, ${0, $72ba03e317f3d228$export$29a4f05edc054374})` : `var(--ds-background-input, ${0, $72ba03e317f3d228$export$9fdfb749e33cdf97})`;
                let backgroundColorHover = isFocused ? `var(--ds-background-input-pressed, ${0, $72ba03e317f3d228$export$29a4f05edc054374})` : `var(--ds-background-input-hovered, ${0, $72ba03e317f3d228$export$3e51e8f1440314ba})`;
                if (isDisabled) {
                    backgroundColor = `var(--ds-background-disabled, ${0, $72ba03e317f3d228$export$9fdfb749e33cdf97})`;
                    borderColor = `var(--ds-background-disabled, ${0, $72ba03e317f3d228$export$9fdfb749e33cdf97})`;
                }
                if (validationState === 'error') borderColor = `var(--ds-border-danger, ${0, $72ba03e317f3d228$export$2010d0fb4295b346})`;
                if (validationState === 'success') borderColor = `var(--ds-border-success, ${0, $72ba03e317f3d228$export$a49394138f7b8e85})`;
                let borderColorHover = isFocused ? `var(--ds-border-focused, ${0, $72ba03e317f3d228$export$ecfc1dff386a3e7a})` : `var(--ds-border-input, ${0, $72ba03e317f3d228$export$d6447c357493214f})`;
                if (validationState === 'error') borderColorHover = `var(--ds-border-danger, ${0, $72ba03e317f3d228$export$2010d0fb4295b346})`;
                if (validationState === 'success') borderColorHover = `var(--ds-border-success, ${0, $72ba03e317f3d228$export$a49394138f7b8e85})`;
                const transitionDuration = '200ms';
                if (appearance === 'subtle') {
                    borderColor = isFocused ? `var(--ds-border-focused, ${0, $72ba03e317f3d228$export$ecfc1dff386a3e7a})` : 'transparent';
                    backgroundColor = isFocused ? `var(--ds-surface, ${0, $72ba03e317f3d228$export$29a4f05edc054374})` : 'transparent';
                    backgroundColorHover = isFocused ? `var(--ds-background-input-pressed, ${0, $72ba03e317f3d228$export$29a4f05edc054374})` : `var(--ds-background-input-hovered, ${0, $72ba03e317f3d228$export$3e51e8f1440314ba})`;
                }
                if (appearance === 'none') {
                    borderColor = 'transparent';
                    backgroundColor = 'transparent';
                    backgroundColorHover = 'transparent';
                    borderColorHover = 'transparent';
                }
                return {
                    ...css,
                    pointerEvents: isDisabled ? 'none' : undefined,
                    backgroundColor: backgroundColor,
                    borderColor: borderColor,
                    borderStyle: 'solid',
                    borderRadius: "var(--ds-border-radius-100, 3px)",
                    borderWidth: "var(--ds-border-width, 1px)",
                    boxShadow: validationState === 'error' ? `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}` : 'none',
                    '&:focus-within': {
                        boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}`
                    },
                    minHeight: isCompact ? 32 : 40,
                    padding: 0,
                    transition: `background-color ${transitionDuration} ease-in-out,
        border-color ${transitionDuration} ease-in-out`,
                    '::-webkit-scrollbar': {
                        height: 8,
                        width: 8
                    },
                    '::-webkit-scrollbar-corner': {
                        display: 'none'
                    },
                    ':hover': {
                        '::-webkit-scrollbar-thumb': {
                            backgroundColor: 'rgba(0,0,0,0.2)'
                        },
                        cursor: 'pointer',
                        backgroundColor: backgroundColorHover,
                        borderColor: borderColorHover
                    },
                    '::-webkit-scrollbar-thumb:hover': {
                        backgroundColor: 'rgba(0,0,0,0.4)'
                    }
                };
            },
            valueContainer: (css)=>({
                    ...css,
                    paddingLeft: "var(--ds-space-075, 6px)",
                    paddingRight: "var(--ds-space-075, 6px)",
                    paddingBottom: isCompact ? 0 : 2,
                    paddingTop: isCompact ? 0 : 2
                }),
            clearIndicator: (css)=>({
                    ...css,
                    color: `var(--ds-text-subtlest, ${0, $72ba03e317f3d228$export$5f71e19f3a7ad9de})`,
                    paddingLeft: "var(--ds-space-025, 2px)",
                    paddingRight: "var(--ds-space-025, 2px)",
                    paddingBottom: isCompact ? 0 : 6,
                    paddingTop: isCompact ? 0 : 6,
                    ':hover': {
                        color: `var(--ds-text-subtle, ${0, $72ba03e317f3d228$export$c39c0fe0f26207ae})`
                    }
                }),
            loadingIndicator: (css)=>({
                    ...css,
                    paddingBottom: isCompact ? 0 : 6,
                    paddingTop: isCompact ? 0 : 6
                }),
            dropdownIndicator: (css, { isDisabled: isDisabled })=>{
                let color = `var(--ds-text-subtle, ${(0, $72ba03e317f3d228$export$c39c0fe0f26207ae)})`;
                if (isDisabled) color = `var(--ds-text-disabled, ${0, $72ba03e317f3d228$export$5f71e19f3a7ad9de})`;
                return {
                    ...css,
                    color: color,
                    paddingLeft: "var(--ds-space-025, 2px)",
                    paddingRight: "var(--ds-space-025, 2px)",
                    paddingBottom: isCompact ? 0 : 6,
                    paddingTop: isCompact ? 0 : 6,
                    ':hover': {
                        color: `var(--ds-text-subtle, ${0, $72ba03e317f3d228$export$f563ee71e9ee74cd})`
                    }
                };
            },
            indicatorsContainer: (css)=>({
                    ...css,
                    paddingRight: "var(--ds-space-050, 4px)"
                }),
            option: (css, { isFocused: isFocused, isSelected: isSelected, isDisabled: isDisabled })=>{
                let color = `var(--ds-text, ${(0, $72ba03e317f3d228$export$7d61b15e0da132af)})`;
                if (isDisabled) color = `var(--ds-text-disabled, ${0, $72ba03e317f3d228$export$5f71e19f3a7ad9de})`;
                else if (isSelected) color = `var(--ds-text-selected, ${0, $72ba03e317f3d228$export$b3de0ae08da2ce64})`;
                let boxShadow;
                let backgroundColor;
                if (isDisabled) backgroundColor = undefined;
                else if (isSelected && isFocused) backgroundColor = `var(--ds-background-selected-hovered, ${0, $72ba03e317f3d228$export$226de0355ed012f8})`;
                else if (isSelected) backgroundColor = `var(--ds-background-selected, ${0, $72ba03e317f3d228$export$226de0355ed012f8})`;
                else if (isFocused) backgroundColor = `var(--ds-background-neutral-subtle-hovered, ${0, $72ba03e317f3d228$export$9fdfb749e33cdf97})`;
                if (!isDisabled && (isFocused || isSelected)) boxShadow = `inset 2px 0px 0px ${`var(--ds-border-selected, ${0, $72ba03e317f3d228$export$b3de0ae08da2ce64})`}`;
                const cursor = isDisabled ? 'not-allowed' : css.cursor;
                return {
                    ...css,
                    padding: '6px 12px',
                    backgroundColor: backgroundColor,
                    color: color,
                    cursor: cursor,
                    boxShadow: boxShadow,
                    ':active': {
                        backgroundColor: !isDisabled ? isSelected ? `var(--ds-background-selected-pressed, ${0, $72ba03e317f3d228$export$9fdfb749e33cdf97})` : `var(--ds-background-neutral-subtle-pressed, ${0, $72ba03e317f3d228$export$3e51e8f1440314ba})` : undefined
                    },
                    '@media screen and (-ms-high-contrast: active)': {
                        borderLeft: !isDisabled && (isFocused || isSelected) ? '2px solid transparent' : ''
                    }
                };
            },
            placeholder: (css, { isDisabled: isDisabled })=>({
                    ...css,
                    color: isDisabled ? `var(--ds-text-disabled, ${0, $72ba03e317f3d228$export$e2ef2124cf4024b1})` : `var(--ds-text-subtlest, ${0, $72ba03e317f3d228$export$f563ee71e9ee74cd})`
                }),
            singleValue: (css, { isDisabled: isDisabled })=>({
                    ...css,
                    color: isDisabled ? `var(--ds-text-disabled, ${0, $72ba03e317f3d228$export$5f71e19f3a7ad9de})` : `var(--ds-text, ${0, $72ba03e317f3d228$export$7d61b15e0da132af})`
                }),
            menu: (css)=>({
                    ...css,
                    backgroundColor: "var(--ds-surface-overlay, white)",
                    boxShadow: "var(--ds-shadow-overlay, 0 0 0 1px hsl(0deg 0% 0% / 10%), 0 4px 11px hsl(0deg 0% 0% / 10%))"
                }),
            menuList: (css)=>({
                    ...css,
                    paddingTop: "var(--ds-space-100, 8px)",
                    paddingBottom: "var(--ds-space-100, 8px)"
                }),
            multiValue: (css, { isDisabled: isDisabled, isFocused: isFocused })=>{
                let backgroundColor;
                let color;
                if (isDisabled) {
                    backgroundColor = `var(--ds-background-neutral, ${0, $72ba03e317f3d228$export$1ce2d1575d444ceb})`;
                    color = `var(--ds-text-disabled, ${0, $72ba03e317f3d228$export$5f71e19f3a7ad9de})`;
                } else if (isFocused) {
                    backgroundColor = `var(--ds-background-selected, ${0, $72ba03e317f3d228$export$1ce2d1575d444ceb})`;
                    color = "var(--ds-text-selected, hsl(0, 0%, 20%))";
                } else {
                    backgroundColor = (0, (0, parcelRequire("2oS3b")).fg)('platform-component-visual-refresh') ? "var(--ds-background-neutral-subtle-hovered, #091E420F)" : `var(--ds-background-neutral, ${0, $72ba03e317f3d228$export$1ce2d1575d444ceb})`;
                    color = "var(--ds-text, hsl(0, 0%, 20%))";
                }
                return {
                    ...css,
                    borderRadius: "var(--ds-border-radius-050, 2px)",
                    backgroundColor: backgroundColor,
                    boxShadow: isFocused ? `0 0 0 2px ${"var(--ds-surface, transparent)"}, 0 0 0 4px ${"var(--ds-border-focused, transparent)"}` : 'none',
                    maxWidth: '100%',
                    '@media screen and (-ms-high-contrast: active)': {
                        border: isFocused ? '1px solid transparent' : 'none'
                    },
                    color: color,
                    ...(0, (0, parcelRequire("2oS3b")).fg)('platform-component-visual-refresh') && {
                        borderRadius: "var(--ds-border-radius-100, 4px)",
                        borderColor: '#B7B9BE',
                        borderWidth: "var(--ds-border-width, 1px)",
                        borderStyle: 'solid',
                        backgroundColor: "var(--ds-background-input, #FFFFFF)"
                    }
                };
            },
            multiValueLabel: (css, { isDisabled: isDisabled })=>({
                    ...css,
                    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                    padding: "var(--ds-space-025, 2px)",
                    color: isDisabled ? `var(--ds-text-disabled, ${0, $72ba03e317f3d228$export$5f71e19f3a7ad9de})` : 'inherit',
                    paddingRight: "var(--ds-space-025, 2px)",
                    ...(0, (0, parcelRequire("2oS3b")).fg)('platform-component-visual-refresh') && {
                        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                        paddingTop: 0,
                        paddingBottom: 0,
                        paddingLeft: "var(--ds-space-050, 4px)"
                    }
                }),
            multiValueRemove: (css, { isFocused: isFocused })=>({
                    ...css,
                    backgroundColor: isFocused ? `var(--ds-UNSAFE-transparent, ${0, $72ba03e317f3d228$export$b34b069eff244586})` : undefined,
                    fill: isFocused ? "var(--ds-text-selected, #000)" : "var(--ds-text, #000)",
                    paddingLeft: "var(--ds-space-025, 2px)",
                    paddingRight: "var(--ds-space-025, 2px)",
                    borderRadius: '0px 2px 2px 0px',
                    ':hover': {
                        backgroundColor: `var(--ds-background-danger-hovered, ${0, $72ba03e317f3d228$export$b34b069eff244586})`,
                        fill: "var(--ds-text-danger, #000)"
                    },
                    ':active': {
                        backgroundColor: `var(--ds-background-danger-pressed, ${0, $72ba03e317f3d228$export$b34b069eff244586})`,
                        fill: "var(--ds-text-danger, #000)"
                    },
                    ...(0, (0, parcelRequire("2oS3b")).fg)('platform-component-visual-refresh') && {
                        backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
                        border: 'none',
                        alignItems: 'center',
                        justifyContent: 'center',
                        alignSelf: 'center',
                        appearance: 'none',
                        borderRadius: "var(--ds-border-radius, 4px)",
                        color: "var(--ds-text, #172B4D)",
                        padding: "var(--ds-space-025, 2px)",
                        marginRight: "var(--ds-space-025, 2px)",
                        ':focus-visible': {
                            outlineOffset: "var(--ds-space-negative-025, -2px)"
                        },
                        ':hover': {
                            backgroundColor: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
                        },
                        ':active': {
                            backgroundColor: "var(--ds-background-neutral-subtle-pressed, #091E4224)"
                        }
                    }
                }),
            groupHeading: (css)=>({
                    ...css,
                    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                    color: `var(--ds-text-subtle, ${0, $72ba03e317f3d228$export$f563ee71e9ee74cd})`,
                    fontWeight: `${"var(--ds-font-weight-bold, 700)"} !important`,
                    textTransform: 'none'
                })
        };
    }
});
parcelRegister("HFUaQ", function(module, exports) {
    $parcel$export(module.exports, "onFocus", ()=>$79b4bf05f1ff4469$export$ecf9bf35ad97eb74);
    $parcel$export(module.exports, "isOptionsGrouped", ()=>$79b4bf05f1ff4469$export$d2756249f53f9f8);
    $parcel$export(module.exports, "countAllOptions", ()=>$79b4bf05f1ff4469$export$8ee33f304118fce4);
    function $79b4bf05f1ff4469$export$ecf9bf35ad97eb74(onFocusProps, defaultOptions) {
        const { focused: focused } = onFocusProps;
        const isOptionFocused = (option)=>{
            return option.label === focused.label;
        };
        const groupData = defaultOptions?.find((option)=>{
            return option.options?.some(isOptionFocused);
        });
        const groupOptionIndex = groupData?.options.findIndex(isOptionFocused) ?? 0;
        return `Option ${focused.label}, ${groupData?.label} group, item ${groupOptionIndex + 1} out of ${groupData?.options.length}. All in all `;
    }
    const $79b4bf05f1ff4469$export$d2756249f53f9f8 = (arr)=>{
        return arr?.every((obj)=>obj.hasOwnProperty('options'));
    };
    const $79b4bf05f1ff4469$export$8ee33f304118fce4 = (groupsArray)=>{
        const totalLength = groupsArray?.reduce((acc, currentGroup)=>{
            const group = currentGroup;
            acc += group?.options?.length;
            return acc;
        }, 0);
        return totalLength;
    };
});
parcelRegister("3RqVj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d11f08b766d05255$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6Ll2T;
    var $99gde;
    var $6EaIJ;
    const $d11f08b766d05255$var$IssueCard = ({ issueType: issueType, issueKey: issueKey, issueSummary: issueSummary, iconUrl: iconUrl, tooltipProps: tooltipProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            xcss: $d11f08b766d05255$var$issueCardStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6EaIJ")).default), {
            tooltipProps: tooltipProps,
            issueType: issueType,
            issueKey: issueKey,
            issueSummary: issueSummary,
            iconUrl: iconUrl
        }));
    const $d11f08b766d05255$var$issueCardStyles = (0, (0, parcelRequire("99gde")).xcss)({
        backgroundColor: 'elevation.surface.raised',
        padding: 'space.100',
        paddingLeft: 'space.150',
        paddingRight: 'space.150',
        boxShadow: 'elevation.shadow.raised',
        borderRadius: 'border.radius'
    });
    var $d11f08b766d05255$export$2e2bcd8739ae039 = $d11f08b766d05255$var$IssueCard;
});
parcelRegister("6EaIJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$8ec6c1f05c370c71$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $6jrGg;
    var $6Ll2T;
    var $99gde;
    const $8ec6c1f05c370c71$var$IssueInfo = ({ issueType: issueType, issueKey: issueKey, issueSummary: issueSummary, iconUrl: iconUrl, tooltipProps: tooltipProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            ...tooltipProps,
            xcss: $8ec6c1f05c370c71$var$issueInfoStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("img", {
            src: iconUrl,
            alt: issueType
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6jrGg")).default), {
            size: "xxsmall",
            as: "span"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            as: "span",
            xcss: $8ec6c1f05c370c71$var$noWrapStyles
        }, issueKey)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            as: "span",
            xcss: $8ec6c1f05c370c71$var$issueSummaryStyles
        }, issueSummary));
    const $8ec6c1f05c370c71$var$issueInfoStyles = (0, (0, parcelRequire("99gde")).xcss)({
        display: 'flex',
        alignItems: 'center',
        gap: 'space.100'
    });
    const $8ec6c1f05c370c71$var$issueSummaryStyles = (0, (0, parcelRequire("99gde")).xcss)({
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis'
    });
    const $8ec6c1f05c370c71$var$noWrapStyles = (0, (0, parcelRequire("99gde")).xcss)({
        whiteSpace: 'nowrap'
    });
    var $8ec6c1f05c370c71$export$2e2bcd8739ae039 = $8ec6c1f05c370c71$var$IssueInfo;
});
parcelRegister("eLoZY", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5d6788c7bb5f5a63$export$2e2bcd8739ae039);
    var $7VHMR;
    var $5d6788c7bb5f5a63$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        modalLabel: {
            "id": "roadmap.timeline-table-kit.edit-dependency-modal.modal-label",
            "defaultMessage": "Link to related work. Current issue: {issueType} {issueKey} {issueSummary}. {isLoading}"
        },
        isLoadingLabel: {
            "id": "roadmap.timeline-table-kit.edit-dependency-modal.is-loading-label",
            "defaultMessage": "Issue links are loading."
        },
        finishedLoadingLabel: {
            "id": "roadmap.timeline-table-kit.edit-dependency-modal.finished-loading-label",
            "defaultMessage": "Finished loading issue links."
        },
        title: {
            "id": "roadmap.timeline-table-kit.edit-dependency-modal.title",
            "defaultMessage": "Link to related work"
        },
        description: {
            "id": "roadmap.timeline-table-kit.edit-dependency-modal.description",
            "defaultMessage": "Connect issues to indicate the order in which they need to be done."
        },
        selectedIssueLabel: {
            "id": "roadmap.timeline-table-kit.edit-dependency-modal.selected-issue-label",
            "defaultMessage": "This issue"
        },
        linkedIssuesLabel: {
            "id": "roadmap.timeline-table-kit.edit-dependency-modal.linked-issues-label",
            "defaultMessage": "Linked issues"
        },
        blocks: {
            "id": "roadmap.timeline-table-kit.edit-dependency-modal.blocks",
            "defaultMessage": "Blocks"
        },
        blockedBy: {
            "id": "roadmap.timeline-table-kit.edit-dependency-modal.blocked-by",
            "defaultMessage": "Is blocked by"
        },
        linkIssueLabel: {
            "id": "roadmap.timeline-table-kit.edit-dependency-modal.link-issue-label",
            "defaultMessage": "Link issue"
        },
        linkTypePlaceholder: {
            "id": "roadmap.timeline-table-kit.edit-dependency-modal.link-type-placeholder",
            "defaultMessage": "Select link type"
        },
        selectLabel: {
            "id": "roadmap.timeline-table-kit.edit-dependency-modal.select-label",
            "defaultMessage": "Create new link"
        },
        selectIssuePlaceholder: {
            "id": "roadmap.timeline-table-kit.edit-dependency-modal.select-issue-placeholder",
            "defaultMessage": "Select an issue"
        },
        add: {
            "id": "roadmap.timeline-table-kit.edit-dependency-modal.add",
            "defaultMessage": "Link"
        },
        addAriaLabel: {
            "id": "roadmap.timeline-table-kit.edit-dependency-modal.add-aria-label",
            "defaultMessage": "Add link"
        },
        close: {
            "id": "roadmap.timeline-table-kit.edit-dependency-modal.close",
            "defaultMessage": "Close"
        },
        closeIconLabel: {
            "id": "roadmap.timeline-table-kit.edit-dependency-modal.close-icon-label",
            "defaultMessage": "Close modal"
        },
        warning: {
            "id": "roadmap.timeline-table-kit.edit-dependency-modal.warning",
            "defaultMessage": "Warning"
        },
        issueInfoLabel: {
            "id": "roadmap.timeline-table-kit.edit-dependency-modal.issue-info-label",
            "defaultMessage": "Issue {issueType} {issueKey} {issueSummary}"
        },
        errorMessage: {
            "id": "roadmap.timeline-table-kit.edit-dependency-modal.error-message",
            "defaultMessage": "Warning: {error}"
        },
        fixedWarnings: {
            "id": "roadmap.timeline-table-kit.edit-dependency-modal.fixed-warnings",
            "defaultMessage": "No more warnings"
        },
        modalLabelIssueTermRefresh: {
            "id": "roadmap.timeline-table-kit.edit-dependency-modal.modal-label-issue-term-refresh",
            "defaultMessage": "Link to related work. Current work item: {issueType} {issueKey} {issueSummary}. {isLoading}"
        },
        isLoadingLabelIssueTermRefresh: {
            "id": "roadmap.timeline-table-kit.edit-dependency-modal.is-loading-label-issue-term-refresh",
            "defaultMessage": "Work item links are loading."
        },
        finishedLoadingLabelIssueTermRefresh: {
            "id": "roadmap.timeline-table-kit.edit-dependency-modal.finished-loading-label-issue-term-refresh",
            "defaultMessage": "Finished loading work item links."
        },
        descriptionIssueTermRefresh: {
            "id": "roadmap.timeline-table-kit.edit-dependency-modal.description-issue-term-refresh",
            "defaultMessage": "Link work items to connect work between software and <a>business projects</a>, and other project types in Jira."
        },
        selectedIssueLabelIssueTermRefresh: {
            "id": "roadmap.timeline-table-kit.edit-dependency-modal.selected-issue-label-issue-term-refresh",
            "defaultMessage": "This work item"
        },
        linkedIssuesLabelIssueTermRefresh: {
            "id": "roadmap.timeline-table-kit.edit-dependency-modal.linked-issues-label-issue-term-refresh",
            "defaultMessage": "Linked work items"
        },
        linkIssueLabelIssueTermRefresh: {
            "id": "roadmap.timeline-table-kit.edit-dependency-modal.link-issue-label-issue-term-refresh",
            "defaultMessage": "Link work item"
        },
        selectIssuePlaceholderIssueTermRefresh: {
            "id": "roadmap.timeline-table-kit.edit-dependency-modal.select-issue-placeholder-issue-term-refresh",
            "defaultMessage": "Select a work item"
        },
        issueInfoLabelIssueTermRefresh: {
            "id": "roadmap.timeline-table-kit.edit-dependency-modal.issue-info-label-issue-term-refresh",
            "defaultMessage": "Work item {issueType} {issueKey} {issueSummary}"
        }
    });
});
parcelRegister("kKx5I", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$480eefecb8063c16$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $42Si9;
    var $dxJhf;
    var $6s1PB;
    var $koVbs;
    var $bkUsp;
    var $2ItYN;
    const $480eefecb8063c16$var$UnlinkDependencyButton = (0, $5uXOq.forwardRef)(({ dependency: dependency, onUnlinkDependency: onUnlinkDependency, focusNextUnlinkButton: focusNextUnlinkButton }, ref)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { issueType: issueType, issueKey: issueKey, issueSummary: issueSummary, link: link } = dependency;
        const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
        const onClick = (0, $5uXOq.useCallback)(async (event, analyticsEvent)=>{
            focusNextUnlinkButton();
            setIsLoading(true);
            await onUnlinkDependency({
                dependency: dependency,
                event: event,
                analyticsEvent: analyticsEvent
            });
            setIsLoading(false);
        }, [
            dependency,
            focusNextUnlinkButton,
            onUnlinkDependency
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42Si9")).default), {
            ref: ref,
            iconBefore: (0, ($parcel$interopDefault((0, parcelRequire("dxJhf"))))),
            isLoading: isLoading,
            appearance: "subtle",
            onClick: onClick,
            interactionName: "timeline-edit-dependency-unlink-clicked",
            "aria-label": formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("2ItYN")).default).unlinkAriaLabelIssueTermRefresh : (0, (0, parcelRequire("2ItYN")).default).unlinkAriaLabel, {
                issueType: issueType,
                issueKey: issueKey,
                issueSummary: issueSummary,
                linkType: link === (0, (0, parcelRequire("bkUsp")).OUTWARD_LINK_DIRECTION) ? formatMessage((0, (0, parcelRequire("2ItYN")).default).blocks) : formatMessage((0, (0, parcelRequire("2ItYN")).default).blockedBy)
            })
        }, formatMessage((0, (0, parcelRequire("2ItYN")).default).unlink));
    });
    var $480eefecb8063c16$export$2e2bcd8739ae039 = $480eefecb8063c16$var$UnlinkDependencyButton;
});
parcelRegister("2ItYN", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d60584a8611b94d6$export$2e2bcd8739ae039);
    var $7VHMR;
    var $d60584a8611b94d6$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        blocks: {
            "id": "roadmap.timeline-table-kit.edit-dependency-modal.unlink-dependency-button.blocks",
            "defaultMessage": "Blocks"
        },
        blockedBy: {
            "id": "roadmap.timeline-table-kit.edit-dependency-modal.unlink-dependency-button.blocked-by",
            "defaultMessage": "Is blocked by"
        },
        unlink: {
            "id": "roadmap.timeline-table-kit.edit-dependency-modal.unlink-dependency-button.unlink",
            "defaultMessage": "Unlink"
        },
        unlinkAriaLabel: {
            "id": "roadmap.timeline-table-kit.edit-dependency-modal.unlink-dependency-button.unlink-aria-label",
            "defaultMessage": "Unlink dependency, Current issue {linkType} Issue {issueType} {issueKey} {issueSummary}"
        },
        unlinkAriaLabelIssueTermRefresh: {
            "id": "roadmap.timeline-table-kit.edit-dependency-modal.unlink-dependency-button.unlink-aria-label-issue-term-refresh",
            "defaultMessage": "Unlink dependency, Current work item {linkType} Work item {issueType} {issueKey} {issueSummary}"
        }
    });
});
parcelRegister("kxC7J", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$53adfbe86c60ccb3$export$2e2bcd8739ae039);
    var $7VHMR;
    var $53adfbe86c60ccb3$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        timelineHeading: {
            "id": "business-timeline.timeline-view.timeline-heading",
            "defaultMessage": "Timeline"
        },
        inlineCreateErrorTitle: {
            "id": "business-timeline.timeline-view.inline-create-error-title",
            "defaultMessage": "Failed to create an item."
        },
        inlineCreateErrorDescription: {
            "id": "business-timeline.timeline-view.inline-create-error-description",
            "defaultMessage": "We were not able to create the item. Try again with the create button."
        },
        loadingMoreItems: {
            "id": "business-timeline.timeline-view.loading-more-items",
            "defaultMessage": "Loading more items..."
        },
        createDependencyErrorTitle: {
            "id": "business-timeline.timeline-view.create-dependency-error-title",
            "defaultMessage": "We couldn't link items."
        },
        createDependencyErrorMessage: {
            "id": "business-timeline.timeline-view.create-dependency-error-message",
            "defaultMessage": "Check your connection, then give it another try."
        },
        startDateMissingErrorTitle: {
            "id": "business-timeline.timeline-view.start-date-missing-error-title",
            "defaultMessage": "We couldn't save the item."
        },
        startDateMissingErrorMessage: {
            "id": "business-timeline.timeline-view.start-date-missing-error-message",
            "defaultMessage": "Field 'Start date' cannot be set. It is not on the appropriate screen."
        }
    });
});
parcelRegister("dupdF", function(module, exports) {
    $parcel$export(module.exports, "StickyInlineCreate", ()=>$0deff68b706a68c9$export$22baec6f8784b075);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $34ck9 = parcelRequire("34ck9");
    var $eNaDQ;
    var $iFFYo;
    var $kI8fv;
    var $4R6GH;
    var $5Xbjf;
    var $g3prf;
    var $l8ruj;
    var $dCm1o;
    var $gNAqw;
    var $1o48H;
    var $1lN06;
    var $u2fd8;
    var $4rVoq;
    const $0deff68b706a68c9$var$inlineCreateStyles = (height)=>({
            horizontalPadding: `${"var(--ds-space-100, 8px)"} 0 ${"var(--ds-space-150, 12px)"}`,
            minHeight: `${height - 1}px`
        });
    const $0deff68b706a68c9$var$inlineCreateStylesOld = (height)=>({
            horizontalPadding: `${"var(--ds-space-100, 8px)"} 0 ${"var(--ds-space-250, 20px)"}`,
            minHeight: `${height - 1}px`,
            borderRadius: `0 0 0 ${"var(--ds-border-radius-200, 8px)"}`
        });
    const $0deff68b706a68c9$export$22baec6f8784b075 = ({ issuesMap: issuesMap, loading: loading, listWidth: listWidth, height: height, items: items, expandedItems: expandedItems, timelineRef: timelineRef })=>{
        const [{ createItemAnchor: createItemAnchor }] = (0, (0, parcelRequire("1lN06")).useCreateItemAnchor)();
        const [{ headerHeight: headerHeight }] = (0, (0, parcelRequire("g3prf")).useHeaderState)();
        const [containerHeight, setContainerHeight] = (0, $5uXOq.useState)(()=>(timelineRef?.offsetHeight || 0) - headerHeight);
        const { addOptimisticIssue: addOptimisticIssue, updateIssue: updateIssue, removeOptimisticIssue: removeOptimisticIssue } = (0, (0, parcelRequire("u2fd8")).useOptimisticIssueCreate)();
        const isEmpty = items.length === 0;
        const onPrepareIssueContext = (0, $5uXOq.useCallback)(()=>{
            const issue = (0, (0, parcelRequire("4rVoq")).getIssueAfter)(containerHeight, expandedItems, height, issuesMap, items, timelineRef);
            if (!issue || !issue.rank) return {};
            return {
                rankAfter: {
                    issueId: issue.issueId,
                    rank: issue.rank
                }
            };
        }, [
            containerHeight,
            expandedItems,
            height,
            issuesMap,
            items,
            timelineRef
        ]);
        const { sticky: sticky, offsetTop: offsetTop } = (0, $5uXOq.useMemo)(()=>{
            const itemsHeight = (0, (0, parcelRequire("1o48H")).getTimelineTableItemsHeight)(items, expandedItems, height);
            const isSticky = itemsHeight + height > containerHeight;
            const createItemAnchorOffset = !isSticky && createItemAnchor ? height : 0;
            return {
                sticky: isSticky,
                offsetTop: itemsHeight + createItemAnchorOffset + headerHeight
            };
        }, [
            containerHeight,
            createItemAnchor,
            height,
            items,
            expandedItems,
            headerHeight
        ]);
        const throttledUpdateContainerHeight = (0, $5uXOq.useMemo)(()=>(0, ($parcel$interopDefault($34ck9)))(()=>{
                if (!timelineRef) return;
                setContainerHeight((timelineRef?.offsetHeight || 0) - headerHeight);
            }, 100), [
            headerHeight,
            timelineRef
        ]);
        (0, (0, parcelRequire("kI8fv")).useResizeObserver)(timelineRef ?? null, throttledUpdateContainerHeight);
        const onSubmit = (0, $5uXOq.useCallback)(async ({ optimisticIssuePayload: optimisticIssuePayload, promise: promise })=>{
            addOptimisticIssue(optimisticIssuePayload);
            try {
                const issue = await promise;
                if (issue) updateIssue(issue);
                else removeOptimisticIssue(optimisticIssuePayload.issueId, optimisticIssuePayload.parentIssueId);
            } catch  {
                removeOptimisticIssue(optimisticIssuePayload.issueId, optimisticIssuePayload.parentIssueId);
            }
        }, [
            addOptimisticIssue,
            updateIssue,
            removeOptimisticIssue
        ]);
        if (loading || !timelineRef) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "business-timeline-sticky-inline-create"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($0deff68b706a68c9$var$Wrapper, {
            width: listWidth,
            height: height,
            sticky: sticky,
            offsetTop: offsetTop
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5Xbjf")).TimelineAddItemNudgeAsync), {
            attributes: {
                isEmpty: isEmpty
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("eNaDQ")).default), {
            appearance: (0, (0, parcelRequire("iFFYo")).ROW_APPEARANCE),
            fieldIdsToReturn: (0, (0, parcelRequire("gNAqw")).fieldIds),
            inlineCreateStyles: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_eap_drop_2') ? {
                ...$0deff68b706a68c9$var$inlineCreateStyles(height),
                ...(0, (0, parcelRequire("4R6GH")).fg)('visual-refresh_drop_1') ? {} : {
                    borderRadius: `0 0 0 ${"var(--ds-border-radius-200, 8px)"}`
                }
            } : $0deff68b706a68c9$var$inlineCreateStylesOld(height),
            isCompact: true,
            location: "timelineFooter",
            onPrepareIssueContext: onPrepareIssueContext,
            onSubmit: onSubmit
        }))));
    };
    const $0deff68b706a68c9$var$BORDER_OFFSET = 4;
    const $0deff68b706a68c9$var$wrapperBaseStyles = null;
    const $0deff68b706a68c9$var$wrapperStickyStyles = null;
    const $0deff68b706a68c9$var$wrapperStickyStylesOld = null;
    const $0deff68b706a68c9$var$Wrapper = ({ sticky: sticky, offsetTop: offsetTop, width: width, height: height, children: children, ...rest })=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            style: {
                top: sticky ? 'auto' : `${offsetTop}px`,
                height: `${height - 1}px`,
                width: `${width - $0deff68b706a68c9$var$BORDER_OFFSET}px`
            },
            ...rest,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_11q7vuon _kqswstnw _1ltvv77o _1pbyzo7u _1yt4ze3t _2rkoidpf _x3doqvwq _n7zl1lnu _1e0c1txw _4cvr1h6o _bhl91osq",
                (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('visual-refresh_drop_1') ? "_94n51i6y" : "_2rko6iej _94n51i6y"
            ])
        }, children);
});
parcelRegister("eNaDQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c99115eac966aea2$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1T2vX;
    var $4R6GH;
    var $iFFYo;
    var $9hZ86;
    const $c99115eac966aea2$var$emptyArray = [];
    const $c99115eac966aea2$var$InlineCreate = ({ allowedIssueTypeIds: allowedIssueTypeIds, appearance: appearance, fieldIdsToReturn: fieldIdsToReturn, inlineCreateStyles: inlineCreateStyles, isCompact: isCompact, location: location, maxHierarchyLevel: maxHierarchyLevel, minHierarchyLevel: minHierarchyLevel, onBlur: onBlur, onPrepareIssueContext: onPrepareIssueContext, onSubmit: onSubmit, onToggleForm: onToggleForm, isOpenByDefault: isOpenByDefault = false, popperStrategy: popperStrategy })=>{
        const [isFormVisible, setIsFormVisible] = (0, $5uXOq.useState)(isOpenByDefault);
        const issueTypes = (0, (0, parcelRequire("4R6GH")).fg)('fun-1256_handle_available_fields_load_in_ic_2') ? $c99115eac966aea2$var$emptyArray : (0, (0, parcelRequire("1T2vX")).useIssueTypesAndFields)({
            issueOperation: 'CREATE'
        }).data.issueTypes;
        const showForm = (0, $5uXOq.useCallback)(()=>{
            setIsFormVisible(true);
            onToggleForm?.(true);
        }, [
            onToggleForm
        ]);
        const hideForm = (0, $5uXOq.useCallback)(()=>{
            setIsFormVisible(false);
            onToggleForm?.(false);
        }, [
            onToggleForm
        ]);
        const handleBlur = (0, $5uXOq.useCallback)(()=>{
            hideForm();
            onBlur?.();
        }, [
            hideForm,
            onBlur
        ]);
        const isInlineCreateFormVisible = (0, (0, parcelRequire("4R6GH")).fg)('fun-1256_handle_available_fields_load_in_ic_2') ? isFormVisible : (0, (0, parcelRequire("4R6GH")).fg)('jira_one_screen_onboarding_feature_gate') ? isFormVisible && issueTypes.length > 0 : isFormVisible;
        return isInlineCreateFormVisible ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iFFYo")).default), {
            allowedIssueTypeIds: allowedIssueTypeIds,
            appearance: appearance,
            fieldIdsToReturn: fieldIdsToReturn,
            isCompact: isCompact,
            location: location,
            maxHierarchyLevel: maxHierarchyLevel,
            minHierarchyLevel: minHierarchyLevel,
            onBlur: handleBlur,
            onPrepareIssueContext: onPrepareIssueContext,
            onSubmit: onSubmit,
            popperStrategy: popperStrategy,
            ...inlineCreateStyles
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9hZ86")).default), {
            onClick: showForm,
            isDisabled: !(0, (0, parcelRequire("4R6GH")).fg)('fun-1256_handle_available_fields_load_in_ic_2') && issueTypes.length === 0,
            ...inlineCreateStyles
        });
    };
    const $c99115eac966aea2$var$genericMemo = (0, $5uXOq.memo);
    var $c99115eac966aea2$export$2e2bcd8739ae039 = $c99115eac966aea2$var$genericMemo($c99115eac966aea2$var$InlineCreate);
});
parcelRegister("iFFYo", function(module, exports) {
    $parcel$export(module.exports, "CARD_APPEARANCE", ()=>$da27b835be8eb6e3$export$2e234a0f40160716);
    $parcel$export(module.exports, "ROW_APPEARANCE", ()=>$da27b835be8eb6e3$export$e99c52f52501386d);
    $parcel$export(module.exports, "default", ()=>$da27b835be8eb6e3$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $2APCZ;
    var $42Si9;
    var $9jNMw;
    var $cSXhT;
    var $h8Wzd;
    var $3srSR;
    var $ZuPvl;
    var $99gde;
    var $2JKLA;
    var $3t0PE;
    var $113Tq;
    var $loZC0;
    var $daQYX;
    var $1T2vX;
    var $cm8b5;
    var $dkvNx;
    var $x8FYU;
    var $1kpI8;
    var $6s1PB;
    var $4R6GH;
    var $koVbs;
    var $8zOmE;
    var $lwMsT;
    var $dCm1o;
    var $hDzhb;
    var $8OpiR;
    var $8roPX;
    var $cLGgz;
    var $6uB1c;
    var $t9aRF;
    const $da27b835be8eb6e3$var$GENERIC_ICON_URL = '/icons/issuetypes/genericissue.svg';
    const $da27b835be8eb6e3$export$2e234a0f40160716 = 'CARD';
    const $da27b835be8eb6e3$export$e99c52f52501386d = 'ROW';
    const $da27b835be8eb6e3$var$LINK = 'link';
    const $da27b835be8eb6e3$var$ISSUE_TYPE = 'issueType';
    const $da27b835be8eb6e3$var$BUTTON = 'button';
    const $da27b835be8eb6e3$var$useExperience = (location)=>(0, $5uXOq.useMemo)(()=>{
            let experienceId;
            switch(location){
                case 'listFooter':
                case 'listSibling':
                case 'listGroup':
                case 'listHierarchy':
                    experienceId = 'list';
                    break;
                case 'boardFooter':
                case 'boardSibling':
                    experienceId = 'board';
                    break;
                case 'calendarDate':
                    experienceId = 'calendar';
                    break;
                case 'timelineFooter':
                case 'timelineSibling':
                case 'timelineHierarchy':
                    experienceId = 'timeline';
                    break;
                default:
                    throw new Error(`Unknown location ${location}`);
            }
            return {
                ...(0, (0, parcelRequire("8OpiR")).CREATE_ISSUE_EXPERIENCE),
                experienceId: experienceId
            };
        }, [
            location
        ]);
    const $da27b835be8eb6e3$var$Option = ({ children: children, ...props })=>{
        if (props.data.optionType === $da27b835be8eb6e3$var$ISSUE_TYPE) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2JKLA")).components).Option, props, (0, ($parcel$interopDefault($5uXOq))).createElement($da27b835be8eb6e3$var$OptionWrapper, {
            "data-testid": "business-issue-create.ui.inline-create-form.option"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($da27b835be8eb6e3$var$OptionTypeIcon, {
            src: props.data.issueType.avatarUrl ?? $da27b835be8eb6e3$var$GENERIC_ICON_URL,
            alt: ""
        }), children));
        if (props.data.optionType === $da27b835be8eb6e3$var$BUTTON) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2JKLA")).components).Option, props, children);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($da27b835be8eb6e3$var$StyledLink, {
            href: props.data.url
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2JKLA")).components).Option, props, children));
    };
    const $da27b835be8eb6e3$var$Group = ({ children: children })=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement($da27b835be8eb6e3$var$ExtraLinksGroup, null, children);
    };
    const $da27b835be8eb6e3$var$OptionOld = ({ children: children, ...props })=>{
        if (props.data.optionType === $da27b835be8eb6e3$var$ISSUE_TYPE) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2JKLA")).components).Option, props, (0, ($parcel$interopDefault($5uXOq))).createElement($da27b835be8eb6e3$var$OptionWrapper, {
            "data-testid": "business-issue-create.ui.inline-create-form.option"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($da27b835be8eb6e3$var$OptionTypeIcon, {
            src: props.data.issueType.avatarUrl ?? $da27b835be8eb6e3$var$GENERIC_ICON_URL,
            alt: ""
        }), children));
        return (0, ($parcel$interopDefault($5uXOq))).createElement($da27b835be8eb6e3$var$ExtraLinksGroup, null, (0, ($parcel$interopDefault($5uXOq))).createElement($da27b835be8eb6e3$var$StyledLink, {
            href: props.data.url
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2JKLA")).components).Option, props, children)));
    };
    const $da27b835be8eb6e3$export$35cad9398ceaeef0 = ()=>{
        const isReadyRef = (0, $5uXOq.useRef)(false);
        (0, $5uXOq.useEffect)(()=>{
            setTimeout(()=>{
                isReadyRef.current = true;
            }, 100);
        }, []);
        return isReadyRef;
    };
    const $da27b835be8eb6e3$var$isComposing = (event)=>event.nativeEvent.isComposing;
    const $da27b835be8eb6e3$var$ChevronDownIcon = ()=>{
        if ((0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)()) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("h8Wzd"))))), {
            label: "",
            color: "var(--ds-icon, #44546F)"
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("cSXhT"))))), {
            label: ""
        });
    };
    const $da27b835be8eb6e3$var$InlineCreateForm = ({ allowedIssueTypeIds: allowedIssueTypeIds, appearance: appearance, borderRadius: borderRadius, fieldIdsToReturn: fieldIdsToReturn = [], indent: indent, isCompact: isCompact, location: location, maxHierarchyLevel: maxHierarchyLevel = Number.POSITIVE_INFINITY, minHeight: minHeight, minHierarchyLevel: minHierarchyLevel = 0, onBlur: onBlur, onPrepareIssueContext: onPrepareIssueContext, onSubmit: onSubmit, popperStrategy: popperStrategy = 'absolute' })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { data: { issueTypes: issueTypes }, loading: loading } = (0, (0, parcelRequire("1T2vX")).useIssueTypesAndFields)({
            issueOperation: 'CREATE'
        });
        if (loading) return (0, ($parcel$interopDefault($5uXOq))).createElement($da27b835be8eb6e3$var$FullContent, {
            appearance: appearance,
            borderRadius: borderRadius,
            indent: indent,
            minHeight: minHeight
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3srSR")).default), {
            alignItems: "center",
            justifyContent: "center",
            xcss: $da27b835be8eb6e3$var$spinnerWrapperStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("113Tq")).default), {
            label: formatMessage((0, (0, parcelRequire("6uB1c")).default).loadingIssueCreateForm)
        })));
        if (issueTypes.length === 0) throw new Error('Unable to show the issue create form, no issue types available');
        return (0, ($parcel$interopDefault($5uXOq))).createElement($da27b835be8eb6e3$var$InlineCreateFormInternal, {
            allowedIssueTypeIds: allowedIssueTypeIds,
            appearance: appearance,
            borderRadius: borderRadius,
            fieldIdsToReturn: fieldIdsToReturn,
            indent: indent,
            isCompact: isCompact,
            issueTypes: issueTypes,
            location: location,
            maxHierarchyLevel: maxHierarchyLevel,
            minHeight: minHeight,
            minHierarchyLevel: minHierarchyLevel,
            onBlur: onBlur,
            onPrepareIssueContext: onPrepareIssueContext,
            onSubmit: onSubmit,
            popperStrategy: popperStrategy
        });
    };
    const $da27b835be8eb6e3$var$InlineCreateFormInternal = ({ allowedIssueTypeIds: allowedIssueTypeIds, appearance: appearance, borderRadius: borderRadius, fieldIdsToReturn: fieldIdsToReturn = [], indent: indent, isCompact: isCompact, issueTypes: issueTypesProp, location: location, maxHierarchyLevel: maxHierarchyLevel = Number.POSITIVE_INFINITY, minHeight: minHeight, minHierarchyLevel: minHierarchyLevel = 0, onBlur: onBlur, onPrepareIssueContext: onPrepareIssueContext, onSubmit: onSubmit, popperStrategy: popperStrategy = 'absolute' })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const issueTypes = (0, (0, parcelRequire("4R6GH")).fg)('fun-1256_handle_available_fields_load_in_ic_2') ? issueTypesProp : (0, (0, parcelRequire("1T2vX")).useIssueTypesAndFields)({
            issueOperation: 'CREATE'
        }).data.issueTypes;
        const project = (0, (0, parcelRequire("daQYX")).useProject)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const [filter] = (0, (0, parcelRequire("1kpI8")).useViewPreference)((0, (0, parcelRequire("x8FYU")).FILTER_PREFERENCE));
        const [sorting] = (0, (0, parcelRequire("1kpI8")).useViewPreference)((0, (0, parcelRequire("x8FYU")).SORTING_PREFERENCE));
        const [preferredIssueTypeId, savePreferredIssueTypeId] = (0, (0, parcelRequire("1kpI8")).useViewPreference)((0, (0, parcelRequire("x8FYU")).CREATE_TYPE_ID_PREFERENCE));
        const showSuccessFlag = filter != null || sorting != null;
        const experience = $da27b835be8eb6e3$var$useExperience(location);
        const startExperience = (0, (0, parcelRequire("cm8b5")).useExperienceStart)(experience);
        const markExperienceSuccess = (0, (0, parcelRequire("cm8b5")).useExperienceSuccess)(experience);
        const markExperienceFail = (0, (0, parcelRequire("cm8b5")).useExperienceFail)(experience);
        const abortExperience = (0, (0, parcelRequire("cm8b5")).useExperienceAbort)(experience);
        const issueTypeOptions = (0, $5uXOq.useMemo)(()=>{
            const validIssueTypes = issueTypes.filter((issueType)=>{
                const isAllowed = allowedIssueTypeIds?.includes(issueType.id) ?? true;
                return isAllowed && issueType.hierarchyLevel >= minHierarchyLevel && issueType.hierarchyLevel <= maxHierarchyLevel;
            });
            const typeOptions = validIssueTypes.map((issueType)=>({
                    label: issueType.name,
                    value: issueType.id,
                    issueType: issueType,
                    optionType: $da27b835be8eb6e3$var$ISSUE_TYPE
                }));
            typeOptions.sort((a, b)=>b.issueType.hierarchyLevel - a.issueType.hierarchyLevel);
            return typeOptions;
        }, [
            allowedIssueTypeIds,
            issueTypes,
            maxHierarchyLevel,
            minHierarchyLevel
        ]);
        const options = (0, $5uXOq.useMemo)(()=>{
            const canManageTypes = project.permissions.administerProject;
            const manageIssueTypesLink = (0, (0, parcelRequire("dkvNx")).getIssueTypesSettingsUrl)(project.key, project.isSimplified);
            const [expConfig] = (0, (0, parcelRequire("6s1PB")).UNSAFE_noExposureExp)('jsw_inline_issuetype_creation_list_view');
            if (expConfig.get('isInlineIssueTypesEnabled', false)) {
                if (canManageTypes) {
                    const actionOptions = [];
                    if (project.isSimplified) {
                        const createTypeOption = {
                            label: formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("6uB1c")).default).createIssueTypesIssueTermRefresh : (0, (0, parcelRequire("6uB1c")).default).createIssueTypes),
                            optionType: $da27b835be8eb6e3$var$BUTTON
                        };
                        actionOptions.push(createTypeOption);
                    }
                    const manageTypesOption = {
                        label: formatMessage((0, (0, parcelRequire("6uB1c")).default).manageIssueTypes),
                        value: manageIssueTypesLink,
                        url: manageIssueTypesLink,
                        optionType: $da27b835be8eb6e3$var$LINK
                    };
                    actionOptions.push(manageTypesOption);
                    return [
                        ...issueTypeOptions,
                        {
                            options: [
                                ...actionOptions
                            ]
                        }
                    ];
                }
                return [
                    ...issueTypeOptions
                ];
            }
            let manageTypesOption = null;
            if (canManageTypes) {
                manageTypesOption = {
                    label: formatMessage((0, (0, parcelRequire("6uB1c")).default).manageIssueTypes),
                    value: manageIssueTypesLink,
                    url: manageIssueTypesLink,
                    optionType: $da27b835be8eb6e3$var$LINK
                };
                return [
                    ...issueTypeOptions,
                    manageTypesOption
                ];
            }
            return [
                ...issueTypeOptions
            ];
        }, [
            formatMessage,
            issueTypeOptions,
            project
        ]);
        const { summaryRef: summaryRef, submit: submit, blur: blur } = (0, (0, parcelRequire("cLGgz")).useCreateIssue)(onSubmit, onBlur);
        const [selectedType, setSelectedType] = (0, $5uXOq.useState)(()=>{
            if (preferredIssueTypeId) {
                const defaultIssueType = issueTypeOptions.find((issueType)=>issueType.value === preferredIssueTypeId);
                if (defaultIssueType) return defaultIssueType;
            }
            if (minHierarchyLevel === 0) return issueTypeOptions.find((option)=>option.issueType.hierarchyLevel === 0) ?? options[0];
            return options[0];
        });
        const [textContent, setTextContent] = (0, $5uXOq.useState)(summaryRef.current);
        summaryRef.current = textContent;
        const formRef = (0, $5uXOq.useRef)(null);
        const popperRef = (0, $5uXOq.useRef)(null);
        const isEmptyRef = (0, $5uXOq.useRef)(true);
        const textAreaRef = (0, $5uXOq.useRef)(null);
        isEmptyRef.current = textContent.trim().length === 0;
        const handleCreateIssue = ()=>{
            if (!isEmptyRef.current && selectedType.optionType === $da27b835be8eb6e3$var$ISSUE_TYPE) {
                const issueType = issueTypes.find((type)=>type.id === selectedType.value);
                startExperience();
                const result = submit({
                    input: {
                        summary: textContent.trim(),
                        projectId: String(project.id),
                        issueType: issueType,
                        ...onPrepareIssueContext?.()
                    },
                    fieldIdsToReturn: fieldIdsToReturn,
                    location: location,
                    showSuccessFlag: showSuccessFlag
                });
                setTextContent('');
                result.promise.then(()=>markExperienceSuccess()).catch((error)=>{
                    if (error instanceof (0, (0, parcelRequire("8roPX")).CancelledError)) abortExperience('User cancelled');
                    else markExperienceFail('Failed to create issue', error);
                });
            }
        };
        const handleCreateIssueRef = (0, $5uXOq.useRef)(handleCreateIssue);
        handleCreateIssueRef.current = handleCreateIssue;
        const isReadyRef = $da27b835be8eb6e3$export$35cad9398ceaeef0();
        const handleBlur = (0, $5uXOq.useCallback)((event)=>{
            if (!isReadyRef.current) return;
            const formEmpty = isEmptyRef.current;
            const inForm = formRef.current?.contains(event.target) ?? false;
            const inPopper = popperRef.current?.contains(event.target) ?? false;
            if (!inForm && !inPopper) {
                handleCreateIssueRef.current();
                blur();
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'form blurred', 'inlineCreate', {
                    location: location,
                    formEmpty: formEmpty,
                    escapeKeyPressed: false
                });
            }
        }, [
            isReadyRef,
            blur,
            createAnalyticsEvent,
            location
        ]);
        const issueTypeButton = (0, $5uXOq.useCallback)((triggerProps)=>(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("42Si9")).default), {
                ...triggerProps,
                appearance: "subtle",
                "aria-label": formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("6uB1c")).default).selectIssueTypeButtonIssueTermRefresh : (0, (0, parcelRequire("6uB1c")).default).selectIssueTypeButton, {
                    issueType: selectedType.label
                }),
                testId: "business-issue-create.ui.inline-create-form.issue-type-trigger",
                spacing: "compact"
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3srSR")).default), {
                alignItems: "center",
                justifyContent: "center",
                gap: "space.075",
                xcss: (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_1') ? $da27b835be8eb6e3$var$issueTypeButtonStyles : $da27b835be8eb6e3$var$issueTypeButtonStylesOld
            }, (0, ($parcel$interopDefault($5uXOq))).createElement("img", {
                src: selectedType.issueType.avatarUrl ?? undefined,
                alt: "",
                height: 16,
                width: 16
            }), (0, ($parcel$interopDefault($5uXOq))).createElement($da27b835be8eb6e3$var$ChevronDownIcon, null))) : (0, ($parcel$interopDefault($5uXOq))).createElement($da27b835be8eb6e3$var$StyledButton, {
                ...triggerProps,
                "aria-label": formatMessage((0, (0, parcelRequire("6s1PB")).expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, (0, parcelRequire("6uB1c")).default).selectIssueTypeButtonIssueTermRefresh : (0, (0, parcelRequire("6uB1c")).default).selectIssueTypeButton, {
                    issueType: selectedType.label
                }),
                iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement("img", {
                    src: selectedType.issueType.avatarUrl ?? undefined,
                    alt: "",
                    height: 16,
                    width: 16
                }),
                iconAfter: isCompact ? (0, ($parcel$interopDefault($5uXOq))).createElement($da27b835be8eb6e3$var$ChevronDownWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement($da27b835be8eb6e3$var$ChevronDownIcon, null)) : (0, ($parcel$interopDefault($5uXOq))).createElement($da27b835be8eb6e3$var$ChevronDownIcon, null),
                spacing: "compact",
                testId: "business-issue-create.ui.inline-create-form.issue-type-trigger"
            }, !isCompact && selectedType.label), [
            formatMessage,
            isCompact,
            selectedType
        ]);
        (0, $5uXOq.useEffect)(()=>{
            textAreaRef.current?.setSelectionRange(textAreaRef.current.value.length, textAreaRef.current.value.length);
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'form focused', 'inlineCreate', {
                location: location
            });
        }, [
            createAnalyticsEvent,
            location
        ]);
        (0, $5uXOq.useEffect)(()=>{
            document.addEventListener('click', handleBlur, true);
            return ()=>{
                document.removeEventListener('click', handleBlur, true);
            };
        }, [
            handleBlur
        ]);
        const issueTypesSelect = (0, $5uXOq.useMemo)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3t0PE")).default), {
                onMenuOpen: ()=>{
                    (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'select opened', 'inlineCreateIssueTypes', {
                        location: location
                    });
                },
                components: {
                    Option: (0, (0, parcelRequire("6s1PB")).expVal)('jsw_inline_issuetype_creation_list_view', 'isInlineIssueTypesEnabled', false) ? $da27b835be8eb6e3$var$Option : $da27b835be8eb6e3$var$OptionOld,
                    Group: $da27b835be8eb6e3$var$Group
                },
                searchThreshold: 10,
                options: options,
                onChange: (option)=>{
                    if (option?.optionType === $da27b835be8eb6e3$var$ISSUE_TYPE) {
                        setSelectedType(option);
                        savePreferredIssueTypeId(option.value);
                    }
                },
                popperProps: {
                    strategy: popperStrategy,
                    innerRef: popperRef
                },
                value: selectedType,
                target: ({ isOpen: isOpen, ...triggerProps })=>isCompact || appearance === $da27b835be8eb6e3$export$e99c52f52501386d && (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("loZC0")).default), {
                        content: selectedType.label
                    }, issueTypeButton(triggerProps)) : issueTypeButton(triggerProps)
            }), [
            appearance,
            createAnalyticsEvent,
            isCompact,
            issueTypeButton,
            location,
            options,
            popperStrategy,
            savePreferredIssueTypeId,
            selectedType
        ]);
        const getRowHeader = (0, $5uXOq.useCallback)(()=>{
            if ((0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)()) return issueTypesSelect;
            if (!isCompact) return (0, ($parcel$interopDefault($5uXOq))).createElement($da27b835be8eb6e3$var$IssueTypeIcon, {
                alt: "",
                src: selectedType.issueType.avatarUrl ?? $da27b835be8eb6e3$var$GENERIC_ICON_URL
            });
            return null;
        }, [
            isCompact,
            issueTypesSelect,
            selectedType
        ]);
        if (!(0, (0, parcelRequire("4R6GH")).fg)('fun-1256_handle_available_fields_load_in_ic_2') && issueTypes.length === 0) return null;
        return (0, ($parcel$interopDefault($5uXOq))).createElement($da27b835be8eb6e3$var$FullContent, {
            appearance: appearance,
            borderRadius: borderRadius,
            indent: indent,
            minHeight: minHeight,
            onKeyDown: (event)=>{
                event.stopPropagation();
                if (event.key === 'Escape' && !$da27b835be8eb6e3$var$isComposing(event)) {
                    if ((0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline_table_meatballs_menu_a11y')) blur(event);
                    else blur();
                    (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'form blurred', 'inlineCreate', {
                        location: location,
                        formEmpty: isEmptyRef.current,
                        escapeKeyPressed: true
                    });
                }
            },
            onSubmit: (event)=>{
                event.preventDefault();
                handleCreateIssue();
            },
            ref: formRef
        }, appearance === $da27b835be8eb6e3$export$e99c52f52501386d && getRowHeader(), (0, ($parcel$interopDefault($5uXOq))).createElement($da27b835be8eb6e3$var$StyledTextArea, {
            appearance: appearance,
            autoFocus: true,
            "data-testid": "business-issue-create.ui.inline-create-form.textarea",
            maxLength: (0, $7462c685f739ed5a$export$193356664cd84c83),
            onChange: (event)=>{
                const content = event.target.value.replace(/[\n\r]+/g, ' ');
                setTextContent(content);
            },
            onKeyDown: (event)=>{
                if (event.key === 'Enter' && !$da27b835be8eb6e3$var$isComposing(event)) {
                    event.preventDefault();
                    handleCreateIssue();
                }
            },
            placeholder: formatMessage((0, (0, parcelRequire("6uB1c")).default).placeholderText),
            value: textContent,
            ref: textAreaRef
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($da27b835be8eb6e3$var$Footer, {
            appearance: appearance
        }, (!(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() || appearance !== $da27b835be8eb6e3$export$e99c52f52501386d) && issueTypesSelect, appearance !== $da27b835be8eb6e3$export$e99c52f52501386d && (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9jNMw")).default), {
            label: formatMessage((0, (0, parcelRequire("6uB1c")).default).createButton),
            appearance: "default",
            type: "submit",
            onClick: ()=>{
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'inlineCreateSubmit', {
                    location: location,
                    hierarchyLevel: selectedType.optionType === $da27b835be8eb6e3$var$ISSUE_TYPE ? selectedType.issueType?.hierarchyLevel : undefined
                });
            },
            isDisabled: isEmptyRef.current,
            spacing: "compact",
            icon: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ZuPvl")).default), {
                    color: "inherit",
                    weight: "medium"
                }, "\u23CE")
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement($da27b835be8eb6e3$var$StyledCreateButton, {
            appearance: "primary",
            iconAfter: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("t9aRF")).default), null),
            isDisabled: isEmptyRef.current,
            spacing: "compact",
            type: "submit",
            onClick: ()=>{
                (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'inlineCreateSubmit', {
                    location: location,
                    hierarchyLevel: selectedType.optionType === $da27b835be8eb6e3$var$ISSUE_TYPE ? selectedType.issueType?.hierarchyLevel : undefined
                });
            }
        }, formatMessage((0, (0, parcelRequire("6uB1c")).default).createButton))));
    };
    const $da27b835be8eb6e3$var$emptyArray = [];
    const $da27b835be8eb6e3$var$InlineCreateFormWithErrorBoundary = (props)=>{
        const experience = $da27b835be8eb6e3$var$useExperience(props.location);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cm8b5")).ExperienceErrorBoundary), {
            experience: experience,
            fallback: "flag"
        }, (0, (0, parcelRequire("4R6GH")).fg)('fun-1256_handle_available_fields_load_in_ic_2') ? (0, ($parcel$interopDefault($5uXOq))).createElement($da27b835be8eb6e3$var$InlineCreateForm, props) : (0, ($parcel$interopDefault($5uXOq))).createElement($da27b835be8eb6e3$var$InlineCreateFormInternal, {
            ...props,
            issueTypes: $da27b835be8eb6e3$var$emptyArray
        }));
    };
    const $da27b835be8eb6e3$var$genericMemo = (0, $5uXOq.memo);
    var $da27b835be8eb6e3$export$2e2bcd8739ae039 = $da27b835be8eb6e3$var$genericMemo($da27b835be8eb6e3$var$InlineCreateFormWithErrorBoundary);
    const $da27b835be8eb6e3$var$lineHeight = 20;
    const $da27b835be8eb6e3$var$FullContent = (0, $5uXOq.forwardRef)(({ as: C = "form", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { borderRadius: borderRadius, minHeight: minHeight, appearance: appearance, indent: indent, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_a70prk": (0, (0, parcelRequire("lD23V")).default)(__cmplp.borderRadius ?? "var(--ds-border-radius, 3px)"),
                "--_jfgeee": (0, (0, parcelRequire("lD23V")).default)(__cmplp.minHeight ?? '40px'),
                "--_10qudx8": (0, (0, parcelRequire("lD23V")).default)(__cmplp.appearance === $da27b835be8eb6e3$export$e99c52f52501386d && 'center'),
                "--_gg0ene": (0, (0, parcelRequire("lD23V")).default)(__cmplp.indent)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _zulpu2gc _bfhkvuon _v56416gf _16qshqll _vchhusvi _12ji1r31 _1qu2glyw _12y31o36 _2rko7ebt _1tkej4pn _4cvrnb98 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0q1b66 _u5f3u2gc _n3td1b66 _19bvu2gc",
                __cmplp.appearance === $da27b835be8eb6e3$export$2e234a0f40160716 ? "_2lx21bp4" : "_2lx2vrvc",
                __cmplp.appearance === $da27b835be8eb6e3$export$e99c52f52501386d ? "_4t3i1ylp" : "_4t3i53f4",
                __cmplp.appearance === $da27b835be8eb6e3$export$2e234a0f40160716 && "_ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp",
                __cmplp.indent && "_19bv2uct",
                __cmplp.className
            ])
        });
    });
    const $da27b835be8eb6e3$var$StyledTextArea = (0, $5uXOq.forwardRef)(({ as: C = "textarea", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { appearance: appearance, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jlkb7n _1o9zkb7n _i0dlf1ug _19itglyw _12ji1r31 _1qu2glyw _12y31o36 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1yt41b66 _14zgglyw _bfhkvuon _syaz1fxt _ect41wi2 _1wybdlk8 _vwz4gktf _1idr1wmz _1wfakb7n",
                __cmplp.appearance === $da27b835be8eb6e3$export$2e234a0f40160716 ? "_4t3i1ylp" : "_4t3igktf",
                __cmplp.appearance === $da27b835be8eb6e3$export$e99c52f52501386d && "_o572qvpr _1fjgglyw _1cicglyw",
                __cmplp.className
            ])
        });
    });
    const $da27b835be8eb6e3$var$Footer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { appearance: appearance, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _zulpu2gc _4cvr1h6o",
                __cmplp.appearance === $da27b835be8eb6e3$export$2e234a0f40160716 ? "_1bah1yb4" : "_1bahh9n0",
                __cmplp.className
            ])
        });
    });
    const $da27b835be8eb6e3$var$StyledButton = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("2APCZ")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1ul9idpf",
                __cmplp.className
            ])
        });
    });
    const $da27b835be8eb6e3$var$StyledCreateButton = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("2APCZ")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jlidpf _1o9zidpf _i0dl1wug",
                __cmplp.className
            ])
        });
    });
    const $da27b835be8eb6e3$var$OptionWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
    const $da27b835be8eb6e3$var$OptionTypeIcon = (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3ipxbi _1bsbpxbi _2hwxu2gc",
                __cmplp.className
            ])
        });
    });
    const $da27b835be8eb6e3$var$ExtraLinksGroup = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_x3dope8f _19pk1b66 _ca0q1b66",
                __cmplp.className
            ])
        });
    });
    const $da27b835be8eb6e3$var$StyledLink = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("hDzhb")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_9oik18uv _1bnxglyw _jf4cnqa1",
                __cmplp.className
            ])
        });
    });
    const $da27b835be8eb6e3$var$IssueTypeIcon = (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3ipxbi _1bsbpxbi",
                __cmplp.className
            ])
        });
    });
    const $da27b835be8eb6e3$var$ChevronDownWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18s83jz8",
                __cmplp.className
            ])
        });
    });
    const $da27b835be8eb6e3$var$issueTypeButtonStylesOld = (0, (0, parcelRequire("99gde")).xcss)({
        marginTop: 'space.050'
    });
    const $da27b835be8eb6e3$var$issueTypeButtonStyles = (0, (0, parcelRequire("99gde")).xcss)({
        marginTop: 'space.025'
    });
    const $da27b835be8eb6e3$var$spinnerWrapperStyles = (0, (0, parcelRequire("99gde")).xcss)({
        flex: 1
    });
});
parcelRegister("3t0PE", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$38a8e58d05b19458$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $cBeZP;
    var $7nsd3 = parcelRequire("7nsd3");
    var $ao4Ml = parcelRequire("ao4Ml");
    var $9ZKDH = parcelRequire("9ZKDH");
    var $2w28i;
    var $43fmF;
    var $lr9Km;
    var $4wJSY = parcelRequire("4wJSY");
    var $bkJDg;
    var $2oS3b;
    var $crsHE;
    var $gN6Vx;
    var $imyI2;
    var $HFUaQ;
    var $hhPK6;
    const $38a8e58d05b19458$var$canUseDOM = ()=>Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
    const $38a8e58d05b19458$var$FocusLock = (0, (0, parcelRequire("2oS3b")).fg)('platform_dst_select-bump-react-focus-lock') ? (0, $9ZKDH.default) : (0, $ao4Ml.default);
    const $38a8e58d05b19458$var$modifiers = [
        {
            name: 'offset',
            options: {
                offset: [
                    0,
                    8
                ]
            }
        },
        {
            name: 'preventOverflow',
            enabled: true,
            options: {
                padding: 5,
                boundary: 'clippingParents',
                altAxis: true,
                altBoundary: true
            }
        }
    ];
    const $38a8e58d05b19458$var$defaultPopperProps = {
        modifiers: $38a8e58d05b19458$var$modifiers,
        placement: 'bottom-start'
    };
    const $38a8e58d05b19458$var$isEmpty = (obj)=>Object.keys(obj).length === 0;
    class $38a8e58d05b19458$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
        static{
            this.defaultProps = {
                closeMenuOnSelect: true,
                shouldCloseMenuOnTab: true,
                components: {},
                maxMenuHeight: 300,
                maxMenuWidth: 440,
                minMenuWidth: 220,
                popperProps: {},
                isSearchable: true,
                searchThreshold: 5,
                styles: {},
                options: []
            };
        }
        static getDerivedStateFromProps(props, state) {
            const newState = {};
            const mergedPopperProps = {
                ...$38a8e58d05b19458$var$defaultPopperProps,
                ...props.popperProps
            };
            if (!(0, $4wJSY.shallowEqualObjects)(mergedPopperProps, state.mergedPopperProps)) newState.mergedPopperProps = mergedPopperProps;
            const mergedComponents = {
                ...(0, (0, parcelRequire("hhPK6")).defaultComponents),
                ...props.components
            };
            if (!(0, $4wJSY.shallowEqualObjects)(mergedComponents, state.mergedComponents)) newState.mergedComponents = mergedComponents;
            if (!$38a8e58d05b19458$var$isEmpty(newState)) return newState;
            return null;
        }
        componentDidMount() {
            if (typeof window === 'undefined') return;
            this.unbindWindowClick = (0, (0, parcelRequire("cBeZP")).bind)(window, {
                type: 'click',
                listener: this.handleClick,
                options: {
                    capture: true
                }
            });
        }
        componentWillUnmount() {
            if (typeof window === 'undefined') return;
            this.unbindWindowClick?.();
            this.unbindWindowClick = null;
            this.unbindWindowKeydown?.();
            this.unbindWindowKeydown = null;
        }
        componentDidUpdate(prevProps) {
            const { isOpen: isOpen } = this.props;
            if (prevProps.isOpen !== isOpen) {
                if (isOpen === true) this.open({
                    controlOverride: true
                });
                else if (isOpen === false) this.close({
                    controlOverride: true
                });
            }
        }
        render() {
            const { target: target } = this.props;
            const { isOpen: isOpen } = this.state;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2w28i")).Manager), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bkJDg")).IdProvider), {
                postfix: "-popup-select"
            }, ({ id: id })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lr9Km")).Reference), null, ({ ref: ref })=>target && target({
                        isOpen: isOpen,
                        onKeyDown: this.handleTargetKeyDown,
                        ref: this.resolveTargetRef(ref),
                        'aria-haspopup': 'true',
                        'aria-expanded': isOpen,
                        'aria-controls': isOpen ? id : undefined
                    })), this.renderSelect(id))));
        }
        constructor(...args){
            super(...args);
            this.menuRef = null;
            this.selectRef = null;
            this.targetRef = null;
            this.unbindWindowClick = null;
            this.unbindWindowKeydown = null;
            this.defaultStyles = (0, (0, parcelRequire("crsHE")).mergeStyles)((0, (0, parcelRequire("imyI2")).default)(this.props.validationState || (this.props.isInvalid ? 'error' : 'default'), this.props.spacing === 'compact', 'default'), {
                groupHeading: (provided)=>({
                        ...provided,
                        color: `var(--ds-text-subtlest, ${0, $72ba03e317f3d228$export$eaa8c8a70ac22806})`
                    })
            });
            this.isOpenControlled = this.props.isOpen !== undefined;
            this.defaultOpenState = this.isOpenControlled ? this.props.isOpen : this.props.defaultIsOpen;
            this.state = {
                focusLockEnabled: false,
                isOpen: this.defaultOpenState ?? false,
                mergedComponents: (0, (0, parcelRequire("hhPK6")).defaultComponents),
                mergedPopperProps: $38a8e58d05b19458$var$defaultPopperProps
            };
            this.handleTargetKeyDown = (event)=>{
                switch(event.key){
                    case 'ArrowDown':
                        this.open();
                        break;
                    default:
                }
            };
            this.handleKeyDown = (event)=>{
                const tabEvent = event.key === 'Tab' && event.shiftKey || event.key === 'Tab';
                if (this.props.shouldCloseMenuOnTab && tabEvent) this.close();
                switch(event.key){
                    case 'Escape':
                    case 'Esc':
                        this.close();
                        break;
                    default:
                }
                if (this.props.onKeyDown) this.props.onKeyDown(event);
            };
            this.handleClick = ({ target: target })=>{
                const { isOpen: isOpen } = this.state;
                if (!(target instanceof Element)) return;
                if (isOpen && this.menuRef && !this.menuRef.contains(target)) this.close();
                if (!isOpen && this.targetRef && this.targetRef.contains(target)) this.open();
            };
            this.handleSelectChange = (value, actionMeta)=>{
                const { closeMenuOnSelect: closeMenuOnSelect, onChange: onChange } = this.props;
                if (closeMenuOnSelect && actionMeta.action !== 'clear') this.close();
                if (onChange) onChange(value, actionMeta);
            };
            this.handleFirstPopperUpdate = ()=>{
                this.setState({
                    focusLockEnabled: true
                });
            };
            this.open = (options)=>{
                const { onOpen: onOpen, onMenuOpen: onMenuOpen } = this.props;
                if (!options?.controlOverride && this.isOpenControlled) return;
                if (onOpen) onOpen();
                if (onMenuOpen) onMenuOpen();
                this.setState({
                    isOpen: true
                }, ()=>{
                    if (this.selectRef) this.selectRef.select?.openMenu('first');
                });
                if (typeof window === 'undefined') return;
                this.unbindWindowKeydown = (0, (0, parcelRequire("cBeZP")).bind)(window, {
                    type: 'keydown',
                    listener: this.handleKeyDown,
                    options: {
                        capture: true
                    }
                });
            };
            this.close = (options)=>{
                const { onClose: onClose, onMenuClose: onMenuClose } = this.props;
                if (!options?.controlOverride && this.isOpenControlled) return;
                if (onClose) onClose();
                if (onMenuClose) onMenuClose();
                this.setState({
                    isOpen: false
                });
                this.setState({
                    focusLockEnabled: false
                });
                if (this.targetRef != null) this.targetRef.focus();
                if (typeof window === 'undefined') return;
                this.unbindWindowKeydown?.();
                this.unbindWindowKeydown = null;
            };
            this.resolveTargetRef = (popperRef)=>(ref)=>{
                    if (!this.targetRef && popperRef && ref) {
                        this.targetRef = ref;
                        if (typeof popperRef === 'function') popperRef(ref);
                        else popperRef.current = ref;
                    }
                };
            this.resolveMenuRef = (popperRef)=>(ref)=>{
                    this.menuRef = ref;
                    if (typeof popperRef === 'function') popperRef(ref);
                    else popperRef.current = ref;
                };
            this.getSelectRef = (ref)=>{
                this.selectRef = ref;
            };
            this.getItemCount = ()=>{
                const { options: options } = this.props;
                let count = 0;
                options.forEach((groupOrOption)=>{
                    if (groupOrOption.options) groupOrOption.options.forEach(()=>count++);
                    else count++;
                });
                return count;
            };
            this.getMaxHeight = ()=>{
                const { maxMenuHeight: maxMenuHeight } = this.props;
                if (!this.selectRef) return maxMenuHeight;
                const showSearchControl = this.showSearchControl();
                const controlRef = this.selectRef.select?.controlRef;
                const offsetHeight = showSearchControl && controlRef ? controlRef.offsetHeight : 0;
                const maxHeight = maxMenuHeight - offsetHeight;
                return maxHeight;
            };
            this.showSearchControl = ()=>{
                const { searchThreshold: searchThreshold, isSearchable: isSearchable } = this.props;
                return isSearchable && this.getItemCount() > searchThreshold;
            };
            this.renderSelect = (id)=>{
                const { footer: footer, label: label, maxMenuWidth: maxMenuWidth, minMenuWidth: minMenuWidth, placeholder: placeholder, target: target, testId: testId, onMenuOpen: onMenuOpen, onMenuClose: onMenuClose, ...props } = this.props;
                const { focusLockEnabled: focusLockEnabled, isOpen: isOpen, mergedComponents: mergedComponents, mergedPopperProps: mergedPopperProps } = this.state;
                const showSearchControl = this.showSearchControl();
                const portalDestination = $38a8e58d05b19458$var$canUseDOM() ? document.body : null;
                if (!portalDestination || !isOpen) return null;
                const selectComponents = {
                    ...mergedComponents,
                    Control: showSearchControl ? mergedComponents.Control : (0, (0, parcelRequire("hhPK6")).DummyControl)
                };
                const getLabel = ()=>{
                    if (label) return label;
                    else if (typeof placeholder === 'string') return placeholder;
                };
                const providedAriaLabel = getLabel();
                const updateInputAriaLabel = (ariaLabelText)=>{
                    if (this.selectRef?.select?.inputRef) {
                        if (providedAriaLabel) ariaLabelText = `${providedAriaLabel}. ${ariaLabelText}`;
                        this.selectRef?.select.inputRef?.setAttribute('aria-label', ariaLabelText);
                    }
                };
                const generateNoGroupsAriaText = (onFocusProps, ariaLabelSuffix)=>{
                    const { focused: focused } = onFocusProps;
                    const options = props?.options || [];
                    const totalLength = options?.length;
                    const optionIndex = options?.findIndex((option)=>option === focused) ?? 0;
                    const optionName = typeof props?.getOptionLabel === 'function' ? props.getOptionLabel(focused) : focused.label;
                    const ariaLabelText = `Option ${optionName} focused, ${optionIndex + 1} of ${totalLength}.
			${totalLength} results available.
			${ariaLabelSuffix}
			`;
                    return ariaLabelText;
                };
                const onReactSelectFocus = (onFocusProps)=>{
                    const ariaLabelSuffix = ' Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu.';
                    let ariaLabelText = '';
                    let ariaLiveMessage = '';
                    if (props.options?.length) {
                        if ((0, (0, parcelRequire("HFUaQ")).isOptionsGrouped)(props.options)) {
                            const totalLength = (0, (0, parcelRequire("HFUaQ")).countAllOptions)(props.options);
                            ariaLiveMessage = (0, (0, parcelRequire("HFUaQ")).onFocus)(onFocusProps, props.options);
                            ariaLabelText = `${ariaLiveMessage} ${totalLength} results available. ${ariaLabelSuffix}`;
                        } else {
                            ariaLabelText = generateNoGroupsAriaText(onFocusProps, ariaLabelSuffix);
                            ariaLiveMessage = ariaLabelText;
                        }
                        updateInputAriaLabel(ariaLabelText);
                        return ariaLiveMessage;
                    }
                    return ariaLiveMessage;
                };
                const popper = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("43fmF")).Popper), {
                    ...mergedPopperProps,
                    onFirstUpdate: (state)=>{
                        this.handleFirstPopperUpdate();
                        mergedPopperProps.onFirstUpdate?.(state);
                    }
                }, ({ placement: placement, ref: ref, style: style })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hhPK6")).MenuDialog), {
                        style: style,
                        "data-placement": placement,
                        minWidth: minMenuWidth,
                        maxWidth: maxMenuWidth,
                        id: id,
                        testId: testId,
                        ref: this.resolveMenuRef(ref)
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement($38a8e58d05b19458$var$FocusLock, {
                        disabled: !focusLockEnabled,
                        returnFocus: true
                    }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gN6Vx")).default), {
                        "aria-label": providedAriaLabel,
                        backspaceRemovesValue: false,
                        controlShouldRenderValue: false,
                        isClearable: false,
                        tabSelectsValue: false,
                        menuIsOpen: true,
                        placeholder: placeholder,
                        ref: this.getSelectRef,
                        ...props,
                        isSearchable: showSearchControl,
                        styles: (0, (0, parcelRequire("crsHE")).mergeStyles)(this.defaultStyles, props.styles || {}),
                        maxMenuHeight: this.getMaxHeight(),
                        components: selectComponents,
                        onChange: this.handleSelectChange,
                        ariaLiveMessages: !showSearchControl ? {
                            onFocus: onReactSelectFocus,
                            ...props.ariaLiveMessages
                        } : props.ariaLiveMessages
                    }), footer)));
                return mergedPopperProps.strategy === 'fixed' ? popper : (0, $7nsd3.createPortal)(popper, portalDestination);
            };
        }
    }
});
parcelRegister("2w28i", function(module, exports) {
    $parcel$export(module.exports, "ManagerReferenceNodeContext", ()=>$1d503975cdd11d34$export$3dbd3405086fec7b);
    $parcel$export(module.exports, "ManagerReferenceNodeSetterContext", ()=>$1d503975cdd11d34$export$cbabb21c2529b130);
    $parcel$export(module.exports, "Manager", ()=>$1d503975cdd11d34$export$d0d38e7dec7a1a61);
    var $5uXOq = parcelRequire("5uXOq");
    var $1d503975cdd11d34$export$3dbd3405086fec7b = $5uXOq.createContext();
    var $1d503975cdd11d34$export$cbabb21c2529b130 = $5uXOq.createContext();
    function $1d503975cdd11d34$export$d0d38e7dec7a1a61(_ref) {
        var children = _ref.children;
        var _React$useState = $5uXOq.useState(null), referenceNode = _React$useState[0], setReferenceNode = _React$useState[1];
        var hasUnmounted = $5uXOq.useRef(false);
        $5uXOq.useEffect(function() {
            return function() {
                hasUnmounted.current = true;
            };
        }, []);
        var handleSetReferenceNode = $5uXOq.useCallback(function(node) {
            if (!hasUnmounted.current) setReferenceNode(node);
        }, []);
        return $5uXOq.createElement($1d503975cdd11d34$export$3dbd3405086fec7b.Provider, {
            value: referenceNode
        }, $5uXOq.createElement($1d503975cdd11d34$export$cbabb21c2529b130.Provider, {
            value: handleSetReferenceNode
        }, children));
    }
});
parcelRegister("43fmF", function(module, exports) {
    $parcel$export(module.exports, "Popper", ()=>$2f335c501a47fe9f$export$badac9ada3a0bdf9);
    var $5uXOq = parcelRequire("5uXOq");
    var $2w28i;
    var $etveP;
    var $69Kah;
    var $2f335c501a47fe9f$var$NOOP = function NOOP() {
        return void 0;
    };
    var $2f335c501a47fe9f$var$NOOP_PROMISE = function NOOP_PROMISE() {
        return Promise.resolve(null);
    };
    var $2f335c501a47fe9f$var$EMPTY_MODIFIERS = [];
    function $2f335c501a47fe9f$export$badac9ada3a0bdf9(_ref) {
        var _ref$placement = _ref.placement, placement = _ref$placement === void 0 ? 'bottom' : _ref$placement, _ref$strategy = _ref.strategy, strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy, _ref$modifiers = _ref.modifiers, modifiers = _ref$modifiers === void 0 ? $2f335c501a47fe9f$var$EMPTY_MODIFIERS : _ref$modifiers, referenceElement = _ref.referenceElement, onFirstUpdate = _ref.onFirstUpdate, innerRef = _ref.innerRef, children = _ref.children;
        var referenceNode = $5uXOq.useContext((0, (0, parcelRequire("2w28i")).ManagerReferenceNodeContext));
        var _React$useState = $5uXOq.useState(null), popperElement = _React$useState[0], setPopperElement = _React$useState[1];
        var _React$useState2 = $5uXOq.useState(null), arrowElement = _React$useState2[0], setArrowElement = _React$useState2[1];
        $5uXOq.useEffect(function() {
            (0, (0, parcelRequire("etveP")).setRef)(innerRef, popperElement);
        }, [
            innerRef,
            popperElement
        ]);
        var options = $5uXOq.useMemo(function() {
            return {
                placement: placement,
                strategy: strategy,
                onFirstUpdate: onFirstUpdate,
                modifiers: [].concat(modifiers, [
                    {
                        name: 'arrow',
                        enabled: arrowElement != null,
                        options: {
                            element: arrowElement
                        }
                    }
                ])
            };
        }, [
            placement,
            strategy,
            onFirstUpdate,
            modifiers,
            arrowElement
        ]);
        var _usePopper = (0, (0, parcelRequire("69Kah")).usePopper)(referenceElement || referenceNode, popperElement, options), state = _usePopper.state, styles = _usePopper.styles, forceUpdate = _usePopper.forceUpdate, update = _usePopper.update;
        var childrenProps = $5uXOq.useMemo(function() {
            return {
                ref: setPopperElement,
                style: styles.popper,
                placement: state ? state.placement : placement,
                hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
                isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
                arrowProps: {
                    style: styles.arrow,
                    ref: setArrowElement
                },
                forceUpdate: forceUpdate || $2f335c501a47fe9f$var$NOOP,
                update: update || $2f335c501a47fe9f$var$NOOP_PROMISE
            };
        }, [
            setPopperElement,
            setArrowElement,
            placement,
            state,
            styles,
            update,
            forceUpdate
        ]);
        return (0, (0, parcelRequire("etveP")).unwrapArray)(children)(childrenProps);
    }
});
parcelRegister("etveP", function(module, exports) {
    $parcel$export(module.exports, "unwrapArray", ()=>$02b8319206411a7f$export$f52c55943429c8b6);
    $parcel$export(module.exports, "safeInvoke", ()=>$02b8319206411a7f$export$3dfa7c28635fe028);
    $parcel$export(module.exports, "setRef", ()=>$02b8319206411a7f$export$4bb192c7cacf928f);
    $parcel$export(module.exports, "fromEntries", ()=>$02b8319206411a7f$export$5150077fc2e7c662);
    $parcel$export(module.exports, "useIsomorphicLayoutEffect", ()=>$02b8319206411a7f$export$700979bc83e7db82);
    var $5uXOq = parcelRequire("5uXOq");
    var $02b8319206411a7f$export$f52c55943429c8b6 = function unwrapArray(arg) {
        return Array.isArray(arg) ? arg[0] : arg;
    };
    var $02b8319206411a7f$export$3dfa7c28635fe028 = function safeInvoke(fn) {
        if (typeof fn === 'function') {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            return fn.apply(void 0, args);
        }
    };
    var $02b8319206411a7f$export$4bb192c7cacf928f = function setRef(ref, node) {
        if (typeof ref === 'function') return $02b8319206411a7f$export$3dfa7c28635fe028(ref, node);
        else if (ref != null) ref.current = node;
    };
    var $02b8319206411a7f$export$5150077fc2e7c662 = function fromEntries(entries) {
        return entries.reduce(function(acc, _ref) {
            var key = _ref[0], value = _ref[1];
            acc[key] = value;
            return acc;
        }, {});
    };
    var $02b8319206411a7f$export$700979bc83e7db82 = typeof window !== 'undefined' && window.document && window.document.createElement ? $5uXOq.useLayoutEffect : $5uXOq.useEffect;
});
parcelRegister("69Kah", function(module, exports) {
    $parcel$export(module.exports, "usePopper", ()=>$47b764b13664bf65$export$f4d5bf230a36dd6e);
    var $5uXOq = parcelRequire("5uXOq");
    var $7nsd3 = parcelRequire("7nsd3");
    var $b6zvG;
    var $lHrkK = parcelRequire("lHrkK");
    var $etveP;
    var $47b764b13664bf65$var$EMPTY_MODIFIERS = [];
    var $47b764b13664bf65$export$f4d5bf230a36dd6e = function usePopper(referenceElement, popperElement, options) {
        if (options === void 0) options = {};
        var prevOptions = $5uXOq.useRef(null);
        var optionsWithDefaults = {
            onFirstUpdate: options.onFirstUpdate,
            placement: options.placement || 'bottom',
            strategy: options.strategy || 'absolute',
            modifiers: options.modifiers || $47b764b13664bf65$var$EMPTY_MODIFIERS
        };
        var _React$useState = $5uXOq.useState({
            styles: {
                popper: {
                    position: optionsWithDefaults.strategy,
                    left: '0',
                    top: '0'
                },
                arrow: {
                    position: 'absolute'
                }
            },
            attributes: {}
        }), state = _React$useState[0], setState = _React$useState[1];
        var updateStateModifier = $5uXOq.useMemo(function() {
            return {
                name: 'updateState',
                enabled: true,
                phase: 'write',
                fn: function fn(_ref) {
                    var state = _ref.state;
                    var elements = Object.keys(state.elements);
                    $7nsd3.flushSync(function() {
                        setState({
                            styles: (0, (0, parcelRequire("etveP")).fromEntries)(elements.map(function(element) {
                                return [
                                    element,
                                    state.styles[element] || {}
                                ];
                            })),
                            attributes: (0, (0, parcelRequire("etveP")).fromEntries)(elements.map(function(element) {
                                return [
                                    element,
                                    state.attributes[element]
                                ];
                            }))
                        });
                    });
                },
                requires: [
                    'computeStyles'
                ]
            };
        }, []);
        var popperOptions = $5uXOq.useMemo(function() {
            var newOptions = {
                onFirstUpdate: optionsWithDefaults.onFirstUpdate,
                placement: optionsWithDefaults.placement,
                strategy: optionsWithDefaults.strategy,
                modifiers: [].concat(optionsWithDefaults.modifiers, [
                    updateStateModifier,
                    {
                        name: 'applyStyles',
                        enabled: false
                    }
                ])
            };
            if ((0, ($parcel$interopDefault($lHrkK)))(prevOptions.current, newOptions)) return prevOptions.current || newOptions;
            else {
                prevOptions.current = newOptions;
                return newOptions;
            }
        }, [
            optionsWithDefaults.onFirstUpdate,
            optionsWithDefaults.placement,
            optionsWithDefaults.strategy,
            optionsWithDefaults.modifiers,
            updateStateModifier
        ]);
        var popperInstanceRef = $5uXOq.useRef();
        (0, (0, parcelRequire("etveP")).useIsomorphicLayoutEffect)(function() {
            if (popperInstanceRef.current) popperInstanceRef.current.setOptions(popperOptions);
        }, [
            popperOptions
        ]);
        (0, (0, parcelRequire("etveP")).useIsomorphicLayoutEffect)(function() {
            if (referenceElement == null || popperElement == null) return;
            var createPopper = options.createPopper || (0, (0, parcelRequire("b6zvG")).createPopper);
            var popperInstance = createPopper(referenceElement, popperElement, popperOptions);
            popperInstanceRef.current = popperInstance;
            return function() {
                popperInstance.destroy();
                popperInstanceRef.current = null;
            };
        }, [
            referenceElement,
            popperElement,
            options.createPopper
        ]);
        return {
            state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
            styles: state.styles,
            attributes: state.attributes,
            update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
            forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
        };
    };
});
parcelRegister("b6zvG", function(module, exports) {
    $parcel$export(module.exports, "createPopper", ()=>$815bcccec8b17332$export$8f7491d57c8f97a9);
    var $8qShm;
    var $fPKjp;
    var $1f2fL;
    var $eAVjh;
    var $7aswo;
    var $hI00f;
    var $a20zu;
    var $byg8Y;
    var $9XETd;
    var $lRyJl;
    var $815bcccec8b17332$export$d34966752335dd47 = [
        (0, (0, parcelRequire("fPKjp")).default),
        (0, (0, parcelRequire("1f2fL")).default),
        (0, (0, parcelRequire("eAVjh")).default),
        (0, (0, parcelRequire("7aswo")).default),
        (0, (0, parcelRequire("hI00f")).default),
        (0, (0, parcelRequire("a20zu")).default),
        (0, (0, parcelRequire("byg8Y")).default),
        (0, (0, parcelRequire("9XETd")).default),
        (0, (0, parcelRequire("lRyJl")).default)
    ];
    var $815bcccec8b17332$export$8f7491d57c8f97a9 = (0, (0, parcelRequire("8qShm")).popperGenerator)({
        defaultModifiers: $815bcccec8b17332$export$d34966752335dd47
    });
});
parcelRegister("8qShm", function(module, exports) {
    $parcel$export(module.exports, "popperGenerator", ()=>$623adb24260301ef$export$ed5e13716264f202);
    var $evIj2;
    var $hbezI;
    var $liMGx;
    var $4Ae4p;
    var $8MQuK;
    var $inHsT;
    var $7w3x4;
    var $49wse;
    var $623adb24260301ef$var$DEFAULT_OPTIONS = {
        placement: 'bottom',
        modifiers: [],
        strategy: 'absolute'
    };
    function $623adb24260301ef$var$areValidElements() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return !args.some(function(element) {
            return !(element && typeof element.getBoundingClientRect === 'function');
        });
    }
    function $623adb24260301ef$export$ed5e13716264f202(generatorOptions) {
        if (generatorOptions === void 0) generatorOptions = {};
        var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $623adb24260301ef$var$DEFAULT_OPTIONS : _generatorOptions$def2;
        return function createPopper(reference, popper, options) {
            if (options === void 0) options = defaultOptions;
            var state = {
                placement: 'bottom',
                orderedModifiers: [],
                options: Object.assign({}, $623adb24260301ef$var$DEFAULT_OPTIONS, defaultOptions),
                modifiersData: {},
                elements: {
                    reference: reference,
                    popper: popper
                },
                attributes: {},
                styles: {}
            };
            var effectCleanupFns = [];
            var isDestroyed = false;
            var instance = {
                state: state,
                setOptions: function setOptions(setOptionsAction) {
                    var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                    cleanupModifierEffects();
                    state.options = Object.assign({}, defaultOptions, state.options, options);
                    state.scrollParents = {
                        reference: (0, (0, parcelRequire("49wse")).isElement)(reference) ? (0, (0, parcelRequire("liMGx")).default)(reference) : reference.contextElement ? (0, (0, parcelRequire("liMGx")).default)(reference.contextElement) : [],
                        popper: (0, (0, parcelRequire("liMGx")).default)(popper)
                    };
                    var orderedModifiers = (0, (0, parcelRequire("8MQuK")).default)((0, (0, parcelRequire("7w3x4")).default)([].concat(defaultModifiers, state.options.modifiers)));
                    state.orderedModifiers = orderedModifiers.filter(function(m) {
                        return m.enabled;
                    });
                    runModifierEffects();
                    return instance.update();
                },
                forceUpdate: function forceUpdate() {
                    if (isDestroyed) return;
                    var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper;
                    if (!$623adb24260301ef$var$areValidElements(reference, popper)) return;
                    state.rects = {
                        reference: (0, (0, parcelRequire("evIj2")).default)(reference, (0, (0, parcelRequire("4Ae4p")).default)(popper), state.options.strategy === 'fixed'),
                        popper: (0, (0, parcelRequire("hbezI")).default)(popper)
                    };
                    state.reset = false;
                    state.placement = state.options.placement;
                    state.orderedModifiers.forEach(function(modifier) {
                        return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                    });
                    for(var index = 0; index < state.orderedModifiers.length; index++){
                        if (state.reset === true) {
                            state.reset = false;
                            index = -1;
                            continue;
                        }
                        var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                        if (typeof fn === 'function') state = fn({
                            state: state,
                            options: _options,
                            name: name,
                            instance: instance
                        }) || state;
                    }
                },
                update: (0, (0, parcelRequire("inHsT")).default)(function() {
                    return new Promise(function(resolve) {
                        instance.forceUpdate();
                        resolve(state);
                    });
                }),
                destroy: function destroy() {
                    cleanupModifierEffects();
                    isDestroyed = true;
                }
            };
            if (!$623adb24260301ef$var$areValidElements(reference, popper)) return instance;
            instance.setOptions(options).then(function(state) {
                if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
            });
            function runModifierEffects() {
                state.orderedModifiers.forEach(function(_ref) {
                    var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                    if (typeof effect === 'function') {
                        var cleanupFn = effect({
                            state: state,
                            name: name,
                            instance: instance,
                            options: options
                        });
                        var noopFn = function noopFn() {};
                        effectCleanupFns.push(cleanupFn || noopFn);
                    }
                });
            }
            function cleanupModifierEffects() {
                effectCleanupFns.forEach(function(fn) {
                    return fn();
                });
                effectCleanupFns = [];
            }
            return instance;
        };
    }
    var $623adb24260301ef$export$8f7491d57c8f97a9 = $623adb24260301ef$export$ed5e13716264f202();
});
parcelRegister("evIj2", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a9065436b281a39e$export$2e2bcd8739ae039);
    var $861mM;
    var $Tywfg;
    var $jVmXH;
    var $49wse;
    var $3p4xw;
    var $fVbyj;
    var $7FflJ;
    var $asHtE;
    function $a9065436b281a39e$var$isElementScaled(element) {
        var rect = element.getBoundingClientRect();
        var scaleX = (0, (0, parcelRequire("asHtE")).round)(rect.width) / element.offsetWidth || 1;
        var scaleY = (0, (0, parcelRequire("asHtE")).round)(rect.height) / element.offsetHeight || 1;
        return scaleX !== 1 || scaleY !== 1;
    }
    function $a9065436b281a39e$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
        if (isFixed === void 0) isFixed = false;
        var isOffsetParentAnElement = (0, (0, parcelRequire("49wse")).isHTMLElement)(offsetParent);
        var offsetParentIsScaled = (0, (0, parcelRequire("49wse")).isHTMLElement)(offsetParent) && $a9065436b281a39e$var$isElementScaled(offsetParent);
        var documentElement = (0, (0, parcelRequire("fVbyj")).default)(offsetParent);
        var rect = (0, (0, parcelRequire("861mM")).default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
        var scroll = {
            scrollLeft: 0,
            scrollTop: 0
        };
        var offsets = {
            x: 0,
            y: 0
        };
        if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
            if ((0, (0, parcelRequire("jVmXH")).default)(offsetParent) !== 'body' || (0, (0, parcelRequire("7FflJ")).default)(documentElement)) scroll = (0, (0, parcelRequire("Tywfg")).default)(offsetParent);
            if ((0, (0, parcelRequire("49wse")).isHTMLElement)(offsetParent)) {
                offsets = (0, (0, parcelRequire("861mM")).default)(offsetParent, true);
                offsets.x += offsetParent.clientLeft;
                offsets.y += offsetParent.clientTop;
            } else if (documentElement) offsets.x = (0, (0, parcelRequire("3p4xw")).default)(documentElement);
        }
        return {
            x: rect.left + scroll.scrollLeft - offsets.x,
            y: rect.top + scroll.scrollTop - offsets.y,
            width: rect.width,
            height: rect.height
        };
    }
});
parcelRegister("861mM", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5e4ff19d6beb6b5e$export$2e2bcd8739ae039);
    var $49wse;
    var $asHtE;
    var $4tZah;
    var $9bn5x;
    function $5e4ff19d6beb6b5e$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
        if (includeScale === void 0) includeScale = false;
        if (isFixedStrategy === void 0) isFixedStrategy = false;
        var clientRect = element.getBoundingClientRect();
        var scaleX = 1;
        var scaleY = 1;
        if (includeScale && (0, (0, parcelRequire("49wse")).isHTMLElement)(element)) {
            scaleX = element.offsetWidth > 0 ? (0, (0, parcelRequire("asHtE")).round)(clientRect.width) / element.offsetWidth || 1 : 1;
            scaleY = element.offsetHeight > 0 ? (0, (0, parcelRequire("asHtE")).round)(clientRect.height) / element.offsetHeight || 1 : 1;
        }
        var _ref = (0, (0, parcelRequire("49wse")).isElement)(element) ? (0, (0, parcelRequire("4tZah")).default)(element) : window, visualViewport = _ref.visualViewport;
        var addVisualOffsets = !(0, (0, parcelRequire("9bn5x")).default)() && isFixedStrategy;
        var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
        var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
        var width = clientRect.width / scaleX;
        var height = clientRect.height / scaleY;
        return {
            width: width,
            height: height,
            top: y,
            right: x + width,
            bottom: y + height,
            left: x,
            x: x,
            y: y
        };
    }
});
parcelRegister("49wse", function(module, exports) {
    $parcel$export(module.exports, "isElement", ()=>$30612d6fb7d8b190$export$45a5e7f76e0caa8d);
    $parcel$export(module.exports, "isHTMLElement", ()=>$30612d6fb7d8b190$export$1b3bfaa9684536aa);
    $parcel$export(module.exports, "isShadowRoot", ()=>$30612d6fb7d8b190$export$af51f0f06c0f328a);
    var $4tZah;
    function $30612d6fb7d8b190$export$45a5e7f76e0caa8d(node) {
        var OwnElement = (0, (0, parcelRequire("4tZah")).default)(node).Element;
        return node instanceof OwnElement || node instanceof Element;
    }
    function $30612d6fb7d8b190$export$1b3bfaa9684536aa(node) {
        var OwnElement = (0, (0, parcelRequire("4tZah")).default)(node).HTMLElement;
        return node instanceof OwnElement || node instanceof HTMLElement;
    }
    function $30612d6fb7d8b190$export$af51f0f06c0f328a(node) {
        if (typeof ShadowRoot === 'undefined') return false;
        var OwnElement = (0, (0, parcelRequire("4tZah")).default)(node).ShadowRoot;
        return node instanceof OwnElement || node instanceof ShadowRoot;
    }
});
parcelRegister("4tZah", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$343950ecb629c3e0$export$2e2bcd8739ae039);
    function $343950ecb629c3e0$export$2e2bcd8739ae039(node) {
        if (node == null) return window;
        if (node.toString() !== '[object Window]') {
            var ownerDocument = node.ownerDocument;
            return ownerDocument ? ownerDocument.defaultView || window : window;
        }
        return node;
    }
});
parcelRegister("asHtE", function(module, exports) {
    $parcel$export(module.exports, "max", ()=>$79de3e960c18d7d8$export$8960430cfd85939f);
    $parcel$export(module.exports, "min", ()=>$79de3e960c18d7d8$export$96ec731ed4dcb222);
    $parcel$export(module.exports, "round", ()=>$79de3e960c18d7d8$export$2077e0241d6afd3c);
    var $79de3e960c18d7d8$export$8960430cfd85939f = Math.max;
    var $79de3e960c18d7d8$export$96ec731ed4dcb222 = Math.min;
    var $79de3e960c18d7d8$export$2077e0241d6afd3c = Math.round;
});
parcelRegister("9bn5x", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$6af70d0534b27122$export$2e2bcd8739ae039);
    var $gbwtB;
    function $6af70d0534b27122$export$2e2bcd8739ae039() {
        return !/^((?!chrome|android).)*safari/i.test((0, (0, parcelRequire("gbwtB")).default)());
    }
});
parcelRegister("gbwtB", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bc86dd98cd9f5c8d$export$2e2bcd8739ae039);
    function $bc86dd98cd9f5c8d$export$2e2bcd8739ae039() {
        var uaData = navigator.userAgentData;
        if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
            return item.brand + "/" + item.version;
        }).join(' ');
        return navigator.userAgent;
    }
});
parcelRegister("Tywfg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0a6fe9f083e73612$export$2e2bcd8739ae039);
    var $dbYNm;
    var $4tZah;
    var $49wse;
    var $l0DYW;
    function $0a6fe9f083e73612$export$2e2bcd8739ae039(node) {
        if (node === (0, (0, parcelRequire("4tZah")).default)(node) || !(0, (0, parcelRequire("49wse")).isHTMLElement)(node)) return (0, (0, parcelRequire("dbYNm")).default)(node);
        else return (0, (0, parcelRequire("l0DYW")).default)(node);
    }
});
parcelRegister("dbYNm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$99ab76185531e6fb$export$2e2bcd8739ae039);
    var $4tZah;
    function $99ab76185531e6fb$export$2e2bcd8739ae039(node) {
        var win = (0, (0, parcelRequire("4tZah")).default)(node);
        var scrollLeft = win.pageXOffset;
        var scrollTop = win.pageYOffset;
        return {
            scrollLeft: scrollLeft,
            scrollTop: scrollTop
        };
    }
});
parcelRegister("l0DYW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f4b89ca735cb1144$export$2e2bcd8739ae039);
    function $f4b89ca735cb1144$export$2e2bcd8739ae039(element) {
        return {
            scrollLeft: element.scrollLeft,
            scrollTop: element.scrollTop
        };
    }
});
parcelRegister("jVmXH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e81526f60e8d94f6$export$2e2bcd8739ae039);
    function $e81526f60e8d94f6$export$2e2bcd8739ae039(element) {
        return element ? (element.nodeName || '').toLowerCase() : null;
    }
});
parcelRegister("3p4xw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$27a73a65b060e00f$export$2e2bcd8739ae039);
    var $861mM;
    var $fVbyj;
    var $dbYNm;
    function $27a73a65b060e00f$export$2e2bcd8739ae039(element) {
        return (0, (0, parcelRequire("861mM")).default)((0, (0, parcelRequire("fVbyj")).default)(element)).left + (0, (0, parcelRequire("dbYNm")).default)(element).scrollLeft;
    }
});
parcelRegister("fVbyj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b97523faca7d1157$export$2e2bcd8739ae039);
    var $49wse;
    function $b97523faca7d1157$export$2e2bcd8739ae039(element) {
        return (((0, (0, parcelRequire("49wse")).isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
    }
});
parcelRegister("7FflJ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$594844d3202a6e1d$export$2e2bcd8739ae039);
    var $ctZLK;
    function $594844d3202a6e1d$export$2e2bcd8739ae039(element) {
        var _getComputedStyle = (0, (0, parcelRequire("ctZLK")).default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
        return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
    }
});
parcelRegister("ctZLK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$91681b837d46108b$export$2e2bcd8739ae039);
    var $4tZah;
    function $91681b837d46108b$export$2e2bcd8739ae039(element) {
        return (0, (0, parcelRequire("4tZah")).default)(element).getComputedStyle(element);
    }
});
parcelRegister("hbezI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c81ec50f65ad08dd$export$2e2bcd8739ae039);
    var $861mM;
    function $c81ec50f65ad08dd$export$2e2bcd8739ae039(element) {
        var clientRect = (0, (0, parcelRequire("861mM")).default)(element);
        var width = element.offsetWidth;
        var height = element.offsetHeight;
        if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
        if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
        return {
            x: element.offsetLeft,
            y: element.offsetTop,
            width: width,
            height: height
        };
    }
});
parcelRegister("liMGx", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f8210b42bb44ac8d$export$2e2bcd8739ae039);
    var $lidy0;
    var $jFVZH;
    var $4tZah;
    var $7FflJ;
    function $f8210b42bb44ac8d$export$2e2bcd8739ae039(element, list) {
        var _element$ownerDocumen;
        if (list === void 0) list = [];
        var scrollParent = (0, (0, parcelRequire("lidy0")).default)(element);
        var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
        var win = (0, (0, parcelRequire("4tZah")).default)(scrollParent);
        var target = isBody ? [
            win
        ].concat(win.visualViewport || [], (0, (0, parcelRequire("7FflJ")).default)(scrollParent) ? scrollParent : []) : scrollParent;
        var updatedList = list.concat(target);
        return isBody ? updatedList : updatedList.concat($f8210b42bb44ac8d$export$2e2bcd8739ae039((0, (0, parcelRequire("jFVZH")).default)(target)));
    }
});
parcelRegister("lidy0", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f805c9aa06299b9b$export$2e2bcd8739ae039);
    var $jFVZH;
    var $7FflJ;
    var $jVmXH;
    var $49wse;
    function $f805c9aa06299b9b$export$2e2bcd8739ae039(node) {
        if ([
            'html',
            'body',
            '#document'
        ].indexOf((0, (0, parcelRequire("jVmXH")).default)(node)) >= 0) return node.ownerDocument.body;
        if ((0, (0, parcelRequire("49wse")).isHTMLElement)(node) && (0, (0, parcelRequire("7FflJ")).default)(node)) return node;
        return $f805c9aa06299b9b$export$2e2bcd8739ae039((0, (0, parcelRequire("jFVZH")).default)(node));
    }
});
parcelRegister("jFVZH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e52ed50fe9115a7d$export$2e2bcd8739ae039);
    var $jVmXH;
    var $fVbyj;
    var $49wse;
    function $e52ed50fe9115a7d$export$2e2bcd8739ae039(element) {
        if ((0, (0, parcelRequire("jVmXH")).default)(element) === 'html') return element;
        return (element.assignedSlot || element.parentNode || ((0, (0, parcelRequire("49wse")).isShadowRoot)(element) ? element.host : null) || (0, (0, parcelRequire("fVbyj")).default)(element));
    }
});
parcelRegister("4Ae4p", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$3565703ec1b3d38e$export$2e2bcd8739ae039);
    var $4tZah;
    var $jVmXH;
    var $ctZLK;
    var $49wse;
    var $kDJeH;
    var $jFVZH;
    var $gbwtB;
    function $3565703ec1b3d38e$var$getTrueOffsetParent(element) {
        if (!(0, (0, parcelRequire("49wse")).isHTMLElement)(element) || (0, (0, parcelRequire("ctZLK")).default)(element).position === 'fixed') return null;
        return element.offsetParent;
    }
    function $3565703ec1b3d38e$var$getContainingBlock(element) {
        var isFirefox = /firefox/i.test((0, (0, parcelRequire("gbwtB")).default)());
        var isIE = /Trident/i.test((0, (0, parcelRequire("gbwtB")).default)());
        if (isIE && (0, (0, parcelRequire("49wse")).isHTMLElement)(element)) {
            var elementCss = (0, (0, parcelRequire("ctZLK")).default)(element);
            if (elementCss.position === 'fixed') return null;
        }
        var currentNode = (0, (0, parcelRequire("jFVZH")).default)(element);
        if ((0, (0, parcelRequire("49wse")).isShadowRoot)(currentNode)) currentNode = currentNode.host;
        while((0, (0, parcelRequire("49wse")).isHTMLElement)(currentNode) && [
            'html',
            'body'
        ].indexOf((0, (0, parcelRequire("jVmXH")).default)(currentNode)) < 0){
            var css = (0, (0, parcelRequire("ctZLK")).default)(currentNode);
            if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
                'transform',
                'perspective'
            ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
            else currentNode = currentNode.parentNode;
        }
        return null;
    }
    function $3565703ec1b3d38e$export$2e2bcd8739ae039(element) {
        var window = (0, (0, parcelRequire("4tZah")).default)(element);
        var offsetParent = $3565703ec1b3d38e$var$getTrueOffsetParent(element);
        while(offsetParent && (0, (0, parcelRequire("kDJeH")).default)(offsetParent) && (0, (0, parcelRequire("ctZLK")).default)(offsetParent).position === 'static')offsetParent = $3565703ec1b3d38e$var$getTrueOffsetParent(offsetParent);
        if (offsetParent && ((0, (0, parcelRequire("jVmXH")).default)(offsetParent) === 'html' || (0, (0, parcelRequire("jVmXH")).default)(offsetParent) === 'body' && (0, (0, parcelRequire("ctZLK")).default)(offsetParent).position === 'static')) return window;
        return offsetParent || $3565703ec1b3d38e$var$getContainingBlock(element) || window;
    }
});
parcelRegister("kDJeH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$f06a8a1eb4cebbbe$export$2e2bcd8739ae039);
    var $jVmXH;
    function $f06a8a1eb4cebbbe$export$2e2bcd8739ae039(element) {
        return [
            'table',
            'td',
            'th'
        ].indexOf((0, (0, parcelRequire("jVmXH")).default)(element)) >= 0;
    }
});
parcelRegister("8MQuK", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$665b86d2c2d27f8a$export$2e2bcd8739ae039);
    var $e2YFf;
    function $665b86d2c2d27f8a$var$order(modifiers) {
        var map = new Map();
        var visited = new Set();
        var result = [];
        modifiers.forEach(function(modifier) {
            map.set(modifier.name, modifier);
        });
        function sort(modifier) {
            visited.add(modifier.name);
            var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
            requires.forEach(function(dep) {
                if (!visited.has(dep)) {
                    var depModifier = map.get(dep);
                    if (depModifier) sort(depModifier);
                }
            });
            result.push(modifier);
        }
        modifiers.forEach(function(modifier) {
            if (!visited.has(modifier.name)) sort(modifier);
        });
        return result;
    }
    function $665b86d2c2d27f8a$export$2e2bcd8739ae039(modifiers) {
        var orderedModifiers = $665b86d2c2d27f8a$var$order(modifiers);
        return (0, (0, parcelRequire("e2YFf")).modifierPhases).reduce(function(acc, phase) {
            return acc.concat(orderedModifiers.filter(function(modifier) {
                return modifier.phase === phase;
            }));
        }, []);
    }
});
parcelRegister("e2YFf", function(module, exports) {
    $parcel$export(module.exports, "top", ()=>$a3a04f44e93af771$export$1e95b668f3b82d);
    $parcel$export(module.exports, "bottom", ()=>$a3a04f44e93af771$export$40e543e69a8b3fbb);
    $parcel$export(module.exports, "right", ()=>$a3a04f44e93af771$export$79ffe56a765070d2);
    $parcel$export(module.exports, "left", ()=>$a3a04f44e93af771$export$eabcd2c8791e7bf4);
    $parcel$export(module.exports, "auto", ()=>$a3a04f44e93af771$export$dfb5619354ba860);
    $parcel$export(module.exports, "basePlacements", ()=>$a3a04f44e93af771$export$aec2ce47c367b8c3);
    $parcel$export(module.exports, "start", ()=>$a3a04f44e93af771$export$b3571188c770cc5a);
    $parcel$export(module.exports, "end", ()=>$a3a04f44e93af771$export$bd5df0f255a350f8);
    $parcel$export(module.exports, "clippingParents", ()=>$a3a04f44e93af771$export$390fd549c5303b4d);
    $parcel$export(module.exports, "viewport", ()=>$a3a04f44e93af771$export$d7b7311ec04a3e8f);
    $parcel$export(module.exports, "popper", ()=>$a3a04f44e93af771$export$ae5ab1c730825774);
    $parcel$export(module.exports, "reference", ()=>$a3a04f44e93af771$export$ca50aac9f3ba507f);
    $parcel$export(module.exports, "variationPlacements", ()=>$a3a04f44e93af771$export$368f9a87e87fa4e1);
    $parcel$export(module.exports, "placements", ()=>$a3a04f44e93af771$export$803cd8101b6c182b);
    $parcel$export(module.exports, "modifierPhases", ()=>$a3a04f44e93af771$export$d087d3878fdf71d5);
    var $a3a04f44e93af771$export$1e95b668f3b82d = 'top';
    var $a3a04f44e93af771$export$40e543e69a8b3fbb = 'bottom';
    var $a3a04f44e93af771$export$79ffe56a765070d2 = 'right';
    var $a3a04f44e93af771$export$eabcd2c8791e7bf4 = 'left';
    var $a3a04f44e93af771$export$dfb5619354ba860 = 'auto';
    var $a3a04f44e93af771$export$aec2ce47c367b8c3 = [
        $a3a04f44e93af771$export$1e95b668f3b82d,
        $a3a04f44e93af771$export$40e543e69a8b3fbb,
        $a3a04f44e93af771$export$79ffe56a765070d2,
        $a3a04f44e93af771$export$eabcd2c8791e7bf4
    ];
    var $a3a04f44e93af771$export$b3571188c770cc5a = 'start';
    var $a3a04f44e93af771$export$bd5df0f255a350f8 = 'end';
    var $a3a04f44e93af771$export$390fd549c5303b4d = 'clippingParents';
    var $a3a04f44e93af771$export$d7b7311ec04a3e8f = 'viewport';
    var $a3a04f44e93af771$export$ae5ab1c730825774 = 'popper';
    var $a3a04f44e93af771$export$ca50aac9f3ba507f = 'reference';
    var $a3a04f44e93af771$export$368f9a87e87fa4e1 = $a3a04f44e93af771$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
        return acc.concat([
            placement + "-" + $a3a04f44e93af771$export$b3571188c770cc5a,
            placement + "-" + $a3a04f44e93af771$export$bd5df0f255a350f8
        ]);
    }, []);
    var $a3a04f44e93af771$export$803cd8101b6c182b = [].concat($a3a04f44e93af771$export$aec2ce47c367b8c3, [
        $a3a04f44e93af771$export$dfb5619354ba860
    ]).reduce(function(acc, placement) {
        return acc.concat([
            placement,
            placement + "-" + $a3a04f44e93af771$export$b3571188c770cc5a,
            placement + "-" + $a3a04f44e93af771$export$bd5df0f255a350f8
        ]);
    }, []);
    var $a3a04f44e93af771$export$421679a7c3d56e = 'beforeRead';
    var $a3a04f44e93af771$export$aafa59e2e03f2942 = 'read';
    var $a3a04f44e93af771$export$6964f6c886723980 = 'afterRead';
    var $a3a04f44e93af771$export$c65e99957a05207c = 'beforeMain';
    var $a3a04f44e93af771$export$f22da7240b7add18 = 'main';
    var $a3a04f44e93af771$export$bab79516f2d662fe = 'afterMain';
    var $a3a04f44e93af771$export$8d4d2d70e7d46032 = 'beforeWrite';
    var $a3a04f44e93af771$export$68d8715fc104d294 = 'write';
    var $a3a04f44e93af771$export$70a6e5159acce2e6 = 'afterWrite';
    var $a3a04f44e93af771$export$d087d3878fdf71d5 = [
        $a3a04f44e93af771$export$421679a7c3d56e,
        $a3a04f44e93af771$export$aafa59e2e03f2942,
        $a3a04f44e93af771$export$6964f6c886723980,
        $a3a04f44e93af771$export$c65e99957a05207c,
        $a3a04f44e93af771$export$f22da7240b7add18,
        $a3a04f44e93af771$export$bab79516f2d662fe,
        $a3a04f44e93af771$export$8d4d2d70e7d46032,
        $a3a04f44e93af771$export$68d8715fc104d294,
        $a3a04f44e93af771$export$70a6e5159acce2e6
    ];
});
parcelRegister("inHsT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d61c173c9120db20$export$2e2bcd8739ae039);
    function $d61c173c9120db20$export$2e2bcd8739ae039(fn) {
        var pending;
        return function() {
            if (!pending) pending = new Promise(function(resolve) {
                Promise.resolve().then(function() {
                    pending = undefined;
                    resolve(fn());
                });
            });
            return pending;
        };
    }
});
parcelRegister("7w3x4", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$578e430b42ab53a7$export$2e2bcd8739ae039);
    function $578e430b42ab53a7$export$2e2bcd8739ae039(modifiers) {
        var merged = modifiers.reduce(function(merged, current) {
            var existing = merged[current.name];
            merged[current.name] = existing ? Object.assign({}, existing, current, {
                options: Object.assign({}, existing.options, current.options),
                data: Object.assign({}, existing.data, current.data)
            }) : current;
            return merged;
        }, {});
        return Object.keys(merged).map(function(key) {
            return merged[key];
        });
    }
});
parcelRegister("fPKjp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$b86f8b04ac280765$export$2e2bcd8739ae039);
    var $4tZah;
    var $b86f8b04ac280765$var$passive = {
        passive: true
    };
    function $b86f8b04ac280765$var$effect(_ref) {
        var state = _ref.state, instance = _ref.instance, options = _ref.options;
        var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
        var window = (0, (0, parcelRequire("4tZah")).default)(state.elements.popper);
        var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.addEventListener('scroll', instance.update, $b86f8b04ac280765$var$passive);
        });
        if (resize) window.addEventListener('resize', instance.update, $b86f8b04ac280765$var$passive);
        return function() {
            if (scroll) scrollParents.forEach(function(scrollParent) {
                scrollParent.removeEventListener('scroll', instance.update, $b86f8b04ac280765$var$passive);
            });
            if (resize) window.removeEventListener('resize', instance.update, $b86f8b04ac280765$var$passive);
        };
    }
    var $b86f8b04ac280765$export$2e2bcd8739ae039 = {
        name: 'eventListeners',
        enabled: true,
        phase: 'write',
        fn: function fn() {},
        effect: $b86f8b04ac280765$var$effect,
        data: {}
    };
});
parcelRegister("1f2fL", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0e78f09923d109fd$export$2e2bcd8739ae039);
    var $dMroj;
    function $0e78f09923d109fd$var$popperOffsets(_ref) {
        var state = _ref.state, name = _ref.name;
        state.modifiersData[name] = (0, (0, parcelRequire("dMroj")).default)({
            reference: state.rects.reference,
            element: state.rects.popper,
            strategy: 'absolute',
            placement: state.placement
        });
    }
    var $0e78f09923d109fd$export$2e2bcd8739ae039 = {
        name: 'popperOffsets',
        enabled: true,
        phase: 'read',
        fn: $0e78f09923d109fd$var$popperOffsets,
        data: {}
    };
});
parcelRegister("dMroj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a08501606cb385a0$export$2e2bcd8739ae039);
    var $j9mpk;
    var $3VNj3;
    var $gbIja;
    var $e2YFf;
    function $a08501606cb385a0$export$2e2bcd8739ae039(_ref) {
        var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
        var basePlacement = placement ? (0, (0, parcelRequire("j9mpk")).default)(placement) : null;
        var variation = placement ? (0, (0, parcelRequire("3VNj3")).default)(placement) : null;
        var commonX = reference.x + reference.width / 2 - element.width / 2;
        var commonY = reference.y + reference.height / 2 - element.height / 2;
        var offsets;
        switch(basePlacement){
            case 0, (0, parcelRequire("e2YFf")).top:
                offsets = {
                    x: commonX,
                    y: reference.y - element.height
                };
                break;
            case 0, (0, parcelRequire("e2YFf")).bottom:
                offsets = {
                    x: commonX,
                    y: reference.y + reference.height
                };
                break;
            case 0, (0, parcelRequire("e2YFf")).right:
                offsets = {
                    x: reference.x + reference.width,
                    y: commonY
                };
                break;
            case 0, (0, parcelRequire("e2YFf")).left:
                offsets = {
                    x: reference.x - element.width,
                    y: commonY
                };
                break;
            default:
                offsets = {
                    x: reference.x,
                    y: reference.y
                };
        }
        var mainAxis = basePlacement ? (0, (0, parcelRequire("gbIja")).default)(basePlacement) : null;
        if (mainAxis != null) {
            var len = mainAxis === 'y' ? 'height' : 'width';
            switch(variation){
                case 0, (0, parcelRequire("e2YFf")).start:
                    offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                    break;
                case 0, (0, parcelRequire("e2YFf")).end:
                    offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                    break;
                default:
            }
        }
        return offsets;
    }
});
parcelRegister("j9mpk", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$df103d3e60d151e1$export$2e2bcd8739ae039);
    function $df103d3e60d151e1$export$2e2bcd8739ae039(placement) {
        return placement.split('-')[0];
    }
});
parcelRegister("3VNj3", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$2dccf12928872ddc$export$2e2bcd8739ae039);
    function $2dccf12928872ddc$export$2e2bcd8739ae039(placement) {
        return placement.split('-')[1];
    }
});
parcelRegister("gbIja", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bc900b177ad4cf78$export$2e2bcd8739ae039);
    function $bc900b177ad4cf78$export$2e2bcd8739ae039(placement) {
        return [
            'top',
            'bottom'
        ].indexOf(placement) >= 0 ? 'x' : 'y';
    }
});
parcelRegister("eAVjh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$aa00e206a7660329$export$2e2bcd8739ae039);
    var $e2YFf;
    var $4Ae4p;
    var $4tZah;
    var $fVbyj;
    var $ctZLK;
    var $j9mpk;
    var $3VNj3;
    var $asHtE;
    var $aa00e206a7660329$var$unsetSides = {
        top: 'auto',
        right: 'auto',
        bottom: 'auto',
        left: 'auto'
    };
    function $aa00e206a7660329$var$roundOffsetsByDPR(_ref, win) {
        var x = _ref.x, y = _ref.y;
        var dpr = win.devicePixelRatio || 1;
        return {
            x: (0, (0, parcelRequire("asHtE")).round)(x * dpr) / dpr || 0,
            y: (0, (0, parcelRequire("asHtE")).round)(y * dpr) / dpr || 0
        };
    }
    function $aa00e206a7660329$export$378fa78a8fea596f(_ref2) {
        var _Object$assign2;
        var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
        var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
        var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
            x: x,
            y: y
        }) : {
            x: x,
            y: y
        };
        x = _ref3.x;
        y = _ref3.y;
        var hasX = offsets.hasOwnProperty('x');
        var hasY = offsets.hasOwnProperty('y');
        var sideX = (0, (0, parcelRequire("e2YFf")).left);
        var sideY = (0, (0, parcelRequire("e2YFf")).top);
        var win = window;
        if (adaptive) {
            var offsetParent = (0, (0, parcelRequire("4Ae4p")).default)(popper);
            var heightProp = 'clientHeight';
            var widthProp = 'clientWidth';
            if (offsetParent === (0, (0, parcelRequire("4tZah")).default)(popper)) {
                offsetParent = (0, (0, parcelRequire("fVbyj")).default)(popper);
                if ((0, (0, parcelRequire("ctZLK")).default)(offsetParent).position !== 'static' && position === 'absolute') {
                    heightProp = 'scrollHeight';
                    widthProp = 'scrollWidth';
                }
            }
            offsetParent;
            if (placement === (0, (0, parcelRequire("e2YFf")).top) || (placement === (0, (0, parcelRequire("e2YFf")).left) || placement === (0, (0, parcelRequire("e2YFf")).right)) && variation === (0, (0, parcelRequire("e2YFf")).end)) {
                sideY = (0, (0, parcelRequire("e2YFf")).bottom);
                var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
                y -= offsetY - popperRect.height;
                y *= gpuAcceleration ? 1 : -1;
            }
            if (placement === (0, (0, parcelRequire("e2YFf")).left) || (placement === (0, (0, parcelRequire("e2YFf")).top) || placement === (0, (0, parcelRequire("e2YFf")).bottom)) && variation === (0, (0, parcelRequire("e2YFf")).end)) {
                sideX = (0, (0, parcelRequire("e2YFf")).right);
                var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
                x -= offsetX - popperRect.width;
                x *= gpuAcceleration ? 1 : -1;
            }
        }
        var commonStyles = Object.assign({
            position: position
        }, adaptive && $aa00e206a7660329$var$unsetSides);
        var _ref4 = roundOffsets === true ? $aa00e206a7660329$var$roundOffsetsByDPR({
            x: x,
            y: y
        }, (0, (0, parcelRequire("4tZah")).default)(popper)) : {
            x: x,
            y: y
        };
        x = _ref4.x;
        y = _ref4.y;
        if (gpuAcceleration) {
            var _Object$assign;
            return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
        }
        return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
    }
    function $aa00e206a7660329$var$computeStyles(_ref5) {
        var state = _ref5.state, options = _ref5.options;
        var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
        var commonStyles = {
            placement: (0, (0, parcelRequire("j9mpk")).default)(state.placement),
            variation: (0, (0, parcelRequire("3VNj3")).default)(state.placement),
            popper: state.elements.popper,
            popperRect: state.rects.popper,
            gpuAcceleration: gpuAcceleration,
            isFixed: state.options.strategy === 'fixed'
        };
        if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $aa00e206a7660329$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
            offsets: state.modifiersData.popperOffsets,
            position: state.options.strategy,
            adaptive: adaptive,
            roundOffsets: roundOffsets
        })));
        if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $aa00e206a7660329$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
            offsets: state.modifiersData.arrow,
            position: 'absolute',
            adaptive: false,
            roundOffsets: roundOffsets
        })));
        state.attributes.popper = Object.assign({}, state.attributes.popper, {
            'data-popper-placement': state.placement
        });
    }
    var $aa00e206a7660329$export$2e2bcd8739ae039 = {
        name: 'computeStyles',
        enabled: true,
        phase: 'beforeWrite',
        fn: $aa00e206a7660329$var$computeStyles,
        data: {}
    };
});
parcelRegister("7aswo", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$537f975557003bb1$export$2e2bcd8739ae039);
    var $jVmXH;
    var $49wse;
    function $537f975557003bb1$var$applyStyles(_ref) {
        var state = _ref.state;
        Object.keys(state.elements).forEach(function(name) {
            var style = state.styles[name] || {};
            var attributes = state.attributes[name] || {};
            var element = state.elements[name];
            if (!(0, (0, parcelRequire("49wse")).isHTMLElement)(element) || !(0, (0, parcelRequire("jVmXH")).default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(name) {
                var value = attributes[name];
                if (value === false) element.removeAttribute(name);
                else element.setAttribute(name, value === true ? '' : value);
            });
        });
    }
    function $537f975557003bb1$var$effect(_ref2) {
        var state = _ref2.state;
        var initialStyles = {
            popper: {
                position: state.options.strategy,
                left: '0',
                top: '0',
                margin: '0'
            },
            arrow: {
                position: 'absolute'
            },
            reference: {}
        };
        Object.assign(state.elements.popper.style, initialStyles.popper);
        state.styles = initialStyles;
        if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
        return function() {
            Object.keys(state.elements).forEach(function(name) {
                var element = state.elements[name];
                var attributes = state.attributes[name] || {};
                var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]);
                var style = styleProperties.reduce(function(style, property) {
                    style[property] = '';
                    return style;
                }, {});
                if (!(0, (0, parcelRequire("49wse")).isHTMLElement)(element) || !(0, (0, parcelRequire("jVmXH")).default)(element)) return;
                Object.assign(element.style, style);
                Object.keys(attributes).forEach(function(attribute) {
                    element.removeAttribute(attribute);
                });
            });
        };
    }
    var $537f975557003bb1$export$2e2bcd8739ae039 = {
        name: 'applyStyles',
        enabled: true,
        phase: 'write',
        fn: $537f975557003bb1$var$applyStyles,
        effect: $537f975557003bb1$var$effect,
        requires: [
            'computeStyles'
        ]
    };
});
parcelRegister("hI00f", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ce468c57ebe9fba2$export$2e2bcd8739ae039);
    var $j9mpk;
    var $e2YFf;
    function $ce468c57ebe9fba2$export$7fa02d8595b015ed(placement, rects, offset) {
        var basePlacement = (0, (0, parcelRequire("j9mpk")).default)(placement);
        var invertDistance = [
            (0, (0, parcelRequire("e2YFf")).left),
            (0, (0, parcelRequire("e2YFf")).top)
        ].indexOf(basePlacement) >= 0 ? -1 : 1;
        var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
            placement: placement
        })) : offset, skidding = _ref[0], distance = _ref[1];
        skidding = skidding || 0;
        distance = (distance || 0) * invertDistance;
        return [
            (0, (0, parcelRequire("e2YFf")).left),
            (0, (0, parcelRequire("e2YFf")).right)
        ].indexOf(basePlacement) >= 0 ? {
            x: distance,
            y: skidding
        } : {
            x: skidding,
            y: distance
        };
    }
    function $ce468c57ebe9fba2$var$offset(_ref2) {
        var state = _ref2.state, options = _ref2.options, name = _ref2.name;
        var _options$offset = options.offset, offset = _options$offset === void 0 ? [
            0,
            0
        ] : _options$offset;
        var data = (0, (0, parcelRequire("e2YFf")).placements).reduce(function(acc, placement) {
            acc[placement] = $ce468c57ebe9fba2$export$7fa02d8595b015ed(placement, state.rects, offset);
            return acc;
        }, {});
        var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
        if (state.modifiersData.popperOffsets != null) {
            state.modifiersData.popperOffsets.x += x;
            state.modifiersData.popperOffsets.y += y;
        }
        state.modifiersData[name] = data;
    }
    var $ce468c57ebe9fba2$export$2e2bcd8739ae039 = {
        name: 'offset',
        enabled: true,
        phase: 'main',
        requires: [
            'popperOffsets'
        ],
        fn: $ce468c57ebe9fba2$var$offset
    };
});
parcelRegister("a20zu", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$74da88c18e1bf1ad$export$2e2bcd8739ae039);
    var $jmkt6;
    var $j9mpk;
    var $akgJU;
    var $kb66N;
    var $xYYSU;
    var $e2YFf;
    var $3VNj3;
    function $74da88c18e1bf1ad$var$getExpandedFallbackPlacements(placement) {
        if ((0, (0, parcelRequire("j9mpk")).default)(placement) === (0, (0, parcelRequire("e2YFf")).auto)) return [];
        var oppositePlacement = (0, (0, parcelRequire("jmkt6")).default)(placement);
        return [
            (0, (0, parcelRequire("akgJU")).default)(placement),
            oppositePlacement,
            (0, (0, parcelRequire("akgJU")).default)(oppositePlacement)
        ];
    }
    function $74da88c18e1bf1ad$var$flip(_ref) {
        var state = _ref.state, options = _ref.options, name = _ref.name;
        if (state.modifiersData[name]._skip) return;
        var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
        var preferredPlacement = state.options.placement;
        var basePlacement = (0, (0, parcelRequire("j9mpk")).default)(preferredPlacement);
        var isBasePlacement = basePlacement === preferredPlacement;
        var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
            (0, (0, parcelRequire("jmkt6")).default)(preferredPlacement)
        ] : $74da88c18e1bf1ad$var$getExpandedFallbackPlacements(preferredPlacement));
        var placements = [
            preferredPlacement
        ].concat(fallbackPlacements).reduce(function(acc, placement) {
            return acc.concat((0, (0, parcelRequire("j9mpk")).default)(placement) === (0, (0, parcelRequire("e2YFf")).auto) ? (0, (0, parcelRequire("xYYSU")).default)(state, {
                placement: placement,
                boundary: boundary,
                rootBoundary: rootBoundary,
                padding: padding,
                flipVariations: flipVariations,
                allowedAutoPlacements: allowedAutoPlacements
            }) : placement);
        }, []);
        var referenceRect = state.rects.reference;
        var popperRect = state.rects.popper;
        var checksMap = new Map();
        var makeFallbackChecks = true;
        var firstFittingPlacement = placements[0];
        for(var i = 0; i < placements.length; i++){
            var placement = placements[i];
            var _basePlacement = (0, (0, parcelRequire("j9mpk")).default)(placement);
            var isStartVariation = (0, (0, parcelRequire("3VNj3")).default)(placement) === (0, (0, parcelRequire("e2YFf")).start);
            var isVertical = [
                (0, (0, parcelRequire("e2YFf")).top),
                (0, (0, parcelRequire("e2YFf")).bottom)
            ].indexOf(_basePlacement) >= 0;
            var len = isVertical ? 'width' : 'height';
            var overflow = (0, (0, parcelRequire("kb66N")).default)(state, {
                placement: placement,
                boundary: boundary,
                rootBoundary: rootBoundary,
                altBoundary: altBoundary,
                padding: padding
            });
            var mainVariationSide = isVertical ? isStartVariation ? (0, (0, parcelRequire("e2YFf")).right) : (0, (0, parcelRequire("e2YFf")).left) : isStartVariation ? (0, (0, parcelRequire("e2YFf")).bottom) : (0, (0, parcelRequire("e2YFf")).top);
            if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, (0, parcelRequire("jmkt6")).default)(mainVariationSide);
            var altVariationSide = (0, (0, parcelRequire("jmkt6")).default)(mainVariationSide);
            var checks = [];
            if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
            if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
            if (checks.every(function(check) {
                return check;
            })) {
                firstFittingPlacement = placement;
                makeFallbackChecks = false;
                break;
            }
            checksMap.set(placement, checks);
        }
        if (makeFallbackChecks) {
            var numberOfChecks = flipVariations ? 3 : 1;
            var _loop = function _loop(_i) {
                var fittingPlacement = placements.find(function(placement) {
                    var checks = checksMap.get(placement);
                    if (checks) return checks.slice(0, _i).every(function(check) {
                        return check;
                    });
                });
                if (fittingPlacement) {
                    firstFittingPlacement = fittingPlacement;
                    return "break";
                }
            };
            for(var _i = numberOfChecks; _i > 0; _i--){
                var _ret = _loop(_i);
                if (_ret === "break") break;
            }
        }
        if (state.placement !== firstFittingPlacement) {
            state.modifiersData[name]._skip = true;
            state.placement = firstFittingPlacement;
            state.reset = true;
        }
    }
    var $74da88c18e1bf1ad$export$2e2bcd8739ae039 = {
        name: 'flip',
        enabled: true,
        phase: 'main',
        fn: $74da88c18e1bf1ad$var$flip,
        requiresIfExists: [
            'offset'
        ],
        data: {
            _skip: false
        }
    };
});
parcelRegister("jmkt6", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$e17ff2fc84215f3e$export$2e2bcd8739ae039);
    var $e17ff2fc84215f3e$var$hash = {
        left: 'right',
        right: 'left',
        bottom: 'top',
        top: 'bottom'
    };
    function $e17ff2fc84215f3e$export$2e2bcd8739ae039(placement) {
        return placement.replace(/left|right|bottom|top/g, function(matched) {
            return $e17ff2fc84215f3e$var$hash[matched];
        });
    }
});
parcelRegister("akgJU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7848c1c349945010$export$2e2bcd8739ae039);
    var $7848c1c349945010$var$hash = {
        start: 'end',
        end: 'start'
    };
    function $7848c1c349945010$export$2e2bcd8739ae039(placement) {
        return placement.replace(/start|end/g, function(matched) {
            return $7848c1c349945010$var$hash[matched];
        });
    }
});
parcelRegister("kb66N", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$eb0992bfe43fdb98$export$2e2bcd8739ae039);
    var $240nb;
    var $fVbyj;
    var $861mM;
    var $dMroj;
    var $agoTm;
    var $e2YFf;
    var $49wse;
    var $4I7vH;
    var $6DetQ;
    function $eb0992bfe43fdb98$export$2e2bcd8739ae039(state, options) {
        if (options === void 0) options = {};
        var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, (0, parcelRequire("e2YFf")).clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, (0, parcelRequire("e2YFf")).viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, (0, parcelRequire("e2YFf")).popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
        var paddingObject = (0, (0, parcelRequire("4I7vH")).default)(typeof padding !== 'number' ? padding : (0, (0, parcelRequire("6DetQ")).default)(padding, (0, (0, parcelRequire("e2YFf")).basePlacements)));
        var altContext = elementContext === (0, (0, parcelRequire("e2YFf")).popper) ? (0, (0, parcelRequire("e2YFf")).reference) : (0, (0, parcelRequire("e2YFf")).popper);
        var popperRect = state.rects.popper;
        var element = state.elements[altBoundary ? altContext : elementContext];
        var clippingClientRect = (0, (0, parcelRequire("240nb")).default)((0, (0, parcelRequire("49wse")).isElement)(element) ? element : element.contextElement || (0, (0, parcelRequire("fVbyj")).default)(state.elements.popper), boundary, rootBoundary, strategy);
        var referenceClientRect = (0, (0, parcelRequire("861mM")).default)(state.elements.reference);
        var popperOffsets = (0, (0, parcelRequire("dMroj")).default)({
            reference: referenceClientRect,
            element: popperRect,
            strategy: 'absolute',
            placement: placement
        });
        var popperClientRect = (0, (0, parcelRequire("agoTm")).default)(Object.assign({}, popperRect, popperOffsets));
        var elementClientRect = elementContext === (0, (0, parcelRequire("e2YFf")).popper) ? popperClientRect : referenceClientRect;
        var overflowOffsets = {
            top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
            bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
            left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
            right: elementClientRect.right - clippingClientRect.right + paddingObject.right
        };
        var offsetData = state.modifiersData.offset;
        if (elementContext === (0, (0, parcelRequire("e2YFf")).popper) && offsetData) {
            var offset = offsetData[placement];
            Object.keys(overflowOffsets).forEach(function(key) {
                var multiply = [
                    (0, (0, parcelRequire("e2YFf")).right),
                    (0, (0, parcelRequire("e2YFf")).bottom)
                ].indexOf(key) >= 0 ? 1 : -1;
                var axis = [
                    (0, (0, parcelRequire("e2YFf")).top),
                    (0, (0, parcelRequire("e2YFf")).bottom)
                ].indexOf(key) >= 0 ? 'y' : 'x';
                overflowOffsets[key] += offset[axis] * multiply;
            });
        }
        return overflowOffsets;
    }
});
parcelRegister("240nb", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$180c3e86dcd2f87c$export$2e2bcd8739ae039);
    var $e2YFf;
    var $5CQTs;
    var $cUrUp;
    var $liMGx;
    var $4Ae4p;
    var $fVbyj;
    var $ctZLK;
    var $49wse;
    var $861mM;
    var $jFVZH;
    var $aMVvs;
    var $jVmXH;
    var $agoTm;
    var $asHtE;
    function $180c3e86dcd2f87c$var$getInnerBoundingClientRect(element, strategy) {
        var rect = (0, (0, parcelRequire("861mM")).default)(element, false, strategy === 'fixed');
        rect.top = rect.top + element.clientTop;
        rect.left = rect.left + element.clientLeft;
        rect.bottom = rect.top + element.clientHeight;
        rect.right = rect.left + element.clientWidth;
        rect.width = element.clientWidth;
        rect.height = element.clientHeight;
        rect.x = rect.left;
        rect.y = rect.top;
        return rect;
    }
    function $180c3e86dcd2f87c$var$getClientRectFromMixedType(element, clippingParent, strategy) {
        return clippingParent === (0, (0, parcelRequire("e2YFf")).viewport) ? (0, (0, parcelRequire("agoTm")).default)((0, (0, parcelRequire("5CQTs")).default)(element, strategy)) : (0, (0, parcelRequire("49wse")).isElement)(clippingParent) ? $180c3e86dcd2f87c$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, (0, parcelRequire("agoTm")).default)((0, (0, parcelRequire("cUrUp")).default)((0, (0, parcelRequire("fVbyj")).default)(element)));
    }
    function $180c3e86dcd2f87c$var$getClippingParents(element) {
        var clippingParents = (0, (0, parcelRequire("liMGx")).default)((0, (0, parcelRequire("jFVZH")).default)(element));
        var canEscapeClipping = [
            'absolute',
            'fixed'
        ].indexOf((0, (0, parcelRequire("ctZLK")).default)(element).position) >= 0;
        var clipperElement = canEscapeClipping && (0, (0, parcelRequire("49wse")).isHTMLElement)(element) ? (0, (0, parcelRequire("4Ae4p")).default)(element) : element;
        if (!(0, (0, parcelRequire("49wse")).isElement)(clipperElement)) return [];
        return clippingParents.filter(function(clippingParent) {
            return (0, (0, parcelRequire("49wse")).isElement)(clippingParent) && (0, (0, parcelRequire("aMVvs")).default)(clippingParent, clipperElement) && (0, (0, parcelRequire("jVmXH")).default)(clippingParent) !== 'body';
        });
    }
    function $180c3e86dcd2f87c$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
        var mainClippingParents = boundary === 'clippingParents' ? $180c3e86dcd2f87c$var$getClippingParents(element) : [].concat(boundary);
        var clippingParents = [].concat(mainClippingParents, [
            rootBoundary
        ]);
        var firstClippingParent = clippingParents[0];
        var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
            var rect = $180c3e86dcd2f87c$var$getClientRectFromMixedType(element, clippingParent, strategy);
            accRect.top = (0, (0, parcelRequire("asHtE")).max)(rect.top, accRect.top);
            accRect.right = (0, (0, parcelRequire("asHtE")).min)(rect.right, accRect.right);
            accRect.bottom = (0, (0, parcelRequire("asHtE")).min)(rect.bottom, accRect.bottom);
            accRect.left = (0, (0, parcelRequire("asHtE")).max)(rect.left, accRect.left);
            return accRect;
        }, $180c3e86dcd2f87c$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
        clippingRect.width = clippingRect.right - clippingRect.left;
        clippingRect.height = clippingRect.bottom - clippingRect.top;
        clippingRect.x = clippingRect.left;
        clippingRect.y = clippingRect.top;
        return clippingRect;
    }
});
parcelRegister("5CQTs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$418987e551afe718$export$2e2bcd8739ae039);
    var $4tZah;
    var $fVbyj;
    var $3p4xw;
    var $9bn5x;
    function $418987e551afe718$export$2e2bcd8739ae039(element, strategy) {
        var win = (0, (0, parcelRequire("4tZah")).default)(element);
        var html = (0, (0, parcelRequire("fVbyj")).default)(element);
        var visualViewport = win.visualViewport;
        var width = html.clientWidth;
        var height = html.clientHeight;
        var x = 0;
        var y = 0;
        if (visualViewport) {
            width = visualViewport.width;
            height = visualViewport.height;
            var layoutViewport = (0, (0, parcelRequire("9bn5x")).default)();
            if (layoutViewport || !layoutViewport && strategy === 'fixed') {
                x = visualViewport.offsetLeft;
                y = visualViewport.offsetTop;
            }
        }
        return {
            width: width,
            height: height,
            x: x + (0, (0, parcelRequire("3p4xw")).default)(element),
            y: y
        };
    }
});
parcelRegister("cUrUp", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$96605d1e3b809cd4$export$2e2bcd8739ae039);
    var $fVbyj;
    var $ctZLK;
    var $3p4xw;
    var $dbYNm;
    var $asHtE;
    function $96605d1e3b809cd4$export$2e2bcd8739ae039(element) {
        var _element$ownerDocumen;
        var html = (0, (0, parcelRequire("fVbyj")).default)(element);
        var winScroll = (0, (0, parcelRequire("dbYNm")).default)(element);
        var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
        var width = (0, (0, parcelRequire("asHtE")).max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
        var height = (0, (0, parcelRequire("asHtE")).max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
        var x = -winScroll.scrollLeft + (0, (0, parcelRequire("3p4xw")).default)(element);
        var y = -winScroll.scrollTop;
        if ((0, (0, parcelRequire("ctZLK")).default)(body || html).direction === 'rtl') x += (0, (0, parcelRequire("asHtE")).max)(html.clientWidth, body ? body.clientWidth : 0) - width;
        return {
            width: width,
            height: height,
            x: x,
            y: y
        };
    }
});
parcelRegister("aMVvs", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$7daafea4cdd8a599$export$2e2bcd8739ae039);
    var $49wse;
    function $7daafea4cdd8a599$export$2e2bcd8739ae039(parent, child) {
        var rootNode = child.getRootNode && child.getRootNode();
        if (parent.contains(child)) return true;
        else if (rootNode && (0, (0, parcelRequire("49wse")).isShadowRoot)(rootNode)) {
            var next = child;
            do {
                if (next && parent.isSameNode(next)) return true;
                next = next.parentNode || next.host;
            }while (next)
        }
        return false;
    }
});
parcelRegister("agoTm", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$778eb4fefa402e23$export$2e2bcd8739ae039);
    function $778eb4fefa402e23$export$2e2bcd8739ae039(rect) {
        return Object.assign({}, rect, {
            left: rect.x,
            top: rect.y,
            right: rect.x + rect.width,
            bottom: rect.y + rect.height
        });
    }
});
parcelRegister("4I7vH", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$36e118df3bac2bb9$export$2e2bcd8739ae039);
    var $1BXbW;
    function $36e118df3bac2bb9$export$2e2bcd8739ae039(paddingObject) {
        return Object.assign({}, (0, (0, parcelRequire("1BXbW")).default)(), paddingObject);
    }
});
parcelRegister("1BXbW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$12c7296361f3b238$export$2e2bcd8739ae039);
    function $12c7296361f3b238$export$2e2bcd8739ae039() {
        return {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0
        };
    }
});
parcelRegister("6DetQ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$4d419e1810273975$export$2e2bcd8739ae039);
    function $4d419e1810273975$export$2e2bcd8739ae039(value, keys) {
        return keys.reduce(function(hashMap, key) {
            hashMap[key] = value;
            return hashMap;
        }, {});
    }
});
parcelRegister("xYYSU", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$066262bd906ca4b5$export$2e2bcd8739ae039);
    var $3VNj3;
    var $e2YFf;
    var $kb66N;
    var $j9mpk;
    function $066262bd906ca4b5$export$2e2bcd8739ae039(state, options) {
        if (options === void 0) options = {};
        var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, (0, parcelRequire("e2YFf")).placements) : _options$allowedAutoP;
        var variation = (0, (0, parcelRequire("3VNj3")).default)(placement);
        var placements = variation ? flipVariations ? (0, (0, parcelRequire("e2YFf")).variationPlacements) : (0, (0, parcelRequire("e2YFf")).variationPlacements).filter(function(placement) {
            return (0, (0, parcelRequire("3VNj3")).default)(placement) === variation;
        }) : (0, (0, parcelRequire("e2YFf")).basePlacements);
        var allowedPlacements = placements.filter(function(placement) {
            return allowedAutoPlacements.indexOf(placement) >= 0;
        });
        if (allowedPlacements.length === 0) allowedPlacements = placements;
        var overflows = allowedPlacements.reduce(function(acc, placement) {
            acc[placement] = (0, (0, parcelRequire("kb66N")).default)(state, {
                placement: placement,
                boundary: boundary,
                rootBoundary: rootBoundary,
                padding: padding
            })[(0, (0, parcelRequire("j9mpk")).default)(placement)];
            return acc;
        }, {});
        return Object.keys(overflows).sort(function(a, b) {
            return overflows[a] - overflows[b];
        });
    }
});
parcelRegister("byg8Y", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$868f647925e44d69$export$2e2bcd8739ae039);
    var $e2YFf;
    var $j9mpk;
    var $gbIja;
    var $g0eTI;
    var $2JB9F;
    var $hbezI;
    var $4Ae4p;
    var $kb66N;
    var $3VNj3;
    var $1BXbW;
    var $asHtE;
    function $868f647925e44d69$var$preventOverflow(_ref) {
        var state = _ref.state, options = _ref.options, name = _ref.name;
        var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
        var overflow = (0, (0, parcelRequire("kb66N")).default)(state, {
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            altBoundary: altBoundary
        });
        var basePlacement = (0, (0, parcelRequire("j9mpk")).default)(state.placement);
        var variation = (0, (0, parcelRequire("3VNj3")).default)(state.placement);
        var isBasePlacement = !variation;
        var mainAxis = (0, (0, parcelRequire("gbIja")).default)(basePlacement);
        var altAxis = (0, (0, parcelRequire("g0eTI")).default)(mainAxis);
        var popperOffsets = state.modifiersData.popperOffsets;
        var referenceRect = state.rects.reference;
        var popperRect = state.rects.popper;
        var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
            placement: state.placement
        })) : tetherOffset;
        var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
            mainAxis: tetherOffsetValue,
            altAxis: tetherOffsetValue
        } : Object.assign({
            mainAxis: 0,
            altAxis: 0
        }, tetherOffsetValue);
        var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
        var data = {
            x: 0,
            y: 0
        };
        if (!popperOffsets) return;
        if (checkMainAxis) {
            var _offsetModifierState$;
            var mainSide = mainAxis === 'y' ? (0, (0, parcelRequire("e2YFf")).top) : (0, (0, parcelRequire("e2YFf")).left);
            var altSide = mainAxis === 'y' ? (0, (0, parcelRequire("e2YFf")).bottom) : (0, (0, parcelRequire("e2YFf")).right);
            var len = mainAxis === 'y' ? 'height' : 'width';
            var offset = popperOffsets[mainAxis];
            var min = offset + overflow[mainSide];
            var max = offset - overflow[altSide];
            var additive = tether ? -popperRect[len] / 2 : 0;
            var minLen = variation === (0, (0, parcelRequire("e2YFf")).start) ? referenceRect[len] : popperRect[len];
            var maxLen = variation === (0, (0, parcelRequire("e2YFf")).start) ? -popperRect[len] : -referenceRect[len];
            var arrowElement = state.elements.arrow;
            var arrowRect = tether && arrowElement ? (0, (0, parcelRequire("hbezI")).default)(arrowElement) : {
                width: 0,
                height: 0
            };
            var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, (0, parcelRequire("1BXbW")).default)();
            var arrowPaddingMin = arrowPaddingObject[mainSide];
            var arrowPaddingMax = arrowPaddingObject[altSide];
            var arrowLen = (0, (0, parcelRequire("2JB9F")).within)(0, referenceRect[len], arrowRect[len]);
            var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
            var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
            var arrowOffsetParent = state.elements.arrow && (0, (0, parcelRequire("4Ae4p")).default)(state.elements.arrow);
            var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
            var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
            var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
            var tetherMax = offset + maxOffset - offsetModifierValue;
            var preventedOffset = (0, (0, parcelRequire("2JB9F")).within)(tether ? (0, (0, parcelRequire("asHtE")).min)(min, tetherMin) : min, offset, tether ? (0, (0, parcelRequire("asHtE")).max)(max, tetherMax) : max);
            popperOffsets[mainAxis] = preventedOffset;
            data[mainAxis] = preventedOffset - offset;
        }
        if (checkAltAxis) {
            var _offsetModifierState$2;
            var _mainSide = mainAxis === 'x' ? (0, (0, parcelRequire("e2YFf")).top) : (0, (0, parcelRequire("e2YFf")).left);
            var _altSide = mainAxis === 'x' ? (0, (0, parcelRequire("e2YFf")).bottom) : (0, (0, parcelRequire("e2YFf")).right);
            var _offset = popperOffsets[altAxis];
            var _len = altAxis === 'y' ? 'height' : 'width';
            var _min = _offset + overflow[_mainSide];
            var _max = _offset - overflow[_altSide];
            var isOriginSide = [
                (0, (0, parcelRequire("e2YFf")).top),
                (0, (0, parcelRequire("e2YFf")).left)
            ].indexOf(basePlacement) !== -1;
            var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
            var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
            var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
            var _preventedOffset = tether && isOriginSide ? (0, (0, parcelRequire("2JB9F")).withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, (0, parcelRequire("2JB9F")).within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
            popperOffsets[altAxis] = _preventedOffset;
            data[altAxis] = _preventedOffset - _offset;
        }
        state.modifiersData[name] = data;
    }
    var $868f647925e44d69$export$2e2bcd8739ae039 = {
        name: 'preventOverflow',
        enabled: true,
        phase: 'main',
        fn: $868f647925e44d69$var$preventOverflow,
        requiresIfExists: [
            'offset'
        ]
    };
});
parcelRegister("g0eTI", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ba6833c805ad3c93$export$2e2bcd8739ae039);
    function $ba6833c805ad3c93$export$2e2bcd8739ae039(axis) {
        return axis === 'x' ? 'y' : 'x';
    }
});
parcelRegister("2JB9F", function(module, exports) {
    $parcel$export(module.exports, "within", ()=>$1fdc9aea7b0c4ec0$export$f28d906d67a997f3);
    $parcel$export(module.exports, "withinMaxClamp", ()=>$1fdc9aea7b0c4ec0$export$86c8af6d3ef0b4a);
    var $asHtE;
    function $1fdc9aea7b0c4ec0$export$f28d906d67a997f3(min, value, max) {
        return (0, (0, parcelRequire("asHtE")).max)(min, (0, (0, parcelRequire("asHtE")).min)(value, max));
    }
    function $1fdc9aea7b0c4ec0$export$86c8af6d3ef0b4a(min, value, max) {
        var v = $1fdc9aea7b0c4ec0$export$f28d906d67a997f3(min, value, max);
        return v > max ? max : v;
    }
});
parcelRegister("9XETd", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$74095795cf93fc91$export$2e2bcd8739ae039);
    var $j9mpk;
    var $hbezI;
    var $aMVvs;
    var $4Ae4p;
    var $gbIja;
    var $2JB9F;
    var $4I7vH;
    var $6DetQ;
    var $e2YFf;
    var $74095795cf93fc91$var$toPaddingObject = function toPaddingObject(padding, state) {
        padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
            placement: state.placement
        })) : padding;
        return (0, (0, parcelRequire("4I7vH")).default)(typeof padding !== 'number' ? padding : (0, (0, parcelRequire("6DetQ")).default)(padding, (0, (0, parcelRequire("e2YFf")).basePlacements)));
    };
    function $74095795cf93fc91$var$arrow(_ref) {
        var _state$modifiersData$;
        var state = _ref.state, name = _ref.name, options = _ref.options;
        var arrowElement = state.elements.arrow;
        var popperOffsets = state.modifiersData.popperOffsets;
        var basePlacement = (0, (0, parcelRequire("j9mpk")).default)(state.placement);
        var axis = (0, (0, parcelRequire("gbIja")).default)(basePlacement);
        var isVertical = [
            (0, (0, parcelRequire("e2YFf")).left),
            (0, (0, parcelRequire("e2YFf")).right)
        ].indexOf(basePlacement) >= 0;
        var len = isVertical ? 'height' : 'width';
        if (!arrowElement || !popperOffsets) return;
        var paddingObject = $74095795cf93fc91$var$toPaddingObject(options.padding, state);
        var arrowRect = (0, (0, parcelRequire("hbezI")).default)(arrowElement);
        var minProp = axis === 'y' ? (0, (0, parcelRequire("e2YFf")).top) : (0, (0, parcelRequire("e2YFf")).left);
        var maxProp = axis === 'y' ? (0, (0, parcelRequire("e2YFf")).bottom) : (0, (0, parcelRequire("e2YFf")).right);
        var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
        var startDiff = popperOffsets[axis] - state.rects.reference[axis];
        var arrowOffsetParent = (0, (0, parcelRequire("4Ae4p")).default)(arrowElement);
        var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
        var centerToReference = endDiff / 2 - startDiff / 2;
        var min = paddingObject[minProp];
        var max = clientSize - arrowRect[len] - paddingObject[maxProp];
        var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
        var offset = (0, (0, parcelRequire("2JB9F")).within)(min, center, max);
        var axisProp = axis;
        state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
    }
    function $74095795cf93fc91$var$effect(_ref2) {
        var state = _ref2.state, options = _ref2.options;
        var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
        if (arrowElement == null) return;
        if (typeof arrowElement === 'string') {
            arrowElement = state.elements.popper.querySelector(arrowElement);
            if (!arrowElement) return;
        }
        if (!(0, (0, parcelRequire("aMVvs")).default)(state.elements.popper, arrowElement)) return;
        state.elements.arrow = arrowElement;
    }
    var $74095795cf93fc91$export$2e2bcd8739ae039 = {
        name: 'arrow',
        enabled: true,
        phase: 'main',
        fn: $74095795cf93fc91$var$arrow,
        effect: $74095795cf93fc91$var$effect,
        requires: [
            'popperOffsets'
        ],
        requiresIfExists: [
            'preventOverflow'
        ]
    };
});
parcelRegister("lRyJl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fea97cf55e1c5bdd$export$2e2bcd8739ae039);
    var $e2YFf;
    var $kb66N;
    function $fea97cf55e1c5bdd$var$getSideOffsets(overflow, rect, preventedOffsets) {
        if (preventedOffsets === void 0) preventedOffsets = {
            x: 0,
            y: 0
        };
        return {
            top: overflow.top - rect.height - preventedOffsets.y,
            right: overflow.right - rect.width + preventedOffsets.x,
            bottom: overflow.bottom - rect.height + preventedOffsets.y,
            left: overflow.left - rect.width - preventedOffsets.x
        };
    }
    function $fea97cf55e1c5bdd$var$isAnySideFullyClipped(overflow) {
        return [
            (0, (0, parcelRequire("e2YFf")).top),
            (0, (0, parcelRequire("e2YFf")).right),
            (0, (0, parcelRequire("e2YFf")).bottom),
            (0, (0, parcelRequire("e2YFf")).left)
        ].some(function(side) {
            return overflow[side] >= 0;
        });
    }
    function $fea97cf55e1c5bdd$var$hide(_ref) {
        var state = _ref.state, name = _ref.name;
        var referenceRect = state.rects.reference;
        var popperRect = state.rects.popper;
        var preventedOffsets = state.modifiersData.preventOverflow;
        var referenceOverflow = (0, (0, parcelRequire("kb66N")).default)(state, {
            elementContext: 'reference'
        });
        var popperAltOverflow = (0, (0, parcelRequire("kb66N")).default)(state, {
            altBoundary: true
        });
        var referenceClippingOffsets = $fea97cf55e1c5bdd$var$getSideOffsets(referenceOverflow, referenceRect);
        var popperEscapeOffsets = $fea97cf55e1c5bdd$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
        var isReferenceHidden = $fea97cf55e1c5bdd$var$isAnySideFullyClipped(referenceClippingOffsets);
        var hasPopperEscaped = $fea97cf55e1c5bdd$var$isAnySideFullyClipped(popperEscapeOffsets);
        state.modifiersData[name] = {
            referenceClippingOffsets: referenceClippingOffsets,
            popperEscapeOffsets: popperEscapeOffsets,
            isReferenceHidden: isReferenceHidden,
            hasPopperEscaped: hasPopperEscaped
        };
        state.attributes.popper = Object.assign({}, state.attributes.popper, {
            'data-popper-reference-hidden': isReferenceHidden,
            'data-popper-escaped': hasPopperEscaped
        });
    }
    var $fea97cf55e1c5bdd$export$2e2bcd8739ae039 = {
        name: 'hide',
        enabled: true,
        phase: 'main',
        requiresIfExists: [
            'preventOverflow'
        ],
        fn: $fea97cf55e1c5bdd$var$hide
    };
});
parcelRegister("lr9Km", function(module, exports) {
    $parcel$export(module.exports, "Reference", ()=>$f9b3ae1ae85fd5ed$export$e0be378c32fb70a7);
    var $5uXOq = parcelRequire("5uXOq");
    var $hBYjV = parcelRequire("hBYjV");
    var $2w28i;
    var $etveP;
    function $f9b3ae1ae85fd5ed$export$e0be378c32fb70a7(_ref) {
        var children = _ref.children, innerRef = _ref.innerRef;
        var setReferenceNode = $5uXOq.useContext((0, (0, parcelRequire("2w28i")).ManagerReferenceNodeSetterContext));
        var refHandler = $5uXOq.useCallback(function(node) {
            (0, (0, parcelRequire("etveP")).setRef)(innerRef, node);
            (0, (0, parcelRequire("etveP")).safeInvoke)(setReferenceNode, node);
        }, [
            innerRef,
            setReferenceNode
        ]);
        $5uXOq.useEffect(function() {
            return function() {
                return (0, (0, parcelRequire("etveP")).setRef)(innerRef, null);
            };
        }, []);
        $5uXOq.useEffect(function() {
            (0, ($parcel$interopDefault($hBYjV)))(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
        }, [
            setReferenceNode
        ]);
        return (0, (0, parcelRequire("etveP")).unwrapArray)(children)({
            ref: refHandler
        });
    }
});
parcelRegister("4wJSY", function(module, exports) {
    $parcel$export(module.exports, "shallowEqualObjects", ()=>$34bdbe885d924a05$export$3e67810a3f0e9f1c);
    function $34bdbe885d924a05$export$967a6b9924a689f7(arrA, arrB) {
        if (arrA === arrB) return true;
        if (!arrA || !arrB) return false;
        const len = arrA.length;
        if (arrB.length !== len) return false;
        for(let i = 0; i < len; i++){
            if (arrA[i] !== arrB[i]) return false;
        }
        return true;
    }
    function $34bdbe885d924a05$export$3e67810a3f0e9f1c(objA, objB) {
        if (objA === objB) return true;
        if (!objA || !objB) return false;
        const aKeys = Object.keys(objA);
        const bKeys = Object.keys(objB);
        const len = aKeys.length;
        if (bKeys.length !== len) return false;
        for(let i = 0; i < len; i++){
            const key = aKeys[i];
            if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
        }
        return true;
    }
    function $34bdbe885d924a05$export$d36bdfa510afb180(a, b) {
        const aIsArr = Array.isArray(a);
        const bIsArr = Array.isArray(b);
        if (aIsArr !== bIsArr) return false;
        if (aIsArr && bIsArr) return $34bdbe885d924a05$export$967a6b9924a689f7(a, b);
        return $34bdbe885d924a05$export$3e67810a3f0e9f1c(a, b);
    }
});
parcelRegister("hhPK6", function(module, exports) {
    $parcel$export(module.exports, "MenuDialog", ()=>$640395697d9647ea$export$c94219dad7c0e37d);
    $parcel$export(module.exports, "DummyControl", ()=>$640395697d9647ea$export$87ce933b7fc29b8c);
    $parcel$export(module.exports, "defaultComponents", ()=>$640395697d9647ea$export$71abc632aa29e6fe);
    var $5uXOq = parcelRequire("5uXOq");
    var $f8Sb3;
    var $5Zz0F;
    var $2JKLA;
    var $bUQGL;
    var $AHUyh;
    function $640395697d9647ea$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
        return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
    }
    const $640395697d9647ea$var$menuDialogStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        zIndex: (0, (0, parcelRequire("bUQGL")).layers).modal(),
        backgroundColor: "var(--ds-surface-overlay, white)",
        borderRadius: "var(--ds-border-radius-100, 4px)",
        boxShadow: `var(--ds-shadow-overlay, ${`0 0 0 1px ${(0, $72ba03e317f3d228$export$46987b49aab6d1a8)}, 0 4px 11px ${(0, $72ba03e317f3d228$export$46987b49aab6d1a8)}`})`
    });
    const $640395697d9647ea$export$c94219dad7c0e37d = (0, $5uXOq.forwardRef)(({ maxWidth: maxWidth, minWidth: minWidth, children: children, id: id, style: style, testId: testId }, ref)=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ref: ref,
            css: [
                $640395697d9647ea$var$menuDialogStyles,
                {
                    maxWidth: maxWidth,
                    minWidth: minWidth
                }
            ],
            style: style,
            id: id,
            "data-testid": testId && `${testId}--menu`
        }, children));
    const $640395697d9647ea$var$dropdownStyles = {
        name: "7693z9",
        styles: "width:32px;margin-inline-end:var(--ds-space-025, 2px);text-align:center"
    };
    const $640395697d9647ea$var$DropdownIndicator = ()=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            css: $640395697d9647ea$var$dropdownStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, ($parcel$interopDefault((0, parcelRequire("5Zz0F"))))), {
            color: "currentColor",
            spacing: "spacious",
            label: "open"
        }));
    const $640395697d9647ea$var$controlStyles = (0, (0, parcelRequire("f8Sb3")).css)({
        padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-100, 8px)"} ${"var(--ds-space-050, 4px)"}`
    });
    const $640395697d9647ea$var$Control = ({ innerRef: innerRef, innerProps: innerProps, ...props })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", {
            ref: innerRef,
            css: $640395697d9647ea$var$controlStyles
        }, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2JKLA")).components).Control, {
            ...props,
            innerProps: innerProps
        }));
    const $640395697d9647ea$export$87ce933b7fc29b8c = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("AHUyh")).default), null, (0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2JKLA")).components).Control, props));
    const $640395697d9647ea$var$Menu = ({ children: children, innerProps: innerProps })=>(0, (0, parcelRequire("f8Sb3")).jsx)("div", innerProps, children);
    const $640395697d9647ea$var$IndicatorSeparator = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2JKLA")).components).IndicatorSeparator, props);
    const $640395697d9647ea$var$ClearIndicator = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2JKLA")).components).ClearIndicator, props);
    const $640395697d9647ea$var$MultiValueRemove = (props)=>(0, (0, parcelRequire("f8Sb3")).jsx)((0, (0, parcelRequire("2JKLA")).components).MultiValueRemove, props);
    const $640395697d9647ea$export$71abc632aa29e6fe = {
        Control: $640395697d9647ea$var$Control,
        DropdownIndicator: $640395697d9647ea$var$DropdownIndicator,
        Menu: $640395697d9647ea$var$Menu,
        IndicatorSeparator: $640395697d9647ea$var$IndicatorSeparator,
        ClearIndicator: $640395697d9647ea$var$ClearIndicator,
        MultiValueRemove: $640395697d9647ea$var$MultiValueRemove
    };
});
parcelRegister("5Zz0F", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $45cdce71504a0b34$var$_react = $45cdce71504a0b34$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $45cdce71504a0b34$var$_search = $45cdce71504a0b34$var$_interopRequireDefault((parcelRequire("682zz")));
    var $45cdce71504a0b34$var$_search2 = $45cdce71504a0b34$var$_interopRequireDefault((parcelRequire("c6suK")));
    function $45cdce71504a0b34$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $45cdce71504a0b34$var$SearchIcon = (props)=>$45cdce71504a0b34$var$_react.default.createElement($45cdce71504a0b34$var$_search.default, Object.assign({
            LEGACY_fallbackIcon: $45cdce71504a0b34$var$_search2.default
        }, props));
    $45cdce71504a0b34$var$SearchIcon.Name = 'SearchIconMigration';
    var $45cdce71504a0b34$var$_default = module.exports.default = $45cdce71504a0b34$var$SearchIcon;
});
parcelRegister("c6suK", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $8cfc261858871813$var$_react = $8cfc261858871813$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $7p1ve;
    var $8cfc261858871813$var$_search = $8cfc261858871813$var$_interopRequireDefault((parcelRequire("682zz")));
    function $8cfc261858871813$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $8cfc261858871813$var$EditorSearchIcon = (props)=>$8cfc261858871813$var$_react.default.createElement((0, parcelRequire("7p1ve")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M14.823 15.883a5.5 5.5 0 1 1 1.06-1.06l2.647 2.647c.293.293.53.59 0 1.06s-.767.293-1.06 0zM11.5 15.5a4 4 0 1 0 0-8 4 4 0 0 0 0 8"/></svg>`
        }, props, {
            newIcon: $8cfc261858871813$var$_search.default
        }));
    $8cfc261858871813$var$EditorSearchIcon.displayName = 'EditorSearchIcon';
    var $8cfc261858871813$var$_default = module.exports.default = $8cfc261858871813$var$EditorSearchIcon;
});
parcelRegister("dkvNx", function(module, exports) {
    $parcel$export(module.exports, "getIssueTypesSettingsUrl", ()=>$7576de1b6386c946$export$b9500524016e18f0);
    const $7576de1b6386c946$export$b9500524016e18f0 = (projectKey, isSimplified)=>isSimplified ? `/jira/core/projects/${projectKey}/settings/issuetypes` : `/plugins/servlet/project-config/${projectKey}/issuetypes`;
});
const $7462c685f739ed5a$export$3789e4b2a10baa2b = 'full';
const $7462c685f739ed5a$export$db1cdb8627b81f84 = 'compact';
const $7462c685f739ed5a$export$aca095bc476d426f = 'simple';
const $7462c685f739ed5a$export$1aad44a7533f8ad8 = 'table_row';
const $7462c685f739ed5a$export$d2f7b3f0efb6e208 = 'hidden';
const $7462c685f739ed5a$export$dda6912361cddac9 = 'visible';
const $7462c685f739ed5a$export$565566e3df4dad53 = 'blur';
const $7462c685f739ed5a$export$806b905ec7df742f = 'enter';
const $7462c685f739ed5a$export$2bb790b9008907b4 = 'escape';
const $7462c685f739ed5a$export$ba9f60edfdf2e66 = 'create_button';
const $7462c685f739ed5a$export$193356664cd84c83 = 255;
const $7462c685f739ed5a$export$f9e3e7ede9ba929d = 500;
const $7462c685f739ed5a$export$e0bc602b327f818b = 'add-issue-type-option';
parcelRegister("8OpiR", function(module, exports) {
    $parcel$export(module.exports, "CREATE_ISSUE_EXPERIENCE", ()=>$1b5c59748aee9f18$export$ed625f60643a6c30);
    const $1b5c59748aee9f18$export$ed625f60643a6c30 = {
        experience: 'createIssue',
        packageName: 'jiraBusinessIssueCreate',
        teamName: 'deliveroo'
    };
});
parcelRegister("6uB1c", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ab3aefe72ec8e0ad$export$2e2bcd8739ae039);
    var $7VHMR;
    var $ab3aefe72ec8e0ad$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        placeholderText: {
            "id": "business-issue-create.inline-create-form.placeholder-text",
            "defaultMessage": "What needs to be done?"
        },
        createButton: {
            "id": "business-issue-create.inline-create-form.create-button",
            "defaultMessage": "Create"
        },
        selectIssueTypeButton: {
            "id": "business-issue-create.inline-create-form.select-issue-type-button",
            "defaultMessage": "Select issue type. {issueType} currently selected."
        },
        createIssueTypes: {
            "id": "business-issue-create.inline-create-form.create-issue-types",
            "defaultMessage": "Create issue type"
        },
        createIssueTypesIssueTermRefresh: {
            "id": "business-issue-create.inline-create-form.create-issue-types-issue-term-refresh",
            "defaultMessage": "Create work type"
        },
        manageIssueTypes: {
            "id": "business-issue-create.inline-create-form.manage-issue-types",
            "defaultMessage": "Manage types"
        },
        selectIssueTypeButtonIssueTermRefresh: {
            "id": "business-issue-create.inline-create-form.select-issue-type-button-issue-term-refresh",
            "defaultMessage": "Select work type. {issueType} currently selected."
        },
        loadingIssueCreateForm: {
            "id": "business-issue-create.inline-create-form.loading-issue-types",
            "defaultMessage": "Loading issue create form"
        }
    });
});
parcelRegister("t9aRF", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$56358a56fb81f180$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1h2s1;
    const $56358a56fb81f180$var$ReturnGlyph = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "24",
            height: "16",
            viewBox: "0 0 24 16",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M3 0C1.34315 0 0 1.34315 0 3V13C0 14.6569 1.34315 16 3 16H21C22.6569 16 24 14.6569 24 13V3C24 1.34315 22.6569 0 21 0H3Z",
            fill: "var(--ds-background-inverse-subtle, #FFFFFF)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M15.5 5.75V6.75C15.5 8.26878 14.2688 9.5 12.75 9.5H8.75C8.33579 9.5 8 9.16421 8 8.75C8 8.33579 8.33579 8 8.75 8H12.75C13.4404 8 14 7.44036 14 6.75V5.75C14 5.33579 14.3358 5 14.75 5C15.1642 5 15.5 5.33579 15.5 5.75Z",
            fill: "var(--ds-text-inverse, #FFFFFF)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M9.28033 9.28033L11.0303 7.53033C11.3232 7.23744 11.3232 6.76256 11.0303 6.46967C10.7374 6.17678 10.2626 6.17678 9.96967 6.46967L8.21967 8.21967C7.92678 8.51256 7.92678 8.98744 8.21967 9.28033C8.51256 9.57322 8.98744 9.57322 9.28033 9.28033Z",
            fill: "var(--ds-text-inverse, #FFFFFF)"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M9.28033 8.21967L11.0303 9.96967C11.3232 10.2626 11.3232 10.7374 11.0303 11.0303C10.7374 11.3232 10.2626 11.3232 9.96967 11.0303L8.21967 9.28033C7.92678 8.98744 7.92678 8.51256 8.21967 8.21967C8.51256 7.92678 8.98744 7.92678 9.28033 8.21967Z",
            fill: "var(--ds-text-inverse, #FFFFFF)"
        }));
    const $56358a56fb81f180$var$ReturnIcon = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1h2s1")).default), {
            glyph: $56358a56fb81f180$var$ReturnGlyph,
            label: ""
        });
    var $56358a56fb81f180$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($56358a56fb81f180$var$ReturnIcon);
});
parcelRegister("9hZ86", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$9cc9514c3a53b827$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $2mHtV;
    var $koVbs;
    var $ltFrh;
    const $9cc9514c3a53b827$var$InlineCreateTrigger = ({ onClick: onClick, minHeight: minHeight, borderRadius: borderRadius, horizontalPadding: horizontalPadding, isDisabled: isDisabled = false })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($9cc9514c3a53b827$var$Trigger, {
            borderRadius: borderRadius,
            "data-testid": "business-issue-create.ui.inline-create-trigger",
            horizontalPadding: horizontalPadding,
            minHeight: minHeight,
            onClick: onClick,
            disabled: isDisabled
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("2mHtV"))))), {
            label: "",
            size: "small"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement($9cc9514c3a53b827$var$Label, null, formatMessage((0, (0, parcelRequire("ltFrh")).default).createLabel)));
    };
    var $9cc9514c3a53b827$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($9cc9514c3a53b827$var$InlineCreateTrigger);
    const $9cc9514c3a53b827$var$Trigger = (0, $5uXOq.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { borderRadius: borderRadius, minHeight: minHeight, horizontalPadding: horizontalPadding, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_ri98hz": (0, (0, parcelRequire("lD23V")).default)(__cmplp.borderRadius ?? 0),
                "--_19b8a3e": (0, (0, parcelRequire("lD23V")).default)(__cmplp.minHeight ?? '32px'),
                "--_1w524p6": (0, (0, parcelRequire("lD23V")).default)(`0 ${__cmplp.horizontalPadding ?? "var(--ds-space-100, 8px)"}`)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _syaz1thw _bfhk18uv _19itglyw _1wybdlk8 _k48pbfng _2rko16jm _1tke1um9 _1yt414jf _zulph9hh _1bsb1osq _1jhm1q09 _y2mv1q09 _1ygb1q09 _13ro1n1a _1bg41n1a _1ah31n1a _irr3166n _1di61dty",
                __cmplp.disabled ? "_80om73ad" : "_80omtlke",
                __cmplp.className
            ])
        });
    });
    const $9cc9514c3a53b827$var$Label = (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("ltFrh", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$92994995ec79c48c$export$2e2bcd8739ae039);
    var $7VHMR;
    var $92994995ec79c48c$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        createLabel: {
            "id": "business-issue-create.inline-create-trigger.create-label",
            "defaultMessage": "Create"
        }
    });
});
parcelRegister("kI8fv", function(module, exports) {
    $parcel$export(module.exports, "useResizeObserver", ()=>$97dc17209ae59841$export$683480f191c0e3ea);
    var $5uXOq = parcelRequire("5uXOq");
    const $97dc17209ae59841$export$683480f191c0e3ea = (element, callback)=>{
        (0, $5uXOq.useEffect)(()=>{
            let resizeObserver;
            if (element && typeof ResizeObserver !== 'undefined') {
                resizeObserver = new ResizeObserver(callback);
                resizeObserver.observe(element);
            }
            return ()=>{
                if (resizeObserver) resizeObserver.disconnect();
            };
        }, [
            element,
            callback
        ]);
        return null;
    };
});
parcelRegister("5Xbjf", function(module, exports) {
    $parcel$export(module.exports, "TimelineAddItemNudgeAsync", ()=>$1b222342731224e1$export$be1e825e671d7036);
    var $5uXOq = parcelRequire("5uXOq");
    var $bBbEG;
    var $lfTZh;
    var $1jUsD;
    const $1b222342731224e1$var$TimelineAddItemNudgeLazy = (0, (0, parcelRequire("1jUsD")).lazyAfterPaint)(()=>(parcelRequire("hlOxU")).then((exportedModule)=>exportedModule.TimelineAddItemNudge), {
        ssr: false,
        moduleId: "./src/packages/software/onboarding-nudges/src/ui/jwm-timeline-nudge-tour/timeline-add-item/index.tsx"
    });
    const $1b222342731224e1$export$be1e825e671d7036 = ({ children: children, attributes: attributes })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bBbEG")).OnboardingNudgeErrorBoundary), {
            id: (0, $dbbf68c32d8c4308$export$2f06a16c987cc1a2),
            fallback: children,
            attributes: {
                nudgeId: (0, $6784cbc7d62e5d7c$export$468488291ccd988)
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "timeline-add-item-onboarding-nudge",
            fallback: children
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($1b222342731224e1$var$TimelineAddItemNudgeLazy, {
            attributes: attributes
        }, children)));
    $1b222342731224e1$export$be1e825e671d7036.displayName = 'TimelineAddItemNudgeAsync';
});
const $6784cbc7d62e5d7c$export$67abe0a3b8dfe03f = 'should-show-scrum-modal-v2';
const $6784cbc7d62e5d7c$export$4e1360a3e7785935 = 'should-show-kanban-modal';
const $6784cbc7d62e5d7c$export$e3884212029f7bef = 'should-show-welcome-modal';
const $6784cbc7d62e5d7c$export$eaf6b96a17b6476c = 'can-enroll-in-select-initial-view';
const $6784cbc7d62e5d7c$export$891ca65264b256bb = 'should-show-personlized-sample-data-for-kanban';
const $6784cbc7d62e5d7c$export$f47dca9dda77d157 = 'should-hide-quickstart-for-personalized-sample-data';
const $6784cbc7d62e5d7c$export$928ffae10e4c0006 = 'template-key-to-show-onboarding-modal';
const $6784cbc7d62e5d7c$export$8a00ecf6498ee2fe = 'onboarding-selected-project-template-type';
const $6784cbc7d62e5d7c$export$69fe8832c4f79a32 = 'onboarding_started_timestamp';
const $6784cbc7d62e5d7c$export$a8d62e500b59f31e = 'boardCreateColumnButtonNudge';
const $6784cbc7d62e5d7c$export$92c7f0eacc8d8d98 = 'assigneeFilterAddPeopleButtonNudge';
const $6784cbc7d62e5d7c$export$dd63d0099d95ba4f = 'navigationAppsNavItemNudge';
const $6784cbc7d62e5d7c$export$aba87e019f5ccb8d = 'navigationCreateIssueButtonNudge';
const $6784cbc7d62e5d7c$export$46d9a3d441dfd22b = 'navigationPlansNavItemNudge';
const $6784cbc7d62e5d7c$export$e20072f7d0c5357f = 'roadmapCreateEpicButtonNudge';
const $6784cbc7d62e5d7c$export$1e39959907a7f359 = 'roadmapCreateEpicChildIssueButtonNudge';
const $6784cbc7d62e5d7c$export$b74a8fdb2c75b869 = 'navigationPeopleNavItemNudge';
const $6784cbc7d62e5d7c$export$b1a6ab17737f33e = 'backlogAccordionNudge';
const $6784cbc7d62e5d7c$export$3366ddefe77d5112 = 'boardCreateColumnNudge';
const $6784cbc7d62e5d7c$export$9d9e95a66a2c6abe = 'addItemsCalendarNudge';
const $6784cbc7d62e5d7c$export$69aca8ebee0d34c8 = 'trelloCrossflowAddItemsCalendarNudge';
const $6784cbc7d62e5d7c$export$dd4b359b5a58cdc0 = 'trelloCrossflowTimelineTabNudge';
const $6784cbc7d62e5d7c$export$7aa8bceae32c7862 = 'navigationAppsProfileItemNudge';
const $6784cbc7d62e5d7c$export$c6df9a2c7447e12d = 'getStartedListNudge';
const $6784cbc7d62e5d7c$export$468488291ccd988 = 'timelineAddItemNudge';
const $6784cbc7d62e5d7c$export$7a33548109ac931d = 'createFormNudge';
const $6784cbc7d62e5d7c$export$b65ba9ea0c0ced43 = 'jsw-onboarding-checklist.open';
const $6784cbc7d62e5d7c$export$3b5d230b66f60471 = 'jsw-onboarding-checklist.visibility';
const $6784cbc7d62e5d7c$export$594d3436316492be = 'summaryViewNudge';
const $6784cbc7d62e5d7c$export$77bc79debbf5c069 = 'inviteTeamNudge';
parcelRegister("hlOxU", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1mJLv").then(()=>parcelRequire('bObW0'));
});
parcelRegister("u2fd8", function(module, exports) {
    $parcel$export(module.exports, "useOptimisticIssueCreate", ()=>$66d2e4bd5fb9ee40$export$d4c0864cc288e78a);
    var $5uXOq = parcelRequire("5uXOq");
    var $2HfxU = parcelRequire("2HfxU");
    var $daQYX;
    var $1T2vX;
    var $kRkJF;
    var $cLGgz;
    var $hlKA4;
    var $4R6GH;
    var $jrO9m;
    var $gNAqw;
    var $9A32U;
    var $evzMt;
    var $4GbhN;
    var $6qNs0;
    var $2qV0a;
    const $66d2e4bd5fb9ee40$export$d4c0864cc288e78a = ()=>{
        const { quickFiltersJql: quickFiltersJql, hierarchyParent: hierarchyParent, jqlContext: jqlContext, isHidingDoneItems: isHidingDoneItems } = (0, (0, parcelRequire("kRkJF")).useFilteredViewContextInput)({
            view: 'timeline'
        });
        const { hierarchyLevels: hierarchyLevels } = (0, (0, parcelRequire("1T2vX")).useIssueTypesAndFields)({
            issueOperation: 'VIEW'
        });
        const hierarchyLevel = (0, ($parcel$interopDefault($2HfxU)))(hierarchyLevels)?.level;
        const [{ issueParentMap: issueParentMap }] = (0, (0, parcelRequire("evzMt")).useIssueParentMap)();
        const { updateItemsInCache: updateItemsInCache, addToCache: addToCache, removeFromCache: removeFromCache } = (0, (0, parcelRequire("hlKA4")).useCacheActions)();
        const { data: overview } = (0, (0, parcelRequire("jrO9m")).useOverview)();
        const isOverview = overview != null && Array.isArray(overview.projects);
        let projectKey;
        if (!isOverview && (0, (0, parcelRequire("4R6GH")).fg)('timeline-uses-new-jql-parent-project-directive')) {
            const { key: key } = (0, (0, parcelRequire("daQYX")).useProject)();
            projectKey = key;
        }
        const getUpdateVariables = (0, $5uXOq.useCallback)((parentId)=>{
            const grandparentIssueId = issueParentMap.get(parentId);
            const baseVariables = {
                jqlContext: jqlContext,
                fieldIds: (0, parcelRequire("gNAqw")).fieldIds,
                quickFiltersJql: quickFiltersJql,
                isHidingDoneItems: isHidingDoneItems,
                ...projectKey ? {
                    projectIdOrKey: projectKey
                } : {}
            };
            if (grandparentIssueId && hierarchyParent) return (0, (0, parcelRequire("9A32U")).getVariables)({
                ...baseVariables,
                hierarchyParent: undefined,
                parentIssue: {
                    hierarchyType: hierarchyParent,
                    issueId: grandparentIssueId
                }
            });
            return (0, (0, parcelRequire("9A32U")).getVariables)({
                ...baseVariables,
                hierarchyLevel: hierarchyLevel,
                hierarchyParent: hierarchyParent
            });
        }, [
            hierarchyLevel,
            hierarchyParent,
            isHidingDoneItems,
            issueParentMap,
            jqlContext,
            projectKey,
            quickFiltersJql
        ]);
        const updateIssue = (0, $5uXOq.useCallback)((item, parentId)=>{
            if (parentId != null && hierarchyParent != null) {
                if ((0, (0, parcelRequire("cLGgz")).isOptimisticIssue)(item.issueId)) updateItemsInCache({
                    query: (0, (0, parcelRequire("6qNs0")).TIMELINE_VIEW_ITEMS_QUERY),
                    variables: getUpdateVariables(parentId),
                    issueIds: [
                        parentId
                    ],
                    updateItem: (0, (0, parcelRequire("2qV0a")).addChildToParentTimeline)
                });
                addToCache({
                    newNodes: [
                        item
                    ],
                    query: (0, (0, parcelRequire("6qNs0")).TIMELINE_VIEW_ITEMS_QUERY),
                    variables: (0, (0, parcelRequire("9A32U")).getVariables)({
                        jqlContext: jqlContext,
                        fieldIds: (0, parcelRequire("gNAqw")).fieldIds,
                        quickFiltersJql: quickFiltersJql,
                        isHidingDoneItems: isHidingDoneItems,
                        hierarchyParent: undefined,
                        parentIssue: {
                            hierarchyType: hierarchyParent,
                            issueId: parentId
                        },
                        ...projectKey ? {
                            projectIdOrKey: projectKey
                        } : {}
                    })
                });
                return;
            }
            addToCache({
                newNodes: [
                    item
                ],
                query: (0, (0, parcelRequire("6qNs0")).TIMELINE_VIEW_ITEMS_QUERY),
                variables: {
                    ...(0, (0, parcelRequire("9A32U")).getVariables)({
                        jqlContext: jqlContext,
                        fieldIds: (0, parcelRequire("gNAqw")).fieldIds,
                        quickFiltersJql: quickFiltersJql,
                        isHidingDoneItems: isHidingDoneItems,
                        hierarchyParent: hierarchyParent,
                        hierarchyLevel: hierarchyLevel,
                        ...projectKey ? {
                            projectIdOrKey: projectKey
                        } : {}
                    })
                }
            });
        }, [
            hierarchyParent,
            addToCache,
            jqlContext,
            quickFiltersJql,
            isHidingDoneItems,
            hierarchyLevel,
            projectKey,
            updateItemsInCache,
            getUpdateVariables
        ]);
        const addOptimisticIssue = (0, $5uXOq.useCallback)((issue, parentId)=>{
            const optimisticItem = (0, (0, parcelRequire("4GbhN")).createOptimisticIssue)(issue);
            updateIssue(optimisticItem, parentId);
        }, [
            updateIssue
        ]);
        const removeOptimisticIssue = (0, $5uXOq.useCallback)((issueId, parentId)=>{
            let variables;
            if (parentId != null && hierarchyParent != null) variables = (0, (0, parcelRequire("9A32U")).getVariables)({
                jqlContext: jqlContext,
                fieldIds: (0, parcelRequire("gNAqw")).fieldIds,
                quickFiltersJql: quickFiltersJql,
                isHidingDoneItems: isHidingDoneItems,
                hierarchyParent: undefined,
                parentIssue: {
                    hierarchyType: hierarchyParent,
                    issueId: parentId
                },
                ...projectKey ? {
                    projectIdOrKey: projectKey
                } : {}
            });
            else variables = (0, (0, parcelRequire("9A32U")).getVariables)({
                jqlContext: jqlContext,
                fieldIds: (0, parcelRequire("gNAqw")).fieldIds,
                quickFiltersJql: quickFiltersJql,
                isHidingDoneItems: isHidingDoneItems,
                hierarchyParent: hierarchyParent,
                hierarchyLevel: hierarchyLevel,
                ...projectKey ? {
                    projectIdOrKey: projectKey
                } : {}
            });
            removeFromCache({
                query: (0, (0, parcelRequire("6qNs0")).TIMELINE_VIEW_ITEMS_QUERY),
                variables: variables,
                issueId: issueId
            });
        }, [
            hierarchyParent,
            removeFromCache,
            jqlContext,
            quickFiltersJql,
            isHidingDoneItems,
            projectKey,
            hierarchyLevel
        ]);
        return {
            addOptimisticIssue: addOptimisticIssue,
            updateIssue: updateIssue,
            removeOptimisticIssue: removeOptimisticIssue
        };
    };
});
parcelRegister("4rVoq", function(module, exports) {
    $parcel$export(module.exports, "getIssueAfter", ()=>$41facd17283c00c4$export$3503751cbe8a73eb);
    var $1o48H;
    const $41facd17283c00c4$export$3503751cbe8a73eb = (containerHeight, expandedItems, height, issuesMap, items, timelineRef)=>{
        const scrollTop = timelineRef?.querySelector('#sr-timeline')?.scrollTop ?? 0;
        const maxHeightForAnchor = containerHeight + scrollTop - height * 2.5;
        let offset = 0;
        let itemIndexForStickyAnchor = 0;
        items.forEach((item, index)=>{
            if (offset < maxHeightForAnchor) {
                itemIndexForStickyAnchor = index;
                offset += height;
                if (expandedItems[item.id]) offset += (0, (0, parcelRequire("1o48H")).getTimelineTableItemsHeight)(item.childItems, expandedItems, height, false);
            }
        });
        const item = items[itemIndexForStickyAnchor];
        return item ? issuesMap.get(item.id) : undefined;
    };
});
parcelRegister("9jHuQ", function(module, exports) {
    $parcel$export(module.exports, "StickyInlineNudge", ()=>$05cf25fc5fcf09bd$export$bed5b0bc851c45b0);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $4R6GH;
    var $cE2Qr;
    var $lcYsh;
    var $g3prf;
    var $dCm1o;
    const $05cf25fc5fcf09bd$export$bed5b0bc851c45b0 = ({ listWidth: listWidth, height: height, loading: loading, timelineRef: timelineRef, isEmpty: isEmpty })=>{
        const [{ headerHeight: headerHeight }] = (0, (0, parcelRequire("g3prf")).useHeaderState)();
        const [nudgeStep, { setNudgeStep: setNudgeStep }] = (0, (0, parcelRequire("cE2Qr")).useNudgeStep)();
        if (loading || !timelineRef || nudgeStep !== 'timelineAddDateNudge') return null;
        const handleClick = ()=>{
            setNudgeStep('');
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lcYsh")).TimelineAddDateNudgeAsync), {
            attributes: {
                isEmpty: isEmpty
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($05cf25fc5fcf09bd$export$e6dfd72ab29f8598, {
            "data-testId": "business-timeline.ui.timeline-view.sticky-inline-nudge.wrapper",
            width: listWidth,
            height: height,
            offsetTop: headerHeight,
            onClick: isEmpty ? handleClick : undefined
        }));
    };
    const $05cf25fc5fcf09bd$var$RESIZE_HANDLE_SIZE = 2;
    const $05cf25fc5fcf09bd$var$wrapperBaseStyles = null;
    const $05cf25fc5fcf09bd$var$wrapperBaseStylesOld = null;
    const $05cf25fc5fcf09bd$export$e6dfd72ab29f8598 = ({ width: width, offsetTop: offsetTop, height: height, ...rest })=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
            style: {
                left: `${width - $05cf25fc5fcf09bd$var$RESIZE_HANDLE_SIZE}px`,
                top: `${offsetTop - 6}px`,
                width: `calc(100% - ${width - $05cf25fc5fcf09bd$var$RESIZE_HANDLE_SIZE}px)`,
                height: `${height - 3}px`
            },
            ...rest,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('visual-refresh_drop_1') ? "_kqswh2mm _1pbyidpf" : "_kqswh2mm _2rko6iej _1pbyidpf"
            ])
        });
});
parcelRegister("lcYsh", function(module, exports) {
    $parcel$export(module.exports, "TimelineAddDateNudgeAsync", ()=>$657ce3952738ee6c$export$1fb63fd3c0dfa456);
    var $5uXOq = parcelRequire("5uXOq");
    var $bBbEG;
    var $lfTZh;
    var $1jUsD;
    const $657ce3952738ee6c$var$TimelineAddDateNudgeLazy = (0, (0, parcelRequire("1jUsD")).lazyAfterPaint)(()=>(parcelRequire("h3sQb")).then((exportedModule)=>exportedModule.TimelineAddDateNudge), {
        ssr: false,
        moduleId: "./src/packages/software/onboarding-nudges/src/ui/jwm-timeline-nudge-tour/timeline-add-date/index.tsx"
    });
    const $657ce3952738ee6c$export$1fb63fd3c0dfa456 = ({ children: children, attributes: attributes })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bBbEG")).OnboardingNudgeErrorBoundary), {
            id: (0, $dbbf68c32d8c4308$export$2f06a16c987cc1a2),
            fallback: children,
            attributes: {
                nudgeId: (0, $dbbf68c32d8c4308$export$e34e81ed4f255f6e)
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "timeline-add-date-onboarding-nudge",
            fallback: children
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($657ce3952738ee6c$var$TimelineAddDateNudgeLazy, {
            attributes: attributes
        }, children)));
    $657ce3952738ee6c$export$1fb63fd3c0dfa456.displayName = 'TimelineAddDateNudgeAsync';
});
parcelRegister("h3sQb", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("1mQtn").then(()=>parcelRequire('kcKH8'));
});
parcelRegister("ft7xI", function(module, exports) {
    $parcel$export(module.exports, "TableProvider", ()=>$774ce707c3c906b6$export$d542ac353845c9cf);
    var $5uXOq = parcelRequire("5uXOq");
    var $gPXTo;
    const $774ce707c3c906b6$var$EMPTY_ARRAY = [];
    const $774ce707c3c906b6$export$d542ac353845c9cf = (props)=>{
        const { items: items, children: children } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("gPXTo")).RoadmapChartItemInteractionProvider), {
            intervals: $774ce707c3c906b6$var$EMPTY_ARRAY,
            items: items,
            isDragAlongEnabled: true
        }, children);
    };
});
parcelRegister("6El6u", function(module, exports) {
    $parcel$export(module.exports, "TimelineTableInlineCreate", ()=>$b921457c7ca94392$export$405c60de0f923a9);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $6Ll2T;
    var $99gde;
    var $113Tq;
    var $iFFYo;
    var $4R6GH;
    var $iZN6h;
    var $82CeN;
    var $gNAqw;
    var $1lN06;
    var $u2fd8;
    const $b921457c7ca94392$export$405c60de0f923a9 = ({ childrenQueryData: childrenQueryData, issuesMap: issuesMap, items: items })=>{
        const { focusCreateTrigger: focusCreateTrigger, removeActiveCreateTrigger: removeActiveCreateTrigger } = (0, (0, parcelRequire("82CeN")).useFocusMarshal)();
        const [{ createItemAnchor: createItemAnchor }, { setCreateItemAnchor: setCreateItemAnchor }] = (0, (0, parcelRequire("1lN06")).useCreateItemAnchor)();
        const { addOptimisticIssue: addOptimisticIssue, updateIssue: updateIssue, removeOptimisticIssue: removeOptimisticIssue } = (0, (0, parcelRequire("u2fd8")).useOptimisticIssueCreate)();
        const onPrepareIssueContext = (0, $5uXOq.useCallback)(()=>{
            const issueContext = {};
            if (createItemAnchor) {
                if (createItemAnchor.position === (0, (0, parcelRequire("iZN6h")).BEFORE)) {
                    issueContext.parentIssueId = createItemAnchor.parentId;
                    const issueForBeforeRank = createItemAnchor.beforeId ? issuesMap.get(createItemAnchor.beforeId) : null;
                    if (issueForBeforeRank?.issueId && issueForBeforeRank?.rank) issueContext.rankBefore = {
                        issueId: issueForBeforeRank.issueId,
                        rank: issueForBeforeRank.rank
                    };
                } else if (createItemAnchor.position === (0, (0, parcelRequire("iZN6h")).LAST)) {
                    const lastIssueId = items[items.length - 1]?.id;
                    const lastIssue = issuesMap.get(lastIssueId);
                    if (lastIssue?.issueId && lastIssue?.rank) issueContext.rankAfter = {
                        issueId: lastIssue.issueId,
                        rank: lastIssue.rank
                    };
                } else if (createItemAnchor.position === (0, (0, parcelRequire("iZN6h")).INSIDE)) {
                    const parentIssue = items.find((i)=>i.id === createItemAnchor.parentId);
                    const childItems = parentIssue?.childItems ?? [];
                    const lastChildWithinParent = childItems.length > 0 ? childItems[childItems.length - 1].id : null;
                    const lastChildWithinParentIssue = lastChildWithinParent ? issuesMap.get(lastChildWithinParent) : null;
                    issueContext.parentIssueId = createItemAnchor.parentId;
                    if (lastChildWithinParentIssue?.issueId && lastChildWithinParentIssue?.rank) issueContext.rankAfter = {
                        issueId: lastChildWithinParentIssue.issueId,
                        rank: lastChildWithinParentIssue.rank
                    };
                }
            }
            return issueContext;
        }, [
            createItemAnchor,
            issuesMap,
            items
        ]);
        const onSubmit = (0, $5uXOq.useCallback)(async ({ optimisticIssuePayload: optimisticIssuePayload, promise: promise })=>{
            addOptimisticIssue(optimisticIssuePayload, optimisticIssuePayload.parentIssueId);
            try {
                const issue = await promise;
                if (issue) updateIssue(issue, optimisticIssuePayload.parentIssueId);
                else removeOptimisticIssue(optimisticIssuePayload.issueId, optimisticIssuePayload.parentIssueId);
            } catch  {
                removeOptimisticIssue(optimisticIssuePayload.issueId, optimisticIssuePayload.parentIssueId);
            }
        }, [
            addOptimisticIssue,
            updateIssue,
            removeOptimisticIssue
        ]);
        const onBlur = (0, $5uXOq.useCallback)((event)=>{
            if ((0, (0, parcelRequire("4R6GH")).fg)('jsw_roadmaps_timeline_table_meatballs_menu_a11y')) {
                const nativeEvent = event?.nativeEvent;
                if (nativeEvent instanceof KeyboardEvent && nativeEvent.key === 'Escape') focusCreateTrigger();
                else removeActiveCreateTrigger();
            }
            setCreateItemAnchor(undefined);
        }, [
            focusCreateTrigger,
            removeActiveCreateTrigger,
            setCreateItemAnchor
        ]);
        const parentId = createItemAnchor && (createItemAnchor.position === (0, (0, parcelRequire("iZN6h")).INSIDE) || createItemAnchor.position === (0, (0, parcelRequire("iZN6h")).BEFORE)) ? createItemAnchor.parentId : undefined;
        const hierarchyLevels = (0, $5uXOq.useMemo)(()=>{
            if (parentId) {
                const parent = issuesMap.get(parentId);
                const parentHierarchyLevel = parent?.issueType.hierarchyLevel;
                return parentHierarchyLevel !== undefined ? {
                    maxHierarchyLevel: parentHierarchyLevel - 1,
                    minHierarchyLevel: parentHierarchyLevel - 1
                } : undefined;
            }
            return undefined;
        }, [
            issuesMap,
            parentId
        ]);
        const queryData = parentId ? childrenQueryData[parentId] : undefined;
        if (parentId && (!queryData || queryData.loading)) {
            if (!queryData) return null;
            return (0, ($parcel$interopDefault($5uXOq))).createElement($b921457c7ca94392$var$InlineCreateLoadingWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement($b921457c7ca94392$var$SpinnerWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("113Tq")).default), {
                size: "small"
            })), (0, ($parcel$interopDefault($5uXOq))).createElement($b921457c7ca94392$var$InlineCreateLoading, {
                type: "text",
                disabled: true
            }));
        }
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
            xcss: $b921457c7ca94392$var$inlineCreateWrapperStyles
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iFFYo")).default), {
            appearance: (0, (0, parcelRequire("iFFYo")).ROW_APPEARANCE),
            location: createItemAnchor?.position === (0, (0, parcelRequire("iZN6h")).BEFORE) ? 'timelineSibling' : 'timelineHierarchy',
            fieldIdsToReturn: (0, (0, parcelRequire("gNAqw")).fieldIds),
            isCompact: true,
            onBlur: onBlur,
            onPrepareIssueContext: onPrepareIssueContext,
            onSubmit: onSubmit,
            ...hierarchyLevels
        }));
    };
    const $b921457c7ca94392$var$inlineCreateWrapperStyles = (0, (0, parcelRequire("99gde")).xcss)({
        width: '100%'
    });
    const $b921457c7ca94392$var$InlineCreateLoadingWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswh2mm _1bsb1osq",
                __cmplp.className
            ])
        });
    });
    const $b921457c7ca94392$var$SpinnerWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_kqswstnw _154i1b66 _1ltvu2gc",
                __cmplp.className
            ])
        });
    });
    const $b921457c7ca94392$var$InlineCreateLoading = (0, $5uXOq.forwardRef)(({ as: C = "input", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb11dc _2rkoyh40 _4t3i1tcg _16qsglyw _189eyh40 _1dqonqa1 _1h6d13by _80om13gf",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("iQqkW", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bec2ac0576148160$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $AHUyh;
    var $lQFjJ;
    var $9pdbW;
    var $17ot5;
    var $5hI3W;
    var $4Mmyc;
    var $17X6Y;
    var $ccsmj;
    var $70g8n;
    var $4R6GH;
    var $koVbs;
    var $3HwlS;
    var $8zOmE;
    var $lwMsT;
    var $5GqLe;
    var $l8ruj;
    var $dCm1o;
    var $jxKr9;
    var $jRNSX;
    var $41NW4;
    const $bec2ac0576148160$var$Toolbar = ({ exportToImageButton: exportToImageButton })=>{
        const [hideDoneItems, setHideDoneItems] = (0, (0, parcelRequire("17ot5")).useHideDoneItems)();
        const { hasShareButton: hasShareButton, hasExportButton: hasExportButton, inviteButtonInteraction: inviteButtonInteraction, hasPresence: hasPresence, hasInviteButton: hasInviteButton, hasFilterCustomFields: hasFilterCustomFields } = (0, (0, parcelRequire("jxKr9")).useTimelineFeatures)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const [hasFiltersApplied, setHasFiltersApplied] = (0, $5uXOq.useState)(false);
        const [isSearching, setIsSearching] = (0, $5uXOq.useState)(false);
        const shareButton = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ccsmj")).JWMShareButton), {
            shareTitle: (0, (0, parcelRequire("jRNSX")).default).shareTitle,
            integrationType: (0, (0, parcelRequire("5GqLe")).integrationTypes).TIMELINE,
            shareContentType: "timeline"
        });
        const searchBarLabelId = 'header-actions-search-field-label';
        const handleIsSearching = (text)=>{
            setIsSearching(text.length > 0);
        };
        const handleHasFiltersApplied = (filtersCount)=>{
            setHasFiltersApplied(filtersCount > 0);
        };
        const searchBar = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("AHUyh")).default), {
            id: searchBarLabelId
        }, formatMessage((0, (0, parcelRequire("jRNSX")).default).searchLabel)), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("4Mmyc")).SimpleSearchField), {
            placeholder: (0, (0, parcelRequire("jRNSX")).default).simpleSearch,
            view: "timeline",
            describedbyId: searchBarLabelId,
            onChange: handleIsSearching
        }));
        const addPeopleWithPresence = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("17X6Y")).default), {
            view: "timeline",
            isPresenceEnabledInContext: hasPresence,
            hasInviteButton: hasInviteButton,
            isOpenNewTabOnClick: inviteButtonInteraction === 'openNewTab',
            allowCustomFields: (0, (0, parcelRequire("4R6GH")).fg)('jira_filter-fix_filter_by_custom_fields_and_avatar') ? hasFilterCustomFields : false
        });
        const todayButton = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("41NW4")).default), null);
        const shareActionButton = hasShareButton && shareButton;
        const exportButton = hasExportButton && exportToImageButton;
        const filters = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5hI3W")).Filters), {
            view: "timeline",
            allowCustomFields: hasFilterCustomFields,
            handleHasFiltersApplied: handleHasFiltersApplied
        });
        const [{ hasExpandedAllItems: hasExpandedAllItems, hasCollapsedAllItems: hasCollapsedAllItems }, { toggleExpandAllItems: toggleExpandAllItems, collapseAllItems: collapseAllItems }] = (0, (0, parcelRequire("9pdbW")).useExpandCollapseAllItems)({
            view: 'timeline'
        });
        const handleExpandCollapseAllItems = (0, $5uXOq.useCallback)((operation)=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'expandCollapseAll', {
                operation: operation
            });
            if (operation === 'collapse') collapseAllItems();
            else if (operation === 'expand') toggleExpandAllItems();
        }, [
            collapseAllItems,
            createAnalyticsEvent,
            toggleExpandAllItems
        ]);
        const moreMenu = (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("70g8n")).default), {
            hideDoneItems: Boolean(hideDoneItems),
            onChangeHideDoneItems: setHideDoneItems,
            onExpandCollapseAllItems: handleExpandCollapseAllItems,
            hasExpandedAllItems: hasExpandedAllItems,
            hasCollapsedAllItems: hasCollapsedAllItems,
            isExpandCollapseButtonEnabled: !(isSearching || hasFiltersApplied)
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "business-timeline-toolbar"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lQFjJ")).ActionsWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lQFjJ")).LeftActionsWrapper), null, searchBar, addPeopleWithPresence, (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && filters), (0, ($parcel$interopDefault($5uXOq))).createElement($bec2ac0576148160$var$UnorderedListWrapper, {
            isVisualRefresh: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_1')
        }, !((0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_beta_drop_1')) && (0, ($parcel$interopDefault($5uXOq))).createElement($bec2ac0576148160$var$ListItemWrapper, null, todayButton), !(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && !(0, (0, parcelRequire("3HwlS")).getWillShowNav4)() && (0, ($parcel$interopDefault($5uXOq))).createElement($bec2ac0576148160$var$ListItemWrapper, null, shareActionButton), (0, ($parcel$interopDefault($5uXOq))).createElement($bec2ac0576148160$var$ListItemWrapper, null, exportButton), !(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, ($parcel$interopDefault($5uXOq))).createElement($bec2ac0576148160$var$ListItemWrapper, null, filters), (0, ($parcel$interopDefault($5uXOq))).createElement($bec2ac0576148160$var$ListItemWrapper, null, moreMenu))));
    };
    var $bec2ac0576148160$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($bec2ac0576148160$var$Toolbar);
    const $bec2ac0576148160$var$UnorderedListWrapper = (0, $5uXOq.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { isVisualRefresh: isVisualRefresh, ...__cmpldp } = __cmplp;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _zulpu2gc _19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                __cmplp.isVisualRefresh ? "_ca0qidpf _u5f31tcg _n3tdidpf _19bvidpf" : "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
                __cmplp.className
            ])
        });
    });
    const $bec2ac0576148160$var$ListItemWrapper = (0, $5uXOq.forwardRef)(({ as: C = "li", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _19pkidpf _2hwxidpf _otyridpf _18u0idpf",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("lQFjJ", function(module, exports) {
    $parcel$export(module.exports, "ActionsWrapper", ()=>$31ed5059f3fb9550$export$c8223871eecc8f3a);
    $parcel$export(module.exports, "ActionsWrapperStyled", ()=>$31ed5059f3fb9550$export$ac9cdc71f29d2899);
    $parcel$export(module.exports, "LeftActionsWrapper", ()=>$31ed5059f3fb9550$export$42cb1c7ab389bf4d);
    $parcel$export(module.exports, "RightActionsWrapper", ()=>$31ed5059f3fb9550$export$4aa2cd250ec24dcc);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $dCm1o;
    var $bUSNl;
    const $31ed5059f3fb9550$export$c8223871eecc8f3a = ({ children: children, testId: testId })=>{
        const [{ content: content }] = (0, (0, parcelRequire("bUSNl")).useSidebar)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement($31ed5059f3fb9550$export$ac9cdc71f29d2899, {
            sidebarOpen: !!content,
            "data-testid": testId,
            isVisualRefreshEnabledFG: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)()
        }, children);
    };
    const $31ed5059f3fb9550$var$CenterAlignedWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _zulpu2gc",
                __cmplp.className
            ])
        });
    });
    const $31ed5059f3fb9550$export$ac9cdc71f29d2899 = (0, $5uXOq.forwardRef)(({ as: C = $31ed5059f3fb9550$var$CenterAlignedWrapper, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: {
                ...__cmpls,
                "--_10qff79": (0, (0, parcelRequire("lD23V")).default)(`0 ${__cmplp.sidebarOpen ? 0 : "var(--ds-space-negative-300, -24px)"} ${"var(--ds-space-200, 16px)"} ${"var(--ds-space-negative-300, -24px)"}`)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1tke1ylp _18s8l1uc _1n261g80 _bfhk1iew _18k9ad7r",
                __cmplp.isVisualRefreshEnabledFG ? "_1yt41big" : "_1yt46hdp",
                __cmplp.className
            ])
        });
    });
    const $31ed5059f3fb9550$export$42cb1c7ab389bf4d = (0, $5uXOq.forwardRef)(({ as: C = $31ed5059f3fb9550$var$CenterAlignedWrapper, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_16jlkb7n _1o9zkb7n _i0dlf1ug",
                __cmplp.className
            ])
        });
    });
    const $31ed5059f3fb9550$export$4aa2cd250ec24dcc = $31ed5059f3fb9550$var$CenterAlignedWrapper;
});
parcelRegister("5hI3W", function(module, exports) {
    $parcel$export(module.exports, "Filters", ()=>$afeed5d78bb3bf98$export$92a576f896a9bf72);
    var $5uXOq = parcelRequire("5uXOq");
    var $7qVt8;
    var $4R6GH;
    var $8zOmE;
    var $lwMsT;
    var $l8ruj;
    var $lM9c1;
    var $1TU9r;
    var $gxGcZ;
    var $dpQnO;
    var $ab4a1;
    var $6xNkv;
    const $afeed5d78bb3bf98$var$hiddenQuickFiltersDefault = [
        'ACTIVE_SPRINTS'
    ];
    const $afeed5d78bb3bf98$export$92a576f896a9bf72 = (0, $5uXOq.memo)(({ view: view, allowedFieldTypes: inputAllowedFieldTypes, allowedAliasFieldId: allowedAliasFieldId, hiddenQuickFilters: hiddenQuickFilters = $afeed5d78bb3bf98$var$hiddenQuickFiltersDefault, allowCustomFields: allowCustomFields, allowSavedFilters: allowSavedFilters = true, handleHasFiltersApplied: handleHasFiltersApplied, appearance: appearance })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const allowedFieldTypes = (0, (0, parcelRequire("gxGcZ")).useAllowedFieldTypes)(inputAllowedFieldTypes);
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
        const close = (0, $5uXOq.useCallback)(()=>{
            setIsOpen(false);
        }, []);
        const toggle = (0, $5uXOq.useCallback)(()=>{
            setIsOpen((prevIsOpen)=>!prevIsOpen);
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'jwmFilterButton clicked');
        }, [
            createAnalyticsEvent
        ]);
        const { quickFilters: quickFilters, persistQuickFilters: setQuickFilters } = (0, (0, parcelRequire("dpQnO")).useQuickFilters)();
        const { filters: filters, fieldConfig: fieldConfig, customFieldsLoader: customFieldsLoader, hasFilterError: hasFilterError, setFilters: setFilters } = (0, (0, parcelRequire("1TU9r")).useDeserialiseJqlFiltersWithContext)({
            view: view,
            allowedFieldTypes: allowedFieldTypes,
            allowedAliasFieldId: allowedAliasFieldId,
            allowCustomFields: allowCustomFields
        });
        const count = Object.values(filters).flat().length + Object.values(quickFilters).filter((value)=>value).length;
        (0, $5uXOq.useEffect)(()=>{
            if (handleHasFiltersApplied) handleHasFiltersApplied(count);
        }, [
            count,
            handleHasFiltersApplied
        ]);
        if ((0, (0, parcelRequire("4R6GH")).fg)('native_goals_integration_on_list_view')) (0, (0, parcelRequire("lM9c1")).useGoalsFilterAnalyticsEvent)({
            filters: filters,
            view: view
        });
        const hasFiltersApplied = count > 0 || hasFilterError;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "business-filters"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7qVt8")).default), {
            isOpen: isOpen,
            onClose: close,
            placement: "bottom-end",
            content: ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("ab4a1")).MenuContent), {
                    "data-testid": "business-filters.ui.filters.menu-content",
                    count: count,
                    fieldConfig: fieldConfig,
                    filters: filters,
                    quickFilters: quickFilters,
                    setQuickFilters: setQuickFilters,
                    setFilters: setFilters,
                    hiddenQuickFilters: hiddenQuickFilters,
                    view: view,
                    allowCustomFields: allowCustomFields,
                    allowSavedFilters: allowSavedFilters,
                    hasFilterError: hasFilterError
                })),
            trigger: (triggerProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6xNkv")).Trigger), {
                    ...triggerProps,
                    ...(0, (0, parcelRequire("4R6GH")).fg)('jira-calendar-business-theme') && {
                        appearance: appearance
                    },
                    count: count,
                    hasFiltersApplied: hasFiltersApplied,
                    isSelected: isOpen,
                    onClick: toggle
                })
        }), customFieldsLoader));
    });
});
parcelRegister("lM9c1", function(module, exports) {
    $parcel$export(module.exports, "useGoalsFilterAnalyticsEvent", ()=>$a083b46fb378eaf3$export$c9b2aef46b42c898);
    var $5uXOq = parcelRequire("5uXOq");
    var $5fc53;
    var $8zOmE;
    var $lwMsT;
    var $8DJTW;
    const $a083b46fb378eaf3$export$c9b2aef46b42c898 = ({ filters: filters, view: view })=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const { data: filterFields } = (0, (0, parcelRequire("8DJTW")).useFilterFields)();
        const goalField = (0, $5uXOq.useMemo)(()=>filterFields.find((field)=>field.type === (0, (0, parcelRequire("5fc53")).GOALS_CF_TYPE)), [
            filterFields
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (goalField && filters[goalField.id]) {
                const goalsFilter = filters[goalField.id];
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'goalsFilter applied', {
                    source: view,
                    goalsCount: Array.isArray(goalsFilter) ? goalsFilter.length : 0
                });
            }
        }, [
            createAnalyticsEvent,
            filters,
            goalField,
            view
        ]);
    };
});
parcelRegister("8DJTW", function(module, exports) {
    $parcel$export(module.exports, "useFilterFields", ()=>$058acf7f8802e33f$export$b2d30fa5478b571a);
    var $5uXOq = parcelRequire("5uXOq");
    var $g4ZHz;
    const $058acf7f8802e33f$export$b2d30fa5478b571a = ()=>{
        const { data: fields, loading: loading } = (0, (0, parcelRequire("g4ZHz")).useFieldsResource)();
        const data = (0, $5uXOq.useMemo)(()=>fields?.map((field)=>({
                    id: field.jqlTerm,
                    name: field.displayName,
                    type: field.type
                })) ?? [], [
            fields
        ]);
        return {
            data: data,
            loading: loading,
            error: undefined
        };
    };
});
parcelRegister("1TU9r", function(module, exports) {
    $parcel$export(module.exports, "DeserialisedFiltersProvider", ()=>$fbaf3c30d9711dbc$export$c5640c1fbeb250b6);
    $parcel$export(module.exports, "useDeserialisedFilters", ()=>$fbaf3c30d9711dbc$export$ac7ff3aa0620d1a7);
    $parcel$export(module.exports, "useDeserialiseJqlFilters", ()=>$fbaf3c30d9711dbc$export$eaa578dc219a620a);
    $parcel$export(module.exports, "useDeserialiseJqlFiltersWithContext", ()=>$fbaf3c30d9711dbc$export$87f52da20e747485);
    var $5uXOq = parcelRequire("5uXOq");
    var $g9ql5;
    var $8DJTW;
    var $17ot5;
    var $l4Ejo;
    var $dpQnO;
    var $2RV6Z;
    const $fbaf3c30d9711dbc$var$DEFAULT_VALUE = {
        filters: {}
    };
    const $fbaf3c30d9711dbc$var$DeserialisedFiltersContext = (0, $5uXOq.createContext)($fbaf3c30d9711dbc$var$DEFAULT_VALUE);
    const $fbaf3c30d9711dbc$export$c5640c1fbeb250b6 = ({ children: children })=>{
        const [filters, setFilters] = (0, $5uXOq.useState)({});
        const [isLoading, setIsLoading] = (0, $5uXOq.useState)(true);
        const value = (0, $5uXOq.useMemo)(()=>({
                filters: filters,
                setFilters: setFilters,
                isLoading: isLoading,
                setIsLoading: setIsLoading
            }), [
            filters,
            isLoading
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($fbaf3c30d9711dbc$var$DeserialisedFiltersContext.Provider, {
            value: value
        }, children);
    };
    const $fbaf3c30d9711dbc$export$ac7ff3aa0620d1a7 = ()=>(0, $5uXOq.useContext)($fbaf3c30d9711dbc$var$DeserialisedFiltersContext);
    const $fbaf3c30d9711dbc$var$EMPTY_FILTER = {};
    const $fbaf3c30d9711dbc$export$eaa578dc219a620a = ({ view: view, allowedFieldTypes: allowedFieldTypes, allowedAliasFieldId: allowedAliasFieldId, allowCustomFields: allowCustomFields })=>{
        const { jql: jql, setFilter: setFilter } = (0, (0, parcelRequire("l4Ejo")).useFilters)();
        const { fieldConfig: fieldConfig, resolvers: resolvers, customFieldsLoader: customFieldsLoader, loading: isLoadingFieldConfig } = (0, (0, parcelRequire("g9ql5")).useFieldConfigWithCustomFields)({
            view: view,
            allowedFieldTypes: allowedFieldTypes,
            allowedAliasFieldId: allowedAliasFieldId,
            allowCustomFields: allowCustomFields
        });
        const [filters, setFilters] = (0, $5uXOq.useState)({});
        const [error, setError] = (0, $5uXOq.useState)(null);
        const hasFilterError = error != null;
        const [isDeserialisingFilters, setIsDeserialisingFilters] = (0, $5uXOq.useState)(false);
        const [filtersCache, setFiltersCache] = (0, $5uXOq.useState)({});
        const { data: filterFields, loading: isLoadingFilterFields } = (0, (0, parcelRequire("8DJTW")).useFilterFields)();
        const { quickFiltersJql: quickFiltersJql } = (0, (0, parcelRequire("dpQnO")).useQuickFilters)();
        (0, $5uXOq.useEffect)(()=>{
            if (isDeserialisingFilters || isLoadingFieldConfig || isLoadingFilterFields) return;
            if (!Object.keys(fieldConfig).length) return;
            if (jql != null && filters === filtersCache[jql]) return;
            if (hasFilterError && jql != null) return;
            if (jql == null) {
                if (hasFilterError) setError(null);
                if (filters !== $fbaf3c30d9711dbc$var$EMPTY_FILTER) setFilters($fbaf3c30d9711dbc$var$EMPTY_FILTER);
                return;
            }
            if (quickFiltersJql !== null) {
                setFilters($fbaf3c30d9711dbc$var$EMPTY_FILTER);
                return;
            }
            if (filtersCache[jql]) {
                setFilters(filtersCache[jql]);
                return;
            }
            setIsDeserialisingFilters(true);
            (0, (0, parcelRequire("2RV6Z")).deserialiseJql)(jql, fieldConfig, filterFields, resolvers).then((result)=>{
                setFilters(result);
                setFiltersCache({
                    ...filtersCache,
                    [jql]: result
                });
            }).catch((e)=>{
                setError(e);
            }).finally(()=>{
                setIsDeserialisingFilters(false);
            });
        }, [
            hasFilterError,
            quickFiltersJql,
            error,
            filters,
            isLoadingFieldConfig,
            isLoadingFilterFields,
            fieldConfig,
            jql,
            filtersCache,
            filterFields,
            resolvers,
            isDeserialisingFilters
        ]);
        (0, (0, parcelRequire("17ot5")).useInferHideDoneItemsWithFilters)({
            filters: filters
        });
        return {
            fieldConfig: fieldConfig,
            filters: filters,
            hasFilterError: hasFilterError,
            customFieldsLoader: customFieldsLoader,
            setFilters: setFilter,
            loading: isLoadingFieldConfig || isDeserialisingFilters
        };
    };
    const $fbaf3c30d9711dbc$export$87f52da20e747485 = (props)=>{
        const { fieldConfig: fieldConfig, filters: filters, hasFilterError: hasFilterError, customFieldsLoader: customFieldsLoader, setFilters: setFilters, loading: loading } = $fbaf3c30d9711dbc$export$eaa578dc219a620a(props);
        const { setFilters: setContextFilters, setIsLoading: setIsLoadingFilters } = $fbaf3c30d9711dbc$export$ac7ff3aa0620d1a7();
        (0, $5uXOq.useEffect)(()=>{
            if (setContextFilters) setContextFilters(filters);
        }, [
            filters,
            setContextFilters
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (setIsLoadingFilters) setIsLoadingFilters(loading);
        }, [
            loading,
            setIsLoadingFilters
        ]);
        return {
            fieldConfig: fieldConfig,
            filters: filters,
            hasFilterError: hasFilterError,
            customFieldsLoader: customFieldsLoader,
            setFilters: setFilters
        };
    };
});
parcelRegister("g9ql5", function(module, exports) {
    $parcel$export(module.exports, "useFieldConfigWithCustomFields", ()=>$937abfae1d89db7d$export$9f6dc7e3584916fa);
    var $5uXOq = parcelRequire("5uXOq");
    var $5fc53;
    var $gzkAf;
    var $5FlVd;
    var $RjSi3;
    var $cLe9v;
    const $937abfae1d89db7d$var$emptySet = new Set();
    const $937abfae1d89db7d$var$CustomFieldsLoader = ({ allowedFieldTypes: allowedFieldTypes, allowedAliasFieldId: allowedAliasFieldId, setFieldConfig: setFieldConfig })=>{
        const { fieldConfig: fieldConfig, resolvers: resolvers, loading: loading } = (0, (0, parcelRequire("cLe9v")).useFieldConfig)({
            allowedFieldTypes: allowedFieldTypes,
            allowedAliasFieldId: allowedAliasFieldId
        });
        (0, $5uXOq.useEffect)(()=>{
            setFieldConfig({
                fieldConfig: fieldConfig,
                resolvers: resolvers,
                loading: loading
            });
        }, [
            fieldConfig,
            resolvers,
            loading,
            setFieldConfig
        ]);
        return null;
    };
    const $937abfae1d89db7d$export$9f6dc7e3584916fa = ({ view: view, allowCustomFields: allowCustomFields, allowedAliasFieldId: allowedAliasFieldId, allowedFieldTypes: allowedFieldTypes })=>{
        const [newAllowedFieldTypes, oldAllowedFieldTypes] = (0, $5uXOq.useMemo)(()=>{
            const newTypes = new Set(allowedFieldTypes);
            const oldTypes = new Set();
            (0, (0, parcelRequire("gzkAf")).EXTRA_CUSTOM_FIELD_TYPES).forEach((type)=>{
                if (allowedFieldTypes.has(type)) {
                    newTypes.delete(type);
                    oldTypes.add(type);
                }
            });
            return [
                newTypes,
                oldTypes
            ];
        }, [
            allowedFieldTypes
        ]);
        const hasCustomFields = Boolean(allowCustomFields) && oldAllowedFieldTypes.size > 0;
        const hasAliasFields = allowedAliasFieldId != null && allowedAliasFieldId.size > 0;
        const shouldLoadOldFieldConfig = hasAliasFields || hasCustomFields;
        const { fieldConfig: fieldConfigNew, resolvers: resolversNew, loading: isLoadingFieldConfigNew } = (0, (0, parcelRequire("RjSi3")).useFieldConfigV2)({
            view: view,
            allowedFieldTypes: newAllowedFieldTypes
        });
        const [{ fieldConfig: fieldConfigOld, loading: isLoadingFieldConfigOld, resolvers: resolversOld }, setFieldConfig] = (0, $5uXOq.useState)({
            fieldConfig: {},
            resolvers: {},
            loading: shouldLoadOldFieldConfig
        });
        const customFieldsLoader = (0, $5uXOq.useMemo)(()=>{
            if (!shouldLoadOldFieldConfig) return null;
            return (0, ($parcel$interopDefault($5uXOq))).createElement($937abfae1d89db7d$var$CustomFieldsLoader, {
                allowedFieldTypes: allowCustomFields ? oldAllowedFieldTypes : $937abfae1d89db7d$var$emptySet,
                allowedAliasFieldId: allowedAliasFieldId,
                setFieldConfig: setFieldConfig
            });
        }, [
            allowCustomFields,
            allowedAliasFieldId,
            oldAllowedFieldTypes,
            shouldLoadOldFieldConfig
        ]);
        const { fetchUsers: fetchUsers } = (0, (0, parcelRequire("5FlVd")).useFetchFieldValues)({
            view: view,
            allowedFieldTypes: allowedFieldTypes
        });
        const fieldConfig = (0, $5uXOq.useMemo)(()=>{
            const aliasFields = {};
            const otherFields = {};
            Object.keys(fieldConfigOld).forEach((id)=>{
                if (fieldConfigOld[id].systemType === (0, (0, parcelRequire("5fc53")).PEOPLE_CF_TYPE) || fieldConfigOld[id].systemType === (0, (0, parcelRequire("5fc53")).USER_CF_TYPE)) fieldConfigOld[id] = {
                    ...fieldConfigOld[id],
                    loadOptions: fetchUsers
                };
                if (fieldConfigOld[id].aliasFieldId != null) aliasFields[id] = fieldConfigOld[id];
                else otherFields[id] = fieldConfigOld[id];
            });
            return {
                ...otherFields,
                ...fieldConfigNew,
                ...aliasFields
            };
        }, [
            fieldConfigOld,
            fieldConfigNew,
            fetchUsers
        ]);
        return {
            fieldConfig: fieldConfig,
            resolvers: {
                ...resolversOld,
                ...resolversNew
            },
            customFieldsLoader: customFieldsLoader,
            loading: isLoadingFieldConfigNew || isLoadingFieldConfigOld
        };
    };
});
parcelRegister("5FlVd", function(module, exports) {
    $parcel$export(module.exports, "useFetchFieldValues", ()=>$b6820483a00ce3be$export$6cb851ed13e3949e);
    var $5uXOq = parcelRequire("5uXOq");
    var $8QpSo;
    var $hE5wF;
    var $5YBrl;
    var $jlq4V;
    var $4R6GH;
    var $eusud;
    var $5fc53;
    var $koeKL;
    var $ieDtd;
    var $b4fG8;
    var $34JdM;
    var $czmU8;
    var $84pWT;
    var $ldL1T;
    const $b6820483a00ce3be$var$MAX_NUMBER_OF_OPTIONS = 20;
    const $b6820483a00ce3be$var$MAX_INITIAL_NUMBER_OF_OPTIONS = 50;
    const $b6820483a00ce3be$var$EMPTY_FIELD_DATA = {
        totalCount: 0,
        options: []
    };
    const $b6820483a00ce3be$var$ACTIVE_SPRINTS_JQL = '(sprint in openSprints() OR sprint in futureSprints())';
    const $b6820483a00ce3be$var$fetchInitialDataInternal = async (cloudId, jqlContext, jqlURLParam, allowedFieldTypes, goalsJqlTerm)=>{
        try {
            const response = await (0, (0, parcelRequire("eusud")).performPostRequest)('/rest/gira/1/?operation=JWMInitialFilterFieldValues', {
                body: JSON.stringify({
                    query: (0, $c4148dc6c1f759d4$export$a48313dd44fc9855),
                    variables: {
                        cloudId: cloudId,
                        first: $b6820483a00ce3be$var$MAX_INITIAL_NUMBER_OF_OPTIONS,
                        jql: jqlContext,
                        shouldFetchSprints: Boolean(allowedFieldTypes?.has((0, (0, parcelRequire("5fc53")).SPRINT_TYPE))),
                        shouldFetchSoftwareFields: Boolean((0, (0, parcelRequire("4R6GH")).fg)('jsw_list_view_-_all_the_fields') && allowedFieldTypes?.has((0, (0, parcelRequire("5fc53")).FIX_VERSIONS_TYPE))),
                        shouldFetchParentField: Boolean((0, (0, parcelRequire("4R6GH")).fg)('jsw_list_view_-_all_the_fields')),
                        shouldFetchGoalsField: Boolean(allowedFieldTypes?.has((0, (0, parcelRequire("5fc53")).GOALS_CF_TYPE)) && !!goalsJqlTerm && (0, (0, parcelRequire("4R6GH")).fg)('native_goals_integration_on_list_view')),
                        goalsJqlTerm: goalsJqlTerm && (0, (0, parcelRequire("4R6GH")).fg)('native_goals_integration_on_list_view') ? goalsJqlTerm : '',
                        sprintsJqlContext: allowedFieldTypes?.has((0, (0, parcelRequire("5fc53")).SPRINT_TYPE)) ? `${jqlContext} AND ${$b6820483a00ce3be$var$ACTIVE_SPRINTS_JQL}` : undefined
                    }
                })
            });
            if (response.data?.jira?.jqlBuilder == null && response.data?.jwmCategoryOptions == null) throw new (0, (0, parcelRequire("jlq4V")).GraphQLErrors)(response.errors);
            const hydratedValues = jqlURLParam ? await (0, (0, parcelRequire("czmU8")).hydrateFilterValues)(cloudId, jqlURLParam) : null;
            const transformedInitialData = (0, (0, parcelRequire("ldL1T")).transformInitialData)(response.data);
            if (hydratedValues !== null) {
                const transformedHydratedValues = (0, (0, parcelRequire("84pWT")).transformHydratedValues)(hydratedValues);
                return (0, (0, parcelRequire("84pWT")).mergeHydratedValues)(transformedInitialData, transformedHydratedValues);
            }
            return transformedInitialData;
        } catch (err) {
            (0, (0, parcelRequire("ldL1T")).fireFieldValuesErrorAnalytics)('initialiseFilterData', 'Failed to initialise filter data', err);
        }
        return null;
    };
    const $b6820483a00ce3be$var$memoizedFetchInitialData = (0, (0, parcelRequire("8QpSo")).default)($b6820483a00ce3be$var$fetchInitialDataInternal);
    const $b6820483a00ce3be$var$fetchTeamsServiceFnc = ()=>Promise.resolve((0, (0, parcelRequire("34JdM")).EMPTY_TEAMS));
    const $b6820483a00ce3be$export$6cb851ed13e3949e = ({ view: view, allowedFieldTypes: allowedFieldTypes, filterFields: filterFields })=>{
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const jqlContext = (0, (0, parcelRequire("5YBrl")).useJqlContext)();
        const [jqlURLParam] = (0, (0, parcelRequire("ieDtd")).useQueryParam)((0, (0, parcelRequire("hE5wF")).FILTER_PARAM));
        const jqlURLParamRef = (0, $5uXOq.useRef)(jqlURLParam);
        const goalsJqlTerm = (0, (0, parcelRequire("ldL1T")).useGoalsJqlTerm)(filterFields);
        let fetchTeamsService = $b6820483a00ce3be$var$fetchTeamsServiceFnc;
        if ((0, (0, parcelRequire("4R6GH")).fg)('jsw_list_view_-_all_the_fields')) fetchTeamsService = (0, (0, parcelRequire("34JdM")).useFetchTeams)();
        const fetchInitialData = (0, $5uXOq.useCallback)(async ()=>{
            if ((0, (0, parcelRequire("4R6GH")).fg)('jsw_list_view_-_all_the_fields')) return Promise.all([
                $b6820483a00ce3be$var$memoizedFetchInitialData(cloudId, jqlContext, jqlURLParamRef.current, allowedFieldTypes, goalsJqlTerm),
                fetchTeamsService({
                    first: $b6820483a00ce3be$var$MAX_NUMBER_OF_OPTIONS
                })
            ]).then((values)=>{
                let result = (0, (0, parcelRequire("b4fG8")).EMPTY_TRANSFORMED_DATA);
                values.forEach((value)=>{
                    result = {
                        ...result,
                        ...value
                    };
                });
                return result;
            });
            return $b6820483a00ce3be$var$memoizedFetchInitialData(cloudId, jqlContext, jqlURLParamRef.current, allowedFieldTypes, goalsJqlTerm);
        }, [
            allowedFieldTypes,
            cloudId,
            fetchTeamsService,
            goalsJqlTerm,
            jqlContext
        ]);
        const fetchData = (0, $5uXOq.useCallback)(async ({ fieldName: fieldName, query: query = '', first: first = $b6820483a00ce3be$var$MAX_NUMBER_OF_OPTIONS, afterCursor: afterCursor, jqlContext: jqlContextProp })=>{
            const response = await (0, (0, parcelRequire("eusud")).performPostRequest)('/rest/gira/1/?operation=JWMFilterFieldValues', {
                body: JSON.stringify({
                    query: (0, $c4148dc6c1f759d4$export$f8e8a5f34f6ea725),
                    variables: {
                        cloudId: cloudId,
                        first: first,
                        jqlTerm: fieldName,
                        jql: jqlContextProp ?? jqlContext,
                        searchString: query,
                        after: afterCursor
                    }
                })
            });
            if (response.data?.jira?.jqlBuilder?.fieldValues == null) throw new (0, (0, parcelRequire("jlq4V")).GraphQLErrors)(response.errors);
            return response.data.jira.jqlBuilder.fieldValues;
        }, [
            cloudId,
            jqlContext
        ]);
        const fetchLabels = (0, $5uXOq.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
            try {
                const fieldValuesData = await fetchData({
                    fieldName: 'labels',
                    query: query,
                    first: first,
                    afterCursor: afterCursor
                });
                return {
                    totalCount: fieldValuesData.totalCount,
                    options: (0, (0, parcelRequire("b4fG8")).transformDefaultField)(fieldValuesData)
                };
            } catch (err) {
                (0, (0, parcelRequire("ldL1T")).fireFieldValuesErrorAnalytics)('searchFilterLabels', 'Failed to search labels', err);
            }
            return $b6820483a00ce3be$var$EMPTY_FIELD_DATA;
        }, [
            fetchData
        ]);
        const fetchComponents = (0, $5uXOq.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
            try {
                const fieldValuesData = await fetchData({
                    fieldName: 'component',
                    query: query,
                    first: first,
                    afterCursor: afterCursor
                });
                return {
                    totalCount: fieldValuesData.totalCount,
                    options: (0, (0, parcelRequire("b4fG8")).transformDefaultField)(fieldValuesData)
                };
            } catch (err) {
                (0, (0, parcelRequire("ldL1T")).fireFieldValuesErrorAnalytics)('searchFilterComponents', 'Failed to search components', err);
            }
            return $b6820483a00ce3be$var$EMPTY_FIELD_DATA;
        }, [
            fetchData
        ]);
        const fetchPriorities = (0, $5uXOq.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
            try {
                const fieldValuesData = await fetchData({
                    fieldName: 'priority',
                    query: query,
                    first: first,
                    afterCursor: afterCursor
                });
                return {
                    totalCount: fieldValuesData.totalCount,
                    options: (0, (0, parcelRequire("b4fG8")).transformPriorities)(fieldValuesData)
                };
            } catch (err) {
                (0, (0, parcelRequire("ldL1T")).fireFieldValuesErrorAnalytics)('searchFilterPriorities', 'Failed to search priorities', err);
            }
            return $b6820483a00ce3be$var$EMPTY_FIELD_DATA;
        }, [
            fetchData
        ]);
        const fetchUsers = (0, $5uXOq.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
            try {
                const fieldValuesData = await fetchData({
                    fieldName: 'assignee',
                    query: query,
                    first: first,
                    afterCursor: afterCursor
                });
                return {
                    totalCount: fieldValuesData.totalCount,
                    options: (0, (0, parcelRequire("b4fG8")).transformUsers)(fieldValuesData)
                };
            } catch (err) {
                (0, (0, parcelRequire("ldL1T")).fireFieldValuesErrorAnalytics)('searchFilterUsers', 'Failed to search users', err);
            }
            return $b6820483a00ce3be$var$EMPTY_FIELD_DATA;
        }, [
            fetchData
        ]);
        const fetchIssueTypes = (0, $5uXOq.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
            try {
                const fieldValuesData = await fetchData({
                    fieldName: 'issuetype',
                    query: query,
                    first: first,
                    afterCursor: afterCursor
                });
                let options = (0, (0, parcelRequire("b4fG8")).transformIssueTypes)(fieldValuesData);
                if (view === 'board') options = options.filter((option)=>option.hierarchyLevel !== -1);
                return {
                    totalCount: fieldValuesData.totalCount,
                    options: options
                };
            } catch (err) {
                (0, (0, parcelRequire("ldL1T")).fireFieldValuesErrorAnalytics)('searchFilterIssueTypes', 'Failed to search issue types', err);
            }
            return $b6820483a00ce3be$var$EMPTY_FIELD_DATA;
        }, [
            fetchData,
            view
        ]);
        const fetchStatuses = (0, $5uXOq.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
            try {
                const fieldValuesData = await fetchData({
                    fieldName: 'status',
                    query: query,
                    first: first,
                    afterCursor: afterCursor
                });
                return {
                    totalCount: fieldValuesData.totalCount,
                    options: (0, (0, parcelRequire("b4fG8")).transformStatuses)(fieldValuesData)
                };
            } catch (err) {
                (0, (0, parcelRequire("ldL1T")).fireFieldValuesErrorAnalytics)('searchFilterStatuses', 'Failed to search statuses', err);
            }
            return $b6820483a00ce3be$var$EMPTY_FIELD_DATA;
        }, [
            fetchData
        ]);
        const fetchCategories = (0, $5uXOq.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first = $b6820483a00ce3be$var$MAX_NUMBER_OF_OPTIONS })=>{
            try {
                const response = await (0, (0, parcelRequire("eusud")).performPostRequest)('/rest/gira/1/?operation=JWMCategoryFieldValuesSearch', {
                    body: JSON.stringify({
                        query: (0, $c4148dc6c1f759d4$export$562e34ec948f373d),
                        variables: {
                            first: first,
                            jql: jqlContext,
                            searchQuery: query,
                            after: afterCursor
                        }
                    })
                });
                if (response.errors != null) throw new (0, (0, parcelRequire("jlq4V")).GraphQLErrors)(response.errors);
                if (response.data?.jira?.jwmCategoryOptions?.edges == null) throw new Error('GraphQL response has no data');
                return {
                    totalCount: response.data.jira.jwmCategoryOptions.totalCount,
                    options: (0, (0, parcelRequire("b4fG8")).transformCategories)(response.data.jira.jwmCategoryOptions)
                };
            } catch (err) {
                (0, (0, parcelRequire("ldL1T")).fireFieldValuesErrorAnalytics)('searchFilterCategories', 'Failed to search categories', err);
            }
            return $b6820483a00ce3be$var$EMPTY_FIELD_DATA;
        }, [
            jqlContext
        ]);
        const fetchSprints = (0, $5uXOq.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
            try {
                const fieldValuesData = await fetchData({
                    fieldName: 'sprint',
                    query: query,
                    first: first,
                    afterCursor: afterCursor,
                    jqlContext: `${jqlContext} AND ${$b6820483a00ce3be$var$ACTIVE_SPRINTS_JQL}`
                });
                return {
                    totalCount: fieldValuesData.totalCount,
                    options: (0, (0, parcelRequire("b4fG8")).transformSprints)(fieldValuesData)
                };
            } catch (err) {
                (0, (0, parcelRequire("ldL1T")).fireFieldValuesErrorAnalytics)('searchFilterSprints', 'Failed to search sprints', err);
            }
            return $b6820483a00ce3be$var$EMPTY_FIELD_DATA;
        }, [
            fetchData,
            jqlContext
        ]);
        const fetchFixVersions = (0, $5uXOq.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
            try {
                const fieldValuesData = await fetchData({
                    fieldName: 'fixVersion',
                    query: query,
                    first: first,
                    afterCursor: afterCursor
                });
                return {
                    totalCount: fieldValuesData.totalCount,
                    options: (0, (0, parcelRequire("b4fG8")).transformDefaultField)(fieldValuesData)
                };
            } catch (err) {
                (0, (0, parcelRequire("ldL1T")).fireFieldValuesErrorAnalytics)('searchFilterFixVersion', 'Failed to search fix version', err);
            }
            return $b6820483a00ce3be$var$EMPTY_FIELD_DATA;
        }, [
            fetchData
        ]);
        const fetchParents = (0, $5uXOq.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
            try {
                const fieldValuesData = await fetchData({
                    fieldName: 'parent',
                    query: query,
                    first: first,
                    afterCursor: afterCursor
                });
                return {
                    totalCount: fieldValuesData.totalCount,
                    options: (0, (0, parcelRequire("b4fG8")).transformParent)(fieldValuesData)
                };
            } catch (err) {
                (0, (0, parcelRequire("ldL1T")).fireFieldValuesErrorAnalytics)('searchFilterParent', 'Failed to search parents', err);
            }
            return $b6820483a00ce3be$var$EMPTY_FIELD_DATA;
        }, [
            fetchData
        ]);
        const fetchGoals = (0, $5uXOq.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
            if (!goalsJqlTerm) return $b6820483a00ce3be$var$EMPTY_FIELD_DATA;
            try {
                const fieldValuesData = await fetchData({
                    fieldName: goalsJqlTerm,
                    query: query,
                    first: first,
                    afterCursor: afterCursor
                });
                return {
                    totalCount: fieldValuesData.totalCount,
                    options: (0, (0, parcelRequire("b4fG8")).transformGoals)(fieldValuesData)
                };
            } catch (err) {
                (0, (0, parcelRequire("ldL1T")).fireFieldValuesErrorAnalytics)('searchFilterGoals', 'Failed to search goals', err);
            }
            return $b6820483a00ce3be$var$EMPTY_FIELD_DATA;
        }, [
            fetchData,
            goalsJqlTerm
        ]);
        const fetchTeams = (0, $5uXOq.useCallback)(async ({ query: query = '', afterCursor: afterCursor, first: first })=>{
            try {
                const fieldValuesData = await fetchTeamsService({
                    query: query,
                    first: first,
                    after: afterCursor
                });
                return fieldValuesData[0, (0, parcelRequire("5fc53")).TEAMS_PLATFORM_CF_TYPE];
            } catch (err) {
                (0, (0, parcelRequire("ldL1T")).fireFieldValuesErrorAnalytics)('searchFilterTeams', 'Failed to search teams', err);
            }
            return $b6820483a00ce3be$var$EMPTY_FIELD_DATA;
        }, [
            fetchTeamsService
        ]);
        return {
            fetchInitialData: fetchInitialData,
            fetchLabels: fetchLabels,
            fetchComponents: fetchComponents,
            fetchPriorities: fetchPriorities,
            fetchUsers: fetchUsers,
            fetchIssueTypes: fetchIssueTypes,
            fetchStatuses: fetchStatuses,
            fetchCategories: fetchCategories,
            fetchSprints: fetchSprints,
            ...(0, (0, parcelRequire("4R6GH")).fg)('jsw_list_view_-_all_the_fields') ? {
                fetchFixVersions: fetchFixVersions,
                fetchParents: fetchParents,
                fetchTeams: fetchTeams
            } : {},
            fetchGoals: fetchGoals
        };
    };
});
parcelRegister("b4fG8", function(module, exports) {
    $parcel$export(module.exports, "transformPriorities", ()=>$7c1a01ddd808f237$export$86ca92dec35c4797);
    $parcel$export(module.exports, "transformUsers", ()=>$7c1a01ddd808f237$export$fb8c90bfc4beaa59);
    $parcel$export(module.exports, "transformIssueTypes", ()=>$7c1a01ddd808f237$export$4c05e2584b34e4d8);
    $parcel$export(module.exports, "transformStatuses", ()=>$7c1a01ddd808f237$export$20a57a5ec025f2d);
    $parcel$export(module.exports, "transformCategories", ()=>$7c1a01ddd808f237$export$1b389c47cf1df04e);
    $parcel$export(module.exports, "transformDefaultField", ()=>$7c1a01ddd808f237$export$6133e08eeff30d5f);
    $parcel$export(module.exports, "transformSprints", ()=>$7c1a01ddd808f237$export$6a33be7fc7f04943);
    $parcel$export(module.exports, "transformGoals", ()=>$7c1a01ddd808f237$export$673d4fceed3e8383);
    $parcel$export(module.exports, "transformParent", ()=>$7c1a01ddd808f237$export$87e9766fb5100314);
    $parcel$export(module.exports, "transformTeams", ()=>$7c1a01ddd808f237$export$fd398a52d6f57b46);
    $parcel$export(module.exports, "EMPTY_TRANSFORMED_DATA", ()=>$7c1a01ddd808f237$export$ca9df9cab9cc134f);
    $parcel$export(module.exports, "transformValuesData", ()=>$7c1a01ddd808f237$export$8e327b5f9ebc175d);
    var $3JOCw = parcelRequire("3JOCw");
    var $5fc53;
    var $dCm1o;
    const $7c1a01ddd808f237$var$getFirstIssueTypeAvatar = (node)=>node.issueTypes?.find((issueType)=>issueType?.avatar?.medium != null)?.avatar?.medium;
    const $7c1a01ddd808f237$var$getFirstIssueTypeId = (node)=>node.issueTypes[0]?.issueTypeId;
    const $7c1a01ddd808f237$var$getFirstIssueTypeHierarchyLevel = (node)=>node.issueTypes[0]?.hierarchy?.level;
    const $7c1a01ddd808f237$export$86ca92dec35c4797 = (data)=>data.edges.map(({ node: node, cursor: cursor })=>({
                cursor: cursor,
                value: node.jqlTerm,
                label: node.displayName,
                avatar: node.priority.iconUrl || ''
            }));
    const $7c1a01ddd808f237$export$fb8c90bfc4beaa59 = (data)=>data.edges.filter(({ node: node })=>node?.user != null).map(({ node: node, cursor: cursor })=>({
                cursor: cursor,
                value: node.jqlTerm,
                label: node.displayName,
                avatar: node?.user?.picture || ''
            }));
    const $7c1a01ddd808f237$export$4c05e2584b34e4d8 = (data)=>data.edges.map(({ node: node, cursor: cursor })=>({
                cursor: cursor,
                value: node.jqlTerm,
                label: node.displayName,
                id: $7c1a01ddd808f237$var$getFirstIssueTypeId(node),
                avatar: $7c1a01ddd808f237$var$getFirstIssueTypeAvatar(node) || '',
                square: true,
                hierarchyLevel: $7c1a01ddd808f237$var$getFirstIssueTypeHierarchyLevel(node) || 0
            }));
    const $7c1a01ddd808f237$export$20a57a5ec025f2d = (data)=>data.edges.map(({ node: node, cursor: cursor })=>({
                cursor: cursor,
                value: node.jqlTerm,
                label: node.displayName,
                categoryId: node.statusCategory.statusCategoryId
            }));
    const $7c1a01ddd808f237$export$1b389c47cf1df04e = (data)=>{
        const transformedCategories = data.edges.map((edge)=>({
                cursor: edge?.cursor,
                value: edge.node.option.value,
                label: edge.node.option.value,
                color: edge.node.color
            }));
        return (0, ($parcel$interopDefault($3JOCw)))(transformedCategories, ({ value: value })=>value);
    };
    const $7c1a01ddd808f237$export$6133e08eeff30d5f = (data)=>data.edges.map(({ node: node, cursor: cursor })=>({
                cursor: cursor,
                value: node.jqlTerm,
                label: node.displayName
            }));
    const $7c1a01ddd808f237$export$6a33be7fc7f04943 = (data)=>data.edges.filter(({ node: node })=>node?.sprint != null).map(({ node: node, cursor: cursor })=>({
                cursor: cursor,
                value: node.displayName,
                label: node.sprint?.name || ''
            }));
    const $7c1a01ddd808f237$export$673d4fceed3e8383 = (data)=>data.edges.map(({ node: node, cursor: cursor })=>({
                cursor: cursor,
                value: node.jqlTerm,
                label: node.goal.name || '',
                status: node.goal.status || ''
            }));
    const $7c1a01ddd808f237$export$87e9766fb5100314 = (data)=>data?.edges.map(({ node: node, cursor: cursor })=>{
            let avatar = '';
            if (Number(node.issue?.fieldsByIdOrAlias.length) > 0) avatar = node.issue?.fieldsByIdOrAlias[0].issueType?.avatar?.medium || '';
            return {
                cursor: cursor,
                value: node.jqlTerm,
                label: node.displayName,
                avatar: avatar,
                ...(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && {
                    square: true
                }
            };
        });
    const $7c1a01ddd808f237$export$fd398a52d6f57b46 = (data)=>data?.edges.filter(({ node: node })=>node?.team != null).map(({ node: node })=>({
                cursor: data.pageInfo?.endCursor,
                value: node.team.id.replace('ari:cloud:identity::team/', ''),
                label: node.team.displayName || '',
                avatar: node.team.smallAvatarImageUrl || ''
            }));
    const $7c1a01ddd808f237$var$isIssueType = (fieldValue)=>{
        const { node: node } = fieldValue.edges[0];
        return Boolean(node && 'issueTypes' in node);
    };
    const $7c1a01ddd808f237$var$isPriority = (fieldValue)=>{
        const { node: node } = fieldValue.edges[0];
        return Boolean(node && 'priority' in node);
    };
    const $7c1a01ddd808f237$var$isStatus = (fieldValue)=>{
        const { node: node } = fieldValue.edges[0];
        return Boolean(node && 'statusCategory' in node);
    };
    const $7c1a01ddd808f237$var$isSprint = (fieldValue)=>{
        const { node: node } = fieldValue.edges[0];
        return Boolean(node && 'sprint' in node);
    };
    const $7c1a01ddd808f237$var$isGoal = (fieldValue)=>{
        const { node: node } = fieldValue.edges[0];
        return Boolean(node && 'goal' in node);
    };
    const $7c1a01ddd808f237$var$isParent = (fieldValue)=>{
        const { node: node } = fieldValue.edges[0];
        return Boolean(node && 'issue' in node);
    };
    const $7c1a01ddd808f237$var$isUser = (fieldValue)=>true;
    const $7c1a01ddd808f237$var$isDefaultField = (fieldValue)=>Boolean(fieldValue.edges[0]);
    const $7c1a01ddd808f237$export$ca9df9cab9cc134f = {
        labels: {
            totalCount: 0,
            options: []
        },
        components: {
            totalCount: 0,
            options: []
        },
        priority: {
            totalCount: 0,
            options: []
        },
        users: {
            totalCount: 0,
            options: []
        },
        issuetype: {
            totalCount: 0,
            options: []
        },
        status: {
            totalCount: 0,
            options: []
        },
        [(0, (0, parcelRequire("5fc53")).CATEGORY_TYPE)]: {
            totalCount: 0,
            options: []
        },
        [(0, (0, parcelRequire("5fc53")).SPRINT_TYPE)]: {
            totalCount: 0,
            options: []
        },
        [(0, (0, parcelRequire("5fc53")).FIX_VERSIONS_TYPE)]: {
            totalCount: 0,
            options: []
        },
        [(0, (0, parcelRequire("5fc53")).PARENT_FIELD_TYPE)]: {
            totalCount: 0,
            options: []
        },
        [(0, (0, parcelRequire("5fc53")).GOALS_CF_TYPE)]: {
            totalCount: 0,
            options: []
        },
        [(0, (0, parcelRequire("5fc53")).TEAMS_PLATFORM_CF_TYPE)]: {
            totalCount: 0,
            options: []
        }
    };
    const $7c1a01ddd808f237$export$8e327b5f9ebc175d = (data)=>{
        const transformedData = {
            ...$7c1a01ddd808f237$export$ca9df9cab9cc134f
        };
        Object.entries(data).forEach(([key, fieldValue])=>{
            if (fieldValue && fieldValue.edges && Array.isArray(fieldValue.edges) && fieldValue.edges.length) switch(key){
                case 'issuetype':
                    if ($7c1a01ddd808f237$var$isIssueType(fieldValue)) transformedData.issuetype = {
                        totalCount: fieldValue.totalCount,
                        options: $7c1a01ddd808f237$export$4c05e2584b34e4d8(fieldValue)
                    };
                    break;
                case 'priority':
                    if ($7c1a01ddd808f237$var$isPriority(fieldValue)) transformedData.priority = {
                        totalCount: fieldValue.totalCount,
                        options: $7c1a01ddd808f237$export$86ca92dec35c4797(fieldValue)
                    };
                    break;
                case 'status':
                    if ($7c1a01ddd808f237$var$isStatus(fieldValue)) transformedData.status = {
                        totalCount: fieldValue.totalCount,
                        options: $7c1a01ddd808f237$export$20a57a5ec025f2d(fieldValue)
                    };
                    break;
                case 'component':
                case 'components':
                case 'fixVersions':
                case 'labels':
                    if ($7c1a01ddd808f237$var$isDefaultField(fieldValue)) {
                        const transformedKey = key === 'component' ? (0, (0, parcelRequire("5fc53")).COMPONENTS_TYPE) : key;
                        transformedData[transformedKey] = {
                            totalCount: fieldValue.totalCount,
                            options: $7c1a01ddd808f237$export$6133e08eeff30d5f(fieldValue)
                        };
                    }
                    break;
                case 'parent':
                    if ($7c1a01ddd808f237$var$isParent(fieldValue)) transformedData[key] = {
                        totalCount: fieldValue.totalCount,
                        options: $7c1a01ddd808f237$export$87e9766fb5100314(fieldValue)
                    };
                    break;
                default:
                    if ($7c1a01ddd808f237$var$isSprint(fieldValue)) transformedData[0, (0, parcelRequire("5fc53")).SPRINT_TYPE] = {
                        totalCount: fieldValue.totalCount,
                        options: $7c1a01ddd808f237$export$6a33be7fc7f04943(fieldValue)
                    };
                    else if (fieldValue.edges.some((item)=>item.node && 'user' in item.node) && $7c1a01ddd808f237$var$isUser(fieldValue)) {
                        const usersData = $7c1a01ddd808f237$export$fb8c90bfc4beaa59(fieldValue);
                        const userOptions = (0, ($parcel$interopDefault($3JOCw)))([
                            ...usersData,
                            ...transformedData.users?.options ?? []
                        ], ({ value: value })=>value);
                        transformedData.users = {
                            totalCount: userOptions.length,
                            options: userOptions
                        };
                    } else if ($7c1a01ddd808f237$var$isGoal(fieldValue)) transformedData[0, (0, parcelRequire("5fc53")).GOALS_CF_TYPE] = {
                        totalCount: fieldValue.totalCount,
                        options: $7c1a01ddd808f237$export$673d4fceed3e8383(fieldValue)
                    };
            }
        });
        return transformedData;
    };
});
parcelRegister("34JdM", function(module, exports) {
    $parcel$export(module.exports, "EMPTY_TEAMS", ()=>$96faa576a82047b8$export$37430da53242c305);
    $parcel$export(module.exports, "useFetchTeams", ()=>$96faa576a82047b8$export$da1ab223b3f1410c);
    var $5uXOq = parcelRequire("5uXOq");
    var $jcw0u;
    var $eusud;
    var $5fc53;
    var $14XJw;
    var $koeKL;
    var $b4fG8;
    const $96faa576a82047b8$var$prependOrgIdAri = (orgId)=>`ari:cloud:platform::org/${orgId}`;
    const $96faa576a82047b8$export$37430da53242c305 = {
        [(0, (0, parcelRequire("5fc53")).TEAMS_PLATFORM_CF_TYPE)]: {
            totalCount: 0,
            options: []
        }
    };
    const $96faa576a82047b8$var$MAX_NUMBER_OF_OPTIONS = 20;
    const $96faa576a82047b8$export$da1ab223b3f1410c = ()=>{
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const { data: orgId } = (0, (0, parcelRequire("14XJw")).useOrgId)();
        const fetchTeams = (0, $5uXOq.useCallback)(async ({ query: query, first: first = $96faa576a82047b8$var$MAX_NUMBER_OF_OPTIONS, after: after })=>{
            if (orgId) try {
                const response = await (0, (0, parcelRequire("eusud")).performPostRequest)('/gateway/api/graphql', {
                    body: JSON.stringify({
                        query: (0, $31f39d27d8739895$export$cbe5a6af25588495),
                        variables: {
                            orgId: $96faa576a82047b8$var$prependOrgIdAri(orgId),
                            cloudId: cloudId,
                            queryString: query,
                            first: first,
                            after: after
                        }
                    })
                });
                const options = (0, (0, parcelRequire("b4fG8")).transformTeams)(response.data.team.teamSearchV2) || [];
                const totalCount = options.length >= first ? first : options.length;
                return {
                    [(0, (0, parcelRequire("5fc53")).TEAMS_PLATFORM_CF_TYPE)]: {
                        totalCount: totalCount,
                        options: options
                    }
                };
            } catch (err) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'fetchTeams',
                        packageName: 'jiraBusinessFilters',
                        teamName: 'wanjel'
                    },
                    attributes: {
                        message: 'Failed to fetch team filter data'
                    },
                    error: err,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
            return $96faa576a82047b8$export$37430da53242c305;
        }, [
            cloudId,
            orgId
        ]);
        return fetchTeams;
    };
});
const $31f39d27d8739895$export$cbe5a6af25588495 = `
    query JWMTeamFilterValues($cloudId: String!, $orgId: ID!, $queryString: String, $first: Int, $after: String) {
        team @optIn(to: "Team-search-v2") {
            teamSearchV2(
                organizationId: $orgId
                siteId: $cloudId
                first: $first
                after: $after
                filter: {query: $queryString}
            ) {
                pageInfo {
                    hasNextPage
                    endCursor
                }
                edges {
                    node {
                        team {
                            id
                            displayName
                            smallAvatarImageUrl
                        }
                    }
                }
            }
        }
    }
`;
parcelRegister("czmU8", function(module, exports) {
    $parcel$export(module.exports, "hydrateFilterValues", ()=>$3268558672fc0eb1$export$b18eef22aaa99c21);
    var $8QpSo;
    var $c9Ur7;
    var $jlq4V;
    var $jcw0u;
    var $4R6GH;
    var $eusud;
    const $3268558672fc0eb1$export$3361e9be8093ddcc = (fields)=>{
        const hydratedValues = {};
        fields.forEach((hydratedField)=>{
            if (!hydratedField) return;
            const { field: field, values: values } = hydratedField;
            if (!field || !values) return;
            hydratedValues[field.jqlTerm] = {
                edges: values.map((item)=>(item && item.values && item.values[0]) ?? null).filter(Boolean).map((item)=>({
                        node: item
                    })),
                totalCount: 0
            };
        });
        return hydratedValues;
    };
    const $3268558672fc0eb1$export$7a89edfb546e2344 = async (cloudId, jqlContext)=>{
        try {
            const response = await (0, (0, parcelRequire("eusud")).performPostRequest)('/rest/gira/1/?operation=JWMHydrateFilterValues', {
                body: JSON.stringify({
                    query: (0, (0, parcelRequire("4R6GH")).fg)('native_goals_integration_on_list_view') ? (0, $d73ce8e52a931002$export$2bd792833522f1f1) : (0, $d73ce8e52a931002$export$e8b5e80812d4a604),
                    variables: {
                        cloudId: cloudId,
                        jql: jqlContext
                    }
                })
            });
            if (response.errors != null) throw new (0, (0, parcelRequire("jlq4V")).GraphQLErrors)(response.errors);
            if (response.data?.jira?.jqlBuilder?.hydrateJqlQuery?.fields == null) {
                if (response.data?.jira?.jqlBuilder?.hydrateJqlQuery?.__typename === 'QueryError') throw new (0, (0, parcelRequire("c9Ur7")).QueryError)(response.data.jira.jqlBuilder.hydrateJqlQuery);
                throw new Error('Failed to fetch on hydrateFilterValuesService');
            }
            return $3268558672fc0eb1$export$3361e9be8093ddcc(response.data.jira.jqlBuilder.hydrateJqlQuery.fields);
        } catch (error) {
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'JWMHydrateFilterValues',
                    packageName: 'jiraBusinessFilters',
                    teamName: 'wanjel'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    };
    const $3268558672fc0eb1$export$b18eef22aaa99c21 = (0, (0, parcelRequire("8QpSo")).default)($3268558672fc0eb1$export$7a89edfb546e2344);
});
const $d73ce8e52a931002$var$FIELD_VALUE_NODE_FRAGMENT_OLD = `
fragment FieldValueNodeFragment on JiraJqlFieldValue {
    jqlTerm
    displayName
    ... on JiraJqlUserFieldValue {
        user {
            picture
        }
    }
    ... on JiraJqlPriorityFieldValue {
        priority {
            iconUrl
        }
    }
    ... on JiraJqlIssueTypeFieldValue {
        issueTypes {
            issueTypeId
            avatar {
                medium
            }
            hierarchy {
                level
            }
        }
    }
    ... on JiraJqlStatusFieldValue {
        statusCategory {
            statusCategoryId
        }
    }
    ... on JiraJqlSprintFieldValue {
        sprint {
            sprintId
            name
        }
    }
    ... on JiraJqlIssueFieldValue {
        issue {
            fieldsByIdOrAlias(idsOrAliases: ["issuetype"]) {
                ... on JiraIssueTypeField {
                    issueType {
                        avatar {
                            medium
                        }
                    }
                }
            }
        }
    }
}
`;
const $d73ce8e52a931002$export$e8b5e80812d4a604 = `
query JwmHydrateFilterValues($cloudId: ID!, $jql: String!) {
	jira {
        jqlBuilder(cloudId: $cloudId) {
            hydrateJqlQuery(query: $jql, viewContext: JWM) {
                ... on JiraJqlHydratedQuery {
                    fields {
                        ... on JiraJqlQueryHydratedField {
                            field {
                                jqlTerm
                            }
                            values {
                                ... on JiraJqlQueryHydratedValue {
                                    values {
                                        jqlTerm
                                        displayName
                                        ...FieldValueNodeFragment
                                    }
                                }
                            }
                        }
                    }
                }
                ... on QueryError {
                    message
                    extensions {
                      statusCode
                    }
                }
                __typename
            }
        }
	}
}
${$d73ce8e52a931002$var$FIELD_VALUE_NODE_FRAGMENT_OLD}
`;
const $d73ce8e52a931002$var$FIELD_VALUE_NODE_FRAGMENT = `
fragment FieldValueNodeFragment on JiraJqlFieldValue {
    jqlTerm
    displayName
    ... on JiraJqlUserFieldValue {
        user {
            picture
        }
    }
    ... on JiraJqlPriorityFieldValue {
        priority {
            iconUrl
        }
    }
    ... on JiraJqlIssueTypeFieldValue {
        issueTypes {
            issueTypeId
            avatar {
                medium
            }
            hierarchy {
                level
            }
        }
    }
    ... on JiraJqlStatusFieldValue {
        statusCategory {
            statusCategoryId
        }
    }
    ... on JiraJqlSprintFieldValue {
        sprint {
            sprintId
            name
        }
    }
    ... on JiraJqlGoalsFieldValue {
        goal {
            name
            status
        }
    }
    ... on JiraJqlIssueFieldValue {
        issue {
            fieldsByIdOrAlias(idsOrAliases: ["issuetype"]) {
                ... on JiraIssueTypeField {
                    issueType {
                        avatar {
                            medium
                        }
                    }
                }
            }
        }
    }
}
`;
const $d73ce8e52a931002$export$2bd792833522f1f1 = `
query JwmHydrateFilterValues($cloudId: ID!, $jql: String!) {
	jira {
        jqlBuilder(cloudId: $cloudId) {
            hydrateJqlQuery(query: $jql, viewContext: JWM) {
                ... on JiraJqlHydratedQuery {
                    fields {
                        ... on JiraJqlQueryHydratedField {
                            field {
                                jqlTerm
                            }
                            values {
                                ... on JiraJqlQueryHydratedValue {
                                    values {
                                        jqlTerm
                                        displayName
                                        ...FieldValueNodeFragment
                                    }
                                }
                            }
                        }
                    }
                }
                ... on QueryError {
                    message
                    extensions {
                      statusCode
                    }
                }
                __typename
            }
        }
	}
}
${$d73ce8e52a931002$var$FIELD_VALUE_NODE_FRAGMENT}
`;
parcelRegister("84pWT", function(module, exports) {
    $parcel$export(module.exports, "transformHydratedValues", ()=>$b845ee1bf81ff96f$export$56282b201a60959e);
    $parcel$export(module.exports, "mergeHydratedValues", ()=>$b845ee1bf81ff96f$export$8f60413c08081990);
    var $3JOCw = parcelRequire("3JOCw");
    var $4R6GH;
    var $5fc53;
    var $b4fG8;
    const $b845ee1bf81ff96f$var$transformHydratedValuesOld = (data)=>{
        const transformedHydratedData = {
            labels: {
                totalCount: 0,
                options: []
            },
            components: {
                totalCount: 0,
                options: []
            },
            priority: {
                totalCount: 0,
                options: []
            },
            users: {
                totalCount: 0,
                options: []
            },
            issuetype: {
                totalCount: 0,
                options: []
            },
            status: {
                totalCount: 0,
                options: []
            },
            [(0, (0, parcelRequire("5fc53")).CATEGORY_TYPE)]: {
                totalCount: 0,
                options: []
            },
            [(0, (0, parcelRequire("5fc53")).SPRINT_TYPE)]: {
                totalCount: 0,
                options: []
            }
        };
        Object.keys(data).forEach((key)=>{
            if (data[key] && data[key].edges && Array.isArray(data[key].edges)) switch(key){
                case 'issuetype':
                    transformedHydratedData[key] = {
                        totalCount: 0,
                        options: (0, (0, parcelRequire("b4fG8")).transformIssueTypes)(data[key])
                    };
                    return;
                case 'priority':
                    transformedHydratedData[key] = {
                        totalCount: 0,
                        options: (0, (0, parcelRequire("b4fG8")).transformPriorities)(data[key])
                    };
                    return;
                case 'status':
                    transformedHydratedData[key] = {
                        totalCount: 0,
                        options: (0, (0, parcelRequire("b4fG8")).transformStatuses)(data[key])
                    };
                    return;
                case 'labels':
                    transformedHydratedData[key] = {
                        totalCount: 0,
                        options: (0, (0, parcelRequire("b4fG8")).transformDefaultField)(data[key])
                    };
                    return;
                case 'component':
                    transformedHydratedData.components = {
                        totalCount: 0,
                        options: (0, (0, parcelRequire("b4fG8")).transformDefaultField)(data[key])
                    };
                    return;
                default:
                    if (data[key].edges.some((item)=>item.node && 'user' in item.node)) transformedHydratedData.users = {
                        totalCount: 0,
                        options: (0, ($parcel$interopDefault($3JOCw)))([
                            ...(0, (0, parcelRequire("b4fG8")).transformUsers)(data[key]),
                            ...transformedHydratedData.users?.options ?? []
                        ], ({ value: value })=>value)
                    };
                    else if (data[key].edges.some((item)=>item.node && 'sprint' in item.node)) transformedHydratedData[0, (0, parcelRequire("5fc53")).SPRINT_TYPE] = {
                        totalCount: 0,
                        options: (0, (0, parcelRequire("b4fG8")).transformSprints)(data[key])
                    };
            }
        });
        return transformedHydratedData;
    };
    const $b845ee1bf81ff96f$export$56282b201a60959e = (data)=>{
        if ((0, (0, parcelRequire("4R6GH")).fg)('jsw_list_view_-_all_the_fields')) return (0, (0, parcelRequire("b4fG8")).transformValuesData)(data);
        return $b845ee1bf81ff96f$var$transformHydratedValuesOld(data);
    };
    const $b845ee1bf81ff96f$export$8f60413c08081990 = (initialData, hydratedValues)=>({
            labels: {
                totalCount: initialData.labels.totalCount,
                options: (0, ($parcel$interopDefault($3JOCw)))([
                    ...hydratedValues.labels.options,
                    ...initialData.labels.options
                ], ({ value: value })=>value)
            },
            components: {
                totalCount: initialData.components.totalCount,
                options: (0, ($parcel$interopDefault($3JOCw)))([
                    ...hydratedValues.components.options,
                    ...initialData.components.options
                ], ({ value: value })=>value)
            },
            priority: {
                totalCount: initialData.priority.totalCount,
                options: (0, ($parcel$interopDefault($3JOCw)))([
                    ...hydratedValues.priority.options,
                    ...initialData.priority.options
                ], ({ value: value })=>value)
            },
            users: {
                totalCount: initialData.users.totalCount,
                options: (0, ($parcel$interopDefault($3JOCw)))([
                    ...hydratedValues.users.options,
                    ...initialData.users.options
                ], ({ value: value })=>value)
            },
            issuetype: {
                totalCount: initialData.issuetype.totalCount,
                options: (0, ($parcel$interopDefault($3JOCw)))([
                    ...hydratedValues.issuetype.options,
                    ...initialData.issuetype.options
                ], ({ value: value })=>value)
            },
            status: {
                totalCount: initialData.status.totalCount,
                options: (0, ($parcel$interopDefault($3JOCw)))([
                    ...hydratedValues.status.options,
                    ...initialData.status.options
                ], ({ value: value })=>value)
            },
            [(0, (0, parcelRequire("5fc53")).CATEGORY_TYPE)]: initialData[0, (0, parcelRequire("5fc53")).CATEGORY_TYPE],
            [(0, (0, parcelRequire("5fc53")).SPRINT_TYPE)]: {
                totalCount: initialData[0, (0, parcelRequire("5fc53")).SPRINT_TYPE].totalCount,
                options: (0, ($parcel$interopDefault($3JOCw)))([
                    ...hydratedValues[0, (0, parcelRequire("5fc53")).SPRINT_TYPE].options,
                    ...initialData[0, (0, parcelRequire("5fc53")).SPRINT_TYPE].options
                ], ({ value: value })=>value)
            },
            [(0, (0, parcelRequire("5fc53")).FIX_VERSIONS_TYPE)]: {
                totalCount: initialData[0, (0, parcelRequire("5fc53")).FIX_VERSIONS_TYPE]?.totalCount || 0,
                options: (0, ($parcel$interopDefault($3JOCw)))([
                    ...hydratedValues[0, (0, parcelRequire("5fc53")).FIX_VERSIONS_TYPE]?.options || [],
                    ...initialData[0, (0, parcelRequire("5fc53")).FIX_VERSIONS_TYPE]?.options || []
                ], ({ value: value })=>value)
            },
            [(0, (0, parcelRequire("5fc53")).PARENT_FIELD_TYPE)]: {
                totalCount: initialData[0, (0, parcelRequire("5fc53")).PARENT_FIELD_TYPE]?.totalCount || 0,
                options: (0, ($parcel$interopDefault($3JOCw)))([
                    ...hydratedValues[0, (0, parcelRequire("5fc53")).PARENT_FIELD_TYPE]?.options || [],
                    ...initialData[0, (0, parcelRequire("5fc53")).PARENT_FIELD_TYPE]?.options || []
                ], ({ value: value })=>value)
            },
            [(0, (0, parcelRequire("5fc53")).GOALS_CF_TYPE)]: {
                totalCount: initialData[0, (0, parcelRequire("5fc53")).GOALS_CF_TYPE]?.totalCount || 0,
                options: (0, ($parcel$interopDefault($3JOCw)))([
                    ...hydratedValues[0, (0, parcelRequire("5fc53")).GOALS_CF_TYPE]?.options || [],
                    ...initialData[0, (0, parcelRequire("5fc53")).GOALS_CF_TYPE]?.options || []
                ], ({ value: value })=>value)
            },
            [(0, (0, parcelRequire("5fc53")).TEAMS_PLATFORM_CF_TYPE)]: {
                totalCount: initialData[0, (0, parcelRequire("5fc53")).TEAMS_PLATFORM_CF_TYPE]?.totalCount || 0,
                options: (0, ($parcel$interopDefault($3JOCw)))([
                    ...hydratedValues[0, (0, parcelRequire("5fc53")).TEAMS_PLATFORM_CF_TYPE]?.options || [],
                    ...initialData[0, (0, parcelRequire("5fc53")).TEAMS_PLATFORM_CF_TYPE]?.options || []
                ], ({ value: value })=>value)
            }
        });
});
const $c4148dc6c1f759d4$var$FIELD_VALUE_NODE_FRAGMENT = `
fragment FieldValueNodeFragment on JiraJqlFieldValue {
    jqlTerm
    displayName
    ... on JiraJqlUserFieldValue {
        user {
            picture
        }
    }
    ... on JiraJqlPriorityFieldValue {
        priority {
            iconUrl
        }
    }
    ... on JiraJqlIssueTypeFieldValue {
        issueTypes {
            issueTypeId
            avatar {
                medium
            }
            hierarchy {
                level
            }
        }
    }
    ... on JiraJqlStatusFieldValue {
        statusCategory {
            statusCategoryId
        }
    }
    ... on JiraJqlSprintFieldValue {
        sprint {
            sprintId
            name
        }
    }
    ... on JiraJqlGoalsFieldValue {
        goal {
            name
            status
        }
    }
    ... on JiraJqlIssueFieldValue {
        issue {
            fieldsByIdOrAlias(idsOrAliases: ["issuetype"]) {
                ... on JiraIssueTypeField {
                    issueType {
                        avatar {
                            medium
                        }
                    }
                }
            }
        }
    }
}
`;
const $c4148dc6c1f759d4$var$CATEGORY_CONNECTION_FRAGMENT = `
fragment CategoryConnection on JiraWorkManagementCategoryOptionConnection {
    edges {
        cursor
        node {
            option {
              value
            }
            color
        }
    }
    totalCount
}
`;
const $c4148dc6c1f759d4$export$a48313dd44fc9855 = `
query JwmInitialFilterValues($cloudId: ID!, $first: Int, $jql: String!, $shouldFetchSprints: Boolean = false, $shouldFetchSoftwareFields: Boolean = false, $sprintsJqlContext: String, $goalsJqlTerm: String!, $shouldFetchGoalsField: Boolean = false, $shouldFetchParentField: Boolean = false) {
    jira {
        jqlBuilder(cloudId: $cloudId) {
            labels: fieldValues(
                first: $first
                jqlTerm: "labels"
                jqlContext: $jql
                viewContext: JWM
            ) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            components: fieldValues(
                first: $first
                jqlTerm: "component"
                jqlContext: $jql
                viewContext: JWM
            ) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            priority: fieldValues(
                first: $first
                jqlTerm: "priority"
                jqlContext: $jql
                viewContext: JWM
            ) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            users: fieldValues(
                first: $first
                jqlTerm: "assignee"
                jqlContext: $jql
                viewContext: JWM
            ) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            recentlyUsedUsers(
                first: $first
            ) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            issuetype: fieldValues(
                first: $first
                jqlTerm: "issuetype"
                jqlContext: $jql
                viewContext: JWM
            ) {
                edges {
                     cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            status: fieldValues(
                first: $first
                jqlTerm: "status"
                jqlContext: $jql
                viewContext: JWM
            ) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            sprints: fieldValues(
                first: $first
                jqlTerm: "sprint"
                jqlContext: $sprintsJqlContext
                viewContext: JSW
            ) @include(if: $shouldFetchSprints) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            fixVersions: fieldValues(
                first: $first
                jqlTerm: "fixVersion"
                jqlContext: $jql
                viewContext: JWM
            ) @include(if: $shouldFetchSoftwareFields) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
            parent: fieldValues(
                first: $first
                jqlTerm: "parent"
                jqlContext: $jql
                viewContext: JSW
            ) @include(if: $shouldFetchParentField) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }

            goals: fieldValues(
                first: $first
                jqlTerm: $goalsJqlTerm
                jqlContext: $jql
                viewContext: JWM
            ) @include(if: $shouldFetchGoalsField) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
        }
        jwmCategoryOptions(jqlContext: $jql, first: $first) {
            ...CategoryConnection
        }
    }
}
${$c4148dc6c1f759d4$var$FIELD_VALUE_NODE_FRAGMENT}
${$c4148dc6c1f759d4$var$CATEGORY_CONNECTION_FRAGMENT}
`;
const $c4148dc6c1f759d4$export$f8e8a5f34f6ea725 = `
query JwmSearchFilterValues($cloudId: ID!, $first: Int, $jqlTerm: String!, $jql: String!, $searchString: String, $after: String) {
    jira {
        jqlBuilder(cloudId: $cloudId) {
            fieldValues(
                first: $first
                jqlTerm: $jqlTerm
                jqlContext: $jql
                searchString: $searchString
                after: $after
                viewContext: JWM
            ) {
                edges {
                    cursor
                    node {
                        ...FieldValueNodeFragment
                    }
                }
                totalCount
            }
        }
    }
}
${$c4148dc6c1f759d4$var$FIELD_VALUE_NODE_FRAGMENT}
`;
const $c4148dc6c1f759d4$export$562e34ec948f373d = `
query JwmCategorySearchFilterValues($first: Int, $jql: String!, $searchQuery: String, $after: String) {
    jira {       
        jwmCategoryOptions(jqlContext: $jql, first: $first, searchQuery: $searchQuery, after: $after) {
            ...CategoryConnection
        }
    }
}
${$c4148dc6c1f759d4$var$CATEGORY_CONNECTION_FRAGMENT}
`;
parcelRegister("ldL1T", function(module, exports) {
    $parcel$export(module.exports, "transformInitialData", ()=>$6a7ee4f9267edb3b$export$93219b8691fe49a0);
    $parcel$export(module.exports, "fireFieldValuesErrorAnalytics", ()=>$6a7ee4f9267edb3b$export$c3c62a63250fc6f8);
    $parcel$export(module.exports, "useGoalsJqlTerm", ()=>$6a7ee4f9267edb3b$export$674eff5ec8403101);
    var $5uXOq = parcelRequire("5uXOq");
    var $3JOCw = parcelRequire("3JOCw");
    var $jcw0u;
    var $4R6GH;
    var $5fc53;
    var $b4fG8;
    const $6a7ee4f9267edb3b$var$transformInitialCategories = (data)=>{
        if (data.jira.jwmCategoryOptions?.edges != null && Array.isArray(data.jira.jwmCategoryOptions.edges)) return {
            totalCount: data.jira.jwmCategoryOptions.totalCount,
            options: (0, (0, parcelRequire("b4fG8")).transformCategories)(data.jira.jwmCategoryOptions)
        };
        return undefined;
    };
    const $6a7ee4f9267edb3b$var$transformInitialDataOld = (data)=>{
        const { components: components, issuetype: issuetype, priority: priority, labels: labels, status: status, users: users, recentlyUsedUsers: recentlyUsedUsers, sprints: sprints } = data.jira.jqlBuilder;
        const transformedData = {
            labels: {
                totalCount: 0,
                options: []
            },
            components: {
                totalCount: 0,
                options: []
            },
            priority: {
                totalCount: 0,
                options: []
            },
            users: {
                totalCount: 0,
                options: []
            },
            issuetype: {
                totalCount: 0,
                options: []
            },
            status: {
                totalCount: 0,
                options: []
            },
            [(0, (0, parcelRequire("5fc53")).CATEGORY_TYPE)]: {
                totalCount: 0,
                options: []
            },
            [(0, (0, parcelRequire("5fc53")).SPRINT_TYPE)]: {
                totalCount: 0,
                options: []
            }
        };
        if (components?.edges != null && Array.isArray(components.edges)) transformedData.components = {
            totalCount: components.totalCount,
            options: (0, (0, parcelRequire("b4fG8")).transformDefaultField)(components)
        };
        if (issuetype?.edges != null && Array.isArray(issuetype.edges)) transformedData.issuetype = {
            totalCount: issuetype.totalCount,
            options: (0, (0, parcelRequire("b4fG8")).transformIssueTypes)(issuetype)
        };
        if (priority?.edges != null && Array.isArray(priority.edges)) transformedData.priority = {
            totalCount: priority.totalCount,
            options: (0, (0, parcelRequire("b4fG8")).transformPriorities)(priority)
        };
        if (labels?.edges != null && Array.isArray(labels.edges)) transformedData.labels = {
            totalCount: labels.totalCount,
            options: (0, (0, parcelRequire("b4fG8")).transformDefaultField)(labels)
        };
        if (status?.edges != null && Array.isArray(status.edges)) transformedData.status = {
            totalCount: status.totalCount,
            options: (0, (0, parcelRequire("b4fG8")).transformStatuses)(status)
        };
        if (users?.edges != null && Array.isArray(users.edges)) {
            const usersData = (0, (0, parcelRequire("b4fG8")).transformUsers)(users);
            const recentlyUsedUsersData = recentlyUsedUsers?.edges != null && Array.isArray(recentlyUsedUsers.edges) ? (0, (0, parcelRequire("b4fG8")).transformUsers)(recentlyUsedUsers) : null;
            transformedData.users = {
                totalCount: users.totalCount,
                options: recentlyUsedUsersData != null ? (0, ($parcel$interopDefault($3JOCw)))([
                    ...recentlyUsedUsersData,
                    ...usersData
                ], ({ value: value })=>value) : usersData
            };
        }
        const categories = $6a7ee4f9267edb3b$var$transformInitialCategories(data);
        if (categories) transformedData[0, (0, parcelRequire("5fc53")).CATEGORY_TYPE] = categories;
        if (sprints?.edges != null && Array.isArray(sprints.edges)) transformedData[0, (0, parcelRequire("5fc53")).SPRINT_TYPE] = {
            options: (0, (0, parcelRequire("b4fG8")).transformSprints)(sprints),
            totalCount: sprints.totalCount
        };
        return transformedData;
    };
    const $6a7ee4f9267edb3b$export$93219b8691fe49a0 = (data)=>{
        if ((0, (0, parcelRequire("4R6GH")).fg)('jsw_list_view_-_all_the_fields')) {
            const transformedData = (0, (0, parcelRequire("b4fG8")).transformValuesData)(data.jira.jqlBuilder);
            const categories = $6a7ee4f9267edb3b$var$transformInitialCategories(data);
            if (categories) transformedData[0, (0, parcelRequire("5fc53")).CATEGORY_TYPE] = categories;
            return transformedData;
        }
        return $6a7ee4f9267edb3b$var$transformInitialDataOld(data);
    };
    const $6a7ee4f9267edb3b$export$c3c62a63250fc6f8 = (errorId, errorMessage, error)=>{
        (0, (0, parcelRequire("jcw0u")).default)({
            meta: {
                id: errorId,
                packageName: 'jiraBusinessFilters',
                teamName: 'wanjel'
            },
            attributes: {
                message: errorMessage
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    };
    const $6a7ee4f9267edb3b$export$674eff5ec8403101 = (filterFields)=>{
        const goalsJqlTerm = (0, $5uXOq.useMemo)(()=>filterFields?.find((field)=>field?.type === (0, (0, parcelRequire("5fc53")).GOALS_CF_TYPE))?.id, [
            filterFields
        ]);
        return goalsJqlTerm;
    };
});
parcelRegister("RjSi3", function(module, exports) {
    $parcel$export(module.exports, "useFieldConfigV2", ()=>$95c9fbd80a67ba2b$export$c041141a7ef797c1);
    var $5uXOq = parcelRequire("5uXOq");
    var $54qG5;
    var $aJfd5;
    var $4R6GH;
    var $koVbs;
    var $5fc53;
    var $5FlVd;
    var $8DJTW;
    var $gxGcZ;
    var $1qi71;
    const $95c9fbd80a67ba2b$var$EMPTY_FIELD_DATA = {
        totalCount: 0,
        options: []
    };
    const $95c9fbd80a67ba2b$var$EMPTY_FILTER_DATA = {
        initialUsers: $95c9fbd80a67ba2b$var$EMPTY_FIELD_DATA,
        initialLabels: $95c9fbd80a67ba2b$var$EMPTY_FIELD_DATA,
        initialComponents: $95c9fbd80a67ba2b$var$EMPTY_FIELD_DATA,
        initialPriorities: $95c9fbd80a67ba2b$var$EMPTY_FIELD_DATA,
        initialIssueTypes: $95c9fbd80a67ba2b$var$EMPTY_FIELD_DATA,
        initialStatuses: $95c9fbd80a67ba2b$var$EMPTY_FIELD_DATA,
        initialCategories: $95c9fbd80a67ba2b$var$EMPTY_FIELD_DATA,
        initialSprints: $95c9fbd80a67ba2b$var$EMPTY_FIELD_DATA,
        initialFixVersions: $95c9fbd80a67ba2b$var$EMPTY_FIELD_DATA,
        initialParents: $95c9fbd80a67ba2b$var$EMPTY_FIELD_DATA,
        initialGoals: $95c9fbd80a67ba2b$var$EMPTY_FIELD_DATA,
        initialTeams: $95c9fbd80a67ba2b$var$EMPTY_FIELD_DATA
    };
    const $95c9fbd80a67ba2b$var$initialState = {
        data: undefined,
        loadingData: true
    };
    const $95c9fbd80a67ba2b$var$reducer = (state, action)=>{
        switch(action.type){
            case 'init':
                return $95c9fbd80a67ba2b$var$initialState;
            case 'fetch-data-success':
                return {
                    ...state,
                    data: action.value,
                    loadingData: false
                };
            case 'fetch-data-error':
                return {
                    ...state,
                    data: $95c9fbd80a67ba2b$var$EMPTY_FILTER_DATA,
                    loadingData: false
                };
            default:
                return state;
        }
    };
    const $95c9fbd80a67ba2b$var$emptyFieldValue = {
        totalCount: 0,
        options: []
    };
    const $95c9fbd80a67ba2b$export$c041141a7ef797c1 = ({ view: view, allowedFieldTypes: allowedFieldTypes })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const projectFieldData = (0, (0, parcelRequire("gxGcZ")).useProjectFilter)();
        const { data: filterFields, loading: loadingFilterFields } = (0, (0, parcelRequire("8DJTW")).useFilterFields)();
        const [{ data: data, loadingData: loadingData }, dispatch] = (0, $5uXOq.useReducer)($95c9fbd80a67ba2b$var$reducer, $95c9fbd80a67ba2b$var$initialState);
        const userResolver = (0, $5uXOq.useRef)(new (0, (0, parcelRequire("aJfd5")).UserResolver)());
        const { fetchLabels: fetchLabels, fetchComponents: fetchComponents, fetchUsers: fetchUsers, fetchCategories: fetchCategories, fetchInitialData: fetchInitialData, ...fetchOptions } = (0, (0, parcelRequire("5FlVd")).useFetchFieldValues)({
            view: view,
            allowedFieldTypes: allowedFieldTypes,
            filterFields: filterFields
        });
        const { data: entity } = (0, (0, parcelRequire("54qG5")).useBusinessEntity)();
        const businessEntityId = entity.id;
        const initialiseDefaultData = (0, $5uXOq.useCallback)(()=>{
            fetchInitialData().then((initialData)=>{
                dispatch({
                    type: 'fetch-data-success',
                    value: {
                        initialUsers: initialData?.users ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
                        initialLabels: initialData?.labels ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
                        initialComponents: initialData?.components ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
                        initialPriorities: initialData?.priority ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
                        initialIssueTypes: initialData?.issuetype ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
                        initialStatuses: initialData?.status ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
                        initialCategories: initialData?.[0, (0, parcelRequire("5fc53")).CATEGORY_TYPE] ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
                        initialSprints: initialData?.[0, (0, parcelRequire("5fc53")).SPRINT_TYPE] ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
                        ...(0, (0, parcelRequire("4R6GH")).fg)('jsw_list_view_-_all_the_fields') ? {
                            initialFixVersions: initialData?.[0, (0, parcelRequire("5fc53")).FIX_VERSIONS_TYPE] ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
                            initialParents: initialData?.[0, (0, parcelRequire("5fc53")).PARENT_FIELD_TYPE] ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
                            initialTeams: initialData?.[0, (0, parcelRequire("5fc53")).TEAMS_PLATFORM_CF_TYPE] ?? $95c9fbd80a67ba2b$var$emptyFieldValue
                        } : {},
                        initialGoals: initialData?.[0, (0, parcelRequire("5fc53")).GOALS_CF_TYPE] ?? $95c9fbd80a67ba2b$var$emptyFieldValue
                    }
                });
            }).catch(()=>{
                dispatch({
                    type: 'fetch-data-error'
                });
            });
        }, [
            fetchInitialData
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (!loadingFilterFields) {
                dispatch({
                    type: 'init'
                });
                initialiseDefaultData();
            }
        }, [
            initialiseDefaultData,
            loadingFilterFields,
            businessEntityId
        ]);
        const { fieldConfig: fieldConfig, resolvers: resolvers } = (0, $5uXOq.useMemo)(()=>{
            const fieldOptionsData = {
                priority: data?.initialPriorities ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
                issuetype: data?.initialIssueTypes ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
                status: data?.initialStatuses ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
                users: data?.initialUsers ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
                labels: data?.initialLabels ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
                components: data?.initialComponents ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
                [(0, (0, parcelRequire("5fc53")).CATEGORY_TYPE)]: data?.initialCategories ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
                [(0, (0, parcelRequire("5fc53")).SPRINT_TYPE)]: data?.initialSprints ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
                project: projectFieldData,
                ...(0, (0, parcelRequire("4R6GH")).fg)('jsw_list_view_-_all_the_fields') ? {
                    [(0, (0, parcelRequire("5fc53")).FIX_VERSIONS_TYPE)]: data?.initialFixVersions ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
                    [(0, (0, parcelRequire("5fc53")).PARENT_FIELD_TYPE)]: data?.initialParents ?? $95c9fbd80a67ba2b$var$emptyFieldValue,
                    [(0, (0, parcelRequire("5fc53")).TEAMS_PLATFORM_CF_TYPE)]: data?.initialTeams ?? $95c9fbd80a67ba2b$var$emptyFieldValue
                } : {},
                [(0, (0, parcelRequire("5fc53")).GOALS_CF_TYPE)]: data?.initialGoals ?? $95c9fbd80a67ba2b$var$emptyFieldValue
            };
            return (0, (0, parcelRequire("1qi71")).getFilterFieldConfigAndResolvers)({
                view: view,
                formatMessage: formatMessage,
                allFields: filterFields,
                allowedFieldTypes: allowedFieldTypes,
                fieldOptionsData: fieldOptionsData,
                fetchUsers: fetchUsers,
                fetchLabels: fetchLabels,
                fetchComponents: fetchComponents,
                fetchCategories: fetchCategories,
                ...fetchOptions,
                userResolver: userResolver.current
            });
        }, [
            data?.initialPriorities,
            data?.initialIssueTypes,
            data?.initialStatuses,
            data?.initialUsers,
            data?.initialLabels,
            data?.initialComponents,
            data?.initialCategories,
            data?.initialSprints,
            data?.initialFixVersions,
            data?.initialParents,
            data?.initialGoals,
            data?.initialTeams,
            projectFieldData,
            view,
            formatMessage,
            filterFields,
            allowedFieldTypes,
            fetchUsers,
            fetchLabels,
            fetchComponents,
            fetchCategories,
            fetchOptions
        ]);
        return {
            fieldConfig: fieldConfig,
            resolvers: resolvers,
            loading: loadingData || loadingFilterFields || data == null
        };
    };
});
parcelRegister("aJfd5", function(module, exports) {
    $parcel$export(module.exports, "UserResolver", ()=>$c1905445333aa67f$export$723df28d03868f02);
    var $dJl1T;
    var $7f4tk;
    class $c1905445333aa67f$export$723df28d03868f02 {
        constructor(){
            this.getUsersFromAccountId = (accountIds)=>{
                const recoveredFromCache = [];
                const missingFromCache = [];
                accountIds.forEach((accountId)=>{
                    const user = this.cache.get(accountId);
                    if (user) recoveredFromCache.push(user);
                    else missingFromCache.push(accountId);
                });
                if (missingFromCache.length === 0) return Promise.resolve(recoveredFromCache);
                return (0, (0, parcelRequire("7f4tk")).default)(`/rest/api/2/user/bulk?maxResults=10&${missingFromCache.map((accountId)=>`accountId=${accountId}`).join('&')}`).then((response)=>response && response.values.length > 0 && response.values.forEach((user)=>{
                        if (user) this.cache.set(user.accountId, user);
                    })).then(()=>this.getUsersFromAccountId(accountIds)).catch((err)=>{
                    (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('jwm.services.get-users', 'Failed to fetch users', err);
                });
            };
            this.cache = new Map();
        }
    }
});
parcelRegister("1qi71", function(module, exports) {
    $parcel$export(module.exports, "getFilterFieldConfigAndResolvers", ()=>$beea8d83023eb0fe$export$ba4f3d2149c2bf3b);
    var $9XE6b = parcelRequire("9XE6b");
    var $8QpSo;
    var $4R6GH;
    var $5fc53;
    var $dCm1o;
    var $gzkAf;
    var $gBF4Z;
    var $7htvz;
    var $j0h5m;
    const $beea8d83023eb0fe$export$fb8c90bfc4beaa59 = (0, (0, parcelRequire("8QpSo")).default)((users)=>users.reduce((acc, next)=>{
            acc.push({
                value: next.accountId || '',
                label: next.displayName,
                avatar: (0, ($parcel$interopDefault($9XE6b)))(next, [
                    'avatarUrls',
                    '24x24'
                ], '')
            });
            return acc;
        }, []));
    const $beea8d83023eb0fe$var$getType = (type)=>{
        switch(type){
            case 0, (0, parcelRequire("5fc53")).CATEGORY_TYPE:
                return (0, (0, parcelRequire("gBF4Z")).FieldType).CategorySelectFilter;
            case 0, (0, parcelRequire("5fc53")).PRIORITY_TYPE:
                return (0, (0, parcelRequire("gBF4Z")).FieldType).PrioritySelectFilter;
            case 0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE:
            case 0, (0, parcelRequire("5fc53")).REPORTER_TYPE:
            case 0, (0, parcelRequire("5fc53")).USER_CF_TYPE:
                return (0, (0, parcelRequire("gBF4Z")).FieldType).AvatarAsyncSelectFilter;
            case 0, (0, parcelRequire("5fc53")).ISSUE_TYPE:
            case 0, (0, parcelRequire("5fc53")).PARENT_FIELD_TYPE:
            case 0, (0, parcelRequire("5fc53")).TEAMS_PLATFORM_CF_TYPE:
                return (0, (0, parcelRequire("gBF4Z")).FieldType).AvatarSelectFilter;
            case 0, (0, parcelRequire("5fc53")).STATUS_TYPE:
                return (0, (0, parcelRequire("gBF4Z")).FieldType).LozengeSelectFilter;
            case 0, (0, parcelRequire("5fc53")).LABELS_TYPE:
            case 0, (0, parcelRequire("5fc53")).COMPONENTS_TYPE:
            case 0, (0, parcelRequire("5fc53")).FIX_VERSIONS_TYPE:
            case 0, (0, parcelRequire("5fc53")).SPRINT_TYPE:
                return (0, (0, parcelRequire("gBF4Z")).FieldType).AsyncSelectFilter;
            case 0, (0, parcelRequire("5fc53")).CREATED:
            case 0, (0, parcelRequire("5fc53")).UPDATED:
                return (0, (0, parcelRequire("gBF4Z")).FieldType).DateFilter;
            case 0, (0, parcelRequire("5fc53")).PROJECT_TYPE:
                return (0, (0, parcelRequire("gBF4Z")).FieldType).ProjectFilter;
            case 0, (0, parcelRequire("5fc53")).GOALS_CF_TYPE:
                return (0, (0, parcelRequire("gBF4Z")).FieldType).GoalsSelectFilter;
            default:
                return (0, (0, parcelRequire("gBF4Z")).FieldType).SelectFilter;
        }
    };
    const $beea8d83023eb0fe$var$getValues = (type, fieldOptionsData)=>{
        switch(type){
            case 0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE:
            case 0, (0, parcelRequire("5fc53")).REPORTER_TYPE:
            case 0, (0, parcelRequire("5fc53")).USER_CF_TYPE:
                return fieldOptionsData.users;
            default:
                return fieldOptionsData[type];
        }
    };
    const $beea8d83023eb0fe$var$isUserField = (type)=>{
        switch(type){
            case 0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE:
            case 0, (0, parcelRequire("5fc53")).REPORTER_TYPE:
            case 0, (0, parcelRequire("5fc53")).USER_CF_TYPE:
                return true;
            default:
                return false;
        }
    };
    const $beea8d83023eb0fe$var$isCustomField = (type)=>{
        switch(type){
            case 0, (0, parcelRequire("5fc53")).USER_CF_TYPE:
            case 0, (0, parcelRequire("5fc53")).PEOPLE_CF_TYPE:
            case 0, (0, parcelRequire("5fc53")).SELECT_CF_TYPE:
            case 0, (0, parcelRequire("5fc53")).MULTI_SELECT_CF_TYPE:
            case 0, (0, parcelRequire("5fc53")).MULTI_CHECKBOXES_CF_TYPE:
                return true;
            default:
                return false;
        }
    };
    const $beea8d83023eb0fe$var$createUserValueGetter = (userResolver)=>(0, (0, parcelRequire("8QpSo")).default)((accountIds)=>userResolver.getUsersFromAccountId(accountIds).then((response)=>$beea8d83023eb0fe$export$fb8c90bfc4beaa59(response)));
    const $beea8d83023eb0fe$export$ba4f3d2149c2bf3b = ({ view: view, formatMessage: formatMessage, allowedFieldTypes: allowedFieldTypes, allFields: allFields, fieldOptionsData: fieldOptionsData, userResolver: userResolver, fetchUsers: fetchUsers, fetchLabels: fetchLabels, fetchComponents: fetchComponents, fetchCategories: fetchCategories, fetchStatuses: fetchStatuses, fetchPriorities: fetchPriorities, fetchIssueTypes: fetchIssueTypes, fetchSprints: fetchSprints, fetchFixVersions: fetchFixVersions, fetchParents: fetchParents, fetchGoals: fetchGoals, fetchTeams: fetchTeams })=>{
        const fieldConfig = {};
        const resolvers = {};
        if (allowedFieldTypes.has((0, (0, parcelRequire("gzkAf")).DATE_RANGE_TYPE))) fieldConfig.dateRange = {
            label: formatMessage((0, (0, parcelRequire("j0h5m")).default).dateRangeLabel),
            type: (0, (0, parcelRequire("gBF4Z")).FieldType).DateFilter,
            fromLabel: formatMessage((0, (0, parcelRequire("j0h5m")).default).startDateLabel),
            toLabel: formatMessage((0, (0, parcelRequire("j0h5m")).default).dueDateLabel)
        };
        const fields = allFields.filter((field)=>allowedFieldTypes.has(field.type ?? ''));
        fields.forEach((field)=>{
            const { name: name, type: type, id: id } = field;
            const fieldType = type ?? '';
            const fieldValues = $beea8d83023eb0fe$var$getValues(fieldType, fieldOptionsData);
            fieldConfig[id] = {
                label: name,
                type: $beea8d83023eb0fe$var$getType(fieldType),
                placeholder: formatMessage((0, (0, parcelRequire("j0h5m")).default).filterPlaceholder),
                options: fieldValues?.options || [],
                totalCount: fieldValues?.totalCount || 0,
                isCustomField: $beea8d83023eb0fe$var$isCustomField(fieldType),
                fieldConfigVersion: 2
            };
            if (type === (0, (0, parcelRequire("5fc53")).ISSUE_TYPE)) {
                let options = fieldValues?.options || [];
                if (view === 'board') {
                    options = (fieldValues?.options).filter((option)=>option.hierarchyLevel !== -1);
                    fieldConfig[id].options = options;
                }
                if (fetchIssueTypes) {
                    fieldConfig[id].loadOptions = fetchIssueTypes;
                    fieldConfig[id].defaultOptions = options;
                }
            } else if ($beea8d83023eb0fe$var$isUserField(fieldType)) {
                fieldConfig[id].loadOptions = fetchUsers;
                fieldConfig[id].defaultOptions = fieldValues?.options || [];
                resolvers[id] = $beea8d83023eb0fe$var$createUserValueGetter(userResolver);
                fieldConfig[id].options = [
                    ...fieldConfig[id].options,
                    {
                        value: (0, (0, parcelRequire("7htvz")).EMPTY_FILTER_VALUE),
                        label: formatMessage((0, (0, parcelRequire("j0h5m")).default).unassignedLabel),
                        isEmptyOption: true
                    }
                ];
                fieldConfig[id].totalCount += 1;
            } else if (fieldType === (0, (0, parcelRequire("5fc53")).LABELS_TYPE)) {
                fieldConfig[id].loadOptions = fetchLabels;
                fieldConfig[id].defaultOptions = fieldValues?.options || [];
                fieldConfig[id].options = [
                    ...fieldConfig[id].options,
                    {
                        value: (0, (0, parcelRequire("7htvz")).EMPTY_FILTER_VALUE),
                        label: formatMessage((0, (0, parcelRequire("j0h5m")).default).noLabelsLabel),
                        isEmptyOption: true
                    }
                ];
                fieldConfig[id].totalCount += 1;
            } else if (fieldType === (0, (0, parcelRequire("5fc53")).COMPONENTS_TYPE)) {
                fieldConfig[id].loadOptions = fetchComponents;
                fieldConfig[id].defaultOptions = fieldValues?.options || [];
                fieldConfig[id].options = [
                    ...fieldConfig[id].options,
                    {
                        value: (0, (0, parcelRequire("7htvz")).EMPTY_FILTER_VALUE),
                        label: formatMessage((0, (0, parcelRequire("j0h5m")).default).noComponentsLabel),
                        isEmptyOption: true
                    }
                ];
                fieldConfig[id].totalCount += 1;
            } else if (fieldType === (0, (0, parcelRequire("5fc53")).CATEGORY_TYPE)) {
                fieldConfig[id].loadOptions = fetchCategories;
                fieldConfig[id].defaultOptions = fieldValues?.options || [];
                fieldConfig[id].options = [
                    ...fieldConfig[id].options,
                    {
                        value: (0, (0, parcelRequire("7htvz")).EMPTY_FILTER_VALUE),
                        label: formatMessage((0, (0, parcelRequire("j0h5m")).default).noCategoriesLabel),
                        isEmptyOption: true
                    }
                ];
                fieldConfig[id].totalCount += 1;
            } else if (fieldType === (0, (0, parcelRequire("5fc53")).STATUS_TYPE) && fetchStatuses) {
                fieldConfig[id].loadOptions = fetchStatuses;
                fieldConfig[id].defaultOptions = fieldValues?.options || [];
            } else if (fieldType === (0, (0, parcelRequire("5fc53")).PRIORITY_TYPE) && fetchPriorities) {
                fieldConfig[id].loadOptions = fetchPriorities;
                fieldConfig[id].defaultOptions = fieldValues?.options || [];
            } else if (fieldType === (0, (0, parcelRequire("5fc53")).SPRINT_TYPE) && fetchSprints) {
                fieldConfig[id].loadOptions = fetchSprints;
                fieldConfig[id].defaultOptions = fieldValues?.options || [];
                fieldConfig[id].options = [
                    ...fieldConfig[id].options,
                    {
                        value: (0, (0, parcelRequire("7htvz")).EMPTY_FILTER_VALUE),
                        label: formatMessage((0, (0, parcelRequire("j0h5m")).default).noSprintLabel),
                        isEmptyOption: true
                    }
                ];
                fieldConfig[id].totalCount += 1;
            } else if (fieldType === (0, (0, parcelRequire("5fc53")).FIX_VERSIONS_TYPE) && fetchFixVersions && (0, (0, parcelRequire("4R6GH")).fg)('jsw_list_view_-_all_the_fields')) {
                fieldConfig[id].loadOptions = fetchFixVersions;
                fieldConfig[id].defaultOptions = fieldValues?.options || [];
                fieldConfig[id].options = [
                    ...fieldConfig[id].options,
                    {
                        value: (0, (0, parcelRequire("7htvz")).EMPTY_FILTER_VALUE),
                        label: formatMessage((0, (0, parcelRequire("j0h5m")).default).noVersionLabel),
                        isEmptyOption: true
                    }
                ];
                fieldConfig[id].totalCount += 1;
            } else if (fieldType === (0, (0, parcelRequire("5fc53")).PARENT_FIELD_TYPE) && fetchParents && (0, (0, parcelRequire("4R6GH")).fg)('jsw_list_view_-_all_the_fields')) {
                fieldConfig[id].loadOptions = fetchParents;
                fieldConfig[id].defaultOptions = fieldValues?.options || [];
                fieldConfig[id].options = [
                    ...fieldConfig[id].options,
                    {
                        value: (0, (0, parcelRequire("7htvz")).EMPTY_FILTER_VALUE),
                        label: formatMessage((0, (0, parcelRequire("j0h5m")).default).noParentLabel),
                        isEmptyOption: true,
                        ...(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && {
                            square: true
                        }
                    }
                ];
                fieldConfig[id].totalCount += 1;
            } else if (fieldType === (0, (0, parcelRequire("5fc53")).GOALS_CF_TYPE) && fetchGoals) {
                fieldConfig[id].loadOptions = fetchGoals;
                fieldConfig[id].options = [
                    ...fieldConfig[id].options,
                    {
                        value: (0, (0, parcelRequire("7htvz")).EMPTY_FILTER_VALUE),
                        label: formatMessage((0, (0, parcelRequire("j0h5m")).default).noGoalLabel),
                        isEmptyOption: true
                    }
                ];
                fieldConfig[id].totalCount += 1;
            } else if (fetchTeams && fieldType === (0, (0, parcelRequire("5fc53")).TEAMS_PLATFORM_CF_TYPE) && (0, (0, parcelRequire("4R6GH")).fg)('jsw_list_view_-_all_the_fields')) {
                fieldConfig[id].loadOptions = fetchTeams;
                fieldConfig[id].defaultOptions = fieldValues?.options || [];
                fieldConfig[id].options = [
                    ...fieldConfig[id].options,
                    {
                        value: (0, (0, parcelRequire("7htvz")).EMPTY_FILTER_VALUE),
                        label: formatMessage((0, (0, parcelRequire("j0h5m")).default).noTeamLabel),
                        isEmptyOption: true
                    }
                ];
                fieldConfig[id].totalCount += 1;
            }
        });
        return {
            fieldConfig: fieldConfig,
            resolvers: resolvers
        };
    };
});
parcelRegister("gBF4Z", function(module, exports) {
    $parcel$export(module.exports, "FieldType", ()=>$8ecd5c1ebfc76de6$export$ed12481c953b8653);
    $parcel$export(module.exports, "isDateField", ()=>$8ecd5c1ebfc76de6$export$7d34c8548269835d);
    const $8ecd5c1ebfc76de6$export$ed12481c953b8653 = {
        AsyncSelectFilter: 'AsyncSelectFilter',
        AvatarSelectFilter: 'AvatarSelectFilter',
        AvatarAsyncSelectFilter: 'AvatarAsyncSelectFilter',
        PaginatedAsyncSelectFilter: 'PaginatedAsyncSelectFilter',
        LozengeAsyncSelectFilter: 'LozengeAsyncSelectFilter',
        PaginatedLozengeAsyncSelectFilter: 'PaginatedLozengeAsyncSelectFilter',
        LozengeSelectFilter: 'LozengeSelectFilter',
        PrioritySelectFilter: 'PrioritySelectFilter',
        CategorySelectFilter: 'CategorySelectFilter',
        GoalsSelectFilter: 'GoalsSelectFilter',
        PaginatedAvatarAsyncSelectFilter: 'PaginatedAvatarAsyncSelectFilter',
        NumberFilter: 'NumberFilter',
        SelectFilter: 'SelectFilter',
        SearchFilter: 'SearchFilter',
        TextFilter: 'TextFilter',
        DateFilter: 'DateFilter',
        ProjectFilter: 'ProjectFilter'
    };
    const $8ecd5c1ebfc76de6$export$7d34c8548269835d = (field)=>field.type === $8ecd5c1ebfc76de6$export$ed12481c953b8653.DateFilter;
});
parcelRegister("j0h5m", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$73773c42d63775af$export$2e2bcd8739ae039);
    var $7VHMR;
    var $73773c42d63775af$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        filterPlaceholder: {
            "id": "business-filters.controllers.field-config-v2.filter-placeholder",
            "defaultMessage": "Search"
        },
        dateRangeLabel: {
            "id": "business-filters.controllers.field-config-v2.date-range-label",
            "defaultMessage": "Date range"
        },
        startDateLabel: {
            "id": "business-filters.controllers.field-config-v2.start-date-label",
            "defaultMessage": "Start date"
        },
        dueDateLabel: {
            "id": "business-filters.controllers.field-config-v2.due-date-label",
            "defaultMessage": "Due date"
        },
        unassignedLabel: {
            "id": "business-filters.controllers.field-config-v2.unassigned-label",
            "defaultMessage": "Unassigned"
        },
        noLabelsLabel: {
            "id": "business-filters.controllers.field-config-v2.no-labels-label",
            "defaultMessage": "No label"
        },
        noCategoriesLabel: {
            "id": "business-filters.controllers.field-config-v2.no-categories-label",
            "defaultMessage": "No category"
        },
        noComponentsLabel: {
            "id": "business-filters.controllers.field-config-v2.no-components-label",
            "defaultMessage": "No component"
        },
        noSprintLabel: {
            "id": "business-filters.controllers.field-config-v2.no-sprint-label",
            "defaultMessage": "Backlog"
        },
        noVersionLabel: {
            "id": "business-filters.controllers.field-config-v2.no-version-label",
            "defaultMessage": "No version"
        },
        noParentLabel: {
            "id": "business-filters.controllers.field-config-v2.no-parent-label",
            "defaultMessage": "No parent"
        },
        noGoalLabel: {
            "id": "business-filters.controllers.field-config-v2.no-goal-label",
            "defaultMessage": "No goal"
        },
        noTeamLabel: {
            "id": "business-filters.controllers.field-config-v2.no-team-label",
            "defaultMessage": "No team"
        }
    });
});
parcelRegister("cLe9v", function(module, exports) {
    $parcel$export(module.exports, "useFieldConfig", ()=>$bad07c14bc3eb691$export$70da50df1be2dbe1);
    var $5uXOq = parcelRequire("5uXOq");
    var $3JOCw = parcelRequire("3JOCw");
    var $hE5wF;
    var $ftuRD;
    var $1T2vX;
    var $2H8QW;
    var $2Lcoi;
    var $aJfd5;
    var $jcw0u;
    var $7f4tk;
    var $koVbs;
    var $5fc53;
    var $koeKL;
    var $ieDtd;
    var $doZTA;
    var $czmU8;
    var $84pWT;
    var $8841m;
    var $1vUxa;
    var $e3P1V;
    const $bad07c14bc3eb691$var$MAX_NUMBER_OF_OPTIONS = 10;
    const $bad07c14bc3eb691$var$useFilterMapper = true;
    const $bad07c14bc3eb691$var$EMPTY_ARRAY = [];
    const $bad07c14bc3eb691$var$EMPTY_USER_ARRAY = [];
    const $bad07c14bc3eb691$var$EMPTY_COMPONENT_ARRAY = [];
    const $bad07c14bc3eb691$var$EMPTY_CATEGORY_ARRAY = [];
    const $bad07c14bc3eb691$export$1fe8227c57fa0d68 = ()=>({
            initialUsers: {
                data: $bad07c14bc3eb691$var$EMPTY_USER_ARRAY,
                isLoading: false
            },
            initialLabels: {
                data: $bad07c14bc3eb691$var$EMPTY_ARRAY,
                isLoading: false
            },
            initialComponents: {
                data: $bad07c14bc3eb691$var$EMPTY_COMPONENT_ARRAY,
                isLoading: false
            },
            initialCategories: {
                data: $bad07c14bc3eb691$var$EMPTY_CATEGORY_ARRAY,
                isLoading: false
            },
            projectKey: null
        });
    const $bad07c14bc3eb691$export$74cea4b24a6bc9fa = $bad07c14bc3eb691$export$1fe8227c57fa0d68();
    const $bad07c14bc3eb691$var$useForceUpdate = ()=>{
        const [, setValue] = (0, $5uXOq.useState)(0);
        return (0, $5uXOq.useCallback)(()=>setValue((value)=>value + 1), []);
    };
    const $bad07c14bc3eb691$export$70da50df1be2dbe1 = ({ allowedFieldTypes: allowedFieldTypes, allowedAliasFieldId: allowedAliasFieldId })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const [userResolver] = (0, $5uXOq.useState)(new (0, (0, parcelRequire("aJfd5")).UserResolver)());
        const forceUpdate = $bad07c14bc3eb691$var$useForceUpdate();
        const [priorityFieldConfig] = (0, (0, parcelRequire("ftuRD")).useIssueTypeFieldConfig)({
            screen: 'VIEW',
            issueTypeId: 'default',
            fieldId: 'priority'
        });
        const { data: issueTypeData, loading: loadingIssueTypesAndFields } = (0, (0, parcelRequire("1T2vX")).useIssueTypesAndFields)({
            issueOperation: 'VIEW'
        });
        const formattedCategoryOptions = (0, $5uXOq.useMemo)(()=>{
            const categoryOptions = issueTypeData.fields.find((field)=>field.type === (0, (0, parcelRequire("5fc53")).CATEGORY_TYPE))?.fieldConfig?.selectOptions ?? [];
            return categoryOptions.map(({ value: value })=>({
                    label: value,
                    value: value
                }));
        }, [
            issueTypeData
        ]);
        const { statuses: statuses, loading: loadingStatuses } = (0, (0, parcelRequire("8841m")).useProjectStatuses)();
        const [{ match: { params: { projectKey: projectKey } } }] = (0, (0, parcelRequire("doZTA")).useRouter)();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const [jqlURLParam] = (0, (0, parcelRequire("ieDtd")).useQueryParam)((0, (0, parcelRequire("hE5wF")).FILTER_PARAM));
        const jqlURLParamRef = (0, $5uXOq.useRef)(jqlURLParam);
        const hydratedUsers = (0, $5uXOq.useRef)(null);
        const fetchInitialUsers = (0, $5uXOq.useCallback)(async ()=>{
            $bad07c14bc3eb691$export$74cea4b24a6bc9fa.initialUsers.isLoading = true;
            let users = [];
            const hydratedValues = jqlURLParamRef.current ? await (0, (0, parcelRequire("czmU8")).hydrateFilterValues)(cloudId, jqlURLParamRef.current) : null;
            if (hydratedValues !== null) {
                const transformedHydratedValues = (0, (0, parcelRequire("84pWT")).transformHydratedValues)(hydratedValues);
                hydratedUsers.current = transformedHydratedValues.users.options;
            }
            const url = `/rest/api/3/user/search?maxResults=${$bad07c14bc3eb691$var$MAX_NUMBER_OF_OPTIONS}&query=`;
            users = await (0, (0, parcelRequire("7f4tk")).default)(url);
            $bad07c14bc3eb691$export$74cea4b24a6bc9fa.initialUsers = {
                data: users,
                isLoading: false
            };
            forceUpdate();
            return users;
        }, [
            cloudId,
            forceUpdate
        ]);
        const fetchInitialLabels = (0, $5uXOq.useCallback)(async ()=>{
            const url = `/rest/api/3/label?maxResults=${$bad07c14bc3eb691$var$MAX_NUMBER_OF_OPTIONS}`;
            try {
                $bad07c14bc3eb691$export$74cea4b24a6bc9fa.initialLabels.isLoading = true;
                const response = await (0, (0, parcelRequire("7f4tk")).default)(url);
                const labels = response.values;
                $bad07c14bc3eb691$export$74cea4b24a6bc9fa.initialLabels = {
                    data: labels,
                    isLoading: false
                };
                forceUpdate();
                return labels;
            } catch (err) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'fetchFilterInitialLabels',
                        packageName: 'jiraBusinessFilters',
                        teamName: 'wanjel'
                    },
                    attributes: {
                        message: 'Failed to fetch initial labels',
                        errorType: (0, (0, parcelRequire("2H8QW")).getErrorType)(err)
                    },
                    error: err,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
            $bad07c14bc3eb691$export$74cea4b24a6bc9fa.initialLabels = {
                data: $bad07c14bc3eb691$var$EMPTY_ARRAY,
                isLoading: false
            };
            forceUpdate();
            return $bad07c14bc3eb691$var$EMPTY_ARRAY;
        }, [
            forceUpdate
        ]);
        const fetchUsers = (0, $5uXOq.useCallback)(async (query = '')=>{
            if (projectKey != null) {
                const url = `/rest/api/2/user/assignable/search?project=${projectKey}&maxResults=${$bad07c14bc3eb691$var$MAX_NUMBER_OF_OPTIONS}&query=${query}`;
                try {
                    const response = await (0, (0, parcelRequire("7f4tk")).default)(url);
                    return response;
                } catch (err) {
                    (0, (0, parcelRequire("jcw0u")).default)({
                        meta: {
                            id: 'searchFilterUsers',
                            packageName: 'jiraBusinessFilters',
                            teamName: 'wanjel'
                        },
                        attributes: {
                            message: 'Failed to search users',
                            errorType: (0, (0, parcelRequire("2H8QW")).getErrorType)(err)
                        },
                        error: err,
                        sendToPrivacyUnsafeSplunk: true
                    });
                }
            }
            return $bad07c14bc3eb691$var$EMPTY_USER_ARRAY;
        }, [
            projectKey
        ]);
        const fetchProjectComponents = (0, $5uXOq.useCallback)(async (query = '')=>{
            if (projectKey != null) try {
                const response = await (0, (0, parcelRequire("2Lcoi")).fetchComponents)({
                    inputValue: query,
                    autoCompleteUrl: `/rest/api/3/project/${projectKey}/component`,
                    useFilterMapper: $bad07c14bc3eb691$var$useFilterMapper
                });
                return response;
            } catch (err) {
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'fetchFilterComponents',
                        packageName: 'jiraBusinessFilters',
                        teamName: 'wanjel'
                    },
                    attributes: {
                        message: 'Failed to fetch components',
                        errorType: (0, (0, parcelRequire("2H8QW")).getErrorType)(err)
                    },
                    error: err,
                    sendToPrivacyUnsafeSplunk: true
                });
            }
            return [];
        }, [
            projectKey
        ]);
        const fetchLabels = (0, $5uXOq.useCallback)((query = '')=>(0, (0, parcelRequire("7f4tk")).default)(`/rest/api/1.0/labels/suggest?query=${query}`).catch((err)=>{
                (0, (0, parcelRequire("jcw0u")).default)({
                    meta: {
                        id: 'searchFilterLabels',
                        packageName: 'jiraBusinessFilters',
                        teamName: 'wanjel'
                    },
                    attributes: {
                        message: 'Failed to search labels',
                        errorType: (0, (0, parcelRequire("2H8QW")).getErrorType)(err)
                    },
                    error: err,
                    sendToPrivacyUnsafeSplunk: true
                });
            }), []);
        const fetchProjectCategories = (0, $5uXOq.useCallback)((query = '')=>{
            const filteredCategoriesQuery = formattedCategoryOptions?.filter((categoryOption)=>categoryOption.label.toLowerCase().startsWith(query.toLowerCase()));
            return Promise.resolve(filteredCategoriesQuery ?? []);
        }, [
            formattedCategoryOptions
        ]);
        const { fetch: fetchInitialStoryPointsData, data: initialStoryPoints, loading: loadingStoryPoints } = (0, (0, parcelRequire("1vUxa")).useGroupItemValues)({
            groupFieldId: (0, (0, parcelRequire("hE5wF")).STORY_POINTS_ALIAS_FIELD_ID)
        });
        const { fetch: fetchInitialStoryPointsEstimateData, data: initialStoryPointsEstimate, loading: loadingStoryPointsEstimate } = (0, (0, parcelRequire("1vUxa")).useGroupItemValues)({
            groupFieldId: (0, (0, parcelRequire("hE5wF")).STORY_POINT_ESTIMATE_ALIAS_FIELD_ID)
        });
        (0, $5uXOq.useEffect)(()=>{
            if (allowedAliasFieldId != null && allowedAliasFieldId.has((0, (0, parcelRequire("hE5wF")).STORY_POINTS_ALIAS_FIELD_ID))) fetchInitialStoryPointsData();
        }, [
            allowedAliasFieldId,
            fetchInitialStoryPointsData
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (allowedAliasFieldId != null && allowedAliasFieldId.has((0, (0, parcelRequire("hE5wF")).STORY_POINT_ESTIMATE_ALIAS_FIELD_ID))) fetchInitialStoryPointsEstimateData();
        }, [
            allowedAliasFieldId,
            fetchInitialStoryPointsEstimateData
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (projectKey != null && ($bad07c14bc3eb691$export$74cea4b24a6bc9fa.projectKey !== projectKey || $bad07c14bc3eb691$export$74cea4b24a6bc9fa.initialUsers.data === $bad07c14bc3eb691$var$EMPTY_USER_ARRAY)) {
                if ($bad07c14bc3eb691$export$74cea4b24a6bc9fa.initialUsers.isLoading === false) {
                    $bad07c14bc3eb691$export$74cea4b24a6bc9fa.projectKey = projectKey;
                    fetchInitialUsers();
                }
            }
        }, [
            fetchInitialUsers,
            fetchProjectComponents,
            projectKey,
            fetchInitialLabels,
            fetchProjectCategories,
            forceUpdate
        ]);
        const { data: initialUsers, isLoading: isLoadingUsers } = $bad07c14bc3eb691$export$74cea4b24a6bc9fa.initialUsers;
        const { data: initialLabels, isLoading: isLoadingLabels } = $bad07c14bc3eb691$export$74cea4b24a6bc9fa.initialLabels;
        const { data: initialComponents, isLoading: isLoadingComponents } = $bad07c14bc3eb691$export$74cea4b24a6bc9fa.initialComponents;
        const { data: initialCategories, isLoading: isLoadingCategories } = $bad07c14bc3eb691$export$74cea4b24a6bc9fa.initialCategories;
        const fieldOptionsData = (0, $5uXOq.useMemo)(()=>({
                priority: (0, (0, parcelRequire("e3P1V")).transformPriority)(priorityFieldConfig),
                issuetype: (0, (0, parcelRequire("e3P1V")).transformIssueType)(issueTypeData),
                status: (0, (0, parcelRequire("e3P1V")).transformStatuses)(statuses),
                users: (0, (0, parcelRequire("e3P1V")).transformUsers)(initialUsers),
                labels: (0, (0, parcelRequire("e3P1V")).transformLabels)(initialLabels),
                components: initialComponents,
                [(0, (0, parcelRequire("5fc53")).CATEGORY_TYPE)]: initialCategories,
                [(0, (0, parcelRequire("hE5wF")).STORY_POINTS_ALIAS_FIELD_ID)]: initialStoryPoints?.options || [],
                [(0, (0, parcelRequire("hE5wF")).STORY_POINT_ESTIMATE_ALIAS_FIELD_ID)]: initialStoryPointsEstimate?.options || []
            }), [
            priorityFieldConfig,
            issueTypeData,
            statuses,
            initialUsers,
            initialLabels,
            initialComponents,
            initialCategories,
            initialStoryPoints?.options,
            initialStoryPointsEstimate?.options
        ]);
        fieldOptionsData.users = (0, $5uXOq.useMemo)(()=>{
            if (hydratedUsers.current === null) return fieldOptionsData.users;
            return (0, ($parcel$interopDefault($3JOCw)))([
                ...hydratedUsers.current ?? [],
                ...fieldOptionsData.users ?? []
            ], ({ value: value })=>value);
        }, [
            fieldOptionsData
        ]);
        const { fieldConfig: fieldConfig, resolvers: resolvers } = (0, (0, parcelRequire("e3P1V")).getFilterFieldConfigAndResolvers)({
            formatMessage: formatMessage,
            allowedFieldTypes: allowedFieldTypes,
            allowedAliasFieldId: allowedAliasFieldId,
            allFields: issueTypeData.fields,
            fieldOptionsData: fieldOptionsData,
            fetchUsers: (query)=>fetchUsers(query).then((users)=>(0, (0, parcelRequire("e3P1V")).transformUsers)(users || [])),
            fetchLabels: (query)=>fetchLabels(query).then((labels)=>labels ? (0, (0, parcelRequire("e3P1V")).transformLabelSuggestions)(labels) : []),
            fetchComponents: (query)=>fetchProjectComponents(query).then((components)=>components),
            fetchCategories: (query)=>fetchProjectCategories(query).then((categoriesResponse)=>categoriesResponse),
            userResolver: userResolver
        });
        const fetching = isLoadingUsers || isLoadingLabels || isLoadingComponents || isLoadingCategories || loadingStoryPoints || loadingStoryPointsEstimate;
        return {
            fieldConfig: fieldConfig,
            resolvers: resolvers,
            loading: loadingIssueTypesAndFields || loadingStatuses || fetching
        };
    };
});
parcelRegister("2H8QW", function(module, exports) {
    $parcel$export(module.exports, "getErrorType", ()=>$3122aab38ac46d24$export$e19f9f08a6d79fd2);
    var $jJZqs;
    const $3122aab38ac46d24$export$7453182ebe5973d4 = 'APOLLO_NETWORK_ERROR';
    const $3122aab38ac46d24$export$9705762bba4e9e25 = 'NULL_OR_UNDEFINED';
    const $3122aab38ac46d24$export$d46a05f8561f868a = 'OTHER';
    const $3122aab38ac46d24$export$c748438cec453c9f = {
        FAILED_TO_FETCH: 'Failed to fetch',
        NETWORK_ERROR: 'NetworkError when attempting to fetch resource.',
        NETWORK_REQUEST_FAILED: 'Network request failed',
        NETWORK_CONNECTION_LOST: 'The network connection was lost.',
        NETWORK_CONNECTION_ERROR: 'upstream connect error or disconnect/reset before headers. reset reason: connection',
        UNEXPECTED_ERROR_OCCURRED: 'Response ended with an error message: An unexpected error occurred',
        ABORTED: 'operation was aborted.',
        CANCELLED: 'cancelled',
        TIMEOUT: 'The request timed out.'
    };
    const $3122aab38ac46d24$var$isApolloClientNetworkError = (error)=>error.networkError !== undefined && error.networkError !== null;
    const $3122aab38ac46d24$export$e19f9f08a6d79fd2 = (error)=>{
        if (error == null) return $3122aab38ac46d24$export$9705762bba4e9e25;
        const message = String(error instanceof Error ? error.message : error).trim();
        if (error instanceof (0, (0, parcelRequire("jJZqs")).default)) {
            const { statusCode: statusCode } = error;
            if (statusCode) return `FETCH_ERROR_${statusCode}`;
        }
        if ($3122aab38ac46d24$var$isApolloClientNetworkError(error)) return $3122aab38ac46d24$export$7453182ebe5973d4;
        const entry = Object.entries($3122aab38ac46d24$export$c748438cec453c9f).find((arrayItem)=>String(arrayItem[1]).toLowerCase() === message.toLowerCase());
        return entry ? entry[0] : $3122aab38ac46d24$export$d46a05f8561f868a;
    };
});
parcelRegister("2Lcoi", function(module, exports) {
    $parcel$export(module.exports, "fetchComponents", ()=>$14f8d378ed2868dc$export$4f703ddb7c8cc5b3);
    var $ebyGx = parcelRequire("ebyGx");
    var $2H8QW;
    var $jcw0u;
    var $eusud;
    var $lb7V6;
    const $14f8d378ed2868dc$export$4f703ddb7c8cc5b3 = ({ inputValue: inputValue, autoCompleteUrl: autoCompleteUrl, useFilterMapper: useFilterMapper, queryParameters: queryParameters })=>{
        const mapperFunction = useFilterMapper === true ? (0, (0, parcelRequire("lb7V6")).mapComponentsToFilterOptions) : (0, (0, parcelRequire("lb7V6")).mapComponentsToOptions);
        const query = (0, ($parcel$interopDefault($ebyGx))).stringify({
            query: inputValue,
            ...queryParameters
        });
        return (0, (0, parcelRequire("eusud")).performGetRequest)(`${autoCompleteUrl}?${query}`).then((response)=>mapperFunction(response.values)).catch((error)=>{
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'fetchProjectComponents',
                    packageName: 'jiraBusinessFetchComponents',
                    teamName: 'wanjel'
                },
                attributes: {
                    message: 'Failed to fetch jwm project components',
                    errorType: (0, (0, parcelRequire("2H8QW")).getErrorType)(error)
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        });
    };
});
parcelRegister("lb7V6", function(module, exports) {
    $parcel$export(module.exports, "mapComponentsToOptions", ()=>$4c5d47ac0f899709$export$85e44418187c2c1e);
    $parcel$export(module.exports, "mapComponentsToFilterOptions", ()=>$4c5d47ac0f899709$export$b4ef58d3e943e4d5);
    const $4c5d47ac0f899709$export$85e44418187c2c1e = (components)=>components.map(({ id: id, componentId: componentId, name: name })=>({
                label: name,
                value: componentId !== undefined ? String(componentId) : String(id)
            }));
    const $4c5d47ac0f899709$export$b4ef58d3e943e4d5 = (components)=>components.map(({ name: name })=>({
                label: name,
                value: name
            }));
});
parcelRegister("1vUxa", function(module, exports) {
    $parcel$export(module.exports, "useGroupItemValues", ()=>$f2df8273d684a2c0$export$f05af123f98299b0);
    var $5uXOq = parcelRequire("5uXOq");
    var $ccvFs;
    var $5YBrl;
    var $jlq4V;
    var $koVbs;
    var $g31qf;
    var $baeZQ;
    const $f2df8273d684a2c0$var$reducer = (state, action)=>{
        switch(action.type){
            case 'loading':
                return {
                    loading: true
                };
            case 'success':
                return {
                    loading: false,
                    data: action.payload
                };
            case 'error':
                return {
                    loading: false,
                    data: null
                };
            default:
                return state;
        }
    };
    const $f2df8273d684a2c0$export$f05af123f98299b0 = ({ groupFieldId: groupFieldId })=>{
        const [state, dispatch] = (0, $5uXOq.useReducer)($f2df8273d684a2c0$var$reducer, {
            loading: false
        });
        const jqlContext = (0, (0, parcelRequire("5YBrl")).useJqlContext)();
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const fetchDataAbortable = (0, (0, parcelRequire("ccvFs")).useAbortable)((0, (0, parcelRequire("g31qf")).fetchGroupItemValues));
        const fetch = (0, $5uXOq.useCallback)(async ()=>{
            try {
                dispatch({
                    type: 'loading'
                });
                const response = await fetchDataAbortable(groupFieldId, jqlContext);
                if (response.data?.items == null) throw new (0, (0, parcelRequire("jlq4V")).GraphQLErrors)(response.errors);
                dispatch({
                    type: 'success',
                    payload: (0, (0, parcelRequire("baeZQ")).transformInitialData)({
                        data: response.data,
                        formatMessage: formatMessage
                    })
                });
            } catch (error) {
                if (error === (0, (0, parcelRequire("ccvFs")).ABORTED)) return;
                dispatch({
                    type: 'error'
                });
            }
        }, [
            fetchDataAbortable,
            formatMessage,
            groupFieldId,
            jqlContext
        ]);
        return {
            fetch: fetch,
            data: state.data,
            loading: state.loading
        };
    };
});
parcelRegister("ccvFs", function(module, exports) {
    $parcel$export(module.exports, "ABORTED", ()=>$e04e223192d877be$export$23e29024ea698a35);
    $parcel$export(module.exports, "useAbortable", ()=>$e04e223192d877be$export$a487c7eb4387f959);
    var $5uXOq = parcelRequire("5uXOq");
    const $e04e223192d877be$export$23e29024ea698a35 = Symbol('ABORTED');
    const $e04e223192d877be$export$a487c7eb4387f959 = (fetch)=>{
        const prevControllerRef = (0, $5uXOq.useRef)(null);
        return (0, $5uXOq.useCallback)((...args)=>{
            if (prevControllerRef.current) prevControllerRef.current.abort();
            const controller = new AbortController();
            prevControllerRef.current = controller;
            return fetch(controller.signal, ...args).catch((error)=>{
                if (controller.signal.aborted) throw $e04e223192d877be$export$23e29024ea698a35;
                else throw error;
            });
        }, [
            fetch
        ]);
    };
});
parcelRegister("g31qf", function(module, exports) {
    $parcel$export(module.exports, "fetchGroupItemValues", ()=>$71087c8bd1916bd2$export$7e6e0c3f4468ce45);
    var $jcw0u;
    var $fZneA;
    var $eusud;
    const $71087c8bd1916bd2$var$MAX_NUMBER_OF_OPTIONS = 20;
    const $71087c8bd1916bd2$export$7e6e0c3f4468ce45 = async (signal, groupFieldId, jqlContext)=>{
        try {
            const variables = {
                fieldId: groupFieldId,
                first: $71087c8bd1916bd2$var$MAX_NUMBER_OF_OPTIONS,
                jql: jqlContext
            };
            const response = await (0, (0, parcelRequire("eusud")).performPostRequest)('/rest/gira/1/?operation=JWMFilterValuesByGroupItems', {
                body: JSON.stringify({
                    query: (0, $626c877b75948b48$export$a48313dd44fc9855),
                    variables: variables
                })
            });
            return response;
        } catch (error) {
            if (!(0, (0, parcelRequire("fZneA")).isHttpClientErrorResponse)(error) && !signal.aborted) (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: 'initializeFilterGroupItemsData',
                    packageName: 'jiraBusinessFilters',
                    teamName: 'wanjel'
                },
                attributes: {
                    message: 'Failed to initialize filter data using the group query'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    };
});
const $626c877b75948b48$export$a48313dd44fc9855 = `
query JWMFilterValuesByGroupItems($fieldId: ID!, $jql: String!, $first: Int!) {
  items: jwmItemGroups(jql: $jql, groupByFieldId: $fieldId, fieldIds: [], first: $first) {
    totalCount
    edges {
      node {
        id
        field {
          __typename
          ... on FloatCustomField {
            floatValue
          }
        }
      }
    }
  }
}
`;
parcelRegister("baeZQ", function(module, exports) {
    $parcel$export(module.exports, "transformInitialData", ()=>$a3e52c0a295405a4$export$93219b8691fe49a0);
    var $9D5f1;
    const $a3e52c0a295405a4$export$93219b8691fe49a0 = ({ data: data, formatMessage: formatMessage })=>({
            totalCount: data.items.totalCount,
            options: data.items.edges.map((edge)=>{
                if (edge.node.field.floatValue == null) return {
                    value: null,
                    label: formatMessage((0, (0, parcelRequire("9D5f1")).default).noneOption)
                };
                const stringFloatValue = String(edge.node.field.floatValue);
                return {
                    value: stringFloatValue,
                    label: stringFloatValue
                };
            })
        });
});
parcelRegister("9D5f1", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$ff2b830268d99634$export$2e2bcd8739ae039);
    var $7VHMR;
    var $ff2b830268d99634$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        noneOption: {
            "id": "business-filters.controllers.group-item-values.none-option",
            "defaultMessage": "None"
        }
    });
});
parcelRegister("e3P1V", function(module, exports) {
    $parcel$export(module.exports, "transformPriority", ()=>$b808701b322de4e8$export$1b9f55a39456e911);
    $parcel$export(module.exports, "transformIssueType", ()=>$b808701b322de4e8$export$96520244689f81c1);
    $parcel$export(module.exports, "transformStatuses", ()=>$b808701b322de4e8$export$20a57a5ec025f2d);
    $parcel$export(module.exports, "transformUsers", ()=>$b808701b322de4e8$export$fb8c90bfc4beaa59);
    $parcel$export(module.exports, "transformLabels", ()=>$b808701b322de4e8$export$c072126708d93f04);
    $parcel$export(module.exports, "transformLabelSuggestions", ()=>$b808701b322de4e8$export$cdfcc40760c1a4f8);
    $parcel$export(module.exports, "getFilterFieldConfigAndResolvers", ()=>$b808701b322de4e8$export$ba4f3d2149c2bf3b);
    var $9XE6b = parcelRequire("9XE6b");
    var $8QpSo;
    var $hE5wF;
    var $5fc53;
    var $gzkAf;
    var $gBF4Z;
    var $7htvz;
    var $6S22M;
    const $b808701b322de4e8$export$1b9f55a39456e911 = (0, (0, parcelRequire("8QpSo")).default)((priorityFieldConfig)=>[
            ...priorityFieldConfig?.options || []
        ].reduce((acc, next)=>{
            acc.push({
                value: next.name,
                label: next.name,
                avatar: next.iconUrl || ''
            });
            return acc;
        }, []));
    const $b808701b322de4e8$export$96520244689f81c1 = (0, (0, parcelRequire("8QpSo")).default)((issueTypeData)=>issueTypeData.issueTypes.reduce((acc, next)=>{
            acc.push({
                value: next.id,
                label: next.name,
                id: next.id,
                avatar: next.avatarUrl,
                square: true
            });
            return acc;
        }, []));
    const $b808701b322de4e8$export$20a57a5ec025f2d = (0, (0, parcelRequire("8QpSo")).default)((statuses)=>statuses.reduce((acc, next)=>{
            acc.push({
                value: next.untranslatedName,
                label: next.name,
                categoryId: next.statusCategory.id,
                id: Number(next.id)
            });
            return acc;
        }, []));
    const $b808701b322de4e8$export$fb8c90bfc4beaa59 = (0, (0, parcelRequire("8QpSo")).default)((users)=>users.reduce((acc, next)=>{
            acc.push({
                value: next.accountId || '',
                label: next.displayName,
                avatar: (0, ($parcel$interopDefault($9XE6b)))(next, [
                    'avatarUrls',
                    '24x24'
                ], '')
            });
            return acc;
        }, []));
    const $b808701b322de4e8$export$c072126708d93f04 = (0, (0, parcelRequire("8QpSo")).default)((labels)=>labels.reduce((acc, next)=>{
            acc.push({
                value: next || '',
                label: next
            });
            return acc;
        }, []));
    const $b808701b322de4e8$export$cdfcc40760c1a4f8 = (0, (0, parcelRequire("8QpSo")).default)((labels)=>labels?.suggestions.reduce((acc, next)=>{
            acc.push({
                value: next.label || '',
                label: next.label
            });
            return acc;
        }, []));
    const $b808701b322de4e8$var$getType = ({ type: type })=>{
        switch(type){
            case 0, (0, parcelRequire("5fc53")).PRIORITY_TYPE:
                return (0, (0, parcelRequire("gBF4Z")).FieldType).PrioritySelectFilter;
            case 0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE:
            case 0, (0, parcelRequire("5fc53")).REPORTER_TYPE:
            case 0, (0, parcelRequire("5fc53")).USER_CF_TYPE:
            case 0, (0, parcelRequire("5fc53")).PEOPLE_CF_TYPE:
                return (0, (0, parcelRequire("gBF4Z")).FieldType).AvatarAsyncSelectFilter;
            case 0, (0, parcelRequire("5fc53")).ISSUE_TYPE:
                return (0, (0, parcelRequire("gBF4Z")).FieldType).AvatarSelectFilter;
            case 0, (0, parcelRequire("5fc53")).STATUS_TYPE:
                return (0, (0, parcelRequire("gBF4Z")).FieldType).LozengeSelectFilter;
            case 0, (0, parcelRequire("5fc53")).LABELS_TYPE:
            case 0, (0, parcelRequire("5fc53")).COMPONENTS_TYPE:
            case 0, (0, parcelRequire("5fc53")).SELECT_CF_TYPE:
            case 0, (0, parcelRequire("5fc53")).MULTI_SELECT_CF_TYPE:
                return (0, (0, parcelRequire("gBF4Z")).FieldType).AsyncSelectFilter;
            case 0, (0, parcelRequire("5fc53")).CREATED:
            case 0, (0, parcelRequire("5fc53")).UPDATED:
            case 0, (0, parcelRequire("5fc53")).DATE_CF_TYPE:
                return (0, (0, parcelRequire("gBF4Z")).FieldType).DateFilter;
            case 0, (0, parcelRequire("5fc53")).CATEGORY_TYPE:
                return (0, (0, parcelRequire("gBF4Z")).FieldType).CategorySelectFilter;
            case 0, (0, parcelRequire("5fc53")).NUMBER_CF_TYPE:
            case 0, (0, parcelRequire("5fc53")).STORY_POINT_ESTIMATE_CF_TYPE:
            default:
                return (0, (0, parcelRequire("gBF4Z")).FieldType).SelectFilter;
        }
    };
    const $b808701b322de4e8$var$getSelectCustomFieldValues = (field)=>(field?.fieldConfig?.selectOptions ?? []).map(({ value: value })=>({
                label: value,
                value: value
            }));
    const $b808701b322de4e8$var$getValues = ({ type: type, fieldOptionsData: fieldOptionsData, field: field, aliasFieldId: aliasFieldId })=>{
        switch(type){
            case 0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE:
            case 0, (0, parcelRequire("5fc53")).REPORTER_TYPE:
            case 0, (0, parcelRequire("5fc53")).USER_CF_TYPE:
            case 0, (0, parcelRequire("5fc53")).PEOPLE_CF_TYPE:
                return fieldOptionsData.users;
            case 0, (0, parcelRequire("5fc53")).SELECT_CF_TYPE:
            case 0, (0, parcelRequire("5fc53")).MULTI_SELECT_CF_TYPE:
            case 0, (0, parcelRequire("5fc53")).MULTI_CHECKBOXES_CF_TYPE:
                return $b808701b322de4e8$var$getSelectCustomFieldValues(field);
            case 0, (0, parcelRequire("5fc53")).NUMBER_CF_TYPE:
                if (aliasFieldId === (0, (0, parcelRequire("hE5wF")).STORY_POINTS_ALIAS_FIELD_ID)) return fieldOptionsData[0, (0, parcelRequire("hE5wF")).STORY_POINTS_ALIAS_FIELD_ID];
                return fieldOptionsData[type];
            case 0, (0, parcelRequire("5fc53")).STORY_POINT_ESTIMATE_CF_TYPE:
                return fieldOptionsData[0, (0, parcelRequire("hE5wF")).STORY_POINT_ESTIMATE_ALIAS_FIELD_ID];
            default:
                return fieldOptionsData[type];
        }
    };
    const $b808701b322de4e8$var$isUserField = (type)=>{
        switch(type){
            case 0, (0, parcelRequire("5fc53")).ASSIGNEE_TYPE:
            case 0, (0, parcelRequire("5fc53")).REPORTER_TYPE:
            case 0, (0, parcelRequire("5fc53")).USER_CF_TYPE:
            case 0, (0, parcelRequire("5fc53")).PEOPLE_CF_TYPE:
                return true;
            default:
                return false;
        }
    };
    const $b808701b322de4e8$var$isCustomField = (type)=>(0, (0, parcelRequire("gzkAf")).EXTRA_CUSTOM_FIELD_TYPES).has(type);
    const $b808701b322de4e8$var$createUserValueGetter = (userResolver)=>(0, (0, parcelRequire("8QpSo")).default)((accountIds)=>userResolver.getUsersFromAccountId(accountIds).then((response)=>$b808701b322de4e8$export$fb8c90bfc4beaa59(response)));
    const $b808701b322de4e8$export$ba4f3d2149c2bf3b = ({ formatMessage: formatMessage, allowedFieldTypes: allowedFieldTypes, allowedAliasFieldId: allowedAliasFieldId = new Set(), allFields: allFields, fieldOptionsData: fieldOptionsData, fetchUsers: fetchUsers, fetchLabels: fetchLabels, fetchComponents: fetchComponents, fetchCategories: fetchCategories, userResolver: userResolver })=>{
        const fieldConfig = {};
        const resolvers = {};
        if (allowedFieldTypes.has((0, (0, parcelRequire("gzkAf")).DATE_RANGE_TYPE))) fieldConfig.dateRange = {
            label: formatMessage((0, (0, parcelRequire("6S22M")).default).dateRangeLabel),
            type: (0, (0, parcelRequire("gBF4Z")).FieldType).DateFilter
        };
        const fields = allFields.filter((field)=>allowedFieldTypes.has(field.type ?? '') || allowedAliasFieldId.has(field.aliasFieldId || ''));
        fields.forEach((field)=>{
            const { name: name, type: type, id: id, aliasFieldId: aliasFieldId } = field;
            if (type == null || aliasFieldId === (0, (0, parcelRequire("hE5wF")).START_DATE_ALIAS_FIELD_ID)) return;
            const selectType = $b808701b322de4e8$var$getType({
                type: type
            });
            fieldConfig[id] = {
                systemType: type,
                label: name,
                type: selectType,
                placeholder: formatMessage((0, (0, parcelRequire("6S22M")).default).filterPlaceholder),
                options: $b808701b322de4e8$var$getValues({
                    type: type,
                    fieldOptionsData: fieldOptionsData,
                    field: field,
                    aliasFieldId: aliasFieldId
                }),
                isCustomField: $b808701b322de4e8$var$isCustomField(type),
                fieldConfigVersion: 1
            };
            if (aliasFieldId != null && allowedAliasFieldId.has(aliasFieldId)) fieldConfig[id].aliasFieldId = aliasFieldId;
            if (type === (0, (0, parcelRequire("5fc53")).ISSUE_TYPE)) fieldConfig[id].label = formatMessage((0, (0, parcelRequire("6S22M")).default).typeLabel);
            if ($b808701b322de4e8$var$isUserField(type)) {
                fieldConfig[id].loadOptions = fetchUsers;
                fieldConfig[id].defaultOptions = $b808701b322de4e8$var$getValues({
                    type: type,
                    fieldOptionsData: fieldOptionsData
                });
                resolvers[id] = $b808701b322de4e8$var$createUserValueGetter(userResolver);
                fieldConfig[id].options = [
                    ...fieldConfig[id].options,
                    {
                        value: 'EMPTY',
                        label: formatMessage((0, (0, parcelRequire("6S22M")).default).unassignedLabel),
                        isEmptyOption: true
                    }
                ];
            }
            if (type === (0, (0, parcelRequire("5fc53")).LABELS_TYPE)) {
                fieldConfig[id].loadOptions = fetchLabels;
                fieldConfig[id].defaultOptions = $b808701b322de4e8$var$getValues({
                    type: type,
                    fieldOptionsData: fieldOptionsData
                });
            }
            if (type === (0, (0, parcelRequire("5fc53")).COMPONENTS_TYPE)) {
                fieldConfig[id].loadOptions = fetchComponents;
                fieldConfig[id].defaultOptions = $b808701b322de4e8$var$getValues({
                    type: type,
                    fieldOptionsData: fieldOptionsData
                });
            }
            if (type === (0, (0, parcelRequire("5fc53")).CATEGORY_TYPE)) {
                fieldConfig[id].loadOptions = fetchCategories;
                fieldConfig[id].defaultOptions = $b808701b322de4e8$var$getValues({
                    type: type,
                    fieldOptionsData: fieldOptionsData
                });
            }
            if (type === (0, (0, parcelRequire("5fc53")).SELECT_CF_TYPE) || type === (0, (0, parcelRequire("5fc53")).MULTI_SELECT_CF_TYPE) || type === (0, (0, parcelRequire("5fc53")).MULTI_CHECKBOXES_CF_TYPE)) fieldConfig[id].options = [
                ...fieldConfig[id].options,
                {
                    value: (0, (0, parcelRequire("7htvz")).EMPTY_FILTER_VALUE),
                    label: formatMessage((0, (0, parcelRequire("6S22M")).default).noneOption),
                    isEmptyOption: true
                }
            ];
        });
        return {
            fieldConfig: fieldConfig,
            resolvers: resolvers
        };
    };
});
parcelRegister("6S22M", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c0167d244ddce5b9$export$2e2bcd8739ae039);
    var $7VHMR;
    var $c0167d244ddce5b9$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        filterPlaceholder: {
            "id": "business-filters.controllers.field-config.filter-placeholder",
            "defaultMessage": "Search"
        },
        dateRangeLabel: {
            "id": "business-filters.controllers.field-config.date-range-label",
            "defaultMessage": "Date range"
        },
        typeLabel: {
            "id": "business-filters.controllers.field-config.type-label",
            "defaultMessage": "Type"
        },
        unassignedLabel: {
            "id": "business-filters.controllers.field-config.unassigned-label",
            "defaultMessage": "Unassigned"
        },
        noneOption: {
            "id": "business-filters.controllers.field-config.none-option",
            "defaultMessage": "None"
        }
    });
});
parcelRegister("2RV6Z", function(module, exports) {
    $parcel$export(module.exports, "deserialiseJql", ()=>$42cbf7cea9b7c40a$export$214464255b766962);
    var $3dHKF = parcelRequire("3dHKF");
    var $2nvJN = parcelRequire("2nvJN");
    var $pyK8a;
    var $f9ece;
    var $8rsat;
    var $6CCiu;
    var $3tbwt;
    var $5fc53;
    var $gBF4Z;
    var $7htvz;
    const $42cbf7cea9b7c40a$var$START_DATE_JQL = 'Start date[Date]';
    const $42cbf7cea9b7c40a$var$EMPTY = 'EMPTY';
    const $42cbf7cea9b7c40a$var$shouldIncludeUnknownOption = (filterField)=>{
        const allowedFieldTypes = new Set([
            (0, (0, parcelRequire("5fc53")).COMPONENTS_TYPE),
            (0, (0, parcelRequire("5fc53")).LABELS_TYPE),
            (0, (0, parcelRequire("5fc53")).PRIORITY_TYPE),
            (0, (0, parcelRequire("5fc53")).CATEGORY_TYPE),
            (0, (0, parcelRequire("5fc53")).PARENT_FIELD_TYPE)
        ]);
        return allowedFieldTypes.has(filterField?.type ?? '');
    };
    const $42cbf7cea9b7c40a$var$getFieldIdFromJql = (rawFieldName, getShouldConvertCustomField)=>{
        const fieldName = (0, ($parcel$interopDefault($2nvJN)))(rawFieldName, '"');
        const shouldConvertCustomField = getShouldConvertCustomField ? getShouldConvertCustomField(fieldName) : true;
        if (fieldName.indexOf('cf[') === 0 && shouldConvertCustomField) {
            const extraction = new RegExp(/cf\[(.+)\]/).exec(fieldName);
            if (!extraction) return fieldName;
            const fieldId = extraction[1];
            return `customfield_${fieldId}`;
        }
        const startDateJql = $42cbf7cea9b7c40a$var$START_DATE_JQL;
        if (fieldName === startDateJql || fieldName === 'due') return 'dateRange';
        return fieldName;
    };
    const $42cbf7cea9b7c40a$var$transformIntoOptions = async (list, field, resolver, filterField)=>{
        if (resolver && typeof resolver === 'function') return resolver(list);
        const allowUnknownOption = $42cbf7cea9b7c40a$var$shouldIncludeUnknownOption(filterField);
        return list.map((value)=>{
            if (field && !(0, (0, parcelRequire("gBF4Z")).isDateField)(field) && Array.isArray(field.options)) {
                const optionInField = field.options.find((option)=>{
                    if ((option == null || option.value == null) && !option.isEmptyOption) return null;
                    if (option.isEmptyOption) return value === $42cbf7cea9b7c40a$var$EMPTY;
                    return option.value === value;
                });
                if (!optionInField && allowUnknownOption) return {
                    value: value,
                    label: value
                };
                return optionInField;
            }
            return undefined;
        }).filter((item)=>item != null && 'value' in item);
    };
    class $42cbf7cea9b7c40a$export$5299115fe71e8b39 extends (0, (0, parcelRequire("8rsat")).AbstractJastVisitor) {
        constructor(fieldConfig, filterFields, resolvers){
            super();
            this.getOption = (fieldName, items)=>$42cbf7cea9b7c40a$var$transformIntoOptions(items, this.fieldConfig[fieldName], this.resolvers[fieldName], this.filterFields.find((field)=>field.id === fieldName));
            this.visitCompoundClause = async (compoundClause)=>{
                const clauseMap = {};
                const operator = compoundClause.operator.value;
                if (operator === (0, $c915714aa8f48e71$export$6d6d48d210d3ca97)) {
                    const clausePromises = await Promise.all(compoundClause.clauses.map((clause)=>clause.accept(this)));
                    return clausePromises.reduce((result, clause)=>this.aggregateResultSync(clause, result), clauseMap);
                }
                throw new Error(`JQL contains invalid operator between clauses: ${operator}`);
            };
            this.parseDateOperand = (operator, operand)=>{
                if (operand?.operandType === (0, $230aa818ebdf534b$export$38accfc5a5d1c113)) {
                    let date = (0, (0, parcelRequire("f9ece")).default)(new Date(operand.value), 'UTC', 'yyyy-MM-dd');
                    if (operator.value === (0, (0, parcelRequire("3tbwt")).OPERATOR_LT)) date = (0, (0, parcelRequire("f9ece")).default)((0, (0, parcelRequire("pyK8a")).default)(new Date(operand.value), 1), 'UTC', 'yyyy-MM-dd');
                    const dateType = operator.value === (0, (0, parcelRequire("3tbwt")).OPERATOR_LT) ? 'to' : 'from';
                    return {
                        value: {
                            [dateType]: date
                        }
                    };
                }
                throw new Error(`JQL cannot parse date operand type: ${operand.operandType}`);
            };
            this.parseSelectOperand = async (fieldName, operand)=>{
                if (operand?.operandType === (0, $230aa818ebdf534b$export$fabec4aebba3f4df)) {
                    const optionPromises = operand.values.flatMap((value)=>this.parseSelectOperand(fieldName, value));
                    return (await Promise.all(optionPromises)).flatMap((option)=>option);
                }
                if (operand?.operandType === (0, $230aa818ebdf534b$export$38accfc5a5d1c113)) return this.getOption(fieldName, [
                    operand.value
                ]);
                if (operand?.operandType === (0, $230aa818ebdf534b$export$f6049126fd97001f)) return [
                    {
                        isEmptyOption: true,
                        value: (0, (0, parcelRequire("7htvz")).EMPTY_FILTER_VALUE),
                        label: ''
                    }
                ];
                throw new Error(`JQL cannot parse select operand type: ${operand.operandType}`);
            };
            this.visitTerminalClause = async (terminalClause)=>{
                const { field: field, operand: operand, operator: operator } = terminalClause;
                if (!operand || !operator) return Promise.resolve({});
                const getShouldConvertCustomField = (fieldName)=>!(this.fieldConfig[fieldName] && this.fieldConfig[fieldName].fieldConfigVersion === 2);
                const fieldName = $42cbf7cea9b7c40a$var$getFieldIdFromJql(field.value, getShouldConvertCustomField);
                if (!Object.keys(this.fieldConfig).includes(fieldName)) throw new Error(`JQL contains unsupported fields: ${fieldName}`);
                let value = [];
                if (operator.value === (0, (0, parcelRequire("3tbwt")).OPERATOR_GT_EQUALS) || operator.value === (0, (0, parcelRequire("3tbwt")).OPERATOR_LT)) value = this.parseDateOperand(operator, operand);
                else if (operator.value === (0, (0, parcelRequire("3tbwt")).OPERATOR_EQUALS) || operator.value === (0, (0, parcelRequire("3tbwt")).OPERATOR_IN)) value = await this.parseSelectOperand(fieldName, operand);
                else throw new Error(`JQL contains unsupported operator in terminal clause: ${operator.value}`);
                return {
                    [fieldName]: value
                };
            };
            this.fieldConfig = fieldConfig;
            this.filterFields = filterFields;
            this.resolvers = resolvers;
        }
        visitNotClause() {
            throw new Error('JQL contains invalid clause: NOT');
        }
        defaultResult() {
            return Promise.resolve({});
        }
        async aggregateResult(aggregate, nextResult) {
            return (0, ($parcel$interopDefault($3dHKF)))(await nextResult, await aggregate, (destValue, srcValue)=>{
                if (Array.isArray(srcValue)) return srcValue.concat(destValue ?? []);
                return undefined;
            });
        }
        aggregateResultSync(aggregate, nextResult) {
            return (0, ($parcel$interopDefault($3dHKF)))(nextResult, aggregate, (destValue, srcValue)=>{
                if (Array.isArray(srcValue)) return srcValue.concat(destValue ?? []);
                return undefined;
            });
        }
    }
    const $42cbf7cea9b7c40a$export$214464255b766962 = async (jql, fieldConfig, filterFields, resolvers)=>{
        const builder = new (0, (0, parcelRequire("6CCiu")).JastBuilder)();
        const jast = builder.build(jql);
        if (jast.query?.orderBy != null) throw new Error('JQL contains unsupported ORDER BY');
        const parser = new $42cbf7cea9b7c40a$export$5299115fe71e8b39(fieldConfig, filterFields, resolvers);
        const parsedJql = await jast.query?.accept(parser);
        return parsedJql ?? {};
    };
});
parcelRegister("3dHKF", function(module, exports) {
    var $1m1GH = parcelRequire("1m1GH");
    var $9MM2g = parcelRequire("9MM2g");
    var $2584862af7fb4983$var$mergeWith = $9MM2g(function(object, source, srcIndex, customizer) {
        $1m1GH(object, source, srcIndex, customizer);
    });
    module.exports = $2584862af7fb4983$var$mergeWith;
});
parcelRegister("ab4a1", function(module, exports) {
    $parcel$export(module.exports, "MenuContent", ()=>$1b74022ad6f4d372$export$479f0f2f71193efe);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $1jUsD;
    var $hMVQe;
    var $kn3Xd;
    const $1b74022ad6f4d372$var$LazyMenuContent = (0, (0, parcelRequire("1jUsD")).lazy)(()=>(parcelRequire("i5AI2")), {
        moduleId: "./src/packages/business/shared/components/filters/src/ui/filters/menu-content/main.tsx"
    });
    const $1b74022ad6f4d372$export$479f0f2f71193efe = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("kn3Xd")).DropdownWrapper), {
            "data-testid": "business-filters.ui.filters.menu-content"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "menu-content",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("hMVQe")).MenuFallback), null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($1b74022ad6f4d372$var$LazyMenuContent, props)));
});
parcelRegister("hMVQe", function(module, exports) {
    $parcel$export(module.exports, "MenuFallback", ()=>$a630aa0f7c48ef76$export$1198e585d599d03);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $113Tq;
    const $a630aa0f7c48ef76$export$1198e585d599d03 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement($a630aa0f7c48ef76$var$SpinnerWrapper, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("113Tq")).default), {
            size: "medium",
            testId: "business-filters.common.ui.menu-fallback.spinner"
        }));
    const $a630aa0f7c48ef76$var$SpinnerWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _1yt4pxbi",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("kn3Xd", function(module, exports) {
    $parcel$export(module.exports, "DropdownWrapper", ()=>$5ca6b1e17ddf2f10$export$5f7211d21bfdae05);
    $parcel$export(module.exports, "ScrollableContent", ()=>$5ca6b1e17ddf2f10$export$6c560fdadeb11d78);
    $parcel$export(module.exports, "DropdownHeaderWrapper", ()=>$5ca6b1e17ddf2f10$export$e23294aded7a8a49);
    $parcel$export(module.exports, "DropdownHeaderButtons", ()=>$5ca6b1e17ddf2f10$export$53ca7a3701b98335);
    $parcel$export(module.exports, "FiltersListSeparator", ()=>$5ca6b1e17ddf2f10$export$1a67069896d998b9);
    $parcel$export(module.exports, "FiltersListWrapper", ()=>$5ca6b1e17ddf2f10$export$a5a9080bd2c85987);
    $parcel$export(module.exports, "Section", ()=>$5ca6b1e17ddf2f10$export$6e2c8f0811a474ce);
    $parcel$export(module.exports, "LastSection", ()=>$5ca6b1e17ddf2f10$export$1faf3c7558df435);
    $parcel$export(module.exports, "SectionMessageWrapper", ()=>$5ca6b1e17ddf2f10$export$c5e20d5e200edfe2);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $gzkAf;
    const $5ca6b1e17ddf2f10$var$DROPDOWN_HEADER_HEIGHT = 52;
    const $5ca6b1e17ddf2f10$var$DROPDOWN_HEADER_VERTICAL_PADDING = "var(--ds-space-150, 12px)";
    const $5ca6b1e17ddf2f10$export$5f7211d21bfdae05 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1ul91gwv",
                __cmplp.className
            ])
        });
    });
    const $5ca6b1e17ddf2f10$export$6c560fdadeb11d78 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { offsetTop: offsetTop, ...__cmpldp } = __cmplp;
        return $5uXOq.createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_1uik9ob": (0, (0, parcelRequire("lD23V")).default)(`calc(${__cmplp.offsetTop && __cmplp.offsetTop > (0, (0, parcelRequire("gzkAf")).POPUP_OFFSET_TOP) ? '95vh' : '85vh'} - ${(__cmplp.offsetTop ?? (0, (0, parcelRequire("gzkAf")).POPUP_OFFSET_TOP)) + $5ca6b1e17ddf2f10$var$DROPDOWN_HEADER_HEIGHT}px)`)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1reo1wug _18m91wug _ln19p27b _c71l1pam",
                __cmplp.className
            ])
        });
    });
    const $5ca6b1e17ddf2f10$export$e23294aded7a8a49 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        const { stickyHeader: stickyHeader, ...__cmpldp } = __cmplp;
        return $5uXOq.createElement(C, {
            ...__cmpldp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_11q71bhr _2rko1sit _1pbykb7n _kqswh2mm _1yt4jd10 _1e0c1txw _1bah1yb4 _4cvr1h6o _11c8qk37",
                __cmplp.stickyHeader ? "_16qsf7oa" : "_16qsglyw",
                __cmplp.className
            ])
        });
    });
    const $5ca6b1e17ddf2f10$export$53ca7a3701b98335 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bahesu3",
                __cmplp.className
            ])
        });
    });
    const $5ca6b1e17ddf2f10$export$1a67069896d998b9 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18s81alc _x3do13y8",
                __cmplp.className
            ])
        });
    });
    const $5ca6b1e17ddf2f10$export$a5a9080bd2c85987 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_p12f1gwv",
                __cmplp.className
            ])
        });
    });
    const $5ca6b1e17ddf2f10$export$6e2c8f0811a474ce = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx21bp4 _zulp1f4h _n3td1f4h",
                __cmplp.className
            ])
        });
    });
    const $5ca6b1e17ddf2f10$export$1faf3c7558df435 = (0, $5uXOq.forwardRef)(({ as: C = $5ca6b1e17ddf2f10$export$6e2c8f0811a474ce, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_n3tdidpf _zulpidpf",
                __cmplp.className
            ])
        });
    });
    const $5ca6b1e17ddf2f10$export$c5e20d5e200edfe2 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1yt4pxbi",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("i5AI2", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("44yBr")
    ]).then(()=>parcelRequire('lk6eZ'));
});
parcelRegister("6xNkv", function(module, exports) {
    $parcel$export(module.exports, "Trigger", ()=>$9499219f0b3ef189$export$41fb9f06171c75f4);
    var $bwpsq;
    var $5uXOq = parcelRequire("5uXOq");
    var $2APCZ;
    var $fe3Xs;
    var $64gLq;
    var $4R6GH;
    var $koVbs;
    var $22OQR;
    var $dCm1o;
    var $fj0YT;
    const $9499219f0b3ef189$var$FILTER_ICON = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("fe3Xs"))))), {
        label: "",
        size: "small"
    });
    const $9499219f0b3ef189$export$41fb9f06171c75f4 = (0, $5uXOq.forwardRef)(({ onClick: onClick, isSelected: isSelected, count: count, hasFiltersApplied: hasFiltersApplied, withThemedButton: withThemedButton = true, isDisabled: isDisabled, appearance: appearance = 'subtle', ...otherProps }, ref)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const filterMessageOld = (0, $5uXOq.useMemo)(()=>{
            if (count > 0) return formatMessage((0, (0, parcelRequire("fj0YT")).default).filtersCount, {
                filters: count
            });
            if (hasFiltersApplied) return formatMessage((0, (0, parcelRequire("fj0YT")).default).buttonWithFilters);
            return formatMessage((0, (0, parcelRequire("fj0YT")).default).filterButton);
        }, [
            count,
            formatMessage,
            hasFiltersApplied
        ]);
        const filterMessage = (0, $5uXOq.useMemo)(()=>{
            if (hasFiltersApplied && count === 0) return formatMessage((0, (0, parcelRequire("fj0YT")).default).buttonWithFilters);
            return formatMessage((0, (0, parcelRequire("fj0YT")).default).filterButton);
        }, [
            count,
            formatMessage,
            hasFiltersApplied
        ]);
        const TriggerButton = withThemedButton ? (0, (0, parcelRequire("22OQR")).ThemedButton) : (0, (0, parcelRequire("2APCZ")).default);
        return (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? (0, ($parcel$interopDefault($5uXOq))).createElement(TriggerButton, {
            ...otherProps,
            "aria-label": formatMessage((0, (0, parcelRequire("fj0YT")).default).filtersCount, {
                filters: count
            }),
            ref: ref,
            isDisabled: isDisabled,
            isSelected: isSelected || count > 0,
            onClick: onClick,
            testId: "business-filters.ui.filters.trigger.button-wrapper",
            iconAfter: count === 0 ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("64gLq"))))), {
                label: "",
                color: "currentColor"
            }) : undefined
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($9499219f0b3ef189$var$ButtonContents, null, filterMessage, count > 0 && (0, ($parcel$interopDefault($5uXOq))).createElement($9499219f0b3ef189$var$BadgeContents, null, count))) : (0, ($parcel$interopDefault($5uXOq))).createElement(TriggerButton, {
            ...otherProps,
            ref: ref,
            testId: "business-filters.ui.filters.trigger.button-wrapper",
            iconBefore: $9499219f0b3ef189$var$FILTER_ICON,
            isSelected: isSelected,
            onClick: onClick,
            appearance: (0, (0, parcelRequire("4R6GH")).fg)('jira-calendar-business-theme') ? appearance : 'subtle',
            isDisabled: isDisabled
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($9499219f0b3ef189$var$ButtonContents, null, filterMessageOld));
    });
    const $9499219f0b3ef189$var$ButtonContents = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _2lx2vrvc _zulp12x7 _4cvr1h6o",
                __cmplp.className
            ])
        });
    });
    const $9499219f0b3ef189$var$BadgeContents = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _1bah1h6o _4cvr1h6o _bfhkllho _ca0qidpf _u5f36mu8 _n3tdidpf _19bv6mu8 _4t3i1j6v _1ul91j6v _2rkogqwt _11c81oud",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("fj0YT", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$483bd49c4d6c7782$export$2e2bcd8739ae039);
    var $7VHMR;
    var $483bd49c4d6c7782$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        filtersCount: {
            "id": "business-filters.filters.trigger.filters-count",
            "defaultMessage": "{filters, number} {filters, plural, one {filter applied} other {filters applied}}"
        },
        filterButton: {
            "id": "business-filters.filters.trigger.filter-button",
            "defaultMessage": "Filter"
        },
        buttonWithFilters: {
            "id": "business-filters.filters.trigger.button-with-filters",
            "defaultMessage": "Filters applied"
        },
        newLozenge: {
            "id": "business-filters.filters.trigger.new-lozenge",
            "defaultMessage": "New"
        },
        newLozengeTooltip: {
            "id": "business-filters.filters.trigger.new-lozenge-tooltip",
            "defaultMessage": "Now you can save your frequently used filters. Apply some filters to get started."
        }
    });
});
parcelRegister("4Mmyc", function(module, exports) {
    $parcel$export(module.exports, "SimpleSearchTextField", ()=>$c9154e4bfb02bfbe$export$63f96dda4bd4f7dc);
    $parcel$export(module.exports, "SimpleSearchField", ()=>$c9154e4bfb02bfbe$export$44e8ccf3428dc1d5);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $9jNMw;
    var $iDP0W;
    var $b2wZT;
    var $682zz;
    var $6Ll2T;
    var $99gde;
    var $8mGGj;
    var $6cG4N;
    var $4R6GH;
    var $koVbs;
    var $jDrwg;
    var $8zOmE;
    var $lwMsT;
    var $dCm1o;
    var $l4v6E;
    var $1T1ir;
    var $emybt;
    const $c9154e4bfb02bfbe$var$SEARCH_FIELD_WIDTH = 184;
    const $c9154e4bfb02bfbe$export$63f96dda4bd4f7dc = (0, $5uXOq.memo)(({ inputRef: inputRef, placeholder: placeholder, value: externalValue = '', onChange: onChange, onFocus: onFocus, view: view, testId: testId = 'searchfield', isDisabled: isDisabled, label: label, describedbyId: describedbyId, themedField: themedField = true, isFullWidth: isFullWidth = false })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const [searchValue, setSearchValue] = (0, $5uXOq.useState)(externalValue);
        const handleSearchChange = (0, $5uXOq.useCallback)((newValue)=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'simpleSearchField updated', {
                view: view,
                ...(0, (0, parcelRequire("l4v6E")).getTextFieldAttributes)(newValue)
            });
            onChange(newValue);
        }, [
            createAnalyticsEvent,
            onChange,
            view
        ]);
        const [handleSearchChangeDebounced] = (0, (0, parcelRequire("jDrwg")).default)(handleSearchChange, 500);
        const handleChange = (0, $5uXOq.useCallback)((e)=>{
            setSearchValue(e.target.value);
            handleSearchChangeDebounced(e.target.value);
        }, [
            handleSearchChangeDebounced
        ]);
        const handleClear = (0, $5uXOq.useCallback)(()=>{
            setSearchValue('');
            handleSearchChangeDebounced('');
        }, [
            setSearchValue,
            handleSearchChangeDebounced
        ]);
        const themedIconPrimaryColor = isDisabled ? (0, (0, parcelRequire("6cG4N")).Tokens).COLOR_TEXT_DISABLED : (0, (0, parcelRequire("6cG4N")).Tokens).COLOR_TEXT_SUBTLEST;
        const Container = themedField ? (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, (0, parcelRequire("4R6GH")).fg)('jira_nav4_eap_drop_2') ? $c9154e4bfb02bfbe$var$ThemedContainer : $c9154e4bfb02bfbe$var$ThemedContainerOld : (0, $5uXOq.Fragment);
        (0, $5uXOq.useEffect)(()=>{
            setSearchValue(externalValue);
        }, [
            externalValue
        ]);
        const elemAfterSearchIcon = !(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("b2wZT"))))), {
            label: "",
            color: "currentColor",
            LEGACY_size: "small",
            LEGACY_primaryColor: themedField ? themedIconPrimaryColor : undefined
        }) : null;
        let textFieldWidth;
        if ((0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)()) textFieldWidth = isFullWidth ? '100%' : $c9154e4bfb02bfbe$var$SEARCH_FIELD_WIDTH;
        return (0, ($parcel$interopDefault($5uXOq))).createElement(Container, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("8mGGj")).default), {
            ref: inputRef,
            "aria-describedby": describedbyId,
            testId: testId,
            value: searchValue,
            isCompact: true,
            placeholder: formatMessage(placeholder),
            "aria-label": label || formatMessage(placeholder),
            onChange: handleChange,
            onFocus: onFocus,
            isDisabled: isDisabled,
            elemAfterInput: searchValue !== '' ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
                paddingInlineEnd: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() ? 'space.025' : undefined
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9jNMw")).default), {
                icon: (iconProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("iDP0W"))))), {
                        ...iconProps,
                        label: formatMessage((0, (0, parcelRequire("emybt")).default).clear),
                        spacing: "none",
                        color: "var(--ds-text, #172B4D)",
                        LEGACY_size: "small",
                        LEGACY_primaryColor: themedField ? themedIconPrimaryColor : undefined
                    }),
                appearance: "subtle",
                spacing: "compact",
                label: formatMessage((0, (0, parcelRequire("emybt")).default).clear),
                testId: "business-filters.ui.simple-search-field.clear-button",
                onClick: handleClear
            })) : elemAfterSearchIcon,
            elemBeforeInput: (0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("6Ll2T")).default), {
                xcss: $c9154e4bfb02bfbe$var$iconStyles
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("682zz"))))), {
                color: "currentColor",
                label: "",
                spacing: "none"
            })),
            width: textFieldWidth,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                !(0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled)() && "_dzcou2gc"
            ])
        }));
    });
    const $c9154e4bfb02bfbe$export$44e8ccf3428dc1d5 = (0, $5uXOq.memo)(({ placeholder: placeholder, view: view, describedbyId: describedbyId, onChange: onChange })=>{
        const [simpleSearch, setSimpleSearch] = (0, (0, parcelRequire("1T1ir")).useSimpleSearch)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const handleFocus = (0, $5uXOq.useCallback)(()=>{
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'simpleSearchField focused', {
                view: view
            });
        }, [
            createAnalyticsEvent,
            view
        ]);
        (0, $5uXOq.useEffect)(()=>{
            if (onChange) onChange(simpleSearch);
        }, [
            onChange,
            simpleSearch
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($c9154e4bfb02bfbe$var$Container, null, (0, ($parcel$interopDefault($5uXOq))).createElement($c9154e4bfb02bfbe$export$63f96dda4bd4f7dc, {
            view: view,
            onFocus: handleFocus,
            describedbyId: describedbyId,
            onChange: (text)=>{
                if (onChange) onChange(text);
                return setSimpleSearch(text);
            },
            value: simpleSearch,
            placeholder: placeholder
        }));
    });
    const $c9154e4bfb02bfbe$var$textFieldStyles = null;
    const $c9154e4bfb02bfbe$var$iconStyles = (0, (0, parcelRequire("99gde")).xcss)({
        display: 'inline-flex',
        marginLeft: 'space.075'
    });
    const $c9154e4bfb02bfbe$var$ThemedContainer = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_6l8rjjc1 _x2xkjjc1 _sg3vjjc1 _w15ajjc1 _n8yf4zrn _jeievy9e _7n83frbu _1o8h13fh _n2ul1jo4",
                __cmplp.className
            ])
        });
    });
    const $c9154e4bfb02bfbe$var$ThemedContainerOld = (0, $5uXOq.forwardRef)(({ as: C = $c9154e4bfb02bfbe$var$ThemedContainer, style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_n8yfim6e",
                __cmplp.className
            ])
        });
    });
    const $c9154e4bfb02bfbe$var$Container = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("jDrwg", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$049f084810e3e7c4$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lFKmC = parcelRequire("lFKmC");
    function $049f084810e3e7c4$export$2e2bcd8739ae039(callback, delay, options) {
        const optionsRef = (0, $5uXOq.useRef)(options);
        const callbackRef = (0, $5uXOq.useRef)((...args)=>{
            callback(...args);
        });
        callbackRef.current = callback;
        const debouncedCallBack = (0, $5uXOq.useMemo)(()=>(0, ($parcel$interopDefault($lFKmC)))((...args)=>callbackRef.current(...args), delay, optionsRef.current), [
            delay
        ]);
        (0, $5uXOq.useEffect)(()=>debouncedCallBack.cancel, [
            debouncedCallBack
        ]);
        return [
            debouncedCallBack,
            debouncedCallBack.cancel
        ];
    }
});
parcelRegister("l4v6E", function(module, exports) {
    $parcel$export(module.exports, "getTextFieldAttributes", ()=>$211f318fc379b0d9$export$dfd7972bcd113afb);
    const $211f318fc379b0d9$export$dfd7972bcd113afb = (value = '')=>{
        const wordCount = value.split(/s+/).filter((word)=>word !== '').length;
        return {
            queryLength: value.length,
            wordCount: wordCount
        };
    };
});
parcelRegister("emybt", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a5a1b27b61b41126$export$2e2bcd8739ae039);
    var $7VHMR;
    var $a5a1b27b61b41126$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        clear: {
            "id": "business-filters.simple-search-field.clear",
            "defaultMessage": "Clear"
        }
    });
});
parcelRegister("17X6Y", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0a40c8fa5f1e21a1$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $heNNl;
    var $lfTZh;
    var $1jUsD;
    var $e1OxR;
    const $0a40c8fa5f1e21a1$var$LazyAddPeopleWithAvatars = (0, (0, parcelRequire("1jUsD")).lazyAfterPaint)(()=>(parcelRequire("5Kdrw")), {
        ssr: false,
        moduleId: "./src/packages/business/shared/components/invite-people/src/ui/add-people-with-avatars/main.tsx"
    });
    const $0a40c8fa5f1e21a1$var$AddPeopleWithAvatar = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: "async.jira-business.invite-people.add-people-with-avatars",
            packageName: "jiraBusinessInvitePeople",
            teamName: "jira-warepil"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "invite-button-with-avatars",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement($0a40c8fa5f1e21a1$var$AvatarFallback, null)
        }, props?.hasInviteButton === false ? (0, ($parcel$interopDefault($5uXOq))).createElement($0a40c8fa5f1e21a1$var$LazyAddPeopleWithAvatars, props) : (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("e1OxR")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement($0a40c8fa5f1e21a1$var$LazyAddPeopleWithAvatars, props))));
    const $0a40c8fa5f1e21a1$var$AvatarFallback = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_4t3i1ylp",
                __cmplp.className
            ])
        });
    });
    var $0a40c8fa5f1e21a1$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($0a40c8fa5f1e21a1$var$AddPeopleWithAvatar);
});
parcelRegister("e1OxR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0f3117b4e456671f$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $heNNl;
    var $7wK4b;
    var $bZLPe;
    const $0f3117b4e456671f$var$AddPeopleModal = ({ shouldUseInvitePeopleModal: shouldUseInvitePeopleModal, source: source })=>{
        const { isModalOpen: isModalOpen, closeAddPeopleModal: closeAddPeopleModal } = (0, (0, parcelRequire("7wK4b")).useAddPeople)();
        if (isModalOpen) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bZLPe")).ProjectInvitePeopleModal), {
            onModalClose: closeAddPeopleModal,
            shouldUseInvitePeopleModal: shouldUseInvitePeopleModal,
            source: source
        });
        return null;
    };
    const $0f3117b4e456671f$var$AddPeople = ({ children: children, shouldUseInvitePeopleModal: shouldUseInvitePeopleModal, source: source })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7wK4b")).AddPeopleProvider), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: "jira-business.invite-people.ui.add-people",
            packageName: "jira-business.invite-people.ui.add-people",
            teamName: "jira-warepil"
        }, children, (0, ($parcel$interopDefault($5uXOq))).createElement($0f3117b4e456671f$var$InviteWrapper, {
            "data-testid": "business-invite-people.ui.add-people-with-avatars.add-people.invite-wrapper"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($0f3117b4e456671f$var$AddPeopleModal, {
            shouldUseInvitePeopleModal: shouldUseInvitePeopleModal,
            source: source
        }))));
    var $0f3117b4e456671f$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($0f3117b4e456671f$var$AddPeople);
    const $0f3117b4e456671f$var$InviteWrapper = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0cglyw",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("7wK4b", function(module, exports) {
    $parcel$export(module.exports, "AddPeopleProvider", ()=>$3ebbf4ad1e53c7be$export$6d41c2327e862d9d);
    $parcel$export(module.exports, "useAddPeople", ()=>$3ebbf4ad1e53c7be$export$93ea361ec674cff6);
    var $5uXOq = parcelRequire("5uXOq");
    var $daQYX;
    var $8zOmE;
    var $lwMsT;
    const $3ebbf4ad1e53c7be$var$AddPeopleContext = (0, $5uXOq.createContext)({
        triggerBtnRef: {
            current: null
        },
        isModalOpen: false,
        openAddPeopleModal: ()=>{},
        closeAddPeopleModal: ()=>{}
    });
    const $3ebbf4ad1e53c7be$export$6d41c2327e862d9d = ({ children: children })=>{
        const projectData = (0, (0, parcelRequire("daQYX")).useProject)();
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const [isModalOpen, setIsModalOpen] = (0, $5uXOq.useState)(false);
        const triggerBtnRef = (0, $5uXOq.useRef)(null);
        const onCloseCallbackRef = (0, $5uXOq.useRef)();
        const openAddPeopleModal = (0, $5uXOq.useCallback)((onClose, source)=>{
            setIsModalOpen(true);
            const eventName = projectData.isSimplified ? 'jwmProjectInviteComponent' : 'jwmInstanceInviteComponent';
            (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', eventName, {
                source: source
            });
            if (onClose) onCloseCallbackRef.current = onClose;
        }, [
            createAnalyticsEvent,
            projectData.isSimplified
        ]);
        const closeAddPeopleModal = (0, $5uXOq.useCallback)(()=>{
            setIsModalOpen(false);
            if (typeof onCloseCallbackRef.current === 'function') {
                onCloseCallbackRef.current();
                onCloseCallbackRef.current = null;
            }
        }, []);
        const context = (0, $5uXOq.useMemo)(()=>({
                triggerBtnRef: triggerBtnRef,
                isModalOpen: isModalOpen,
                openAddPeopleModal: openAddPeopleModal,
                closeAddPeopleModal: closeAddPeopleModal
            }), [
            triggerBtnRef,
            isModalOpen,
            openAddPeopleModal,
            closeAddPeopleModal
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement($3ebbf4ad1e53c7be$var$AddPeopleContext.Provider, {
            value: context
        }, children);
    };
    const $3ebbf4ad1e53c7be$export$93ea361ec674cff6 = ()=>(0, $5uXOq.useContext)($3ebbf4ad1e53c7be$var$AddPeopleContext);
});
parcelRegister("bZLPe", function(module, exports) {
    $parcel$export(module.exports, "ProjectInvitePeopleModal", ()=>$74aeebd820c67267$export$6dfea89767cb5ac1);
    var $5uXOq = parcelRequire("5uXOq");
    var $daQYX;
    var $2erM2;
    var $cb8cx;
    var $9AFuM;
    const $74aeebd820c67267$export$6dfea89767cb5ac1 = ({ onModalClose: onModalClose, shouldUseInvitePeopleModal: shouldUseInvitePeopleModal = false, source: source })=>{
        const projectData = (0, (0, parcelRequire("daQYX")).useProject)();
        const { handleAddSuccess: handleAddSuccess, handleError: handleError } = (0, (0, parcelRequire("2erM2")).useInviteModalHandlers)();
        if (!shouldUseInvitePeopleModal && projectData.isSimplified) return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("cb8cx")).AddPeopleModal), {
            onModalClose: onModalClose,
            onInviteSuccess: handleAddSuccess,
            onInviteError: handleError
        });
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9AFuM")).InvitePeopleModal), {
            onModalClose: onModalClose,
            onInviteSuccess: handleAddSuccess,
            onInviteError: handleError,
            source: source
        });
    };
});
parcelRegister("2erM2", function(module, exports) {
    $parcel$export(module.exports, "useInviteModalHandlers", ()=>$d23a63b1c343bca5$export$f696e14fc423d0b);
    var $5uXOq = parcelRequire("5uXOq");
    var $daQYX;
    var $jcw0u;
    var $pa9q9;
    var $8zOmE;
    var $lwMsT;
    var $9OXo1;
    var $99ejj;
    var $kPioc;
    const $d23a63b1c343bca5$export$f696e14fc423d0b = ()=>{
        const { createAnalyticsEvent: createAnalyticsEvent } = (0, (0, parcelRequire("lwMsT")).useAnalyticsEvents)();
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagService)();
        const { isSiteAdmin: isSiteAdmin } = (0, (0, parcelRequire("9OXo1")).useTenantContext)();
        const projectData = (0, (0, parcelRequire("daQYX")).useProject)();
        const handleAddSuccess = (0, $5uXOq.useCallback)(({ modalType: modalType, totalPeopleAdded: totalPeopleAdded, email: email, inviteStatus: inviteStatus })=>{
            const hasSentInvitation = inviteStatus === (0, (0, parcelRequire("99ejj")).InvitationStatusEnum).INVITED;
            const hasSuccessfullyAddedPeople = !inviteStatus && projectData.permissions.administerProject;
            showFlag(hasSuccessfullyAddedPeople ? (0, (0, parcelRequire("kPioc")).createAddSuccessFlagConfig)({
                totalPeopleAdded: totalPeopleAdded,
                email: email,
                projectKey: projectData.key
            }) : (0, (0, parcelRequire("kPioc")).createInviteSuccessFlagConfig)({
                totalPeopleAdded: totalPeopleAdded,
                email: email,
                hasSentInvitation: hasSentInvitation
            }));
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), `jwm${modalType}Invite success`, {
                inviteStatus: inviteStatus
            });
        }, [
            createAnalyticsEvent,
            showFlag,
            projectData
        ]);
        const handleError = (0, $5uXOq.useCallback)(({ modalType: modalType, errorMessage: errorMessage, statusCode: statusCode })=>{
            if (errorMessage.includes((0, $20132b2015719a62$export$4e427f77b64bbbed)) || errorMessage.includes((0, $20132b2015719a62$export$20ef020abfaa9ec))) {
                showFlag((0, (0, parcelRequire("kPioc")).createInviteFailedUserLimitFlagConfig)(isSiteAdmin, createAnalyticsEvent));
                (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), 'userLimit reached', `jwm${modalType}Invite`);
                return;
            }
            if (errorMessage.includes((0, $20132b2015719a62$export$a1d765adf759361e))) showFlag((0, (0, parcelRequire("kPioc")).inviteFailBadRequestFlagConfig));
            else if (errorMessage.includes((0, $20132b2015719a62$export$c7f012c6e67c4217))) showFlag((0, (0, parcelRequire("kPioc")).inviteFailNetworkErrorFlagConfig));
            else if (errorMessage.includes((0, $20132b2015719a62$export$c8a538cf4ae41623)) || errorMessage.includes((0, $20132b2015719a62$export$9bbcbc11675c1278)) || errorMessage.includes((0, $20132b2015719a62$export$a51af3c30283d234))) showFlag((0, (0, parcelRequire("kPioc")).inviteFailGenericFlagConfig));
            else showFlag((0, (0, parcelRequire("kPioc")).inviteFailFlagConfig));
            const isClientError = statusCode && statusCode >= 400 && statusCode < 500;
            if (errorMessage.includes((0, $20132b2015719a62$export$14fb68f74ccc8b23)) || isClientError) return;
            (0, (0, parcelRequire("jcw0u")).default)({
                meta: {
                    id: `jwm${modalType}Invite`,
                    packageName: (0, $20132b2015719a62$export$b8b9d90f9e5bd72b),
                    teamName: 'jira-warepil'
                },
                attributes: {
                    message: errorMessage
                },
                error: new Error(errorMessage),
                sendToPrivacyUnsafeSplunk: true
            });
            (0, (0, parcelRequire("8zOmE")).fireTrackAnalytics)(createAnalyticsEvent({}), `jwm${modalType}Invite failed`);
        }, [
            createAnalyticsEvent,
            isSiteAdmin,
            showFlag
        ]);
        return {
            handleAddSuccess: handleAddSuccess,
            handleError: handleError
        };
    };
});
const $20132b2015719a62$export$b8b9d90f9e5bd72b = 'jira-business.invite-people';
const $20132b2015719a62$export$a1d765adf759361e = 'Check your request, then give it another try.';
const $20132b2015719a62$export$c7f012c6e67c4217 = 'Check your network connection, then give it another try.';
const $20132b2015719a62$export$c8a538cf4ae41623 = 'AUTH_FAILED';
const $20132b2015719a62$export$9bbcbc11675c1278 = 'SERVER_ERROR';
const $20132b2015719a62$export$a51af3c30283d234 = 'USER_NOT_FOUND';
const $20132b2015719a62$export$4e427f77b64bbbed = 'LICENSE_LIMIT_REACHED';
const $20132b2015719a62$export$20ef020abfaa9ec = 'Licence Exceeded';
const $20132b2015719a62$export$14fb68f74ccc8b23 = 'Recaptcha validation failed';
parcelRegister("99ejj", function(module, exports) {
    $parcel$export(module.exports, "InvitationStatusEnum", ()=>$e49e7d7763027049$export$2e0a7d2dc28c9a18);
    const $e49e7d7763027049$export$2e0a7d2dc28c9a18 = {
        ACCESS_REQUESTED: 'ACCESS_REQUESTED',
        INVITED: 'INVITED'
    };
});
parcelRegister("kPioc", function(module, exports) {
    $parcel$export(module.exports, "inviteFailFlagConfig", ()=>$366128c003d2496b$export$95c6157ced8b3439);
    $parcel$export(module.exports, "inviteFailGenericFlagConfig", ()=>$366128c003d2496b$export$1108ab4b8a5d8a7d);
    $parcel$export(module.exports, "inviteFailBadRequestFlagConfig", ()=>$366128c003d2496b$export$7f2d6442eed4d708);
    $parcel$export(module.exports, "inviteFailNetworkErrorFlagConfig", ()=>$366128c003d2496b$export$c3bdacfc2255a9ed);
    $parcel$export(module.exports, "createInviteSuccessFlagConfig", ()=>$366128c003d2496b$export$d456881895c2a0b2);
    $parcel$export(module.exports, "createAddSuccessFlagConfig", ()=>$366128c003d2496b$export$cca35dec2a083169);
    $parcel$export(module.exports, "createInviteFailedUserLimitFlagConfig", ()=>$366128c003d2496b$export$251dc06b3962c565);
    var $8zOmE;
    var $6OFcj;
    const $366128c003d2496b$export$8c9a09c293b933fb = ({ specificDescription: specificDescription, agnosticDescription: agnosticDescription, totalPeopleAdded: totalPeopleAdded, email: email })=>{
        if (totalPeopleAdded <= 0) return [
            agnosticDescription,
            {}
        ];
        return [
            specificDescription,
            {
                totalPeopleAddedMinusOne: totalPeopleAdded - 1,
                totalPeopleAdded: totalPeopleAdded,
                email: email
            }
        ];
    };
    const $366128c003d2496b$export$95c6157ced8b3439 = {
        type: 'error',
        title: (0, (0, parcelRequire("6OFcj")).default).inviteFailedMessageTitle,
        description: (0, (0, parcelRequire("6OFcj")).default).inviteFailedMessageDescription,
        actions: [
            {
                content: (0, (0, parcelRequire("6OFcj")).default).inviteFailedMessageCta,
                onClick: ()=>window.open('/secure/ContactAdministrators!default.jspa', '_blank')
            }
        ],
        messageType: 'transactional'
    };
    const $366128c003d2496b$export$1108ab4b8a5d8a7d = {
        type: 'error',
        title: (0, (0, parcelRequire("6OFcj")).default).inviteFailedMessageTitle,
        description: (0, (0, parcelRequire("6OFcj")).default).inviteFailedGenericMessageDescription,
        messageType: 'transactional'
    };
    const $366128c003d2496b$export$7f2d6442eed4d708 = {
        type: 'error',
        title: (0, (0, parcelRequire("6OFcj")).default).inviteFailedMessageTitle,
        description: (0, (0, parcelRequire("6OFcj")).default).inviteFailedBadRequestMessageDescription,
        messageType: 'transactional'
    };
    const $366128c003d2496b$export$c3bdacfc2255a9ed = {
        type: 'error',
        title: (0, (0, parcelRequire("6OFcj")).default).inviteFailedMessageTitle,
        description: (0, (0, parcelRequire("6OFcj")).default).inviteFailedNetworkErrorMessageDescription,
        messageType: 'transactional'
    };
    const $366128c003d2496b$export$d456881895c2a0b2 = ({ totalPeopleAdded: totalPeopleAdded, email: email, hasSentInvitation: hasSentInvitation })=>{
        if (!hasSentInvitation) return {
            type: 'success',
            title: (0, (0, parcelRequire("6OFcj")).default).requestInviteSuccessMessageTitle,
            description: $366128c003d2496b$export$8c9a09c293b933fb({
                agnosticDescription: (0, (0, parcelRequire("6OFcj")).default).requestInviteSuccessMessageDescriptionAgnostic,
                specificDescription: (0, (0, parcelRequire("6OFcj")).default).requestInviteSuccessMessageDescription,
                totalPeopleAdded: totalPeopleAdded,
                email: email
            }),
            messageType: 'transactional'
        };
        return {
            type: 'success',
            title: (0, (0, parcelRequire("6OFcj")).default).inviteSuccessMessageTitle,
            description: $366128c003d2496b$export$8c9a09c293b933fb({
                agnosticDescription: (0, (0, parcelRequire("6OFcj")).default).inviteSuccessMessageDescriptionAgnostic,
                specificDescription: (0, (0, parcelRequire("6OFcj")).default).inviteSuccessMessageDescription,
                totalPeopleAdded: totalPeopleAdded,
                email: email
            }),
            messageType: 'transactional'
        };
    };
    const $366128c003d2496b$export$cca35dec2a083169 = ({ totalPeopleAdded: totalPeopleAdded, email: email, projectKey: projectKey })=>({
            type: 'success',
            title: (0, (0, parcelRequire("6OFcj")).default).peopleAddedSuccessMessageTitle,
            description: $366128c003d2496b$export$8c9a09c293b933fb({
                agnosticDescription: (0, (0, parcelRequire("6OFcj")).default).peopleAddedSuccessMessageDescriptionAgnostic,
                specificDescription: (0, (0, parcelRequire("6OFcj")).default).peopleAddedSuccessMessageDescription,
                totalPeopleAdded: totalPeopleAdded,
                email: email
            }),
            actions: [
                {
                    content: (0, (0, parcelRequire("6OFcj")).default).peopleAddedManageAccess,
                    onClick: ()=>window.location.assign(`/jira/core/projects/${projectKey}/settings/access`)
                }
            ],
            messageType: 'transactional'
        });
    const $366128c003d2496b$export$251dc06b3962c565 = (isSiteAdmin, createAnalyticsEvent)=>({
            type: 'warning',
            title: (0, (0, parcelRequire("6OFcj")).default).userLimitInviteErrorTitle,
            description: isSiteAdmin ? (0, (0, parcelRequire("6OFcj")).default).userLimitInviteErrorDescriptionAdmin : (0, (0, parcelRequire("6OFcj")).default).userLimitInviteErrorDescription,
            actions: isSiteAdmin ? [
                {
                    content: (0, (0, parcelRequire("6OFcj")).default).upgradePlan,
                    onClick: ()=>{
                        (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'upgradePlan');
                        window.open('/admin/billing/applications', '_blank');
                    }
                },
                {
                    content: (0, (0, parcelRequire("6OFcj")).default).viewUsers,
                    onClick: ()=>{
                        (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'viewUsers');
                        window.open('/admin/users', '_blank');
                    }
                }
            ] : [
                {
                    content: (0, (0, parcelRequire("6OFcj")).default).inviteFailedMessageCta,
                    onClick: ()=>{
                        (0, (0, parcelRequire("8zOmE")).fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'contactAdmin');
                        window.open('/secure/ContactAdministrators!default.jspa', '_blank');
                    }
                }
            ],
            messageType: 'transactional'
        });
});
parcelRegister("6OFcj", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$d87007b6d35f6d31$export$2e2bcd8739ae039);
    var $7VHMR;
    var $d87007b6d35f6d31$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        inviteSuccessMessageTitle: {
            "id": "business-invite-people.controllers.modal-handlers.invite-success-message-title",
            "defaultMessage": "Invitation sent"
        },
        inviteSuccessMessageDescription: {
            "id": "business-invite-people.controllers.modal-handlers.invite-success-message-description",
            "defaultMessage": "You've invited {totalPeopleAdded, plural, one {{email}} =2 {{email} and {totalPeopleAddedMinusOne} other} other {{email} and {totalPeopleAddedMinusOne} others}} to this business project."
        },
        inviteSuccessMessageDescriptionAgnostic: {
            "id": "business-invite-people.controllers.modal-handlers.invite-success-message-description-agnostic",
            "defaultMessage": "You've successfully invited people to your business project."
        },
        inviteFailedMessageTitle: {
            "id": "business-invite-people.controllers.modal-handlers.invite-failed-message-title",
            "defaultMessage": "Something went wrong"
        },
        inviteFailedMessageDescription: {
            "id": "business-invite-people.controllers.modal-handlers.invite-failed-message-description",
            "defaultMessage": "We weren\u2019t able to invite any users. Contact your admin for help."
        },
        inviteFailedMessageCta: {
            "id": "business-invite-people.controllers.modal-handlers.invite-failed-message-cta",
            "defaultMessage": "Contact your admin"
        },
        inviteFailedGenericMessageDescription: {
            "id": "business-invite-people.controllers.modal-handlers.invite-failed-generic-message-description",
            "defaultMessage": "We weren\u2019t able to invite any users, please try again."
        },
        inviteFailedBadRequestMessageDescription: {
            "id": "business-invite-people.controllers.modal-handlers.invite-failed-bad-request-message-description",
            "defaultMessage": "We weren\u2019t able to invite any users. Check your request, then give it another try."
        },
        inviteFailedNetworkErrorMessageDescription: {
            "id": "business-invite-people.controllers.modal-handlers.invite-failed-network-error-message-description",
            "defaultMessage": "We weren\u2019t able to invite any users. Check your network connection, then give it another try."
        },
        requestInviteSuccessMessageTitle: {
            "id": "business-invite-people.controllers.modal-handlers.request-invite-success-message-title",
            "defaultMessage": "Access request sent to your admin"
        },
        requestInviteSuccessMessageDescription: {
            "id": "business-invite-people.controllers.modal-handlers.request-invite-success-message-description",
            "defaultMessage": "Your admin needs to approve access for {totalPeopleAdded, plural, one {{email}} =2 {{email} and {totalPeopleAddedMinusOne} other} other {{email} and {totalPeopleAddedMinusOne} others}}."
        },
        requestInviteSuccessMessageDescriptionAgnostic: {
            "id": "business-invite-people.controllers.modal-handlers.request-invite-success-message-description-agnostic",
            "defaultMessage": "Your admin needs to approve access for people to your business project."
        },
        peopleAddedSuccessMessageTitle: {
            "id": "business-invite-people.controllers.modal-handlers.people-added-success-message-title",
            "defaultMessage": "New people added"
        },
        peopleAddedSuccessMessageDescription: {
            "id": "business-invite-people.controllers.modal-handlers.people-added-success-message-description",
            "defaultMessage": "{totalPeopleAdded, plural, one {{email}} =2 {{email} and {totalPeopleAddedMinusOne} other} other {{email} and {totalPeopleAddedMinusOne} others}} added to the project. You can also add teammates and manage their access to the project from Project settings"
        },
        peopleAddedSuccessMessageDescriptionAgnostic: {
            "id": "business-invite-people.controllers.modal-handlers.people-added-success-message-description-agnostic",
            "defaultMessage": "People added to the project. You can also add teammates and manage their access to the project from Project settings"
        },
        peopleAddedManageAccess: {
            "id": "business-invite-people.controllers.modal-handlers.people-added-manage-access",
            "defaultMessage": "Manage access"
        },
        userLimitInviteErrorTitle: {
            "id": "business-invite-people.controllers.modal-handlers.user-limit-invite-error-title",
            "defaultMessage": "Can't add more people"
        },
        userLimitInviteErrorDescriptionAdmin: {
            "id": "business-invite-people.controllers.modal-handlers.user-limit-invite-error-description-admin",
            "defaultMessage": "You've reached your user limit. Upgrade your plan or remove other users."
        },
        userLimitInviteErrorDescription: {
            "id": "business-invite-people.controllers.modal-handlers.user-limit-invite-error-description",
            "defaultMessage": "You've reached your user limit. Contact your admin for help."
        },
        viewUsers: {
            "id": "business-invite-people.controllers.modal-handlers.view-users",
            "defaultMessage": "View users"
        },
        upgradePlan: {
            "id": "business-invite-people.controllers.modal-handlers.upgrade-plan",
            "defaultMessage": "Upgrade plan"
        }
    });
});
parcelRegister("cb8cx", function(module, exports) {
    $parcel$export(module.exports, "AddPeopleModal", ()=>$4afbb4a2961eae5f$export$b28f48897cdf7241);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $daQYX;
    var $heNNl;
    var $lfTZh;
    var $5oFIy;
    var $itmJb;
    var $1jUsD;
    var $7wK4b;
    const $4afbb4a2961eae5f$export$a4917c848b5c6ce8 = (0, (0, parcelRequire("1jUsD")).lazy)(()=>(parcelRequire("7HRyA")), {
        ssr: false,
        moduleId: "./src/packages/permissions-administration/components/project-add-people/src/index.tsx"
    });
    const $4afbb4a2961eae5f$var$userInviteErrorCodes = {
        BAD_REQUEST_ERROR_CODE: $20132b2015719a62$export$a1d765adf759361e,
        NETWORK_ERROR_CODE: $20132b2015719a62$export$c7f012c6e67c4217,
        AUTH_FAILED_ERROR_CODE: $20132b2015719a62$export$c8a538cf4ae41623,
        SERVER_ERROR_ERROR_CODE: $20132b2015719a62$export$9bbcbc11675c1278,
        USER_NOT_FOUND_ERROR_CODE: $20132b2015719a62$export$a51af3c30283d234
    };
    const $4afbb4a2961eae5f$export$b28f48897cdf7241 = (0, $5uXOq.memo)(({ onInviteSuccess: onInviteSuccess, onInviteError: onInviteError, onModalClose: onModalClose })=>{
        const { triggerBtnRef: triggerBtnRef } = (0, (0, parcelRequire("7wK4b")).useAddPeople)();
        const projectData = (0, (0, parcelRequire("daQYX")).useProject)();
        const isAdmin = (0, (0, parcelRequire("itmJb")).useIsAdmin)();
        const handleInviteSuccess = (0, $5uXOq.useCallback)((addedParties, _role)=>{
            onInviteSuccess({
                totalPeopleAdded: addedParties.length,
                email: addedParties[0]?.email || addedParties[0]?.displayName,
                modalType: 'Project'
            });
        }, [
            onInviteSuccess
        ]);
        const extractErrorCode = (message)=>{
            for (const errorCode of Object.keys($4afbb4a2961eae5f$var$userInviteErrorCodes)){
                const errorMessage = $4afbb4a2961eae5f$var$userInviteErrorCodes[errorCode];
                if (message.includes(errorMessage)) return errorCode;
            }
            return message;
        };
        const handleInviteFailure = (0, $5uXOq.useCallback)((errors)=>{
            const userInviteErrorsWithCode = {};
            errors.forEach((error)=>{
                const errorCode = extractErrorCode(error.message);
                if (errorCode) {
                    if (!userInviteErrorsWithCode[errorCode]) userInviteErrorsWithCode[errorCode] = [];
                    userInviteErrorsWithCode[errorCode].push(error);
                }
            });
            const groupedUserInviteErrors = Object.values(userInviteErrorsWithCode).map((group)=>{
                const statusCode = group[0]?.statusCode;
                const messages = group.map((obj)=>obj.message).join('\n');
                return {
                    message: messages,
                    statusCode: statusCode
                };
            });
            groupedUserInviteErrors.forEach((groupedUserInviteError)=>{
                onInviteError({
                    modalType: 'Project',
                    errorMessage: groupedUserInviteError.message,
                    statusCode: groupedUserInviteError.statusCode
                });
            });
        }, [
            onInviteError
        ]);
        const { id: id, key: key } = projectData;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: "async.jira-business.project-invite-people-modal.add-people",
            packageName: "jira-business.project-invite-people-modal.add-people",
            teamName: "jira-warepil"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireTrackAnalytics), {
            eventName: "jwmProjectInviteComponent viewed"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "add-people-modal-lazy",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($4afbb4a2961eae5f$export$a4917c848b5c6ce8, {
            isOpen: true,
            triggerBtnRef: triggerBtnRef,
            onClose: onModalClose,
            onAddSuccess: handleInviteSuccess,
            onError: handleInviteFailure,
            projectId: id,
            projectKey: key,
            projectType: "business",
            isAdmin: isAdmin,
            baseUrl: "",
            analyticsPrefix: "",
            allowFlags: false,
            onStopPerfMetric: (0, ($parcel$interopDefault($8Rkzz)))
        })));
    });
});
parcelRegister("7HRyA", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("1TWxe")
    ]).then(()=>parcelRequire('jd2mv'));
});
parcelRegister("9AFuM", function(module, exports) {
    $parcel$export(module.exports, "InvitePeopleModal", ()=>$5ae346fd9b1f20af$export$e3ec81c4d0451f63);
    var $5uXOq = parcelRequire("5uXOq");
    var $daQYX;
    var $9fuVs;
    var $65Ltd;
    var $heNNl;
    var $7NYq5;
    var $lfTZh;
    var $6jY6G;
    var $5oFIy;
    var $12hlA;
    var $14XJw;
    var $efvDm;
    var $ldyPw;
    var $k9JTq;
    var $koeKL;
    var $itmJb;
    var $1jUsD;
    var $99ejj;
    const $5ae346fd9b1f20af$export$cbfde4f653ce234 = (0, (0, parcelRequire("1jUsD")).lazy)(()=>(parcelRequire("cRCnX")), {
        ssr: false,
        moduleId: "../platform/packages/people-and-teams/invite-people/src/index.ts"
    });
    const $5ae346fd9b1f20af$export$4d2a63c83bbce998 = (res)=>{
        if (res.accessRequested?.length) return (0, (0, parcelRequire("99ejj")).InvitationStatusEnum).ACCESS_REQUESTED;
        return (0, (0, parcelRequire("99ejj")).InvitationStatusEnum).INVITED;
    };
    const $5ae346fd9b1f20af$var$LIST_ROUTES = [
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_LIST_CLASSIC),
        (0, (0, parcelRequire("65Ltd")).ROUTE_NAMES_SOFTWARE_LIST)
    ];
    const $5ae346fd9b1f20af$var$isFailureResponse = (res)=>res.failure !== undefined;
    const $5ae346fd9b1f20af$export$e3ec81c4d0451f63 = (0, $5uXOq.memo)(({ onInviteSuccess: onInviteSuccess, onInviteError: onInviteError, onModalClose: onModalClose, source: source = 'projectBoard' })=>{
        const route = (0, (0, parcelRequire("6jY6G")).useCurrentRoute)();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const appEditions = (0, (0, parcelRequire("k9JTq")).useAppEditions)();
        const { data: orgId } = (0, (0, parcelRequire("14XJw")).useOrgId)();
        const projectData = (0, (0, parcelRequire("daQYX")).useProject)();
        const isAdmin = (0, (0, parcelRequire("itmJb")).useIsAdmin)();
        const onInviteCompleteHandler = (0, $5uXOq.useCallback)((response)=>{
            if ($5ae346fd9b1f20af$var$isFailureResponse(response)) {
                const { message: message, status: status } = response.failure;
                onInviteError({
                    modalType: 'Instance',
                    errorMessage: message,
                    statusCode: status
                });
                return;
            }
            const inviteStatus = $5ae346fd9b1f20af$export$4d2a63c83bbce998(response);
            const { invited: invited, accessRequested: accessRequested } = response;
            onInviteSuccess({
                totalPeopleAdded: invited.length || accessRequested.length,
                email: invited[0]?.email || accessRequested[0]?.email || '',
                modalType: 'Instance',
                inviteStatus: inviteStatus
            });
        }, [
            onInviteError,
            onInviteSuccess
        ]);
        const isSoftwareRoute = (0, $5uXOq.useMemo)(()=>$5ae346fd9b1f20af$var$LIST_ROUTES.includes(route.name), [
            route
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: "async.jira-business.project-invite-people-modal.invite-people",
            packageName: "jira-business.project-invite-people-modal.invite-people",
            teamName: "jira-warepil"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "project-invite-people-modal.invite-people",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("9fuVs")).default), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7NYq5")).JiraModal), {
            messageId: "business-invite-people.ui.add-people-with-avatars.add-people.project-invite-people-modal.invite-people-modal.jira-modal",
            messageType: "transactional",
            onClose: onModalClose,
            width: "small",
            shouldScrollInViewport: true,
            testId: "business-invite-people.ui.add-people-with-avatars.add-people.project-invite-people-modal.invite-people-modal"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("5oFIy")).FireTrackAnalytics), {
            eventName: "jwmInstanceInviteComponent viewed"
        }), isSoftwareRoute ? (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("12hlA")).default), {
            isOpen: true,
            cloudId: cloudId,
            projectId: projectData.id,
            jiraProjectKey: projectData.key,
            isSiteAdmin: isAdmin,
            onClose: onModalClose,
            appEdition: (0, (0, parcelRequire("ldyPw")).getEdition)((0, (0, parcelRequire("efvDm")).JIRA_SOFTWARE), appEditions),
            jiraProjectName: projectData.name
        }) : (0, ($parcel$interopDefault($5uXOq))).createElement($5ae346fd9b1f20af$export$cbfde4f653ce234, {
            onSendHandler: onModalClose,
            onInviteCompletedHandler: onInviteCompleteHandler,
            onCancelHandler: onModalClose,
            resourceAri: `ari:cloud:jira::site/${cloudId}`,
            continueUrl: window.location.href,
            enableThirdParty: true,
            source: source,
            orgId: orgId
        })))));
    });
});
parcelRegister("7NYq5", function(module, exports) {
    $parcel$export(module.exports, "JiraModal", ()=>$d308ab9275c4cac7$export$3782fcca1f68992e);
    var $5uXOq = parcelRequire("5uXOq");
    var $bTmOP;
    var $10xFf;
    var $1WAOl;
    const $d308ab9275c4cac7$export$3782fcca1f68992e = (props)=>{
        if ((0, (0, parcelRequire("10xFf")).shouldBeChoreographed)(props)) {
            const { messageType: messageType, ...rest } = props;
            return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1WAOl")).ChoreographerModal), rest);
        }
        const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bTmOP")).default), rest);
    };
    $d308ab9275c4cac7$export$3782fcca1f68992e.displayName = 'JiraModal';
});
parcelRegister("1WAOl", function(module, exports) {
    $parcel$export(module.exports, "ChoreographerModal", ()=>$ae3d8c3c4e97b978$export$3f5d627caa6fc630);
    var $bTmOP;
    var $cSWNW;
    const $ae3d8c3c4e97b978$export$3f5d627caa6fc630 = (0, (0, parcelRequire("cSWNW")).withChoreographedRender)((0, (0, parcelRequire("bTmOP")).default));
});
parcelRegister("12hlA", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0bc8c7c74346f034$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $39xOx;
    var $lfTZh;
    var $1jUsD;
    const $0bc8c7c74346f034$var$LazyComponent = (0, (0, parcelRequire("1jUsD")).lazyForPaint)(()=>(parcelRequire("jWZZk")), {
        moduleId: "./src/packages/project-settings/invite-people-modal-project/src/index.tsx"
    });
    const $0bc8c7c74346f034$export$6a02a79fa2b0ddab = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("39xOx")).JSErrorBoundary), {
            id: "async-project-invite-people-modal",
            packageName: "jira-project-invite-people-modal",
            teamName: "groot-growth"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "project-invite-people-modal",
            fallback: null
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($0bc8c7c74346f034$var$LazyComponent, props)));
    var $0bc8c7c74346f034$export$2e2bcd8739ae039 = $0bc8c7c74346f034$export$6a02a79fa2b0ddab;
});
parcelRegister("jWZZk", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("6C6tQ")
    ]).then(()=>parcelRequire('3dNZP'));
});
parcelRegister("cRCnX", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("29qSX")
    ]).then(()=>parcelRequire('ig8jN'));
});
parcelRegister("5Kdrw", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("eeBXE")
    ]).then(()=>parcelRequire('62h3r'));
});
parcelRegister("ccsmj", function(module, exports) {
    $parcel$export(module.exports, "JWMShareButton", ()=>$e895e30d5d3d8dcc$export$b326da26415fdf10);
    var $5uXOq = parcelRequire("5uXOq");
    var $aFThE;
    var $12jwF;
    var $koVbs;
    var $22OQR;
    var $iL8EU;
    var $9j8is;
    var $fjgF8;
    var $4XKuc;
    const $e895e30d5d3d8dcc$var$SHARE_ICON = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("aFThE"))))), {
        label: "",
        size: "small"
    });
    const $e895e30d5d3d8dcc$export$b326da26415fdf10 = ({ shareTitle: shareTitle, integrationType: integrationType, shareContentType: shareContentType, isAutoOpenDialog: isAutoOpenDialog = false, onDialogClose: onDialogClose })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        const { shareIntegrations: shareIntegrations } = (0, (0, parcelRequire("9j8is")).useShareIntegrations)(shareContentType);
        const entityAri = (0, (0, parcelRequire("12jwF")).useEntityAri)();
        const shareButtonRef = (0, $5uXOq.useRef)(null);
        const renderCustomTriggerButton = (0, $5uXOq.useCallback)(({ onClick: onClick, isSelected: isSelected }, { ref: ref, ...triggerProps })=>(0, ($parcel$interopDefault($5uXOq))).createElement("div", {
                ref: ref
            }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("22OQR")).ThemedButton), {
                ...triggerProps,
                ref: shareButtonRef,
                onClick: onClick,
                isSelected: isSelected,
                iconBefore: $e895e30d5d3d8dcc$var$SHARE_ICON,
                appearance: "subtle"
            }, formatMessage((0, (0, parcelRequire("4XKuc")).default).share))), [
            formatMessage
        ]);
        const handleDialogClose = ()=>{
            onDialogClose?.();
            shareButtonRef?.current?.focus();
        };
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("fjgF8")).AsyncShareProjectNudge), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("iL8EU")).default), {
            isAutoOpenDialog: isAutoOpenDialog,
            integrationType: integrationType,
            triggerButtonStyle: "icon-with-text",
            productId: "jira",
            subProductId: "jira-core",
            shareLink: false ? '' : window.location.href,
            shareTitle: formatMessage(shareTitle),
            shareContentType: shareContentType,
            renderCustomTriggerButton: renderCustomTriggerButton,
            objectAri: entityAri,
            onDialogClose: handleDialogClose,
            copyTooltipText: formatMessage((0, (0, parcelRequire("4XKuc")).default).shareTooltipText),
            shareIntegrations: shareIntegrations,
            integrationMode: "tabs",
            shareFormHelperMessage: formatMessage((0, (0, parcelRequire("4XKuc")).default).shareJwmHelperMessage)
        }));
    };
});
parcelRegister("aFThE", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $7c589dec533d9504$var$_react = $7c589dec533d9504$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $7p1ve;
    var $7c589dec533d9504$var$_share = $7c589dec533d9504$var$_interopRequireDefault((parcelRequire("1AJjz")));
    function $7c589dec533d9504$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $7c589dec533d9504$var$ShareIcon = (props)=>$7c589dec533d9504$var$_react.default.createElement((0, parcelRequire("7p1ve")).IconFacade, Object.assign({
            dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M6 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2m12-4a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2m0 14a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2"/><path d="m7 13.562 8.66 5 1-1.732-8.66-5z"/><path d="m7 10.83 1 1.732 8.66-5-1-1.732z"/></g></svg>`
        }, props, {
            newIcon: $7c589dec533d9504$var$_share.default
        }));
    $7c589dec533d9504$var$ShareIcon.displayName = 'ShareIcon';
    var $7c589dec533d9504$var$_default = module.exports.default = $7c589dec533d9504$var$ShareIcon;
});
parcelRegister("1AJjz", function(module, exports) {
    "use strict";
    Object.defineProperty(module.exports, "__esModule", {
        value: true
    });
    module.exports.default = void 0;
    var $128c4dc3501401e2$var$_react = $128c4dc3501401e2$var$_interopRequireDefault((parcelRequire("5uXOq")));
    var $128c4dc3501401e2$var$_UNSAFE_baseNew = $128c4dc3501401e2$var$_interopRequireDefault((parcelRequire("dTInF")));
    function $128c4dc3501401e2$var$_interopRequireDefault(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    const $128c4dc3501401e2$var$ShareIcon = (props)=>$128c4dc3501401e2$var$_react.default.createElement($128c4dc3501401e2$var$_UNSAFE_baseNew.default, Object.assign({
            dangerouslySetGlyph: `<path stroke="currentcolor" stroke-width="1.5" d="M10.434 11.717a1.75 1.75 0 1 0 3.131 1.566 1.75 1.75 0 0 0-3.13-1.566Zm0 0L5.316 8.783m0 0a1.74 1.74 0 0 0 0-1.566m0 1.566a1.75 1.75 0 1 1 0-1.566m0 0 5.118-2.934m0 0a1.75 1.75 0 1 0 3.13-1.566 1.75 1.75 0 0 0-3.13 1.566Z"/>`
        }, props));
    $128c4dc3501401e2$var$ShareIcon.displayName = 'ShareIcon';
    var $128c4dc3501401e2$var$_default = module.exports.default = $128c4dc3501401e2$var$ShareIcon;
});
parcelRegister("iL8EU", function(module, exports) {
    $parcel$export(module.exports, "ShareLoadingPlaceholder", ()=>$4e5335f44d688bbf$export$5619d05bf511476b);
    $parcel$export(module.exports, "default", ()=>$4e5335f44d688bbf$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $8Rkzz = parcelRequire("8Rkzz");
    var $2APCZ;
    var $aFThE;
    var $heNNl;
    var $koVbs;
    var $lfTZh;
    var $1jUsD;
    var $Kpokz;
    const $4e5335f44d688bbf$export$5619d05bf511476b = ({ triggerButtonStyle: triggerButtonStyle = 'icon-only' })=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement("div", null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2APCZ")).default), {
            appearance: "subtle",
            iconBefore: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("aFThE"))))), {
                size: "medium",
                label: formatMessage((0, (0, parcelRequire("Kpokz")).messages).shareTriggerButtonText),
                primaryColor: `var(--ds-icon, ${(0, $72ba03e317f3d228$exports).N30})`
            }),
            isDisabled: true
        }, triggerButtonStyle === 'icon-with-text' ? formatMessage((0, (0, parcelRequire("Kpokz")).messages).shareTriggerButtonText) : null));
    };
    const $4e5335f44d688bbf$var$ShareButton = (0, (0, parcelRequire("1jUsD")).lazyAfterPaint)(()=>(parcelRequire("jHQiG")), {
        ssr: false,
        moduleId: "./src/packages/growth/share-button/src/ui/index.tsx"
    });
    var $4e5335f44d688bbf$export$2e2bcd8739ae039 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: "async.share.button",
            packageName: "share-button"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "share-button",
            fallback: props.renderCustomTriggerButton === undefined ? (0, ($parcel$interopDefault($5uXOq))).createElement($4e5335f44d688bbf$export$5619d05bf511476b, {
                triggerButtonStyle: props.triggerButtonStyle
            }) : (0, ($parcel$interopDefault($5uXOq))).createElement(props.renderCustomTriggerButton, {
                isDisabled: true,
                onClick: (0, ($parcel$interopDefault($8Rkzz)))
            })
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($4e5335f44d688bbf$var$ShareButton, props)));
});
parcelRegister("Kpokz", function(module, exports) {
    $parcel$export(module.exports, "messages", ()=>$026d1258a1c95d57$export$defe85febe8b728c);
    var $7VHMR;
    const $026d1258a1c95d57$export$defe85febe8b728c = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        shareTriggerButtonText: {
            "id": "share-button.share-trigger-button-text",
            "defaultMessage": "Share"
        }
    });
});
parcelRegister("jHQiG", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("h2MrD"),
        $6fhBS("bYT2S"),
        $6fhBS("bfk3F")
    ]).then(()=>parcelRequire('7aU9g'));
});
parcelRegister("9j8is", function(module, exports) {
    $parcel$export(module.exports, "useShareIntegrations", ()=>$d021f3111fd4c646$export$58a9f7a7ab3466f4);
    var $5uXOq = parcelRequire("5uXOq");
    var $hnsNR;
    var $bCdIp;
    var $pa9q9;
    var $koeKL;
    var $2UEtd;
    var $aMZmw;
    const $d021f3111fd4c646$export$58a9f7a7ab3466f4 = (shareContentType)=>{
        const { showFlag: showFlag } = (0, (0, parcelRequire("pa9q9")).useFlagsService)();
        const cloudId = (0, (0, parcelRequire("koeKL")).useCloudId)();
        const ineligibilityReasons = (0, $5uXOq.useMemo)(()=>{
            const reasons = [];
            if ((0, (0, parcelRequire("bCdIp")).default)()) reasons.push('notDesktop');
            if ((0, (0, parcelRequire("hnsNR")).isFedRamp)()) reasons.push('isFedRAMP');
            return reasons;
        }, []);
        const shareIntegrations = (0, $5uXOq.useMemo)(()=>ineligibilityReasons.length === 0 ? [
                {
                    type: 'Slack',
                    Icon: (0, (0, parcelRequire("aMZmw")).default),
                    Content: ({ onClose: onClose, changeTab: changeTab })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2UEtd")).ShareToSlack), {
                            showFlag: showFlag,
                            product: "jira",
                            channel: "productAnalytics",
                            onClose: onClose,
                            cloudId: cloudId,
                            changeTab: changeTab,
                            shareContentType: shareContentType
                        })
                }
            ] : [], [
            ineligibilityReasons.length,
            showFlag,
            cloudId,
            shareContentType
        ]);
        return {
            shareIntegrations: shareIntegrations
        };
    };
});
parcelRegister("2UEtd", function(module, exports) {
    $parcel$export(module.exports, "ShareToSlack", ()=>$168b88234834bfea$export$2cc56764fd9edb21);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $113Tq;
    var $heNNl;
    var $lfTZh;
    var $3xc3R;
    const $168b88234834bfea$export$2cc56764fd9edb21 = (props)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("heNNl")).default), {
            id: "async-share-to-slack",
            packageName: "integrations"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "share-to-slack",
            fallback: (0, ($parcel$interopDefault($5uXOq))).createElement($168b88234834bfea$var$StyledShareToSlackLoader, null)
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($168b88234834bfea$var$StyledShareToSlack, props)));
    const $168b88234834bfea$var$StyledShareToSlackLoader = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("113Tq")).default), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1osq _19pkidpf _2hwx1wug _otyridpf _18u01wug",
                __cmplp.className
            ])
        });
    });
    const $168b88234834bfea$var$StyledShareToSlack = (0, $5uXOq.forwardRef)(({ as: C = (0, (0, parcelRequire("3xc3R")).LazyShareToSlack), style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_18s8ax2b",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("3xc3R", function(module, exports) {
    $parcel$export(module.exports, "LazyShareToSlack", ()=>$0733f18014b5074d$export$24281652e6b89b3b);
    var $1jUsD;
    const $0733f18014b5074d$export$24281652e6b89b3b = (0, (0, parcelRequire("1jUsD")).lazyAfterPaint)(()=>(parcelRequire("0fzlI")), {
        ssr: false,
        moduleId: "../platform/packages/growth/integrations/src/share-to-slack/ui/index.tsx"
    });
});
parcelRegister("0fzlI", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = Promise.all([
        $6fhBS("hPzOn"),
        $6fhBS("cM9em"),
        $6fhBS("fr9NE"),
        $6fhBS("b4k81")
    ]).then(()=>parcelRequire('2IxSM'));
});
parcelRegister("aMZmw", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$a1ef732ae0096135$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $a1ef732ae0096135$export$2e2bcd8739ae039 = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement("svg", {
            width: "16",
            height: "16",
            viewBox: "4 4 16 16",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M7.50403 13.8563C7.50403 14.727 6.79278 15.4382 5.92212 15.4382C5.05146 15.4382 4.34021 14.727 4.34021 13.8563C4.34021 12.9857 5.05146 12.2744 5.92212 12.2744H7.50403V13.8563Z",
            fill: "#E01E5A"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M8.30115 13.8563C8.30115 12.9857 9.0124 12.2744 9.88307 12.2744C10.7537 12.2744 11.465 12.9857 11.465 13.8563V17.8172C11.465 18.6879 10.7537 19.3991 9.88307 19.3991C9.0124 19.3991 8.30115 18.6879 8.30115 17.8172V13.8563Z",
            fill: "#E01E5A"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M9.88307 7.50415C9.0124 7.50415 8.30115 6.79291 8.30115 5.92224C8.30115 5.05158 9.0124 4.34033 9.88307 4.34033C10.7537 4.34033 11.465 5.05158 11.465 5.92224V7.50415H9.88307Z",
            fill: "#36C5F0"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M9.88304 8.30127C10.7537 8.30127 11.465 9.01251 11.465 9.88317C11.465 10.7538 10.7537 11.4651 9.88304 11.4651H5.92212C5.05146 11.4651 4.34021 10.7538 4.34021 9.88317C4.34021 9.01251 5.05146 8.30127 5.92212 8.30127H9.88304Z",
            fill: "#36C5F0"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M16.2354 9.88317C16.2354 9.01251 16.9466 8.30127 17.8172 8.30127C18.6879 8.30127 19.3991 9.01251 19.3991 9.88317C19.3991 10.7538 18.6879 11.4651 17.8172 11.4651H16.2354V9.88317Z",
            fill: "#2EB67D"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M15.4381 9.88316C15.4381 10.7538 14.7269 11.4651 13.8562 11.4651C12.9855 11.4651 12.2743 10.7538 12.2743 9.88316V5.92225C12.2743 5.05158 12.9855 4.34033 13.8562 4.34033C14.7269 4.34033 15.4381 5.05158 15.4381 5.92225V9.88316Z",
            fill: "#2EB67D"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M13.8562 16.2354C14.7269 16.2354 15.4381 16.9466 15.4381 17.8172C15.4381 18.6879 14.7269 19.3991 13.8562 19.3991C12.9855 19.3991 12.2743 18.6879 12.2743 17.8172V16.2354H13.8562Z",
            fill: "#ECB22E"
        }), (0, ($parcel$interopDefault($5uXOq))).createElement("path", {
            d: "M13.8562 15.4382C12.9855 15.4382 12.2743 14.727 12.2743 13.8563C12.2743 12.9857 12.9855 12.2744 13.8562 12.2744H17.8171C18.6878 12.2744 19.399 12.9857 19.399 13.8563C19.399 14.727 18.6878 15.4382 17.8171 15.4382H13.8562Z",
            fill: "#ECB22E"
        }));
});
parcelRegister("fjgF8", function(module, exports) {
    $parcel$export(module.exports, "AsyncShareProjectNudge", ()=>$7ce891b6fd7965bb$export$d95995d6ca76620b);
    var $5uXOq = parcelRequire("5uXOq");
    var $bBbEG;
    var $lfTZh;
    var $1jUsD;
    const $7ce891b6fd7965bb$var$LazyShareProjectNudge = (0, (0, parcelRequire("1jUsD")).lazyAfterPaint)(()=>(parcelRequire("iEJkp")), {
        ssr: false,
        moduleId: "./src/packages/software/onboarding-nudges/src/ui/jwm-share-project/index.tsx"
    });
    const $7ce891b6fd7965bb$export$d95995d6ca76620b = ({ children: children })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bBbEG")).OnboardingNudgeErrorBoundary), {
            id: (0, $dbbf68c32d8c4308$export$a1be34032ee24f78),
            fallback: children,
            attributes: {
                nudgeId: (0, $dbbf68c32d8c4308$export$a1be34032ee24f78)
            }
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
            name: "jwm-share-project-nudge",
            fallback: children
        }, (0, ($parcel$interopDefault($5uXOq))).createElement($7ce891b6fd7965bb$var$LazyShareProjectNudge, null, children)));
});
parcelRegister("iEJkp", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("8qj8a").then(()=>parcelRequire('dRf63'));
});
parcelRegister("4XKuc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$5ed6b88152ef6ea6$export$2e2bcd8739ae039);
    var $7VHMR;
    var $5ed6b88152ef6ea6$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        share: {
            "id": "business-invite-people.jwm-share-button.share",
            "defaultMessage": "Share"
        },
        shareTooltipText: {
            "id": "business-invite-people.jwm-share-button.share-tooltip-text",
            "defaultMessage": "Embed this Smart Link in other Atlassian products such as Confluence"
        },
        shareJwmHelperMessage: {
            "id": "business-invite-people.jwm-share-button.share-jwm-helper-message",
            "defaultMessage": "This view, along with any applied groups and filters are shared"
        }
    });
});
parcelRegister("70g8n", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1bc06decfa7dde08$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $lfTZh;
    var $1jUsD;
    var $2h2vc;
    var $2SbUq;
    const $1bc06decfa7dde08$export$7174b56226171cc3 = (0, (0, parcelRequire("1jUsD")).lazy)(()=>(parcelRequire("134F6")), {
        ssr: false,
        moduleId: "./src/packages/business/shared/components/more-menu/src/ui/more-menu/menu-content/index.tsx"
    });
    const $1bc06decfa7dde08$var$MoreMenu = ({ hideDoneItems: hideDoneItems, hasExpandedAllItems: hasExpandedAllItems, hasCollapsedAllItems: hasCollapsedAllItems, hasFeedbackButton: hasFeedbackButton, projectType: projectType, isExpandCollapseButtonEnabled: isExpandCollapseButtonEnabled, onChangeHideDoneItems: onChangeHideDoneItems, onExpandCollapseAllItems: onExpandCollapseAllItems })=>{
        const renderContent = (0, $5uXOq.useCallback)((onCloseMenu)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("lfTZh")).default), {
                name: "menu-content",
                fallback: (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2h2vc")).default), null)
            }, (0, ($parcel$interopDefault($5uXOq))).createElement($1bc06decfa7dde08$export$7174b56226171cc3, {
                hideDoneItems: hideDoneItems,
                onChangeHideDoneItems: onChangeHideDoneItems,
                onExpandCollapseAllItems: onExpandCollapseAllItems,
                isExpandCollapseButtonEnabled: isExpandCollapseButtonEnabled,
                hasExpandedAllItems: hasExpandedAllItems,
                hasCollapsedAllItems: hasCollapsedAllItems,
                hasFeedbackButton: hasFeedbackButton,
                projectType: projectType,
                onCloseMenu: onCloseMenu
            })), [
            hideDoneItems,
            onChangeHideDoneItems,
            onExpandCollapseAllItems,
            isExpandCollapseButtonEnabled,
            hasExpandedAllItems,
            hasCollapsedAllItems,
            hasFeedbackButton,
            projectType
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("2SbUq")).default), {
            renderContent: renderContent
        });
    };
    var $1bc06decfa7dde08$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($1bc06decfa7dde08$var$MoreMenu);
});
parcelRegister("2h2vc", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$c4b39db453d8ec83$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $113Tq;
    var $j6WEs;
    const $c4b39db453d8ec83$var$MenuFallback = ()=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("j6WEs")).SpinnerWrapper), null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("113Tq")).default), {
            size: "medium"
        }));
    var $c4b39db453d8ec83$export$2e2bcd8739ae039 = (0, $5uXOq.memo)($c4b39db453d8ec83$var$MenuFallback);
});
parcelRegister("j6WEs", function(module, exports) {
    $parcel$export(module.exports, "SpinnerWrapper", ()=>$ef469de38bc42c7b$export$52b4dfd89a6b3a1b);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    const $ef469de38bc42c7b$export$52b4dfd89a6b3a1b = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return $5uXOq.createElement(C, {
            ...__cmplp,
            style: __cmpls,
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1e0c1txw _4cvr1h6o _1bah1h6o _1yt4pxbi",
                __cmplp.className
            ])
        });
    });
});
parcelRegister("2SbUq", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$86d5dde4b111cc89$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $bwpsq;
    var $lD23V;
    var $7qVt8;
    var $l8ruj;
    var $loRkl;
    const $86d5dde4b111cc89$var$MoreMenuCore = (0, $5uXOq.memo)(({ renderContent: renderContent, minWidth: minWidth = (0, $f1bdb30d4d079129$export$8c68b096b2d5e9f6), forceVisibility: forceVisibility = false })=>{
        const [isOpen, setIsOpen] = (0, $5uXOq.useState)(forceVisibility);
        (0, $5uXOq.useEffect)(()=>{
            setIsOpen(forceVisibility);
        }, [
            forceVisibility
        ]);
        const closeMenu = (0, $5uXOq.useCallback)(()=>setIsOpen(false), []);
        const toggleMenu = (0, $5uXOq.useCallback)(()=>setIsOpen((oldIsOpen)=>!oldIsOpen), []);
        const content = (0, $5uXOq.useCallback)(()=>(0, ($parcel$interopDefault($5uXOq))).createElement($86d5dde4b111cc89$export$5f7211d21bfdae05, {
                width: minWidth
            }, renderContent(closeMenu)), [
            closeMenu,
            renderContent,
            minWidth
        ]);
        const trigger = (0, $5uXOq.useCallback)((triggerProps)=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("loRkl")).default), {
                ...triggerProps,
                isSelected: isOpen,
                onClick: toggleMenu
            }), [
            isOpen,
            toggleMenu
        ]);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("l8ruj")).default), {
            name: "business-more-menu"
        }, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("7qVt8")).default), {
            isOpen: isOpen,
            onClose: closeMenu,
            placement: "bottom-end",
            content: content,
            trigger: trigger
        }));
    });
    var $86d5dde4b111cc89$export$2e2bcd8739ae039 = $86d5dde4b111cc89$var$MoreMenuCore;
    const $86d5dde4b111cc89$export$5f7211d21bfdae05 = (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
        return (0, ($parcel$interopDefault($5uXOq))).createElement(C, {
            ...__cmplp,
            style: {
                ...__cmpls,
                "--_6f8077": (0, (0, parcelRequire("lD23V")).default)(`${__cmplp.width}px`)
            },
            ref: __cmplr,
            className: (0, (0, parcelRequire("bwpsq")).default)([
                "_1bsb1hdq",
                __cmplp.className
            ])
        });
    });
});
const $f1bdb30d4d079129$export$8c68b096b2d5e9f6 = 320;
parcelRegister("loRkl", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$fbbabf378481667d$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $4mxtl;
    var $hxbUj;
    var $7XYc4;
    var $koVbs;
    var $22OQR;
    var $dCm1o;
    var $dSexS;
    const $fbbabf378481667d$var$MORE_ICON = (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("hxbUj"))))), {
        label: "",
        size: "small"
    });
    const $fbbabf378481667d$var$TriggerOld = (0, $5uXOq.forwardRef)(({ onClick: onClick, isSelected: isSelected, ...otherProps }, ref)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("22OQR")).ThemedButton), {
            ...otherProps,
            ref: ref,
            testId: "business-more-menu.ui.more-menu.more-menu-core.trigger",
            iconBefore: $fbbabf378481667d$var$MORE_ICON,
            isSelected: isSelected,
            onClick: onClick,
            appearance: "subtle",
            "aria-label": formatMessage((0, (0, parcelRequire("dSexS")).default).moreButtonLabel)
        }, formatMessage((0, (0, parcelRequire("dSexS")).default).moreButton));
    });
    const $fbbabf378481667d$var$Trigger = (0, $5uXOq.forwardRef)(({ onClick: onClick, isSelected: isSelected, ...otherProps }, ref)=>{
        const { formatMessage: formatMessage } = (0, (0, parcelRequire("koVbs")).default)();
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("22OQR")).ThemedButton), {
            ...otherProps,
            ref: ref,
            testId: "business-more-menu.ui.more-menu.more-menu-core.trigger",
            iconAfter: (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault((0, parcelRequire("4mxtl"))))), {
                label: "",
                spacing: "spacious",
                color: "currentColor"
            }),
            isSelected: isSelected,
            onClick: onClick,
            "aria-label": formatMessage((0, (0, parcelRequire("dSexS")).default).moreButtonLabel),
            title: formatMessage((0, (0, parcelRequire("dSexS")).default).moreButton)
        });
    });
    var $fbbabf378481667d$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7XYc4")).componentWithCondition)((0, (0, parcelRequire("dCm1o")).isVisualRefreshEnabled), $fbbabf378481667d$var$Trigger, $fbbabf378481667d$var$TriggerOld);
});
parcelRegister("dSexS", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$52d3441e2e3906d4$export$2e2bcd8739ae039);
    var $7VHMR;
    var $52d3441e2e3906d4$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        moreButton: {
            "id": "business-more-menu.more-menu.more-menu-core.trigger.more-button",
            "defaultMessage": "More"
        },
        moreButtonLabel: {
            "id": "business-more-menu.more-menu.more-menu-core.trigger.more-button-label",
            "defaultMessage": "More actions on the view options"
        }
    });
});
parcelRegister("134F6", function(module, exports) {
    var $6fhBS = parcelRequire("6fhBS");
    module.exports = $6fhBS("aOlk3").then(()=>parcelRequire('fhUV3'));
});
parcelRegister("5GqLe", function(module, exports) {
    $parcel$export(module.exports, "integrationTypes", ()=>$0970fea694a8095f$export$a7359bcfb0ca8e98);
    const $0970fea694a8095f$export$a7359bcfb0ca8e98 = {
        BENTO_ISSUE: 'bentoIssue',
        CLASSIC_BOARD: 'classicBoard',
        NEXTGEN_BOARD: 'nextGenBoard',
        ROADMAP: 'roadmap',
        TIMELINE: 'timeline',
        LIST: 'list',
        CALENDAR: 'calendar',
        BOARD: 'board',
        FORM: 'form',
        SUMMARY: 'summary',
        ATTACHMENTS: 'attachments',
        DEPENDENCIES: 'dependencies',
        INCREMENT: 'increment'
    };
});
parcelRegister("jRNSX", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1375dabacf146b87$export$2e2bcd8739ae039);
    var $7VHMR;
    var $1375dabacf146b87$export$2e2bcd8739ae039 = (0, (0, parcelRequire("7VHMR")).defineMessages)({
        shareTitle: {
            "id": "business-timeline.timeline-view.toolbar.share-title",
            "defaultMessage": "Timeline"
        },
        shareTooltipText: {
            "id": "business-timeline.timeline-view.toolbar.share-tooltip-text",
            "defaultMessage": "Embed this Smart Link in other Atlassian products such as Confluence"
        },
        simpleSearch: {
            "id": "business-timeline.timeline-view.toolbar.simple-search",
            "defaultMessage": "Search timeline"
        },
        searchLabel: {
            "id": "business-timeline.timeline-view.toolbar.search-label",
            "defaultMessage": "Typing letters in the search input applies filters"
        }
    });
});
parcelRegister("9dbF6", function(module, exports) {
    $parcel$export(module.exports, "SubProductUpdater", ()=>$5979c081afa32bfa$export$eb40d3df56aa5c53);
    var $5uXOq = parcelRequire("5uXOq");
    var $bNvU3;
    var $3iTiR;
    var $ero6m;
    var $54I24;
    var $8OHH4;
    const $5979c081afa32bfa$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
        const subProduct = (0, (0, parcelRequire("8OHH4")).isSubProductProps)(props) ? props.subProduct : (0, (0, parcelRequire("ero6m")).getSubProductFromProjectType)(props.projectType);
        return (0, ($parcel$interopDefault($5uXOq))).createElement((0, ($parcel$interopDefault($5uXOq))).Fragment, null, (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("bNvU3")).default), {
            op: (0, (0, parcelRequire("54I24")).default),
            args: [
                subProduct,
                allowMonolithDeferral
            ]
        }), (0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("3iTiR")).default), {
            subProduct: subProduct
        }));
    };
});
parcelRegister("3iTiR", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$1214b0731559b377$export$2e2bcd8739ae039);
    var $5uXOq = parcelRequire("5uXOq");
    var $1u3Jv;
    var $hFChZ;
    var $1214b0731559b377$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>(0, ($parcel$interopDefault($5uXOq))).createElement((0, (0, parcelRequire("1u3Jv")).default), {
            op: (0, (0, parcelRequire("hFChZ")).default),
            args: [
                subProduct
            ]
        });
});
parcelRegister("hFChZ", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$0e606430ead76cd8$export$2e2bcd8739ae039);
    var $dJl1T;
    var $eusud;
    var $0e606430ead76cd8$export$2e2bcd8739ae039 = (subProduct)=>{
        (0, (0, parcelRequire("eusud")).performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
            (0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
        });
    };
});
parcelRegister("ero6m", function(module, exports) {
    $parcel$export(module.exports, "getSubProductFromProjectType", ()=>$0997694844c8a9e7$export$b1fe420ed15dff7b);
    var $16v4H;
    const $0997694844c8a9e7$export$b1fe420ed15dff7b = (projectType)=>{
        if (projectType === 'product_discovery') return 'polaris';
        return (0, (0, parcelRequire("16v4H")).subProductFromProjectType)(projectType);
    };
});
parcelRegister("54I24", function(module, exports) {
    $parcel$export(module.exports, "default", ()=>$bcbbcd48ca398ed4$export$2e2bcd8739ae039);
    var $7T84i;
    var $9B86Q;
    var $cQZXC;
    var $dJl1T;
    var $fjcgS;
    const $bcbbcd48ca398ed4$var$maybeDelayAndRace = (maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
            maybeWaitPromise.then(getDefaultPromise),
            getRacePromise()
        ]) : getDefaultPromise();
    var $bcbbcd48ca398ed4$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
        (0, (0, parcelRequire("fjcgS")).getAnalyticsWebClientPromise)().then((client)=>{
            client.setSubProduct(subProduct);
            if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
                solutions: [
                    (0, $86344d58e71e925a$export$c8b406ad8ee0dab9)
                ]
            });
            else client.removeUIViewedAttribute('solutions');
        });
        $bcbbcd48ca398ed4$var$maybeDelayAndRace(allowMonolithDeferral ? (0, (0, parcelRequire("cQZXC")).waitForHeritage)() : null, ()=>(0, (0, parcelRequire("7T84i")).loadBridgeStrict)({
                name: 'jira/analytics/sub-product-resolver',
                wrmKeys: [
                    'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
                ]
            }), ()=>(0, (0, parcelRequire("9B86Q")).loadBridgeWeak)({
                name: 'jira/analytics/sub-product-resolver'
            })).then((subProductResolver)=>{
            subProductResolver.setSubProduct(subProduct);
        }).catch((e)=>(0, (0, parcelRequire("dJl1T")).default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
    };
});
const $86344d58e71e925a$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';
parcelRegister("8OHH4", function(module, exports) {
    $parcel$export(module.exports, "isSubProductProps", ()=>$701d07b56c3e3574$export$c3063d6d7a8c075f);
    const $701d07b56c3e3574$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';
    const $701d07b56c3e3574$export$81da4a7e1ba1dcee = (props)=>'projectType' in props && typeof props.projectType === 'string';
});
const $4cff3ad70ea80f75$export$6c8cb487d6ffc522 = 'QueryError';
const $4cff3ad70ea80f75$export$b171488d52070cb3 = 'JiraIssueFieldUnsupportedErrorExtension';
const $4cff3ad70ea80f75$export$14b50ab9fbf2d370 = 'JiraIssueFieldValueValidationErrorExtension';
const $4cff3ad70ea80f75$export$3d1cda9bd50505e8 = 'SERVICE_REQUEST';
const $4cff3ad70ea80f75$export$48c144830383423 = 'INCIDENT_MANAGEMENT';
const $4cff3ad70ea80f75$export$1ea6ead7bcee4494 = 'PROBLEM_MANAGEMENT';
const $4cff3ad70ea80f75$export$b92ccb6dc3cdb548 = 'CHANGE_MANAGEMENT';
const $4cff3ad70ea80f75$export$a4a741b969f6509c = 'POST_INCIDENT_REVIEW';
const $4cff3ad70ea80f75$export$81e62964cc725098 = 'DEVELOPER_ESCALATION';
const $4cff3ad70ea80f75$export$92ab80c1dc9baf44 = 'REQUEST_TYPE';
const $4cff3ad70ea80f75$export$ebb48b08205007c5 = 'ISSUE_TYPE';
const $4cff3ad70ea80f75$export$c835df30ebbd529d = 'UNASSIGNED_REQUEST_TYPE';
